function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref5e5"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref5e5"] = parcelRequire;
}
parcelRequire.register("3E8Nt", function(module, exports) {

$parcel$export(module.exports, "myround", () => $2a7bee67286e6d6e$export$3f73691ae381f36f);
$parcel$export(module.exports, "decimalRound", () => $2a7bee67286e6d6e$export$7cc4fa0deb200401);
$parcel$export(module.exports, "getRandomInt", () => $2a7bee67286e6d6e$export$b141de964f0a90c1);
$parcel$export(module.exports, "getRandomUniform", () => $2a7bee67286e6d6e$export$ebcab1f742ceaae4);
$parcel$export(module.exports, "getRandomChoice", () => $2a7bee67286e6d6e$export$f800fa30df95721e);
$parcel$export(module.exports, "getRandomSample", () => $2a7bee67286e6d6e$export$39e1b264f24c3360);
$parcel$export(module.exports, "shuffle", () => $2a7bee67286e6d6e$export$448332262467e042);
$parcel$export(module.exports, "weightedChoice", () => $2a7bee67286e6d6e$export$15a24ee953540948);
$parcel$export(module.exports, "getTimeDiffHuman", () => $2a7bee67286e6d6e$export$5674eb06b71f0c31);
$parcel$export(module.exports, "getMonthsIndexDifference", () => $2a7bee67286e6d6e$export$ea50a04ffc84496a);
$parcel$export(module.exports, "toTitleCase", () => $2a7bee67286e6d6e$export$f06f8b3003f18927);
$parcel$export(module.exports, "formatStringWithParams", () => $2a7bee67286e6d6e$export$4c7f9e28a1ad7a14);
$parcel$export(module.exports, "commaSeparate", () => $2a7bee67286e6d6e$export$7cedacdd7e8b44e6);
$parcel$export(module.exports, "areObjectArraysEmpty", () => $2a7bee67286e6d6e$export$c1d27b5456cbeae2);
$parcel$export(module.exports, "getMonthsWord", () => $2a7bee67286e6d6e$export$f9cc8344096c85df);
$parcel$export(module.exports, "getYearsWord", () => $2a7bee67286e6d6e$export$c4f03721b6fa938d);
$parcel$export(module.exports, "getCurrentGame", () => $2a7bee67286e6d6e$export$980de59806a9e946);
$parcel$export(module.exports, "objectInArray", () => $2a7bee67286e6d6e$export$eed912e6ca072e35);
$parcel$export(module.exports, "getUniqueObjects", () => $2a7bee67286e6d6e$export$f950d2b96083ede4);
$parcel$export(module.exports, "getUniqueObjectsByName", () => $2a7bee67286e6d6e$export$cf5cbb349390e7a4);
$parcel$export(module.exports, "getRosterMemberPronoun", () => $2a7bee67286e6d6e$export$43a0c04810551022);
$parcel$export(module.exports, "getTalentCompany", () => $2a7bee67286e6d6e$export$c13746f6da88d8df);
$parcel$export(module.exports, "getArrayMaxByProperty", () => $2a7bee67286e6d6e$export$dc4f7de803b00bed);
$parcel$export(module.exports, "getArrayMinByProperty", () => $2a7bee67286e6d6e$export$f5438dbf1e09c1b8);
$parcel$export(module.exports, "getRealMonth", () => $2a7bee67286e6d6e$export$37db71fc5ef89b2d);
$parcel$export(module.exports, "getRealDate", () => $2a7bee67286e6d6e$export$6315bdd75320fbae);
$parcel$export(module.exports, "getFirstSunday", () => $2a7bee67286e6d6e$export$7001e9d9745d7b6f);
$parcel$export(module.exports, "generateName", () => $2a7bee67286e6d6e$export$5d832d6580b26c5);
$parcel$export(module.exports, "romanizeNumber", () => $2a7bee67286e6d6e$export$b0fa10378e95e752);
$parcel$export(module.exports, "getMonthsDifference", () => $2a7bee67286e6d6e$export$543bc81e5a2358fd);
$parcel$export(module.exports, "limitValueBetweenRange", () => $2a7bee67286e6d6e$export$bd35453f482416c8);
$parcel$export(module.exports, "findNameInString", () => $2a7bee67286e6d6e$export$b03bcc2d6e021b95);
$parcel$export(module.exports, "getRosterMemberStreaks", () => $2a7bee67286e6d6e$export$50269d73e013f749);
$parcel$export(module.exports, "getRosterMemberWonTournaments", () => $2a7bee67286e6d6e$export$f404d0b7eb87fdd5);
$parcel$export(module.exports, "getRosterMemberRank", () => $2a7bee67286e6d6e$export$69f9dc468ea2a8b8);
$parcel$export(module.exports, "getRosterMemberPopularity", () => $2a7bee67286e6d6e$export$9abeb93fe44ac16b);
$parcel$export(module.exports, "getRosterMemberAlignment", () => $2a7bee67286e6d6e$export$7cba4e02f40c02a5);
$parcel$export(module.exports, "getRosterMemberBrandName", () => $2a7bee67286e6d6e$export$8654ecbbc696e94);
$parcel$export(module.exports, "getRosterMemberOverness", () => $2a7bee67286e6d6e$export$7683ef391ccf419b);
$parcel$export(module.exports, "getRosterMemberAge", () => $2a7bee67286e6d6e$export$974abedecf6b222d);
$parcel$export(module.exports, "getRosterMemberFaceOfTheCompany", () => $2a7bee67286e6d6e$export$7ed7850db215f44e);
$parcel$export(module.exports, "getRosterMemberHot", () => $2a7bee67286e6d6e$export$36efe9ffd55a2a66);
$parcel$export(module.exports, "getRosterMemberStale", () => $2a7bee67286e6d6e$export$20b3fa36d2b61a01);
$parcel$export(module.exports, "checkAreArraysEqual", () => $2a7bee67286e6d6e$export$667d95731ce46427);
$parcel$export(module.exports, "checkAreObjArraysEqual", () => $2a7bee67286e6d6e$export$b558934c4be14569);
$parcel$export(module.exports, "getMatchOrSegmentName", () => $2a7bee67286e6d6e$export$bb9033084e40f52e);
$parcel$export(module.exports, "getChunks", () => $2a7bee67286e6d6e$export$98f6ffead66e49fe);
$parcel$export(module.exports, "isPowerOfTwo", () => $2a7bee67286e6d6e$export$b9e43d1765415474);
$parcel$export(module.exports, "range", () => $2a7bee67286e6d6e$export$d02631cccf789723);
$parcel$export(module.exports, "getHairColor", () => $2a7bee67286e6d6e$export$ae791a2edf8cdca3);
$parcel$export(module.exports, "getRandomColor", () => $2a7bee67286e6d6e$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getTalentAgeMultiplier", () => $2a7bee67286e6d6e$export$c0088e391060c497);
$parcel$export(module.exports, "getMoraleText", () => $2a7bee67286e6d6e$export$8977ea11325e9663);
$parcel$export(module.exports, "getOvernessText", () => $2a7bee67286e6d6e$export$85a767fc1194f4fe);
$parcel$export(module.exports, "asyncFor", () => $2a7bee67286e6d6e$export$fbc7cb4e17e9d5af);
$parcel$export(module.exports, "captureError", () => $2a7bee67286e6d6e$export$3e205fbb5df021e0);
$parcel$export(module.exports, "generateUUID", () => $2a7bee67286e6d6e$export$e73c8bd0f20705a);
$parcel$export(module.exports, "staffRoles", () => $2a7bee67286e6d6e$export$6a5180f226647561);
$parcel$export(module.exports, "roleToFacilityData", () => $2a7bee67286e6d6e$export$32b5099f8e5b8fb5);
$parcel$export(module.exports, "facilityLevelCosts", () => $2a7bee67286e6d6e$export$b5b5f5e787b6343d);
$parcel$export(module.exports, "gameLimits", () => $2a7bee67286e6d6e$export$4ac53a7f06b2ce2c);
$parcel$export(module.exports, "reputationXpLevels", () => $2a7bee67286e6d6e$export$2f234d44f725e283);
$parcel$export(module.exports, "fanLevels", () => $2a7bee67286e6d6e$export$e258b12cc6714c1b);
$parcel$export(module.exports, "facilitiesData", () => $2a7bee67286e6d6e$export$c220c573eeaab725);
$parcel$export(module.exports, "staffFirstNames", () => $2a7bee67286e6d6e$export$9337016f09b3e64e);
$parcel$export(module.exports, "staffLastNames", () => $2a7bee67286e6d6e$export$c00029808f76df2c);
$parcel$export(module.exports, "staffMartianFirstNames", () => $2a7bee67286e6d6e$export$c85070b0dfdc5188);
$parcel$export(module.exports, "staffMartianLastNames", () => $2a7bee67286e6d6e$export$ef26431555f7e916);
$parcel$export(module.exports, "staffHiredRamblings", () => $2a7bee67286e6d6e$export$bf232bbd8f73b1e3);
$parcel$export(module.exports, "staffFiredRamblings", () => $2a7bee67286e6d6e$export$7a2a7e755b11d550);
$parcel$export(module.exports, "eventPostersData", () => $2a7bee67286e6d6e$export$4f3ccd6d58995426);
$parcel$export(module.exports, "annualTournamentPostersData", () => $2a7bee67286e6d6e$export$14e75549e87e3827);
$parcel$export(module.exports, "championshipPrestigeXps", () => $2a7bee67286e6d6e$export$b0afb21554076fed);
$parcel$export(module.exports, "eventPrestigeXps", () => $2a7bee67286e6d6e$export$faf5aa19dbf08c1f);
$parcel$export(module.exports, "goalProperties", () => $2a7bee67286e6d6e$export$12f5d44842119050);

var $98xmD = parcelRequire("98xmD");

var $14eBR = parcelRequire("14eBR");

var $1JSre = parcelRequire("1JSre");

var $hBIDz = parcelRequire("hBIDz");

var $972Ip = parcelRequire("972Ip");

var $dl5u4 = parcelRequire("dl5u4");

var $4ptHI = parcelRequire("4ptHI");

var $6RCLU = parcelRequire("6RCLU");

var $5kTkA = parcelRequire("5kTkA");

var $ko5kE = parcelRequire("ko5kE");
function $2a7bee67286e6d6e$export$3f73691ae381f36f(rating, base = 0.25) {
    // For rounding to below 0.25, use decimalRound
    return base * Math.round(rating / base);
}
function $2a7bee67286e6d6e$export$7cc4fa0deb200401(num) {
    // Rounds to 2 decimal places
    return Math.round((num + Number.EPSILON) * 100) / 100;
}
function $2a7bee67286e6d6e$export$b141de964f0a90c1(min, max, random) {
    const randomToUse = random ? random : Math.random();
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(randomToUse * (max - min + 1) + min);
}
function $2a7bee67286e6d6e$export$ebcab1f742ceaae4(min, max, random) {
    const randomToUse = random ? random : Math.random();
    return randomToUse * (max - min) + min;
}
function $2a7bee67286e6d6e$export$f800fa30df95721e(arr, random) {
    const randomToUse = random ? random : Math.random();
    return arr[Math.floor(randomToUse * arr.length)];
}
function $2a7bee67286e6d6e$export$39e1b264f24c3360(arr, size, randomFunction) {
    let shuffled = $2a7bee67286e6d6e$export$448332262467e042([
        ...arr
    ], randomFunction);
    return shuffled.slice(0, size);
}
function $2a7bee67286e6d6e$export$448332262467e042(array, randomFunction) {
    const randomToUse = randomFunction ? randomFunction : Math.random;
    let currentIndex = array.length, temporaryValue, randomIndex;
    // While there remain elements to shuffle...
    while(0 !== currentIndex){
        // Pick a remaining element...
        randomIndex = Math.floor(randomToUse() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}
function $2a7bee67286e6d6e$export$15a24ee953540948(options, randomInstance) {
    let i;
    let weights = [];
    const randomToUse = randomInstance ? randomInstance : Math.random();
    if (options.every((x)=>x[1] === 0)) for (let o of options)o[1] = 1;
    for(i = 0; i < options.length; i++)weights[i] = options[i][1] + (weights[i - 1] || 0);
    let random = randomToUse * weights[weights.length - 1];
    for(i = 0; i < weights.length; i++)if (weights[i] > random) break;
    return options[i][0];
}
function $2a7bee67286e6d6e$export$5674eb06b71f0c31(startDate, dateNow) {
    let diffInMilliSeconds = Math.abs(startDate - dateNow) / 1000;
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;
    const seconds = Math.floor(diffInMilliSeconds) % 60;
    let difference = "";
    if (days > 0) difference += days === 1 ? `${days} day` : `${days} days`;
    else if (hours > 0) difference += hours === 1 ? `${hours} hour` : `${hours} hours`;
    else if (minutes > 0) difference += minutes === 1 ? `${minutes} minute` : `${minutes} minutes`;
    else difference += seconds === 1 ? `${seconds} second` : `${seconds} seconds`;
    return difference;
}
function $2a7bee67286e6d6e$export$ea50a04ffc84496a(endMonth, startMonth) {
    // Get difference between month indexes
    let monthsDifference;
    if (endMonth < startMonth) monthsDifference = endMonth + 12 - startMonth;
    else monthsDifference = endMonth - startMonth;
    return monthsDifference;
}
function $2a7bee67286e6d6e$export$f06f8b3003f18927(str) {
    return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
// String format function
if (!String.prototype.format) String.prototype.format = function() {
    let args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) {
        return typeof args[number] != "undefined" ? args[number] : match;
    });
};
String.prototype.formatUnicorn = String.prototype.formatUnicorn || function() {
    "use strict";
    var str = this.toString();
    if (arguments.length) {
        var t = typeof arguments[0];
        var key;
        var args = "string" === t || "number" === t ? Array.prototype.slice.call(arguments) : arguments[0];
        for(key in args)str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
    }
    return str;
};
function $2a7bee67286e6d6e$export$4c7f9e28a1ad7a14(string, params) {
    const names = Object.keys(params);
    const values = Object.values(params);
    return new Function(...names, `return \`${string}\`;`)(...values);
}
function $2a7bee67286e6d6e$export$7cedacdd7e8b44e6(arr, separator) {
    if (typeof separator === "undefined") separator = "and";
    return arr.slice(0, -2).join(", ") + (arr.slice(0, -2).length ? ", " : "") + arr.slice(-2).join(" " + separator + " ");
}
function $2a7bee67286e6d6e$export$c1d27b5456cbeae2(obj) {
    for (const key of Object.keys(obj)){
        if (obj[key].length > 0) return false;
    }
    return true;
}
function $2a7bee67286e6d6e$export$f9cc8344096c85df(months) {
    if (months === 1) return "month";
    return "months";
}
function $2a7bee67286e6d6e$export$c4f03721b6fa938d(years) {
    if (years === 1) return "year";
    return "years";
}
function $2a7bee67286e6d6e$export$980de59806a9e946() {
    if ((0, $98xmD.globals).game.id) return (0, $14eBR.Games).get((0, $98xmD.globals).game.id);
    return null;
}
function $2a7bee67286e6d6e$export$eed912e6ca072e35(obj, array) {
    // Check if id of object present in array of object ids
    if (obj.objectName) array = array.filter((x)=>x.objectName === obj.objectName) // only check in same collection
    ;
    const ids = array.map((x)=>x.$loki);
    return ids.indexOf(obj.$loki) >= 0;
}
function $2a7bee67286e6d6e$export$f950d2b96083ede4(objects) {
    return objects.filter((value, index, self)=>index === self.findIndex((t)=>t.$loki === value.$loki && t.objectName === value.objectName));
}
function $2a7bee67286e6d6e$export$cf5cbb349390e7a4(objects) {
    return objects.filter((value, index, self)=>index === self.findIndex((t)=>t.name === value.name));
}
function $2a7bee67286e6d6e$export$43a0c04810551022(rosterMember, pronounType = null) {
    let pronouns = {
        "male": "he",
        "female": "she",
        "non-binary": "they",
        "default": "he"
    };
    if (pronounType === "possessive") pronouns = {
        "male": "his",
        "female": "her",
        "non-binary": "their",
        "default": "his"
    };
    else if (pronounType === "objective") pronouns = {
        "male": "him",
        "female": "her",
        "non-binary": "them",
        "default": "him"
    };
    // Get team's pronoun
    if (rosterMember.objectName === "tagTeam") return pronouns["non-binary"];
    else return pronouns[rosterMember.gender] || pronouns["default"];
}
async function $2a7bee67286e6d6e$export$c13746f6da88d8df(talent) {
    let talentCompany = null;
    let talentRoster;
    if (talent.objectName === "superstar") talentRoster = await (0, $hBIDz.getSuperstarRoster)(talent);
    else talentRoster = await (0, $972Ip.getTagTeamRoster)(talent);
    if (!talentRoster || [
        "indie",
        "indieAvailable"
    ].indexOf(talentRoster.type) >= 0) return null;
    let talentRosterCompany = await (0, $dl5u4.getRosterCompany)(talentRoster);
    if (talentRosterCompany) talentCompany = talentRosterCompany;
    return talentCompany;
}
function $2a7bee67286e6d6e$export$dc4f7de803b00bed(array, property) {
    let res = Math.max.apply(Math, array.map(function(o) {
        return o[property];
    }));
    return array.find(function(o) {
        return o[property] === res;
    });
}
function $2a7bee67286e6d6e$export$f5438dbf1e09c1b8(array, property) {
    let res = Math.min.apply(Math, array.map(function(o) {
        return o[property];
    }));
    return array.find(function(o) {
        return o[property] === res;
    });
}
function $2a7bee67286e6d6e$export$37db71fc5ef89b2d(month, startingMonth) {
    // Find current month by adding game's monthCount to startingMonth, return month name
    const startDate = new Date(1, startingMonth, 1);
    const endDate = new Date(startDate.setMonth(startDate.getMonth() + month));
    return (0, $1JSre.monthNames)[endDate.getMonth()].slice(0, 3);
}
function $2a7bee67286e6d6e$export$6315bdd75320fbae(month, year, startingMonth, startingYear) {
    // Convert starting month and year to datetime, add months and years passed
    const startDate = new Date(startingYear, startingMonth, 1);
    let endDate = new Date(startDate.setFullYear(startDate.getFullYear() + year));
    endDate = new Date(endDate.setMonth(startDate.getMonth() + month));
    return `${(0, $1JSre.monthNames)[endDate.getMonth()].slice(0, 3)} ${endDate.getFullYear()}`;
}
function $2a7bee67286e6d6e$export$7001e9d9745d7b6f(year, month) {
    let date = new Date(year, month, 1, 12);
    let weekday = date.getDay();
    let dayDiff = weekday === 0 ? 0 : 7 - weekday;
    return new Date(date.setDate(date.getDate() + dayDiff));
}
function $2a7bee67286e6d6e$export$5d832d6580b26c5(gender = "male", randomInstance = null, martian = false, usePatreonSuperstar = false) {
    const randomToUse = randomInstance ? randomInstance : Math.random();
    let name;
    // Add patreon superstar
    if (usePatreonSuperstar) {
        let patreonSuperstars = JSON.parse(localStorage.getItem("patreonSuperstarsData")) || [];
        if (patreonSuperstars.length) {
            let patreonSuperstar = $2a7bee67286e6d6e$export$f800fa30df95721e(patreonSuperstars);
            return patreonSuperstar.name;
        }
    }
    if (martian) name = `${$2a7bee67286e6d6e$export$f800fa30df95721e($2a7bee67286e6d6e$var$martianFirstNames, randomToUse)} ${$2a7bee67286e6d6e$export$f800fa30df95721e($2a7bee67286e6d6e$var$martianLastNames, randomToUse)}`;
    else {
        let lastName = $2a7bee67286e6d6e$export$f800fa30df95721e($2a7bee67286e6d6e$var$lastNames, randomToUse);
        if (gender === "non-binary") name = `${$2a7bee67286e6d6e$export$f800fa30df95721e($2a7bee67286e6d6e$var$firstNames.male.concat($2a7bee67286e6d6e$var$firstNames.female), randomToUse)} ${lastName}`;
        else name = `${$2a7bee67286e6d6e$export$f800fa30df95721e($2a7bee67286e6d6e$var$firstNames[gender], randomToUse)} ${lastName}`;
    }
    return name;
}
function $2a7bee67286e6d6e$export$b0fa10378e95e752(num) {
    if (isNaN(num)) return NaN;
    let digits = String(+num).split(""), key = [
        "",
        "C",
        "CC",
        "CCC",
        "CD",
        "D",
        "DC",
        "DCC",
        "DCCC",
        "CM",
        "",
        "X",
        "XX",
        "XXX",
        "XL",
        "L",
        "LX",
        "LXX",
        "LXXX",
        "XC",
        "",
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX"
    ], roman = "", i = 3;
    while(i--)roman = (key[+digits.pop() + i * 10] || "") + roman;
    return Array(+digits.join("") + 1).join("M") + roman;
}
function $2a7bee67286e6d6e$export$543bc81e5a2358fd(endMonth, endYear, startMonth, startYear) {
    return endMonth + endYear * 12 - (startMonth + startYear * 12);
}
function $2a7bee67286e6d6e$export$bd35453f482416c8(value, min, max) {
    if (value > max) return max;
    else if (value < min) return min;
    return value;
}
function $2a7bee67286e6d6e$export$b03bcc2d6e021b95(name, string) {
    const re = new RegExp("\\b(" + name + ")\\b", "i");
    return re.exec(string);
}
async function $2a7bee67286e6d6e$export$50269d73e013f749(rosterMember) {
    if (rosterMember.objectName === "superstar") return (0, $hBIDz.getSuperstarStreaks)(rosterMember);
    else if (rosterMember.objectName === "tagTeam") return (0, $972Ip.getTagTeamStreaks)(rosterMember);
}
async function $2a7bee67286e6d6e$export$f404d0b7eb87fdd5(rosterMember) {
    if (rosterMember.objectName === "superstar") return (0, $hBIDz.getSuperstarWonTournaments)(rosterMember);
    else if (rosterMember.objectName === "tagTeam") return (0, $972Ip.getTagTeamWonTournaments)(rosterMember);
}
async function $2a7bee67286e6d6e$export$69f9dc468ea2a8b8(rosterMember, superstars) {
    let popularity = rosterMember.objectName === "superstar" ? rosterMember.popularity : await (0, $ko5kE.getTagTeamPopularity)(rosterMember, superstars);
    return (0, $5kTkA.getRankFromPopularity)(popularity);
}
async function $2a7bee67286e6d6e$export$9abeb93fe44ac16b(rosterMember, superstars) {
    if (rosterMember.objectName === "superstar") return rosterMember.popularity;
    else if (rosterMember.objectName === "tagTeam" || rosterMember.objectName === "faction") return (0, $ko5kE.getTagTeamPopularity)(rosterMember, superstars);
}
async function $2a7bee67286e6d6e$export$7cba4e02f40c02a5(rosterMember) {
    if (rosterMember.objectName === "superstar") return rosterMember.alignment;
    else if (rosterMember.objectName === "tagTeam" || rosterMember.objectName === "faction") {
        const s = await (0, $5kTkA.getRosterMemberSuperstars)(rosterMember);
        return s.every((x)=>x.alignment === s[0].alignment) ? s[0].alignment : null;
    }
}
async function $2a7bee67286e6d6e$export$8654ecbbc696e94(rosterMember) {
    if (rosterMember.objectName === "superstar") return rosterMember.brandName;
    else if (rosterMember.objectName === "tagTeam" || rosterMember.objectName === "faction") return (0, $ko5kE.getTagTeamBrandName)(rosterMember);
}
async function $2a7bee67286e6d6e$export$7683ef391ccf419b(rosterMember) {
    if (rosterMember.objectName === "superstar") return rosterMember.overness;
    else if (rosterMember.objectName === "tagTeam" || rosterMember.objectName === "faction") {
        const s = await (0, $5kTkA.getRosterMemberSuperstars)(rosterMember);
        return Math.round(s.reduce((n, { overness: overness })=>n + overness, 0) / s.length);
    }
}
async function $2a7bee67286e6d6e$export$974abedecf6b222d(rosterMember) {
    if (rosterMember.objectName === "superstar") return rosterMember.age;
    else if (rosterMember.objectName === "tagTeam" || rosterMember.objectName === "faction") {
        const s = await (0, $5kTkA.getRosterMemberSuperstars)(rosterMember);
        return Math.round(s.reduce((n, { age: age })=>n + age, 0) / s.length);
    }
}
async function $2a7bee67286e6d6e$export$7ed7850db215f44e(rosterMember) {
    if (rosterMember.objectName === "superstar") return rosterMember.faceOfTheCompany;
    else if (rosterMember.objectName === "tagTeam" || rosterMember.objectName === "faction") {
        const s = await (0, $5kTkA.getRosterMemberSuperstars)(rosterMember);
        return s.every((x)=>x.faceOfTheCompany);
    }
}
async function $2a7bee67286e6d6e$export$36efe9ffd55a2a66(rosterMember) {
    if (rosterMember.objectName === "superstar") return rosterMember.hot;
    else if (rosterMember.objectName === "tagTeam" || rosterMember.objectName === "faction") {
        const s = await (0, $5kTkA.getRosterMemberSuperstars)(rosterMember);
        return s.every((x)=>x.hot);
    }
}
async function $2a7bee67286e6d6e$export$20b3fa36d2b61a01(rosterMember) {
    if (rosterMember.objectName === "superstar") return rosterMember.stale;
    else if (rosterMember.objectName === "tagTeam" || rosterMember.objectName === "faction") {
        const s = await (0, $5kTkA.getRosterMemberSuperstars)(rosterMember);
        return s.every((x)=>x.stale);
    }
}
function $2a7bee67286e6d6e$export$667d95731ce46427(array1, array2) {
    return array1.length === array2.length && array1.every((y)=>array2.includes(y));
}
function $2a7bee67286e6d6e$export$b558934c4be14569(array1, array2) {
    return array1.length === array2.length && array1.every((y)=>$2a7bee67286e6d6e$export$eed912e6ca072e35(y, array2));
}
function $2a7bee67286e6d6e$export$bb9033084e40f52e(item) {
    if (item.objectName === "segment") return (0, $4ptHI.getSegmentName)(item);
    else return (0, $6RCLU.getMatchName)(item);
}
function $2a7bee67286e6d6e$export$98f6ffead66e49fe(arr, len) {
    let chunks = [], i = 0, n = arr.length;
    while(i <= n - len)chunks.push(arr.slice(i, i += len));
    return chunks;
}
function $2a7bee67286e6d6e$export$b9e43d1765415474(x) {
    return Math.log(x) / Math.log(2) % 1 === 0;
}
function $2a7bee67286e6d6e$export$d02631cccf789723(size, startAt = 0) {
    return [
        ...Array(size).keys()
    ].map((i)=>i + startAt);
}
function $2a7bee67286e6d6e$export$ae791a2edf8cdca3() {
    const colorsList = [
        "0x502F0C",
        "0x733A00",
        "0x844B11",
        "0xA3672B",
        "0xC48647",
        "0xB04F1B",
        "0xFFFA84",
        "0x471E08",
        "0x999999",
        "0xEB8C4E",
        "0x090909",
        "0x3E3120",
        "0xDEBE99",
        "0x4C4C4C",
        "0xAA8866",
        "0x4F1A00",
        "0x9A3300",
        "0xE5E5E5",
        "0xC05D1C",
        "0xD5C427",
        "0xEBB25F"
    ];
    if ($2a7bee67286e6d6e$export$b141de964f0a90c1(0, 100) <= 90) return $2a7bee67286e6d6e$export$f800fa30df95721e(colorsList);
    else return $2a7bee67286e6d6e$export$e4369cabd7e84cd9();
}
function $2a7bee67286e6d6e$export$e4369cabd7e84cd9() {
    const letters = "0123456789ABCDEF";
    let color = "0x";
    for(let i = 0; i < 6; i++)color += letters[Math.floor(Math.random() * 16)];
    return color;
}
function $2a7bee67286e6d6e$export$c0088e391060c497(talent) {
    if (talent.age <= 25) return 1.5;
    else if (talent.age <= 32) return 1.25;
    else if (talent.age <= 40) return 1;
    else return 0.5;
}
function $2a7bee67286e6d6e$export$8977ea11325e9663(morale) {
    if (morale >= 60) return "Happy";
    else if (morale >= 40) return "Content";
    else if (morale >= 20) return "Dissatisfied";
    else return "Unhappy";
}
function $2a7bee67286e6d6e$export$85a767fc1194f4fe(overness, isSuperstar = true) {
    if (overness >= 80) {
        if (isSuperstar) return "Over";
        else return "Hot";
    } else if (overness >= 60) return "Popular";
    else if (overness >= 40) return "Average";
    else if (overness >= 20) return "Not Popular";
    else return "Stale";
}
async function $2a7bee67286e6d6e$export$fbc7cb4e17e9d5af(iters, callback) {
    for (let i of iters){
        const promise = new Promise((resolve, _reject)=>{
            setTimeout(async ()=>{
                await callback(i);
                resolve();
            }, 0);
        });
        await promise;
    }
}
async function $2a7bee67286e6d6e$export$beca342e15b450be(url) {
    let response = await fetch(url);
    return response.json();
}
function $2a7bee67286e6d6e$export$3e205fbb5df021e0(error) {
    console.log(error);
    if (typeof window.Sentry !== "undefined") Sentry.captureException(error);
}
function $2a7bee67286e6d6e$export$e73c8bd0f20705a() {
    let d = new Date().getTime(), d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 0x7 | 0x8).toString(16);
    });
}
const $2a7bee67286e6d6e$export$6a5180f226647561 = [
    "doctor",
    "scout",
    "producer",
    "trainer",
    "talent_manager"
];
const $2a7bee67286e6d6e$export$32b5099f8e5b8fb5 = {
    "doctor": "Medical",
    "scout": "Scouting",
    "producer": "Production",
    "trainer": "Training",
    "talent_manager": "Talent Management"
};
const $2a7bee67286e6d6e$export$b5b5f5e787b6343d = {
    2: 200,
    3: 450
};
const $2a7bee67286e6d6e$export$4ac53a7f06b2ce2c = {
    "maxCompetitors": 5,
    "maxEditorCompetitors": 24,
    "maxTraits": 10,
    "maxFactionSuperstars": 25,
    "maxRosterSuperstars": 500
};
const $2a7bee67286e6d6e$export$2f234d44f725e283 = {
    1: 0,
    2: 10,
    3: 30,
    4: 60,
    5: 100,
    6: 150,
    7: 210,
    8: 280,
    9: 360,
    10: 450,
    11: 550
};
const $2a7bee67286e6d6e$export$e258b12cc6714c1b = [
    200,
    500,
    1100,
    2300,
    5000,
    10500,
    22000,
    47000,
    99000,
    212000,
    451000
];
const $2a7bee67286e6d6e$export$c220c573eeaab725 = {
    "Medical": {
        "actionsToNextLevel": {
            2: 5,
            3: 12
        },
        "actionName": "Injuries Recovered",
        "nextLevelInfo": {
            1: "The Developed (Level 2) Medical Facility unlocks the Rehab Facility for faster injury recovery and allows two Doctors up to Level 2 to work for you.",
            2: "The Advanced (Level 3) Medical Facility unlocks an improved Rehab Facility for faster injury recovery and allows three Doctors up to Level 3 to work for you.",
            3: "Your Advanced Medical Facility includes excellent rehab facilities and allows three Doctors up to Level 3 to work for you."
        }
    },
    "Production": {
        "actionsToNextLevel": {
            2: 25,
            3: 60
        },
        "actionName": "Production Packages Produced",
        "nextLevelInfo": {
            1: "The Developed (Level 2) Production Facility unlocks the Championship Gimmicks Facility to add gimmicks to custom championships, allows you to have more (+2) Matches and Segments on your shows and allows two Producers up to Level 2 to work for you.",
            2: "The Advanced (Level 3) Production Facility unlocks the Focused Packages Facility to create custom production packages, allows you to have more (+4) Matches and Segments on your shows and allows three Producers up to Level 3 to work for you.",
            3: "Your Advanced Production Facility includes more (+4) Matches and Segments on shows, the Championship Gimmicks Facility, the Focused Packages Facility and allows three Producers up to Level 3 to work for you."
        }
    },
    "Scouting": {
        "actionsToNextLevel": {
            2: 8,
            3: 20
        },
        "actionName": "Superstars Scouted/Recruited",
        "nextLevelInfo": {
            1: "The Developed (Level 2) Scouting Facility unlocks the Interest-building Facility for reducing indie signing costs and allows two Scouts up to Level 2 to work for you.",
            2: "The Advanced (Level 3) Scouting Facility unlocks the Indie Tracking Facility to recruit new indie talent and allows three Scouts up to Level 3 to work for you.",
            3: "Your Advanced Scouting Facility includes the Interest-building Facility, the Indie Tracking Facility and allows three Scouts up to Level 3 to work for you."
        }
    },
    "Training": {
        "actionsToNextLevel": {
            2: 4,
            3: 10
        },
        "actionName": "Superstars Trained",
        "nextLevelInfo": {
            1: "The Developed (Level 2) Training Facility increases Training Roster changes (Popularity, XP and Overness) and allows two Trainers up to Level 2 to work for you.",
            2: "The Advanced (Level 3) Training Facility unlocks the Accelerated Training Facility to easily bring newly signed talent straight to the Main Roster, further increases Training Roster changes (Popularity, XP and Overness) and allows three Trainers up to Level 3 to work for you.",
            3: "Your Advanced Training Facility includes the Accelerated Training Facility, increases Training Roster changes (Popularity, XP and Overness) and allows three Trainers up to Level 3 to work for you."
        }
    },
    "Talent Management": {
        "actionsToNextLevel": {
            2: 15,
            3: 35
        },
        "actionName": "Superstars Reassured / Talent Requests Completed",
        "nextLevelInfo": {
            1: "The Developed (Level 2) Talent Management Facility unlocks the Guaranteed Appearances Facility, allowing you to negotiate a minimum number of appearances with part-timers at the end of the year and allows two Talent Managers up to Level 2 to work for you.",
            2: "The Advanced (Level 3) Talent Management Facility unlocks the Company Acquisition Facility, allowing you to buyout Competitors with certain conditions and allows three Talent Managers up to Level 3 to work for you.",
            3: "Your Advanced Talent Management Facility includes the Guaranteed Appearances Facility, the Company Acquisition Facility and allows three Talent Managers up to Level 3 to work for you."
        }
    }
};
const $2a7bee67286e6d6e$export$9337016f09b3e64e = {
    "male": [
        "Aaron",
        "Adam",
        "Adil",
        "Alan",
        "Albert",
        "Alberto",
        "Alex",
        "Alexander",
        "Alfie",
        "Alfonso",
        "Amir",
        "Angel",
        "Anthony",
        "Austin",
        "Axel",
        "Bartolomeu",
        "Benjamin",
        "Billy",
        "Bobby",
        "Brian",
        "Bruce",
        "Bruno",
        "Bryan",
        "Carl",
        "Cesar",
        "Charles",
        "Christian",
        "Christopher",
        "Craig",
        "Damien",
        "Daniel",
        "Dario",
        "David",
        "Dominic",
        "Donald",
        "Doug",
        "Drake",
        "Dylan",
        "Ed",
        "Eddie",
        "Edgar",
        "Eduardo",
        "Eli",
        "Emanuel",
        "Emin",
        "Eric",
        "Eugene",
        "Evil",
        "Fabio",
        "Fernando",
        "Florian",
        "Frank",
        "Gaspard",
        "George",
        "Gerald",
        "Gregory",
        "Gus",
        "Gustavo",
        "Harry",
        "Hayden",
        "Henry",
        "Howard",
        "Hugo",
        "Igor",
        "Ivan",
        "Jack",
        "Jaime",
        "James",
        "Jase",
        "Jason",
        "Jay",
        "Jerry",
        "Jesse",
        "Jimmy",
        "Joe",
        "John",
        "Johnathan",
        "Johnny",
        "Jordan",
        "Jose",
        "Juan",
        "Julian",
        "Justin",
        "Karl",
        "Keith",
        "Kenneth",
        "Kevin",
        "Kyle",
        "Larry",
        "Leonard",
        "Louis",
        "Lucas",
        "Marco",
        "Marin",
        "Marlon",
        "Matt",
        "Max",
        "Michael",
        "Mohit",
        "Muhammad",
        "Nate",
        "Nathan",
        "Nicolas",
        "Nolan",
        "Octavian",
        "Omer",
        "Oscar",
        "Pat",
        "Paul",
        "Pedro",
        "Philip",
        "Phoenix",
        "Rafael",
        "Rahul",
        "Randy",
        "Raymond",
        "Rhys",
        "Richard",
        "Riley",
        "Rob",
        "Robin",
        "Rocky",
        "Roger",
        "Russell",
        "Ryan",
        "Sabir",
        "Sam",
        "Sami",
        "Samuel",
        "Scott",
        "Sean",
        "Sebastian",
        "Silvester",
        "Simon",
        "Stan",
        "Steven",
        "Terry",
        "Theo",
        "Tim",
        "Tom",
        "Trent",
        "Tyler",
        "Victor",
        "Vince",
        "Vladimir",
        "Vladislav",
        "Wayne",
        "William",
        "Willie",
        "Zachary",
        "Fab",
        "Mad",
        "Mr. "
    ],
    "female": [
        "Alice",
        "Amanda",
        "Amber",
        "Amelie",
        "Amy",
        "Anabela",
        "Andrea",
        "Angela",
        "Ann",
        "Anna",
        "Ashley",
        "Aubree",
        "Barbara",
        "Betty",
        "Beverly",
        "Brenda",
        "Brittany",
        "Carmen",
        "Carol",
        "Carolyn",
        "Catherine",
        "Cheryl",
        "Christina",
        "Christine",
        "Claudia",
        "Crystal",
        "Cynthia",
        "Danielle",
        "Deborah",
        "Debra",
        "Deepa",
        "Denise",
        "Diana",
        "Diane",
        "Donna",
        "Doris",
        "Dorothy",
        "Elizabeth",
        "Emily",
        "Emma",
        "Eva",
        "Evelyn",
        "Frances",
        "Gloria",
        "Grace",
        "Hannah",
        "Heather",
        "Helen",
        "Helena",
        "Imogen",
        "Jacqueline",
        "Jane",
        "Janet",
        "Janice",
        "Jasmine",
        "Jean",
        "Jennifer",
        "Jessica",
        "Joan",
        "Joyce",
        "Judith",
        "Judy",
        "Julia",
        "Julie",
        "Karen",
        "Katherine",
        "Kathleen",
        "Kathryn",
        "Kathy",
        "Kelly",
        "Kimberly",
        "Laura",
        "Lauren",
        "Linda",
        "Lisa",
        "Lola",
        "Lori",
        "Luna",
        "Madison",
        "Margaret",
        "Maria",
        "Marie",
        "Marilyn",
        "Marketa",
        "Martha",
        "Mary",
        "Megan",
        "Melania",
        "Melissa",
        "Mia",
        "Michelle",
        "Mildred",
        "Mina",
        "Monica",
        "Nancy",
        "Natalia",
        "Nicole",
        "Olivia",
        "Pamela",
        "Patricia",
        "Peyton",
        "Pooja",
        "Priya",
        "Rachel",
        "Rebecca",
        "Rose",
        "Ruth",
        "Samantha",
        "Sandra",
        "Sara",
        "Sarah",
        "Sharon",
        "Shirley",
        "Sofia",
        "Sophia",
        "Stephanie",
        "Summer",
        "Susan",
        "Tammy",
        "Tayla",
        "Teresa",
        "Tessa",
        "Theresa",
        "Theresa",
        "Tiffany",
        "Valerie",
        "Victoria",
        "Virginia",
        "Mrs. ",
        "Candy",
        "Indigo",
        "Dandelion"
    ]
};
const $2a7bee67286e6d6e$export$c00029808f76df2c = [
    "Adams",
    "Alexander",
    "Allen",
    "Alvarez",
    "Anderson",
    "Andrews",
    "Armstrong",
    "Arnold",
    "Austin",
    "Bailey",
    "Baker",
    "Banks",
    "Barnes",
    "Barnett",
    "Barrett",
    "Bates",
    "Beck",
    "Bell",
    "Bennett",
    "Black",
    "Bowman",
    "Bradley",
    "Brewer",
    "Brooks",
    "Brown",
    "Bryant",
    "Burke",
    "Burns",
    "Burton",
    "Campbell",
    "Carlson",
    "Carpenter",
    "Carr",
    "Carroll",
    "Carter",
    "Castillo",
    "Castro",
    "Chapman",
    "Chavez",
    "Chen",
    "Clark",
    "Cole",
    "Coleman",
    "Collins",
    "Contreras",
    "Cook",
    "Cooper",
    "Cox",
    "Crawford",
    "Cruz",
    "Cunningham",
    "Curtis",
    "Daniels",
    "Davis",
    "Day",
    "Dean",
    "Delgado",
    "Diaz",
    "Dixon",
    "Douglas",
    "Duncan",
    "Dunn",
    "Edwards",
    "Elliott",
    "Ellis",
    "Estrada",
    "Evans",
    "Fernandez",
    "Fields",
    "Fisher",
    "Flores",
    "Ford",
    "Foster",
    "Fox",
    "Fuller",
    "Garcia",
    "Gardner",
    "Garrett",
    "Garza",
    "George",
    "Gomez",
    "Gonzales",
    "Gonzalez",
    "Gordon",
    "Graham",
    "Grant",
    "Gray",
    "Green",
    "Greene",
    "Guerrero",
    "Gutierrez",
    "Hall",
    "Hamilton",
    "Hansen",
    "Hanson",
    "Harper",
    "Harris",
    "Harrison",
    "Hart",
    "Harvey",
    "Hawkins",
    "Hayes",
    "Henderson",
    "Henry",
    "Hernandez",
    "Herrera",
    "Hicks",
    "Hill",
    "Holland",
    "Holmes",
    "Hopkins",
    "Howard",
    "Howell",
    "Hughes",
    "Hunt",
    "Hunter",
    "Jackson",
    "Jacobs",
    "James",
    "Jenkins",
    "Jensen",
    "Johnson",
    "Jones",
    "Jordan",
    "Keller",
    "Kennedy",
    "Kim",
    "King",
    "Knight",
    "Lane",
    "Larson",
    "Lee",
    "Lewis",
    "Little",
    "Long",
    "Lopez",
    "Lucas",
    "Lynch",
    "Marshall",
    "Martinez",
    "Mason",
    "Matthews",
    "May",
    "McDonald",
    "Medina",
    "Mendez",
    "Mendoza",
    "Meyer",
    "Miller",
    "Mills",
    "Mitchell",
    "Moore",
    "Morales",
    "Moreno",
    "Morgan",
    "Morris",
    "Morrison",
    "Munoz",
    "Murray",
    "Myers",
    "Nelson",
    "Newman",
    "Nguyen",
    "Nichols",
    "Oliver",
    "Olson",
    "Ortega",
    "Ortiz",
    "Owens",
    "Palmer",
    "Parker",
    "Patel",
    "Patterson",
    "Payne",
    "Pearson",
    "Perkins",
    "Perry",
    "Peters",
    "Peterson",
    "Phillips",
    "Pierce",
    "Porter",
    "Powell",
    "Price",
    "Ramirez",
    "Ramos",
    "Ray",
    "Reed",
    "Reid",
    "Reyes",
    "Reynolds",
    "Rice",
    "Richards",
    "Richardson",
    "Riley",
    "Rios",
    "Roberts",
    "Robertson",
    "Robinson",
    "Rodriguez",
    "Rogers",
    "Romero",
    "Rose",
    "Ross",
    "Ruiz",
    "Russell",
    "Ryan",
    "Sanchez",
    "Sanders",
    "Sandoval",
    "Santos",
    "Schmidt",
    "Schneider",
    "Schultz",
    "Silva",
    "Simmons",
    "Simpson",
    "Sims",
    "Smith",
    "Snyder",
    "Spencer",
    "Stanley",
    "Stephens",
    "Stevens",
    "Stewart",
    "Stone",
    "Sullivan",
    "Taylor",
    "Thomas",
    "Thompson",
    "Torres",
    "Tran",
    "Tucker",
    "Turner",
    "Valdez",
    "Vargas",
    "Vasquez",
    "Wade",
    "Wagner",
    "Walker",
    "Wallace",
    "Walsh",
    "Walters",
    "Ward",
    "Washington",
    "Watkins",
    "Watson",
    "Weaver",
    "Webb",
    "Weber",
    "Wells",
    "West",
    "Wheeler",
    "White",
    "Williams",
    "Williamson",
    "Willis",
    "Wilson",
    "Wong",
    "Wood",
    "Woods",
    "Wright",
    "Young"
];
const $2a7bee67286e6d6e$export$c85070b0dfdc5188 = [
    "Able",
    "Araqr",
    "Atthel",
    "Avin",
    "Brickev",
    "Chol",
    "Chrone",
    "Clipatr",
    "Dennio",
    "Digital",
    "El",
    "Eldan",
    "Enjan",
    "Eoo",
    "Evin",
    "Feri",
    "Fire",
    "Fryan",
    "Garey",
    "Gory",
    "Harlo",
    "Hawne",
    "Hawnio",
    "Hebjam",
    "Hery",
    "Jery",
    "Johne",
    "Jonty",
    "Juany",
    "Kham",
    "Koni",
    "Lary",
    "Lovin",
    "Maester",
    "Maqzuz",
    "Mertutu",
    "Michy",
    "Mondy",
    "Muely",
    "Nichua",
    "Nitrogen",
    "Orange",
    "Oxygen",
    "Priest",
    "Pule",
    "Red",
    "Reverend",
    "Rog",
    "Roni",
    "Sharly",
    "Stimy",
    "Stine",
    "Stoddy",
    "Tauvav",
    "Thenry",
    "Theward",
    "Topu",
    "Turi",
    "Waltodd",
    "Waynio"
];
const $2a7bee67286e6d6e$export$ef26431555f7e916 = [
    "Ales",
    "Anchez",
    "Ashins",
    "Aved",
    "Bande",
    "Binson",
    "Briffost",
    "Campa",
    "Carte",
    "Clema",
    "Coopat",
    "Coopow",
    "Derson",
    "Drusske",
    "Earthling",
    "Ener",
    "Finer",
    "Flare",
    "Grobak",
    "Guezal",
    "Henders",
    "Hingte",
    "Holo",
    "Homan",
    "Jamart",
    "Jamit",
    "Jimin",
    "Kingonz",
    "Lente",
    "Lexand",
    "Lezal",
    "Longonz",
    "Lopark",
    "Lory",
    "Maner",
    "Miray",
    "Pari",
    "Patte",
    "Per",
    "Powash",
    "Power",
    "Price",
    "Priver",
    "Ramorr",
    "Reeder",
    "Reson",
    "River",
    "Rodre",
    "Rogonz",
    "Rossanch",
    "Rowner",
    "Ryantez",
    "Scoley",
    "Smarte",
    "Smil",
    "Smoor",
    "Sones",
    "Thill",
    "Torra",
    "Wanch",
    "Wardams",
    "Wison",
    "Woodez",
    "Yournell",
    "Zene"
];
const $2a7bee67286e6d6e$export$bf232bbd8f73b1e3 = [
    {
        "subject": "Excited!",
        "content": "I'm excited to get to work! Thanks for hiring me."
    },
    {
        "subject": "Ready",
        "content": "I'm ready to get to work. Let me know what you need and I'll do my best."
    },
    {
        "subject": "Thanks",
        "content": "Thank you for giving me a shot. I won't let you down."
    },
    {
        "subject": "New start",
        "content": "I'm so glad to have this new start. It was hard being an independent contractor."
    },
    {
        "subject": "Hey!",
        "content": "I'm so ready to start! Let's do this!"
    },
    {
        "subject": "Thank you",
        "content": "I wanted to formally thank you for hiring me. I will try my best to live up to your expectations."
    },
    {
        "subject": "Work",
        "content": "I'm ready for work. Let me know what my first job is."
    },
    {
        "subject": "Lovely place",
        "content": "This is such a lovely place to work at! I'm really happy to be here."
    }
];
const $2a7bee67286e6d6e$export$7a2a7e755b11d550 = [
    {
        "subject": "What happened?",
        "content": "I thought things were going really well? Really, I did. I don't know what happened .."
    },
    {
        "subject": "Let go",
        "content": "I understand you had to let me go. I won't hold it against you. Good luck for the future."
    },
    {
        "subject": "Scared",
        "content": "I'm a little scared of going back to being an independent contractor. But I got by before, and hey, maybe something better will come along?"
    },
    {
        "subject": "Fired?!",
        "content": "I can't believe you let me go! Your company is going to break down without me! You made the biggest mistake of your career."
    },
    {
        "subject": "What?!",
        "content": "You fired me?! You're crazy to do this! I'm going to make you pay."
    },
    {
        "subject": "Disappointed",
        "content": "I'm really disappointed you let me go. I'm going to go to a company that treats their staff better."
    },
    {
        "subject": "Stupid",
        "content": "Letting me go was a stupid decision on your part. You're going to regret it one day."
    },
    {
        "subject": "Sorry",
        "content": "I'm sorry for letting you down. I guess I have to go now. I really thought I fit in here .."
    }
];
const $2a7bee67286e6d6e$export$4f3ccd6d58995426 = [
    {
        "type": 1,
        "numberOfSuperstars": 9
    },
    {
        "type": 2,
        "numberOfSuperstars": 6
    },
    {
        "type": 3,
        "numberOfSuperstars": 5
    },
    {
        "type": 4,
        "numberOfSuperstars": 3
    }
];
const $2a7bee67286e6d6e$export$14e75549e87e3827 = [
    {
        "type": 5,
        "numberOfSuperstars": 16
    },
    {
        "type": 6,
        "numberOfSuperstars": 16
    },
    {
        "type": 7,
        "numberOfSuperstars": 16
    }
];
const $2a7bee67286e6d6e$export$b0afb21554076fed = {
    "S": 800,
    "A": 300,
    "B": 100,
    "C": 0
};
const $2a7bee67286e6d6e$export$faf5aa19dbf08c1f = {
    "A": 110,
    "B": 40,
    "C": 0
};
const $2a7bee67286e6d6e$var$firstNames = {
    "male": [
        "Aaron",
        "Adam",
        "Alan",
        "Albert",
        "Alexander",
        "Alex",
        "Anthony",
        "Austin",
        "Benjamin",
        "Billy",
        "Bobby",
        "Brian",
        "Bruce",
        "Bryan",
        "Carl",
        "Charles",
        "Christian",
        "Christopher",
        "Craig",
        "Daniel",
        "David",
        "Donald",
        "Doug",
        "Dylan",
        "Ed",
        "Eddie",
        "Eric",
        "Eugene",
        "George",
        "Gerald",
        "Gregory",
        "Harry",
        "Felix",
        "Sabir",
        "Sami",
        "Henry",
        "Howard",
        "Jack",
        "James",
        "Jason",
        "Jerry",
        "Jesse",
        "Joe",
        "Lucas",
        "Adil",
        "Marin",
        "John",
        "Johnny",
        "Jordan",
        "Jose",
        "Juan",
        "Justin",
        "Keith",
        "Kevin",
        "Kyle",
        "Larry",
        "Matt",
        "Pat",
        "Paul",
        "Philip",
        "Randy",
        "Raymond",
        "Angel",
        "Victor",
        "Igor",
        "Gaspard",
        "Theo",
        "Richard",
        "Rob",
        "Roger",
        "Russell",
        "Ryan",
        "Sam",
        "Scott",
        "Sean",
        "Jay",
        "Evil",
        "Steven",
        "Terry",
        "Tom",
        "Tim",
        "Tyler",
        "Vince",
        "Wayne",
        "Karl",
        "Bruno",
        "Paul",
        "Muhammad",
        "William",
        "Willie",
        "Zachary",
        "Stan",
        "Drake",
        "Trent",
        "Velvet",
        "Omer",
        "Michael",
        "Nathan",
        "Selim",
        "Magnus",
        "Vladimir",
        "Gus",
        "Eli",
        "Jase",
        "Riley",
        "Nate",
        "Nolan",
        "Oscar",
        "Cesar",
        "Dario",
        "Rocky",
        "Max",
        "Axel",
        "Alberto",
        "Rhys",
        "Dominic",
        "Julian",
        "Phoenix"
    ],
    "female": [
        "Alice",
        "Amanda",
        "Amber",
        "Amy",
        "Andrea",
        "Angela",
        "Ann",
        "Anna",
        "Ashley",
        "Barbara",
        "Betty",
        "Beverly",
        "Brenda",
        "Brittany",
        "Carol",
        "Carolyn",
        "Catherine",
        "Cheryl",
        "Christina",
        "Christine",
        "Crystal",
        "Cynthia",
        "Danielle",
        "Deborah",
        "Debra",
        "Denise",
        "Diana",
        "Diane",
        "Donna",
        "Doris",
        "Dorothy",
        "Elizabeth",
        "Emily",
        "Emma",
        "Evelyn",
        "Frances",
        "Gloria",
        "Grace",
        "Hannah",
        "Heather",
        "Helen",
        "Jacqueline",
        "Jane",
        "Janet",
        "Janice",
        "Jean",
        "Jennifer",
        "Jessica",
        "Joan",
        "Joyce",
        "Judith",
        "Judy",
        "Julia",
        "Julie",
        "Karen",
        "Katherine",
        "Kathleen",
        "Kathryn",
        "Kathy",
        "Kelly",
        "Kimberly",
        "Laura",
        "Lauren",
        "Linda",
        "Lisa",
        "Lori",
        "Madison",
        "Margaret",
        "Maria",
        "Marie",
        "Marilyn",
        "Martha",
        "Mary",
        "Megan",
        "Melissa",
        "Michelle",
        "Mildred",
        "Nancy",
        "Nicole",
        "Olivia",
        "Pamela",
        "Patricia",
        "Rachel",
        "Rebecca",
        "Rose",
        "Ruth",
        "Samantha",
        "Sandra",
        "Sara",
        "Sarah",
        "Sharon",
        "Shirley",
        "Stephanie",
        "Sophia",
        "Susan",
        "Tammy",
        "Teresa",
        "Theresa",
        "Tiffany",
        "Victoria",
        "Virginia",
        "Queen",
        "Miss",
        "Ela",
        "Io",
        "Juniper",
        "Taya",
        "Rose",
        "Tessa",
        "Tayla",
        "Trinity",
        "Violet",
        "Savannah",
        "Imogen",
        "Summer",
        "Leah",
        "Jordyn",
        "Lea",
        "Lylah",
        "Aleah",
        "Aubree",
        "Isla",
        "Paisley",
        "Peyton",
        "Dahlia",
        "Sombra",
        "Eden",
        "Kitsune",
        "Azalea"
    ]
};
const $2a7bee67286e6d6e$var$lastNames = [
    "Adams",
    "Alexander",
    "Allen",
    "Alvarez",
    "Anderson",
    "Andrews",
    "Armstrong",
    "Arnold",
    "Austin",
    "Bailey",
    "Baker",
    "Banks",
    "Barnes",
    "Barnett",
    "Barrett",
    "Bates",
    "Beck",
    "Bell",
    "Bennett",
    "Black",
    "Bowman",
    "Bradley",
    "Brewer",
    "Brooks",
    "Brown",
    "Bryant",
    "Burke",
    "Burns",
    "Burton",
    "Campbell",
    "Carlson",
    "Carpenter",
    "Carr",
    "Carroll",
    "Carter",
    "Castillo",
    "Castro",
    "Chapman",
    "Chavez",
    "Chen",
    "Clark",
    "Cole",
    "Coleman",
    "Collins",
    "Contreras",
    "Cook",
    "Cooper",
    "Cox",
    "Crawford",
    "Cruz",
    "Cunningham",
    "Curtis",
    "Daniels",
    "Davis",
    "Day",
    "Dean",
    "Delgado",
    "Diaz",
    "Dixon",
    "Douglas",
    "Duncan",
    "Dunn",
    "Edwards",
    "Elliott",
    "Ellis",
    "Estrada",
    "Evans",
    "Fernandez",
    "Fields",
    "Fisher",
    "Flores",
    "Ford",
    "Foster",
    "Fox",
    "Fuller",
    "Garcia",
    "Gardner",
    "Garrett",
    "Garza",
    "George",
    "Gomez",
    "Gonzales",
    "Gonzalez",
    "Gordon",
    "Graham",
    "Grant",
    "Gray",
    "Green",
    "Greene",
    "Guerrero",
    "Gutierrez",
    "Hall",
    "Hamilton",
    "Hansen",
    "Hanson",
    "Harper",
    "Harris",
    "Harrison",
    "Hart",
    "Harvey",
    "Hawkins",
    "Hayes",
    "Henderson",
    "Henry",
    "Hernandez",
    "Herrera",
    "Hicks",
    "Hill",
    "Holland",
    "Holmes",
    "Hopkins",
    "Howard",
    "Howell",
    "Hughes",
    "Hunt",
    "Hunter",
    "Jackson",
    "Jacobs",
    "James",
    "Jenkins",
    "Jensen",
    "Johnson",
    "Jones",
    "Jordan",
    "Keller",
    "Kennedy",
    "Kim",
    "King",
    "Knight",
    "Lane",
    "Larson",
    "Lee",
    "Lewis",
    "Little",
    "Long",
    "Lopez",
    "Lucas",
    "Lynch",
    "Marshall",
    "Martinez",
    "Mason",
    "Matthews",
    "May",
    "McDonald",
    "Medina",
    "Mendez",
    "Mendoza",
    "Meyer",
    "Miller",
    "Mills",
    "Mitchell",
    "Moore",
    "Morales",
    "Moreno",
    "Morgan",
    "Morris",
    "Morrison",
    "Munoz",
    "Murray",
    "Myers",
    "Nelson",
    "Newman",
    "Nguyen",
    "Nichols",
    "Oliver",
    "Olson",
    "Ortega",
    "Ortiz",
    "Owens",
    "Palmer",
    "Parker",
    "Patel",
    "Patterson",
    "Payne",
    "Pearson",
    "Perkins",
    "Perry",
    "Peters",
    "Peterson",
    "Phillips",
    "Pierce",
    "Porter",
    "Powell",
    "Price",
    "Ramirez",
    "Ramos",
    "Ray",
    "Reed",
    "Reid",
    "Reyes",
    "Reynolds",
    "Rice",
    "Richards",
    "Richardson",
    "Riley",
    "Rios",
    "Roberts",
    "Robertson",
    "Robinson",
    "Rodriguez",
    "Rogers",
    "Romero",
    "Rose",
    "Ross",
    "Ruiz",
    "Russell",
    "Ryan",
    "Sanchez",
    "Sanders",
    "Sandoval",
    "Santos",
    "Schmidt",
    "Schneider",
    "Schultz",
    "Silva",
    "Simmons",
    "Simpson",
    "Smith",
    "Snyder",
    "Spencer",
    "Stanley",
    "Stephens",
    "Stevens",
    "Stewart",
    "Stone",
    "Sullivan",
    "Taylor",
    "Thomas",
    "Thompson",
    "Torres",
    "Tran",
    "Tucker",
    "Turner",
    "Valdez",
    "Vargas",
    "Vasquez",
    "Wade",
    "Wagner",
    "Walker",
    "Wallace",
    "Walsh",
    "Walters",
    "Ward",
    "Washington",
    "Watkins",
    "Watson",
    "Weaver",
    "Webb",
    "Weber",
    "Wells",
    "West",
    "Wheeler",
    "White",
    "Williams",
    "Williamson",
    "Willis",
    "Wilson",
    "Wong",
    "Wood",
    "Woods",
    "Wright",
    "Young",
    "Crude",
    "Watts",
    "Black",
    "Crusher",
    "Flye",
    "Dragon",
    "Carnage",
    "Storm",
    "Bane",
    "Bukhari",
    "Wyatt",
    "Bourne",
    "Cat",
    "Lethal",
    "Jr",
    "Sr",
    "Hero",
    "Strong",
    "Pain",
    "Kong",
    "Butcher",
    "Cabana",
    "Red",
    "Blue",
    "Tiger",
    "Gunn",
    "Slinger",
    "Spot",
    "Studd",
    "Angel",
    "Koloff",
    "Punisher",
    "Ice",
    "Storm",
    "Ray",
    "Kid",
    "Jack",
    "Frye",
    "Flame",
    "Rocker",
    "Lee",
    "Horowitz",
    "Rich",
    "Rose",
    "Regal",
    "Cannon",
    "Wolfman",
    "Dust",
    "Dream",
    "the Third",
    "Hawke",
    "Flowers",
    "Durante",
    "Gallows",
    "Graves",
    "Rain",
    "Beast"
];
const $2a7bee67286e6d6e$var$martianFirstNames = [
    "Able",
    "Araqr",
    "Atthel",
    "Avin",
    "Brickev",
    "Chol",
    "Chrone",
    "Clipatr",
    "Dennio",
    "Digital",
    "El",
    "Eldan",
    "Enjan",
    "Eoo",
    "Evin",
    "Feri",
    "Fire",
    "Fryan",
    "Garey",
    "Gory",
    "Harlo",
    "Hawne",
    "Hawnio",
    "Hebjam",
    "Hery",
    "Jery",
    "Johne",
    "Jonty",
    "Juany",
    "Kham",
    "Koni",
    "Lary",
    "Lovin",
    "Maester",
    "Maqzuz",
    "Mertutu",
    "Michy",
    "Mondy",
    "Muely",
    "Nichua",
    "Nitrogen",
    "Orange",
    "Oxygen",
    "Priest",
    "Pule",
    "Red",
    "Reverend",
    "Rog",
    "Roni",
    "Sharly",
    "Sol",
    "Solar",
    "Space",
    "Stimy",
    "Stine",
    "Stoddy",
    "Tauvav",
    "The",
    "The",
    "The",
    "Thenry",
    "Theward",
    "Topu",
    "Turi",
    "Venutian",
    "Virtual",
    "Waltodd",
    "Waynio"
];
const $2a7bee67286e6d6e$var$martianLastNames = [
    "Ales",
    "Anchez",
    "Ashins",
    "Aved",
    "Bande",
    "Binson",
    "Briffost",
    "Campa",
    "Carte",
    "Clema",
    "Coopat",
    "Coopow",
    "Derson",
    "Drusske",
    "Earthling",
    "Ener",
    "Energy",
    "Finer",
    "Flare",
    "Freeze",
    "God",
    "Grobak",
    "Guezal",
    "Henders",
    "Hingte",
    "Holo",
    "Homan",
    "Jamart",
    "Jamit",
    "Jimin",
    "Kingonz",
    "Lente",
    "Lexand",
    "Lezal",
    "Longonz",
    "Lopark",
    "Lory",
    "Man",
    "Maner",
    "Meteor",
    "Miray",
    "Mission",
    "Oxide",
    "Pari",
    "Patte",
    "Per",
    "Powash",
    "Power",
    "Price",
    "Priver",
    "Ramorr",
    "Reeder",
    "Reson",
    "River",
    "Rodre",
    "Rogonz",
    "Rossanch",
    "Rowner",
    "Ryantez",
    "Scoley",
    "Sensation",
    "Smarte",
    "Smil",
    "Smoor",
    "Sones",
    "Sones",
    "Supply",
    "Thill",
    "Torra",
    "Virus",
    "Voyager",
    "Wanch",
    "Wardams",
    "Wison",
    "Woodez",
    "Yournell",
    "Zene"
];
const $2a7bee67286e6d6e$export$12f5d44842119050 = {
    "rating": [
        "events",
        "matches",
        "gimmick matches"
    ],
    "company": [
        "holy shit moments",
        "main eventers signed",
        "new championship",
        "win awards",
        "win moty",
        "win eoty",
        "win woty",
        "win gmoty"
    ],
    "superstar": [
        "win battle royal",
        "win championship contract",
        "face of the company",
        "main eventer",
        "new tag team",
        "get over",
        "new trio"
    ]
};

});
parcelRequire.register("98xmD", function(module, exports) {

$parcel$export(module.exports, "globalUser", () => $6a6ebdd59dcb1e0c$export$d73d89a5747bacca);
$parcel$export(module.exports, "globals", () => $6a6ebdd59dcb1e0c$export$816be348776d53c1);
let $6a6ebdd59dcb1e0c$var$requestRunning = false;
let $6a6ebdd59dcb1e0c$var$cloudSaveRequestRunning = false;
let $6a6ebdd59dcb1e0c$var$game = {};
$6a6ebdd59dcb1e0c$var$game.settings = {};
$6a6ebdd59dcb1e0c$var$game.powerupLevel1 = "powerup_1_icon";
$6a6ebdd59dcb1e0c$var$game.powerupLevel2 = "powerup_2_icon";
$6a6ebdd59dcb1e0c$var$game.powerupLevel3 = "powerup_3_icon";
$6a6ebdd59dcb1e0c$var$game.powerupWord = "Artifact";
const $6a6ebdd59dcb1e0c$export$d73d89a5747bacca = {};
$6a6ebdd59dcb1e0c$export$d73d89a5747bacca.settings = {};
$6a6ebdd59dcb1e0c$export$d73d89a5747bacca.developerMode = location.hostname === "localhost";
let $6a6ebdd59dcb1e0c$var$baseUrl = "";
const $6a6ebdd59dcb1e0c$export$816be348776d53c1 = {
    requestRunning: $6a6ebdd59dcb1e0c$var$requestRunning,
    cloudSaveRequestRunning: $6a6ebdd59dcb1e0c$var$cloudSaveRequestRunning,
    game: $6a6ebdd59dcb1e0c$var$game,
    currentTutorialStep: null,
    baseUrl: $6a6ebdd59dcb1e0c$var$baseUrl
};

});

parcelRequire.register("14eBR", function(module, exports) {

$parcel$export(module.exports, "db", () => $0c717f5331597510$export$f932f06c7eb6abeb);
$parcel$export(module.exports, "Superstars", () => $0c717f5331597510$export$4164f670d029583c);
$parcel$export(module.exports, "TagTeams", () => $0c717f5331597510$export$ce3603a60c2b7c54);
$parcel$export(module.exports, "Championships", () => $0c717f5331597510$export$8f6549b3f582f539);
$parcel$export(module.exports, "Matches", () => $0c717f5331597510$export$6479cfcac2b87c0);
$parcel$export(module.exports, "Games", () => $0c717f5331597510$export$93fd0e768dbd3f80);
$parcel$export(module.exports, "Companies", () => $0c717f5331597510$export$231b12729d1c37ce);
$parcel$export(module.exports, "Events", () => $0c717f5331597510$export$ada873a34909da65);
$parcel$export(module.exports, "Rosters", () => $0c717f5331597510$export$9be83b813194f4b8);
$parcel$export(module.exports, "Scenarios", () => $0c717f5331597510$export$2e72096e1cea7866);
$parcel$export(module.exports, "ChampionshipReigns", () => $0c717f5331597510$export$add1c0636ac93680);
$parcel$export(module.exports, "Streaks", () => $0c717f5331597510$export$3d8bd892ba1ae6f9);
$parcel$export(module.exports, "Brands", () => $0c717f5331597510$export$8cf0a2ece96e33e9);
$parcel$export(module.exports, "Factions", () => $0c717f5331597510$export$c454e4c3445e22b1);
$parcel$export(module.exports, "CompanyLogs", () => $0c717f5331597510$export$fc945748e9838371);
$parcel$export(module.exports, "GimmickMatches", () => $0c717f5331597510$export$caf50ac2a13b4508);
$parcel$export(module.exports, "CompanyAlerts", () => $0c717f5331597510$export$76739aee1cb6bd37);
$parcel$export(module.exports, "NewsItems", () => $0c717f5331597510$export$ac348fcc205420ed);
$parcel$export(module.exports, "Objectives", () => $0c717f5331597510$export$715d548ffbdb4245);
$parcel$export(module.exports, "Properties", () => $0c717f5331597510$export$8714badcfa4caafb);
$parcel$export(module.exports, "Relationships", () => $0c717f5331597510$export$ddbf7887bc0aa836);
$parcel$export(module.exports, "Powerups", () => $0c717f5331597510$export$f327e01d1ded4084);
$parcel$export(module.exports, "MatchContracts", () => $0c717f5331597510$export$a694b2871fa6c464);
$parcel$export(module.exports, "StoryChoices", () => $0c717f5331597510$export$da48ce74a0b0952b);
$parcel$export(module.exports, "Tournaments", () => $0c717f5331597510$export$d539445bbfebe79d);
$parcel$export(module.exports, "Feuds", () => $0c717f5331597510$export$4606ee8058194b06);
$parcel$export(module.exports, "FeudItems", () => $0c717f5331597510$export$e53c7703801823f1);
$parcel$export(module.exports, "Segments", () => $0c717f5331597510$export$cfdc085ffca97c47);
$parcel$export(module.exports, "SegmentItems", () => $0c717f5331597510$export$5c62f70d0baa8eda);
$parcel$export(module.exports, "Gimmicks", () => $0c717f5331597510$export$fec63823e61a2566);
$parcel$export(module.exports, "Messages", () => $0c717f5331597510$export$ceaacf8b390a3600);
$parcel$export(module.exports, "RandomEvents", () => $0c717f5331597510$export$47e9b71178c96712);
$parcel$export(module.exports, "StaffMembers", () => $0c717f5331597510$export$57a67e779dfa1a4d);
$parcel$export(module.exports, "Facilities", () => $0c717f5331597510$export$442a48e23d8e9d11);
$parcel$export(module.exports, "YearlyRankings", () => $0c717f5331597510$export$36edd0a1564c0ffc);
$parcel$export(module.exports, "Drafts", () => $0c717f5331597510$export$1d3fe8f04fd169f5);
$parcel$export(module.exports, "Negotiations", () => $0c717f5331597510$export$cd856ac041b0089e);
$parcel$export(module.exports, "TradeOffers", () => $0c717f5331597510$export$2d840d587e3b406);
$parcel$export(module.exports, "TalentRequests", () => $0c717f5331597510$export$3c9bab1f8255e2a4);
$parcel$export(module.exports, "MatchesHash", () => $0c717f5331597510$export$13441e8472389638);
$parcel$export(module.exports, "TagTeamsHash", () => $0c717f5331597510$export$2b941c11596a2737);
$parcel$export(module.exports, "FactionsHash", () => $0c717f5331597510$export$4a9c68c25423444b);
$parcel$export(module.exports, "ChampionshipReignMatchesHash", () => $0c717f5331597510$export$7fa248ca5bccf8ea);
$parcel$export(module.exports, "FeudParticipantsHash", () => $0c717f5331597510$export$b2aab77d191a0618);
$parcel$export(module.exports, "SegmentParticipantsHash", () => $0c717f5331597510$export$84604f068c132b1b);
$parcel$export(module.exports, "FeudMatchesHash", () => $0c717f5331597510$export$21567cecdf174487);
$parcel$export(module.exports, "FeudSegmentsHash", () => $0c717f5331597510$export$669951f657429ce7);
$parcel$export(module.exports, "loadDb", () => $0c717f5331597510$export$e430f45c202c5b47);
$parcel$export(module.exports, "deleteDb", () => $0c717f5331597510$export$bebcb4d37769aec3);

var $3E8Nt = parcelRequire("3E8Nt");
let $0c717f5331597510$var$idbAdapter;
try {
    $0c717f5331597510$var$idbAdapter = new LokiIndexedAdapter();
} catch (err) {
    notie.alert({
        type: 3,
        text: "Your browser is not supported. Please try playing on another browser like Chrome.",
        stay: true
    });
    throw err;
}
let $0c717f5331597510$export$f932f06c7eb6abeb;
let $0c717f5331597510$export$4164f670d029583c, $0c717f5331597510$export$ce3603a60c2b7c54, $0c717f5331597510$export$8f6549b3f582f539, $0c717f5331597510$export$6479cfcac2b87c0, $0c717f5331597510$export$93fd0e768dbd3f80, $0c717f5331597510$export$231b12729d1c37ce, $0c717f5331597510$export$ada873a34909da65, $0c717f5331597510$export$9be83b813194f4b8, $0c717f5331597510$export$2e72096e1cea7866, $0c717f5331597510$export$add1c0636ac93680, $0c717f5331597510$export$3d8bd892ba1ae6f9, $0c717f5331597510$export$8cf0a2ece96e33e9, $0c717f5331597510$export$c454e4c3445e22b1, $0c717f5331597510$export$fc945748e9838371, $0c717f5331597510$export$caf50ac2a13b4508, $0c717f5331597510$export$76739aee1cb6bd37, $0c717f5331597510$export$ac348fcc205420ed, $0c717f5331597510$export$715d548ffbdb4245, $0c717f5331597510$export$8714badcfa4caafb, $0c717f5331597510$export$ddbf7887bc0aa836, $0c717f5331597510$export$f327e01d1ded4084, $0c717f5331597510$export$a694b2871fa6c464, $0c717f5331597510$export$da48ce74a0b0952b, $0c717f5331597510$export$d539445bbfebe79d, $0c717f5331597510$export$4606ee8058194b06, $0c717f5331597510$export$e53c7703801823f1, $0c717f5331597510$export$cfdc085ffca97c47, $0c717f5331597510$export$5c62f70d0baa8eda, $0c717f5331597510$export$fec63823e61a2566, $0c717f5331597510$export$a3168656a78efa21, $0c717f5331597510$export$ceaacf8b390a3600, $0c717f5331597510$export$47e9b71178c96712, $0c717f5331597510$export$57a67e779dfa1a4d, $0c717f5331597510$export$442a48e23d8e9d11, $0c717f5331597510$export$36edd0a1564c0ffc, $0c717f5331597510$export$1d3fe8f04fd169f5, $0c717f5331597510$export$cd856ac041b0089e, $0c717f5331597510$export$2d840d587e3b406, $0c717f5331597510$export$3c9bab1f8255e2a4, $0c717f5331597510$export$13441e8472389638, $0c717f5331597510$export$2b941c11596a2737, $0c717f5331597510$export$4a9c68c25423444b, $0c717f5331597510$export$7fa248ca5bccf8ea, $0c717f5331597510$export$b2aab77d191a0618, $0c717f5331597510$export$84604f068c132b1b, $0c717f5331597510$export$21567cecdf174487, $0c717f5331597510$export$669951f657429ce7;
async function $0c717f5331597510$var$databaseInitialize() {
    // Get collections
    $0c717f5331597510$export$4164f670d029583c = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Superstars");
    $0c717f5331597510$export$ce3603a60c2b7c54 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("TagTeams");
    $0c717f5331597510$export$8f6549b3f582f539 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Championships");
    $0c717f5331597510$export$6479cfcac2b87c0 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Matches");
    $0c717f5331597510$export$93fd0e768dbd3f80 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Games");
    $0c717f5331597510$export$231b12729d1c37ce = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Companies");
    $0c717f5331597510$export$ada873a34909da65 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Events");
    $0c717f5331597510$export$9be83b813194f4b8 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Rosters");
    $0c717f5331597510$export$2e72096e1cea7866 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Scenarios");
    $0c717f5331597510$export$add1c0636ac93680 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("ChampionshipReigns");
    $0c717f5331597510$export$3d8bd892ba1ae6f9 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Streaks");
    $0c717f5331597510$export$8cf0a2ece96e33e9 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Brands");
    $0c717f5331597510$export$c454e4c3445e22b1 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Factions");
    $0c717f5331597510$export$fc945748e9838371 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("CompanyLogs");
    $0c717f5331597510$export$caf50ac2a13b4508 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("GimmickMatches");
    $0c717f5331597510$export$76739aee1cb6bd37 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("CompanyAlerts");
    $0c717f5331597510$export$ac348fcc205420ed = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("NewsItems");
    $0c717f5331597510$export$715d548ffbdb4245 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Objectives");
    $0c717f5331597510$export$8714badcfa4caafb = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Properties");
    $0c717f5331597510$export$ddbf7887bc0aa836 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Relationships");
    $0c717f5331597510$export$f327e01d1ded4084 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Powerups");
    $0c717f5331597510$export$a694b2871fa6c464 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("MatchContracts");
    $0c717f5331597510$export$da48ce74a0b0952b = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("StoryChoices");
    $0c717f5331597510$export$d539445bbfebe79d = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Tournaments");
    $0c717f5331597510$export$4606ee8058194b06 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Feuds");
    $0c717f5331597510$export$e53c7703801823f1 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("FeudItems");
    $0c717f5331597510$export$cfdc085ffca97c47 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Segments");
    $0c717f5331597510$export$5c62f70d0baa8eda = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("SegmentItems");
    $0c717f5331597510$export$fec63823e61a2566 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Gimmicks");
    $0c717f5331597510$export$a3168656a78efa21 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Characters");
    $0c717f5331597510$export$ceaacf8b390a3600 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Messages");
    $0c717f5331597510$export$47e9b71178c96712 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("RandomEvents");
    $0c717f5331597510$export$57a67e779dfa1a4d = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("StaffMembers");
    $0c717f5331597510$export$442a48e23d8e9d11 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Facilities");
    $0c717f5331597510$export$36edd0a1564c0ffc = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("YearlyRankings");
    $0c717f5331597510$export$1d3fe8f04fd169f5 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Drafts");
    $0c717f5331597510$export$cd856ac041b0089e = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("Negotiations");
    $0c717f5331597510$export$2d840d587e3b406 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("TradeOffers");
    $0c717f5331597510$export$3c9bab1f8255e2a4 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("TalentRequests");
    $0c717f5331597510$export$13441e8472389638 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("MatchesHash");
    $0c717f5331597510$export$2b941c11596a2737 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("TagTeamsHash");
    $0c717f5331597510$export$4a9c68c25423444b = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("FactionsHash");
    $0c717f5331597510$export$7fa248ca5bccf8ea = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("ChampionshipReignMatchesHash");
    $0c717f5331597510$export$b2aab77d191a0618 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("FeudParticipantsHash");
    $0c717f5331597510$export$84604f068c132b1b = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("SegmentParticipantsHash");
    $0c717f5331597510$export$21567cecdf174487 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("FeudMatchesHash");
    $0c717f5331597510$export$669951f657429ce7 = $0c717f5331597510$export$f932f06c7eb6abeb.getCollection("FeudSegmentsHash");
    if ($0c717f5331597510$export$4164f670d029583c === null) {
        // Initialize collections upon first load
        $0c717f5331597510$export$4164f670d029583c = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Superstars");
        $0c717f5331597510$export$ce3603a60c2b7c54 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("TagTeams");
        $0c717f5331597510$export$8f6549b3f582f539 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Championships");
        $0c717f5331597510$export$6479cfcac2b87c0 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Matches");
        $0c717f5331597510$export$93fd0e768dbd3f80 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Games");
        $0c717f5331597510$export$231b12729d1c37ce = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Companies");
        $0c717f5331597510$export$ada873a34909da65 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Events");
        $0c717f5331597510$export$9be83b813194f4b8 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Rosters");
        $0c717f5331597510$export$2e72096e1cea7866 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Scenarios");
        $0c717f5331597510$export$add1c0636ac93680 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("ChampionshipReigns");
        $0c717f5331597510$export$3d8bd892ba1ae6f9 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Streaks");
        $0c717f5331597510$export$8cf0a2ece96e33e9 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Brands");
        $0c717f5331597510$export$c454e4c3445e22b1 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Factions");
        $0c717f5331597510$export$fc945748e9838371 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("CompanyLogs");
        $0c717f5331597510$export$caf50ac2a13b4508 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("GimmickMatches");
        $0c717f5331597510$export$76739aee1cb6bd37 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("CompanyAlerts");
        $0c717f5331597510$export$ac348fcc205420ed = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("NewsItems");
        $0c717f5331597510$export$715d548ffbdb4245 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Objectives");
        $0c717f5331597510$export$8714badcfa4caafb = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Properties");
        $0c717f5331597510$export$ddbf7887bc0aa836 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Relationships");
        $0c717f5331597510$export$f327e01d1ded4084 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Powerups");
        $0c717f5331597510$export$a694b2871fa6c464 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("MatchContracts");
        $0c717f5331597510$export$da48ce74a0b0952b = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("StoryChoices");
        $0c717f5331597510$export$d539445bbfebe79d = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Tournaments");
        $0c717f5331597510$export$4606ee8058194b06 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Feuds");
        $0c717f5331597510$export$e53c7703801823f1 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("FeudItems");
        $0c717f5331597510$export$cfdc085ffca97c47 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Segments");
        $0c717f5331597510$export$5c62f70d0baa8eda = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("SegmentItems");
        $0c717f5331597510$export$fec63823e61a2566 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Gimmicks");
        $0c717f5331597510$export$a3168656a78efa21 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Characters");
        $0c717f5331597510$export$ceaacf8b390a3600 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Messages");
        $0c717f5331597510$export$47e9b71178c96712 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("RandomEvents");
        $0c717f5331597510$export$57a67e779dfa1a4d = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("StaffMembers");
        $0c717f5331597510$export$442a48e23d8e9d11 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Facilities");
        $0c717f5331597510$export$36edd0a1564c0ffc = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("YearlyRankings");
        $0c717f5331597510$export$1d3fe8f04fd169f5 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Drafts");
        $0c717f5331597510$export$cd856ac041b0089e = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("Negotiations");
        $0c717f5331597510$export$2d840d587e3b406 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("TradeOffers");
        $0c717f5331597510$export$3c9bab1f8255e2a4 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("TalentRequests");
        $0c717f5331597510$export$13441e8472389638 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("MatchesHash");
        $0c717f5331597510$export$2b941c11596a2737 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("TagTeamsHash");
        $0c717f5331597510$export$4a9c68c25423444b = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("FactionsHash");
        $0c717f5331597510$export$7fa248ca5bccf8ea = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("ChampionshipReignMatchesHash");
        $0c717f5331597510$export$b2aab77d191a0618 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("FeudParticipantsHash");
        $0c717f5331597510$export$84604f068c132b1b = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("SegmentParticipantsHash");
        $0c717f5331597510$export$21567cecdf174487 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("FeudMatchesHash");
        $0c717f5331597510$export$669951f657429ce7 = $0c717f5331597510$export$f932f06c7eb6abeb.addCollection("FeudSegmentsHash");
        // Set max id to prevent potential collisions
        $0c717f5331597510$export$ce3603a60c2b7c54.maxId = 20000;
        $0c717f5331597510$export$c454e4c3445e22b1.maxId = 10000;
        $0c717f5331597510$export$cfdc085ffca97c47.maxId = 100000;
        // Load initial data
        $0c717f5331597510$export$f932f06c7eb6abeb.saveDatabase();
    }
}
async function $0c717f5331597510$export$e430f45c202c5b47(uuid, jsonData) {
    return new Promise((resolve, reject)=>{
        $0c717f5331597510$export$f932f06c7eb6abeb = new loki(uuid, {
            adapter: $0c717f5331597510$var$idbAdapter,
            autoload: true,
            autoloadCallback: async (err)=>{
                if (err) {
                    (0, $3E8Nt.captureError)(new Error(err));
                    notie.alert({
                        type: 3,
                        text: "There was an error loading the database. Please try again."
                    });
                } else {
                    if (jsonData) $0c717f5331597510$export$f932f06c7eb6abeb.loadJSONObject(jsonData);
                    await $0c717f5331597510$var$databaseInitialize();
                    resolve();
                }
            }
        });
    });
}
async function $0c717f5331597510$export$bebcb4d37769aec3(uuid) {
    return new Promise((resolve, reject)=>{
        $0c717f5331597510$var$idbAdapter.deleteDatabase(uuid, function() {
            resolve();
        });
    });
}

});

parcelRequire.register("1JSre", function(module, exports) {

$parcel$export(module.exports, "monthNames", () => $144438bbddcf8edc$export$2e59fa295abca125);
$parcel$export(module.exports, "requestTimeout", () => $144438bbddcf8edc$export$363ac302bdbd807b);
$parcel$export(module.exports, "getPointsHtml", () => $144438bbddcf8edc$export$fd3677a2a6f21aec);
$parcel$export(module.exports, "getFansHtml", () => $144438bbddcf8edc$export$7072b4f810cae78c);
$parcel$export(module.exports, "hideContent", () => $144438bbddcf8edc$export$3aabce9d398d502c);
$parcel$export(module.exports, "hideEventCardContent", () => $144438bbddcf8edc$export$a3dad32d09f5385b);
$parcel$export(module.exports, "hideMainMenuContent", () => $144438bbddcf8edc$export$8308b5cbf01dae73);
$parcel$export(module.exports, "getChampionshipsDisplayName", () => $144438bbddcf8edc$export$1e0be9916d0203e3);
$parcel$export(module.exports, "getChampionshipDisplayName", () => $144438bbddcf8edc$export$e351c25825636243);
$parcel$export(module.exports, "formatCompanyName", () => $144438bbddcf8edc$export$2373245550291f88);
$parcel$export(module.exports, "formatCompanyNameBackend", () => $144438bbddcf8edc$export$39ed436df0d7971);
$parcel$export(module.exports, "escapeHTML", () => $144438bbddcf8edc$export$5dd27816c66fb702);
$parcel$export(module.exports, "getOvernessLevelText", () => $144438bbddcf8edc$export$21f6a370f16b044);
$parcel$export(module.exports, "getRosterMemberMoraleClass", () => $144438bbddcf8edc$export$673b41bbf783469);
$parcel$export(module.exports, "getRosterMemberMoraleText", () => $144438bbddcf8edc$export$efd09287a1a677d8);
$parcel$export(module.exports, "getRosterMemberFatigueClass", () => $144438bbddcf8edc$export$106604c60363906e);
$parcel$export(module.exports, "getRosterMemberAlignmentHtml", () => $144438bbddcf8edc$export$baa570efd60a0988);
$parcel$export(module.exports, "getSuperstarTraitHelpHtml", () => $144438bbddcf8edc$export$a179651e6b25a948);
$parcel$export(module.exports, "getTraitHelpHtml", () => $144438bbddcf8edc$export$985eafb37c77d1db);
$parcel$export(module.exports, "parseObjectiveName", () => $144438bbddcf8edc$export$474bc5af55289366);
$parcel$export(module.exports, "getTalentRequestTypesHelpHtml", () => $144438bbddcf8edc$export$6ef52a1e71cba6ef);
$parcel$export(module.exports, "getChampionshipPrestigeIconHtml", () => $144438bbddcf8edc$export$fb6527dc70312185);
$parcel$export(module.exports, "getStarRatingHtml", () => $144438bbddcf8edc$export$b290d5770483e828);
$parcel$export(module.exports, "setRating", () => $144438bbddcf8edc$export$cb1b49f9f209a26c);
$parcel$export(module.exports, "getSuperstarInjuredText", () => $144438bbddcf8edc$export$b999a32b168634e9);
$parcel$export(module.exports, "getViewershipText", () => $144438bbddcf8edc$export$f5fa5c6a97c980b);
$parcel$export(module.exports, "getShortenedName", () => $144438bbddcf8edc$export$48128d2f4b52ebb1);
$parcel$export(module.exports, "getTimesWord", () => $144438bbddcf8edc$export$b9bb71960292cc22);
$parcel$export(module.exports, "applySentenceCase", () => $144438bbddcf8edc$export$e133a96dfc27a9d5);
$parcel$export(module.exports, "replaceAll", () => $144438bbddcf8edc$export$b8b3234b4edfc4c2);
$parcel$export(module.exports, "runFuseElementsSearch", () => $144438bbddcf8edc$export$68bc210a2e532e13);
$parcel$export(module.exports, "runAnnualTournamentSelectionsSearch", () => $144438bbddcf8edc$export$af4793caabee51a0);
$parcel$export(module.exports, "getChampionshipGimmickRestrictionText", () => $144438bbddcf8edc$export$9b171c46f59ade73);
$parcel$export(module.exports, "getChampionshipPrestigeProgressHtml", () => $144438bbddcf8edc$export$814573067fb73986);
$parcel$export(module.exports, "getCompanyHeaderHtml", () => $144438bbddcf8edc$export$a25d08a4cee46644);
$parcel$export(module.exports, "getGimmickDescription", () => $144438bbddcf8edc$export$9a01c30b2d879f48);
$parcel$export(module.exports, "getGimmickEffectivenessHtml", () => $144438bbddcf8edc$export$a97d43ee03f207b1);
$parcel$export(module.exports, "populateBrandNameSelect", () => $144438bbddcf8edc$export$ed9b599a28c9a613);
$parcel$export(module.exports, "makeGameRequest", () => $144438bbddcf8edc$export$9a2ff7ee993820c0);
$parcel$export(module.exports, "makeGetRequest", () => $144438bbddcf8edc$export$1e5baaf76e4b1f02);
$parcel$export(module.exports, "predicateBy", () => $144438bbddcf8edc$export$cde5dc4d070dd566);
$parcel$export(module.exports, "objectEquals", () => $144438bbddcf8edc$export$5b4d20f570fee173);
$parcel$export(module.exports, "getFeudPotentialHtml", () => $144438bbddcf8edc$export$ba2c6799323202b0);
$parcel$export(module.exports, "getChampionshipGimmickRestrictionInfoHtml", () => $144438bbddcf8edc$export$9d146348df2d4e4d);
$parcel$export(module.exports, "getGimmickMatchUnlockedBy", () => $144438bbddcf8edc$export$74d7710fb6ab5f76);
$parcel$export(module.exports, "updateGamePointsAndFans", () => $144438bbddcf8edc$export$f1a14159ee779b14);
$parcel$export(module.exports, "getGimmickDebutHtml", () => $144438bbddcf8edc$export$b2a3e0591db83e24);
$parcel$export(module.exports, "addTournamentParticipantsEditing", () => $144438bbddcf8edc$export$f60b820a6ef9f0ce);
$parcel$export(module.exports, "getTournamentGroupsHtml", () => $144438bbddcf8edc$export$847ffaf7242e3b89);
$parcel$export(module.exports, "getTournamentGroupName", () => $144438bbddcf8edc$export$e6f22ba519626a5f);
$parcel$export(module.exports, "getFeudStartedHtml", () => $144438bbddcf8edc$export$9a47ff33c303b854);
$parcel$export(module.exports, "getFeudHypeIncreasedHtml", () => $144438bbddcf8edc$export$b7155a51d771774a);
$parcel$export(module.exports, "getGimmickEffectivenessLevelChangeHtml", () => $144438bbddcf8edc$export$2ef1e0f43736ad8c);
$parcel$export(module.exports, "showFactionReputationData", () => $144438bbddcf8edc$export$a8c39434b93b192a);
$parcel$export(module.exports, "getChampionshipPrestigeHtml", () => $144438bbddcf8edc$export$5b4a3607c73a597e);
$parcel$export(module.exports, "getRosterInfo", () => $144438bbddcf8edc$export$e247db8ce197412e);
$parcel$export(module.exports, "getItemListDiv", () => $144438bbddcf8edc$export$d596834de4c64195);
$parcel$export(module.exports, "getItemColumnDiv", () => $144438bbddcf8edc$export$410bf8553390566);
$parcel$export(module.exports, "getChampionshipsInfo", () => $144438bbddcf8edc$export$18c137ba5cda31a4);
$parcel$export(module.exports, "getCompanyInfo", () => $144438bbddcf8edc$export$d58714ba93985757);
$parcel$export(module.exports, "getBrandsInfo", () => $144438bbddcf8edc$export$ccbacf175f05e660);
$parcel$export(module.exports, "toCamel", () => $144438bbddcf8edc$export$bc7802f0bef8d7aa);
$parcel$export(module.exports, "showFormattedDisplayName", () => $144438bbddcf8edc$export$15525a6f80bfb79d);
$parcel$export(module.exports, "previewSegmentSinglesParticipants", () => $144438bbddcf8edc$export$98a643f2bb8d4ab);
$parcel$export(module.exports, "previewSegmentTagParticipants", () => $144438bbddcf8edc$export$14c654bb39fc3e37);

var $3E8Nt = parcelRequire("3E8Nt");

var $98xmD = parcelRequire("98xmD");

var $lCS03 = parcelRequire("lCS03");

var $aP7lq = parcelRequire("aP7lq");

var $14eBR = parcelRequire("14eBR");
const $144438bbddcf8edc$export$2e59fa295abca125 = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $144438bbddcf8edc$export$363ac302bdbd807b = 30000;
function $144438bbddcf8edc$export$fd3677a2a6f21aec(points, unlimitedCreativePoints) {
    if (unlimitedCreativePoints) return "Max";
    else {
        if (points >= 1000000) {
            let pointsText = (Math.round((points / 1000000 + Number.EPSILON) * 10) / 10).toLocaleString("en") + "M";
            return '<span class="help-text" title="' + points.toLocaleString("en") + '">' + pointsText + "</span>";
        } else if (points >= 10000) {
            let pointsText = (Math.round((points / 1000 + Number.EPSILON) * 10) / 10).toLocaleString("en") + "K";
            return '<span class="help-text" title="' + points.toLocaleString("en") + '">' + pointsText + "</span>";
        }
        return points.toLocaleString("en");
    }
}
function $144438bbddcf8edc$export$7072b4f810cae78c(fans) {
    if (fans >= 1000000) {
        let fansText = (Math.round((fans / 1000000 + Number.EPSILON) * 100) / 100).toLocaleString("en") + "M";
        return '<span class="help-text" title="' + fans.toLocaleString("en") + '">' + fansText + "</span>";
    } else if (fans >= 10000) {
        let fansText = (Math.round((fans / 1000 + Number.EPSILON) * 10) / 10).toLocaleString("en") + "K";
        return '<span class="help-text" title="' + fans.toLocaleString("en") + '">' + fansText + "</span>";
    }
    return fans.toLocaleString("en");
}
function $144438bbddcf8edc$export$3aabce9d398d502c(element) {
    $(".game-content-left-column").children("div").each(function() {
        if ($(this)[0] !== element[0]) $(this).hide();
        element.show();
    });
    $144438bbddcf8edc$export$a3dad32d09f5385b($("#event-card"));
}
function $144438bbddcf8edc$export$a3dad32d09f5385b(element) {
    $(".game-content-right-column").children("div").each(function() {
        if ($(this)[0] !== element[0]) $(this).hide();
        element.show();
    });
}
function $144438bbddcf8edc$export$8308b5cbf01dae73(element) {
    $(".main-page-container").children("div").each(function() {
        if ($(this)[0] !== element[0]) $(this).hide();
        element.show();
    });
}
function $144438bbddcf8edc$export$1e0be9916d0203e3(championships, holder, excludeSuffix, addPlural) {
    let formattedNames = Array.from(championships, function(c) {
        if (championships.length > 1 && championships.indexOf(c) !== championships.length - 1) // Get the name of n - 1 championships without the suffix if there are multiple championships
        return c.name;
        return $144438bbddcf8edc$export$e351c25825636243(c, holder, excludeSuffix, addPlural);
    });
    return (0, $3E8Nt.commaSeparate)(formattedNames, "&");
}
function $144438bbddcf8edc$export$e351c25825636243(championship, holder = false, excludeSuffix = false, addPlural = true) {
    let suffix = "";
    if (!excludeSuffix) {
        suffix = holder ? " Champion" : " Championship";
        if (championship["matchContract"] || championship["championshipContract"]) suffix = holder ? " Holder" : " Contract";
        if ((championship["tagTeam"] || championship["trio"]) && addPlural) suffix += "s";
        if (championship["event"]) suffix += " (" + championship["event"] + ")";
    }
    return championship["name"] + suffix;
}
function $144438bbddcf8edc$export$2373245550291f88(name) {
    let splitNames = name.split(" ");
    if (splitNames.length > 1) {
        let initials = Array.from(splitNames, function(x) {
            return x[0];
        });
        return initials.join("").toUpperCase();
    } else return name.slice(0, 16) + ".";
}
function $144438bbddcf8edc$export$39ed436df0d7971(name) {
    let splitNames = name.split(" ");
    if (splitNames.length > 2) {
        let initials = Array.from(splitNames, function(x) {
            return x[0];
        });
        return initials.join("");
    } else return name;
}
function $144438bbddcf8edc$export$5dd27816c66fb702(str) {
    let p = document.createElement("p");
    p.appendChild(document.createTextNode(str));
    return p.innerHTML;
}
function $144438bbddcf8edc$export$21f6a370f16b044(overness) {
    let text;
    if (overness >= 80) text = "Over";
    else if (overness >= 60) text = "Popular";
    else if (overness >= 40) text = "Average";
    else if (overness >= 20) text = "Not Popular";
    else if (overness >= 0) text = "Stale";
    return text;
}
function $144438bbddcf8edc$export$673b41bbf783469(morale) {
    let moraleClass = "";
    if (morale < 20) moraleClass = "puke-green";
    else if (morale < 40) moraleClass = "morale-dissatisfied-color";
    else if (morale < 60) moraleClass = "yellow-green";
    else moraleClass = "light-green";
    return moraleClass;
}
function $144438bbddcf8edc$export$efd09287a1a677d8(morale) {
    let moraleText = "";
    if (morale >= 60) moraleText = "Happy";
    else if (morale >= 40) moraleText = "Content";
    else if (morale >= 20) moraleText = "Dissatisfied";
    else moraleText = "Unhappy";
    return moraleText;
}
function $144438bbddcf8edc$export$106604c60363906e(fatigue) {
    let fatigueClass = "";
    if (fatigue >= 70) fatigueClass = "dark-red";
    else if (fatigue >= 40) fatigueClass = "dark-yellow";
    return fatigueClass;
}
function $144438bbddcf8edc$export$baa570efd60a0988(data) {
    let alignment = data["alignment"];
    let alignmentClass;
    switch(data["alignment"]){
        case "heel":
            alignmentClass = "alignment-heel";
            break;
        case "face":
            alignmentClass = "alignment-face";
            break;
        default:
            alignmentClass = "alignment-neutral";
            alignment = "Neutral";
    }
    let alignmentMonthsHtml = "";
    if (data["alignmentMonths"] !== undefined) {
        let monthsText = "months";
        if (data["alignmentMonths"] === 1) monthsText = "month";
        let alignmentMonths = Math.round(data["alignmentMonths"] * 10) / 10;
        alignmentMonthsHtml = '<div class="light-grey">' + alignmentMonths + " " + monthsText + "</div>";
    }
    return '<span class="' + alignmentClass + '">' + (0, $3E8Nt.toTitleCase)(alignment) + "</span>" + alignmentMonthsHtml;
}
function $144438bbddcf8edc$export$a179651e6b25a948(trait) {
    let html;
    let helpText = $144438bbddcf8edc$var$getSuperstarTraitHelpText(trait);
    html = '<span class="help-text" title="' + helpText + '">' + trait + "</span>";
    return html;
}
function $144438bbddcf8edc$var$getSuperstarTraitHelpText(trait) {
    function getTraitChangeHtml(change) {
        return change >= 0 ? "+" + change : "-" + change * -1;
    }
    function getTraitChangeWord(change) {
        return change >= 1.0 ? "Multiplies" : "Reduces";
    }
    if (!(0, $aP7lq.traitsData)) return "";
    let helpTexts = [];
    let traitData = (0, $aP7lq.traitsData)[trait];
    if (traitData) {
        if (traitData["gimmick_match_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["gimmick_match_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} gimmick match rating boost {1} {2}x".format(changeWord, changeVerb, traitData["gimmick_match_multiplier"]));
        }
        if (traitData["holy_shit_moment_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["holy_shit_moment_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} holy shit moment chance in gimmick matches {1} {2}x".format(changeWord, changeVerb, traitData["holy_shit_moment_chance_multiplier"]));
        }
        if (traitData["holy_shit_moment_pure_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["holy_shit_moment_pure_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} holy shit moment chance in non-gimmick matches in 'pure' companies {1} {2}x".format(changeWord, changeVerb, traitData["holy_shit_moment_pure_chance_multiplier"]));
        }
        if (traitData["injury_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["injury_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} chance to get injured {1} {2}x".format(changeWord, changeVerb, traitData["injury_chance_multiplier"]));
        }
        if (traitData["cause_injury_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["cause_injury_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} chance to injure an opponent {1} {2}x".format(changeWord, changeVerb, traitData["cause_injury_chance_multiplier"]));
        }
        if (traitData["add_blood_to_opponent_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["add_blood_to_opponent_chance_boost"]);
            helpTexts.push("Changes chance to make opponent bleed by {0}%".format(change));
        }
        if (traitData["positive_match_rating_boost_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["positive_match_rating_boost_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} positive match rating effect chance {1} {2}x".format(changeWord, changeVerb, traitData["positive_match_rating_boost_multiplier"]));
        }
        if (traitData["negative_match_rating_boost_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["negative_match_rating_boost_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} negative match rating effect chance {1} {2}x".format(changeWord, changeVerb, traitData["negative_match_rating_boost_multiplier"]));
        }
        if (traitData["monthly_event_match_rating_boost"]) {
            let change = getTraitChangeHtml(traitData["monthly_event_match_rating_boost"]);
            helpTexts.push("Changes match ratings by {0} on monthly events".format(change));
        }
        if (traitData["weekly_show_match_rating_boost"]) {
            let change = getTraitChangeHtml(traitData["weekly_show_match_rating_boost"]);
            helpTexts.push("Changes match ratings by {0} on weekly shows".format(change));
        }
        if (traitData["hot_match_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["hot_match_chance_boost"]);
            helpTexts.push("Changes hot match chance by {0}%".format(change));
        }
        if (traitData["no_morale_change_except_rank"]) helpTexts.push("Mostly happy to lose to anyone except {0}s".format(traitData["no_morale_change_except_rank"]));
        if (traitData["no_morale_change_rank"]) helpTexts.push("Mostly happy to lose to {0}s".format(traitData["no_morale_change_rank"]));
        if (traitData["loss_affects_morale_chance"]) helpTexts.push("{0}% chance for losses to lower morale".format(traitData["loss_affects_morale_chance"]));
        if (traitData["win_affects_morale_chance"]) helpTexts.push("{0}% chance for wins to raise morale".format(traitData["win_affects_morale_chance"]));
        if (traitData["leaving_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["leaving_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} chance to leave if unhappy {1} {2}x".format(changeWord, changeVerb, traitData["leaving_chance_multiplier"]));
        }
        if (traitData["training_xp_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["training_xp_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} training XP gain {1} {2}x".format(changeWord, changeVerb, traitData["training_xp_multiplier"]));
        }
        if (traitData["skill_xp_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["skill_xp_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} skill XP gain in matches and segments {1} {2}x".format(changeWord, changeVerb, traitData["skill_xp_multiplier"]));
        }
        if (traitData["retirement_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["retirement_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} retirement chance {1} {2}x".format(changeWord, changeVerb, traitData["retirement_chance_multiplier"]));
        }
        if (traitData["retirement_age_change"]) {
            let change = getTraitChangeHtml(traitData["retirement_age_change"]);
            helpTexts.push("Changes retirement age by {0}".format(change));
        }
        if (traitData["turn_part_timer_age_change"]) {
            let change = getTraitChangeHtml(traitData["turn_part_timer_age_change"]);
            helpTexts.push("Changes age of turning part-timer by {0}".format(change));
        }
        if (traitData["overness_increase_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["overness_increase_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} overness increases {1} {2}x".format(changeWord, changeVerb, traitData["overness_increase_multiplier"]));
        }
        if (traitData["overness_decrease_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["overness_decrease_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} overness decreases {1} {2}x".format(changeWord, changeVerb, traitData["overness_decrease_multiplier"]));
        }
        if (traitData["silly_segment_rating_boost"]) {
            let change = getTraitChangeHtml(traitData["silly_segment_rating_boost"]);
            helpTexts.push("Changes silly segment ratings by {0}".format(change));
        }
        if (traitData["hot_segment_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["hot_segment_chance_boost"]);
            helpTexts.push("Changes hot segment chance by {0}%".format(change));
        }
        if (traitData["face_alignment_hype_boost"]) {
            let change = getTraitChangeHtml(traitData["face_alignment_hype_boost"]);
            helpTexts.push("Changes face alignment hype boost for matches and feuds by {0}".format(change));
        }
        if (traitData["heel_alignment_hype_boost"]) {
            let change = getTraitChangeHtml(traitData["heel_alignment_hype_boost"]);
            helpTexts.push("Changes heel alignment hype boost for matches and feuds by {0}".format(change));
        }
        if (traitData["face_alignment_penalty"]) {
            let change = getTraitChangeHtml(traitData["face_alignment_penalty"]);
            helpTexts.push("Adds hype penalty of {0} when aligned as a face".format(change));
        }
        if (traitData["heel_alignment_penalty"]) {
            let change = getTraitChangeHtml(traitData["heel_alignment_penalty"]);
            helpTexts.push("Adds hype penalty of {0} when aligned as a heel".format(change));
        }
        if (traitData["fantasy_gimmick_character_boost"]) {
            let change = getTraitChangeHtml(traitData["fantasy_gimmick_character_boost"]);
            helpTexts.push("Changes gimmick effectiveness for fantasy characters by {0}%".format(change));
        }
        if (traitData["non_fantasy_gimmick_character_boost"]) {
            let change = getTraitChangeHtml(traitData["non_fantasy_gimmick_character_boost"]);
            helpTexts.push("Changes gimmick effectiveness for non-fantasy characters by {0}%".format(change));
        }
        if (traitData["bad_combination_gimmick_boost"]) {
            let change = getTraitChangeHtml(traitData["bad_combination_gimmick_boost"]);
            helpTexts.push("Changes gimmick effectiveness for bad combination gimmicks by {0}%".format(change));
        }
        if (traitData["gimmick_boost"]) {
            let change = getTraitChangeHtml(traitData["gimmick_boost"]);
            helpTexts.push("Changes gimmick effectiveness for all gimmicks by {0}%".format(change));
        }
        if (traitData["gimmick_interview_superstar_chance"]) helpTexts.push("Adds {0}% chance to be in the Gimmick Interview random event".format(traitData["gimmick_interview_superstar_chance"]));
        if (traitData["hot_feud_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["hot_feud_chance_boost"]);
            helpTexts.push("Changes hot feud chance by {0}%".format(change));
        }
        if (traitData["feud_staleness_limit_boost"]) {
            let change = getTraitChangeHtml(traitData["feud_staleness_limit_boost"]);
            helpTexts.push("Changes feud staleness limit by {0}".format(change));
        }
        if (traitData["feud_boosted_feud_chance"]) helpTexts.push("Adds {0}% chance to be in the Feud Boosted random event".format(traitData["feud_boosted_feud_chance"]));
        if (traitData["feud_ignored_feud_chance"]) helpTexts.push("Adds {0}% chance to be in the Feud Ignored random event".format(traitData["feud_ignored_feud_chance"]));
        if (traitData["feud_hype_change_boost"]) {
            let change = getTraitChangeHtml(traitData["feud_hype_change_boost"]);
            helpTexts.push("Adds {0} to feud hype change in matches and segments".format(change));
        }
        if (traitData["gimmick_effectiveness_increase_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["gimmick_effectiveness_increase_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} gimmick effectiveness change {1} {2}x".format(changeWord, changeVerb, traitData["gimmick_effectiveness_increase_multiplier"]));
        }
        if (traitData["morale_boost_helper_chance"]) helpTexts.push("Adds {0}% chance to be in the Morale Boost random event".format(traitData["morale_boost_helper_chance"]));
        if (traitData["wrestler_court_judge_chance"]) helpTexts.push("Adds {0}% chance to be a judge in the Wrestlers Court random event".format(traitData["wrestler_court_judge_chance"]));
        if (traitData["wrestler_court_defendant_chance"]) helpTexts.push("Adds {0}% chance to be a defendant in the Wrestlers Court random event".format(traitData["wrestler_court_defendant_chance"]));
        if (traitData["backstage_fight_starter_chance"]) helpTexts.push("Adds {0}% chance to be in the Backstage Fight random event".format(traitData["backstage_fight_starter_chance"]));
        if (traitData["drug_abuse_superstar_chance"]) helpTexts.push("Adds {0}% chance to be in the Drug Abuse random event".format(traitData["drug_abuse_superstar_chance"]));
        if (traitData["tag_match_workrate_boost"]) {
            let change = getTraitChangeHtml(traitData["tag_match_workrate_boost"]);
            helpTexts.push("Changes workrate by {0} in tag matches".format(change));
        }
        if (traitData["lose_trait_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["lose_trait_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} chance to lose traits with age {1} {2}x".format(changeWord, changeVerb, traitData["lose_trait_chance_multiplier"]));
        }
        if (traitData["add_blood_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["add_blood_chance_boost"]);
            helpTexts.push("Changes chance to bleed by {0}%".format(change));
        }
        if (traitData["months_to_unlearn_traits_boost"]) {
            let change = getTraitChangeHtml(traitData["months_to_unlearn_traits_boost"]);
            helpTexts.push("Changes number of months needed to unlearn traits by {0}".format(change));
        }
        if (traitData["weekly_show_match_fatigue_change"]) {
            let change = getTraitChangeHtml(traitData["weekly_show_match_fatigue_change"]);
            helpTexts.push("Changes match fatigue by {0} on weekly shows".format(change));
        }
        if (traitData["monthly_event_match_fatigue_change"]) {
            let change = getTraitChangeHtml(traitData["monthly_event_match_fatigue_change"]);
            helpTexts.push("Changes match fatigue by {0} on monthly events".format(change));
        }
        if (traitData["gimmick_match_fatigue_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["gimmick_match_fatigue_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} gimmick match fatigue change {1} {2}x".format(changeWord, changeVerb, traitData["gimmick_match_fatigue_multiplier"]));
        }
        if (traitData["remove_fatigue_age_penalty"]) helpTexts.push("Removes fatigue penalty normally added past the age of 40");
    }
    let helpText = helpTexts.join(". ");
    helpText += ".";
    return helpText;
}
function $144438bbddcf8edc$export$985eafb37c77d1db(traitName, traitData) {
    let conflictingTraitsHtml = "";
    if (traitData["conflicting_traits"].length > 0) conflictingTraitsHtml = '<div class="margin-top-7 medium-dark-grey">Conflicts with ' + (0, $3E8Nt.commaSeparate)(traitData["conflicting_traits"]) + ".</div>";
    let loseWithAgeHtml = "";
    if (traitData["disable_lose_with_age"]) loseWithAgeHtml = '<div class="medium-dark-grey margin-top-7">Cannot lose with age.</div>';
    let acquirableHtml = "";
    if (traitData["acquirable"]) {
        // Get requirements from array
        let requirementsToAcquireHtml = "";
        if (traitData["requirements_to_acquire"].length > 0) {
            let requirementsToAcquire = Array.from(traitData["requirements_to_acquire"], function(x) {
                return $144438bbddcf8edc$export$474bc5af55289366(x.replace(/_/g, " "), "faded-blue", 3);
            });
            requirementsToAcquireHtml = '<span class="margin-left-5">(requires {0})</span>'.format((0, $3E8Nt.commaSeparate)(requirementsToAcquire));
        }
        acquirableHtml = '<div class="faded-blue margin-top-7">' + "Chance to acquire via {0}{1}.".format($144438bbddcf8edc$export$474bc5af55289366(traitData["action_to_acquire"], "faded-blue"), requirementsToAcquireHtml) + "</div>";
    }
    // Add can unlearn data
    let canUnlearnHtml = "";
    if (traitData["can_unlearn"]) canUnlearnHtml = '<div class="faded-blue margin-top-7">' + "Can be unlearned by a {0}.".format((0, $3E8Nt.toTitleCase)(traitData["staff_role_to_unlearn"].replace(/_/g, " "))) + "</div>";
    let html = '<div class="margin-bottom-10"><div class="superstar-trait-color font-15px">' + traitName + "</div>" + "</div>" + '<div class="margin-bottom-7">' + traitData["description"] + "</div>" + '<div class="medium-dark-grey">' + $144438bbddcf8edc$var$getSuperstarTraitHelpText(traitName) + "</div>" + conflictingTraitsHtml + loseWithAgeHtml + acquirableHtml + canUnlearnHtml;
    return '<div class="trait-help-item-container">' + html + "</div>";
}
function $144438bbddcf8edc$export$6ef52a1e71cba6ef(data) {
    let talentRequestTypesHelpHtml = "";
    data.forEach(function(talentRequestTypeData) {
        let importantHtml = "";
        if (talentRequestTypeData["importance"] === "major") importantHtml = '<div class="faded-blue margin-top-5 help-text" title="Important requests have a higher morale change.">Important</div>';
        talentRequestTypesHelpHtml += '<div class="morale-help-item-container dark-grey"><div><div class="superstar-trait-color font-15px">' + talentRequestTypeData["name"] + "</div>" + "</div>" + '<div class="margin-top-8">' + talentRequestTypeData["description"] + "</div>" + importantHtml + "</div>";
    });
    return talentRequestTypesHelpHtml;
}
function $144438bbddcf8edc$export$fb6527dc70312185(prestige) {
    let iconClass = "bronze";
    if (prestige === "S") iconClass = "obsidian";
    else if (prestige === "A") iconClass = "gold-light";
    else if (prestige === "B") iconClass = "silver";
    else if (prestige === "C") iconClass = "bronze";
    return '<i class="fa fa-star-o font-bold ' + iconClass + '"></i>';
}
function $144438bbddcf8edc$export$b290d5770483e828(rating, colorClass, maxStars) {
    if (typeof colorClass === "undefined") colorClass = "";
    if (typeof maxStars === "undefined") maxStars = 5;
    let ratingValue = rating;
    let ratingFloor = Math.floor(ratingValue);
    let decimalRating = ratingValue - ratingFloor;
    let ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
    if (decimalRating) {
        if (decimalRating === 0.75) decimalRating = 0.70;
        else if (decimalRating === 0.25) decimalRating = 0.35;
        ratingText += '<i class="star star-under fa fa-star"><i class="star star-over ' + colorClass + ' fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' + "</i>";
        if (ratingFloor < maxStars) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(maxStars - ratingFloor - 1);
    } else if (ratingFloor < maxStars) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(maxStars - ratingFloor);
    return ratingText;
}
function $144438bbddcf8edc$export$cb1b49f9f209a26c(rating) {
    let ratingText;
    if (rating !== null) {
        let ratingFloor = Math.floor(rating);
        let decimalRating = rating - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) decimalRating = 0.70;
            else if (decimalRating === 0.25) decimalRating = 0.35;
            ratingText += '<i class="star star-under fa fa-star"><i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' + "</i>";
            if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
        } else if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
    } else // Set rating element
    ratingText = "No Rating";
    return ratingText;
}
function $144438bbddcf8edc$export$474bc5af55289366(objectiveName, colorClass, maxStars) {
    if (typeof colorClass === "undefined") colorClass = "goal-color";
    return objectiveName.replace(/\S+(?=\*)/g, function(rating) {
        return $144438bbddcf8edc$export$b290d5770483e828(rating, colorClass, maxStars);
    }).replace(/\d+\b(?!%)/g, function(match) {
        return match;
    }).replace("*", "");
}
function $144438bbddcf8edc$export$b999a32b168634e9(data) {
    let injuryNameText = "";
    if (data["injuryName"]) injuryNameText = " from a " + data["injuryName"];
    let monthsWord = data["injuryTime"] === "1" ? "month" : "months";
    let injuryWord = data["workableInjury"] ? "Recovers" : "Returns";
    return "{0} in {1} {2} {3}".format(injuryWord, data["injuryTime"], monthsWord, injuryNameText);
}
function $144438bbddcf8edc$export$f5fa5c6a97c980b(viewership) {
    let absoluteViewership = Math.abs(viewership);
    if (absoluteViewership < 1000) return viewership;
    else if (absoluteViewership < 1000000) return "{0}K".format(Math.round((viewership / 1000 + Number.EPSILON) * 10) / 10);
    else return "{0}M".format(Math.round((viewership / 1000000 + Number.EPSILON) * 100) / 100);
}
function $144438bbddcf8edc$export$48128d2f4b52ebb1(name, maxLength, reverse) {
    if (typeof maxLength === "undefined") maxLength = 18;
    let splitNames = name.split(" ");
    let nameEdited = false;
    while(name.length > maxLength && splitNames.length > 1){
        if (reverse) {
            let firstIndex = name.indexOf(" ");
            name = name.substring(firstIndex + 1);
        } else {
            let lastIndex = name.lastIndexOf(" ");
            name = name.substring(0, lastIndex);
        }
        splitNames = name.split(" ");
        nameEdited = true;
    }
    if (nameEdited) {
        if (!reverse) name += " .";
    }
    return name;
}
function $144438bbddcf8edc$export$b9bb71960292cc22(times) {
    if (times === 1) return "time";
    return "times";
}
function $144438bbddcf8edc$export$e133a96dfc27a9d5(str) {
    if (!str) return str;
    return str.replace(/.+?[\.\?\!](\s|$)/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1);
    });
}
function $144438bbddcf8edc$export$b8b3234b4edfc4c2(str, find, replace) {
    if (!str) return str;
    return str.replace(new RegExp($144438bbddcf8edc$var$escapeRegExp(find), "g"), replace);
}
function $144438bbddcf8edc$var$escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}
function $144438bbddcf8edc$export$68bc210a2e532e13(elements, searchTerm, keys) {
    let options = {
        keys: keys,
        shouldSort: true,
        distance: 70,
        threshold: 0.3
    };
    let fuse = new Fuse(elements, options);
    return fuse.search(searchTerm);
}
function $144438bbddcf8edc$export$af4793caabee51a0() {
    let parent = $(".annual-tournament-selections-container");
    let selectionsContainer = parent.find(".annual-tournament-selection-items-container");
    let selectionElements = parent.find(".annual-tournament-selection-item:not(.no-annual-tournament-selections-search-results)");
    let searchTerm = parent.find(".annual-tournament-selections-search-input").val();
    selectionElements.hide();
    // Run search
    if (searchTerm.length > 0) {
        let searchResults = $144438bbddcf8edc$export$68bc210a2e532e13(selectionElements, searchTerm, [
            "textContent"
        ]);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function(e) {
                $(e).show();
            });
            $(".no-annual-tournament-selections-search-results").hide();
        } else if ($(".no-annual-tournament-selections-search-results").length > 0) $(".no-annual-tournament-selections-search-results").show();
        else selectionsContainer.append('<div class="no-annual-tournament-selections-search-results inner-box-item annual-tournament-selection-item unavailable light-grey">No Results Found</div>');
    } else {
        selectionElements.show();
        $(".no-annual-tournament-selections-search-results").hide();
    }
    selectionsContainer.scrollTop(0);
    selectionsContainer[0].scrollIntoView();
}
function $144438bbddcf8edc$export$9b171c46f59ade73(data) {
    let text;
    if (data) {
        if (data["type"] === "gimmick_match") {
            if (data["value"]) text = data["value"] + " Matches Only";
            else text = "Gimmick Matches Only";
        } else if (data["type"] === "weekly_show") text = "Weekly Shows Only";
        else if (data["type"] === "maximum_age") text = data["value"] + " years old or younger";
        else if (data["type"] === "minimum_age") text = data["value"] + " years old or older";
    }
    return text;
}
function $144438bbddcf8edc$export$814573067fb73986(data) {
    let progress = 100;
    let xpToLevel = "";
    if (!data["maxPrestige"]) progress = data["progressPercentage"];
    else xpToLevel = "Max Prestige";
    if (progress > 100) progress = 100;
    else if (progress <= 0) progress = 1;
    let prestigeIcon = '<span class="margin-left-6">' + $144438bbddcf8edc$export$fb6527dc70312185(data["prestige"]) + "</span>";
    return '<div class="progress-under compact narrow help-text championship-prestige-progress display-inline-block" title="' + data["xp"] + " / " + data["nextPrestigeXp"] + ' XP">' + '<div class="progress compact" style="width:' + progress + '%">' + "</div>" + "</div>" + prestigeIcon + '<div class="display-block margin-left-1 margin-top-3">' + '<div class="display-inline-block font-0p925em grey">' + xpToLevel + "</div>" + "</div>";
}
function $144438bbddcf8edc$export$a25d08a4cee46644(companyName, playerName) {
    if (companyName.length > 18) companyName = $144438bbddcf8edc$export$2373245550291f88(companyName);
    let html = companyName;
    if ((0, $98xmD.globals).game.sandboxModeEnabled) html = '<span class="sandbox-mode-color help-text" title="Sandbox Mode">' + html + "</span>";
    if ((0, $98xmD.globals).game.story === "passion") html = '<span class="pow-color">' + html + "</span>";
    if ((0, $98xmD.globals).game.controlMultipleCompanies) {
        if (playerName) html += '<span class="light-grey margin-left-8">{0}</span>'.format(playerName);
        $(".change-company-button").show();
    } else $(".change-company-button").hide();
    return html;
}
function $144438bbddcf8edc$export$9a01c30b2d879f48(gimmick) {
    // Debuted
    if (gimmick["effectiveness"]) {
        let gimmickEffectiveness = "(" + gimmick["effectiveness"] + "%)";
        let gimmickBoost = '<span class="display-block">' + $144438bbddcf8edc$var$getGimmickEffectivenessBonusHtml(gimmick["effectiveness"]) + '<span class="light-grey"> Overness Effect</span>' + "</span>";
        let effectivenessText = $144438bbddcf8edc$export$a97d43ee03f207b1(gimmick["effectiveness"]);
        return gimmick["name"] + '<span class="margin-left-8">' + effectivenessText + "</span>" + '<span class="margin-left-8 light-grey">' + gimmickEffectiveness + "</span>" + gimmickBoost;
    } else {
        let combinationHtml = $144438bbddcf8edc$var$getGimmickCombinationHtml(gimmick["combinationResult"]);
        return gimmick["name"] + '<span class="margin-left-8 light-grey">Not Debuted</span>' + '<span class="margin-left-8">' + combinationHtml + "</span>";
    }
}
function $144438bbddcf8edc$export$a97d43ee03f207b1(effectiveness) {
    let text;
    if (effectiveness >= 80) text = '<span class="light-green">Mark Out!</span>';
    else if (effectiveness >= 60) text = '<span class="green">Good</span>';
    else if (effectiveness >= 40) text = '<span class="dark-yellow">Average</span>';
    else if (effectiveness >= 20) text = '<span class="dark-red">Not Good</span>';
    else if (effectiveness >= 0) text = '<span class="red">Bad</span>';
    return text;
}
function $144438bbddcf8edc$var$getGimmickEffectivenessText(effectiveness) {
    let text;
    if (effectiveness >= 80) text = "Mark Out";
    else if (effectiveness >= 60) text = "Good";
    else if (effectiveness >= 40) text = "Average";
    else if (effectiveness >= 20) text = "Not Good";
    else if (effectiveness >= 0) text = "Bad";
    return text;
}
function $144438bbddcf8edc$var$getGimmickCombinationHtml(combination) {
    let text;
    switch(combination){
        case "easy":
            text = '<span class="green">Easy</span>';
            break;
        case "hard":
            text = '<span class="red">Hard</span>';
            break;
        case "okay":
            text = '<span class="dark-yellow">Okay</span>';
            break;
    }
    return text;
}
function $144438bbddcf8edc$var$getGimmickEffectivenessBonusHtml(effectiveness) {
    let text;
    if (effectiveness >= 80) text = '<span class="green">+ 15</span>';
    else if (effectiveness >= 60) text = '<span class="green">+ 5</span>';
    else if (effectiveness >= 40) text = '<span class="dark-yellow">+ 0</span>';
    else if (effectiveness >= 20) text = '<span class="red">- 5</span>';
    else if (effectiveness >= 0) text = '<span class="red">- 15</span>';
    return text;
}
function $144438bbddcf8edc$export$ed9b599a28c9a613(brandNames, select) {
    let brandNamesOptions = '<option value="">None</option>';
    brandNames.forEach(function(brandName) {
        brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + "</option>";
    });
    select.html(brandNamesOptions);
}
async function $144438bbddcf8edc$export$9a2ff7ee993820c0(getFunction, getFunctionArgs, showFunction, showFunctionArgs = {}, hide = true, subRequest = false, setRequestRunning = true, hideAlerts = true) {
    try {
        // Don't run if request running
        if ((0, $98xmD.globals).requestRunning) return;
        // Get function
        if (!subRequest) notie.alert({
            type: 4,
            text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
            stay: true
        });
        if (setRequestRunning) (0, $98xmD.globals).requestRunning = true;
        let data = await getFunction(getFunctionArgs);
        (0, $98xmD.globals).requestRunning = false;
        if (hideAlerts) notie.hideAlerts();
        // Play sound effect
        if (!data["error"]) {
            if (!subRequest) (0, $lCS03.playSoundEffect)("success");
            // Hide ui
            if (hide) $144438bbddcf8edc$export$3aabce9d398d502c($());
        } else if (!subRequest) (0, $lCS03.playSoundEffect)("error");
        // Show function with data
        showFunctionArgs.data = data;
        await showFunction(showFunctionArgs);
    } catch (error) {
        notie.alert({
            type: 3,
            text: "An error occurred."
        });
        (0, $lCS03.playSoundEffect)("error");
        (0, $3E8Nt.captureError)(error);
        (0, $98xmD.globals).requestRunning = false;
        await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
    }
}
function $144438bbddcf8edc$export$1e5baaf76e4b1f02(url, data, callback, continueRequest = false, notieText = null, showNotie = true) {
    if (!notieText) notieText = "Loading";
    if (showNotie) {
        notie.alert({
            type: 4,
            text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>' + notieText,
            stay: true
        });
        (0, $98xmD.globals).requestRunning = true;
    }
    $.ajax({
        url: (0, $98xmD.globals).baseUrl + url,
        dataType: "json",
        data: data,
        success: async (data)=>{
            if (!continueRequest) {
                (0, $98xmD.globals).requestRunning = false;
                notie.hideAlerts();
            }
            await callback(data);
        },
        timeout: $144438bbddcf8edc$export$363ac302bdbd807b,
        error: function(jqXHR, status, errorThrown) {
            (0, $98xmD.globals).requestRunning = false;
            notie.hideAlerts();
            if (!window.navigator.onLine) notie.alert({
                type: 3,
                text: "It seems like you're offline. Please check your internet connection and try again."
            });
            else {
                if (status === "timeout") notie.alert({
                    type: 3,
                    text: "The request timed out. Please try again."
                });
                else notie.alert({
                    type: 3,
                    text: "An error occurred while making this request. Please try again."
                });
                (0, $3E8Nt.captureError)(new Error("error for get request " + url + " " + errorThrown));
            }
        }
    });
}
function $144438bbddcf8edc$export$cde5dc4d070dd566(prop) {
    return function(a, b) {
        if (a[prop] > b[prop]) return 1;
        else if (a[prop] < b[prop]) return -1;
        return 0;
    };
}
function $144438bbddcf8edc$export$5b4d20f570fee173(x, y) {
    "use strict";
    if (x === null || x === undefined || y === null || y === undefined) return x === y;
    // after this just checking type of one would be enough
    if (x.constructor !== y.constructor) return false;
    // if they are functions, they should exactly refer to same one (because of closures)
    if (x instanceof Function) return x === y;
    // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
    if (x instanceof RegExp) return x === y;
    if (x === y || x.valueOf() === y.valueOf()) return true;
    if (Array.isArray(x) && x.length !== y.length) return false;
    // if they are dates, they must had equal valueOf
    if (x instanceof Date) return false;
    // if they are strictly equal, they both need to be object at least
    if (!(x instanceof Object)) return false;
    if (!(y instanceof Object)) return false;
    // recursive object equality check
    let p = Object.keys(x);
    return Object.keys(y).every(function(i) {
        return p.indexOf(i) !== -1;
    }) && p.every(function(i) {
        return $144438bbddcf8edc$export$5b4d20f570fee173(x[i], y[i]);
    });
}
function $144438bbddcf8edc$export$ba2c6799323202b0(feud) {
    let participants = feud["participants"].join(" and ");
    let feudPotential = "Feud Potential";
    if (feud["started"]) feudPotential = "Feud started";
    return '<span class="faded-red-light">' + feud["name"] + "</span>" + " " + feudPotential + " between " + participants;
}
window.mobilecheck = function() {
    let check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
function $144438bbddcf8edc$export$9d146348df2d4e4d(data) {
    let text;
    if (data["gimmickRestriction"]["type"] === "gimmick_match") {
        if (data["gimmickRestriction"]["value"]) text = data["name"] + " can only be contested in " + data["gimmickRestriction"]["value"] + " Matches";
        else text = data["name"] + " can only be contested in Gimmick Matches";
    } else if (data["gimmickRestriction"]["type"] === "weekly_show") text = data["name"] + " can only be contested on Weekly Shows";
    else if (data["gimmickRestriction"]["type"] === "maximum_age") text = data["name"] + " can only be contested by Superstars " + data["gimmickRestriction"]["value"] + " years old or younger";
    else if (data["gimmickRestriction"]["type"] === "minimum_age") text = data["name"] + " can only be contested by Superstars " + data["gimmickRestriction"]["value"] + " years old or older";
    return '<span class="display-block">' + text + "</span>";
}
function $144438bbddcf8edc$export$74d7710fb6ab5f76(name) {
    let unlockedByName;
    switch(name){
        case "TLC":
            unlockedByName = "Ladder";
            break;
        case "Tables":
            unlockedByName = "Ladder";
            break;
        case "Brawl":
            unlockedByName = "Ironman";
            break;
        case "Casket":
            unlockedByName = "Ironman";
            break;
        case "Steel Cell":
            unlockedByName = "Steel Cage";
            break;
        case "Hell In A Cell":
            unlockedByName = "Steel Cage";
            break;
        case "Loser Leaves":
            unlockedByName = "Submission";
            break;
        case "Unsanctioned":
            unlockedByName = "Street Fight";
            break;
        case "LMS":
            unlockedByName = "Street Fight";
            break;
        case "Ambulance":
            unlockedByName = "Street Fight";
            break;
        case "Flag":
            unlockedByName = "Pole";
            break;
        case "Graphene Cell":
            unlockedByName = "Graphene Cage";
            break;
        case "Spaceflight":
            unlockedByName = "Glacier Escape";
            break;
        case "Chemical Warfare":
            unlockedByName = "Canyon Fight";
            break;
    }
    return unlockedByName;
}
function $144438bbddcf8edc$export$f1a14159ee779b14(points, fans) {
    let gamePointsHtml = $144438bbddcf8edc$export$fd3677a2a6f21aec(points, (0, $98xmD.globals).game.unlimitedCreativePoints);
    $(".points-number").html(gamePointsHtml).hide().fadeIn();
    let gameFansHtml = $144438bbddcf8edc$export$7072b4f810cae78c(fans);
    $(".fans-number").html(gameFansHtml).hide().fadeIn();
}
function $144438bbddcf8edc$export$b2a3e0591db83e24(gimmick, show) {
    let effectivenessText;
    if (!show) effectivenessText = '<span class="gimmick-effectiveness-text margin-left-5"></span>';
    else effectivenessText = '<span class="gimmick-effectiveness-text margin-left-3">' + $144438bbddcf8edc$export$a97d43ee03f207b1(gimmick["effectiveness"]) + "</span>";
    let gimmickName = '<span class="character-label">' + gimmick["name"] + "</span>";
    let gimmickEffectiveness;
    if (!show) {
        let productionBoost = "";
        if (gimmick["productionBoost"]) productionBoost = 'data-production-boost="' + gimmick["productionBoost"] + '" ';
        gimmickEffectiveness = '<span class="grey margin-left-5"><span class="gimmick-effectiveness" ' + productionBoost + 'data-value="' + gimmick["effectiveness"] + '" data-overness-change="' + gimmick["overnessEffectChange"] + '">' + '</span><span class="margin-left-2">%</span></span>';
    } else gimmickEffectiveness = '<span class="grey margin-left-3">' + gimmick["effectiveness"] + '<span class="margin-left-2">%</span></span>';
    return "{0} debuted a new {1} Gimmick {2} {3}".format(gimmick["superstar"], gimmickName, gimmickEffectiveness, effectivenessText);
}
function $144438bbddcf8edc$export$f60b820a6ef9f0ce(elementClassName) {
    $(".tournament-participant").draggable({
        revert: true,
        containment: elementClassName,
        stack: ".tournament-participant",
        revertDuration: 30,
        opacity: 0.6,
        scroll: true
    });
    $(".tournament-participant").droppable({
        accept: ".tournament-participant",
        activeClass: "droppable-hover",
        hoverClass: "droppable-active",
        drop: function(event, ui) {
            let draggable = ui.draggable, droppable = $(this);
            draggable.swap(droppable);
            setTimeout(function() {
                droppable.addClass("color-change-grey");
                draggable.addClass("color-change-grey");
            }, 50);
            setTimeout(function() {
                droppable.removeClass("color-change-grey");
                draggable.removeClass("color-change-grey");
            }, 800);
        }
    });
}
jQuery.fn.swap = function(b) {
    // method from: http://blog.pengoworks.com/index.cfm/2008/9/24/A-quick-and-dirty-swap-method-for-jQuery
    b = jQuery(b)[0];
    let a = this[0];
    let t = a.parentNode.insertBefore(document.createTextNode(""), a);
    b.parentNode.insertBefore(a, b);
    t.parentNode.insertBefore(b, t);
    t.parentNode.removeChild(t);
    return this;
};
function $144438bbddcf8edc$export$847ffaf7242e3b89(groups, participants, edit) {
    if (typeof edit === "undefined") edit = false;
    let html = "";
    let bracketClass = "";
    if (participants >= 16) bracketClass = "compact";
    groups.forEach(function(group, i) {
        html += '<div class="tournament-group-container">';
        // Add group name
        let groupName = $144438bbddcf8edc$export$e6f22ba519626a5f(i + 1);
        html += '<span class="display-block margin-bottom-10 text-center medium-dark-grey"><span class="tournament-group-name">Group ' + groupName + "</span>" + "</span>";
        // Add group participants
        html += '<div class="tournament-bracket-match ' + bracketClass + '">';
        group.forEach(function(participant, j, arr) {
            let participantSeed = participant[1];
            let participantName = participant[0];
            let editClass = "";
            if (edit) editClass = "edit";
            html += '<div class="tournament-participant ' + editClass + '">' + '<span class="tournament-participant-seed margin-right-5 light-grey">' + participantSeed + "</span>" + '<span class="tournament-participant-name">' + participantName + "</span>" + "</div>";
            if (j !== arr.length - 1) html += '<div class="tournament-participant-separator"></div>';
        });
        html += "</div></div>";
    });
    return html;
}
function $144438bbddcf8edc$export$e6f22ba519626a5f(n) {
    switch(n){
        case 1:
            return "A";
        case 2:
            return "B";
        case 3:
            return "C";
        case 4:
            return "D";
        default:
            return n;
    }
}
function $144438bbddcf8edc$export$9a47ff33c303b854(feud) {
    let participants = feud["participants"].join(" and ");
    let html = '<span class="faded-red-light">' + feud["name"] + "</span>" + " Feud started between " + participants;
    if (feud["shocking"]) html += ". Extra Hype surrounds the Feud due to the shocking turn.";
    let prev = "";
    if (feud["boosts"]["previousFeudBoost"]) prev = '<span class="margin-left-12 grey help-text" title="Hype added due to Participants\' latest Feud">Prev. Feud<span class="faded-red-extra-light"><i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["boosts"]["previousFeudBoost"] + "</span>" + "</span>";
    let turnHype = "";
    if (feud["turnHype"]) turnHype = '<span class="margin-left-12 grey help-text" title="Shocking turn Hype Boost">Turn Hype<span class="faded-red-extra-light"><i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["turnHype"] + "</span>" + "</span>";
    let hotBoost = "";
    if (feud["boosts"]["hotParticipantsBoost"]) hotBoost = '<span class="margin-left-12 grey help-text" title="Over Participants\' Boost">Over<span class="faded-red-extra-light"><i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["boosts"]["hotParticipantsBoost"] + "</span>" + "</span>";
    let staleBoost = "";
    if (feud["boosts"]["staleParticipantsBoost"]) staleBoost = '<span class="margin-left-12 grey help-text" title="Stale Participants\' Penalty">Stale<span class="faded-red-extra-light"><i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["boosts"]["staleParticipantsBoost"] + "</span>" + "</span>";
    // Brands boost
    let brandsBoost = "";
    if (feud["boosts"]["brandsBoost"]) brandsBoost = '<span class="margin-left-12 grey help-text" title="Different Brands Boost">Brands<span class="faded-red-extra-light"><i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["boosts"]["brandsBoost"] + "</span>" + "</span>";
    let factionsBoost = "";
    if (feud["boosts"]["factionReputationBoost"]) factionsBoost = '<span class="margin-left-12 grey help-text" title="Faction REP Boost">Faction<span class="faded-red-extra-light"><i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["boosts"]["factionReputationBoost"] + "</span>" + "</span>";
    let boosts = '<span class="margin-left-12 grey help-text" title="Base Hype of the Feud Item">Base<span class="faded-red-extra-light"><i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["baseHype"] + "</span>" + "</span>" + '<span class="margin-left-12 grey help-text" title="Participants\' Rank Boost">Rank' + '<span class="faded-red-extra-light">' + '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["boosts"]["rankBoost"] + "</span>" + "</span>" + '<span class="margin-left-12 grey help-text" title="Participants\' Alignment Boost">Aln.' + '<span class="faded-red-extra-light">' + '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["boosts"]["alignmentBoost"] + "</span>" + "</span>" + hotBoost + staleBoost + brandsBoost + prev + turnHype + factionsBoost;
    html += boosts;
    return html;
}
function $144438bbddcf8edc$export$b7155a51d771774a(feud) {
    let participants = feud["participants"].join(" and ");
    return '<span class="faded-red-light">' + feud["newFeud"] + "</span> Feud increased the Hype of the " + '<span class="faded-red-light">' + feud["name"] + "</span>" + " Feud between " + participants + ' by<span class="faded-red-light margin-right-8 margin-left-8"><i class="fa fa-bolt margin-right-5"></i>' + feud["hypeIncrease"] + "</span>";
}
function $144438bbddcf8edc$export$2ef1e0f43736ad8c(gimmick) {
    let effectiveness = gimmick["effectiveness"];
    let effectivenessHtml = $144438bbddcf8edc$var$getGimmickEffectivenessText(effectiveness);
    let oldEffectiveness = effectiveness - gimmick["effectivenessChange"];
    let oldEffectivenessHtml = $144438bbddcf8edc$var$getGimmickEffectivenessText(oldEffectiveness);
    let gimmickName = '<span class="character-label">' + gimmick["name"] + "</span>";
    let overnessChangeHtml;
    // Gimmick Overness Effect Change
    if (gimmick["overnessEffectChange"] < 0) {
        gimmick["overnessEffectChange"] *= -1;
        overnessChangeHtml = '<span class="red">- ' + gimmick["overnessEffectChange"] + "</span>";
    } else overnessChangeHtml = '<span class="green">+ ' + gimmick["overnessEffectChange"] + "</span>";
    let verb;
    if (effectiveness > oldEffectiveness) verb = "progressed";
    else verb = "declined";
    let progress = '<span class="light-grey">' + oldEffectivenessHtml + " to " + effectivenessHtml + "</span>";
    return "{0}'s {1} Gimmick {2} from {3} changing Overness by {5}".format(gimmick["superstarName"], gimmickName, verb, progress, effectivenessHtml, overnessChangeHtml);
}
function $144438bbddcf8edc$export$a8c39434b93b192a(data) {
    // If faction reputation element present, update it
    let factionPrestigeElement = $('.faction-reputation[data-uid="' + data["uid"] + '"]');
    if (factionPrestigeElement.length > 0) $144438bbddcf8edc$var$updateFactionReputationElement(data, factionPrestigeElement);
    else {
        let factionReputationHtml = $144438bbddcf8edc$var$getFactionReputationHtml(data);
        $("#prestige-results").find(".event-prestige-header").after('<div class="faction-reputation margin-bottom-20" data-uid="' + data["uid"] + '">' + factionReputationHtml + "</div>");
        factionPrestigeElement = $('.faction-reputation[data-uid="' + data["uid"] + '"]');
    }
    // Add animation for xp and progress change
    factionPrestigeElement.find(".reputation-xp").hide().fadeIn("slow");
    setTimeout(function() {
        factionPrestigeElement.find(".progress").addClass("expand-width");
    }, 0);
    setTimeout(function() {
        factionPrestigeElement.find(".progress").removeClass("expand-width");
    }, 1800);
}
function $144438bbddcf8edc$var$getFactionReputationHtml(data) {
    // Get max indication
    let maxHtml = "";
    if (data["reputation"] >= 10) maxHtml = '<span class="margin-left-8 red">MAX</span>';
    // Get xp change
    let xpChangeHtml = $144438bbddcf8edc$var$getFactionXpChangeHtml(data["xpChange"]);
    // Get progress percentage
    let progressPercentage = data["progressPercentage"];
    if (progressPercentage <= 0) progressPercentage = 1;
    // Add reputation data
    let reputationHtml = '<div class="display-block margin-bottom-8"><div class="display-inline-block width-80 line-height-1p25em"><span>' + data["factionName"] + "</span>" + '<span class="margin-left-8 light-grey">' + "REP " + '<span class="reputation-value">' + data["reputation"] + "</span>" + "</span>" + maxHtml + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey reputation-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text faction-reputation-progress" title="' + data["xp"] + " / " + data["xpToNextReputation"] + ' XP">' + '<div class="progress" style="width:' + progressPercentage + '%">' + "</div>" + "</div>";
    // Get xp change details html (labels, values)
    let detailsHtml = $144438bbddcf8edc$var$getFactionXpChangeDetailsHtml(data);
    // XP change details div
    let xpChangeDetails = '<div class="faction-reputation-details margin-top-10"><div class="column-left">' + detailsHtml[0] + "</div>" + '<div class="column-right">' + detailsHtml[1] + "</div>" + '<div class="clear"></div>' + "</div>";
    // Add button to show xp change details
    reputationHtml += '<div class="margin-top-15"><button class="button retro-button condensed grey-button-background show-faction-reputation-details">Details</button></div>';
    reputationHtml += xpChangeDetails;
    return reputationHtml;
}
function $144438bbddcf8edc$var$updateFactionReputationElement(data, element) {
    // Add xp change details
    let detailsHtml = $144438bbddcf8edc$var$getFactionXpChangeDetailsHtml(data);
    let xpChangeDetails = '<div class="column-left margin-top-5">' + detailsHtml[0] + "</div>" + '<div class="column-right margin-top-5">' + detailsHtml[1] + "</div>" + '<div class="clear"></div>';
    element.find(".faction-reputation-details").append(xpChangeDetails);
    // Get progress percentage
    let progressPercentage = data["progressPercentage"];
    if (progressPercentage <= 0) progressPercentage = 1;
    // Update reputation and progress
    element.find(".reputation-value").html(data["reputation"]);
    element.find(".faction-reputation-progress").attr("title", data["xp"] + " / " + data["xpToNextReputation"] + " XP");
    element.find(".progress").attr("style", "width:" + progressPercentage + "%");
    // Update xp change
    let xpChangeValue = parseInt(element.find(".reputation-xp-value").attr("data-value"));
    xpChangeValue += data["xpChange"];
    let xpChangeHtml = $144438bbddcf8edc$var$getFactionXpChangeHtml(xpChangeValue);
    element.find(".reputation-xp").html("XP" + xpChangeHtml);
}
function $144438bbddcf8edc$var$getFactionXpChangeHtml(xpChange) {
    let xpChangeHtml;
    if (xpChange >= 0) xpChangeHtml = '<span class="reputation-xp-value green margin-left-8" data-value="' + xpChange + '">+ ' + xpChange + "</span>";
    else if (xpChange < 0) xpChangeHtml = '<span class="reputation-xp-value red margin-left-8" data-value="' + xpChange + '">- ' + -1 * xpChange + "</span>";
    return xpChangeHtml;
}
function $144438bbddcf8edc$var$getFactionXpChangeDetailsHtml(data) {
    let labelsHtml = "";
    let valuesHtml = "";
    let orderedKeys = [
        "addedMembers",
        "removedMembers",
        "championshipWon",
        "championshipLost",
        "feudWon",
        "feudLost",
        "hot",
        "stale",
        "becameFotc",
        "lostFotc"
    ];
    // Show change for each item
    orderedKeys.forEach(function(key) {
        if (data["xpChangeDetails"][key]) {
            // Get leader boost if leader
            let leaderHtml = "";
            if (data["xpChangeDetails"]["isLeader"]) leaderHtml = '<span class="light-grey display-block">1.25x Leader Multiplier</span>';
            labelsHtml += '<div class="dark-grey help-text" title="' + $144438bbddcf8edc$var$getFactionReputationKeyHelp(key) + '">' + $144438bbddcf8edc$var$formatFactionReputationDetailsKey(key) + leaderHtml + "</div>";
            valuesHtml += "<div>" + $144438bbddcf8edc$var$formatFactionReputationDetailsValue(data["xpChangeDetails"][key]) + "</div>";
        }
    });
    return [
        labelsHtml,
        valuesHtml
    ];
}
function $144438bbddcf8edc$var$getFactionReputationKeyHelp(key) {
    switch(key){
        case "addedMembers":
        case "removedMembers":
            return "Reputation changes with members added or removed, based on their popularity and overness.";
        case "championshipWon":
        case "championshipLost":
            return "Reputation changes with championships won or lost by faction members.";
        case "feudWon":
        case "feudLost":
            return "Reputation changes for Faction vs Faction feuds won or lost.";
        case "hot":
        case "stale":
            return "Reputation changes if a faction member becomes hot or stale.";
        case "becameFotc":
        case "lostFotc":
            return "Reputation changes if a faction member becomes a Face of the Company or loses their Face of the Company status.";
    }
}
function $144438bbddcf8edc$var$formatFactionReputationDetailsValue(value) {
    if (value >= 0) value = '<span class="green"><span class="value-plus">+</span>' + value + "</span>";
    else if (value < 0) value = '<span class="red"><span class="value-minus">-</span>' + value * -1 + "</span>";
    return value;
}
function $144438bbddcf8edc$var$formatFactionReputationDetailsKey(key) {
    switch(key){
        case "addedMembers":
            return "Added Members";
        case "removedMembers":
            return "Removed Members";
        case "championshipWon":
            return "Won Championship";
        case "championshipLost":
            return "Lost Championship";
        case "feudWon":
            return "Won Feud";
        case "feudLost":
            return "Lost Feud";
        case "hot":
            return "Hot Member";
        case "stale":
            return "Stale Member";
        case "becameFotc":
            return "Became FotC";
        case "lostFotc":
            return "Lost FotC";
    }
}
function $144438bbddcf8edc$export$5b4a3607c73a597e(data) {
    let progress = 100;
    let maxHtml = "";
    if (!data["maxPrestige"]) progress = data["progressPercentage"];
    else maxHtml = '<span class="margin-left-8 red">MAX</span>';
    if (progress > 100) progress = 100;
    else if (progress <= 0) progress = 1;
    let xpChangeHtml;
    let xpChange = data["xpChange"];
    if (data["xpChange"] >= 0) xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + "</span>";
    else if (data["xpChange"] < 0) xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' + -1 * xpChange + "</span>";
    let prestigeIcon = $144438bbddcf8edc$export$fb6527dc70312185(data["prestige"]);
    let prestigeText = '<div class="display-block margin-bottom-8"><div class="display-inline-block width-80 line-height-1p25em"><span>' + data["championshipName"] + "</span>" + '<span class="margin-left-5">' + prestigeIcon + "</span>" + maxHtml + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey prestige-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text championship-prestige-progress" title="' + data["xp"] + " / " + data["nextPrestigeXp"] + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>";
    // Get prestige change details
    let labelsHtml = "";
    let valuesHtml = "";
    let orderedKeys = [
        "rating_change",
        "segment_change",
        "challenger_change",
        "champion_change",
        "reign_change",
        "feuds_change",
        "main_event_change"
    ];
    // Show change for each item
    orderedKeys.forEach(function(key) {
        if (data["xpDetails"][key]) {
            labelsHtml += '<div class="margin-bottom-3 grey help-text" title="' + $144438bbddcf8edc$var$getChampionshipPrestigeKeyHelp(key) + '">' + $144438bbddcf8edc$var$formatChampionshipPrestigeDetailsKey(key) + "</div>";
            valuesHtml += '<div class="margin-bottom-3">' + $144438bbddcf8edc$var$formatChampionshipPrestigeDetailsValue(data["xpDetails"][key]) + "</div>";
        }
    });
    // Show total change
    labelsHtml += '<div class="dark-grey margin-top-12">Total</div>';
    valuesHtml += '<div class="margin-top-12">' + $144438bbddcf8edc$var$formatChampionshipPrestigeDetailsValue(data["xpDetails"]["totalXpChange"]) + "</div>";
    // Prestige change details div
    let prestigeChangeDetails = '<div class="championship-prestige-details margin-top-12 display-none"><div class="column-left">' + labelsHtml + "</div>" + '<div class="column-right">' + valuesHtml + "</div>" + '<div class="clear"></div>' + "</div>";
    prestigeText += '<div class="margin-top-15"><button class="button retro-button condensed grey-button-background show-championship-prestige-details">Details</button></div>';
    prestigeText += prestigeChangeDetails;
    // Prestige increase/decrease text
    if (data["prestigeIncrease"]) prestigeText += '<span class="gold display-block margin-top-12">Prestige Increased</span>';
    else if (data["prestigeDecrease"]) prestigeText += '<span class="puke-green display-block margin-top-12">Prestige Decreased</span>';
    return prestigeText;
}
function $144438bbddcf8edc$var$formatChampionshipPrestigeDetailsValue(value) {
    if (value > 0) value = '<span class="green"><span class="value-plus">+</span>' + value + "</span>";
    else if (value < 0) value = '<span class="red"><span class="value-minus">-</span>' + value * -1 + "</span>";
    return value;
}
function $144438bbddcf8edc$var$formatChampionshipPrestigeDetailsKey(key) {
    switch(key){
        case "rating_change":
            return "Rating";
        case "segment_change":
            return "Segment";
        case "challenger_change":
            return "Challenger";
        case "champion_change":
            return "Champion";
        case "reign_change":
            return "Reign";
        case "feuds_change":
            return "Feuds";
        case "main_event_change":
            return "Main Event";
    }
}
function $144438bbddcf8edc$var$getChampionshipPrestigeKeyHelp(key) {
    switch(key){
        case "rating_change":
            return "Prestige increases with high Match Ratings and decreases with low Match Ratings.";
        case "segment_change":
            return "Prestige increases/decreases with certain Segments.";
        case "challenger_change":
            return "Prestige increases for credible challengers and decreases for non-credible challengers.";
        case "champion_change":
            return "Prestige increases for credible champions and decreases for non-credible champions. Championship wins result in a higher change.";
        case "reign_change":
            return "Prestige increases for every 3 months of a Championship Reign based on the number of defenses. Prestige decreases for each previous Championship Reign shorter than 3 months.";
        case "feuds_change":
            return "Prestige increases for Hot Feuds and decreases for Stale Feuds.";
        case "main_event_change":
            return "Prestige increases if a non-top Championship is put in the Main Event (Match or Segment). Prestige decreases if the top Championship is not put in the Main Event (only for Matches).";
    }
}
function $144438bbddcf8edc$export$e247db8ce197412e(roster, competitor, showGraphicsPercentage = true, showFuture = true) {
    let topSuperstarsDiv = $144438bbddcf8edc$export$d596834de4c64195(roster["topSuperstars"]);
    let futureSuperstarsDiv = roster["futureSuperstars"] !== undefined && showFuture ? $144438bbddcf8edc$export$410bf8553390566("Future", $144438bbddcf8edc$export$d596834de4c64195(roster["futureSuperstars"])) : "";
    let retiredSuperstarsDiv = roster["retiredSuperstars"] !== undefined ? $144438bbddcf8edc$export$410bf8553390566("Retired", $144438bbddcf8edc$export$d596834de4c64195(roster["retiredSuperstars"])) : "";
    let rosterType = roster["name"] ? (0, $3E8Nt.toTitleCase)(roster["name"].replace("-", " ")) : `${(0, $3E8Nt.toTitleCase)(roster["type"])} Roster`;
    let topTagTeamDiv = roster["topTagTeam"] ? $144438bbddcf8edc$export$410bf8553390566("Top Tag Team", roster["topTagTeam"]) : "";
    let topTrioDiv = roster["topTrio"] ? $144438bbddcf8edc$export$410bf8553390566("Top Trio", roster["topTrio"]) : "";
    let graphicsPercentage = "";
    if (showGraphicsPercentage) graphicsPercentage = $144438bbddcf8edc$var$getGraphicsPercentageDiv(roster["numberOfSuperstarsWithGraphics"], roster["numberOfSuperstars"]);
    let numberOfGimmicks = roster["numberOfSuperstarsWithGimmicks"] !== undefined && !competitor ? $144438bbddcf8edc$export$410bf8553390566("Gimmicks", roster["numberOfSuperstarsWithGimmicks"]) : "";
    let numberOfOver = roster["numberOfOverSuperstars"] !== undefined && !competitor ? $144438bbddcf8edc$export$410bf8553390566("Over", roster["numberOfOverSuperstars"]) : "";
    let numberOfStale = roster["numberOfStaleSuperstars"] !== undefined && !competitor ? $144438bbddcf8edc$export$410bf8553390566("Stale", roster["numberOfOverSuperstars"]) : "";
    let numberOfFaces = roster["numberOfFaceSuperstars"] !== undefined && !competitor ? $144438bbddcf8edc$export$410bf8553390566("Faces", roster["numberOfFaceSuperstars"]) : "";
    let numberOfHeel = roster["numberOfHeelSuperstars"] !== undefined && !competitor ? $144438bbddcf8edc$export$410bf8553390566("Heels", roster["numberOfHeelSuperstars"]) : "";
    let numberOfTraits = roster["numberOfSuperstarsWithTraits"] !== undefined && !competitor ? $144438bbddcf8edc$export$410bf8553390566("Traits", roster["numberOfSuperstarsWithTraits"]) : "";
    let classes = competitor ? "blue margin-bottom-5" : "blue font-1p25em margin-bottom-12";
    return '<div class="margin-bottom-25"><div class="' + classes + '">' + rosterType + "</div>" + $144438bbddcf8edc$export$410bf8553390566("Superstars", roster["numberOfSuperstars"]) + $144438bbddcf8edc$export$410bf8553390566("Tag Teams", roster["numberOfTagTeams"]) + $144438bbddcf8edc$export$410bf8553390566("Trios", roster["numberOfTrios"]) + $144438bbddcf8edc$export$410bf8553390566("Factions", roster["numberOfFactions"]) + $144438bbddcf8edc$export$410bf8553390566("Managers", roster["numberOfManagers"]) + $144438bbddcf8edc$export$410bf8553390566("Top Superstars", topSuperstarsDiv) + topTagTeamDiv + topTrioDiv + retiredSuperstarsDiv + futureSuperstarsDiv + graphicsPercentage + numberOfGimmicks + numberOfOver + numberOfStale + numberOfFaces + numberOfHeel + numberOfTraits + "</div>";
}
function $144438bbddcf8edc$export$18c137ba5cda31a4(championships, competitor, showGraphicsPercentage) {
    if (typeof showGraphicsPercentage === "undefined") showGraphicsPercentage = true;
    let championshipsPercentage = "";
    if (showGraphicsPercentage) championshipsPercentage = $144438bbddcf8edc$var$getGraphicsPercentageDiv(championships["numberOfChampionshipsWithGraphics"], championships["numberOfChampionships"]);
    let topChampionshipsDiv = "";
    championships["topChampionships"].forEach(function(championship) {
        let champion = championship["championName"] ? championship["championName"] : "Vacant";
        topChampionshipsDiv += '<div class="display-block margin-bottom-3"><span class="gold">{0}</span> <span class="grey display-block">{1}</span></div>'.format(championship["name"], champion);
    });
    let classes = competitor ? "blue margin-bottom-5" : "blue font-1p25em margin-bottom-12";
    return '<div class="margin-bottom-25"><div class="' + classes + '">Championships</div>' + $144438bbddcf8edc$export$410bf8553390566("Top", topChampionshipsDiv) + championshipsPercentage + "</div>";
}
function $144438bbddcf8edc$export$d58714ba93985757(company, competitor) {
    // Based on Python data format
    let classes = competitor ? "blue margin-bottom-5" : "blue font-1p25em margin-bottom-12";
    let prestigeIcon = "";
    switch(company["topEvent"]["prestige"]){
        case "C":
            prestigeIcon = '<i class="fa fa-star-o font-bold bronze"></i>';
            break;
        case "B":
            prestigeIcon = '<i class="fa fa-star-o font-bold silver"></i>';
            break;
        case "A":
            prestigeIcon = '<i class="fa fa-star-o font-bold gold-light"></i>';
            break;
    }
    let topEvent = "{0} {1}".format(company["topEvent"]["name"], prestigeIcon);
    let owner = company["ownerName"] ? company["ownerName"] : "None";
    return '<div class="margin-bottom-25"><div class="' + classes + '">Company</div>' + $144438bbddcf8edc$export$410bf8553390566("Name", company["companyName"]) + $144438bbddcf8edc$export$410bf8553390566("REP", company["reputation"]) + $144438bbddcf8edc$export$410bf8553390566("Owner", owner) + $144438bbddcf8edc$export$410bf8553390566("Top Event", topEvent) + $144438bbddcf8edc$export$410bf8553390566("Style", (0, $3E8Nt.toTitleCase)(company["style"])) + "</div>";
}
function $144438bbddcf8edc$export$ccbacf175f05e660(brands, competitor) {
    // Based on Python data format
    let brandsHtml = "";
    brands.forEach(function(brand) {
        // Get brand exclusive objects info
        let brandSuperstarsWord = brand["superstars"].length === 1 ? "Superstar" : "Superstars";
        let brandSuperstarsHtml = "{0} {1}".format(brand["superstars"].length, brandSuperstarsWord);
        let brandChampionshipsWord = brand["championships"].length === 1 ? "Championship" : "Championships";
        let brandChampionshipsHtml = "{0} {1}".format(brand["championships"].length, brandChampionshipsWord);
        let brandEventsWord = brand["events"].length === 1 ? "Event" : "Events";
        let brandEventsHtml = "{0} {1}".format(brand["events"].length, brandEventsWord);
        let brandNumberOfObjects = $144438bbddcf8edc$export$d596834de4c64195([
            brandSuperstarsHtml,
            brandChampionshipsHtml,
            brandEventsHtml
        ]);
        // Get brand name and color
        let brandNameStyleHtml = "";
        if (brand["color"] && !(0, $98xmD.globalUser).settings.colorblindMode) brandNameStyleHtml = ' style="color: ' + brand["color"] + '"';
        let brandNameHtml = "<div" + brandNameStyleHtml + ">" + brand["name"] + "</div>";
        brandsHtml += $144438bbddcf8edc$export$410bf8553390566(brandNameHtml, brandNumberOfObjects);
    });
    if (brands.length <= 0) brandsHtml += '<div class="medium-grey">None</div>';
    let classes = competitor ? "blue margin-bottom-5" : "blue font-1p25em margin-bottom-12";
    return '<div class="margin-bottom-25"><div class="' + classes + '">Brands</div>' + brandsHtml + "</div>";
}
function $144438bbddcf8edc$export$410bf8553390566(itemName, itemValue) {
    return '<div class="margin-bottom-8">' + '<div class="scenario-information-column-left medium-grey">{0}</div>'.format(itemName) + '<div class="scenario-information-column-right">{0}</div>'.format(itemValue) + '<div class="clear"></div>' + "</div>";
}
function $144438bbddcf8edc$export$d596834de4c64195(list) {
    let div = "";
    list.forEach(function(item) {
        div += '<div class="display-block">{0}</div>'.format(item);
    });
    if (list.length < 1) div = "None";
    return div;
}
function $144438bbddcf8edc$var$getGraphicsPercentageDiv(graphics, total) {
    let percentage = Math.round(graphics * 1.0 / total * 100);
    let percentageClass;
    if (percentage < 25) percentageClass = "red";
    else if (percentage < 75) percentageClass = "dark-yellow";
    else percentageClass = "green";
    let graphicsDiv = '<span class="' + percentageClass + '">' + percentage + " %</span>";
    return $144438bbddcf8edc$export$410bf8553390566("Graphics", graphicsDiv);
}
function $144438bbddcf8edc$export$bc7802f0bef8d7aa(item) {
    if (Array.isArray(item)) return item.map((el)=>$144438bbddcf8edc$export$bc7802f0bef8d7aa(el));
    else if (typeof item === "function" || item !== Object(item)) return item;
    return Object.fromEntries(Object.entries(item).map(([key, value])=>[
            key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, "")),
            $144438bbddcf8edc$export$bc7802f0bef8d7aa(value)
        ]));
}
function $144438bbddcf8edc$export$15525a6f80bfb79d(user) {
    let formattedName = user.displayName;
    if (user.displayName.length > 7) {
        $(".user-display-name").addClass("help-text").attr("title", user.displayName);
        formattedName = user.displayName.slice(0, 7) + "...";
    }
    $(".user-display-name").text(formattedName);
}
let $144438bbddcf8edc$export$98a643f2bb8d4ab = [
    {
        "name": "Jimmy",
        "type": "he"
    },
    {
        "name": "Adam",
        "type": "he"
    },
    {
        "name": "Ben",
        "type": "he"
    },
    {
        "name": "Molly",
        "type": "she"
    },
    {
        "name": "Shirley",
        "type": "she"
    }
];
let $144438bbddcf8edc$export$14c654bb39fc3e37 = [
    {
        "name": "Dangerous Twins",
        "type": "tag"
    },
    {
        "name": "The Ugly Duo",
        "type": "tag"
    },
    {
        "name": "Gorgeous Bunch",
        "type": "tag"
    },
    {
        "name": "Butcher Boys",
        "type": "tag"
    },
    {
        "name": "Dirt & Fortune",
        "type": "tag"
    },
    {
        "name": "Lion Tamers",
        "type": "tag"
    },
    {
        "name": "Pain & Pleasure",
        "type": "tag"
    },
    {
        "name": "Funk and Wolfman",
        "type": "tag"
    }
];

});
parcelRequire.register("lCS03", function(module, exports) {

$parcel$export(module.exports, "playSoundEffect", () => $fbe708d918ff4612$export$a4cf0a05ea3968a2);

var $3E8Nt = parcelRequire("3E8Nt");
// Initialize sounds
let $fbe708d918ff4612$var$audioErrorElement = document.createElement("audio");
$fbe708d918ff4612$var$audioErrorElement.setAttribute("src", "static/www/static/music/error.mp3");
let $fbe708d918ff4612$var$audioSuccessElement = document.createElement("audio");
$fbe708d918ff4612$var$audioSuccessElement.setAttribute("src", "static/www/static/music/success.mp3");
let $fbe708d918ff4612$var$audioSelectElement = document.createElement("audio");
$fbe708d918ff4612$var$audioSelectElement.setAttribute("src", "static/www/static/music/select.mp3");
let $fbe708d918ff4612$var$soundEffects = [
    $fbe708d918ff4612$var$audioErrorElement,
    $fbe708d918ff4612$var$audioSuccessElement,
    $fbe708d918ff4612$var$audioSelectElement
];
// Initialize music
let $fbe708d918ff4612$var$musicFileNames = [
    "Hole.mp3",
    "Bash and Trash.mp3",
    "Down Hill.mp3",
    "Get Serious.mp3",
    "Leading Together.mp3",
    "Rocking Adrenaline.mp3",
    "Scream Now.mp3",
    "Split Between.mp3",
    "Sports Junkie.mp3",
    "Spring Cleaning.mp3",
    "Thirsty.mp3",
    "Too Crazy.mp3",
    "Unrelenting.mp3"
];
$fbe708d918ff4612$var$musicFileNames = (0, $3E8Nt.shuffle)($fbe708d918ff4612$var$musicFileNames);
let $fbe708d918ff4612$var$i = 0;
let $fbe708d918ff4612$var$audioMusicElement = document.createElement("audio");
// Mute sounds and music
$fbe708d918ff4612$var$soundEffects.forEach(function(audio) {
    audio.muted = true;
    audio.volume = 0.3;
});
$fbe708d918ff4612$var$audioMusicElement.autoplay = false;
$fbe708d918ff4612$var$audioMusicElement.volume = 0.3;
// Go to next song upon song ending
$fbe708d918ff4612$var$audioMusicElement.addEventListener("ended", function() {
    $fbe708d918ff4612$var$i++;
    if ($fbe708d918ff4612$var$i === $fbe708d918ff4612$var$musicFileNames.length) $fbe708d918ff4612$var$i = 0;
    this.setAttribute("src", "static/www/static/music/" + $fbe708d918ff4612$var$musicFileNames[$fbe708d918ff4612$var$i]);
    this.play();
}, false);
$(document).ready(function() {
    // Enable / disable music
    $("#music-range").on("input", function() {
        const volume = parseInt($(this).val());
        // Play music
        if (volume > 0) {
            if (!$fbe708d918ff4612$var$audioMusicElement.getAttribute("src")) $fbe708d918ff4612$var$audioMusicElement.setAttribute("src", "static/www/static/music/" + $fbe708d918ff4612$var$musicFileNames[$fbe708d918ff4612$var$i]);
            $fbe708d918ff4612$var$audioMusicElement.play();
            $fbe708d918ff4612$var$audioMusicElement.volume = volume / 100;
        } else $fbe708d918ff4612$var$audioMusicElement.pause();
    });
    // Enable / disable sounds
    $("#sound-effects-range").on("input", function() {
        const volume = parseInt($(this).val());
        // Unmute sounds
        if (volume > 0) $fbe708d918ff4612$var$soundEffects.forEach(function(audio) {
            audio.muted = false;
            audio.volume = volume / 100;
        });
        else $fbe708d918ff4612$var$soundEffects.forEach(function(audio) {
            audio.muted = true;
        });
    });
    $("#sound-effects-range").on("change", function() {
        $fbe708d918ff4612$export$a4cf0a05ea3968a2("success");
    });
});
function $fbe708d918ff4612$export$a4cf0a05ea3968a2(soundEffectType) {
    if (soundEffectType === "success") $fbe708d918ff4612$var$audioSuccessElement.play();
    else if (soundEffectType === "error") $fbe708d918ff4612$var$audioErrorElement.play();
}

});

parcelRequire.register("aP7lq", function(module, exports) {

$parcel$export(module.exports, "traitsData", () => $7e145d47841621fe$export$3a9f0f1c1eee429c);
let $7e145d47841621fe$export$3a9f0f1c1eee429c = {
    // Holy shit moments
    "Risk Taker": {
        "holy_shit_moment_chance_multiplier": 2.4,
        "gimmick_match_fatigue_multiplier": 1.4,
        "category": "Holy Shit Moments",
        "conflicting_traits": [
            "Risk Averse"
        ],
        "description": "This worker is eager to take risks in gimmick matches. They can create more amazing moments than others.",
        "order": 1
    },
    "Risk Averse": {
        "holy_shit_moment_chance_multiplier": 0.2,
        "gimmick_match_fatigue_multiplier": 0.6,
        "category": "Holy Shit Moments",
        "conflicting_traits": [
            "Risk Taker",
            "Gifted Acrobat"
        ],
        "description": "This worker is a little afraid of risks. They aren't able to take full advantage of gimmick matches.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "trainer",
        "order": 2
    },
    "Gifted Acrobat": {
        "holy_shit_moment_chance_multiplier": 1.6,
        "overness_increase_multiplier": 1.25,
        "category": "Holy Shit Moments",
        "conflicting_traits": [
            "Risk Averse"
        ],
        "description": "This worker is a natural at performing stunning moves and unbelievable leaps that the fans love.",
        "order": 3
    },
    "Stiff Worker": {
        "holy_shit_moment_pure_chance_multiplier": 1.8,
        "category": "Holy Shit Moments",
        "conflicting_traits": [],
        "description": "This worker likes to work a strong style in matches. They are better suited towards 'pure' style companies.",
        "order": 4
    },
    // Injuries
    "Injury Prone": {
        "injury_chance_multiplier": 2.0,
        "category": "Injuries",
        "conflicting_traits": [
            "Injury Resilient"
        ],
        "description": "This worker has a history of injuries. A slight misstep could lead to many months of inactivity.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "doctor",
        "acquirable": true,
        "action_to_acquire": "injuries",
        "requirements_to_acquire": [],
        "progress_per_action": 8,
        "minimum_progress_to_acquire": 20,
        "order": 1
    },
    "Injury Resilient": {
        "injury_chance_multiplier": 0.5,
        "category": "Injuries",
        "conflicting_traits": [
            "Injury Prone"
        ],
        "description": "This worker is tough, careful and lucky. Injuries seem to escape them.",
        "order": 2
    },
    "Dangerous Worker": {
        "cause_injury_chance_multiplier": 3.0,
        "add_blood_to_opponent_chance_boost": 8,
        "category": "Injuries",
        "conflicting_traits": [],
        "description": "This worker is a danger to others in the ring. Opponents have a higher chance to get injured and bleed during matches with them.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "trainer",
        "acquirable": true,
        "action_to_acquire": "injuries inflicted",
        "requirements_to_acquire": [
            "2*_workrate_or_lower"
        ],
        "progress_per_action": 8,
        "minimum_progress_to_acquire": 15,
        "order": 3
    },
    // Matches
    "Ring General": {
        "positive_match_rating_boost_multiplier": 10,
        "negative_match_rating_boost_multiplier": 0.5,
        "category": "Matches",
        "conflicting_traits": [
            "Dull Worker"
        ],
        "description": "This worker knows how to add good effects to their matches.",
        "acquirable": true,
        "action_to_acquire": "4.5* or higher one-on-one Matches with positive effects",
        "requirements_to_acquire": [
            "3*_workrate"
        ],
        "progress_per_action": 1,
        "minimum_progress_to_acquire": 10,
        "order": 1
    },
    "Dull Worker": {
        "positive_match_rating_boost_multiplier": 0.5,
        "negative_match_rating_boost_multiplier": 10,
        "category": "Matches",
        "conflicting_traits": [
            "Ring General"
        ],
        "description": "This worker seems to attract bad effects in their matches.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "trainer",
        "acquirable": true,
        "action_to_acquire": "2.5* or lower one-on-one Matches with negative effects",
        "requirements_to_acquire": [
            "1*_workrate"
        ],
        "progress_per_action": 2,
        "minimum_progress_to_acquire": 10,
        "order": 2
    },
    "Workhorse": {
        "hot_match_chance_boost": 10,
        "category": "Matches",
        "conflicting_traits": [],
        "description": "This worker goes the extra mile in matches, working harder than most others.",
        "acquirable": true,
        "action_to_acquire": "hot Matches",
        "requirements_to_acquire": [
            "3*_workrate"
        ],
        "progress_per_action": 1,
        "minimum_progress_to_acquire": 15,
        "order": 3
    },
    "Big Match Specialist": {
        "monthly_event_match_rating_boost": 0.4,
        "monthly_event_match_fatigue_change": 4,
        "category": "Matches",
        "conflicting_traits": [
            "Big Stage Wreck"
        ],
        "description": "This worker goes into a higher gear on the big stage.",
        "acquirable": true,
        "action_to_acquire": "5* or higher one-on-one Matches on monthly events",
        "requirements_to_acquire": [
            "2*_workrate_or_higher"
        ],
        "progress_per_action": 1,
        "minimum_progress_to_acquire": 15,
        "order": 4
    },
    "Big Stage Wreck": {
        "weekly_show_match_rating_boost": 0.2,
        "monthly_event_match_rating_boost": -0.4,
        "category": "Matches",
        "conflicting_traits": [
            "Big Match Specialist",
            "Weekly Sloth"
        ],
        "description": "This worker gets nervous on the big stage but performs better on weekly shows.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "talent_manager",
        "order": 5
    },
    "Weekly Sloth": {
        "weekly_show_match_rating_boost": -0.4,
        "monthly_event_match_rating_boost": 0.2,
        "weekly_show_match_fatigue_change": -2,
        "category": "Matches",
        "conflicting_traits": [
            "Big Stage Wreck"
        ],
        "description": "This worker phones it in on weekly shows but performs better on monthly events.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "talent_manager",
        "order": 6
    },
    // Gimmick match boost
    "Enjoys Gimmick Matches": {
        "gimmick_match_multiplier": 3,
        "category": "Matches",
        "conflicting_traits": [
            "Hates Gimmick Matches"
        ],
        "description": "This worker performs better in gimmick matches than others.",
        "order": 7
    },
    "Hates Gimmick Matches": {
        "gimmick_match_multiplier": -3,
        "category": "Matches",
        "conflicting_traits": [
            "Enjoys Gimmick Matches",
            "Match Expert"
        ],
        "description": "This worker finds it difficult to take advantage of gimmick matches.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "trainer",
        "order": 8
    },
    "Match Expert": {
        "gimmick_match_multiplier": 4,
        "gimmick_match_fatigue_multiplier": 0.6,
        "category": "Matches",
        "conflicting_traits": [
            "Hates Gimmick Matches"
        ],
        "description": "This worker has discovered a love for a particular kind of gimmick match and excels in it.",
        "acquirable": true,
        "action_to_acquire": "5* or higher one-on-one Gimmick Matches",
        "requirements_to_acquire": [
            "2*_workrate_or_higher"
        ],
        "progress_per_action": 2,
        "minimum_progress_to_acquire": 10,
        "order": 9
    },
    // Morale
    "Easy To Please": {
        "loss_affects_morale_chance": 40,
        "category": "Morale",
        "conflicting_traits": [
            "Hard To Please",
            "Rebel",
            "Loyal",
            "Extreme Emotions"
        ],
        "description": "This worker is not too concerned with losing. A few losses here and there won't affect their happiness.",
        "order": 1
    },
    "Hard To Please": {
        "win_affects_morale_chance": 60,
        "category": "Morale",
        "conflicting_traits": [
            "Easy To Please",
            "Rebel",
            "Loyal",
            "Extreme Emotions"
        ],
        "description": "This worker can be a bit difficult. Once unhappy, they might need more than a single win to win them over.",
        "order": 2
    },
    "Loyal": {
        "loss_affects_morale_chance": 20,
        "leaving_chance_multiplier": 0.25,
        "category": "Morale",
        "conflicting_traits": [
            "Rebel",
            "Easy To Please",
            "Hard To Please",
            "Extreme Emotions"
        ],
        "description": "This worker is devoted to the company and is more difficult to poach. It takes some doing to make them decide to leave.",
        "order": 3
    },
    "Rebel": {
        "win_affects_morale_chance": 30,
        "leaving_chance_multiplier": 2.0,
        "category": "Morale",
        "conflicting_traits": [
            "Loyal",
            "Easy To Please",
            "Hard To Please",
            "Extreme Emotions"
        ],
        "description": "This worker is likely to leave at the slightest chance and is easier to poach.",
        "order": 4
    },
    "Extreme Emotions": {
        "win_affects_morale_chance": 30,
        "loss_affects_morale_chance": 20,
        "category": "Morale",
        "conflicting_traits": [
            "Easy To Please",
            "Hard To Please",
            "Rebel",
            "Loyal"
        ],
        "description": "This worker is easy to deal with when happy, but if you get on their bad side, it's tough to get them to stay.",
        "order": 5
    },
    "Giving Veteran": {
        "no_morale_change_except_rank": "Jabroni",
        "category": "Morale",
        "conflicting_traits": [],
        "description": "This worker likes to give back to the business and is happy to put over most talent.",
        "acquirable": true,
        "action_to_acquire": "turning part-timer",
        "requirements_to_acquire": [
            "2*_workrate_or_higher",
            "dedicated_wrestler_trait_present"
        ],
        "progress_per_action": 25,
        "minimum_progress_to_acquire": 25,
        "order": 6
    },
    "Star Maker": {
        "no_morale_change_rank": "Upper Midcarder",
        "category": "Morale",
        "conflicting_traits": [],
        "description": "This worker believes they can make stars out of rising talent and are willing to lose to them.",
        "acquirable": true,
        "action_to_acquire": "losses in 4* or higher one-on-one Matches vs Upper Midcarders",
        "requirements_to_acquire": [],
        "progress_per_action": 2,
        "minimum_progress_to_acquire": 15,
        "order": 7
    },
    "Spotlight Lover": {
        "no_morale_change_rank": "Main Eventer",
        "category": "Morale",
        "conflicting_traits": [],
        "description": "This worker enjoys being in the spotlight, even if that means losing.",
        "acquirable": true,
        "action_to_acquire": "losses in 4.5* or higher one-on-one Matches vs Main Eventers",
        "requirements_to_acquire": [],
        "progress_per_action": 1,
        "minimum_progress_to_acquire": 15,
        "order": 8
    },
    // Training
    "Quick Learner": {
        "skill_xp_multiplier": 1.15,
        "training_xp_multiplier": 1.25,
        "months_to_unlearn_traits_boost": 1,
        "category": "Progress",
        "conflicting_traits": [
            "Slow Learner",
            "Loves Training",
            "Hates Training",
            "Self Learner",
            "Lacks Self Learning"
        ],
        "description": "This worker has a sharp mind and is quick to learn new things.",
        "order": 1
    },
    "Slow Learner": {
        "skill_xp_multiplier": 0.8,
        "training_xp_multiplier": 0.8,
        "months_to_unlearn_traits_boost": -1,
        "category": "Progress",
        "conflicting_traits": [
            "Quick Learner",
            "Loves Training",
            "Hates Training",
            "Self Learner",
            "Lacks Self Learning"
        ],
        "description": "This worker is slower at learning new things than others.",
        "order": 2
    },
    "Loves Training": {
        "training_xp_multiplier": 1.5,
        "category": "Progress",
        "conflicting_traits": [
            "Hates Training",
            "Quick Learner",
            "Slow Learner"
        ],
        "description": "This worker puts in extra effort when training and learns faster from it.",
        "order": 3
    },
    "Hates Training": {
        "training_xp_multiplier": 0.7,
        "neglected_training_superstar_chance": 60,
        "category": "Progress",
        "conflicting_traits": [
            "Loves Training",
            "Quick Learner",
            "Slow Learner"
        ],
        "description": "This worker tends to slack off during training. This doesn't allow them to learn as much from training sessions.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "trainer",
        "order": 4
    },
    "Self Learner": {
        "skill_xp_multiplier": 1.3,
        "category": "Progress",
        "conflicting_traits": [
            "Lacks Self Learning",
            "Quick Learner",
            "Slow Learner"
        ],
        "description": "This worker is good at developing their skills by being in matches and segments.",
        "order": 5
    },
    "Lacks Self Learning": {
        "skill_xp_multiplier": 0.7,
        "category": "Progress",
        "conflicting_traits": [
            "Self Learner",
            "Quick Learner",
            "Slow Learner"
        ],
        "description": "This worker doesn't learn as much from being in matches and segments. Instead, they need good training.",
        "order": 6
    },
    // Contract Status
    "Dedicated Wrestler": {
        "retirement_chance_multiplier": 0.5,
        "retirement_age_change": 2,
        "part_timer_chance_multiplier": 0.5,
        "turn_part_timer_age_change": 2,
        "category": "Career",
        "conflicting_traits": [
            "Lifelong Wrestler",
            "Other Interests"
        ],
        "complimentary_traits": [
            "Leader",
            "Ages Well",
            "Injury Resilient"
        ],
        "description": "This worker loves the business and wants to stay active longer than others.",
        "disable_lose_with_age": true,
        "order": 1
    },
    "Lifelong Wrestler": {
        "retirement_age_change": 10,
        "retirement_chance_multiplier": 0.5,
        "category": "Career",
        "conflicting_traits": [
            "Dedicated Wrestler",
            "Other Interests"
        ],
        "description": "This worker lives and breathes the business. They never want to retire.",
        "disable_lose_with_age": true,
        "order": 2
    },
    "Other Interests": {
        "part_timer_chance_multiplier": 1.5,
        "turn_part_timer_age_change": -5,
        "category": "Career",
        "conflicting_traits": [
            "Dedicated Wrestler",
            "Lifelong Wrestler"
        ],
        "description": "This worker has other interests in life. The time could come early when they decide to leave and pursue them.",
        "order": 3
    },
    // Overness
    "Natural Charisma": {
        "overness_increase_multiplier": 1.5,
        "overness_decrease_multiplier": 0.5,
        "category": "Overness/Alignment",
        "conflicting_traits": [
            "Naturally Stale"
        ],
        "description": "This worker oozes charisma. They have an easier road to getting over with the fans.",
        "order": 1
    },
    "Naturally Stale": {
        "overness_increase_multiplier": 0.5,
        "overness_decrease_multiplier": 1.5,
        "category": "Overness/Alignment",
        "conflicting_traits": [
            "Natural Charisma"
        ],
        "description": "This worker has a boring quality that makes them lean towards staleness in the eyes of the fans.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "producer",
        "order": 2
    },
    // Alignment
    "Natural Babyface": {
        "face_alignment_hype_boost": 10,
        "heel_alignment_penalty": -15,
        "category": "Overness/Alignment",
        "conflicting_traits": [
            "Natural Heel"
        ],
        "description": "This worker was born to play the good guy. They are more believable and work better when acting as a face.",
        "order": 3
    },
    "Natural Heel": {
        "heel_alignment_hype_boost": 10,
        "face_alignment_penalty": -15,
        "category": "Overness/Alignment",
        "conflicting_traits": [
            "Natural Babyface"
        ],
        "description": "This worker looks and acts like a bad guy. They work better when playing a heel.",
        "order": 4
    },
    // Segments
    "Entertainer": {
        "hot_segment_chance_boost": 10,
        "category": "Segments",
        "conflicting_traits": [],
        "description": "This worker is a natural at putting on entertaining segments.",
        "acquirable": true,
        "action_to_acquire": "hot Segments",
        "requirements_to_acquire": [
            "3*_charisma"
        ],
        "progress_per_action": 2,
        "minimum_progress_to_acquire": 20,
        "order": 1
    },
    "Comedy Chops": {
        "silly_segment_rating_boost": 0.1,
        "category": "Segments",
        "conflicting_traits": [
            "Humorless"
        ],
        "description": "This worker has a knack for comedy, making them excel at silly segments.",
        "order": 2
    },
    "Humorless": {
        "silly_segment_rating_boost": -0.1,
        "category": "Segments",
        "conflicting_traits": [
            "Comedy Chops"
        ],
        "description": "This worker is a serious person who doesn't do well in silly segments.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "producer",
        "order": 3
    },
    // Gimmicks
    "Character Worker": {
        "gimmick_boost": 15,
        "gimmick_interview_superstar_chance": 60,
        "category": "Gimmicks",
        "conflicting_traits": [],
        "description": "This worker gives special attention to their gimmick, committing themselves to the character.",
        "order": 1
    },
    "Lore Master": {
        "fantasy_gimmick_character_boost": 20,
        "non_fantasy_gimmick_character_boost": -40,
        "category": "Gimmicks",
        "conflicting_traits": [],
        "description": "This worker shines when put in fantasy gimmicks. Monsters and Demons are their thing, Bodybuilders and Brutes, not so much.",
        "order": 2
    },
    "Redeems Bad Gimmicks": {
        "bad_combination_gimmick_boost": 20,
        "category": "Gimmicks",
        "conflicting_traits": [],
        "description": "This worker can turn awful gimmicks into something better.",
        "order": 3
    },
    // Feuds
    "Storyteller": {
        "hot_feud_chance_boost": 10,
        "feud_staleness_limit_boost": 1,
        "feud_boosted_feud_chance": 75,
        "category": "Feuds",
        "conflicting_traits": [
            "Neglects Story"
        ],
        "description": "This worker engages in longer feuds and sticks to the story being told.",
        "order": 1
    },
    "Neglects Story": {
        "hot_feud_chance_boost": -10,
        "feud_staleness_limit_boost": -1,
        "feud_ignored_feud_chance": 75,
        "category": "Feuds",
        "conflicting_traits": [
            "Storyteller"
        ],
        "description": "This worker works shorter feuds without focusing on the story too much.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "producer",
        "order": 2
    },
    "Good Actor": {
        "feud_hype_change_boost": 3,
        "gimmick_effectiveness_increase_multiplier": 1.5,
        "gimmick_effectiveness_decrease_multiplier": 0.5,
        "category": "Feuds",
        "conflicting_traits": [
            "Bad Actor"
        ],
        "description": "This worker has good acting chops. They get the audience more invested in their feuds and character.",
        "order": 3
    },
    "Bad Actor": {
        "feud_hype_change_boost": -3,
        "gimmick_effectiveness_increase_multiplier": 0.5,
        "gimmick_effectiveness_decrease_multiplier": 1.5,
        "category": "Feuds",
        "conflicting_traits": [
            "Good Actor"
        ],
        "description": "This worker can barely act. The audience is less invested in their feuds and character.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "producer",
        "order": 4
    },
    // Backstage
    "Leader": {
        "morale_boost_helper_chance": 70,
        "wrestler_court_judge_chance": 100,
        "category": "Backstage",
        "conflicting_traits": [],
        "description": "This worker leads the locker room. They tend to help others and are the authority backstage.",
        "acquirable": true,
        "action_to_acquire": "helping with Morale Boost or being a judge in a Wrestlers Court",
        "requirements_to_acquire": [],
        "progress_per_action": 8,
        "minimum_progress_to_acquire": 20,
        "order": 1
    },
    "Troublemaker": {
        "wrestler_court_defendant_chance": 50,
        "backstage_fight_starter_chance": 50,
        "category": "Backstage",
        "conflicting_traits": [],
        "description": "This worker has a tendency to get in trouble with others backstage. They can be difficult to manage.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "talent_manager",
        "acquirable": true,
        "action_to_acquire": "starting a Backstage Fight",
        "requirements_to_acquire": [],
        "progress_per_action": 25,
        "minimum_progress_to_acquire": 50,
        "order": 2
    },
    "Drug Habit": {
        "drug_abuse_superstar_chance": 75,
        "category": "Backstage",
        "conflicting_traits": [],
        "description": "This worker has a habit of recreational drug use that can interfere with their work.",
        "can_unlearn": true,
        "staff_role_to_unlearn": "doctor",
        "acquirable": true,
        "action_to_acquire": "being involved in Drug Abuse",
        "requirements_to_acquire": [],
        "progress_per_action": 25,
        "minimum_progress_to_acquire": 50,
        "order": 3
    },
    // Misc
    "Bleeder": {
        "add_blood_chance_boost": 20,
        "category": "Misc",
        "conflicting_traits": [],
        "description": "This worker loves to bleed. They are prone to using the razor on themselves in gimmick matches.",
        "acquirable": true,
        "action_to_acquire": "bleeding in Matches",
        "requirements_to_acquire": [],
        "progress_per_action": 2,
        "minimum_progress_to_acquire": 10,
        "order": 1
    },
    "Tag Team Specialist": {
        "tag_match_workrate_boost": 0.5,
        "category": "Misc",
        "conflicting_traits": [],
        "description": "This worker performs better in tag matches.",
        "order": 2
    },
    "Ages Well": {
        "lose_trait_chance_multiplier": 0.25,
        "remove_fatigue_age_penalty": true,
        "category": "Misc",
        "conflicting_traits": [],
        "description": "This worker consistently practices their abilities and is less likely to lose them with age.",
        "disable_lose_with_age": true,
        "order": 3
    }
};

});


parcelRequire.register("hBIDz", function(module, exports) {

$parcel$export(module.exports, "Superstar", () => $cd18846a21e57ea1$export$eeec5bcea9bfe429);
$parcel$export(module.exports, "getSuperstarData", () => $cd18846a21e57ea1$export$7af850a215c050ef);
$parcel$export(module.exports, "getSuperstarChampionships", () => $cd18846a21e57ea1$export$e449ece5a3fcb618);
$parcel$export(module.exports, "addSuperstarChampionships", () => $cd18846a21e57ea1$export$ae954500c84976fd);
$parcel$export(module.exports, "removeSuperstarChampionships", () => $cd18846a21e57ea1$export$527e96790eb9dc94);
$parcel$export(module.exports, "getSuperstarTagTeams", () => $cd18846a21e57ea1$export$884e2c0b6d318c32);
$parcel$export(module.exports, "getSuperstarMatches", () => $cd18846a21e57ea1$export$f1699b2e83d0161e);
$parcel$export(module.exports, "getSuperstarRoster", () => $cd18846a21e57ea1$export$b0db48d2aa602b31);
$parcel$export(module.exports, "getSuperstarOriginalRoster", () => $cd18846a21e57ea1$export$9b97b0d72ad3dbce);
$parcel$export(module.exports, "getSuperstarFactions", () => $cd18846a21e57ea1$export$91eebd3b42e96e13);
$parcel$export(module.exports, "getSuperstarLeadFactions", () => $cd18846a21e57ea1$export$cc19acd0cc968d4c);
$parcel$export(module.exports, "addSuperstarChampionshipReigns", () => $cd18846a21e57ea1$export$b092468d3a905e25);
$parcel$export(module.exports, "getSuperstarChampionshipReigns", () => $cd18846a21e57ea1$export$6d8d4bbff3588885);
$parcel$export(module.exports, "addSuperstarRelationships", () => $cd18846a21e57ea1$export$873dbb6189b226c1);
$parcel$export(module.exports, "getSuperstarRelationships", () => $cd18846a21e57ea1$export$b528499420266afa);
$parcel$export(module.exports, "addSuperstarMatchContracts", () => $cd18846a21e57ea1$export$39b837b53c3c87e4);
$parcel$export(module.exports, "addSuperstarStreaks", () => $cd18846a21e57ea1$export$9bc78f9aac3fb6e8);
$parcel$export(module.exports, "getSuperstarStreaks", () => $cd18846a21e57ea1$export$1c39f7476c699659);
$parcel$export(module.exports, "addSuperstarWonTournaments", () => $cd18846a21e57ea1$export$6728b9e1da0826c1);
$parcel$export(module.exports, "getSuperstarWonTournaments", () => $cd18846a21e57ea1$export$40d25ab404f26c89);
$parcel$export(module.exports, "addSuperstarGimmicks", () => $cd18846a21e57ea1$export$758f0a0a5b1c2a5);
$parcel$export(module.exports, "removeSuperstarGimmicks", () => $cd18846a21e57ea1$export$1bc8592af11e45f4);
$parcel$export(module.exports, "getSuperstarGimmicks", () => $cd18846a21e57ea1$export$1a25e98a8cf6ac18);
$parcel$export(module.exports, "getSuperstarCurrentGimmick", () => $cd18846a21e57ea1$export$8045f8ee5d8e4386);
$parcel$export(module.exports, "addSuperstarRandomEvents", () => $cd18846a21e57ea1$export$8b6ee52b2c4b57b4);
$parcel$export(module.exports, "removeSuperstarRandomEvents", () => $cd18846a21e57ea1$export$f85b8d3b06d0c20f);
$parcel$export(module.exports, "getSuperstarRandomEvents", () => $cd18846a21e57ea1$export$c6ede37f1f0b0ed0);
$parcel$export(module.exports, "addSuperstarStaffObjects", () => $cd18846a21e57ea1$export$8efc2222ecfaec65);
$parcel$export(module.exports, "getSuperstarStaffObject", () => $cd18846a21e57ea1$export$596716fcab13f66);
$parcel$export(module.exports, "addSuperstarNegotiations", () => $cd18846a21e57ea1$export$894bdf172564e9a6);
$parcel$export(module.exports, "getSuperstarNegotiations", () => $cd18846a21e57ea1$export$78e746c55dc35e94);
$parcel$export(module.exports, "addSuperstarTalentRequests", () => $cd18846a21e57ea1$export$d525531e1b380c8e);
$parcel$export(module.exports, "getSuperstarTalentRequests", () => $cd18846a21e57ea1$export$c6dd79f1b8c2baa8);
$parcel$export(module.exports, "getSuperstarFeuds", () => $cd18846a21e57ea1$export$1ad7bbcde28f3749);
$parcel$export(module.exports, "setSuperstarManager", () => $cd18846a21e57ea1$export$5a8662b6afb9c471);
$parcel$export(module.exports, "removeSuperstarManager", () => $cd18846a21e57ea1$export$7a921220e3b8020b);
$parcel$export(module.exports, "getSuperstarManager", () => $cd18846a21e57ea1$export$7dcffdf512088476);
$parcel$export(module.exports, "getSuperstarManagedSuperstars", () => $cd18846a21e57ea1$export$fc0a663b83757c93);

var $14eBR = parcelRequire("14eBR");
function $cd18846a21e57ea1$export$eeec5bcea9bfe429(name, popularity, age, partTimer = false, injured = 0, faceOfTheCompany = false, graphic = null) {
    // Strings
    const injuryName = null;
    const activeEffect = null;
    const alignment = null;
    const brandName = null;
    const temporaryInjury = null;
    const highestRank = null;
    const objectName = "superstar";
    const gender = "male";
    // Booleans
    const unhappy = false;
    const retired = false;
    const dead = false;
    const hallOfFamer = false;
    const cyborg = false;
    const debutNewGimmick = false;
    const hot = false;
    const stale = false;
    const unavailable = false;
    const injuredAtLatestShow = null;
    const availableThisMonth = null;
    const fullTimeManager = null;
    const readyToReturn = null;
    const workableInjury = null;
    // Integer
    const faceOfTheCompanyCounter = 0;
    const morale = 65;
    const alignmentMonths = 0;
    const charisma = 1;
    const charismaXp = 0;
    const workrate = 1;
    const workrateXp = 0;
    const overness = 45;
    const winsCounter = 0;
    const lossesCounter = 0;
    const wins = 0;
    const losses = 0;
    const currentAttire = 0;
    const suspensionMonths = 0;
    const winsTemporary = 0;
    const lossesTemporary = 0;
    const kayfabePoints = 0;
    const kayfabePointsTemporary = 0;
    const fatigue = 0;
    const appearances = null;
    const tournamentSeed = null;
    const tournamentPoints = null;
    const monthToAppearIn = null;
    const injuryReturnMin = null;
    const injuryReturnMax = null;
    const contractMonthsRemaining = null;
    // Arrays
    const traits = [];
    // Objects
    const traitsProgress = {};
    // Foreign keys
    const rosterId = null;
    const originalRosterId = null;
    const propertyId = null;
    const offeredTradeOfferId = null;
    const requestedTradeOfferId = null;
    const managerId = null;
    return {
        name: name,
        objectName: objectName,
        popularity: popularity,
        age: age,
        partTimer: partTimer,
        gender: gender,
        injured: injured,
        faceOfTheCompany: faceOfTheCompany,
        graphic: graphic,
        injuryName: injuryName,
        activeEffect: activeEffect,
        alignment: alignment,
        brandName: brandName,
        temporaryInjury: temporaryInjury,
        highestRank: highestRank,
        unhappy: unhappy,
        retired: retired,
        dead: dead,
        hallOfFamer: hallOfFamer,
        cyborg: cyborg,
        debutNewGimmick: debutNewGimmick,
        hot: hot,
        stale: stale,
        unavailable: unavailable,
        injuredAtLatestShow: injuredAtLatestShow,
        availableThisMonth: availableThisMonth,
        fullTimeManager: fullTimeManager,
        readyToReturn: readyToReturn,
        faceOfTheCompanyCounter: faceOfTheCompanyCounter,
        morale: morale,
        alignmentMonths: alignmentMonths,
        charisma: charisma,
        charismaXp: charismaXp,
        workrate: workrate,
        workrateXp: workrateXp,
        overness: overness,
        winsCounter: winsCounter,
        lossesCounter: lossesCounter,
        wins: wins,
        losses: losses,
        currentAttire: currentAttire,
        suspensionMonths: suspensionMonths,
        winsTemporary: winsTemporary,
        lossesTemporary: lossesTemporary,
        kayfabePoints: kayfabePoints,
        kayfabePointsTemporary: kayfabePointsTemporary,
        appearances: appearances,
        tournamentSeed: tournamentSeed,
        tournamentPoints: tournamentPoints,
        monthToAppearIn: monthToAppearIn,
        injuryReturnMin: injuryReturnMin,
        injuryReturnMax: injuryReturnMax,
        contractMonthsRemaining: contractMonthsRemaining,
        traits: traits,
        traitsProgress: traitsProgress,
        rosterId: rosterId,
        originalRosterId: originalRosterId,
        propertyId: propertyId,
        offeredTradeOfferId: offeredTradeOfferId,
        requestedTradeOfferId: requestedTradeOfferId,
        managerId: managerId,
        workableInjury: workableInjury,
        fatigue: fatigue
    };
}
async function $cd18846a21e57ea1$export$7af850a215c050ef(superstar) {
    let superstarData = JSON.parse(JSON.stringify(superstar));
    superstarData["championships"] = await $cd18846a21e57ea1$export$e449ece5a3fcb618(superstar);
    return superstarData;
}
function $cd18846a21e57ea1$export$ae954500c84976fd(superstar, championships) {
    championships.forEach((c)=>{
        c.superstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$527e96790eb9dc94(superstar, championships) {
    championships.forEach((c)=>{
        c.superstarId = null;
    });
}
function $cd18846a21e57ea1$export$e449ece5a3fcb618(superstar) {
    return (0, $14eBR.Championships).find({
        "superstarId": superstar.$loki
    });
}
async function $cd18846a21e57ea1$export$884e2c0b6d318c32(superstar) {
    const tagTeamHashes = await (0, $14eBR.TagTeamsHash).find({
        "superstarId": superstar.$loki
    });
    const tagTeamIds = tagTeamHashes.map((x)=>{
        return x.tagTeamId;
    });
    return (0, $14eBR.TagTeams).find({
        "$loki": {
            "$in": tagTeamIds
        }
    });
}
async function $cd18846a21e57ea1$export$f1699b2e83d0161e(superstar) {
    const matchHashes = await (0, $14eBR.MatchesHash).find({
        "superstarId": superstar.$loki
    });
    const matchIds = matchHashes.map((x)=>{
        return x.matchId;
    });
    return (0, $14eBR.Matches).find({
        "$loki": {
            "$in": matchIds
        }
    });
}
function $cd18846a21e57ea1$export$b0db48d2aa602b31(superstar) {
    return (0, $14eBR.Rosters).find({
        "$loki": superstar.rosterId
    })[0];
}
function $cd18846a21e57ea1$export$9b97b0d72ad3dbce(superstar) {
    return (0, $14eBR.Rosters).find({
        "$loki": superstar.originalRosterId
    })[0];
}
async function $cd18846a21e57ea1$export$91eebd3b42e96e13(superstar) {
    const factionHashes = await (0, $14eBR.FactionsHash).find({
        "superstarId": superstar.$loki
    });
    const factionIds = factionHashes.map((x)=>{
        return x.factionId;
    });
    return (0, $14eBR.Factions).find({
        "$loki": {
            "$in": factionIds
        }
    });
}
function $cd18846a21e57ea1$export$cc19acd0cc968d4c(superstar) {
    return (0, $14eBR.Factions).find({
        "leaderSuperstarId": superstar.$loki
    });
}
function $cd18846a21e57ea1$export$b092468d3a905e25(superstar, championshipReigns) {
    championshipReigns.forEach((c)=>{
        c.superstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$4f504bb1316dfbf5(superstar, championshipReigns) {
    championshipReigns.forEach((c)=>{
        c.superstarId = null;
    });
}
function $cd18846a21e57ea1$export$6d8d4bbff3588885(superstar) {
    return (0, $14eBR.ChampionshipReigns).find({
        "superstarId": superstar.$loki
    });
}
function $cd18846a21e57ea1$export$d8e5c27001bcffa1(superstar) {
    return (0, $14eBR.Properties).find({
        "$loki": superstar.propertyId
    })[0];
}
function $cd18846a21e57ea1$export$873dbb6189b226c1(superstar, relationships) {
    relationships.forEach((c)=>{
        c.superstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$45f392641fc16ce7(superstar, relationships) {
    relationships.forEach((c)=>{
        c.superstarId = null;
    });
}
function $cd18846a21e57ea1$export$b528499420266afa(superstar) {
    return (0, $14eBR.Relationships).find({
        "superstarId": superstar.$loki
    });
}
function $cd18846a21e57ea1$export$39b837b53c3c87e4(superstar, matchContracts) {
    matchContracts.forEach((c)=>{
        c.superstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$c8c38bce04d2d3f(superstar, matchContracts) {
    matchContracts.forEach((c)=>{
        c.superstarId = null;
    });
}
function $cd18846a21e57ea1$export$7d3f846b12835687(superstar) {
    return (0, $14eBR.MatchContracts).find({
        "superstarId": superstar.$loki
    });
}
function $cd18846a21e57ea1$export$9bc78f9aac3fb6e8(superstar, streaks) {
    streaks.forEach((c)=>{
        c.superstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$56c53acda7a2a0f5(superstar, streaks) {
    streaks.forEach((c)=>{
        c.superstarId = null;
    });
}
function $cd18846a21e57ea1$export$1c39f7476c699659(superstar) {
    return (0, $14eBR.Streaks).find({
        "superstarId": superstar.$loki
    });
}
function $cd18846a21e57ea1$export$6728b9e1da0826c1(superstar, tournaments) {
    tournaments.forEach((c)=>{
        c.winnerSuperstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$70d5ad78c937d09c(superstar, tournaments) {
    tournaments.forEach((c)=>{
        c.winnerSuperstarId = null;
    });
}
function $cd18846a21e57ea1$export$40d25ab404f26c89(superstar) {
    return (0, $14eBR.Tournaments).find({
        "winnerSuperstarId": superstar.$loki
    });
}
function $cd18846a21e57ea1$export$758f0a0a5b1c2a5(superstar, gimmicks) {
    gimmicks.forEach((c)=>{
        c.superstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$1bc8592af11e45f4(superstar, gimmicks) {
    gimmicks.forEach((c)=>{
        c.superstarId = null;
    });
}
function $cd18846a21e57ea1$export$1a25e98a8cf6ac18(superstar) {
    return (0, $14eBR.Gimmicks).find({
        "superstarId": superstar.$loki
    });
}
function $cd18846a21e57ea1$export$8045f8ee5d8e4386(superstar) {
    return (0, $14eBR.Gimmicks).find({
        "superstarId": superstar.$loki
    }).reverse()[0];
}
function $cd18846a21e57ea1$export$8b6ee52b2c4b57b4(superstar, randomEvents) {
    randomEvents.forEach((c)=>{
        c.superstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$f85b8d3b06d0c20f(superstar, randomEvents) {
    randomEvents.forEach((c)=>{
        c.superstarId = null;
    });
}
function $cd18846a21e57ea1$export$c6ede37f1f0b0ed0(superstar) {
    return (0, $14eBR.RandomEvents).find({
        "superstarId": superstar.$loki
    });
}
function $cd18846a21e57ea1$export$8efc2222ecfaec65(superstar, staff) {
    staff.forEach((c)=>{
        c.superstarObjectId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$4a52bf5ec86566b5(superstar, staff) {
    staff.forEach((c)=>{
        c.superstarObjectId = null;
    });
}
function $cd18846a21e57ea1$export$596716fcab13f66(superstar) {
    return (0, $14eBR.StaffMembers).find({
        "superstarObjectId": superstar.$loki
    })[0];
}
function $cd18846a21e57ea1$export$894bdf172564e9a6(superstar, negotiations) {
    negotiations.forEach((c)=>{
        c.superstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$5ac18701647a7cf0(superstar, negotiations) {
    negotiations.forEach((c)=>{
        c.superstarId = null;
    });
}
function $cd18846a21e57ea1$export$78e746c55dc35e94(superstar) {
    return (0, $14eBR.Negotiations).find({
        "superstarId": superstar.$loki
    });
}
function $cd18846a21e57ea1$export$d525531e1b380c8e(superstar, talentRequests) {
    talentRequests.forEach((c)=>{
        c.superstarId = superstar.$loki;
    });
}
function $cd18846a21e57ea1$export$20e81083af7afd9a(superstar, talentRequests) {
    talentRequests.forEach((c)=>{
        c.superstarId = null;
    });
}
function $cd18846a21e57ea1$export$c6dd79f1b8c2baa8(superstar) {
    return (0, $14eBR.TalentRequests).find({
        "superstarId": superstar.$loki
    });
}
async function $cd18846a21e57ea1$export$1ad7bbcde28f3749(superstar) {
    const feudHashes = await (0, $14eBR.FeudParticipantsHash).find({
        "superstarId": superstar.$loki
    });
    const feudIds = feudHashes.map((x)=>{
        return x.feudId;
    });
    return (0, $14eBR.Feuds).find({
        "$loki": {
            "$in": feudIds
        }
    });
}
function $cd18846a21e57ea1$export$5a8662b6afb9c471(superstar, manager) {
    superstar.managerId = manager.$loki;
}
function $cd18846a21e57ea1$export$7a921220e3b8020b(superstar) {
    superstar.managerId = null;
}
function $cd18846a21e57ea1$export$7dcffdf512088476(superstar) {
    if (!superstar.managerId) return;
    return (0, $14eBR.Superstars).find({
        "$loki": superstar.managerId
    })[0];
}
function $cd18846a21e57ea1$export$fc0a663b83757c93(superstar) {
    return (0, $14eBR.Superstars).find({
        "managerId": superstar.$loki
    });
}

});

parcelRequire.register("972Ip", function(module, exports) {

$parcel$export(module.exports, "TagTeam", () => $6a26dfb56aa8b73e$export$6c6c5f71aac72646);
$parcel$export(module.exports, "getTagTeamSuperstars", () => $6a26dfb56aa8b73e$export$e76ce022de5b8ff1);
$parcel$export(module.exports, "addTagTeam", () => $6a26dfb56aa8b73e$export$3ef2f9b3e8234d9f);
$parcel$export(module.exports, "addTagTeamSuperstars", () => $6a26dfb56aa8b73e$export$edb4c7706dd39f7f);
$parcel$export(module.exports, "removeTagTeamSuperstars", () => $6a26dfb56aa8b73e$export$9cd384240edd97b8);
$parcel$export(module.exports, "removeSuperstarFromTagTeam", () => $6a26dfb56aa8b73e$export$20bc85c0a8465ce3);
$parcel$export(module.exports, "getTagTeamMatches", () => $6a26dfb56aa8b73e$export$aeb2091ec1b9eedf);
$parcel$export(module.exports, "addTagTeamMatchContracts", () => $6a26dfb56aa8b73e$export$cdbab10ac4d177dd);
$parcel$export(module.exports, "addTagTeamStreaks", () => $6a26dfb56aa8b73e$export$9d4395da2c4a8574);
$parcel$export(module.exports, "getTagTeamStreaks", () => $6a26dfb56aa8b73e$export$14b12d5146f03872);
$parcel$export(module.exports, "addTagTeamWonTournaments", () => $6a26dfb56aa8b73e$export$ecf0cb5b59c43c5d);
$parcel$export(module.exports, "getTagTeamWonTournaments", () => $6a26dfb56aa8b73e$export$8fd32dcbad05abff);
$parcel$export(module.exports, "addTagTeamNegotiations", () => $6a26dfb56aa8b73e$export$a10909545d585656);
$parcel$export(module.exports, "getTagTeamNegotiations", () => $6a26dfb56aa8b73e$export$99e68cbad5ed3a0c);
$parcel$export(module.exports, "addTagTeamTalentRequests", () => $6a26dfb56aa8b73e$export$fc3814c651a687c3);
$parcel$export(module.exports, "getTagTeamFeuds", () => $6a26dfb56aa8b73e$export$8e9233b56f430b28);
$parcel$export(module.exports, "getTagTeamRoster", () => $6a26dfb56aa8b73e$export$2160bffb9c4b0a25);

var $hBIDz = parcelRequire("hBIDz");

var $14eBR = parcelRequire("14eBR");
function $6a26dfb56aa8b73e$export$6c6c5f71aac72646(name, temporary = false, trio = false) {
    // Booleans
    const trioTagTeam = false;
    const factionTagTeam = false;
    const objectName = "tagTeam";
    // Integer
    const winsCounter = 0;
    const lossesCounter = 0;
    const wins = 0;
    const losses = 0;
    const winsTemporary = 0;
    const lossesTemporary = 0;
    const tournamentSeed = null;
    const tournamentPoints = null;
    // Foreign keys
    const rosterId = null;
    // Pronouns
    const pronoun = "they";
    const possessivePronoun = "their";
    const objectivePronoun = "them";
    return {
        name: name,
        objectName: objectName,
        temporary: temporary,
        trio: trio,
        trioTagTeam: trioTagTeam,
        factionTagTeam: factionTagTeam,
        winsCounter: winsCounter,
        lossesCounter: lossesCounter,
        wins: wins,
        losses: losses,
        winsTemporary: winsTemporary,
        lossesTemporary: lossesTemporary,
        tournamentSeed: tournamentSeed,
        tournamentPoints: tournamentPoints,
        rosterId: rosterId,
        pronoun: pronoun,
        possessivePronoun: possessivePronoun,
        objectivePronoun: objectivePronoun
    };
}
async function $6a26dfb56aa8b73e$export$674ecb1554e3f59e(tagTeam) {
    let tagTeamData = JSON.parse(JSON.stringify(tagTeam));
    let tagTeamSuperstars = await $6a26dfb56aa8b73e$export$e76ce022de5b8ff1(tagTeam);
    tagTeamData["superstars"] = await Promise.all(tagTeamSuperstars.map((s)=>(0, $hBIDz.getSuperstarData)(s)));
    return tagTeamData;
}
async function $6a26dfb56aa8b73e$export$3ef2f9b3e8234d9f(name, superstars, trio = false, temporary = false) {
    // Create tagTeam, add superstars
    let tagTeam = $6a26dfb56aa8b73e$export$6c6c5f71aac72646(name, temporary, trio);
    (0, $14eBR.TagTeams).insert(tagTeam);
    $6a26dfb56aa8b73e$export$edb4c7706dd39f7f(tagTeam, superstars);
    return tagTeam;
}
function $6a26dfb56aa8b73e$export$edb4c7706dd39f7f(tagTeam, superstars) {
    let tagTeamHashes = superstars.map((s)=>{
        return {
            tagTeamId: tagTeam.$loki,
            superstarId: s.$loki
        };
    });
    return (0, $14eBR.TagTeamsHash).insert(tagTeamHashes);
}
async function $6a26dfb56aa8b73e$export$9cd384240edd97b8(tagTeam) {
    return (0, $14eBR.TagTeamsHash).findAndRemove({
        "tagTeamId": tagTeam.$loki
    });
}
async function $6a26dfb56aa8b73e$export$20bc85c0a8465ce3(tagTeam, superstar) {
    return (0, $14eBR.TagTeamsHash).findAndRemove({
        "tagTeamId": tagTeam.$loki,
        "superstarId": superstar.$loki
    });
}
async function $6a26dfb56aa8b73e$export$e76ce022de5b8ff1(tagTeam) {
    const tagTeamHashes = (0, $14eBR.TagTeamsHash).find({
        "tagTeamId": tagTeam.$loki
    });
    const superstarIds = tagTeamHashes.map((x)=>{
        return x.superstarId;
    });
    return (0, $14eBR.Superstars).find({
        "$loki": {
            "$in": superstarIds
        }
    });
}
async function $6a26dfb56aa8b73e$export$aeb2091ec1b9eedf(tagTeam) {
    const matchHashes = (0, $14eBR.MatchesHash).find({
        "tagTeamId": tagTeam.$loki
    });
    const matchIds = matchHashes.map((x)=>{
        return x.matchId;
    });
    return (0, $14eBR.Matches).find({
        "$loki": {
            "$in": matchIds
        }
    });
}
function $6a26dfb56aa8b73e$export$cdbab10ac4d177dd(tagTeam, matchContracts) {
    matchContracts.forEach((c)=>{
        c.tagTeamId = tagTeam.$loki;
    });
}
function $6a26dfb56aa8b73e$export$4ac485d0afc38c65(tagTeam, matchContracts) {
    matchContracts.forEach((c)=>{
        c.tagTeamId = null;
    });
}
function $6a26dfb56aa8b73e$export$ec85523987f6954a(tagTeam) {
    return (0, $14eBR.MatchContracts).find({
        "tagTeamId": tagTeam.$loki
    });
}
function $6a26dfb56aa8b73e$export$9d4395da2c4a8574(tagTeam, streaks) {
    streaks.forEach((c)=>{
        c.tagTeamId = tagTeam.$loki;
    });
}
function $6a26dfb56aa8b73e$export$45fe7ce7149a4f41(tagTeam, streaks) {
    streaks.forEach((c)=>{
        c.tagTeamId = null;
    });
}
function $6a26dfb56aa8b73e$export$14b12d5146f03872(tagTeam) {
    return (0, $14eBR.Streaks).find({
        "tagTeamId": tagTeam.$loki
    });
}
function $6a26dfb56aa8b73e$export$ecf0cb5b59c43c5d(tagTeam, tournaments) {
    tournaments.forEach((c)=>{
        c.winnerTagTeamId = tagTeam.$loki;
    });
}
function $6a26dfb56aa8b73e$export$aef184837cf268a0(tagTeam, tournaments) {
    tournaments.forEach((c)=>{
        c.winnerTagTeamId = null;
    });
}
function $6a26dfb56aa8b73e$export$8fd32dcbad05abff(tagTeam) {
    return (0, $14eBR.Tournaments).find({
        "winnerTagTeamId": tagTeam.$loki
    });
}
function $6a26dfb56aa8b73e$export$a10909545d585656(tagTeam, negotiations) {
    negotiations.forEach((c)=>{
        c.tagTeamId = tagTeam.$loki;
    });
}
function $6a26dfb56aa8b73e$export$4ebbdd4b428b549c(tagTeam, negotiations) {
    negotiations.forEach((c)=>{
        c.tagTeamId = null;
    });
}
function $6a26dfb56aa8b73e$export$99e68cbad5ed3a0c(tagTeam) {
    return (0, $14eBR.Negotiations).find({
        "tagTeamId": tagTeam.$loki
    });
}
function $6a26dfb56aa8b73e$export$fc3814c651a687c3(tagTeam, talentRequests) {
    talentRequests.forEach((c)=>{
        c.tagTeamId = tagTeam.$loki;
    });
}
function $6a26dfb56aa8b73e$export$8abe08701398d072(tagTeam, talentRequests) {
    talentRequests.forEach((c)=>{
        c.tagTeamId = null;
    });
}
function $6a26dfb56aa8b73e$export$68f76c06c8a4ba6b(tagTeam) {
    return (0, $14eBR.TalentRequests).find({
        "tagTeamId": tagTeam.$loki
    });
}
async function $6a26dfb56aa8b73e$export$8e9233b56f430b28(tagTeam) {
    const feudHashes = (0, $14eBR.FeudParticipantsHash).find({
        "tagTeamId": tagTeam.$loki
    });
    const feudIds = feudHashes.map((x)=>{
        return x.feudId;
    });
    return (0, $14eBR.Feuds).find({
        "$loki": {
            "$in": feudIds
        }
    });
}
function $6a26dfb56aa8b73e$export$2160bffb9c4b0a25(tagTeam) {
    return (0, $14eBR.Rosters).find({
        "$loki": tagTeam.rosterId
    })[0];
}

});

parcelRequire.register("dl5u4", function(module, exports) {

$parcel$export(module.exports, "Roster", () => $9b617d893e32e4a5$export$2a17e8c4ca64b732);
$parcel$export(module.exports, "getRosterSuperstars", () => $9b617d893e32e4a5$export$e328bbafb7a022b9);
$parcel$export(module.exports, "addRosterSuperstars", () => $9b617d893e32e4a5$export$4404d9babd7423bb);
$parcel$export(module.exports, "removeRosterSuperstars", () => $9b617d893e32e4a5$export$5f5f715a24e30dc0);
$parcel$export(module.exports, "getRosterTagTeams", () => $9b617d893e32e4a5$export$aa738c833776c533);
$parcel$export(module.exports, "addRosterTagTeams", () => $9b617d893e32e4a5$export$45715b999e15a5bf);
$parcel$export(module.exports, "addRosterOriginalSuperstars", () => $9b617d893e32e4a5$export$d1267b6504979626);
$parcel$export(module.exports, "getRosterCompany", () => $9b617d893e32e4a5$export$f0249058c8a80d8f);
$parcel$export(module.exports, "getRosterBrands", () => $9b617d893e32e4a5$export$5fd324db6d215b9a);
$parcel$export(module.exports, "addRosterBrands", () => $9b617d893e32e4a5$export$21e416c6a8fe0b83);
$parcel$export(module.exports, "removeRosterBrands", () => $9b617d893e32e4a5$export$5c23fa8cbbcf8d46);
$parcel$export(module.exports, "getRosterFactions", () => $9b617d893e32e4a5$export$3158cd7407aa428f);
$parcel$export(module.exports, "addRosterFactions", () => $9b617d893e32e4a5$export$a702394bf21b1731);
$parcel$export(module.exports, "getRosterFeuds", () => $9b617d893e32e4a5$export$c7a64c833d8ed04a);
$parcel$export(module.exports, "addRosterFeuds", () => $9b617d893e32e4a5$export$4309e1569b7e2a60);
$parcel$export(module.exports, "getRosterGimmicks", () => $9b617d893e32e4a5$export$c00bf8eee625933e);
$parcel$export(module.exports, "addRosterGimmicks", () => $9b617d893e32e4a5$export$2fbfe1738c5e3893);
$parcel$export(module.exports, "getRosterStaff", () => $9b617d893e32e4a5$export$e1ecbd10f6918e8b);
$parcel$export(module.exports, "addRosterStaff", () => $9b617d893e32e4a5$export$2427047c6c813cc);
$parcel$export(module.exports, "removeRosterStaff", () => $9b617d893e32e4a5$export$502da0735eeaea36);

var $14eBR = parcelRequire("14eBR");
function $9b617d893e32e4a5$export$2a17e8c4ca64b732(type) {
    // Foreign keys
    const companyId = null;
    const draftId = null;
    const currentDraftPickId = null;
    return {
        type: type,
        companyId: companyId,
        draftId: draftId,
        currentDraftPickId: currentDraftPickId
    };
}
function $9b617d893e32e4a5$export$e328bbafb7a022b9(roster) {
    return (0, $14eBR.Superstars).find({
        "rosterId": roster.$loki
    });
}
function $9b617d893e32e4a5$export$4404d9babd7423bb(roster, superstars) {
    superstars.forEach((c)=>{
        c.rosterId = roster.$loki;
    });
}
function $9b617d893e32e4a5$export$5f5f715a24e30dc0(roster, superstars) {
    superstars.forEach((c)=>{
        c.rosterId = null;
    });
}
function $9b617d893e32e4a5$export$aa738c833776c533(roster) {
    return (0, $14eBR.TagTeams).find({
        "rosterId": roster.$loki
    });
}
function $9b617d893e32e4a5$export$45715b999e15a5bf(roster, tagTeams) {
    tagTeams.forEach((c)=>{
        c.rosterId = roster.$loki;
    });
}
function $9b617d893e32e4a5$export$1fc4f0cd3bd0b1fa(roster, tagTeams) {
    tagTeams.forEach((c)=>{
        c.rosterId = null;
    });
}
function $9b617d893e32e4a5$export$2d82c3895b767a14(roster) {
    return (0, $14eBR.Superstars).find({
        "originalRosterId": roster.$loki
    });
}
function $9b617d893e32e4a5$export$d1267b6504979626(roster, superstars) {
    superstars.forEach((c)=>{
        c.originalRosterId = roster.$loki;
    });
}
function $9b617d893e32e4a5$export$37849d2ad6ec3f73(roster, superstars) {
    superstars.forEach((c)=>{
        c.originalRosterId = null;
    });
}
function $9b617d893e32e4a5$export$f0249058c8a80d8f(roster) {
    return (0, $14eBR.Companies).find({
        "$loki": roster.companyId
    })[0];
}
function $9b617d893e32e4a5$export$5fd324db6d215b9a(roster) {
    return (0, $14eBR.Brands).find({
        "rosterId": roster.$loki
    });
}
function $9b617d893e32e4a5$export$21e416c6a8fe0b83(roster, brands) {
    brands.forEach((c)=>{
        c.rosterId = roster.$loki;
    });
}
function $9b617d893e32e4a5$export$5c23fa8cbbcf8d46(roster, brands) {
    brands.forEach((c)=>{
        c.rosterId = null;
    });
}
function $9b617d893e32e4a5$export$3158cd7407aa428f(roster) {
    return (0, $14eBR.Factions).find({
        "rosterId": roster.$loki
    });
}
function $9b617d893e32e4a5$export$a702394bf21b1731(roster, factions) {
    factions.forEach((c)=>{
        c.rosterId = roster.$loki;
    });
}
function $9b617d893e32e4a5$export$ecdb3cf8f7f3e8b3(roster, factions) {
    factions.forEach((c)=>{
        c.rosterId = null;
    });
}
function $9b617d893e32e4a5$export$c7a64c833d8ed04a(roster) {
    return (0, $14eBR.Feuds).find({
        "rosterId": roster.$loki
    });
}
function $9b617d893e32e4a5$export$4309e1569b7e2a60(roster, feuds) {
    feuds.forEach((c)=>{
        c.rosterId = roster.$loki;
    });
}
function $9b617d893e32e4a5$export$42fca16907b0e24e(roster, feuds) {
    feuds.forEach((c)=>{
        c.rosterId = null;
    });
}
function $9b617d893e32e4a5$export$c00bf8eee625933e(roster) {
    return (0, $14eBR.Gimmicks).find({
        "rosterId": roster.$loki
    });
}
function $9b617d893e32e4a5$export$2fbfe1738c5e3893(roster, gimmicks) {
    gimmicks.forEach((c)=>{
        c.rosterId = roster.$loki;
    });
}
function $9b617d893e32e4a5$export$a9cf56a0c3f57edd(roster, gimmicks) {
    gimmicks.forEach((c)=>{
        c.rosterId = null;
    });
}
function $9b617d893e32e4a5$export$e1ecbd10f6918e8b(roster) {
    return (0, $14eBR.StaffMembers).find({
        "rosterId": roster.$loki
    });
}
function $9b617d893e32e4a5$export$2427047c6c813cc(roster, staff) {
    staff.forEach((c)=>{
        c.rosterId = roster.$loki;
    });
}
function $9b617d893e32e4a5$export$502da0735eeaea36(roster, staff) {
    staff.forEach((c)=>{
        c.rosterId = null;
    });
}
function $9b617d893e32e4a5$var$getRosterDraft(roster) {
    return (0, $14eBR.Drafts).find({
        "$loki": roster.draftId
    })[0];
}

});

parcelRequire.register("4ptHI", function(module, exports) {

$parcel$export(module.exports, "getSpecialSegmentsData", () => $336089d6be28ba1c$export$83d949bd6a96ade2);
$parcel$export(module.exports, "getSegmentItemData", () => $336089d6be28ba1c$export$23fb60f0ecbfea2f);
$parcel$export(module.exports, "getSpecialSegmentHistoryData", () => $336089d6be28ba1c$export$6604a4c3d3e82226);
$parcel$export(module.exports, "getSegmentData", () => $336089d6be28ba1c$export$7d69ed11e8e03a89);
$parcel$export(module.exports, "getSegmentHistoryData", () => $336089d6be28ba1c$export$6c4cc1caa3100962);
$parcel$export(module.exports, "getAvailableSegmentItems", () => $336089d6be28ba1c$export$f427e285419d35e2);
$parcel$export(module.exports, "createCustomProductionPackage", () => $336089d6be28ba1c$export$f152999265c43d70);
$parcel$export(module.exports, "checkSegmentItemRequirement", () => $336089d6be28ba1c$export$e22daf9fc2c7de3);
$parcel$export(module.exports, "getSegmentInputsData", () => $336089d6be28ba1c$export$502fa564e22c7ca4);
$parcel$export(module.exports, "getSegmentName", () => $336089d6be28ba1c$export$4adfda27a8a9a2a5);
$parcel$export(module.exports, "bookSegment", () => $336089d6be28ba1c$export$e6121a3f40ff8960);
$parcel$export(module.exports, "getSegmentConsequenceAppliedTo", () => $336089d6be28ba1c$export$ec82fc9f5436dff2);
$parcel$export(module.exports, "getHypeForSegment", () => $336089d6be28ba1c$export$9bc052c1baf11858);
$parcel$export(module.exports, "getHypeForFeuds", () => $336089d6be28ba1c$export$7b5a40f91c0455f2);
$parcel$export(module.exports, "getHypeForParticipants", () => $336089d6be28ba1c$export$c072c73f0c7fcfce);
$parcel$export(module.exports, "deleteCompanySegment", () => $336089d6be28ba1c$export$6a7d693a7b69a150);
$parcel$export(module.exports, "deleteSegment", () => $336089d6be28ba1c$export$b68702c79c55865d);
$parcel$export(module.exports, "addProducerToSegment", () => $336089d6be28ba1c$export$11723d5430c81fe3);
$parcel$export(module.exports, "removeProducerFromSegment", () => $336089d6be28ba1c$export$6f980415cfe88d34);
$parcel$export(module.exports, "playSegment", () => $336089d6be28ba1c$export$cb564f394db2944f);
$parcel$export(module.exports, "processPlaySegment", () => $336089d6be28ba1c$export$1387bd61f30c74fa);
$parcel$export(module.exports, "updateSuperstarCharisma", () => $336089d6be28ba1c$export$23c1e265430766ca);
$parcel$export(module.exports, "checkProducerSegmentItemsToUnlock", () => $336089d6be28ba1c$export$ae201c4048d23331);
$parcel$export(module.exports, "introduceSpecialSegmentsView", () => $336089d6be28ba1c$export$7006eaf6af085e61);
$parcel$export(module.exports, "introduceSpecialSegments", () => $336089d6be28ba1c$export$1c0ab3fd8489739d);

var $98xmD = parcelRequire("98xmD");

var $cMrnz = parcelRequire("cMrnz");

var $14eBR = parcelRequire("14eBR");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $9esFv = parcelRequire("9esFv");

var $6RCLU = parcelRequire("6RCLU");

var $eg5dz = parcelRequire("eg5dz");

var $iQtzn = parcelRequire("iQtzn");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $cXLSF = parcelRequire("cXLSF");

var $5ZsVo = parcelRequire("5ZsVo");

var $972Ip = parcelRequire("972Ip");

var $5kTkA = parcelRequire("5kTkA");

var $ko5kE = parcelRequire("ko5kE");

var $1JkT6 = parcelRequire("1JkT6");

var $kZwpB = parcelRequire("kZwpB");

var $jDtEn = parcelRequire("jDtEn");

var $hBIDz = parcelRequire("hBIDz");

var $6PzHO = parcelRequire("6PzHO");

var $ycsyu = parcelRequire("ycsyu");

var $2JFAd = parcelRequire("2JFAd");

var $ivuOU = parcelRequire("ivuOU");

var $3SyPM = parcelRequire("3SyPM");

var $4K85d = parcelRequire("4K85d");

var $1olyO = parcelRequire("1olyO");

var $aP7lq = parcelRequire("aP7lq");

var $kZMqI = parcelRequire("kZMqI");

var $hekDR = parcelRequire("hekDR");

var $iWkAo = parcelRequire("iWkAo");

var $jpMCP = parcelRequire("jpMCP");

var $i7bmn = parcelRequire("i7bmn");

var $9MKdC = parcelRequire("9MKdC");

var $im36F = parcelRequire("im36F");

var $1Dp0h = parcelRequire("1Dp0h");

var $1AAHK = parcelRequire("1AAHK");

var $8bQDO = parcelRequire("8bQDO");

var $kpu3X = parcelRequire("kpu3X");

var $bZol7 = parcelRequire("bZol7");

var $jC7EP = parcelRequire("jC7EP");

var $3MfBd = parcelRequire("3MfBd");
async function $336089d6be28ba1c$export$83d949bd6a96ade2() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    if (userCompany.storyName === "mars") return {
        "error": "wom"
    };
    // Get special segments
    const specialSegments = (await (0, $9esFv.getCompanySegmentItems)(userCompany)).filter((x)=>x.special);
    // Get data
    return Promise.all(specialSegments.map((x)=>$336089d6be28ba1c$export$23fb60f0ecbfea2f(x, true)));
}
async function $336089d6be28ba1c$export$23fb60f0ecbfea2f(segmentItem, checkBooked = false) {
    const baseHypes = {
        1: 3,
        2: 8,
        3: 15
    };
    const basePopularities = {
        1: 5,
        2: 10,
        3: 18
    };
    // Copy data
    let data = JSON.parse(JSON.stringify(segmentItem));
    data["uid"] = segmentItem.$loki;
    data["hypeBoost"] = baseHypes[segmentItem.hypeBoost] || 0;
    data["popularityBoost"] = basePopularities[segmentItem.popularityBoost] || 0;
    // Check if special segment was booked, for viewing history
    if (checkBooked) data["booked"] = (await (0, $cMrnz.getSegmentItemSegments)(segmentItem)).filter((x)=>x.rating !== null).length > 0;
    return data;
}
async function $336089d6be28ba1c$export$6604a4c3d3e82226(uid) {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const company = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    const segmentItem = await (0, $14eBR.SegmentItems).get(uid);
    const segment = (await (0, $cMrnz.getSegmentItemSegments)(segmentItem)).filter((x)=>x.rating !== null).reverse()[0];
    let participants = await (0, $eg5dz.getSegmentParticipants)(segment);
    // Get segment data
    data["name"] = segmentItem.name;
    data["segmentType"] = "segment";
    data["special"] = segmentItem.special;
    data["uid"] = segment.$loki;
    // Get pronouns
    data["pronouns"] = [];
    for (const p of participants)data["pronouns"].push({
        "name": p.name,
        "pronoun": (0, $3E8Nt.getRosterMemberPronoun)(p),
        "possessivePronoun": (0, $3E8Nt.getRosterMemberPronoun)(p, "possessive"),
        "objectivePronoun": (0, $3E8Nt.getRosterMemberPronoun)(p, "objective")
    });
    // Add graphics for participants
    data["graphics"] = participants.map((x)=>(0, $5kTkA.getGraphicForSuperstar)(x));
    // Add special segment data
    const superstarRandom = new Math.seedrandom(participants[0].meta.created);
    if (segmentItem.name === "Timely Rescue") {
        // Get a staff member's data
        const staffMembers = await (0, $9esFv.getCompanyStaff)(company);
        const availableStaffMembers = (0, $8A6FL.getAvailableStaffMembers)(staffMembers);
        let staffMember;
        if (staffMembers.length > 0) {
            if (availableStaffMembers.length > 0) staffMember = (0, $3E8Nt.getRandomChoice)(availableStaffMembers, superstarRandom());
            else staffMember = (0, $3E8Nt.getRandomChoice)(staffMembers, superstarRandom());
        } else {
            // Generate if none found
            const generatedStaffGender = (0, $3E8Nt.getRandomChoice)([
                "male",
                "female",
                "non-binary"
            ]);
            staffMember = {
                "name": (0, $8bQDO.generateStaffName)(null, generatedStaffGender),
                "gender": generatedStaffGender,
                "graphic": (0, $8bQDO.generateStaffGraphic)(generatedStaffGender)
            };
        }
        data["pronouns"].push({
            "name": staffMember.name,
            "pronoun": (0, $3E8Nt.getRosterMemberPronoun)(staffMember),
            "possessivePronoun": (0, $3E8Nt.getRosterMemberPronoun)(staffMember, "possessive"),
            "objectivePronoun": (0, $3E8Nt.getRosterMemberPronoun)(staffMember, "objective")
        });
        data["graphics"].push((0, $8A6FL.getStaffMemberGraphic)(staffMember));
    }
    if (segmentItem.name === "Celebrity Beatdown") {
        // Get a celebrity's data
        const celebrity = (0, $3E8Nt.getRandomChoice)((0, $1JkT6.specialSegmentCelebritiesData), superstarRandom());
        data["pronouns"].push({
            "name": celebrity["name"],
            "possessivePronoun": celebrity["possessivePronoun"]
        });
    }
    if (segmentItem.name === "Love Making") {
        // Get partner's pronoun
        const participantPronoun = participants[0].pronoun;
        let partnerPronoun;
        if ((0, $3E8Nt.getRandomInt)(0, 100, superstarRandom()) <= 16) partnerPronoun = participantPronoun;
        else {
            if (participantPronoun === "he") partnerPronoun = "she";
            else if (participantPronoun === "she") partnerPronoun = "he";
            else partnerPronoun = (0, $3E8Nt.getRandomChoice)([
                "he",
                "she"
            ], superstarRandom());
        }
        data["pronouns"].push({
            "partnerPronoun": partnerPronoun
        });
    }
    if (segmentItem.name === "Helicopter Raid") {
        // Get a competitor's name
        const competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game);
        let competitorName;
        if (competitors.length > 0) competitorName = (0, $3E8Nt.getRandomChoice)(competitors, superstarRandom()).name;
        else competitorName = "our competitor";
        data["pronouns"].push({
            "name": competitorName
        });
    }
    return data;
}
async function $336089d6be28ba1c$export$7d69ed11e8e03a89({ segment: segment, pronouns: pronouns = false, play: play = false, history: history = false, rosterSuperstars: rosterSuperstars = null, producers: producers = null } = {}) {
    let data = {};
    const segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(segment);
    let company = await (0, $cMrnz.getSegmentItemCompany)(segmentItem);
    const segmentEvent = await (0, $eg5dz.getSegmentEvent)(segment);
    if (!company) company = await (0, $iQtzn.getEventCompany)(segmentEvent);
    const game = await (0, $9esFv.getCompanyGame)(company);
    let participants = await (0, $eg5dz.getSegmentParticipants)(segment);
    const segmentFeuds = await (0, $eg5dz.getSegmentFeuds)(segment);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    if (!rosterSuperstars) rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Get participants type
    if (participants.length > 0) data["participantsType"] = participants[participants.length - 1].objectName === "superstar" ? "singles" : "tag";
    // Get segment data
    data["name"] = segmentItem.name;
    data["rating"] = segment.rating;
    data["feuds"] = await Promise.all(segmentFeuds.map((x)=>(0, $cXLSF.getFeudData)(x, true)));
    data["participantsNumber"] = participants.length;
    data["segmentType"] = "segment";
    data["chooseWinner"] = segmentItem.chooseWinner;
    data["consequence"] = segmentItem.consequence;
    data["productionSegment"] = segmentItem.productionSegment;
    data["startTexts"] = segmentItem.startTexts;
    data["actionTexts"] = segmentItem.actionTexts;
    data["text"] = segmentItem.text;
    data["special"] = segmentItem.special;
    data["order"] = segment.order;
    data["hype"] = segment.hype;
    data["hidden"] = segment.hidden;
    data["uid"] = segment.$loki;
    data["consequenceAppliedTo"] = segment.consequenceAppliedTo;
    data["event"] = (0, $5ZsVo.getEventTitle)(segmentEvent);
    data["played"] = segment.rating !== null;
    // Get producer if assigned
    if (producers) {
        const segmentProducer = $336089d6be28ba1c$var$getSegmentProducer(segment, producers);
        if (segmentProducer) data["producerName"] = segmentProducer.name;
    }
    // Sort superstars for segments
    if (pronouns && !history) {
        data["pronouns"] = [];
        // Sort participants
        await $336089d6be28ba1c$var$sortSegmentParticipants(segment, participants, segmentItem, company, game);
        // Add pronoun data
        for (const p of participants)data["pronouns"].push({
            "name": p.name,
            "pronoun": (0, $3E8Nt.getRosterMemberPronoun)(p),
            "possessivePronoun": (0, $3E8Nt.getRosterMemberPronoun)(p, "possessive"),
            "objectivePronoun": (0, $3E8Nt.getRosterMemberPronoun)(p, "objective")
        });
        // Add extra pronouns
        const [extraPronounsData, usePatreonSuperstar] = await $336089d6be28ba1c$var$addSegmentExtraPronouns(data["pronouns"], segment, participants, segmentItem, mainRoster, company, game);
        data["pronouns"] = extraPronounsData;
        data["usePatreonSuperstar"] = usePatreonSuperstar;
    }
    // Get participants data
    data["graphics"] = [];
    data["participants"] = [];
    if (participants.length > 0 || history) {
        if (play) // Get all data when playing
        for (const x of participants){
            let participantData;
            if (x.objectName === "superstar") {
                participantData = await (0, $5kTkA.getSuperstarDisplayData)({
                    superstar: x,
                    getCurrentAttire: true,
                    managersUsed: segment.managersUsed,
                    rosterSuperstars: rosterSuperstars,
                    game: game
                });
                data["graphics"].push(participantData["graphic"]);
            } else {
                participantData = await (0, $ko5kE.getTagTeamDisplayData)({
                    tagTeam: x,
                    getCurrentAttire: true,
                    managersUsed: segment.managersUsed,
                    rosterSuperstars: rosterSuperstars
                });
                data["graphics"].push(...participantData["graphics"]);
            }
            data["participants"].push(participantData);
            // Add manager graphic
            for (const y of (await (0, $5kTkA.getRosterMemberSuperstars)(x))){
                const superstarManager = await (0, $5kTkA.getSuperstarManagerUsedForMatchOrSegment)(y, segment.managersUsed, rosterSuperstars);
                if (superstarManager) {
                    const superstarManagerGraphic = (0, $5kTkA.getSuperstarManagerGraphic)(superstarManager, y);
                    data["graphics"].push(superstarManagerGraphic);
                }
            }
        }
        else if (history) {
            // Get history data
            if (segment.participants) data["participants"] = segment.participants;
            else data["participants"] = participants.map((x)=>x.name);
            // Add manager names for participants in history
            data["participantsDetails"] = [];
            for (const x of participants){
                const managerNames = [];
                for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(x))){
                    const superstarManager = await (0, $5kTkA.getSuperstarManagerUsedForMatchOrSegment)(s, segment.managersUsed, rosterSuperstars);
                    if (superstarManager && !managerNames.includes(superstarManager.name)) managerNames.push(superstarManager.name);
                }
                data["participantsDetails"].push({
                    "name": x.name,
                    "managerNames": managerNames
                });
            }
            // Check for manager segment
            data["managerSegment"] = [
                "boost-managed-talent",
                "add-manager",
                "remove-manager",
                "remove-managed-talent"
            ].includes(segmentItem.consequence);
        } else // Get specific data for displaying in event card
        for (const x of participants){
            let participantData;
            if (x.objectName === "superstar") participantData = await (0, $5kTkA.getSuperstarMatchOrSegmentData)(x, [], segment.managersUsed, rosterSuperstars);
            else {
                const participantSuperstarsData = await Promise.all((await (0, $972Ip.getTagTeamSuperstars)(x)).map((y)=>(0, $5kTkA.getSuperstarMatchOrSegmentData)(y, [], segment.managersUsed, rosterSuperstars)));
                participantData = {
                    "name": x.name,
                    "members": participantSuperstarsData,
                    "uid": x.$loki
                };
            }
            data["participants"].push(participantData);
        }
        // Get team details
        if (!history && participants[0].objectName === "tagTeam") {
            data["teamType"] = participants[0].trio ? "trio" : "tag-team";
            data["largerTag"] = (await (0, $972Ip.getTagTeamSuperstars)(participants[0])).length;
        }
    }
    // Add consequence data pronouns
    if (segment.consequenceData && Object.keys(segment.consequenceData).length !== 0 && !history) data = await $336089d6be28ba1c$var$addSegmentConsequenceDataPronouns(data, segment, participants, segmentItem, mainRoster, pronouns, rosterSuperstars);
    // Add pronouns for special segments
    if (segmentItem.special && play && !history) data = await $336089d6be28ba1c$var$addSpecialSegmentPronouns(data, segment, participants, segmentItem, company, game);
    return data;
}
async function $336089d6be28ba1c$var$sortSegmentParticipants(segment, participants, segmentItem, company, game) {
    if ([
        "title-feud",
        "champion"
    ].includes(segmentItem.requirement)) {
        // Put champion last
        for (const x of participants){
            let participantChampionships = [];
            for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(x))){
                let superstarChampionships = (await (0, $hBIDz.getSuperstarChampionships)(s)).filter((y)=>!y.matchContract && !y.championshipContract);
                if (x.objectName === "superstar") superstarChampionships = superstarChampionships.filter((y)=>!y.trio && !y.tagTeam);
                else superstarChampionships = superstarChampionships.filter((y)=>y.trio === x.trio && y.tagTeam === !x.trio);
                participantChampionships.push(...superstarChampionships);
            }
            x.tempChampionships = participantChampionships;
        }
        participants.sort((a, b)=>a.tempChampionships.length - b.tempChampionships.length);
        for (const x of participants)delete x.tempChampionships;
    } else if (segmentItem.requirement === "contract-and-champion") {
        // Put contract holder first
        for (const x of participants){
            let participantChampionships = [];
            for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(x))){
                let superstarChampionships = (await (0, $hBIDz.getSuperstarChampionships)(s)).filter((y)=>y.championshipContract);
                if (x.objectName === "superstar") superstarChampionships = superstarChampionships.filter((y)=>!y.trio && !y.tagTeam);
                else superstarChampionships = superstarChampionships.filter((y)=>y.trio === x.trio && y.tagTeam === !x.trio);
                participantChampionships.push(...superstarChampionships);
            }
            x.tempChampionships = participantChampionships;
        }
        participants.sort((a, b)=>b.tempChampionships.length - a.tempChampionships.length);
        for (const x of participants)delete x.tempChampionships;
    } else if ([
        "legend",
        "legend-and-heel",
        "legend-and-over-superstar"
    ].includes(segmentItem.requirement)) participants.sort((a, b)=>a.hallOfFamer - b.hallOfFamer);
    else if (segmentItem.requirement === "award-winner") {
        const companyAwards = (await (0, $9esFv.getCompanyCompanyLogs)(company)).filter((x)=>x.type === "award" && x.value > 0);
        function checkAwardWinners(p) {
            for (const awardWon of companyAwards)if (awardWon.text.includes(p.name) && awardWon.realYear !== null) {
                const monthsPassed = (0, $3E8Nt.getMonthsDifference)(game.monthCount, game.year, awardWon.month, awardWon.realYear);
                if (monthsPassed < 3) return awardWon.$loki;
            }
            return null;
        }
        participants.sort((a, b)=>checkAwardWinners(b) - checkAwardWinners(a));
    } else if (segmentItem.requirement === "injured-partner-and-singles-superstar") {
        let participantInTeam;
        for (const x of participants){
            let t = (await (0, $hBIDz.getSuperstarTagTeams)(x)).find((y)=>!y.temporary && !y.trio);
            if (t) {
                participantInTeam = x;
                break;
            }
        }
        participants.sort((a)=>a.$loki === participantInTeam.$loki ? -1 : 1);
    } else if (segmentItem.requirement === "heels-vs-face-singles") participants.sort((a)=>a.alignment === "face" ? -1 : 1);
    else if (segmentItem.requirement === "retiring") {
        for (const x of participants)x.tempAge = await (0, $3E8Nt.getRosterMemberAge)(x);
        participants.sort((a, b)=>b.tempAge - a.tempAge);
        for (const x of participants)delete x.tempAge;
    } else if (segmentItem.requirement === "masked-talent") {
        // Put masked superstar first
        for (const x of participants)x.tempMasked = (await (0, $5kTkA.getRosterMemberSuperstars)(x)).every((y)=>(0, $5kTkA.checkSuperstarGraphicMask)(y.graphic));
        participants.sort((a, b)=>b.tempMasked - a.tempMasked);
        for (const x of participants)delete x.tempMasked;
    } else if (segmentItem.requirement === "new-talent") {
        const newSuperstarLogs = (await (0, $9esFv.getCompanyCompanyLogs)(company)).filter((x)=>[
                "signing",
                "callup",
                "new-superstar",
                "new-trade-superstar"
            ].includes(x.type));
        function checkNewSuperstars(p) {
            for (const newSuperstarLog of newSuperstarLogs)if (newSuperstarLog.text.includes(p.name) && newSuperstarLog.realYear !== null) {
                const monthsPassed = (0, $3E8Nt.getMonthsDifference)(game.monthCount, game.year, newSuperstarLog.month, newSuperstarLog.realYear);
                if (monthsPassed < 3) return newSuperstarLog.$loki;
            }
            return null;
        }
        participants.sort((a, b)=>checkNewSuperstars(b) - checkNewSuperstars(a));
    } else if (segmentItem.requirement === "returning-talent") {
        for (const x of participants)x.tempReadyToReturn = (await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.readyToReturn);
        participants.sort((a, b)=>b.tempReadyToReturn - a.tempReadyToReturn);
        for (const x of participants)delete x.tempReadyToReturn;
    } else if (segment.consequenceAppliedTo) {
        if (segmentItem.requirement === "face-vs-heel-past-feud") {
            const consequenceAppliedTo = participants.find((x)=>x.name === segment.consequenceAppliedTo);
            const remainingParticipants = participants.filter((x)=>x.$loki !== consequenceAppliedTo.$loki);
            const feuds = (await (0, $cXLSF.getRosterMemberFeuds)(consequenceAppliedTo)).filter((y)=>y.started && y.ended);
            // Find who saving superstar is feuding with (gets most recent feuds first)
            let feudingWith;
            for (const feud of feuds){
                const feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
                if (feudParticipants.length > 1 && feudParticipants.every((p)=>(0, $3E8Nt.objectInArray)(p, participants))) {
                    feudingWith = feudParticipants.find((x)=>(0, $3E8Nt.objectInArray)(x, remainingParticipants));
                    break;
                }
            }
            participants.sort((a, b)=>{
                if (a.name === segment.consequenceAppliedTo) return -1;
                else if (b.name === segment.consequenceAppliedTo) return 1;
                else if (b.$loki === feudingWith.$loki) return 1;
                else if (a.$loki === feudingWith.$loki) return -1;
                else return 0;
            });
        } else participants.sort((a)=>a.name !== segment.consequenceAppliedTo ? 1 : -1);
    }
}
async function $336089d6be28ba1c$var$addSegmentExtraPronouns(pronounsData, segment, participants, segmentItem, mainRoster, company, game) {
    let usePatreonSuperstar;
    // Add injured superstar (can't add injured superstars in booking, only can add in this segment)
    if (segmentItem.requirement === "inflicted-injury") {
        const injuries = (await (0, $9esFv.getCompanyCompanyLogs)(company)).filter((x)=>x.type === "injury").reverse();
        for (const y of participants){
            // Find participant name in injury logs
            const injuriesInflicted = injuries.filter((x)=>x.text.split(" injured ")[0].includes(y.name));
            for (const injury of injuriesInflicted){
                const monthsPassed = (0, $3E8Nt.getMonthsDifference)(game.monthCount, game.year, injury.month, injury.year);
                if (monthsPassed < 2) {
                    const otherParticipantName = injury.text.split(" injured ")[1];
                    if (otherParticipantName) {
                        pronounsData.push({
                            "name": otherParticipantName
                        });
                        break;
                    }
                }
            }
        }
    }
    // Add participant turned on
    if (segmentItem.requirement === "shocking-heel-turn") {
        const shockingTurns = (await (0, $9esFv.getCompanyCompanyLogs)(company)).filter((x)=>x.type === "turn").reverse();
        for (const y of participants){
            // Find participant name in shocking heel turns
            const shockingTurn = shockingTurns.find((x)=>x.text.includes("turned on") && x.text.includes(y.name));
            if (shockingTurn) {
                const otherParticipantName = shockingTurn.text.split(" turned on ")[1].split(" in ")[0];
                if (otherParticipantName) pronounsData.push({
                    "name": otherParticipantName
                });
            }
        }
    }
    // Add retired feud participant
    if (segmentItem.requirement === "not-done-yet-potential-feud") for (const y of participants){
        for (const f of (await (0, $cXLSF.getRosterMemberFeuds)(y)))if (f.directFeudEvent === "retirement-feud" && !f.started && !f.ended) {
            const otherParticipant = (await (0, $jDtEn.getFeudParticipants)(f)).find((x)=>!(0, $3E8Nt.objectInArray)(x, participants));
            if (otherParticipant) pronounsData.push({
                "name": otherParticipant.name
            });
        }
    }
    // Add random superstar for local squash segment
    if (segmentItem.name === "Local Squash") {
        usePatreonSuperstar = (0, $3E8Nt.getRandomInt)(0, 100) <= 25;
        let rosterMemberSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participants[0]);
        let randomOpponentsNames = rosterMemberSuperstars.map((x)=>(0, $3E8Nt.generateName)(x.gender, null, false, usePatreonSuperstar));
        let randomOpponentName = (0, $3E8Nt.commaSeparate)(randomOpponentsNames);
        pronounsData.push({
            "name": randomOpponentName
        });
    }
    // Add brand names for brand invasion segment
    if (segmentItem.requirement === "other-brand-talent") {
        let segmentSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        pronounsData = [
            {
                "name": (0, $3E8Nt.commaSeparate)(segmentSuperstars.map((x)=>x.name))
            }
        ];
        let currentEvent = await (0, $eg5dz.getSegmentEvent)(segment);
        let brandName = currentEvent.brandName;
        if (!brandName && currentEvent.weeklyShow) {
            let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
            brandName = rosterBrands.find((x)=>x.weeklyShowName === currentEvent.name)?.name;
        }
        let secondBrandName = segmentSuperstars.find((x)=>x.brandName && x.brandName !== brandName)?.brandName;
        if (brandName && secondBrandName) {
            pronounsData.push({
                "name": brandName
            });
            pronounsData.push({
                "name": secondBrandName
            });
        }
    }
    // Add data for buyout segment
    if (segmentItem.requirement === "buyout-offer-accepted") {
        let competitor = (await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game)).find((x)=>x.operatingStatus.includes("Negotiating Buyout"));
        pronounsData = [
            {
                "name": company.ownerName ? company.ownerName : "The Owner"
            },
            {
                "name": competitor.name
            }
        ];
    }
    // Combine participant names for promo battle / fight segments
    if ([
        "Promo Battle",
        "Fight"
    ].includes(segmentItem.name)) pronounsData = [
        {
            "name": (0, $3E8Nt.commaSeparate)(participants.map((x)=>x.name))
        }
    ];
    return [
        pronounsData,
        usePatreonSuperstar
    ];
}
async function $336089d6be28ba1c$var$addSegmentConsequenceDataPronouns(data, segment, participants, segmentItem, mainRoster, pronouns, rosterSuperstars) {
    // Add faction segment data
    if (segmentItem.factionSegment) {
        data["factionSegment"] = true;
        // Add faction names
        data["pronouns"] = [
            {
                "name": (0, $3E8Nt.commaSeparate)(participants.map((x)=>x.name))
            }
        ];
        // Add consequence superstars names and pronouns
        let segmentConsequenceSuperstars = [];
        for (const y of segment.consequenceData["superstarUids"]){
            const segmentConsequenceSuperstar = rosterSuperstars.find((x)=>x.$loki === y);
            if (segmentConsequenceSuperstar) segmentConsequenceSuperstars.push(segmentConsequenceSuperstar);
        }
        segmentConsequenceSuperstars = (0, $3E8Nt.getUniqueObjects)(segmentConsequenceSuperstars);
        if (segmentConsequenceSuperstars.length) {
            data["pronouns"].push({
                "name": (0, $3E8Nt.commaSeparate)(segmentConsequenceSuperstars.map((x)=>x.name)),
                "pronoun": segmentConsequenceSuperstars.length > 1 ? "they" : segmentConsequenceSuperstars[0].pronoun,
                "possessivePronoun": segmentConsequenceSuperstars.length > 1 ? "their" : segmentConsequenceSuperstars[0].possessivePronoun,
                "objectivePronoun": segmentConsequenceSuperstars.length > 1 ? "them" : segmentConsequenceSuperstars[0].objectivePronoun
            });
            data["factionSuperstarsMultiple"] = segmentConsequenceSuperstars.length > 1;
        }
        // Add faction leader name and pronouns
        const factionUid = segment.consequenceData["factionUids"]?.[0];
        const faction = factionUid ? await (0, $14eBR.Factions).get(factionUid) : null;
        const factionLeader = faction ? await (0, $2JFAd.getFactionLeaderSuperstar)(faction) : null;
        data["pronouns"].push({
            "name": factionLeader ? factionLeader.name : "",
            "pronoun": factionLeader ? factionLeader.pronoun : "",
            "possessivePronoun": factionLeader ? factionLeader.possessivePronoun : "",
            "objectivePronoun": factionLeader ? factionLeader.objectivePronoun : ""
        });
        // Add consequence faction
        const consequenceFactions = [];
        const rosterFactions = await (0, $dl5u4.getRosterFactions)(mainRoster);
        for (const y of segment.consequenceData["factionConsequenceUids"]){
            const consequenceFaction = rosterFactions.find((x)=>x.$loki === y);
            if (consequenceFaction) consequenceFactions.push(consequenceFaction);
        }
        data["pronouns"].push({
            "name": (0, $3E8Nt.commaSeparate)(consequenceFactions.map((x)=>x.name))
        });
        // Add created faction name
        data["pronouns"].push({
            "name": segment.consequenceData["createdFactionName"]
        });
        // Add graphics if create faction segment (as it has no participants)
        if (segmentItem.consequence === "create-faction") for (const s of segmentConsequenceSuperstars){
            let superstarGraphic = (0, $5kTkA.getGraphicForSuperstar)(s);
            delete superstarGraphic.uid;
            data["graphics"].push(superstarGraphic);
        }
    }
    // Add brand segment data
    if (pronouns && segmentItem.consequence === "draft-talent-to-brand") {
        let consequenceBrand;
        if (segment.consequenceData["brandUid"]) consequenceBrand = await (0, $14eBR.Brands).get(segment.consequenceData["brandUid"]);
        if (consequenceBrand) data["pronouns"].push({
            "name": consequenceBrand.name
        });
    }
    // Add feud participant
    if (pronouns && segmentItem.requirement === "feud-present") {
        let selectedFeud;
        if (segment.consequenceData["feudUid"]) selectedFeud = await (0, $14eBR.Feuds).get(segment.consequenceData["feudUid"]);
        if (selectedFeud) {
            const feudParticipant = (await (0, $jDtEn.getFeudParticipants)(selectedFeud)).find((y)=>!(0, $3E8Nt.objectInArray)(y, participants));
            if (feudParticipant) data["pronouns"].push({
                "name": feudParticipant.name,
                "pronoun": feudParticipant.pronoun,
                "possessivePronoun": feudParticipant.possessivePronoun,
                "objectivePronoun": feudParticipant.objectivePronoun
            });
        }
    }
    return data;
}
async function $336089d6be28ba1c$var$addSpecialSegmentPronouns(data, segment, participants, segmentItem, company, game) {
    let superstarRandom = new Math.seedrandom(participants[0].meta.created);
    if (segmentItem.name === "Timely Rescue") {
        let staffMembers = await (0, $9esFv.getCompanyStaff)(company);
        if (staffMembers.length <= 0) staffMembers.push(await (0, $8bQDO.generateStaffMember)());
        let availableStaffMembers = (0, $8A6FL.getAvailableStaffMembers)(staffMembers);
        let staffMember;
        if (availableStaffMembers.length > 0) staffMember = (0, $3E8Nt.getRandomChoice)(availableStaffMembers, superstarRandom());
        else staffMember = (0, $3E8Nt.getRandomChoice)(staffMembers, superstarRandom());
        data["pronouns"].push({
            "name": staffMember.name
        });
        data["graphics"].push((0, $8A6FL.getStaffMemberGraphic)(staffMember));
    }
    if (segmentItem.name === "Celebrity Beatdown") {
        let celebrity = (0, $3E8Nt.getRandomChoice)((0, $1JkT6.specialSegmentCelebritiesData), superstarRandom());
        data["pronouns"].push({
            "name": celebrity.name,
            "possessivePronoun": celebrity.possessivePronoun
        });
    }
    if (segmentItem.name === "Love Making") {
        // Get partner's gender
        let participantPronoun = participants[0].pronoun;
        let partnerPronoun;
        if ((0, $3E8Nt.getRandomInt)(0, 100, superstarRandom()) <= 16) partnerPronoun = participantPronoun;
        else {
            if (participantPronoun === "he") partnerPronoun = "she";
            else if (participantPronoun === "she") partnerPronoun = "he";
            else partnerPronoun = (0, $3E8Nt.getRandomChoice)([
                "he",
                "she"
            ], superstarRandom());
        }
        data["pronouns"].push({
            "partnerPronoun": partnerPronoun
        });
    }
    if (segmentItem.name === "Helicopter Raid") {
        let competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game);
        let competitorName;
        if (competitors.length > 0) competitorName = (0, $3E8Nt.getRandomChoice)(competitors, superstarRandom()).name;
        else competitorName = "our competitor";
        data["pronouns"].push({
            "name": competitorName
        });
    }
    return data;
}
async function $336089d6be28ba1c$export$6c4cc1caa3100962(segment) {
    let data = {};
    let segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(segment);
    if (segment.participants) data["participants"] = segment.participants;
    else {
        let segmentParticipants = await (0, $eg5dz.getSegmentParticipants)(segment);
        data["participants"] = segmentParticipants.map((x)=>x.name);
    }
    data["rating"] = segment.rating;
    data["event"] = await (0, $6RCLU.getMatchEventTitle)(segment);
    data["name"] = segmentItem?.name;
    data["managerSegment"] = [
        "boost-managed-talent",
        "add-manager",
        "remove-manager",
        "remove-managed-talent"
    ].includes(segmentItem?.consequence);
    data["productionSegment"] = segmentItem?.productionSegment;
    return data;
}
function $336089d6be28ba1c$var$getSegmentProducer(segment, producers) {
    return producers.find((x)=>x.taskData && x.taskData["segment_id"] === segment.$loki);
}
async function $336089d6be28ba1c$export$f427e285419d35e2() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    // Get segment items, sort
    let segmentItems = await (0, $9esFv.getCompanySegmentItems)(userCompany);
    segmentItems.sort((a, b)=>(0, $1JkT6.segmentItemsOrder).includes(a.name) - (0, $1JkT6.segmentItemsOrder).includes(b.name) || (0, $1JkT6.segmentItemsOrder).indexOf(b.name) - (0, $1JkT6.segmentItemsOrder).indexOf(a.name) || b.$loki - a.$loki).reverse();
    // Get available segment items
    let availableSegmentItems = [];
    for (const x of segmentItems)if (x.unlocked) {
        // Add faction/manager/brand segments only for paid users
        if (x.factionSegment || x.requirement === "other-brand-talent" || [
            "boost-managed-talent",
            "add-manager",
            "remove-manager",
            "remove-managed-talent",
            "draft-talent-to-brand"
        ].includes(x.consequence)) {
            if ((0, $98xmD.globalUser).paid) availableSegmentItems.push(x);
        } else availableSegmentItems.push(x);
    }
    // Get unavailable segment items
    let unavailableSegmentItems = segmentItems.filter((x)=>!(0, $3E8Nt.objectInArray)(x, availableSegmentItems));
    // Get data for segment items
    data["availableSegmentItems"] = await Promise.all(availableSegmentItems.map((x)=>$336089d6be28ba1c$export$23fb60f0ecbfea2f(x)));
    data["unavailableSegmentItems"] = await Promise.all(unavailableSegmentItems.map((x)=>$336089d6be28ba1c$export$23fb60f0ecbfea2f(x)));
    // Check custom package requirement
    const productionFacility = (await (0, $9esFv.getCompanyFacilities)(userCompany)).find((x)=>x.name === "Production");
    const producer = await (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "producer");
    if (productionFacility && productionFacility.level >= 3 && producer && producer.level >= 3) data["customPackage"] = true;
    // Check tutorial action
    if (userCompany.storyName === "tutorial") {
        data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
            "other_features"
        ]);
        (0, $14eBR.db).saveDatabase();
    }
    return data;
}
async function $336089d6be28ba1c$export$f152999265c43d70({ name: name, startText: startText, actionTexts: actionTexts } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const segmentItems = await (0, $9esFv.getCompanySegmentItems)(userCompany);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const cost = 30;
    // Check if enough points
    if (userCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Check if allowed to create custom package
    const productionFacility = (await (0, $9esFv.getCompanyFacilities)(userCompany)).find((x)=>x.name === "Production");
    const producer = await (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "producer");
    if (!(productionFacility && productionFacility.level >= 3) || !(producer && producer.level >= 3)) {
        data["error"] = "level";
        return data;
    }
    // Check if segment item name exists
    if (segmentItems.map((x)=>x.name).indexOf(name) >= 0) {
        data["error"] = "name-exists";
        return data;
    }
    // Create segment item and add to company
    let newSegmentItem = $336089d6be28ba1c$var$createProductionPackageSegmentItem(name, [
        startText
    ], actionTexts);
    await (0, $14eBR.SegmentItems).insert(newSegmentItem);
    await (0, $9esFv.addCompanySegmentItems)(userCompany, [
        newSegmentItem
    ]);
    // Remove points
    userCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = userCompany.points;
    data["name"] = newSegmentItem.name;
    return data;
}
function $336089d6be28ba1c$var$createProductionPackageSegmentItem(name, startTexts, actionTexts) {
    const segmentItem = (0, $cMrnz.SegmentItem)();
    segmentItem.name = name;
    segmentItem.startTexts = startTexts;
    segmentItem.actionTexts = actionTexts;
    segmentItem.hypeBoost = 0;
    segmentItem.popularityBoost = 2;
    segmentItem.difficulty = 1;
    segmentItem.entertainment = 3;
    segmentItem.action = 0;
    segmentItem.maxParticipants = 1;
    segmentItem.minParticipants = 1;
    segmentItem.oneAtATime = true;
    segmentItem.productionSegment = true;
    segmentItem.custom = true;
    segmentItem.saveToCommunity = true;
    segmentItem.unlocked = true;
    segmentItem.chooseWinner = false;
    segmentItem.feudOnly = false;
    segmentItem.oneWayConsequence = false;
    segmentItem.requirement = "level-1-producer";
    return segmentItem;
}
async function $336089d6be28ba1c$export$e22daf9fc2c7de3(segmentItem, participants, companyLogs, month, year, championships, availableStaffMembers, factions = []) {
    let data = {};
    // Get participants type
    let participantsType;
    if (participants.length > 0) participantsType = participants[0].objectName;
    // Check for trio
    if (participantsType === "tagTeam" && participants[0].trio) participantsType = "trio";
    // Check for faction (while booking, participantsType is tagTeam for factions)
    if (participantsType === "tagTeam" && factions.length > 0) participantsType = "faction";
    // Define check functions
    async function titleFeudCheck() {
        for (const p of participants){
            let titleFeuds = [];
            for (const feud of (await (0, $cXLSF.getRosterMemberFeuds)(p))){
                let feudItem = await (0, $jDtEn.getFeudFeudItem)(feud);
                if (feud.started && !feud.ended && [
                    "new-title-challenger",
                    "champions",
                    "long-title-reign",
                    "previous-title-feud",
                    "previous-champion",
                    "old-and-champion"
                ].includes(feudItem.requirement)) titleFeuds.push(feud);
            }
            for (const feud of titleFeuds){
                let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
                if (participants.every((x)=>(0, $3E8Nt.objectInArray)(x, feudParticipants))) return true;
            }
        }
        return false;
    }
    async function vacantTitleCheck() {
        let vacatedChampionships = championships.filter((x)=>x.vacated && !x.booked);
        if (participantsType === "superstar") {
            vacatedChampionships = vacatedChampionships.filter((x)=>!x.tagTeam && !x.trio);
            return vacatedChampionships.length > 0;
        } else if (participantsType === "tagTeam" || participantsType === "trio") {
            if (participantsType === "tagTeam") vacatedChampionships = vacatedChampionships.filter((x)=>x.tagTeam);
            else if (participantsType === "trio") vacatedChampionships = vacatedChampionships.filter((x)=>x.tagTeam || x.trio);
            return vacatedChampionships.length > 0;
        }
    }
    async function teamSuperstarsCheck() {
        if (participantsType === "superstar") {
            let tagTeams = await (0, $hBIDz.getSuperstarTagTeams)(participants[0]);
            for (const tagTeam of tagTeams){
                let tagTeamMembers = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                if ((0, $3E8Nt.checkAreObjArraysEqual)(tagTeamMembers, participants)) return true;
            }
        }
        return false;
    }
    async function championCheck() {
        if (participantsType === "superstar") {
            let participantsChampionships = (await Promise.all(participants.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            participantsChampionships = participantsChampionships.filter((x)=>!x.tagTeam && !x.trio);
            return participantsChampionships.length > 0;
        } else if (participantsType === "tagTeam" || participantsType === "trio") {
            let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            let participantsChampionships = (await Promise.all(participantsSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            if (participantsType === "tagTeam") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam);
            else if (participantsType === "trio") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam || x.trio);
            return participantsChampionships.length > 0;
        }
    }
    async function newChampionCheck() {
        if (participantsType === "superstar") {
            let participantsChampionships = (await Promise.all(participants.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            participantsChampionships = participantsChampionships.filter((x)=>!x.tagTeam && !x.trio);
            for (const c of participantsChampionships){
                let reigns = await (0, $ivuOU.getChampionshipChampionshipReigns)(c);
                for (const r of reigns){
                    if (r.endMonth === null && (0, $3E8Nt.getMonthsDifference)(month, year, r.startMonth, r.startYear) < 2) return true;
                }
            }
        } else if (participantsType === "tagTeam" || participantsType === "trio") {
            let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            let participantsChampionships = (await Promise.all(participantsSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            if (participantsType === "tagTeam") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam);
            else if (participantsType === "trio") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam || x.trio);
            for (const c of participantsChampionships){
                let reigns = await (0, $ivuOU.getChampionshipChampionshipReigns)(c);
                for (const r of reigns){
                    if (r.endMonth === null && (0, $3E8Nt.getMonthsDifference)(month, year, r.startMonth, r.startYear) < 2) return true;
                }
            }
        }
        return false;
    }
    async function previousFeudsCheck() {
        let previousFeuds = [];
        let checkParticipants = participants;
        if (participantsType === "faction" && factions.length) checkParticipants = factions;
        for (const p of checkParticipants){
            let feuds = (await (0, $cXLSF.getRosterMemberFeuds)(p)).filter((x)=>x.started && x.ended);
            for (const feud of feuds){
                let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
                if (checkParticipants.every((x)=>(0, $3E8Nt.objectInArray)(x, feudParticipants))) previousFeuds.push(feud);
            }
        }
        previousFeuds = (0, $3E8Nt.getUniqueObjects)(previousFeuds);
        return previousFeuds.length >= 1;
    }
    async function newTalentCheck() {
        let newTalentNames = [];
        for (const companyLog of companyLogs){
            if ([
                "signing",
                "callup",
                "new-superstar",
                "new-trade-superstar"
            ].includes(companyLog.type) && !newTalentNames.includes(companyLog.text) && companyLog.realYear !== null) {
                if ((0, $3E8Nt.getMonthsDifference)(month, year, companyLog.month, companyLog.realYear) < 3) newTalentNames.push(companyLog.text);
            }
        }
        return participants.some((x)=>newTalentNames.includes(x.name));
    }
    async function contractAndChampionCheck() {
        if (participantsType === "superstar") {
            let participantsChampionships = (await Promise.all(participants.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            participantsChampionships = participantsChampionships.filter((x)=>!x.tagTeam && !x.trio);
            return participantsChampionships.some((x)=>!x.championshipContract) && participantsChampionships.some((x)=>x.championshipContract);
        } else if (participantsType === "tagTeam" || participantsType === "trio") {
            let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            let participantsChampionships = (await Promise.all(participantsSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            if (participantsType === "tagTeam") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam);
            else if (participantsType === "trio") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam || x.trio);
            return participantsChampionships.some((x)=>!x.championshipContract) && participantsChampionships.some((x)=>x.championshipContract);
        }
    }
    async function legendCheck() {
        return participantsType === "superstar" && participants.some((x)=>x.hallOfFamer);
    }
    async function alignmentCheck(alignment) {
        let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        return participantsSuperstars.every((x)=>x.alignment === alignment);
    }
    async function heelCheck() {
        return alignmentCheck("heel");
    }
    async function faceCheck() {
        return alignmentCheck("face");
    }
    async function teamSuperstarsAlignmentCheck(alignment) {
        if (participantsType === "superstar") {
            let tagTeams = await (0, $hBIDz.getSuperstarTagTeams)(participants[0]);
            for (const tagTeam of tagTeams){
                let tagTeamMembers = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                if ((0, $3E8Nt.checkAreObjArraysEqual)(tagTeamMembers, participants) && tagTeamMembers.every((x)=>x.alignment === alignment)) return true;
            }
        }
        return false;
    }
    async function faceTeamSuperstarsCheck() {
        return teamSuperstarsAlignmentCheck("face");
    }
    async function faceAndHeelPastFeudCheck() {
        for (const p of participants){
            let feuds = (await (0, $cXLSF.getRosterMemberFeuds)(p)).filter((x)=>x.started && x.ended);
            for (const feud of feuds){
                let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
                if (feudParticipants.every((x)=>(0, $3E8Nt.objectInArray)(x, participants))) {
                    // Check if face and heel present
                    if (participantsType === "superstar") {
                        if (feudParticipants.some((x)=>x.alignment === "heel") && feudParticipants.some((x)=>x.alignment === "face")) return true;
                    } else {
                        let faces = false;
                        let heels = false;
                        for (const p of feudParticipants){
                            let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(p);
                            if (participantSuperstars.every((x)=>x.alignment === "heel")) heels = true;
                            else if (participantSuperstars.every((x)=>x.alignment === "face")) faces = true;
                        }
                        if (heels && faces) return true;
                    }
                }
            }
        }
        return false;
    }
    async function faceAndFacePastFeudCheck() {
        for (const p of participants){
            let feuds = (await (0, $cXLSF.getRosterMemberFeuds)(p)).filter((x)=>x.started && x.ended);
            for (const feud of feuds){
                let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
                if (feudParticipants.every((x)=>(0, $3E8Nt.objectInArray)(x, participants))) {
                    let feudSuperstars = (await Promise.all(feudParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
                    if (feudSuperstars.every((x)=>x.alignment === "face")) return true;
                }
            }
        }
        return false;
    }
    async function faceAndHeelCheck() {
        if (participantsType === "superstar") {
            if (participants.some((x)=>x.alignment === "heel") && participants.some((x)=>x.alignment === "face")) return true;
        } else {
            let faces = false;
            let heels = false;
            for (const p of participants){
                let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(p);
                if (participantSuperstars.every((x)=>x.alignment === "heel")) heels = true;
                else if (participantSuperstars.every((x)=>x.alignment === "face")) faces = true;
            }
            return heels && faces;
        }
        return false;
    }
    async function heelTeamSuperstarsCheck() {
        return teamSuperstarsAlignmentCheck("heel");
    }
    async function neutralCheck() {
        let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        return participantsSuperstars.every((x)=>!x.alignment);
    }
    async function producerLevelCheck(level) {
        let producers = availableStaffMembers.filter((x)=>x.role === "producer");
        for (const producer of producers){
            if (producer.level >= level) return true;
        }
        return false;
    }
    async function producerLevel1Check() {
        return producerLevelCheck(1);
    }
    async function producerLevel2Check() {
        return producerLevelCheck(2);
    }
    async function producerLevel3Check() {
        return producerLevelCheck(3);
    }
    async function newTalentPackageCheck() {
        if (!await producerLevel2Check()) return false;
        return newTalentCheck();
    }
    async function returningTalentPackageCheck() {
        if (!await producerLevel2Check()) return false;
        let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        return participantsSuperstars.every((x)=>x.injured > 0 && x.injured <= 3);
    }
    async function retiringTalentPackageCheck() {
        if (!await producerLevel3Check()) return false;
        return retiringCheck();
    }
    async function championPackage() {
        if (!await producerLevel2Check()) return false;
        return championCheck();
    }
    async function newGimmickPackageCheck() {
        if (!await producerLevel1Check()) return false;
        let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        return participantsSuperstars.every((x)=>x.debutNewGimmick);
    }
    async function buyoutOfferAcceptedCheck() {
        let company = await (0, $cMrnz.getSegmentItemCompany)(segmentItem);
        if (company) {
            let game = await (0, $9esFv.getCompanyGame)(company);
            let buyoutCompetitor = (await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game)).find((x)=>x.operatingStatus.includes("Negotiating Buyout"));
            if (buyoutCompetitor) return true;
        }
        return false;
    }
    async function championPrestigeCheck(prestige, checkGraphic = false) {
        let prestigeRanks = {
            "S": 4,
            "A": 3,
            "B": 2,
            "C": 1
        };
        let participantsChampionships = [];
        if (participantsType === "superstar") {
            participantsChampionships = (await Promise.all(participants.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            participantsChampionships = participantsChampionships.filter((x)=>!x.tagTeam && !x.trio);
        } else if (participantsType === "tagTeam" || participantsType === "trio") {
            let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            participantsChampionships = (await Promise.all(participantsSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            if (participantsType === "tagTeam") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam);
            else if (participantsType === "trio") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam || x.trio);
        }
        let championship = participantsChampionships.find((x)=>prestigeRanks[x.prestige] >= prestigeRanks[prestige]);
        if (checkGraphic) return championship && championship.graphic && Object.keys(championship.graphic).length !== 0;
        else return !!championship;
    }
    async function championPrestigeCheckAWithGraphic() {
        return championPrestigeCheck("A", true);
    }
    async function championPrestigeCheckS() {
        return championPrestigeCheck("S");
    }
    async function championPrestigeCheckB() {
        return championPrestigeCheck("B");
    }
    async function retirementCheck() {
        let retiredSuperstarsNames = [];
        for (const companyLog of companyLogs){
            if (companyLog.type === "retirement" && !retiredSuperstarsNames.includes(companyLog.text)) {
                if ((0, $3E8Nt.getMonthsDifference)(month, year, companyLog.month, companyLog.year) < 3) retiredSuperstarsNames.push(companyLog.text);
            }
        }
        return participants.some((x)=>retiredSuperstarsNames.includes(x.name));
    }
    async function losingStreakCheck() {
        let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        return participantsSuperstars.every((x)=>x.lossesCounter >= 5);
    }
    async function legendAndOverSuperstarCheck() {
        if (participantsType === "superstar") {
            if (participants.some((x)=>x.hot) && participants.some((x)=>x.hallOfFamer)) return true;
        }
        return false;
    }
    async function legendAndHeelCheck() {
        if (participantsType === "superstar") {
            if (participants.some((x)=>x.alignment === "heel") && participants.some((x)=>x.hallOfFamer)) return true;
        }
        return false;
    }
    async function faceOfTheCompanyCheck() {
        let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        return participantsSuperstars.every((x)=>x.faceOfTheCompany);
    }
    async function wrestlerOfTheYearAwardCheck() {
        let companyAwards = companyLogs.filter((x)=>x.type === "award" && x.value > 0 && x.text.includes("Wrestler of the Year"));
        for (const awardWon of companyAwards){
            for (const participant of participants)if ((0, $3E8Nt.findNameInString)(participant.name, awardWon.text) && awardWon.realYear !== null) {
                if ((0, $3E8Nt.getMonthsDifference)(month, year, awardWon.month, awardWon.realYear) < 3) return true;
            }
        }
        return false;
    }
    async function awardWinnerCheck() {
        let companyAwards = companyLogs.filter((x)=>x.type === "award");
        for (const awardWon of companyAwards){
            for (const participant of participants)if ((0, $3E8Nt.findNameInString)(participant.name, awardWon.text) && awardWon.realYear !== null) {
                if ((0, $3E8Nt.getMonthsDifference)(month, year, awardWon.month, awardWon.realYear) < 3) return true;
            }
        }
        return false;
    }
    async function inflictedInjuryCheck() {
        let injuries = companyLogs.filter((x)=>x.type === "injury");
        for (const p of participants){
            let injured = false;
            if (participantsType === "superstar") injured = p.injured;
            else injured = (await (0, $5kTkA.getRosterMemberSuperstars)(p)).some((x)=>x.injured);
            if (!injured) {
                let injuriesInflicted = injuries.filter((x)=>x.text.split(" injured ")[0].includes(p.name));
                for (const injuryInflicted of injuriesInflicted){
                    if ((0, $3E8Nt.getMonthsDifference)(month, year, injuryInflicted.month, injuryInflicted.year) < 2) return true;
                }
            }
        }
        return false;
    }
    async function notDoneYetPotentialFeudCheck() {
        for (const p of participants){
            let retired = false;
            if (participantsType === "superstar") retired = p.retired;
            else retired = (await (0, $5kTkA.getRosterMemberSuperstars)(p)).some((x)=>x.retired);
            if (!retired) {
                for (const f of (await (0, $cXLSF.getRosterMemberFeuds)(p)))if (f.directFeudEvent === "retirement-feud" && !f.started && !f.ended) {
                    if ((0, $3E8Nt.getMonthsDifference)(month, year, f.startMonth, f.startYear) < 3) return true;
                }
            }
        }
        return false;
    }
    async function shockingHeelTurnCheck() {
        let shockingTurns = companyLogs.filter((x)=>x.type === "turn" && !x.text.includes("Face"));
        for (const participant of participants){
            // Get superstar name by splitting companyLog text and getting word before 'turned'
            let shockingTurn = shockingTurns.find((x)=>x.text.split(" turned ")[0].includes(participant.name));
            if (shockingTurn && (0, $3E8Nt.getMonthsDifference)(month, year, shockingTurn.month, shockingTurn.year) < 3) return true;
        }
        return false;
    }
    async function shockingFaceTurnCheck() {
        let shockingTurns = companyLogs.filter((x)=>x.type === "turn" && x.text.includes("Face"));
        for (const participant of participants){
            // Get superstar name by splitting companyLog text and getting word before 'turned'
            let shockingTurn = shockingTurns.find((x)=>x.text.split(" turned ")[0].includes(participant.name));
            if (shockingTurn && (0, $3E8Nt.getMonthsDifference)(month, year, shockingTurn.month, shockingTurn.year) < 3) return true;
        }
        return false;
    }
    async function singlesSuperstarsCheck() {
        if (participantsType === "superstar") {
            // Check if superstars are already in a team
            for (const p of participants){
                let currentTeams = (await (0, $hBIDz.getSuperstarTagTeams)(p)).filter((x)=>!x.temporary);
                if (currentTeams.length > 0) return false;
            }
            return true;
        }
        return false;
    }
    async function companyOfTheYearAward() {
        let companyAwards = companyLogs.filter((x)=>x.type === "award" && x.value > 0 && x.text.includes("Company of the Year"));
        for (const awardWon of companyAwards)if (awardWon.realYear !== null) {
            if ((0, $3E8Nt.getMonthsDifference)(month, year, awardWon.month, awardWon.realYear) < 3) return true;
        }
        return false;
    }
    async function injuredPartnerAndSinglesSuperstar() {
        if (participantsType === "superstar") {
            // Check if one participant is in team and one is not
            let participantInTeam;
            let participantNotInTeam;
            for (const p of participants){
                let participantTeams = (await (0, $hBIDz.getSuperstarTagTeams)(p)).filter((x)=>!x.temporary && !x.trio);
                if (participantTeams.length > 0) participantInTeam = p;
                else participantNotInTeam = p;
            }
            if (participantInTeam && participantNotInTeam) {
                let participantTeam = (await (0, $hBIDz.getSuperstarTagTeams)(participantInTeam)).find((x)=>!x.temporary && !x.trio);
                // Check if other team member in injured
                let otherTeamMembers = (await (0, $972Ip.getTagTeamSuperstars)(participantTeam)).filter((x)=>x.$loki !== participantInTeam.$loki);
                if (otherTeamMembers.some((x)=>x.injured > 0)) return true;
            }
        }
        return false;
    }
    async function retiringCheck() {
        if (participantsType === "superstar") {
            if (participants.some((x)=>x.age >= 45)) return true;
        } else for (const p of participants){
            let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(p);
            if (participantSuperstars.every((x)=>x.age >= 45)) return true;
        }
        return false;
    }
    async function heelsAndFaceSinglesCheck() {
        if (participantsType === "superstar") {
            let faces = participants.filter((x)=>x.alignment === "face").length;
            let heels = participants.filter((x)=>x.alignment === "heel").length;
            if (faces === 1 && heels === participants.length - 1) {
                // Check if heels are already in a team
                for (const p of participants.filter((x)=>x.alignment === "heel")){
                    let currentTeams = (await (0, $hBIDz.getSuperstarTagTeams)(p)).filter((x)=>!x.temporary);
                    if (currentTeams.length > 0) return false;
                }
                return true;
            }
        }
        return false;
    }
    async function maskedTalentCheck() {
        for (const p of participants){
            let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(p);
            if (participantSuperstars.every((x)=>(0, $5kTkA.checkSuperstarGraphicMask)(x.graphic))) return true;
        }
        return false;
    }
    async function noFactionLeaderCheck() {
        if (factions.length > 0) {
            if (!await (0, $2JFAd.getFactionLeaderSuperstar)(factions[0])) return true;
        }
        return false;
    }
    async function factionLeaderPresentCheck() {
        if (factions.length > 0) {
            if (await (0, $2JFAd.getFactionLeaderSuperstar)(factions[0])) return true;
        }
        return false;
    }
    async function otherBrandTalentCheck() {
        let company = await (0, $cMrnz.getSegmentItemCompany)(segmentItem);
        let currentEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
        let brandName = currentEvent.brandName;
        if (!brandName && currentEvent.weeklyShow) {
            let roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
            let rosterBrands = await (0, $dl5u4.getRosterBrands)(roster);
            brandName = rosterBrands.find((x)=>x.weeklyShowName === currentEvent.name)?.name;
        }
        if (brandName) {
            let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            return participantsSuperstars.every((x)=>x.brandName && x.brandName !== brandName);
        }
        return false;
    }
    async function returningTalentCheck() {
        let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        return participantsSuperstars.some((x)=>x.readyToReturn);
    }
    async function doubleChampionCheck() {
        if (participantsType === "superstar") {
            let participantsChampionships = (await Promise.all(participants.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            participantsChampionships = participantsChampionships.filter((x)=>!x.tagTeam && !x.trio);
            return participantsChampionships.length === 2;
        } else if (participantsType === "tagTeam" || participantsType === "trio") {
            let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            let participantsChampionships = (await Promise.all(participantsSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            if (participantsType === "tagTeam") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam);
            else if (participantsType === "trio") participantsChampionships = participantsChampionships.filter((x)=>x.tagTeam || x.trio);
            return (0, $kZwpB.getUniqueChampionships)(participantsChampionships).length === 2;
        }
    }
    async function overTalentCheck() {
        let participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        return participantsSuperstars.every((x)=>x.hot);
    }
    async function feudPresentCheck() {
        let checkParticipants = participants;
        if (participantsType === "faction" && factions.length) checkParticipants = factions;
        for (const p of checkParticipants){
            let feuds = (await (0, $cXLSF.getRosterMemberFeuds)(p)).filter((x)=>x.started && !x.ended || !x.started && x.directFeudEvent && !x.ended);
            if (feuds.length > 0) return true;
        }
        return false;
    }
    async function theGrandInvitationalWinnerCheck() {
        let companyAwards = companyLogs.filter((x)=>x.type === "award" && x.value === 3 && x.text.includes("The Grand Invitational"));
        for (const awardWon of companyAwards){
            for (const participant of participants)if ((0, $3E8Nt.findNameInString)(participant.name, awardWon.text) && awardWon.realYear !== null) {
                if ((0, $3E8Nt.getMonthsDifference)(month, year, awardWon.month, awardWon.realYear) < 3) return true;
            }
        }
        return false;
    }
    const checkFunctions = {
        "title-feud": titleFeudCheck,
        "vacant-title": vacantTitleCheck,
        "team-superstars": teamSuperstarsCheck,
        "champion": championCheck,
        "new-champion": newChampionCheck,
        "previous-feuds": previousFeudsCheck,
        "new-talent": newTalentCheck,
        "contract-and-champion": contractAndChampionCheck,
        "legend": legendCheck,
        "heel": heelCheck,
        "face": faceCheck,
        "face-vs-face": faceCheck,
        "face-team-superstars": faceTeamSuperstarsCheck,
        "face-vs-heel-past-feud": faceAndHeelPastFeudCheck,
        "face-vs-face-past-feud": faceAndFacePastFeudCheck,
        "face-vs-heel": faceAndHeelCheck,
        "heel-team-superstars": heelTeamSuperstarsCheck,
        "neutral": neutralCheck,
        "level-1-producer": producerLevel1Check,
        "level-3-producer": producerLevel3Check,
        "new-talent-and-level-2-producer": newTalentPackageCheck,
        "returning-talent-and-level-2-producer": returningTalentPackageCheck,
        "retiring-talent-and-level-3-producer": retiringTalentPackageCheck,
        "champion-and-level-2-producer": championPackage,
        "new-gimmick-and-level-1-producer": newGimmickPackageCheck,
        "buyout-offer-accepted": buyoutOfferAcceptedCheck,
        "silver-champion": championPrestigeCheckB,
        "gold-champion": championPrestigeCheckAWithGraphic,
        "obsidian-champion": championPrestigeCheckS,
        "retirement": retirementCheck,
        "losing-streak": losingStreakCheck,
        "legend-and-over-superstar": legendAndOverSuperstarCheck,
        "legend-and-heel": legendAndHeelCheck,
        "face-of-the-company": faceOfTheCompanyCheck,
        "wrestler-of-the-year-award": wrestlerOfTheYearAwardCheck,
        "award-winner": awardWinnerCheck,
        "inflicted-injury": inflictedInjuryCheck,
        "not-done-yet-potential-feud": notDoneYetPotentialFeudCheck,
        "shocking-heel-turn": shockingHeelTurnCheck,
        "shocking-face-turn": shockingFaceTurnCheck,
        "singles-superstars": singlesSuperstarsCheck,
        "company-of-the-year-award": companyOfTheYearAward,
        "injured-partner-and-singles-superstar": injuredPartnerAndSinglesSuperstar,
        "retiring": retiringCheck,
        "heels-vs-face-singles": heelsAndFaceSinglesCheck,
        "masked-talent": maskedTalentCheck,
        "no-faction-leader": noFactionLeaderCheck,
        "faction-leader-present": factionLeaderPresentCheck,
        "other-brand-talent": otherBrandTalentCheck,
        "heel-vs-heel": heelCheck,
        "returning-talent": returningTalentCheck,
        "double-champion": doubleChampionCheck,
        "over-talent": overTalentCheck,
        "feud-present": feudPresentCheck,
        "the-grand-invitational-winner": theGrandInvitationalWinnerCheck
    };
    // Check segment item's requirement
    const checkFunction = checkFunctions[segmentItem.requirement];
    if (checkFunction && !await checkFunction()) data["error"] = "requirement-fail";
    if (participants.length > 0) {
        let segmentSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        // Only allow retired superstars (who are not managers) in legends, retired and manager segments or as part of a faction
        if (segmentSuperstars.some((x)=>x.retired && !x.fullTimeManager) && factions.length <= 0) {
            if (!segmentItem.requirement || ![
                "legend",
                "retirement",
                "no-manager",
                "manager-present",
                "manager"
            ].some((y)=>segmentItem.requirement.includes(y))) data["error"] = "retired";
        }
        // Don't allow managers in segments that create teams
        if (segmentSuperstars.some((x)=>x.fullTimeManager)) {
            if ([
                "create-trio-of-heels",
                "create-tag-team-and-blowoff",
                "remove-tag-team-and-create-tag-team",
                "create-team"
            ].includes(segmentItem.consequence)) data["error"] = "manager";
        }
    }
    return data;
}
async function $336089d6be28ba1c$export$502fa564e22c7ca4({ participantUid: participantUid, participantType: participantType, inputType: inputType } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    if (inputType === "competitors") {
        const competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(userCompany, currentGame);
        data["competitors"] = competitors.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        });
    } else if ([
        "vacant-championships",
        "participant-championships",
        "participant-feuds"
    ].includes(inputType)) {
        // Get participant
        let participant;
        if (participantType === "superstar") participant = await (0, $14eBR.Superstars).get(participantUid);
        else if (participantType === "tag-team" || participantType === "trio") participant = await (0, $14eBR.TagTeams).get(participantUid);
        else if (participantType === "faction") participant = await (0, $14eBR.Factions).get(participantUid);
        if (participant) {
            // Get vacant championships
            if (inputType === "vacant-championships") {
                let championships = [];
                let vacatedChampionships = (await (0, $9esFv.getCompanyChampionships)(userCompany)).filter((x)=>x.vacated);
                if (participant.objectName === "superstar") championships = vacatedChampionships.filter((x)=>!x.tagTeam && !x.trio);
                else if (participant.objectName === "tagTeam") {
                    if (participant.trio) championships = vacatedChampionships.filter((x)=>x.tagTeam || x.trio);
                    else championships = vacatedChampionships.filter((x)=>x.tagTeam);
                }
                data["championships"] = (0, $kZwpB.getUniqueChampionships)(championships).map((x)=>{
                    return {
                        "name": x.name,
                        "uid": x.$loki
                    };
                });
            }
            // Get participant's championships
            if (inputType === "participant-championships") {
                let championships = [];
                if (participant.objectName === "superstar") championships = await (0, $5kTkA.getSuperstarChampionshipsToVacate)(participant);
                else if (participant.objectName === "tagTeam") {
                    let participantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participant);
                    championships = (await Promise.all(participantSuperstars.map((x)=>(0, $5kTkA.getSuperstarChampionshipsToVacate)(x, participant)))).flat();
                }
                data["championships"] = (0, $kZwpB.getUniqueChampionships)(championships).map((x)=>{
                    return {
                        "name": x.name,
                        "uid": x.$loki
                    };
                });
            }
            // Get participant's feuds
            if (inputType === "participant-feuds") {
                let feuds = [];
                let participantFeuds = (await (0, $cXLSF.getRosterMemberFeuds)(participant)).filter((x)=>x.started && !x.ended || !x.started && x.directFeudEvent && !x.ended);
                for (const participantFeud of participantFeuds){
                    let otherParticipants = (await (0, $jDtEn.getFeudParticipants)(participantFeud)).filter((x)=>x.$loki !== participant.$loki).map((x)=>x.name);
                    feuds.push({
                        "opponents": otherParticipants,
                        "name": participantFeud.name,
                        "uid": participantFeud.$loki
                    });
                }
                data["feuds"] = feuds;
            }
        }
    } else if (inputType === "segments-and-matches") {
        // Get matches and segments of last event except production segments
        const companyEvents = (await (0, $9esFv.getCompanyEvents)(userCompany)).reverse();
        const previousEvent = companyEvents[1];
        const segments = await (0, $iQtzn.getEventSegments)(previousEvent);
        let filteredSegments = [];
        for (const segment of segments){
            const segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(segment);
            if (!segmentItem.productionSegment) filteredSegments.push(segment);
        }
        const matches = await (0, $iQtzn.getEventMatches)(previousEvent);
        const segmentsAndMatches = filteredSegments.concat(matches);
        data["segmentsAndMatches"] = await Promise.all(segmentsAndMatches.map(async (x)=>{
            return {
                "name": await (0, $3E8Nt.getMatchOrSegmentName)(x),
                "uid": x.$loki,
                "type": x.objectName
            };
        }));
    }
    return data;
}
async function $336089d6be28ba1c$export$4adfda27a8a9a2a5(segment) {
    const participants = await (0, $eg5dz.getSegmentParticipants)(segment);
    let participantNames = (0, $3E8Nt.commaSeparate)(participants.map((x)=>x.name));
    let segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(segment);
    let segmentItemName = segmentItem.name;
    let segmentWord = "";
    if (participantNames) segmentWord = participants.length > 1 ? "between" : "with";
    return `${segmentItemName} ${segmentWord} ${participantNames}`;
}
async function $336089d6be28ba1c$export$e6121a3f40ff8960({ feudUid: feudUid, segmentItemUid: segmentItemUid, selectedParticipants: selectedParticipants, consequenceData: consequenceData, managedTalentUid: managedTalentUid, managerUid: managerUid, producerUid: producerUid } = {}) {
    let data = {};
    try {
        const currentGame = await (0, $3E8Nt.getCurrentGame)();
        const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
        const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
        const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(userCompany);
        const eventMatches = await (0, $iQtzn.getEventMatches)(nextEvent);
        const eventSegments = await (0, $iQtzn.getEventSegments)(nextEvent);
        const eventSegmentParticipants = (await Promise.all(eventSegments.map((x)=>(0, $eg5dz.getSegmentParticipants)(x)))).flat();
        const productionFacility = (await (0, $9esFv.getCompanyFacilities)(userCompany)).find((x)=>x.name === "Production");
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
        const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
        const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
        const availableStaffMembers = await (0, $8A6FL.getAvailableStaffMembers)(staffMembers);
        const producers = await (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
        const companyLogs = await (0, $9esFv.getCompanyCompanyLogs)(userCompany);
        const segmentItem = await (0, $14eBR.SegmentItems).get(segmentItemUid);
        const monthlyEventSegmentLimit = 4;
        let factionsSelected = [];
        // Check match/segment limit
        const maximumMatchesAndSegments = (0, $5ZsVo.getEventMaximumMatchesAndSegments)(nextEvent, parentEvents, productionFacility);
        if (eventSegments.concat(eventMatches).length >= maximumMatchesAndSegments) {
            data["error"] = "match-and-segment-limit";
            data["limit"] = maximumMatchesAndSegments;
            return data;
        }
        // Check for monthly event segment limit
        if (!nextEvent.weeklyShow && nextEvent.name !== "Weekly Show") {
            if (eventSegments.length >= monthlyEventSegmentLimit) {
                data["error"] = "monthly-event-segment-limit";
                data["limit"] = monthlyEventSegmentLimit;
                return data;
            }
        }
        // Check if special segment item has been used
        if (segmentItem.special) {
            if (segmentItem.used) {
                data["error"] = "already-used";
                data["monthsToReuse"] = segmentItem.monthsToReuse;
                return data;
            }
            if (!(0, $98xmD.globalUser).paid) {
                data["error"] = "special-segments-not-paid";
                return data;
            }
            // Set segment item to used
            if (!currentGame.settings["no_special_items_cooldown"]) segmentItem.used = true;
        }
        // Check if segment item is unlocked
        if (!segmentItem.unlocked) {
            data["error"] = "locked-segment-item";
            return data;
        }
        // Check for production packages only
        if (nextEvent.activeEffect === "production_packages_only" && !segmentItem.productionSegment) {
            data["error"] = "production-packages-only";
            return data;
        }
        // Create segment, add to segment item and event
        const newSegment = (0, $eg5dz.Segment)();
        await (0, $14eBR.Segments).insert(newSegment);
        await (0, $cMrnz.addSegmentItemSegments)(segmentItem, [
            newSegment
        ]);
        await (0, $iQtzn.addEventSegments)(nextEvent, [
            newSegment
        ]);
        newSegment.order = nextEvent.matchesCount;
        nextEvent.matchesCount += 1;
        // Get participants
        let participants = [];
        if (feudUid) {
            const feud = await (0, $14eBR.Feuds).get(feudUid);
            participants = await (0, $jDtEn.getFeudParticipants)(feud);
            // Add temporary teams if factions feud
            if (participants[0].objectName === "faction") {
                let newParticipants = [];
                for (const p of participants){
                    let factionSuperstars = await (0, $6PzHO.getFactionSuperstarsForSegment)(p, nextEvent, companyChampionships);
                    // Check if at least one faction superstar is available
                    if (factionSuperstars.length < 2) {
                        data["error"] = "not-enough-available-faction-superstars";
                        return data;
                    }
                    factionsSelected.push(p);
                    let temporaryFactionTeam = await $336089d6be28ba1c$var$getFactionTemporaryTagTeam(p, factionSuperstars, mainRoster);
                    newParticipants.push(temporaryFactionTeam);
                }
                participants = newParticipants;
            }
        } else for (const x of selectedParticipants){
            let participant;
            if (x.type === "superstar") {
                participant = await (0, $14eBR.Superstars).get(x.uid);
                participants.push(participant);
            } else if (x.type === "tag-team" || x.type === "trio") {
                participant = await (0, $14eBR.TagTeams).get(x.uid);
                participants.push(participant);
            } else if (x.type === "faction") {
                participant = await (0, $14eBR.Factions).get(x.uid);
                let factionSuperstars = await (0, $6PzHO.getFactionSuperstarsForSegment)(participant, nextEvent, companyChampionships);
                // Check if at least one faction superstar is available
                if (factionSuperstars.length < 2) {
                    data["error"] = "not-enough-available-faction-superstars";
                    return data;
                }
                factionsSelected.push(participant);
                let temporaryFactionTeam = await $336089d6be28ba1c$var$getFactionTemporaryTagTeam(participant, factionSuperstars, mainRoster);
                participants.push(temporaryFactionTeam);
            }
        }
        // Check segment participants limits
        if (participants.length > segmentItem.maxParticipants) {
            data["error"] = "max-participants";
            data["maxParticipants"] = segmentItem.maxParticipants;
            return data;
        }
        if (participants.length < segmentItem.minParticipants) {
            data["error"] = "min-participants";
            data["minParticipants"] = segmentItem.minParticipants;
            return data;
        }
        // Check manager segment consequence
        if ([
            "boost-managed-talent",
            "add-manager",
            "remove-manager",
            "remove-managed-talent"
        ].includes(segmentItem.consequence)) {
            if (!(0, $98xmD.globalUser).paid) {
                data["error"] = "managers-paid-only";
                return data;
            }
            let managerSegmentCheck = await $336089d6be28ba1c$var$checkManagerSegmentAndGetParticipants(segmentItem, [
                ...participants
            ], rosterSuperstars, managedTalentUid, managerUid);
            if (managerSegmentCheck[0].error) {
                data = managerSegmentCheck[0];
                return data;
            }
            // Update participants
            participants = managerSegmentCheck[1];
        }
        // Check brand segment consequence
        if ([
            "draft-talent-to-brand"
        ].includes(segmentItem.consequence)) {
            let brandSegmentCheck = await $336089d6be28ba1c$var$checkBrandSegmentAndGetParticipants(segmentItem, [
                ...participants
            ], consequenceData);
            if (brandSegmentCheck[0].error) {
                data = brandSegmentCheck[0];
                return data;
            }
            // Update participants
            participants = brandSegmentCheck[1];
        }
        // Add participants to segment
        for (const p of participants)await (0, $eg5dz.addSegmentParticipants)(newSegment, [
            p
        ]);
        // Check for booking restrictions on event
        let activeEffect = nextEvent.activeEffect;
        if ([
            "no_women_bookable",
            "no_men_bookable"
        ].includes(activeEffect)) {
            for (const p of participants)for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(p))){
                if (activeEffect === "no_women_bookable" && s.gender === "female") {
                    data["error"] = "no-women-allowed";
                    return data;
                } else if (activeEffect === "no_men_bookable" && s.gender === "male") {
                    data["error"] = "no-men-allowed";
                    return data;
                }
            }
        }
        // Check if participant is in more than 2 segments
        for (const p of participants)if (eventSegmentParticipants.filter((x)=>x.$loki === p.$loki && x.objectName === p.objectName).length >= 2) {
            data["error"] = "max-segments";
            return data;
        }
        // Get participants type
        let participantsType;
        if (participants.length > 0) participantsType = participants[0].objectName;
        // Check if singles participant in special segment
        if (segmentItem.special && participantsType !== "superstar") {
            data["error"] = "superstars-only";
            return data;
        }
        // Check if faction participant in factions segment
        if (segmentItem.factionSegment) {
            if (factionsSelected.length <= 0 && segmentItem.minParticipants > 0) {
                data["error"] = "factions-only";
                return data;
            }
            if (!(0, $98xmD.globalUser).paid) {
                data["error"] = "factions-paid-only";
                return data;
            }
        }
        // Check if paid for brand segment
        if (segmentItem.consequence === "draft-talent-to-brand" || segmentItem.requirement === "other-brand-talent") {
            if (!(0, $98xmD.globalUser).paid) {
                data["error"] = "brands-paid-only";
                return data;
            }
        }
        // Add feuds if participants present
        let segmentFeuds = [];
        let superstarsPresent;
        if (participants.length > 0) {
            // Get all superstars and teams present
            superstarsPresent = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            let tagTeamsPresent = [];
            for (const s of superstarsPresent)tagTeamsPresent.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
            tagTeamsPresent = (0, $3E8Nt.getUniqueObjects)(tagTeamsPresent);
            // Check if superstars available, check brand exclusivity if not brand signing segment
            for (const s of superstarsPresent){
                let brandCheck = (0, $5kTkA.checkSuperstarBrandAvailability)(nextEvent, s, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(s, companyChampionships)) || segmentItem.consequence === "draft-talent-to-brand";
                if (s.unavailable || s.suspensionMonths > 0 || !brandCheck) {
                    data["error"] = "superstar-not-available";
                    data["superstarName"] = s.name;
                    return data;
                }
            }
            // Get existing feuds
            segmentFeuds = await (0, $cXLSF.getParticipantFeuds)(superstarsPresent, tagTeamsPresent);
            // Check feuds for feud only segment
            if (segmentItem.feudOnly && segmentFeuds.length <= 0) {
                data["error"] = "feud-only";
                return data;
            }
            // Add segment to feuds
            await (0, $eg5dz.addSegmentFeuds)(newSegment, segmentFeuds);
            // Reset attires
            for (const s of superstarsPresent)if (s.currentAttire > 0) s.currentAttire = 0;
            // Add managers
            if (!segmentItem.special && (0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(newSegment, superstarsPresent, rosterSuperstars, nextEvent);
        }
        // Check segment item requirement
        let requirementCheck = await $336089d6be28ba1c$export$e22daf9fc2c7de3(segmentItem, participants, companyLogs, currentGame.monthCount, currentGame.year, companyChampionships, availableStaffMembers, factionsSelected);
        if (requirementCheck.error) {
            data["error"] = requirementCheck.error;
            data["alreadyHeld"] = requirementCheck.alreadyHeld;
            data["requirement"] = segmentItem.requirement;
            return data;
        }
        // Add consequence data
        if (consequenceData) {
            // Check faction inputs for errors
            if (segmentItem.factionSegment) {
                let factionSegmentCheck = await $336089d6be28ba1c$var$checkFactionSegmentConsequence(factionsSelected, segmentItem, consequenceData, rosterSuperstars, mainRoster, nextEvent, companyChampionships);
                if (factionSegmentCheck.error) {
                    data = factionSegmentCheck;
                    return data;
                }
            }
            // Check if team/faction or championship name already exists
            if (consequenceData["objectName"]) {
                if ([
                    "create-team",
                    "create-trio-of-heels",
                    "remove-tag-team-and-create-tag-team",
                    "create-tag-team-and-blowoff"
                ].includes(segmentItem.consequence)) {
                    let tagTeamNames = (await (0, $dl5u4.getRosterTagTeams)(mainRoster)).map((x)=>x.name);
                    if (tagTeamNames.includes(consequenceData["objectName"])) {
                        data["error"] = "team-already-present";
                        return data;
                    }
                    let factionNames = (await (0, $6PzHO.getRosterActiveFactions)(mainRoster)).map((x)=>x.name);
                    if (factionNames.includes(consequenceData["objectName"])) {
                        data["error"] = "faction-already-present";
                        return data;
                    }
                } else if ([
                    "unify-titles",
                    "split-title"
                ].includes(segmentItem.consequence)) {
                    let championshipNames = companyChampionships.map((x)=>x.name);
                    if (championshipNames.includes(consequenceData["objectName"])) {
                        data["error"] = "championship-already-present";
                        return data;
                    }
                }
            }
            // Add feud to segment feuds
            if (consequenceData["feudUid"]) {
                let feudToAdd = await (0, $14eBR.Feuds).get(consequenceData["feudUid"]);
                if (feudToAdd) {
                    await (0, $eg5dz.addSegmentFeuds)(newSegment, [
                        feudToAdd
                    ]);
                    segmentFeuds.push(feudToAdd);
                }
            }
            // Set consequence data
            newSegment.consequenceData = consequenceData;
        }
        // Add one way consequence
        if (segmentItem.oneWayConsequence) newSegment.consequenceAppliedTo = await $336089d6be28ba1c$export$ec82fc9f5436dff2(segmentItem, participants);
        // Add hype
        newSegment.hype = await $336089d6be28ba1c$export$9bc052c1baf11858(participants, segmentFeuds, segmentItem);
        // Add producer task
        let producer;
        if (producerUid) {
            producer = producers.find((x)=>x.$loki === producerUid);
            if (producer) {
                // Check for current task
                if (producer.currentTask) {
                    data["producer"] = producer.name;
                    data["error"] = "producer-task-present";
                    return data;
                }
                if (!(0, $98xmD.globalUser).paid) {
                    data["error"] = "producer-focus-not-paid";
                    return data;
                }
                await $336089d6be28ba1c$var$addProducerSegmentTask(producer, newSegment, segmentItem);
            }
        }
        // Check tutorial action
        if (userCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
            "book_feud_segment",
            "book_singles_segment"
        ]);
        (0, $14eBR.db).saveDatabase();
        // Get data to return
        data["segment"] = await $336089d6be28ba1c$export$7d69ed11e8e03a89({
            segment: newSegment,
            rosterSuperstars: rosterSuperstars,
            producers: producers
        });
    } finally{
        if (data["error"]) await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
    }
    return data;
}
async function $336089d6be28ba1c$export$ec82fc9f5436dff2(segmentItem, participants) {
    if (segmentItem.requirement === "face-vs-heel" && segmentItem.consequence === "face-turn-and-blowoff") {
        // Get heel
        let heel;
        if (participants[0].objectName === "superstar") heel = participants.find((x)=>x.alignment === "heel");
        else if (participants[0].objectName === "tagTeam") {
            for (const p of participants)if ((await (0, $972Ip.getTagTeamSuperstars)(p)).every((x)=>x.alignment === "heel")) {
                heel = p;
                break;
            }
        }
        if (heel) return heel.name;
    }
    if (segmentItem.requirement === "face-vs-heel-past-feud") {
        // Get past feud's participants
        let pastFeud;
        for (const p of participants){
            let feuds = (await (0, $cXLSF.getRosterMemberFeuds)(p)).filter((x)=>x.started && x.ended);
            for (const feud of feuds){
                let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
                if (feudParticipants.every((y)=>(0, $3E8Nt.objectInArray)(y, participants))) {
                    pastFeud = feud;
                    break;
                }
            }
            if (pastFeud) break;
        }
        let pastFeudParticipants = await (0, $jDtEn.getFeudParticipants)(pastFeud);
        // Get heel or face
        if (segmentItem.consequence === "heel-turn") {
            let face;
            if (participants[0].objectName === "superstar") face = pastFeudParticipants.find((x)=>x.alignment === "face");
            else if (participants[0].objectName === "tagTeam") {
                for (const p of pastFeudParticipants)if ((await (0, $972Ip.getTagTeamSuperstars)(p)).every((x)=>x.alignment === "face")) {
                    face = p;
                    break;
                }
            }
            if (face) return face.name;
        }
        if (segmentItem.consequence === "face-turn") {
            let heel;
            if (participants[0].objectName === "superstar") heel = pastFeudParticipants.find((x)=>x.alignment === "heel");
            else if (participants[0].objectName === "tagTeam") {
                for (const p of pastFeudParticipants)if ((await (0, $972Ip.getTagTeamSuperstars)(p)).every((x)=>x.alignment === "heel")) {
                    heel = p;
                    break;
                }
            }
            if (heel) return heel.name;
        }
    }
    if (segmentItem.requirement === "retiring" && segmentItem.consequence === "heel-turn") {
        if (participants[0].objectName === "superstar") return (0, $3E8Nt.getArrayMaxByProperty)(participants, "age").name;
        else if (participants[0].objectName === "tagTeam") {
            let tempParticipants = [
                ...participants
            ];
            for (const p of tempParticipants){
                let s = await (0, $5kTkA.getRosterMemberSuperstars)(p);
                p.age = Math.round(s.reduce((n, { age: age })=>n + age, 0) / s.length);
            }
            return (0, $3E8Nt.getArrayMaxByProperty)(tempParticipants, "age").name;
        }
    }
    return null;
}
async function $336089d6be28ba1c$var$checkBrandSegmentAndGetParticipants(segmentItem, participants, consequenceData) {
    // Returns array: [data, modified participants]
    let data = {};
    if (segmentItem.consequence === "draft-talent-to-brand") {
        // Get brand
        let brand = await (0, $14eBR.Brands).get(consequenceData["brandUid"]);
        if (!brand) {
            data["error"] = "brand-not-found";
            return [
                data,
                participants
            ];
        }
        // Get talent
        let talent;
        if (consequenceData["talentType"] === "superstar") talent = await (0, $14eBR.Superstars).get(consequenceData["talentUid"]);
        else talent = await (0, $14eBR.TagTeams).get(consequenceData["talentUid"]);
        if (!talent) {
            data["error"] = "talent-not-found";
            return [
                data,
                participants
            ];
        }
        if ((await (0, $5kTkA.getRosterMemberSuperstars)(talent)).some((x)=>x.brandName === brand.name)) {
            data["error"] = "already-on-brand";
            return [
                data,
                participants
            ];
        }
        participants.push(talent);
    }
    return [
        data,
        participants
    ];
}
async function $336089d6be28ba1c$var$checkManagerSegmentAndGetParticipants(segmentItem, participants, rosterSuperstars, managedTalentUid, managerUid) {
    // Returns array: [data, modified participants]
    let data = {};
    // Add managed talent for manager segments
    if ([
        "boost-managed-talent",
        "remove-managed-talent"
    ].includes(segmentItem.consequence)) {
        let managedTalent = await (0, $ycsyu.getManagerManagedTalent)(participants[0], rosterSuperstars, true);
        if (managedTalent.length <= 0) {
            data["error"] = "no-managed-talent";
            return [
                data,
                participants
            ];
        }
        // Get talent from managed talent
        let talent;
        if (managedTalentUid) talent = managedTalent.find((x)=>x.$loki === managedTalentUid);
        else talent = managedTalent[0];
        participants.push(talent);
    }
    // Get manager for remove manager segment
    if (segmentItem.consequence === "remove-manager") {
        let managerId = null;
        let manager = null;
        // Get manager if managing all participant superstars
        let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participants[0]);
        managerId = participantSuperstars.every((y)=>y.managerId === participantSuperstars[0].managerId) ? participantSuperstars[0].managerId : null;
        if (managerId) manager = rosterSuperstars.find((x)=>x.$loki === managerId);
        if (!manager) {
            data["error"] = "no-manager-present";
            return [
                data,
                participants
            ];
        }
        participants.unshift(manager);
    }
    // Get manager for add manager segment
    if (segmentItem.consequence === "add-manager") {
        // Get manager
        let manager = await (0, $14eBR.Superstars).get(managerUid);
        if (!manager) {
            data["error"] = "manager-not-found";
            return [
                data,
                participants
            ];
        }
        // Check participant superstars
        let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participants[0]);
        for (const s of participantSuperstars){
            if (s.managerId) {
                data["error"] = "manager-present";
                data["superstarName"] = s.name;
                return [
                    data,
                    participants
                ];
            }
            if (s.$loki === manager.$loki) {
                data["error"] = "managing-self";
                return [
                    data,
                    participants
                ];
            }
            if (s.fullTimeManager) {
                data["error"] = "managing-full-time-manager";
                return [
                    data,
                    participants
                ];
            }
        }
        // Check for maximum superstars for manager
        let managedSuperstars = [
            ...await (0, $hBIDz.getSuperstarManagedSuperstars)(manager)
        ];
        if (participantSuperstars.length + managedSuperstars.length > 15) {
            data["error"] = "maximum-superstars";
            return [
                data,
                participants
            ];
        }
        participants.unshift(manager);
    }
    return [
        data,
        participants
    ];
}
async function $336089d6be28ba1c$var$checkFactionSegmentConsequence(factions, segmentItem, consequenceData, rosterSuperstars, roster, event, companyChampionships) {
    let data = {};
    // Don't run consequence for disbanded faction
    if (factions.length > 0 && factions[0].disbanded) {
        data["error"] = "selected-disbanded-faction";
        return data;
    }
    // Faction superstar availability function
    function checkFactionSuperstarAvailability(superstar) {
        return (0, $5kTkA.checkAvailability)(superstar, true, true) && (0, $5kTkA.checkSuperstarBrandAvailability)(event, superstar, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(superstar, companyChampionships));
    }
    // Remove faction members
    if (segmentItem.consequence === "remove-faction-members") {
        let existingFactionSuperstars = await (0, $2JFAd.getFactionSuperstars)(factions[0]);
        // Get superstars to remove
        let superstarsToRemove = [];
        for (const superstarUid of consequenceData["superstarUids"]){
            let superstar = await (0, $14eBR.Superstars).get(superstarUid);
            // Check if superstar present, is in this faction and is available
            if (!superstar) {
                data["error"] = "faction-superstar-not-found";
                return data;
            }
            if (!(0, $3E8Nt.objectInArray)(superstar, existingFactionSuperstars)) {
                data["error"] = "not-member-of-faction";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data["error"] = "faction-superstar-not-available";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            superstarsToRemove.push(superstar);
        }
        // Remove duplicates
        superstarsToRemove = (0, $3E8Nt.getUniqueObjects)(superstarsToRemove);
        // Check if faction superstars are above 2
        if (existingFactionSuperstars.length - superstarsToRemove.length < 2) {
            data["error"] = "minimum-faction-superstars";
            return data;
        }
    }
    // Add faction members
    if (segmentItem.consequence === "add-faction-members") {
        let existingFactionSuperstars = await (0, $2JFAd.getFactionSuperstars)(factions[0]);
        // Get superstars to add
        let superstarsToAdd = [];
        for (const superstarUid of consequenceData["superstarUids"]){
            let superstar = await (0, $14eBR.Superstars).get(superstarUid);
            // Check if superstar present, not in this or any other faction and is available
            if (!superstar) {
                data["error"] = "faction-superstar-not-found";
                return data;
            }
            if ((0, $3E8Nt.objectInArray)(superstar, existingFactionSuperstars)) {
                data["error"] = "already-member-of-faction";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            if ((await (0, $5kTkA.getSuperstarActiveFactions)(superstar)).length > 0) {
                data["error"] = "already-in-faction";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data["error"] = "faction-superstar-not-available";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            superstarsToAdd.push(superstar);
        }
        // Remove duplicates
        superstarsToAdd = (0, $3E8Nt.getUniqueObjects)(superstarsToAdd);
        // Check if faction superstars are below maximum
        if (existingFactionSuperstars.length + superstarsToAdd.length > (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
            data["error"] = "maximum-faction-superstars";
            return data;
        }
    }
    // Leader consequences
    if ([
        "change-faction-leader",
        "add-faction-leader",
        "kick-out-faction-leader-and-change-leader"
    ].includes(segmentItem.consequence)) {
        let existingFactionSuperstars = await (0, $2JFAd.getFactionSuperstars)(factions[0]);
        let leaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(factions[0]);
        for (const superstarUid of consequenceData["superstarUids"]){
            let superstar = await (0, $14eBR.Superstars).get(superstarUid);
            // Check if new leader superstar is present, is in this faction, is not already leader and is available
            if (!superstar) {
                data["error"] = "faction-superstar-not-found";
                return data;
            }
            // Allow any superstar for add-faction-leader, otherwise only allow member of faction
            if (segmentItem.consequence !== "add-faction-leader" && !(0, $3E8Nt.objectInArray)(superstar, existingFactionSuperstars)) {
                data["error"] = "leader-superstar-not-present";
                return data;
            }
            if (leaderSuperstar && superstar.$loki === leaderSuperstar.$loki) {
                data["error"] = "select-non-faction-leader";
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data["error"] = "faction-superstar-not-available";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
        }
        // Check if faction superstars are above 2 for kicking out leader
        if (segmentItem.consequence === "kick-out-faction-leader-and-change-leader") {
            if (existingFactionSuperstars.length - 1 < 2) {
                data["error"] = "minimum-faction-superstars";
                return data;
            }
        }
    }
    // Join other faction
    if (segmentItem.consequence === "leave-faction-and-join-other-faction") {
        let factionToJoin = await (0, $14eBR.Factions).get(consequenceData["factionConsequenceUids"][0]);
        // Check faction to join is present, is active and not the same as existing faction
        if (!factionToJoin) {
            data["error"] = "faction-not-found";
            return data;
        }
        if (factionToJoin.disbanded) {
            data["error"] = "selected-disbanded-faction";
            return data;
        }
        if (factionToJoin.$loki === factions[0].$loki) {
            data["error"] = "selected-existing-faction";
            return data;
        }
        let existingFactionSuperstars = await (0, $2JFAd.getFactionSuperstars)(factions[0]);
        let factionToJoinSuperstars = await (0, $2JFAd.getFactionSuperstars)(factionToJoin);
        // Get superstars to move
        let superstarsToMove = [];
        for (const superstarUid of consequenceData["superstarUids"]){
            let superstar = await (0, $14eBR.Superstars).get(superstarUid);
            // Check if superstar present, in this faction, not in faction to join and is available
            if (!superstar) {
                data["error"] = "faction-superstar-not-found";
                return data;
            }
            if (!(0, $3E8Nt.objectInArray)(superstar, existingFactionSuperstars)) {
                data["error"] = "not-member-of-faction";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            if ((0, $3E8Nt.objectInArray)(superstar, factionToJoinSuperstars)) {
                data["error"] = "already-member-of-faction";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data["error"] = "faction-superstar-not-available";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            superstarsToMove.push(superstar);
        }
        // Remove duplicates
        superstarsToMove = (0, $3E8Nt.getUniqueObjects)(superstarsToMove);
        // Check if existing faction's superstars are above 2
        if (existingFactionSuperstars.length - superstarsToMove.length < 2) {
            data["error"] = "minimum-faction-superstars";
            return data;
        }
        // Check if faction to join's superstars are below maximum
        if (factionToJoinSuperstars.length + superstarsToMove.length > (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
            data["error"] = "maximum-faction-superstars";
            return data;
        }
    }
    // Merge factions
    if (segmentItem.consequence === "merge-factions") {
        let factionToMerge = await (0, $14eBR.Factions).get(consequenceData["factionConsequenceUids"][0]);
        // Check faction to merge is present, is active and not the same as existing faction
        if (!factionToMerge) {
            data["error"] = "faction-not-found";
            return data;
        }
        if (factionToMerge.disbanded) {
            data["error"] = "selected-disbanded-faction";
            return data;
        }
        if (factionToMerge.$loki === factions[0].$loki) {
            data["error"] = "selected-existing-faction";
            return data;
        }
        // Check created faction name
        let createdFactionName = consequenceData["createdFactionName"];
        if (!createdFactionName) {
            data["error"] = "faction-name-not-entered";
            return data;
        }
        // Check if faction already exists
        let otherActiveFactions = (await (0, $6PzHO.getRosterActiveFactions)(roster)).filter((x)=>x.$loki !== factions[0].$loki && x.$loki !== factionToMerge.$loki);
        if (otherActiveFactions.find((x)=>x.name === createdFactionName)) {
            data["error"] = "faction-already-present";
            return data;
        }
        // Check if team already exists
        if ((await (0, $dl5u4.getRosterTagTeams)(roster)).find((x)=>x.name === createdFactionName)) {
            data["error"] = "team-already-present";
            return data;
        }
        let existingFactionSuperstars = await (0, $2JFAd.getFactionSuperstars)(factions[0]);
        let factionToMergeSuperstars = await (0, $2JFAd.getFactionSuperstars)(factionToMerge);
        // Check if resulting faction's superstars are below maximum
        if (factionToMergeSuperstars.length + existingFactionSuperstars.length > (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
            data["error"] = "maximum-faction-superstars";
            return data;
        }
    }
    // Split faction
    if (segmentItem.consequence === "split-faction") {
        let existingFactionSuperstars = await (0, $2JFAd.getFactionSuperstars)(factions[0]);
        // Check created faction name
        let createdFactionName = consequenceData["createdFactionName"];
        if (!createdFactionName) {
            data["error"] = "faction-name-not-entered";
            return data;
        }
        // Check if faction already exists
        if ((await (0, $6PzHO.getRosterActiveFactions)(roster)).find((x)=>x.name === createdFactionName)) {
            data["error"] = "faction-already-present";
            return data;
        }
        // Check if team already exists
        if ((await (0, $dl5u4.getRosterTagTeams)(roster)).find((x)=>x.name === createdFactionName)) {
            data["error"] = "team-already-present";
            return data;
        }
        // Get superstars to move
        let superstarsToMove = [];
        for (const superstarUid of consequenceData["superstarUids"]){
            let superstar = await (0, $14eBR.Superstars).get(superstarUid);
            // Check if superstar present, in this faction and is available
            if (!superstar) {
                data["error"] = "faction-superstar-not-found";
                return data;
            }
            if (!(0, $3E8Nt.objectInArray)(superstar, existingFactionSuperstars)) {
                data["error"] = "not-member-of-faction";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data["error"] = "faction-superstar-not-available";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            superstarsToMove.push(superstar);
        }
        // Remove duplicates
        superstarsToMove = (0, $3E8Nt.getUniqueObjects)(superstarsToMove);
        // Check if existing faction's superstars are above 2
        if (existingFactionSuperstars.length - superstarsToMove.length < 2) {
            data["error"] = "minimum-faction-superstars";
            return data;
        }
        // Check if new faction superstars are above 2
        if (superstarsToMove.length < 2) {
            data["error"] = "minimum-faction-superstars";
            return data;
        }
    }
    // Create faction
    if (segmentItem.consequence === "create-faction") {
        // Check created faction name
        let createdFactionName = consequenceData["createdFactionName"];
        if (!createdFactionName) {
            data["error"] = "faction-name-not-entered";
            return data;
        }
        // Check if faction already exists
        if ((await (0, $6PzHO.getRosterActiveFactions)(roster)).find((x)=>x.name === createdFactionName)) {
            data["error"] = "faction-already-present";
            return data;
        }
        // Check if team already exists
        if ((await (0, $dl5u4.getRosterTagTeams)(roster)).find((x)=>x.name === createdFactionName)) {
            data["error"] = "team-already-present";
            return data;
        }
        // Get superstars to add
        let superstarsToAdd = [];
        for (const superstarUid of consequenceData["superstarUids"]){
            let superstar = await (0, $14eBR.Superstars).get(superstarUid);
            // Check if superstar present, not in faction and is available
            if (!superstar) {
                data["error"] = "faction-superstar-not-found";
                return data;
            }
            if ((await (0, $5kTkA.getSuperstarActiveFactions)(superstar)).length > 0) {
                data["error"] = "already-in-faction";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            if (!checkFactionSuperstarAvailability(superstar)) {
                data["error"] = "faction-superstar-not-available";
                data["errorSuperstarName"] = superstar.name;
                return data;
            }
            superstarsToAdd.push(superstar);
        }
        // Remove duplicates
        superstarsToAdd = (0, $3E8Nt.getUniqueObjects)(superstarsToAdd);
        // Get leader superstar
        if (consequenceData["leaderUid"]) {
            let leaderSuperstar = await (0, $14eBR.Superstars).get(consequenceData["leaderUid"]);
            // Check if present in faction superstars
            if (leaderSuperstar && !(0, $3E8Nt.objectInArray)(leaderSuperstar, superstarsToAdd)) {
                data["error"] = "leader-superstar-not-present";
                return data;
            }
        }
        // Check if number of superstars are between 2 and maximum
        if (superstarsToAdd.length < 2) {
            data["error"] = "minimum-faction-superstars";
            return data;
        }
        if (superstarsToAdd.length > (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
            data["error"] = "maximum-faction-superstars";
            return data;
        }
    }
    return data;
}
async function $336089d6be28ba1c$var$addProducerSegmentTask(producer, segment, segmentItem) {
    if (!segmentItem) segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(segment);
    producer.currentTask = `Producing ${segmentItem.name} Segment`;
    producer.taskData = {
        "segment_id": segment.$loki
    };
    return true;
}
async function $336089d6be28ba1c$export$9bc052c1baf11858(participants, feuds, segmentItem) {
    if (segmentItem.productionSegment) return 0;
    let feudHype = $336089d6be28ba1c$export$7b5a40f91c0455f2(feuds, participants);
    let participantsHype = await $336089d6be28ba1c$export$c072c73f0c7fcfce(participants);
    let segmentItemHype = $336089d6be28ba1c$var$getHypeForSegmentItem(segmentItem);
    return Math.floor(feudHype + participantsHype + segmentItemHype);
}
function $336089d6be28ba1c$export$7b5a40f91c0455f2(feuds, participants) {
    let hype = 0;
    for (const feud of feuds)if (feud.started) {
        hype += feud.hype / 4;
        if (feud.hot) hype += 15;
        if (feud.stale) hype -= 15;
    }
    if (participants.length > 10) hype *= 0.3;
    else if (participants.length > 2) hype *= 0.7;
    hype = (0, $3E8Nt.limitValueBetweenRange)(hype, hype, 100);
    return hype;
}
async function $336089d6be28ba1c$export$c072c73f0c7fcfce(participants) {
    let hype = 0;
    let brandsPresent = [];
    for (const p of participants){
        let s = await (0, $5kTkA.getRosterMemberSuperstars)(p);
        if (await (0, $3E8Nt.getRosterMemberRank)(p, s) === "Main Eventer") hype += 5;
        if (s.some((x)=>x.hot)) hype += 15;
        if (s.some((x)=>x.stale)) hype -= 15;
        for (const x of s)if (x.brandName) brandsPresent.push(x.brandName);
    }
    // Boost hype if more than one brand present
    if ([
        ...new Set(brandsPresent)
    ].length > 1) hype += 15;
    hype = (0, $3E8Nt.limitValueBetweenRange)(hype, -80, 80);
    return hype;
}
function $336089d6be28ba1c$var$getHypeForSegmentItem(segmentItem) {
    let hype = 0;
    let total = segmentItem.action + segmentItem.entertainment;
    if (total <= 3) hype = total * 5;
    else if (total <= 4) hype = total * 10;
    else hype = total * 20;
    if (segmentItem.consequence) hype += 15;
    return hype;
}
async function $336089d6be28ba1c$var$getFactionTemporaryTagTeam(participant, factionSuperstars, mainRoster) {
    let temporaryFactionTeam = (await (0, $dl5u4.getRosterTagTeams)(mainRoster)).find((x)=>x.name === participant.name && x.temporary);
    // Check if temporary faction team already made
    let temporaryFactionTeamSuperstars = temporaryFactionTeam ? await (0, $972Ip.getTagTeamSuperstars)(temporaryFactionTeam) : [];
    if (temporaryFactionTeam && temporaryFactionTeamSuperstars.length === factionSuperstars.length && temporaryFactionTeamSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, factionSuperstars))) return temporaryFactionTeam;
    else {
        const newTagTeam = (0, $972Ip.TagTeam)(participant.name, true);
        newTagTeam.factionTagTeam = true;
        await (0, $14eBR.TagTeams).insert(newTagTeam);
        await (0, $972Ip.addTagTeamSuperstars)(newTagTeam, factionSuperstars);
        await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
            newTagTeam
        ]);
        return newTagTeam;
    }
}
async function $336089d6be28ba1c$export$6a7d693a7b69a150({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    let eventSegments = await (0, $iQtzn.getEventSegments)(latestEvent);
    const eventMatches = await (0, $iQtzn.getEventMatches)(latestEvent);
    const segment = eventSegments.find((x)=>x.$loki === uid);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const producers = await (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
    // Don't allow deleting 'Welcome to POW' promo at premier event in POW
    if (userCompany.storyName === "passion") {
        const segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(segment);
        const sponsorGoal = (await (0, $9esFv.getCompanyObjectives)(userCompany)).find((x)=>x.name === "Get some Sponsors");
        if (!sponsorGoal.completed && !sponsorGoal.failed && segmentItem.name === "Welcome to POW") {
            data["error"] = "pow-cannot-delete";
            return data;
        }
    }
    // Delete segment
    await $336089d6be28ba1c$export$b68702c79c55865d(segment, producers);
    // Subtract from event's matchesCount
    latestEvent.matchesCount -= 1;
    // Reset event's matches and segments order
    eventSegments = eventSegments.filter((x)=>x.$loki !== segment.$loki);
    let segmentsAndMatches = eventSegments.concat(eventMatches);
    segmentsAndMatches.sort((a, b)=>a.order - b.order);
    for (const x of segmentsAndMatches)x.order = segmentsAndMatches.indexOf(x);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $336089d6be28ba1c$export$b68702c79c55865d(segment, producers) {
    // Remove feuds
    for (const feud of (await (0, $eg5dz.getSegmentFeuds)(segment)))// Delete potential feuds
    if (!feud.started && !feud.directFeudEvent) {
        await (0, $14eBR.FeudParticipantsHash).findAndRemove({
            "feudId": feud.$loki
        });
        await (0, $14eBR.Feuds).remove(feud);
    }
    // Reset special segment item
    const segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(segment);
    if (segmentItem && segmentItem.special) segmentItem.used = false;
    // Remove producer task
    const segmentProducer = $336089d6be28ba1c$var$getSegmentProducer(segment, producers);
    if (segmentProducer) (0, $8A6FL.removeStaffTaskData)(segmentProducer);
    // Delete from db
    await (0, $14eBR.FeudSegmentsHash).findAndRemove({
        "segmentId": segment.$loki
    });
    await (0, $14eBR.SegmentParticipantsHash).findAndRemove({
        "segmentId": segment.$loki
    });
    await (0, $14eBR.Segments).remove(segment);
    return true;
}
async function $336089d6be28ba1c$export$11723d5430c81fe3({ segmentUid: segmentUid, producerUid: producerUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const producers = await (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "not-paid";
        return data;
    }
    // Get segment
    const segment = await (0, $14eBR.Segments).get(segmentUid);
    if (!segment) {
        data["error"] = "segment-not-found";
        return data;
    }
    // Get producer
    const producer = producers.find((x)=>x.$loki === producerUid);
    if (!producer) {
        data["error"] = "producer-not-found";
        return data;
    }
    // Check for current task
    if (producer.currentTask) {
        data["error"] = "producer-task-present";
        data["producer"] = producer.name;
        return data;
    }
    // Add producer task
    await $336089d6be28ba1c$var$addProducerSegmentTask(producer, segment);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["segment"] = await $336089d6be28ba1c$export$7d69ed11e8e03a89({
        segment: segment,
        rosterSuperstars: rosterSuperstars,
        producers: producers
    });
    return data;
}
async function $336089d6be28ba1c$export$6f980415cfe88d34({ segmentUid: segmentUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const producers = await (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
    // Get segment
    const segment = await (0, $14eBR.Segments).get(segmentUid);
    if (!segment) {
        data["error"] = "segment-not-found";
        return data;
    }
    // Get producer
    const producer = $336089d6be28ba1c$var$getSegmentProducer(segment, producers);
    if (!producer) {
        data["error"] = "no-producer-assigned";
        return data;
    }
    // Remove producer task
    (0, $8A6FL.removeStaffTaskData)(producer);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["segment"] = await $336089d6be28ba1c$export$7d69ed11e8e03a89({
        segment: segment,
        rosterSuperstars: rosterSuperstars,
        producers: producers
    });
    return data;
}
async function $336089d6be28ba1c$export$cb564f394db2944f({ winnerName: winnerName, uid: uid, graphics: graphics } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
    const indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
    // Get segment
    const eventSegments = await (0, $iQtzn.getEventSegments)(latestEvent);
    const segment = eventSegments.find((x)=>x.$loki === uid);
    try {
        data = await $336089d6be28ba1c$export$1387bd61f30c74fa(segment, winnerName, eventSegments, latestEvent, userCompany, mainCompany, currentGame, mainRoster, indieRoster, indieAvailableRoster, graphics);
        // Check tutorial action
        if (userCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
            "play_second_event",
            "play_second_event_second_segment"
        ]);
        (0, $14eBR.db).saveDatabase();
    } catch (error) {
        data["error"] = true;
        await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
        // Check if any empty teams present, return in error
        const segment = await (0, $14eBR.Segments).get(uid);
        const tagTeams = await (0, $eg5dz.getSegmentTagTeams)(segment);
        for (const tagTeam of tagTeams)if (!(await (0, $972Ip.getTagTeamSuperstars)(tagTeam)).length) {
            data["error"] = "team-members-not-found";
            data["teamName"] = tagTeam.name;
            break;
        }
        if (data["error"] !== "team-members-not-found") (0, $3E8Nt.captureError)(error);
    }
    return data;
}
async function $336089d6be28ba1c$export$1387bd61f30c74fa(segment, winnerName, eventSegments, event, company, mainCompany, game, mainRoster, indieRoster, indieAvailableRoster, graphics, rosterSuperstars = null, companyChampionships = null, staffMembers = null, segmentsAndMatches = null) {
    try {
        let data = {};
        const segmentParticipants = await (0, $eg5dz.getSegmentParticipants)(segment);
        const segmentFeuds = await (0, $eg5dz.getSegmentFeuds)(segment);
        const segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(segment);
        const month = game.monthCount;
        const year = game.year;
        if (!staffMembers) staffMembers = await (0, $9esFv.getCompanyStaff)(company);
        if (!companyChampionships) companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
        if (!rosterSuperstars) rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        if (!segmentsAndMatches) segmentsAndMatches = await (0, $5ZsVo.getEventMatchesAndSegments)(event);
        // Check if weekly show
        const weeklyShow = event.weeklyShow || event.name === "Weekly Show";
        // Check if main event
        segmentsAndMatches.sort((a, b)=>a.order - b.order);
        const mainEvent = segment.$loki === segmentsAndMatches[0].$loki && segment.objectName === segmentsAndMatches[0].objectName;
        // Declare variables
        let purePositiveBoost = null;
        let pureNegativeBoost = null;
        let updateGraphics = null;
        // Declare arrays
        data["vacated"] = [];
        data["createdChampionships"] = [];
        data["fired"] = [];
        data["feudPotentials"] = [];
        data["feudHypeIncreased"] = [];
        data["feudsEnded"] = [];
        data["awarded"] = [];
        data["feudItemsLevelData"] = [];
        data["unlockedFeudItems"] = [];
        data["turnedHeel"] = [];
        data["turnedFace"] = [];
        data["turnedNeutral"] = [];
        data["feudsStarted"] = [];
        data["disbanded"] = [];
        data["debutedGimmicks"] = [];
        data["staffSkillIncreases"] = [];
        data["championshipPrestiges"] = [];
        data["unlockedChampionshipSegmentItems"] = [];
        data["unavailable"] = [];
        data["suspended"] = [];
        data["retirements"] = [];
        data["teamsCreated"] = [];
        data["managersAdded"] = [];
        data["managersRemoved"] = [];
        data["factionReputationsData"] = [];
        data["brandChanges"] = [];
        data["maskRemoved"] = [];
        // Get segment superstars
        let segmentSuperstars = [];
        for (const x of segmentParticipants){
            let s = await (0, $5kTkA.getRosterMemberSuperstars)(x);
            x.tempSuperstars = s;
            segmentSuperstars.push(...s);
        }
        // Set stating morale for matchSuperstars
        for (const x of segmentSuperstars){
            x.startingMorale = x.morale;
            x.startingOverness = x.overness;
        }
        // Get winner
        let winnerParticipant = segmentParticipants.find((x)=>x.name === winnerName);
        // Get producer
        let producer;
        const producers = (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
        const assignedProducer = $336089d6be28ba1c$var$getSegmentProducer(segment, producers);
        // Get assigned producer if present, otherwise select random/highest level producer
        if (assignedProducer) producer = assignedProducer;
        else if (producers.length > 0) {
            if (segmentItem.requirement && (segmentItem.requirement.includes("level-2-producer") || segmentItem.requirement.includes("level-3-producer"))) producer = (0, $8A6FL.getHighestLevelStaffMemberByRole)(producers, "producer");
            else producer = (0, $8A6FL.getRandomStaffMemberByRole)(producers, "producer");
        }
        // Set winner for no winner segment
        if (!winnerParticipant) {
            if (segment.consequenceAppliedTo) winnerParticipant = segmentParticipants.find((x)=>x.name === segment.consequenceAppliedTo);
            else if (segmentItem.maxParticipants > 0 || segmentItem.consequence === "draft-talent-to-brand") winnerParticipant = (0, $3E8Nt.getRandomChoice)(segmentParticipants);
        }
        // Get segment championships
        let segmentChampionship = null;
        if (segmentItem.consequence === "award-title") {
            if (segment.consequenceData) {
                const championshipUid = segment.consequenceData["championshipUid"];
                if (championshipUid) {
                    segmentChampionship = await (0, $14eBR.Championships).get(championshipUid);
                    if (segmentChampionship) segmentChampionship = companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, segmentChampionship));
                }
            }
        } else segmentChampionship = await $336089d6be28ba1c$var$getSegmentParticipantsChampionship(segmentParticipants);
        // Convert segment championship(s) to list
        let segmentChampionships = [];
        if (segmentChampionship) {
            if (Array.isArray(segmentChampionship)) segmentChampionships = segmentChampionship;
            else segmentChampionships = [
                segmentChampionship
            ];
        }
        // Get participants data
        data["participantsData"] = [];
        for (const x of [
            ...segmentParticipants
        ]){
            const participantData = {};
            participantData["name"] = x.name;
            participantData["uid"] = x.$loki;
            participantData["pronoun"] = x.possessivePronoun;
            participantData["startingOverness"] = await (0, $3E8Nt.getRosterMemberOverness)(x);
            participantData["gimmickEffectivenessChange"] = 0;
            participantData["moraleChange"] = 0;
            participantData["hot"] = x.tempSuperstars.every((s)=>s.hot);
            participantData["stale"] = x.tempSuperstars.every((s)=>s.stale);
            participantData["managersData"] = await (0, $3SyPM.getParticipantManagersData)(x, segment.managersUsed, rosterSuperstars);
            data["participantsData"].push(participantData);
        }
        // Remove gimmick change boost before segment runs
        for (const s of segmentSuperstars){
            const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(s);
            if (superstarGimmick && superstarGimmick.nextGimmickBoost) superstarGimmick.nextGimmickBoost = false;
        }
        // Get managers present in segment
        const segmentManagers = [];
        const segmentFullTimeManagers = [];
        for (const s of segmentSuperstars){
            const superstarManager = await (0, $5kTkA.getSuperstarManagerUsedForMatchOrSegment)(s, segment.managersUsed, rosterSuperstars);
            if (superstarManager && !(0, $3E8Nt.objectInArray)(superstarManager, segmentManagers)) {
                segmentManagers.push(superstarManager);
                // Add manager to segment if full time
                if (superstarManager.fullTimeManager && !(0, $3E8Nt.objectInArray)(superstarManager, segmentFullTimeManagers)) segmentFullTimeManagers.push(superstarManager);
            }
        }
        // Add managers to participant/superstars list with managers
        const participantsWithManagers = [
            ...segmentParticipants
        ];
        const segmentSuperstarsWithManagers = [
            ...segmentSuperstars
        ];
        participantsWithManagers.push(...segmentFullTimeManagers);
        segmentSuperstarsWithManagers.push(...segmentFullTimeManagers);
        // Get managed participant for manager segments
        let managedParticipant;
        let managedSuperstars = [];
        if ([
            "boost-managed-talent",
            "add-manager",
            "remove-manager",
            "remove-managed-talent"
        ].includes(segmentItem.consequence)) {
            data["managerSegment"] = true;
            managedParticipant = segmentParticipants.find((x)=>x.objectName === "tagTeam" || x.managerId);
            if (managedParticipant) {
                managedSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(managedParticipant);
                if (segmentItem.consequence === "boost-managed-talent") {
                    // Remove from participants so segment rating is only based on manager
                    participantsWithManagers.splice(participantsWithManagers.indexOf(managedParticipant), 1);
                    for (const y of managedSuperstars)segmentSuperstarsWithManagers.splice(segmentSuperstarsWithManagers.indexOf(y), 1);
                }
                // Set managed participant as winner
                winnerParticipant = managedParticipant;
            }
        }
        // Check if segment already held
        const segmentAlreadyHeld = await $336089d6be28ba1c$var$checkSegmentAlreadyHeld(segment, segmentItem, event, eventSegments, segmentFeuds);
        // Get boosts for silly/action segments in pure companies
        if (company.style === "pure" && (0, $3E8Nt.getRandomInt)(0, 100) <= 40) {
            if (segmentItem.silly) pureNegativeBoost = true;
            else if (segmentItem.action > segmentItem.entertainment && segmentItem.action > 1) purePositiveBoost = true;
        }
        // Get rating
        let ratingData;
        let talentDebutRelationship = await $336089d6be28ba1c$var$getTalentDebutRelationship(segmentItem, segmentParticipants, company);
        if (segmentItem.productionSegment || !segmentParticipants.length) // Use producer to get rating if production segment or no participants present (competitor buyout etc)
        ratingData = $336089d6be28ba1c$var$getProductionSegmentRating(producer, segmentAlreadyHeld, assignedProducer);
        else ratingData = await $336089d6be28ba1c$var$getSegmentRating(segmentItem, participantsWithManagers, purePositiveBoost, pureNegativeBoost, segmentSuperstarsWithManagers, segmentAlreadyHeld, talentDebutRelationship, assignedProducer, company.storyName);
        const rating = ratingData["rating"];
        const effectiveness = ratingData["effectiveness"];
        data["ratingData"] = ratingData;
        segment.rating = rating;
        // Set participants
        segment.participants = segmentParticipants.map((x)=>x.name);
        // Run consequences
        let shockingTurn = false;
        let turnTooSoon = false;
        if (segmentItem.consequence) {
            const consequenceResults = await $336089d6be28ba1c$var$runSegmentConsequence(segmentItem, segment, segmentParticipants, company, mainCompany, game, month, year, indieRoster, indieAvailableRoster, winnerParticipant, graphics, segmentManagers);
            shockingTurn = consequenceResults["shockingTurn"];
            turnTooSoon = consequenceResults["turnTooSoon"];
            data["consequenceResults"] = consequenceResults;
            data["vacated"] = consequenceResults["vacated"];
            data["fired"] = consequenceResults["fired"];
            data["feudsEnded"] = consequenceResults["feudsEnded"];
            data["awarded"] = consequenceResults["awarded"];
            data["createdChampionships"] = consequenceResults["createdChampionships"];
            data["feudItemsLevelData"] = consequenceResults["feudItemsLevelData"];
            data["unlockedFeudItems"] = consequenceResults["unlockedFeudItems"];
            data["turnedHeel"] = consequenceResults["turnedHeel"];
            data["turnedFace"] = consequenceResults["turnedFace"];
            data["turnedNeutral"] = consequenceResults["turnedNeutral"];
            data["feudsStarted"] = consequenceResults["feudsStarted"];
            data["feudPotentials"] = consequenceResults["feudPotentials"];
            data["feudHypeIncreased"] = consequenceResults["feudHypeIncreased"];
            data["disbanded"] = consequenceResults["disbanded"];
            data["consequenceRunOn"] = consequenceResults["consequenceRunOn"];
            data["hypeBoostAdded"] = consequenceResults["hypeBoostAdded"];
            data["mainEventHype"] = consequenceResults["mainEventHype"];
            data["eventHype"] = consequenceResults["eventHype"];
            data["popularityBoostAdded"] = consequenceResults["popularityBoostAdded"];
            data["unavailable"] = consequenceResults["unavailable"];
            data["suspended"] = consequenceResults["suspended"];
            data["retirements"] = consequenceResults["retirements"];
            data["teamsCreated"] = consequenceResults["teamsCreated"];
            data["factionSegmentConsequence"] = consequenceResults["factionSegmentConsequence"];
            data["factionReputationsData"] = consequenceResults["factionReputationsData"];
            data["managersAdded"] = consequenceResults["managersAdded"];
            data["managersRemoved"] = consequenceResults["managersRemoved"];
            data["brandChanges"] = consequenceResults["brandChanges"];
            data["maskRemoved"] = consequenceResults["maskRemoved"];
            data["unifiedChampionships"] = consequenceResults["unifiedChampionships"];
            // Check whether to update graphics
            if (consequenceResults["graphics"]) {
                updateGraphics = true;
                graphics = consequenceResults["graphics"];
            }
        } else // Add consequenceRunOn to show name in results section
        if (segmentItem.requirement === "buyout-offer-accepted") {
            const competitor = (await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game)).find((c)=>c.operatingStatus.includes("Negotiating Buyout"));
            data["consequenceRunOn"] = competitor.name;
        }
        // Special segment consequence
        if (segmentItem.special) {
            data["specialSegmentConsequence"] = await $336089d6be28ba1c$var$runSpecialSegmentConsequence(segmentItem, segment, segmentParticipants, company, mainCompany, staffMembers, game, month, year);
            // Add special segments to company logs
            let newLog = (0, $4K85d.CompanyLog)(month, year);
            newLog.text = `${segmentItem.name} with ${segmentParticipants[0].name}`;
            newLog.type = "special-segment";
            await (0, $14eBR.CompanyLogs).insert(newLog);
            await (0, $9esFv.addCompanyCompanyLogs)(company, [
                newLog
            ]);
            if (company.userControlled && game.settings["no_special_items_cooldown"]) segmentItem.used = false;
        }
        // Get hype, popularity and xp changes, hot
        const hotSegment = $336089d6be28ba1c$var$checkSegmentHot(segment, segmentParticipants, segmentSuperstars, segmentFeuds, shockingTurn, turnTooSoon, segmentItem.special);
        const [baseHypeChange, popularityChange, sillySuccess, sillyFailure] = $336089d6be28ba1c$var$getSegmentBoosts(rating, segmentItem, hotSegment);
        const trainer = (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "trainer");
        const trainerLevel = trainer ? trainer.level : 1;
        const xpGained = $336089d6be28ba1c$var$getSegmentXps(rating, segment.order, segmentItem.difficulty, trainerLevel);
        // Update segment item prestige
        let segmentItemLevelData = null;
        const unlockedSegmentItems = [];
        if ((0, $98xmD.globalUser).paid && !segmentItem.special) {
            let levelIncrease = false;
            let addedPerk = null;
            // Add xp
            const increase = Math.floor(Math.pow(rating, 2));
            segmentItem.xp += increase;
            // Check level increase
            if (segmentItem.level < 3 && segmentItem.xp >= Math.pow(segmentItem.level, 2) * 75) {
                segmentItem.level += 1;
                levelIncrease = true;
                // Add perk if level increase
                addedPerk = $336089d6be28ba1c$var$addPerkToSegmentItem(segmentItem);
            }
            // Prepare data
            segmentItemLevelData = {
                "name": segmentItem.name,
                "xp": segmentItem.xp,
                "xpChange": increase,
                "level": segmentItem.level,
                "levelIncrease": levelIncrease,
                "addedPerk": addedPerk
            };
            const unlocked = $336089d6be28ba1c$var$checkSegmentItemsToUnlock(segmentItem, await (0, $9esFv.getCompanySegmentItems)(company));
            unlockedSegmentItems.push(...unlocked);
        }
        // Process feuds
        let feudsData = [];
        let hotFeuds = [];
        for (const feud of segmentFeuds){
            // Get participants and superstars
            let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
            let feudSuperstars = (await Promise.all(feudParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            // Check hot
            let hotFeud = (0, $3SyPM.checkFeudHot)(feud, segment.rating, feudSuperstars);
            let hotFeudHypeBoost = 0;
            if (hotFeud) {
                if (!hotSegment) hotFeudHypeBoost = (0, $3E8Nt.getRandomInt)(15, 20);
                if (feudParticipants.map((x)=>x.name).includes(company.ownerName)) await (0, $3SyPM.unlockSpecialSegment)(company, "Anti-Company Rant", month, year);
            }
            let started;
            const feudItem = await (0, $jDtEn.getFeudFeudItem)(feud);
            if (!feud.started) {
                // Start feud
                started = false;
                feud.started = true;
                if (feud.startMonth === null) {
                    feud.startMonth = month;
                    feud.startYear = year;
                }
                // Remove any added blowoffs
                feud.runBlowoff = false;
                // Add hype
                let boosts = await (0, $cXLSF.getFeudCreationBoosts)(feud, feudParticipants, month, year, company.style);
                feud.hype = feudItem.baseHype + boosts["hypeBoost"];
                // Get feud started data
                data["feudsStarted"].push({
                    "name": feud.name,
                    "participants": feudParticipants.map((x)=>x.name),
                    "boosts": boosts,
                    "baseHype": feudItem.baseHype
                });
                // Check talent request and update morale
                for (const feudParticipant of feudParticipants){
                    let otherFeudParticipant = feudParticipants.find((x)=>x.$loki !== feudParticipant.$loki);
                    if (otherFeudParticipant) {
                        // Check feud_with_x talent request
                        let requestData = {
                            "talentId": otherFeudParticipant.$loki
                        };
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "feud_with_x",
                            talent: feudParticipant,
                            data: requestData
                        });
                        // Update morale for feud started
                        let popularityDifference = await (0, $3E8Nt.getRosterMemberPopularity)(feudParticipant) - await (0, $3E8Nt.getRosterMemberPopularity)(otherFeudParticipant);
                        let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                            changeType: "feud_started",
                            popularityDifference: popularityDifference,
                            feudParticipants: [
                                feudParticipant,
                                otherFeudParticipant
                            ]
                        });
                        for (let s of (await (0, $5kTkA.getRosterMemberSuperstars)(feudParticipant)))(0, $5kTkA.updateSuperstarMorale)(s, moraleChange);
                    }
                }
            }
            // Get feud superstars present in match
            const feudSuperstarsPresentInMatch = feudSuperstars.filter((x)=>(0, $3E8Nt.objectInArray)(x, segmentSuperstars));
            // Get trait boost for feud hype change
            let feudHypeTraitBoost = 0;
            for (const feudSuperstar of feudSuperstarsPresentInMatch)for (const trait of feudSuperstar.traits){
                const traitData = (0, $aP7lq.traitsData)[trait];
                if (traitData && traitData["feud_hype_change_boost"]) feudHypeTraitBoost += traitData["feud_hype_change_boost"];
            }
            feudHypeTraitBoost = (0, $3E8Nt.limitValueBetweenRange)(feudHypeTraitBoost, -6, 6);
            // Check staleness
            let stale = false;
            let staleWarning = false;
            let stalenessHypeDecrease = 0;
            let staleFeudOvernessDecrease = 0;
            const staleLength = await (0, $cXLSF.getMatchesForStaleFeud)(feud, feudParticipants);
            // Decrease hype if stale
            if (feud.stale) stalenessHypeDecrease = Math.round(feud.stalenessCounter * -1);
            // Check for feud staleness
            if (feud.stalenessCounter >= staleLength && !feud.stale) {
                staleWarning = true;
                if (feud.stalenessCounter > staleLength) {
                    stale = true;
                    feud.stale = true;
                    feud.hot = false;
                    stalenessHypeDecrease = Math.round(feud.stalenessCounter ** 1.5 * -1);
                    // Decrease overness for superstars
                    staleFeudOvernessDecrease = Math.floor(feud.stalenessCounter * 2);
                    staleFeudOvernessDecrease = (0, $3E8Nt.limitValueBetweenRange)(staleFeudOvernessDecrease, staleFeudOvernessDecrease, 16);
                    staleFeudOvernessDecrease *= -1;
                    for (let s of feudSuperstars)updateOverness(s, staleFeudOvernessDecrease);
                }
            }
            // Add hype change to feud
            let feudHypeChange = baseHypeChange + hotFeudHypeBoost + feudHypeTraitBoost + stalenessHypeDecrease;
            feudHypeChange = Math.round(feudHypeChange);
            if (feudHypeChange) feud.hype += feudHypeChange;
            // Add to staleness counter
            feud.stalenessCounter += 0.25;
            // Get feud data
            const feudData = {
                name: feud.name,
                participants: feudParticipants.map((x)=>x.name),
                hype: feud.hype,
                baseHype: feud.hype - feudHypeChange,
                hypeChange: feudHypeChange,
                ended: feud.ended,
                stale: stale,
                staleWarning: staleWarning,
                rating: feud.rating,
                hot: hotFeud,
                overnessDecrease: staleFeudOvernessDecrease * -1
            };
            feudsData.push(feudData);
            if (hotFeud) {
                // Increase overness for superstars
                const overnessIncrease = (0, $3E8Nt.getRandomInt)(3, 5);
                for (let s of feudSuperstars)updateOverness(s, overnessIncrease);
                feudData["overnessIncrease"] = overnessIncrease;
                // Update morale for hot feud
                for (const x of segmentSuperstars){
                    const moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                        changeType: "hot_feud"
                    });
                    (0, $5kTkA.updateSuperstarMorale)(x, moraleChange);
                }
                hotFeuds.push(feudData);
            }
        }
        data["feuds"] = feudsData;
        data["hotFeuds"] = hotFeuds;
        // Update popularity
        data["popularityChange"] = popularityChange;
        if (popularityChange && segmentParticipants.length > 0) {
            // Update popularity for all superstars if hot segment
            if (hotSegment) for (const s of segmentSuperstars)data["popularityChange"] = (0, $5kTkA.updateSuperstarPopularity)(s, popularityChange, false, false, true);
            else {
                const overnessChange = $336089d6be28ba1c$var$getSegmentOvernessChange(winnerParticipant, popularityChange);
                for (const s of winnerParticipant.tempSuperstars){
                    let superstarOvernessChange = overnessChange;
                    // Get trait multiplier for overness change
                    for (const trait of s.traits){
                        const traitData = (0, $aP7lq.traitsData)[trait];
                        if (traitData && traitData["overness_increase_multiplier"]) {
                            if (superstarOvernessChange > 0) superstarOvernessChange *= traitData["overness_increase_multiplier"];
                        }
                        if (traitData && traitData["overness_decrease_multiplier"]) {
                            if (superstarOvernessChange < 0) superstarOvernessChange *= traitData["overness_decrease_multiplier"];
                        }
                    }
                    data["popularityChange"] = (0, $5kTkA.updateSuperstarPopularity)(s, popularityChange, false, false, true);
                    updateOverness(s, superstarOvernessChange);
                }
            }
            // Rank checks
            for (const p of segmentParticipants)for (const s of p.tempSuperstars){
                let superstarNewRank = (0, $5kTkA.getRankFromPopularity)(s.popularity);
                if (superstarNewRank !== s.highestRank) {
                    // Set highest rank
                    let ranks = {
                        "Main Eventer": 4,
                        "Upper Midcarder": 3,
                        "Lower Midcarder": 2,
                        "Jabroni": 1
                    };
                    ranks[superstarNewRank] || ranks[s.highestRank];
                    s.highestRank = superstarNewRank;
                    // Check goals
                    if (company.userControlled) {
                        if (superstarNewRank === "Main Eventer") {
                            let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                name: "main eventer",
                                change: 1,
                                company: company,
                                superstarName: s.name
                            });
                            if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                            // Find trio
                            let winnerTrio = (await (0, $hBIDz.getSuperstarTagTeams)(s)).find((y)=>y.trio);
                            if (winnerTrio) {
                                // Check if all members are main eventers
                                let winnerTrioSuperstars = await (0, $972Ip.getTagTeamSuperstars)(winnerTrio);
                                if (winnerTrioSuperstars.every((y)=>(0, $5kTkA.getRankFromPopularity)(y.popularity) === "Main Eventer")) {
                                    let superstarNames = (0, $3E8Nt.commaSeparate)(winnerTrioSuperstars.map((z)=>z.name).sort((a, b)=>a.localeCompare(b)));
                                    let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                        name: "new trio",
                                        change: 1,
                                        company: company,
                                        superstarName: superstarNames
                                    });
                                    if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                                }
                            }
                        } else if (superstarNewRank === "Upper Midcarder") {
                            let winnerTagTeam = (await (0, $hBIDz.getSuperstarTagTeams)(s)).find((y)=>!y.temporary && !y.trio);
                            if (winnerTagTeam) {
                                let winnerTagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(winnerTagTeam);
                                if (winnerTagTeamSuperstars.every((y)=>[
                                        "Main Eventer",
                                        "Upper Midcarder"
                                    ].includes((0, $5kTkA.getRankFromPopularity)(y.popularity)))) {
                                    let superstarNames = (0, $3E8Nt.commaSeparate)(winnerTagTeamSuperstars.map((z)=>z.name).sort((a, b)=>a.localeCompare(b)));
                                    let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                        name: "new tag team",
                                        change: 1,
                                        company: company,
                                        superstarName: superstarNames
                                    });
                                    if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                                }
                            }
                        }
                    }
                }
                // Check talent request
                let requestData = {
                    "reachedRank": superstarNewRank
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "go_to_next_rank",
                    talent: s,
                    data: requestData
                });
            }
        }
        // Process charisma xp if not production segment
        data["charismaIncreases"] = [];
        if (!segmentItem.productionSegment) {
            for (let p of segmentParticipants)if (!managedParticipant || p.$loki !== managedParticipant.$loki) await processSegmentParticipantCharismaXp(p, xpGained);
        }
        // Production segment checks
        if (segmentItem.productionSegment) {
            // Add action completed (Packages Produced)
            await (0, $8A6FL.checkFacilityUpgrade)("Production", company);
            // Unlock special segment
            if (segmentItem.custom) {
                const segmentTexts = segmentItem.startTexts.concat(segmentItem.actionTexts, [
                    segmentItem.name
                ]);
                for (const text of segmentTexts)if (text.toLowerCase().includes("celebrity")) await (0, $3SyPM.unlockSpecialSegment)(company, "Celebrity Beatdown", month, year);
            }
        }
        // Add xp to random producer (for production segment) or assigned producer
        if (segmentItem.productionSegment && producer || assignedProducer) {
            const ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(producer);
            const isAssignedProducer = assignedProducer != null;
            let producerXPGained = $336089d6be28ba1c$var$getSegmentProducerXp(rating, segment.order, segmentItem.difficulty, isAssignedProducer);
            producerXPGained = Math.round(producerXPGained * ageMultiplier);
            const producerLevelIncrease = await (0, $8A6FL.updateStaffMemberXp)(producer, producerXPGained, company, game);
            if (producerLevelIncrease) data["staffSkillIncreases"].push({
                "name": producer.name,
                "level": producer.level,
                "role": producer.role
            });
            data["producerName"] = producer.name;
            data["producerXpGained"] = producerXPGained;
        }
        // Debut/update gimmicks if not production segment or if New Gimmick Package
        data["gimmickEffectivenessLevelChanges"] = [];
        if (!segmentItem.productionSegment || segmentItem.requirement === "new-gimmick-and-level-1-producer") {
            for (const s of segmentSuperstars)// Debut new gimmick if set
            if (s.debutNewGimmick) {
                let debutedGimmickData = await (0, $5kTkA.debutGimmick)(s, company, producer, month, year);
                data["debutedGimmicks"].push(debutedGimmickData);
                // Add producer skill increase data
                if (debutedGimmickData["staffSkillIncreases"]) data["staffSkillIncreases"].push(debutedGimmickData["staffSkillIncreases"]);
            } else {
                let segmentSuperstarParticipant;
                for (const y of segmentParticipants)if ((0, $3E8Nt.objectInArray)(s, y.tempSuperstars)) {
                    segmentSuperstarParticipant = y;
                    break;
                }
                await updateSuperstarGimmickEffectiveness(s, segmentSuperstarParticipant);
            }
        }
        // Mark ready to return as False
        for (let s of segmentSuperstarsWithManagers)if (s.readyToReturn) s.readyToReturn = false;
        // Increase overness for hot segment
        if (hotSegment) {
            // Get overness increase
            let overnessIncrease;
            if (segmentParticipants.length > 1) overnessIncrease = Math.round(8 / segmentParticipants.length);
            else overnessIncrease = 4;
            if (overnessIncrease < 1) overnessIncrease = 1;
            // Special segments gets superstar overness to 90+
            if (segmentItem.special) {
                if (segmentParticipants.some((x)=>x.overness < 80)) overnessIncrease = 90 - segmentParticipants[0].overness;
                else overnessIncrease = 20;
            }
            data["hotSegmentOvernessIncrease"] = overnessIncrease;
            for (let x of segmentSuperstars)updateOverness(x, overnessIncrease);
            // Unlock special segment
            if (segmentItem.silly) await (0, $3SyPM.unlockSpecialSegment)(company, "Hosedown", month, year);
            // Update morale for hot segment
            for (let x of segmentSuperstars){
                let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                    changeType: "hot_segment"
                });
                (0, $5kTkA.updateSuperstarMorale)(x, moraleChange);
            }
        }
        // Update morale for silly failure
        if (sillyFailure) for (let x of segmentSuperstars){
            let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                changeType: "silly_failure"
            });
            (0, $5kTkA.updateSuperstarMorale)(x, moraleChange);
        }
        // Update morale for main event
        if (mainEvent) for (let x of segmentSuperstars){
            let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                changeType: "main_event",
                weeklyShow: weeklyShow
            });
            (0, $5kTkA.updateSuperstarMorale)(x, moraleChange);
            // Check main event request
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "be_in_main_event",
                talent: x
            });
        }
        // Check no weekly shows request
        if (weeklyShow) for (let x of segmentSuperstars)await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "no_weekly_shows",
            talent: x,
            failRequest: true
        });
        // Check promo segment request
        if ([
            "Slander Competitor",
            "Lost My Smile",
            "Heat Promo",
            "Spirited Promo",
            "Retirement Announcement",
            "I Quit",
            "Best Wrestler Promo",
            "New Heel Promo",
            "New Babyface Promo",
            "Retirement Gloat",
            "I'm The Face",
            "Losing Streak Promo",
            "Build Honor",
            "Villainize",
            "Neutralize",
            "Injury Gloat",
            "Anti-Company Rant",
            "Ring Invasion",
            "This Is My Life",
            "Cryptic Threat",
            "Backstage Interview",
            "Indifferent Promo",
            "Debut Promo",
            "Solo Feud Promo",
            "Manager Promo"
        ].includes(segmentItem.name) || segmentItem.custom && segmentItem.name.toLowerCase().includes("promo") && segmentItem.maxParticipants === 1) {
            if (segmentParticipants.length > 0) await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "solo_promo_segment",
                talent: segmentParticipants[0]
            });
        }
        // Check morale changes
        data["moraleChanges"] = [];
        for (let p of segmentParticipants){
            // Add morale change to participant's data
            const participantData = data["participantsData"].find((x)=>x["uid"] === p.$loki);
            participantData["moraleChange"] = Math.round(p.tempSuperstars.reduce((n, x)=>n + (x.morale - x.startingMorale), 0) / p.tempSuperstars.length * 10) / 10;
            // Check for morale level change for superstars
            for (const s of p.tempSuperstars){
                let startingMoraleText = (0, $3E8Nt.getMoraleText)(s.startingMorale);
                let endingMoraleText = (0, $3E8Nt.getMoraleText)(s.morale);
                if (endingMoraleText !== startingMoraleText) data["moraleChanges"].push({
                    name: s.name,
                    previousMorale: startingMoraleText,
                    currentMorale: endingMoraleText,
                    morale: s.morale
                });
                // Delete starting morale attribute
                delete s.startingMorale;
            }
        }
        // Check hot and stale changes
        data["hotChanges"] = [];
        data["staleChanges"] = [];
        data["unlockedCharacters"] = [];
        data["overnessChanges"] = [];
        for (let p of segmentParticipants){
            // Add overness change to participant's data
            const participantData = data["participantsData"].find((x)=>x["uid"] === p.$loki);
            participantData["overnessChange"] = Math.round(p.tempSuperstars.reduce((n, x)=>n + (x.overness - x.startingOverness), 0) / p.tempSuperstars.length * 10) / 10;
            // Check for overness level change for superstars
            for (const s of p.tempSuperstars){
                const startingOvernessText = (0, $3E8Nt.getOvernessText)(s.startingOverness);
                const endingOvernessText = (0, $3E8Nt.getOvernessText)(s.overness);
                if (endingOvernessText !== startingOvernessText) data["overnessChanges"].push({
                    name: s.name,
                    previousOverness: startingOvernessText,
                    currentOverness: endingOvernessText,
                    overness: s.overness,
                    increase: s.overness > s.startingOverness
                });
                const superstarOvernessChange = s.overness - s.startingOverness;
                // Check hot
                const hotCheck = (0, $8A6FL.checkObjectHot)(s, superstarOvernessChange);
                if (hotCheck) {
                    data["hotChanges"].push({
                        name: s.name,
                        pronoun: s.possessivePronoun,
                        status: hotCheck
                    });
                    // Check for character unlock upon hot
                    if ((0, $98xmD.globalUser).paid && hotCheck === "hot") {
                        const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(s);
                        if (superstarGimmick) {
                            if (superstarGimmick.character) {
                                const unlockedCharacter = (0, $3SyPM.checkCharacterToUnlock)(superstarGimmick.character);
                                if (unlockedCharacter) data["unlockedCharacters"].push({
                                    name: unlockedCharacter,
                                    originalCharacter: superstarGimmick.character
                                });
                            }
                        }
                    }
                    if (hotCheck === "hot") {
                        // Add news
                        if (company) {
                            let newsItem = await (0, $kZMqI.generateNewsItem)({
                                company: company,
                                month: game.newsMonth,
                                year: game.newsYear,
                                superstar: s,
                                newsType: "over_superstar"
                            });
                            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                                newsItem
                            ]);
                        }
                        if (company.userControlled) {
                            // Check goal
                            let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                name: "get over",
                                change: 1,
                                company: company,
                                superstarName: s.name
                            });
                            if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                            // Add TGI president's message
                            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 25) {
                                let annualTournamentHeld = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((y)=>y.annualTournament && y.status === "ended");
                                if (annualTournamentHeld) {
                                    const newMessage = await (0, $hekDR.createPresidentOverSuperstarMessage)(s, game, month, year);
                                    await (0, $9esFv.addCompanyMessages)(company, [
                                        newMessage
                                    ]);
                                }
                            }
                        }
                        // Update faction rep (overness change)
                        const superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                            superstar: s,
                            overnessChange: "hot"
                        });
                        data["factionReputationsData"].push(...superstarFactionsData);
                    }
                }
                // Check stale
                const staleCheck = (0, $8A6FL.checkObjectStale)(s, superstarOvernessChange);
                if (staleCheck) {
                    data["staleChanges"].push({
                        name: s.name,
                        pronoun: s.possessivePronoun,
                        status: staleCheck
                    });
                    if (staleCheck === "stale") {
                        let newsItem = await (0, $kZMqI.generateNewsItem)({
                            company: company,
                            month: game.newsMonth,
                            year: game.newsYear,
                            superstar: s,
                            newsType: "stale_superstar"
                        });
                        await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                            newsItem
                        ]);
                        // Update faction rep (overness change)
                        const superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                            superstar: s,
                            overnessChange: "stale"
                        });
                        data["factionReputationsData"].push(...superstarFactionsData);
                    }
                }
                // Delete starting overness attribute
                delete s.startingOverness;
            }
        }
        // Change prestige for segment championship
        if ((0, $98xmD.globalUser).paid) for (let championship of segmentChampionships){
            // Get prestige data
            let championshipXpData = await (0, $kZwpB.getChampionshipXpChange)({
                championship: championship,
                company: company,
                month: month,
                year: year,
                segment: segment,
                weeklyShow: weeklyShow,
                mainEvent: mainEvent
            });
            // Process prestige
            if (championshipXpData["totalXpChange"]) {
                let championshipPrestigeData = await (0, $8A6FL.processChampionshipXpChange)(championship, championshipXpData["totalXpChange"], companyChampionships);
                if (championshipPrestigeData["xp"]) {
                    championshipPrestigeData["xpDetails"] = championshipXpData;
                    // Add to data (if not already added)
                    if (!data["championshipPrestiges"].map((y)=>y["championshipName"]).includes(championshipPrestigeData["championshipName"])) data["championshipPrestiges"].push(championshipPrestigeData);
                    // Check for objective completed
                    if (championshipPrestigeData["prestigeIncrease"]) {
                        if (company.userControlled) {
                            let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                name: "championship prestige",
                                change: 1,
                                company: company,
                                championship: championship
                            });
                            if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                        }
                        // If prestige increased over highest value, unlock prestige bonus segments
                        if (championshipPrestigeData["firstPrestigeIncrease"]) data["unlockedChampionshipSegmentItems"].push(...await (0, $kZwpB.checkChampionshipSegmentItemsToUnlock)(championshipPrestigeData["prestige"], company));
                    }
                }
            }
        }
        // Check to acquire traits
        if (hotSegment) {
            for (let segmentSuperstar of segmentSuperstars)// Don't acquire for managed talent
            if (!(0, $3E8Nt.objectInArray)(segmentSuperstar, managedSuperstars)) await (0, $5kTkA.checkAcquireTrait)(segmentSuperstar, "Entertainer");
        }
        // Get event hype boosts
        if (company.userControlled && game.marketSize !== null) {
            const eventHypeBoostData = await $336089d6be28ba1c$var$getEventHypeBoostData(segment, segmentItem, talentDebutRelationship, hotSegment, company, game, segmentParticipants);
            if (eventHypeBoostData["hypeBoost"]) {
                event.hype += eventHypeBoostData["hypeBoost"];
                data["eventHype"] = event.hype;
                data["eventHypeBoostData"] = eventHypeBoostData;
            }
        }
        // Add kayfabe points change
        for (let s of segmentSuperstars){
            let kayfabePointsChange = 0;
            if (mainEvent) kayfabePointsChange += await (0, $5kTkA.getKayfabePointsChange)({
                changeType: `mainEvent`,
                weeklyShow: weeklyShow
            });
            if (kayfabePointsChange) (0, $5kTkA.updateSuperstarKayfabePoints)(s, kayfabePointsChange);
        }
        // Mark hidden as false
        if (segment.hidden) segment.hidden = false;
        // Get data to return
        data["rating"] = rating;
        data["effectiveness"] = effectiveness;
        data["segmentAlreadyHeld"] = segmentAlreadyHeld;
        data["purePositiveBoost"] = purePositiveBoost;
        data["pureNegativeBoost"] = pureNegativeBoost;
        data["sillySuccess"] = sillySuccess;
        data["sillyFailure"] = sillyFailure;
        data["segmentItemLevelData"] = segmentItemLevelData;
        data["unlockedSegmentItems"] = unlockedSegmentItems;
        data["winnerName"] = winnerParticipant ? winnerParticipant.name : null;
        data["hotSegment"] = hotSegment;
        data["specialSegment"] = segmentItem.special;
        if (updateGraphics) data["graphics"] = graphics;
        // Delete tempSuperstars attribute
        for (const x of segmentParticipants)delete x.tempSuperstars;
        async function processSegmentParticipantCharismaXp(p, xpToAdd) {
            const pSuperstars = p.tempSuperstars;
            let participantXpGained = 0;
            for (const s of pSuperstars){
                // Check for skill xp multiplier trait
                let traitMultiplier = 1;
                for (const trait of s.traits){
                    const traitData = (0, $aP7lq.traitsData)[trait];
                    if (traitData && traitData["skill_xp_multiplier"]) traitMultiplier = traitData["skill_xp_multiplier"];
                }
                // Get and add charisma xp
                const ageMultiplier = (0, $3E8Nt.getTalentAgeMultiplier)(s);
                const superstarXpGained = Math.round(xpToAdd * ageMultiplier * traitMultiplier);
                s.charismaXp += superstarXpGained;
                participantXpGained += superstarXpGained;
                // Add charisma xp, check level increase
                const increaseData = await $336089d6be28ba1c$export$23c1e265430766ca(s, company, staffMembers, month, year);
                if (increaseData) data["charismaIncreases"].push({
                    "name": s.name,
                    "level": s.charisma
                });
            }
            participantXpGained = Math.floor(participantXpGained / pSuperstars.length);
            // Add xp gained to participant's data
            const participantData = data["participantsData"].find((x)=>x["uid"] === p.$loki);
            if (participantData) participantData["xpGained"] = participantXpGained;
        }
        async function updateSuperstarGimmickEffectiveness(s, p) {
            // Find gimmick
            const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(s);
            if (superstarGimmick) {
                const isWinner = winnerParticipant && p.$loki === winnerParticipant.$loki && segmentItem.chooseWinner;
                // Get change
                const gimmickEffectivenessChange = (0, $3SyPM.getGimmickEffectivenessChange)(s, rating, segment.order, weeklyShow, isWinner, segmentItem.difficulty, false, s.hot);
                if (gimmickEffectivenessChange !== 0) {
                    const gimmickData = (0, $3SyPM.progressGimmick)(superstarGimmick, gimmickEffectivenessChange, s);
                    // Add gimmick effectiveness level change if present
                    if (gimmickData["overnessEffectChange"]) data["gimmickEffectivenessLevelChanges"].push(gimmickData);
                    // Add gimmick effectiveness change to participant's data
                    const participantData = data["participantsData"].find((x)=>x["uid"] === p.$loki);
                    participantData["gimmickEffectivenessChange"] += gimmickEffectivenessChange;
                    // Unlock special segment
                    if (superstarGimmick.character && superstarGimmick.character === "Degenerate" && superstarGimmick.effectiveness >= 100) await (0, $3SyPM.unlockSpecialSegment)(company, "Love Making", month, year);
                }
            }
            return superstarGimmick;
        }
        function updateOverness(p, increase) {
            p.overness += increase;
            p.overness = (0, $3E8Nt.limitValueBetweenRange)(p.overness, 0, 100);
            return p.overness;
        }
        return data;
    } catch (err) {
        // Delete tempSuperstars attribute
        for (const x of (await (0, $eg5dz.getSegmentParticipants)(segment)))delete x.tempSuperstars;
        throw err;
    }
}
async function $336089d6be28ba1c$var$getSegmentParticipantsChampionship(participants) {
    for (const p of participants){
        for (const s of p.tempSuperstars)for (const c of (await (0, $hBIDz.getSuperstarChampionships)(s))){
            if (!c.championshipContract && !c.matchContract) return c;
        }
    }
    return null;
}
async function $336089d6be28ba1c$var$checkSegmentAlreadyHeld(segment, segmentItem, event, eventSegments, segmentFeuds) {
    // Check event segments and feuds' segments
    const feudsSegments = (await Promise.all(segmentFeuds.map((x)=>(0, $jDtEn.getFeudSegments)(x)))).flat();
    const segmentsToCheck = eventSegments.concat(feudsSegments);
    let segmentAlreadyHeld = false;
    for (const x of segmentsToCheck){
        let si = await (0, $eg5dz.getSegmentSegmentItem)(x);
        // Not repeatable and same segment item, not played and not this segment
        if (si.$loki === segmentItem.$loki && si.oneAtATime && x.$loki !== segment.$loki && x.rating) {
            segmentAlreadyHeld = true;
            break;
        }
    }
    // Check if event package already held
    if (segmentItem.consequence === "boost-event-hype" && event.nextEventBoost) segmentAlreadyHeld = true;
    return segmentAlreadyHeld;
}
async function $336089d6be28ba1c$var$getTalentDebutRelationship(segmentItem, participants, company) {
    if ([
        "Debut",
        "Debut Promo",
        "Debut Attack"
    ].includes(segmentItem.name)) {
        for (const p of participants)for (const s of p.tempSuperstars){
            const relationship = (await (0, $hBIDz.getSuperstarRelationships)(s)).find((x)=>x.type === "former_company" && x.companyId !== company.$loki);
            if (relationship && s.popularity >= 600) return relationship;
        }
    }
    return null;
}
async function $336089d6be28ba1c$var$getEventHypeBoostData(segment, segmentItem, talentDebutRelationship, hotSegment, company, game, participants) {
    const data = {};
    if (talentDebutRelationship) {
        if (await (0, $3E8Nt.getRosterMemberRank)(participants[0]) === "Main Eventer") data["hypeBoost"] = 25;
        else data["hypeBoost"] = 10;
        data["debutBoost"] = true;
        data["companyName"] = company.name;
        const formerCompany = (0, $iWkAo.getRelationshipCompany)(talentDebutRelationship);
        data["formerCompanyName"] = formerCompany.name;
    } else if (segmentItem.name === "Slander Competitor" && (segment.rating >= 4 || segment.rating <= 3)) {
        // Get competitor
        let competitor;
        if (segment.consequenceData) {
            const competitorUid = segment.consequenceData["competitorUid"];
            if (competitorUid) competitor = await (0, $14eBR.Companies).get(competitorUid);
        }
        if (!competitor) {
            // Compatibility with old saves
            const competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game);
            competitor = (0, $3E8Nt.getArrayMaxByProperty)(competitors, "fans");
        }
        if (competitor) data["competitorName"] = competitor.name;
        if (segment.rating >= 4) {
            data["hypeBoost"] = 5;
            data["slanderBoost"] = true;
        } else if (segment.rating <= 3) {
            data["hypeBoost"] = -5;
            data["slanderPenalty"] = true;
        }
    } else if (hotSegment) {
        data["hypeBoost"] = 10;
        data["hotSegmentBoost"] = true;
    }
    return data;
}
function $336089d6be28ba1c$var$getProductionSegmentRating(producer, segmentAlreadyHeld, assignedProducer = null) {
    const data = {};
    const producerLevel = producer ? producer.level : 1;
    const maxRating = 5;
    const effectiveness = Math.round($336089d6be28ba1c$var$getProductionSegmentEffectiveness(producerLevel) * 100) / 100;
    let rating = effectiveness * maxRating;
    if (segmentAlreadyHeld) rating *= 0.6;
    // Add producer focus effect
    if (assignedProducer) data["producerFocusEffect"] = $336089d6be28ba1c$var$getProducerFocusEffect(assignedProducer);
    rating = (0, $3E8Nt.myround)(rating, 0.25);
    data["rating"] = rating;
    data["effectiveness"] = effectiveness;
    return data;
}
function $336089d6be28ba1c$var$getProductionSegmentEffectiveness(producerLevel) {
    let minValue, maxValue;
    if (producerLevel === 1) {
        minValue = 0.45;
        maxValue = 0.85;
    } else if (producerLevel === 2) {
        minValue = 0.6;
        maxValue = 0.9;
    } else {
        minValue = 0.8;
        maxValue = 1.05;
    }
    let effectiveness = (0, $3E8Nt.getRandomUniform)(minValue, maxValue);
    effectiveness = (0, $3E8Nt.limitValueBetweenRange)(effectiveness, 0.0, 1.0);
    const randomBoosts = [
        [
            -0.1,
            10
        ],
        [
            0,
            80
        ],
        [
            0.1,
            10
        ]
    ];
    effectiveness += (0, $3E8Nt.weightedChoice)(randomBoosts);
    effectiveness = (0, $3E8Nt.limitValueBetweenRange)(effectiveness, 0.0, 1.0);
    return (0, $3E8Nt.decimalRound)(effectiveness, 0.05);
}
async function $336089d6be28ba1c$var$getSegmentRating(segmentItem, participantsWithManagers, purePositiveBoost, pureNegativeBoost, segmentSuperstarsWithManagers, segmentAlreadyHeld, talentDebutRelationship, assignedProducer, storyName) {
    const data = {};
    if (storyName === "passion" && segmentItem.name === "Welcome to POW") {
        data["rating"] = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(4, 5.25), 0.25);
        data["effectiveness"] = 1.0;
        return data;
    }
    const averageCharisma = (0, $3E8Nt.myround)(await $336089d6be28ba1c$var$getSegmentParticipantsAverageCharisma(participantsWithManagers), 0.25);
    const maxRatings = {
        1: 3.75,
        2: 4.25,
        3: 5
    };
    const maxAttribute = Math.max(segmentItem.entertainment, segmentItem.action);
    const minAttribute = Math.min(segmentItem.entertainment, segmentItem.action);
    let maxRating = maxRatings[maxAttribute] || 3.5;
    if (minAttribute > 0) {
        const extraRating = minAttribute * 0.5;
        maxRating += extraRating;
        if (maxRating > 5) maxRating = 5;
    }
    // Get trait multiplier for silly segment rating
    let traitsBoost = 0;
    if (segmentItem.silly) {
        for (const superstar of segmentSuperstarsWithManagers)for (const trait of superstar.traits){
            const traitData = (0, $aP7lq.traitsData)[trait];
            if (traitData && traitData["silly_segment_rating_boost"]) traitsBoost += traitData["silly_segment_rating_boost"];
        }
        traitsBoost = (0, $3E8Nt.limitValueBetweenRange)(traitsBoost, -0.2, 0.2);
    }
    let effectiveness = $336089d6be28ba1c$var$getSegmentEffectiveness(segmentItem.difficulty, averageCharisma, segmentItem.silly, traitsBoost);
    let rating = effectiveness * maxRating;
    if (segmentAlreadyHeld) rating *= 0.6;
    if (purePositiveBoost) rating *= 1.1;
    else if (pureNegativeBoost) rating *= 0.8;
    // Stale penalty
    const stalePenalty = segmentSuperstarsWithManagers.filter((x)=>x.stale).length * (-1 / segmentSuperstarsWithManagers.length);
    rating += stalePenalty;
    // Faction reputation effect for faction segments
    if (segmentItem.factionSegment) {
        let participantSuperstar = (await (0, $972Ip.getTagTeamSuperstars)(participantsWithManagers[0]))[0];
        const faction = (await (0, $hBIDz.getSuperstarFactions)(participantSuperstar)).find((y)=>!y.disbanded);
        if (faction) {
            // Negative effect for reputation under 5, positive effect for reputation over 5
            const reputationEffect = (faction.reputation - 5) / 2;
            rating += reputationEffect;
            rating = (0, $3E8Nt.limitValueBetweenRange)(rating, 0, 5);
        }
    }
    // Add producer focus effect
    if (assignedProducer) data["producerFocusEffect"] = $336089d6be28ba1c$var$getProducerFocusEffect(assignedProducer);
    rating = (0, $3E8Nt.myround)(rating, 0.25);
    if (rating < 0) rating = 0;
    if (segmentItem.special || talentDebutRelationship) {
        rating = 5;
        effectiveness = 1.0;
    }
    data["rating"] = rating;
    data["effectiveness"] = effectiveness;
    return data;
}
function $336089d6be28ba1c$var$getSegmentEffectiveness(difficulty, charisma, silly, traitsBoost) {
    let maxValue;
    if (charisma > 2) maxValue = 1.1;
    else if (charisma > 1) maxValue = 0.8;
    else maxValue = 0.7;
    // Set minimum value based on charisma (20% for 2 charisma, 40% for 3 charisma)
    const minValue = maxValue - 0.5;
    const randomMultiplier = (0, $3E8Nt.getRandomUniform)(minValue, maxValue);
    const difficultyFactor = 1.1 / (difficulty + 1);
    let effectiveness = Math.pow(charisma, 1.15) * difficultyFactor * randomMultiplier;
    effectiveness = (0, $3E8Nt.limitValueBetweenRange)(effectiveness, 0.0, 1.0);
    // Add random boost
    const randomBoosts = [
        [
            -0.1,
            10
        ],
        [
            0,
            80
        ],
        [
            0.1,
            10
        ]
    ];
    effectiveness += (0, $3E8Nt.weightedChoice)(randomBoosts);
    // Add traits boost
    effectiveness += traitsBoost;
    effectiveness = (0, $3E8Nt.limitValueBetweenRange)(effectiveness, 0.0, 1.0);
    return (0, $3E8Nt.myround)(effectiveness, 0.05);
}
function $336089d6be28ba1c$var$checkSegmentHot(segment, participants, superstars, feuds, shockingTurn = false, turnTooSoon = false, special = false) {
    let chance = 0;
    // Special segment is always hot
    if (special) return true;
    // Minimum rating
    if (segment.rating < 4) return false;
    // No participants
    if (!participants.length) return false;
    // Segment rating factor
    if (segment.rating >= 4.75) chance += 10;
    // Feud hype factor
    const feudsHype = $336089d6be28ba1c$export$7b5a40f91c0455f2(feuds, participants);
    chance += feudsHype / 2;
    // Hot/stale superstars factor
    let hotParticipantBonus = 0;
    for (const x of superstars){
        if (x.hot) hotParticipantBonus += 8 / superstars.length;
        else if (x.stale) hotParticipantBonus -= 8 / superstars.length;
    }
    chance += hotParticipantBonus;
    // Shocking turns chance
    if (shockingTurn) chance += 30;
    if (turnTooSoon) chance -= 30;
    // Get trait multiplier for hot segment chance
    let traitBoost = 0;
    for (const superstar of superstars)for (const trait of superstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["hot_segment_chance_boost"]) traitBoost += traitData["hot_segment_chance_boost"];
    }
    traitBoost = (0, $3E8Nt.limitValueBetweenRange)(traitBoost, 0, 15);
    chance += traitBoost;
    // Max chance
    if (chance >= 50) chance = 50;
    if ((0, $3E8Nt.getRandomInt)(1, 100) <= chance) {
        segment.hot = true;
        return true;
    }
    return false;
}
function $336089d6be28ba1c$var$getSegmentXps(rating, order, difficulty, trainerLevel) {
    const baseXps = {
        1: 2,
        2: 3.5,
        3: 5
    };
    let baseXp = baseXps[trainerLevel] || 5;
    if (order === 0) baseXp += 2;
    if (rating >= 4.5) baseXp += 2;
    else if (rating <= 2) baseXp -= 2;
    const difficultyXps = {
        1: 0,
        2: 1,
        3: 3
    };
    baseXp += difficultyXps[difficulty] || 0;
    return Math.floor(baseXp);
}
function $336089d6be28ba1c$var$getSegmentProducerXp(rating, order, difficulty, isAssignedProducer) {
    let baseXp = 2;
    if (isAssignedProducer) baseXp += 3;
    if (order === 0) baseXp += 2;
    if (rating >= 4) baseXp += 1;
    else if (rating <= 2) baseXp -= 1;
    const difficultyXps = {
        1: 0,
        2: 2,
        3: 4
    };
    baseXp += difficultyXps[difficulty] || 0;
    return Math.floor(baseXp);
}
function $336089d6be28ba1c$var$getSegmentBoosts(rating, segmentItem, hot = false) {
    const baseHypes = {
        1: 3,
        2: 8,
        3: 15
    };
    const basePopularities = {
        1: 5,
        2: 9,
        3: 15
    };
    let ratingMultiplier = (rating - 3) * 0.5;
    let sillySuccess = false;
    let sillyFailure = false;
    // Add initial hype/popularity change
    let hypeChange = baseHypes[segmentItem.hypeBoost] || 0;
    let popularityChange = basePopularities[segmentItem.popularityBoost] || 0;
    if (rating >= 4.5) {
        ratingMultiplier += 0.25;
        if (segmentItem.silly) {
            sillySuccess = true;
            ratingMultiplier += 0.75;
        }
    } else if (rating <= 2) {
        ratingMultiplier -= 1.5;
        if (segmentItem.silly) {
            sillyFailure = true;
            ratingMultiplier -= 0.5;
        }
    }
    // Hot segment multiplier boost
    if (hot) ratingMultiplier += 0.25;
    // Add rating multiplier's hype/pop change
    hypeChange += Math.round(hypeChange * ratingMultiplier);
    popularityChange += Math.round(popularityChange * ratingMultiplier);
    // Hot segment boost
    if (hot) {
        hypeChange += (0, $3E8Nt.getRandomInt)(3, 5);
        popularityChange += (0, $3E8Nt.getRandomInt)(5, 8);
    }
    return [
        hypeChange,
        popularityChange,
        sillySuccess,
        sillyFailure
    ];
}
async function $336089d6be28ba1c$var$getSegmentParticipantsAverageCharisma(participants) {
    let totalCharisma = 0;
    for (const x of participants)if (x.objectName === "superstar") totalCharisma += (0, $5kTkA.getSuperstarCharisma)(x);
    else totalCharisma += await $336089d6be28ba1c$var$getTagTeamCharisma(x);
    return totalCharisma / participants.length;
}
async function $336089d6be28ba1c$var$getTagTeamCharisma(tagTeam) {
    const superstars = await (0, $5kTkA.getRosterMemberSuperstars)(tagTeam);
    // Get leader's charisma if faction tag team
    if (tagTeam.factionTagTeam) {
        let faction = (await (0, $hBIDz.getSuperstarFactions)(superstars[0])).find((x)=>!x.disbanded);
        if (faction) {
            let factionLeaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(faction);
            let leaderSuperstar = superstars.find((x)=>factionLeaderSuperstar && x.$loki === factionLeaderSuperstar.$loki);
            if (leaderSuperstar) return (0, $5kTkA.getSuperstarCharisma)(leaderSuperstar);
        }
    }
    // Get average charisma of team superstars
    let totalCharisma = 0;
    for (const s of superstars)totalCharisma += (0, $5kTkA.getSuperstarCharisma)(s);
    return totalCharisma / superstars.length;
}
function $336089d6be28ba1c$var$getProducerFocusEffect(producer) {
    let producerFocusEffects;
    if (producer.level <= 1) producerFocusEffects = [
        [
            -0.25,
            15
        ],
        [
            0,
            40
        ],
        [
            0.25,
            45
        ]
    ];
    else if (producer.level === 2) producerFocusEffects = [
        [
            -0.25,
            10
        ],
        [
            0,
            30
        ],
        [
            0.25,
            40
        ],
        [
            0.5,
            20
        ]
    ];
    else if (producer.level >= 3) producerFocusEffects = [
        [
            0,
            20
        ],
        [
            0.25,
            50
        ],
        [
            0.5,
            30
        ]
    ];
    return (0, $3E8Nt.weightedChoice)(producerFocusEffects);
}
function $336089d6be28ba1c$var$checkSegmentItemsToUnlock(segmentItem, segmentItems) {
    // Check for segment item unlocks, returning unlocked
    const unlocked = [];
    const unlocksDict = {
        "Debut": "Legend's Praise",
        "Title Disrespect": "Title Destruction",
        "Anger Management": "Exposing the Past",
        "Demand Title Shot": "Lost My Smile",
        "Talk Show": "You're Fired",
        "Heat Promo": "Backstab",
        "Spirited Promo": "Defying a Villain",
        "Fight": "Delayed Vengeance",
        "Siblings Parody": "Entrance Parody",
        "Backstage Attack": "Police Arrest",
        "Legendary Beatdown": "One Last Run",
        "Backstage Interview": "This Is My Life",
        "Home Invasion": "Spouse Attack",
        "Promo Battle": "Catchphrase Showdown",
        "Masked Attacker": "Face Reveal"
    };
    const toUnlock = unlocksDict[segmentItem.name];
    if (toUnlock) {
        const segmentItemToUnlock = segmentItems.find((x)=>x.name === toUnlock);
        if (segmentItemToUnlock && !segmentItemToUnlock.unlocked && segmentItem.level === 3) {
            segmentItemToUnlock.unlocked = true;
            unlocked.push(segmentItemToUnlock.name);
        }
    }
    return unlocked;
}
async function $336089d6be28ba1c$export$23c1e265430766ca(superstar, company, staffMembers, month, year) {
    const xps = {
        2: 300,
        1: 100
    };
    let levelIncrease = false;
    if (superstar.charisma < 3 && superstar.charismaXp >= (xps[superstar.charisma] || 300)) {
        superstar.charisma += 1;
        levelIncrease = true;
        // Add level up message
        if (company.userControlled) {
            const trainer = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "trainer");
            const newMessage = await (0, $hekDR.createSuperstarLevelUpMessage)(trainer, superstar, "charisma", month, year);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
    }
    return levelIncrease;
}
function $336089d6be28ba1c$var$getSegmentOvernessChange(winner, popularityChange) {
    let hot = winner.tempSuperstars.every((x)=>x.hot);
    let stale = winner.tempSuperstars.every((x)=>x.stale);
    let overnessIncrease;
    if (popularityChange > 0) {
        if (hot) overnessIncrease = Math.floor(popularityChange / 8);
        else if (stale) overnessIncrease = Math.floor(popularityChange / 2);
        else overnessIncrease = Math.floor(popularityChange / 4);
    } else {
        // Popularity change will be mostly positive for hot superstar, since it depends on charisma
        // so use lower divisor here
        if (hot) overnessIncrease = Math.floor(popularityChange / 1);
        else if (stale) overnessIncrease = Math.floor(popularityChange / 1);
        else overnessIncrease = Math.floor(popularityChange / 2);
    }
    if (overnessIncrease > 10) overnessIncrease = 10;
    return overnessIncrease;
}
function $336089d6be28ba1c$var$addPerkToSegmentItem(segmentItem, perk = null) {
    // Get available perks
    let perks = [];
    if (segmentItem.entertainment < 3) perks.push("entertainment");
    if (segmentItem.action < 3) perks.push("action");
    if (segmentItem.popularityBoost < 3) perks.push("popularity");
    if (segmentItem.hypeBoost < 3) perks.push("hype");
    if (segmentItem.difficulty > 1) perks.push("difficulty");
    if (perk == null && perks.length > 0) perk = (0, $3E8Nt.getRandomChoice)(perks);
    // Add perk effect
    if (perk === "entertainment") segmentItem.entertainment += 1;
    if (perk === "action") segmentItem.action += 1;
    if (perk === "difficulty") segmentItem.difficulty -= 1;
    if (perk === "hype") segmentItem.hypeBoost += 1;
    if (perk === "popularity") segmentItem.popularityBoost += 1;
    return perk;
}
async function $336089d6be28ba1c$var$runSpecialSegmentConsequence(segmentItem, segment, participants, company, mainCompany, staffMembers, game, month, year) {
    const data = {};
    const superstar = participants[0];
    const superstarRandom = new Math.seedrandom(superstar.meta.created);
    let newsItem;
    if (segmentItem.name === "Car Explosion") {
        (0, $5kTkA.addKayfabeInjuryToSuperstar)(superstar, (0, $3E8Nt.getRandomInt)(2, 4));
        data["unavailableSuperstar"] = superstar.name;
        // Check talent request
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "write_off",
            talent: superstar
        });
        // Add news
        if (company.userControlled) newsItem = await (0, $kZMqI.generateNewsItem)({
            company: company,
            month: month,
            year: year,
            superstar: superstar,
            newsType: "car_explosion",
            headline: true
        });
    }
    if (segmentItem.name === "Stunt Dive") {
        (0, $5kTkA.addKayfabeInjuryToSuperstar)(superstar, 2);
        data["unavailableSuperstar"] = superstar.name;
        // Check talent request
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "write_off",
            talent: superstar
        });
        // Add news
        if (company.userControlled) newsItem = await (0, $kZMqI.generateNewsItem)({
            company: company,
            month: month,
            year: year,
            superstar: superstar,
            newsType: "stunt_dive",
            headline: true
        });
    }
    if (segmentItem.name === "Dummy Wrestling") {
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
        const superstars = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>!(0, $3E8Nt.objectInArray)(x, participants));
        const availableSuperstars = superstars.filter((x)=>(0, $5kTkA.checkAvailability)(x, true) && !x.unhappy);
        // Set unhappy superstars
        let unhappySuperstars = [];
        if (!game.settings["no_unhappiness"]) {
            if (availableSuperstars.length > 0) unhappySuperstars = (0, $3E8Nt.getRandomSample)(availableSuperstars, 2);
            else unhappySuperstars = (0, $3E8Nt.getRandomSample)(superstars, 2);
            for (const s of unhappySuperstars)await (0, $5kTkA.changeSuperstarMoraleToUnhappy)(s, company);
            data["unhappySuperstars"] = unhappySuperstars.map((x)=>x.name);
            data["unhappyReason"] = "dummy wrestling";
        }
        if (company.userControlled) {
            // Add news
            newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: month,
                year: year,
                superstar: superstar,
                newsType: "dummy_wrestling",
                headline: true
            });
            // Add mark out message
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) {
                const markOutSuperstar = (0, $3E8Nt.getRandomChoice)(superstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, unhappySuperstars)));
                const newMessage = await (0, $hekDR.createSuperstarMarkedOutMessage)(markOutSuperstar, segmentItem.name, superstar, month, year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
        }
    }
    if (segmentItem.name === "Timely Rescue") {
        if (staffMembers.length > 0) {
            const availableStaffMembers = (0, $8A6FL.getAvailableStaffMembers)(staffMembers);
            let staffMember;
            if (availableStaffMembers.length > 0) staffMember = (0, $3E8Nt.getRandomChoice)(availableStaffMembers, superstarRandom());
            else staffMember = (0, $3E8Nt.getRandomChoice)(staffMembers, superstarRandom());
            staffMember.unavailableMonths = 2;
            data["unavailableStaffMember"] = staffMember.name;
            if (company.userControlled) newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: month,
                year: year,
                superstar: superstar,
                staffMember: staffMember,
                staffMemberPronoun: (0, $3E8Nt.getRosterMemberPronoun)(staffMember),
                staffMemberObjectivePronoun: (0, $3E8Nt.getRosterMemberPronoun)(staffMember, "objective"),
                newsType: "timely_rescue",
                headline: true
            });
        }
    }
    if (segmentItem.name === "Helicopter Raid") {
        let segmentEvent = await (0, $eg5dz.getSegmentEvent)(segment);
        superstar.suspensionMonths = segmentEvent.weeklyShow ? 1 : 2;
        data["suspendedSuperstar"] = superstar.name;
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "write_off",
            talent: superstar
        });
        if (company.userControlled) {
            let competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game);
            if (competitors.length > 0) {
                let competitor = (0, $3E8Nt.getRandomChoice)(competitors, superstarRandom());
                newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: month,
                    year: year,
                    superstar: superstar,
                    competitor: competitor,
                    newsType: "helicopter_raid",
                    headline: true
                });
            }
        }
    }
    if (segmentItem.name === "Ring Invasion") {
        let segmentEvent = await (0, $eg5dz.getSegmentEvent)(segment);
        superstar.suspensionMonths = segmentEvent.weeklyShow ? 1 : 2;
        data["suspendedSuperstar"] = superstar.name;
        // Check talent request
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "write_off",
            talent: superstar
        });
        if (company.userControlled) newsItem = await (0, $kZMqI.generateNewsItem)({
            company: company,
            month: month,
            year: year,
            superstar: superstar,
            newsType: "ring_invasion",
            headline: true
        });
    }
    if (segmentItem.name === "Love Making") {
        const penalty = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(100, 200), 20);
        company.points -= penalty;
        company.points = (0, $3E8Nt.limitValueBetweenRange)(company.points, 0, company.points);
        data["creativePointsPenalty"] = penalty;
        if (company.userControlled) {
            // Add news
            newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: month,
                year: year,
                superstar: superstar,
                newsType: "love_making",
                headline: true
            });
            // Add mark out message
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) {
                const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
                const superstars = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>!(0, $3E8Nt.objectInArray)(x, participants));
                const markOutSuperstar = (0, $3E8Nt.getRandomChoice)(superstars);
                const newMessage = await (0, $hekDR.createSuperstarMarkedOutMessage)(markOutSuperstar, segmentItem.name, superstar, month, year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
        }
    }
    if (segmentItem.name === "Celebrity Beatdown") {
        const penalty = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(100, 200), 20);
        company.points -= penalty;
        company.points = (0, $3E8Nt.limitValueBetweenRange)(company.points, 0, company.points);
        data["creativePointsPenalty"] = penalty;
        if (company.userControlled) {
            const celebrity = (0, $3E8Nt.getRandomChoice)((0, $1JkT6.specialSegmentCelebritiesData), superstarRandom())["name"];
            newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: month,
                year: year,
                superstar: superstar,
                celebrity: celebrity,
                newsType: "celebrity_beatdown",
                headline: true
            });
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) {
                const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
                const superstars = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>!(0, $3E8Nt.objectInArray)(x, participants));
                const markOutSuperstar = (0, $3E8Nt.getRandomChoice)(superstars);
                const newMessage = await (0, $hekDR.createSuperstarMarkedOutMessage)(markOutSuperstar, segmentItem.name, superstar, month, year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
        }
    }
    if (segmentItem.name === "Hosedown") {
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
        const superstars = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>!(0, $3E8Nt.objectInArray)(x, participants));
        const availableSuperstars = superstars.filter((x)=>(0, $5kTkA.checkAvailability)(x, true) && !x.unhappy);
        // Set unhappy superstars
        let unhappySuperstars = [];
        if (!game.settings["no_unhappiness"]) {
            if (availableSuperstars.length > 0) unhappySuperstars = (0, $3E8Nt.getRandomSample)(availableSuperstars, 2);
            else unhappySuperstars = (0, $3E8Nt.getRandomSample)(superstars, 2);
            for (const s of unhappySuperstars)await (0, $5kTkA.changeSuperstarMoraleToUnhappy)(s, company);
            data["unhappySuperstars"] = unhappySuperstars.map((x)=>x.name);
            data["unhappyReason"] = "hosedown";
        }
        if (company.userControlled) {
            // Add news
            newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: month,
                year: year,
                superstar: superstar,
                newsType: "hosedown",
                headline: true
            });
            // Add mark out message
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) {
                const markOutSuperstar = (0, $3E8Nt.getRandomChoice)(superstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, unhappySuperstars)));
                const newMessage = await (0, $hekDR.createSuperstarMarkedOutMessage)(markOutSuperstar, segmentItem.name, superstar, month, year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
        }
    }
    if (segmentItem.name === "Anti-Company Rant") {
        let segmentEvent = await (0, $eg5dz.getSegmentEvent)(segment);
        superstar.suspensionMonths = segmentEvent.weeklyShow ? 1 : 2;
        data["suspendedSuperstar"] = superstar.name;
        // Check talent request
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "write_off",
            talent: superstar
        });
        if (company.userControlled) // Add news
        newsItem = await (0, $kZMqI.generateNewsItem)({
            company: company,
            month: month,
            year: year,
            superstar: superstar,
            newsType: "anti_company_rant",
            headline: true
        });
    }
    // Add news item
    if (newsItem) await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
        newsItem
    ]);
    data["ownerName"] = company.ownerName || "the Owner";
    return data;
}
async function $336089d6be28ba1c$var$runSegmentConsequence(segmentItem, segment, participants, company, mainCompany, game, month, year, indieRoster, indieAvailableRoster, winnerParticipant, graphics, segmentManagers) {
    const data = {};
    const vacated = [];
    const awarded = [];
    const fired = [];
    const feudsEnded = [];
    const feudItemsLevelData = [];
    const unlockedFeudItems = [];
    const turnedHeel = [];
    const turnedFace = [];
    const turnedNeutral = [];
    const feudsStarted = [];
    const feudPotentials = [];
    const feudHypeIncreased = [];
    const disbanded = [];
    const createdChampionships = [];
    const unavailable = [];
    const suspended = [];
    const retirements = [];
    const teamsCreated = [];
    const managersAdded = [];
    const managersRemoved = [];
    const factionReputationsData = [];
    const factionSegmentConsequence = {};
    const brandChanges = [];
    const maskRemoved = [];
    let shockingTurn = false;
    let turnTooSoon = false;
    let monthsAfterTurn = 0;
    let consequenceRunOn = null;
    const monthsPassed = year * 12 + month;
    const rosters = await (0, $9esFv.getCompanyRosters)(company);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    const segmentEvent = await (0, $eg5dz.getSegmentEvent)(segment);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main", rosters);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(company);
    const feudItems = await (0, $9esFv.getCompanyFeudItems)(company);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
    let segmentSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    const prestigeRanks = {
        "S": 4,
        "A": 3,
        "B": 2,
        "C": 1
    };
    // Check if singles/tag/trio participants
    let singles = false, tag = false;
    if (participants.length > 0) {
        if (participants[0].objectName === "superstar") singles = true;
        else tag = true;
    }
    // Get who to apply consequence to
    let applyConsequenceTo;
    if (segment.consequenceAppliedTo) applyConsequenceTo = participants.find((x)=>x.name === segment.consequenceAppliedTo);
    else applyConsequenceTo = winnerParticipant;
    if ([
        "feud-blowoff",
        "face-turn-and-blowoff",
        "create-tag-team-and-blowoff"
    ].includes(segmentItem.consequence)) {
        for (const s of participants){
            // Check for existing feud
            let existingFeud;
            for (const f of (await (0, $cXLSF.getRosterMemberFeuds)(s))){
                if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
                    if ((await (0, $jDtEn.getFeudParticipants)(f)).every((y)=>(0, $3E8Nt.objectInArray)(y, participants))) {
                        existingFeud = f;
                        break;
                    }
                }
            }
            if (existingFeud) {
                // End feud
                existingFeud.ended = true;
                if (existingFeud.started) existingFeud.rating = await (0, $cXLSF.getFeudRating)(existingFeud);
                existingFeud.endMonth = month;
                existingFeud.endYear = year;
                const d = {
                    "name": existingFeud.name,
                    "participants": (await (0, $jDtEn.getFeudParticipants)(existingFeud)).map((x)=>x.name),
                    "rating": existingFeud.rating
                };
                if (!feudsEnded.includes(d)) {
                    feudsEnded.push(d);
                    // Change prestige
                    if (existingFeud.ended && existingFeud.started && (0, $98xmD.globalUser).paid) {
                        const feudItem = await (0, $jDtEn.getFeudFeudItem)(existingFeud);
                        let levelIncrease = false;
                        let hypeIncrease = 0;
                        // Add xp
                        let increase = 0;
                        if (existingFeud.rating !== null) increase = Math.floor(Math.pow(existingFeud.rating, 2));
                        feudItem.xp += increase;
                        if (feudItem.level < 3) // Check level increase
                        {
                            if (feudItem.xp >= Math.pow(feudItem.level, 2) * 40) {
                                // Increase base hype
                                hypeIncrease = feudItem.level * 5;
                                feudItem.baseHype += hypeIncrease;
                                feudItem.level += 1;
                                levelIncrease = true;
                            }
                        }
                        // Prepare data
                        const feudItemLevelData = {
                            "name": feudItem.name,
                            "xp": feudItem.xp,
                            "xpChange": increase,
                            "level": feudItem.level,
                            "levelIncrease": levelIncrease,
                            "hypeIncrease": hypeIncrease
                        };
                        feudItemsLevelData.push(feudItemLevelData);
                        const unlocked = (0, $3SyPM.checkFeudItemsToUnlock)(feudItem, await (0, $9esFv.getCompanyFeudItems)(company));
                        unlockedFeudItems.push(...unlocked);
                    }
                }
                // Unlock special segment
                if (existingFeud.rating >= 4.5 && existingFeud.name.toLowerCase().includes("family")) await (0, $3SyPM.unlockSpecialSegment)(company, "Car Explosion", month, year);
            }
        }
        // Add face turn
        if (segmentItem.consequence === "face-turn-and-blowoff") {
            for (const s of applyConsequenceTo.tempSuperstars)if (s.alignment !== "face") await (0, $jpMCP.turnRosterMember)(s, "face", company);
            turnedFace.push({
                "name": applyConsequenceTo.name,
                "shocking": shockingTurn
            });
        }
    }
    if (segmentItem.consequence === "fire-superstar") {
        let superstars = participants[0].tempSuperstars;
        // Process superstars if not on trade
        superstars = superstars.filter((x)=>x.activeEffect !== "traded");
        const overnessDecrease = (0, $3E8Nt.getRandomInt)(8, 12);
        for (const superstar of superstars){
            // Move to indies
            if (game.settings["all_indies_available"]) await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, [
                superstar
            ]);
            else await (0, $dl5u4.addRosterSuperstars)(indieRoster, [
                superstar
            ]);
            // Lower overness
            superstar.overness -= overnessDecrease;
            fired.push({
                "name": superstar.name,
                "pronoun": superstar.possessivePronoun,
                "overnessDecrease": overnessDecrease
            });
            // Remove teams/managers/factions
            disbanded.push(...await (0, $5kTkA.removeSuperstarTagTeams)(superstar));
            await (0, $5kTkA.removeSuperstarFactionRelationships)(superstar, month, year);
            await (0, $5kTkA.removeSuperstarManagerRelationships)(superstar);
            superstar.brandName = null;
            // Vacate championships
            vacated.push(...await (0, $5kTkA.vacateChampionships)({
                superstar: superstar,
                championships: companyChampionships,
                month: month,
                year: year
            }));
            // Delete all relationships, add former company relationship
            for (const relationship of (await (0, $hBIDz.getSuperstarRelationships)(superstar)))await (0, $14eBR.Relationships).remove(relationship);
            await (0, $8A6FL.addFormerCompanyRelationship)(superstar, company);
            // Delete talent requests
            for (const talentRequest of (await (0, $hBIDz.getSuperstarTalentRequests)(superstar)))await (0, $14eBR.TalentRequests).remove(talentRequest);
            // Make superstar happy
            (0, $5kTkA.changeSuperstarMoraleToHappy)(superstar);
            // Add news
            let newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: game.newsMonth,
                year: game.newsYear,
                superstar: superstar,
                newsType: "superstar_released_by_company"
            });
            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                newsItem
            ]);
            if (company.userControlled) {
                // Add message
                const newMessage = await (0, $hekDR.createTalentReleasedMessage)(superstar, staffMembers, month, year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            if (company.storyName === "passion") await (0, $jC7EP.processPowSuperstarLeavesCompany)(superstar, company);
        }
    }
    if (segmentItem.consequence === "vacate-title") {
        // Get championships to vacate
        const championshipsToVacate = [];
        if (segment.consequenceData) {
            const championshipUid = segment.consequenceData["championshipUid"];
            if (championshipUid) {
                const championship = await (0, $14eBR.Championships).get(championshipUid);
                if (championship) championshipsToVacate.push(championship);
            }
        }
        // Vacate championships
        for (const s of participants[0].tempSuperstars){
            const vacatedChampionships = await (0, $5kTkA.vacateChampionships)({
                superstar: s,
                championships: companyChampionships,
                month: month,
                year: year,
                company: company,
                championshipsToVacate: championshipsToVacate,
                checkTalentRequest: true
            });
            vacated.push(...vacatedChampionships);
        }
    }
    if (segmentItem.consequence === "award-title") {
        // Get championship to award
        let championship;
        if (segment.consequenceData) {
            const championshipUid = segment.consequenceData["championshipUid"];
            if (championshipUid) championship = await (0, $14eBR.Championships).get(championshipUid);
        }
        // Award championship(s)
        if (championship) {
            const championshipsSet = companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship));
            for(let i = 0; i < championshipsSet.length; i++){
                const s = participants[0].tempSuperstars[i];
                const c = championshipsSet[i];
                await (0, $hBIDz.addSuperstarChampionships)(s, [
                    c
                ]);
                s.popularity += (0, $8A6FL.getChampionshipPopularityIncrease)(c);
                c.vacated = false;
                // Add championship reign
                const newReign = (0, $9MKdC.ChampionshipReign)(month, year);
                await (0, $14eBR.ChampionshipReigns).insert(newReign);
                await (0, $ivuOU.addChampionshipChampionshipReigns)(c, [
                    newReign
                ]);
                await (0, $hBIDz.addSuperstarChampionshipReigns)(s, [
                    newReign
                ]);
                // Transfer match contract
                if (c.matchContract) {
                    const matchContract = await (0, $ivuOU.getChampionshipMatchContract)(c);
                    if (matchContract) await (0, $1AAHK.addTalentMatchContracts)(participants[0], [
                        matchContract
                    ]);
                }
            }
            // Award titles
            awarded.push((0, $kZwpB.getChampionshipMatchData)(championshipsSet[0]));
        }
    }
    if (segmentItem.consequence === "heel-turn" || segmentItem.consequence === "face-turn") {
        if (applyConsequenceTo) {
            let participantAlignment = applyConsequenceTo.tempSuperstars.every((s)=>s.alignment);
            let alignmentMonths = applyConsequenceTo.tempSuperstars.reduce((total, s)=>total + s.alignmentMonths, 0) / applyConsequenceTo.tempSuperstars.length;
            let popularity = await (0, $3E8Nt.getRosterMemberPopularity)(applyConsequenceTo);
            let newLog;
            let overnessChange = 0;
            // Check for shocking turn
            if (participantAlignment && alignmentMonths >= 12 && popularity >= 800 && segmentItem.minParticipants > 1) {
                // Set shocking turn variables
                shockingTurn = true;
                monthsAfterTurn = alignmentMonths;
                // Holy shit moment award
                const pointsGained = 30;
                company.points += pointsGained;
                // Check goals
                if (company.userControlled) {
                    let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                        name: "holy shit moments",
                        change: 1,
                        company: company
                    });
                    if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                }
                // Unlock powerup
                if (company.storyName !== "mars") {
                    const powerups = await (0, $9esFv.getCompanyPowerups)(company);
                    if (powerups.length > 0) {
                        const powerupsToUnlock = (0, $kpu3X.getPowerupsToUnlock)(powerups);
                        if (powerupsToUnlock.length > 0) {
                            const unlockedPowerup = (0, $kpu3X.awardPowerup)(powerupsToUnlock, true, true);
                            if (unlockedPowerup && company.userControlled) {
                                const newMessage = await (0, $hekDR.createPowerupMessage)(unlockedPowerup, month, year);
                                await (0, $9esFv.addCompanyMessages)(company, [
                                    newMessage
                                ]);
                            }
                        }
                    }
                }
                // Add log
                newLog = (0, $4K85d.CompanyLog)(month, year);
                newLog.type = "turn";
                newLog.eventName = segmentEvent.name;
                newLog.value = 6;
                newLog.realYear = company.realYear;
                await (0, $14eBR.CompanyLogs).insert(newLog);
                await (0, $9esFv.addCompanyCompanyLogs)(company, [
                    newLog
                ]);
                // Increase overness
                overnessChange = 5;
                overnessChange += Math.floor(monthsAfterTurn / 6);
                if (overnessChange > 15) overnessChange = 15;
                for (const s of applyConsequenceTo.tempSuperstars)s.overness += overnessChange;
            } else if (participantAlignment && alignmentMonths < 6 && monthsPassed > 6) {
                turnTooSoon = true;
                monthsAfterTurn = alignmentMonths;
                // Decrease overness
                overnessChange = 1;
                overnessChange += (6 - monthsAfterTurn) * 4;
                overnessChange = Math.floor(overnessChange * -1);
                for (const s of applyConsequenceTo.tempSuperstars)s.overness += overnessChange;
            }
            if (segmentItem.consequence === "heel-turn") {
                for (const s of applyConsequenceTo.tempSuperstars)if (s.alignment !== "heel") await (0, $jpMCP.turnRosterMember)(s, "heel", company);
                turnedHeel.push({
                    "name": applyConsequenceTo.name,
                    "shocking": shockingTurn,
                    "pronoun": applyConsequenceTo.possessivePronoun,
                    "overnessChange": overnessChange,
                    "tooSoon": turnTooSoon
                });
                if (shockingTurn) {
                    const turnedOn = participants.find((x)=>x.$loki !== applyConsequenceTo.$loki);
                    newLog.text = `${applyConsequenceTo.name} turned on ${turnedOn.name} in a shocking move!`;
                }
            } else if (segmentItem.consequence === "face-turn") {
                for (const s of applyConsequenceTo.tempSuperstars)if (s.alignment !== "face") await (0, $jpMCP.turnRosterMember)(s, "face", company);
                turnedFace.push({
                    "name": applyConsequenceTo.name,
                    "shocking": shockingTurn,
                    "pronoun": applyConsequenceTo.possessivePronoun,
                    "overnessChange": overnessChange,
                    "tooSoon": turnTooSoon
                });
                if (shockingTurn) newLog.text = `${applyConsequenceTo.name} turned Face in a shocking move!`;
            }
            // Disband tag team
            if (segmentItem.requirement === "heel-team-superstars" || segmentItem.requirement === "face-team-superstars") {
                // Get tag team
                let tagTeam;
                for (const t of (await (0, $hBIDz.getSuperstarTagTeams)(applyConsequenceTo)))if (!t.temporary && (0, $3E8Nt.checkAreObjArraysEqual)(await (0, $972Ip.getTagTeamSuperstars)(t), participants)) tagTeam = t;
                if (tagTeam) {
                    // Vacate championships
                    const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                    const vacatedChampionships = await (0, $5kTkA.vacateChampionships)({
                        superstar: tagTeamSuperstars[0],
                        championships: companyChampionships,
                        month: month,
                        year: year,
                        tagTeam: tagTeam
                    });
                    vacated.push(...vacatedChampionships);
                    // Remove tag team
                    await (0, $ko5kE.removeTagTeam)(tagTeam);
                    disbanded.push(tagTeam.name);
                    // Check talent request
                    for (const superstar of tagTeamSuperstars){
                        let requestData = {
                            "teamId": tagTeam.$loki
                        };
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "disband_team",
                            talent: superstar,
                            data: requestData
                        });
                    }
                }
            }
        }
    }
    if (segmentItem.consequence === "neutral-turn") {
        for (const s of applyConsequenceTo.tempSuperstars)if (s.alignment !== "") await (0, $jpMCP.turnRosterMember)(s, null, company);
        turnedNeutral.push({
            "name": applyConsequenceTo.name
        });
    }
    if (segmentItem.consequence === "boost-event-hype") {
        const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(company);
        const nextEvent = await (0, $5ZsVo.getUpcomingMonthlyEventForWeeklyEvent)(latestEvent, parentEvents, company);
        consequenceRunOn = nextEvent.name;
        // Add hype boost to next event
        const eventHypeBoost = $336089d6be28ba1c$var$getSegmentEventHypeBoost(segment.rating, segmentItem.hypeBoost);
        segmentEvent.nextEventBoost += eventHypeBoost;
        data["hypeBoostAdded"] = eventHypeBoost;
        segment.participants = [
            nextEvent.name
        ];
    }
    if (segmentItem.consequence === "boost-main-event-hype") {
        const matchesAndSegments = await (0, $5ZsVo.getEventMatchesAndSegments)(segmentEvent);
        if (matchesAndSegments.length > 0) {
            const sortedSegmentAndMatches = matchesAndSegments.sort((a, b)=>a.order - b.order);
            const mainEvent = sortedSegmentAndMatches[0];
            consequenceRunOn = await (0, $3E8Nt.getMatchOrSegmentName)(mainEvent);
            // Add hype boost to main event
            const hypeBoost = $336089d6be28ba1c$var$getMainEventHypeBoost(segment.rating, segmentItem.hypeBoost);
            mainEvent.hype += hypeBoost;
            // Add hype to event
            segmentEvent.hype += Math.round(hypeBoost / matchesAndSegments.length);
            data["hypeBoostAdded"] = hypeBoost;
            data["mainEventHype"] = mainEvent.hype;
            data["eventHype"] = segmentEvent.hype;
            segment.participants = [
                consequenceRunOn
            ];
        } else {
            consequenceRunOn = "Main Event";
            segment.participants = [
                "Main Event"
            ];
        }
    }
    if (segmentItem.consequence === "boost-popularity") {
        // Get best match/segment of last event, except production segments
        let companyEvents = (await (0, $9esFv.getCompanyEvents)(company)).reverse();
        let previousEvent = companyEvents[1];
        let segmentsAndMatches = await (0, $iQtzn.getEventMatches)(previousEvent);
        for (const x of (await (0, $iQtzn.getEventSegments)(previousEvent)))if (!(await (0, $eg5dz.getSegmentSegmentItem)(x))?.productionSegment) segmentsAndMatches.push(x);
        if (segmentsAndMatches.length > 0) {
            // Get match or segment
            let matchOrSegment;
            if (segment.consequenceData) {
                let matchOrSegmentUid = segment.consequenceData["matchOrSegmentUid"];
                let matchOrSegmentType = segment.consequenceData["matchOrSegmentType"];
                if (matchOrSegmentUid) matchOrSegment = segmentsAndMatches.find((y)=>y.$loki === matchOrSegmentUid && y.objectName === matchOrSegmentType);
            }
            if (!matchOrSegment) // Compatibility with old saves
            matchOrSegment = segmentsAndMatches.sort((a, b)=>b.rating - a.rating)[0];
            // Get name and set participants
            consequenceRunOn = await (0, $3E8Nt.getMatchOrSegmentName)(matchOrSegment);
            segment["participants"] = [
                consequenceRunOn
            ];
            // Boost pop for participants
            let popularityBoost = $336089d6be28ba1c$var$getSegmentPopularityBoost(segment.rating, segmentItem.popularityBoost);
            let matchOrSegmentParticipants;
            if (matchOrSegment.objectName === "segment") matchOrSegmentParticipants = await (0, $eg5dz.getSegmentParticipants)(matchOrSegment);
            else matchOrSegmentParticipants = await (0, $i7bmn.getMatchParticipants)(matchOrSegment);
            for (const p of matchOrSegmentParticipants)for (let s of (await (0, $5kTkA.getRosterMemberSuperstars)(p)))popularityBoost = (0, $5kTkA.updateSuperstarPopularity)(s, popularityBoost, false, false, true);
            data["popularityBoostAdded"] = popularityBoost;
        } else {
            consequenceRunOn = "Segment on Last Show";
            segment["participants"] = [
                consequenceRunOn
            ];
        }
    }
    if (segmentItem.consequence === "vacate-title-and-create-match-contract") {
        let championship;
        for (const s of segmentSuperstars){
            let championships = (await (0, $hBIDz.getSuperstarChampionships)(s)).filter((c)=>prestigeRanks[c.prestige] >= 2);
            if (singles) championships = championships.filter((x)=>!x.tagTeam && !x.trio);
            else if (participants[0].trio) championships = championships.filter((x)=>x.trio || x.tagTeam);
            else championships = championships.filter((x)=>x.tagTeam);
            if (championships.length > 0) {
                championship = championships[0];
                break;
            }
        }
        if (championship) {
            let matchContractAwarded = await (0, $kZwpB.runOptionCAction)(championship, companyChampionships, company, month, year);
            if (matchContractAwarded) {
                vacated.push((0, $kZwpB.getChampionshipMatchData)(championship));
                awarded.push((0, $kZwpB.getChampionshipMatchData)(matchContractAwarded[0]));
            }
        }
    }
    if (segmentItem.consequence === "change-title-design") {
        let championship;
        for (const s of segmentSuperstars){
            let championships = (await (0, $hBIDz.getSuperstarChampionships)(s)).filter((c)=>prestigeRanks[c.prestige] >= 3);
            if (singles) championships = championships.filter((x)=>!x.tagTeam && !x.trio);
            else if (participants[0].trio) championships = championships.filter((x)=>x.trio || x.tagTeam);
            else championships = championships.filter((x)=>x.tagTeam);
            if (championships.length > 0) {
                championship = championships[0];
                break;
            }
        }
        if (championship) {
            await (0, $kZwpB.runCustomizeChampionshipAction)(championship, companyChampionships);
            let requestData = {
                "championshipId": championship.$loki
            };
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "customize_championship",
                talent: participants[0],
                data: requestData
            });
        }
    }
    if (segmentItem.consequence === "split-title") {
        let championship;
        for (const s of segmentSuperstars){
            let championships = (await (0, $hBIDz.getSuperstarChampionships)(s)).filter((c)=>prestigeRanks[c.prestige] >= 4);
            if (singles) championships = championships.filter((x)=>!x.tagTeam && !x.trio);
            else if (participants[0].trio) championships = championships.filter((x)=>x.trio || x.tagTeam);
            else championships = championships.filter((x)=>x.tagTeam);
            if (championships.length > 0) {
                championship = championships[0];
                break;
            }
        }
        if (championship) {
            let championshipName = null;
            if (segment.consequenceData) championshipName = segment.consequenceData["objectName"];
            const newChampionships = await (0, $kZwpB.runSplitChampionshipAction)(championship, companyChampionships, company, championshipName);
            if (newChampionships) createdChampionships.push((0, $kZwpB.getChampionshipMatchData)(newChampionships[0]));
        }
    }
    if (segmentItem.consequence === "suspend") for (const superstar of segmentSuperstars){
        superstar.suspensionMonths = segmentEvent.weeklyShow ? 1 : 2;
        suspended.push({
            "name": superstar.name,
            "months": 1
        });
        // Check talent request
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "write_off",
            talent: superstar
        });
    }
    if (segmentItem.consequence === "retire") {
        for (const superstar of segmentSuperstars)if (superstar.activeEffect !== "traded") {
            const retirementData = await (0, $5kTkA.retireSuperstar)(superstar, mainRoster, companyChampionships, month, year, company);
            retirements.push(retirementData);
            vacated.push(...retirementData["vacated"]);
            disbanded.push(...retirementData["tagTeams"]);
        }
    }
    if (segmentItem.consequence === "make-unavailable") {
        // Get months unavailable for
        let monthsUnavailable = null;
        if (segment.consequenceData) {
            if (segment.consequenceData["monthsUnavailable"]) monthsUnavailable = parseInt(segment.consequenceData["monthsUnavailable"]);
        }
        if (!monthsUnavailable) monthsUnavailable = (0, $3E8Nt.getRandomInt)(3, 5);
        for (const superstar of segmentSuperstars){
            (0, $5kTkA.addKayfabeInjuryToSuperstar)(superstar, monthsUnavailable);
            unavailable.push({
                "name": superstar.name
            });
            // Check talent request
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "write_off",
                talent: superstar
            });
        }
    }
    if (segmentItem.consequence === "loser-unavailable") {
        const loser = participants.find((p)=>p.$loki !== winnerParticipant.$loki);
        // Get months unavailable for
        let monthsUnavailable = null;
        if (segment.consequenceData) {
            if (segment.consequenceData["monthsUnavailable"]) monthsUnavailable = parseInt(segment.consequenceData["monthsUnavailable"]);
        }
        if (!monthsUnavailable) monthsUnavailable = (0, $3E8Nt.getRandomInt)(3, 5);
        for (const superstar of loser.tempSuperstars){
            (0, $5kTkA.addKayfabeInjuryToSuperstar)(superstar, monthsUnavailable);
            unavailable.push({
                "name": superstar.name
            });
            // Check talent request
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "write_off",
                talent: superstar
            });
        }
        // Add to company logs
        let newLog = (0, $4K85d.CompanyLog)(month, year);
        newLog.type = "injury";
        newLog.text = `${winnerParticipant.name} injured ${loser.name}`;
        newLog.value = 0;
        await (0, $14eBR.CompanyLogs).insert(newLog);
        await (0, $9esFv.addCompanyCompanyLogs)(company, [
            newLog
        ]);
    }
    if (segmentItem.consequence === "create-tag-team-and-blowoff" || segmentItem.consequence === "create-team") {
        // Create team and add to roster
        const tagTeam = await (0, $8bQDO.generateTagTeam)(participants);
        if (segment.consequenceData) {
            const teamName = segment.consequenceData["objectName"];
            if (teamName) tagTeam.name = teamName;
        }
        await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
            tagTeam
        ]);
        if (participants.length === 3) tagTeam.trio = true;
        teamsCreated.push({
            "name": tagTeam.name,
            "superstars": (0, $3E8Nt.commaSeparate)(participants.map((x)=>x.name))
        });
        // Add log
        const newLog = (0, $4K85d.CompanyLog)(month, company.realYear);
        (0, $14eBR.CompanyLogs).insert(newLog);
        newLog.text = `${tagTeam.name}`;
        newLog.type = "new-tag-team";
        newLog.realYear = year;
        await (0, $9esFv.addCompanyCompanyLogs)(company, [
            newLog
        ]);
        // Check talent request
        for (const participant of participants)for (const teamMember of participants.filter((x)=>x !== participant)){
            let requestData = {
                "talentId": teamMember.$loki
            };
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "team_with_x",
                talent: participant,
                data: requestData
            });
        }
    }
    if (segmentItem.consequence === "create-trio-of-heels") {
        // Create trio of heels and add to roster
        const trioMembers = participants.filter((y)=>y.alignment === "heel");
        if (trioMembers.length === 3) {
            const trio = await (0, $8bQDO.generateTrio)(trioMembers);
            if (segment.consequenceData) {
                const teamName = segment.consequenceData["objectName"];
                if (teamName) trio.name = teamName;
            }
            await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
                trio
            ]);
            teamsCreated.push({
                "name": trio.name,
                "superstars": (0, $3E8Nt.commaSeparate)(trioMembers.map((x)=>x.name))
            });
            // Add log
            const newLog = (0, $4K85d.CompanyLog)(month, company.realYear);
            (0, $14eBR.CompanyLogs).insert(newLog);
            newLog.text = `${trio.name}`;
            newLog.type = "new-tag-team";
            newLog.realYear = year;
            await (0, $9esFv.addCompanyCompanyLogs)(company, [
                newLog
            ]);
            // Check talent request
            for (const participant of trioMembers)for (const teamMember of trioMembers.filter((x)=>x !== participant)){
                let requestData = {
                    "talentId": teamMember.$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "team_with_x",
                    talent: participant,
                    data: requestData
                });
            }
        }
    }
    if (segmentItem.consequence === "remove-tag-team-and-create-tag-team") {
        // Get tag team
        let participantInTeam;
        let participantTagTeam;
        for (const p of participants){
            let pt = (await (0, $hBIDz.getSuperstarTagTeams)(p)).find((x)=>!x.temporary && !x.trio);
            if (pt) {
                participantInTeam = p;
                participantTagTeam = pt;
                break;
            }
        }
        if (participantInTeam) {
            // Vacate championships
            const teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participantTagTeam);
            const vacatedChampionships = await (0, $5kTkA.vacateChampionships)({
                superstar: teamSuperstars[0],
                championships: companyChampionships,
                month: month,
                year: year,
                tagTeam: participantTagTeam
            });
            vacated.push(...vacatedChampionships);
            // Remove tag team
            await (0, $ko5kE.removeTagTeam)(participantTagTeam);
            disbanded.push(participantTagTeam.name);
            // Check talent request
            for (const superstar of teamSuperstars){
                let requestData = {
                    "teamId": participantTagTeam.$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "disband_team",
                    talent: superstar,
                    data: requestData
                });
            }
        }
        // Create new tag team and add to roster
        const tagTeam = await (0, $8bQDO.generateTagTeam)(participants);
        if (segment.consequenceData) {
            const teamName = segment.consequenceData["objectName"];
            if (teamName) tagTeam.name = teamName;
        }
        await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
            tagTeam
        ]);
        teamsCreated.push({
            "name": tagTeam.name,
            "superstars": (0, $3E8Nt.commaSeparate)(participants.map((x)=>x.name))
        });
        // Add log
        const newLog = (0, $4K85d.CompanyLog)(month, company.realYear);
        (0, $14eBR.CompanyLogs).insert(newLog);
        newLog.text = `${tagTeam.name}`;
        newLog.type = "new-tag-team";
        newLog.realYear = year;
        await (0, $9esFv.addCompanyCompanyLogs)(company, [
            newLog
        ]);
        // Check talent request
        for (const participant of participants){
            const teamMember = participants.find((x)=>x !== participant);
            if (teamMember) {
                let requestData = {
                    "talentId": teamMember.$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "team_with_x",
                    talent: participant,
                    data: requestData
                });
            }
        }
    }
    if (segmentItem.consequence === "create-retirement-feud") {
        // Find existing feuds
        const feuds = [];
        for (const s of participants){
            // Check for existing feud
            let existingFeud;
            for (const f of (await (0, $cXLSF.getRosterMemberFeuds)(s))){
                if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
                    if ((await (0, $jDtEn.getFeudParticipants)(f)).every((y)=>(0, $3E8Nt.objectInArray)(y, participants))) {
                        existingFeud = f;
                        break;
                    }
                }
            }
            if (existingFeud) feuds.push(existingFeud);
        }
        // Create feud if no feuds present
        if (!feuds.length) {
            let feudItem = feudItems.find((x)=>x.name === "Retire Me");
            if (!feudItem) {
                const availableFeudItems = feudItems.filter((x)=>x.unlocked && !x.requirement && !x.consequence);
                feudItem = (0, $3E8Nt.getRandomChoice)(availableFeudItems);
            }
            let feudParticipants = participants.slice(0, 2);
            const newFeud = (0, $jDtEn.Feud)();
            await (0, $14eBR.Feuds).insert(newFeud);
            newFeud.name = feudItem.name;
            newFeud.hype = feudItem.baseHype;
            const boosts = await (0, $cXLSF.getFeudCreationBoosts)(newFeud, feudParticipants, month, year, company.style);
            const addedHype = boosts["hypeBoost"];
            newFeud.hype += addedHype;
            newFeud.started = true;
            newFeud.startMonth = month;
            newFeud.startYear = year;
            await (0, $im36F.addFeudItemFeuds)(feudItem, [
                newFeud
            ]);
            await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                newFeud
            ]);
            await (0, $eg5dz.addSegmentFeuds)(segment, [
                newFeud
            ]);
            // Add feud to participants
            if (singles) await (0, $jDtEn.addFeudSuperstars)(newFeud, feudParticipants);
            else if (tag) await (0, $jDtEn.addFeudTagTeams)(newFeud, feudParticipants);
            newFeud.participants = feudParticipants.map((x)=>x.name);
            feudsStarted.push({
                "name": newFeud.name,
                "participants": newFeud.participants,
                "boosts": boosts,
                "baseHype": feudItem.baseHype
            });
            for (const feudParticipant of feudParticipants){
                const otherFeudParticipant = feudParticipants.find((x)=>x.$loki !== feudParticipant.$loki);
                // Check talent request
                if (otherFeudParticipant) {
                    let requestData = {
                        "talentId": otherFeudParticipant.$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "feud_with_x",
                        talent: feudParticipant,
                        data: requestData
                    });
                }
            }
        }
    }
    if (segmentItem.consequence === "create-random-feud") {
        // Add random superstar to feud participants
        let feudParticipants = [
            ...participants
        ];
        let availableChoices = [];
        if (singles) availableChoices = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>!(0, $3E8Nt.objectInArray)(x, feudParticipants) && (0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, x));
        else {
            if (participants[0].factionTagTeam) {
                // Choose factions to feud with faction
                let tagTeamSuperstar = (await (0, $972Ip.getTagTeamSuperstars)(participants[0]))[0];
                let participantFaction = (await (0, $hBIDz.getSuperstarFactions)(tagTeamSuperstar)).find((y)=>!y.disbanded);
                feudParticipants = [
                    participantFaction
                ];
                for (const f of (await (0, $dl5u4.getRosterFactions)(mainRoster))){
                    let fs = await (0, $2JFAd.getFactionSuperstars)(f);
                    if (!f.disbanded && !(0, $3E8Nt.objectInArray)(f, feudParticipants) && fs.every((s)=>(0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, s))) availableChoices.push(f);
                }
            } else for (const t of (await (0, $dl5u4.getRosterTagTeams)(mainRoster))){
                let ts = await (0, $972Ip.getTagTeamSuperstars)(t);
                if (!t.temporary && !(0, $3E8Nt.objectInArray)(t, feudParticipants) && ts.every((s)=>(0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, s))) availableChoices.push(t);
            }
        }
        if (availableChoices.length > 0) {
            let randomSuperstar = (0, $3E8Nt.getRandomChoice)(availableChoices);
            feudParticipants.push(randomSuperstar);
            // Find existing feuds
            let feuds = [];
            for (let s of feudParticipants){
                // Check for existing feud
                let existingFeud;
                for (const f of (await (0, $cXLSF.getRosterMemberFeuds)(s))){
                    if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
                        if ((await (0, $jDtEn.getFeudParticipants)(f)).every((y)=>(0, $3E8Nt.objectInArray)(y, participants))) {
                            existingFeud = f;
                            break;
                        }
                    }
                }
                if (existingFeud) feuds.push(existingFeud);
            }
            // Create feud if no feuds present
            if (!feuds.length) {
                let feudItem = feudItems.find((x)=>x.name === "Grudge");
                if (!feudItem) {
                    let companyFeudItems = feudItems.find((x)=>x.unlocked && !x.requirement && !x.consequence);
                    feudItem = (0, $3E8Nt.getRandomChoice)(companyFeudItems);
                }
                let newFeud = (0, $jDtEn.Feud)();
                await (0, $14eBR.Feuds).insert(newFeud);
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) newFeud.name = feudItem.name;
                else newFeud.name = (0, $cXLSF.generateRandomFeudItemName)();
                newFeud.hype = feudItem.baseHype;
                let boosts = await (0, $cXLSF.getFeudCreationBoosts)(newFeud, feudParticipants, month, year, company.style);
                let addedHype = boosts.hypeBoost;
                newFeud.hype += addedHype;
                newFeud.started = true;
                newFeud.startMonth = month;
                newFeud.startYear = year;
                await (0, $im36F.addFeudItemFeuds)(feudItem, [
                    newFeud
                ]);
                await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                    newFeud
                ]);
                await (0, $eg5dz.addSegmentFeuds)(segment, [
                    newFeud
                ]);
                // Add feud to participants
                if (singles) await (0, $jDtEn.addFeudSuperstars)(newFeud, feudParticipants);
                else if (tag) {
                    if (participants[0].factionTagTeam) await (0, $jDtEn.addFeudFactions)(newFeud, feudParticipants);
                    else await (0, $jDtEn.addFeudTagTeams)(newFeud, feudParticipants);
                }
                newFeud.participants = feudParticipants.map((x)=>x.name);
                feudsStarted.push({
                    "name": newFeud.name,
                    "participants": newFeud.participants,
                    "boosts": boosts,
                    "baseHype": feudItem.baseHype
                });
                for (let feudParticipant of feudParticipants){
                    const otherFeudParticipant = feudParticipants.find((x)=>x.$loki !== feudParticipant.$loki);
                    // Check talent request
                    if (otherFeudParticipant) {
                        let requestData = {
                            "talentId": otherFeudParticipant.$loki
                        };
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "feud_with_x",
                            talent: feudParticipant,
                            data: requestData
                        });
                    }
                }
            }
        }
    }
    if ([
        "remove-faction-members",
        "add-faction-members",
        "add-faction-leader",
        "change-faction-leader",
        "kick-out-faction-leader-and-change-leader",
        "leave-faction-and-join-other-faction",
        "merge-factions",
        "split-faction",
        "create-faction"
    ].includes(segmentItem.consequence)) {
        // Get segment factions
        const rosterFactions = await (0, $dl5u4.getRosterFactions)(mainRoster);
        const factions = [];
        for (const y of segment.consequenceData["factionUids"]){
            const faction = rosterFactions.find((x)=>x.$loki === y);
            if (faction) factions.push(faction);
        }
        // Check faction inputs for errors
        const mainRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        const factionSegmentCheck = await $336089d6be28ba1c$var$checkFactionSegmentConsequence(factions, segmentItem, segment.consequenceData, mainRosterSuperstars, mainRoster, latestEvent, companyChampionships);
        if ((factions.length > 0 || segmentItem.consequence === "create-faction") && !factionSegmentCheck.error) {
            let updateFactionGraphic = false;
            let factionToMerge;
            let factionToJoin;
            // Get consequence superstars
            let segmentConsequenceSuperstars = [];
            for (const y of segment.consequenceData["superstarUids"]){
                const segmentConsequenceSuperstar = mainRosterSuperstars.find((x)=>x.$loki === y);
                if (segmentConsequenceSuperstar) segmentConsequenceSuperstars.push(segmentConsequenceSuperstar);
            }
            // Remove duplicates
            segmentConsequenceSuperstars = (0, $3E8Nt.getUniqueObjects)(segmentConsequenceSuperstars);
            // Run consequence
            if (segmentItem.consequence === "remove-faction-members") {
                // Update faction rep (members)
                const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                    faction: factions[0],
                    removedMembers: segmentConsequenceSuperstars
                });
                if (factionData) factionReputationsData.push(factionData);
                await (0, $2JFAd.removeFactionSuperstars)(factions[0], segmentConsequenceSuperstars);
                factionSegmentConsequence["removedFactionMembers"] = segmentConsequenceSuperstars.map((x)=>x.name);
                // Affect popularity of removed members
                const popularityChange = Math.floor(((factions[0].reputation + 1) / 1.72) ** 2) * -1;
                for (const s of segmentConsequenceSuperstars)s.popularity += popularityChange;
                factionSegmentConsequence["popularityChange"] = popularityChange;
                // Check leave faction request
                for (const s of segmentConsequenceSuperstars){
                    let requestData = {
                        "factionId": factions[0].$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "leave_faction",
                        talent: s,
                        data: requestData
                    });
                }
            } else if (segmentItem.consequence === "add-faction-members") {
                // Update faction rep (members)
                const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                    faction: factions[0],
                    addedMembers: segmentConsequenceSuperstars
                });
                if (factionData) factionReputationsData.push(factionData);
                (0, $2JFAd.addFactionSuperstars)(factions[0], segmentConsequenceSuperstars);
                factionSegmentConsequence["addedFactionMembers"] = segmentConsequenceSuperstars.map((x)=>x.name);
                updateFactionGraphic = true;
                // Affect popularity of added members
                const popularityChange = Math.floor(((factions[0].reputation + 1) / 1.72) ** 2);
                for (const s of segmentConsequenceSuperstars)s.popularity += popularityChange;
                factionSegmentConsequence["popularityChange"] = popularityChange;
                // Check join faction request
                for (const s of segmentConsequenceSuperstars){
                    let requestData = {
                        "factionId": factions[0].$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "join_faction",
                        talent: s,
                        data: requestData
                    });
                }
            } else if ([
                "add-faction-leader",
                "change-faction-leader"
            ].includes(segmentItem.consequence)) {
                // Add leader to faction if not present in it
                if (!(0, $3E8Nt.objectInArray)(segmentConsequenceSuperstars[0], await (0, $2JFAd.getFactionSuperstars)(factions[0]))) {
                    (0, $2JFAd.addFactionSuperstars)(factions[0], [
                        segmentConsequenceSuperstars[0]
                    ]);
                    factionSegmentConsequence["addedFactionMembers"] = [
                        segmentConsequenceSuperstars[0].name
                    ];
                    updateFactionGraphic = true;
                    // Check join faction request
                    let requestData = {
                        "factionId": factions[0].$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "join_faction",
                        talent: segmentConsequenceSuperstars[0],
                        data: requestData
                    });
                }
                // Set new leader
                (0, $2JFAd.setFactionLeaderSuperstar)(factions[0], segmentConsequenceSuperstars[0]);
                factionSegmentConsequence["setFactionLeader"] = segmentConsequenceSuperstars[0].name;
                // Update faction rep (members) if leader is new member
                if (factionSegmentConsequence["addedFactionMembers"]) {
                    const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                        faction: factions[0],
                        addedMembers: [
                            segmentConsequenceSuperstars[0]
                        ]
                    });
                    if (factionData) factionReputationsData.push(factionData);
                }
            } else if (segmentItem.consequence === "kick-out-faction-leader-and-change-leader") {
                // Remove faction leader from faction
                const factionLeader = await (0, $2JFAd.getFactionLeaderSuperstar)(factions[0]);
                if (factionLeader) {
                    // Update faction rep (members)
                    const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                        faction: factions[0],
                        removedMembers: [
                            factionLeader
                        ]
                    });
                    if (factionData) factionReputationsData.push(factionData);
                    await (0, $2JFAd.removeFactionSuperstars)(factions[0], [
                        factionLeader
                    ]);
                    factionSegmentConsequence["removedFactionMembers"] = [
                        factionLeader.name
                    ];
                    // Check leave faction request
                    let requestData = {
                        "factionId": factions[0].$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "leave_faction",
                        talent: factionLeader,
                        data: requestData
                    });
                }
                // Set new leader
                await (0, $2JFAd.setFactionLeaderSuperstar)(factions[0], segmentConsequenceSuperstars[0]);
                factionSegmentConsequence["setFactionLeader"] = segmentConsequenceSuperstars[0].name;
                // Add feud potential
                const feudItem = feudItems.find((x)=>x.unlocked && x.requirement === "usurped");
                if (feudItem && factionLeader) {
                    const newFeud = (0, $jDtEn.Feud)();
                    await (0, $14eBR.Feuds).insert(newFeud);
                    newFeud.name = feudItem.name;
                    newFeud.hype = feudItem.baseHype;
                    await (0, $im36F.addFeudItemFeuds)(feudItem, [
                        newFeud
                    ]);
                    await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                        newFeud
                    ]);
                    const feudSuperstars = [
                        factionLeader,
                        segmentConsequenceSuperstars[0]
                    ];
                    await (0, $jDtEn.addFeudSuperstars)(newFeud, feudSuperstars);
                    newFeud.participants = feudSuperstars.map((x)=>x.name);
                    newFeud.directFeudEvent = feudItem.requirement;
                    newFeud.startMonth = month;
                    newFeud.startYear = year;
                    feudPotentials.push({
                        "name": newFeud.name,
                        "participants": feudSuperstars.map((x)=>x.name)
                    });
                }
            } else if (segmentItem.consequence === "leave-faction-and-join-other-faction") {
                factionToJoin = rosterFactions.find((x)=>x.$loki === segment.consequenceData["factionConsequenceUids"][0]);
                // Update faction rep (members)
                let factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                    faction: factions[0],
                    removedMembers: segmentConsequenceSuperstars
                });
                if (factionData) factionReputationsData.push(factionData);
                factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                    faction: factionToJoin,
                    addedMembers: segmentConsequenceSuperstars
                });
                if (factionData) factionReputationsData.push(factionData);
                // Move superstars
                await (0, $2JFAd.removeFactionSuperstars)(factions[0], segmentConsequenceSuperstars);
                (0, $2JFAd.addFactionSuperstars)(factionToJoin, segmentConsequenceSuperstars);
                factionSegmentConsequence["movedFactionMembers"] = segmentConsequenceSuperstars.map((x)=>x.name);
                factionSegmentConsequence["consequenceFaction"] = factionToJoin.name;
                updateFactionGraphic = true;
                // Check faction requests
                for (const s of segmentConsequenceSuperstars){
                    let requestData = {
                        "factionId": factions[0].$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "leave_faction",
                        talent: s,
                        data: requestData
                    });
                    requestData = {
                        "factionId": factionToJoin.$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "join_faction",
                        talent: s,
                        data: requestData
                    });
                }
                // Add feud potential
                const feudItem = feudItems.find((x)=>x.unlocked && x.requirement === "switching-sides");
                if (feudItem) {
                    const newFeud = (0, $jDtEn.Feud)();
                    await (0, $14eBR.Feuds).insert(newFeud);
                    newFeud.name = feudItem.name;
                    newFeud.hype = feudItem.baseHype;
                    await (0, $im36F.addFeudItemFeuds)(feudItem, [
                        newFeud
                    ]);
                    await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                        newFeud
                    ]);
                    let leaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(factions[0]);
                    let factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(factions[0]);
                    const feudSuperstars = [
                        leaderSuperstar || (0, $3E8Nt.getRandomChoice)(factionSuperstars),
                        (0, $3E8Nt.getRandomChoice)(segmentConsequenceSuperstars)
                    ];
                    await (0, $jDtEn.addFeudSuperstars)(newFeud, feudSuperstars);
                    newFeud.participants = feudSuperstars.map((x)=>x.name);
                    newFeud.directFeudEvent = feudItem.requirement;
                    newFeud.startMonth = game.monthCount;
                    newFeud.startYear = game.year;
                    feudPotentials.push({
                        "name": newFeud.name,
                        "participants": feudSuperstars.map((x)=>x.name)
                    });
                }
            } else if (segmentItem.consequence === "merge-factions") {
                factionToMerge = rosterFactions.find((x)=>x.$loki === segment.consequenceData["factionConsequenceUids"][0]);
                let factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(factionToMerge);
                // Update faction rep (members)
                const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                    faction: factions[0],
                    addedMembers: factionSuperstars
                });
                if (factionData) factionReputationsData.push(factionData);
                // Disband faction to merge, move members to main faction, rename it
                factionToMerge.disbanded = true;
                (0, $2JFAd.addFactionSuperstars)(factions[0], factionSuperstars);
                factions[0].name = segment.consequenceData["createdFactionName"];
                factionSegmentConsequence["mergedFactions"] = [
                    factions[0].name,
                    factionToMerge.name
                ];
                factionSegmentConsequence["createdFactionName"] = segment.consequenceData["createdFactionName"];
                updateFactionGraphic = true;
            } else if (segmentItem.consequence === "split-faction") {
                // Update faction rep (members)
                const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                    faction: factions[0],
                    removedMembers: segmentConsequenceSuperstars
                });
                if (factionData) factionReputationsData.push(factionData);
                // Remove superstars from faction
                await (0, $2JFAd.removeFactionSuperstars)(factions[0], segmentConsequenceSuperstars);
                // Create new faction and add to roster
                const { reputation: reputation, xp: xp } = (0, $6PzHO.getFactionCreationReputationAndXp)(segmentConsequenceSuperstars);
                const newFaction = await (0, $6PzHO.createFaction)(segment.consequenceData["createdFactionName"], segmentConsequenceSuperstars, reputation, xp);
                await (0, $dl5u4.addRosterFactions)(mainRoster, [
                    newFaction
                ]);
                // Add company log
                const newLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
                (0, $14eBR.CompanyLogs).insert(newLog);
                newLog.text = `${newFaction.name}`;
                newLog.type = "new-faction";
                newLog.realYear = game.year;
                await (0, $9esFv.addCompanyCompanyLogs)(company, [
                    newLog
                ]);
                factionSegmentConsequence["newFactionMembers"] = segmentConsequenceSuperstars.map((x)=>x.name);
                factionSegmentConsequence["createdFactionName"] = segment.consequenceData["createdFactionName"];
                // Add feud potential
                const feudItem = feudItems.find((x)=>x.unlocked && x.requirement === "internal-division");
                if (feudItem) {
                    const newFeud = (0, $jDtEn.Feud)();
                    await (0, $14eBR.Feuds).insert(newFeud);
                    newFeud.name = feudItem.name;
                    newFeud.hype = feudItem.baseHype;
                    await (0, $im36F.addFeudItemFeuds)(feudItem, [
                        newFeud
                    ]);
                    await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                        newFeud
                    ]);
                    const feudFactions = [
                        factions[0],
                        newFaction
                    ];
                    await (0, $jDtEn.addFeudFactions)(newFeud, feudFactions);
                    newFeud.participants = feudFactions.map((x)=>x.name);
                    newFeud.directFeudEvent = feudItem.requirement;
                    newFeud.startMonth = game.monthCount;
                    newFeud.startYear = game.year;
                    feudPotentials.push({
                        "name": newFeud.name,
                        "participants": feudFactions.map((x)=>x.name)
                    });
                }
                // Check leave faction request
                for (const s of segmentConsequenceSuperstars){
                    let requestData = {
                        "factionId": factions[0].$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "leave_faction",
                        talent: s,
                        data: requestData
                    });
                }
            } else if (segmentItem.consequence === "create-faction") {
                // Get faction leader if selected
                let leaderSuperstar;
                if (segment.consequenceData["leaderUid"]) leaderSuperstar = segmentConsequenceSuperstars.find((y)=>y.$loki === segment.consequenceData["leaderUid"]);
                // Create new faction and add to roster
                const { reputation: reputation, xp: xp } = (0, $6PzHO.getFactionCreationReputationAndXp)(segmentConsequenceSuperstars);
                const newFaction = await (0, $6PzHO.createFaction)(segment.consequenceData["createdFactionName"], segmentConsequenceSuperstars, reputation, xp, leaderSuperstar);
                await (0, $dl5u4.addRosterFactions)(mainRoster, [
                    newFaction
                ]);
                // Add company log
                const newLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
                newLog.text = `${newFaction.name}`;
                newLog.type = "new-faction";
                newLog.realYear = game.year;
                await (0, $9esFv.addCompanyCompanyLogs)(company, [
                    newLog
                ]);
                factionSegmentConsequence["createdFactionMembers"] = segmentConsequenceSuperstars.map((x)=>x.name);
                factionSegmentConsequence["createdFactionName"] = segment.consequenceData["createdFactionName"];
                // Check start faction request
                for (const s of segmentConsequenceSuperstars)await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "start_faction",
                    talent: s
                });
            }
            if (factions.length > 0) factionSegmentConsequence["faction"] = factions[0].name;
            // Update graphics
            if (graphics && updateFactionGraphic) {
                if (segmentItem.consequence !== "leave-faction-and-join-other-faction") {
                    for (const x of segmentConsequenceSuperstars)if (!(0, $3E8Nt.objectInArray)(x, segmentManagers)) {
                        const superstarGraphic = (0, $5kTkA.getGraphicForSuperstar)(x);
                        graphics.push(superstarGraphic);
                    }
                }
                if (segmentItem.consequence === "merge-factions") for (const x of (await (0, $2JFAd.getFactionSuperstars)(factionToMerge))){
                    const superstarGraphic = (0, $5kTkA.getGraphicForSuperstar)(x);
                    graphics.push(superstarGraphic);
                }
                if (segmentItem.consequence === "leave-faction-and-join-other-faction") for (const x of (await (0, $2JFAd.getFactionSuperstars)(factionToJoin))){
                    const superstarGraphic = (0, $5kTkA.getGraphicForSuperstar)(x);
                    graphics.push(superstarGraphic);
                }
                data["graphics"] = graphics;
            }
        }
    }
    if ([
        "disband-faction",
        "remove-faction-leadership"
    ].includes(segmentItem.consequence)) {
        let teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participants[0]);
        if (teamSuperstars.length > 0) {
            let faction = (await (0, $hBIDz.getSuperstarFactions)(teamSuperstars[0])).find((x)=>!x.disbanded);
            if (faction) {
                if (segmentItem.consequence === "remove-faction-leadership") {
                    let leaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(faction);
                    if (leaderSuperstar) {
                        await (0, $6PzHO.removeFactionLeader)(faction, leaderSuperstar);
                        factionSegmentConsequence["removedFactionLeader"] = leaderSuperstar.name;
                    }
                } else if (segmentItem.consequence === "disband-faction") {
                    await (0, $6PzHO.disbandFaction)(faction, month, year);
                    factionSegmentConsequence["disbandedFaction"] = faction.name;
                }
                factionSegmentConsequence["faction"] = faction.name;
            }
        }
    }
    if ([
        "remove-manager",
        "remove-managed-talent"
    ].includes(segmentItem.consequence)) {
        let managedParticipant = participants[participants.length - 1];
        let managerParticipant = participants.find((x)=>x !== managedParticipant);
        if (managedParticipant && managerParticipant) {
            await (0, $5kTkA.removeSuperstarsFromManager)(managerParticipant, managedParticipant.tempSuperstars);
            managersRemoved.push({
                "managerName": managerParticipant.name,
                "removedSuperstarsNames": managedParticipant.tempSuperstars.map((x)=>x.name)
            });
        }
    }
    if (segmentItem.consequence === "add-manager") {
        let managedParticipant = participants[participants.length - 1];
        let managerParticipant = participants.find((x)=>x !== managedParticipant);
        if (managedParticipant && managerParticipant) {
            // Check if manager not present, not managing full time manager, check maximum superstars for manager
            let superstarsToManage = await (0, $5kTkA.getRosterMemberSuperstars)(managedParticipant);
            let addManagerCheck = true;
            for (let s of superstarsToManage){
                if (s.managerId) addManagerCheck = false;
                if (s.fullTimeManager) addManagerCheck = false;
            }
            let managedSuperstars = [
                ...await (0, $hBIDz.getSuperstarManagedSuperstars)(managerParticipant)
            ];
            if (superstarsToManage.length + managedSuperstars.length > 15) addManagerCheck = false;
            // Add superstars to manager if checks passed
            if (addManagerCheck) {
                await (0, $5kTkA.addSuperstarsToManager)(managerParticipant, superstarsToManage);
                managersAdded.push({
                    "managerName": managerParticipant.name,
                    "managedSuperstarsNames": superstarsToManage.map((x)=>x.name)
                });
                for (let superstarToManage of superstarsToManage){
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "be_managed",
                        talent: superstarToManage
                    });
                    let requestData = {
                        "talentId": superstarToManage.$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "manage_x",
                        talent: managerParticipant,
                        data: requestData
                    });
                }
            }
        }
    }
    if (segmentItem.consequence === "draft-talent-to-brand") {
        let brandUid = segment.consequenceData["brandUid"];
        let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
        let brand = rosterBrands.find((x)=>x.$loki === brandUid);
        if (brand && participants.length > 0) for (let s of participants[0].tempSuperstars){
            (0, $1Dp0h.draftSuperstarToBrand)(s, brand.name, companyChampionships);
            brandChanges.push({
                "name": s.name,
                "brandName": brand.name
            });
            let requestData = {
                "brandId": brand.$loki
            };
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "change_brand",
                talent: s,
                data: requestData
            });
        }
    }
    if (segmentItem.consequence === "disband-team") {
        // Get tag team
        let tagTeam;
        for (const t of (await (0, $hBIDz.getSuperstarTagTeams)(participants[0])))if (!t.temporary && (0, $3E8Nt.checkAreObjArraysEqual)(await (0, $972Ip.getTagTeamSuperstars)(t), participants)) tagTeam = t;
        if (tagTeam) {
            // Vacate championships
            const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
            const vacatedChampionships = await (0, $5kTkA.vacateChampionships)({
                superstar: tagTeamSuperstars[0],
                championships: companyChampionships,
                month: month,
                year: year,
                tagTeam: tagTeam
            });
            vacated.push(...vacatedChampionships);
            // Remove tag team
            await (0, $ko5kE.removeTagTeam)(tagTeam);
            disbanded.push(tagTeam.name);
            // Check talent request
            for (const superstar of tagTeamSuperstars){
                let requestData = {
                    "teamId": tagTeam.$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "disband_team",
                    talent: superstar,
                    data: requestData
                });
            }
        }
    }
    if (segmentItem.consequence === "unify-titles") {
        let participantChampionships = (await Promise.all(participants[0].tempSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
        if (participants[0].objectName === "superstar") participantChampionships = participantChampionships.filter((x)=>!x.trio && !x.tagTeam);
        else {
            if (participants[0].trio) participantChampionships = participantChampionships.filter((x)=>x.trio || x.tagTeam);
            else participantChampionships = participantChampionships.filter((x)=>x.tagTeam);
            participantChampionships = (0, $kZwpB.getUniqueChampionships)(participantChampionships);
        }
        if (participantChampionships.length > 1) {
            let championshipName = null;
            if (segment.consequenceData) championshipName = segment.consequenceData["objectName"];
            data["unifiedChampionships"] = await (0, $kZwpB.unifyChampionships)(participantChampionships, company, companyChampionships, game, championshipName);
        }
    }
    if (segmentItem.consequence === "remove-mask") for (const s of segmentSuperstars){
        // Remove mask graphic
        if (s.graphic) s.graphic = (0, $5kTkA.removeSuperstarGraphicMask)(s.graphic);
        maskRemoved.push({
            "name": s.name,
            "possessivePronoun": s.possessivePronoun
        });
        // Next gimmick boost chance
        const addedNextGimmickBoost = await (0, $5kTkA.addNextGimmickBoost)(s, 75);
        if (addedNextGimmickBoost && company.userControlled) {
            const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
            const newMessage = await (0, $hekDR.createGimmickChangeBoostMessage)(s, "Unmasking", month, year, talentManager);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        // Update graphics
        if (graphics) {
            graphics = (0, $3SyPM.updateMatchOrSegmentGraphics)(graphics, s);
            data["graphics"] = graphics;
        }
        // Check talent request
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "change_appearance",
            talent: s
        });
    }
    // Add feud potentials
    let requirementName = null;
    if (segmentItem.requirement === "face-team-superstars") requirementName = "backstab";
    else if (segmentItem.requirement === "face-vs-face" && segmentItem.consequence === "heel-turn") requirementName = "vicious-beatdown";
    else if (segmentItem.requirement === "face-vs-face-past-feud" && segmentItem.consequence === "heel-turn") requirementName = "delayed-vengeance";
    else if (segmentItem.requirement === "heel-team-superstars") requirementName = "defying-a-villain";
    else if (segmentItem.consequence === "remove-managed-talent" && singles) requirementName = "client-betrayal";
    else if (segmentItem.requirement === "retiring" && segmentItem.consequence === "heel-turn") requirementName = "retirement-fakeout";
    if (requirementName) {
        const feudItem = feudItems.find((x)=>x.unlocked && x.requirement === requirementName);
        // Check for existing feud
        let existingFeud;
        for (const y of participants)for (const f of (await (0, $cXLSF.getRosterMemberFeuds)(y))){
            if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
                if ((await (0, $jDtEn.getFeudParticipants)(f)).every((y)=>(0, $3E8Nt.objectInArray)(y, participants))) {
                    existingFeud = f;
                    break;
                }
            }
        }
        if (!existingFeud) {
            let feudParticipants = participants.slice(0, 2);
            const newFeud = (0, $jDtEn.Feud)();
            await (0, $14eBR.Feuds).insert(newFeud);
            newFeud.name = feudItem.name;
            newFeud.hype = feudItem.baseHype;
            const boosts = await (0, $cXLSF.getFeudCreationBoosts)(newFeud, feudParticipants, month, year, company.style);
            const addedHype = boosts["hypeBoost"];
            newFeud.hype += addedHype;
            let turnHype = 0;
            if (shockingTurn) {
                turnHype = Math.floor(monthsAfterTurn / 12 * 10);
                if (turnHype > 50) turnHype = 50;
                newFeud.hype += turnHype;
            }
            newFeud.participants = feudParticipants.map((s)=>s.name);
            newFeud.directFeudEvent = requirementName;
            newFeud.started = true;
            newFeud.startMonth = month;
            newFeud.startYear = year;
            await (0, $im36F.addFeudItemFeuds)(feudItem, [
                newFeud
            ]);
            await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                newFeud
            ]);
            await (0, $eg5dz.addSegmentFeuds)(segment, [
                newFeud
            ]);
            if (singles) await (0, $jDtEn.addFeudSuperstars)(newFeud, feudParticipants);
            else if (tag) await (0, $jDtEn.addFeudTagTeams)(newFeud, feudParticipants);
            feudsStarted.push({
                "name": newFeud.name,
                "participants": feudParticipants.map((x)=>x.name),
                "boosts": boosts,
                "baseHype": feudItem.baseHype,
                "shocking": shockingTurn,
                "turnHype": turnHype
            });
            // Check talent request
            for (const feudParticipant of feudParticipants){
                const otherFeudParticipant = feudParticipants.find((x)=>x.$loki !== feudParticipant.$loki);
                if (otherFeudParticipant) {
                    let requestData = {
                        "talentId": otherFeudParticipant.$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "feud_with_x",
                        talent: feudParticipant,
                        data: requestData
                    });
                }
            }
        } else {
            const hypeIncrease = feudItem.baseHype;
            existingFeud.hype += hypeIncrease;
            feudHypeIncreased.push({
                "name": existingFeud.name,
                "participants": participants.map((x)=>x.name),
                "hypeIncrease": hypeIncrease,
                "newFeud": feudItem.name
            });
        }
    }
    // Add next gimmick boost for shocking turn
    if (shockingTurn && applyConsequenceTo) for (const s of applyConsequenceTo.tempSuperstars){
        const addedNextGimmickBoost = await (0, $5kTkA.addNextGimmickBoost)(s, 100);
        if (addedNextGimmickBoost && company.userControlled) {
            const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
            const newMessage = await (0, $hekDR.createGimmickChangeBoostMessage)(s, "Shocking Turn", month, year, talentManager);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
    }
    data["vacated"] = vacated;
    data["fired"] = fired;
    data["feudsEnded"] = feudsEnded;
    data["awarded"] = awarded;
    data["feudItemsLevelData"] = feudItemsLevelData;
    data["unlockedFeudItems"] = unlockedFeudItems;
    data["turnedHeel"] = turnedHeel;
    data["turnedFace"] = turnedFace;
    data["turnedNeutral"] = turnedNeutral;
    data["feudsStarted"] = feudsStarted;
    data["feudPotentials"] = feudPotentials;
    data["feudHypeIncreased"] = feudHypeIncreased;
    data["disbanded"] = disbanded;
    data["shockingTurn"] = shockingTurn;
    data["turnTooSoon"] = turnTooSoon;
    data["consequenceRunOn"] = consequenceRunOn;
    data["createdChampionships"] = createdChampionships;
    data["unavailable"] = unavailable;
    data["suspended"] = suspended;
    data["retirements"] = retirements;
    data["teamsCreated"] = teamsCreated;
    data["factionSegmentConsequence"] = factionSegmentConsequence;
    data["factionReputationsData"] = factionReputationsData;
    data["managersAdded"] = managersAdded;
    data["managersRemoved"] = managersRemoved;
    data["brandChanges"] = brandChanges;
    data["maskRemoved"] = maskRemoved;
    return data;
}
function $336089d6be28ba1c$var$getSegmentEventHypeBoost(rating, hypeBoost) {
    const baseHypes = {
        1: 2,
        2: 4,
        3: 6
    };
    let hypeChange = baseHypes[hypeBoost] || 0;
    let ratingMultiplier = (rating - 3) * 0.5;
    if (rating >= 4.5) ratingMultiplier += 0.25;
    else if (rating < 2) ratingMultiplier -= 0.75;
    hypeChange += Math.round(hypeChange * ratingMultiplier);
    return hypeChange;
}
function $336089d6be28ba1c$var$getMainEventHypeBoost(rating, hypeBoost) {
    const baseHypes = {
        1: 4,
        2: 8,
        3: 12
    };
    let hypeChange = baseHypes[hypeBoost] || 0;
    let ratingMultiplier = (rating - 3) * 0.5;
    if (rating >= 4.5) ratingMultiplier += 0.25;
    else if (rating < 2) ratingMultiplier -= 0.75;
    hypeChange += Math.round(hypeChange * ratingMultiplier);
    return hypeChange;
}
function $336089d6be28ba1c$var$getSegmentPopularityBoost(rating, popularityBoost) {
    const baseHypes = {
        1: 3,
        2: 6,
        3: 10
    };
    let hypeChange = baseHypes[popularityBoost] || 0;
    let ratingMultiplier = (rating - 3) * 0.5;
    if (rating >= 4.5) ratingMultiplier += 0.25;
    else if (rating < 2) ratingMultiplier -= 0.75;
    hypeChange += Math.round(hypeChange * ratingMultiplier);
    return hypeChange;
}
function $336089d6be28ba1c$export$ae201c4048d23331(producer, allSegmentItems) {
    // Check for segment item unlocks, unlocking them
    const unlocksDict = {
        2: [
            "Debut Package",
            "Return Package",
            "Champion Package"
        ],
        3: [
            "Career Package",
            "Day in the Life"
        ]
    };
    for (const [level, items] of Object.entries(unlocksDict)){
        if (producer.level >= level) for (const itemName of items){
            const itemToUnlock = allSegmentItems.find((x)=>x.name === itemName);
            if (itemToUnlock && !itemToUnlock.unlocked) itemToUnlock.unlocked = true;
        }
    }
    return true;
}
async function $336089d6be28ba1c$export$7006eaf6af085e61() {
    let data = {};
    let currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const user = (0, $bZol7.loadUser)();
    if (!currentGame.settings["unlock_all_items"]) {
        if (currentGame.monthCount === 4 && currentGame.year === 0 && userCompany.storyName !== "mars") data["specialSegmentIntroduced"] = await $336089d6be28ba1c$export$1c0ab3fd8489739d(userCompany, currentGame, user);
    }
    // Get data to return
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(userCompany);
    data["unreadMessages"] = unreadMessages.length;
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $336089d6be28ba1c$export$1c0ab3fd8489739d(company, game, user) {
    let stuntDive = (await (0, $9esFv.getCompanySegmentItems)(company)).find((x)=>x.special === true && x.name === "Stunt Dive");
    if (stuntDive && !stuntDive.unlocked && (0, $98xmD.globalUser).paid) {
        // Unlock stunt dive
        await (0, $3SyPM.unlockSpecialSegment)(company, stuntDive.name, game.monthCount, game.year, false);
        // Unlock user segments, if any
        let userSegmentsToUnlock = (await (0, $9esFv.getCompanySegmentItems)(company)).filter((x)=>user.unlockedSegments.includes(x.name) && x.$loki !== stuntDive.$loki);
        for (let segmentToUnlock of userSegmentsToUnlock)segmentToUnlock.unlocked = true;
        // Add introduce special segments message
        if (company.userControlled) {
            let newMessage = await (0, $hekDR.createIntroduceSpecialSegmentsMessage)(stuntDive, company, userSegmentsToUnlock.length);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        return true;
    }
    return false;
}

});
parcelRequire.register("cMrnz", function(module, exports) {

$parcel$export(module.exports, "SegmentItem", () => $94df34b048a21b7d$export$5ac23689c0c6f04f);
$parcel$export(module.exports, "getSegmentItemSegments", () => $94df34b048a21b7d$export$3882678d5316f600);
$parcel$export(module.exports, "addSegmentItemSegments", () => $94df34b048a21b7d$export$d0927bd95bc6a8b4);
$parcel$export(module.exports, "getSegmentItemCompany", () => $94df34b048a21b7d$export$ac2a8575f8e2ee11);

var $14eBR = parcelRequire("14eBR");
function $94df34b048a21b7d$export$5ac23689c0c6f04f() {
    // String
    const name = null;
    const description = null;
    const consequence = null;
    const requirement = null;
    // Integer
    const level = 1;
    const xp = 0;
    const minParticipants = 2;
    const maxParticipants = 2;
    const monthsToReuse = 36; // To check if special segment item is available to use again
    const hypeBoost = 1;
    const popularityBoost = 0;
    const difficulty = 1;
    const entertainment = 1;
    const action = 1;
    // Boolean
    const unlocked = true;
    const standard = false;
    const silly = false;
    const oneAtATime = true;
    const chooseWinner = true;
    const feudOnly = false;
    const oneWayConsequence = false;
    const productionSegment = false;
    const custom = false;
    const temporary = false;
    const saveToCommunity = false;
    const special = false;
    const used = false; // To check if special segment item as been used
    const factionSegment = false;
    // Foreign keys
    const companyId = null;
    // Objects
    const text = {};
    // Arrays
    const startTexts = [];
    const actionTexts = [];
    return {
        name: name,
        description: description,
        consequence: consequence,
        requirement: requirement,
        level: level,
        xp: xp,
        minParticipants: minParticipants,
        maxParticipants: maxParticipants,
        monthsToReuse: monthsToReuse,
        hypeBoost: hypeBoost,
        popularityBoost: popularityBoost,
        difficulty: difficulty,
        entertainment: entertainment,
        action: action,
        unlocked: unlocked,
        standard: standard,
        silly: silly,
        oneAtATime: oneAtATime,
        chooseWinner: chooseWinner,
        feudOnly: feudOnly,
        oneWayConsequence: oneWayConsequence,
        productionSegment: productionSegment,
        custom: custom,
        temporary: temporary,
        saveToCommunity: saveToCommunity,
        special: special,
        used: used,
        factionSegment: factionSegment,
        companyId: companyId,
        text: text,
        startTexts: startTexts,
        actionTexts: actionTexts
    };
}
function $94df34b048a21b7d$export$3882678d5316f600(segmentItem) {
    return (0, $14eBR.Segments).find({
        "segmentItemId": segmentItem.$loki
    });
}
function $94df34b048a21b7d$export$d0927bd95bc6a8b4(segmentItem, segments) {
    segments.forEach((c)=>{
        c.segmentItemId = segmentItem.$loki;
    });
}
function $94df34b048a21b7d$export$9baecea25e377734(segmentItem, segments) {
    segments.forEach((c)=>{
        c.segmentItemId = null;
    });
}
function $94df34b048a21b7d$export$ac2a8575f8e2ee11(segmentItem) {
    return (0, $14eBR.Companies).find({
        "$loki": segmentItem.companyId
    })[0];
}

});

parcelRequire.register("iRMwH", function(module, exports) {

$parcel$export(module.exports, "createGameFromScenarioData", () => $dbc2d18ee95b9d27$export$edc6dec1cbd9b270);
$parcel$export(module.exports, "createGameInDatabase", () => $dbc2d18ee95b9d27$export$3f925be9d00b40bf);
$parcel$export(module.exports, "deleteGameRequest", () => $dbc2d18ee95b9d27$export$1b15dc79c1430152);
$parcel$export(module.exports, "getUserGames", () => $dbc2d18ee95b9d27$export$e5245eae479fa0a);
$parcel$export(module.exports, "getGameSaveData", () => $dbc2d18ee95b9d27$export$8e8e164d89554a8d);
$parcel$export(module.exports, "getGameCurrentUserCompany", () => $dbc2d18ee95b9d27$export$8a53f38bace97ef6);
$parcel$export(module.exports, "getGameMainUserCompany", () => $dbc2d18ee95b9d27$export$ad29dd9dcc3f674d);
$parcel$export(module.exports, "getGameActiveCompanies", () => $dbc2d18ee95b9d27$export$ab76722cedbd9375);
$parcel$export(module.exports, "getHomePageData", () => $dbc2d18ee95b9d27$export$e1a2fad8b5ce4e7e);
$parcel$export(module.exports, "saveGameDataToLocalStorage", () => $dbc2d18ee95b9d27$export$e052c844ba0621d4);
$parcel$export(module.exports, "markGameAsPlaying", () => $dbc2d18ee95b9d27$export$4855fe878311d2a5);
$parcel$export(module.exports, "getOptionsData", () => $dbc2d18ee95b9d27$export$4ae8a26083d03e92);
$parcel$export(module.exports, "changeNumberOfWeeklyShows", () => $dbc2d18ee95b9d27$export$2922acf9d11e6a45);
$parcel$export(module.exports, "getUserControlledCompanies", () => $dbc2d18ee95b9d27$export$16575f22c425a52a);
$parcel$export(module.exports, "changeUserSetting", () => $dbc2d18ee95b9d27$export$8cd29ced70f92e2);
$parcel$export(module.exports, "changeUserMatchResultSetting", () => $dbc2d18ee95b9d27$export$8ef63851d5addd8d);
$parcel$export(module.exports, "changeGameSetting", () => $dbc2d18ee95b9d27$export$756a040b6d411621);
$parcel$export(module.exports, "getUserInfo", () => $dbc2d18ee95b9d27$export$801fe16824f675f7);
$parcel$export(module.exports, "removePaidFeatures", () => $dbc2d18ee95b9d27$export$60c5f108ca6199dd);
$parcel$export(module.exports, "addPaidFeatures", () => $dbc2d18ee95b9d27$export$ac914e869fda317f);

var $14eBR = parcelRequire("14eBR");

var $eSlDe = parcelRequire("eSlDe");

var $hBIDz = parcelRequire("hBIDz");

var $972Ip = parcelRequire("972Ip");

var $iQtzn = parcelRequire("iQtzn");

var $ivuOU = parcelRequire("ivuOU");

var $dBFC4 = parcelRequire("dBFC4");

var $dl5u4 = parcelRequire("dl5u4");

var $9esFv = parcelRequire("9esFv");

var $i7bmn = parcelRequire("i7bmn");

var $8LLPX = parcelRequire("8LLPX");

var $3E8Nt = parcelRequire("3E8Nt");

var $5kTkA = parcelRequire("5kTkA");

var $8A6FL = parcelRequire("8A6FL");

var $5ZsVo = parcelRequire("5ZsVo");

var $98xmD = parcelRequire("98xmD");

var $fPpxU = parcelRequire("fPpxU");

var $2JFAd = parcelRequire("2JFAd");

var $5DBvS = parcelRequire("5DBvS");

var $5JRw3 = parcelRequire("5JRw3");

var $9MKdC = parcelRequire("9MKdC");

var $4K85d = parcelRequire("4K85d");

var $6dDCX = parcelRequire("6dDCX");

var $dfpYx = parcelRequire("dfpYx");

var $fQoFZ = parcelRequire("fQoFZ");

var $eg5dz = parcelRequire("eg5dz");

var $1AAHK = parcelRequire("1AAHK");

var $lhVvD = parcelRequire("lhVvD");

var $jDtEn = parcelRequire("jDtEn");

var $5NNI6 = parcelRequire("5NNI6");

var $ct4m6 = parcelRequire("ct4m6");

var $cYLJ6 = parcelRequire("cYLJ6");

var $iWkAo = parcelRequire("iWkAo");

var $9tPJr = parcelRequire("9tPJr");

var $csISS = parcelRequire("csISS");

var $iY7cj = parcelRequire("iY7cj");

var $cpTRW = parcelRequire("cpTRW");

var $4EGpv = parcelRequire("4EGpv");

var $im36F = parcelRequire("im36F");

var $cMrnz = parcelRequire("cMrnz");

var $1owiX = parcelRequire("1owiX");

var $7UN4J = parcelRequire("7UN4J");

var $gImaj = parcelRequire("gImaj");

var $3ZjYr = parcelRequire("3ZjYr");

var $i6OYC = parcelRequire("i6OYC");

var $3NAMH = parcelRequire("3NAMH");

var $1olyO = parcelRequire("1olyO");

var $knp8C = parcelRequire("knp8C");

var $lueZ1 = parcelRequire("lueZ1");

var $18vSN = parcelRequire("18vSN");

var $66ItE = parcelRequire("66ItE");

var $jpMCP = parcelRequire("jpMCP");

var $kZwpB = parcelRequire("kZwpB");

var $5qFpQ = parcelRequire("5qFpQ");

var $5esHg = parcelRequire("5esHg");

var $l4Fms = parcelRequire("l4Fms");

var $gFyK0 = parcelRequire("gFyK0");

var $8bQDO = parcelRequire("8bQDO");

var $hekDR = parcelRequire("hekDR");

var $5yA6U = parcelRequire("5yA6U");

var $7Hx0P = parcelRequire("7Hx0P");

var $bZol7 = parcelRequire("bZol7");

var $2A9WA = parcelRequire("2A9WA");

var $aynj3 = parcelRequire("aynj3");

var $jC7EP = parcelRequire("jC7EP");

var $1Dp0h = parcelRequire("1Dp0h");
async function $dbc2d18ee95b9d27$export$9c1a45fa87f90634(gameData, newGameSettings = null) {
    // Duplicates game and saves to database. Used in import web game,
    // download web scenario (createScenarioFromScenarioData), create game from scenario.
    // newGameSettings parameter sets properties for new game (last played, randomness etc)
    const gameDetails = gameData["gameDetails"];
    const game = {
        ...(0, $dBFC4.Game)(),
        ...gameDetails
    };
    const user = (0, $bZol7.loadUser)();
    game.userUid = user?.uid;
    if (newGameSettings) {
        let mainCompanyDetails = gameData.companies[0].companyDetails;
        game.datetimeLastPlayed = Date.now();
        game.numberOfWeeklyShows = mainCompanyDetails.storyName === "mars" ? 0 : newGameSettings["numberOfWeeklyShows"];
    }
    await (0, $14eBR.Games).insert(game);
    let allBrandNames = [];
    let draftAvailableSuperstars = [];
    let draftAvailableTagTeams = [];
    let gameDataCompetitors = gameData["companies"].slice(1);
    // Get starting event index, remove extra event from main company
    let startingEventIndex;
    if (newGameSettings) {
        startingEventIndex = gameData.companies[0].events.slice(0, 12).map((x)=>x.name).indexOf(gameData.companies[0].events[gameData.companies[0].events.length - 1].name);
        if (startingEventIndex === -1) startingEventIndex = 0 // in case starting event not set in editor
        ;
        gameData.companies[0].events = gameData.companies[0].events.slice(0, 12);
    }
    if (newGameSettings) {
        // Set sandbox mode settings
        if (newGameSettings["gameModeOption"] === "sandbox") {
            game.settings["sandbox_mode_enabled"] = true;
            // User specified settings
            const sandboxSettings = [
                "unlimited_creative_points",
                "maximum_roster_capacity",
                "all_indies_available",
                "unlock_all_items",
                "maximum_staff_and_facilities",
                "no_special_items_cooldown",
                "no_injuries",
                "no_unhappiness",
                "no_talent_requests",
                "no_random_events",
                "no_retirements",
                "no_going_part_time"
            ];
            let sandboxModeOptions = newGameSettings["sandboxModeOptions"];
            for (const sandboxSetting of sandboxSettings)game.settings[sandboxSetting] = !!(sandboxModeOptions && sandboxModeOptions.includes(sandboxSetting));
        }
        // Get starting company
        let startingCompany;
        if (newGameSettings["playerModeOption"] === "local-multiplayer") // If local multiplayer mode, set first user company as starting company
        startingCompany = gameData["companies"].find((x)=>x.companyDetails.name === newGameSettings["selectedUserCompanies"][0]);
        else if (newGameSettings["customStartingCompanyData"]) {
            // Create custom company data
            let customStartingCompanyData = newGameSettings["customStartingCompanyData"];
            let companyDetails = {};
            const customCompanyFinances = {
                "weak": 150,
                "average": 500,
                "strong": 2000,
                "loaded": 10000
            };
            const customCompanySize = {
                "backyard": 1,
                "indie": 4,
                "national": 7,
                "global": 10
            };
            companyDetails.name = customStartingCompanyData.companyName;
            companyDetails.ownerName = customStartingCompanyData.ownerName;
            companyDetails.weeklyShowName = customStartingCompanyData.weeklyShowName;
            companyDetails.style = customStartingCompanyData.companyStyle;
            companyDetails.points = customCompanyFinances[customStartingCompanyData.companyFinances];
            companyDetails.reputation = customCompanySize[customStartingCompanyData.companySize];
            companyDetails.fans = (0, $3E8Nt.fanLevels)[companyDetails.reputation - 1];
            // Add rosters data
            let rostersData = [];
            for (let type of [
                "main",
                "training",
                "trainingAvailable",
                "trainingFuture"
            ]){
                let rosterData = {
                    "type": type,
                    "superstars": [],
                    "tagTeams": [],
                    "factions": [],
                    "brands": []
                };
                rostersData.push(rosterData);
            }
            // Add generated main roster superstars data
            if (customStartingCompanyData["talentOption"] === "generate") {
                let rosterCapacity = (0, $8A6FL.getCompanyRosterCapacity)(companyDetails, game);
                let rosterSuperstars = [];
                for(let y = 0; y < Math.floor(rosterCapacity * (0, $3E8Nt.getRandomUniform)(0.65, 0.85)); y++){
                    let newSuperstar = await (0, $8bQDO.generateSuperstar)({
                        indie: true,
                        insert: false,
                        generateGimmick: false
                    });
                    rosterSuperstars.push(newSuperstar);
                }
                let mainRoster = rostersData.find((x)=>x.type === "main");
                mainRoster.superstars = JSON.parse(JSON.stringify(rosterSuperstars));
            }
            // Add generated training roster superstars data
            if (customStartingCompanyData["trainingRosterOption"] === "generate") {
                let trainingRosterSuperstars = [];
                for (let y of Array((0, $3E8Nt.getRandomInt)(10, 15)).keys()){
                    let newSuperstar = await (0, $8bQDO.generateSuperstar)({
                        insert: false,
                        generateGimmick: false
                    });
                    trainingRosterSuperstars.push(newSuperstar);
                }
                let trainingRoster = rostersData.find((x)=>x.type === "training");
                trainingRoster.superstars = JSON.parse(JSON.stringify(trainingRosterSuperstars));
            }
            // Add championships data
            let divisionChampionshipsData = {
                "singles": 1,
                "tag-team": 2,
                "trio": 3
            };
            let prestigeXps = {
                "A": 300,
                "B": 100,
                "C": 0
            };
            let championshipsData = [];
            for (let [i, y] of customStartingCompanyData["companyChampionshipsData"].entries()){
                let divisionChampionships = divisionChampionshipsData[y["division"]] || 1;
                // Get graphic if present
                let graphic = null;
                if (y["graphic"]) graphic = JSON.parse(y["graphic"]);
                // Get rank
                let rankName;
                if (i === 0) rankName = "Main Eventer";
                else rankName = "Upper Midcarder";
                // Create championships and add to roster
                for (let z of Array(divisionChampionships).keys()){
                    let championshipData = {};
                    championshipData.name = y["name"];
                    championshipData.rank = rankName;
                    championshipData.vacated = true;
                    if (graphic) championshipData.graphic = graphic;
                    if (y["division"] === "tag-team") championshipData.tagTeam = true;
                    else if (y["division"] === "trio") championshipData.trio = true;
                    championshipData.prestige = y["prestige"];
                    championshipData.highestPrestige = y["prestige"];
                    championshipData.xp = prestigeXps[y["prestige"]] || 0;
                    championshipsData.push(championshipData);
                }
            }
            // Add events data
            let eventsData = [];
            for (let y of customStartingCompanyData["companyMonthlyEventsData"]){
                let eventData = {
                    "name": y["name"],
                    "prestige": y["prestige"],
                    "xp": (0, $3E8Nt.eventPrestigeXps)[y["prestige"]] || 0,
                    "matchContracts": [],
                    "streaks": []
                };
                eventsData.push(eventData);
            }
            // Add gimmick matches data
            let gimmickMatchesData = JSON.parse(JSON.stringify((0, $7Hx0P.standardGimmickMatchesData)));
            // Add custom company data to gameCompanies, set as starting company
            startingCompany = {
                "companyDetails": companyDetails,
                "championships": championshipsData,
                "events": eventsData,
                "gimmickMatches": gimmickMatchesData,
                "rosters": rostersData
            };
            gameData["companies"].push(startingCompany);
        } else if (newGameSettings["startingCompanyName"]) startingCompany = gameData["companies"].find((x)=>x.companyDetails.name === newGameSettings["startingCompanyName"]);
        // Process starting company if different from first company
        if (startingCompany && startingCompany !== gameData["companies"][0]) {
            // Move indie rosters to new starting company
            let firstCompany = gameData["companies"][0];
            let indieRosters = firstCompany.rosters.filter((x)=>[
                    "indie",
                    "indieAvailable",
                    "indieFuture"
                ].includes(x.type));
            firstCompany.rosters = firstCompany.rosters.filter((x)=>!indieRosters.includes(x));
            startingCompany.rosters.push(...indieRosters);
            startingCompany.companyDetails.realYear = firstCompany.companyDetails.realYear;
            // Move starting company to start of companies
            gameData["companies"].sort(function(a, b) {
                return a.companyDetails.name === startingCompany.companyDetails.name ? -1 : b.companyDetails.name === startingCompany.companyDetails.name ? 1 : 0;
            });
        }
        // Get competitors
        gameDataCompetitors = gameData["companies"].slice(1);
        let originalCompetitors = [
            ...gameDataCompetitors
        ];
        if (newGameSettings["playerModeOption"] === "local-multiplayer") // Filter competitors if local multiplayer
        gameDataCompetitors = gameDataCompetitors.filter((x)=>newGameSettings["selectedUserCompanies"].concat(newGameSettings["selectedCPUCompanies"]).includes(x.companyDetails.name));
        else if (newGameSettings["selectedCompetitorsNames"] && !newGameSettings["editOption"]) // Filter competitors based on selections
        gameDataCompetitors = gameDataCompetitors.filter((x)=>newGameSettings["selectedCompetitorsNames"].includes(x.companyDetails.name));
        else {
            if (newGameSettings["competitorsOption"] === "generate") gameDataCompetitors = [];
            else if (newGameSettings["competitorsOption"] === "none") gameDataCompetitors = [];
        }
        gameDataCompetitors = gameDataCompetitors.slice(0, (0, $3E8Nt.gameLimits).maxCompetitors);
        // Set competitorsPresent
        game.competitorsPresent = gameDataCompetitors.length > 0 || newGameSettings["competitorsOption"] === "generate";
        // Send unselected competitors' superstars to indie roster
        let unselectedCompetitors = originalCompetitors.filter((x)=>!gameDataCompetitors.includes(x));
        if (unselectedCompetitors.length && newGameSettings["competitorsOption"] !== "generate" && (0, $98xmD.globalUser).paid) {
            let indieRoster = gameData["companies"][0].rosters.find((x)=>x.type === "indie");
            let indieFutureRoster = gameData["companies"][0].rosters.find((x)=>x.type === "indieFuture");
            for (let unselectedCompetitor of unselectedCompetitors){
                let currentRosters = unselectedCompetitor.rosters.filter((x)=>[
                        "main",
                        "training"
                    ].includes(x.type));
                for (let currentRoster of currentRosters){
                    indieRoster.superstars.push(...currentRoster.superstars);
                    indieRoster.tagTeams.push(...currentRoster.tagTeams);
                }
                let futureRoster = unselectedCompetitor.rosters.find((x)=>x.type === "trainingFuture");
                if (futureRoster && indieFutureRoster) {
                    indieFutureRoster.superstars.push(...futureRoster.superstars);
                    indieFutureRoster.tagTeams.push(...futureRoster.tagTeams);
                }
            }
        }
    }
    // Create companies with rosters (to add superstars and tag teams first for matches and other relationships)
    let gameCompanies = [];
    let gameDataCompanies = [
        gameData["companies"][0],
        ...gameDataCompetitors
    ];
    for(let i = 0; i < gameDataCompanies.length; i++){
        const companyData = gameDataCompanies[i];
        const company = await $dbc2d18ee95b9d27$var$createGameCompanyWithRosters(companyData, newGameSettings, allBrandNames, draftAvailableSuperstars, draftAvailableTagTeams);
        gameCompanies.push(company);
    }
    await (0, $dBFC4.addGameCompanies)(game, gameCompanies);
    let mainUserCompany = gameCompanies[0];
    mainUserCompany.userControlled = true;
    // Set current company
    if (game["currentCompanyUid"]) {
        const gameCurrentCompany = gameCompanies.find((x)=>{
            return x.uid === game.currentCompanyUid;
        });
        if (gameCurrentCompany) await (0, $dBFC4.setGameCurrentCompany)(game, gameCurrentCompany);
        delete game.currentCompanyUid;
    }
    // Get all superstars and teams
    let [allRosters, allFactions, allFeuds, allBrands] = await $dbc2d18ee95b9d27$var$getRosterObjects(gameCompanies);
    // Add original superstars relationship
    if (!newGameSettings) {
        for (const roster of allRosters)if (roster["originalSuperstarsUids"].length > 0) {
            const rosterOriginalSuperstars = (0, $14eBR.Superstars).find({
                "uid": {
                    "$in": roster["originalSuperstarsUids"]
                }
            });
            if (rosterOriginalSuperstars.length > 0) await (0, $dl5u4.addRosterOriginalSuperstars)(roster, rosterOriginalSuperstars);
            if (roster["originalSuperstarsUids"].length !== rosterOriginalSuperstars.length) console.log("original superstars not found when creating roster", roster, roster.originalSuperstarsUids);
        }
    }
    // Add managers
    if ((!newGameSettings || newGameSettings["mainRostersOption"] !== "draft") && (0, $98xmD.globalUser).paid) {
        for (const rosterSuperstar of (0, $14eBR.Superstars).find({}))if (rosterSuperstar["managerUid"] && !rosterSuperstar.monthToAppearIn) {
            const superstarManager = (0, $14eBR.Superstars).findOne({
                "uid": rosterSuperstar.managerUid
            });
            if (superstarManager && !superstarManager.monthToAppearIn) await (0, $hBIDz.setSuperstarManager)(rosterSuperstar, superstarManager);
            delete rosterSuperstar.managerUid;
        }
    }
    // Add tag team superstars
    for (const tagTeam of (0, $14eBR.TagTeams).find({})){
        const tagTeamSuperstars = (0, $14eBR.Superstars).find({
            "uid": {
                "$in": tagTeam["superstarUids"]
            }
        }).filter((x)=>!x.monthToAppearIn);
        if (tagTeamSuperstars.length) (0, $972Ip.addTagTeamSuperstars)(tagTeam, tagTeamSuperstars);
        if (tagTeam["superstarUids"].length !== tagTeamSuperstars.length) {
            console.log("superstars not found when creating tagTeam", tagTeam, tagTeam.superstarUids);
            if (!tagTeamSuperstars.length) (0, $14eBR.TagTeams).remove(tagTeam);
        }
        delete tagTeam.superstarUids;
    }
    // Add faction superstars
    for (const faction of (0, $14eBR.Factions).find({})){
        const factionSuperstars = (0, $14eBR.Superstars).find({
            "uid": {
                "$in": faction["superstarUids"]
            }
        }).filter((x)=>!x.monthToAppearIn);
        if (factionSuperstars.length) {
            await (0, $2JFAd.addFactionSuperstars)(faction, factionSuperstars);
            // Add leader superstar
            if (faction.leaderSuperstarUid) {
                const leaderSuperstar = factionSuperstars.find((x)=>{
                    return x.uid === faction.leaderSuperstarUid;
                });
                if (leaderSuperstar) (0, $2JFAd.setFactionLeaderSuperstar)(faction, leaderSuperstar);
                else console.log("leader not found when creating game", faction);
                delete faction.leaderSuperstarUid;
            }
        }
        if (faction["superstarUids"].length !== factionSuperstars.length) {
            console.log("superstars not found when creating faction", faction, faction.superstarUids);
            if (!factionSuperstars.length) (0, $14eBR.Factions).remove(faction);
        }
        delete faction.superstarUids;
    }
    // Add brand uids to company settings
    for (const company of gameCompanies){
        if (company.settings["yearly_brand_draft_settings"] && Object.keys(company.settings["yearly_brand_draft_settings"]).length !== 0) for (const [i, brandUid] of company.settings["yearly_brand_draft_settings"]["brandUids"].entries()){
            let draftBrand = allBrands.find((x)=>{
                return x.uid === brandUid;
            });
            if (draftBrand) company.settings["yearly_brand_draft_settings"]["brandUids"][i] = draftBrand.$loki;
            else company.settings["yearly_brand_draft_settings"]["brandUids"].splice(i, 1);
        }
    }
    // Create events and championships
    let allSegments = [];
    let allMatches = [];
    let allChampionships = [];
    for(let i = 0; i < gameDataCompanies.length; i++){
        const companyData = gameDataCompanies[i];
        const company = gameCompanies[i];
        let otherObjects = await $dbc2d18ee95b9d27$var$createGameCompanyOtherObjects(company, companyData, allFactions, allFeuds, allBrands, allRosters, startingEventIndex, newGameSettings, game, gameData["favoritedCommunitySegments"], mainUserCompany.storyName);
        allSegments.push(...otherObjects[0]);
        allMatches.push(...otherObjects[1]);
        allChampionships.push(...otherObjects[2]);
    }
    // Add feud participants
    for (const feud of (0, $14eBR.Feuds).find({})){
        let feudParticipants = [];
        if (feud["type"] === "singles") {
            feudParticipants = (0, $14eBR.Superstars).find({
                "uid": {
                    "$in": feud.participantUids
                }
            });
            await (0, $jDtEn.addFeudSuperstars)(feud, feudParticipants);
        } else if (feud["type"] === "faction") {
            feudParticipants = (0, $14eBR.Factions).find({
                "uid": {
                    "$in": feud.participantUids
                }
            });
            await (0, $jDtEn.addFeudFactions)(feud, feudParticipants);
        } else {
            feudParticipants = (0, $14eBR.TagTeams).find({
                "uid": {
                    "$in": feud.participantUids
                }
            });
            await (0, $jDtEn.addFeudTagTeams)(feud, feudParticipants);
        }
        if (feudParticipants.length !== feud.participantUids.length) console.log("feud participants not found when creating feud", feud.participants, feud.participantUids);
        delete feud.participantUids;
    }
    if (newGameSettings) {
        // Generate competitors
        if (newGameSettings["competitorsOption"] === "generate") {
            // Get starting event index
            const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(mainUserCompany);
            const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(mainUserCompany);
            const startingEventIndex = parentEvents.map((x)=>x.name).indexOf(nextEvent.name);
            let existingCompanyNames = gameCompanies.map((x)=>x.name);
            for (let x of Array((0, $3E8Nt.getRandomInt)(2, 5)).keys()){
                const newCompetitor = await (0, $8bQDO.generateCompany)({
                    startingEventIndex: startingEventIndex,
                    existingCompanyNames: existingCompanyNames,
                    uncommonNames: true,
                    mainRostersOption: newGameSettings["mainRostersOption"],
                    month: game.monthCount,
                    year: game.year,
                    realYear: mainUserCompany.realYear,
                    game: game
                });
                newCompetitor.overness = (0, $3E8Nt.getRandomInt)(25, 75);
                gameCompanies.push(newCompetitor);
                await (0, $dBFC4.addGameCompanies)(game, [
                    newCompetitor
                ]);
                existingCompanyNames.push(newCompetitor.name);
                if (newGameSettings["mainRostersOption"] === "draft") {
                    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(newCompetitor, "main");
                    draftAvailableSuperstars.push(...await (0, $dl5u4.getRosterSuperstars)(mainRoster));
                    draftAvailableTagTeams.push(...await (0, $dl5u4.getRosterTagTeams)(mainRoster));
                }
            }
        }
        // Set market size
        if (mainUserCompany.storyName !== "mars" && game.competitorsPresent && ((0, $98xmD.globalUser).paid || mainUserCompany.storyName === "tutorial")) {
            if (game.marketSize === null) game.marketSize = 4000000; // Default market size
        } else game.marketSize = null;
        // Divide market between competitors, depending on number of fans
        if (game.marketSize) {
            // Add fans/xp based on market size
            const reputationXpLevels = {
                1: 0,
                2: 10,
                3: 30,
                4: 60,
                5: 100,
                6: 150,
                7: 210,
                8: 280,
                9: 360,
                10: 450,
                11: 550
            };
            let totalFans = gameCompanies.reduce((n, { fans: fans })=>n + fans, 0);
            for (const company of gameCompanies){
                company.fans = company.fans / totalFans * game.marketSize;
                company.fans = (0, $3E8Nt.myround)(company.fans, 1000);
                if (company.fans < 20000) company.fans = 20000;
                company.xp = reputationXpLevels[company.reputation];
                // Add 10% xp to next reputation so it doesn't drop right after starting game
                company.xp += (reputationXpLevels[company.reputation + 1] - company.xp) / 10.0;
            }
        }
        // Move some superstars to training / indie available rosters
        for (const gameCompany of gameCompanies){
            let trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(gameCompany, "training");
            let trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(gameCompany, "trainingAvailable");
            for (let i of Array(2).keys()){
                const talentToTransfer = (0, $3E8Nt.getRandomChoice)(await (0, $dl5u4.getRosterSuperstars)(trainingRoster));
                if (talentToTransfer) await (0, $jpMCP.transferTalentToRoster)(talentToTransfer, trainingAvailableRoster);
            }
        }
        let indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainUserCompany, "indie");
        let indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainUserCompany, "indieAvailable");
        if (newGameSettings["mainRostersOption"] !== "draft" && !newGameSettings["all_indies_available"] && (!newGameSettings["customStartingCompanyData"] || newGameSettings["customStartingCompanyData"]["talentOption"] !== "draft")) for (let i of Array(3).keys()){
            const talentToTransfer = (0, $3E8Nt.getRandomChoice)(await (0, $dl5u4.getRosterSuperstars)(indieRoster));
            if (talentToTransfer) await (0, $jpMCP.transferTalentToRoster)(talentToTransfer, indieAvailableRoster);
        }
        // Set local multiplayer attributes
        let userControlledCompanies = gameCompanies.filter((x)=>x.userControlled);
        if (newGameSettings["playerModeOption"] === "local-multiplayer") {
            game.settings["control_multiple_companies"] = true;
            game.settings["number_of_user_companies"] = userControlledCompanies.length;
            // Add player names and set turn status
            for (const [i, y] of userControlledCompanies.entries()){
                if (newGameSettings["playerNames"][i]) y.playerName = newGameSettings["playerNames"][i];
                else y.playerName = `Player ${i + 1}`;
                y.turnStatus = "playing";
            }
        }
        // Add objectives for POW
        if (mainUserCompany.storyName === "passion") {
            let objectives = await (0, $jC7EP.createPowObjectives)(mainUserCompany);
            await (0, $9esFv.addCompanyObjectives)(mainUserCompany, objectives);
        }
        // Add first tutorial state for tutorial
        if (mainUserCompany.storyName === "tutorial") {
            const storyChoice = (0, $7UN4J.StoryChoice)();
            (0, $14eBR.StoryChoices).insert(storyChoice);
            storyChoice.choice = "add_singles_match";
            await (0, $9esFv.addCompanyStoryChoices)(mainUserCompany, [
                storyChoice
            ]);
            // Disable first callup
            mainUserCompany.trainingCallupRun = true;
        }
        // Add draft if selected and competitors present
        if (newGameSettings["mainRostersOption"] === "draft" && game.competitorsPresent) {
            // Move all draft superstars/tagTeams to indie available roster
            await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, draftAvailableSuperstars);
            for (let s of draftAvailableSuperstars)s.brandName = null;
            await (0, $dl5u4.addRosterTagTeams)(indieAvailableRoster, draftAvailableTagTeams);
            // Create draft
            let draft = await (0, $lueZ1.createDraft)(mainUserCompany, gameCompanies);
            await (0, $lueZ1.processDraftPick)(draft, draftAvailableSuperstars);
        } else if (newGameSettings["customStartingCompanyData"] && newGameSettings["customStartingCompanyData"]["talentOption"] === "draft") await (0, $lueZ1.createCustomCompanyDraft)(mainUserCompany, newGameSettings["customStartingCompanyData"]["draftSettings"]);
        else // Add staff, facilities and goals. If running draft, add after ending draft
        for (let company of userControlledCompanies){
            // Get main roster superstars
            let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
            let mainRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
            // Add staff and facilities messages
            await (0, $8A6FL.addNewCompanyStaffAndFacilities)(company, mainRosterSuperstars, indieAvailableRoster, game.settings);
            // Add unlimited artifacts message
            if (game.settings["unlock_all_items"]) {
                let newMessage = await (0, $hekDR.createIntroducePowerupsSandboxModeMessage)(company, game);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            // Add sandbox mode message
            if (game.settings["sandbox_mode_enabled"]) {
                let newMessage = await (0, $hekDR.createIntroduceSandboxModeMessage)(0, 0, company.ownerName, game.settings);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            // If custom starting company, add superstar joined / competitor messages
            if (newGameSettings["customStartingCompanyData"]) {
                let topSuperstars = [
                    ...mainRosterSuperstars
                ].sort((a, b)=>b.popularity - a.popularity).slice(0, 3);
                let newMessage = await (0, $hekDR.createJoinedCompanySuperstarMessage)((0, $3E8Nt.getRandomChoice)(topSuperstars), game.monthCount, game.year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
                let competitors = await (0, $8A6FL.getCpuControlledCompanies)(company, game);
                if (competitors.length) {
                    let newMessage = await (0, $hekDR.createCustomStartingCompanyCompetitorMessage)((0, $3E8Nt.getRandomChoice)(competitors), game.monthCount, game.year);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
            // Add objectives
            if (![
                "mars",
                "passion"
            ].includes(company.storyName)) {
                let objectives = await (0, $5yA6U.generateCompanyObjectives)(company, game);
                await (0, $9esFv.addCompanyObjectives)(company, objectives);
            }
        }
        // Add sandbox mode options
        if (newGameSettings["gameModeOption"] === "sandbox") {
            // Add high number of points
            for (let userControlledCompany of userControlledCompanies)if (game.settings["unlimited_creative_points"]) userControlledCompany.points = 1000000;
            if (game.settings["all_indies_available"]) // Move all indie superstars and teams to indie available roster if not draft
            {
                if (newGameSettings["mainRostersOption"] !== "draft" && (!newGameSettings["customStartingCompanyData"] || newGameSettings["customStartingCompanyData"]["talentOption"] !== "draft")) {
                    let indieRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(indieRoster);
                    let indieRosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(indieRoster);
                    await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, indieRosterSuperstars);
                    await (0, $dl5u4.addRosterTagTeams)(indieAvailableRoster, indieRosterTagTeams);
                }
            }
        }
    }
    if (!newGameSettings) {
        if (gameDetails["yearlyRankings"]) await $dbc2d18ee95b9d27$var$createGameYearlyRankings(gameDetails["yearlyRankings"], game);
        // Add annual tournament companies
        await $dbc2d18ee95b9d27$var$addAnnualTournamentOrganizationIds(gameCompanies);
        // Add segment consequence data
        for (const x of allSegments)if (x.consequenceData) $dbc2d18ee95b9d27$var$addSegmentConsequenceData(x, allFactions, allChampionships, allBrands, allFeuds, allSegments, allMatches, gameCompanies);
        // Add receiver companies to sent negotiations / trade offers
        for (const x of gameCompanies){
            for (const y of (await (0, $9esFv.getCompanySentNegotiations)(x)))if (y["receiverCompanyUid"]) {
                const c = gameCompanies.find((x)=>{
                    return x.uid === y["receiverCompanyUid"];
                });
                if (c) await (0, $9esFv.addCompanyReceivedNegotiations)(c, [
                    y
                ]);
                delete y["receiverCompanyUid"];
            }
            for (const y of (await (0, $9esFv.getCompanySentTradeOffers)(x)))if (y["receiverCompanyUid"]) {
                const c = gameCompanies.find((x)=>{
                    return x.uid === y["receiverCompanyUid"];
                });
                if (c) await (0, $9esFv.addCompanyReceivedTradeOffers)(c, [
                    y
                ]);
                delete y["receiverCompanyUid"];
            }
        }
    }
    // Delete extra keys
    let collections = [
        (0, $14eBR.Companies),
        (0, $14eBR.Rosters),
        (0, $14eBR.Factions),
        (0, $14eBR.Brands),
        (0, $14eBR.Feuds),
        (0, $14eBR.TalentRequests),
        (0, $14eBR.Tournaments),
        (0, $14eBR.FeudItems),
        (0, $14eBR.Events),
        (0, $14eBR.MatchContracts),
        (0, $14eBR.Streaks),
        (0, $14eBR.Matches),
        (0, $14eBR.GimmickMatches),
        (0, $14eBR.SegmentItems),
        (0, $14eBR.Messages),
        (0, $14eBR.Superstars),
        (0, $14eBR.TagTeams),
        (0, $14eBR.Championships),
        (0, $14eBR.ChampionshipReigns),
        (0, $14eBR.Segments),
        (0, $14eBR.Feuds)
    ];
    for (let collection of collections)for (let object of collection.find({})){
        delete object.uid;
        if (collection.name === "Feuds") delete object.feudItemUid;
        if (collection.name === "Segments") delete object.segmentItemUid;
        if (collection.name === "Championships") delete object.matchUid;
        if (collection.name === "Tournaments") delete object.eventUid;
        if (collection.name === "Rosters") delete object.originalSuperstarsUids;
        if (collection.name === "Superstars") delete object.gimmicks;
    }
    // Developer mode settings
    if ((0, $98xmD.globalUser).developerMode) {
        game.settings["run_annual_tournament"] = false;
        game.numberOfWeeklyShows = 0;
    }
    return game;
}
async function $dbc2d18ee95b9d27$export$edc6dec1cbd9b270({ scenarioData: scenarioData, gameSettings: gameSettings } = {}) {
    let data = {};
    try {
        let mainCompanyDetails = scenarioData.companies[0].companyDetails;
        // Disallow stories for free users
        if (mainCompanyDetails.storyName && mainCompanyDetails.storyName !== "tutorial" && !(0, $98xmD.globalUser).paid) {
            data["error"] = "story-mode-paid";
            return data;
        }
        // Disallow POW for trial users
        if (mainCompanyDetails.storyName === "passion" && (0, $98xmD.globalUser).freeTrialActivated) {
            data["error"] = "pow-free-trial";
            return data;
        }
        // Disallow sandbox mode for free users
        if (gameSettings["gameModeOption"] === "sandbox" && !(0, $98xmD.globalUser).paid) {
            data["error"] = "sandbox-mode-paid";
            return data;
        }
        // Disallow local multiplayer mode for free users
        if (gameSettings["playerModeOption"] === "local-multiplayer" && !(0, $98xmD.globalUser).paid) {
            data["error"] = "local-multiplayer-mode-paid";
            return data;
        }
        // Disallow private games to be played except by creator
        let user = (0, $bZol7.loadUser)();
        if (scenarioData.scenarioDetails.private) {
            if (user.uid !== scenarioData.scenarioDetails.creatorUid) {
                data["error"] = "private-scenario";
                return data;
            }
        }
        // Disallow custom starting company for free users
        if (gameSettings["customStartingCompanyData"] && !(0, $98xmD.globalUser).paid) {
            data["error"] = "custom-starting-company-paid";
            return data;
        }
        // Create game from scenario data
        data["createdGame"] = await $dbc2d18ee95b9d27$export$3f925be9d00b40bf(scenarioData, gameSettings);
        data["storyName"] = mainCompanyDetails.storyName;
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
        data["error"] = true;
    }
    return data;
}
async function $dbc2d18ee95b9d27$export$d65ff19a99539579(scenarioData) {
    // Duplicates scenario and saves to database. Used in download scenario. todo test
    let scenarioDetails = scenarioData["scenarioDetails"];
    const scenario = {
        ...(0, $eSlDe.Scenario)(),
        ...scenarioDetails
    };
    (0, $14eBR.Scenarios).insert(scenario);
    // Create game, add to scenario
    let gameData;
    ({ scenarioDetails: scenarioDetails, ...gameData } = scenarioData);
    const game = await $dbc2d18ee95b9d27$export$9c1a45fa87f90634(gameData);
    await (0, $eSlDe.setScenarioGame)(scenario, game);
    // Save
    (0, $14eBR.db).saveDatabase();
    return scenario;
}
async function $dbc2d18ee95b9d27$var$createGameCompanyWithRosters(companyData, newGameSettings, allBrandNames, draftAvailableSuperstars, draftAvailableTagTeams) {
    const companyDetails = companyData["companyDetails"];
    const company = {
        ...(0, $9esFv.Company)(),
        ...companyDetails
    };
    if (newGameSettings) {
        const maxPoints = 5000;
        const minFans = 100;
        if (company.points > maxPoints && !newGameSettings["customStartingCompanyData"]) company.points = maxPoints;
        if (company.fans < minFans) company.fans = minFans;
        company.overness += (0, $3E8Nt.getRandomInt)(-3, 5);
        if (company.overness >= 80) company.hot = true;
        if (company.overness < 20) company.stale = true;
        if (company.reputation === null) {
            company.reputation = 4;
            company.highestReputation = 4;
        }
        company.highestReputation = company.reputation;
        if (newGameSettings["selectedUserCompanies"] && newGameSettings["selectedUserCompanies"].includes(company.name)) company.userControlled = true;
    }
    (0, $14eBR.Companies).insert(company);
    // Create rosters
    await $dbc2d18ee95b9d27$var$createCompanyRosters(companyData["rosters"], company, newGameSettings, allBrandNames, draftAvailableSuperstars, draftAvailableTagTeams);
    return company;
}
async function $dbc2d18ee95b9d27$var$createGameCompanyOtherObjects(company, companyData, allFactions, allFeuds, allBrands, allRosters, startingEventIndex, newGameSettings, game, favoritedCommunitySegments, storyName) {
    if (!newGameSettings) await $dbc2d18ee95b9d27$var$createCompanyStaff(companyData["staff"], company);
    let companyTournaments = [];
    if (!newGameSettings) {
        await $dbc2d18ee95b9d27$var$createCompanyTournaments(companyData["tournaments"], company);
        companyTournaments = await (0, $9esFv.getCompanyTournaments)(company);
    }
    // Create championships
    let companyMainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let companyBrandNames = (await (0, $dl5u4.getRosterBrands)(companyMainRoster)).map((x)=>x.name);
    await $dbc2d18ee95b9d27$var$createCompanyChampionships(companyData["championships"], companyTournaments, company, newGameSettings, companyBrandNames);
    let companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    // Create gimmick matches
    await $dbc2d18ee95b9d27$var$createCompanyGimmickMatches(companyData["gimmickMatches"], company, game, newGameSettings);
    // Create events
    let allEvents = await $dbc2d18ee95b9d27$var$createCompanyEvents(companyData["events"], companyChampionships, companyTournaments, allFeuds, company, newGameSettings, companyBrandNames, startingEventIndex);
    // Get all segments
    let allSegments = await Promise.all(allEvents.map((x)=>{
        return (0, $iQtzn.getEventSegments)(x);
    }));
    allSegments = allSegments.flat();
    // Get all matches
    let allMatches = await Promise.all(allEvents.map((x)=>{
        return (0, $iQtzn.getEventMatches)(x);
    }));
    allMatches = allMatches.flat();
    // Recreate company objects if importing
    if (!newGameSettings) {
        await $dbc2d18ee95b9d27$var$createCompanyAlerts(companyData["companyAlerts"], company);
        await $dbc2d18ee95b9d27$var$createCompanyFacilities(companyData["facilities"], company);
        await $dbc2d18ee95b9d27$var$createCompanyLogs(companyData["companyLogs"], company);
        await $dbc2d18ee95b9d27$var$createCompanyMessages(companyData["messages"], company);
        const companyMessages = await (0, $9esFv.getCompanyMessages)(company);
        await $dbc2d18ee95b9d27$var$createCompanyObjectives(companyData["objectives"], company);
        await $dbc2d18ee95b9d27$var$createCompanyRelationships(companyData["relationships"], company);
        await $dbc2d18ee95b9d27$var$createCompanyRandomEvents(companyData["randomEvents"], companyMessages, company);
        await $dbc2d18ee95b9d27$var$createCompanySentNegotiations(companyData["sentNegotiations"], company);
        await $dbc2d18ee95b9d27$var$createCompanySentTradeOffers(companyData["sentTradeOffers"], company);
        await $dbc2d18ee95b9d27$var$createCompanyTalentRequests(companyData["talentRequests"], allFactions, allBrands, company);
        if (companyData["news"]) await $dbc2d18ee95b9d27$var$createCompanyNews(companyData["news"], company);
        if (companyData["storyChoices"]) await $dbc2d18ee95b9d27$var$createCompanyStoryChoices(companyData["storyChoices"], company);
        await $dbc2d18ee95b9d27$var$createCompanyPowerups(companyData["powerups"], company);
        await $dbc2d18ee95b9d27$var$createCompanyFeudItems(companyData["feudItems"], allFeuds, company);
        await $dbc2d18ee95b9d27$var$createCompanySegmentItems(companyData["segmentItems"], allSegments, company);
        if (companyData["draft"]) await $dbc2d18ee95b9d27$var$createCompanyDraft(companyData["draft"], allRosters, company);
        // Add staff task data uids
        const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(company);
        for (const staffMember of companyStaffMembers){
            if (staffMember.taskData && staffMember.taskData["segment_id"]) {
                let taskDataSegment = allSegments.find((x)=>{
                    return x.uid === staffMember.taskData["segment_id"];
                });
                if (taskDataSegment) staffMember.taskData["segment_id"] = taskDataSegment.$loki;
                else {
                    console.log("object not found for staff task data", staffMember.taskData);
                    delete staffMember.taskData["segment_id"];
                }
            }
            if (staffMember.taskData && staffMember.taskData["talent_id"]) {
                let taskDataTalent = (0, $14eBR.Superstars).findOne({
                    "uid": staffMember.taskData["talent_id"]
                });
                if (taskDataTalent) staffMember.taskData["talent_id"] = taskDataTalent.$loki;
                else {
                    console.log("object not found for staff task data", staffMember.taskData);
                    delete staffMember.taskData["talent_id"];
                }
            }
        }
    }
    // Add new company objects for new game
    if (newGameSettings) {
        // Add feud items
        for (let x of (0, $5esHg.standardFeudItemsData)){
            let newFeudItem = {
                ...(0, $im36F.FeudItem)(),
                ...JSON.parse(JSON.stringify(x))
            };
            if (company.userControlled && game.settings["unlock_all_items"]) newFeudItem.unlocked = true;
            await (0, $14eBR.FeudItems).insert(newFeudItem);
            await (0, $9esFv.addCompanyFeudItems)(company, [
                newFeudItem
            ]);
        }
        // Add segment items
        for (let x of (0, $l4Fms.standardSegmentItemsData)){
            let newSegmentItem = {
                ...(0, $cMrnz.SegmentItem)(),
                ...JSON.parse(JSON.stringify(x))
            };
            if (company.userControlled && game.settings["unlock_all_items"]) newSegmentItem.unlocked = true;
            await (0, $14eBR.SegmentItems).insert(newSegmentItem);
            await (0, $9esFv.addCompanySegmentItems)(company, [
                newSegmentItem
            ]);
        }
        // Get powerups (except story ones)
        let powerupsData = (0, $gFyK0.standardPowerupsData).filter((x)=>!x.storyName);
        // Add user (story) powerups if unlocked
        const user = (0, $bZol7.loadUser)();
        if (user && (0, $98xmD.globalUser).paid && storyName !== "passion" && company.userControlled) powerupsData.push(...(0, $gFyK0.standardPowerupsData).filter((x)=>user.unlockedPowerups.includes(x.name)));
        // Remove competition based powerups if no competition
        if (!game.competitorsPresent) powerupsData = powerupsData.filter((x)=>x.effect !== "superstar_jump");
        // Remove some powerups for competitors
        if (!company.userControlled) powerupsData = (0, $8bQDO.filterCompetitorPowerups)(powerupsData);
        // Remove Hypnosis, Step Up and brand powerups in POW
        if (storyName === "passion") powerupsData = powerupsData.filter((x)=>![
                "reroll_goal",
                "one_match",
                "allow_other_brands",
                "allow_other_brands_extended"
            ].includes(x.effect));
        // Add powerups
        for (let x of powerupsData){
            let newPowerup = {
                ...(0, $dfpYx.Powerup)(),
                ...JSON.parse(JSON.stringify(x))
            };
            if (company.userControlled && game.settings["unlock_all_items"]) {
                newPowerup.unlocked = true;
                newPowerup.stock = 99;
            }
            await (0, $14eBR.Powerups).insert(newPowerup);
            await (0, $9esFv.addCompanyPowerups)(company, [
                newPowerup
            ]);
        }
        // Add femme fatale if POW completed
        if (user && (0, $98xmD.globalUser).paid && user.storiesCompleted.includes("passion") && !storyName && company.userControlled) {
            const femmeFataleMatch = (0, $jC7EP.createFemmeFataleMatch)();
            await (0, $14eBR.GimmickMatches).insert(femmeFataleMatch);
            await (0, $9esFv.addCompanyGimmickMatches)(company, [
                femmeFataleMatch
            ]);
        }
        // Get community segments favorited by user and not present in standard segments
        if (user && (0, $98xmD.globalUser).paid && company.userControlled && user.settings["loadFavoriteCommunitySegments"] !== false && favoritedCommunitySegments) {
            const standardSegmentItemsNames = (0, $l4Fms.standardSegmentItemsData).map((x)=>x.name);
            const communitySegmentsToAdd = favoritedCommunitySegments.filter((x)=>!standardSegmentItemsNames.includes(x.name));
            for (let communitySegmentToAdd of communitySegmentsToAdd){
                let newSegmentItem = {
                    ...(0, $cMrnz.SegmentItem)(),
                    ...JSON.parse(JSON.stringify(communitySegmentToAdd))
                };
                await (0, $14eBR.SegmentItems).insert(newSegmentItem);
                newSegmentItem.hypeBoost = newSegmentItem.feudOnly ? 1 : 0;
                newSegmentItem.popularityBoost = newSegmentItem.feudOnly ? 0 : 1;
                newSegmentItem.difficulty = 1;
                newSegmentItem.entertainment = 2;
                newSegmentItem.action = 1;
                newSegmentItem.custom = true;
                await (0, $9esFv.addCompanySegmentItems)(company, [
                    newSegmentItem
                ]);
            }
        }
    }
    return [
        allSegments,
        allMatches,
        companyChampionships
    ];
}
async function $dbc2d18ee95b9d27$var$getRosterObjects(companies) {
    // Get superstars and tagteams from all rosters
    let allRosters = await Promise.all(companies.map((x)=>{
        return (0, $9esFv.getCompanyRosters)(x);
    }));
    allRosters = allRosters.flat();
    let allFactions = await Promise.all(allRosters.map((x)=>{
        return (0, $dl5u4.getRosterFactions)(x);
    }));
    allFactions = allFactions.flat();
    let allFeuds = await Promise.all(allRosters.map((x)=>{
        return (0, $dl5u4.getRosterFeuds)(x);
    }));
    allFeuds = allFeuds.flat();
    let allBrands = await Promise.all(allRosters.map((x)=>{
        return (0, $dl5u4.getRosterBrands)(x);
    }));
    allBrands = allBrands.flat();
    return [
        allRosters,
        allFactions,
        allFeuds,
        allBrands
    ];
}
async function $dbc2d18ee95b9d27$var$createCompanyRosters(rostersData, company, newGameSettings, allBrandNames, draftAvailableSuperstars, draftAvailableTagTeams) {
    let companyRosters = [];
    for(let i = 0; i < rostersData.length; i++){
        const rosterData = rostersData[i];
        const roster = await $dbc2d18ee95b9d27$var$createCompanyRoster(rosterData, rosterData["type"], newGameSettings, allBrandNames, draftAvailableSuperstars, draftAvailableTagTeams);
        companyRosters.push(roster);
    }
    await (0, $9esFv.addCompanyRosters)(company, companyRosters);
}
async function $dbc2d18ee95b9d27$var$createCompanyRoster(rosterData, rosterType, newGameSettings, allBrandNames, draftAvailableSuperstars, draftAvailableTagTeams) {
    const roster = (0, $dl5u4.Roster)(rosterType);
    roster["uid"] = rosterData["uid"];
    roster["originalSuperstarsUids"] = rosterData["originalSuperstarsUids"];
    (0, $14eBR.Rosters).insert(roster);
    if (!newGameSettings) // Create staff
    await $dbc2d18ee95b9d27$var$createRosterStaff(rosterData["staff"], roster);
    // Create brands
    let companyBrandNames = [];
    if ((0, $98xmD.globalUser).paid) await $dbc2d18ee95b9d27$var$createRosterBrands(rosterData["brands"], roster, newGameSettings, companyBrandNames, allBrandNames);
    // Create superstars
    let rosterSuperstars = await $dbc2d18ee95b9d27$var$createRosterSuperstars(rosterData["superstars"], roster, newGameSettings, companyBrandNames);
    // Add superstars for draft
    if (newGameSettings && newGameSettings["mainRostersOption"] === "draft") {
        if (roster.type === "main" || roster.type === "training" && newGameSettings["draftIncludeTraining"] || roster.type === "indie" && newGameSettings["draftIncludeIndies"]) draftAvailableSuperstars.push(...rosterSuperstars);
    }
    // Create tagTeams
    await $dbc2d18ee95b9d27$var$createRosterTagTeams(rosterData["tagTeams"], roster);
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(roster);
    // Add tagTeams for draft
    if (newGameSettings && newGameSettings["mainRostersOption"] === "draft") {
        if (roster.type === "main" || roster.type === "training" && newGameSettings["draftIncludeTraining"] || roster.type === "indie" && newGameSettings["draftIncludeIndies"]) draftAvailableTagTeams.push(...rosterTagTeams);
    }
    // Create factions
    if ((!newGameSettings || newGameSettings["mainRostersOption"] !== "draft") && (0, $98xmD.globalUser).paid) await $dbc2d18ee95b9d27$var$createRosterFactions(rosterData["factions"], roster);
    if (!newGameSettings) // Create feuds
    await $dbc2d18ee95b9d27$var$createRosterFeuds(rosterData["feuds"], roster);
    return roster;
}
async function $dbc2d18ee95b9d27$var$createRosterSuperstars(superstarsData, roster, newGameSettings, companyBrandNames) {
    let rosterSuperstars = [];
    for(let i = 0; i < superstarsData.length; i++){
        const superstarData = superstarsData[i];
        const superstar = {
            ...(0, $hBIDz.Superstar)(),
            ...superstarData
        };
        (0, $14eBR.Superstars).insert(superstar);
        if (!(0, $98xmD.globalUser).paid || !companyBrandNames.includes(superstar.brandName)) superstar.brandName = null;
        superstar.pronoun = (0, $3E8Nt.getRosterMemberPronoun)(superstar);
        superstar.possessivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(superstar, "possessive");
        superstar.objectivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(superstar, "objective");
        if (newGameSettings) {
            superstar.overness += (0, $3E8Nt.getRandomInt)(-3, 5);
            if (superstar.overness >= 80) superstar.hot = true;
            if (superstar.overness < 20) superstar.stale = true;
            // Don't allow part timer and retired at the same time
            if (superstar.partTimer && superstar.retired) superstar.partTimer = false;
            // Add part timer's appearances
            if (superstar.partTimer) superstar.appearances = (0, $jpMCP.getPartTimerAppearances)(superstar);
            // Add default injury names
            if (superstar.injured) {
                if (superstar.injured > 6) superstar.injuryName = "major injury";
                else superstar.injuryName = "minor injury";
            }
            if (superstar.monthToAppearIn > 2) superstar.monthToAppearIn += (0, $3E8Nt.getRandomInt)(-2, 2);
            superstar.highestRank = (0, $5kTkA.getRankFromPopularity)(superstar.popularity);
        }
        // Create gimmicks
        if (superstarData["gimmicks"]) await $dbc2d18ee95b9d27$var$createSuperstarGimmicks(superstarData["gimmicks"], superstar, roster, newGameSettings);
        // Add staff object if present
        if (superstar.staffObjectData) {
            const superstarStaffObject = {
                ...(0, $5JRw3.Staff)(),
                ...superstar.staffObjectData
            };
            (0, $14eBR.StaffMembers).insert(superstarStaffObject);
            (0, $5JRw3.setStaffSuperstarObject)(superstarStaffObject, superstar);
            delete superstar.staffObjectData;
        }
        rosterSuperstars.push(superstar);
    }
    (0, $dl5u4.addRosterSuperstars)(roster, rosterSuperstars);
    return rosterSuperstars;
}
async function $dbc2d18ee95b9d27$var$createSuperstarGimmicks(gimmicksData, superstar, roster, newGameSettings) {
    let gimmicks = [];
    for(let i = 0; i < gimmicksData.length; i++){
        const gimmickData = gimmicksData[i];
        const gimmick = {
            ...(0, $i6OYC.Gimmick)(),
            ...gimmickData
        };
        (0, $14eBR.Gimmicks).insert(gimmick);
        gimmicks.push(gimmick);
        if (newGameSettings) {
            gimmick.startMonth = 0;
            gimmick.startYear = 0;
        }
        // Add relationships
        if (gimmick["rosterUid"]) {
            const gimmickRoster = [
                roster
            ].find((x)=>{
                return x.uid === gimmick.rosterUid;
            });
            if (gimmickRoster) await (0, $dl5u4.addRosterGimmicks)(gimmickRoster, [
                gimmick
            ]);
            delete gimmick.rosterUid;
        }
    }
    (0, $hBIDz.addSuperstarGimmicks)(superstar, gimmicks);
}
async function $dbc2d18ee95b9d27$var$createRosterTagTeams(tagTeamsData, roster) {
    let rosterTagTeams = [];
    for(let i = 0; i < tagTeamsData.length; i++){
        const tagTeamData = tagTeamsData[i];
        const tagTeam = {
            ...(0, $972Ip.TagTeam)(),
            ...tagTeamData
        };
        (0, $14eBR.TagTeams).insert(tagTeam);
        if (!tagTeamData["detachedItem"]) rosterTagTeams.push(tagTeam);
    }
    await (0, $dl5u4.addRosterTagTeams)(roster, rosterTagTeams);
}
async function $dbc2d18ee95b9d27$var$createRosterFactions(factionsData, roster) {
    let rosterFactions = [];
    for(let i = 0; i < factionsData.length; i++){
        const factionData = factionsData[i];
        const faction = {
            ...(0, $2JFAd.Faction)(),
            ...factionData
        };
        (0, $14eBR.Factions).insert(faction);
        rosterFactions.push(faction);
    }
    await (0, $dl5u4.addRosterFactions)(roster, rosterFactions);
}
async function $dbc2d18ee95b9d27$var$createRosterBrands(brandsData, roster, newGameSettings, companyBrandNames, allBrandNames) {
    let rosterBrands = [];
    for(let i = 0; i < brandsData.length; i++){
        const brandData = brandsData[i];
        if (!allBrandNames.includes(brandData["name"])) {
            const brand = {
                ...(0, $8LLPX.Brand)(),
                ...brandData
            };
            (0, $14eBR.Brands).insert(brand);
            rosterBrands.push(brand);
            companyBrandNames.push(brand.name);
            allBrandNames.push(brand.name);
            if (newGameSettings) {
                brand.overness += (0, $3E8Nt.getRandomInt)(-3, 5);
                if (brand.overness >= 80) brand.hot = true;
                if (brand.overness < 20) brand.stale = true;
            }
        }
    }
    await (0, $dl5u4.addRosterBrands)(roster, rosterBrands);
    return rosterBrands;
}
async function $dbc2d18ee95b9d27$var$createRosterFeuds(feudsData, roster) {
    let rosterFeuds = [];
    for(let i = 0; i < feudsData.length; i++){
        const feudData = feudsData[i];
        const feud = {
            ...(0, $jDtEn.Feud)(),
            ...feudData
        };
        (0, $14eBR.Feuds).insert(feud);
        rosterFeuds.push(feud);
    }
    await (0, $dl5u4.addRosterFeuds)(roster, rosterFeuds);
}
async function $dbc2d18ee95b9d27$var$createCompanyChampionships(championshipsData, companyTournaments, company, newGameSettings, companyBrandNames) {
    let companyChampionships = [];
    for(let i = 0; i < championshipsData.length; i++){
        const championshipData = championshipsData[i];
        const championship = {
            ...(0, $ivuOU.Championship)(),
            ...championshipData
        };
        if (!(0, $98xmD.globalUser).paid || !companyBrandNames.includes(championship.brandName)) championship.brandName = null;
        (0, $14eBR.Championships).insert(championship);
        if (newGameSettings) // Add xp over prestige base value
        {
            if (championship.prestige !== "C") championship.xp += 10;
        }
        if (!championship["detachedItem"]) companyChampionships.push(championship);
        // Add to superstar
        if (championship.superstarUid && (!newGameSettings || newGameSettings["mainRostersOption"] !== "draft")) {
            const championSuperstar = (0, $14eBR.Superstars).findOne({
                "uid": championship.superstarUid
            });
            if (championSuperstar) {
                (0, $hBIDz.addSuperstarChampionships)(championSuperstar, [
                    championship
                ]);
                if (newGameSettings) {
                    // Add reign
                    const championshipReign = (0, $9MKdC.ChampionshipReign)(0, 0);
                    (0, $14eBR.ChampionshipReigns).insert(championshipReign);
                    await (0, $hBIDz.addSuperstarChampionshipReigns)(championSuperstar, [
                        championshipReign
                    ]);
                    await (0, $ivuOU.addChampionshipChampionshipReigns)(championship, [
                        championshipReign
                    ]);
                    if (championship.tagTeam || championship.trio) {
                        let championTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(championSuperstar)).filter((x)=>x.trio === championship.trio);
                        if (championTagTeams.length) championshipReign.holderName = championTagTeams[0].name;
                    } else championshipReign.holderName = championSuperstar.name;
                }
            } else {
                championship.vacated = true;
                console.log("champion not found when creating game", championship.name, championship.superstarUid);
            }
            delete championship.superstarUid;
        } else championship.vacated = true;
        // Add championship reigns
        if (!newGameSettings) await $dbc2d18ee95b9d27$var$createCompanyChampionshipReigns(championshipData["reigns"], championship);
        // Add tournament
        if (championship["tournamentUid"]) {
            const championshipTournament = companyTournaments.find((x)=>{
                return x.uid === championship.tournamentUid;
            });
            if (championshipTournament) await (0, $4EGpv.addTournamentChampionships)(championshipTournament, [
                championship
            ]);
            else console.log("tournament not found when creating game", championship.name, championship.tournamentUid);
            delete championship.tournamentUid;
        }
        delete championshipsData["reigns"];
    }
    await (0, $9esFv.addCompanyChampionships)(company, companyChampionships);
}
async function $dbc2d18ee95b9d27$var$createCompanyEvents(eventsData, companyChampionships, companyTournaments, allFeuds, company, newGameSettings, companyBrandNames, startingEventIndex) {
    let allEvents = [];
    let companyEvents = [];
    await (0, $3E8Nt.asyncFor)(eventsData, async (eventData)=>{
        const event = await $dbc2d18ee95b9d27$var$createCompanyEvent(eventData, companyEvents, companyChampionships, companyTournaments, allFeuds, companyBrandNames, newGameSettings);
        if (!event["detachedEvent"]) companyEvents.push(event);
        allEvents.push(event);
    });
    await (0, $9esFv.addCompanyEvents)(company, companyEvents);
    if (newGameSettings) {
        // Add starting event
        const parentEvent = companyEvents[startingEventIndex];
        const latestEvent = (0, $iQtzn.Event)(parentEvent.name);
        await (0, $14eBR.Events).insert(latestEvent);
        await (0, $9esFv.addCompanyEvents)(company, [
            latestEvent
        ]);
        const isTopEvent = parentEvent.name === (0, $3E8Nt.getArrayMaxByProperty)(companyEvents, "xp").name;
        latestEvent.year = company.realYear;
        latestEvent.prestige = parentEvent.prestige;
        latestEvent.hype = await (0, $5ZsVo.getEventHype)(latestEvent, isTopEvent);
        if ((0, $98xmD.globalUser).paid) latestEvent.brandName = parentEvent.brandName;
        (0, $iQtzn.addChildEvent)(parentEvent, latestEvent);
    }
    return allEvents;
}
async function $dbc2d18ee95b9d27$var$createCompanyEvent(eventData, companyEvents, companyChampionships, companyTournaments, allFeuds, companyBrandNames, newGameSettings) {
    const event = {
        ...(0, $iQtzn.Event)(),
        ...eventData
    };
    if (!(0, $98xmD.globalUser).paid || !companyBrandNames.includes(event.brandName)) event.brandName = null;
    (0, $14eBR.Events).insert(event);
    // Add parent event
    if (event.parentUid) {
        const parentEvent = companyEvents.find((x)=>{
            return x.uid === event.parentUid;
        });
        (0, $iQtzn.addChildEvent)(parentEvent, event);
        delete event.parentUid;
    }
    // Add tournaments
    if (!newGameSettings) {
        const eventTournaments = companyTournaments.filter((x)=>{
            return x["eventUid"] === eventData["uid"];
        });
        if (eventTournaments.length > 0) await (0, $iQtzn.addEventTournaments)(event, eventTournaments);
    }
    // Create matches
    await $dbc2d18ee95b9d27$var$createEventMatches(eventData, companyChampionships, companyTournaments, allFeuds, event);
    // Create segments
    await $dbc2d18ee95b9d27$var$createEventSegments(eventData, companyChampionships, allFeuds, event);
    // Create match contracts
    await $dbc2d18ee95b9d27$var$createEventMatchContracts(eventData, companyChampionships, companyTournaments, event, newGameSettings);
    // Create streaks
    await $dbc2d18ee95b9d27$var$createEventStreaks(eventData, event);
    delete event.matches;
    delete event.segments;
    delete event.matchContracts;
    delete event.streaks;
    return event;
}
async function $dbc2d18ee95b9d27$var$createEventMatches(eventData, companyChampionships, companyTournaments, allFeuds, event) {
    let eventMatches = [];
    if (eventData["matches"]) for(let i = 0; i < eventData["matches"].length; i++){
        const matchData = eventData["matches"][i];
        const match = await $dbc2d18ee95b9d27$var$createEventMatch(matchData, companyChampionships, companyTournaments, allFeuds);
        eventMatches.push(match);
    }
    await (0, $iQtzn.addEventMatches)(event, eventMatches);
}
async function $dbc2d18ee95b9d27$var$createEventMatch(matchData, companyChampionships, companyTournaments, allFeuds) {
    let match = {
        ...(0, $i7bmn.Match)(),
        ...matchData
    };
    (0, $14eBR.Matches).insert(match);
    // Get participants
    let matchParticipants;
    if (match.type === "singles") {
        matchParticipants = (0, $14eBR.Superstars).find({
            "uid": {
                "$in": match.participantUids
            }
        });
        matchParticipants.sort((a, b)=>match.participantUids.indexOf(a.uid) - match.participantUids.indexOf(b.uid));
        await (0, $i7bmn.addMatchSuperstars)(match, matchParticipants);
    } else {
        matchParticipants = (0, $14eBR.TagTeams).find({
            "uid": {
                "$in": match.participantUids
            }
        });
        matchParticipants.sort((a, b)=>match.participantUids.indexOf(a.uid) - match.participantUids.indexOf(b.uid));
        await (0, $i7bmn.addMatchTagTeams)(match, matchParticipants);
    }
    if (matchParticipants.length !== match.participantUids.length) console.log("match participants not found when creating match", match);
    // Add championships
    const matchChampionships = companyChampionships.filter((x)=>{
        return x["matchUid"] === matchData["uid"];
    });
    await (0, $i7bmn.addMatchChampionships)(match, matchChampionships);
    // Add tournament
    if (match["tournamentUid"]) {
        const matchTournament = companyTournaments.find((x)=>{
            return x.uid === match.tournamentUid;
        });
        if (matchTournament) await (0, $4EGpv.addTournamentMatches)(matchTournament, [
            match
        ]);
        else console.log("tournament not found when creating match", match, match.tournamentUid);
        delete match.tournamentUid;
    }
    // Add gimmick match
    if (match["gimmickMatchUid"]) {
        const matchGimmickMatch = (0, $14eBR.GimmickMatches).findOne({
            "uid": match.gimmickMatchUid
        });
        if (matchGimmickMatch) await (0, $cYLJ6.addGimmickMatchMatches)(matchGimmickMatch, [
            match
        ]);
        else console.log("gimmick match not found when creating match", match, match.gimmickMatchUid);
        delete match.gimmickMatchUid;
    }
    // Add feuds
    if (match["feudUids"].length > 0) {
        const matchFeuds = allFeuds.filter((x)=>{
            return match["feudUids"].indexOf(x.uid) >= 0;
        });
        if (matchFeuds.length > 0) await (0, $i7bmn.addMatchFeuds)(match, matchFeuds);
        if (match["feudUids"].length !== matchFeuds.length) console.log("feud not found when creating match", match, match.feudUids);
    }
    delete match.feudUids;
    // Add championship reigns
    if (match["championshipReignUids"].length > 0) {
        const matchChampionshipReigns = (0, $14eBR.ChampionshipReigns).find({
            "uid": {
                "$in": match["championshipReignUids"]
            }
        });
        if (matchChampionshipReigns.length > 0) await (0, $i7bmn.addMatchChampionshipReigns)(match, matchChampionshipReigns);
        if (match["championshipReignUids"].length !== matchChampionshipReigns.length) console.log("reign not found when creating match", match, match.championshipReignUids);
    }
    delete match.championshipReignUids;
    // Add referee uid
    if (match["refereeUid"]) {
        const refereeSuperstar = (0, $14eBR.Superstars).findOne({
            "uid": match.refereeUid
        });
        if (refereeSuperstar) match["refereeId"] = refereeSuperstar.$loki;
        delete match.refereeUid;
    }
    // Add managers used ids
    if (match["managersUsedUids"]) {
        for(const uid in match["managersUsedUids"])if (match["managersUsedUids"].hasOwnProperty(uid)) {
            let key = (0, $14eBR.Superstars).findOne({
                "uid": uid
            })?.$loki;
            let value = (0, $14eBR.Superstars).findOne({
                "uid": match["managersUsedUids"][uid]
            })?.$loki;
            if (key && value) match["managersUsed"][key] = value;
        }
        delete match.managersUsedUids;
    }
    // Remove match's uid keys
    delete match.participantUids;
    return match;
}
async function $dbc2d18ee95b9d27$var$createEventSegments(eventData, companyChampionships, allFeuds, event) {
    let eventSegments = [];
    if (eventData["segments"]) for(let i = 0; i < eventData["segments"].length; i++){
        const segmentData = eventData["segments"][i];
        const segment = await $dbc2d18ee95b9d27$var$createEventSegment(segmentData, companyChampionships, allFeuds);
        eventSegments.push(segment);
    }
    await (0, $iQtzn.addEventSegments)(event, eventSegments);
}
async function $dbc2d18ee95b9d27$var$createEventSegment(segmentData, companyChampionships, allFeuds) {
    let segment = {
        ...(0, $eg5dz.Segment)(),
        ...segmentData
    };
    (0, $14eBR.Segments).insert(segment);
    // Get participants
    let segmentParticipants = (0, $14eBR.Superstars).find({}).concat((0, $14eBR.TagTeams).find({})).filter((x)=>{
        return segment.participantUids.indexOf(x.uid) >= 0;
    });
    if (segmentParticipants.length !== segment.participantUids.length) console.log("segment participants not found when creating segment", segment);
    segmentParticipants.sort((a, b)=>segment.participantUids.indexOf(b.uid) - segment.participantUids.indexOf(a.uid));
    for (const p of segmentParticipants)if (p.objectName === "superstar") await (0, $eg5dz.addSegmentSuperstars)(segment, [
        p
    ]);
    else await (0, $eg5dz.addSegmentTagTeams)(segment, [
        p
    ]);
    // Add feuds
    if (segment["feudUids"].length > 0) {
        const segmentFeuds = allFeuds.filter((x)=>{
            return segment["feudUids"].indexOf(x.uid) >= 0;
        });
        if (segmentFeuds.length > 0) await (0, $eg5dz.addSegmentFeuds)(segment, segmentFeuds);
        if (segment["feudUids"].length !== segmentFeuds.length) console.log("feud not found when creating segment", segment, segment.feudUids);
    }
    delete segment.feudUids;
    // Add managers used ids
    if (segment["managersUsedUids"]) {
        for(const uid in segment["managersUsedUids"])if (segment["managersUsedUids"].hasOwnProperty(uid)) {
            let key = (0, $14eBR.Superstars).findOne({
                "uid": uid
            })?.$loki;
            let value = (0, $14eBR.Superstars).findOne({
                "uid": segment["managersUsedUids"][uid]
            })?.$loki;
            if (key && value) segment["managersUsed"][key] = value;
        }
        delete segment.managersUsedUids;
    }
    delete segment.participantUids;
    return segment;
}
async function $dbc2d18ee95b9d27$var$createCompanyAlerts(companyAlertsData, company) {
    let companyAlerts = [];
    for(let i = 0; i < companyAlertsData.length; i++){
        const companyAlertData = companyAlertsData[i];
        const companyAlert = {
            ...(0, $5DBvS.CompanyAlert)(),
            ...companyAlertData
        };
        (0, $14eBR.CompanyAlerts).insert(companyAlert);
        companyAlerts.push(companyAlert);
    }
    await (0, $9esFv.addCompanyCompanyAlerts)(company, companyAlerts);
}
async function $dbc2d18ee95b9d27$var$createCompanyLogs(companyLogsData, company) {
    let companyLogs = [];
    for(let i = 0; i < companyLogsData.length; i++){
        const companyLogData = companyLogsData[i];
        const companyLog = {
            ...(0, $4K85d.CompanyLog)(),
            ...companyLogData
        };
        (0, $14eBR.CompanyLogs).insert(companyLog);
        companyLogs.push(companyLog);
    }
    await (0, $9esFv.addCompanyCompanyLogs)(company, companyLogs);
}
async function $dbc2d18ee95b9d27$var$createCompanyGimmickMatches(companyGimmickMatchesData, company, game, newGameSettings) {
    let companyGimmickMatches = [];
    let unavailable = [
        "Brawl",
        "Loser Leaves",
        "Steel Cell",
        "Hell In A Cell",
        "Flag",
        "Ambulance",
        "LMS",
        "TLC",
        "Unsanctioned",
        "Tables",
        "Casket"
    ];
    let companyGimmickMatchNames = companyGimmickMatchesData.map((x)=>x.name);
    for(let i = 0; i < companyGimmickMatchesData.length; i++){
        const companyGimmickMatchData = companyGimmickMatchesData[i];
        const companyGimmickMatch = {
            ...(0, $cYLJ6.GimmickMatch)(),
            ...companyGimmickMatchData
        };
        if (newGameSettings && company.userControlled) {
            // Make specific gimmick matches unavailable
            if (unavailable.includes(companyGimmickMatch.name)) {
                if (companyGimmickMatchNames.includes($dbc2d18ee95b9d27$var$getGimmickMatchUnlockedBy(companyGimmickMatch.name))) companyGimmickMatch.available = false;
            }
            if (game.settings["unlock_all_items"]) companyGimmickMatch.available = true;
        }
        (0, $14eBR.GimmickMatches).insert(companyGimmickMatch);
        if (!companyGimmickMatch["detachedItem"]) companyGimmickMatches.push(companyGimmickMatch);
    }
    await (0, $9esFv.addCompanyGimmickMatches)(company, companyGimmickMatches);
}
function $dbc2d18ee95b9d27$var$getGimmickMatchUnlockedBy(gimmickMatchName) {
    for (const [k, v] of Object.entries((0, $5qFpQ.gimmickMatchUnlocksData))){
        if (v.includes(gimmickMatchName)) return k;
    }
    return null;
}
async function $dbc2d18ee95b9d27$var$createCompanyRelationships(companyRelationshipsData, company) {
    let companyRelationships = [];
    for(let i = 0; i < companyRelationshipsData.length; i++){
        const companyRelationshipData = companyRelationshipsData[i];
        const companyRelationship = {
            ...(0, $iWkAo.Relationship)(),
            ...companyRelationshipData
        };
        (0, $14eBR.Relationships).insert(companyRelationship);
        companyRelationships.push(companyRelationship);
        if (companyRelationship["superstarUid"]) {
            const companyRelationshipSuperstar = (0, $14eBR.Superstars).findOne({
                "uid": companyRelationship["superstarUid"]
            });
            if (companyRelationshipSuperstar) await (0, $hBIDz.addSuperstarRelationships)(companyRelationshipSuperstar, [
                companyRelationship
            ]);
            delete companyRelationship.superstarUid;
        }
    }
    await (0, $9esFv.addCompanyRelationships)(company, companyRelationships);
}
async function $dbc2d18ee95b9d27$var$createCompanyRandomEvents(companyRandomEventsData, companyMessages, company) {
    let companyRandomEvents = [];
    for(let i = 0; i < companyRandomEventsData.length; i++){
        const companyRandomEventData = companyRandomEventsData[i];
        const companyRandomEvent = {
            ...(0, $9tPJr.RandomEvent)(),
            ...companyRandomEventData
        };
        (0, $14eBR.RandomEvents).insert(companyRandomEvent);
        companyRandomEvents.push(companyRandomEvent);
        if (companyRandomEvent["superstarUid"]) {
            const randomEventSuperstar = (0, $14eBR.Superstars).findOne({
                "uid": companyRandomEvent["superstarUid"]
            });
            if (randomEventSuperstar) await (0, $hBIDz.addSuperstarRandomEvents)(randomEventSuperstar, [
                companyRandomEvent
            ]);
            else console.log("superstar not found when creating randomEvent", companyRandomEvent.name, companyRandomEvent.superstarUid);
            delete companyRandomEvent.superstarUid;
        }
        if (companyRandomEvent["messageUid"]) {
            const randomEventMessage = (0, $14eBR.Messages).findOne({
                "uid": companyRandomEvent.messageUid
            });
            if (randomEventMessage) await (0, $9tPJr.addRandomEventMessages)(companyRandomEvent, [
                randomEventMessage
            ]);
            else console.log("message not found when creating randomEvent", companyRandomEvent.name, companyRandomEvent.messageUid);
            delete companyRandomEvent.messageUid;
        }
        if (companyRandomEvent["championshipUid"]) {
            const randomEventChampionship = (0, $14eBR.Championships).findOne({
                "uid": companyRandomEvent.championshipUid
            });
            if (randomEventChampionship) await (0, $ivuOU.addChampionshipRandomEvents)(randomEventChampionship, [
                companyRandomEvent
            ]);
            else console.log("championship not found when creating randomEvent", companyRandomEvent.name, companyRandomEvent.championshipUid);
            delete companyRandomEvent.championshipUid;
        }
        if (companyRandomEvent["gimmickMatchUid"]) {
            const randomEventGimmickMatch = (0, $14eBR.GimmickMatches).findOne({
                "uid": companyRandomEvent.gimmickMatchUid
            });
            if (randomEventGimmickMatch) await (0, $cYLJ6.addGimmickMatchRandomEvents)(randomEventGimmickMatch, [
                companyRandomEvent
            ]);
            else console.log("gimmickMatch not found when creating randomEvent", companyRandomEvent.name, companyRandomEvent.gimmickMatchUid);
            delete companyRandomEvent.gimmickMatchUid;
        }
        if (companyRandomEvent["selectionIds"].length > 0) {
            const selectedSuperstars = companyRandomEvent["selectionIds"].map((x)=>{
                return (0, $14eBR.Superstars).findOne({
                    uid: x
                });
            }).filter((x)=>x);
            companyRandomEvent.selectionIds = selectedSuperstars.map((x)=>x.$loki);
        }
    }
    await (0, $9esFv.addCompanyRandomEvents)(company, companyRandomEvents);
}
async function $dbc2d18ee95b9d27$var$createCompanySentNegotiations(companySentNegotiationsData, company) {
    let companySentNegotiations = [];
    for(let i = 0; i < companySentNegotiationsData.length; i++){
        const companySentNegotiationData = companySentNegotiationsData[i];
        const companySentNegotiation = {
            ...(0, $csISS.Negotiation)(),
            ...companySentNegotiationData
        };
        (0, $14eBR.Negotiations).insert(companySentNegotiation);
        companySentNegotiations.push(companySentNegotiation);
        if (companySentNegotiation["superstarUid"]) {
            const companySentNegotiationSuperstar = (0, $14eBR.Superstars).findOne({
                "uid": companySentNegotiation["superstarUid"]
            });
            if (companySentNegotiationSuperstar) await (0, $hBIDz.addSuperstarNegotiations)(companySentNegotiationSuperstar, [
                companySentNegotiation
            ]);
            else console.log("superstar not found when creating companySentNegotiation", companySentNegotiation.name, companySentNegotiation.superstarUid);
            delete companySentNegotiation.superstarUid;
        }
        if (companySentNegotiation["tagTeamUid"]) {
            const companySentNegotiationTagTeam = (0, $14eBR.TagTeams).findOne({
                "uid": companySentNegotiation.tagTeamUid
            });
            if (companySentNegotiationTagTeam) await (0, $972Ip.addTagTeamNegotiations)(companySentNegotiationTagTeam, [
                companySentNegotiation
            ]);
            else console.log("tagTeam not found when creating companySentNegotiation", companySentNegotiation.name, companySentNegotiation.tagTeamUid);
            delete companySentNegotiation.tagTeamUid;
        }
    }
    await (0, $9esFv.addCompanySentNegotiations)(company, companySentNegotiations);
}
async function $dbc2d18ee95b9d27$var$createCompanySentTradeOffers(companySentTradeOffersData, company) {
    let companySentTradeOffers = [];
    for(let i = 0; i < companySentTradeOffersData.length; i++){
        const companySentTradeOfferData = companySentTradeOffersData[i];
        const companySentTradeOffer = {
            ...(0, $iY7cj.TradeOffer)(),
            ...companySentTradeOfferData
        };
        (0, $14eBR.TradeOffers).insert(companySentTradeOffer);
        companySentTradeOffers.push(companySentTradeOffer);
        // Add superstars
        if (companySentTradeOffer["offeredSuperstarsUids"].length > 0) {
            const offeredSuperstars = (0, $14eBR.Superstars).find({
                "uid": {
                    "$in": companySentTradeOffer["offeredSuperstarsUids"]
                }
            });
            if (offeredSuperstars.length > 0) await (0, $iY7cj.addTradeOfferOfferedSuperstars)(companySentTradeOffer, offeredSuperstars);
            if (companySentTradeOffer["offeredSuperstarsUids"].length !== offeredSuperstars.length) console.log("offeredSuperstars not found when creating sent trade offer", companySentTradeOffer, companySentTradeOffer.offeredSuperstarsUids);
        }
        delete companySentTradeOffer.offeredSuperstarsUids;
        if (companySentTradeOffer["requestedSuperstarsUids"].length > 0) {
            const requestedSuperstars = (0, $14eBR.Superstars).find({
                "uid": {
                    "$in": companySentTradeOffer["requestedSuperstarsUids"]
                }
            });
            if (requestedSuperstars.length > 0) await (0, $iY7cj.addTradeOfferRequestedSuperstars)(companySentTradeOffer, requestedSuperstars);
            if (companySentTradeOffer["requestedSuperstarsUids"].length !== requestedSuperstars.length) console.log("requestedSuperstars not found when creating sent trade offer", companySentTradeOffer, companySentTradeOffer.requestedSuperstarsUids);
        }
        delete companySentTradeOffer.requestedSuperstarsUids;
    }
    await (0, $9esFv.addCompanySentTradeOffers)(company, companySentTradeOffers);
}
async function $dbc2d18ee95b9d27$var$createCompanyTalentRequests(companyTalentRequestsData, allFactions, allBrands, company) {
    let companyTalentRequests = [];
    for(let i = 0; i < companyTalentRequestsData.length; i++){
        const companyTalentRequestData = companyTalentRequestsData[i];
        const companyTalentRequest = {
            ...(0, $cpTRW.TalentRequest)(),
            ...companyTalentRequestData
        };
        (0, $14eBR.TalentRequests).insert(companyTalentRequest);
        companyTalentRequests.push(companyTalentRequest);
        if (companyTalentRequest["superstarUid"]) {
            const companyTalentRequestSuperstar = (0, $14eBR.Superstars).findOne({
                "uid": companyTalentRequest["superstarUid"]
            });
            if (companyTalentRequestSuperstar) await (0, $hBIDz.addSuperstarTalentRequests)(companyTalentRequestSuperstar, [
                companyTalentRequest
            ]);
            else console.log("superstar not found when creating companyTalentRequestData", companyTalentRequestData.name, companyTalentRequestData.superstarUid);
            delete companyTalentRequest.superstarUid;
        }
        if (companyTalentRequest["tagTeamUid"]) {
            const companyTalentRequestTagTeam = (0, $14eBR.TagTeams).findOne({
                "uid": companyTalentRequest.tagTeamUid
            });
            if (companyTalentRequestTagTeam) await (0, $972Ip.addTagTeamTalentRequests)(companyTalentRequestTagTeam, [
                companyTalentRequest
            ]);
            else console.log("tagTeam not found when creating companyTalentRequestData", companyTalentRequestData.name, companyTalentRequestData.tagTeamUid);
            delete companyTalentRequest.tagTeamUid;
        }
        // Add action data ids
        if (companyTalentRequest.actionData["selectedTalentId"]) {
            let actionDataTalent = (0, $14eBR.Superstars).findOne({
                "uid": companyTalentRequest.actionData["selectedTalentId"]
            });
            if (!actionDataTalent) actionDataTalent = (0, $14eBR.TagTeams).findOne({
                "uid": companyTalentRequest.actionData["selectedTalentId"]
            });
            if (actionDataTalent) companyTalentRequest.actionData["selectedTalentId"] = actionDataTalent.$loki;
            else {
                console.log("object not found for talent request", companyTalentRequest.actionData);
                delete companyTalentRequest.actionData["selectedTalentId"];
            }
        }
        if (companyTalentRequest.actionData["selectedTeamId"]) {
            let actionDataTeam = (0, $14eBR.TagTeams).findOne({
                "uid": companyTalentRequest.actionData["selectedTeamId"]
            });
            if (actionDataTeam) companyTalentRequest.actionData["selectedTeamId"] = actionDataTeam.$loki;
            else {
                console.log("object not found for talent request", companyTalentRequest.actionData);
                delete companyTalentRequest.actionData["selectedTeamId"];
            }
        }
        if (companyTalentRequest.actionData["selectedFactionId"]) {
            let actionDataFaction = allFactions.find((x)=>{
                return x.uid === companyTalentRequest.actionData["selectedFactionId"];
            });
            if (actionDataFaction) companyTalentRequest.actionData["selectedFactionId"] = actionDataFaction.$loki;
            else {
                console.log("object not found for talent request", companyTalentRequest.actionData);
                delete companyTalentRequest.actionData["selectedFactionId"];
            }
        }
        if (companyTalentRequest.actionData["selectedChampionshipId"]) {
            let actionDataChampionship = (0, $14eBR.Championships).findOne({
                "uid": companyTalentRequest.actionData["selectedChampionshipId"]
            });
            if (actionDataChampionship) companyTalentRequest.actionData["selectedChampionshipId"] = actionDataChampionship.$loki;
            else {
                console.log("object not found for talent request", companyTalentRequest.actionData);
                delete companyTalentRequest.actionData["selectedChampionshipId"];
            }
        }
        if (companyTalentRequest.actionData["selectedGimmickMatchId"]) {
            let actionDataGimmickMatch = (0, $14eBR.GimmickMatches).findOne({
                "uid": companyTalentRequest.actionData["selectedGimmickMatchId"]
            });
            if (actionDataGimmickMatch) companyTalentRequest.actionData["selectedGimmickMatchId"] = actionDataGimmickMatch.$loki;
            else {
                console.log("object not found for talent request", companyTalentRequest.actionData);
                delete companyTalentRequest.actionData["selectedGimmickMatchId"];
            }
        }
        if (companyTalentRequest.actionData["selectedBrandId"]) {
            let actionDataBrand = allBrands.find((x)=>{
                return x.uid === companyTalentRequest.actionData["selectedBrandId"];
            });
            if (actionDataBrand) companyTalentRequest.actionData["selectedBrandId"] = actionDataBrand.$loki;
            else {
                console.log("object not found for talent request", companyTalentRequest.actionData);
                delete companyTalentRequest.actionData["selectedBrandId"];
            }
        }
    }
    await (0, $9esFv.addCompanyTalentRequests)(company, companyTalentRequests);
}
async function $dbc2d18ee95b9d27$var$createCompanyTournaments(companyTournamentsData, company) {
    let companyTournaments = [];
    for(let i = 0; i < companyTournamentsData.length; i++){
        const companyTournamentData = companyTournamentsData[i];
        const companyTournament = {
            ...(0, $4EGpv.Tournament)(),
            ...companyTournamentData
        };
        (0, $14eBR.Tournaments).insert(companyTournament);
        companyTournaments.push(companyTournament);
        if (companyTournament["winnerSuperstarUid"]) {
            const tournamentWinnerSuperstar = (0, $14eBR.Superstars).findOne({
                "uid": companyTournament["winnerSuperstarUid"]
            });
            if (tournamentWinnerSuperstar) await (0, $hBIDz.addSuperstarWonTournaments)(tournamentWinnerSuperstar, [
                companyTournament
            ]);
            else console.log("winnerSuperstar not found when creating companyTournamentData", companyTournamentData.name, companyTournamentData.winnerSuperstarUid);
            delete companyTournament.winnerSuperstarUid;
        }
        if (companyTournament["winnerTagTeamUid"]) {
            const tournamentWinnerTagTeam = (0, $14eBR.TagTeams).findOne({
                "uid": companyTournament["winnerTagTeamUid"]
            });
            if (tournamentWinnerTagTeam) await (0, $972Ip.addTagTeamWonTournaments)(tournamentWinnerTagTeam, [
                companyTournament
            ]);
            else console.log("winnerTagTeam not found when creating companyTournamentData", companyTournamentData.name, companyTournamentData.winnerTagTeamUid);
            delete companyTournament.winnerTagTeamUid;
        }
        // Add company data ids
        if (companyTournament.companiesData) {
            for(const orgId in companyTournament.companiesData)if (companyTournament.companiesData.hasOwnProperty(orgId)) {
                if (companyTournament.companiesData[orgId]["participantIds"]) {
                    const newParticipantIds = [];
                    for (const participantId of companyTournament.companiesData[orgId]["participantIds"]){
                        let participant = (0, $14eBR.Superstars).findOne({
                            "uid": participantId
                        });
                        if (participant) newParticipantIds.push(participant.$loki);
                    }
                    companyTournament.companiesData[orgId]["participantIds"] = newParticipantIds;
                }
                if (companyTournament.companiesData[orgId]["injuredParticipantId"]) {
                    let injuredParticipant = (0, $14eBR.Superstars).findOne({
                        "uid": companyTournament.companiesData[orgId]["injuredParticipantId"]
                    });
                    if (injuredParticipant) companyTournament.companiesData[orgId]["injuredParticipantId"] = injuredParticipant.$loki;
                }
            }
        }
    }
    await (0, $9esFv.addCompanyTournaments)(company, companyTournaments);
}
async function $dbc2d18ee95b9d27$var$addAnnualTournamentOrganizationIds(allCompanies) {
    const companyTournaments = await (0, $9esFv.getCompanyTournaments)(allCompanies[0]);
    for (const tournament of companyTournaments)if (tournament.companiesData) {
        for(const orgId in tournament.companiesData)if (tournament.companiesData.hasOwnProperty(orgId) && orgId !== "Indies") {
            const tournamentOrganization = allCompanies.find((x)=>{
                return x.uid === orgId;
            });
            if (tournamentOrganization) {
                tournament.companiesData[tournamentOrganization.$loki] = tournament.companiesData[orgId];
                delete tournament.companiesData[orgId];
            }
        }
    }
}
function $dbc2d18ee95b9d27$var$addSegmentConsequenceData(segment, allFactions, allChampionships, allBrands, allFeuds, allSegments, allMatches, allCompetitors) {
    if (segment["consequenceData"]) {
        if (segment["consequenceData"]["superstarUids"]) {
            let consequenceObjects = (0, $14eBR.Superstars).find({
                "uid": {
                    "$in": segment["consequenceData"]["superstarUids"]
                }
            });
            if (consequenceObjects) segment["consequenceData"]["superstarUids"] = consequenceObjects.map((x)=>x.$loki);
        }
        if (segment["consequenceData"]["factionUids"]) {
            let consequenceObjects = allFactions.filter((x)=>{
                return segment["consequenceData"]["factionUids"].includes(x.uid);
            });
            if (consequenceObjects) segment["consequenceData"]["factionUids"] = consequenceObjects.map((x)=>x.$loki);
        }
        if (segment["consequenceData"]["factionConsequenceUids"]) {
            let consequenceObjects = allFactions.filter((x)=>{
                return segment["consequenceData"]["factionConsequenceUids"].includes(x.uid);
            });
            if (consequenceObjects) segment["consequenceData"]["factionConsequenceUids"] = consequenceObjects.map((x)=>x.$loki);
        }
        if (segment["consequenceData"]["leaderUid"]) {
            let consequenceObject = (0, $14eBR.Superstars).findOne({
                "uid": segment["consequenceData"]["leaderUid"]
            });
            if (consequenceObject) segment["consequenceData"]["leaderUid"] = consequenceObject.$loki;
            else {
                console.log("object not found for segment consequenceData", segment["consequenceData"]);
                delete segment["consequenceData"]["leaderUid"];
            }
        }
        if (segment["consequenceData"]["brandUid"]) {
            let consequenceObject = allBrands.find((x)=>{
                return x.uid === segment["consequenceData"]["brandUid"];
            });
            if (consequenceObject) segment["consequenceData"]["brandUid"] = consequenceObject.$loki;
            else {
                console.log("object not found for segment consequenceData", segment["consequenceData"]);
                delete segment["consequenceData"]["brandUid"];
            }
        }
        if (segment["consequenceData"]["talentUid"]) {
            let consequenceObject = (0, $14eBR.Superstars).findOne({
                "uid": segment["consequenceData"]["talentUid"]
            });
            if (!consequenceObject) consequenceObject = (0, $14eBR.TagTeams).findOne({
                "uid": segment["consequenceData"]["talentUid"]
            });
            if (consequenceObject) segment["consequenceData"]["talentUid"] = consequenceObject.$loki;
            else {
                console.log("object not found for segment consequenceData", segment["consequenceData"]);
                delete segment["consequenceData"]["talentUid"];
            }
        }
        if (segment["consequenceData"]["competitorUid"]) {
            let consequenceObject = allCompetitors.find((x)=>{
                return x.uid === segment["consequenceData"]["competitorUid"];
            });
            if (consequenceObject) segment["consequenceData"]["competitorUid"] = consequenceObject.$loki;
            else {
                console.log("object not found for segment consequenceData", segment["consequenceData"]);
                delete segment["consequenceData"]["competitorUid"];
            }
        }
        if (segment["consequenceData"]["feudUid"]) {
            let consequenceObject = allFeuds.find((x)=>{
                return x.uid === segment["consequenceData"]["feudUid"];
            });
            if (consequenceObject) segment["consequenceData"]["feudUid"] = consequenceObject.$loki;
            else {
                console.log("object not found for segment consequenceData", segment["consequenceData"]);
                delete segment["consequenceData"]["feudUid"];
            }
        }
        if (segment["consequenceData"]["championshipUid"]) {
            let consequenceObject = allChampionships.find((x)=>{
                return x.uid === segment["consequenceData"]["championshipUid"];
            });
            if (consequenceObject) segment["consequenceData"]["championshipUid"] = consequenceObject.$loki;
            else {
                console.log("object not found for segment consequenceData", segment["consequenceData"]);
                delete segment["consequenceData"]["championshipUid"];
            }
        }
        if (segment["consequenceData"]["matchOrSegmentUid"]) {
            let matchOrSegmentType = "segment";
            let consequenceObject = allSegments.find((x)=>{
                return x.uid === segment["consequenceData"]["matchOrSegmentUid"];
            });
            if (!consequenceObject) {
                matchOrSegmentType = "match";
                consequenceObject = allMatches.find((x)=>{
                    return x.uid === segment["consequenceData"]["matchOrSegmentUid"];
                });
            }
            if (consequenceObject) {
                segment["consequenceData"]["matchOrSegmentUid"] = consequenceObject.$loki;
                segment["consequenceData"]["matchOrSegmentType"] = matchOrSegmentType;
            } else {
                console.log("object not found for segment consequenceData", segment["consequenceData"]);
                delete segment["consequenceData"]["matchOrSegmentUid"];
            }
        }
    }
}
async function $dbc2d18ee95b9d27$var$createCompanyNews(companyNewsItemsData, company) {
    let companyNewsItems = [];
    for(let i = 0; i < companyNewsItemsData.length; i++){
        const companyNewsItemData = companyNewsItemsData[i];
        const companyNewsItem = {
            ...(0, $1owiX.NewsItem)(),
            ...companyNewsItemData
        };
        (0, $14eBR.NewsItems).insert(companyNewsItem);
        companyNewsItems.push(companyNewsItem);
    }
    await (0, $9esFv.addCompanyNewsItems)(company, companyNewsItems);
}
async function $dbc2d18ee95b9d27$var$createCompanyStoryChoices(companyStoryChoicesData, company) {
    let companyStoryChoices = [];
    for(let i = 0; i < companyStoryChoicesData.length; i++){
        const companyStoryChoiceData = companyStoryChoicesData[i];
        const companyStoryChoice = {
            ...(0, $7UN4J.StoryChoice)(),
            ...companyStoryChoiceData
        };
        (0, $14eBR.StoryChoices).insert(companyStoryChoice);
        companyStoryChoices.push(companyStoryChoice);
    }
    await (0, $9esFv.addCompanyStoryChoices)(company, companyStoryChoices);
}
async function $dbc2d18ee95b9d27$var$createGameYearlyRankings(companyYearlyRankingsData, game) {
    let companyYearlyRankings = [];
    for(let i = 0; i < companyYearlyRankingsData.length; i++){
        const companyYearlyRankingData = companyYearlyRankingsData[i];
        const companyYearlyRanking = {
            ...(0, $gImaj.YearlyRanking)(),
            ...companyYearlyRankingData
        };
        (0, $14eBR.YearlyRankings).insert(companyYearlyRanking);
        companyYearlyRankings.push(companyYearlyRanking);
    }
    await (0, $dBFC4.addGameYearlyRankings)(game, companyYearlyRankings);
}
async function $dbc2d18ee95b9d27$var$createCompanyDraft(companyDraftData, allRosters, company) {
    const companyDraft = {
        ...(0, $3ZjYr.Draft)(),
        ...companyDraftData
    };
    (0, $14eBR.Drafts).insert(companyDraft);
    // Add relationships
    if (companyDraft["rosterPickOrderIds"].length > 0) {
        const draftRosters = companyDraft["rosterPickOrderIds"].map((x)=>{
            return allRosters.find((r)=>r.uid === x);
        }).filter((x)=>x);
        companyDraft.rosterPickOrderIds = draftRosters.map((x)=>x.$loki);
        if (draftRosters.length > 0) await (0, $3ZjYr.addDraftRosters)(companyDraft, draftRosters);
    }
    if (companyDraft["currentPickRosterUid"]) {
        const draftCurrentPickRoster = allRosters.find((x)=>{
            return x.uid === companyDraft.currentPickRosterUid;
        });
        if (draftCurrentPickRoster) await (0, $3ZjYr.setDraftCurrentPickRoster)(companyDraft, draftCurrentPickRoster);
        delete companyDraft.currentPickRosterUid;
    }
    if (companyDraft["protectedSuperstarsIds"].length > 0) {
        const protectedSuperstars = companyDraft["protectedSuperstarsIds"].map((x)=>{
            return (0, $14eBR.Superstars).findOne({
                uid: x
            });
        }).filter((x)=>x);
        companyDraft.protectedSuperstarsIds = protectedSuperstars.map((x)=>x.$loki);
    }
    await (0, $3ZjYr.addDraftCompanies)(companyDraft, [
        company
    ]);
}
async function $dbc2d18ee95b9d27$var$createCompanyFeudItems(companyFeudItemsData, allFeuds, company) {
    let companyFeudItems = [];
    for(let i = 0; i < companyFeudItemsData.length; i++){
        const companyFeudItemData = companyFeudItemsData[i];
        const companyFeudItem = {
            ...(0, $im36F.FeudItem)(),
            ...companyFeudItemData
        };
        (0, $14eBR.FeudItems).insert(companyFeudItem);
        companyFeudItems.push(companyFeudItem);
        // Add feuds
        const feudItemFeuds = allFeuds.filter((x)=>{
            return x["feudItemUid"] === companyFeudItemData["uid"];
        });
        if (feudItemFeuds.length > 0) await (0, $im36F.addFeudItemFeuds)(companyFeudItem, feudItemFeuds);
    }
    await (0, $9esFv.addCompanyFeudItems)(company, companyFeudItems);
}
async function $dbc2d18ee95b9d27$var$createCompanySegmentItems(companySegmentItemsData, allSegments, company) {
    let companySegmentItems = [];
    for(let i = 0; i < companySegmentItemsData.length; i++){
        const companySegmentItemData = companySegmentItemsData[i];
        const companySegmentItem = {
            ...(0, $cMrnz.SegmentItem)(),
            ...companySegmentItemData
        };
        (0, $14eBR.SegmentItems).insert(companySegmentItem);
        if (!companySegmentItem["detachedItem"]) companySegmentItems.push(companySegmentItem);
        // Add segments
        const segmentItemSegments = allSegments.filter((x)=>{
            return x["segmentItemUid"] === companySegmentItemData["uid"];
        });
        if (segmentItemSegments.length > 0) await (0, $cMrnz.addSegmentItemSegments)(companySegmentItem, segmentItemSegments);
    }
    await (0, $9esFv.addCompanySegmentItems)(company, companySegmentItems);
}
async function $dbc2d18ee95b9d27$var$createCompanyMessages(companyMessagesData, company) {
    let companyMessages = [];
    for(let i = 0; i < companyMessagesData.length; i++){
        const companyMessageData = companyMessagesData[i];
        const companyMessage = {
            ...(0, $6dDCX.Message)(),
            ...companyMessageData
        };
        (0, $14eBR.Messages).insert(companyMessage);
        if (!companyMessageData["detachedItem"]) companyMessages.push(companyMessage);
    }
    await (0, $9esFv.addCompanyMessages)(company, companyMessages);
}
async function $dbc2d18ee95b9d27$var$createCompanyPowerups(companyPowerupsData, company) {
    let companyPowerups = [];
    for(let i = 0; i < companyPowerupsData.length; i++){
        const companyPowerupData = companyPowerupsData[i];
        const companyPowerup = {
            ...(0, $dfpYx.Powerup)(),
            ...companyPowerupData
        };
        (0, $14eBR.Powerups).insert(companyPowerup);
        companyPowerups.push(companyPowerup);
    }
    await (0, $9esFv.addCompanyPowerups)(company, companyPowerups);
}
async function $dbc2d18ee95b9d27$var$createCompanyFacilities(companyFacilitiesData, company) {
    let companyFacilities = [];
    for(let i = 0; i < companyFacilitiesData.length; i++){
        const companyFacilityData = companyFacilitiesData[i];
        const companyFacility = {
            ...(0, $fQoFZ.Facility)(),
            ...companyFacilityData
        };
        (0, $14eBR.Facilities).insert(companyFacility);
        companyFacilities.push(companyFacility);
    }
    await (0, $9esFv.addCompanyFacilities)(company, companyFacilities);
}
async function $dbc2d18ee95b9d27$var$createCompanyObjectives(companyObjectivesData, company) {
    let companyObjectives = [];
    for(let i = 0; i < companyObjectivesData.length; i++){
        const companyObjectiveData = companyObjectivesData[i];
        const companyObjective = {
            ...(0, $5NNI6.Objective)(),
            ...companyObjectiveData
        };
        (0, $14eBR.Objectives).insert(companyObjective);
        companyObjectives.push(companyObjective);
        // Create properties
        await $dbc2d18ee95b9d27$var$createObjectiveProperties(companyObjectiveData["properties"], companyObjective);
        delete companyObjective.properties;
    }
    await (0, $9esFv.addCompanyObjectives)(company, companyObjectives);
}
async function $dbc2d18ee95b9d27$var$createObjectiveProperties(objectivePropertiesData, objective) {
    let objectiveProperties = [];
    for(let i = 0; i < objectivePropertiesData.length; i++){
        const objectivePropertyData = objectivePropertiesData[i];
        const objectiveProperty = {
            ...(0, $ct4m6.Property)(),
            ...objectivePropertyData
        };
        (0, $14eBR.Properties).insert(objectiveProperty);
        objectiveProperties.push(objectiveProperty);
        // Add relationships
        if (objectiveProperty["superstarUids"].length > 0) {
            const propertySuperstars = (0, $14eBR.Superstars).find({
                "uid": {
                    "$in": objectiveProperty["superstarUids"]
                }
            });
            if (propertySuperstars.length > 0) await (0, $ct4m6.addPropertySuperstars)(objectiveProperty, propertySuperstars);
            else console.log("superstar not found when creating objectivePropertyData", objectivePropertyData.name, objectivePropertyData.superstarUids);
        }
        delete objectiveProperty.superstarUids;
        if (objectiveProperty["championshipUids"].length > 0) {
            const propertyChampionships = (0, $14eBR.Championships).find({
                "uid": {
                    "$in": objectiveProperty["championshipUids"]
                }
            });
            if (propertyChampionships.length > 0) await (0, $ct4m6.addPropertyChampionships)(objectiveProperty, propertyChampionships);
            else console.log("championship not found when creating objectivePropertyData", objectivePropertyData.name, objectivePropertyData.championshipUids);
        }
        delete objectiveProperty.championshipUids;
        if (objectiveProperty["gimmickMatchUids"].length > 0) {
            const propertyGimmickMatches = (0, $14eBR.GimmickMatches).find({
                "uid": {
                    "$in": objectiveProperty["gimmickMatchUids"]
                }
            });
            if (propertyGimmickMatches.length > 0) await (0, $ct4m6.addPropertyGimmickMatches)(objectiveProperty, propertyGimmickMatches);
            else console.log("gimmickMatch not found when creating objectivePropertyData", objectivePropertyData.name, objectivePropertyData.gimmickMatchUids);
        }
        delete objectiveProperty.gimmickMatchUids;
    }
    await (0, $5NNI6.addObjectiveProperties)(objective, objectiveProperties);
}
async function $dbc2d18ee95b9d27$var$createCompanyStaff(staffData, company) {
    let staff = [];
    for(let i = 0; i < staffData.length; i++){
        const staffMember = await $dbc2d18ee95b9d27$var$createStaffMember(staffData[i]);
        staff.push(staffMember);
    }
    await (0, $9esFv.addCompanyStaff)(company, staff);
}
async function $dbc2d18ee95b9d27$var$createRosterStaff(staffData, roster) {
    let staff = [];
    for(let i = 0; i < staffData.length; i++){
        const staffMember = await $dbc2d18ee95b9d27$var$createStaffMember(staffData[i]);
        staff.push(staffMember);
    }
    await (0, $dl5u4.addRosterStaff)(roster, staff);
}
async function $dbc2d18ee95b9d27$var$createStaffMember(staffMemberData) {
    const staffMember = {
        ...(0, $5JRw3.Staff)(),
        ...staffMemberData
    };
    (0, $14eBR.StaffMembers).insert(staffMember);
    // Add superstar object if present
    if (staffMember.superstarObjectData) {
        const staffSuperstarObject = {
            ...(0, $hBIDz.Superstar)(),
            ...staffMember.superstarObjectData
        };
        (0, $14eBR.Superstars).insert(staffSuperstarObject);
        if (!(0, $98xmD.globalUser).paid) staffSuperstarObject.brandName = null;
        staffSuperstarObject.pronoun = (0, $3E8Nt.getRosterMemberPronoun)(staffSuperstarObject);
        staffSuperstarObject.possessivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(staffSuperstarObject, "possessive");
        staffSuperstarObject.objectivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(staffSuperstarObject, "objective");
        (0, $5JRw3.setStaffSuperstarObject)(staffMember, staffSuperstarObject);
        delete staffMember.superstarObjectData;
    }
    return staffMember;
}
async function $dbc2d18ee95b9d27$var$createCompanyChampionshipReigns(championshipReignsData, championship) {
    let championshipReigns = [];
    for(let i = 0; i < championshipReignsData.length; i++){
        const championshipReignData = championshipReignsData[i];
        const championshipReign = {
            ...(0, $9MKdC.ChampionshipReign)(championshipReignData["startMonth"], championshipReignData["startYear"]),
            ...championshipReignData
        };
        (0, $14eBR.ChampionshipReigns).insert(championshipReign);
        const championshipReignSuperstar = (0, $14eBR.Superstars).findOne({
            "uid": championshipReignData.superstarUid
        });
        if (championshipReignSuperstar) await (0, $hBIDz.addSuperstarChampionshipReigns)(championshipReignSuperstar, [
            championshipReign
        ]);
        else console.log("reign superstar not found when creating game", championshipReign.name, championshipReign.superstarUid);
        delete championshipReign.superstarUid;
        championshipReigns.push(championshipReign);
    }
    await (0, $ivuOU.addChampionshipChampionshipReigns)(championship, championshipReigns);
}
async function $dbc2d18ee95b9d27$var$createEventMatchContracts(eventData, companyChampionships, companyTournaments, event, newGameSettings) {
    let matchContracts = [];
    for(let i = 0; i < eventData["matchContracts"].length; i++){
        const matchContractData = eventData["matchContracts"][i];
        let matchContractTalent;
        if (matchContractData["superstarUid"]) matchContractTalent = (0, $14eBR.Superstars).findOne({
            "uid": matchContractData["superstarUid"]
        });
        if (matchContractData["tagTeamUid"]) matchContractTalent = (0, $14eBR.TagTeams).findOne({
            "uid": matchContractData["tagTeamUid"]
        });
        if (matchContractTalent || !matchContractData["superstarUid"] && !matchContractData["tagTeamUid"]) {
            const matchContract = {
                ...(0, $1AAHK.MatchContract)(),
                ...matchContractData
            };
            (0, $14eBR.MatchContracts).insert(matchContract);
            matchContracts.push(matchContract);
            if (newGameSettings) matchContract.awarded = true;
            if (matchContract["superstarUid"]) {
                await (0, $hBIDz.addSuperstarMatchContracts)(matchContractTalent, [
                    matchContract
                ]);
                delete matchContract.superstarUid;
            }
            if (matchContract["tagTeamUid"]) {
                await (0, $972Ip.addTagTeamMatchContracts)(matchContractTalent, [
                    matchContract
                ]);
                delete matchContract.tagTeamUid;
            }
            if (matchContract["championshipUid"]) {
                const foundChampionship = companyChampionships.find((x)=>{
                    return x.uid === matchContract.championshipUid;
                });
                const matchContractChampionships = companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, foundChampionship));
                for (const matchContractChampionship of matchContractChampionships)await (0, $ivuOU.addChampionshipMatchContracts)(matchContractChampionship, [
                    matchContract
                ]);
                delete matchContract.championshipUid;
            }
            if (matchContract["tournamentUid"]) {
                const matchContractTournament = companyTournaments.find((x)=>{
                    return x.uid === matchContract.tournamentUid;
                });
                if (matchContractTournament) await (0, $4EGpv.addTournamentMatchContracts)(matchContractTournament, [
                    matchContract
                ]);
                delete matchContract.tournamentUid;
            }
        } else console.log("talent not found when creating matchContract", matchContractData.name, matchContractData.superstarUid, matchContractData.tagTeamUid);
    }
    await (0, $iQtzn.addEventMatchContracts)(event, matchContracts);
}
async function $dbc2d18ee95b9d27$var$createEventStreaks(eventData, event) {
    let streaks = [];
    for(let i = 0; i < eventData["streaks"].length; i++){
        const streakData = eventData["streaks"][i];
        let streakTalent;
        if (streakData["superstarUid"]) streakTalent = (0, $14eBR.Superstars).findOne({
            "uid": streakData.superstarUid
        });
        if (streakData["tagTeamUid"]) streakTalent = (0, $14eBR.TagTeams).findOne({
            "uid": streakData.tagTeamUid
        });
        if (streakTalent) {
            const streak = {
                ...(0, $lhVvD.Streak)(),
                ...streakData
            };
            (0, $14eBR.Streaks).insert(streak);
            streaks.push(streak);
            if (streak["superstarUid"]) {
                await (0, $hBIDz.addSuperstarStreaks)(streakTalent, [
                    streak
                ]);
                delete streak.superstarUid;
            }
            if (streak["tagTeamUid"]) {
                await (0, $972Ip.addTagTeamStreaks)(streakTalent, [
                    streak
                ]);
                delete streak.tagTeamUid;
            }
        } else console.log("talent not found when creating streak", streakData);
    }
    await (0, $iQtzn.addEventStreaks)(event, streaks);
}
async function $dbc2d18ee95b9d27$export$1b15dc79c1430152({ dbUid: dbUid } = {}) {
    let data = {};
    await (0, $14eBR.deleteDb)(dbUid);
    (0, $98xmD.globals).game.id = null;
    $dbc2d18ee95b9d27$export$7a60f90c88676f7f(dbUid);
    return data;
}
async function $dbc2d18ee95b9d27$export$e5245eae479fa0a() {
    let allGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
    // Don't get scenario games todo test that scenarios don't appear here
    let activeGames = allGames.filter((x)=>!x.scenarioId);
    // Sort by last played
    activeGames.sort((a, b)=>b.datetimeLastPlayed - a.datetimeLastPlayed || b.$loki - a.$loki);
    // Limit free user's games shown
    if (!(0, $98xmD.globalUser).paid) activeGames = activeGames.slice(0, 1);
    // Get last played
    for (let x of activeGames)if (x.datetimeLastPlayed) x.lastPlayed = (0, $3E8Nt.getTimeDiffHuman)(x.datetimeLastPlayed, new Date()) + " ago";
    return activeGames;
}
async function $dbc2d18ee95b9d27$export$8e8e164d89554a8d(game) {
    // Get game's attributes
    let gameData = {
        uid: game.$loki,
        name: game.name,
        editName: game.editName,
        settings: game.settings,
        scenarioId: game.scenarioId,
        datetimeLastPlayed: game.datetimeLastPlayed
    };
    // Get main user company's name
    const gameCompanies = await (0, $dBFC4.getGameCompanies)(game);
    const userCompany = gameCompanies.find((x)=>x.userControlled);
    gameData.companyName = userCompany.name;
    gameData.storyName = userCompany.storyName;
    // Get display month/year
    [gameData.month, gameData.year] = $dbc2d18ee95b9d27$export$336804f18a0452c1(game.monthCount, 0, game.year, true);
    gameData.year += 1;
    // Get player names for local multiplayer
    if (game.settings.control_multiple_companies) {
        const userControlledCompanies = gameCompanies.filter((x)=>x.userControlled);
        gameData.playerNames = userControlledCompanies.map((x)=>x.playerName);
    }
    // Get next event's name
    let userCompanyEvents = await (0, $9esFv.getCompanyEvents)(userCompany);
    if (userCompanyEvents) gameData.nextEventName = userCompanyEvents[userCompanyEvents.length - 1].name;
    return gameData;
}
function $dbc2d18ee95b9d27$export$336804f18a0452c1(month, addMonths = 0, year = null, calendar = false) {
    let endMonth = calendar ? 12 : 11;
    let nextMonth = month + 1;
    if (month === endMonth) {
        nextMonth = 0;
        if (year !== null) year += 1;
    }
    if (addMonths === 0) {
        if (year !== null) return [
            nextMonth,
            year
        ];
        return nextMonth;
    } else return $dbc2d18ee95b9d27$export$336804f18a0452c1(nextMonth, addMonths - 1, year, calendar);
}
async function $dbc2d18ee95b9d27$export$8a53f38bace97ef6(game) {
    // Get current company (for local multiplayer)
    if (game.currentCompanyId) return (0, $dBFC4.getGameCurrentCompany)(game);
    // Otherwise get first user controlled company
    const gameCompanies = await (0, $dBFC4.getGameCompanies)(game);
    return gameCompanies.find((x)=>x.userControlled);
}
async function $dbc2d18ee95b9d27$export$ad29dd9dcc3f674d(game) {
    // Get first user company
    const gameCompanies = await (0, $dBFC4.getGameCompanies)(game);
    return gameCompanies.find((x)=>x.userControlled);
}
async function $dbc2d18ee95b9d27$export$ab76722cedbd9375(game) {
    // Get companies that don't have 'Inactive' status
    const allCompanies = await (0, $dBFC4.getGameCompanies)(game);
    return allCompanies.filter((x)=>x.operatingStatus !== "Inactive");
}
async function $dbc2d18ee95b9d27$export$e1a2fad8b5ce4e7e(game) {
    let data = {};
    let company = await $dbc2d18ee95b9d27$export$8a53f38bace97ef6(game);
    let saveDatabase = false;
    let mainCompany = await $dbc2d18ee95b9d27$export$ad29dd9dcc3f674d(game);
    let annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
    // Process forming new company
    try {
        if (company.newCompanyData?.monthsToForm !== undefined) {
            if (company.newCompanyData.monthsToForm <= 0 && ![
                "selecting",
                "running"
            ].includes(annualTournament?.status)) {
                await (0, $8A6FL.formNewCompany)();
                saveDatabase = true;
                company = await $dbc2d18ee95b9d27$export$8a53f38bace97ef6(game);
                mainCompany = await $dbc2d18ee95b9d27$export$ad29dd9dcc3f674d(game);
                annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
                // Save to local storage
                await $dbc2d18ee95b9d27$export$e052c844ba0621d4(game);
            }
        }
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
        await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
    }
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(company);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
    const user = (0, $bZol7.loadUser)();
    // Get event card data
    let eventCardData = await (0, $5ZsVo.getEventCardData)();
    data["eventData"] = eventCardData["eventData"];
    data["maximumMatchesAndSegments"] = eventCardData["maximumMatchesAndSegments"];
    data["minimumMatchesAndSegments"] = eventCardData["minimumMatchesAndSegments"];
    data["matchesAndSegments"] = eventCardData["matchesAndSegments"];
    // Get dialogs for Passion of Wrestling story
    if (mainCompany.storyName === "passion") {
        // Get introduction dialog
        if (game.monthCount === 0 && game.year === 0) data["showPowIntroduction"] = true;
        // Get reaction dialogs
        data["powReactionDialogs"] = await (0, $jC7EP.getPowProducerReactionDialogs)(company);
        // Check if story failed
        const powFailureEnding = (await (0, $9esFv.getCompanyStoryChoices)(company)).find((x)=>x.choice === "failure_ending");
        data["powStoryFailureEnding"] = !!powFailureEnding;
    }
    // Get state for tutorial
    if (mainCompany.storyName === "tutorial") data["tutorialState"] = await (0, $8A6FL.getTutorialStateName)(mainCompany);
    // Check for Running Buyout status in companies
    let [runningBuyout, companyToBuyout] = await (0, $8A6FL.runningBuyoutCheck)(company, game);
    if (runningBuyout) data["buyoutData"] = await (0, $8A6FL.getBuyoutData)(companyToBuyout, company);
    // Check for forming new company
    if (company.newCompanyData?.monthsToForm !== undefined) {
        data["newCompanyData"] = company.newCompanyData;
        if (data["newCompanyData"]["monthsToForm"] === 1) data["newCompanyData"]["selectionsData"] = await (0, $8A6FL.getNewCompanySelectionsData)(company);
    }
    // Check for yearly updates
    if ((0, $8A6FL.getCompanyMonth)(company, game) === 0 && !company.yearlyCheckRun) try {
        await (0, $8A6FL.processSuperstarsYearlyChanges)(company);
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    // Get game data
    data["monthCount"] = game.monthCount;
    data["companyMonth"] = (0, $8A6FL.getCompanyMonth)(company, game);
    data["year"] = game.year;
    data["competitorsPresent"] = game.competitorsPresent;
    data["awardsRun"] = game.awardsRun;
    data["gameSettings"] = game.settings;
    data["userSettings"] = user ? user.settings : {};
    data["marketSize"] = game.marketSize;
    // Get company data
    data["companyName"] = company.name;
    data["currentMonth"] = await (0, $8A6FL.getCurrentMonth)(company, parentEvents);
    data["realYear"] = company.realYear;
    data["style"] = company.style;
    data["points"] = company.points;
    data["fans"] = company.fans;
    data["reputation"] = company.reputation;
    data["story"] = company.storyName;
    data["owner"] = company.ownerName;
    data["trainingCallupRun"] = company.trainingCallupRun;
    data["playerName"] = company.playerName;
    // Get random events that are current and have choices not entered
    const randomEvents = (await (0, $9esFv.getCompanyRandomEvents)(company)).filter((x)=>x.monthsRemaining > 0 && x.choices.length && !x.selectedChoice);
    data["randomEvents"] = await Promise.all(randomEvents.map((x)=>(0, $2A9WA.getRandomEventData)(x)));
    // Get trade offers
    const receivedTradeOffers = await (0, $9esFv.getCompanyReceivedTradeOffers)(company);
    data["tradeOffers"] = await Promise.all(receivedTradeOffers.map((x)=>(0, $aynj3.getTradeOfferData)(x)));
    // Get talent offers
    data["talentOffers"] = [];
    const acceptedNegotiations = (await (0, $9esFv.getCompanyReceivedNegotiations)(company)).filter((x)=>x.status === "accepted_by_talent");
    for (const acceptedNegotiation of acceptedNegotiations){
        const negotiationTalent = await (0, $csISS.getNegotiationTalent)(acceptedNegotiation);
        if (negotiationTalent && (await (0, $5kTkA.getRosterMemberSuperstars)(negotiationTalent)).length) // Don't show multiple offers separately
        {
            if (!data["talentOffers"].some((x)=>x["name"] === negotiationTalent.name)) data["talentOffers"].push(await (0, $3NAMH.getTalentOfferData)(acceptedNegotiation));
        } else {
            await (0, $14eBR.Negotiations).remove(acceptedNegotiation); // For compatibility with old games
            saveDatabase = true;
        }
    }
    // Get created talent requests
    try {
        const companyTalentRequests = await (0, $9esFv.getCompanyTalentRequests)(company);
        data["talentRequestsData"] = [];
        const createdTalentRequests = companyTalentRequests.filter((x)=>x.status === "created");
        for (const createdTalentRequest of createdTalentRequests)data["talentRequestsData"].push(await (0, $1olyO.getTalentRequestData)(createdTalentRequest));
        // Delete finished talent requests, get data for major ones
        const finishedTalentRequests = companyTalentRequests.filter((x)=>x.status === "completed" || x.status === "failed");
        if (!data["randomEvents"].length && !data["talentOffers"].length && !data["tradeOffers"].length && !data["buyoutData"] && !(game.monthCount === 10 && game.competitorsPresent && !game.awardsRun) && !(data.newCompanyData?.monthsToForm === 2 && !data.newCompanyData?.companyDetails) && !(data.newCompanyData?.monthsToForm === 1 && !data.newCompanyData?.talentDetails)) for (const finishedTalentRequest of finishedTalentRequests){
            if ((0, $knp8C.talentRequestsData)[finishedTalentRequest.type]["importance"] === "major") data["talentRequestsData"].push(await (0, $1olyO.getTalentRequestData)(finishedTalentRequest));
            await (0, $14eBR.TalentRequests).remove(finishedTalentRequest);
            saveDatabase = true;
        }
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    // Set news month/year
    game.newsMonth = game.monthCount;
    game.newsYear = game.year;
    // Available callups message
    let availableCallupsMessage = await (0, $hekDR.checkForAvailableCallupsMessage)(company, game);
    if (availableCallupsMessage) {
        await (0, $9esFv.addCompanyMessages)(company, [
            availableCallupsMessage
        ]);
        saveDatabase = true;
    }
    // Delete old messages
    let messagesToDelete = (await (0, $9esFv.getCompanyMessages)(company)).filter((x)=>(0, $3E8Nt.getMonthsDifference)(game.monthCount, game.year, x.month, x.year) > 4);
    for (let message of messagesToDelete){
        await (0, $14eBR.Messages).remove(message);
        saveDatabase = true;
    }
    // Process yearly rankings in January
    try {
        if (company === mainCompany && data["currentMonth"] === 0 && !latestEvent.weeklyShow && latestEvent.name !== "Weekly Show" && !latestEvent.temporaryEvent && !(game.year === 0 && game.monthCount === 0)) data["yearlyRankingData"] = await (0, $66ItE.processYearlyRanking)(game, mainCompany);
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    // Get annual tournament data
    if (annualTournament) data["annualTournamentData"] = await (0, $18vSN.getAnnualTournamentData)(annualTournament, company, mainCompany, game);
    // Get draft data if running
    let draft = await (0, $9esFv.getCompanyDraft)(company);
    if (draft && !draft.postEndRun) data["draftData"] = await (0, $lueZ1.getDraftData)(draft, company);
    // Objectives review and messages
    try {
        if (!data["draftData"]) {
            let reviewData = await (0, $8A6FL.reviewObjectives)(company, game);
            let objectivesMessage = await (0, $hekDR.checkToAddCurrentObjectivesMessage)(company);
            if (objectivesMessage) await (0, $9esFv.addCompanyMessages)(company, [
                objectivesMessage
            ]);
            if (reviewData["numberOfCompletedObjectives"]) saveDatabase = true;
        }
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    if (saveDatabase) (0, $14eBR.db).saveDatabase();
    // Get dashboard data
    try {
        data["dashboardData"] = await (0, $fPpxU.getDashboardData)(company, game);
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    // Get unread messages
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(company);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $dbc2d18ee95b9d27$export$4855fe878311d2a5(game) {
    // Set global game id
    (0, $98xmD.globals).game.id = game.$loki;
    // Update datetime last played
    game.datetimeLastPlayed = Date.now();
    (0, $14eBR.db).saveDatabase();
    return game;
}
async function $dbc2d18ee95b9d27$export$4ae8a26083d03e92() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const user = (0, $bZol7.loadUser)();
    if (!currentGame) return data;
    data["numberOfWeeklyShows"] = currentGame.numberOfWeeklyShows;
    data["userSettings"] = user ? user.settings : {};
    data["gameSettings"] = currentGame.settings;
    data["dateTimeLastCloudSave"] = currentGame.dateTimeLastCloudSave;
    return data;
}
async function $dbc2d18ee95b9d27$export$2922acf9d11e6a45(value) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await $dbc2d18ee95b9d27$export$8a53f38bace97ef6(currentGame);
    // Return error if upcoming event is weekly show
    const upcomingEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    if (upcomingEvent.weeklyShow || upcomingEvent.name === "Weekly Show") {
        data["error"] = "weekly-show";
        data["numberOfWeeklyShows"] = currentGame.numberOfWeeklyShows;
        return data;
    }
    // Check if no companies have ended their turn in local multiplayer
    if (currentGame.settings["control_multiple_companies"]) {
        const userControlledCompanies = await $dbc2d18ee95b9d27$export$16575f22c425a52a(currentGame);
        const userControlledCompaniesEnded = userControlledCompanies.filter((x)=>x.turnStatus === "ended");
        if (userControlledCompaniesEnded.length > 0) {
            data["error"] = "turn-ended";
            data["numberOfWeeklyShows"] = currentGame.numberOfWeeklyShows;
            return data;
        }
    }
    // Change number of weekly shows
    if (value !== null && value >= 0 && value <= 4) {
        currentGame.numberOfWeeklyShows = value;
        (0, $14eBR.db).saveDatabase();
    }
    return data;
}
async function $dbc2d18ee95b9d27$export$16575f22c425a52a(game) {
    // Get all user controlled companies
    const gameActiveCompanies = await $dbc2d18ee95b9d27$export$ab76722cedbd9375(game);
    return gameActiveCompanies.filter((x)=>x.userControlled);
}
async function $dbc2d18ee95b9d27$export$8cd29ced70f92e2(settingName, settingValue) {
    let data = {};
    const user = (0, $bZol7.loadUser)();
    // Change user setting
    if (user) {
        user.settings[settingName] = settingValue;
        (0, $bZol7.saveUser)(user);
        data["userSettings"] = user.settings;
    } else data["error"] = "not-logged-in";
    return data;
}
async function $dbc2d18ee95b9d27$export$8ef63851d5addd8d({ setting: setting } = {}) {
    let data = {};
    const user = (0, $bZol7.loadUser)();
    // Change user setting
    if (user) {
        user.settings["matchResult"] = setting;
        (0, $bZol7.saveUser)(user);
    }
    return data;
}
async function $dbc2d18ee95b9d27$export$756a040b6d411621(settingName, settingValue) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    if (settingName === "sandbox_mode_enabled") {
        data["error"] = "change-not-allowed";
        return data;
    }
    // Change user setting
    if (currentGame) {
        currentGame.settings[settingName] = settingValue;
        (0, $14eBR.db).saveDatabase();
        data["gameSettings"] = currentGame.settings;
    } else data["error"] = "game-not-found";
    return data;
}
async function $dbc2d18ee95b9d27$export$801fe16824f675f7({}) {
    const user = (0, $bZol7.loadUser)();
    let data = JSON.parse(JSON.stringify(user));
    data["talentRequestTypesCompletedData"] = [];
    for (const requestType of user.talentRequestTypesCompleted){
        let requestData = (0, $knp8C.talentRequestsData)[requestType];
        if (requestData) data["talentRequestTypesCompletedData"].push(requestData["display_name"]);
    }
    data["talentRequestTypesCompletedData"].sort();
    data["talentRequestTypesTotal"] = Object.keys((0, $knp8C.talentRequestsData)).length;
    return data;
}
async function $dbc2d18ee95b9d27$export$e052c844ba0621d4(game, dbUid) {
    let jowGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
    if (!dbUid) dbUid = (0, $14eBR.db).filename;
    let gameSaveData = await $dbc2d18ee95b9d27$export$8e8e164d89554a8d(game);
    gameSaveData["dbUid"] = dbUid;
    let gameDataIndex = jowGames.findIndex((x)=>x.dbUid === dbUid);
    if (gameDataIndex >= 0) jowGames[gameDataIndex] = gameSaveData;
    else jowGames.push(gameSaveData);
    window.localStorage.setItem("jowGames", JSON.stringify(jowGames));
}
function $dbc2d18ee95b9d27$export$7a60f90c88676f7f(dbUid) {
    let jowGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
    jowGames = jowGames.filter((x)=>x.dbUid !== dbUid);
    window.localStorage.setItem("jowGames", JSON.stringify(jowGames));
}
async function $dbc2d18ee95b9d27$export$3f925be9d00b40bf(gameData, gameSettings) {
    // Create db for game
    let dbUid = self.crypto.randomUUID ? self.crypto.randomUUID() : (0, $3E8Nt.generateUUID)();
    await (0, $14eBR.loadDb)(dbUid);
    // Create game from data
    const createdGame = await $dbc2d18ee95b9d27$export$9c1a45fa87f90634(gameData, gameSettings);
    // Set datetimeLastPlayed and save
    await $dbc2d18ee95b9d27$export$4855fe878311d2a5(createdGame);
    // Save to local storage
    await $dbc2d18ee95b9d27$export$e052c844ba0621d4(createdGame, dbUid);
    return createdGame;
}
async function $dbc2d18ee95b9d27$export$60c5f108ca6199dd(game) {
    let company = await $dbc2d18ee95b9d27$export$ad29dd9dcc3f674d(game);
    // Remove staff
    for (let staffMember of (await (0, $9esFv.getCompanyStaff)(company)))await (0, $14eBR.StaffMembers).remove(staffMember);
    // Downgrade facilities
    for (let facility of (await (0, $9esFv.getCompanyFacilities)(company)))facility.level = 1;
    // Remove unlockable feud/segment items
    let unlockableFeudItems = (0, $5esHg.standardFeudItemsData).filter((x)=>!x.unlocked).map((x)=>x.name);
    let unlockableSegmentItems = (0, $l4Fms.standardSegmentItemsData).filter((x)=>!x.unlocked).map((x)=>x.name);
    for (let feudItem of (await (0, $9esFv.getCompanyFeudItems)(company)).filter((x)=>x.unlocked))if (unlockableFeudItems.includes(feudItem.name)) feudItem.unlocked = false;
    for (let segmentItem of (await (0, $9esFv.getCompanySegmentItems)(company)).filter((x)=>x.unlocked))if (unlockableSegmentItems.includes(segmentItem.name)) segmentItem.unlocked = false;
    // Remove custom segments
    for (let segmentItem of (await (0, $9esFv.getCompanySegmentItems)(company)).filter((x)=>x.custom))await (0, $9esFv.removeCompanySegmentItems)(company, [
        segmentItem
    ]);
    // Remove unlocked powerups
    for (let powerup of (await (0, $9esFv.getCompanyPowerups)(company)))if ([
        "Neural Control",
        "Neural Control+",
        "Cyborg"
    ].includes(powerup.name)) await (0, $14eBR.Powerups).remove(powerup);
    // Remove brands
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    if (rosterBrands.length) {
        let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        let companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
        let parentEvents = await (0, $8A6FL.getCompanyParentEvents)(company);
        let latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
        for (let brand of rosterBrands){
            await (0, $dl5u4.removeRosterBrands)(mainRoster, [
                brand
            ]);
            for (const x of [
                ...rosterSuperstars,
                ...parentEvents,
                ...companyChampionships
            ])if (x.brandName === brand.name) (0, $1Dp0h.removeObjectBrand)(x);
            if (!latestEvent.weeklyShow) {
                if (latestEvent.brandName === brand.name) (0, $1Dp0h.removeObjectBrand)(latestEvent);
            }
        }
    }
    (0, $14eBR.db).saveDatabase();
}
async function $dbc2d18ee95b9d27$export$ac914e869fda317f(game) {
    let company = await $dbc2d18ee95b9d27$export$ad29dd9dcc3f674d(game);
    // Add staff
    let companyStaff = [];
    for (let role of (0, $3E8Nt.staffRoles)){
        let staffMember = await (0, $8bQDO.generateStaffMember)(role, 1);
        await (0, $9esFv.addCompanyStaff)(company, [
            staffMember
        ]);
        companyStaff.push(staffMember);
    }
    for (let facility of (await (0, $9esFv.getCompanyFacilities)(company)))facility.staffNeverHired = false;
    // Add staff messages
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let mainRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    let doctor = companyStaff.find((x)=>x.role === "doctor");
    let newMessage = await (0, $hekDR.createNewCompanyDoctorMessage)(mainRosterSuperstars.filter((x)=>x.injured), 0, 0, doctor);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    let trainer = companyStaff.find((x)=>x.role === "trainer");
    newMessage = await (0, $hekDR.createNewCompanyTrainerMessage)(0, 0, trainer);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    let scout = companyStaff.find((x)=>x.role === "scout");
    newMessage = await (0, $hekDR.createNewCompanyScoutMessage)(0, 0, scout);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    let producer = companyStaff.find((x)=>x.role === "producer");
    newMessage = await (0, $hekDR.createNewCompanyProducerMessage)(0, 0, producer);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    let talentManager = companyStaff.find((x)=>x.role === "talent_manager");
    newMessage = await (0, $hekDR.createNewCompanyTalentManagerMessage)(0, 0, talentManager);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    (0, $14eBR.db).saveDatabase();
}

});
parcelRequire.register("eSlDe", function(module, exports) {

$parcel$export(module.exports, "Scenario", () => $ad46e377cd6cd825$export$bbb5fc28f977b7af);
$parcel$export(module.exports, "getScenarioGame", () => $ad46e377cd6cd825$export$8189aed1ca212c83);
$parcel$export(module.exports, "setScenarioGame", () => $ad46e377cd6cd825$export$a60eff7f1e62a335);

var $14eBR = parcelRequire("14eBR");
function $ad46e377cd6cd825$export$bbb5fc28f977b7af() {
    // Strings
    const name = null;
    const description = null;
    const creator = null;
    const comments = null;
    // Integer
    const version = null;
    const editVersion = null;
    // Boolean
    const softDelete = false;
    const edit = false;
    // Arrays
    const contributorScenarios = [];
    // Foreign keys
    const originalScenarioId = null;
    return {
        name: name,
        description: description,
        creator: creator,
        comments: comments,
        version: version,
        softDelete: softDelete,
        contributorScenarios: contributorScenarios,
        originalScenarioId: originalScenarioId,
        edit: edit,
        editVersion: editVersion
    };
}
function $ad46e377cd6cd825$export$db3cf62e8c3b3069(scenario) {
    return (0, $14eBR.Scenarios).find({
        "originalScenarioId": scenario.$loki
    });
}
function $ad46e377cd6cd825$export$95abe49affc53bb(scenario, scenarios) {
    scenarios.forEach((c)=>{
        c.originalScenarioId = scenario.$loki;
    });
}
function $ad46e377cd6cd825$export$66f9a095907d513d(scenario, scenarios) {
    scenarios.forEach((c)=>{
        c.originalScenarioId = null;
    });
}
function $ad46e377cd6cd825$export$db554adcc38d5b4f(scenario) {
    return (0, $14eBR.Scenarios).find({
        "$loki": scenario.originalScenarioId
    })[0];
}
function $ad46e377cd6cd825$export$8189aed1ca212c83(scenario) {
    return (0, $14eBR.Games).find({
        "scenarioId": scenario.$loki
    })[0];
}
function $ad46e377cd6cd825$export$a60eff7f1e62a335(scenario, game) {
    game.scenarioId = scenario.$loki;
}
function $ad46e377cd6cd825$export$3d05aa4dfac9d9e5(scenario, game) {
    game.scenarioId = null;
}

});

parcelRequire.register("iQtzn", function(module, exports) {

$parcel$export(module.exports, "Event", () => $db8405382de6e90d$export$d61e24a684f9e51);
$parcel$export(module.exports, "addEventMatches", () => $db8405382de6e90d$export$cbd572d6721c0d5a);
$parcel$export(module.exports, "getEventMatches", () => $db8405382de6e90d$export$6958a9b4e173f702);
$parcel$export(module.exports, "getEventCompany", () => $db8405382de6e90d$export$d65cbbb81cf9d966);
$parcel$export(module.exports, "addChildEvent", () => $db8405382de6e90d$export$a8880caf3dd203c6);
$parcel$export(module.exports, "getChildEvents", () => $db8405382de6e90d$export$49ed1b9ec5e7e48c);
$parcel$export(module.exports, "getParentEvent", () => $db8405382de6e90d$export$6bceca2da3a7c15d);
$parcel$export(module.exports, "addEventMatchContracts", () => $db8405382de6e90d$export$88513dc220b96b3);
$parcel$export(module.exports, "getEventMatchContracts", () => $db8405382de6e90d$export$3b618599bb888699);
$parcel$export(module.exports, "addEventStreaks", () => $db8405382de6e90d$export$b8f17d707b4aa64a);
$parcel$export(module.exports, "removeEventStreaks", () => $db8405382de6e90d$export$b8ed65c65e6e5a7a);
$parcel$export(module.exports, "getEventStreaks", () => $db8405382de6e90d$export$cf7b35a1c5fa678);
$parcel$export(module.exports, "addEventTournaments", () => $db8405382de6e90d$export$e510ac88d500216f);
$parcel$export(module.exports, "getEventTournaments", () => $db8405382de6e90d$export$6d208d54a2675841);
$parcel$export(module.exports, "addEventSegments", () => $db8405382de6e90d$export$e9af96408ba92644);
$parcel$export(module.exports, "getEventSegments", () => $db8405382de6e90d$export$6b7ebf8621851fff);

var $14eBR = parcelRequire("14eBR");
function $db8405382de6e90d$export$d61e24a684f9e51(name) {
    // String
    const activeEffect = null;
    const monthlyEventName = null;
    const weeklyShowBeforeName = null;
    const weeklyShowAfterName = null;
    const brandName = null;
    const prestige = "C";
    const objectName = "event";
    // Integer
    const matchesCount = 0;
    const year = null;
    const month = null;
    const pointsEarned = null;
    const fansGained = null;
    const xp = 0;
    const hype = 0;
    const nextEventBoost = 0;
    const viewership = null;
    const totalFans = null;
    // Float
    const rating = null;
    // Numeric
    const weekNumber = null;
    // Boolean
    const weeklyShow = false;
    const temporaryEvent = null;
    // Objects
    const posterGraphic = {};
    // Foreign keys
    const companyId = null;
    const parentId = null;
    return {
        name: name,
        activeEffect: activeEffect,
        monthlyEventName: monthlyEventName,
        weeklyShowBeforeName: weeklyShowBeforeName,
        weeklyShowAfterName: weeklyShowAfterName,
        brandName: brandName,
        prestige: prestige,
        matchesCount: matchesCount,
        year: year,
        month: month,
        pointsEarned: pointsEarned,
        fansGained: fansGained,
        xp: xp,
        hype: hype,
        nextEventBoost: nextEventBoost,
        viewership: viewership,
        totalFans: totalFans,
        rating: rating,
        weekNumber: weekNumber,
        weeklyShow: weeklyShow,
        temporaryEvent: temporaryEvent,
        posterGraphic: posterGraphic,
        companyId: companyId,
        parentId: parentId,
        objectName: objectName
    };
}
function $db8405382de6e90d$export$cbd572d6721c0d5a(event, matches) {
    matches.forEach((c)=>{
        c.eventId = event.$loki;
    });
}
function $db8405382de6e90d$export$e5db56ecde0e2f35(event, matches) {
    matches.forEach((c)=>{
        c.eventId = null;
    });
}
function $db8405382de6e90d$export$6958a9b4e173f702(event) {
    return (0, $14eBR.Matches).find({
        "eventId": event.$loki
    });
}
function $db8405382de6e90d$export$d65cbbb81cf9d966(event) {
    return (0, $14eBR.Companies).find({
        "$loki": event.companyId
    })[0];
}
function $db8405382de6e90d$export$a8880caf3dd203c6(event, childEvent) {
    childEvent.parentId = event.$loki;
}
function $db8405382de6e90d$export$ff39bca046f350cc(event, childEvent) {
    childEvent.parentId = null;
}
function $db8405382de6e90d$export$49ed1b9ec5e7e48c(event) {
    return (0, $14eBR.Events).find({
        "parentId": event.$loki
    });
}
function $db8405382de6e90d$export$6bceca2da3a7c15d(event) {
    if (!event.parentId) return;
    return (0, $14eBR.Events).find({
        "$loki": event.parentId
    })[0];
}
function $db8405382de6e90d$export$88513dc220b96b3(event, matchContracts) {
    matchContracts.forEach((c)=>{
        c.eventId = event.$loki;
    });
}
function $db8405382de6e90d$export$bbb3321613201fbc(event, matchContracts) {
    matchContracts.forEach((c)=>{
        c.eventId = null;
    });
}
function $db8405382de6e90d$export$3b618599bb888699(event) {
    return (0, $14eBR.MatchContracts).find({
        "eventId": event.$loki
    });
}
function $db8405382de6e90d$export$b8f17d707b4aa64a(event, streaks) {
    streaks.forEach((c)=>{
        c.eventId = event.$loki;
    });
}
function $db8405382de6e90d$export$b8ed65c65e6e5a7a(event, streaks) {
    streaks.forEach((c)=>{
        c.eventId = null;
    });
}
function $db8405382de6e90d$export$cf7b35a1c5fa678(event) {
    return (0, $14eBR.Streaks).find({
        "eventId": event.$loki
    });
}
function $db8405382de6e90d$export$e510ac88d500216f(event, tournaments) {
    tournaments.forEach((c)=>{
        c.eventId = event.$loki;
    });
}
function $db8405382de6e90d$export$a1354457e2fa5343(event, tournaments) {
    tournaments.forEach((c)=>{
        c.eventId = null;
    });
}
function $db8405382de6e90d$export$6d208d54a2675841(event) {
    return (0, $14eBR.Tournaments).find({
        "eventId": event.$loki
    });
}
function $db8405382de6e90d$export$e9af96408ba92644(event, segments) {
    segments.forEach((c)=>{
        c.eventId = event.$loki;
    });
}
function $db8405382de6e90d$export$b72343fbdc95e86d(event, segments) {
    segments.forEach((c)=>{
        c.eventId = null;
    });
}
function $db8405382de6e90d$export$6b7ebf8621851fff(event) {
    return (0, $14eBR.Segments).find({
        "eventId": event.$loki
    });
}

});

parcelRequire.register("ivuOU", function(module, exports) {

$parcel$export(module.exports, "Championship", () => $d793077b2bd5be27$export$9b850933a0d49fcc);
$parcel$export(module.exports, "getChampionshipSuperstar", () => $d793077b2bd5be27$export$a32da29e72b75013);
$parcel$export(module.exports, "getChampionshipCompany", () => $d793077b2bd5be27$export$3c415d787af0f0e9);
$parcel$export(module.exports, "addChampionshipChampionshipReigns", () => $d793077b2bd5be27$export$d842ca92c6e67cce);
$parcel$export(module.exports, "getChampionshipChampionshipReigns", () => $d793077b2bd5be27$export$794133692fecada2);
$parcel$export(module.exports, "getChampionshipCurrentReign", () => $d793077b2bd5be27$export$6baf5dd0409c83f3);
$parcel$export(module.exports, "addChampionshipMatchContracts", () => $d793077b2bd5be27$export$c2b6cb6e98865554);
$parcel$export(module.exports, "getChampionshipMatchContracts", () => $d793077b2bd5be27$export$4047174b2f4c86d3);
$parcel$export(module.exports, "getChampionshipMatchContract", () => $d793077b2bd5be27$export$eee952871fcfc868);
$parcel$export(module.exports, "addChampionshipRandomEvents", () => $d793077b2bd5be27$export$49ee887b522a2d61);

var $14eBR = parcelRequire("14eBR");
function $d793077b2bd5be27$export$9b850933a0d49fcc(name, vacated = false, tagTeam = false) {
    // Strings
    const rank = null;
    const gender = "male";
    const prestige = "C";
    const highestPrestige = "C";
    const brandName = null;
    const objectName = "championship";
    // Integer
    const monthsToExpire = null;
    const xp = 0;
    const xpGainedThisYear = 0;
    // Boolean
    const booked = false;
    const trio = false;
    const championshipContract = false;
    const matchContract = false;
    const retired = false;
    // Foreign keys
    const superstarId = null;
    const matchId = null;
    const companyId = null;
    const propertyId = null;
    const tournamentId = null;
    // Objects
    const gimmickRestriction = null;
    const graphic = null;
    return {
        name: name,
        rank: rank,
        gender: gender,
        prestige: prestige,
        highestPrestige: highestPrestige,
        brandName: brandName,
        monthsToExpire: monthsToExpire,
        xp: xp,
        xpGainedThisYear: xpGainedThisYear,
        booked: booked,
        tagTeam: tagTeam,
        trio: trio,
        championshipContract: championshipContract,
        matchContract: matchContract,
        vacated: vacated,
        retired: retired,
        superstarId: superstarId,
        matchId: matchId,
        companyId: companyId,
        propertyId: propertyId,
        tournamentId: tournamentId,
        gimmickRestriction: gimmickRestriction,
        graphic: graphic,
        objectName: objectName
    };
}
function $d793077b2bd5be27$export$a32da29e72b75013(championship) {
    if (championship.superstarId) return (0, $14eBR.Superstars).find({
        "$loki": championship.superstarId
    })[0];
    else return null;
}
function $d793077b2bd5be27$export$9be28f7a62b10d97(championship) {
    return (0, $14eBR.Matches).find({
        "$loki": championship.matchId
    })[0];
}
function $d793077b2bd5be27$export$3c415d787af0f0e9(championship) {
    return (0, $14eBR.Companies).find({
        "$loki": championship.companyId
    })[0];
}
function $d793077b2bd5be27$export$d842ca92c6e67cce(championship, championshipReigns) {
    championshipReigns.forEach((c)=>{
        c.championshipId = championship.$loki;
    });
}
function $d793077b2bd5be27$export$5ad6e10afe0d74ca(championship, championshipReigns) {
    championshipReigns.forEach((c)=>{
        c.championshipId = null;
    });
}
function $d793077b2bd5be27$export$794133692fecada2(championship) {
    return (0, $14eBR.ChampionshipReigns).find({
        "championshipId": championship.$loki
    });
}
function $d793077b2bd5be27$export$6baf5dd0409c83f3(championship) {
    return (0, $14eBR.ChampionshipReigns).find({
        "championshipId": championship.$loki
    }).reverse()[0];
}
function $d793077b2bd5be27$export$7b3aa98a5cb03b1d(championship) {
    return (0, $14eBR.Properties).find({
        "$loki": championship.propertyId
    })[0];
}
function $d793077b2bd5be27$export$c2b6cb6e98865554(championship, matchContracts) {
    matchContracts.forEach((c)=>{
        c.championshipId = championship.$loki;
    });
}
function $d793077b2bd5be27$export$f960b0954985c3f3(championship, matchContracts) {
    matchContracts.forEach((c)=>{
        c.championshipId = null;
    });
}
function $d793077b2bd5be27$export$4047174b2f4c86d3(championship) {
    return (0, $14eBR.MatchContracts).find({
        "championshipId": championship.$loki
    });
}
function $d793077b2bd5be27$export$eee952871fcfc868(championship) {
    return (0, $14eBR.MatchContracts).find({
        "championshipId": championship.$loki
    })[0];
}
function $d793077b2bd5be27$export$312da801cb6d83fb(championship) {
    return (0, $14eBR.Tournaments).find({
        "$loki": championship.tournamentId
    })[0];
}
function $d793077b2bd5be27$export$49ee887b522a2d61(championship, randomEvents) {
    randomEvents.forEach((c)=>{
        c.championshipId = championship.$loki;
    });
}
function $d793077b2bd5be27$export$608b2774753eb65d(championship, randomEvents) {
    randomEvents.forEach((c)=>{
        c.championshipId = null;
    });
}
function $d793077b2bd5be27$export$d42a19f74022e2b5(championship) {
    return (0, $14eBR.RandomEvents).find({
        "championshipId": championship.$loki
    });
}

});

parcelRequire.register("dBFC4", function(module, exports) {

$parcel$export(module.exports, "Game", () => $9e7f028aeac650cc$export$985739bfa5723e08);
$parcel$export(module.exports, "getGameCompanies", () => $9e7f028aeac650cc$export$3dacd71abd801260);
$parcel$export(module.exports, "addGameCompanies", () => $9e7f028aeac650cc$export$edfa330ee5d8c6e0);
$parcel$export(module.exports, "getGameCurrentCompany", () => $9e7f028aeac650cc$export$422bb155bf7a207);
$parcel$export(module.exports, "setGameCurrentCompany", () => $9e7f028aeac650cc$export$1310c89eb8054d05);
$parcel$export(module.exports, "addGameYearlyRankings", () => $9e7f028aeac650cc$export$556520752c48f85f);
$parcel$export(module.exports, "getGameYearlyRankings", () => $9e7f028aeac650cc$export$d2c4c63d5fb568e);

var $14eBR = parcelRequire("14eBR");
function $9e7f028aeac650cc$export$985739bfa5723e08() {
    // Strings
    const name = null; // scenario name
    const editName = null;
    const userUid = null;
    // Integer
    const monthCount = 0;
    const year = 0;
    const numberOfWeeklyShows = 2;
    const marketSize = null;
    // Boolean
    const awardsRun = false;
    const monthlySimulationRun = false;
    const competitorsPresent = false;
    const yearlyAttributesResetRan = false;
    // Objects
    const settings = {};
    // Datetime
    const datetimeLastPlayed = null;
    const datetimeLastCloudSave = null;
    // Foreign keys
    const currentCompanyId = null;
    const scenarioId = null;
    return {
        name: name,
        editName: editName,
        userUid: userUid,
        year: year,
        monthCount: monthCount,
        numberOfWeeklyShows: numberOfWeeklyShows,
        marketSize: marketSize,
        awardsRun: awardsRun,
        monthlySimulationRun: monthlySimulationRun,
        competitorsPresent: competitorsPresent,
        yearlyAttributesResetRan: yearlyAttributesResetRan,
        settings: settings,
        datetimeLastPlayed: datetimeLastPlayed,
        datetimeLastCloudSave: datetimeLastCloudSave,
        currentCompanyId: currentCompanyId,
        scenarioId: scenarioId
    };
}
function $9e7f028aeac650cc$export$3dacd71abd801260(game) {
    return (0, $14eBR.Companies).find({
        "gameId": game.$loki
    });
}
function $9e7f028aeac650cc$export$edfa330ee5d8c6e0(game, companies) {
    companies.forEach((c)=>{
        c.gameId = game.$loki;
    });
}
function $9e7f028aeac650cc$export$9105c825cee59b66(game, companies) {
    companies.forEach((c)=>{
        c.gameId = null;
    });
}
function $9e7f028aeac650cc$export$422bb155bf7a207(game) {
    return (0, $14eBR.Companies).find({
        "$loki": game.currentCompanyId
    })[0];
}
function $9e7f028aeac650cc$export$1310c89eb8054d05(game, company) {
    game.currentCompanyId = company.$loki;
}
function $9e7f028aeac650cc$export$ba24a1e12532764(game) {
    return (0, $14eBR.Scenarios).find({
        "$loki": game.scenarioId
    })[0];
}
function $9e7f028aeac650cc$export$556520752c48f85f(game, yearlyRankings) {
    yearlyRankings.forEach((c)=>{
        c.gameId = game.$loki;
    });
}
function $9e7f028aeac650cc$export$f0f8b2149e57307e(game, yearlyRankings) {
    yearlyRankings.forEach((c)=>{
        c.gameId = null;
    });
}
function $9e7f028aeac650cc$export$d2c4c63d5fb568e(game) {
    return (0, $14eBR.YearlyRankings).find({
        "gameId": game.$loki
    });
}

});

parcelRequire.register("9esFv", function(module, exports) {

$parcel$export(module.exports, "Company", () => $6b8ba8cbc5b608b9$export$17f7382901150e2d);
$parcel$export(module.exports, "getCompanyRosters", () => $6b8ba8cbc5b608b9$export$534ba41094408e11);
$parcel$export(module.exports, "addCompanyRosters", () => $6b8ba8cbc5b608b9$export$e4e034f8171d1f90);
$parcel$export(module.exports, "getCompanyChampionships", () => $6b8ba8cbc5b608b9$export$9a6476a0aa9d05d9);
$parcel$export(module.exports, "addCompanyChampionships", () => $6b8ba8cbc5b608b9$export$5711bd71a1a0d0a0);
$parcel$export(module.exports, "removeCompanyChampionships", () => $6b8ba8cbc5b608b9$export$c4653e4402ca7785);
$parcel$export(module.exports, "addCompanyEvents", () => $6b8ba8cbc5b608b9$export$7f4f85973dc37254);
$parcel$export(module.exports, "removeCompanyEvents", () => $6b8ba8cbc5b608b9$export$906a1d56fdb017d2);
$parcel$export(module.exports, "getCompanyEvents", () => $6b8ba8cbc5b608b9$export$6a4f44d56fd52b22);
$parcel$export(module.exports, "addCompanyCompanyLogs", () => $6b8ba8cbc5b608b9$export$9c6835cc89d98fbb);
$parcel$export(module.exports, "getCompanyCompanyLogs", () => $6b8ba8cbc5b608b9$export$b0e0a693d89be2b2);
$parcel$export(module.exports, "addCompanyGimmickMatches", () => $6b8ba8cbc5b608b9$export$334f07645912a0d7);
$parcel$export(module.exports, "removeCompanyGimmickMatches", () => $6b8ba8cbc5b608b9$export$7e2dbab83d7552fa);
$parcel$export(module.exports, "getCompanyGimmickMatches", () => $6b8ba8cbc5b608b9$export$54ece5bc0b506b96);
$parcel$export(module.exports, "getCompanyGame", () => $6b8ba8cbc5b608b9$export$47af34ad5ae85f56);
$parcel$export(module.exports, "addCompanyObjectives", () => $6b8ba8cbc5b608b9$export$66cb5b9ea59e5bab);
$parcel$export(module.exports, "removeCompanyObjectives", () => $6b8ba8cbc5b608b9$export$92333c41ba1b5fe3);
$parcel$export(module.exports, "getCompanyObjectives", () => $6b8ba8cbc5b608b9$export$237be315f2585351);
$parcel$export(module.exports, "addCompanyNewsItems", () => $6b8ba8cbc5b608b9$export$7277ce5bb8047153);
$parcel$export(module.exports, "getCompanyNewsItems", () => $6b8ba8cbc5b608b9$export$788e64812edd8d94);
$parcel$export(module.exports, "addCompanyRelationships", () => $6b8ba8cbc5b608b9$export$ca24cc4cc18d42fc);
$parcel$export(module.exports, "addCompanyPowerups", () => $6b8ba8cbc5b608b9$export$e0b545e61d8635b4);
$parcel$export(module.exports, "getCompanyPowerups", () => $6b8ba8cbc5b608b9$export$794da438024fc420);
$parcel$export(module.exports, "addCompanyStoryChoices", () => $6b8ba8cbc5b608b9$export$e08a7684bcf9461c);
$parcel$export(module.exports, "getCompanyStoryChoices", () => $6b8ba8cbc5b608b9$export$979bb36a156efb8b);
$parcel$export(module.exports, "addCompanyTournaments", () => $6b8ba8cbc5b608b9$export$6073bb931c1afb27);
$parcel$export(module.exports, "removeCompanyTournaments", () => $6b8ba8cbc5b608b9$export$8489dad6693e8bd4);
$parcel$export(module.exports, "getCompanyTournaments", () => $6b8ba8cbc5b608b9$export$5d014ebca8c50a5e);
$parcel$export(module.exports, "addCompanyFeudItems", () => $6b8ba8cbc5b608b9$export$80590342d71e8434);
$parcel$export(module.exports, "getCompanyFeudItems", () => $6b8ba8cbc5b608b9$export$36b7cbd34651bd7b);
$parcel$export(module.exports, "addCompanySegmentItems", () => $6b8ba8cbc5b608b9$export$e9ea6a648ab637ff);
$parcel$export(module.exports, "removeCompanySegmentItems", () => $6b8ba8cbc5b608b9$export$a41e427f7e4b222a);
$parcel$export(module.exports, "getCompanySegmentItems", () => $6b8ba8cbc5b608b9$export$b88b582b6d6c8e48);
$parcel$export(module.exports, "addCompanyMessages", () => $6b8ba8cbc5b608b9$export$3ca8efe3fbe21d12);
$parcel$export(module.exports, "getCompanyMessages", () => $6b8ba8cbc5b608b9$export$6a14fe481c5cd9ae);
$parcel$export(module.exports, "addCompanyRandomEvents", () => $6b8ba8cbc5b608b9$export$1f4e3b0ac3117c93);
$parcel$export(module.exports, "getCompanyRandomEvents", () => $6b8ba8cbc5b608b9$export$2dd7f362636b0b35);
$parcel$export(module.exports, "addCompanyStaff", () => $6b8ba8cbc5b608b9$export$c74e28e47c246399);
$parcel$export(module.exports, "removeCompanyStaff", () => $6b8ba8cbc5b608b9$export$43cd405456566989);
$parcel$export(module.exports, "getCompanyStaff", () => $6b8ba8cbc5b608b9$export$b27e7f4959b8131b);
$parcel$export(module.exports, "addCompanyFacilities", () => $6b8ba8cbc5b608b9$export$accde82d9d24adf5);
$parcel$export(module.exports, "getCompanyFacilities", () => $6b8ba8cbc5b608b9$export$ff59bce31559150a);
$parcel$export(module.exports, "addCompanyCompanyAlerts", () => $6b8ba8cbc5b608b9$export$7d2877a40d8f74f6);
$parcel$export(module.exports, "getCompanyCompanyAlerts", () => $6b8ba8cbc5b608b9$export$5fa16de129b7161a);
$parcel$export(module.exports, "getCompanyDraft", () => $6b8ba8cbc5b608b9$export$1bb8eb4fce5b3de3);
$parcel$export(module.exports, "addCompanySentNegotiations", () => $6b8ba8cbc5b608b9$export$2fc1611636af0f20);
$parcel$export(module.exports, "getCompanySentNegotiations", () => $6b8ba8cbc5b608b9$export$edc56f20d2a22a52);
$parcel$export(module.exports, "addCompanyReceivedNegotiations", () => $6b8ba8cbc5b608b9$export$5c18c6ddd111ec26);
$parcel$export(module.exports, "getCompanyReceivedNegotiations", () => $6b8ba8cbc5b608b9$export$4ba46aa355a6e6e1);
$parcel$export(module.exports, "addCompanySentTradeOffers", () => $6b8ba8cbc5b608b9$export$a3f84f68649b3c27);
$parcel$export(module.exports, "getCompanySentTradeOffers", () => $6b8ba8cbc5b608b9$export$e07f292c723d44e1);
$parcel$export(module.exports, "addCompanyReceivedTradeOffers", () => $6b8ba8cbc5b608b9$export$4c6eceff56c15fd1);
$parcel$export(module.exports, "getCompanyReceivedTradeOffers", () => $6b8ba8cbc5b608b9$export$4379491d5fb510f1);
$parcel$export(module.exports, "addCompanyTalentRequests", () => $6b8ba8cbc5b608b9$export$35c537e35f0bb0cc);
$parcel$export(module.exports, "getCompanyTalentRequests", () => $6b8ba8cbc5b608b9$export$6ea8c67744708fd1);

var $14eBR = parcelRequire("14eBR");
function $6b8ba8cbc5b608b9$export$17f7382901150e2d() {
    // Strings
    const name = null;
    const style = "entertainment";
    const ownerName = null;
    const weeklyShowName = null;
    const operatingStatus = "Active";
    const playerName = null;
    const turnStatus = null;
    const activeEffect = null;
    const storyName = null;
    // Integer
    const fans = 3000;
    const points = 150;
    const reputation = null;
    const highestReputation = null;
    const xp = null;
    const realYear = null;
    const overness = 45;
    const month = null;
    const year = null;
    // Boolean
    const ownerAdded = false;
    const standardGimmickMatches = false;
    const hot = false;
    const stale = false;
    const trainingTransferRun = false;
    const trainingCallupRun = false;
    const yearlyReviewRun = false;
    const yearlyCheckRun = false;
    const introducedPowerups = false;
    const userControlled = false;
    const newUserCompany = false;
    // Objects
    const specialFinishesData = {};
    const settings = {};
    const newCompanyData = {};
    // Foreign keys
    const gameId = null;
    const draftId = null;
    return {
        name: name,
        style: style,
        ownerName: ownerName,
        weeklyShowName: weeklyShowName,
        operatingStatus: operatingStatus,
        playerName: playerName,
        turnStatus: turnStatus,
        activeEffect: activeEffect,
        storyName: storyName,
        fans: fans,
        points: points,
        reputation: reputation,
        highestReputation: highestReputation,
        xp: xp,
        realYear: realYear,
        overness: overness,
        month: month,
        year: year,
        ownerAdded: ownerAdded,
        standardGimmickMatches: standardGimmickMatches,
        hot: hot,
        stale: stale,
        trainingTransferRun: trainingTransferRun,
        trainingCallupRun: trainingCallupRun,
        yearlyReviewRun: yearlyReviewRun,
        yearlyCheckRun: yearlyCheckRun,
        introducedPowerups: introducedPowerups,
        userControlled: userControlled,
        newUserCompany: newUserCompany,
        specialFinishesData: specialFinishesData,
        settings: settings,
        gameId: gameId,
        draftId: draftId,
        newCompanyData: newCompanyData
    };
}
function $6b8ba8cbc5b608b9$export$534ba41094408e11(company) {
    return (0, $14eBR.Rosters).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$e4e034f8171d1f90(company, rosters) {
    rosters.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$a4a574fe31eb67b1(company, rosters) {
    rosters.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$9a6476a0aa9d05d9(company, filterRetired = true) {
    let companyChampionships = (0, $14eBR.Championships).find({
        "companyId": company.$loki
    });
    if (filterRetired) companyChampionships = companyChampionships.filter((x)=>!x.retired);
    return companyChampionships;
}
function $6b8ba8cbc5b608b9$export$5711bd71a1a0d0a0(company, championships) {
    championships.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$c4653e4402ca7785(company, championships) {
    championships.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$7f4f85973dc37254(company, events) {
    events.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$906a1d56fdb017d2(company, events) {
    events.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$6a4f44d56fd52b22(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Events).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$9c6835cc89d98fbb(company, companyLogs) {
    companyLogs.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$6e02ba57f22b344c(company, companyLogs) {
    companyLogs.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$b0e0a693d89be2b2(company) {
    if (!company.gameId) return;
    return (0, $14eBR.CompanyLogs).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$334f07645912a0d7(company, gimmickMatches) {
    gimmickMatches.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$7e2dbab83d7552fa(company, gimmickMatches) {
    gimmickMatches.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$54ece5bc0b506b96(company) {
    if (!company.gameId) return;
    return (0, $14eBR.GimmickMatches).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$47af34ad5ae85f56(company) {
    return (0, $14eBR.Games).find({
        "$loki": company.gameId
    })[0];
}
function $6b8ba8cbc5b608b9$export$66cb5b9ea59e5bab(company, objectives) {
    objectives.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$92333c41ba1b5fe3(company, objectives) {
    objectives.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$237be315f2585351(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Objectives).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$7277ce5bb8047153(company, newsItems) {
    newsItems.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$9c8750587402d82a(company, newsItems) {
    newsItems.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$788e64812edd8d94(company) {
    if (!company.gameId) return;
    return (0, $14eBR.NewsItems).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$ca24cc4cc18d42fc(company, relationships) {
    relationships.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$4457ade30192e0d0(company, relationships) {
    relationships.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$6aa9fe87cb560ad8(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Relationships).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$e0b545e61d8635b4(company, powerups) {
    powerups.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$b41749fd71c5f7c2(company, powerups) {
    powerups.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$794da438024fc420(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Powerups).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$e08a7684bcf9461c(company, storyChoices) {
    storyChoices.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$a3b777ede79f90c5(company, storyChoices) {
    storyChoices.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$979bb36a156efb8b(company) {
    if (!company.gameId) return;
    return (0, $14eBR.StoryChoices).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$6073bb931c1afb27(company, tournaments) {
    tournaments.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$8489dad6693e8bd4(company, tournaments) {
    tournaments.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$5d014ebca8c50a5e(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Tournaments).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$80590342d71e8434(company, feudItems) {
    feudItems.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$173162315d8361a6(company, feudItems) {
    feudItems.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$36b7cbd34651bd7b(company) {
    if (!company.gameId) return;
    return (0, $14eBR.FeudItems).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$e9ea6a648ab637ff(company, segmentItems) {
    segmentItems.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$a41e427f7e4b222a(company, segmentItems) {
    segmentItems.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$b88b582b6d6c8e48(company) {
    if (!company.gameId) return;
    return (0, $14eBR.SegmentItems).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$3ca8efe3fbe21d12(company, messages) {
    messages.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$e33aceaa9a728658(company, messages) {
    messages.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$6a14fe481c5cd9ae(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Messages).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$1f4e3b0ac3117c93(company, randomEvents) {
    randomEvents.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$5105494973b7767f(company, randomEvents) {
    randomEvents.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$2dd7f362636b0b35(company) {
    if (!company.gameId) return;
    return (0, $14eBR.RandomEvents).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$c74e28e47c246399(company, staff) {
    staff.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$43cd405456566989(company, staff) {
    staff.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$b27e7f4959b8131b(company) {
    if (!company.gameId) return;
    return (0, $14eBR.StaffMembers).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$accde82d9d24adf5(company, facilities) {
    facilities.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$bfec216097c042a9(company, facilities) {
    facilities.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$ff59bce31559150a(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Facilities).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$7d2877a40d8f74f6(company, companyAlerts) {
    companyAlerts.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$4205bff963a98495(company, companyAlerts) {
    companyAlerts.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$5fa16de129b7161a(company) {
    if (!company.gameId) return;
    return (0, $14eBR.CompanyAlerts).find({
        "companyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$1bb8eb4fce5b3de3(company) {
    return (0, $14eBR.Drafts).find({
        "$loki": company.draftId
    })[0];
}
function $6b8ba8cbc5b608b9$export$2fc1611636af0f20(company, negotiations) {
    negotiations.forEach((c)=>{
        c.senderCompanyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$edfda2c2a9243c1a(company, negotiations) {
    negotiations.forEach((c)=>{
        c.senderCompanyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$edc56f20d2a22a52(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Negotiations).find({
        "senderCompanyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$5c18c6ddd111ec26(company, negotiations) {
    negotiations.forEach((c)=>{
        c.receiverCompanyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$8d5f59c5aebce342(company, negotiations) {
    negotiations.forEach((c)=>{
        c.receiverCompanyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$4ba46aa355a6e6e1(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Negotiations).find({
        "receiverCompanyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$a3f84f68649b3c27(company, tradeOffers) {
    tradeOffers.forEach((c)=>{
        c.senderCompanyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$50dc0eef331c8c8d(company, tradeOffers) {
    tradeOffers.forEach((c)=>{
        c.senderCompanyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$e07f292c723d44e1(company) {
    if (!company.gameId) return;
    return (0, $14eBR.TradeOffers).find({
        "senderCompanyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$4c6eceff56c15fd1(company, tradeOffers) {
    tradeOffers.forEach((c)=>{
        c.receiverCompanyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$1abf685e86d14083(company, tradeOffers) {
    tradeOffers.forEach((c)=>{
        c.receiverCompanyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$4379491d5fb510f1(company) {
    if (!company.gameId) return;
    return (0, $14eBR.TradeOffers).find({
        "receiverCompanyId": company.$loki
    });
}
function $6b8ba8cbc5b608b9$export$35c537e35f0bb0cc(company, talentRequests) {
    talentRequests.forEach((c)=>{
        c.companyId = company.$loki;
    });
}
function $6b8ba8cbc5b608b9$export$6eaec3b0ceae6582(company, talentRequests) {
    talentRequests.forEach((c)=>{
        c.companyId = null;
    });
}
function $6b8ba8cbc5b608b9$export$6ea8c67744708fd1(company) {
    if (!company.gameId) return;
    return (0, $14eBR.TalentRequests).find({
        "companyId": company.$loki
    });
}

});

parcelRequire.register("i7bmn", function(module, exports) {

$parcel$export(module.exports, "Match", () => $d301b1492cbd0288$export$f421feb8fad20413);
$parcel$export(module.exports, "addMatchSuperstars", () => $d301b1492cbd0288$export$22e5ca55b0f92272);
$parcel$export(module.exports, "addMatchTagTeams", () => $d301b1492cbd0288$export$4df1559624df4585);
$parcel$export(module.exports, "addMatchChampionships", () => $d301b1492cbd0288$export$7db63cbf87871eee);
$parcel$export(module.exports, "removeMatchChampionships", () => $d301b1492cbd0288$export$170376540d92f482);
$parcel$export(module.exports, "getMatchParticipants", () => $d301b1492cbd0288$export$bdaaa3bff5c9abc4);
$parcel$export(module.exports, "getMatchTagTeams", () => $d301b1492cbd0288$export$d26a782094688670);
$parcel$export(module.exports, "getAllSuperstarsForMatch", () => $d301b1492cbd0288$export$befea8e9488238dd);
$parcel$export(module.exports, "getMatchChampionships", () => $d301b1492cbd0288$export$ab37973fca3cf859);
$parcel$export(module.exports, "getMatchEvent", () => $d301b1492cbd0288$export$f087fce28e2ebe17);
$parcel$export(module.exports, "getMatchGimmickMatch", () => $d301b1492cbd0288$export$f16eaf9c577a5e25);
$parcel$export(module.exports, "addMatchChampionshipReigns", () => $d301b1492cbd0288$export$f956380db4e55272);
$parcel$export(module.exports, "getMatchTournament", () => $d301b1492cbd0288$export$cc94800c024abeee);
$parcel$export(module.exports, "addMatchFeuds", () => $d301b1492cbd0288$export$58767b00ffcddace);
$parcel$export(module.exports, "removeMatchFeud", () => $d301b1492cbd0288$export$de5527b8e2fae3a7);
$parcel$export(module.exports, "getMatchFeuds", () => $d301b1492cbd0288$export$3e713306742e6ede);
$parcel$export(module.exports, "addMatchParticipants", () => $d301b1492cbd0288$export$73cfc1c1b9253bcf);

var $14eBR = parcelRequire("14eBR");

var $972Ip = parcelRequire("972Ip");
function $d301b1492cbd0288$export$f421feb8fad20413(order, type = "singles") {
    // String
    const objectToClaim = null;
    const location = null;
    const winner = null;
    const loser = null;
    const championshipsWon = null;
    const championshipsDefended = null;
    const championshipsRetained = null;
    const generatedText = null;
    const activeEffect = null;
    const finishName = null;
    const finishText = null;
    const objectName = "match";
    // Integer
    const hype = 0;
    const streakBonus = 0;
    const eventBonus = 0;
    const contractBonus = 0;
    const tournamentFinalBonus = 0;
    const tournamentRound = null;
    const tournamentGroup = null;
    const refereeId = null;
    // Float
    const rating = null;
    // Boolean
    const hot = false;
    const hidden = null;
    // Array
    const fallGimmickNames = [];
    // Object
    const managersUsed = {};
    // Foreign key
    const eventId = null;
    const gimmickMatchId = null;
    const tournamentId = null;
    const championshipReignDefenseId = null;
    return {
        order: order,
        type: type,
        objectToClaim: objectToClaim,
        location: location,
        winner: winner,
        loser: loser,
        championshipsWon: championshipsWon,
        championshipsDefended: championshipsDefended,
        championshipsRetained: championshipsRetained,
        generatedText: generatedText,
        activeEffect: activeEffect,
        finishName: finishName,
        finishText: finishText,
        hype: hype,
        streakBonus: streakBonus,
        eventBonus: eventBonus,
        contractBonus: contractBonus,
        tournamentFinalBonus: tournamentFinalBonus,
        tournamentRound: tournamentRound,
        tournamentGroup: tournamentGroup,
        refereeId: refereeId,
        rating: rating,
        hot: hot,
        hidden: hidden,
        fallGimmickNames: fallGimmickNames,
        managersUsed: managersUsed,
        eventId: eventId,
        gimmickMatchId: gimmickMatchId,
        tournamentId: tournamentId,
        championshipReignDefenseId: championshipReignDefenseId,
        objectName: objectName
    };
}
function $d301b1492cbd0288$export$22e5ca55b0f92272(match, superstars) {
    let matchHashes = superstars.map((x)=>{
        return {
            matchId: match.$loki,
            superstarId: x.$loki
        };
    });
    return (0, $14eBR.MatchesHash).insert(matchHashes);
}
function $d301b1492cbd0288$export$4df1559624df4585(match, tagTeams) {
    let matchHashes = tagTeams.map((x)=>{
        return {
            matchId: match.$loki,
            tagTeamId: x.$loki
        };
    });
    return (0, $14eBR.MatchesHash).insert(matchHashes);
}
async function $d301b1492cbd0288$export$59d56abab845390c(match) {
    (0, $14eBR.MatchesHash).findAndRemove({
        "matchId": match.$loki
    });
}
async function $d301b1492cbd0288$export$50c236648e3019ee(match, participant) {
    if (participant.objectName === "superstar") (0, $14eBR.MatchesHash).findAndRemove({
        "matchId": match.$loki,
        "superstarId": participant.$loki
    });
    else if (participant.objectName === "tagTeam") (0, $14eBR.MatchesHash).findAndRemove({
        "matchId": match.$loki,
        "tagTeamId": participant.$loki
    });
}
function $d301b1492cbd0288$export$7db63cbf87871eee(match, championships) {
    championships.forEach((c)=>{
        c.matchId = match.$loki;
    });
}
function $d301b1492cbd0288$export$170376540d92f482(match, championships) {
    championships.forEach((c)=>{
        c.matchId = null;
    });
}
function $d301b1492cbd0288$export$bdaaa3bff5c9abc4(match) {
    if (match.type === "singles") return $d301b1492cbd0288$export$b48ffe280c44f3c9(match);
    else return $d301b1492cbd0288$export$d26a782094688670(match);
}
async function $d301b1492cbd0288$export$b48ffe280c44f3c9(match) {
    const matchHashes = await (0, $14eBR.MatchesHash).find({
        "matchId": match.$loki
    });
    const superstarIds = matchHashes.map((x)=>{
        return x.superstarId;
    });
    const result = (0, $14eBR.Superstars).find({
        "$loki": {
            "$in": superstarIds
        }
    });
    result.sort((a, b)=>superstarIds.indexOf(a.$loki) - superstarIds.indexOf(b.$loki));
    return result;
}
async function $d301b1492cbd0288$export$d26a782094688670(match) {
    const matchHashes = await (0, $14eBR.MatchesHash).find({
        "matchId": match.$loki
    });
    const tagTeamIds = matchHashes.map((x)=>{
        return x.tagTeamId;
    });
    const result = (0, $14eBR.TagTeams).find({
        "$loki": {
            "$in": tagTeamIds
        }
    });
    result.sort((a, b)=>tagTeamIds.indexOf(a.$loki) - tagTeamIds.indexOf(b.$loki));
    return result;
}
async function $d301b1492cbd0288$export$befea8e9488238dd(match) {
    if (match.type === "singles") return $d301b1492cbd0288$export$b48ffe280c44f3c9(match);
    else {
        let allSuperstars = [];
        for await (const x of (await $d301b1492cbd0288$export$d26a782094688670(match)))allSuperstars.push(...await (0, $972Ip.getTagTeamSuperstars)(x));
        return allSuperstars;
    }
}
function $d301b1492cbd0288$export$ab37973fca3cf859(match) {
    return (0, $14eBR.Championships).find({
        "matchId": match.$loki
    });
}
function $d301b1492cbd0288$export$f087fce28e2ebe17(match) {
    if (!match.eventId) return;
    return (0, $14eBR.Events).find({
        "$loki": match.eventId
    })[0];
}
function $d301b1492cbd0288$export$f16eaf9c577a5e25(match) {
    if (!match.gimmickMatchId) return;
    return (0, $14eBR.GimmickMatches).find({
        "$loki": match.gimmickMatchId
    })[0];
}
function $d301b1492cbd0288$export$f956380db4e55272(match, championshipReigns) {
    let matchHashes = championshipReigns.map((x)=>{
        return {
            matchId: match.$loki,
            championshipReignId: x.$loki
        };
    });
    return (0, $14eBR.ChampionshipReignMatchesHash).insert(matchHashes);
}
async function $d301b1492cbd0288$export$c53049f2f1a5e578(match) {
    const matchHashes = await (0, $14eBR.ChampionshipReignMatchesHash).find({
        "matchId": match.$loki
    });
    const championshipReignIds = matchHashes.map((x)=>{
        return x.championshipReignId;
    });
    return (0, $14eBR.ChampionshipReigns).find({
        "$loki": {
            "$in": championshipReignIds
        }
    });
}
function $d301b1492cbd0288$export$cc94800c024abeee(match) {
    if (!match.tournamentId) return;
    return (0, $14eBR.Tournaments).find({
        "$loki": match.tournamentId
    })[0];
}
function $d301b1492cbd0288$export$58767b00ffcddace(match, feuds) {
    let matchHashes = feuds.map((x)=>{
        return {
            matchId: match.$loki,
            feudId: x.$loki
        };
    });
    return (0, $14eBR.FeudMatchesHash).insert(matchHashes);
}
async function $d301b1492cbd0288$export$de5527b8e2fae3a7(match, feud) {
    (0, $14eBR.FeudMatchesHash).findAndRemove({
        "matchId": match.$loki,
        "feudId": feud.$loki
    });
}
async function $d301b1492cbd0288$export$3e713306742e6ede(match) {
    const matchHashes = await (0, $14eBR.FeudMatchesHash).find({
        "matchId": match.$loki
    });
    const feudIds = matchHashes.map((x)=>{
        return x.feudId;
    });
    return (0, $14eBR.Feuds).find({
        "$loki": {
            "$in": feudIds
        }
    });
}
async function $d301b1492cbd0288$export$73cfc1c1b9253bcf(match, participants) {
    for (const p of participants){
        if (p.objectName === "superstar") await $d301b1492cbd0288$export$22e5ca55b0f92272(match, [
            p
        ]);
        else if (p.objectName === "tagTeam") await $d301b1492cbd0288$export$4df1559624df4585(match, [
            p
        ]);
    }
}

});

parcelRequire.register("8LLPX", function(module, exports) {

$parcel$export(module.exports, "Brand", () => $6627d1f908587fd0$export$75d5b518c51e7fd6);

var $14eBR = parcelRequire("14eBR");
function $6627d1f908587fd0$export$75d5b518c51e7fd6() {
    // Strings
    const name = null;
    const weeklyShowName = null;
    const color = null;
    // Integer
    const overness = 45;
    // Boolean
    const weeklyShowIsExclusive = false;
    const hot = false;
    const stale = false;
    // Foreign keys
    const rosterId = null;
    return {
        name: name,
        weeklyShowName: weeklyShowName,
        color: color,
        overness: overness,
        weeklyShowIsExclusive: weeklyShowIsExclusive,
        hot: hot,
        stale: stale,
        rosterId: rosterId
    };
}
function $6627d1f908587fd0$export$e93c968f0d59aa45(brand) {
    return (0, $14eBR.Rosters).find({
        "$loki": brand.rosterId
    })[0];
}

});

parcelRequire.register("5kTkA", function(module, exports) {

$parcel$export(module.exports, "getRankFromPopularity", () => $3e29bd9aa5422a42$export$c4599c2b86ea2e7f);
$parcel$export(module.exports, "getNextRank", () => $3e29bd9aa5422a42$export$5c16a8b7eebff4b8);
$parcel$export(module.exports, "getInjuryReturnTime", () => $3e29bd9aa5422a42$export$179bed0d7a969080);
$parcel$export(module.exports, "evaluateInjury", () => $3e29bd9aa5422a42$export$f2f7a90776990f77);
$parcel$export(module.exports, "getSuperstarChampionshipsAll", () => $3e29bd9aa5422a42$export$9677c8cb39ec12ef);
$parcel$export(module.exports, "checkAvailability", () => $3e29bd9aa5422a42$export$c4f17efb5a39bbd0);
$parcel$export(module.exports, "checkSuperstarBrandAvailability", () => $3e29bd9aa5422a42$export$e1577a9e85de2a7f);
$parcel$export(module.exports, "checkObjectBrandAvailability", () => $3e29bd9aa5422a42$export$b211d81e86f15d10);
$parcel$export(module.exports, "checkSuperstarSegmentAvailability", () => $3e29bd9aa5422a42$export$4aca442b6c73e8b6);
$parcel$export(module.exports, "getSuperstarDisplayData", () => $3e29bd9aa5422a42$export$fca17f38c9e14a40);
$parcel$export(module.exports, "getGraphicForSuperstar", () => $3e29bd9aa5422a42$export$a4c875f55030a528);
$parcel$export(module.exports, "getSuperstarFreebirdTagChampionships", () => $3e29bd9aa5422a42$export$6ce038e19de65738);
$parcel$export(module.exports, "getSuperstarActiveFactions", () => $3e29bd9aa5422a42$export$fa9de4df2e00da79);
$parcel$export(module.exports, "getGimmickData", () => $3e29bd9aa5422a42$export$64dd7a8588c854d9);
$parcel$export(module.exports, "getSuperstarManagerUsedForMatchOrSegment", () => $3e29bd9aa5422a42$export$ceda885e1dfef32e);
$parcel$export(module.exports, "checkIfCanUnlearnTrait", () => $3e29bd9aa5422a42$export$c31b95768782ee90);
$parcel$export(module.exports, "getGimmickCombinationResult", () => $3e29bd9aa5422a42$export$cd82cdf264b0e6d8);
$parcel$export(module.exports, "getSuperstarMatchOrSegmentData", () => $3e29bd9aa5422a42$export$5fdcf304511f31b3);
$parcel$export(module.exports, "getRosterMemberSuperstars", () => $3e29bd9aa5422a42$export$ce43b5f35d3e6e3b);
$parcel$export(module.exports, "getEmptySuperstarGraphic", () => $3e29bd9aa5422a42$export$adde1e88813de763);
$parcel$export(module.exports, "getSuperstarGenderFromPronoun", () => $3e29bd9aa5422a42$export$9e7ef561bf3ba9eb);
$parcel$export(module.exports, "checkSuperstarGraphicMask", () => $3e29bd9aa5422a42$export$ede4139409087a56);
$parcel$export(module.exports, "getSuperstarChampionshipsFromCompanyChampionships", () => $3e29bd9aa5422a42$export$a00c78583f6a016d);
$parcel$export(module.exports, "changeSuperstarMoraleToHappy", () => $3e29bd9aa5422a42$export$dc429a710513ee58);
$parcel$export(module.exports, "changeSuperstarMoraleToUnhappy", () => $3e29bd9aa5422a42$export$b7c90e1eb2cd702a);
$parcel$export(module.exports, "removeSuperstarFactionRelationships", () => $3e29bd9aa5422a42$export$dc6940d321124923);
$parcel$export(module.exports, "removeSuperstarManagerRelationships", () => $3e29bd9aa5422a42$export$21dfb94fe5615e93);
$parcel$export(module.exports, "removeSuperstarsFromManager", () => $3e29bd9aa5422a42$export$93d3c67e0b8acba0);
$parcel$export(module.exports, "addSuperstarsToManager", () => $3e29bd9aa5422a42$export$baf1d47eaf764da7);
$parcel$export(module.exports, "removeSuperstarTagTeams", () => $3e29bd9aa5422a42$export$2d642a932620186a);
$parcel$export(module.exports, "endSuperstarInjury", () => $3e29bd9aa5422a42$export$406ee22b5cd47066);
$parcel$export(module.exports, "updateSuperstarMorale", () => $3e29bd9aa5422a42$export$2c1736e89480acb3);
$parcel$export(module.exports, "getSuperstarChampionshipsToVacate", () => $3e29bd9aa5422a42$export$18643886df825496);
$parcel$export(module.exports, "getSuperstarLastName", () => $3e29bd9aa5422a42$export$3b758ef63637c454);
$parcel$export(module.exports, "changeSuperstarAttire", () => $3e29bd9aa5422a42$export$3dd7f50c94361964);
$parcel$export(module.exports, "getSuperstarCharisma", () => $3e29bd9aa5422a42$export$4817d36ff076caf2);
$parcel$export(module.exports, "getSuperstarWorkrate", () => $3e29bd9aa5422a42$export$40e51a0db6f1e065);
$parcel$export(module.exports, "getSuperstarManagerGraphic", () => $3e29bd9aa5422a42$export$ddf95a6fc5193cb6);
$parcel$export(module.exports, "getTraitWeightsForSuperstars", () => $3e29bd9aa5422a42$export$359f35a987dc7d80);
$parcel$export(module.exports, "getKayfabePointsChange", () => $3e29bd9aa5422a42$export$588b8486271c4a24);
$parcel$export(module.exports, "updateSuperstarKayfabePoints", () => $3e29bd9aa5422a42$export$899c2c022f9af547);
$parcel$export(module.exports, "checkAcquireTrait", () => $3e29bd9aa5422a42$export$c7407d2379a271ab);
$parcel$export(module.exports, "formatSuperstarTrait", () => $3e29bd9aa5422a42$export$909918bc78a25e7f);
$parcel$export(module.exports, "debutGimmick", () => $3e29bd9aa5422a42$export$339607a84a85cd15);
$parcel$export(module.exports, "getGimmickEffectivenessEffect", () => $3e29bd9aa5422a42$export$aeb467a2e88a2e67);
$parcel$export(module.exports, "checkForSuperstarInjury", () => $3e29bd9aa5422a42$export$b2688aa0818c112c);
$parcel$export(module.exports, "addInjuryToSuperstar", () => $3e29bd9aa5422a42$export$308b59438e406dc4);
$parcel$export(module.exports, "addKayfabeInjuryToSuperstar", () => $3e29bd9aa5422a42$export$8fa23b05ac79c55e);
$parcel$export(module.exports, "checkSuperstarWorkThroughInjury", () => $3e29bd9aa5422a42$export$fdeab6e4077e48af);
$parcel$export(module.exports, "addNextGimmickBoost", () => $3e29bd9aa5422a42$export$ad637ca5c842779a);
$parcel$export(module.exports, "removeSuperstarGraphicHair", () => $3e29bd9aa5422a42$export$92e6a245bdb408b0);
$parcel$export(module.exports, "removeSuperstarGraphicMask", () => $3e29bd9aa5422a42$export$687301cd06d6f499);
$parcel$export(module.exports, "addSuperstarGraphicHair", () => $3e29bd9aa5422a42$export$6bf0842608a5a5e);
$parcel$export(module.exports, "updateSuperstarFatigue", () => $3e29bd9aa5422a42$export$13bc0913f434c9c1);
$parcel$export(module.exports, "getSuperstarFatigueChangeForMatch", () => $3e29bd9aa5422a42$export$e36d9f679272d2ae);
$parcel$export(module.exports, "updateSuperstarPopularity", () => $3e29bd9aa5422a42$export$4f6246b9b04b9b97);
$parcel$export(module.exports, "getSuperstarMoraleChange", () => $3e29bd9aa5422a42$export$ca9087d6b9f24306);
$parcel$export(module.exports, "vacateChampionships", () => $3e29bd9aa5422a42$export$5663676ffa021cfc);
$parcel$export(module.exports, "retireSuperstar", () => $3e29bd9aa5422a42$export$dc795dacb32dbe0a);
$parcel$export(module.exports, "getFutureSuperstarsToAdd", () => $3e29bd9aa5422a42$export$38f3d5b1cd2f9010);
$parcel$export(module.exports, "addFutureSuperstar", () => $3e29bd9aa5422a42$export$69abe7df5c990393);
$parcel$export(module.exports, "processSuperstarTemporaryInjury", () => $3e29bd9aa5422a42$export$d6a418b13952faaf);
$parcel$export(module.exports, "processSuperstarTemporaryTrophy", () => $3e29bd9aa5422a42$export$bd997919facd8b02);
$parcel$export(module.exports, "processSuperstarLeavingCompany", () => $3e29bd9aa5422a42$export$d77fe2ada004eaf5);
$parcel$export(module.exports, "recoverSuperstarFatigue", () => $3e29bd9aa5422a42$export$76fe39072eb6441d);
$parcel$export(module.exports, "processSuperstarMorale", () => $3e29bd9aa5422a42$export$d5fe724cafe14f09);
$parcel$export(module.exports, "addSuperstarGraphicTemporaryTrophy", () => $3e29bd9aa5422a42$export$6aadce3c99e5f07d);
$parcel$export(module.exports, "removeTraitFromSuperstar", () => $3e29bd9aa5422a42$export$5de8c46603af6ef1);
$parcel$export(module.exports, "addInterestedRelationship", () => $3e29bd9aa5422a42$export$ee5945437f10e69d);
$parcel$export(module.exports, "processSuperstarContract", () => $3e29bd9aa5422a42$export$1ee625ec9c2f9bb7);
$parcel$export(module.exports, "vacateSuperstarChampionships", () => $3e29bd9aa5422a42$export$52030f2b50b9962a);

var $98xmD = parcelRequire("98xmD");

var $kZwpB = parcelRequire("kZwpB");

var $972Ip = parcelRequire("972Ip");

var $hBIDz = parcelRequire("hBIDz");

var $2JFAd = parcelRequire("2JFAd");

var $2GWzg = parcelRequire("2GWzg");

var $14eBR = parcelRequire("14eBR");

var $9esFv = parcelRequire("9esFv");

var $3E8Nt = parcelRequire("3E8Nt");

var $6PzHO = parcelRequire("6PzHO");

var $ivuOU = parcelRequire("ivuOU");

var $1AAHK = parcelRequire("1AAHK");

var $ycsyu = parcelRequire("ycsyu");

var $ko5kE = parcelRequire("ko5kE");

var $aP7lq = parcelRequire("aP7lq");

var $jpMCP = parcelRequire("jpMCP");

var $8A6FL = parcelRequire("8A6FL");

var $4rksk = parcelRequire("4rksk");

var $1olyO = parcelRequire("1olyO");

var $hekDR = parcelRequire("hekDR");

var $fuJHb = parcelRequire("fuJHb");

var $dl5u4 = parcelRequire("dl5u4");

var $4K85d = parcelRequire("4K85d");

var $iRMwH = parcelRequire("iRMwH");

var $cXLSF = parcelRequire("cXLSF");

var $kZMqI = parcelRequire("kZMqI");

var $iWkAo = parcelRequire("iWkAo");

var $4EGpv = parcelRequire("4EGpv");

var $jC7EP = parcelRequire("jC7EP");
function $3e29bd9aa5422a42$export$c4599c2b86ea2e7f(popularity) {
    if (popularity >= 800) return "Main Eventer";
    else if (popularity >= 600) return "Upper Midcarder";
    else if (popularity >= 400) return "Lower Midcarder";
    else return "Jabroni";
}
async function $3e29bd9aa5422a42$export$5c16a8b7eebff4b8(talent) {
    let popularity = await (0, $3E8Nt.getRosterMemberPopularity)(talent);
    if (popularity >= 800) return null;
    else if (popularity >= 600) return "Main Eventer";
    else if (popularity >= 400) return "Upper Midcarder";
    else return "Lower Midcarder";
}
function $3e29bd9aa5422a42$export$179bed0d7a969080(superstar, doctor = null) {
    let length = superstar.injured;
    // Get doctor level
    let level = doctor ? doctor.level : 1;
    if (level >= 3 || superstar.workableInjury) return length.toString();
    else {
        if (!superstar.injuryReturnMin || !superstar.injuryReturnMax) $3e29bd9aa5422a42$export$f2f7a90776990f77(superstar, doctor);
        return `${superstar.injuryReturnMin} to ${superstar.injuryReturnMax}`;
    }
}
function $3e29bd9aa5422a42$export$f2f7a90776990f77(superstar, doctor = null) {
    let length = superstar.injured;
    // Get doctor level
    let level = doctor ? doctor.level : 1;
    if (level >= 3 || superstar.workableInjury) {
        superstar.injuryReturnMin = length;
        superstar.injuryReturnMax = length + 1;
        return `${length}`;
    } else {
        let rangeLength;
        if (length < 6) rangeLength = 2;
        else if (length < 10) rangeLength = 4;
        else rangeLength = 6;
        if (level === 2) rangeLength /= 2; // Lower range for level 2 doctor
        // Get random starting point, add range
        let lowerValue = length + (0, $3E8Nt.getRandomInt)(-rangeLength, 0);
        if (lowerValue <= 0) lowerValue = 1;
        let upperValue = lowerValue + rangeLength;
        superstar.injuryReturnMin = lowerValue;
        superstar.injuryReturnMax = upperValue;
        return `${lowerValue} to ${upperValue}`;
    }
}
function $3e29bd9aa5422a42$export$9677c8cb39ec12ef(superstar, championships) {
    let superstarChampionships = championships.filter((x)=>x.superstarId === superstar.$loki);
    let uniqueChampionships = (0, $kZwpB.getUniqueChampionships)(superstarChampionships);
    return uniqueChampionships.map((x)=>x.name);
}
function $3e29bd9aa5422a42$export$c4f17efb5a39bbd0(superstar, allowManagers = true, factionSegment = false, allowWorkableInjury = true) {
    if (allowManagers === false && superstar.fullTimeManager && superstar.activeEffect !== "one_match_appearance") return false;
    // Check injury
    let injuredCheck;
    if (allowWorkableInjury) injuredCheck = superstar.injured > 0 && !superstar.workableInjury;
    else injuredCheck = superstar.injured;
    // For faction segments, don't check retired, no appearances or injured
    let appearancesCheck = superstar.partTimer && superstar.appearances <= 0;
    let retiredCheck = superstar.retired;
    if (factionSegment) {
        retiredCheck = false;
        appearancesCheck = false;
        injuredCheck = false;
    }
    // Skip injured, part timer with no appearances and retired
    if (injuredCheck || appearancesCheck || retiredCheck || superstar.unavailable || superstar.suspensionMonths > 0 || superstar.dead) return false;
    return true;
}
function $3e29bd9aa5422a42$export$e1577a9e85de2a7f(event, superstar, superstarChampionships = null) {
    // Check if any superstar championships are non exclusive or exclusive to this brand
    let allowChampion = false;
    if (superstarChampionships) allowChampion = superstarChampionships.some((x)=>!x.brandName || x.brandName === event.brandName);
    // Return true if superstar passes brand availability check
    let eventBrandName = event ? event.brandName : null;
    let eventActiveEffect = event ? event.activeEffect : null;
    return $3e29bd9aa5422a42$export$b211d81e86f15d10(superstar, eventBrandName, allowChampion, eventActiveEffect);
}
function $3e29bd9aa5422a42$export$b211d81e86f15d10(object, eventBrandName, allowChampion = false, eventActiveEffect = null) {
    // Return true if no event brand name present or object / its championship is not exclusive to a brand or belongs
    // to this brand or event has allow_other_brands active effect
    if (eventBrandName && object.brandName && !allowChampion && ![
        "allow_other_brands",
        "allow_other_brands_extended"
    ].includes(eventActiveEffect)) return object.brandName === eventBrandName;
    return true;
}
function $3e29bd9aa5422a42$export$4aca442b6c73e8b6(s, checkInjured = true) {
    // Skip injured (except workable injury), suspended, unavailable and dead
    if (checkInjured && s.injured > 0 && !s.workableInjury || s.suspensionMonths > 0 || s.unavailable || s.dead) return false;
    return true;
}
async function $3e29bd9aa5422a42$export$fca17f38c9e14a40({ superstar: superstar, scenarioInformation: scenarioInformation = false, doctor: doctor = null, includeChampionships: includeChampionships = true, getTeamsAndFactions: getTeamsAndFactions = false, rosterSuperstars: rosterSuperstars = null, managedSuperstars: managedSuperstars = null, manager: manager = null, managersUsed: managersUsed = null, getCurrentAttire: getCurrentAttire = false, getGimmick: getGimmick = true, superstarChampionships: superstarChampionships = null, superstarTagTeamsAndFactions: superstarTagTeamsAndFactions = null, getTagTeamPartners: getTagTeamPartners = false, getTournamentsWon: getTournamentsWon = false, game: game = null } = {}) {
    // Copy data
    let superstarData = JSON.parse(JSON.stringify(superstar));
    // Get rank
    superstarData["rank"] = $3e29bd9aa5422a42$export$c4599c2b86ea2e7f(superstar.popularity);
    // Check if hot, increase workrate/charisma
    if (superstar.hot && !scenarioInformation) {
        superstarData["charisma"] += 1;
        superstarData["workrate"] += 1;
    }
    // Get injury return time
    if (superstar.injured) superstarData["injuryTime"] = $3e29bd9aa5422a42$export$179bed0d7a969080(superstar, doctor);
    // Get can unlearn traits
    superstarData["canUnlearnTraits"] = $3e29bd9aa5422a42$var$getCanUnlearnTraitsForSuperstar(superstar);
    // Get graphic
    superstarData["graphic"] = $3e29bd9aa5422a42$export$a4c875f55030a528(superstar, getCurrentAttire);
    // Get championships
    if (!scenarioInformation && includeChampionships) {
        superstarData["championships"] = [];
        // Load championships if not present
        if (!superstarChampionships) {
            superstarChampionships = await (0, $hBIDz.getSuperstarChampionships)(superstar);
            // Get freebird championships
            superstarChampionships.push(...await $3e29bd9aa5422a42$export$6ce038e19de65738(superstar));
        }
        // Get unique championships and sort
        superstarChampionships = (0, $kZwpB.getUniqueChampionships)(superstarChampionships);
        superstarChampionships.sort((0, $kZwpB.compareChampionships));
        // Get data for championships
        for (const c of superstarChampionships){
            let d = {};
            d["name"] = c.name;
            d["prestige"] = c.prestige;
            d["matchContract"] = c.matchContract;
            if (c.championshipContract && !c.tagTeam) {
                d["championshipContract"] = true;
                d["championshipUid"] = c.$loki;
            }
            if (c.matchContract) {
                d["matchContract"] = true;
                // Find match contract
                let matchContract = await (0, $ivuOU.getChampionshipMatchContract)(c);
                if (matchContract) d["event"] = (await (0, $1AAHK.getMatchContractEvent)(matchContract))?.name;
            }
            const reign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
            if (reign && game) d["reignLength"] = (0, $8A6FL.getChampionshipReignLength)(reign, game.monthCount, game.year);
            superstarData["championships"].push(d);
        }
        // Get graphic with championships
        if (superstarData["graphic"] && superstarChampionships.length > 0) superstarData["graphic"]["title"] = JSON.parse(JSON.stringify(superstarChampionships[0].graphic));
    }
    // Get teams and factions
    if (getTeamsAndFactions) {
        // Get if passed as argument
        let superstarTagTeams;
        let superstarFactions;
        if (superstarTagTeamsAndFactions) {
            superstarTagTeams = superstarTagTeamsAndFactions.filter((x)=>x.objectName === "tagTeam");
            superstarFactions = superstarTagTeamsAndFactions.filter((x)=>x.objectName === "faction");
        } else {
            superstarTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(superstar)).filter((x)=>!x.temporary);
            superstarFactions = await $3e29bd9aa5422a42$export$fa9de4df2e00da79(superstar);
        }
        superstarData["teams"] = superstarTagTeams.map((x)=>x.name);
        superstarData["factions"] = superstarFactions.map((x)=>x.name);
        if (getTagTeamPartners) {
            superstarData["teamSuperstars"] = [];
            for (let tagTeam of superstarTagTeams)if (!tagTeam.temporary) {
                let members = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                for (let member of members)if (member.$loki !== superstar.$loki) superstarData["teamSuperstars"].push(member.name);
            }
        }
    }
    // Get gimmick
    if (getGimmick) {
        const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(superstar);
        if (superstarGimmick) superstarData["gimmick"] = $3e29bd9aa5422a42$export$64dd7a8588c854d9(superstarGimmick, superstar);
    }
    // Get status
    if (superstar.fullTimeManager) superstarData["status"] = "Manager";
    else {
        if (superstar.partTimer) superstarData["status"] = "Part-timer";
        else if (superstar.retired) superstarData["status"] = "Retired";
        else superstarData["status"] = "Full-time";
    }
    superstarData["uid"] = superstar.$loki;
    if (rosterSuperstars) {
        // Get manager names
        if (managersUsed) manager = await $3e29bd9aa5422a42$export$ceda885e1dfef32e(superstar, managersUsed, rosterSuperstars);
        else {
            manager = rosterSuperstars.find((y)=>y.$loki === superstar.managerId);
            if (!manager) manager = await (0, $hBIDz.getSuperstarManager)(superstar);
        }
        if (manager) superstarData["managerNames"] = [
            manager.name
        ];
        // Get managed talent names
        const managedTalent = await (0, $ycsyu.getManagerManagedTalent)(superstar, rosterSuperstars, false, managedSuperstars);
        superstarData["managedTalentNames"] = managedTalent.map((x)=>x.name);
    }
    // Get tournaments won
    if (!scenarioInformation && getTournamentsWon) {
        superstarData["tournamentsWon"] = [];
        for (let tournament of (await (0, $hBIDz.getSuperstarWonTournaments)(superstar))){
            let tournamentEvent = await (0, $4EGpv.getTournamentEvent)(tournament);
            superstarData["tournamentsWon"].push(`${tournament.name} ${tournamentEvent ? tournamentEvent.year : ""}`);
        }
    }
    return superstarData;
}
function $3e29bd9aa5422a42$var$getCanUnlearnTraitsForSuperstar(superstar) {
    return superstar.traits.filter((x)=>$3e29bd9aa5422a42$export$c31b95768782ee90(x));
}
function $3e29bd9aa5422a42$export$c31b95768782ee90(trait) {
    const traitData = (0, $aP7lq.traitsData)[trait];
    if (traitData) return traitData["can_unlearn"];
    return false;
}
async function $3e29bd9aa5422a42$export$6ce038e19de65738(superstar, companyChampionships = null, superstarTagTeams = null) {
    let championships = [];
    if (!superstarTagTeams) superstarTagTeams = await (0, $hBIDz.getSuperstarTagTeams)(superstar);
    let superstarTrio = superstarTagTeams.find((x)=>x.trio && !x.temporary);
    if (superstarTrio) {
        // Get superstar championships
        const tagChampionshipsAll = [];
        for (const s of (await (0, $972Ip.getTagTeamSuperstars)(superstarTrio))){
            let superstarChampionships;
            if (companyChampionships) superstarChampionships = companyChampionships.filter((x)=>x.superstarId === s.$loki && x.tagTeam);
            else superstarChampionships = (await (0, $hBIDz.getSuperstarChampionships)(s)).filter((x)=>x.tagTeam);
            tagChampionshipsAll.push(...superstarChampionships);
        }
        // Get title sets
        const tagChampionships = (0, $kZwpB.getUniqueChampionships)(tagChampionshipsAll);
        for (const y of tagChampionships){
            const championshipsSets = tagChampionshipsAll.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, y));
            // Check if all sets present in team superstars
            if (championshipsSets.length === 2) championships.push(y);
        }
    }
    return championships;
}
function $3e29bd9aa5422a42$export$64dd7a8588c854d9(gimmick, superstar) {
    let data = {};
    data["name"] = gimmick.name;
    data["effectiveness"] = gimmick.effectiveness;
    data["combinationResult"] = $3e29bd9aa5422a42$export$cd82cdf264b0e6d8(gimmick.combinationBonus);
    data["superstar"] = superstar.name;
    if (gimmick.startMonth) data["startMonths"] = gimmick.startMonth * 12 + gimmick.startYear;
    if (gimmick.endMonth) data["endMonths"] = gimmick.endMonth * 12 + gimmick.endYear;
    return data;
}
function $3e29bd9aa5422a42$export$cd82cdf264b0e6d8(value) {
    if (value > 0) return "easy";
    else if (value < 0) return "hard";
    return "okay";
}
async function $3e29bd9aa5422a42$export$5fdcf304511f31b3(superstar, matchChampionships, managersUsed, rosterSuperstars = null) {
    let championshipSuperstarIds = matchChampionships.map((x)=>x.superstarId);
    let manager = await $3e29bd9aa5422a42$export$ceda885e1dfef32e(superstar, managersUsed, rosterSuperstars);
    return {
        "name": superstar.name,
        "champion": championshipSuperstarIds.indexOf(superstar.$loki) >= 0,
        "uid": superstar.$loki,
        "currentAttire": superstar.currentAttire,
        "alternateAttires": superstar.graphic && superstar.graphic.alternate_attires && superstar.graphic.alternate_attires.length > 0 ? superstar.graphic.alternate_attires.length : null,
        "managerName": manager ? manager.name : null
    };
}
async function $3e29bd9aa5422a42$export$ceda885e1dfef32e(superstar, managersUsed, rosterSuperstars = null) {
    // Get manager from roster superstars to reduce queries to Superstar
    if (managersUsed !== null) {
        const managerId = managersUsed[String(superstar.$loki)];
        if (managerId) {
            let manager;
            if (rosterSuperstars) manager = rosterSuperstars.find((x)=>x.$loki === managerId);
            if (!manager) manager = await (0, $14eBR.Superstars).get(managerId);
            return manager;
        }
    }
    return null;
}
async function $3e29bd9aa5422a42$export$ce43b5f35d3e6e3b(rosterMember) {
    if (rosterMember.objectName === "superstar") return [
        rosterMember
    ];
    else if (rosterMember.objectName === "tagTeam") return (0, $972Ip.getTagTeamSuperstars)(rosterMember);
    else if (rosterMember.objectName === "faction") return (0, $2JFAd.getFactionSuperstars)(rosterMember);
}
function $3e29bd9aa5422a42$export$a4c875f55030a528(superstar, getCurrentAttire = false) {
    // Get superstar's graphic with uid
    let graphic = superstar.graphic ? JSON.parse(JSON.stringify(superstar.graphic)) : null;
    if (getCurrentAttire && superstar.currentAttire > 0 && graphic && graphic["alternate_attires"]) graphic = graphic["alternate_attires"][superstar.currentAttire - 1];
    if (!graphic || Object.keys(graphic).length === 0) // Get empty graphic if none present
    graphic = $3e29bd9aa5422a42$export$adde1e88813de763(superstar);
    graphic["uid"] = superstar.$loki;
    return graphic;
}
function $3e29bd9aa5422a42$export$adde1e88813de763(superstar) {
    const emptyMaleGraphic = {
        "empty_graphic": true,
        "body": {
            "colors": [
                "0x4D4D4D"
            ],
            "object": 0
        },
        "tattoo": {
            "colors": null,
            "object": -1
        },
        "eyes": {
            "colors": [
                "0x353535"
            ],
            "object": 0
        },
        "facepaint": {
            "colors": null,
            "object": -1
        },
        "shoes": {
            "colors": [
                "0x1B1B1B"
            ],
            "object": -1
        },
        "accessory2": {
            "colors": null,
            "object": -1
        },
        "accessory3": {
            "colors": null,
            "object": -1
        },
        "alternate_attires": [],
        "facialHair": {
            "colors": null,
            "object": -1
        },
        "accessory": {
            "colors": null,
            "object": -1
        },
        "hair": {
            "colors": [
                "0x71645F"
            ],
            "object": 0
        },
        "bottoms": {
            "colors": [
                "0x333333"
            ],
            "object": -1
        },
        "elbow": {
            "colors": null,
            "object": -1
        },
        "knee": {
            "colors": null,
            "object": -1
        },
        "torso": {
            "colors": null,
            "object": -1
        }
    };
    const emptyFemaleGraphic = {
        "empty_graphic": true,
        "body": {
            "colors": [
                "0x4D4D4D"
            ],
            "object": 3
        },
        "tattoo": {
            "colors": null,
            "object": -1
        },
        "eyes": {
            "colors": [
                "0x353535"
            ],
            "object": 0
        },
        "facepaint": {
            "colors": null,
            "object": -1
        },
        "shoes": {
            "colors": [
                "0x1B1B1B"
            ],
            "object": -1
        },
        "accessory2": {
            "colors": null,
            "object": -1
        },
        "accessory3": {
            "colors": null,
            "object": -1
        },
        "alternate_attires": [],
        "facialHair": {
            "colors": null,
            "object": -1
        },
        "accessory": {
            "colors": null,
            "object": -1
        },
        "hair": {
            "colors": [
                "0x71645F"
            ],
            "object": 0
        },
        "bottoms": {
            "colors": [
                "0x333333"
            ],
            "object": -1
        },
        "elbow": {
            "colors": null,
            "object": -1
        },
        "knee": {
            "colors": null,
            "object": -1
        },
        "torso": {
            "colors": null,
            "object": -1
        }
    };
    if (superstar.gender === "male") return JSON.parse(JSON.stringify(emptyMaleGraphic));
    else if (superstar.gender === "female") return JSON.parse(JSON.stringify(emptyFemaleGraphic));
    else return JSON.parse(JSON.stringify(emptyMaleGraphic));
}
function $3e29bd9aa5422a42$export$9e7ef561bf3ba9eb(pronoun) {
    if (pronoun === "he") return "male";
    else if (pronoun === "she") return "female";
    return "non-binary";
}
function $3e29bd9aa5422a42$export$ede4139409087a56(graphic) {
    if (!graphic) return false;
    const accessoriesData = (0, $2GWzg.graphicsData)["accessories"];
    const facepaintsData = (0, $2GWzg.graphicsData)["facepaints"];
    let maskFound = false;
    for (const [key, value] of Object.entries(graphic)){
        if ([
            "accessory",
            "accessory2",
            "accessory3"
        ].indexOf(key) >= 0) try {
            if (accessoriesData[value["object"]]["category"] === "mask") {
                maskFound = true;
                break;
            }
        } catch  {}
        else if (key === "facepaint") try {
            if (facepaintsData[value["object"]]["category"] === "mask") {
                maskFound = true;
                break;
            }
        } catch  {}
    }
    return maskFound;
}
function $3e29bd9aa5422a42$export$a00c78583f6a016d(superstar, companyChampionships) {
    return (0, $kZwpB.getUniqueChampionships)(companyChampionships.filter((x)=>x.superstarId === superstar.$loki));
}
async function $3e29bd9aa5422a42$export$fa9de4df2e00da79(superstar) {
    return (await (0, $hBIDz.getSuperstarFactions)(superstar)).filter((x)=>!x.disbanded);
}
function $3e29bd9aa5422a42$export$dc429a710513ee58(superstar) {
    superstar.unhappy = false;
    superstar.morale = 85;
    superstar.contractMonthsRemaining = null;
    return superstar;
}
async function $3e29bd9aa5422a42$export$b7c90e1eb2cd702a(superstar, company) {
    superstar.unhappy = true;
    superstar.morale = 15;
    if (company.userControlled) {
        const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("unhappy", superstar.name);
        await (0, $9esFv.addCompanyCompanyAlerts)(company, [
            newCompanyAlert
        ]);
    }
    return superstar;
}
async function $3e29bd9aa5422a42$export$dc6940d321124923(superstar, month, year) {
    const disbandedFactions = [];
    const superstarFactions = [
        ...await (0, $hBIDz.getSuperstarFactions)(superstar)
    ];
    for (const faction of superstarFactions){
        // Update faction rep (members)
        await (0, $6PzHO.processFactionXpChangeForFaction)({
            faction: faction,
            removedMembers: [
                superstar
            ]
        });
        await (0, $6PzHO.removeSuperstarsFromFaction)(faction, [
            superstar
        ]);
        const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
        if (factionSuperstars.length < 2) {
            await (0, $6PzHO.disbandFaction)(faction, month, year);
            disbandedFactions.push(faction.name);
        }
    }
    return disbandedFactions;
}
async function $3e29bd9aa5422a42$export$21dfb94fe5615e93(superstar) {
    // Remove manager
    const manager = await (0, $hBIDz.getSuperstarManager)(superstar);
    if (manager) await $3e29bd9aa5422a42$export$93d3c67e0b8acba0(manager, [
        superstar
    ]);
    // Remove managed superstars
    const managedSuperstars = await (0, $hBIDz.getSuperstarManagedSuperstars)(superstar);
    if (managedSuperstars.length > 0) await $3e29bd9aa5422a42$export$93d3c67e0b8acba0(superstar, managedSuperstars);
    return true;
}
async function $3e29bd9aa5422a42$export$93d3c67e0b8acba0(manager, superstars) {
    const managedSuperstars = await (0, $hBIDz.getSuperstarManagedSuperstars)(manager);
    for (const superstar of [
        ...superstars
    ])if ((0, $3E8Nt.objectInArray)(superstar, managedSuperstars)) (0, $hBIDz.removeSuperstarManager)(superstar);
    return true;
}
async function $3e29bd9aa5422a42$export$baf1d47eaf764da7(manager, superstars) {
    const managedSuperstars = await (0, $hBIDz.getSuperstarManagedSuperstars)(manager);
    for (const superstar of superstars)if (!(0, $3E8Nt.objectInArray)(superstar, managedSuperstars)) await (0, $hBIDz.setSuperstarManager)(superstar, manager);
    return true;
}
async function $3e29bd9aa5422a42$export$2d642a932620186a(superstar) {
    const data = [];
    const superstarTagTeams = await (0, $hBIDz.getSuperstarTagTeams)(superstar);
    for (const tagTeam of superstarTagTeams){
        if (!tagTeam.temporary) data.push(tagTeam.name);
        await (0, $ko5kE.removeTagTeam)(tagTeam);
    }
    return data;
}
function $3e29bd9aa5422a42$export$406ee22b5cd47066(superstar) {
    superstar.readyToReturn = true;
    superstar.workableInjury = false;
    return true;
}
function $3e29bd9aa5422a42$export$2c1736e89480acb3(superstar, change) {
    superstar.morale += change;
    superstar.morale = (0, $3E8Nt.limitValueBetweenRange)(superstar.morale, 0, 100);
    return superstar.morale;
}
async function $3e29bd9aa5422a42$export$18643886df825496(superstar, tagTeam = null) {
    let championshipsToVacate = await (0, $hBIDz.getSuperstarChampionships)(superstar);
    if (tagTeam) {
        if (tagTeam.trio) championshipsToVacate = championshipsToVacate.filter((x)=>x.trio || x.tagTeam);
        else championshipsToVacate = championshipsToVacate.filter((x)=>x.tagTeam);
    }
    return championshipsToVacate;
}
function $3e29bd9aa5422a42$export$3b758ef63637c454(superstar) {
    let names = superstar.name.split(" ");
    if (names.length === 2 && names[names.length - 1].length > 2) return names[names.length - 1];
    else return superstar.name;
}
async function $3e29bd9aa5422a42$export$3dd7f50c94361964({ superstarUid: superstarUid }) {
    let data = {};
    let superstar = await (0, $14eBR.Superstars).get(superstarUid);
    data["name"] = superstar.name;
    // Check if graphic present
    if (!superstar.graphic || Object.keys(superstar.graphic).length === 0) {
        data["error"] = "no-graphic";
        return data;
    }
    // Check if alternate attires present
    let alternateAttires = superstar.graphic["alternate_attires"];
    if (!alternateAttires || alternateAttires.length <= 0) {
        data["error"] = "no-alternate-attires";
        return data;
    }
    // Set currentAttire to next attire`
    let nextAttire = superstar.currentAttire + 1;
    if (nextAttire > alternateAttires.length) nextAttire = 0;
    superstar.currentAttire = nextAttire;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["name"] = superstar.name;
    data["currentAttire"] = superstar.currentAttire;
    return data;
}
function $3e29bd9aa5422a42$export$4817d36ff076caf2(superstar) {
    return superstar.hot ? superstar.charisma + 1 : superstar.charisma;
}
function $3e29bd9aa5422a42$export$40e51a0db6f1e065(superstar) {
    return superstar.hot ? superstar.workrate + 1 : superstar.workrate;
}
function $3e29bd9aa5422a42$export$ddf95a6fc5193cb6(manager, participant) {
    let graphic = JSON.parse(JSON.stringify(manager.graphic));
    if (!graphic || Object.keys(graphic).length === 0) graphic = $3e29bd9aa5422a42$export$adde1e88813de763(manager);
    graphic = JSON.parse(JSON.stringify(graphic));
    graphic["isManager"] = true;
    graphic["superstarUid"] = participant.$loki;
    return graphic;
}
function $3e29bd9aa5422a42$export$359f35a987dc7d80(superstars, traitEffect) {
    let weights = [];
    for (const superstar of superstars){
        let weight = 1;
        for (const trait of superstar.traits){
            let traitData = (0, $aP7lq.traitsData)[trait];
            if (traitData && traitData[traitEffect]) weight *= 8;
        }
        weights.push([
            superstar,
            weight
        ]);
    }
    return weights;
}
async function $3e29bd9aa5422a42$export$588b8486271c4a24({ changeType: changeType, participants: participants = null, winner: winner = null, win: win = false, weeklyShow: weeklyShow = false, wonChampionships: wonChampionships = null, defendedChampionships: defendedChampionships = null, match: match = null } = {}) {
    let change = 0;
    if (changeType === "matchResult") change = await $3e29bd9aa5422a42$var$getKayfabePointsChangeForMatchResult(participants, winner, win, weeklyShow, match);
    if (changeType === "mainEvent") change = $3e29bd9aa5422a42$var$getKayfabePointsChangeForMainEvent(weeklyShow);
    if (changeType === "championships") change = $3e29bd9aa5422a42$var$getKayfabePointsChangeForChampionships(wonChampionships, defendedChampionships);
    if (changeType === "fotc") change = 30;
    if (changeType === "holyShitMoment") change = 8;
    return Math.floor(change);
}
async function $3e29bd9aa5422a42$var$getKayfabePointsChangeForMatchResult(participants, winner, win, weeklyShow, match) {
    const ranks = {
        "Main Eventer": 3,
        "Upper Midcarder": 2,
        "Lower Midcarder": 1,
        "Jabroni": 0
    };
    // Get win/loss change
    let change = 15;
    if (weeklyShow) change = 5;
    if (!win) change *= -1;
    for (const x of participants)x.tempPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x, x.tempSuperstars); // add to get max, remove below
    // Get change based on ranks and fotc
    let losers = participants.filter((x)=>x.$loki !== winner.$loki);
    const opponentToUse = win ? (0, $3E8Nt.getArrayMaxByProperty)(losers, "tempPopularity") : winner;
    const opponentIsFotc = (await $3e29bd9aa5422a42$export$ce43b5f35d3e6e3b(opponentToUse)).every((x)=>x.faceOfTheCompany);
    let rankChange = opponentIsFotc ? 4 : ranks[$3e29bd9aa5422a42$export$c4599c2b86ea2e7f(opponentToUse.tempPopularity)] || 0;
    if (!weeklyShow) rankChange *= 2;
    change += rankChange;
    // Divide loss by number of opponents
    if (!win) {
        const numberOfOpponents = participants.length - 1;
        if (numberOfOpponents > 0) change /= numberOfOpponents;
    }
    // Add high rating boost
    if (match.rating >= 5) change += 20;
    for (const x of participants)delete x.tempPopularity;
    return change;
}
function $3e29bd9aa5422a42$var$getKayfabePointsChangeForMainEvent(weeklyShow) {
    let change;
    if (weeklyShow) change = 4;
    else change = 12;
    return change;
}
function $3e29bd9aa5422a42$var$getKayfabePointsChangeForChampionships(wonChampionships, defendedChampionships) {
    const championshipsWins = {
        "S": 20,
        "A": 15,
        "B": 8,
        "C": 3
    };
    const championshipsDefences = {
        "S": 12,
        "A": 9,
        "B": 5,
        "C": 2
    };
    let change = 0;
    for (let championship of wonChampionships)change += championshipsWins[championship.prestige];
    for (let championship of defendedChampionships)change += championshipsDefences[championship.prestige];
    return change;
}
function $3e29bd9aa5422a42$export$899c2c022f9af547(superstar, change) {
    superstar.kayfabePoints += change;
    superstar.kayfabePointsTemporary += change;
    return superstar.kayfabePointsTemporary;
}
async function $3e29bd9aa5422a42$export$c7407d2379a271ab(superstar, trait, gimmickMatchName = null) {
    if (!await (0, $hBIDz.getSuperstarRoster)(superstar)) return false;
    if (!(0, $98xmD.globalUser).paid) return false;
    // Check if trait is acquirable
    const traitData = (0, $aP7lq.traitsData)[trait];
    if (traitData && traitData["acquirable"]) {
        // Check trait requirements
        const requirementCheck = $3e29bd9aa5422a42$var$checkAcquireTraitRequirement(superstar, trait);
        if (requirementCheck) {
            // Set gimmick match expert trait if present
            if (trait === "Match Expert" && gimmickMatchName) trait = `${gimmickMatchName} ${trait}`;
            // Check if trait is not present and doesn't conflict
            const superstarTraits = [
                ...superstar.traits
            ];
            const conflictingTraits = [];
            for (const s of superstarTraits)conflictingTraits.push(...(0, $aP7lq.traitsData)[$3e29bd9aa5422a42$export$909918bc78a25e7f(s)]["conflicting_traits"]);
            // Format trait so that match expert sends in 'Match Expert' for conflicting traits check
            if (!superstarTraits.includes(trait) && !conflictingTraits.includes($3e29bd9aa5422a42$export$909918bc78a25e7f(trait))) {
                // Add trait progress
                const traitProgressIncrease = traitData["progress_per_action"];
                if (superstar.traitsProgress[trait]) superstar.traitsProgress[trait] += traitProgressIncrease;
                else superstar.traitsProgress[trait] = traitProgressIncrease;
                // Check if minimum progress achieved, random chance to add trait based on trait progress
                const traitProgress = superstar.traitsProgress[trait];
                if (traitProgress >= traitData["minimum_progress_to_acquire"] && (0, $3E8Nt.getRandomInt)(0, 100) <= traitProgress) {
                    $3e29bd9aa5422a42$var$addTraitToSuperstar(superstar, trait);
                    // Remove trait progress
                    delete superstar.traitsProgress[trait];
                    // Add trait acquired message
                    const talentCompany = await (0, $3E8Nt.getTalentCompany)(superstar);
                    if (talentCompany && talentCompany.userControlled) {
                        const newMessage = await (0, $hekDR.createTraitAcquiredMessage)(superstar, trait, talentCompany);
                        await (0, $9esFv.addCompanyMessages)(talentCompany, [
                            newMessage
                        ]);
                    }
                }
            }
        }
    }
    return true;
}
function $3e29bd9aa5422a42$var$addTraitToSuperstar(superstar, trait) {
    if (!superstar.traits.includes(trait)) superstar.traits.push(trait);
    return superstar.traits;
}
function $3e29bd9aa5422a42$export$909918bc78a25e7f(trait) {
    if (trait.includes("Match Expert")) return "Match Expert";
    return trait;
}
function $3e29bd9aa5422a42$var$checkAcquireTraitRequirement(superstar, trait) {
    function checkTraitRequirementWorkrate(value, operator) {
        if (operator === ">=") {
            if (superstar.workrate >= value) return true;
        } else if (operator === "<=") {
            if (superstar.workrate <= value) return true;
        }
        return false;
    }
    function checkTraitRequirementCharisma(value, operator) {
        if (operator === ">=") {
            if (superstar.charisma >= value) return true;
        } else if (operator === "<=") {
            if (superstar.charisma <= value) return true;
        }
        return false;
    }
    function checkTraitRequirementTrait(value) {
        return superstar.traits.includes(value);
    }
    function checkTraitRequirementWorkrate3StarsOrHigher() {
        return checkTraitRequirementWorkrate(3, ">=");
    }
    function checkTraitRequirementWorkrate2StarsOrHigher() {
        return checkTraitRequirementWorkrate(2, ">=");
    }
    function checkTraitRequirementWorkrate2StarsOrLower() {
        return checkTraitRequirementWorkrate(2, "<=");
    }
    function checkTraitRequirementWorkrate1StarOrLower() {
        return checkTraitRequirementWorkrate(1, "<=");
    }
    function checkTraitRequirementCharisma3StarsOrHigher() {
        return checkTraitRequirementCharisma(3, ">=");
    }
    function checkTraitRequirementDedicatedWrestlerTraitPresent() {
        return checkTraitRequirementTrait("Dedicated Wrestler");
    }
    // Dictionary of check functions
    const checkFunctions = {
        "3*_workrate": checkTraitRequirementWorkrate3StarsOrHigher,
        "2*_workrate_or_higher": checkTraitRequirementWorkrate2StarsOrHigher,
        "2*_workrate_or_lower": checkTraitRequirementWorkrate2StarsOrLower,
        "1*_workrate": checkTraitRequirementWorkrate1StarOrLower,
        "3*_charisma": checkTraitRequirementCharisma3StarsOrHigher,
        "dedicated_wrestler_trait_present": checkTraitRequirementDedicatedWrestlerTraitPresent
    };
    for (const requirement of (0, $aP7lq.traitsData)[trait]["requirements_to_acquire"]){
        const checkFunction = checkFunctions[requirement];
        if (checkFunction && !checkFunction()) return false;
    }
    return true;
}
async function $3e29bd9aa5422a42$export$339607a84a85cd15(superstar, company, producer, month = null, year = null) {
    const superstarGimmicks = (await (0, $hBIDz.getSuperstarGimmicks)(superstar)).reverse();
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Add effectiveness, start month/year
    const gimmick = superstarGimmicks[0];
    const [effectiveness, productionBoost] = $3e29bd9aa5422a42$var$getGimmickEffectiveness(superstar, gimmick, producer);
    gimmick.effectiveness = effectiveness;
    gimmick.startMonth = month;
    gimmick.startYear = year;
    // End previous gimmick
    let oldGimmickEffect = 0;
    if (superstarGimmicks.length > 1) {
        const oldGimmick = superstarGimmicks[1];
        oldGimmick.endMonth = month;
        oldGimmick.endYear = year;
        // Undo previous gimmick's overness effect
        oldGimmickEffect = $3e29bd9aa5422a42$export$aeb467a2e88a2e67(oldGimmick.effectiveness);
        superstar.overness -= oldGimmickEffect;
    }
    // Add new gimmick's overness effect
    const newGimmickEffect = $3e29bd9aa5422a42$export$aeb467a2e88a2e67(gimmick.effectiveness);
    superstar.overness += newGimmickEffect;
    superstar.debutNewGimmick = false;
    const data = $3e29bd9aa5422a42$export$64dd7a8588c854d9(gimmick, superstar);
    data["overnessEffectChange"] = newGimmickEffect - oldGimmickEffect;
    data["productionBoost"] = productionBoost;
    // Add xp to producer
    if (producer) {
        const ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(producer);
        const xpGained = Math.round(5 * ageMultiplier);
        const producerLevelIncrease = await (0, $8A6FL.updateStaffMemberXp)(producer, xpGained, company, game);
        if (producerLevelIncrease) data["staffSkillIncreases"] = {
            "name": producer.name,
            "level": producer.level,
            "role": producer.role
        };
    }
    // Check talent request
    const talentCompany = await (0, $3E8Nt.getTalentCompany)(superstar);
    if (talentCompany) await (0, $1olyO.checkTalentRequestAction)({
        company: talentCompany,
        requestType: "debut_new_gimmick",
        talent: superstar
    });
    return data;
}
function $3e29bd9aa5422a42$var$getGimmickEffectiveness(superstar, gimmick, producer) {
    const charisma = superstar.hot ? superstar.charisma + 1 : superstar.charisma;
    const combinationBase = 15;
    const charismaMultiplier = 14.5;
    let minimumValue, maximumValue;
    if (gimmick.combinationBonus === 10) {
        minimumValue = combinationBase;
        maximumValue = combinationBase * 2;
    } else if (gimmick.combinationBonus === 0) {
        minimumValue = 0;
        maximumValue = combinationBase;
    } else {
        minimumValue = combinationBase * -1;
        maximumValue = 0;
    }
    minimumValue += charisma ** 1.35 * charismaMultiplier;
    maximumValue += charisma ** 1.35 * charismaMultiplier;
    // Get trait boost for gimmick character
    let traitBoost = 0;
    if (gimmick.character) {
        let gimmickCharacterData = (0, $fuJHb.charactersData).find((x)=>x["name"] === gimmick.character);
        if (gimmickCharacterData) for (const trait of superstar.traits){
            const traitData = (0, $aP7lq.traitsData)[trait];
            if (gimmickCharacterData["tag"] === "fantasy") {
                if (traitData && traitData["fantasy_gimmick_character_boost"]) traitBoost += traitData["fantasy_gimmick_character_boost"];
            }
            if (gimmickCharacterData["tag"] !== "fantasy") {
                if (traitData && traitData["non_fantasy_gimmick_character_boost"]) traitBoost += traitData["non_fantasy_gimmick_character_boost"];
            }
            if (traitData && traitData["gimmick_boost"]) traitBoost += traitData["gimmick_boost"];
            if (gimmick.combinationBonus <= -10) {
                if (traitData && traitData["bad_combination_gimmick_boost"]) traitBoost += traitData["bad_combination_gimmick_boost"];
            }
        }
    }
    traitBoost = (0, $3E8Nt.limitValueBetweenRange)(traitBoost, -40, 20);
    let startingEffectiveness = Math.floor((0, $3E8Nt.getRandomUniform)(minimumValue, maximumValue)) + gimmick.characterBonus + traitBoost;
    // Add producer multiplier
    const producerMultipliers = {
        1: 0,
        2: 8,
        3: 15
    };
    const producerLevel = producer ? producer.level : 1;
    let producerBoost = producerMultipliers[producerLevel] || 0;
    if (producerBoost) producerBoost += (0, $3E8Nt.getRandomInt)(-2, 2);
    let effectiveness = startingEffectiveness + producerBoost;
    // Limit effectiveness between 0 and 100
    effectiveness = (0, $3E8Nt.limitValueBetweenRange)(effectiveness, 0, 100);
    return [
        effectiveness,
        producerBoost
    ];
}
async function $3e29bd9aa5422a42$export$b2688aa0818c112c(superstar, matchParticipants, opponentSuperstars, matchGimmick, holyShitData, tournament, company, game) {
    // Defaults
    let injuryMonths = 0;
    let injuryName = null;
    let injuryType = null;
    let injuryChance = null;
    // Don't check injury if turned off in sandbox mode
    if (game.settings["no_injuries"]) return {
        "months": injuryMonths,
        "type": injuryType,
        "chance": injuryChance,
        "name": injuryName
    };
    // Don't let cyborgs get injured
    if (superstar.cyborg) return {
        "months": injuryMonths,
        "type": injuryType,
        "chance": injuryChance,
        "name": injuryName
    };
    if (company) {
        // Don't let stars get injured in POW
        if (company.storyName === "passion" && [
            "Lady Julia",
            "Violet",
            "Natasha Ali",
            "Zora"
        ].includes(superstar.name)) return {
            "months": injuryMonths,
            "type": injuryType,
            "chance": injuryChance,
            "name": injuryName
        };
        if (company.storyName === "tutorial") {
            // Force injury
            let tutorialState = await (0, $8A6FL.getTutorialStateName)(company);
            if (tutorialState === "play_first_event" && superstar.name === "Chris Gray") {
                injuryMonths = 6;
                injuryType = "minor";
                injuryName = (0, $3E8Nt.getRandomChoice)((0, $4rksk.injuriesData)[injuryType]["names"]);
                return {
                    "months": injuryMonths,
                    "type": injuryType,
                    "chance": injuryChance,
                    "name": injuryName
                };
            } else if (tutorialState !== "end_tutorial") return {
                "months": injuryMonths,
                "type": injuryType,
                "chance": injuryChance,
                "name": injuryName
            };
        }
    }
    // Get injury chance
    injuryChance = await $3e29bd9aa5422a42$var$getSuperstarInjuryChance(superstar, matchParticipants, opponentSuperstars, matchGimmick, holyShitData, tournament, company, game);
    // Check for injury
    if ((0, $3E8Nt.getRandomUniform)(0, 100) <= injuryChance) [injuryMonths, injuryName, injuryType] = $3e29bd9aa5422a42$var$getInjuryDetails(superstar, game);
    return {
        "months": injuryMonths,
        "type": injuryType,
        "chance": injuryChance,
        "name": injuryName
    };
}
async function $3e29bd9aa5422a42$var$getSuperstarInjuryChance(superstar, matchParticipants, opponentSuperstars, matchGimmick, holyShitData, tournament, company, game) {
    // Injury chance is a percentage
    // Set default value
    let injuryChance = 1.0;
    // Increase by match gimmick's injury rate
    if (matchGimmick) injuryChance *= matchGimmick.injuryRate;
    // Increase for holy shit moment
    if (holyShitData) injuryChance *= 1.4;
    // Slight increase for pure companies
    if (company && company.style === "pure") injuryChance += 0.1;
    // Decrease injury chance by tournament rounds
    if (tournament) injuryChance /= tournament.rounds;
    // Decrease injury chance by number of superstars
    let matchSuperstars = (await Promise.all(matchParticipants.map((x)=>$3e29bd9aa5422a42$export$ce43b5f35d3e6e3b(x)))).flat();
    const numberOfSuperstars = matchSuperstars.length;
    injuryChance /= numberOfSuperstars * 0.5;
    // Get injury chance trait multiplier, increase superstar injury chance if found
    for (const trait of superstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["injury_chance_multiplier"]) injuryChance *= traitData["injury_chance_multiplier"];
    }
    // Get dangerous worker trait from opponent superstars, increase superstar injury chance if found
    let superstarInjuryChanceMultiplier = 1;
    for (const opponentSuperstar of opponentSuperstars)for (const trait of opponentSuperstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["cause_injury_chance_multiplier"]) superstarInjuryChanceMultiplier = traitData["cause_injury_chance_multiplier"];
    }
    injuryChance *= superstarInjuryChanceMultiplier;
    // Add fatigue effect if enabled
    if (game.settings["enable_fatigue"] !== false) injuryChance *= $3e29bd9aa5422a42$var$getFatigueInjuryChance(superstar);
    // Add workable injury chance
    if (superstar.workableInjury) injuryChance += 15;
    // Decrease chance of multiple injuries in a period
    if (company) {
        const injuries3Months = (await (0, $9esFv.getCompanyCompanyLogs)(company)).filter((x)=>x.type === "injury" && x.value !== 0 && (0, $3E8Nt.getMonthsDifference)(game.monthCount, game.year, x.month, x.year) <= 3);
        if (injuries3Months.length >= 3) injuryChance *= 0.6;
    }
    // Limit value
    injuryChance = (0, $3E8Nt.limitValueBetweenRange)(injuryChance, 0, 30);
    return injuryChance;
}
function $3e29bd9aa5422a42$var$getFatigueInjuryChance(superstar) {
    // Injury chance rises exponentially with fatigue, from 0.5% to 20%
    return 1.055 ** (superstar.fatigue / 1.15) / 4.2 + 0.25;
}
function $3e29bd9aa5422a42$var$getInjuryDetails(superstar, game) {
    // Returns injury months, name and type
    let injuryType = null;
    let injuryName = null;
    let injuryMonths = null;
    // Get severe version of workable injury
    if (superstar.workableInjury) {
        injuryName = (0, $4rksk.injuriesData)["workable"]["severe_versions"][superstar.injuryName];
        injuryType = Object.keys((0, $4rksk.injuriesData)).find((k)=>(0, $4rksk.injuriesData)[k]["names"].includes(injuryName));
        if (injuryType) {
            const injuryData = (0, $4rksk.injuriesData)[injuryType];
            injuryMonths = (0, $3E8Nt.getRandomInt)(injuryData["months_min"], injuryData["months_max"]);
        }
    }
    // Get random injury if not working through injury or severe version not found
    if (!injuryType) {
        // Get injury type from chances
        injuryType = (0, $3E8Nt.weightedChoice)($3e29bd9aa5422a42$var$getInjuryTypeChances(superstar, game));
        // Get injury name and months
        const injuryData = (0, $4rksk.injuriesData)[injuryType];
        injuryName = (0, $3E8Nt.getRandomChoice)(injuryData["names"]);
        injuryMonths = (0, $3E8Nt.getRandomInt)(injuryData["months_min"], injuryData["months_max"]);
    }
    return [
        injuryMonths,
        injuryName,
        injuryType
    ];
}
function $3e29bd9aa5422a42$var$getInjuryTypeChances(superstar, game) {
    // Get workable injury chance
    const workableInjuryChance = $3e29bd9aa5422a42$var$getWorkableInjuryChance(superstar, game);
    let remainingChance = 100 - workableInjuryChance;
    // Get major/minor injury chances. Major vs minor injury chance is 1:3.
    let majorInjuryChance = Math.floor(0.25 * remainingChance);
    let minorInjuryChance = remainingChance - majorInjuryChance;
    return [
        [
            "workable",
            workableInjuryChance
        ],
        [
            "minor",
            minorInjuryChance
        ],
        [
            "major",
            majorInjuryChance
        ]
    ];
}
function $3e29bd9aa5422a42$var$getWorkableInjuryChance(superstar, game) {
    // Fatigue affects chance, low fatigue is more likely to cause workable injury
    let workableInjuryChance;
    if (game.settings["enable_fatigue"] !== false) {
        if (superstar.fatigue > 80) workableInjuryChance = 5;
        else if (superstar.fatigue > 40) workableInjuryChance = 20;
        else workableInjuryChance = 30;
    } else workableInjuryChance = 25;
    return workableInjuryChance;
}
async function $3e29bd9aa5422a42$export$308b59438e406dc4(superstar, injuryMonths, injuryName, injuryType, company) {
    superstar.injured += injuryMonths;
    superstar.injuryName = injuryName;
    superstar.injuredAtLatestShow = true;
    superstar.workableInjury = injuryType === "workable";
    // Check talent request
    if (company) await (0, $1olyO.checkTalentRequestAction)({
        company: company,
        requestType: "write_off",
        talent: superstar
    });
    return true;
}
function $3e29bd9aa5422a42$export$8fa23b05ac79c55e(superstar, injuryMonths) {
    if (superstar.workableInjury) superstar.injured = injuryMonths;
    else superstar.injured += injuryMonths;
    superstar.workableInjury = false;
    superstar.injuryName = null;
    superstar.injuryReturnMin = superstar.injured;
    superstar.injuryReturnMax = superstar.injured + 1;
    return true;
}
function $3e29bd9aa5422a42$export$fdeab6e4077e48af(superstar) {
    const workThroughInjuryTraits = [
        "Workhorse",
        "Dedicated Wrestler",
        "Lifelong Wrestler",
        "Loyal"
    ];
    return workThroughInjuryTraits.some((x)=>superstar.traits.includes(x));
}
async function $3e29bd9aa5422a42$export$ad637ca5c842779a(superstar, chance = 20) {
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= chance) {
        const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(superstar);
        if (superstarGimmick) {
            superstarGimmick.nextGimmickBoost = true;
            return true;
        }
    }
    return false;
}
function $3e29bd9aa5422a42$export$92e6a245bdb408b0(graphic) {
    // Remove hair
    graphic = JSON.parse(JSON.stringify(graphic));
    if (graphic["hair"]) graphic["hair"]["object"] = 0;
    // Remove hair on alternate attires
    const alternateAttires = graphic.alternate_attires;
    if (alternateAttires) {
        const newAlternateAttires = [];
        for (const alt of alternateAttires){
            let altGraphic = JSON.parse(JSON.stringify(alt));
            altGraphic.hair.object = 0;
            newAlternateAttires.push(altGraphic);
        }
        graphic.alternate_attires = newAlternateAttires;
    }
    return graphic;
}
function $3e29bd9aa5422a42$export$687301cd06d6f499(graphic) {
    let accessoriesData = (0, $2GWzg.graphicsData)["accessories"];
    let facepaintsData = (0, $2GWzg.graphicsData)["facepaints"];
    for (const [k, v] of Object.entries(graphic)){
        let remove = false;
        if ([
            "accessory",
            "accessory2",
            "accessory3"
        ].includes(k)) try {
            if (accessoriesData[v["object"]]["category"] === "mask") remove = true;
        } catch  {}
        if ([
            "facepaint"
        ].includes(k)) try {
            if (facepaintsData[v["object"]]["category"] === "mask") remove = true;
        } catch  {}
        if (remove) {
            // Remove mask
            graphic = JSON.parse(JSON.stringify(graphic));
            graphic[k]["object"] = -1;
            // Remove mask on alternate attires
            const alternateAttires = graphic.alternate_attires;
            if (alternateAttires) {
                const newAlternateAttires = [];
                for (const alt of alternateAttires){
                    let altGraphic = JSON.parse(JSON.stringify(alt));
                    altGraphic[k]["object"] = -1;
                    newAlternateAttires.push(altGraphic);
                }
                graphic.alternate_attires = newAlternateAttires;
            }
        }
    }
    return graphic;
}
function $3e29bd9aa5422a42$export$6bf0842608a5a5e(graphic, gender) {
    graphic = JSON.parse(JSON.stringify(graphic));
    // Select hair
    let hairsChoices = [
        ...(0, $2GWzg.graphicsData)["hairs"]
    ];
    if (gender === "male" && (0, $3E8Nt.getRandomInt)(0, 100) <= 80) hairsChoices = hairsChoices.filter((x)=>x["style"] === "masculine");
    else if (gender === "female" && (0, $3E8Nt.getRandomInt)(0, 100) <= 80) hairsChoices = hairsChoices.filter((x)=>x["style"] === "feminine");
    const hairObject = (0, $3E8Nt.getRandomChoice)(hairsChoices);
    const hairObjectNumber = hairObject["number"];
    // Select hair color
    let hairColor = null;
    // Get hair color using facial hair color if present
    if (graphic["facialHair"]["object"] > 0) hairColor = graphic["facialHair"]["colors"][0];
    // Otherwise get new color
    if (!hairColor) hairColor = (0, $3E8Nt.getHairColor)();
    // Add hair colors for each design in hair object
    const hairColors = new Array(hairObject["designs"]).fill(hairColor);
    // Add hair
    graphic["hair"]["object"] = hairObjectNumber;
    graphic["hair"]["colors"] = hairColors;
    // Add hair on alternate attires
    const alternateAttires = graphic.alternate_attires;
    if (alternateAttires) {
        const newAlternateAttires = [];
        for (const alt of alternateAttires){
            let altGraphic = JSON.parse(JSON.stringify(alt));
            altGraphic["hair"]["object"] = hairObjectNumber;
            altGraphic["hair"]["colors"] = hairColors;
            newAlternateAttires.push(altGraphic);
        }
        graphic.alternate_attires = newAlternateAttires;
    }
    return graphic;
}
function $3e29bd9aa5422a42$export$13bc0913f434c9c1(superstar, change) {
    superstar.fatigue += change;
    return superstar.fatigue;
}
function $3e29bd9aa5422a42$export$e36d9f679272d2ae(superstar, matchGimmick, matchParticipants, weeklyShow, matchType, tournament) {
    // Base change for a superstar per match
    let change = 20;
    if (superstar.age > 40 && !superstar.traits.includes("Ages Well")) // Higher for older superstar
    change = 23;
    // Lower change by number of participants
    if (matchParticipants.length > 2) {
        // Participant decrease is 1-10
        let participantsDecrease;
        if (matchParticipants.length > 11) participantsDecrease = 10;
        else participantsDecrease = matchParticipants.length - 2;
        change -= participantsDecrease;
    }
    // Increase change for gimmick match
    if (matchGimmick) {
        let matchGimmickFatigueIncrease = (0, $8A6FL.getMatchGimmickFatigueIncrease)(matchGimmick);
        // Check for traits that affect gimmick match fatigue increase
        for (let trait of superstar.traits){
            let traitData = (0, $aP7lq.traitsData)[trait];
            // Get gimmick match expert trait data
            if (trait.includes("Match Expert") && matchGimmick.name === trait.split(" Match Expert")[0]) traitData = (0, $aP7lq.traitsData)["Match Expert"];
            if (traitData && traitData["gimmick_match_fatigue_multiplier"]) matchGimmickFatigueIncrease *= traitData["gimmick_match_fatigue_multiplier"];
        }
        change += matchGimmickFatigueIncrease;
    }
    // Lower change for weekly show
    if (weeklyShow) change *= 0.8;
    // Lower change for tag match
    if (matchType === "tag") change -= 3;
    // Check for traits that affect fatigue change
    for (let trait of superstar.traits){
        let traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["weekly_show_match_fatigue_change"] && weeklyShow) change += traitData["weekly_show_match_fatigue_change"];
        if (traitData && traitData["monthly_event_match_fatigue_change"] && !weeklyShow) change += traitData["monthly_event_match_fatigue_change"];
    }
    // Lower change by tournament rounds
    if (tournament) {
        if (tournament.rounds > 9) // Keeps change at same value for 10 or more rounds
        change *= 4.5 / tournament.rounds;
        else change -= tournament.rounds;
    }
    // Minimum change
    if (change <= 1) change = 1;
    return Math.round(change);
}
function $3e29bd9aa5422a42$export$4f6246b9b04b9b97(superstar, popularityChange, decrease = false, hotMatch = false, isSegment = false) {
    // Popularity change is positive integer for matches, positive or negative for segments
    let newPopularity;
    if (decrease) newPopularity = superstar.popularity - popularityChange;
    else newPopularity = superstar.popularity + popularityChange;
    // Logarithmic change
    if (newPopularity > 1000 || superstar.faceOfTheCompany) {
        try {
            // New fotc
            if (superstar.popularity < 1000) {
                let over1000Value = newPopularity - 1000;
                if (over1000Value >= 1) popularityChange = Math.round(Math.log2(over1000Value) * 1.75) + (1000 - superstar.popularity);
            } else {
                if (Math.abs(popularityChange) >= 1) popularityChange = Math.round(Math.log2(Math.abs(popularityChange)) * 1.75);
                if (isSegment && popularityChange < 0) // Reverse popularity change for segments as value can be negative
                popularityChange *= -1;
            }
        } catch (error) {
            (0, $3E8Nt.captureError)(error);
        }
        // Increase if hot match
        if (decrease && hotMatch) popularityChange *= -0.5;
    }
    if (decrease) superstar.popularity -= popularityChange;
    else superstar.popularity += popularityChange;
    return popularityChange;
}
async function $3e29bd9aa5422a42$export$ca9087d6b9f24306({ changeType: changeType, matchParticipants: matchParticipants = null, positive: positive = false, popularityDifference: popularityDifference = null, weeklyShow: weeklyShow = false, championship: championship = null, feudParticipants: feudParticipants = null } = {}) {
    let change;
    if (changeType === "match_result") change = await $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForMatch(matchParticipants, popularityDifference, weeklyShow, positive);
    else if (changeType === "championship_result") change = $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForChampionship(championship, positive);
    else if (changeType === "championship_match") change = $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForChampionshipMatch(championship);
    else if (changeType === "main_event") change = $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForMainEvent(weeklyShow);
    else if ([
        "hot_match",
        "hot_feud",
        "hot_segment"
    ].includes(changeType)) change = 5;
    else if (changeType === "feud_started") change = await $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForFeudStarted(feudParticipants, popularityDifference);
    else if (changeType === "silly_failure") change = -5;
    else if (changeType === "annual_tournament_won") change = 20;
    return Math.round(change);
}
async function $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForMatch(participants, popularityDifference, weeklyShow, positive) {
    let change = 5;
    if (positive) {
        if (popularityDifference >= 0) {
            change -= popularityDifference / 200;
            if (change < 0) change = 0;
        } else {
            change += popularityDifference / -40;
            if (change > 15) change = 15;
        }
    } else if (popularityDifference >= 0) {
        change += popularityDifference / 25;
        if (change > 25) change = 25;
    } else {
        change -= popularityDifference / -200;
        if (change < 0) change = 0;
    }
    // Divide match loss morale change by number of opponents
    if (!positive) {
        const numberOfOpponents = participants.length - 1;
        if (numberOfOpponents > 0) change /= numberOfOpponents;
    }
    if (weeklyShow) change /= 2;
    if (!positive) change *= -1;
    let superstars = (await Promise.all(participants.map((x)=>$3e29bd9aa5422a42$export$ce43b5f35d3e6e3b(x)))).flat();
    if (superstars.every((s)=>s.faceOfTheCompany)) change /= 3;
    return change;
}
function $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForChampionship(championship, positive) {
    const championshipsWins = {
        "S": 15,
        "A": 12,
        "B": 10,
        "C": 8
    };
    let change = championshipsWins[championship.prestige];
    if (!positive) change *= -1;
    return change;
}
function $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForChampionshipMatch(championship) {
    const championshipsMatches = {
        "S": 4,
        "A": 3,
        "B": 2,
        "C": 1
    };
    return championshipsMatches[championship.prestige];
}
async function $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForFeudStarted(participants, popularityDifference) {
    let change = 0;
    if (Math.abs(popularityDifference) >= 200) {
        if (popularityDifference >= 0) {
            change -= popularityDifference / 30;
            if (change < -20) change = -20;
        } else {
            change += popularityDifference / -40;
            if (change > 15) change = 15;
        }
    }
    let superstars = (await Promise.all(participants.map((x)=>$3e29bd9aa5422a42$export$ce43b5f35d3e6e3b(x)))).flat();
    if (superstars.every((s)=>s.faceOfTheCompany)) change /= 3;
    return change;
}
function $3e29bd9aa5422a42$var$getSuperstarMoraleChangeForMainEvent(weeklyShow) {
    let change;
    if (weeklyShow) change = 1;
    else change = 3;
    return change;
}
async function $3e29bd9aa5422a42$export$5663676ffa021cfc({ superstar: superstar, championships: championships, month: month, year: year, tagTeam: tagTeam = null, company: company = null, checkTalentRequest: checkTalentRequest = false, championshipsToVacate: championshipsToVacate = null }) {
    const vacated = [];
    if (!championshipsToVacate) championshipsToVacate = await $3e29bd9aa5422a42$export$18643886df825496(superstar, tagTeam);
    for (let c of championshipsToVacate)if (!c.vacated) {
        const championshipsSet = championships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, c) && !x.vacated);
        for (let championship of championshipsSet){
            championship.vacated = true;
            const champion = await (0, $ivuOU.getChampionshipSuperstar)(championship);
            champion.popularity -= (0, $8A6FL.getChampionshipPopularityDecrease)(championship);
            await (0, $hBIDz.removeSuperstarChampionships)(champion, [
                championship
            ]);
            // End current reign
            const oldReign = await (0, $ivuOU.getChampionshipCurrentReign)(championship);
            if (oldReign) {
                oldReign.endMonth = month;
                oldReign.endYear = year;
                oldReign.vacated = true;
            }
        }
        vacated.push((0, $kZwpB.getChampionshipMatchData)(c));
        // Check talent request
        if (checkTalentRequest) {
            let requestData = {
                "championshipId": c.$loki
            };
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "vacate_championship",
                talent: superstar,
                data: requestData
            });
        }
    }
    return vacated;
}
function $3e29bd9aa5422a42$export$aeb467a2e88a2e67(effectiveness) {
    if (effectiveness === null) return 0;
    if (effectiveness >= 80) return 10;
    else if (effectiveness >= 60) return 5;
    else if (effectiveness >= 40) return 0;
    else if (effectiveness >= 20) return -5;
    else if (effectiveness >= 0) return -10;
    else return 0;
}
async function $3e29bd9aa5422a42$export$dc795dacb32dbe0a(superstar, roster, championships, month, year, company) {
    let data = {};
    let rosterCompany = await (0, $dl5u4.getRosterCompany)(roster);
    if (!superstar.dead) {
        // Set retired, part timer and appearances
        superstar.retired = true;
        superstar.partTimer = false;
        superstar.appearances = null;
        // Add company alert
        if (rosterCompany && rosterCompany.userControlled) {
            let newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("superstarRetired", superstar.name);
            await (0, $9esFv.addCompanyCompanyAlerts)(rosterCompany, [
                newCompanyAlert
            ]);
        }
        if (rosterCompany) {
            // Check talent request
            await (0, $1olyO.checkTalentRequestAction)({
                company: rosterCompany,
                requestType: "write_off",
                talent: superstar
            });
            // Add to log
            const newLog = (0, $4K85d.CompanyLog)(month, year);
            (0, $14eBR.CompanyLogs).insert(newLog);
            newLog.text = superstar.name;
            newLog.type = "retirement";
            await (0, $9esFv.addCompanyCompanyLogs)(rosterCompany, [
                newLog
            ]);
        }
    }
    // Vacate championships
    data["vacated"] = await $3e29bd9aa5422a42$export$5663676ffa021cfc({
        superstar: superstar,
        championships: championships,
        month: month,
        year: year,
        company: company,
        checkTalentRequest: true
    });
    // Remove tag teams
    data["tagTeams"] = [];
    for (const tagTeam of (await (0, $hBIDz.getSuperstarTagTeams)(superstar))){
        await (0, $ko5kE.removeTagTeam)(tagTeam);
        if (!tagTeam.temporary) data["tagTeams"].push(tagTeam.name);
    }
    // Get hall of fame ceremony text
    if (superstar.popularity >= 780 && !superstar.hallOfFamer) {
        superstar.hallOfFamer = true;
        data["hallOfFame"] = $3e29bd9aa5422a42$var$generateHallOfFameText(superstar, await (0, $dl5u4.getRosterSuperstars)(roster));
    } else data["hallOfFame"] = false;
    data["name"] = superstar.name;
    return data;
}
function $3e29bd9aa5422a42$var$generateHallOfFameText(superstar, rosterSuperstars) {
    const data = [];
    const speeches = [
        `They say you can be anything you want. They say a lot of stuff, really, and almost all of it is bs. ` + `Well, ever since I was a child, I wanted to be a wrestler. And someone told me I could. That's all I ` + `needed. Ever since then, every ounce of my soul has gone into it: from watching the superstars on ` + `the TV, to attending my local indie wrestling promotion, to ` + `training at the dojo, all the way to getting to the big leagues. It's been long and hard, and at times ` + `almost impossible to keep hope. Losses, injuries, being fired. It's not an easy life. Divorces. ` + `No, it's never been easy. I didn't expect it to be. But I couldn't stop. I had to wrestle. If you want ` + `anything as bad, don't stop. Work hard enough and, with some luck, you'll end up somewhere here. ` + `You can be anything you want. Thank you.`,
        `You don't know how surreal this is, ha ha. I've seen so many of these speeches ... I couldn't imagine ` + `giving one myself. You people have brought me here, thank you so much for that. Thanks to all the ` + `wrestlers in the back. ${(0, $3E8Nt.getRandomChoice)(rosterSuperstars).name} for the advice that took me one step further, ` + `always. ${(0, $3E8Nt.getRandomChoice)(rosterSuperstars).name}, man, I had so much ` + `fun messing around with you. To all the management for believing in me. ` + `I just can't believe this. Maybe in a few weeks I'll get used to being a Hall of Famer. ` + `It's been a hell of a ride.`,
        `Thank you. You know, they told me at one point that wrestling was not for me. They told me to quit, ` + `to go get a real job. They didn't know the passion, the love and the desire to get in that ring that ` + `I had. They couldn't ... they couldn't feel it. But every wrestler here knows it. I'm damn sure. ` + `Don't you dare believe anyone who tells you to stop doing this, doing what you love. Look around you ` + `... do it for these fans. They'll love you for it, more than you can imagine. And I love them back ` + `just as much.`
    ];
    const comments = [
        `${superstar.name} was one of the best in the business.`,
        `It was, indeed, a privilege to work with ${superstar.name}.`,
        `${superstar.name} deserves to go into the hall of fame. A legend, for sure.`,
        `${superstar.name} was and still is one of my idols, someone who I grew up watching. All I can say about the induction is, about damn time, huh?`,
        `The contributions ${superstar.name} made to the wrestling business will never be forgotten.`,
        `${superstar.age} was still too soon for ${superstar.name}'s retirement, but there are times when you have to think about other chapters of your life.`,
        `${superstar.name} was one of the greatest of all time, no doubt about it.`,
        `I remember one day ${superstar.name} stole my towel. I think ${superstar.pronoun} still has it.`,
        `One night, I was teaming up with ${superstar.name} and I was nervous. ${superstar.name} told me to look at the twenty thousand people all around us, told me they all came to see us and that we were gonna send them home happy. We had a classic match that night.`,
        `The fans would be hard pressed to find a better match of mine than the one I had with ${superstar.name}.`,
        `You know those superstars that just have 'it'. I don't know what that is, but I know for sure that ${superstar.name} did have it.`,
        `This is a sad day for our business and for me. But ${superstar.name} has left us inspired to continue to be the best we can.`,
        `Today, it is my honor to induct ${superstar.name} into the Hall of Fame. ${superstar.name} had an illustrious career, one that helped this company in more ways than I can count. But ${superstar.name} also helped all of us, all of the superstars in the back. ${superstar.name} was a joy to be around, an enthusiastic worker, a great friend, and now, deservedly, a legend.`
    ];
    // Randomize choices
    (0, $3E8Nt.shuffle)(comments);
    let superstars = [
        ...rosterSuperstars
    ];
    (0, $3E8Nt.shuffle)(superstars);
    // Add comments by other superstars
    let limit = superstars.length < 3 ? superstars.length : 3;
    for (let x of Array(limit).keys()){
        let comment = {};
        comment["content"] = comments[x];
        comment["superstar"] = superstars[x].name;
        data.push(comment);
    }
    // Add speech by superstar
    let speech = {};
    speech["content"] = (0, $3E8Nt.getRandomChoice)(speeches);
    speech["superstar"] = superstar.name;
    data.push(speech);
    return data;
}
async function $3e29bd9aa5422a42$export$38f3d5b1cd2f9010(roster, month, year) {
    // Go through roster's superstars, checking if monthToAppearIn is equal or lesser than months played
    const toAdd = [];
    const months = year * 12 + month;
    for (const superstar of (await (0, $dl5u4.getRosterSuperstars)(roster)))if (superstar.monthToAppearIn !== null && superstar.monthToAppearIn <= months) toAdd.push(superstar);
    return toAdd;
}
async function $3e29bd9aa5422a42$export$69abe7df5c990393(superstar, roster) {
    await (0, $dl5u4.addRosterSuperstars)(roster, [
        superstar
    ]);
    superstar.monthToAppearIn = null;
    return superstar;
}
function $3e29bd9aa5422a42$export$d6a418b13952faaf(superstar, event) {
    if (superstar.temporaryInjury) {
        const superstarGraphic = superstar.graphic;
        if (superstarGraphic) {
            if (superstarGraphic["temporaryInjury"]) // Remove temporary injury graphic if set (removed after 1 event on which superstar is available)
            {
                if ($3e29bd9aa5422a42$export$e1577a9e85de2a7f(event, superstar)) {
                    superstar.graphic = $3e29bd9aa5422a42$var$removeSuperstarGraphicKey(superstarGraphic, "temporaryInjury");
                    superstar.temporaryInjury = null;
                }
            } else // Add temporary injury graphic if not set (added after event)
            superstar.graphic = $3e29bd9aa5422a42$var$addSuperstarGraphicTemporaryInjury(superstarGraphic, superstar.temporaryInjury);
        } else superstar.temporaryInjury = null;
    }
    return superstar;
}
function $3e29bd9aa5422a42$export$bd997919facd8b02(superstar) {
    // Remove trophy graphic if set (removed after 1 month)
    const superstarGraphic = superstar.graphic;
    if (superstarGraphic && typeof superstarGraphic === "object" && superstarGraphic["temporaryTrophy"]) superstar.graphic = $3e29bd9aa5422a42$var$removeSuperstarGraphicKey(superstarGraphic, "temporaryTrophy");
    return superstar;
}
async function $3e29bd9aa5422a42$export$d77fe2ada004eaf5(superstar, company, disbandTagTeams = true, addNews = true, transfer = true) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
    const indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
    const month = game.monthCount;
    const year = game.year;
    // Vacate championships
    const vacated = [];
    const vacatedChampionships = await $3e29bd9aa5422a42$export$5663676ffa021cfc({
        superstar: superstar,
        championships: await (0, $9esFv.getCompanyChampionships)(company),
        month: month,
        year: year
    });
    if (vacatedChampionships.length > 0) vacated.push(...vacatedChampionships);
    // Disband tag teams
    let disbanded = [];
    if (disbandTagTeams) disbanded = await $3e29bd9aa5422a42$export$2d642a932620186a(superstar);
    // Remove relationships
    await $3e29bd9aa5422a42$export$dc6940d321124923(superstar, month, year);
    await $3e29bd9aa5422a42$export$21dfb94fe5615e93(superstar);
    superstar.brandName = null;
    // Remove feuds
    for (const feud of (await (0, $hBIDz.getSuperstarFeuds)(superstar)))if (!feud.ended) {
        feud.ended = true;
        feud.endMonth = month;
        feud.endYear = year;
        // For ending potential feuds
        if (!feud.started) feud.rating = null;
        else feud.rating = await (0, $cXLSF.getFeudRating)(feud);
    }
    // Transfer talent
    if (transfer) {
        if (game.settings["all_indies_available"]) await (0, $jpMCP.transferTalentToRoster)(superstar, indieAvailableRoster, false);
        else await (0, $jpMCP.transferTalentToRoster)(superstar, indieRoster, false);
    }
    if (company.userControlled) {
        const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("leftCompany", superstar.name);
        await (0, $9esFv.addCompanyCompanyAlerts)(company, [
            newCompanyAlert
        ]);
    }
    // Make superstar happy again
    $3e29bd9aa5422a42$export$dc429a710513ee58(superstar);
    // Delete all relationships, add former company relationship
    for (const relationship of (await (0, $hBIDz.getSuperstarRelationships)(superstar)))await (0, $14eBR.Relationships).remove(relationship);
    await (0, $8A6FL.addFormerCompanyRelationship)(superstar, company);
    // Delete talent requests
    for (const talentRequest of (await (0, $hBIDz.getSuperstarTalentRequests)(superstar)))await (0, $14eBR.TalentRequests).remove(talentRequest);
    // Add news
    if (addNews) {
        let newsItem = await (0, $kZMqI.generateNewsItem)({
            company: company,
            month: game.newsMonth,
            year: game.newsYear,
            superstar: superstar,
            newsType: "superstar_released_by_company"
        });
        await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
            newsItem
        ]);
    }
    // Add messages
    if (company.userControlled) {
        const newMessage = await (0, $hekDR.createLeftCompanyMessage)(superstar, month, year, company, disbanded, vacated);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) {
            const newMessage = await (0, $hekDR.createLeftCompanySuperstarMessage)(superstar, month, year);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
    } else {
        const scout = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(mainCompany), "scout");
        const newMessage = await (0, $hekDR.createCompetitorSuperstarLeftMessage)(superstar, company, month, year, scout);
        await (0, $9esFv.addCompanyMessages)(mainCompany, [
            newMessage
        ]);
    }
    // Process POW stars leaving
    if (company.storyName === "passion") await (0, $jC7EP.processPowSuperstarLeavesCompany)(superstar, company);
    // Remove rejected by company offers so company can no longer block offers
    const negotiations = (await (0, $hBIDz.getSuperstarNegotiations)(superstar)).filter((x)=>[
            "rejected_by_company",
            "negotiating"
        ].includes(x.status));
    for (const negotiation of negotiations)await (0, $14eBR.Negotiations).remove(negotiation);
    return true;
}
function $3e29bd9aa5422a42$export$76fe39072eb6441d(superstar, usedAtEvent, weeklyShow, rosterBrands, game) {
    const fatigueRecovered = $3e29bd9aa5422a42$var$getSuperstarFatigueRecovery(usedAtEvent, weeklyShow, rosterBrands, game);
    $3e29bd9aa5422a42$export$13bc0913f434c9c1(superstar, -fatigueRecovered);
    return true;
}
function $3e29bd9aa5422a42$var$getSuperstarFatigueRecovery(usedAtEvent, weeklyShow, rosterBrands, game) {
    let recovery;
    if (game.numberOfWeeklyShows) {
        // Recovery if weekly shows on
        recovery = 10;
        // For weekly show, divide recovery by number of brands
        if (weeklyShow && rosterBrands.length) {
            recovery /= rosterBrands.length;
            if (rosterBrands.length > 1) recovery -= 1;
        }
    } else // Recovery if no weeklies
    recovery = 15;
    // Increase recovery if not used at event
    if (!usedAtEvent) recovery += 2;
    return Math.floor(recovery);
}
async function $3e29bd9aa5422a42$export$d5fe724cafe14f09(superstar, company, game) {
    await $3e29bd9aa5422a42$export$d67a2eb0ebae0980(superstar, company, game);
    if (superstar.morale < 20 && !superstar.unhappy && !game.settings["no_unhappiness"]) await $3e29bd9aa5422a42$var$setSuperstarUnhappy(superstar, company);
    if ((superstar.morale >= 20 || game.settings["no_unhappiness"]) && superstar.unhappy) await $3e29bd9aa5422a42$var$setSuperstarNotUnhappy(superstar, company);
    // Reset low morale if 'no_unhappiness' option selected
    if (game.settings["no_unhappiness"] && superstar.morale < 20) superstar.morale = 20;
    return superstar;
}
async function $3e29bd9aa5422a42$export$d67a2eb0ebae0980(superstar, company, game) {
    if (superstar.unhappy && superstar.morale < 20 && superstar.contractMonthsRemaining === null && !game.settings["no_unhappiness"]) await $3e29bd9aa5422a42$var$setSuperstarLeaving(superstar, company);
    if (superstar.contractMonthsRemaining !== null && (superstar.morale >= 60 || game.settings["no_unhappiness"])) await $3e29bd9aa5422a42$var$setSuperstarNotLeaving(superstar, company);
    return superstar;
}
async function $3e29bd9aa5422a42$var$setSuperstarUnhappy(superstar, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    superstar.unhappy = true;
    // Add company alert
    if (company.userControlled) {
        const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("unhappy", superstar.name);
        await (0, $9esFv.addCompanyCompanyAlerts)(company, [
            newCompanyAlert
        ]);
        // Add unhappy message
        const newMessage = await (0, $hekDR.createUnhappyMessage)(superstar, game.monthCount, game.year, talentManager);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    }
    return superstar;
}
async function $3e29bd9aa5422a42$var$setSuperstarNotUnhappy(superstar, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    superstar.unhappy = false;
    if (superstar.contractMonthsRemaining === null) {
        let xpGained = null;
        if (talentManager) {
            xpGained = 15;
            const ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(talentManager);
            xpGained = Math.round(xpGained * ageMultiplier);
            await (0, $8A6FL.updateStaffMemberXp)(talentManager, xpGained, company, game);
        }
        if (company.userControlled) {
            const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("notUnhappy", superstar.name);
            await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                newCompanyAlert
            ]);
            const newMessage = await (0, $hekDR.createNoLongerUnhappyMessage)(superstar, game.monthCount, game.year, talentManager, xpGained);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
    }
    return superstar;
}
async function $3e29bd9aa5422a42$var$setSuperstarLeaving(superstar, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const talentManager = (0, $8A6FL.getHighestLevelStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    // Get chance to leave
    const talentManagerLevel = talentManager ? talentManager.level : 1;
    const leavingChances = {
        1: 75,
        2: 60,
        3: 45
    };
    let leavingChance = leavingChances[talentManagerLevel] || 45;
    // Check for affect leaving chance trait
    for (const trait of superstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["leaving_chance_multiplier"]) leavingChance *= traitData["leaving_chance_multiplier"];
    }
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= leavingChance) {
        superstar.contractMonthsRemaining = (0, $3E8Nt.getRandomInt)(3, 8);
        if (company.userControlled) {
            const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("leavingCompany", superstar.name);
            await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                newCompanyAlert
            ]);
            // Add leaving message from talent manager
            const newMessage = await (0, $hekDR.createLeavingMessage)(superstar, game.monthCount, game.year, talentManager);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        } else {
            const scout = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(mainCompany), "scout");
            const newMessage = await (0, $hekDR.createCompetitorSuperstarLeavingMessage)(superstar, company, game.monthCount, game.year, scout);
            await (0, $9esFv.addCompanyMessages)(mainCompany, [
                newMessage
            ]);
        }
        let newsItem = await (0, $kZMqI.generateNewsItem)({
            company: company,
            month: game.newsMonth,
            year: game.newsYear,
            superstar: superstar,
            newsType: "superstar_leaving"
        });
        await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
            newsItem
        ]);
    }
    return superstar;
}
async function $3e29bd9aa5422a42$var$setSuperstarNotLeaving(superstar, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    superstar.contractMonthsRemaining = null;
    if (company.userControlled) {
        const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("notLeavingCompany", superstar.name);
        await (0, $9esFv.addCompanyCompanyAlerts)(company, [
            newCompanyAlert
        ]);
        const newMessage = await (0, $hekDR.createNotLeavingMessage)(superstar, game.monthCount, game.year, talentManager);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    }
    let newsItem = await (0, $kZMqI.generateNewsItem)({
        company: company,
        month: game.newsMonth,
        year: game.newsYear,
        superstar: superstar,
        newsType: "superstar_staying"
    });
    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
        newsItem
    ]);
    return superstar;
}
function $3e29bd9aa5422a42$var$addSuperstarGraphicTemporaryInjury(graphic, injuryType) {
    let objectsDict = {
        "left_eye": 0,
        "right_eye": 1,
        "left_arm": 2,
        "right_arm": 3,
        "forehead": (0, $3E8Nt.getRandomChoice)([
            4,
            5
        ]),
        "forehead_left": 4,
        "forehead_right": 5,
        "forehead_full": 6
    };
    // Get object number
    let objectNumber = objectsDict[injuryType] || 5;
    // Add temporary injury
    graphic = JSON.parse(JSON.stringify(graphic));
    graphic["temporaryInjury"] = {
        "object": objectNumber,
        "colors": [
            "0xFFFFFF"
        ]
    };
    // Add to alternate attires
    let alternateAttires = graphic["alternate_attires"];
    if (alternateAttires) {
        let newAlternateAttires = [];
        for (let alt of alternateAttires){
            let altGraphic = JSON.parse(JSON.stringify(alt));
            altGraphic["temporaryInjury"] = {
                "object": objectNumber,
                "colors": [
                    "0xFFFFFF"
                ]
            };
            newAlternateAttires.push(altGraphic);
        }
        graphic["alternate_attires"] = newAlternateAttires;
    }
    return graphic;
}
function $3e29bd9aa5422a42$export$6aadce3c99e5f07d(graphic) {
    // Add trophy
    graphic = JSON.parse(JSON.stringify(graphic));
    graphic["temporaryTrophy"] = {
        "object": 0,
        "colors": [
            "0xFFFFFF"
        ]
    };
    // Add to alternate attires
    let alternateAttires = graphic["alternate_attires"];
    if (alternateAttires) {
        let newAlternateAttires = [];
        for (let alt of alternateAttires){
            let altGraphic = JSON.parse(JSON.stringify(alt));
            altGraphic["temporaryTrophy"] = {
                "object": 0,
                "colors": [
                    "0xFFFFFF"
                ]
            };
            newAlternateAttires.push(altGraphic);
        }
        graphic["alternate_attires"] = newAlternateAttires;
    }
    return graphic;
}
function $3e29bd9aa5422a42$var$removeSuperstarGraphicKey(graphic, key) {
    graphic = JSON.parse(JSON.stringify(graphic));
    // Remove key
    delete graphic[key];
    // Remove from alternate attires
    let alternateAttires = graphic["alternate_attires"];
    if (alternateAttires) {
        let newAlternateAttires = [];
        for (let alt of alternateAttires){
            let altGraphic = JSON.parse(JSON.stringify(alt));
            delete altGraphic[key];
            newAlternateAttires.push(altGraphic);
        }
        graphic["alternate_attires"] = newAlternateAttires;
    }
    return graphic;
}
function $3e29bd9aa5422a42$export$5de8c46603af6ef1(superstar, trait) {
    const index = superstar.traits.indexOf(trait);
    if (index > -1) superstar.traits.splice(index, 1);
    return superstar.traits;
}
async function $3e29bd9aa5422a42$export$ee5945437f10e69d(superstar, company) {
    let relationship = (0, $iWkAo.Relationship)();
    await (0, $14eBR.Relationships).insert(relationship);
    relationship.interested = true;
    await (0, $hBIDz.addSuperstarRelationships)(superstar, [
        relationship
    ]);
    await (0, $9esFv.addCompanyRelationships)(company, [
        relationship
    ]);
    return relationship;
}
async function $3e29bd9aa5422a42$export$1ee625ec9c2f9bb7(superstar, company, game) {
    if (superstar.contractMonthsRemaining !== null && !game.settings["no_unhappiness"]) {
        superstar.contractMonthsRemaining -= 1;
        if (superstar.contractMonthsRemaining <= 0) {
            await $3e29bd9aa5422a42$export$d77fe2ada004eaf5(superstar, company);
            return true;
        }
    }
    return false;
}
async function $3e29bd9aa5422a42$export$52030f2b50b9962a({ superstarUid: superstarUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const superstar = await (0, $14eBR.Superstars).get(superstarUid);
    const company = await (0, $3E8Nt.getTalentCompany)(superstar);
    data["vacatedChampionships"] = await $3e29bd9aa5422a42$export$5663676ffa021cfc({
        superstar: superstar,
        championships: await (0, $9esFv.getCompanyChampionships)(company),
        month: currentGame.monthCount,
        year: currentGame.year,
        company: company,
        checkTalentRequest: true
    });
    (0, $14eBR.db).saveDatabase();
    return data;
}

});
parcelRequire.register("kZwpB", function(module, exports) {

$parcel$export(module.exports, "getUniqueChampionships", () => $f482a58056f3c401$export$a9f4397b1472c442);
$parcel$export(module.exports, "checkAreChampionshipsEqual", () => $f482a58056f3c401$export$2b2426229f866ca1);
$parcel$export(module.exports, "compareChampionships", () => $f482a58056f3c401$export$8c5c3b9fd90ca487);
$parcel$export(module.exports, "getChampionshipMatchData", () => $f482a58056f3c401$export$e4f343aabecc457d);
$parcel$export(module.exports, "getChampionshipBookingData", () => $f482a58056f3c401$export$b836060ef43602d);
$parcel$export(module.exports, "getMatchAvailableChampionships", () => $f482a58056f3c401$export$2bc4c57fdea08ba0);
$parcel$export(module.exports, "checkChampionshipGimmickRestriction", () => $f482a58056f3c401$export$cc53413a3df7cbb5);
$parcel$export(module.exports, "getTagChampionshipsSets", () => $f482a58056f3c401$export$1ef66de66cb99cdd);
$parcel$export(module.exports, "getVacatedChampionshipsForMatch", () => $f482a58056f3c401$export$44ae0658e5569be0);
$parcel$export(module.exports, "getChampionshipHolder", () => $f482a58056f3c401$export$684f14e67d967148);
$parcel$export(module.exports, "checkChampionshipSegmentItemsToUnlock", () => $f482a58056f3c401$export$cf4c2b101e8d155d);
$parcel$export(module.exports, "getChampionshipXpChange", () => $f482a58056f3c401$export$dd95e2ab94cf66f4);
$parcel$export(module.exports, "getChampionshipContractHolders", () => $f482a58056f3c401$export$61520ab37d17f121);
$parcel$export(module.exports, "getChampionshipsForCashin", () => $f482a58056f3c401$export$82f1989fe3b45496);
$parcel$export(module.exports, "addCashinFutureMatch", () => $f482a58056f3c401$export$5aae6223077543ff);
$parcel$export(module.exports, "addCashinToMatch", () => $f482a58056f3c401$export$649e21eff56cf3c6);
$parcel$export(module.exports, "unifyChampionships", () => $f482a58056f3c401$export$4642c1cb9454a474);
$parcel$export(module.exports, "runCustomizeChampionshipAction", () => $f482a58056f3c401$export$190cc6e669916800);
$parcel$export(module.exports, "runSplitChampionshipAction", () => $f482a58056f3c401$export$1c12be25121f575c);
$parcel$export(module.exports, "runOptionCAction", () => $f482a58056f3c401$export$16287311ec61a14c);

var $972Ip = parcelRequire("972Ip");

var $hBIDz = parcelRequire("hBIDz");

var $ivuOU = parcelRequire("ivuOU");

var $1AAHK = parcelRequire("1AAHK");

var $3E8Nt = parcelRequire("3E8Nt");

var $1JSre = parcelRequire("1JSre");

var $9esFv = parcelRequire("9esFv");

var $i7bmn = parcelRequire("i7bmn");

var $eg5dz = parcelRequire("eg5dz");

var $8A6FL = parcelRequire("8A6FL");

var $9MKdC = parcelRequire("9MKdC");

var $iRMwH = parcelRequire("iRMwH");

var $14eBR = parcelRequire("14eBR");

var $iQtzn = parcelRequire("iQtzn");

var $dl5u4 = parcelRequire("dl5u4");

var $5kTkA = parcelRequire("5kTkA");

var $6RCLU = parcelRequire("6RCLU");

var $ycsyu = parcelRequire("ycsyu");

var $98xmD = parcelRequire("98xmD");

var $4K85d = parcelRequire("4K85d");

var $ko5kE = parcelRequire("ko5kE");

var $2GWzg = parcelRequire("2GWzg");

var $1olyO = parcelRequire("1olyO");

var $5ZsVo = parcelRequire("5ZsVo");

var $8bQDO = parcelRequire("8bQDO");
function $f482a58056f3c401$export$a9f4397b1472c442(championships) {
    return championships.filter((value, index, self)=>index === self.findIndex((t)=>$f482a58056f3c401$export$2b2426229f866ca1(t, value)));
}
function $f482a58056f3c401$export$2b2426229f866ca1(a, b) {
    return a.name === b.name && a.tagTeam === b.tagTeam && a.trio === b.trio && a.companyId === b.companyId;
}
function $f482a58056f3c401$export$8c5c3b9fd90ca487(a, b) {
    // Sort championships by rank, prestige then order created
    const ranks = {
        "Main Eventer": 4,
        "Upper Midcarder": 3,
        "Lower Midcarder": 2,
        "Jabroni": 1,
        "default": 1
    };
    const prestiges = {
        "S": 4,
        "A": 3,
        "B": 2,
        "C": 1,
        "default": 1
    };
    return a.retired - b.retired || (ranks[b.rank] || ranks["default"]) - (ranks[a.rank] || ranks["default"]) || (prestiges[b.prestige] || prestiges["default"]) - (prestiges[a.prestige] || prestiges["default"]) || b.xp - a.xp || a.$loki - b.$loki;
}
function $f482a58056f3c401$export$e4f343aabecc457d(championship) {
    let data = {};
    data["name"] = championship.name;
    data["matchContract"] = championship.matchContract;
    data["championshipContract"] = championship.championshipContract;
    data["tagTeam"] = championship.tagTeam;
    data["trio"] = championship.trio;
    data["prestige"] = championship.prestige;
    return data;
}
async function $f482a58056f3c401$export$b836060ef43602d(championship) {
    let championshipData = JSON.parse(JSON.stringify(championship));
    championshipData["uid"] = championship.$loki;
    if (championship.matchContract) {
        const championshipMatchContract = await (0, $ivuOU.getChampionshipMatchContract)(championship);
        if (championshipMatchContract) championshipData["event"] = (await (0, $1AAHK.getMatchContractEvent)(championshipMatchContract))?.name;
    }
    return championshipData;
}
async function $f482a58056f3c401$export$2bc4c57fdea08ba0(participants, participantSuperstars, companyChampionships, gimmickMatch = null, event = null, skipBooked = false) {
    let data = {};
    // Get singles championships
    let allChampionships = [];
    if (participants[0].objectName === "superstar") allChampionships = await $f482a58056f3c401$var$getMatchParticipantsSinglesChampionships(participants);
    else allChampionships = await $f482a58056f3c401$var$getMatchParticipantsTagChampionships(participants, companyChampionships);
    // Sort championships
    allChampionships.sort($f482a58056f3c401$export$8c5c3b9fd90ca487);
    // Check to skip booked championships
    if (skipBooked) allChampionships = allChampionships.filter((x)=>!x.booked);
    // Check for gimmick restrictions
    let availableChampionships = allChampionships.filter((x)=>$f482a58056f3c401$export$cc53413a3df7cbb5(x, gimmickMatch, event, participantSuperstars));
    // Get available championships
    data["availableChampionships"] = availableChampionships;
    // Add gimmick restricted championships
    data["gimmickRestrictedChampionships"] = [];
    let gimmickRestrictedChampionships = allChampionships.filter((x)=>!(0, $3E8Nt.objectInArray)(x, availableChampionships));
    for (const x of gimmickRestrictedChampionships)data["gimmickRestrictedChampionships"].push({
        "name": (0, $1JSre.getChampionshipDisplayName)(x),
        "gimmickRestriction": x.gimmickRestriction
    });
    return data;
}
async function $f482a58056f3c401$var$getMatchParticipantsSinglesChampionships(participants) {
    let championships = [];
    for (const superstar of participants)// Get superstar's championships
    championships = [
        ...championships,
        ...await (0, $hBIDz.getSuperstarChampionships)(superstar)
    ];
    return championships.filter((x)=>!x.tagTeam && !x.trio);
}
async function $f482a58056f3c401$var$getMatchParticipantsTagChampionships(participants, companyChampionships) {
    let foundChampionships = [];
    // Check if trios match
    let trio = false;
    if (participants.length > 0) trio = (await (0, $972Ip.getTagTeamSuperstars)(participants[0])).length === 3;
    // Filter tag/trios championships
    if (trio) companyChampionships = companyChampionships.filter((x)=>x.trio);
    else companyChampionships = companyChampionships.filter((x)=>x.tagTeam);
    // Get all tag championships sets
    let tagChampionshipsSets = $f482a58056f3c401$export$1ef66de66cb99cdd(companyChampionships);
    for (const tagTeam of participants){
        if (tagTeam.temporary && !tagTeam.trioTagTeam) continue; // Temporary tag teams have no superstars, don't get their championships
        // Get tag team superstars and their ids
        let tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
        if (tagTeam.trioTagTeam && tagTeamSuperstars.length > 0) {
            // Get trio superstars for trio tag team
            let teamTrio = (await (0, $hBIDz.getSuperstarTagTeams)(tagTeamSuperstars[0])).find((x)=>x.trio);
            if (teamTrio) tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(teamTrio);
        }
        let tagTeamSuperstarsIds = tagTeamSuperstars.map((x)=>x.$loki);
        // Get championship if the whole set is held by superstars of this team
        tagChampionshipsSets.forEach((championshipSet)=>{
            let championshipSetCheck = championshipSet.every((x)=>{
                return tagTeamSuperstarsIds.includes(x.superstarId);
            });
            if (championshipSetCheck) // Get one championship from set
            foundChampionships.push(championshipSet[0]);
        });
    }
    return foundChampionships;
}
function $f482a58056f3c401$export$1ef66de66cb99cdd(championships) {
    let tagChampionshipsSets = [];
    const uniqueChampionships = $f482a58056f3c401$export$a9f4397b1472c442(championships);
    uniqueChampionships.forEach((x)=>{
        let championshipsSet = championships.filter((y)=>$f482a58056f3c401$export$2b2426229f866ca1(y, x));
        tagChampionshipsSets.push(championshipsSet);
    });
    return tagChampionshipsSets;
}
function $f482a58056f3c401$export$44ae0658e5569be0(match, companyChampionships, trio) {
    let vacatedChampionships;
    if (match.type === "singles") vacatedChampionships = companyChampionships.filter((x)=>!x.tagTeam && !x.trio && x.vacated);
    else if (trio) vacatedChampionships = companyChampionships.filter((x)=>x.trio && x.vacated);
    else vacatedChampionships = companyChampionships.filter((x)=>x.tagTeam && x.vacated);
    return $f482a58056f3c401$export$a9f4397b1472c442(vacatedChampionships);
}
async function $f482a58056f3c401$export$684f14e67d967148(championship) {
    // Get championship's superstar or team of superstar
    let champion = null;
    const championshipSuperstar = await (0, $ivuOU.getChampionshipSuperstar)(championship);
    if (championshipSuperstar) {
        if (championship.tagTeam || championship.trio) // Find championshipSuperstar's team
        champion = (await (0, $hBIDz.getSuperstarTagTeams)(championshipSuperstar)).find((x)=>{
            if (championship.tagTeam) return !x.temporary;
            else if (championship.trio) return !x.temporary && x.trio;
        });
        else champion = championshipSuperstar;
    }
    return champion;
}
function $f482a58056f3c401$export$cc53413a3df7cbb5(championship, gimmickMatch, event, matchSuperstars) {
    let gimmickRestriction = championship.gimmickRestriction;
    if (gimmickRestriction) {
        if (gimmickRestriction["type"] === "gimmick_match") {
            if (!gimmickMatch) return false;
            if (gimmickRestriction["value"] && gimmickRestriction["value"] !== gimmickMatch.name) return false;
        }
        if (gimmickRestriction["type"] === "weekly_show") {
            if (!event.weeklyShow) return false;
        }
        if ([
            "maximum_age",
            "minimum_age"
        ].includes(gimmickRestriction["type"])) {
            if (gimmickRestriction["type"] === "maximum_age") {
                if (matchSuperstars.some((x)=>x.age > gimmickRestriction["value"])) return false;
            }
            if (gimmickRestriction["type"] === "minimum_age") {
                if (matchSuperstars.some((x)=>x.age < gimmickRestriction["value"])) return false;
            }
        }
    }
    return true;
}
async function $f482a58056f3c401$export$cf4c2b101e8d155d(prestige, company) {
    let unlocked = [];
    let unlocksDict = {
        "S": "Championship Split",
        "A": "New Title Reveal",
        "B": "Option C"
    };
    let toUnlock = unlocksDict[prestige];
    if (toUnlock) {
        let segmentItemToUnlock = (await (0, $9esFv.getCompanySegmentItems)(company)).find((x)=>x.name === toUnlock);
        if (segmentItemToUnlock && !segmentItemToUnlock.unlocked) {
            segmentItemToUnlock.unlocked = true;
            unlocked.push(segmentItemToUnlock.name);
        }
    }
    return unlocked;
}
async function $f482a58056f3c401$var$checkIsTopChampionship(c, company) {
    let topChampionship = (await (0, $9esFv.getCompanyChampionships)(company)).reduce((prev, current)=>{
        return prev.xp > current.xp ? prev : current;
    });
    return c.$loki === topChampionship.$loki;
}
async function $f482a58056f3c401$export$dd95e2ab94cf66f4({ championship: championship, company: company, month: month, year: year, mainEvent: mainEvent = false, championshipDefendedOrRetained: championshipDefendedOrRetained = false, championshipWon: championshipWon = false, match: match = null, segment: segment = null, weeklyShow: weeklyShow = false } = {}) {
    let data = {};
    if (match) {
        // Get rating change
        data["rating_change"] = $f482a58056f3c401$var$getChampionshipXpChangeForMatchRating(match.rating, weeklyShow);
        // Get feuds change
        let feuds = await (0, $i7bmn.getMatchFeuds)(match);
        data["feuds_change"] = $f482a58056f3c401$var$getChampionshipXpChangeForFeuds(feuds, weeklyShow);
        // Get reign change
        data["reign_change"] = await $f482a58056f3c401$var$getChampionshipXpChangeForReign(championship, month, year, championshipDefendedOrRetained, weeklyShow);
        // Get champion/challenger change
        let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
        let championshipHolder = await $f482a58056f3c401$export$684f14e67d967148(championship);
        let champion = championshipHolder ? matchParticipants.find((x)=>championshipHolder.$loki === x.$loki) : null;
        if (champion) {
            data["champion_change"] = await $f482a58056f3c401$var$getChampionshipXpChangeForChampion(championship, champion, championshipWon, weeklyShow);
            // Get challenger change if championship not won
            if (!championshipWon) {
                let challengers = matchParticipants.filter((x)=>x.$loki !== champion.$loki);
                data["challenger_change"] = await $f482a58056f3c401$var$getChampionshipXpChangeForChallengers(championship, challengers, weeklyShow);
            }
        }
    }
    // Get segment change
    if (segment) {
        const segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(segment);
        data["segment_change"] = $f482a58056f3c401$var$getChampionshipXpChangeForSegmentItem(segmentItem, segment.rating);
    }
    // Get main event change
    let isTopChampionship = await $f482a58056f3c401$var$checkIsTopChampionship(championship, company);
    data["main_event_change"] = $f482a58056f3c401$var$getChampionshipXpChangeForMainEvent(mainEvent, isTopChampionship, weeklyShow, segment);
    // Get total xp change
    data["totalXpChange"] = Object.values(data).reduce((a, b)=>a + b);
    return data;
}
function $f482a58056f3c401$var$getChampionshipXpChangeForMainEvent(mainEvent, isTopChampionship, weeklyShow = false, segment = null) {
    let xpChange = 0;
    if (mainEvent && !isTopChampionship) xpChange += 4;
    if (!mainEvent && isTopChampionship && !segment) xpChange -= 6;
    if (weeklyShow) xpChange = Math.round(xpChange / 2);
    return xpChange;
}
function $f482a58056f3c401$var$getChampionshipXpChangeForMatchRating(matchRating, weeklyShow = false) {
    let xpChange = 0;
    if (matchRating !== null) {
        const ratings = {
            1.0: -15,
            1.25: -14,
            1.5: -12,
            1.75: -10,
            2.0: -8,
            2.25: -6,
            2.5: -4,
            2.75: -3,
            3.0: -2,
            3.25: 0,
            3.5: 1,
            3.75: 2,
            4.0: 3,
            4.25: 4,
            4.5: 5,
            4.75: 5,
            5.0: 6
        };
        if (ratings.hasOwnProperty(matchRating)) xpChange = ratings[matchRating];
        if (matchRating > 5) xpChange = Math.max(...Object.values(ratings));
        if (matchRating < 1) xpChange = Math.min(...Object.values(ratings));
        if (weeklyShow) xpChange = Math.round(xpChange / 2);
    }
    return xpChange;
}
function $f482a58056f3c401$var$getChampionshipXpChangeForSegmentItem(segmentItem, segmentRating) {
    // Get xp change if segment is linked to a title
    let xpChange = 0;
    const ratings = {
        "Demand Title Shot": 3,
        "Cash-In Tease": 3,
        "Champion Package": 5,
        "Champion Coronation": 6,
        "Lost My Smile": -15,
        "Title Destruction": -15,
        "Title Disrespect": -5,
        "This Belongs To You": -10
    };
    // Get xp change for segment item
    if (ratings.hasOwnProperty(segmentItem.name)) {
        let segmentXpChange = ratings[segmentItem.name];
        if (segmentRating !== null) {
            // If positive boost, increase change for high rating, decrease for low rating
            if (segmentXpChange > 0) {
                if (segmentRating >= 4.5) segmentXpChange *= 1.5;
                else if (segmentRating <= 2.5) segmentXpChange /= 1.5;
            // If negative boost, decrease change for high rating, increase for low rating
            } else {
                if (segmentRating >= 4.5) segmentXpChange /= 1.5;
                else if (segmentRating <= 2.5) segmentXpChange *= 1.5;
            }
        }
        xpChange += Math.floor(segmentXpChange);
    }
    return xpChange;
}
function $f482a58056f3c401$var$getChampionshipXpChangeForFeuds(feuds, weeklyShow = false) {
    // Raise prestige for match feuds if any feuds are hot
    let xpChange = 0;
    for (const feud of feuds){
        if (feud.hot) xpChange += 4;
        if (feud.stale) xpChange -= 8;
    }
    if (weeklyShow) xpChange = Math.round(xpChange / 2);
    if (xpChange > 8) xpChange = 8;
    if (xpChange < -16) xpChange = -16;
    return xpChange;
}
async function $f482a58056f3c401$var$getChampionshipXpChangeForReign(championship, month, year, championshipDefendedOrRetained = false, weeklyShow = false) {
    let xpChange = 0;
    const currentReign = await (0, $ivuOU.getChampionshipCurrentReign)(championship);
    if (currentReign) {
        if (championshipDefendedOrRetained && !championship.vacated) {
            const reignLength = (0, $8A6FL.getChampionshipReignLength)(currentReign, month, year);
            const numberOfDefenses = (await (0, $9MKdC.getChampionshipReignMatches)(currentReign)).length;
            xpChange += $f482a58056f3c401$var$getChampionshipXpChangeForReignDefense(reignLength, numberOfDefenses, weeklyShow);
        } else xpChange += await $f482a58056f3c401$var$getChampionshipXpChangeForReignEnd(currentReign, championship, month, year);
    }
    return xpChange;
}
async function $f482a58056f3c401$var$getChampionshipXpChangeForReignEnd(reign, championship, month, year, xpChange = 0, i = 1) {
    // Get previous reign that was not vacated
    const previousReign = await $f482a58056f3c401$var$getPreviousChampionshipReign(reign, championship);
    if (previousReign && !previousReign.vacated && i < 5) {
        // If reign shorter than 3 months, decrease xpChange
        const reignLength = (0, $8A6FL.getChampionshipReignLength)(previousReign, month, year);
        if (reignLength < 3) {
            // Raise decrease for every short reign
            xpChange -= 6 * i;
            // Go through previous reign
            i += 1;
            return $f482a58056f3c401$var$getChampionshipXpChangeForReignEnd(previousReign, championship, month, year, xpChange, i);
        }
    }
    // Return xpChange when previous reign not found or not short
    return xpChange;
}
async function $f482a58056f3c401$var$getPreviousChampionshipReign(reign, championship) {
    const allReigns = (await (0, $ivuOU.getChampionshipChampionshipReigns)(championship)).reverse();
    let reignIndex = allReigns.findIndex((x)=>x.$loki === reign.$loki);
    return allReigns[reignIndex + 1];
}
function $f482a58056f3c401$var$getChampionshipXpChangeForReignDefense(reignLength, numberOfDefenses, weeklyShow = false) {
    // Raise prestige for every 3 months of reign
    let xpChange = 0;
    if (!weeklyShow) {
        if (reignLength && reignLength % 3 === 0) {
            // Increase xp by number of defenses
            xpChange += numberOfDefenses;
            // If defenses are over 30% of reign months, add reign months boost
            if (numberOfDefenses > reignLength / 3) xpChange += Math.floor(reignLength / 2);
            // Maximum change
            if (xpChange > 30) xpChange = 30;
        }
    }
    return xpChange;
}
async function $f482a58056f3c401$var$getChampionshipXpChangeForChallengers(championship, challengers, weeklyShow = false) {
    let xpChange = 0;
    const ranks = {
        "Main Eventer": 4,
        "Upper Midcarder": 3,
        "Lower Midcarder": 2,
        "Jabroni": 1
    };
    const prestigeRanks = {
        "S": 4,
        "A": 4,
        "B": 3,
        "C": 2
    };
    // Get rank values for championship and challengers
    const championshipRankValue = prestigeRanks[championship.prestige] || 1;
    for (const challenger of challengers){
        let rank = await (0, $3E8Nt.getRosterMemberRank)(challenger);
        const challengerRankValue = ranks[rank] || 1;
        const rankDifference = challengerRankValue - championshipRankValue;
        // Decrease prestige if challenger rank is lower than championship rank
        if (rankDifference < 0) xpChange += rankDifference * 5;
        else if (rankDifference > 0) xpChange += rankDifference * 3;
        // Increase prestige if face of the company
        if (await (0, $3E8Nt.getRosterMemberFaceOfTheCompany)(challenger)) xpChange += 2;
        // Increase prestige if hot
        if (await (0, $3E8Nt.getRosterMemberHot)(challenger)) xpChange += 3;
        // Decrease prestige if stale
        if (await (0, $3E8Nt.getRosterMemberStale)(challenger)) xpChange -= 4;
    }
    if (challengers.length > 0) xpChange = Math.floor(xpChange / challengers.length);
    if (weeklyShow) xpChange = Math.round(xpChange / 2);
    // Min/max values
    if (xpChange > 20) xpChange = 20;
    if (xpChange < -20) xpChange = -20;
    return xpChange;
}
async function $f482a58056f3c401$var$getChampionshipXpChangeForChampion(championship, champion, championshipWon = false, weeklyShow = false) {
    let xpChange = 0;
    const ranks = {
        "Main Eventer": 4,
        "Upper Midcarder": 3,
        "Lower Midcarder": 2,
        "Jabroni": 1
    };
    const prestigeRanks = {
        "S": 4,
        "A": 4,
        "B": 3,
        "C": 2
    };
    const changes = {
        "positive_rank_difference_multiplier": 2,
        "negative_rank_difference_multiplier": 4,
        "fotc_change": 2,
        "hot_change": 3,
        "stale_change": -4
    };
    // Higher change for championship win
    if (championshipWon) {
        changes["positive_rank_difference_multiplier"] = 4;
        changes["negative_rank_difference_multiplier"] = 8;
        changes["fotc_change"] = 4;
        changes["hot_change"] = 6;
        changes["stale_change"] = -8;
    }
    // Get rank values for championship and champion
    const championshipRankValue = prestigeRanks[championship.prestige] || 1;
    const rank = await (0, $3E8Nt.getRosterMemberRank)(champion);
    const championRankValue = ranks[rank] || 1;
    const rankDifference = championRankValue - championshipRankValue;
    // Decrease prestige if champion rank is lower than championship rank
    if (rankDifference < 0) xpChange += rankDifference * changes["negative_rank_difference_multiplier"];
    else if (rankDifference > 0) xpChange += rankDifference * changes["positive_rank_difference_multiplier"];
    if (await (0, $3E8Nt.getRosterMemberFaceOfTheCompany)(champion)) xpChange += changes["fotc_change"];
    if (await (0, $3E8Nt.getRosterMemberHot)(champion)) xpChange += changes["hot_change"];
    if (await (0, $3E8Nt.getRosterMemberStale)(champion)) xpChange += changes["stale_change"];
    // Reduce champion passive boost on weekly shows
    if (weeklyShow && !championshipWon) xpChange = Math.round(xpChange / 2);
    return xpChange;
}
async function $f482a58056f3c401$export$61520ab37d17f121({ teamType: teamType }) {
    let holders = [];
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    let championshipContracts = companyChampionships.filter((x)=>x.championshipContract);
    if (![
        "tag-team",
        "trio"
    ].includes(teamType)) championshipContracts = championshipContracts.filter((x)=>!x.tagTeam && !x.trio);
    else if (teamType === "trio") championshipContracts = championshipContracts.filter((x)=>x.trio);
    else championshipContracts = championshipContracts.filter((x)=>x.tagTeam);
    for (const c of championshipContracts)if (!c.vacated) {
        let holder = await $f482a58056f3c401$export$684f14e67d967148(c);
        if (holder) holders.push(holder);
    }
    holders = (0, $3E8Nt.getUniqueObjects)(holders);
    // Get data to return
    return holders.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
}
async function $f482a58056f3c401$export$82f1989fe3b45496({ uid: uid } = {}) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    const championshipContract = await (0, $14eBR.Championships).get(uid);
    const allChampionships = companyChampionships.filter((x)=>!x.championshipContract && !x.vacated);
    allChampionships.sort($f482a58056f3c401$export$8c5c3b9fd90ca487);
    let championships = allChampionships.filter((x)=>x.tagTeam === championshipContract.tagTeam && x.trio === championshipContract.trio);
    championships = $f482a58056f3c401$export$a9f4397b1472c442(championships);
    // Get data to return
    return championships.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
}
async function $f482a58056f3c401$export$5aae6223077543ff({ championshipContractUid: championshipContractUid, championshipUid: championshipUid }) {
    const data = {};
    try {
        const currentGame = await (0, $3E8Nt.getCurrentGame)();
        const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
        const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
        const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
        const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        // Get championship contract and challenger
        const championshipContract = await (0, $14eBR.Championships).get(championshipContractUid);
        const challenger = await $f482a58056f3c401$export$684f14e67d967148(championshipContract);
        // Get championship and champion
        const championship = await (0, $14eBR.Championships).get(championshipUid);
        if (!championship) {
            data["error"] = "championship-not-found";
            return data;
        }
        const champion = await $f482a58056f3c401$export$684f14e67d967148(championship);
        // Check for production packages only
        if (latestEvent.activeEffect === "production_packages_only") {
            data["error"] = "production-packages-only";
            return data;
        }
        // Check if champion cashing in on themselves
        if (challenger.$loki === champion.$loki) {
            data["error"] = "challenger-is-champion";
            return data;
        }
        // Create match
        let matchParticipants = [
            challenger,
            champion
        ];
        let matchType = challenger.objectName === "superstar" ? "singles" : "tag";
        const newMatch = (0, $i7bmn.Match)(latestEvent.matchesCount, matchType);
        await (0, $14eBR.Matches).insert(newMatch);
        await (0, $iQtzn.addEventMatches)(latestEvent, [
            newMatch
        ]);
        latestEvent.matchesCount += 1;
        await (0, $i7bmn.addMatchParticipants)(newMatch, matchParticipants);
        await (0, $i7bmn.addMatchChampionships)(newMatch, [
            championship
        ]);
        for (const c of companyChampionships.filter((x)=>$f482a58056f3c401$export$2b2426229f866ca1(x, championship)))c.booked = true;
        // Check superstars
        let matchSuperstars = await (0, $i7bmn.getAllSuperstarsForMatch)(newMatch);
        for (let s of matchSuperstars){
            if (s.currentAttire > 0) s.currentAttire = 0;
            if (latestEvent.activeEffect === "no_women_bookable" && s.gender === "female") {
                data["error"] = "no-women-allowed";
                return data;
            } else if (latestEvent.activeEffect === "no_men_bookable" && s.gender === "male") {
                data["error"] = "no-men-allowed";
                return data;
            }
        }
        // Add managers
        if ((0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(newMatch, matchSuperstars, rosterSuperstars);
        // Remove championship contract
        for (let s of (await (0, $5kTkA.getRosterMemberSuperstars)(challenger))){
            const c = (await (0, $hBIDz.getSuperstarChampionships)(s)).find((x)=>x.championshipContract && x.name === championshipContract.name);
            if (c) {
                await (0, $hBIDz.removeSuperstarChampionships)(s, [
                    c
                ]);
                await (0, $9esFv.removeCompanyChampionships)(userCompany, [
                    c
                ]);
                await (0, $14eBR.Championships).remove(c);
            }
        }
        (0, $14eBR.db).saveDatabase();
        // Get data to return
        data["match"] = await (0, $6RCLU.getMatchData)({
            match: newMatch,
            companyChampionships: companyChampionships,
            rosterSuperstars: rosterSuperstars,
            play: true
        });
        data["challenger"] = challenger.name;
        data["championshipContract"] = championshipContract.name;
        data["points"] = userCompany.points;
    } finally{
        if (data["error"]) await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
    }
    return data;
}
async function $f482a58056f3c401$export$649e21eff56cf3c6({ challengerUid: challengerUid, cashinTime: cashinTime, matchUid: matchUid }) {
    const data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    data["objectivesCompleted"] = [];
    let cashinSinglesAvailable = false;
    let cashinTagAvailable = false;
    let cashinTriosAvailable = false;
    let championshipContract;
    let matchSuperstars;
    // Get match and challenger
    const match = await (0, $14eBR.Matches).get(matchUid);
    let challenger;
    if (match.type === "singles") challenger = await (0, $14eBR.Superstars).get(challengerUid);
    else challenger = await (0, $14eBR.TagTeams).get(challengerUid);
    if (!challenger) {
        data["error"] = "challenger-not-found";
        return data;
    }
    // Get match participants
    const matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    const matchParticipantNames = matchParticipants.map((x)=>x.name).join(" vs ");
    // Check superstars
    let challengerSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(challenger);
    for (let s of challengerSuperstars){
        if (s.currentAttire > 0) s.currentAttire = 0;
        if (latestEvent.activeEffect === "no_women_bookable" && s.gender === "female") {
            data["error"] = "no-women-allowed";
            return data;
        } else if (latestEvent.activeEffect === "no_men_bookable" && s.gender === "male") {
            data["error"] = "no-men-allowed";
            return data;
        }
    }
    // Check if challenger in match
    if ((0, $3E8Nt.objectInArray)(challenger, matchParticipants)) {
        data["error"] = "challenger-in-match";
        return data;
    }
    // Find championship contract
    for (const c of (await (0, $hBIDz.getSuperstarChampionships)(challengerSuperstars[0])))if (c.championshipContract) {
        championshipContract = c;
        break;
    }
    // Add challenger to current match
    if (cashinTime === "0") {
        await (0, $i7bmn.addMatchParticipants)(match, [
            challenger
        ]);
        matchParticipants.push(challenger);
        // Remove championship contract
        for (const s of challengerSuperstars){
            const c = (await (0, $hBIDz.getSuperstarChampionships)(s)).find((x)=>x.championshipContract && x.name === championshipContract.name);
            if (c) {
                await (0, $hBIDz.removeSuperstarChampionships)(s, [
                    c
                ]);
                await (0, $9esFv.removeCompanyChampionships)(userCompany, [
                    c
                ]);
                await (0, $14eBR.Championships).remove(c);
            }
        }
        // Check for championship contracts
        for (let championship of (await (0, $9esFv.getCompanyChampionships)(userCompany)))if (championship.championshipContract && !championship.vacated) {
            if (!championship.tagTeam && !championship.trio) cashinSinglesAvailable = true;
            else if (championship.trio) cashinTriosAvailable = true;
            else cashinTagAvailable = true;
        }
        // Add managers
        matchSuperstars = await (0, $i7bmn.getAllSuperstarsForMatch)(match);
        if ((0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(match, matchSuperstars, rosterSuperstars);
        // Holy shit moment award
        let pointsGained = 30;
        userCompany.points += pointsGained;
        // Change objective property
        const objectiveCompleted = await (0, $8A6FL.changeProperty)({
            name: "holy shit moments",
            change: 1,
            company: userCompany
        });
        if (objectiveCompleted) {
            await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, userCompany);
            const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(userCompany);
            data["unreadMessages"] = unreadMessages.length;
        }
        // Add company log
        const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, userCompany.realYear);
        (0, $14eBR.CompanyLogs).insert(newCompanyLog);
        newCompanyLog.text = `${challenger.name} cashed in ${championshipContract.name} during ${matchParticipantNames}!`;
        newCompanyLog.type = "moment";
        newCompanyLog.realYear = currentGame.year;
        newCompanyLog.eventName = latestEvent.name;
        newCompanyLog.value = 6;
        await (0, $9esFv.addCompanyCompanyLogs)(userCompany, [
            newCompanyLog
        ]);
    }
    (0, $14eBR.db).saveDatabase();
    // Get graphics if challenger added to current match
    if (cashinTime === "0") {
        // Get match graphics
        let allChampionships = (await Promise.all(matchSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
        let refereeSuperstar = await (0, $6RCLU.getMatchRefereeSuperstar)(match, rosterSuperstars);
        // Get gimmick match graphic
        let gimmickMatchForGraphic = await (0, $6RCLU.getGimmickMatchForGraphic)(await (0, $i7bmn.getMatchGimmickMatch)(match), match);
        let gimmickMatchGraphic = (0, $6RCLU.getGimmickMatchGraphic)(gimmickMatchForGraphic);
        let hangChampionships = (0, $6RCLU.checkHangChampionships)(gimmickMatchGraphic);
        let championshipsToRemove = hangChampionships ? [
            ...await (0, $i7bmn.getMatchChampionships)(match)
        ] : [];
        data["graphics"] = await (0, $6RCLU.getMatchParticipantsGraphics)(match, matchParticipants, allChampionships, matchSuperstars, rosterSuperstars, refereeSuperstar, gimmickMatchForGraphic, championshipsToRemove);
    }
    // Get data to return
    data["championshipContract"] = championshipContract.name;
    data["cashinSinglesAvailable"] = cashinSinglesAvailable;
    data["cashinTagAvailable"] = cashinTagAvailable;
    data["cashinTriosAvailable"] = cashinTriosAvailable;
    if (match.type === "singles") data["challenger"] = await (0, $5kTkA.getSuperstarDisplayData)({
        superstar: challenger,
        managersUsed: match.managersUsed,
        game: currentGame,
        rosterSuperstars: rosterSuperstars
    });
    else data["challenger"] = await (0, $ko5kE.getTagTeamDisplayData)({
        tagTeam: challenger,
        managersUsed: match.managersUsed,
        rosterSuperstars: rosterSuperstars
    });
    data["points"] = userCompany.points;
    data["fans"] = userCompany.fans;
    return data;
}
async function $f482a58056f3c401$export$4642c1cb9454a474(championships, company, companyChampionships, game, newChampionshipName = null) {
    let unificationXpChange = 0;
    const unifyPrestigeXpData = {
        "S": 150,
        "A": 80,
        "B": 40,
        "C": 10
    };
    // Get championship to unify with (highest xp)
    let championshipToUnifyWith = (0, $3E8Nt.getArrayMaxByProperty)(championships, "xp");
    if (company.storyName === "passion") {
        // Keep POW championship
        const powChampionship = championships.find((c)=>c.name === "POW");
        if (powChampionship) championshipToUnifyWith = powChampionship;
    }
    // Get championships to unify
    const championshipsToUnify = championships.filter((c)=>c.$loki !== championshipToUnifyWith.$loki);
    // Unify championships
    for (const championship of championshipsToUnify){
        let championshipsSet = companyChampionships.filter((c)=>$f482a58056f3c401$export$2b2426229f866ca1(c, championship));
        // Process championships
        for (const x of championshipsSet){
            // Remove championship from champion
            const champion = await (0, $ivuOU.getChampionshipSuperstar)(x);
            if (champion) {
                await (0, $hBIDz.removeSuperstarChampionships)(champion, [
                    x
                ]);
                // End current reign
                const oldReign = await (0, $ivuOU.getChampionshipCurrentReign)(x);
                if (oldReign) {
                    oldReign.endMonth = game.monthCount;
                    oldReign.endYear = game.year;
                    oldReign.retired = true;
                }
            }
            if (x.matchContract || x.championshipContract) await (0, $9esFv.removeCompanyChampionships)(company, [
                x
            ]);
            x.retired = true;
        }
        // Get championship prestige to add
        unificationXpChange += unifyPrestigeXpData[championship.prestige] || 10;
    }
    // Get data
    let data = {
        "unifiedChampionships": (0, $1JSre.getChampionshipsDisplayName)(championshipsToUnify),
        "unifiedChampionshipWith": (0, $1JSre.getChampionshipDisplayName)(championshipToUnifyWith),
        "multipleChampionships": championshipToUnifyWith.trio || championshipToUnifyWith.tagTeam || championships.length > 2
    };
    // Update name (if not POW title)
    if (newChampionshipName && !(company.storyName === "passion" && championshipToUnifyWith.name === "POW")) {
        const championshipToUnifyWithSet = companyChampionships.filter((c)=>$f482a58056f3c401$export$2b2426229f866ca1(c, championshipToUnifyWith));
        for (const c of championshipToUnifyWithSet)c.name = newChampionshipName;
        data["newChampionshipName"] = (0, $1JSre.getChampionshipDisplayName)(championshipToUnifyWith);
    }
    // Increase prestige of championship to unify with
    if ((0, $98xmD.globalUser).paid) {
        const championshipPrestigeData = await (0, $8A6FL.processChampionshipXpChange)(championshipToUnifyWith, unificationXpChange, companyChampionships);
        data["xpChange"] = unificationXpChange;
        // Check for objective completed
        if (championshipPrestigeData["prestigeIncrease"]) {
            const objectiveCompleted = await (0, $8A6FL.changeProperty)({
                name: "championship prestige",
                change: 1,
                company: company,
                championship: championshipToUnifyWith
            });
            if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
            // If prestige increased over highest value, unlock prestige bonus segments
            if (championshipPrestigeData["firstPrestigeIncrease"]) await $f482a58056f3c401$export$cf4c2b101e8d155d(championshipToUnifyWith.prestige, company);
        }
    }
    return data;
}
async function $f482a58056f3c401$export$190cc6e669916800(championship, companyChampionships) {
    const holder = await (0, $ivuOU.getChampionshipSuperstar)(championship);
    const partsChanged = [];
    if (!holder || !championship.graphic) return null;
    // Get championship graphic
    const graphic = JSON.parse(JSON.stringify(championship.graphic));
    // Change sideplate design
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 30) {
        const sidePlatesChoices = (0, $2GWzg.championshipsGraphicsData)["sidePlates"];
        const sidePlatesObject = (0, $3E8Nt.getRandomChoice)(sidePlatesChoices);
        graphic["sidePlates"]["object"] = sidePlatesObject["number"];
        graphic["sideGems"]["object"] = sidePlatesObject["sideGemsPart"];
        partsChanged.push("side_plates");
    }
    // Change center and side plate colors
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 45) {
        graphic["centerPlate"]["colors"] = [
            (0, $8bQDO.getChampionshipGraphicPlateColor)(true, 50)
        ];
        let sidePlatesColor = graphic["centerPlate"]["colors"];
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 30) sidePlatesColor = [
            (0, $8bQDO.getChampionshipGraphicPlateColor)(true, 50)
        ];
        graphic["sidePlates"]["colors"] = sidePlatesColor;
        partsChanged.push("plate_colors");
    }
    // Change strap color
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 60 || !partsChanged.length) {
        graphic["strap"]["colors"] = [
            (0, $8bQDO.getChampionshipGraphicStrapColor)(true, 50)
        ];
        partsChanged.push("strap_colors");
    }
    // Change center and side gems colors
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 30) {
        graphic["centerGems"]["colors"] = [
            (0, $8bQDO.getChampionshipGraphicGemsColor)()
        ];
        graphic["sideGems"]["colors"] = graphic["centerGems"]["colors"];
        partsChanged.push("gem_colors");
    }
    // Set championship(s) graphic to new graphic
    const championshipsSet = companyChampionships.filter((c)=>$f482a58056f3c401$export$2b2426229f866ca1(c, championship));
    for (const c of championshipsSet)c.graphic = graphic;
    return championship.graphic;
}
async function $f482a58056f3c401$export$1c12be25121f575c(championship, companyChampionships, company, newChampionshipName = null) {
    // Divide Obsidian championship into 2 Gold championships
    const prestigeRanks = {
        "S": 4,
        "A": 3,
        "B": 2,
        "C": 1
    };
    if (prestigeRanks[championship.prestige] < 4) return null;
    // Reduce prestige and xp of championship(s)
    const championshipsSet = companyChampionships.filter((c)=>$f482a58056f3c401$export$2b2426229f866ca1(c, championship));
    for (const c of championshipsSet){
        c.prestige = "A";
        c.highestPrestige = c.prestige;
        c.xp = 300;
    }
    // Get number of duplicate championships to create
    let numberOfDuplicateChampionships = 1;
    let teamType = null;
    if (championship.tagTeam) {
        numberOfDuplicateChampionships = 2;
        teamType = "tag-team";
    } else if (championship.trio) {
        numberOfDuplicateChampionships = 3;
        teamType = "trio";
    }
    // Generate strap color
    let graphic = null;
    if (championship.graphic) {
        graphic = JSON.parse(JSON.stringify(championship.graphic));
        // Generate strap color once for all new championships
        let strapColor = [
            (0, $8bQDO.getChampionshipGraphicStrapColor)(true)
        ];
        while(strapColor[0] === graphic.strap.colors[0])strapColor = [
            (0, $8bQDO.getChampionshipGraphicStrapColor)(true)
        ];
        graphic["strap"]["colors"] = strapColor;
    }
    // Get championship's name
    let name;
    if (newChampionshipName) name = newChampionshipName;
    else {
        // Generate unique name
        const womens = championship.gender === "female" || championship.name.includes("Women");
        name = (0, $8bQDO.generateChampionshipName)(company.name, championship.rank, teamType, womens);
        while(companyChampionships.some((x)=>x.name === name))name = (0, $8bQDO.generateChampionshipName)(company.name, championship.rank, teamType, womens);
    }
    // Create duplicate(s) of championship
    const newChampionships = [];
    for(let i = 0; i < numberOfDuplicateChampionships; i++){
        const newChampionship = (0, $ivuOU.Championship)(name);
        await (0, $14eBR.Championships).insert(newChampionship);
        newChampionship.tagTeam = championship.tagTeam;
        newChampionship.trio = championship.trio;
        newChampionship.gender = championship.gender;
        newChampionship.prestige = championship.prestige;
        newChampionship.highestPrestige = newChampionship.prestige;
        newChampionship.xp = championship.xp;
        newChampionship.vacated = true;
        // Change strap color
        if (championship.graphic) newChampionship.graphic = graphic;
        newChampionships.push(newChampionship);
    }
    await (0, $9esFv.addCompanyChampionships)(company, newChampionships);
    return newChampionships;
}
async function $f482a58056f3c401$export$16287311ec61a14c(championship, companyChampionships, company, month, year) {
    // Vacate championship, create match contract at next monthly event. For Silver Championship Only.
    const holder = await $f482a58056f3c401$export$684f14e67d967148(championship);
    const holderSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(holder);
    const currentEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(company);
    const prestigeRanks = {
        "S": 4,
        "A": 3,
        "B": 2,
        "C": 1
    };
    if (prestigeRanks[championship.prestige] < 2 || !holder) return null;
    // Vacate championship(s), end current reign
    const championshipsSet = companyChampionships.filter((c)=>$f482a58056f3c401$export$2b2426229f866ca1(c, championship));
    for (const c of championshipsSet){
        c.vacated = true;
        const champion = await (0, $ivuOU.getChampionshipSuperstar)(c);
        await (0, $hBIDz.removeSuperstarChampionships)(champion, [
            c
        ]);
        // End current reign
        const oldReign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
        if (oldReign) {
            oldReign.endMonth = month;
            oldReign.endYear = year;
            oldReign.vacated = true;
        }
        // Check talent request
        let requestData = {
            "championshipId": c.$loki
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "vacate_championship",
            talent: champion,
            data: requestData
        });
    }
    // Create match contract at next event
    const matchContract = (0, $1AAHK.MatchContract)();
    await (0, $14eBR.MatchContracts).insert(matchContract);
    matchContract.name = "Option C Title Match";
    matchContract.awarded = true;
    // Add match contract to next monthly event's parent event
    const monthlyParentEvent = await (0, $5ZsVo.getUpcomingMonthlyEventForWeeklyEvent)(currentEvent, parentEvents, company);
    await (0, $iQtzn.addEventMatchContracts)(monthlyParentEvent, [
        matchContract
    ]);
    // Add bonus
    const bonuses = {
        "C": 12,
        "B": 25,
        "A": 50
    };
    matchContract.bonus = bonuses[monthlyParentEvent.prestige] || 12;
    // Create match contract's championship(s)
    let numberOfChampionships = 1;
    if (championship.tagTeam) numberOfChampionships = 2;
    else if (championship.trio) numberOfChampionships = 3;
    const newChampionships = [];
    for(let i = 0; i < numberOfChampionships; i++){
        const newChampionship = (0, $ivuOU.Championship)(matchContract.name);
        await (0, $14eBR.Championships).insert(newChampionship);
        newChampionship.matchContract = true;
        newChampionship.rank = "Upper Midcarder";
        newChampionship.tagTeam = championship.tagTeam;
        newChampionship.trio = championship.trio;
        await (0, $ivuOU.addChampionshipMatchContracts)(newChampionship, [
            matchContract
        ]);
        await (0, $hBIDz.addSuperstarChampionships)(holderSuperstars[i], [
            newChampionship
        ]);
        newChampionships.push(newChampionship);
    }
    await (0, $9esFv.addCompanyChampionships)(company, newChampionships);
    // Add match contract to holder
    await (0, $1AAHK.addTalentMatchContracts)(holder, [
        matchContract
    ]);
    return newChampionships;
}

});
parcelRequire.register("1AAHK", function(module, exports) {

$parcel$export(module.exports, "MatchContract", () => $12859ffeab9543f4$export$94c05109a516b666);
$parcel$export(module.exports, "getMatchContractEvent", () => $12859ffeab9543f4$export$7de7cd6cdb3e23d7);
$parcel$export(module.exports, "getMatchContractChampionship", () => $12859ffeab9543f4$export$96261f6a2dcd5d50);
$parcel$export(module.exports, "getMatchContractTalent", () => $12859ffeab9543f4$export$142a05770078a8d6);
$parcel$export(module.exports, "addTalentMatchContracts", () => $12859ffeab9543f4$export$8d43e164fe9e542);

var $14eBR = parcelRequire("14eBR");

var $hBIDz = parcelRequire("hBIDz");

var $972Ip = parcelRequire("972Ip");
function $12859ffeab9543f4$export$94c05109a516b666() {
    // Integer
    const bonus = null;
    // Boolean
    const awarded = false;
    const availableForUse = true;
    // String
    const name = null;
    // Foreign keys
    const superstarId = null;
    const tagTeamId = null;
    const eventId = null;
    const championshipId = null;
    const tournamentId = null;
    return {
        bonus: bonus,
        awarded: awarded,
        availableForUse: availableForUse,
        name: name,
        superstarId: superstarId,
        tagTeamId: tagTeamId,
        eventId: eventId,
        championshipId: championshipId,
        tournamentId: tournamentId
    };
}
function $12859ffeab9543f4$export$d97040ee6e7c07cf(matchContract) {
    return (0, $14eBR.Superstars).find({
        "$loki": matchContract.superstarId
    })[0];
}
function $12859ffeab9543f4$export$b2721cf17f5749cd(matchContract) {
    return (0, $14eBR.TagTeams).find({
        "$loki": matchContract.tagTeamId
    })[0];
}
function $12859ffeab9543f4$export$7de7cd6cdb3e23d7(matchContract) {
    return (0, $14eBR.Events).find({
        "$loki": matchContract.eventId
    })[0];
}
function $12859ffeab9543f4$export$96261f6a2dcd5d50(matchContract) {
    if (!matchContract.championshipId) return;
    return (0, $14eBR.Championships).find({
        "$loki": matchContract.championshipId
    })[0];
}
function $12859ffeab9543f4$export$a8d291878d6b0b9b(matchContract) {
    return (0, $14eBR.Tournaments).find({
        "$loki": matchContract.tournamentId
    })[0];
}
function $12859ffeab9543f4$export$142a05770078a8d6(matchContract) {
    if (matchContract.superstarId) return $12859ffeab9543f4$export$d97040ee6e7c07cf(matchContract);
    else return $12859ffeab9543f4$export$b2721cf17f5749cd(matchContract);
}
async function $12859ffeab9543f4$export$8d43e164fe9e542(talent, matchContracts) {
    if (talent.objectName === "superstar") return (0, $hBIDz.addSuperstarMatchContracts)(talent, matchContracts);
    else return (0, $972Ip.addTagTeamMatchContracts)(talent, matchContracts);
}

});

parcelRequire.register("eg5dz", function(module, exports) {

$parcel$export(module.exports, "Segment", () => $a6169b79a2b73878$export$d53aa5c5ab432700);
$parcel$export(module.exports, "getSegmentEvent", () => $a6169b79a2b73878$export$d2c7d43828dc0988);
$parcel$export(module.exports, "getSegmentSegmentItem", () => $a6169b79a2b73878$export$b9891dd6510e72a0);
$parcel$export(module.exports, "addSegmentSuperstars", () => $a6169b79a2b73878$export$87549e1fc6b1b8cd);
$parcel$export(module.exports, "addSegmentTagTeams", () => $a6169b79a2b73878$export$97856587b9692c75);
$parcel$export(module.exports, "getSegmentTagTeams", () => $a6169b79a2b73878$export$57de58c7fd239b63);
$parcel$export(module.exports, "getSegmentParticipants", () => $a6169b79a2b73878$export$e8e968e42f739060);
$parcel$export(module.exports, "addSegmentParticipants", () => $a6169b79a2b73878$export$8496fb1122396f91);
$parcel$export(module.exports, "addSegmentFeuds", () => $a6169b79a2b73878$export$747e2b5b96b9ae29);
$parcel$export(module.exports, "removeSegmentFeud", () => $a6169b79a2b73878$export$29d9ed654fddb19e);
$parcel$export(module.exports, "getSegmentFeuds", () => $a6169b79a2b73878$export$92d39eed2b528725);

var $14eBR = parcelRequire("14eBR");
function $a6169b79a2b73878$export$d53aa5c5ab432700() {
    // String
    const consequenceAppliedTo = null;
    const objectName = "segment";
    // Integer
    const order = null;
    const hype = null;
    // Float
    const rating = null;
    // Boolean
    const hot = false;
    const hidden = false;
    // Arrays
    const participants = [];
    // Objects
    const consequenceData = {};
    const managersUsed = {};
    // Foreign keys
    const feudId = null;
    const segmentItemId = null;
    const eventId = null;
    return {
        consequenceAppliedTo: consequenceAppliedTo,
        order: order,
        hype: hype,
        rating: rating,
        hot: hot,
        hidden: hidden,
        participants: participants,
        consequenceData: consequenceData,
        managersUsed: managersUsed,
        feudId: feudId,
        segmentItemId: segmentItemId,
        eventId: eventId,
        objectName: objectName
    };
}
function $a6169b79a2b73878$export$d2c7d43828dc0988(segment) {
    return (0, $14eBR.Events).find({
        "$loki": segment.eventId
    })[0];
}
function $a6169b79a2b73878$export$b9891dd6510e72a0(segment) {
    return (0, $14eBR.SegmentItems).find({
        "$loki": segment.segmentItemId
    })[0];
}
function $a6169b79a2b73878$export$1479d18abd865be3(segment) {
    return (0, $14eBR.Feuds).find({
        "$loki": segment.feudId
    })[0];
}
function $a6169b79a2b73878$export$87549e1fc6b1b8cd(segment, superstars) {
    let segmentHashes = superstars.map((s)=>{
        return {
            segmentId: segment.$loki,
            superstarId: s.$loki
        };
    });
    return (0, $14eBR.SegmentParticipantsHash).insert(segmentHashes);
}
async function $a6169b79a2b73878$export$c59701f48459a721(segment) {
    const segmentHashes = await (0, $14eBR.SegmentParticipantsHash).find({
        "segmentId": segment.$loki
    });
    const segmentSuperstarIds = segmentHashes.map((x)=>x.superstarId);
    const superstarIds = segmentHashes.map((x)=>{
        return x.superstarId;
    }).filter((y)=>y);
    const result = (0, $14eBR.Superstars).find({
        "$loki": {
            "$in": superstarIds
        }
    });
    result.sort((a, b)=>segmentSuperstarIds.indexOf(a.$loki) - segmentSuperstarIds.indexOf(b.$loki));
    return result;
}
function $a6169b79a2b73878$export$97856587b9692c75(segment, tagTeams) {
    let segmentHashes = tagTeams.map((s)=>{
        return {
            segmentId: segment.$loki,
            tagTeamId: s.$loki
        };
    });
    return (0, $14eBR.SegmentParticipantsHash).insert(segmentHashes);
}
async function $a6169b79a2b73878$export$57de58c7fd239b63(segment) {
    const segmentHashes = await (0, $14eBR.SegmentParticipantsHash).find({
        "segmentId": segment.$loki
    });
    const segmentTagTeamIds = segmentHashes.map((x)=>x.tagTeamId);
    const tagTeamIds = segmentHashes.map((x)=>{
        return x.tagTeamId;
    }).filter((y)=>y);
    const result = (0, $14eBR.TagTeams).find({
        "$loki": {
            "$in": tagTeamIds
        }
    });
    result.sort((a, b)=>segmentTagTeamIds.indexOf(a.$loki) - segmentTagTeamIds.indexOf(b.$loki));
    return result;
}
async function $a6169b79a2b73878$export$e8e968e42f739060(segment) {
    let participants = [];
    const segmentSuperstars = await $a6169b79a2b73878$export$c59701f48459a721(segment);
    if (segmentSuperstars) participants.push(...segmentSuperstars);
    const segmentTagTeams = await $a6169b79a2b73878$export$57de58c7fd239b63(segment);
    if (segmentTagTeams) participants.push(...segmentTagTeams);
    return participants;
}
async function $a6169b79a2b73878$export$4227dacb416ff461(segment) {
    return (0, $14eBR.SegmentParticipantsHash).findAndRemove({
        "segmentId": segment.$loki
    });
}
async function $a6169b79a2b73878$export$8496fb1122396f91(segment, participants) {
    for (const p of participants){
        if (p.objectName === "superstar") await $a6169b79a2b73878$export$87549e1fc6b1b8cd(segment, [
            p
        ]);
        else if (p.objectName === "tagTeam") await $a6169b79a2b73878$export$97856587b9692c75(segment, [
            p
        ]);
    }
}
function $a6169b79a2b73878$export$747e2b5b96b9ae29(segment, feuds) {
    let segmentHashes = feuds.map((x)=>{
        return {
            segmentId: segment.$loki,
            feudId: x.$loki
        };
    });
    return (0, $14eBR.FeudSegmentsHash).insert(segmentHashes);
}
async function $a6169b79a2b73878$export$29d9ed654fddb19e(segment, feud) {
    return (0, $14eBR.FeudSegmentsHash).findAndRemove({
        "segmentId": segment.$loki,
        "feudId": feud.$loki
    });
}
async function $a6169b79a2b73878$export$92d39eed2b528725(segment) {
    const segmentHashes = await (0, $14eBR.FeudSegmentsHash).find({
        "segmentId": segment.$loki
    });
    const feudIds = segmentHashes.map((x)=>{
        return x.feudId;
    });
    return (0, $14eBR.Feuds).find({
        "$loki": {
            "$in": feudIds
        }
    });
}

});

parcelRequire.register("8A6FL", function(module, exports) {

$parcel$export(module.exports, "getCompanyMainRosterSuperstars", () => $63f6dc8ca1007bd9$export$be76e1c1c7fb3418);
$parcel$export(module.exports, "getCompanyRosterByType", () => $63f6dc8ca1007bd9$export$596e41e02971e822);
$parcel$export(module.exports, "getCompanyLatestEvent", () => $63f6dc8ca1007bd9$export$ebbfd7a50411b417);
$parcel$export(module.exports, "getCurrentMonth", () => $63f6dc8ca1007bd9$export$4bf68489d4ce7543);
$parcel$export(module.exports, "getCompanyStartingMonth", () => $63f6dc8ca1007bd9$export$90a9e2fee4b79199);
$parcel$export(module.exports, "getBuyoutData", () => $63f6dc8ca1007bd9$export$b46355eaea227f33);
$parcel$export(module.exports, "getBuyoutSuperstars", () => $63f6dc8ca1007bd9$export$21c3db4bb65d37b0);
$parcel$export(module.exports, "getNumberOfBuyoutSignings", () => $63f6dc8ca1007bd9$export$ae21115afb55aed9);
$parcel$export(module.exports, "getHighestLevelStaffMemberByRole", () => $63f6dc8ca1007bd9$export$c39c537a73a9ae6e);
$parcel$export(module.exports, "runningBuyoutCheck", () => $63f6dc8ca1007bd9$export$c381cdf49b57db6);
$parcel$export(module.exports, "getCompanyParentEvents", () => $63f6dc8ca1007bd9$export$745573c3519c00ba);
$parcel$export(module.exports, "getViewCompaniesData", () => $63f6dc8ca1007bd9$export$d98ad16df125836b);
$parcel$export(module.exports, "getActiveCompetitorsForCompany", () => $63f6dc8ca1007bd9$export$1e4a46f46735bc71);
$parcel$export(module.exports, "getCompanyRosterCapacity", () => $63f6dc8ca1007bd9$export$d342efbc7d93e412);
$parcel$export(module.exports, "getCompanySelectData", () => $63f6dc8ca1007bd9$export$42db1b2640598504);
$parcel$export(module.exports, "getMakeTradeOfferData", () => $63f6dc8ca1007bd9$export$ca78fbcdc54ce76a);
$parcel$export(module.exports, "getAvailableStaffMembers", () => $63f6dc8ca1007bd9$export$4300fa74fcc6d545);
$parcel$export(module.exports, "getRandomStaffMemberByRole", () => $63f6dc8ca1007bd9$export$499c40897d9957a2);
$parcel$export(module.exports, "getAvailableStaffMembersByRole", () => $63f6dc8ca1007bd9$export$3117d1c4fcb92e56);
$parcel$export(module.exports, "getViewObjectivesData", () => $63f6dc8ca1007bd9$export$b9c10e56bdeeffa4);
$parcel$export(module.exports, "reviewObjectives", () => $63f6dc8ca1007bd9$export$321fd088e9a7034e);
$parcel$export(module.exports, "getCompanyMonth", () => $63f6dc8ca1007bd9$export$fe732773535a22d4);
$parcel$export(module.exports, "getCompanyYear", () => $63f6dc8ca1007bd9$export$2c9c79c85a054651);
$parcel$export(module.exports, "getViewManagementActivityData", () => $63f6dc8ca1007bd9$export$2620b3bf8c8a32dd);
$parcel$export(module.exports, "getFanHistoryData", () => $63f6dc8ca1007bd9$export$5885c25141ba42dc);
$parcel$export(module.exports, "getTutorialStateName", () => $63f6dc8ca1007bd9$export$5ead34eb308f091f);
$parcel$export(module.exports, "getViewCompanyStaffData", () => $63f6dc8ca1007bd9$export$278b77c4d232095b);
$parcel$export(module.exports, "getStaffMemberGraphic", () => $63f6dc8ca1007bd9$export$d02b031b0adfeba2);
$parcel$export(module.exports, "hireStaffMember", () => $63f6dc8ca1007bd9$export$8a10a4d37deed126);
$parcel$export(module.exports, "fireStaffMember", () => $63f6dc8ca1007bd9$export$6a262ebc29342441);
$parcel$export(module.exports, "removeStaffTaskData", () => $63f6dc8ca1007bd9$export$2c5f6e19e926959f);
$parcel$export(module.exports, "getViewCompanyFacilitiesData", () => $63f6dc8ca1007bd9$export$52d388e8c053912e);
$parcel$export(module.exports, "upgradeCompanyFacility", () => $63f6dc8ca1007bd9$export$15ff38ad84708b93);
$parcel$export(module.exports, "checkFacilityUpgrade", () => $63f6dc8ca1007bd9$export$51eebd90bf2c0c61);
$parcel$export(module.exports, "createCompanyAlert", () => $63f6dc8ca1007bd9$export$d7d1923b1a78ff80);
$parcel$export(module.exports, "getViewIndieStaffData", () => $63f6dc8ca1007bd9$export$b8e0770e26ec2a83);
$parcel$export(module.exports, "getEditStaffMemberData", () => $63f6dc8ca1007bd9$export$e277bd7468230132);
$parcel$export(module.exports, "changeStaffMemberName", () => $63f6dc8ca1007bd9$export$6506b19d1b107c23);
$parcel$export(module.exports, "changeStaffMemberPronoun", () => $63f6dc8ca1007bd9$export$c1f080156be27ee1);
$parcel$export(module.exports, "changeStaffMemberGraphic", () => $63f6dc8ca1007bd9$export$a270f826a48e086a);
$parcel$export(module.exports, "cancelStaffMemberTask", () => $63f6dc8ca1007bd9$export$3b41ccd69e0f255a);
$parcel$export(module.exports, "getYearlyRankingsHistoryData", () => $63f6dc8ca1007bd9$export$83f82a058e9ec30d);
$parcel$export(module.exports, "getAnnualTournamentHistoryData", () => $63f6dc8ca1007bd9$export$20b16d33f63d194b);
$parcel$export(module.exports, "getAnnualTournamentStatsData", () => $63f6dc8ca1007bd9$export$6e232615a8871480);
$parcel$export(module.exports, "getViewStatsData", () => $63f6dc8ca1007bd9$export$afdc45cc69777fb);
$parcel$export(module.exports, "getChampionshipReignLength", () => $63f6dc8ca1007bd9$export$46822c97d29d2bbd);
$parcel$export(module.exports, "getViewTournamentsData", () => $63f6dc8ca1007bd9$export$8f3ddbe231d60daa);
$parcel$export(module.exports, "getTournamentDisplayData", () => $63f6dc8ca1007bd9$export$643e2264c18d27ff);
$parcel$export(module.exports, "getViewGimmickMatchesData", () => $63f6dc8ca1007bd9$export$a3ea48a9b5992fd2);
$parcel$export(module.exports, "getMatchGimmickFatigueIncrease", () => $63f6dc8ca1007bd9$export$1cf41b89a2a5b04a);
$parcel$export(module.exports, "getRemoveGimmickMatchesData", () => $63f6dc8ca1007bd9$export$9be41fd18bf0fb8);
$parcel$export(module.exports, "removeGimmickMatch", () => $63f6dc8ca1007bd9$export$1a8fe90aeb8fbfd9);
$parcel$export(module.exports, "addGimmickMatch", () => $63f6dc8ca1007bd9$export$a9e9ed8a0ce1f9d9);
$parcel$export(module.exports, "getViewSegmentsData", () => $63f6dc8ca1007bd9$export$6b95ca3478855e5e);
$parcel$export(module.exports, "getEditSegmentsData", () => $63f6dc8ca1007bd9$export$940248067d6ac444);
$parcel$export(module.exports, "removeSegmentItem", () => $63f6dc8ca1007bd9$export$c90392a9e9f4afe7);
$parcel$export(module.exports, "getEditSegmentData", () => $63f6dc8ca1007bd9$export$9463f2008227089b);
$parcel$export(module.exports, "addCustomSegmentItem", () => $63f6dc8ca1007bd9$export$4cd70676862a65d6);
$parcel$export(module.exports, "createCustomSegmentItem", () => $63f6dc8ca1007bd9$export$5fd69b449ba075f9);
$parcel$export(module.exports, "editCustomSegmentItem", () => $63f6dc8ca1007bd9$export$abac02a9779ad029);
$parcel$export(module.exports, "getViewTitlesData", () => $63f6dc8ca1007bd9$export$a173f1800798fbe9);
$parcel$export(module.exports, "getCompanyBrandNames", () => $63f6dc8ca1007bd9$export$140a1634590e6f31);
$parcel$export(module.exports, "getCompanySuperstarsData", () => $63f6dc8ca1007bd9$export$78a94493d0ba8421);
$parcel$export(module.exports, "getCompanyGimmickMatchesForChampionshipGimmick", () => $63f6dc8ca1007bd9$export$fc43503f1679e520);
$parcel$export(module.exports, "getCompanyChampionshipsData", () => $63f6dc8ca1007bd9$export$1f0f2c845718ba00);
$parcel$export(module.exports, "addChampionship", () => $63f6dc8ca1007bd9$export$8b9c0c5c6c2d0ae5);
$parcel$export(module.exports, "getChampionshipCost", () => $63f6dc8ca1007bd9$export$c1d55cf219b3030a);
$parcel$export(module.exports, "getChampionshipPopularityIncrease", () => $63f6dc8ca1007bd9$export$5c151ed57a6f3af0);
$parcel$export(module.exports, "changeProperty", () => $63f6dc8ca1007bd9$export$94ff8d12f6118ed0);
$parcel$export(module.exports, "processObjectiveCompleted", () => $63f6dc8ca1007bd9$export$e538311ea37ef618);
$parcel$export(module.exports, "getCompanyUnreadMessages", () => $63f6dc8ca1007bd9$export$18f27f63ba1cd846);
$parcel$export(module.exports, "rebrandChampionship", () => $63f6dc8ca1007bd9$export$5c74b918b9f4f9aa);
$parcel$export(module.exports, "processChampionshipXpChange", () => $63f6dc8ca1007bd9$export$3b5efa76271d873e);
$parcel$export(module.exports, "updateCompanyLogsForTalentNameChange", () => $63f6dc8ca1007bd9$export$92c874eb396f0a17);
$parcel$export(module.exports, "vacateChampionship", () => $63f6dc8ca1007bd9$export$7b901a14f8fe4bcc);
$parcel$export(module.exports, "getChampionshipPopularityDecrease", () => $63f6dc8ca1007bd9$export$fbcff619e4586bd);
$parcel$export(module.exports, "retireChampionship", () => $63f6dc8ca1007bd9$export$ef948d8338b7388d);
$parcel$export(module.exports, "rebrandCompany", () => $63f6dc8ca1007bd9$export$e56d1a92442490eb);
$parcel$export(module.exports, "updateObjectOverness", () => $63f6dc8ca1007bd9$export$655e9945239cdcf8);
$parcel$export(module.exports, "checkObjectHot", () => $63f6dc8ca1007bd9$export$11b9bdb11e994fcf);
$parcel$export(module.exports, "checkObjectStale", () => $63f6dc8ca1007bd9$export$714afb045cf567b2);
$parcel$export(module.exports, "getCompanyOwnerName", () => $63f6dc8ca1007bd9$export$cc331890c5084e7a);
$parcel$export(module.exports, "addFormerCompanyRelationship", () => $63f6dc8ca1007bd9$export$defc55f9bb616482);
$parcel$export(module.exports, "getAddStaffTaskData", () => $63f6dc8ca1007bd9$export$8e4a01037594af53);
$parcel$export(module.exports, "getTransitionToStaffMemberRoleBoostData", () => $63f6dc8ca1007bd9$export$8c6d6c10ad895ff6);
$parcel$export(module.exports, "addStaffTask", () => $63f6dc8ca1007bd9$export$4faa8a50b981c70a);
$parcel$export(module.exports, "getAddManagerRelationshipData", () => $63f6dc8ca1007bd9$export$d3c668cb6b2aefd0);
$parcel$export(module.exports, "getRemoveManagerRelationshipData", () => $63f6dc8ca1007bd9$export$b437afac0b487f4c);
$parcel$export(module.exports, "addManagerRelationship", () => $63f6dc8ca1007bd9$export$908152b08c70b8f7);
$parcel$export(module.exports, "removeManagerRelationship", () => $63f6dc8ca1007bd9$export$c32335be1103bf0d);
$parcel$export(module.exports, "getCpuControlledCompanies", () => $63f6dc8ca1007bd9$export$6662b06ad2b15a09);
$parcel$export(module.exports, "getCompanyProducers", () => $63f6dc8ca1007bd9$export$e423d864a1905a6a);
$parcel$export(module.exports, "getBookingGimmickMatchesData", () => $63f6dc8ca1007bd9$export$2896194470d06224);
$parcel$export(module.exports, "generateGimmickMatchObject", () => $63f6dc8ca1007bd9$export$c76611feb0e9a24e);
$parcel$export(module.exports, "generateGimmickMatchObjectName", () => $63f6dc8ca1007bd9$export$9f725fd28572ce6d);
$parcel$export(module.exports, "generateGimmickMatchLocation", () => $63f6dc8ca1007bd9$export$e70d402d31666f93);
$parcel$export(module.exports, "generateGimmickMatchLocationName", () => $63f6dc8ca1007bd9$export$57867d2a1d8a0a08);
$parcel$export(module.exports, "generateGimmickMatch", () => $63f6dc8ca1007bd9$export$2577d2e12fe20c05);
$parcel$export(module.exports, "getCompanyUniqueTournaments", () => $63f6dc8ca1007bd9$export$529bc4c128273050);
$parcel$export(module.exports, "updateStaffMemberXp", () => $63f6dc8ca1007bd9$export$22984e5bac6d78c5);
$parcel$export(module.exports, "getStaffAgeMultiplier", () => $63f6dc8ca1007bd9$export$1a4fcd5cdd1b5e40);
$parcel$export(module.exports, "checkCompetitorsAvailableForBuyout", () => $63f6dc8ca1007bd9$export$4613c45b669b9363);
$parcel$export(module.exports, "addNewCompetitorCheck", () => $63f6dc8ca1007bd9$export$27e60e7d6ff81724);
$parcel$export(module.exports, "getBuyoutInformation", () => $63f6dc8ca1007bd9$export$5c4f16ca69677e4a);
$parcel$export(module.exports, "makeBuyoutOffer", () => $63f6dc8ca1007bd9$export$cb78fd4b9b7c8986);
$parcel$export(module.exports, "confirmBuyoutSelections", () => $63f6dc8ca1007bd9$export$cac4ba4211f70e11);
$parcel$export(module.exports, "addNewCompanyStaffAndFacilities", () => $63f6dc8ca1007bd9$export$ad001f2932d102e1);
$parcel$export(module.exports, "processSuperstarsYearlyChanges", () => $63f6dc8ca1007bd9$export$ffbf66b849aebc45);
$parcel$export(module.exports, "getViewershipData", () => $63f6dc8ca1007bd9$export$35fabf184faa077e);
$parcel$export(module.exports, "changeCurrentCompany", () => $63f6dc8ca1007bd9$export$af038510249ddb52);
$parcel$export(module.exports, "getUserCompanies", () => $63f6dc8ca1007bd9$export$b17cc431a6faf390);
$parcel$export(module.exports, "getFormNewCompanyInformation", () => $63f6dc8ca1007bd9$export$4ee2598fa0e8c4fc);
$parcel$export(module.exports, "generateFormNewCompanyOwnerName", () => $63f6dc8ca1007bd9$export$3ddce8cece123621);
$parcel$export(module.exports, "startFormingNewCompany", () => $63f6dc8ca1007bd9$export$1502697a3002b5fc);
$parcel$export(module.exports, "confirmNewCompanyDetails", () => $63f6dc8ca1007bd9$export$fdf398db72a92ada);
$parcel$export(module.exports, "getNewCompanySelectionsData", () => $63f6dc8ca1007bd9$export$1ac9f3dd088d2125);
$parcel$export(module.exports, "confirmNewCompanyTalent", () => $63f6dc8ca1007bd9$export$f818672de6f4449d);
$parcel$export(module.exports, "formNewCompany", () => $63f6dc8ca1007bd9$export$bc22e60b13ece380);

var $14eBR = parcelRequire("14eBR");

var $9esFv = parcelRequire("9esFv");

var $iQtzn = parcelRequire("iQtzn");

var $dl5u4 = parcelRequire("dl5u4");

var $5ZsVo = parcelRequire("5ZsVo");

var $3E8Nt = parcelRequire("3E8Nt");

var $5kTkA = parcelRequire("5kTkA");

var $kZwpB = parcelRequire("kZwpB");

var $dBFC4 = parcelRequire("dBFC4");

var $98xmD = parcelRequire("98xmD");

var $iRMwH = parcelRequire("iRMwH");

var $5NNI6 = parcelRequire("5NNI6");

var $hBIDz = parcelRequire("hBIDz");

var $1JSre = parcelRequire("1JSre");

var $5JRw3 = parcelRequire("5JRw3");

var $hekDR = parcelRequire("hekDR");

var $4EGpv = parcelRequire("4EGpv");

var $i7bmn = parcelRequire("i7bmn");

var $972Ip = parcelRequire("972Ip");

var $2JFAd = parcelRequire("2JFAd");

var $ivuOU = parcelRequire("ivuOU");

var $ko5kE = parcelRequire("ko5kE");

var $cXLSF = parcelRequire("cXLSF");

var $4ptHI = parcelRequire("4ptHI");

var $6RCLU = parcelRequire("6RCLU");

var $9MKdC = parcelRequire("9MKdC");

var $cYLJ6 = parcelRequire("cYLJ6");

var $cMrnz = parcelRequire("cMrnz");

var $4K85d = parcelRequire("4K85d");

var $1Dp0h = parcelRequire("1Dp0h");

var $iWkAo = parcelRequire("iWkAo");

var $aP7lq = parcelRequire("aP7lq");

var $5DBvS = parcelRequire("5DBvS");

var $ct4m6 = parcelRequire("ct4m6");

var $1olyO = parcelRequire("1olyO");

var $kZMqI = parcelRequire("kZMqI");

var $8bQDO = parcelRequire("8bQDO");

var $18vSN = parcelRequire("18vSN");

var $kpu3X = parcelRequire("kpu3X");

var $5yA6U = parcelRequire("5yA6U");

var $cJeaP = parcelRequire("cJeaP");

var $jDtEn = parcelRequire("jDtEn");

var $3SyPM = parcelRequire("3SyPM");

var $6PzHO = parcelRequire("6PzHO");

var $fQoFZ = parcelRequire("fQoFZ");

var $66ItE = parcelRequire("66ItE");

var $bZol7 = parcelRequire("bZol7");

var $3MfBd = parcelRequire("3MfBd");

var $im36F = parcelRequire("im36F");

var $dfpYx = parcelRequire("dfpYx");
async function $63f6dc8ca1007bd9$export$be76e1c1c7fb3418(company) {
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "main");
    return (0, $dl5u4.getRosterSuperstars)(mainRoster);
}
async function $63f6dc8ca1007bd9$export$596e41e02971e822(company, rosterType, companyRosters = null) {
    if (!companyRosters) companyRosters = await (0, $9esFv.getCompanyRosters)(company);
    return companyRosters.find((x)=>x.type === rosterType);
}
function $63f6dc8ca1007bd9$export$ebbfd7a50411b417(company) {
    if (!company.gameId) return;
    return (0, $14eBR.Events).find({
        "companyId": company.$loki
    }).reverse()[0];
}
async function $63f6dc8ca1007bd9$export$4bf68489d4ce7543(company, parentEvents = null) {
    let companyEvents = await (0, $9esFv.getCompanyEvents)(company);
    // Get parent event names
    if (!parentEvents) parentEvents = companyEvents.slice(0, 12);
    let parentEventNames = parentEvents.map((x)=>x.name);
    // Get latest monthly event
    let latestMonthlyEvent = (0, $5ZsVo.getLatestMonthlyEvent)(companyEvents);
    // Get name of latest monthly event
    let latestMonthlyEventName = latestMonthlyEvent.name;
    if (!parentEventNames.includes(latestMonthlyEvent.name)) {
        // If event name changed, use parent event name
        let latestMonthlyEventParent = await (0, $iQtzn.getParentEvent)(latestMonthlyEvent);
        if (latestMonthlyEventParent) latestMonthlyEventName = latestMonthlyEventParent.name;
    }
    // Get current month using index of latest monthly event name
    return parentEventNames.indexOf(latestMonthlyEventName);
}
async function $63f6dc8ca1007bd9$export$90a9e2fee4b79199(startingEvents) {
    // Get starting month index by getting index of starting event in parent events
    let startingMonth;
    const firstEvent = startingEvents[startingEvents.length - 1];
    const parentEventNames = startingEvents.slice(0, 12).map((x)=>x.name);
    if (parentEventNames.indexOf(firstEvent.name) > 0) startingMonth = parentEventNames.indexOf(firstEvent.name);
    else {
        // If first event's name changed, use parent event
        const firstEventParentEvent = await (0, $iQtzn.getParentEvent)(firstEvent);
        startingMonth = parentEventNames.indexOf(firstEventParentEvent.name);
    }
    return startingMonth;
}
async function $63f6dc8ca1007bd9$export$b46355eaea227f33(companyToBuyout, userCompany) {
    let data = {};
    const companyToBuyoutSuperstars = await $63f6dc8ca1007bd9$export$be76e1c1c7fb3418(companyToBuyout);
    const [availableSuperstars, _] = await $63f6dc8ca1007bd9$export$21c3db4bb65d37b0(companyToBuyout, companyToBuyoutSuperstars, userCompany);
    const numberOfBuyoutSignings = $63f6dc8ca1007bd9$export$ae21115afb55aed9(companyToBuyout);
    const companyToBuyoutChampionships = await (0, $9esFv.getCompanyChampionships)(companyToBuyout);
    data["companyName"] = companyToBuyout.name;
    data["companyUid"] = companyToBuyout.$loki;
    data["ownerName"] = userCompany.ownerName ? userCompany.ownerName : "The owner";
    data["signingsAvailable"] = numberOfBuyoutSignings;
    // Get superstars, sort by popularity
    data["superstars"] = companyToBuyoutSuperstars.map((x)=>{
        return {
            "name": x.name,
            "popularity": x.popularity,
            "age": x.age,
            "uid": x.$loki,
            "appearances": x.partTimer ? x.appearances : null,
            "retired": x.retired,
            "injured": x.injured > 0 ? x.injured : false,
            "championships": (0, $5kTkA.getSuperstarChampionshipsAll)(x, companyToBuyoutChampionships),
            "available": (0, $3E8Nt.objectInArray)(x, availableSuperstars),
            "fullTimeManager": x.fullTimeManager
        };
    });
    data["superstars"].sort((a, b)=>b.popularity - a.popularity);
    // Get unique championships, sort by rank
    let uniqueChampionships = (0, $kZwpB.getUniqueChampionships)(companyToBuyoutChampionships);
    uniqueChampionships.sort((0, $kZwpB.compareChampionships));
    data["championships"] = uniqueChampionships.map((x)=>{
        return {
            "name": x.name,
            "rank": x.rank,
            "tag": x.tagTeam,
            "trio": x.trio,
            "prestige": x.prestige,
            "uid": x.$loki
        };
    });
    data["championshipsAvailable"] = 3;
    return data;
}
async function $63f6dc8ca1007bd9$export$21c3db4bb65d37b0(companyToBuyout, rosterSuperstars, userCompany) {
    rosterSuperstars.sort((a, b)=>a.$loki - b.$loki);
    const companyRandom = new Math.seedrandom(companyToBuyout.meta.created);
    // Get percentage of superstars that will be available
    const talentManager = $63f6dc8ca1007bd9$export$c39c537a73a9ae6e(await (0, $9esFv.getCompanyStaff)(userCompany), "talent_manager");
    const talentManagerLevel = talentManager ? talentManager.level : 1;
    const percentageAvailableDict = {
        1: [
            0.4,
            0.5
        ],
        2: [
            0.5,
            0.6
        ],
        3: [
            0.6,
            0.7
        ],
        "default": [
            0.4,
            0.5
        ]
    };
    const percentageAvailableRange = percentageAvailableDict[talentManagerLevel] || percentageAvailableDict["default"];
    const percentageAvailableValue = (0, $3E8Nt.getRandomUniform)(percentageAvailableRange[0], percentageAvailableRange[1], companyRandom());
    // Get available / not available superstars
    const numberAvailable = Math.round(percentageAvailableValue * rosterSuperstars.length);
    const available = (0, $3E8Nt.getRandomSample)(rosterSuperstars, numberAvailable, companyRandom);
    const notAvailable = rosterSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, available));
    return [
        available,
        notAvailable
    ];
}
function $63f6dc8ca1007bd9$export$ae21115afb55aed9(company) {
    const companyRandom = new Math.seedrandom(company.meta.created);
    return (0, $3E8Nt.getRandomInt)(12, 18, companyRandom());
}
async function $63f6dc8ca1007bd9$export$c381cdf49b57db6(company, game) {
    let check = false;
    const gameCompanies = await (0, $iRMwH.getGameActiveCompanies)(game);
    const companyToBuyout = gameCompanies.find((x)=>x.operatingStatus.includes("Running Buyout"));
    if (companyToBuyout && (0, $98xmD.globalUser).paid) {
        // Check if company doing buyout is selected for local multiplayer
        let localMultiplayerBuyoutCheck = true;
        if (game.settings["control_multiple_companies"]) {
            localMultiplayerBuyoutCheck = false;
            const companyPerformingBuyoutName = companyToBuyout.operatingStatus.split(" ").slice(3).join(" ");
            if (company.name === companyPerformingBuyoutName) localMultiplayerBuyoutCheck = true;
            else {
                // If company doing buyout not found (e.g company name changed), run buyout for any user company
                const userControlledCompanies = gameCompanies.filter((x)=>x.userControlled);
                if (!userControlledCompanies.some((x)=>x.name === companyPerformingBuyoutName)) localMultiplayerBuyoutCheck = true;
            }
        }
        if (localMultiplayerBuyoutCheck) check = true;
    }
    return [
        check,
        companyToBuyout
    ];
}
async function $63f6dc8ca1007bd9$export$745573c3519c00ba(company) {
    return (0, $14eBR.Events).chain().find({
        "companyId": company.$loki
    }).limit(12).data();
}
async function $63f6dc8ca1007bd9$export$d98ad16df125836b() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get data for all active companies
    let data = {};
    const activeCompanies = await (0, $iRMwH.getGameActiveCompanies)(currentGame);
    data["companies"] = activeCompanies.map((x)=>$63f6dc8ca1007bd9$var$getViewCompanyData(x, userCompany));
    // Sort by fans
    data["companies"].sort((a, b)=>b.fans - a.fans);
    data["formingNewCompany"] = userCompany.newCompanyData?.monthsToForm !== undefined;
    return data;
}
function $63f6dc8ca1007bd9$var$getViewCompanyData(company, userCompany) {
    let data = {};
    data["name"] = company.name;
    data["fans"] = company.fans;
    data["points"] = company.points;
    data["reputation"] = company.reputation;
    data["highestReputation"] = company.highestReputation;
    data["style"] = company.style;
    data["uid"] = company.$loki;
    data["availableForBuyout"] = company.operatingStatus === "Buyout Available";
    data["overness"] = company.overness;
    data["hot"] = company.hot;
    data["stale"] = company.stale;
    data["ownerName"] = company.ownerName;
    data["playerName"] = company.playerName;
    data["isUserCompany"] = company.$loki === userCompany.$loki;
    data["isUserControlled"] = company.userControlled;
    return data;
}
async function $63f6dc8ca1007bd9$export$1e4a46f46735bc71(company, game) {
    const activeCompanies = await (0, $iRMwH.getGameActiveCompanies)(game);
    return activeCompanies.filter((x)=>x.$loki !== company.$loki);
}
function $63f6dc8ca1007bd9$export$d342efbc7d93e412(company, game) {
    const reputationCapacityData = {
        1: 20,
        2: 25,
        3: 35,
        4: 45,
        5: 60,
        6: 75,
        7: 95,
        8: 115,
        9: 140,
        10: 180
    };
    // If maximum roster capacity selected, get max value
    if (company.userControlled && game.settings["maximum_roster_capacity"]) return (0, $3E8Nt.gameLimits).maxRosterSuperstars;
    else return reputationCapacityData[company.reputation];
}
async function $63f6dc8ca1007bd9$export$42db1b2640598504() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get data for active companies
    const activeCompanies = await (0, $iRMwH.getGameActiveCompanies)(currentGame);
    let data = activeCompanies.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki,
            "isCompetitor": x.$loki !== userCompany.$loki
        };
    });
    // Sort by user company first
    data.sort((a, b)=>a.isCompetitor - b.isCompetitor);
    return data;
}
async function $63f6dc8ca1007bd9$export$ca78fbcdc54ce76a() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get competitors sorted by highest reputation
    let data = {};
    const competitors = await $63f6dc8ca1007bd9$export$1e4a46f46735bc71(userCompany, currentGame);
    competitors.sort((a, b)=>b.reputation - a.reputation);
    data["competitors"] = competitors.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    data["userCompanyName"] = userCompany.name;
    return data;
}
function $63f6dc8ca1007bd9$export$c39c537a73a9ae6e(staffMembers, role) {
    let staffMember = null;
    const availableStaffMembers = $63f6dc8ca1007bd9$export$4300fa74fcc6d545(staffMembers);
    const roleStaffMembers = availableStaffMembers.filter((x)=>x.role === role);
    if (roleStaffMembers.length > 0) staffMember = (0, $3E8Nt.getArrayMaxByProperty)(roleStaffMembers, "level");
    return staffMember;
}
function $63f6dc8ca1007bd9$export$499c40897d9957a2(staffMembers, role) {
    let staffMember = null;
    const availableStaffMembers = $63f6dc8ca1007bd9$export$4300fa74fcc6d545(staffMembers);
    const roleStaffMembers = availableStaffMembers.filter((x)=>x.role === role);
    if (roleStaffMembers.length > 0) staffMember = (0, $3E8Nt.getRandomChoice)(roleStaffMembers);
    return staffMember;
}
function $63f6dc8ca1007bd9$export$4300fa74fcc6d545(staffMembers) {
    return staffMembers.filter((x)=>x.unavailableMonths <= 0 && !x.retired);
}
function $63f6dc8ca1007bd9$export$3117d1c4fcb92e56(staffMembers, role) {
    return $63f6dc8ca1007bd9$export$4300fa74fcc6d545(staffMembers).filter((x)=>x.role === role);
}
async function $63f6dc8ca1007bd9$export$b9c10e56bdeeffa4() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get data for current objectives
    let data = {};
    const objectives = (await (0, $9esFv.getCompanyObjectives)(userCompany)).filter((x)=>!x.past);
    data["objectives"] = await Promise.all(objectives.map((x)=>$63f6dc8ca1007bd9$var$getObjectiveData(x)));
    // Check tutorial action
    if (userCompany.storyName === "tutorial") {
        data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
            "goals"
        ]);
        (0, $14eBR.db).saveDatabase();
    }
    return data;
}
async function $63f6dc8ca1007bd9$var$getObjectiveData(objective) {
    let data = {};
    const objectiveProperty = (await (0, $5NNI6.getObjectiveProperties)(objective))[0];
    data["name"] = objective.name;
    data["completed"] = objective.completed;
    data["failed"] = objective.failed;
    data["helpText"] = objective.helpText;
    data["value"] = objectiveProperty.value;
    data["activationValue"] = objectiveProperty.activationValue;
    return data;
}
async function $63f6dc8ca1007bd9$export$321fd088e9a7034e(company, game) {
    let data = {};
    let companyObjectives = await (0, $9esFv.getCompanyObjectives)(company);
    let unlockedPowerups = [];
    let awardedPowerups = [];
    if (!company.yearlyReviewRun && $63f6dc8ca1007bd9$export$fe732773535a22d4(company, game) === 0 && $63f6dc8ca1007bd9$export$2c9c79c85a054651(company, game) > 0 && !company.storyName) {
        // Review last year's objectives (current objectives)
        let lastYearsObjectives = companyObjectives.filter((x)=>!x.past);
        let completedObjectives = lastYearsObjectives.filter((x)=>x.completed && !x.past);
        let failedObjectives = lastYearsObjectives.filter((x)=>!x.completed && !x.past);
        data["numberOfCompletedObjectives"] = completedObjectives.length;
        if (completedObjectives.length === lastYearsObjectives.length) {
            // Add points
            let points = (0, $3E8Nt.myround)(Math.pow(game.year, 0.45) * 200, 10);
            if (points > 500) points = 500;
            company.points += points;
            data["bonus"] = points;
            // Generate and add special gimmick match for entertainment companies
            let newMatch = await $63f6dc8ca1007bd9$var$generateSpecialGimmickMatch();
            await (0, $9esFv.addCompanyGimmickMatches)(company, [
                newMatch
            ]);
            data["newMatch"] = newMatch.name;
            // Unlock as many powerups as objectives completed
            let powerups = await (0, $9esFv.getCompanyPowerups)(company);
            if (powerups.length) for (let x of Array(completedObjectives.length).keys())await awardOrUnlockPowerup(powerups);
        } else if (completedObjectives.length === lastYearsObjectives.length - 1) {
            // Unlock powerup
            let powerups = await (0, $9esFv.getCompanyPowerups)(company);
            if (powerups.length) await awardOrUnlockPowerup(powerups);
        } else if (failedObjectives.length === lastYearsObjectives.length) {
            // Remove points
            let points = (0, $3E8Nt.myround)(Math.pow(game.year, 0.7) * 100, 10);
            if (points > 500) points = 500;
            company.points -= points;
            if (company.points < 0) company.points = 0;
            data["punishment"] = points;
        }
        company.yearlyReviewRun = true;
        // Set last year's objectives as past
        for (let x of lastYearsObjectives)x.past = true;
        // Generate new objectives
        let newObjectives = await (0, $5yA6U.generateCompanyObjectives)(company, game);
        await (0, $9esFv.addCompanyObjectives)(company, newObjectives);
        // Add messages
        let reviewMessage = await (0, $hekDR.createObjectivesReviewMessage)(data, company, game);
        if (reviewMessage) await (0, $9esFv.addCompanyMessages)(company, [
            reviewMessage
        ]);
        if (unlockedPowerups.length > 0 || awardedPowerups.length > 0) {
            let powerupsMessage = await (0, $hekDR.createPowerupsAwardedMessage)(unlockedPowerups, awardedPowerups, company, game);
            await (0, $9esFv.addCompanyMessages)(company, [
                powerupsMessage
            ]);
        }
    }
    async function awardOrUnlockPowerup(p) {
        // Unlock powerup
        let powerupsToUnlock = (0, $kpu3X.getPowerupsToUnlock)(p);
        if (powerupsToUnlock.length) {
            let unlockedPowerup = (0, $kpu3X.awardPowerup)(powerupsToUnlock, true, true);
            unlockedPowerups.push({
                name: unlockedPowerup.name,
                level: unlockedPowerup.level,
                storyName: unlockedPowerup.storyName
            });
        } else {
            let powerupsToAward = p.filter((x)=>x.unlocked);
            let unlockedPowerup = (0, $kpu3X.awardPowerup)(powerupsToAward, false, true);
            awardedPowerups.push({
                name: unlockedPowerup.name,
                level: unlockedPowerup.level,
                storyName: unlockedPowerup.storyName
            });
        }
    }
    return data;
}
async function $63f6dc8ca1007bd9$var$generateSpecialGimmickMatch() {
    let match = (0, $cYLJ6.GimmickMatch)();
    await (0, $14eBR.GimmickMatches).insert(match);
    match.name = $63f6dc8ca1007bd9$var$generateGimmickMatchName();
    match.ratingBoost = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(1.2, 1.325), 0.01);
    match.popularityIncrease = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(2, 3), 0.01);
    match.popularityDecrease = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(0.6, 0.35), 0.01);
    match.injuryRate = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(1.15, 1.225), 0.01);
    match.available = true;
    match.special = true;
    // Add cost
    let scaledCost = Math.pow((1 - match.ratingBoost) * 10, 2) * 30;
    let deviation = (0, $3E8Nt.getRandomInt)(Math.floor(scaledCost * -0.2), 0);
    let cost = Math.round(scaledCost + deviation);
    if (cost <= 0) cost = 5;
    cost = (0, $3E8Nt.myround)(cost * 0.6, 10);
    match.cost = cost;
    // Add random weapons
    match.addRandomWeapons = true;
    return match;
}
async function $63f6dc8ca1007bd9$export$2620b3bf8c8a32dd() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(userCompany, "main");
    const companyLogs = (await (0, $9esFv.getCompanyCompanyLogs)(userCompany)).reverse();
    const startingEvents = (0, $14eBR.Events).chain().limit(13).data();
    const startingMonth = await $63f6dc8ca1007bd9$export$90a9e2fee4b79199(startingEvents);
    const mainRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Add data from company logs
    for (const key of [
        "signings",
        "callups",
        "releases",
        "championshipsRebranded",
        "eventsRebranded",
        "companyRebranded",
        "superstarsSuspended",
        "tradeDeals",
        "brandsCreated",
        "brandsRemoved"
    ]){
        const keyTypes = {
            "signings": "signing",
            "callups": "callup",
            "releases": "release",
            "championshipsRebranded": "rebrand-championship",
            "eventsRebranded": "rebrand-event",
            "companyRebranded": "rebrand-company",
            "superstarsSuspended": "suspension",
            "tradeDeals": "trade-deal",
            "brandsCreated": "brand-created",
            "brandsRemoved": "brand-removed"
        };
        const keyType = keyTypes[key];
        const keyCompanyLogs = companyLogs.filter((x)=>x.type === keyType);
        data[key] = keyCompanyLogs.map((x)=>{
            return {
                "name": x.text,
                "value": x.value,
                "date": `${(0, $3E8Nt.getRealMonth)(x.month, startingMonth)} ${x.year}`
            };
        });
    }
    // Get on trade superstars
    const onTradeSuperstars = mainRosterSuperstars.filter((x)=>x.activeEffect === "traded");
    data["onTradeTalent"] = await Promise.all(onTradeSuperstars.map(async (y)=>{
        const originalRoster = await (0, $hBIDz.getSuperstarOriginalRoster)(y);
        let companyName = "";
        if (originalRoster) companyName = (await (0, $dl5u4.getRosterCompany)(originalRoster))?.name;
        return {
            "name": y.name,
            "appearances": y.appearances,
            "company": companyName
        };
    }));
    data["onTradeTalent"].sort((a, b)=>a.appearances - b.appearances);
    return data;
}
async function $63f6dc8ca1007bd9$export$5885c25141ba42dc(graphType, timePeriod, showBrandsSeparately) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const allCompanies = await (0, $iRMwH.getGameActiveCompanies)(currentGame);
    let colors = [
        [
            "#d63d29",
            "#ab2e22",
            "#702015"
        ],
        [
            "#4e77c2",
            "#395b96",
            "#25375c"
        ],
        [
            "#c9a136",
            "#9e7f2b",
            "#63501b"
        ],
        [
            "#8657d0",
            "#6a46a6",
            "#452d6b"
        ],
        [
            "#50aeb5",
            "#3d858a",
            "#234c4f"
        ],
        [
            "#8db021",
            "#6a8519",
            "#3b4a0e"
        ],
        [
            "#cc7432",
            "#a1602b",
            "#663b1a"
        ],
        [
            "#68a3d5",
            "#5088ab",
            "#375570"
        ],
        [
            "#d04a91",
            "#a63c74",
            "#6b274b"
        ],
        [
            "#9e99d4",
            "#7e7bab",
            "#524f6e"
        ],
        [
            "#98b273",
            "#738754",
            "#414d32"
        ],
        [
            "#cd90cd",
            "#a175a1",
            "#664766"
        ],
        [
            "#408734",
            "#3c7830",
            "#295421"
        ],
        [
            "#ce9e72",
            "#a18055",
            "#664e38"
        ],
        [
            "#2f6f98",
            "#26597a",
            "#18384d"
        ],
        [
            "#cf787e",
            "#a36262",
            "#693d40"
        ],
        [
            "#b2a46b",
            "#877b51",
            "#595136"
        ],
        [
            "#61bc8b",
            "#4d946e",
            "#2e5942"
        ],
        [
            "#7c382c",
            "#632d23",
            "#4a211a"
        ],
        [
            "#707734",
            "#525e23",
            "#41451e"
        ],
        [
            "#a44d72",
            "#803c59",
            "#663047"
        ]
    ];
    // Check if paid
    const tutorialGoalsState = userCompany.storyName === "tutorial" && await $63f6dc8ca1007bd9$export$5ead34eb308f091f(userCompany) === "goals";
    if (!(0, $98xmD.globalUser).paid && !tutorialGoalsState) {
        data["error"] = "paid-only";
        return data;
    }
    // Get fan history data for each company's events
    const fanHistoryData = [];
    for (const company of allCompanies){
        const roster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "main");
        const rosterBrands = await (0, $dl5u4.getRosterBrands)(roster);
        const companyIndex = allCompanies.indexOf(company);
        // Get events
        let events = await (0, $9esFv.getCompanyEvents)(company);
        if (graphType === "buys") events = events.filter((x)=>!x.weeklyShow);
        else if (graphType === "viewers") events = events.filter((x)=>x.weeklyShow);
        events = events.filter((x)=>x.rating !== null);
        // Get datetime of latest event
        let latestEventDatetime;
        if (events.length > 0) latestEventDatetime = (0, $5ZsVo.getDatetimeForEvent)(events[events.length - 1], rosterBrands);
        // Get data for brand events separately if selected
        if (rosterBrands.length > 0 && showBrandsSeparately) for (const brand of rosterBrands){
            const brandEvents = events.filter((x)=>x.name === brand.weeklyShowName || x.brandName === brand.name);
            const eventsData = $63f6dc8ca1007bd9$var$getFanHistoryEventsData(brandEvents, rosterBrands, timePeriod, graphType, latestEventDatetime);
            const brandIndex = rosterBrands.indexOf(brand);
            const brandColor = brand.color || (colors[companyIndex] ? colors[companyIndex][brandIndex] : "#5d5d5d");
            fanHistoryData.push({
                "name": (0, $1JSre.formatCompanyNameBackend)(brand.name),
                "data": eventsData,
                "color": brandColor,
                "companyXp": company.xp,
                "companyId": company.$loki,
                "userControlled": company.userControlled
            });
        }
        else {
            const eventsData = $63f6dc8ca1007bd9$var$getFanHistoryEventsData(events, rosterBrands, timePeriod, graphType, latestEventDatetime);
            let color = colors[companyIndex] ? colors[companyIndex][0] : "#5d5d5d";
            fanHistoryData.push({
                "name": (0, $1JSre.formatCompanyNameBackend)(company.name),
                "data": eventsData,
                "color": color,
                "companyXp": company.xp,
                "companyId": company.$loki,
                "userControlled": company.userControlled
            });
        }
    }
    // Sort by company xp (except main user company)
    fanHistoryData.sort((a, b)=>{
        if (a.companyId !== userCompany.$loki && b.companyId !== userCompany.$loki) return b.companyXp - a.companyXp;
    });
    data["fanHistoryData"] = fanHistoryData;
    return data;
}
function $63f6dc8ca1007bd9$var$getFanHistoryEventsData(events, rosterBrands, timePeriod, graphType, latestEventDatetime) {
    const eventsData = [];
    for (const event of events){
        // Get event name
        let eventName;
        if (event.weeklyShow) eventName = event.name;
        else {
            const brandName = event.brandName ? ` ${event.brandName}` : "";
            eventName = `${event.name} ${event.year}${brandName}`;
        }
        // Check if event within time period
        const eventDatetime = (0, $5ZsVo.getDatetimeForEvent)(event, rosterBrands);
        if ((0, $5ZsVo.checkEventWithinDatetime)(eventDatetime, latestEventDatetime, timePeriod)) {
            // Add event date
            let yAxisValue;
            if (graphType === "fans") yAxisValue = event.totalFans;
            else if (graphType === "fan-change") yAxisValue = event.fansGained;
            else if (graphType === "star-rating") yAxisValue = event.rating;
            else yAxisValue = event.viewership;
            eventsData.push({
                "x": eventDatetime,
                "y": yAxisValue,
                "description": eventName
            });
        }
    }
    return eventsData;
}
async function $63f6dc8ca1007bd9$export$278b77c4d232095b() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    // Get data for active and retired staff members
    const activeStaffMembers = companyStaffMembers.filter((x)=>!x.retired);
    const retiredStaffMembers = companyStaffMembers.filter((x)=>x.retired);
    data["activeStaffMembers"] = activeStaffMembers.map((x)=>$63f6dc8ca1007bd9$var$getStaffMemberData(x));
    data["retiredStaffMembers"] = retiredStaffMembers.map((x)=>$63f6dc8ca1007bd9$var$getStaffMemberData(x));
    // Get number hired/available for each staff role
    data["staffRoleNumbers"] = {};
    for (const staffRole of (0, $3E8Nt.staffRoles)){
        const roleData = {};
        const companyRoles = activeStaffMembers.filter((x)=>x.role === staffRole);
        roleData["numberHired"] = companyRoles.length;
        const facilityName = (0, $3E8Nt.roleToFacilityData)[staffRole];
        const facility = (await (0, $9esFv.getCompanyFacilities)(userCompany)).find((x)=>x.name === facilityName);
        roleData["numberAvailable"] = $63f6dc8ca1007bd9$var$getNumberOfStaffForFacility(facility);
        data["staffRoleNumbers"][staffRole] = roleData;
    }
    return data;
}
function $63f6dc8ca1007bd9$var$getStaffMemberData(staffMember) {
    let data = {};
    data["name"] = staffMember.name;
    data["role"] = staffMember.role;
    data["pronoun"] = (0, $3E8Nt.getRosterMemberPronoun)(staffMember);
    data["age"] = staffMember.age;
    data["graphic"] = $63f6dc8ca1007bd9$export$d02b031b0adfeba2(staffMember);
    data["level"] = staffMember.level;
    data["xp"] = staffMember.xp;
    data["cost"] = staffMember.cost;
    data["currentTask"] = staffMember.currentTask;
    data["monthsLeftForTask"] = staffMember.monthsLeftForTask;
    data["retired"] = staffMember.retired;
    data["unavailableMonths"] = staffMember.unavailableMonths;
    data["uid"] = staffMember.$loki;
    data["superstarObjectPresent"] = staffMember.superstarObjectId !== null;
    return data;
}
function $63f6dc8ca1007bd9$export$d02b031b0adfeba2(staffMember) {
    let staffMemberGraphic = JSON.parse(JSON.stringify(staffMember.graphic));
    if (!staffMemberGraphic || Object.keys(staffMemberGraphic).length === 0) staffMemberGraphic = (0, $5kTkA.getEmptySuperstarGraphic)(staffMember);
    return staffMemberGraphic;
}
function $63f6dc8ca1007bd9$var$getNumberOfStaffForFacility(facility) {
    const data = {
        1: 1,
        2: 2,
        3: 3
    };
    const facilityLevel = facility ? facility.level : 1;
    return data[facilityLevel] || 1;
}
async function $63f6dc8ca1007bd9$export$8a10a4d37deed126(uid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    const companyStaffMembers = (await (0, $9esFv.getCompanyStaff)(userCompany)).filter((x)=>!x.retired);
    const indieAvailableRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(mainCompany, "indieAvailable");
    // Find staff member to hire
    const staffMember = (await (0, $dl5u4.getRosterStaff)(indieAvailableRoster)).find((x)=>x.$loki === uid);
    // Check if staff found
    if (!staffMember) {
        data["error"] = "not-found";
        return data;
    }
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Check if enough points
    if (userCompany.points < staffMember.cost) {
        data["error"] = "points";
        return data;
    }
    // Check if facility level allows staff member level
    const role = staffMember.role;
    const facilityName = (0, $3E8Nt.roleToFacilityData)[role];
    let facility;
    if (facilityName) {
        facility = (await (0, $9esFv.getCompanyFacilities)(userCompany)).find((x)=>x.name === facilityName);
        if (facility && staffMember.level > facility.level) {
            data["error"] = "facility-level";
            data["facilityName"] = facilityName;
            data["facilityLevel"] = facility.level;
            data["role"] = role;
            return data;
        }
    }
    // Check number of staff roles present
    if (!staffMember.retired) {
        const companyRoles = companyStaffMembers.filter((x)=>x.role === role);
        let numberOfCompanyRoles = companyRoles.length;
        for (const companyStaffMember of companyStaffMembers)// Include superstars transitioning to staff
        if (companyStaffMember.taskData && companyStaffMember.taskData["role_name"] === role) numberOfCompanyRoles += 1;
        const numberOfRoles = $63f6dc8ca1007bd9$var$getNumberOfStaffForFacility(facility);
        if (numberOfCompanyRoles >= numberOfRoles) {
            data["error"] = "max-roles";
            data["role"] = role;
            data["facilityName"] = facilityName ? facilityName : "";
            data["numberOfRoles"] = numberOfRoles;
            return data;
        }
    }
    // Add staff member to user company
    await (0, $9esFv.addCompanyStaff)(userCompany, [
        staffMember
    ]);
    await (0, $dl5u4.removeRosterStaff)(indieAvailableRoster, [
        staffMember
    ]);
    // Remove points
    userCompany.points -= staffMember.cost;
    // Add message
    if (!staffMember.retired) {
        let newMessage;
        if (facility && facility.staffNeverHired) {
            newMessage = await (0, $hekDR.createNewCompanyStaffMemberMessage)(staffMember, userCompany, currentGame);
            facility.staffNeverHired = false;
        } else newMessage = await (0, $hekDR.createStaffHiredMessage)(staffMember, currentGame.monthCount, currentGame.year);
        await (0, $9esFv.addCompanyMessages)(userCompany, [
            newMessage
        ]);
        // Unlock special segment
        if (staffMember.level === 3 && staffMember.role === "doctor") {
            const user = (0, $bZol7.loadUser)();
            await (0, $3SyPM.unlockSpecialSegment)(userCompany, "Timely Rescue", currentGame.monthCount, currentGame.year);
        }
    }
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["name"] = staffMember.name;
    data["points"] = userCompany.points;
    const unreadMessages = (await (0, $9esFv.getCompanyMessages)(userCompany)).filter((x)=>!x.read);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $63f6dc8ca1007bd9$export$6a262ebc29342441(uid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyStaffMembers = (await (0, $9esFv.getCompanyStaff)(userCompany)).filter((x)=>!x.retired);
    const indieAvailableRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(mainCompany, "indieAvailable");
    // Find staff member to fire
    const staffMember = companyStaffMembers.find((x)=>x.$loki === uid);
    // Check if staff found
    if (!staffMember) {
        data["error"] = "not-found";
        return data;
    }
    // Remove staff member from user company
    await (0, $9esFv.removeCompanyStaff)(userCompany, [
        staffMember
    ]);
    await (0, $dl5u4.addRosterStaff)(indieAvailableRoster, [
        staffMember
    ]);
    // Remove task
    $63f6dc8ca1007bd9$export$2c5f6e19e926959f(staffMember);
    // Add message
    const newMessage = await (0, $hekDR.createStaffFiredMessage)(staffMember, currentGame.monthCount, currentGame.year);
    await (0, $9esFv.addCompanyMessages)(userCompany, [
        newMessage
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["name"] = staffMember.name;
    const unreadMessages = (await (0, $9esFv.getCompanyMessages)(userCompany)).filter((x)=>!x.read);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
function $63f6dc8ca1007bd9$export$2c5f6e19e926959f(staffMember) {
    staffMember.currentTask = null;
    staffMember.taskData = {};
    staffMember.monthsLeftForTask = null;
    return true;
}
async function $63f6dc8ca1007bd9$export$5ead34eb308f091f(company) {
    const storyChoices = await (0, $9esFv.getCompanyStoryChoices)(company);
    return storyChoices[0].choice;
}
async function $63f6dc8ca1007bd9$export$52d388e8c053912e() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyFacilities = await (0, $9esFv.getCompanyFacilities)(userCompany);
    data["facilities"] = companyFacilities.map((x)=>$63f6dc8ca1007bd9$var$getFacilityData(x));
    // Check tutorial action
    if (userCompany.storyName === "tutorial") {
        data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
            "view_staff_and_facilities"
        ]);
        (0, $14eBR.db).saveDatabase();
    }
    return data;
}
function $63f6dc8ca1007bd9$var$getFacilityData(facility) {
    let data = {};
    const levelPhrases = {
        2: "a Developed",
        3: "an Advanced"
    };
    data["name"] = facility.name;
    data["level"] = facility.level;
    data["actionsCompleted"] = facility.actionsCompleted;
    data["uid"] = facility.$loki;
    data["levelPhrase"] = levelPhrases[facility.level];
    // Get actions to next level
    const facilityData = (0, $3E8Nt.facilitiesData)[facility.name];
    const nextLevel = facility.level + 1;
    data["actionsToNextLevel"] = facilityData["actionsToNextLevel"][nextLevel];
    data["actionName"] = facilityData["actionName"];
    data["nextLevelInfo"] = facilityData["nextLevelInfo"][facility.level] || "No information available";
    // Last level info
    if (facility.level === 1) data["lastLevelInfo"] = facilityData["nextLevelInfo"][facility.level + 1] || "";
    if (facility.level < 3) data["nextLevelCost"] = (0, $3E8Nt.facilityLevelCosts)[nextLevel];
    return data;
}
async function $63f6dc8ca1007bd9$export$15ff38ad84708b93(uid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyFacilities = await (0, $9esFv.getCompanyFacilities)(userCompany);
    const companyFacility = companyFacilities.find((x)=>x.$loki === uid);
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Check facility requirements
    const levelCheck = $63f6dc8ca1007bd9$var$checkFacilityLevelActionsCompleted(companyFacility);
    if (!levelCheck) {
        if (companyFacility.level >= 3) data["error"] = "max-level";
        else data["error"] = "requirements-failed";
        return data;
    }
    // Check cost
    const cost = (0, $3E8Nt.facilityLevelCosts)[companyFacility.level + 1];
    if (userCompany.points < cost) {
        data["error"] = "points";
        return data;
    }
    // Upgrade facility level
    companyFacility.level += 1;
    userCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["facility"] = $63f6dc8ca1007bd9$var$getFacilityData(companyFacility);
    data["points"] = userCompany.points;
    return data;
}
function $63f6dc8ca1007bd9$var$checkFacilityLevelActionsCompleted(facility) {
    if (facility.level < 3) {
        const facilityData = (0, $3E8Nt.facilitiesData)[facility.name];
        const actionsToNextLevel = facilityData["actionsToNextLevel"][facility.level + 1];
        return facility.actionsCompleted >= actionsToNextLevel;
    }
    return false;
}
async function $63f6dc8ca1007bd9$export$51eebd90bf2c0c61(name, company) {
    if (company.userControlled) {
        const facility = (await (0, $9esFv.getCompanyFacilities)(company)).find((x)=>x.name === name);
        if (facility) {
            const oldUpgradeCheck = $63f6dc8ca1007bd9$var$checkFacilityLevelActionsCompleted(facility);
            facility.actionsCompleted += 1;
            const upgradeCheck = $63f6dc8ca1007bd9$var$checkFacilityLevelActionsCompleted(facility);
            if (upgradeCheck && !oldUpgradeCheck) {
                const messageData = {
                    "name": facility.name,
                    "level": facility.level + 1
                };
                const newMessage = await (0, $hekDR.createFacilityUpgradeAvailableMessage)(messageData, company);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
                const newCompanyAlert = await $63f6dc8ca1007bd9$export$d7d1923b1a78ff80("facilityUpgradeAvailable", facility.name);
                await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                    newCompanyAlert
                ]);
            }
        }
    }
    return true;
}
async function $63f6dc8ca1007bd9$export$b8e0770e26ec2a83() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    const indieAvailableRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(mainCompany, "indieAvailable");
    // Fixes hiring for free users upgrading since they don't have any level 1 staff to start off with
    if ((await (0, $9esFv.getCompanyFacilities)(userCompany)).filter((x)=>x.level === 1).length > 0) {
        for (const staffRole of (0, $3E8Nt.staffRoles))// If staff member not in user's game and level 1 not available on indies, generate
        if ((await (0, $9esFv.getCompanyStaff)(userCompany)).filter((y)=>y.role === staffRole).length <= 0 && (await (0, $dl5u4.getRosterStaff)(indieAvailableRoster)).filter((z)=>z.level === 1 && z.role === staffRole).length <= 0) {
            const staffMember = await (0, $8bQDO.generateStaffMember)(staffRole, 1);
            await (0, $dl5u4.addRosterStaff)(indieAvailableRoster, [
                staffMember
            ]);
            (0, $14eBR.db).saveDatabase();
        }
    }
    return $63f6dc8ca1007bd9$var$getRosterStaffData(indieAvailableRoster);
}
async function $63f6dc8ca1007bd9$var$getRosterStaffData(roster) {
    let data = [];
    const staffMembers = await (0, $dl5u4.getRosterStaff)(roster);
    staffMembers.sort((a, b)=>a.retired - b.retired || a.role.localeCompare(b.role));
    for (const staffMember of staffMembers){
        // Add cost if not present
        if (!staffMember.cost) {
            staffMember.cost = $63f6dc8ca1007bd9$var$getStaffMemberCost(staffMember);
            (0, $14eBR.db).saveDatabase();
        }
        data.push($63f6dc8ca1007bd9$var$getStaffMemberData(staffMember));
    }
    return data;
}
function $63f6dc8ca1007bd9$var$getStaffMemberCost(staffMember) {
    const scaledPoints = Math.pow(staffMember.level * 50, 1.2);
    const deviation = Math.round(scaledPoints * 0.1);
    let totalPoints = scaledPoints + (0, $3E8Nt.getRandomInt)(-deviation, deviation);
    totalPoints = (0, $3E8Nt.myround)(totalPoints, 10);
    return totalPoints;
}
async function $63f6dc8ca1007bd9$export$e277bd7468230132(uid) {
    let data = {};
    // Get staff member
    const staffMember = (0, $14eBR.StaffMembers).get(uid);
    // Get data to return
    data["name"] = staffMember.name;
    data["pronoun"] = (0, $3E8Nt.getRosterMemberPronoun)(staffMember);
    data["graphic"] = staffMember.graphic;
    return data;
}
async function $63f6dc8ca1007bd9$export$6506b19d1b107c23(uid, name) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const cost = 50;
    // Get staff member
    const staffMember = companyStaffMembers.find((x)=>x.$loki === uid);
    // Check if staff found
    if (!staffMember) {
        data["error"] = "staff-not-found";
        return data;
    }
    // Check points
    if (userCompany.points < cost) {
        data["error"] = "points";
        return data;
    }
    // Check for same name
    if (name === staffMember.name) {
        data["error"] = "same-name";
        return data;
    }
    // Check for other staff with name
    if (companyStaffMembers.map((x)=>x.name).indexOf(name) >= 0) {
        data["error"] = "name-exists";
        return data;
    }
    // Change name
    if (name) staffMember.name = name;
    // Remove points
    userCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = userCompany.points;
    data["name"] = staffMember.name;
    return data;
}
async function $63f6dc8ca1007bd9$export$c1f080156be27ee1(uid, pronoun) {
    let data = {};
    // Get staff member
    const staffMember = (0, $14eBR.StaffMembers).get(uid);
    // Check if staff found
    if (!staffMember) {
        data["error"] = "staff-not-found";
        return data;
    }
    // Change gender
    staffMember.gender = (0, $5kTkA.getSuperstarGenderFromPronoun)(pronoun);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $63f6dc8ca1007bd9$export$a270f826a48e086a(uid, graphic) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const cost = 15;
    // Get staff member
    const staffMember = (0, $14eBR.StaffMembers).get(uid);
    // Check if staff found
    if (!staffMember) {
        data["error"] = "staff-not-found";
        return data;
    }
    // Check points
    if (userCompany.points < cost) {
        data["error"] = "points";
        return data;
    }
    // Change graphic
    staffMember.graphic = JSON.parse(graphic);
    // Remove points
    userCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = userCompany.points;
    data["graphic"] = staffMember.graphic;
    return data;
}
async function $63f6dc8ca1007bd9$export$3b41ccd69e0f255a(uid) {
    let data = {};
    // Get staff member
    const staffMember = (0, $14eBR.StaffMembers).get(uid);
    // Check if staff found
    if (!staffMember) {
        data["error"] = "staff-not-found";
        return data;
    }
    // Check for buyout task
    if (staffMember.currentTask.indexOf("Negotiating") >= 0) {
        data["error"] = "negotiating-buyout";
        return data;
    }
    // Remove task
    $63f6dc8ca1007bd9$export$2c5f6e19e926959f(staffMember);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $63f6dc8ca1007bd9$export$83f82a058e9ec30d(year) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const yearlyRankings = (await (0, $dBFC4.getGameYearlyRankings)(currentGame)).reverse();
    // Check if yearly rankings present
    if (yearlyRankings.length <= 0) {
        data["error"] = "no-rankings-present";
        return data;
    }
    // Check if paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Find yearly ranking by year
    let yearlyRanking;
    if (year) yearlyRanking = yearlyRankings.find((x)=>x.year === year);
    else yearlyRanking = yearlyRankings[0];
    // Check if yearly ranking found
    if (!yearlyRanking) {
        data["error"] = "ranking-not-found";
        return data;
    }
    data["ranking"] = (0, $66ItE.getYearlyRankingData)(yearlyRanking, currentGame);
    data["years"] = yearlyRankings.map((x)=>x.year);
    return data;
}
async function $63f6dc8ca1007bd9$export$20b16d33f63d194b(iteration) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    // Check if paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Get annual tournaments
    const annualTournaments = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).filter((x)=>x.annualTournament && x.status === "ended");
    if (annualTournaments.length <= 0) {
        data["error"] = "no-annual-tournament-present";
        return data;
    }
    // Get annual tournament by iteration
    let annualTournament;
    if (iteration && iteration < annualTournaments.length) annualTournament = annualTournaments[iteration - 1];
    else annualTournament = annualTournaments[annualTournaments.length - 1];
    // Get data to return
    data["annualTournament"] = await $63f6dc8ca1007bd9$var$getAnnualTournamentData(annualTournament, currentGame);
    // Get iterations from 1 to number of annual tournaments
    const iterations = Array.from({
        length: annualTournaments.length
    }, (_, i)=>i + 1);
    data["iterations"] = iterations.map((x)=>x <= 30 ? (0, $3E8Nt.romanizeNumber)(x) : x);
    data["iteration"] = annualTournaments.indexOf(annualTournament) + 1;
    return data;
}
async function $63f6dc8ca1007bd9$var$getAnnualTournamentData(annualTournament, game) {
    let data = {};
    const event = await (0, $4EGpv.getTournamentEvent)(annualTournament);
    // Get winner and organization
    const winner = await (0, $4EGpv.getTournamentWinnerSuperstar)(annualTournament);
    const allCompanies = await (0, $dBFC4.getGameCompanies)(game);
    const winnerOrganizationName = (0, $18vSN.getAnnualTournamentParticipantOrganizationName)(winner, annualTournament, allCompanies);
    data["name"] = annualTournament.name;
    data["bracket"] = await $63f6dc8ca1007bd9$var$getTournamentBracket(annualTournament, game);
    data["winner"] = annualTournament.winnerName;
    data["winnerOrganizationName"] = winnerOrganizationName;
    data["uid"] = annualTournament.$loki;
    data["year"] = event ? event.year : null;
    return data;
}
async function $63f6dc8ca1007bd9$export$6e232615a8871480() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    const allCompanies = await (0, $dBFC4.getGameCompanies)(currentGame);
    const previousTournaments = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).filter((x)=>x.annualTournament && x.status === "ended");
    let winners = [];
    let winnerOrganizations = [];
    let allParticipantIds = [];
    let matches = [];
    for (const tournament of previousTournaments){
        // Get winners
        const winner = await (0, $4EGpv.getTournamentWinnerSuperstar)(tournament);
        if (winner) winners.push(winner);
        // Get winner organizations
        const winnerOrganization = await (0, $18vSN.getAnnualTournamentParticipantOrganizationName)(winner, tournament, allCompanies);
        if (winnerOrganization) winnerOrganizations.push(winnerOrganization);
        // Get entries
        const participantIds = (0, $18vSN.getAnnualTournamentAllParticipantIds)(tournament);
        allParticipantIds.push(...participantIds);
        // Get matches
        const tournamentMatches = await (0, $4EGpv.getTournamentMatches)(tournament);
        matches.push(...tournamentMatches);
    }
    // Get top objects
    const uniqueWinners = (0, $3E8Nt.getUniqueObjects)(winners);
    let mostWins = uniqueWinners.map((x)=>{
        return {
            "name": x.name,
            "number": winners.filter((y)=>y.$loki === x.$loki).length
        } // Get count of object
        ;
    });
    mostWins.sort((a, b)=>b.number - a.number); // Get most common objects
    data["mostWins"] = mostWins.slice(0, 3);
    const uniqueWinnerOrganizations = [
        ...new Set(winnerOrganizations)
    ];
    let mostOrganizationWins = uniqueWinnerOrganizations.map((x)=>{
        return {
            "name": x,
            "number": winnerOrganizations.filter((y)=>y === x).length
        };
    });
    mostOrganizationWins.sort((a, b)=>b.number - a.number);
    data["mostOrganizationWins"] = mostOrganizationWins.slice(0, 3);
    const uniqueParticipantIds = [
        ...new Set(allParticipantIds)
    ];
    let mostEntries = uniqueParticipantIds.map((x)=>{
        return {
            "id": x,
            "number": allParticipantIds.filter((y)=>y === x).length
        };
    });
    mostEntries.sort((a, b)=>b.number - a.number);
    data["mostEntries"] = await Promise.all(// Get entry name from id
    mostEntries.slice(0, 3).map(async (x)=>{
        return {
            "name": (0, $14eBR.Superstars).get(x["id"])?.name,
            "number": x["number"]
        };
    }));
    const sortedMatches = matches.filter((x)=>x.rating > 3).sort((a, b)=>b.rating - a.rating);
    data["bestMatches"] = await Promise.all(sortedMatches.slice(0, 3).map(async (x)=>await $63f6dc8ca1007bd9$var$getAnnualTournamentMatchHistoryData(x)));
    return data;
}
async function $63f6dc8ca1007bd9$var$getAnnualTournamentMatchHistoryData(match) {
    let data = {};
    const matchTournament = await (0, $i7bmn.getMatchTournament)(match);
    data["winner"] = match.winner;
    data["loser"] = match.loser;
    data["rating"] = match.rating;
    data["tournamentName"] = matchTournament.name;
    return data;
}
async function $63f6dc8ca1007bd9$var$getTournamentBracket(tournament, game, startRound = 0) {
    let bracket = {};
    let tournamentMatches = await (0, $4EGpv.getTournamentMatches)(tournament);
    const allCompanies = tournament.annualTournament ? await (0, $iRMwH.getGameActiveCompanies)(game) : [];
    // Filter and sort tournament matches
    if (startRound) tournamentMatches = tournamentMatches.filter((x)=>x.tournamentRound > startRound);
    tournamentMatches.sort((a, b)=>b.order - a.order);
    // Get number of rounds
    let numberOfRounds = 1;
    if (tournamentMatches.length > 0) numberOfRounds = Math.floor(Math.log2(tournamentMatches.length * 2));
    // Initialize bracket with rounds
    for(let x = 1 + startRound; x < numberOfRounds + 1 + startRound; x++)bracket[x] = [];
    // Add matches
    for (const match of tournamentMatches){
        let matchData = {};
        const matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
        matchParticipants.sort((a, b)=>a.tournamentSeed - b.tournamentSeed);
        // Get participants data (name, tournament seed, organization name)
        if (matchParticipants.length > 0) {
            matchData["participants"] = [];
            for (const matchParticipant of matchParticipants){
                let participantData = [
                    matchParticipant.name,
                    matchParticipant.tournamentSeed
                ];
                if (tournament.annualTournament) {
                    const participantOrganizationName = (0, $18vSN.getAnnualTournamentParticipantOrganizationName)(matchParticipant, tournament, allCompanies);
                    participantData.push(participantOrganizationName);
                }
                matchData["participants"].push(participantData);
            }
        } else matchData["participants"] = [
            [
                null,
                null
            ],
            [
                null,
                null
            ]
        ];
        matchData["winnerName"] = match.winner;
        // Add using match's round
        try {
            bracket[match.tournamentRound].push(matchData);
        } catch (error) {}
    }
    // Add winners using next round participants
    for(let round in bracket)if (bracket.hasOwnProperty(round)) {
        round = parseInt(round);
        if (round < numberOfRounds) for (const match of bracket[round]){
            let nextRoundWinners = [];
            for (const x of bracket[round + 1])for (const y of x["participants"])nextRoundWinners.push(y[0]);
            let matchWinnerArray = match["participants"].find((z)=>nextRoundWinners.indexOf(z[0]) >= 0);
            match["winner"] = matchWinnerArray ? matchWinnerArray[0] : null;
            // Add using winnerName if participants not found in next round (e.g in tournament substitution)
            if (!match["winner"]) {
                matchWinnerArray = match["participants"].find((z)=>z[0] === match["winnerName"]);
                match["winner"] = matchWinnerArray ? matchWinnerArray[0] : null;
            }
        }
        else try {
            // Tournament winner
            bracket[round][0]["winner"] = tournament.winnerName;
        } catch (error) {}
    }
    return bracket;
}
async function $63f6dc8ca1007bd9$var$getTournamentTable(tournament) {
    let table = [];
    let tournamentMatches = await (0, $4EGpv.getTournamentMatches)(tournament);
    tournamentMatches.sort((a, b)=>b.order - a.order);
    // Get match participants once
    for (const match of tournamentMatches)match.tempParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    // Divide into groups
    let groupMatches = tournamentMatches.filter((x)=>x.tournamentGroup !== null);
    let groupsWithMatches = {};
    for (const groupMatch of groupMatches)if (groupsWithMatches[groupMatch.tournamentGroup]) groupsWithMatches[groupMatch.tournamentGroup].push(groupMatch);
    else groupsWithMatches[groupMatch.tournamentGroup] = [
        groupMatch
    ];
    // Add matches
    for (const [group, matches] of Object.entries(groupsWithMatches)){
        let groupData = [];
        // Add participants using first round matches
        let participants = [];
        let firstRoundMatches = matches.filter((x)=>x.tournamentRound === 1);
        for (const match of firstRoundMatches)for (const matchParticipant of match.tempParticipants){
            matchParticipant.tempPoints = null;
            participants.push([
                matchParticipant,
                []
            ]); // [participant, matches]
        }
        // Add participant matches that have been played
        for (const match of matches)if (match.rating !== null) {
            for (const participant of participants)if ((0, $3E8Nt.objectInArray)(participant[0], match.tempParticipants)) participant[1].push(match);
        }
        // Add participant data
        for (const participant of participants){
            let participantData = {};
            participantData["name"] = participant[0].name;
            participantData["points"] = participant[0].tournamentPoints;
            participantData["history"] = [];
            // Add temp points for tied participants based on head to head record
            const tiedParticipants = participants.filter((x)=>x[0].tournamentPoints === participant[0].tournamentPoints).map((x)=>x[0]);
            if (tiedParticipants.length > 1) {
                // Create sub table of max participants
                for (const tiedParticipant of tiedParticipants)if (tiedParticipant.tempPoints === null) {
                    tiedParticipant.tempPoints = 0;
                    const opponents = tiedParticipants.filter((x)=>x.$loki !== tiedParticipant.$loki);
                    for (const match of matches)// Check if participant and an opponent are in match participants
                    if ((0, $3E8Nt.objectInArray)(tiedParticipant, match.tempParticipants) && opponents.some((x)=>(0, $3E8Nt.objectInArray)(x, match.tempParticipants))) {
                        if ([
                            "Double Pin",
                            "Time-limit Draw"
                        ].indexOf(match.finishName) >= 0) tiedParticipant.tempPoints += 1;
                        else if (match.winner === tiedParticipant.name) tiedParticipant.tempPoints += 2;
                    }
                }
            }
            participantData["tempPoints"] = participant[0].tempPoints;
            // Go through matches, add records
            for (const match of participant[1]){
                let record;
                if ([
                    "Double Pin",
                    "Time-limit Draw"
                ].indexOf(match.finishName) >= 0) record = "D";
                else if (match.winner === participant[0].name) record = "W";
                else record = "L";
                participantData["history"].push(record);
            }
            groupData.push(participantData);
        }
        // Sort by points
        groupData.sort((a, b)=>b.points - a.points || b.tempPoints - a.tempPoints);
        table.push(groupData);
    }
    return table;
}
async function $63f6dc8ca1007bd9$export$afdc45cc69777fb(companyUid, brandName) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    let brand = null;
    if (brandName) brand = rosterBrands.find((x)=>x.name === brandName);
    return $63f6dc8ca1007bd9$var$getCompanyStats(selectedCompany, mainRoster, currentGame.monthCount, currentGame.year, rosterBrands, brand);
}
async function $63f6dc8ca1007bd9$var$getCompanyStats(company, roster, month, year, rosterBrands, brand) {
    let data = {};
    // Define arrays
    let averageMatchRatings = [];
    let winningStreaks = [];
    let losingStreaks = [];
    let nonWorldChampions = [];
    let notTurnedSuperstars = [];
    let winPercentages = [];
    let gimmicks = [];
    let streaks = [];
    let simultaneousFeuds = [];
    let superstarsInMainEvents = [];
    let superstarsInOpeningMatches = [];
    let superstarsInFiveStarMatches = [];
    let fotcLosses = [];
    // Get brand name and weekly show name
    const brandName = brand ? brand.name : null;
    const brandWeeklyShowName = brand ? brand.weeklyShowName : null;
    // Get company/brand objects
    let superstars = (await (0, $dl5u4.getRosterSuperstars)(roster)).filter((x)=>x.activeEffect !== "traded" && (!brandName || x.brandName === brandName));
    let tagTeams = [];
    for (const tagTeam of (await (0, $dl5u4.getRosterTagTeams)(roster))){
        const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
        tagTeam.tempPopularity = await (0, $ko5kE.getTagTeamPopularity)(tagTeam, tagTeamSuperstars);
        if (tagTeamSuperstars.every((x)=>x.activeEffect !== "traded")) {
            if (!brandName || tagTeamSuperstars.every((x)=>x.brandName === brandName)) tagTeams.push(tagTeam);
        }
    }
    let factions = [];
    for (const faction of (await (0, $dl5u4.getRosterFactions)(roster))){
        const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
        if (!brandName || factionSuperstars.every((x)=>x.brandName === brandName)) factions.push(faction);
    }
    let championships = (0, $kZwpB.getUniqueChampionships)(await (0, $9esFv.getCompanyChampionships)(company, false)).filter((x)=>!brandName || x.brandName === brandName);
    const companySegmentItems = await (0, $9esFv.getCompanySegmentItems)(company);
    const companyEvents = (await (0, $9esFv.getCompanyEvents)(company)).reverse();
    let monthlyEvents = companyEvents.filter((x)=>!x.weeklyShow && (!brandName || x.brandName === brandName));
    let weeklyEvents = companyEvents.filter((x)=>x.weeklyShow && (!brandName || x.name === brandWeeklyShowName));
    const companyLogs = (await (0, $9esFv.getCompanyCompanyLogs)(company)).reverse();
    const championshipReigns = (await Promise.all(championships.map((x)=>(0, $ivuOU.getChampionshipChampionshipReigns)(x)))).flat();
    const reignsData = await Promise.all(championshipReigns.map((x)=>$63f6dc8ca1007bd9$var$getChampionshipReignData(x, month, year, false)));
    const activeSuperstars = superstars.filter((x)=>!x.retired && !x.dead && !x.fullTimeManager);
    // Get matches, segments and streaks from events
    let allEventMatches = [];
    let allEventStreaks = [];
    let allEventSegments = [];
    let brandEventIds = monthlyEvents.concat(weeklyEvents).map((x)=>x.$loki);
    for (const event of companyEvents){
        const eventMatches = await (0, $iQtzn.getEventMatches)(event);
        event.tempMatches = eventMatches; // For getting event matches later for all events
        event.tempMatches.sort((a, b)=>a.order - b.order);
        if (brandEventIds.indexOf(event.$loki) >= 0) {
            // Add if belongs to brand filter (or no filter)
            allEventMatches.push(...eventMatches);
            const eventSegments = await (0, $iQtzn.getEventSegments)(event);
            allEventSegments.push(...eventSegments);
            if (!event.weeklyShow) {
                const eventStreaks = (await (0, $iQtzn.getEventStreaks)(event)).filter((x)=>!x.ended);
                allEventStreaks.push(...eventStreaks);
            }
        }
    }
    // Non brand stats
    if (!brandName) {
        // Signature event
        const signatureEvent = monthlyEvents.reduce((prev, current)=>prev.xp > current.xp ? prev : current);
        data["signatureEvent"] = {
            "name": signatureEvent.name,
            "prestige": signatureEvent.prestige
        };
        // Iconic feuds
        const endedFeuds = (await (0, $dl5u4.getRosterFeuds)(roster)).filter((x)=>x.started && x.ended);
        const sortedFeudsByRating = endedFeuds.filter((x)=>x.rating > 3).sort((a, b)=>b.rating - a.rating);
        data["iconicFeuds"] = await Promise.all(sortedFeudsByRating.slice(0, 3).map(async (x)=>{
            return {
                "name": x.name,
                "rating": x.rating,
                "participants": await (0, $cXLSF.getFeudParticipantsNames)(x)
            };
        }));
        // Top signings
        const sortedSigningsByValue = companyLogs.filter((x)=>x.type === "signing").sort((a, b)=>b.value - a.value);
        data["topSignings"] = sortedSigningsByValue.slice(0, 3).map((x)=>{
            return {
                "name": x.text,
                "value": x.value,
                "month": x.month,
                "year": x.year
            };
        });
        // Top moments
        const sortedMomentsByValue = companyLogs.filter((x)=>[
                "moment",
                "turn"
            ].indexOf(x.type) >= 0).sort((a, b)=>b.value - a.value);
        data["topMoments"] = sortedMomentsByValue.slice(0, 5).map((x)=>{
            let year = x.realYear || "";
            return {
                "name": x.text,
                "value": x.value,
                "event": `${x.eventName} ${year}`
            };
        });
        // Shocking turns
        const shockingTurns = companyLogs.filter((x)=>x.type === "turn").sort((a, b)=>b.value - a.value);
        data["shockingTurns"] = shockingTurns.slice(0, 3).map((x)=>{
            let year = x.realYear || "";
            return {
                "name": x.text,
                "event": `${x.eventName} ${year}`
            };
        });
        // Awards won
        const sortedAwardsWon = companyLogs.filter((x)=>x.type === "award").sort((a, b)=>b.year - a.year || b.value - a.value);
        data["awardsWon"] = sortedAwardsWon.map((x)=>{
            return {
                "name": x.text,
                "value": x.value,
                "year": x.year
            };
        });
    }
    // Iconic matches
    const sortedMatchesByRating = allEventMatches.filter((x)=>x.rating > 3).sort((a, b)=>b.rating - a.rating);
    data["iconicMatches"] = await Promise.all(sortedMatchesByRating.slice(0, 3).map((x)=>(0, $6RCLU.getMatchHistoryData)(x)));
    // Iconic segments
    const sortedSegmentsByRating = [];
    for (const segment of allEventSegments){
        let segmentItem = companySegmentItems.find((x)=>x.$loki === segment.segmentItemId);
        if (!segmentItem) // Get segment item directly if removed from company
        segmentItem = (0, $14eBR.SegmentItems).get(segment.segmentItemId);
        if (segmentItem && !segmentItem.special && segment.rating > 3) sortedSegmentsByRating.push(segment);
    }
    sortedSegmentsByRating.sort((a, b)=>b.rating - a.rating);
    data["iconicSegments"] = await Promise.all(sortedSegmentsByRating.slice(0, 3).map((x)=>(0, $4ptHI.getSegmentHistoryData)(x)));
    // Special segments
    const specialSegments = [];
    for (const segment of allEventSegments){
        const segmentItem = companySegmentItems.find((x)=>x.$loki === segment.segmentItemId);
        if (segmentItem && segmentItem.special && segment.rating !== null) specialSegments.push(segment);
    }
    data["specialSegments"] = await Promise.all(specialSegments.slice(0, 5).map((x)=>(0, $4ptHI.getSegmentHistoryData)(x)));
    // Iconic superstars
    const sortedSuperstarsByPopularity = [
        ...activeSuperstars
    ].sort((a, b)=>b.popularity - a.popularity);
    data["iconicSuperstars"] = sortedSuperstarsByPopularity.slice(0, 3).map((x)=>x.name);
    // Top face/heel superstars
    const heels = sortedSuperstarsByPopularity.filter((x)=>x.alignment === "heel");
    const faces = sortedSuperstarsByPopularity.filter((x)=>x.alignment === "face");
    if (heels.length > 0) data["topHeelSuperstar"] = heels[0].name;
    if (faces.length > 0) data["topFaceSuperstar"] = faces[0].name;
    // Most over superstar
    const sortedSuperstarsByOverness = [
        ...activeSuperstars
    ].sort((a, b)=>b.overness - a.overness);
    if (sortedSuperstarsByOverness.length > 0) data["mostOverSuperstar"] = sortedSuperstarsByOverness[0].name;
    // Iconic tag teams
    const sortedTagTeamsByPopularity = [
        ...tagTeams
    ].sort((a, b)=>b.tempPopularity - a.tempPopularity);
    data["iconicTagTeams"] = sortedTagTeamsByPopularity.slice(0, 2).map((x)=>x.name);
    // Iconic factions
    const sortedFactionsByXp = [
        ...factions
    ].sort((a, b)=>b.xp - a.xp);
    data["iconicFactions"] = sortedFactionsByXp.slice(0, 2).map((x)=>x.name);
    // Top championship
    if (championships.length > 0) {
        const topChampionship = championships.filter((x)=>!x.retired).reduce((prev, current)=>prev.xp > current.xp ? prev : current);
        data["topChampionship"] = {
            "name": (0, $1JSre.getChampionshipDisplayName)(topChampionship),
            "prestige": topChampionship.prestige
        };
    }
    // Iconic events
    const sortedEventsByRating = monthlyEvents.filter((x)=>x.rating > 3).sort((a, b)=>b.rating - a.rating);
    data["iconicEvents"] = sortedEventsByRating.slice(0, 3).map((x)=>{
        return {
            "name": x.name,
            "rating": x.rating,
            "year": x.year
        };
    });
    // Most bought event
    const sortedMonthlyEventsByViewership = monthlyEvents.filter((x)=>x.viewership).sort((a, b)=>b.viewership - a.viewership);
    if (sortedMonthlyEventsByViewership.length > 0) {
        const mostBoughtEvent = sortedMonthlyEventsByViewership[0];
        data["mostBoughtEvent"] = {
            "name": mostBoughtEvent.name,
            "buys": mostBoughtEvent.viewership,
            "year": mostBoughtEvent.year
        };
    }
    // Highest viewership event
    const sortedWeeklyEventsByViewership = weeklyEvents.filter((x)=>x.viewership).sort((a, b)=>b.viewership - a.viewership);
    if (sortedWeeklyEventsByViewership.length > 0) {
        const highestViewershipEvent = sortedWeeklyEventsByViewership[0];
        const eventDateOptions = {
            year: "numeric",
            month: "short",
            day: "numeric"
        };
        const eventDate = (0, $5ZsVo.getDatetimeForEvent)(highestViewershipEvent, rosterBrands).toLocaleDateString("en-US", eventDateOptions);
        data["highestViewershipEvent"] = {
            "name": highestViewershipEvent.name,
            "viewership": highestViewershipEvent.viewership,
            "date": eventDate
        };
    }
    // Legends
    const sortedHallOfFamersByPopularity = superstars.filter((x)=>x.retired && x.hallOfFamer).sort((a, b)=>b.popularity - a.popularity);
    data["legends"] = sortedHallOfFamersByPopularity.slice(0, 3).map((x)=>x.name);
    // Get data from superstars
    for (const superstar of superstars){
        // Get superstar's matches
        const superstarMatches = await (0, $hBIDz.getSuperstarMatches)(superstar);
        // Get data from matches
        for (const superstarMatch of superstarMatches){
            const matchEvent = companyEvents.find((x)=>x.$loki === superstarMatch.eventId);
            // Only check matches at company's events
            if (matchEvent) {
                let eventMatches = matchEvent.tempMatches;
                // Check if main event or opening match
                if (superstarMatch.$loki === eventMatches[0].$loki) superstarsInMainEvents.push(superstar.name);
                else if (superstarMatch.$loki === eventMatches[eventMatches.length - 1].$loki) superstarsInOpeningMatches.push(superstar.name);
                // Check if five star match
                if (superstarMatch.rating >= 5) superstarsInFiveStarMatches.push(superstar.name);
            }
        }
        // Get average match rating
        if (superstarMatches.length > 10) {
            const filteredSuperstarMatches = superstarMatches.filter((x)=>x.rating !== null);
            const ratingsSum = filteredSuperstarMatches.map((x)=>x.rating).reduce((partialSum, a)=>partialSum + a, 0);
            const averageRating = ratingsSum / filteredSuperstarMatches.length;
            averageMatchRatings.push({
                "name": superstar.name,
                "rating": (0, $3E8Nt.decimalRound)(averageRating)
            });
        }
        // Add winning/losing streaks
        if (superstar.winsCounter > 0) winningStreaks.push({
            "name": superstar.name,
            "length": superstar.winsCounter
        });
        if (superstar.lossesCounter > 0) losingStreaks.push({
            "name": superstar.name,
            "length": superstar.lossesCounter
        });
        // Check if held main event championship
        if (!brandName) {
            let beenWorldChampion = false;
            const superstarReigns = championshipReigns.filter((x)=>x.superstarId === superstar.$loki);
            for (const reign of superstarReigns){
                const reignChampionship = await (0, $9MKdC.getChampionshipReignChampionship)(reign);
                if (reignChampionship && reignChampionship.rank === "Main Eventer") {
                    beenWorldChampion = true;
                    break;
                }
            }
            if (!beenWorldChampion) nonWorldChampions.push({
                "name": superstar.name,
                "popularity": superstar.popularity
            });
        }
        // Check if not turned
        if (superstar.alignment && superstar.alignmentMonths >= year * 12 + month) notTurnedSuperstars.push({
            "name": superstar.name,
            "popularity": superstar.popularity
        });
        // Add win percentages
        if (superstarMatches.length > 0) {
            const totalMatches = superstar.wins + superstar.losses;
            let winPercentage = 0;
            if (totalMatches > 0) winPercentage = Math.round(superstar.wins / totalMatches * 100);
            winPercentages.push({
                "name": superstar.name,
                "winPercentage": winPercentage
            });
        }
        // Get current gimmick
        const gimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(superstar);
        if (gimmick && gimmick.startMonth) gimmicks.push({
            "name": gimmick.name,
            "effectiveness": gimmick.effectiveness,
            "superstarName": superstar.name,
            "startMonths": gimmick.startYear * 12 + gimmick.startMonth
        });
        // Get streaks
        const superstarStreaks = allEventStreaks.filter((x)=>x.superstarId === superstar.$loki);
        streaks.push(...superstarStreaks);
        // Get overlapping feuds
        let feuds = (await (0, $hBIDz.getSuperstarFeuds)(superstar)).filter((x)=>x.started);
        let numberOfOverlappingFeuds = $63f6dc8ca1007bd9$var$getNumberOfOverlappingFeuds(feuds, month, year);
        if (numberOfOverlappingFeuds > 0) simultaneousFeuds.push({
            "name": superstar.name,
            "numberOfFeuds": numberOfOverlappingFeuds
        });
        // FotC losses
        if (superstar.faceOfTheCompany) {
            let lossesTo = superstarMatches.filter((x)=>x.loser && x.loser.indexOf(superstar.name) >= 0).map((y)=>y.winner);
            lossesTo = [
                ...new Set(lossesTo)
            ];
            // Add if beaten by 3 or fewer superstars
            if (lossesTo.length > 0 && lossesTo.length <= 3) fotcLosses.push({
                "name": superstar.name,
                "losses": lossesTo
            });
        }
    }
    // Get top worker
    if (averageMatchRatings.length > 0) data["topWorker"] = averageMatchRatings.sort((a, b)=>b.rating - a.rating)[0];
    // Get greatest non world champion
    if (nonWorldChampions.length > 0) data["greatestNonWorldChampion"] = nonWorldChampions.sort((a, b)=>b.popularity - a.popularity)[0];
    // Get greatest to not turn
    if (notTurnedSuperstars.length > 0) data["greatestToNotTurn"] = notTurnedSuperstars.sort((a, b)=>b.popularity - a.popularity)[0];
    // Top win percentage
    if (winPercentages.length > 0) data["topWinPercentage"] = winPercentages.sort((a, b)=>b.winPercentage - a.winPercentage)[0];
    // Biggest streak
    if (streaks.length > 0) {
        const biggestStreak = streaks.sort((a, b)=>b.length - a.length)[0];
        data["biggestStreak"] = await (0, $5ZsVo.getStreakData)(biggestStreak);
    }
    // Longest winning streak
    if (winningStreaks.length > 0) data["longestWinningStreak"] = winningStreaks.sort((a, b)=>b.length - a.length)[0];
    // Longest losing streak
    if (losingStreaks.length > 0) data["longestLosingStreak"] = losingStreaks.sort((a, b)=>b.length - a.length)[0];
    // Most simultaneous feuds
    if (simultaneousFeuds.length > 0) data["mostSimultaneousFeuds"] = simultaneousFeuds.sort((a, b)=>b.numberOfFeuds - a.numberOfFeuds)[0];
    // Fotc losses
    if (fotcLosses.length > 0) data["fotcLosses"] = fotcLosses.sort((a, b)=>a.losses.length - b.losses.length)[0];
    // Best/worst/longest gimmick
    if (gimmicks.length > 0) {
        const gimmicksSortedByEffectiveness = gimmicks.sort((a, b)=>b.effectiveness - a.effectiveness);
        data["bestGimmick"] = gimmicksSortedByEffectiveness[0];
        // Don't make worst and best gimmick the same
        if (gimmicks.length > 1) data["worstGimmick"] = gimmicksSortedByEffectiveness[gimmicksSortedByEffectiveness.length - 1];
        data["longestGimmick"] = gimmicks.sort((a, b)=>a.startMonths - b.startMonths)[0];
    }
    // Longest/shortest reign
    if (reignsData.length > 0) {
        const reignsSortedByLength = [
            ...reignsData
        ].sort((a, b)=>b.length - a.length);
        data["longestReign"] = reignsSortedByLength[0];
        data["shortestReign"] = reignsSortedByLength[reignsSortedByLength.length - 1];
    }
    // Most 5 star matches
    if (superstarsInFiveStarMatches.length > 0) {
        const uniqueSuperstarsInFiveStarMatches = [
            ...new Set(superstarsInFiveStarMatches)
        ];
        let mostFiveStarMatches = uniqueSuperstarsInFiveStarMatches.map((x)=>{
            return {
                "name": x,
                "number": superstarsInFiveStarMatches.filter((y)=>y === x).length
            } // Get count of object
            ;
        });
        data["mostFiveStarMatches"] = mostFiveStarMatches.sort((a, b)=>b.number - a.number)[0];
    }
    // Most main events
    if (superstarsInMainEvents.length > 0) {
        const uniqueSuperstarsInMainEvents = [
            ...new Set(superstarsInMainEvents)
        ];
        let mostMainEvents = uniqueSuperstarsInMainEvents.map((x)=>{
            return {
                "name": x,
                "number": superstarsInMainEvents.filter((y)=>y === x).length
            };
        });
        data["mostMainEvents"] = mostMainEvents.sort((a, b)=>b.number - a.number)[0];
    }
    // Most opening matches
    if (superstarsInOpeningMatches.length > 0) {
        const uniqueSuperstarsInOpeningMatches = [
            ...new Set(superstarsInOpeningMatches)
        ];
        let mostOpeningMatches = uniqueSuperstarsInOpeningMatches.map((x)=>{
            return {
                "name": x,
                "number": superstarsInOpeningMatches.filter((y)=>y === x).length
            };
        });
        data["mostOpeningMatches"] = mostOpeningMatches.sort((a, b)=>b.number - a.number)[0];
    }
    // Most championships held
    const reignChampions = reignsData.map((x)=>x["championName"]);
    if (reignChampions.length > 0) {
        const uniqueChampions = [
            ...new Set(reignChampions)
        ];
        let mostChampionshipsHeld = uniqueChampions.map((x)=>{
            return {
                "name": x,
                "number": reignChampions.filter((y)=>y === x).length
            };
        });
        data["mostChampionshipsHeld"] = mostChampionshipsHeld.sort((a, b)=>b.number - a.number)[0];
    }
    // Most world championships held
    const reignWorldChampions = reignsData.filter((x)=>x["championshipRank"] === "Main Eventer").map((y)=>y["championName"]);
    if (reignWorldChampions.length > 0) {
        const uniqueWorldChampions = [
            ...new Set(reignWorldChampions)
        ];
        let mostWorldChampionshipsHeld = uniqueWorldChampions.map((x)=>{
            return {
                "name": x,
                "number": reignWorldChampions.filter((y)=>y === x).length
            };
        });
        data["mostWorldChampionshipsHeld"] = mostWorldChampionshipsHeld.sort((a, b)=>b.number - a.number)[0];
    }
    // Get data to return
    data["companyName"] = company.name;
    data["brandName"] = brandName;
    data["brandNames"] = rosterBrands.map((x)=>x.name);
    data["inactive"] = company.operatingStatus === "Inactive";
    return data;
}
async function $63f6dc8ca1007bd9$var$getChampionshipReignData(championshipReign, month, year, getMatchesData = false, championship = null) {
    let data = {};
    if (!championship) championship = await (0, $9MKdC.getChampionshipReignChampionship)(championshipReign);
    let matches = (await (0, $9MKdC.getChampionshipReignMatches)(championshipReign)).reverse();
    // Get matches data
    if (getMatchesData) data["matchesData"] = await Promise.all(matches.map((x)=>(0, $6RCLU.getMatchHistoryData)(x)));
    // Get number of defenses
    let numberOfDefenses;
    if (matches.length > 0 && matches[matches.length - 1].championshipsWon) numberOfDefenses = matches.length - 1 // Lost in last defense
    ;
    else numberOfDefenses = matches.length;
    if (numberOfDefenses < 0) numberOfDefenses = 0;
    data["numberOfDefenses"] = numberOfDefenses;
    // Get champion name
    if (matches.length > 0) data["championName"] = matches.reverse()[0].winner // Add name from first match
    ;
    else // For first champion without defenses, get holder_name
    if (championshipReign.holderName) data["championName"] = championshipReign.holderName;
    else {
        let reignSuperstar = await (0, $9MKdC.getChampionshipReignSuperstar)(championshipReign);
        // Fix for current games without holder name, get champion name using reign.superstar
        if (championship.tagTeam || championship.trio) {
            let teams = (await (0, $hBIDz.getSuperstarTagTeams)(reignSuperstar)).filter((x)=>!x.temporary);
            if (championship.trio) teams = teams.filter((x)=>x.trio);
            data["championName"] = teams.length > 0 ? teams[0].name : "Disbanded Team";
        } else data["championName"] = reignSuperstar.name;
    }
    // Get other data
    data["vacated"] = championshipReign.vacated;
    data["retired"] = championshipReign.retired;
    data["length"] = $63f6dc8ca1007bd9$export$46822c97d29d2bbd(championshipReign, month, year);
    data["championshipName"] = $63f6dc8ca1007bd9$var$getChampionshipReignChampionshipName(championshipReign, matches, championship);
    data["championshipRank"] = championship.rank;
    return data;
}
function $63f6dc8ca1007bd9$var$getChampionshipReignChampionshipName(championshipReign, matches, championship) {
    let championshipName;
    if (matches.length > 0 && matches[matches.length - 1].championshipsWon) championshipName = matches[matches.length - 1].championshipsWon;
    else championshipName = (0, $1JSre.getChampionshipDisplayName)(championship);
    return championshipName;
}
function $63f6dc8ca1007bd9$export$46822c97d29d2bbd(championshipReign, month, year) {
    let length;
    if (championshipReign.endMonth !== null) length = (0, $3E8Nt.getMonthsDifference)(championshipReign.endMonth, championshipReign.endYear, championshipReign.startMonth, championshipReign.startYear);
    else length = (0, $3E8Nt.getMonthsDifference)(month, year, championshipReign.startMonth, championshipReign.startYear);
    if (length < 0) length = 0;
    return length;
}
function $63f6dc8ca1007bd9$var$getNumberOfOverlappingFeuds(feuds, month, year) {
    const numbersOfOverlappingFeuds = [];
    for (const feud of feuds){
        // Get active feuds during current feud's time
        let endMonths;
        if (feud.ended) endMonths = feud.endYear * 12 + feud.endMonth;
        else endMonths = year * 12 + month;
        let startMonths = feud.startYear * 12 + feud.startMonth;
        const activeFeuds = feuds.filter((x)=>{
            return x.startYear * 12 + x.startMonth >= startMonths && x.startYear * 12 + x.startMonth <= endMonths;
        });
        numbersOfOverlappingFeuds.push(activeFeuds.length);
    }
    return Math.max.apply(Math, numbersOfOverlappingFeuds);
}
async function $63f6dc8ca1007bd9$export$8f3ddbe231d60daa() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get unique, non annual tournaments
    let companyTournaments = (await (0, $9esFv.getCompanyTournaments)(selectedCompany)).filter((x)=>!x.annualTournament).reverse();
    let uniqueTournaments = (0, $3E8Nt.getUniqueObjectsByName)(companyTournaments);
    data["tournaments"] = [];
    for (const tournament of uniqueTournaments){
        let tournamentData = $63f6dc8ca1007bd9$var$getTournamentData(tournament);
        tournamentData["history"] = [];
        const heldTournaments = companyTournaments.filter((x)=>x.name === tournament.name);
        for (const heldTournament of heldTournaments){
            const historyData = await $63f6dc8ca1007bd9$var$getTournamentHistoryData(heldTournament, currentGame, selectedCompany.realYear);
            tournamentData["history"].push(historyData);
        }
        data["tournaments"].push(tournamentData);
    }
    return data;
}
function $63f6dc8ca1007bd9$var$getTournamentData(tournament) {
    let data = {};
    data["name"] = tournament.name;
    data["type"] = tournament.type;
    data["winnerName"] = tournament.winnerName;
    data["matchContractName"] = tournament.matchContractName;
    data["prestige"] = tournament.prestige;
    data["xp"] = tournament.xp;
    data["baseXp"] = (0, $3E8Nt.eventPrestigeXps)[tournament.prestige];
    data["cost"] = tournament.cost;
    data["xpToNextPrestige"] = tournament.prestige === "C" ? 40 : 110;
    data["uid"] = tournament.$loki;
    return data;
}
async function $63f6dc8ca1007bd9$export$643e2264c18d27ff(tournament, game) {
    let data = {};
    data["type"] = tournament.type;
    data["stage"] = tournament.stage;
    data["startRound"] = tournament.stage !== "elimination" ? 0 : tournament.rounds - tournament.knockoutRounds;
    data["participantsAdvancing"] = tournament.participantsAdvancing;
    if (tournament.type === "elimination" || tournament.stage === "elimination") data["bracket"] = await $63f6dc8ca1007bd9$var$getTournamentBracket(tournament, game, data["startRound"]);
    else if (tournament.type === "round-robin") data["table"] = await $63f6dc8ca1007bd9$var$getTournamentTable(tournament);
    return data;
}
async function $63f6dc8ca1007bd9$var$getTournamentHistoryData(tournament, game, currentYear = null) {
    let data = {};
    const event = await (0, $4EGpv.getTournamentEvent)(tournament);
    data["event"] = event.name;
    data["eventYear"] = event.year || currentYear;
    data["winnerName"] = tournament.winnerName;
    data["awardName"] = tournament.awardName;
    if (tournament.type === "elimination" || tournament.stage === "elimination") {
        data["startRound"] = tournament.stage !== "elimination" ? 0 : tournament.rounds - tournament.knockoutRounds;
        data["bracket"] = await $63f6dc8ca1007bd9$var$getTournamentBracket(tournament, game, data["startRound"]);
    }
    if (tournament.type === "round-robin") {
        data["table"] = await $63f6dc8ca1007bd9$var$getTournamentTable(tournament);
        data["participantsAdvancing"] = tournament.participantsAdvancing;
    }
    return data;
}
async function $63f6dc8ca1007bd9$export$a3ea48a9b5992fd2() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get data for gimmick matches
    const gimmickMatches = (await (0, $9esFv.getCompanyGimmickMatches)(selectedCompany)).reverse();
    gimmickMatches.sort((a, b)=>a.cost - b.cost);
    data["gimmickMatches"] = gimmickMatches.map((x)=>$63f6dc8ca1007bd9$var$getGimmickMatchData(x));
    return data;
}
function $63f6dc8ca1007bd9$var$getGimmickMatchData(gimmickMatch) {
    // Copy data
    let data = JSON.parse(JSON.stringify(gimmickMatch));
    data["uid"] = gimmickMatch.$loki;
    if (gimmickMatch.ratingBoost < 1.13) data["ratingBoost"] = 1;
    else if (gimmickMatch.ratingBoost < 1.2) data["ratingBoost"] = 2;
    else if (gimmickMatch.ratingBoost < 1.3) data["ratingBoost"] = 3;
    else data["ratingBoost"] = 4;
    if (gimmickMatch.popularityIncrease < 1.6) data["popularityBoost"] = 1;
    else if (gimmickMatch.popularityIncrease < 2) data["popularityBoost"] = 2;
    else if (gimmickMatch.popularityIncrease < 2.5) data["popularityBoost"] = 3;
    else data["popularityBoost"] = 4;
    if (gimmickMatch.injuryRate < 1.1) data["injuryRate"] = 1;
    else if (gimmickMatch.injuryRate < 1.15) data["injuryRate"] = 2;
    else if (gimmickMatch.injuryRate < 1.2) data["injuryRate"] = 3;
    else data["injuryRate"] = 4;
    data["fatigueChange"] = $63f6dc8ca1007bd9$export$1cf41b89a2a5b04a(gimmickMatch);
    return data;
}
function $63f6dc8ca1007bd9$export$1cf41b89a2a5b04a(gimmickMatch) {
    let increase;
    if (gimmickMatch.injuryRate < 1.1) increase = 4;
    else if (gimmickMatch.injuryRate < 1.15) increase = 8;
    else if (gimmickMatch.injuryRate < 1.2) increase = 12;
    else increase = 16;
    return increase;
}
async function $63f6dc8ca1007bd9$export$9be41fd18bf0fb8() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get data for gimmick matches
    const gimmickMatches = (await (0, $9esFv.getCompanyGimmickMatches)(selectedCompany)).map((x)=>x.name);
    gimmickMatches.sort();
    return gimmickMatches;
}
async function $63f6dc8ca1007bd9$export$1a8fe90aeb8fbfd9(name) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const gimmickMatches = await (0, $9esFv.getCompanyGimmickMatches)(selectedCompany);
    const gimmickMatch = gimmickMatches.find((x)=>x.name === name);
    if (!gimmickMatch) {
        data["error"] = "not-found";
        return data;
    }
    data["name"] = gimmickMatch.name;
    // Remove gimmick match from company
    await (0, $9esFv.removeCompanyGimmickMatches)(selectedCompany, [
        gimmickMatch
    ]);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $63f6dc8ca1007bd9$export$a9e9ed8a0ce1f9d9(name, rules, ratingBoost, popularityBoost, injuryRate, consequence, cashinContractName, cashinContractExpiry, matchContractName, graphicType, addRandomWeapons) {
    let data = {};
    try {
        const currentGame = await (0, $3E8Nt.getCurrentGame)();
        const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
        const gimmickMatches = await (0, $9esFv.getCompanyGimmickMatches)(selectedCompany);
        const cost = 100;
        // Check if enough points
        if (selectedCompany.points < cost) {
            data["error"] = "not-enough-points";
            return data;
        }
        // Check for other gimmick match with same name
        if (gimmickMatches.map((x)=>x.name.toLowerCase()).indexOf(name.toLowerCase()) >= 0) {
            data["error"] = "already-exists";
            return data;
        }
        // Don't allow Femme Fatale match in POW
        if (selectedCompany.storyName === "passion" && name === "Femme Fatale") {
            data["error"] = "pow-femme-fatale";
            return data;
        }
        const newGimmickMatch = (0, $cYLJ6.GimmickMatch)();
        newGimmickMatch.name = name;
        if (rules) newGimmickMatch.rules = rules;
        // Add boosts and cost
        const ratingBoosts = {
            "0": 1.05,
            "1": 1.13,
            "2": 1.2,
            "3": 1.3
        };
        const popularityIncreases = {
            "0": 1.3,
            "1": 1.6,
            "2": 2,
            "3": 2.5
        };
        const popularityDecreases = {
            "0": 0.9,
            "1": 0.8,
            "2": 0.6,
            "3": 0.4
        };
        const injuryRates = {
            "0": 1.05,
            "1": 1.1,
            "2": 1.15,
            "3": 1.2
        };
        newGimmickMatch.ratingBoost = ratingBoosts[ratingBoost];
        newGimmickMatch.popularityIncrease = popularityIncreases[popularityBoost];
        newGimmickMatch.popularityDecrease = popularityDecreases[popularityBoost];
        newGimmickMatch.injuryRate = injuryRates[injuryRate];
        newGimmickMatch.cost = $63f6dc8ca1007bd9$var$calculateGimmickMatchCost(newGimmickMatch);
        // Add consequence
        if (consequence) {
            // Set cash-in/match contract attributes
            if (consequence === "cashin_contract") {
                if (selectedCompany.storyName === "passion") {
                    data["error"] = "pow-cashin";
                    return data;
                }
                if (cashinContractName) {
                    if (gimmickMatches.find((x)=>x.cashinContractName && x.cashinContractName === cashinContractName)) {
                        data["error"] = "cashin-contract-exists";
                        return data;
                    }
                }
                newGimmickMatch.cashinContractName = cashinContractName ? cashinContractName : "Contract";
                newGimmickMatch.monthsToExpire = cashinContractExpiry ? parseInt(cashinContractExpiry) : 12;
            } else if (consequence === "match_contract") {
                newGimmickMatch.matchContractName = matchContractName ? matchContractName : "Title Match";
                if (matchContractName) {
                    if (gimmickMatches.find((x)=>x.matchContractName && x.matchContractName === matchContractName)) {
                        data["error"] = "match-contract-exists";
                        return data;
                    }
                }
            }
            newGimmickMatch.consequence = consequence;
        }
        // Add graphic type and 'add random weapon' options
        if ([
            "ladder",
            "ladder_black",
            "ladder_grey",
            "ladder_orange",
            "cage_grey",
            "cage_red",
            "cage_retro_blue",
            "cage_retro_black",
            "table",
            "chair",
            "tables_ladders_chairs",
            "ambulance",
            "barbed_wire_ropes",
            "casket",
            "grave",
            "parking_lot"
        ].indexOf(graphicType) >= 0) newGimmickMatch.graphicType = graphicType;
        if (addRandomWeapons === "1") newGimmickMatch.addRandomWeapons = true;
        (0, $14eBR.GimmickMatches).insert(newGimmickMatch);
        // Remove points
        selectedCompany.points -= cost;
        // Add gimmick match to company
        await (0, $9esFv.addCompanyGimmickMatches)(selectedCompany, [
            newGimmickMatch
        ]);
        // Check tutorial action
        if (selectedCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(selectedCompany, [
            "add_gimmick_match"
        ]);
        (0, $14eBR.db).saveDatabase();
        // Get data to return
        data["points"] = selectedCompany.points;
        data["name"] = newGimmickMatch.name;
    } finally{
        if (data["error"]) await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
    }
    return data;
}
function $63f6dc8ca1007bd9$var$calculateGimmickMatchCost(gimmickMatch) {
    let cost = 0;
    // Get cost from rating boost and add a small, random deviation
    let ratingCost = Math.pow((1 - gimmickMatch.ratingBoost) * 10, 2) * 30;
    cost += Math.round(ratingCost);
    // Get cost from popularity increase and add a small, random deviation
    let popularityCost = Math.pow((1 - gimmickMatch.popularityIncrease) * 2.04, 2) * 30;
    cost += Math.round(popularityCost);
    // Subtract cost from injury rate
    let injuryCost = Math.pow((1 - gimmickMatch.injuryRate) * 17, 2) * 5;
    cost -= Math.round(injuryCost);
    cost /= 3;
    cost = Math.round(Math.ceil(cost / 10) * 10); // Round up to nearest 10
    if (cost <= 5) cost = 5;
    return cost;
}
async function $63f6dc8ca1007bd9$export$6b95ca3478855e5e() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const segmentItems = (await (0, $9esFv.getCompanySegmentItems)(selectedCompany)).filter((x)=>x.custom).reverse();
    data["segmentItems"] = await Promise.all(segmentItems.map((x)=>(0, $4ptHI.getSegmentItemData)(x)));
    return data;
}
async function $63f6dc8ca1007bd9$export$940248067d6ac444() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const segmentItems = (await (0, $9esFv.getCompanySegmentItems)(selectedCompany)).filter((x)=>x.custom);
    return segmentItems.map((x)=>x.name);
}
async function $63f6dc8ca1007bd9$export$c90392a9e9f4afe7(name) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const segmentItems = await (0, $9esFv.getCompanySegmentItems)(selectedCompany);
    const segmentItem = segmentItems.find((x)=>x.name === name);
    if (!segmentItem) {
        data["error"] = "not-found";
        return data;
    }
    if (!segmentItem.custom) {
        data["error"] = "not-custom";
        return data;
    }
    data["name"] = segmentItem.name;
    // Remove segment item from company
    await (0, $9esFv.removeCompanySegmentItems)(selectedCompany, [
        segmentItem
    ]);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $63f6dc8ca1007bd9$export$9463f2008227089b(name) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const segmentItems = await (0, $9esFv.getCompanySegmentItems)(selectedCompany);
    const segmentItem = segmentItems.find((x)=>x.name === name);
    if (!segmentItem) {
        data["error"] = "not-found";
        return data;
    }
    if (segmentItem.productionSegment) {
        data["error"] = "production-segment";
        return data;
    }
    data = $63f6dc8ca1007bd9$var$getCustomSegmentItemData(segmentItem);
    return data;
}
function $63f6dc8ca1007bd9$var$getCustomSegmentItemData(segmentItem) {
    let data = {};
    data["name"] = segmentItem.name;
    data["participants"] = segmentItem.maxParticipants;
    data["chooseWinner"] = segmentItem.chooseWinner;
    data["feudOnly"] = segmentItem.feudOnly;
    data["silly"] = segmentItem.silly;
    data["startText"] = segmentItem.text.start;
    data["actionText"] = segmentItem.text.action;
    data["startTagText"] = segmentItem.text.startTag;
    data["actionTagText"] = segmentItem.text.actionTag;
    return data;
}
async function $63f6dc8ca1007bd9$export$4cd70676862a65d6(name, numberOfParticipants, startText, actionTexts, tagStartText, tagActionTexts, saveToGame, saveToCommunity, chooseWinner, feudOnly, silly) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const segmentItems = await (0, $9esFv.getCompanySegmentItems)(selectedCompany);
    const cost = saveToGame ? 30 : 0;
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Check if enough points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Check if segment item name exists
    if (segmentItems.map((x)=>x.name).indexOf(name) >= 0) {
        data["error"] = "already-exists";
        return data;
    }
    // Get segment text
    let segmentText = {};
    segmentText["start"] = [
        startText
    ];
    segmentText["action"] = actionTexts;
    if (tagStartText) segmentText["startTag"] = [
        tagStartText
    ];
    if (tagActionTexts.length) segmentText["actionTag"] = tagActionTexts;
    if (numberOfParticipants < 2) {
        // Don't add choose winner if less than 2 participants
        if (chooseWinner) chooseWinner = false;
        // Don't add feud only if less than 2 participants
        if (feudOnly) feudOnly = false;
    }
    // Create segment item and add to company
    let newSegmentItem = $63f6dc8ca1007bd9$export$5fd69b449ba075f9(name, numberOfParticipants, segmentText, saveToGame, saveToCommunity, chooseWinner, feudOnly, silly);
    (0, $14eBR.SegmentItems).insert(newSegmentItem);
    await (0, $9esFv.addCompanySegmentItems)(selectedCompany, [
        newSegmentItem
    ]);
    // Add to community segments if online
    if (saveToCommunity && window.navigator.onLine) $.ajax({
        type: "POST",
        contentType: "application/json; charset=utf-8",
        url: (0, $98xmD.globals).baseUrl + "/_add_template_segment_item",
        data: JSON.stringify({
            name: name,
            startText: startText,
            actionTexts: actionTexts,
            tagStartText: tagStartText,
            tagActionTexts: tagActionTexts,
            numberOfParticipants: numberOfParticipants,
            chooseWinner: chooseWinner,
            feudOnly: feudOnly,
            silly: silly
        }),
        success: async (data)=>{
            if (data["added_template_segment_item"]) notie.alert({
                type: 4,
                text: '<span class="display-block">{0} segment has been added to Community Segments</span>'.format(name)
            });
        }
    });
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["name"] = newSegmentItem.name;
    return data;
}
async function $63f6dc8ca1007bd9$export$abac02a9779ad029(name, previousName, numberOfParticipants, startText, actionTexts, tagStartText, tagActionTexts, chooseWinner, feudOnly, silly) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const segmentItems = await (0, $9esFv.getCompanySegmentItems)(selectedCompany);
    // Get segment item
    const segmentItem = segmentItems.find((x)=>x.name === previousName);
    if (!segmentItem) {
        data["error"] = "not-found";
        return data;
    }
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // If changing name, check if segment item name exists
    if (name !== previousName && segmentItems.map((x)=>x.name).indexOf(name) >= 0) {
        data["error"] = "already-exists";
        return data;
    }
    // Get segment text
    let segmentText = {};
    segmentText["start"] = [
        startText
    ];
    segmentText["action"] = actionTexts;
    if (tagStartText) segmentText["startTag"] = [
        tagStartText
    ];
    if (tagActionTexts.length) segmentText["actionTag"] = tagActionTexts;
    if (numberOfParticipants < 2) {
        // Don't add choose winner if less than 2 participants
        if (chooseWinner) chooseWinner = false;
        // Don't add feud only if less than 2 participants
        if (feudOnly) feudOnly = false;
    }
    // Edit segment item
    segmentItem.name = name;
    segmentItem.maxParticipants = numberOfParticipants;
    segmentItem.minParticipants = numberOfParticipants;
    segmentItem.chooseWinner = chooseWinner;
    segmentItem.feudOnly = feudOnly;
    segmentItem.silly = silly;
    segmentItem.text = segmentText;
    segmentItem.hypeBoost = feudOnly ? 1 : 0;
    segmentItem.popularityBoost = feudOnly ? 0 : 1;
    // Add to community segments if online
    if (segmentItem.saveToCommunity && window.navigator.onLine) $.ajax({
        type: "POST",
        contentType: "application/json; charset=utf-8",
        url: (0, $98xmD.globals).baseUrl + "/_add_template_segment_item",
        data: JSON.stringify({
            name: name,
            startText: startText,
            actionTexts: actionTexts,
            tagStartText: tagStartText,
            tagActionTexts: tagActionTexts,
            numberOfParticipants: numberOfParticipants,
            chooseWinner: chooseWinner,
            feudOnly: feudOnly,
            silly: silly
        }),
        success: async (data)=>{
            if (data["added_template_segment_item"]) notie.alert({
                type: 4,
                text: '<span class="display-block">{0} segment has been added to Community Segments</span>'.format(name)
            });
        }
    });
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["name"] = previousName;
    return data;
}
function $63f6dc8ca1007bd9$export$5fd69b449ba075f9(name, numberOfParticipants, text, saveToGame, saveToCommunity, chooseWinner, feudOnly, silly) {
    const segmentItem = (0, $cMrnz.SegmentItem)();
    segmentItem.name = name;
    segmentItem.maxParticipants = numberOfParticipants;
    segmentItem.minParticipants = numberOfParticipants;
    segmentItem.chooseWinner = chooseWinner;
    segmentItem.feudOnly = feudOnly;
    segmentItem.silly = silly;
    segmentItem.text = text;
    segmentItem.hypeBoost = feudOnly ? 1 : 0;
    segmentItem.popularityBoost = feudOnly ? 0 : 1;
    segmentItem.difficulty = 1;
    segmentItem.entertainment = 2;
    segmentItem.action = 1;
    segmentItem.unlocked = true;
    segmentItem.productionSegment = false;
    segmentItem.temporary = !saveToGame;
    segmentItem.custom = true;
    segmentItem.saveToCommunity = saveToCommunity;
    return segmentItem;
}
async function $63f6dc8ca1007bd9$export$a173f1800798fbe9(companyUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get unique company championships and sort
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany, false);
    let uniqueChampionships = (0, $kZwpB.getUniqueChampionships)(companyChampionships);
    uniqueChampionships.sort((0, $kZwpB.compareChampionships));
    // Get data for championships
    const getStats = (0, $98xmD.globalUser).paid;
    data["championships"] = await Promise.all(uniqueChampionships.map((x)=>$63f6dc8ca1007bd9$var$getChampionshipData(x, getStats, currentGame)));
    // Get data to return
    data["inactive"] = selectedCompany.operatingStatus === "Inactive";
    data["companyName"] = selectedCompany.name;
    return data;
}
async function $63f6dc8ca1007bd9$var$getChampionshipData(championship, getStats = false, game) {
    let data = {};
    data["name"] = (0, $1JSre.getChampionshipDisplayName)(championship);
    data["rank"] = championship.rank;
    data["graphic"] = championship.graphic;
    data["brandName"] = championship.brandName;
    data["gimmickRestriction"] = championship.gimmickRestriction;
    data["prestigeData"] = $63f6dc8ca1007bd9$var$getChampionshipPrestigeData(championship);
    data["retired"] = championship.retired;
    if (getStats) {
        const reigns = (await (0, $ivuOU.getChampionshipChampionshipReigns)(championship)).reverse();
        data["reignsData"] = await Promise.all(reigns.map((x)=>$63f6dc8ca1007bd9$var$getChampionshipReignData(x, game.monthCount, game.year, true, championship)));
        // Get shortest and longest reigns
        data["longestReigns"] = [];
        if (reigns.length > 0) {
            const sortedReigns = [
                ...data["reignsData"]
            ].sort((a, b)=>b.length - a.length || b.numberOfDefenses - a.numberOfDefenses);
            data["shortestReign"] = sortedReigns[sortedReigns.length - 1];
            data["longestReigns"] = sortedReigns.slice(0, 3);
        }
        // Calculate changes and average length of reigns
        data["changes"] = reigns.length > 0 ? reigns.length - 1 : 0;
        if (data["changes"] > 0) {
            const reignsLengthSum = data["reignsData"].map((x)=>x.length).reduce((partialSum, a)=>partialSum + a, 0);
            data["averageReignLength"] = Math.round(reignsLengthSum / data["reignsData"].length);
        }
        // Most reigns
        const reignChampions = data["reignsData"].map((x)=>x.championName);
        if (reignChampions.length > 0) {
            const uniqueReignChampions = [
                ...new Set(reignChampions)
            ];
            let mostReigns = uniqueReignChampions.map((x)=>{
                return {
                    "name": x,
                    "number": reignChampions.filter((y)=>y === x).length
                };
            });
            data["mostReigns"] = mostReigns.sort((a, b)=>b.number - a.number)[0];
        }
        // Get best and worst matches (except cash-ins)
        const championshipsMatches = data["reignsData"].map((x)=>x.matchesData).flat().filter((x)=>x.rating !== null);
        if (championshipsMatches.length > 0) {
            const maximumRating = Math.max(...championshipsMatches.map((o)=>o.rating));
            data["bestMatch"] = championshipsMatches.find((x)=>x.rating === maximumRating);
            const minimumRating = Math.min(...championshipsMatches.map((o)=>o.rating));
            data["worstMatch"] = championshipsMatches.find((x)=>x.rating === minimumRating);
        }
        // Get current reign
        data["currentReign"] = null;
        if (!championship.vacated && data["reignsData"].length > 0) data["currentReign"] = data["reignsData"][0];
    }
    return data;
}
function $63f6dc8ca1007bd9$var$getChampionshipPrestigeData(championship) {
    let data = {};
    // Get prestige data
    const prestigeValues = Object.keys((0, $3E8Nt.championshipPrestigeXps));
    const prestigeItems = Object.entries((0, $3E8Nt.championshipPrestigeXps));
    // Get xp of next prestige (same prestige if max)
    const prestigeIndex = prestigeValues.indexOf(championship.prestige);
    let nextPrestigeData;
    if (prestigeIndex > 0) nextPrestigeData = prestigeItems[prestigeIndex - 1];
    else nextPrestigeData = prestigeItems[prestigeIndex];
    const nextPrestigeXp = nextPrestigeData[1];
    const currentPrestigeXp = (0, $3E8Nt.championshipPrestigeXps)[championship.prestige];
    // Get data to return
    data["prestige"] = championship.prestige;
    data["xp"] = championship.xp;
    data["nextPrestigeXp"] = nextPrestigeXp;
    data["maxPrestige"] = prestigeIndex <= 0;
    if (!data["maxPrestige"]) {
        data["xpToNextPrestige"] = nextPrestigeXp - championship.xp;
        data["progressPercentage"] = (championship.xp - currentPrestigeXp) / (nextPrestigeXp - currentPrestigeXp) * 100;
    }
    return data;
}
async function $63f6dc8ca1007bd9$export$140a1634590e6f31() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    return rosterBrands.map((x)=>x.name);
}
async function $63f6dc8ca1007bd9$export$78a94493d0ba8421() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyRosters = await (0, $9esFv.getCompanyRosters)(selectedCompany);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main", companyRosters);
    const trainingRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "training", companyRosters);
    const trainingAvailableRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "trainingAvailable", companyRosters);
    let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    let trainingSuperstars = (await (0, $dl5u4.getRosterSuperstars)(trainingRoster)).concat(await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster));
    let allSuperstars = rosterSuperstars.concat(trainingSuperstars);
    let data = allSuperstars.map((x)=>{
        let name = x.name;
        if ((0, $3E8Nt.objectInArray)(x, trainingSuperstars)) name += " (Training)";
        return {
            "name": name,
            "uid": x.$loki,
            "value": x.name
        };
    });
    data.sort((a, b)=>a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    return data;
}
async function $63f6dc8ca1007bd9$export$fc43503f1679e520() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    let gimmickMatches = await (0, $9esFv.getCompanyGimmickMatches)(selectedCompany);
    gimmickMatches = gimmickMatches.filter((x)=>x.available && !x.cashinContractName && !x.matchContractName);
    gimmickMatches.sort((a, b)=>a.name.localeCompare(b.name));
    return gimmickMatches.map((x)=>x.name);
}
async function $63f6dc8ca1007bd9$export$1f0f2c845718ba00(getContracts = true) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    let companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    // Filter out contracts
    if (!getContracts) companyChampionships = companyChampionships.filter((x)=>!x.matchContract && !x.championshipContract);
    // Get unique championships, sort
    companyChampionships = (0, $kZwpB.getUniqueChampionships)(companyChampionships);
    companyChampionships.sort((0, $kZwpB.compareChampionships));
    // Get data for championships
    data["championships"] = companyChampionships.map((x)=>{
        return {
            "name": (0, $1JSre.getChampionshipDisplayName)(x),
            "gimmickRestriction": x.gimmickRestriction,
            "brandName": x.brandName,
            "uid": x.$loki,
            "graphic": x.graphic
        };
    });
    data["brandNames"] = rosterBrands.map((x)=>x.name);
    return data;
}
async function $63f6dc8ca1007bd9$export$8b9c0c5c6c2d0ae5(name, rank, championUid, division, addGraphic, graphicData, gimmickRestrictionName, gimmickMatchName, gimmickRestrictionMaxAge, gimmickRestrictionMixAge, brandName) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    // Check for paid version if adding brand
    if (brandName && !(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Check brand name
    if (brandName && rosterBrands.map((x)=>x.name).indexOf(brandName) < 0) {
        data["error"] = "brand-not-found";
        return data;
    }
    // Get gimmick restriction
    let gimmickRestriction = null;
    if (gimmickRestrictionName === "gimmick_match") {
        let gimmickRestrictionValue = null;
        if (gimmickMatchName !== "Any") {
            const gimmickMatch = (await (0, $9esFv.getCompanyGimmickMatches)(selectedCompany)).find((x)=>x.name === gimmickMatchName);
            if (gimmickMatch) gimmickRestrictionValue = gimmickMatch.name;
        }
        gimmickRestriction = {
            "type": gimmickRestrictionName,
            value: gimmickRestrictionValue
        };
    } else if (gimmickRestrictionName === "weekly_show") gimmickRestriction = {
        "type": gimmickRestrictionName,
        value: null
    };
    else if (gimmickRestrictionName === "maximum_age") gimmickRestriction = {
        "type": gimmickRestrictionName,
        value: parseInt(gimmickRestrictionMaxAge)
    };
    else if (gimmickRestrictionName === "minimum_age") gimmickRestriction = {
        "type": gimmickRestrictionName,
        value: parseInt(gimmickRestrictionMixAge)
    };
    // Check production facility level requirement
    if (gimmickRestriction) {
        const productionFacility = (await (0, $9esFv.getCompanyFacilities)(selectedCompany)).find((x)=>x.name === "Production");
        if (!(productionFacility && productionFacility.level >= 2)) {
            data["error"] = "level-2-production-facility-required";
            return data;
        }
    }
    // Check points
    const cost = $63f6dc8ca1007bd9$export$c1d55cf219b3030a(rank, gimmickRestriction);
    if (selectedCompany.points < cost) {
        data["error"] = "points";
        return data;
    }
    // Check if championship already exists
    if (companyChampionships.map((x)=>x.name.toLowerCase()).indexOf(name.toLowerCase()) >= 0) {
        data["error"] = "already-exists";
        return data;
    }
    // Get champion to award championship to
    let champion = null;
    if (championUid) {
        if (division === "singles") champion = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).find((x)=>x.$loki === championUid);
        if (division === "tag-team") champion = (await (0, $dl5u4.getRosterTagTeams)(mainRoster)).find((x)=>x.$loki === championUid);
        if (division === "trio") champion = (await (0, $dl5u4.getRosterTagTeams)(mainRoster)).filter((x)=>x.trio).find((x)=>x.$loki === championUid);
        if (!champion) {
            data["error"] = "champion-not-found";
            return data;
        }
    }
    // Get graphic
    let graphic = null;
    if (addGraphic) graphic = JSON.parse(graphicData);
    // Get number of championships to add based on division selected
    const divisionData = {
        "singles": 1,
        "tag-team": 2,
        "trio": 3
    };
    const numberOfChampionships = divisionData[division] || 1;
    // Create championships
    let championships = [];
    for (const x of Array(numberOfChampionships).keys()){
        const newChampionship = (0, $ivuOU.Championship)(name);
        newChampionship.rank = rank;
        if (division === "tag-team") newChampionship.tagTeam = true;
        if (division === "trio") newChampionship.trio = true;
        if (graphic) newChampionship.graphic = graphic;
        if (gimmickRestriction) {
            newChampionship.gimmickRestriction = gimmickRestriction;
            newChampionship.xp = 40;
        }
        if (!championUid) newChampionship.vacated = true;
        if (brandName) (0, $1Dp0h.setObjectBrand)(newChampionship, brandName);
        championships.push(newChampionship);
        // Save
        (0, $14eBR.Championships).insert(newChampionship);
        // Add to company
        await (0, $9esFv.addCompanyChampionships)(selectedCompany, [
            newChampionship
        ]);
    }
    // Add championships to champion if entered
    if (championUid) {
        const championSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(champion);
        const popularityIncrease = $63f6dc8ca1007bd9$export$5c151ed57a6f3af0(championships[0], true);
        for (const [i, c] of Object.entries(championships)){
            // Add to superstars
            await (0, $hBIDz.addSuperstarChampionships)(championSuperstars[i], [
                c
            ]);
            // Update champion's popularity
            championSuperstars[i].popularity += popularityIncrease;
            // Add championship reign
            const newReign = (0, $9MKdC.ChampionshipReign)(currentGame.monthCount, currentGame.year);
            (0, $14eBR.ChampionshipReigns).insert(newReign);
            await (0, $ivuOU.addChampionshipChampionshipReigns)(c, [
                newReign
            ]);
            await (0, $hBIDz.addSuperstarChampionshipReigns)(championSuperstars[i], [
                newReign
            ]);
        }
    }
    // Change objective property
    const objectiveCompleted = await $63f6dc8ca1007bd9$export$94ff8d12f6118ed0({
        name: "new championship",
        change: 1,
        company: selectedCompany
    });
    if (objectiveCompleted) {
        await $63f6dc8ca1007bd9$export$e538311ea37ef618(objectiveCompleted, selectedCompany);
        const unreadMessages = await $63f6dc8ca1007bd9$export$18f27f63ba1cd846(selectedCompany);
        data["unreadMessages"] = unreadMessages.length;
    }
    // Add company log
    const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, selectedCompany.realYear);
    (0, $14eBR.CompanyLogs).insert(newCompanyLog);
    newCompanyLog.text = championships[0].name;
    newCompanyLog.type = "new-championship";
    newCompanyLog.realYear = currentGame.year;
    await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
        newCompanyLog
    ]);
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["championshipName"] = (0, $1JSre.getChampionshipDisplayName)(championships[0]);
    data["points"] = selectedCompany.points;
    return data;
}
async function $63f6dc8ca1007bd9$export$5c74b918b9f4f9aa(uid, name, appearanceOption, graphicData, gimmickRestrictionName, gimmickMatchName, gimmickRestrictionMaxAge, gimmickRestrictionMinAge, brandName) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const companyLogs = await (0, $9esFv.getCompanyCompanyLogs)(selectedCompany);
    let cost = 50;
    // Get championship
    let championship = companyChampionships.find((x)=>x.$loki === uid);
    let championships = companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship));
    // Check if championship already exists
    if (companyChampionships.map((x)=>x.name.toLowerCase()).indexOf(name.toLowerCase()) >= 0) {
        data["error"] = "already-exists";
        return data;
    }
    // Check for WoM
    if (selectedCompany.storyName === "mars") {
        data["error"] = "mars";
        return data;
    }
    // Check for POW
    if (selectedCompany.storyName === "passion" && championship.name === "POW") {
        data["error"] = "pow-title";
        return data;
    }
    // Check for paid version if adding brand
    if (brandName && !(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Check brand name
    if (brandName && rosterBrands.map((x)=>x.name).indexOf(brandName) < 0) {
        data["error"] = "brand-not-found";
        return data;
    }
    // Get gimmick restriction
    let gimmickRestriction = null;
    if (gimmickRestrictionName === "gimmick_match") {
        let gimmickRestrictionValue = null;
        if (gimmickMatchName !== "Any") {
            const gimmickMatch = (await (0, $9esFv.getCompanyGimmickMatches)(selectedCompany)).find((x)=>x.name === gimmickMatchName);
            if (gimmickMatch) gimmickRestrictionValue = gimmickMatch.name;
        }
        gimmickRestriction = {
            "type": gimmickRestrictionName,
            value: gimmickRestrictionValue
        };
    } else if (gimmickRestrictionName === "weekly_show") gimmickRestriction = {
        "type": gimmickRestrictionName,
        value: null
    };
    else if (gimmickRestrictionName === "maximum_age") gimmickRestriction = {
        "type": gimmickRestrictionName,
        value: parseInt(gimmickRestrictionMaxAge)
    };
    else if (gimmickRestrictionName === "minimum_age") gimmickRestriction = {
        "type": gimmickRestrictionName,
        value: parseInt(gimmickRestrictionMinAge)
    };
    // Check production facility level requirement
    if (gimmickRestriction) {
        const productionFacility = (await (0, $9esFv.getCompanyFacilities)(selectedCompany)).find((x)=>x.name === "Production");
        if (!(productionFacility && productionFacility.level >= 2)) {
            data["error"] = "level-2-production-facility-required";
            return data;
        }
    }
    // Check points
    if (gimmickRestriction) cost += 100;
    if (selectedCompany.points < cost) {
        data["error"] = "points";
        return data;
    }
    // Get previous name
    const previousName = (0, $1JSre.getChampionshipDisplayName)(championship);
    const previousNameRaw = championship.name;
    // Process championships
    for (const c of championships){
        if (name) c.name = name;
        const previousGraphic = c.graphic;
        if (appearanceOption === "change") c.graphic = JSON.parse(graphicData);
        else if (appearanceOption === "remove") c.graphic = null;
        if (gimmickRestriction) c.gimmickRestriction = gimmickRestriction;
        else c.gimmickRestriction = null;
        if (brandName) (0, $1Dp0h.setObjectBrand)(c, brandName);
        else (0, $1Dp0h.removeObjectBrand)(c);
        // Lower prestige
        if ((0, $98xmD.globalUser).paid) {
            const xpChange = -50;
            await $63f6dc8ca1007bd9$export$3b5efa76271d873e(c, xpChange);
            data["rebrandXpChange"] = xpChange;
        }
        // Check customize title request
        if (!(0, $1JSre.objectEquals)(previousGraphic, c.graphic)) {
            const champion = await (0, $ivuOU.getChampionshipSuperstar)(c);
            let requestData = {
                "championshipId": c.$loki
            };
            await (0, $1olyO.checkTalentRequestAction)({
                company: selectedCompany,
                requestType: "customize_championship",
                talent: champion,
                data: requestData
            });
        }
    }
    // Add company log
    const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, selectedCompany.realYear);
    (0, $14eBR.CompanyLogs).insert(newCompanyLog);
    const newName = (0, $1JSre.getChampionshipDisplayName)(championship);
    newCompanyLog.text = `Rebranded ${previousName} to ${newName}`;
    newCompanyLog.type = "rebrand-championship";
    newCompanyLog.realYear = currentGame.year;
    await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
        newCompanyLog
    ]);
    // Update company logs
    await $63f6dc8ca1007bd9$export$c739d2de258adfef(companyLogs, championship, previousNameRaw);
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["championshipName"] = (0, $1JSre.getChampionshipDisplayName)(championships[0]);
    data["points"] = selectedCompany.points;
    data["previousName"] = previousName;
    const unreadMessages = await $63f6dc8ca1007bd9$export$18f27f63ba1cd846(selectedCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $63f6dc8ca1007bd9$export$c739d2de258adfef(companyLogs, championship, previousName) {
    for (const companyLog of companyLogs)if (companyLog.type === "new-championship" && companyLog.text === previousName) companyLog.text = championship.name;
}
async function $63f6dc8ca1007bd9$export$92c874eb396f0a17(companyLogs, talent, previousName) {
    for (const companyLog of companyLogs)if ([
        "signing",
        "callup",
        "new-superstar",
        "new-trade-superstar"
    ].indexOf(companyLog.type) >= 0 && companyLog.text === previousName) companyLog.text = talent.name;
}
async function $63f6dc8ca1007bd9$export$7b901a14f8fe4bcc({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    const cost = 50;
    // Get championship
    let championship = companyChampionships.find((x)=>x.$loki === uid);
    if (!championship) {
        data["error"] = "not-found";
        return data;
    }
    // Check for PoW
    if (selectedCompany.storyName === "passion" && championship.name === "POW") {
        const championshipSuperstar = await (0, $ivuOU.getChampionshipSuperstar)(championship);
        if (championshipSuperstar && championshipSuperstar.injured <= 0) {
            data["error"] = "pow-title";
            return data;
        }
    }
    // Check if already vacant
    if (championship.vacated) {
        data["error"] = "already-vacant";
        return data;
    }
    // Get tag/trio championships
    let championships = [];
    championships.push(championship);
    if (championship.tagTeam || championship.trio) {
        championships = companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship));
        data["tag"] = true;
    }
    // Check if already vacated
    const vacatedLog = (await (0, $9esFv.getCompanyCompanyLogs)(selectedCompany)).reverse().find((x)=>x.type === "vacated_without_reason" && x.text === championship.name);
    if (vacatedLog) {
        const monthsPassed = (0, $3E8Nt.getMonthsDifference)(currentGame.monthCount, currentGame.year, vacatedLog.month, vacatedLog.year);
        // Lower prestige if vacated within last 3 months
        if (monthsPassed < 3 && (0, $98xmD.globalUser).paid) {
            const xpChange = -20;
            await $63f6dc8ca1007bd9$export$3b5efa76271d873e(championship, xpChange, championships);
            data["vacatedTooOftenXpDecrease"] = xpChange;
        }
    }
    // Process championships
    for (const c of championships){
        // Vacate championship and save
        c.vacated = true;
        // Remove championship from champion
        const champion = await (0, $ivuOU.getChampionshipSuperstar)(c);
        await (0, $hBIDz.removeSuperstarChampionships)(champion, [
            c
        ]);
        // Update champion's popularity
        champion.popularity -= $63f6dc8ca1007bd9$export$fbcff619e4586bd(c);
        // End current reign
        const oldReign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
        if (oldReign) {
            oldReign.endMonth = currentGame.monthCount;
            oldReign.endYear = currentGame.year;
            oldReign.vacated = true;
        }
        // Add vacated to company logs
        const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, currentGame.year);
        (0, $14eBR.CompanyLogs).insert(newCompanyLog);
        newCompanyLog.text = c.name;
        newCompanyLog.type = "vacated_without_reason";
        await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
            newCompanyLog
        ]);
        // Check talent request
        let requestData = {
            "championshipId": c.$loki
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: selectedCompany,
            requestType: "vacate_championship",
            talent: champion,
            data: requestData
        });
    }
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["championshipName"] = (0, $1JSre.getChampionshipDisplayName)(championship);
    data["points"] = selectedCompany.points;
    return data;
}
async function $63f6dc8ca1007bd9$export$ef948d8338b7388d(uid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    // Get championship
    let championship = companyChampionships.find((x)=>x.$loki === uid);
    if (!championship) {
        data["error"] = "not-found";
        return data;
    }
    // Check for PoW
    if (selectedCompany.storyName === "passion" && championship.name === "POW") {
        data["error"] = "pow-title";
        return data;
    }
    // Get tag/trio championships
    let championships = [];
    championships.push(championship);
    if (championship.tagTeam || championship.trio) {
        championships = companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship));
        data["tag"] = true;
    }
    // Get points to add
    let pointsToAdd = $63f6dc8ca1007bd9$export$c1d55cf219b3030a(championship.rank, true, championship.gimmickRestriction);
    // Process championships
    data["championshipName"] = (0, $1JSre.getChampionshipDisplayName)(championship);
    for (const c of championships){
        // Remove championship from champion
        const champion = await (0, $ivuOU.getChampionshipSuperstar)(c);
        if (champion) {
            await (0, $hBIDz.removeSuperstarChampionships)(champion, [
                c
            ]);
            // Update champion's popularity
            champion.popularity -= $63f6dc8ca1007bd9$export$fbcff619e4586bd(c);
            // End current reign
            const oldReign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
            if (oldReign) {
                oldReign.endMonth = currentGame.monthCount;
                oldReign.endYear = currentGame.year;
                oldReign.retired = true;
            }
        }
        // Remove match contract
        if (c.matchContract) {
            const matchContract = await (0, $ivuOU.getChampionshipMatchContract)(c);
            if (matchContract) (0, $14eBR.MatchContracts).remove(matchContract);
        }
        if (c.matchContract || c.championshipContract) {
            pointsToAdd = 0;
            await (0, $9esFv.removeCompanyChampionships)(selectedCompany, [
                c
            ]);
        }
        c.retired = true;
    }
    // Add points
    selectedCompany.points += pointsToAdd;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["pointsReturned"] = pointsToAdd;
    return data;
}
function $63f6dc8ca1007bd9$export$c1d55cf219b3030a(rank, remove = false, gimmickRestriction = null) {
    const ranks = {
        "Main Eventer": 250,
        "Upper Midcarder": 150,
        "Lower Midcarder": 100,
        "Jabroni": 50
    };
    const ranksRemove = {
        "Main Eventer": 150,
        "Upper Midcarder": 100,
        "Lower Midcarder": 50,
        "Jabroni": 25
    };
    let points;
    if (remove) {
        points = ranksRemove[rank] || 150;
        if (gimmickRestriction && Object.keys(gimmickRestriction).length !== 0) points += 75;
    } else {
        points = ranks[rank] || 100;
        if (gimmickRestriction) points += 100;
    }
    return points;
}
function $63f6dc8ca1007bd9$export$fbcff619e4586bd(championship, defense = false) {
    let values;
    if (defense) values = {
        "S": 9,
        "A": 6,
        "B": 4,
        "C": 1
    };
    else values = {
        "S": 21,
        "A": 16,
        "B": 10,
        "C": 5
    };
    return values[championship.prestige];
}
function $63f6dc8ca1007bd9$export$5c151ed57a6f3af0(championship, defense = false) {
    let values;
    if (defense) values = {
        "S": 12,
        "A": 8,
        "B": 5,
        "C": 3
    };
    else values = {
        "S": 28,
        "A": 21,
        "B": 14,
        "C": 7
    };
    return values[championship.prestige];
}
async function $63f6dc8ca1007bd9$export$18f27f63ba1cd846(company) {
    return (await (0, $9esFv.getCompanyMessages)(company)).filter((x)=>x.read === false);
}
async function $63f6dc8ca1007bd9$export$3b5efa76271d873e(championship, xpChange, companyChampionships = null) {
    let data = {};
    if ((0, $98xmD.globalUser).paid) {
        // Update xp and prestige
        let allChampionships = companyChampionships ? companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship)) : [
            championship
        ];
        let prestigeIncrease = false;
        let prestigeDecrease = false;
        for (const c of allChampionships){
            $63f6dc8ca1007bd9$var$updateChampionshipXp(c, xpChange);
            let prestigeChangeData = $63f6dc8ca1007bd9$var$updateChampionshipPrestige(c);
            // Get prestige increase/decrease if true (so one team title doesn't overwrite other team title's value)
            if (prestigeChangeData["prestigeIncrease"]) prestigeIncrease = true;
            if (prestigeChangeData["prestigeDecrease"]) prestigeDecrease = true;
        }
        if (allChampionships.length > 0) {
            data = $63f6dc8ca1007bd9$var$getChampionshipPrestigeData(allChampionships[0]);
            data["xpChange"] = xpChange;
            data["prestigeIncrease"] = prestigeIncrease;
            data["prestigeDecrease"] = prestigeDecrease;
            data["championshipName"] = (0, $1JSre.getChampionshipDisplayName)(allChampionships[0]);
            if ($63f6dc8ca1007bd9$var$getChampionshipPrestigeValue(allChampionships[0].prestige) > $63f6dc8ca1007bd9$var$getChampionshipPrestigeValue(allChampionships[0].highestPrestige)) {
                allChampionships[0].highestPrestige = allChampionships[0].prestige;
                data["firstPrestigeIncrease"] = true;
            }
        }
    }
    return data;
}
function $63f6dc8ca1007bd9$var$getChampionshipPrestigeValue(prestige) {
    const prestigeValues = {
        "S": 4,
        "A": 3,
        "B": 2,
        "C": 1
    };
    return prestigeValues[prestige] || 1;
}
function $63f6dc8ca1007bd9$var$updateChampionshipXp(championship, xpChange) {
    championship.xp += xpChange;
    championship.xpGainedThisYear += xpChange;
    if (championship.xp < 0) championship.xp = 0;
    return championship.xp;
}
function $63f6dc8ca1007bd9$var$updateChampionshipPrestige(championship) {
    // Update a championships's prestige if it goes above or below the prestige's xp.
    // Prestige item is a tuple of the format (prestige, xp)
    let data = {};
    data["prestigeIncrease"] = false;
    data["prestigeDecrease"] = false;
    // Get prestige data
    const prestigeValues = Object.keys((0, $3E8Nt.championshipPrestigeXps));
    const prestigeItems = Object.entries((0, $3E8Nt.championshipPrestigeXps));
    if (prestigeValues.indexOf(championship.prestige) >= 0) {
        const prestigeIndex = prestigeValues.indexOf(championship.prestige);
        // Check for prestige increase if not max prestige
        if (prestigeIndex > 0) {
            let nextPrestigeData = prestigeItems[prestigeIndex - 1];
            // Set prestige to next prestige if over next prestige xp
            if (championship.xp >= nextPrestigeData[1]) {
                championship.prestige = nextPrestigeData[0];
                data["prestigeIncrease"] = true;
            }
        }
        // Check for prestige decrease if not min prestige
        if (prestigeIndex < prestigeItems.length - 1) {
            const currentPrestigeXp = (0, $3E8Nt.championshipPrestigeXps)[championship.prestige];
            // Set prestige to previous prestige if below current prestige xp
            if (championship.xp < currentPrestigeXp) {
                let previousPrestigeData = prestigeItems[prestigeIndex + 1];
                championship.prestige = previousPrestigeData[0];
                data["prestigeDecrease"] = true;
            }
        }
    }
    return data;
}
async function $63f6dc8ca1007bd9$export$e56d1a92442490eb(name) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const cost = 200;
    // Check points
    if (selectedCompany.points < cost) {
        data["error"] = "points";
        return data;
    }
    // Check for story
    if ([
        "mars",
        "passion"
    ].indexOf(selectedCompany.storyName) >= 0) {
        data["error"] = "story";
        return data;
    }
    // Check if name exists
    const allCompanies = await (0, $iRMwH.getGameActiveCompanies)(currentGame);
    if (allCompanies.map((x)=>x.name).indexOf(name) >= 0) {
        data["error"] = "name-exists";
        return data;
    }
    // Change company name
    const previousName = selectedCompany.name;
    selectedCompany.name = name;
    // Add company log
    const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, selectedCompany.realYear);
    (0, $14eBR.CompanyLogs).insert(newCompanyLog);
    newCompanyLog.text = `Rebranded ${previousName} to ${name}`;
    newCompanyLog.type = "rebrand-company";
    newCompanyLog.realYear = currentGame.year;
    await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
        newCompanyLog
    ]);
    // Remove points
    selectedCompany.points -= cost;
    // Decrease company overness
    const overnessChange = -10;
    $63f6dc8ca1007bd9$export$655e9945239cdcf8(selectedCompany, overnessChange);
    $63f6dc8ca1007bd9$export$11b9bdb11e994fcf(selectedCompany, overnessChange);
    $63f6dc8ca1007bd9$export$714afb045cf567b2(selectedCompany, overnessChange);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["previousName"] = previousName;
    data["newName"] = name;
    data["points"] = selectedCompany.points;
    data["playerName"] = selectedCompany.playerName;
    // Save to local storage
    await (0, $iRMwH.saveGameDataToLocalStorage)(currentGame);
    return data;
}
function $63f6dc8ca1007bd9$export$655e9945239cdcf8(object, overnessChange) {
    object.overness += overnessChange;
    object.overness = (0, $3E8Nt.limitValueBetweenRange)(object.overness, 0, 100);
    return object.overness;
}
function $63f6dc8ca1007bd9$export$11b9bdb11e994fcf(object, overnessChange) {
    if (object.overness >= 80) {
        if (!object.hot) {
            object.hot = true;
            return "hot";
        }
    } else {
        if (object.hot) {
            object.hot = false;
            return "hotEnd";
        } else if (object.overness >= 70) {
            // Check if overness was below 70 before
            if (object.overness - overnessChange < 70) return "hotStart";
        }
    }
    return null;
}
function $63f6dc8ca1007bd9$export$714afb045cf567b2(object, overnessChange) {
    if (object.overness < 20) {
        if (!object.stale) {
            object.stale = true;
            return "stale";
        }
    } else {
        if (object.stale) {
            object.stale = false;
            return "staleEnd";
        } else if (object.overness <= 30) {
            // Check if overness was above 30 before
            if (object.overness - overnessChange > 30) return "staleStart";
        }
    }
    return null;
}
function $63f6dc8ca1007bd9$export$cc331890c5084e7a(company) {
    return company.ownerName ? company.ownerName : `Owner - ${company.name}`;
}
async function $63f6dc8ca1007bd9$export$defc55f9bb616482(superstar, company) {
    const relationship = (0, $iWkAo.Relationship)();
    relationship.type = "former_company";
    (0, $14eBR.Relationships).insert(relationship);
    await (0, $hBIDz.addSuperstarRelationships)(superstar, [
        relationship
    ]);
    await (0, $9esFv.addCompanyRelationships)(company, [
        relationship
    ]);
}
async function $63f6dc8ca1007bd9$export$8e4a01037594af53(talentUid, task) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get staff role from task
    const roleData = {
        "scout": "scout",
        "recruit": "scout",
        "train": "trainer",
        "transition": "trainer",
        "prepare": "trainer",
        "transition (talent)": "trainer",
        "reassure": "talent_manager",
        "rehab": "doctor",
        "unlearn trait": "all",
        "transition (staff)": "all"
    };
    const staffRole = roleData[task];
    // Get staff members based on role
    let availableStaffMembers = $63f6dc8ca1007bd9$export$4300fa74fcc6d545(await (0, $9esFv.getCompanyStaff)(selectedCompany));
    if (staffRole !== "all") availableStaffMembers = availableStaffMembers.filter((x)=>x.role === staffRole);
    if (task === "transition (staff)") availableStaffMembers = availableStaffMembers.filter((x)=>x.role !== "doctor");
    // Check if staff members present
    if (availableStaffMembers.length <= 0) {
        data["error"] = "no-staff-member";
        data["role"] = staffRole;
        return data;
    }
    // Get data for sorted staff members
    availableStaffMembers.sort((a, b)=>a.role.localeCompare(b.role) || b.level - a.level);
    data["availableStaffMembers"] = availableStaffMembers.map((x)=>$63f6dc8ca1007bd9$var$getStaffMemberData(x));
    data["role"] = staffRole;
    // Get top role if transitioning superstar to staff
    if (task === "transition (staff)") {
        const talent = (0, $14eBR.Superstars).get(talentUid);
        if (talent) data["topRolesData"] = $63f6dc8ca1007bd9$var$getTransitionToStaffMemberTopRolesData(talent);
    }
    return data;
}
function $63f6dc8ca1007bd9$var$getTransitionToStaffMemberTopRolesData(superstar) {
    // Get available roles that have boosts
    const allRoles = [
        "trainer",
        "scout",
        "producer",
        "talent_manager"
    ];
    const availableRoles = allRoles.filter((x)=>!$63f6dc8ca1007bd9$var$checkStaffRoleRequirement(superstar, x).requirementFailed);
    const boostsData = availableRoles.map((x)=>$63f6dc8ca1007bd9$export$8c6d6c10ad895ff6(superstar, x));
    const topRolesData = boostsData.filter((x)=>x.xpBoost > 0);
    topRolesData.sort((a, b)=>b.xpBoost - a.xpBoost);
    return topRolesData;
}
function $63f6dc8ca1007bd9$export$8c6d6c10ad895ff6(superstar, role) {
    let boostData = {};
    let xpBoost = 0;
    let boostNames = [];
    if ([
        "talent_manager",
        "scout"
    ].indexOf(role) >= 0) {
        if (superstar.hallOfFamer) {
            xpBoost += 20;
            boostNames.push("Hall of Famer");
        }
    }
    if ([
        "trainer"
    ].indexOf(role) >= 0) {
        if (superstar.traits.some((x)=>[
                "Ring General",
                "Workhorse",
                "Loves Training"
            ].indexOf(x) >= 0)) {
            xpBoost += 25;
            boostNames.push(superstar.traits.find((x)=>[
                    "Ring General",
                    "Workhorse",
                    "Loves Training"
                ].indexOf(x) >= 0));
        }
        if (superstar.workrate >= 3) {
            xpBoost += 25;
            boostNames.push("High Workrate");
        }
    }
    if ([
        "talent_manager"
    ].indexOf(role) >= 0) {
        if (superstar.traits.some((x)=>[
                "Natural Charisma",
                "Leader"
            ].indexOf(x) >= 0)) {
            xpBoost += 25;
            boostNames.push(superstar.traits.find((x)=>[
                    "Natural Charisma",
                    "Leader"
                ].indexOf(x) >= 0));
        }
    }
    if ([
        "producer"
    ].indexOf(role) >= 0) {
        if (superstar.traits.some((x)=>[
                "Entertainer",
                "Storyteller"
            ].indexOf(x) >= 0)) {
            xpBoost += 25;
            boostNames.push(superstar.traits.find((x)=>[
                    "Entertainer",
                    "Storyteller"
                ].indexOf(x) >= 0));
        }
        if (superstar.charisma >= 3) {
            xpBoost += 25;
            boostNames.push("High Charisma");
        }
    }
    boostData["xpBoost"] = xpBoost;
    boostData["boostNames"] = boostNames;
    boostData["role"] = role;
    return boostData;
}
async function $63f6dc8ca1007bd9$export$4faa8a50b981c70a(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName, replace) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyStaffMembers = (await (0, $9esFv.getCompanyStaff)(selectedCompany)).filter((x)=>!x.retired);
    const cost = taskName === "transition (staff)" ? 50 : 10;
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "not-paid";
        return data;
    }
    // Check if enough points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Find staff member
    const staffMember = (0, $14eBR.StaffMembers).get(staffUid);
    if (!staffMember) {
        data["error"] = "staff-not-found";
        return data;
    }
    // Check if task exists
    if (!taskName) {
        data["error"] = "no-task";
        return data;
    }
    // Find talent
    let talent;
    if (talentType === "tagTeam") talent = (0, $14eBR.TagTeams).get(talentUid);
    else if (talentType === "staff") talent = (0, $14eBR.StaffMembers).get(talentUid);
    else talent = (0, $14eBR.Superstars).get(talentUid);
    if (!talent) {
        data["error"] = "talent-not-found";
        return data;
    }
    data["staffMemberName"] = staffMember.name;
    data["talentName"] = talent.name;
    // Get task name and months to complete
    let monthsToComplete;
    let taskFormattedName;
    if (taskName === "scout") taskFormattedName = "Scouting";
    else if (taskName === "recruit") taskFormattedName = "Recruiting";
    else if (taskName === "train") {
        taskFormattedName = `Training (${(0, $3E8Nt.toTitleCase)(skillName)})`;
        monthsToComplete = 3;
    } else if (taskName === "reassure") {
        taskFormattedName = "Reassuring";
        monthsToComplete = 1;
        // Don't allow reassure on leaving or high morale talent
        if (talent.contractMonthsRemaining !== null) {
            data["error"] = "leaving-talent";
            return data;
        }
        if (talent.morale >= 80) {
            data["error"] = "high-morale-talent";
            return data;
        }
    } else if (taskName === "prepare") {
        taskFormattedName = "Preparing";
        monthsToComplete = staffMember.level < 3 ? 2 : 1;
        if (staffMember.level < 2) {
            data["error"] = "trainer-level-2";
            return data;
        }
    } else if (taskName === "transition") {
        taskFormattedName = "Transitioning";
        monthsToComplete = 1;
    } else if (taskName === "rehab") {
        taskFormattedName = "Rehabbing";
        // Don't allow rehab on short injury
        if (talent.injured < 3) {
            data["error"] = "short-injury";
            return data;
        }
        // Don't allow rehab on non-injury
        if (!talent.injuryName) {
            data["error"] = "non-injury";
            return data;
        }
        // Check doctor's level
        if (staffMember.level < 2) {
            data["error"] = "doctor-level-2";
            return data;
        }
        // Check medical facility's level
        const medicalFacility = (await (0, $9esFv.getCompanyFacilities)(selectedCompany)).find((x)=>x.name === "Medical");
        if (!medicalFacility || medicalFacility.level < 2) {
            data["error"] = "medical-facility-level-2";
            return data;
        }
    } else if (taskName === "unlearn trait") {
        taskFormattedName = `Unlearning Trait (${traitName}) For`;
        monthsToComplete = $63f6dc8ca1007bd9$var$getMonthsToUnlearnTrait(talent);
        // Check if trait data present
        const traitData = (0, $aP7lq.traitsData)[traitName];
        if (!traitData) {
            data["error"] = "trait-not-found";
            return data;
        }
        // Check if trait can be unlearned
        if (!traitData["can_unlearn"]) {
            data["error"] = "cannot-unlearn-trait";
            return data;
        }
        // Check if correct staff role to unlearn trait
        const staffRoleToUnlearn = traitData["staff_role_to_unlearn"];
        if (staffMember.role !== staffRoleToUnlearn) {
            data["error"] = "wrong-staff-role-to-unlearn";
            data["staffRoleToUnlearn"] = staffRoleToUnlearn;
            return data;
        }
    } else if (taskName === "transition (staff)") {
        taskFormattedName = "Transitioning (Staff)";
        monthsToComplete = 2;
        // Check for staff limit
        const facilityName = (0, $3E8Nt.roleToFacilityData)[roleName];
        const facility = (await (0, $9esFv.getCompanyFacilities)(selectedCompany)).find((x)=>x.name === facilityName);
        const numberOfRoles = $63f6dc8ca1007bd9$var$getNumberOfStaffForFacility(facility);
        let numberOfCompanyRoles = companyStaffMembers.filter((x)=>x.role === roleName).length;
        for (const x of companyStaffMembers)// Include superstars transitioning to staff
        if (x.taskData && x.taskData["role_name"] === roleName) numberOfCompanyRoles += 1;
        if (numberOfCompanyRoles >= numberOfRoles) {
            data["error"] = "max-roles";
            data["facilityName"] = facilityName || "";
            data["numberOfRoles"] = numberOfRoles;
            return data;
        }
        // Check if on trade
        if (talent.activeEffect === "traded") {
            data["error"] = "trade-talent";
            return data;
        }
        // Check if leaving
        if (talent.contractMonthsRemaining !== null) {
            data["error"] = "leaving-talent";
            return data;
        }
        // Check if correct staff role used
        if (staffMember.role !== roleName) {
            data["error"] = "wrong-staff-role-to-transition";
            return data;
        }
        // Check if same existing role selected
        const talentStaffObject = await (0, $hBIDz.getSuperstarStaffObject)(talent);
        if (talentStaffObject && talentStaffObject.role !== roleName) {
            data["error"] = "different-existing-staff-role";
            data["existingRole"] = talentStaffObject.role;
            return data;
        }
        // Don't allow in stories
        if (selectedCompany.storyName === "mars" || selectedCompany.storyName === "passion") {
            data["error"] = selectedCompany.storyName;
            return data;
        }
        // Check role requirement first time
        const roleCheck = $63f6dc8ca1007bd9$var$checkStaffRoleRequirement(talent, roleName);
        if (!talentStaffObject && roleCheck["requirementFailed"]) {
            data["error"] = "role-requirement-failed";
            data["requirementName"] = roleCheck["requirementName"];
            return data;
        }
        // Check decline
        const declineCheck = $63f6dc8ca1007bd9$var$checkSuperstarTransitionDecline(talent);
        if (declineCheck["declined"]) {
            data["error"] = "transition-declined";
            data["declinedReason"] = declineCheck["declinedReason"];
            return data;
        }
    } else if (taskName === "transition (talent)") {
        taskFormattedName = "Transitioning (Talent)";
        monthsToComplete = 2;
        if (talent.$loki === staffMember.$loki) {
            data["error"] = "task-assigned-to-self";
            return data;
        }
        const talentSuperstarObject = await (0, $5JRw3.getStaffSuperstarObject)(talent);
        if (!talentSuperstarObject) {
            data["error"] = "no-superstar-object-present";
            return data;
        }
    }
    let task = `${taskFormattedName} ${talent.name}`;
    // Check if any staff already working on same task
    for (const s of companyStaffMembers)if (s.currentTask === task) {
        data["error"] = "task-already-present";
        data["otherStaff"] = s.name;
        data["otherStaffTask"] = s.currentTask;
        return data;
    }
    // Check for current task if not replacing
    if (staffMember.currentTask && !replace) {
        data["currentTask"] = staffMember.currentTask;
        // Check for buyout task
        if (staffMember.currentTask.indexOf("Negotiating") >= 0) {
            data["error"] = "negotiating-buyout";
            return data;
        }
        data["error"] = "task-present";
        return data;
    }
    // Add task and months for task to staff member
    staffMember.currentTask = task;
    if (monthsToComplete) staffMember.monthsLeftForTask = monthsToComplete;
    // Add task data
    if (taskName === "rehab") staffMember.taskData = {
        "talent_id": talent.$loki
    };
    else if (taskName === "unlearn trait") staffMember.taskData = {
        "trait_name": traitName
    };
    else if (taskName === "transition (staff)") staffMember.taskData = {
        "role_name": roleName
    };
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    return data;
}
function $63f6dc8ca1007bd9$var$getMonthsToUnlearnTrait(superstar) {
    let months = 6;
    for (const trait of superstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["months_to_unlearn_traits_boost"]) months -= traitData["months_to_unlearn_traits_boost"];
    }
    return months;
}
function $63f6dc8ca1007bd9$var$checkStaffRoleRequirement(superstar, role) {
    let data = {};
    let requirementFailed = false;
    if (role === "trainer") {
        if (superstar.workrate <= 1) {
            requirementFailed = true;
            data["requirementName"] = "Low Workrate";
        }
    }
    if (role === "producer") {
        if (superstar.charisma <= 1) {
            requirementFailed = true;
            data["requirementName"] = "Low Charisma";
        }
    }
    data["requirementFailed"] = requirementFailed;
    return data;
}
function $63f6dc8ca1007bd9$var$checkSuperstarTransitionDecline(superstar) {
    let data = {};
    let declined = false;
    if (superstar.traits.indexOf("Dedicated Wrestler") >= 0 && superstar.age < 52) {
        declined = true;
        data["declinedReason"] = "Dedicated Wrestler Trait";
    }
    if (superstar.traits.indexOf("Lifelong Wrestler") >= 0 && superstar.age < 60) {
        declined = true;
        data["declinedReason"] = "Lifelong Wrestler Trait";
    }
    data["declined"] = declined;
    return data;
}
async function $63f6dc8ca1007bd9$export$d3c668cb6b2aefd0(checkBrandExclusivity) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
    const currentEvent = await $63f6dc8ca1007bd9$export$ebbfd7a50411b417(selectedCompany);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    // Check for brand exclusive event
    let availableSuperstars = [
        ...rosterSuperstars
    ];
    if (checkBrandExclusivity) availableSuperstars = availableSuperstars.filter((x)=>(0, $5kTkA.checkSuperstarBrandAvailability)(currentEvent, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships)));
    // Get managers from available superstars, full-time managers first
    data["managerSelections"] = availableSuperstars.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki,
            "fullTimeManager": x.fullTimeManager
        };
    });
    data["managerSelections"].sort((a, b)=>a.name.localeCompare(b.name));
    // Get talent from all superstars and teams
    data["talentSelections"] = availableSuperstars.filter((x)=>!x.fullTimeManager).map((y)=>{
        return {
            "name": y.name,
            "uid": y.$loki,
            "type": "superstar"
        };
    });
    data["talentSelections"].push(...rosterTagTeams.filter((x)=>!x.temporary).map((y)=>{
        return {
            "name": y.name,
            "uid": y.$loki,
            "type": "team"
        };
    }));
    data["talentSelections"].sort((a, b)=>a.name.localeCompare(b.name));
    return data;
}
async function $63f6dc8ca1007bd9$export$b437afac0b487f4c() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Get managers using superstars who have manager_id set
    const managerIds = rosterSuperstars.filter((x)=>x.managerId).map((x)=>x.managerId);
    const managers = rosterSuperstars.filter((x)=>managerIds.indexOf(x.$loki) >= 0);
    // Get data for managers
    data["managerSelections"] = [];
    for (const x of managers){
        let d = {};
        d["name"] = x.name;
        d["uid"] = x.$loki;
        // Add managed superstars
        const managedSuperstars = rosterSuperstars.filter((y)=>y.managerId === x.$loki);
        d["talentData"] = managedSuperstars.map((y)=>{
            return {
                "name": y.name,
                "uid": y.$loki
            };
        });
        d["talentData"].sort((a, b)=>a.name.localeCompare(b.name));
        data["managerSelections"].push(d);
    }
    data["managerSelections"].sort((a, b)=>a.name.localeCompare(b.name));
    return data;
}
async function $63f6dc8ca1007bd9$export$908152b08c70b8f7(managerUid, talentData) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
    const cost = 20;
    // Check if enough points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Get manager
    const manager = rosterSuperstars.find((x)=>x.$loki === managerUid);
    if (!manager) {
        data["error"] = "manager-not-found";
        return data;
    }
    // Get superstars to manage
    let superstarsToManage = [];
    for (const d of talentData){
        // Get talent
        let talent;
        if (d["type"] === "superstar") talent = rosterSuperstars.find((x)=>x.$loki === d["uid"]);
        else talent = rosterTagTeams.find((x)=>x.$loki === d["uid"]);
        if (!talent) {
            data["error"] = "talent-not-found";
            return data;
        }
        // Check talent superstars
        const talentSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
        for (const s of talentSuperstars){
            if (s.managerId) {
                data["error"] = "manager-present";
                data["superstarName"] = s.name;
                return data;
            }
            if (s.$loki === manager.$loki) {
                data["error"] = "managing-self";
                return data;
            }
            if (s.fullTimeManager) {
                data["error"] = "managing-full-time-manager";
                return data;
            }
            superstarsToManage.push(s);
        }
    }
    // Remove duplicate superstars
    superstarsToManage = (0, $3E8Nt.getUniqueObjects)(superstarsToManage);
    // Check for maximum superstars
    let managedSuperstars = await (0, $hBIDz.getSuperstarManagedSuperstars)(manager);
    if (managedSuperstars.length + superstarsToManage.length > 15) {
        data["error"] = "maximum-superstars";
        return data;
    }
    // Add superstars to manager
    await (0, $5kTkA.addSuperstarsToManager)(manager, superstarsToManage);
    // Check manager requests
    for (const superstarToManage of superstarsToManage){
        await (0, $1olyO.checkTalentRequestAction)({
            company: selectedCompany,
            requestType: "be_managed",
            talent: superstarToManage
        });
        let requestData = {
            "talentId": superstarToManage.$loki
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: selectedCompany,
            requestType: "manage_x",
            talent: manager,
            data: requestData
        });
    }
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["managerName"] = manager.name;
    data["managedSuperstarsNames"] = superstarsToManage.map((x)=>x.name);
    data["points"] = selectedCompany.points;
    const unreadMessages = await $63f6dc8ca1007bd9$export$18f27f63ba1cd846(selectedCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $63f6dc8ca1007bd9$export$c32335be1103bf0d(managerUid, talentData) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Get manager
    const manager = rosterSuperstars.find((x)=>x.$loki === managerUid);
    if (!manager) {
        data["error"] = "manager-not-found";
        return data;
    }
    // Get superstars to remove
    let superstarsToRemove = [];
    for (const d of talentData){
        const superstar = rosterSuperstars.find((x)=>x.$loki === d["uid"]);
        if (!superstar) {
            data["error"] = "talent-not-found";
            return data;
        }
        // Check superstar is managed by manager
        if (superstar.managerId !== manager.$loki) {
            data["error"] = "not-manager";
            data["superstarName"] = superstar.name;
            return data;
        }
        superstarsToRemove.push(superstar);
    }
    // Remove duplicate superstars
    superstarsToRemove = (0, $3E8Nt.getUniqueObjects)(superstarsToRemove);
    // Remove superstars from manager
    await (0, $5kTkA.removeSuperstarsFromManager)(manager, superstarsToRemove);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["managerName"] = manager.name;
    data["removedSuperstarsNames"] = superstarsToRemove.map((x)=>x.name);
    return data;
}
async function $63f6dc8ca1007bd9$export$6662b06ad2b15a09(company, game) {
    return (await $63f6dc8ca1007bd9$export$1e4a46f46735bc71(company, game)).filter((x)=>!x.userControlled);
}
async function $63f6dc8ca1007bd9$export$e423d864a1905a6a() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const producers = await $63f6dc8ca1007bd9$export$3117d1c4fcb92e56(staffMembers, "producer");
    producers.sort((a, b)=>b.level - a.level);
    data["producers"] = producers.map((x)=>$63f6dc8ca1007bd9$var$getStaffMemberData(x));
    return data;
}
async function $63f6dc8ca1007bd9$export$2896194470d06224({ tagMatchOptionSelected: tagMatchOptionSelected, matchUid: matchUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    let latestEvent = await $63f6dc8ca1007bd9$export$ebbfd7a50411b417(userCompany);
    let eventMatches = await (0, $iQtzn.getEventMatches)(latestEvent);
    let parentEvents = await $63f6dc8ca1007bd9$export$745573c3519c00ba(userCompany);
    let mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(userCompany, "main");
    let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    let companyGimmickMatches = (await (0, $9esFv.getCompanyGimmickMatches)(userCompany)).reverse();
    let companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    let singlesTagMatch = [
        "2v2",
        "3v3",
        "4v4",
        "5v5",
        "1v2",
        "1v3",
        "2v3",
        "?v?"
    ].indexOf(tagMatchOptionSelected) > -1;
    let tagMatch = !!tagMatchOptionSelected;
    // Find match, check if singles tag / tag match
    if (matchUid) {
        let match = (0, $14eBR.Matches).get(matchUid);
        if (match) {
            tagMatch = match.type === "tag";
            let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
            if (matchParticipants.length > 0 && matchParticipants[0].objectName === "tagTeam") {
                if (matchParticipants.some((x)=>x.temporary)) singlesTagMatch = true;
                else {
                    let firstTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(matchParticipants[0]);
                    for (const matchParticipant of matchParticipants)if ((await (0, $972Ip.getTagTeamSuperstars)(matchParticipant)).length !== firstTeamSuperstars.length) {
                        singlesTagMatch = true;
                        break;
                    }
                }
            }
        }
    }
    // Filter gimmick matches
    let availableGimmickMatches = companyGimmickMatches.filter((x)=>x.available);
    let unavailableGimmickMatches = companyGimmickMatches.filter((x)=>!(0, $3E8Nt.objectInArray)(x, availableGimmickMatches));
    // Find gimmick matches to not show
    let gimmickMatchesToNotShow = [];
    for (const gimmickMatch of companyGimmickMatches){
        // Remove match/championship contract if singles tag or already booked
        if (gimmickMatch.cashinContractName || gimmickMatch.matchContractName) {
            if (singlesTagMatch) gimmickMatchesToNotShow.push(gimmickMatch);
            for (const match of eventMatches){
                let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
                if (matchGimmick && matchGimmick.$loki === gimmickMatch.$loki) gimmickMatchesToNotShow.push(gimmickMatch);
            }
        }
        // Don't add open challenge and battle royal if adding gimmick match to existing match
        if (matchUid && (gimmickMatch.consequence === "random_opponent" || gimmickMatch.rules === "battle_royal")) gimmickMatchesToNotShow.push(gimmickMatch);
        // Don't show story gimmick matches in tag match
        if (tagMatch) {
            if (gimmickMatch.name === "Femme Fatale" && gimmickMatch.special) gimmickMatchesToNotShow.push(gimmickMatch);
            if (userCompany.storyName === "mars" && (gimmickMatch.name === "Olympus Mons" || gimmickMatch.name === "Hellas Impact")) gimmickMatchesToNotShow.push(gimmickMatch);
        }
    }
    // Remove availableGimmickMatches, sort
    availableGimmickMatches = availableGimmickMatches.filter((x)=>!(0, $3E8Nt.objectInArray)(x, gimmickMatchesToNotShow));
    availableGimmickMatches.sort((a, b)=>a.cost - b.cost);
    unavailableGimmickMatches.sort((a, b)=>a.cost - b.cost);
    // Get gimmick match names for 2/3 falls selection
    let multipleFallsGimmickMatches = availableGimmickMatches.filter((x)=>!x.matchContractName && !x.cashinContractName && !x.consequence && !x.rules);
    multipleFallsGimmickMatches.sort((a, b)=>a.name.localeCompare(b.name));
    // Get superstars data for special referee match
    let specialRefereeSuperstars = rosterSuperstars.filter((x)=>(0, $5kTkA.checkSuperstarSegmentAvailability)(x) && (0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships)));
    specialRefereeSuperstars.sort((a, b)=>a.name.localeCompare(b.name));
    // Get data to return
    data["availableGimmickMatches"] = availableGimmickMatches.map((x)=>$63f6dc8ca1007bd9$var$getGimmickMatchData(x));
    data["unavailableGimmickMatches"] = unavailableGimmickMatches.map((x)=>$63f6dc8ca1007bd9$var$getGimmickMatchData(x));
    data["parentEvents"] = parentEvents.map((x)=>{
        return {
            name: x.name,
            uid: x.$loki
        };
    });
    data["multipleFallsGimmickMatches"] = multipleFallsGimmickMatches.map((x)=>x.name);
    data["specialRefereeSuperstars"] = specialRefereeSuperstars.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    return data;
}
function $63f6dc8ca1007bd9$export$c76611feb0e9a24e({ participantNames: participantNames, previousName: previousName } = {}) {
    let objectName = $63f6dc8ca1007bd9$export$9f725fd28572ce6d(participantNames);
    while(objectName === previousName)objectName = $63f6dc8ca1007bd9$export$9f725fd28572ce6d(participantNames);
    return objectName;
}
function $63f6dc8ca1007bd9$export$9f725fd28572ce6d(participantNames) {
    let objects = [
        "Kendo Stick",
        "Chair",
        "$10,000",
        "Cucumber",
        "Spider",
        "Pole",
        "Guitar",
        "JoW Disc",
        "Handcuffs",
        "Brass Knuckles",
        "Chain",
        "Pickle Jar",
        "Banana",
        "Deodorant",
        "Baseball Bat",
        "Teddy Bear",
        "Pills",
        "Knife",
        "Barbed Wire",
        "Toilet Paper",
        "Screwdriver",
        "Water Gun",
        "Steroids"
    ];
    let superstarObjects = [
        "Action Figure",
        "Son",
        "Daughter",
        "Mother",
        "Child",
        "Family Photo",
        "Spouse",
        "Trophies",
        "Secret Recipe",
        "Divorce Papers",
        "Pet Mouse",
        "Shoes",
        "Merch",
        "Passport",
        "Favorite CD",
        "Diary",
        "Underwear",
        "Soul",
        "Home Key",
        "Best Friend",
        "DNA",
        "Knitting Needles",
        "Stuffed Toy",
        "Lunch",
        "$10",
        "Pet Fish",
        "Baby Oil"
    ];
    if (participantNames.length > 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= 50) return `${(0, $3E8Nt.getRandomChoice)(superstarObjects)} of ${(0, $3E8Nt.getRandomChoice)(participantNames)}`;
    else return (0, $3E8Nt.getRandomChoice)(objects);
}
function $63f6dc8ca1007bd9$export$e70d402d31666f93({ participantNames: participantNames, previousName: previousName } = {}) {
    let locationName = $63f6dc8ca1007bd9$export$57867d2a1d8a0a08(participantNames);
    while(locationName === previousName)locationName = $63f6dc8ca1007bd9$export$57867d2a1d8a0a08(participantNames);
    return locationName;
}
function $63f6dc8ca1007bd9$export$57867d2a1d8a0a08(participantNames) {
    let locations = [
        "Parking Lot",
        "Bar",
        "Boiler Room",
        "Locker Room",
        "Gorilla Position",
        "Rafters",
        "Beach",
        "Grocery Store",
        "Pool",
        "Restaurant",
        "Farmer's Market",
        "Flea Market",
        "Graveyard",
        "Hospital",
        "Barn",
        "Golf Course",
        "Nightclub",
        "Sewer",
        "Library",
        "Opera House",
        "Alley",
        "Zoo",
        "Church"
    ];
    let superstarLocations = [
        "Compound",
        "Basement",
        "Dungeon",
        "Backyard",
        "Bedroom",
        "Favorite Club",
        "House",
        "Beach House",
        "Favorite Fast Food Joint",
        "Barn",
        "Underground Lair",
        "Mansion",
        "Ranch",
        "Cabin",
        "Castle",
        "Tree House",
        "Bunker",
        "Hotel Room",
        "Shed",
        "Greenhouse",
        "Private Island",
        "Mind",
        "Yacht"
    ];
    if (participantNames.length > 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= 50) return `${(0, $3E8Nt.getRandomChoice)(participantNames)}'s ${(0, $3E8Nt.getRandomChoice)(superstarLocations)}`;
    else return (0, $3E8Nt.getRandomChoice)(locations);
}
function $63f6dc8ca1007bd9$export$2577d2e12fe20c05() {
    let gimmickMatch = (0, $cYLJ6.GimmickMatch)();
    gimmickMatch.name = $63f6dc8ca1007bd9$var$generateGimmickMatchName();
    gimmickMatch.ratingBoost = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(1.13, 1.3), 0.01);
    gimmickMatch.popularityIncrease = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(1.6, 2.5), 0.01);
    gimmickMatch.popularityDecrease = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(0.9, 0.4), 0.01);
    gimmickMatch.injuryRate = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(1.1, 1.2), 0.01);
    gimmickMatch.available = true;
    gimmickMatch.cost = $63f6dc8ca1007bd9$var$calculateGimmickMatchCost(gimmickMatch);
    return gimmickMatch;
}
function $63f6dc8ca1007bd9$var$generateGimmickMatchName() {
    let prefixes = [
        "Hell",
        "Burning",
        "Last",
        "Nightmare",
        "Punjabi",
        "Insanity",
        "Royal",
        "Ultimate",
        "Final",
        "Lunatic",
        "Hardcore",
        "Concrete",
        "Titanium",
        "Electric",
        "Fire",
        "Blood",
        "Glass",
        "Scaffold",
        "Ladder"
    ];
    let suffixes = [
        "War",
        "Cage",
        "Cell",
        "Chain",
        "Battle",
        "Cell",
        "Asylum",
        "Prison",
        "Horrors",
        "Chamber",
        "Brawl",
        "Fight",
        "Combat",
        "Melee"
    ];
    return `${(0, $3E8Nt.getRandomChoice)(prefixes)} ${(0, $3E8Nt.getRandomChoice)(suffixes)}`;
}
async function $63f6dc8ca1007bd9$export$529bc4c128273050({} = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const tournaments = (await (0, $9esFv.getCompanyTournaments)(userCompany)).filter((x)=>!x.annualTournament);
    let uniqueTournaments = (0, $3E8Nt.getUniqueObjectsByName)(tournaments);
    // Get latest of each tournament by $loki
    let maxTournaments = [];
    for (const y of uniqueTournaments){
        let maxTournament = (0, $3E8Nt.getArrayMaxByProperty)(tournaments.filter((x)=>x.name === y.name), "$loki");
        maxTournaments.push(maxTournament);
    }
    // Get data to return
    data["tournaments"] = await Promise.all(maxTournaments.map((x)=>$63f6dc8ca1007bd9$var$getTournamentData(x)));
    data["events"] = (await $63f6dc8ca1007bd9$export$745573c3519c00ba(userCompany)).map((x)=>x.name);
    return data;
}
async function $63f6dc8ca1007bd9$export$d7d1923b1a78ff80(type, name, description = null) {
    const companyAlert = (0, $5DBvS.CompanyAlert)();
    companyAlert.type = type;
    companyAlert.name = name;
    companyAlert.description = description;
    (0, $14eBR.CompanyAlerts).insert(companyAlert);
    return companyAlert;
}
async function $63f6dc8ca1007bd9$export$22984e5bac6d78c5(staffMember, xpGain, company, game) {
    const xps = {
        2: 300,
        1: 100
    };
    let levelIncrease = false;
    staffMember.xp += xpGain;
    if (staffMember.level < 3) {
        if (staffMember.xp >= (xps[staffMember.level] || 300)) {
            staffMember.level += 1;
            levelIncrease = true;
            // Add level up message
            if (company.userControlled) {
                const newMessage = await (0, $hekDR.createStaffLevelUpMessage)(staffMember, game.monthCount, game.year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            // Unlock special segment
            if (staffMember.level === 3 && staffMember.role === "doctor") {
                const user = (0, $bZol7.loadUser)();
                await (0, $3SyPM.unlockSpecialSegment)(company, "Timely Rescue", game.monthCount, game.year);
            }
        }
    }
    return levelIncrease;
}
function $63f6dc8ca1007bd9$export$1a4fcd5cdd1b5e40(staffMember) {
    if (staffMember.age < 30) return 1.5;
    else if (staffMember.age < 45) return 1;
    else if (staffMember.age < 100) return 0.75;
    else return 0.75;
}
async function $63f6dc8ca1007bd9$export$94ff8d12f6118ed0({ name: name, change: change, company: company, rating: rating = null, superstarName: superstarName = null, gimmickMatchName: gimmickMatchName = null, championship: championship = null } = {}) {
    let objectiveCompletedName = null;
    const objectives = (await (0, $9esFv.getCompanyObjectives)(company)).filter((x)=>!x.past && !x.completed);
    const properties = (await Promise.all(objectives.map((x)=>(0, $5NNI6.getObjectiveProperties)(x)))).flat();
    // Find property and objective
    const p = properties.find((x)=>x.name === name);
    if (p) {
        if (p.rating) {
            if (gimmickMatchName) {
                const propertyGimmickMatches = await (0, $ct4m6.getPropertyGimmickMatches)(p);
                let propertyGimmickMatchName;
                if (propertyGimmickMatches.length > 0) propertyGimmickMatchName = propertyGimmickMatches[0].name;
                else propertyGimmickMatchName = p.gimmickMatchName;
                if (gimmickMatchName === propertyGimmickMatchName && rating >= p.rating) p.value += change;
            } else if (rating >= p.rating) p.value += change;
        } else if (p.superstarName) {
            // If property superstars present, check superstarName against their names
            const propertySuperstars = await (0, $ct4m6.getPropertySuperstars)(p);
            let propertySuperstarName;
            if (propertySuperstars.length > 0) propertySuperstarName = (0, $3E8Nt.commaSeparate)(propertySuperstars.map((x)=>x.name).sort((a, b)=>a.localeCompare(b)));
            else propertySuperstarName = p.superstarName;
            if (superstarName === propertySuperstarName) p.value += change;
        } else if (p.name === "championship prestige") {
            const propertyChampionships = await (0, $ct4m6.getPropertyChampionships)(p);
            let propertyChampionshipName;
            if (propertyChampionships.length > 0) propertyChampionshipName = (0, $1JSre.getChampionshipDisplayName)(propertyChampionships[0]);
            else propertyChampionshipName = p.championshipName;
            if ((0, $1JSre.getChampionshipDisplayName)(championship) === propertyChampionshipName && championship.prestige === p.activationText) p.value += change;
        } else p.value += change;
        // Check for completion
        if (p.value >= p.activationValue) {
            const objective = await (0, $ct4m6.getPropertyObjective)(p);
            objective.completed = true;
            objectiveCompletedName = objective.name;
        }
    }
    return objectiveCompletedName;
}
async function $63f6dc8ca1007bd9$export$e538311ea37ef618(objectiveName, company) {
    // Add reward
    const reward = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(200, 320), 20);
    company.points += reward;
    // Add message
    const newMessage = await (0, $hekDR.createObjectiveCompletedMessage)(objectiveName, reward, company);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Add company alert
    const newCompanyAlert = await $63f6dc8ca1007bd9$export$d7d1923b1a78ff80("goalCompleted", objectiveName);
    await (0, $9esFv.addCompanyCompanyAlerts)(company, [
        newCompanyAlert
    ]);
    return true;
}
async function $63f6dc8ca1007bd9$export$4613c45b669b9363(company, month, year) {
    const data = {};
    const game = await (0, $9esFv.getCompanyGame)(company);
    const activeCompetitors = (await $63f6dc8ca1007bd9$export$1e4a46f46735bc71(company, game)).filter((x)=>!x.userControlled);
    for (const competitor of activeCompetitors){
        const availableForBuyoutCheck = $63f6dc8ca1007bd9$var$checkBuyoutAvailability(competitor, game.marketSize, activeCompetitors);
        if (competitor.operatingStatus === "Active") // Chance to become available for buyout
        {
            if (availableForBuyoutCheck && (0, $3E8Nt.getRandomInt)(0, 100) <= 30) {
                competitor.operatingStatus = "Buyout Available";
                const talentManager = $63f6dc8ca1007bd9$export$499c40897d9957a2(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
                const newMessage = await (0, $hekDR.createCompetitorBuyoutAvailableMessage)(competitor, month, year, talentManager);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
                const newCompanyAlert = await $63f6dc8ca1007bd9$export$d7d1923b1a78ff80("buyoutAvailable", competitor.name);
                await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                    newCompanyAlert
                ]);
                let newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: competitor,
                    month: month,
                    year: year,
                    newsType: "buyout_available",
                    headline: true
                });
                await (0, $9esFv.addCompanyNewsItems)(company, [
                    newsItem
                ]);
            }
        } else if (competitor.operatingStatus === "Buyout Available") {
            // Become unavailable for buyout
            if (!availableForBuyoutCheck) {
                competitor.operatingStatus = "Active";
                const talentManager = $63f6dc8ca1007bd9$export$499c40897d9957a2(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
                const newMessage = await (0, $hekDR.createCompetitorBuyoutNoLongerAvailableMessage)(competitor, month, year, talentManager);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
                let newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: competitor,
                    month: month,
                    year: year,
                    newsType: "buyout_not_available",
                    headline: true
                });
                await (0, $9esFv.addCompanyNewsItems)(company, [
                    newsItem
                ]);
            }
            // Chance to fold company
            if (availableForBuyoutCheck && (0, $3E8Nt.getRandomInt)(0, 100) <= 0) {
                // Get rosters
                let rosters = await (0, $9esFv.getCompanyRosters)(company);
                let indieRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "indie", rosters);
                let indieAvailableRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "indieAvailable", rosters);
                let indieFutureRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "indieFuture", rosters);
                // Get superstars from main, training, and future rosters
                let competitorRosters = await (0, $9esFv.getCompanyRosters)(competitor);
                let competitorSuperstars = [];
                for (const x of [
                    "main",
                    "training",
                    "trainingAvailable",
                    "trainingFuture"
                ]){
                    let roster = await $63f6dc8ca1007bd9$export$596e41e02971e822(competitor, x, competitorRosters);
                    if (roster) competitorSuperstars.push(...await (0, $dl5u4.getRosterSuperstars)(roster));
                }
                // Transfer superstars on trade
                let onTradeSuperstars = competitorSuperstars.filter((x)=>x.activeEffect === "traded");
                competitorSuperstars = competitorSuperstars.filter((x)=>x.activeEffect !== "traded");
                for (let superstar of onTradeSuperstars){
                    const originalRoster = await (0, $hBIDz.getSuperstarOriginalRoster)(superstar);
                    await (0, $dl5u4.addRosterSuperstars)(originalRoster, [
                        superstar
                    ]);
                    await (0, $5kTkA.vacateChampionships)({
                        superstar: superstar,
                        championships: await (0, $9esFv.getCompanyChampionships)(competitor),
                        month: month,
                        year: year
                    });
                    await (0, $5kTkA.removeSuperstarFactionRelationships)(superstar, month, year);
                    await (0, $5kTkA.removeSuperstarManagerRelationships)(superstar);
                    superstar.brandName = null;
                    superstar.activeEffect = null;
                    if (!superstar.partTimer) superstar.appearances = null;
                }
                // Transfer superstars to indie rosters
                let numberForIndieUnavailableRoster = Math.round(competitorSuperstars.length * 0.6);
                let superstarsForIndieUnavailableRoster;
                if (game.settings["all_indies_available"]) superstarsForIndieUnavailableRoster = [];
                else superstarsForIndieUnavailableRoster = (0, $3E8Nt.getRandomSample)(competitorSuperstars, numberForIndieUnavailableRoster);
                let superstarsForIndieAvailableRoster = competitorSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, superstarsForIndieUnavailableRoster));
                for (let superstar of competitorSuperstars){
                    if (superstar.monthToAppearIn) // Send future superstars to indie future roster
                    {
                        if (indieFutureRoster) await (0, $dl5u4.addRosterSuperstars)(indieFutureRoster, [
                            superstar
                        ]);
                    } else if ((0, $3E8Nt.objectInArray)(superstar, superstarsForIndieUnavailableRoster)) await (0, $dl5u4.addRosterSuperstars)(indieRoster, [
                        superstar
                    ]);
                    else await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, [
                        superstar
                    ]);
                    superstar.brandName = null;
                }
                // Get tagTeams from main and training rosters
                let competitorTagTeams = [];
                for (const x of [
                    "main",
                    "training",
                    "trainingAvailable"
                ]){
                    let roster = await $63f6dc8ca1007bd9$export$596e41e02971e822(competitor, x, competitorRosters);
                    if (roster) competitorTagTeams.push(...await (0, $dl5u4.getRosterTagTeams)(roster));
                }
                // Move/remove teams if trade ending
                for (let superstar of onTradeSuperstars)for (let tagTeam of [
                    ...await (0, $hBIDz.getSuperstarTagTeams)(superstar)
                ]){
                    let ts = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                    if (ts.every((s)=>(0, $3E8Nt.objectInArray)(s, onTradeSuperstars))) await (0, $dl5u4.addRosterTagTeams)(await (0, $hBIDz.getSuperstarOriginalRoster)(superstar), [
                        tagTeam
                    ]);
                    else await (0, $ko5kE.removeTagTeam)(tagTeam);
                    competitorTagTeams = competitorTagTeams.filter((x)=>x !== tagTeam);
                }
                // Transfer teams to indie rosters if all members in same roster, otherwise remove tag team
                for (let tagTeam of competitorTagTeams){
                    let foundInRoster = null;
                    let teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                    if (teamSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForIndieUnavailableRoster))) foundInRoster = indieRoster;
                    else if (teamSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForIndieAvailableRoster))) foundInRoster = indieAvailableRoster;
                    if (foundInRoster) await (0, $dl5u4.addRosterTagTeams)(foundInRoster, [
                        tagTeam
                    ]);
                    else {
                        tagTeam.rosterId = null;
                        await (0, $972Ip.removeTagTeamSuperstars)(tagTeam);
                    }
                }
                // Vacate competitor championships and remove from champions
                let competitorChampionships = await (0, $9esFv.getCompanyChampionships)(competitor);
                for (let championship of competitorChampionships){
                    let s = await (0, $ivuOU.getChampionshipSuperstar)(championship);
                    if (s) {
                        championship.vacated = true;
                        await (0, $hBIDz.removeSuperstarChampionships)(s, [
                            championship
                        ]);
                    }
                }
                // Mark competitor as inactive
                competitor.operatingStatus = "Inactive";
                // Decrease market size (moves some fans to competitors in next market size process)
                if (game.marketSize !== null) {
                    let lostFans = Math.round(competitor.fans * 0.75);
                    game.marketSize -= lostFans;
                    competitor.fans = lostFans;
                }
                let newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: month,
                    year: year,
                    competitor: competitor,
                    newsType: "company_folds",
                    headline: true
                });
                await (0, $9esFv.addCompanyNewsItems)(company, [
                    newsItem
                ]);
                const newCompanyAlert = await $63f6dc8ca1007bd9$export$d7d1923b1a78ff80("companyFolded", competitor.name);
                await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                    newCompanyAlert
                ]);
            }
        }
    }
    return data;
}
function $63f6dc8ca1007bd9$var$checkBuyoutAvailability(company, marketSize, competitors) {
    const reputationDifference = company.highestReputation - company.reputation;
    if (marketSize) {
        let threshold = 0.0025;
        if (competitors.length >= 15) threshold = 0.0015;
        if (company.fans < threshold * marketSize) return true;
        else if (company.fans < threshold * 10 * marketSize && reputationDifference >= 5) return true;
    } else {
        if (reputationDifference >= 5) return true;
    }
    return false;
}
async function $63f6dc8ca1007bd9$export$27e60e7d6ff81724(company) {
    const minimumSuperstars = 50;
    const game = await (0, $9esFv.getCompanyGame)(company);
    let indieRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "indie");
    let indieAvailableRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "indieAvailable");
    const indieRosterSuperstars = (await (0, $dl5u4.getRosterSuperstars)(indieRoster)).concat(await (0, $dl5u4.getRosterSuperstars)(indieAvailableRoster));
    const indieRosterTagTeams = (await (0, $dl5u4.getRosterTagTeams)(indieRoster)).concat(await (0, $dl5u4.getRosterTagTeams)(indieAvailableRoster));
    const companyLogs = (await (0, $9esFv.getCompanyCompanyLogs)(company)).reverse();
    if (company.storyName === "mars" || company.storyName === "passion") return false;
    if (!game.competitorsPresent) return false;
    // Check competitor limit
    const companies = await (0, $iRMwH.getGameActiveCompanies)(game);
    if (companies.length >= (0, $3E8Nt.gameLimits).maxCompetitors + 1) return false;
    // Check indie roster size
    if (indieRosterSuperstars.length < minimumSuperstars) return false;
    // Check for buyout
    let addBuyoutChance = false;
    const buyout = companyLogs.find((x)=>x.type === "buyout"); // Get latest buyout
    if (buyout) {
        // Add higher chance after buyout
        const buyoutMonthsPassed = (0, $3E8Nt.getMonthsDifference)(game.monthCount, game.year, buyout.month, buyout.year);
        if (buyoutMonthsPassed === 9 || buyoutMonthsPassed === 15) addBuyoutChance = true;
    }
    const chance = addBuyoutChance ? 60 : 2;
    // Chance to generate competitor
    const pick = (0, $3E8Nt.getRandomInt)(0, 100);
    if (pick <= chance) {
        // Get starting event index and standard feud and segment items
        const parentEvents = await $63f6dc8ca1007bd9$export$745573c3519c00ba(company);
        const nextEvent = (await (0, $9esFv.getCompanyEvents)(company)).filter((x)=>!x.weeklyShow).reverse()[0];
        const parentEventsNames = parentEvents.map((x)=>x.name);
        const startingEventIndex = parentEventsNames.indexOf(nextEvent.name);
        // Get number of superstars to add to competitor
        const percentageToAdd = (0, $3E8Nt.getRandomUniform)(0.75, 0.8);
        let numberOfSuperstarsToAdd = Math.floor(percentageToAdd * indieRosterSuperstars.length);
        const maximumSuperstars = 80;
        if (numberOfSuperstarsToAdd > maximumSuperstars) numberOfSuperstarsToAdd = maximumSuperstars + (0, $3E8Nt.getRandomInt)(-4, 4);
        // Get superstars to add
        let superstars = (0, $3E8Nt.getRandomSample)(indieRosterSuperstars, numberOfSuperstarsToAdd);
        // Add top indie superstars
        const topIndieSuperstars = [
            ...indieRosterSuperstars
        ].sort((a, b)=>b.popularity - a.popularity).slice(0, 8);
        if (topIndieSuperstars.length >= 5) {
            for (const superstar of (0, $3E8Nt.getRandomSample)(topIndieSuperstars, 5))if (!(0, $3E8Nt.objectInArray)(superstar, superstars)) superstars.push(superstar);
        }
        // Remove some stale superstars
        const staleSuperstars = superstars.filter((x)=>x.stale);
        for (const superstar of staleSuperstars.slice(0, 8))superstars.splice(superstars.indexOf(superstar), 1);
        // Get owner, chance to make a veteran the owner
        const veterans = superstars.filter((x)=>x.age >= 35 && x.popularity >= 800 && (x.partTimer || x.retired || x.fullTimeManager));
        const owner = veterans.length > 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= 75 ? (0, $3E8Nt.getRandomChoice)(veterans) : await (0, $8bQDO.generateSuperstar)();
        // Get tag teams of superstars added
        const tagTeams = [];
        for (const tagTeam of indieRosterTagTeams){
            const teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
            // If all team members selected, move team
            if (teamSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstars))) tagTeams.push(tagTeam);
            else if (teamSuperstars.some((x)=>(0, $3E8Nt.objectInArray)(x, superstars))) {
                tagTeam.rosterId = null;
                await (0, $972Ip.removeTagTeamSuperstars)(tagTeam);
            }
        }
        // Generate competitor
        const newCompetitor = await (0, $8bQDO.generateCompany)({
            startingEventIndex: startingEventIndex,
            existingCompanyNames: companies.map((x)=>x.name),
            superstars: superstars,
            tagTeams: tagTeams,
            ownerName: owner.name,
            month: game.monthCount,
            year: game.year,
            realYear: company.realYear,
            game: game
        });
        newCompetitor.activeEffect = "good_booking";
        if (game.marketSize !== null) {
            // Add fans, percentage of market size
            newCompetitor.fans = 0.0125 * newCompetitor.reputation * game.marketSize;
            newCompetitor.fans = (0, $3E8Nt.myround)(newCompetitor.fans, 10000);
            // Increase market size
            game.marketSize += newCompetitor.fans;
            // Add reputation xp
            newCompetitor.xp = (0, $3E8Nt.reputationXpLevels)[newCompetitor.reputation];
            newCompetitor.xp += ((0, $3E8Nt.reputationXpLevels)[newCompetitor.reputation + 1] - newCompetitor.xp) / 10.0;
        }
        const topSuperstars = [
            ...superstars
        ].sort((a, b)=>b.popularity - a.popularity).slice(0, 3).map((x)=>x.name);
        // Add message from talent manager
        const talentManager = $63f6dc8ca1007bd9$export$499c40897d9957a2(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
        const newMessage = await (0, $hekDR.createNewCompetitorMessage)(newCompetitor.name, owner.name, topSuperstars, game.monthCount, game.year, talentManager);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        // Add company alert
        const newCompanyAlert = await $63f6dc8ca1007bd9$export$d7d1923b1a78ff80("companyFormed", newCompetitor.name);
        await (0, $9esFv.addCompanyCompanyAlerts)(company, [
            newCompanyAlert
        ]);
        // Add company log
        const newLog = (0, $4K85d.CompanyLog)(game.monthCount, game.year);
        (0, $14eBR.CompanyLogs).insert(newLog);
        newLog.text = `New Company formed: ${newCompetitor.name}`;
        newLog.type = "new_company";
        newLog.value = 8;
        await (0, $9esFv.addCompanyCompanyLogs)(company, [
            newLog
        ]);
        // Add news
        let newsItem = await (0, $kZMqI.generateNewsItem)({
            company: newCompetitor,
            month: game.newsMonth,
            year: game.newsYear,
            newsType: "new_company",
            headline: true
        });
        await (0, $9esFv.addCompanyNewsItems)(company, [
            newsItem
        ]);
    }
    return true;
}
async function $63f6dc8ca1007bd9$export$5c4f16ca69677e4a({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get competitor
    const competitor = (await $63f6dc8ca1007bd9$export$1e4a46f46735bc71(userCompany, currentGame)).find((x)=>x.$loki === uid && x.operatingStatus === "Buyout Available");
    if (!competitor) {
        data["error"] = "competitor-not-found";
        return data;
    }
    // Get company data
    data = $63f6dc8ca1007bd9$var$getViewCompanyData(competitor, userCompany);
    const facility = (await (0, $9esFv.getCompanyFacilities)(userCompany)).find((x)=>x.name === "Talent Management");
    data["acquisitionFacilityPresent"] = facility ? facility.level >= 3 : false;
    data["cost"] = (0, $3E8Nt.myround)(3000 + competitor.reputation * 200, 100);
    data["companyInformation"] = await (0, $cJeaP.getScenarioCompanyInformation)(competitor, true);
    // Get available talent managers
    const talentManagers = $63f6dc8ca1007bd9$export$3117d1c4fcb92e56(await (0, $9esFv.getCompanyStaff)(userCompany), "talent_manager");
    if (!talentManagers.length) {
        data["error"] = "no-talent-manager-available";
        return data;
    }
    talentManagers.sort((a, b)=>b.level - a.level);
    data["talentManagers"] = talentManagers.map((x)=>$63f6dc8ca1007bd9$var$getStaffMemberData(x));
    return data;
}
async function $63f6dc8ca1007bd9$export$cb78fd4b9b7c8986({ uid: uid, talentManagerUid: talentManagerUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const competitor = (await $63f6dc8ca1007bd9$export$1e4a46f46735bc71(userCompany, currentGame)).find((x)=>x.$loki === uid && x.operatingStatus === "Buyout Available");
    if (userCompany.storyName === "mars") {
        data["error"] = "mars";
        return data;
    }
    if (!competitor) {
        data["error"] = "competitor-not-found";
        return data;
    }
    // Get talent manager
    const talentManager = (0, $14eBR.StaffMembers).get(talentManagerUid);
    if (!talentManager) {
        data["error"] = "talent-manager-not-found";
        return data;
    }
    if (talentManager.currentTask) // Check if already negotiating buyout
    {
        if (talentManager.currentTask.includes("Negotiating")) {
            data["error"] = "negotiating-buyout";
            data["talentManager"] = talentManager.name;
            data["currentTask"] = talentManager.currentTask;
            return data;
        }
    }
    // Check facility level
    const talentManagementFacility = (await (0, $9esFv.getCompanyFacilities)(userCompany)).find((x)=>x.name === "Talent Management");
    if (!talentManagementFacility || talentManagementFacility.level < 3) {
        data["error"] = "talent-management-facility-level";
        return data;
    }
    // Check if buyout available
    if (competitor.operatingStatus !== "Buyout Available") {
        data["error"] = "not-available-for-buyout";
        return data;
    }
    // Get cost
    const cost = (0, $3E8Nt.myround)(3000 + competitor.reputation * 200, 100);
    if (userCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Add task
    talentManager.currentTask = `Negotiating ${competitor.name} Buyout`;
    talentManager.monthsLeftForTask = 2;
    // Change competitor's operating status
    competitor.operatingStatus = `Negotiating Buyout by ${userCompany.name}`;
    // Remove points
    userCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = userCompany.points;
    data["talentManager"] = talentManager.name;
    data["task"] = talentManager.currentTask;
    data["competitorName"] = competitor.name;
    return data;
}
async function $63f6dc8ca1007bd9$export$cac4ba4211f70e11({ superstarUids: superstarUids, championshipUids: championshipUids, companyUid: companyUid, sendAllToMainRoster: sendAllToMainRoster } = {}) {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const user = (0, $bZol7.loadUser)();
    const competitor = (await $63f6dc8ca1007bd9$export$1e4a46f46735bc71(userCompany, game)).find((x)=>x.$loki === companyUid && x.operatingStatus !== "Inactive");
    const competitorRosters = await (0, $9esFv.getCompanyRosters)(competitor);
    const competitorMainRoster = competitorRosters[0];
    let competitorSuperstars = await (0, $dl5u4.getRosterSuperstars)(competitorMainRoster);
    const competitorTagTeams = await (0, $dl5u4.getRosterTagTeams)(competitorMainRoster);
    const competitorFactions = await (0, $dl5u4.getRosterFactions)(competitorMainRoster);
    let competitorChampionships = await (0, $9esFv.getCompanyChampionships)(competitor);
    const competitorActiveFeuds = (await (0, $dl5u4.getRosterFeuds)(competitorMainRoster)).filter((x)=>x.ended === false);
    const [available] = await $63f6dc8ca1007bd9$export$21c3db4bb65d37b0(competitor, competitorSuperstars, userCompany);
    const month = game.monthCount;
    const year = game.year;
    // Add training roster superstars, teams, and future superstars, but don't include them in available to select
    for (const x of [
        "training",
        "trainingAvailable",
        "trainingFuture"
    ]){
        let r = await $63f6dc8ca1007bd9$export$596e41e02971e822(competitor, x, competitorRosters);
        if (r) {
            competitorSuperstars.push(...await (0, $dl5u4.getRosterSuperstars)(r));
            competitorTagTeams.push(...await (0, $dl5u4.getRosterTagTeams)(r));
        }
    }
    if (!competitor) {
        data["error"] = "competitor-not-found";
        return data;
    }
    // If buyout not running, return error
    if (!competitor.operatingStatus.includes("Running Buyout")) {
        data["error"] = "no-buyout-running";
        return data;
    }
    // Get superstars from available buyout superstars
    let superstars = await Promise.all(superstarUids.map((x)=>(0, $14eBR.Superstars).get(x)));
    superstars = superstars.filter((x)=>(0, $3E8Nt.objectInArray)(x, available));
    let signingsAvailable = $63f6dc8ca1007bd9$export$ae21115afb55aed9(competitor);
    if (!superstars.length) {
        // Auto add signings if none selected
        if (signingsAvailable > available.length) signingsAvailable = available.length;
        superstars = (0, $3E8Nt.getRandomSample)(available, signingsAvailable);
    }
    // Max superstars
    if (superstars.length > signingsAvailable) superstars = superstars.slice(0, signingsAvailable);
    // Get championships
    let championships = await Promise.all(championshipUids.map((x)=>(0, $14eBR.Championships).get(x)));
    let championshipsAvailable = 3;
    if (!championships.length) {
        // Auto add championships if none selected
        const uniqueCompetitorChampionships = (0, $kZwpB.getUniqueChampionships)(competitorChampionships);
        if (championshipsAvailable > uniqueCompetitorChampionships.length) championshipsAvailable = uniqueCompetitorChampionships.length;
        championships = (0, $3E8Nt.getRandomSample)(uniqueCompetitorChampionships, championshipsAvailable);
    }
    // Max championships
    if (championships.length > championshipsAvailable) championships = championships.slice(0, championshipsAvailable);
    // Transfer superstars. Send top 70% to main roster, rest to training roster
    const companyRosters = await (0, $9esFv.getCompanyRosters)(userCompany);
    const companyMainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(userCompany, "main", companyRosters);
    const companyTrainingRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(userCompany, "training", companyRosters);
    let indieRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(mainCompany, "indie");
    let indieAvailableRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(mainCompany, "indieAvailable");
    let indieFutureRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(mainCompany, "indieFuture");
    let superstarsForMainRoster = [
        ...superstars
    ].sort((a, b)=>b.popularity - a.popularity);
    if (!sendAllToMainRoster) {
        const numberForMainRoster = Math.round(superstars.length * 0.7);
        superstarsForMainRoster = superstarsForMainRoster.slice(0, numberForMainRoster);
    }
    // Add retired superstars to main roster, not training
    const retiredSuperstars = superstars.filter((x)=>x.retired && !(0, $3E8Nt.objectInArray)(x, superstarsForMainRoster));
    superstarsForMainRoster.push(...retiredSuperstars);
    const superstarsForTrainingRoster = superstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, superstarsForMainRoster));
    // Move superstars
    for (const superstar of superstars){
        if ((0, $3E8Nt.objectInArray)(superstar, superstarsForMainRoster)) await (0, $dl5u4.addRosterSuperstars)(companyMainRoster, [
            superstar
        ]);
        else await (0, $dl5u4.addRosterSuperstars)(companyTrainingRoster, [
            superstar
        ]);
        superstar.brandName = null;
        await (0, $5kTkA.removeSuperstarManagerRelationships)(superstar);
        // Remove from competitorSuperstars
        competitorSuperstars = competitorSuperstars.filter((x)=>x.$loki !== superstar.$loki);
    }
    // Add signing company log
    for (const superstar of superstarsForMainRoster){
        let newLog = (0, $4K85d.CompanyLog)(month, mainCompany.realYear);
        (0, $14eBR.CompanyLogs).insert(newLog);
        newLog.text = superstar.name;
        newLog.value = 0;
        newLog.type = "signing";
        newLog.realYear = year;
        await (0, $9esFv.addCompanyCompanyLogs)(userCompany, [
            newLog
        ]);
    }
    // Transfer championships
    const superstarsForMainRosterIds = superstarsForMainRoster.map((x)=>x.$loki);
    for (const championship of championships){
        // Get tag, trio title sets
        const allFoundChampionships = competitorChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship));
        // Check if all championship holders are transferred to the main roster
        const championFound = allFoundChampionships.every((x)=>superstarsForMainRosterIds.includes(x.superstarId));
        for (const c of allFoundChampionships){
            await (0, $9esFv.addCompanyChampionships)(userCompany, [
                c
            ]);
            // Vacate title if all championship holders not transferred
            if (!championFound) {
                c.vacated = true;
                const champion = await (0, $ivuOU.getChampionshipSuperstar)(c);
                if (champion) await (0, $hBIDz.removeSuperstarChampionships)(champion, [
                    c
                ]);
            }
            c.booked = false;
            // Remove from competitorChampionships
            competitorChampionships = competitorChampionships.filter((x)=>x.$loki !== c.$loki);
        }
    }
    // Transfer remaining competitor superstars. Send 60% to indie unavailable, rest to indie available.
    const numberForIndieUnavailableRoster = Math.round(competitorSuperstars.length * 0.6);
    let superstarsForIndieUnavailableRoster = [];
    if (game.settings["all_indies_available"]) superstarsForIndieUnavailableRoster = [];
    else superstarsForIndieUnavailableRoster = (0, $3E8Nt.getRandomSample)(competitorSuperstars, numberForIndieUnavailableRoster);
    const superstarsForIndieAvailableRoster = competitorSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, superstarsForIndieUnavailableRoster));
    for (const superstar of competitorSuperstars){
        if (superstar.monthToAppearIn) // Send future superstars to indie future roster
        {
            if (indieFutureRoster) await (0, $dl5u4.addRosterSuperstars)(indieFutureRoster, [
                superstar
            ]);
        } else if ((0, $3E8Nt.objectInArray)(superstar, superstarsForIndieUnavailableRoster)) await (0, $dl5u4.addRosterSuperstars)(indieRoster, [
            superstar
        ]);
        else await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, [
            superstar
        ]);
        superstar.brandName = null;
        await (0, $5kTkA.removeSuperstarManagerRelationships)(superstar);
    }
    // Vacate remaining competitor championships and remove from champions
    for (const c of competitorChampionships){
        const champion = await (0, $ivuOU.getChampionshipSuperstar)(c);
        if (champion) await (0, $hBIDz.removeSuperstarChampionships)(champion, [
            c
        ]);
    }
    // Transfer tag teams
    const tagTeamsForMainRoster = [];
    for (const tagTeam of competitorTagTeams){
        // If all team superstars moved to one roster, move team
        let foundInRoster = null;
        const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
        if (tagTeamSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForMainRoster))) {
            foundInRoster = companyMainRoster;
            tagTeamsForMainRoster.push(tagTeam);
            // Add signing company log
            let newLog = (0, $4K85d.CompanyLog)(month, mainCompany.realYear);
            (0, $14eBR.CompanyLogs).insert(newLog);
            newLog.text = tagTeam.name;
            newLog.value = 0;
            newLog.type = "signing";
            newLog.realYear = year;
            await (0, $9esFv.addCompanyCompanyLogs)(userCompany, [
                newLog
            ]);
        } else if (tagTeamSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForTrainingRoster))) foundInRoster = companyTrainingRoster;
        else if (tagTeamSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForIndieUnavailableRoster))) foundInRoster = indieRoster;
        else if (tagTeamSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForIndieAvailableRoster))) foundInRoster = indieAvailableRoster;
        if (foundInRoster) await (0, $dl5u4.addRosterTagTeams)(foundInRoster, [
            tagTeam
        ]);
        else await (0, $972Ip.removeTagTeamSuperstars)(tagTeam);
    }
    // Transfer factions
    const factionsForMainRoster = [];
    for (const faction of competitorFactions){
        // If all faction superstars moved to one roster, move faction
        let foundInRoster = null;
        const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
        if (factionSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForMainRoster))) {
            foundInRoster = companyMainRoster;
            factionsForMainRoster.push(faction);
        } else if (factionSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForTrainingRoster))) foundInRoster = companyTrainingRoster;
        else if (factionSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForIndieUnavailableRoster))) foundInRoster = indieRoster;
        else if (factionSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForIndieAvailableRoster))) foundInRoster = indieAvailableRoster;
        if (foundInRoster) await (0, $dl5u4.addRosterFactions)(foundInRoster, [
            faction
        ]);
        else await (0, $6PzHO.disbandFaction)(faction, month, year);
    }
    // Transfer roster feuds if all participants transferred
    const feudsTransferred = [];
    for (const feud of competitorActiveFeuds){
        const feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
        if (feudParticipants[0].objectName === "superstar") {
            if (feudParticipants.every((x)=>(0, $3E8Nt.objectInArray)(x, superstarsForMainRoster))) {
                await (0, $dl5u4.addRosterFeuds)(companyMainRoster, [
                    feud
                ]);
                feudsTransferred.push(feud);
            }
        } else if (feudParticipants[0].objectName === "tagTeam") {
            if (feudParticipants.every((x)=>(0, $3E8Nt.objectInArray)(x, tagTeamsForMainRoster))) {
                await (0, $dl5u4.addRosterFeuds)(companyMainRoster, [
                    feud
                ]);
                feudsTransferred.push(feud);
            }
        } else if (feudParticipants[0].objectName === "faction") {
            if (feudParticipants.every((x)=>(0, $3E8Nt.objectInArray)(x, factionsForMainRoster))) {
                await (0, $dl5u4.addRosterFeuds)(companyMainRoster, [
                    feud
                ]);
                feudsTransferred.push(feud);
            }
        }
    }
    // Decrease market size, move some fans to competitors
    if (game.marketSize !== null) {
        const lostFans = competitor.fans * 0.50;
        game.marketSize -= lostFans;
        competitor.fans = lostFans;
    } else {
        // Add fans
        const fansToMove = (0, $3E8Nt.myround)(competitor.fans * (0, $3E8Nt.getRandomUniform)(0.5, 0.7), 1000);
        userCompany.fans += fansToMove;
        competitor.fans -= fansToMove;
    }
    // Change company to inactive
    competitor.operatingStatus = "Inactive";
    // Add messages
    const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const talentManager = $63f6dc8ca1007bd9$export$c39c537a73a9ae6e(companyStaffMembers, "talent_manager");
    const trainer = $63f6dc8ca1007bd9$export$c39c537a73a9ae6e(companyStaffMembers, "trainer");
    const doctor = $63f6dc8ca1007bd9$export$c39c537a73a9ae6e(companyStaffMembers, "doctor");
    // From doctor about any injured talent brought in
    const injuredSuperstars = superstars.filter((x)=>x.injured > 0);
    if (injuredSuperstars.length) {
        const newMessage = await (0, $hekDR.createBuyoutCompleteDoctorMessage)(competitor, month, year, doctor, injuredSuperstars);
        await (0, $9esFv.addCompanyMessages)(userCompany, [
            newMessage
        ]);
    }
    // From one of the top signed superstars
    const sortedSuperstarsForMainRoster = [
        ...superstarsForMainRoster
    ].sort((a, b)=>b.popularity - a.popularity);
    let newMessage = await (0, $hekDR.createBuyoutJoinedCompanyMessage)((0, $3E8Nt.getRandomChoice)(sortedSuperstarsForMainRoster.slice(0, 3)), month, year);
    await (0, $9esFv.addCompanyMessages)(userCompany, [
        newMessage
    ]);
    // From trainer about who was sent to the training roster
    if (superstarsForTrainingRoster.length) {
        const newMessage = await (0, $hekDR.createBuyoutCompleteTrainer)(competitor, month, year, trainer, superstarsForTrainingRoster);
        await (0, $9esFv.addCompanyMessages)(userCompany, [
            newMessage
        ]);
    }
    // From talent manager about what assets were brought in
    newMessage = await (0, $hekDR.createBuyoutCompleteMessage)(competitor, month, year, talentManager, superstars, championships, tagTeamsForMainRoster, feudsTransferred, factionsForMainRoster);
    await (0, $9esFv.addCompanyMessages)(userCompany, [
        newMessage
    ]);
    // Add userCompany log
    const newLog = (0, $4K85d.CompanyLog)(month, year);
    newLog.text = `${userCompany.name} bought out ${competitor.name}`;
    newLog.type = "buyout";
    newLog.value = 10;
    await (0, $9esFv.addCompanyCompanyLogs)(userCompany, [
        newLog
    ]);
    // Add competitor company log
    const newCompetitorLog = (0, $4K85d.CompanyLog)(month, year);
    newCompetitorLog.text = "Inactive after buyout";
    newCompetitorLog.type = "inactive";
    newCompetitorLog.value = 10;
    await (0, $9esFv.addCompanyCompanyLogs)(competitor, [
        newLog
    ]);
    // Add news
    let newsItem = await (0, $kZMqI.generateNewsItem)({
        company: userCompany,
        month: month,
        year: year,
        newsType: "company_buyout",
        competitor: competitor,
        headline: true
    });
    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
        newsItem
    ]);
    // Unlock special segment
    await (0, $3SyPM.unlockSpecialSegment)(userCompany, "Helicopter Raid", month, year);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    const unreadMessages = await $63f6dc8ca1007bd9$export$18f27f63ba1cd846(userCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $63f6dc8ca1007bd9$export$ad001f2932d102e1(company, mainRosterSuperstars, indieAvailableRoster, sandboxSettings = {}, month = 0, year = 0) {
    // Add staff
    let companyStaff = [];
    if ((0, $98xmD.globalUser).paid || company.storyName === "tutorial") {
        let level = 1;
        let numberOfStaffPerRole = 1;
        if (sandboxSettings["maximum_staff_and_facilities"]) {
            level = 3;
            numberOfStaffPerRole = 2;
        }
        for (let role of (0, $3E8Nt.staffRoles))for(let y = 0; y < numberOfStaffPerRole; y++){
            let staffMember = await (0, $8bQDO.generateStaffMember)(role, level);
            await (0, $9esFv.addCompanyStaff)(company, [
                staffMember
            ]);
            companyStaff.push(staffMember);
        }
    }
    // Add facilities
    let facilityNames = [
        "Medical",
        "Scouting",
        "Production",
        "Training",
        "Talent Management"
    ];
    let companyFacilities = [];
    for (let facility of facilityNames){
        let newFacility = (0, $fQoFZ.Facility)();
        (0, $14eBR.Facilities).insert(newFacility);
        newFacility.name = facility;
        if ((0, $98xmD.globalUser).paid || company.storyName === "tutorial") // Set staffNeverHired to False, as new game messages will be added at the start
        newFacility.staffNeverHired = false;
        await (0, $9esFv.addCompanyFacilities)(company, [
            newFacility
        ]);
        companyFacilities.push(facility);
        // For sandbox, set facility level to 3, actions completed to those required for level 3
        if (sandboxSettings["maximum_staff_and_facilities"]) {
            newFacility.level = 3;
            newFacility.actionsCompleted = (0, $3E8Nt.facilitiesData)[newFacility.name]["actionsToNextLevel"][3];
        }
    }
    // Add indie staff
    if (indieAvailableRoster) {
        for (let role of (0, $3E8Nt.staffRoles))for(let x = 0; x < (0, $3E8Nt.getRandomInt)(3, 4); x++){
            let staffMember = await (0, $8bQDO.generateStaffMember)(role);
            await (0, $dl5u4.addRosterStaff)(indieAvailableRoster, [
                staffMember
            ]);
        }
    }
    // Add facilities introduction message
    let newMessage = await (0, $hekDR.createIntroduceFacilitiesMessage)(month, year, company.ownerName, sandboxSettings);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Add staff members introduction message
    newMessage = await (0, $hekDR.createIntroduceStaffMembersMessage)(month, year, company.ownerName);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Add staff new game messages
    if ((0, $98xmD.globalUser).paid || company.storyName === "tutorial") {
        let doctor = companyStaff.find((x)=>x.role === "doctor");
        newMessage = await (0, $hekDR.createNewCompanyDoctorMessage)(mainRosterSuperstars.filter((x)=>x.injured), month, year, doctor, sandboxSettings);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        let trainer = companyStaff.find((x)=>x.role === "trainer");
        newMessage = await (0, $hekDR.createNewCompanyTrainerMessage)(month, year, trainer, sandboxSettings);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        let scout = companyStaff.find((x)=>x.role === "scout");
        newMessage = await (0, $hekDR.createNewCompanyScoutMessage)(month, year, scout, sandboxSettings);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        let producer = companyStaff.find((x)=>x.role === "producer");
        newMessage = await (0, $hekDR.createNewCompanyProducerMessage)(month, year, producer, sandboxSettings);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        let talentManager = companyStaff.find((x)=>x.role === "talent_manager");
        newMessage = await (0, $hekDR.createNewCompanyTalentManagerMessage)(month, year, talentManager, sandboxSettings);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    }
    return [
        companyStaff,
        companyFacilities
    ];
}
async function $63f6dc8ca1007bd9$export$ffbf66b849aebc45(company, simulating = false) {
    let data = {};
    let retired = [];
    let turnedPartTimers = [];
    let rosters = await (0, $9esFv.getCompanyRosters)(company);
    let mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "main", rosters);
    let mainRosterSuperstars = await $63f6dc8ca1007bd9$export$be76e1c1c7fb3418(company);
    let companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    let game = await (0, $9esFv.getCompanyGame)(company);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    let draft = await (0, $9esFv.getCompanyDraft)(mainCompany);
    // Get ages, different for stories
    let partTimerAge = company.storyName !== "mars" ? 38 : 45;
    let retirementAge = company.storyName !== "mars" ? 45 : 55;
    // Runs every first month, don't run if draft running
    if (!company.yearlyCheckRun && (!draft || draft.postEndRun)) {
        company.yearlyCheckRun = true;
        let staffMembers = await (0, $9esFv.getCompanyStaff)(company);
        let talentManager = $63f6dc8ca1007bd9$export$c39c537a73a9ae6e(staffMembers, "talent_manager");
        let talentManagementFacility = (await (0, $9esFv.getCompanyFacilities)(company)).find((facility)=>facility.name === "Talent Management");
        // Get minimum appearances for part timers
        let minimumAppearances = 1;
        let guaranteedAppearances = false;
        if (talentManager && talentManagementFacility) {
            if (talentManager.level >= 3 && talentManagementFacility.level >= 3) {
                minimumAppearances = 5;
                guaranteedAppearances = true;
            } else if (talentManager.level >= 2 && talentManagementFacility.level >= 2) {
                minimumAppearances = 3;
                guaranteedAppearances = true;
            }
        }
        $63f6dc8ca1007bd9$var$setPartTimerAppearances(mainRosterSuperstars, minimumAppearances);
        // Process retirements, part timers, traits lost and age increases after first year
        if ($63f6dc8ca1007bd9$export$2c9c79c85a054651(company, game) > 0) {
            retired = await $63f6dc8ca1007bd9$var$processRetired(mainRoster, mainRosterSuperstars, companyChampionships, game.monthCount, game.year, company, game, retirementAge);
            turnedPartTimers = await $63f6dc8ca1007bd9$var$processPartTimers(mainRosterSuperstars, partTimerAge, game, minimumAppearances);
            let traitsLost = $63f6dc8ca1007bd9$var$processTraitsLoss(mainRosterSuperstars);
            $63f6dc8ca1007bd9$var$incrementAges(mainRosterSuperstars);
            // Add messages
            for (const s of retired){
                let newMessage = await (0, $hekDR.createRetirementMessage)(s, game.monthCount, game.year, company, staffMembers);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            if (turnedPartTimers.length) {
                let newMessage = await (0, $hekDR.createPartTimersMessage)(turnedPartTimers, company, game, staffMembers);
                if (newMessage) await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            for (const traitLost of traitsLost){
                let newMessage = await (0, $hekDR.createTraitLostMessage)(traitLost, company, game, staffMembers);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            // Process training/indie rosters (except future)
            let otherRosters = rosters.filter((x)=>x !== mainRoster && ![
                    "trainingFuture",
                    "indieFuture"
                ].includes(x.type));
            for (const roster of otherRosters)await $63f6dc8ca1007bd9$var$processRosterYearlyChanges(roster, companyChampionships, game, company, retirementAge, partTimerAge);
            // Process competitor rosters
            if (company === mainCompany) for (const competitor of (await $63f6dc8ca1007bd9$export$6662b06ad2b15a09(company, game))){
                const competitorRosters = await (0, $9esFv.getCompanyRosters)(competitor);
                const competitorChampionships = await (0, $9esFv.getCompanyChampionships)(competitor);
                for (const competitorRoster of competitorRosters.filter((x)=>[
                        "main",
                        "training",
                        "trainingAvailable"
                    ].includes(x.type)))await $63f6dc8ca1007bd9$var$processRosterYearlyChanges(competitorRoster, competitorChampionships, game, competitor, retirementAge, partTimerAge);
            }
        }
        // Get potential part timers / retirements and add message
        const { partTimerChances: partTimerChances, retirementChances: retirementChances } = $63f6dc8ca1007bd9$var$getPotentialContractChanges(mainRosterSuperstars, game, partTimerAge, retirementAge);
        if (partTimerChances.length || retirementChances.length) {
            let newMessage = await (0, $hekDR.createContractsChangeMessage)(partTimerChances, retirementChances, company, game, staffMembers);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        // Add part timers appearances message
        let partTimers = mainRosterSuperstars.filter((x)=>x.partTimer && !x.retired && !x.dead && ![
                "retirement_return",
                "traded"
            ].includes(x.activeEffect) && !x.fullTimeManager);
        if (partTimers.length) {
            let newMessage = await (0, $hekDR.createPartTimersAppearancesSignedForMessage)(company, game, partTimers, talentManager, guaranteedAppearances, minimumAppearances);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        if (!simulating) (0, $14eBR.db).saveDatabase();
    }
    data["retired"] = retired;
    return data;
}
async function $63f6dc8ca1007bd9$var$processRosterYearlyChanges(roster, companyChampionships, game, company, retirementAge, partTimerAge) {
    let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(roster);
    $63f6dc8ca1007bd9$var$setPartTimerAppearances(rosterSuperstars);
    await $63f6dc8ca1007bd9$var$processRetired(roster, rosterSuperstars, companyChampionships, game.monthCount, game.year, company, game, retirementAge);
    await $63f6dc8ca1007bd9$var$processPartTimers(rosterSuperstars, partTimerAge, game);
    $63f6dc8ca1007bd9$var$processTraitsLoss(rosterSuperstars);
    $63f6dc8ca1007bd9$var$incrementAges(rosterSuperstars);
}
function $63f6dc8ca1007bd9$var$setPartTimerAppearances(superstars, minimumAppearances = 1) {
    let filteredSuperstars = superstars.filter((x)=>!x.retired && !x.dead && ![
            "retirement_return",
            "traded"
        ].includes(x.activeEffect) && !x.fullTimeManager);
    for (const superstar of filteredSuperstars)if (superstar.partTimer) superstar.appearances = (0, $3E8Nt.getRandomInt)(minimumAppearances, 8);
    return true;
}
function $63f6dc8ca1007bd9$var$getPotentialContractChanges(superstars, game, partTimerAge, retirementAge) {
    // Returns superstars that have a chance to be part timers or retired next year
    let partTimerChances = [];
    let retirementChances = [];
    let filteredSuperstars = superstars.filter((x)=>!x.retired && !x.dead && ![
            "retirement_return",
            "traded"
        ].includes(x.activeEffect) && !x.fullTimeManager);
    for (const superstar of filteredSuperstars){
        if (superstar.age >= partTimerAge && !superstar.partTimer && !game["settings"]["no_going_part_time"]) partTimerChances.push(superstar.name);
        if (superstar.age >= retirementAge && !game.settings["no_retirements"]) retirementChances.push(superstar.name);
    }
    return {
        partTimerChances: partTimerChances,
        retirementChances: retirementChances
    };
}
async function $63f6dc8ca1007bd9$var$processPartTimers(superstars, age, game, minimumAppearances = 1) {
    let turnedPartTimers = [];
    if (!game.settings["no_going_part_time"]) {
        let filteredSuperstars = superstars.filter((x)=>!x.retired && !x.dead && !x.partTimer && ![
                "retirement_return",
                "traded"
            ].includes(x.activeEffect) && !x.fullTimeManager);
        for (const superstar of filteredSuperstars){
            let pick = (0, $3E8Nt.getRandomInt)(0, 100);
            let turnPartTimerChance = 25;
            let superstarTurnPartTimerAge = age;
            // Check for turn part timer traits
            for (let trait of superstar.traits){
                let traitData = (0, $aP7lq.traitsData)[trait];
                if (traitData && traitData["part_timer_chance_multiplier"]) turnPartTimerChance *= traitData["part_timer_chance_multiplier"];
                if (traitData && traitData["turn_part_timer_age_change"]) superstarTurnPartTimerAge += traitData["turn_part_timer_age_change"];
            }
            // Turn part timer
            if (superstar.age >= superstarTurnPartTimerAge && pick <= turnPartTimerChance) {
                superstar.partTimer = true;
                superstar.appearances = (0, $3E8Nt.getRandomInt)(minimumAppearances, 8);
                turnedPartTimers.push(superstar.name);
                await (0, $5kTkA.checkAcquireTrait)(superstar, "Giving Veteran");
            }
        }
    }
    return turnedPartTimers;
}
async function $63f6dc8ca1007bd9$var$processRetired(roster, superstars, championships, month, year, company, game, age) {
    let retired = [];
    if (!game.settings["no_retirements"]) {
        let filteredSuperstars = superstars.filter((x)=>!x.retired && !x.dead && ![
                "retirement_return",
                "traded"
            ].includes(x.activeEffect) && !x.fullTimeManager);
        for (const superstar of filteredSuperstars){
            let pick = (0, $3E8Nt.getRandomInt)(0, 100);
            let retirementChance = 25;
            let superstarRetirementAge = age;
            for (let trait of superstar.traits){
                let traitData = (0, $aP7lq.traitsData)[trait];
                if (traitData && traitData["retirement_chance_multiplier"]) retirementChance *= traitData["retirement_chance_multiplier"];
                if (traitData && traitData["retirement_age_change"]) superstarRetirementAge += traitData["retirement_age_change"];
            }
            if (superstar.age >= superstarRetirementAge && pick <= retirementChance) {
                let data = await (0, $5kTkA.retireSuperstar)(superstar, roster, championships, month, year, company);
                retired.push(data);
            }
        }
    }
    return retired;
}
function $63f6dc8ca1007bd9$var$incrementAges(superstars) {
    for (const superstar of superstars)superstar.age += 1;
    return true;
}
function $63f6dc8ca1007bd9$var$processTraitsLoss(superstars) {
    let traitsLost = [];
    let filteredSuperstars = superstars.filter((x)=>!x.dead && x.traits.length && x.activeEffect !== "traded");
    for (let superstar of filteredSuperstars){
        // Check if over trait loss age, which is higher for managers
        let age = superstar.fullTimeManager ? 62 : 42;
        if (superstar.age >= age) {
            let pick = (0, $3E8Nt.getRandomInt)(0, 100);
            let loseTraitChance = 20;
            // Check for lose trait chance multiplier trait
            for (let trait of superstar.traits){
                let traitData = (0, $aP7lq.traitsData)[trait];
                if (traitData && traitData["lose_trait_chance_multiplier"]) loseTraitChance *= traitData["lose_trait_chance_multiplier"];
            }
            if (pick <= loseTraitChance) {
                // Don't pick trait that lowers lose trait chance
                let availableTraits = superstar.traits.filter((x)=>!(0, $aP7lq.traitsData)[(0, $5kTkA.formatSuperstarTrait)(x)]["disable_lose_with_age"]);
                if (availableTraits.length > 0) {
                    let traitToRemove = (0, $3E8Nt.getRandomChoice)(availableTraits);
                    (0, $5kTkA.removeTraitFromSuperstar)(superstar, traitToRemove);
                    traitsLost.push({
                        "superstar": superstar.name,
                        "pronoun": superstar.pronoun,
                        "trait": traitToRemove
                    });
                }
            }
        }
    }
    return traitsLost;
}
async function $63f6dc8ca1007bd9$export$35fabf184faa077e(companies, game, latestMainCompanyEvent) {
    let data = {};
    data["viewershipData"] = [];
    data["reputationData"] = [];
    let allEventsRan = [];
    // Increase monthlyEventFanChangeMultiplier if no weekly shows
    let monthlyEventFanChangeMultiplier = 5;
    if (game.numberOfWeeklyShows === 0) monthlyEventFanChangeMultiplier = 15;
    let startingFansData = {};
    for (let company of companies){
        let events = (await (0, $9esFv.getCompanyEvents)(company)).filter((x)=>x.rating !== null).reverse();
        let mainRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "main");
        let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
        startingFansData[company.$loki] = company.fans;
        // Skip newly formed company as it will not have a held event
        if (!events.length) continue;
        let event = events[0];
        // Skip if not same event as game's latest event
        if (event.weeklyShow !== latestMainCompanyEvent.weeklyShow || event.weekNumber !== latestMainCompanyEvent.weekNumber) continue;
        // Get events that company ran
        let companyEventsRan = [
            event
        ];
        // Get multiple shows if present (when competitor has more brands than user)
        let currentBrandIndex = (0, $1Dp0h.getBrandIndexForWeeklyShow)(event, rosterBrands);
        if (event.weeklyShow && currentBrandIndex > 0) {
            // Get brand weekly shows with same week number as last event
            let multipleEventsRan = events.slice(0, 3).filter((x)=>!x.viewership && x.weeklyShow && rosterBrands.some((y)=>y.weeklyShowName === x.name) && x.weekNumber === event.weekNumber);
            if (multipleEventsRan.length) companyEventsRan = [
                ...multipleEventsRan
            ].reverse();
        }
        let totalFanChange = 0;
        for (let event of companyEventsRan){
            // Check if viewership already gotten for event (when user has more brands), don't calculate viewership
            let pastEvent = !!event.viewership;
            let viewership = event.viewership;
            // Get viewership and fan change
            let highHype = 75;
            let fanChange;
            if (event.weeklyShow) {
                if (!viewership) {
                    // Get viewership multiplier based on brand index if present
                    let viewershipFanMultiplier = 0.75;
                    let eventBrandIndex = (0, $1Dp0h.getBrandIndexForWeeklyShow)(event, rosterBrands);
                    if (eventBrandIndex) {
                        if (eventBrandIndex === 1) viewershipFanMultiplier = 0.68;
                        else if (eventBrandIndex === 2) viewershipFanMultiplier = 0.61;
                    }
                    viewership = company.fans * viewershipFanMultiplier + event.hype / highHype * company.fans * 0.25;
                }
                fanChange = (event.rating - 3.5) / 30.0 * viewership;
            } else {
                // Get buys if monthly show
                if (!viewership) viewership = company.fans * 0.02 + event.hype / highHype * company.fans * 0.06;
                fanChange = (event.rating - 3.5) / 30.0 * viewership * monthlyEventFanChangeMultiplier;
            }
            // Fix low fan change
            if (0 <= fanChange && fanChange < 100) {
                if (fanChange < 10) fanChange += 10;
                fanChange *= 10;
            }
            if (!event.viewership) {
                if (viewership < 1000) viewership = (0, $3E8Nt.myround)(viewership, 100);
                else viewership = (0, $3E8Nt.myround)(viewership, 1000);
                event.viewership = viewership;
            }
            totalFanChange += fanChange;
            let ratingData = {};
            ratingData["company"] = (0, $1JSre.formatCompanyNameBackend)(company.name);
            ratingData["viewership"] = viewership;
            ratingData["rating"] = event.rating;
            ratingData["event"] = event.name;
            ratingData["brandName"] = event.brandName;
            ratingData["brandColor"] = (0, $1Dp0h.getBrandColorForEvent)(event, rosterBrands);
            ratingData["weeklyShow"] = event.weeklyShow;
            ratingData["playerName"] = company.playerName;
            ratingData["isUserControlled"] = company.userControlled;
            ratingData["uid"] = company.$loki;
            if (event.weeklyShow) ratingData["nielsenRating"] = (0, $5ZsVo.getNielsenRatingFromViewership)(viewership);
            ratingData["pastEvent"] = pastEvent; // If past event, show 'last weekly show' label on viewership page
            data["viewershipData"].push(ratingData);
            allEventsRan.push(event);
        }
        // Add fans to company
        company.fans += totalFanChange / companyEventsRan.length;
    }
    // Limit fans to market size
    let totalFans = companies.map((x)=>x.fans).reduce((acc, curr)=>acc + curr, 0);
    let multiplyValue = game.marketSize / totalFans;
    for (let company of companies){
        let events = (await (0, $9esFv.getCompanyEvents)(company)).filter((x)=>x.rating !== null).reverse().slice(0, 3);
        // Get total fan change for company
        company.fans = (0, $3E8Nt.myround)(company.fans * multiplyValue, 100);
        let totalFanChange = company.fans - startingFansData[company.$loki];
        // Add fans gained and total fans to events
        let companyEventsRan = events.filter((x)=>(0, $3E8Nt.objectInArray)(x, allEventsRan)).reverse();
        let eventStartingFans = startingFansData[company.$loki]; // Use to add totalFans to multiple events
        for (let event of companyEventsRan){
            // Divide fan change between multiple events (when competitor has more brands than user)
            let eventFanChange = totalFanChange / companyEventsRan.length;
            if (event.fansGained) // Add to existing fansGained if present (when user has more brands)
            event.fansGained += eventFanChange;
            else event.fansGained = eventFanChange;
            event.totalFans = eventStartingFans + eventFanChange;
            eventStartingFans += eventFanChange;
        }
        // Add to data
        let ratingData = data["viewershipData"].find((x)=>x["uid"] === company.$loki);
        if (ratingData) {
            ratingData["fans"] = company.fans;
            ratingData["fanChange"] = totalFanChange;
            // If multiple company events ran (when competitor has more brands), show 'total' label on viewership page
            if (companyEventsRan.length > 1) ratingData["multipleCompanyEvents"] = true;
        }
        // Update reputation, add data if user controlled company
        let reputationData = $63f6dc8ca1007bd9$var$updateCompanyReputation(company, totalFanChange, startingFansData, game);
        if (company.userControlled) data["reputationData"].push(reputationData);
    }
    // Sort by viewership
    data["viewershipData"].sort((a, b)=>b["viewership"] - a["viewership"]);
    return data;
}
function $63f6dc8ca1007bd9$var$updateCompanyReputation(company, fanChange, startingFansData, game) {
    let data = {};
    let xpToNextReputation = (0, $3E8Nt.reputationXpLevels)[company.reputation + 1];
    let xpToPreviousReputation = (0, $3E8Nt.reputationXpLevels)[company.reputation];
    let xpChange;
    try {
        xpChange = Math.round(fanChange / startingFansData[company.$loki] * 500.0);
    } catch (e) {
        xpChange = 0;
    }
    if (xpChange < 0) xpChange = Math.round(xpChange / 2);
    if (xpChange >= 50) xpChange = 50;
    company.xp += xpChange;
    company.xp = (0, $3E8Nt.limitValueBetweenRange)(company.xp, 0, 600);
    // Check for reputation change
    if (company.xp >= xpToNextReputation && company.reputation < 10) {
        company.reputation += 1;
        data["reputationIncrease"] = true;
        // Get xp levels again
        xpToNextReputation = (0, $3E8Nt.reputationXpLevels)[company.reputation + 1];
        xpToPreviousReputation = (0, $3E8Nt.reputationXpLevels)[company.reputation];
        // Update highestReputation
        if (company.reputation > company.highestReputation) company.highestReputation = company.reputation;
        data["rosterSize"] = $63f6dc8ca1007bd9$export$d342efbc7d93e412(company, game);
    } else if (company.xp < xpToPreviousReputation && company.reputation > 1) {
        // Reputation decrease
        company.reputation -= 1;
        data["reputationDecrease"] = true;
        // Get xp levels again
        xpToNextReputation = (0, $3E8Nt.reputationXpLevels)[company.reputation + 1];
        xpToPreviousReputation = (0, $3E8Nt.reputationXpLevels)[company.reputation];
        data["rosterSize"] = $63f6dc8ca1007bd9$export$d342efbc7d93e412(company, game);
    }
    data["xpToPreviousReputation"] = xpToPreviousReputation;
    data["reputation"] = company.reputation;
    data["reputationXpChange"] = xpChange;
    data["reputationXp"] = company.xp;
    data["xpToNextReputation"] = xpToNextReputation;
    data["companyName"] = company.name;
    return data;
}
async function $63f6dc8ca1007bd9$export$af038510249ddb52({ uid: uid } = {}) {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const userCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
    // Get company to switch to
    let companyToSwitchTo;
    if (uid) companyToSwitchTo = userCompanies.find((x)=>x.$loki === uid);
    else {
        const currentCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
        companyToSwitchTo = userCompanies.find((x)=>x.$loki !== currentCompany.$loki);
    }
    if (!companyToSwitchTo) {
        data["error"] = "company-not-found";
        return data;
    }
    // Check if turn not ended
    if (companyToSwitchTo.turnStatus === "ended") {
        data["error"] = "turn-ended";
        data["playerName"] = companyToSwitchTo.playerName;
        return data;
    }
    // Set current company
    (0, $dBFC4.setGameCurrentCompany)(game, companyToSwitchTo);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $63f6dc8ca1007bd9$export$b17cc431a6faf390({} = {}) {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const userCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
    // Get data for user companies
    data["companies"] = [];
    for (const userCompany of userCompanies){
        let userCompanyData = {
            "name": userCompany.name,
            "uid": userCompany.$loki,
            "playerName": userCompany.playerName,
            "turnStatus": userCompany.turnStatus
        };
        data["companies"].push(userCompanyData);
    }
    // Get current company's name
    const currentCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    data["currentCompanyName"] = currentCompany.name;
    return data;
}
async function $63f6dc8ca1007bd9$export$4ee2598fa0e8c4fc() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Generate owner name
    data["ownerName"] = $63f6dc8ca1007bd9$export$3ddce8cece123621(userCompany);
    // Check other requirements
    data["yearsAtCompanyFulfilled"] = $63f6dc8ca1007bd9$export$2c9c79c85a054651(userCompany, currentGame) >= 2;
    data["yearsAtCompany"] = $63f6dc8ca1007bd9$export$2c9c79c85a054651(userCompany, currentGame);
    data["points"] = userCompany.points;
    const companies = await (0, $iRMwH.getGameActiveCompanies)(currentGame);
    data["companySpaceAvailable"] = companies.length < (0, $3E8Nt.gameLimits).maxCompetitors + 1;
    return data;
}
function $63f6dc8ca1007bd9$export$3ddce8cece123621(userCompany) {
    const companyRandom = new Math.seedrandom(userCompany.meta.created);
    let ownerGender = (0, $3E8Nt.getRandomInt)(0, 100, companyRandom) <= 60 ? "male" : "female";
    return (0, $3E8Nt.generateName)(ownerGender, companyRandom());
}
async function $63f6dc8ca1007bd9$export$1502697a3002b5fc() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const cost = 5000;
    const companies = await (0, $iRMwH.getGameActiveCompanies)(currentGame);
    // Check local multiplayer
    if (currentGame.settings["control_multiple_companies"]) {
        data["error"] = "local-multiplayer";
        return data;
    }
    // Check stories
    if (userCompany.storyName) {
        data["error"] = "story";
        return data;
    }
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Check if already forming
    if (userCompany.newCompanyData?.monthsToForm !== undefined) {
        data["error"] = "already-forming";
        return data;
    }
    // Check cost
    if (userCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Check years
    if ($63f6dc8ca1007bd9$export$2c9c79c85a054651(userCompany, currentGame) < 2) {
        data["error"] = "not-enough-years";
        return data;
    }
    // Check companies
    if (companies.length >= (0, $3E8Nt.gameLimits).maxCompetitors + 1) {
        data["error"] = "not-enough-space";
        return data;
    }
    const ownerName = $63f6dc8ca1007bd9$export$3ddce8cece123621(userCompany);
    // Add new company data
    userCompany.newCompanyData = {
        monthsToForm: 3,
        ownerName: ownerName
    };
    // Add message
    const currentOwnerMessage = await (0, $hekDR.createFormingNewCompanyCurrentOwnerMessage)(userCompany.ownerName, currentGame.monthCount, currentGame.year);
    await (0, $9esFv.addCompanyMessages)(userCompany, [
        currentOwnerMessage
    ]);
    const newOwnerMessage = await (0, $hekDR.createFormingNewCompanyNewOwnerMessage)(ownerName, currentGame.monthCount, currentGame.year);
    await (0, $9esFv.addCompanyMessages)(userCompany, [
        newOwnerMessage
    ]);
    // Remove points
    userCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = userCompany.points;
    const unreadMessages = (await (0, $9esFv.getCompanyMessages)(userCompany)).filter((x)=>!x.read);
    data["unreadMessages"] = unreadMessages.length;
    data["ownerName"] = ownerName;
    return data;
}
async function $63f6dc8ca1007bd9$export$fdf398db72a92ada({ companyDetails: companyDetails }) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companies = await (0, $iRMwH.getGameActiveCompanies)(currentGame);
    if (userCompany.newCompanyData.companyDetails) {
        data["error"] = "already-done";
        return data;
    }
    // Check company name
    if (companies.map((x)=>x.name).includes(companyDetails.companyName)) {
        data["error"] = "name-exists";
        return data;
    }
    // Add new company data
    userCompany.newCompanyData.companyDetails = companyDetails;
    // Add message
    const ownerName = userCompany.newCompanyData.ownerName;
    const newMessage = await (0, $hekDR.createNewCompanyOwnerDetailsMessage)(ownerName, companyDetails.companyName, userCompany.name, currentGame.monthCount, currentGame.year);
    await (0, $9esFv.addCompanyMessages)(userCompany, [
        newMessage
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["ownerName"] = ownerName;
    return data;
}
async function $63f6dc8ca1007bd9$export$1ac9f3dd088d2125(company) {
    let data = {};
    const superstars = await $63f6dc8ca1007bd9$export$be76e1c1c7fb3418(company);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    const interestedSuperstars = await $63f6dc8ca1007bd9$var$getNewCompanyInterestedSuperstars(company, superstars);
    data["selectionsAvailable"] = 30;
    // Get superstars, sort by popularity
    data["superstars"] = superstars.map((x)=>({
            "name": x.name,
            "popularity": x.popularity,
            "age": x.age,
            "uid": x.$loki,
            "appearances": x.partTimer ? x.appearances : null,
            "retired": x.retired,
            "injured": x.injured > 0 ? x.injured : false,
            "championships": (0, $5kTkA.getSuperstarChampionshipsAll)(x, companyChampionships),
            "interested": (0, $3E8Nt.objectInArray)(x, interestedSuperstars),
            "fullTimeManager": x.fullTimeManager
        }));
    data["superstars"].sort((a, b)=>b.popularity - a.popularity);
    return data;
}
async function $63f6dc8ca1007bd9$var$getNewCompanyInterestedSuperstars(company, rosterSuperstars) {
    const companyRandom = new Math.seedrandom(company.meta.created);
    let interestedSuperstars = [];
    // Get interested superstars based on morale
    for (let x of rosterSuperstars){
        let chance;
        if (x.morale >= 100) chance = 100;
        else if (x.morale >= 90) chance = 70;
        else if (x.morale >= 80) chance = 50;
        else if (x.morale >= 60) chance = 15;
        else chance = 2;
        if (x.unhappy) chance = 0;
        if ((0, $3E8Nt.getRandomInt)(0, 100, companyRandom()) <= chance) interestedSuperstars.push(x);
    }
    return interestedSuperstars;
}
async function $63f6dc8ca1007bd9$export$f818672de6f4449d({ superstarUids: superstarUids } = {}) {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    if (userCompany.newCompanyData.talentDetails) {
        data["error"] = "already-done";
        return data;
    }
    // Add talent company data
    const superstars = await $63f6dc8ca1007bd9$export$be76e1c1c7fb3418(userCompany);
    const interestedSuperstars = await $63f6dc8ca1007bd9$var$getNewCompanyInterestedSuperstars(userCompany, superstars);
    userCompany.newCompanyData.talentDetails = {
        interestedIds: interestedSuperstars.map((x)=>x.$loki),
        selectedIds: superstarUids
    };
    // Add message
    let interestedSelectedTalent = interestedSuperstars.find((x)=>superstarUids.includes(x.$loki));
    if (interestedSelectedTalent) {
        const interestedMessage = await (0, $hekDR.createNewCompanyInterestedTalentMessage)(interestedSelectedTalent, game.monthCount, game.year);
        await (0, $9esFv.addCompanyMessages)(userCompany, [
            interestedMessage
        ]);
    }
    const currentOwnerMessage = await (0, $hekDR.createNewCompanyCurrentOwnerTalentMessage)(userCompany.ownerName, userCompany.newCompanyData.companyDetails.companyName, game.monthCount, game.year);
    await (0, $9esFv.addCompanyMessages)(userCompany, [
        currentOwnerMessage
    ]);
    const ownerName = userCompany.newCompanyData.ownerName;
    const newMessage = await (0, $hekDR.createNewCompanyOwnerTalentMessage)(ownerName, superstarUids.length, game.monthCount, game.year);
    await (0, $9esFv.addCompanyMessages)(userCompany, [
        newMessage
    ]);
    // Add news
    let newsItem = await (0, $kZMqI.generateNewsItem)({
        company: userCompany,
        month: game.monthCount,
        year: game.year,
        newsType: "new_user_company",
        headline: true,
        newOwnerName: ownerName,
        newCompanyName: userCompany.newCompanyData.companyDetails.companyName
    });
    await (0, $9esFv.addCompanyNewsItems)(userCompany, [
        newsItem
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["ownerName"] = ownerName;
    return data;
}
async function $63f6dc8ca1007bd9$export$bc22e60b13ece380() {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const company = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    const indieRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "indie");
    const indieAvailableRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "indieAvailable");
    const indieFutureRoster = await $63f6dc8ca1007bd9$export$596e41e02971e822(company, "indieFuture");
    const newCompanyData = company.newCompanyData;
    const companyDetails = newCompanyData.companyDetails;
    // Get superstars selected from previous company
    const previousCompanySuperstars = await $63f6dc8ca1007bd9$export$be76e1c1c7fb3418(company);
    const interestedIds = newCompanyData.talentDetails.interestedIds;
    const selectedIds = newCompanyData.talentDetails.selectedIds;
    const selectedSuperstars = previousCompanySuperstars.filter((x)=>selectedIds.includes(x.$loki));
    let previousCompanySuperstarsToAdd = [];
    let newCompanySuperstars = [];
    for (let x of selectedSuperstars){
        let joinChance = 20;
        if (interestedIds.includes(x.$loki)) joinChance = 100;
        else {
            if (x.morale >= 60) joinChance += 30;
            if (x.unhappy) joinChance -= 60;
            if (x.traits.includes("Rebel")) joinChance += 40;
            if (x.traits.includes("Loyal")) joinChance -= 40;
        }
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= joinChance) previousCompanySuperstarsToAdd.push(x);
    }
    newCompanySuperstars.push(...previousCompanySuperstarsToAdd);
    // Get superstars from indies and competitors
    const indieSuperstars = await (0, $dl5u4.getRosterSuperstars)(indieRoster).concat(await (0, $dl5u4.getRosterSuperstars)(indieAvailableRoster));
    const indieSuperstarsToAdd = (0, $3E8Nt.getRandomSample)(indieSuperstars, (0, $3E8Nt.getRandomInt)(24, 26));
    newCompanySuperstars.push(...indieSuperstarsToAdd);
    let competitorSuperstars = [];
    for (let x of (await (0, $iRMwH.getGameActiveCompanies)(game)))if (x.$loki !== company.$loki) competitorSuperstars.push(...await $63f6dc8ca1007bd9$export$be76e1c1c7fb3418(x));
    const competitorSuperstarsToAdd = (0, $3E8Nt.getRandomSample)(competitorSuperstars, (0, $3E8Nt.getRandomInt)(4, 6));
    newCompanySuperstars.push(...competitorSuperstarsToAdd);
    // Generate superstars if not enough
    while(newCompanySuperstars.length < 20){
        let newSuperstar = await (0, $8bQDO.generateSuperstar)({
            generateGimmick: false
        });
        newCompanySuperstars.push(newSuperstar);
    }
    // Get starting event index
    const parentEvents = await $63f6dc8ca1007bd9$export$745573c3519c00ba(company);
    const nextEvent = (await (0, $9esFv.getCompanyEvents)(company)).filter((x)=>!x.weeklyShow && !x.temporaryEvent).reverse()[0];
    const parentEventsNames = parentEvents.map((x)=>x.name);
    const startingEventIndex = parentEventsNames.indexOf(nextEvent.name);
    // Create company
    const newCompany = await $63f6dc8ca1007bd9$var$createCompany(companyDetails, newCompanySuperstars, newCompanyData.ownerName, startingEventIndex, company, game);
    newCompany.introducedPowerups = true;
    newCompany.userControlled = true;
    newCompany.newUserCompany = true;
    newCompany.month = 0;
    newCompany.year = 0;
    // Add company log
    const newLog = (0, $4K85d.CompanyLog)(game.monthCount, game.year);
    (0, $14eBR.CompanyLogs).insert(newLog);
    newLog.text = `New Company formed: ${companyDetails.companyName}`;
    newLog.type = "new_company";
    newLog.value = 8;
    await (0, $9esFv.addCompanyCompanyLogs)(newCompany, [
        newLog
    ]);
    // Add message from top superstar
    let topSuperstars = [
        ...newCompanySuperstars
    ].sort((a, b)=>b.popularity - a.popularity).slice(0, 3);
    let newMessage = await (0, $hekDR.createJoinedCompanySuperstarMessage)((0, $3E8Nt.getRandomChoice)(topSuperstars), game.monthCount, game.year);
    await (0, $9esFv.addCompanyMessages)(newCompany, [
        newMessage
    ]);
    // Add message from competitor
    let competitors = await $63f6dc8ca1007bd9$export$6662b06ad2b15a09(company, game);
    if (competitors.length) {
        let competitorMessage = await (0, $hekDR.createCustomStartingCompanyCompetitorMessage)((0, $3E8Nt.getRandomChoice)(competitors), game.monthCount, game.year);
        await (0, $9esFv.addCompanyMessages)(newCompany, [
            competitorMessage
        ]);
    }
    // Add message from owner about talent
    if (previousCompanySuperstarsToAdd.length || competitorSuperstarsToAdd.length) {
        let ownerMessage = await (0, $hekDR.createNewCompanyJoinedTalentMessage)(newCompanyData.ownerName, company.name, previousCompanySuperstarsToAdd, competitorSuperstarsToAdd, game.monthCount, game.year);
        await (0, $9esFv.addCompanyMessages)(newCompany, [
            ownerMessage
        ]);
    }
    // Reset newCompanyData for previous company, set as cpu
    company.newCompanyData = {};
    company.userControlled = false;
    if (game.settings["unlimited_creative_points"]) company.points = 10000;
    // Undo running buyouts
    for (let x of (await (0, $iRMwH.getGameActiveCompanies)(game)))if (x.operatingStatus.includes("Negotiating Buyout") || x.operatingStatus.includes("Running Buyout")) x.operatingStatus = "Buyout Available";
    // Transfer indie roster, annual tournaments and news to new user company (as its not main user company)
    await (0, $9esFv.addCompanyRosters)(newCompany, [
        indieRoster,
        indieAvailableRoster,
        indieFutureRoster
    ]);
    const annualTournaments = (await (0, $9esFv.getCompanyTournaments)(company)).filter((y)=>y.annualTournament);
    await (0, $9esFv.addCompanyTournaments)(newCompany, annualTournaments);
    const allNewsItems = await (0, $9esFv.getCompanyNewsItems)(company);
    await (0, $9esFv.addCompanyNewsItems)(newCompany, allNewsItems);
    // Set competitors present and market size, fans
    game.competitorsPresent = true;
    if (game.marketSize === null && (0, $98xmD.globalUser).paid) {
        game.marketSize = 4000000;
        const gameCompanies = await (0, $dBFC4.getGameCompanies)(game);
        const reputationXpLevels = {
            1: 0,
            2: 10,
            3: 30,
            4: 60,
            5: 100,
            6: 150,
            7: 210,
            8: 280,
            9: 360,
            10: 450,
            11: 550
        };
        let totalFans = gameCompanies.reduce((n, { fans: fans })=>n + fans, 0);
        for (const company of gameCompanies){
            company.fans = company.fans / totalFans * game.marketSize;
            company.fans = (0, $3E8Nt.myround)(company.fans, 1000);
            if (company.fans < 20000) company.fans = 20000;
            company.xp = reputationXpLevels[company.reputation];
            company.xp += (reputationXpLevels[company.reputation + 1] - company.xp) / 10.0;
        }
    }
    return data;
}
async function $63f6dc8ca1007bd9$var$createCompany(companyDetails, superstars, ownerName, startingEventIndex, previousCompany, game) {
    // Add company
    let company = (0, $9esFv.Company)();
    await (0, $14eBR.Companies).insert(company);
    await (0, $dBFC4.addGameCompanies)(game, [
        company
    ]);
    // Add details
    company.name = companyDetails.companyName;
    company.style = companyDetails.companyStyle;
    company.ownerName = ownerName;
    company.realYear = previousCompany.realYear;
    company.reputation = 5;
    company.highestReputation = 5;
    company.weeklyShowName = companyDetails.weeklyShowName;
    company.fans = (0, $3E8Nt.fanLevels)[company.reputation - 1];
    company.points = 2000;
    if (game.settings["unlimited_creative_points"]) company.points = 1000000;
    company.overness = 45 + (0, $3E8Nt.getRandomInt)(-3, 5);
    // Add fans/xp
    if (game.marketSize !== null) {
        // Add fans, percentage of market size
        company.fans = 0.0125 * company.reputation * game.marketSize;
        company.fans = (0, $3E8Nt.myround)(company.fans, 10000);
        // Increase market size
        game.marketSize += company.fans;
        // Add reputation xp
        company.xp = (0, $3E8Nt.reputationXpLevels)[company.reputation];
        company.xp += ((0, $3E8Nt.reputationXpLevels)[company.reputation + 1] - company.xp) / 10.0;
    }
    // Add events
    for (let eventData of companyDetails.companyMonthlyEventsData){
        let newEvent = (0, $iQtzn.Event)(eventData.name);
        await (0, $14eBR.Events).insert(newEvent);
        newEvent.prestige = eventData.prestige;
        newEvent.xp = (0, $3E8Nt.eventPrestigeXps)[eventData.prestige] || 0;
        await (0, $9esFv.addCompanyEvents)(company, [
            newEvent
        ]);
    }
    // Add starting event with prestige
    let events = await (0, $9esFv.getCompanyEvents)(company);
    let topEvent = (0, $3E8Nt.getArrayMaxByProperty)(events, "xp");
    let parentEvent = events[startingEventIndex];
    let prestige = parentEvent.prestige;
    let startingEventIsTop = parentEvent.$loki === topEvent.$loki;
    let hype = await (0, $5ZsVo.getEventHype)(parentEvent, startingEventIsTop);
    let startingEvent = (0, $iQtzn.Event)(parentEvent.name);
    await (0, $14eBR.Events).insert(startingEvent);
    startingEvent.prestige = prestige;
    startingEvent.hype = hype;
    await (0, $9esFv.addCompanyEvents)(company, [
        startingEvent
    ]);
    await (0, $iQtzn.addChildEvent)(parentEvent, startingEvent);
    // Set top event xp
    let topXps = {
        "A": 160,
        "B": 80,
        "C": 25
    };
    topEvent.xp = topXps[topEvent.prestige] || 0;
    // Add main roster
    let mainRoster = (0, $dl5u4.Roster)("main");
    await (0, $14eBR.Rosters).insert(mainRoster);
    await (0, $9esFv.addCompanyRosters)(company, [
        mainRoster
    ]);
    // Move superstars
    for (const superstar of superstars){
        let superstarCompany = await (0, $3E8Nt.getTalentCompany)(superstar);
        if (!superstarCompany) superstarCompany = previousCompany;
        await (0, $5kTkA.processSuperstarLeavingCompany)(superstar, superstarCompany, false, false, false);
        superstar.faceOfTheCompanyCounter = 0;
        superstar.suspensionMonths = 0;
        superstar.winsTemporary = 0;
        superstar.lossesTemporary = 0;
        for (const negotiation of (await (0, $hBIDz.getSuperstarNegotiations)(superstar)))await (0, $14eBR.Negotiations).remove(negotiation);
        // Process tag teams
        const superstarTagTeams = await (0, $hBIDz.getSuperstarTagTeams)(superstar);
        for (let tagTeam of superstarTagTeams){
            const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
            if (tagTeamSuperstars.every((x)=>(0, $3E8Nt.objectInArray)(x, superstars))) {
                await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
                    tagTeam
                ]);
                // Add company log
                const newLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
                (0, $14eBR.CompanyLogs).insert(newLog);
                newLog.text = tagTeam.name;
                newLog.value = 0;
                newLog.type = "signing";
                newLog.realYear = game.year;
                await (0, $9esFv.addCompanyCompanyLogs)(company, [
                    newLog
                ]);
            } else await (0, $ko5kE.removeTagTeam)(tagTeam);
        }
        // Add company log
        const newLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
        (0, $14eBR.CompanyLogs).insert(newLog);
        newLog.text = superstar.name;
        newLog.value = 0;
        newLog.type = "signing";
        newLog.realYear = game.year;
        await (0, $9esFv.addCompanyCompanyLogs)(company, [
            newLog
        ]);
    }
    await (0, $dl5u4.addRosterSuperstars)(mainRoster, superstars);
    // Add training roster
    let trainingRoster = (0, $dl5u4.Roster)("training");
    await (0, $14eBR.Rosters).insert(trainingRoster);
    await (0, $9esFv.addCompanyRosters)(company, [
        trainingRoster
    ]);
    let companyTrainingSuperstars = [];
    if (companyDetails.trainingRosterOption === "generate") for (let x of Array((0, $3E8Nt.getRandomInt)(10, 15)).keys()){
        let newSuperstar = await (0, $8bQDO.generateSuperstar)({
            generateGimmick: false
        });
        companyTrainingSuperstars.push(newSuperstar);
    }
    await (0, $dl5u4.addRosterSuperstars)(trainingRoster, companyTrainingSuperstars);
    // Add training available and future rosters
    let trainingAvailableRoster = (0, $dl5u4.Roster)("trainingAvailable");
    await (0, $14eBR.Rosters).insert(trainingAvailableRoster);
    await (0, $9esFv.addCompanyRosters)(company, [
        trainingAvailableRoster
    ]);
    let trainingFutureRoster = (0, $dl5u4.Roster)("trainingFuture");
    await (0, $14eBR.Rosters).insert(trainingFutureRoster);
    await (0, $9esFv.addCompanyRosters)(company, [
        trainingFutureRoster
    ]);
    // Add championships
    const divisionChampionshipsData = {
        "singles": 1,
        "tag-team": 2,
        "trio": 3
    };
    for (let [i, championshipData] of companyDetails.companyChampionshipsData.entries()){
        // Get number of championships
        let divisionChampionships = divisionChampionshipsData[championshipData["division"]] || 1;
        // Get graphic if present
        let graphic = null;
        if (championshipData.graphic) graphic = JSON.parse(championshipData.graphic);
        // Get rank
        let rankName;
        if (i === 0) rankName = "Main Eventer";
        else rankName = "Upper Midcarder";
        // Create championships and add to company
        for (let z of Array(divisionChampionships).keys()){
            let newChampionship = (0, $ivuOU.Championship)(championshipData.name);
            await (0, $14eBR.Championships).insert(newChampionship);
            if (graphic) newChampionship.graphic = graphic;
            newChampionship.rank = rankName;
            newChampionship.vacated = true;
            if (championshipData.division === "tag-team") newChampionship.tagTeam = true;
            else if (championshipData.division === "trio") newChampionship.trio = true;
            newChampionship.prestige = championshipData.prestige;
            newChampionship.highestPrestige = championshipData.prestige;
            newChampionship.xp = (0, $3E8Nt.championshipPrestigeXps)[championshipData.prestige] || 0;
            if (newChampionship.prestige !== "C") newChampionship.xp += 10; // Add xp over prestige base value
            await (0, $9esFv.addCompanyChampionships)(company, [
                newChampionship
            ]);
        }
    }
    // Add standard gimmick matches
    for (let x of (await (0, $9esFv.getCompanyGimmickMatches)(previousCompany))){
        let newGimmickMatch = {
            ...(0, $cYLJ6.GimmickMatch)(),
            ...JSON.parse(JSON.stringify(x))
        };
        delete newGimmickMatch.$loki;
        await (0, $14eBR.GimmickMatches).insert(newGimmickMatch);
        await (0, $9esFv.addCompanyGimmickMatches)(company, [
            newGimmickMatch
        ]);
    }
    // Add previous segment and feud items, powerups
    for (let x of (await (0, $9esFv.getCompanySegmentItems)(previousCompany))){
        let newSegmentItem = {
            ...(0, $cMrnz.SegmentItem)(),
            ...JSON.parse(JSON.stringify(x))
        };
        delete newSegmentItem.$loki;
        await (0, $14eBR.SegmentItems).insert(newSegmentItem);
        await (0, $9esFv.addCompanySegmentItems)(company, [
            newSegmentItem
        ]);
    }
    for (let x of (await (0, $9esFv.getCompanyFeudItems)(previousCompany))){
        let newFeudItem = {
            ...(0, $im36F.FeudItem)(),
            ...JSON.parse(JSON.stringify(x))
        };
        delete newFeudItem.$loki;
        await (0, $14eBR.FeudItems).insert(newFeudItem);
        await (0, $9esFv.addCompanyFeudItems)(company, [
            newFeudItem
        ]);
    }
    for (const x of (await (0, $9esFv.getCompanyPowerups)(previousCompany))){
        let newPowerup = {
            ...(0, $dfpYx.Powerup)(),
            ...JSON.parse(JSON.stringify(x))
        };
        delete newPowerup.$loki;
        await (0, $14eBR.Powerups).insert(newPowerup);
        await (0, $9esFv.addCompanyPowerups)(company, [
            newPowerup
        ]);
    }
    // Add staff and facilities
    let mainRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    await $63f6dc8ca1007bd9$export$ad001f2932d102e1(company, mainRosterSuperstars, null, game.settings, game.monthCount, game.year);
    // Add objectives
    let objectives = await (0, $5yA6U.generateCompanyObjectives)(company, game);
    await (0, $9esFv.addCompanyObjectives)(company, objectives);
    return company;
}
function $63f6dc8ca1007bd9$export$fe732773535a22d4(company, game) {
    if (company.newUserCompany) return company.month;
    return game.monthCount;
}
function $63f6dc8ca1007bd9$export$2c9c79c85a054651(company, game) {
    if (company.newUserCompany) return company.year;
    return game.year;
}

});
parcelRequire.register("5ZsVo", function(module, exports) {

$parcel$export(module.exports, "getLatestMonthlyEvent", () => $45c916186f207ab3$export$931bc177ba8c1741);
$parcel$export(module.exports, "getUpcomingMonthlyEventForWeeklyEvent", () => $45c916186f207ab3$export$2093faeea03db163);
$parcel$export(module.exports, "addWeeklyShow", () => $45c916186f207ab3$export$a532836f87843373);
$parcel$export(module.exports, "getParentEventForEvent", () => $45c916186f207ab3$export$560d4c97cc427f09);
$parcel$export(module.exports, "getNextEvent", () => $45c916186f207ab3$export$e224eaef75697910);
$parcel$export(module.exports, "getEventHype", () => $45c916186f207ab3$export$a95829736ebc7a40);
$parcel$export(module.exports, "getTopEvent", () => $45c916186f207ab3$export$9312fd3ae03903e0);
$parcel$export(module.exports, "getWeeklyEventName", () => $45c916186f207ab3$export$f7ff913218cb70f1);
$parcel$export(module.exports, "getEventMinimumMatchesAndSegments", () => $45c916186f207ab3$export$11155d02ed0faaa);
$parcel$export(module.exports, "getEventMaximumMatchesAndSegments", () => $45c916186f207ab3$export$d12231fd41bc9dc5);
$parcel$export(module.exports, "getEventMatchesData", () => $45c916186f207ab3$export$cb63a303318c2c2b);
$parcel$export(module.exports, "getEventSegmentsData", () => $45c916186f207ab3$export$f4e3fa4bed8b2677);
$parcel$export(module.exports, "getEventTitle", () => $45c916186f207ab3$export$e24dc4474d7582b4);
$parcel$export(module.exports, "getDatetimeForEvent", () => $45c916186f207ab3$export$75e901d8cc011e43);
$parcel$export(module.exports, "checkEventWithinDatetime", () => $45c916186f207ab3$export$cb255b0228b34214);
$parcel$export(module.exports, "getEventPosterData", () => $45c916186f207ab3$export$48165c9da2ae8f04);
$parcel$export(module.exports, "getEventPosterGraphicData", () => $45c916186f207ab3$export$ad3b7b3640187e2b);
$parcel$export(module.exports, "getViewEventsData", () => $45c916186f207ab3$export$6355d10ea03a8136);
$parcel$export(module.exports, "getStreakData", () => $45c916186f207ab3$export$101b1ff58353fb0a);
$parcel$export(module.exports, "getNielsenRatingFromViewership", () => $45c916186f207ab3$export$18605aa77cb3f0eb);
$parcel$export(module.exports, "getCompanyEventsData", () => $45c916186f207ab3$export$4e639cd701d08fec);
$parcel$export(module.exports, "rebrandEvent", () => $45c916186f207ab3$export$4d1698d96fdc315b);
$parcel$export(module.exports, "getEventCardData", () => $45c916186f207ab3$export$187af84c58b7b522);
$parcel$export(module.exports, "getEventMatchesAndSegments", () => $45c916186f207ab3$export$bd2cccaaf22fdcbc);
$parcel$export(module.exports, "playEvent", () => $45c916186f207ab3$export$f9702c88d617efa2);
$parcel$export(module.exports, "getSuperstarsUsedAtEvent", () => $45c916186f207ab3$export$56601633066b7859);
$parcel$export(module.exports, "endEventRequest", () => $45c916186f207ab3$export$d547f2efa298290d);
$parcel$export(module.exports, "calculateEventRating", () => $45c916186f207ab3$export$ad451c85840cb7c4);
$parcel$export(module.exports, "getEventPreviewMatchText", () => $45c916186f207ab3$export$c30622051d8fc8ec);
$parcel$export(module.exports, "generateJournalistData", () => $45c916186f207ab3$export$6817ac6e7f300c2b);

var $14eBR = parcelRequire("14eBR");

var $9esFv = parcelRequire("9esFv");

var $iQtzn = parcelRequire("iQtzn");

var $5kTkA = parcelRequire("5kTkA");

var $8A6FL = parcelRequire("8A6FL");

var $6RCLU = parcelRequire("6RCLU");

var $dl5u4 = parcelRequire("dl5u4");

var $1Dp0h = parcelRequire("1Dp0h");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $4EGpv = parcelRequire("4EGpv");

var $98xmD = parcelRequire("98xmD");

var $i7bmn = parcelRequire("i7bmn");

var $1JSre = parcelRequire("1JSre");

var $lhVvD = parcelRequire("lhVvD");

var $1AAHK = parcelRequire("1AAHK");

var $4K85d = parcelRequire("4K85d");

var $4ptHI = parcelRequire("4ptHI");

var $eg5dz = parcelRequire("eg5dz");

var $dGbip = parcelRequire("dGbip");

var $kZwpB = parcelRequire("kZwpB");

var $6hwt2 = parcelRequire("6hwt2");

var $18vSN = parcelRequire("18vSN");

var $bZol7 = parcelRequire("bZol7");

var $972Ip = parcelRequire("972Ip");

var $3MfBd = parcelRequire("3MfBd");
function $45c916186f207ab3$export$18c23d95653bd725(monthlyEvent, parentEvents) {
    // Get next monthly event from parent events
    let monthlyEventIndex = parentEvents.findIndex((x)=>x.$loki === monthlyEvent.$loki) + 1;
    if (monthlyEventIndex >= parentEvents.length) monthlyEventIndex = 0;
    return parentEvents[monthlyEventIndex];
}
async function $45c916186f207ab3$export$d6979cc03f7bb678(weeklyEvent, parentEvents, company) {
    // Find parent monthly event
    let monthlyEvent = parentEvents.find((x)=>x.name === weeklyEvent.monthlyEventName);
    // If name changed, get latest monthly event and then its parent event
    if (!monthlyEvent) {
        let companyEvents = await (0, $9esFv.getCompanyEvents)(company);
        let latestMonthlyEvent = $45c916186f207ab3$export$931bc177ba8c1741(companyEvents);
        monthlyEvent = await (0, $iQtzn.getParentEvent)(latestMonthlyEvent);
        // Get monthly event after latest if weekly show before monthly or at monthly event
        if (weeklyEvent.weekNumber < 0 || weeklyEvent.weekNumber === null) monthlyEvent = $45c916186f207ab3$export$18c23d95653bd725(monthlyEvent, parentEvents);
    }
    return monthlyEvent;
}
async function $45c916186f207ab3$export$2093faeea03db163(weeklyEvent, parentEvents, company) {
    let upcomingMonthlyEvent = await $45c916186f207ab3$export$d6979cc03f7bb678(weeklyEvent, parentEvents, company);
    // If weekly show after monthly event, get next monthly event
    if (weeklyEvent.weekNumber > 0) upcomingMonthlyEvent = $45c916186f207ab3$export$18c23d95653bd725(upcomingMonthlyEvent, parentEvents);
    return upcomingMonthlyEvent;
}
function $45c916186f207ab3$export$931bc177ba8c1741(events) {
    // Sorts events by latest first
    let sortedEvents = events.slice().sort((a, b)=>b.$loki - a.$loki);
    let latestMonthlyEvent;
    for (const x of sortedEvents)if (!x.weeklyShow && x.name !== "Weekly Show" && !x.temporaryEvent) {
        latestMonthlyEvent = x;
        break;
    }
    return latestMonthlyEvent;
}
async function $45c916186f207ab3$var$getNextEventFromCurrentEvent(currentEvent, parentEvents, company, numberOfWeeklyShows, weeklyShowName) {
    let roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let rosterBrands = await (0, $dl5u4.getRosterBrands)(roster);
    let firstBrand = rosterBrands.length ? rosterBrands[0] : null;
    let nextEvent;
    // If currentEvent is weekly event
    if (currentEvent.weeklyShow && currentEvent.monthlyEventName) {
        let monthlyEvent = await $45c916186f207ab3$export$d6979cc03f7bb678(currentEvent, parentEvents, company);
        let finalWeekNumber = Math.floor(numberOfWeeklyShows / 2);
        // If at brand's weekly event and next brand is present,
        // add weekly show for next brand with same attributes as current event
        let currentBrandIndex = (0, $1Dp0h.getBrandIndexForWeeklyShow)(currentEvent, rosterBrands);
        if (currentBrandIndex !== null && currentBrandIndex + 1 < rosterBrands.length) {
            let nextBrand = rosterBrands[currentBrandIndex + 1];
            nextEvent = await $45c916186f207ab3$export$a532836f87843373(weeklyShowName, currentEvent.monthlyEventName, currentEvent.weekNumber, nextBrand);
        } else {
            // Weekly show after monthly event
            if (currentEvent.weekNumber > 0) {
                // If this show is final week number, add weekly show before next monthly event
                if (currentEvent.weekNumber >= finalWeekNumber) {
                    monthlyEvent = $45c916186f207ab3$export$18c23d95653bd725(monthlyEvent, parentEvents);
                    if (monthlyEvent.weeklyShowBeforeName) weeklyShowName = monthlyEvent.weeklyShowBeforeName;
                    // If 3 or more weekly shows per month, hold 2 shows before monthly event.
                    // If less than 3 weekly shows per month, hold 1 event before monthly event.
                    let weekNumber = numberOfWeeklyShows >= 3 ? -2 : -1;
                    nextEvent = await $45c916186f207ab3$export$a532836f87843373(weeklyShowName, monthlyEvent.name, weekNumber, firstBrand);
                } else {
                    if (monthlyEvent.weeklyShowAfterName) weeklyShowName = monthlyEvent.weeklyShowAfterName;
                    nextEvent = await $45c916186f207ab3$export$a532836f87843373(weeklyShowName, monthlyEvent.name, 2, firstBrand);
                }
            } else // If week right before monthly event, add upcoming monthly event
            if (currentEvent.weekNumber === -1) nextEvent = await $45c916186f207ab3$var$addMonthlyEvent(monthlyEvent, parentEvents);
            else {
                if (monthlyEvent.weeklyShowBeforeName) weeklyShowName = monthlyEvent.weeklyShowBeforeName;
                nextEvent = await $45c916186f207ab3$export$a532836f87843373(weeklyShowName, monthlyEvent.name, -1, firstBrand);
            }
        }
    } else {
        let monthlyEvent = await $45c916186f207ab3$export$560d4c97cc427f09(parentEvents, currentEvent);
        // Add weekly show if running weekly shows
        if (numberOfWeeklyShows > 0) {
            let weekNumber;
            // If running one weekly show per month, add weekly show before next monthly event
            if (numberOfWeeklyShows === 1) {
                weekNumber = -1;
                monthlyEvent = $45c916186f207ab3$export$18c23d95653bd725(monthlyEvent, parentEvents);
            } else weekNumber = 1;
            // Add weekly show
            if (monthlyEvent.weeklyShowAfterName) weeklyShowName = monthlyEvent.weeklyShowAfterName;
            nextEvent = await $45c916186f207ab3$export$a532836f87843373(weeklyShowName, monthlyEvent.name, weekNumber, firstBrand);
        } else {
            monthlyEvent = $45c916186f207ab3$export$18c23d95653bd725(monthlyEvent, parentEvents);
            nextEvent = await $45c916186f207ab3$var$addMonthlyEvent(monthlyEvent, parentEvents);
        }
    }
    return nextEvent;
}
async function $45c916186f207ab3$export$e224eaef75697910(currentEvent, parentEvents, company, numberOfWeeklyShows = 2) {
    // Get weekly show name
    let weeklyShowName = company.weeklyShowName;
    if (!weeklyShowName) weeklyShowName = `${(0, $1JSre.formatCompanyNameBackend)(company.name)} Weekly`;
    let nextEvent = await $45c916186f207ab3$var$getNextEventFromCurrentEvent(currentEvent, parentEvents, company, numberOfWeeklyShows, weeklyShowName);
    // Add next event boost
    if (currentEvent.nextEventBoost && nextEvent.weeklyShow) // Carry over boost until next monthly event
    nextEvent.nextEventBoost = currentEvent.nextEventBoost;
    // Continue allow_other_brands_extended active effect until monthly show
    if (currentEvent.activeEffect === "allow_other_brands_extended") {
        if (nextEvent.weeklyShow) nextEvent.activeEffect = "allow_other_brands_extended";
        else nextEvent.activeEffect = "allow_other_brands";
    }
    return nextEvent;
}
async function $45c916186f207ab3$export$a532836f87843373(name, monthlyEventName, weekNumber, brand = null) {
    if (brand) name = brand.weeklyShowName;
    let weeklyShow = (0, $iQtzn.Event)(name);
    await (0, $14eBR.Events).insert(weeklyShow);
    weeklyShow.weeklyShow = true;
    weeklyShow.monthlyEventName = monthlyEventName;
    weeklyShow.weekNumber = weekNumber;
    if (brand && brand.weeklyShowIsExclusive) weeklyShow.brandName = brand.name;
    return weeklyShow;
}
async function $45c916186f207ab3$var$addMonthlyEvent(parentEvent, parentEvents) {
    let prestige = parentEvent.prestige;
    let topEvent = parentEvent.$loki === (0, $3E8Nt.getArrayMaxByProperty)(parentEvents, "xp").$loki;
    let hype = await $45c916186f207ab3$export$a95829736ebc7a40(parentEvent, topEvent);
    let monthlyEvent = (0, $iQtzn.Event)(parentEvent.name);
    await (0, $14eBR.Events).insert(monthlyEvent);
    monthlyEvent.prestige = prestige;
    monthlyEvent.hype = hype;
    monthlyEvent.brandName = parentEvent.brandName;
    (0, $iQtzn.addChildEvent)(parentEvent, monthlyEvent);
    return monthlyEvent;
}
function $45c916186f207ab3$export$9312fd3ae03903e0(parentEvents) {
    return parentEvents.reduce((prev, current)=>{
        return prev.xp > current.xp ? prev : current;
    });
}
function $45c916186f207ab3$export$f7ff913218cb70f1(event, nextMonthlyEvent, numberOfWeeklyShows) {
    if (event.monthlyEventName) {
        let numberOfShowsRemaining;
        let nextEventName = nextMonthlyEvent.name;
        // Get number of shows remaining till monthly event
        if (event.weekNumber === null) // One show remaining if tournament or cash in weekly show
        numberOfShowsRemaining = 1;
        else if (event.weekNumber < 0) {
            // If weekly show before monthly
            numberOfShowsRemaining = Math.abs(event.weekNumber);
            nextEventName = event.monthlyEventName;
        } else // If weekly show after monthly
        numberOfShowsRemaining = numberOfWeeklyShows - event.weekNumber + 1;
        let showsWord = numberOfShowsRemaining !== 1 ? "Shows" : "Show";
        return `${numberOfShowsRemaining} ${showsWord} to ${nextEventName}`;
    }
    return null;
}
function $45c916186f207ab3$export$11155d02ed0faaa(event, parentEvents, rosterSuperstars) {
    let minimumMatchesAndSegments;
    // Get minimum based on event prestige
    if (event.weeklyShow || event.name === "Weekly Show") {
        // If weekly event
        minimumMatchesAndSegments = 4;
        let monthlyEvent = parentEvents.find((x)=>x.name === event.monthlyEventName);
        if (monthlyEvent) {
            let minLimits = {
                "A": 4,
                "B": 3,
                "C": 2,
                "default": 2
            };
            minimumMatchesAndSegments = minLimits[monthlyEvent.prestige] || minLimits["default"];
        }
    } else {
        // If monthly event
        let minLimits = {
            "A": 6,
            "B": 5,
            "C": 4,
            "default": 4
        };
        minimumMatchesAndSegments = minLimits[event.prestige] || minLimits["default"];
        // Lower minimum if superstars available are low
        let availableSuperstars = rosterSuperstars.filter((x)=>(0, $5kTkA.checkAvailability)(x, false) && (0, $5kTkA.checkSuperstarBrandAvailability)(event, x));
        let superstarsNeeded = minimumMatchesAndSegments * 3;
        if (availableSuperstars.length < superstarsNeeded) minimumMatchesAndSegments = availableSuperstars.length / 3;
        if (minimumMatchesAndSegments < 1) minimumMatchesAndSegments = 1;
    }
    return parseInt(minimumMatchesAndSegments);
}
function $45c916186f207ab3$export$d12231fd41bc9dc5(event, parentEvents, productionFacility) {
    let maximumMatchesAndSegments;
    // Get maximum based on event prestige
    if (event.weeklyShow || event.name === "Weekly Show") {
        // If weekly event
        maximumMatchesAndSegments = 6;
        let monthlyEvent = parentEvents.find((x)=>x.name === event.monthlyEventName);
        if (monthlyEvent) {
            let maxLimits = {
                "A": 8,
                "B": 7,
                "C": 6,
                "default": 6
            };
            maximumMatchesAndSegments = maxLimits[monthlyEvent.prestige] || maxLimits["default"];
        }
    } else {
        // If monthly event
        let maxLimits = {
            "A": 12,
            "B": 11,
            "C": 10,
            "default": 10
        };
        maximumMatchesAndSegments = maxLimits[event.prestige] || maxLimits["default"];
    }
    // Increase maximum if artifact used on event
    if (event.activeEffect === "increase_matches") maximumMatchesAndSegments += 2;
    // Increase maximum depending on production facility's level
    if (productionFacility && productionFacility.level >= 2) maximumMatchesAndSegments += (productionFacility.level - 1) * 2;
    return maximumMatchesAndSegments;
}
async function $45c916186f207ab3$export$cb63a303318c2c2b({ event: event, rosterSuperstars: rosterSuperstars = null, cashinSingles: cashinSingles = false, cashinTag: cashinTag = false, cashinTrios: cashinTrios = false, history: history = false, getChampionshipsAvailable: getChampionshipsAvailable = true, play: play = false, game: game = null } = {}) {
    let matchesData = [];
    let eventMatches = await (0, $iQtzn.getEventMatches)(event);
    let company = await (0, $iQtzn.getEventCompany)(event);
    if (eventMatches.length > 0) {
        const sortedMatches = eventMatches.sort((a, b)=>b.order - a.order);
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
        if (!rosterSuperstars) rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        // Get company championships
        const companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
        for (const match of sortedMatches){
            const matchData = await (0, $6RCLU.getMatchData)({
                match: match,
                cashinSingles: cashinSingles,
                cashinTag: cashinTag,
                cashinTrios: cashinTrios,
                history: history,
                getChampionshipsAvailable: getChampionshipsAvailable,
                play: play,
                companyChampionships: companyChampionships,
                rosterSuperstars: rosterSuperstars,
                game: game
            });
            matchesData.push(matchData);
        }
    }
    return matchesData;
}
async function $45c916186f207ab3$export$f4e3fa4bed8b2677({ event: event, play: play = false, history: history = false, rosterSuperstars: rosterSuperstars = null, producers: producers = null } = {}) {
    let segmentsData = [];
    let eventSegments = await (0, $iQtzn.getEventSegments)(event);
    let company = await (0, $iQtzn.getEventCompany)(event);
    if (eventSegments.length > 0) {
        const sortedSegments = eventSegments.sort((a, b)=>b.order - a.order);
        // Get roster superstars if not present
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
        if (!rosterSuperstars) rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        for (const segment of sortedSegments){
            const segmentData = await (0, $4ptHI.getSegmentData)({
                segment: segment,
                pronouns: true,
                play: play,
                history: history,
                rosterSuperstars: rosterSuperstars,
                producers: producers
            });
            segmentsData.push(segmentData);
        }
    }
    return segmentsData;
}
async function $45c916186f207ab3$export$e511c8e09be6c90d(event, isTopEvent = null, rosterBrands = null) {
    const company = await (0, $iQtzn.getEventCompany)(event);
    let baseHype;
    // Get hype for weekly show
    if (event.weeklyShow || event.name === "Weekly Show") {
        baseHype = 0;
        if (company.hot) baseHype += 10;
    } else {
        const baseHypes = {
            "A": 60,
            "B": 20,
            "C": 5,
            "default": 0
        };
        baseHype = baseHypes[event.prestige] || baseHypes["default"];
        if (isTopEvent) baseHype += 90;
        if (company.hot) baseHype += 30;
    }
    // Add brand hype
    baseHype += $45c916186f207ab3$var$getEventBrandHype(event, rosterBrands);
    return baseHype;
}
function $45c916186f207ab3$var$getEventBrandHype(event, rosterBrands) {
    let brandHype = 0;
    if (rosterBrands) {
        const eventBrand = (0, $1Dp0h.getBrandForEvent)(event, rosterBrands);
        if (eventBrand) {
            // For weekly shows, add overness effect
            if (event.weeklyShow) brandHype += -35 + (0, $3E8Nt.myround)(eventBrand.overness, 10);
            else {
                if (eventBrand.hot) brandHype += 15;
                else if (eventBrand.stale) brandHype += -20;
            }
        }
    }
    return brandHype;
}
function $45c916186f207ab3$export$e24dc4474d7582b4(event) {
    // Get month name
    let monthName = "";
    if (event.month !== null && !event.temporaryEvent) {
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        monthName = " - " + monthNames[event.month].slice(0, 3);
    }
    // Get year
    let eventYear = event.year ? " " + event.year : "";
    // Get title
    return `${event.name}${monthName}${eventYear}`;
}
function $45c916186f207ab3$export$75e901d8cc011e43(event, rosterBrands) {
    const year = event.year;
    const month = event.month;
    const firstSunday = (0, $3E8Nt.getFirstSunday)(year, month);
    if (event.weeklyShow) {
        // Get day for weekly show based on brand order if present
        const currentBrandIndex = (0, $1Dp0h.getBrandIndexForWeeklyShow)(event, rosterBrands);
        let weeklyEventDay = new Date(firstSunday);
        if (currentBrandIndex === 0 || currentBrandIndex === null) // Get first monday
        weeklyEventDay = new Date(weeklyEventDay.setDate(firstSunday.getDate() + 1));
        else if (currentBrandIndex === 1) // Get first wednesday
        weeklyEventDay = new Date(weeklyEventDay.setDate(firstSunday.getDate() + 3));
        else if (currentBrandIndex === 2) // Get first friday
        weeklyEventDay = new Date(weeklyEventDay.setDate(firstSunday.getDate() + 5));
        // Get increasing weeks based on weeklyEventDay
        if (event.weekNumber === -2) {
            weeklyEventDay.setDate(weeklyEventDay.getDate() + 14);
            return weeklyEventDay;
        } else if (event.weekNumber === -1) {
            weeklyEventDay.setDate(weeklyEventDay.getDate() + 21);
            return weeklyEventDay;
        } else if (event.weekNumber === 1) return weeklyEventDay;
        else if (event.weekNumber === 2) {
            weeklyEventDay.setDate(weeklyEventDay.getDate() + 7);
            return weeklyEventDay;
        }
    } else // Get first sunday for monthly event
    return firstSunday;
    return new Date();
}
function $45c916186f207ab3$export$cb255b0228b34214(eventDatetime, datetimeToCheck, timePeriod) {
    if (timePeriod === "all") return true;
    const numberOfMonths = parseInt(timePeriod);
    let latestDate = new Date(datetimeToCheck.getTime());
    latestDate.setMonth(datetimeToCheck.getMonth() - numberOfMonths);
    return eventDatetime >= latestDate;
}
async function $45c916186f207ab3$export$560d4c97cc427f09(parentEvents, event) {
    let parentEvent = parentEvents.find((x)=>x.name === event.name);
    if (!parentEvent) parentEvent = await (0, $iQtzn.getParentEvent)(event);
    return parentEvent;
}
async function $45c916186f207ab3$export$48165c9da2ae8f04(eventUid, annualTournamentUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get event or annual tournament
    let annualTournament;
    let event;
    if (annualTournamentUid) {
        annualTournament = await (0, $14eBR.Tournaments).get(annualTournamentUid);
        event = await (0, $4EGpv.getTournamentEvent)(annualTournament);
    } else event = await (0, $14eBR.Events).get(eventUid);
    // Check if event found
    if (!event) {
        data["error"] = "event-not-found";
        return data;
    }
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Check if poster present
    if (!event.posterGraphic || Object.keys(event.posterGraphic).length === 0) {
        data["error"] = "poster-not-present";
        return data;
    }
    // Get poster data
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(userCompany);
    const parentEvent = await $45c916186f207ab3$export$560d4c97cc427f09(parentEvents, event);
    const eventMatches = await (0, $iQtzn.getEventMatches)(event);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    data["eventPosterGraphicData"] = await $45c916186f207ab3$export$ad3b7b3640187e2b(event, eventMatches, companyChampionships, parentEvent, annualTournament);
    return data;
}
async function $45c916186f207ab3$export$ad3b7b3640187e2b(event, eventMatches, companyChampionships, parentEvent, annualTournament = null) {
    let data = {};
    let eventRandom = new Math.seedrandom(event.meta.created); // Use to get poster and keep it the same
    if (annualTournament) companyChampionships = [];
    // On night 2 of annual tournament, use night 1 for random instance and to duplicate poster graphic
    if (annualTournament && event.name[event.name.length - 1] === "2") {
        const tournamentMatches = await (0, $4EGpv.getTournamentMatches)(annualTournament);
        let night1Event;
        for (const tournamentMatch of tournamentMatches){
            const matchEvent = await (0, $i7bmn.getMatchEvent)(tournamentMatch);
            if (matchEvent.$loki !== event.$loki) {
                night1Event = matchEvent;
                break;
            }
        }
        eventRandom = new Math.seedrandom(night1Event.meta.created);
        event.posterGraphic = night1Event.posterGraphic;
    }
    // Get superstar weights
    const superstarWeights = await $45c916186f207ab3$var$getEventPosterSuperstarWeights(eventMatches, companyChampionships);
    // Get poster type
    let posterTypeData = (0, $3E8Nt.getRandomChoice)((0, $3E8Nt.eventPostersData), eventRandom());
    if (annualTournament) posterTypeData = (0, $3E8Nt.getRandomChoice)((0, $3E8Nt.annualTournamentPostersData), eventRandom());
    // Load poster graphics if present
    if (event.posterGraphic && Object.keys(event.posterGraphic).length !== 0) {
        data["graphics"] = event.posterGraphic;
        // Match poster data to poster graphics (used for games imported with different event ids)
        if (data["graphics"].length !== posterTypeData["numberOfSuperstars"]) {
            posterTypeData = (0, $3E8Nt.eventPostersData).find((x)=>data["graphics"].length === x["numberOfSuperstars"]);
            if (!posterTypeData) return null // Don't show poster if not enough superstars
            ;
        }
    } else {
        // Get poster with fewer number of superstars if not enough for selected poster
        if (superstarWeights.length < posterTypeData["numberOfSuperstars"]) {
            posterTypeData = (0, $3E8Nt.eventPostersData).find((x)=>superstarWeights.length >= x["numberOfSuperstars"]);
            if (!posterTypeData) return null // Don't show poster if not enough superstars
            ;
        }
        const posterSuperstars = $45c916186f207ab3$var$getEventPosterSuperstars(eventRandom, superstarWeights, posterTypeData);
        data["graphics"] = $45c916186f207ab3$var$getEventPosterGraphics(posterSuperstars, companyChampionships);
    }
    // Get other poster data
    data["styleData"] = $45c916186f207ab3$var$getPosterStyleData(event, parentEvent);
    data["eventName"] = event.name;
    data["eventYear"] = annualTournament ? "" : event.year;
    data["type"] = posterTypeData["type"];
    data["annualTournament"] = !!annualTournament;
    return data;
}
function $45c916186f207ab3$var$getEventPosterSuperstars(eventRandom, superstarWeights, posterTypeData) {
    // Get top superstars
    const posterSuperstars = [];
    const numberOfSuperstars = posterTypeData.numberOfSuperstars;
    for(let x = 0; x < numberOfSuperstars; x++){
        const selection = (0, $3E8Nt.weightedChoice)(superstarWeights, eventRandom());
        posterSuperstars.push(selection);
        superstarWeights = superstarWeights.filter((y)=>y[0].$loki !== selection.$loki);
    }
    // Get superstars in specific order for annual tournament
    if (posterTypeData.type === 5) posterSuperstars.sort((a, b)=>{
        const orderMapping = {
            1: 12,
            2: 11,
            3: 14,
            4: 9,
            5: 10,
            6: 13,
            7: 15,
            8: 8,
            9: 2,
            10: 5,
            11: 1,
            12: 7,
            13: 4,
            14: 3,
            15: 6,
            16: 0
        };
        return (orderMapping[a.tournamentSeed] ?? 20) - (orderMapping[b.tournamentSeed] ?? 20);
    });
    if (posterTypeData.type === 6) posterSuperstars.sort((a, b)=>{
        const orderMapping = {
            1: 13,
            2: 14,
            3: 15,
            4: 12,
            5: 0,
            6: 2,
            7: 1,
            8: 3,
            9: 11,
            10: 8,
            11: 10,
            12: 9,
            13: 5,
            14: 7,
            15: 6,
            16: 4
        };
        return (orderMapping[a.tournamentSeed] ?? 20) - (orderMapping[b.tournamentSeed] ?? 20);
    });
    if (posterTypeData.type === 7) posterSuperstars.sort((a, b)=>{
        const orderMapping = {
            1: 2,
            2: 3,
            3: 1,
            4: 4,
            5: 6,
            6: 7,
            7: 5,
            8: 8,
            9: 9,
            10: 10,
            11: 11,
            12: 12,
            13: 13,
            14: 14,
            15: 15,
            16: 16
        };
        return (orderMapping[a.tournamentSeed] ?? 20) - (orderMapping[b.tournamentSeed] ?? 20);
    });
    return posterSuperstars;
}
function $45c916186f207ab3$var$getEventPosterGraphics(posterSuperstars, companyChampionships) {
    const graphics = [];
    // Get graphics for top superstars with titles
    for (const superstar of posterSuperstars){
        // Get attire or graphic if present, otherwise get empty graphic
        let superstarGraphic = JSON.parse(JSON.stringify(superstar.graphic));
        if (superstarGraphic) {
            if (superstar.currentAttire > 0 && superstarGraphic["alternate_attires"]) superstarGraphic = superstarGraphic["alternate_attires"][superstar.currentAttire - 1];
        } else superstarGraphic = (0, $5kTkA.getEmptySuperstarGraphic)(superstar);
        // Get championship graphic
        const superstarChampionship = companyChampionships.find((c)=>c.superstarId === superstar.$loki);
        if (superstarChampionship && typeof superstarGraphic === "object") superstarGraphic["title"] = JSON.parse(JSON.stringify(superstarChampionship.graphic));
        graphics.push(superstarGraphic);
    }
    return graphics;
}
async function $45c916186f207ab3$var$getEventPosterSuperstarWeights(eventMatches, companyChampionships) {
    const superstarWeights = [];
    const mainEventMatchId = eventMatches.length ? eventMatches.reduce((prev, current)=>{
        return prev.order < current.order ? prev : current;
    }).$loki : null;
    // Get superstar weights using event matches
    for (const match of eventMatches){
        const matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
        const matchSuperstars = (await Promise.all(matchParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        for (const superstar of matchSuperstars){
            if (superstarWeights.find((x)=>x[0].$loki === superstar.$loki)) continue; // Don't add superstar to weights more than once
            const superstarChampionships = companyChampionships.filter((x)=>x.superstarId === superstar.$loki);
            let weight = Math.pow(superstar.popularity / 100, 2);
            if (superstar.hot) weight *= 5;
            if (superstar.faceOfTheCompany) weight *= 5;
            if (superstarChampionships.length > 0) weight *= 10;
            if (match.$loki === mainEventMatchId) weight *= 100;
            if (!superstar.graphic || Object.keys(superstar.graphic).length === 0 || superstar.graphic["empty_graphic"]) weight /= 1000;
            superstarWeights.push([
                superstar,
                weight
            ]);
        }
    }
    return superstarWeights;
}
function $45c916186f207ab3$var$getPosterStyleData(event, parentEvent) {
    let data = {};
    let eventRandom = new Math.seedrandom(event.meta.created);
    let parentEventRandom = parentEvent ? new Math.seedrandom(parentEvent.meta.created) : Math.random; // Use to get poster font
    // Get background object
    let backgroundObjectChoices = [
        [
            0,
            25
        ],
        [
            1,
            14
        ],
        [
            2,
            14
        ],
        [
            3,
            14
        ],
        [
            4,
            7
        ]
    ];
    if (event.prestige === "A") // Unique gradient choice for A prestige events
    backgroundObjectChoices.push(...[
        [
            5,
            10
        ],
        [
            6,
            10
        ],
        [
            7,
            10
        ],
        [
            8,
            10
        ]
    ]);
    let backgroundObject = (0, $3E8Nt.weightedChoice)(backgroundObjectChoices, eventRandom());
    // POW premier event background
    if (event.activeEffect === "premier_event") backgroundObject = 9;
    let backgroundColor;
    if (backgroundObject === 0) // Single color solid background
    backgroundColor = (0, $3E8Nt.getRandomChoice)([
        "151414",
        "151414",
        "151414",
        "151414",
        "2F1442",
        "0C2240",
        "400309",
        "102F3B",
        "400D26"
    ], eventRandom());
    else if (backgroundObject === 4) // Single color solid background
    backgroundColor = (0, $3E8Nt.getRandomChoice)([
        "2F1442",
        "0C2240",
        "400309",
        "11324F",
        "42083E"
    ], eventRandom());
    else if ([
        1,
        2,
        3
    ].indexOf(backgroundObject) >= 0) // Gradient background
    backgroundColor = (0, $3E8Nt.getRandomChoice)([
        "7F6F16",
        "631919",
        "182A60",
        "1F567D",
        "19425F",
        "3C1762",
        "343A70",
        "3D4D59",
        "704234",
        "342B57",
        "4F2635",
        "59513D",
        "28473E"
    ], eventRandom());
    else // Special background, original color only
    backgroundColor = "FFFFFF";
    // Get font family object and color
    const fontFamilyObject = (0, $3E8Nt.getRandomInt)(0, 6, parentEventRandom());
    let fontColor;
    if (backgroundColor === "151414") // Add colored fonts if solid black background
    fontColor = (0, $3E8Nt.getRandomChoice)([
        "FFFFFF",
        "FFFFFF",
        "FFFFFF",
        "A51818",
        "1568D4",
        "4D44FC",
        "7440B8",
        "C8B963",
        "BD5909"
    ], eventRandom());
    else fontColor = "F7F7F7";
    // Get text position
    const textPosition = (0, $3E8Nt.weightedChoice)([
        [
            "top",
            70
        ],
        [
            "bottom",
            30
        ]
    ], eventRandom());
    // Get data to return
    data["backgroundObject"] = backgroundObject;
    data["backgroundColor"] = backgroundColor;
    data["fontFamilyObject"] = fontFamilyObject;
    data["fontColor"] = fontColor;
    data["textPosition"] = textPosition;
    return data;
}
async function $45c916186f207ab3$export$6355d10ea03a8136(companyUid, eventUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get events
    const companyEvents = await (0, $9esFv.getCompanyEvents)(selectedCompany);
    const parentEvents = companyEvents.slice(0, 12);
    const nonParentEvents = companyEvents.slice(12);
    // Get event by uid
    let event;
    if (eventUid) event = await (0, $14eBR.Events).get(eventUid);
    else {
        event = companyEvents[companyEvents.length - 2];
        if (event.rating === null) event = companyEvents[companyEvents.length - 1];
    }
    data["event"] = await $45c916186f207ab3$var$getEventData(event, parentEvents, selectedCompany, currentGame);
    // Get ids for next and previous events if present
    const eventIndex = nonParentEvents.indexOf(nonParentEvents.find((x)=>x.$loki === event.$loki));
    if (eventIndex < nonParentEvents.length - 2) data["nextEventId"] = nonParentEvents[eventIndex + 1].$loki;
    if (eventIndex > 0) data["previousEventId"] = nonParentEvents[eventIndex - 1].$loki;
    // Get year/uid for each year event was held
    data["years"] = [];
    if (!event.weeklyShow) {
        const eventIterations = await $45c916186f207ab3$var$getEventIterations(event, nonParentEvents);
        data["years"] = eventIterations.filter((y)=>y.year !== null && y.rating !== null).map((x)=>{
            return {
                "year": x.year,
                "uid": x.$loki
            };
        });
        data["years"] = [
            ...new Set(data["years"])
        ];
    }
    // Get prestige info for monthly event
    const parentEvent = await $45c916186f207ab3$export$560d4c97cc427f09(parentEvents, event);
    if (parentEvent) {
        data["event"]["prestige"] = parentEvent.prestige;
        data["event"]["xp"] = parentEvent.xp;
        data["event"]["baseXp"] = (0, $3E8Nt.eventPrestigeXps)[parentEvent.prestige];
        data["event"]["xpToNextPrestige"] = parentEvent.prestige === "C" ? 40 : 110;
        data["event"]["topEvent"] = parentEvent.$loki === $45c916186f207ab3$export$9312fd3ae03903e0(parentEvents).$loki;
        // Get match contracts for this event
        const matchContracts = await (0, $iQtzn.getEventMatchContracts)(parentEvent);
        data["event"]["matchContracts"] = await Promise.all(matchContracts.map((x)=>$45c916186f207ab3$var$getMatchContractData(x)));
        // Get streaks and match effects if paid
        data["event"]["streaks"] = [];
        data["event"]["matchEffects"] = [];
        if ((0, $98xmD.globalUser).paid) {
            if (parentEvent.prestige === "A") {
                const streaks = await (0, $iQtzn.getEventStreaks)(parentEvent);
                data["event"]["streaks"] = await Promise.all(streaks.map((x)=>$45c916186f207ab3$export$101b1ff58353fb0a(x)));
                data["event"]["streaks"].sort((a, b)=>b.length - a.length);
            }
            // Get match effects
            const eventGimmickMatchPoints = await $45c916186f207ab3$var$getEventGimmickMatchPoints(event, companyEvents);
            for (const [key, value] of Object.entries(eventGimmickMatchPoints))data["event"]["matchEffects"].push({
                "gimmickMatch": key,
                "bonus": $45c916186f207ab3$var$getGimmickMatchBonusFromPoints(value),
                "points": value
            });
            data["event"]["matchEffects"].sort((a, b)=>{
                if (a.bonus !== 0 && b.bonus === 0) return -1;
                if (a.bonus === 0 && b.bonus !== 0) return 1;
                return b.bonus - a.bonus;
            });
        }
    }
    return data;
}
async function $45c916186f207ab3$var$getEventIterations(event, nonParentEvents) {
    let eventIterations = nonParentEvents.filter((x)=>x.name === event.name);
    // Get child/sibling events
    let childEvents;
    const eventParent = await (0, $iQtzn.getParentEvent)(event);
    if (eventParent) childEvents = await (0, $iQtzn.getChildEvents)(eventParent);
    else childEvents = await (0, $iQtzn.getChildEvents)(event);
    eventIterations.push(...childEvents);
    eventIterations = (0, $3E8Nt.getUniqueObjects)(eventIterations);
    eventIterations.sort((a, b)=>a.$loki - b.$loki);
    return eventIterations;
}
async function $45c916186f207ab3$var$getEventData(event, parentEvents, company, game) {
    let data = {};
    data["name"] = event.name;
    data["year"] = event.year;
    data["rating"] = event.rating;
    data["pointsEarned"] = event.pointsEarned;
    data["fansGained"] = event.fansGained;
    data["hype"] = event.hype;
    data["viewership"] = event.viewership;
    data["weeklyShow"] = event.weeklyShow;
    data["brandName"] = event.brandName;
    data["weeklyShowBeforeName"] = event.weeklyShowBeforeName;
    data["weeklyShowAfterName"] = event.weeklyShowAfterName;
    data["uid"] = event.$loki;
    data["companyName"] = company.name;
    data["name"] = event.name;
    // Get matches and segments
    const matches = await $45c916186f207ab3$export$cb63a303318c2c2b({
        event: event,
        history: true,
        getChampionshipsAvailable: false
    });
    const segments = await $45c916186f207ab3$export$f4e3fa4bed8b2677({
        event: event,
        history: true
    });
    data["matchesAndSegments"] = matches.concat(segments);
    data["matchesAndSegments"].sort((a, b)=>a.order - b.order || a.segmentType.localeCompare(b.segmentType));
    // Get weekly show's name
    if (event.weeklyShow) {
        const nextMonthlyEvent = await $45c916186f207ab3$export$2093faeea03db163(event, parentEvents, company);
        data["weeklyShowName"] = $45c916186f207ab3$export$f7ff913218cb70f1(event, nextMonthlyEvent, game.numberOfWeeklyShows);
        // Get nielsen rating for weekly show
        if (event.viewership !== null) data["nielsenRating"] = $45c916186f207ab3$export$18605aa77cb3f0eb(event.viewership);
    }
    return data;
}
async function $45c916186f207ab3$export$4e639cd701d08fec(companyUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get events
    const companyEvents = await (0, $9esFv.getCompanyEvents)(selectedCompany);
    const parentEvents = companyEvents.slice(0, 12);
    const nextEvent = companyEvents[companyEvents.length - 1];
    // Get data for parent events
    data["events"] = await Promise.all(parentEvents.map(async (x)=>{
        const childEvents = (await (0, $iQtzn.getChildEvents)(x)).filter((y)=>y.rating !== null);
        // Get latestChildEvent if held for calendar click
        let latestChildEventId = childEvents.length > 0 ? childEvents[childEvents.length - 1].$loki : null;
        return {
            "name": x.name,
            "uid": x.$loki,
            "brandName": x.brandName,
            "latestChildEventUid": latestChildEventId
        };
    }));
    // Get upcoming event's name
    if (nextEvent.weeklyShow || nextEvent.name === "Weekly Show") {
        const upcomingMonthlyEvent = await $45c916186f207ab3$export$2093faeea03db163(nextEvent, parentEvents, selectedCompany);
        data["upcomingEventName"] = upcomingMonthlyEvent.name;
    } else data["upcomingEventName"] = nextEvent.name;
    // Get company weekly show name
    let companyWeeklyShowName = selectedCompany.weeklyShowName;
    if (!companyWeeklyShowName) companyWeeklyShowName = `${(0, $1JSre.formatCompanyNameBackend)(selectedCompany.name)} Weekly`;
    data["companyWeeklyShowName"] = companyWeeklyShowName;
    // Get brand names
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    data["brandNames"] = rosterBrands.map((x)=>x.name);
    return data;
}
function $45c916186f207ab3$export$18605aa77cb3f0eb(viewership) {
    return (0, $3E8Nt.decimalRound)(viewership * 0.8 / 1000000);
}
async function $45c916186f207ab3$export$4d1698d96fdc315b(uid, name, weeklyShow, brandName) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const cost = 50;
    const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const companyEvents = await (0, $9esFv.getCompanyEvents)(userCompany);
    const parentEvents = companyEvents.slice(0, 12);
    const nonParentEvents = companyEvents.slice(12);
    // Remove multiple spaces in name
    name = name.replace(/ +(?= )/g, "");
    // Check points
    if (userCompany.points < cost) {
        data["error"] = "points";
        return data;
    }
    // Check for WoM
    if (userCompany.storyName === "mars") {
        data["error"] = "mars";
        return data;
    }
    // Get event
    let event;
    if (!weeklyShow) event = await (0, $14eBR.Events).get(uid);
    // Check for same name
    if (event && name === event.name) {
        data["error"] = "same-name";
        return data;
    }
    // Check for same weekly show name
    if (!event && name === userCompany.weeklyShowName) {
        data["error"] = "same-name";
        return data;
    }
    // Check if name already exists
    const existingEventNames = parentEvents.map((x)=>x.name);
    if (userCompany.weeklyShowName) existingEventNames.push(userCompany.weeklyShowName);
    if (existingEventNames.indexOf(name) >= 0) data["error"] = "name-exists";
    // Change weekly show name
    let previousName;
    if (weeklyShow) {
        previousName = userCompany.weeklyShowName;
        if (!previousName) previousName = `${(0, $1JSre.formatCompanyNameBackend)(userCompany.name)} Weekly`;
        userCompany.weeklyShowName = name;
        // Change next event's name if weekly show and not brand show
        const brandWeeklyShowNames = rosterBrands.map((x)=>x.weeklyShowName);
        if (nextEvent.weeklyShow && brandWeeklyShowNames.indexOf(nextEvent.name) < 0) {
            nextEvent.name = name;
            data["updateEvent"] = true;
        }
    } else {
        // Lower prestige by 1, update xp and hype
        const prestiges = [
            "A",
            "B",
            "C"
        ];
        const hypes = {
            "A": 80,
            "B": 40,
            "C": 15
        };
        let newPrestigeIndex = prestiges.indexOf(event.prestige) + 1;
        if (newPrestigeIndex >= prestiges.length) newPrestigeIndex -= 1;
        event.prestige = prestiges[newPrestigeIndex];
        event.xp = (0, $3E8Nt.eventPrestigeXps)[event.prestige] || 0;
        event.hype = hypes[event.prestige] || 15;
        // Change name
        previousName = event.name;
        event.name = name;
        // Change brand name
        if (brandName) (0, $1Dp0h.setObjectBrand)(event, brandName);
        else (0, $1Dp0h.removeObjectBrand)(event);
        // Add child events by name if they don't already have a parent
        let eventIterations = nonParentEvents.filter((x)=>x.name === previousName);
        for (const x of eventIterations){
            const eventParent = await (0, $iQtzn.getParentEvent)(x);
            if (!eventParent) await (0, $iQtzn.addChildEvent)(event, x);
        }
        // Change name, prestige, brand name of upcoming show if next
        if (!nextEvent.weeklyShow && nextEvent.name === previousName) {
            nextEvent.name = name;
            nextEvent.prestige = event.prestige;
            nextEvent.xp = event.xp;
            nextEvent.hype = event.hype;
            nextEvent.brandName = event.brandName;
            data["updateEvent"] = true;
        }
        // Change name only of weekly show before monthly show
        if (nextEvent.weeklyShow && nextEvent.weekNumber < 0 && nextEvent.monthlyEventName === previousName) nextEvent.monthlyEventName = name;
    }
    // Remove points
    userCompany.points -= cost;
    // Add company log
    const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, userCompany.realYear);
    await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
    newCompanyLog.text = `Rebranded ${previousName} to ${name}`;
    newCompanyLog.type = "rebrand-event";
    newCompanyLog.realYear = currentGame.year;
    await (0, $9esFv.addCompanyCompanyLogs)(userCompany, [
        newCompanyLog
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["previousName"] = previousName;
    data["newName"] = name;
    data["points"] = userCompany.points;
    // Save to local storage
    await (0, $iRMwH.saveGameDataToLocalStorage)(currentGame);
    return data;
}
async function $45c916186f207ab3$export$101b1ff58353fb0a(streak) {
    let data = {};
    data["holder"] = (await (0, $lhVvD.getStreakTalent)(streak))?.name;
    data["length"] = streak.length;
    data["event"] = (await (0, $lhVvD.getStreakEvent)(streak))?.name;
    data["uid"] = streak.$loki;
    return data;
}
async function $45c916186f207ab3$var$getMatchContractData(matchContract) {
    let data = {};
    data["holder"] = (await (0, $1AAHK.getMatchContractTalent)(matchContract))?.name;
    data["name"] = matchContract.name;
    data["bonus"] = matchContract.bonus;
    data["event"] = (await (0, $1AAHK.getMatchContractEvent)(matchContract))?.name;
    data["uid"] = matchContract.$loki;
    return data;
}
async function $45c916186f207ab3$var$getEventGimmickMatchPoints(event, allEvents) {
    let eventIterations = allEvents.filter((x)=>x.name === event.name && x.rating !== null);
    const gimmickMatchesPoints = {};
    // Go through event iterations, finding gimmick matches
    for (const eventIteration of eventIterations){
        const eventMatches = await (0, $iQtzn.getEventMatches)(eventIteration);
        for (const match of eventMatches){
            const gimmickMatch = await (0, $i7bmn.getMatchGimmickMatch)(match);
            if (gimmickMatch && match.rating !== null) {
                // Get points for each time gimmick match used
                const points = $45c916186f207ab3$var$getGimmickMatchPoints(match.rating);
                if (gimmickMatchesPoints[gimmickMatch.name]) gimmickMatchesPoints[gimmickMatch.name] += points;
                else gimmickMatchesPoints[gimmickMatch.name] = points;
            }
        }
    }
    return gimmickMatchesPoints;
}
function $45c916186f207ab3$var$getGimmickMatchPoints(rating) {
    let points;
    let ratingValue = 4 - rating;
    if (rating > 4) {
        ratingValue *= -1;
        points = Math.pow(ratingValue, 0.5);
    } else if (rating === 4) points = Math.pow(0.125, 0.5);
    else points = Math.pow(ratingValue, 0.5) * -1;
    return Math.floor(points * 100);
}
function $45c916186f207ab3$var$getGimmickMatchBonusFromPoints(points) {
    let bonus;
    if (points < -500) bonus = -50;
    else if (points < -340) bonus = -25;
    else if (points < -170) bonus = -12;
    else if (points < 170) bonus = 0;
    else if (points < 340) bonus = 12;
    else if (points < 500) bonus = 25;
    else bonus = 50;
    return bonus;
}
async function $45c916186f207ab3$export$187af84c58b7b522() {
    let data = {};
    let eventData = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const company = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
    const companyEvents = await (0, $9esFv.getCompanyEvents)(company);
    const parentEvents = companyEvents.slice(0, 12);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const productionFacility = (await (0, $9esFv.getCompanyFacilities)(company)).find((x)=>x.name === "Production");
    const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(company);
    // Check if top event
    const topEvent = $45c916186f207ab3$export$9312fd3ae03903e0(parentEvents);
    const isTopEvent = nextEvent.name === topEvent.name;
    // Get next event data
    eventData.name = nextEvent.name;
    eventData.activeEffect = nextEvent.activeEffect;
    eventData.brandName = nextEvent.brandName;
    eventData.brandColor = (0, $1Dp0h.getBrandColorForEvent)(nextEvent, rosterBrands);
    eventData.prestige = nextEvent.prestige;
    eventData.baseHype = await $45c916186f207ab3$export$e511c8e09be6c90d(nextEvent, isTopEvent, rosterBrands);
    if (nextEvent.weeklyShow || nextEvent.name === "Weekly Show") {
        eventData.weeklyShow = true;
        const nextMonthlyEvent = await $45c916186f207ab3$export$2093faeea03db163(nextEvent, parentEvents, company);
        eventData.weeklyShowName = $45c916186f207ab3$export$f7ff913218cb70f1(nextEvent, nextMonthlyEvent, currentGame.numberOfWeeklyShows);
    }
    // Get match and segment limits
    data["minimumMatchesAndSegments"] = $45c916186f207ab3$export$11155d02ed0faaa(nextEvent, parentEvents, rosterSuperstars);
    data["maximumMatchesAndSegments"] = $45c916186f207ab3$export$d12231fd41bc9dc5(nextEvent, parentEvents, productionFacility);
    // Get matches and segments
    const producers = (0, $8A6FL.getAvailableStaffMembersByRole)(companyStaffMembers, "producer");
    const matches = await $45c916186f207ab3$export$cb63a303318c2c2b({
        event: nextEvent,
        rosterSuperstars: rosterSuperstars
    });
    const segments = await $45c916186f207ab3$export$f4e3fa4bed8b2677({
        event: nextEvent,
        rosterSuperstars: rosterSuperstars,
        producers: producers
    });
    data["matchesAndSegments"] = matches.concat(segments);
    data["matchesAndSegments"].sort((a, b)=>a.order - b.order);
    // Get prestige info for monthly event
    eventData["streaks"] = [];
    eventData["matchEffects"] = [];
    eventData["matchContracts"] = [];
    if (nextEvent.name !== "Weekly Show" && !nextEvent.weeklyShow && !nextEvent.temporaryEvent) {
        const parentEvent = await $45c916186f207ab3$export$560d4c97cc427f09(parentEvents, nextEvent);
        // Get match contracts for this event
        const matchContracts = (await (0, $iQtzn.getEventMatchContracts)(parentEvent)).filter((x)=>x.awarded);
        for (const matchContract of matchContracts){
            const matchContractData = await $45c916186f207ab3$var$getMatchContractData(matchContract);
            eventData["matchContracts"].push(matchContractData);
            // Remove match contract championship TODO remove reigns and random events?
            const matchContractChampionship = await (0, $1AAHK.getMatchContractChampionship)(matchContract);
            if (matchContractChampionship) {
                const matchContractChampionships = (await (0, $9esFv.getCompanyChampionships)(company)).filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, matchContractChampionship));
                for (const c of matchContractChampionships){
                    await (0, $9esFv.removeCompanyChampionships)(company, [
                        c
                    ]);
                    await (0, $14eBR.Championships).remove(c);
                    (0, $14eBR.db).saveDatabase();
                }
            }
        }
        // Get streaks and match effects if paid
        if ((0, $98xmD.globalUser).paid) {
            if (parentEvent.prestige === "A") {
                const streaks = await (0, $iQtzn.getEventStreaks)(parentEvent);
                eventData["streaks"] = await Promise.all(streaks.map((x)=>$45c916186f207ab3$export$101b1ff58353fb0a(x)));
                eventData["streaks"].sort((a, b)=>b.length - a.length);
            }
            const eventGimmickMatchPoints = await $45c916186f207ab3$var$getEventGimmickMatchPoints(nextEvent, companyEvents);
            for (const [key, value] of Object.entries(eventGimmickMatchPoints))eventData["matchEffects"].push({
                "gimmickMatch": key,
                "bonus": $45c916186f207ab3$var$getGimmickMatchBonusFromPoints(value),
                "points": value
            });
            eventData["matchEffects"].sort((a, b)=>{
                if (a.bonus !== 0 && b.bonus === 0) return -1;
                if (a.bonus === 0 && b.bonus !== 0) return 1;
                return b.bonus - a.bonus;
            });
        }
    }
    data["eventData"] = eventData;
    return data;
}
async function $45c916186f207ab3$export$bd2cccaaf22fdcbc(event) {
    return (await (0, $iQtzn.getEventMatches)(event)).concat(await (0, $iQtzn.getEventSegments)(event));
}
async function $45c916186f207ab3$export$f9702c88d617efa2({ skipTrainingRosterCallup: skipTrainingRosterCallup = false, simulating: simulating = false, eventMatches: eventMatches = null, eventSegments: eventSegments = null } = {}) {
    let data = {};
    try {
        const currentGame = await (0, $3E8Nt.getCurrentGame)();
        const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
        const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
        const companyEvents = await (0, $9esFv.getCompanyEvents)(userCompany);
        const event = companyEvents[companyEvents.length - 1];
        const companyRosters = await (0, $9esFv.getCompanyRosters)(userCompany);
        const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(userCompany);
        const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main", companyRosters);
        const trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "trainingAvailable", companyRosters);
        const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
        const weeklyShow = event.weeklyShow || event.name === "Weekly Show" || event.temporaryEvent;
        const parentEvent = await $45c916186f207ab3$export$560d4c97cc427f09(parentEvents, event);
        // Get matches and segments if not present
        if (!eventMatches) eventMatches = await (0, $iQtzn.getEventMatches)(event);
        if (!eventSegments) eventSegments = await (0, $iQtzn.getEventSegments)(event);
        // Get event tournament
        let tournaments = await (0, $iQtzn.getEventTournaments)(event);
        let tournament;
        if (tournaments.length > 0) tournament = tournaments[0];
        let annualTournament;
        if (tournament && tournament.annualTournament) annualTournament = tournament;
        // Check for unused training roster callup if not simulating or annual tournament
        if (!skipTrainingRosterCallup && !simulating && !annualTournament) {
            if (!userCompany.trainingCallupRun && [
                0,
                6
            ].includes((0, $8A6FL.getCompanyMonth)(userCompany, currentGame))) {
                if ((await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster)).length > 0) {
                    data["error"] = "training-callup-available";
                    return data;
                }
            }
        }
        // Checks to return cash in option with match
        let cashinSingles = false;
        let cashinTag = false;
        let cashinTrios = false;
        // Checks to see if cash in is available
        let cashinSinglesAvailable = false;
        let cashinTagAvailable = false;
        let cashinTriosAvailable = false;
        // Check for championship contracts
        for (const championship of companyChampionships)if (championship.championshipContract && !championship.vacated) {
            if (championship.tagTeam || championship.trio) {
                if (championship.tagTeam) {
                    cashinTag = true;
                    cashinTagAvailable = true;
                } else {
                    cashinTrios = true;
                    cashinTriosAvailable = true;
                }
            } else {
                cashinSingles = true;
                cashinSinglesAvailable = true;
            }
        }
        // Check for potential championship contracts
        for (const match of eventMatches){
            for (const championship of (await (0, $i7bmn.getMatchChampionships)(match)))if (championship.championshipContract && championship.vacated) {
                if (championship.tagTeam || championship.trio) {
                    if (championship.tagTeam) cashinTag = true;
                    else cashinTrios = true;
                } else cashinSingles = true;
            }
        }
        // Add event prestige effect bonuses
        if (!weeklyShow) {
            if ((0, $98xmD.globalUser).paid) {
                // Add streak bonus
                if (event.prestige === "A") {
                    let streaks = await (0, $iQtzn.getEventStreaks)(parentEvent);
                    for (const match of eventMatches){
                        let streakBonus = 0;
                        let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
                        for (const streak of streaks){
                            let streakHolder = await (0, $lhVvD.getStreakTalent)(streak);
                            if ((0, $3E8Nt.objectInArray)(streakHolder, matchParticipants)) streakBonus += $45c916186f207ab3$var$getStreakBonus(streak.length);
                        }
                        if (streakBonus) match.streakBonus = streakBonus;
                    }
                }
                // Add match effect bonus
                let matchEffects = await $45c916186f207ab3$var$getEventGimmickMatchPoints(event, companyEvents);
                for (const match of eventMatches){
                    const matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
                    for (const [key, value] of Object.entries(matchEffects))if (matchGimmick && matchGimmick.name === key) match.eventBonus = $45c916186f207ab3$var$getGimmickMatchBonusFromPoints(value);
                }
            }
            // Add match contract bonus
            let matchContracts = await (0, $iQtzn.getEventMatchContracts)(parentEvent);
            for (const match of eventMatches)if ((await (0, $i7bmn.getMatchChampionships)(match)).length > 0) {
                let matchContractBonus = 0;
                let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
                for (const matchContract of matchContracts)if (matchContract.awarded && (0, $3E8Nt.objectInArray)(await (0, $1AAHK.getMatchContractTalent)(matchContract), matchParticipants)) matchContractBonus += matchContract.bonus;
                if (matchContractBonus) match.contractBonus = matchContractBonus;
            }
        }
        // Add hype for unplayed matches
        for (const match of eventMatches)if (match.winner === null) match.hype = await (0, $6RCLU.getHypeForMatch)(await (0, $i7bmn.getMatchParticipants)(match), await (0, $i7bmn.getMatchFeuds)(match), await (0, $i7bmn.getMatchChampionships)(match), userCompany.style, annualTournament, match.tournamentRound);
        // Get matches and segments if not simulating
        data["matchesAndSegmentsData"] = [];
        if (!simulating) {
            let eventMatchesData = await $45c916186f207ab3$export$cb63a303318c2c2b({
                event: event,
                cashinSingles: cashinSingles,
                cashinTag: cashinTag,
                cashinTrios: cashinTrios,
                getChampionshipsAvailable: false,
                play: true,
                rosterSuperstars: rosterSuperstars,
                game: currentGame
            });
            let eventSegmentsData = await $45c916186f207ab3$export$f4e3fa4bed8b2677({
                event: event,
                play: true,
                rosterSuperstars: rosterSuperstars
            });
            let matchesAndSegmentsData = eventMatchesData.concat(eventSegmentsData);
            matchesAndSegmentsData.sort((a, b)=>b.order - a.order);
            // Check for minimum number (don't check during tutorial)
            let minimumMatchesAndSegments = $45c916186f207ab3$export$11155d02ed0faaa(event, parentEvents, rosterSuperstars);
            let tutorialCheck = userCompany.storyName === "tutorial" && [
                "play_first_event",
                "simulate_match"
            ].includes(await (0, $8A6FL.getTutorialStateName)(userCompany));
            if ((0, $98xmD.globalUser).developerMode || tutorialCheck) minimumMatchesAndSegments = 0;
            if (matchesAndSegmentsData.length < minimumMatchesAndSegments) {
                data["limit"] = minimumMatchesAndSegments;
                data["error"] = "min-limit";
                return data;
            }
            // Remove played
            matchesAndSegmentsData = matchesAndSegmentsData.filter((x)=>{
                return x["segmentType"] === "segment" ? x["rating"] === null : x["winnerName"] === null;
            });
            data["matchesAndSegmentsData"] = matchesAndSegmentsData;
        }
        // Get event hype if no matches or segments played
        let eventStartedBefore = $45c916186f207ab3$var$checkEventStartedBefore(eventMatches.concat(eventSegments));
        if (!eventStartedBefore) {
            let topEvent = event.name === $45c916186f207ab3$export$9312fd3ae03903e0(parentEvents).name;
            event.hype = await $45c916186f207ab3$export$a95829736ebc7a40(event, topEvent, eventMatches.concat(eventSegments), companyEvents[companyEvents.length - 2], rosterBrands);
        }
        // Get event preview if no matches or segments played and monthly event or annual tournament
        if (!eventStartedBefore && (!weeklyShow || annualTournament)) try {
            data["eventPreviewData"] = await $45c916186f207ab3$var$getEventPreviewData(event, userCompany.name, parentEvents, companyChampionships, annualTournament, mainCompany, currentGame);
        } catch (error) {
            (0, $3E8Nt.captureError)(error);
        }
        // Add annual tournament opening segment
        if (annualTournament && event.name.endsWith("1") && !eventStartedBefore) {
            let annualTournamentOpeningSegment = (0, $18vSN.getAnnualTournamentOpeningSegmentData)(currentGame, annualTournament);
            data["matchesAndSegmentsData"].splice(0, 0, annualTournamentOpeningSegment);
        }
        if (!simulating) (0, $14eBR.db).saveDatabase();
        // Get data to return
        data["activeEffect"] = event.activeEffect;
        data["hype"] = event.hype;
        data["eventName"] = event.name;
        data["cashinData"] = {
            "cashinSinglesAvailable": cashinSinglesAvailable,
            "cashinTagAvailable": cashinTagAvailable,
            "cashinTriosAvailable": cashinTriosAvailable
        };
        if (tournament) data["tournamentDisplay"] = await (0, $8A6FL.getTournamentDisplayData)(tournament, currentGame);
    } catch (error) {
        data["error"] = true;
        // Check if any empty teams present, return in error
        const currentGame = await (0, $3E8Nt.getCurrentGame)();
        const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
        const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
        const eventMatchesAndSegments = await $45c916186f207ab3$export$bd2cccaaf22fdcbc(latestEvent);
        for (const matchOrSegment of eventMatchesAndSegments){
            const tagTeams = matchOrSegment.objectName === "match" ? await (0, $i7bmn.getMatchTagTeams)(matchOrSegment) : await (0, $eg5dz.getSegmentTagTeams)(matchOrSegment);
            for (const tagTeam of tagTeams)if (!(await (0, $972Ip.getTagTeamSuperstars)(tagTeam)).length) {
                data["error"] = "team-members-not-found";
                data["teamName"] = tagTeam.name;
                break;
            }
        }
        if (data["error"] !== "team-members-not-found") (0, $3E8Nt.captureError)(error);
    }
    return data;
}
function $45c916186f207ab3$var$getStreakBonus(length) {
    let bonus;
    if (length < 2) return 0;
    if (length < 5) bonus = 12;
    else if (length < 10) bonus = 25;
    else if (length < 20) bonus = 50;
    else bonus = 75;
    return bonus;
}
function $45c916186f207ab3$var$checkEventStartedBefore(matchesAndSegments) {
    let check = false;
    for (const x of matchesAndSegments){
        if (x.objectName === "segment") {
            if (x.rating !== null) check = true;
        } else if (x.winner !== null) check = true;
    }
    return check;
}
async function $45c916186f207ab3$export$a95829736ebc7a40(event, topEvent = false, matchesAndSegments = null, previousEvent = null, rosterBrands = null) {
    // Get base hype
    let baseHype = await $45c916186f207ab3$export$e511c8e09be6c90d(event, topEvent, rosterBrands);
    // Get average of matches and segments hypes
    let matchesAndSegmentsHype = 0;
    if (matchesAndSegments && matchesAndSegments.length) matchesAndSegmentsHype = matchesAndSegments.map((x)=>$45c916186f207ab3$var$getMatchOrSegmentHype(x)).reduce((partialSum, a)=>partialSum + a, 0) / matchesAndSegments.length;
    // Get event boost from previous event
    let eventHypeBoost = previousEvent ? previousEvent.nextEventBoost : 0;
    return Math.round(baseHype + matchesAndSegmentsHype + eventHypeBoost);
}
function $45c916186f207ab3$var$getMatchOrSegmentHype(matchOrSegment) {
    if (matchOrSegment.hype !== null) {
        if (matchOrSegment.objectName === "segment") return matchOrSegment.hype;
        else return (0, $6RCLU.getMatchHype)(matchOrSegment);
    }
    return 0;
}
async function $45c916186f207ab3$export$56601633066b7859(matchesAndSegments, rosterSuperstars = null) {
    const superstarsUsedAtEvent = [];
    for (const x of matchesAndSegments){
        let participants;
        if (x.objectName === "segment") participants = await (0, $eg5dz.getSegmentParticipants)(x);
        else if (x.objectName === "match") participants = await (0, $i7bmn.getMatchParticipants)(x);
        for (const p of participants)for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(p))){
            superstarsUsedAtEvent.push(s);
            const manager = await (0, $5kTkA.getSuperstarManagerUsedForMatchOrSegment)(s, x.managersUsed, rosterSuperstars);
            if (manager) superstarsUsedAtEvent.push(manager);
        }
    }
    return (0, $3E8Nt.getUniqueObjects)(superstarsUsedAtEvent);
}
async function $45c916186f207ab3$export$d547f2efa298290d() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const user = (0, $bZol7.loadUser)();
    let data = {};
    try {
        data = await (0, $dGbip.endEvent)(userCompany, user);
        // Check tutorial action
        if (userCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
            "end_first_event",
            "end_second_event"
        ]);
        (0, $14eBR.db).saveDatabase();
        // Save to local storage
        await (0, $iRMwH.saveGameDataToLocalStorage)(currentGame);
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
        data["error"] = true;
        await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
    }
    return data;
}
function $45c916186f207ab3$export$ad451c85840cb7c4(matchesAndSegments) {
    let eventMatchesAndSegments = [
        ...matchesAndSegments
    ].sort((a, b)=>b.order - a.order);
    // Remove cashins
    eventMatchesAndSegments = eventMatchesAndSegments.filter((x)=>x.rating !== null);
    let matchesToRemove = Math.round(eventMatchesAndSegments.length * 0.2);
    for(let x = 0; x < matchesToRemove; x++){
        let minimum = (0, $3E8Nt.getArrayMinByProperty)(eventMatchesAndSegments, "rating");
        if (minimum.rating < 2) continue;
        if (minimum !== eventMatchesAndSegments[eventMatchesAndSegments.length - 1]) eventMatchesAndSegments.splice(eventMatchesAndSegments.indexOf(minimum), 1);
    }
    // Add main event weight (2x)
    if (eventMatchesAndSegments.length > 0) eventMatchesAndSegments.push(eventMatchesAndSegments[eventMatchesAndSegments.length - 1]);
    if (eventMatchesAndSegments.length === 0) return 0;
    let average = eventMatchesAndSegments.reduce((sum, match)=>sum + match.rating, 0) / eventMatchesAndSegments.length;
    return Math.round(average * 4) / 4; // Round to nearest 0.25
}
async function $45c916186f207ab3$var$getEventPreviewData(event, companyName, parentEvents, companyChampionships, annualTournament, mainCompany, game) {
    // Generate event description (hype, signature event, main event, exciting matches, top feuds, streaks, match effects,
    // fixed match contract)
    const data = {};
    let parentEvent = await $45c916186f207ab3$export$560d4c97cc427f09(parentEvents, event);
    if (!parentEvent) parentEvent = await (0, $iQtzn.getParentEvent)(event);
    const eventMatches = await (0, $iQtzn.getEventMatches)(event);
    const sortedMatches = [
        ...eventMatches
    ].sort((a, b)=>a.order - b.order);
    let mainEventMatch = null;
    if (sortedMatches.length) mainEventMatch = sortedMatches[0];
    const isTopEvent = event.name === (0, $3E8Nt.getArrayMaxByProperty)(parentEvents, "xp").name;
    // Get poster data
    data["eventPosterData"] = await $45c916186f207ab3$export$ad3b7b3640187e2b(event, eventMatches, companyChampionships, parentEvent, annualTournament);
    // Set graphic if user is paid
    if ((0, $98xmD.globalUser).paid && data["eventPosterData"]) event.posterGraphic = data["eventPosterData"]["graphics"];
    if (annualTournament) {
        // Get event information
        data["eventName"] = event.name;
        data["eventYear"] = "";
        // Get preview texts
        data["previewTexts"] = await (0, $18vSN.getAnnualTournamentPreviewTexts)(event, eventMatches, annualTournament, mainCompany, game);
        // Get match predictions
        data["predictionsData"] = await (0, $18vSN.getAnnualTournamentMatchPredictions)(eventMatches, event.name, annualTournament);
    } else {
        // Get event information
        data["eventName"] = event.name;
        data["eventYear"] = event.year;
        data["activeEffect"] = event.activeEffect;
        // Get hype level
        const baseHype = await $45c916186f207ab3$export$e511c8e09be6c90d(event, isTopEvent);
        const hypeDifference = event.hype - baseHype;
        let hypeWord, audienceWord;
        if (hypeDifference <= 0) {
            hypeWord = "low";
            audienceWord = "half packed audience.";
        } else if (hypeDifference <= 50) {
            hypeWord = "on par";
            audienceWord = "mostly packed audience.";
        } else {
            hypeWord = "high";
            audienceWord = "fully packed audience!";
        }
        // Intro text
        let premierEventText = "";
        if (event.activeEffect === "premier_event") premierEventText = ' <span class="font-bold">their premier event</span>,';
        let topEventText = "";
        if (isTopEvent && !premierEventText) topEventText = ' <span class="font-bold">their biggest event of the year</span>,';
        let companyOrBrandName = companyName;
        if (event.brandName) companyOrBrandName = event.brandName;
        data["introText"] = `${companyOrBrandName} presents ${event.name},${topEventText}${premierEventText} live ` + `tonight in front of a ${audienceWord}`;
        // Interest / main event text
        let mainEventText = "";
        if (mainEventMatch && (await (0, $i7bmn.getMatchParticipants)(mainEventMatch)).length) mainEventText = `, which is headlined by ${await $45c916186f207ab3$export$c30622051d8fc8ec(mainEventMatch, true)}`;
        data["interestText"] = `Fan interest is ${hypeWord} for the event${mainEventText}.`;
        // Top matches text (exclude matches without participants e.g tournament finals)
        let topMatchesText = "";
        let topMatches = [];
        for (const x of eventMatches)if ((!mainEventMatch || x.$loki !== mainEventMatch.$loki) && (await (0, $i7bmn.getMatchParticipants)(x)).length) topMatches.push(x);
        topMatches = [
            ...topMatches
        ].sort((a, b)=>b.hype - a.hype).slice(0, 3);
        if (topMatches.length) {
            const topMatchPreviewText = await $45c916186f207ab3$export$c30622051d8fc8ec(topMatches[0]);
            topMatchesText += `One of the most anticipated matches of the night is ${topMatchPreviewText}.`;
            // If more than 2 top matches, get their preview texts as well
            if (topMatches.length > 2) {
                const topMatchesPreviewText = (0, $3E8Nt.commaSeparate)(await Promise.all(topMatches.slice(1).map((x)=>$45c916186f207ab3$export$c30622051d8fc8ec(x))));
                topMatchesText += ` Other matches that have the fans buzzing include ${topMatchesPreviewText}.`;
            }
            data["topMatchesText"] = topMatchesText;
        }
        // Event effects text
        if (parentEvent) {
            // Get match contracts
            const matchContracts = await (0, $iQtzn.getEventMatchContracts)(parentEvent);
            if (matchContracts.length) {
                // Get top match contract
                const topMatchContract = (0, $3E8Nt.getArrayMaxByProperty)(matchContracts, "bonus");
                const matchContractHolder = await (0, $1AAHK.getMatchContractTalent)(topMatchContract);
                const matchContractType = matchContractHolder && matchContractHolder.objectName === "superstar" ? "singles" : "tag";
                if (matchContractHolder) {
                    // Check if match contract used
                    let matchContractUsed = false;
                    let championshipUsedFor;
                    let matchContractText;
                    if (topMatchContract.awarded) for (const match of eventMatches){
                        const matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
                        if (matchChampionships.length && (0, $3E8Nt.objectInArray)(matchContractHolder, await (0, $i7bmn.getMatchParticipants)(match))) {
                            matchContractUsed = true;
                            // Get championship that doesn't belong to match contract holder and is not vacant
                            for (const c of matchChampionships){
                                let holder = await (0, $kZwpB.getChampionshipHolder)(c);
                                if (!c.vacated && holder && holder !== matchContractHolder) {
                                    championshipUsedFor = c;
                                    break;
                                }
                            }
                        }
                    }
                    if (matchContractUsed) // Match contract text if used
                    {
                        if (championshipUsedFor) {
                            const champion = await (0, $kZwpB.getChampionshipHolder)(championshipUsedFor);
                            const championshipUsedForName = (0, $1JSre.getChampionshipDisplayName)(championshipUsedFor);
                            const facesWord = matchContractType === "singles" ? "faces" : "face";
                            const championWord = matchContractType === "singles" ? "champion" : "champions";
                            const titleWord = matchContractType === "singles" ? "title" : "titles";
                            matchContractText = `<span class="font-bold">${matchContractHolder.name} ${facesWord} ` + `${champion.name}</span> tonight, using ${matchContractHolder.possessivePronoun} ` + `${topMatchContract.name} Contract for a shot at the ${championshipUsedForName}. Can ` + `${matchContractHolder.name} defeat the ${championWord} and win the ${titleWord}, or ` + `will ${champion.name} end ${matchContractHolder.name}'s dream?`;
                        }
                    } else {
                        const hasWord = matchContractType === "singles" ? "has" : "have";
                        if ((await (0, $5kTkA.getRosterMemberSuperstars)(matchContractHolder)).some((y)=>!(0, $5kTkA.checkAvailability)(y, true, false, false))) // Unavailable text
                        matchContractText = `<span class="font-bold">${matchContractHolder.name} ${hasWord} a ` + `${topMatchContract.name} Contract</span> to challenge for a ${matchContractType} title ` + `at ${event.name}. Unfortunately, ${matchContractHolder.pronoun} won't be able to use it ` + `tonight due to unavailability.`;
                        else {
                            // Fans upset text if not used
                            const isWord = matchContractType === "singles" ? "is" : "are";
                            matchContractText = `As you might remember, <span class="font-bold">${matchContractHolder.name} ` + `${hasWord} a ${topMatchContract.name} Contract</span> to challenge for a ${matchContractType} ` + `title at ${event.name}. However, ${matchContractHolder.pronoun} ${isWord} not booked to use it ` + `tonight, and fans are quite upset about it.`;
                        }
                    }
                    if (matchContractText) data["matchContractText"] = matchContractText;
                }
            }
            // Get streaks if paid and 'A' event prestige
            if ((0, $98xmD.globalUser).paid && event.prestige === "A") {
                const streaks = await (0, $iQtzn.getEventStreaks)(parentEvent);
                if (streaks.length) {
                    let streakUsed = false;
                    let streakText;
                    // Get top streak
                    const topStreak = await (0, $3E8Nt.getArrayMaxByProperty)(streaks, "length");
                    const streakHolder = await (0, $lhVvD.getStreakTalent)(topStreak);
                    const streakType = streakHolder && streakHolder.objectName === "superstar" ? "singles" : "tag";
                    const streakAdjective = $45c916186f207ab3$var$getStreakAdjective(topStreak.length);
                    // Check if streak used
                    let streakOpponents;
                    for (const match of eventMatches){
                        const matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
                        if ((0, $3E8Nt.objectInArray)(streakHolder, matchParticipants)) {
                            streakUsed = true;
                            streakOpponents = matchParticipants.filter((x)=>x.$loki !== streakHolder.$loki);
                        }
                    }
                    if (streakUsed) {
                        // Streak text if used
                        const defendWord = streakType === "singles" ? "defends" : "defend";
                        const oneWord = streakType === "singles" ? "one" : "ones";
                        let streakOpponentsText, streakOpponentName;
                        if (streakOpponents.length) {
                            streakOpponentsText = (0, $3E8Nt.commaSeparate)(streakOpponents.map((x)=>x.name));
                            streakOpponentName = (0, $3E8Nt.getRandomChoice)(streakOpponents).name;
                        } else {
                            streakOpponentsText = "???";
                            streakOpponentName = "???";
                        }
                        streakText = `<span class="font-bold">${streakHolder.name} ${defendWord} ` + `${streakHolder.possessivePronoun} ${streakAdjective} ${topStreak.length}-0 streak at ` + `${event.name} against ${streakOpponentsText}</span>. Will the streak continue to ` + `${topStreak.length + 1}-0 or could ${streakOpponentName} be the ${oneWord} to end it tonight?`;
                    } else {
                        const hasWord = streakType === "singles" ? "has" : "have";
                        if ((await (0, $5kTkA.getRosterMemberSuperstars)(streakHolder)).some((y)=>!(0, $5kTkA.checkAvailability)(y, true, false, false))) // Unavailable text
                        streakText = `<span class="font-bold">${streakHolder.name} ${hasWord} a ${streakAdjective} ` + `${topStreak.length}-0 streak at ${event.name}</span>, but ${streakHolder.pronoun} ` + `unfortunately won't be able to defend it due to unavailability.`;
                        else {
                            // Fans let down text if not used
                            const isWord = streakType === "singles" ? "is" : "are";
                            streakText = `<span class="font-bold">${streakHolder.name} ${hasWord} a ${streakAdjective} ` + `${topStreak.length}-0 streak at ${event.name}</span>, so it comes as a surprise that ` + `${streakHolder.pronoun} ${isWord} not defending it tonight.`;
                        }
                    }
                    data["streakText"] = streakText;
                }
            }
        }
        // Get match predictions
        data["predictionsData"] = await $45c916186f207ab3$var$getEventPreviewPredictions(eventMatches);
    }
    return data;
}
async function $45c916186f207ab3$export$c30622051d8fc8ec(match, extraText = false, compactText = false) {
    const matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
    const championshipsSuperstarIds = matchChampionships.map((c)=>c.superstarId);
    const participants = await (0, $i7bmn.getMatchParticipants)(match);
    const matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
    // Sort participants by champions first, then by popularity
    let sortedParticipants = [
        ...participants
    ];
    for (const x of sortedParticipants){
        x.tempPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
        x.tempChampion = (await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((z)=>championshipsSuperstarIds.includes(z.$loki));
    }
    sortedParticipants.sort((a, b)=>b.tempChampion - a.tempChampion || b.tempPopularity - a.tempPopularity);
    for (const x of sortedParticipants){
        delete x.tempPopularity;
        delete x.tempChampion;
    }
    // Add participants text
    let participantsText;
    if (participants.length <= 10) {
        const participantsNamesText = await Promise.all(sortedParticipants.map((x)=>$45c916186f207ab3$var$getEventPreviewParticipantLabel(x, championshipsSuperstarIds)));
        // Extra text if singles match without gimmick or title
        if (extraText && !compactText && !matchGimmick && !matchChampionships.length && participants.length === 2) participantsText = participantsNamesText.join(" facing off against ");
        else participantsText = participantsNamesText.join(" vs ");
    } else {
        // Get names of top participants only
        const topParticipants = sortedParticipants.slice(0, 6);
        const topParticipantsNamesText = await Promise.all(topParticipants.map((x)=>$45c916186f207ab3$var$getEventPreviewParticipantLabel(x, championshipsSuperstarIds)));
        const numberOfOthers = sortedParticipants.length - topParticipants.length;
        participantsText = `${topParticipantsNamesText.join(" vs ")} vs ${numberOfOthers} others`;
    }
    // Add championships text
    let championshipsText = "";
    if (matchChampionships.length) {
        const championshipsNames = (0, $3E8Nt.commaSeparate)(matchChampionships.map((x)=>(0, $1JSre.getChampionshipDisplayName)(x)));
        if (!compactText) championshipsText = ` for the ${championshipsNames}`;
        else championshipsText = `${championshipsNames}: `;
    }
    // Add gimmick match text
    let gimmickMatchText = "";
    if (matchGimmick) {
        if (!compactText) {
            const gimmickMatchPrefix = [
                "a",
                "e",
                "i",
                "o",
                "u"
            ].includes(matchGimmick.name[0].toLowerCase()) ? "an" : "a";
            gimmickMatchText = ` in ${gimmickMatchPrefix} ${matchGimmick.name} Match`;
        } else gimmickMatchText = ` (${matchGimmick.name} Match)`;
    }
    let text;
    if (!compactText) text = `<span class="font-bold">${participantsText}${championshipsText}</span>${gimmickMatchText}`;
    else text = `${championshipsText}${participantsText}${gimmickMatchText}`;
    return text;
}
async function $45c916186f207ab3$var$getEventPreviewPredictions(eventMatches) {
    const data = {};
    const predictions = [];
    const allMatches = [
        ...eventMatches
    ].sort((a, b)=>a.order - b.order);
    const matchFinishTextChance = 15;
    const noContestChance = 4;
    const noInterestChance = 30;
    const noPickChance = 10;
    const percentagesChance = 6;
    const drawChance = 20;
    for (const match of allMatches){
        const participants = await (0, $i7bmn.getMatchParticipants)(match);
        const championships = await (0, $i7bmn.getMatchChampionships)(match);
        const matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
        // Don't run for matches without participants e.g tournament finals
        if (!participants.length) continue;
        // Get predicted winner
        const weights = await (0, $6RCLU.getWinLossPercentagesWeights)(participants, championships, "standard", false);
        const winner = (0, $3E8Nt.weightedChoice)(weights);
        const firstRoundedPercentage = Math.ceil(weights[0][1] / 10) * 10;
        // No interest chance if hype is low
        let predictionText;
        if (match.hype < -20 && (0, $3E8Nt.getRandomInt)(0, 100) <= noInterestChance) predictionText = (0, $3E8Nt.getRandomChoice)([
            "Who cares?",
            "Don't care.",
            "No interest.",
            "Not interested."
        ]);
        else if (participants.length === 2 && 55 >= weights[0][1] && weights[0][1] >= 45 && (0, $3E8Nt.getRandomInt)(0, 100) <= noPickChance) {
            if (!matchGimmick && (0, $3E8Nt.getRandomInt)(0, 100) <= drawChance) predictionText = "Draw.";
            else predictionText = (0, $3E8Nt.getRandomChoice)([
                "Can't pick.",
                "Can't decide.",
                "No idea.",
                "No idea who wins."
            ]);
        } else if (participants.length === 2 && ![
            100,
            50
        ].includes(firstRoundedPercentage) && (0, $3E8Nt.getRandomInt)(0, 100) <= percentagesChance) {
            // Round percentages to 10s
            const secondRoundedPercentage = Math.floor(weights[1][1] / 10) * 10;
            predictionText = `${firstRoundedPercentage}% ${weights[0][0].name}, ${secondRoundedPercentage}% ${weights[1][0].name}.`;
        } else if (match.hype < 40 && !matchGimmick && (0, $3E8Nt.getRandomInt)(0, 100) <= noContestChance) predictionText = "No Contest";
        else {
            // Get win/retain text
            const winWord = winner.objectName === "superstar" ? "wins" : "win";
            const retainWord = winner.objectName === "superstar" ? "retains" : "retain";
            let predictionWord;
            if (championships.length === 1) {
                const championshipSuperstarIds = championships.map((x)=>x.superstarId);
                const winnerSuperstarIds = (await (0, $5kTkA.getRosterMemberSuperstars)(winner)).map((x)=>x.$loki);
                // Check if any winner superstar holds match championship
                if (winnerSuperstarIds.some((x)=>championshipSuperstarIds.includes(x))) predictionWord = retainWord;
                else if (championships.some((x)=>x.matchContract || x.championshipContract)) {
                    const titleWord = winner.objectName === "superstar" ? "contract" : "contracts";
                    predictionWord = `${winWord} the ${titleWord}`;
                } else {
                    const titleWord = winner.objectName === "superstar" ? "title" : "titles";
                    predictionWord = `${winWord} the ${titleWord}`;
                }
            } else predictionWord = winWord;
            // Match finish text chance if title didn't change hands and not gimmick match and not face win
            if ((!championships.length || championships.length === 1 && predictionWord === retainWord) && await (0, $3E8Nt.getRosterMemberAlignment)(winner) !== "face" && !matchGimmick && (0, $3E8Nt.getRandomInt)(0, 100) <= matchFinishTextChance) {
                const matchFinishes = (0, $6hwt2.matchFinishesData).filter((x)=>x.category === "dusty");
                if (matchFinishes.length) {
                    const matchFinish = (0, $3E8Nt.getRandomChoice)(matchFinishes);
                    if (matchFinish.name) predictionWord += ` via ${matchFinish.name}`;
                }
            }
            predictionText = `${winner.name} ${predictionWord}.`;
        }
        predictions.push({
            "matchText": await $45c916186f207ab3$export$c30622051d8fc8ec(match, false, true),
            "predictionText": predictionText
        });
    }
    // Get journalist data
    const journalistData = $45c916186f207ab3$export$6817ac6e7f300c2b();
    data["journalistName"] = journalistData.name;
    data["journalistPossessivePronoun"] = journalistData.possessivePronoun;
    data["predictions"] = predictions;
    return data;
}
function $45c916186f207ab3$export$6817ac6e7f300c2b() {
    const data = {};
    const gender = (0, $3E8Nt.getRandomChoice)([
        "male",
        "female"
    ]);
    const name = (0, $3E8Nt.generateName)(gender);
    const possessivePronoun = gender === "male" ? "his" : "her";
    data["name"] = name;
    data["possessivePronoun"] = possessivePronoun;
    return data;
}
async function $45c916186f207ab3$var$getEventPreviewParticipantLabel(participant, championshipsSuperstarIds) {
    // Add champion label if champion
    const superstars = await (0, $5kTkA.getRosterMemberSuperstars)(participant);
    if (superstars.some((x)=>championshipsSuperstarIds.includes(x.$loki))) return `${participant.name} (c)`;
    else return participant.name;
}
function $45c916186f207ab3$var$getStreakAdjective(length) {
    // Get adjective for streak length for event preview
    if (length < 5) return "budding";
    else if (length < 10) return "remarkable";
    else if (length < 20) return "fantastic";
    else return "legendary";
}

});
parcelRequire.register("6RCLU", function(module, exports) {

$parcel$export(module.exports, "getMatchData", () => $4ff5c4925572972c$export$c5b257e384b09f);
$parcel$export(module.exports, "getMatchRefereeSuperstar", () => $4ff5c4925572972c$export$282105ae99b45659);
$parcel$export(module.exports, "getGimmickMatchForGraphic", () => $4ff5c4925572972c$export$9f130f338ade43ad);
$parcel$export(module.exports, "getGimmickMatchGraphic", () => $4ff5c4925572972c$export$df685982e326a600);
$parcel$export(module.exports, "checkHangChampionships", () => $4ff5c4925572972c$export$be683621f1503c2e);
$parcel$export(module.exports, "getMatchParticipantsGraphics", () => $4ff5c4925572972c$export$8073c7b65dd39049);
$parcel$export(module.exports, "getMatchHype", () => $4ff5c4925572972c$export$d63b53e5ce2f4a62);
$parcel$export(module.exports, "getTournamentFinalBonus", () => $4ff5c4925572972c$export$7ea5f0b201e64484);
$parcel$export(module.exports, "getMatchEventTitle", () => $4ff5c4925572972c$export$6f7c2e6808cf4ee7);
$parcel$export(module.exports, "getMatchHistoryData", () => $4ff5c4925572972c$export$7e10c72a263413d5);
$parcel$export(module.exports, "getMatchName", () => $4ff5c4925572972c$export$b1afcf9801cabde3);
$parcel$export(module.exports, "deleteCompanyMatch", () => $4ff5c4925572972c$export$326e659d37b5f9cf);
$parcel$export(module.exports, "deleteMatch", () => $4ff5c4925572972c$export$69744b2cfe59ef30);
$parcel$export(module.exports, "getSuperstarsBookedAtEventMatches", () => $4ff5c4925572972c$export$71b76f28e85dc7ef);
$parcel$export(module.exports, "addMatch", () => $4ff5c4925572972c$export$94f0c78bd7c6b503);
$parcel$export(module.exports, "getAlignmentBoost", () => $4ff5c4925572972c$export$c6866f4a511f3680);
$parcel$export(module.exports, "addGimmickMatchToMatch", () => $4ff5c4925572972c$export$984937cd7bb5cbfb);
$parcel$export(module.exports, "changeMatchOrSegmentOrder", () => $4ff5c4925572972c$export$22f335050a6a4a35);
$parcel$export(module.exports, "removeChampionshipFromMatch", () => $4ff5c4925572972c$export$48ce62ea76fa7b7e);
$parcel$export(module.exports, "getMatchChampionshipsForSelection", () => $4ff5c4925572972c$export$1c43ea4e328aa306);
$parcel$export(module.exports, "changeMatchChampionships", () => $4ff5c4925572972c$export$2c0bff7b5b7d8273);
$parcel$export(module.exports, "getAddMatchManagerSelections", () => $4ff5c4925572972c$export$d184060b3c4d959b);
$parcel$export(module.exports, "addManagerToMatch", () => $4ff5c4925572972c$export$2a4a74af3b288237);
$parcel$export(module.exports, "getRemoveMatchManagerSelections", () => $4ff5c4925572972c$export$fd76dcfdbeeeda1f);
$parcel$export(module.exports, "removeManagerFromMatch", () => $4ff5c4925572972c$export$7192ba6eb91335ab);
$parcel$export(module.exports, "changeTrioTagTeamMembers", () => $4ff5c4925572972c$export$e963b549f107d9ba);
$parcel$export(module.exports, "changeFactionTagTeamMembers", () => $4ff5c4925572972c$export$43684a271e900824);
$parcel$export(module.exports, "addFeudsToMatch", () => $4ff5c4925572972c$export$fa67f969eab6bc3);
$parcel$export(module.exports, "getHypeForMatch", () => $4ff5c4925572972c$export$e390aee79ca4ee9c);
$parcel$export(module.exports, "playMatch", () => $4ff5c4925572972c$export$1008f312072c70e7);
$parcel$export(module.exports, "getRandomOpponent", () => $4ff5c4925572972c$export$132777715c2dcc62);
$parcel$export(module.exports, "selectRandomOpponent", () => $4ff5c4925572972c$export$651233d057b6ab4);
$parcel$export(module.exports, "getAvailableMatchFinishes", () => $4ff5c4925572972c$export$24b09150d265f836);
$parcel$export(module.exports, "getRosterMembersForInterference", () => $4ff5c4925572972c$export$1cf1681ab9b05296);
$parcel$export(module.exports, "getRandomGimmickMatch", () => $4ff5c4925572972c$export$d49e7738724ddb);
$parcel$export(module.exports, "simulateMatchWinnerRequest", () => $4ff5c4925572972c$export$4468841c5ffcfa9a);
$parcel$export(module.exports, "simulateAnnualTournamentMatchWinner", () => $4ff5c4925572972c$export$33d9ac53668f0b38);
$parcel$export(module.exports, "simulateMatchWinner", () => $4ff5c4925572972c$export$5627b598398e8aef);
$parcel$export(module.exports, "getWinLossPercentagesWeights", () => $4ff5c4925572972c$export$7e439ca3578757b0);
$parcel$export(module.exports, "getAnnualTournamentWinLossPercentagesWeights", () => $4ff5c4925572972c$export$8cd12d4a972eea20);
$parcel$export(module.exports, "generateGimmickMatchText", () => $4ff5c4925572972c$export$82313bc1d0e50912);

var $3E8Nt = parcelRequire("3E8Nt");

var $972Ip = parcelRequire("972Ip");

var $i7bmn = parcelRequire("i7bmn");

var $hBIDz = parcelRequire("hBIDz");

var $kZwpB = parcelRequire("kZwpB");

var $5kTkA = parcelRequire("5kTkA");

var $ko5kE = parcelRequire("ko5kE");

var $5ZsVo = parcelRequire("5ZsVo");

var $cXLSF = parcelRequire("cXLSF");

var $iRMwH = parcelRequire("iRMwH");

var $8A6FL = parcelRequire("8A6FL");

var $iQtzn = parcelRequire("iQtzn");

var $9esFv = parcelRequire("9esFv");

var $14eBR = parcelRequire("14eBR");

var $4EGpv = parcelRequire("4EGpv");

var $ivuOU = parcelRequire("ivuOU");

var $4ptHI = parcelRequire("4ptHI");

var $dl5u4 = parcelRequire("dl5u4");

var $98xmD = parcelRequire("98xmD");

var $ycsyu = parcelRequire("ycsyu");

var $2JFAd = parcelRequire("2JFAd");

var $1JSre = parcelRequire("1JSre");

var $cYLJ6 = parcelRequire("cYLJ6");

var $aP7lq = parcelRequire("aP7lq");

var $1AAHK = parcelRequire("1AAHK");

var $jpMCP = parcelRequire("jpMCP");

var $6hwt2 = parcelRequire("6hwt2");

var $6PzHO = parcelRequire("6PzHO");

var $3SyPM = parcelRequire("3SyPM");

var $bZol7 = parcelRequire("bZol7");

var $3MfBd = parcelRequire("3MfBd");
async function $4ff5c4925572972c$export$c5b257e384b09f({ match: match, cashinSingles: cashinSingles = false, cashinTag: cashinTag = false, cashinTrios: cashinTrios = false, history: history = false, getChampionshipsAvailable: getChampionshipsAvailable = true, play: play = false, companyChampionships: companyChampionships = null, rosterSuperstars: rosterSuperstars = null, game: game = null } = {}) {
    let matchData = {};
    let matchParticipants = (await (0, $i7bmn.getMatchParticipants)(match)).reverse();
    matchParticipants.reverse();
    let matchSuperstars = await (0, $i7bmn.getAllSuperstarsForMatch)(match);
    let matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
    let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
    let matchEvent = await (0, $i7bmn.getMatchEvent)(match);
    let canCashin = false;
    const refereeSuperstar = await $4ff5c4925572972c$export$282105ae99b45659(match, rosterSuperstars);
    // Check if trios match, handicap match, get team size
    let trio = false;
    let teamSize;
    let handicapMatch = false;
    if (match.type === "tag") {
        if (matchParticipants.length > 0) {
            const firstTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(matchParticipants[0]);
            teamSize = firstTeamSuperstars.length;
            trio = matchParticipants[0].trio;
            // Check for handicap match by checking if any teams have unequal superstars
            for (const matchParticipant of matchParticipants)if ((await (0, $972Ip.getTagTeamSuperstars)(matchParticipant)).length !== firstTeamSuperstars.length) {
                handicapMatch = true;
                break;
            }
        } else teamSize = trio ? 3 : 2;
    }
    // Get handicap size
    if (handicapMatch) matchData["handicapSize"] = await $4ff5c4925572972c$var$getMatchHandicapSize(matchParticipants);
    // Get match championships data
    matchData["championships"] = [];
    matchChampionships.sort((0, $kZwpB.compareChampionships));
    matchChampionships.forEach((x)=>{
        let championshipData = (0, $kZwpB.getChampionshipMatchData)(x);
        matchData["championships"].push(championshipData);
        // Check if championship can be cashed in on
        if (!x.championshipContract && (cashinSingles || cashinTag && !trio || cashinTrios && trio)) canCashin = true;
    });
    let participantsData = [];
    // Get deeper data when playing match
    if (play) for (const matchParticipant of matchParticipants){
        let participantData;
        if (match.type === "singles") participantData = await (0, $5kTkA.getSuperstarDisplayData)({
            superstar: matchParticipant,
            rosterSuperstars: rosterSuperstars,
            managersUsed: match.managersUsed,
            game: game
        });
        else participantData = await (0, $ko5kE.getTagTeamDisplayData)({
            tagTeam: matchParticipant,
            rosterSuperstars: rosterSuperstars,
            managersUsed: match.managersUsed,
            game: game
        });
        participantsData.push(participantData);
    }
    else {
        const dataFunction = match.type === "singles" ? (0, $5kTkA.getSuperstarMatchOrSegmentData) : (0, $ko5kE.getTagTeamMatchData);
        for (const matchParticipant of matchParticipants){
            const participantData = await dataFunction(matchParticipant, matchChampionships, match.managersUsed, rosterSuperstars);
            participantsData.push(participantData);
        }
    }
    // Check if championships available for match
    if (getChampionshipsAvailable && !handicapMatch && matchParticipants.length > 0) {
        // Find available championships from match participants and vacated championships
        let availableChampionshipsData = await (0, $kZwpB.getMatchAvailableChampionships)(matchParticipants, matchSuperstars, companyChampionships, matchGimmick, matchEvent);
        let availableChampionships = availableChampionshipsData["availableChampionships"];
        availableChampionships.push(...(0, $kZwpB.getVacatedChampionshipsForMatch)(match, companyChampionships, trio));
        if (availableChampionships.length > 0) matchData["championshipsAvailable"] = true;
    }
    // If playing match and trioTagTeam are tag champions, transfer tag titles to participating members
    if (play && match.type === "tag") {
        for (let matchParticipant of matchParticipants)if (matchParticipant.trioTagTeam) {
            let trioTagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(matchParticipant);
            // Get trio superstars
            const teamTrio = (await (0, $hBIDz.getSuperstarTagTeams)(trioTagTeamSuperstars[0])).find((x)=>x.trio);
            const trioSuperstars = teamTrio ? await (0, $972Ip.getTagTeamSuperstars)(teamTrio) : [];
            const trioSuperstarsIds = trioSuperstars.map((x)=>x.$loki);
            // Get all tag team title sets
            let tagChampionshipSets = (0, $kZwpB.getTagChampionshipsSets)(companyChampionships.filter((x)=>x.tagTeam));
            // Check if each team title is held by a superstar of this team and one is present in match
            let foundTagChampionshipSets = [];
            for (let c of tagChampionshipSets)if (c.every((x)=>trioSuperstarsIds.includes(x.superstarId)) && c.some((x)=>(0, $3E8Nt.objectInArray)(x, matchChampionships))) foundTagChampionshipSets.push(c);
            // Transfer each pair of tag titles to participating members
            for (const championshipsSet of foundTagChampionshipSets)for (const [i, c] of Object.entries(championshipsSet))await (0, $hBIDz.addSuperstarChampionships)(trioTagTeamSuperstars[i], [
                c
            ]);
        }
    }
    // Get gimmick match graphic
    let gimmickMatchForGraphic = await $4ff5c4925572972c$export$9f130f338ade43ad(matchGimmick, match);
    let gimmickMatchGraphic = $4ff5c4925572972c$export$df685982e326a600(gimmickMatchForGraphic);
    // Get championships to remove from graphics
    let hangChampionships = $4ff5c4925572972c$export$be683621f1503c2e(gimmickMatchGraphic);
    let championshipsToRemove = hangChampionships ? [
        ...matchChampionships
    ] : [];
    // Get graphics
    if (play) {
        let participantChampionships = [];
        for (const matchSuperstar of matchSuperstars)participantChampionships = [
            ...participantChampionships,
            ...await (0, $hBIDz.getSuperstarChampionships)(matchSuperstar)
        ];
        matchData["graphics"] = await $4ff5c4925572972c$export$8073c7b65dd39049(match, matchParticipants, participantChampionships, matchSuperstars, rosterSuperstars, refereeSuperstar, gimmickMatchForGraphic, championshipsToRemove);
        matchData["gimmickMatchGraphic"] = gimmickMatchGraphic;
        if (hangChampionships) {
            // Get top match championships to hang (get sets)
            let availableHangingChampionships = [];
            for (const c of matchChampionships)if (c.graphic) availableHangingChampionships.push(...companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, c)));
            availableHangingChampionships.sort((a, b)=>b.xp - a.xp);
            matchData["hangingChampionships"] = availableHangingChampionships.slice(0, 2).map((x)=>x.graphic);
        }
        // Get other attributes displayed when playing match
        matchData["hype"] = $4ff5c4925572972c$export$d63b53e5ce2f4a62(match);
        matchData["streakBonus"] = match.streakBonus;
        matchData["eventBonus"] = match.eventBonus;
        matchData["contractBonus"] = match.contractBonus;
        matchData["tournamentFinalBonus"] = match.tournamentFinalBonus;
        matchData["canCashin"] = canCashin;
    }
    // Add to data object
    matchData["participants"] = participantsData;
    matchData["uid"] = match.$loki;
    matchData["type"] = match.type;
    matchData["activeEffect"] = match.activeEffect;
    matchData["order"] = match.order;
    matchData["rating"] = match.rating;
    matchData["hidden"] = match.hidden;
    matchData["generated"] = {
        "objectToClaim": match.objectToClaim,
        "location": match.location
    };
    matchData["segmentType"] = "match";
    matchData["gimmick"] = matchGimmick ? matchGimmick.name : "";
    matchData["rules"] = matchGimmick ? matchGimmick.rules : false;
    matchData["consequence"] = matchGimmick ? matchGimmick.consequence : false;
    if (match.type === "tag") {
        matchData["teamType"] = trio ? "trio" : "tag-team";
        matchData["largerTag"] = teamSize > 2 ? teamSize : false;
    }
    matchData["winnerName"] = match.winner ? match.winner : null;
    // Add feuds data
    const matchFeuds = await (0, $i7bmn.getMatchFeuds)(match);
    matchData["feuds"] = await Promise.all(matchFeuds.map((x)=>(0, $cXLSF.getFeudData)(x, true)));
    // Get referee name
    if (refereeSuperstar) matchData["refereeName"] = refereeSuperstar.name;
    // Get tournament
    const matchTournament = await (0, $i7bmn.getMatchTournament)(match);
    if (matchTournament) {
        matchData["tournamentName"] = matchTournament.name;
        matchData["tournamentRound"] = match.tournamentRound;
        matchData["tournamentGroup"] = $4ff5c4925572972c$var$getTournamentGroupName(match.tournamentGroup);
        matchData["tournamentRoundName"] = $4ff5c4925572972c$var$getTournamentRoundName(matchTournament.rounds, match.tournamentRound, match.tournamentGroup);
        if (match.tournamentRound === matchTournament.rounds && !matchTournament.annualTournament) matchData["tournamentFinalBonus"] = $4ff5c4925572972c$export$7ea5f0b201e64484(matchTournament);
    }
    if (history) {
        // Get winner data
        let winnerDict = {};
        winnerDict.name = match.winner;
        winnerDict.championshipsWon = match.championshipsWon;
        winnerDict.championshipsDefended = match.championshipsDefended;
        winnerDict.championshipsRetained = match.championshipsRetained;
        matchData["winner"] = winnerDict;
        // Get losers data
        let losers;
        if (match.loser) losers = [
            match.loser
        ];
        else losers = participantsData.filter((x)=>x.name !== match.winner);
        matchData["losers"] = losers;
        // Get other data
        matchData["text"] = match.generatedText;
        matchData["event"] = await $4ff5c4925572972c$export$6f7c2e6808cf4ee7(match);
        matchData["finishName"] = match.finishName;
        matchData["finishText"] = match.finishText;
    }
    return matchData;
}
function $4ff5c4925572972c$export$7ea5f0b201e64484(tournament) {
    const bonuses = {
        "A": 50,
        "B": 25,
        "C": 12
    };
    return bonuses[tournament.prestige] || 12;
}
function $4ff5c4925572972c$var$getTournamentGroupName(group) {
    const groups = {
        1: "A",
        2: "B",
        3: "C",
        4: "D"
    };
    return groups[group] || "";
}
function $4ff5c4925572972c$var$getTournamentRoundName(tournamentRounds, matchRound, group) {
    if (group !== null) return `Round ${matchRound}`;
    const rounds = {
        0: "Final",
        1: "Semi Finals",
        2: "Quarter Finals",
        3: "Round of 16"
    };
    return rounds[tournamentRounds - matchRound] || `Round ${matchRound}`;
}
function $4ff5c4925572972c$export$d63b53e5ce2f4a62(match) {
    try {
        return match.hype + match.streakBonus + match.eventBonus + match.contractBonus + match.tournamentFinalBonus;
    } catch (error) {
        return match.hype;
    }
}
async function $4ff5c4925572972c$export$6f7c2e6808cf4ee7(match) {
    const event = await (0, $i7bmn.getMatchEvent)(match);
    return (0, $5ZsVo.getEventTitle)(event);
}
async function $4ff5c4925572972c$var$getMatchHandicapSize(matchParticipants) {
    let handicapSize = [];
    for (const matchParticipant of matchParticipants){
        const matchParticipantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(matchParticipant);
        handicapSize.push(matchParticipantSuperstars.length);
    }
    return handicapSize;
}
async function $4ff5c4925572972c$export$282105ae99b45659(match, rosterSuperstars = null) {
    let refereeSuperstar = null;
    if (match.refereeId) {
        if (rosterSuperstars) refereeSuperstar = rosterSuperstars.find((x)=>x.$loki === match.refereeId);
        else refereeSuperstar = await (0, $14eBR.Superstars).get(match.refereeId);
    }
    return refereeSuperstar;
}
async function $4ff5c4925572972c$export$7e10c72a263413d5(match) {
    let matchData = {};
    let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
    const matchTournament = await (0, $i7bmn.getMatchTournament)(match);
    // Get winner data
    let winnerDict = {};
    winnerDict.name = match.winner;
    winnerDict.championshipsWon = match.championshipsWon;
    winnerDict.championshipsDefended = match.championshipsDefended;
    winnerDict.championshipsRetained = match.championshipsRetained;
    matchData["winner"] = winnerDict;
    // Get losers data
    let losers;
    if (match.loser) losers = [
        match.loser
    ];
    else {
        let matchParticipants = (await (0, $i7bmn.getMatchParticipants)(match)).reverse().map((x)=>x.name);
        losers = matchParticipants.filter((x)=>x !== match.winner);
    }
    matchData["losers"] = losers;
    // Get other data
    matchData["rating"] = match.rating;
    matchData["text"] = match.generatedText;
    matchData["event"] = await $4ff5c4925572972c$export$6f7c2e6808cf4ee7(match);
    matchData["gimmick"] = matchGimmick ? matchGimmick.name : "";
    matchData["finishName"] = match.finishName;
    // Get tournament data
    if (matchTournament) {
        matchData["tournamentName"] = matchTournament.name;
        matchData["tournamentGroup"] = $4ff5c4925572972c$var$getTournamentGroupName(match.tournamentGroup);
        matchData["tournamentRoundName"] = $4ff5c4925572972c$var$getTournamentRoundName(matchTournament.rounds, match.tournamentRound, match.tournamentGroup);
    }
    return matchData;
}
async function $4ff5c4925572972c$export$b1afcf9801cabde3(match) {
    const participants = await (0, $i7bmn.getMatchParticipants)(match);
    let participantNames;
    if (participants.length > 10) {
        participantNames = participants.slice(0, 10).map((x)=>x.name);
        let others = participants.length - 10;
        let othersWord = others !== 1 ? "others" : "other";
        participantNames.push(`${others} ${othersWord}`);
    } else participantNames = participants.map((x)=>x.name);
    return participantNames.join(" vs ");
}
async function $4ff5c4925572972c$export$326e659d37b5f9cf({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const producers = await (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
    const match = await (0, $14eBR.Matches).get(uid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Don't allow deleting 'Femme Fatale' match at premier event in POW
    if (userCompany.storyName === "passion") {
        const matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
        const sponsorGoal = (await (0, $9esFv.getCompanyObjectives)(userCompany)).find((x)=>x.name === "Get some Sponsors");
        if (!sponsorGoal.completed && !sponsorGoal.failed && matchGimmick && matchGimmick.name === "Femme Fatale") {
            data["error"] = "pow-cannot-delete";
            return data;
        }
    }
    // Delete match
    let deleteData = await $4ff5c4925572972c$export$69744b2cfe59ef30(match, userCompany);
    let numberOfMatchesDeleted = deleteData[0];
    let tournament = deleteData[1];
    data["deletedPotentialFeudUids"] = deleteData[2];
    // Subtract from event's matchesCount
    latestEvent.matchesCount -= numberOfMatchesDeleted;
    // Check for tournament weekly show
    if (tournament && latestEvent.name === "Weekly Show") {
        data["weeklyShowDeleted"] = true;
        // Delete event
        const eventMatches = await (0, $iQtzn.getEventMatches)(latestEvent);
        const eventSegments = await (0, $iQtzn.getEventSegments)(latestEvent);
        for (const match of eventMatches)await $4ff5c4925572972c$export$69744b2cfe59ef30(match, userCompany);
        for (const segment of eventSegments)await (0, $4ptHI.deleteSegment)(segment, producers);
        await (0, $14eBR.Events).remove(latestEvent);
    }
    // Reset event's matches and segments order
    let segmentsAndMatches = await (0, $5ZsVo.getEventMatchesAndSegments)(latestEvent);
    segmentsAndMatches.sort((a, b)=>a.order - b.order);
    for (const x of segmentsAndMatches)x.order = segmentsAndMatches.indexOf(x);
    (0, $14eBR.db).saveDatabase();
    // Get unbooked (match superstars/tag teams who aren't booked in other matches)
    const bookedSuperstars = await $4ff5c4925572972c$export$71b76f28e85dc7ef(latestEvent);
    const matchSuperstars = deleteData[3];
    data["unbookedMatchSuperstarsUids"] = matchSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, bookedSuperstars)).map((x)=>x.$loki);
    // Get data to return
    data["points"] = userCompany.points;
    return data;
}
async function $4ff5c4925572972c$export$71b76f28e85dc7ef(event) {
    // Includes superstars in singles and tag matches
    const superstarsBooked = [];
    const matches = await (0, $iQtzn.getEventMatches)(event);
    for (const x of matches)superstarsBooked.push(...await (0, $i7bmn.getAllSuperstarsForMatch)(x));
    return (0, $3E8Nt.getUniqueObjects)(superstarsBooked);
}
async function $4ff5c4925572972c$export$69744b2cfe59ef30(match, company) {
    let matches = [
        match
    ];
    let tournament = await (0, $i7bmn.getMatchTournament)(match);
    if (tournament) {
        // Delete tournament's matches
        matches = await (0, $4EGpv.getTournamentMatches)(tournament);
        company.points += tournament.cost;
        await (0, $14eBR.Tournaments).remove(tournament);
    }
    let numberOfMatchesDeleted = matches.length;
    let companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    let deletedPotentialFeudUids = [];
    let matchSuperstars = [];
    let matchTagTeams = [];
    for (const match of matches){
        let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
        let championships = await (0, $i7bmn.getMatchChampionships)(match);
        let feuds = await (0, $i7bmn.getMatchFeuds)(match);
        let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
        // Remove temporary tag teams
        for (const p of matchParticipants){
            for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(p)))matchSuperstars.push(s);
            if (p.objectName === "tagTeam" && p.temporary) await (0, $ko5kE.removeTagTeam)(p);
            if (p.objectName === "tagTeam") matchTagTeams.push(p);
        }
        // Process championships
        for (const c of championships){
            let allChampionships = companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, c));
            // Check if match contract awarded
            let matchContractAwarded = false;
            for (const x of allChampionships)if (x.matchContract) {
                let matchContract = await (0, $ivuOU.getChampionshipMatchContract)(x);
                if (matchContract && matchContract.awarded) {
                    matchContractAwarded = true;
                    break;
                }
            }
            for (const x of allChampionships){
                x.booked = false;
                // Find newly created championship contract and delete it
                if (x.championshipContract) {
                    let reigns = await (0, $ivuOU.getChampionshipChampionshipReigns)(x);
                    if (reigns.length <= 0) await (0, $14eBR.Championships).remove(x);
                }
                // Find newly created match contract and remove it
                if (x.matchContract && !matchContractAwarded) {
                    let matchContract = await (0, $ivuOU.getChampionshipMatchContract)(x);
                    if (matchContract) await (0, $14eBR.MatchContracts).remove(matchContract);
                    await (0, $14eBR.Championships).remove(x);
                }
            }
        }
        // Refund gimmick match points
        if (matchGimmick) company.points += matchGimmick.cost;
        // Refund used powerups
        if (match.activeEffect) {
            let powerup = (await (0, $9esFv.getCompanyPowerups)(company)).find((x)=>x.effect === match.activeEffect);
            if (powerup) powerup.stock += 1;
        }
        // Remove feuds
        for (const feud of feuds){
            if (feud.started && feud.runBlowoff) feud.runBlowoff = false;
            // Delete potential feuds
            if (!feud.started && !feud.directFeudEvent) {
                await (0, $14eBR.FeudParticipantsHash).findAndRemove({
                    "feudId": feud.$loki
                });
                deletedPotentialFeudUids.push(feud.$loki);
                await (0, $14eBR.Feuds).remove(feud);
            }
        }
        // Delete match from db
        await (0, $14eBR.FeudMatchesHash).findAndRemove({
            "matchId": match.$loki
        });
        await (0, $14eBR.MatchesHash).findAndRemove({
            "matchId": match.$loki
        });
        try {
            await (0, $14eBR.Matches).remove(match);
        } catch  {}
    }
    return [
        numberOfMatchesDeleted,
        tournament,
        deletedPotentialFeudUids,
        matchSuperstars,
        matchTagTeams
    ];
}
async function $4ff5c4925572972c$export$94f0c78bd7c6b503({ participantsData: participantsData, selectedGimmickMatchUid: selectedGimmickMatchUid, selectedGimmickMatchName: selectedGimmickMatchName, selectedChampionshipUid: selectedChampionshipUid, matchEventUid: matchEventUid, gimmickMatchObject: gimmickMatchObject, fallGimmickNames: fallGimmickNames, refereeUid: refereeUid, tagTeamSize: tagTeamSize, handicapSize: handicapSize, singlesTag: singlesTag, matchType: matchType, tagMatchOptionSelected: tagMatchOptionSelected } = {}) {
    let data = {};
    try {
        const currentGame = await (0, $3E8Nt.getCurrentGame)();
        const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
        const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
        const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(userCompany);
        const eventMatchesAndSegments = await (0, $5ZsVo.getEventMatchesAndSegments)(latestEvent);
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
        const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        const productionFacility = (await (0, $9esFv.getCompanyFacilities)(userCompany)).find((x)=>x.name === "Production");
        const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
        // Check match/segment limit
        const maximumMatchesAndSegments = (0, $5ZsVo.getEventMaximumMatchesAndSegments)(latestEvent, parentEvents, productionFacility);
        if (eventMatchesAndSegments.length >= maximumMatchesAndSegments) {
            data["error"] = "match-and-segment-limit";
            data["limit"] = maximumMatchesAndSegments;
            return data;
        }
        // Check for production packages only
        if (latestEvent.activeEffect === "production_packages_only") {
            data["error"] = "production-packages-only";
            return data;
        }
        // Get participants
        let matchParticipants = [];
        if (singlesTag) {
            // Get selected superstars
            let superstars = [];
            for (const x of participantsData){
                let participant = rosterSuperstars.find((y)=>y.$loki === x.uid);
                // Check participant
                if (!participant) {
                    data["error"] = "not-found";
                    return data;
                }
                if ((0, $3E8Nt.objectInArray)(participant, matchParticipants)) {
                    data["error"] = "same";
                    return data;
                }
                superstars.push(participant);
            }
            // Divide superstars into teams
            let teamsData;
            if (handicapSize) {
                // Check max team size
                let maxTeamSize = 10;
                let teamASize = handicapSize[0];
                let teamBSize = handicapSize[1];
                if (teamASize > maxTeamSize || teamBSize > maxTeamSize) {
                    data["error"] = "max-team-size";
                    data["maxTeamSize"] = maxTeamSize;
                    return data;
                }
                // Split superstars into chunks using handicap size
                teamsData = [
                    superstars.slice(0, teamASize),
                    superstars.slice(teamASize, teamASize + teamBSize)
                ];
            } else {
                // Check max team size
                let maxTeamSize = 5;
                if (tagTeamSize > maxTeamSize) {
                    data["error"] = "max-team-size";
                    data["maxTeamSize"] = maxTeamSize;
                    return data;
                }
                // Split superstars into chunks of team size
                teamsData = (0, $3E8Nt.getChunks)(superstars, tagTeamSize);
            }
            for (const teamSuperstars of teamsData){
                // Find existing tag team
                let existingTagTeam;
                for (const tagTeam of (await (0, $hBIDz.getSuperstarTagTeams)(teamSuperstars[0])))if ((0, $3E8Nt.checkAreObjArraysEqual)(await (0, $972Ip.getTagTeamSuperstars)(tagTeam), teamSuperstars)) {
                    existingTagTeam = tagTeam;
                    break;
                }
                if (existingTagTeam) matchParticipants.push(existingTagTeam);
                else {
                    // Find existing faction
                    let existingFaction;
                    for (const faction of (await (0, $5kTkA.getSuperstarActiveFactions)(teamSuperstars[0]))){
                        let factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
                        if (teamSuperstars.every((s)=>(0, $3E8Nt.objectInArray)(s, factionSuperstars))) {
                            existingFaction = faction;
                            break;
                        }
                    }
                    // Get team name. Use faction name if found.
                    let teamName;
                    if (existingFaction) {
                        if ((0, $3E8Nt.checkAreObjArraysEqual)(await (0, $2JFAd.getFactionSuperstars)(existingFaction), teamSuperstars)) teamName = existingFaction.name;
                        else {
                            let teamSuperstarsNames = (0, $3E8Nt.commaSeparate)([
                                ...teamSuperstars
                            ].sort((a, b)=>a.$loki - b.$loki).map((y)=>(0, $5kTkA.getSuperstarLastName)(y)));
                            teamName = `${existingFaction.name} (${teamSuperstarsNames})`;
                        }
                    } else teamName = (0, $3E8Nt.commaSeparate)([
                        ...teamSuperstars
                    ].sort((a, b)=>a.$loki - b.$loki).map((y)=>y.name));
                    // Create temporary tag team
                    const newTagTeam = (0, $972Ip.TagTeam)(teamName, true);
                    await (0, $14eBR.TagTeams).insert(newTagTeam);
                    await (0, $972Ip.addTagTeamSuperstars)(newTagTeam, teamSuperstars);
                    await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
                        newTagTeam
                    ]);
                    matchParticipants.push(newTagTeam);
                }
            }
        } else for (const x of participantsData){
            let participant;
            if (x.type === "superstar") participant = rosterSuperstars.find((y)=>y.$loki === x.uid);
            else if (x.type === "tag-team" || x.type === "trio") participant = await (0, $14eBR.TagTeams).get(x.uid);
            else if (x.type === "faction") participant = await (0, $14eBR.Factions).get(x.uid);
            // Check participant
            if (!participant) {
                data["error"] = "not-found";
                return data;
            }
            if ((0, $3E8Nt.objectInArray)(participant, matchParticipants)) {
                data["error"] = "same";
                return data;
            }
            // If faction selected or trio selected in tag match, create temporary tag team
            if (participant.objectName === "faction" || participant.trio && tagMatchOptionSelected === "Tag") {
                let teamSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participant);
                let availableTeamSuperstars = teamSuperstars.filter((y)=>(0, $5kTkA.checkAvailability)(y, false) && (0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, y, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(y, companyChampionships)));
                // Check if enough team superstars available
                let minimumAvailableSuperstars = tagMatchOptionSelected === "Trio" ? 3 : 2;
                if (availableTeamSuperstars.length < minimumAvailableSuperstars) {
                    data["error"] = "not-available";
                    return data;
                }
                // Create temporary tag team
                let temporaryTeamSuperstars = (0, $3E8Nt.getRandomSample)(availableTeamSuperstars, minimumAvailableSuperstars);
                let temporaryTeamSuperstarsNames = (0, $3E8Nt.commaSeparate)([
                    ...temporaryTeamSuperstars
                ].sort((a, b)=>a.$loki - b.$loki).map((y)=>(0, $5kTkA.getSuperstarLastName)(y)));
                let teamName = `${participant.name} (${temporaryTeamSuperstarsNames})`;
                const newTagTeam = (0, $972Ip.TagTeam)(teamName, true);
                if (participant.objectName === "tagTeam") newTagTeam.trioTagTeam = true;
                else if (participant.objectName === "faction") newTagTeam.factionTagTeam = true;
                await (0, $14eBR.TagTeams).insert(newTagTeam);
                await (0, $972Ip.addTagTeamSuperstars)(newTagTeam, temporaryTeamSuperstars);
                await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
                    newTagTeam
                ]);
                matchParticipants.push(newTagTeam);
            } else matchParticipants.push(participant);
        }
        // Get participant superstars
        let participantSuperstars = (await Promise.all(matchParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        // Check if any superstars are present twice
        for (const s of participantSuperstars)if (participantSuperstars.filter((x)=>x.$loki === s.$loki).length > 1) {
            data["error"] = "duplicate-superstar";
            data["duplicateSuperstar"] = s.name;
            return data;
        }
        // Check for booking restrictions on event
        let eventActiveEffect = latestEvent.activeEffect;
        if ([
            "no_women_bookable",
            "no_men_bookable"
        ].includes(eventActiveEffect)) for (const s of participantSuperstars){
            if (eventActiveEffect === "no_women_bookable" && s.gender === "female") {
                data["error"] = "no-women-allowed";
                return data;
            } else if (eventActiveEffect === "no_men_bookable" && s.gender === "male") {
                data["error"] = "no-men-allowed";
                return data;
            }
        }
        // Get gimmick match data
        let gimmickMatch;
        let matchChampionship;
        let generatedObject;
        let generatedLocation;
        if (selectedGimmickMatchUid) {
            // Get gimmick match
            gimmickMatch = await (0, $14eBR.GimmickMatches).get(selectedGimmickMatchUid);
            if (!gimmickMatch) {
                data["error"] = "gimmick-match-not-found";
                return data;
            }
            // Get custom object/location
            if (gimmickMatchObject) {
                if (selectedGimmickMatchName === "Brawl") generatedLocation = "Arena";
                else if (selectedGimmickMatchName === "Pole") generatedObject = "Chair";
                else {
                    let gimmickMatchNameWords = selectedGimmickMatchName.split(" ");
                    if (gimmickMatchNameWords[gimmickMatchNameWords.length - 1] === "Brawl") generatedLocation = selectedGimmickMatchName.split(" Brawl")[0];
                    else if (gimmickMatchNameWords[gimmickMatchNameWords.length - 1] === "Pole") generatedObject = selectedGimmickMatchName.split(" on a Pole")[0];
                }
            }
            // Check gimmick match
            if (userCompany.points < gimmickMatch.cost) {
                data["error"] = "points";
                return data;
            }
            if (gimmickMatch.rules === "2/3_falls" && matchParticipants.length > 2) {
                data["error"] = "2/3-falls-one-on-one";
                return data;
            }
            if ([
                "remove_hair",
                "add_hair",
                "remove_mask",
                "remove_mask_or_hair"
            ].includes(gimmickMatch.consequence)) {
                if (participantSuperstars.some((x)=>!x.graphic || Object.keys(x.graphic).length === 0 || x.graphic["empty_graphic"])) {
                    data["error"] = "graphics-not-present";
                    return data;
                }
                if (gimmickMatch.consequence === "remove_hair") {
                    if (participantSuperstars.some((x)=>x.graphic["hair"]["object"] === 0)) {
                        data["error"] = "hair-not-present";
                        return data;
                    }
                }
                if (gimmickMatch.consequence === "add_hair") {
                    if (participantSuperstars.some((x)=>x.graphic["hair"]["object"] !== 0)) {
                        data["error"] = "hair-present";
                        return data;
                    }
                }
                if (gimmickMatch.consequence === "remove_mask") {
                    if (participantSuperstars.some((x)=>!(0, $5kTkA.checkSuperstarGraphicMask)(x.graphic))) {
                        data["error"] = "mask-not-present";
                        return data;
                    }
                }
                if (gimmickMatch.consequence === "remove_mask_or_hair") {
                    let superstarsWithMask = participantSuperstars.filter((x)=>(0, $5kTkA.checkSuperstarGraphicMask)(x.graphic));
                    let superstarsWithHair = participantSuperstars.filter((x)=>x.graphic["hair"]["object"] !== 0 && !(0, $3E8Nt.objectInArray)(x, superstarsWithMask));
                    if (superstarsWithMask.length <= 0 || superstarsWithHair.length <= 0) {
                        data["error"] = "mask-and-hair-not-present";
                        return data;
                    }
                }
            }
            // TODO LATER test
            if (userCompany.storyName === "mars" && gimmickMatch.name === "Olympus Mons") for (const match of (await (0, $iQtzn.getEventMatches)(latestEvent))){
                let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
                if (matchGimmick && matchGimmick.$loki === gimmickMatch.$loki) {
                    data["error"] = "olympus-mons-already-booked";
                    return data;
                }
            }
            // Create contract championships
            if (gimmickMatch.cashinContractName) {
                // Check for existing championship
                let existingCashinChampionship = companyChampionships.find((x)=>x.name === gimmickMatch.cashinContractName && x.championshipContract);
                if (existingCashinChampionship && existingCashinChampionship.monthsToExpire !== 0) {
                    data["error"] = "cashin-contract-exists";
                    return data;
                }
                matchChampionship = await $4ff5c4925572972c$var$createCashinContractChampionship(gimmickMatch, matchParticipants, userCompany);
            }
            if (gimmickMatch.matchContractName) {
                let existingMatchContractChampionship = companyChampionships.find((x)=>x.name === gimmickMatch.matchContractName && x.matchContract);
                if (existingMatchContractChampionship) {
                    data["error"] = "match-contract-exists";
                    return data;
                }
                matchChampionship = await $4ff5c4925572972c$var$createMatchContractChampionship(gimmickMatch, matchParticipants, userCompany, matchEventUid);
            }
        }
        // Check for women only gimmick match
        let womenOnlyGimmickMatch = gimmickMatch && gimmickMatch.name === "Femme Fatale" && gimmickMatch.special;
        if (womenOnlyGimmickMatch && participantSuperstars.some((x)=>x.gender === "male")) {
            data["error"] = "femme-fatale-men";
            return data;
        }
        // Get match championship if not created and not handicap match
        if (!matchChampionship && !handicapSize) {
            if (selectedChampionshipUid) {
                // Get vacant championship
                matchChampionship = companyChampionships.find((x)=>x.$loki === selectedChampionshipUid);
                if (!matchChampionship) {
                    data["error"] = "championship-not-found";
                    return data;
                }
                // Check for gimmick restriction
                if (!(0, $kZwpB.checkChampionshipGimmickRestriction)(matchChampionship, gimmickMatch, latestEvent, participantSuperstars)) {
                    data["error"] = "gimmick-restriction";
                    data["gimmickRestrictedChampionship"] = {
                        "name": (0, $1JSre.getChampionshipDisplayName)(matchChampionship),
                        "gimmickRestriction": matchChampionship.gimmickRestriction
                    };
                    return data;
                }
            } else {
                // Get participants' championship
                let matchChampionshipsData = await (0, $kZwpB.getMatchAvailableChampionships)(matchParticipants, participantSuperstars, companyChampionships, gimmickMatch, latestEvent, true);
                if (matchChampionshipsData["availableChampionships"].length > 0) matchChampionship = matchChampionshipsData["availableChampionships"][0];
                data["gimmickRestrictedChampionships"] = matchChampionshipsData["gimmickRestrictedChampionships"];
            }
        }
        // Create match
        const newMatch = (0, $i7bmn.Match)(latestEvent.matchesCount, matchType);
        await (0, $14eBR.Matches).insert(newMatch);
        await (0, $iQtzn.addEventMatches)(latestEvent, [
            newMatch
        ]);
        latestEvent.matchesCount += 1;
        // Add participants
        await (0, $i7bmn.addMatchParticipants)(newMatch, matchParticipants);
        // Add championship
        if (matchChampionship) {
            await (0, $i7bmn.addMatchChampionships)(newMatch, [
                matchChampionship
            ]);
            for (const c of (await (0, $9esFv.getCompanyChampionships)(userCompany)).filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, matchChampionship)))c.booked = true;
        }
        // Add gimmick match and its data
        if (gimmickMatch) {
            await (0, $cYLJ6.addGimmickMatchMatches)(gimmickMatch, [
                newMatch
            ]);
            userCompany.points -= gimmickMatch.cost;
            // Add custom object or location
            if (gimmickMatch.generateObject) newMatch.objectToClaim = generatedObject;
            if (gimmickMatch.generateLocation) newMatch.location = generatedLocation;
            // Add fall names
            if (gimmickMatch.rules === "2/3_falls" && fallGimmickNames) newMatch.fallGimmickNames = fallGimmickNames;
            // Add referee id
            if (gimmickMatch.rules === "special_referee" && refereeUid) {
                let refereeSuperstar = await (0, $14eBR.Superstars).get(refereeUid);
                if ((0, $3E8Nt.objectInArray)(refereeSuperstar, participantSuperstars)) {
                    data["error"] = "referee-in-match";
                    return data;
                }
                newMatch.refereeId = refereeSuperstar.$loki;
            }
        }
        // Get all superstars and teams present
        let tagTeamsPresent = [];
        for (const s of participantSuperstars)tagTeamsPresent.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
        tagTeamsPresent = (0, $3E8Nt.getUniqueObjects)(tagTeamsPresent);
        // Find existing feuds and add to match
        let matchFeuds = await (0, $cXLSF.getParticipantFeuds)(participantSuperstars, tagTeamsPresent);
        await (0, $i7bmn.addMatchFeuds)(newMatch, matchFeuds);
        // Start direct feuds
        for (const feud of matchFeuds)if (!feud.started && feud.directFeudEvent && !feud.ended) {
            feud.startMonth = currentGame.monthCount;
            feud.startYear = currentGame.year;
            feud.runBlowoff = false;
        }
        // Reset attires
        for (const s of participantSuperstars)if (s.currentAttire > 0) s.currentAttire = 0;
        // Add managers
        if ((0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(newMatch, participantSuperstars, rosterSuperstars, latestEvent);
        // Check tutorial action
        if (userCompany.storyName === "tutorial") {
            if (matchType === "singles") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
                "add_singles_match",
                "book_feud_match"
            ]);
            else data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
                "add_tag_match",
                "add_vacant_title_match"
            ]);
        }
        (0, $14eBR.db).saveDatabase();
        // Get data to return
        data["match"] = await $4ff5c4925572972c$export$c5b257e384b09f({
            match: newMatch,
            companyChampionships: companyChampionships,
            rosterSuperstars: rosterSuperstars
        });
        data["points"] = userCompany.points;
        data["alignmentBoost"] = await $4ff5c4925572972c$export$c6866f4a511f3680(matchParticipants, userCompany.style);
    } finally{
        if (data["error"]) await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
    }
    return data;
}
async function $4ff5c4925572972c$export$c6866f4a511f3680(participants, style = "entertainment") {
    let alignmentBoost = 0;
    let defaultBoost = style === "pure" ? 5 : 10;
    let traitBoost = 0;
    if (participants.length <= 0) return alignmentBoost;
    let faces = [];
    let heels = [];
    let faceAlignmentBoost = 0;
    let heelAlignmentBoost = 0;
    let traitPenalty = 0;
    for (const x of participants){
        // Get faces and heels
        let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(x);
        if (participantSuperstars.every((x)=>x.alignment === "face")) faces.push(x);
        else if (participantSuperstars.every((x)=>x.alignment === "heel")) heels.push(x);
        // Get traits that affect alignment boost
        for (const superstar of participantSuperstars)for (const trait of superstar.traits){
            let traitData = (0, $aP7lq.traitsData)[trait];
            if (traitData) {
                if (superstar.alignment === "face") {
                    if (traitData["face_alignment_hype_boost"]) faceAlignmentBoost += traitData["face_alignment_hype_boost"];
                    if (traitData["face_alignment_penalty"]) traitPenalty += traitData["face_alignment_penalty"];
                } else if (superstar.alignment === "heel") {
                    if (traitData["heel_alignment_hype_boost"]) heelAlignmentBoost += traitData["heel_alignment_hype_boost"];
                    if (traitData["heel_alignment_penalty"]) traitPenalty += traitData["heel_alignment_penalty"];
                }
            }
        }
    }
    // Face vs heel
    if (faces.length > 0 && heels.length > 0) {
        faceAlignmentBoost = (0, $3E8Nt.limitValueBetweenRange)(faceAlignmentBoost, 0, 10);
        heelAlignmentBoost = (0, $3E8Nt.limitValueBetweenRange)(heelAlignmentBoost, 0, 10);
        traitBoost += faceAlignmentBoost + heelAlignmentBoost;
        traitBoost = (0, $3E8Nt.limitValueBetweenRange)(traitBoost, 0, 20);
        if (style === "pure") traitBoost /= 2;
        alignmentBoost += defaultBoost + traitBoost;
    } else if (heels.length > 1) {
        traitBoost -= heelAlignmentBoost;
        traitBoost = (0, $3E8Nt.limitValueBetweenRange)(traitBoost, -20, 0);
        if (style === "pure") traitBoost /= 2;
        alignmentBoost -= defaultBoost - traitBoost;
    } else if (faces.length > 1) {
        traitBoost += faceAlignmentBoost / 2;
        traitBoost = (0, $3E8Nt.limitValueBetweenRange)(traitBoost, 0, 10);
        if (style === "pure") traitBoost /= 2;
        alignmentBoost += defaultBoost / 2 + traitBoost;
    }
    // Add trait alignment penalty
    traitPenalty = (0, $3E8Nt.limitValueBetweenRange)(traitPenalty, -30, 0);
    alignmentBoost += traitPenalty;
    return alignmentBoost;
}
async function $4ff5c4925572972c$var$createCashinContractChampionship(gimmickMatch, matchParticipants, company) {
    // Get number of championships to create
    let numberOfChampionships = 1;
    if (matchParticipants[0].objectName === "tagTeam") {
        if (matchParticipants[0].trio) numberOfChampionships = 3;
        else numberOfChampionships = 2;
    }
    // Create championships
    let createdChampionships = [];
    for (const x of Array(numberOfChampionships).keys()){
        const newChampionship = (0, $ivuOU.Championship)(gimmickMatch.cashinContractName);
        newChampionship.championshipContract = true;
        newChampionship.monthsToExpire = gimmickMatch.monthsToExpire ? gimmickMatch.monthsToExpire : 12;
        newChampionship.vacated = true;
        newChampionship.rank = "Upper Midcarder";
        if (numberOfChampionships === 2) newChampionship.tagTeam = true;
        else if (numberOfChampionships === 3) newChampionship.trio = true;
        await (0, $14eBR.Championships).insert(newChampionship);
        createdChampionships.push(newChampionship);
    }
    // Add to company
    await (0, $9esFv.addCompanyChampionships)(company, createdChampionships);
    return createdChampionships[0];
}
async function $4ff5c4925572972c$var$createMatchContractChampionship(gimmickMatch, matchParticipants, company, matchEventUid) {
    let bonuses = {
        "C": 12,
        "B": 25,
        "A": 50
    };
    let parentEvent = await (0, $14eBR.Events).get(matchEventUid);
    // Create match contract
    let matchContract = (0, $1AAHK.MatchContract)();
    matchContract.name = gimmickMatch.matchContractName;
    matchContract.awarded = false;
    matchContract.bonus = bonuses[parentEvent.prestige];
    await (0, $14eBR.MatchContracts).insert(matchContract);
    // Add match contract to parent event
    await (0, $iQtzn.addEventMatchContracts)(parentEvent, [
        matchContract
    ]);
    // Get number of championships to create
    let numberOfChampionships = 1;
    if (matchParticipants[0].objectName === "tagTeam") {
        if (matchParticipants[0].trio) numberOfChampionships = 3;
        else numberOfChampionships = 2;
    }
    // Create championships
    let createdChampionships = [];
    for (const x of Array(numberOfChampionships).keys()){
        const newChampionship = (0, $ivuOU.Championship)(gimmickMatch.matchContractName);
        newChampionship.matchContract = true;
        newChampionship.vacated = true;
        newChampionship.rank = "Upper Midcarder";
        if (numberOfChampionships === 2) newChampionship.tagTeam = true;
        else if (numberOfChampionships === 3) newChampionship.trio = true;
        await (0, $14eBR.Championships).insert(newChampionship);
        await (0, $ivuOU.addChampionshipMatchContracts)(newChampionship, [
            matchContract
        ]);
        createdChampionships.push(newChampionship);
    }
    // Add to company
    await (0, $9esFv.addCompanyChampionships)(company, createdChampionships);
    return createdChampionships[0];
}
async function $4ff5c4925572972c$export$984937cd7bb5cbfb({ matchUid: matchUid, gimmickMatchUid: gimmickMatchUid, gimmickMatchName: gimmickMatchName, matchEventUid: matchEventUid, gimmickMatchObject: gimmickMatchObject, fallGimmickNames: fallGimmickNames, refereeUid: refereeUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Get match and participants
    let match = await (0, $14eBR.Matches).get(matchUid);
    let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    let participantSuperstars = (await Promise.all(matchParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    // Get gimmick match
    let gimmickMatch = await (0, $14eBR.GimmickMatches).get(gimmickMatchUid);
    if (!gimmickMatch) {
        data["error"] = "gimmick-match-not-found";
        return data;
    }
    // Check gimmick match
    if (userCompany.points < gimmickMatch.cost) {
        data["error"] = "points";
        return data;
    }
    if (gimmickMatch.rules === "2/3_falls" && matchParticipants.length > 2) {
        data["error"] = "2/3-falls-one-on-one";
        return data;
    }
    if ([
        "remove_hair",
        "add_hair",
        "remove_mask",
        "remove_mask_or_hair"
    ].includes(gimmickMatch.consequence)) {
        if (participantSuperstars.some((x)=>!x.graphic || Object.keys(x.graphic).length === 0 || x.graphic["empty_graphic"])) {
            data["error"] = "graphics-not-present";
            return data;
        }
        if (gimmickMatch.consequence === "remove_hair") {
            if (participantSuperstars.some((x)=>x.graphic["hair"]["object"] === 0)) {
                data["error"] = "hair-not-present";
                return data;
            }
        }
        if (gimmickMatch.consequence === "add_hair") {
            if (participantSuperstars.some((x)=>x.graphic["hair"]["object"] !== 0)) {
                data["error"] = "hair-present";
                return data;
            }
        }
        if (gimmickMatch.consequence === "remove_mask") {
            if (participantSuperstars.some((x)=>!(0, $5kTkA.checkSuperstarGraphicMask)(x.graphic))) {
                data["error"] = "mask-not-present";
                return data;
            }
        }
        if (gimmickMatch.consequence === "remove_mask_or_hair") {
            let superstarsWithMask = participantSuperstars.filter((x)=>(0, $5kTkA.checkSuperstarGraphicMask)(x.graphic));
            let superstarsWithHair = participantSuperstars.filter((x)=>x.graphic["hair"]["object"] !== 0 && !(0, $3E8Nt.objectInArray)(x, superstarsWithMask));
            if (superstarsWithMask.length <= 0 || superstarsWithHair.length <= 0) {
                data["error"] = "mask-and-hair-not-present";
                return data;
            }
        }
    }
    let womenOnlyGimmickMatch = gimmickMatch.name === "Femme Fatale" && gimmickMatch.special;
    if (womenOnlyGimmickMatch && participantSuperstars.some((x)=>x.gender === "male")) {
        data["error"] = "femme-fatale-men";
        return data;
    }
    // TODO LATER test
    if (userCompany.storyName === "mars" && gimmickMatch.name === "Olympus Mons") {
        const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
        for (const match of (await (0, $iQtzn.getEventMatches)(latestEvent))){
            let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
            if (matchGimmick && matchGimmick.$loki === gimmickMatch.$loki) {
                data["error"] = "olympus-mons-already-booked";
                return data;
            }
        }
    }
    // Get referee
    let refereeSuperstar;
    if (gimmickMatch.rules === "special_referee" && refereeUid) {
        refereeSuperstar = await (0, $14eBR.Superstars).get(refereeUid);
        if ((0, $3E8Nt.objectInArray)(refereeSuperstar, participantSuperstars)) {
            data["error"] = "referee-in-match";
            return data;
        }
    }
    // Create contract championships
    let matchChampionship;
    if (gimmickMatch.cashinContractName) {
        if (matchParticipants.length <= 0) {
            data["error"] = "no-participants";
            return data;
        }
        // Check for existing championship
        let existingCashinChampionship = companyChampionships.find((x)=>x.name === gimmickMatch.cashinContractName && x.championshipContract);
        if (existingCashinChampionship && existingCashinChampionship.monthsToExpire !== 0) {
            data["error"] = "cashin-contract-exists";
            return data;
        }
        matchChampionship = await $4ff5c4925572972c$var$createCashinContractChampionship(gimmickMatch, matchParticipants, userCompany);
    }
    if (gimmickMatch.matchContractName) {
        if (matchParticipants.length <= 0) {
            data["error"] = "no-participants";
            return data;
        }
        let existingMatchContractChampionship = companyChampionships.find((x)=>x.name === gimmickMatch.matchContractName && x.matchContract);
        if (existingMatchContractChampionship) {
            data["error"] = "match-contract-exists";
            return data;
        }
        matchChampionship = await $4ff5c4925572972c$var$createMatchContractChampionship(gimmickMatch, matchParticipants, userCompany, matchEventUid);
    }
    // Add gimmick match to match
    await (0, $cYLJ6.addGimmickMatchMatches)(gimmickMatch, [
        match
    ]);
    // Add championship
    if (matchChampionship) {
        await (0, $i7bmn.addMatchChampionships)(match, [
            matchChampionship
        ]);
        for (const c of (await (0, $9esFv.getCompanyChampionships)(userCompany)).filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, matchChampionship)))c.booked = true;
    }
    // Get custom object/location
    let generatedObject;
    let generatedLocation;
    if (gimmickMatchObject) {
        if (gimmickMatchName === "Brawl") generatedLocation = "Arena";
        else if (gimmickMatchName === "Pole") generatedObject = "Chair";
        else {
            let gimmickMatchNameWords = gimmickMatchName.split(" ");
            if (gimmickMatchNameWords[gimmickMatchNameWords.length - 1] === "Brawl") generatedLocation = gimmickMatchName.split(" Brawl")[0];
            else if (gimmickMatchNameWords[gimmickMatchNameWords.length - 1] === "Pole") generatedObject = gimmickMatchName.split(" on a Pole")[0];
        }
    }
    // Add custom object or location
    if (gimmickMatch.generateObject) match.objectToClaim = generatedObject;
    if (gimmickMatch.generateLocation) match.location = generatedLocation;
    // Add fall names
    if (gimmickMatch.rules === "2/3_falls" && fallGimmickNames) match.fallGimmickNames = fallGimmickNames;
    // Add referee
    if (refereeSuperstar) match.refereeId = refereeSuperstar.$loki;
    // Subtract points
    userCompany.points -= gimmickMatch.cost;
    // Check tutorial action
    if (userCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
        "add_gimmick_to_match"
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["match"] = await $4ff5c4925572972c$export$c5b257e384b09f({
        match: match,
        companyChampionships: companyChampionships,
        rosterSuperstars: rosterSuperstars
    });
    data["points"] = userCompany.points;
    return data;
}
async function $4ff5c4925572972c$export$22f335050a6a4a35({ uid: uid, objectName: objectName, position: position } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const segmentsAndMatches = await (0, $5ZsVo.getEventMatchesAndSegments)(latestEvent);
    segmentsAndMatches.sort((a, b)=>a.order - b.order);
    // Get match or segment
    let matchOrSegment = segmentsAndMatches.find((x)=>x.$loki === uid && x.objectName === objectName);
    // Reorder other matches and segments
    for (const x of segmentsAndMatches)if (x !== matchOrSegment) {
        if (position <= x.order && x.order < matchOrSegment.order) x.order += 1;
        else if (matchOrSegment.order < x.order && x.order <= position) x.order -= 1;
    }
    // Change order or selected match or segment
    matchOrSegment.order = position;
    // Check tutorial action
    if (userCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
        "move_to_main_event"
    ]);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $4ff5c4925572972c$export$48ce62ea76fa7b7e({ matchUid: matchUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    // Remove match's championships
    let matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
    for (const championship of matchChampionships){
        await (0, $i7bmn.removeMatchChampionships)(match, [
            championship
        ]);
        for (const x of companyChampionships.filter((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(y, championship)))x.booked = false;
    }
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["championshipUid"] = matchChampionships[0].$loki;
    return data;
}
async function $4ff5c4925572972c$export$1c43ea4e328aa306({ matchUid: matchUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    // Get available championships
    let matchParticipants = (await (0, $i7bmn.getMatchParticipants)(match)).reverse();
    let matchSuperstars = await (0, $i7bmn.getAllSuperstarsForMatch)(match);
    let trio = matchParticipants.length > 0 ? (await (0, $972Ip.getTagTeamSuperstars)(matchParticipants[0])).length === 3 : false;
    let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
    let matchEvent = await (0, $i7bmn.getMatchEvent)(match);
    let availableChampionshipsData = await (0, $kZwpB.getMatchAvailableChampionships)(matchParticipants, matchSuperstars, companyChampionships, matchGimmick, matchEvent);
    let availableChampionships = availableChampionshipsData["availableChampionships"];
    availableChampionships.push(...(0, $kZwpB.getVacatedChampionshipsForMatch)(match, companyChampionships, trio));
    // If match championships not all in available championships (e.g match to award match contract), add to it
    let matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
    for (const championship of matchChampionships)if (!(0, $3E8Nt.objectInArray)(championship, availableChampionships)) availableChampionships.push(championship);
    // Get data to return
    data["championships"] = [];
    let matchChampionshipNames = matchChampionships.map((x)=>x.name);
    for (const c of availableChampionships)data["championships"].push({
        "name": c.name,
        "uid": c.$loki,
        "present": matchChampionshipNames.includes(c.name)
    });
    return data;
}
async function $4ff5c4925572972c$export$2c0bff7b5b7d8273({ matchUid: matchUid, selectedChampionshipsUids: selectedChampionshipsUids } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    // Get championships to add
    let championshipsToAdd = [];
    for (const x of selectedChampionshipsUids){
        let championship = await (0, $14eBR.Championships).get(x);
        if (championship) championshipsToAdd.push(championship);
    }
    // Check for gimmick restriction / booked
    let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
    let matchEvent = await (0, $i7bmn.getMatchEvent)(match);
    let matchSuperstars = await (0, $i7bmn.getAllSuperstarsForMatch)(match);
    let matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
    for (const x of championshipsToAdd){
        if (!(0, $kZwpB.checkChampionshipGimmickRestriction)(x, matchGimmick, matchEvent, matchSuperstars)) {
            data["error"] = "gimmick-restriction";
            data["gimmickRestrictedChampionship"] = {
                "name": (0, $1JSre.getChampionshipDisplayName)(x),
                "gimmickRestriction": x.gimmickRestriction
            };
            return data;
        }
        if (x.booked && !(0, $3E8Nt.objectInArray)(x, matchChampionships)) {
            data["error"] = "already-booked";
            data["championshipName"] = (0, $1JSre.getChampionshipDisplayName)(x);
            data["championshipTag"] = x.tagTeam || x.trio;
            return data;
        }
    }
    // Remove match's championships
    for (const championship of matchChampionships){
        await (0, $i7bmn.removeMatchChampionships)(match, [
            championship
        ]);
        for (const x of companyChampionships.filter((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(y, championship)))x.booked = false;
    }
    // Add championships to match
    for (const championship of championshipsToAdd){
        await (0, $i7bmn.addMatchChampionships)(match, [
            championship
        ]);
        for (const x of companyChampionships.filter((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(y, championship)))x.booked = true;
    }
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["match"] = await $4ff5c4925572972c$export$c5b257e384b09f({
        match: match,
        companyChampionships: companyChampionships
    });
    data["championships"] = [];
    for (const x of championshipsToAdd){
        let championshipData = (0, $kZwpB.getChampionshipMatchData)(x);
        let championshipHolder = await (0, $kZwpB.getChampionshipHolder)(x);
        if (championshipHolder) championshipData["holder"] = championshipHolder.name;
        data["championships"].push(championshipData);
    }
    return data;
}
async function $4ff5c4925572972c$export$d184060b3c4d959b({ matchUid: matchUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get match participants
    let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    data["matchParticipants"] = matchParticipants.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    // Get partner superstars
    let partnerSuperstars = [];
    let matchSuperstars = (await Promise.all(matchParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    for (const superstar of matchSuperstars){
        let superstarFactions = await (0, $5kTkA.getSuperstarActiveFactions)(superstar);
        let superstarTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(superstar)).filter((x)=>!x.temporary);
        for (const faction of superstarFactions)partnerSuperstars.push(...await (0, $2JFAd.getFactionSuperstars)(faction));
        for (const tagTeam of superstarTagTeams)partnerSuperstars.push(...await (0, $972Ip.getTagTeamSuperstars)(tagTeam));
    }
    // Get available superstars
    let availableSuperstars = rosterSuperstars.filter((x)=>(0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships)) && !(0, $3E8Nt.objectInArray)(x, matchSuperstars));
    // Get manager selections
    data["managerSelections"] = availableSuperstars.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki,
            "partnerSuperstar": (0, $3E8Nt.objectInArray)(x, partnerSuperstars)
        };
    });
    data["managerSelections"].sort((a, b)=>a.name.localeCompare(b.name));
    return data;
}
async function $4ff5c4925572972c$export$2a4a74af3b288237({ matchUid: matchUid, participantUid: participantUid, managerUid: managerUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get participant
    let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    let participant = matchParticipants.find((x)=>x.$loki === participantUid);
    if (!participant) {
        data["error"] = "participant-not-found";
        return data;
    }
    // Get manager
    let manager = rosterSuperstars.find((x)=>x.$loki === managerUid);
    if (!manager) {
        data["error"] = "manager-not-found";
        return data;
    }
    // Don't allow if any participant superstar already has manager assigned
    let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participant);
    if (!match.managersUsed) match.managersUsed = {};
    for (const s of participantSuperstars)if (match.managersUsed[String(s.$loki)]) {
        data["error"] = "manager-assigned";
        data["participantName"] = participant.name;
        return data;
    }
    // Don't allow if manager already managing someone in match or in match superstars
    let matchSuperstars = (await Promise.all(matchParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    if (Object.values(match.managersUsed).includes(manager.$loki) || (0, $3E8Nt.objectInArray)(manager, matchSuperstars)) {
        data["error"] = "manager-in-match";
        data["managerName"] = manager.name;
        return data;
    }
    // Check if manager available
    if (!(0, $5kTkA.checkSuperstarSegmentAvailability)(manager) || !(0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, manager, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(manager, companyChampionships))) {
        data["error"] = "manager-not-available";
        data["managerName"] = manager.name;
        return data;
    }
    // Add manager to match
    (0, $ycsyu.addSuperstarManagerToMatchOrSegment)(match, participantSuperstars[0], manager);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["match"] = await $4ff5c4925572972c$export$c5b257e384b09f({
        match: match,
        companyChampionships: companyChampionships,
        rosterSuperstars: rosterSuperstars
    });
    return data;
}
async function $4ff5c4925572972c$export$fd76dcfdbeeeda1f({ matchUid: matchUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get manager selections from match.managersUsed
    data["managerSelections"] = [];
    for (const [superstarUid, managerUid] of Object.entries(match.managersUsed)){
        let manager = rosterSuperstars.find((x)=>x.$loki === managerUid);
        if (manager) data["managerSelections"].push({
            "name": manager.name,
            "superstarUid": Number(superstarUid)
        });
    }
    data["managerSelections"].sort((a, b)=>a.name.localeCompare(b.name));
    return data;
}
async function $4ff5c4925572972c$export$7192ba6eb91335ab({ matchUid: matchUid, superstarUid: superstarUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get superstar
    let superstar = rosterSuperstars.find((x)=>x.$loki === superstarUid);
    if (!superstar) {
        data["error"] = "superstar-not-found";
        return data;
    }
    // Check if superstar's manager is assigned in match
    if (!match.managersUsed[String(superstar.$loki)]) {
        data["error"] = "manager-not-assigned";
        return data;
    }
    // Remove manager from match
    (0, $ycsyu.removeSuperstarManagerFromMatchOrSegment)(match, superstar);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["match"] = await $4ff5c4925572972c$export$c5b257e384b09f({
        match: match,
        companyChampionships: companyChampionships,
        rosterSuperstars: rosterSuperstars
    });
    return data;
}
async function $4ff5c4925572972c$export$e963b549f107d9ba({ matchUid: matchUid, teamName: teamName, selectedMembers: selectedMembers } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get team
    let matchTeams = await (0, $i7bmn.getMatchParticipants)(match);
    let team = matchTeams.find((x)=>x.name === teamName);
    if (!team) {
        data["error"] = "team-not-found";
        return data;
    }
    // Get trio
    let oldMembers = await (0, $972Ip.getTagTeamSuperstars)(team);
    let trio = (await (0, $hBIDz.getSuperstarTagTeams)(oldMembers[0])).find((x)=>x.trio);
    // Get new members
    let newMembers = [];
    let trioSuperstars = await (0, $972Ip.getTagTeamSuperstars)(trio);
    for (const name of selectedMembers){
        let newMember = trioSuperstars.find((x)=>x.name === name);
        if (!newMember) {
            data["error"] = "team-members-not-found";
            return data;
        }
        newMembers.push(newMember);
    }
    // Check new members
    let refereeSuperstar = rosterSuperstars.find((x)=>x.$loki === match.refereeId);
    for (const x of newMembers){
        if (!(0, $5kTkA.checkAvailability)(x, false) || !(0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships))) {
            data["error"] = "member-not-available";
            data["memberName"] = x.name;
            return data;
        }
        if (refereeSuperstar && refereeSuperstar.$loki === x.$loki) {
            data["error"] = "referee-in-match";
            return data;
        }
    }
    // Check for booking restrictions on event
    let eventActiveEffect = latestEvent.activeEffect;
    if ([
        "no_women_bookable",
        "no_men_bookable"
    ].includes(eventActiveEffect)) for (const s of newMembers){
        if (eventActiveEffect === "no_women_bookable" && s.gender === "female") {
            data["error"] = "no-women-allowed";
            return data;
        } else if (eventActiveEffect === "no_men_bookable" && s.gender === "male") {
            data["error"] = "no-men-allowed";
            return data;
        }
    }
    // Remove old members
    await (0, $972Ip.removeTagTeamSuperstars)(team);
    await (0, $972Ip.addTagTeamSuperstars)(team, newMembers);
    // Change team name
    let teamSuperstarsNames = (0, $3E8Nt.commaSeparate)(newMembers.sort((a, b)=>a.$loki - b.$loki).map((x)=>(0, $5kTkA.getSuperstarLastName)(x)));
    team.name = `${trio.name} (${teamSuperstarsNames})`;
    // Remove match's feuds
    let previousMatchFeuds = await (0, $i7bmn.getMatchFeuds)(match);
    for (const x of previousMatchFeuds)await (0, $i7bmn.removeMatchFeud)(match, x);
    // Get all superstars and teams present
    let superstarsPresent = (await Promise.all(matchTeams.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    let tagTeamsPresent = [];
    for (const s of superstarsPresent)tagTeamsPresent.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
    tagTeamsPresent = (0, $3E8Nt.getUniqueObjects)(tagTeamsPresent);
    // Find existing feuds and add to match
    let newMatchFeuds = await (0, $cXLSF.getParticipantFeuds)(superstarsPresent, tagTeamsPresent);
    await (0, $i7bmn.addMatchFeuds)(match, newMatchFeuds);
    // Start direct feuds
    for (const feud of newMatchFeuds)if (!feud.started && feud.directFeudEvent && !feud.ended) {
        feud.startMonth = currentGame.monthCount;
        feud.startYear = currentGame.year;
        feud.runBlowoff = false;
    }
    // Reset attires
    for (const s of newMembers)if (s.currentAttire > 0) s.currentAttire = 0;
    // Add managers
    if ((0, $98xmD.globalUser).paid) {
        let matchManagersUsed = match.managersUsed;
        (0, $ycsyu.setManagersForMatchOrSegment)(match, newMembers, rosterSuperstars, latestEvent);
        // Add previously added managers
        $4ff5c4925572972c$var$updateMatchManagersForMembersChange(match, matchManagersUsed, newMembers, oldMembers, superstarsPresent);
    }
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["match"] = await $4ff5c4925572972c$export$c5b257e384b09f({
        match: match,
        companyChampionships: companyChampionships,
        rosterSuperstars: rosterSuperstars
    });
    data["alignmentBoost"] = await $4ff5c4925572972c$export$c6866f4a511f3680(matchTeams, userCompany.style);
    // Get unbooked and booker superstars
    const bookedSuperstars = await $4ff5c4925572972c$export$71b76f28e85dc7ef(latestEvent);
    data["unbookedMatchSuperstarsUids"] = oldMembers.filter((x)=>!(0, $3E8Nt.objectInArray)(x, bookedSuperstars)).map((x)=>x.$loki);
    data["bookedMatchSuperstarsUids"] = newMembers.map((x)=>x.$loki);
    return data;
}
async function $4ff5c4925572972c$export$43684a271e900824({ matchUid: matchUid, teamName: teamName, selectedMembers: selectedMembers } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get team
    let matchTeams = await (0, $i7bmn.getMatchParticipants)(match);
    let team = matchTeams.find((x)=>x.name === teamName);
    if (!team) {
        data["error"] = "team-not-found";
        return data;
    }
    // Get faction
    let oldMembers = await (0, $972Ip.getTagTeamSuperstars)(team);
    let faction = (await (0, $hBIDz.getSuperstarFactions)(oldMembers[0])).find((x)=>!x.disbanded);
    // Get new members
    let newMembers = [];
    let factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
    for (const name of selectedMembers){
        let newMember = factionSuperstars.find((x)=>x.name === name);
        if (!newMember) {
            data["error"] = "team-members-not-found";
            return data;
        }
        newMembers.push(newMember);
    }
    // Check new members
    let refereeSuperstar = rosterSuperstars.find((x)=>x.$loki === match.refereeId);
    for (const x of newMembers){
        if (!(0, $5kTkA.checkAvailability)(x, false) || !(0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships))) {
            data["error"] = "member-not-available";
            data["memberName"] = x.name;
            return data;
        }
        if (refereeSuperstar && refereeSuperstar.$loki === x.$loki) {
            data["error"] = "referee-in-match";
            return data;
        }
    }
    // Check for booking restrictions on event
    let eventActiveEffect = latestEvent.activeEffect;
    if ([
        "no_women_bookable",
        "no_men_bookable"
    ].includes(eventActiveEffect)) for (const s of newMembers){
        if (eventActiveEffect === "no_women_bookable" && s.gender === "female") {
            data["error"] = "no-women-allowed";
            return data;
        } else if (eventActiveEffect === "no_men_bookable" && s.gender === "male") {
            data["error"] = "no-men-allowed";
            return data;
        }
    }
    // Remove old members
    await (0, $972Ip.removeTagTeamSuperstars)(team);
    await (0, $972Ip.addTagTeamSuperstars)(team, newMembers);
    // Change team name
    let teamSuperstarsNames = (0, $3E8Nt.commaSeparate)(newMembers.sort((a, b)=>a.$loki - b.$loki).map((x)=>(0, $5kTkA.getSuperstarLastName)(x)));
    team.name = `${faction.name} (${teamSuperstarsNames})`;
    // Remove match's feuds
    let previousMatchFeuds = await (0, $i7bmn.getMatchFeuds)(match);
    for (const x of previousMatchFeuds)await (0, $i7bmn.removeMatchFeud)(match, x);
    // Get all superstars and teams present
    let superstarsPresent = (await Promise.all(matchTeams.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    let tagTeamsPresent = [];
    for (const s of superstarsPresent)tagTeamsPresent.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
    tagTeamsPresent = (0, $3E8Nt.getUniqueObjects)(tagTeamsPresent);
    // Find existing feuds and add to match
    let matchFeuds = await (0, $cXLSF.getParticipantFeuds)(superstarsPresent, tagTeamsPresent);
    await (0, $i7bmn.addMatchFeuds)(match, matchFeuds);
    // Start direct feuds
    for (const feud of matchFeuds)if (!feud.started && feud.directFeudEvent && !feud.ended) {
        feud.startMonth = currentGame.monthCount;
        feud.startYear = currentGame.year;
        feud.runBlowoff = false;
    }
    // Reset attires
    for (const s of newMembers)if (s.currentAttire > 0) s.currentAttire = 0;
    // Add managers
    if ((0, $98xmD.globalUser).paid) {
        let matchManagersUsed = match.managersUsed;
        (0, $ycsyu.setManagersForMatchOrSegment)(match, newMembers, rosterSuperstars, latestEvent);
        // Add previously added managers
        $4ff5c4925572972c$var$updateMatchManagersForMembersChange(match, matchManagersUsed, newMembers, oldMembers, superstarsPresent);
    }
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["match"] = await $4ff5c4925572972c$export$c5b257e384b09f({
        match: match,
        companyChampionships: companyChampionships,
        rosterSuperstars: rosterSuperstars
    });
    data["alignmentBoost"] = await $4ff5c4925572972c$export$c6866f4a511f3680(matchTeams, userCompany.style);
    // Get unbooked and booker superstars
    const bookedSuperstars = await $4ff5c4925572972c$export$71b76f28e85dc7ef(latestEvent);
    data["unbookedMatchSuperstarsUids"] = oldMembers.filter((x)=>!(0, $3E8Nt.objectInArray)(x, bookedSuperstars)).map((x)=>x.$loki);
    data["bookedMatchSuperstarsUids"] = newMembers.map((x)=>x.$loki);
    return data;
}
async function $4ff5c4925572972c$export$fa67f969eab6bc3(match, participants) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get all superstars and teams present
    let superstarsPresent = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    let tagTeamsPresent = [];
    for (const s of superstarsPresent)tagTeamsPresent.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
    tagTeamsPresent = (0, $3E8Nt.getUniqueObjects)(tagTeamsPresent);
    // Find existing feuds and add to match
    let matchFeuds = await (0, $cXLSF.getParticipantFeuds)(superstarsPresent, tagTeamsPresent);
    await (0, $i7bmn.addMatchFeuds)(match, matchFeuds);
    // Start direct feuds
    for (const feud of matchFeuds)if (!feud.started && feud.directFeudEvent && !feud.ended) {
        feud.startMonth = currentGame.monthCount;
        feud.startYear = currentGame.year;
        feud.runBlowoff = false;
    }
    return matchFeuds;
}
async function $4ff5c4925572972c$export$e390aee79ca4ee9c(participants, feuds, championships, style, annualTournament = null, tournamentRound = null) {
    let feudHype = (0, $4ptHI.getHypeForFeuds)(feuds, participants);
    let championshipHype = $4ff5c4925572972c$var$getHypeForChampionships(championships);
    let participantsHype = await (0, $4ptHI.getHypeForParticipants)(participants);
    let alignmentHype = await $4ff5c4925572972c$export$c6866f4a511f3680(participants, style);
    let annualTournamentHype = $4ff5c4925572972c$var$getHypeForAnnualTournament(annualTournament, tournamentRound);
    return Math.floor(feudHype + championshipHype + participantsHype + alignmentHype + annualTournamentHype);
}
function $4ff5c4925572972c$var$getHypeForChampionships(championships) {
    let championshipHypes = {
        "S": 40,
        "A": 30,
        "B": 20,
        "C": 10
    };
    let hype = 0;
    for (const c of championships)if (c) hype += championshipHypes[c.prestige] || 10;
    if (hype > 80) hype = 80;
    return hype;
}
function $4ff5c4925572972c$var$getHypeForAnnualTournament(annualTournament, tournamentRound) {
    // Add hype for annual tournament based on round
    let annualTournamentHypes = {
        1: 15,
        2: 30,
        3: 50,
        4: 75
    };
    let hype = 0;
    if (annualTournament) hype += annualTournamentHypes[tournamentRound] || 10;
    return hype;
}
async function $4ff5c4925572972c$export$8073c7b65dd39049(match, participants, participantChampionships, matchSuperstars, rosterSuperstars = null, refereeSuperstar = null, gimmick = null, championshipsToRemove = []) {
    let graphics = [];
    let addWeaponGraphic = $4ff5c4925572972c$var$checkToAddWeaponGraphicToSuperstar(gimmick);
    for (const participant of participants)for (const superstar of (await (0, $5kTkA.getRosterMemberSuperstars)(participant))){
        let superstarGraphic = (0, $5kTkA.getGraphicForSuperstar)(superstar, true);
        // Add title graphic if superstar is champion and championship has graphic
        let superstarChampionship = participantChampionships.find((x)=>x.superstarId === superstar.$loki && x.graphic);
        if (superstarChampionship) // Don't add match championship graphics if ladder etc match
        {
            if (!(0, $3E8Nt.objectInArray)(superstarChampionship, championshipsToRemove)) superstarGraphic["title"] = JSON.parse(JSON.stringify(superstarChampionship.graphic));
        }
        // Check to add weapon graphic
        superstarGraphic["addWeaponGraphic"] = addWeaponGraphic;
        graphics.push(superstarGraphic);
        // Add manager graphic
        if (matchSuperstars.length < 7) {
            let superstarManager = await (0, $5kTkA.getSuperstarManagerUsedForMatchOrSegment)(superstar, match.managersUsed, rosterSuperstars);
            // Don't add if manager is referee
            if (superstarManager && (!refereeSuperstar || superstarManager.$loki !== refereeSuperstar.$loki)) {
                const superstarManagerGraphic = (0, $5kTkA.getSuperstarManagerGraphic)(superstarManager, superstar);
                graphics.push(superstarManagerGraphic);
            }
        }
    }
    // Add referee graphic
    if (refereeSuperstar && !(0, $3E8Nt.objectInArray)(refereeSuperstar, matchSuperstars)) {
        let refereeGraphic = $4ff5c4925572972c$var$getMatchRefereeGraphic(refereeSuperstar);
        graphics.push(refereeGraphic);
    }
    return graphics;
}
function $4ff5c4925572972c$var$checkToAddWeaponGraphicToSuperstar(gimmickMatch) {
    if (gimmickMatch) return gimmickMatch.addRandomWeapons;
    return false;
}
function $4ff5c4925572972c$export$df685982e326a600(gimmickMatch) {
    if (gimmickMatch) return gimmickMatch.graphicType;
    return null;
}
function $4ff5c4925572972c$export$be683621f1503c2e(gimmickMatchGraphic) {
    return !!(gimmickMatchGraphic && [
        "ladder",
        "ladder_black",
        "ladder_grey",
        "ladder_orange",
        "tables_ladders_chairs"
    ].includes(gimmickMatchGraphic));
}
function $4ff5c4925572972c$var$getMatchRefereeGraphic(refereeSuperstar) {
    let graphic = JSON.parse(JSON.stringify(refereeSuperstar.graphic));
    if (!graphic || Object.keys(graphic).length === 0) graphic = (0, $5kTkA.getEmptySuperstarGraphic)(refereeSuperstar);
    graphic = JSON.parse(JSON.stringify(graphic));
    graphic["isReferee"] = true;
    return graphic;
}
async function $4ff5c4925572972c$export$9f130f338ade43ad(matchGimmick, match) {
    let gimmickMatchForGraphic = matchGimmick;
    // Get first fall gimmick match's graphic for 2/3 falls
    if (Array.isArray(match.fallGimmickNames) && match.fallGimmickNames.length > 0 && matchGimmick) {
        let matchCompany = await (0, $cYLJ6.getGimmickMatchCompany)(matchGimmick);
        if (matchCompany) {
            let companyGimmickMatches = await (0, $9esFv.getCompanyGimmickMatches)(matchCompany);
            let firstFallGimmickMatch = companyGimmickMatches.find((x)=>x.name === match.fallGimmickNames[0]);
            if (firstFallGimmickMatch) gimmickMatchForGraphic = firstFallGimmickMatch;
        }
    }
    return gimmickMatchForGraphic;
}
async function $4ff5c4925572972c$export$1008f312072c70e7({ winnerName: winnerName, uid: uid, type: type, cashinData: cashinData, matchFinishData: matchFinishData, graphics: graphics } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const companyRosters = await (0, $9esFv.getCompanyRosters)(userCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
    const user = (0, $bZol7.loadUser)();
    // Get match
    const match = await (0, $14eBR.Matches).get(uid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get match finish and check requirements
    if (matchFinishData) {
        let matchFinish = (0, $6hwt2.matchFinishesData).find((x)=>x.name === matchFinishData.name);
        if (matchFinish) {
            // Check if company has enough points
            if (userCompany.points < matchFinish["cost"]) {
                data["error"] = "match-finish-points";
                return data;
            }
            // Don't allow indecisive finishes in gimmick matches
            if (await (0, $i7bmn.getMatchGimmickMatch)(match) && !matchFinish["changeChampionship"]) {
                data["error"] = "indecisive-finish-gimmick-match";
                return data;
            }
            // Check match finish requirements
            if (matchFinish["requirements"]) {
                let check = await $4ff5c4925572972c$var$checkMatchFinishRequirements(matchFinish, match, winnerName, latestEvent, userCompany);
                if (check["error"]) {
                    data = check;
                    return data;
                }
            }
            // Check if match finish can be re-used
            if (userCompany.specialFinishesData[matchFinish["name"]]) {
                let monthsToReuse = userCompany.specialFinishesData[matchFinish["name"]]["months_to_reuse"];
                if (monthsToReuse > 0) {
                    data["error"] = "match-finish-reuse-not-available";
                    data["monthsToReuse"] = monthsToReuse;
                    return data;
                }
            }
            // Check tournament
            let matchTournament = await (0, $i7bmn.getMatchTournament)(match);
            if (matchTournament && matchTournament.type === "elimination") {
                // Don't allow draw finishes in elimination tournaments
                if (matchFinish["draw"]) {
                    data["error"] = "draw-elimination-tournament";
                    return data;
                }
                // Don't allow indecisive finishes in tournament finals (for awarding titles, match contracts etc)
                if (match.tournamentRound === matchTournament.rounds && !matchFinish["changeChampionship"]) {
                    data["error"] = "indecisive-finish-tournament-final";
                    return data;
                }
            }
            // Don't allow manager finishes for free users
            if (!(0, $98xmD.globalUser).paid) {
                if (matchFinish["requirements"] && matchFinish["requirements"].includes("loser_has_manager")) {
                    data["error"] = "manager-finish-paid";
                    return data;
                }
            }
            // Subtract points
            userCompany.points -= matchFinish["cost"];
        }
    }
    try {
        data = await (0, $3SyPM.processPlayMatch)(match, winnerName, latestEvent, userCompany, mainCompany, mainRoster, indieRoster, currentGame, cashinData, matchFinishData, graphics);
        // Check tutorial action
        if (userCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
            "simulate_match",
            "play_first_event",
            "play_second_event_main_event"
        ]);
        (0, $14eBR.db).saveDatabase();
    } catch (error) {
        data["error"] = true;
        await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
        // Check if any empty teams present, return in error
        const match = await (0, $14eBR.Matches).get(uid);
        const tagTeams = await (0, $i7bmn.getMatchTagTeams)(match);
        for (const tagTeam of tagTeams)if (!(await (0, $972Ip.getTagTeamSuperstars)(tagTeam)).length) {
            data["error"] = "team-members-not-found";
            data["teamName"] = tagTeam.name;
            break;
        }
        if (data["error"] !== "team-members-not-found") (0, $3E8Nt.captureError)(error);
    }
    return data;
}
async function $4ff5c4925572972c$export$132777715c2dcc62({ uid: uid, type: type } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const companyRosters = await (0, $9esFv.getCompanyRosters)(userCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main", companyRosters);
    const trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "training", companyRosters);
    const trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "trainingAvailable", companyRosters);
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Get match
    const match = await (0, $14eBR.Matches).get(uid);
    const matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    // Chance to get talent from training roster
    let allTalent = [];
    let trainingTalent = false;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) {
        if (type === "singles") {
            let trainingSuperstars = (await (0, $dl5u4.getRosterSuperstars)(trainingRoster)).concat(await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster));
            if (trainingSuperstars.length > 0) {
                allTalent = trainingSuperstars;
                trainingTalent = true;
            }
        } else if (type === "tag") {
            let trainingTeams = (await (0, $dl5u4.getRosterTagTeams)(trainingRoster)).concat(await (0, $dl5u4.getRosterTagTeams)(trainingAvailableRoster)).filter((x)=>x.trio === matchParticipants[0].trio && !x.temporary);
            if (trainingTeams.length > 0) {
                allTalent = trainingTeams;
                trainingTalent = true;
            }
        }
    }
    // Otherwise get talent from main roster
    if (allTalent.length <= 0) {
        if (type === "singles") allTalent = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        else if (type === "tag") allTalent = (await (0, $dl5u4.getRosterTagTeams)(mainRoster)).filter((x)=>x.trio === matchParticipants[0].trio && !x.temporary);
    }
    // Select random opponent
    let randomOpponentData = await $4ff5c4925572972c$export$651233d057b6ab4(matchParticipants[0], allTalent, latestEvent);
    let opponent = randomOpponentData[0];
    let available = randomOpponentData[1];
    // Check if opponent found
    if (!opponent) {
        data["error"] = "no-opponents-found";
        return data;
    }
    // Callup training talent if selected
    if (trainingTalent) await (0, $jpMCP.callupTalentToMainRoster)(opponent, mainRoster, userCompany, currentGame);
    // Add opponent to match
    await (0, $i7bmn.addMatchParticipants)(match, [
        opponent
    ]);
    matchParticipants.push(opponent);
    // Add managers
    const participantSuperstars = (await Promise.all(matchParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    if ((0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(match, participantSuperstars, rosterSuperstars, latestEvent);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    if (type === "singles") data["opponent"] = await (0, $5kTkA.getSuperstarDisplayData)({
        superstar: opponent,
        rosterSuperstars: rosterSuperstars,
        managersUsed: match.managersUsed,
        game: currentGame
    });
    else data["opponent"] = await (0, $ko5kE.getTagTeamDisplayData)({
        tagTeam: opponent,
        rosterSuperstars: rosterSuperstars,
        managersUsed: match.managersUsed,
        game: currentGame
    });
    data["available"] = available.map((x)=>x.name);
    // Get match graphics again
    let participantChampionships = [];
    for (const matchSuperstar of participantSuperstars)participantChampionships = [
        ...participantChampionships,
        ...await (0, $hBIDz.getSuperstarChampionships)(matchSuperstar)
    ];
    const refereeSuperstar = await $4ff5c4925572972c$export$282105ae99b45659(match, rosterSuperstars);
    data["graphics"] = await $4ff5c4925572972c$export$8073c7b65dd39049(match, matchParticipants, participantChampionships, participantSuperstars, rosterSuperstars, refereeSuperstar);
    return data;
}
async function $4ff5c4925572972c$export$651233d057b6ab4(participant, allTalent, event) {
    let weights = [];
    const eventMatches = await (0, $iQtzn.getEventMatches)(event);
    let eventMatchesParticipants = (await Promise.all(eventMatches.map((x)=>(0, $i7bmn.getMatchParticipants)(x)))).flat();
    eventMatchesParticipants = eventMatchesParticipants.filter((x)=>x.objectName === participant.objectName);
    // Get available
    let available = [];
    let genderFiltered = [];
    let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participant);
    for (const talent of allTalent){
        let talentSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
        if (talentSuperstars.every((x)=>(0, $5kTkA.checkAvailability)(x, false, false, false) && (0, $5kTkA.checkSuperstarBrandAvailability)(event, x) && talent.$loki !== participant.$loki)) {
            if (talentSuperstars.every((x)=>x.gender === participantSuperstars[0].gender)) genderFiltered.push(talent);
            available.push(talent);
        }
    }
    // Filtered by gender / not booked
    if (genderFiltered.length > 0) available = available.filter((x)=>(0, $3E8Nt.objectInArray)(x, genderFiltered));
    let notBookedFiltered = available.filter((x)=>!(0, $3E8Nt.objectInArray)(x, eventMatchesParticipants));
    if (notBookedFiltered.length > 0) available = notBookedFiltered;
    // Add weights based on popularity difference
    for (const y of available){
        let difference = Math.abs(await (0, $3E8Nt.getRosterMemberPopularity)(participant) - await (0, $3E8Nt.getRosterMemberPopularity)(y));
        if (difference < 50) difference = 50;
        let weight = 1000 / difference;
        weights.push([
            y,
            weight
        ]);
    }
    if (weights.length <= 0) return [
        null,
        null
    ];
    let opponent = (0, $3E8Nt.weightedChoice)(weights);
    return [
        opponent,
        available
    ];
}
async function $4ff5c4925572972c$export$24b09150d265f836({ uid: uid }) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    // Get match
    const match = await (0, $14eBR.Matches).get(uid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get match finishes, make copy
    let matchFinishes = JSON.parse(JSON.stringify((0, $6hwt2.matchFinishesData)));
    // Check for unavailable match finishes
    for (const matchFinish of matchFinishes){
        // Don't allow indecisive finishes in gimmick matches
        if (await (0, $i7bmn.getMatchGimmickMatch)(match) && !matchFinish["changeChampionship"]) matchFinish["unavailable"] = true;
        // Check match finish requirements
        if (matchFinish["requirements"]) {
            let check = await $4ff5c4925572972c$var$checkMatchFinishRequirements(matchFinish, match, null, latestEvent, userCompany);
            if (check["error"]) matchFinish["unavailable"] = true;
        }
        // Check if match finish can be re-used
        if (userCompany.specialFinishesData[matchFinish["name"]]) {
            let monthsToReuse = userCompany.specialFinishesData[matchFinish["name"]]["months_to_reuse"];
            if (monthsToReuse > 0) {
                matchFinish["unavailable"] = true;
                matchFinish["monthsToReuse"] = monthsToReuse;
            }
        }
        // Check tournament
        let matchTournament = await (0, $i7bmn.getMatchTournament)(match);
        if (matchTournament && matchTournament.type === "elimination") {
            // Don't allow draw finishes in elimination tournaments
            if (matchFinish["draw"]) matchFinish["unavailable"] = true;
            // Don't allow indecisive finishes in tournament finals (for awarding titles, match contracts etc)
            if (match.tournamentRound === matchTournament.rounds && !matchFinish["changeChampionship"]) matchFinish["unavailable"] = true;
        }
        // Don't allow manager finishes for free users
        if (!(0, $98xmD.globalUser).paid) {
            if (matchFinish["requirements"] && matchFinish["requirements"].includes("loser_has_manager")) matchFinish["unavailable"] = true;
        }
    }
    data["matchFinishes"] = matchFinishes;
    return data;
}
async function $4ff5c4925572972c$var$checkMatchFinishRequirements(matchFinish, match, winnerName, event, company) {
    let data = {};
    let participants = await (0, $i7bmn.getMatchParticipants)(match);
    let participantType;
    let singlesTag = false;
    if (participants[0].objectName === "superstar") participantType = "singles";
    else {
        participantType = "tag";
        singlesTag = participants.some((x)=>x.temporary && !(x.trioTagTeam || x.factionTagTeam));
    }
    // Check if one on one match and not singles tag
    if (participants.length !== 2 || singlesTag) {
        data["error"] = "requirement-fail";
        data["requirement"] = "one-on-one-match";
        return data;
    }
    async function faceAndHeelCheck() {
        if (participantType === "singles") {
            if (participants.some((x)=>x.alignment === "heel") && participants.some((x)=>x.alignment === "face")) return true;
        } else if (participantType === "tag") {
            let faces = false;
            let heels = false;
            for (const p of participants){
                let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(p);
                if (participantSuperstars.every((x)=>x.alignment === "heel")) heels = true;
                else if (participantSuperstars.every((x)=>x.alignment === "face")) faces = true;
            }
            return heels && faces;
        }
        return false;
    }
    async function faceWinnerCheck() {
        // Pre-match check
        if (!winnerName) {
            let face;
            for (const x of participants)if (await (0, $3E8Nt.getRosterMemberAlignment)(x) === "face") {
                face = x;
                break;
            }
            return !!face;
        } else {
            let winner = participants.find((x)=>x.name === winnerName);
            return await (0, $3E8Nt.getRosterMemberAlignment)(winner) === "face";
        }
    }
    async function heelLoserCheck() {
        // Pre-match check
        if (!winnerName) {
            let heel;
            for (const x of participants)if (await (0, $3E8Nt.getRosterMemberAlignment)(x) === "heel") {
                heel = x;
                break;
            }
            return !!heel;
        } else {
            let loser = participants.find((x)=>x.name !== winnerName);
            return await (0, $3E8Nt.getRosterMemberAlignment)(loser) === "heel";
        }
    }
    async function hotFeudCheck() {
        return (await (0, $i7bmn.getMatchFeuds)(match)).some((x)=>x.hot);
    }
    async function titleMatchCheck() {
        return (await (0, $i7bmn.getMatchChampionships)(match)).length > 0;
    }
    async function mainEventCheck() {
        let segmentsAndMatches = await (0, $5ZsVo.getEventMatchesAndSegments)(event);
        segmentsAndMatches.sort((a, b)=>a.order - b.order);
        return match.$loki === segmentsAndMatches[0].$loki && match.objectName === segmentsAndMatches[0].objectName;
    }
    async function loserHasManagerCheck() {
        // Pre-match check
        if (!winnerName) {
            for (const x of participants){
                let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(x);
                if (participantSuperstars[0].managerId && participantSuperstars.every((y)=>y.managerId === participantSuperstars[0].managerId)) return true;
            }
            return false;
        } else {
            let loser = participants.find((x)=>x.name !== winnerName);
            if (loser) {
                let loserSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(loser);
                if (loserSuperstars[0].managerId && loserSuperstars.every((y)=>y.managerId === loserSuperstars[0].managerId)) return true;
            }
            return false;
        }
    }
    async function winnerHasNoManagerCheck() {
        // Pre-match check
        if (!winnerName) {
            for (const x of participants){
                let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(x);
                if (participantSuperstars.every((y)=>!y.managerId && !y.fullTimeManager)) return true;
            }
            return false;
        } else {
            let winner = participants.find((x)=>x.name === winnerName);
            if (winner) {
                let winnerSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(winner);
                if (winnerSuperstars.every((y)=>!y.managerId && !y.fullTimeManager)) return true;
            }
            return false;
        }
    }
    async function level2ProducerCheck() {
        let staffMembers = await (0, $9esFv.getCompanyStaff)(company);
        let producers = (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
        return producers.find((x)=>x.level >= 2);
    }
    async function level3ProducerCheck() {
        let staffMembers = await (0, $9esFv.getCompanyStaff)(company);
        let producers = (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
        return producers.find((x)=>x.level >= 3);
    }
    let checkFunctions = {
        "face_vs_heel": faceAndHeelCheck,
        "face_winner": faceWinnerCheck,
        "heel_loser": heelLoserCheck,
        "hot_feud": hotFeudCheck,
        "title_match": titleMatchCheck,
        "main_event": mainEventCheck,
        "loser_has_manager": loserHasManagerCheck,
        "winner_has_no_manager": winnerHasNoManagerCheck,
        "level_2_producer": level2ProducerCheck,
        "level_3_producer": level3ProducerCheck
    };
    // Check requirements
    for (const requirement of matchFinish["requirements"]){
        const checkFunction = checkFunctions[requirement];
        if (checkFunction && !await checkFunction()) {
            data["error"] = "requirement-fail";
            data["requirement"] = requirement;
            return data;
        }
    }
    return data;
}
async function $4ff5c4925572972c$export$1cf1681ab9b05296({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Get match
    const match = await (0, $14eBR.Matches).get(uid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get match participants and all tag teams and superstars
    let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    if (match.type === "singles") for (const s of matchParticipants)matchParticipants.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
    else if (match.type === "tag") matchParticipants.push(...(await Promise.all(matchParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat());
    // Add superstars that are available and not in match, get match managers
    let managerIds = match.managersUsed ? Object.values(match.managersUsed) : [];
    let matchManagers = [];
    let rosterMembers = [];
    for (const x of (await (0, $dl5u4.getRosterSuperstars)(mainRoster))){
        let superstarChampionships = (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships);
        let brandCheck = (0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, x, superstarChampionships);
        if ((0, $5kTkA.checkSuperstarSegmentAvailability)(x) && brandCheck && !(0, $3E8Nt.objectInArray)(x, matchParticipants)) {
            let superstarData = {
                "name": x.name,
                "uid": x.$loki,
                "type": "superstar"
            };
            if (managerIds.includes(x.$loki)) matchManagers.push(superstarData);
            else rosterMembers.push(superstarData);
        }
    }
    // Add teams
    for (const x of (await (0, $jpMCP.getRosterActiveTagTeams)(mainRoster))){
        let superstars = await (0, $5kTkA.getRosterMemberSuperstars)(x);
        if (superstars.every((y)=>(0, $5kTkA.checkSuperstarSegmentAvailability)(y)) && superstars.every((y)=>(0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, y, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(y, companyChampionships))) && !(0, $3E8Nt.objectInArray)(x, matchParticipants)) rosterMembers.push({
            "name": x.name,
            "uid": x.$loki,
            "type": "team"
        });
    }
    // Add factions
    for (const x of (await (0, $6PzHO.getRosterActiveFactions)(mainRoster))){
        let superstars = await (0, $2JFAd.getFactionSuperstars)(x);
        // Add if at least 1 member available and not in match
        let availableSuperstars = superstars.filter((y)=>(0, $5kTkA.checkSuperstarSegmentAvailability)(y) && (0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, y, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(y, companyChampionships)) && !(0, $3E8Nt.objectInArray)(y, matchParticipants));
        if (availableSuperstars.length > 0) rosterMembers.push({
            "name": x.name,
            "uid": x.$loki,
            "type": "faction"
        });
    }
    // Sort by name
    rosterMembers.sort((a, b)=>a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    // Get data to return
    data["rosterMembers"] = rosterMembers;
    data["matchManagers"] = matchManagers;
    return data;
}
async function $4ff5c4925572972c$export$d49e7738724ddb({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get match
    const match = await (0, $14eBR.Matches).get(uid);
    const matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    // Get available gimmick matches
    let availableGimmickMatches = (await (0, $9esFv.getCompanyGimmickMatches)(userCompany)).filter((x)=>x.available && !x.cashinContractName && !x.matchContractName && x.rules === null && x.consequence !== "random_opponent" && !(x.special && x.name === "Femme Fatale"));
    // Select gimmick match
    let gimmickMatch = (0, $3E8Nt.getRandomChoice)(availableGimmickMatches);
    // Add gimmick match to match
    await (0, $cYLJ6.addGimmickMatchMatches)(gimmickMatch, [
        match
    ]);
    // Add custom object or location
    if (gimmickMatch.generateObject) match.objectToClaim = (0, $8A6FL.generateGimmickMatchObjectName)(matchParticipants.map((x)=>x.name));
    if (gimmickMatch.generateLocation) match.location = (0, $8A6FL.generateGimmickMatchLocationName)(matchParticipants.map((x)=>x.name));
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["gimmickMatch"] = {
        "gimmick": gimmickMatch.name,
        "generated": {
            "objectToClaim": match.objectToClaim,
            "location": match.location
        }
    };
    data["available"] = availableGimmickMatches.map((x)=>x.name);
    return data;
}
async function $4ff5c4925572972c$export$4468841c5ffcfa9a({ uid: uid } = {}) {
    let data = {};
    // Get match
    const match = await (0, $14eBR.Matches).get(uid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Simulate winner
    let winner;
    let tournament = await (0, $i7bmn.getMatchTournament)(match);
    if (tournament && tournament.annualTournament) winner = await $4ff5c4925572972c$export$33d9ac53668f0b38(match, tournament);
    else winner = await $4ff5c4925572972c$export$5627b598398e8aef(match);
    // Get data to return
    data["winnerName"] = winner.name;
    return data;
}
async function $4ff5c4925572972c$export$5627b598398e8aef(match, style = "standard") {
    let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    let matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
    let weights = await $4ff5c4925572972c$export$7e439ca3578757b0(matchParticipants, matchChampionships, style);
    return (0, $3E8Nt.weightedChoice)(weights);
}
async function $4ff5c4925572972c$export$33d9ac53668f0b38(match, annualTournament) {
    let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
    let weights = await $4ff5c4925572972c$export$8cd12d4a972eea20(matchParticipants, annualTournament);
    return (0, $3E8Nt.weightedChoice)(weights);
}
async function $4ff5c4925572972c$export$7e439ca3578757b0(participants, championships, style = "standard", checkMorale = true) {
    let championshipSuperstarIds = championships.map((x)=>x.superstarId);
    let weights = [];
    let remainingPercentage = 100;
    let remainingParticipants = participants.length;
    // Get temporary attributes for participants (for sorting)
    for (const x of participants){
        x.tempPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
        x.tempUnhappiness = await checkUnhappiness(x);
        x.tempChampion = await checkChampion(x);
    }
    async function checkUnhappiness(p) {
        if (!checkMorale) return false;
        let s = await (0, $5kTkA.getRosterMemberSuperstars)(p);
        return s.some((x)=>x.unhappy || x.contractMonthsRemaining !== null);
    }
    async function checkChampion(p) {
        let championshipFound = false;
        for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(p)))if (championshipSuperstarIds.includes(s.$loki)) championshipFound = true;
        return championshipFound;
    }
    async function checkPartTimer(p) {
        let s = await (0, $5kTkA.getRosterMemberSuperstars)(p);
        return s.some((x)=>x.partTimer);
    }
    async function getAge(p) {
        let s = await (0, $5kTkA.getRosterMemberSuperstars)(p);
        return Math.round(s.reduce((n, { age: age })=>n + age, 0) / s.length);
    }
    // Sort participants
    let sortedParticipants;
    let comparisonParticipant;
    if (style !== "bizarro") {
        sortedParticipants = [
            ...participants
        ].sort((a, b)=>b.tempUnhappiness - a.tempUnhappiness || b.tempChampion - a.tempChampion || b.tempPopularity - a.tempPopularity);
        comparisonParticipant = (0, $3E8Nt.getArrayMinByProperty)(sortedParticipants, "tempPopularity");
    } else {
        sortedParticipants = [
            ...participants
        ].sort((a, b)=>b.tempUnhappiness - a.tempUnhappiness || a.tempPopularity - b.tempPopularity);
        comparisonParticipant = (0, $3E8Nt.getArrayMaxByProperty)(sortedParticipants, "tempPopularity");
    }
    // Get weights for participants except last
    for (const x of sortedParticipants.slice(0, sortedParticipants.length - 1)){
        let partTimer = await checkPartTimer(x);
        let age = await getAge(x);
        // Divide remaining percentage equally
        let defaultPercentage = Math.floor(remainingPercentage / remainingParticipants);
        // Get win bias percentage
        let difference = Math.abs(x.tempPopularity - comparisonParticipant.tempPopularity);
        let percentage = $4ff5c4925572972c$var$getWinBiasPercentage(difference, participants, age, x.tempChampion, x.tempUnhappiness, partTimer, style, checkMorale);
        // Max value
        if (percentage + defaultPercentage > remainingPercentage) percentage = remainingPercentage;
        else // Add bias to default percentage
        percentage += defaultPercentage;
        // Remove percentage, participant
        remainingPercentage -= percentage;
        remainingParticipants -= 1;
        weights.push([
            x,
            percentage
        ]);
    }
    // Get weight for last participant
    weights.push([
        sortedParticipants[sortedParticipants.length - 1],
        remainingPercentage
    ]);
    // Add 1% chance for 0% weight
    let zeroChanceWeights = weights.filter((x)=>x[1] === 0);
    for (const x of zeroChanceWeights){
        let index = weights.findIndex((y)=>y[0].$loki === x[0].$loki);
        weights[index] = [
            x[0],
            1
        ];
        // Subtract 1% chance from a random weight except this one
        let others = weights.filter((y)=>y[1] > 1);
        if (others.length > 0) {
            let selected = (0, $3E8Nt.getRandomChoice)(others);
            let index = weights.findIndex((y)=>y[0].$loki === selected[0].$loki);
            weights[index] = [
                selected[0],
                selected[1] - 1
            ];
        }
    }
    return weights;
}
function $4ff5c4925572972c$var$getWinBiasPercentage(difference, participants, age, champion, unhappy, partTimer, style, checkMorale) {
    let bias = Math.ceil(Math.pow(difference * 3, 1.09) / 20) / participants.length;
    if (bias <= 0) bias = Math.floor(14 / participants.length);
    if (champion) {
        if ([
            "standard",
            "quality"
        ].includes(style)) bias *= 2;
        else if (style === "long-term") bias *= 4;
        else if (style === "bizarro") bias *= 1.5;
    }
    if (unhappy && checkMorale) bias *= 50;
    if (style === "long-term") {
        if (partTimer) bias /= 2.5;
        // Add age bias
        let ageBiases = [
            [
                25,
                1
            ],
            [
                32,
                0.8
            ],
            [
                38,
                0.5
            ],
            [
                45,
                0.3
            ]
        ];
        let ageBias = ageBiases.find((x)=>x[0] > age);
        ageBias = ageBias ? ageBias[1] : 0.3;
        bias *= ageBias;
    } else if (style === "bizarro") {
        if (partTimer) bias /= 0.5;
        // Add age bias
        let ageBiases = [
            [
                25,
                0.3
            ],
            [
                32,
                0.5
            ],
            [
                38,
                1
            ],
            [
                45,
                1.5
            ]
        ];
        let ageBias = ageBiases.find((x)=>x[0] > age);
        ageBias = ageBias ? ageBias[1] : 1;
        bias *= ageBias;
    }
    return Math.floor(bias);
}
async function $4ff5c4925572972c$export$8cd12d4a972eea20(participants, annualTournament = null) {
    let weights = [];
    let remainingPercentage = 100;
    let remainingParticipants = participants.length;
    // Get temporary attributes for participants (for sorting)
    for (const x of participants)x.tempPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
    // Sort by popularity
    let sortedParticipants = [
        ...participants
    ].sort((a, b)=>b.tempPopularity - a.tempPopularity);
    let comparisonParticipant = sortedParticipants[sortedParticipants.length - 1];
    // Get weights for participants except last
    for (const x of sortedParticipants.slice(0, sortedParticipants.length - 1)){
        // Divide remaining percentage equally
        let defaultPercentage = Math.floor(remainingPercentage / remainingParticipants);
        // Get win bias percentage
        let difference = Math.abs($4ff5c4925572972c$var$getScaledPopularity(x) - $4ff5c4925572972c$var$getScaledPopularity(comparisonParticipant));
        let percentage = $4ff5c4925572972c$var$getAnnualTournamentWinBiasPercentage(difference);
        // Add bias to default percentage
        percentage += defaultPercentage;
        // Check for bribe, add to percentage if present
        if (annualTournament) {
            let participantBribe = $4ff5c4925572972c$var$checkAnnualTournamentParticipantBribe(annualTournament, x.$loki);
            let opponentBribe = $4ff5c4925572972c$var$checkAnnualTournamentParticipantBribe(annualTournament, comparisonParticipant.$loki);
            if (participantBribe && !opponentBribe) percentage += 15;
            else if (opponentBribe && !participantBribe) percentage -= 15;
        }
        percentage = (0, $3E8Nt.limitValueBetweenRange)(percentage, 0, 100);
        // Remove percentage, participant
        remainingPercentage -= percentage;
        remainingParticipants -= 1;
        weights.push([
            x,
            percentage
        ]);
    }
    // Get weight for last participant
    weights.push([
        comparisonParticipant,
        remainingPercentage
    ]);
    // Add 2% chance for 0% weight
    let zeroChanceWeights = weights.filter((x)=>x[1] === 0);
    for (const x of zeroChanceWeights){
        let index = weights.findIndex((y)=>y[0].$loki === x[0].$loki);
        weights[index] = [
            x[0],
            2
        ];
    }
    return weights;
}
function $4ff5c4925572972c$var$getAnnualTournamentWinBiasPercentage(difference) {
    // Higher the exponent, greater the bias increase with difference
    let bias = Math.ceil(Math.pow(difference, 0.67));
    return Math.floor(bias);
}
function $4ff5c4925572972c$var$getScaledPopularity(superstar) {
    // Small increase after 1000 pop, none after 3000
    if (superstar.tempPopularity > 1000) {
        let extra = superstar.tempPopularity - 1000;
        if (extra > 2000) extra = 2000;
        return 1000 + extra ** 0.6;
    } else return superstar.tempPopularity;
}
function $4ff5c4925572972c$var$checkAnnualTournamentParticipantBribe(annualTournament, participantId) {
    for (const x of Object.values(annualTournament.companiesData)){
        let participantIds = x["participantIds"] || [];
        if (participantIds.includes(participantId) && x["bribed"] === true) return true;
    }
    return false;
}
function $4ff5c4925572972c$export$82313bc1d0e50912(gimmickMatch, winningSuperstar, losingSuperstar) {
    // Note: when adding text, add two superstar placeholders, otherwise it won't format
    // For specific gimmick matches
    let texts = {
        "Ladder": [
            `${winningSuperstar.name} jumped off a 20 foot ladder onto ${losingSuperstar.name}!`,
            `${winningSuperstar.name} hit ${losingSuperstar.name} with a leg drop off the ladder!`,
            `${winningSuperstar.name} threw ${losingSuperstar.name} face first into a ladder set up in the corner!`,
            `${winningSuperstar.name} suplexed ${losingSuperstar.name} off the top of a ladder, crashing onto the mat below!`,
            `${winningSuperstar.name} suplexed ${losingSuperstar.name} head first onto a ladder!`,
            `${winningSuperstar.name} powerbombed ${losingSuperstar.name} through a ladder!`,
            `${winningSuperstar.name} threw ${losingSuperstar.name} off the ladder, sending {0} through another ladder!`.format(losingSuperstar.objectivePronoun),
            `${winningSuperstar.name} jumped off a ladder onto ${losingSuperstar.name}, putting {0} through another ladder!`.format(losingSuperstar.objectivePronoun)
        ],
        "Cage": [
            `${winningSuperstar.name} hit ${losingSuperstar.name} with a hurricanrana off the top of the cage!`,
            `${winningSuperstar.name} slammed ${losingSuperstar.name} head first into the side of the cage!`,
            `${winningSuperstar.name} dragged ${losingSuperstar.name}'s head across the entire cage!`,
            `${winningSuperstar.name} hit ${losingSuperstar.name} with a crossbody off the top of the cage!`,
            `${winningSuperstar.name} hit ${losingSuperstar.name} with a frog splash off the top of the cage!`,
            `${winningSuperstar.name} hit ${losingSuperstar.name} with a leg drop off the top of the cage!`
        ],
        "LMS": [
            `${winningSuperstar.name} powerbombed ${losingSuperstar.name} off the ramp and onto the tables below!`,
            `${winningSuperstar.name} threw ${losingSuperstar.name} off the stage onto the tables below!`,
            `${winningSuperstar.name} hit ${losingSuperstar.name} with {0} finisher off the ramp onto a table below!`.format(winningSuperstar.possessivePronoun),
            `${winningSuperstar.name} jumped off a ladder onto ${losingSuperstar.name}, putting {0} through a table!`.format(losingSuperstar.objectivePronoun)
        ],
        "TLC": [
            `${winningSuperstar.name} powerbombed ${losingSuperstar.name} through a table on the outside!`,
            `${winningSuperstar.name} tipped ${losingSuperstar.name} off the ladder, sending {0} crashing outside!`.format(losingSuperstar.objectivePronoun),
            `${winningSuperstar.name} put ${losingSuperstar.name} on the announce table and dove on {0} off a ladder!`.format(losingSuperstar.objectivePronoun),
            `${winningSuperstar.name} jumped for the title after walking on three ladders like a tightrope, before ${losingSuperstar.name} pulled {0} down!`.format(winningSuperstar.objectivePronoun)
        ],
        "Quit": [
            `${winningSuperstar.name} put ${losingSuperstar.name} through a hundred thumbtacks!`,
            `${winningSuperstar.name} hit ${losingSuperstar.name} with a dozen consecutive chair shots!`,
            `${winningSuperstar.name} speared ${losingSuperstar.name} through the stage screen!`,
            `${winningSuperstar.name} jumped onto ${losingSuperstar.name} and a pile of electrical equipment below the ramp!`
        ],
        "Cell": [
            `${winningSuperstar.name} threw ${losingSuperstar.name} off the side of the cell through the announce table!`,
            `${winningSuperstar.name} speared ${losingSuperstar.name} through the cell wall!`,
            `${winningSuperstar.name} catapulted ${losingSuperstar.name} into the steel wall!`,
            `${winningSuperstar.name} slammed ${losingSuperstar.name} on top of the cell!`
        ]
    };
    // For level 3 gimmick matches
    let levelThreeTexts = {
        "Cage": [
            `${winningSuperstar.name} jumped off the cage and crashed on top of ${losingSuperstar.name}!`,
            `${winningSuperstar.name} hit a moonsault off the cage onto ${losingSuperstar.name}!`
        ],
        "LMS": [
            `${winningSuperstar.name} jumped off the titantron onto ${losingSuperstar.name}!`,
            `${winningSuperstar.name} threw ${losingSuperstar.name} off the titantron!`
        ],
        "TLC": [
            `${winningSuperstar.name} threw ${losingSuperstar.name} off a ladder through two tables on the outside!`,
            `${winningSuperstar.name} speared ${losingSuperstar.name} while {0} was dangling off the title, 15 feet in the air!`.format(losingSuperstar.pronoun)
        ],
        "Cell": [
            `${winningSuperstar.name} slammed ${losingSuperstar.name} through the top of the cell, sending {0} crashing to the mat below!`.format(losingSuperstar.objectivePronoun),
            `${winningSuperstar.name} dove off the top of the cell, crashing onto ${losingSuperstar.name} on the announce table below!`
        ]
    };
    // For gimmick matches not in the list
    let defaultTexts = [
        `${winningSuperstar.name} suplexed ${losingSuperstar.name} onto the apron, slamming {0} head hard on the edge!`.format(losingSuperstar.possessivePronoun),
        `${winningSuperstar.name} speared ${losingSuperstar.name} through the barricade!`,
        `${winningSuperstar.name} put ${losingSuperstar.name} through the announce table with an elbow drop from the top rope!`,
        `${winningSuperstar.name} hit ${losingSuperstar.name} with {0} finisher off the top rope!`.format(winningSuperstar.possessivePronoun),
        `${winningSuperstar.name} was about to hit ${losingSuperstar.name} with {0} finisher before both of them collapsed from exhaustion!`.format(winningSuperstar.possessivePronoun),
        `${winningSuperstar.name} hit ${losingSuperstar.name} with a hard headbutt that almost knocked them both out!`,
        `${winningSuperstar.name} suplexed ${losingSuperstar.name} from the apron through a table outside!`,
        `${winningSuperstar.name} reversed ${losingSuperstar.name}'s finisher, cursed at {0} and hit {1} own!`.format(losingSuperstar.objectivePronoun, winningSuperstar.possessivePronoun),
        `${winningSuperstar.name} slapped the taste out of ${losingSuperstar.name}'s mouth before both of them started brawling!`,
        `${winningSuperstar.name} refused to give up as {0} crawled around for two minutes in ${losingSuperstar.name}'s submission!`.format(winningSuperstar.pronoun),
        `${winningSuperstar.name} hit ${losingSuperstar.name} with a lariat that knocked {0} head off!`.format(losingSuperstar.possessivePronoun),
        `${winningSuperstar.name} spat in ${losingSuperstar.name}'s face when {0} asked for a handshake!`.format(losingSuperstar.pronoun),
        `${winningSuperstar.name} got up from ${losingSuperstar.name}'s finisher before asking {0} to hit another!`.format(losingSuperstar.objectivePronoun),
        `${winningSuperstar.name} and ${losingSuperstar.name} started a battle of forearms before both kicked each other's heads off!`,
        `${winningSuperstar.name} kicked out of ${losingSuperstar.name}'s finisher, used {0} body to get up and asked to be finished off!`.format(losingSuperstar.possessivePronoun),
        `${winningSuperstar.name} hit ${losingSuperstar.name} with three consecutive finishers!`
    ];
    // Get choices
    let choices = defaultTexts;
    for (const key of Object.keys(texts))if (gimmickMatch && gimmickMatch.name.split(" ").some((y)=>y.toLowerCase() === key.toLowerCase())) {
        choices = texts[key];
        if (gimmickMatch.level >= 3 && Object.keys(levelThreeTexts).includes(key)) choices.push(...levelThreeTexts[key]);
        break;
    }
    return (0, $3E8Nt.getRandomChoice)(choices);
}
function $4ff5c4925572972c$var$updateMatchManagersForMembersChange(match, previousManagersUsed, newMembers, oldMembers, superstarsPresent) {
    let newMembersIds = newMembers.map((x)=>x.$loki.toString());
    let oldMembersIds = oldMembers.map((x)=>x.$loki.toString());
    let superstarsPresentIds = superstarsPresent.map((x)=>x.$loki);
    for (const [superstarId, managerId] of Object.entries(previousManagersUsed))if (!superstarsPresentIds.includes(managerId) && !Object.values(match.managersUsed).includes(managerId)) {
        if (oldMembersIds.includes(superstarId) && !newMembersIds.includes(superstarId)) {
            let replacingSuperstarId = newMembersIds.find((x)=>!match.managersUsed[x]);
            if (!replacingSuperstarId) replacingSuperstarId = newMembersIds.find((x)=>!oldMembersIds.includes(x));
            match.managersUsed[replacingSuperstarId] = managerId;
        } else match.managersUsed[superstarId] = managerId;
    }
}

});
parcelRequire.register("ko5kE", function(module, exports) {

$parcel$export(module.exports, "getTagTeamMatchData", () => $ed7a2f5b18e3cd6c$export$3ad387fbaeb83738);
$parcel$export(module.exports, "getTagTeamDisplayData", () => $ed7a2f5b18e3cd6c$export$3f9de9c136e7cc33);
$parcel$export(module.exports, "getTagTeamPopularity", () => $ed7a2f5b18e3cd6c$export$e17b720efaa4c1a);
$parcel$export(module.exports, "getTagTeamBrandName", () => $ed7a2f5b18e3cd6c$export$8df692b2e2c2d109);
$parcel$export(module.exports, "removeTagTeam", () => $ed7a2f5b18e3cd6c$export$a4e0bac268302074);

var $972Ip = parcelRequire("972Ip");

var $5kTkA = parcelRequire("5kTkA");

var $hBIDz = parcelRequire("hBIDz");

var $kZwpB = parcelRequire("kZwpB");

var $2JFAd = parcelRequire("2JFAd");

var $14eBR = parcelRequire("14eBR");

var $ivuOU = parcelRequire("ivuOU");

var $1AAHK = parcelRequire("1AAHK");

var $8A6FL = parcelRequire("8A6FL");

var $4EGpv = parcelRequire("4EGpv");
async function $ed7a2f5b18e3cd6c$export$3ad387fbaeb83738(tagTeam, matchChampionships, managersUsed, rosterSuperstars = null) {
    let tagTeamSuperstars = [
        ...await (0, $972Ip.getTagTeamSuperstars)(tagTeam)
    ];
    tagTeamSuperstars.sort((a, b)=>a.$loki - b.$loki);
    let championshipSuperstarIds = matchChampionships.map((x)=>x.superstarId);
    let data = {};
    data["name"] = tagTeam.name;
    data["champion"] = tagTeamSuperstars.some((x)=>championshipSuperstarIds.includes(x.$loki));
    data["trioTagTeam"] = tagTeam.trioTagTeam;
    data["factionTagTeam"] = tagTeam.factionTagTeam;
    data["members"] = await Promise.all(tagTeamSuperstars.map((x)=>(0, $5kTkA.getSuperstarMatchOrSegmentData)(x, matchChampionships, managersUsed, rosterSuperstars)));
    if (tagTeam.trioTagTeam) {
        // Find trio, get trio members
        let teamTrio = false;
        if (tagTeamSuperstars.length > 0) {
            let memberTagTeams = await (0, $hBIDz.getSuperstarTagTeams)(tagTeamSuperstars[0]);
            teamTrio = memberTagTeams.find((x)=>x.trio);
        }
        if (teamTrio) {
            let trioSuperstars = await (0, $972Ip.getTagTeamSuperstars)(teamTrio);
            data["trioMembers"] = trioSuperstars.map((x)=>x.name);
            data["trioMembersSelected"] = tagTeamSuperstars.map((x)=>x.name);
        }
    }
    if (tagTeam.factionTagTeam) {
        let faction = null;
        if (tagTeamSuperstars.length > 0) {
            let memberFactions = await (0, $hBIDz.getSuperstarFactions)(tagTeamSuperstars[0]);
            faction = memberFactions.find((x)=>!x.disbanded);
        }
        if (faction) {
            let factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
            data["factionMembers"] = factionSuperstars.map((x)=>x.name);
            data["factionMembersSelected"] = tagTeamSuperstars.map((x)=>x.name);
        }
    }
    return data;
}
async function $ed7a2f5b18e3cd6c$export$3f9de9c136e7cc33({ tagTeam: tagTeam, scenarioInformation: scenarioInformation = false, rosterSuperstars: rosterSuperstars = null, managersUsed: managersUsed = null, getCurrentAttire: getCurrentAttire = false, getTournamentsWon: getTournamentsWon = false, tagTeamChampionships: tagTeamChampionships = null, game: game = null } = {}) {
    // Copy data
    let tagTeamData = JSON.parse(JSON.stringify(tagTeam));
    tagTeamData["uid"] = tagTeam.$loki;
    // Get superstars
    const teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
    // Get team superstars average attributes
    if (teamSuperstars) {
        tagTeamData["popularity"] = await $ed7a2f5b18e3cd6c$export$e17b720efaa4c1a(tagTeam, teamSuperstars);
        tagTeamData["rank"] = (0, $5kTkA.getRankFromPopularity)(tagTeamData["popularity"]);
        tagTeamData["alignmentMonths"] = Math.round(teamSuperstars.reduce((n, { alignmentMonths: alignmentMonths })=>n + alignmentMonths, 0) / teamSuperstars.length);
        tagTeamData["morale"] = Math.round(teamSuperstars.reduce((n, { morale: morale })=>n + morale, 0) / teamSuperstars.length);
        tagTeamData["age"] = Math.round(teamSuperstars.reduce((n, { age: age })=>n + age, 0) / teamSuperstars.length);
        tagTeamData["overness"] = Math.round(teamSuperstars.reduce((n, { overness: overness })=>n + overness, 0) / teamSuperstars.length);
        tagTeamData["workrate"] = teamSuperstars.reduce((n, { workrate: workrate })=>n + workrate, 0) / teamSuperstars.length;
        tagTeamData["charisma"] = teamSuperstars.reduce((n, { charisma: charisma })=>n + charisma, 0) / teamSuperstars.length;
        tagTeamData["fatigue"] = Math.round(teamSuperstars.reduce((n, { fatigue: fatigue })=>n + fatigue, 0) / teamSuperstars.length);
    }
    // Get superstars names and traits
    tagTeamData["superstars"] = teamSuperstars.map((x)=>x.name);
    tagTeamData["traits"] = teamSuperstars.map((x)=>{
        return x.traits.map((y)=>{
            return {
                "name": y,
                "superstar": x.name
            };
        });
    }).flat();
    // Get pronoun, alignment if same for every superstar
    tagTeamData["pronoun"] = teamSuperstars.length && teamSuperstars.every((x)=>x.pronoun === teamSuperstars[0].pronoun) ? teamSuperstars[0].pronoun : null;
    tagTeamData["alignment"] = teamSuperstars.length && teamSuperstars.every((x)=>x.alignment === teamSuperstars[0].alignment) ? teamSuperstars[0].alignment : null;
    // Get unhappy if any unhappy
    tagTeamData["unhappy"] = teamSuperstars.some((x)=>x.unhappy);
    // Get part timer if all part timer
    tagTeamData["partTimer"] = teamSuperstars.every((x)=>x.partTimer);
    // Get brand name
    tagTeamData["brandName"] = teamSuperstars.length && teamSuperstars.every((x)=>x.brandName === teamSuperstars[0].brandName) ? teamSuperstars[0].brandName : null;
    // Get minimum appearances
    const appearances = teamSuperstars.filter((x)=>x.appearances !== null);
    if (appearances.length > 0) tagTeamData["appearances"] = Math.min(...appearances.map((o)=>o.appearances));
    // Get championships
    if (!scenarioInformation) {
        tagTeamData["championships"] = [];
        // Get all tag championships of team superstars
        if (!tagTeamChampionships) tagTeamChampionships = (await Promise.all(teamSuperstars.map((x)=>{
            return (0, $hBIDz.getSuperstarChampionships)(x);
        }))).flat();
        // Filter trio/tagTeam
        const trio = tagTeam.trio;
        if (trio) tagTeamChampionships = tagTeamChampionships.filter((x)=>x.trio || x.tagTeam);
        else tagTeamChampionships = tagTeamChampionships.filter((x)=>x.tagTeam);
        // Get unique tag championships and sort
        let uniqueTagChampionships = (0, $kZwpB.getUniqueChampionships)(tagTeamChampionships);
        uniqueTagChampionships.sort((0, $kZwpB.compareChampionships));
        // Get team championships if not temporary team (4v4, 5v5 etc)
        let teamChampionships = [];
        if (!tagTeam.temporary || tagTeam.trioTagTeam || tagTeam.factionTagTeam) for (const c of uniqueTagChampionships){
            const championshipsSet = tagTeamChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, c));
            // Check if all championships of set are present in team superstars
            const setLength = c.trio ? 3 : 2;
            if (championshipsSet.length === setLength) teamChampionships.push(c);
        }
        // Get data for team championships
        for (const c of teamChampionships){
            let d = {};
            d["name"] = c.name;
            d["trio"] = c.trio;
            d["tagTeam"] = c.tagTeam;
            d["prestige"] = c.prestige;
            const championshipsSet = tagTeamChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, c));
            if (championshipsSet.every((x)=>x.championshipContract)) {
                d["championshipContract"] = true;
                d["championshipUid"] = c.$loki;
            }
            if (championshipsSet.every((x)=>x.matchContract)) {
                d["matchContract"] = true;
                // Find match contract
                let matchContract;
                for (const c of championshipsSet){
                    let m = await (0, $ivuOU.getChampionshipMatchContract)(c);
                    if (m) matchContract = m;
                }
                if (matchContract) d["event"] = (await (0, $1AAHK.getMatchContractEvent)(matchContract))?.name;
            }
            const reign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
            if (reign && game) d["reignLength"] = (0, $8A6FL.getChampionshipReignLength)(reign, game.monthCount, game.year);
            tagTeamData["championships"].push(d);
        }
        // Get graphics with championships
        tagTeamData["graphics"] = [];
        for (const s of teamSuperstars){
            let superstarGraphic = (0, $5kTkA.getGraphicForSuperstar)(s, getCurrentAttire);
            const superstarChampionship = tagTeamChampionships.find((x)=>x.superstarId === s.$loki);
            if (superstarChampionship && superstarGraphic) superstarGraphic["title"] = JSON.parse(JSON.stringify(superstarChampionship.graphic));
            tagTeamData["graphics"].push(superstarGraphic);
        }
    }
    // Get manager names
    if (rosterSuperstars) {
        const managerNames = [];
        for (const x of teamSuperstars){
            let manager;
            if (managersUsed) manager = await (0, $5kTkA.getSuperstarManagerUsedForMatchOrSegment)(x, managersUsed, rosterSuperstars);
            else {
                manager = rosterSuperstars.find((y)=>y.$loki === x.managerId);
                if (!manager) manager = await (0, $hBIDz.getSuperstarManager)(x);
            }
            if (manager && managerNames.indexOf(manager.name) < 0) managerNames.push(manager.name);
        }
        tagTeamData["managerNames"] = managerNames;
    }
    // Get tournaments won
    if (!scenarioInformation && getTournamentsWon) {
        tagTeamData["tournamentsWon"] = [];
        for (let tournament of (await (0, $972Ip.getTagTeamWonTournaments)(tagTeam))){
            let tournamentEvent = await (0, $4EGpv.getTournamentEvent)(tournament);
            tagTeamData["tournamentsWon"].push(`${tournament.name} ${tournamentEvent ? tournamentEvent.year : ""}`);
        }
    }
    return tagTeamData;
}
async function $ed7a2f5b18e3cd6c$export$e17b720efaa4c1a(tagTeam, superstars = null) {
    if (!superstars) superstars = await (0, $5kTkA.getRosterMemberSuperstars)(tagTeam);
    return Math.round(superstars.reduce((n, { popularity: popularity })=>n + popularity, 0) / superstars.length);
}
async function $ed7a2f5b18e3cd6c$export$8df692b2e2c2d109(tagTeam, superstars = null) {
    if (!superstars) superstars = await (0, $5kTkA.getRosterMemberSuperstars)(tagTeam);
    return superstars.every((x)=>x.brandName === superstars[0].brandName) ? superstars[0].brandName : null;
}
async function $ed7a2f5b18e3cd6c$export$a4e0bac268302074(tagTeam) {
    await (0, $972Ip.removeTagTeamSuperstars)(tagTeam);
    tagTeam.rosterId = null; // Remove from roster
    for (const negotiation of (await (0, $972Ip.getTagTeamNegotiations)(tagTeam)))await (0, $14eBR.Negotiations).remove(negotiation);
    for (const streak of (await (0, $972Ip.getTagTeamStreaks)(tagTeam))){
        streak.ended = true;
        streak.eventId = null; // Remove from event
    }
    // Delete faction tag teams created for segments
    if (tagTeam.factionTagTeam && !tagTeam.wins && !tagTeam.losses) await (0, $14eBR.TagTeams).remove(tagTeam);
}

});
parcelRequire.register("2JFAd", function(module, exports) {

$parcel$export(module.exports, "Faction", () => $1fe00a4413250d3d$export$241fa4a02666ccb0);
$parcel$export(module.exports, "getFactionRoster", () => $1fe00a4413250d3d$export$93c50d58716bd743);
$parcel$export(module.exports, "addFactionSuperstars", () => $1fe00a4413250d3d$export$fae31c204ed101aa);
$parcel$export(module.exports, "removeFactionSuperstars", () => $1fe00a4413250d3d$export$776ef38469c856d2);
$parcel$export(module.exports, "getFactionSuperstars", () => $1fe00a4413250d3d$export$4603bab433e531da);
$parcel$export(module.exports, "getFactionLeaderSuperstar", () => $1fe00a4413250d3d$export$35033b6b97e87e0);
$parcel$export(module.exports, "setFactionLeaderSuperstar", () => $1fe00a4413250d3d$export$96caca371bf8b656);
$parcel$export(module.exports, "removeFactionLeaderSuperstar", () => $1fe00a4413250d3d$export$e5e34d45ae9adf5d);
$parcel$export(module.exports, "getFactionFeuds", () => $1fe00a4413250d3d$export$bb4a97530f705c85);

var $14eBR = parcelRequire("14eBR");
function $1fe00a4413250d3d$export$241fa4a02666ccb0() {
    // Strings
    const name = null;
    const objectName = "faction";
    // Integer
    const reputation = null;
    const xp = 0;
    const xpGainedThisYear = 0;
    // Boolean
    const disbanded = false;
    // Arrays
    const formerMembers = [];
    // Foreign keys
    const rosterId = null;
    const leaderSuperstarId = null;
    return {
        name: name,
        reputation: reputation,
        xp: xp,
        xpGainedThisYear: xpGainedThisYear,
        disbanded: disbanded,
        formerMembers: formerMembers,
        rosterId: rosterId,
        leaderSuperstarId: leaderSuperstarId,
        objectName: objectName
    };
}
function $1fe00a4413250d3d$export$93c50d58716bd743(faction) {
    return (0, $14eBR.Rosters).find({
        "$loki": faction.rosterId
    })[0];
}
function $1fe00a4413250d3d$export$fae31c204ed101aa(faction, superstars) {
    let factionHashes = superstars.map((x)=>{
        return {
            factionId: faction.$loki,
            superstarId: x.$loki
        };
    });
    return (0, $14eBR.FactionsHash).insert(factionHashes);
}
async function $1fe00a4413250d3d$export$776ef38469c856d2(faction, superstars) {
    const superstarIds = superstars.map((x)=>{
        return x.$loki;
    });
    const factionHashesToRemove = await (0, $14eBR.FactionsHash).where((x)=>x.factionId === faction.$loki && superstarIds.includes(x.superstarId));
    for (const x of factionHashesToRemove)(0, $14eBR.FactionsHash).remove(x);
}
async function $1fe00a4413250d3d$export$4603bab433e531da(faction) {
    const factionHashes = await (0, $14eBR.FactionsHash).find({
        "factionId": faction.$loki
    });
    const superstarIds = factionHashes.map((x)=>{
        return x.superstarId;
    });
    return (0, $14eBR.Superstars).find({
        "$loki": {
            "$in": superstarIds
        }
    });
}
function $1fe00a4413250d3d$export$35033b6b97e87e0(faction) {
    if (faction.leaderSuperstarId) return (0, $14eBR.Superstars).find({
        "$loki": faction.leaderSuperstarId
    })[0];
    else return null;
}
function $1fe00a4413250d3d$export$96caca371bf8b656(faction, superstar) {
    faction.leaderSuperstarId = superstar.$loki;
}
function $1fe00a4413250d3d$export$e5e34d45ae9adf5d(faction) {
    faction.leaderSuperstarId = null;
}
async function $1fe00a4413250d3d$export$bb4a97530f705c85(faction) {
    const feudHashes = await (0, $14eBR.FeudParticipantsHash).find({
        "factionId": faction.$loki
    });
    const feudIds = feudHashes.map((x)=>{
        return x.feudId;
    });
    return (0, $14eBR.Feuds).find({
        "$loki": {
            "$in": feudIds
        }
    });
}

});

parcelRequire.register("4EGpv", function(module, exports) {

$parcel$export(module.exports, "Tournament", () => $363bcba90d7f317f$export$24507df08ec3bc29);
$parcel$export(module.exports, "getTournamentWinnerSuperstar", () => $363bcba90d7f317f$export$d75145ef6707aea3);
$parcel$export(module.exports, "getTournamentEvent", () => $363bcba90d7f317f$export$e340e194d7c1b43a);
$parcel$export(module.exports, "addTournamentMatches", () => $363bcba90d7f317f$export$7990a0201255d407);
$parcel$export(module.exports, "getTournamentMatches", () => $363bcba90d7f317f$export$e7cfcfe260ca4e35);
$parcel$export(module.exports, "addTournamentChampionships", () => $363bcba90d7f317f$export$dcfd74336efb3d64);
$parcel$export(module.exports, "addTournamentMatchContracts", () => $363bcba90d7f317f$export$ef785f00c4f5533c);
$parcel$export(module.exports, "getTournamentMatchContracts", () => $363bcba90d7f317f$export$9c8d6fc978e30235);

var $14eBR = parcelRequire("14eBR");
function $363bcba90d7f317f$export$24507df08ec3bc29(name, type, rounds, matchesAtEvent = null, participantsAdvancing = null, knockoutRounds = null, numberOfGroups = null) {
    // Integer
    const xp = 0;
    const startingXp = 0;
    const cost = 150;
    // String
    const prestige = "C";
    const stage = null;
    const winnerName = null;
    const matchContractName = null;
    const awardName = null;
    const status = null;
    // Boolean
    const annualTournament = false;
    // Objects
    const companiesData = {};
    // Foreign keys
    const companyId = null;
    const winnerSuperstarId = null;
    const winnerTagTeamId = null;
    const eventId = null;
    return {
        name: name,
        type: type,
        rounds: rounds,
        matchesAtEvent: matchesAtEvent,
        participantsAdvancing: participantsAdvancing,
        knockoutRounds: knockoutRounds,
        numberOfGroups: numberOfGroups,
        xp: xp,
        startingXp: startingXp,
        cost: cost,
        prestige: prestige,
        stage: stage,
        winnerName: winnerName,
        matchContractName: matchContractName,
        awardName: awardName,
        status: status,
        annualTournament: annualTournament,
        companiesData: companiesData,
        companyId: companyId,
        winnerSuperstarId: winnerSuperstarId,
        winnerTagTeamId: winnerTagTeamId,
        eventId: eventId
    };
}
function $363bcba90d7f317f$export$d75145ef6707aea3(tournament) {
    return (0, $14eBR.Superstars).find({
        "$loki": tournament.winnerSuperstarId
    })[0];
}
function $363bcba90d7f317f$export$2f4a32335d0e218b(tournament) {
    return (0, $14eBR.TagTeams).find({
        "$loki": tournament.winnerTagTeamId
    })[0];
}
function $363bcba90d7f317f$export$e340e194d7c1b43a(tournament) {
    return (0, $14eBR.Events).find({
        "$loki": tournament.eventId
    })[0];
}
function $363bcba90d7f317f$export$7990a0201255d407(tournament, matches) {
    matches.forEach((c)=>{
        c.tournamentId = tournament.$loki;
    });
}
function $363bcba90d7f317f$export$370f991ac3b81763(tournament, matches) {
    matches.forEach((c)=>{
        c.tournamentId = null;
    });
}
function $363bcba90d7f317f$export$e7cfcfe260ca4e35(tournament) {
    return (0, $14eBR.Matches).find({
        "tournamentId": tournament.$loki
    });
}
function $363bcba90d7f317f$export$dcfd74336efb3d64(tournament, championships) {
    championships.forEach((c)=>{
        c.tournamentId = tournament.$loki;
    });
}
function $363bcba90d7f317f$export$3b54b4d594174b29(tournament, championships) {
    championships.forEach((c)=>{
        c.tournamentId = null;
    });
}
function $363bcba90d7f317f$export$19935b5ca8080065(tournament) {
    return (0, $14eBR.Championships).find({
        "tournamentId": tournament.$loki
    });
}
function $363bcba90d7f317f$export$ef785f00c4f5533c(tournament, matchContracts) {
    matchContracts.forEach((c)=>{
        c.tournamentId = tournament.$loki;
    });
}
function $363bcba90d7f317f$export$3b37a8e6187d8d90(tournament, matchContracts) {
    matchContracts.forEach((c)=>{
        c.tournamentId = null;
    });
}
function $363bcba90d7f317f$export$9c8d6fc978e30235(tournament) {
    return (0, $14eBR.MatchContracts).find({
        "tournamentId": tournament.$loki
    });
}

});


parcelRequire.register("cXLSF", function(module, exports) {

$parcel$export(module.exports, "getFeudData", () => $970022da1cbf4562$export$e24de7f47450bd3);
$parcel$export(module.exports, "getFeudParticipantsNames", () => $970022da1cbf4562$export$e34ceb1d7f101603);
$parcel$export(module.exports, "getMatchesForStaleFeud", () => $970022da1cbf4562$export$7ae02ed6ea164ec4);
$parcel$export(module.exports, "getRosterMemberFeuds", () => $970022da1cbf4562$export$3c72f6cf1609909a);
$parcel$export(module.exports, "getViewFeudsData", () => $970022da1cbf4562$export$98e337fe8484aa9d);
$parcel$export(module.exports, "getFeudHistoryData", () => $970022da1cbf4562$export$5ec992343dea2008);
$parcel$export(module.exports, "endViewFeudsFeud", () => $970022da1cbf4562$export$257cc048960a92cc);
$parcel$export(module.exports, "endFeud", () => $970022da1cbf4562$export$4418f243777f0334);
$parcel$export(module.exports, "getFeudRating", () => $970022da1cbf4562$export$9f318d37bf59aac9);
$parcel$export(module.exports, "getAllTalentData", () => $970022da1cbf4562$export$5cf5743b6dd0dd5f);
$parcel$export(module.exports, "getCreateFeudItemsData", () => $970022da1cbf4562$export$2d0ea11555f1c282);
$parcel$export(module.exports, "getAvailableFeudItems", () => $970022da1cbf4562$export$4068de3b381d66ad);
$parcel$export(module.exports, "generateRandomFeudItemName", () => $970022da1cbf4562$export$121a6c35fff88679);
$parcel$export(module.exports, "getAvailableFeudsForMatch", () => $970022da1cbf4562$export$4e326d7289e76fa3);
$parcel$export(module.exports, "createFeud", () => $970022da1cbf4562$export$32d5f153bd3c9554);
$parcel$export(module.exports, "getFeudConsequenceAppliedTo", () => $970022da1cbf4562$export$2d5bb4ed8fb683e5);
$parcel$export(module.exports, "getFeudsForBooking", () => $970022da1cbf4562$export$af60eb84591b3610);
$parcel$export(module.exports, "getFeudSegmentsInformation", () => $970022da1cbf4562$export$153123b5cfaf4b60);
$parcel$export(module.exports, "getPreviousFeudHypeBoost", () => $970022da1cbf4562$export$a3ba6d1ac7b55cbf);
$parcel$export(module.exports, "getParticipantFeuds", () => $970022da1cbf4562$export$8e3d8066211e0bdd);
$parcel$export(module.exports, "addFeudToMatchOrSegment", () => $970022da1cbf4562$export$20f508e9ebc0ab23);
$parcel$export(module.exports, "getFeudCreationPreviousFeudsBoost", () => $970022da1cbf4562$export$3d79133f5a8d81a7);
$parcel$export(module.exports, "getFeudCreationBoosts", () => $970022da1cbf4562$export$cb9a3c32b0d1ab0b);
$parcel$export(module.exports, "removeFeudFromMatchOrSegment", () => $970022da1cbf4562$export$6e3068b4fe668add);
$parcel$export(module.exports, "changeFeudBlowoff", () => $970022da1cbf4562$export$24a8471a9e1f4e2);
$parcel$export(module.exports, "checkFeudBlowoffMatchParticipantType", () => $970022da1cbf4562$export$6e1a4c081bd530e9);
$parcel$export(module.exports, "runFeudConsequence", () => $970022da1cbf4562$export$a24acf28e6ff3521);

var $jDtEn = parcelRequire("jDtEn");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $5kTkA = parcelRequire("5kTkA");

var $aP7lq = parcelRequire("aP7lq");

var $14eBR = parcelRequire("14eBR");

var $i7bmn = parcelRequire("i7bmn");

var $eg5dz = parcelRequire("eg5dz");

var $6RCLU = parcelRequire("6RCLU");

var $hBIDz = parcelRequire("hBIDz");

var $972Ip = parcelRequire("972Ip");

var $jpMCP = parcelRequire("jpMCP");

var $9esFv = parcelRequire("9esFv");

var $2JFAd = parcelRequire("2JFAd");

var $im36F = parcelRequire("im36F");

var $lhVvD = parcelRequire("lhVvD");

var $ivuOU = parcelRequire("ivuOU");

var $9MKdC = parcelRequire("9MKdC");

var $4ptHI = parcelRequire("4ptHI");

var $cYLJ6 = parcelRequire("cYLJ6");

var $kZwpB = parcelRequire("kZwpB");

var $1olyO = parcelRequire("1olyO");

var $kZMqI = parcelRequire("kZMqI");

var $hekDR = parcelRequire("hekDR");

var $ko5kE = parcelRequire("ko5kE");

var $3SyPM = parcelRequire("3SyPM");

var $6PzHO = parcelRequire("6PzHO");

var $jC7EP = parcelRequire("jC7EP");

var $3MfBd = parcelRequire("3MfBd");
async function $970022da1cbf4562$export$e24de7f47450bd3(feud, getParticipants = false, month = null, year = null, getHistory = false, getStaleLength = true, feudParticipants = null, getUpdatedParticipants = false) {
    let data = {};
    data["name"] = feud.name;
    data["hype"] = feud.hype;
    data["started"] = feud.started;
    data["runBlowoff"] = feud.runBlowoff;
    data["consequence"] = (await (0, $jDtEn.getFeudFeudItem)(feud))?.consequence;
    data["ended"] = feud.ended;
    data["hot"] = feud.hot;
    data["stale"] = feud.stale;
    data["stalenessCounter"] = feud.stalenessCounter;
    data["uid"] = feud.$loki;
    // Get months since blowoff if feud ended
    if (feud.ended) {
        data["rating"] = feud.rating;
        if (month !== null) data["monthsSinceBlowoff"] = (0, $3E8Nt.getMonthsDifference)(month, year, feud.endMonth, feud.endYear);
    }
    // Get months elapsed
    if (data["started"]) {
        if (!feud.ended) {
            if (month !== null) data["monthsElapsed"] = (0, $3E8Nt.getMonthsDifference)(month, year, feud.startMonth, feud.startYear);
        } else data["monthsElapsed"] = (0, $3E8Nt.getMonthsDifference)(feud.endMonth, feud.endYear, feud.startMonth, feud.startYear);
    }
    // Get participants
    if (getParticipants) {
        data["participants"] = await $970022da1cbf4562$export$e34ceb1d7f101603(feud);
        if (getUpdatedParticipants) data["participants"] = (await (0, $jDtEn.getFeudParticipants)(feud)).map((x)=>x.name);
    }
    // Get stale length
    if (getStaleLength) {
        if (!feudParticipants) feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
        data["staleLength"] = await $970022da1cbf4562$export$7ae02ed6ea164ec4(feud, feudParticipants);
    }
    if (getHistory) {
        // Get feud roster's superstars
        const feudRoster = await (0, $jDtEn.getFeudRoster)(feud);
        let rosterSuperstars = [];
        if (feudRoster) rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(feudRoster);
        // Get feud matches and segments in order of their events
        let feudMatchesAndSegments = (await (0, $jDtEn.getFeudMatches)(feud)).concat(await (0, $jDtEn.getFeudSegments)(feud));
        const eventIds = await Promise.all(feudMatchesAndSegments.map(async (x)=>(await (0, $i7bmn.getMatchEvent)(x))?.$loki));
        feudMatchesAndSegments.sort((a, b)=>{
            return eventIds[feudMatchesAndSegments.indexOf(b)] - eventIds[feudMatchesAndSegments.indexOf(a)];
        });
        // Add matches and segments data
        data["events"] = [];
        for (const y of feudMatchesAndSegments)if (y.rating !== null) {
            let d;
            if (y.objectName === "segment") {
                d = await (0, $4ptHI.getSegmentData)({
                    segment: y,
                    history: true,
                    rosterSuperstars: rosterSuperstars
                });
                d["eventType"] = "segment";
            } else {
                d = await (0, $6RCLU.getMatchData)({
                    match: y,
                    history: true,
                    getChampionshipsAvailable: false,
                    rosterSuperstars: rosterSuperstars
                });
                d["eventType"] = "match";
            }
            d["eventWeeklyShow"] = (await (0, $eg5dz.getSegmentEvent)(y))?.weeklyShow;
            data["events"].push(d);
        }
        // Get win records
        data["winRecords"] = data["participants"].map((x)=>{
            return {
                "name": x,
                "wins": 0
            };
        });
        for (const x of data["winRecords"]){
            for (const m of data["events"])if (m["eventType"] === "match") {
                // If trio/faction tagteam in match, use regex to search for trio/faction in match's winner name
                if (m["type"] === "tag" && m["participants"].some((y)=>y["trioTagTeam"] || y["factionTagTeam"])) {
                    if ((0, $3E8Nt.findNameInString)(x["name"], m["winner"]["name"])) x["wins"] += 1;
                } else if (x["name"] === m["winner"]["name"]) x["wins"] += 1;
            }
        }
        // Get past feuds between same participants
        let pastFeuds = [];
        const feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
        const participantFeuds = feudParticipants.length > 0 ? (await $970022da1cbf4562$export$3c72f6cf1609909a(feudParticipants[0])).reverse() : [];
        const participantPastFeuds = participantFeuds.filter((x)=>x.started && x.ended && x.$loki !== feud.$loki);
        for (const f of participantPastFeuds){
            const feudParticipantNames = await $970022da1cbf4562$export$e34ceb1d7f101603(f);
            if (feudParticipantNames.every((y)=>data["participants"].indexOf(y) >= 0)) pastFeuds.push(f);
        }
        data["pastFeuds"] = await Promise.all(pastFeuds.map((x)=>$970022da1cbf4562$export$e24de7f47450bd3(x, false, month, year)));
    }
    return data;
}
async function $970022da1cbf4562$export$e34ceb1d7f101603(feud) {
    if (feud.participants) return feud.participants;
    else return (await (0, $jDtEn.getFeudParticipants)(feud)).map((x)=>x.name);
}
async function $970022da1cbf4562$export$7ae02ed6ea164ec4(feud, feudParticipants) {
    let staleLength = 4;
    if (feud.hot) staleLength = 6;
    // Get trait boost for feud staleness limit
    let traitBoost = 0;
    for (const participant of feudParticipants){
        const participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participant);
        for (const superstar of participantSuperstars)for (const trait of superstar.traits){
            const traitData = (0, $aP7lq.traitsData)[trait];
            if (traitData && traitData["feud_staleness_limit_boost"]) traitBoost += traitData["feud_staleness_limit_boost"];
        }
    }
    traitBoost = (0, $3E8Nt.limitValueBetweenRange)(traitBoost, -2, 2);
    staleLength += traitBoost;
    return staleLength;
}
async function $970022da1cbf4562$export$98e337fe8484aa9d() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterFeuds = (await (0, $dl5u4.getRosterFeuds)(mainRoster)).reverse();
    let currentFeuds = [];
    let potentialFeuds = [];
    let pastFeuds = [];
    for (const [index, feud] of rosterFeuds.entries()){
        const feudData = await $970022da1cbf4562$export$e24de7f47450bd3(feud, true, currentGame.monthCount, currentGame.year, false, false);
        feudData["order"] = index; // Add order to feuds for sorting by date
        if (feud.started && feud.ended) pastFeuds.push(feudData);
        else if (feud.started) currentFeuds.push(feudData);
        else if (feud.directFeudEvent && !feud.ended) potentialFeuds.push(feudData);
    }
    data["currentFeuds"] = currentFeuds;
    data["potentialFeuds"] = potentialFeuds.slice(0, 8);
    data["pastFeuds"] = pastFeuds;
    return data;
}
async function $970022da1cbf4562$export$5ec992343dea2008(uid) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const feud = await (0, $14eBR.Feuds).get(uid);
    return $970022da1cbf4562$export$e24de7f47450bd3(feud, true, currentGame.monthCount, currentGame.year, true);
}
async function $970022da1cbf4562$export$3c72f6cf1609909a(rosterMember) {
    if (rosterMember.objectName === "superstar") return (0, $hBIDz.getSuperstarFeuds)(rosterMember);
    else if (rosterMember.objectName === "tagTeam") return (0, $972Ip.getTagTeamFeuds)(rosterMember);
    else return (0, $2JFAd.getFactionFeuds)(rosterMember);
}
async function $970022da1cbf4562$export$257cc048960a92cc(uid) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const feud = await (0, $14eBR.Feuds).get(uid);
    await $970022da1cbf4562$export$4418f243777f0334(feud, currentGame.monthCount, currentGame.year);
    (0, $14eBR.db).saveDatabase();
    return $970022da1cbf4562$export$e24de7f47450bd3(feud, true, currentGame.monthCount, currentGame.year);
}
async function $970022da1cbf4562$export$4418f243777f0334(feud, month, year) {
    feud.ended = true;
    feud.endMonth = month;
    feud.endYear = year;
    // Get feud rating
    if (!feud.started) feud.rating = null;
    else feud.rating = await $970022da1cbf4562$export$9f318d37bf59aac9(feud);
    return feud;
}
async function $970022da1cbf4562$export$9f318d37bf59aac9(feud) {
    const feudSegments = await (0, $jDtEn.getFeudSegments)(feud);
    const feudMatches = await (0, $jDtEn.getFeudMatches)(feud);
    const feudMatchesAndSegments = feudSegments.concat(feudMatches);
    return $970022da1cbf4562$var$calculateFeudRating(feudMatchesAndSegments);
}
function $970022da1cbf4562$var$calculateFeudRating(matchesAndSegments) {
    let filteredMatchesAndSegments = matchesAndSegments.filter((x)=>x.rating !== null);
    if (filteredMatchesAndSegments.length <= 0) return 0;
    const ratingsSum = filteredMatchesAndSegments.map((x)=>x.rating).reduce((partialSum, a)=>partialSum + a, 0);
    const average = ratingsSum / filteredMatchesAndSegments.length;
    return (0, $3E8Nt.myround)(average, 0.25);
}
async function $970022da1cbf4562$export$5cf5743b6dd0dd5f(participantType) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    let participants = [];
    if (participantType === "singles") participants = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    else if (participantType === "tag") participants = await (0, $jpMCP.getRosterActiveTagTeams)(mainRoster);
    else if (participantType === "trio") participants = (await (0, $jpMCP.getRosterActiveTagTeams)(mainRoster)).filter((x)=>x.trio);
    else if (participantType === "faction") participants = (await (0, $dl5u4.getRosterFactions)(mainRoster)).filter((x)=>!x.disbanded);
    participants.sort((a, b)=>a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    return participants.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
}
async function $970022da1cbf4562$export$2d0ea11555f1c282(participantUids, participantType, participants) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const feudItems = (await (0, $9esFv.getCompanyFeudItems)(userCompany)).reverse();
    // Get feud participants
    if (!participants) {
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
        participants = [];
        for (const participantUid of participantUids){
            let participant = await $970022da1cbf4562$var$getFeudParticipantFromUid(participantUid, participantType, mainRoster);
            if (!participant) {
                data["error"] = "participant-not-found";
                return data;
            }
            participants.push(participant);
        }
    }
    // Get available and unavailable feud items
    let unavailableFeudItems = [];
    let availableFeudItems = [];
    if (participants.length > 0) {
        let feudParticipantsType;
        if (participantType === "trio") feudParticipantsType = "tag";
        else feudParticipantsType = participantType;
        const companyLogs = await (0, $9esFv.getCompanyCompanyLogs)(userCompany);
        const feudItemsData = await $970022da1cbf4562$export$4068de3b381d66ad(feudItems, participants, userCompany.storyName, currentGame.monthCount, currentGame.year, companyLogs, feudParticipantsType);
        availableFeudItems = feudItemsData[0];
        unavailableFeudItems = feudItemsData[1];
    } else availableFeudItems = feudItems;
    // Get data for feud items
    availableFeudItems.sort((a, b)=>a.baseHype - b.baseHype || (a.requirement, b.requirement, true));
    unavailableFeudItems.sort((a, b)=>a.baseHype - b.baseHype || (a.requirement, b.requirement, true));
    data["availableFeudItems"] = availableFeudItems.map((x)=>$970022da1cbf4562$var$getFeudItemData(x));
    data["unavailableFeudItems"] = unavailableFeudItems.map((x)=>$970022da1cbf4562$var$getFeudItemData(x));
    // Get random feud name
    data["randomFeudName"] = $970022da1cbf4562$export$121a6c35fff88679();
    return data;
}
async function $970022da1cbf4562$export$4e326d7289e76fa3({ matchUid: matchUid, matchType: matchType, isSegment: isSegment } = {}) {
    let data = {};
    // Get participants
    let participants;
    if (isSegment) {
        let segment = await (0, $14eBR.Segments).get(matchUid);
        if (!segment) {
            data["error"] = "segment-not-found";
            return data;
        }
        participants = await (0, $eg5dz.getSegmentParticipants)(segment);
    } else {
        let match = await (0, $14eBR.Matches).get(matchUid);
        if (!match) {
            data["error"] = "match-not-found";
            return data;
        }
        participants = await (0, $i7bmn.getMatchParticipants)(match);
    }
    // Check if superstar vs team feud
    if (participants.some((x)=>x.objectName === "superstar") && participants.some((x)=>x.objectName === "tagTeam")) {
        data["error"] = "superstar-and-team";
        return data;
    }
    if (matchType === "tag") {
        // Set 'faction' matchType
        if (participants.every((x)=>x.factionTagTeam)) matchType = "faction";
        // Check for faction vs non faction
        if (participants.some((x)=>x.factionTagTeam) && participants.some((x)=>!x.factionTagTeam)) {
            data["error"] = "faction-vs-non-faction";
            return data;
        }
        // Check for temporary team
        if (participants.some((x)=>x.temporary && !x.factionTagTeam && !x.trioTagTeam)) {
            data["error"] = "temporary-team";
            return data;
        }
    }
    // Get feud items
    data = await $970022da1cbf4562$export$2d0ea11555f1c282([], matchType, participants);
    return data;
}
async function $970022da1cbf4562$export$4068de3b381d66ad(feudItems, participants, storyName, month, year, companyLogs, participantsType) {
    let singles = false;
    let tag = false;
    let trio = false;
    const participantsSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    const retirementAge = storyName !== "mars" ? 45 : 55;
    const titleFeudRequirements = [
        "new-title-challenger",
        "champions",
        "long-title-reign",
        "previous-title-feud",
        "previous-champion",
        "old-and-champion"
    ];
    // Filter feud items based on participants type
    if (participantsType === "singles") {
        feudItems = feudItems.filter((x)=>x.singles);
        singles = true;
    } else if (participantsType === "tag") {
        feudItems = feudItems.filter((x)=>x.tag);
        tag = true;
        trio = participants.every((x)=>x.trio);
    } else if (participantsType === "faction") feudItems = feudItems.filter((x)=>x.faction);
    // Get feud items with no requirements
    let availableFeudItems = feudItems.filter((x)=>!x.requirement && x.unlocked);
    // Define check functions
    async function faceVsFaceCheck() {
        return participantsSuperstars.every((x)=>x.alignment === "face");
    }
    async function heelVsHeelCheck() {
        return participantsSuperstars.every((x)=>x.alignment === "heel");
    }
    async function faceVsHeelCheck() {
        if (singles) return participantsSuperstars.some((x)=>x.alignment === "face") && participantsSuperstars.some((x)=>x.alignment === "heel");
        else {
            let heelsPresent = false;
            let facesPresent = false;
            for (const p of participants){
                const ps = await (0, $5kTkA.getRosterMemberSuperstars)(p);
                if (ps.every((x)=>x.alignment === "face")) facesPresent = true;
                if (ps.every((x)=>x.alignment === "heel")) heelsPresent = true;
            }
            return facesPresent && heelsPresent;
        }
    }
    async function partTimerVsFullTimerCheck() {
        return participantsSuperstars.some((x)=>x.partTimer) && participantsSuperstars.some((x)=>!x.partTimer && !x.retired);
    }
    async function hallOfFamerReturnCheck() {
        return participantsSuperstars.some((x)=>x.hallOfFamer) && participantsSuperstars.some((x)=>!x.partTimer && !x.retired && !x.hallOfFamer);
    }
    async function retiringSuperstarCheck() {
        return participantsSuperstars.some((x)=>x.age >= retirementAge);
    }
    async function retiringSuperstarsCheck() {
        return participantsSuperstars.every((x)=>x.age >= retirementAge);
    }
    async function facesOfTheCompanyCheck() {
        return participantsSuperstars.every((x)=>x.faceOfTheCompany);
    }
    async function becomingFotcCheck() {
        return participantsSuperstars.every((x)=>x.faceOfTheCompanyCounter > 0 && !x.faceOfTheCompany);
    }
    async function upperMidcardersCheck() {
        return participantsSuperstars.every((x)=>x.popularity >= 740 && x.popularity < 800);
    }
    async function lowerVsUpperMidcardersCheck() {
        return participantsSuperstars.some((x)=>(0, $5kTkA.getRankFromPopularity)(x.popularity) === "Lower Midcarder") && participantsSuperstars.some((x)=>(0, $5kTkA.getRankFromPopularity)(x.popularity) === "Upper Midcarder");
    }
    async function unhappyVsHappyCheck() {
        return participantsSuperstars.some((x)=>!x.unhappy) && participantsSuperstars.some((x)=>x.unhappy);
    }
    async function youngVsOldCheck() {
        return participantsSuperstars.some((x)=>x.age > 37) && participantsSuperstars.some((x)=>x.age < 25);
    }
    async function youngMidcardersCheck() {
        return participantsSuperstars.every((x)=>[
                "Upper Midcarder",
                "Lower Midcarder"
            ].indexOf((0, $5kTkA.getRankFromPopularity)(x.popularity)) >= 0 && x.age < 30);
    }
    async function highWorkrateCheck() {
        return participantsSuperstars.every((x)=>x.workrate >= 3);
    }
    async function faceVsFaceHotCheck() {
        return participantsSuperstars.every((x)=>x.alignment === "face" && x.hot);
    }
    async function heelVsHeelHotCheck() {
        return participantsSuperstars.every((x)=>x.alignment === "heel" && x.hot);
    }
    async function largePopularityLossCheck() {
        const ranks = {
            "Main Eventer": 4,
            "Upper Midcarder": 3,
            "Lower Midcarder": 2,
            "Jabroni": 1
        };
        return participantsSuperstars.some((x)=>(ranks[(0, $5kTkA.getRankFromPopularity)(x.popularity)] || 1) < (ranks[x.highestRank] || 1)) && participantsSuperstars.some((x)=>(ranks[(0, $5kTkA.getRankFromPopularity)(x.popularity)] || 1) >= (ranks[x.highestRank] || 1));
    }
    async function sameManagerCheck() {
        return participantsSuperstars.every((x)=>x.managerId && x.managerId === participantsSuperstars[0].managerId);
    }
    async function tagPartnersCheck() {
        const participantTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(participantsSuperstars[0])).filter((x)=>!x.trio && !x.temporary);
        const participantNames = participants.map((x)=>x.name);
        for (const participantTagTeam of participantTagTeams){
            const tagTeamMembers = await (0, $972Ip.getTagTeamSuperstars)(participantTagTeam);
            if (tagTeamMembers.map((x)=>x.name).every((y)=>participantNames.indexOf(y) >= 0)) return true;
        }
        return false;
    }
    async function differentBrandsCheck() {
        let brandsPresent = participantsSuperstars.filter((x)=>x.brandName).map((y)=>y.brandName);
        brandsPresent = [
            ...new Set(brandsPresent)
        ];
        return brandsPresent.length > 1;
    }
    async function championsCheck() {
        let notChampion = false;
        if (singles) for (const participant of participants){
            let participantChampionships = await (0, $hBIDz.getSuperstarChampionships)(participant);
            participantChampionships = participantChampionships.filter((x)=>!x.tagTeam && !x.trio && !x.championshipContract && !x.matchContract);
            if (participantChampionships.length <= 0) {
                notChampion = true;
                break;
            }
        }
        else if (tag) for (const participant of participants){
            const teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participant);
            let participantChampionships = (await Promise.all(teamSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            if (participant.trio) participantChampionships = participantChampionships.filter((x)=>x.trio && !x.championshipContract && !x.matchContract);
            else participantChampionships = participantChampionships.filter((x)=>x.tagTeam && !x.championshipContract && !x.matchContract);
            if (participantChampionships.length <= 0) {
                notChampion = true;
                break;
            }
        }
        return !notChampion;
    }
    async function oldAndLongStreakCheck() {
        // Streak of 5 years or longer
        let streaks = (await Promise.all(participants.map((x)=>(0, $3E8Nt.getRosterMemberStreaks)(x)))).flat().filter((x)=>x.length > 4);
        let challengerCheck = false;
        for (const streak of streaks){
            const streakTalent = await (0, $lhVvD.getStreakTalent)(streak);
            const streakChallenger = participants.find((x)=>x.$loki !== streakTalent.$loki);
            if (streakChallenger && streakChallenger.age >= 38) challengerCheck = true;
        }
        return challengerCheck;
    }
    async function oldAndChampionCheck() {
        let champions = [];
        for (const participant of participants){
            let participantChampionships = await (0, $hBIDz.getSuperstarChampionships)(participant);
            participantChampionships = participantChampionships.filter((x)=>!x.tagTeam && !x.trio && !x.championshipContract && !x.matchContract);
            if (participantChampionships.length > 0) champions.push(participant);
        }
        let challengerCheck = false;
        if (champions.length === 1) {
            let champion = champions[0];
            const challenger = participantsSuperstars.find((x)=>x.$loki !== champion.$loki);
            if (challenger && challenger.age >= 38) challengerCheck = true;
        }
        return challengerCheck;
    }
    async function longStreakCheck() {
        // Streak of 5 years or longer
        let streaks = (await Promise.all(participants.map((x)=>(0, $3E8Nt.getRosterMemberStreaks)(x)))).flat().filter((x)=>x.length > 4);
        return streaks.length > 0;
    }
    async function newTagTeamCheck() {
        const newTagTeamsNames = [];
        for (const companyLog of companyLogs)if (companyLog.realYear !== null) {
            // Team created less than 6 months ago
            const monthsPassed = (0, $3E8Nt.getMonthsDifference)(month, year, companyLog.month, companyLog.realYear);
            if (companyLog.type === "new-tag-team" && monthsPassed < 6) newTagTeamsNames.push(companyLog.text);
        }
        // One team is new, one is not
        return participants.some((x)=>newTagTeamsNames.indexOf(x.name) >= 0) && participants.some((x)=>newTagTeamsNames.indexOf(x.name) < 0);
    }
    async function oldAndMaskCheck() {
        if (singles) {
            const maskedParticipants = participants.filter((x)=>(0, $5kTkA.checkSuperstarGraphicMask)(x.graphic));
            if (maskedParticipants.length === 1) {
                const challenger = participants.find((x)=>x.$loki !== maskedParticipants[0].$loki);
                if (challenger && challenger.age >= 38) return true;
            }
        }
        return false;
    }
    async function indieSuperstarCheck() {
        const signingNames = [];
        for (const companyLog of companyLogs)if (companyLog.realYear !== null) {
            const monthsPassed = (0, $3E8Nt.getMonthsDifference)(month, year, companyLog.month, companyLog.realYear);
            if (companyLog.type === "signing" && monthsPassed < 6) signingNames.push(companyLog.text);
        }
        return participants.some((x)=>signingNames.indexOf(x.name) >= 0) && participants.some((x)=>signingNames.indexOf(x.name) < 0);
    }
    async function tradeDealCheck() {
        return participantsSuperstars.some((x)=>x.activeEffect === "traded") && participantsSuperstars.some((x)=>x.activeEffect !== "traded");
    }
    async function previousChampionCheck() {
        let previousChampionPresent = false;
        for (const participant of participants){
            // Find previous champion within reigns of champion
            let participantChampionships = await (0, $hBIDz.getSuperstarChampionships)(participant);
            participantChampionships = participantChampionships.filter((x)=>!x.tagTeam && !x.trio && !x.championshipContract && !x.matchContract);
            for (const participantChampionship of participantChampionships)for (const reign of (await (0, $ivuOU.getChampionshipChampionshipReigns)(participantChampionship))){
                const reignSuperstar = await (0, $9MKdC.getChampionshipReignSuperstar)(reign);
                if ((0, $3E8Nt.objectInArray)(reignSuperstar, participants) && reignSuperstar.$loki !== participant.$loki && reign.endMonth !== null) previousChampionPresent = true;
            }
        }
        return previousChampionPresent;
    }
    async function factionVsFactionHotCheck() {
        const allFactionSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        return allFactionSuperstars.every((x)=>x.hot);
    }
    async function factionMembersCheck() {
        const faction = (await (0, $hBIDz.getSuperstarFactions)(participants[0])).find((x)=>!x.disbanded);
        if (faction) {
            const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
            // Check if faction superstars are above 2 and feud participants are present in faction
            if (factionSuperstars.length > 2 && participants.every((x)=>(0, $3E8Nt.objectInArray)(x, factionSuperstars))) return true;
        }
        return false;
    }
    async function factionLeaderPresentCheck() {
        const faction = (await (0, $hBIDz.getSuperstarFactions)(participants[0])).find((x)=>!x.disbanded);
        if (faction) {
            const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
            const leaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(faction);
            // Check if faction leader present and feud participants are present in faction
            if (leaderSuperstar && (0, $3E8Nt.objectInArray)(leaderSuperstar, factionSuperstars) && participants.every((x)=>(0, $3E8Nt.objectInArray)(x, factionSuperstars))) return true;
        }
        return false;
    }
    async function noFactionLeaderCheck() {
        const faction = (await (0, $hBIDz.getSuperstarFactions)(participants[0])).find((x)=>!x.disbanded);
        if (faction) {
            const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
            const leaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(faction);
            // Check if faction leader not present and feud participants are present in faction
            if (!leaderSuperstar && participants.every((x)=>(0, $3E8Nt.objectInArray)(x, factionSuperstars))) return true;
        }
        return false;
    }
    async function factionPresentCheck() {
        let factionCheck = false;
        for (const p of participants){
            const faction = (await (0, $hBIDz.getSuperstarFactions)(p)).find((x)=>!x.disbanded);
            if (faction) {
                const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
                // Check if faction superstars are below maximum and feud participants are not in same faction
                if (factionSuperstars.length < (0, $3E8Nt.gameLimits).maxFactionSuperstars && !participants.every((x)=>(0, $3E8Nt.objectInArray)(x, factionSuperstars))) factionCheck = true;
            }
        }
        return factionCheck;
    }
    async function matchContractWonCheck() {
        let matchContractFound = false;
        if (singles) {
            for (const participant of participants)if ((await (0, $hBIDz.getSuperstarChampionships)(participant)).find((x)=>x.matchContract)) {
                matchContractFound = true;
                break;
            }
        } else if (tag) for (const participant of participants){
            const teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participant);
            let participantChampionships = (await Promise.all(teamSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            if (participant.trio) participantChampionships = participantChampionships.filter((x)=>x.trio && x.matchContract);
            else participantChampionships = participantChampionships.filter((x)=>x.tagTeam && x.matchContract);
            if (participantChampionships.length > 0) {
                matchContractFound = true;
                break;
            }
        }
        return matchContractFound;
    }
    async function longTitleReignCheck() {
        if (singles) {
            let reignCheck = false;
            for (const participant of participants){
                let participantReigns = await (0, $hBIDz.getSuperstarChampionshipReigns)(participant);
                for (const reign of participantReigns){
                    const reignChampionship = await (0, $9MKdC.getChampionshipReignChampionship)(reign);
                    if (reign.endMonth === null && (0, $3E8Nt.getMonthsDifference)(month, year, reign.startMonth, reign.startYear) > 6 && reignChampionship && !reignChampionship.tagTeam && !reignChampionship.trio && !reignChampionship.vacated) reignCheck = true;
                }
            }
            return reignCheck;
        } else if (tag) {
            let reigns = [];
            for (const participant of participants){
                const teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participant);
                for (const s of teamSuperstars){
                    let superstarReigns = await (0, $hBIDz.getSuperstarChampionshipReigns)(s);
                    for (const reign of superstarReigns){
                        const reignChampionship = await (0, $9MKdC.getChampionshipReignChampionship)(reign);
                        if (reign.endMonth === null && (0, $3E8Nt.getMonthsDifference)(month, year, reign.startMonth, reign.startYear) > 6 && reignChampionship && (trio && reignChampionship.trio || !trio && reignChampionship.tagTeam) && !reignChampionship.vacated) reigns.push(reign);
                    }
                }
            }
            return reigns.length > 1;
        }
        return false;
    }
    async function previousHotFeudCheck() {
        let previousHotFeudCheck = false;
        for (const participant of participants){
            const feuds = (await $970022da1cbf4562$export$3c72f6cf1609909a(participant)).filter((x)=>x.started && x.ended && x.hot);
            for (const feud of feuds)if ((await (0, $jDtEn.getFeudParticipants)(feud)).every((x)=>(0, $3E8Nt.objectInArray)(x, participants))) previousHotFeudCheck = true;
        }
        return previousHotFeudCheck;
    }
    async function previousFeudsCheck() {
        let previousFeuds = [];
        for (const participant of participants){
            const feuds = (await $970022da1cbf4562$export$3c72f6cf1609909a(participant)).filter((x)=>x.started && x.ended && x.rating > 3.5);
            for (const feud of feuds)if ((await (0, $jDtEn.getFeudParticipants)(feud)).every((x)=>(0, $3E8Nt.objectInArray)(x, participants)) && !(0, $3E8Nt.objectInArray)(feud, previousFeuds)) previousFeuds.push(feud);
        }
        return previousFeuds.length >= 2;
    }
    async function newTitleChallengerCheck() {
        // Check for previous title feuds
        let previousTitleFeuds = [];
        for (const participant of participants){
            let feuds = (await $970022da1cbf4562$export$3c72f6cf1609909a(participant)).filter((x)=>x.started && x.ended);
            for (const feud of feuds){
                const fi = await (0, $jDtEn.getFeudFeudItem)(feud);
                if (titleFeudRequirements.indexOf(fi.requirement) >= 0 && (await (0, $jDtEn.getFeudParticipants)(feud)).every((x)=>(0, $3E8Nt.objectInArray)(x, participants)) && !(0, $3E8Nt.objectInArray)(feud, previousTitleFeuds)) previousTitleFeuds.push(feud);
            }
        }
        if (previousTitleFeuds.length >= 1) return false;
        // Check for champion
        let championCheck = false;
        if (singles) for (const participant of participants){
            let participantChampionships = await (0, $hBIDz.getSuperstarChampionships)(participant);
            participantChampionships = participantChampionships.filter((x)=>!x.tagTeam && !x.trio && !x.championshipContract && !x.matchContract);
            if (participantChampionships.length > 0) {
                championCheck = true;
                break;
            }
        }
        else if (tag) for (const participant of participants){
            const teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participant);
            let participantChampionships = (await Promise.all(teamSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
            if (participant.trio) participantChampionships = participantChampionships.filter((x)=>x.trio && !x.championshipContract && !x.matchContract);
            else participantChampionships = participantChampionships.filter((x)=>x.tagTeam && !x.championshipContract && !x.matchContract);
            if (participantChampionships.length > 0) {
                championCheck = true;
                break;
            }
        }
        return championCheck;
    }
    async function previousTitleFeudCheck() {
        // Check for previous title feuds
        let previousTitleFeuds = [];
        for (const participant of participants){
            let feuds = (await $970022da1cbf4562$export$3c72f6cf1609909a(participant)).filter((x)=>x.started && x.ended);
            for (const feud of feuds){
                const fi = await (0, $jDtEn.getFeudFeudItem)(feud);
                if (titleFeudRequirements.indexOf(fi.requirement) >= 0 && (await (0, $jDtEn.getFeudParticipants)(feud)).every((x)=>(0, $3E8Nt.objectInArray)(x, participants)) && !(0, $3E8Nt.objectInArray)(feud, previousTitleFeuds)) previousTitleFeuds.push(feud);
            }
        }
        if (previousTitleFeuds.length >= 1) {
            // Check if champion present, don't allow champion vs champion
            let champions = [];
            if (singles) for (const participant of participants){
                let participantChampionships = await (0, $hBIDz.getSuperstarChampionships)(participant);
                participantChampionships = participantChampionships.filter((x)=>!x.tagTeam && !x.trio && !x.championshipContract && !x.matchContract);
                if (participantChampionships.length > 0) champions.push(participant);
            }
            else if (tag) for (const participant of participants){
                const teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participant);
                let participantChampionships = (await Promise.all(teamSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
                if (participant.trio) participantChampionships = participantChampionships.filter((x)=>x.trio && !x.championshipContract && !x.matchContract);
                else participantChampionships = participantChampionships.filter((x)=>x.tagTeam && !x.championshipContract && !x.matchContract);
                if (participantChampionships.length > 0) champions.push(participant);
            }
            return champions.length === 1;
        }
        return false;
    }
    const checkFunctions = {
        "face-vs-face": faceVsFaceCheck,
        "heel-vs-heel": heelVsHeelCheck,
        "part-timer-vs-full-timer": partTimerVsFullTimerCheck,
        "retiring-superstar": retiringSuperstarCheck,
        "retiring-superstars": retiringSuperstarsCheck,
        "faces-of-the-company": facesOfTheCompanyCheck,
        "becoming-fotc": becomingFotcCheck,
        "upper-midcarders": upperMidcardersCheck,
        "lower-vs-upper-midcarder": lowerVsUpperMidcardersCheck,
        "unhappy-vs-happy": unhappyVsHappyCheck,
        "young-vs-old": youngVsOldCheck,
        "young-midcarders": youngMidcardersCheck,
        "face-vs-heel": faceVsHeelCheck,
        "high-workrate": highWorkrateCheck,
        "face-vs-face-hot": faceVsFaceHotCheck,
        "heel-vs-heel-hot": heelVsHeelHotCheck,
        "large-popularity-loss": largePopularityLossCheck,
        "same-manager": sameManagerCheck,
        "tag-partners": tagPartnersCheck,
        "different-brands": differentBrandsCheck,
        "champions": championsCheck,
        "old-and-long-streak": oldAndLongStreakCheck,
        "old-and-champion": oldAndChampionCheck,
        "long-streak": longStreakCheck,
        "new-tag-team": newTagTeamCheck,
        "old-and-mask": oldAndMaskCheck,
        "indie-superstar": indieSuperstarCheck,
        "hall-of-famer-return": hallOfFamerReturnCheck,
        "trade-deal": tradeDealCheck,
        "previous-champion": previousChampionCheck,
        "faction-vs-faction-hot": factionVsFactionHotCheck,
        "faction-members": factionMembersCheck,
        "faction-leader-present": factionLeaderPresentCheck,
        "no-faction-leader": noFactionLeaderCheck,
        "faction-present": factionPresentCheck,
        "match-contract-won": matchContractWonCheck,
        "long-title-reign": longTitleReignCheck,
        "new-title-challenger": newTitleChallengerCheck,
        "previous-feuds": previousFeudsCheck,
        "previous-title-feud": previousTitleFeudCheck,
        "previous-hot-feud": previousHotFeudCheck
    };
    // Check feud items with requirements
    let feudItemsToCheck = feudItems.filter((x)=>x.requirement && x.unlocked);
    for (const feudItem of feudItemsToCheck){
        const checkFunction = checkFunctions[feudItem.requirement];
        if (checkFunction && await checkFunction()) availableFeudItems.push(feudItem);
    }
    // Add direct feuds
    for (const participant of participants){
        for (const feud of (await $970022da1cbf4562$export$3c72f6cf1609909a(participant)))if (!feud.started && feud.directFeudEvent && !feud.ended && (await (0, $jDtEn.getFeudParticipants)(feud)).every((x)=>(0, $3E8Nt.objectInArray)(x, participants))) {
            const fi = feudItemsToCheck.filter((x)=>x.requirement === feud.directFeudEvent);
            for (const y of fi)if (!(0, $3E8Nt.objectInArray)(y, availableFeudItems)) availableFeudItems.push(y);
        }
    }
    // Get unavailable feud items
    let availableFeudItemIds = availableFeudItems.map((x)=>x.$loki);
    let unavailableFeudItems = feudItems.filter((x)=>availableFeudItemIds.indexOf(x.$loki) < 0);
    return [
        availableFeudItems,
        unavailableFeudItems
    ];
}
function $970022da1cbf4562$var$getFeudItemData(feudItem) {
    let data = {};
    data["name"] = feudItem.name;
    data["description"] = feudItem.description;
    data["level"] = feudItem.level;
    data["xp"] = feudItem.xp;
    data["baseHype"] = feudItem.baseHype;
    data["consequence"] = feudItem.consequence;
    data["requirement"] = feudItem.requirement;
    data["oneAtATime"] = feudItem.oneAtATime;
    data["category"] = feudItem.category;
    data["unlocked"] = feudItem.unlocked;
    data["uid"] = feudItem.$loki;
    return data;
}
function $970022da1cbf4562$export$121a6c35fff88679(previousName) {
    let names = [
        "Spite",
        "Marital Dispute",
        "You Took My Banana",
        "True Opposites",
        "Stalker",
        "Patriotism",
        "Kidnapping",
        "Family Affair",
        "Embarrassment",
        "I'm Above You",
        "Financial Trouble",
        "My Hair Is Better",
        "Love or Hate?",
        "Demonic Exorcism",
        "Insulted My Spouse",
        "Jealousy",
        "Resentment",
        "Mother Insult",
        "Property Destruction",
        "Vanity",
        "Cheating Spouse",
        "Illegitimate Child",
        "Hurt My Ego",
        "Insulting The Dead",
        "Backstage Heat",
        "Stole My Friend",
        "Better Entrance",
        "You Are A Prude",
        "God Hates You",
        "Moral Disagreement",
        "Pineapple on Pizza",
        "Stole My Gimmick",
        "Burned Down House",
        "Goo Fight",
        "Better Merch",
        "Duel",
        "That's My Move",
        "Toilet Prank",
        "Former Friends",
        "Creeper",
        "You Smell",
        "Undeserving",
        "God Loves You",
        "I Loved You",
        "Better Cook",
        "Murder",
        "Better Car",
        "Last Rites",
        "Stolen Parking Spot",
        "Intimidation",
        "Torment"
    ];
    if (previousName) names = names.filter((item)=>item !== previousName);
    return (0, $3E8Nt.getRandomChoice)(names);
}
async function $970022da1cbf4562$export$32d5f153bd3c9554(feudItemUid, customFeudName, participantUids, participantType) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const cost = 5;
    // Check if enough points
    if (userCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Get feud item
    const feudItem = await (0, $14eBR.FeudItems).get(feudItemUid);
    if (!feudItem) {
        data["error"] = "feud-item-not-found";
        return data;
    }
    // Get feud participants
    let feudParticipants = [];
    for (const participantUid of participantUids){
        let participant = await $970022da1cbf4562$var$getFeudParticipantFromUid(participantUid, participantType, mainRoster);
        if (!participant) {
            data["error"] = "participant-not-found";
            return data;
        }
        if (feudParticipants.map((x)=>x.$loki).indexOf(participant.$loki) >= 0) {
            data["error"] = "duplicate-participants";
            return data;
        }
        feudParticipants.push(participant);
    }
    // Check for existing feuds
    const feudParticipantNames = feudParticipants.map((x)=>x.name);
    for (const f of (await $970022da1cbf4562$export$3c72f6cf1609909a(feudParticipants[0]))){
        // Check running feuds with same participants
        if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
            if ((await (0, $jDtEn.getFeudParticipants)(f)).every((x)=>feudParticipantNames.indexOf(x.name) >= 0)) {
                data["error"] = "existing-feud-present";
                return data;
            }
        }
    }
    // Create feud
    const newFeud = (0, $jDtEn.Feud)();
    newFeud.name = customFeudName || feudItem.name;
    newFeud.hype = feudItem.baseHype;
    newFeud.startMonth = currentGame.monthCount;
    newFeud.startYear = currentGame.year;
    newFeud.directFeudEvent = "created-manually";
    newFeud.participants = feudParticipantNames;
    // Get who to apply consequence to
    if (feudItem.oneWayConsequence) {
        let feudParticipantsType;
        if (participantType === "trio") feudParticipantsType = "tag";
        else feudParticipantsType = participantType;
        newFeud.consequenceAppliedTo = await $970022da1cbf4562$export$2d5bb4ed8fb683e5(feudItem, feudParticipants, feudParticipantsType);
    }
    // Save feud to db
    await (0, $14eBR.Feuds).insert(newFeud);
    // Add feud to feud item and roster
    await (0, $im36F.addFeudItemFeuds)(feudItem, [
        newFeud
    ]);
    await (0, $dl5u4.addRosterFeuds)(mainRoster, [
        newFeud
    ]);
    // Add feud to participants
    if (participantType === "singles") await (0, $jDtEn.addFeudSuperstars)(newFeud, feudParticipants);
    else if (participantType === "faction") await (0, $jDtEn.addFeudFactions)(newFeud, feudParticipants);
    else await (0, $jDtEn.addFeudTagTeams)(newFeud, feudParticipants);
    // Remove points
    userCompany.points -= cost;
    // Check tutorial action
    if (userCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
        "add_feud"
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["feudName"] = newFeud.name;
    data["feudHype"] = newFeud.hype;
    data["feudParticipantNames"] = feudParticipantNames;
    data["consequenceAppliedTo"] = newFeud.consequenceAppliedTo;
    data["consequence"] = feudItem.consequence;
    data["points"] = userCompany.points;
    return data;
}
async function $970022da1cbf4562$export$2d5bb4ed8fb683e5(feudItem, feudParticipants, feudParticipantsType) {
    if (feudItem.consequence === "retirement") {
        if (feudItem.requirement === "retiring-superstar") {
            const consequenceParticipant = feudParticipants.reduce((prev, current)=>prev.age > current.age ? prev : current);
            return consequenceParticipant.name;
        } else if (feudItem.requirement === "old-and-long-streak") {
            // Streak of 5 years or longer
            let streaks = (await Promise.all(feudParticipants.map((x)=>(0, $3E8Nt.getRosterMemberStreaks)(x)))).flat().filter((x)=>x.length > 4);
            for (const streak of streaks){
                const streakTalent = await (0, $lhVvD.getStreakTalent)(streak);
                const streakChallenger = feudParticipants.find((x)=>x.$loki !== streakTalent.$loki);
                if (streakChallenger && streakChallenger.age >= 38) return streakChallenger.name;
            }
        } else if (feudItem.requirement === "old-and-champion") {
            let champions = [];
            for (const participant of feudParticipants){
                let participantChampionships = await (0, $hBIDz.getSuperstarChampionships)(participant);
                participantChampionships = participantChampionships.filter((x)=>!x.tagTeam && !x.trio && !x.championshipContract && !x.matchContract);
                if (participantChampionships.length > 0) champions.push(participant);
            }
            if (champions.length === 1) {
                let champion = champions[0];
                const challenger = feudParticipants.find((x)=>x.$loki !== champion.$loki);
                if (challenger && challenger.age >= 38) return challenger.name;
            }
        }
    }
    if (feudItem.consequence === "unavailable") {
        if (feudItem.requirement === "previous-title-feud") {
            if (feudParticipantsType === "singles") for (const participant of feudParticipants){
                let participantChampionships = await (0, $hBIDz.getSuperstarChampionships)(participant);
                participantChampionships = participantChampionships.filter((x)=>!x.tagTeam && !x.trio && !x.championshipContract && !x.matchContract);
                if (participantChampionships.length <= 0) return participant.name;
            }
            else if (feudParticipantsType === "tag") for (const participant of feudParticipants){
                const teamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participant);
                let participantChampionships = (await Promise.all(teamSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
                if (participant.trio) participantChampionships = participantChampionships.filter((x)=>x.trio && !x.championshipContract && !x.matchContract);
                else participantChampionships = participantChampionships.filter((x)=>x.tagTeam && !x.championshipContract && !x.matchContract);
                if (participantChampionships.length <= 0) return participant.name;
            }
        }
        if (feudItem.requirement === "hall-of-famer-return") {
            const consequenceParticipant = feudParticipants.find((x)=>x.hallOfFamer);
            if (consequenceParticipant) return consequenceParticipant.name;
        }
    }
    if (feudItem.consequence === "winner-turns-face") {
        if (feudParticipantsType === "singles") {
            const consequenceParticipant = feudParticipants.find((x)=>x.alignment === "heel");
            if (consequenceParticipant) return consequenceParticipant.name;
        } else if ([
            "tag",
            "faction"
        ].indexOf(feudParticipantsType) >= 0) for (const participant of feudParticipants){
            const participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participant);
            if (participantSuperstars.every((x)=>x.alignment === "heel")) return participant.name;
        }
    }
    if (feudItem.consequence === "loser-turns-heel") {
        if (feudParticipantsType === "singles") {
            const consequenceParticipant = feudParticipants.find((x)=>x.alignment === "face");
            if (consequenceParticipant) return consequenceParticipant.name;
        } else if ([
            "tag",
            "faction"
        ].indexOf(feudParticipantsType) >= 0) for (const participant of feudParticipants){
            const participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participant);
            if (participantSuperstars.every((x)=>x.alignment === "face")) return participant.name;
        }
    }
    return null;
}
async function $970022da1cbf4562$export$af60eb84591b3610({ matchType: matchType } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const rosterFeuds = await (0, $dl5u4.getRosterFeuds)(mainRoster);
    let feuds = [];
    // Get feuds based on match type
    let matchTypeFeuds = [];
    for (const feud of rosterFeuds)if (!feud.ended) {
        // Get feud participants, cache for later
        const feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
        feud.tempParticipants = feudParticipants;
        // Get participant type
        let participantType;
        if (feudParticipants.length > 0) participantType = feudParticipants[0].objectName;
        if (matchType === "singles") {
            if (participantType === "superstar") matchTypeFeuds.push(feud);
        } else if (matchType === "tag") {
            if (participantType === "tagTeam" || participantType === "faction") matchTypeFeuds.push(feud);
        } else if (matchType === "trio") {
            // Only get feuds with all trio participants, and all faction participants having more than 2 superstars
            if (feudParticipants.every((x)=>x.objectName === "tagTeam" && x.trio)) matchTypeFeuds.push(feud);
            for (const p of feudParticipants)if (p.objectName === "faction") p.tempSuperstars = await (0, $2JFAd.getFactionSuperstars)(p);
            if (feudParticipants.every((x)=>x.objectName === "faction" && x.tempSuperstars.length > 2)) matchTypeFeuds.push(feud);
            for (const p of feudParticipants)if (p.objectName === "faction") delete p.tempSuperstars;
        } else matchTypeFeuds.push(feud);
    }
    // Check feud participant availability
    for (const feud of matchTypeFeuds){
        if (!(0, $3E8Nt.objectInArray)(feud, feuds)) {
            if (await $970022da1cbf4562$var$checkFeudParticipantsAvailability(feud.tempParticipants, rosterSuperstars, matchType, nextEvent, companyChampionships)) feuds.push(feud);
        }
    }
    // Sort feuds by hype
    feuds.sort((a, b)=>b.hype - a.hype);
    // Get data for feuds
    data["feuds"] = await Promise.all(feuds.map((x)=>$970022da1cbf4562$export$e24de7f47450bd3(x, true, currentGame.monthCount, currentGame.year, false, true, x.tempParticipants, true)));
    return data;
}
async function $970022da1cbf4562$var$checkFeudParticipantsAvailability(participants, rosterSuperstars, matchType, nextEvent, companyChampionships) {
    for (const x of participants){
        if (x.objectName === "superstar") {
            if (matchType === "segment") {
                if (!(0, $5kTkA.checkSuperstarSegmentAvailability)(x, false)) return false;
            } else {
                if (!(0, $5kTkA.checkAvailability)(x, true)) return false;
            }
            if (!(0, $3E8Nt.objectInArray)(x, rosterSuperstars)) return false;
            // Check for brand exclusive event
            const superstarChampionships = (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships);
            if (!(0, $5kTkA.checkSuperstarBrandAvailability)(nextEvent, x, superstarChampionships)) return false;
        } else if (x.objectName === "tagTeam" || x.objectName === "faction") {
            let minAvailableMembers = matchType === "trio" ? 3 : 2;
            if (matchType === "segment") minAvailableMembers = 2;
            // Check if minimum number of superstars are available
            const superstars = await (0, $5kTkA.getRosterMemberSuperstars)(x);
            let availableSuperstars;
            if (matchType === "segment") availableSuperstars = superstars.filter((x)=>(0, $5kTkA.checkSuperstarSegmentAvailability)(x, false));
            else availableSuperstars = superstars.filter((x)=>(0, $5kTkA.checkAvailability)(x, true));
            availableSuperstars = availableSuperstars.filter((x)=>(0, $5kTkA.checkSuperstarBrandAvailability)(nextEvent, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships)) && (0, $3E8Nt.objectInArray)(x, rosterSuperstars));
            if (availableSuperstars.length < minAvailableMembers) return false;
        }
    }
    return true;
}
async function $970022da1cbf4562$var$getFeudParticipantFromUid(uid, type, mainRoster) {
    let participant;
    if (type === "singles") participant = await (0, $14eBR.Superstars).get(uid);
    else if (type === "faction") participant = (await (0, $dl5u4.getRosterFactions)(mainRoster)).find((x)=>x.$loki === uid && !x.disbanded);
    else participant = await (0, $14eBR.TagTeams).get(uid);
    return participant;
}
async function $970022da1cbf4562$export$153123b5cfaf4b60({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const segmentItems = await (0, $9esFv.getCompanySegmentItems)(userCompany);
    const companyLogs = await (0, $9esFv.getCompanyCompanyLogs)(userCompany);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const availableStaffMembers = await (0, $8A6FL.getAvailableStaffMembers)(staffMembers);
    // Get feud
    const feud = await (0, $14eBR.Feuds).get(uid);
    // Get segment item names for past segments in feud, besides repeatable ones
    data["feudSegmentNames"] = [];
    for (const feudSegment of (await (0, $jDtEn.getFeudSegments)(feud))){
        const segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(feudSegment);
        if (feudSegment.rating && segmentItem.oneAtATime && !data["feudSegmentNames"].includes(segmentItem.name)) data["feudSegmentNames"].push(segmentItem.name);
    }
    // Get unavailable segment items
    const participants = await (0, $jDtEn.getFeudParticipants)(feud);
    let unavailableSegmentItems = [];
    let requirementChecksCompleted = [];
    let requirementChecksFailed = [];
    for (const x of segmentItems){
        // Check number of participants
        if (participants.length < x.minParticipants || participants.length > x.maxParticipants) unavailableSegmentItems.push(x.name);
        else if (x.requirement) {
            // Don't check requirement if already checked
            if (requirementChecksCompleted.includes(x.requirement) || requirementChecksFailed.includes(x.requirement)) {
                if (requirementChecksFailed.includes(x.requirement)) unavailableSegmentItems.push(x.name);
            } else {
                let check = await (0, $4ptHI.checkSegmentItemRequirement)(x, participants, companyLogs, currentGame.monthCount, currentGame.year, companyChampionships, availableStaffMembers);
                // Store requirement check
                if (!check.error) requirementChecksCompleted.push(x.requirement);
                else {
                    requirementChecksFailed.push(x.requirement);
                    unavailableSegmentItems.push(x.name);
                }
            }
        }
    }
    data["unavailableSegments"] = unavailableSegmentItems;
    return data;
}
function $970022da1cbf4562$export$a3ba6d1ac7b55cbf(previousFeud, month, year) {
    let hype = previousFeud.hype;
    hype = (0, $3E8Nt.limitValueBetweenRange)(hype, hype, 80);
    let monthsPassed = (0, $3E8Nt.getMonthsDifference)(month, year, previousFeud.endMonth, previousFeud.endYear);
    monthsPassed = (0, $3E8Nt.limitValueBetweenRange)(monthsPassed, monthsPassed, 12);
    let hypeBoost = 0;
    // Add months passed factor
    if (monthsPassed <= 6) hypeBoost = -90 + 15 * monthsPassed;
    else if (hype > 15) hypeBoost += monthsPassed - 2;
    // Add previous feud's rating factor
    hypeBoost += Math.floor((hype - 15) / 4);
    return hypeBoost;
}
async function $970022da1cbf4562$export$8e3d8066211e0bdd(superstars, teams) {
    let feuds = [];
    async function checkFeud(f, arr) {
        if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
            const p = await (0, $jDtEn.getFeudParticipants)(f);
            if (p.every((x)=>(0, $3E8Nt.objectInArray)(x, arr))) return true;
        }
        return false;
    }
    let factions = [];
    for (const s of superstars){
        let superstarFactions = await (0, $5kTkA.getSuperstarActiveFactions)(s);
        factions.push(...superstarFactions);
        for (const feud of (await $970022da1cbf4562$export$3c72f6cf1609909a(s)))if (await checkFeud(feud, superstars)) feuds.push(feud);
    }
    for (const t of teams){
        for (const feud of (await $970022da1cbf4562$export$3c72f6cf1609909a(t)))if (await checkFeud(feud, teams)) feuds.push(feud);
    }
    for (const f of (0, $3E8Nt.getUniqueObjects)(factions)){
        for (const feud of (await $970022da1cbf4562$export$3c72f6cf1609909a(f)))if (await checkFeud(feud, factions)) feuds.push(feud);
    }
    return (0, $3E8Nt.getUniqueObjects)(feuds);
}
async function $970022da1cbf4562$export$20f508e9ebc0ab23({ matchOrSegmentUid: matchOrSegmentUid, matchType: matchType, isSegment: isSegment, feudItemUid: feudItemUid, feudName: feudName } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    // Get match and its participants
    let participants;
    let matchOrSegment;
    if (isSegment) {
        matchOrSegment = await (0, $14eBR.Segments).get(matchOrSegmentUid);
        if (!matchOrSegment) {
            data["error"] = "segment-not-found";
            return data;
        }
        participants = await (0, $eg5dz.getSegmentParticipants)(matchOrSegment);
    } else {
        matchOrSegment = await (0, $14eBR.Matches).get(matchOrSegmentUid);
        if (!matchOrSegment) {
            data["error"] = "match-not-found";
            return data;
        }
        participants = await (0, $i7bmn.getMatchParticipants)(matchOrSegment);
    }
    // Get feud item
    const feudItem = await (0, $14eBR.FeudItems).get(feudItemUid);
    if (!feudItem) {
        data["error"] = "feud-item-not-found";
        return data;
    }
    // If trio or faction temporary tag team present, add the trio or faction to participants
    if (matchType === "tag") {
        let newParticipants = [];
        for (const p of participants){
            if (p.trioTagTeam) {
                let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(p);
                let trio = (await (0, $hBIDz.getSuperstarTagTeams)(participantSuperstars[0])).find((x)=>x.trio);
                if (trio) newParticipants.push(trio);
            } else if (p.factionTagTeam) {
                let participantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(p);
                let faction = (await (0, $hBIDz.getSuperstarFactions)(participantSuperstars[0])).find((x)=>!x.disbanded);
                if (faction) newParticipants.push(faction);
            } else newParticipants.push(p);
        }
        participants = [
            ...newParticipants
        ];
    }
    // Get participant type
    let participantType = matchType;
    if (participants.some((x)=>x.objectName === "faction")) participantType = "faction";
    // Check for existing feuds
    let existingFeud;
    for (const f of (await $970022da1cbf4562$export$3c72f6cf1609909a(participants[0]))){
        // Check running feuds with same participants
        if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
            if ((await (0, $jDtEn.getFeudParticipants)(f)).every((x)=>(0, $3E8Nt.objectInArray)(x, participants))) {
                existingFeud = f;
                break;
            }
        }
    }
    // Create new feud or use existing
    let newFeud;
    if (existingFeud) {
        newFeud = existingFeud;
        let existingFeudItem = await (0, $jDtEn.getFeudFeudItem)(newFeud);
        await (0, $im36F.removeFeudItemFeuds)(existingFeudItem, [
            newFeud
        ]);
    } else {
        newFeud = (0, $jDtEn.Feud)();
        newFeud.participants = participants.map((x)=>x.name);
    }
    // Add new feud attributes
    newFeud.name = feudName || feudItem.name;
    newFeud.hype = feudItem.baseHype;
    newFeud.startMonth = currentGame.monthCount;
    newFeud.startYear = currentGame.year;
    // Get who to apply consequence to
    if (feudItem.oneWayConsequence) {
        newFeud.consequenceAppliedTo = await $970022da1cbf4562$export$2d5bb4ed8fb683e5(feudItem, participants, matchType);
        data["consequenceAppliedTo"] = newFeud.consequenceAppliedTo;
    }
    // Save feud to db
    await (0, $14eBR.Feuds).insert(newFeud);
    // Add feud to feud item and roster
    await (0, $im36F.addFeudItemFeuds)(feudItem, [
        newFeud
    ]);
    await (0, $dl5u4.addRosterFeuds)(mainRoster, [
        newFeud
    ]);
    // Add feud to match/segment
    if (isSegment) await (0, $eg5dz.addSegmentFeuds)(matchOrSegment, [
        newFeud
    ]);
    else await (0, $i7bmn.addMatchFeuds)(matchOrSegment, [
        newFeud
    ]);
    // Add feud to participants
    if (!existingFeud) {
        if (participantType === "singles") await (0, $jDtEn.addFeudSuperstars)(newFeud, participants);
        else if (participantType === "faction") await (0, $jDtEn.addFeudFactions)(newFeud, participants);
        else await (0, $jDtEn.addFeudTagTeams)(newFeud, participants);
    }
    // Check tutorial action
    if (userCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
        "add_feud_to_match"
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["feud"] = await $970022da1cbf4562$export$e24de7f47450bd3(newFeud);
    data["previousFeudBoost"] = await $970022da1cbf4562$export$3d79133f5a8d81a7(newFeud, participants, currentGame.monthCount, currentGame.year);
    return data;
}
async function $970022da1cbf4562$export$cb9a3c32b0d1ab0b(feud, participants, month, year, style) {
    let data = {};
    let brandsPresent;
    data["rankBoost"] = await $970022da1cbf4562$var$getRankBoost(participants);
    data["alignmentBoost"] = await (0, $6RCLU.getAlignmentBoost)(participants, style);
    if (participants[0].objectName === "superstar") {
        data["hotParticipantsBoost"] = participants.filter((x)=>x.hot).length * 10;
        data["staleParticipantsBoost"] = participants.filter((x)=>x.stale).length * -10;
        brandsPresent = [
            ...new Set(participants.filter((x)=>x.brandName).map((x)=>x.brandName))
        ];
    } else if ([
        "tagTeam",
        "faction"
    ].includes(participants[0].objectName)) {
        let superstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        data["hotParticipantsBoost"] = superstars.filter((x)=>x.hot).length * 5;
        data["staleParticipantsBoost"] = superstars.filter((x)=>x.stale).length * -5;
        brandsPresent = [
            ...new Set(superstars.filter((x)=>x.brandName).map((x)=>x.brandName))
        ];
    }
    // Get brands boost
    data["brandsBoost"] = 0;
    if (brandsPresent.length > 1) data["brandsBoost"] = 10;
    // Get previous feuds boost
    data["previousFeudBoost"] = await $970022da1cbf4562$export$3d79133f5a8d81a7(feud, participants, month, year);
    // Add faction reputation boost if no previous feud penalty
    data["factionReputationBoost"] = 0;
    if (data["previousFeudBoost"] >= 0) data["factionReputationBoost"] = participants.filter((x)=>x.objectName === "faction").reduce((acc, x)=>acc + x.reputation * 3, 0);
    data["hypeBoost"] = data["rankBoost"] + data["alignmentBoost"] + data["previousFeudBoost"] + data["hotParticipantsBoost"] + data["staleParticipantsBoost"] + data["factionReputationBoost"] + data["brandsBoost"];
    return data;
}
async function $970022da1cbf4562$var$getRankBoost(participants) {
    let ranks = {
        "Main Eventer": 4,
        "Upper Midcarder": 2,
        "Lower Midcarder": 1,
        "Jabroni": 0
    };
    let rankBoost = 0;
    for (let p of participants){
        if (p.objectName === "superstar") {
            if (p.faceOfTheCompany) rankBoost += 12;
            else rankBoost += ranks[(0, $5kTkA.getRankFromPopularity)(p.popularity)] || 0;
        } else if ([
            "tagTeam",
            "faction"
        ].includes(p.objectName)) {
            for (let s of (await (0, $5kTkA.getRosterMemberSuperstars)(p)))if (s.faceOfTheCompany) rankBoost += 3;
            else rankBoost += (ranks[(0, $5kTkA.getRankFromPopularity)(s.popularity)] || 0) / 2;
        }
    }
    rankBoost /= 2;
    return Math.floor(rankBoost);
}
async function $970022da1cbf4562$export$3d79133f5a8d81a7(feud, participants, month, year) {
    let previousFeudBoost = 0;
    for (const p of participants){
        let previousFeuds = [];
        for (const f of (await $970022da1cbf4562$export$3c72f6cf1609909a(p)))if (f.started && f.ended && (await (0, $jDtEn.getFeudParticipants)(f)).every((x)=>(0, $3E8Nt.objectInArray)(x, participants)) && f.$loki !== feud.$loki) previousFeuds.push(f);
        if (previousFeuds.length > 0) {
            previousFeuds.sort((a, b)=>b.endYear - a.endYear || b.endMonth - a.endMonth);
            let previousFeud = previousFeuds[0];
            previousFeudBoost = $970022da1cbf4562$export$a3ba6d1ac7b55cbf(previousFeud, month, year);
            break;
        }
    }
    return previousFeudBoost;
}
async function $970022da1cbf4562$export$6e3068b4fe668add({ matchOrSegmentUid: matchOrSegmentUid, isSegment: isSegment } = {}) {
    let data = {};
    // Get match and its participants
    let feuds;
    let matchOrSegment;
    if (isSegment) {
        matchOrSegment = await (0, $14eBR.Segments).get(matchOrSegmentUid);
        if (!matchOrSegment) {
            data["error"] = "segment-not-found";
            return data;
        }
        feuds = await (0, $eg5dz.getSegmentFeuds)(matchOrSegment);
    } else {
        matchOrSegment = await (0, $14eBR.Matches).get(matchOrSegmentUid);
        if (!matchOrSegment) {
            data["error"] = "match-not-found";
            return data;
        }
        feuds = await (0, $i7bmn.getMatchFeuds)(matchOrSegment);
    }
    // Remove feuds
    data["deletedPotentialFeudUids"] = [];
    for (const feud of feuds){
        // Delete potential feuds
        if (!feud.started && !feud.directFeudEvent) {
            await (0, $14eBR.FeudParticipantsHash).findAndRemove({
                "feudId": feud.$loki
            });
            await (0, $14eBR.FeudMatchesHash).findAndRemove({
                "feudId": feud.$loki
            });
            await (0, $14eBR.FeudSegmentsHash).findAndRemove({
                "feudId": feud.$loki
            });
            await (0, $14eBR.Feuds).remove(feud);
            data["deletedPotentialFeudUids"].push(feud.$loki);
        } else // Remove direct feud from match/segment
        if (isSegment) await (0, $eg5dz.removeSegmentFeud)(matchOrSegment, feud);
        else await (0, $i7bmn.removeMatchFeud)(matchOrSegment, feud);
    }
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $970022da1cbf4562$export$24a8471a9e1f4e2({ matchUid: matchUid, matchType: matchType, feudUid: feudUid, add: add } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Get match
    let match = await (0, $14eBR.Matches).get(matchUid);
    if (!match) {
        data["error"] = "match-not-found";
        return data;
    }
    // Get feud
    let feud = await (0, $14eBR.Feuds).get(feudUid);
    let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
    let feudItem = await (0, $jDtEn.getFeudFeudItem)(feud);
    // Check for 1 on 1 match if consequence
    if (feudItem.consequence) {
        let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
        if (matchParticipants.length > 2) {
            data["error"] = "multi-person-match";
            return data;
        }
        if (add) {
            // Only allow blowoff if match type is same as feud participant type
            if (feudParticipants[0].objectName === "superstar") {
                if (matchType !== "singles") {
                    data["error"] = "singles-match-blowoff";
                    return data;
                }
            }
            if (feudParticipants[0].objectName === "faction") {
                if (matchType !== "tag") {
                    data["error"] = "faction-match-blowoff";
                    return data;
                }
            }
            if (feudParticipants[0].objectName === "tagTeam") {
                if (matchType !== "tag") {
                    data["error"] = "tag-match-blowoff";
                    return data;
                }
                if (feudParticipants.every((x)=>x.trio)) // Allow trios feud blowoff in tag or trios match
                for (const x of matchParticipants){
                    let participantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(x);
                    if (![
                        2,
                        3
                    ].includes(participantSuperstars.length)) {
                        data["error"] = "trio-match-blowoff";
                        return data;
                    }
                }
                else // Allow tag feud blowoff in tag match only
                for (const x of matchParticipants){
                    let participantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(x);
                    if (participantSuperstars.length !== 2) {
                        data["error"] = "tag-match-blowoff";
                        return data;
                    }
                }
            }
        }
    }
    // Check if blowoff already set
    if (add && feud.runBlowoff) {
        data["error"] = "blowoff-set";
        return data;
    }
    // Set blowoff
    feud.runBlowoff = add;
    // Add new gimmick match
    if (feudItem.consequence === "new-gimmick-match") {
        if (add) {
            // Generate or get gimmick match
            let newGimmickMatch;
            if (feud.consequenceAppliedTo) newGimmickMatch = (await (0, $9esFv.getCompanyGimmickMatches)(userCompany)).find((x)=>x.name === feud.consequenceAppliedTo);
            else {
                newGimmickMatch = (0, $8A6FL.generateGimmickMatch)();
                await (0, $14eBR.GimmickMatches).insert(newGimmickMatch);
                await (0, $9esFv.addCompanyGimmickMatches)(userCompany, [
                    newGimmickMatch
                ]);
                feud.consequenceAppliedTo = newGimmickMatch.name;
                data["newMatch"] = newGimmickMatch.name;
                data["participants"] = feudParticipants.map((x)=>x.name);
            }
            // Add to match
            if (newGimmickMatch) {
                // Remove existing
                let existingGimmickMatch = await (0, $i7bmn.getMatchGimmickMatch)(match);
                if (existingGimmickMatch) userCompany.points += existingGimmickMatch.cost;
                await (0, $cYLJ6.addGimmickMatchMatches)(newGimmickMatch, [
                    match
                ]);
            }
        } else {
            let existingGimmickMatch = await (0, $i7bmn.getMatchGimmickMatch)(match);
            await (0, $cYLJ6.removeGimmickMatchMatches)(existingGimmickMatch, [
                match
            ]);
        }
    }
    // Add all available championships to match
    data["gimmickRestrictedChampionships"] = [];
    if (feudItem.consequence === "unify-titles") {
        // Get championships to add to match
        let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
        let matchSuperstars = await (0, $i7bmn.getAllSuperstarsForMatch)(match);
        let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
        let matchEvent = await (0, $i7bmn.getMatchEvent)(match);
        let availableChampionshipsData = await (0, $kZwpB.getMatchAvailableChampionships)(matchParticipants, matchSuperstars, companyChampionships, matchGimmick, matchEvent);
        let availableChampionships = availableChampionshipsData["availableChampionships"];
        let championshipsToAdd = [];
        if (availableChampionships.length > 0) {
            if (add) {
                championshipsToAdd = availableChampionships;
                data["gimmickRestrictedChampionships"] = availableChampionshipsData["gimmickRestrictedChampionships"];
            } else // Revert to first championship when removing blowoff
            championshipsToAdd = [
                availableChampionships[0]
            ];
        }
        // Remove match's championships
        let matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
        for (const championship of matchChampionships){
            await (0, $i7bmn.removeMatchChampionships)(match, [
                championship
            ]);
            for (const x of companyChampionships.filter((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(y, championship)))x.booked = false;
        }
        // Add championships to match
        for (const championship of championshipsToAdd){
            await (0, $i7bmn.addMatchChampionships)(match, [
                championship
            ]);
            for (const x of companyChampionships.filter((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(y, championship)))x.booked = true;
        }
    }
    // Check tutorial action
    if (userCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
        "add_feud_blowoff"
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["match"] = await (0, $6RCLU.getMatchData)({
        match: match,
        companyChampionships: companyChampionships
    });
    data["points"] = userCompany.points;
    return data;
}
async function $970022da1cbf4562$export$6e1a4c081bd530e9(feudParticipants, matchParticipants, matchType, consequence) {
    // Only allow blowoff if match type is same as feud participant type, except if no consequence
    if (!consequence) return true;
    const feudParticipantType = feudParticipants[0].objectName;
    if (feudParticipantType === "superstar") {
        if (matchType !== "singles") return false;
    }
    if (feudParticipantType === "tagTeam") {
        if (matchType !== "tag") return false;
        let participantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(matchParticipants[0]);
        if (feudParticipants[0].trio) {
            // Allow trios feud blowoff in tag match (trio tagteam)
            if (![
                2,
                3
            ].includes(participantSuperstars.length)) return false;
        } else {
            if (participantSuperstars.length !== 2) return false;
        }
    }
    if (feudParticipantType === "faction") {
        if (matchType !== "tag") return false;
    }
    return true;
}
async function $970022da1cbf4562$export$a24acf28e6ff3521(feud, winner, loser, company, mainCompany, game, mainRoster, indieRoster, match, month, year, matchGraphics, matchType = "singles") {
    const data = {};
    let feudPotentials = [];
    let feudHypeIncreased = [];
    let vacated = [];
    let retirements = [];
    let fired = [];
    let unlockedChampionshipSegmentItems = [];
    let maskRemoved = [];
    let factionConsequences = [];
    let factionReputationsData = [];
    let disbanded = [];
    const feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
    const feudItem = await (0, $jDtEn.getFeudFeudItem)(feud);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(company);
    // Get trio if trio tagteam wins tag match
    if (matchType === "tag" && winner.trioTagTeam) {
        let winnerSuperstar = (await (0, $972Ip.getTagTeamSuperstars)(winner))[0];
        let winnerTrio = (await (0, $hBIDz.getSuperstarTagTeams)(winnerSuperstar)).find((x)=>x.trio);
        if (winnerTrio) winner = winnerTrio;
    }
    if (feudItem.consequence === "retirement") {
        // Get superstars to retire
        let participantsToRetire;
        if (feud.consequenceAppliedTo) {
            let consequenceAppliedTo = feudParticipants.filter((y)=>y.name === feud.consequenceAppliedTo);
            if (!(0, $3E8Nt.objectInArray)(winner, consequenceAppliedTo)) participantsToRetire = consequenceAppliedTo;
            else {
                participantsToRetire = [];
                data["careerNotEnded"] = feud.consequenceAppliedTo;
            }
        } else participantsToRetire = [
            loser
        ];
        // Get all members of tag team
        if (matchType === "tag" && participantsToRetire) participantsToRetire = (await Promise.all(participantsToRetire.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        for (const superstar of participantsToRetire)if (superstar.activeEffect !== "traded") await processRetirementConsequence(superstar);
        if (retirements.length > 0) await createRetirementFeud();
    }
    if (feudItem.consequence === "main-event-push") {
        let superstar = winner;
        let increase = superstar.popularity >= 800 ? 10 : 30;
        superstar.popularity += increase;
        data["pushed"] = superstar.name;
    }
    if (feudItem.consequence === "unavailable") {
        // Get superstars to make unavailable
        let participant;
        if (feud.consequenceAppliedTo) {
            let consequenceAppliedTo = feudParticipants.filter((y)=>y.name === feud.consequenceAppliedTo);
            if (!(0, $3E8Nt.objectInArray)(winner, consequenceAppliedTo)) participant = consequenceAppliedTo[0];
        } else participant = loser;
        if (participant) {
            // Make unavailable
            data["forcedToLeave"] = participant.name;
            data["forcedToLeaveType"] = participant.objectName;
            let unavailableMonths = (0, $3E8Nt.getRandomInt)(2, 4);
            for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(participant))){
                (0, $5kTkA.addKayfabeInjuryToSuperstar)(s, unavailableMonths);
                vacated.push(...await (0, $5kTkA.vacateChampionships)({
                    superstar: s,
                    championships: companyChampionships,
                    month: month,
                    year: year,
                    company: company,
                    checkTalentRequest: true
                }));
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "write_off",
                    talent: s
                });
            }
            // Add feud potential
            let feudParticipants = [
                winner,
                loser
            ];
            const feudItems = (await (0, $9esFv.getCompanyFeudItems)(company)).filter((x)=>x.unlocked && x.requirement === "loser-leaves");
            let feudItem = (0, $3E8Nt.getRandomChoice)(feudItems);
            let newFeud = (0, $jDtEn.Feud)();
            await (0, $14eBR.Feuds).insert(newFeud);
            newFeud.name = feudItem.name;
            newFeud.hype = feudItem.baseHype;
            if (matchType === "singles") await (0, $jDtEn.addFeudSuperstars)(newFeud, feudParticipants);
            else if (matchType === "tag") await (0, $jDtEn.addFeudTagTeams)(newFeud, feudParticipants);
            newFeud.participants = feudParticipants.map((s)=>s.name);
            newFeud.directFeudEvent = feudItem.requirement;
            newFeud.startMonth = month;
            newFeud.startYear = year;
            feudPotentials.push({
                "name": newFeud.name,
                "participants": feudParticipants.map((x)=>x.name)
            });
            await (0, $im36F.addFeudItemFeuds)(feudItem, [
                newFeud
            ]);
            await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                newFeud
            ]);
        }
    }
    if (feudItem.consequence === "fired") {
        // Remove superstar from their roster and add to indie roster
        let superstars = (await (0, $5kTkA.getRosterMemberSuperstars)(loser)).filter((x)=>x.activeEffect !== "traded");
        const overnessDecrease = (0, $3E8Nt.getRandomInt)(8, 12);
        for (const superstar of superstars){
            // Move to indies
            if (game.settings["all_indies_available"]) {
                let indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
                await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, [
                    superstar
                ]);
            } else await (0, $dl5u4.addRosterSuperstars)(indieRoster, [
                superstar
            ]);
            // Lower overness
            superstar.overness -= overnessDecrease;
            fired.push({
                "name": superstar.name,
                "pronoun": superstar.possessivePronoun,
                "overnessDecrease": overnessDecrease
            });
            // Remove teams/managers/factions
            disbanded.push(...await (0, $5kTkA.removeSuperstarTagTeams)(superstar));
            await (0, $5kTkA.removeSuperstarFactionRelationships)(superstar, month, year);
            await (0, $5kTkA.removeSuperstarManagerRelationships)(superstar);
            superstar.brandName = null;
            // Vacate championships
            vacated.push(...await (0, $5kTkA.vacateChampionships)({
                superstar: superstar,
                championships: companyChampionships,
                month: month,
                year: year
            }));
            // Delete all relationships, add former company relationship
            for (const relationship of (await (0, $hBIDz.getSuperstarRelationships)(superstar)))await (0, $14eBR.Relationships).remove(relationship);
            await (0, $8A6FL.addFormerCompanyRelationship)(superstar, company);
            // Delete talent requests
            for (const talentRequest of (await (0, $hBIDz.getSuperstarTalentRequests)(superstar)))await (0, $14eBR.TalentRequests).remove(talentRequest);
            // Make superstar happy
            (0, $5kTkA.changeSuperstarMoraleToHappy)(superstar);
            // Add news
            let newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: game.newsMonth,
                year: game.newsYear,
                superstar: superstar,
                newsType: "superstar_released_by_company"
            });
            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                newsItem
            ]);
            if (company.userControlled) {
                // Add message
                const newMessage = await (0, $hekDR.createTalentReleasedMessage)(superstar, staffMembers, month, year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            if (company.storyName === "passion") await (0, $jC7EP.processPowSuperstarLeavesCompany)(superstar, company);
        }
    }
    if (feudItem.consequence === "disband-tag-team") {
        // Get tag team
        let tagTeam;
        for (const t of (await (0, $hBIDz.getSuperstarTagTeams)(winner))){
            if (!t.temporary) {
                if ((0, $3E8Nt.checkAreObjArraysEqual)(await (0, $972Ip.getTagTeamSuperstars)(t), [
                    winner,
                    loser
                ])) tagTeam = t;
            }
        }
        if (tagTeam) {
            // Vacate championships
            const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
            const vacatedChampionships = await (0, $5kTkA.vacateChampionships)({
                superstar: tagTeamSuperstars[0],
                championships: companyChampionships,
                month: month,
                year: year,
                tagTeam: tagTeam
            });
            vacated.push(...vacatedChampionships);
            // Remove tag team
            await (0, $ko5kE.removeTagTeam)(tagTeam);
            disbanded.push(tagTeam.name);
            // Check talent request
            for (const superstar of tagTeamSuperstars){
                let requestData = {
                    "teamId": tagTeam.$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "disband_team",
                    talent: superstar,
                    data: requestData
                });
            }
        }
    }
    if (feudItem.consequence === "unify-titles") {
        const matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
        if (matchChampionships.length > 1) data["unifiedChampionships"] = await (0, $kZwpB.unifyChampionships)(matchChampionships, company, companyChampionships, game);
    }
    if (feudItem.consequence === "loser-turns-heel") {
        // Check if face lost
        const consequenceAppliedTo = feudParticipants.filter((y)=>y.name === feud.consequenceAppliedTo);
        if (consequenceAppliedTo.length > 0) {
            let participant = consequenceAppliedTo[0];
            let winnerParticipant = winner;
            if (winnerParticipant.objectName === "tagTeam" && winnerParticipant.factionTagTeam) {
                let winnerSuperstar = (await (0, $972Ip.getTagTeamSuperstars)(winnerParticipant))[0];
                winnerParticipant = (await (0, $hBIDz.getSuperstarFactions)(winnerSuperstar)).find((x)=>!x.disbanded);
            }
            if ((await (0, $5kTkA.getRosterMemberSuperstars)(participant)).every((s)=>s.alignment !== "heel")) {
                if (!(0, $3E8Nt.objectInArray)(winnerParticipant, consequenceAppliedTo)) {
                    await (0, $jpMCP.turnRosterMember)(participant, "heel", company);
                    data["turnedHeel"] = participant.name;
                } else data["didNotTurnHeel"] = participant.name;
            }
        }
    }
    if (feudItem.consequence === "winner-turns-face") {
        // Check if heel won
        let consequenceAppliedTo = feudParticipants.filter((y)=>y.name === feud.consequenceAppliedTo);
        if (consequenceAppliedTo.length > 0) {
            let participant = consequenceAppliedTo[0];
            let winnerParticipant = winner;
            if (winnerParticipant.objectName === "tagTeam" && winnerParticipant.factionTagTeam) {
                let winnerSuperstar = (await (0, $972Ip.getTagTeamSuperstars)(winnerParticipant))[0];
                winnerParticipant = (await (0, $hBIDz.getSuperstarFactions)(winnerSuperstar)).find((x)=>!x.disbanded);
            }
            if ((await (0, $5kTkA.getRosterMemberSuperstars)(participant)).every((s)=>s.alignment !== "face")) {
                if ((0, $3E8Nt.objectInArray)(winnerParticipant, consequenceAppliedTo)) {
                    await (0, $jpMCP.turnRosterMember)(participant, "face", company);
                    data["turnedFace"] = participant.name;
                } else data["didNotTurnFace"] = participant.name;
            }
        }
    }
    if (feudItem.consequence === "retirement-or-unmasking") {
        // Remove mask
        if ((0, $5kTkA.checkSuperstarGraphicMask)(loser.graphic)) {
            loser.graphic = (0, $5kTkA.removeSuperstarGraphicMask)(loser.graphic);
            maskRemoved.push(loser.name);
            // Update graphics
            if (matchGraphics) matchGraphics = (0, $3SyPM.updateMatchOrSegmentGraphics)(matchGraphics, loser);
            // Check talent request
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "change_appearance",
                talent: loser
            });
        } else {
            // Get superstars to retire
            let participantsToRetire = [
                loser
            ];
            for (const superstar of participantsToRetire)if (superstar.activeEffect !== "traded") await processRetirementConsequence(superstar);
            if (retirements.length > 0) await createRetirementFeud();
        }
    }
    if (feudItem.consequence === "disband-faction") {
        let loserSuperstar = (await (0, $972Ip.getTagTeamSuperstars)(loser))[0];
        let losingFaction = (await (0, $hBIDz.getSuperstarFactions)(loserSuperstar)).find((x)=>!x.disbanded);
        if (losingFaction) {
            await (0, $6PzHO.disbandFaction)(losingFaction, month, year);
            disbanded.push(losingFaction.name);
        }
    }
    if (feudItem.consequence === "join-faction") {
        const faction = (await (0, $hBIDz.getSuperstarFactions)(winner)).find((x)=>!x.disbanded);
        if (faction) {
            const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
            // Check if loser is not present in faction and faction has less than maximum members
            if (!(0, $3E8Nt.objectInArray)(loser, factionSuperstars) && factionSuperstars.length < (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
                // Remove loser from their faction, if any
                const losersFaction = (await (0, $hBIDz.getSuperstarFactions)(loser)).find((x)=>!x.disbanded);
                if (losersFaction) await processLeaveFaction(losersFaction, loser);
                // Update faction rep (members)
                const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                    faction: faction,
                    addedMembers: [
                        loser
                    ]
                });
                if (factionData) factionReputationsData.push(factionData);
                // Add loser to winner's faction
                await (0, $2JFAd.addFactionSuperstars)(faction, [
                    loser
                ]);
                factionConsequences.push({
                    "name": loser.name,
                    "faction": faction.name,
                    "consequence": "join_faction"
                });
                // Check join faction request
                let requestData = {
                    "factionId": faction.$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "join_faction",
                    talent: loser,
                    data: requestData
                });
            }
            if (factionSuperstars.length >= (0, $3E8Nt.gameLimits).maxFactionSuperstars) factionConsequences.push({
                "name": loser.name,
                "faction": faction.name,
                "consequence": "did_not_join_faction"
            });
        }
    }
    if (feudItem.consequence === "leave-faction") {
        const faction = (await (0, $hBIDz.getSuperstarFactions)(winner)).find((x)=>!x.disbanded);
        if (faction) await processLeaveFaction(faction, loser);
    }
    if (feudItem.consequence === "become-faction-leader") {
        const faction = (await (0, $hBIDz.getSuperstarFactions)(winner)).find((x)=>!x.disbanded);
        if (faction) {
            (0, $2JFAd.setFactionLeaderSuperstar)(faction, winner);
            factionConsequences.push({
                "name": winner.name,
                "faction": faction.name,
                "consequence": "become_faction_leader"
            });
        }
    }
    data["feudPotentials"] = feudPotentials;
    data["feudHypeIncreased"] = feudHypeIncreased;
    data["vacated"] = vacated;
    data["retirements"] = retirements;
    data["fired"] = fired;
    data["unlockedChampionshipSegmentItems"] = unlockedChampionshipSegmentItems;
    data["maskRemoved"] = maskRemoved;
    data["graphics"] = matchGraphics;
    data["factionConsequences"] = factionConsequences;
    data["factionReputationsData"] = factionReputationsData;
    data["disbanded"] = disbanded;
    async function processRetirementConsequence(superstar) {
        // Add Are You Proud feud potential between winner superstar and loser's partner
        const superstarTeams = (await (0, $hBIDz.getSuperstarTagTeams)(superstar)).filter((x)=>!x.temporary);
        if (superstarTeams.length > 0 && winner.objectName === "superstar") {
            // Get partner superstar
            let partnerSuperstar;
            for (const t of superstarTeams){
                for (const s of (await (0, $972Ip.getTagTeamSuperstars)(t)))if (!(0, $3E8Nt.objectInArray)(s, [
                    winner,
                    superstar
                ])) {
                    partnerSuperstar = s;
                    break;
                }
            }
            if (partnerSuperstar) {
                const newFeudSuperstars = [
                    winner,
                    partnerSuperstar
                ];
                const feudItems = (await (0, $9esFv.getCompanyFeudItems)(company)).filter((x)=>x.unlocked && x.requirement === "career-ended");
                const feudItem = (0, $3E8Nt.getRandomChoice)(feudItems);
                // Check for existing feud
                let existingFeud;
                for (const y of newFeudSuperstars)for (const f of (await $970022da1cbf4562$export$3c72f6cf1609909a(y))){
                    if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
                        if ((await (0, $jDtEn.getFeudParticipants)(f)).every((y)=>(0, $3E8Nt.objectInArray)(y, newFeudSuperstars))) {
                            existingFeud = f;
                            break;
                        }
                    }
                }
                if (!existingFeud) {
                    // Add feud potential
                    const newFeud = (0, $jDtEn.Feud)();
                    await (0, $14eBR.Feuds).insert(newFeud);
                    newFeud.name = feudItem.name;
                    newFeud.hype = feudItem.baseHype;
                    newFeud.participants = newFeudSuperstars.map((s)=>s.name);
                    newFeud.directFeudEvent = feudItem.requirement;
                    newFeud.startMonth = month;
                    newFeud.startYear = year;
                    feudPotentials.push({
                        "name": newFeud.name,
                        "participants": newFeudSuperstars.map((s)=>s.name)
                    });
                    await (0, $im36F.addFeudItemFeuds)(feudItem, [
                        newFeud
                    ]);
                    await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                        newFeud
                    ]);
                    await (0, $jDtEn.addFeudSuperstars)(newFeud, newFeudSuperstars);
                } else {
                    const hypeIncrease = Math.floor(feudItem.baseHype / 2);
                    existingFeud.hype += hypeIncrease;
                    feudHypeIncreased.push({
                        "name": existingFeud.name,
                        "participants": newFeudSuperstars.map((s)=>s.name),
                        "hypeIncrease": hypeIncrease,
                        "newFeud": feudItem.name
                    });
                }
            }
        }
        // Retire superstar
        const result = await (0, $5kTkA.retireSuperstar)(superstar, mainRoster, companyChampionships, month, year, company);
        retirements.push(result);
    }
    async function createRetirementFeud() {
        // Add Not Done Yet feud potential
        const feudItems = (await (0, $9esFv.getCompanyFeudItems)(company)).filter((x)=>x.unlocked && x.requirement === "retirement-feud");
        const feudItem = (0, $3E8Nt.getRandomChoice)(feudItems);
        const newFeud = (0, $jDtEn.Feud)();
        await (0, $14eBR.Feuds).insert(newFeud);
        newFeud.name = feudItem.name;
        newFeud.hype = feudItem.baseHype;
        newFeud.participants = [
            winner.name,
            loser.name
        ];
        newFeud.directFeudEvent = feudItem.requirement;
        newFeud.startMonth = month;
        newFeud.startYear = year;
        feudPotentials.push({
            "name": newFeud.name,
            "participants": [
                winner.name,
                loser.name
            ]
        });
        await (0, $im36F.addFeudItemFeuds)(feudItem, [
            newFeud
        ]);
        await (0, $dl5u4.addRosterFeuds)(mainRoster, [
            newFeud
        ]);
        await (0, $jDtEn.addFeudSuperstars)(newFeud, [
            winner,
            loser
        ]);
    }
    async function processLeaveFaction(f, s) {
        // Update faction rep (members)
        const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
            faction: f,
            removedMembers: [
                s
            ]
        });
        if (factionData) factionReputationsData.push(factionData);
        // Remove superstars from faction
        await (0, $2JFAd.removeFactionSuperstars)(f, [
            s
        ]);
        factionConsequences.push({
            "name": s.name,
            "faction": f.name,
            "consequence": "leave_faction"
        });
        // Disband faction if less than 2 superstars remain
        if ((await (0, $2JFAd.getFactionSuperstars)(f)).length < 2) {
            await (0, $6PzHO.disbandFaction)(f, month, year);
            disbanded.push(f.name);
        }
        // Check leave faction request
        let requestData = {
            "factionId": f.$loki
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "leave_faction",
            talent: s,
            data: requestData
        });
    }
    return data;
}

});
parcelRequire.register("jDtEn", function(module, exports) {

$parcel$export(module.exports, "Feud", () => $e4b8a8bf6b422f43$export$c94652786556d0dd);
$parcel$export(module.exports, "getFeudRoster", () => $e4b8a8bf6b422f43$export$2dcdf38d2d2754b1);
$parcel$export(module.exports, "getFeudFeudItem", () => $e4b8a8bf6b422f43$export$30350c3052f877e3);
$parcel$export(module.exports, "addFeudSuperstars", () => $e4b8a8bf6b422f43$export$1f3900b3a2dd7036);
$parcel$export(module.exports, "addFeudTagTeams", () => $e4b8a8bf6b422f43$export$1d8847424ec6aa79);
$parcel$export(module.exports, "addFeudFactions", () => $e4b8a8bf6b422f43$export$54a41d71860749f6);
$parcel$export(module.exports, "getFeudParticipants", () => $e4b8a8bf6b422f43$export$ebcb52586f15f026);
$parcel$export(module.exports, "getFeudMatches", () => $e4b8a8bf6b422f43$export$dcd37668fa15d5d1);
$parcel$export(module.exports, "getFeudSegments", () => $e4b8a8bf6b422f43$export$531b39e5d2e82140);

var $14eBR = parcelRequire("14eBR");
function $e4b8a8bf6b422f43$export$c94652786556d0dd() {
    // String
    const name = null;
    const description = null;
    const consequenceAppliedTo = null;
    const directFeudEvent = null;
    // Integer
    const hype = 0;
    const startMonth = null;
    const startYear = null;
    const endMonth = null;
    const endYear = null;
    // Float
    const rating = null;
    const stalenessCounter = 0;
    // Boolean
    const started = false;
    const runBlowoff = false;
    const ended = false;
    const hot = false;
    const stale = false;
    // Arrays
    const participants = [];
    // Foreign keys
    const feudItemId = null;
    const rosterId = null;
    return {
        name: name,
        description: description,
        consequenceAppliedTo: consequenceAppliedTo,
        directFeudEvent: directFeudEvent,
        hype: hype,
        startMonth: startMonth,
        startYear: startYear,
        endMonth: endMonth,
        endYear: endYear,
        rating: rating,
        stalenessCounter: stalenessCounter,
        started: started,
        runBlowoff: runBlowoff,
        ended: ended,
        hot: hot,
        stale: stale,
        participants: participants,
        feudItemId: feudItemId,
        rosterId: rosterId
    };
}
function $e4b8a8bf6b422f43$export$2dcdf38d2d2754b1(feud) {
    return (0, $14eBR.Rosters).find({
        "$loki": feud.rosterId
    })[0];
}
function $e4b8a8bf6b422f43$export$30350c3052f877e3(feud) {
    return (0, $14eBR.FeudItems).find({
        "$loki": feud.feudItemId
    })[0];
}
function $e4b8a8bf6b422f43$export$1f3900b3a2dd7036(feud, superstars) {
    let feudHashes = superstars.map((s)=>{
        return {
            feudId: feud.$loki,
            superstarId: s.$loki
        };
    });
    return (0, $14eBR.FeudParticipantsHash).insert(feudHashes);
}
async function $e4b8a8bf6b422f43$export$952ceb42f737fdae(feud) {
    const feudHashes = await (0, $14eBR.FeudParticipantsHash).find({
        "feudId": feud.$loki
    });
    const superstarIds = feudHashes.map((x)=>{
        return x.superstarId;
    });
    if (!superstarIds[0]) return;
    return (0, $14eBR.Superstars).find({
        "$loki": {
            "$in": superstarIds
        }
    });
}
function $e4b8a8bf6b422f43$export$1d8847424ec6aa79(feud, tagTeams) {
    let feudHashes = tagTeams.map((s)=>{
        return {
            feudId: feud.$loki,
            tagTeamId: s.$loki
        };
    });
    return (0, $14eBR.FeudParticipantsHash).insert(feudHashes);
}
async function $e4b8a8bf6b422f43$export$101a0f8dc584afba(feud) {
    const feudHashes = await (0, $14eBR.FeudParticipantsHash).find({
        "feudId": feud.$loki
    });
    const tagTeamIds = feudHashes.map((x)=>{
        return x.tagTeamId;
    });
    if (!tagTeamIds[0]) return;
    return (0, $14eBR.TagTeams).find({
        "$loki": {
            "$in": tagTeamIds
        }
    });
}
function $e4b8a8bf6b422f43$export$54a41d71860749f6(feud, factions) {
    let feudHashes = factions.map((s)=>{
        return {
            feudId: feud.$loki,
            factionId: s.$loki
        };
    });
    return (0, $14eBR.FeudParticipantsHash).insert(feudHashes);
}
async function $e4b8a8bf6b422f43$export$7dceb064dab251ed(feud) {
    const feudHashes = await (0, $14eBR.FeudParticipantsHash).find({
        "feudId": feud.$loki
    });
    const factionIds = feudHashes.map((x)=>{
        return x.factionId;
    });
    if (!factionIds[0]) return;
    return (0, $14eBR.Factions).find({
        "$loki": {
            "$in": factionIds
        }
    });
}
async function $e4b8a8bf6b422f43$export$ebcb52586f15f026(feud) {
    const feudSuperstars = await $e4b8a8bf6b422f43$export$952ceb42f737fdae(feud);
    if (feudSuperstars) return feudSuperstars;
    const feudTagTeams = await $e4b8a8bf6b422f43$export$101a0f8dc584afba(feud);
    if (feudTagTeams) return feudTagTeams;
    const feudFactions = await $e4b8a8bf6b422f43$export$7dceb064dab251ed(feud);
    if (feudFactions) return feudFactions;
    return [];
}
async function $e4b8a8bf6b422f43$export$dcd37668fa15d5d1(feud) {
    const feudHashes = await (0, $14eBR.FeudMatchesHash).find({
        "feudId": feud.$loki
    });
    const matchIds = feudHashes.map((x)=>{
        return x.matchId;
    });
    return (0, $14eBR.Matches).find({
        "$loki": {
            "$in": matchIds
        }
    });
}
async function $e4b8a8bf6b422f43$export$531b39e5d2e82140(feud) {
    const feudHashes = await (0, $14eBR.FeudSegmentsHash).find({
        "feudId": feud.$loki
    });
    const segmentIds = feudHashes.map((x)=>{
        return x.segmentId;
    });
    return (0, $14eBR.Segments).find({
        "$loki": {
            "$in": segmentIds
        }
    });
}

});

parcelRequire.register("jpMCP", function(module, exports) {

$parcel$export(module.exports, "getAvailableCallupsData", () => $e22612169abb8ad8$export$c50c322c536d5be5);
$parcel$export(module.exports, "transferTalentToRoster", () => $e22612169abb8ad8$export$979c864c88dfdeb2);
$parcel$export(module.exports, "callupAvailableTrainingTalent", () => $e22612169abb8ad8$export$ed3352db781e858);
$parcel$export(module.exports, "callupTalentToMainRoster", () => $e22612169abb8ad8$export$484bdc66b6811c64);
$parcel$export(module.exports, "getViewRosterData", () => $e22612169abb8ad8$export$43c6216e281f8bf6);
$parcel$export(module.exports, "getViewRosterMemberData", () => $e22612169abb8ad8$export$79fff64be13226f4);
$parcel$export(module.exports, "getViewIndiesData", () => $e22612169abb8ad8$export$5418e43d6f4857fe);
$parcel$export(module.exports, "getViewTeamsData", () => $e22612169abb8ad8$export$54bbf589c235e825);
$parcel$export(module.exports, "getRosterActiveTagTeams", () => $e22612169abb8ad8$export$b34c0a3628418a1a);
$parcel$export(module.exports, "getViewManagersData", () => $e22612169abb8ad8$export$15a3545e49efab33);
$parcel$export(module.exports, "getAddTeamData", () => $e22612169abb8ad8$export$45c03faa5e3830f5);
$parcel$export(module.exports, "addTeam", () => $e22612169abb8ad8$export$e44b0fb90766dd97);
$parcel$export(module.exports, "getRosterMemberNameData", () => $e22612169abb8ad8$export$c1eec92d42efa941);
$parcel$export(module.exports, "getRosterMemberPronounData", () => $e22612169abb8ad8$export$ada9aeeec3341de8);
$parcel$export(module.exports, "getRosterMemberGimmickData", () => $e22612169abb8ad8$export$a896b1d8cf87f7);
$parcel$export(module.exports, "checkCharacterUsage", () => $e22612169abb8ad8$export$5f6c6fb672a09041);
$parcel$export(module.exports, "getRosterMemberAlignmentData", () => $e22612169abb8ad8$export$d84b78a0d634d60b);
$parcel$export(module.exports, "getRosterMemberBrandData", () => $e22612169abb8ad8$export$a9b5722f3c85591);
$parcel$export(module.exports, "changeRosterMemberName", () => $e22612169abb8ad8$export$1233b9decaf94f98);
$parcel$export(module.exports, "changeRosterMemberPronoun", () => $e22612169abb8ad8$export$62061aba88e9a767);
$parcel$export(module.exports, "changeRosterMemberAlignment", () => $e22612169abb8ad8$export$21834ec588f2cb0f);
$parcel$export(module.exports, "turnRosterMember", () => $e22612169abb8ad8$export$96e8a2b5a0ab13e4);
$parcel$export(module.exports, "changeRosterMemberBrand", () => $e22612169abb8ad8$export$7f7f9f5238fb4903);
$parcel$export(module.exports, "changeSuperstarGraphic", () => $e22612169abb8ad8$export$b175b43d640b17d);
$parcel$export(module.exports, "addSuperstarGimmick", () => $e22612169abb8ad8$export$a92e8ea5b2ad5be9);
$parcel$export(module.exports, "createGimmick", () => $e22612169abb8ad8$export$311c74177e40d92a);
$parcel$export(module.exports, "getGimmickCreationBonus", () => $e22612169abb8ad8$export$61b8cdb30db661e1);
$parcel$export(module.exports, "removeSuperstarGimmick", () => $e22612169abb8ad8$export$28ce9a1f1d597b95);
$parcel$export(module.exports, "addSuperstar", () => $e22612169abb8ad8$export$60f8f2ba37043bfd);
$parcel$export(module.exports, "releaseTalent", () => $e22612169abb8ad8$export$89e44fbfb71050e5);
$parcel$export(module.exports, "getPartTimerAppearances", () => $e22612169abb8ad8$export$87e7b14799f29ae0);
$parcel$export(module.exports, "disbandTagTeam", () => $e22612169abb8ad8$export$6c34b2ae9ca603b2);
$parcel$export(module.exports, "getBookingData", () => $e22612169abb8ad8$export$207e8b5f0d8ae19e);
$parcel$export(module.exports, "getBookingSelectionInformation", () => $e22612169abb8ad8$export$d3456f6cceb4e1fc);

var $98xmD = parcelRequire("98xmD");

var $8A6FL = parcelRequire("8A6FL");

var $9esFv = parcelRequire("9esFv");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $14eBR = parcelRequire("14eBR");

var $dl5u4 = parcelRequire("dl5u4");

var $972Ip = parcelRequire("972Ip");

var $5kTkA = parcelRequire("5kTkA");

var $ko5kE = parcelRequire("ko5kE");

var $hBIDz = parcelRequire("hBIDz");

var $kZwpB = parcelRequire("kZwpB");

var $ivuOU = parcelRequire("ivuOU");

var $ycsyu = parcelRequire("ycsyu");

var $1AAHK = parcelRequire("1AAHK");

var $6PzHO = parcelRequire("6PzHO");

var $4K85d = parcelRequire("4K85d");

var $dBFC4 = parcelRequire("dBFC4");

var $9MKdC = parcelRequire("9MKdC");

var $1JSre = parcelRequire("1JSre");

var $jDtEn = parcelRequire("jDtEn");

var $i7bmn = parcelRequire("i7bmn");

var $6RCLU = parcelRequire("6RCLU");

var $lhVvD = parcelRequire("lhVvD");

var $cXLSF = parcelRequire("cXLSF");

var $aP7lq = parcelRequire("aP7lq");

var $1Dp0h = parcelRequire("1Dp0h");

var $fuJHb = parcelRequire("fuJHb");

var $5IqxM = parcelRequire("5IqxM");

var $i6OYC = parcelRequire("i6OYC");

var $iQtzn = parcelRequire("iQtzn");

var $eg5dz = parcelRequire("eg5dz");

var $im36F = parcelRequire("im36F");

var $2JFAd = parcelRequire("2JFAd");

var $kZMqI = parcelRequire("kZMqI");

var $1olyO = parcelRequire("1olyO");

var $bZol7 = parcelRequire("bZol7");

var $4EOBX = parcelRequire("4EOBX");

var $3MfBd = parcelRequire("3MfBd");
async function $e22612169abb8ad8$export$c50c322c536d5be5() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyRosters = await (0, $9esFv.getCompanyRosters)(userCompany);
    // Get training and training available rosters
    const trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "training", companyRosters);
    const trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "trainingAvailable", companyRosters);
    // Transfer training superstar to available training roster if not already done
    if (!userCompany.trainingTransferRun) {
        const talentToTransfer = (0, $3E8Nt.getRandomChoice)(await (0, $dl5u4.getRosterSuperstars)(trainingRoster));
        if (talentToTransfer) await $e22612169abb8ad8$export$979c864c88dfdeb2(talentToTransfer, trainingAvailableRoster);
        userCompany.trainingTransferRun = true;
        (0, $14eBR.db).saveDatabase();
    }
    // Get simplified data for training available roster
    return $e22612169abb8ad8$var$getRosterDataSimplified(trainingAvailableRoster);
}
async function $e22612169abb8ad8$var$getRosterDataSimplified(roster, company = null, getInterestedRelationships = false) {
    let data = [];
    // Get roster superstars, teams and superstars in teams
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(roster);
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(roster);
    let superstarsInTeams = (await Promise.all(rosterTagTeams.map((x)=>{
        return (0, $972Ip.getTagTeamSuperstars)(x);
    }))).flat();
    // Get dict of managed superstars and managers
    let managedSuperstarsDict = {};
    let managersDict = {};
    for (const s of rosterSuperstars)if (s.managerId) {
        if (managedSuperstarsDict[s.managerId]) managedSuperstarsDict[s.managerId].push(s);
        else managedSuperstarsDict[s.managerId] = [
            s
        ];
    }
    for (const s of rosterSuperstars){
        const managedSuperstars = managedSuperstarsDict[s.$loki] || [];
        for (const x of managedSuperstars)managersDict[x.$loki] = s;
    }
    // Get superstars and teams data
    for (const superstar of rosterSuperstars){
        if (superstarsInTeams.map((x)=>x.$loki).indexOf(superstar.$loki) >= 0) continue;
        let managedSuperstars = managedSuperstarsDict[superstar.$loki] || [];
        let manager = managersDict[superstar.$loki] || null;
        let superstarData = await (0, $5kTkA.getSuperstarDisplayData)({
            superstar: superstar,
            includeChampionships: false,
            rosterSuperstars: rosterSuperstars,
            managedSuperstars: managedSuperstars,
            manager: manager
        });
        superstarData["uid"] = superstar.$loki;
        superstarData["type"] = "superstar";
        if (getInterestedRelationships) {
            // Get interested relationship
            const interestedRelationship = (await (0, $hBIDz.getSuperstarRelationships)(superstar)).find((x)=>x.interested && company && x.companyId === company.$loki);
            if (interestedRelationship) superstarData["interested"] = true;
        }
        data.push(superstarData);
    }
    for (const tagTeam of rosterTagTeams){
        let teamData = await (0, $ko5kE.getTagTeamDisplayData)({
            tagTeam: tagTeam,
            rosterSuperstars: rosterSuperstars
        });
        teamData["uid"] = tagTeam.$loki;
        teamData["type"] = "tagTeam";
        if (getInterestedRelationships) {
            // Get interested relationship
            const interestedRelationships = [];
            const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
            for (const s of tagTeamSuperstars){
                const interestedRelationship = (await (0, $hBIDz.getSuperstarRelationships)(s)).find((x)=>x.interested && company && x.companyId === company.$loki);
                if (interestedRelationship) interestedRelationships.push(interestedRelationship);
            }
            if (interestedRelationships.length === tagTeamSuperstars.length) teamData["interested"] = true;
        }
        data.push(teamData);
    }
    return data;
}
async function $e22612169abb8ad8$export$ed3352db781e858(talentUid, talentType) {
    // Performs callup from available training roster (when user is presented option to callup talent in specific months)
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get main roster
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    // Check if callup already run
    if (userCompany.trainingCallupRun) {
        data["error"] = "callup-already-run";
        return data;
    }
    // Get talent
    const talent = await $e22612169abb8ad8$var$getTalentByIdAndType(parseInt(talentUid), talentType);
    // Check if talent found
    if (!talent) {
        data["error"] = "talent-not-found";
        return data;
    }
    // Callup talent to main roster
    const overnessIncrease = await $e22612169abb8ad8$export$484bdc66b6811c64(talent, mainRoster, userCompany, currentGame);
    // Increase morale for talent superstars
    const talentSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
    await Promise.all(talentSuperstars.map((x)=>{
        (0, $5kTkA.updateSuperstarMorale)(x, (0, $3E8Nt.getRandomInt)(20, 25));
    }));
    // Get data
    data["overnessIncrease"] = overnessIncrease;
    data["name"] = talent.name;
    data["pronoun"] = talent.possessivePronoun;
    // Change trainingCallupRun to true
    userCompany.trainingCallupRun = true;
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $e22612169abb8ad8$var$getTalentByIdAndType(talentId, talentType) {
    let talent;
    if (talentType === "superstar") talent = await (0, $14eBR.Superstars).get(talentId);
    else if (talentType === "tagTeam") talent = await (0, $14eBR.TagTeams).get(talentId);
    return talent;
}
async function $e22612169abb8ad8$export$484bdc66b6811c64(talent, mainRoster, company, game) {
    // Get random value for overness increase
    const overnessIncrease = (0, $3E8Nt.getRandomInt)(6, 8);
    // Transfer talent
    let transferredSuperstars = await $e22612169abb8ad8$export$979c864c88dfdeb2(talent, mainRoster);
    // Process transferred superstars
    for (const transferredSuperstar of transferredSuperstars){
        // Reset active effect
        transferredSuperstar.activeEffect = null;
        // Increase overness
        transferredSuperstar.overness += overnessIncrease;
        transferredSuperstar.overness = (0, $3E8Nt.limitValueBetweenRange)(transferredSuperstar.overness, 0, 100);
        // Remove from factions and managers
        await (0, $5kTkA.removeSuperstarFactionRelationships)(transferredSuperstar, game.monthCount, game.year);
        await (0, $5kTkA.removeSuperstarManagerRelationships)(transferredSuperstar);
    }
    // Add company log
    const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
    await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
    newCompanyLog.text = talent.name;
    newCompanyLog.type = "callup";
    newCompanyLog.realYear = game.year;
    await (0, $9esFv.addCompanyCompanyLogs)(company, [
        newCompanyLog
    ]);
    return overnessIncrease;
}
async function $e22612169abb8ad8$export$979c864c88dfdeb2(talent, roster, transferTeams = true) {
    // Transfers superstars or tag teams to roster. If superstar, finds tag teams and transfers them and their
    // superstars too.
    let transferredSuperstars = [];
    // Transfer superstar
    if (talent.objectName === "superstar") {
        // Find superstar's tag teams if transferTeams is true
        let superstarTagTeams = transferTeams ? (await (0, $hBIDz.getSuperstarTagTeams)(talent)).filter((x)=>!x.temporary) : [];
        // If tag teams present, transfer them
        if (superstarTagTeams.length > 0) for (const tagTeam of superstarTagTeams){
            const t = await $e22612169abb8ad8$var$transferTagTeamToRoster(tagTeam, roster);
            transferredSuperstars = transferredSuperstars.concat(t);
        }
        else {
            await (0, $dl5u4.addRosterSuperstars)(roster, [
                talent
            ]);
            transferredSuperstars.push(talent);
        }
    } else if (talent.objectName === "tagTeam") {
        const t = await $e22612169abb8ad8$var$transferTagTeamToRoster(talent, roster);
        transferredSuperstars = transferredSuperstars.concat(t);
    }
    return transferredSuperstars;
}
async function $e22612169abb8ad8$var$transferTagTeamToRoster(tagTeam, roster) {
    // Transfer tagTeam and its superstars
    await (0, $dl5u4.addRosterTagTeams)(roster, [
        tagTeam
    ]);
    const tagTeamSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(tagTeam);
    await (0, $dl5u4.addRosterSuperstars)(roster, tagTeamSuperstars);
    return tagTeamSuperstars;
}
async function $e22612169abb8ad8$export$43c6216e281f8bf6(companyUid) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get main roster superstars
    const companyRosters = await (0, $9esFv.getCompanyRosters)(selectedCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main", companyRosters);
    const mainRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const activeMainRosterSuperstars = mainRosterSuperstars.filter((x)=>!(x.retired && !x.fullTimeManager) && !x.dead);
    // Get data for superstars, tag teams and championships
    let data = await $e22612169abb8ad8$var$getViewRosterSuperstarsData(companyRosters, selectedCompany, mainRosterSuperstars, activeMainRosterSuperstars);
    data["tagTeams"] = await $e22612169abb8ad8$var$getViewRosterTagTeamsData(mainRoster);
    data["championships"] = await $e22612169abb8ad8$var$getViewRosterChampionshipsData(selectedCompany, mainRosterSuperstars, currentGame);
    // Get roster size and capacity
    data["rosterSize"] = activeMainRosterSuperstars.length;
    data["rosterCapacity"] = (0, $8A6FL.getCompanyRosterCapacity)(selectedCompany, currentGame);
    // Get brand names
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    data["brandNames"] = rosterBrands.map((x)=>x.name);
    return data;
}
async function $e22612169abb8ad8$var$getViewRosterSuperstarsData(companyRosters, selectedCompany, mainRosterSuperstars, activeMainRosterSuperstars) {
    // Define data
    let data = {};
    data["superstars"] = [];
    data["managers"] = [];
    data["trainingSuperstars"] = [];
    data["retiredSuperstars"] = [];
    data["deadSuperstars"] = [];
    // Get doctor
    const staffMembers = await (0, $9esFv.getCompanyStaff)(selectedCompany);
    const doctor = (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "doctor");
    // Get training rosters
    const trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "training", companyRosters);
    const trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "trainingAvailable", companyRosters);
    const trainingFutureRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "trainingFuture", companyRosters);
    // Get training and training future superstars
    let trainingRostersSuperstars = trainingRoster ? await (0, $dl5u4.getRosterSuperstars)(trainingRoster) : [];
    if (trainingAvailableRoster) trainingRostersSuperstars = trainingRostersSuperstars.concat(await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster));
    const trainingFutureRosterSuperstars = trainingFutureRoster ? await (0, $dl5u4.getRosterSuperstars)(trainingFutureRoster) : [];
    // Get active training roster superstars
    let activeTrainingRosterSuperstars = trainingRostersSuperstars.filter((x)=>!(x.retired && !x.fullTimeManager) && !x.dead);
    // Get retired and dead superstars (main and training roster)
    const mainAndTrainingRosterSuperstars = mainRosterSuperstars.concat(trainingRostersSuperstars);
    let deadSuperstars = mainAndTrainingRosterSuperstars.filter((x)=>x.dead);
    let retiredSuperstars = mainAndTrainingRosterSuperstars.filter((x)=>x.retired && !x.fullTimeManager && !x.dead);
    // Get data for superstars, sorted by most popular
    for (const superstar of activeMainRosterSuperstars.concat(activeTrainingRosterSuperstars, trainingFutureRosterSuperstars, retiredSuperstars, deadSuperstars).sort((a, b)=>b.popularity - a.popularity)){
        let superstarData = {};
        superstarData["name"] = superstar.name;
        superstarData["uid"] = superstar.$loki;
        // Main roster
        if (activeMainRosterSuperstars.includes(superstar)) {
            superstarData["rank"] = (0, $5kTkA.getRankFromPopularity)(superstar.popularity);
            superstarData["pronoun"] = superstar.pronoun;
            superstarData["alignment"] = superstar.alignment;
            superstarData["brandName"] = superstar.brandName;
            superstarData["faceOfTheCompany"] = superstar.faceOfTheCompany;
            superstarData["faceOfTheCompanyCounter"] = superstar.faceOfTheCompanyCounter;
            superstarData["suspensionMonths"] = superstar.suspensionMonths;
            superstarData["unhappy"] = superstar.unhappy;
            if (superstar.partTimer && !superstar.fullTimeManager) superstarData["appearances"] = superstar.appearances;
            if (superstar.injured > 0) {
                superstarData["injured"] = superstar.injured;
                superstarData["injuryName"] = superstar.injuryName;
                superstarData["injuryTime"] = (0, $5kTkA.getInjuryReturnTime)(superstar, doctor);
                superstarData["workableInjury"] = superstar.workableInjury;
            }
            if (superstar.fullTimeManager) data["managers"].push(superstarData);
            else data["superstars"].push(superstarData);
        } else if (activeTrainingRosterSuperstars.includes(superstar)) {
            superstarData["future"] = false;
            data["trainingSuperstars"].push(superstarData);
        } else if (trainingFutureRosterSuperstars.includes(superstar)) {
            if (superstar.monthToAppearIn) {
                superstarData["name"] = "???";
                superstarData["future"] = true;
                superstarData["uid"] = null;
                superstarData["yearToAppearIn"] = Math.ceil(superstar.monthToAppearIn / 12);
                data["trainingSuperstars"].push(superstarData);
            }
        } else if (retiredSuperstars.includes(superstar)) {
            superstarData["hallOfFamer"] = superstar.hallOfFamer;
            superstarData["inTrainingRoster"] = trainingRostersSuperstars.includes(superstar);
            data["retiredSuperstars"].push(superstarData);
        } else if (deadSuperstars.includes(superstar)) data["deadSuperstars"].push(superstarData);
    }
    return data;
}
async function $e22612169abb8ad8$var$getViewRosterTagTeamsData(mainRoster) {
    let data = [];
    // Get roster tag teams
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
    // Get data for tag teams
    for (const tagTeam of rosterTagTeams){
        const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
        // Skip if no superstars or temporary team
        if (tagTeamSuperstars.length <= 0) {
            await (0, $ko5kE.removeTagTeam)(tagTeam);
            (0, $14eBR.db).saveDatabase();
            continue;
        }
        if (tagTeam.temporary) continue;
        let tagTeamData = {};
        tagTeamData["name"] = tagTeam.name;
        tagTeamData["uid"] = tagTeam.$loki;
        tagTeamData["trio"] = tagTeam.trio;
        tagTeamData["popularity"] = await (0, $ko5kE.getTagTeamPopularity)(tagTeam, tagTeamSuperstars);
        tagTeamData["superstars"] = tagTeamSuperstars.map((x)=>x.name);
        data.push(tagTeamData);
    }
    // Sort tag teams by most popular
    data.sort((a, b)=>b.popularity - a.popularity);
    return data;
}
async function $e22612169abb8ad8$var$getViewRosterChampionshipsData(selectedCompany, mainRosterSuperstars, currentGame) {
    let data = [];
    // Get all championships, including competitors'
    const activeCompanies = await (0, $iRMwH.getGameActiveCompanies)(currentGame);
    let allChampionships = (await Promise.all(activeCompanies.map((x)=>{
        return (0, $9esFv.getCompanyChampionships)(x);
    }))).flat();
    // Filter out tag titles without match contracts
    allChampionships = await $e22612169abb8ad8$var$filterTagChampionshipsWithoutMatchContracts(allChampionships);
    // Get unique championships
    const uniqueChampionships = (0, $kZwpB.getUniqueChampionships)(allChampionships);
    // Get company's championships and championships with champion in company's roster
    const mainRosterSuperstarIds = mainRosterSuperstars.map((x)=>x.$loki);
    let foundChampionships = [];
    for await (const c of uniqueChampionships){
        const championshipCompany = await (0, $ivuOU.getChampionshipCompany)(c);
        const championshipSuperstar = await (0, $ivuOU.getChampionshipSuperstar)(c);
        if (championshipCompany.$loki === selectedCompany.$loki || championshipSuperstar && mainRosterSuperstarIds.indexOf(championshipSuperstar.$loki) >= 0) foundChampionships.push(c);
    }
    // Sort championships
    foundChampionships.sort((0, $kZwpB.compareChampionships));
    // Get data for championships
    for (const championship of foundChampionships){
        let championshipData = {};
        championshipData["name"] = championship.name;
        championshipData["brandName"] = championship.brandName;
        championshipData["tagTeam"] = championship.tagTeam;
        championshipData["trio"] = championship.trio;
        championshipData["prestige"] = championship.prestige;
        // Get champion data
        let champion = await (0, $kZwpB.getChampionshipHolder)(championship, false);
        if (champion) {
            championshipData["championName"] = champion.name;
            championshipData["championUid"] = champion.$loki;
        }
        // Get event if match contract present
        if (championship.matchContract) {
            const championshipMatchContract = await (0, $ivuOU.getChampionshipMatchContract)(championship);
            if (championshipMatchContract) {
                championshipData["event"] = (await (0, $1AAHK.getMatchContractEvent)(championshipMatchContract))?.name;
                championshipData["matchContract"] = true;
            }
        }
        data.push(championshipData);
    }
    return data;
}
async function $e22612169abb8ad8$var$filterTagChampionshipsWithoutMatchContracts(championships) {
    const filteredChampionships = [];
    for (const championship of championships)if ((championship.tagTeam || championship.trio) && championship.matchContract) {
        const championshipMatchContracts = await (0, $ivuOU.getChampionshipMatchContracts)(championship);
        if (championshipMatchContracts.length > 0) filteredChampionships.push(championship);
    } else filteredChampionships.push(championship);
    return filteredChampionships;
}
async function $e22612169abb8ad8$export$79fff64be13226f4({ uid: uid, type: type, companyUid: companyUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = userCompany;
    // Get staff
    const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const scout = (0, $8A6FL.getHighestLevelStaffMemberByRole)(companyStaffMembers, "scout");
    const doctor = (0, $8A6FL.getHighestLevelStaffMemberByRole)(companyStaffMembers, "doctor");
    // Get roster member data
    let talent;
    let trainingTalent = false;
    const mainRosterSuperstars = await (0, $8A6FL.getCompanyMainRosterSuperstars)(selectedCompany);
    if (type === "superstar" || type === "training-superstar") {
        talent = await (0, $14eBR.Superstars).get(uid);
        data = await (0, $5kTkA.getSuperstarDisplayData)({
            superstar: talent,
            rosterSuperstars: mainRosterSuperstars,
            getTeamsAndFactions: true,
            getTournamentsWon: true,
            doctor: doctor
        });
        // Check if superstar in available training roster
        const talentRoster = await (0, $hBIDz.getSuperstarRoster)(talent);
        if (talentRoster.type === "trainingAvailable") data["available"] = true;
        if ([
            "training",
            "trainingAvailable"
        ].indexOf(talentRoster.type) >= 0) trainingTalent = true;
    } else if (type === "tagTeam") {
        talent = await (0, $14eBR.TagTeams).get(uid);
        data = await (0, $ko5kE.getTagTeamDisplayData)({
            tagTeam: talent,
            rosterSuperstars: mainRosterSuperstars,
            getTournamentsWon: true
        });
    } else if (type === "faction") {
        talent = await (0, $14eBR.Factions).get(uid);
        data = await (0, $6PzHO.getFactionData)(talent, await (0, $9esFv.getCompanyChampionships)(selectedCompany));
    }
    // Get other data to return
    data["competitorTalent"] = !!companyUid;
    data["type"] = type;
    if (trainingTalent) data["type"] = "training-superstar";
    data["scoutLevel"] = scout ? scout.level : 1;
    // Get talent stats for main roster superstars if JoW Paid or tutorial
    const tutorialStatsState = userCompany.storyName === "tutorial" && await (0, $8A6FL.getTutorialStateName)(userCompany) === "view_superstar_details";
    if (((0, $98xmD.globalUser).paid || tutorialStatsState) && [
        "superstar",
        "tagTeam"
    ].indexOf(type) >= 0 && (!data["competitorTalent"] || data["scoutLevel"] >= 3)) {
        const startingEvents = (0, $14eBR.Events).chain().limit(13).data();
        const firstEvent = startingEvents[startingEvents.length - 1];
        const startingMonth = await (0, $8A6FL.getCompanyStartingMonth)(startingEvents);
        const allCompanies = await (0, $dBFC4.getGameCompanies)(currentGame);
        const companyLogs = (await Promise.all(allCompanies.map((x)=>(0, $9esFv.getCompanyCompanyLogs)(x)))).flat();
        const yearlyRankings = type === "superstar" ? await (0, $dBFC4.getGameYearlyRankings)(currentGame) : [];
        data["stats"] = await $e22612169abb8ad8$var$getTalentStats(talent, startingMonth, firstEvent.year, companyLogs, yearlyRankings);
    }
    // Check tutorial action
    if (userCompany.storyName === "tutorial") {
        data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(userCompany, [
            "view_superstar_details",
            "view_indies"
        ]);
        (0, $14eBR.db).saveDatabase();
    }
    return data;
}
async function $e22612169abb8ad8$var$getTalentStats(talent, startingMonth, startingYear, companyLogs, yearlyRankings) {
    let data = {};
    // Get talent matches and reigns
    const talentNames = [
        talent.name
    ];
    let talentMatches;
    let talentReigns = [];
    if (talent.objectName === "superstar") {
        talentMatches = await (0, $hBIDz.getSuperstarMatches)(talent);
        for (const tagTeam of (await (0, $hBIDz.getSuperstarTagTeams)(talent))){
            talentMatches.push(...await (0, $972Ip.getTagTeamMatches)(tagTeam));
            talentNames.push(tagTeam.name);
        }
        const superstarReigns = await (0, $hBIDz.getSuperstarChampionshipReigns)(talent);
        for (const superstarReign of superstarReigns){
            const c = await (0, $9MKdC.getChampionshipReignChampionship)(superstarReign);
            if (c) talentReigns.push(superstarReign);
        }
    } else {
        talentMatches = await (0, $972Ip.getTagTeamMatches)(talent);
        const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(talent);
        const superstarReigns = await (0, $hBIDz.getSuperstarChampionshipReigns)(tagTeamSuperstars[0]);
        const superstarTagReigns = [];
        for (const superstarReign of superstarReigns){
            const c = await (0, $9MKdC.getChampionshipReignChampionship)(superstarReign);
            if (c && (c.tagTeam || c.trio)) superstarTagReigns.push(superstarReign);
        }
        for (const superstarTagReign of superstarTagReigns){
            // Check if specific number of members of team have this championship reign
            const c = await (0, $9MKdC.getChampionshipReignChampionship)(superstarTagReign);
            const numberOfTitles = c.tagTeam ? 2 : 3;
            const sameReignMembers = [];
            for (const s of tagTeamSuperstars){
                const r = await (0, $hBIDz.getSuperstarChampionshipReigns)(s);
                if (await $e22612169abb8ad8$var$checkIfReignPresentInReigns(superstarTagReign, r)) sameReignMembers.push(s);
            }
            if (sameReignMembers.length === numberOfTitles) talentReigns.push(superstarTagReign);
        }
    }
    // Filter out matches not held
    talentMatches = talentMatches.filter((x)=>x.winner !== null);
    // Wins/losses
    data["wins"] = talent.wins;
    data["losses"] = talent.losses;
    const totalMatches = talent.wins + talent.losses;
    data["winPercentage"] = null;
    if (totalMatches > 0) data["winPercentage"] = Math.round(talent.wins / totalMatches * 100);
    // Winning/losing streaks
    data["winningStreak"] = talent.winsCounter;
    data["losingStreak"] = talent.lossesCounter;
    // Current feuds
    data["currentFeuds"] = [];
    const talentFeuds = (await (0, $cXLSF.getRosterMemberFeuds)(talent)).reverse();
    const feuds = [
        ...talentFeuds
    ].filter((x)=>x.started && !x.ended);
    for (const feud of feuds){
        const otherParticipants = (await (0, $jDtEn.getFeudParticipants)(feud)).filter((x)=>x.$loki !== talent.$loki);
        data["currentFeuds"].push({
            "opponents": otherParticipants.map((x)=>x.name),
            "hype": feud.hype,
            "name": feud.name
        });
    }
    // Biggest rival
    const pastFeuds = [
        ...talentFeuds
    ].filter((x)=>x.started && x.ended);
    if (pastFeuds.length > 0) {
        const topFeud = (0, $3E8Nt.getArrayMaxByProperty)(pastFeuds, "hype");
        const topFeudParticipants = await (0, $jDtEn.getFeudParticipants)(topFeud);
        const biggestRival = topFeudParticipants.find((x)=>x.$loki !== talent.$loki);
        if (biggestRival) data["biggestRival"] = biggestRival.name;
    }
    // Past 5 matches and record
    data["recentMatches"] = [];
    const talentMatchesEvents = (0, $14eBR.Events).find({
        "$loki": {
            "$in": talentMatches.map((x)=>x.eventId)
        }
    });
    const recentMatches = [
        ...talentMatches
    ].sort((a, b)=>{
        let aEvent = talentMatchesEvents.find((x)=>x.$loki === a.eventId);
        let bEvent = talentMatchesEvents.find((x)=>x.$loki === b.eventId);
        // .year sorting fixes imported games bug where competitor eventIds were higher than company
        return bEvent.year - aEvent.year || bEvent.month - aEvent.month || Number(aEvent.name === "Weekly Show") - Number(bEvent.name === "Weekly Show") || b.eventId - a.eventId || a.order - b.order;
    }).slice(0, 5);
    for (const match of recentMatches){
        const otherParticipants = (await (0, $i7bmn.getMatchParticipants)(match)).filter((x)=>talentNames.indexOf(x.name) < 0);
        data["recentMatches"].push({
            "opponents": otherParticipants.map((x)=>x.name),
            "event": await (0, $6RCLU.getMatchEventTitle)(match),
            "win": talentNames.indexOf(match.winner) >= 0,
            "rating": match.rating
        });
    }
    if (talentMatches.length > 0) {
        // Greatest match
        const sortedMatches = [
            ...talentMatches
        ].sort((a, b)=>b.rating - a.rating || b.eventId - a.eventId);
        const greatestMatch = sortedMatches[0];
        const otherParticipants = (await (0, $i7bmn.getMatchParticipants)(greatestMatch)).filter((x)=>talentNames.indexOf(x.name) < 0);
        data["greatestMatch"] = {
            "opponents": otherParticipants.map((x)=>x.name),
            "event": await (0, $6RCLU.getMatchEventTitle)(greatestMatch),
            "win": talentNames.indexOf(greatestMatch.winner) >= 0,
            "rating": greatestMatch.rating
        };
        // Average match rating
        data["averageMatchRating"] = (0, $3E8Nt.myround)(talentMatches.filter((x)=>x.rating).map((y)=>y.rating).reduce((partialSum, a)=>partialSum + a, 0) / talentMatches.length, 0.01).toFixed(2);
    }
    // Streaks
    data["eventStreaks"] = [];
    for (const streak of (await (0, $3E8Nt.getRosterMemberStreaks)(talent)))if (streak.length >= 2 && !streak.ended) data["eventStreaks"].push({
        "event": (await (0, $lhVvD.getStreakEvent)(streak))?.name,
        "length": streak.length
    });
    // Awards and annual tournaments won
    data["awardsWon"] = [];
    for (const tournamentWon of (await (0, $3E8Nt.getRosterMemberWonTournaments)(talent)))if (tournamentWon.annualTournament) data["awardsWon"].push({
        "name": tournamentWon.name,
        "award": 3
    });
    for (const companyLog of companyLogs.reverse()){
        const isTGILog = companyLog.text.split(" ").slice(0, 3).join(" ") === "The Grand Invitational";
        if (companyLog.type === "award" && (0, $3E8Nt.findNameInString)(talent.name, companyLog.text) && !isTGILog) data["awardsWon"].push({
            "name": companyLog.text,
            "award": companyLog.value
        });
    }
    // Yearly rankings history if in top 10
    data["yearlyRankingsHistory"] = [];
    for (const yearlyRanking of yearlyRankings){
        const top10Ranking = yearlyRanking.data?.slice(0, 10).find((x)=>x.name === talent.name);
        if (top10Ranking) data["yearlyRankingsHistory"].push({
            "rank": yearlyRanking.data.indexOf(top10Ranking) + 1,
            "year": yearlyRanking.year
        });
    }
    data["yearlyRankingsHistory"].sort((a, b)=>b.year - a.year);
    // Championship reigns in chronological order
    data["championshipReigns"] = [];
    talentReigns.sort((a, b)=>(b.endMonth === null) - (a.endMonth === null) || b.startMonth + b.startYear * 12 - (a.startMonth + a.startYear * 12));
    for (const reign of talentReigns){
        const startDate = (0, $3E8Nt.getRealDate)(reign.startMonth, reign.startYear, startingMonth, startingYear);
        let endDate = null;
        if (reign.endMonth !== null) endDate = (0, $3E8Nt.getRealDate)(reign.endMonth, reign.endYear, startingMonth, startingYear);
        // Get number of defenses
        let numberOfDefenses;
        let matches = (await (0, $9MKdC.getChampionshipReignMatches)(reign)).reverse();
        if (matches.length > 0 && matches[matches.length - 1].championshipsWon) numberOfDefenses = matches.length - 1 // Lost in last defense
        ;
        else numberOfDefenses = matches.length;
        if (numberOfDefenses < 0) numberOfDefenses = 0;
        const reignChampionship = await (0, $9MKdC.getChampionshipReignChampionship)(reign);
        data["championshipReigns"].push({
            "defenses": numberOfDefenses,
            "startDate": startDate,
            "endDate": endDate,
            "name": (0, $1JSre.getChampionshipDisplayName)(reignChampionship)
        });
    }
    return data;
}
async function $e22612169abb8ad8$var$checkIfReignPresentInReigns(checkReign, reigns) {
    const checkC = await (0, $9MKdC.getChampionshipReignChampionship)(checkReign);
    const checkM = await (0, $9MKdC.getChampionshipReignMatches)(checkReign);
    for (const r of reigns){
        const c = await (0, $9MKdC.getChampionshipReignChampionship)(r);
        const m = await (0, $9MKdC.getChampionshipReignMatches)(r);
        if (c && checkC && c.name === checkC.name && m.every((x)=>(0, $3E8Nt.objectInArray)(x, checkM))) return true;
    }
    return false;
}
async function $e22612169abb8ad8$export$5418e43d6f4857fe() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    // Get indie and indie available rosters
    const indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
    const indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
    // Get scout level
    const scout = (0, $8A6FL.getHighestLevelStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(userCompany), "scout");
    data["scoutLevel"] = scout ? scout.level : 1;
    // Get data for indie rosters
    data["available"] = await $e22612169abb8ad8$var$getRosterDataSimplified(indieAvailableRoster, userCompany, true);
    data["unavailable"] = await $e22612169abb8ad8$var$getRosterDataSimplified(indieRoster);
    return data;
}
async function $e22612169abb8ad8$export$54bbf589c235e825(companyUid) {
    let data = [];
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get main roster's tag teams
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    let mainRosterTagTeams = await $e22612169abb8ad8$export$b34c0a3628418a1a(mainRoster);
    // Sort by latest first
    mainRosterTagTeams.sort((a, b)=>b.$loki - a.$loki);
    // Get data for tag teams
    for (const tagTeam of mainRosterTagTeams){
        const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
        // Skip if no superstars
        if (tagTeamSuperstars.length <= 0) {
            await (0, $ko5kE.removeTagTeam)(tagTeam);
            (0, $14eBR.db).saveDatabase();
            continue;
        }
        let tagTeamData = {};
        tagTeamData["name"] = tagTeam.name;
        tagTeamData["uid"] = tagTeam.$loki;
        tagTeamData["superstars"] = tagTeamSuperstars.map((x)=>x.name);
        tagTeamData["trio"] = tagTeam.trio;
        data.push(tagTeamData);
    }
    return data;
}
async function $e22612169abb8ad8$export$15a3545e49efab33(companyUid) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get main roster's superstars
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    let mainRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Get managers (full time managers and superstars managing other superstars)
    const managerIds = mainRosterSuperstars.filter((x)=>x.managerId).map((x)=>x.managerId);
    const managers = mainRosterSuperstars.filter((x)=>x.fullTimeManager || managerIds.indexOf(x.$loki) >= 0);
    // Get managers data
    let data = await Promise.all(managers.map((x)=>(0, $ycsyu.getManagerData)(x, mainRosterSuperstars)));
    data.sort((a, b)=>b.fullTimeManager - a.fullTimeManager || b.charisma - a.charisma);
    return data;
}
async function $e22612169abb8ad8$export$b34c0a3628418a1a(roster) {
    return (await (0, $dl5u4.getRosterTagTeams)(roster)).filter((x)=>!x.temporary);
}
async function $e22612169abb8ad8$export$45c03faa5e3830f5() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const superstars = (await (0, $8A6FL.getCompanyMainRosterSuperstars)(selectedCompany)).filter((x)=>!x.fullTimeManager).map((y)=>y.name);
    superstars.sort();
    return superstars;
}
async function $e22612169abb8ad8$export$e44b0fb90766dd97(name, firstSuperstarName, secondSuperstarName, thirdSuperstarName, teamType) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
    const rosterFactions = await (0, $6PzHO.getRosterActiveFactions)(mainRoster);
    const cost = 20;
    data["tagTeamType"] = teamType === "trio" ? "Trio" : "Tag Team";
    // Check if enough points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Get superstars
    let firstSuperstar = rosterSuperstars.find((x)=>x.name === firstSuperstarName);
    let secondSuperstar = rosterSuperstars.find((x)=>x.name === secondSuperstarName);
    let thirdSuperstar = null;
    if (teamType === "trio") thirdSuperstar = rosterSuperstars.find((x)=>x.name === thirdSuperstarName);
    // Check if superstars found
    const tagTeamSuperstars = [
        firstSuperstar,
        secondSuperstar
    ];
    if (teamType === "trio") tagTeamSuperstars.push(thirdSuperstar);
    if (tagTeamSuperstars.some((x)=>!x)) {
        data["error"] = "not-found";
        return data;
    }
    // Check if team already exists
    if (rosterTagTeams.find((x)=>x.name === name)) {
        data["error"] = "already-present";
        return data;
    }
    // Check if faction already exists
    if (rosterFactions.find((x)=>x.name === name)) {
        data["error"] = "faction-already-present";
        return data;
    }
    // Check if superstars are present more than once
    if ((0, $3E8Nt.getUniqueObjects)(tagTeamSuperstars).length !== tagTeamSuperstars.length) {
        data["error"] = "duplicate-superstars";
        return data;
    }
    // Check if superstars are already in a tag team
    for (const s of tagTeamSuperstars){
        let superstarTagTeams;
        if (teamType === "trio") superstarTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary && x.trio);
        else superstarTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary && !x.trio);
        if (superstarTagTeams.length > 0) {
            data["error"] = "already-in-tag-team";
            data["superstarName"] = s.name;
            return data;
        }
    }
    // Create tag team and add to roster
    const newTagTeam = await (0, $972Ip.addTagTeam)(name, tagTeamSuperstars, teamType === "trio");
    await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
        newTagTeam
    ]);
    // Add company log
    const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, selectedCompany.realYear);
    await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
    newCompanyLog.text = newTagTeam.name;
    newCompanyLog.type = "new-tag-team";
    newCompanyLog.realYear = currentGame.year;
    await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
        newCompanyLog
    ]);
    // Remove points
    selectedCompany.points -= cost;
    // Check talent request
    for (const s of tagTeamSuperstars)for (const otherMember of tagTeamSuperstars.filter((x)=>x.$loki !== s.$loki)){
        let requestData = {
            "talentId": otherMember.$loki
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: selectedCompany,
            requestType: "team_with_x",
            talent: s,
            data: requestData
        });
    }
    // Check tutorial action
    if (selectedCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(selectedCompany, [
        "add_team"
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["tagTeamName"] = newTagTeam.name;
    const unreadMessages = (await (0, $9esFv.getCompanyMessages)(selectedCompany)).filter((x)=>!x.read);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $e22612169abb8ad8$export$c1eec92d42efa941({ uid: uid, type: type } = {}) {
    let data = {};
    // Get member
    let rosterMember;
    if (type === "superstar" || type === "training-superstar") rosterMember = await (0, $14eBR.Superstars).get(uid);
    else if (type === "tagTeam") rosterMember = await (0, $14eBR.TagTeams).get(uid);
    else if (type === "faction") rosterMember = await (0, $14eBR.Factions).get(uid);
    data["name"] = rosterMember.name;
    return data;
}
async function $e22612169abb8ad8$export$ada9aeeec3341de8({ uid: uid } = {}) {
    let data = {};
    let rosterMember = await (0, $14eBR.Superstars).get(uid);
    data["name"] = rosterMember.name;
    data["pronoun"] = rosterMember.pronoun;
    return data;
}
async function $e22612169abb8ad8$export$a896b1d8cf87f7({ uid: uid, getCharacters: getCharacters = true } = {}) {
    let data = {};
    let rosterMember = await (0, $14eBR.Superstars).get(uid);
    let gimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(rosterMember);
    data["name"] = rosterMember.name;
    data["graphic"] = rosterMember.graphic;
    data["alignment"] = rosterMember.alignment;
    if (gimmick) {
        data["gimmick"] = gimmick.name;
        data["nextGimmickBoost"] = gimmick.nextGimmickBoost;
    }
    // Get characters
    if (getCharacters) {
        const currentGame = await (0, $3E8Nt.getCurrentGame)();
        const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
        const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
        const user = (0, $bZol7.loadUser)();
        const characters = [
            ...(0, $fuJHb.charactersData)
        ];
        const usedCharacters = await $e22612169abb8ad8$var$getUsedCharacters(mainRoster, rosterMember);
        let unlockedCharacters = (0, $98xmD.globalUser).paid ? user.unlockedCharacters : [];
        data["characters"] = characters.map((x)=>$e22612169abb8ad8$var$getCharacterData(x, user, usedCharacters, unlockedCharacters));
    }
    return data;
}
async function $e22612169abb8ad8$var$getUsedCharacters(roster, superstar = null) {
    const standardCharactersNames = [
        ...(0, $fuJHb.charactersData)
    ].filter((x)=>x.standard).map((y)=>y.name);
    let rosterCharacters = [];
    for (const s of (await (0, $dl5u4.getRosterSuperstars)(roster)))// Check gimmicks of all other superstars
    if (!superstar || s.$loki !== superstar.$loki) {
        const gimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(s);
        if (gimmick && gimmick.character) {
            if (standardCharactersNames.includes(gimmick.character)) rosterCharacters.push(gimmick.character);
        }
    }
    return rosterCharacters;
}
async function $e22612169abb8ad8$export$5f6c6fb672a09041(character, roster, superstar) {
    const rosterCharacters = await $e22612169abb8ad8$var$getUsedCharacters(roster, superstar);
    return rosterCharacters.filter((x)=>x === character).length;
}
function $e22612169abb8ad8$var$getCharacterData(character, user, usedCharacters, unlockedCharacters) {
    let data = {};
    data["name"] = character.name;
    data["level"] = character.level;
    data["tag"] = character.tag;
    // Check locked
    let locked;
    if (character.standard) locked = false;
    else locked = unlockedCharacters.indexOf(character.name) < 0;
    data["locked"] = locked;
    // Add combinations and times used if not locked
    if (!locked) {
        data["combinations"] = {
            "easy": [],
            "hard": [],
            "okay": []
        };
        if (user) {
            let combinations = user.unlockedCombinations;
            if (combinations && combinations[character.name]) for (const k of Object.keys(data["combinations"]))data["combinations"][k].push(...combinations[character.name][k]);
        }
        data["timesUsed"] = usedCharacters.filter((x)=>x === character.name).length;
        // Get unlock counts
        data["easyCombinationsTotal"] = [
            ...new Set((0, $5IqxM.gimmickCombinationsData)[character.name]["easy"])
        ].length;
        data["hardCombinationsTotal"] = [
            ...new Set((0, $5IqxM.gimmickCombinationsData)[character.name]["hard"])
        ].length;
        data["easyCombinationsUnlocked"] = data["combinations"]["easy"].length;
        data["hardCombinationsUnlocked"] = data["combinations"]["hard"].length;
    }
    return data;
}
async function $e22612169abb8ad8$export$d84b78a0d634d60b({ uid: uid, type: type } = {}) {
    let data = {};
    // Get member
    let rosterMember;
    if (type === "superstar" || type === "training-superstar") rosterMember = await (0, $14eBR.Superstars).get(uid);
    else if (type === "tagTeam") rosterMember = await (0, $14eBR.TagTeams).get(uid);
    data["name"] = rosterMember.name;
    if (type === "tagTeam") {
        const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(rosterMember);
        if (tagTeamSuperstars.every((x)=>x.alignment === tagTeamSuperstars[0].alignment)) data["alignment"] = tagTeamSuperstars[0].alignment;
        else {
            data["error"] = "different-alignments";
            return data;
        }
    } else data["alignment"] = rosterMember.alignment;
    return data;
}
async function $e22612169abb8ad8$export$a9b5722f3c85591({ uid: uid, type: type } = {}) {
    let data = {};
    // Get member
    let rosterMember;
    if (type === "superstar" || type === "training-superstar") rosterMember = await (0, $14eBR.Superstars).get(uid);
    else if (type === "tagTeam") rosterMember = await (0, $14eBR.TagTeams).get(uid);
    data["name"] = rosterMember.name;
    if (type === "tagTeam") {
        const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(rosterMember);
        if (tagTeamSuperstars.every((x)=>x.brandName === tagTeamSuperstars[0].brandName)) data["brandName"] = tagTeamSuperstars[0].brandName;
    } else data["brandName"] = rosterMember.brandName;
    // Get brand names
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    data["brandNames"] = rosterBrands.map((x)=>x.name);
    return data;
}
async function $e22612169abb8ad8$export$1233b9decaf94f98({ uid: uid, type: type, name: name } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyRosters = await (0, $9esFv.getCompanyRosters)(selectedCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main", companyRosters);
    const trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "training", companyRosters);
    const trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "trainingAvailable", companyRosters);
    const cost = 50;
    // Get member
    let rosterMember;
    let allNames;
    if (type === "superstar" || type === "training-superstar") {
        rosterMember = await (0, $14eBR.Superstars).get(uid);
        allNames = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).concat(await (0, $dl5u4.getRosterSuperstars)(trainingRoster), await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster)).map((x)=>x.name);
    } else if (type === "tagTeam" || type === "faction") {
        if (type === "tagTeam") rosterMember = await (0, $14eBR.TagTeams).get(uid);
        else rosterMember = await (0, $14eBR.Factions).get(uid);
        allNames = (await (0, $dl5u4.getRosterTagTeams)(mainRoster)).concat(await (0, $dl5u4.getRosterTagTeams)(trainingRoster), await (0, $dl5u4.getRosterTagTeams)(trainingAvailableRoster)).map((x)=>x.name);
        allNames.push(...(await (0, $6PzHO.getRosterActiveFactions)(mainRoster)).concat(await (0, $6PzHO.getRosterActiveFactions)(trainingRoster), await (0, $6PzHO.getRosterActiveFactions)(trainingAvailableRoster)).map((x)=>x.name));
    }
    // Check if enough points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Check for same name
    if (rosterMember.name === name) {
        data["error"] = "same-name";
        return data;
    }
    // Check for WoM
    if (selectedCompany.storyName === "mars") {
        data["error"] = "mars";
        return data;
    }
    // Check for PoW
    if (selectedCompany.storyName === "passion") {
        const dialogPeopleNames = Object.keys((0, $4EOBX.powDialog));
        if (dialogPeopleNames.indexOf(rosterMember.name) >= 0) {
            data["error"] = "pow-person";
            return data;
        }
    }
    // Check for owner name change
    if (rosterMember.name === selectedCompany.ownerName) {
        data["error"] = "owner-name-change";
        return data;
    }
    // Check for owner name
    if (name === selectedCompany.ownerName) {
        data["error"] = "same-name-as-owner";
        return data;
    }
    // Check if name already exists on roster
    if (allNames.indexOf(name) >= 0) {
        data["error"] = "name-exists";
        return data;
    }
    // Change name
    const previousName = rosterMember.name;
    if (name) rosterMember.name = name;
    // Update company logs
    await (0, $8A6FL.updateCompanyLogsForTalentNameChange)(await (0, $9esFv.getCompanyCompanyLogs)(selectedCompany), rosterMember, previousName);
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["name"] = name;
    data["previousName"] = previousName;
    return data;
}
async function $e22612169abb8ad8$export$62061aba88e9a767({ uid: uid, pronoun: pronoun } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get roster member
    let rosterMember = await (0, $14eBR.Superstars).get(uid);
    // Check for WoM
    if (selectedCompany.storyName === "mars" || selectedCompany.storyName === "passion") {
        data["error"] = selectedCompany.storyName;
        return data;
    }
    // Change gender and pronoun
    rosterMember.gender = (0, $5kTkA.getSuperstarGenderFromPronoun)(pronoun);
    rosterMember.pronoun = (0, $3E8Nt.getRosterMemberPronoun)(rosterMember);
    rosterMember.possessivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(rosterMember, "possessive");
    rosterMember.objectivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(rosterMember, "objective");
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["pronoun"] = pronoun;
    return data;
}
async function $e22612169abb8ad8$export$21834ec588f2cb0f({ uid: uid, type: type, alignment: alignment } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const cost = 30;
    // Check if enough points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Get roster member
    let rosterMember;
    let rosterMemberSuperstars;
    if (type === "superstar" || type === "training-superstar") {
        rosterMember = await (0, $14eBR.Superstars).get(uid);
        // Change alignment
        if (alignment !== rosterMember.alignment) await $e22612169abb8ad8$export$96e8a2b5a0ab13e4(rosterMember, alignment, selectedCompany);
        else {
            data["error"] = "same-alignment";
            return data;
        }
    } else if (type === "tagTeam") {
        rosterMember = await (0, $14eBR.TagTeams).get(uid);
        rosterMemberSuperstars = await (0, $972Ip.getTagTeamSuperstars)(rosterMember);
        if (alignment !== rosterMemberSuperstars[0].alignment) for (const s of rosterMemberSuperstars)await $e22612169abb8ad8$export$96e8a2b5a0ab13e4(s, alignment, selectedCompany);
        else {
            data["error"] = "same-alignment";
            return data;
        }
    }
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["alignment"] = alignment;
    data["alignmentMonths"] = 0;
    return data;
}
async function $e22612169abb8ad8$export$7f7f9f5238fb4903({ uid: uid, type: type, brandName: brandName } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const cost = 10;
    // Check if enough points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Check if paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "not-paid";
        return data;
    }
    // Check for story
    if (selectedCompany.storyName === "mars" || selectedCompany.storyName === "passion") {
        data["error"] = selectedCompany.storyName;
        return data;
    }
    // Get roster member
    let rosterMember;
    if (type === "superstar") rosterMember = await (0, $14eBR.Superstars).get(uid);
    else if (type === "tagTeam") rosterMember = await (0, $14eBR.TagTeams).get(uid);
    if (!rosterMember) {
        data["error"] = "roster-member-not-found";
        return data;
    }
    // Check brand name
    if (brandName && rosterBrands.map((x)=>x.name).indexOf(brandName) < 0) {
        data["error"] = "brand-name-not-found";
        return data;
    }
    // Change brand name
    let rosterMemberSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(rosterMember);
    for (const superstar of rosterMemberSuperstars)if (brandName) {
        (0, $1Dp0h.setObjectBrand)(superstar, brandName);
        // Check talent request
        const selectedBrand = rosterBrands.find((x)=>x.name === brandName);
        if (selectedBrand) {
            let requestData = {
                "brandId": selectedBrand.$loki
            };
            await (0, $1olyO.checkTalentRequestAction)({
                company: selectedCompany,
                requestType: "change_brand",
                talent: superstar,
                data: requestData
            });
        }
    } else (0, $1Dp0h.removeObjectBrand)(superstar);
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["brandName"] = rosterMemberSuperstars[0].brandName;
    const unreadMessages = (await (0, $9esFv.getCompanyMessages)(selectedCompany)).filter((x)=>!x.read);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $e22612169abb8ad8$export$b175b43d640b17d({ uid: uid, appearanceOption: appearanceOption, graphicData: graphicData } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const cost = 15;
    // Get superstar
    let superstar = await (0, $14eBR.Superstars).get(uid);
    const currentGraphic = superstar.graphic;
    const graphicPresent = currentGraphic !== null && Object.keys(currentGraphic).length !== 0;
    // Check if enough points
    if (graphicPresent && selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Change/remove graphic
    if (appearanceOption === "change") superstar.graphic = JSON.parse(graphicData);
    else if (appearanceOption === "remove") superstar.graphic = null;
    // Check talent request
    if (!(0, $1JSre.objectEquals)(superstar.graphic, currentGraphic)) await (0, $1olyO.checkTalentRequestAction)({
        company: selectedCompany,
        requestType: "change_appearance",
        talent: superstar
    });
    // Remove points
    if (graphicPresent) selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["graphic"] = superstar.graphic ? JSON.parse(JSON.stringify(superstar.graphic)) : (0, $5kTkA.getEmptySuperstarGraphic)(superstar);
    const unreadMessages = (await (0, $9esFv.getCompanyMessages)(selectedCompany)).filter((x)=>!x.read);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $e22612169abb8ad8$export$a92e8ea5b2ad5be9({ uid: uid, character: character, personality: personality, customGimmickName: customGimmickName, appearanceOption: appearanceOption, graphicData: graphicData, superstarName: superstarName, alignment: alignment } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const cost = 30;
    // Get superstar
    let superstar = await (0, $14eBR.Superstars).get(uid);
    const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(superstar);
    const currentGraphic = superstar.graphic;
    // Check if enough points
    if (superstarGimmick && !superstarGimmick.nextGimmickBoost && selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Set gimmick name
    let gimmickName;
    if (customGimmickName) gimmickName = customGimmickName;
    else if (character && personality) gimmickName = `${personality} ${character}`;
    else gimmickName = personality || character;
    // Check for same gimmick name
    if (superstarGimmick && superstarGimmick.name === gimmickName) {
        data["error"] = "same-name";
        return data;
    }
    // Check usage of character
    let alreadyUsedPenalty = 0;
    if (character) {
        const timesUsed = await $e22612169abb8ad8$export$5f6c6fb672a09041(character, mainRoster, superstar);
        if (timesUsed > 0) {
            if (timesUsed >= 8) alreadyUsedPenalty = -40;
            else if (timesUsed >= 5) alreadyUsedPenalty = -15;
            else if (timesUsed >= 2) alreadyUsedPenalty = -5;
        }
    }
    // Next gimmick bonus
    let nextGimmickBonus = 0;
    if (superstarGimmick && superstarGimmick.nextGimmickBoost) nextGimmickBonus = 20;
    // Create gimmick
    const newGimmick = await $e22612169abb8ad8$export$311c74177e40d92a(superstar, gimmickName, character, alreadyUsedPenalty, nextGimmickBonus);
    superstar.debutNewGimmick = true;
    // Add combination bonus
    data["combinationResult"] = null;
    if (character && personality) {
        const combinationBonus = await $e22612169abb8ad8$export$61b8cdb30db661e1(character, personality);
        newGimmick.combinationBonus = combinationBonus;
        data["combinationResult"] = (0, $5kTkA.getGimmickCombinationResult)(combinationBonus);
    }
    // Change/remove graphic
    if (appearanceOption === "change") superstar.graphic = JSON.parse(graphicData);
    else if (appearanceOption === "remove") superstar.graphic = null;
    // Update name
    const previousName = superstar.name;
    if (superstarName && superstar.name !== superstarName && superstar.name !== selectedCompany.ownerName && selectedCompany.storyName !== "mars") {
        // Check for POW
        if (selectedCompany.storyName === "passion") {
            const dialogPeopleNames = Object.keys((0, $4EOBX.powDialog));
            if (dialogPeopleNames.indexOf(superstar.name) >= 0) {
                data["error"] = "pow-person";
                return data;
            }
        }
        superstar.name = superstarName;
        data["previousName"] = previousName;
        await (0, $8A6FL.updateCompanyLogsForTalentNameChange)(await (0, $9esFv.getCompanyCompanyLogs)(selectedCompany), superstar, previousName);
    }
    // Update alignment
    if (alignment !== superstar.alignment) {
        await $e22612169abb8ad8$export$96e8a2b5a0ab13e4(superstar, alignment, selectedCompany);
        data["alignment"] = superstar.alignment;
        data["alignmentMonths"] = superstar.alignmentMonths;
    }
    // Check talent request
    if (!(0, $1JSre.objectEquals)(superstar.graphic, currentGraphic)) await (0, $1olyO.checkTalentRequestAction)({
        company: selectedCompany,
        requestType: "change_appearance",
        talent: superstar
    });
    // Remove points
    if (superstarGimmick && !superstarGimmick.nextGimmickBoost) selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["superstarName"] = superstar.name;
    data["superstarPossessivePronoun"] = superstar.possessivePronoun;
    data["points"] = selectedCompany.points;
    data["gimmick"] = (0, $5kTkA.getGimmickData)(newGimmick, superstar);
    data["graphic"] = superstar.graphic ? JSON.parse(JSON.stringify(superstar.graphic)) : (0, $5kTkA.getEmptySuperstarGraphic)(superstar);
    const unreadMessages = (await (0, $9esFv.getCompanyMessages)(selectedCompany)).filter((x)=>!x.read);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $e22612169abb8ad8$export$311c74177e40d92a(superstar, gimmickName, character, alreadyUsedPenalty = 0, nextGimmickBonus = 0, characterBonus = 0) {
    const gimmick = (0, $i6OYC.Gimmick)();
    gimmick.name = gimmickName;
    // Get character's bonus or add bonus directly
    if (character) {
        const characterData = (0, $fuJHb.charactersData).find((x)=>x.name === character);
        const bonuses = {
            1: 0,
            2: 10,
            3: 30
        };
        gimmick.character = character;
        gimmick.characterBonus = bonuses[characterData.level] || 0;
    } else gimmick.characterBonus = characterBonus;
    gimmick.characterBonus += alreadyUsedPenalty + nextGimmickBonus;
    // Add to superstar
    await (0, $14eBR.Gimmicks).insert(gimmick);
    await (0, $hBIDz.addSuperstarGimmicks)(superstar, [
        gimmick
    ]);
    return gimmick;
}
async function $e22612169abb8ad8$export$61b8cdb30db661e1(character, personality) {
    let bonus = 0;
    let bonusName;
    let data = (0, $5IqxM.gimmickCombinationsData)[character];
    if (data) {
        if (data["easy"].indexOf(personality) >= 0) {
            bonus = 10;
            bonusName = "easy";
        } else if (data["hard"].indexOf(personality) >= 0) {
            bonus = -10;
            bonusName = "hard";
        } else {
            bonus = 0;
            bonusName = "okay";
        }
        // Add combination to user
        const user = (0, $bZol7.loadUser)();
        if (user && bonusName) {
            if (!user.unlockedCombinations || Object.keys(user.unlockedCombinations).length === 0) await $e22612169abb8ad8$var$addEmptyCombinationsToUser(user);
            await $e22612169abb8ad8$var$addCombinationToUser(user, character, personality, bonusName);
            (0, $bZol7.saveUser)(user);
        }
    }
    return bonus;
}
async function $e22612169abb8ad8$var$addEmptyCombinationsToUser(user) {
    let data = {};
    for (const c of (0, $fuJHb.charactersData))data[c.name] = {
        "easy": [],
        "hard": [],
        "okay": []
    };
    user.unlockedCombinations = data;
    return data;
}
async function $e22612169abb8ad8$var$addCombinationToUser(user, character, personality, value) {
    if (!user.unlockedCombinations.hasOwnProperty(character) && (0, $fuJHb.charactersData).find((x)=>x.name === character)) user.unlockedCombinations[character] = {
        "easy": [],
        "hard": [],
        "okay": []
    };
    if (user.unlockedCombinations[character] && user.unlockedCombinations[character][value]) {
        if (user.unlockedCombinations[character][value].indexOf(personality) < 0) user.unlockedCombinations[character][value].push(personality);
    }
}
async function $e22612169abb8ad8$export$28ce9a1f1d597b95({ uid: uid } = {}) {
    let data = {};
    // Get superstar
    let superstar = await (0, $14eBR.Superstars).get(uid);
    if (!superstar) {
        data["error"] = "superstar-not-found";
        return data;
    }
    // Get gimmick
    const gimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(superstar);
    if (!gimmick) {
        data["error"] = "no-gimmick-present";
        return data;
    }
    // Remove gimmick
    await (0, $hBIDz.removeSuperstarGimmicks)(superstar, [
        gimmick
    ]);
    superstar.debutNewGimmick = false;
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $e22612169abb8ad8$export$96e8a2b5a0ab13e4(rosterMember, alignment, company) {
    for (const superstar of (await (0, $5kTkA.getRosterMemberSuperstars)(rosterMember))){
        superstar.alignment = alignment;
        superstar.alignmentMonths = 0;
        // Check talent request
        let requestData = {
            "alignment": alignment
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "change_alignment",
            talent: superstar,
            data: requestData
        });
    }
}
async function $e22612169abb8ad8$export$60f8f2ba37043bfd(name, age, pronoun, alignment, partTimer, charisma, workrate, fullTimeManager, brandName, graphicData, addGraphic, selectedTraits) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const companyRosters = await (0, $9esFv.getCompanyRosters)(selectedCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main", companyRosters);
    const trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "training", companyRosters);
    const trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "trainingAvailable", companyRosters);
    const trainingFutureRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "trainingFuture", companyRosters);
    let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    let trainingSuperstars = (await (0, $dl5u4.getRosterSuperstars)(trainingRoster)).concat(await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster));
    let futureSuperstars = trainingFutureRoster ? await (0, $dl5u4.getRosterSuperstars)(trainingFutureRoster) : [];
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    // Get selected traits
    let traits = [];
    if (selectedTraits.length > 0) traits = selectedTraits.filter((x)=>Object.keys((0, $aP7lq.traitsData)).indexOf(x) >= 0);
    // Get cost
    let cost = 100;
    cost += (workrate - 1) * 75;
    cost += (charisma - 1) * 75;
    cost += traits.length * 25;
    // Check if enough points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Get gender
    const gender = (0, $5kTkA.getSuperstarGenderFromPronoun)(pronoun);
    // Check age
    if (age > 100 || age < 10) {
        data["error"] = "age";
        return data;
    }
    // Check manager
    if (fullTimeManager && !(0, $98xmD.globalUser).paid) {
        data["error"] = "managers-paid";
        return data;
    }
    // Check brand
    if (brandName && !(0, $98xmD.globalUser).paid) {
        data["error"] = "brands-paid";
        return data;
    }
    // Check if superstar already exists (roster, training, future training)
    const mainRosterNames = rosterSuperstars.map((x)=>x.name);
    const trainingRosterNames = trainingSuperstars.map((x)=>x.name);
    const futureRosterNames = futureSuperstars.map((x)=>x.name);
    if (mainRosterNames.concat(trainingRosterNames, futureRosterNames).indexOf(name) >= 0) {
        data["error"] = "already-exists";
        if (mainRosterNames.indexOf(name) >= 0) data["existsRoster"] = "Main";
        if (trainingRosterNames.indexOf(name) >= 0) data["existsRoster"] = "Training";
        if (futureRosterNames.indexOf(name) >= 0) data["existsRoster"] = "future";
        return data;
    }
    // Check if name is same as owner name
    if (name === selectedCompany.ownerName) {
        data["error"] = "owner-name";
        return data;
    }
    // Check brand name
    if (brandName && rosterBrands.map((x)=>x.name).indexOf(brandName) < 0) {
        data["error"] = "brand-not-found";
        return data;
    }
    // Add superstar
    if (!addGraphic) graphicData = null;
    let superstar = await $e22612169abb8ad8$var$createCustomSuperstar(name, age, gender, alignment, workrate, charisma, partTimer, traits, fullTimeManager, graphicData);
    // Set brand name
    if (brandName) (0, $1Dp0h.setObjectBrand)(superstar, brandName);
    // Add to roster
    await (0, $dl5u4.addRosterSuperstars)(mainRoster, [
        superstar
    ]);
    // Add company log
    const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, selectedCompany.realYear);
    await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
    newCompanyLog.text = superstar.name;
    newCompanyLog.type = "new-superstar";
    newCompanyLog.realYear = currentGame.year;
    await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
        newCompanyLog
    ]);
    // Remove points
    selectedCompany.points -= cost;
    // Add to community graphics if online
    if (graphicData && window.navigator.onLine) $.ajax({
        url: (0, $98xmD.globals).baseUrl + "/_add_template_superstar",
        dataType: "json",
        data: {
            name: name,
            age: age,
            graphic: graphicData
        },
        success: async (data)=>{
            if (!data["error"]) notie.alert({
                type: 4,
                text: '<span class="display-block">{0}\'s graphic has been added to Community Graphics</span>'.format(name)
            });
        }
    });
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["superstarName"] = superstar.name;
    return data;
}
async function $e22612169abb8ad8$export$89e44fbfb71050e5({ uid: uid, type: type } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    const indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
    const indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(selectedCompany);
    // Get talent
    let talent;
    let talentSuperstars;
    if (type === "tagTeam") {
        talent = await (0, $14eBR.TagTeams).get(uid);
        talentSuperstars = await (0, $972Ip.getTagTeamSuperstars)(talent);
    } else {
        talent = await (0, $14eBR.Superstars).get(uid);
        talentSuperstars = [
            talent
        ];
    }
    if (!talent) {
        data["error"] = "not-found";
        return data;
    }
    // Don't allow champions
    for (const s of talentSuperstars){
        const superstarChampionships = await (0, $hBIDz.getSuperstarChampionships)(s);
        const freebirdChampionships = await (0, $5kTkA.getSuperstarFreebirdTagChampionships)(s, companyChampionships);
        const stolenChampionshipRandomEvent = (await (0, $hBIDz.getSuperstarRandomEvents)(s)).find((x)=>x.name === "championshipStolen" && x.monthsRemaining > 0);
        if (superstarChampionships.length > 0 || freebirdChampionships.length > 0 || stolenChampionshipRandomEvent) {
            data["error"] = "champion";
            return data;
        }
    }
    // Don't allow on trade
    if (talentSuperstars.some((x)=>x.activeEffect === "traded")) {
        data["error"] = "trade-deal";
        return data;
    }
    // Don't allow booked
    const bookedSuperstars = await (0, $6RCLU.getSuperstarsBookedAtEventMatches)(latestEvent);
    if (talentSuperstars.some((x)=>(0, $3E8Nt.objectInArray)(x, bookedSuperstars))) {
        data["error"] = "booked";
        return data;
    }
    // Don't allow martians
    if (selectedCompany.storyName === "mars") {
        if (talentSuperstars.some((x)=>x.name.indexOf("(Martian)") >= 0)) {
            data["error"] = "martian";
            return data;
        }
    }
    // Don't allow POW stars
    if (selectedCompany.storyName === "passion") {
        if (talentSuperstars.some((x)=>[
                "Lady Julia",
                "Violet",
                "Natasha Ali",
                "Zora"
            ].indexOf(x.name) >= 0)) {
            data["error"] = "pow-person";
            return data;
        }
    }
    // Remove superstar(s) from their roster and add to indie roster
    const overnessDecrease = (0, $3E8Nt.getRandomInt)(8, 12);
    for (const s of talentSuperstars){
        if (currentGame.settings["all_indies_available"]) await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, [
            s
        ]);
        else await (0, $dl5u4.addRosterSuperstars)(indieRoster, [
            s
        ]);
        // End feuds
        for (const feud of (await (0, $hBIDz.getSuperstarFeuds)(s)))if (!feud.ended) await (0, $cXLSF.endFeud)(feud, currentGame.monthCount, currentGame.year);
        // Remove teams/managers/factions
        await (0, $5kTkA.removeSuperstarTagTeams)(s);
        await (0, $5kTkA.removeSuperstarFactionRelationships)(s, currentGame.monthCount, currentGame.year);
        await (0, $5kTkA.removeSuperstarManagerRelationships)(s);
        // Delete all relationships, add former company relationship
        for (const relationship of (await (0, $hBIDz.getSuperstarRelationships)(s)))await (0, $14eBR.Relationships).remove(relationship);
        await (0, $8A6FL.addFormerCompanyRelationship)(s, selectedCompany);
        // Delete talent requests
        for (const talentRequest of (await (0, $hBIDz.getSuperstarTalentRequests)(s)))await (0, $14eBR.TalentRequests).remove(talentRequest);
        // Make superstar happy
        (0, $5kTkA.changeSuperstarMoraleToHappy)(s);
        // Decrease overness
        s.overness -= overnessDecrease;
        // Reset attributes
        s.brandName = null;
        s.faceOfTheCompanyCounter = 0;
        s.suspensionMonths = 0;
        // Add company log
        const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, selectedCompany.realYear);
        await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
        newCompanyLog.text = s.name;
        newCompanyLog.type = "release";
        newCompanyLog.realYear = currentGame.year;
        await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
            newCompanyLog
        ]);
    }
    let newsItem = await (0, $kZMqI.generateNewsItem)({
        company: selectedCompany,
        month: currentGame.monthCount,
        year: currentGame.year,
        superstar: talent,
        newsType: "superstar_released_by_company"
    });
    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
        newsItem
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["name"] = talent.name;
    data["possessivePronoun"] = talent.possessivePronoun;
    data["overnessDecrease"] = overnessDecrease;
    return data;
}
async function $e22612169abb8ad8$var$createCustomSuperstar(name, age, gender, alignment, workrate, charisma, partTimer, traits, fullTimeManager, graphicData) {
    const xps = {
        3: 300,
        2: 100,
        1: 0
    };
    const superstar = (0, $hBIDz.Superstar)();
    superstar.name = name;
    superstar.age = age;
    superstar.gender = gender;
    superstar.pronoun = (0, $3E8Nt.getRosterMemberPronoun)(superstar);
    superstar.possessivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(superstar, "possessive");
    superstar.objectivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(superstar, "objective");
    superstar.popularity = (0, $3E8Nt.getRandomInt)(500, 600);
    superstar.graphic = JSON.parse(graphicData);
    superstar.partTimer = partTimer;
    if (partTimer) superstar.appearances = $e22612169abb8ad8$export$87e7b14799f29ae0(superstar);
    superstar.alignment = alignment;
    superstar.charisma = charisma;
    superstar.highestRank = (0, $5kTkA.getRankFromPopularity)(superstar.popularity);
    superstar.charismaXp = xps[charisma] || 0;
    superstar.workrate = workrate;
    superstar.workrateXp = xps[workrate] || 0;
    superstar.fullTimeManager = fullTimeManager;
    if (traits.length > 0) superstar.traits = traits;
    await (0, $14eBR.Superstars).insert(superstar);
    return superstar;
}
function $e22612169abb8ad8$export$87e7b14799f29ae0(superstar) {
    if (superstar.partTimer) return (0, $3E8Nt.getRandomInt)(1, 8);
    return null;
}
async function $e22612169abb8ad8$export$6c34b2ae9ca603b2({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(selectedCompany);
    // Get tag team
    const tagTeam = await (0, $14eBR.TagTeams).get(uid);
    if (!tagTeam) {
        data["error"] = "not-found";
        return data;
    }
    const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
    const trio = tagTeam.trio;
    // Don't allow champions
    let tagChampionships = (await Promise.all(tagTeamSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
    if (trio) tagChampionships = tagChampionships.filter((x)=>x.trio || x.tagTeam);
    else tagChampionships = tagChampionships.filter((x)=>x.tagTeam);
    if (tagChampionships.length > 0) {
        data["error"] = "champion";
        return data;
    }
    // Don't allow booked
    const bookedSuperstars = await (0, $6RCLU.getSuperstarsBookedAtEventMatches)(nextEvent);
    if (tagTeamSuperstars.some((x)=>(0, $3E8Nt.objectInArray)(x, bookedSuperstars))) {
        data["error"] = "booked";
        return data;
    }
    const eventSegments = await (0, $iQtzn.getEventSegments)(nextEvent);
    const eventSegmentsParticipants = (await Promise.all(eventSegments.map((x)=>(0, $eg5dz.getSegmentParticipants)(x)))).flat();
    if ((0, $3E8Nt.objectInArray)(tagTeam, eventSegmentsParticipants)) {
        data["error"] = "booked";
        return data;
    }
    // Remove tag team
    await (0, $ko5kE.removeTagTeam)(tagTeam);
    // Add feud potential
    if (tagTeamSuperstars.length > 1) {
        const feudItem = (await (0, $9esFv.getCompanyFeudItems)(selectedCompany)).find((x)=>x.unlocked && x.requirement === "disbanded-tag-team");
        if (feudItem) {
            const feudSuperstars = (0, $3E8Nt.getRandomSample)(tagTeamSuperstars, 2);
            const newFeud = (0, $jDtEn.Feud)();
            newFeud.name = feudItem.name;
            newFeud.hype = feudItem.baseHype;
            newFeud.participants = feudSuperstars.map((x)=>x.name);
            newFeud.directFeudEvent = "disbanded-tag-team";
            newFeud.startMonth = currentGame.monthCount;
            newFeud.startYear = currentGame.year;
            await (0, $14eBR.Feuds).insert(newFeud);
            await (0, $im36F.addFeudItemFeuds)(feudItem, [
                newFeud
            ]);
            await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                newFeud
            ]);
            await (0, $jDtEn.addFeudSuperstars)(newFeud, feudSuperstars);
            data["feudPotential"] = {
                "name": newFeud.name,
                "participants": newFeud.participants
            };
        }
    }
    // Check talent request
    for (const s of tagTeamSuperstars){
        let requestData = {
            "teamId": tagTeam.$loki
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: selectedCompany,
            requestType: "disband_team",
            talent: s,
            data: requestData
        });
    }
    // Check tutorial action
    if (selectedCompany.storyName === "tutorial") data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(selectedCompany, [
        "disband_team"
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["name"] = tagTeam.name;
    const unreadMessages = (await (0, $9esFv.getCompanyMessages)(selectedCompany)).filter((x)=>!x.read);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $e22612169abb8ad8$export$207e8b5f0d8ae19e({ matchType: matchType, tagTeamType: tagTeamType, segment: segment = false, getVacatedChampionships: getVacatedChampionships = true } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(selectedCompany);
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const staffMembers = (await (0, $9esFv.getCompanyStaff)(selectedCompany)).filter((x)=>!x.retired);
    const doctor = (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "doctor");
    let vacatedChampionships = [];
    // Define data
    data["available"] = [];
    data["notAvailable"] = [];
    data["retired"] = [];
    data["managers"] = [];
    data["teams"] = [];
    data["vacatedChampionships"] = [];
    data["factions"] = [];
    data["brandNames"] = rosterBrands.map((x)=>x.name);
    if (matchType === "singles") {
        const rosterTagTeams = await $e22612169abb8ad8$export$b34c0a3628418a1a(mainRoster);
        const rosterFactions = await (0, $6PzHO.getRosterActiveFactions)(mainRoster);
        const competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(selectedCompany, currentGame);
        const competitorChampionships = (await Promise.all(competitors.map((x)=>(0, $9esFv.getCompanyChampionships)(x)))).flat();
        const allChampionships = companyChampionships.concat(competitorChampionships);
        const bookedSuperstars = await (0, $6RCLU.getSuperstarsBookedAtEventMatches)(nextEvent);
        // Get available superstars
        let availableSuperstars = rosterSuperstars.filter((x)=>!x.dead);
        // Allow retired superstars and managers in segments
        if (!segment) availableSuperstars = availableSuperstars.filter((x)=>!(x.retired && !x.fullTimeManager) && (!x.fullTimeManager || x.activeEffect === "one_match_appearance"));
        // Sort superstars by popularity and name
        availableSuperstars.sort((a, b)=>b.popularity - a.popularity || b.name.localeCompare(a.name));
        // Add temporary participants to tag teams and factions
        for (const x of rosterTagTeams.concat(rosterFactions))x.tempSuperstarsIds = (await (0, $5kTkA.getRosterMemberSuperstars)(x)).map((x)=>x.$loki);
        // Get data for superstars
        for (const superstar of availableSuperstars){
            // Get superstar tagTeams, factions and championships from already loaded data
            let superstarTagTeams = rosterTagTeams.filter((x)=>x.tempSuperstarsIds.includes(superstar.$loki));
            let superstarFactions = rosterFactions.filter((x)=>x.tempSuperstarsIds.includes(superstar.$loki));
            let superstarTagTeamsAndFactions = superstarTagTeams.concat(superstarFactions);
            let superstarChampionships = allChampionships.filter((x)=>x.superstarId === superstar.$loki);
            superstarChampionships.push(...await (0, $5kTkA.getSuperstarFreebirdTagChampionships)(superstar, allChampionships, superstarTagTeams));
            // Check for brand exclusive event
            if (!(0, $5kTkA.checkSuperstarBrandAvailability)(nextEvent, superstar, superstarChampionships)) continue;
            // Get data for superstar
            const superstarData = await (0, $5kTkA.getSuperstarDisplayData)({
                superstar: superstar,
                doctor: doctor,
                getTeamsAndFactions: true,
                rosterSuperstars: rosterSuperstars,
                getGimmick: false,
                superstarChampionships: superstarChampionships,
                game: currentGame,
                superstarTagTeamsAndFactions: superstarTagTeamsAndFactions
            });
            // Add booked
            if (!segment && (0, $3E8Nt.objectInArray)(superstar, bookedSuperstars)) superstarData["booked"] = true;
            // Add to managers
            if (superstar.fullTimeManager) {
                data["managers"].push(superstarData);
                continue;
            }
            // Add to retired
            if (superstar.retired) {
                data["retired"].push(superstarData);
                continue;
            }
            // Add to not available if part timer with 0 appearances
            if (superstar.partTimer && superstar.appearances <= 0) {
                data["notAvailable"].push(superstarData);
                continue;
            }
            // Add to not available if injured (except workable injury)
            if (superstar.injured > 0 && !superstar.workableInjury) {
                data["notAvailable"].push(superstarData);
                continue;
            }
            // Add to not available if suspended or unavailable
            if (superstar.suspensionMonths > 0 || superstar.unavailable) {
                data["notAvailable"].push(superstarData);
                continue;
            }
            // Add to available
            data["available"].push(superstarData);
        }
        // Get vacated championships
        vacatedChampionships = companyChampionships.filter((x)=>x.vacated && !x.booked);
        if (tagTeamType) {
            // Get team titles if singles tag match (2v2, 3v3)
            if (tagTeamType === "tag-team") vacatedChampionships = vacatedChampionships.filter((x)=>x.tagTeam);
            else if (tagTeamType === "trio") vacatedChampionships = vacatedChampionships.filter((x)=>x.trio);
        } else // Get singles championships
        vacatedChampionships = vacatedChampionships.filter((x)=>!x.tagTeam && !x.trio);
    } else if (matchType === "tag") {
        const rosterTagTeams = (await $e22612169abb8ad8$export$b34c0a3628418a1a(mainRoster)).filter((x)=>tagTeamType === "trio" ? x.trio : true);
        const competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(selectedCompany, currentGame);
        const competitorChampionships = (await Promise.all(competitors.map((x)=>(0, $9esFv.getCompanyChampionships)(x)))).flat();
        const allChampionships = companyChampionships.concat(competitorChampionships).filter((x)=>tagTeamType === "trio" ? x.trio : x.tagTeam);
        // Get data for tag teams
        for (const tagTeam of rosterTagTeams){
            let tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
            // Remove tag team if no superstars present
            if (tagTeamSuperstars.length <= 0) {
                await (0, $ko5kE.removeTagTeam)(tagTeam);
                (0, $14eBR.db).saveDatabase();
                continue;
            }
            // Check if temporary team
            if (tagTeam.temporary) continue;
            // Get championships
            let tagTeamChampionships = allChampionships.filter((x)=>tagTeamSuperstars.some((y)=>x.superstarId === y.$loki));
            // Allow one unavailable superstar for trios in tag match booking (not in segment)
            let maxUnavailableMembers = 0;
            if (tagTeamType === "tag-team" && tagTeam.trio && !segment) maxUnavailableMembers = 1;
            // Check for excluded superstars
            const excludedSuperstars = tagTeamSuperstars.filter((x)=>!(0, $5kTkA.checkSuperstarBrandAvailability)(nextEvent, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships)));
            if (excludedSuperstars.length > maxUnavailableMembers) continue;
            // Filter out excluded superstars
            tagTeamSuperstars = tagTeamSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, excludedSuperstars));
            // Get data for tagTeam
            const tagTeamData = await (0, $ko5kE.getTagTeamDisplayData)({
                tagTeam: tagTeam,
                rosterSuperstars: rosterSuperstars,
                tagTeamChampionships: tagTeamChampionships,
                game: currentGame
            });
            // Get not available superstars
            let notAvailableSuperstars;
            if (segment) notAvailableSuperstars = tagTeamSuperstars.filter((x)=>!(0, $5kTkA.checkSuperstarSegmentAvailability)(x));
            else notAvailableSuperstars = tagTeamSuperstars.filter((x)=>!(0, $5kTkA.checkAvailability)(x, false));
            // Add to not available or teams
            if (notAvailableSuperstars.length > maxUnavailableMembers) data["notAvailable"].push(tagTeamData);
            else data["teams"].push(tagTeamData);
        }
        // Sort teams
        data["teams"].sort((a, b)=>b.popularity - a.popularity || b.name.localeCompare(a.name));
        // Get vacated championships
        vacatedChampionships = companyChampionships.filter((x)=>x.vacated && !x.booked && (tagTeamType === "trio" ? x.trio : x.tagTeam));
    }
    if (matchType === "factions" || matchType === "tag" && !segment) {
        const rosterFactions = await (0, $6PzHO.getRosterActiveFactions)(mainRoster);
        // Get data for factions
        for (const faction of rosterFactions){
            let factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
            let minAvailableMembers = tagTeamType === "trio" ? 3 : 2;
            if (segment) minAvailableMembers = 2;
            // Check for excluded superstars
            factionSuperstars = factionSuperstars.filter((x)=>(0, $5kTkA.checkSuperstarBrandAvailability)(nextEvent, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships)));
            if (factionSuperstars.length < minAvailableMembers) continue;
            // Get data for faction
            const factionData = await (0, $6PzHO.getFactionData)(faction, companyChampionships, true);
            // Get not available superstars
            let availableSuperstars;
            if (segment) availableSuperstars = factionSuperstars.filter((x)=>(0, $5kTkA.checkSuperstarSegmentAvailability)(x));
            else availableSuperstars = factionSuperstars.filter((x)=>(0, $5kTkA.checkAvailability)(x, false));
            // Add to not available or teams
            if (availableSuperstars.length < minAvailableMembers) data["notAvailable"].push(factionData);
            else data["factions"].push(factionData);
        }
    }
    // Filter vacated championships
    vacatedChampionships = vacatedChampionships.filter((x)=>(0, $5kTkA.checkObjectBrandAvailability)(x, nextEvent.brandName, false, nextEvent.activeEffect));
    vacatedChampionships = (0, $kZwpB.getUniqueChampionships)(vacatedChampionships);
    // Get data for vacated championships
    if (getVacatedChampionships) data["vacatedChampionships"] = await Promise.all(vacatedChampionships.map((x)=>(0, $kZwpB.getChampionshipBookingData)(x)));
    return data;
}
async function $e22612169abb8ad8$export$d3456f6cceb4e1fc({ uid: uid, participantType: participantType } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get participant and feuds
    let feuds = [];
    if (participantType === "superstar") {
        const superstar = await (0, $14eBR.Superstars).get(uid);
        if (!superstar) return data;
        feuds = await (0, $hBIDz.getSuperstarFeuds)(superstar);
        // Get faction and team member names
        let factions = await (0, $5kTkA.getSuperstarActiveFactions)(superstar);
        let tagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(superstar)).filter((x)=>!x.temporary);
        data["partnerSuperstars"] = (await Promise.all(factions.map((x)=>(0, $2JFAd.getFactionSuperstars)(x)))).flat().filter((x)=>x.$loki !== superstar.$loki).map((x)=>x.name);
        data["partnerSuperstars"].push(...(await Promise.all(tagTeams.map((x)=>(0, $972Ip.getTagTeamSuperstars)(x)))).flat().filter((x)=>x.$loki !== superstar.$loki).map((x)=>x.name));
    } else if (participantType === "tag-team" || participantType === "trio") {
        const tagTeam = await (0, $14eBR.TagTeams).get(uid);
        if (!tagTeam) return data;
        feuds = await (0, $972Ip.getTagTeamFeuds)(tagTeam);
    } else if (participantType === "faction") {
        const faction = await (0, $14eBR.Factions).get(uid);
        if (!faction) return data;
        feuds = await (0, $2JFAd.getFactionFeuds)(faction);
    }
    // Sort feuds by not ended, then end time
    feuds.sort((a, b)=>a.ended - b.ended || b.endYear - a.endYear || b.endMonth - a.endMonth);
    // Get data for feuds
    data["feudsData"] = [];
    for (const feud of feuds){
        // Skip ended potential feuds
        if (feud.ended && !feud.started) continue;
        let feudData = await (0, $cXLSF.getFeudData)(feud, true);
        // Skips previous feud if current feud present and skips feuds before latest previous feud
        if (data["feudsData"].some((x)=>(0, $3E8Nt.checkAreArraysEqual)(x["participants"], feudData["participants"]))) continue;
        // Add previous feud boost
        if (feud.started && feud.ended) feudData["previousFeudBoost"] = (0, $cXLSF.getPreviousFeudHypeBoost)(feud, currentGame.monthCount, currentGame.year);
        data["feudsData"].push(feudData);
    }
    return data;
}

});
parcelRequire.register("ycsyu", function(module, exports) {

$parcel$export(module.exports, "getManagerData", () => $066cd74d15bfe445$export$a9c2ce2c7f0102ff);
$parcel$export(module.exports, "getManagerManagedTalent", () => $066cd74d15bfe445$export$5dc7d4bd76ffa39a);
$parcel$export(module.exports, "getManagedTalentForManager", () => $066cd74d15bfe445$export$111c5dd98ab71cb5);
$parcel$export(module.exports, "setManagersForMatchOrSegment", () => $066cd74d15bfe445$export$9d63c8262b963964);
$parcel$export(module.exports, "setupSetManagersForMatchOrSegment", () => $066cd74d15bfe445$export$121273031cb1354e);
$parcel$export(module.exports, "addSuperstarManagerToMatchOrSegment", () => $066cd74d15bfe445$export$263f2a4b571c7393);
$parcel$export(module.exports, "removeSuperstarManagerFromMatchOrSegment", () => $066cd74d15bfe445$export$81fd55e15fb33859);

var $14eBR = parcelRequire("14eBR");

var $hBIDz = parcelRequire("hBIDz");

var $972Ip = parcelRequire("972Ip");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");
async function $066cd74d15bfe445$export$a9c2ce2c7f0102ff(manager, rosterSuperstars = null) {
    let data = {};
    data["name"] = manager.name;
    data["charisma"] = manager.charisma;
    if (manager.hot) data["charisma"] += 1;
    data["hot"] = manager.hot;
    data["fullTimeManager"] = manager.fullTimeManager;
    data["uid"] = manager.$loki;
    // Get managed talent names
    const managedTalent = await $066cd74d15bfe445$export$5dc7d4bd76ffa39a(manager, rosterSuperstars);
    data["managedTalentNames"] = managedTalent.map((x)=>x.name);
    return data;
}
async function $066cd74d15bfe445$export$5dc7d4bd76ffa39a(manager, rosterSuperstars = null, checkAvailable = false, managedSuperstars = null) {
    // Check availability for manager promo segment
    function checkManagedTalentAvailability(talent) {
        return !checkAvailable || !talent.unavailable && talent.suspensionMonths <= 0;
    }
    // Get managed superstars
    if (managedSuperstars === null) {
        if (rosterSuperstars) managedSuperstars = rosterSuperstars.filter((x)=>x.managerId === manager.$loki);
        else managedSuperstars = [
            ...await (0, $hBIDz.getSuperstarManagedSuperstars)(manager)
        ];
    }
    // Get managed talent (get team names, if found, instead of individual superstar names)
    let managedTalent = [];
    for (const managedSuperstar of managedSuperstars){
        // Get superstar's teams that have all members managed by manager
        let managedTeamFound = false;
        const superstarTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(managedSuperstar)).filter((y)=>!y.temporary);
        for (const superstarTagTeam of superstarTagTeams){
            const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(superstarTagTeam);
            if (tagTeamSuperstars.every((s)=>(0, $3E8Nt.objectInArray)(s, managedSuperstars) && checkManagedTalentAvailability(s))) {
                managedTeamFound = true;
                managedTalent.push(superstarTagTeam);
            }
        }
        // Get superstar if no managed team found
        if (!managedTeamFound && checkManagedTalentAvailability(managedSuperstar)) managedTalent.push(managedSuperstar);
    }
    // Remove duplicates
    managedTalent = (0, $3E8Nt.getUniqueObjects)(managedTalent);
    return managedTalent;
}
async function $066cd74d15bfe445$export$111c5dd98ab71cb5({ managerUid: managerUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    let manager = await (0, $14eBR.Superstars).get(managerUid);
    let managedTalent = [];
    if (manager) managedTalent = await $066cd74d15bfe445$export$5dc7d4bd76ffa39a(manager, rosterSuperstars, true);
    data["managedTalent"] = managedTalent.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    return data;
}
function $066cd74d15bfe445$export$9d63c8262b963964() {
    return;
}
function $066cd74d15bfe445$export$121273031cb1354e(newFunction) {
    $066cd74d15bfe445$export$9d63c8262b963964 = newFunction;
}
function $066cd74d15bfe445$export$263f2a4b571c7393(matchOrSegment, superstar, manager) {
    // Add manager to superstar if not already added to a superstar in the match/segment
    if (!Object.values(matchOrSegment.managersUsed).includes(manager.$loki)) {
        matchOrSegment.managersUsed[String(superstar.$loki)] = manager.$loki;
        return true;
    }
    return false;
}
function $066cd74d15bfe445$export$81fd55e15fb33859(matchOrSegment, superstar) {
    // Remove manager from superstar if present
    delete matchOrSegment.managersUsed[String(superstar.$loki)];
    return true;
}

});

parcelRequire.register("6PzHO", function(module, exports) {

$parcel$export(module.exports, "createFaction", () => $4f9333e8bb627a7e$export$5f0dc2f57620b787);
$parcel$export(module.exports, "setupCreateFaction", () => $4f9333e8bb627a7e$export$71c93e9d4003a75);
$parcel$export(module.exports, "removeSuperstarsFromFaction", () => $4f9333e8bb627a7e$export$babc6ea551591eab);
$parcel$export(module.exports, "removeFactionLeader", () => $4f9333e8bb627a7e$export$bc6415e03e02d8e3);
$parcel$export(module.exports, "disbandFaction", () => $4f9333e8bb627a7e$export$9bad266ef22a65ff);
$parcel$export(module.exports, "getViewFactionsData", () => $4f9333e8bb627a7e$export$1ad7e737803fad01);
$parcel$export(module.exports, "getFactionData", () => $4f9333e8bb627a7e$export$a6b52454bc34550a);
$parcel$export(module.exports, "getRosterActiveFactions", () => $4f9333e8bb627a7e$export$b45ffdf6d43944c7);
$parcel$export(module.exports, "getSuperstarsAvailableForFaction", () => $4f9333e8bb627a7e$export$d8513f2b29233ed6);
$parcel$export(module.exports, "getFactionSuperstarsRequest", () => $4f9333e8bb627a7e$export$83d92d74cf8d5f05);
$parcel$export(module.exports, "addFaction", () => $4f9333e8bb627a7e$export$c578a28e377fef0c);
$parcel$export(module.exports, "getFactionCreationReputationAndXp", () => $4f9333e8bb627a7e$export$7fdeea148e00ef32);
$parcel$export(module.exports, "updateFactionXpAndReputation", () => $4f9333e8bb627a7e$export$c0feff3b6ef353b1);
$parcel$export(module.exports, "disbandFactionRequest", () => $4f9333e8bb627a7e$export$b367e26fcead7aae);
$parcel$export(module.exports, "addFactionMembers", () => $4f9333e8bb627a7e$export$5b84ea98b0758424);
$parcel$export(module.exports, "removeFactionMembers", () => $4f9333e8bb627a7e$export$683235c35fde060c);
$parcel$export(module.exports, "removeFactionLeaderRequest", () => $4f9333e8bb627a7e$export$2e4791a6621590f7);
$parcel$export(module.exports, "setFactionLeader", () => $4f9333e8bb627a7e$export$78b76cb80de4c7f4);
$parcel$export(module.exports, "getCompanyFactionsForSelection", () => $4f9333e8bb627a7e$export$7448b3eec82d5dda);
$parcel$export(module.exports, "getFactionSuperstarsForSegment", () => $4f9333e8bb627a7e$export$d6c9dba3f4ce1aa4);
$parcel$export(module.exports, "processFactionXpChangeForSuperstar", () => $4f9333e8bb627a7e$export$4dcd402063b4c8d3);
$parcel$export(module.exports, "processFactionXpChangeForFaction", () => $4f9333e8bb627a7e$export$b57ebcdab978c06b);

var $3E8Nt = parcelRequire("3E8Nt");

var $14eBR = parcelRequire("14eBR");

var $iRMwH = parcelRequire("iRMwH");

var $8A6FL = parcelRequire("8A6FL");

var $9esFv = parcelRequire("9esFv");

var $dl5u4 = parcelRequire("dl5u4");

var $2JFAd = parcelRequire("2JFAd");

var $ko5kE = parcelRequire("ko5kE");

var $kZwpB = parcelRequire("kZwpB");

var $1JSre = parcelRequire("1JSre");

var $5kTkA = parcelRequire("5kTkA");

var $hBIDz = parcelRequire("hBIDz");

var $cXLSF = parcelRequire("cXLSF");

var $4K85d = parcelRequire("4K85d");

var $1olyO = parcelRequire("1olyO");
const $4f9333e8bb627a7e$export$598ac26c4bbfbc07 = [
    0,
    20,
    50,
    90,
    140,
    200,
    270,
    350,
    440,
    540
];
// BASIC FACTION FUNCTIONS
async function $4f9333e8bb627a7e$export$5f0dc2f57620b787() {
    return;
}
function $4f9333e8bb627a7e$export$71c93e9d4003a75(newFunction) {
    $4f9333e8bb627a7e$export$5f0dc2f57620b787 = newFunction;
}
async function $4f9333e8bb627a7e$var$addSuperstarsToFaction(faction, superstars) {
    const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
    for (const superstar of superstars)if (!(0, $3E8Nt.objectInArray)(superstar, factionSuperstars)) await (0, $2JFAd.addFactionSuperstars)(faction, [
        superstar
    ]);
}
async function $4f9333e8bb627a7e$export$babc6ea551591eab(faction, superstars) {
    const leader = await (0, $2JFAd.getFactionLeaderSuperstar)(faction);
    const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
    for (const superstar of superstars)if ((0, $3E8Nt.objectInArray)(superstar, factionSuperstars)) {
        await (0, $2JFAd.removeFactionSuperstars)(faction, [
            superstar
        ]);
        // Add to faction's former members array if not present already
        if (faction.formerMembers.indexOf(superstar.name) < 0) faction.formerMembers.push(superstar.name);
        // Remove leader status if removing from faction
        if (leader && superstar.$loki === leader.$loki) await $4f9333e8bb627a7e$export$bc6415e03e02d8e3(faction, leader);
    }
    return faction;
}
async function $4f9333e8bb627a7e$export$bc6415e03e02d8e3(faction, leader) {
    if (leader) {
        const leadsFactions = await (0, $hBIDz.getSuperstarLeadFactions)(leader);
        if ((0, $3E8Nt.objectInArray)(faction, leadsFactions)) await (0, $2JFAd.removeFactionLeaderSuperstar)(faction);
    }
    return faction;
}
async function $4f9333e8bb627a7e$export$9bad266ef22a65ff(faction, month, year) {
    faction.disbanded = true;
    // End feuds
    for (const feud of (await (0, $2JFAd.getFactionFeuds)(faction)))if (!feud.ended) await (0, $cXLSF.endFeud)(feud, month, year);
}
// END BASIC FACTION FUNCTIONS
async function $4f9333e8bb627a7e$export$1ad7e737803fad01(companyUid) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get main roster's factions and sort
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const mainRosterFactions = await (0, $dl5u4.getRosterFactions)(mainRoster);
    mainRosterFactions.sort((a, b)=>a.disbanded - b.disbanded || b.reputation - a.reputation || b.xp - a.xp || b.$loki - a.$loki);
    // Get company championships
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    // Get data for factions
    return Promise.all(mainRosterFactions.map((x)=>$4f9333e8bb627a7e$export$a6b52454bc34550a(x, companyChampionships)));
}
async function $4f9333e8bb627a7e$export$a6b52454bc34550a(faction, companyChampionships, getSuperstarsInformation = false) {
    let data = {};
    // Get attributes
    data["name"] = faction.name;
    data["disbanded"] = faction.disbanded;
    data["uid"] = faction.$loki;
    data["type"] = "faction";
    // Get superstars data
    const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
    data["superstars"] = await $4f9333e8bb627a7e$var$getFactionSuperstarsData(faction, factionSuperstars, companyChampionships);
    // Get graphics
    data["graphic"] = await $4f9333e8bb627a7e$var$getFactionGraphicsData(faction, factionSuperstars, companyChampionships);
    // Get former members, removing those who have rejoined faction
    const factionSuperstarsNames = factionSuperstars.map((x)=>x.name);
    data["formerMembers"] = faction.formerMembers.filter((x)=>factionSuperstarsNames.indexOf(x) < 0);
    // Get reputation data
    data["reputationData"] = $4f9333e8bb627a7e$var$getFactionReputationData(faction);
    // Get data for superstars/booking
    if (getSuperstarsInformation && factionSuperstars.length) {
        data["popularity"] = await (0, $ko5kE.getTagTeamPopularity)(faction, factionSuperstars);
        data["pronoun"] = factionSuperstars.every((x)=>x.pronoun === factionSuperstars[0].pronoun) ? factionSuperstars[0].pronoun : null;
        data["alignment"] = factionSuperstars.every((x)=>x.alignment === factionSuperstars[0].alignment) ? factionSuperstars[0].alignment : null;
        data["brandName"] = factionSuperstars.every((x)=>x.brandName === factionSuperstars[0].brandName) ? factionSuperstars[0].brandName : null;
        data["unhappy"] = factionSuperstars.some((x)=>x.unhappy);
        data["partTimer"] = factionSuperstars.every((x)=>x.partTimer);
        data["charisma"] = factionSuperstars.reduce((n, { charisma: charisma })=>n + charisma, 0) / factionSuperstars.length;
        data["workrate"] = factionSuperstars.reduce((n, { workrate: workrate })=>n + workrate, 0) / factionSuperstars.length;
        data["overness"] = factionSuperstars.reduce((n, { overness: overness })=>n + overness, 0) / factionSuperstars.length;
        data["age"] = factionSuperstars.reduce((n, { age: age })=>n + age, 0) / factionSuperstars.length;
        data["morale"] = factionSuperstars.reduce((n, { morale: morale })=>n + morale, 0) / factionSuperstars.length;
        data["fatigue"] = factionSuperstars.reduce((n, { fatigue: fatigue })=>n + fatigue, 0) / factionSuperstars.length;
    }
    return data;
}
async function $4f9333e8bb627a7e$var$getFactionSuperstarsData(faction, factionSuperstars, companyChampionships) {
    let data = [];
    const factionLeaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(faction);
    for (const superstar of factionSuperstars){
        // Get superstar championships
        const superstarChampionships = companyChampionships.filter((x)=>x.superstarId === superstar.$loki);
        superstarChampionships.sort((0, $kZwpB.compareChampionships));
        // Get data for superstar
        let d = {};
        d["name"] = superstar.name;
        d["championshipsNames"] = superstarChampionships.length > 0 ? (0, $1JSre.getChampionshipsDisplayName)(superstarChampionships, true, false, false) : null;
        d["leader"] = factionLeaderSuperstar ? superstar.$loki === factionLeaderSuperstar.$loki : false;
        d["fullTimeManager"] = superstar.fullTimeManager;
        data.push(d);
    }
    // Sort by leader first
    data.sort((a, b)=>b["leader"] - a["leader"]);
    return data;
}
async function $4f9333e8bb627a7e$var$getFactionGraphicsData(faction, factionSuperstars, companyChampionships) {
    let graphics = [];
    const factionLeaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(faction);
    let factionLeaderSuperstarGraphic;
    for (const superstar of factionSuperstars){
        // Get superstar's graphic
        let superstarGraphic = (0, $5kTkA.getGraphicForSuperstar)(superstar);
        // Add title graphic if superstar is champion
        const superstarChampionship = companyChampionships.find((x)=>x.superstarId === superstar.$loki);
        if (superstarChampionship && superstarGraphic) superstarGraphic["title"] = JSON.parse(JSON.stringify(superstarChampionship.graphic));
        graphics.push(superstarGraphic);
        // Set faction leader graphic if superstar is leader
        if (factionLeaderSuperstar && superstar.$loki === factionLeaderSuperstar.$loki) factionLeaderSuperstarGraphic = superstarGraphic;
    }
    // Move leader graphic to center position
    if (factionLeaderSuperstarGraphic) {
        const factionLeaderSuperstarIndex = graphics.indexOf(factionLeaderSuperstarGraphic);
        const centerIndex = Math.floor((graphics.length + 1) / 2) - 1;
        graphics.splice(factionLeaderSuperstarIndex, 1);
        graphics.splice(centerIndex, 0, factionLeaderSuperstarGraphic);
    }
    return graphics;
}
function $4f9333e8bb627a7e$var$getFactionReputationData(faction) {
    let data = {};
    data["reputation"] = faction.reputation;
    data["xp"] = faction.xp;
    if (faction.reputation < 10) {
        const xpToNextReputation = $4f9333e8bb627a7e$export$598ac26c4bbfbc07[faction.reputation];
        const xpToPreviousReputation = $4f9333e8bb627a7e$export$598ac26c4bbfbc07[faction.reputation - 1];
        data["xpToNextReputation"] = xpToNextReputation;
        data["progressPercentage"] = (faction.xp - xpToPreviousReputation) / (xpToNextReputation - xpToPreviousReputation) * 100;
    } else {
        data["xpToNextReputation"] = $4f9333e8bb627a7e$export$598ac26c4bbfbc07[faction.reputation - 1];
        data["progressPercentage"] = 100;
    }
    return data;
}
async function $4f9333e8bb627a7e$export$b45ffdf6d43944c7(roster) {
    const factions = (await (0, $dl5u4.getRosterFactions)(roster)).filter((x)=>!x.disbanded);
    factions.sort((a, b)=>b.reputation - a.reputation || b.xp - a.xp);
    return factions;
}
async function $4f9333e8bb627a7e$export$d8513f2b29233ed6({ factionUid: factionUid, checkBrandExclusivity: checkBrandExclusivity, excludeFactionSuperstars: excludeFactionSuperstars } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const currentEvent = await (0, $8A6FL.getCompanyLatestEvent)(selectedCompany);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    // Get faction
    let faction;
    if (factionUid) faction = await (0, $14eBR.Factions).get(factionUid);
    // Get faction superstars
    let factionSuperstars = faction && !excludeFactionSuperstars ? await (0, $2JFAd.getFactionSuperstars)(faction) : [];
    // Check for brand exclusive event
    let availableSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    if (checkBrandExclusivity) availableSuperstars = availableSuperstars.filter((x)=>(0, $5kTkA.checkSuperstarBrandAvailability)(currentEvent, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships)));
    // Get data for available superstars
    data["availableSuperstars"] = availableSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, factionSuperstars)).map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    data["availableSuperstars"].sort((a, b)=>a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    return data;
}
async function $4f9333e8bb627a7e$export$83d92d74cf8d5f05({ factionUid: factionUid } = {}) {
    let data = {};
    // Get faction
    let faction;
    if (factionUid) faction = await (0, $14eBR.Factions).get(factionUid);
    if (!faction) {
        data["error"] = "faction-not-found";
        return data;
    }
    // Get data for faction superstars
    data["factionSuperstars"] = (await (0, $2JFAd.getFactionSuperstars)(faction)).map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    return data;
}
async function $4f9333e8bb627a7e$export$c578a28e377fef0c(name, superstarUids, leaderSuperstarUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
    const rosterActiveFactions = await $4f9333e8bb627a7e$export$b45ffdf6d43944c7(mainRoster);
    const cost = 20;
    // Check if enough points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Check if faction already exists
    if (rosterActiveFactions.find((x)=>x.name === name)) {
        data["error"] = "already-present";
        return data;
    }
    // Check if team already exists
    if (rosterTagTeams.find((x)=>x.name === name)) {
        data["error"] = "team-already-present";
        return data;
    }
    // Get superstars
    let factionSuperstars = [];
    for (const superstarUid of superstarUids){
        let superstar = rosterSuperstars.find((x)=>x.$loki === superstarUid);
        // Check if superstar present and not in a faction
        if (!superstar) {
            data["error"] = "superstar-not-found";
            return data;
        }
        const superstarActiveFactions = await (0, $5kTkA.getSuperstarActiveFactions)(superstar);
        if (superstarActiveFactions.length > 0) {
            data["error"] = "already-in-faction";
            data["errorSuperstarName"] = superstar.name;
            return data;
        }
        factionSuperstars.push(superstar);
    }
    // Remove duplicates
    factionSuperstars = (0, $3E8Nt.getUniqueObjects)(factionSuperstars);
    // Get leader superstar
    let leaderSuperstar;
    if (leaderSuperstarUid) {
        leaderSuperstar = rosterSuperstars.find((x)=>x.$loki === leaderSuperstarUid);
        if (leaderSuperstar && !(0, $3E8Nt.objectInArray)(leaderSuperstar, factionSuperstars)) {
            data["error"] = "leader-superstar-not-present";
            return data;
        }
    }
    // Check if number of superstars are between 2 and maximum
    if (factionSuperstars.length < 2) {
        data["error"] = "minimum-superstars";
        return data;
    }
    if (factionSuperstars.length > (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
        data["error"] = "maximum-superstars";
        return data;
    }
    // Create faction and add to roster
    let reputationXpData = $4f9333e8bb627a7e$export$7fdeea148e00ef32(factionSuperstars, leaderSuperstar);
    const newFaction = await $4f9333e8bb627a7e$export$5f0dc2f57620b787(name, factionSuperstars, reputationXpData.reputation, reputationXpData.xp, leaderSuperstar);
    await (0, $dl5u4.addRosterFactions)(mainRoster, [
        newFaction
    ]);
    // Add company log
    const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, selectedCompany.realYear);
    await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
    newCompanyLog.text = newFaction.name;
    newCompanyLog.type = "new-faction";
    newCompanyLog.realYear = currentGame.year;
    await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
        newCompanyLog
    ]);
    // Check start faction request
    for (const factionSuperstar of factionSuperstars)await (0, $1olyO.checkTalentRequestAction)({
        company: selectedCompany,
        requestType: "start_faction",
        talent: factionSuperstar
    });
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["factionName"] = newFaction.name;
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(selectedCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
function $4f9333e8bb627a7e$export$7fdeea148e00ef32(factionSuperstars, leaderSuperstar = null) {
    // Add double weight for leader superstar
    factionSuperstars = [
        ...factionSuperstars
    ];
    if (leaderSuperstar) factionSuperstars.push(leaderSuperstar);
    // Get xp using popularity of faction superstars and hot/stale
    let totalXp = 0;
    for (const s of factionSuperstars){
        const popularity = s.popularity >= 0 ? s.popularity : 0;
        let xp = Math.pow(Math.floor(popularity / 110), 2.45);
        if (s.hot) xp += 30;
        if (s.stale) xp -= 30;
        xp = (0, $3E8Nt.limitValueBetweenRange)(xp, 0, 220);
        totalXp += xp;
    }
    let factionXp = Math.floor(totalXp / factionSuperstars.length);
    // Get reputation from xp
    let reputation = 1;
    for (const [index, factionReputationXp] of $4f9333e8bb627a7e$export$598ac26c4bbfbc07.entries())if (factionXp >= factionReputationXp) reputation = index + 1;
    return {
        reputation: reputation,
        xp: factionXp
    };
}
function $4f9333e8bb627a7e$export$c0feff3b6ef353b1(faction, xpChange) {
    // Update xp
    faction.xp += xpChange;
    faction.xpGainedThisYear += xpChange;
    if (faction.xp < 0) faction.xp = 0;
    // Update reputation
    for (const [index, factionReputationXp] of $4f9333e8bb627a7e$export$598ac26c4bbfbc07.entries())if (faction.xp >= factionReputationXp) faction.reputation = index + 1;
    // Get reputation data
    let data = $4f9333e8bb627a7e$var$getFactionReputationData(faction);
    data["xpChange"] = xpChange;
    data["factionName"] = faction.name;
    data["uid"] = faction.$loki;
    return data;
}
async function $4f9333e8bb627a7e$export$b367e26fcead7aae(factionUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get faction
    let faction = await (0, $14eBR.Factions).get(factionUid);
    if (!faction) {
        data["error"] = "faction-not-found";
        return data;
    }
    // Disband faction
    await $4f9333e8bb627a7e$export$9bad266ef22a65ff(faction, currentGame.monthCount, currentGame.year);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["factionName"] = faction.name;
    return data;
}
async function $4f9333e8bb627a7e$export$5b84ea98b0758424(factionUid, superstarUids) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Get faction
    let faction = await (0, $14eBR.Factions).get(factionUid);
    if (!faction) {
        data["error"] = "faction-not-found";
        return data;
    }
    // Get superstars to add
    const existingFactionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
    let superstarsToAdd = [];
    for (const superstarUid of superstarUids){
        let superstar = rosterSuperstars.find((x)=>x.$loki === superstarUid);
        // Check if superstar present and not in this or other faction
        if (!superstar) {
            data["error"] = "superstar-not-found";
            return data;
        }
        if ((0, $3E8Nt.objectInArray)(superstar, existingFactionSuperstars)) {
            data["error"] = "already-member-of-faction";
            data["errorSuperstarName"] = superstar.name;
            return data;
        }
        const superstarActiveFactions = await (0, $5kTkA.getSuperstarActiveFactions)(superstar);
        if (superstarActiveFactions.length > 0) {
            data["error"] = "already-in-faction";
            data["errorSuperstarName"] = superstar.name;
            return data;
        }
        superstarsToAdd.push(superstar);
    }
    // Remove duplicates
    superstarsToAdd = (0, $3E8Nt.getUniqueObjects)(superstarsToAdd);
    // Check if faction superstars are below maximum
    if (existingFactionSuperstars.length + superstarsToAdd.length > (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
        data["error"] = "maximum-superstars";
        return data;
    }
    // Lower faction reputation xp
    const xpChange = -20;
    $4f9333e8bb627a7e$export$c0feff3b6ef353b1(faction, xpChange);
    // Add faction superstars
    await $4f9333e8bb627a7e$var$addSuperstarsToFaction(faction, superstarsToAdd);
    // Check join faction request
    for (const superstarToAdd of superstarsToAdd){
        let requestData = {
            "factionId": faction.$loki
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: selectedCompany,
            requestType: "join_faction",
            talent: superstarToAdd,
            data: requestData
        });
    }
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["factionName"] = faction.name;
    data["xpChange"] = xpChange;
    data["addedSuperstarsNames"] = superstarsToAdd.map((x)=>x.name);
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(selectedCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $4f9333e8bb627a7e$export$683235c35fde060c(factionUid, superstarUids) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    // Get faction
    let faction = await (0, $14eBR.Factions).get(factionUid);
    if (!faction) {
        data["error"] = "faction-not-found";
        return data;
    }
    // Get superstars to remove
    const existingFactionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
    let superstarsToRemove = [];
    for (const superstarUid of superstarUids){
        let superstar = rosterSuperstars.find((x)=>x.$loki === superstarUid);
        // Check if superstar present and in this faction
        if (!superstar) {
            data["error"] = "superstar-not-found";
            return data;
        }
        if (!(0, $3E8Nt.objectInArray)(superstar, existingFactionSuperstars)) {
            data["error"] = "not-member-of-faction";
            data["errorSuperstarName"] = superstar.name;
            return data;
        }
        superstarsToRemove.push(superstar);
    }
    // Remove duplicates
    superstarsToRemove = (0, $3E8Nt.getUniqueObjects)(superstarsToRemove);
    // Check if faction superstars are above 2
    if (existingFactionSuperstars.length - superstarsToRemove.length < 2) {
        data["error"] = "minimum-superstars";
        return data;
    }
    // Lower faction reputation xp
    const xpChange = -20;
    $4f9333e8bb627a7e$export$c0feff3b6ef353b1(faction, xpChange);
    // Remove faction superstars
    await $4f9333e8bb627a7e$export$babc6ea551591eab(faction, superstarsToRemove);
    // Check leave faction request
    for (const superstarToRemove of superstarsToRemove){
        let requestData = {
            "factionId": faction.$loki
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: selectedCompany,
            requestType: "leave_faction",
            talent: superstarToRemove,
            data: requestData
        });
    }
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["factionName"] = faction.name;
    data["xpChange"] = xpChange;
    data["removedSuperstarsNames"] = superstarsToRemove.map((x)=>x.name);
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(selectedCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $4f9333e8bb627a7e$export$2e4791a6621590f7(factionUid) {
    let data = {};
    // Get faction
    let faction = await (0, $14eBR.Factions).get(factionUid);
    if (!faction) {
        data["error"] = "faction-not-found";
        return data;
    }
    // Check if faction leader present
    let leaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(faction);
    if (!leaderSuperstar) {
        data["error"] = "leader-not-present";
        return data;
    }
    // Lower faction reputation xp
    const xpChange = -10;
    $4f9333e8bb627a7e$export$c0feff3b6ef353b1(faction, xpChange);
    // Remove faction leader
    await $4f9333e8bb627a7e$export$bc6415e03e02d8e3(faction, leaderSuperstar);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["factionName"] = faction.name;
    data["xpChange"] = xpChange;
    data["removedLeaderSuperstarName"] = leaderSuperstar.name;
    return data;
}
async function $4f9333e8bb627a7e$export$78b76cb80de4c7f4(factionUid, leaderSuperstarUid) {
    let data = {};
    // Get faction
    let faction = await (0, $14eBR.Factions).get(factionUid);
    if (!faction) {
        data["error"] = "faction-not-found";
        return data;
    }
    // Get leader superstar
    let leaderSuperstar = await (0, $14eBR.Superstars).get(leaderSuperstarUid);
    if (!leaderSuperstar) {
        data["error"] = "leader-superstar-not-found";
        return data;
    }
    const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
    if (!(0, $3E8Nt.objectInArray)(leaderSuperstar, factionSuperstars)) {
        data["error"] = "not-member-of-faction";
        data["errorSuperstarName"] = leaderSuperstar.name;
        return data;
    }
    // Lower faction reputation xp
    const xpChange = -10;
    $4f9333e8bb627a7e$export$c0feff3b6ef353b1(faction, xpChange);
    // Set faction leader
    await (0, $2JFAd.setFactionLeaderSuperstar)(faction, leaderSuperstar);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["factionName"] = faction.name;
    data["xpChange"] = xpChange;
    data["leaderSuperstarName"] = leaderSuperstar.name;
    return data;
}
async function $4f9333e8bb627a7e$export$7448b3eec82d5dda() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const factions = await $4f9333e8bb627a7e$export$b45ffdf6d43944c7(mainRoster);
    data["factions"] = factions.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    return data;
}
async function $4f9333e8bb627a7e$export$d6c9dba3f4ce1aa4(faction, event, companyChampionships) {
    let factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
    return factionSuperstars.filter((x)=>(0, $5kTkA.checkAvailability)(x, true, true) && (0, $5kTkA.checkSuperstarBrandAvailability)(event, x, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships)));
}
async function $4f9333e8bb627a7e$export$4dcd402063b4c8d3({ superstar: superstar, championshipWon: championshipWon = null, championshipLost: championshipLost = null, overnessChange: overnessChange = null, fotcChange: fotcChange = null } = {}) {
    let factionReputationsData = [];
    // Process faction xp change for superstar's active factions
    const superstarFactions = await (0, $5kTkA.getSuperstarActiveFactions)(superstar);
    for (const faction of superstarFactions){
        const factionReputationData = await $4f9333e8bb627a7e$export$b57ebcdab978c06b({
            faction: faction,
            superstar: superstar,
            championshipWon: championshipWon,
            championshipLost: championshipLost,
            overnessChange: overnessChange,
            fotcChange: fotcChange
        });
        factionReputationsData.push(factionReputationData);
    }
    return factionReputationsData;
}
async function $4f9333e8bb627a7e$export$b57ebcdab978c06b({ faction: faction, superstar: superstar = null, championshipWon: championshipWon = null, championshipLost: championshipLost = null, overnessChange: overnessChange = null, fotcChange: fotcChange = null, addedMembers: addedMembers = null, removedMembers: removedMembers = null, feudWon: feudWon = null, feudLost: feudLost = null } = {}) {
    const xpChangeData = await $4f9333e8bb627a7e$var$getFactionXpChange(faction, superstar, championshipWon, championshipLost, overnessChange, fotcChange, addedMembers, removedMembers, feudWon, feudLost);
    const xpChange = xpChangeData["xpChange"];
    const data = $4f9333e8bb627a7e$export$c0feff3b6ef353b1(faction, xpChange);
    data["xpChangeDetails"] = xpChangeData;
    return data;
}
async function $4f9333e8bb627a7e$var$getFactionXpChange(faction, superstar = null, championshipWon = null, championshipLost = null, overnessChange = null, fotcChange = null, addedMembers = null, removedMembers = null, feudWon = null, feudLost = null) {
    const data = {};
    const leaderSuperstar = await (0, $2JFAd.getFactionLeaderSuperstar)(faction);
    // Check if leader present
    let isLeader = superstar && leaderSuperstar && superstar.$loki === leaderSuperstar.$loki;
    if (addedMembers && leaderSuperstar && (0, $3E8Nt.objectInArray)(leaderSuperstar, addedMembers)) isLeader = true;
    if (removedMembers && leaderSuperstar && (0, $3E8Nt.objectInArray)(leaderSuperstar, removedMembers)) isLeader = true;
    // Get xp change based on action
    if (championshipWon || championshipLost) {
        const championshipChangeData = $4f9333e8bb627a7e$var$getFactionXpChangeForChampionships(championshipWon, championshipLost, isLeader);
        if (championshipWon) data["championshipWon"] = championshipChangeData;
        else if (championshipLost) data["championshipLost"] = championshipChangeData;
    }
    if (overnessChange) {
        const overnessChangeData = $4f9333e8bb627a7e$var$getFactionXpChangeForSuperstarOverness(overnessChange, isLeader);
        if (overnessChange === "hot") data["hot"] = overnessChangeData;
        else if (overnessChange === "stale") data["stale"] = overnessChangeData;
    }
    if (fotcChange) {
        const fotcChangeData = $4f9333e8bb627a7e$var$getFactionXpChangeForFotcChange(fotcChange, isLeader);
        if (fotcChange === "becameFotc") data["becameFotc"] = fotcChangeData;
        if (fotcChange === "lostFotc") data["lostFotc"] = fotcChangeData;
    }
    if (addedMembers || removedMembers) {
        const membersChangeData = $4f9333e8bb627a7e$var$getFactionXpChangeForMembersChange(addedMembers, removedMembers, leaderSuperstar);
        if (addedMembers) data["addedMembers"] = membersChangeData;
        else if (removedMembers) data["removedMembers"] = membersChangeData;
    }
    if (feudWon || feudLost) {
        const feudChangeData = $4f9333e8bb627a7e$var$getFactionXpChangeForFeud(feudWon, feudLost);
        if (feudWon) data["feudWon"] = feudChangeData;
        else if (feudLost) data["feudLost"] = feudChangeData;
    }
    // Get total xp change
    data["xpChange"] = Object.values(data).reduce((total, xpChange)=>total + xpChange, 0);
    data["isLeader"] = isLeader;
    return data;
}
function $4f9333e8bb627a7e$var$getFactionXpChangeForChampionships(championshipWon, championshipLost, isLeader = false) {
    let xpChange = 0;
    const championshipWonPrestigeData = {
        "S": 40,
        "A": 30,
        "B": 18,
        "C": 10
    };
    const championshipLostPrestigeData = {
        "S": 35,
        "A": 25,
        "B": 15,
        "C": 8
    };
    if (championshipWon) xpChange += championshipWonPrestigeData[championshipWon.prestige] || 10;
    else if (championshipLost) xpChange -= championshipLostPrestigeData[championshipLost.prestige] || 8;
    if (isLeader) xpChange = Math.floor(xpChange * 1.25);
    return xpChange;
}
function $4f9333e8bb627a7e$var$getFactionXpChangeForSuperstarOverness(overnessChange, isLeader = false) {
    let xpChange = 0;
    if (overnessChange === "hot") xpChange = 20;
    if (overnessChange === "stale") xpChange = -20;
    if (isLeader) xpChange = Math.floor(xpChange * 1.25);
    return xpChange;
}
function $4f9333e8bb627a7e$var$getFactionXpChangeForFotcChange(fotcChange, isLeader = false) {
    let xpChange = 0;
    if (fotcChange === "becameFotc") xpChange = 30;
    if (fotcChange === "lostFotc") xpChange = -30;
    if (isLeader) xpChange = Math.floor(xpChange * 1.25);
    return xpChange;
}
function $4f9333e8bb627a7e$var$getFactionXpChangeForMembersChange(addedMembers, removedMembers, leaderSuperstar) {
    let xpChange = 0;
    // Get list of added and removed members
    let allMembers = [];
    if (addedMembers) allMembers.push(...addedMembers);
    if (removedMembers) allMembers.push(...removedMembers);
    for (let s of allMembers){
        let xp = Math.floor(Math.pow(s.popularity / 440, 5));
        if (s.hot) xp += 20;
        if (s.stale) xp -= 20;
        if (s.faceOfTheCompany) xp += 30;
        xp = (0, $3E8Nt.limitValueBetweenRange)(xp, -20, 100);
        if (leaderSuperstar && s.$loki === leaderSuperstar.$loki) xp = Math.floor(xp * 1.25);
        if (addedMembers && (0, $3E8Nt.objectInArray)(s, addedMembers)) xpChange += xp;
        else if (removedMembers && (0, $3E8Nt.objectInArray)(s, removedMembers)) {
            // Higher penalty for removed member
            if (xp > 0) xp = Math.floor(xp * 1.25);
            xpChange -= xp;
        }
    }
    return xpChange;
}
function $4f9333e8bb627a7e$var$getFactionXpChangeForFeud(feudWon = null, feudLost = null) {
    let xpChange = 0;
    if (feudWon) {
        xpChange += 15;
        let hypeBonus = Math.floor(feudWon.hype / 10);
        hypeBonus = (0, $3E8Nt.limitValueBetweenRange)(hypeBonus, -20, 20);
        xpChange += hypeBonus;
    } else if (feudLost) {
        xpChange -= 12;
        let hypeBonus = Math.floor(feudLost.hype / 12);
        hypeBonus = (0, $3E8Nt.limitValueBetweenRange)(hypeBonus, -16, 16);
        xpChange -= hypeBonus;
    }
    return xpChange;
}

});
parcelRequire.register("4K85d", function(module, exports) {

$parcel$export(module.exports, "CompanyLog", () => $3741ba6ffaa1bc0b$export$b0ca7d1f755c17a7);

var $14eBR = parcelRequire("14eBR");
function $3741ba6ffaa1bc0b$export$b0ca7d1f755c17a7(month, year) {
    // Integer
    const value = null;
    const realYear = null;
    // Strings
    const text = null;
    const type = null;
    const eventName = null;
    // Foreign keys
    const companyId = null;
    return {
        month: month,
        year: year,
        value: value,
        realYear: realYear,
        text: text,
        type: type,
        eventName: eventName,
        companyId: companyId
    };
}
function $3741ba6ffaa1bc0b$export$57e61a6650e0fdc(companyLog) {
    return (0, $14eBR.Companies).find({
        "$loki": companyLog.companyId
    })[0];
}

});

parcelRequire.register("1olyO", function(module, exports) {

$parcel$export(module.exports, "getCompanyTalentRequestsData", () => $1038c1d091f9de0a$export$7e3554cbcd7347ef);
$parcel$export(module.exports, "getTalentRequestData", () => $1038c1d091f9de0a$export$9ad417bc5921c65a);
$parcel$export(module.exports, "getTalentRequestName", () => $1038c1d091f9de0a$export$a369e8ec11240587);
$parcel$export(module.exports, "acceptTalentRequestView", () => $1038c1d091f9de0a$export$b3392ab2d1bb73ca);
$parcel$export(module.exports, "declineTalentRequestView", () => $1038c1d091f9de0a$export$d1ff4c3b419cc185);
$parcel$export(module.exports, "changeTalentRequestView", () => $1038c1d091f9de0a$export$898e5c59586e214d);
$parcel$export(module.exports, "checkTalentRequestAction", () => $1038c1d091f9de0a$export$a19a415715e07b25);
$parcel$export(module.exports, "processTalentRequests", () => $1038c1d091f9de0a$export$abe3b30e5174bde0);
$parcel$export(module.exports, "checkTalentRequestCreation", () => $1038c1d091f9de0a$export$33a8f7ab84a4e683);
$parcel$export(module.exports, "setupCreateTalentRequest", () => $1038c1d091f9de0a$export$b1dee221070a21e4);

var $14eBR = parcelRequire("14eBR");

var $9esFv = parcelRequire("9esFv");

var $cpTRW = parcelRequire("cpTRW");

var $knp8C = parcelRequire("knp8C");

var $3E8Nt = parcelRequire("3E8Nt");

var $hekDR = parcelRequire("hekDR");

var $8A6FL = parcelRequire("8A6FL");

var $5kTkA = parcelRequire("5kTkA");

var $6PzHO = parcelRequire("6PzHO");

var $5ZsVo = parcelRequire("5ZsVo");

var $hBIDz = parcelRequire("hBIDz");

var $dl5u4 = parcelRequire("dl5u4");

var $2JFAd = parcelRequire("2JFAd");

var $ivuOU = parcelRequire("ivuOU");

var $cXLSF = parcelRequire("cXLSF");

var $jDtEn = parcelRequire("jDtEn");

var $iRMwH = parcelRequire("iRMwH");

var $bZol7 = parcelRequire("bZol7");
async function $1038c1d091f9de0a$export$7e3554cbcd7347ef(company) {
    const companyTalentRequests = await (0, $9esFv.getCompanyTalentRequests)(company);
    let activeTalentRequests = companyTalentRequests.filter((x)=>[
            "created",
            "active"
        ].indexOf(x.status) >= 0);
    activeTalentRequests.sort((a, b)=>a.$loki - b.$loki);
    return Promise.all(activeTalentRequests.map((x)=>{
        return $1038c1d091f9de0a$export$9ad417bc5921c65a(x);
    }));
}
async function $1038c1d091f9de0a$export$9ad417bc5921c65a(talentRequest) {
    let data = {};
    const talent = await $1038c1d091f9de0a$var$getTalentRequestTalent(talentRequest);
    const changeAllowed = await $1038c1d091f9de0a$var$checkTalentRequestChangeAllowed(talentRequest, talent);
    data["talentName"] = talent.name;
    data["name"] = await $1038c1d091f9de0a$export$a369e8ec11240587(talentRequest);
    data["monthsRemaining"] = talentRequest.monthsRemaining;
    data["uid"] = talentRequest.$loki;
    data["talentUid"] = talent.$loki;
    data["talentType"] = talent.objectName;
    data["type"] = talentRequest.type;
    data["importance"] = (0, $knp8C.talentRequestsData)[talentRequest.type]["importance"];
    data["dialog"] = await $1038c1d091f9de0a$var$getTalentRequestDialog(talentRequest, talent);
    data["status"] = talentRequest.status;
    data["changeAllowed"] = changeAllowed;
    // Get graphic
    const topSuperstar = (0, $3E8Nt.getArrayMaxByProperty)(await (0, $5kTkA.getRosterMemberSuperstars)(talent), "popularity");
    let topSuperstarGraphic = topSuperstar.graphic;
    if (!topSuperstarGraphic || Object.keys(topSuperstarGraphic).length === 0) topSuperstarGraphic = (0, $5kTkA.getEmptySuperstarGraphic)(topSuperstar);
    data["graphic"] = [
        topSuperstarGraphic
    ];
    // Get responses
    data["responses"] = $1038c1d091f9de0a$var$getTalentRequestResponses(talentRequest);
    // Get change dialog
    data["changeDialog"] = $1038c1d091f9de0a$var$getTalentRequestChangeDialog(talentRequest, changeAllowed);
    return data;
}
async function $1038c1d091f9de0a$var$checkTalentRequestChangeAllowed(talentRequest, talent) {
    const rosterMemberSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
    const hasEasyToPleaseOrLoyalTrait = rosterMemberSuperstars.some((superstar)=>[
            "Easy To Please",
            "Loyal"
        ].some((trait)=>superstar.traits.includes(trait)));
    const hasHighMorale = rosterMemberSuperstars.some((superstar)=>superstar.morale >= 60);
    return (hasEasyToPleaseOrLoyalTrait || hasHighMorale) && !talentRequest.changedRequest;
}
function $1038c1d091f9de0a$var$getTalentRequestResponses(talentRequest) {
    const data = {};
    const talentRequestRandom = new Math.seedrandom(talentRequest.meta.created);
    data["acceptRequest"] = (0, $3E8Nt.getRandomChoice)((0, $knp8C.talentRequestCommonDialogs)["acceptRequest"], talentRequestRandom());
    data["declineRequest"] = (0, $3E8Nt.getRandomChoice)((0, $knp8C.talentRequestCommonDialogs)["declineRequest"], talentRequestRandom());
    data["changeRequest"] = (0, $3E8Nt.getRandomChoice)((0, $knp8C.talentRequestCommonDialogs)["changeRequest"], talentRequestRandom());
    return data;
}
function $1038c1d091f9de0a$var$getTalentRequestChangeDialog(talentRequest, changeAllowed) {
    const talentRequestRandom = new Math.seedrandom(talentRequest.meta.created);
    const changeDialogs = changeAllowed ? (0, $knp8C.talentRequestCommonDialogs)["changeAccepted"] : (0, $knp8C.talentRequestCommonDialogs)["changeDeclined"];
    return (0, $3E8Nt.getRandomChoice)(changeDialogs, talentRequestRandom());
}
async function $1038c1d091f9de0a$var$getTalentRequestDialog(talentRequest, talent = null, declined = false) {
    const talentRequestRandom = new Math.seedrandom(talentRequest.meta.created);
    let talentRequestData = (0, $knp8C.talentRequestsData)[talentRequest.type];
    let dialog;
    // Get talent request's creation dialog
    if ([
        "created",
        "active"
    ].includes(talentRequest.status)) {
        let talentName = null;
        let talentPronoun = null;
        let talentPossessive = null;
        let talentObjective = null;
        let teamName = null;
        let factionName = null;
        let championshipName = null;
        let brandName = null;
        let currentBrandName = null;
        let gimmickMatchName = null;
        let alignment = null;
        let currentAlignment = null;
        let skill = null;
        if (talentRequest.actionData["selectedTalentId"]) {
            let selectedTalent = await (0, $14eBR.Superstars).get(talentRequest.actionData["selectedTalentId"]);
            if (!selectedTalent) selectedTalent = await (0, $14eBR.TagTeams).get(talentRequest.actionData["selectedTalentId"]);
            talentName = selectedTalent.name;
            talentPronoun = selectedTalent.pronoun;
            talentPossessive = selectedTalent.possessivePronoun;
            talentObjective = selectedTalent.objectivePronoun;
        }
        if (talentRequest.actionData["selectedTeamId"]) {
            let team = await (0, $14eBR.TagTeams).get(talentRequest.actionData["selectedTeamId"]);
            if (team) teamName = team.name;
        }
        if (talentRequest.actionData["selectedFactionId"]) {
            let faction = await (0, $14eBR.Factions).get(talentRequest.actionData["selectedFactionId"]);
            if (faction) factionName = faction.name;
        }
        if (talentRequest.actionData["selectedChampionshipId"]) {
            let championship = await (0, $14eBR.Championships).get(talentRequest.actionData["selectedChampionshipId"]);
            if (championship) championshipName = championship.name;
        }
        if (talentRequest.actionData["selectedBrandId"]) {
            let brand = await (0, $14eBR.Brands).get(talentRequest.actionData["selectedBrandId"]);
            if (brand) brandName = brand.name;
            currentBrandName = (await (0, $5kTkA.getRosterMemberSuperstars)(talent))[0].brandName;
        }
        if (talentRequest.actionData["selectedGimmickMatchId"]) {
            let gimmickMatch = await (0, $14eBR.GimmickMatches).get(talentRequest.actionData["selectedGimmickMatchId"]);
            if (gimmickMatch) gimmickMatchName = gimmickMatch.name;
        }
        if (talentRequest.actionData["selectedAlignment"]) {
            alignment = talentRequest.actionData["selectedAlignment"];
            currentAlignment = talent.alignment;
        }
        if (talentRequest.actionData["selectedSkill"]) skill = talentRequest.actionData["selectedSkill"];
        let rank = talentRequest.actionData["selectedRank"];
        let rankIndefiniteArticle = rank === "Upper Midcarder" ? "an" : "a";
        let dialogChoice = (0, $3E8Nt.getRandomChoice)(talentRequestData.dialogs, talentRequestRandom());
        dialog = (0, $3E8Nt.formatStringWithParams)(dialogChoice, {
            rank: rank,
            rankIndefiniteArticle: rankIndefiniteArticle,
            talentName: talentName,
            teamName: teamName,
            factionName: factionName,
            championshipName: championshipName,
            talentPronoun: talentPronoun,
            talentPossessive: talentPossessive,
            talentObjective: talentObjective,
            brandName: brandName,
            gimmickMatchName: gimmickMatchName,
            alignment: alignment,
            currentAlignment: currentAlignment,
            currentBrandName: currentBrandName,
            skill: skill
        });
    } else if ([
        "completed",
        "failed"
    ].includes(talentRequest.status)) {
        let dialogs;
        if (declined) dialogs = (0, $knp8C.talentRequestCommonDialogs)["requestDeclined"][talentRequestData.importance];
        else if (talentRequest.status === "completed") dialogs = (0, $knp8C.talentRequestCommonDialogs)["requestCompleted"];
        else if (talentRequest.status === "failed") dialogs = (0, $knp8C.talentRequestCommonDialogs)["requestFailed"];
        dialog = (0, $3E8Nt.getRandomChoice)(dialogs, talentRequestRandom());
    }
    return dialog;
}
async function $1038c1d091f9de0a$export$b3392ab2d1bb73ca({ uid: uid } = {}) {
    let data = {};
    // Get talent request
    let talentRequest = await (0, $14eBR.TalentRequests).get(uid);
    if (!talentRequest) {
        data["error"] = "talent-request-not-found";
        return data;
    }
    // Accept talent request
    talentRequest.status = "active";
    (0, $14eBR.db).saveDatabase();
    // Get dialog
    data["dialog"] = await $1038c1d091f9de0a$var$getTalentRequestAcceptedDialog(talentRequest);
    return data;
}
function $1038c1d091f9de0a$var$getTalentRequestAcceptedDialog(talentRequest) {
    const talentRequestRandom = new Math.seedrandom(talentRequest.meta.created);
    return (0, $3E8Nt.getRandomChoice)((0, $knp8C.talentRequestCommonDialogs)["requestAccepted"], talentRequestRandom());
}
async function $1038c1d091f9de0a$export$d1ff4c3b419cc185({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get talent request
    let talentRequest = await (0, $14eBR.TalentRequests).get(uid);
    if (!talentRequest) {
        data["error"] = "talent-request-not-found";
        return data;
    }
    // Decline talent request
    await $1038c1d091f9de0a$var$declineTalentRequest(talentRequest, userCompany, currentGame);
    // Get dialog
    data["dialog"] = await $1038c1d091f9de0a$var$getTalentRequestDialog(talentRequest, null, true);
    // Delete request
    await (0, $14eBR.TalentRequests).remove(talentRequest);
    (0, $14eBR.db).saveDatabase();
    // Get unread messages
    let unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(userCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $1038c1d091f9de0a$var$declineTalentRequest(talentRequest, company, game) {
    talentRequest.status = "failed";
    let talent = await $1038c1d091f9de0a$var$getTalentRequestTalent(talentRequest);
    // Update morale
    let moraleChange = await $1038c1d091f9de0a$var$getTalentRequestMoraleChange(talentRequest, true);
    for (let superstar of (await (0, $5kTkA.getRosterMemberSuperstars)(talent)))(0, $5kTkA.updateSuperstarMorale)(superstar, moraleChange);
    // Add message
    let talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    let newMessage = await (0, $hekDR.createTalentRequestDeclinedMessage)(talentRequest, talent, moraleChange, game.monthCount, game.year, talentManager);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    return true;
}
async function $1038c1d091f9de0a$export$898e5c59586e214d({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    let championships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Get talent request
    let talentRequest = await (0, $14eBR.TalentRequests).get(uid);
    if (!talentRequest) {
        data["error"] = "talent-request-not-found";
        return data;
    }
    // Change talent request
    let newTalentRequest = await $1038c1d091f9de0a$var$changeTalentRequest(talentRequest, userCompany, rosterSuperstars, mainRoster, championships);
    (0, $14eBR.db).saveDatabase();
    // Get data for new talent request
    data["newTalentRequestData"] = await $1038c1d091f9de0a$export$9ad417bc5921c65a(newTalentRequest);
    return data;
}
async function $1038c1d091f9de0a$var$changeTalentRequest(talentRequest, company, rosterSuperstars, roster, championships) {
    let talent = await $1038c1d091f9de0a$var$getTalentRequestTalent(talentRequest);
    // Get new talent request data
    let requestObjects = await $1038c1d091f9de0a$var$getObjectsForChangeTalentRequest(talentRequest, talent, company, rosterSuperstars, roster, championships);
    let [requestType, requestMonths, actionData] = requestObjects;
    // Create changed talent request, add to company
    let newTalentRequest = await $1038c1d091f9de0a$var$createTalentRequest(talent, requestType, requestMonths, actionData);
    newTalentRequest.changedRequest = true;
    await (0, $9esFv.addCompanyTalentRequests)(company, [
        newTalentRequest
    ]);
    // Delete old request
    await (0, $14eBR.TalentRequests).remove(talentRequest);
    return newTalentRequest;
}
async function $1038c1d091f9de0a$var$getObjectsForChangeTalentRequest(talentRequest, talent, company, rosterSuperstars, roster, championships) {
    let actionData = {};
    let tagTeams = await (0, $dl5u4.getRosterTagTeams)(roster);
    let rosterFactions = await (0, $6PzHO.getRosterActiveFactions)(roster);
    // Get available superstars
    let superstars = rosterSuperstars.filter((x)=>(0, $5kTkA.checkAvailability)(x, true, false, false) && x.activeEffect !== "traded" && !x.fullTimeManager);
    // Get request type
    let requestType = await $1038c1d091f9de0a$var$getRequestTypeForChangeTalentRequest(talentRequest, talent, company, superstars, tagTeams, rosterFactions, championships, roster, rosterSuperstars);
    // Get action data, if applicable
    if ((0, $knp8C.talentRequestsData)[requestType]["get_action_data"]) {
        actionData = await $1038c1d091f9de0a$var$getActionDataForTalentRequest(requestType, talent, superstars, tagTeams, championships, roster, company);
        // If action data error, get from basic request types
        if (!actionData || Object.keys(actionData).length === 0) {
            if (talent.fullTimeManager) requestType = "solo_promo_segment";
            else requestType = (0, $3E8Nt.getRandomChoice)([
                "be_in_main_event",
                "solo_promo_segment"
            ]);
        }
    }
    // Get request months
    let requestMonths = (0, $3E8Nt.getRandomChoice)((0, $knp8C.talentRequestsData)[requestType]["months"]);
    return [
        requestType,
        requestMonths,
        actionData
    ];
}
async function $1038c1d091f9de0a$var$getRequestTypeForChangeTalentRequest(talentRequest, talent, company, superstars, teams, rosterFactions, championships, roster, rosterSuperstars) {
    // Go through all request types, add those that talent is eligible for
    let requestTypesWeights = [];
    let rarityWeights = {
        "common": 3.8,
        "normal": 3.5,
        "uncommon": 2.15,
        "rare": 1.25
    };
    for (let [requestType, v] of Object.entries((0, $knp8C.talentRequestsData)))if (requestType !== talentRequest.type && !(0, $knp8C.talentRequestsData)[talentRequest.type]["conflicting_requests"].includes(requestType) && (!talent.fullTimeManager || (0, $knp8C.talentRequestsData)[requestType]["allow_managers"])) {
        let addRequestType = false;
        if ([
            "be_in_main_event",
            "feud_with_x",
            "match_with_x",
            "solo_promo_segment",
            "change_appearance"
        ].includes(requestType)) addRequestType = true;
        if (requestType === "go_to_next_rank") {
            let nextRank = await (0, $5kTkA.getNextRank)(talent);
            if (nextRank) {
                let nextRankPopularity = {
                    "Main Eventer": 800,
                    "Upper Midcarder": 600,
                    "Lower Midcarder": 400
                };
                let popularityToNextRank = nextRankPopularity[nextRank] - talent.popularity;
                if (10 < popularityToNextRank && popularityToNextRank < 80) addRequestType = true;
            }
        }
        if ([
            "no_clean_loss",
            "beat_x_clean",
            "win_and_not_lose"
        ].includes(requestType)) {
            if ((0, $5kTkA.getRankFromPopularity)(talent.popularity) === "Main Eventer" || (await (0, $5kTkA.getRosterMemberSuperstars)(talent)).some((y)=>y.unhappy) || [
                "Rebel",
                "Hard To Please"
            ].some((y)=>talent.traits.includes(y))) addRequestType = true;
        }
        if (requestType === "put_x_over_clean") {
            if ([
                "Spotlight Lover",
                "Giving Veteran",
                "Star Maker"
            ].some((y)=>talent.traits.includes(y))) addRequestType = true;
        }
        if ([
            "be_in_title_match",
            "win_a_championship"
        ].includes(requestType)) {
            if (!championships.some((c)=>c.superstarId === talent.$loki)) addRequestType = true;
        }
        if (requestType === "lose_championship") {
            if (championships.some((c)=>c.superstarId === talent.$loki && !c.matchContract && !c.championshipContract)) {
                if ([
                    "Big Stage Wreck",
                    "Other Interests",
                    "Extreme Emotions"
                ].some((y)=>talent.traits.includes(y)) || (await (0, $5kTkA.getRosterMemberSuperstars)(talent)).some((y)=>y.contractMonthsRemaining)) addRequestType = true;
            }
        }
        if (requestType === "be_in_gimmick_match") {
            if ([
                "Risk Taker",
                "Gifted Acrobat",
                "Enjoys Gimmick Matches"
            ].some((y)=>talent.traits.includes(y))) addRequestType = true;
        }
        if (requestType === "team_with_x") {
            let superstarTagTeam = (await (0, $hBIDz.getSuperstarTagTeams)(talent)).find((y)=>!y.temporary);
            if (!superstarTagTeam) addRequestType = true;
        }
        if (requestType === "disband_team") {
            let superstarTagTeam = (await (0, $hBIDz.getSuperstarTagTeams)(talent)).find((y)=>!y.temporary);
            if (talent.hot && superstarTagTeam) addRequestType = true;
        }
        if (requestType === "write_off") {
            if (talent.partTimer || talent.traits.includes("Other Interests")) addRequestType = true;
        }
        if (requestType === "lose_next_match") {
            if (talent.winsCounter >= 2 && [
                "Giving Veteran",
                "Star Maker"
            ].some((y)=>talent.traits.includes(y))) addRequestType = true;
        }
        if (requestType === "beat_main_eventer") {
            if ((0, $5kTkA.getRankFromPopularity)(talent.popularity) === "Upper Midcarder") addRequestType = true;
        }
        if (requestType === "win_next_match") {
            if (talent.lossesCounter >= 2) addRequestType = true;
        }
        if (requestType === "be_managed") {
            if (!talent.managerId && !talent.fullTimeManager && talent.charisma <= 2) addRequestType = true;
        }
        if (requestType === "manage_x") {
            let managerIds = [
                ...new Set(superstars.filter((x)=>x.managerId).map((x)=>x.managerId))
            ];
            if (talent.fullTimeManager && talent.charisma >= 2 && !managerIds.includes(talent.$loki)) addRequestType = true;
        }
        if (requestType === "start_faction") {
            let rosterFactionSuperstars = (await Promise.all(rosterFactions.map((x)=>(0, $2JFAd.getFactionSuperstars)(x)))).flat();
            if (!(0, $3E8Nt.objectInArray)(talent, rosterFactionSuperstars)) addRequestType = true;
        }
        if (requestType === "leave_faction") {
            let rosterFactionSuperstars = (await Promise.all(rosterFactions.map((x)=>(0, $2JFAd.getFactionSuperstars)(x)))).flat();
            if (talent.hot && (0, $3E8Nt.objectInArray)(talent, rosterFactionSuperstars)) addRequestType = true;
        }
        if (requestType === "no_weekly_shows") {
            let game = await (0, $9esFv.getCompanyGame)(company);
            if (game.numberOfWeeklyShows !== 0 && (talent.partTimer || [
                "Other Interests",
                "Weekly Sloth"
            ].some((y)=>talent.traits.includes(y)))) addRequestType = true;
        }
        if (requestType === "customize_championship") {
            let game = await (0, $9esFv.getCompanyGame)(company);
            let superstarChampionships = championships.filter((c)=>c.superstarId === talent.$loki && !c.matchContract && !c.championshipContract);
            for (let c of superstarChampionships){
                let reign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
                if (reign.endMonth === null && (0, $3E8Nt.getMonthsDifference)(game.monthCount, game.year, reign.startMonth, reign.startYear) < 4) {
                    addRequestType = true;
                    break;
                }
            }
        }
        if (requestType === "change_alignment") {
            if (talent.alignment) addRequestType = true;
        }
        if (requestType === "debut_new_gimmick") {
            if (talent.overness < 40) addRequestType = true;
        }
        if (requestType === "vacate_championship") {
            if (championships.some((c)=>c.superstarId === talent.$loki && !c.matchContract && !c.championshipContract && !c.tagTeam && !c.trio) && ([
                "Rebel",
                "Hard To Please"
            ].some((y)=>talent.traits.includes(y)) || (await (0, $5kTkA.getRosterMemberSuperstars)(talent)).some((y)=>y.unhappy))) addRequestType = true;
        }
        if (requestType === "be_in_gimmick_match_x") {
            if ([
                "Risk Taker",
                "Gifted Acrobat",
                "Enjoys Gimmick Matches"
            ].some((y)=>talent.traits.includes(y)) || talent.traits.some((y)=>y.split(" ")[y.split(" ").length - 1] === "Expert")) addRequestType = true;
        }
        if (requestType === "join_faction") {
            let rosterFactionSuperstars = (await Promise.all(rosterFactions.map((x)=>(0, $2JFAd.getFactionSuperstars)(x)))).flat();
            if (rosterFactions.length > 0 && !(0, $3E8Nt.objectInArray)(talent, rosterFactionSuperstars)) addRequestType = true;
        }
        if (requestType === "change_brand") {
            let exclusiveRosterBrands = (await (0, $dl5u4.getRosterBrands)(roster)).filter((y)=>y.weeklyShowIsExclusive && y.name !== talent.brandName);
            if (exclusiveRosterBrands.length > 0 && talent.brandName) addRequestType = true;
        }
        if (requestType === "be_on_monthly_event") {
            // Check if talent not featured on last monthly event
            let latestHeldEvent = (await (0, $9esFv.getCompanyEvents)(company)).filter((x)=>x.rating !== null).sort((a, b)=>b.$loki - a.$loki)[0];
            let matchesAndSegments = await (0, $5ZsVo.getEventMatchesAndSegments)(latestHeldEvent);
            let superstarsUsedAtEvent = await (0, $5ZsVo.getSuperstarsUsedAtEvent)(matchesAndSegments, rosterSuperstars);
            if (!(0, $3E8Nt.objectInArray)(talent, superstarsUsedAtEvent) && (0, $5kTkA.checkSuperstarBrandAvailability)(latestHeldEvent, talent)) addRequestType = true;
        }
        if (requestType === "train_skill_x") {
            if ((0, $8A6FL.getAvailableStaffMembersByRole)(await (0, $9esFv.getCompanyStaff)(company), "trainer").some((x)=>!x.currentTask)) {
                if (talent.workrate < 3 || talent.charisma < 3) addRequestType = true;
            }
        }
        // Add request type with weights
        if (addRequestType) {
            let weight = rarityWeights[v.rarity];
            requestTypesWeights.push([
                requestType,
                weight
            ]);
        }
    }
    // Select request type
    return (0, $3E8Nt.weightedChoice)(requestTypesWeights);
}
async function $1038c1d091f9de0a$var$getTalentRequestTalent(talentRequest) {
    if (talentRequest.superstarId) return (0, $cpTRW.getTalentRequestSuperstar)(talentRequest);
    else return (0, $cpTRW.getTalentRequestTagTeam)(talentRequest);
}
async function $1038c1d091f9de0a$export$a369e8ec11240587(talentRequest) {
    let talentName = null;
    let teamName = null;
    let factionName = null;
    let championshipName = null;
    let brandName = null;
    let gimmickMatchName = null;
    let alignment = null;
    let skill = null;
    let rank = null;
    // Get action data objects
    if (talentRequest.actionData["selectedTalentId"]) {
        let talent = await (0, $14eBR.Superstars).get(talentRequest.actionData["selectedTalentId"]);
        if (!talent) talent = await (0, $14eBR.TagTeams).get(talentRequest.actionData["selectedTalentId"]);
        talentName = talent.name;
    }
    if (talentRequest.actionData["selectedTeamId"]) {
        let team = await (0, $14eBR.TagTeams).get(talentRequest.actionData["selectedTeamId"]);
        teamName = team.name;
    }
    if (talentRequest.actionData["selectedFactionId"]) {
        let faction = await (0, $14eBR.Factions).get(talentRequest.actionData["selectedFactionId"]);
        factionName = faction.name;
    }
    if (talentRequest.actionData["selectedChampionshipId"]) {
        let championship = await (0, $14eBR.Championships).get(talentRequest.actionData["selectedChampionshipId"]);
        championshipName = championship?.name;
    }
    if (talentRequest.actionData["selectedBrandId"]) {
        let brand = await (0, $14eBR.Brands).get(talentRequest.actionData["selectedBrandId"]);
        brandName = brand.name;
    }
    if (talentRequest.actionData["selectedGimmickMatchId"]) {
        let gimmickMatch = await (0, $14eBR.GimmickMatches).get(talentRequest.actionData["selectedGimmickMatchId"]);
        gimmickMatchName = gimmickMatch.name;
    }
    if (talentRequest.actionData["selectedAlignment"]) alignment = (0, $3E8Nt.toTitleCase)(talentRequest.actionData["selectedAlignment"]);
    if (talentRequest.actionData["selectedSkill"]) skill = (0, $3E8Nt.toTitleCase)(talentRequest.actionData["selectedSkill"]);
    if (talentRequest.actionData["selectedRank"]) rank = (0, $3E8Nt.toTitleCase)(talentRequest.actionData["selectedRank"]);
    // Format name using objects
    const talentRequestNameData = (0, $knp8C.talentRequestsData)[talentRequest.type]["name"];
    return (0, $3E8Nt.formatStringWithParams)(talentRequestNameData, {
        talentName: talentName,
        teamName: teamName,
        factionName: factionName,
        championshipName: championshipName,
        brandName: brandName,
        gimmickMatchName: gimmickMatchName,
        alignment: alignment,
        skill: skill,
        rank: rank
    });
}
async function $1038c1d091f9de0a$export$a19a415715e07b25({ company: company, requestType: requestType, talent: talent, data: data = null, secondaryAction: secondaryAction = false, failRequest: failRequest = false } = {}) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Get talent request from company's talent requests
    const companyTalentRequests = (await (0, $9esFv.getCompanyTalentRequests)(company)).filter((x)=>[
            "created",
            "active"
        ].includes(x.status) && x.type === requestType);
    let talentRequest;
    for (const x of companyTalentRequests){
        let t = await $1038c1d091f9de0a$var$getTalentRequestTalent(x);
        if (t.objectName === talent.objectName && t.$loki === talent.$loki) {
            talentRequest = x;
            break;
        }
    }
    // Check result of talent request
    if (talentRequest) {
        let completed = false;
        let failed = false;
        if ([
            "be_in_main_event",
            "win_a_championship",
            "be_in_gimmick_match",
            "write_off",
            "change_appearance",
            "beat_main_eventer",
            "solo_promo_segment",
            "be_in_title_match",
            "be_managed",
            "start_faction",
            "debut_new_gimmick",
            "be_on_monthly_event"
        ].includes(requestType)) completed = true;
        if ([
            "put_x_over_clean",
            "feud_with_x",
            "team_with_x",
            "beat_x_clean",
            "match_with_x",
            "manage_x"
        ].includes(requestType)) {
            if (data["talentId"] === talentRequest.actionData["selectedTalentId"]) completed = true;
        }
        if ([
            "lose_championship",
            "customize_championship"
        ].includes(requestType)) {
            if (data["championshipId"] === talentRequest.actionData["selectedChampionshipId"]) completed = true;
        }
        if (requestType === "go_to_next_rank") {
            if (data["reachedRank"] === talentRequest.actionData["selectedRank"]) completed = true;
        }
        if (requestType === "disband_team") {
            if (data["teamId"] === talentRequest.actionData["selectedTeamId"]) completed = true;
        }
        if ([
            "leave_faction",
            "join_faction"
        ].includes(requestType)) {
            if (data["factionId"] === talentRequest.actionData["selectedFactionId"]) completed = true;
        }
        if ([
            "no_clean_loss",
            "no_weekly_shows"
        ].includes(requestType)) {
            if (failRequest) failed = true;
        }
        if (requestType === "win_and_not_lose") {
            if (secondaryAction) talentRequest.actionCompleted = true;
            else if (failRequest) failed = true;
        }
        if (requestType === "change_alignment") {
            if (data["alignment"] === talentRequest.actionData["selectedAlignment"]) completed = true;
        }
        if (requestType === "be_in_gimmick_match_x") {
            if (data["gimmickMatchId"] === talentRequest.actionData["selectedGimmickMatchId"]) completed = true;
        }
        if (requestType === "change_brand") {
            if (data["brandId"] === talentRequest.actionData["selectedBrandId"]) completed = true;
        }
        if (requestType === "vacate_championship") {
            if (data["championshipId"] === talentRequest.actionData["selectedChampionshipId"]) {
                if (failRequest) // Lost championship
                failed = true;
                else completed = true;
            }
        }
        if (requestType === "train_skill_x") {
            if (data["skill"] === talentRequest.actionData["selectedSkill"]) completed = true;
        }
        if ([
            "win_next_match",
            "lose_next_match"
        ].includes(requestType)) {
            if (failRequest) failed = true;
            else completed = true;
        }
        // Complete/fail request
        if (completed) await $1038c1d091f9de0a$var$completeTalentRequest(talentRequest, company, game);
        else if (failed) await $1038c1d091f9de0a$var$failTalentRequest(talentRequest, company, game);
    }
    return talentRequest;
}
async function $1038c1d091f9de0a$var$completeTalentRequest(talentRequest, company, game) {
    talentRequest.status = "completed";
    const talent = await $1038c1d091f9de0a$var$getTalentRequestTalent(talentRequest);
    const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    // Add company alert
    const talentRequestText = `${talent.name} (${await $1038c1d091f9de0a$export$a369e8ec11240587(talentRequest)})`;
    const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("talentRequestCompleted", talentRequestText);
    await (0, $9esFv.addCompanyCompanyAlerts)(company, [
        newCompanyAlert
    ]);
    // Update morale
    const moraleChange = await $1038c1d091f9de0a$var$getTalentRequestMoraleChange(talentRequest);
    for (const superstar of (await (0, $5kTkA.getRosterMemberSuperstars)(talent)))(0, $5kTkA.updateSuperstarMorale)(superstar, moraleChange);
    // Add actions completed (Superstars Reassured)
    await (0, $8A6FL.checkFacilityUpgrade)("Talent Management", company);
    // Add talent manager xp
    let xpGained = 0;
    if (talentManager) {
        xpGained = 8;
        const ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(talentManager);
        xpGained = Math.round(xpGained * ageMultiplier);
        await (0, $8A6FL.updateStaffMemberXp)(talentManager, xpGained, company, game);
    }
    // Add message
    const newMessage = await (0, $hekDR.createTalentRequestSucceededMessage)(talentRequest, talent, moraleChange, game.monthCount, game.year, talentManager, xpGained);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Add to user's talent requests completed
    const user = (0, $bZol7.loadUser)();
    if (user && !user.talentRequestTypesCompleted.includes(talentRequest.type)) {
        user.talentRequestTypesCompleted.push(talentRequest.type);
        (0, $bZol7.saveUser)(user);
    }
    return true;
}
async function $1038c1d091f9de0a$var$failTalentRequest(talentRequest, company, game) {
    talentRequest.status = "failed";
    const talent = await $1038c1d091f9de0a$var$getTalentRequestTalent(talentRequest);
    const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    // Add company alert
    const talentRequestText = `${talent.name} (${await $1038c1d091f9de0a$export$a369e8ec11240587(talentRequest)})`;
    const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("talentRequestFailed", talentRequestText);
    await (0, $9esFv.addCompanyCompanyAlerts)(company, [
        newCompanyAlert
    ]);
    // Update morale
    const moraleChange = await $1038c1d091f9de0a$var$getTalentRequestMoraleChange(talentRequest);
    for (const superstar of (await (0, $5kTkA.getRosterMemberSuperstars)(talent)))(0, $5kTkA.updateSuperstarMorale)(superstar, moraleChange);
    // Add message
    const newMessage = await (0, $hekDR.createTalentRequestFailedMessage)(talentRequest, talent, moraleChange, game.monthCount, game.year, talentManager);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    return true;
}
async function $1038c1d091f9de0a$var$getTalentRequestMoraleChange(talentRequest, declined = false) {
    const talent = await $1038c1d091f9de0a$var$getTalentRequestTalent(talentRequest);
    // Morale change depends on traits
    let moraleChange = 0;
    const superstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
    if (talentRequest.status === "failed") {
        if (superstars.some((x)=>x.traits.includes("Easy To Please") || x.traits.includes("Loyal"))) moraleChange = (0, $3E8Nt.getRandomInt)(-14, -12);
        else if (superstars.some((x)=>x.traits.includes("Hard To Please") || x.traits.includes("Rebel"))) moraleChange = (0, $3E8Nt.getRandomInt)(-22, -20);
        else moraleChange = (0, $3E8Nt.getRandomInt)(-18, -16);
    } else if (talentRequest.status === "completed") {
        if (superstars.some((x)=>x.traits.includes("Easy To Please") || x.traits.includes("Loyal"))) moraleChange = (0, $3E8Nt.getRandomInt)(16, 18);
        else if (superstars.some((x)=>x.traits.includes("Hard To Please") || x.traits.includes("Rebel"))) moraleChange = (0, $3E8Nt.getRandomInt)(8, 10);
        else moraleChange = (0, $3E8Nt.getRandomInt)(12, 14);
    }
    // Increase change for major requests
    if ((0, $knp8C.talentRequestsData)[talentRequest.type]["importance"] === "major") moraleChange = Math.round(moraleChange * 1.4);
    // Decrease change for declined requests
    if (declined) moraleChange = Math.round(moraleChange * 0.85);
    return moraleChange;
}
async function $1038c1d091f9de0a$export$abe3b30e5174bde0(company, weeklyShow) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    // Process created/active requests
    let currentTalentRequests = (await (0, $9esFv.getCompanyTalentRequests)(company)).filter((x)=>[
            "created",
            "active"
        ].includes(x.status));
    for (let talentRequest of currentTalentRequests){
        // Set active status
        if (talentRequest.status === "created") talentRequest.status = "active";
        // Decrease months remaining
        if (!weeklyShow) {
            if (talentRequest.monthsRemaining > 0) talentRequest.monthsRemaining -= 1;
        }
        // Check for end
        if (talentRequest.monthsRemaining <= 0) {
            // Complete request if negative request and secondary action completed (if present)
            if ((0, $knp8C.talentRequestsData)[talentRequest.type]["negative_request"] && (!(0, $knp8C.talentRequestsData)[talentRequest.type]["secondary_action"] || talentRequest.actionCompleted)) await $1038c1d091f9de0a$var$completeTalentRequest(talentRequest, company, game);
            else // Otherwise fail request
            await $1038c1d091f9de0a$var$failTalentRequest(talentRequest, company, game);
        }
    }
    return true;
}
async function $1038c1d091f9de0a$export$33a8f7ab84a4e683(company, rosterSuperstars, roster, championships) {
    let requestsToAdd = 0;
    let companyTalentRequests = (await (0, $9esFv.getCompanyTalentRequests)(company)).filter((x)=>[
            "created",
            "active"
        ].includes(x.status));
    // Don't have more than maxRequests at a time
    let maxRequests = 5;
    if (companyTalentRequests.length < maxRequests) {
        let requestsToAddWeights = [
            [
                0,
                30
            ],
            [
                1,
                50
            ],
            [
                2,
                15
            ],
            [
                3,
                5
            ]
        ];
        let maxRequestsToAdd = maxRequests - companyTalentRequests.length;
        requestsToAddWeights = requestsToAddWeights.filter((x)=>x[0] <= maxRequestsToAdd);
        requestsToAdd = (0, $3E8Nt.weightedChoice)(requestsToAddWeights);
    }
    // Add requests
    for (let x of Array(requestsToAdd).keys()){
        let newTalentRequest = await $1038c1d091f9de0a$var$addTalentRequest(company, companyTalentRequests, rosterSuperstars, roster, championships);
        if (newTalentRequest) companyTalentRequests.push(newTalentRequest);
    }
    return true;
}
async function $1038c1d091f9de0a$var$addTalentRequest(company, companyTalentRequests, rosterSuperstars, roster, championships) {
    let talent = null;
    let requestMonths;
    let actionData;
    let requestType;
    // Get request type, talent and months
    let count = 0;
    while(talent === null && count < 5){
        requestType = $1038c1d091f9de0a$var$selectTalentRequestType();
        let requestObjects = await $1038c1d091f9de0a$var$getObjectsForTalentRequest(requestType, company, companyTalentRequests, rosterSuperstars, roster, championships);
        talent = requestObjects[0];
        requestMonths = requestObjects[1];
        actionData = requestObjects[2];
        count += 1;
    }
    if (!talent) return null;
    // Create talent request, add to company
    let newTalentRequest = await $1038c1d091f9de0a$var$createTalentRequest(talent, requestType, requestMonths, actionData);
    await (0, $9esFv.addCompanyTalentRequests)(company, [
        newTalentRequest
    ]);
    return newTalentRequest;
}
function $1038c1d091f9de0a$var$selectTalentRequestType() {
    let requestTypesWeights = [];
    let rarityWeights = {
        "common": 3.8,
        "normal": 3.5,
        "uncommon": 2.15,
        "rare": 1.25
    };
    for(let k in 0, $knp8C.talentRequestsData){
        let weight = rarityWeights[(0, $knp8C.talentRequestsData)[k]["rarity"]];
        requestTypesWeights.push([
            k,
            weight
        ]);
    }
    return (0, $3E8Nt.weightedChoice)(requestTypesWeights);
}
async function $1038c1d091f9de0a$var$createTalentRequest() {
    return;
}
function $1038c1d091f9de0a$export$b1dee221070a21e4(newFunction) {
    $1038c1d091f9de0a$var$createTalentRequest = newFunction;
}
async function $1038c1d091f9de0a$var$getObjectsForTalentRequest(requestType, company, companyTalentRequests, rosterSuperstars, roster, championships) {
    let actionData = {};
    let tagTeams = await (0, $dl5u4.getRosterTagTeams)(roster);
    let talentRequestData = (0, $knp8C.talentRequestsData)[requestType];
    // Get available superstars
    let superstars = rosterSuperstars.filter((x)=>(0, $5kTkA.checkAvailability)(x, true, false, false) && x.activeEffect !== "traded");
    // Check if request allows managers
    if (!talentRequestData["allow_managers"]) superstars = superstars.filter((x)=>!x.fullTimeManager);
    // Remove superstars that already have a talent request of this type or have a conflicting request
    for (let talentRequest of companyTalentRequests)if (requestType === talentRequest.type || (0, $knp8C.talentRequestsData)[talentRequest.type]["conflicting_requests"].includes(requestType)) {
        let talentRequestTalent = await $1038c1d091f9de0a$var$getTalentRequestTalent(talentRequest);
        let talentRequestTalentSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talentRequestTalent);
        superstars = superstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, talentRequestTalentSuperstars));
    }
    // Get talent
    let talent = await $1038c1d091f9de0a$var$getTalentForTalentRequest(requestType, company, superstars, tagTeams, roster, championships, rosterSuperstars);
    // Get action data if talent found
    if (talent && talentRequestData["get_action_data"]) {
        actionData = await $1038c1d091f9de0a$var$getActionDataForTalentRequest(requestType, talent, superstars, tagTeams, championships, roster, company);
        // If action data error, don't set talent
        if (!actionData || Object.keys(actionData).length === 0) talent = null;
    }
    let requestMonths = (0, $3E8Nt.getRandomChoice)(talentRequestData["months"]);
    return [
        talent,
        requestMonths,
        actionData
    ];
}
async function $1038c1d091f9de0a$var$getTalentForTalentRequest(requestType, company, superstars, teams, roster, championships, rosterSuperstars) {
    // Can return None if no talent found
    let talent = null;
    try {
        if (requestType === "be_in_main_event") {
            let weights = [];
            for (let x of superstars){
                let weight = 1;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 20;
                if ([
                    "Spotlight Lover",
                    "Rebel",
                    "Hard To Please"
                ].some((y)=>x.traits.includes(y))) weight += 40;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Upper Midcarder") weight *= 3;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Jabroni") weight *= 0.25;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "go_to_next_rank") {
            let weights = [];
            for (let x of superstars){
                let nextRank = await (0, $5kTkA.getNextRank)(x);
                if (nextRank) {
                    let nextRankPopularity = {
                        "Main Eventer": 800,
                        "Upper Midcarder": 600,
                        "Lower Midcarder": 400
                    };
                    let popularityToNextRank = nextRankPopularity[nextRank] - x.popularity;
                    if (10 < popularityToNextRank && popularityToNextRank < 80) {
                        let weight = 1;
                        if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 10;
                        if ([
                            "Spotlight Lover",
                            "Rebel",
                            "Hard To Please"
                        ].some((y)=>x.traits.includes(y))) weight += 10;
                        weights.push([
                            x,
                            weight
                        ]);
                    }
                }
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "no_clean_loss") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 25;
                if ([
                    "Rebel",
                    "Hard To Please"
                ].some((y)=>x.traits.includes(y))) weight += 50;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Main Eventer") {
                    weight *= 2;
                    if (x.faceOfTheCompany) weight *= 2;
                } else weight *= 0.1;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "put_x_over_clean") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if ([
                    "Spotlight Lover",
                    "Giving Veteran",
                    "Star Maker"
                ].some((y)=>x.traits.includes(y))) weight += 50;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "feud_with_x") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if (x.traits.includes("Storyteller")) weight += 20;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "team_with_x") {
            let weights = [];
            for (let x of superstars){
                let superstarTagTeam = (await (0, $hBIDz.getSuperstarTagTeams)(x)).find((y)=>!y.temporary);
                if (!superstarTagTeam) {
                    let weight = 0.1;
                    if (x.traits.includes("Tag Team Specialist")) weight += 20;
                    weights.push([
                        x,
                        weight
                    ]);
                }
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "disband_team") {
            let weights = [];
            for (let x of superstars){
                let superstarTagTeam = (await (0, $hBIDz.getSuperstarTagTeams)(x)).find((y)=>!y.temporary);
                if (superstarTagTeam) {
                    let weight = 1;
                    if (x.hot) weight += 10;
                    weights.push([
                        x,
                        weight
                    ]);
                }
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "change_appearance") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if (x.stale) weight += 5;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "lose_next_match") {
            let weights = [];
            for (let x of superstars)if (x.winsCounter >= 2) {
                let weight = 0.1;
                if (x.winsCounter >= 5) weight += 5;
                if ([
                    "Rebel",
                    "Hard To Please"
                ].some((y)=>x.traits.includes(y))) weight *= 0.1;
                if ([
                    "Giving Veteran",
                    "Star Maker"
                ].some((y)=>x.traits.includes(y))) weight += 10;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "beat_main_eventer") {
            let weights = [];
            for (let x of superstars){
                let weight = 1;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 10;
                if ([
                    "Spotlight Lover",
                    "Rebel",
                    "Hard To Please"
                ].some((y)=>x.traits.includes(y))) weight += 10;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Upper Midcarder") weight *= 4;
                if ([
                    "Main Eventer",
                    "Jabroni"
                ].includes((0, $5kTkA.getRankFromPopularity)(x.popularity))) weight *= 0.1;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "beat_x_clean") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if ([
                    "Rebel",
                    "Hard To Please"
                ].some((y)=>x.traits.includes(y))) weight += 25;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Main Eventer") {
                    weight *= 2;
                    if (x.faceOfTheCompany) weight *= 2;
                } else weight *= 0.1;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "win_and_not_lose") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 20;
                if ([
                    "Rebel",
                    "Hard To Please"
                ].some((y)=>x.traits.includes(y))) weight += 20;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Main Eventer") {
                    weight *= 2;
                    if (x.faceOfTheCompany) weight *= 2;
                } else weight *= 0.1;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "win_next_match") {
            let weights = [];
            for (let x of superstars)if (x.lossesCounter >= 2) {
                let weight = 0.1;
                if (x.lossesCounter >= 5) weight += 4;
                if ([
                    "Easy To Please",
                    "Loyal"
                ].some((y)=>x.traits.includes(y))) weight *= 0.5;
                if ([
                    "Rebel",
                    "Hard To Please"
                ].some((y)=>x.traits.includes(y))) weight += 8;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "be_managed") {
            let weights = [];
            for (let x of superstars)if (!x.managerId && !x.fullTimeManager && x.charisma <= 2) {
                let weight = 0.1;
                if (x.charisma <= 1) weight *= 2;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "manage_x") {
            let weights = [];
            let managerIds = [
                ...new Set(superstars.filter((x)=>x.managerId).map((x)=>x.managerId))
            ];
            for (let x of superstars)if (x.charisma >= 2 && !managerIds.includes(x.$loki)) {
                let weight = 0.1;
                if (x.fullTimeManager) weight += 15;
                if (x.charisma >= 3) weight *= 3;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "start_faction") {
            let weights = [];
            let rosterFactions = await (0, $6PzHO.getRosterActiveFactions)(roster);
            let rosterFactionSuperstars = (await Promise.all(rosterFactions.map((x)=>(0, $2JFAd.getFactionSuperstars)(x)))).flat();
            for (let x of superstars)if (!(0, $3E8Nt.objectInArray)(x, rosterFactionSuperstars)) {
                let weight = 0.1;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Upper Midcarder") weight *= 3;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Jabroni") weight *= 0.2;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "leave_faction") {
            let weights = [];
            let rosterFactions = await (0, $6PzHO.getRosterActiveFactions)(roster);
            let rosterFactionSuperstars = (await Promise.all(rosterFactions.map((x)=>(0, $2JFAd.getFactionSuperstars)(x)))).flat();
            for (let x of superstars)if ((0, $3E8Nt.objectInArray)(x, rosterFactionSuperstars)) {
                let weight = 1;
                if (x.hot) weight += 5;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "be_in_title_match") {
            let weights = [];
            for (let x of superstars)if (!championships.some((c)=>c.superstarId === x.$loki)) {
                let weight = 1;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 10;
                if (x.traits.includes("Spotlight Lover")) weight += 20;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Upper Midcarder") weight *= 3;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Jabroni") weight *= 0.1;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "match_with_x") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if (x.workrate >= 3) weight += 10;
                if (x.traits.includes("Ring General") || x.traits.includes("Workhorse")) weight += 20;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "solo_promo_segment") {
            let weights = [];
            for (let x of superstars){
                let weight = 1;
                if (x.traits.includes("Spotlight Lover")) weight *= 5;
                if ([
                    "Main Eventer",
                    "Jabroni"
                ].includes((0, $5kTkA.getRankFromPopularity)(x.popularity)) || x.hot) weight *= 0.5;
                if (x.charisma === 2) weight *= 5;
                if (await (0, $3E8Nt.getRosterMemberAge)(x) < 35) weight *= 3;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "no_weekly_shows") {
            let game = await (0, $9esFv.getCompanyGame)(company);
            if (game.numberOfWeeklyShows !== 0) {
                let weights = [];
                for (let x of superstars){
                    let weight = 0.1;
                    if (x.partTimer) weight += 20;
                    if (x.traits.includes("Other Interests") || x.traits.includes("Weekly Sloth")) weight += 40;
                    weights.push([
                        x,
                        weight
                    ]);
                }
                talent = (0, $3E8Nt.weightedChoice)(weights);
            }
        }
        if (requestType === "customize_championship") {
            let game = await (0, $9esFv.getCompanyGame)(company);
            let weights = [];
            for (let x of superstars){
                let superstarChampionships = championships.filter((c)=>c.superstarId === x.$loki && !c.matchContract && !c.championshipContract);
                for (let c of superstarChampionships){
                    let reign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
                    if (reign.endMonth === null && (0, $3E8Nt.getMonthsDifference)(game.monthCount, game.year, reign.startMonth, reign.startYear) < 4) {
                        weights.push([
                            x,
                            1
                        ]);
                        break;
                    }
                }
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "change_alignment") {
            let weights = [];
            for (let x of superstars)if (x.alignment) {
                let weight = 1 + x.alignmentMonths;
                if (x.alignmentMonths >= 12) weight *= 10;
                if (x.traits.includes("Natural Babyface") && x.alignment === "heel") weight *= 40;
                if (x.traits.includes("Natural Heel") && x.alignment === "face") weight *= 40;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "debut_new_gimmick") {
            let weights = [];
            for (let x of superstars)if (x.overness < 40) {
                let weight = 1;
                if (x.stale) weight += 15;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "vacate_championship") {
            let weights = [];
            for (let x of superstars)if (championships.some((c)=>c.superstarId === x.$loki && !c.matchContract && !c.championshipContract && !c.tagTeam && !c.trio)) {
                let weight = 1;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 25;
                if (x.traits.includes("Rebel") || x.traits.includes("Hard To Please")) weight += 75;
                if (x.faceOfTheCompany) weight *= 5;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "be_in_gimmick_match_x") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if ([
                    "Risk Taker",
                    "Gifted Acrobat",
                    "Enjoys Gimmick Matches"
                ].some((y)=>x.traits.includes(y)) || x.traits.some((y)=>y.split(" ")[y.split(" ").length - 1] === "Expert")) weight += 30;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "join_faction") {
            let weights = [];
            let rosterFactions = await (0, $6PzHO.getRosterActiveFactions)(roster);
            let rosterFactionSuperstars = (await Promise.all(rosterFactions.map((x)=>(0, $2JFAd.getFactionSuperstars)(x)))).flat();
            for (let x of superstars)if (!(0, $3E8Nt.objectInArray)(x, rosterFactionSuperstars)) {
                let weight = 1;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Upper Midcarder") weight *= 3;
                if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Jabroni") weight *= 0.2;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "change_brand") {
            let weights = [];
            for (let x of superstars)if (x.brandName) {
                let weight = 1;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 5;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "win_a_championship") {
            let weights = [];
            for (let x of superstars)if (!championships.some((c)=>c.superstarId === x.$loki)) {
                let weight = 0.1;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 50;
                if ([
                    "Rebel",
                    "Hard To Please"
                ].some((y)=>x.traits.includes(y))) weight += 25;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "lose_championship") {
            let weights = [];
            for (let x of superstars)if (championships.some((c)=>c.superstarId === x.$loki && !c.matchContract && !c.championshipContract)) {
                let weight = 1;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.unhappy)) weight += 15;
                if ((await (0, $5kTkA.getRosterMemberSuperstars)(x)).some((y)=>y.contractMonthsRemaining)) weight += 30;
                if ([
                    "Big Stage Wreck",
                    "Other Interests",
                    "Extreme Emotions"
                ].some((y)=>x.traits.includes(y))) weight += 30;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "be_in_gimmick_match") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if ([
                    "Risk Taker",
                    "Gifted Acrobat",
                    "Enjoys Gimmick Matches"
                ].some((y)=>x.traits.includes(y))) weight += 30;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "write_off") {
            let weights = [];
            for (let x of superstars){
                let weight = 0.1;
                if (x.partTimer) weight += 15;
                if (x.traits.includes("Other Interests")) weight += 50;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "be_on_monthly_event") {
            // Get superstars used at latest monthly event
            let latestHeldEvent = (await (0, $9esFv.getCompanyEvents)(company)).filter((x)=>x.rating !== null).sort((a, b)=>b.$loki - a.$loki)[0];
            let matchesAndSegments = await (0, $5ZsVo.getEventMatchesAndSegments)(latestHeldEvent);
            let superstarsUsedAtEvent = await (0, $5ZsVo.getSuperstarsUsedAtEvent)(matchesAndSegments, rosterSuperstars);
            // Get bottom 25% superstars by popularity
            let sortedSuperstars = superstars.sort((a, b)=>a.popularity - b.popularity);
            let bottomPopularitySuperstars = sortedSuperstars.slice(0, Math.floor(sortedSuperstars.length * 0.25));
            let weights = [];
            for (let x of superstars)// Check if not featured on last monthly event
            if (!(0, $3E8Nt.objectInArray)(x, superstarsUsedAtEvent) && (0, $5kTkA.checkSuperstarBrandAvailability)(latestHeldEvent, x)) {
                let weight = 1;
                // Check if part of low popularity superstars and not Jabroni
                if ((0, $3E8Nt.objectInArray)(x, bottomPopularitySuperstars) && (0, $5kTkA.getRankFromPopularity)(x.popularity) !== "Jabroni") weight += 15;
                weights.push([
                    x,
                    weight
                ]);
            }
            talent = (0, $3E8Nt.weightedChoice)(weights);
        }
        if (requestType === "train_skill_x") {
            if ((0, $8A6FL.getAvailableStaffMembersByRole)(await (0, $9esFv.getCompanyStaff)(company), "trainer").some((x)=>!x.currentTask)) {
                let weights = [];
                for (let x of superstars)if (x.workrate < 3 || x.charisma < 3) {
                    let weight = 0.1;
                    if ([
                        "Loves Training",
                        "Quick Learner"
                    ].some((y)=>x.traits.includes(y))) weight += 25;
                    if ([
                        "Hates Training",
                        "Slow Learner"
                    ].some((y)=>x.traits.includes(y))) weight *= 0.1;
                    weights.push([
                        x,
                        weight
                    ]);
                }
                talent = (0, $3E8Nt.weightedChoice)(weights);
            }
        }
    } catch (error) {}
    return talent;
}
async function $1038c1d091f9de0a$var$getActionDataForTalentRequest(requestType, talent, superstars, teams, championships, roster, company) {
    let actionData = {};
    try {
        if (requestType === "go_to_next_rank") actionData["selectedRank"] = await (0, $5kTkA.getNextRank)(talent);
        if (requestType === "put_x_over_clean") {
            let opponentWeights = [];
            for (let x of superstars)if (x.$loki !== talent.$loki && x.gender === talent.gender && x.brandName === talent.brandName) {
                let weight = 1;
                let popularityDifference = await (0, $3E8Nt.getRosterMemberPopularity)(talent) - await (0, $3E8Nt.getRosterMemberPopularity)(x);
                if (50 < popularityDifference && popularityDifference < 150) weight += 20;
                let superstarAge = await (0, $3E8Nt.getRosterMemberAge)(x);
                let ageDifference = await (0, $3E8Nt.getRosterMemberAge)(talent) - superstarAge;
                if (ageDifference > 8 || superstarAge < 30) weight += 10;
                if (superstarAge > 40) weight /= 5;
                opponentWeights.push([
                    x,
                    weight
                ]);
            }
            let selectedOpponent = (0, $3E8Nt.weightedChoice)(opponentWeights);
            actionData["selectedTalentId"] = selectedOpponent.$loki;
        }
        if (requestType === "feud_with_x") {
            let opponentWeights = [];
            let currentFeuds = (await (0, $cXLSF.getRosterMemberFeuds)(talent)).filter((x)=>x.started && !x.ended);
            let feudingSuperstars = (await Promise.all(currentFeuds.map((x)=>(0, $jDtEn.getFeudParticipants)(x)))).flat();
            for (let x of superstars)if (x.$loki !== talent.$loki && x.gender === talent.gender && x.alignment !== talent.alignment && x.brandName === talent.brandName && !(0, $3E8Nt.objectInArray)(x, feudingSuperstars)) {
                let weight = 0.1;
                let popularityDifference = Math.abs(await (0, $3E8Nt.getRosterMemberPopularity)(talent) - await (0, $3E8Nt.getRosterMemberPopularity)(x));
                if (popularityDifference < 200) weight += 10;
                if (x.hot) weight += 100;
                opponentWeights.push([
                    x,
                    weight
                ]);
            }
            let selectedOpponent = (0, $3E8Nt.weightedChoice)(opponentWeights);
            actionData["selectedTalentId"] = selectedOpponent.$loki;
        }
        if (requestType === "team_with_x") {
            let opponentWeights = [];
            for (let x of superstars)if (x.$loki !== talent.$loki && x.gender === talent.gender && x.alignment === talent.alignment && x.brandName === talent.brandName) {
                let superstarTagTeam = (await (0, $hBIDz.getSuperstarTagTeams)(x)).find((y)=>!y.temporary);
                if (!superstarTagTeam) {
                    let weight = 0.1;
                    let popularityDifference = Math.abs(await (0, $3E8Nt.getRosterMemberPopularity)(talent) - await (0, $3E8Nt.getRosterMemberPopularity)(x));
                    if (popularityDifference < 100) weight += 10;
                    opponentWeights.push([
                        x,
                        weight
                    ]);
                }
            }
            let selectedOpponent = (0, $3E8Nt.weightedChoice)(opponentWeights);
            actionData["selectedTalentId"] = selectedOpponent.$loki;
        }
        if (requestType === "disband_team") {
            let talentTeam = (await (0, $hBIDz.getSuperstarTagTeams)(talent)).find((x)=>!x.temporary);
            actionData["selectedTeamId"] = talentTeam.$loki;
        }
        if (requestType === "beat_x_clean") {
            let opponentWeights = [];
            for (let x of superstars)if (x.$loki !== talent.$loki && x.gender === talent.gender && x.brandName === talent.brandName) {
                let weight = 0.1;
                if (x.overness < 60) weight *= 0.1;
                if (x.hot) weight += 50;
                opponentWeights.push([
                    x,
                    weight
                ]);
            }
            let selectedOpponent = (0, $3E8Nt.weightedChoice)(opponentWeights);
            actionData["selectedTalentId"] = selectedOpponent.$loki;
        }
        if (requestType === "manage_x") {
            let superstarToManageWeights = [];
            for (let x of superstars)if (x.$loki !== talent.$loki && !x.managerId && !x.fullTimeManager && x.charisma <= 2) {
                let weight = 0.1;
                if (x.charisma <= 1) weight *= 2;
                superstarToManageWeights.push([
                    x,
                    weight
                ]);
            }
            let selectedTalent = (0, $3E8Nt.weightedChoice)(superstarToManageWeights);
            actionData["selectedTalentId"] = selectedTalent.$loki;
        }
        if (requestType === "leave_faction") {
            let talentFaction = (await (0, $5kTkA.getSuperstarActiveFactions)(talent))[0];
            actionData["selectedFactionId"] = talentFaction.$loki;
        }
        if (requestType === "match_with_x") {
            let opponentWeights = [];
            for (let x of superstars)if (x.$loki !== talent.$loki && x.gender === talent.gender && x.brandName === talent.brandName) {
                let weight = 0.1;
                if (x.workrate >= 3) weight += 10;
                if ([
                    "Ring General",
                    "Workhorse"
                ].some((y)=>x.traits.includes(y))) weight += 20;
                opponentWeights.push([
                    x,
                    weight
                ]);
            }
            let selectedOpponent = (0, $3E8Nt.weightedChoice)(opponentWeights);
            actionData["selectedTalentId"] = selectedOpponent.$loki;
        }
        if ([
            "lose_championship",
            "customize_championship"
        ].includes(requestType)) {
            let talentChampionships = championships.filter((x)=>x.superstarId === talent.$loki && !x.matchContract && !x.championshipContract);
            let talentChampionship = (0, $3E8Nt.getArrayMaxByProperty)(talentChampionships, "xp");
            actionData["selectedChampionshipId"] = talentChampionship.$loki;
        }
        if (requestType === "vacate_championship") {
            let talentChampionships = championships.filter((x)=>x.superstarId === talent.$loki && !x.matchContract && !x.championshipContract && !x.tagTeam && !x.trio);
            let talentChampionship = (0, $3E8Nt.getArrayMaxByProperty)(talentChampionships, "xp");
            actionData["selectedChampionshipId"] = talentChampionship.$loki;
        }
        if (requestType === "change_alignment") {
            let selectedAlignment;
            if (talent.alignment === "face") selectedAlignment = "heel";
            else if (talent.alignment === "heel") selectedAlignment = "face";
            actionData["selectedAlignment"] = selectedAlignment;
        }
        if (requestType === "join_faction") {
            let rosterFactions = await (0, $6PzHO.getRosterActiveFactions)(roster);
            let factionWeights = [];
            for (let x of rosterFactions){
                let weight = 1;
                weight += x.reputation;
                factionWeights.push([
                    x,
                    weight
                ]);
            }
            let selectedFaction = (0, $3E8Nt.weightedChoice)(factionWeights);
            actionData["selectedFactionId"] = selectedFaction.$loki;
        }
        if (requestType === "change_brand") {
            // Get exclusive brands that are not talent's brand
            let exclusiveRosterBrands = (await (0, $dl5u4.getRosterBrands)(roster)).filter((x)=>x.weeklyShowIsExclusive && x.name !== talent.brandName);
            let brandWeights = [];
            for (let x of exclusiveRosterBrands){
                let weight = 1;
                if (x.hot) weight += 5;
                brandWeights.push([
                    x,
                    weight
                ]);
            }
            let selectedBrand = (0, $3E8Nt.weightedChoice)(brandWeights);
            actionData["selectedBrandId"] = selectedBrand.$loki;
        }
        if (requestType === "train_skill_x") {
            let availableSkills = [];
            if (talent.workrate < 3) {
                let weight = 3 - talent.workrate;
                availableSkills.push([
                    "workrate",
                    weight
                ]);
            }
            if (talent.charisma < 3) {
                let weight = 3 - talent.charisma;
                availableSkills.push([
                    "charisma",
                    weight
                ]);
            }
            actionData["selectedSkill"] = (0, $3E8Nt.weightedChoice)(availableSkills);
        }
        if (requestType === "be_in_gimmick_match_x") {
            // Remove contract, unavailable, battle royal and some consequence matches
            let gimmickMatches = (await (0, $9esFv.getCompanyGimmickMatches)(company)).filter((x)=>x.available && x.rules !== "battle_royal" && !x.cashinContractName && !x.matchContractName && ![
                    "remove_hair",
                    "add_hair",
                    "remove_mask",
                    "remove_mask_or_hair"
                ].includes(x.consequence));
            // Remove Femme Fatale if talent doesn't have female gender
            if (talent.gender !== "female") gimmickMatches = gimmickMatches.filter((x)=>x.name !== "Femme Fatale");
            // Select random gimmick match
            let gimmickMatch = (0, $3E8Nt.getRandomChoice)(gimmickMatches);
            // Lower chance to select pole or brawl matches
            if (gimmickMatch.generateObject || gimmickMatch.generateLocation) gimmickMatch = (0, $3E8Nt.getRandomChoice)(gimmickMatches);
            // High chance to select expert match
            for (let trait of talent.traits)if (trait.includes("Match Expert")) {
                let expertGimmickMatchName = trait.split(" Match Expert")[0];
                let expertGimmickMatch = gimmickMatches.find((x)=>x.name === expertGimmickMatchName);
                if (expertGimmickMatch && (0, $3E8Nt.getRandomInt)(0, 100) <= 75) gimmickMatch = expertGimmickMatch;
            }
            actionData["selectedGimmickMatchId"] = gimmickMatch.$loki;
        }
    } catch (error) {}
    return actionData;
}

});
parcelRequire.register("cpTRW", function(module, exports) {

$parcel$export(module.exports, "TalentRequest", () => $90a32845c50dc02f$export$c2e2c29a6a22b67);
$parcel$export(module.exports, "getTalentRequestSuperstar", () => $90a32845c50dc02f$export$27dccb04eee882df);
$parcel$export(module.exports, "getTalentRequestTagTeam", () => $90a32845c50dc02f$export$cec6dd42d90d09f1);

var $14eBR = parcelRequire("14eBR");
function $90a32845c50dc02f$export$c2e2c29a6a22b67() {
    // String
    const type = null;
    const status = null;
    // Integer
    const monthsRemaining = null;
    // Boolean
    const actionCompleted = null;
    const changedRequest = null;
    // Objects
    const actionData = {};
    // Foreign keys
    const superstarId = null;
    const tagTeamId = null;
    const companyId = null;
    return {
        type: type,
        status: status,
        monthsRemaining: monthsRemaining,
        actionCompleted: actionCompleted,
        changedRequest: changedRequest,
        actionData: actionData,
        superstarId: superstarId,
        tagTeamId: tagTeamId,
        companyId: companyId
    };
}
function $90a32845c50dc02f$export$27dccb04eee882df(talentRequest) {
    return (0, $14eBR.Superstars).find({
        "$loki": talentRequest.superstarId
    })[0];
}
function $90a32845c50dc02f$export$cec6dd42d90d09f1(talentRequest) {
    return (0, $14eBR.TagTeams).find({
        "$loki": talentRequest.tagTeamId
    })[0];
}
function $90a32845c50dc02f$export$cd25556d1269a44f(talentRequest) {
    return (0, $14eBR.Companies).find({
        "$loki": talentRequest.companyId
    })[0];
}

});

parcelRequire.register("knp8C", function(module, exports) {

$parcel$export(module.exports, "talentRequestsData", () => $ed5974855d5db306$export$c4db1fda2bd0b227);
$parcel$export(module.exports, "talentRequestCommonDialogs", () => $ed5974855d5db306$export$a13569c7ed7372a1);
let $ed5974855d5db306$export$c4db1fda2bd0b227 = {
    "team_with_x": {
        "months": [
            1,
            2
        ],
        "display_name": "Team With X",
        "name": "Team With ${talentName}",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "${talentName} and I have decent chemistry. It would be a good idea to put us in a team together.",
            "I've been thinking about getting into the tag division for a while now. I've had talks with ${talentName} and we both agreed to team up.",
            "${talentName} and I were thinking about teaming up. We both know we could do really well together."
        ],
        "description": "More likely by talent with the Tag Team Specialist trait.",
        "conflicting_requests": [
            "write_off",
            "no_weekly_shows",
            "change_brand"
        ],
        "rarity": "uncommon"
    },
    "solo_promo_segment": {
        "allow_managers": true,
        "months": [
            1
        ],
        "display_name": "Have A Solo Promo Segment",
        "name": "Have A Solo Promo Segment",
        "importance": "minor",
        "dialogs": [
            "I'd like to showcase my character a bit. Could you book me in a solo promo segment this month?",
            "I feel like going out there for a solo promo. It might help me connect with the fans.",
            "I would appreciate some solo mic time. How about a promo segment where it's just me talking?",
            "Hey, how about some mic time? A solo promo slot would be perfect."
        ],
        "description": "More likely by talent with 2 Charisma and those with the Spotlight Lover trait.",
        "conflicting_requests": [
            "no_weekly_shows"
        ],
        "rarity": "common"
    },
    "win_next_match": {
        "months": [
            1
        ],
        "display_name": "Win Next Match",
        "name": "Win Next Match (Singles)",
        "importance": "minor",
        "dialogs": [
            "I've been on a bit of a losing streak. How about giving me a win, boss?",
            "It doesn't feel good to take so many losses. A win would really help my character out.",
            "You might not know this, but losing isn't the best feeling. Could you please book me to win my next match?",
            "I don't know what your plan is with my recent losses, but getting a win next could help turn things around.",
            "I noticed I've been taking a bunch of losses recently. Getting a win in my next match would be nice."
        ],
        "description": "More likely by talent with 5+ match losing streaks and those with the Hard To Please or Rebel traits.",
        "conflicting_requests": [
            "lose_next_match",
            "no_weekly_shows"
        ],
        "rarity": "common"
    },
    "debut_new_gimmick": {
        "allow_managers": true,
        "months": [
            1
        ],
        "display_name": "Debut New Gimmick",
        "name": "Debut New Gimmick",
        "importance": "minor",
        "dialogs": [
            "I don't know if you can tell, but I'm not too popular with the fans right now. Maybe introducing a new gimmick could help me out?",
            "You know what's a great way to refresh my character? Coming out with a cool new gimmick, something the fans will be interested in.",
            "The fans are not too hot on me these days. How about I debut a new gimmick that freshens up my character?"
        ],
        "description": "More likely by Stale talent.",
        "conflicting_requests": [
            "write_off"
        ],
        "rarity": "uncommon"
    },
    "be_in_title_match": {
        "months": [
            1,
            2
        ],
        "display_name": "Be In A Title Match",
        "name": "Be In A Title Match",
        "importance": "minor",
        "dialogs": [
            "Being in a title match would really help my character out. A match with real stakes, where I can show the fans what I got.",
            "I could really use a title match right now. I'll make any champion look good, even in defeat.",
            "You know that a title match can elevate all participants. If you put me in one, I'll make sure it's a great match.",
            "I somehow keep getting the urge to be in a title match. Could you book me in one so I can shine out there?"
        ],
        "description": "More likely by Unhappy talent, Upper Midcarders and those with the Spotlight Lover trait.",
        "conflicting_requests": [],
        "rarity": "common"
    },
    "lose_championship": {
        "months": [
            1,
            2
        ],
        "display_name": "Lose Championship",
        "name": "Lose ${championshipName} Championship",
        "get_action_data": true,
        "importance": "major",
        "dialogs": [
            "This is hard to say .. I think it's time for me to drop the ${championshipName} Title to someone else. Being the champion is taking its toll on me.",
            "I'm sorry, but I can't be the ${championshipName} Champion any longer. I have other things going on in my life right now .. I'd like to drop the title soon.",
            "The ${championshipName} Championship is being wasted on me. You should have me lose the title to someone who can do better things with it."
        ],
        "description": "More likely by talent leaving the Company, Unhappy talent and those with the Big Stage Wreck, Other Interests or Extreme Emotions traits.",
        "conflicting_requests": [
            "customize_championship"
        ],
        "rarity": "rare"
    },
    "leave_faction": {
        "months": [
            2,
            3
        ],
        "display_name": "Leave Faction",
        "name": "Leave Faction (${factionName})",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "I keep getting the feeling that I don't belong in ${factionName}. Don't get me wrong, it's been good, but I could do better things outside of it.",
            "You know, it would be a really cool story if I slowly left ${factionName}. I think now's the time to do it.",
            "I had a talk with all members of ${factionName}, and we agreed that it's best for me to leave so I can do my own thing.",
            "Maybe it's time for me to break away from ${factionName}. I'll be able to do bigger things outside of it. Plus, it would make for a nice angle."
        ],
        "description": "More likely by Over talent.",
        "conflicting_requests": [],
        "rarity": "uncommon"
    },
    "be_managed": {
        "months": [
            1
        ],
        "display_name": "Be Managed",
        "name": "Be Managed",
        "importance": "minor",
        "dialogs": [
            "I'm sure you've noticed my lack of skills on the mic. How about you assign me someone to do the talking for me?",
            "I feel like I need a manager assigned to me, someone who can hide my shortcomings. Don't you agree?",
            "I could do a lot better if I had a manager paired up with me. Someone who can do the talking and make me look good.",
            "You know what I need to progress further? A skilled manager. Someone who adds to my presence and aura."
        ],
        "description": "More likely by talent with 1 Charisma.",
        "conflicting_requests": [
            "write_off",
            "no_weekly_shows"
        ],
        "rarity": "uncommon"
    },
    "start_faction": {
        "months": [
            1,
            2
        ],
        "display_name": "Start A Faction",
        "name": "Start A Faction",
        "importance": "minor",
        "dialogs": [
            "I'm a big fan of factions. If you put me in one with a few other talented superstars, we could all help each other out.",
            "The stories on the show needs some freshening up, and a new faction is the perfect way to do that. You can pick some other superstars and start one with me.",
            "A lot of wrestlers could benefit from being part of a group, myself included. How about you put a few of us together in a new faction?"
        ],
        "description": "More likely by Upper Midcarders.",
        "conflicting_requests": [
            "write_off",
            "no_weekly_shows",
            "change_brand"
        ],
        "rarity": "uncommon"
    },
    "manage_x": {
        "allow_managers": true,
        "months": [
            1
        ],
        "display_name": "Manage X",
        "name": "Manage ${talentName}",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "${talentName} is a special talent who needs a little help on the mic. I think I would be a good fit as ${talentPossessive} manager.",
            "It's time for me to use my manager skills to push someone up the card. How about ${talentName}? I know we'd make a great pairing.",
            "I've been scouting talent to manage recently, and I see ${talentName} as someone who could really benefit from my abilities.",
            "I've been coaching ${talentName} a bit backstage, and I know I could make a real difference if you made me ${talentPossessive} on-screen manager."
        ],
        "description": "More likely by Full-time Managers and talent with 3 Charisma.",
        "conflicting_requests": [
            "write_off",
            "no_weekly_shows",
            "change_brand"
        ],
        "rarity": "uncommon"
    },
    "win_and_not_lose": {
        "negative_request": true,
        "display_name": "Win Clean And Don't Lose",
        "name": "Win Clean And Don't Lose (Singles)",
        "secondary_action": true,
        "importance": "major",
        "dialogs": [
            "I need to get more wins under my belt. And I don't think I should take any losses, not for a while.",
            "It's time to start booking me strong. I need to win some matches. And no losses, alright?",
            "I'm a valuable asset to this company and I need to be protected. You should book me to get some wins and go over anyone I face."
        ],
        "description": "More likely by Unhappy talent, Faces of the Company and those with the Hard To Please or Rebel traits.",
        "conflicting_requests": [
            "put_x_over_clean",
            "lose_next_match"
        ],
        "months": [
            2,
            3
        ],
        "rarity": "normal"
    },
    "lose_next_match": {
        "months": [
            1
        ],
        "display_name": "Lose Next Match",
        "name": "Lose Next Match (Singles)",
        "importance": "minor",
        "dialogs": [
            "I've been winning quite a few matches lately, and I think it's time for me to take a loss. Don't want to be too dominant.",
            "I want to lose my next match. I've been winning a few and I should give someone the rub instead.",
            "I'm in the position where I can elevate people by putting them over. I'd like to lose to someone in my next match.",
            "I'm at the point where I should be building up other talent. How about you book me to lose my next match?"
        ],
        "description": "More likely by talent with 5+ match win streaks and those with the Giving Veteran or Star Maker traits.",
        "conflicting_requests": [
            "win_next_match",
            "no_clean_loss",
            "no_weekly_shows",
            "win_and_not_lose"
        ],
        "rarity": "common"
    },
    "put_x_over_clean": {
        "months": [
            1
        ],
        "display_name": "Put X Over Clean",
        "name": "Put ${talentName} Over Clean (Singles)",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "I've been thinking about wrestling ${talentName}. If we do have a match, ${talentPronoun} should get a clean win over me.",
            "${talentName} is a great talent in my eyes. I'd like to be in a match against ${talentObjective} where ${talentPronoun} goes over clean.",
            "It's time for me to elevate someone by giving them a win. How about ${talentName}?",
            "I should be putting other talent over. How about a match with ${talentName} where ${talentPronoun} wins clean?"
        ],
        "description": "More likely by talent with the Spotlight Lover, Giving Veteran or Star Maker traits.",
        "conflicting_requests": [
            "no_clean_loss",
            "win_and_not_lose"
        ],
        "rarity": "common"
    },
    "join_faction": {
        "allow_managers": true,
        "months": [
            1,
            2
        ],
        "display_name": "Join Faction",
        "name": "Join Faction (${factionName})",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "${factionName} could use a hot new member. How about you add me to the group?",
            "I've been talking to members of ${factionName} and they want me to join their group. How about you book that into the story?",
            "I would be a good fit in ${factionName}. They could use someone like me and I'd benefit from being part of the faction."
        ],
        "description": "More likely by Upper Midcarders.",
        "conflicting_requests": [
            "write_off",
            "change_brand"
        ],
        "rarity": "uncommon"
    },
    "be_in_main_event": {
        "months": [
            1
        ],
        "display_name": "Be In The Main Event",
        "name": "Be In The Main Event",
        "importance": "minor",
        "dialogs": [
            "I know I'll do well if you gave me an opportunity to be in the main event of the show.",
            "I'd like to be booked in the main event soon. The spotlight could help elevate me.",
            "What do you think about booking me in the main event? I know I can deliver in that spot.",
            "I would benefit a lot from being in the main event of the show. And you know I'll give it my best."
        ],
        "description": "More likely by Unhappy talent, Upper Midcarders and those with the Spotlight Lover, Hard To Please or Rebel traits.",
        "conflicting_requests": [
            "no_weekly_shows"
        ],
        "rarity": "common"
    },
    "change_alignment": {
        "allow_managers": true,
        "months": [
            2,
            3
        ],
        "display_name": "Turn Face/Heel",
        "name": "Turn ${alignment}",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "You might've noticed that I'm not working too well as a ${currentAlignment} character. How about I turn ${alignment} over the next few months?",
            "My ${currentAlignment} character doesn't feel right anymore. I'm due for a ${alignment} turn.",
            "I think we have a good opportunity right now to turn me ${alignment}. It would make for a nice story over the coming months."
        ],
        "description": "More likely by talent with the Natural Babyface or Natural Heel traits (with the wrong alignment) and those who have spent 12+ months with the same alignment.",
        "conflicting_requests": [
            "write_off"
        ],
        "rarity": "uncommon"
    },
    "win_a_championship": {
        "months": [
            2,
            3
        ],
        "display_name": "Win A Championship",
        "name": "Win A Championship",
        "importance": "major",
        "dialogs": [
            "You know the spotlight that comes with being a champion? I need that.",
            "You know, I could elevate any championship in the company. Give me a title and you'll see.",
            "I feel like it's time for me to hold a championship. You know I deserve it."
        ],
        "description": "More likely by Unhappy talent and those with the Hard To Please or Rebel traits.",
        "conflicting_requests": [
            "write_off"
        ],
        "rarity": "normal"
    },
    "match_with_x": {
        "months": [
            1
        ],
        "display_name": "Have A Match With X",
        "name": "Have A Match With ${talentName} (Singles)",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "${talentName} is an amazing wrestler and I think the two of us could have a memorable match against each other.",
            "I would really like a singles match against ${talentName}. We could tear the house down together.",
            "I've been looking at talent to work with and I believe ${talentName} would be a perfect opponent for me.",
            "I was talking with ${talentName}, and we agreed that we could do some fantastic things if you put us in a match together."
        ],
        "description": "More likely by talent with 3 Workrate and those with the Ring General or Workhorse traits.",
        "conflicting_requests": [],
        "rarity": "common"
    },
    "go_to_next_rank": {
        "months": [
            2,
            3
        ],
        "display_name": "Become Rank X",
        "name": "Become ${rank}",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "I think it's time for me to move up the card to ${rankIndefiniteArticle} ${rank}. It feels like the right moment.",
            "I can sense that I'm close to becoming ${rankIndefiniteArticle} ${rank}. We could do it over the next few months.",
            "I've earned my way up to ${rankIndefiniteArticle} ${rank}. It's time to pull the trigger on it.",
            "I know I can do really well as ${rankIndefiniteArticle} ${rank}. Give me the shot and I'll prove it."
        ],
        "description": "Given by talent close to the next Rank. More likely by Unhappy talent and those with the Spotlight Lover, Hard To Please or Rebel traits.",
        "conflicting_requests": [
            "write_off"
        ],
        "rarity": "common"
    },
    "vacate_championship": {
        "months": [
            1,
            2
        ],
        "display_name": "Vacate Championship",
        "name": "Vacate ${championshipName} Championship",
        "get_action_data": true,
        "importance": "major",
        "dialogs": [
            "I feel like it's time for me to drop the ${championshipName} Title, but I'm not in the position to lose it to anybody. Maybe you could vacate it instead?",
            "I'm a strong champion, and my reign can't end with me losing to someone. I think you should vacate the ${championshipName} Title to get it off me.",
            "I can sense that my title reign should be over, but I don't believe I should lose it to someone. What if I go out and say something like .. I don't know .. I lost my smile?"
        ],
        "description": "More likely by Unhappy talent, Faces of the Company and those with the Hard To Please or Rebel traits.",
        "conflicting_requests": [
            "customize_championship"
        ],
        "rarity": "rare"
    },
    "beat_x_clean": {
        "months": [
            1,
            2
        ],
        "display_name": "Beat X Clean",
        "name": "Beat ${talentName} Clean (Singles)",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "${talentName} would really benefit from a match against someone like me. Of course, I should go over, but even facing me will cement ${talentObjective} as a star.",
            "${talentName} is getting a little popular. You should put us in a match to establish ${talentObjective} .. even losing to me will help ${talentObjective} out.",
            "I've been thinking about facing ${talentName}. A match against me would be great for ${talentObjective}. But, you know, I'll have to win."
        ],
        "description": "More likely by Faces of the Company and talent with the Hard To Please or Rebel traits.",
        "conflicting_requests": [],
        "rarity": "uncommon"
    },
    "change_appearance": {
        "allow_managers": true,
        "months": [
            0,
            1
        ],
        "display_name": "Change Appearance",
        "name": "Change Appearance",
        "importance": "minor",
        "dialogs": [
            "I think a change in appearance could help freshen up my character. Maybe some new hair, or accessories?",
            "You know what would really help me? A new look. Even a little change could work.",
            "I'm bored of my look. A small makeover would do wonders for my character."
        ],
        "description": "More likely by Stale talent.",
        "conflicting_requests": [
            "write_off"
        ],
        "rarity": "normal"
    },
    "feud_with_x": {
        "months": [
            1,
            2
        ],
        "display_name": "Feud With X",
        "name": "Feud With ${talentName} (Singles)",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "I've had my eyes on ${talentName} for a while now. A feud between us would be perfect.",
            "I think ${talentName} and I should be in a feud against each other. We could do some amazing stuff.",
            "${talentName} was talking to me and we thought of some great ideas for a feud. What do you think about putting us against each other?",
            "${talentName} and I were talking, and we agreed that we could put together a great feud."
        ],
        "description": "More likely by talent with the Storyteller trait.",
        "conflicting_requests": [],
        "rarity": "common"
    },
    "no_weekly_shows": {
        "negative_request": true,
        "display_name": "No Weekly Shows",
        "name": "No Weekly Shows",
        "months": [
            2,
            3
        ],
        "importance": "major",
        "dialogs": [
            "Some important stuff has come up and I don't know if I can be on the weekly shows right now. Could you save my appearances for the monthly events?",
            "My schedule's gotten a bit busy and I don't think I can do weekly appearances for a few months. How about you only use me at the monthly events?",
            "My body can't go every week right now. It might be best to save my appearances for the next few monthly events.",
            "You know, I don't perform too well on the weekly shows. How about a bit of a break? Save me for the monthlies?"
        ],
        "description": "More likely by Part-timers and talent with the Other Interests or Weekly Sloth traits.",
        "conflicting_requests": [
            "solo_promo_segment",
            "be_in_main_event",
            "win_next_match",
            "lose_next_match",
            "team_with_x",
            "manage_x",
            "be_managed",
            "start_faction",
            "train_skill_x"
        ],
        "rarity": "uncommon"
    },
    "no_clean_loss": {
        "negative_request": true,
        "display_name": "Can't Lose Clean",
        "name": "Can't Lose Clean (Singles)",
        "months": [
            1,
            2
        ],
        "importance": "major",
        "dialogs": [
            "I feel like I need to be protected more. A clean loss won't be good for me right now.",
            "I can't afford to take a clean loss right now. My character need to be protected.",
            "I can't go out there and lose clean right now. You know how much that would hurt my character."
        ],
        "description": "More likely by Unhappy talent, Faces of the Company and those with the Hard To Please or Rebel traits.",
        "conflicting_requests": [
            "put_x_over_clean",
            "lose_next_match"
        ],
        "rarity": "normal"
    },
    "train_skill_x": {
        "months": [
            3
        ],
        "display_name": "Train Skill X",
        "name": "Train ${skill}",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "I know I need to improve my ${skill} and training is the best way to do it. How about you hook me up with the trainer for a few months?",
            "How about some focused training for my ${skill}, boss? I heard the trainer can do wonders in a few months.",
            "You must've noticed that my ${skill} isn't that good. How about some one on one time with the trainer to help me improve?",
            "Could you assign the trainer to help me with my ${skill}? I think I could make some decent progress in a few months."
        ],
        "description": "More likely by talent with the Loves Training or Quick Learner traits.",
        "conflicting_requests": [
            "no_weekly_shows",
            "write_off"
        ],
        "rarity": "normal"
    },
    "write_off": {
        "months": [
            1
        ],
        "display_name": "Write Me Off",
        "name": "Write Me Off",
        "importance": "major",
        "dialogs": [
            "Now's a good time to write me off. Do something cool that tells the fans that I won't be returning for a while.",
            "Some other commitments have come up and I need focus on them. You can write me off however you want, but I don't want to be active much longer.",
            "I can't do this much longer .. I need to focus on other things. You can do a fake injury angle or a suspension or something."
        ],
        "description": "More likely by Part-timers and talent with the Other Interests trait.",
        "conflicting_requests": [
            "go_to_next_rank",
            "win_a_championship",
            "start_faction",
            "manage_x",
            "be_managed",
            "customize_championship",
            "team_with_x",
            "change_appearance",
            "debut_new_gimmick",
            "change_alignment",
            "join_faction",
            "be_on_monthly_event",
            "train_skill_x"
        ],
        "rarity": "uncommon"
    },
    "customize_championship": {
        "months": [
            1
        ],
        "display_name": "Customize Championship",
        "name": "Customize ${championshipName} Championship",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "The ${championshipName} Championship looks great on me, but I was thinking we could customize the belt to add some style to my reign.",
            "I got a neat idea. How about we add a unique design for my ${championshipName} Title? All the cool champions did it.",
            "I could do more with the ${championshipName} Title if it was personalized. Maybe we could add a custom design for the belt?"
        ],
        "description": "Given by talent less than 4 months into their title reigns.",
        "conflicting_requests": [
            "write_off",
            "lose_championship",
            "vacate_championship"
        ],
        "rarity": "rare"
    },
    "be_in_gimmick_match": {
        "months": [
            1
        ],
        "display_name": "Be In A Gimmick Match",
        "name": "Be In A Gimmick Match",
        "importance": "minor",
        "dialogs": [
            "I'm craving a gimmick match. How about you book me in one this month?",
            "I want to show the fans some new things and a gimmick match seems like the perfect way to do it.",
            "You should put me in a gimmick match this month. I want to use it to tell a different kind of story in the ring.",
            "Gimmick matches might be overdone, but I feel like I could do something cool if you put me in one."
        ],
        "description": "More likely by talent with the Risk Taker, Gifted Acrobat or Enjoys Gimmick Matches traits.",
        "conflicting_requests": [],
        "rarity": "common"
    },
    "be_on_monthly_event": {
        "allow_managers": true,
        "months": [
            1
        ],
        "display_name": "Be Booked At Monthly Event",
        "name": "Be Booked At Monthly Event",
        "importance": "minor",
        "dialogs": [
            "You didn't use me on the last monthly event .. could you make some plans for me this month?",
            "The next monthly event is in my hometown, and I would appreciate if you can put me on the card. The whole family's going to be watching.",
            "I'd really appreciate being booked on the upcoming monthly event this time. Could you put me in a match or segment?",
            "I think I should be booked on the upcoming monthly event, especially after not being part of last month's show."
        ],
        "description": "Given by talent not booked at the previous monthly event.",
        "conflicting_requests": [
            "write_off"
        ],
        "rarity": "common"
    },
    "beat_main_eventer": {
        "months": [
            1,
            2
        ],
        "display_name": "Beat A Main Eventer",
        "name": "Beat A Main Eventer (Singles)",
        "importance": "minor",
        "dialogs": [
            "I'm at the position where I can legitimately beat a Main Eventer, and I believe the fans want to see it too.",
            "I'm ready to take on a Main Eventer and beat them. Don't you think so?",
            "The fans are ready to see me get a win against a Main Eventer. It'll really help me out."
        ],
        "description": "More likely by Unhappy talent, Upper Midcarders and those with the Spotlight Lover, Hard To Please or Rebel traits.",
        "conflicting_requests": [],
        "rarity": "common"
    },
    "disband_team": {
        "months": [
            2,
            3
        ],
        "display_name": "Disband Team",
        "name": "Disband Team (${teamName})",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "I'm picking up some momentum as a solo performer, and maybe it's time for me to do my own thing.",
            "I love my tag partner, but I feel like I would be better off as a singles superstar. What do you think?",
            "I think it's time for me to break away from ${teamName} and go on a singles run. I need to see what I can do on my own.",
            "Being part of ${teamName} isn't working for me anymore. My partner and I had a long talk, and we think it's best for us to break up."
        ],
        "description": "More likely by Over talent.",
        "conflicting_requests": [],
        "rarity": "uncommon"
    },
    "be_in_gimmick_match_x": {
        "months": [
            1
        ],
        "display_name": "Be In Gimmick Match X",
        "name": "Be In A Gimmick Match (${gimmickMatchName})",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "I got a few ideas for a ${gimmickMatchName} match running around in my head. Could you put me in one soon?",
            "Let's do a ${gimmickMatchName} match soon. I really wanna be in one and I know the fans will love it.",
            "${gimmickMatchName} match. ASAP.",
            "I've had this recent fascination with ${gimmickMatchName} matches .. could you book me in one?"
        ],
        "description": "More likely by talent with the Risk Taker, Gifted Acrobat, Enjoys Gimmick Matches or Match Expert traits.",
        "conflicting_requests": [],
        "rarity": "normal"
    },
    "change_brand": {
        "allow_managers": true,
        "months": [
            2,
            3
        ],
        "display_name": "Move to Brand X",
        "name": "Move to ${brandName}",
        "get_action_data": true,
        "importance": "minor",
        "dialogs": [
            "Staying on ${currentBrandName} isn't working for me right now. Could you perhaps transfer me over to ${brandName}? I think I'll be better off there.",
            "I've spent enough time on ${currentBrandName} to know it's not the right fit for me. Could you move me to ${brandName} instead?",
            "${currentBrandName} is great, but I have a lot of friends over at ${brandName} and I'd like to join them. Maybe you could move me there?"
        ],
        "description": "More likely by Unhappy talent.",
        "conflicting_requests": [
            "start_faction",
            "join_faction",
            "team_with_x",
            "manage_x"
        ],
        "rarity": "uncommon"
    }
};
const $ed5974855d5db306$export$a13569c7ed7372a1 = {
    "requestAccepted": [
        "You're a smart booker.",
        "Yes!",
        "Thanks!",
        "Thank you.",
        "I didn't expect you to agree to that.",
        "Wow, thank you.",
        "Thanks for listening to me.",
        "That's what I'm talking about.",
        "Thanks a bunch.",
        "I'll be very grateful.",
        "I'm looking forward to it.",
        "I knew you were a good person.",
        "Good booker.",
        "Thanks, boss.",
        "I knew you were on my side.",
        "I knew I could count on you.",
        "That's great.",
        "Thanks for agreeing with me.",
        "You actually listened .. thanks.",
        "Okay, hope it works out.",
        "That's very nice of you.",
        "Beautiful.",
        "I appreciate it.",
        "Can't wait!",
        "Awesome."
    ],
    "requestCompleted": [
        "Thanks a lot for listening to me. You're a good boss.",
        "You did as I asked. That doesn't happen very often in this business.",
        "I'm grateful you did as I asked. This is going to help me out a lot.",
        "Thank you for taking care of me. I owe you one.",
        "Thanks for dealing with my request, boss. I know it wasn't easy.",
        "You did the right thing. Thank you.",
        "I know I made a tough request, but you did as I asked, and I'll try to repay the favour.",
        "I know I didn't make the easiest request in the world, so thank you.",
        "Hey, thanks a lot for listening to me. You did as I asked, and I'm very grateful.",
        "Thanks. I know I'm not the easiest person to work with, but I'll try to be better from now on.",
        "I'm quite happy with how that turned out. Thank you.",
        "Other bookers might not have done that for their talent, but you're one of the good ones."
    ],
    "requestFailed": [
        "What the #@!&? I thought we had an understanding!",
        "This sucks. Maybe I asked for a lot .. but I know you could've done more.",
        "You couldn't even do what we discussed? How do you expect me to be happy here?",
        "I asked you for one thing. ONE THING. And you can't even do that?",
        "It was a bad decision to not listen to me. I'll do my best to make your life more difficult from now on.",
        "You need to start listening to your talent, or the locker room is going to turn against you.",
        "You should've taken better care of my needs. I could easily find another place that treats me better.",
        "I thought we had a deal! It's really disappointing to be treated like this.",
        "You gave me your word. This is going to come back to bite you .. ",
        "I can't believe I trusted you. This really sucks.",
        "You said you would do it .. I can't believe I fell for it.",
        "This was important to me, and you just ignored it? After you said you would work on it?!"
    ],
    "requestDeclined": {
        "major": [
            "What? I thought I could trust you with things like this!",
            "I really thought you would treat me better than this.",
            "So, I come to you with a personal request, and you just decline it? This sucks.",
            "You didn't even try to work on my request. This is beyond disappointing.",
            "That's it, you're just saying no? And you expect me to be happy here?",
            "That's a really bad decision you made and you're going to regret it.",
            "Right, I forgot you're the booker, playing with us like we're your puppets.",
            "You know, there are other places where talent are treated much better.",
            "I thought I could come to you with stuff like this. That was important to me .. ",
            "This blows. I can't trust you with things important to me.",
            "You treat us like crap. Like we're some characters you're managing in a video game."
        ],
        "minor": [
            "You know, that was important to me.",
            "You should've given that more thought.",
            "Okay .. ",
            "Right, okay .. ",
            "Oh .. alright.",
            "Fine, I guess we'll go with your decision.",
            "I don't think you made the right choice there.",
            "You could've trusted me on that.",
            "I'm not too happy about this.",
            "Fine, there's not much else to say.",
            "Really? I thought it was a decent idea.",
            "Okay, fine. I have to go.",
            "I guess we don't see eye to eye on that.",
            "I somehow thought you would agree to that.",
            "Damn, I was looking forward to that .. ",
            "Of course. You always get the final say.",
            "Okay, whatever. I guess that's fine.",
            "That was important to me.",
            "I guess I have a different opinion then.",
            "I think that's the wrong decision, but fine."
        ]
    },
    "acceptRequest": [
        "I'll see what I can do.",
        "Sure, we can do that.",
        "You got it.",
        "That will work.",
        "Let's do it!",
        "I think we can do that.",
        "Consider it done.",
        "Okay, let's do it.",
        "I can manage that.",
        "That'll work out quite well, actually.",
        "I was already thinking of that.",
        "I can incorporate that.",
        "That's actually exciting.",
        "That works for me.",
        "I think that's a great idea."
    ],
    "declineRequest": [
        "Sorry, pal. Can't do this.",
        "That's a stupid idea.",
        "We can't do this right now.",
        "That doesn't work for me.",
        "Are you kidding?",
        "That's a bad idea.",
        "This won't work right now.",
        "Sorry, that's a no from me.",
        "Nope.",
        "Now's not the right time.",
        "Sorry.",
        "I don't think so.",
        "That doesn't go with the plans.",
        "Sorry, I have to say no.",
        "I don't think that will work."
    ],
    "changeRequest": [
        "Could you try asking for something else?",
        "Is there something else I could do for you?",
        "Is there some other thing I can do for you?",
        "Maybe there's something else you can ask for?",
        "Maybe you have another idea?",
        "Do you have another idea?",
        "Could you reconsider and ask for something else?",
        "I might be able to do something else for you.",
        "Is there another request you had in mind?",
        "Try me with something else.",
        "Ask me for something else? I'll owe you one.",
        "Ask me for something else, pal."
    ],
    "changeDeclined": [
        "No, this is what I want.",
        "No, I want this.",
        "Nope.",
        "Can't think of anything else.",
        "Why, so you can shoot that down too?",
        "Why, is this too difficult for you?",
        "No. You should be able to do this for me.",
        "No.",
        "You may be able to get other people to change their minds, but not me.",
        "I'm not going to bend on my request like some other talent do.",
        "No. Give me what I want.",
        "Why would I want anything else?"
    ],
    "changeAccepted": [
        "There is something else you could do for me .. ",
        "Okay, sure .. ",
        "Okay, hear me out now.",
        "There is this other thing I wanted to ask you for.",
        "Now that you mention it .. ",
        "Okay, how about this .. ",
        "Actually, there is something else .. ",
        "I did have another idea.",
        "I guess I could think of something else.",
        "Okay, I got an even better idea.",
        "I can't believe you're making me change my request, but okay.",
        "How dare you .. ugh, fine."
    ]
};

});

parcelRequire.register("hekDR", function(module, exports) {

$parcel$export(module.exports, "getMessages", () => $c8b3c18104c7e1a2$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "setMessageRead", () => $c8b3c18104c7e1a2$export$c1bb551219164dcd);
$parcel$export(module.exports, "deleteMessage", () => $c8b3c18104c7e1a2$export$b7572a81e749f23f);
$parcel$export(module.exports, "deleteAllMessages", () => $c8b3c18104c7e1a2$export$9b6480ac8f0abd9f);
$parcel$export(module.exports, "createMessage", () => $c8b3c18104c7e1a2$export$62651879628e0c4c);
$parcel$export(module.exports, "createStaffHiredMessage", () => $c8b3c18104c7e1a2$export$ef5c2e57eebf55b2);
$parcel$export(module.exports, "createStaffFiredMessage", () => $c8b3c18104c7e1a2$export$81d4429ab968af0d);
$parcel$export(module.exports, "createInjuryReturnPowerupMessage", () => $c8b3c18104c7e1a2$export$e9710b0db133aa1b);
$parcel$export(module.exports, "createResignPowerupMessage", () => $c8b3c18104c7e1a2$export$6414cc24851bea6e);
$parcel$export(module.exports, "createRetirementReturnPowerupMessage", () => $c8b3c18104c7e1a2$export$43067a8e54ac4e9b);
$parcel$export(module.exports, "createRetirementReturnPermanentPowerupMessage", () => $c8b3c18104c7e1a2$export$7ba413458ac544a4);
$parcel$export(module.exports, "createChangeObjectivePowerupMessage", () => $c8b3c18104c7e1a2$export$718e810f88f44fe);
$parcel$export(module.exports, "createOwnerAppearancePowerupMessage", () => $c8b3c18104c7e1a2$export$8c94ee49fa7f4b4b);
$parcel$export(module.exports, "createStyleChangePowerupMessage", () => $c8b3c18104c7e1a2$export$1534d7cc078e302d);
$parcel$export(module.exports, "createRecruitmentPowerupMessage", () => $c8b3c18104c7e1a2$export$10ab0d898d915682);
$parcel$export(module.exports, "createStaffRecruitmentPowerupMessage", () => $c8b3c18104c7e1a2$export$1b3181c3a55d29b2);
$parcel$export(module.exports, "createPowerupMessage", () => $c8b3c18104c7e1a2$export$483d8c71767a5bcc);
$parcel$export(module.exports, "createPresidentFotcSuperstarMessage", () => $c8b3c18104c7e1a2$export$cf7d0abefea6bc75);
$parcel$export(module.exports, "createPresidentOverSuperstarMessage", () => $c8b3c18104c7e1a2$export$353156e0bbeda21d);
$parcel$export(module.exports, "createNoAppearancesMessage", () => $c8b3c18104c7e1a2$export$1dce07f7f31c013c);
$parcel$export(module.exports, "createLastAppearanceMessage", () => $c8b3c18104c7e1a2$export$5ab7ebb7523c562b);
$parcel$export(module.exports, "createWorkThroughInjurySuperstarMessage", () => $c8b3c18104c7e1a2$export$90addd1e7a598dcb);
$parcel$export(module.exports, "createAggravatedInjurySuperstarMessage", () => $c8b3c18104c7e1a2$export$813e08beab694ec6);
$parcel$export(module.exports, "createInjuryMessage", () => $c8b3c18104c7e1a2$export$58103e6eb9bd88d2);
$parcel$export(module.exports, "createStaffLevelUpMessage", () => $c8b3c18104c7e1a2$export$582d6ae3a030165b);
$parcel$export(module.exports, "createGimmickChangeBoostMessage", () => $c8b3c18104c7e1a2$export$cd19ebf176336906);
$parcel$export(module.exports, "createSpecialSegmentUnlockedMessage", () => $c8b3c18104c7e1a2$export$d711c474e876cd59);
$parcel$export(module.exports, "createSuperstarLevelUpMessage", () => $c8b3c18104c7e1a2$export$7198dd739b044a7);
$parcel$export(module.exports, "createTraitAcquiredMessage", () => $c8b3c18104c7e1a2$export$c77b613b8a8c4cb8);
$parcel$export(module.exports, "createObjectiveCompletedMessage", () => $c8b3c18104c7e1a2$export$a6e00006a55f1f1a);
$parcel$export(module.exports, "createTalentRequestSucceededMessage", () => $c8b3c18104c7e1a2$export$5d96f2c2c728bc7c);
$parcel$export(module.exports, "createTalentRequestFailedMessage", () => $c8b3c18104c7e1a2$export$9254f2c9f7c44130);
$parcel$export(module.exports, "createFacilityUpgradeAvailableMessage", () => $c8b3c18104c7e1a2$export$12f94e267c7af04);
$parcel$export(module.exports, "createSuperstarMarkedOutMessage", () => $c8b3c18104c7e1a2$export$2b6f7d764c000394);
$parcel$export(module.exports, "createTalentReleasedMessage", () => $c8b3c18104c7e1a2$export$483c7aead442b6fb);
$parcel$export(module.exports, "createAvailableSuperstarMessage", () => $c8b3c18104c7e1a2$export$342b89a9c658343);
$parcel$export(module.exports, "createInjuryReevaluatedMessage", () => $c8b3c18104c7e1a2$export$8a065c5389d4546a);
$parcel$export(module.exports, "createInjuryRehabMessage", () => $c8b3c18104c7e1a2$export$fb29e7848320610a);
$parcel$export(module.exports, "createWorkableInjuryRecoveryMessage", () => $c8b3c18104c7e1a2$export$9fa6001e5e14ec72);
$parcel$export(module.exports, "createIndieSuperstarAvailableMessage", () => $c8b3c18104c7e1a2$export$99e595211656966);
$parcel$export(module.exports, "createNewIndieSuperstarMessage", () => $c8b3c18104c7e1a2$export$2de6056ca7876c13);
$parcel$export(module.exports, "createNewIndieSuperstarRecruitedMessage", () => $c8b3c18104c7e1a2$export$77433a570f6bc1e7);
$parcel$export(module.exports, "createSpecialSegmentReuseMessage", () => $c8b3c18104c7e1a2$export$d0c02b6577804d07);
$parcel$export(module.exports, "createFutureSuperstarMessage", () => $c8b3c18104c7e1a2$export$c52399b7a1b0fbec);
$parcel$export(module.exports, "createChampionshipNotUsedPenaltyMessage", () => $c8b3c18104c7e1a2$export$7d7d414090c574e5);
$parcel$export(module.exports, "createStaffMemberRetirementMessage", () => $c8b3c18104c7e1a2$export$97681e1cbe84b8af);
$parcel$export(module.exports, "createStaffMemberRetirementChanceMessage", () => $c8b3c18104c7e1a2$export$1492e9cf789582c0);
$parcel$export(module.exports, "createFeudEndedMessage", () => $c8b3c18104c7e1a2$export$14a349a8caeb58f3);
$parcel$export(module.exports, "createEndFeudReminderMessage", () => $c8b3c18104c7e1a2$export$9fc25e79c884334d);
$parcel$export(module.exports, "createTrainingRosterPopularityMessage", () => $c8b3c18104c7e1a2$export$f8ef8f22686bec39);
$parcel$export(module.exports, "createTrainingRosterHotMessage", () => $c8b3c18104c7e1a2$export$b3e7fe800a610719);
$parcel$export(module.exports, "createTrainingRosterStaleMessage", () => $c8b3c18104c7e1a2$export$19f79c95691b1636);
$parcel$export(module.exports, "createBuyoutAcceptedMessage", () => $c8b3c18104c7e1a2$export$5348db63dc2841eb);
$parcel$export(module.exports, "createBuyoutAcceptedTrainerMessage", () => $c8b3c18104c7e1a2$export$c6c1b1fb539f7aa0);
$parcel$export(module.exports, "createBuyoutSigningsMessage", () => $c8b3c18104c7e1a2$export$3fc52982102fdb1c);
$parcel$export(module.exports, "createBuyoutNotAvailableSuperstarMessage", () => $c8b3c18104c7e1a2$export$823ea173c8f98a10);
$parcel$export(module.exports, "createCompetitorBuyoutAvailableMessage", () => $c8b3c18104c7e1a2$export$c74c5e781b3cd639);
$parcel$export(module.exports, "createCompetitorBuyoutNoLongerAvailableMessage", () => $c8b3c18104c7e1a2$export$6b278e5b912a9c2b);
$parcel$export(module.exports, "createNewCompetitorMessage", () => $c8b3c18104c7e1a2$export$474c35dd6bb59658);
$parcel$export(module.exports, "createCompetitorSuperstarLeavingMessage", () => $c8b3c18104c7e1a2$export$265b562fbfe4fc3c);
$parcel$export(module.exports, "createCompetitorSuperstarLeftMessage", () => $c8b3c18104c7e1a2$export$ba663bfa36edba86);
$parcel$export(module.exports, "createLeavingMessage", () => $c8b3c18104c7e1a2$export$6ee97b06511e8d31);
$parcel$export(module.exports, "createNotLeavingMessage", () => $c8b3c18104c7e1a2$export$1d9d78a93f67fed1);
$parcel$export(module.exports, "createLeftCompanyMessage", () => $c8b3c18104c7e1a2$export$bbca3ecf2ca3604c);
$parcel$export(module.exports, "createLeftCompanySuperstarMessage", () => $c8b3c18104c7e1a2$export$6d60a98123076b7b);
$parcel$export(module.exports, "createNoLongerUnhappyMessage", () => $c8b3c18104c7e1a2$export$2456db1800417fa1);
$parcel$export(module.exports, "createUnhappyMessage", () => $c8b3c18104c7e1a2$export$d9b7fe26d165884b);
$parcel$export(module.exports, "generateRamblingMessage", () => $c8b3c18104c7e1a2$export$fe3da380d444ebba);
$parcel$export(module.exports, "createTalentOfferAcceptedMessage", () => $c8b3c18104c7e1a2$export$116655fd61be27bc);
$parcel$export(module.exports, "createTalentOfferRejectedMessage", () => $c8b3c18104c7e1a2$export$94d872e963d14074);
$parcel$export(module.exports, "createTalentOfferDeclinedMessage", () => $c8b3c18104c7e1a2$export$5ac3be00fa387597);
$parcel$export(module.exports, "createTalentOfferRejectedByTalentMessage", () => $c8b3c18104c7e1a2$export$3d025fc11024ace4);
$parcel$export(module.exports, "createJoinedCompanySuperstarMessage", () => $c8b3c18104c7e1a2$export$a925917fd415feda);
$parcel$export(module.exports, "createTrainingFinishedMessage", () => $c8b3c18104c7e1a2$export$f9a3ba9ec1e696b);
$parcel$export(module.exports, "createPreparingFinishedMessage", () => $c8b3c18104c7e1a2$export$c712f48c59f18082);
$parcel$export(module.exports, "createSuperstarInterestMessage", () => $c8b3c18104c7e1a2$export$439b467071c343da);
$parcel$export(module.exports, "createSuperstarInterestedScoutMessage", () => $c8b3c18104c7e1a2$export$27d922a3d1503e08);
$parcel$export(module.exports, "createRecruitmentSuccessMessage", () => $c8b3c18104c7e1a2$export$812f9120eed34932);
$parcel$export(module.exports, "createRecruitmentFailMessage", () => $c8b3c18104c7e1a2$export$ea9c626f9fcfbd46);
$parcel$export(module.exports, "createScoutingReportMessage", () => $c8b3c18104c7e1a2$export$6f1c01a3d4cb31b8);
$parcel$export(module.exports, "createUnlearnTraitSuccessMessage", () => $c8b3c18104c7e1a2$export$68c3905bcf9bd170);
$parcel$export(module.exports, "createUnlearnTraitFailureMessage", () => $c8b3c18104c7e1a2$export$5ee78458bf3c3a9a);
$parcel$export(module.exports, "createTransitionFinishedMessage", () => $c8b3c18104c7e1a2$export$6233f5d9dfcac013);
$parcel$export(module.exports, "createTransitionToStaffFinishedMessage", () => $c8b3c18104c7e1a2$export$9fcb1a06855b95c);
$parcel$export(module.exports, "createTransitionToStaffFinishedSuperstarMessage", () => $c8b3c18104c7e1a2$export$9da892ff5cef018);
$parcel$export(module.exports, "createTransitionToSuperstarFinishedMessage", () => $c8b3c18104c7e1a2$export$85ec9ac246eaf77b);
$parcel$export(module.exports, "createReassureSuccessMessage", () => $c8b3c18104c7e1a2$export$f0a7c4172ad2e0c0);
$parcel$export(module.exports, "createReassureFailureMessage", () => $c8b3c18104c7e1a2$export$30a055452178d91c);
$parcel$export(module.exports, "createUpcomingYearlyDraftMessage", () => $c8b3c18104c7e1a2$export$c0c9e667458b07a1);
$parcel$export(module.exports, "createAnnualTournamentOwnerWinMessage", () => $c8b3c18104c7e1a2$export$4e0e588b3ba403b6);
$parcel$export(module.exports, "createAnnualTournamentWinnerMessage", () => $c8b3c18104c7e1a2$export$31ef4fc8cea99824);
$parcel$export(module.exports, "createAnnualTournamentIndieWinnerAvailableMessage", () => $c8b3c18104c7e1a2$export$bf42474a7048de5c);
$parcel$export(module.exports, "createAnnualTournamentNoCompetitorsMessage", () => $c8b3c18104c7e1a2$export$2f4cc97c13059f3f);
$parcel$export(module.exports, "createAnnualTournamentPresidentWinMessage", () => $c8b3c18104c7e1a2$export$e401d1a207627891);
$parcel$export(module.exports, "createAnnualTournamentPresidentLossMessage", () => $c8b3c18104c7e1a2$export$7eb13bd1380d7458);
$parcel$export(module.exports, "createAnnualTournamentPresidentNoParticipationMessage", () => $c8b3c18104c7e1a2$export$5664eb63c76cf3b5);
$parcel$export(module.exports, "createIntroducePowerupsMessage", () => $c8b3c18104c7e1a2$export$205ed0894b6a9822);
$parcel$export(module.exports, "createIntroduceSpecialSegmentsMessage", () => $c8b3c18104c7e1a2$export$d220fbea5737b632);
$parcel$export(module.exports, "checkToAddCurrentObjectivesMessage", () => $c8b3c18104c7e1a2$export$3753c3a33c4c7fd8);
$parcel$export(module.exports, "createObjectivesReviewMessage", () => $c8b3c18104c7e1a2$export$3ad0f735009c98b6);
$parcel$export(module.exports, "createPowerupsAwardedMessage", () => $c8b3c18104c7e1a2$export$74be8863da226be3);
$parcel$export(module.exports, "createBuyoutCompleteMessage", () => $c8b3c18104c7e1a2$export$65c126b446a46caa);
$parcel$export(module.exports, "createBuyoutCompleteTrainer", () => $c8b3c18104c7e1a2$export$1ec9d1b6c6653ec4);
$parcel$export(module.exports, "createBuyoutCompleteDoctorMessage", () => $c8b3c18104c7e1a2$export$776fef3db16c1d8d);
$parcel$export(module.exports, "createBuyoutJoinedCompanyMessage", () => $c8b3c18104c7e1a2$export$1830ca3b242e20f7);
$parcel$export(module.exports, "createTalentRequestDeclinedMessage", () => $c8b3c18104c7e1a2$export$a24743dc3e24d53b);
$parcel$export(module.exports, "createIntroduceSandboxModeMessage", () => $c8b3c18104c7e1a2$export$c6a94dc128bc5ded);
$parcel$export(module.exports, "createIntroducePowerupsSandboxModeMessage", () => $c8b3c18104c7e1a2$export$2121c19a14a1646a);
$parcel$export(module.exports, "createCustomStartingCompanyCompetitorMessage", () => $c8b3c18104c7e1a2$export$47559039619def5a);
$parcel$export(module.exports, "createIntroduceFacilitiesMessage", () => $c8b3c18104c7e1a2$export$fd038ba09ec4729a);
$parcel$export(module.exports, "createIntroduceStaffMembersMessage", () => $c8b3c18104c7e1a2$export$4301fe600baf9422);
$parcel$export(module.exports, "createNewCompanyStaffMemberMessage", () => $c8b3c18104c7e1a2$export$b16f5dfcb5e33141);
$parcel$export(module.exports, "createNewCompanyDoctorMessage", () => $c8b3c18104c7e1a2$export$85c1b77146faec0d);
$parcel$export(module.exports, "createNewCompanyScoutMessage", () => $c8b3c18104c7e1a2$export$136cee437e0e7ad5);
$parcel$export(module.exports, "createNewCompanyProducerMessage", () => $c8b3c18104c7e1a2$export$dc33c912cf2ff472);
$parcel$export(module.exports, "createNewCompanyTrainerMessage", () => $c8b3c18104c7e1a2$export$c046aa28cf3182d5);
$parcel$export(module.exports, "createNewCompanyTalentManagerMessage", () => $c8b3c18104c7e1a2$export$73275b44fecee670);
$parcel$export(module.exports, "createInvitationAcceptedMessage", () => $c8b3c18104c7e1a2$export$9be967c3b4206d3b);
$parcel$export(module.exports, "createInvitationDeclinedMessage", () => $c8b3c18104c7e1a2$export$cf55f1cb6e074043);
$parcel$export(module.exports, "createPresidentChampionInjuryMessage", () => $c8b3c18104c7e1a2$export$d4dd4f51b435b026);
$parcel$export(module.exports, "createPartTimersMessage", () => $c8b3c18104c7e1a2$export$95a688ed2164fce9);
$parcel$export(module.exports, "createTraitLostMessage", () => $c8b3c18104c7e1a2$export$35e81819773402f1);
$parcel$export(module.exports, "createRetirementMessage", () => $c8b3c18104c7e1a2$export$9c1182cca2f7b05f);
$parcel$export(module.exports, "createContractsChangeMessage", () => $c8b3c18104c7e1a2$export$db71b5d15cb15b80);
$parcel$export(module.exports, "createPartTimersAppearancesSignedForMessage", () => $c8b3c18104c7e1a2$export$429b919c5a61c94e);
$parcel$export(module.exports, "checkForAvailableCallupsMessage", () => $c8b3c18104c7e1a2$export$6f2fff2cfb84ecd3);
$parcel$export(module.exports, "createTopSuperstarPopularityMessage", () => $c8b3c18104c7e1a2$export$af1aca878ff2a8a8);
$parcel$export(module.exports, "createTopSuperstarPointsMessage", () => $c8b3c18104c7e1a2$export$38420f4fd964537b);
$parcel$export(module.exports, "createStaffMemberUnavailableMessage", () => $c8b3c18104c7e1a2$export$caedc18f7264f425);
$parcel$export(module.exports, "createFormingNewCompanyPotentialMessage", () => $c8b3c18104c7e1a2$export$3cf07d251bf224da);
$parcel$export(module.exports, "createFormingNewCompanyNewOwnerMessage", () => $c8b3c18104c7e1a2$export$e56a808c05f6079b);
$parcel$export(module.exports, "createFormingNewCompanyCurrentOwnerMessage", () => $c8b3c18104c7e1a2$export$ad29d36f654bda77);
$parcel$export(module.exports, "createNewCompanyOwnerDetailsMessage", () => $c8b3c18104c7e1a2$export$1599882fc1f4c0ab);
$parcel$export(module.exports, "createNewCompanyOwnerTalentMessage", () => $c8b3c18104c7e1a2$export$d8233f7a513a3bb5);
$parcel$export(module.exports, "createNewCompanyCurrentOwnerTalentMessage", () => $c8b3c18104c7e1a2$export$ef127244b8d2461);
$parcel$export(module.exports, "createNewCompanyInterestedTalentMessage", () => $c8b3c18104c7e1a2$export$fa69819c89d1c9dd);
$parcel$export(module.exports, "createNewCompanyJoinedTalentMessage", () => $c8b3c18104c7e1a2$export$e728d06ec98ca69c);

var $14eBR = parcelRequire("14eBR");

var $3E8Nt = parcelRequire("3E8Nt");

var $6dDCX = parcelRequire("6dDCX");

var $iRMwH = parcelRequire("iRMwH");

var $9esFv = parcelRequire("9esFv");

var $8A6FL = parcelRequire("8A6FL");

var $4rksk = parcelRequire("4rksk");

var $5kTkA = parcelRequire("5kTkA");

var $1olyO = parcelRequire("1olyO");

var $1JSre = parcelRequire("1JSre");

var $TqG49 = parcelRequire("TqG49");

var $18vSN = parcelRequire("18vSN");

var $kpu3X = parcelRequire("kpu3X");

var $jDtEn = parcelRequire("jDtEn");

var $dl5u4 = parcelRequire("dl5u4");

var $3MfBd = parcelRequire("3MfBd");
async function $c8b3c18104c7e1a2$export$8c20ab16ac9cf14f() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const messages = await (0, $9esFv.getCompanyMessages)(selectedCompany);
    messages.sort((a, b)=>b.year - a.year || b.month - a.month || b.$loki - a.$loki);
    data["messages"] = messages.map((x)=>$c8b3c18104c7e1a2$var$getMessageData(x, currentGame.monthCount, currentGame.year));
    // Check tutorial action
    if (selectedCompany.storyName === "tutorial") {
        data["nextTutorialState"] = await (0, $3MfBd.checkToGoToNextTutorialState)(selectedCompany, [
            "view_messages"
        ]);
        (0, $14eBR.db).saveDatabase();
    }
    return data;
}
async function $c8b3c18104c7e1a2$export$c1bb551219164dcd({ uid: uid } = {}) {
    let data = {};
    let message = await (0, $14eBR.Messages).get(uid);
    if (message) message.read = true;
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $c8b3c18104c7e1a2$export$b7572a81e749f23f({ uid: uid } = {}) {
    let data = {};
    let message = await (0, $14eBR.Messages).get(uid);
    if (message) {
        await (0, $14eBR.Messages).remove(message);
        (0, $14eBR.db).saveDatabase();
    }
    return data;
}
async function $c8b3c18104c7e1a2$export$9b6480ac8f0abd9f({ read: read } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    let messages = await (0, $9esFv.getCompanyMessages)(selectedCompany);
    if (read) messages = messages.filter((x)=>x.read);
    for (const message of messages)await (0, $14eBR.Messages).remove(message);
    (0, $14eBR.db).saveDatabase();
    return data;
}
function $c8b3c18104c7e1a2$var$getMessageData(message, month, year) {
    let data = {};
    data["subject"] = message.subject;
    data["content"] = message.content;
    data["fromName"] = message.fromName;
    data["read"] = message.read;
    data["tag"] = message.tag;
    data["month"] = message.month;
    data["year"] = message.year;
    data["uid"] = message.$loki;
    data["monthsPassed"] = (0, $3E8Nt.getMonthsDifference)(month, year, message.month, message.year);
    data["subject"] = message.subject;
    data["subject"] = message.subject;
    return data;
}
async function $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, fromName, month, year, content = null, tag = null) {
    const newMessage = (0, $6dDCX.Message)();
    newMessage.subject = subject;
    newMessage.fromName = fromName;
    newMessage.content = content;
    newMessage.tag = tag;
    newMessage.month = month;
    newMessage.year = year;
    await (0, $14eBR.Messages).insert(newMessage);
    return newMessage;
}
async function $c8b3c18104c7e1a2$export$ef5c2e57eebf55b2(staffMember, month, year) {
    const rambling = (0, $3E8Nt.getRandomChoice)((0, $3E8Nt.staffHiredRamblings));
    const subject = rambling["subject"];
    const newMessageText = `<p>${rambling["content"]}</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, staffMember.name, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$81d4429ab968af0d(staffMember, month, year) {
    const rambling = (0, $3E8Nt.getRandomChoice)((0, $3E8Nt.staffFiredRamblings));
    const subject = rambling["subject"];
    const newMessageText = `<p>${rambling["content"]}</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, staffMember.name, month, year, newMessageText, "staff");
}
function $c8b3c18104c7e1a2$export$e9710b0db133aa1b(superstar, month, year, doctor = null) {
    const subject = "Early return";
    const content = `<p>I'm not sure how it was possible, but ${superstar.name} is ready to return to the ring. It's amazing how soon ${superstar.pronoun} recovered.</p>`;
    const messageFrom = doctor ? doctor.name : "Staff";
    const tag = "staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, tag);
}
async function $c8b3c18104c7e1a2$export$6414cc24851bea6e(superstar, month, year) {
    const subject = "Here to stay";
    const content = "<p>No more part-time wrestling for me. I'm ready to wrestle every week and every month.</p>";
    const messageFrom = superstar.name;
    const tag = "superstar";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, tag);
}
async function $c8b3c18104c7e1a2$export$43067a8e54ac4e9b(superstar, month, year) {
    const subject = "Return";
    const content = "<p>It's great to be back. I can't wait for my return match.</p>";
    const messageFrom = superstar.name;
    const tag = "superstar";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, tag);
}
async function $c8b3c18104c7e1a2$export$7ba413458ac544a4(superstar, month, year) {
    const subject = "Full return";
    const content = "<p>I'm back, and I'm not going away after a couple appearances. I'm here to stay and wrestle.</p>";
    const messageFrom = superstar.name;
    const tag = "superstar";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, tag);
}
async function $c8b3c18104c7e1a2$export$718e810f88f44fe(objective, company, month, year) {
    const subject = "New goal";
    const content = '<p>I want you to put your focus on my new goal:</p><p class="goal-color">' + objective.name.replace("*", '<i class="fa fa-star margin-left-3"></i>') + "</p>";
    const messageFrom = company.ownerName || "Owner";
    const tag = "owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, tag);
}
async function $c8b3c18104c7e1a2$export$8c94ee49fa7f4b4b(company, month, year) {
    const subject = "Booking";
    const content = "I'm gonna be stepping into the ring soon. You better book me well!";
    const messageFrom = company.ownerName || "Owner";
    const tag = "owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, tag);
}
async function $c8b3c18104c7e1a2$export$1534d7cc078e302d(style, company, month, year) {
    const subject = "Style Change";
    const content = `<p>From now on, we're going to be changing the style of our product to ${(0, $3E8Nt.toTitleCase)(style)}. I want you to work that style for all of our shows.</p>`;
    const messageFrom = company.ownerName || "Owner";
    const tag = "owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, tag);
}
async function $c8b3c18104c7e1a2$export$10ab0d898d915682(topSuperstar, trainer, company, month, year) {
    const subject = "New recruits";
    const content = `The Training Roster got some new recruits recently. ${topSuperstar.name} in particular looks to be a great prospect.</p>`;
    const messageFrom = trainer ? trainer.name : "Staff";
    const tag = "staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, tag);
}
async function $c8b3c18104c7e1a2$export$1b3181c3a55d29b2(topStaffMember, talentManager, company, month, year) {
    const subject = "New prospects";
    const content = `Some new professionals listed themselves for hire on the Staff Hiring Board. ${topStaffMember.name} in particular looks to be a great ${(0, $3E8Nt.toTitleCase)(topStaffMember.role.replace("_", " "))}.</p>`;
    const messageFrom = talentManager ? talentManager.name : "Staff";
    const tag = "staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, tag);
}
async function $c8b3c18104c7e1a2$export$483d8c71767a5bcc(powerup, month, year, unlock = true) {
    let powerupsImage = (0, $kpu3X.getPowerupImage)(powerup);
    let powerupHtml = '<p class="black">' + powerupsImage + '<span class="top--10px margin-left-5">' + powerup.name + "</span>" + "</p>";
    let subject;
    let text;
    if (powerup.storyName === "mars") {
        if (unlock) {
            subject = "Experiment discovered";
            text = "A powerful experiment has been discovered from Zholov's notes.";
        } else {
            subject = "Experiment re-use";
            text = "I've managed to create a re-use of one of Zholov's experiments.";
        }
    } else if (unlock) {
        subject = "Artifact discovered";
        text = "A powerful wrestling artifact has been discovered.";
    } else {
        subject = "Artifact re-use";
        text = "I've managed to create a re-use of one of our wrestling artifacts.";
    }
    text = "<p>" + text + "</p>";
    text += powerupHtml;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, "Mysterious Advisor", month, year, text);
}
async function $c8b3c18104c7e1a2$export$cf7d0abefea6bc75(superstar, game, month, year) {
    const presidentData = (0, $18vSN.getPresidentData)(game);
    const subject = "Icon";
    const content = `<p>${superstar.name} has become quite the icon for your company. It would be great to have ${superstar.objectivePronoun} participate in the next TGI; ${superstar.pronoun} could even be your winner!`;
    const messageFrom = presidentData["name"];
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content);
}
async function $c8b3c18104c7e1a2$export$353156e0bbeda21d(superstar, game, month, year) {
    const presidentData = (0, $18vSN.getPresidentData)(game);
    const newMessageText = `<p>${superstar.name} has gotten quite over with the fans, hasn't ${superstar.pronoun}? We would love to see ${superstar.objectivePronoun} compete at the next TGI.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Over", presidentData["name"], month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$1dce07f7f31c013c(superstar, month, year, talentManager) {
    const subject = "Out of Appearances";
    const content = `<p>${superstar.name} has run out of appearances for this company year.</p><p>You can wait for ${superstar.objectivePronoun} to re-sign next year, though I\'ve heard that some powerful Artifacts can lead to immediate re-signing.</p>`;
    const messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, "staff");
}
async function $c8b3c18104c7e1a2$export$5ab7ebb7523c562b(superstar, month, year, talentManager) {
    const subject = "Last Appearance";
    const content = `<p>${superstar.name} is on ${superstar.possessivePronoun} last appearances for this company year. Use ${superstar.objectivePronoun} wisely.</p>`;
    const messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, content, "staff");
}
async function $c8b3c18104c7e1a2$export$90addd1e7a598dcb(superstar, month, year) {
    const messageData = (0, $3E8Nt.getRandomChoice)((0, $4rksk.superstarWorkThroughInjuryTexts));
    const subject = messageData["subject"];
    const content = `<p>${messageData["content"]}</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, superstar.name, month, year, content, "superstar");
}
async function $c8b3c18104c7e1a2$export$813e08beab694ec6(superstar, month, year) {
    const messageData = (0, $3E8Nt.getRandomChoice)((0, $4rksk.superstarAggravatedInjuryTexts));
    const subject = messageData["subject"];
    const content = `<p>${messageData["content"]}</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, superstar.name, month, year, content, "superstar");
}
function $c8b3c18104c7e1a2$export$58103e6eb9bd88d2(injuryTime, superstar, injuryType, workingThroughInjury, month, year, doctor = null) {
    let newMessageText;
    // Injury extended
    if (workingThroughInjury) {
        newMessageText = `<p>${superstar.name.trim()}'s injury has worsened and turned into a ${superstar.injuryName}. `;
        newMessageText += `The return timeline has been extended to ${injuryTime} months.</p>`;
        newMessageText += "<p>You can get away with working through an injury sometimes, but often it only aggravates the issue.</p>";
    } else {
        newMessageText = `<p>${superstar.name.trim()}'s injury was diagnosed as a ${superstar.injuryName}. `;
        if (injuryType === "workable") {
            const monthsWord = Math.round(injuryTime) === 1 ? "month" : "months";
            newMessageText += `Fortunately, it's only a small issue that should clear up in about ${injuryTime} ${monthsWord}.` + "</p><p>It is possible to work through the injury, but I would not recommend it " + "as it could make things worse.</p>";
        } else newMessageText += `${(0, $3E8Nt.toTitleCase)(superstar.pronoun)} should be able to return in ${injuryTime} months.</p>`;
    }
    // Check if rehab possible
    if (doctor && doctor.level >= 2 && superstar.injured >= 3) newMessageText += `<p>You can assign me to rehab ${superstar.name} by selecting ${superstar.objectivePronoun}` + ` under <span class="prominent-grey">Manage > Roster > View</span> and clicking on ` + '<span class="prominent-grey">Rehab</span>.</p>';
    const messageFrom = doctor ? doctor.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Injury", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$582d6ae3a030165b(staffMember, month, year) {
    let newMessageText = "<p>After recent work, I noticed that my skills have increased.</p>";
    if (staffMember.role === "doctor") {
        if (staffMember.level === 2) {
            newMessageText += "<p>I can now provide a shorter range on a Superstar's injury return timeline.</p>";
            newMessageText += "<p>Oh, and with the Rehab Facility (Level 2 Medical), I can offer rehab services to injured Superstars, bringing their returns closer.</p>";
            newMessageText += '<p>To assign me to rehab a talent, go to your Roster under <span class="prominent-grey">Manage > Roster > View</span>, select an injured talent and click on <span class="prominent-grey">Rehab</span>.</p>';
        } else if (staffMember.level === 3) {
            newMessageText += "<p>I can now provide a certain month for a Superstar's return.</p>";
            newMessageText += "<p>Oh, and with the Advanced (Level 3) Medical Facility, my rehab services for injured Superstars can have a higher chance to bring their returns closer.</p>";
        }
    } else if (staffMember.role === "scout") {
        if (staffMember.level === 2) {
            newMessageText += "<p>I can now produce Researched Reports on indie talent, which includes Popularity, Contract Status, Workrate, Charisma, Morale, Fatigue and any Injuries. I also have Researched Info compiled for all available talent and Basic Info for all unavailable talent.</p>";
            newMessageText += "<p>I also have a higher chance to recruit talent and a decent chance to recruit them while scouting.</p>";
            newMessageText += "<p>Oh, and with the Interest-building Facility (Level 2 Scouting), I can get indie talent interested in joining our company, reducing their signing cost. My recruitment also has a slight chance to build interest.</p>";
        } else if (staffMember.level === 3) {
            newMessageText += "<p>I can now produce Deep Reports on indie talent, which includes Overness, Gimmick, Alignment, Traits and Face of the Company Status. I also have Deep Info compiled for all available talent and Researched Info for all unavailable talent, and I can view Talent Stats for competitors.</p>";
            newMessageText += "<p>I now have a higher chance to recruit talent and get them interested. I also have a good chance to recruit them while scouting and a decent chance to get them interested while recruiting.</p>";
            newMessageText += "<p>And with the Indie Tracking Facility (Level 3 Scouting), I can automatically recruit new talent that join the Indies!</p>";
        }
    } else if (staffMember.role === "producer") {
        if (staffMember.level === 2) {
            newMessageText += "<p>My attempts to improve segments by focusing on them have a bigger effect and a higher chance to succeed.</p>";
            newMessageText += "<p>I can now create the following packages:</p>";
            newMessageText += "<p>- Return Package</p>";
            newMessageText += "<p>- Debut Package</p>";
            newMessageText += "<p>- Champion Package</p>";
            newMessageText += "<p>My packages will also be better in quality and I will boost new gimmicks upon debut.</p>";
            newMessageText += "<p>I can also add the following match finishes:</p>";
            newMessageText += "<p>- Switch Association</p>";
            newMessageText += "<p>- Throw In Towel</p>";
            newMessageText += "<p>- Respectful End</p>";
            newMessageText += "<p>- By Any Means</p>";
            newMessageText += "<p>Oh, and with the Championship Gimmicks Facility (Level 2 Production), you can add gimmicks to custom championships!</p>";
        } else if (staffMember.level === 3) {
            newMessageText += "<p>My attempts to improve segments by focusing on them have an even higher chance to succeed.</p>";
            newMessageText += "<p>I can now create the following packages:</p>";
            newMessageText += "<p>- Career Package</p>";
            newMessageText += "<p>- Day in the Life</p>";
            newMessageText += "<p>My packages will also be better in quality and I will further boost new gimmicks upon debut.</p>";
            newMessageText += "<p>I can also add the following match finishes:</p>";
            newMessageText += "<p>- Screwjob</p>";
            newMessageText += "<p>- Passout</p>";
            newMessageText += "<p>Oh, and with the Focused Packages Facility (Level 3 Production), I can create custom production packages! Go to book a Segment and you'll see a Custom Package option where you can tell me what to produce.</p>";
        }
    } else if (staffMember.role === "trainer") {
        if (staffMember.level === 2) {
            newMessageText += "<p>My training program will now help talent gain a larger amount of experience (28 XP) and they will gain more experience (+ 1.5 XP) during Matches and Segments as well.</p>";
            newMessageText += "<p>I can now prepare specific talent in the Training Roster to make them available for callups. I will need two months for this in order to wrap up their affairs.</p>";
        } else if (staffMember.level === 3) {
            newMessageText += "<p>My training program will now help talent gain an even larger amount of experience (40 XP) and they will gain more experience (+ 1.5 XP) during Matches and Segments as well.</p>";
            newMessageText += "<p>I can now prepare specific talent in the Training Roster to make them available for callups in one month instead of two.</p>";
            newMessageText += "<p>And with the Accelerated Training Facility (Level 3 Training), I can easily bring newly signed talent straight to the Main Roster.</p>";
        }
    } else if (staffMember.role === "talent_manager") {
        if (staffMember.level === 2) {
            newMessageText += "<p>My attempts to reassure talent have a bigger effect and a higher chance to succeed. I also have a higher chance to keep unhappy talent from leaving.</p>";
            newMessageText += "<p>Oh, and with the Guaranteed Appearances Facility (Level 2 Talent Management), I can negotiate a minimum of 3 appearances with part-timers when they re-sign at the end of the year.</p>";
        } else if (staffMember.level === 3) {
            newMessageText += "<p>My attempts to reassure talent have an even bigger effect and a higher chance to succeed. I also have an even higher chance to keep unhappy talent from leaving and I can negotiate a minimum of 5 appearances with part-timers when they re-sign at the end of the year.</p>";
            newMessageText += "<p>Also, with the Company Acquisition Facility (Level 3 Talent Management), I can negotiate deals with a large number of talent from the company we are buying out.</p>";
        }
    }
    const messageFrom = staffMember.name;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Skill Increase", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$cd19ebf176336906(superstar, momentName, month, year, talentManager = null) {
    const newMessageText = `<p>Due to the <span class="olive">${momentName}</span>, a Gimmick change boost is available ` + `for ${superstar.name}.</p><p>If you change ${superstar.possessivePronoun} Gimmick before ` + `${superstar.possessivePronoun} next appearance, a boost will be added to the new Gimmick and the change will be free.</p>`;
    const messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Gimmick Change", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$d711c474e876cd59(segmentItem, month, year) {
    const itemImage = '<img alt="Special Segments" src="static/www/static/special_segments_icon.png"/>';
    const itemHtml = `<p class="special-segment-color">${itemImage}<span class="top--12px margin-left-5">${segmentItem.name}</span></p>`;
    const messageSubject = "Special Segment";
    let newMessageText = "<p>A special segment has been uncovered.</p>";
    newMessageText += itemHtml;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, "Mysterious Advisor", month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$7198dd739b044a7(trainer, superstar, skill, month, year) {
    let skillHtml;
    if (skill === "workrate") skillHtml = `<span class="workrate-blue">${(0, $3E8Nt.toTitleCase)(skill)}</span>`;
    else if (skill === "charisma") skillHtml = `<span class="charisma-purple">${(0, $3E8Nt.toTitleCase)(skill)}</span>`;
    const newMessageText = `<p>After recent performances, I noticed that ${superstar.name}'s ${skillHtml} skill has increased.</p>`;
    const messageFrom = trainer ? trainer.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Skill Increase", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$c77b613b8a8c4cb8(superstar, trait, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const canUnlearnTrait = (0, $5kTkA.checkIfCanUnlearnTrait)(trait);
    const messageSubject = "Trait Acquired";
    let newMessageText = `<p>After a recent check up on ${superstar.name}, I noticed that ${superstar.pronoun} has ` + `acquired the <span class="superstar-trait-color">${trait}</span> Trait.</p><p>Traits can be acquired when ` + `superstars perform certain actions.</p>`;
    if (canUnlearnTrait) newMessageText += "<p>This Trait can be unlearned though, given considerable attention and time by a capable Staff Member.</p>";
    const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    const messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$a6e00006a55f1f1a(objectiveName, reward, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const objectiveHtml = `<p class="goal-color">${objectiveName.replace("*", '<i class="fa fa-star margin-left-3"></i>')}</p>`;
    let newMessageText = "<p>Good work on completing the following goal:</p>";
    newMessageText += objectiveHtml;
    newMessageText += `<p>I have rewarded you with <span class="blue margin-left-3 margin-right-3">` + `<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ${reward}</span></p>`;
    const messageFrom = company.ownerName ? company.ownerName : "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Goal Reward", messageFrom, game.monthCount, game.year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$5d96f2c2c728bc7c(talentRequest, talent, moraleChange, month, year, talentManager, xpGained) {
    let verb = talent.objectName === "superstar" ? "is" : "are";
    let moraleChangeHtml = `<span class="margin-left-2 margin-right-2 light-green">+ ${moraleChange}` + `<span class="margin-left-2">%</span></span>`;
    let newMessageText = `<p>${talent.name} ${verb} happy that you completed ${talent.possessivePronoun} ` + `"${await (0, $1olyO.getTalentRequestName)(talentRequest)}" request and ${talent.possessivePronoun} morale ${moraleChangeHtml} ` + `has improved.</p>`;
    // Show xp gained
    if (xpGained) {
        let xpGainedHtml = `<span class="green margin-left-3 margin-right-3">+ ${xpGained} XP</span>`;
        newMessageText += `<p>I gained some experience ${xpGainedHtml} dealing with the request.</p>`;
    }
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Request completed", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$9254f2c9f7c44130(talentRequest, talent, moraleChange, month, year, talentManager) {
    const moraleChangeHtml = `<span class="margin-left-2 margin-right-2 morale-dissatisfied-color">- ${moraleChange * -1}` + `<span class="margin-left-2">%</span></span>`;
    const newMessageText = `<p>${talent.name}'s "${await (0, $1olyO.getTalentRequestName)(talentRequest)}" request was not completed in time, ` + `and as a result, ${talent.possessivePronoun} morale ${moraleChangeHtml} has dropped.</p>`;
    const messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Request failed", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$12f94e267c7af04(data, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const levelPhrases = {
        2: "a Developed",
        3: "an Advanced"
    };
    const levelPhrase = levelPhrases[data.level];
    const newMessageText = `<p>You have completed my requirements for the <span class="facility-color">${data["name"]} ` + `Facility</span> upgrade. I will now allow you to change it to ${levelPhrase} <span class="gold">Level ${data["level"]}</span>` + `Facility.</p>`;
    const messageFrom = company.ownerName || "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Upgrade Available", messageFrom, game.monthCount, game.year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$2b6f7d764c000394(superstar, segmentItemName, participant, month, year) {
    const subject = "Marked Out";
    const newMessageText = `<p>Some people may not be happy with it, but that ${segmentItemName} segment with ` + `${participant.name} made me mark out!</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, superstar.name, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$483c7aead442b6fb(talent, staffMembers, month, year, vacated = null, disbanded = null) {
    let newMessageText;
    if (talent.objectName === "superstar") newMessageText = `<p>${talent.name}'s contract has been terminated and ${talent.pronoun} has been released, as per your orders.</p>`;
    else newMessageText = `<p>${talent.name}'s contracts have been terminated and ${talent.pronoun} have been released, as per your orders.</p>`;
    if (vacated) for (let v of vacated){
        let championshipName = (0, $1JSre.getChampionshipDisplayName)(v);
        if (v.tagTeam || v.trio) newMessageText += `<p><span class="gold">${championshipName}</span> have been vacated.</p>`;
        else newMessageText += `<p><span class="gold">${championshipName}</span> has been vacated.</p>`;
    }
    if (disbanded) for (let d of disbanded)newMessageText += `<p>${d} have disbanded.</p>`;
    let talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(`${talent.name} released`, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$342b89a9c658343(superstar, overnessIncrease, month, year, doctor = null) {
    let newMessageText = `<p>${superstar.name} is ready to return to the ring.`;
    if (overnessIncrease) newMessageText += ` ${(0, $3E8Nt.toTitleCase)(superstar.possessivePronoun)} overness should get a nice boost` + ` (<span class="hot-color">+${overnessIncrease}%</span>).</p>`;
    let messageFrom = doctor ? doctor.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(`${superstar.name} available`, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$8a065c5389d4546a(injuryData, doctor, month, year) {
    const oldMonthWord = injuryData["oldTime"] === "1" ? "month" : "months";
    const newMonthWord = injuryData["time"] === "1" ? "month" : "months";
    let healingText = "";
    if (injuryData["rehabPerformed"]) healingText = ", sped up due to rehab";
    const newMessageText = `<p>${injuryData["name"]}'s return timeline from a ${injuryData["injuryName"]} has been ` + `re-evaluated from <span class="grey">${injuryData["oldTime"]} ${oldMonthWord}</span> to ` + `<span class="grey">${injuryData["time"]} ${newMonthWord}</span>${healingText}.</p>`;
    const messageFrom = doctor?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Injury update", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$fb29e7848320610a(injuryData, doctor, month, year) {
    const oldMonthWord = injuryData["oldTime"] === "1" ? "month" : "months";
    const newMonthWord = injuryData["newTime"] === "1" ? "month" : "months";
    const newMessageText = `<p>${injuryData["name"]}'s return timeline from a ${injuryData["injuryName"]} has been ` + `sped up due to rehab, changing it from <span class="grey">${injuryData["oldTime"]} ${oldMonthWord}</span> to ` + `<span class="grey">${injuryData["newTime"]} ${newMonthWord}</span>.</p>`;
    const messageFrom = doctor?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Injury rehab", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$9fa6001e5e14ec72(superstar, month, year, doctor = null) {
    const newMessageText = `<p>${superstar.name}'s injury has healed completely and ${superstar.pronoun} can now ` + `wrestle without any added risks.</p>`;
    const messageFrom = doctor ? doctor.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(`${superstar.name} cleared`, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$99e595211656966(superstar, tagTeam, month, year, scout = null) {
    let tagTeamName = tagTeam ? ` (${tagTeam.name})` : "";
    const newMessageText = `<p>${superstar.name}${tagTeamName} has made ${superstar.objectivePronoun}self available to sign from the ` + `Indies. You should give ${superstar.objectivePronoun} a look.</p>`;
    const messageFrom = scout ? scout.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Available Indie", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$2de6056ca7876c13(superstar, month, year, scout = null) {
    let newMessageText = `<p>A new talent, ${superstar.name}, has joined the Indies.</p>`;
    if (scout) newMessageText += `<p>We can try scouting or recruiting ${superstar.objectivePronoun}.</p>`;
    const messageFrom = scout?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Talent available", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$77433a570f6bc1e7(superstar, month, year, scout) {
    const reportLevels = {
        1: "Basic",
        2: "Researched",
        3: "Deep"
    };
    const newMessageText = `<p>A new talent, ${superstar.name}, joined the Indies recently. With the help of the ` + `Indie Tracking Facility, I was able to recruit ${superstar.objectivePronoun}.</p><p>Take a look at the ` + `${reportLevels[scout.level] || "Deep"} Info I compiled and see if you want to sign ${superstar.objectivePronoun}.</p>`;
    const messageFrom = scout?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("New talent", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$d0c02b6577804d07(segmentItem, month, year) {
    const itemImage = '<img alt="Special Segments" src="static/www/static/special_segments_icon.png"/>';
    const itemHtml = `<p class="special-segment-color">${itemImage}<span class="top--12px margin-left-5">${segmentItem.name}</span></p>`;
    const messageSubject = "Special Segment";
    let newMessageText = "<p>A special segment is available to re-use.</p>";
    newMessageText += itemHtml;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, "Mysterious Advisor", month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$c52399b7a1b0fbec(superstar, month, year, staffMembers, company, rosterName = "Training") {
    let newMessageText;
    if (rosterName === "Training") newMessageText = `<p>We just finished the recruitment of ${superstar.name}, who looks to be a Future Superstar.` + ` ${(0, $3E8Nt.toTitleCase)(superstar.pronoun)} has signed up with our Training Roster.</p>`;
    else if (rosterName === "Indie") newMessageText = `<p>A new talent named ${superstar.name} has arrived on the Indies. ` + `${(0, $3E8Nt.toTitleCase)(superstar.pronoun)} looks to be a Future Superstar.</p>`;
    else newMessageText = `<p>${rosterName} have completed the recruitment of a new talent, ${superstar.name}, who ` + `looks to be a Future Superstar.</p>`;
    const scout = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "scout");
    const messageFrom = scout ? scout.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Future Superstar", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$7d7d414090c574e5(championship, month, year, talentManager = null) {
    let newMessageText = `<p>You haven't booked the <span class="gold">${(0, $1JSre.getChampionshipDisplayName)(championship)}</span> in 6 months.</p>` + `<p>If you don't put it on the line this month, fans will start to lose interest and the ` + `Title's Prestige will be negatively affected.</p>`;
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Unused Championship", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$97681e1cbe84b8af(staffMember, month, year) {
    const newMessageText = `<p>I have officially retired as a staff member, so you might want to find a suitable replacement.</p>` + `<p>I'm going to enjoy my time off now. Good luck.</p>`;
    const messageFrom = staffMember?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Retired", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$1492e9cf789582c0(staffMember, month, year) {
    const newMessageText = `<p>Hey,</p><p>Just wanted to let you know that I'm thinking about retiring soon. I'm getting old, ` + `and a younger person could probably do a better job.</p><p>I'll be here this year, but I'm not sure about the coming ones.</p>`;
    const messageFrom = staffMember?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Retiring", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$14a349a8caeb58f3(feudData, company, month, year) {
    const participantNames = feudData["participants"].join(" and ");
    const newMessageText = `<p>I have ended the ${feudData["name"]} Feud between ${participantNames}. Too much time ` + `has passed since the Feud started.</p>`;
    const messageFrom = company.ownerName || "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Feud Ended", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$9fc25e79c884334d(feudData, company, month, year) {
    const participantNames = feudData["participants"].join(" and ");
    const newMessageText = `<p>The ${feudData["name"]} Feud between ${participantNames} has been going on for too long. ` + `I will automatically end it next month.</p>`;
    const messageFrom = company.ownerName || "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Long Feud", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$f8ef8f22686bec39(superstars, popularityChange, month, year, trainer) {
    const popularityChangeHtml = `<span class="green margin-left-2 margin-right-2">+ ${popularityChange}</span>`;
    const newMessageText = `<p>${(0, $3E8Nt.commaSeparate)(superstars)} gained a good amount of popularity ${popularityChangeHtml} while working ` + `the latest Training Roster Event.</p>`;
    const messageFrom = trainer?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Popularity gained", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$b3e7fe800a610719(talent, month, year, trainer) {
    const newMessageText = `<p>${talent.name} got Over with the fans at the latest Training Roster Event!</p>`;
    const messageFrom = trainer?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Hot superstar", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$19f79c95691b1636(talent, month, year, trainer) {
    const newMessageText = `<p>${talent.name} became Stale with the fans at the latest Training Roster Event ..</p>`;
    const messageFrom = trainer?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Stale superstar", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$5348db63dc2841eb(company, rosterSuperstars, available, notAvailable, month, year, talentManager) {
    let newMessageText = `<p>${company.name} have accepted the Buyout Offer we made. The details should be ` + `finalized next month. Once they are, ${company.name} will shut down and we should absorb some of their fanbase.</p>`;
    newMessageText += `<p>Out of ${rosterSuperstars.length} Superstars on the Roster, negotiations went well with ` + `about ${(0, $3E8Nt.myround)(available.length, 5)}, including ${(0, $3E8Nt.commaSeparate)(available.slice(0, 3).map((x)=>x.name))}.</p>`;
    newMessageText += `<p>The rest of the Superstars have made it clear they are not willing to sign with us, and they ` + `include names like ${(0, $3E8Nt.commaSeparate)(notAvailable.slice(0, 3).map((x)=>x.name))}.</p>`;
    newMessageText += `<p>Most of the Superstars we don't sign will move to the Indies.</p>`;
    const messageFrom = talentManager?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Buyout accepted", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$c6c1b1fb539f7aa0(company, month, year, trainer) {
    let newMessageText = `<p>Hey,</p>`;
    newMessageText += `<p>I hear you will decide which Superstars to sign from ${company.name}.</p>`;
    newMessageText += `<p>I wanted to let you know that I will send a small number of them to the Training Roster.</p>`;
    newMessageText += `<p>Looking forward to working with them.</p>`;
    const messageFrom = trainer?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Buyout signings", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$3fc52982102fdb1c(company, month, year, owner) {
    const numberOfBuyoutSignings = (0, $8A6FL.getNumberOfBuyoutSignings)(company);
    const numberOfBuyoutChampionships = 3;
    let newMessageText = `<p>We're on our way to buying out ${company.name}! Many of the Superstars there want to join  ` + `us, but we can only afford a limited number.</p>`;
    newMessageText += `<p>Once the deal goes through, I will allow you to sign a maximum of ${numberOfBuyoutSignings} ` + `Superstars. Make sure you think hard about who you want to bring on board.</p>`;
    newMessageText += `<p>I will also allow you to bring a maximum of ${numberOfBuyoutChampionships} of their ` + `Championships into our Company.</p>`;
    const messageFrom = owner || "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Buyout assets", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$823ea173c8f98a10(superstar, month, year) {
    const rambling = (0, $3E8Nt.getRandomChoice)((0, $TqG49.superstarNotAvailableBuyoutData));
    const subject = rambling["subject"];
    const newMessageText = `<p>${rambling["content"]}</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, superstar.name, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$c74c5e781b3cd639(competitor, month, year, talentManager) {
    let newMessageText = `<p>This could be really exciting news. Due to falling in reputation recently, ` + `${competitor.name} is available for a buyout.</p>`;
    newMessageText += "<p>We can only make an offer if we have the Company Acquisition Facility (Level 3 Talent Management).</p>";
    newMessageText += '<p>To make an offer, go to <span class="prominent-grey">Manage > Job > Companies</span> and click the <span class="prominent-grey">Buyout</span> button.</p>';
    const messageFrom = talentManager?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Buyout", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$6b278e5b912a9c2b(competitor, month, year, talentManager) {
    const newMessageText = `<p>Due to new developments behind-the-scenes, ${competitor.name} is no longer available for a buyout.</p>`;
    const messageFrom = talentManager?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Buyout Off", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$474c35dd6bb59658(competitor, owner, topSuperstars, month, year, talentManager) {
    let newMessageText = `<p>A new wrestling Company, ${competitor}, has opened up, led by ${owner}.</p>`;
    newMessageText += `<p>A lot of talented Superstars have joined the Company, including ${(0, $3E8Nt.commaSeparate)(topSuperstars)}.</p>`;
    newMessageText += "<p>We should keep a close eye on how well they do.</p>";
    const messageFrom = talentManager?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("New Competitor", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$265b562fbfe4fc3c(superstar, competitor, month, year, scout = null) {
    let newMessageText = `<p>${superstar.name} is unhappy in ${competitor.name} and will be leaving when ` + `${superstar.possessivePronoun} contract expires.</p>`;
    newMessageText += `<p>If we make an offer now, ${competitor.name} might accept a lower amount than normal.</p>`;
    newMessageText += `<p>To make an offer, go to <span class="prominent-grey">Manage > Roster > View</span>, ` + `select the competitor in the dropdown, then select the talent and click on <span class="prominent-grey">Negotiate</span>.</p>`;
    const messageFrom = scout?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Potential Negotiation", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$ba663bfa36edba86(superstar, company, month, year, scout = null) {
    const newMessageText = `<p>${superstar.name} has left ${company.name} due to ${superstar.possessivePronoun} ` + `contract ending. We can try to sign ${superstar.objectivePronoun} from the Indies.</p>`;
    const messageFrom = scout?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Available Superstar", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$6ee97b06511e8d31(superstar, month, year, talentManager) {
    const newMessageText = `<p>${superstar.name} has decided to leave the company when ${superstar.possessivePronoun} ` + `contract expires in ${superstar.contractMonthsRemaining} months. Due to ${superstar.possessivePronoun} ` + `unhappiness, ${superstar.pronoun} is not willing to stay on longer.</p><p>However, if you can make ` + `${superstar.name} happy before ${superstar.pronoun} leaves, we might be able to get ${superstar.objectivePronoun} to re-sign.</p>`;
    const messageFrom = talentManager?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(`${superstar.name} leaving`, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$1d9d78a93f67fed1(superstar, month, year, talentManager) {
    const newMessageText = `<p>Due to your efforts to make ${superstar.objectivePronoun} happy, we were able to ` + `convince ${superstar.name} to re-sign with the company.</p><p>${(0, $3E8Nt.toTitleCase)(superstar.pronoun)} is willing to stay with us ` + `for the foreseeable future.</p>`;
    const messageFrom = talentManager?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(`${superstar.name} staying`, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$bbca3ecf2ca3604c(superstar, month, year, company, disbanded = [], vacated = []) {
    let newMessageText = `<p>${superstar.name} refused our attempts to re-sign and ${superstar.possessivePronoun} ` + `contract ran out. ${(0, $3E8Nt.toTitleCase)(superstar.pronoun)} is no longer with the company.</p>`;
    for (const tagTeam of disbanded)newMessageText += `<p>${tagTeam} have disbanded.</p>`;
    for (const championship of vacated){
        const championshipName = (0, $1JSre.getChampionshipDisplayName)(championship);
        if (championship.tagTeam || championship.trio) newMessageText += `<p><span class="gold">${championshipName}</span> have been vacated.</p>`;
        else newMessageText += `<p><span class="gold">${championshipName}</span> has been vacated.</p>`;
    }
    const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    const messageFrom = talentManager?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(`${superstar.name} left`, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$6d60a98123076b7b(superstar, month, year) {
    const rambling = (0, $3E8Nt.getRandomChoice)((0, $TqG49.superstarLeftRamblings));
    const subject = rambling.subject;
    const newMessageText = `<p>${rambling.content}</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, superstar.name, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$2456db1800417fa1(superstar, month, year, talentManager, xpGained = null) {
    let newMessageText = `<p>After a talk with ${superstar.name}, ${superstar.pronoun} is no longer unhappy with ${superstar.possessivePronoun} position in the company.</p>`;
    newMessageText += `<p>${superstar.pronoun.charAt(0).toUpperCase() + superstar.pronoun.slice(1)} said ${superstar.pronoun} is willing to stay here and work with us.</p>`;
    if (xpGained) {
        const xpGainedHtml = `<span class="green margin-left-3 margin-right-3">+ ${xpGained} XP</span>`;
        newMessageText += `<p>I also gained some experience ${xpGainedHtml} after the talk.</p>`;
    }
    const messageFrom = talentManager?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(`${superstar.name} not unhappy`, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$d9b7fe26d165884b(superstar, month, year, talentManager) {
    const newMessageText = `<p>${superstar.name} is unhappy with how we're using ${superstar.objectivePronoun}. ` + `If we don't do anything about it, ${superstar.pronoun} might decide to leave the company when ` + `${superstar.possessivePronoun} contract expires.</p>`;
    const messageFrom = talentManager?.name || "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(`${superstar.name} unhappy`, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$fe3da380d444ebba(superstars, company) {
    const pick = (0, $3E8Nt.getRandomInt)(0, 100);
    let messageFrom, tag, rambling;
    if (pick <= 85) {
        messageFrom = (0, $3E8Nt.getRandomChoice)(superstars).name;
        tag = "superstar";
        rambling = (0, $3E8Nt.getRandomChoice)((0, $TqG49.superstarRamblings));
    } else if (pick <= 94) {
        messageFrom = company.ownerName ? company.ownerName : "Owner";
        tag = "owner";
        rambling = (0, $3E8Nt.getRandomChoice)((0, $TqG49.ownerRamblings));
    } else if (pick <= 98) {
        tag = "staff";
        const availableStaffMembers = await (0, $8A6FL.getAvailableStaffMembers)(await (0, $9esFv.getCompanyStaff)(company));
        if (availableStaffMembers.length > 0) messageFrom = (0, $3E8Nt.getRandomChoice)(availableStaffMembers).name;
        else messageFrom = "Staff";
        rambling = (0, $3E8Nt.getRandomChoice)((0, $TqG49.staffRamblings));
    } else {
        messageFrom = "Mysterious Advisor";
        tag = "";
        rambling = (0, $3E8Nt.getRandomChoice)((0, $TqG49.mysteriousAdvisorRamblings));
    }
    const subject = rambling["subject"];
    const content = rambling["content"];
    return $c8b3c18104c7e1a2$var$createUniqueMessage(content, subject, messageFrom, tag, company);
}
async function $c8b3c18104c7e1a2$var$createUniqueMessage(content, subject, messageFrom, tag, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const gameMessagesSubjects = (await (0, $9esFv.getCompanyMessages)(company)).map((x)=>x.subject);
    if (!gameMessagesSubjects.includes(subject)) return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, game.monthCount, game.year, `<p>${content}</p>`, tag);
    return false;
}
async function $c8b3c18104c7e1a2$export$116655fd61be27bc(talent, month, year, company) {
    let verb = talent.objectName === "superstar" ? "is" : "are";
    let newMessageText = `<p>We have accepted your offer for ${talent.name}. ${(0, $3E8Nt.toTitleCase)(talent.pronoun)} ${verb} ` + `ready to work for you immediately.</p>`;
    let messageFrom = company.ownerName ? company.ownerName : `Owner - ${company.name}`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Offer accepted", messageFrom, month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$94d872e963d14074(talent, month, year, company) {
    let verb = talent.objectName === "superstar" ? "is" : "are";
    let newMessageText = `<p>We have declined the offer you made for ${talent.name}. ${(0, $3E8Nt.toTitleCase)(talent.pronoun)} ` + `${verb} too valuable for us to let go of right now.</p>`;
    let messageFrom = company.ownerName ? company.ownerName : `Owner - ${company.name}`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Offer rejected", messageFrom, month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$5ac3be00fa387597(talent, month, year, company) {
    let verb = talent.objectName === "superstar" ? "is" : "are";
    let newMessageText = `<p>${talent.name} ${verb} not happy with how we handled the offer for ${talent.objectivePronoun}. ` + `The decision to not let ${talent.objectivePronoun} leave impacted ${talent.possessivePronoun} morale quite a bit.</p>`;
    let talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(`${talent.name} not happy`, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$3d025fc11024ace4(talent, month, year, company) {
    let personalPronoun = talent.objectName === "superstar" ? "I" : "we";
    let objectivePronoun = talent.objectName === "superstar" ? "me" : "us";
    let newMessageText = `<p>${(0, $3E8Nt.toTitleCase)(personalPronoun)} have decided to sign with ${company.name} instead. They ` + `made a better offer and ${personalPronoun} believe they will be a good fit for ${objectivePronoun}.</p>`;
    let messageFrom = talent.name;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Offer rejected", messageFrom, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$a925917fd415feda(superstar, month, year) {
    const rambling = (0, $3E8Nt.getRandomChoice)((0, $TqG49.superstarJoinedRamblings));
    const subject = rambling["subject"];
    const newMessageText = `<p>${rambling["content"]}</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, superstar.name, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$f9a3ba9ec1e696b(talent, trainingData, month, year, trainer) {
    let xpWord = "small";
    if (trainingData["xpGained"] >= 40) xpWord = "large";
    else if (trainingData["xpGained"] >= 30) xpWord = "significant";
    else if (trainingData["xpGained"] >= 20) xpWord = "decent";
    let skillHtml = "";
    if (trainingData["skill"] === "workrate") skillHtml = `<span class="workrate-blue">${(0, $3E8Nt.toTitleCase)(trainingData["skill"])}</span>`;
    else if (trainingData["skill"] === "charisma") skillHtml = `<span class="charisma-purple">${(0, $3E8Nt.toTitleCase)(trainingData["skill"])}</span>`;
    let newMessageText = `<p>${talent.name}'s training is now complete. ${(0, $3E8Nt.toTitleCase)(talent.pronoun)} gained a ` + `${xpWord} amount of experience (${trainingData["xpGained"]} XP) in ${talent.possessivePronoun} ${skillHtml} skill.</p>`;
    let messageFrom = trainer ? trainer.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Training finished", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$c712f48c59f18082(talent, month, year, trainer) {
    let newMessageText = `<p>${talent.name}'s preparation for being called up is now complete. ` + `${(0, $3E8Nt.toTitleCase)(talent.pronoun)} will be available at the next callup.</p>`;
    let messageFrom = trainer ? trainer.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Preparation complete", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$439b467071c343da(superstar, scout, month, year) {
    const newMessageText = `<p>Hey,</p><p>I had your scout, ${scout.name}, approach me recently. I wanted to personally ` + `tell you that I am currently interested in coming on board and working for your company.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Interested", superstar.name, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$27d922a3d1503e08(superstar, scout, month, year) {
    const newMessageText = `<p>I managed to get ${superstar.name}, who is available to sign in the Indies, interested ` + `in joining our company. You should be able to sign ${superstar.objectivePronoun} for a lower cost, though the ` + `interest will go away with time.</p>`;
    const messageFrom = scout ? scout.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Interest developed", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$812f9120eed34932(talent, month, year, scout, interested = false) {
    const reportLevels = {
        1: "Basic",
        2: "Researched",
        3: "Deep"
    };
    let newMessageText = `<p>I managed to successfully recruit ${talent.name} and ${talent.pronoun} ` + `${talent.pronoun === "they" ? "are" : "is"} now available to sign in the Indies.</p>`;
    if (interested) newMessageText += `<p>The recruitment went so well that ${talent.name} is interested in joining our company, ` + `which means you can sign ${talent.objectivePronoun} for a lower cost.</p>`;
    newMessageText += `<p>Have a look at the ${reportLevels[scout.level] || "Deep"} Info I compiled (in the Indies view) ` + `and see if you want to sign ${talent.objectivePronoun}.</p>`;
    const messageFrom = scout ? scout.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Recruitment success", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$ea9c626f9fcfbd46(talent, month, year, scout) {
    const newMessageText = `<p>I was unsuccessful in recruiting ${talent.name}. We can try again this month though.</p>`;
    const messageFrom = scout ? scout.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Recruitment failure", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$6f1c01a3d4cb31b8(data, scout, month, year, recruited = false) {
    const reportAttributes = {
        1: [
            "rank",
            "age",
            "pronoun",
            "unhappy",
            "status",
            "appearances"
        ],
        2: [
            "popularity",
            "charisma",
            "workrate",
            "injured",
            "fatigue",
            "morale"
        ],
        3: [
            "overness",
            "gimmick",
            "alignment",
            "faceOfTheCompany",
            "cyborg",
            "traits"
        ]
    };
    const reportLevels = {
        1: "Basic",
        2: "Researched",
        3: "Deep"
    };
    const scoutLevel = scout ? scout.level : 1;
    let newMessageText = `<p>The ${reportLevels[scoutLevel] || "Deep"} Report on ${data["name"]} is complete. Here are the details: </p>`;
    for (let [level, attributes] of Object.entries(reportAttributes)){
        // Get attributes for scouting level
        level = Number(level);
        if (scoutLevel >= level) // Get attributes that are present in data
        for (let attribute of attributes.filter((x)=>Object.keys(data).includes(x))){
            let value = data[attribute];
            // Add pronoun
            if (attribute === "pronoun") {
                // Don't show pronoun for teams
                if (data["objectName"] === "tagTeam") continue;
                value = (0, $3E8Nt.toTitleCase)(String(value));
            }
            // Add stats
            if ([
                "workrate",
                "charisma"
            ].includes(attribute)) {
                if (typeof value === "number" && !Number.isInteger(value)) value = `${value.toFixed(1)} / 3`;
                else value = `${value} / 3`;
            }
            // Add injured
            if (attribute === "injured" && value) {
                let injuredMonthWord = value === 1 ? "month" : "months";
                value = `${value} ${injuredMonthWord}`;
            }
            // Add hot/stale
            if (attribute === "overness") {
                value = `${value}%`;
                if (data["hot"]) value += " (hot)";
                else if (data["stale"]) value += " (stale)";
            }
            // Add alignment data
            if (attribute === "alignment") {
                if (!value) value = "Neutral";
                value = (0, $3E8Nt.toTitleCase)(String(value));
                let alignmentMonths = data["alignmentMonths"];
                if (alignmentMonths !== undefined) {
                    let alignmentMonthWord = alignmentMonths === 1 ? "month" : "months";
                    value += ` for ${alignmentMonths} ${alignmentMonthWord}`;
                }
            }
            // Add gimmick data
            if (attribute === "gimmick") {
                if (!value) value = "None";
                else value = value.name;
            }
            // Add traits data
            if (attribute === "traits") {
                if (!value.length) value = "None";
                else if (typeof value[0] === "object") value = value.map((y)=>`${y.name} (${y.superstar})`).join(", ");
                else value = (0, $3E8Nt.commaSeparate)(value);
            }
            // Add morale/fatigue
            if ([
                "morale",
                "fatigue"
            ].includes(attribute)) value = `${value}%`;
            if (value) {
                if (value === true) value = "Yes";
                const name = attribute === "faceOfTheCompany" ? "Face of the Company" : (0, $3E8Nt.toTitleCase)(attribute);
                if (typeof value !== "string") value = String(value);
                newMessageText += `<span class="margin-bottom-5 display-block">${name}: ${value}</span>`;
            }
        }
    }
    if (!recruited) newMessageText += `<p class="margin-top-10">If you want to pursue ${data["name"]}, we can try recruiting ${data["objectivePronoun"]}.</p>`;
    else newMessageText += `<p class="margin-top-10">The scouting went so well that I managed to recruit ${data["name"]}. ` + `${(0, $3E8Nt.toTitleCase)(data["pronoun"])} ${data["pronoun"] === "they" ? "are" : "is"} ` + `now available to sign in the Indies.</p>`;
    const messageFrom = scout ? scout.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Scouting report", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$68c3905bcf9bd170(talent, month, year, traitName, staffMember) {
    let newMessageText = `<p>After a lot of effort, I am pleased to say that the ` + `<span class="superstar-trait-color">${traitName}</span> Trait that ${talent.name} was associated with is no longer ` + `present in ${talent.objectivePronoun}.</p><p>${(0, $3E8Nt.toTitleCase)(talent.pronoun)} should be a better overall performer.</p>`;
    let messageFrom = staffMember ? staffMember.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Unlearning success", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$5ee78458bf3c3a9a(talent, month, year, traitName, staffMember) {
    let newMessageText = `<p>Despite working quite a bit with ${talent.name}, I wasn't able to get ` + `${talent.objectivePronoun} to overcome the <span class="superstar-trait-color">${traitName}</span> Trait.</p><p>` + `Perhaps we can try again in the future?</p>`;
    let messageFrom = staffMember ? staffMember.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Unlearning failure", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$6233f5d9dfcac013(talent, month, year, trainer, role) {
    let newMessageText = `<p>${talent.name}'s transition to a ${role} role is complete. ${(0, $3E8Nt.toTitleCase)(talent.pronoun)} ` + `is now available to use as a ${role}.</p>`;
    let messageFrom = trainer ? trainer.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Transition complete", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$9fcb1a06855b95c(superstar, month, year, staffMember, role) {
    let newMessageText = `<p>${superstar.name}'s transition to a ${(0, $3E8Nt.toTitleCase)(role.replace("_", " "))} is now complete ` + `and ${superstar.pronoun} is ready to work with us.</p>`;
    let messageFrom = staffMember ? staffMember.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Transition finished", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$9da892ff5cef018(superstar, month, year, role) {
    let newMessageText = `<p>I'm excited for my new journey as a ${(0, $3E8Nt.toTitleCase)(role.replace("_", " "))}. Let me know ` + `what I should work on first.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Work", superstar.name, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$85ec9ac246eaf77b(talent, month, year, staffMember) {
    let newMessageText = `<p>${talent.name}'s transition back to a superstar is complete and ${talent.pronoun} is ` + `now available to use.</p>`;
    let messageFrom = staffMember ? staffMember.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Transition finished", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$f0a7c4172ad2e0c0(talent, moraleChange, month, year, talentManager) {
    let moraleChangeHtml = `<span class="margin-left-2 margin-right-2 light-green">+ ${moraleChange}` + `<span class="margin-left-2">%</span></span>`;
    let newMessageText = `<p>I had a good talk with ${talent.name} and was able to reassure ${talent.objectivePronoun}. ` + `${talent.name}'s morale ${moraleChangeHtml} should get a boost.</p>`;
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Reassure success", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$30a055452178d91c(talent, moraleChange, month, year, talentManager) {
    let moraleChangeHtml = `<span class="margin-left-2 margin-right-2 morale-dissatisfied-color">- ${moraleChange * -1}` + `<span class="margin-left-2">%</span></span>`;
    let newMessageText = `<p>My talk with ${talent.name} didn't go so well. I wasn't able to reassure ` + `${talent.objectivePronoun} and ${talent.possessivePronoun} morale ${moraleChangeHtml} suffered.</p>`;
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Reassure failure", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$c0c9e667458b07a1(company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let newMessageText = "<p>The Yearly Draft is coming up next month. It's an opportunity to freshen things up with new matches and feuds.</p><p>Try to finish up any existing stories before moving superstars to a different brand.</p>";
    let talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Yearly Draft", messageFrom, game.monthCount, game.year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$4e0e588b3ba403b6(winner, pointsBonus, company, annualTournament, month, year) {
    let newMessageText = `<p>Seeing ${winner.name} raise the trophy at ${annualTournament.name} was a wonderful sight.</p>`;
    newMessageText += `<p>It's a big deal for our company to win the tournament, and it got us some new fans, so ` + `I've given you a bonus of <span class="blue margin-left-3 margin-right-3"><img alt="Points" src="static/www/static/cp_icon.png" ` + `class="points-image-small four-px"/> ${pointsBonus}</span>.</p>`;
    let messageFrom = company.ownerName || "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Victory", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$31ef4fc8cea99824(winner, annualTournament, month, year) {
    let newMessageText = `<p>It's a great honor to win ${annualTournament.name}. I think I'm going to keep holding ` + `the trophy for a month or so.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Trophy", winner.name, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$bf42474a7048de5c(winner, month, year, scout = null) {
    let newMessageText = `<p>Due to ${winner.possessivePronoun} TGI win, ${winner.name} is a hot commodity and ` + `available to sign from the Indies. You should make ${winner.objectivePronoun} an offer.</p>`;
    let messageFrom = scout ? scout.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("TGI Winner", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$2f4cc97c13059f3f(presidentName, month, year) {
    let newMessageText = `<p>There isn't any competition in the wrestling industry these days, which means ` + `fans don't have much interest in The Grand Invitational. Sadly, we can't run it without going into a loss.</p>` + `<p>I really hope a new company springs up by next year.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("No Competition", presidentName, month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$e401d1a207627891(presidentName, month, year) {
    let newMessageText = "<p>That was a great win for your company! The fans will be eager to see you defend your trophy.</p>";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Great Win", presidentName, month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$7eb13bd1380d7458(presidentName, month, year) {
    let newMessageText = "<p>Thank you for your company's part in The Grand Invitational. I hope to see you again next time where I'm sure you can win!</p>";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Thank You", presidentName, month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$5664eb63c76cf3b5(presidentName, winner, month, year) {
    let newMessageText = `<p>We had a great show at The Grand Invitational, with ${winner.name} taking the trophy ` + `home.</p>You don't want to miss participating next time. It could be your company that wins instead.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Great Show", presidentName, month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$205ed0894b6a9822(powerup, company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let powerupImage = (0, $kpu3X.getPowerupImage)(powerup);
    let powerupHtml = `<p class="black">${powerupImage}<span class="top--10px margin-left-5">${powerup.name}</span></p>`;
    let messageFrom, messageSubject, newMessageText;
    if (company.storyName === "mars") {
        messageFrom = "Company Lab";
        messageSubject = "Experiment produced";
        newMessageText = `<p>We finished work on a new experiment. It's ready for you to use.</p>${powerupHtml}`;
    } else {
        messageFrom = "Mysterious Advisor";
        messageSubject = "Artifact discovered";
        newMessageText = `<p>A powerful wrestling artifact has been discovered in a dungeon below our company headquarters.</p>${powerupHtml}`;
        let holyShitHelpText = "Gold Prestige Gimmick Matches";
        if (company.style === "pure") holyShitHelpText = "High-rated Matches";
        newMessageText += `<p>Use it carefully. More artifacts are known to be hidden in the wrestling world.</p>` + `<p>I believe offerings like creating Holy Shit Moments, winning Wrestling Awards and completing Owner Goals ` + `are sure to uncover more.</p>` + `<p>Holy Shit Moments can be created through ${holyShitHelpText} and Shocking Turns (Main Eventer turns ` + `in a Segment after a year or more of the same Alignment).</p>` + `<p>After you collect artifacts, you can activate them under <span class="prominent-grey">Manage > Other > ` + `Artifacts</span>, where I can also help you re-use them for some Creative Points.</p>`;
    }
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$d220fbea5737b632(specialSegment, company, numberOfUserUnlockedSegments = 0) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let specialSegmentHtml = `<p class="special-segment-color"><img alt="Special Segment" src="static/www/static/special_segments_icon.png"/>` + `<span class="top--12px margin-left-5">${specialSegment.name}</span></p>`;
    let messageFrom = "Mysterious Advisor";
    let messageSubject = "Special Segments";
    let newMessageText = `<p>A special segment has been discovered in the dusty vaults of our company library.</p>${specialSegmentHtml}`;
    // Add user segments to message
    if (numberOfUserUnlockedSegments > 0) {
        let segmentsWord = numberOfUserUnlockedSegments !== 1 ? "segments" : "segment";
        let segmentsVerb = numberOfUserUnlockedSegments !== 1 ? "have" : "has";
        newMessageText += `<p>${numberOfUserUnlockedSegments} other special ${segmentsWord} ${segmentsVerb} also ` + `been found from your previous encounters.</p>`;
    }
    newMessageText += `
        <p>Special Segments are unique items that always result in hot segments and get participants over. Use them ` + `carefully, for you can only use them once every 3 years and they have certain consequences. </p>` + `<p>A total of 10 Special Segments are known to exist in the wrestling world. You can go to ` + `<span class="prominent-grey">Manage > Other > Special</span> to learn more about them.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$3753c3a33c4c7fd8(company) {
    let incompleteObjectives = (await (0, $9esFv.getCompanyObjectives)(company)).filter((x)=>!x.completed && !x.past);
    let game = await (0, $9esFv.getCompanyGame)(company);
    let companyMessagesSubjects = (await (0, $9esFv.getCompanyMessages)(company)).map((x)=>x.subject);
    let messageFrom = company.ownerName ? company.ownerName : "Owner";
    let newMessage = false;
    if (!company.storyName) {
        if ((0, $8A6FL.getCompanyMonth)(company, game) === 0) {
            let messageSubject = "Goals for this year";
            if (!companyMessagesSubjects.includes(messageSubject)) {
                // Add objectives message
                let objectivesMessageText = "<p>I'm giving you the following goals for this year:</p>";
                for (let objective of incompleteObjectives)objectivesMessageText += `<p class="goal-color">` + `${objective.name.replace("*", '<i class="fa fa-star margin-left-3"></i>')}</p>`;
                if (!game.settings["unlimited_creative_points"]) objectivesMessageText += "<p>Complete them and I'll award you a significant amount of Creative Points. If you don't complete any of them, I'll have to take some Creative Points away. You can view the goals under <span class=\"prominent-grey\">Manage > Job > Goals</span>.</p>";
                else objectivesMessageText += "<p>Complete them and I'll award you a significant amount of Creative Points. If you don't complete any of them, I'll have to take some Creative Points away. Not that it matters anymore.</p><p>You can view the goals under <span class=\"prominent-grey\">Manage > Job > Goals</span>.</p>";
                newMessage = await $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, objectivesMessageText, "owner");
            }
        }
        if ((0, $8A6FL.getCompanyMonth)(company, game) === 5) {
            let messageSubject = "Goals update";
            if (!companyMessagesSubjects.includes(messageSubject)) {
                let objectivesMessageText = "";
                if (incompleteObjectives.length) {
                    objectivesMessageText = "<p>I wanted to remind you that I still have the following goals for the current year: </p>";
                    for (let objective of incompleteObjectives)objectivesMessageText += `<p class="goal-color">` + `${objective.name.replace("*", '<i class="fa fa-star margin-left-3"></i>')}</p>`;
                    objectivesMessageText += "<p>Complete all these goals and I'll give you a bonus reward at the end of the year.</p>";
                } else objectivesMessageText = "<p>Great job on completing all the goals I gave you. You're on your way to a hefty reward at the end of the year.</p>";
                newMessage = await $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, objectivesMessageText, "owner");
            }
        }
        if ((0, $8A6FL.getCompanyMonth)(company, game) === 9) {
            if (incompleteObjectives.length === 3) {
                let messageSubject = "Goals??";
                if (!companyMessagesSubjects.includes(messageSubject)) {
                    let objectivesMessageText = "<p>You haven't completed any of the following goals for this year: </p>";
                    for (let objective of incompleteObjectives)objectivesMessageText += `<p class="goal-color">` + `${objective.name.replace("*", '<i class="fa fa-star margin-left-3"></i>')}</p>`;
                    if (!game.settings["unlimited_creative_points"]) objectivesMessageText += "<p>If you don't complete at least one of these goals, I will take some Creative Points away from you.</p>";
                    else objectivesMessageText += "<p>If you don't complete at least one of these goals, I will take some Creative Points away from you. But they don't matter anymore, so I will also scold you!</p>";
                    newMessage = await $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, objectivesMessageText, "owner");
                }
            }
        }
    }
    return newMessage;
}
async function $c8b3c18104c7e1a2$export$3ad0f735009c98b6(data, company, game) {
    let messageSubject = "Goals Review";
    let newMessageText = "";
    let newMessage = null;
    if (data["bonus"]) {
        newMessageText = '<p>I\'ve given you a bonus of <span class="blue margin-left-3 margin-right-3"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ' + data["bonus"] + "</span> for completing all the goals " + "for last year.</span>";
        if (data["newMatch"]) newMessageText += '<span class="display-block">As an additional reward, I\'ve created a special gimmick match (<span class="light-blue">' + data["newMatch"] + "</span>" + ") unique to our company.</span>";
        newMessageText += "<p>Complete this year's goals and you'll get an even larger bonus.</p>";
    } else if (data["punishment"]) {
        if (!game.settings["unlimited_creative_points"]) newMessageText = '<p>I\'ve taken away <span class="blue margin-left-3 margin-right-3"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ' + data["punishment"] + "</span> for not completing any of my goals. I will take away even more Creative Points " + "if you do the same this year.</p>";
        else newMessageText = '<p>Bad booker! I\'ve taken away <span class="blue margin-left-3 margin-right-3"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ' + data["punishment"] + "</span> for not completing any of my goals. " + "I will take away even more Creative Points if you do the same this year. Do as I say!</p>";
    }
    if (newMessageText) {
        let messageFrom = company.ownerName ? company.ownerName : "Owner";
        newMessage = await $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, newMessageText, "owner");
    }
    return newMessage;
}
function $c8b3c18104c7e1a2$export$74be8863da226be3(unlockedPowerups, awardedPowerups, company, game) {
    let powerupHtml = "";
    for (let powerup of [
        ...unlockedPowerups,
        ...awardedPowerups
    ]){
        let powerupImage = (0, $kpu3X.getPowerupImage)(powerup, powerup.storyName);
        powerupHtml += '<p class="black">' + powerupImage + '<span class="top--10px margin-left-5">' + powerup.name + "</span>" + "</p>";
    }
    let messageSubject;
    let newMessageText;
    if (unlockedPowerups.length) {
        if (unlockedPowerups.length > 1) {
            messageSubject = "Artifacts discovered";
            newMessageText = "Powerful wrestling artifacts have been discovered";
        } else if (unlockedPowerups[0].storyName === "mars") {
            messageSubject = "Experiment discovered";
            newMessageText = "A powerful experiment has been discovered from Zholov's notes";
        } else {
            messageSubject = "Artifact discovered";
            newMessageText = "A powerful wrestling artifact has been discovered";
        }
    } else {
        if (awardedPowerups.length > 1) {
            messageSubject = "Artifacts re-use";
            newMessageText = "I've managed to create a re-use of the following artifacts";
        } else if (awardedPowerups[0].storyName === "mars") {
            messageSubject = "Experiment re-use";
            newMessageText = "I've managed to create a re-use of one of Zholov's experiments";
        } else {
            messageSubject = "Artifact re-use";
            newMessageText = "I've managed to create a re-use of the following artifact";
        }
    }
    newMessageText = "<p>" + newMessageText + "</p>";
    newMessageText += powerupHtml;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, "Mysterious Advisor", game.monthCount, game.year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$65c126b446a46caa(company, month, year, talentManager, superstars, championships, teams, feuds, factions) {
    // Tell player about superstars, championships, teams, feuds, and factions transferred to their company
    let newMessageText = `<p>The ${company.name} Buyout is complete and the company has dissolved. ` + `We brought in the following <span class="superstar-blue">Superstars</span>:</p>`;
    for (const superstar of superstars)newMessageText += `<p class="grey">- ${superstar.name}</p>`;
    newMessageText += `<p>and the following <span class="championship-gold">Championships</span>:</p>`;
    for (const championship of championships)newMessageText += `<p class="grey">- ${championship.name} Championship</p>`;
    if (teams.length) {
        newMessageText += `<p>The following Teams were also added to the Roster:</p>`;
        for (const team of teams)newMessageText += `<p class="grey">- ${team.name}</p>`;
    }
    if (factions.length) {
        newMessageText += `<p>The following Factions were also added to the Roster:</p>`;
        for (const faction of factions)newMessageText += `<p class="grey">- ${faction.name}</p>`;
    }
    if (feuds.length) {
        newMessageText += `<p>And finally, these existing Feuds carried over:</p>`;
        for (const feud of feuds){
            const feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
            newMessageText += `<p class="grey">- ${feud.name} (${feudParticipants.map((x)=>x.name).join(" vs ")})</p>`;
        }
    }
    const messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Buyout complete", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$1ec9d1b6c6653ec4(company, month, year, trainer, sentToTrainingRoster) {
    // Tell player about superstars sent to the training roster after buyout
    let newMessageText = `<p>I have sent the following ${company.name} Superstars to the <span class="green">Training Roster</span>:</p>`;
    for (const superstar of sentToTrainingRoster)newMessageText += `<p class="grey">- ${superstar.name}</p>`;
    const messageFrom = trainer ? trainer.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Sent to training", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$776fef3db16c1d8d(company, month, year, doctor, injuredSuperstars) {
    // Tell player about superstars that are injured
    let newMessageText = `<p>The following ${company.name} Superstars have come into the Company injured:</p>`;
    for (const superstar of injuredSuperstars){
        const injuryTime = (0, $5kTkA.evaluateInjury)(superstar, doctor);
        const monthWord = injuryTime === "1" ? "month" : "months";
        if (superstar.injuryName) newMessageText += `<p class="grey">- ${superstar.name}: ${(0, $3E8Nt.toTitleCase)(superstar.injuryName)} (${injuryTime} ${monthWord})</p>`;
        else newMessageText += `<p class="grey">- ${superstar.name} (${injuryTime} ${monthWord})</p>`;
    }
    const messageFrom = doctor ? doctor.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Injured talent", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$1830ca3b242e20f7(superstar, month, year) {
    const rambling = (0, $3E8Nt.getRandomChoice)((0, $TqG49.superstarJoinedInBuyoutTexts));
    const subject = rambling["subject"];
    const newMessageText = `<p>${rambling["content"]}</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, superstar.name, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$a24743dc3e24d53b(talentRequest, talent, moraleChange, month, year, talentManager) {
    let moraleChangeHtml = `<span class="margin-left-2 margin-right-2 morale-dissatisfied-color">- ${moraleChange * -1}
                            <span class="margin-left-2">%</span></span>`;
    let newMessageText = `<p>${talent.name}'s "${await (0, $1olyO.getTalentRequestName)(talentRequest)}" request was declined, and ` + `as a result, ${talent.possessivePronoun} morale ${moraleChangeHtml} has dropped.</p>`;
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Request declined", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$c6a94dc128bc5ded(month, year, owner, settings) {
    let newMessageText = "<p>Our company is doing quite well these days.</p>";
    if (settings["maximum_roster_capacity"]) newMessageText += "<p>Finances are terrific so we have a lot of room on the roster.</p>";
    if (settings["all_indies_available"]) newMessageText += "<p>Everyone on the Indies is interested in signing with us.</p>";
    if (settings["unlock_all_items"]) newMessageText += "<p>We have a wide variety of gimmick matches, feuds and segments to use. Plus, the Mysterious Advisor keeps talking about a limitless supply of ancient artifacts.</p>";
    if (settings["maximum_staff_and_facilities"]) newMessageText += "<p>Our staff is excellently trained and our company facilities are top of the line.</p>";
    if (settings["no_special_items_cooldown"]) newMessageText += "<p>We're doing well creatively so you can use special segments and match finishes as often as you want to.</p>";
    if (settings["unlimited_creative_points"]) newMessageText += "<p>You don't have to worry about creative points anymore. Book whatever you want. Go crazy.</p>";
    if (settings["no_injuries"]) newMessageText += "<p>Injuries are non-existent. Our medical facility is so good that it will catch any injuries before they happen!</p>";
    if (settings["no_unhappiness"]) {
        newMessageText += "<p>There's no need to worry about talent becoming unhappy. We pay them so much that they won't ever complain.";
        if (settings["no_talent_requests"]) newMessageText += " And they won't ever ask for anything!";
        newMessageText += "</p>";
    }
    let messageFrom = owner ? owner : "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Good days", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$2121c19a14a1646a(company, game) {
    let messageFrom = "Mysterious Advisor";
    let messageSubject = "Hidden tomb";
    let newMessageText = '<p>Something amazing happened last night. I was walking around the dungeon below our company headquarters when I discovered a hidden door with weird markings on it.</p><p>I opened it to find a tomb filled with ancient artifacts. Not just a few, but hundreds of them!</p><p>The most surprising part is that when one of them is activated, it seems to replenish itself.</p><p>I don\'t know how this is possible. It must be some sort of enchantment from the past. Whatever it is, be careful, and make good use of it.</p><p>You can activate the artifacts under <span class="prominent-grey">Manage > Other > Artifacts</span>.</p>';
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$47559039619def5a(competitor, month, year) {
    const subject = "Good luck";
    const newMessageText = "<p>Hey, I heard about your new company and wanted to wish you good luck. You're gonna need it.</p>";
    const messageFrom = competitor.ownerName ? competitor.ownerName : `Owner - ${competitor.name}`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$fd038ba09ec4729a(month, year, owner, sandboxSettings = {}) {
    const staffFacilities = Object.keys((0, $3E8Nt.facilitiesData));
    const facilitiesNames = (0, $3E8Nt.commaSeparate)(staffFacilities);
    let newMessageText = `<p>We have the following <span class="facility-color">Facilities</span> at our company: ${facilitiesNames}.</p>`;
    if (sandboxSettings["maximum_staff_and_facilities"]) newMessageText += '<p>Our Facilities are fully upgraded. You can view more information about them under <span class="prominent-grey">Manage > Staff > Facilities</span>.</p>';
    else newMessageText += '<p>If you want to upgrade a Facility (JoW Paid), you\'ll have to complete some requirements, which you can view under <span class="prominent-grey">Manage > Staff > Facilities</span>.</p><p>These upgrades will allow you to hire more and better skilled Staff as well as bring other improvements to the company.</p>';
    const messageFrom = owner ? owner : "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Company facilities", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$4301fe600baf9422(month, year, owner) {
    let newMessageText = `<p>We have space for the following <span class="staff-color">Staff Members</span> ` + `at our company: Doctor, Producer, Scout, Trainer and Talent Manager.</p>` + `<p>Each role can enhance our company in multiple ways. You can hire new Staff Members (JoW Paid) under ` + `<span class="prominent-grey">Manage > Staff > View > Hire</span>.</p>`;
    newMessageText += `<p>You can also transition retired Superstars to Staff Members by selecting them under ` + `<span class="prominent-grey">Manage > Roster > View</span> and clicking on ` + `<span class="prominent-grey">Transition To Staff</span>.</p><p>The number of Staff you can hire per role ` + `depends on the level of our Facilities.</p>`;
    const messageFrom = owner ? owner : "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Staff Members", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$b16f5dfcb5e33141(staffMember, company, game) {
    if (staffMember.role === "doctor") {
        let mainRosterSuperstars = await (0, $8A6FL.getCompanyMainRosterSuperstars)(company);
        let injuredSuperstars = mainRosterSuperstars.filter((x)=>x.injured);
        return $c8b3c18104c7e1a2$export$85c1b77146faec0d(injuredSuperstars, game.monthCount, game.year, staffMember);
    }
    if (staffMember.role === "scout") return $c8b3c18104c7e1a2$export$136cee437e0e7ad5(game.monthCount, game.year, staffMember);
    if (staffMember.role === "producer") return $c8b3c18104c7e1a2$export$dc33c912cf2ff472(game.monthCount, game.year, staffMember);
    if (staffMember.role === "trainer") return $c8b3c18104c7e1a2$export$c046aa28cf3182d5(game.monthCount, game.year, staffMember);
    if (staffMember.role === "talent_manager") return $c8b3c18104c7e1a2$export$73275b44fecee670(game.monthCount, game.year, staffMember);
}
async function $c8b3c18104c7e1a2$export$136cee437e0e7ad5(month, year, scout, sandboxSettings = {}) {
    const greeting = (0, $3E8Nt.getRandomChoice)((0, $TqG49.greetings));
    let newMessageText = `<p>${greeting},</p><p>I\'m here to help you scout and recruit talent.</p>` + `<p>I recommend first scouting a talent to get a better idea of their status, then recruiting them to ` + `make them available to sign.</p>`;
    if (sandboxSettings["maximum_staff_and_facilities"]) newMessageText += `<p>I can produce Deep Reports on talent, which include everything you need to know about them.</p>
                           <p>To scout or recruit an indie talent, go to <span class="prominent-grey">Manage > Roster > ` + `Indies</span> and select an unavailable talent.</p>
                           <p>I will automatically compile Deep Info for talent that are available to sign in the Indies.</p>`;
    else newMessageText += `<p>Right now I can produce Basic Reports on talent, which include Rank, Age and Pronoun. My ` + `scouting also has a slight chance to recruit talent.</p>
                           <p>To scout or recruit an indie talent, go to <span class="prominent-grey">Manage > Roster > ` + `Indies</span> and select an unavailable talent.</p>
                           <p>I will automatically compile Basic Info for talent that are available to sign in the Indies.</p>`;
    if (sandboxSettings["maximum_staff_and_facilities"]) newMessageText += `<p>My experience allows me to get indie talent interested in joining our company and ` + `automatically recruit new talent that join the Indies.</p>`;
    else newMessageText += `<p>As my skills increase, I can produce more detailed reports, view talent stats for ` + `competitors, get better at recruiting talent and get them interested in joining our company.</p>`;
    const messageFrom = scout ? scout.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Scouting", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$c046aa28cf3182d5(month, year, trainer, sandboxSettings = {}) {
    const greeting = (0, $3E8Nt.getRandomChoice)((0, $TqG49.greetings));
    let newMessageText = `<p>${greeting},</p><p>My job is to train talent and manage the Training Roster.</p>` + `<p>I can run training programs on talent that help them increase their skills.</p><p>To assign me to train a ` + `talent, go to your Roster under <span class="prominent-grey">Manage > Roster > View</span>, select a talent ` + `and click on <span class="prominent-grey">Train</span>.</p>`;
    if (sandboxSettings["maximum_staff_and_facilities"]) newMessageText += `<p>My skill level allows me to prepare specific talent in the Training Roster for callups ` + `and easily train new signings to bring them straight to the Main Roster.</p>`;
    else newMessageText += `<p>As my skills increase, I will be able to increase the experience that talent gain, choose ` + `who to make available for callups and easily train new signings to bring them straight to the Main Roster.</p>`;
    newMessageText += "<p>New callups are available in Month 1 and Month 7.</p>";
    const messageFrom = trainer ? trainer.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Training", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$73275b44fecee670(month, year, talentManager, sandboxSettings = {}) {
    const greeting = (0, $3E8Nt.getRandomChoice)((0, $TqG49.greetings));
    let newMessageText = `<p>${greeting},</p><p>My job is to manage talent relations.</p><p>I can reassure talent, ` + `which increases their morale, and reduce the chance of them deciding to leave if unhappy.</p>` + `<p>To assign me to reassure a talent, go to your Roster under <span class="prominent-grey">Manage > Roster ` + `> View</span>, select a talent and click on <span class="prominent-grey">Reassure</span>.</p>` + `<p>Talent morale goes up by winning matches and titles, being in title matches and the main event, being ` + `part of hot matches/feuds/segments and feuding with top talent.</p><p>Morale goes down by losing matches ` + `and titles, feuding with lower talent and being in silly segments that flop.</p>`;
    if (sandboxSettings["maximum_staff_and_facilities"]) newMessageText += `<p>My experience allows me to negotiate for more appearances with part-timers and negotiate ` + `deals with more talent during Company Buyouts.</p>`;
    else newMessageText += `<p>As my skills increase, I will be able to reduce the chance of talent deciding to leave ` + `if unhappy, negotiate for more appearances with part-timers and negotiate deals with more talent during Company Buyouts (Level 3 Talent Management Facility).</p>`;
    newMessageText += `<p>Competitors can become available for a buyout if their fan base drops low and their reputation ` + `decreases 5 or more levels than their highest reputation.</p>`;
    const messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Talent management", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$dc33c912cf2ff472(month, year, producer, sandboxSettings = {}) {
    const greeting = (0, $3E8Nt.getRandomChoice)((0, $TqG49.greetings));
    let newMessageText = `<p>${greeting},</p>` + `<p>I'm here to help you boost talent using production.</p><p>I can create Production ` + `Packages that you can add to the show as a Segment.</p><p>These include Video Packages for Superstars ` + `and Tag Teams to boost their popularity, Feud Packages to boost Feud Hype and Event Packages to boost ` + `the Hype of the upcoming monthly event.</p><p>I can also focus on a certain Segment every show to try ` + `and improve its result.</p>`;
    if (sandboxSettings["maximum_staff_and_facilities"]) newMessageText += `<p>My skills allow me to boost new gimmick debuts and add new types of packages and match finishes.</p>`;
    else newMessageText += `<p>As my skills increase, I will be able to create better packages, boost new gimmick debuts ` + `and add new types of packages and match finishes.</p>`;
    const messageFrom = producer ? producer.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Production", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$85c1b77146faec0d(superstars, month, year, doctor, sandboxSettings = {}) {
    const greeting = (0, $3E8Nt.getRandomChoice)((0, $TqG49.greetings));
    let newMessageText = `<p>${greeting},</p><p>I'm here to help talent deal with injuries.</p><p>If a talent gets ` + `injured, I will provide a diagnosis and start their recovery.</p>`;
    if (sandboxSettings["maximum_staff_and_facilities"]) newMessageText += `<p>My experience allows me to provide accurate diagnoses and offer rehab services to injured ` + `talent, bringing their returns closer.</p>
                           <p>To assign me to rehab a talent, go to your Roster under <span class="prominent-grey">` + `Manage > Roster > View</span>, select an injured talent and click on <span class="prominent-grey">Rehab</span>.</p>`;
    else newMessageText += `<p>As my skills increase, my diagnoses will get better and I will be able to offer rehab ` + `services to injured talent, bringing their returns closer.</p>`;
    newMessageText += `<p>I would recommend keeping talent fatigue levels below 40% to reduce the chance of injuries.</p>`;
    if (superstars.length > 0) {
        newMessageText += `<p>The following superstars are on the injury shelf:</p>`;
        for (let s of superstars){
            const injuryTime = (0, $5kTkA.evaluateInjury)(s, doctor);
            const monthWord = injuryTime === "1" ? "month" : "months";
            newMessageText += `<p class="grey">- ${s.name} (${injuryTime} ${monthWord})</p>`;
        }
    }
    const messageFrom = doctor ? doctor.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Medical", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$9be967c3b4206d3b(company, month, year) {
    let newMessageText = `<p>I'm glad you decided to participate in The Grand Invitational. It'll be a big deal if we ` + `win, so make sure to send our top superstars.</p>`;
    let messageFrom = company["ownerName"] ? company["ownerName"] : "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Good Luck", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$cf55f1cb6e074043(company, month, year) {
    let newMessageText = `<p>We need to be represented at a tournament like The Grand Invitational. Consider doing so ` + `next time, and if we win, I'll throw in a reward for you.</p>`;
    let messageFrom = company["ownerName"] ? company["ownerName"] : "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Next Time", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$d4dd4f51b435b026(superstar, game, month, year) {
    const presidentData = (0, $18vSN.getPresidentData)(game);
    const newMessageText = `<p>Even though The Grand Invitational is not liable for any injuries that happen during its ` + `events, I was sorry to see your champion get injured. I wish ${superstar.name} a speedy recovery.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Sorry", presidentData["name"], month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$95a688ed2164fce9(partTimers, company, game, staffMembers) {
    let messageSubject = "Contract changes";
    let newMessageText = "<p>The following Superstars have become part timers:</p>";
    for (const x of partTimers)newMessageText += `<p class="grey">- ${x}</p>`;
    let talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$35e81819773402f1(data, company, game, staffMembers) {
    let messageSubject = "Trait Lost";
    let newMessageText = `<p>I was doing a check up and noticed something different about ${data["superstar"]}.</p>`;
    newMessageText += `<p>${(0, $3E8Nt.toTitleCase)(data["pronoun"])} no longer seems to have the ` + `<span class="superstar-trait-color">${data.trait}</span> Trait.</p>`;
    newMessageText += "<p>Traits can be lost as workers cross their early 40s.</p>";
    let talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$9c1182cca2f7b05f(s, month, year, company, staffMembers) {
    let messageSubject = `${s["name"]} retires`;
    let newMessageText;
    if (s["hallOfFame"]) {
        newMessageText = `<p>${s["name"]} has retired and been inducted into the <span class="gold">Hall of Fame</span>. ` + `A moving ceremony was held:</p>`;
        for (let speech of s["hallOfFame"])newMessageText += `<p>"${speech["content"]}" - ${speech["superstar"]}</p>`;
    } else newMessageText = `<p>${s["name"]} has retired from wrestling.</p>`;
    for (let tagTeam of s["tagTeams"])newMessageText += `<p>${tagTeam} have disbanded.</p>`;
    for (let championship of s["vacated"]){
        let championshipName = (0, $1JSre.getChampionshipDisplayName)(championship);
        if (championship["tagTeam"] || championship["trio"]) newMessageText += `<p><span class="gold">${championshipName}</span> have been vacated.</p>`;
        else newMessageText += `<p><span class="gold">${championshipName}</span> has been vacated.</p>`;
    }
    newMessageText += `<p>Retired superstars can make the transition to Staff Members. Maybe that could be the next ` + `step in ${s["name"]}'s career?</p>`;
    let talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$db71b5d15cb15b80(partTimerChances, retirementChances, company, game, staffMembers) {
    let messageSubject = "Potential contract changes";
    let newMessageText = "";
    if (retirementChances.length) {
        newMessageText += "<p>The following Superstars are thinking about retiring:</p>";
        for (let x of retirementChances)newMessageText += `<p class="grey">- ${x}</p>`;
    }
    if (partTimerChances.length) {
        newMessageText += "<p>The following Superstars are thinking about becoming part timers:</p>";
        for (let x of partTimerChances)newMessageText += `<p class="grey">- ${x}</p>`;
    }
    let talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(messageSubject, messageFrom, game.monthCount, game.year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$429b919c5a61c94e(company, game, superstars, talentManager, guaranteedAppearances, minimumAppearances) {
    let newMessageText;
    if (guaranteedAppearances) {
        newMessageText = "<p>The following part-timers have signed on for limited appearances this year.</p>";
        newMessageText += `<p>Due to the Guaranteed Appearances Facility, I was able to negotiate a minimum of ` + `${minimumAppearances} appearances for each Superstar.</p>`;
    } else newMessageText = "<p>The following part-timers have signed on for limited appearances this year:</p>";
    for (let s of superstars){
        let monthWord = s.appearances === 1 ? "appearance" : "appearances";
        newMessageText += `<p class="grey">- ${s.name} (${s.appearances} ${monthWord})</p>`;
    }
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Part-timers", messageFrom, game.monthCount, game.year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$6f2fff2cfb84ecd3(company, game) {
    let newMessage = null;
    let trainer = (0, $8A6FL.getHighestLevelStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "trainer");
    let trainerLevel = trainer ? trainer.level : 1;
    let monthsToCheck = trainerLevel < 3 ? [
        4,
        10
    ] : [
        5,
        11
    ];
    if (monthsToCheck.includes((0, $8A6FL.getCompanyMonth)(company, game))) {
        let trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "trainingAvailable");
        let availableNames = (await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster)).map((x)=>x.name);
        if (availableNames.length) newMessage = await $c8b3c18104c7e1a2$var$createAvailableForCallupMessage(availableNames, company, trainer);
    }
    return newMessage;
}
function $c8b3c18104c7e1a2$var$createAvailableForCallupMessage(availableNames, company, trainer) {
    let trainerLevel = trainer ? trainer.level : 1;
    let monthsPhrase = trainerLevel < 3 ? "in two months" : "next month";
    let newMessageText = `<p>A Training Roster callup will be available ${monthsPhrase}. The following talent are ` + `available to callup:</p>`;
    for (const s of availableNames)newMessageText += `<p class="grey">- ${s}</p>`;
    if (trainerLevel < 2) {
        if (trainer) newMessageText += "<p>As my skills increase, I will be able to prepare specific talent to make them available for callups.</p>";
        else newMessageText += "<p>With a skilled Trainer (JoW Paid), we will be able to prepare specific talent to make them available for callups.</p>";
    } else newMessageText += "<p>If you want to make a particular talent available for the next callup, you should task me to prepare them now.</p>";
    let messageFrom = trainer ? trainer.name : "Staff";
    return $c8b3c18104c7e1a2$var$createUniqueMessage(newMessageText, "Available Callups", messageFrom, "staff", company);
}
async function $c8b3c18104c7e1a2$export$af1aca878ff2a8a8(topSuperstar, popularityBoost, company, month, year) {
    let talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
    let popularityBoostHtml = '<span class="green margin-left-2 margin-right-2">+ ' + popularityBoost + "</span>";
    let newMessageText = "<p>" + topSuperstar.name + " grabbed the top spot in this year's Top 50 Rankings! As a result, " + topSuperstar.possessivePronoun + " popularity " + popularityBoostHtml + " got a boost.</p>";
    let messageFrom = talentManager ? talentManager.name : "Staff";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Top Superstar", messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$38420f4fd964537b(topSuperstar, creativePointsBoost, company, month, year) {
    let newMessageText = "<p>Good job getting " + topSuperstar.name + " to the #1 rank in this year's Top 50.</p>";
    newMessageText += '<p>I felt proud that one of our superstars topped the list, so I gave you a bonus of <span class="blue margin-left-3 margin-right-3"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ' + creativePointsBoost + "</span>.</p>";
    let messageFrom = company.ownerName ? company.ownerName : "Owner";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("#1 Rank", messageFrom, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$caedc18f7264f425(staffMember, data, month, year) {
    let text = "";
    let subject = "";
    if (data["name"] === "illness") {
        text = "<p>I've come down with a bad case of the flu. I don't think I will be available to work this month.</p>";
        subject = "Flu";
    } else if (data["name"] === "family-issue") {
        text = "<p>There's been a significant issue in my family .. I'll need to take some time off to work it out.</p><p>Hopefully, things will be alright soon. I think I should be back in about two months.</p>";
        subject = "Family issue";
    } else if (data["name"] === "court-case") {
        text = "<p>Recently, a fraudulent court case was registered against me, and until it's resolved, I'm not allowed to work here.</p><p>I don't know how long it will take, but I will fight it and and I will be back.</p>";
        subject = "Court case";
    }
    let newMessageText = `${text}`;
    let messageFrom = staffMember.name;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c(subject, messageFrom, month, year, newMessageText, "staff");
}
async function $c8b3c18104c7e1a2$export$3cf07d251bf224da(ownerName, month, year) {
    let newMessageText = `<p>Hey, I'm a big fan of your work. I thought I'd reach out to you about a new opportunity.</p>`;
    newMessageText += `<p>I've always had the dream to start my own wrestling company, and I think now's the right time to do it.</p>`;
    newMessageText += `<p>I really think we could make a viable alternative. Let me know if you're interested (<span class="prominent-grey">Manage > Job  > Companies > Form New Company</span>).</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Opportunity", ownerName, month, year, newMessageText);
}
async function $c8b3c18104c7e1a2$export$e56a808c05f6079b(ownerName, month, year) {
    let newMessageText = "<p>I'm really excited that you decided to take this chance with me!</p>";
    newMessageText += "<p>There's a lot to do, and I'm going to get right to it. Meanwhile, think of what you'd like to call the new company, and other details like names of our events and championships.</p>";
    newMessageText += "<p>I'll keep you posted.</p>";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Excited", ownerName, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$ad29d36f654bda77(ownerName, month, year) {
    let newMessageText = "<p>I heard the news that you're leaving us.</p>";
    newMessageText += "<p>I can't say I'm surprised. You were running out of ideas, and a fresh direction would benefit us anyway.</p>";
    newMessageText += "<p>But to leave for a new company, that could fold at any time? I thought you were smarter than that.</p>";
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Leaving??", ownerName, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$1599882fc1f4c0ab(ownerName, newCompanyName, currentCompanyName, month, year) {
    let newMessageText = `<p>The details you sent look good, and the name "${newCompanyName}" is available! We should be ready to start in a couple of months.</p>`;
    newMessageText += `<p>Could you think of any talent at ${currentCompanyName} that would be interested in joining us? Perhaps talent that are happy with your work? We can make them an offer next month.</p>`;
    newMessageText += `<p>I'll also try to recruit suitable talent from the Indies and other companies.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Details", ownerName, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$d8233f7a513a3bb5(ownerName, selectionsMade, month, year) {
    let newMessageText = "";
    if (selectionsMade) newMessageText += `<p>The talent you selected are really interesting. I have sent offers to all of them, and we should have our roster ready soon.</p>`;
    else newMessageText += `<p>I'm surprised you didn't select any talent, but don't worry, I have my eye on some other superstars. We should have our roster ready soon.</p>`;
    newMessageText += `<p>We officially start next month! You will be booking our first monthly event, and I can't wait to see it!</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Talent", ownerName, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$ef127244b8d2461(ownerName, newCompanyName, month, year) {
    let newMessageText = `<p>It's one thing that you're leaving us, but some talent are thinking of leaving too??</p>`;
    newMessageText += `<p>No one is going to join this pointless company. I read somewhere that it's going to be called ${newCompanyName}, what a stupid name!</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Pointless", ownerName, month, year, newMessageText, "owner");
}
async function $c8b3c18104c7e1a2$export$fa69819c89d1c9dd(superstar, month, year) {
    let newMessageText = `<p>I heard that you'd like to bring me into the new company you're starting.</p>`;
    newMessageText += `<p>You should know that I'm on board. I'll follow you anywhere.</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("New Company", superstar.name, month, year, newMessageText, "superstar");
}
async function $c8b3c18104c7e1a2$export$e728d06ec98ca69c(ownerName, previousCompanyName, previousCompanySuperstars, competitorsSuperstars, month, year) {
    let newMessageText = ``;
    if (previousCompanySuperstars.length) {
        newMessageText += `<p>We were able to sign the following talent from ${previousCompanyName}:</p>`;
        for (const superstar of previousCompanySuperstars)newMessageText += `<p class="grey">- ${superstar.name}</p>`;
    }
    if (competitorsSuperstars.length) {
        newMessageText += `<p>These superstars from other companies have signed with us:</p>`;
        for (const superstar of competitorsSuperstars)newMessageText += `<p class="grey">- ${superstar.name}</p>`;
    }
    newMessageText += `<p>We have also signed a bunch of talent from the Indies.</p>`;
    newMessageText += `<p>Let's book an amazing show!</p>`;
    return $c8b3c18104c7e1a2$export$62651879628e0c4c("Our Talent", ownerName, month, year, newMessageText, "owner");
}

});
parcelRequire.register("6dDCX", function(module, exports) {

$parcel$export(module.exports, "Message", () => $4872b227a668006d$export$f69c19e57285b83a);

var $14eBR = parcelRequire("14eBR");
function $4872b227a668006d$export$f69c19e57285b83a() {
    // Integer
    const month = null;
    const year = null;
    // Strings
    const subject = null;
    const content = null;
    const fromName = null;
    const tag = null;
    // Boolean
    const read = false;
    const promptAction = false;
    // Foreign keys
    const companyId = null;
    const randomEventId = null;
    return {
        month: month,
        year: year,
        subject: subject,
        content: content,
        fromName: fromName,
        tag: tag,
        read: read,
        promptAction: promptAction,
        companyId: companyId,
        randomEventId: randomEventId
    };
}
function $4872b227a668006d$export$9c3a50a9f9134eb9(message) {
    return (0, $14eBR.Companies).find({
        "$loki": message.companyId
    })[0];
}
function $4872b227a668006d$export$32c40767cb4b5973(message) {
    return (0, $14eBR.RandomEvents).find({
        "$loki": message.randomEventId
    })[0];
}

});

parcelRequire.register("4rksk", function(module, exports) {

$parcel$export(module.exports, "superstarWorkThroughInjuryTexts", () => $33b98d2bbe1ce115$export$3fac5a7e97c4df27);
$parcel$export(module.exports, "superstarAggravatedInjuryTexts", () => $33b98d2bbe1ce115$export$72d5235237e18a3c);
$parcel$export(module.exports, "injuriesData", () => $33b98d2bbe1ce115$export$5b4f8659bb99da1c);
const $33b98d2bbe1ce115$export$3fac5a7e97c4df27 = [
    {
        "subject": "Wrestle",
        "content": "I know the doctors are saying I should take it easy, but I know my body better. I'm okay to wrestle."
    },
    {
        "subject": "Work",
        "content": "Listen, I can work with this injury. I'll take it easy in my matches until I'm back to a hundred percent."
    },
    {
        "subject": "My place",
        "content": "This injury isn't too serious .. let me work through it. I don't want to lose my place."
    },
    {
        "subject": "Wrestle",
        "content": "This injury isn't bothering me too much. I'm pretty sure I can wrestle with it."
    },
    {
        "subject": "Careful",
        "content": "If I'm careful, I can easily wrestle with this injury until it heals. What do you think?"
    }
];
const $33b98d2bbe1ce115$export$72d5235237e18a3c = [
    {
        "subject": "Doctors",
        "content": "Maybe I should have listened to the doctors, taken it easy for a few months .. I just didn't want to lose my place."
    },
    {
        "subject": "Bad Idea",
        "content": "Guess it was a bad idea to work with the injury. I felt like I couldn't say no .. actually, I didn't want to say no."
    },
    {
        "subject": "Rest",
        "content": "I know I have no one to blame but myself. I guess the silver lining is I get a lot of time to rest and heal now."
    },
    {
        "subject": "Heal",
        "content": "I did what you're supposed to do with an injury like that, you know? You fight through it .. it just didn't work out this time."
    }
];
const $33b98d2bbe1ce115$export$5b4f8659bb99da1c = {
    "workable": {
        "names": [
            "twisted ankle",
            "pulled hamstring",
            "broken finger",
            "bruised wrist",
            "inflamed achilles",
            "pulled groin",
            "shoulder sprain",
            "strained bicep",
            "pulled calf",
            "quad strain",
            "sprained knee",
            "strained pec",
            "skin infection",
            "concussion"
        ],
        "months_min": 1,
        "months_max": 2,
        "severe_versions": {
            "twisted ankle": "torn ankle ligament",
            "pulled hamstring": "hamstring tear",
            "broken finger": "shattered finger",
            "bruised wrist": "torn wrist ligament",
            "inflamed achilles": "ruptured achilles",
            "pulled groin": "groin tear",
            "shoulder sprain": "separated shoulder",
            "strained bicep": "torn bicep",
            "pulled calf": "ruptured calf",
            "quad strain": "torn quad",
            "sprained knee": "torn knee ligament",
            "strained pec": "torn pec",
            "skin infection": "staph infection",
            "concussion": "severe concussion"
        }
    },
    "minor": {
        "names": [
            "kidney problem",
            "torn bicep",
            "torn tricep",
            "torn pec",
            "dislocated shoulder",
            "fractured ankle",
            "staph infection",
            "broken rib",
            "groin tear",
            "torn rotator cuff",
            "fractured wrist",
            "broken hand",
            "broken foot",
            "broken arm",
            "fractured knee",
            "torn ankle ligament",
            "hamstring tear",
            "shattered finger",
            "torn wrist ligament",
            "ruptured achilles",
            "ruptured calf",
            "separated shoulder"
        ],
        "months_min": 3,
        "months_max": 6
    },
    "major": {
        "names": [
            "broken neck",
            "broken back",
            "torn knee ligament",
            "torn quad",
            "severe concussion",
            "herniated disc",
            "broken leg"
        ],
        "months_min": 7,
        "months_max": 13
    }
};

});

parcelRequire.register("TqG49", function(module, exports) {

$parcel$export(module.exports, "greetings", () => $0a69d4c2d43b5225$export$97818a4e89f24fb7);
$parcel$export(module.exports, "superstarNotAvailableBuyoutData", () => $0a69d4c2d43b5225$export$63232d534813b55d);
$parcel$export(module.exports, "superstarJoinedInBuyoutTexts", () => $0a69d4c2d43b5225$export$844c33ba20b1954a);
$parcel$export(module.exports, "superstarJoinedRamblings", () => $0a69d4c2d43b5225$export$e296c73225d6b1ca);
$parcel$export(module.exports, "superstarLeftRamblings", () => $0a69d4c2d43b5225$export$daed745569feb104);
$parcel$export(module.exports, "superstarRamblings", () => $0a69d4c2d43b5225$export$4766e8d52671464);
$parcel$export(module.exports, "staffRamblings", () => $0a69d4c2d43b5225$export$550976994ed49cd1);
$parcel$export(module.exports, "mysteriousAdvisorRamblings", () => $0a69d4c2d43b5225$export$38b424d97ea0b481);
$parcel$export(module.exports, "ownerRamblings", () => $0a69d4c2d43b5225$export$3427fb283706ffcd);
const $0a69d4c2d43b5225$export$97818a4e89f24fb7 = [
    "Hi",
    "Hey",
    "Hello",
    "Greetings"
];
const $0a69d4c2d43b5225$export$63232d534813b55d = [
    {
        "subject": "Not signing",
        "content": "I'm sorry but I'm not open to signing with you. Instead, I'll be going to the Indies or maybe even to a new company."
    },
    {
        "subject": "Not available",
        "content": "After the buyout, I'm not looking to sign with anyone. It's time for a break."
    },
    {
        "subject": "Thanks but no",
        "content": "I promised myself I would not jump ship and I'm not going to do it even after the buyout."
    }
];
const $0a69d4c2d43b5225$export$844c33ba20b1954a = [
    {
        "subject": "Excited",
        "content": "I'm excited to be a part of this company and I can't wait to get started."
    },
    {
        "subject": "Let's start",
        "content": "Thanks for signing me onto the Main Roster. I'm ready to start."
    },
    {
        "subject": "Much better",
        "content": "This company already seems so much better. I think I'll be a more useful fit here."
    }
];
const $0a69d4c2d43b5225$export$e296c73225d6b1ca = [
    {
        "subject": "Excited",
        "content": "I'm excited to be here and I can't wait to get started."
    },
    {
        "subject": "Let's go",
        "content": "I'm here and I'm ready to start wrestling."
    },
    {
        "subject": "Can't wait",
        "content": "This is already so much better than where I was before. I can't wait to see what you have planned for me."
    },
    {
        "subject": "Thanks",
        "content": "It's good to be here. Thanks for giving me a chance."
    },
    {
        "subject": "Hello",
        "content": "I'm glad you signed me. Looking forward to what you have planned for me."
    },
    {
        "subject": "Good deal",
        "content": "That was a good deal you offered me. Hopefully my future here is even better."
    },
    {
        "subject": "Fresh start",
        "content": "I needed a fresh start. Thanks for signing me."
    },
    {
        "subject": "Ready",
        "content": "I'm ready to start and give you my best."
    }
];
const $0a69d4c2d43b5225$export$daed745569feb104 = [
    {
        "subject": "You'll beg me!",
        "content": "I'm going to do big things on the Indies. In a few months, you're going to beg me to come back, but I won't!"
    },
    {
        "subject": "Scared",
        "content": "I'll be honest: I'm scared of being out on my own, but I'm going to make the best of it."
    },
    {
        "subject": "Goodbye",
        "content": "I'm glad I could leave right now. Who knows, I might end up coming back. But for now, I need to be somewhere else."
    },
    {
        "subject": "You suck",
        "content": "You just didn't listen to me. You didn't care that I was unhappy. Well good riddance. I'm sure I can find much better bookers than you."
    },
    {
        "subject": "Goodbye",
        "content": "You know, I'm really glad I left. Now I can work where I want and be happy with my wrestling."
    },
    {
        "subject": "Big mistake",
        "content": "You made a big mistake. I'm going to make you regret booking me so badly."
    },
    {
        "subject": "Bad treatment",
        "content": "There are a lot of places that will treat me a lot better than you did. I'm glad I left because I deserve better."
    }
];
const $0a69d4c2d43b5225$export$4766e8d52671464 = [
    {
        "subject": "Weird dream",
        "content": `Have you ever dreamed of Martians? Last night I had a pretty weird dream about them. They were ` + `all green and they looked so scared, like they were being abused. I tried to help them but they just ` + `ran away. I wonder if it all meant anything.`
    },
    {
        "subject": "Hey",
        "content": `I just wanted to ask: have you ever been in love? I think I might be. I know I shouldn't do anything ` + `about it. It would mess up the locker room.`
    },
    {
        "subject": "Wrestling",
        "content": `This wrestling thing is pretty cool huh? Sometimes I can't believe I do this for a living. ` + `Just had a moment where it suddenly hit me how awesome the stories and the business are. Thought I'd share ` + `it with you, cause you must love it too.`
    },
    {
        "subject": "Hi",
        "content": `Just wanted to say hi and tell you that I'm super into my journey of wrestling. I've worked so hard ` + `to get here, and I'm ready to go even further.`
    },
    {
        "subject": "Booker",
        "content": `You ever thought about stepping into the ring? If you do, you better not make it a match with me!`
    },
    {
        "subject": "Bad day",
        "content": `You ever get low for no reason? Things just get really hard and you don't feel like getting up. ` + `Don't worry, I'll be there at the show. Wrestling takes me out of the bad place.`
    },
    {
        "subject": "Gene editing",
        "content": `You hear about this new gene editing thing? They take genes and insert them into your DNA using a ` + `virus. Soon they'll be able to cure diseases. But they could do anything, like making super humans. Maybe they ` + `could even clone people! It's terrifying to think about. I don't want to live in a world like that.`
    },
    {
        "subject": "Trash",
        "content": `There's so much trash in the locker room! I keep telling people to pick it up but I can't always ` + `be there. You gotta enforce this stuff. And while you're at it, tell 'em to stop using so much plastic!`
    }
];
const $0a69d4c2d43b5225$export$550976994ed49cd1 = [
    {
        "subject": "Wrestling game",
        "content": `Last week, superstars were backstage playing some wrestling game. It looked really fun, and ` + `everyone had a great time, but they were all wishing for a game where they could be the manager, so they could play you!`
    },
    {
        "subject": "Locker room",
        "content": `I was passing by the locker room and saw some of the superstars sitting quietly and eating ` + `together. It brought out such a homely feel and I just wanted to share that with you.`
    },
    {
        "subject": "Stories",
        "content": `Being around the superstars and in the locker room, I've seen a lot of things. I feel like ` + `I should write a book about it, but people wouldn't believe the stories!`
    }
];
const $0a69d4c2d43b5225$export$38b424d97ea0b481 = [
    {
        "subject": "Artifacts",
        "content": `Do you ever wonder where these Artifacts came from? Maybe they were built by some ancient ` + `civilization and lost to time? Or maybe a sorcerer ensouled the stones with some some powerful magic?`
    },
    {
        "subject": "Gods",
        "content": `Do you believe in the wrestling gods? I think they put the Artifacts down here on earth, and give ` + `them to us when we do things that make them happy.`
    }
];
const $0a69d4c2d43b5225$export$3427fb283706ffcd = [
    {
        "subject": "Hey",
        "content": `Hey pal, you up? Sorry to message you at 4 in the morning. Couldn't sleep.`
    },
    {
        "subject": "Gym Session",
        "content": `That gym session with the talent was a big mistake. My back hurts so much I can't even bend down at the toilet.`
    },
    {
        "subject": "Come on!",
        "content": `We gotta work hard to put on a great event for the fans. We gotta show them we can deliver! Let's work on an amazing show.`
    }
];

});

parcelRequire.register("18vSN", function(module, exports) {

$parcel$export(module.exports, "getAnnualTournamentData", () => $0d3f450b1a87ca0b$export$5184c82c2863bf81);
$parcel$export(module.exports, "getAnnualTournamentDialogData", () => $0d3f450b1a87ca0b$export$cbcea8e62e9d2c77);
$parcel$export(module.exports, "getPresidentData", () => $0d3f450b1a87ca0b$export$e64a3d02df70539e);
$parcel$export(module.exports, "addAnnualTournamentInjuredParticipantId", () => $0d3f450b1a87ca0b$export$7d4bf0dd09b2c9de);
$parcel$export(module.exports, "getAnnualTournamentAllParticipantIds", () => $0d3f450b1a87ca0b$export$85aa8d87a91a649f);
$parcel$export(module.exports, "processAnnualTournament", () => $0d3f450b1a87ca0b$export$63c2fb33dfcdbbc1);
$parcel$export(module.exports, "getAnnualTournamentParticipantOrganizationName", () => $0d3f450b1a87ca0b$export$2d0b70d045c56475);
$parcel$export(module.exports, "getAnnualTournamentParticipantOrganization", () => $0d3f450b1a87ca0b$export$7af57aa49c2e4db);
$parcel$export(module.exports, "getAnnualTournamentMatchPredictions", () => $0d3f450b1a87ca0b$export$7717b855b121d517);
$parcel$export(module.exports, "getAnnualTournamentPreviewTexts", () => $0d3f450b1a87ca0b$export$7e6ae9c345910485);
$parcel$export(module.exports, "getAnnualTournamentOpeningSegmentData", () => $0d3f450b1a87ca0b$export$179123e9156026a8);
$parcel$export(module.exports, "getAnnualTournamentWinnerSegmentData", () => $0d3f450b1a87ca0b$export$51dba658836151a3);
$parcel$export(module.exports, "updateAnnualTournamentCompanyStatusView", () => $0d3f450b1a87ca0b$export$e4071a1f3e69ee33);
$parcel$export(module.exports, "getAnnualTournamentAvailableSelections", () => $0d3f450b1a87ca0b$export$8cfbd56b940faf99);
$parcel$export(module.exports, "selectAnnualTournamentCompanyParticipants", () => $0d3f450b1a87ca0b$export$787a62d9464e4e6a);
$parcel$export(module.exports, "addAnnualTournamentCompanyBribeView", () => $0d3f450b1a87ca0b$export$651ed13880f6c9d2);
$parcel$export(module.exports, "replaceAnnualTournamentCompanyInjuredParticipant", () => $0d3f450b1a87ca0b$export$1b4227e599bdeb22);
$parcel$export(module.exports, "addAnnualTournamentInjuryReplacement", () => $0d3f450b1a87ca0b$export$2ba20f4e20d543be);
$parcel$export(module.exports, "getAnnualTournamentCpuReplacement", () => $0d3f450b1a87ca0b$export$b93a9d14a7d6bf6e);
$parcel$export(module.exports, "startAnnualTournamentView", () => $0d3f450b1a87ca0b$export$a84c4ccac441ffac);

var $98xmD = parcelRequire("98xmD");

var $4EGpv = parcelRequire("4EGpv");

var $iQtzn = parcelRequire("iQtzn");

var $8A6FL = parcelRequire("8A6FL");

var $3E8Nt = parcelRequire("3E8Nt");

var $5kTkA = parcelRequire("5kTkA");

var $4K85d = parcelRequire("4K85d");

var $iRMwH = parcelRequire("iRMwH");

var $14eBR = parcelRequire("14eBR");

var $9esFv = parcelRequire("9esFv");

var $hekDR = parcelRequire("hekDR");

var $eVEoH = parcelRequire("eVEoH");

var $dl5u4 = parcelRequire("dl5u4");

var $i7bmn = parcelRequire("i7bmn");

var $hBIDz = parcelRequire("hBIDz");

var $jpMCP = parcelRequire("jpMCP");

var $1JSre = parcelRequire("1JSre");

var $kZMqI = parcelRequire("kZMqI");

var $5ZsVo = parcelRequire("5ZsVo");

var $6RCLU = parcelRequire("6RCLU");

var $3SyPM = parcelRequire("3SyPM");

var $dGbip = parcelRequire("dGbip");

var $8bQDO = parcelRequire("8bQDO");

var $46buw = parcelRequire("46buw");
async function $0d3f450b1a87ca0b$export$5184c82c2863bf81(annualTournament, company, mainCompany, game) {
    let data = {};
    data["name"] = annualTournament.name;
    data["status"] = annualTournament.status;
    let companyData = $0d3f450b1a87ca0b$var$getAnnualTournamentCompanyData(annualTournament, company);
    // Get dialog
    if ([
        "selecting",
        "running"
    ].includes(annualTournament.status) || annualTournament.status === "inviting" && !companyData) data["dialogData"] = await $0d3f450b1a87ca0b$export$cbcea8e62e9d2c77(annualTournament, company, mainCompany, game, companyData);
    return data;
}
function $0d3f450b1a87ca0b$var$getAnnualTournamentCompanyData(annualTournament, company) {
    return annualTournament.companiesData[company.$loki.toString()];
}
async function $0d3f450b1a87ca0b$export$cbcea8e62e9d2c77(annualTournament, company, mainCompany, game, companyData) {
    let data = {};
    let presidentData = $0d3f450b1a87ca0b$export$e64a3d02df70539e(game);
    let participatingCompanies = await $0d3f450b1a87ca0b$var$getParticipatingCompanies(annualTournament, game);
    let participatingCompaniesNames = (0, $3E8Nt.commaSeparate)(participatingCompanies.map((x)=>x.name));
    let event = await (0, $8A6FL.getCompanyLatestEvent)(mainCompany);
    let previousTournaments = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).filter((x)=>x.annualTournament && x.status === "ended");
    let participationPoints = null;
    let entriesSample = null;
    let injuredParticipant = null;
    let bribeCost = null;
    if (annualTournament.status === "inviting") participationPoints = $0d3f450b1a87ca0b$var$getAnnualTournamentParticipationPoints(company);
    if (annualTournament.status === "selecting") {
        entriesSample = await $0d3f450b1a87ca0b$var$getAnnualTournamentEntriesSample(annualTournament, company);
        bribeCost = $0d3f450b1a87ca0b$var$getAnnualTournamentBribeCost(previousTournaments);
    }
    if (annualTournament.status === "running") injuredParticipant = $0d3f450b1a87ca0b$var$getAnnualTournamentInjuredParticipant(annualTournament);
    data["dialogs"] = await (0, $eVEoH.getAnnualTournamentDialogs)(annualTournament, companyData, event, previousTournaments, presidentData["name"], participatingCompaniesNames, entriesSample, participationPoints, injuredParticipant, bribeCost);
    data["information"] = presidentData;
    return data;
}
function $0d3f450b1a87ca0b$export$7d4bf0dd09b2c9de(annualTournament, injuredParticipantId) {
    for (let [_, v] of Object.entries(annualTournament.companiesData))if (v["participantIds"] && v["participantIds"].includes(injuredParticipantId)) {
        v["injuredParticipantId"] = injuredParticipantId;
        break;
    }
    return true;
}
function $0d3f450b1a87ca0b$var$getAnnualTournamentInjuredParticipant(annualTournament) {
    let injuredParticipant = null;
    let injuredParticipantId = null;
    for (let companyData of Object.values(annualTournament.companiesData))if (companyData["injuredParticipantId"]) {
        injuredParticipantId = companyData["injuredParticipantId"];
        break;
    }
    if (injuredParticipantId) injuredParticipant = (0, $14eBR.Superstars).get(injuredParticipantId);
    return injuredParticipant;
}
function $0d3f450b1a87ca0b$var$getAnnualTournamentParticipationPoints(company) {
    return company.reputation * 50;
}
function $0d3f450b1a87ca0b$var$getAnnualTournamentBribeCost(previousTournaments) {
    return 300 + previousTournaments.length * 50;
}
async function $0d3f450b1a87ca0b$var$getAnnualTournamentEntriesSample(annualTournament, company) {
    // Get all participants ids
    let allParticipantIds = $0d3f450b1a87ca0b$export$85aa8d87a91a649f(annualTournament);
    // Get sample ids, don't include company superstars
    let randomInstance = new Math.seedrandom(annualTournament.meta.created);
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let companySuperstarIds = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).map((x)=>x.$loki);
    let competitorSuperstarIds = allParticipantIds.filter((id)=>!companySuperstarIds.includes(id));
    let sampleSize = 3;
    if (competitorSuperstarIds.length < sampleSize) sampleSize = competitorSuperstarIds.length;
    let participantIdsSample = (0, $3E8Nt.getRandomSample)(competitorSuperstarIds, sampleSize, randomInstance);
    return Promise.all(participantIdsSample.map((x)=>(0, $14eBR.Superstars).get(x)));
}
async function $0d3f450b1a87ca0b$export$63c2fb33dfcdbbc1(game, mainCompany, user, weeklyShow, eventsToSimulate = null) {
    let annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
    const simulatingPastTournament = eventsToSimulate && eventsToSimulate !== 1;
    // Create tournament
    if (!annualTournament && !mainCompany.storyName && (0, $98xmD.globalUser).paid && !weeklyShow && game.settings["run_annual_tournament"] !== false && await $0d3f450b1a87ca0b$var$checkToAddAnnualTournament(game, mainCompany)) {
        // Check if competitors present
        const allCompetitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(mainCompany, game);
        if (allCompetitors.length) {
            // Get participating cpu companies
            const cpuCompanies = await (0, $8A6FL.getCpuControlledCompanies)(mainCompany, game);
            const userCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
            const [participatingCpuCompanies, participatingUserCompanies] = $0d3f450b1a87ca0b$var$selectParticipatingCompanies(cpuCompanies, userCompanies);
            let notParticipatingUserCompanies = userCompanies.filter((x)=>!(0, $3E8Nt.objectInArray)(x, participatingUserCompanies));
            // Create tournament
            await $0d3f450b1a87ca0b$var$createAnnualTournament(mainCompany, participatingCpuCompanies, notParticipatingUserCompanies);
        } else if (game.monthCount === 4) {
            const presidentData = $0d3f450b1a87ca0b$export$e64a3d02df70539e(game);
            const newMessage = await (0, $hekDR.createAnnualTournamentNoCompetitorsMessage)(presidentData["name"], game.monthCount, game.year);
            await (0, $9esFv.addCompanyMessages)(mainCompany, [
                newMessage
            ]);
        }
    } else if (annualTournament) {
        // Change to 'waiting' after invitations processed
        if (annualTournament.status === "inviting") {
            annualTournament.status = "waiting";
            // Add user response if simulating todo test simulating, below too, test sim past TGI
            if (eventsToSimulate) {
                const response = $0d3f450b1a87ca0b$var$getCompanyParticipationResponse(mainCompany);
                $0d3f450b1a87ca0b$var$updateAnnualTournamentCompanyStatus(annualTournament, mainCompany, response);
            }
        }
        // Change to 'selecting' after monthly show
        if (annualTournament.status === "waiting" && !weeklyShow) {
            // Create tournament events
            await $0d3f450b1a87ca0b$var$createAnnualTournamentEvents(annualTournament, mainCompany);
            // Add number of entries
            const participatingCompanies = await $0d3f450b1a87ca0b$var$getParticipatingCompanies(annualTournament, game);
            const numberOfEntriesData = $0d3f450b1a87ca0b$var$getNumberOfEntriesData(participatingCompanies);
            $0d3f450b1a87ca0b$var$addAnnualTournamentNumberOfEntriesData(annualTournament, numberOfEntriesData);
            // Select entries, select for user if simulating past TGI
            let organizations = participatingCompanies.filter((x)=>!x.userControlled);
            if (simulatingPastTournament) organizations = [
                ...participatingCompanies
            ];
            await $0d3f450b1a87ca0b$var$selectParticipantsForOrganizations(annualTournament, numberOfEntriesData, organizations, mainCompany);
            annualTournament.status = "selecting";
            // Simulate tournament if no user companies participating or simulating past TGI
            if (!participatingCompanies.some((x)=>x.userControlled) || simulatingPastTournament) {
                await $0d3f450b1a87ca0b$var$startAnnualTournament(annualTournament, game, mainCompany);
                await $0d3f450b1a87ca0b$var$simulateAnnualTournament(annualTournament, game, user, mainCompany);
            }
        }
        // End tournament if winner added
        if (annualTournament.status === "running" && annualTournament.winnerName) {
            annualTournament.status = "ended";
            await $0d3f450b1a87ca0b$var$processAnnualTournamentEnd(annualTournament, game, mainCompany);
        }
    }
    return true;
}
async function $0d3f450b1a87ca0b$var$checkToAddAnnualTournament(game, mainCompany) {
    let check = false;
    let currentMonth = game.monthCount;
    let annualTournamentMonth = 4;
    let previousTournaments = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).filter((x)=>x.annualTournament && x.status === "ended");
    // For existing saves past annual tournament's month, add if annual tournament is more than 3 months away
    if (currentMonth === annualTournamentMonth || !previousTournaments.length && (currentMonth > annualTournamentMonth || currentMonth < 2 && game.year > 0)) check = true;
    return check;
}
async function $0d3f450b1a87ca0b$var$simulateAnnualTournament(annualTournament, game, user, mainCompany) {
    let events = (await (0, $9esFv.getCompanyEvents)(mainCompany)).reverse();
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "main");
    let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    try {
        // Go through Night 1 & 2, process matches and end events
        for (let event of [
            events[0],
            events[1]
        ]){
            let eventMatches = await (0, $iQtzn.getEventMatches)(event);
            let sortedEventMatches = eventMatches.sort((a, b)=>b.order - a.order);
            // Add poster data
            if (event === events[0]) {
                let eventPosterData = await (0, $5ZsVo.getEventPosterGraphicData)(event, eventMatches, [], null, annualTournament);
                if (eventPosterData) event.posterGraphic = eventPosterData["graphics"];
            } else event.posterGraphic = events[0].posterGraphic;
            // Play matches
            for (let match of sortedEventMatches){
                let winner = await (0, $6RCLU.simulateAnnualTournamentMatchWinner)(match, annualTournament);
                await (0, $3SyPM.processPlayMatch)(match, winner.name, event, mainCompany, mainCompany, mainRoster, null, game, {}, {}, null, rosterSuperstars, null, null, null, null, null, true);
            }
            // End event
            await (0, $dGbip.endEvent)(mainCompany, user, true, rosterSuperstars);
        }
    } catch (err) {
        // If error simulating TGI, remove events and tournament
        (0, $3E8Nt.captureError)(err);
        await (0, $9esFv.removeCompanyEvents)(mainCompany, [
            events[0],
            events[1]
        ]);
        await (0, $9esFv.removeCompanyTournaments)(mainCompany, [
            annualTournament
        ]);
    }
    return true;
}
async function $0d3f450b1a87ca0b$var$processAnnualTournamentEnd(annualTournament, game, mainCompany) {
    let month = game.monthCount;
    let year = game.year;
    let annualTournamentWinner = await (0, $4EGpv.getTournamentWinnerSuperstar)(annualTournament);
    let annualTournamentWinnerCompany = await (0, $3E8Nt.getTalentCompany)(annualTournamentWinner);
    let presidentData = $0d3f450b1a87ca0b$export$e64a3d02df70539e(game);
    let allCompanies = await (0, $iRMwH.getGameActiveCompanies)(game);
    let participatingCompanies = await $0d3f450b1a87ca0b$var$getParticipatingCompanies(annualTournament, game);
    let userControlledParticipatingCompanies = participatingCompanies.filter((x)=>x.userControlled);
    // Send message from president
    if (userControlledParticipatingCompanies.length > 0) {
        let newMessage;
        if (annualTournamentWinnerCompany && annualTournamentWinnerCompany.userControlled) {
            // Send win message to user
            newMessage = await (0, $hekDR.createAnnualTournamentPresidentWinMessage)(presidentData["name"], month, year);
            await (0, $9esFv.addCompanyMessages)(annualTournamentWinnerCompany, [
                newMessage
            ]);
        } else {
            // Send loss message to user if CPU/Indies won
            newMessage = await (0, $hekDR.createAnnualTournamentPresidentLossMessage)(presidentData["name"], month, year);
            await (0, $9esFv.addCompanyMessages)(userControlledParticipatingCompanies[0], [
                newMessage
            ]);
        }
    } else {
        // Send message to user if they didn't participate
        let newMessage = await (0, $hekDR.createAnnualTournamentPresidentNoParticipationMessage)(presidentData["name"], annualTournamentWinner, month, year);
        await (0, $9esFv.addCompanyMessages)(mainCompany, [
            newMessage
        ]);
    }
    if (annualTournamentWinnerCompany) {
        if (annualTournamentWinnerCompany.userControlled) {
            // Add creative points bonus and message from owner
            let pointsBonus = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(200, 300), 50);
            annualTournamentWinnerCompany.points += pointsBonus;
            let newMessage = await (0, $hekDR.createAnnualTournamentOwnerWinMessage)(annualTournamentWinner, pointsBonus, annualTournamentWinnerCompany, annualTournament, month, year);
            await (0, $9esFv.addCompanyMessages)(annualTournamentWinnerCompany, [
                newMessage
            ]);
            // Add message from winner
            newMessage = await (0, $hekDR.createAnnualTournamentWinnerMessage)(annualTournamentWinner, annualTournament, month, year);
            await (0, $9esFv.addCompanyMessages)(annualTournamentWinnerCompany, [
                newMessage
            ]);
        }
        // Add fans to winning company
        if (game.marketSize) {
            let fanIncrease = game.marketSize * 0.05;
            if (fanIncrease > 300000) fanIncrease = 300000;
            annualTournamentWinnerCompany.fans += fanIncrease;
            // Read just fans based on market size
            let totalFans = allCompanies.reduce((total, company)=>total + company.fans, 0);
            let multiplyValue = game.marketSize / totalFans;
            for (const x of allCompanies)x.fans = (0, $3E8Nt.myround)(x.fans * multiplyValue, 100);
        } else annualTournamentWinnerCompany.fans += 20000;
        await $0d3f450b1a87ca0b$var$addAnnualTournamentWinCompanyLog(annualTournamentWinnerCompany, annualTournamentWinner, annualTournament, game, mainCompany);
    } else {
        // Move indie winner to available indies if not already there
        let indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
        if ((await (0, $hBIDz.getSuperstarRoster)(annualTournamentWinner))?.$loki === indieRoster.$loki) {
            let indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
            let transferred = await (0, $jpMCP.transferTalentToRoster)(annualTournamentWinner, indieAvailableRoster);
            for (let x of transferred)x.availableThisMonth = true;
        }
        // Add message from scout
        let scout = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(mainCompany), "scout");
        let newMessage = await (0, $hekDR.createAnnualTournamentIndieWinnerAvailableMessage)(annualTournamentWinner, month, year, scout);
        await (0, $9esFv.addCompanyMessages)(mainCompany, [
            newMessage
        ]);
    }
    // Add headline news for winner
    let superstarCompanyName = $0d3f450b1a87ca0b$export$2d0b70d045c56475(annualTournamentWinner, annualTournament, allCompanies);
    let newsItem = await (0, $kZMqI.generateNewsItem)({
        company: mainCompany,
        month: month,
        year: year,
        newsType: "annual_tournament_won",
        annualTournamentName: annualTournament.name,
        superstarCompanyName: superstarCompanyName,
        superstar: annualTournamentWinner,
        headline: true
    });
    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
        newsItem
    ]);
    // Add kayfabe points for winner
    (0, $5kTkA.updateSuperstarKayfabePoints)(annualTournamentWinner, 100);
    // Add trophy graphic to winner
    if (annualTournamentWinner.graphic) annualTournamentWinner.graphic = (0, $5kTkA.addSuperstarGraphicTemporaryTrophy)(annualTournamentWinner.graphic);
    // Set all user companies as 'playing'
    if (game.settings["control_multiple_companies"]) {
        let userControlledCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
        for (let x of userControlledCompanies)x.turnStatus = "playing";
    }
    return true;
}
async function $0d3f450b1a87ca0b$var$addAnnualTournamentWinCompanyLog(company, winner, annualTournament, game, mainCompany) {
    let newLog = (0, $4K85d.CompanyLog)(game.monthCount, mainCompany.realYear);
    await (0, $14eBR.CompanyLogs).insert(newLog);
    newLog.text = `${annualTournament.name} (${winner.name})`;
    newLog.type = "award";
    newLog.realYear = game.year;
    newLog.value = 3;
    await (0, $9esFv.addCompanyCompanyLogs)(company, [
        newLog
    ]);
    return newLog;
}
function $0d3f450b1a87ca0b$export$2d0b70d045c56475(participant, tournament, allCompanies) {
    const organization = $0d3f450b1a87ca0b$export$7af57aa49c2e4db(participant, tournament, allCompanies);
    if (organization) return (0, $1JSre.formatCompanyNameBackend)(organization.name);
    else return "Indies";
}
function $0d3f450b1a87ca0b$export$7af57aa49c2e4db(participant, tournament, allCompanies) {
    let organizationKey;
    for(const key in tournament.companiesData)if (tournament.companiesData.hasOwnProperty(key)) {
        const participantIds = tournament.companiesData[key]["participantIds"] || [];
        if (participantIds.indexOf(participant.$loki) >= 0) {
            organizationKey = key;
            break;
        }
    }
    return allCompanies.find((x)=>x.$loki.toString() === organizationKey);
}
function $0d3f450b1a87ca0b$export$e64a3d02df70539e(game) {
    const gameRandom = new Math.seedrandom(game.meta.created);
    return (0, $3E8Nt.getRandomChoice)((0, $eVEoH.presidentsData), gameRandom());
}
async function $0d3f450b1a87ca0b$var$createAnnualTournament(mainCompany, participatingCpuCompanies, notParticipatingUserCompanies) {
    const tournamentName = await $0d3f450b1a87ca0b$var$getAnnualTournamentName(mainCompany);
    let annualTournament = (0, $4EGpv.Tournament)(tournamentName, "elimination", 4);
    await (0, $14eBR.Tournaments).insert(annualTournament);
    annualTournament.annualTournament = true;
    annualTournament.prestige = "A";
    annualTournament.xp = 300;
    annualTournament.status = "inviting";
    annualTournament.companiesData = {};
    for (let x of participatingCpuCompanies)annualTournament.companiesData[x.$loki.toString()] = {
        status: "accepted"
    };
    for (let x of notParticipatingUserCompanies)annualTournament.companiesData[x.$loki.toString()] = {
        status: "declined"
    };
    annualTournament.companiesData["Indies"] = {
        status: "accepted"
    };
    await (0, $9esFv.addCompanyTournaments)(mainCompany, [
        annualTournament
    ]);
    return annualTournament;
}
async function $0d3f450b1a87ca0b$var$getAnnualTournamentName(mainCompany) {
    let previousAnnualTournaments = [];
    for (let x of (await (0, $9esFv.getCompanyTournaments)(mainCompany)))if (x.annualTournament && x.status === "ended") previousAnnualTournaments.push(x);
    let name = "The Grand Invitational";
    // Add iteration number
    if (previousAnnualTournaments.length) {
        let iteration = previousAnnualTournaments.length + 1;
        // Convert to roman numeral if 30 or below
        if (iteration <= 30) iteration = (0, $3E8Nt.romanizeNumber)(iteration);
        name = `${name} ${iteration}`;
    }
    return name;
}
function $0d3f450b1a87ca0b$var$selectParticipatingCompanies(cpuCompanies, userCompanies) {
    // Everyone accepts by default
    let participatingCpuCompanies = [
        ...cpuCompanies
    ];
    let participatingUserCompanies = [
        ...userCompanies
    ];
    // Remove companies if plentiful
    if (participatingCpuCompanies.length > 2) for (let competitor of participatingCpuCompanies){
        const response = $0d3f450b1a87ca0b$var$getCompanyParticipationResponse(competitor);
        if (response === "declined") {
            // Remove from participating companies
            participatingCpuCompanies = participatingCpuCompanies.filter((x)=>x.$loki !== competitor.$loki);
            if (participatingCpuCompanies.length <= 2) break;
        }
    }
    // Remove lowest xp companies if total above 15 (leaves one space for indies)
    // Remove cpu before user
    while(participatingCpuCompanies.length + participatingUserCompanies.length > 15){
        let lowestXpCompetitor = (0, $3E8Nt.getArrayMinByProperty)(participatingCpuCompanies, "xp");
        if (lowestXpCompetitor) participatingCpuCompanies = participatingCpuCompanies.filter((x)=>x.$loki !== lowestXpCompetitor.$loki);
        else {
            let lowestXpUserCompany = (0, $3E8Nt.getArrayMinByProperty)(participatingUserCompanies, "xp");
            participatingUserCompanies = participatingUserCompanies.filter((x)=>x.$loki !== lowestXpUserCompany.$loki);
        }
    }
    return [
        participatingCpuCompanies,
        participatingUserCompanies
    ];
}
function $0d3f450b1a87ca0b$var$getCompanyParticipationResponse(company) {
    let response = "accepted";
    // Higher chance for high or low REP companies to decline
    let chanceToDecline = 1;
    if (company.reputation <= 2 || company.reputation >= 9) chanceToDecline = 5;
    // Get chance to decline
    if ((0, $3E8Nt.getRandomInt)(1, 100) <= chanceToDecline) response = "declined";
    return response;
}
function $0d3f450b1a87ca0b$var$updateAnnualTournamentCompanyStatus(annualTournament, company, status) {
    let companyData = $0d3f450b1a87ca0b$var$getAnnualTournamentCompanyData(annualTournament, company);
    if (companyData === undefined) // Add status to companies data
    annualTournament.companiesData[company.$loki.toString()] = {
        status: status
    };
    return true;
}
async function $0d3f450b1a87ca0b$var$createAnnualTournamentEvents(annualTournament, mainCompany) {
    // Create events
    let events = [
        (0, $iQtzn.Event)(`${annualTournament.name} Night 2`),
        (0, $iQtzn.Event)(`${annualTournament.name} Night 1`)
    ];
    for (let x of events){
        await (0, $14eBR.Events).insert(x);
        x.prestige = "A";
        x.temporaryEvent = true;
        x.year = mainCompany.realYear;
    }
    await (0, $9esFv.addCompanyEvents)(mainCompany, events);
    await (0, $iQtzn.addEventTournaments)(events[1], [
        annualTournament
    ]);
    return true;
}
async function $0d3f450b1a87ca0b$var$getParticipatingCompanies(annualTournament, game) {
    let participatingCompanies = [];
    for (let x of (await (0, $iRMwH.getGameActiveCompanies)(game))){
        // Get companies with "accepted" status
        let companyData = $0d3f450b1a87ca0b$var$getAnnualTournamentCompanyData(annualTournament, x);
        if (companyData && companyData["status"] === "accepted") participatingCompanies.push(x);
    }
    return participatingCompanies;
}
function $0d3f450b1a87ca0b$var$getNumberOfEntriesData(participatingCompanies) {
    let data = {};
    let totalParticipants = 16;
    let maximumIndies = $0d3f450b1a87ca0b$var$getMaximumIndies(totalParticipants, participatingCompanies);
    let averageParticipants = $0d3f450b1a87ca0b$var$getAverageParticipants(participatingCompanies, totalParticipants);
    let sortedCompanies = participatingCompanies.sort((a, b)=>b.reputation - a.reputation || b.fans - a.fans);
    // Add participants for each company
    for (let company of sortedCompanies)data[company.$loki] = $0d3f450b1a87ca0b$var$getNumberOfCompanyParticipants(company, sortedCompanies, averageParticipants);
    // Add remaining participants
    data = $0d3f450b1a87ca0b$var$addRemainingParticipantsToIndiesData(data, totalParticipants, maximumIndies, sortedCompanies);
    return data;
}
function $0d3f450b1a87ca0b$var$getMaximumIndies(totalParticipants, participatingCompanies) {
    let maximumIndies = Math.floor(totalParticipants / 4);
    if (participatingCompanies.length >= 5) maximumIndies -= 1;
    if (participatingCompanies.length >= 10) maximumIndies -= 1;
    return maximumIndies;
}
function $0d3f450b1a87ca0b$var$getAverageParticipants(participatingCompanies, totalParticipants) {
    let totalOrganizations = participatingCompanies.length + 1; // Add indies
    let averageParticipants = Math.floor(totalParticipants / totalOrganizations);
    if (averageParticipants < 1) averageParticipants = 1;
    return averageParticipants;
}
function $0d3f450b1a87ca0b$var$getNumberOfCompanyParticipants(company, sortedCompanies, averageParticipants) {
    // Use average participants as a baseline of number of participants to add
    let reputationRatio = company.reputation / sortedCompanies[0].reputation; // highest company reputation
    return Math.ceil(averageParticipants * reputationRatio);
}
function $0d3f450b1a87ca0b$var$addRemainingParticipantsToIndiesData(data, totalParticipants, maximumIndies, sortedCompanies) {
    // Get remaining participants
    let remainingParticipants = totalParticipants - Object.values(data).reduce((a, b)=>a + b, 0);
    // If participants are more than maximum indies, add to companies
    while(remainingParticipants > maximumIndies && sortedCompanies.length)for (let company of sortedCompanies){
        data[company.$loki] += 1;
        remainingParticipants -= 1;
        if (remainingParticipants <= maximumIndies) break;
    }
    // Add remaining participants to indies
    data["Indies"] = remainingParticipants;
    return data;
}
function $0d3f450b1a87ca0b$var$getAnnualTournamentCompanyNumberOfEntries(annualTournament, company) {
    let numberOfEntries = null;
    let companyData = $0d3f450b1a87ca0b$var$getAnnualTournamentCompanyData(annualTournament, company);
    if (companyData) numberOfEntries = companyData["numberOfEntries"];
    return numberOfEntries;
}
function $0d3f450b1a87ca0b$var$addAnnualTournamentNumberOfEntriesData(annualTournament, numberOfEntriesData) {
    for (let [k, v] of Object.entries(numberOfEntriesData))if (annualTournament.companiesData[k.toString()]) annualTournament.companiesData[k.toString()]["numberOfEntries"] = v;
    return numberOfEntriesData;
}
async function $0d3f450b1a87ca0b$var$selectParticipantsForOrganizations(annualTournament, numberOfEntriesData, companies, mainCompany, participantType = null) {
    let organizations = [
        ...companies,
        "Indies"
    ]; // Competitors and Indies
    let indieRosters = [
        await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie"),
        await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable")
    ];
    for (let organization of organizations){
        // Get number of entries
        let organizationKey = organization === "Indies" ? organization : organization.$loki;
        let numberOfEntries = numberOfEntriesData[organizationKey];
        // Select participants for organization
        let participants = await $0d3f450b1a87ca0b$var$selectOrganizationParticipants(organization, numberOfEntries, indieRosters, participantType);
        let participantIds = participants.map((x)=>x.$loki);
        // Add to companies data
        $0d3f450b1a87ca0b$var$addAnnualTournamentCompanyParticipants(annualTournament, organization, participantIds);
    }
    return true;
}
function $0d3f450b1a87ca0b$var$addAnnualTournamentCompanyParticipants(annualTournament, company, participantIds) {
    let companyKey = company === "Indies" ? company : company.$loki.toString();
    if (annualTournament.companiesData[companyKey]) annualTournament.companiesData[companyKey]["participantIds"] = participantIds;
    return true;
}
async function $0d3f450b1a87ca0b$var$selectOrganizationParticipants(organization, numberOfEntries, indieRosters, participantType) {
    // Get weights
    let rosters = organization === "Indies" ? indieRosters : [
        await (0, $8A6FL.getCompanyRosterByType)(organization, "main")
    ];
    let talent = await $0d3f450b1a87ca0b$var$getAvailableTalent(rosters, participantType);
    let participantsWeights = await $0d3f450b1a87ca0b$var$getParticipantsWeights(talent);
    // Select participants
    return $0d3f450b1a87ca0b$var$selectParticipantsFromWeights(participantsWeights, numberOfEntries);
}
async function $0d3f450b1a87ca0b$var$getAvailableTalent(rosters, participantType) {
    // Get talent based on participant type
    let rosterTalent;
    switch(participantType){
        case "tag":
            rosterTalent = (await Promise.all(rosters.map((x)=>(0, $dl5u4.getRosterTagTeams)(x)))).flat().filter((x)=>!x.trio && !x.temporary);
            break;
        case "trio":
            rosterTalent = (await Promise.all(rosters.map((x)=>(0, $dl5u4.getRosterTagTeams)(x)))).flat().filter((x)=>x.trio && !x.temporary);
            break;
        default:
            rosterTalent = (await Promise.all(rosters.map((x)=>(0, $dl5u4.getRosterSuperstars)(x)))).flat();
    }
    // Get available talent
    let availableTalent = [];
    for (const x of rosterTalent){
        let ts = await (0, $5kTkA.getRosterMemberSuperstars)(x);
        if (ts.every((y)=>(0, $5kTkA.checkAvailability)(y, false))) availableTalent.push(x);
    }
    // Restrict female talent if enough male talent
    availableTalent = await $0d3f450b1a87ca0b$var$filterFemaleTalent(availableTalent);
    return availableTalent;
}
async function $0d3f450b1a87ca0b$var$filterFemaleTalent(talent) {
    let maleTalent = [];
    for (const x of talent){
        let ts = await (0, $5kTkA.getRosterMemberSuperstars)(x);
        if (ts.every((y)=>y.gender === "male")) maleTalent.push(x);
    }
    if (maleTalent.length >= 10) talent = maleTalent;
    return talent;
}
async function $0d3f450b1a87ca0b$var$getParticipantsWeights(participants) {
    let weights = [];
    // Add weights from top and young participants
    let topParticipants = await $0d3f450b1a87ca0b$var$getTopParticipants(participants);
    let youngParticipants = await $0d3f450b1a87ca0b$var$getYoungParticipants(participants, topParticipants);
    // Get weights for participants
    for (let participant of [
        ...topParticipants,
        ...youngParticipants
    ]){
        let weight = await $0d3f450b1a87ca0b$var$getParticipantWeight(participant);
        weights.push([
            participant,
            weight
        ]);
    }
    return weights;
}
async function $0d3f450b1a87ca0b$var$getParticipantWeight(participant) {
    let popularity = await (0, $3E8Nt.getRosterMemberPopularity)(participant);
    if (popularity > 1000) popularity = 1000;
    // Get weight based on popularity
    return (popularity / 100) ** 2 / 100;
}
async function $0d3f450b1a87ca0b$var$getTopParticipants(participants) {
    let sortedPopularityParticipants = await $0d3f450b1a87ca0b$var$getSortedParticipantsByPopularity(participants);
    return sortedPopularityParticipants.slice(0, 15);
}
async function $0d3f450b1a87ca0b$var$getYoungParticipants(participants, topParticipants) {
    let sorted = [
        ...participants
    ].filter((p)=>!(0, $3E8Nt.objectInArray)(p, topParticipants));
    for (const x of sorted)x.tempAge = await (0, $3E8Nt.getRosterMemberAge)(x);
    sorted = sorted.sort((a, b)=>a.tempAge - b.tempAge);
    for (const x of sorted)delete x.tempAge;
    return sorted.slice(0, 3);
}
async function $0d3f450b1a87ca0b$var$getSortedParticipantsByPopularity(participants) {
    let sorted = [
        ...participants
    ];
    for (const x of sorted)x.tempPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
    sorted = sorted.sort((a, b)=>b.tempPopularity - a.tempPopularity);
    for (const x of sorted)delete x.tempPopularity;
    return sorted;
}
function $0d3f450b1a87ca0b$var$selectParticipantsFromWeights(weights, numberOfEntries) {
    let participants = [];
    for(let x = 0; x < numberOfEntries; x++)if (weights.length) {
        let selection = (0, $3E8Nt.weightedChoice)(weights);
        weights = weights.filter((y)=>y[0].$loki !== selection.$loki);
        participants.push(selection);
    }
    return participants;
}
async function $0d3f450b1a87ca0b$var$startAnnualTournament(annualTournament, game, mainCompany) {
    // Get participants
    let participants = await $0d3f450b1a87ca0b$var$getAllParticipantsForTournament(annualTournament, game, mainCompany);
    // Create matches, add to tournament events
    let events = (await (0, $9esFv.getCompanyEvents)(mainCompany)).reverse();
    await $0d3f450b1a87ca0b$var$createAnnualTournamentMatches(annualTournament, events, participants, game, mainCompany);
    annualTournament.status = "running";
    // Set all user companies besides game as 'ended', set game as current company
    if (game.settings["control_multiple_companies"]) {
        game.currentCompanyId = null;
        let userControlledCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
        for (let x of userControlledCompanies)if (x.$loki !== mainCompany.$loki) x.turnStatus = "ended";
    }
    return true;
}
async function $0d3f450b1a87ca0b$var$getAllParticipantsForTournament(annualTournament, game, mainCompany, participantType = null) {
    // Get participants from companies data
    let allParticipantIds = $0d3f450b1a87ca0b$export$85aa8d87a91a649f(annualTournament);
    let allParticipants = await (0, $14eBR.Superstars).find({
        "$loki": {
            "$in": allParticipantIds
        }
    });
    // Generate indie participants if not enough participants
    let totalParticipants = Object.values(annualTournament.companiesData).map((y)=>y["numberOfEntries"] || 0).reduce((a, b)=>a + b, 0);
    if (allParticipants.length < totalParticipants) {
        let indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
        let generatedParticipants = await $0d3f450b1a87ca0b$var$generateIndieParticipants(totalParticipants, indieRoster, participantType, allParticipants);
        allParticipants.push(...generatedParticipants);
        // Add generated participant ids to 'Indies' in companies data
        annualTournament.companiesData["Indies"]["participantIds"].push(...generatedParticipants.map((x)=>x.$loki));
    }
    return allParticipants;
}
async function $0d3f450b1a87ca0b$var$generateIndieParticipants(totalParticipants, indieRoster, participantType, participants) {
    let generatedParticipants = [];
    let numberToGenerate = totalParticipants - participants.length;
    let gender = participants.length ? (await (0, $5kTkA.getRosterMemberSuperstars)(participants[0]))[0].gender : "male";
    if (participantType === "tag") numberToGenerate *= 2;
    else if (participantType === "trio") numberToGenerate *= 3;
    // Generate superstars
    let generatedSuperstars = [];
    for(let i = 0; i < numberToGenerate; i++){
        let newSuperstar = await (0, $8bQDO.generateSuperstar)({
            popularity: (0, $3E8Nt.getRandomInt)(400, 750),
            gender: gender,
            notManager: true
        });
        generatedSuperstars.push(newSuperstar);
        await (0, $dl5u4.addRosterSuperstars)(indieRoster, [
            newSuperstar
        ]);
    }
    // Generate tag teams
    if (participantType === "tag" || participantType === "trio") {
        let superstarsPerTeam = participantType === "tag" ? 2 : 3;
        let superstarsData = chunk(generatedSuperstars, superstarsPerTeam);
        for (let x of superstarsData){
            let newTeam;
            if (participantType === "tag") newTeam = await (0, $8bQDO.generateTagTeam)(x);
            else newTeam = await (0, $8bQDO.generateTrio)(x);
            generatedParticipants.push(newTeam);
            await (0, $dl5u4.addRosterTagTeams)(indieRoster, [
                newTeam
            ]);
        }
    } else generatedParticipants = generatedSuperstars;
    return generatedParticipants;
}
function $0d3f450b1a87ca0b$export$85aa8d87a91a649f(annualTournament) {
    let allParticipantIds = [];
    for (const x of Object.values(annualTournament.companiesData)){
        const companyParticipantIds = x["participantIds"];
        if (companyParticipantIds) allParticipantIds.push(...companyParticipantIds);
    }
    return allParticipantIds;
}
async function $0d3f450b1a87ca0b$var$createAnnualTournamentMatches(annualTournament, events, participants, game, mainCompany) {
    const tournamentRounds = 4;
    // Get first round matches from seeds
    let seeds = await $0d3f450b1a87ca0b$var$getTournamentSeeds(participants, game, mainCompany, annualTournament);
    let firstRoundMatchGroups = [
        ...$0d3f450b1a87ca0b$var$getMatchesFromSeeds(seeds)
    ].reverse();
    // Add future matches
    let futureMatches = await $0d3f450b1a87ca0b$var$addFutureMatchesToEvent(tournamentRounds, firstRoundMatchGroups, events[1]);
    // Add first round matches
    let firstRoundMatches = await $0d3f450b1a87ca0b$var$addMatchesToEvent(firstRoundMatchGroups, events[0]);
    // Add matches to tournament
    await (0, $4EGpv.addTournamentMatches)(annualTournament, futureMatches.concat(firstRoundMatches));
    return true;
}
async function $0d3f450b1a87ca0b$var$getTournamentSeeds(participants, game, mainCompany, annualTournament) {
    // Get nested array of participants sorted by popularity then into organization groups e.g [[a, b], [c, d]]
    let organizationGroups = await $0d3f450b1a87ca0b$var$getOrganizationGroups(participants, game, mainCompany, annualTournament);
    // Add seeds by cycling through organization groups until they're filled
    let seeds = [];
    while(seeds.length < participants.length)for (const organizationGroup of organizationGroups){
        if (organizationGroup.length) {
            let seed = seeds.length + 1;
            let participant = organizationGroup[0];
            seeds.push([
                participant,
                seed
            ]);
            organizationGroup.shift();
            participant.tournamentSeed = seed;
        }
        // End when seeds are full
        if (seeds.length >= participants.length) break;
    }
    return seeds;
}
async function $0d3f450b1a87ca0b$var$getOrganizationGroups(participants, game, mainCompany, annualTournament) {
    let allCompanies = await (0, $iRMwH.getGameActiveCompanies)(game);
    // Sort organizations by top first, indies at end
    let organizations = [
        ...await $0d3f450b1a87ca0b$var$getParticipatingCompanies(annualTournament, game),
        "Indies"
    ];
    organizations.sort((a, b)=>b.reputation - a.reputation || b.fans - a.fans);
    // Group participants, sorted by popularity, by organization into dict e.g {organization: [participants]}
    let participantsForOrganizations = {};
    let sortedParticipants = await $0d3f450b1a87ca0b$var$getSortedParticipantsByPopularity(participants);
    for (let participant of sortedParticipants){
        let participantOrganization = $0d3f450b1a87ca0b$export$7af57aa49c2e4db(participant, annualTournament, allCompanies);
        if (!participantOrganization) participantOrganization = "Indies";
        let key = participantOrganization === "Indies" ? participantOrganization : participantOrganization.$loki;
        if (participantsForOrganizations[key]) participantsForOrganizations[key].push(participant);
        else participantsForOrganizations[key] = [
            participant
        ];
    }
    // Get participants for sorted organizations in arrays
    return organizations.map((x)=>{
        let key = x === "Indies" ? x : x.$loki;
        return participantsForOrganizations[key] || [];
    });
}
function $0d3f450b1a87ca0b$var$getMatchesFromSeeds(seeds) {
    let matches = [];
    let nextNodes = [
        seeds[0],
        seeds[1]
    ];
    let rounds = Math.floor(Math.log2(seeds.length));
    for(let z = 0; z < rounds - 1; z++){
        let nodes = [
            ...nextNodes
        ];
        nextNodes = [];
        // Add seed to previous round
        for (let x of nodes)nextNodes.push(...[
            x,
            null
        ]);
        let nextSeeds = seeds.slice(nextNodes.length / 2, nextNodes.length);
        for (let x of nextSeeds){
            // Find seed to pair with
            let i = nextNodes.length + 1 - x[1];
            // Add seed to node after i
            let node = nextNodes.find((y)=>y && y[1] === i);
            let pos = nextNodes.indexOf(node) + 1;
            nextNodes[pos] = x;
        }
    }
    // Reverse second half
    nextNodes = nextNodes.splice(0, nextNodes.length / 2).concat(nextNodes.reverse());
    // Divide nodes into two superstars
    for (const x of (0, $3E8Nt.getChunks)(nextNodes, 2)){
        let participants = [
            x[1][0],
            x[0][0]
        ];
        matches.push(participants);
    }
    return matches;
}
async function $0d3f450b1a87ca0b$var$addFutureMatchesToEvent(tournamentRounds, firstRoundMatchGroups, event) {
    // Add blank matches for final rounds
    let addedMatches = [];
    for(let tournamentRound = tournamentRounds; tournamentRound > 1; tournamentRound--){
        let matchesToAdd = firstRoundMatchGroups.length * 2 / 2 ** tournamentRound;
        for(let y = 0; y < matchesToAdd; y++){
            let addedMatch = await $0d3f450b1a87ca0b$var$addMatchToEvent([], event, tournamentRound);
            addedMatches.push(addedMatch);
        }
    }
    return addedMatches;
}
async function $0d3f450b1a87ca0b$var$addMatchesToEvent(firstRoundMatchGroups, event) {
    // Add first round matches
    let addedMatches = [];
    for (let matchParticipants of firstRoundMatchGroups){
        let addedMatch = await $0d3f450b1a87ca0b$var$addMatchToEvent(matchParticipants, event, 1);
        addedMatches.push(addedMatch);
    }
    return addedMatches;
}
async function $0d3f450b1a87ca0b$var$addMatchToEvent(participants, event, tournamentRound) {
    let participantType = $0d3f450b1a87ca0b$var$getParticipantType(participants);
    const newMatch = (0, $i7bmn.Match)(event.matchesCount, participantType === "tag" ? "tag" : "singles");
    await (0, $14eBR.Matches).insert(newMatch);
    await (0, $iQtzn.addEventMatches)(event, [
        newMatch
    ]);
    event.matchesCount += 1;
    await (0, $i7bmn.addMatchParticipants)(newMatch, participants);
    newMatch.tournamentRound = tournamentRound;
    return newMatch;
}
function $0d3f450b1a87ca0b$var$getParticipantType(participants) {
    let participantType = null;
    if (participants.length && participants[0].objectName === "tagTeam") participantType = "tag";
    return participantType;
}
async function $0d3f450b1a87ca0b$export$7717b855b121d517(eventMatches, eventName, annualTournament) {
    const data = {};
    const predictions = [];
    const winners = [];
    const allMatches = [
        ...eventMatches
    ].sort((a, b)=>a.order - b.order);
    for (const match of allMatches){
        const participants = await (0, $i7bmn.getMatchParticipants)(match);
        // Don't run for matches without participants e.g tournament finals
        if (!participants.length) continue;
        // Get predicted winner
        const weights = await (0, $6RCLU.getAnnualTournamentWinLossPercentagesWeights)(participants);
        const winner = (0, $3E8Nt.weightedChoice)(weights);
        winners.push(winner);
        // Get win text
        const predictionText = `${winner.name}.`;
        predictions.push({
            matchText: await (0, $5ZsVo.getEventPreviewMatchText)(match, false, true),
            predictionText: predictionText
        });
    }
    // Get tournament winner prediction on Night 2
    if (eventName.endsWith("2")) {
        const tournamentWinner = await $0d3f450b1a87ca0b$var$getAnnualTournamentWinnerPrediction(winners);
        const predictionText = `${tournamentWinner.name}.`;
        predictions.push({
            matchText: `${annualTournament.name} Winner`,
            predictionText: predictionText
        });
    }
    data["predictions"] = predictions;
    // Get journalist data
    const journalistData = (0, $5ZsVo.generateJournalistData)();
    data["journalistName"] = journalistData.name;
    data["journalistPossessivePronoun"] = journalistData.possessivePronoun;
    return data;
}
async function $0d3f450b1a87ca0b$var$getAnnualTournamentWinnerPrediction(participants) {
    const weights = await $0d3f450b1a87ca0b$var$getParticipantsWeights(participants);
    return (0, $3E8Nt.weightedChoice)(weights);
}
async function $0d3f450b1a87ca0b$export$7e6ae9c345910485(event, eventMatches, annualTournament, mainCompany, game) {
    const previewTexts = [];
    const participatingCompanies = await $0d3f450b1a87ca0b$var$getParticipatingCompanies(annualTournament, game);
    const participatingCompaniesNames = (0, $3E8Nt.commaSeparate)(participatingCompanies.map((x)=>x.name).concat("the Indies"));
    // Get top matches by popularity of participants
    let sortedMatches = [
        ...eventMatches
    ];
    for (const x of sortedMatches){
        let p = await (0, $i7bmn.getMatchParticipants)(x);
        if (p.length) {
            let totalPopularity = await Promise.all(p.map((s)=>(0, $3E8Nt.getRosterMemberPopularity)(s)));
            x.tempPopularity = totalPopularity.reduce((a, b)=>a + b, 0);
        }
    }
    sortedMatches = sortedMatches.filter((x)=>x.tempPopularity !== undefined).sort((a, b)=>b.tempPopularity - a.tempPopularity);
    for (const x of sortedMatches)delete x.tempPopularity;
    // Night 1
    if (event.name.endsWith("1")) {
        const previousTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).reverse().find((x)=>x.annualTournament && x.status === "ended");
        const allParticipantIds = $0d3f450b1a87ca0b$export$85aa8d87a91a649f(annualTournament);
        // Intro text
        if (previousTournament) previewTexts.push("Fans have been eagerly anticipating the tournament, and it starts tonight in front of a sold out crowd!");
        else previewTexts.push("Fans have been dreaming about this tournament ever since it was announced, and it finally starts tonight!");
        // Companies text
        previewTexts.push(`Talent from <span class="font-bold">${participatingCompaniesNames}</span> are competing to see who takes home the trophy.`);
        // Previous winner text
        if (previousTournament) {
            const winner = await (0, $4EGpv.getTournamentWinnerSuperstar)(previousTournament);
            if (winner) {
                if (allParticipantIds.includes(winner.$loki)) previewTexts.push(`<span class="font-bold">${winner.name}</span>, winner of the last tournament, is participating ` + `and hoping to win again.`);
                else previewTexts.push(`<span class="font-bold">${winner.name}</span>, who won the last tournament, is sadly not ` + `participating this time.`);
            }
        }
        // Entries text
        previewTexts.push("Here is the complete entry list:");
        const allParticipants = await Promise.all(allParticipantIds.map((x)=>(0, $14eBR.Superstars).get(x)));
        const entriesTexts = allParticipants.sort((a, b)=>a.tournamentSeed - b.tournamentSeed).map((p, i)=>{
            const participantOrganization = $0d3f450b1a87ca0b$export$2d0b70d045c56475(p, annualTournament, participatingCompanies);
            const classHtml = i > 0 ? ' class="margin-top-5"' : "";
            return `<div${classHtml}>- ${p.name} (${participantOrganization})</div>`;
        });
        previewTexts.push(entriesTexts.join(""));
        // Matches text
        const topMatchesPreviewText = (0, $3E8Nt.commaSeparate)(await Promise.all(sortedMatches.slice(0, 3).map((x)=>(0, $5ZsVo.getEventPreviewMatchText)(x))));
        previewTexts.push(`Some first round matches we're excited for include ${topMatchesPreviewText}.`);
        // Continue text
        previewTexts.push(`Who will move on to Night 2 of ${annualTournament.name}? Continue for our predictions.`);
    } else if (event.name.endsWith("2")) {
        // Intro text
        previewTexts.push("Excitement is high for Night 2 of the tournament, but so is the tension. The winner will be crowned tonight!");
        // Remaining participants text
        let topRemainingParticipants = (await Promise.all(sortedMatches.map((x)=>(0, $i7bmn.getMatchParticipants)(x)))).flat();
        topRemainingParticipants = topRemainingParticipants.sort((a, b)=>a.tournamentSeed - b.tournamentSeed).slice(0, 4);
        const topRemainingParticipantsData = topRemainingParticipants.map((p)=>{
            const participantOrganization = $0d3f450b1a87ca0b$export$2d0b70d045c56475(p, annualTournament, participatingCompanies);
            return `${p.name} (${participantOrganization})`;
        });
        previewTexts.push(`Top stars that progressed to Night 2 include ` + `<span class="font-bold">${(0, $3E8Nt.commaSeparate)(topRemainingParticipantsData)}</span>.`);
        // Matches text
        const topMatchesPreviewText = (0, $3E8Nt.commaSeparate)(await Promise.all(sortedMatches.slice(0, 2).map((x)=>(0, $5ZsVo.getEventPreviewMatchText)(x))));
        previewTexts.push(`Fans cannot wait for the quarter final matchups, especially ${topMatchesPreviewText}.`);
        // Continue text
        previewTexts.push(`Who will go on to win ${annualTournament.name}? Continue for our predictions.`);
    }
    return previewTexts;
}
function $0d3f450b1a87ca0b$export$179123e9156026a8(game, annualTournament) {
    const presidentData = $0d3f450b1a87ca0b$export$e64a3d02df70539e(game);
    return {
        name: "Opening Segment",
        startTexts: [
            `The show opens with the president, ${presidentData.name}, standing in the middle of the ring ...`
        ],
        actionTexts: [
            `${presidentData.name} welcomes the fans to ${annualTournament.name} and promises an amazing show!`
        ],
        graphics: [
            presidentData.graphic
        ],
        segmentType: "segment",
        annualTournament: true
    };
}
function $0d3f450b1a87ca0b$export$51dba658836151a3(game, annualTournament, winner) {
    const presidentData = $0d3f450b1a87ca0b$export$e64a3d02df70539e(game);
    // Get attire or graphic of winner if present, otherwise get empty graphic
    let winnerGraphic = (0, $5kTkA.getGraphicForSuperstar)(winner);
    delete winnerGraphic["uid"];
    return {
        name: "Trophy Presentation",
        startTexts: [
            `${presidentData["name"]} comes down to the ring and announces ${winner.name} as the winner of ${annualTournament.name}.`
        ],
        actionTexts: [
            `${winner.name} lifts the trophy as fireworks go off! ${presidentData["name"]} thanks everyone and asks them to come again next time.`
        ],
        graphics: [
            winnerGraphic,
            presidentData["graphic"]
        ],
        segmentType: "segment",
        annualTournament: true
    };
}
async function $0d3f450b1a87ca0b$export$e4071a1f3e69ee33({ action: action } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    // Get annual tournament
    let annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
    if (!annualTournament) {
        data["error"] = "tournament-not-found";
        return data;
    }
    // Change user company's status
    let status = action === "acceptInvitation" ? "accepted" : "declined";
    $0d3f450b1a87ca0b$var$updateAnnualTournamentCompanyStatus(annualTournament, userCompany, status);
    // Add message from owner
    let newMessage;
    if (status === "accepted") newMessage = await (0, $hekDR.createInvitationAcceptedMessage)(userCompany, game.monthCount, game.year);
    else newMessage = await (0, $hekDR.createInvitationDeclinedMessage)(userCompany, game.monthCount, game.year);
    await (0, $9esFv.addCompanyMessages)(userCompany, [
        newMessage
    ]);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $0d3f450b1a87ca0b$export$8cfbd56b940faf99({ injuryReplacement: injuryReplacement } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    // Get annual tournament
    let annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
    // Get available superstars
    let company;
    if (injuryReplacement) {
        // Get injured superstar's company
        let companyKey = null;
        for (let [k, v] of Object.entries(annualTournament.companiesData))if (v["injuredParticipantId"]) {
            companyKey = k;
            break;
        }
        company = companyKey === String(userCompany.$loki) ? userCompany : (0, $14eBR.Companies).get(parseInt(companyKey));
    } else company = userCompany;
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    let sortedSuperstars = [
        ...superstars
    ].sort((a, b)=>b.popularity - a.popularity);
    let companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    // Mark current participants as unavailable if tournament injury replacement
    let allParticipantIds = [];
    if (injuryReplacement && annualTournament) allParticipantIds = $0d3f450b1a87ca0b$export$85aa8d87a91a649f(annualTournament);
    data["selections"] = sortedSuperstars.map((x)=>({
            "name": x.name,
            "popularity": x.popularity,
            "uid": x.$loki,
            "appearances": x.partTimer && !x.retired ? x.appearances : null,
            "retired": x.retired,
            "injured": x.injured > 0 ? x.injured : false,
            "championships": (0, $5kTkA.getSuperstarChampionshipsAll)(x, companyChampionships),
            "fullTimeManager": x.fullTimeManager,
            "available": (0, $5kTkA.checkAvailability)(x, false) && !allParticipantIds.includes(x.$loki)
        }));
    // Get number of entries
    if (annualTournament) {
        if (injuryReplacement) data["numberOfEntries"] = 1;
        else data["numberOfEntries"] = $0d3f450b1a87ca0b$var$getAnnualTournamentCompanyNumberOfEntries(annualTournament, userCompany);
    }
    return data;
}
async function $0d3f450b1a87ca0b$export$787a62d9464e4e6a({ participantUids: participantUids } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    // Get annual tournament
    let annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
    if (!annualTournament) {
        data["error"] = "tournament-not-found";
        return data;
    }
    // Get participants
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    let participants = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>participantUids.includes(x.$loki));
    // Check number of entries
    let numberOfEntries = $0d3f450b1a87ca0b$var$getAnnualTournamentCompanyNumberOfEntries(annualTournament, userCompany);
    if (participants.length > numberOfEntries) {
        data["error"] = "too-many-entries";
        return data;
    }
    // Add user company participants
    $0d3f450b1a87ca0b$var$addAnnualTournamentCompanyParticipants(annualTournament, userCompany, participantUids);
    // Add popularity boosts to participants
    $0d3f450b1a87ca0b$var$addAnnualTournamentParticipantsPopularityBoost(participants);
    // Add participation points
    let participationPoints = $0d3f450b1a87ca0b$var$getAnnualTournamentParticipationPoints(userCompany);
    if (participants.length === numberOfEntries) data["dialog"] = (0, $eVEoH.otherDialogs)["entriesSelectedFull"];
    else {
        participationPoints = (0, $3E8Nt.myround)(participationPoints * (participants.length / numberOfEntries), 50);
        data["dialog"] = (0, $eVEoH.otherDialogs)["entriesSelectedNotFull"];
    }
    userCompany.points += participationPoints;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = userCompany.points;
    return data;
}
function $0d3f450b1a87ca0b$var$addAnnualTournamentParticipantsPopularityBoost(participants) {
    for (let participant of participants){
        let boost = (0, $3E8Nt.getRandomInt)(20, 30);
        (0, $5kTkA.updateSuperstarPopularity)(participant, boost);
    }
    return true;
}
async function $0d3f450b1a87ca0b$export$651ed13880f6c9d2() {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    // Get bribe cost
    let previousTournaments = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).filter((x)=>x.annualTournament && x.status === "ended");
    let bribeCost = $0d3f450b1a87ca0b$var$getAnnualTournamentBribeCost(previousTournaments);
    // Get annual tournament
    let annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
    if (!annualTournament) {
        data["error"] = "tournament-not-found";
        return data;
    }
    if (userCompany.points >= bribeCost) {
        // Add user company bribe
        $0d3f450b1a87ca0b$var$addAnnualTournamentCompanyBribe(annualTournament, userCompany);
        // Remove points
        userCompany.points -= bribeCost;
        (0, $14eBR.db).saveDatabase();
        data["success"] = true;
        data["dialog"] = (0, $eVEoH.otherDialogs)["bribeAccepted"];
        data["points"] = userCompany.points;
    } else data["dialog"] = (0, $eVEoH.otherDialogs)["bribeNotEnoughPoints"];
    return data;
}
async function $0d3f450b1a87ca0b$export$1b4227e599bdeb22({ replacementUid: replacementUid } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    // Get latest event match
    let event = await (0, $8A6FL.getCompanyLatestEvent)(mainCompany);
    let eventMatches = (await (0, $iQtzn.getEventMatches)(event)).filter((x)=>x.winner !== null);
    let latestMatch = eventMatches.sort((a, b)=>a.order - b.order)[0];
    // Get annual tournament
    let annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
    if (!annualTournament) {
        data["error"] = "tournament-not-found";
        return data;
    }
    // Get replacement
    let replacement = null;
    if (replacementUid) replacement = (0, $14eBR.Superstars).get(replacementUid);
    // Get injured participant
    let injuredParticipant = $0d3f450b1a87ca0b$var$getAnnualTournamentInjuredParticipant(annualTournament);
    // Replace injured participant
    let replacementId = null;
    if (replacement) {
        replacementId = replacement.$loki;
        data["dialog"] = [
            ...(0, $eVEoH.otherDialogs)["replacementAdded"]
        ];
        data["dialog"][0] = data["dialog"][0].format(injuredParticipant.name);
    } else {
        let matchParticipants = await (0, $i7bmn.getMatchParticipants)(latestMatch);
        replacement = matchParticipants.find((x)=>x.name !== latestMatch.winner);
        data["dialog"] = [
            ...(0, $eVEoH.otherDialogs)["replacementNotAdded"]
        ];
        data["dialog"][0] = data["dialog"][0].format(replacement.name);
    }
    $0d3f450b1a87ca0b$export$2ba20f4e20d543be(annualTournament, injuredParticipant.$loki, replacementId);
    // Add replacement to next round
    let nextRoundMatches = await (0, $46buw.getNextRoundMatches)(annualTournament, latestMatch.tournamentRound);
    await (0, $46buw.addWinnerToNextRound)(nextRoundMatches, replacement, event, false, null, annualTournament);
    (0, $14eBR.db).saveDatabase();
    // Get injury data
    data["tournamentInjury"] = {
        injured: injuredParticipant.name,
        participantGoingThrough: replacement.name,
        injuredPronoun: injuredParticipant.pronoun,
        tournamentName: annualTournament.name,
        type: "elimination",
        replacement: true
    };
    return data;
}
async function $0d3f450b1a87ca0b$export$b93a9d14a7d6bf6e(annualTournament, organization, mainCompany) {
    // Select a talent who is not already part of tournament
    let replacement = null;
    // Get weights
    const rosters = organization ? [
        await (0, $8A6FL.getCompanyRosterByType)(organization, "main")
    ] : [
        await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie"),
        await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable")
    ];
    const allParticipantIds = $0d3f450b1a87ca0b$export$85aa8d87a91a649f(annualTournament);
    const talent = (await $0d3f450b1a87ca0b$var$getAvailableTalent(rosters, null)).filter((x)=>!allParticipantIds.includes(x.$loki));
    const participantsWeights = await $0d3f450b1a87ca0b$var$getParticipantsWeights(talent);
    // Select replacement
    if (participantsWeights.length) replacement = (0, $3E8Nt.weightedChoice)(participantsWeights);
    return replacement;
}
async function $0d3f450b1a87ca0b$export$a84c4ccac441ffac() {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    // Get annual tournament
    let annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
    if (!annualTournament) {
        data["error"] = "tournament-not-found";
        return data;
    }
    // Check if all companies who accepted have selected their participants
    for (let y of Object.values(annualTournament.companiesData))if (!y["participantIds"] && y["status"] === "accepted" && y["numberOfEntries"]) {
        data["dialog"] = (0, $eVEoH.otherDialogs)["startTournamentIncompleteEntries"];
        return data;
    }
    // Start annual tournament
    await $0d3f450b1a87ca0b$var$startAnnualTournament(annualTournament, game, mainCompany);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["dialog"] = (0, $eVEoH.otherDialogs)["startTournament"];
    data["success"] = true;
    return data;
}
function $0d3f450b1a87ca0b$export$2ba20f4e20d543be(annualTournament, injuredParticipantId, replacementId) {
    for (let [_, v] of Object.entries(annualTournament.companiesData))if (v["participantIds"] && v["participantIds"].includes(injuredParticipantId)) {
        // Add replacementId
        if (replacementId) v["participantIds"].push(replacementId);
        // Remove injuredParticipantId
        delete v["injuredParticipantId"];
        break;
    }
    return true;
}
function $0d3f450b1a87ca0b$var$addAnnualTournamentCompanyBribe(annualTournament, company) {
    let companyData = $0d3f450b1a87ca0b$var$getAnnualTournamentCompanyData(annualTournament, company);
    if (companyData) companyData["bribed"] = true;
    return true;
}

});
parcelRequire.register("eVEoH", function(module, exports) {

$parcel$export(module.exports, "presidentsData", () => $ade5b9a7fcd1528b$export$6205a1945c1892dc);
$parcel$export(module.exports, "getAnnualTournamentDialogs", () => $ade5b9a7fcd1528b$export$db575ce64077a71a);
$parcel$export(module.exports, "otherDialogs", () => $ade5b9a7fcd1528b$export$4f3c04f208905a91);

var $3E8Nt = parcelRequire("3E8Nt");

var $4EGpv = parcelRequire("4EGpv");
const $ade5b9a7fcd1528b$export$6205a1945c1892dc = [
    {
        "name": "Mr. Binsworth",
        "graphic": {
            "accessory": {
                "object": 36,
                "colors": [
                    "0x724c32"
                ]
            },
            "accessory2": {
                "object": -1,
                "colors": null
            },
            "accessory3": {
                "object": -1,
                "colors": null
            },
            "body": {
                "object": 0,
                "colors": [
                    "0xf5d0ae"
                ]
            },
            "bottoms": {
                "object": 0,
                "colors": [
                    "0x5d3e29"
                ]
            },
            "elbow": {
                "object": -1,
                "colors": null
            },
            "eyes": {
                "object": 0,
                "colors": [
                    "0x000000"
                ]
            },
            "facepaint": {
                "object": -1,
                "colors": null
            },
            "facialHair": {
                "object": -1,
                "colors": null
            },
            "hair": {
                "object": 17,
                "colors": [
                    "0xb7b7b7"
                ]
            },
            "knee": {
                "object": -1,
                "colors": null
            },
            "shoes": {
                "object": 3,
                "colors": [
                    "0x1E1E1E",
                    "0x1E1E1E"
                ]
            },
            "tattoo": {
                "object": -1,
                "colors": null
            },
            "torso": {
                "object": 47,
                "colors": [
                    "0xe1e1e1"
                ]
            },
            "alternate_attires": []
        }
    },
    {
        "name": "Miss Preston",
        "graphic": {
            "accessory": {
                "object": 37,
                "colors": [
                    "0x313f4c"
                ]
            },
            "accessory2": {
                "object": 26,
                "colors": [
                    "0xf4f4f4"
                ]
            },
            "accessory3": {
                "object": -1,
                "colors": null
            },
            "body": {
                "object": 3,
                "colors": [
                    "0xF7D1B9"
                ]
            },
            "bottoms": {
                "object": 0,
                "colors": [
                    "0x191919"
                ]
            },
            "elbow": {
                "object": -1,
                "colors": null
            },
            "eyes": {
                "object": 0,
                "colors": [
                    "0x000000"
                ]
            },
            "facepaint": {
                "object": -1,
                "colors": null
            },
            "facialHair": {
                "object": -1,
                "colors": null
            },
            "hair": {
                "object": 47,
                "colors": [
                    "0xcccccc",
                    "0xcccccc"
                ]
            },
            "knee": {
                "object": -1,
                "colors": null
            },
            "shoes": {
                "object": 3,
                "colors": [
                    "0x2f2316",
                    "0x2f2316"
                ]
            },
            "tattoo": {
                "object": -1,
                "colors": null
            },
            "torso": {
                "object": 47,
                "colors": [
                    "0x82a0c1"
                ]
            },
            "alternate_attires": []
        }
    },
    {
        "name": "Mr. Cunningham",
        "graphic": {
            "accessory": {
                "object": 85,
                "colors": [
                    "0x8a1437"
                ]
            },
            "accessory2": {
                "object": -1,
                "colors": null
            },
            "accessory3": {
                "object": -1,
                "colors": null
            },
            "body": {
                "object": 0,
                "colors": [
                    "0xddbda0"
                ]
            },
            "bottoms": {
                "object": 0,
                "colors": [
                    "0x141414"
                ]
            },
            "elbow": {
                "object": -1,
                "colors": null
            },
            "eyes": {
                "object": 0,
                "colors": [
                    "0x000000"
                ]
            },
            "facepaint": {
                "object": -1,
                "colors": null
            },
            "facialHair": {
                "object": -1,
                "colors": null
            },
            "hair": {
                "object": 0,
                "colors": [
                    "0x090909"
                ]
            },
            "knee": {
                "object": -1,
                "colors": null
            },
            "shoes": {
                "object": 3,
                "colors": [
                    "0x020202",
                    "0x020202"
                ]
            },
            "tattoo": {
                "object": -1,
                "colors": null
            },
            "torso": {
                "object": 47,
                "colors": [
                    "0x040404"
                ]
            },
            "alternate_attires": []
        }
    },
    {
        "name": "Mr. Cruz",
        "graphic": {
            "accessory": {
                "object": 37,
                "colors": [
                    "0x4d536e"
                ]
            },
            "accessory2": {
                "object": -1,
                "colors": null
            },
            "accessory3": {
                "object": -1,
                "colors": null
            },
            "body": {
                "object": 0,
                "colors": [
                    "0xe4b486"
                ]
            },
            "bottoms": {
                "object": 0,
                "colors": [
                    "0x2a2a2a"
                ]
            },
            "elbow": {
                "object": -1,
                "colors": null
            },
            "eyes": {
                "object": 0,
                "colors": [
                    "0x000000"
                ]
            },
            "facepaint": {
                "object": -1,
                "colors": null
            },
            "facialHair": {
                "object": 11,
                "colors": [
                    "0x565148"
                ]
            },
            "hair": {
                "object": 25,
                "colors": [
                    "0x383838"
                ]
            },
            "knee": {
                "object": -1,
                "colors": null
            },
            "shoes": {
                "object": 3,
                "colors": [
                    "0x473437",
                    "0x473437"
                ]
            },
            "tattoo": {
                "object": -1,
                "colors": null
            },
            "torso": {
                "object": 47,
                "colors": [
                    "0xa05b7f"
                ]
            },
            "alternate_attires": []
        }
    },
    {
        "name": "Mr. Oliver",
        "graphic": {
            "accessory": {
                "object": 36,
                "colors": [
                    "0x4e4e4e"
                ]
            },
            "accessory2": {
                "object": 39,
                "colors": [
                    "0xd29c5c"
                ]
            },
            "accessory3": {
                "object": -1,
                "colors": null
            },
            "body": {
                "object": 0,
                "colors": [
                    "0xffd9b6"
                ]
            },
            "bottoms": {
                "object": 0,
                "colors": [
                    "0x323232"
                ]
            },
            "elbow": {
                "object": -1,
                "colors": null
            },
            "eyes": {
                "object": 0,
                "colors": [
                    "0x000000"
                ]
            },
            "facepaint": {
                "object": -1,
                "colors": null
            },
            "facialHair": {
                "object": -1,
                "colors": null
            },
            "hair": {
                "object": 9,
                "colors": [
                    "0xd4b583"
                ]
            },
            "knee": {
                "object": -1,
                "colors": null
            },
            "shoes": {
                "object": 3,
                "colors": [
                    "0x1e1e1e",
                    "0x1e1e1e"
                ]
            },
            "tattoo": {
                "object": -1,
                "colors": null
            },
            "torso": {
                "object": 47,
                "colors": [
                    "0xc9dbe4"
                ]
            },
            "alternate_attires": []
        }
    }
];
async function $ade5b9a7fcd1528b$export$db575ce64077a71a(annualTournament, companyData, event, previousTournaments, presidentName, participatingCompaniesNames, entriesSample, participationPoints, injuredParticipant, bribeCost) {
    let numberOfEntries = "";
    let bribed = false;
    let entriesSampleNames = "";
    if (companyData) {
        numberOfEntries = companyData["numberOfEntries"];
        bribed = companyData["bribed"];
    }
    // Get participating companies text
    let participatingCompaniesText;
    if (participatingCompaniesNames) participatingCompaniesText = `${participatingCompaniesNames} have joined The Grand Invitational this time. ` + `Of course, top stars from the Indies will also be present.`;
    else participatingCompaniesText = "We are currently reaching out to top companies to join The Grand Invitational. Besides them, top stars from the Indies will be participating.";
    let normalInviteFirstText = "Hello again! It's that terrific time of the year where the wrestling world fights to see who has the best talent.";
    if (previousTournaments && previousTournaments.length === 1) normalInviteFirstText = "Hello there! I have some great news. Due to the success of the first TGI, the tournament will be held again next month, and we plan to run it at the same time every year!";
    let entriesVerb = "are";
    if (entriesSample) {
        entriesSampleNames = (0, $3E8Nt.commaSeparate)(entriesSample.map((x)=>x.name));
        if (entriesSample.length === 1) entriesVerb = "is";
    }
    // Get dialog objects
    const { firstInvite: firstInvite, normalInvite: normalInvite, inviteChoices: inviteChoices, bribeChoice: bribeChoice, beforeStartChoices: beforeStartChoices, selectingEntries: selectingEntries, declined: declined, entriesSelected: entriesSelected, starting: starting, runningNight1: runningNight1, runningNight2: runningNight2, replacing: replacing } = $ade5b9a7fcd1528b$var$getAnnualTournamentDialogObjects(annualTournament, presidentName, entriesSample, participationPoints, injuredParticipant, bribeCost, numberOfEntries, participatingCompaniesText, normalInviteFirstText, entriesSampleNames, entriesVerb);
    let dialogs = [];
    if (annualTournament.status === "inviting") {
        if (!previousTournaments.length) {
            firstInvite[firstInvite.length - 1].choices.push(...inviteChoices);
            dialogs = firstInvite;
        } else {
            normalInvite[normalInvite.length - 1].choices.push(...inviteChoices);
            dialogs = normalInvite;
        }
    } else if (annualTournament.status === "selecting") {
        // Get declined invitation dialog (for user company)
        if (companyData.status === "declined") dialogs = declined;
        else {
            // Check if bribed
            if (!bribed) beforeStartChoices.push(bribeChoice);
            // Check if entries selected
            if (companyData && companyData["participantIds"]) {
                entriesSelected[entriesSelected.length - 1].choices.push(...beforeStartChoices);
                dialogs = entriesSelected;
            } else {
                selectingEntries[selectingEntries.length - 1].choices.push(...beforeStartChoices);
                dialogs = selectingEntries;
            }
        }
    } else if (annualTournament.status === "running") {
        const tournamentEvent = await (0, $4EGpv.getTournamentEvent)(annualTournament);
        if (injuredParticipant) dialogs = replacing;
        else {
            // Runs before start of tournament
            if (tournamentEvent && tournamentEvent.name[tournamentEvent.name.length - 1] === "1") dialogs = starting;
            else if (event && event.name[event.name.length - 1] === "1") dialogs = runningNight1;
            else dialogs = runningNight2;
        }
    }
    return dialogs;
}
function $ade5b9a7fcd1528b$var$getAnnualTournamentDialogObjects(annualTournament, presidentName, entriesSample, participationPoints, injuredParticipant, bribeCost, numberOfEntries, participatingCompaniesText, normalInviteFirstText, entriesSampleNames, entriesVerb) {
    const numberOfEntriesWord = numberOfEntries !== 1 ? "entries" : "entry";
    const firstInvite = [
        {
            "choices": [
                {
                    "text": [
                        "Pleased to meet you."
                    ],
                    "reply": {
                        "text": [
                            "No need to be so formal, we're going to be in business!"
                        ],
                        "goToNextDialog": true
                    }
                },
                {
                    "text": [
                        "Can I help you?"
                    ],
                    "reply": {
                        "text": [
                            "Straight to the point, I like it."
                        ],
                        "goToNextDialog": true
                    }
                },
                {
                    "text": [
                        "Why're you here?"
                    ],
                    "reply": {
                        "text": [
                            "Business, of course."
                        ],
                        "goToNextDialog": true
                    }
                }
            ],
            "text": [
                `Hello there. I'm ${presidentName}, president of The Grand Invitational.`
            ]
        },
        {
            "choices": [
                {
                    "text": [
                        "No, what is it?"
                    ],
                    "reply": {
                        "text": [
                            "The Grand Invitational is a new tournament where talent from all over the world face off to see who is the best.",
                            "Superstars will represent their companies or the Indies, competing in dream matches and igniting company rivalries for the chance to write their names in the history books.",
                            "The Grand Invitational itself will be in charge of the booking and we plan to deliver the best possible show for the fans.",
                            "With substantial backing from our board of directors, we plan to run the tournament every year."
                        ],
                        "goToNextDialog": true
                    }
                },
                {
                    "text": [
                        "Of course."
                    ],
                    "reply": {
                        "text": [
                            "Then you know how important it is. The first edition of The Grand Invitational will be talked about for ages!"
                        ],
                        "goToNextDialog": true
                    }
                }
            ],
            "text": [
                "Have you heard about The Grand Invitational?"
            ]
        },
        {
            "choices": [
                {
                    "text": [
                        "I'm excited to be a part of it."
                    ],
                    "action": "acceptInvitation",
                    "highlight": "green",
                    "reply": {
                        "text": [
                            "Wonderful! The Grand Invitational will run at the start of next month. You can select your entries once you arrive and I will be available to answer any questions you have."
                        ]
                    }
                },
                {
                    "text": [
                        "I don't think it's a good idea for us."
                    ],
                    "action": "declineInvitation",
                    "highlight": "red",
                    "reply": {
                        "text": [
                            "We didn't expect everyone to be on board for our first event. I'm sure once you see how well it does, you'll decide to participate next time."
                        ]
                    }
                }
            ],
            "text": [
                "I wanted to personally invite you to the inaugural edition of our tournament, which will be held next month.",
                `Besides the chance to win and establish your company's supremacy, we're ready to offer you a suitable ` + `payment of ${$ade5b9a7fcd1528b$var$getPointsHtml(participationPoints)} for participating.`,
                "The Grand Invitational will be a one of a kind event that your company cannot miss, especially if you don't want a competitor to claim all the glory.",
                "So, can we expect to see you there?"
            ]
        }
    ];
    const normalInvite = [
        {
            "choices": [
                {
                    "text": [
                        "We'll be there."
                    ],
                    "action": "acceptInvitation",
                    "highlight": "green",
                    "reply": {
                        "text": [
                            "Lovely! I'll see you there."
                        ]
                    }
                },
                {
                    "text": [
                        "We can't make it."
                    ],
                    "action": "declineInvitation",
                    "highlight": "red",
                    "reply": {
                        "text": [
                            "Not the response I was looking for, but we'll still have a great show. I hope you will join us next time."
                        ]
                    }
                }
            ],
            "text": [
                normalInviteFirstText,
                `I wanted to invite you to the upcoming edition of the tournament, ${annualTournament.name}. We have ` + `prepared a financial package of ${$ade5b9a7fcd1528b$var$getPointsHtml(participationPoints)} for your participation in the event.`,
                "It's shaping up to be quite the affair, one that your company shouldn't miss.",
                "Will we see you there?"
            ]
        }
    ];
    const inviteChoices = [
        {
            "text": [
                "How does it work?"
            ],
            "reply": {
                "text": [
                    "The Grand Invitational is a 16 person elimination tournament held over two nights. Companies select their participants right before the event starts, so you have a month to decide who to send.",
                    "The number of entries for companies depends on their reputation, with the remaining entries coming from the Indies."
                ]
            }
        },
        {
            "text": [
                "Which companies are participating?"
            ],
            "reply": {
                "text": [
                    participatingCompaniesText
                ]
            }
        },
        {
            "text": [
                "How are winners chosen?"
            ],
            "reply": {
                "text": [
                    "Winners are decided by The Grand Invitational's booking committee. This means that your win/loss  won't be affected.",
                    "I can't tell you exactly how the process works. I believe it has something to do with computers .. ",
                    "Suffice to say that the more popular a talent is, the more likely they are to win. That means it's best to send your top superstars!"
                ]
            }
        },
        {
            "text": [
                "What does the winner get?"
            ],
            "reply": {
                "text": [
                    "The winner is awarded the prestigious TGI trophy, as well as significant boosts to their status, while all participants benefit from increased exposure.",
                    "The winning company is also bound to gain some new fans."
                ]
            }
        },
        {
            "text": [
                "Are there any rules for the tournament?"
            ],
            "reply": {
                "text": [
                    "The Grand Invitational is held under pure wrestling rules, which means there are no managers, gimmick matches or dusty finishes.",
                    "In an effort to stay impartial, no company can send any staff of their own.",
                    "Finally, in any match, there is always the chance of injury. It is my obligation to tell you that The Grand Invitational cannot be held responsible for any injuries sustained during it."
                ]
            }
        },
        {
            "text": [
                "How did this start?"
            ],
            "reply": {
                "text": [
                    "In a wrestling world filled with competitions like Year-End Awards and Top 50 Rankings, we thought: why not have talent directly compete against each other?",
                    "We decided to host the tournament ourselves on neutral grounds. You can imagine if the bookers had to figure out who would win .. we'd never get started!",
                    "Investors came running once we told them how much fans would pay to see the top companies fight it out, and here we are."
                ]
            }
        }
    ];
    const bribeChoice = {
        "text": [
            "How are the winners decided?"
        ],
        "reply": {
            "text": [
                "The Grand Invitational's booking committee picks the winners. You know, I do happen to sit on the committee ..",
                `I could do you a favor and put in a good word for your superstars. How about you raise your chances of ` + `winning, for a modest fee of, let's say, ${$ade5b9a7fcd1528b$var$getPointsHtml(bribeCost)}?`
            ],
            "choices": [
                {
                    "text": [
                        "Sounds like a good deal."
                    ],
                    "action": "bribePresident"
                },
                {
                    "text": [
                        "I can't do that. That's cheating."
                    ],
                    "reply": {
                        "text": [
                            "I was only going to talk to some people. Anyways, let's continue."
                        ]
                    }
                }
            ]
        }
    };
    const beforeStartChoices = [
        {
            "text": [
                "Which superstars are participating?"
            ],
            "reply": {
                "text": [
                    "Oh, that's secret. Participants cannot be revealed until everyone makes their picks and the bracket is created. This prevents anyone from gaining an unfair advantage.",
                    "But, just because we're friends .. ",
                    `I overheard that ${entriesSampleNames} ${entriesVerb} on the entry list.`
                ]
            }
        },
        {
            "text": [
                "How is the bracket made?"
            ],
            "reply": {
                "text": [
                    "Participants are seeded based on their popularity. Companies are kept apart so that, ideally, the top two companies should face each other in the final."
                ]
            }
        }
    ];
    const selectingEntries = [
        {
            "choices": [
                {
                    "text": [
                        "I'd like to select my entries."
                    ],
                    "highlight": "green",
                    "reply": {
                        "text": [
                            `Very well. Based on your company's reputation, we have given you ${numberOfEntries} ` + `${numberOfEntriesWord} in the tournament.`
                        ],
                        "choices": [
                            {
                                "text": [
                                    "Okay."
                                ],
                                "action": "selectEntries",
                                "highlight": "green"
                            },
                            {
                                "text": [
                                    "Just a moment."
                                ],
                                "reply": {
                                    "text": [
                                        "Of course."
                                    ]
                                }
                            }
                        ]
                    }
                }
            ],
            "text": [
                `Welcome to ${annualTournament.name}! We are so glad you could make it. The other companies are just 
                arriving as well.`,
                "Please make yourself comfortable and feel free to ask any questions you have about the tournament.",
                "Once you have decided on your entries, the tournament can start."
            ]
        }
    ];
    const declined = [
        {
            "choices": [],
            "text": [
                `Welcome to ${annualTournament.name}! Wait, you're not participating .. `,
                "Ah, you're here as a spectator. I see. I should go talk to the other companies."
            ]
        }
    ];
    const entriesSelected = [
        {
            "choices": [
                {
                    "text": [
                        "I'm ready."
                    ],
                    "highlight": "green",
                    "reply": {
                        "text": [
                            "Are you sure? The bracket will be created now."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "Yes, let's start."
                                ],
                                "action": "startTournament",
                                "highlight": "green"
                            },
                            {
                                "text": [
                                    "Actually, hold on."
                                ],
                                "reply": {
                                    "text": [
                                        "We can wait a bit longer."
                                    ]
                                }
                            }
                        ]
                    }
                }
            ],
            "text": [
                "Your entries have been finalized. Once you are ready, we can start the tournament."
            ]
        }
    ];
    const starting = [
        {
            "choices": [],
            "text": [
                "That's quite an interesting bracket! Let's go on to the event."
            ],
            "action": "startEvent"
        }
    ];
    const runningNight1 = [
        {
            "choices": [],
            "text": [
                "The tournament's going quite well, isn't it?"
            ],
            "action": "startEvent"
        }
    ];
    const runningNight2 = [
        {
            "choices": [],
            "text": [
                "We're getting close to crowning the winner! Let's continue to the event."
            ],
            "action": "startEvent"
        }
    ];
    let replacing;
    if (injuredParticipant) replacing = [
        {
            "choices": [
                {
                    "text": [
                        "Okay."
                    ],
                    "action": "selectReplacement"
                }
            ],
            "text": [
                `I'm afraid that ${injuredParticipant.name} has suffered an injury .. I don't think we can have ` + `${injuredParticipant.objectivePronoun} participate in the rest of the tournament. Fortunately, ` + `you can select a replacement.`
            ]
        }
    ];
    return {
        firstInvite: firstInvite,
        normalInvite: normalInvite,
        inviteChoices: inviteChoices,
        bribeChoice: bribeChoice,
        beforeStartChoices: beforeStartChoices,
        selectingEntries: selectingEntries,
        declined: declined,
        entriesSelected: entriesSelected,
        starting: starting,
        runningNight1: runningNight1,
        runningNight2: runningNight2,
        replacing: replacing
    };
}
let $ade5b9a7fcd1528b$export$4f3c04f208905a91 = {
    "bribeAccepted": [
        "I'll do my best to sway opinions in the committee. And listen, let's keep this between us."
    ],
    "bribeNotEnoughPoints": [
        "Sorry, but I don't think you have the funds for that."
    ],
    "entriesSelectedFull": [
        "Thank you and good luck. You should see that we have sent the agreed upon fee for your participation."
    ],
    "entriesSelectedNotFull": [
        "Not the amount we wanted, but we'll make do with some Indies. I hope you understand that we cannot give you the full fee we agreed upon."
    ],
    "startTournament": [
        "Good, then let's begin."
    ],
    "startTournamentIncompleteEntries": [
        "Unfortunately, some companies haven't finalized their entries yet. Please wait a moment."
    ],
    "replacementAdded": [
        "Your replacement has been confirmed. I hope to see {0} again next time."
    ],
    "replacementNotAdded": [
        "No problem. {0}, the loser from the previous round, will go through instead."
    ]
};
function $ade5b9a7fcd1528b$var$getPointsHtml(points) {
    return `<span class="blue margin-left-3 margin-right-3 display-inline-block">
                <img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> 
                ${points}
            </span>`;
}

});

parcelRequire.register("kZMqI", function(module, exports) {

$parcel$export(module.exports, "createNewsItem", () => $f48f12570ba8b80e$export$6be40d87fed59c6e);
$parcel$export(module.exports, "generateNewsItem", () => $f48f12570ba8b80e$export$73189331f75457c5);

var $3E8Nt = parcelRequire("3E8Nt");

var $1JSre = parcelRequire("1JSre");

var $1owiX = parcelRequire("1owiX");

var $14eBR = parcelRequire("14eBR");
async function $f48f12570ba8b80e$export$6be40d87fed59c6e(title, content, month, year, company = null, headline = false) {
    let priority = 1000000;
    let companyName;
    if (company) {
        companyName = (0, $1JSre.formatCompanyNameBackend)(company.name);
        priority = company.fans + 4;
    }
    const newsItem = (0, $1owiX.NewsItem)(title, content, year, month, priority, companyName);
    newsItem.headline = headline;
    (0, $14eBR.NewsItems).insert(newsItem);
    return newsItem;
}
const $f48f12570ba8b80e$var$priorities = {
    "injury": 2,
    "workable_injury": 2,
    "injury_return": 1,
    "workable_injury_return": 0,
    "superstar_left_company": 3,
    "superstar_released_by_company": 4,
    "high_event_rating": 3,
    "low_event_rating": 3,
    "high_match_rating": -1,
    "low_match_rating": -2,
    "won_championship": 2,
    "new_signing": 4,
    "rib": 1,
    "superstar_venture": 1,
    "superstar_interest": 1,
    "injury_return_powerup": 2,
    "retirement_return_powerup": 2,
    "retirement_return_permanent_powerup": 4,
    "trade_deal": 2,
    "retired_championship": 3,
    "new_championship": 3,
    "over_superstar": 2,
    "stale_superstar": 2,
    "company_buyout": 10,
    "new_company": 8,
    "buyout_available": 5,
    "buyout_not_available": 5,
    "stale_company": 5,
    "company_folds": 5,
    "drug_use_suspension": 2,
    "superstar_time_off": 3,
    "championship_stolen": 3,
    "championship_found": 3,
    "conservative_government_show": 5,
    "car_explosion": 5,
    "stunt_dive": 5,
    "dummy_wrestling": 5,
    "timely_rescue": 5,
    "helicopter_raid": 5,
    "ring_invasion": 5,
    "love_making": 5,
    "celebrity_beatdown": 5,
    "hosedown": 5,
    "anti_company_rant": 5,
    "superstar_leaving": 3,
    "superstar_staying": 3,
    "annual_tournament_won": 5
};
async function $f48f12570ba8b80e$export$73189331f75457c5({ company: company, month: month, year: year, newsType: newsType, superstar: superstar = null, championship: championship = null, matchParticipants: matchParticipants = null, event: event = null, ribVictim: ribVictim = null, ribCulprit: ribCulprit = null, competitor: competitor = null, headline: headline = false, location: location = null, staffMember: staffMember = null, staffMemberPronoun: staffMemberPronoun = null, staffMemberObjectivePronoun: staffMemberObjectivePronoun = null, celebrity: celebrity = null, superstarCompanyName: superstarCompanyName = null, annualTournamentName: annualTournamentName = null, newOwnerName: newOwnerName = null, newCompanyName: newCompanyName = null }) {
    let participants = null;
    let participant = null;
    let participantNames;
    if (newsType === "high_match_rating" || newsType === "low_match_rating") {
        participantNames = matchParticipants.map((x)=>x.name);
        if (participantNames.length <= 4) participants = (0, $3E8Nt.commaSeparate)(participantNames);
        else participants = (0, $3E8Nt.getRandomChoice)(participantNames) + " and " + (participantNames.length - 1) + " others";
        participant = participantNames[0];
    }
    // test utf rib culprit
    let superstarName = superstar ? superstar.name : null;
    let superstarPronoun = superstar ? superstar.pronoun : null;
    let superstarPossessivePronoun = superstar ? superstar.possessivePronoun : null;
    let superstarObjectivePronoun = superstar ? superstar.objectivePronoun : null;
    let injuryName = superstar ? superstar.injuryName || "" : "wrestling injury";
    let injuryLength = superstar ? superstar.injured : 0;
    let companyName = company ? company.name : null;
    let eventName = event ? event.name : null;
    let championshipName = championship ? championship.name : null;
    let competitorName = competitor ? competitor.name : null;
    let ribCulpritName = ribCulprit ? ribCulprit.name : null;
    let ribCulpritPronoun = ribCulprit ? ribCulprit.pronoun : null;
    let ribCulpritObjectivePronoun = ribCulprit ? ribCulprit.objectivePronoun : null;
    let ribVictimName = ribVictim ? ribVictim.name : null;
    let ribVictimPronoun = ribVictim ? ribVictim.pronoun : null;
    let ribVictimObjectivePronoun = ribVictim ? ribVictim.objectivePronoun : null;
    let ribVictimPossessivePronoun = ribVictim ? ribVictim.possessivePronoun : null;
    let staffMemberName = staffMember ? staffMember.name : null;
    let staffMemberRole = staffMember ? (0, $3E8Nt.toTitleCase)(staffMember.role.replace("_", " ")) : null;
    const titles = {
        "injury": [
            `${superstarName} injured`,
            `${superstarName} suffers injury`,
            `${superstarName} suffers a ${injuryName}`,
            `${(0, $3E8Nt.toTitleCase)(injuryName)}`,
            `${superstarName} out for ${injuryLength} months`,
            `${superstarName} on the shelf`,
            `${superstarName} out of action`,
            "Injury report"
        ],
        "workable_injury": [
            `Slight injury for ${superstarName}`,
            `${(0, $3E8Nt.toTitleCase)(injuryName)}`,
            "Small injury reported",
            `Niggle for ${superstarName}`,
            `${superstarName} suffering discomfort`,
            `${superstarName} suffers small injury`
        ],
        "injury_return": [
            `${superstarName} fully recovered from injury`,
            `${superstarName} ready to return`,
            `${superstarName} recovers`,
            `Recovery finished for ${superstarName}`,
            `${superstarName} expected to return soon`,
            `${superstarName} is ready to return`,
            `${superstarName} finishes injury rehab`,
            `${superstarName} is available to return`
        ],
        "workable_injury_return": [
            `${superstarName} fully recovered`,
            `${superstarName} heals fully`,
            `${superstarName} recovers`,
            `Recovery finished for ${superstarName}`,
            `${superstarName} overcomes niggle`,
            `${superstarName} at 100%`,
            `${superstarName} no longer injured`,
            `${superstarName} completely fit`
        ],
        "injury_return_powerup": [
            `${superstarName} undergoes quick recovery`,
            `${superstarName} returns in record time`,
            `${superstarName} recovered already`,
            `${superstarName} ready to return already`
        ],
        "retirement_return_powerup": [
            `${superstarName} returns to the ring`,
            `${superstarName} makes a return`,
            `${superstarName} returns for one match`,
            `${superstarName} back for one match`
        ],
        "retirement_return_permanent_powerup": [
            `${superstarName} makes miraculous return`,
            `${superstarName} makes unbelievable return`,
            `${superstarName} comes out of retirement!`
        ],
        "trade_deal": [
            `${companyName} makes a deal with ${competitorName}`,
            `${companyName} and ${competitorName} make a deal`,
            `Trade between ${companyName} and ${competitorName}`
        ],
        "superstar_left_company": [
            `${companyName} and ${superstarName} part ways`,
            `${superstarName} leaves ${companyName}`,
            `${superstarName} leaves`,
            `${companyName} release ${superstarName}`
        ],
        "superstar_released_by_company": [
            `${companyName} and ${superstarName} part ways`,
            `${superstarName} released`,
            `${companyName} release ${superstarName}`
        ],
        "high_event_rating": [
            `${eventName} goes beyond the hype`,
            `${eventName} delivers great show`,
            `${eventName} delivers`,
            `${eventName} was a great event`
        ],
        "low_event_rating": [
            `Fans didn't like ${eventName}`,
            `Many unhappy with ${eventName}`,
            `${eventName} was a bad show`,
            `${eventName} disappoints`
        ],
        "high_match_rating": [
            `${eventName} delivers classic match`,
            `MOTY contender at ${eventName}`,
            `${eventName} has a great match`,
            `Classic match at ${eventName}`,
            `Fantastic match at ${eventName}`,
            "MOTY contender",
            "An amazing match",
            `${participants} in a great match`
        ],
        "low_match_rating": [
            `Fans booed match at ${eventName}`,
            `${eventName} has a terrible match`,
            `Terrible match at ${eventName}`,
            `A really bad match`,
            `Worst match of the year contender`,
            `${participant} part of a bad match`,
            `Disappointing match at ${eventName}`,
            `Fans unhappy with match at ${eventName}`
        ],
        "won_championship": [
            `${superstarName} wins big title`,
            `${superstarName} wins the big one`,
            "New champion",
            `${superstarName} wins big`,
            "New champion crowned",
            `${superstarName} crowned champion`
        ],
        "new_signing": [
            `${companyName} sign ${superstarName}`,
            `${superstarName} signs with ${companyName}`,
            `${superstarName} goes to ${companyName}`,
            `${superstarName} signs for ${companyName}`
        ],
        "rib": [
            `${ribCulpritName} ribs ${ribVictimName}`,
            `${ribVictimName} gets ribbed`,
            `${ribCulpritName} pranks ${ribVictimName}`,
            "Backstage rib"
        ],
        "superstar_venture": [
            `${superstarName} tries something new`,
            `${superstarName} tries a new thing`,
            "New venture",
            `${superstarName}'s new venture`
        ],
        "superstar_interest": [
            `${superstarName} interest`,
            `${superstarName} eager to join ${companyName}`,
            `${superstarName} interested in ${companyName}`
        ],
        "retired_championship": [
            "Title retired",
            "Championship retired",
            `${companyName} retires Title`
        ],
        "new_championship": [
            "New Title",
            `${companyName} creates new Title`,
            "New Championship"
        ],
        "over_superstar": [
            `${superstarName} gets over`,
            `${superstarName} over with the fans`,
            `${superstarName} becomes hot`
        ],
        "stale_superstar": [
            `${superstarName} gets stale`,
            `${superstarName} stale with the fans`,
            `Fans low on ${superstarName}`
        ],
        "company_buyout": [
            `${companyName} buys out ${competitorName}`,
            `${companyName} buys ${competitorName}`,
            `${companyName} acquires ${competitorName}`
        ],
        "new_company": [
            "New Company emerges",
            "New Competitor",
            "New player"
        ],
        "buyout_available": [
            `${companyName} to be bought out?`,
            `${companyName} for sale`,
            "Potential buyout"
        ],
        "buyout_not_available": [
            "No sale",
            `${companyName} not for sale`,
            "Buyout off"
        ],
        "stale_company": [
            `Fans low on ${companyName}`,
            `${companyName} gets stale`
        ],
        "company_folds": [
            `${competitorName} folds`,
            `${competitorName} no more`
        ],
        "drug_use_suspension": [
            `${superstarName} suspended`,
            `${superstarName}'s drug abuse`
        ],
        "superstar_time_off": [
            `${superstarName} taking a break`,
            `${superstarName} takes time off`
        ],
        "championship_stolen": [
            `${championshipName} Championship stolen`
        ],
        "championship_found": [
            `${championshipName} Championship found`
        ],
        "conservative_government_show": [
            `${location} show`
        ],
        "car_explosion": [
            "Dangerous explosion"
        ],
        "stunt_dive": [
            "Jaw-dropping dive"
        ],
        "dummy_wrestling": [
            "Wrestling a dummy"
        ],
        "timely_rescue": [
            "Heart attack"
        ],
        "helicopter_raid": [
            "Helicopter invasion"
        ],
        "ring_invasion": [
            "Occupy the ring"
        ],
        "love_making": [
            "Live adult content"
        ],
        "celebrity_beatdown": [
            `${celebrity} assaulted`
        ],
        "hosedown": [
            "Silly mayhem"
        ],
        "anti_company_rant": [
            "Shoot promo"
        ],
        "superstar_leaving": [
            `${superstarName} leaving ${companyName}`,
            `${superstarName} leaving`,
            `${superstarName} wants out`,
            `${superstarName} looking to leave`
        ],
        "superstar_staying": [
            `${superstarName} staying at ${companyName}`,
            `${superstarName} staying`,
            `${superstarName} not leaving`,
            `${superstarName} not leaving ${companyName}`
        ],
        "annual_tournament_won": [
            annualTournamentName
        ],
        "new_user_company": [
            "New Wrestling Company"
        ]
    };
    const contents = {
        "injury": [
            `Doctors report ${superstarName} suffered a ${injuryName} at the latest event. They currently expect ${superstarObjectivePronoun} to be out of action for ${injuryLength} months.`,
            `${superstarName} suffered a ${injuryName} at the latest event and according to the doctors will be out for ${injuryLength} months.`,
            `Doctors say ${superstarName} suffered a ${injuryName} recently. Current diagnosis expects ${superstarObjectivePronoun} to be out of action for ${injuryLength} months.`,
            `It is being reported that ${superstarName} has a ${injuryName}. Doctors are saying ${superstarPronoun} will be out of action for around ${injuryLength} months.`
        ],
        "workable_injury": [
            `We have reports that ${superstarName} suffered a ${injuryName}. The good news is the injury is minor and ${superstarPronoun} could work through it if needed.`,
            `${superstarName} suffered a ${injuryName} at the latest show. Doctors say the nature of the injury is not too severe, and we might even see ${superstarObjectivePronoun} work through it.`,
            `Reports are coming in about ${superstarName} suffering a ${injuryName}. The current diagnosis expects it to clear up completely in about a month or two.`,
            `We have heard that ${superstarName} experienced a ${injuryName} recently. Doctors recommend ${superstarPronoun} should rest for some time, but we could see ${superstarObjectivePronoun} work through the injury too.`
        ],
        "injury_return": [
            `${superstarName} has fully recovered from a ${injuryName} and is expected to return anytime to the ring.`,
            `${superstarName} is ready to return after being out from a ${injuryName}. Doctors confirmed that ${superstarPossessivePronoun} recovery is complete.`,
            `${superstarName} is expected to return to the ring soon. After being out with a ${injuryName}, ${superstarPronoun} has fully recovered.`,
            `Reports say ${superstarName} has fully healed from a ${injuryName} and doctors have cleared ${superstarObjectivePronoun} to return to the ring.`
        ],
        "workable_injury_return": [
            `${superstarName} says ${superstarPronoun} has fully recovered from the ${injuryName} ${superstarPronoun} encountered some time ago and the injury is no longer bothering ${superstarObjectivePronoun}.`,
            `The ${injuryName} that ${superstarName} was suffering from has healed completely and ${superstarPronoun} should now be back to a 100%.`,
            `${superstarName} is feeling completely healthy after experiencing a ${injuryName}. Doctors say ${superstarPronoun} can now return to ${superstarPossessivePronoun} full capacity.`,
            `Reports say ${superstarName} has fully healed from a ${injuryName} and doctors have cleared ${superstarObjectivePronoun} to return to normal action.`
        ],
        "injury_return_powerup": [
            `${superstarName} has fully recovered from a ${injuryName}. The recovery took months less than expected, and other companies are trying to consult with the doctors who managed it.`,
            `${superstarName} is somehow ready to return after being out from a ${injuryName}. Reports are uncertain as to how it happened so fast, and the doctors are still being questioned.`,
            `Reports say ${superstarName} has fully healed from a ${injuryName}, in record time, and after some magical effort and rehab, the doctors have cleared ${superstarObjectivePronoun} to return to the ring.`
        ],
        "retirement_return_powerup": [
            `${superstarName} has returned to the ring for one match only, coming out of retirement. Fans are excited to see how well the retired superstar can go in the ring.`,
            `${superstarName} has decided to come out of retirement for a one match deal. Everyone is looking forward to the match and there is much speculation to who ${superstarName} will face.`
        ],
        "retirement_return_permanent_powerup": [
            `${superstarName} has returned to full-time status! This news came as a shock to all, as ${superstarName} was considered permanently retired. People are anxious to see how the run goes and many are asking ${superstarName} the secrets to the return.`,
            `${superstarName} has decided to come out of retirement on a full-time basis. Everyone is bewildered as to how ${superstarName} can manage this, and many are jumping on the diet and workout regiment ${superstarPronoun} is following.`
        ],
        "trade_deal": [
            `${companyName} and ${competitorName} came up with a deal backstage in which they exchanged talent. Reports say that further trades between the two companies are expected if the deal goes well.`,
            `A trade deal was struck between ${companyName} and ${competitorName} recently as they exchanged superstars. Opinion in the industry is mixed as to whether this will be a mutually beneficial trade, but more deals are expected to happen.`
        ],
        "new_signing": [
            `${companyName} announced that ${superstarName} signed a long-term contract with the company. Fans are excited to see what ${companyName} has in store for ${superstarObjectivePronoun}.`,
            `After quick talks, ${superstarName} signed a big contract with ${companyName} this month and joined the company.`,
            `${companyName} has signed ${superstarName} to their roster. Reports say the company is high on the new signing.`,
            `${superstarName} announced that ${superstarPronoun} signed a long-term deal with ${companyName}. Fans are eager to see how ${companyName} uses ${superstarObjectivePronoun}.`
        ],
        "high_event_rating": [
            `${eventName} delivered a great show with solid matches throughout the card. Fans are already considering it for the year end awards.`,
            `${eventName} was an amazing show with great matches from top to bottom. Fans rated it as one of the best shows of the year so far.`,
            `${eventName} was an event with solid matches throughout the card. Fans are thinking it's a worthy contender for the event of the year award.`
        ],
        "low_event_rating": [
            `${eventName} was considered one of the worst shows of the year. Fans almost revolted at the end and many demanded a refund from the company.`,
            `Fans didn't enjoy ${eventName} at all. Most of them called it a terrible show with bad matches and not worth the money or time they spent watching it.`
        ],
        "high_match_rating": [
            `${participants} put on an all-time classic in the ring at ${eventName}. Fans are considering it for the match of the year award.`,
            `${participants} tore the house down at ${eventName}, producing a memorable match that looks to be a contender for the year end awards.`,
            `${participants} put on an amazing match at ${eventName}. It's being considered for the match of the year award.`,
            `${participants} had a terrific match at ${eventName} that is looking like a MOTY contender. People backstage were really happy with it too.`
        ],
        "low_match_rating": [
            `At ${eventName}, ${participants} stank up the place with a really bad match. The crowd booed them quite soon and couldn't care less for the match. It's looking like a contender for worst match of the year.`,
            `${participants} had a terrible match at ${eventName} and no one was happy with it backstage. Fan reaction was so bad that it's a likely contender for worst match of the year.`,
            `${participants} had a really bad match at ${eventName} that fans booed and no one was happy with it backstage either. It's likely a contender for the worst match of the year.`,
            `${participants} disappointed in their match at ${eventName} in what is being considered one of the worst matches of the year. The crowd never got into it and kept pretty silent.`
        ],
        "superstar_left_company": [
            `${companyName} announced that ${superstarName} has left the company. Sources say it was because of dissatisfaction with the company. Other companies are showing interest in signing ${superstarName}.`,
            `${superstarName}'s contract with ${companyName} expired this month. Sources say ${superstarName} wasn't happy in the company and is looking for new opportunities.`,
            `${superstarName} has left ${companyName} due to ${superstarPossessivePronoun} contract expiring. Reports say the departure was due to underlying issues with the company. Other companies are now looking to sign ${superstarName}.`
        ],
        "superstar_released_by_company": [
            `${companyName} announced that ${superstarName} was released by the company. Sources say it was because the company didn't have direction for ${superstarObjectivePronoun}. Other companies are showing interest in signing ${superstarName}.`,
            `${superstarName} was released from ${superstarPossessivePronoun} contract with ${companyName}. Sources say the company wasn't happy with ${superstarName}, who is now looking for new opportunities.`,
            `${companyName} released ${superstarName} from ${superstarPossessivePronoun} contract. Reports say the release was due to a lack of direction. Other companies are now looking to sign ${superstarName}.`
        ],
        "won_championship": [
            `${superstarName} won the ${championshipName} title at ${eventName} in a big match. Fans are wondering what the new title reign has in store for ${superstarName}.`,
            `The ${championshipName} championship changed hands at ${eventName} as ${superstarName} was crowned the new champion. Fans are eager to see what the company does with the new championship reign.`,
            `${superstarName} became the new ${championshipName} champion at ${eventName}. Reports say ${companyName} has big plans for this title reign.`,
            `${superstarName} won the ${championshipName} title at ${eventName} in a big match. ${companyName} seems to be high on ${superstarName} and this title reign.`
        ],
        "rib": [
            `${ribVictimName} lost ${ribVictimPossessivePronoun} passport on the way back from the latest show and couldn't find it backstage. This made ${ribVictimObjectivePronoun} miss ${ribVictimPossessivePronoun} flight. ` + `${ribVictimName} finally found it in the washroom after getting an anonymous text. Most people think ${ribCulpritName} is behind this as ${ribCulpritPronoun}'s known for playing jokes on other superstars.`,
            `${ribVictimName} was seen complaining to any management ${ribVictimPronoun} could find about cookies inside ${ribVictimPossessivePronoun} bed. The superstars were staying at a hotel together and somehow ` + `${ribVictimName}'s bed kept getting stuffed with cookies every night and ${ribVictimPronoun} grew increasingly annoyed with having to clean it. Apparently ${ribVictimPronoun} didn't get much sleep and it ` + `affected ${ribVictimPossessivePronoun} performance. ${ribCulpritName} is probably behind the rib because some people saw ${ribCulpritObjectivePronoun} buying a large box of cookies at the supermarket.`,
            `It started when ${ribVictimName} started getting texts from a childhood friend. Little did ${ribVictimPronoun} know that ${ribCulpritName} knew ${ribVictimName} had mentioned this friend as a childhood ` + `crush and got a new mobile number from ${ribVictimName}'s hometown to mess with ${ribVictimObjectivePronoun}. The texts kept growing in intensity until they got to the level of declaring lust and ` + `love. It all ended when they decided to meet but of course the date didn't show and it actually got pretty sad.`,
            `${ribVictimName} had told ${ribCulpritName} about a crazy stalker messaging and calling ${ribVictimObjectivePronoun}. So one day ${ribCulpritName} got the number of the stalker through ${ribVictimName}'s ` + `phone and sent a text declaring ${ribVictimPossessivePronoun} feelings and asking to meet. They were all sitting at a bar after a show when the stalker came. ${ribVictimName} started panicking ` + `as the stalker sat next to them all with a huge smile. It was funny until the stalker threatened ${ribVictimName} when ${ribVictimPronoun} said ${ribVictimPronoun} didn't want to leave together, but ` + `it was too late and ${ribCulpritName} couldn't do anything about it. They all somehow managed to escape through the back door and leave the stalker behind.`,
            `${ribVictimName} was seen with a bizarre new look where both ${ribVictimPossessivePronoun} eyebrows went missing. Reports say ${ribCulpritName} took ${ribVictimObjectivePronoun} out for drinks and, late ` + `into the night, managed to shave ${ribVictimPossessivePronoun} eyebrows off. It looked so bad that the next day ${ribCulpritName} helped ${ribVictimObjectivePronoun} draw new eyebrows with a permanent marker.`,
            `${ribCulpritName} doused ${ribVictimObjectivePronoun}self with a ton of oil before a house show match with ${ribVictimName}. There was so much oil that ${ribVictimName} couldn't even ` + `get ${ribCulpritName} up for a suplex as ${ribCulpritName} kept slipping around the ring and hitting ${ribVictimObjectivePronoun} with baseball slides. Everyone was happy with it ` + `except for ${ribVictimName} who was seen disgusted backstage.`
        ],
        "superstar_venture": [
            `${superstarName} recently had a cameo on a new TV show. The role seems to be a one time thing as the producers weren't all that impressed with the acting.`,
            `Reports from students at a top university say ${superstarName} appeared for a one time lecture. Many were fans and kept calling out to ${superstarPossessivePronoun} wrestling persona and chanting for ${superstarObjectivePronoun}, so much that ${superstarName} couldn't focus on the topic at hand and gave a confusing lecture.`,
            `${superstarName} recently starred in a wrestling documentary. First viewers admired the role and the nature of the documentary, and other wrestlers have complimented ${superstarName} for portraying the reality of professional wrestling well.`,
            `${superstarName} came on a late night show last night, participating in a heated yet hilarious segment. The whole thing was worked, despite other reports, and showcased ${superstarName}'s charisma.`,
            `${superstarName} was seen performing at a comedy club a few nights ago, doing a comedy routine, and reports from people present say ${superstarName} put on a hilarious performance. Perhaps a career in standup comedy would suit ${superstarName}.`
        ],
        "superstar_interest": [
            `Sources are reporting that ${superstarName} is interested in signing for ${companyName}. With such high interest, a deal is likely to be made soon.`,
            `Reports say that ${superstarName} is eager to join ${companyName} and wants to make it as easy as possible. An agreement could be made soon.`,
            `${superstarName} has shown great interest in signing for ${companyName} and thinks the job will be a great fit. A deal might be made quite soon.`
        ],
        "retired_championship": [
            `${companyName} decided to retire the ${championshipName} Championship. Many superstars came out to pay respect to the title and the company put out a video of its best champions.`,
            `The ${championshipName} Championship has been retired by ${companyName}. The reason is currently unknown but many speculate the company is working on creating a new title.`
        ],
        "new_championship": [
            `${companyName} has created a new title called the ${championshipName} Championship. The Title already has a lot of prestige and many superstars are gunning to hold it.`,
            `The ${championshipName} Championship was recently revealed by ${companyName} and many people loved the belt's exquisite design. Reports say the company want to use the new title to elevate talent in an already brimming roster.`
        ],
        "over_superstar": [
            `After the recent event, it seems that ${superstarName} is quite over with the fans. Excitement is high for everything associated with ${superstarObjectivePronoun}.`,
            `${superstarName} has gotten over with the fans recently, becoming one of the hottest wrestlers in the company. Everything linked to ${superstarName} is getting a good boost as fans clamor to see more of ${superstarObjectivePronoun}.`
        ],
        "stale_superstar": [
            `After the recent event, it seems that ${superstarName} has become stale with the fans, as there appears to be almost no interest from them in anything related to ${superstarObjectivePronoun}.`,
            `The fans have turned on ${superstarName} recently, barely showing any interest in ${superstarObjectivePronoun}. Everything linked to ${superstarName} seems to be getting boring in their eyes too.`
        ],
        "company_buyout": [
            `After months of negotiations, ${companyName} has bought out ${competitorName}. Although most fans saw it as inevitable, many were still overwhelmed. Some of the ` + `fanbase has moved on to ${companyName}, while the remaining seems to have left. Some talent moved to ${companyName} along with a few of ${competitorName}'s Championships, ` + `but many superstars are left without work. A big void has been left by the dissolving of ${competitorName}, but who will fill it?`
        ],
        "new_company": [
            `A new company has emerged in the wrestling industry: ${companyName}. Comprised of a great amount of Independent Talent, it looks to put on a strong challenge to the existing players, and has already increased the wrestling market.`,
            `${companyName} opens its doors this month. Many Independent Talent have joined together to form this new competitor. Though the jury is out on how successful they can be, one thing is for sure: the wrestling market has grown bigger.`,
            `A new competitor has emerged in the wrestling landscape. ${companyName} formed this month, looking to give a challenge to the established companies. We'll soon find out what they can offer. What we do know is that the wrestling market has increased slightly.`
        ],
        "buyout_available": [
            `Reports are coming in that ${companyName} is up for sale. Talent at ${companyName} are worried about what this means about their future.`,
            `According to recent reports, ${companyName} is available to be bought. If the buyout goes through, the effects on the wrestling industry will be quite significant.`,
            `Insiders are hearing talks about ${companyName} being bought out to save them from their huge slump. Less competition cannot be good for the talent but will benefit the big players.`
        ],
        "buyout_not_available": [
            `The potential buyout of ${companyName} seems to be put on hold for the moment. No word on why but it might just be a temporary solution to buy them time.`,
            `Negotiations to buy out ${companyName} appear to have fallen through. It seems that the worst has passed for ${companyName}.`,
            `Reports are coming in that ${companyName} is no longer available for a buyout. The reason is unknown at the moment but things might work out for them.`
        ],
        "stale_company": [
            `After their recent show, it seems that ${companyName} has become stale with the fans. If their Reputation continues to decline, they may have to resort to a buyout to save them.`,
            `The fans have recently turned on ${companyName}, barely showing any interest in their work. If the bad run continues, a buyout may be on the table.`
        ],
        "company_folds": [
            `After a long run of bad shows, ${competitorName} has stopped its operations. This could be seen coming but many are still dismayed by the news. Their superstars have ended up on the indies and other companies are looking to scoop up talent after the folding. Most of the fans have moved on to the competition while some have left altogether.`
        ],
        "drug_use_suspension": [
            `Backstage reports say that, due to drug abuse, ${superstarName} has been suspended for two months. The drugs came to the company's attention recently and ${superstarName} was immediately suspended.`
        ],
        "superstar_time_off": [
            `Reports say that ${superstarName} is taking some time off for personal reasons. We aren't sure when ${superstarPronoun} plans to come back but it could be a few months.`
        ],
        "championship_stolen": [
            `${companyName} recently reported the ${championshipName} Championship as missing. For a company to lose a title and be unable to locate it is quite embarrassing. The investigation is currently ongoing.`
        ],
        "championship_found": [
            `The police finally located the ${championshipName} Championship after a long search. Thankfully, the title is in good shape and was returned to ${companyName}. Hopefully they will take better care of it in the future.`
        ],
        "conservative_government_show": [
            `${companyName} has announced that they will soon hold a show in ${location}. Apparently, a big money deal was struck with the ${location} government, who have not allowed any women to appear on the show. It's yet to be seen whether the high revenue from the event will be worth the inevitable backlash that will arise from the fans.`
        ],
        "car_explosion": [
            `An unbelievable segment took place this month. ${superstarName} got into ${superstarPossessivePronoun} car backstage but before it could drive off, the car exploded. Viewers at home were shocked and many called in to check if ${superstarName} was dead. Thankfully, the rumors were cleared up and the explosion was just an angle to write ${superstarName} off.`
        ],
        "stunt_dive": [
            `${superstarName} performed an amazing dive off the titantron, falling almost 30 feet onto a group of superstars. The stunt came at a price as ${superstarName} suffered a minor injury and won't be able to compete for a while. It seems to be worth it though as fans are still talking about the jump.`
        ],
        "dummy_wrestling": [
            `An unexpected match took place this month, with ${superstarName} taking on a dummy. Yes, you read that right. ${superstarName} actually wrestled a doll and it was spectacular. A few superstars in the back weren't happy to lose their spot to an inanimate object, but the fans ate it up.`
        ],
        "timely_rescue": [
            `${staffMemberName}, a ${staffMemberRole} backstage at ${companyName}, suffered a heart attack on-air. ${superstarName} was performing a segment when ${staffMemberName} ` + `collapsed behind ${superstarObjectivePronoun}, leading ${superstarName} to perform CPR on ${staffMemberObjectivePronoun} until ${staffMemberPronoun} could be taken to a ` + `hospital. ${companyName} issued a statement hoping ${staffMemberName} would make a full recovery and return to the company soon.`
        ],
        "helicopter_raid": [
            `In a stunning segment this month, ${superstarName} took flight in a helicopter and landed on top of ${competitorName}'s building. Apparently the stunt wasn't supposed to go as far as an actual invasion, despite how incredible it was, and ${companyName} has suspended ${superstarName} for a month. ${competitorName} declined to comment on the story.`
        ],
        "ring_invasion": [
            `A unique segment took place this month. ${superstarName}, tired of not getting ${superstarPossessivePronoun} demands met, occupied the ring with a hundred supporting fans. The segment was very well received and reports say that big things are planned for ${superstarName}.`
        ],
        "celebrity_beatdown": [
            `During an appearance for ${companyName} this month, ${celebrity} was on the receiving end of an unprovoked attack by ${superstarName}. The segment drew great interest and ${celebrity} seems to have enjoyed being a part of it but some fans were appalled by the attack and complained to the sponsors.`
        ],
        "hosedown": [
            `${superstarName} was the star of a special segment this month when ${superstarPronoun} came down to the ring in a lemonade truck and sprayed everyone with lemonade. The silliness was off the charts and some superstars in the back were unhappy with it, but overall, the segment was a hit.`
        ],
        "anti_company_rant": [
            `${superstarName} went off on ${companyName} in a live promo, breaking the fourth wall and criticizing the company for issues many fans agree with. It is believed the promo and ${superstarName}'s suspension are a work, but many people bought into it because of how much truth was in ${superstarPossessivePronoun} statements.`
        ],
        "love_making": [
            `An extremely provocative segment took place this month. ${superstarName} and ${superstarPossessivePronoun} partner took their clothes off, ` + `got into a bed in the ring and proceeded to have sex on-air. As you can imagine, the sponsors weren't ` + `too happy with this segment. The risk seems to have paid off though as tons of new fans tuned in.`
        ],
        "superstar_leaving": [
            `Sources inside ${companyName} say that ${superstarName} is unhappy in the company and is going to leave. If things don't change, ${superstarName} will be a free agent soon.`,
            `${superstarName} has looked unhappy at ${companyName} lately. Sources say it's because of booking frustrations. Rumors are circulating that ${superstarName} is already in talks with other companies.`,
            `Reports are coming in that ${superstarName} isn't happy at ${companyName} and is looking to leaving. People backstage are worried that ${superstarName} is looking to jump ship.`
        ],
        "superstar_staying": [
            `Reports have come in that ${companyName} and ${superstarName} have made amends. The recent rumors of ${superstarName} leaving have been shut down as ${superstarPronoun} wants to stay with the company.`,
            `${superstarName} and ${companyName} apparently sat down and negotiated a deal for ${superstarObjectivePronoun} to stay with the company. This comes off reports that ${superstarName} was looking to leave.`,
            `${superstarName} said that ${superstarPronoun} is going to stay with ${companyName} for the time being. Apparently things changed backstage and ${superstarName} is happy in the company.`
        ],
        "annual_tournament_won": [
            `${annualTournamentName} was held this month, with ${superstarName} (${superstarCompanyName}) beating talent from around the wrestling world over two nights to lift the trophy. ${superstarName} will hold the bragging rights of being the greatest until the next tournament.`
        ],
        "new_user_company": [
            `A new wrestling company named ${newCompanyName} was unvieled this month, backed by investor ${newOwnerName}. It hopes to compete with ${companyName}, having hired their booker, and some talent from ${companyName} are also interested in joining the new company. Time will tell how successful it can be.`
        ]
    };
    // Set priority of news item based on company level and type of news
    let priority = $f48f12570ba8b80e$var$priorities[newsType] + company.fans;
    // Set title and content
    let title = (0, $3E8Nt.getRandomChoice)(titles[newsType]);
    let content = (0, $3E8Nt.getRandomChoice)(contents[newsType]);
    // Create and return news item
    let newsItem = (0, $1owiX.NewsItem)(title, content, year, month, priority, (0, $1JSre.formatCompanyNameBackend)(company.name));
    (0, $14eBR.NewsItems).insert(newsItem);
    if (headline) newsItem.headline = true;
    return newsItem;
}

});
parcelRequire.register("1owiX", function(module, exports) {

$parcel$export(module.exports, "NewsItem", () => $10411760bf48d257$export$a244d056ff17b67b);

var $14eBR = parcelRequire("14eBR");
function $10411760bf48d257$export$a244d056ff17b67b(title, content, year, monthCount, priority, companyName = null) {
    // Boolean
    const headline = false;
    // Foreign keys
    const companyId = null;
    return {
        title: title,
        content: content,
        year: year,
        monthCount: monthCount,
        priority: priority,
        companyName: companyName,
        headline: headline,
        companyId: companyId
    };
}
function $10411760bf48d257$export$450fedacd2f9595(newsItem) {
    return (0, $14eBR.Companies).find({
        "$loki": newsItem.companyId
    })[0];
}

});


parcelRequire.register("3SyPM", function(module, exports) {

$parcel$export(module.exports, "processPlayMatch", () => $2d316f999b9a52df$export$b6fa34805ccb87e8);
$parcel$export(module.exports, "updateMatchOrSegmentGraphics", () => $2d316f999b9a52df$export$401884867da6aea9);
$parcel$export(module.exports, "unlockSpecialSegment", () => $2d316f999b9a52df$export$330602a311ac05c5);
$parcel$export(module.exports, "checkFeudHot", () => $2d316f999b9a52df$export$8bcffe5f50ce90df);
$parcel$export(module.exports, "checkFeudItemsToUnlock", () => $2d316f999b9a52df$export$d561132ac3e2681b);
$parcel$export(module.exports, "checkCharacterToUnlock", () => $2d316f999b9a52df$export$617c0c9711ea615a);
$parcel$export(module.exports, "updateSuperstarWorkrate", () => $2d316f999b9a52df$export$b89e809709b1a9cc);
$parcel$export(module.exports, "getGimmickEffectivenessChange", () => $2d316f999b9a52df$export$ff98fcb70ca1ca21);
$parcel$export(module.exports, "progressGimmick", () => $2d316f999b9a52df$export$1fd22a731a3a3817);
$parcel$export(module.exports, "getParticipantManagersData", () => $2d316f999b9a52df$export$b2ce0bfe3182db14);

var $98xmD = parcelRequire("98xmD");

var $9esFv = parcelRequire("9esFv");

var $i7bmn = parcelRequire("i7bmn");

var $dl5u4 = parcelRequire("dl5u4");

var $8A6FL = parcelRequire("8A6FL");

var $6hwt2 = parcelRequire("6hwt2");

var $5ZsVo = parcelRequire("5ZsVo");

var $14eBR = parcelRequire("14eBR");

var $5kTkA = parcelRequire("5kTkA");

var $iQtzn = parcelRequire("iQtzn");

var $lhVvD = parcelRequire("lhVvD");

var $4K85d = parcelRequire("4K85d");

var $3E8Nt = parcelRequire("3E8Nt");

var $cXLSF = parcelRequire("cXLSF");

var $jDtEn = parcelRequire("jDtEn");

var $im36F = parcelRequire("im36F");

var $hBIDz = parcelRequire("hBIDz");

var $972Ip = parcelRequire("972Ip");

var $aP7lq = parcelRequire("aP7lq");

var $hekDR = parcelRequire("hekDR");

var $6RCLU = parcelRequire("6RCLU");

var $2GWzg = parcelRequire("2GWzg");

var $ivuOU = parcelRequire("ivuOU");

var $kZwpB = parcelRequire("kZwpB");

var $9MKdC = parcelRequire("9MKdC");

var $ycsyu = parcelRequire("ycsyu");

var $1olyO = parcelRequire("1olyO");

var $4EGpv = parcelRequire("4EGpv");

var $iRMwH = parcelRequire("iRMwH");

var $46buw = parcelRequire("46buw");

var $1JSre = parcelRequire("1JSre");

var $5qFpQ = parcelRequire("5qFpQ");

var $2JFAd = parcelRequire("2JFAd");

var $fuJHb = parcelRequire("fuJHb");

var $jpMCP = parcelRequire("jpMCP");

var $kZMqI = parcelRequire("kZMqI");

var $6PzHO = parcelRequire("6PzHO");

var $1AAHK = parcelRequire("1AAHK");

var $18vSN = parcelRequire("18vSN");

var $kpu3X = parcelRequire("kpu3X");

var $bZol7 = parcelRequire("bZol7");

var $jC7EP = parcelRequire("jC7EP");
async function $2d316f999b9a52df$export$b6fa34805ccb87e8(match, winnerName, event, company, mainCompany, mainRoster, indieRoster, game, cashinData, matchFinishData, graphics, rosterSuperstars = null, companyParentEvents = null, companyChampionships = null, staffMembers = null, segmentsAndMatches = null, effect = null, simulator = false) {
    try {
        let data = {};
        const matchFeuds = await (0, $i7bmn.getMatchFeuds)(match);
        const tournament = await (0, $i7bmn.getMatchTournament)(match);
        const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
        if (!companyParentEvents) companyParentEvents = await (0, $8A6FL.getCompanyParentEvents)(company);
        if (!staffMembers) staffMembers = await (0, $9esFv.getCompanyStaff)(company);
        if (!companyChampionships) companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
        if (!rosterSuperstars) rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        if (!segmentsAndMatches) segmentsAndMatches = await (0, $5ZsVo.getEventMatchesAndSegments)(event);
        const month = game.monthCount;
        const year = game.year;
        const realYear = company.realYear;
        let newMatch;
        let type = match.type;
        // Get match finish
        let matchFinish = (0, $6hwt2.matchFinishesData).find((x)=>x.name === matchFinishData["name"]);
        // Check if weekly show
        const weeklyShow = event.weeklyShow || event.name === "Weekly Show";
        // Check if main event
        segmentsAndMatches.sort((a, b)=>a.order - b.order);
        const mainEvent = match.$loki === segmentsAndMatches[0].$loki && match.objectName === segmentsAndMatches[0].objectName;
        // Check for tournament
        let annualTournament = tournament ? tournament.annualTournament : false;
        let checkTournament = true;
        if (tournament) checkTournament = match.tournamentRound && match.tournamentRound === tournament.rounds;
        if (annualTournament) staffMembers = [];
        // Declare arrays
        let overnessChanges = [], staffSkillIncreases = [], gimmickEffectivenessLevelChanges = [], hairRemoved = [], hairAdded = [], maskRemoved = [], unavailable = [], vacated = [], streaks = [], feudPotentials = [], feudHypeIncreased = [], feudsStarted = [], turnedHeel = [], turnedFace = [], debutedGimmicks = [], hotFeuds = [], championshipPrestiges = [], unlockedChampionshipSegmentItems = [], bloodySuperstarsData = [], factionConsequences = [], factionReputationsData = [], managersRemoved = [], managersAdded = [], fotcChanges = [];
        // Declare variables
        let updateGraphics = false;
        let generatedText = null;
        let holyShitData = null;
        let holyShitMomentTo = null;
        let newTournamentRound = false;
        let interferingMember;
        let unlockedGimmickMatches = [];
        let gimmickMatchLevelData = null;
        // Add finish name and finish text to match
        if (matchFinish) {
            match.finishName = matchFinish["name"];
            // Get interfering member for match finish, if present
            if (matchFinishData && matchFinishData["interferingMemberUid"]) {
                if (matchFinishData["interferingMemberType"] === "superstar") interferingMember = await (0, $14eBR.Superstars).get(matchFinishData["interferingMemberUid"]);
                else if (matchFinishData["interferingMemberType"] === "team") interferingMember = await (0, $14eBR.TagTeams).get(matchFinishData["interferingMemberUid"]);
                else if (matchFinishData["interferingMemberType"] === "faction") interferingMember = await (0, $14eBR.Factions).get(matchFinishData["interferingMemberUid"]);
                if (interferingMember) match.finishText = interferingMember.name;
            }
        }
        // Get attributes of match finish (don't affect record for annual tournament)
        let affectRecord = (!matchFinish || matchFinish["affectRecord"]) && !annualTournament;
        let changeChampionship = !matchFinish || matchFinish["changeChampionship"];
        // Get participants
        let matchParticipants = await (0, $i7bmn.getMatchParticipants)(match);
        let matchGimmick = await (0, $i7bmn.getMatchGimmickMatch)(match);
        if (matchGimmick && matchGimmick.consequence === "random_opponent" && matchParticipants.length < 2) {
            // Add random opponent to match
            let allTalent;
            if (type === "singles") allTalent = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
            else if (type === "tag") allTalent = (await (0, $dl5u4.getRosterTagTeams)(mainRoster)).filter((x)=>x.trio === matchParticipants[0].trio && !x.temporary);
            let randomOpponentData = await (0, $6RCLU.selectRandomOpponent)(matchParticipants[0], allTalent, event);
            let opponent = randomOpponentData[0];
            await (0, $i7bmn.addMatchParticipants)(match, [
                opponent
            ]);
            matchParticipants.push(opponent);
        }
        // Get superstars
        let matchSuperstars = [];
        for (const x of matchParticipants){
            let s = await (0, $5kTkA.getRosterMemberSuperstars)(x);
            x.tempSuperstars = s;
            matchSuperstars.push(...s);
        }
        // Set stating morale for matchSuperstars
        for (const x of matchSuperstars){
            x.startingMorale = x.morale;
            x.startingOverness = x.overness;
        }
        // Get winner
        let winnerParticipant = matchParticipants.find((x)=>x.name === winnerName);
        let winnerSuperstars = winnerParticipant.tempSuperstars;
        // Check streaks
        let streakEnded = null;
        if (!weeklyShow && event.prestige === "A" && affectRecord) {
            let parentEvent = await (0, $5ZsVo.getParentEventForEvent)(companyParentEvents, event);
            if (parentEvent) for (const x of matchParticipants){
                let existingStreak;
                for (const streak of (await (0, $iQtzn.getEventStreaks)(parentEvent))){
                    let streakTalent = await (0, $lhVvD.getStreakTalent)(streak);
                    if (streakTalent.objectName === x.objectName && streakTalent.$loki === x.$loki) {
                        existingStreak = streak;
                        break;
                    }
                }
                if (existingStreak) {
                    let streakData = {};
                    if (x.$loki === winnerParticipant.$loki) // Add to streak if winner and not tournament match or tournament match final
                    {
                        if (checkTournament) {
                            existingStreak.length += 1;
                            if (existingStreak.length === 2) streakData["started"] = true;
                            else if (existingStreak.length > 2) streakData["extended"] = true;
                            // Get streak data
                            streaks.push({
                                ...streakData,
                                ...await (0, $5ZsVo.getStreakData)(existingStreak)
                            });
                        }
                    } else {
                        // End streak
                        if (existingStreak.length > 2) {
                            streakData["ended"] = true;
                            streakData["winner"] = winnerParticipant.name;
                            streakEnded = existingStreak;
                            // Add to company log
                            let streakTalent = await (0, $lhVvD.getStreakTalent)(existingStreak);
                            let newLog = (0, $4K85d.CompanyLog)(month, realYear);
                            newLog.text = `${winnerParticipant.name} ended ${streakTalent.name}'s ${existingStreak.length} ` + `match undefeated streak at ${event.name}!`;
                            newLog.type = "moment";
                            newLog.realYear = year;
                            newLog.eventName = event.name;
                            newLog.value = existingStreak.length * 2;
                            await (0, $14eBR.CompanyLogs).insert(newLog);
                            await (0, $9esFv.addCompanyCompanyLogs)(company, [
                                newLog
                            ]);
                            // Get streak data
                            streaks.push({
                                ...streakData,
                                ...await (0, $5ZsVo.getStreakData)(existingStreak)
                            });
                            // Add feud
                            if (existingStreak.length > 4) {
                                let newFeudParticipants = [
                                    streakTalent,
                                    winnerParticipant
                                ];
                                let addFeudData = await $2d316f999b9a52df$var$checkToAddFeud("streak-broken", newFeudParticipants, company, mainRoster, month, year);
                                if (addFeudData["key"] === "feudPotentials") feudPotentials.push(addFeudData["value"]);
                                else if (addFeudData["key"] === "feudHypeIncreased") feudHypeIncreased.push(addFeudData["value"]);
                            }
                        }
                        await (0, $iQtzn.removeEventStreaks)(parentEvent, [
                            existingStreak
                        ]);
                        existingStreak.ended = true;
                    }
                } else // Create new streak if winner
                if (x.$loki === winnerParticipant.$loki && checkTournament) {
                    let newStreak = (0, $lhVvD.Streak)();
                    await (0, $14eBR.Streaks).insert(newStreak);
                    if (x.objectName === "superstar") await (0, $hBIDz.addSuperstarStreaks)(x, [
                        newStreak
                    ]);
                    else if (x.objectName === "tagTeam") await (0, $972Ip.addTagTeamStreaks)(x, [
                        newStreak
                    ]);
                    await (0, $iQtzn.addEventStreaks)(parentEvent, [
                        newStreak
                    ]);
                }
            }
        }
        // Check for tournament final
        let tournamentFinal = null;
        let lowerPopularityChange = false;
        if (tournament) {
            if (match.tournamentRound === tournament.rounds && !tournament.annualTournament) {
                tournamentFinal = tournament;
                match.tournamentFinalBonus = (0, $6RCLU.getTournamentFinalBonus)(tournament);
            } else if (tournament.type === "round-robin" && tournament.stage !== "elimination") lowerPopularityChange = true;
        }
        // Get losers
        let loserParticipants = matchParticipants.filter((x)=>x.$loki !== winnerParticipant.$loki);
        // Check for holy shit moment
        if (matchGimmick) {
            let pick = (0, $3E8Nt.getRandomInt)(0, 100);
            let holyShitMomentChance = 25;
            // Get superstar who performs holy shit moment
            let superstarsTraitsWeights = (0, $5kTkA.getTraitWeightsForSuperstars)(winnerSuperstars, "holy_shit_moment_chance_multiplier");
            let holyShitMomentBy = (0, $3E8Nt.weightedChoice)(superstarsTraitsWeights);
            // Get trait multiplier for winner superstar
            let holyShitMomentChanceMultiplier = 1;
            for (const trait of holyShitMomentBy.traits){
                let traitData = (0, $aP7lq.traitsData)[trait];
                if (traitData && traitData["holy_shit_moment_chance_multiplier"]) holyShitMomentChanceMultiplier *= traitData["holy_shit_moment_chance_multiplier"];
            }
            holyShitMomentChanceMultiplier = (0, $3E8Nt.limitValueBetweenRange)(holyShitMomentChanceMultiplier, 0, 2.4);
            holyShitMomentChance *= holyShitMomentChanceMultiplier;
            if (pick <= holyShitMomentChance) {
                let pointsToAdd = 30;
                let overnessIncrease = (0, $3E8Nt.getRandomInt)(1, 3);
                // Get superstar to perform holy shit moment on
                let randomLoserParticipant = (0, $3E8Nt.getRandomChoice)(loserParticipants);
                holyShitMomentTo = (0, $3E8Nt.getRandomChoice)(randomLoserParticipant.tempSuperstars);
                // Get holy shit text and data
                let holyShitText = (0, $6RCLU.generateGimmickMatchText)(matchGimmick, holyShitMomentBy, holyShitMomentTo);
                holyShitData = {
                    "text": holyShitText,
                    "overnessIncrease": overnessIncrease,
                    "superstarName": holyShitMomentBy.name,
                    "pointsGained": pointsToAdd
                };
                // Boost overness
                holyShitMomentBy.overness += overnessIncrease;
                // Add points
                company.points += pointsToAdd;
                // Change objective property
                if (company.userControlled) {
                    let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                        name: "holy shit moments",
                        change: 1,
                        company: company
                    });
                    if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                }
                // Add company log
                let newLog = (0, $4K85d.CompanyLog)(month, realYear);
                newLog.text = holyShitText;
                newLog.type = "moment";
                newLog.realYear = year;
                newLog.eventName = event.name;
                newLog.value = 2;
                await (0, $14eBR.CompanyLogs).insert(newLog);
                await (0, $9esFv.addCompanyCompanyLogs)(company, [
                    newLog
                ]);
                // Add kayfabe points
                let kayfabePointsChange = await (0, $5kTkA.getKayfabePointsChange)({
                    changeType: "holyShitMoment"
                });
                (0, $5kTkA.updateSuperstarKayfabePoints)(holyShitMomentBy, kayfabePointsChange);
                // Award or unlock powerup
                if (company.storyName !== "mars" && (0, $3E8Nt.getRandomInt)(0, 100) <= 25 && company.style === "entertainment" && company.introducedPowerups) {
                    let powerups = await (0, $9esFv.getCompanyPowerups)(company);
                    if (powerups.length > 0) {
                        if (matchGimmick.level < 3) // Award powerup
                        {
                            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) await awardOrUnlockPowerup(powerups);
                        } else {
                            let powerupsToUnlock = (0, $kpu3X.getPowerupsToUnlock)(powerups);
                            // Unlock powerup
                            if (powerupsToUnlock.length > 0) await awardOrUnlockPowerup(powerupsToUnlock, true);
                            else await awardOrUnlockPowerup(powerups);
                        }
                    }
                }
            }
        }
        // Check for blood boost
        let bloodBoost = 0;
        let bloodySuperstars = [];
        let randomLoserParticipant = (0, $3E8Nt.getRandomChoice)(loserParticipants);
        let randomLoserSuperstar = (0, $3E8Nt.getRandomChoice)(randomLoserParticipant.tempSuperstars);
        // Add blood for specific special match finishes
        if (matchFinish && [
            "Pass Out",
            "Respectful End",
            "By Any Means",
            "Throw In Towel"
        ].includes(matchFinish["name"])) bloodySuperstars.push(randomLoserSuperstar);
        else if (matchGimmick) {
            // Add blood in first blood match
            if (matchGimmick.name.toLowerCase() === "first blood") bloodySuperstars.push(randomLoserSuperstar);
            else {
                let bleederTraitSuperstar = null;
                let dangerousWorkerTraitSuperstar = null;
                let addBloodChance = 2;
                if (holyShitData) addBloodChance += 30;
                else {
                    // Get trait to add blood chance
                    let addBloodChanceBoost = 0;
                    for (const matchSuperstar of matchSuperstars)for (const trait of matchSuperstar.traits){
                        let traitData = (0, $aP7lq.traitsData)[trait];
                        if (traitData && traitData["add_blood_chance_boost"]) {
                            addBloodChanceBoost += traitData["add_blood_chance_boost"];
                            bleederTraitSuperstar = matchSuperstar;
                        }
                        if (traitData && traitData["add_blood_to_opponent_chance_boost"]) {
                            addBloodChanceBoost += traitData["add_blood_to_opponent_chance_boost"];
                            dangerousWorkerTraitSuperstar = matchSuperstar;
                        }
                    }
                    addBloodChanceBoost = (0, $3E8Nt.limitValueBetweenRange)(addBloodChanceBoost, 0, 40);
                    addBloodChance += addBloodChanceBoost;
                }
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= addBloodChance) {
                    // Choose bloody superstar
                    let bloodySuperstar;
                    if (holyShitData) bloodySuperstar = holyShitMomentTo;
                    else {
                        if (bleederTraitSuperstar) // Add blood to superstar with bleeder trait
                        bloodySuperstar = bleederTraitSuperstar;
                        else if (dangerousWorkerTraitSuperstar) {
                            // Get superstar from opponents of dangerous worker
                            let dangerousWorkerTraitParticipant;
                            for (const y of matchParticipants)if ((0, $3E8Nt.objectInArray)(dangerousWorkerTraitSuperstar, y.tempSuperstars)) {
                                dangerousWorkerTraitParticipant = y;
                                break;
                            }
                            const dangerousWorkerTraitParticipantSuperstars = dangerousWorkerTraitParticipant.tempSuperstars;
                            bloodySuperstar = (0, $3E8Nt.getRandomChoice)(matchSuperstars.filter((y)=>!(0, $3E8Nt.objectInArray)(y, dangerousWorkerTraitParticipantSuperstars)));
                        } else // Otherwise get random superstar
                        bloodySuperstar = (0, $3E8Nt.getRandomChoice)(matchSuperstars);
                    }
                    bloodySuperstars.push(bloodySuperstar);
                    bloodBoost += 0.25;
                    // Check to acquire trait
                    await (0, $5kTkA.checkAcquireTrait)(bloodySuperstar, "Bleeder");
                    // Chance to add second bloody superstar
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) {
                        let superstarsWithoutBlood = matchSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, bloodySuperstars));
                        bloodySuperstars.push((0, $3E8Nt.getRandomChoice)(superstarsWithoutBlood));
                        bloodBoost += 0.25;
                    }
                }
            }
        }
        // Add blood to superstars
        if (bloodySuperstars.length > 0) {
            let bloodObjects = (0, $2GWzg.graphicsData)["bloodObjects"];
            for (const bloodySuperstar of bloodySuperstars){
                bloodySuperstarsData.push({
                    "name": bloodySuperstar.name
                });
                // Find superstar graphic, add blood object
                if (graphics) {
                    let participantGraphic = graphics.find((y)=>y && y["uid"] === bloodySuperstar.$loki);
                    if (participantGraphic) {
                        let bloodObject = (0, $3E8Nt.getRandomChoice)(bloodObjects);
                        participantGraphic["blood"] = {
                            "object": bloodObject["number"],
                            "colors": [
                                "0xFFFFFF"
                            ]
                        };
                        // Add temporary injury
                        bloodySuperstar.temporaryInjury = bloodObject["type"];
                    }
                }
            }
            // Don't add graphics when simulating (match_graphics is None there)
            if (graphics) updateGraphics = true;
        }
        // Get managers present in match
        let matchManagers = [];
        let fullTimeManagerFinish = false;
        for (const s of matchSuperstars){
            let superstarManager = await (0, $5kTkA.getSuperstarManagerUsedForMatchOrSegment)(s, match.managersUsed, rosterSuperstars);
            if (superstarManager && !(0, $3E8Nt.objectInArray)(superstarManager, matchManagers)) {
                matchManagers.push(superstarManager);
                // Check if full-time manager present and they are part of finish
                if (matchFinish && superstarManager.fullTimeManager) {
                    if (!interferingMember || interferingMember.$loki === superstarManager.$loki) fullTimeManagerFinish = true;
                }
            }
        }
        // Get match rating
        let matchChampionships = await (0, $i7bmn.getMatchChampionships)(match);
        let ratingData = await $2d316f999b9a52df$var$getMatchRating(matchParticipants, matchSuperstars, matchChampionships, matchGimmick, match, weeklyShow, effect, matchFinish, matchFeuds, bloodBoost, fullTimeManagerFinish, annualTournament, company.storyName, segmentsAndMatches);
        // Get and set match's rating
        let rating = ratingData["rating"];
        if (cashinData["cashin"]) rating = null;
        if (rating !== null) {
            if (event.activeEffect === "lower_match_ratings") {
                rating -= (0, $3E8Nt.getRandomChoice)([
                    0.5,
                    0.75,
                    1,
                    1.5,
                    1.5,
                    2,
                    2.5
                ]);
                if (rating < 0) rating = 0;
            } else if (event.activeEffect === "raise_match_ratings") {
                rating += (0, $3E8Nt.getRandomChoice)([
                    0.75,
                    1,
                    1.5,
                    1.5
                ]);
                if (rating > 6) rating = 6;
            }
        }
        match.rating = rating;
        // Check for hot match
        let hotMatch = await $2d316f999b9a52df$var$checkMatchHot(match, matchParticipants, matchSuperstars);
        // Process popularity changes
        let [winnerData, losersData] = await $2d316f999b9a52df$var$processMatchWinnerAndLosers(winnerParticipant, loserParticipants, matchChampionships, matchGimmick, company, match, streakEnded, tournamentFinal, lowerPopularityChange, weeklyShow, hotMatch, matchFinish, rosterSuperstars);
        // Set winner and loser
        match.winner = winnerParticipant.name;
        match.loser = (0, $3E8Nt.commaSeparate)(loserParticipants.map((y)=>y.name));
        // Add won/defended/retained championships to match
        if (winnerData["wonChampionships"].length > 0) match.championshipsWon = (0, $1JSre.getChampionshipsDisplayName)(winnerData["wonChampionships"]);
        if (winnerData["defendedChampionships"].length > 0) match.championshipsDefended = (0, $1JSre.getChampionshipsDisplayName)(winnerData["defendedChampionships"]);
        if (winnerData["retainedChampionships"].length > 0) match.championshipsRetained = (0, $1JSre.getChampionshipsDisplayName)(winnerData["retainedChampionships"]);
        // Check championship contract win objective
        for (const y of matchChampionships)if (y.championshipContract) {
            let holder = await (0, $ivuOU.getChampionshipSuperstar)(y);
            if (holder && company.userControlled) {
                // Change objective property
                let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                    name: "win championship contract",
                    change: 1,
                    company: company,
                    superstarName: holder.name
                });
                if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
            }
        }
        // Check for holy shit moment in pure company, added later because it depends on match rating
        if (!matchGimmick && (company.style === "pure" || annualTournament) && rating > 4) {
            let pick;
            if (rating >= 4.75) pick = (0, $3E8Nt.getRandomInt)(0, 60);
            else pick = (0, $3E8Nt.getRandomInt)(0, 100);
            let holyShitMomentChance = 20;
            // Get superstar who performs holy shit moment
            const superstarsTraitsWeights = (0, $5kTkA.getTraitWeightsForSuperstars)(winnerSuperstars, "holy_shit_moment_pure_chance_multiplier");
            let holyShitMomentBy = (0, $3E8Nt.weightedChoice)(superstarsTraitsWeights);
            // Get trait multiplier for holy shit moment by
            for (const trait of holyShitMomentBy.traits){
                const traitData = (0, $aP7lq.traitsData)[trait];
                if (traitData && traitData["holy_shit_moment_pure_chance_multiplier"]) holyShitMomentChance *= traitData["holy_shit_moment_pure_chance_multiplier"];
            }
            if (pick <= holyShitMomentChance) {
                const pointsToAdd = !annualTournament ? 30 : 0;
                let overnessIncrease = (0, $3E8Nt.getRandomInt)(1, 3);
                // Get superstar to perform holy shit moment on
                let randomLoserParticipant = (0, $3E8Nt.getRandomChoice)(loserParticipants);
                holyShitMomentTo = (0, $3E8Nt.getRandomChoice)(randomLoserParticipant.tempSuperstars);
                // Get holy shit text and data
                let holyShitText = (0, $6RCLU.generateGimmickMatchText)(null, holyShitMomentBy, holyShitMomentTo);
                holyShitData = {
                    "text": holyShitText,
                    "overnessIncrease": overnessIncrease,
                    "superstarName": holyShitMomentBy.name,
                    "pointsGained": pointsToAdd
                };
                // Boost overness
                holyShitMomentBy.overness += overnessIncrease;
                // Add points
                company.points += pointsToAdd;
                // Add kayfabe points
                let kayfabePointsChange = await (0, $5kTkA.getKayfabePointsChange)({
                    changeType: "holyShitMoment"
                });
                (0, $5kTkA.updateSuperstarKayfabePoints)(holyShitMomentBy, kayfabePointsChange);
                if (!annualTournament) {
                    // Change objective property
                    if (company.userControlled) {
                        let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                            name: "holy shit moments",
                            change: 1,
                            company: company
                        });
                        if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                    }
                    // Add company log
                    let newLog = (0, $4K85d.CompanyLog)(month, realYear);
                    newLog.text = holyShitText;
                    newLog.type = "moment";
                    newLog.realYear = year;
                    newLog.eventName = event.name;
                    newLog.value = Math.round(rating);
                    await (0, $14eBR.CompanyLogs).insert(newLog);
                    await (0, $9esFv.addCompanyCompanyLogs)(company, [
                        newLog
                    ]);
                    // Award or unlock powerup
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 25 && company.introducedPowerups) {
                        let powerups = await (0, $9esFv.getCompanyPowerups)(company);
                        if (powerups.length > 0) {
                            if (rating < 5) // Award powerup
                            {
                                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) await awardOrUnlockPowerup(powerups);
                            } else {
                                let powerupsToUnlock = (0, $kpu3X.getPowerupsToUnlock)(powerups);
                                // Unlock powerup
                                if (powerupsToUnlock.length > 0) await awardOrUnlockPowerup(powerupsToUnlock, true);
                                else await awardOrUnlockPowerup(powerups);
                            }
                        }
                    }
                }
            }
        }
        // Process match superstars
        for (const s of matchSuperstars){
            let talentCompany = await (0, $3E8Nt.getTalentCompany)(s);
            // Check fotc
            if (!weeklyShow) {
                if (!s.faceOfTheCompany) {
                    if (s.popularity >= 1000) {
                        s.faceOfTheCompanyCounter += 1;
                        if (s.faceOfTheCompanyCounter >= 6) {
                            s.faceOfTheCompany = true;
                            fotcChanges.push({
                                "name": s.name,
                                "faceOfTheCompany": s.faceOfTheCompany
                            });
                            // Change objective property
                            let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                name: "face of the company",
                                change: 1,
                                company: company,
                                superstarName: s.name
                            });
                            if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                            // Update faction rep
                            let superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                                superstar: s,
                                fotcChange: "becameFotc"
                            });
                            factionReputationsData.push(...superstarFactionsData);
                            // Add kayfabe points
                            let kayfabePointsChange = await (0, $5kTkA.getKayfabePointsChange)({
                                changeType: "fotc"
                            });
                            (0, $5kTkA.updateSuperstarKayfabePoints)(s, kayfabePointsChange);
                            // Add TGI president's message
                            if (talentCompany && talentCompany.userControlled && (0, $3E8Nt.getRandomInt)(0, 100) <= 40) {
                                let annualTournamentHeld = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((y)=>y.annualTournament && y.status === "ended");
                                if (annualTournamentHeld) {
                                    let newMessage = await (0, $hekDR.createPresidentFotcSuperstarMessage)(s, game, month, year);
                                    await (0, $9esFv.addCompanyMessages)(talentCompany, [
                                        newMessage
                                    ]);
                                }
                            }
                        } else if (s.faceOfTheCompanyCounter === 1) fotcChanges.push({
                            "name": s.name,
                            "faceOfTheCompany": s.faceOfTheCompany,
                            "faceOfTheCompanyStart": true
                        });
                    } else s.faceOfTheCompanyCounter = 0;
                } else if (s.popularity < 1000) {
                    s.faceOfTheCompany = false;
                    s.faceOfTheCompanyCounter = 0;
                    fotcChanges.push({
                        "name": s.name,
                        "faceOfTheCompany": s.faceOfTheCompany
                    });
                    // Update faction rep
                    let superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                        superstar: s,
                        fotcChange: "lostFotc"
                    });
                    factionReputationsData.push(...superstarFactionsData);
                }
            }
            // Reduce appearance for part timers
            if (s.partTimer && s.activeEffect !== "traded") {
                if (!match.tournamentRound || match.tournamentRound === 1) {
                    s.appearances -= 1;
                    if (s.appearances < 0) s.appearances = 0;
                }
            }
            // Reset active effect
            if (s.activeEffect) {
                if (s.activeEffect === "retirement_return") {
                    s.activeEffect = null;
                    s.retired = true;
                    s.partTimer = false;
                    s.appearances = null;
                } else if (s.activeEffect === "one_match_appearance") s.activeEffect = null;
            }
            // Check if last/no appearances, send message
            if (talentCompany && talentCompany.userControlled) {
                if (s.partTimer && (!match.tournamentRound || match.tournamentRound === 1)) {
                    const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
                    if (s.appearances <= 0) {
                        let newMessage = await (0, $hekDR.createNoAppearancesMessage)(s, month, year, talentManager);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                    } else if (s.appearances === 1) {
                        let newMessage = await (0, $hekDR.createLastAppearanceMessage)(s, month, year, talentManager);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                    }
                }
            }
            // Debut new gimmick if set
            if (s.debutNewGimmick) {
                let producer = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "producer");
                let debutedGimmickData = await (0, $5kTkA.debutGimmick)(s, company, producer, month, year);
                debutedGimmicks.push(debutedGimmickData);
                // Add producer skill increase data
                if (debutedGimmickData["staffSkillIncreases"]) staffSkillIncreases.push(debutedGimmickData["staffSkillIncreases"]);
            } else {
                let matchSuperstarParticipant;
                for (const y of matchParticipants)if ((0, $3E8Nt.objectInArray)(s, y.tempSuperstars)) {
                    matchSuperstarParticipant = y;
                    break;
                }
                await updateSuperstarGimmickEffectiveness(s, matchSuperstarParticipant);
            }
        }
        // Process championships
        let championshipsWon = winnerData["wonChampionships"].map((x)=>x["name"]);
        let championshipsDefended = winnerData["defendedChampionships"].map((x)=>x["name"]);
        let championshipsRetained = winnerData["retainedChampionships"].map((x)=>x["name"]);
        for (const x of matchChampionships){
            let championshipSet = x.tagTeam || x.trio ? companyChampionships.filter((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(y, x)) : [
                x
            ];
            // If match for championship contract, set cashin available
            if (x.championshipContract && !x.vacated) {
                if (!x.tagTeam && !x.trio) cashinData["cashinSinglesAvailable"] = true;
                else if (x.trio) cashinData["cashinTriosAvailable"] = true;
                else cashinData["cashinTagAvailable"] = true;
            }
            // Set match contract to awarded
            if (changeChampionship) {
                for (const y of championshipSet)if (y.matchContract) {
                    let matchContract = await (0, $ivuOU.getChampionshipMatchContract)(y);
                    if (matchContract && !matchContract.awarded) {
                        matchContract.awarded = true;
                        matchContract.availableForUse = false;
                    }
                }
            }
            // Process won
            if (championshipsWon.includes(x.name)) {
                for (const c of championshipSet){
                    // End current reign
                    let currentReign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
                    if (currentReign) {
                        currentReign.endMonth = month;
                        currentReign.endYear = year;
                    }
                    // Add new reign
                    let newReign = (0, $9MKdC.ChampionshipReign)(month, year);
                    await (0, $14eBR.ChampionshipReigns).insert(newReign);
                    await (0, $ivuOU.addChampionshipChampionshipReigns)(c, [
                        newReign
                    ]);
                    await (0, $hBIDz.addSuperstarChampionshipReigns)(await (0, $ivuOU.getChampionshipSuperstar)(c), [
                        newReign
                    ]);
                    await (0, $i7bmn.addMatchChampionshipReigns)(match, [
                        newReign
                    ]);
                    // Transfer match contract
                    if (c.matchContract) {
                        let matchContract = await (0, $ivuOU.getChampionshipMatchContract)(c);
                        if (matchContract) await (0, $1AAHK.addTalentMatchContracts)(winnerParticipant, [
                            matchContract
                        ]);
                    }
                }
                // Add championship win news
                if (x.rank === "Main Eventer") {
                    let newsItem = await (0, $kZMqI.generateNewsItem)({
                        company: company,
                        month: game.newsMonth,
                        year: game.newsYear,
                        superstar: winnerParticipant,
                        newsType: "won_championship",
                        championship: x,
                        event: event
                    });
                    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                        newsItem
                    ]);
                }
                // Check for POW goal if winning main championship
                if (type === "singles" && company.storyName === "passion" && x.name === "POW") {
                    const powStarResult = await (0, $jC7EP.processPowStarResult)(winnerParticipant, company);
                    // Lower match rating and remove hot if failure
                    if (powStarResult["failed"]) {
                        if (match.rating >= 3) {
                            rating = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(100, 200), 25) / 100;
                            match.rating = rating;
                        }
                        if (match.hot) {
                            hotMatch = false;
                            match.hot = hotMatch;
                        }
                    }
                    // Increase match rating if success
                    if (powStarResult["completed"]) {
                        if (match.rating < 4) {
                            rating = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(400, 450), 25) / 100;
                            match.rating = rating;
                        }
                    }
                    // Add superstar changes
                    if (powStarResult["superstarChanges"]) try {
                        let powStarPopularityChange = powStarResult["superstarChanges"]["popularityChange"];
                        if (powStarPopularityChange) {
                            winnerData["popularityChange"] += powStarPopularityChange;
                            winnerData["popularity"] = winnerParticipant.popularity;
                        }
                    } catch (error) {
                        (0, $3E8Nt.captureError)(error);
                    }
                } else if (type === "tag") {
                    if (winnerParticipant.temporary && !winnerParticipant.trioTagTeam) {
                        // If team already exists (for team within a faction), don't make temporary team permanent
                        let existingTagTeam;
                        for (const y of (await (0, $hBIDz.getSuperstarTagTeams)(winnerSuperstars[0])))if (!y.temporary && (0, $3E8Nt.checkAreObjArraysEqual)(await (0, $972Ip.getTagTeamSuperstars)(y), winnerSuperstars)) {
                            existingTagTeam = y;
                            break;
                        }
                        if (!existingTagTeam) {
                            winnerParticipant.temporary = false;
                            // Set as trio if 3 superstars in team
                            if (winnerSuperstars.length === 3) winnerParticipant.trio = true;
                        }
                    }
                }
            } else if (championshipsDefended.includes(x.name)) for (const c of championshipSet){
                // Add match to reign's defenses
                let currentReign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
                if (currentReign) await (0, $i7bmn.addMatchChampionshipReigns)(match, [
                    currentReign
                ]);
            }
            else if (championshipsRetained.includes(x.name) && !x.vacated) for (const c of championshipSet){
                // Add match to reign's defenses
                let currentReign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
                if (currentReign) await (0, $i7bmn.addMatchChampionshipReigns)(match, [
                    currentReign
                ]);
            }
            // Get xp data
            let championshipWon = championshipsWon.includes(x.name);
            let championshipDefendedOrRetained = championshipsDefended.concat(championshipsRetained).includes(x.name);
            let championshipXpData = await (0, $kZwpB.getChampionshipXpChange)({
                championship: x,
                company: company,
                month: month,
                year: year,
                match: match,
                weeklyShow: weeklyShow,
                championshipWon: championshipWon,
                championshipDefendedOrRetained: championshipDefendedOrRetained,
                mainEvent: mainEvent
            });
            // Process prestige
            if (championshipXpData["totalXpChange"]) {
                let championshipPrestigeData = await (0, $8A6FL.processChampionshipXpChange)(x, championshipXpData["totalXpChange"], companyChampionships);
                if (championshipPrestigeData["xp"]) {
                    championshipPrestigeData["xpDetails"] = championshipXpData;
                    // Add to data (if not already added)
                    if (!championshipPrestiges.map((y)=>y["championshipName"]).includes(championshipPrestigeData["championshipName"])) championshipPrestiges.push(championshipPrestigeData);
                    // Check for objective completed
                    if (championshipPrestigeData["prestigeIncrease"]) {
                        if (company.userControlled) {
                            let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                name: "championship prestige",
                                change: 1,
                                company: company,
                                championship: x
                            });
                            if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                        }
                        // If prestige increased over highest value, unlock prestige bonus segments
                        if (championshipPrestigeData["firstPrestigeIncrease"]) unlockedChampionshipSegmentItems.push(...await (0, $kZwpB.checkChampionshipSegmentItemsToUnlock)(championshipPrestigeData["prestige"], company));
                    }
                }
            }
        }
        // Create new match between winner and championship contract holder
        if (cashinData["challengerName"]) {
            let championshipToCashinOn;
            if (matchChampionships.length > 0) {
                championshipToCashinOn = [
                    ...matchChampionships
                ].sort((0, $kZwpB.compareChampionships))[0];
                // Find champion and challenger
                let champion;
                let challenger;
                if (type === "singles") {
                    champion = await (0, $ivuOU.getChampionshipSuperstar)(championshipToCashinOn);
                    challenger = rosterSuperstars.find((y)=>y.name === cashinData["challengerName"]);
                } else if (type === "tag") {
                    if (championshipToCashinOn.trio) champion = (await (0, $hBIDz.getSuperstarTagTeams)(await (0, $ivuOU.getChampionshipSuperstar)(championshipToCashinOn))).find((y)=>!y.temporary && y.trio);
                    else champion = (await (0, $hBIDz.getSuperstarTagTeams)(await (0, $ivuOU.getChampionshipSuperstar)(championshipToCashinOn))).find((y)=>!y.temporary && !y.trio);
                    challenger = rosterTagTeams.find((y)=>y.name === cashinData["challengerName"]);
                }
                if (champion && challenger) {
                    // Find championship contract
                    let championshipContract;
                    let challengerSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(challenger);
                    for (const y of (await (0, $hBIDz.getSuperstarChampionships)(challengerSuperstars[0])))if (y.championshipContract) {
                        championshipContract = y;
                        break;
                    }
                    // Add match
                    newMatch = (0, $i7bmn.Match)(event.matchesCount, type);
                    newMatch.order = match.order - 1;
                    await (0, $14eBR.Matches).insert(newMatch);
                    await (0, $iQtzn.addEventMatches)(event, [
                        newMatch
                    ]);
                    await (0, $i7bmn.addMatchParticipants)(newMatch, [
                        champion,
                        challenger
                    ]);
                    for (const c of companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championshipToCashinOn)))c.booked = true;
                    await (0, $i7bmn.addMatchChampionships)(newMatch, [
                        championshipToCashinOn
                    ]);
                    event.matchesCount += 1;
                    // Set decreasing order for matches/segments after this one
                    for (const y of segmentsAndMatches.reverse())if (y.order <= newMatch.order) y.order -= 1;
                    // Get superstars
                    const newMatchSuperstars = await (0, $i7bmn.getAllSuperstarsForMatch)(newMatch);
                    // Remove championship contracts
                    let championshipSet = championshipContract.tagTeam || championshipContract.trio ? companyChampionships.filter((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(y, championshipContract)) : [
                        championshipContract
                    ];
                    for (const championship of championshipSet){
                        await (0, $hBIDz.removeSuperstarChampionships)(await (0, $ivuOU.getChampionshipSuperstar)(championship), [
                            championship
                        ]);
                        await (0, $9esFv.removeCompanyChampionships)(company, [
                            championship
                        ]);
                        await (0, $14eBR.Championships).remove(championship);
                    }
                    // Add managers
                    if ((0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(newMatch, newMatchSuperstars, rosterSuperstars);
                    // Check for championship contracts
                    cashinData["cashinSinglesAvailable"] = false;
                    cashinData["cashinTagAvailable"] = false;
                    cashinData["cashinTriosAvailable"] = false;
                    for (const championship of (await (0, $9esFv.getCompanyChampionships)(company)))if (championship.championshipContract && !championship.vacated) {
                        if (!championship.tagTeam && !championship.trio) cashinData["cashinSinglesAvailable"] = true;
                        else if (championship.trio) cashinData["cashinTriosAvailable"] = true;
                        else cashinData["cashinTagAvailable"] = true;
                    }
                    data["challenger"] = challenger.name;
                    data["championshipContract"] = championshipContract.name;
                    // Holy shit moment award
                    let pointsGained = 30;
                    company.points += pointsGained;
                    // Check goal
                    const objectiveCompleted = await (0, $8A6FL.changeProperty)({
                        name: "holy shit moments",
                        change: 1,
                        company: company
                    });
                    if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                    // Add company log
                    const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
                    (0, $14eBR.CompanyLogs).insert(newCompanyLog);
                    const matchParticipantNames = matchParticipants.map((x)=>x.name).join(" vs ");
                    newCompanyLog.text = `${challenger.name} cashed in ${championshipContract.name} after ${matchParticipantNames}!`;
                    newCompanyLog.type = "moment";
                    newCompanyLog.realYear = game.year;
                    newCompanyLog.eventName = event.name;
                    newCompanyLog.value = 6;
                    await (0, $9esFv.addCompanyCompanyLogs)(company, [
                        newCompanyLog
                    ]);
                }
            }
        }
        // Check for injuries
        if (match.activeEffect !== "virtual") for (const matchParticipant of matchParticipants){
            for (const s of matchParticipant.tempSuperstars){
                // Don't injure wrestlers in Olympus Mons match
                if (matchGimmick && matchGimmick.name === "Olympus Mons" && company.storyName === "mars") break;
                // Check for injury
                let talentCompany = await (0, $3E8Nt.getTalentCompany)(s);
                let opponentSuperstars = matchSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, matchParticipant.tempSuperstars));
                let injuryData = await (0, $5kTkA.checkForSuperstarInjury)(s, matchParticipants, opponentSuperstars, matchGimmick, holyShitData, tournament, talentCompany, game);
                // Process injury
                if (injuryData["months"] > 0) {
                    // Check if superstar was working through injury
                    let workingThroughInjury = s.workableInjury;
                    // Add injury to superstar
                    await (0, $5kTkA.addInjuryToSuperstar)(s, injuryData["months"], injuryData["name"], injuryData["type"], talentCompany);
                    // Get doctor
                    let doctor = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "doctor");
                    let maxDoctor = (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "doctor");
                    // Add injury message and company alert
                    if (talentCompany && talentCompany.userControlled) {
                        // Get talent company's doctor for TGI
                        if (annualTournament && !doctor) {
                            let talentCompanyStaff = (0, $9esFv.getCompanyStaff)(talentCompany);
                            doctor = (0, $8A6FL.getRandomStaffMemberByRole)(talentCompanyStaff, "doctor");
                            maxDoctor = (0, $8A6FL.getHighestLevelStaffMemberByRole)(talentCompanyStaff, "doctor");
                        }
                        // Talent message
                        if ((0, $5kTkA.checkSuperstarWorkThroughInjury)(s)) {
                            // Superstar message to work through injury
                            if (injuryData["type"] === "workable") {
                                let newMessage = await (0, $hekDR.createWorkThroughInjurySuperstarMessage)(s, month, year);
                                await (0, $9esFv.addCompanyMessages)(talentCompany, [
                                    newMessage
                                ]);
                            }
                            // Superstar message if decided to work through injury
                            if (workingThroughInjury) {
                                let newMessage = await (0, $hekDR.createAggravatedInjurySuperstarMessage)(s, month, year);
                                await (0, $9esFv.addCompanyMessages)(talentCompany, [
                                    newMessage
                                ]);
                            }
                        }
                        // Doctor message
                        let injuryTime = (0, $5kTkA.evaluateInjury)(s, maxDoctor);
                        let newMessage = await (0, $hekDR.createInjuryMessage)(injuryTime, s, injuryData["type"], workingThroughInjury, month, year, doctor);
                        await (0, $9esFv.addCompanyMessages)(talentCompany, [
                            newMessage
                        ]);
                        // Company alert
                        let newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("injured", s.name);
                        await (0, $9esFv.addCompanyCompanyAlerts)(talentCompany, [
                            newCompanyAlert
                        ]);
                    }
                    // Add doctor xp
                    let doctorXpGained = null;
                    let ageMultiplier = null;
                    let doctorName = null;
                    if (doctor) {
                        ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(doctor);
                        doctorXpGained = Math.round(15 * ageMultiplier);
                        let doctorLevelIncrease = await (0, $8A6FL.updateStaffMemberXp)(doctor, doctorXpGained, company, game);
                        doctorName = doctor["name"];
                        if (doctorLevelIncrease) staffSkillIncreases.push({
                            "name": doctor["name"],
                            "level": doctor["level"],
                            "role": doctor["role"]
                        });
                    }
                    // Check for championships to vacate
                    let championshipsToVacate = [];
                    if (!simulator) {
                        if (talentCompany && talentCompany.userControlled) championshipsToVacate = await Promise.all((await (0, $5kTkA.getSuperstarChampionshipsToVacate)(s)).map((x)=>(0, $kZwpB.getChampionshipMatchData)(x)));
                    } else // Vacate if simulating
                    await (0, $5kTkA.vacateChampionships)({
                        superstar: s,
                        championships: companyChampionships,
                        month: month,
                        year: year,
                        company: company,
                        checkTalentRequest: true
                    });
                    // Get unavailable data
                    unavailable.push({
                        "name": s.name,
                        "type": "injury",
                        "injuryType": injuryData["type"],
                        "doctorXpGained": doctorXpGained,
                        "doctorName": doctorName,
                        "doctorAgeMultiplier": ageMultiplier,
                        "uid": s.$loki,
                        "championshipsToVacate": championshipsToVacate,
                        "injuryChance": injuryData["chance"],
                        "participantName": matchParticipant.name
                    });
                    // Get injury caused by, injured participant
                    let injuryCausedBy = (0, $3E8Nt.getRandomChoice)(matchParticipants.filter((x)=>x.$loki !== matchParticipant.$loki));
                    let dangerousWorkerTraitSuperstar = $2d316f999b9a52df$var$getDangerousWorkerSuperstar(opponentSuperstars);
                    let injuredParticipant;
                    if (type === "singles") {
                        injuredParticipant = s;
                        if (dangerousWorkerTraitSuperstar) injuryCausedBy = dangerousWorkerTraitSuperstar;
                    } else {
                        // Get tag team for adding feud and companyLog unless it's temporary, then get superstar
                        injuredParticipant = matchParticipant;
                        if (injuryCausedBy.temporary && !injuryCausedBy.trioTagTeam) {
                            if (dangerousWorkerTraitSuperstar) injuryCausedBy = dangerousWorkerTraitSuperstar;
                            else injuryCausedBy = (0, $3E8Nt.getRandomChoice)(injuryCausedBy.tempSuperstars);
                            injuredParticipant = s;
                        }
                    }
                    // Check to acquire trait
                    let injuryCausedBySuperstar = injuryCausedBy;
                    if (injuryCausedBy.objectName === "tagTeam") injuryCausedBySuperstar = (0, $3E8Nt.getRandomChoice)(injuryCausedBy.tempSuperstars);
                    if (!workingThroughInjury) {
                        await (0, $5kTkA.checkAcquireTrait)(s, "Injury Prone");
                        await (0, $5kTkA.checkAcquireTrait)(injuryCausedBySuperstar, "Dangerous Worker");
                    }
                    if (talentCompany) {
                        // Add news
                        let newsType = injuryData["type"] === "workable" ? "workable_injury" : "injury";
                        let newsItem = await (0, $kZMqI.generateNewsItem)({
                            company: talentCompany,
                            month: game.newsMonth,
                            year: game.newsYear,
                            newsType: newsType,
                            superstar: s
                        });
                        await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                            newsItem
                        ]);
                        // Add company log
                        let newLog = (0, $4K85d.CompanyLog)(month, year);
                        newLog.text = `${injuryCausedBy.name} injured ${injuredParticipant.name}`;
                        newLog.type = "injury";
                        await (0, $14eBR.CompanyLogs).insert(newLog);
                        await (0, $9esFv.addCompanyCompanyLogs)(talentCompany, [
                            newLog
                        ]);
                    }
                    // Add feud if not annual tournament
                    if (!annualTournament) {
                        let newFeudParticipants = [
                            injuredParticipant,
                            injuryCausedBy
                        ];
                        let addFeudData = await $2d316f999b9a52df$var$checkToAddFeud("injury-return", newFeudParticipants, company, mainRoster, month, year);
                        if (addFeudData["key"] === "feudPotentials") feudPotentials.push(addFeudData["value"]);
                        else if (addFeudData["key"] === "feudHypeIncreased") feudHypeIncreased.push(addFeudData["value"]);
                    }
                    break;
                }
            }
            // Break injury loop if any superstar injured
            if (unavailable.length > 0) break;
        }
        // Gimmick match checks
        if (matchGimmick) {
            // Add gimmick match consequences if record affected
            if (affectRecord) {
                const loserParticipant = loserParticipants[0];
                const loserParticipantSuperstars = loserParticipant.tempSuperstars;
                // Make loser unavailable
                if (matchGimmick.consequence === "loser_unavailable") {
                    let months = (0, $3E8Nt.getRandomInt)(2, 4);
                    for (const s of loserParticipantSuperstars){
                        (0, $5kTkA.addKayfabeInjuryToSuperstar)(s, months);
                        unavailable.push({
                            "name": s.name,
                            "type": "unavailable"
                        });
                        // Check talent request
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "write_off",
                            talent: s
                        });
                    }
                    // Add feud
                    let newFeudParticipants = [
                        winnerParticipant,
                        loserParticipant
                    ];
                    if (type === "tag" && winnerParticipant.factionTagTeam && loserParticipant.factionTagTeam) {
                        // Get factions if factions in tag match
                        let winnerFaction = (await (0, $hBIDz.getSuperstarFactions)(winnerSuperstars[0])).find((x)=>!x.disbanded);
                        let loserFaction = (await (0, $hBIDz.getSuperstarFactions)(loserParticipantSuperstars[0])).find((x)=>!x.disbanded);
                        newFeudParticipants = [
                            winnerFaction,
                            loserFaction
                        ];
                    }
                    let addFeudData = await $2d316f999b9a52df$var$checkToAddFeud("loser-leaves", newFeudParticipants, company, mainRoster, month, year);
                    if (addFeudData["key"] === "feudPotentials") feudPotentials.push(addFeudData["value"]);
                    else if (addFeudData["key"] === "feudHypeIncreased") feudHypeIncreased.push(addFeudData["value"]);
                }
                // Hair removed, hair added or mask removed
                if ([
                    "remove_hair",
                    "remove_mask",
                    "add_hair"
                ].includes(matchGimmick.consequence)) for (const s of loserParticipantSuperstars){
                    let gimmickChangeReason;
                    if (matchGimmick.consequence === "remove_hair") {
                        if (s.graphic && Object.keys(s.graphic).length !== 0) s.graphic = (0, $5kTkA.removeSuperstarGraphicHair)(s.graphic);
                        hairRemoved.push({
                            "name": s.name,
                            "possessivePronoun": s.possessivePronoun
                        });
                        gimmickChangeReason = "Hair Loss";
                    }
                    if (matchGimmick.consequence === "remove_mask") {
                        if (s.graphic && Object.keys(s.graphic).length !== 0) s.graphic = (0, $5kTkA.removeSuperstarGraphicMask)(s.graphic);
                        maskRemoved.push({
                            "name": s.name,
                            "possessivePronoun": s.possessivePronoun
                        });
                        gimmickChangeReason = "Unmasking";
                    }
                    if (matchGimmick.consequence === "add_hair") {
                        if (s.graphic && Object.keys(s.graphic).length !== 0) s.graphic = (0, $5kTkA.addSuperstarGraphicHair)(s.graphic, s.gender);
                        hairAdded.push({
                            "name": s.name,
                            "possessivePronoun": s.possessivePronoun
                        });
                    }
                    if (gimmickChangeReason) {
                        // Next gimmick boost chance and message
                        let addedNextGimmickBoost = await (0, $5kTkA.addNextGimmickBoost)(s, 75);
                        if (addedNextGimmickBoost && company.userControlled) {
                            const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
                            let newMessage = await (0, $hekDR.createGimmickChangeBoostMessage)(s, gimmickChangeReason, month, year, talentManager);
                            await (0, $9esFv.addCompanyMessages)(company, [
                                newMessage
                            ]);
                        }
                    }
                    // Update graphics
                    if (graphics) {
                        graphics = $2d316f999b9a52df$export$401884867da6aea9(graphics, s);
                        updateGraphics = true;
                    }
                    // Check talent request
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "change_appearance",
                        talent: s
                    });
                }
                // Mask or hair removed
                if (matchGimmick.consequence === "remove_mask_or_hair") for (const s of loserParticipantSuperstars){
                    let gimmickChangeReason = null;
                    if (loserParticipantSuperstars.some((x)=>(0, $5kTkA.checkSuperstarGraphicMask)(x.graphic))) {
                        if ((0, $5kTkA.checkSuperstarGraphicMask)(s.graphic)) {
                            s.graphic = (0, $5kTkA.removeSuperstarGraphicMask)(s.graphic);
                            maskRemoved.push({
                                "name": s.name,
                                "possessivePronoun": s.possessivePronoun
                            });
                            gimmickChangeReason = "Unmasking";
                        }
                    } else if (s.graphic && s.graphic["hair"]["object"] !== 0) {
                        s.graphic = (0, $5kTkA.removeSuperstarGraphicHair)(s.graphic);
                        hairRemoved.push({
                            "name": s.name,
                            "possessivePronoun": s.possessivePronoun
                        });
                        gimmickChangeReason = "Hair Loss";
                    }
                    if (gimmickChangeReason) {
                        // Next gimmick boost chance and message
                        let addedNextGimmickBoost = await (0, $5kTkA.addNextGimmickBoost)(s, 75);
                        if (addedNextGimmickBoost && company.userControlled) {
                            const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
                            let newMessage = await (0, $hekDR.createGimmickChangeBoostMessage)(s, gimmickChangeReason, month, year, talentManager);
                            await (0, $9esFv.addCompanyMessages)(company, [
                                newMessage
                            ]);
                        }
                        // Update graphics
                        if (graphics) {
                            graphics = $2d316f999b9a52df$export$401884867da6aea9(graphics, s);
                            updateGraphics = true;
                        }
                        // Check talent request
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "change_appearance",
                            talent: s
                        });
                    }
                }
            }
            // Check talent request
            for (const matchSuperstar of matchSuperstars){
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "be_in_gimmick_match",
                    talent: matchSuperstar
                });
                let requestData = {
                    "gimmickMatchId": matchGimmick.$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "be_in_gimmick_match_x",
                    talent: matchSuperstar,
                    data: requestData
                });
            }
            // Add xp to gimmick match
            const increase = Math.floor(rating ** 2 * 1.5);
            matchGimmick.xp += increase;
            // Check level increase
            let levelIncrease = false;
            let addedPerk = null;
            if (matchGimmick.level < 3 && matchGimmick.xp >= matchGimmick.level ** 2 * 50) {
                matchGimmick.level += 1;
                levelIncrease = true;
                // Add perk if level increase
                addedPerk = $2d316f999b9a52df$var$addPerkToGimmickMatch(matchGimmick);
            }
            // Get gimmick match level data
            gimmickMatchLevelData = {
                name: matchGimmick.name,
                xp: matchGimmick.xp,
                xpChange: increase,
                level: matchGimmick.level,
                levelIncrease: levelIncrease,
                addedPerk: addedPerk
            };
            // Check for unlocked gimmick matches
            unlockedGimmickMatches = $2d316f999b9a52df$var$checkGimmickMatchesToUnlock(matchGimmick, await (0, $9esFv.getCompanyGimmickMatches)(company));
            // Add match effect change if paid version
            if (rating !== null && (0, $98xmD.globalUser).paid) {
                if (rating >= 4) data["matchEffectIncrease"] = true;
                else data["matchEffectDecrease"] = true;
            }
            data["matchGimmick"] = matchGimmick.name;
            // Generate text for battle royal etc
            if (matchGimmick.rules === "battle_royal") {
                generatedText = await $2d316f999b9a52df$var$generateBattleRoyalMatchResult(match, winnerParticipant, type, matchParticipants, matchSuperstars);
                // Check goal
                if (company.userControlled) {
                    let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                        name: "win battle royal",
                        change: 1,
                        company: company,
                        superstarName: winnerParticipant.name
                    });
                    if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                }
            } else if (matchGimmick.name === "Ironman") generatedText = $2d316f999b9a52df$var$generateIronmanMatchText();
            else if (matchGimmick.rules === "elimination") generatedText = $2d316f999b9a52df$var$generateEliminationMatchResult(winnerParticipant, matchParticipants);
            else if (matchGimmick.rules === "2/3_falls") generatedText = $2d316f999b9a52df$var$generateTwoOutOfThreeFallsResult(winnerParticipant, matchParticipants, match.fallGimmickNames);
            // Add generated text to match
            if (generatedText) match.generatedText = generatedText;
            // Check goal
            if (rating !== null && company.userControlled) {
                let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                    name: "gimmick matches",
                    change: 1,
                    company: company,
                    rating: rating,
                    gimmickMatchName: matchGimmick.name
                });
                if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
            }
            company.storyName === "mars" && matchGimmick.name;
        }
        // Rank checks
        for (const x of winnerSuperstars){
            let talentCompany = await (0, $3E8Nt.getTalentCompany)(x);
            let winnerNewRank = (0, $5kTkA.getRankFromPopularity)(x.popularity);
            if (winnerNewRank !== x.highestRank) {
                // Set highest rank
                let ranks = {
                    "Main Eventer": 4,
                    "Upper Midcarder": 3,
                    "Lower Midcarder": 2,
                    "Jabroni": 1
                };
                ranks[winnerNewRank] || ranks[x.highestRank];
                x.highestRank = winnerNewRank;
                // Check Martian Main Eventer Goal if first time Main Eventer todo LATER
                if (company.userControlled && winnerNewRank === "Main Eventer" && x.name.includes("(Martian)")) await (0, $8A6FL.changeProperty)({
                    name: "martian main eventers",
                    change: 1,
                    company: company
                });
                // Check goals
                if (talentCompany && talentCompany.userControlled) {
                    if (winnerNewRank === "Main Eventer") {
                        let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                            name: "main eventer",
                            change: 1,
                            company: talentCompany,
                            superstarName: x.name
                        });
                        if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, talentCompany);
                        // Find trio
                        let winnerTrio = (await (0, $hBIDz.getSuperstarTagTeams)(x)).find((y)=>y.trio);
                        if (winnerTrio) {
                            // Check if all members are main eventers
                            let winnerTrioSuperstars = await (0, $972Ip.getTagTeamSuperstars)(winnerTrio);
                            if (winnerTrioSuperstars.every((y)=>(0, $5kTkA.getRankFromPopularity)(y.popularity) === "Main Eventer")) {
                                let superstarNames = (0, $3E8Nt.commaSeparate)(winnerTrioSuperstars.map((z)=>z.name).sort((a, b)=>a.localeCompare(b)));
                                let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                    name: "new trio",
                                    change: 1,
                                    company: talentCompany,
                                    superstarName: superstarNames
                                });
                                if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, talentCompany);
                            }
                        }
                    } else if (winnerNewRank === "Upper Midcarder") {
                        let winnerTagTeam = (await (0, $hBIDz.getSuperstarTagTeams)(x)).find((y)=>!y.temporary && !y.trio);
                        if (winnerTagTeam) {
                            let winnerTagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(winnerTagTeam);
                            if (winnerTagTeamSuperstars.every((y)=>[
                                    "Main Eventer",
                                    "Upper Midcarder"
                                ].includes((0, $5kTkA.getRankFromPopularity)(y.popularity)))) {
                                let superstarNames = (0, $3E8Nt.commaSeparate)(winnerTagTeamSuperstars.map((z)=>z.name).sort((a, b)=>a.localeCompare(b)));
                                let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                    name: "new tag team",
                                    change: 1,
                                    company: talentCompany,
                                    superstarName: superstarNames
                                });
                                if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, talentCompany);
                            }
                        }
                    }
                }
            }
            // Check talent request
            if (talentCompany) {
                let requestData = {
                    "reachedRank": winnerNewRank
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: talentCompany,
                    requestType: "go_to_next_rank",
                    talent: x,
                    data: requestData
                });
            }
        }
        // Add next round if tournament
        if (match.tournamentRound) {
            let tournamentWon = false;
            let tournamentWinner;
            let injuryReplacement = false;
            // If winner got injured, put loser through to next round
            const maxUnavailable = winnerParticipant.objectName === "tagTeam" && winnerParticipant.trioTagTeam ? 1 : 0;
            const injuredTeamSuperstars = winnerSuperstars.filter((x)=>x.injured > 0);
            let participantGoingThrough = injuredTeamSuperstars.length > maxUnavailable ? loserParticipants[0] : winnerParticipant;
            // Replace injured winner during annual tournament (except final)
            if (annualTournament && winnerParticipant.injured > 0 && match.tournamentRound !== tournament.rounds) {
                const activeCompanies = await (0, $iRMwH.getGameActiveCompanies)(game);
                const winnerParticipantCompany = (0, $18vSN.getAnnualTournamentParticipantOrganization)(winnerParticipant, tournament, activeCompanies);
                // Add injury to companiesData
                (0, $18vSN.addAnnualTournamentInjuredParticipantId)(tournament, winnerParticipant.$loki);
                if (winnerParticipantCompany && winnerParticipantCompany.userControlled && !simulator) {
                    // Prompt user for replacement
                    data["annualTournamentDialogData"] = await (0, $18vSN.getAnnualTournamentDialogData)(tournament, company, mainCompany, game, null);
                    // Don't add participant to next round
                    participantGoingThrough = null;
                    // Add injury message for champion
                    if ((await (0, $hBIDz.getSuperstarChampionships)(winnerParticipant)).length > 0) {
                        const newMessage = await (0, $hekDR.createPresidentChampionInjuryMessage)(winnerParticipant, game, month, year);
                        await (0, $9esFv.addCompanyMessages)(winnerParticipantCompany, [
                            newMessage
                        ]);
                    }
                } else {
                    // Select CPU replacement
                    const participantReplacement = await (0, $18vSN.getAnnualTournamentCpuReplacement)(tournament, winnerParticipantCompany, mainCompany);
                    let participantReplacementId = null;
                    // Set replacement as participant going through
                    if (participantReplacement) {
                        participantReplacementId = participantReplacement.$loki;
                        injuryReplacement = true;
                        participantGoingThrough = participantReplacement;
                    }
                    // Replace in companiesData
                    (0, $18vSN.addAnnualTournamentInjuryReplacement)(tournament, winnerParticipant.$loki, participantReplacementId);
                }
            }
            // Elimination
            if (tournament.type === "elimination" || tournament.stage === "elimination") {
                newTournamentRound = true;
                // Get next round matches, add winner to next round
                const nextRoundMatches = await (0, $46buw.getNextRoundMatches)(tournament, match.tournamentRound);
                if (nextRoundMatches.length > 0 && participantGoingThrough) {
                    await (0, $46buw.addWinnerToNextRound)(nextRoundMatches, participantGoingThrough, event, false, rosterSuperstars, annualTournament);
                    // Injury notification. Don't show if one trio member injured in tag tournament
                    if (injuredTeamSuperstars.length > maxUnavailable) data["tournamentInjury"] = {
                        injured: winnerParticipant.name,
                        "injuredPronoun": winnerParticipant.pronoun,
                        participantGoingThrough: participantGoingThrough.name,
                        tournamentName: tournament.name,
                        type: "elimination",
                        "replacement": injuryReplacement
                    };
                }
                // Check for final round
                if (match.tournamentRound === tournament.rounds) {
                    tournamentWon = true;
                    tournamentWinner = winnerParticipant;
                }
                // Substitute trio member for tag tournament injury
                if (winnerParticipant.objectName === "tagTeam" && winnerParticipant.trioTagTeam && injuredTeamSuperstars.length > 0 && participantGoingThrough && participantGoingThrough.$loki === winnerParticipant.$loki) for (const m of nextRoundMatches){
                    const mp = await (0, $i7bmn.getMatchParticipants)(m);
                    if ((0, $3E8Nt.objectInArray)(winnerParticipant, mp)) {
                        const trio = (await (0, $hBIDz.getSuperstarTagTeams)(winnerSuperstars[0])).find((x)=>x.trio);
                        const newMember = (await (0, $972Ip.getTagTeamSuperstars)(trio)).find((x)=>!(0, $3E8Nt.objectInArray)(x, winnerSuperstars));
                        // Add new member, remove old member, rename team
                        await (0, $972Ip.removeSuperstarFromTagTeam)(winnerParticipant, injuredTeamSuperstars[0]);
                        await (0, $972Ip.addTagTeamSuperstars)(winnerParticipant, [
                            newMember
                        ]);
                        const newMembers = await (0, $972Ip.getTagTeamSuperstars)(winnerParticipant);
                        winnerParticipant.name = `${trio.name} (${(0, $3E8Nt.commaSeparate)(newMembers.map((x)=>(0, $5kTkA.getSuperstarLastName)(x)))})`;
                        // Add data
                        data["tournamentSubstitution"] = {
                            injured: injuredTeamSuperstars[0].name,
                            newMember: newMember.name,
                            tournamentName: tournament.name,
                            possessivePronoun: injuredTeamSuperstars[0].possessivePronoun
                        };
                    }
                }
            }
            // Add group points
            if (tournament.type === "round-robin") {
                if (matchFinish && matchFinish["draw"]) {
                    winnerParticipant.tournamentPoints += 1;
                    loserParticipants[0].tournamentPoints += 1;
                } else winnerParticipant.tournamentPoints += 2;
                // Check for final group round
                let tournamentRounds = tournament.rounds;
                // Subtract knockout rounds if any participants advancing
                if (tournament.participantsAdvancing !== 0) tournamentRounds -= tournament.knockoutRounds;
                if (match.tournamentRound === tournamentRounds) {
                    // Check if final match of group and round
                    const roundMatches = (await (0, $4EGpv.getTournamentMatches)(tournament)).filter((x)=>x.tournamentGroup === match.tournamentGroup && x.tournamentRound === match.tournamentRound);
                    if (match.$loki === roundMatches[0].$loki) {
                        newTournamentRound = true;
                        // No knockout stage
                        if (tournament.participantsAdvancing === 0) {
                            tournamentWon = true;
                            tournamentWinner = (await (0, $46buw.getAdvancingParticipants)(tournament, match.tournamentGroup))[0];
                        } else {
                            const advancingParticipants = await (0, $46buw.getAdvancingParticipants)(tournament, match.tournamentGroup, tournament.participantsAdvancing);
                            // Add advancing participants to next round
                            const nextRoundMatches = await (0, $46buw.getNextRoundMatches)(tournament, match.tournamentRound);
                            for (const x of advancingParticipants)await (0, $46buw.addWinnerToNextRound)(nextRoundMatches, x, event, true, rosterSuperstars);
                            // Show advancing
                            data["tournamentAdvance"] = {
                                "names": advancingParticipants.map((x)=>x.name),
                                "group": match.tournamentGroup
                            };
                            // Change to elimination stage if last match of last group
                            if (match.tournamentGroup === tournament.numberOfGroups || match.tournamentGroup === 0) tournament.stage = "elimination";
                        }
                    }
                }
                // Injury notification
                if (!tournamentWon) {
                    for (const x of matchParticipants)if (unavailable.map((y)=>y["participantName"]).includes(x.name)) data["tournamentInjury"] = {
                        injured: x.name,
                        tournamentName: tournament.name,
                        type: "round-robin"
                    };
                }
            }
            // Tournament win
            if (tournamentWinner) {
                if (tournamentWinner.objectName === "superstar") await (0, $hBIDz.addSuperstarWonTournaments)(tournamentWinner, [
                    tournament
                ]);
                if (tournamentWinner.objectName === "tagTeam") await (0, $972Ip.addTagTeamWonTournaments)(tournamentWinner, [
                    tournament
                ]);
                tournament.winnerName = tournamentWinner.name;
                data["tournamentWon"] = {
                    "name": tournamentWinner.name,
                    "tournamentName": tournament.name
                };
                if (annualTournament) {
                    // Add trophy presentation segment
                    const annualTournamentWinnerSegment = (0, $18vSN.getAnnualTournamentWinnerSegmentData)(game, tournament, tournamentWinner);
                    data["matches"] = [
                        annualTournamentWinnerSegment
                    ];
                    // Update morale for annual tournament win
                    const moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                        changeType: "annual_tournament_won"
                    });
                    (0, $5kTkA.updateSuperstarMorale)(tournamentWinner, moraleChange);
                }
                // Check for tournament match contract
                const matchContracts = await (0, $4EGpv.getTournamentMatchContracts)(tournament);
                if (matchContracts.length > 0) {
                    // Add to winner
                    await (0, $1AAHK.addTalentMatchContracts)(tournamentWinner, [
                        matchContracts[0]
                    ]);
                    data["tournamentWon"]["matchContractName"] = matchContracts[0].name;
                }
            }
            // Check whether to add tournament to next event
            const tournamentEvent = await (0, $4EGpv.getTournamentEvent)(tournament);
            if (tournamentEvent && (tournamentEvent.name === "Weekly Show" || annualTournament && tournamentEvent.name[tournamentEvent.name.length - 1] === "1")) {
                const companyEvents = await (0, $9esFv.getCompanyEvents)(company);
                const nextEvent = companyEvents[companyEvents.length - 2];
                await (0, $iQtzn.addEventTournaments)(nextEvent, [
                    tournament
                ]);
            }
        }
        // Add win/loss record
        if (affectRecord) {
            winnerParticipant.wins += 1;
            winnerParticipant.winsCounter += 1;
            winnerParticipant.winsTemporary += 1;
            winnerParticipant.lossesCounter = 0;
            for (const x of loserParticipants){
                x.losses += 1;
                x.lossesCounter += 1;
                x.lossesTemporary += 1;
                x.winsCounter = 0;
                // Unlock special segment
                if (x.objectName === "superstar" && x.lossesCounter >= 10 && x.hot) {
                    let talentCompany = await (0, $3E8Nt.getTalentCompany)(x);
                    if (talentCompany) await $2d316f999b9a52df$export$330602a311ac05c5(talentCompany, "Ring Invasion", month, year);
                }
            }
        }
        // Check talent requests if not annual tournament
        if (!annualTournament) {
            // Check for clean finish requests
            if (!matchFinish || [
                "Squash",
                "Respectful End",
                "By Any Means"
            ].includes(matchFinish["name"])) {
                for (const loserParticipant of loserParticipants){
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "no_clean_loss",
                        talent: loserParticipant,
                        failRequest: true
                    });
                    let requestData = {
                        "talentId": winnerParticipant.$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "put_x_over_clean",
                        talent: loserParticipant,
                        data: requestData
                    });
                }
                let requestData = {
                    "talentId": loserParticipants[0].$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "beat_x_clean",
                    talent: winnerParticipant,
                    data: requestData
                });
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "win_and_not_lose",
                    talent: winnerParticipant,
                    secondaryAction: true
                });
            }
            // Check for winning/losing requests
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "win_next_match",
                talent: winnerParticipant
            });
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "lose_next_match",
                talent: winnerParticipant,
                failRequest: true
            });
            for (const loserParticipant of loserParticipants){
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "win_and_not_lose",
                    talent: loserParticipant,
                    failRequest: true
                });
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "lose_next_match",
                    talent: loserParticipant
                });
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "win_next_match",
                    talent: loserParticipant,
                    failRequest: true
                });
            }
            // Check for beat main eventer request
            if (await (0, $3E8Nt.getRosterMemberRank)(loserParticipants[0]) === "Main Eventer") await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "beat_main_eventer",
                talent: winnerParticipant
            });
            // Check for match request
            for (const x of matchParticipants){
                let otherParticipant = matchParticipants.find((y)=>y.$loki !== x.$loki);
                if (otherParticipant) {
                    let requestData = {
                        "talentId": otherParticipant.$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "match_with_x",
                        talent: x,
                        data: requestData
                    });
                }
            }
        }
        // Add tournament prestige data except for annual tournament, check for end of tournament
        if (tournament && !annualTournament && match.tournamentRound === tournament.rounds && (0, $98xmD.globalUser).paid) {
            // Update tournament's xp
            tournament.xp += await $2d316f999b9a52df$var$getTournamentXpChange(tournament);
            // Update tournament's prestige
            const [prestigeIncrease, prestigeDecrease] = $2d316f999b9a52df$var$updateTournamentPrestige(tournament);
            // Add prestige data
            data["tournamentPrestige"] = {
                "prestige": tournament.prestige,
                "xp": tournament.xp,
                "xpChange": tournament.xp - tournament.startingXp,
                "baseXp": (0, $3E8Nt.eventPrestigeXps)[tournament.prestige],
                "xpToNextPrestige": tournament.prestige === "C" ? 40 : 110,
                "prestigeIncrease": prestigeIncrease,
                "prestigeDecrease": prestigeDecrease,
                "finalBonus": (0, $6RCLU.getTournamentFinalBonus)(tournament)
            };
            // Update starting xp
            tournament.startingXp = tournament.xp;
        }
        // Process feuds
        let feuds = [];
        let feudItemsLevelData = [];
        let unlockedFeudItems = [];
        // Get base hype change
        let baseHypeChange = 0;
        if (match.rating !== null) {
            let ratingMultiplier = match.rating - 3;
            baseHypeChange = ratingMultiplier * 3;
            if (weeklyShow) baseHypeChange *= 0.6;
            baseHypeChange = Math.floor(baseHypeChange);
        }
        // Add match finish boost to hype change
        if (matchFinish && matchFinish["consequences"]) {
            if (matchFinish["consequences"].includes("feud_boost")) baseHypeChange += (0, $3E8Nt.getRandomInt)(20, 30);
        }
        for (const feud of matchFeuds){
            // Skip ended feuds (e.g ended in match before this)
            if (feud.ended) continue;
            // Get participants and superstars
            let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
            let feudSuperstars = (await Promise.all(feudParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            // Check hot
            let hotFeud = $2d316f999b9a52df$export$8bcffe5f50ce90df(feud, match.rating, feudSuperstars);
            let hotFeudHypeBoost = 0;
            if (hotFeud) {
                hotFeudHypeBoost = (0, $3E8Nt.getRandomInt)(15, 20);
                if (feudParticipants.map((x)=>x.name).includes(company.ownerName)) await $2d316f999b9a52df$export$330602a311ac05c5(company, "Anti-Company Rant", month, year);
            }
            let started;
            const feudItem = await (0, $jDtEn.getFeudFeudItem)(feud);
            if (!feud.started) {
                // Start feud
                started = false;
                feud.started = true;
                if (feud.startMonth === null) {
                    feud.startMonth = month;
                    feud.startYear = year;
                }
                // Remove any added blowoffs
                feud.runBlowoff = false;
                // Add hype
                let boosts = await (0, $cXLSF.getFeudCreationBoosts)(feud, feudParticipants, month, year, company.style);
                feud.hype = feudItem.baseHype + boosts["hypeBoost"];
                // Get feud started data
                feudsStarted.push({
                    "name": feud.name,
                    "participants": feudParticipants.map((x)=>x.name),
                    "boosts": boosts,
                    "baseHype": feudItem.baseHype
                });
                // Check talent request and update morale
                for (const feudParticipant of feudParticipants){
                    let otherFeudParticipant = feudParticipants.find((x)=>x.$loki !== feudParticipant.$loki);
                    if (otherFeudParticipant) {
                        // Check feud_with_x talent request
                        let requestData = {
                            "talentId": otherFeudParticipant.$loki
                        };
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "feud_with_x",
                            talent: feudParticipant,
                            data: requestData
                        });
                        // Update morale for feud started
                        let popularityDifference = await (0, $3E8Nt.getRosterMemberPopularity)(feudParticipant) - await (0, $3E8Nt.getRosterMemberPopularity)(otherFeudParticipant);
                        let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                            changeType: "feud_started",
                            popularityDifference: popularityDifference,
                            feudParticipants: [
                                feudParticipant,
                                otherFeudParticipant
                            ]
                        });
                        for (let s of (await (0, $5kTkA.getRosterMemberSuperstars)(feudParticipant)))(0, $5kTkA.updateSuperstarMorale)(s, moraleChange);
                    }
                }
            } else {
                started = true;
                let feudBlowoffTypeCheck = await (0, $cXLSF.checkFeudBlowoffMatchParticipantType)(feudParticipants, matchParticipants, type, feudItem.consequence);
                if (feud.runBlowoff && !feud.ended && feudBlowoffTypeCheck) {
                    // End feud
                    feud.ended = true;
                    feud.endMonth = month;
                    feud.endYear = year;
                    feud.runBlowoff = false;
                    // Get rating
                    feud.rating = await (0, $cXLSF.getFeudRating)(feud);
                    // Get winner and loser
                    let feudWinner = winnerParticipant;
                    let feudLoser = loserParticipants[0];
                    // Overness changes
                    if (feud.hype > 0) {
                        let overnessIncrease = Math.round(feud.hype / 20.0);
                        if (overnessIncrease > 10) overnessIncrease = 10;
                        for (let s of feudWinner.tempSuperstars)updateOverness(s, overnessIncrease);
                        let overnessDecrease = Math.round(feud.hype / 30.0) * -1;
                        if (overnessDecrease < -5) overnessDecrease = -5;
                        for (let s of feudLoser.tempSuperstars)updateOverness(s, overnessDecrease);
                    }
                    // Run consequence EA todo
                    if (feudItem.consequence) {
                        data["feudConsequenceResults"] = await (0, $cXLSF.runFeudConsequence)(feud, feudWinner, feudLoser, company, mainCompany, game, mainRoster, indieRoster, match, month, year, graphics, type);
                        const feudConsequenceResults = data["feudConsequenceResults"];
                        vacated.push(...feudConsequenceResults["vacated"]);
                        feudPotentials.push(...feudConsequenceResults["feudPotentials"]);
                        feudHypeIncreased.push(...feudConsequenceResults["feudHypeIncreased"]);
                        unlockedChampionshipSegmentItems.push(...feudConsequenceResults["unlockedChampionshipSegmentItems"]);
                        graphics = feudConsequenceResults["graphics"];
                        factionConsequences = feudConsequenceResults["factionConsequences"];
                        factionReputationsData.push(...feudConsequenceResults["factionReputationsData"]);
                        updateGraphics = true;
                    }
                    // Check to unlock special segment
                    if (feud.rating >= 4.5 && feud.name.toLowerCase().includes("family")) await $2d316f999b9a52df$export$330602a311ac05c5(company, "Car Explosion", month, year);
                    // Update faction rep
                    if (feudParticipants[0].objectName === "faction") {
                        let winningFaction;
                        for (const faction of feudParticipants){
                            let factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
                            if (feudWinner.tempSuperstars.every((s)=>(0, $3E8Nt.objectInArray)(s, factionSuperstars))) {
                                winningFaction = faction;
                                break;
                            }
                        }
                        if (winningFaction) {
                            const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                                faction: winningFaction,
                                feudWon: feud
                            });
                            if (factionData) factionReputationsData.push(factionData);
                            const losingFaction = feudParticipants.find((y)=>y.$loki !== winningFaction.$loki);
                            if (losingFaction) {
                                const factionData = await (0, $6PzHO.processFactionXpChangeForFaction)({
                                    faction: losingFaction,
                                    feudLost: feud
                                });
                                if (factionData) factionReputationsData.push(factionData);
                            }
                        }
                    }
                }
            }
            // Get feud superstars present in match
            const feudSuperstarsPresentInMatch = feudSuperstars.filter((x)=>(0, $3E8Nt.objectInArray)(x, matchSuperstars));
            // Get trait boost for feud hype change
            let feudHypeTraitBoost = 0;
            for (const feudSuperstar of feudSuperstarsPresentInMatch)for (const trait of feudSuperstar.traits){
                const traitData = (0, $aP7lq.traitsData)[trait];
                if (traitData && traitData["feud_hype_change_boost"]) feudHypeTraitBoost += traitData["feud_hype_change_boost"];
            }
            feudHypeTraitBoost = (0, $3E8Nt.limitValueBetweenRange)(feudHypeTraitBoost, -6, 6);
            // Check staleness
            let stale = false;
            let staleWarning = false;
            let stalenessHypeDecrease = 0;
            let staleFeudOvernessDecrease = 0;
            const staleLength = await (0, $cXLSF.getMatchesForStaleFeud)(feud, feudParticipants);
            // Decrease hype if stale
            if (feud.stale) stalenessHypeDecrease = Math.round(feud.stalenessCounter * -1.5);
            // Check for feud staleness
            if (feud.stalenessCounter >= staleLength && !feud.stale) {
                staleWarning = true;
                if (feud.stalenessCounter > staleLength) {
                    stale = true;
                    feud.stale = true;
                    feud.hot = false;
                    stalenessHypeDecrease = Math.round(feud.stalenessCounter ** 1.5 * -1);
                    // Decrease overness for superstars
                    staleFeudOvernessDecrease = Math.floor(feud.stalenessCounter * 2);
                    staleFeudOvernessDecrease = (0, $3E8Nt.limitValueBetweenRange)(staleFeudOvernessDecrease, staleFeudOvernessDecrease, 16);
                    staleFeudOvernessDecrease *= -1;
                    for (let s of feudSuperstars)updateOverness(s, staleFeudOvernessDecrease);
                }
            }
            // Add hype change to feud
            let feudHypeChange = baseHypeChange + hotFeudHypeBoost + feudHypeTraitBoost + stalenessHypeDecrease;
            feudHypeChange = Math.round(feudHypeChange);
            if (feudHypeChange) feud.hype += feudHypeChange;
            // Add to staleness counter
            let stalenessEffect = 1;
            if (matchFinish) stalenessEffect = matchFinish["feudStalenessEffect"];
            if (weeklyShow) stalenessEffect /= 2.0;
            feud.stalenessCounter += stalenessEffect;
            // XP/Prestige if ended
            if (feud.started && feud.ended && feud.rating !== null && (0, $98xmD.globalUser).paid) {
                let levelIncrease = false;
                let feudItemHypeIncrease = 0;
                // Add xp
                const increase = Math.floor(feud.rating ** 2);
                feudItem.xp += increase;
                // Check level increase
                if (feudItem.level < 3) {
                    if (feudItem.xp >= feudItem.level ** 2 * 40) {
                        // Increase base hype
                        feudItemHypeIncrease = feudItem.level * 5;
                        feudItem.baseHype += feudItemHypeIncrease;
                        feudItem.level += 1;
                        levelIncrease = true;
                    }
                }
                // Get data
                const feudItemLevelData = {
                    name: feudItem.name,
                    xp: feudItem.xp,
                    xpChange: increase,
                    level: feudItem.level,
                    levelIncrease: levelIncrease,
                    hypeIncrease: feudItemHypeIncrease
                };
                feudItemsLevelData.push(feudItemLevelData);
                const unlocked = $2d316f999b9a52df$export$d561132ac3e2681b(feudItem, await (0, $9esFv.getCompanyFeudItems)(company));
                unlockedFeudItems.push(...unlocked);
            }
            // Get feud data
            const feudData = {
                name: feud.name,
                participants: feudParticipants.map((x)=>x.name),
                started: started,
                runBlowoff: feud.runBlowoff,
                hype: feud.hype,
                baseHype: feud.hype - feudHypeChange,
                hypeChange: feudHypeChange,
                ended: feud.ended,
                stale: stale,
                staleWarning: staleWarning,
                rating: feud.rating,
                hot: hotFeud,
                overnessDecrease: staleFeudOvernessDecrease * -1
            };
            feuds.push(feudData);
            if (hotFeud) {
                // Increase overness for superstars
                const overnessIncrease = (0, $3E8Nt.getRandomInt)(3, 5);
                for (let s of feudSuperstars)updateOverness(s, overnessIncrease);
                feudData["overnessIncrease"] = overnessIncrease;
                // Update morale for hot feud
                for (const x of matchSuperstars){
                    const moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                        changeType: "hot_feud"
                    });
                    (0, $5kTkA.updateSuperstarMorale)(x, moraleChange);
                }
                hotFeuds.push(feudData);
            }
        }
        // Check to acquire traits
        if (rating !== null) {
            if (matchParticipants.length === 2) {
                if (!weeklyShow && rating >= 5) for (let x of matchSuperstars)await (0, $5kTkA.checkAcquireTrait)(x, "Big Match Specialist");
                if (rating >= 4 && await (0, $3E8Nt.getRosterMemberRank)(winnerParticipant) === "Upper Midcarder") for (let x of loserParticipants[0].tempSuperstars)await (0, $5kTkA.checkAcquireTrait)(x, "Star Maker");
                if (rating >= 4.5 && await (0, $3E8Nt.getRosterMemberRank)(winnerParticipant) === "Main Eventer") for (let x of loserParticipants[0].tempSuperstars)await (0, $5kTkA.checkAcquireTrait)(x, "Spotlight Lover");
                if (matchGimmick && rating >= 5) for (let x of matchSuperstars)await (0, $5kTkA.checkAcquireTrait)(x, "Match Expert", matchGimmick.name);
            }
            if (rating >= 4.5 && ratingData["positiveBoostName"]) for (let x of matchSuperstars)await (0, $5kTkA.checkAcquireTrait)(x, "Ring General");
            if (rating <= 2.5 && ratingData["negativeBoostName"]) for (let x of matchSuperstars)await (0, $5kTkA.checkAcquireTrait)(x, "Dull Worker");
        }
        if (hotMatch) for (let x of matchSuperstars)await (0, $5kTkA.checkAcquireTrait)(x, "Workhorse");
        // Check rating goal and add news
        if (!weeklyShow && rating !== null) {
            // Check goal
            if (company.userControlled) {
                let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                    name: "matches",
                    change: 1,
                    company: company,
                    rating: rating
                });
                if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
            }
            // Add news
            if (rating >= 4.5) {
                let newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: game.newsMonth,
                    year: game.newsYear,
                    superstar: winnerParticipant,
                    newsType: "high_match_rating",
                    event: event,
                    matchParticipants: matchParticipants
                });
                if (annualTournament) newsItem.companyName = "TGI";
                await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                    newsItem
                ]);
            } else if (rating < 2) {
                let newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: game.newsMonth,
                    year: game.newsYear,
                    superstar: winnerParticipant,
                    newsType: "low_match_rating",
                    event: event,
                    matchParticipants: matchParticipants
                });
                if (annualTournament) newsItem.companyName = "TGI";
                await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                    newsItem
                ]);
            }
        }
        // Process workrate xp changes
        data["workrateIncreases"] = [];
        const trainer = (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "trainer");
        const trainerLevel = trainer ? trainer.level : 1;
        let xpGained = $2d316f999b9a52df$var$getWorkrateXP(rating, match.order, trainerLevel);
        if (weeklyShow) xpGained = Math.floor(xpGained * 0.4);
        for (let p of matchParticipants)await processMatchParticipantWorkrateXp(p, xpGained);
        // Increase overness for hot match
        if (hotMatch) {
            let overnessIncrease = Math.round(8.0 / matchParticipants.length);
            if (weeklyShow) overnessIncrease = Math.round(overnessIncrease * 0.7);
            if (overnessIncrease < 1) overnessIncrease = 1;
            data["hotMatchOvernessIncrease"] = overnessIncrease;
            for (let x of matchSuperstars)updateOverness(x, overnessIncrease);
            // Update morale for hot match
            for (let x of matchSuperstars){
                let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                    changeType: "hot_match"
                });
                (0, $5kTkA.updateSuperstarMorale)(x, moraleChange);
            }
        }
        // Decrease overness for bad match
        if (match.rating !== null && match.rating < 2) {
            let overnessDecrease = Math.round(12.0 / matchParticipants.length);
            if (weeklyShow) overnessDecrease = Math.round(overnessDecrease * 0.7);
            if (overnessDecrease < 1) overnessDecrease = 1;
            overnessDecrease *= -1;
            for (let x of matchSuperstars)updateOverness(x, overnessDecrease);
        }
        // Update morale for main event
        if (mainEvent && !annualTournament) for (let x of matchSuperstars){
            let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                changeType: "main_event",
                weeklyShow: weeklyShow
            });
            (0, $5kTkA.updateSuperstarMorale)(x, moraleChange);
            // Check main event request
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "be_in_main_event",
                talent: x
            });
        }
        // Check no weekly shows request
        if (weeklyShow && !annualTournament) for (let x of matchSuperstars)await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "no_weekly_shows",
            talent: x,
            failRequest: true
        });
        // Check title match request
        if (matchChampionships.length > 0) for (let x of matchSuperstars)await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "be_in_title_match",
            talent: x
        });
        // Check morale changes
        data["moraleChanges"] = [];
        for (let p of matchParticipants){
            // Add morale change to participant's data
            let participantData;
            if (p.$loki === winnerData["uid"]) participantData = winnerData;
            else participantData = losersData.find((x)=>x["uid"] === p.$loki);
            participantData["moraleChange"] = Math.round(p.tempSuperstars.reduce((n, x)=>n + (x.morale - x.startingMorale), 0) / p.tempSuperstars.length * 10) / 10;
            // Check for morale level change for superstars
            for (const s of p.tempSuperstars){
                let startingMoraleText = (0, $3E8Nt.getMoraleText)(s.startingMorale);
                let endingMoraleText = (0, $3E8Nt.getMoraleText)(s.morale);
                if (endingMoraleText !== startingMoraleText) data["moraleChanges"].push({
                    name: s.name,
                    previousMorale: startingMoraleText,
                    currentMorale: endingMoraleText,
                    morale: s.morale
                });
                // Delete starting morale attribute
                delete s.startingMorale;
            }
        }
        // Check hot and stale changes
        data["hotChanges"] = [];
        data["staleChanges"] = [];
        data["unlockedCharacters"] = [];
        for (let p of matchParticipants){
            // Add overness change to participant's data
            let participantData;
            if (p.$loki === winnerData["uid"]) participantData = winnerData;
            else participantData = losersData.find((x)=>x["uid"] === p.$loki);
            participantData["overnessChange"] = Math.round(p.tempSuperstars.reduce((n, x)=>n + (x.overness - x.startingOverness), 0) / p.tempSuperstars.length * 10) / 10;
            // Check for overness level change for superstars
            for (const s of p.tempSuperstars){
                const startingOvernessText = (0, $3E8Nt.getOvernessText)(s.startingOverness);
                const endingOvernessText = (0, $3E8Nt.getOvernessText)(s.overness);
                if (endingOvernessText !== startingOvernessText) overnessChanges.push({
                    name: s.name,
                    previousOverness: startingOvernessText,
                    currentOverness: endingOvernessText,
                    overness: s.overness,
                    increase: s.overness > s.startingOverness
                });
                const superstarOvernessChange = s.overness - s.startingOverness;
                // Check hot
                const talentCompany = await (0, $3E8Nt.getTalentCompany)(p);
                const hotCheck = (0, $8A6FL.checkObjectHot)(s, superstarOvernessChange);
                if (hotCheck) {
                    data["hotChanges"].push({
                        name: s.name,
                        pronoun: s.possessivePronoun,
                        status: hotCheck
                    });
                    // Check for character unlock upon hot
                    if ((0, $98xmD.globalUser).paid && hotCheck === "hot") {
                        const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(s);
                        if (superstarGimmick) {
                            if (superstarGimmick.character) {
                                const unlockedCharacter = $2d316f999b9a52df$export$617c0c9711ea615a(superstarGimmick.character);
                                if (unlockedCharacter) data["unlockedCharacters"].push({
                                    name: unlockedCharacter,
                                    originalCharacter: superstarGimmick.character
                                });
                            }
                        }
                    }
                    if (hotCheck === "hot") {
                        // Add news
                        if (talentCompany) {
                            let newsItem = await (0, $kZMqI.generateNewsItem)({
                                company: talentCompany,
                                month: game.newsMonth,
                                year: game.newsYear,
                                superstar: s,
                                newsType: "over_superstar"
                            });
                            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                                newsItem
                            ]);
                        }
                        if (talentCompany && talentCompany.userControlled) {
                            // Check goal
                            let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                                name: "get over",
                                change: 1,
                                company: talentCompany,
                                superstarName: s.name
                            });
                            if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, talentCompany);
                            // Add TGI president's message
                            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 25) {
                                let annualTournamentHeld = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((y)=>y.annualTournament && y.status === "ended");
                                if (annualTournamentHeld) {
                                    const newMessage = await (0, $hekDR.createPresidentOverSuperstarMessage)(s, game, month, year);
                                    await (0, $9esFv.addCompanyMessages)(talentCompany, [
                                        newMessage
                                    ]);
                                }
                            }
                        }
                        // Update faction rep (overness change)
                        const superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                            superstar: s,
                            overnessChange: "hot"
                        });
                        factionReputationsData.push(...superstarFactionsData);
                    }
                }
                // Check stale
                const staleCheck = (0, $8A6FL.checkObjectStale)(s, superstarOvernessChange);
                if (staleCheck) {
                    data["staleChanges"].push({
                        name: s.name,
                        pronoun: s.possessivePronoun,
                        status: staleCheck
                    });
                    if (staleCheck === "stale") {
                        if (talentCompany) {
                            let newsItem = await (0, $kZMqI.generateNewsItem)({
                                company: talentCompany,
                                month: game.newsMonth,
                                year: game.newsYear,
                                superstar: s,
                                newsType: "stale_superstar"
                            });
                            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                                newsItem
                            ]);
                        }
                        // Update faction rep (overness change)
                        const superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                            superstar: s,
                            overnessChange: "stale"
                        });
                        factionReputationsData.push(...superstarFactionsData);
                    }
                }
                // Delete starting overness attribute
                delete s.startingOverness;
            }
        }
        // Run interference effects
        if (interferingMember) {
            // Add popularity to interfering member superstars
            const interferencePopularityIncrease = (0, $3E8Nt.getRandomInt)(2, 4);
            let interferingSuperstars;
            if (interferingMember.objectName === "faction") // Get available faction members not present in match
            interferingSuperstars = (await (0, $2JFAd.getFactionSuperstars)(interferingMember)).filter((y)=>(0, $5kTkA.checkSuperstarSegmentAvailability)(y) && (0, $5kTkA.checkSuperstarBrandAvailability)(event, y, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(y, companyChampionships)));
            else interferingSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(interferingMember);
            interferingSuperstars = interferingSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, matchSuperstars));
            for (const x of interferingSuperstars)x.popularity += Math.round(interferencePopularityIncrease / interferingSuperstars.length);
            data["interferencePopularityIncrease"] = interferencePopularityIncrease;
            // Get feuds for interference
            let interferingSuperstarsForFeud = [
                ...interferingSuperstars
            ];
            interferingSuperstarsForFeud.push(...matchSuperstars);
            interferingSuperstarsForFeud = (0, $3E8Nt.getUniqueObjects)(interferingSuperstarsForFeud);
            let interferingTeamsForFeud = [];
            for (const s of interferingSuperstarsForFeud)interferingTeamsForFeud.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
            interferingTeamsForFeud = (0, $3E8Nt.getUniqueObjects)(interferingTeamsForFeud);
            const interferenceFeuds = (await (0, $cXLSF.getParticipantFeuds)(interferingSuperstarsForFeud, interferingTeamsForFeud)).filter((x)=>!(0, $3E8Nt.objectInArray)(x, matchFeuds));
            // Boost interference feuds hype
            const interferenceFeudHypeIncrease = (0, $3E8Nt.getRandomInt)(1, 2);
            for (const x of interferenceFeuds)x.hype += interferenceFeudHypeIncrease;
            data["interferenceFeuds"] = interferenceFeuds.map((y)=>({
                    name: y.name,
                    hype: y.hype,
                    hypeChange: interferenceFeudHypeIncrease
                }));
        }
        // Process match finish
        if (matchFinish) {
            // Run match finish consequences
            if (matchFinish["consequences"]) {
                if (matchFinish["consequences"].includes("face_turns_heel")) {
                    for (let s of winnerSuperstars)await (0, $jpMCP.turnRosterMember)(s, "heel", company);
                    turnedHeel.push(winnerParticipant.name);
                }
                if (matchFinish["consequences"].includes("heel_turns_face")) {
                    for (let s of loserParticipants[0].tempSuperstars)await (0, $jpMCP.turnRosterMember)(s, "face", company);
                    turnedFace.push(loserParticipants[0].name);
                }
                if (matchFinish["consequences"].includes("manager_leaves_loser_and_joins_winner")) {
                    // Get managed superstars
                    let managedSuperstars = [
                        ...loserParticipants[0].tempSuperstars
                    ];
                    // Get manager
                    let managerIdSuperstar = managedSuperstars.find((s)=>{
                        return managedSuperstars.every((y)=>y.managerId === s.managerId);
                    });
                    if (managerIdSuperstar) {
                        let manager = rosterSuperstars.find((x)=>x.$loki === managerIdSuperstar.managerId);
                        if (manager) {
                            // Remove managed superstars from manager
                            await (0, $5kTkA.removeSuperstarsFromManager)(manager, managedSuperstars);
                            managersRemoved.push({
                                "managerName": manager.name,
                                "removedSuperstarsNames": managedSuperstars.map((x)=>x.name)
                            });
                            // Add superstars to manager if checks passed
                            let superstarsToManage = [
                                ...winnerSuperstars
                            ];
                            if (superstarsToManage.every((s)=>!s.managerId && !s.fullTimeManager)) {
                                await (0, $5kTkA.addSuperstarsToManager)(manager, superstarsToManage);
                                managersAdded.push({
                                    "managerName": manager.name,
                                    "managedSuperstarsNames": superstarsToManage.map((x)=>x.name)
                                });
                                // Check manager requests
                                for (let x of superstarsToManage){
                                    let requestData = {
                                        "talentId": x.$loki
                                    };
                                    await (0, $1olyO.checkTalentRequestAction)({
                                        company: company,
                                        requestType: "be_managed",
                                        talent: x
                                    });
                                    await (0, $1olyO.checkTalentRequestAction)({
                                        company: company,
                                        requestType: "manage_x",
                                        talent: manager,
                                        data: requestData
                                    });
                                }
                            }
                        }
                    }
                }
            }
            // Add company log and special finishes data
            if (matchFinish.category === "special") {
                let newLog = (0, $4K85d.CompanyLog)(month, realYear);
                newLog.text = `${matchFinish.name} Finish between ${(0, $3E8Nt.commaSeparate)(matchParticipants.map((x)=>x.name))}`;
                newLog.type = "moment";
                newLog.realYear = year;
                newLog.eventName = event.name;
                newLog.value = 6;
                await (0, $14eBR.CompanyLogs).insert(newLog);
                await (0, $9esFv.addCompanyCompanyLogs)(company, [
                    newLog
                ]);
                // Set months to re-use if not sandbox mode
                if (!company.userControlled || !game.settings["no_special_items_cooldown"]) {
                    if (!company.specialFinishesData[matchFinish.name]) company.specialFinishesData[matchFinish.name] = {
                        "months_to_reuse": 6
                    };
                    else company.specialFinishesData[matchFinish.name]["months_to_reuse"] = 6;
                }
            }
            // Add interfering member's graphic to match graphics
            const refereeSuperstar = await (0, $6RCLU.getMatchRefereeSuperstar)(match, rosterSuperstars);
            if (matchFinish["interference"] && interferingMember && graphics) {
                let interferingSuperstars;
                if (interferingMember.objectName === "faction") // Get available faction members not present in match
                interferingSuperstars = (await (0, $2JFAd.getFactionSuperstars)(interferingMember)).filter((y)=>(0, $5kTkA.checkSuperstarSegmentAvailability)(y) && (0, $5kTkA.checkSuperstarBrandAvailability)(event, y, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(y, companyChampionships)));
                else interferingSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(interferingMember);
                interferingSuperstars = interferingSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, matchSuperstars));
                for (const x of interferingSuperstars)// Don't add match manager or referee superstar's graphic
                if (!(0, $3E8Nt.objectInArray)(x, matchManagers) && (!refereeSuperstar || x.$loki !== refereeSuperstar.$loki)) {
                    let interferingSuperstarGraphic = (0, $5kTkA.getGraphicForSuperstar)(x);
                    graphics.push(interferingSuperstarGraphic);
                }
                updateGraphics = true;
            }
        }
        // Get event hype boosts
        if (hotMatch && company.userControlled && game.marketSize !== null) {
            const eventHypeBoostData = {};
            eventHypeBoostData["hypeBoost"] = 10;
            eventHypeBoostData["hotMatchBoost"] = true;
            event.hype += eventHypeBoostData["hypeBoost"];
            data["eventHype"] = event.hype;
            data["eventHypeBoostData"] = eventHypeBoostData;
        }
        // Add kayfabe points change
        for (const p of matchParticipants){
            let kayfabePointsChange = 0;
            const win = p.$loki === winnerParticipant.$loki;
            kayfabePointsChange += await (0, $5kTkA.getKayfabePointsChange)({
                changeType: `matchResult`,
                participants: matchParticipants,
                winner: winnerParticipant,
                win: win,
                weeklyShow: weeklyShow,
                match: match
            });
            if (mainEvent) kayfabePointsChange += await (0, $5kTkA.getKayfabePointsChange)({
                changeType: `mainEvent`,
                weeklyShow: weeklyShow
            });
            if (win) kayfabePointsChange += await (0, $5kTkA.getKayfabePointsChange)({
                changeType: `championships`,
                wonChampionships: winnerData["wonChampionships"],
                defendedChampionships: winnerData["defendedChampionships"]
            });
            if (kayfabePointsChange) for (const s of p.tempSuperstars)(0, $5kTkA.updateSuperstarKayfabePoints)(s, Math.floor(kayfabePointsChange / p.tempSuperstars.length));
        }
        // Get fatigue change if not disabled, update fatigue, add to results
        if (game.settings["enable_fatigue"] !== false) for (let p of matchParticipants){
            let participantFatigueChange = 0;
            for (let s of p.tempSuperstars){
                let superstarFatigueChange = (0, $5kTkA.getSuperstarFatigueChangeForMatch)(s, matchGimmick, matchParticipants, weeklyShow, type, tournament);
                (0, $5kTkA.updateSuperstarFatigue)(s, superstarFatigueChange);
                participantFatigueChange += superstarFatigueChange;
            }
            // Get average fatigue change for participant, add to participant's data
            participantFatigueChange = Math.floor(participantFatigueChange / p.tempSuperstars.length);
            let participantData;
            if (p.$loki === winnerData["uid"]) participantData = winnerData;
            else participantData = losersData.find((x)=>x["uid"] === p.$loki);
            participantData["fatigueChange"] = participantFatigueChange;
        }
        // Mark ready to return as false
        for (const x of [
            ...matchSuperstars,
            ...matchManagers
        ])if (x.readyToReturn) x.readyToReturn = false;
        // Mark hidden as false
        if (match.hidden) match.hidden = false;
        // Get data to return
        data["winner"] = winnerData;
        data["losers"] = losersData;
        data["rating"] = rating;
        data["ratingData"] = ratingData;
        data["feuds"] = feuds;
        data["feudItemsLevelData"] = feudItemsLevelData;
        data["unlockedFeudItems"] = unlockedFeudItems;
        data["championshipPrestiges"] = championshipPrestiges;
        data["finishName"] = match.finishName;
        data["finishText"] = match.finishText;
        data["matchFinish"] = matchFinish;
        data["factionReputationsData"] = factionReputationsData;
        data["factionReputationsData"].push(...winnerData["factionReputationsData"]); // Rep change for championships
        data["unavailable"] = unavailable;
        data["hairRemoved"] = hairRemoved;
        data["hairAdded"] = hairAdded;
        data["maskRemoved"] = maskRemoved;
        data["vacated"] = vacated;
        data["generatedText"] = generatedText;
        data["cashinData"] = cashinData;
        data["holyShitData"] = holyShitData;
        data["points"] = company.points;
        data["fans"] = company.fans;
        data["eventHype"] = event.hype;
        data["streaks"] = streaks;
        data["feudPotentials"] = feudPotentials;
        data["feudHypeIncreased"] = feudHypeIncreased;
        data["feudsStarted"] = feudsStarted;
        data["turnedHeel"] = turnedHeel;
        data["turnedFace"] = turnedFace;
        data["debutedGimmicks"] = debutedGimmicks;
        data["hotMatch"] = hotMatch;
        data["overnessChanges"] = overnessChanges;
        data["staffSkillIncreases"] = staffSkillIncreases;
        data["gimmickEffectivenessLevelChanges"] = gimmickEffectivenessLevelChanges;
        data["managersRemoved"] = managersRemoved;
        data["managersAdded"] = managersAdded;
        data["hotFeuds"] = hotFeuds;
        data["unlockedChampionshipSegmentItems"] = unlockedChampionshipSegmentItems;
        data["bloodySuperstarsData"] = bloodySuperstarsData;
        data["factionConsequences"] = factionConsequences;
        data["fotcChanges"] = fotcChanges;
        data["unlockedGimmickMatches"] = unlockedGimmickMatches;
        if (gimmickMatchLevelData) data["gimmickMatchLevelData"] = gimmickMatchLevelData;
        if (updateGraphics) data["graphics"] = graphics;
        // Delete tempSuperstars attribute
        for (const x of matchParticipants)delete x.tempSuperstars;
        // Get tournament matches if next round
        if (match.tournamentRound && match.tournamentRound !== tournament.rounds && !simulator) {
            if (newTournamentRound) {
                // Get matches and segments data
                let eventMatchesData = await (0, $5ZsVo.getEventMatchesData)({
                    event: event,
                    getChampionshipsAvailable: false,
                    play: true,
                    rosterSuperstars: rosterSuperstars,
                    game: game
                });
                let eventSegmentsData = await (0, $5ZsVo.getEventSegmentsData)({
                    event: event,
                    play: true,
                    rosterSuperstars: rosterSuperstars
                });
                let matchesAndSegmentsData = eventMatchesData.concat(eventSegmentsData);
                matchesAndSegmentsData.sort((a, b)=>b.order - a.order);
                matchesAndSegmentsData = matchesAndSegmentsData.filter((x)=>x["segmentType"] === "segment" ? x["rating"] === null : x["winnerName"] === null);
                data["matches"] = matchesAndSegmentsData;
            }
            data["tournamentDisplay"] = await (0, $8A6FL.getTournamentDisplayData)(tournament, game);
        }
        // Get cash in created match's data
        if (newMatch) data["createdMatch"] = await (0, $6RCLU.getMatchData)({
            match: newMatch,
            play: true,
            companyChampionships: companyChampionships,
            rosterSuperstars: rosterSuperstars,
            game: game
        });
        async function awardOrUnlockPowerup(allPowerups, unlock = false) {
            let unlockedOrAwardedPowerup;
            let dataKey;
            if (unlock) dataKey = "unlockedPowerup";
            else {
                allPowerups = allPowerups.filter((y)=>y.unlocked);
                dataKey = "awardedPowerup";
            }
            unlockedOrAwardedPowerup = (0, $kpu3X.awardPowerup)(allPowerups, unlock);
            data[dataKey] = {
                "name": unlockedOrAwardedPowerup.name,
                "level": unlockedOrAwardedPowerup.level,
                "storyName": unlockedOrAwardedPowerup.storyName
            };
            if (company.userControlled) {
                let newMessage = await (0, $hekDR.createPowerupMessage)(unlockedOrAwardedPowerup, month, year, unlock);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
        }
        async function processMatchParticipantWorkrateXp(p, xpToAdd) {
            const talentCompany = await (0, $3E8Nt.getTalentCompany)(p);
            const pSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(p);
            let participantXpGained = 0;
            for (const s of pSuperstars){
                // Check for skill xp multiplier trait
                let traitMultiplier = 1;
                for (const trait of s.traits){
                    const traitData = (0, $aP7lq.traitsData)[trait];
                    if (traitData && traitData["skill_xp_multiplier"]) traitMultiplier = traitData["skill_xp_multiplier"];
                }
                // Get and add workrate xp
                const ageMultiplier = (0, $3E8Nt.getTalentAgeMultiplier)(s);
                const superstarXpGained = Math.round(xpToAdd * ageMultiplier * traitMultiplier);
                s.workrateXp += superstarXpGained;
                participantXpGained += superstarXpGained;
                // Add workrate xp, check level increase
                const increaseData = await $2d316f999b9a52df$export$b89e809709b1a9cc(s, talentCompany, staffMembers, month, year);
                if (increaseData) data["workrateIncreases"].push({
                    name: s.name,
                    level: s.workrate
                });
            }
            participantXpGained = Math.floor(participantXpGained / pSuperstars.length);
            // Add xp gained to winner/losers data
            if (p.$loki === winnerData["uid"]) winnerData["xpGained"] = participantXpGained;
            else {
                const loserData = losersData.find((x)=>x["uid"] === p.$loki);
                if (loserData) loserData["xpGained"] = participantXpGained;
            }
        }
        async function updateSuperstarGimmickEffectiveness(s, p) {
            // Find gimmick
            const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(s);
            if (superstarGimmick) {
                const isWinner = p.$loki === winnerData["uid"];
                // Get change
                const gimmickEffectivenessChange = $2d316f999b9a52df$export$ff98fcb70ca1ca21(s, rating, match.order, weeklyShow, isWinner, 1, true, s.hot, matchFinish);
                if (gimmickEffectivenessChange !== 0) {
                    const gimmickData = $2d316f999b9a52df$export$1fd22a731a3a3817(superstarGimmick, gimmickEffectivenessChange, s);
                    // Add gimmick effectiveness level change if present
                    if (gimmickData["overnessEffectChange"]) gimmickEffectivenessLevelChanges.push(gimmickData);
                    // Add gimmick effectiveness change to participant's data
                    let participantData;
                    if (isWinner) participantData = winnerData;
                    else participantData = losersData.find((x)=>x["uid"] === p.$loki);
                    participantData["gimmickEffectivenessChange"] += gimmickEffectivenessChange;
                    // Unlock special segment
                    if (superstarGimmick.character && superstarGimmick.character === "Degenerate" && superstarGimmick.effectiveness >= 100) {
                        const talentCompany = await (0, $3E8Nt.getTalentCompany)(s);
                        if (talentCompany) await $2d316f999b9a52df$export$330602a311ac05c5(talentCompany, "Love Making", month, year);
                    }
                }
                // Remove gimmick change boost
                if (superstarGimmick.nextGimmickBoost) superstarGimmick.nextGimmickBoost = false;
            }
            return superstarGimmick;
        }
        function updateOverness(p, increase) {
            p.overness += increase;
            p.overness = (0, $3E8Nt.limitValueBetweenRange)(p.overness, 0, 100);
            return p.overness;
        }
        return data;
    } catch (err) {
        // Delete tempSuperstars attribute
        for (const x of (await (0, $i7bmn.getMatchParticipants)(match)))delete x.tempSuperstars;
        throw err;
    }
}
async function $2d316f999b9a52df$var$getMatchRating(participants, superstars, championships, gimmickMatch, match, weeklyShow, effect, matchFinish, feuds, bloodBoost, fullTimeManagerFinish, annualTournament, storyName, segmentsAndMatches) {
    let data = {};
    let ranks = {
        "Main Eventer": 0.25,
        "Jabroni": -0.25
    };
    let baseRatings = {
        1: 1.5,
        2: 3.2,
        3: 3.95,
        4: 4.25
    };
    if (storyName === "passion" && gimmickMatch && gimmickMatch.name === "Femme Fatale" && !gimmickMatch.special) {
        data["rating"] = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(450, 525), 25) / 100;
        return data;
    }
    // Add average of workrate and rank bonus
    let rating = 0;
    for (const s of superstars){
        rating += baseRatings[(0, $5kTkA.getSuperstarWorkrate)(s)] || 3.2;
        rating += ranks[(0, $5kTkA.getRankFromPopularity)(s.popularity)] || 0;
        // Get tag match workrate boost trait
        if (match.type === "tag") for (const trait of s.traits){
            let traitData = (0, $aP7lq.traitsData)[trait];
            if (traitData && traitData["tag_match_workrate_boost"]) rating += traitData["tag_match_workrate_boost"];
        }
    }
    // Add bonus for higher workrate participant again
    for (const x of participants){
        const s = await (0, $5kTkA.getRosterMemberSuperstars)(x);
        x.tempWorkrate = s.map((y)=>(0, $5kTkA.getSuperstarWorkrate)(y)).reduce((partialSum, a)=>partialSum + a, 0);
    }
    let topParticipant = (0, $3E8Nt.getArrayMaxByProperty)(participants, "tempWorkrate");
    let topParticipantSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(topParticipant);
    for (const s of topParticipantSuperstars){
        rating += baseRatings[(0, $5kTkA.getSuperstarWorkrate)(s)] || 3.2;
        rating += ranks[(0, $5kTkA.getRankFromPopularity)(s.popularity)] || 0;
    }
    rating /= superstars.length + topParticipantSuperstars.length;
    // Add deviation
    let randomDeviations = null;
    if (effect === "positive_boost") randomDeviations = [
        0.3,
        0.6
    ];
    else if (effect === "negative_boost") randomDeviations = [
        -0.3,
        -0.6
    ];
    if (randomDeviations) rating += (0, $3E8Nt.getRandomUniform)(randomDeviations[0], randomDeviations[1]);
    // Add random boost/penalty
    let randomBoosts = [
        [
            -0.75,
            2
        ],
        [
            -0.5,
            4
        ],
        [
            -0.25,
            18
        ],
        [
            0,
            52
        ],
        [
            0.25,
            18
        ],
        [
            0.5,
            4
        ],
        [
            0.75,
            2
        ]
    ];
    // Get multiplier for random boosts/penalties
    for (const superstar of superstars)for (const trait of superstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        // Add multiplier as fraction of superstars
        if (traitData && traitData["positive_match_rating_boost_multiplier"]) randomBoosts = randomBoosts.map((boost)=>boost[0] > 0.25 ? [
                boost[0],
                boost[1] * traitData["positive_match_rating_boost_multiplier"] / superstars.length
            ] : [
                boost[0],
                boost[1]
            ] // Affect boosts/penalties with names
        );
        if (traitData && traitData["negative_match_rating_boost_multiplier"]) randomBoosts = randomBoosts.map((boost)=>boost[0] < -0.25 ? [
                boost[0],
                boost[1] * traitData["negative_match_rating_boost_multiplier"] / superstars.length
            ] : [
                boost[0],
                boost[1]
            ]);
    }
    const randomBoost = (0, $3E8Nt.weightedChoice)(randomBoosts);
    rating += randomBoost;
    const matchNegativeBoosts = [
        "Indifferent Crowd",
        "Worked Against Crowd",
        "Bad Conditioning",
        "Focused On Shortcomings",
        "Lack Of Psychology",
        "No Story",
        "Stop & Start Action",
        "Slow Start",
        "Sloppy Performances",
        "Boring Spots",
        "Low Intensity"
    ];
    const matchPositiveBoosts = [
        "Crowd Interest",
        "Worked With Crowd",
        "Great Form",
        "Worked To Strengths",
        "Good Psychology",
        "Interesting Story",
        "Full Of Action",
        "Lively Start",
        "Smooth Performances",
        "Cool Spots",
        "Plenty Of Intensity"
    ];
    // Add random effect name if not squash finish
    if (!matchFinish || matchFinish && matchFinish["name"] !== "Squash") {
        if (randomBoost < -0.25) {
            data["negativeBoostName"] = (0, $3E8Nt.getRandomChoice)(matchNegativeBoosts);
            data["negativeBoostNumber"] = randomBoost;
        } else if (randomBoost > 0.25) {
            data["positiveBoostName"] = (0, $3E8Nt.getRandomChoice)(matchPositiveBoosts);
            data["positiveBoostNumber"] = randomBoost;
        }
    }
    // Add championship boost
    let championshipBoost = 0;
    for (const championship of championships)championshipBoost += $2d316f999b9a52df$var$getChampionshipBoost(championship.prestige);
    if (championshipBoost > 0.25) championshipBoost = 0.25;
    rating += championshipBoost;
    // Add gimmick boost
    let gimmickBoost = 0;
    if (gimmickMatch) {
        const ratingBoosts = {
            1: 0.1,
            2: 0.2,
            3: 0.3
        };
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70) {
            let ratingBoost = 0;
            if (gimmickMatch.ratingBoost < 1.13) ratingBoost = 1;
            else if (gimmickMatch.ratingBoost < 1.2) ratingBoost = 2;
            else ratingBoost = 3;
            gimmickBoost = ratingBoosts[ratingBoost];
            // Get trait multiplier for all superstars
            let traitGimmickMatchMultipliers = 0;
            for (const superstar of superstars)for (const trait of superstar.traits){
                let traitData = (0, $aP7lq.traitsData)[trait];
                // Get gimmick match expert trait data
                if (trait.includes("Match Expert") && gimmickMatch.name === trait.split(" Match Expert")[0]) traitData = (0, $aP7lq.traitsData)["Match Expert"];
                if (traitData && traitData["gimmick_match_multiplier"]) traitGimmickMatchMultipliers += traitData["gimmick_match_multiplier"];
            }
            // Add multiplier
            if (traitGimmickMatchMultipliers) gimmickBoost *= traitGimmickMatchMultipliers;
            // Set min/max values
            if (gimmickBoost > 1.0) gimmickBoost = 1.0;
            if (gimmickBoost < -1) gimmickBoost = -1;
        }
    }
    rating += gimmickBoost;
    // Weekly show penalty
    if (weeklyShow && !annualTournament) rating += (0, $3E8Nt.getRandomChoice)([
        -0.5,
        -0.25
    ]);
    // Get multiplier for weekly show or monthly event match rating boost
    let eventTypeRatingBoost = 0;
    for (const superstar of superstars)for (const trait of superstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (weeklyShow) {
            if (traitData && traitData["weekly_show_match_rating_boost"]) eventTypeRatingBoost += traitData["weekly_show_match_rating_boost"];
        } else if (traitData && traitData["monthly_event_match_rating_boost"]) eventTypeRatingBoost += traitData["monthly_event_match_rating_boost"];
    }
    eventTypeRatingBoost = (0, $3E8Nt.limitValueBetweenRange)(eventTypeRatingBoost, -0.8, 0.4);
    rating += eventTypeRatingBoost;
    // If any unhappy worker, lower rating by their part of the total workers
    const unhappySuperstars = superstars.filter((x)=>x.unhappy);
    if (unhappySuperstars.length > 0) {
        const unhappySuperstarsPenalty = 1.0 * unhappySuperstars.length / superstars.length;
        rating -= unhappySuperstarsPenalty;
        data["unhappySuperstarsPenalty"] = unhappySuperstarsPenalty;
    }
    // Add injury penalty
    const injuredSuperstars = superstars.filter((x)=>x.workableInjury || x.injured > 0);
    if (injuredSuperstars.length > 0) {
        const injuredSuperstarsPenalty = 1.5 * injuredSuperstars.length / superstars.length;
        rating -= injuredSuperstarsPenalty;
        data["workableInjuryPenalty"] = injuredSuperstarsPenalty;
    }
    // Add match finish penalty
    if (matchFinish) {
        const matchFinishAlreadyHeld = await $2d316f999b9a52df$var$checkMatchFinishAlreadyHeld(matchFinish, match, feuds, segmentsAndMatches);
        const matchFinishRatingEffects = $2d316f999b9a52df$var$getMatchFinishRatingEffect(matchFinish, gimmickMatch, feuds, matchFinishAlreadyHeld, fullTimeManagerFinish);
        rating += matchFinishRatingEffects["totalRatingEffect"];
        data["matchFinishRatingData"] = matchFinishRatingEffects["ratingEffects"];
    }
    // Add blood boost
    if (bloodBoost) {
        rating += bloodBoost;
        data["drewBloodBoost"] = bloodBoost;
    }
    // Add match bonuses
    const matchContractBonus = (0, $3E8Nt.limitValueBetweenRange)(match.contractBonus / 100.0, 0, 1);
    const streakBonus = (0, $3E8Nt.limitValueBetweenRange)(match.streakBonus / 100.0, 0, 1);
    const eventBonus = (0, $3E8Nt.limitValueBetweenRange)(match.eventBonus / 100.0, 0, 1);
    const tournamentFinalBonus = (0, $3E8Nt.limitValueBetweenRange)(match.tournamentFinalBonus / 100.0, 0, 1);
    rating += streakBonus + eventBonus + tournamentFinalBonus + matchContractBonus;
    // Format
    if (rating < 0) rating = 0;
    data["rating"] = (0, $3E8Nt.myround)(rating);
    // Delete tempWorkrate attribute
    for (const x of participants)delete x.tempWorkrate;
    return data;
}
function $2d316f999b9a52df$var$getMatchFinishRatingEffect(matchFinish, matchGimmick, matchFeuds, matchFinishAlreadyHeld, fullTimeManagerFinish = false) {
    const data = {};
    data["ratingEffects"] = [];
    let totalRatingEffect = 0;
    // Get rating effect
    const matchFinishRatingEffect = matchFinish["ratingEffect"];
    // Chance to remove negative rating effect if full time manager part of dusty finish
    let addRatingEffect = true;
    if (fullTimeManagerFinish && matchFinish["category"] === "dusty" && matchFinish["ratingEffect"] < 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= 60) addRatingEffect = false;
    if (addRatingEffect) {
        data["ratingEffects"].push({
            name: matchFinish["name"],
            number: matchFinishRatingEffect
        });
        totalRatingEffect += matchFinishRatingEffect;
    }
    // Get penalty for use in feud blowoff
    if (!matchFinish["changeChampionship"]) {
        if (matchFeuds.some((x)=>x.runBlowoff)) {
            const blowoffPenalty = -0.75;
            data["ratingEffects"].push({
                name: "Unsatisfying Blowoff",
                number: blowoffPenalty
            });
            totalRatingEffect += blowoffPenalty;
        }
    }
    // Get penalty for match finish already held
    if (matchFinishAlreadyHeld) {
        const alreadyHeldPenalty = -0.5;
        data["ratingEffects"].push({
            name: "Finish Already Held",
            number: alreadyHeldPenalty
        });
        totalRatingEffect += alreadyHeldPenalty;
    }
    data["totalRatingEffect"] = totalRatingEffect;
    return data;
}
async function $2d316f999b9a52df$var$checkMatchFinishAlreadyHeld(matchFinish, match, feuds, eventMatches) {
    let matchFinishAlreadyHeld = $2d316f999b9a52df$var$isMatchFinishPresent(matchFinish, match, eventMatches);
    if (!matchFinishAlreadyHeld) {
        const feudMatches = (await Promise.all(feuds.map((x)=>(0, $jDtEn.getFeudMatches)(x)))).flat();
        matchFinishAlreadyHeld = $2d316f999b9a52df$var$isMatchFinishPresent(matchFinish, match, feudMatches);
    }
    return matchFinishAlreadyHeld;
}
function $2d316f999b9a52df$var$isMatchFinishPresent(matchFinish, match, matches) {
    return matches.some((x)=>x.$loki !== match.$loki && x.rating && x.finishName === matchFinish["name"]);
}
function $2d316f999b9a52df$var$getChampionshipBoost(prestige) {
    const boosts = {
        "S": 0.25,
        "A": 0.2,
        "B": 0.15,
        "C": 0.1
    };
    return boosts[prestige] || 0.1;
}
async function $2d316f999b9a52df$var$processMatchWinnerAndLosers(winnerParticipant, loserParticipants, championships, gimmickMatch, company, match, streakEnded, tournamentFinal, lowerPopularityChange, weeklyShow, hotMatch, matchFinish, rosterSuperstars) {
    // Declare variables
    const winnerData = {};
    const losersData = [];
    const defendedChampionships = [];
    const wonChampionships = [];
    const retainedChampionships = [];
    const factionReputationsData = [];
    const changeChampionship = !matchFinish || matchFinish["changeChampionship"];
    const winnerSuperstars = winnerParticipant.tempSuperstars;
    let activeEffectIncrease = 1;
    let activeEffectDecrease = 1;
    let matchFinishWinMultiplier = 1;
    let matchFinishLossMultiplier = 1;
    let gimmickMatchIncrease = 1;
    let gimmickMatchDecrease = 1;
    let hotMatchIncrease = 1;
    let hotMatchDecrease = 1;
    let streakEndedIncrease = 1;
    let streakEndedDecrease = 1;
    let tournamentWinIncrease = 1;
    let popularityMultiplier = 1;
    // Get temp popularities
    const matchParticipants = [
        winnerParticipant,
        ...loserParticipants
    ];
    for (const x of matchParticipants)x.tempStartPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
    // Get multipliers
    if (gimmickMatch) {
        gimmickMatchIncrease = gimmickMatch.popularityIncrease;
        gimmickMatchDecrease = gimmickMatch.popularityDecrease;
        if (winnerParticipant.tempSuperstars.every((x)=>x.partTimer)) {
            gimmickMatchIncrease *= 0.5;
            gimmickMatchDecrease *= 0.5;
        }
    }
    if (hotMatch) {
        hotMatchIncrease = 1.4;
        hotMatchDecrease = -0.5;
    }
    if (streakEnded) [streakEndedIncrease, streakEndedDecrease] = $2d316f999b9a52df$var$getStreakEndedBoosts(streakEnded.length);
    if (tournamentFinal) tournamentWinIncrease = $2d316f999b9a52df$var$getTournamentWinBonus(tournamentFinal);
    if (lowerPopularityChange) popularityMultiplier = 0.4;
    if (matchFinish) {
        matchFinishWinMultiplier = matchFinish.winMultiplier;
        matchFinishLossMultiplier = matchFinish.lossMultiplier;
    }
    // Process championships
    let championshipMatchLostChange = 0;
    let championshipMatchWonChange = 0;
    for (const championship of championships){
        // Championship defense
        const winnerSuperstarsChampionships = (await Promise.all(winnerSuperstars.map((x)=>(0, $hBIDz.getSuperstarChampionships)(x)))).flat();
        if ((0, $3E8Nt.objectInArray)(championship, winnerSuperstarsChampionships)) {
            defendedChampionships.push((0, $kZwpB.getChampionshipMatchData)(championship));
            championshipMatchWonChange += (0, $8A6FL.getChampionshipPopularityIncrease)(championship, true);
            championshipMatchLostChange += (0, $8A6FL.getChampionshipPopularityDecrease)(championship, true);
        } else if (championship.vacated) {
            if (changeChampionship) {
                let championshipsSet = championship.tagTeam || championship.trio ? (await (0, $9esFv.getCompanyChampionships)(company)).filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship)) : [
                    championship
                ];
                // Add championship(s) to winner superstars
                for (const [i, c] of championshipsSet.entries()){
                    const s = winnerSuperstars[i];
                    await (0, $hBIDz.addSuperstarChampionships)(s, [
                        c
                    ]);
                    c.vacated = false;
                    // Update morale for championship win
                    const moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                        changeType: "championship_result",
                        positive: true,
                        championship: c
                    });
                    (0, $5kTkA.updateSuperstarMorale)(s, moraleChange);
                    // Update faction rep (championship won)
                    const superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                        superstar: s,
                        championshipWon: c
                    });
                    factionReputationsData.push(...superstarFactionsData);
                    // Check talent request
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "win_a_championship",
                        talent: s
                    });
                }
                wonChampionships.push((0, $kZwpB.getChampionshipMatchData)(championship));
                championshipMatchWonChange += (0, $8A6FL.getChampionshipPopularityIncrease)(championship);
            } else retainedChampionships.push((0, $kZwpB.getChampionshipMatchData)(championship));
        } else if (changeChampionship) {
            let championshipsSet = championship.tagTeam || championship.trio ? (await (0, $9esFv.getCompanyChampionships)(company)).filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship)) : [
                championship
            ];
            // Add championship(s) to winner superstars
            for (const [i, c] of championshipsSet.entries()){
                const previousChampion = await (0, $ivuOU.getChampionshipSuperstar)(c);
                const s = winnerSuperstars[i];
                await (0, $hBIDz.removeSuperstarChampionships)(previousChampion, [
                    c
                ]);
                await (0, $hBIDz.addSuperstarChampionships)(s, [
                    c
                ]);
                // Update morale for championship win/loss
                let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                    changeType: "championship_result",
                    positive: true,
                    championship: c
                });
                (0, $5kTkA.updateSuperstarMorale)(s, moraleChange);
                moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                    changeType: "championship_result",
                    positive: false,
                    championship: c
                });
                (0, $5kTkA.updateSuperstarMorale)(previousChampion, moraleChange);
                // Update faction rep (championship won/lost)
                let superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                    superstar: s,
                    championshipWon: c
                });
                factionReputationsData.push(...superstarFactionsData);
                superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                    superstar: previousChampion,
                    championshipLost: c
                });
                factionReputationsData.push(...superstarFactionsData);
                // Check talent request
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "win_a_championship",
                    talent: s
                });
                let requestData = {
                    "championshipId": c.$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "lose_championship",
                    talent: previousChampion,
                    data: requestData
                });
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "vacate_championship",
                    talent: previousChampion,
                    data: requestData,
                    failRequest: true
                });
            }
            wonChampionships.push((0, $kZwpB.getChampionshipMatchData)(championship));
            championshipMatchWonChange += (0, $8A6FL.getChampionshipPopularityIncrease)(championship);
            championshipMatchLostChange += (0, $8A6FL.getChampionshipPopularityDecrease)(championship);
        } else retainedChampionships.push((0, $kZwpB.getChampionshipMatchData)(championship));
    }
    // Get popularity changes
    const topLoserParticipant = (0, $3E8Nt.getArrayMaxByProperty)(loserParticipants, "tempStartPopularity");
    for (let x of matchParticipants)for (let s of x.tempSuperstars){
        let isWinner = x.$loki === winnerParticipant.$loki;
        let winOrLossMultiplier;
        let hotSuperstarMultiplier = 1;
        let handicapIncreaseMultiplier;
        // Get change
        let popularityChange;
        if (isWinner) {
            winOrLossMultiplier = $2d316f999b9a52df$var$getWinMultiplier((0, $5kTkA.getRankFromPopularity)(x.tempStartPopularity), (0, $5kTkA.getRankFromPopularity)(topLoserParticipant.tempStartPopularity));
            if (s.hot) hotSuperstarMultiplier = 1.3;
            popularityChange = $2d316f999b9a52df$var$getMatchPopularityIncrease(winnerParticipant.tempStartPopularity, topLoserParticipant.tempStartPopularity, winOrLossMultiplier, gimmickMatchIncrease, activeEffectIncrease, streakEndedIncrease, tournamentWinIncrease, popularityMultiplier, match.hype, weeklyShow, hotMatchIncrease, hotSuperstarMultiplier, matchFinishWinMultiplier);
            handicapIncreaseMultiplier = 1.5;
        } else {
            winOrLossMultiplier = $2d316f999b9a52df$var$getLossMultiplier((0, $5kTkA.getRankFromPopularity)(x.tempStartPopularity), (0, $5kTkA.getRankFromPopularity)(winnerParticipant.tempStartPopularity));
            if (s.hot) hotSuperstarMultiplier = 1.4;
            popularityChange = $2d316f999b9a52df$var$getMatchPopularityDecrease(x.tempStartPopularity, winnerParticipant.tempStartPopularity, winOrLossMultiplier, gimmickMatchDecrease, activeEffectDecrease, streakEndedDecrease, popularityMultiplier, weeklyShow, hotMatchDecrease, hotSuperstarMultiplier, matchFinishLossMultiplier);
            handicapIncreaseMultiplier = 1.25;
        }
        // Lower change for part timers
        if (s.partTimer) popularityChange *= 0.7;
        // Lower change for multi men match
        if (!isWinner && loserParticipants.length > 1) popularityChange *= 0.6;
        // Adjust change for handicap match
        if (loserParticipants[0].tempSuperstars.length < winnerSuperstars.length) // Lower if more winners than losers
        popularityChange *= 0.5 / (winnerSuperstars.length - loserParticipants[0].tempSuperstars.length);
        else if (loserParticipants[0].tempSuperstars.length > winnerSuperstars.length) // Raise if more losers than winners
        popularityChange *= handicapIncreaseMultiplier;
        // Add championship won/lost change
        if (isWinner) popularityChange += championshipMatchWonChange;
        else popularityChange += championshipMatchLostChange;
        // Reduce change for tag match
        if (match.type === "tag") popularityChange *= 0.5;
        popularityChange = Math.round(popularityChange);
        // Update popularity
        if (isWinner) (0, $5kTkA.updateSuperstarPopularity)(s, popularityChange);
        else (0, $5kTkA.updateSuperstarPopularity)(s, popularityChange, true, hotMatch);
    }
    // Update morale for winner
    let affectMorale = !matchFinish || matchFinish["affectMorale"];
    for (let s of winnerSuperstars){
        // Check for affect morale trait
        let affectSuperstarMoraleChance = 100;
        for (let trait of s.traits){
            let traitData = (0, $aP7lq.traitsData)[trait];
            if (traitData && traitData["win_affects_morale_chance"]) affectSuperstarMoraleChance = traitData["win_affects_morale_chance"];
        }
        // Update morale for match win
        if (affectMorale && (0, $3E8Nt.getRandomInt)(0, 100) <= affectSuperstarMoraleChance) {
            let winnerPopularityDifference = await (0, $3E8Nt.getRosterMemberPopularity)(winnerParticipant) - await (0, $3E8Nt.getRosterMemberPopularity)(topLoserParticipant);
            let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                changeType: "match_result",
                positive: true,
                popularityDifference: winnerPopularityDifference,
                matchParticipants: matchParticipants,
                weeklyShow: weeklyShow
            });
            (0, $5kTkA.updateSuperstarMorale)(s, moraleChange);
        }
    }
    // Update morale for losers
    for (let x of loserParticipants)for (let s of x.tempSuperstars){
        // Check for no morale change trait
        let affectSuperstarMorale = affectMorale;
        let affectSuperstarMoraleChance = 100;
        for (let trait of s.traits){
            let traitData = (0, $aP7lq.traitsData)[trait];
            if (traitData && traitData["no_morale_change_rank"]) {
                if ((0, $5kTkA.getRankFromPopularity)(winnerParticipant.tempStartPopularity) === traitData["no_morale_change_rank"]) // Chance to not affect morale
                {
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70) affectSuperstarMorale = false;
                }
            }
            if (traitData && traitData["no_morale_change_except_rank"]) {
                if ((0, $5kTkA.getRankFromPopularity)(winnerParticipant.tempStartPopularity) !== traitData["no_morale_change_except_rank"]) {
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70) affectSuperstarMorale = false;
                }
            }
            if (traitData && traitData["loss_affects_morale_chance"]) affectSuperstarMoraleChance = traitData["loss_affects_morale_chance"];
        }
        // Update morale for match loss
        if (affectSuperstarMorale && (0, $3E8Nt.getRandomInt)(0, 100) <= affectSuperstarMoraleChance && !match.tournamentRound) {
            let opponentPopularityDifference = await (0, $3E8Nt.getRosterMemberPopularity)(x) - await (0, $3E8Nt.getRosterMemberPopularity)(winnerParticipant);
            let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                changeType: "match_result",
                popularityDifference: opponentPopularityDifference,
                matchParticipants: matchParticipants,
                weeklyShow: weeklyShow
            });
            (0, $5kTkA.updateSuperstarMorale)(s, moraleChange);
        }
        // Update morale for championship match
        if (defendedChampionships.length > 0) {
            let moraleChange = await (0, $5kTkA.getSuperstarMoraleChange)({
                changeType: "championship_match",
                positive: true,
                championship: defendedChampionships[0]
            });
            (0, $5kTkA.updateSuperstarMorale)(s, moraleChange);
        }
    }
    // Get overness changes
    let loserParticipant = (0, $3E8Nt.getRandomChoice)(loserParticipants);
    for (const x of [
        winnerParticipant,
        loserParticipant
    ]){
        let isWinner = x.$loki === winnerParticipant.$loki;
        const participantPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
        for (const s of x.tempSuperstars){
            // Get overness change
            let overnessChange = 0;
            let overnessChangeTrait;
            let popularityChangeForOverness;
            if (isWinner) {
                popularityChangeForOverness = participantPopularity - x.tempStartPopularity;
                if (match.type === "tag") popularityChangeForOverness *= 2;
                overnessChange = $2d316f999b9a52df$var$getMatchOvernessIncrease(x, popularityChangeForOverness, s.faceOfTheCompany);
                // Add annual tournament win boost
                if (tournamentFinal && tournamentFinal.annualTournament) overnessChange += 15;
                overnessChange = Math.ceil(overnessChange / x.tempSuperstars.length);
                overnessChangeTrait = "overness_increase_multiplier";
            } else {
                popularityChangeForOverness = x.tempStartPopularity - participantPopularity;
                if (match.type === "tag") popularityChangeForOverness *= 2;
                if (!hotMatch) overnessChange = $2d316f999b9a52df$var$getMatchOvernessDecrease(x, popularityChangeForOverness, s.faceOfTheCompany);
                overnessChange = Math.floor(overnessChange / x.tempSuperstars.length);
                overnessChangeTrait = "overness_decrease_multiplier";
            }
            // Get trait multiplier for overness change
            for (const trait of s.traits){
                const traitData = (0, $aP7lq.traitsData)[trait];
                if (traitData && traitData[overnessChangeTrait]) overnessChange *= traitData[overnessChangeTrait];
            }
            // Change overness
            s.overness += Math.floor(overnessChange);
            s.overness = (0, $3E8Nt.limitValueBetweenRange)(s.overness, 0, 100);
        }
    }
    // Get data to return
    let winnerNewPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(winnerParticipant);
    winnerData["uid"] = winnerParticipant.$loki;
    winnerData["name"] = winnerParticipant.name;
    winnerData["popularityChange"] = winnerNewPopularity - winnerParticipant.tempStartPopularity;
    winnerData["popularity"] = winnerNewPopularity;
    winnerData["wonChampionships"] = wonChampionships;
    winnerData["defendedChampionships"] = defendedChampionships;
    winnerData["retainedChampionships"] = retainedChampionships;
    winnerData["gimmickEffectivenessChange"] = 0;
    winnerData["factionReputationsData"] = factionReputationsData;
    winnerData["hot"] = winnerSuperstars.every((x)=>x.hot);
    winnerData["stale"] = winnerSuperstars.every((x)=>x.stale);
    winnerData["managersData"] = await $2d316f999b9a52df$export$b2ce0bfe3182db14(winnerParticipant, match.managersUsed, rosterSuperstars);
    for (const x of loserParticipants){
        const loserData = {};
        let loserNewPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
        loserData["uid"] = x.$loki;
        loserData["name"] = x.name;
        loserData["popularityChange"] = x.tempStartPopularity - loserNewPopularity;
        loserData["popularity"] = loserNewPopularity;
        loserData["gimmickEffectivenessChange"] = 0;
        loserData["hot"] = x.tempSuperstars.every((y)=>y.hot);
        loserData["stale"] = x.tempSuperstars.every((y)=>y.stale);
        loserData["managersData"] = await $2d316f999b9a52df$export$b2ce0bfe3182db14(x, match.managersUsed, rosterSuperstars);
        losersData.push(loserData);
    }
    // Delete tempStartPopularity attributes
    for (const x of matchParticipants)delete x.tempStartPopularity;
    return [
        winnerData,
        losersData
    ];
}
async function $2d316f999b9a52df$var$checkMatchHot(match, participants, superstars) {
    let chance = 1;
    // Minimum rating
    if (match.rating < 4) return false;
    // Match rating factor
    if (match.rating >= 4.75) chance += 10;
    // Match hype factor
    chance += match.hype / 5;
    // Hot/stale superstars factor
    let hotParticipantBonus = 0;
    for (const x of superstars){
        if (x.hot) hotParticipantBonus += 8 / superstars.length;
        else if (x.stale) hotParticipantBonus -= 8 / superstars.length;
    }
    chance += hotParticipantBonus;
    // Get trait multiplier for hot match chance
    let traitBoost = 0;
    for (const superstar of superstars)for (const trait of superstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["hot_match_chance_boost"]) traitBoost += traitData["hot_match_chance_boost"];
    }
    traitBoost = (0, $3E8Nt.limitValueBetweenRange)(traitBoost, 0, 15);
    chance += traitBoost;
    // Max chance
    if (chance >= 50) chance = 50;
    if ((0, $3E8Nt.getRandomInt)(1, 100) <= chance) {
        match.hot = true;
        return true;
    }
    return false;
}
async function $2d316f999b9a52df$var$checkToAddFeud(feudItemName, feudParticipants, company, mainRoster, month, year) {
    let data = {};
    let feudItems = (await (0, $9esFv.getCompanyFeudItems)(company)).filter((y)=>y.unlocked && y.requirement === feudItemName);
    let feudItem = (0, $3E8Nt.getRandomChoice)(feudItems);
    // Check for existing feud
    let existingFeud;
    for (const f of (await (0, $cXLSF.getRosterMemberFeuds)(feudParticipants[0]))){
        if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
            if ((await (0, $jDtEn.getFeudParticipants)(f)).every((y)=>(0, $3E8Nt.objectInArray)(y, feudParticipants))) {
                existingFeud = f;
                break;
            }
        }
    }
    if (!existingFeud) {
        // Add potential feud
        let newFeud = (0, $jDtEn.Feud)();
        newFeud.name = feudItem.name;
        newFeud.hype = feudItem.baseHype;
        newFeud.startMonth = month;
        newFeud.startYear = year;
        newFeud.directFeudEvent = feudItem.requirement;
        newFeud.participants = feudParticipants.map((y)=>y.name);
        await (0, $14eBR.Feuds).insert(newFeud);
        await (0, $im36F.addFeudItemFeuds)(feudItem, [
            newFeud
        ]);
        await (0, $dl5u4.addRosterFeuds)(mainRoster, [
            newFeud
        ]);
        if (feudParticipants[0].objectName === "superstar") await (0, $jDtEn.addFeudSuperstars)(newFeud, feudParticipants);
        else if (feudParticipants[0].objectName === "tagTeam") await (0, $jDtEn.addFeudTagTeams)(newFeud, feudParticipants);
        else if (feudParticipants[0].objectName === "faction") await (0, $jDtEn.addFeudFactions)(newFeud, feudParticipants);
        data["key"] = "feudPotentials";
        data["value"] = {
            "name": newFeud.name,
            "participants": feudParticipants.map((y)=>y.name)
        };
    } else {
        // Add hype to existing feud
        let hypeIncrease = Math.floor(feudItem.baseHype / 2);
        existingFeud.hype += hypeIncrease;
        data["key"] = "feudHypeIncreased";
        data["value"] = {
            "name": existingFeud.name,
            "participants": feudParticipants.map((y)=>y.name),
            "hypeIncrease": hypeIncrease,
            "newFeud": feudItem.name
        };
    }
    return data;
}
function $2d316f999b9a52df$var$getDangerousWorkerSuperstar(opponentSuperstars) {
    return opponentSuperstars.find((x)=>{
        for (const t of x.traits){
            if ((0, $aP7lq.traitsData)[t] && (0, $aP7lq.traitsData)[t]["cause_injury_chance_multiplier"]) return true;
        }
    });
}
function $2d316f999b9a52df$export$401884867da6aea9(matchOrSegmentGraphics, s) {
    // Update superstar's graphic dict in matchOrSegmentGraphics. Add title, uid, blood to dict.
    const participantGraphic = matchOrSegmentGraphics.find((x)=>x && x["uid"] === s.$loki);
    const participantGraphicIndex = matchOrSegmentGraphics.indexOf(participantGraphic);
    if (participantGraphic) {
        const titleGraphic = participantGraphic["title"];
        const uidGraphic = participantGraphic["uid"];
        const bloodGraphic = participantGraphic["blood"];
        matchOrSegmentGraphics[participantGraphicIndex] = (0, $5kTkA.getGraphicForSuperstar)(s);
        if (titleGraphic) matchOrSegmentGraphics[participantGraphicIndex].title = titleGraphic;
        matchOrSegmentGraphics[participantGraphicIndex].uid = uidGraphic;
        matchOrSegmentGraphics[participantGraphicIndex].blood = bloodGraphic;
    }
    return matchOrSegmentGraphics;
}
function $2d316f999b9a52df$var$checkGimmickMatchesToUnlock(gimmickMatch, gimmickMatches) {
    // Check for gimmick match unlocks, returning unlocked
    const unlocked = [];
    const toUnlockNames = (0, $5qFpQ.gimmickMatchUnlocksData)[gimmickMatch.name] || [];
    for (const toUnlockName of toUnlockNames){
        const gimmickMatchToUnlock = gimmickMatches.find((x)=>x.name === toUnlockName);
        if (gimmickMatchToUnlock && !gimmickMatchToUnlock.available && gimmickMatch.level === 3) {
            gimmickMatchToUnlock.available = true;
            unlocked.push(gimmickMatchToUnlock.name);
        }
    }
    return unlocked;
}
function $2d316f999b9a52df$var$addPerkToGimmickMatch(gimmickMatch, perk = null) {
    const perks = [
        "rating",
        "injury",
        "popularity",
        "cost"
    ];
    if (perk === null) perk = (0, $3E8Nt.getRandomChoice)(perks);
    if (perk === "rating") gimmickMatch.ratingBoost += gimmickMatch.level / 15.0;
    else if (perk === "injury") gimmickMatch.injuryRate -= gimmickMatch.level / 23.0;
    else if (perk === "popularity") {
        gimmickMatch.popularityIncrease += gimmickMatch.level / 5.0;
        gimmickMatch.popularityDecrease -= gimmickMatch.level / 12.0;
    } else if (perk === "cost") {
        const decrease = (0, $3E8Nt.myround)(gimmickMatch.level * 0.12 * gimmickMatch.cost, 5);
        gimmickMatch.cost -= decrease;
        if (gimmickMatch.cost < 5) gimmickMatch.cost = 5;
    }
    return perk;
}
function $2d316f999b9a52df$var$generateIronmanMatchText() {
    return (0, $3E8Nt.getRandomChoice)([
        "1-0",
        "2-1",
        "3-1",
        "4-1",
        "3-2",
        "4-2",
        "4-3",
        "5-4"
    ]);
}
function $2d316f999b9a52df$var$generateEliminationMatchResult(winnerParticipant, participants) {
    const matchTexts = [];
    const participantsData = participants.map((p)=>({
            "participant": p,
            "superstars": [
                ...p.tempSuperstars
            ]
        }));
    const winnerParticipantData = participantsData.find((x)=>x["participant"].$loki === winnerParticipant.$loki);
    const showSurvivors = winnerParticipantData["superstars"].length > 1;
    function eliminateSuperstar() {
        // Get superstar to eliminate from participants, except last superstar of winner
        let p = (0, $3E8Nt.getRandomChoice)(participantsData);
        while(p === winnerParticipantData && p["superstars"].length < 2)p = (0, $3E8Nt.getRandomChoice)(participantsData);
        const superstarToEliminate = (0, $3E8Nt.getRandomChoice)(p["superstars"]);
        // Remove superstar, remove participant if all superstars eliminated
        p["superstars"].splice(p["superstars"].indexOf(superstarToEliminate), 1);
        if (p["superstars"].length < 1) participantsData.splice(participantsData.indexOf(p), 1);
        // Get elimination text
        const eliminatedByParticipant = (0, $3E8Nt.getRandomChoice)(participantsData.filter((y)=>y !== p));
        const eliminatedBy = (0, $3E8Nt.getRandomChoice)(eliminatedByParticipant["superstars"]);
        const text = `${eliminatedBy.name} eliminated ${superstarToEliminate.name}`;
        return [
            superstarToEliminate,
            text
        ];
    }
    try {
        // Run eliminations until one participant remains
        while(participantsData.length > 1){
            const [eliminatedSuperstar, text] = eliminateSuperstar();
            matchTexts.push(text);
        }
        // Show survivors if winner is not a single superstar
        if (showSurvivors) {
            const survivorNames = winnerParticipantData["superstars"].map((x)=>x.name);
            const survivorWord = survivorNames.length > 1 ? "Survivors" : "Survivor";
            const text = `${survivorWord}: ${(0, $3E8Nt.commaSeparate)(survivorNames)}`;
            matchTexts.push(text);
        }
    } catch (err) {
        (0, $3E8Nt.captureError)(err);
    }
    return matchTexts.join(" ... ");
}
function $2d316f999b9a52df$var$generateTwoOutOfThreeFallsResult(winnerParticipant, participants, fallGimmickNames = null) {
    const matchTexts = [];
    try {
        // Select whether to run 2 or 3 falls
        const fallsToRun = (0, $3E8Nt.weightedChoice)([
            [
                3,
                90
            ],
            [
                2,
                10
            ]
        ]);
        let fallWinner;
        for (let x of Array(fallsToRun).keys()){
            if (fallsToRun === 3) {
                if (x === 0) // Choose random participant for first fall
                fallWinner = (0, $3E8Nt.getRandomChoice)(participants);
                else if (x === 1) // Choose other participant for second fall
                fallWinner = participants.find((p)=>p.$loki !== fallWinner.$loki);
                else if (x === 2) // Choose winner for final fall
                fallWinner = winnerParticipant;
            } else // Choose winner for all falls if 2 falls
            fallWinner = winnerParticipant;
            // Get fall and gimmick text
            const fallNumber = x + 1;
            const fallNumberText = {
                1: "st",
                2: "nd",
                3: "rd"
            }[fallNumber];
            const gimmickText = fallGimmickNames && fallGimmickNames[x] ? ` (${fallGimmickNames[x]} Match)` : "";
            // Get fall text
            const fallText = `${fallWinner.name} won the ${fallNumber}${fallNumberText} fall${gimmickText}`;
            matchTexts.push(fallText);
        }
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    return matchTexts.join(" ... ");
}
async function $2d316f999b9a52df$var$generateBattleRoyalMatchResult(match, winnerParticipant, matchType, allParticipants, allSuperstars) {
    // Declare variables
    let data = [];
    let entryData = {};
    let inMatch = [];
    let eliminated = [];
    let finalFourDisplayed = false;
    let loserParticipants = allParticipants.filter((x)=>x.$loki !== winnerParticipant.$loki);
    let loserSuperstars = loserParticipants.flatMap((x)=>x.tempSuperstars);
    // Helper function to eliminate superstar
    async function eliminateSuperstar(matchSuperstars) {
        // Choose who is eliminated from loser superstars
        let choices = matchSuperstars.filter((x)=>(0, $3E8Nt.objectInArray)(x, loserSuperstars));
        let s = (0, $3E8Nt.getRandomChoice)(choices);
        matchSuperstars.splice(matchSuperstars.indexOf(s), 1);
        const text = `${(0, $3E8Nt.getRandomChoice)(matchSuperstars).name} eliminated ${s.name} (${entryData[s.$loki]})`;
        return [
            s,
            text
        ];
    }
    function getParticipantFromId(id) {
        return allSuperstars.find((x)=>x.$loki === parseInt(id));
    }
    // Get entry numbers, final number
    let entryNumbers = (0, $3E8Nt.range)(allSuperstars.length, 1);
    let finalNumber;
    if (matchType === "singles") finalNumber = 1;
    else if (winnerParticipant.trio) finalNumber = 3;
    else finalNumber = 2;
    // Randomize entries and assign to superstars
    (0, $3E8Nt.shuffle)(entryNumbers);
    for (const x of allSuperstars)entryData[x.$loki] = entryNumbers.pop();
    // Sort by entry order
    const sortedEntryData = Object.entries(entryData).sort((a, b)=>a[1] - b[1]);
    // First two entries to start the match
    for (const [participantId, entryNumber] of sortedEntryData.slice(0, 2)){
        const participant = getParticipantFromId(participantId);
        inMatch.push(participant);
        data.push(`${participant.name} entered at No ${entryNumber}.`);
    }
    // Enter the rest of the superstars
    for (const [participantId, entryNumber] of sortedEntryData.slice(2)){
        const participant = getParticipantFromId(participantId);
        inMatch.push(participant);
        data.push(`${participant.name} entered at No ${entryNumber}.`);
        // Eliminate a participant or continue to next entry
        let pick = Math.random();
        while(pick < 0.4 && inMatch.length > finalNumber){
            // being in the same winning team, bugging eliminateSuperstar
            // Eliminate
            const [eliminatedSuperstar, text] = await eliminateSuperstar(inMatch);
            eliminated.push(eliminatedSuperstar);
            data.push(text);
            pick = Math.random();
            // Display final four
            if (inMatch.length === 4 && eliminated.length === allSuperstars.length - 4 && !finalFourDisplayed) {
                data.push(`Final Four: ${inMatch.map((x)=>x.name).join(", ")}.`);
                finalFourDisplayed = true;
            }
        }
    }
    // Once all superstars have entered
    while(inMatch.length > finalNumber){
        // Eliminate
        const [eliminatedSuperstar, text] = await eliminateSuperstar(inMatch);
        eliminated.push(eliminatedSuperstar);
        data.push(text);
        // Display final four
        if (inMatch.length === 4 && !finalFourDisplayed) {
            data.push(`Final Four: ${inMatch.map((x)=>x.name).join(", ")}.`);
            finalFourDisplayed = true;
        }
    }
    // Format text
    const text = [];
    let winnerTexts = 0;
    for (let [index, item] of data.entries()){
        let addedEllipses = false;
        if (index === data.length - 5 || [
            8,
            24,
            44
        ].includes(index)) {
            addedEllipses = true;
            text.push("...");
        }
        // Add winner texts
        if (item.includes(winnerParticipant.name) && winnerTexts < 7) {
            if (2 < index && index < data.length - 5 && !addedEllipses) text.push("...");
            text.push(item);
            winnerTexts += 1;
        } else if (index < 2 || 7 < index && index < 10 || 23 < index && index < 26 || 43 < index && index < 46 || index >= data.length - 5) text.push(item);
        else if (item.includes("No 30")) {
            if (!addedEllipses) text.push("...");
            text.push(item);
        }
    }
    return text.join(" ");
}
function $2d316f999b9a52df$var$updateTournamentPrestige(tournament) {
    let prestigeIncrease = false;
    let prestigeDecrease = false;
    if (tournament.xp >= 110 && tournament.prestige !== "A") {
        tournament.prestige = "A";
        tournament.cost += 50;
        prestigeIncrease = true;
    } else if (40 <= tournament.xp && tournament.xp < 110 && tournament.prestige !== "B") {
        if (tournament.prestige === "A") {
            tournament.cost -= 50;
            prestigeDecrease = true;
        } else {
            tournament.cost += 50;
            prestigeIncrease = true;
        }
        tournament.prestige = "B";
    } else if (tournament.xp < 40 && tournament.prestige !== "C") {
        tournament.prestige = "C";
        tournament.cost -= 50;
        prestigeDecrease = true;
    }
    return [
        prestigeIncrease,
        prestigeDecrease
    ];
}
async function $2d316f999b9a52df$var$getTournamentXpChange(tournament) {
    let xpChange;
    const tournamentRating = await $2d316f999b9a52df$var$getTournamentRating(tournament);
    if (tournamentRating < 3.5) xpChange = (4 - tournamentRating) * -10;
    else if (tournamentRating < 5) xpChange = (3 - tournamentRating) * -15;
    else xpChange = (2.5 - tournamentRating) * -15;
    return Math.floor(xpChange);
}
async function $2d316f999b9a52df$var$getTournamentRating(tournament) {
    let tournamentMatches = await (0, $4EGpv.getTournamentMatches)(tournament);
    tournamentMatches = tournamentMatches.filter((x)=>x.rating !== null);
    if (tournamentMatches.length <= 0) return 0;
    // Add main event weight (2x)
    if (tournamentMatches.length) tournamentMatches.push(tournamentMatches[tournamentMatches.length - 1]);
    const average = tournamentMatches.reduce((sum, match)=>sum + match.rating, 0) / tournamentMatches.length;
    return (0, $3E8Nt.myround)(average, 0.25);
}
function $2d316f999b9a52df$export$8bcffe5f50ce90df(feud, rating, superstars) {
    let chance = 0;
    // No chance to get hot if already hot, not started or ended
    if (feud.hot || !feud.started || feud.ended || rating < 3.5) return false;
    // No chance if stale
    if (feud.stale) return false;
    // Minimum hype
    if (feud.hype < 30) return false;
    // Feud hype factor
    const increase = (feud.hype - 15) / 4;
    chance += increase;
    // Hot superstars factor
    let hotParticipantBonus = 0;
    for (const x of superstars){
        if (x.hot) hotParticipantBonus += 10 / superstars.length;
        else if (x.stale) hotParticipantBonus += -10 / superstars.length;
    }
    chance += hotParticipantBonus;
    // Get trait multiplier for hot feud chance
    let traitBoost = 0;
    for (const superstar of superstars)for (const trait of superstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["hot_feud_chance_boost"]) traitBoost += traitData["hot_feud_chance_boost"];
    }
    traitBoost = (0, $3E8Nt.limitValueBetweenRange)(traitBoost, -20, 20);
    chance += traitBoost;
    // Max chance
    if (chance >= 50) chance = 50;
    if ((0, $3E8Nt.getRandomInt)(1, 100) <= chance) {
        feud.hot = true;
        return true;
    }
    return false;
}
function $2d316f999b9a52df$export$d561132ac3e2681b(feudItem, feudItems) {
    // Check for feud item unlocks, returning unlocked
    const unlocked = [];
    const unlocksDict = {
        "New Challenger": "That's My Title",
        "Who's the Best?": "Innovation",
        "Taking My Spot": "It's My Time Now",
        "This Is Our Home": "Us vs Them",
        "Better Wrestler": "Greatest Wrestler",
        "Retire Me": "Streak vs Career",
        "Stepping Up": "Legend Killer",
        "Friendly Contest": "Redemption",
        "Better Villain": "Corruption",
        "Main Event Ready": "Best in the World",
        "Rivals": "Bitter Rivals"
    };
    const toUnlockName = unlocksDict[feudItem.name];
    if (toUnlockName) {
        const feudItemToUnlock = feudItems.find((x)=>x.name === toUnlockName);
        if (feudItemToUnlock && !feudItemToUnlock.unlocked && feudItem.level === 3) {
            feudItemToUnlock.unlocked = true;
            unlocked.push(feudItemToUnlock.name);
        }
    }
    return unlocked;
}
async function $2d316f999b9a52df$export$330602a311ac05c5(company, segmentItemName, month, year, addMessage = true) {
    const segmentItem = (await (0, $9esFv.getCompanySegmentItems)(company)).find((x)=>x.name === segmentItemName);
    const user = (0, $bZol7.loadUser)();
    if ((0, $98xmD.globalUser).paid && company.storyName !== "mars") {
        if (segmentItem && !segmentItem.unlocked) {
            segmentItem.unlocked = true;
            // Add unlock message
            if (company.userControlled && addMessage) {
                const newMessage = await (0, $hekDR.createSpecialSegmentUnlockedMessage)(segmentItem, month, year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            // Add unlocked segment to user
            if (!user.unlockedSegments.includes(segmentItem.name)) {
                user.unlockedSegments.push(segmentItem.name);
                (0, $bZol7.saveUser)(user);
            }
        }
    }
    return true;
}
function $2d316f999b9a52df$var$getWorkrateXP(rating, order, trainerLevel) {
    const baseXPs = {
        1: 4,
        2: 5.5,
        3: 7
    };
    let baseXP = baseXPs[trainerLevel] || 7;
    if (order === 0) baseXP += 2;
    if (rating >= 4.5) baseXP += 2;
    else if (rating <= 2) baseXP -= 2;
    return Math.floor(baseXP);
}
async function $2d316f999b9a52df$export$b89e809709b1a9cc(superstar, company, staffMembers, month, year) {
    const xps = {
        2: 300,
        1: 100
    };
    let levelIncrease = false;
    if (superstar.workrate < 3 && superstar.workrateXp >= (xps[superstar.workrate] || 300)) {
        superstar.workrate += 1;
        levelIncrease = true;
        // Add level up message
        if (company && company.userControlled) {
            const trainer = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "trainer");
            const newMessage = await (0, $hekDR.createSuperstarLevelUpMessage)(trainer, superstar, "workrate", month, year);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
    }
    return levelIncrease;
}
function $2d316f999b9a52df$export$617c0c9711ea615a(character) {
    let unlockedCharacters = [];
    const user = (0, $bZol7.loadUser)();
    if (user) unlockedCharacters = user.unlockedCharacters;
    const unlocksDict = {
        "Punk": "Abstainer",
        "Rich Person": "Degenerate",
        "Spot Monkey": "Enigma",
        "Singer": "Rapper",
        "Musician": "Rockstar",
        "Occultist": "Cult Leader",
        "Big Shot": "Drug Lord",
        "VIP": "Royalty",
        "Demon": "Undead",
        "Philosophist": "Game Dev.",
        "Game Dev.": "Martian"
    };
    const toUnlock = unlocksDict[character];
    if (toUnlock) {
        const characterToUnlock = (0, $fuJHb.charactersData).find((x)=>x["name"] === toUnlock)?.name;
        if (characterToUnlock && !unlockedCharacters.includes(characterToUnlock)) {
            unlockedCharacters.push(characterToUnlock);
            (0, $bZol7.saveUser)(user);
            return characterToUnlock;
        }
    }
    return null;
}
function $2d316f999b9a52df$export$ff98fcb70ca1ca21(superstar, rating, order, weeklyShow, isWinner, boost = 1, match = false, hot = false, matchFinish = null) {
    // 1 boost is default for match, segments have custom boost
    let change = 0;
    if (rating !== null) {
        if (rating >= 4.25) {
            change += 2;
            if (order === 0) change += 1;
        } else if (rating < 2) {
            change -= 2;
            if (order === 0) change -= 1;
        }
    }
    // Add boost for match winner/loser
    if (match) {
        if (!matchFinish || matchFinish["affectRecord"]) {
            if (isWinner) change += boost;
            else change -= boost;
        }
    } else // Add boost for segment winner, if any
    if (isWinner) {
        if (rating >= 4) change += boost;
        else if (rating <= 2.5) change -= boost;
    }
    // Add hot multiplier
    if (hot) change *= 1.5;
    // Reduce change for weekly show matches
    if (weeklyShow && match) {
        if (change > 1) change *= 0.6;
    }
    // Get trait multiplier for overness change
    for (const trait of superstar.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["gimmick_effectiveness_increase_multiplier"]) {
            if (change > 0) change *= traitData["gimmick_effectiveness_increase_multiplier"];
        }
        if (traitData && traitData["gimmick_effectiveness_decrease_multiplier"]) {
            if (change < 0) change *= traitData["gimmick_effectiveness_decrease_multiplier"];
        }
    }
    change = (0, $3E8Nt.limitValueBetweenRange)(change, -10, 10);
    if (change > 10) change = 10;
    if (change < -10) change = -10;
    return Math.round(change);
}
function $2d316f999b9a52df$export$1fd22a731a3a3817(gimmick, change, superstar) {
    const oldOvernessEffect = (0, $5kTkA.getGimmickEffectivenessEffect)(gimmick.effectiveness);
    gimmick.effectiveness += change;
    gimmick.effectiveness = (0, $3E8Nt.limitValueBetweenRange)(gimmick.effectiveness, 0, 100);
    const newOvernessEffect = (0, $5kTkA.getGimmickEffectivenessEffect)(gimmick.effectiveness);
    // Add overness effect
    if (oldOvernessEffect !== newOvernessEffect) {
        superstar.overness -= oldOvernessEffect;
        superstar.overness += newOvernessEffect;
    }
    return {
        effectivenessChange: change,
        effectiveness: gimmick.effectiveness,
        name: gimmick.name,
        superstarName: superstar.name,
        overnessEffectChange: newOvernessEffect - oldOvernessEffect
    };
}
function $2d316f999b9a52df$var$getStreakEndedBoosts(length) {
    // No bonus
    if (length < 2) return [
        1,
        1
    ];
    else if (length < 5) return [
        1.4,
        1.4
    ];
    else if (length < 10) return [
        2.0,
        2.0
    ];
    else if (length < 20) return [
        3.4,
        2.8
    ];
    else return [
        6.0,
        4.0
    ];
}
function $2d316f999b9a52df$var$getTournamentWinBonus(tournament) {
    const bonuses = {
        "A": 2.3,
        "B": 1.7,
        "C": 1.3
    };
    let bonus = bonuses[tournament.prestige] || 1.2;
    if (tournament.annualTournament) bonus = 4;
    return bonus;
}
function $2d316f999b9a52df$var$getWinMultiplier(rank1, rank2) {
    const ranks = {
        "Main Eventer": 4,
        "Upper Midcarder": 3,
        "Lower Midcarder": 2,
        "Jabroni": 1
    };
    if (ranks[rank1] <= ranks[rank2]) return 1.5;
    else return -1;
}
function $2d316f999b9a52df$var$getLossMultiplier(rank1, rank2) {
    const ranks = {
        "Main Eventer": 4,
        "Upper Midcarder": 3,
        "Lower Midcarder": 2,
        "Jabroni": 1
    };
    if (ranks[rank1] === ranks[rank2]) return 1;
    else if (ranks[rank1] >= ranks[rank2]) return 1.25;
    else return -1;
}
function $2d316f999b9a52df$var$getMatchPopularityIncrease(pop1, pop2, multiplier, gimmickMatchMultiplier = 1, activeEffectBoost = 1, streakEndedBoost = 1, tournamentWinIncrease = 1, popularityMultiplier = 1, matchHype = 0, weeklyShow = false, hotMatchIncrease = 1, hotSuperstarIncrease = 1, matchFinishWinMultiplier = 1) {
    const difference = Math.abs(pop1 - pop2);
    let increase;
    if (pop1 > pop2) increase = 12 + (0, $3E8Nt.getRandomInt)(-2, 2);
    else {
        if (difference <= 100) increase = 14 + Math.floor(difference / 20) + (0, $3E8Nt.getRandomInt)(-2, 2);
        else if (multiplier === -1) increase = 15 + (0, $3E8Nt.getRandomInt)(-1, 1);
        else increase = Math.floor(Math.floor(difference / 11) * multiplier);
    }
    increase = increase * gimmickMatchMultiplier * activeEffectBoost * streakEndedBoost * tournamentWinIncrease * popularityMultiplier * hotMatchIncrease * hotSuperstarIncrease * matchFinishWinMultiplier;
    increase += matchHype / 5.0;
    // Maximum increase
    if (increase > 80) increase = 80;
    if (weeklyShow) {
        if (hotMatchIncrease > 1) increase *= 0.7;
        else increase *= 0.4;
    }
    return Math.floor(increase);
}
function $2d316f999b9a52df$var$getMatchPopularityDecrease(pop1, pop2, multiplier, gimmickMatchMultiplier = 1, activeEffectBoost = 1, streakEndedBoost = 1, popularityMultiplier = 1, weeklyShow = false, hotMatchDecrease = 1, hotSuperstarDecrease = 1, matchFinishLossMultiplier = 1) {
    const difference = Math.abs(pop1 - pop2);
    let decrease;
    if (pop2 > pop1 || matchFinishLossMultiplier < 0) decrease = 10 + (0, $3E8Nt.getRandomInt)(-2, 2);
    else {
        if (difference <= 100) decrease = 12 + Math.floor(difference / 20) + (0, $3E8Nt.getRandomInt)(-2, 2);
        else if (multiplier === -1) decrease = 12 + (0, $3E8Nt.getRandomInt)(-1, 1);
        else decrease = Math.floor(Math.floor(difference / 11) * multiplier);
    }
    decrease = decrease * gimmickMatchMultiplier * activeEffectBoost * streakEndedBoost * popularityMultiplier * hotMatchDecrease * hotSuperstarDecrease * matchFinishLossMultiplier;
    // Ensure negative value
    if (matchFinishLossMultiplier < 0 && hotMatchDecrease < 0) {
        if (decrease > 0) decrease *= -1;
    }
    // Add hot match boost
    if (hotMatchDecrease < 0) {
        decrease -= (0, $3E8Nt.getRandomInt)(6, 10);
        if (pop2 > pop1 && difference > 50) decrease -= (0, $3E8Nt.getRandomInt)(12, 16);
    }
    // Maximum decrease
    if (decrease > 80) decrease = 80;
    if (weeklyShow) {
        if (hotMatchDecrease < 0) decrease *= 0.7;
        else decrease *= 0.4;
    }
    return Math.floor(decrease);
}
function $2d316f999b9a52df$var$getMatchOvernessIncrease(participant, popularityIncrease, fotc = false) {
    let hot = participant.tempSuperstars.every((x)=>x.hot);
    let stale = participant.tempSuperstars.every((x)=>x.stale);
    let overnessIncrease;
    if (fotc) {
        if (hot) overnessIncrease = Math.floor(popularityIncrease / 7.0);
        else if (stale) overnessIncrease = Math.floor(popularityIncrease / 3.0);
        else overnessIncrease = Math.floor(popularityIncrease / 5.0);
    } else {
        // Popularity change will be high for hot superstar, since it increases, so use higher divisor here
        if (hot) overnessIncrease = Math.floor(popularityIncrease / 15.0);
        else if (stale) overnessIncrease = Math.floor(popularityIncrease / 4.0);
        else overnessIncrease = Math.floor(popularityIncrease / 10.0);
    }
    if (overnessIncrease > 10) overnessIncrease = 10;
    return overnessIncrease;
}
function $2d316f999b9a52df$var$getMatchOvernessDecrease(participant, popularityDecrease, fotc = false) {
    let hot = participant.tempSuperstars.every((x)=>x.hot);
    let overnessDecrease;
    if (fotc) {
        if (hot) overnessDecrease = Math.floor(popularityDecrease / 2.0);
        else overnessDecrease = Math.floor(popularityDecrease / 4.0);
    } else if (hot) overnessDecrease = Math.floor(popularityDecrease / 5.0);
    else overnessDecrease = Math.floor(popularityDecrease / 10.0);
    if (overnessDecrease > 8) overnessDecrease = 8;
    return overnessDecrease * -1;
}
async function $2d316f999b9a52df$export$b2ce0bfe3182db14(participant, managersUsed, rosterSuperstars = null) {
    // Gets managers data for match/segment participant to show in results
    const managersData = [];
    for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(participant))){
        const manager = await (0, $5kTkA.getSuperstarManagerUsedForMatchOrSegment)(s, managersUsed, rosterSuperstars);
        if (manager) {
            const participantManagerData = {
                "name": manager.name,
                "fullTimeManager": manager.fullTimeManager
            };
            if (!managersData.includes(participantManagerData)) managersData.push(participantManagerData);
        }
    }
    return managersData;
}

});
parcelRequire.register("6hwt2", function(module, exports) {

$parcel$export(module.exports, "matchFinishesData", () => $492d83f8c394934d$export$276c315050e7f6d8);
const $492d83f8c394934d$export$276c315050e7f6d8 = [
    {
        "name": "Interference DQ",
        "description": "An interference causes a participant to get disqualified.",
        "cost": 0,
        "winMultiplier": 0.1,
        "lossMultiplier": 0.0,
        "ratingEffect": -1,
        "changeChampionship": false,
        "affectRecord": true,
        "affectMorale": false,
        "feudStalenessEffect": 0.5,
        "category": "dusty",
        "interference": true
    },
    {
        "name": "DQ",
        "description": "A participant gets disqualified for using unfair means.",
        "cost": 0,
        "winMultiplier": 0.1,
        "lossMultiplier": 0.0,
        "ratingEffect": -1,
        "changeChampionship": false,
        "affectRecord": true,
        "affectMorale": false,
        "feudStalenessEffect": 0.5,
        "category": "dusty",
        "interference": false
    },
    {
        "name": "Cheating",
        "description": "A participant uses illegal tactics to win.",
        "cost": 0,
        "winMultiplier": 0.5,
        "lossMultiplier": 0.4,
        "ratingEffect": -0.5,
        "changeChampionship": true,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 0.75,
        "category": "dusty",
        "interference": false
    },
    {
        "name": "Distraction",
        "description": "A roster member's distraction causes a participant to lose.",
        "cost": 0,
        "winMultiplier": 0.5,
        "lossMultiplier": 0.4,
        "ratingEffect": -0.5,
        "changeChampionship": true,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 1.0,
        "category": "dusty",
        "interference": true
    },
    {
        "name": "Countout",
        "description": "A participant wins by countout.",
        "cost": 0,
        "winMultiplier": 0.25,
        "lossMultiplier": 0.15,
        "ratingEffect": -0.5,
        "changeChampionship": false,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 0.75,
        "category": "dusty",
        "interference": false
    },
    {
        "name": "Double Pin",
        "description": "The referee declares that both participants' shoulders were on the mat during the pin.",
        "cost": 20,
        "winMultiplier": 0.5,
        "lossMultiplier": 0.0,
        "ratingEffect": -0.25,
        "changeChampionship": false,
        "affectRecord": false,
        "affectMorale": false,
        "feudStalenessEffect": 0.5,
        "category": "other",
        "interference": false,
        "draw": true
    },
    {
        "name": "Time-limit Draw",
        "description": "Participants wrestle till the time-limit, leading to a draw.",
        "cost": 50,
        "winMultiplier": 0.5,
        "lossMultiplier": -0.9,
        "ratingEffect": -0.25,
        "changeChampionship": false,
        "affectRecord": false,
        "affectMorale": false,
        "feudStalenessEffect": 0.5,
        "category": "other",
        "interference": false,
        "draw": true
    },
    {
        "name": "Squash",
        "description": "A participant dominates another in a quick and one-sided match.",
        "cost": 70,
        "winMultiplier": 2.0,
        "lossMultiplier": 2.0,
        "ratingEffect": -2,
        "changeChampionship": true,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 1.0,
        "category": "other",
        "interference": false
    },
    {
        "name": "Ring Collapse",
        "description": "Participants perform a move from the top rope, causing the ring to collapse.",
        "cost": 100,
        "winMultiplier": 0.5,
        "lossMultiplier": -1,
        "ratingEffect": 0.25,
        "changeChampionship": false,
        "affectRecord": false,
        "affectMorale": false,
        "feudStalenessEffect": 0.5,
        "category": "special",
        "interference": false,
        "requirements": [
            "main_event"
        ],
        "draw": true
    },
    {
        "name": "Switch Alliance",
        "description": "A manager betrays their client, causing them to lose, and joins the winner.",
        "cost": 100,
        "winMultiplier": 0.5,
        "lossMultiplier": -1,
        "ratingEffect": 0.25,
        "changeChampionship": true,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 1,
        "category": "special",
        "interference": false,
        "requirements": [
            "level_2_producer",
            "loser_has_manager",
            "winner_has_no_manager"
        ],
        "consequences": [
            "manager_leaves_loser_and_joins_winner"
        ]
    },
    {
        "name": "Throw In Towel",
        "description": "A manager throws in the towel for their client, causing them to lose.",
        "cost": 125,
        "winMultiplier": 1.0,
        "lossMultiplier": -1.5,
        "ratingEffect": 0.25,
        "changeChampionship": true,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 1,
        "category": "special",
        "interference": false,
        "requirements": [
            "level_2_producer",
            "loser_has_manager"
        ]
    },
    {
        "name": "Respectful End",
        "description": "A heel refuses to cheat and loses valiantly, earning everyone's respect.",
        "cost": 125,
        "winMultiplier": 1.0,
        "lossMultiplier": -1.2,
        "ratingEffect": 0.5,
        "changeChampionship": true,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 1,
        "category": "special",
        "interference": false,
        "requirements": [
            "level_2_producer",
            "hot_feud",
            "heel_loser"
        ],
        "consequences": [
            "heel_turns_face"
        ]
    },
    {
        "name": "By Any Means",
        "description": "A face goes to extreme lengths in order to win.",
        "cost": 125,
        "winMultiplier": 1.5,
        "lossMultiplier": -0.5,
        "ratingEffect": 0.5,
        "changeChampionship": true,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 1,
        "category": "special",
        "interference": false,
        "requirements": [
            "level_2_producer",
            "hot_feud",
            "face_winner"
        ],
        "consequences": [
            "face_turns_heel"
        ]
    },
    {
        "name": "Screwjob",
        "description": "A participant is in a submission when the referee unexpectedly calls for the bell.",
        "cost": 150,
        "winMultiplier": 1.5,
        "lossMultiplier": -2,
        "ratingEffect": 0.25,
        "changeChampionship": true,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 1,
        "category": "special",
        "interference": false,
        "requirements": [
            "level_3_producer",
            "title_match"
        ],
        "consequences": [
            "feud_boost"
        ]
    },
    {
        "name": "Pass Out",
        "description": "A face turns to the dark side to win but the heel refuses to give up and ends up passing out.",
        "cost": 150,
        "winMultiplier": 1.0,
        "lossMultiplier": -2.5,
        "ratingEffect": 1.0,
        "changeChampionship": true,
        "affectRecord": true,
        "affectMorale": true,
        "feudStalenessEffect": 1,
        "category": "special",
        "interference": false,
        "requirements": [
            "level_3_producer",
            "hot_feud",
            "face_vs_heel",
            "face_winner"
        ],
        "consequences": [
            "heel_turns_face",
            "face_turns_heel"
        ]
    }
];

});

parcelRequire.register("lhVvD", function(module, exports) {

$parcel$export(module.exports, "Streak", () => $f7f7cb9f9a2cd7df$export$7ec16b107acd59a0);
$parcel$export(module.exports, "getStreakEvent", () => $f7f7cb9f9a2cd7df$export$fcc0ea08a52a1fef);
$parcel$export(module.exports, "getStreakTalent", () => $f7f7cb9f9a2cd7df$export$a674ac41bdc79d38);

var $14eBR = parcelRequire("14eBR");
function $f7f7cb9f9a2cd7df$export$7ec16b107acd59a0() {
    // Integer
    const length = 1;
    // Boolean
    const ended = false;
    // Foreign keys
    const superstarId = null;
    const tagTeamId = null;
    const eventId = null;
    return {
        length: length,
        ended: ended,
        superstarId: superstarId,
        tagTeamId: tagTeamId,
        eventId: eventId
    };
}
function $f7f7cb9f9a2cd7df$export$692167ba216dfe3a(streak) {
    return (0, $14eBR.Superstars).find({
        "$loki": streak.superstarId
    })[0];
}
function $f7f7cb9f9a2cd7df$export$83d753ac1ac2ea39(streak) {
    return (0, $14eBR.TagTeams).find({
        "$loki": streak.tagTeamId
    })[0];
}
function $f7f7cb9f9a2cd7df$export$fcc0ea08a52a1fef(streak) {
    return (0, $14eBR.Events).find({
        "$loki": streak.eventId
    })[0];
}
function $f7f7cb9f9a2cd7df$export$a674ac41bdc79d38(streak) {
    if (streak.superstarId) return $f7f7cb9f9a2cd7df$export$692167ba216dfe3a(streak);
    else return $f7f7cb9f9a2cd7df$export$83d753ac1ac2ea39(streak);
}

});

parcelRequire.register("im36F", function(module, exports) {

$parcel$export(module.exports, "FeudItem", () => $d5ccb0f8a5ef5009$export$4ec03b1404933145);
$parcel$export(module.exports, "addFeudItemFeuds", () => $d5ccb0f8a5ef5009$export$bfa9fd0f000826c7);
$parcel$export(module.exports, "removeFeudItemFeuds", () => $d5ccb0f8a5ef5009$export$c49d63e68543a875);

var $14eBR = parcelRequire("14eBR");
function $d5ccb0f8a5ef5009$export$4ec03b1404933145() {
    // String
    const name = null;
    const description = null;
    const consequence = null;
    const requirement = null;
    const category = null;
    // Integer
    const level = 1;
    const xp = 0;
    const baseHype = 10;
    // Boolean
    const oneAtATime = false;
    const unlocked = true;
    const standard = false;
    const singles = true;
    const tag = false;
    const faction = false;
    const directFeud = false;
    const oneWayConsequence = false;
    // Foreign keys
    const companyId = null;
    return {
        name: name,
        description: description,
        consequence: consequence,
        requirement: requirement,
        category: category,
        level: level,
        xp: xp,
        baseHype: baseHype,
        oneAtATime: oneAtATime,
        unlocked: unlocked,
        standard: standard,
        singles: singles,
        tag: tag,
        faction: faction,
        directFeud: directFeud,
        oneWayConsequence: oneWayConsequence,
        companyId: companyId
    };
}
function $d5ccb0f8a5ef5009$export$33a28ff7accb059(feudItem) {
    return (0, $14eBR.Feuds).find({
        "feudItemId": feudItem.$loki
    });
}
function $d5ccb0f8a5ef5009$export$bfa9fd0f000826c7(feudItem, feuds) {
    feuds.forEach((c)=>{
        c.feudItemId = feudItem.$loki;
    });
}
function $d5ccb0f8a5ef5009$export$c49d63e68543a875(feudItem, feuds) {
    feuds.forEach((c)=>{
        c.feudItemId = null;
    });
}
function $d5ccb0f8a5ef5009$var$getFeudItemCompany(feudItem) {
    return (0, $14eBR.Companies).find({
        "$loki": feudItem.companyId
    })[0];
}

});

parcelRequire.register("2GWzg", function(module, exports) {

$parcel$export(module.exports, "graphicsData", () => $1f5cef598ab2538c$export$ebe5ce9e7b514041);
$parcel$export(module.exports, "championshipsGraphicsData", () => $1f5cef598ab2538c$export$3d09a5aef066fd9f);
$parcel$export(module.exports, "bodyColorsList", () => $1f5cef598ab2538c$export$f489eb13f54980c8);
$parcel$export(module.exports, "hairColorsList", () => $1f5cef598ab2538c$export$845fa0a416b16eb6);
$parcel$export(module.exports, "pantsColorsList", () => $1f5cef598ab2538c$export$ecbc569e5db1a8de);
$parcel$export(module.exports, "shirtsColorsList", () => $1f5cef598ab2538c$export$1373745cdd13ed29);
$parcel$export(module.exports, "jacketsColorsList", () => $1f5cef598ab2538c$export$c0f58b694c889316);
$parcel$export(module.exports, "glassesColorsList", () => $1f5cef598ab2538c$export$fb2d5005d59b6627);
$parcel$export(module.exports, "shoesColorsList", () => $1f5cef598ab2538c$export$2582745fe12bfa2b);
$parcel$export(module.exports, "doctorCoatColorsList", () => $1f5cef598ab2538c$export$3200b27fe0e8ed87);
const $1f5cef598ab2538c$export$ebe5ce9e7b514041 = {
    "bodies": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 1
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 3
        }
    ],
    "bottoms": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0,
            "staff": true
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 1
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 3
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 4
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 5
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 6
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 7
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 9
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 10
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 11
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 12
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 13
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 14
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 15
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 16
        },
        {
            "designs": 4,
            "style": "masculine",
            "number": 17
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 18
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 19
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 20
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 21
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 22
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 23
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 24
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 25
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 26
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 27
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 28
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 29
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 30
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 31
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 32
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 33
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 34
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 35
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 36
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 37
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 38
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 39
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 40
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 41
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 42
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 43
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 44
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 45
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 46
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 47
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 48
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 49
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 50
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 51
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 52
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 53
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 54
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 55
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 56
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 57
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 58
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 59
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 60
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 61,
            "staff": true
        }
    ],
    "torsos": [
        {
            "designs": 2,
            "style": "masculine",
            "number": 0
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 1
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 3
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 4
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 5
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 6,
            "staff": true
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 7
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 9
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 10
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 11
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 12
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 13
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 14
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 15
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 16
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 17
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 18
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 19
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 20
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 21
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 22
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 23
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 24
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 25
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 26
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 27
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 28
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 29
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 30
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 31
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 32
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 33
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 34
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 35
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 36
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 37
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 38
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 39
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 40
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 41
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 42
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 43
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 44
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 45,
            "staff": true
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 46
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 47,
            "staff": true
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 48,
            "staff": true
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 49
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 50
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 51
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 52
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 53
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 54
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 55
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 56
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 57
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 58
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 59
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 60
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 61
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 62
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 63
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 64
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 65
        },
        {
            "designs": 4,
            "style": "feminine",
            "number": 66
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 67
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 68,
            "staff": true
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 69
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 70
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 71,
            "staff": true
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 72,
            "staff": true
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 73
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 74
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 75
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 76
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 77
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 78
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": -1
        }
    ],
    "hairs": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 1,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 2,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 3,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 4
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 5,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 6,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 7,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 9,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 10
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 11,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 12
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 13,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 14,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 15,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 16,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 17,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 18,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 19
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 20
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 21,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 22,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 23,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 24,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 25,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 26,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 27
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 28,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 29
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 30
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 31
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 32
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 33,
            "category": "short"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 34,
            "category": "short"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 35
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 36
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 37
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 38
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 39
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 40
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 41
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 42
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 43
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 44
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 45
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 46
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 47
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 48
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 49
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 50
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 51
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 52
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 53
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 54
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 55
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 56
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 57
        },
        {
            "designs": 3,
            "style": "feminine",
            "number": 58
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 59
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 60
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 61
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 62
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 63
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 64
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 65
        }
    ],
    "shoes": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0,
            "staff": true
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 1,
            "staff": true
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 3,
            "staff": true
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 4,
            "staff": true
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 5
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 6
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 7
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 9
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 10
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 11,
            "staff": true
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 12
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 13
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 14
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 15
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 16,
            "staff": true
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 17
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 18,
            "staff": true
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 19
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 20
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": -1
        }
    ],
    "elbows": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 1
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 3
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 4
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 5
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 6
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 7
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 9
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": -1
        }
    ],
    "facial_hairs": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 1
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 3
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 4
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 5
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 6
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 7
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 9
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 10
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 11
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 12
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 13
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 14
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 15
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 16
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 17
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 18
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 19
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": -1
        }
    ],
    "accessories": [
        {
            "designs": 3,
            "style": "masculine",
            "number": 0
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 1
        },
        {
            "designs": 4,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 3
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 4
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 5
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 6,
            "category": "mask"
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 7,
            "category": "mask"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 9
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 10
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 11
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 12
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 13
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 14
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 15
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 16
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 17
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 18
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 19
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 20
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 21
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 22
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 23
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 24
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 25
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 26
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 27
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 28
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 29
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 30,
            "staff": true,
            "category": "glasses"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 31
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 32,
            "staff": true,
            "category": "glasses"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 33,
            "staff": true,
            "category": "glasses"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 34
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 35
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 36,
            "staff": true,
            "category": "suit"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 37,
            "staff": true,
            "category": "suit"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 38,
            "staff": true,
            "category": "suit"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 39
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 40
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 41
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 42
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 43
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 44
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 45
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 46
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 47
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 48
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 49
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 50
        },
        {
            "designs": 2,
            "style": "feminine",
            "number": 51
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 52
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 53
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": 54
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 55,
            "staff": true,
            "category": "doctor"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 56
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 57
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 58
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 59
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 60
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 61
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 62
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 63
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 64
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 65
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 66
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 67
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 68
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 69
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 70
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 71
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 72
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 73
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 74
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 75
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 76
        },
        {
            "designs": 4,
            "style": "masculine",
            "number": 77,
            "category": "mask"
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 78,
            "category": "mask"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 79
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 80
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 81
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 82
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 83
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 84
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 85
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 86
        },
        {
            "designs": 4,
            "style": "masculine",
            "number": 87
        },
        {
            "designs": 4,
            "style": "masculine",
            "number": 88,
            "category": "mask"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 89
        },
        {
            "designs": 1,
            "style": "feminine",
            "number": -1
        }
    ],
    "facepaints": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 1
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 3,
            "category": "mask"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 4,
            "category": "mask"
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 5,
            "category": "mask"
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 6
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 7
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 9,
            "category": "mask"
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": -1
        }
    ],
    "kneepads": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 1
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 3
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 4
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 5
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 6
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 7
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 9
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": -1
        }
    ],
    "tattoos": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 1
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 2
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 3
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 4
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 5
        },
        {
            "designs": 3,
            "style": "masculine",
            "number": 6
        },
        {
            "designs": 2,
            "style": "masculine",
            "number": 7
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 8
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 9
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 10
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 11
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 12
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 13
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": 14
        },
        {
            "designs": 1,
            "style": "masculine",
            "number": -1
        }
    ],
    "eyes": [
        {
            "designs": 1,
            "style": "masculine",
            "number": 0
        }
    ],
    "bloodObjects": [
        {
            "designs": 1,
            "number": 0,
            "type": "forehead"
        },
        {
            "designs": 1,
            "number": 1,
            "type": "forehead"
        },
        {
            "designs": 1,
            "number": 2,
            "type": "forehead"
        },
        {
            "designs": 1,
            "number": 3,
            "type": "left_eye"
        },
        {
            "designs": 1,
            "number": 4,
            "type": "right_eye"
        },
        {
            "designs": 1,
            "number": 5,
            "type": "forehead"
        },
        {
            "designs": 1,
            "number": 6,
            "type": "forehead_right"
        },
        {
            "designs": 1,
            "number": 7,
            "type": "forehead_left"
        },
        {
            "designs": 1,
            "number": 8,
            "type": "right_arm"
        },
        {
            "designs": 1,
            "number": 9,
            "type": "left_arm"
        },
        {
            "designs": 1,
            "number": 10,
            "type": "forehead"
        },
        {
            "designs": 1,
            "number": 11,
            "type": "forehead_full"
        },
        {
            "designs": 1,
            "number": 12,
            "type": "forehead_full"
        }
    ]
};
const $1f5cef598ab2538c$export$3d09a5aef066fd9f = {
    "centerPlate": [
        {
            "designs": 1,
            "number": 0,
            "gemPart": 9,
            "strapPart": 9,
            "sidePlatesPart": 9
        },
        {
            "designs": 1,
            "number": 1,
            "gemPart": 0,
            "strapPart": 0,
            "sidePlatesPart": 0
        },
        {
            "designs": 1,
            "number": 2,
            "gemPart": 1,
            "strapPart": 1,
            "sidePlatesPart": 1
        },
        {
            "designs": 1,
            "number": 3,
            "gemPart": 2,
            "strapPart": 2,
            "sidePlatesPart": 2
        },
        {
            "designs": 1,
            "number": 4,
            "gemPart": 3,
            "strapPart": 3,
            "sidePlatesPart": 3
        },
        {
            "designs": 1,
            "number": 5,
            "gemPart": 4,
            "strapPart": 4,
            "sidePlatesPart": 4
        },
        {
            "designs": 1,
            "number": 6,
            "gemPart": 5,
            "strapPart": 5,
            "sidePlatesPart": 5
        },
        {
            "designs": 1,
            "number": 7,
            "gemPart": 6,
            "strapPart": 6,
            "sidePlatesPart": 6
        },
        {
            "designs": 1,
            "number": 8,
            "gemPart": 7,
            "strapPart": 7,
            "sidePlatesPart": 7
        },
        {
            "designs": 1,
            "number": 9,
            "gemPart": 8,
            "strapPart": 8,
            "sidePlatesPart": 8
        }
    ],
    "sidePlates": [
        {
            "designs": 1,
            "number": 0,
            "sideGemsPart": 0
        },
        {
            "designs": 1,
            "number": 1,
            "sideGemsPart": 1
        },
        {
            "designs": 1,
            "number": 2,
            "sideGemsPart": 2
        },
        {
            "designs": 1,
            "number": 3,
            "sideGemsPart": 3
        },
        {
            "designs": 1,
            "number": 4,
            "sideGemsPart": 4
        },
        {
            "designs": 1,
            "number": 5,
            "sideGemsPart": 5
        },
        {
            "designs": 1,
            "number": 6,
            "sideGemsPart": 6
        },
        {
            "designs": 1,
            "number": 7,
            "sideGemsPart": 7
        },
        {
            "designs": 1,
            "number": 8,
            "sideGemsPart": 8
        },
        {
            "designs": 1,
            "number": 9,
            "sideGemsPart": 9
        },
        {
            "designs": 1,
            "number": 10,
            "sideGemsPart": 10
        },
        {
            "designs": 1,
            "number": 11,
            "sideGemsPart": 11
        },
        {
            "designs": 1,
            "number": 12,
            "sideGemsPart": 12
        },
        {
            "designs": 1,
            "number": 13,
            "sideGemsPart": 13
        },
        {
            "designs": 1,
            "number": 14,
            "sideGemsPart": 15
        },
        {
            "designs": 1,
            "number": 15,
            "sideGemsPart": 14
        },
        {
            "designs": 1,
            "number": 16,
            "sideGemsPart": 16
        },
        {
            "designs": 1,
            "number": 17,
            "sideGemsPart": 17
        },
        {
            "designs": 1,
            "number": 18,
            "sideGemsPart": 18
        },
        {
            "designs": 1,
            "number": 19,
            "sideGemsPart": 19
        },
        {
            "designs": 1,
            "number": 20,
            "sideGemsPart": 20
        },
        {
            "designs": 1,
            "number": -1,
            "sideGemsPart": 21
        }
    ]
};
const $1f5cef598ab2538c$export$f489eb13f54980c8 = [
    "0xFFE4CB",
    "0xF4D7BC",
    "0xFFD9B6",
    "0xFFD4AB",
    "0xF2D2A5",
    "0xDFB58D",
    "0xCAA684",
    "0x7A6353"
];
const $1f5cef598ab2538c$export$845fa0a416b16eb6 = [
    "0x502F0C",
    "0x733A00",
    "0x844B11",
    "0xA3672B",
    "0xC48647",
    "0xB04F1B",
    "0xFFFA84",
    "0x471E08",
    "0x999999",
    "0xeb8c4e",
    "0x090909",
    "0x3e3120",
    "0xDEBE99",
    "0x4C4C4C",
    "0xAA8866",
    "0x4F1A00",
    "0x9A3300",
    "0xE5E5E5",
    "0xC05D1C",
    "0xD5C427",
    "0xEBB25F"
];
const $1f5cef598ab2538c$export$ecbc569e5db1a8de = [
    // Greys
    "0x333333",
    "0x111216",
    "0x898B8E",
    "0x595959",
    "0x4C4C4C",
    // Navys
    "0x222744",
    "0x434C61",
    "0x414975",
    "0x2C2C35",
    // Khakis
    "0x9B7B58",
    "0x735B41",
    "0xC1A07D",
    // Other
    "0x57573D",
    "0x3F2625",
    "0xEAE8DB",
    "0x9C9872"
];
const $1f5cef598ab2538c$export$1373745cdd13ed29 = [
    // Greys
    "0xE4E4E4",
    "0xF0EEEE",
    "0x989898",
    "0x2B2B2B",
    "0xD1D1D1",
    "0x5B5B5B",
    // Blues
    "0xC4CFE5",
    "0xD9E2F5",
    "0xA9C1F1",
    "0x8CB4E1",
    "0xC5CCDC",
    "0x2E4679",
    // Pink
    "0xF7CEF7",
    "0xEFBAC2",
    "0xEEBDC9",
    "0xE69B8F",
    // Other
    "0xFCE3C7",
    "0x575932",
    "0xA52A2F",
    "0x51955A",
    "0x87AE49",
    "0xA54F24",
    "0x8EC6AD",
    "0x774354",
    "0xFFFCCF"
];
const $1f5cef598ab2538c$export$c0f58b694c889316 = [
    // Navys
    "0x1A2D61",
    "0x465A7B",
    "0x2E384C",
    "0x3A4A6E",
    "0x2B448C",
    "0x2F3353",
    // Greys
    "0x6F7887",
    "0x656C76",
    "0x969CA4",
    "0x646464",
    "0xC5CCDC",
    "0x2E4679",
    // Browns
    "0x8C6953",
    "0x6A5738",
    "0x9D6236",
    "0x573923",
    // Khakis
    "0xCBBA9E",
    "0xC1A691",
    "0xC7C296",
    "0xEADAD4",
    // Olives
    "0x5B725E",
    "0x545743"
];
const $1f5cef598ab2538c$export$fb2d5005d59b6627 = [
    "0x333333",
    "0x7C6C5E",
    "0x434343",
    "0x171717"
];
const $1f5cef598ab2538c$export$2582745fe12bfa2b = [
    "0x1E1E1E",
    "0x3B3B3B",
    "0x553828"
];
const $1f5cef598ab2538c$export$3200b27fe0e8ed87 = [
    "0xF3F3F3",
    "0xEEEEEE",
    "0xF1F5F9",
    "0xF8F9F9"
];

});

parcelRequire.register("9MKdC", function(module, exports) {

$parcel$export(module.exports, "ChampionshipReign", () => $71fc72cedd122680$export$7019a51c2470912d);
$parcel$export(module.exports, "getChampionshipReignSuperstar", () => $71fc72cedd122680$export$25df381651f5a0f1);
$parcel$export(module.exports, "getChampionshipReignChampionship", () => $71fc72cedd122680$export$e6c1a91bc86cc945);
$parcel$export(module.exports, "getChampionshipReignMatches", () => $71fc72cedd122680$export$29bc07ee7e6186fc);

var $14eBR = parcelRequire("14eBR");
function $71fc72cedd122680$export$7019a51c2470912d(startMonth, startYear) {
    // Booleans
    const vacated = false;
    const retired = false;
    // Integer
    const endMonth = null;
    const endYear = null;
    // Strings
    const holderName = null;
    // Foreign keys
    const championshipId = null;
    const superstarId = null;
    return {
        startMonth: startMonth,
        startYear: startYear,
        vacated: vacated,
        retired: retired,
        endMonth: endMonth,
        endYear: endYear,
        holderName: holderName,
        championshipId: championshipId,
        superstarId: superstarId
    };
}
function $71fc72cedd122680$export$25df381651f5a0f1(championshipReign) {
    if (championshipReign.superstarId) return (0, $14eBR.Superstars).find({
        "$loki": championshipReign.superstarId
    })[0];
    else return null;
}
function $71fc72cedd122680$export$e6c1a91bc86cc945(championshipReign) {
    if (championshipReign.championshipId) return (0, $14eBR.Championships).find({
        "$loki": championshipReign.championshipId
    })[0];
    else return null;
}
async function $71fc72cedd122680$export$29bc07ee7e6186fc(championshipReign) {
    const championshipReignMatchHashes = (0, $14eBR.ChampionshipReignMatchesHash).find({
        "championshipReignId": championshipReign.$loki
    });
    const matchIds = championshipReignMatchHashes.map((x)=>{
        return x.matchId;
    });
    return (0, $14eBR.Matches).find({
        "$loki": {
            "$in": matchIds
        }
    });
}

});

parcelRequire.register("46buw", function(module, exports) {

$parcel$export(module.exports, "getTournamentDisplay", () => $2fc0a2e2a26fe831$export$e0c87de1a5e43942);
$parcel$export(module.exports, "createTournament", () => $2fc0a2e2a26fe831$export$ed49a7f4a1bee5db);
$parcel$export(module.exports, "getAdvancingParticipants", () => $2fc0a2e2a26fe831$export$4ccc9bb93688a887);
$parcel$export(module.exports, "getNextRoundMatches", () => $2fc0a2e2a26fe831$export$10e13d6a2ef64bba);
$parcel$export(module.exports, "addWinnerToNextRound", () => $2fc0a2e2a26fe831$export$4b76e365aabb106a);

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $14eBR = parcelRequire("14eBR");

var $iQtzn = parcelRequire("iQtzn");

var $9esFv = parcelRequire("9esFv");

var $5kTkA = parcelRequire("5kTkA");

var $972Ip = parcelRequire("972Ip");

var $4EGpv = parcelRequire("4EGpv");

var $5ZsVo = parcelRequire("5ZsVo");

var $kZwpB = parcelRequire("kZwpB");

var $i7bmn = parcelRequire("i7bmn");

var $1AAHK = parcelRequire("1AAHK");

var $ivuOU = parcelRequire("ivuOU");

var $ycsyu = parcelRequire("ycsyu");

var $98xmD = parcelRequire("98xmD");

var $6RCLU = parcelRequire("6RCLU");
async function $2fc0a2e2a26fe831$export$e0c87de1a5e43942({ participantsData: participantsData, tournamentType: tournamentType, matchType: matchType, numberOfGroups: numberOfGroups } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
    // Get participants
    let participants = [];
    for (const x of participantsData){
        let participant;
        if (matchType === "singles") participant = rosterSuperstars.find((y)=>y.$loki === x.uid);
        else if (matchType === "tag") participant = rosterTagTeams.find((y)=>y.$loki === x.uid);
        // Check participant
        if (!participant) {
            data["error"] = "participant-not-found";
            return data;
        }
        if ((0, $3E8Nt.objectInArray)(participant, participants)) {
            data["error"] = "duplicate-participant";
            return data;
        }
        participants.push(participant);
    }
    // Get bracket/table
    let participantSeeds = await $2fc0a2e2a26fe831$var$createTournamentParticipantSeeds([
        ...participants
    ]);
    if (tournamentType === "elimination") data["bracket"] = $2fc0a2e2a26fe831$var$getTournamentBracketFromSeeds(participantSeeds);
    else if (tournamentType === "round-robin") data["table"] = $2fc0a2e2a26fe831$var$getTournamentGroupsFromSeeds(participantSeeds, numberOfGroups);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $2fc0a2e2a26fe831$var$createTournamentParticipantSeeds(participants) {
    // Create seeds from 1 to len(participants) based on popularity, returns [participant, seed]
    let participantSeeds = [];
    // Sort by popularity
    for (const x of participants)x.tempPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
    participants.sort((a, b)=>b.tempPopularity - a.tempPopularity);
    for (const x of participants)delete x.tempPopularity;
    // Add seeds, set tournamentSeed for participants
    for (const [i, p] of participants.entries()){
        let seed = i + 1;
        participantSeeds.push([
            p,
            seed
        ]);
        p.tournamentSeed = seed;
    }
    return participantSeeds;
}
function $2fc0a2e2a26fe831$var$getTournamentBracketFromSeeds(participantSeeds) {
    // Start with finals node, go backwards to create bracket
    let nextNodes = [
        participantSeeds[0],
        participantSeeds[1]
    ];
    let numberOfRounds = Math.log2(participantSeeds.length);
    for (const z of (0, $3E8Nt.range)(numberOfRounds - 1)){
        let nodes = [
            ...nextNodes
        ];
        nextNodes = [];
        // Add seed to previous round
        for (const x of nodes)nextNodes.push(...[
            x,
            null
        ]);
        let nextSeeds = participantSeeds.slice(nextNodes.length / 2, nextNodes.length);
        for (const x of nextSeeds){
            // Find seed to pair with
            let i = nextNodes.length + 1 - x[1];
            // Add seed to node after i
            let node = nextNodes.find((y)=>y && y[1] === i);
            let pos = nextNodes.indexOf(node) + 1;
            nextNodes[pos] = x;
        }
    }
    // Reverse second half
    nextNodes = nextNodes.splice(0, nextNodes.length / 2).concat(nextNodes.reverse());
    // Initialize brackets with numberOfRounds
    let bracket = {};
    for (const x of (0, $3E8Nt.range)(numberOfRounds, 1))bracket[x] = [];
    // Divide nodes into two superstars
    let matches = (0, $3E8Nt.getChunks)(nextNodes, 2);
    for (const x of matches){
        let superstars = [
            x[0][0],
            x[1][0]
        ];
        // Get match bracket
        let data = {
            "participants": superstars.map((s)=>s ? [
                    s.name,
                    s.tournamentSeed
                ] : [
                    null,
                    null
                ])
        };
        bracket[1].push(data);
    }
    // Add empty future numberOfRounds' matches
    for (const x of (0, $3E8Nt.range)(numberOfRounds, 1))if (!bracket[x].length) {
        let n = Math.floor(matches.length * 2 / 2 ** x); // Number of matches for this round
        for (const m of (0, $3E8Nt.range)(n)){
            let data = {
                "participants": [
                    [
                        null,
                        null
                    ],
                    [
                        null,
                        null
                    ]
                ]
            };
            bracket[x].push(data);
        }
    }
    return bracket;
}
function $2fc0a2e2a26fe831$var$getTournamentGroupsFromSeeds(participantSeeds, numberOfGroups) {
    // Create empty groups
    let groups = Array.from({
        length: numberOfGroups
    }).map(()=>[]);
    // Divide participants into chunks of numberOfGroups
    let seedsChunks = (0, $3E8Nt.getChunks)(participantSeeds, numberOfGroups);
    // Go through each chunk, adding participant name and seed to their group
    for (const seedChunk of seedsChunks)for (const [i, participantSeed] of seedChunk.entries())groups[i].push([
        participantSeed[0].name,
        participantSeed[1]
    ]);
    return groups;
}
async function $2fc0a2e2a26fe831$export$ed49a7f4a1bee5db({ participantsData: participantsData, name: name, tournamentName: tournamentName, type: type, matchesAtEvent: matchesAtEvent, matchType: matchType, matchContractName: matchContractName, matchContractEventName: matchContractEventName, awardOption: awardOption, participantsAdvancing: participantsAdvancing, triosMatch: triosMatch, selectedChampionshipUid: selectedChampionshipUid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const companyTournaments = await (0, $9esFv.getCompanyTournaments)(userCompany);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const cost = 150;
    // Check if enough points
    if (userCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Check if tournament already booked
    if ((await (0, $iQtzn.getEventTournaments)(latestEvent)).length > 0) {
        data["error"] = "tournament-booked";
        return data;
    }
    // Check name uniqueness if new tournament
    if (!tournamentName) {
        const tournamentNames = companyTournaments.map((x)=>x.name);
        if (tournamentNames.includes(name)) {
            data["error"] = "non-unique-name";
            return data;
        }
    } else name = tournamentName;
    // Check if match contract exists
    if (matchContractName) {
        if (companyChampionships.find((x)=>x.name === matchContractName)) {
            data["error"] = "match-contract-exists";
            return data;
        }
    }
    // Get participants
    let participants = [];
    let participantsDataFormatted = [
        ...participantsData
    ];
    if (type === "round-robin") participantsDataFormatted = participantsData.flat();
    for (const x of participantsDataFormatted){
        let participant;
        if (matchType === "singles") participant = rosterSuperstars.find((y)=>y.name === x);
        else if (matchType === "tag") {
            participant = rosterTagTeams.find((y)=>y.name === x);
            // If trio selected in tag match, create temporary tag team of 2 of trio's superstars
            if (participant && participant.trio && !triosMatch) {
                let teamSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(participant);
                let availableTeamSuperstars = teamSuperstars.filter((y)=>(0, $5kTkA.checkAvailability)(y, false) && (0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, y, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(y, companyChampionships)));
                // Check if enough team superstars available
                if (availableTeamSuperstars.length < 2) {
                    data["error"] = "not-available";
                    return data;
                }
                // Create temporary tag team
                let temporaryTeamSuperstars = (0, $3E8Nt.getRandomSample)(availableTeamSuperstars, 2);
                let temporaryTeamSuperstarsNames = (0, $3E8Nt.commaSeparate)([
                    ...temporaryTeamSuperstars
                ].sort((a, b)=>a.$loki - b.$loki).map((y)=>(0, $5kTkA.getSuperstarLastName)(y)));
                let teamName = `${participant.name} (${temporaryTeamSuperstarsNames})`;
                const newTagTeam = (0, $972Ip.TagTeam)(teamName, true);
                newTagTeam.trioTagTeam = true;
                await (0, $14eBR.TagTeams).insert(newTagTeam);
                await (0, $972Ip.addTagTeamSuperstars)(newTagTeam, temporaryTeamSuperstars);
                await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
                    newTagTeam
                ]);
                participant = newTagTeam;
            }
        }
        if (!participant) {
            data["error"] = "not-found";
            return data;
        }
        participants.push(participant);
    }
    // Get participant superstars
    let participantSuperstars = (await Promise.all(participants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    // Check if any superstars are present twice
    for (const s of participantSuperstars)if (participantSuperstars.filter((x)=>x.$loki === s.$loki).length > 1) {
        data["error"] = "duplicate-superstar";
        data["duplicateSuperstar"] = s.name;
        return data;
    }
    // Check for booking restrictions on event
    let eventActiveEffect = latestEvent.activeEffect;
    if ([
        "no_women_bookable",
        "no_men_bookable"
    ].includes(eventActiveEffect)) for (const s of participantSuperstars){
        if (eventActiveEffect === "no_women_bookable" && s.gender === "female") {
            data["error"] = "no-women-allowed";
            return data;
        } else if (eventActiveEffect === "no_men_bookable" && s.gender === "male") {
            data["error"] = "no-men-allowed";
            return data;
        }
    }
    // Create first round matches
    let firstRoundMatches;
    let rounds;
    let groupSize;
    let numberOfGroups;
    let knockoutRounds;
    if (type === "elimination") {
        rounds = Math.log2(participants.length);
        firstRoundMatches = (0, $3E8Nt.getChunks)([
            ...participants
        ].reverse(), 2);
    } else if (type === "round-robin") {
        numberOfGroups = participantsData.length;
        let groupRounds = participantsData[0].length - 1;
        if (participantsAdvancing > 0) knockoutRounds = Math.log2(participantsAdvancing * numberOfGroups);
        else knockoutRounds = 0;
        rounds = groupRounds + knockoutRounds;
        groupSize = participants.length / numberOfGroups;
        let groups = (0, $3E8Nt.getChunks)(participants, groupSize);
        firstRoundMatches = (await $2fc0a2e2a26fe831$var$createGroupMatches(groups)).reverse();
        for (const x of participants)x.tournamentPoints = 0;
    }
    // Get matches to hold at next event
    let matchesAtEventNumber;
    if (participantsAdvancing !== 0) {
        let matchesAtEventValues = {
            "finals": 1,
            "semi-finals": 2,
            "quarter-finals": 4
        };
        matchesAtEventNumber = matchesAtEventValues[matchesAtEvent] || 4;
    } else // No knockout round
    matchesAtEventNumber = parseInt(matchesAtEvent);
    // Set matches at event to first round matches if smaller than it
    if (firstRoundMatches.length < matchesAtEventNumber) matchesAtEventNumber = firstRoundMatches.length;
    let tournamentEvent;
    let weeklyShowCreated = false;
    let addedMatches = [];
    if (firstRoundMatches.length > 4 || firstRoundMatches.length > matchesAtEventNumber) {
        // Create weekly show
        let weeklyShow = (0, $iQtzn.Event)("Weekly Show");
        weeklyShow.monthlyEventName = latestEvent.name;
        weeklyShow.brandName = latestEvent.brandName;
        await (0, $14eBR.Events).insert(weeklyShow);
        await (0, $9esFv.addCompanyEvents)(userCompany, [
            weeklyShow
        ]);
        tournamentEvent = weeklyShow;
        weeklyShowCreated = true;
        if (type === "elimination") {
            // Calculate rounds to add at event, add future matches
            let roundsData = {
                "finals": rounds - 1,
                "semi-finals": rounds - 2,
                "quarter-finals": rounds - 3
            };
            let matchesAtEventRounds = roundsData[matchesAtEvent] || rounds - 3;
            let futureMatches = await $2fc0a2e2a26fe831$var$createFutureEliminationMatches(matchesAtEventRounds, rounds, firstRoundMatches, latestEvent, matchType, weeklyShow);
            addedMatches.push(...futureMatches);
            // Add matches to weekly show
            let addedEventMatches = await $2fc0a2e2a26fe831$var$addMatchesToEvent(firstRoundMatches, weeklyShow, matchType, rosterSuperstars);
            addedMatches.push(...addedEventMatches);
        } else if (type === "round-robin") {
            if (participantsAdvancing === 0) {
                // Add matches to weekly show and next event if no knockout stage
                let matchesIndex;
                if (matchesAtEventNumber === 0) matchesIndex = Math.floor(groupSize / 2) // Final round matches
                ;
                else matchesIndex = matchesAtEventNumber // Selected matches
                ;
                let weeklyShowMatches = firstRoundMatches.slice(matchesIndex);
                let eventMatches = firstRoundMatches.slice(0, matchesIndex);
                let addedWeeklyShowMatches = await $2fc0a2e2a26fe831$var$addMatchesToEvent(weeklyShowMatches, weeklyShow, matchType, rosterSuperstars, true);
                let addedEventMatches = await $2fc0a2e2a26fe831$var$addMatchesToEvent(eventMatches, latestEvent, matchType, rosterSuperstars, true);
                addedMatches.push(...addedWeeklyShowMatches);
                addedMatches.push(...addedEventMatches);
                if (!addedWeeklyShowMatches.length) {
                    await (0, $9esFv.removeCompanyEvents)(userCompany, [
                        weeklyShow
                    ]);
                    (0, $14eBR.Events).remove(weeklyShow);
                    weeklyShowCreated = false;
                    tournamentEvent = latestEvent;
                }
            } else {
                // Add knockout matches to weekly show and next event
                let roundsData = {
                    "finals": 1,
                    "semi-finals": 2,
                    "quarter-finals": 3
                }; // Rounds to add
                let eventRounds = roundsData[matchesAtEvent] || 3;
                let weeklyRounds = knockoutRounds - eventRounds;
                roundsData = {
                    "finals": rounds,
                    "semi-finals": rounds - 1,
                    "quarter-finals": rounds - 2
                }; // Match rounds
                let eventRound = roundsData[matchesAtEvent] || 2;
                let weeklyRound = eventRound - weeklyRounds;
                let futureGroupMatchesEvent = await $2fc0a2e2a26fe831$var$createFutureGroupMatches(eventRounds, latestEvent, rounds, eventRound, matchType);
                let futureGroupMatchesWeeklyShow = await $2fc0a2e2a26fe831$var$createFutureGroupMatches(weeklyRounds, weeklyShow, rounds, weeklyRound, matchType);
                addedMatches.push(...futureGroupMatchesEvent);
                addedMatches.push(...futureGroupMatchesWeeklyShow);
                // Add group stage matches to weekly show
                let addedEventMatches = await $2fc0a2e2a26fe831$var$addMatchesToEvent(firstRoundMatches, weeklyShow, matchType, rosterSuperstars, true);
                addedMatches.push(...addedEventMatches);
            }
        }
    } else {
        // Add matches to event
        if (type === "elimination") {
            let futureMatches = await $2fc0a2e2a26fe831$var$createFutureEliminationMatches(1, rounds, firstRoundMatches, latestEvent, matchType);
            addedMatches.push(...futureMatches);
            let addedEventMatches = await $2fc0a2e2a26fe831$var$addMatchesToEvent(firstRoundMatches, latestEvent, matchType, rosterSuperstars);
            addedMatches.push(...addedEventMatches);
        }
        tournamentEvent = latestEvent;
    }
    // Find previous tournament with max prestige
    let previousTournament;
    if (tournamentName) previousTournament = (0, $3E8Nt.getArrayMaxByProperty)(companyTournaments.filter((x)=>x.name === tournamentName), "xp");
    // Create tournament
    let tournament = (0, $4EGpv.Tournament)(name, type, rounds, matchesAtEventNumber, participantsAdvancing, knockoutRounds, numberOfGroups);
    await (0, $14eBR.Tournaments).insert(tournament);
    // Add previous tournament's prestige data if found
    if (previousTournament) {
        tournament.prestige = previousTournament.prestige;
        tournament.xp = previousTournament.xp;
        tournament.startingXp = previousTournament.startingXp;
        tournament.cost = previousTournament.cost;
    }
    // Add tournament relationships
    await (0, $4EGpv.addTournamentMatches)(tournament, addedMatches);
    await (0, $iQtzn.addEventTournaments)(tournamentEvent, [
        tournament
    ]);
    await (0, $9esFv.addCompanyTournaments)(userCompany, [
        tournament
    ]);
    // Remove cost
    userCompany.points -= tournament.cost;
    // Add championship award
    if (awardOption === "championship") {
        let championship = await (0, $14eBR.Championships).get(selectedChampionshipUid);
        if (championship) {
            await (0, $4EGpv.addTournamentChampionships)(tournament, [
                championship
            ]);
            for (const x of companyChampionships.filter((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(y, championship)))x.booked = true;
            // Add to final match
            let finalMatch = (0, $3E8Nt.getArrayMaxByProperty)(addedMatches, "tournamentRound");
            await (0, $i7bmn.addMatchChampionships)(finalMatch, [
                championship
            ]);
            // Add to tournament awardName
            tournament.awardName = championship.name + " Championship";
        }
    } else if (awardOption === "match-contract") {
        let parentEvents = await (0, $8A6FL.getCompanyParentEvents)(userCompany);
        let parentEvent = parentEvents.find((x)=>x.name.trim() === matchContractEventName);
        let matchContract = (0, $1AAHK.MatchContract)();
        matchContract.name = matchContractName;
        matchContract.awarded = false;
        let bonuses = {
            "C": 12,
            "B": 25,
            "A": 50
        };
        matchContract.bonus = bonuses[parentEvent.prestige] || 12;
        await (0, $14eBR.MatchContracts).insert(matchContract);
        await (0, $4EGpv.addTournamentMatchContracts)(tournament, [
            matchContract
        ]);
        tournament.matchContractName = matchContractName;
        tournament.awardName = matchContractName + " Contract";
        // Add match contract to parent event
        await (0, $iQtzn.addEventMatchContracts)(parentEvent, [
            matchContract
        ]);
        // Get number of championships to create
        let numberOfChampionships = 1;
        if (matchType === "tag") {
            if (triosMatch) numberOfChampionships = 3;
            else numberOfChampionships = 2;
        }
        // Create championships
        let createdChampionships = [];
        for (const x of Array(numberOfChampionships).keys()){
            const newChampionship = (0, $ivuOU.Championship)(matchContractName);
            newChampionship.matchContract = true;
            newChampionship.booked = true;
            newChampionship.vacated = true;
            newChampionship.rank = "Upper Midcarder";
            if (numberOfChampionships === 2) newChampionship.tagTeam = true;
            else if (numberOfChampionships === 3) newChampionship.trio = true;
            await (0, $14eBR.Championships).insert(newChampionship);
            await (0, $ivuOU.addChampionshipMatchContracts)(newChampionship, [
                matchContract
            ]);
            createdChampionships.push(newChampionship);
        }
        // Add to company
        await (0, $9esFv.addCompanyChampionships)(userCompany, createdChampionships);
        // Add to final match
        let finalMatch = (0, $3E8Nt.getArrayMaxByProperty)(addedMatches, "tournamentRound");
        await (0, $i7bmn.addMatchChampionships)(finalMatch, [
            createdChampionships[createdChampionships.length - 1]
        ]);
    }
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = userCompany.points;
    const producers = (0, $8A6FL.getAvailableStaffMembersByRole)(companyStaffMembers, "producer");
    const matches = await (0, $5ZsVo.getEventMatchesData)({
        event: latestEvent,
        rosterSuperstars: rosterSuperstars,
        getChampionshipsAvailable: false
    });
    const segments = await (0, $5ZsVo.getEventSegmentsData)({
        event: latestEvent,
        rosterSuperstars: rosterSuperstars,
        producers: producers
    });
    data["matchesAndSegments"] = matches.concat(segments);
    data["matchesAndSegments"].sort((a, b)=>a.order - b.order);
    data["weeklyShowCreated"] = weeklyShowCreated;
    return data;
}
async function $2fc0a2e2a26fe831$var$createFutureEliminationMatches(eventRoundStart, rounds, firstRoundMatches, latestEvent, matchType, weeklyEvent = null) {
    let addedMatches = [];
    // Add matches to next event
    for(let z = rounds + 1; z > eventRoundStart; z--){
        let matchesToAdd = Math.floor(firstRoundMatches.length * 2 / 2 ** z);
        for (const y of (0, $3E8Nt.range)(matchesToAdd)){
            const newMatch = await $2fc0a2e2a26fe831$var$createFutureTournamentMatch(latestEvent, z, matchType);
            addedMatches.push(newMatch);
        }
    }
    // If tournament starting at weekly show, add future matches to it
    if (weeklyEvent) for(let z = eventRoundStart; z > 1; z--){
        let matchesToAdd = Math.floor(firstRoundMatches.length * 2 / 2 ** z);
        for (const y of (0, $3E8Nt.range)(matchesToAdd)){
            const newMatch = await $2fc0a2e2a26fe831$var$createFutureTournamentMatch(weeklyEvent, z, matchType);
            addedMatches.push(newMatch);
        }
    }
    return addedMatches;
}
async function $2fc0a2e2a26fe831$var$createFutureTournamentMatch(event, tournamentRound, matchType) {
    const newMatch = (0, $i7bmn.Match)(event.matchesCount, matchType);
    newMatch.tournamentRound = tournamentRound;
    await (0, $14eBR.Matches).insert(newMatch);
    await (0, $iQtzn.addEventMatches)(event, [
        newMatch
    ]);
    event.matchesCount += 1;
    return newMatch;
}
async function $2fc0a2e2a26fe831$var$createFutureGroupMatches(rounds, event, tournamentRounds, matchRound, matchType) {
    // Add knockout rounds
    let addedMatches = [];
    for(let z = rounds - 1; z > -1; z--){
        let currentRound = matchRound + z;
        let matchesToAdd = 2 ** (tournamentRounds - currentRound);
        for (const y of (0, $3E8Nt.range)(matchesToAdd)){
            const newMatch = await $2fc0a2e2a26fe831$var$createFutureTournamentMatch(event, currentRound, matchType);
            addedMatches.push(newMatch);
        }
    }
    return addedMatches;
}
async function $2fc0a2e2a26fe831$var$createGroupMatches(groups) {
    let matches = [];
    for (const [i, group] of groups.entries()){
        let groupMembers = [
            ...group
        ];
        let firstMember = groupMembers[0];
        // Circle algorithm
        let rows = (0, $3E8Nt.getChunks)(groupMembers, Math.floor(groupMembers.length / 2));
        let row1 = rows[0];
        let row2 = rows[1].reverse(); // Divide into two halves, reverse second half
        // Create round's matches
        for (const matchRound of (0, $3E8Nt.range)(groupMembers.length - 1)){
            for (const x of (0, $3E8Nt.range)(Math.floor(groupMembers.length / 2)).reverse()){
                // Get corresponding value in row
                let groupValue = 0;
                if (groups.length > 1) groupValue = i + 1;
                let match = [
                    [
                        row1[x],
                        row2[x]
                    ],
                    groupValue,
                    matchRound + 1
                ]; // Superstars, group, round
                matches.push(match);
            }
            // Rotate all elements except first member
            let l = groupMembers.filter((x)=>x.$loki !== firstMember.$loki);
            let rotated = l.slice(l.length - 1).concat(l.slice(0, l.length - 1));
            groupMembers = [
                firstMember
            ].concat(rotated);
            rows = (0, $3E8Nt.getChunks)(groupMembers, Math.floor(groupMembers.length / 2));
            row1 = rows[0];
            row2 = rows[1].reverse();
        }
    }
    matches.sort((a, b)=>a[2] - b[2]);
    return matches;
}
async function $2fc0a2e2a26fe831$var$addMatchesToEvent(matchesData, event, matchType, rosterSuperstars, group = false) {
    let addedMatches = [];
    for (const matchData of matchesData){
        // Add match
        const newMatch = (0, $i7bmn.Match)(event.matchesCount, matchType);
        if (group) {
            newMatch.tournamentGroup = matchData[1];
            newMatch.tournamentRound = matchData[2];
        } else newMatch.tournamentRound = 1;
        await (0, $14eBR.Matches).insert(newMatch);
        await (0, $iQtzn.addEventMatches)(event, [
            newMatch
        ]);
        event.matchesCount += 1;
        addedMatches.push(newMatch);
        // Add participants
        let matchParticipants = group ? matchData[0] : matchData;
        await (0, $i7bmn.addMatchParticipants)(newMatch, matchParticipants);
        // Get match superstars
        let matchSuperstars = (await Promise.all(matchParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
        // Reset attires
        for (const s of matchSuperstars)if (s.currentAttire > 0) s.currentAttire = 0;
        // Add feuds
        await (0, $6RCLU.addFeudsToMatch)(newMatch, matchParticipants);
        // Add managers
        if ((0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(newMatch, matchSuperstars, rosterSuperstars, event);
    }
    return addedMatches;
}
async function $2fc0a2e2a26fe831$export$4ccc9bb93688a887(tournament, group, numberToAdvance = 1) {
    // Get group's matches
    let groupMatches = (await (0, $4EGpv.getTournamentMatches)(tournament)).filter((x)=>x.tournamentGroup === group);
    // Add participants using first round matches
    let participants = [];
    const firstRoundMatches = groupMatches.filter((x)=>x.tournamentRound === 1);
    for (const m of firstRoundMatches){
        const matchParticipants = await (0, $i7bmn.getMatchParticipants)(m);
        for (const p of matchParticipants){
            participants.push(p);
            p.tempPoints = 0;
        }
    }
    let advancing;
    let advancingPoints;
    if (numberToAdvance === 1) {
        // Get winner by maximum points
        advancing = [
            (0, $3E8Nt.getArrayMaxByProperty)(participants, "tournamentPoints")
        ];
        advancingPoints = advancing[0].tournamentPoints;
    } else {
        // Sort by points
        const sortedParticipants = participants.sort((a, b)=>b.tournamentPoints - a.tournamentPoints);
        advancing = sortedParticipants.slice(0, numberToAdvance);
        advancingPoints = advancing[numberToAdvance - 1].tournamentPoints;
    }
    // Check if tie at advancing points
    const tiedParticipants = participants.filter((x)=>x.tournamentPoints === advancingPoints);
    if (tiedParticipants.length > 1) {
        // Create sub table of max participants
        for (const p of tiedParticipants){
            const opponents = tiedParticipants.filter((x)=>x.$loki !== p.$loki);
            for (const m of groupMatches){
                const matchParticipants = await (0, $i7bmn.getMatchParticipants)(m);
                // Check if participant and an opponent in match participants
                if ((0, $3E8Nt.objectInArray)(p, matchParticipants) && opponents.some((x)=>(0, $3E8Nt.objectInArray)(x, matchParticipants))) {
                    if ([
                        "Double Pin",
                        "Time-limit Draw"
                    ].includes(m.finishName)) p.tempPoints += 1;
                    else if (m.winner === p.name) p.tempPoints += 2;
                }
            }
        }
        if (numberToAdvance === 1) advancing = [
            (0, $3E8Nt.getArrayMaxByProperty)(tiedParticipants, "tempPoints")
        ];
        else {
            // Secondary sort by temp points
            const sortedParticipants = participants.sort((a, b)=>b.tournamentPoints - a.tournamentPoints || b.tempPoints - a.tempPoints);
            advancing = sortedParticipants.slice(0, numberToAdvance);
        }
    }
    return advancing;
}
async function $2fc0a2e2a26fe831$export$10e13d6a2ef64bba(tournament, tournamentRound) {
    // Find all matches of next round
    let matches = (await (0, $4EGpv.getTournamentMatches)(tournament)).filter((x)=>x.tournamentRound === tournamentRound + 1);
    // Reverse, as they are added in reverse order
    matches.reverse();
    return matches;
}
async function $2fc0a2e2a26fe831$export$4b76e365aabb106a(matches, winner, event, pickRandom = false, rosterSuperstars = null, annualTournament = null) {
    // Get first incomplete match and add winner to it
    let availableMatches = [];
    for (const x of matches)if ((await (0, $i7bmn.getMatchParticipants)(x)).length < 2) availableMatches.push(x);
    let matchToAddTo;
    if (pickRandom) matchToAddTo = (0, $3E8Nt.getRandomChoice)(availableMatches);
    else matchToAddTo = availableMatches.find((x)=>x);
    await (0, $i7bmn.addMatchParticipants)(matchToAddTo, [
        winner
    ]);
    // Add feuds and managers if full participants for match (if not annual tournament)
    const matchParticipants = await (0, $i7bmn.getMatchParticipants)(matchToAddTo);
    if (matchParticipants.length === 2) {
        if (!annualTournament) {
            await (0, $6RCLU.addFeudsToMatch)(matchToAddTo, matchParticipants);
            const matchSuperstars = (await Promise.all(matchParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
            if ((0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(matchToAddTo, matchSuperstars, rosterSuperstars, event);
        } else // Add hype for next round matches of annual tournament
        matchToAddTo.hype = await (0, $6RCLU.getHypeForMatch)(matchParticipants, [], [], "pure", annualTournament, matchToAddTo.tournamentRound);
    }
    return matchToAddTo;
}

});

parcelRequire.register("5qFpQ", function(module, exports) {

$parcel$export(module.exports, "gimmickMatchUnlocksData", () => $3f3f81cd5e1675a0$export$1dfcf7e163b29a7b);
const $3f3f81cd5e1675a0$export$1dfcf7e163b29a7b = {
    "Ladder": [
        "Tables",
        "TLC"
    ],
    "Street Fight": [
        "Unsanctioned",
        "LMS",
        "Ambulance"
    ],
    "Steel Cage": [
        "Steel Cell",
        "Hell In A Cell"
    ],
    "Submission": [
        "Loser Leaves"
    ],
    "Pole": [
        "Flag"
    ],
    "Ironman": [
        "Brawl",
        "Casket"
    ],
    "Graphene Cage": [
        "Graphene Cell"
    ],
    "Glacier Escape": [
        "Spaceflight"
    ],
    "Canyon Fight": [
        "Chemical Warfare"
    ]
};

});

parcelRequire.register("fuJHb", function(module, exports) {

$parcel$export(module.exports, "charactersData", () => $b47d1a8c45049dae$export$1ad51d6ac59a9f43);
let $b47d1a8c45049dae$export$1ad51d6ac59a9f43 = [
    {
        "name": "Executive",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Biker",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Royalty",
        "level": 2,
        "tag": "lifestyle",
        "standard": false
    },
    {
        "name": "VIP",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Occultist",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Cowboy",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Foreigner",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Patriot",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Rockstar",
        "level": 2,
        "tag": "lifestyle",
        "standard": false
    },
    {
        "name": "Druggie",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Pirate",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Rich Person",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Spot Monkey",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Big Shot",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Drug Lord",
        "level": 2,
        "tag": "lifestyle",
        "standard": false
    },
    {
        "name": "Philosophist",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    },
    {
        "name": "Abstainer",
        "level": 2,
        "tag": "lifestyle",
        "standard": false
    },
    {
        "name": "Bully",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Sidekick",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Brute",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Lunatic",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Underdog",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Opportunist",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Degenerate",
        "level": 2,
        "tag": "behavior",
        "standard": false
    },
    {
        "name": "Prize Fighter",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Punk",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Enigma",
        "level": 2,
        "tag": "behavior",
        "standard": false
    },
    {
        "name": "Jock",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Child",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Body-builder",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Cheerleader",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Police Officer",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Shoot Fighter",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Movie Star",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Amateur Wrestler",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Sports Star",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Rapper",
        "level": 2,
        "tag": "career",
        "standard": false
    },
    {
        "name": "Singer",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Musician",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Game Dev.",
        "level": 2,
        "tag": "career",
        "standard": false
    },
    {
        "name": "Kickboxer",
        "level": 1,
        "tag": "career",
        "standard": true
    },
    {
        "name": "Undead",
        "level": 2,
        "tag": "fantasy",
        "standard": false
    },
    {
        "name": "Monster",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Cult Leader",
        "level": 2,
        "tag": "fantasy",
        "standard": false
    },
    {
        "name": "Voodoo",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Martian",
        "level": 3,
        "tag": "fantasy",
        "standard": false
    },
    {
        "name": "Demon",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Vampire",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Superhero",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Fighter",
        "level": 1,
        "tag": "standard",
        "standard": true
    },
    {
        "name": "Wrestler",
        "level": 1,
        "tag": "standard",
        "standard": true
    },
    {
        "name": "Superstar",
        "level": 1,
        "tag": "standard",
        "standard": true
    },
    {
        "name": "Rising Star",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Thug",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Mythical Being",
        "level": 1,
        "tag": "fantasy",
        "standard": true
    },
    {
        "name": "Giant",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Veteran",
        "level": 1,
        "tag": "behavior",
        "standard": true
    },
    {
        "name": "Mobster",
        "level": 1,
        "tag": "lifestyle",
        "standard": true
    }
];

});

parcelRequire.register("kpu3X", function(module, exports) {

$parcel$export(module.exports, "getPowerupsData", () => $edbd764cbd661ba6$export$68923618b7dc1cd0);
$parcel$export(module.exports, "buyPowerup", () => $edbd764cbd661ba6$export$7022a6eb537c2d29);
$parcel$export(module.exports, "usePowerup", () => $edbd764cbd661ba6$export$4403eaca0066da5f);
$parcel$export(module.exports, "getPowerupSelections", () => $edbd764cbd661ba6$export$7ff1490ae9cadc20);
$parcel$export(module.exports, "applyPowerup", () => $edbd764cbd661ba6$export$a3d6f22392c8f6b2);
$parcel$export(module.exports, "applyPowerupToSelection", () => $edbd764cbd661ba6$export$cc92fb0a0f7caedf);
$parcel$export(module.exports, "getPowerupsToUnlock", () => $edbd764cbd661ba6$export$1d37da039e7caef6);
$parcel$export(module.exports, "awardPowerup", () => $edbd764cbd661ba6$export$ccab04c4230327c2);
$parcel$export(module.exports, "getPowerupImage", () => $edbd764cbd661ba6$export$36b70a4bdda4034);
$parcel$export(module.exports, "introducePowerupsView", () => $edbd764cbd661ba6$export$5ba7a4a2f2f8dd3);
$parcel$export(module.exports, "introducePowerups", () => $edbd764cbd661ba6$export$93775a05f14b8e3a);

var $14eBR = parcelRequire("14eBR");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $9esFv = parcelRequire("9esFv");

var $98xmD = parcelRequire("98xmD");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $hBIDz = parcelRequire("hBIDz");

var $iQtzn = parcelRequire("iQtzn");

var $i7bmn = parcelRequire("i7bmn");

var $6PzHO = parcelRequire("6PzHO");

var $5ZsVo = parcelRequire("5ZsVo");

var $hekDR = parcelRequire("hekDR");

var $5kTkA = parcelRequire("5kTkA");

var $5NNI6 = parcelRequire("5NNI6");

var $jpMCP = parcelRequire("jpMCP");

var $4K85d = parcelRequire("4K85d");

var $2JFAd = parcelRequire("2JFAd");

var $kZMqI = parcelRequire("kZMqI");

var $8bQDO = parcelRequire("8bQDO");

var $5yA6U = parcelRequire("5yA6U");

var $bZol7 = parcelRequire("bZol7");
async function $edbd764cbd661ba6$export$68923618b7dc1cd0() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const user = (0, $bZol7.loadUser)();
    const powerups = await (0, $9esFv.getCompanyPowerups)(userCompany);
    powerups.sort((a, b)=>a.cost - b.cost || a.$loki - b.$loki);
    const powerupsData = powerups.map((x)=>JSON.parse(JSON.stringify(x)));
    for (const x of powerupsData)x["uid"] = x.$loki;
    // Show WoM powerups as hidden if not unlocked
    let unlocked = false;
    if (user && (0, $98xmD.globalUser).paid) {
        const userPowerups = user.unlockedPowerups;
        if (userPowerups.length) unlocked = true;
    }
    if (!unlocked && userCompany.storyName !== "mars") {
        const wrestlingOnMarsPowerups = [
            {
                "name": "Cyborg",
                "level": 1
            },
            {
                "name": "Neural Control",
                "level": 1
            },
            {
                "name": "Neural Control+",
                "level": 2
            }
        ];
        for (const powerup of wrestlingOnMarsPowerups){
            let data = {};
            data["name"] = powerup.name;
            data["level"] = powerup.level;
            data["storyName"] = "mars";
            data["unlocked"] = false;
            data["stock"] = 0;
            data["unavailable"] = true;
            powerupsData.push(data);
        }
    }
    return powerupsData;
}
async function $edbd764cbd661ba6$export$7022a6eb537c2d29({ uid: uid } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get powerup
    const powerup = await (0, $14eBR.Powerups).get(uid);
    if (!powerup) {
        data["error"] = "powerup-not-found";
        return data;
    }
    // Check if enough points
    if (selectedCompany.points < powerup.cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Add stock
    powerup.stock += 1;
    // Remove points
    selectedCompany.points -= powerup.cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["stock"] = powerup.stock;
    return data;
}
async function $edbd764cbd661ba6$export$4403eaca0066da5f({ uid: uid } = {}) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const powerup = await (0, $14eBR.Powerups).get(uid);
    return $edbd764cbd661ba6$export$7ff1490ae9cadc20(selectedCompany, powerup);
}
async function $edbd764cbd661ba6$export$a3d6f22392c8f6b2({ uid: uid, selectionUid: selectionUid } = {}) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const powerup = await (0, $14eBR.Powerups).get(uid);
    let data = await $edbd764cbd661ba6$export$cc92fb0a0f7caedf(selectedCompany, powerup, selectionUid);
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $edbd764cbd661ba6$export$7ff1490ae9cadc20(company, powerup) {
    let data = {};
    let selections = [];
    const game = await (0, $9esFv.getCompanyGame)(company);
    const companyRosters = await (0, $9esFv.getCompanyRosters)(company);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main", companyRosters);
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "training", companyRosters);
    const trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "trainingAvailable", companyRosters);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    const event = await (0, $8A6FL.getCompanyLatestEvent)(company);
    const championshipSuperstarIds = companyChampionships.map((x)=>x.superstarId);
    const superstarsWithPastGimmicks = [];
    for (const s of rosterSuperstars){
        const gimmicks = await (0, $hBIDz.getSuperstarGimmicks)(s);
        if (gimmicks.length > 1) superstarsWithPastGimmicks.push(s);
    }
    let trainingSuperstars = [];
    if (trainingRoster) trainingSuperstars.push(...await (0, $dl5u4.getRosterSuperstars)(trainingRoster));
    if (trainingAvailableRoster) trainingSuperstars.push(...await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster));
    // Check if stock available
    if (powerup.stock <= 0) {
        data["error"] = "stock-empty";
        return data;
    }
    // Check for already active powerups
    const brandEffects = [
        "allow_other_brands",
        "allow_other_brands_extended"
    ];
    const otherEffects = [
        "increase_matches",
        "raise_multiplier"
    ];
    if (brandEffects.concat(otherEffects).indexOf(powerup.effect) >= 0) // Show brand artifacts as active if any of them has been used
    {
        if (event.activeEffect === powerup.effect || brandEffects.indexOf(event.activeEffect) >= 0 && brandEffects.indexOf(powerup.effect) >= 0) {
            data["error"] = "upcoming-show-active";
            return data;
        }
    }
    function getPowerupSelectionSuperstarsExceptChampions() {
        return getPowerupSelectionSuperstars(rosterSuperstars, true);
    }
    function getPowerupSelectionPastGimmickSuperstars() {
        return getPowerupSelectionSuperstars(rosterSuperstars, false, true, true);
    }
    function getPowerupSelectionAllSuperstars() {
        return getPowerupSelectionSuperstars(rosterSuperstars, false, false);
    }
    function getPowerupSelectionTrainingSuperstars() {
        return getPowerupSelectionSuperstars(trainingSuperstars, false, false);
    }
    function getPowerupSelectionSuperstars(superstars, filterChampions = false, filterRetired = true, filterPastGimmicks = false) {
        if (!superstars) superstars = rosterSuperstars;
        let selectedSuperstars = superstars.filter((x)=>x.activeEffect !== "traded" && !x.dead);
        if (filterRetired) selectedSuperstars = selectedSuperstars.filter((x)=>!x.retired);
        if (filterChampions) selectedSuperstars = selectedSuperstars.filter((x)=>championshipSuperstarIds.indexOf(x.$loki) < 0);
        if (filterPastGimmicks) selectedSuperstars = selectedSuperstars.filter((x)=>(0, $3E8Nt.objectInArray)(x, superstarsWithPastGimmicks));
        return selectedSuperstars.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        });
    }
    function getPowerupSelectionInjuredSuperstars(injuredLimit = 100) {
        let selectedSuperstars = rosterSuperstars.filter((x)=>x.activeEffect !== "traded" && !x.dead && x.injured > 0 && x.injured <= injuredLimit);
        return selectedSuperstars.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        });
    }
    function getPowerupSelectionReturningSuperstars() {
        return getPowerupSelectionInjuredSuperstars(4);
    }
    function getPowerupSelectionRetiredSuperstars() {
        let selectedSuperstars = rosterSuperstars.filter((x)=>x.activeEffect !== "traded" && !x.dead && !x.fullTimeManager && x.retired);
        if (powerup.level === 1) selectedSuperstars = selectedSuperstars.filter((x)=>!x.hallOfFamer);
        else if (powerup.level === 2) selectedSuperstars = selectedSuperstars.filter((x)=>x.hallOfFamer);
        return selectedSuperstars.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        });
    }
    function getPowerupSelectionUnhappySuperstars() {
        let selectedSuperstars = rosterSuperstars.filter((x)=>x.activeEffect !== "traded" && !x.dead && (x.unhappy || x.contractMonthsRemaining !== null));
        return selectedSuperstars.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        });
    }
    function getPowerupSelectionPartTimeSuperstars() {
        let selectedSuperstars = rosterSuperstars.filter((x)=>x.activeEffect !== "traded" && !x.dead && !x.fullTimeManager && x.partTimer && !x.retired && x.activeEffect !== "retirement_return");
        return selectedSuperstars.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        });
    }
    function getPowerupSelectionDeadSuperstars() {
        let selectedSuperstars = rosterSuperstars.filter((x)=>x.activeEffect !== "traded" && x.dead);
        return selectedSuperstars.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        });
    }
    async function getPowerupSelectionCompetitors() {
        let competitors = await (0, $8A6FL.getCpuControlledCompanies)(company, game);
        return competitors.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        });
    }
    async function getPowerupSelectionObjectives() {
        let objectives = (await (0, $9esFv.getCompanyObjectives)(company)).filter((x)=>!x.past && !x.failed && !x.completed);
        return objectives.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        });
    }
    async function getPowerupSelectionMatches() {
        let matches = await (0, $iQtzn.getEventMatches)(event);
        matches.sort((a, b)=>b.order - a.order);
        return Promise.all(matches.map(async (x)=>{
            const participants = await (0, $i7bmn.getMatchParticipants)(x);
            return {
                "name": participants.map((y)=>y.name).join(" vs "),
                "uid": x.$loki
            };
        }));
    }
    async function getPowerupSelectionTrainingFactions() {
        // Add option to select random superstars
        let returnData = [
            {
                "name": "Random",
                "uid": ""
            }
        ];
        let factions = await (0, $6PzHO.getRosterActiveFactions)(trainingRoster);
        returnData.push(...factions.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        }));
        return returnData;
    }
    async function getPowerupSelectionOwnerAndManagers() {
        // Add option to select random superstars
        let returnData = [
            {
                "name": "Owner",
                "uid": ""
            }
        ];
        let managers = rosterSuperstars.filter((x)=>x.fullTimeManager && !x.activeEffect);
        returnData.push(...managers.map((x)=>{
            return {
                "name": x.name,
                "uid": x.$loki
            };
        }));
        return returnData;
    }
    const checkFunctions = {
        "objectives": getPowerupSelectionObjectives,
        "training_superstars": getPowerupSelectionTrainingSuperstars,
        "part_time_superstars": getPowerupSelectionPartTimeSuperstars,
        "returning_superstars": getPowerupSelectionReturningSuperstars,
        "training_factions": getPowerupSelectionTrainingFactions,
        "owner_and_managers": getPowerupSelectionOwnerAndManagers,
        "superstars_except_champions": getPowerupSelectionSuperstarsExceptChampions,
        "past_gimmick_superstars": getPowerupSelectionPastGimmickSuperstars,
        "matches": getPowerupSelectionMatches,
        "injured_superstars": getPowerupSelectionInjuredSuperstars,
        "competitors": getPowerupSelectionCompetitors,
        "unhappy_superstars": getPowerupSelectionUnhappySuperstars,
        "retired_superstars": getPowerupSelectionRetiredSuperstars,
        "dead_superstars": getPowerupSelectionDeadSuperstars,
        "all_superstars": getPowerupSelectionAllSuperstars,
        "superstars": getPowerupSelectionSuperstars
    };
    // Get selections
    if (powerup.selection) {
        selections = await checkFunctions[powerup.selection]();
        if (selections.length <= 0) {
            data["error"] = "not-available";
            data["selectionsType"] = powerup.selection;
            return data;
        }
    }
    data["selections"] = selections;
    data["uid"] = powerup.$loki;
    return data;
}
async function $edbd764cbd661ba6$export$cc92fb0a0f7caedf(company, powerup, selectionUid = null) {
    let data = {};
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const companyRosters = await (0, $9esFv.getCompanyRosters)(company);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main", companyRosters);
    const trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "training", companyRosters);
    const trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "trainingAvailable", companyRosters);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    // Check if stock available
    if (powerup.stock <= 0) {
        data["error"] = "stock-empty";
        return data;
    }
    async function applyPowerupIncreaseMatches() {
        const event = await (0, $8A6FL.getCompanyLatestEvent)(company);
        if (event.activeEffect) {
            data["error"] = "cannot-use-on-event";
            return null;
        }
        // Set active effect
        event.activeEffect = "increase_matches";
        // Get maximum matches and segments
        const productionFacility = (await (0, $9esFv.getCompanyFacilities)(company)).find((x)=>x.name === "Production");
        const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(company);
        const maximumMatchesAndSegments = (0, $5ZsVo.getEventMaximumMatchesAndSegments)(event, parentEvents, productionFacility);
        return `${event.name} has been upgraded to a Mega Show with up to ${maximumMatchesAndSegments} Matches and Segments!`;
    }
    async function applyPowerupAllowOtherBrands(level = 1) {
        const event = await (0, $8A6FL.getCompanyLatestEvent)(company);
        if (event.activeEffect) {
            data["error"] = "cannot-use-on-event";
            return null;
        }
        if (!event.brandName) {
            data["error"] = "event-already-non-exclusive";
            return null;
        }
        // Set active effect
        event.activeEffect = level === 1 ? "allow_other_brands" : "allow_other_brands_extended";
        if (level === 1) return `Superstars from all brands are available to book at ${event.name}!`;
        else return `Superstars from all brands are available to book on all shows up to the next monthly event!`;
    }
    async function applyPowerupAllowOtherBrandsExtended() {
        return applyPowerupAllowOtherBrands(2);
    }
    async function applyPowerupPartTimerAppearances() {
        let text;
        const superstar = await (0, $14eBR.Superstars).get(selectionUid);
        if (powerup.level === 1) {
            let appearances = (0, $3E8Nt.getRandomInt)(3, 9);
            superstar.appearances += appearances;
            text = `${superstar.name} signed on for ${appearances} more appearances this year!`;
        } else if (powerup.level === 2) {
            superstar.appearances = null;
            superstar.partTimer = false;
            text = `${superstar.name} signed on to a full-time deal!`;
            // Add message
            if (company.userControlled) {
                const newMessage = await (0, $hekDR.createResignPowerupMessage)(superstar, game.monthCount, game.year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
        }
        return text;
    }
    async function applyPowerupEarlyReturn() {
        const superstar = await (0, $14eBR.Superstars).get(selectionUid);
        superstar.injured = 0;
        (0, $5kTkA.endSuperstarInjury)(superstar);
        let text = `${superstar.name} has been cleared to immediately return to the ring!`;
        // Add news
        if (game.competitorsPresent) {
            const newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: game.monthCount,
                year: game.year,
                newsType: "injury_return_powerup",
                superstar: superstar
            });
            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                newsItem
            ]);
        }
        // Add message
        if (company.userControlled && (0, $3E8Nt.getRandomInt)(0, 100) <= 20) {
            const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(company);
            const doctor = (0, $8A6FL.getRandomStaffMemberByRole)(companyStaffMembers, "doctor");
            const newMessage = await (0, $hekDR.createInjuryReturnPowerupMessage)(superstar, game.monthCount, game.year, doctor);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        return text;
    }
    async function applyPowerupCallup() {
        let text;
        if (powerup.level === 1) {
            const superstar = await (0, $14eBR.Superstars).get(selectionUid);
            // Transfer to main roster and process
            let transferred = await (0, $jpMCP.transferTalentToRoster)(superstar, mainRoster);
            for (const s of transferred){
                s.activeEffect = null;
                await (0, $5kTkA.removeSuperstarFactionRelationships)(s, game.monthCount, game.year);
                await (0, $5kTkA.removeSuperstarManagerRelationships)(s);
            }
            const superstarTagTeams = await (0, $hBIDz.getSuperstarTagTeams)(superstar);
            const superstarTeam = superstarTagTeams.length > 0 ? superstarTagTeams[0] : null;
            const callupName = superstarTeam ? superstarTeam.name : superstar.name;
            const verbText = superstarTeam ? "have" : "has";
            text = `${callupName} ${verbText} been called up immediately to the Main Roster!`;
            // Add company log
            const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
            await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
            newCompanyLog.text = callupName;
            newCompanyLog.type = "callup";
            newCompanyLog.realYear = game.year;
            await (0, $9esFv.addCompanyCompanyLogs)(company, [
                newCompanyLog
            ]);
        } else if (powerup.level === 2) {
            // Faction
            if (selectionUid) {
                const faction = await (0, $14eBR.Factions).get(selectionUid);
                const factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(faction);
                // Transfer faction superstars
                for (const x of factionSuperstars){
                    let transferred = await (0, $jpMCP.transferTalentToRoster)(x, mainRoster);
                    for (const s of transferred){
                        s.activeEffect = null;
                        await (0, $5kTkA.removeSuperstarManagerRelationships)(s);
                    }
                    // Add company log
                    const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
                    await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
                    newCompanyLog.text = x.name;
                    newCompanyLog.type = "callup";
                    newCompanyLog.realYear = game.year;
                    await (0, $9esFv.addCompanyCompanyLogs)(company, [
                        newCompanyLog
                    ]);
                }
                // Transfer faction
                await (0, $dl5u4.addRosterFactions)(mainRoster, [
                    faction
                ]);
                // Add company log
                const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
                await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
                newCompanyLog.text = faction.name;
                newCompanyLog.type = "callup";
                newCompanyLog.realYear = game.year;
                await (0, $9esFv.addCompanyCompanyLogs)(company, [
                    newCompanyLog
                ]);
                text = `${faction.name} have been immediately called up to the Main Roster!`;
            } else {
                let superstarsToMove = [];
                let teamFound = false;
                let selections = (await (0, $dl5u4.getRosterSuperstars)(trainingRoster)).concat(await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster));
                for (const x of Array((0, $3E8Nt.getRandomInt)(3, 5)).keys())if (selections.length > 0) {
                    let superstarToMove = (0, $3E8Nt.getRandomChoice)(selections);
                    // Transfer superstar
                    let transferred = await (0, $jpMCP.transferTalentToRoster)(superstarToMove, mainRoster);
                    for (const s of transferred){
                        s.activeEffect = null;
                        await (0, $5kTkA.removeSuperstarFactionRelationships)(s, game.monthCount, game.year);
                        await (0, $5kTkA.removeSuperstarManagerRelationships)(s);
                        if ((0, $3E8Nt.objectInArray)(s, selections)) selections = selections.filter((x)=>x.$loki !== s.$loki);
                    }
                    const superstarTagTeams = await (0, $hBIDz.getSuperstarTagTeams)(superstarToMove);
                    const superstarTeam = superstarTagTeams.length > 0 ? superstarTagTeams[0] : null;
                    if (superstarTeam) teamFound = true;
                    const callupName = superstarTeam ? superstarTeam.name : superstarToMove.name;
                    superstarsToMove.push(callupName);
                    // Add company log
                    const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
                    await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
                    newCompanyLog.text = callupName;
                    newCompanyLog.type = "callup";
                    newCompanyLog.realYear = game.year;
                    await (0, $9esFv.addCompanyCompanyLogs)(company, [
                        newCompanyLog
                    ]);
                }
                const verbText = superstarsToMove.length === 1 && !teamFound ? "has" : "have";
                text = `${(0, $3E8Nt.commaSeparate)(superstarsToMove)} ${verbText} been called up immediately to the Main Roster!`;
            }
        }
        return text;
    }
    async function applyPowerupRetirementReturn() {
        const superstar = await (0, $14eBR.Superstars).get(selectionUid);
        superstar.retired = false;
        let text;
        if (powerup.level === 1 || powerup.level === 2) {
            // Temporary return
            superstar.partTimer = true;
            superstar.appearances = 1;
            superstar.activeEffect = "retirement_return";
            text = `${superstar.name} is ready to return to the ring for one last match!`;
            // Add news
            if (game.competitorsPresent) {
                const newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: game.monthCount,
                    year: game.year,
                    newsType: "retirement_return_powerup",
                    superstar: superstar
                });
                await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                    newsItem
                ]);
            }
            // Add message
            if (company.userControlled) {
                const newMessage = await (0, $hekDR.createRetirementReturnPowerupMessage)(superstar, game.monthCount, game.year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
        } else {
            // Full return
            superstar.partTimer = false;
            text = `${superstar.name} is ready to make a full-time return to the ring!`;
            // Add news
            if (game.competitorsPresent) {
                const newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: game.monthCount,
                    year: game.year,
                    newsType: "retirement_return_permanent_powerup",
                    superstar: superstar
                });
                await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                    newsItem
                ]);
            }
            // Add message
            if (company.userControlled) {
                const newMessage = await (0, $hekDR.createRetirementReturnPermanentPowerupMessage)(superstar, game.monthCount, game.year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
        }
        return text;
    }
    async function applyPowerupOneMatch() {
        let text;
        // Add for manager
        if (selectionUid) {
            const superstar = await (0, $14eBR.Superstars).get(selectionUid);
            superstar.activeEffect = "one_match_appearance";
            text = `${superstar.name} is available to be booked for a match!`;
        } else {
            // Check for owner
            if (company.ownerAdded) {
                let owner = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).find((x)=>x.name === company.ownerName);
                if (!owner) {
                    data["error"] = "owner-not-found";
                    return null;
                }
                owner.appearances = (0, $3E8Nt.getRandomInt)(2, 5);
                text = `${owner.name}, the owner of ${company.name}, is ready to step back into the ring!`;
            } else {
                const sortedSuperstars = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).sort((a, b)=>b.popularity - a.popularity);
                let popularity = (0, $3E8Nt.getRandomChoice)(sortedSuperstars.slice(0, 5)).popularity + (0, $3E8Nt.getRandomInt)(-150, 10);
                let owner = await (0, $8bQDO.generateSuperstar)({
                    popularity: popularity,
                    name: company.ownerName,
                    addGraphic: false,
                    notManager: true
                });
                owner.age = (0, $3E8Nt.getRandomInt)(50, 60);
                owner.charisma = 3;
                owner.charismaXp = 300;
                owner.overness = (0, $3E8Nt.getRandomInt)(60, 75);
                owner.partTimer = true;
                owner.appearances = (0, $3E8Nt.getRandomInt)(2, 5);
                await (0, $dl5u4.addRosterSuperstars)(mainRoster, [
                    owner
                ]);
                company.ownerAdded = true;
                company.ownerName = owner.name;
                text = `${owner.name}, the owner of ${company.name}, is ready to step into the ring!`;
            }
            // Add message
            const newMessage = await (0, $hekDR.createOwnerAppearancePowerupMessage)(company, game.monthCount, game.year);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        return text;
    }
    async function applyPowerupRerollGoal() {
        const objective = await (0, $14eBR.Objectives).get(selectionUid);
        const monthsRemaining = 12 - game.monthCount;
        const properties = await (0, $5NNI6.getObjectiveProperties)(objective);
        // Get new objective with same tag but different objective name
        const newObjective = await (0, $5yA6U.generateCompanySingleObjective)(mainRoster, await (0, $9esFv.getCompanyGimmickMatches)(company), game.year, properties[0].tag, companyChampionships, game, properties[0].name, monthsRemaining);
        await (0, $9esFv.removeCompanyObjectives)(company, [
            objective
        ]);
        await (0, $9esFv.addCompanyObjectives)(company, [
            newObjective
        ]);
        let text = `The owner assigned you a new Objective "${newObjective.name}"!`;
        // Add message
        const newMessage = await (0, $hekDR.createChangeObjectivePowerupMessage)(newObjective, company, game.monthCount, game.year);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        return text;
    }
    async function applyStyleChangePowerup() {
        // Change style
        let newStyle;
        if (company.style === "pure") newStyle = "entertainment";
        else if (company.style === "entertainment") newStyle = "pure";
        company.style = newStyle;
        data["style"] = company.style;
        let text = `The company directors agreed to change the company's style to ${(0, $3E8Nt.toTitleCase)(newStyle)}!`;
        // Add message
        if (company.userControlled) {
            const newMessage = await (0, $hekDR.createStyleChangePowerupMessage)(newStyle, company, game.monthCount, game.year);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        return text;
    }
    async function applySendToTrainingPowerup() {
        const superstar = await (0, $14eBR.Superstars).get(selectionUid);
        if ((await (0, $hBIDz.getSuperstarChampionships)(superstar)).length) {
            data["error"] = "champion";
            return null;
        }
        let text = `${superstar.name} has been sent to the Training Roster with a special focus on improving ${superstar.possessivePronoun} popularity!`;
        // Remove tag teams so they don't transfer
        await (0, $5kTkA.removeSuperstarTagTeams)(superstar);
        // Transfer talent to training roster
        let transferred = await (0, $jpMCP.transferTalentToRoster)(superstar, trainingRoster);
        // Set active effect
        for (let s of transferred){
            s.activeEffect = "in_training";
            await (0, $5kTkA.removeSuperstarFactionRelationships)(s, game.monthCount, game.year);
            await (0, $5kTkA.removeSuperstarManagerRelationships)(s);
            s.brandName = null;
        }
        return text;
    }
    async function applyRecruitmentPowerup() {
        // Generate 3-5 superstars and add to training roster
        let superstars = [];
        for (let x of Array((0, $3E8Nt.getRandomInt)(3, 5)).keys()){
            let newSuperstar = await (0, $8bQDO.generateSuperstar)();
            superstars.push(newSuperstar);
        }
        await (0, $dl5u4.addRosterSuperstars)(trainingRoster, superstars);
        let text = `Your Training Center held a tryout. ${(0, $3E8Nt.commaSeparate)(superstars.map((x)=>x.name))} got selected for the Training Roster!`;
        // Add message
        if (company.userControlled) {
            const topSuperstar = (0, $3E8Nt.getArrayMaxByProperty)(superstars, "popularity");
            const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(company);
            const trainer = (0, $8A6FL.getRandomStaffMemberByRole)(companyStaffMembers, "trainer");
            const newMessage = await (0, $hekDR.createRecruitmentPowerupMessage)(topSuperstar, trainer, company, game.monthCount, game.year);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        return text;
    }
    async function applyStaffRecruitmentPowerup() {
        // Generate 3-4 staff members and add to indie available roster
        let staffMembers = [];
        for (let x of Array((0, $3E8Nt.getRandomInt)(3, 4)).keys()){
            let role = (0, $3E8Nt.getRandomChoice)((0, $3E8Nt.staffRoles));
            let newStaffMember = await (0, $8bQDO.generateStaffMember)(role);
            staffMembers.push(newStaffMember);
        }
        const indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
        await (0, $dl5u4.addRosterStaff)(indieAvailableRoster, staffMembers);
        let text = `Your company held a job ad. ${(0, $3E8Nt.commaSeparate)(staffMembers.map((x)=>`${x.name} (${(0, $3E8Nt.toTitleCase)(x.role.replace("_", " "))})`))} listed themselves for hire on the Staff Hiring Board!`;
        // Add message
        if (company.userControlled) {
            const topStaffMember = (0, $3E8Nt.getArrayMaxByProperty)(staffMembers, "level");
            const companyStaffMembers = await (0, $9esFv.getCompanyStaff)(company);
            const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(companyStaffMembers, "talent_manager");
            const newMessage = await (0, $hekDR.createStaffRecruitmentPowerupMessage)(topStaffMember, talentManager, company, game.monthCount, game.year);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        return text;
    }
    async function applyGimmickMatchRoulettePowerup() {
        const match = await (0, $14eBR.Matches).get(selectionUid);
        let availableGimmickMatches = (await (0, $9esFv.getCompanyGimmickMatches)(company)).filter((x)=>x.available && !x.cashinContractName && !x.matchContractName && x.rules === null && x.consequence !== "random_opponent" && !(x.special && x.name === "Femme Fatale"));
        if (!availableGimmickMatches.length) {
            data["error"] = "no-gimmick-matches-available";
            return null;
        }
        if (await (0, $i7bmn.getMatchGimmickMatch)(match)) {
            data["error"] = "gimmick-match-already-present";
            return null;
        }
        match.activeEffect = "gimmick_match_roulette";
        let matchParticipantNames = (await (0, $i7bmn.getMatchParticipants)(match)).map((x)=>x.name).join(" vs ");
        return `A Gimmick Match Roulette will be run on ${matchParticipantNames}!`;
    }
    async function applyRandomPastGimmickPowerup() {
        const superstar = await (0, $14eBR.Superstars).get(selectionUid);
        // Select a random gimmick except the current one
        let gimmicks = await (0, $hBIDz.getSuperstarGimmicks)(superstar);
        let selectedGimmick = (0, $3E8Nt.getRandomChoice)(gimmicks.slice(0, -1));
        // Create and add gimmick to superstar
        let newGimmick = await (0, $jpMCP.createGimmick)(superstar, selectedGimmick.name, null, 0, 0, selectedGimmick.characterBonus);
        superstar.debutNewGimmick = true;
        return `${superstar.name} is ready to debut ${superstar.possessivePronoun} old "${newGimmick.name}" Gimmick!`;
    }
    // WoM
    async function applyPowerupVirtual() {}
    async function applyPowerupHappy() {
        const superstar = await (0, $14eBR.Superstars).get(selectionUid);
        (0, $5kTkA.changeSuperstarMoraleToHappy)(superstar);
        return `With a successful drug delivery and emotional override, ${superstar.name} has been rid of negative emotions!`;
    }
    async function applyPowerupRaisePopularity() {}
    async function applyPowerupInstantHeal() {
        const superstar = await (0, $14eBR.Superstars).get(selectionUid);
        if (superstar.injured > 0) {
            superstar.injured = 0;
            (0, $5kTkA.endSuperstarInjury)(superstar);
        }
        let text = `With new, synthetic parts, ${superstar.name} is ready to return immediately to the ring!`;
        if (powerup.level === 2) {
            // TODO test
            superstar.cyborg = true;
            // Add news todo
            const newsItem = await (0, $kZMqI.createNewsItem)("True Cyborg", "In a revolutionary experiment, {0} had all moving parts replaced by synthetic substitutes. The results of this are unforeseen, but experts think {1} will be free of any possible injuries " + "in the future".format(company.name, superstar.name, superstar.name), game.monthCount, game.year, company);
            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                newsItem
            ]);
            text = `With all moving parts replaced by synthetics, ${superstar.name} will always be ring ready!`;
        }
        return text;
    }
    async function applyPowerupYoungAge() {}
    async function applyPowerupFertilize() {}
    async function applyPowerupClone() {}
    async function applyPowerupSuperstarJump() {
        // Check roster capacity
        const rosterCapacity = (0, $8A6FL.getCompanyRosterCapacity)(company, game);
        const rosterSize = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>!x.retired && !x.dead).length;
        if (rosterSize >= rosterCapacity) {
            data["error"] = "max-roster-capacity";
            return null;
        }
        // Get superstars to move
        const competitor = await (0, $14eBR.Companies).get(selectionUid);
        const competitorMainRoster = await (0, $8A6FL.getCompanyRosterByType)(competitor, "main");
        const selections = [];
        for (const s of (await (0, $dl5u4.getRosterSuperstars)(competitorMainRoster))){
            const c = await (0, $hBIDz.getSuperstarChampionships)(s);
            if (c.length <= 0 && s.activeEffect !== "traded") selections.push(s);
        }
        if (selections.length <= 0) {
            data["error"] = "empty-roster";
            return null;
        }
        // Transfer random superstar
        const superstarToMove = (0, $3E8Nt.getRandomChoice)(selections);
        await (0, $dl5u4.addRosterSuperstars)(mainRoster, [
            superstarToMove
        ]);
        // Reset morale
        (0, $5kTkA.changeSuperstarMoraleToHappy)(superstarToMove);
        // Remove relationships
        await (0, $5kTkA.removeSuperstarTagTeams)(superstarToMove);
        await (0, $5kTkA.removeSuperstarFactionRelationships)(superstarToMove, game.monthCount, game.year);
        await (0, $5kTkA.removeSuperstarManagerRelationships)(superstarToMove);
        superstarToMove.brandName = null;
        let text = `${superstarToMove.name} decided to suddenly leave ${competitor.name} and jump ship to ${company.name}!`;
        // Add news
        const newsItem = await (0, $kZMqI.createNewsItem)("Brain Washed", `In a surprising turn of events, ${superstarToMove.name} decided to jump ship to ${company.name}. Sources are unsure as to how ` + `this exactly happened, but the possibility of a neuron-altering experiment can't be ruled out.`, game.monthCount, game.year, company);
        await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
            newsItem
        ]);
        return text;
    }
    async function applyPowerupRaiseMultiplier() {
        const event = await (0, $8A6FL.getCompanyLatestEvent)(company);
        event.activeEffect = "raise_multiplier";
        return `${event.name} will now be broadcast to Earth, raising its potential fans gained or lost!`;
    }
    async function applyPowerupResurrect() {
        const superstar = await (0, $14eBR.Superstars).get(selectionUid);
        superstar.dead = false;
        // Add news todo
        const newsItem = await (0, $kZMqI.createNewsItem)("Back from the dead", "In a startling experiment, the scientists at {0} managed to bring {0} back from the dead. Experts are puzzled at the success result of the experiment, and it is currently unknown how well " + "{0} can perform in the ring.".format(company.name, superstar.name, superstar.name), game.monthCount, game.year, company);
        await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
            newsItem
        ]);
        return `We managed to restore all non-functioning systems, bringing ${superstar.name} back to life!`;
    }
    const applyFunctions = {
        "callup": applyPowerupCallup,
        "early_return": applyPowerupEarlyReturn,
        "retirement_return": applyPowerupRetirementReturn,
        "part_timer_appearances": applyPowerupPartTimerAppearances,
        "increase_matches": applyPowerupIncreaseMatches,
        "one_match": applyPowerupOneMatch,
        "reroll_goal": applyPowerupRerollGoal,
        "allow_other_brands": applyPowerupAllowOtherBrands,
        "allow_other_brands_extended": applyPowerupAllowOtherBrandsExtended,
        "superstar_jump": applyPowerupSuperstarJump,
        "happy": applyPowerupHappy,
        "instant_heal": applyPowerupInstantHeal,
        "style_change": applyStyleChangePowerup,
        "send_to_training": applySendToTrainingPowerup,
        "recruitment": applyRecruitmentPowerup,
        "staff_recruitment": applyStaffRecruitmentPowerup,
        "gimmick_match_roulette": applyGimmickMatchRoulettePowerup,
        "random_past_gimmick": applyRandomPastGimmickPowerup,
        // TODO
        "virtual": applyPowerupVirtual,
        "raise_multiplier": applyPowerupRaiseMultiplier,
        "raise_popularity": applyPowerupRaisePopularity,
        "young_age": applyPowerupYoungAge,
        "fertilize": applyPowerupFertilize,
        "clone": applyPowerupClone,
        "resurrect": applyPowerupResurrect
    };
    // Apply function
    let func = applyFunctions[powerup.effect];
    let result;
    if (func) result = await func();
    if (result) // Don't remove stock if sandbox mode
    {
        if (!company.userControlled || !game.settings["unlock_all_items"]) powerup.stock -= 1;
    }
    // Get data to return
    data["stock"] = powerup.stock;
    data["result"] = result;
    data["effect"] = powerup.effect;
    const unreadMessages = (await (0, $9esFv.getCompanyMessages)(company)).filter((x)=>!x.read);
    data["unreadMessages"] = unreadMessages.length;
    // Check second story event TODO
    const womEnded = (await (0, $9esFv.getCompanyStoryChoices)(company)).find((x)=>[
            "Ending A 3A",
            "Ending A 3B",
            "Ending B 3A",
            "Ending B 3B"
        ].includes(x.choice));
    return data;
}
function $edbd764cbd661ba6$export$1d37da039e7caef6(powerups) {
    // Find powerup of same effect but one level below, check if unlocked
    let toUnlock = [];
    for (const p of powerups)if (!p.unlocked) {
        // Add level 1 powerups
        if (p.level === 1) toUnlock.push(p);
        else {
            let sameEffectPowerups = powerups.filter((x)=>x.effect === p.effect && x.$loki !== p.$loki);
            for (const x of sameEffectPowerups)if (x.level === p.level - 1 && x.unlocked) toUnlock.push(p);
        }
    }
    return toUnlock;
}
function $edbd764cbd661ba6$export$ccab04c4230327c2(powerups, unlock = false, rare = false) {
    let weights = [];
    // Lower rarity for higher level powerups
    for (const x of powerups){
        let weight = (1000 / x.rarity) ** 2;
        if (rare) {
            if (x.level > 1) weight *= 4;
            else weight /= 3;
        }
        weights.push([
            x,
            weight
        ]);
    }
    // Use weighted choice using powerup rarity
    let powerup = (0, $3E8Nt.weightedChoice)(weights);
    // Set powerup to unlocked
    if (unlock) powerup.unlocked = true;
    // Increase stock
    powerup.stock += 1;
    return powerup;
}
function $edbd764cbd661ba6$export$36b70a4bdda4034(powerup) {
    let level = powerup.level;
    let image;
    if (powerup.storyName === "mars") {
        if (level === 1) image = "experiment_1_icon";
        else if (level === 2) image = "experiment_2_icon";
        else if (level === 3) image = "experiment_3_icon";
    } else {
        if (level === 1) image = (0, $98xmD.globals).game.powerupLevel1;
        else if (level === 2) image = (0, $98xmD.globals).game.powerupLevel2;
        else if (level === 3) image = (0, $98xmD.globals).game.powerupLevel3;
    }
    if (powerup.storyName !== "mars") image = '<img alt="Artifact" class="pulse" src="static/www/static/' + image + '.png"/>';
    else image = '<img alt="Experiment" src="static/www/static/' + image + '.png"/>';
    return image;
}
async function $edbd764cbd661ba6$export$5ba7a4a2f2f8dd3() {
    let data = {};
    let currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    if (!currentGame.settings["unlock_all_items"]) data["powerupIntroduced"] = await $edbd764cbd661ba6$export$93775a05f14b8e3a(userCompany);
    // Get data to return
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(userCompany);
    data["unreadMessages"] = unreadMessages.length;
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $edbd764cbd661ba6$export$93775a05f14b8e3a(company) {
    if (!company.introducedPowerups) {
        let powerups = await (0, $9esFv.getCompanyPowerups)(company);
        if (!powerups.length) return false;
        // Unlock and award a level 1 powerup
        let awardedPowerup;
        if (company.storyName !== "mars") {
            powerups = powerups.filter((x)=>x.level === 1 && !x.storyName && ![
                    "retired_superstars",
                    "returning_superstars",
                    "unhappy_superstars"
                ].includes(x.selection));
            awardedPowerup = $edbd764cbd661ba6$export$ccab04c4230327c2(powerups, true);
        } else {
            awardedPowerup = powerups.find((x)=>x.name === "Virtual");
            awardedPowerup.unlocked = true;
            awardedPowerup.stock = 1;
        }
        if (company.userControlled) {
            let newMessage = await (0, $hekDR.createIntroducePowerupsMessage)(awardedPowerup, company);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        company.introducedPowerups = true;
        return true;
    }
    return false;
}

});
parcelRequire.register("5NNI6", function(module, exports) {

$parcel$export(module.exports, "Objective", () => $439816c503f88962$export$4512ea4580f91533);
$parcel$export(module.exports, "addObjectiveProperties", () => $439816c503f88962$export$ce32650190c69037);
$parcel$export(module.exports, "getObjectiveProperties", () => $439816c503f88962$export$a7235b8d7b44479e);

var $14eBR = parcelRequire("14eBR");
function $439816c503f88962$export$4512ea4580f91533(name) {
    // Boolean
    const completed = false;
    const past = false;
    const failed = false;
    // Strings
    const helpText = null;
    const type = null;
    const eventName = null;
    // Foreign keys
    const companyId = null;
    return {
        name: name,
        completed: completed,
        past: past,
        failed: failed,
        helpText: helpText,
        type: type,
        eventName: eventName,
        companyId: companyId
    };
}
function $439816c503f88962$export$3abb1c2e0938121d(objective) {
    return (0, $14eBR.Companies).find({
        "$loki": objective.companyId
    })[0];
}
function $439816c503f88962$export$ce32650190c69037(objective, properties) {
    properties.forEach((c)=>{
        c.objectiveId = objective.$loki;
    });
}
function $439816c503f88962$export$477a4286f7b879d3(objective, properties) {
    properties.forEach((c)=>{
        c.objectiveId = null;
    });
}
function $439816c503f88962$export$a7235b8d7b44479e(objective) {
    return (0, $14eBR.Properties).find({
        "objectiveId": objective.$loki
    });
}

});

parcelRequire.register("8bQDO", function(module, exports) {

$parcel$export(module.exports, "generateCompany", () => $5f682f3fb959e552$export$7c2ea0ccc9415e86);
$parcel$export(module.exports, "generateSuperstar", () => $5f682f3fb959e552$export$5fa2492bdfa4be32);
$parcel$export(module.exports, "generateTagTeam", () => $5f682f3fb959e552$export$f2eef4e5ded14af2);
$parcel$export(module.exports, "generateTrio", () => $5f682f3fb959e552$export$e59a0ebb2c6be813);
$parcel$export(module.exports, "generateFaction", () => $5f682f3fb959e552$export$6c85662ad163446a);
$parcel$export(module.exports, "generateChampionshipName", () => $5f682f3fb959e552$export$d8a09243cbb975c6);
$parcel$export(module.exports, "generateChampionshipGraphic", () => $5f682f3fb959e552$export$f7ca51af6d99301f);
$parcel$export(module.exports, "filterCompetitorPowerups", () => $5f682f3fb959e552$export$a5b806afefaab762);
$parcel$export(module.exports, "generateCustomStartingCompany", () => $5f682f3fb959e552$export$b3cd59a78badedc4);
$parcel$export(module.exports, "getChampionshipGraphicPlateColor", () => $5f682f3fb959e552$export$618309ddfddc7817);
$parcel$export(module.exports, "getChampionshipGraphicStrapColor", () => $5f682f3fb959e552$export$73315adfcdab1496);
$parcel$export(module.exports, "getChampionshipGraphicGemsColor", () => $5f682f3fb959e552$export$12f6b3d176608696);
$parcel$export(module.exports, "generateGimmickName", () => $5f682f3fb959e552$export$150fb0a3e654fc67);
$parcel$export(module.exports, "generateStaffMember", () => $5f682f3fb959e552$export$c9d63cfe142368ae);
$parcel$export(module.exports, "generateStaffName", () => $5f682f3fb959e552$export$bc5ad4d8c00a56ec);
$parcel$export(module.exports, "generateStaffGraphic", () => $5f682f3fb959e552$export$7fdb797495385a36);

var $3E8Nt = parcelRequire("3E8Nt");

var $5ZsVo = parcelRequire("5ZsVo");

var $5kTkA = parcelRequire("5kTkA");

var $9esFv = parcelRequire("9esFv");

var $iQtzn = parcelRequire("iQtzn");

var $14eBR = parcelRequire("14eBR");

var $dl5u4 = parcelRequire("dl5u4");

var $im36F = parcelRequire("im36F");

var $cMrnz = parcelRequire("cMrnz");

var $dfpYx = parcelRequire("dfpYx");

var $cYLJ6 = parcelRequire("cYLJ6");

var $ivuOU = parcelRequire("ivuOU");

var $hBIDz = parcelRequire("hBIDz");

var $9MKdC = parcelRequire("9MKdC");

var $972Ip = parcelRequire("972Ip");

var $8CUkC = parcelRequire("8CUkC");

var $6PzHO = parcelRequire("6PzHO");

var $jpMCP = parcelRequire("jpMCP");

var $1JSre = parcelRequire("1JSre");

var $dBFC4 = parcelRequire("dBFC4");

var $7Hx0P = parcelRequire("7Hx0P");

var $gFyK0 = parcelRequire("gFyK0");

var $5esHg = parcelRequire("5esHg");

var $l4Fms = parcelRequire("l4Fms");

var $2GWzg = parcelRequire("2GWzg");

var $5JRw3 = parcelRequire("5JRw3");

var $98xmD = parcelRequire("98xmD");

var $i6OYC = parcelRequire("i6OYC");

var $aP7lq = parcelRequire("aP7lq");
async function $5f682f3fb959e552$export$7c2ea0ccc9415e86({ startingEventIndex: startingEventIndex = null, existingCompanyNames: existingCompanyNames = null, superstars: superstars = null, tagTeams: tagTeams = null, ownerName: ownerName = null, month: month = 0, year: year = 0, realYear: realYear = null, game: game = null, uncommonNames: uncommonNames = false, mainRostersOption: mainRostersOption = null }) {
    let ranks = {
        "Main Eventer": 4,
        "Upper Midcarder": 3,
        "Lower Midcarder": 2,
        "Jabroni": 1
    };
    // Create company
    let company = (0, $9esFv.Company)();
    await (0, $14eBR.Companies).insert(company);
    await (0, $dBFC4.addGameCompanies)(game, [
        company
    ]);
    // Add name
    let companyName = $5f682f3fb959e552$var$generateCompanyName(uncommonNames);
    // Check for duplicate company names
    if (existingCompanyNames) while(existingCompanyNames.includes(companyName))companyName = $5f682f3fb959e552$var$generateCompanyName(uncommonNames);
    company.name = companyName;
    // Add owner
    if (ownerName) company.ownerName = ownerName;
    // Add style
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 40) company.style = "entertainment";
    else company.style = "pure";
    // Add real year
    company.realYear = realYear;
    // Generate events
    let existingEventNames = [];
    for (let y of Array(12).keys()){
        let newEvent = await $5f682f3fb959e552$var$generateEvent(existingEventNames);
        await (0, $9esFv.addCompanyEvents)(company, [
            newEvent
        ]);
        existingEventNames.push(newEvent.name);
    }
    // Add starting event with prestige
    let events = await (0, $9esFv.getCompanyEvents)(company);
    let topEvent = (0, $3E8Nt.getArrayMaxByProperty)(events, "xp");
    let parentEvent = events[startingEventIndex];
    let prestige = parentEvent.prestige;
    let startingEventIsTop = parentEvent.$loki === topEvent.$loki;
    let hype = await (0, $5ZsVo.getEventHype)(parentEvent, startingEventIsTop);
    let startingEvent = (0, $iQtzn.Event)(events[startingEventIndex].name);
    await (0, $14eBR.Events).insert(startingEvent);
    startingEvent.prestige = prestige;
    startingEvent.hype = hype;
    await (0, $9esFv.addCompanyEvents)(company, [
        startingEvent
    ]);
    await (0, $iQtzn.addChildEvent)(parentEvent, startingEvent);
    // Set top event xp
    let topXps = {
        "A": 160,
        "B": 80,
        "C": 25
    };
    topEvent.xp = topXps[topEvent.prestige] || 0;
    // Add main roster
    let mainRoster = (0, $dl5u4.Roster)("main");
    await (0, $14eBR.Rosters).insert(mainRoster);
    await (0, $9esFv.addCompanyRosters)(company, [
        mainRoster
    ]);
    // Add superstars
    let rosterSuperstars = [];
    if (superstars) // Keep existing
    rosterSuperstars = superstars;
    else // Generate new
    for (let y of Array((0, $3E8Nt.getRandomInt)(20, 90)).keys()){
        let newSuperstar = await $5f682f3fb959e552$export$5fa2492bdfa4be32({
            indie: true
        });
        rosterSuperstars.push(newSuperstar);
    }
    await (0, $dl5u4.addRosterSuperstars)(mainRoster, rosterSuperstars);
    // Add tag teams
    let rosterTagTeams = [];
    if (tagTeams) rosterTagTeams = tagTeams;
    else {
        let superstars = (0, $3E8Nt.getRandomSample)([
            ...rosterSuperstars
        ], (0, $3E8Nt.getRandomInt)(4, 10));
        let superstarsData = (0, $3E8Nt.getChunks)(superstars, 2);
        for (let z of superstarsData){
            let newTagteam = await $5f682f3fb959e552$export$f2eef4e5ded14af2(z);
            rosterTagTeams.push(newTagteam);
        }
    }
    await (0, $dl5u4.addRosterTagTeams)(mainRoster, rosterTagTeams);
    // Chance to add trios
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 40) {
        let superstars = (0, $3E8Nt.getRandomSample)([
            ...rosterSuperstars
        ], (0, $3E8Nt.getRandomInt)(6, 15));
        let superstarsData = (0, $3E8Nt.getChunks)(superstars, 3);
        for (let z of superstarsData){
            let newTrio = await $5f682f3fb959e552$export$e59a0ebb2c6be813(z);
            rosterTagTeams.push(newTrio);
            await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
                newTrio
            ]);
        }
    }
    // Factions
    let rosterFactions = [];
    let superstarsAvailableForFactions = [
        ...rosterSuperstars
    ];
    if ((0, $98xmD.globalUser).paid) {
        for (let y of Array((0, $3E8Nt.getRandomInt)(2, 5)).keys())if (superstarsAvailableForFactions.length > 8) {
            let factionSuperstars = (0, $3E8Nt.getRandomSample)(superstarsAvailableForFactions, (0, $3E8Nt.getRandomInt)(2, 8));
            superstarsAvailableForFactions = superstarsAvailableForFactions.filter((x)=>!(0, $3E8Nt.objectInArray)(x, factionSuperstars));
            let newFaction = await $5f682f3fb959e552$export$6c85662ad163446a(factionSuperstars, rosterFactions, rosterTagTeams);
            await (0, $dl5u4.addRosterFactions)(mainRoster, [
                newFaction
            ]);
            rosterFactions.push(newFaction);
        }
    }
    // Add training roster
    let trainingRoster = (0, $dl5u4.Roster)("training");
    await (0, $14eBR.Rosters).insert(trainingRoster);
    await (0, $9esFv.addCompanyRosters)(company, [
        trainingRoster
    ]);
    // Add training superstars
    let companyTrainingSuperstars = [];
    if (game.settings["generate_indie_superstars"] !== false) for (let x of Array((0, $3E8Nt.getRandomInt)(10, 14)).keys()){
        let newSuperstar = await $5f682f3fb959e552$export$5fa2492bdfa4be32();
        companyTrainingSuperstars.push(newSuperstar);
    }
    await (0, $dl5u4.addRosterSuperstars)(trainingRoster, companyTrainingSuperstars);
    if (companyTrainingSuperstars.length) {
        // Add training tag teams
        let superstars = (0, $3E8Nt.getRandomSample)([
            ...companyTrainingSuperstars
        ], (0, $3E8Nt.getRandomInt)(2, 4));
        let superstarsData = (0, $3E8Nt.getChunks)(superstars, 2);
        for (let z of superstarsData){
            let newTagteam = await $5f682f3fb959e552$export$f2eef4e5ded14af2(z);
            await (0, $dl5u4.addRosterTagTeams)(trainingRoster, [
                newTagteam
            ]);
        }
        // Chance to add training trios
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 40) {
            let superstars = (0, $3E8Nt.getRandomSample)([
                ...companyTrainingSuperstars
            ], (0, $3E8Nt.getRandomInt)(6, 9));
            let superstarsData = (0, $3E8Nt.getChunks)(superstars, 3);
            for (let z of superstarsData){
                let newTrio = await $5f682f3fb959e552$export$e59a0ebb2c6be813(z);
                await (0, $dl5u4.addRosterTagTeams)(trainingRoster, [
                    newTrio
                ]);
            }
        }
    }
    // Add training available roster
    let trainingAvailableRoster = (0, $dl5u4.Roster)("trainingAvailable");
    await (0, $14eBR.Rosters).insert(trainingAvailableRoster);
    await (0, $9esFv.addCompanyRosters)(company, [
        trainingAvailableRoster
    ]);
    let trainingFutureRoster = (0, $dl5u4.Roster)("trainingFuture");
    await (0, $14eBR.Rosters).insert(trainingFutureRoster);
    await (0, $9esFv.addCompanyRosters)(company, [
        trainingFutureRoster
    ]);
    // Add championships
    let femaleSuperstars = rosterSuperstars.filter((x)=>x.gender === "female");
    let championshipNames = [];
    for (let c of Array((0, $3E8Nt.getRandomInt)(1, 2)).keys()){
        let prestiges = [
            "C",
            "B"
        ];
        // Select gender
        let womens = false;
        let championshipGender = "male";
        if (femaleSuperstars.length > 4 && (0, $3E8Nt.getRandomInt)(0, 100) <= 30) {
            championshipGender = "female";
            womens = true;
        }
        // Generate name, don't allow duplicates
        let rankName;
        let championshipName;
        if (c === 0) {
            rankName = "Main Eventer";
            prestiges.push("A");
        } else rankName = (0, $3E8Nt.getRandomChoice)([
            "Main Eventer",
            "Upper Midcarder",
            "Lower Midcarder",
            "Jabroni"
        ]);
        championshipName = $5f682f3fb959e552$export$d8a09243cbb975c6(company.name, rankName, null, womens);
        while(championshipNames.includes(championshipName))championshipName = $5f682f3fb959e552$export$d8a09243cbb975c6(company.name, rankName, null, womens);
        championshipNames.push(championshipName);
        let newChampionship = (0, $ivuOU.Championship)(championshipName.trim());
        await (0, $14eBR.Championships).insert(newChampionship);
        newChampionship.graphic = $5f682f3fb959e552$export$f7ca51af6d99301f();
        newChampionship.gender = championshipGender;
        newChampionship.rank = rankName;
        await (0, $9esFv.addCompanyChampionships)(company, [
            newChampionship
        ]);
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70 && mainRostersOption !== "draft") {
            // Add champion of same or greater rank of championship
            let eligible = rosterSuperstars.filter((x)=>(ranks[(0, $5kTkA.getRankFromPopularity)(x.popularity)] || 1) >= ranks[rankName] && x.gender === newChampionship.gender);
            if (eligible.length) {
                let champion = (0, $3E8Nt.getRandomChoice)(eligible);
                await (0, $hBIDz.addSuperstarChampionships)(champion, [
                    newChampionship
                ]);
                // Add reign
                let newReign = (0, $9MKdC.ChampionshipReign)(month, year);
                await (0, $14eBR.ChampionshipReigns).insert(newReign);
                await (0, $ivuOU.addChampionshipChampionshipReigns)(newChampionship, [
                    newReign
                ]);
                await (0, $hBIDz.addSuperstarChampionshipReigns)(champion, [
                    newReign
                ]);
            } else newChampionship.vacated = true;
        } else newChampionship.vacated = true;
        // Add prestige
        newChampionship.prestige = (0, $3E8Nt.getRandomChoice)(prestiges);
        newChampionship.highestPrestige = newChampionship.prestige;
        newChampionship.xp = (0, $3E8Nt.championshipPrestigeXps)[newChampionship.prestige] || 0;
        // Add xp over prestige base value
        if (newChampionship.prestige !== "C") newChampionship.xp += 10;
    }
    // Add tag team championships
    let rankName = (0, $3E8Nt.getRandomChoice)([
        "Lower Midcarder",
        "Jabroni"
    ]);
    let championshipName = $5f682f3fb959e552$export$d8a09243cbb975c6(company.name, rankName, "tag-team");
    await $5f682f3fb959e552$var$addNewTagChampionshipsToCompany(championshipName, rankName, company, rosterTagTeams.filter((x)=>!x.trio), "tag-team", month, year);
    // Add trio championships
    let rosterTrios = rosterTagTeams.filter((x)=>x.trio);
    if (rosterTrios.length) {
        rankName = (0, $3E8Nt.getRandomChoice)([
            "Lower Midcarder",
            "Jabroni"
        ]);
        championshipName = $5f682f3fb959e552$export$d8a09243cbb975c6(company.name, rankName, "trio");
        await $5f682f3fb959e552$var$addNewTagChampionshipsToCompany(championshipName, rankName, company, rosterTrios, "trio", month, year);
    }
    // Add standard gimmick matches
    for (let x of (0, $7Hx0P.standardGimmickMatchesData)){
        let newGimmickMatch = {
            ...(0, $cYLJ6.GimmickMatch)(),
            ...JSON.parse(JSON.stringify(x))
        };
        await (0, $14eBR.GimmickMatches).insert(newGimmickMatch);
        await (0, $9esFv.addCompanyGimmickMatches)(company, [
            newGimmickMatch
        ]);
    }
    // Add reputation and fans
    let rosterSize = rosterSuperstars.length;
    // Adjusting for formula and negative values
    rosterSize -= 15;
    if (rosterSize <= 0) rosterSize = 1;
    let reputation = Math.round(rosterSize ** 0.5);
    company.reputation = reputation;
    company.highestReputation = reputation;
    company.fans = (0, $3E8Nt.fanLevels)[reputation - 1];
    company.points = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(500, 1200), 50);
    company.overness = 45 + (0, $3E8Nt.getRandomInt)(-3, 5);
    // Add standard segment and feud items, powerups
    for (let x of (0, $l4Fms.standardSegmentItemsData)){
        let newSegmentItem = {
            ...(0, $cMrnz.SegmentItem)(),
            ...JSON.parse(JSON.stringify(x))
        };
        await (0, $14eBR.SegmentItems).insert(newSegmentItem);
        await (0, $9esFv.addCompanySegmentItems)(company, [
            newSegmentItem
        ]);
    }
    for (let x of (0, $5esHg.standardFeudItemsData)){
        let newFeudItem = {
            ...(0, $im36F.FeudItem)(),
            ...JSON.parse(JSON.stringify(x))
        };
        await (0, $14eBR.FeudItems).insert(newFeudItem);
        await (0, $9esFv.addCompanyFeudItems)(company, [
            newFeudItem
        ]);
    }
    if (company.storyName !== "mars") {
        const standardPowerups = $5f682f3fb959e552$export$a5b806afefaab762((0, $gFyK0.standardPowerupsData));
        for (const x of standardPowerups){
            let newPowerup = {
                ...(0, $dfpYx.Powerup)(),
                ...JSON.parse(JSON.stringify(x))
            };
            await (0, $14eBR.Powerups).insert(newPowerup);
            await (0, $9esFv.addCompanyPowerups)(company, [
                newPowerup
            ]);
        }
    }
    return company;
}
async function $5f682f3fb959e552$export$b3cd59a78badedc4({}) {
    let data = {};
    // Generate company attributes
    let companyName = $5f682f3fb959e552$var$generateCompanyName();
    let companyStyle = (0, $3E8Nt.getRandomInt)(0, 100) <= 60 ? "entertainment" : "pure";
    let ownerGender = (0, $3E8Nt.getRandomInt)(0, 100) <= 60 ? "male" : "female";
    let ownerName = (0, $3E8Nt.generateName)(ownerGender);
    let weeklyShowName = $5f682f3fb959e552$var$generateWeeklyShowName();
    let companySize = (0, $3E8Nt.getRandomChoice)([
        "backyard",
        "indie",
        "national",
        "global"
    ]);
    let companyFinances = (0, $3E8Nt.getRandomChoice)([
        "weak",
        "average",
        "strong",
        "loaded"
    ]);
    // Generate events
    let eventsData = [];
    let prestigesData = [
        [
            "C",
            10
        ],
        [
            "B",
            8
        ],
        [
            "A",
            2
        ]
    ];
    let eventNames = [];
    for(let y = 0; y < 12; y++){
        let eventName = $5f682f3fb959e552$var$generateEventName(eventNames);
        eventNames.push(eventName);
        eventsData.push({
            "name": eventName,
            "prestige": (0, $3E8Nt.weightedChoice)(prestigesData)
        });
    }
    // Generate championships
    let championshipsData = [];
    let championshipName = $5f682f3fb959e552$export$d8a09243cbb975c6(companyName, "Main Eventer");
    championshipsData.push({
        "name": championshipName,
        "prestige": (0, $3E8Nt.getRandomChoice)([
            "A",
            "B"
        ]),
        "division": "singles"
    });
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70) {
        championshipName = $5f682f3fb959e552$export$d8a09243cbb975c6(companyName, "Main Eventer", "tag-team");
        championshipsData.push({
            "name": championshipName,
            "prestige": (0, $3E8Nt.getRandomChoice)([
                "A",
                "B",
                "C"
            ]),
            "division": "tag-team"
        });
    }
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70) {
        championshipName = $5f682f3fb959e552$export$d8a09243cbb975c6(companyName, "Main Eventer", null, true);
        championshipsData.push({
            "name": championshipName,
            "prestige": (0, $3E8Nt.getRandomChoice)([
                "A",
                "B",
                "C"
            ]),
            "division": "singles"
        });
    }
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70) {
        championshipName = $5f682f3fb959e552$export$d8a09243cbb975c6(companyName, "");
        championshipsData.push({
            "name": championshipName,
            "prestige": (0, $3E8Nt.getRandomChoice)([
                "B",
                "C"
            ]),
            "division": "singles"
        });
    }
    // Get data
    data["companyName"] = companyName;
    data["companySize"] = companySize;
    data["companyFinances"] = companyFinances;
    data["companyStyle"] = companyStyle;
    data["ownerName"] = ownerName;
    data["weeklyShowName"] = weeklyShowName;
    data["companyEventsData"] = eventsData;
    data["companyChampionshipsData"] = championshipsData;
    return data;
}
function $5f682f3fb959e552$var$generateWeeklyShowName() {
    let daysOfTheWeek = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ];
    let weeklyShowNames = [
        "Conflict",
        "Showdown",
        "Combat",
        "War",
        "Idols",
        "Explosion",
        "Outbreak",
        "BANG",
        "Eruption",
        "Storm",
        "Surge",
        "Uprising",
        "Flash",
        "Fury",
        "Rage",
        "Destruction",
        "Turmoil",
        "Revolution",
        "Attitude",
        "Recoil",
        "Gauntlet",
        "Mythics",
        "Power",
        "Mayhem",
        "Anarchy",
        "Insanity",
        "Limelight",
        "Gore",
        "Slugfest",
        "Disaster",
        "Pride",
        "Visions",
        "Apocalypse",
        "Nightmare",
        "Horrors"
    ];
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 20) return `${(0, $3E8Nt.getRandomChoice)(daysOfTheWeek)} Night ${(0, $3E8Nt.getRandomChoice)(weeklyShowNames)}`;
    return (0, $3E8Nt.getRandomChoice)(weeklyShowNames);
}
function $5f682f3fb959e552$export$a5b806afefaab762(powerups) {
    return powerups.filter((x)=>![
            "reroll_goal",
            "one_match",
            "staff_recruitment",
            "gimmick_match_roulette"
        ].includes(x.effect));
}
async function $5f682f3fb959e552$var$addNewTagChampionshipsToCompany(name, rankName, company, divisionMembers, teamType = "tag-team", month = 0, year = 0) {
    let divisionsChampionshipsData = {
        "tag-team": 2,
        "trio": 3
    };
    let divisionsChampionships = divisionsChampionshipsData[teamType];
    let newChampionships = Array.from({
        length: divisionsChampionships
    }, ()=>(0, $ivuOU.Championship)(name));
    let graphic = $5f682f3fb959e552$export$f7ca51af6d99301f();
    for (let newChampionship of newChampionships){
        await (0, $14eBR.Championships).insert(newChampionship);
        if (teamType === "trio") newChampionship.trio = true;
        else newChampionship.tagTeam = true;
        newChampionship.rank = rankName;
        newChampionship.graphic = graphic;
        await (0, $9esFv.addCompanyChampionships)(company, [
            newChampionship
        ]);
    }
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70) {
        if (divisionMembers.length) {
            let championTagTeam = (0, $3E8Nt.getRandomChoice)(divisionMembers);
            let championTagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(championTagTeam);
            for(let i = 0; i < newChampionships.length; i++){
                await (0, $hBIDz.addSuperstarChampionships)(championTagTeamSuperstars[i], [
                    newChampionships[i]
                ]);
                // Add reign
                let newReign = (0, $9MKdC.ChampionshipReign)(month, year);
                await (0, $14eBR.ChampionshipReigns).insert(newReign);
                await (0, $ivuOU.addChampionshipChampionshipReigns)(newChampionships[i], [
                    newReign
                ]);
                await (0, $hBIDz.addSuperstarChampionshipReigns)(championTagTeamSuperstars[i], [
                    newReign
                ]);
            }
        } else for (let newChampionship of newChampionships)newChampionship.vacated = true;
    } else for (let newChampionship of newChampionships)newChampionship.vacated = true;
    return newChampionships;
}
function $5f682f3fb959e552$export$d8a09243cbb975c6(companyName, rankName, teamType = null, isWomen = false) {
    const championshipPrefix = (0, $1JSre.formatCompanyNameBackend)(companyName);
    let firstSuffixes = [];
    let suffixes;
    if (rankName === "Main Eventer") suffixes = [
        "World",
        "Global",
        "National",
        "",
        "Heavyweight",
        "Undisputed",
        "World Heavyweight"
    ];
    else suffixes = [
        "Intercontinental",
        "Regional",
        "Hardcore",
        "Legends",
        "Television",
        "International",
        "Rookie",
        "TV",
        "European",
        "Super",
        "Internet",
        "United States",
        "All Action",
        "Ironman",
        "Shoot",
        "North American",
        "People's",
        "United Kingdom",
        "Primetime",
        "Pure",
        "Platinum",
        "Silver"
    ];
    if (teamType) {
        if (teamType === "tag-team") firstSuffixes = [
            "Tag",
            "Tag Team"
        ];
        else if (teamType === "trio") firstSuffixes = [
            "Trios",
            "6 Person",
            "Six-Person"
        ];
    }
    if (isWomen) firstSuffixes = [
        "Women",
        "Women's",
        "Ladies"
    ];
    let championshipName;
    if (teamType || isWomen) {
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 40) championshipName = `${championshipPrefix} ${(0, $3E8Nt.getRandomChoice)(firstSuffixes)} ${(0, $3E8Nt.getRandomChoice)(suffixes)}`;
        else championshipName = `${championshipPrefix} ${(0, $3E8Nt.getRandomChoice)(firstSuffixes)}`;
    } else championshipName = `${championshipPrefix} ${(0, $3E8Nt.getRandomChoice)(suffixes)}`;
    return championshipName;
}
function $5f682f3fb959e552$export$f7ca51af6d99301f() {
    let data = {};
    let centerPlateChoices = (0, $2GWzg.championshipsGraphicsData)["centerPlate"];
    let sidePlatesChoices = (0, $2GWzg.championshipsGraphicsData)["sidePlates"];
    // Select center plate
    let centerPlateObject = (0, $3E8Nt.getRandomChoice)(centerPlateChoices);
    let centerPlateObjectNumber = centerPlateObject["number"];
    let centerPlateColor = [
        $5f682f3fb959e552$export$618309ddfddc7817()
    ];
    data["centerPlate"] = {
        "object": centerPlateObjectNumber,
        "colors": centerPlateColor
    };
    // Set strap
    let strapObjectNumber = centerPlateObject["strapPart"];
    let strapColor = [
        $5f682f3fb959e552$export$73315adfcdab1496()
    ];
    data["strap"] = {
        "object": strapObjectNumber,
        "colors": strapColor
    };
    // Set center gems
    let centerGemsObjectNumber = centerPlateObject["gemPart"];
    let centerGemsColor = [
        $5f682f3fb959e552$export$12f6b3d176608696()
    ];
    data["centerGems"] = {
        "object": centerGemsObjectNumber,
        "colors": centerGemsColor
    };
    // Set side plates
    let sidePlatesObject;
    let sidePlatesObjectNumber;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70) {
        sidePlatesObjectNumber = centerPlateObject["sidePlatesPart"];
        sidePlatesObject = sidePlatesChoices[sidePlatesObjectNumber];
    } else {
        sidePlatesObject = (0, $3E8Nt.getRandomChoice)(sidePlatesChoices);
        sidePlatesObjectNumber = sidePlatesObject["number"];
    }
    let sidePlatesColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 95 ? [
        centerPlateColor
    ] : [
        $5f682f3fb959e552$export$618309ddfddc7817()
    ];
    data["sidePlates"] = {
        "object": sidePlatesObjectNumber,
        "colors": sidePlatesColor
    };
    // Set side gems
    let sideGemsObjectNumber = sidePlatesObject["sideGemsPart"];
    let sideGemsColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 95 ? [
        centerGemsColor
    ] : [
        $5f682f3fb959e552$export$12f6b3d176608696()
    ];
    data["sideGems"] = {
        "object": sideGemsObjectNumber,
        "colors": sideGemsColor
    };
    return data;
}
function $5f682f3fb959e552$export$73315adfcdab1496(excludeMainColors = false, secondaryColorsChance = 95) {
    const mainColors = [
        "0x1D1D1D"
    ];
    const secondaryColors = [
        "0x981E21",
        "0x2F4F7D",
        "0xE5E5E5",
        "0x2F6232",
        "0x83264F",
        "0x3B2363"
    ];
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70 && !excludeMainColors) return (0, $3E8Nt.getRandomChoice)(mainColors);
    else {
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= secondaryColorsChance) return (0, $3E8Nt.getRandomChoice)(secondaryColors);
        else return (0, $3E8Nt.getRandomColor)();
    }
}
function $5f682f3fb959e552$export$618309ddfddc7817(excludeMainColors = false, secondaryColorsChance = 95) {
    const mainColors = [
        "0xC59548",
        "0xDDA240",
        "0xD9B04D",
        "0xD7A018",
        "0xEABF3E",
        "0xC69F29",
        "0xC1B76B"
    ];
    const secondaryColors = [
        "0xF6CDCE",
        "0xD99352",
        "0xB7641C",
        "0xE5E6EA",
        "0xBABABA"
    ];
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70 && !excludeMainColors) return (0, $3E8Nt.getRandomChoice)(mainColors);
    else {
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= secondaryColorsChance) return (0, $3E8Nt.getRandomChoice)(secondaryColors);
        else return (0, $3E8Nt.getRandomColor)();
    }
}
function $5f682f3fb959e552$export$12f6b3d176608696() {
    const mainColors = [
        "0x001E97",
        "0x148A0D",
        "0xC51616",
        "0xCA0F68",
        "0xF4DE39",
        "0xBD1DAC",
        "0xEFEFF0"
    ];
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 80) return (0, $3E8Nt.getRandomChoice)(mainColors);
    else return (0, $3E8Nt.getRandomColor)();
}
function $5f682f3fb959e552$var$generateCompanyName(uncommonNames = false) {
    let words = [];
    // Get number of words using weights
    let numberOfWordsWeights = [];
    for(let numberOfWords in 0, $8CUkC.companyNames)numberOfWordsWeights.push([
        numberOfWords,
        (0, $8CUkC.companyNames)[numberOfWords]["weight"]
    ]);
    let numberOfWords = (0, $3E8Nt.weightedChoice)(numberOfWordsWeights);
    // Get common names
    let namesData = (0, $8CUkC.companyNames)[numberOfWords];
    let firstNames = namesData["first_names"]["common"];
    let middleNames = namesData["middle_names"]["common"];
    let lastNames = namesData["last_names"]["common"];
    // Add uncommon names
    if (uncommonNames) {
        firstNames.push(...namesData["first_names"]["uncommon"]);
        middleNames.push(...namesData["middle_names"]["uncommon"]);
        lastNames.push(...namesData["last_names"]["uncommon"]);
    }
    let firstWord = (0, $3E8Nt.weightedChoice)(firstNames);
    words.push(firstWord);
    // Add middle word if numberOfWords more than 2
    if (numberOfWords > 2) {
        middleNames = middleNames.filter((x)=>!x[0].split(" ").includes(firstWord)); // Prevent duplicate words
        let middleWord = (0, $3E8Nt.weightedChoice)(middleNames);
        words.push(...middleWord.split(" "));
    }
    lastNames = lastNames.filter((x)=>!words.includes(x[0]));
    let lastWord = (0, $3E8Nt.weightedChoice)(lastNames);
    words.push(lastWord);
    // Join words
    return words.join(" ");
}
async function $5f682f3fb959e552$var$generateEvent(existingEventNames = null) {
    let prestigesData = [
        [
            [
                "C",
                5
            ],
            10
        ],
        [
            [
                "B",
                45
            ],
            8
        ],
        [
            [
                "A",
                115
            ],
            2
        ]
    ];
    let eventName = $5f682f3fb959e552$var$generateEventName(existingEventNames);
    let newEvent = (0, $iQtzn.Event)(eventName);
    await (0, $14eBR.Events).insert(newEvent);
    let prestigeData = (0, $3E8Nt.weightedChoice)(prestigesData);
    newEvent.prestige = prestigeData[0];
    newEvent.xp = prestigeData[1];
    return newEvent;
}
function $5f682f3fb959e552$var$generateEventName(existingEventNames = null) {
    let singleNames = [
        "Uncensored",
        "Retribution",
        "Destruction",
        "Carnage",
        "Annihilation",
        "Sabotage",
        "Aggression",
        "Hatred",
        "Alienation",
        "Revulsion",
        "Malice",
        "Evolution",
        "Elimination",
        "Extinction",
        "Genesis",
        "Destiny",
        "Fallout",
        "Hellfire",
        "Heroes",
        "Insanity",
        "Believe",
        "Turmoil",
        "Pride",
        "Overdose",
        "Nightmare",
        "Anarchy",
        "Outbreak",
        "Attitude",
        "Warzone"
    ];
    let prefixes = [
        "Deadly",
        "Bloody",
        "Epic",
        "Legendary",
        "Extreme",
        "Great",
        "Final",
        "Last",
        "Fiery",
        "Global",
        "Violent",
        "Super",
        "Our",
        "Lasting",
        "Dream",
        "Dark",
        "Red",
        "New",
        "Brutal",
        "Mega",
        "Dangerous"
    ];
    let suffixes = [
        "Battle",
        "War",
        "Fight",
        "Fever",
        "Game",
        "Mania",
        "Slam",
        "Assault",
        "Turmoil",
        "Raid",
        "Saturday",
        "Nightmare",
        "Treason",
        "Betrayal",
        "Attack",
        "Revolution",
        "Sunday",
        "Night",
        "Contest",
        "Struggle",
        "Conquest",
        "Havoc",
        "Blast",
        "Thunder",
        "Sunday",
        "Night",
        "Day",
        "Showdown",
        "Clash"
    ];
    let functions = [
        `${(0, $3E8Nt.getRandomChoice)(singleNames)}`,
        `${(0, $3E8Nt.getRandomChoice)(prefixes)} ${(0, $3E8Nt.getRandomChoice)(suffixes)}`
    ];
    let eventName = (0, $3E8Nt.getRandomChoice)(functions);
    // Prevent duplicates
    if (existingEventNames) while(existingEventNames.includes(eventName))eventName = (0, $3E8Nt.getRandomChoice)(functions);
    return eventName;
}
async function $5f682f3fb959e552$export$5fa2492bdfa4be32({ popularity: popularity = null, indie: indie = false, martian: martian = false, name: name = null, gender: gender = null, addGraphic: addGraphic = true, notManager: notManager = false, patreonChance: patreonChance = false, insert: insert = true, generateGimmick: generateGimmick = true } = {}) {
    // Get gender
    if (!gender) {
        gender = "male";
        if (!martian) {
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 30) {
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) gender = "non-binary";
                else gender = "female";
            }
        }
    }
    // Get name
    if (name === null) name = (0, $3E8Nt.generateName)(gender, null, martian);
    // Get age and part timer
    let partTimer;
    let age;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) {
        partTimer = true;
        age = (0, $3E8Nt.getRandomInt)(28, 40);
    } else {
        partTimer = false;
        age = (0, $3E8Nt.getRandomInt)(18, 32);
    }
    // Get popularity and fotc
    if (!popularity) {
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 80 || !indie) popularity = (0, $3E8Nt.getRandomInt)(100, 820);
        else popularity = (0, $3E8Nt.getRandomInt)(820, 1030);
    }
    popularity = (0, $3E8Nt.myround)(popularity, 5);
    let faceOfTheCompany = popularity >= 1000;
    // Create superstar
    const superstar = (0, $hBIDz.Superstar)(name, popularity, age);
    if (insert) await (0, $14eBR.Superstars).insert(superstar);
    superstar.highestRank = (0, $5kTkA.getRankFromPopularity)(superstar.popularity);
    superstar.partTimer = partTimer;
    superstar.faceOfTheCompany = faceOfTheCompany;
    if (superstar.partTimer) superstar.appearances = (0, $jpMCP.getPartTimerAppearances)(superstar);
    superstar.overness = (0, $3E8Nt.getRandomInt)(25, 75);
    superstar.alignment = (0, $3E8Nt.getRandomChoice)([
        null,
        "face",
        "heel"
    ]);
    superstar.gender = gender;
    superstar.pronoun = (0, $3E8Nt.getRosterMemberPronoun)(superstar);
    superstar.possessivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(superstar, "possessive");
    superstar.objectivePronoun = (0, $3E8Nt.getRosterMemberPronoun)(superstar, "objective");
    // Add graphic
    if (addGraphic) superstar.graphic = $5f682f3fb959e552$export$f981621c566b714f(superstar, martian);
    // Add charisma and workrate
    const xpsData = {
        2: 100,
        1: 0
    };
    superstar.charisma = (0, $3E8Nt.getRandomInt)(1, 2);
    superstar.workrate = (0, $3E8Nt.getRandomInt)(1, 2);
    superstar.charismaXp = xpsData[superstar.charisma];
    superstar.workrateXp = xpsData[superstar.workrate];
    // Add manager
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10 && !notManager) superstar.fullTimeManager = true;
    // Add gimmick
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 25 && !patreonChance && generateGimmick) {
        let newGimmick = (0, $i6OYC.Gimmick)();
        await (0, $14eBR.Gimmicks).insert(newGimmick);
        newGimmick.name = $5f682f3fb959e552$export$150fb0a3e654fc67();
        await (0, $hBIDz.addSuperstarGimmicks)(superstar, [
            newGimmick
        ]);
        superstar.debutNewGimmick = true;
    }
    // Add traits
    superstar.traits = $5f682f3fb959e552$var$generateSuperstarTraits();
    // Chance to add patreon superstar
    if (patreonChance && (0, $3E8Nt.getRandomInt)(0, 100) <= 25) {
        let patreonSuperstars = JSON.parse(localStorage.getItem("patreonSuperstarsData")) || [];
        if (patreonSuperstars.length) {
            let patreonSuperstar = (0, $3E8Nt.getRandomChoice)(patreonSuperstars);
            superstar.name = patreonSuperstar.name;
            if (patreonSuperstar.graphic) superstar.graphic = patreonSuperstar.graphic;
            if (patreonSuperstar.traits) superstar.traits = patreonSuperstar.traits;
            if (patreonSuperstar.gender) superstar.gender = patreonSuperstar.gender;
            if (patreonSuperstar.alignment) superstar.alignment = patreonSuperstar.alignment;
            if (patreonSuperstar.age) superstar.age = patreonSuperstar.age;
            let newGimmick = (0, $i6OYC.Gimmick)();
            await (0, $14eBR.Gimmicks).insert(newGimmick);
            newGimmick.name = "Patron";
            await (0, $hBIDz.addSuperstarGimmicks)(superstar, [
                newGimmick
            ]);
            superstar.debutNewGimmick = true;
        }
    }
    return superstar;
}
function $5f682f3fb959e552$var$generateSuperstarTraits() {
    let traits = [];
    let addTraitChance = 80;
    let allTraits = Object.keys((0, $aP7lq.traitsData)).filter((x)=>x !== "Match Expert");
    while((0, $3E8Nt.getRandomInt)(0, 100) <= addTraitChance && traits.length < 3){
        let trait = (0, $3E8Nt.getRandomChoice)(allTraits);
        allTraits = allTraits.filter((x)=>x !== trait && !(0, $aP7lq.traitsData)[trait]["conflicting_traits"].includes(x));
        traits.push(trait);
        addTraitChance /= 1.5;
    }
    return traits;
}
function $5f682f3fb959e552$export$f981621c566b714f(superstar, martian = false) {
    const data = {};
    // Get parts
    let accessoryChoices = (0, $2GWzg.graphicsData)["accessories"];
    let bottomsChoices = (0, $2GWzg.graphicsData)["bottoms"];
    let hairChoices = (0, $2GWzg.graphicsData)["hairs"];
    let facialHairObjectNumber = -1;
    let torsoObjectNumber = -1;
    let facialHairObject = null;
    let torsoObject = null;
    const partsSelection = superstar.gender === "male" ? "masculine" : superstar.gender === "female" ? "feminine" : (0, $3E8Nt.getRandomChoice)([
        "masculine",
        "feminine"
    ]);
    // Set masculine parts
    if (partsSelection === "masculine") {
        // Bottoms
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 95) bottomsChoices = bottomsChoices.filter((x)=>x["style"] === "masculine");
        else bottomsChoices = bottomsChoices.filter((x)=>x["style"] === "feminine");
        // Hair
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 95) hairChoices = hairChoices.filter((x)=>x["style"] === "masculine");
        else hairChoices = hairChoices.filter((x)=>x["style"] === "feminine");
        // Facial hair
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) {
            facialHairObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["facial_hairs"]);
            facialHairObjectNumber = facialHairObject["number"];
        }
        // Torso
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 25) {
            let torsoChoices;
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 95) torsoChoices = (0, $2GWzg.graphicsData)["torsos"].filter((x)=>x["style"] === "masculine");
            else torsoChoices = (0, $2GWzg.graphicsData)["torsos"].filter((x)=>x["style"] === "feminine");
            torsoObject = (0, $3E8Nt.getRandomChoice)(torsoChoices);
            torsoObjectNumber = torsoObject["number"];
        }
        // Accessory
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 95) accessoryChoices = accessoryChoices.filter((x)=>x["style"] === "masculine");
        else accessoryChoices = accessoryChoices.filter((x)=>x["style"] === "feminine");
    } else if (partsSelection === "feminine") {
        // Bottoms
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) bottomsChoices = bottomsChoices.filter((x)=>x["style"] === "masculine");
        else bottomsChoices = bottomsChoices.filter((x)=>x["style"] === "feminine");
        // Hair
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) hairChoices = hairChoices.filter((x)=>x["style"] === "masculine");
        else hairChoices = hairChoices.filter((x)=>x["style"] === "feminine");
        // Facial hair
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 1) {
            facialHairObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["facial_hairs"]);
            facialHairObjectNumber = facialHairObject["number"];
        }
        // Torso
        let torsoChoices;
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) torsoChoices = (0, $2GWzg.graphicsData)["torsos"].filter((x)=>x["style"] === "masculine");
        else torsoChoices = (0, $2GWzg.graphicsData)["torsos"].filter((x)=>x["style"] === "feminine");
        torsoObject = (0, $3E8Nt.getRandomChoice)(torsoChoices);
        torsoObjectNumber = torsoObject["number"];
        // Accessory
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 20) accessoryChoices = accessoryChoices.filter((x)=>x["style"] === "masculine");
        else accessoryChoices = accessoryChoices.filter((x)=>x["style"] === "feminine");
    }
    // REQUIRED PARTS
    // Body
    let bodyObject;
    if (partsSelection === "masculine") bodyObject = 0;
    else if (partsSelection === "feminine") bodyObject = 3;
    else bodyObject = 0;
    // Body color
    let bodyColor;
    if (!martian) bodyColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 99 ? (0, $3E8Nt.getRandomChoice)((0, $2GWzg.bodyColorsList)) : (0, $3E8Nt.getRandomColor)();
    else bodyColor = "0xD2FFAF";
    data["body"] = {
        "object": bodyObject,
        "colors": [
            bodyColor
        ]
    };
    // Eyes
    const eyesObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["eyes"]);
    const eyesObjectNumber = eyesObject["number"];
    // Eyes color
    const eyesColors = [];
    for (const x of Array(eyesObject["designs"]).keys()){
        const eyesColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 95 ? "0x000000" : (0, $3E8Nt.getRandomColor)();
        eyesColors.push(eyesColor);
    }
    data["eyes"] = {
        "object": eyesObjectNumber,
        "colors": eyesColors
    };
    // Shoes
    const shoesObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["shoes"]);
    const shoesObjectNumber = shoesObject["number"];
    // Shoes color
    const shoesColors = [];
    let shoeColor = null;
    for (const x of Array(shoesObject["designs"]).keys()){
        if (shoeColor) {
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) shoeColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 70 ? shoeColor = $5f682f3fb959e552$var$getSimilarColor(shoeColor) : (0, $3E8Nt.getRandomColor)();
        } else shoeColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 30 ? "0x1E1E1E" : (0, $3E8Nt.getRandomColor)();
        shoesColors.push(shoeColor);
    }
    data["shoes"] = {
        "object": shoesObjectNumber,
        "colors": shoesColors
    };
    // Bottoms
    const bottomsObject = (0, $3E8Nt.getRandomChoice)(bottomsChoices);
    const bottomsObjectNumber = bottomsObject["number"];
    // Bottoms color
    const bottomsColors = [];
    let bottomsColor = null;
    for (const x of Array(bottomsObject["designs"]).keys()){
        if (bottomsColor) {
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 75) bottomsColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 50 ? bottomsColor = $5f682f3fb959e552$var$getSimilarColor(bottomsColor) : (0, $3E8Nt.getRandomColor)();
        } else bottomsColor = (0, $3E8Nt.getRandomColor)();
        bottomsColors.push(bottomsColor);
    }
    data["bottoms"] = {
        "object": bottomsObjectNumber,
        "colors": bottomsColors
    };
    // Hair
    const hairObject = (0, $3E8Nt.getRandomChoice)(hairChoices);
    const hairObjectNumber = hairObject["number"];
    // Hair color
    const hairColors = [];
    let hairColor = null;
    for (const x of Array(hairObject["designs"]).keys()){
        if (hairColor) {
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 20) hairColor = (0, $3E8Nt.getHairColor)();
        } else hairColor = (0, $3E8Nt.getHairColor)();
        hairColors.push(hairColor);
    }
    data["hair"] = {
        "object": hairObjectNumber,
        "colors": hairColors
    };
    // OPTIONAL PARTS
    // Elbow
    let elbowObjectNumber = -1;
    let elbowObject = null;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 20) {
        elbowObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["elbows"]);
        elbowObjectNumber = elbowObject["number"];
    }
    // Elbow color
    const elbowColors = [];
    if (elbowObjectNumber >= 0) for (const x of Array(elbowObject["designs"]).keys()){
        let elbowColor;
        if (x > 0) elbowColor = (0, $3E8Nt.getRandomColor)();
        else elbowColor = shoeColor;
        elbowColors.push(elbowColor);
    }
    data["elbow"] = {
        "object": elbowObjectNumber,
        "colors": elbowColors
    };
    // Kneepad
    let kneeObjectNumber = -1;
    let kneeObject = null;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 20) {
        kneeObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["kneepads"]);
        kneeObjectNumber = kneeObject["number"];
    }
    // Kneepad color
    const kneeColors = [];
    if (kneeObjectNumber >= 0) for (const x of Array(kneeObject["designs"]).keys()){
        let kneeColor;
        if (x > 0) kneeColor = (0, $3E8Nt.getRandomColor)();
        else kneeColor = shoeColor;
        kneeColors.push(kneeColor);
    }
    data["knee"] = {
        "object": kneeObjectNumber,
        "colors": kneeColors
    };
    // Facepaint
    let facepaintObjectNumber = -1;
    let facepaintObject = null;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) {
        facepaintObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["facepaints"]);
        facepaintObjectNumber = facepaintObject["number"];
    }
    // Facepaint color
    const facepaintColors = [];
    if (facepaintObjectNumber >= 0) for (const x of Array(facepaintObject["designs"]).keys()){
        const facepaintColor = (0, $3E8Nt.getRandomColor)();
        facepaintColors.push(facepaintColor);
    }
    data["facepaint"] = {
        "object": facepaintObjectNumber,
        "colors": facepaintColors
    };
    // Tattoos
    let tattooObjectNumber = -1;
    let tattooObject = null;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) {
        tattooObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["tattoos"]);
        tattooObjectNumber = tattooObject["number"];
    }
    // Tattoo color
    const tattooColors = [];
    if (tattooObjectNumber >= 0) for (const x of Array(tattooObject["designs"]).keys()){
        const tattooColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 95 ? "0x555555" : (0, $3E8Nt.getRandomColor)();
        tattooColors.push(tattooColor);
    }
    data["tattoo"] = {
        "object": tattooObjectNumber,
        "colors": tattooColors
    };
    // Facial hair color
    const facialHairColors = [];
    let facialHairColor = hairColor;
    if (facialHairObjectNumber >= 0) for (const x of Array(facialHairObject["designs"]).keys())facialHairColors.push(facialHairColor);
    data["facialHair"] = {
        "object": facialHairObjectNumber,
        "colors": facialHairColors
    };
    // Torso color
    const torsoColors = [];
    let torsoColor = null;
    if (torsoObjectNumber >= 0) for (const x of Array(torsoObject["designs"]).keys()){
        if (torsoColor) {
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 75) torsoColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 50 ? torsoColor = $5f682f3fb959e552$var$getSimilarColor(torsoColor) : (0, $3E8Nt.getRandomColor)();
        } else torsoColor = (0, $3E8Nt.getRandomColor)();
        torsoColors.push(torsoColor);
    }
    data["torso"] = {
        "object": torsoObjectNumber,
        "colors": torsoColors
    };
    // Accessories
    let accessoryObject;
    let accessoryObjectNumber = -1;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) {
        accessoryObject = (0, $3E8Nt.getRandomChoice)(accessoryChoices);
        accessoryObjectNumber = accessoryObject["number"];
    }
    const accessoryColors = [];
    if (accessoryObjectNumber >= 0) {
        let accessoryColor = null;
        for (const x of Array(accessoryObject["designs"]).keys()){
            if (accessoryColor) {
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) accessoryColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 75 ? accessoryColor = $5f682f3fb959e552$var$getSimilarColor(accessoryColor) : (0, $3E8Nt.getRandomColor)();
            } else accessoryColor = (0, $3E8Nt.getRandomColor)();
            accessoryColors.push(accessoryColor);
        }
    }
    data["accessory"] = {
        "object": accessoryObjectNumber,
        "colors": accessoryColors
    };
    let accessory2Object;
    let accessory2ObjectNumber = -1;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) {
        accessory2Object = (0, $3E8Nt.getRandomChoice)(accessoryChoices);
        accessory2ObjectNumber = accessory2Object["number"];
    }
    const accessory2Colors = [];
    if (accessory2ObjectNumber >= 0) {
        let accessory2Color = null;
        for (const x of Array(accessory2Object["designs"]).keys()){
            if (accessory2Color) {
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) accessory2Color = (0, $3E8Nt.getRandomInt)(0, 100) <= 75 ? accessory2Color = $5f682f3fb959e552$var$getSimilarColor(accessory2Color) : (0, $3E8Nt.getRandomColor)();
            } else accessory2Color = (0, $3E8Nt.getRandomColor)();
            accessory2Colors.push(accessory2Color);
        }
    }
    data["accessory2"] = {
        "object": accessory2ObjectNumber,
        "colors": accessory2Colors
    };
    let accessory3Object;
    let accessory3ObjectNumber = -1;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) {
        accessory3Object = (0, $3E8Nt.getRandomChoice)(accessoryChoices);
        accessory3ObjectNumber = accessory3Object["number"];
    }
    const accessory3Colors = [];
    if (accessory3ObjectNumber >= 0) {
        let accessory3Color = null;
        for (const x of Array(accessory3Object["designs"]).keys()){
            if (accessory3Color) {
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) accessory3Color = (0, $3E8Nt.getRandomInt)(0, 100) <= 75 ? accessory3Color = $5f682f3fb959e552$var$getSimilarColor(accessory3Color) : (0, $3E8Nt.getRandomColor)();
            } else accessory3Color = (0, $3E8Nt.getRandomColor)();
            accessory3Colors.push(accessory3Color);
        }
    }
    data["accessory3"] = {
        "object": accessory3ObjectNumber,
        "colors": accessory3Colors
    };
    return data;
}
async function $5f682f3fb959e552$export$f2eef4e5ded14af2(superstars) {
    const names = {
        prefix: [
            "The",
            "Big",
            "Dangerous",
            "American",
            "Universal",
            "The",
            "Wasted",
            "Natural",
            "Stiff",
            "Hard",
            "Beat Down",
            "Fabulous",
            "The",
            "Wild",
            "The",
            "Rebel",
            "Hope",
            "Hate",
            "Hell",
            "Undisputed",
            "Top",
            "Dirty",
            "Fancy",
            "Ultimate",
            "Pretty",
            "The",
            "Lion",
            "Torn",
            "Deadly",
            "Danger",
            "Ultimate",
            "Undisputed",
            "Gorgeous",
            "Glorious",
            "Odd",
            "Thunder",
            "Raw"
        ],
        suffixes: [
            "Killers",
            "Butchers",
            "Legends",
            "Guys",
            "Destroyers",
            "Busters",
            "Team",
            "Crew",
            "Brothers",
            "Express",
            "Foundation",
            "Beta",
            "Damnation",
            "Grapplers",
            "Fighters",
            "Survivors",
            "Emergence",
            "Future",
            "Disruptors",
            "Warriors",
            "Duo",
            "Squad",
            "Bodies",
            "Twins",
            "Bunch",
            "Boys",
            "Fighters",
            "Stars",
            "Boyz",
            "Dream",
            "Gang",
            "Club",
            "Squad"
        ]
    };
    let firstSuperstarName = superstars[0].name;
    let secondSuperstarName = superstars[1].name;
    const s1NameSplit = firstSuperstarName.split(" ");
    const s2NameSplit = secondSuperstarName.split(" ");
    const choices = [
        `${s1NameSplit[s1NameSplit.length - 1]} & ${s2NameSplit[s2NameSplit.length - 1]}`,
        `${s1NameSplit[s1NameSplit.length - 1]} and ${s2NameSplit[s2NameSplit.length - 1]}`,
        `${(0, $3E8Nt.getRandomChoice)(names.prefix)} ${(0, $3E8Nt.getRandomChoice)(names.suffixes)}`
    ];
    // Add joint names if long enough
    if (s1NameSplit[s1NameSplit.length - 1].length > 4 && s2NameSplit[s2NameSplit.length - 1].length > 4) choices.push(`${s1NameSplit[s1NameSplit.length - 1].substring(0, (0, $3E8Nt.getRandomInt)(2, s1NameSplit[s1NameSplit.length - 1].length))}` + `${s2NameSplit[s2NameSplit.length - 1].substring(0, (0, $3E8Nt.getRandomInt)(2, s2NameSplit[s2NameSplit.length - 1].length))}`);
    // Add family names
    let name;
    if (s1NameSplit[s1NameSplit.length - 1] === s2NameSplit[s2NameSplit.length - 1]) name = `${s1NameSplit[s1NameSplit.length - 1]} ${(0, $3E8Nt.getRandomChoice)(names.suffixes)}`;
    else name = (0, $3E8Nt.getRandomChoice)(choices);
    const newTagTeam = (0, $972Ip.TagTeam)(name);
    await (0, $14eBR.TagTeams).insert(newTagTeam);
    await (0, $972Ip.addTagTeamSuperstars)(newTagTeam, superstars);
    return newTagTeam;
}
async function $5f682f3fb959e552$export$e59a0ebb2c6be813(superstars) {
    const names = {
        prefix: [
            "The",
            "Huge",
            "Hot",
            "Global",
            "The",
            "Angry",
            "Natural",
            "Stiff",
            "Disaster",
            "Beat Down",
            "Pyro",
            "The",
            "Wild",
            "The",
            "Rebel",
            "Hope",
            "Hate",
            "Heaven",
            "Undisputed",
            "Top",
            "Pretty",
            "The",
            "Tiger",
            "Torn",
            "Deadly",
            "Humongous",
            "The",
            "Danger",
            "Ultimate",
            "Cool",
            "Odd",
            "Snow",
            "Rainbow",
            "Thunder",
            "Hungry",
            "Fierce",
            "Unholy",
            "Force",
            "Headlock",
            "Dropkick",
            "Power",
            "New",
            "X",
            "Full",
            "The",
            "Mean"
        ],
        suffixes: [
            "Trinity",
            "Team",
            "Opposition",
            "Alliance",
            "Pact",
            "Group",
            "Era",
            "People",
            "Three",
            "Trio",
            "Mafia",
            "3",
            "Treble",
            "Triple",
            "Triad",
            "Band",
            "Club",
            "Faction",
            "Gang",
            "Party",
            "Clique",
            "Crew",
            "Posse",
            "Fellas",
            "Squad",
            "Evolution",
            "Wrestlers",
            "Coalition",
            "Style",
            "Animals",
            "Threat",
            "World Order",
            "Dragons",
            "Family",
            "Generation"
        ]
    };
    const name = `${(0, $3E8Nt.getRandomChoice)(names.prefix)} ${(0, $3E8Nt.getRandomChoice)(names.suffixes)}`;
    const newTagTeam = (0, $972Ip.TagTeam)(name);
    await (0, $14eBR.TagTeams).insert(newTagTeam);
    newTagTeam.trio = true;
    await (0, $972Ip.addTagTeamSuperstars)(newTagTeam, superstars);
    return newTagTeam;
}
async function $5f682f3fb959e552$export$6c85662ad163446a(factionSuperstars, rosterFactions, rosterTeams) {
    // Get leader superstar
    let leaderSuperstar = null;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 60) leaderSuperstar = (0, $3E8Nt.getRandomChoice)(factionSuperstars);
    // Get faction name
    let unavailableFactionNames = [
        ...rosterFactions,
        ...rosterTeams
    ].map((x)=>x.name);
    let factionName = $5f682f3fb959e552$var$getRandomFactionName();
    while(unavailableFactionNames.includes(factionName))factionName = $5f682f3fb959e552$var$getRandomFactionName();
    // Create faction
    const { reputation: reputation, xp: xp } = (0, $6PzHO.getFactionCreationReputationAndXp)(factionSuperstars, leaderSuperstar);
    return (0, $6PzHO.createFaction)(factionName, factionSuperstars, reputation, xp, leaderSuperstar);
}
function $5f682f3fb959e552$var$getRandomFactionName() {
    let names = {
        "prefix": [
            "The",
            "Big",
            "Dangerous",
            "American",
            "Universal",
            "The",
            "Natural",
            "Fantastic",
            "Marvelous",
            "Fabulous",
            "The",
            "Wild",
            "The",
            "Rebel",
            "Hell",
            "Undisputed",
            "Top",
            "Fancy",
            "Drug",
            "Ultimate",
            "Pretty",
            "The",
            "Deadly",
            "Ultimate",
            "Undisputed",
            "Gorgeous",
            "Glorious",
            "Thunder",
            "Original",
            "Elite",
            "Premier",
            "Perfect",
            "Street",
            "Executive",
            "Cool",
            "Main Event"
        ],
        "names": [
            "Killers",
            "Legends",
            "Guys",
            "Crew",
            "Express",
            "Foundation",
            "Fighters",
            "Squad",
            "Stars",
            "Gang",
            "Club",
            "Squad",
            "Alliance",
            "Family",
            "Posse",
            "Order",
            "Society",
            "Association",
            "Circle",
            "Corporation",
            "Group",
            "League",
            "Clique",
            "Clan",
            "Gang",
            "Syndicate",
            "Band",
            "Mafia"
        ]
    };
    return `${(0, $3E8Nt.getRandomChoice)(names["prefix"])} ${(0, $3E8Nt.getRandomChoice)(names["names"])}`;
}
async function $5f682f3fb959e552$export$c9d63cfe142368ae(role, level = null) {
    const staffMember = (0, $5JRw3.Staff)();
    staffMember.role = role;
    // Generate gender
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) staffMember.gender = "male";
    else if ((0, $3E8Nt.getRandomInt)(0, 100) <= 75) staffMember.gender = "female";
    else staffMember.gender = "non-binary";
    // Generate name, age, graphic
    staffMember.name = $5f682f3fb959e552$export$bc5ad4d8c00a56ec(staffMember.role, staffMember.gender);
    staffMember.age = (0, $3E8Nt.getRandomInt)(20, 60);
    staffMember.graphic = $5f682f3fb959e552$export$7fdb797495385a36(staffMember.gender, staffMember.role);
    // Add level, affected by age
    if (level === null) {
        const levelWeights = staffMember.age <= 45 ? [
            [
                1,
                35
            ],
            [
                2,
                35
            ],
            [
                3,
                30
            ]
        ] : [
            [
                1,
                10
            ],
            [
                2,
                45
            ],
            [
                3,
                45
            ]
        ];
        level = (0, $3E8Nt.weightedChoice)(levelWeights);
    }
    staffMember.level = level;
    // Add xp
    const xps = {
        1: 0,
        2: 100,
        3: 300
    };
    const xpDeviations = [
        0,
        0,
        0,
        0,
        2,
        4,
        5,
        5,
        6,
        7,
        8,
        8,
        9,
        10,
        10
    ];
    staffMember.xp = (xps[staffMember.level] || 0) + (0, $3E8Nt.getRandomChoice)(xpDeviations);
    // Save
    (0, $14eBR.StaffMembers).insert(staffMember);
    return staffMember;
}
function $5f682f3fb959e552$export$bc5ad4d8c00a56ec(role = null, gender = "male", martian = false) {
    let name;
    let firstNameOptions;
    let firstName;
    if (martian) name = `${(0, $3E8Nt.getRandomChoice)((0, $3E8Nt.staffMartianFirstNames))} ${0, $3E8Nt.staffMartianLastNames}`;
    else {
        if (role === "doctor") firstName = "Dr.";
        else {
            if (gender === "non-binary") firstNameOptions = (0, $3E8Nt.staffFirstNames)["male"].concat((0, $3E8Nt.staffLastNames)["female"]);
            else firstNameOptions = (0, $3E8Nt.staffFirstNames)[gender];
            firstName = (0, $3E8Nt.getRandomChoice)(firstNameOptions);
        }
        let lastName = (0, $3E8Nt.getRandomChoice)((0, $3E8Nt.staffLastNames));
        if (firstName && lastName) name = `${firstName} ${lastName}`;
        else if (firstName) name = firstName;
        else if (lastName) name = lastName;
        else name = "Staff";
    }
    return name;
}
function $5f682f3fb959e552$export$7fdb797495385a36(gender, role = null, martian = false) {
    const data = {};
    let hairChoices = (0, $2GWzg.graphicsData)["hairs"];
    let facialHairObjectNumber = -1;
    let facialHairObject = null;
    // Get staff parts
    let shoes = (0, $2GWzg.graphicsData)["shoes"].filter((x)=>x["staff"]);
    let torsos = (0, $2GWzg.graphicsData)["torsos"].filter((x)=>x["staff"]);
    let bottoms = (0, $2GWzg.graphicsData)["bottoms"].filter((x)=>x["staff"]);
    let accessories = (0, $2GWzg.graphicsData)["accessories"].filter((x)=>x["staff"]);
    if (role === "doctor") accessories = accessories.filter((x)=>x["category"] === "doctor");
    else accessories = accessories.filter((x)=>x["category"] !== "doctor");
    const partsSelection = gender === "male" ? "masculine" : gender === "female" ? "feminine" : (0, $3E8Nt.getRandomChoice)([
        "masculine",
        "feminine"
    ]);
    // Set masculine parts
    if (partsSelection === "masculine") {
        // Hair
        hairChoices = (0, $2GWzg.graphicsData)["hairs"].filter((x)=>x["style"] === "masculine");
        // Facial hair
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) {
            facialHairObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["facial_hairs"]);
            facialHairObjectNumber = facialHairObject["number"];
        }
        // Torsos
        torsos = torsos.filter((x)=>x["style"] !== "feminine");
        // Bottoms
        bottoms = bottoms.filter((x)=>x["style"] !== "feminine");
    } else if (partsSelection === "feminine") {
        hairChoices = (0, $2GWzg.graphicsData)["hairs"].filter((x)=>x["style"] === "feminine");
        // Bottoms
        bottoms = bottoms.filter((x)=>x["style"] !== "masculine");
    }
    // REQUIRED PARTS
    // Body
    let bodyObject;
    if (partsSelection === "masculine") bodyObject = 0;
    else if (partsSelection === "feminine") bodyObject = 3;
    else bodyObject = 0;
    // Body color
    let bodyColor;
    if (!martian) bodyColor = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.bodyColorsList));
    else bodyColor = "0xD2FFAF";
    data["body"] = {
        "object": bodyObject,
        "colors": [
            bodyColor
        ]
    };
    // Eyes
    const eyesObject = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.graphicsData)["eyes"]);
    const eyesObjectNumber = eyesObject["number"];
    // Eyes color
    const eyesColors = [];
    for (const x of Array(eyesObject["designs"]).keys()){
        const eyesColor = "0x000000";
        eyesColors.push(eyesColor);
    }
    data["eyes"] = {
        "object": eyesObjectNumber,
        "colors": eyesColors
    };
    // Hair
    const hairObject = (0, $3E8Nt.getRandomChoice)(hairChoices);
    const hairObjectNumber = hairObject["number"];
    // Hair color
    const hairColors = [];
    let hairColor = null;
    for (const x of Array(hairObject["designs"]).keys()){
        if (!hairColor) hairColor = (0, $3E8Nt.getRandomChoice)((0, $2GWzg.hairColorsList));
        hairColors.push(hairColor);
    }
    data["hair"] = {
        "object": hairObjectNumber,
        "colors": hairColors
    };
    // Shoes
    const shoesObject = (0, $3E8Nt.getRandomChoice)(shoes);
    const shoesObjectNumber = shoesObject["number"];
    // Shoes color
    const shoesColors = [];
    let shoeColor = null;
    for (const x of Array(shoesObject["designs"]).keys()){
        if (shoeColor) {
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) {
                if (shoeColor === "0x1E1E1E" && (0, $3E8Nt.getRandomInt)(0, 100) <= 80) shoeColor = $5f682f3fb959e552$var$getSimilarColor(shoeColor, true);
                else shoeColor = $5f682f3fb959e552$var$getSimilarColor(shoeColor);
            }
        } else shoeColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 95 ? (0, $3E8Nt.getRandomChoice)((0, $2GWzg.shoesColorsList)) : (0, $3E8Nt.getRandomColor)();
        shoesColors.push(shoeColor);
    }
    data["shoes"] = {
        "object": shoesObjectNumber,
        "colors": shoesColors
    };
    // Bottoms
    const bottomsObject = (0, $3E8Nt.getRandomChoice)(bottoms);
    const bottomsObjectNumber = bottomsObject["number"];
    // Bottoms color
    const bottomsColors = [];
    let bottomsColor = null;
    for (const x of Array(bottomsObject["designs"]).keys()){
        if (bottomsColor) bottomsColor = $5f682f3fb959e552$var$getSimilarColor(bottomsColor);
        else bottomsColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 95 ? (0, $3E8Nt.getRandomChoice)((0, $2GWzg.pantsColorsList)) : (0, $3E8Nt.getRandomColor)();
        bottomsColors.push(bottomsColor);
    }
    data["bottoms"] = {
        "object": bottomsObjectNumber,
        "colors": bottomsColors
    };
    // Torso
    let torsoObject = (0, $3E8Nt.getRandomChoice)(torsos);
    let torsoObjectNumber = torsoObject["number"];
    // Torso color
    const torsoColors = [];
    if (torsoObjectNumber >= 0) {
        let torsoColor = null;
        for (const x of Array(torsoObject["designs"]).keys()){
            if (torsoColor) {
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 30) torsoColor = $5f682f3fb959e552$var$getSimilarColor(torsoColor, false, "light");
            } else torsoColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 95 ? (0, $3E8Nt.getRandomChoice)((0, $2GWzg.shirtsColorsList)) : (0, $3E8Nt.getRandomColor)();
            torsoColors.push(torsoColor);
        }
    }
    data["torso"] = {
        "object": torsoObjectNumber,
        "colors": torsoColors
    };
    // OPTIONAL PARTS
    // Facial hair
    const facialHairColors = [];
    let facialHairColor = hairColor;
    if (facialHairObjectNumber >= 0) for (const x of Array(facialHairObject["designs"]).keys())facialHairColors.push(facialHairColor);
    data["facialHair"] = {
        "object": facialHairObjectNumber,
        "colors": facialHairColors
    };
    // Accessories
    let accessoryObjectNumber = -1;
    let accessoryObject = null;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50 || role === "doctor") {
        accessoryObject = (0, $3E8Nt.getRandomChoice)(accessories);
        accessoryObjectNumber = accessoryObject["number"];
    }
    const accessoryColors = [];
    if (accessoryObjectNumber >= 0) {
        let accessoryColor = null;
        // Get colors list for specific items
        let colorsList = [];
        if (accessoryObject["category"] === "suit") colorsList = (0, $2GWzg.jacketsColorsList);
        else if (accessoryObject["category"] === "glasses") colorsList = (0, $2GWzg.glassesColorsList);
        else if (accessoryObject["category"] === "doctor") colorsList = (0, $2GWzg.doctorCoatColorsList);
        for (const x of Array(accessoryObject["designs"]).keys()){
            if (accessoryColor) {
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 30) accessoryColor = $5f682f3fb959e552$var$getSimilarColor(accessoryColor, false, "light");
            } else if (colorsList.length > 0) accessoryColor = (0, $3E8Nt.getRandomInt)(0, 100) <= 95 ? (0, $3E8Nt.getRandomChoice)(colorsList) : (0, $3E8Nt.getRandomColor)();
            else accessoryColor = (0, $3E8Nt.getRandomColor)();
            accessoryColors.push(accessoryColor);
        }
    }
    data["accessory"] = {
        "object": accessoryObjectNumber,
        "colors": accessoryColors
    };
    // EMPTY PARTS
    data["elbow"] = {
        "object": -1,
        "colors": []
    };
    data["knee"] = {
        "object": -1,
        "colors": []
    };
    data["facepaint"] = {
        "object": -1,
        "colors": []
    };
    data["tattoo"] = {
        "object": -1,
        "colors": []
    };
    data["accessory2"] = {
        "object": -1,
        "colors": []
    };
    data["accessory3"] = {
        "object": -1,
        "colors": []
    };
    return data;
}
function $5f682f3fb959e552$var$getSimilarColor(color, monochrome = false, luminosity = null) {
    let colorHue;
    if (monochrome) colorHue = "monochrome";
    else colorHue = "#" + color.substring(2);
    const selectedColor = randomColor({
        hue: colorHue,
        luminosity: luminosity
    });
    return "0x" + selectedColor.substring(1);
}
function $5f682f3fb959e552$export$150fb0a3e654fc67() {
    const gimmickNames = [
        "Legend Killer",
        "Grim Reaper",
        "Rock Star",
        "Crime Boss",
        "General Manager",
        "Demon Hunter",
        "Secret Service",
        "Career Killer",
        "Unleashed Animal",
        "Wrestling God",
        "Parole Officer",
        "Crazy Russian",
        "Country Singer",
        "Outdoorsman",
        "Little Dog",
        "Bulldog",
        "Brawler",
        "Romantic",
        "Hugger",
        "Lovesick",
        "Royalty",
        "Comic-book Hero",
        "Comic-book Villain",
        "Supermodel",
        "Hacker",
        "Redneck",
        "Bodyguard",
        "Rebel",
        "Monk",
        "Hypocrite",
        "Hustler",
        "Butcher",
        "Surfer",
        "Skater",
        "Ninja",
        "Iceman",
        "Dancer",
        "Poser",
        "Hoser",
        "Lumberjack"
    ];
    return (0, $3E8Nt.getRandomChoice)(gimmickNames);
}

});
parcelRequire.register("dfpYx", function(module, exports) {

$parcel$export(module.exports, "Powerup", () => $9a50d341c964d975$export$b66492aa06af3011);

var $14eBR = parcelRequire("14eBR");
function $9a50d341c964d975$export$b66492aa06af3011() {
    // Integer
    const stock = 0;
    const cost = null;
    const level = null;
    const rarity = null;
    // Boolean
    const unlocked = false;
    const active = false;
    const hidden = false;
    const standard = false;
    // String
    const name = null;
    const description = null;
    const effect = null;
    const selection = null;
    const storyName = null;
    // Foreign keys
    const companyId = null;
    return {
        stock: stock,
        cost: cost,
        level: level,
        rarity: rarity,
        unlocked: unlocked,
        active: active,
        hidden: hidden,
        standard: standard,
        name: name,
        description: description,
        effect: effect,
        selection: selection,
        storyName: storyName,
        companyId: companyId
    };
}
function $9a50d341c964d975$export$ab9fb81714b51a7f(powerup) {
    return (0, $14eBR.Companies).find({
        "$loki": powerup.companyId
    })[0];
}

});

parcelRequire.register("cYLJ6", function(module, exports) {

$parcel$export(module.exports, "GimmickMatch", () => $97301c1b601e74d9$export$55fe2628712acfcd);
$parcel$export(module.exports, "addGimmickMatchMatches", () => $97301c1b601e74d9$export$e055dc9b8d256979);
$parcel$export(module.exports, "removeGimmickMatchMatches", () => $97301c1b601e74d9$export$b0801eeba7633ada);
$parcel$export(module.exports, "getGimmickMatchCompany", () => $97301c1b601e74d9$export$5eedfde19f4d918);
$parcel$export(module.exports, "addGimmickMatchRandomEvents", () => $97301c1b601e74d9$export$56f1f4a034861d28);

var $14eBR = parcelRequire("14eBR");
function $97301c1b601e74d9$export$55fe2628712acfcd() {
    // Float
    const ratingBoost = null;
    const popularityIncrease = null;
    const popularityDecrease = null;
    const injuryRate = null;
    // Integer
    const cost = null;
    const level = 1;
    const xp = 0;
    const monthsToExpire = 12;
    // Strings
    const name = null;
    const description = null;
    const cashinContractName = null;
    const consequence = null;
    const rules = null;
    const graphicType = null;
    const matchContractName = null;
    // Boolean
    const available = true;
    const generateObject = false;
    const generateLocation = false;
    const standard = false;
    const special = false;
    const addRandomWeapons = false;
    // Foreign keys
    const companyId = null;
    const propertyId = null;
    return {
        ratingBoost: ratingBoost,
        popularityIncrease: popularityIncrease,
        popularityDecrease: popularityDecrease,
        injuryRate: injuryRate,
        cost: cost,
        level: level,
        xp: xp,
        monthsToExpire: monthsToExpire,
        name: name,
        description: description,
        cashinContractName: cashinContractName,
        consequence: consequence,
        rules: rules,
        graphicType: graphicType,
        matchContractName: matchContractName,
        available: available,
        generateObject: generateObject,
        generateLocation: generateLocation,
        standard: standard,
        special: special,
        addRandomWeapons: addRandomWeapons,
        companyId: companyId,
        propertyId: propertyId
    };
}
function $97301c1b601e74d9$export$e055dc9b8d256979(gimmickMatch, matches) {
    matches.forEach((c)=>{
        c.gimmickMatchId = gimmickMatch.$loki;
    });
}
function $97301c1b601e74d9$export$b0801eeba7633ada(gimmickMatch, matches) {
    matches.forEach((c)=>{
        c.gimmickMatchId = null;
    });
}
function $97301c1b601e74d9$export$62e5fb5757718474(gimmickMatch) {
    return (0, $14eBR.Matches).find({
        "gimmickMatchId": gimmickMatch.$loki
    });
}
function $97301c1b601e74d9$export$5eedfde19f4d918(gimmickMatch) {
    return (0, $14eBR.Companies).find({
        "$loki": gimmickMatch.companyId
    })[0];
}
function $97301c1b601e74d9$export$11b85c3f46cce708(gimmickMatch) {
    return (0, $14eBR.Properties).find({
        "$loki": gimmickMatch.propertyId
    })[0];
}
function $97301c1b601e74d9$export$56f1f4a034861d28(gimmickMatch, randomEvents) {
    randomEvents.forEach((c)=>{
        c.gimmickMatchId = gimmickMatch.$loki;
    });
}
function $97301c1b601e74d9$export$82af56e06d964b0f(gimmickMatch, randomEvents) {
    randomEvents.forEach((c)=>{
        c.gimmickMatchId = null;
    });
}
function $97301c1b601e74d9$export$9f99a27f60f16d34(gimmickMatch) {
    return (0, $14eBR.RandomEvents).find({
        "gimmickMatchId": gimmickMatch.$loki
    });
}

});

parcelRequire.register("8CUkC", function(module, exports) {

$parcel$export(module.exports, "companyNames", () => $647d919f429e6530$export$db7590ff8fdeacfe);
const $647d919f429e6530$export$db7590ff8fdeacfe = {
    3: {
        "weight": 62,
        "first_names": {
            "common": [
                [
                    "Pro",
                    103
                ],
                [
                    "World",
                    34
                ],
                [
                    "Wrestling",
                    33
                ],
                [
                    "International",
                    24
                ],
                [
                    "Lucha",
                    22
                ],
                [
                    "All",
                    15
                ],
                [
                    "Independent",
                    15
                ],
                [
                    "Big",
                    15
                ],
                [
                    "Ultimate",
                    14
                ],
                [
                    "American",
                    14
                ],
                [
                    "National",
                    13
                ],
                [
                    "Universal",
                    13
                ],
                [
                    "Southern",
                    13
                ],
                [
                    "Global",
                    12
                ],
                [
                    "Eastern",
                    11
                ],
                [
                    "Xtreme",
                    11
                ],
                [
                    "Championship",
                    10
                ],
                [
                    "Midwest",
                    10
                ],
                [
                    "German",
                    9
                ],
                [
                    "Texas",
                    9
                ],
                [
                    "United",
                    9
                ],
                [
                    "European",
                    9
                ],
                [
                    "Elite",
                    9
                ],
                [
                    "Professional",
                    9
                ],
                [
                    "Extreme",
                    9
                ],
                [
                    "Real",
                    9
                ],
                [
                    "Northern",
                    8
                ],
                [
                    "Premier",
                    8
                ],
                [
                    "Power",
                    8
                ],
                [
                    "Insane",
                    8
                ],
                [
                    "Revolution",
                    8
                ],
                [
                    "Canadian",
                    7
                ],
                [
                    "Full",
                    7
                ],
                [
                    "Great",
                    7
                ],
                [
                    "Continental",
                    6
                ],
                [
                    "Ring",
                    6
                ],
                [
                    "Impact",
                    6
                ],
                [
                    "Australian",
                    6
                ]
            ],
            "uncommon": [
                [
                    "Shooting",
                    0.4
                ],
                [
                    "Spanish",
                    0.4
                ],
                [
                    "Kombat",
                    0.4
                ],
                [
                    "Descension",
                    0.4
                ],
                [
                    "Violent",
                    0.4
                ],
                [
                    "Empress",
                    0.4
                ],
                [
                    "Quaker",
                    0.4
                ],
                [
                    "Arcadian",
                    0.4
                ],
                [
                    "Ultimate",
                    0.4
                ],
                [
                    "Hillbilly",
                    0.4
                ],
                [
                    "Online",
                    0.4
                ],
                [
                    "Super",
                    0.4
                ],
                [
                    "Global",
                    0.4
                ],
                [
                    "Juggalo",
                    0.4
                ],
                [
                    "Squared Circle",
                    0.4
                ],
                [
                    "Dragon",
                    0.4
                ],
                [
                    "XTREME",
                    0.4
                ],
                [
                    "DUDEKARA",
                    0.4
                ]
            ]
        },
        "middle_names": {
            "common": [
                [
                    "Wrestling",
                    492
                ],
                [
                    "Pro",
                    243
                ],
                [
                    "Championship",
                    171
                ],
                [
                    "City",
                    24
                ],
                [
                    "Lucha",
                    21
                ],
                [
                    "Sports",
                    12
                ],
                [
                    "Professional",
                    11
                ],
                [
                    "Star",
                    9
                ],
                [
                    "States",
                    9
                ],
                [
                    "Impact",
                    8
                ],
                [
                    "Time",
                    8
                ],
                [
                    "World",
                    8
                ],
                [
                    "Zone",
                    8
                ],
                [
                    "Athletic",
                    8
                ],
                [
                    "Xtreme",
                    8
                ],
                [
                    "Mountain",
                    7
                ],
                [
                    "American",
                    7
                ],
                [
                    "League",
                    6
                ],
                [
                    "Valley",
                    6
                ],
                [
                    "Independent",
                    6
                ],
                [
                    "All-Star",
                    6
                ],
                [
                    "Combat",
                    5
                ],
                [
                    "Premier",
                    5
                ],
                [
                    "Event",
                    5
                ],
                [
                    "Action",
                    5
                ],
                [
                    "Breed",
                    4
                ],
                [
                    "Coast",
                    4
                ],
                [
                    "Power",
                    4
                ],
                [
                    "Club",
                    4
                ],
                [
                    "Entertainment",
                    4
                ],
                [
                    "Generation",
                    4
                ],
                [
                    "State",
                    3
                ],
                [
                    "Evolution",
                    3
                ],
                [
                    "Renegade",
                    4
                ],
                [
                    "Valley",
                    4
                ],
                [
                    "Glory",
                    4
                ]
            ],
            "uncommon": [
                [
                    "2000",
                    0.4
                ],
                [
                    "Spectrum",
                    0.4
                ],
                [
                    "Modern",
                    0.4
                ],
                [
                    "All-Pro",
                    0.4
                ],
                [
                    "Madness",
                    0.4
                ],
                [
                    "Karate",
                    0.4
                ],
                [
                    "Freelance",
                    0.4
                ],
                [
                    "Extreme",
                    0.4
                ],
                [
                    "Slam",
                    0.4
                ],
                [
                    "Pro",
                    0.4
                ],
                [
                    "Wrestle",
                    0.4
                ],
                [
                    "Magic",
                    0.4
                ],
                [
                    "Outlaw",
                    0.4
                ]
            ]
        },
        "last_names": {
            "common": [
                [
                    "Wrestling",
                    813
                ],
                [
                    "Federation",
                    86
                ],
                [
                    "Alliance",
                    81
                ],
                [
                    "Entertainment",
                    57
                ],
                [
                    "Association",
                    53
                ],
                [
                    "League",
                    18
                ],
                [
                    "Pro",
                    16
                ],
                [
                    "Club",
                    12
                ],
                [
                    "Revolution",
                    11
                ],
                [
                    "Enterprises",
                    9
                ],
                [
                    "Elite",
                    8
                ],
                [
                    "Organization",
                    7
                ],
                [
                    "Superstars",
                    7
                ],
                [
                    "Promotion",
                    6
                ],
                [
                    "Force",
                    6
                ],
                [
                    "USA",
                    6
                ],
                [
                    "Pro-Wrestling",
                    5
                ],
                [
                    "Union",
                    4
                ],
                [
                    "Company",
                    4
                ],
                [
                    "World",
                    4
                ],
                [
                    "Network",
                    4
                ],
                [
                    "Sports",
                    4
                ],
                [
                    "Stars",
                    4
                ],
                [
                    "Coalition",
                    4
                ],
                [
                    "United",
                    3
                ],
                [
                    "Ring",
                    3
                ],
                [
                    "International",
                    3
                ],
                [
                    "Society",
                    3
                ],
                [
                    "America",
                    3
                ],
                [
                    "Group",
                    3
                ],
                [
                    "Syndicate",
                    3
                ],
                [
                    "Inc.",
                    3
                ]
            ],
            "uncommon": [
                [
                    "Era",
                    0.4
                ],
                [
                    "Cartel",
                    0.4
                ],
                [
                    "eXpress",
                    0.4
                ],
                [
                    "Xplosion",
                    0.4
                ],
                [
                    "Total",
                    0.4
                ],
                [
                    "Promotion",
                    0.4
                ],
                [
                    "Dojo",
                    0.4
                ],
                [
                    "Productions",
                    0.4
                ],
                [
                    "Ring",
                    0.4
                ],
                [
                    "Juniors",
                    0.4
                ],
                [
                    "Extremo",
                    0.4
                ],
                [
                    "SUN",
                    0.4
                ],
                [
                    "Academy",
                    0.4
                ],
                [
                    "Brawl",
                    0.4
                ],
                [
                    "Azteca",
                    0.4
                ]
            ]
        }
    },
    2: {
        "weight": 17,
        "first_names": {
            "common": [
                [
                    "Lucha",
                    11
                ],
                [
                    "Tri-State",
                    4
                ],
                [
                    "All-Star",
                    3
                ],
                [
                    "Hardcore",
                    3
                ],
                [
                    "Freelance",
                    2
                ],
                [
                    "Fight",
                    2
                ],
                [
                    "International",
                    2
                ],
                [
                    "Extreme",
                    2
                ],
                [
                    "Pro-Wrestling",
                    2
                ],
                [
                    "Legacy",
                    2
                ],
                [
                    "Invasion",
                    2
                ],
                [
                    "Powerslam",
                    2
                ],
                [
                    "Anarchy",
                    2
                ],
                [
                    "Project:",
                    20
                ],
                [
                    "Brawl",
                    2
                ],
                [
                    "All-Out",
                    1
                ],
                [
                    "Beyond",
                    1
                ]
            ],
            "uncommon": [
                [
                    "Zeus",
                    0.4
                ],
                [
                    "Empire",
                    0.4
                ],
                [
                    "Summit",
                    0.4
                ],
                [
                    "Mayhem",
                    0.4
                ],
                [
                    "Northeast",
                    0.4
                ],
                [
                    "Playhouse",
                    0.4
                ],
                [
                    "Crossfire",
                    0.4
                ],
                [
                    "Infinite",
                    0.4
                ],
                [
                    "Wizard",
                    0.4
                ],
                [
                    "Ultimate",
                    0.4
                ],
                [
                    "Hillbilly",
                    0.4
                ],
                [
                    "Online",
                    0.4
                ],
                [
                    "Super",
                    0.4
                ],
                [
                    "Global",
                    0.4
                ],
                [
                    "Juggalo",
                    0.4
                ],
                [
                    "Squared Circle",
                    0.4
                ],
                [
                    "Dragon",
                    0.4
                ],
                [
                    "XTREME",
                    0.4
                ],
                [
                    "DUDEKARA",
                    0.4
                ]
            ]
        },
        "middle_names": {
            "common": [],
            "uncommon": []
        },
        "last_names": {
            "common": [
                [
                    "Wrestling",
                    100
                ],
                [
                    "Pro",
                    14
                ],
                [
                    "Lucha",
                    6
                ],
                [
                    "Pro-Wrestling",
                    5
                ],
                [
                    "Sports",
                    3
                ],
                [
                    "Entertainment",
                    3
                ],
                [
                    "Underground",
                    3
                ],
                [
                    "Rising",
                    2
                ],
                [
                    "Live",
                    2
                ]
            ],
            "uncommon": [
                [
                    "Supershow",
                    0.4
                ],
                [
                    "Slam",
                    0.4
                ],
                [
                    "Dynasty",
                    0.4
                ],
                [
                    "Gate",
                    0.4
                ],
                [
                    "Combat",
                    0.4
                ],
                [
                    "U.K",
                    0.4
                ],
                [
                    "Promotion",
                    0.4
                ],
                [
                    "Dojo",
                    0.4
                ],
                [
                    "Productions",
                    0.4
                ],
                [
                    "Ring",
                    0.4
                ],
                [
                    "Juniors",
                    0.4
                ],
                [
                    "Extremo",
                    0.4
                ],
                [
                    "SUN",
                    0.4
                ],
                [
                    "Academy",
                    0.4
                ],
                [
                    "Brawl",
                    0.4
                ],
                [
                    "Azteca",
                    0.4
                ]
            ]
        }
    },
    4: {
        "weight": 21,
        "first_names": {
            "common": [
                [
                    "National",
                    64
                ],
                [
                    "New",
                    23
                ],
                [
                    "World",
                    19
                ],
                [
                    "Pro",
                    18
                ],
                [
                    "North",
                    16
                ],
                [
                    "Lucha",
                    14
                ],
                [
                    "Championship",
                    9
                ],
                [
                    "American",
                    9
                ],
                [
                    "International",
                    8
                ],
                [
                    "All",
                    8
                ],
                [
                    "Independent",
                    7
                ],
                [
                    "United",
                    7
                ],
                [
                    "Xtreme",
                    6
                ],
                [
                    "Wrestling",
                    6
                ],
                [
                    "Southern",
                    5
                ],
                [
                    "Big",
                    4
                ],
                [
                    "Canadian",
                    4
                ],
                [
                    "East",
                    4
                ],
                [
                    "West",
                    4
                ],
                [
                    "Ladies",
                    4
                ],
                [
                    "Mid",
                    4
                ],
                [
                    "Great",
                    4
                ],
                [
                    "South",
                    4
                ],
                [
                    "Western",
                    3
                ],
                [
                    "Fighting",
                    3
                ],
                [
                    "Victory",
                    3
                ],
                [
                    "Universal",
                    3
                ],
                [
                    "Main",
                    3
                ],
                [
                    "Real",
                    3
                ],
                [
                    "Social",
                    2
                ],
                [
                    "Global",
                    2
                ],
                [
                    "Scottish",
                    2
                ],
                [
                    "Premier",
                    2
                ],
                [
                    "Michigan",
                    2
                ]
            ],
            "uncommon": [
                [
                    "Beyond",
                    0.4
                ],
                [
                    "Dynamic",
                    0.4
                ],
                [
                    "Ultimate",
                    0.4
                ],
                [
                    "Hillbilly",
                    0.4
                ],
                [
                    "Online",
                    0.4
                ],
                [
                    "Super",
                    0.4
                ],
                [
                    "Global",
                    0.4
                ],
                [
                    "Juggalo",
                    0.4
                ],
                [
                    "Squared Circle",
                    0.4
                ],
                [
                    "Dragon",
                    0.4
                ],
                [
                    "XTREME",
                    0.4
                ],
                [
                    "DUDEKARA",
                    0.4
                ]
            ]
        },
        "middle_names": {
            "common": [
                [
                    "Wrestling Alliance",
                    68
                ],
                [
                    "Pro Wrestling",
                    18
                ],
                [
                    "Championship Wrestling",
                    17
                ],
                [
                    "American Wrestling",
                    7
                ],
                [
                    "World Wrestling",
                    5
                ],
                [
                    "States Wrestling",
                    5
                ],
                [
                    "Professional Wrestling",
                    5
                ],
                [
                    "Wide Wrestling",
                    4
                ],
                [
                    "Coast Championship",
                    4
                ],
                [
                    "All Pro",
                    4
                ],
                [
                    "Independent Wrestling",
                    4
                ],
                [
                    "States Championship",
                    3
                ],
                [
                    "Coast Wrestling",
                    3
                ],
                [
                    "City Pro",
                    3
                ],
                [
                    "Event Championship",
                    3
                ],
                [
                    "Coast Pro",
                    3
                ],
                [
                    "Championship Pro",
                    2
                ],
                [
                    "Star Wrestling",
                    2
                ],
                [
                    "National Wrestling",
                    2
                ],
                [
                    "Big Time",
                    2
                ],
                [
                    "Star Pro",
                    2
                ]
            ],
            "uncommon": [
                [
                    "Horizon Pro",
                    0.4
                ],
                [
                    "Star Championship",
                    0.4
                ],
                [
                    "Frontier Wrestling",
                    0.4
                ],
                [
                    "Hardcore Wrestling",
                    0.4
                ],
                [
                    "Era Pro",
                    0.4
                ],
                [
                    "City Championship",
                    0.4
                ],
                [
                    "Independent Pro",
                    0.4
                ],
                [
                    "One Pro",
                    0.4
                ]
            ]
        },
        "last_names": {
            "common": [
                [
                    "Alliance",
                    40
                ],
                [
                    "Association",
                    29
                ],
                [
                    "Federation",
                    21
                ],
                [
                    "League",
                    5
                ],
                [
                    "Supreme",
                    4
                ],
                [
                    "Club",
                    4
                ],
                [
                    "Coalition",
                    4
                ],
                [
                    "Network",
                    4
                ],
                [
                    "Mid-Atlantic",
                    2
                ],
                [
                    "Tri-State",
                    2
                ],
                [
                    "Entertainment",
                    2
                ],
                [
                    "Promotion",
                    2
                ],
                [
                    "Mid-South",
                    2
                ],
                [
                    "Group",
                    2
                ],
                [
                    "Midwest",
                    2
                ],
                [
                    "Enterprises",
                    2
                ],
                [
                    "Connection",
                    2
                ],
                [
                    "Wildside",
                    2
                ]
            ],
            "uncommon": [
                [
                    "Total",
                    0.4
                ],
                [
                    "Empire",
                    0.4
                ],
                [
                    "Mayhem",
                    0.4
                ],
                [
                    "Series",
                    0.4
                ],
                [
                    "Alliance",
                    0.4
                ],
                [
                    "Association",
                    0.4
                ],
                [
                    "Federation",
                    0.4
                ],
                [
                    "Wrestling",
                    0.4
                ]
            ]
        }
    }
};

});

parcelRequire.register("7Hx0P", function(module, exports) {

$parcel$export(module.exports, "standardGimmickMatchesData", () => $59b6281c829df487$export$5816a2c8feaaf6d0);
const $59b6281c829df487$export$5816a2c8feaaf6d0 = [
    {
        "name": "2/3 Falls",
        "cost": 90,
        "ratingBoost": 1.25,
        "popularityIncrease": 2.2,
        "popularityDecrease": 0.5,
        "injuryRate": 1.15,
        "description": "The first superstar to score two falls wins.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": "2/3_falls",
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Special Referee",
        "cost": 60,
        "ratingBoost": 1.13,
        "popularityIncrease": 1.55,
        "popularityDecrease": 0.8,
        "injuryRate": 1.05,
        "description": "A guest referee is selected to enforce the match.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": "special_referee",
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Pole",
        "cost": 20,
        "ratingBoost": 1.0,
        "popularityIncrease": 1.3,
        "popularityDecrease": 0.9,
        "injuryRate": 1.05,
        "description": "An object hangs off a pole, the goal being to claim it or use it. Can be a hit or a big miss!",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": true,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Elimination",
        "cost": 30,
        "ratingBoost": 1.15,
        "popularityIncrease": 1.5,
        "popularityDecrease": 0.7,
        "injuryRate": 1.05,
        "description": "Teams battle it out in an elimination tag match, where an entire team must be eliminated for the match to end.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": "elimination",
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Open Challenge",
        "cost": 60,
        "ratingBoost": 1.1,
        "popularityIncrease": 1.55,
        "popularityDecrease": 0.8,
        "injuryRate": 1.05,
        "description": "A random superstar shows up to answer the open challenge!",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": "random_opponent",
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Hair vs Hair",
        "cost": 110,
        "ratingBoost": 1.18,
        "popularityIncrease": 1.66,
        "popularityDecrease": 0.6,
        "injuryRate": 1.06,
        "description": "The losing superstar gets their hair shaved off!",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": "remove_hair",
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Submission",
        "cost": 25,
        "ratingBoost": 1.08,
        "popularityIncrease": 1.45,
        "popularityDecrease": 0.85,
        "injuryRate": 1.05,
        "description": "The first superstar to score a submission and make their opponent tap wins the match.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Ironman",
        "cost": 60,
        "ratingBoost": 1.2,
        "popularityIncrease": 2.0,
        "popularityDecrease": 0.6,
        "injuryRate": 1.05,
        "description": "A marathon match to see who is the best.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Mask vs Mask",
        "cost": 130,
        "ratingBoost": 1.18,
        "popularityIncrease": 1.66,
        "popularityDecrease": 0.6,
        "injuryRate": 1.06,
        "description": "The losing superstar is forced to unmask!",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": "remove_mask",
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Mask vs Hair",
        "cost": 130,
        "ratingBoost": 1.18,
        "popularityIncrease": 1.66,
        "popularityDecrease": 0.6,
        "injuryRate": 1.06,
        "description": "One superstar will be forced to either remove their mask or shave their hair!",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": "remove_mask_or_hair",
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Battle Royal",
        "cost": 60,
        "ratingBoost": 1.13,
        "popularityIncrease": 1.2,
        "popularityDecrease": 0.4,
        "injuryRate": 1.05,
        "description": "Superstars are eliminated if thrown over the top rope and both feet touch the floor. Last remaining superstar wins!",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": "battle_royal",
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Brawl",
        "cost": 25,
        "ratingBoost": 1.1,
        "popularityIncrease": 1.55,
        "popularityDecrease": 0.8,
        "injuryRate": 1.1,
        "description": "Superstars brawl it out in a special location.",
        "available": false,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": true,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": true,
        "graphicType": null
    },
    {
        "name": "Ladder",
        "cost": 35,
        "ratingBoost": 1.13,
        "popularityIncrease": 1.6,
        "popularityDecrease": 0.8,
        "injuryRate": 1.15,
        "description": "The only way to win is to climb the ladder and grab the prize.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": "ladder"
    },
    {
        "name": "I Quit",
        "cost": 50,
        "ratingBoost": 1.16,
        "popularityIncrease": 1.7,
        "popularityDecrease": 0.75,
        "injuryRate": 1.12,
        "description": "The only way to win is to humiliate your opponent and make them quit.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "First Blood",
        "cost": 45,
        "ratingBoost": 1.13,
        "popularityIncrease": 1.45,
        "popularityDecrease": 0.85,
        "injuryRate": 1.05,
        "description": "The first superstar to make their opponent bleed wins the match.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Loser Leaves",
        "cost": 75,
        "ratingBoost": 1.2,
        "popularityIncrease": 2.0,
        "popularityDecrease": 0.6,
        "injuryRate": 1.05,
        "description": "A grudge match in which the loser is forced to take takes a hiatus from the company.",
        "available": false,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": "loser_unavailable",
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": null
    },
    {
        "name": "Casket",
        "cost": 45,
        "ratingBoost": 1.13,
        "popularityIncrease": 1.45,
        "popularityDecrease": 0.85,
        "injuryRate": 1.05,
        "description": "The only way to win is to put your opponent in a casket and close it!",
        "available": false,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": "casket"
    },
    {
        "name": "Steel Cage",
        "cost": 40,
        "ratingBoost": 1.13,
        "popularityIncrease": 1.6,
        "popularityDecrease": 0.8,
        "injuryRate": 1.15,
        "description": "Superstars are locked inside a steel cage, with only one survivor.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": "cage_grey"
    },
    {
        "name": "Street Fight",
        "cost": 10,
        "ratingBoost": 1.05,
        "popularityIncrease": 1.3,
        "popularityDecrease": 0.9,
        "injuryRate": 1.05,
        "description": "Superstars battle it out anywhere in the arena using weapons.",
        "available": true,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": true,
        "graphicType": null
    },
    {
        "name": "Tables",
        "cost": 20,
        "ratingBoost": 1.1,
        "popularityIncrease": 1.3,
        "popularityDecrease": 0.9,
        "injuryRate": 1.1,
        "description": "The only way to win is to put your opponent through a table.",
        "available": false,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": "table"
    },
    {
        "name": "Unsanctioned",
        "cost": 35,
        "ratingBoost": 1.13,
        "popularityIncrease": 1.6,
        "popularityDecrease": 0.8,
        "injuryRate": 1.1,
        "description": "A fight without any rules or consequences where anything goes.",
        "available": false,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": true,
        "graphicType": null
    },
    {
        "name": "Steel Cell",
        "cost": 80,
        "ratingBoost": 1.25,
        "popularityIncrease": 2.2,
        "popularityDecrease": 0.5,
        "injuryRate": 1.15,
        "description": "Superstars are locked in a large, high steel cell, where they battle to survive.",
        "available": false,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": "cage_grey"
    },
    {
        "name": "TLC",
        "cost": 65,
        "ratingBoost": 1.2,
        "popularityIncrease": 1.8,
        "popularityDecrease": 0.7,
        "injuryRate": 1.175,
        "description": "Tables Ladders and Chairs, oh my!",
        "available": false,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": false,
        "graphicType": "tables_ladders_chairs"
    },
    {
        "name": "LMS",
        "cost": 50,
        "ratingBoost": 1.16,
        "popularityIncrease": 1.7,
        "popularityDecrease": 0.75,
        "injuryRate": 1.1,
        "description": "The only way to win is to knock your opponent out for a ten count.",
        "available": false,
        "cashinContractName": null,
        "monthsToExpire": 12,
        "generateObject": false,
        "generateLocation": false,
        "matchContractName": null,
        "consequence": null,
        "special": false,
        "rules": null,
        "addRandomWeapons": true,
        "graphicType": null
    }
];

});

parcelRequire.register("gFyK0", function(module, exports) {

$parcel$export(module.exports, "standardPowerupsData", () => $c22b6c8022773a7d$export$b5e82af10bd44ff);
const $c22b6c8022773a7d$export$b5e82af10bd44ff = [
    {
        "name": "Ring Return",
        "description": "Bring back a retired superstar who is not a hall-of-famer for one more match.",
        "cost": 130,
        "effect": "retirement_return",
        "level": 1,
        "selection": "retired_superstars",
        "rarity": 90,
        "storyName": null
    },
    {
        "name": "Ring Return+",
        "description": "Bring back a retired hall-of-famer for one last legendary match.",
        "cost": 160,
        "effect": "retirement_return",
        "level": 2,
        "selection": "retired_superstars",
        "rarity": 105,
        "storyName": null
    },
    {
        "name": "Ring Return++",
        "description": "Stage a miraculous, full-time comeback for a retired superstar.",
        "cost": 400,
        "effect": "retirement_return",
        "level": 3,
        "selection": "retired_superstars",
        "rarity": 350,
        "storyName": null
    },
    {
        "name": "Callup",
        "description": "Callup a training superstar to the main roster.",
        "cost": 100,
        "effect": "callup",
        "level": 1,
        "selection": "training_superstars",
        "rarity": 80,
        "storyName": null
    },
    {
        "name": "Re-sign",
        "description": "Convince a part-time superstar to sign on for more appearances.",
        "cost": 150,
        "effect": "part_timer_appearances",
        "level": 1,
        "selection": "part_time_superstars",
        "rarity": 100,
        "storyName": null
    },
    {
        "name": "Wolverine",
        "description": "Speed up the return of an injured superstar who is in the later stages of recovery.",
        "cost": 120,
        "effect": "early_return",
        "level": 1,
        "selection": "returning_superstars",
        "rarity": 95,
        "storyName": null
    },
    {
        "name": "Callup+",
        "description": "Stage a takeover, calling up multiple training superstars or a faction to the main roster.",
        "cost": 250,
        "effect": "callup",
        "level": 2,
        "selection": "training_factions",
        "rarity": 225,
        "storyName": null
    },
    {
        "name": "Mega Show",
        "description": "Hold more events than usual at the upcoming show.",
        "cost": 70,
        "effect": "increase_matches",
        "level": 1,
        "selection": null,
        "rarity": 60,
        "storyName": null
    },
    {
        "name": "Recruitment",
        "description": "Hold a tryout, recruiting new talent to join your training roster.",
        "cost": 90,
        "effect": "recruitment",
        "level": 1,
        "selection": null,
        "rarity": 75,
        "storyName": null
    },
    {
        "name": "Step Up",
        "description": "Get the owner of the company or a manager to step into the ring and wrestle.",
        "cost": 170,
        "effect": "one_match",
        "level": 1,
        "selection": "owner_and_managers",
        "rarity": 120,
        "storyName": null
    },
    {
        "name": "Hypnosis",
        "description": "Convince the owner of the company to change an incomplete goal.",
        "cost": 200,
        "effect": "reroll_goal",
        "level": 1,
        "selection": "objectives",
        "rarity": 200,
        "storyName": null
    },
    {
        "name": "Training",
        "description": "Send a superstar to the training roster to improve their popularity.",
        "cost": 80,
        "effect": "send_to_training",
        "level": 1,
        "selection": "superstars_except_champions",
        "rarity": 70,
        "storyName": null
    },
    {
        "name": "Style Change",
        "description": "Convince the company directors to change the company's style.",
        "cost": 120,
        "effect": "style_change",
        "level": 1,
        "selection": null,
        "rarity": 95,
        "storyName": null
    },
    {
        "name": "Re-sign+",
        "description": "Convince a part-time superstar to sign on full-time with the company.",
        "cost": 320,
        "effect": "part_timer_appearances",
        "level": 2,
        "selection": "part_time_superstars",
        "rarity": 270,
        "storyName": null
    },
    {
        "name": "Reincarnation",
        "description": "Bring back a random gimmick from a superstar's past.",
        "cost": 80,
        "effect": "random_past_gimmick",
        "level": 1,
        "selection": "past_gimmick_superstars",
        "rarity": 65,
        "storyName": null
    },
    {
        "name": "Roulette",
        "description": "Run a gimmick match roulette, adding a random gimmick to the match.",
        "cost": 60,
        "effect": "gimmick_match_roulette",
        "level": 1,
        "selection": "matches",
        "rarity": 55,
        "storyName": null
    },
    {
        "name": "Staff Interest",
        "description": "Hold a job ad, getting professionals to list themselves on the Staff Hiring Board.",
        "cost": 130,
        "effect": "staff_recruitment",
        "level": 1,
        "selection": "",
        "rarity": 90,
        "storyName": null
    },
    {
        "name": "Interbrand+",
        "description": "Allow superstars from other brands to be booked on all shows up to the next monthly event.",
        "cost": 220,
        "effect": "allow_other_brands_extended",
        "level": 2,
        "selection": null,
        "rarity": 200,
        "storyName": null
    },
    {
        "name": "Interbrand",
        "description": "Allow superstars from other brands to be booked at the upcoming show.",
        "cost": 100,
        "effect": "allow_other_brands",
        "level": 1,
        "selection": null,
        "rarity": 85,
        "storyName": null
    },
    {
        "name": "Cyborg",
        "description": "Replace an injured body part using synthetic materials, instantly healing the injury.",
        "cost": 130,
        "effect": "instant_heal",
        "level": 1,
        "selection": "injured_superstars",
        "rarity": 100,
        "storyName": "mars"
    },
    {
        "name": "Neural Control",
        "description": "Remove negative emotions from a superstar using a neural control interface.",
        "cost": 120,
        "effect": "happy",
        "level": 1,
        "selection": "unhappy_superstars",
        "rarity": 95,
        "storyName": "mars"
    },
    {
        "name": "Neural Control+",
        "description": "Hide a neural control device in a competitor's company, implanting the superstar who uses it with a desire to leave and join your company.",
        "cost": 500,
        "effect": "superstar_jump",
        "level": 2,
        "selection": "competitors",
        "rarity": 450,
        "storyName": "mars"
    }
];

});

parcelRequire.register("5esHg", function(module, exports) {

$parcel$export(module.exports, "standardFeudItemsData", () => $3cf4851fd9c5ee6f$export$1cb84f8062d60e5e);
const $3cf4851fd9c5ee6f$export$1cb84f8062d60e5e = [
    {
        "name": "Main Event Ready",
        "description": "Two superstars on the cusp of the main event fight to see who is deserving of it.",
        "baseHype": 20,
        "consequence": "main-event-push",
        "oneAtATime": false,
        "requirement": "upper-midcarders",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Stepping Up",
        "description": "A low-on-the-card superstar looks to step up in the roster.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "lower-vs-upper-midcarder",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Who's the Best?",
        "description": "Tag partners fight to see which one is the better member of the team.",
        "baseHype": 15,
        "consequence": "disband-tag-team",
        "oneAtATime": false,
        "requirement": "tag-partners",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Ungrateful",
        "description": "A hard-working superstars looks to teach an unhappy one a lesson.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "unhappy-vs-happy",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Better Wrestler",
        "description": null,
        "baseHype": 5,
        "consequence": null,
        "oneAtATime": false,
        "requirement": null,
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "End the Reign",
        "description": "A challenger emerges, promising to end a long title reign.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "long-title-reign",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "I'm the Next Face",
        "description": "Two emerging stars confront each other to see who can get to the top first.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "becoming-fotc",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "That's My Shot",
        "description": "A contender challenges a match contract holder, claiming the contract as theirs.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "match-contract-won",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "End the Streak",
        "description": "A contender believes they can be the one to end a long winning streak.",
        "baseHype": 30,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "long-streak",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Injury Revenge",
        "description": "A returning superstar is looking to make the person who injured them pay.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "injury-return",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Streak Revenge",
        "description": "The former streak holder comes for retribution.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "streak-broken",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "No More Jokes",
        "description": "A harmless rib gets out of hand and becomes the basis for a feud.",
        "baseHype": 10,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "rib",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "New Challenger",
        "description": "A new challenger emerges for the championship.",
        "baseHype": 10,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "new-title-challenger",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Leave For Good",
        "description": "A superstar or tag team forced to leave the company return to get even.",
        "baseHype": 25,
        "consequence": "fired",
        "oneAtATime": false,
        "requirement": "loser-leaves",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "Us vs Them",
        "description": "A superstar fights for his locker room against another company's talent.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "trade-deal",
        "category": null,
        "unlocked": false,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Are You Proud?",
        "description": "A friend of a retired superstar is unhappy with the person who retired them.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "career-ended",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Taking My Spot",
        "description": "A full-timer refuses to let a part-timer take their spot.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "part-timer-vs-full-timer",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Fall From Grace",
        "description": "A superstar looks to regain the popularity they lost while another looks to put them further down the card.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "large-popularity-loss",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "It's My Time Now",
        "description": "A young superstar wants to take the spot of an older one.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "young-vs-old",
        "category": null,
        "unlocked": false,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Better Champion",
        "description": "Two champions fight it out to see which champion is the better one.",
        "baseHype": 25,
        "consequence": "unify-titles",
        "oneAtATime": false,
        "requirement": "champions",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "This Is Our Home",
        "description": "A mainstay of the roster clashes with a new indie signing.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "indie-superstar",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Selling Out",
        "description": "A superstar betrays their tag partner to move on to bigger things.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "disbanded-tag-team",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Grudge",
        "description": null,
        "baseHype": 5,
        "consequence": null,
        "oneAtATime": false,
        "requirement": null,
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "Disrespect",
        "description": null,
        "baseHype": 5,
        "consequence": null,
        "oneAtATime": false,
        "requirement": null,
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "Friendly Contest",
        "description": "Two faces fight each other to see who is better.",
        "baseHype": 10,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "face-vs-face",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "Rivals",
        "description": "Two rivals with a history of great feuds go to battle again.",
        "baseHype": 10,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "previous-feuds",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Prove Yourself",
        "description": "A new tag team looks to prove its effectiveness against an established team.",
        "baseHype": 10,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "new-tag-team",
        "category": null,
        "unlocked": true,
        "singles": false,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Career vs Career",
        "description": "Two aging superstars put their careers on the line to see which one retires.",
        "baseHype": 30,
        "consequence": "retirement",
        "oneAtATime": true,
        "requirement": "retiring-superstars",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Jealous Friend",
        "description": "A tag partner is jealous of their friend's success.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "disbanded-tag-team",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Not Done Yet",
        "description": "A retired superstar comes back to get revenge on the person who retired them.",
        "baseHype": 25,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "retirement-feud",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Retire Me",
        "description": "An aging superstar looks for the right superstar to retire them.",
        "baseHype": 25,
        "consequence": "retirement",
        "oneAtATime": true,
        "requirement": "retiring-superstar",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": true,
        "faction": false
    },
    {
        "name": "Streak vs Career",
        "description": "A superstars puts their career on the line to end a long winning streak.",
        "baseHype": 35,
        "consequence": "retirement",
        "oneAtATime": true,
        "requirement": "old-and-long-streak",
        "category": null,
        "unlocked": false,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": true,
        "faction": false
    },
    {
        "name": "Last Shot",
        "description": "A challenger is willing to do whatever it takes for one final shot at the title.",
        "baseHype": 20,
        "consequence": "unavailable",
        "oneAtATime": false,
        "requirement": "previous-title-feud",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": true,
        "faction": false
    },
    {
        "name": "Legend Killer",
        "description": "A hungry superstar looks to take out a hall-of-famer returning from retirement.",
        "baseHype": 20,
        "consequence": "unavailable",
        "oneAtATime": false,
        "requirement": "hall-of-famer-return",
        "category": null,
        "unlocked": false,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": true,
        "faction": false
    },
    {
        "name": "All or Nothing",
        "description": "A challenger puts their career on the line in order to be the champion.",
        "baseHype": 30,
        "consequence": "retirement",
        "oneAtATime": true,
        "requirement": "old-and-champion",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": true,
        "faction": false
    },
    {
        "name": "That's My Title",
        "description": "A previous title holder wants back the title that once belonged to them.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "previous-champion",
        "category": null,
        "unlocked": false,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Innovation",
        "description": "Two tag teams explore new territory in order to outdo each other.",
        "baseHype": 20,
        "consequence": "new-gimmick-match",
        "oneAtATime": true,
        "requirement": "young-midcarders",
        "category": null,
        "unlocked": false,
        "singles": false,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Best in the World",
        "description": "Two faces of the company challenge each other to see who is the best.",
        "baseHype": 25,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "faces-of-the-company",
        "category": null,
        "unlocked": false,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "Corruption",
        "description": "A face is tempted by a heel towards corruption.",
        "baseHype": 15,
        "consequence": "loser-turns-heel",
        "oneAtATime": false,
        "requirement": "face-vs-heel",
        "category": null,
        "unlocked": false,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": true,
        "faction": true
    },
    {
        "name": "Redemption",
        "description": "A heel battles a face in the aim of redemption.",
        "baseHype": 15,
        "consequence": "winner-turns-face",
        "oneAtATime": false,
        "requirement": "face-vs-heel",
        "category": null,
        "unlocked": false,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": true,
        "faction": true
    },
    {
        "name": "Better Villain",
        "description": "Two heels fight each other to see who is more dominant.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "heel-vs-heel",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "Betrayal",
        "description": "Former partners fight each other after a sudden betrayal.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "backstab",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Becoming Good",
        "description": "A newly-turned face looks to get over their heel partner.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "defying-a-villain",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Vengeance",
        "description": "A newly-turned heel looks to enact vengance.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "delayed-vengeance",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Greatest Wrestler",
        "description": "Two superstars renowned for their wrestling ability fight to see who is the greatest.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "high-workrate",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Fighting the Darkness",
        "description": "A face tries to fight off a newly-turned heel.",
        "baseHype": 15,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "vicious-beatdown",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Bitter Rivals",
        "description": "A hot feud is rekindled as two bitter rivals fight again.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "previous-hot-feud",
        "category": null,
        "unlocked": false,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Only Monster",
        "description": "Two over heels fight to see who is the only true monster in the company.",
        "baseHype": 25,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "heel-vs-heel-hot",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "Top Talent",
        "description": "Two over faces fight to determine the top talent in the company.",
        "baseHype": 25,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "face-vs-face-hot",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "This is Personal",
        "description": "Two superstars look to settle their personal history.",
        "baseHype": 30,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "backstage-fight",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Mask vs Career",
        "description": "A superstars puts their career on the line against the mask of another.",
        "baseHype": 30,
        "consequence": "retirement-or-unmasking",
        "oneAtATime": true,
        "requirement": "old-and-mask",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Not Your Place",
        "description": "Faction members fight to see who leaves the faction.",
        "baseHype": 20,
        "consequence": "leave-faction",
        "oneAtATime": true,
        "requirement": "faction-members",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "True Leader",
        "description": "A faction member fights the leader for the right to lead the faction.",
        "baseHype": 20,
        "consequence": "become-faction-leader",
        "oneAtATime": true,
        "requirement": "faction-leader-present",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Best Among Us",
        "description": "Faction members fight to see who will lead the faction.",
        "baseHype": 20,
        "consequence": "become-faction-leader",
        "oneAtATime": true,
        "requirement": "no-faction-leader",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Headhunting",
        "description": "A faction leader looks to recruit a superstar into their faction.",
        "baseHype": 20,
        "consequence": "join-faction",
        "oneAtATime": true,
        "requirement": "faction-present",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Civil War",
        "description": "A faction splits off from within another and starts a war against them.",
        "baseHype": 25,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "internal-division",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Leader Revenge",
        "description": "A former faction leader looks for revenge against the person who usurped them.",
        "baseHype": 25,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "usurped",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Treachery",
        "description": "A superstar betrays their faction to join another.",
        "baseHype": 25,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "switching-sides",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Total War",
        "description": "Factions go to war against another to see who is the top power in the company.",
        "baseHype": 30,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "faction-vs-faction-hot",
        "category": null,
        "unlocked": true,
        "singles": false,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "End of the Line",
        "description": "Two factions fight to put an end to each other.",
        "baseHype": 25,
        "consequence": "disband-faction",
        "oneAtATime": true,
        "requirement": null,
        "category": null,
        "unlocked": true,
        "singles": false,
        "tag": false,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "Former Manager",
        "description": "A superstar seeks revenge for their manager's betrayal.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "client-betrayal",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "True Loyalties",
        "description": "Two clients belonging to the same manager fight each other.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "same-manager",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": false
    },
    {
        "name": "Brand Loyalty",
        "description": "Superstars belonging to different brands fight to see which brand is superior.",
        "baseHype": 20,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "different-brands",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": true,
        "directFeud": false,
        "oneWayConsequence": false,
        "faction": true
    },
    {
        "name": "I Can Still Go",
        "description": "A superstar tries to prove they still have it.",
        "baseHype": 25,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "retirement-fakeout",
        "category": null,
        "unlocked": true,
        "singles": true,
        "tag": false,
        "directFeud": true,
        "oneWayConsequence": false,
        "faction": false
    }
];

});

parcelRequire.register("l4Fms", function(module, exports) {

$parcel$export(module.exports, "standardSegmentItemsData", () => $f57a0e3185a229d3$export$cca285ab939d813e);
const $f57a0e3185a229d3$export$cca285ab939d813e = [
    {
        "name": "Debut",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "new-talent",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Slander Competitor",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Champion Coronation",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "new-champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "This Belongs To You",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "award-title",
        "oneAtATime": true,
        "requirement": "vacant-title",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Exposing the Past",
        "description": null,
        "unlocked": false,
        "silly": true,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 3,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Anger Management",
        "description": null,
        "unlocked": true,
        "silly": true,
        "maxParticipants": 3,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "team-superstars",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Cash-In Tease",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "",
        "oneAtATime": true,
        "requirement": "contract-and-champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Title Destruction",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 3,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Push-up Contest",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Singing Contest",
        "description": null,
        "unlocked": true,
        "silly": true,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Slime Surprise",
        "description": null,
        "unlocked": true,
        "silly": true,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Spooky Trick",
        "description": null,
        "unlocked": true,
        "silly": true,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Promo Ambush",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 1,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Epic Brawl",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "previous-feuds",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 3,
        "entertainment": 0,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Backstage BBQ",
        "description": null,
        "unlocked": true,
        "silly": true,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Smack Talk",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 3,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Legend's Praise",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 3,
        "minParticipants": 3,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "legend",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 2,
        "difficulty": 3,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "You're Fired",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "fire-superstar",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Title Disrespect",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "title-feud",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Demand Title Shot",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Lost My Smile",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "vacate-title",
        "oneAtATime": true,
        "requirement": "champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 3,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Local Squash",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 0,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Masked Attacker",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 1,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Car Destruction",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 1,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Home Invasion",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 3,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Kidnapping",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Midget Impersonation",
        "description": null,
        "unlocked": true,
        "silly": true,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": true,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Promo Battle",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 4,
        "minParticipants": 2,
        "consequence": "",
        "oneAtATime": false,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Fight",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 4,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": false,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Team Tension",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 3,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "team-superstars",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Contract Signing",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Unlikely Partners",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Talk Show",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 3,
        "minParticipants": 3,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Mutual Respect",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "feud-blowoff",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": true,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Moving On",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "feud-blowoff",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": true,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Heat Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "heel",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Spirited Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "face",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Vicious Beatdown",
        "description": "Creates the 'Fighting the Darkness' Feud",
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "heel-turn",
        "oneAtATime": true,
        "requirement": "face-vs-face",
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Backstab",
        "description": "Creates the 'Betrayal' Feud",
        "unlocked": false,
        "silly": false,
        "maxParticipants": 3,
        "minParticipants": 2,
        "consequence": "heel-turn",
        "oneAtATime": true,
        "requirement": "face-team-superstars",
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Beatdown Save",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 3,
        "minParticipants": 3,
        "consequence": "face-turn",
        "oneAtATime": true,
        "requirement": "face-vs-heel-past-feud",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 1,
        "action": 2,
        "oneWayConsequence": true,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Forgiveness",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "face-turn-and-blowoff",
        "oneAtATime": true,
        "requirement": "face-vs-heel",
        "chooseWinner": false,
        "feudOnly": true,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": true,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Defying a Villain",
        "description": "Creates the 'Becoming Good' Feud",
        "unlocked": false,
        "silly": false,
        "maxParticipants": 3,
        "minParticipants": 2,
        "consequence": "face-turn",
        "oneAtATime": true,
        "requirement": "heel-team-superstars",
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Delayed Vengeance",
        "description": "Creates the 'Vengeance' Feud",
        "unlocked": false,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "heel-turn",
        "oneAtATime": true,
        "requirement": "face-vs-face-past-feud",
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 1,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Joining the Devil",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 3,
        "minParticipants": 3,
        "consequence": "heel-turn",
        "oneAtATime": true,
        "requirement": "face-vs-heel-past-feud",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 1,
        "action": 2,
        "oneWayConsequence": true,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Neutralize",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "neutral-turn",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Villainize",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "heel-turn",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Build Honor",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "face-turn",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Feud Package",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "level-1-producer",
        "chooseWinner": false,
        "feudOnly": true,
        "hypeBoost": 2,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Video Package",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "level-1-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Event Package",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 0,
        "minParticipants": 0,
        "consequence": "boost-event-hype",
        "oneAtATime": true,
        "requirement": "level-1-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Debut Package",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "new-talent-and-level-2-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Return Package",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "returning-talent-and-level-2-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Career Package",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "retiring-talent-and-level-3-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Day in the Life",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "level-3-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 2,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Competitor Buyout",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 0,
        "minParticipants": 0,
        "consequence": "",
        "oneAtATime": true,
        "requirement": "buyout-offer-accepted",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Championship Split",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "split-title",
        "oneAtATime": true,
        "requirement": "obsidian-champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "New Title Reveal",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "change-title-design",
        "oneAtATime": true,
        "requirement": "gold-champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Option C",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "vacate-title-and-create-match-contract",
        "oneAtATime": true,
        "requirement": "silver-champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Champion Package",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "champion-and-level-2-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Cryptic Threat",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "create-random-feud",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "New Alliance",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 4,
        "minParticipants": 4,
        "consequence": "create-trio-of-heels",
        "oneAtATime": true,
        "requirement": "heels-vs-face-singles",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Proven Winner",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "feud-blowoff",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": true,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Best Company Brag",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 0,
        "minParticipants": 0,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "company-of-the-year-award",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Laying Down The Law",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "suspend",
        "oneAtATime": true,
        "requirement": "",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Strip Champion",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "vacate-title",
        "oneAtATime": true,
        "requirement": "champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Dangerous Attack",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "loser-unavailable",
        "oneAtATime": true,
        "requirement": "",
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 0,
        "difficulty": 2,
        "entertainment": 1,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "New Partner",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "remove-tag-team-and-create-tag-team",
        "oneAtATime": true,
        "requirement": "injured-partner-and-singles-superstar",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "One Last Run",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "create-retirement-feud",
        "oneAtATime": true,
        "requirement": "retiring",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Better Together",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "create-tag-team-and-blowoff",
        "oneAtATime": true,
        "requirement": "singles-superstars",
        "chooseWinner": false,
        "feudOnly": true,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Retirement Announcement",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "retire",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Police Arrest",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "suspend",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "I Quit",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "make-unavailable",
        "oneAtATime": true,
        "requirement": "",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "New Gimmick Package",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "new-gimmick-and-level-1-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "New Heel Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "shocking-heel-turn",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "New Babyface Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "shocking-face-turn",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Retirement Gloat",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "not-done-yet-potential-feud",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Injury Gloat",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "inflicted-injury",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Trophy Destruction",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "award-winner",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 1,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Best Wrestler Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "wrestler-of-the-year-award",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "I'm The Face",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "face-of-the-company",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Legendary Beatdown",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "legend-and-heel",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Legendary Endorsement",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "legend-and-over-superstar",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 2,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Losing Streak Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "losing-streak",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Retirement Ceremony",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "retirement",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Spouse Affair",
        "description": null,
        "unlocked": true,
        "silly": true,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "This Is My Life",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Siblings Parody",
        "description": null,
        "unlocked": true,
        "silly": true,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Bodybuilding Contest",
        "description": null,
        "unlocked": true,
        "silly": true,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Backstage Attack",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Entrance Parody",
        "description": null,
        "unlocked": false,
        "silly": true,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Recap Package",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 0,
        "minParticipants": 0,
        "consequence": "boost-popularity",
        "oneAtATime": true,
        "requirement": "level-1-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Main Event Package",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 0,
        "minParticipants": 0,
        "consequence": "boost-main-event-hype",
        "oneAtATime": true,
        "requirement": "level-1-producer",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": true,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Backstage Interview",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": false,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Stunt Dive",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Car Explosion",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Dummy Wrestling",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Timely Rescue",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Helicopter Raid",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Ring Invasion",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Love Making",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Celebrity Beatdown",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Anti-Company Rant",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Hosedown",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 3,
        "action": 3,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": true,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Handicap Beatdown",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 5,
        "minParticipants": 3,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Rip Off Mask",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "masked-talent",
        "chooseWinner": false,
        "feudOnly": true,
        "hypeBoost": 2,
        "popularityBoost": 0,
        "difficulty": 2,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Kicked Out",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "remove-faction-members",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "Time To Leave",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "remove-faction-members",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "New Blood",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "add-faction-members",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "Our Leader",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "add-faction-leader",
        "oneAtATime": true,
        "requirement": "no-faction-leader",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "New Leadership",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "change-faction-leader",
        "oneAtATime": true,
        "requirement": "faction-leader-present",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "No Leadership",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "remove-faction-leadership",
        "oneAtATime": true,
        "requirement": "faction-leader-present",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "Usurped",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "kick-out-faction-leader-and-change-leader",
        "oneAtATime": true,
        "requirement": "faction-leader-present",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "Switching Sides",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "leave-faction-and-join-other-faction",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "Joining Forces",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "merge-factions",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "Internal Division",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "split-faction",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "Our End",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "disband-faction",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "New Power",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 0,
        "minParticipants": 0,
        "consequence": "create-faction",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": true
    },
    {
        "name": "Manager Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "boost-managed-talent",
        "oneAtATime": true,
        "requirement": "manager",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Dismiss Manager",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "remove-manager",
        "oneAtATime": true,
        "requirement": "manager-present",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": false
    },
    {
        "name": "Reveal Manager",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "add-manager",
        "oneAtATime": true,
        "requirement": "no-manager",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": false
    },
    {
        "name": "Client Betrayal",
        "description": "Creates the 'Former Manager' Feud",
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "remove-managed-talent",
        "oneAtATime": true,
        "requirement": "manager",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 2,
        "difficulty": 2,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": false
    },
    {
        "name": "Brand Signing",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 0,
        "minParticipants": 0,
        "consequence": "draft-talent-to-brand",
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": false
    },
    {
        "name": "Brand Invasion",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 8,
        "minParticipants": 3,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "other-brand-talent",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 3,
        "difficulty": 2,
        "entertainment": 1,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": false
    },
    {
        "name": "Surprise Return",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "returning-talent",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Debut Attack",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "new-talent",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Retirement Fakeout",
        "description": "Creates the 'I Can Still Go' Feud",
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "heel-turn",
        "oneAtATime": true,
        "requirement": "retiring",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 2,
        "oneWayConsequence": true,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Return Attack",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "returning-talent",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Title Unification",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "unify-titles",
        "oneAtATime": true,
        "requirement": "double-champion",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Righteous Beatdown",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": "face-turn",
        "oneAtATime": true,
        "requirement": "heel-vs-heel",
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Face Reveal",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": "remove-mask",
        "oneAtATime": true,
        "requirement": "masked-talent",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "New Association",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 3,
        "minParticipants": 2,
        "consequence": "create-team",
        "oneAtATime": true,
        "requirement": "singles-superstars",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Cutting Ties",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 3,
        "minParticipants": 2,
        "consequence": "disband-team",
        "oneAtATime": true,
        "requirement": "team-superstars",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Catchphrase Showdown",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "over-talent",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 2,
        "difficulty": 3,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Indifferent Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "neutral",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Debut Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "new-talent",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 2,
        "difficulty": 1,
        "entertainment": 3,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Desecrate Grave",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Spouse Attack",
        "description": null,
        "unlocked": false,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 1,
        "difficulty": 2,
        "entertainment": 2,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Interview Attack",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 0,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "After Match Save",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 0,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "After Match Attack",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 0,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Surprise Attack",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 0,
        "action": 2,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Tense Pull-Apart",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Standing Tall",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Forced To Retreat",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Fight Tease",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 0,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Staredown",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Solo Feud Promo",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": false,
        "requirement": "feud-present",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Split Interview",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Off-Camera Assault",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 2,
        "popularityBoost": 0,
        "difficulty": 2,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "Backstage Confrontation",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 2,
        "minParticipants": 2,
        "consequence": null,
        "oneAtATime": true,
        "requirement": null,
        "chooseWinner": true,
        "feudOnly": false,
        "hypeBoost": 1,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 1,
        "action": 1,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    },
    {
        "name": "TGI Victory Boast",
        "description": null,
        "unlocked": true,
        "silly": false,
        "maxParticipants": 1,
        "minParticipants": 1,
        "consequence": null,
        "oneAtATime": true,
        "requirement": "the-grand-invitational-winner",
        "chooseWinner": false,
        "feudOnly": false,
        "hypeBoost": 0,
        "popularityBoost": 1,
        "difficulty": 1,
        "entertainment": 2,
        "action": 0,
        "oneWayConsequence": false,
        "productionSegment": false,
        "startTexts": null,
        "actionTexts": null,
        "custom": false,
        "temporary": false,
        "saveToCommunity": false,
        "text": null,
        "special": false,
        "used": false,
        "monthsToReuse": 36,
        "factionSegment": null
    }
];

});

parcelRequire.register("5JRw3", function(module, exports) {

$parcel$export(module.exports, "Staff", () => $42daaae26aa26afc$export$dfc0833b0119811d);
$parcel$export(module.exports, "setStaffSuperstarObject", () => $42daaae26aa26afc$export$b9d882f1f5adb38f);
$parcel$export(module.exports, "getStaffSuperstarObject", () => $42daaae26aa26afc$export$11f45566f5848e0b);

var $14eBR = parcelRequire("14eBR");
function $42daaae26aa26afc$export$dfc0833b0119811d() {
    // Integer
    const level = 1;
    const xp = 0;
    const age = null;
    const cost = null;
    const monthsLeftForTask = null;
    const unavailableMonths = 0;
    // Strings
    const name = null;
    const gender = "male";
    const role = null;
    const currentTask = null;
    // Boolean
    const retired = false;
    // Objects
    const graphic = {};
    const taskData = {};
    // Foreign keys
    const companyId = null;
    const rosterId = null;
    const superstarObjectId = null;
    return {
        level: level,
        xp: xp,
        age: age,
        cost: cost,
        monthsLeftForTask: monthsLeftForTask,
        unavailableMonths: unavailableMonths,
        name: name,
        gender: gender,
        role: role,
        currentTask: currentTask,
        retired: retired,
        graphic: graphic,
        taskData: taskData,
        companyId: companyId,
        rosterId: rosterId,
        superstarObjectId: superstarObjectId
    };
}
function $42daaae26aa26afc$export$4f7fd2f1b19cc3bc(staff) {
    return (0, $14eBR.Companies).find({
        "$loki": staff.companyId
    })[0];
}
function $42daaae26aa26afc$export$f2c43f250835dc89(staff) {
    return (0, $14eBR.Rosters).find({
        "$loki": staff.rosterId
    })[0];
}
function $42daaae26aa26afc$export$b9d882f1f5adb38f(staff, superstarObject) {
    staff.superstarObjectId = superstarObject.$loki;
}
function $42daaae26aa26afc$export$11f45566f5848e0b(staff) {
    if (!staff.superstarObjectId) return;
    return (0, $14eBR.Superstars).find({
        "$loki": staff.superstarObjectId
    })[0];
}

});

parcelRequire.register("i6OYC", function(module, exports) {

$parcel$export(module.exports, "Gimmick", () => $d2f0546d7cb8959b$export$556d9431ac493a31);

var $14eBR = parcelRequire("14eBR");
function $d2f0546d7cb8959b$export$556d9431ac493a31() {
    // Float
    const effectiveness = null;
    // Integer
    const startMonth = null;
    const startYear = null;
    const endMonth = null;
    const endYear = null;
    const combinationBonus = 0;
    const characterBonus = 0;
    // Strings
    const name = null;
    // Boolean
    const nextGimmickBoost = false;
    // Foreign keys
    const superstarId = null;
    const character = null;
    const rosterId = null;
    return {
        effectiveness: effectiveness,
        startMonth: startMonth,
        startYear: startYear,
        endMonth: endMonth,
        endYear: endYear,
        combinationBonus: combinationBonus,
        characterBonus: characterBonus,
        name: name,
        nextGimmickBoost: nextGimmickBoost,
        superstarId: superstarId,
        character: character,
        rosterId: rosterId
    };
}
function $d2f0546d7cb8959b$export$a2db672910a84131(gimmick) {
    return (0, $14eBR.Superstars).find({
        "$loki": gimmick.superstarId
    })[0];
}
function $d2f0546d7cb8959b$export$a18d2562169cdee2(gimmick) {
    return (0, $14eBR.Rosters).find({
        "$loki": gimmick.rosterId
    })[0];
}

});


parcelRequire.register("5yA6U", function(module, exports) {

$parcel$export(module.exports, "generateCompanyObjectives", () => $40bc2387e9b94044$export$cc40a41cc6071b01);
$parcel$export(module.exports, "generateCompanySingleObjective", () => $40bc2387e9b94044$export$ba328c842b4eb0da);

var $98xmD = parcelRequire("98xmD");

var $3E8Nt = parcelRequire("3E8Nt");

var $8A6FL = parcelRequire("8A6FL");

var $9esFv = parcelRequire("9esFv");

var $14eBR = parcelRequire("14eBR");

var $5NNI6 = parcelRequire("5NNI6");

var $1JSre = parcelRequire("1JSre");

var $ct4m6 = parcelRequire("ct4m6");

var $dl5u4 = parcelRequire("dl5u4");

var $5kTkA = parcelRequire("5kTkA");

var $972Ip = parcelRequire("972Ip");
async function $40bc2387e9b94044$export$cc40a41cc6071b01(company, game) {
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let gimmickMatches = await (0, $9esFv.getCompanyGimmickMatches)(company);
    let championships = await (0, $9esFv.getCompanyChampionships)(company);
    let properties = JSON.parse(JSON.stringify((0, $3E8Nt.goalProperties)));
    // Add championship prestige property name for paid users
    if ((0, $98xmD.globalUser).paid) properties["company"].push("championship prestige");
    // Remove award property names if no competitors present
    if (!game.competitorsPresent) properties["company"] = properties["company"].filter((x)=>![
            "win awards",
            "win moty",
            "win eoty",
            "win woty",
            "win gmoty"
        ].includes(x));
    // Select random property names from each tag
    let selectedProperties = {};
    for (let x of [
        "company",
        "superstar",
        "rating"
    ])selectedProperties[x] = (0, $3E8Nt.getRandomChoice)(properties[x]);
    // Create properties and objectives
    let objectives = [];
    for (let [tag, name] of Object.entries(selectedProperties)){
        if (company.storyName === "tutorial" && tag === "superstar") name = "main eventer";
        let objectiveProperty = await $40bc2387e9b94044$var$createProperty(name, tag, mainRoster, game.year, gimmickMatches, championships, 12, company.storyName);
        let newObjective = await $40bc2387e9b94044$var$createObjective(objectiveProperty);
        await (0, $5NNI6.addObjectiveProperties)(newObjective, [
            objectiveProperty
        ]);
        objectives.push(newObjective);
    }
    return objectives;
}
async function $40bc2387e9b94044$export$ba328c842b4eb0da(roster, gimmickMatches, year, tag, championships, game, nameException = null, monthsRemaining = 12) {
    let properties = JSON.parse(JSON.stringify((0, $3E8Nt.goalProperties)));
    // Add championship prestige goal for paid users
    if ((0, $98xmD.globalUser).paid) properties["company"].push("championship prestige");
    // Remove award objectives if no competitors present or awards passed
    if (!game.competitorsPresent || monthsRemaining <= 2) properties["company"] = properties["company"].filter((x)=>![
            "win awards",
            "win moty",
            "win eoty",
            "win woty",
            "win gmoty"
        ].includes(x));
    // Select property
    let name = (0, $3E8Nt.getRandomChoice)(properties[tag]);
    if (nameException) // Don't select name exception
    while(name === nameException)name = (0, $3E8Nt.getRandomChoice)(properties[tag]);
    // Create property and objective
    const objectiveProperty = await $40bc2387e9b94044$var$createProperty(name, tag, roster, year, gimmickMatches, championships, monthsRemaining);
    const newObjective = await $40bc2387e9b94044$var$createObjective(objectiveProperty);
    await (0, $5NNI6.addObjectiveProperties)(newObjective, [
        objectiveProperty
    ]);
    return newObjective;
}
async function $40bc2387e9b94044$var$createObjective(objectiveProperty) {
    let properties = {
        "events": {
            "name": `Hold {0} {1}* or higher {2}`,
            "help": "Only monthly Events count."
        },
        "matches": {
            "name": `Hold {0} {1}* or higher {2}`,
            "help": "Only Matches at monthly Events count"
        },
        "holy shit moments": {
            "name": "Create {0} Holy Shit {1}",
            "help": "Holy shit moments occur when cashing in a Cash-in Contract, through shocking Turns and have a chance of occurring during Gimmick Matches."
        },
        "main eventers signed": {
            "name": "Sign {0} Main Event Talent",
            "help": ""
        },
        "win awards": {
            "name": "Win {0} Year End {1} (no bad awards!)",
            "help": "Win any of the 'Best' Awards. No bad awards!"
        },
        "win moty": {
            "name": "Win {0} Match of the Year Award",
            "help": ""
        },
        "win eoty": {
            "name": "Win {0} Event of the Year Award",
            "help": ""
        },
        "win gmoty": {
            "name": "Win {0} Craziest Match of the Year Award",
            "help": ""
        },
        "win woty": {
            "name": "Win {0} Wrestler of the Year Award",
            "help": "Wrestler of the year goes to the Superstar with the best average Match rating."
        },
        "new championship": {
            "name": "Create {0} new Championship",
            "help": ""
        },
        "championship prestige": {
            "name": "Raise the prestige of the {0} to {1}",
            "help": ""
        },
        "new tag team": {
            "name": "Create a Tag Team of {0} and make them Upper Midcarders",
            "help": ""
        },
        "new trio": {
            "name": "Create a Trio of {0} and make them Main Eventers",
            "help": ""
        },
        "win battle royal": {
            "name": "Have {0} win a major Battle Royal",
            "help": ""
        },
        "win championship contract": {
            "name": "Have {0} win a Cash-in Contract",
            "help": ""
        },
        "face of the company": {
            "name": "Make {0} a Face of the Company",
            "help": "Start by bringing a superstar to 1000 popularity and then keep it above 1000 for at least six monthly Events."
        },
        "main eventer": {
            "name": "Make {0} a Main Eventer",
            "help": ""
        },
        "get over": {
            "name": "Get {0} Over with the Fans",
            "help": "Get Overness to 80%"
        },
        "gimmick matches": {
            "name": "Hold {0} {1}* or higher {2} {3}",
            "help": "Only Matches at monthly Events count."
        }
    };
    // Get name
    let name = null;
    if (objectiveProperty.tag === "superstar") name = properties[objectiveProperty.name]["name"].format(objectiveProperty.superstarName);
    else if (objectiveProperty.tag === "rating") {
        const rating = String(objectiveProperty.rating);
        let noun;
        if (objectiveProperty.name === "events") noun = objectiveProperty.activationValue === 1 ? "Event" : "Events";
        else if (objectiveProperty.name === "matches" || objectiveProperty.name === "gimmick matches") noun = objectiveProperty.activationValue === 1 ? "Match" : "Matches";
        if (objectiveProperty.name === "gimmick matches") name = properties[objectiveProperty.name]["name"].format(objectiveProperty.activationValue, rating, objectiveProperty.gimmickMatchName, noun);
        else name = properties[objectiveProperty.name]["name"].format(objectiveProperty.activationValue, rating, noun);
    } else if (objectiveProperty.tag === "company") {
        if (objectiveProperty.name === "championship prestige") name = properties[objectiveProperty.name]["name"].format(objectiveProperty.championshipName, $40bc2387e9b94044$var$getChampionshipPrestigeIconHtml(objectiveProperty.activationText));
        else if (objectiveProperty.name === "holy shit moments") {
            let noun = objectiveProperty.activationValue === 1 ? "Moment" : "Moments";
            name = properties[objectiveProperty.name]["name"].format(String(objectiveProperty.activationValue), noun);
        } else if (objectiveProperty.name === "win awards") {
            let noun = objectiveProperty.activationValue === 1 ? "Award" : "Awards";
            name = properties[objectiveProperty.name]["name"].format(String(objectiveProperty.activationValue), noun);
        } else name = properties[objectiveProperty.name]["name"].format(String(objectiveProperty.activationValue));
    }
    // Create objective
    let newObjective = (0, $5NNI6.Objective)(name);
    await (0, $14eBR.Objectives).insert(newObjective);
    // Add help text
    let helpText = properties[objectiveProperty.name]["help"];
    if (helpText) newObjective.helpText = helpText;
    return newObjective;
}
async function $40bc2387e9b94044$var$createProperty(name, tag, roster, year, gimmickMatches, championships, monthsRemaining = 12, storyName = null) {
    // Set default values
    let activationValue = 1;
    let rating = null;
    let superstar = null;
    let superstarName = null;
    let teamSuperstars = [];
    let gimmickMatch = null;
    let gimmickMatchName = null;
    let championship = null;
    let championshipName = null;
    let activationText = null;
    let rosterSuperstars = (await (0, $dl5u4.getRosterSuperstars)(roster)).filter((x)=>!x.retired && !x.dead && x.activeEffect !== "traded" && x.activeEffect !== "retirement_return" && !x.fullTimeManager);
    let availableRosterSuperstars = rosterSuperstars.filter((x)=>!x.injured || x.injured < 5);
    // Set property attributes
    if (tag === "rating") {
        rating = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(4.5, 5));
        activationValue = (0, $3E8Nt.getRandomInt)(year + 1, year + 2);
        if (name === "gimmick matches") {
            rating = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(4.5, 5));
            if (activationValue > 6) activationValue = 6;
            let availableGimmickMatches = gimmickMatches.filter((x)=>x.rules !== "battle_royal" && x.available);
            if (availableGimmickMatches.length === 0) // If no available gimmick matches
            return $40bc2387e9b94044$var$createProperty("matches", tag, roster, year, gimmickMatches, championships);
            gimmickMatch = (0, $3E8Nt.getRandomChoice)(availableGimmickMatches);
        } else if (name === "events") {
            rating = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(4.5, 5));
            activationValue = (0, $3E8Nt.getRandomInt)(year + 1, year + 2);
            if (activationValue > 8) activationValue = 8;
            // Reduce events needed to complete goal if they are less than months remaining
            if (activationValue > monthsRemaining) activationValue = monthsRemaining;
        } else if (name === "matches") {
            rating = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomUniform)(4.5, 5));
            activationValue = (0, $3E8Nt.getRandomInt)(year + 2, (year + 2) * 2);
            if (activationValue > 20) activationValue = 20;
        }
    } else if (tag === "company") {
        activationValue = year + 2;
        if (activationValue > 10) activationValue = 10;
        if (name === "new championship") activationValue = 1;
        else if (name === "main eventers signed") {
            activationValue = year + 1;
            if (activationValue > 3) activationValue = 3;
        } else if ([
            "win moty",
            "win eoty",
            "win woty",
            "win gmoty"
        ].includes(name)) activationValue = 1;
        else if (name === "win awards") {
            activationValue = year + 1;
            if (activationValue > 5) activationValue = 5;
        } else if (name === "championship prestige") {
            // Get championships that don't have maximum prestige
            let prestigeItems = Object.entries((0, $3E8Nt.championshipPrestigeXps));
            let maximumChampionshipPrestige = (0, $3E8Nt.getArrayMaxByProperty)(prestigeItems, 1)[0];
            let availableChampionships = championships.filter((x)=>x.prestige !== maximumChampionshipPrestige && !x.matchContract && !x.championshipContract);
            if (availableChampionships.length === 0) return $40bc2387e9b94044$var$createProperty("win awards", tag, roster, year, gimmickMatches, championships);
            championship = (0, $3E8Nt.getRandomChoice)(availableChampionships);
            // Get next prestige
            activationText = prestigeItems.reverse().find((y)=>y[1] > championship.xp);
            if (activationText) activationText = activationText[0];
            activationValue = 1;
        }
    } else if (tag === "superstar") {
        if (name === "win battle royal") {
            let superstars = availableRosterSuperstars.filter((x)=>x.partTimer);
            if (superstars.length === 0) superstar = (0, $3E8Nt.getRandomChoice)(rosterSuperstars);
            else superstar = (0, $3E8Nt.getRandomChoice)(superstars);
        } else if (name === "win championship contract") {
            let championshipContracts = gimmickMatches.filter((x)=>x.cashinContractName !== null);
            if (championshipContracts.length > 0) {
                let superstars = availableRosterSuperstars.filter((x)=>(0, $5kTkA.getRankFromPopularity)(x.popularity) === "Upper Midcarder");
                if (superstars.length === 0) superstar = (0, $3E8Nt.getRandomChoice)(rosterSuperstars);
                else superstar = (0, $3E8Nt.getRandomChoice)(superstars);
            } else return $40bc2387e9b94044$var$createProperty("win battle royal", tag, roster, year, gimmickMatches, championships);
        } else if (name === "face of the company") {
            let superstars = availableRosterSuperstars.filter((x)=>(0, $5kTkA.getRankFromPopularity)(x.popularity) === "Main Eventer" && !x.faceOfTheCompany);
            if (superstars.length === 0) {
                superstars = availableRosterSuperstars.filter((x)=>!x.faceOfTheCompany);
                if (superstars.length === 0) return $40bc2387e9b94044$var$createProperty("main eventer", tag, roster, year, gimmickMatches, championships);
                else superstar = (0, $3E8Nt.getRandomChoice)(superstars);
            } else superstar = (0, $3E8Nt.getRandomChoice)(superstars);
        } else if (name === "main eventer") {
            let superstars = availableRosterSuperstars.filter((x)=>(0, $5kTkA.getRankFromPopularity)(x.popularity) === "Upper Midcarder" && x.popularity <= 750);
            if (superstars.length === 0) {
                superstars = availableRosterSuperstars.filter((x)=>(0, $5kTkA.getRankFromPopularity)(x.popularity) !== "Main Eventer");
                if (superstars.length === 0) return $40bc2387e9b94044$var$createProperty("win battle royal", tag, roster, year, gimmickMatches, championships);
                else superstar = (0, $3E8Nt.getRandomChoice)(superstars);
            } else superstar = (0, $3E8Nt.getRandomChoice)(superstars);
            if (storyName === "tutorial") superstar = availableRosterSuperstars.find((x)=>x.name === "Johnny Knight");
        } else if (name === "new tag team") {
            let tagTeamSuperstars = (await Promise.all((await (0, $dl5u4.getRosterTagTeams)(roster)).map((x)=>(0, $972Ip.getTagTeamSuperstars)(x)))).flat();
            let superstars = availableRosterSuperstars.filter((x)=>(0, $5kTkA.getRankFromPopularity)(x.popularity) === "Lower Midcarder" && !x.partTimer && !(0, $3E8Nt.objectInArray)(x, tagTeamSuperstars));
            if (superstars.length < 2) return $40bc2387e9b94044$var$createProperty("main eventer", tag, roster, year, gimmickMatches, championships);
            let firstSuperstar = (0, $3E8Nt.getRandomChoice)(superstars);
            teamSuperstars.push(firstSuperstar);
            let otherSuperstars = superstars.filter((x)=>x.gender === firstSuperstar.gender && (!x.brandName || x.brandName === firstSuperstar.brandName) && !(0, $3E8Nt.objectInArray)(x, teamSuperstars));
            if (otherSuperstars.length === 0) return $40bc2387e9b94044$var$createProperty("main eventer", tag, roster, year, gimmickMatches, championships);
            let secondSuperstar = (0, $3E8Nt.getRandomChoice)(otherSuperstars);
            teamSuperstars.push(secondSuperstar);
        } else if (name === "new trio") {
            let tagTeamSuperstars = (await Promise.all((await (0, $dl5u4.getRosterTagTeams)(roster)).map((x)=>(0, $972Ip.getTagTeamSuperstars)(x)))).flat();
            let superstars = availableRosterSuperstars.filter((x)=>(0, $5kTkA.getRankFromPopularity)(x.popularity) === "Upper Midcarder" && !x.partTimer && !(0, $3E8Nt.objectInArray)(x, tagTeamSuperstars));
            if (superstars.length < 3) return $40bc2387e9b94044$var$createProperty("main eventer", tag, roster, year, gimmickMatches, championships);
            let firstSuperstar = (0, $3E8Nt.getRandomChoice)(superstars);
            teamSuperstars.push(firstSuperstar);
            let otherSuperstars = superstars.filter((x)=>x.gender === firstSuperstar.gender && (!x.brandName || x.brandName === firstSuperstar.brandName) && !(0, $3E8Nt.objectInArray)(x, teamSuperstars));
            if (otherSuperstars.length < 2) return $40bc2387e9b94044$var$createProperty("main eventer", tag, roster, year, gimmickMatches, championships);
            let secondSuperstar = (0, $3E8Nt.getRandomChoice)(otherSuperstars);
            otherSuperstars = otherSuperstars.filter((x)=>x.$loki !== secondSuperstar.$loki);
            teamSuperstars.push(secondSuperstar);
            let thirdSuperstar = (0, $3E8Nt.getRandomChoice)(otherSuperstars);
            teamSuperstars.push(thirdSuperstar);
        } else if (name === "get over") {
            let superstars = availableRosterSuperstars.filter((x)=>x.overness <= 60);
            if (superstars.length === 0) {
                superstars = availableRosterSuperstars.filter((x)=>!x.hot);
                if (superstars.length === 0) return $40bc2387e9b94044$var$createProperty("main eventer", tag, roster, year, gimmickMatches, championships);
                else superstar = (0, $3E8Nt.getRandomChoice)(superstars);
            } else superstar = (0, $3E8Nt.getRandomChoice)(superstars);
        }
        activationValue = 1;
    }
    // Set names
    if (superstar) superstarName = superstar.name;
    else if (teamSuperstars.length > 0) superstarName = (0, $3E8Nt.commaSeparate)(teamSuperstars.map((z)=>z.name).sort((a, b)=>a.localeCompare(b)));
    if (gimmickMatch) gimmickMatchName = gimmickMatch.name;
    if (championship) championshipName = (0, $1JSre.getChampionshipDisplayName)(championship);
    // Create property
    let objectiveProperty = (0, $ct4m6.Property)(name, activationValue, tag, rating, superstarName, gimmickMatchName, championshipName);
    await (0, $14eBR.Properties).insert(objectiveProperty);
    if (activationText) objectiveProperty.activationText = activationText;
    // Add property relationships
    if (superstar) await (0, $ct4m6.addPropertySuperstars)(objectiveProperty, [
        superstar
    ]);
    else if (teamSuperstars.length > 0) await (0, $ct4m6.addPropertySuperstars)(objectiveProperty, teamSuperstars);
    if (gimmickMatch) await (0, $ct4m6.addPropertyGimmickMatches)(objectiveProperty, [
        gimmickMatch
    ]);
    if (championship) await (0, $ct4m6.addPropertyGimmickMatches)(objectiveProperty, [
        championship
    ]);
    return objectiveProperty;
}
function $40bc2387e9b94044$var$getChampionshipPrestigeIconHtml(prestige) {
    let iconClass = "bronze";
    if (prestige === "C") iconClass = "bronze";
    else if (prestige === "B") iconClass = "silver";
    else if (prestige === "A") iconClass = "gold-light";
    else if (prestige === "S") iconClass = "obsidian";
    return `<i class="fa fa-star-o font-bold ${iconClass}"></i>`;
}

});
parcelRequire.register("ct4m6", function(module, exports) {

$parcel$export(module.exports, "Property", () => $913b9263744eb004$export$41b04b3a73e7216d);
$parcel$export(module.exports, "getPropertyObjective", () => $913b9263744eb004$export$6a46f9a1f03394af);
$parcel$export(module.exports, "addPropertyGimmickMatches", () => $913b9263744eb004$export$780acccd35f46a39);
$parcel$export(module.exports, "getPropertyGimmickMatches", () => $913b9263744eb004$export$859408d0d8193132);
$parcel$export(module.exports, "addPropertySuperstars", () => $913b9263744eb004$export$a892b0ae32d49542);
$parcel$export(module.exports, "getPropertySuperstars", () => $913b9263744eb004$export$3df1030e65656824);
$parcel$export(module.exports, "addPropertyChampionships", () => $913b9263744eb004$export$c500463a55ccdbed);
$parcel$export(module.exports, "getPropertyChampionships", () => $913b9263744eb004$export$fd9e7fa6826be2a5);

var $14eBR = parcelRequire("14eBR");
function $913b9263744eb004$export$41b04b3a73e7216d(name, activationValue, tag, rating, superstarName = null, gimmickMatchName = null, championshipName = null) {
    // Integer
    const value = 0;
    // Strings
    const activationText = null;
    // Foreign keys
    const objectiveId = null;
    return {
        name: name,
        activationText: activationText,
        activationValue: activationValue,
        tag: tag,
        rating: rating,
        superstarName: superstarName,
        gimmickMatchName: gimmickMatchName,
        championshipName: championshipName,
        objectiveId: objectiveId,
        value: value
    };
}
function $913b9263744eb004$export$6a46f9a1f03394af(property) {
    return (0, $14eBR.Objectives).find({
        "$loki": property.objectiveId
    })[0];
}
function $913b9263744eb004$export$780acccd35f46a39(property, gimmickMatches) {
    gimmickMatches.forEach((c)=>{
        c.propertyId = property.$loki;
    });
}
function $913b9263744eb004$export$3674a71e69a68f05(property, gimmickMatches) {
    gimmickMatches.forEach((c)=>{
        c.propertyId = null;
    });
}
function $913b9263744eb004$export$859408d0d8193132(property) {
    return (0, $14eBR.GimmickMatches).find({
        "propertyId": property.$loki
    });
}
function $913b9263744eb004$export$a892b0ae32d49542(property, superstars) {
    superstars.forEach((c)=>{
        c.propertyId = property.$loki;
    });
}
function $913b9263744eb004$export$7c3d04399874fa26(property, superstars) {
    superstars.forEach((c)=>{
        c.propertyId = null;
    });
}
function $913b9263744eb004$export$3df1030e65656824(property) {
    return (0, $14eBR.Superstars).find({
        "propertyId": property.$loki
    });
}
function $913b9263744eb004$export$c500463a55ccdbed(property, championships) {
    championships.forEach((c)=>{
        c.propertyId = property.$loki;
    });
}
function $913b9263744eb004$export$d7b6ce3fff0f37d3(property, championships) {
    championships.forEach((c)=>{
        c.propertyId = null;
    });
}
function $913b9263744eb004$export$fd9e7fa6826be2a5(property) {
    return (0, $14eBR.Championships).find({
        "propertyId": property.$loki
    });
}

});


parcelRequire.register("bZol7", function(module, exports) {

$parcel$export(module.exports, "loadUser", () => $8ba8458c91463dd8$export$1e060e77a27c83ed);
$parcel$export(module.exports, "saveUser", () => $8ba8458c91463dd8$export$ca0e1882e225378b);
$parcel$export(module.exports, "syncUserData", () => $8ba8458c91463dd8$export$112e54780100078b);

var $7U7I2 = parcelRequire("7U7I2");

var $98xmD = parcelRequire("98xmD");

var $3E8Nt = parcelRequire("3E8Nt");

var $1JSre = parcelRequire("1JSre");
function $8ba8458c91463dd8$export$1e060e77a27c83ed() {
    return JSON.parse(localStorage.getItem("tempUserData")) || (0, $7U7I2.User)();
}
function $8ba8458c91463dd8$export$ca0e1882e225378b(userData) {
    window.localStorage.setItem("tempUserData", JSON.stringify(userData));
}
async function $8ba8458c91463dd8$export$112e54780100078b() {
    if (window.navigator.onLine) {
        let user = $8ba8458c91463dd8$export$1e060e77a27c83ed();
        return new Promise((resolve, reject)=>{
            $.ajax({
                type: "POST",
                contentType: "application/json; charset=utf-8",
                url: (0, $98xmD.globals).baseUrl + "/_sync_user_data",
                data: JSON.stringify({
                    userData: user
                }),
                timeout: (0, $1JSre.requestTimeout),
                success: async (data)=>{
                    if (data && Object.keys(data).length !== 0) {
                        user.eventsPlayed = data["eventsPlayed"];
                        user.unlockedSegments = data["unlockedSegments"];
                        user.storiesCompleted = data["storiesCompleted"];
                        user.talentRequestTypesCompleted = data["talentRequestTypesCompleted"];
                        user.unlockedPowerups = data["unlockedPowerups"];
                        user.unlockedCharacters = data["unlockedCharacters"];
                        user.unlockedCombinations = data["unlockedCombinations"];
                        $8ba8458c91463dd8$export$ca0e1882e225378b(user);
                    }
                    resolve();
                },
                error: function(jqXHR, status, errorThrown) {
                    (0, $3E8Nt.captureError)(new Error("error for sync user data: " + errorThrown));
                    resolve();
                }
            });
        });
    }
}

});
parcelRequire.register("7U7I2", function(module, exports) {

$parcel$export(module.exports, "User", () => $5c13be4221ff3e68$export$1f44aaf2ec115b54);
function $5c13be4221ff3e68$export$1f44aaf2ec115b54() {
    // Integer
    const eventsPlayed = 0;
    // Arrays
    const unlockedSegments = [];
    const storiesCompleted = [];
    const talentRequestTypesCompleted = [];
    const unlockedPowerups = [];
    const unlockedCharacters = [];
    // Objects
    const unlockedCombinations = {};
    const settings = {};
    // Strings
    const updateVersionShown = null;
    return {
        eventsPlayed: eventsPlayed,
        unlockedSegments: unlockedSegments,
        storiesCompleted: storiesCompleted,
        talentRequestTypesCompleted: talentRequestTypesCompleted,
        unlockedCombinations: unlockedCombinations,
        settings: settings,
        unlockedPowerups: unlockedPowerups,
        unlockedCharacters: unlockedCharacters,
        updateVersionShown: updateVersionShown
    };
}

});



parcelRequire.register("jC7EP", function(module, exports) {

$parcel$export(module.exports, "createFemmeFataleMatch", () => $e47781944504d946$export$fd95e87bbb04bfd2);
$parcel$export(module.exports, "getPowDialog", () => $e47781944504d946$export$52b922e7a9678a13);
$parcel$export(module.exports, "createPowObjectives", () => $e47781944504d946$export$63269602324eb9c3);
$parcel$export(module.exports, "processPowStarResult", () => $e47781944504d946$export$e700a720381f5a12);
$parcel$export(module.exports, "getPowPostEventDialogs", () => $e47781944504d946$export$836f392434f5bd5d);
$parcel$export(module.exports, "processPowStoryChoices", () => $e47781944504d946$export$3a485001f774d547);
$parcel$export(module.exports, "getPowProducerReactionDialogs", () => $e47781944504d946$export$38b8a45a32c85077);
$parcel$export(module.exports, "processPowSuperstarLeavesCompany", () => $e47781944504d946$export$fc22fcb5e9bec97e);

var $cYLJ6 = parcelRequire("cYLJ6");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $9esFv = parcelRequire("9esFv");

var $5kTkA = parcelRequire("5kTkA");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $4EOBX = parcelRequire("4EOBX");

var $5NNI6 = parcelRequire("5NNI6");

var $14eBR = parcelRequire("14eBR");

var $ct4m6 = parcelRequire("ct4m6");

var $7UN4J = parcelRequire("7UN4J");

var $iQtzn = parcelRequire("iQtzn");

var $eg5dz = parcelRequire("eg5dz");

var $cMrnz = parcelRequire("cMrnz");

var $hBIDz = parcelRequire("hBIDz");

var $i7bmn = parcelRequire("i7bmn");

var $ycsyu = parcelRequire("ycsyu");

var $cXLSF = parcelRequire("cXLSF");

var $bZol7 = parcelRequire("bZol7");
function $e47781944504d946$export$fd95e87bbb04bfd2() {
    const newGimmickMatch = (0, $cYLJ6.GimmickMatch)();
    newGimmickMatch.name = "Femme Fatale";
    newGimmickMatch.description = "A story-driven, women only match invented by Hank Hughes.";
    newGimmickMatch.cost = 70;
    newGimmickMatch.ratingBoost = 1.25;
    newGimmickMatch.popularityIncrease = 2;
    newGimmickMatch.popularityDecrease = 0.6;
    newGimmickMatch.injuryRate = 1.05;
    newGimmickMatch.special = true;
    return newGimmickMatch;
}
async function $e47781944504d946$export$52b922e7a9678a13() {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const goals = await (0, $9esFv.getCompanyObjectives)(userCompany);
    const storyChoices = (await (0, $9esFv.getCompanyStoryChoices)(userCompany)).reverse();
    const powSuccessEnding = storyChoices.find((x)=>x.choice === "success_ending");
    for (let [person, dialog] of Object.entries((0, $4EOBX.powDialog)))// Hank Hughes' dialog if not at success ending
    if (person === "Hank Hughes" && !powSuccessEnding) {
        let storyPosition;
        if (game.monthCount === 0 && game.year === 0) storyPosition = "introduction";
        else storyPosition = "normal";
        data[person] = dialog[storyPosition];
        data[person]["information"] = dialog["information"];
        data[person]["storyPosition"] = storyPosition;
        // Remove 'what do you think of x' dialogs if their goal has finished
        data[person]["choices"] = data[person]["choices"].filter((y)=>{
            return !y["person_name"] || goals.find((x)=>x.name === `Make ${y["person_name"]} a Star` && !x.completed && !x.failed);
        });
    } else {
        let superstar = rosterSuperstars.find((x)=>x.name === person);
        if (superstar && !superstar.dead && !superstar.retired) {
            // Get dialog if available based on story position
            let storyPosition;
            if (game.monthCount === 0 && game.year === 0) storyPosition = "introduction";
            else {
                let storyChoice = storyChoices.find((x)=>x.information && x.information === superstar.name);
                if (storyChoice) storyPosition = storyChoice.choice;
                else if ($e47781944504d946$var$checkPowStarRequirement(superstar)) storyPosition = "confident";
                else storyPosition = "normal";
            }
            if (dialog[storyPosition]) {
                data[person] = dialog[storyPosition];
                data[person]["information"] = $e47781944504d946$var$getPowDialogPersonInformation(superstar);
            }
        }
    }
    return data;
}
function $e47781944504d946$var$getPowDialogPersonInformation(superstar) {
    let graphic = (0, $5kTkA.getGraphicForSuperstar)(superstar);
    delete graphic.uid;
    let workrate = superstar.hot ? superstar.workrate + 1 : superstar.workrate;
    let charisma = superstar.hot ? superstar.charisma + 1 : superstar.charisma;
    return {
        "popularity": superstar.popularity,
        "hot": superstar.hot,
        "name": superstar.name,
        "workrate": workrate,
        "charisma": charisma,
        "overness": superstar.overness,
        "graphic": graphic
    };
}
function $e47781944504d946$var$checkPowStarRequirement(superstar) {
    // Check if star's requirement has been fulfilled
    if (superstar.name === "Lady Julia") return true;
    if (superstar.name === "Violet") {
        if (superstar.workrate >= 3) return true;
    }
    if (superstar.name === "Natasha Ali") {
        if ((0, $5kTkA.getRankFromPopularity)(superstar.popularity) === "Main Eventer") return true;
    }
    if (superstar.name === "Zora") {
        if (superstar.hot) return true;
    }
}
async function $e47781944504d946$export$63269602324eb9c3(company) {
    let objectives = [];
    // Sponsors goal
    let mainObjective = (0, $5NNI6.Objective)("Get some Sponsors");
    (0, $14eBR.Objectives).insert(mainObjective);
    let mainObjectiveProperty = (0, $ct4m6.Property)("get sponsors", 1, "company", null);
    (0, $14eBR.Properties).insert(mainObjectiveProperty);
    await (0, $5NNI6.addObjectiveProperties)(mainObjective, [
        mainObjectiveProperty
    ]);
    objectives.push(mainObjective);
    // Stars' goals
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>[
            "Lady Julia",
            "Violet",
            "Natasha Ali",
            "Zora"
        ].includes(x.name));
    for (let superstar of superstars){
        let starObjective = (0, $5NNI6.Objective)(`Make ${superstar.name} a Star`);
        (0, $14eBR.Objectives).insert(starObjective);
        let starObjectiveProperty = (0, $ct4m6.Property)("star", 1, "superstar", null, superstar.name);
        (0, $14eBR.Properties).insert(starObjectiveProperty);
        await (0, $5NNI6.addObjectiveProperties)(starObjective, [
            starObjectiveProperty
        ]);
        await (0, $ct4m6.addPropertySuperstars)(starObjectiveProperty, [
            superstar
        ]);
        objectives.push(starObjective);
        if (superstar.name === "Violet") superstar.workrateXp = 150;
        if (superstar.name === "Zora") superstar.morale = 30;
    }
    return objectives;
}
async function $e47781944504d946$export$e700a720381f5a12(superstar, company) {
    let data = {};
    let goals = await (0, $9esFv.getCompanyObjectives)(company);
    let goal = goals.find((x)=>x.name === `Make ${superstar.name} a Star` && !x.completed && !x.failed);
    if (goal) {
        let goalProperty = (await (0, $5NNI6.getObjectiveProperties)(goal))[0];
        let goalSuperstar = (await (0, $ct4m6.getPropertySuperstars)(goalProperty))[0];
        if (goalSuperstar.$loki === superstar.$loki) {
            let isStar = $e47781944504d946$var$checkPowStarRequirement(superstar);
            if (isStar) {
                goalProperty.value += 1;
                goal.completed = true;
                data["completed"] = true;
                let newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("goalCompleted", goal.name);
                await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                    newCompanyAlert
                ]);
            } else {
                goal.failed = true;
                data["failed"] = true;
                let newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("goalFailed", goal.name);
                await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                    newCompanyAlert
                ]);
            }
            // Add star changes
            data["superstarChanges"] = await $e47781944504d946$var$addPowStarResultChanges(superstar, isStar);
            // Add story choice
            let storyWord = isStar ? "success" : "failure";
            let storyChoice = $e47781944504d946$var$createPowStoryChoice(`${storyWord}_post_event`, superstar.name);
            await (0, $9esFv.addCompanyStoryChoices)(company, [
                storyChoice
            ]);
        }
    }
    return data;
}
function $e47781944504d946$var$createPowStoryChoice(choice, information = null) {
    let storyChoice = (0, $7UN4J.StoryChoice)();
    storyChoice.choice = choice;
    (0, $14eBR.StoryChoices).insert(storyChoice);
    if (information) storyChoice.information = information;
    return storyChoice;
}
async function $e47781944504d946$var$addPowStarResultChanges(superstar, isStar) {
    let data = {};
    // Add success effect
    if (isStar) {
        if (superstar.name === "Lady Julia") {
            superstar.workrateXp = 80;
            superstar.workrate = 1;
        }
        if (superstar.overness < 80) {
            superstar.overness += 20;
            superstar.stale = false;
        }
        if (superstar.morale < 40) superstar.morale += 20;
    } else {
        if (superstar.name === "Violet") {
            superstar.partTimer = true;
            superstar.appearances = (0, $3E8Nt.getRandomInt)(2, 6);
        }
        if (superstar.name === "Natasha Ali") {
            data["popularityChange"] = -150;
            superstar.popularity += data["popularityChange"];
            if (superstar.popularity < 0) superstar.popularity = 0;
        }
        if (superstar.name === "Zora") {
            superstar.overness = 5;
            superstar.stale = true;
        }
        if (superstar.morale >= 60) {
            if (superstar.morale >= 80) superstar.morale += -45;
            else superstar.morale += -25;
        }
    }
    return data;
}
function $e47781944504d946$export$836f392434f5bd5d(storyChoices, rosterSuperstars) {
    // Get post event dialog after 'post_event' if 'next_event' not added
    let dialogs = [];
    for (let storyChoice of storyChoices){
        let { storyPosition: storyPosition } = $e47781944504d946$var$getPowStoryPositionAndResult(storyChoice);
        if (storyPosition === "post_event") {
            let personName = storyChoice.information;
            let nextStoryPosition = $e47781944504d946$var$getPowNextStoryPosition(storyPosition);
            let nextStoryChoice = storyChoices.find((x)=>x.information === personName && x.choice.split("_").slice(1).join("_") === nextStoryPosition);
            if (!nextStoryChoice) {
                // Get dialog and information
                let dialogData = (0, $4EOBX.powDialog)[personName][storyChoice.choice];
                let superstar = rosterSuperstars.find((x)=>x.name === personName);
                dialogData["information"] = $e47781944504d946$var$getPowDialogPersonInformation(superstar);
                dialogs.push(dialogData);
            }
        }
    }
    return dialogs;
}
function $e47781944504d946$var$getPowStoryPositionAndResult(storyChoice) {
    let storyChoiceSplit = storyChoice.choice.split("_");
    return {
        storyPosition: storyChoiceSplit.slice(1).join("_"),
        resultWord: storyChoiceSplit[0]
    };
}
function $e47781944504d946$var$getPowNextStoryPosition(storyPosition) {
    if (storyPosition === "post_event") return "next_event";
    if (storyPosition === "next_event") return "normal";
    if (storyPosition === "goals") return "pre_premier_event";
    if (storyPosition === "pre_premier_event") return "ending";
    if (storyPosition === "ending") return "post_ending";
}
async function $e47781944504d946$export$3a485001f774d547(storyChoices, company, event) {
    // Runs after monthly event, adds next story choice
    const objectives = await (0, $9esFv.getCompanyObjectives)(company);
    const sponsorGoal = objectives.find((x)=>x.name === "Get some Sponsors");
    const starGoals = objectives.filter((x)=>x.$loki !== sponsorGoal.$loki);
    for (let storyChoice of storyChoices){
        // Get result and story position
        let { storyPosition: storyPosition, resultWord: resultWord } = $e47781944504d946$var$getPowStoryPositionAndResult(storyChoice);
        let nextStoryPosition = $e47781944504d946$var$getPowNextStoryPosition(storyPosition);
        // If at 'pre_premier_event' in story and premier event not held
        if (storyPosition === "pre_premier_event" && !sponsorGoal.completed && !sponsorGoal.failed) {
            // Check for premier event result if at monthly event, complete/fail sponsors goal
            if (!event.weeklyShow && event.name !== "Weekly Show") {
                resultWord = $e47781944504d946$var$getPowPremierEventResult(starGoals.filter((x)=>x.completed).length, event.rating);
                if (resultWord === "success") {
                    sponsorGoal.completed = true;
                    await $e47781944504d946$var$processPowPremierEventSuccess(company);
                } else sponsorGoal.failed = true;
            } else nextStoryPosition = null; // Skip next story position if not at monthly event
        }
        // If at 'goals' in story and premier event not held
        if (storyPosition === "goals" && !sponsorGoal.completed && !sponsorGoal.failed) {
            // Process premier event if next event is monthly event
            let latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
            if (!latestEvent.weeklyShow && latestEvent.name !== "Weekly Show") {
                latestEvent.activeEffect = "premier_event";
                await $e47781944504d946$var$processPowPremierEvent(company, latestEvent, resultWord);
            }
        }
        // Add next story position
        if (nextStoryPosition) {
            let nextStoryChoiceText = `${resultWord}_${nextStoryPosition}`;
            await $e47781944504d946$var$checkToAddPowStoryChoice(storyChoices, company, nextStoryChoiceText, storyChoice.information);
        }
    }
    // Add goals story choice after goals finished
    if (starGoals.every((x)=>x.completed || x.failed)) {
        let resultWord;
        if (starGoals.every((x)=>x.completed)) resultWord = "success";
        else resultWord = "failure";
        let nextStoryChoiceText = `${resultWord}_goals`;
        await $e47781944504d946$var$checkToAddPowStoryChoice(storyChoices, company, nextStoryChoiceText);
    }
}
async function $e47781944504d946$var$checkToAddPowStoryChoice(storyChoices, company, storyChoiceText, information = null) {
    let nextStoryPosition = storyChoiceText.split("_").slice(1).join("_");
    let nextStoryChoice = storyChoices.find((x)=>x.information === information && x.choice.split("_").slice(1).join("_") === nextStoryPosition);
    if (!nextStoryChoice) {
        let newStoryChoice = $e47781944504d946$var$createPowStoryChoice(storyChoiceText, information);
        await (0, $9esFv.addCompanyStoryChoices)(company, [
            newStoryChoice
        ]);
    }
}
async function $e47781944504d946$export$38b8a45a32c85077(company) {
    let dialogs = [];
    let storyChoices = (await (0, $9esFv.getCompanyStoryChoices)(company)).reverse();
    // Get next event and ending dialogs
    let nextEventDialogs = $e47781944504d946$var$getPowProducerNextEventDialogs(storyChoices);
    let endingDialog = await $e47781944504d946$var$getPowProducerEndingDialog(storyChoices, company);
    // Add to dialogs list if found
    if (nextEventDialogs) dialogs.push(...nextEventDialogs);
    if (endingDialog) dialogs.push(endingDialog);
    return dialogs;
}
function $e47781944504d946$var$getPowProducerNextEventDialogs(storyChoices) {
    let dialogs = [];
    for (let storyChoice of storyChoices){
        let { storyPosition: storyPosition, resultWord: resultWord } = $e47781944504d946$var$getPowStoryPositionAndResult(storyChoice);
        // Get reaction dialog at 'next_event' if 'normal' not added
        if (storyPosition === "next_event") {
            let personName = storyChoice.information;
            let nextStoryPosition = $e47781944504d946$var$getPowNextStoryPosition(storyPosition);
            let nextStoryChoice = storyChoices.find((x)=>x.information === personName && x.choice.split("_").slice(1).join("_") === nextStoryPosition);
            if (!nextStoryChoice) {
                // Get dialog
                let dialogEvent = `${personName.toLowerCase().replace(" ", "_")}_${resultWord}`;
                let dialogData = $e47781944504d946$var$getProducerDialogData(dialogEvent);
                dialogs.push(dialogData);
            }
        }
    }
    return dialogs;
}
async function $e47781944504d946$var$getPowProducerEndingDialog(storyChoices, company) {
    for (let storyChoice of storyChoices){
        let { storyPosition: storyPosition } = $e47781944504d946$var$getPowStoryPositionAndResult(storyChoice);
        // Get dialog if at that story position and not at next
        if ([
            "ending",
            "goals",
            "pre_premier_event"
        ].includes(storyPosition)) {
            // Get next story position
            let nextStoryPosition = $e47781944504d946$var$getPowNextStoryPosition(storyPosition);
            let nextStoryChoice = storyChoices.find((x)=>x.choice.split("_").slice(1).join("_") === nextStoryPosition);
            if (!nextStoryChoice) {
                // Skip 'pre_premier_event' dialog if not at monthly event
                if (storyPosition === "pre_premier_event") {
                    let latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
                    if (latestEvent.weeklyShow || latestEvent.name === "Weekly Show") return null;
                }
                return $e47781944504d946$var$getProducerDialogData(storyChoice.choice);
            }
        }
    }
    return null;
}
function $e47781944504d946$var$getProducerDialogData(storyPosition) {
    let producerDialogData = (0, $4EOBX.powDialog)["Hank Hughes"];
    let dialogData = producerDialogData[storyPosition];
    dialogData["information"] = producerDialogData["information"];
    return dialogData;
}
async function $e47781944504d946$var$processPowPremierEvent(company, event, resultWord) {
    // Add Femme Fatale match with top stars and owner promo to premier event
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Add once
    if (!(await (0, $iQtzn.getEventMatches)(event)).length) {
        // Add femme fatale match if all star goals completed
        if (resultWord === "success") {
            let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
            let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
            // Get stars
            let superstars = [];
            for (let name of [
                "Lady Julia",
                "Violet",
                "Natasha Ali",
                "Zora"
            ]){
                let superstar = rosterSuperstars.find((x)=>x.name === name);
                if (superstar) superstars.push(superstar);
            }
            if (superstars.length >= 2) {
                // Add match
                const newMatch = (0, $i7bmn.Match)(event.matchesCount, "singles");
                (0, $14eBR.Matches).insert(newMatch);
                await (0, $iQtzn.addEventMatches)(event, [
                    newMatch
                ]);
                event.matchesCount += 1;
                await (0, $i7bmn.addMatchParticipants)(newMatch, superstars);
                // Add gimmick match
                let newGimmickMatch = (0, $8A6FL.generateGimmickMatch)();
                (0, $14eBR.GimmickMatches).insert(newGimmickMatch);
                newGimmickMatch.name = "Femme Fatale";
                await (0, $cYLJ6.addGimmickMatchMatches)(newGimmickMatch, [
                    newMatch
                ]);
                // Add feuds
                let tagTeamsPresent = [];
                for (const s of superstars)tagTeamsPresent.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
                tagTeamsPresent = (0, $3E8Nt.getUniqueObjects)(tagTeamsPresent);
                let matchFeuds = await (0, $cXLSF.getParticipantFeuds)(superstars, tagTeamsPresent);
                await (0, $i7bmn.addMatchFeuds)(newMatch, matchFeuds);
                for (const feud of matchFeuds)if (!feud.started && feud.directFeudEvent && !feud.ended) {
                    feud.startMonth = game.monthCount;
                    feud.startYear = game.year;
                    feud.runBlowoff = false;
                }
                // Add managers
                (0, $ycsyu.setManagersForMatchOrSegment)(newMatch, superstars, rosterSuperstars);
            }
        }
        // Add owner promo
        let text = {};
        text["start"] = [
            "Hank Hughes comes out to the ring to welcome the fans to the show."
        ];
        text["action"] = [
            `"Ladies and Gentlemen, welcome to ${event.name}, one of our most eagerly anticipated events ever! The ` + `amazing talents of our women will be showcased tonight as they offer you incredible action ` + `and drama that is sure to have you jumping out of your seats. I am Hank Hughes, and this is: ` + `Passion. Of. Wrestling!"`
        ];
        let segmentItem = (0, $8A6FL.createCustomSegmentItem)("Welcome to POW", 1, text, false, false, false, false, false);
        (0, $14eBR.SegmentItems).insert(segmentItem);
        let newSegment = (0, $eg5dz.Segment)();
        newSegment.hype = 50;
        (0, $14eBR.Segments).insert(newSegment);
        await (0, $cMrnz.addSegmentItemSegments)(segmentItem, [
            newSegment
        ]);
        await (0, $iQtzn.addEventSegments)(event, [
            newSegment
        ]);
        newSegment.order = event.matchesCount;
        event.matchesCount += 1;
        // Add producer to segment
        let producerData = (0, $4EOBX.powDialog)["Hank Hughes"]["information"];
        let producer = (0, $hBIDz.Superstar)(producerData["name"], 800, 46);
        (0, $14eBR.Superstars).insert(producer);
        producer.gender = "male";
        producer.graphic = JSON.parse(JSON.stringify(producerData["graphic"]));
        await (0, $eg5dz.addSegmentSuperstars)(newSegment, [
            producer
        ]);
    }
}
function $e47781944504d946$var$getPowPremierEventResult(numberOfStarsMade, eventRating) {
    let result = "failure";
    if (numberOfStarsMade >= 4) // Success if all star goals completed
    result = "success";
    else if (numberOfStarsMade >= 1) // Chance for success if at least 1 star goal completed
    {
        if (eventRating >= 3.5) {
            let chance = numberOfStarsMade * 25;
            if (eventRating >= 4.5) chance += 25;
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= chance) result = "success";
        }
    }
    return result;
}
async function $e47781944504d946$var$processPowPremierEventSuccess(company) {
    // Add creative points
    company.points += (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(500, 700), 50);
    // Add to stories completed
    const user = (0, $bZol7.loadUser)();
    if (user && !user.storiesCompleted.includes("passion")) {
        user.storiesCompleted.push("passion");
        (0, $bZol7.saveUser)(user);
    }
    // Add femme fatale
    const femmeFataleMatch = $e47781944504d946$export$fd95e87bbb04bfd2();
    (0, $14eBR.GimmickMatches).insert(femmeFataleMatch);
    await (0, $9esFv.addCompanyGimmickMatches)(company, [
        femmeFataleMatch
    ]);
    return true;
}
async function $e47781944504d946$export$fc22fcb5e9bec97e(superstar, company) {
    // Fail star goal if superstar leaves company
    let goals = await (0, $9esFv.getCompanyObjectives)(company);
    let goal = goals.find((x)=>x.name === `Make ${superstar.name} a Star` && !x.failed);
    if (goal) {
        let goalProperty = (await (0, $5NNI6.getObjectiveProperties)(goal))[0];
        let goalSuperstar = (await (0, $ct4m6.getPropertySuperstars)(goalProperty))[0];
        if (goalSuperstar.$loki === superstar.$loki) {
            goal.failed = true;
            goal.completed = false;
            let newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("goalFailed", goal.name);
            await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                newCompanyAlert
            ]);
        }
    }
    return true;
}

});
parcelRequire.register("4EOBX", function(module, exports) {

$parcel$export(module.exports, "powDialog", () => $3642282910481935$export$59c56095808f2dbd);
const $3642282910481935$export$59c56095808f2dbd = {
    "Natasha Ali": {
        "introduction": {
            "text": [
                "Hi? Oh, you're the new booker."
            ],
            "choices": [
                {
                    "text": [
                        "Tell me about yourself Natasha."
                    ],
                    "reply": {
                        "text": [
                            "Okay. I joined POW a few months ago. I've done a few matches here and there but nothing big. Hank said he sees a lot in me but he probably says that to everyone."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "You don't see yourself becoming a star?"
                                ],
                                "reply": {
                                    "text": [
                                        "No. I mean I just got here. Maybe once I'm good enough, but that's a long time away."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "Okay, see you."
                    ],
                    "reply": {
                        "text": [
                            "Okay."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "normal": {
            "text": [
                "Hi."
            ],
            "choices": [
                {
                    "text": [
                        "How would you like to be POW champion?"
                    ],
                    "reply": {
                        "text": [
                            "Me? No way, I'm not ready. I'm not even a main eventer. The fans would hate it. I can't be the champion."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "Why don't you think you're good enough?"
                                ],
                                "reply": {
                                    "text": [
                                        "I don't know. I just think other women deserve it more. I don't want them to hate me, or the fans to hate me."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "What do you think of Hank?"
                    ],
                    "reply": {
                        "text": [
                            "Hank was really kind to hire me. I didn't have much experience wrestling, and being an immigrant with a name like mine didn't really make me a promised star. But he gave me a shot, and I guess I have to prove that he didn't make a mistake."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "See you later."
                    ],
                    "reply": {
                        "text": [
                            "Okay."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "confident": {
            "text": [
                "Hi."
            ],
            "choices": [
                {
                    "text": [
                        "How would you like to be POW champion?"
                    ],
                    "reply": {
                        "text": [
                            "Really, you think I'm ready? I'm not sure if the fans are, but Hank talked to me about it too. If you both think it's a good idea .. "
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "What do you think of Hank?"
                    ],
                    "reply": {
                        "text": [
                            "Hank was really kind to hire me. I didn't have much experience wrestling, and being an immigrant with a name like mine didn't really make me a promised star. But he gave me a shot, and I guess I have to prove that he didn't make a mistake."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "See you later."
                    ],
                    "reply": {
                        "text": [
                            "Okay, see you."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_post_event": {
            "text": [
                "Wow .. I can't believe that actually happened. That went well, right?"
            ],
            "choices": [
                {
                    "text": [
                        "It went really well."
                    ],
                    "reply": {
                        "text": [
                            "Thank you .. the fans, they really liked me .. "
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "There's a long way to go."
                    ],
                    "reply": {
                        "text": [
                            "Of course .. I hope I'm ready for it."
                        ],
                        "choices": []
                    }
                }
            ]
        },
        "failure_post_event": {
            "text": [
                "I'm so sorry .. I don't know what happened out there. The fans were silent and I couldn't handle it. I lost track of the match."
            ],
            "choices": [
                {
                    "text": [
                        "It's not your fault."
                    ],
                    "reply": {
                        "text": [
                            "I should have tried harder. I just froze. I'm sorry .. What are we going to do now? The fans .. they just ignored me."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "We'll figure something out."
                                ],
                                "reply": {
                                    "text": [
                                        "Okay .. "
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "You could have at least tried to make it work."
                    ],
                    "reply": {
                        "text": [
                            "I know .. I just froze. I couldn't focus and it just got worse and worse .. I'm sorry."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "I'll try to salvage what I can."
                                ],
                                "reply": {
                                    "text": [
                                        "Okay .. sorry, again."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "success_next_event": {
            "text": [
                "Hi."
            ],
            "choices": [
                {
                    "text": [
                        "How's it like being champion?"
                    ],
                    "reply": {
                        "text": [
                            "I never thought I'd be champion one day, but here I am. I'm just soaking in every moment of it."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "I'll see you later."
                    ],
                    "reply": {
                        "text": [
                            "Okay, see you."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_next_event": {
            "text": [
                "Hi."
            ],
            "choices": [
                {
                    "text": [
                        "How's it like being champion?"
                    ],
                    "reply": {
                        "text": [
                            "Not good. I'm sure you can tell. The fans don't like me, the women in the back make fun of me. Please end this as soon as you can. I just want to be out of the spotlight."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "I'll see you later."
                    ],
                    "reply": {
                        "text": [
                            "Okay."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_normal": {
            "text": [
                "Hi."
            ],
            "choices": [
                {
                    "text": [
                        "How're you doing?"
                    ],
                    "reply": {
                        "text": [
                            "Things are .. good. I kind of feel like I belong here. The women actually respect me."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "I'll see you later."
                    ],
                    "reply": {
                        "text": [
                            "Okay, see you."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_normal": {
            "text": [
                "Hi."
            ],
            "choices": [
                {
                    "text": [
                        "How're you doing?"
                    ],
                    "reply": {
                        "text": [
                            "I'm okay. Just trying to stay away from people as much as I can."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "I'll see you later."
                    ],
                    "reply": {
                        "text": [
                            "Okay."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Lady Julia": {
        "introduction": {
            "text": [
                "Hey! Hank tells me you're the new booker. It's nice to meet you."
            ],
            "choices": [
                {
                    "text": [
                        "Tell me about yourself Lady Julia."
                    ],
                    "reply": {
                        "text": [
                            "Well my name's Julia Duncan. I'm 25, an actress. Oh, and I'm a former gymnast! You should see the things I can do in the ring."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "Why did you join POW?"
                                ],
                                "reply": {
                                    "text": [
                                        "I was waiting on a TV host role but the production got delayed. The next day I saw an ad for this wrestling promotion in the paper and signed up. They saw my gymnastics background and I was hired!",
                                        "Now I'm here to get my name out and try to land a decent acting role. You're going to help turn me into a star, right?"
                                    ],
                                    "choices": [
                                        {
                                            "text": [
                                                "I'll do my best."
                                            ],
                                            "reply": {
                                                "text": [
                                                    "Once you see me work, you'll know I can be a star here. People want to see a young, talented woman become champion. And the sponsors want a pretty face to put on the covers."
                                                ],
                                                "choices": []
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "Okay, talk later."
                    ],
                    "reply": {
                        "text": [
                            "Buh-bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "confident": {
            "text": [
                "Hey!"
            ],
            "choices": [
                {
                    "text": [
                        "How would you like to be POW champion?"
                    ],
                    "reply": {
                        "text": [
                            "Are you kidding? Yes! Of course! I knew you'd see it. I'm so ready to be champion. The fans will love it and Hank needs a real star for the sponsors. You're making the right choice with me."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "What do you think of Hank?"
                    ],
                    "reply": {
                        "text": [
                            "Hank's .. well he's smart and he knows what he's doing. He was convinced I could be a star as soon as he saw me. I think he'll figure out a way to get us those sponsors."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Who do you think could be a star for POW?"
                    ],
                    "reply": {
                        "text": [
                            "Honestly, I mean there are a lot of talented women in the back, but to be a star, you need something else. You need real talent and charisma. And I don't think you'll find that anyone else has that star power but me."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "See you later."
                    ],
                    "reply": {
                        "text": [
                            "Buh-bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_post_event": {
            "text": [
                "That went so well .. it was tough, remembering all those spots, with the crowd all excited. I'm just gonna go to my room for a bit .. "
            ],
            "choices": [
                {
                    "text": [
                        "Okay. Are you alright?"
                    ],
                    "reply": {
                        "text": [
                            "Yes, yes, I'll be right out to join you guys .. "
                        ],
                        "choices": []
                    }
                }
            ]
        },
        "success_next_event": {
            "text": [
                "..."
            ],
            "choices": [
                {
                    "text": [
                        "Why did you leave right after your win?"
                    ],
                    "reply": {
                        "text": [
                            "I had some .. celebrating to do. I'm the champion now! Champion, champion, champion."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Are you high?"
                    ],
                    "reply": {
                        "text": [
                            "What? No .. I'm perfectly fine. I'm the champion, the staarrr of this show .. and I'm here. You need me?"
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Can you perform tonight?"
                    ],
                    "reply": {
                        "text": [
                            "Of course I can perform .. I can wrestle .. I can talk .. I'm Lady Juuulia. Just .. listen here. Put me in something easy okay? Just for tonight."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "I thought you were ready to be champion."
                    ],
                    "reply": {
                        "text": [
                            "I was. I am .. I just. I worked so hard on it, on being the best. Woman. Here. It's just a lot .. you know .. being champion. And all that."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "Isn't this what you wanted? So you could get your name out there?"
                                ],
                                "reply": {
                                    "text": [
                                        "Yeah. This is what I wanted. To be the wrestling champion of a show no one takes seriously! So I can try to get a half decent acting role .. so I don't have to keep regretting choosing a career that no one respects."
                                    ],
                                    "choices": [
                                        {
                                            "text": [
                                                "You are respected here."
                                            ],
                                            "reply": {
                                                "text": [
                                                    "Give me a break. Respected by who? Freaks in costumes? Just .. forget it."
                                                ],
                                                "choices": []
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "Okay, talk later."
                    ],
                    "reply": {
                        "text": [
                            "Byeee."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_normal": {
            "text": [
                "Hey."
            ],
            "choices": [
                {
                    "text": [
                        "How're you doing?"
                    ],
                    "reply": {
                        "text": [
                            "Better. Much better. I'm sorry for what I said when I was .. you know. That wasn't me. And I'm not on that stuff anymore.",
                            "Anyway, I've been training more, trying to get as good as I was in the ring before. I'm gonna stay here, work hard, and figure things out along the way."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Okay, talk later."
                    ],
                    "reply": {
                        "text": [
                            "Buh-bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Violet": {
        "introduction": {
            "text": [
                "Hello."
            ],
            "choices": [
                {
                    "text": [
                        "Tell me about yourself Violet."
                    ],
                    "reply": {
                        "text": [
                            "My name's Madie Hill, or as people know me, Violet. You may have seen me on TV if you were watching wrestling in the late 70's. I started out as a valet in Big Action Wrestling, and ended up being their champion after they introduced a women's title in '78."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "How long have you been wrestling?"
                                ],
                                "reply": {
                                    "text": [
                                        "Since I was 19. I started in a local promotion in Ohio until Big Bob signed me up for BAW in '75. And that lasted for five, no, six good years."
                                    ],
                                    "choices": [
                                        {
                                            "text": [
                                                "Why did you leave?"
                                            ],
                                            "reply": {
                                                "text": [
                                                    "My husband, Doug, and I decided it was time to start a family. I had to vacate the title, say goodbye to everyone and leave. Had my little Markie. He's 4 now. My husband brings him to the shows sometimes; you should meet him! He's such a sweetheart."
                                                ],
                                                "choices": [
                                                    {
                                                        "text": [
                                                            "You're back wrestling now?"
                                                        ],
                                                        "reply": {
                                                            "text": [
                                                                "Yes. I was a real star in Big Action Wrestling. I couldn't leave all that behind. Doug didn't think I could wrestle while being a mother; oh we had a lot of fights about that. But he came around."
                                                            ],
                                                            "choices": [
                                                                {
                                                                    "text": [
                                                                        "Why did you join POW?"
                                                                    ],
                                                                    "reply": {
                                                                        "text": [
                                                                            "I went to BAW first, but 5 years is a long time. The whole show had changed. The women's title was a joke. They wanted me as a valet. A valet! I was a good wrestler and the fans wanted to see me perform in the ring, not on the sidelines talking for some man.",
                                                                            "You know what it really was? They didn't think I could wrestle anymore, with the pregnancy and the long absence. And maybe they were right.",
                                                                            "But POW gave me a shot. Hank said he believed I could wrestle, and wrestle well, with the right training. So I trusted him and, well, here I am."
                                                                        ],
                                                                        "choices": []
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "Okay, see you later."
                    ],
                    "reply": {
                        "text": [
                            "Bye for now."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "normal": {
            "text": [
                "Hello."
            ],
            "choices": [
                {
                    "text": [
                        "How would you like to be POW champion?"
                    ],
                    "reply": {
                        "text": [
                            "Champion? That's a big ask. I've been here a few months and I've been working matches, but I still don't feel that comfortable in the ring.",
                            "After I had Markie, for four years I didn't train or wrestle or even work out. I'm 35 now. I'm not the Violet that used to put on clinics in the ring. Right now I just get in, do my job and get out."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "And you don't think you'll ever get back to that level?"
                                ],
                                "reply": {
                                    "text": [
                                        "I'm trying to. It sucks to be in the ring and know you could be doing so much better. I need more training, more matches."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "What do you think of Hank?"
                    ],
                    "reply": {
                        "text": [
                            "Hank's a good friend. I worked with him on a few shows before I joined BAW and I respect him. He hired me as a wrestler even though everyone else thought I was past my prime. He thinks I can go back to being the old me."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "How's it like, being a mother while being a wrestler?"
                    ],
                    "reply": {
                        "text": [
                            "I didn't think I could do it before, when Markie was little. I just didn't have the time. But now .. you know he tucks himself in at night? Like he doesn't want us to read him his stories. He just tells us goodnight, goes into bed and goes to sleep.",
                            "He's so grown up now. Doug takes care of him when I'm here and I go home as soon as I'm done. We're making it work."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "See you."
                    ],
                    "reply": {
                        "text": [
                            "Okay, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "confident": {
            "text": [
                "Hello."
            ],
            "choices": [
                {
                    "text": [
                        "How would you like to be POW champion?"
                    ],
                    "reply": {
                        "text": [
                            "You know, I'm feeling pretty good about myself. My performances have improved, training has been going well. Being champion is a huge weight on anyone's shoulders, but I've been there before. I know how it's done."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "What do you think of Hank?"
                    ],
                    "reply": {
                        "text": [
                            "Hank's a good friend. I worked with him on a few shows before I joined BAW and I respect him. He hired me as a wrestler even though everyone else thought I was past my prime. He thinks I can go back to being the old me."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "See you."
                    ],
                    "reply": {
                        "text": [
                            "Sure, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_post_event": {
            "text": [
                "That was a terrific match! I felt like myself in the ring. After so long, I felt like I could go. Oh, and seeing Markie in the crowd made it so much better when I won.",
                "I need to go see him and hug him! He must be driving my husband crazy after a match as long as that."
            ],
            "choices": [
                {
                    "text": [
                        "You did well. Markie and Doug will be proud of you."
                    ],
                    "reply": {
                        "text": [
                            "Oh I'm so glad they were there. Thank you for helping me with everything."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "You're a star now, so you won't be leaving early from shows, right?"
                    ],
                    "reply": {
                        "text": [
                            "Being champion means the company comes first, I know that. We'll get a nanny, or Doug can change his shifts. We'll have to figure something out."
                        ],
                        "choices": []
                    }
                }
            ]
        },
        "failure_post_event": {
            "text": [
                "I .. I don't know what happened there. I thought I could do it off the top rope, give the fans a big spot before the .. where's the doctor, is he here yet?"
            ],
            "choices": [
                {
                    "text": [
                        "Doctor's coming. Are you alright?"
                    ],
                    "reply": {
                        "text": [
                            "I think so .. my arms feel a bit weird, but I think I'm fine. I've done that move before. I thought I could do it again .."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "You're okay, you didn't suffer an injury."
                                ],
                                "reply": {
                                    "text": [
                                        "I was this close to landing on my neck. Just an inch or two and .. where's Markie? I saw him in the crowd .. Doug must be so scared. I need to go see them."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "success_next_event": {
            "text": [
                "Hello."
            ],
            "choices": [
                {
                    "text": [
                        "How's it like being champion?"
                    ],
                    "reply": {
                        "text": [
                            "It's stressful, but good stressful, you know? Doug got a shift change so I can be here longer. He knows how important being champion is to me."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Talk later."
                    ],
                    "reply": {
                        "text": [
                            "Sure, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_next_event": {
            "text": [
                "Hello."
            ],
            "choices": [
                {
                    "text": [
                        "Are you okay?"
                    ],
                    "reply": {
                        "text": [
                            "Yeah. I'm okay. I'm sorry I wasn't here after the show."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "You're not going to be full-time anymore?"
                                ],
                                "reply": {
                                    "text": [
                                        "I know I'm the champion, and the champion needs to be here every show .. I just realized, after that, that spot, that my body isn't what it used to be. I'm older now, I have a family. I have a baby boy .. what if I had landed on my neck? What would I do if I couldn't take Markie out for a walk .. "
                                    ],
                                    "choices": [
                                        {
                                            "text": [
                                                "It's okay. I get it."
                                            ],
                                            "reply": {
                                                "text": [
                                                    "I know nothing happened .. but .. you know Doug was crying that night. He cried asking me if I was okay. I thought a lot that night, about my career, about what I want. And I made my decision.",
                                                    "I'll still be here, but not every week, not every month. And I can't be who I was before. That was another woman, in another time."
                                                ],
                                                "choices": []
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "Talk later."
                    ],
                    "reply": {
                        "text": [
                            "Okay, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_normal": {
            "text": [
                "Hey."
            ],
            "choices": [
                {
                    "text": [
                        "How're you doing?"
                    ],
                    "reply": {
                        "text": [
                            "Oh, really good. I'm grateful for what you did for me. You made my comeback possible."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "How's Markie?"
                                ],
                                "reply": {
                                    "text": [
                                        "He's doing well. Doug can't bring him to the shows that often because he's so tired from his new shift. But I'll get to see him once we're done with the show. "
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "Talk later."
                    ],
                    "reply": {
                        "text": [
                            "Sure, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_normal": {
            "text": [
                "Hey."
            ],
            "choices": [
                {
                    "text": [
                        "How're you doing?"
                    ],
                    "reply": {
                        "text": [
                            "I'm good. Taking it easy in the ring. Spending more time at home. I think this is a better role for me, working when I can, helping the younger talent."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "How's Markie?"
                                ],
                                "reply": {
                                    "text": [
                                        "Oh he's splendid. Doug doesn't bring him to the shows anymore, after the incident. But I'm working real safe now, so maybe I'll ask Doug to bring him, just for one show. I'd like to see him cheering me on again."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "Talk later."
                    ],
                    "reply": {
                        "text": [
                            "Okay, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Zora": {
        "introduction": {
            "text": [
                "Yeah?"
            ],
            "choices": [
                {
                    "text": [
                        "Tell me about yourself Zora."
                    ],
                    "reply": {
                        "text": [
                            "What is this, some sort of interview? I'm one of the wrestlers here."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "I just wanted to know about you."
                                ],
                                "reply": {
                                    "text": [
                                        "Oh, you want to know about me. Okay, let's see. I was a rising star here in POW until the last show, where I was put in the spotlight. Hank thought it would be this great star making moment, but it failed.",
                                        "The match sucked, the story sucked, and the fans turned on me. So that's who I am right now. Someone the fans don't want to see."
                                    ],
                                    "choices": [
                                        {
                                            "text": [
                                                "Why was it so bad?"
                                            ],
                                            "reply": {
                                                "text": [
                                                    "Because the fans didn't want me! I gave it my best, but they didn't want me. Hank convinced me I was ready, and I stupidly went along with it even though I knew better."
                                                ],
                                                "choices": [
                                                    {
                                                        "text": [
                                                            "I'll try to turn the fans around."
                                                        ],
                                                        "reply": {
                                                            "text": [
                                                                "Yeah, good luck with that. They seem pretty much done with me."
                                                            ],
                                                            "choices": []
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "Okay, bye."
                    ],
                    "reply": {
                        "text": [
                            "Yeah, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "normal": {
            "text": [
                "Yeah?"
            ],
            "choices": [
                {
                    "text": [
                        "How would you like to be POW champion?"
                    ],
                    "reply": {
                        "text": [
                            "Champion? Don't you know how the fans treated me the last time I was in the spotlight? They haven't forgotten. No way, I'm not putting myself through that again."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "Even if I turned the fans around on you?"
                                ],
                                "reply": {
                                    "text": [
                                        "You must be crazy if you think you can do that. Listen, they don't want me, and I don't want to be champion like that."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "What do you think of Hank?"
                    ],
                    "reply": {
                        "text": [
                            "Hank is an idiot. He's a bad judge of the business, and I don't know if you're any better."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "You don't seem to like it here."
                    ],
                    "reply": {
                        "text": [
                            "No, I don't. But it's my job so I'll do what's needed. I had to go through a lot to get here and I'm not just gonna quit because of one night."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "See you later."
                    ],
                    "reply": {
                        "text": [
                            "Yeah, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "confident": {
            "text": [
                "Yeah?"
            ],
            "choices": [
                {
                    "text": [
                        "How would you like to be POW champion?"
                    ],
                    "reply": {
                        "text": [
                            "You sound exactly like Hank did. He was so confident I could be his star. And then I flopped."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "Things are different now. You're over with the fans."
                                ],
                                "reply": {
                                    "text": [
                                        "I might be, but that doesn't mean they'll accept me as champion. I can't take a reaction like that again."
                                    ],
                                    "choices": [
                                        {
                                            "text": [
                                                "It won't be like before."
                                            ],
                                            "reply": {
                                                "text": [
                                                    "Look, I know being champion would be a step up. I want to be the champion. I just don't believe you can pull it off. You'll have to come up with something really amazing if you want the fans to see me differently."
                                                ],
                                                "choices": []
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "What do you think of Hank?"
                    ],
                    "reply": {
                        "text": [
                            "Hank is an idiot. He's a bad judge of the business, and I don't know if you're any better."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "See you later."
                    ],
                    "reply": {
                        "text": [
                            "Yeah, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_post_event": {
            "text": [
                "That actually worked. They were on my side. I'm champion and they were on my side."
            ],
            "choices": [
                {
                    "text": [
                        "Good job, you did well."
                    ],
                    "reply": {
                        "text": [
                            "It wouldn't have worked without the right booking. I'll see you soon .. I need to take all this in."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "I told you it would work."
                    ],
                    "reply": {
                        "text": [
                            "You did a much better job than Hank, that's for sure. I'll see you soon .. I need to take all this in."
                        ],
                        "choices": []
                    }
                }
            ]
        },
        "failure_post_event": {
            "text": [
                "I told you it wouldn't work! The fans turned on me, just like before. You made me champion even though the fans wouldn't have it. Were you that desperate to make a star?!"
            ],
            "choices": [
                {
                    "text": [
                        "I'm sorry, I thought it would work."
                    ],
                    "reply": {
                        "text": [
                            "You were wrong. I don't know what we're going to do now. I can't be the champion like this."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Hank thought you could do it."
                    ],
                    "reply": {
                        "text": [
                            "I'm going to kill him when I see him. And I'm not going to be your champion."
                        ],
                        "choices": []
                    }
                }
            ]
        },
        "success_next_event": {
            "text": [
                "Yeah?"
            ],
            "choices": [
                {
                    "text": [
                        "How's it like being champion?"
                    ],
                    "reply": {
                        "text": [
                            "How do you think? It's unreal. The fans are behind me and I can't let them down. I need to stay on top of my game."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Talk to you later."
                    ],
                    "reply": {
                        "text": [
                            "Yeah, sure."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_next_event": {
            "text": [
                "Yeah?"
            ],
            "choices": [
                {
                    "text": [
                        "How's it like being champion?"
                    ],
                    "reply": {
                        "text": [
                            "What, you expect me to be grateful that I'm the champion? You need to take this title off me. I can't go out there every night and be rejected by the fans."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Talk to you later."
                    ],
                    "reply": {
                        "text": [
                            "Yeah, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "success_normal": {
            "text": [
                "Yeah?"
            ],
            "choices": [
                {
                    "text": [
                        "How're you doing?"
                    ],
                    "reply": {
                        "text": [
                            "Fine. Doing my job like always. Listen .. "
                        ],
                        "choices": [
                            {
                                "text": [
                                    "Yes?"
                                ],
                                "reply": {
                                    "text": [
                                        "Thank you, for making me believe I'm not a failure here .. yeah, just wanted to say that. Now get out, I've got to focus."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "Talk to you later."
                    ],
                    "reply": {
                        "text": [
                            "Yeah, sure."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "failure_normal": {
            "text": [
                "Yeah?"
            ],
            "choices": [
                {
                    "text": [
                        "How're you doing?"
                    ],
                    "reply": {
                        "text": [
                            "Still here, doing what I need to do. Trying to put my disasters behind me."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Talk to you later."
                    ],
                    "reply": {
                        "text": [
                            "Yeah, bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Hank Hughes": {
        "introduction": {
            "text": [
                "Hey. I'm Hank Hughes, the man in charge of Passion of Wrestling. You're gonna be helping me put the shows together.",
                "This is a small promotion trying to stand on its own feet. Our champion, Merry Martha, isn't really what you would call a draw. So I've come up with a plan to build up new stars, and once we do, put on a premier event for some sponsors so we can get them to sign with us.",
                "To turn someone into a star, you need to give them a good run and then make them the POW Champion. I have my eyes on four women for that role: Lady Julia, Violet, Natasha Ali and Zora. Get to know them and see who you want to focus on first.",
                "It's your first day, so go talk to the talent and plan for your first show."
            ],
            "choices": [
                {
                    "text": [
                        "Why did you join POW?"
                    ],
                    "reply": {
                        "text": [
                            "My previous project failed. It was an out-there TV pilot: Psychos in Space. Heard of it? Nah, didn't think so. Anyway, I was strapped for cash, and I got feelers for this wrestling show that needed a producer. The owners and I talked, and after some commitments and promises, I was on board.",
                            "That was, let's see, half a year ago. We couldn't get any sponsors, 'cause the show sucked thanks to the owners putting their idiotic ideas into it. So we sat down and negotiated, and I promised to stay if I got full creative control. Oh, and I got to hire you."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "Psychos in Space, what was that about?"
                                ],
                                "reply": {
                                    "text": [
                                        "I don't wanna talk about it, okay? POW, that's where I'm at now."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                },
                {
                    "text": [
                        "What makes POW unique?"
                    ],
                    "reply": {
                        "text": [
                            "We're the only women's wrestling show in the country! We've got ladies of all kinds here; we just need to showcase their talents."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Why those four women?"
                    ],
                    "reply": {
                        "text": [
                            "I have a plan, okay? I hired those women and I've worked with them. I know they can be our stars. Talk to them, work with them and you'll know too.",
                            "And whatever you do, don't put them in a position where they want to leave. I need them for the premier event."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "What's my role here?"
                    ],
                    "reply": {
                        "text": [
                            "You'll put the shows together. You know the wrestling business, so I'm hoping you can make stars out of these women."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Okay, see you."
                    ],
                    "reply": {
                        "text": [
                            "See you around."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "normal": {
            "text": [
                "Come on, let's get to booking."
            ],
            "choices": [
                {
                    "text": [
                        "What do you think of Lady Julia?"
                    ],
                    "reply": {
                        "text": [
                            "She's our star. She has the ability, the confidence and the charisma. And the sponsors; they're gonna love her. Don't mess her up."
                        ],
                        "choices": []
                    },
                    "person_name": "Lady Julia"
                },
                {
                    "text": [
                        "What do you think of Violet?"
                    ],
                    "reply": {
                        "text": [
                            "Violet? She's a known talent, was the champion in Big Action Wrestling. Scooped her up just as she was returning to the ring. She may not work as well as she used to, but she has what it takes. We're gonna give her the best training we can and get her back to the top where she belongs."
                        ],
                        "choices": []
                    },
                    "person_name": "Violet"
                },
                {
                    "text": [
                        "What do you think of Natasha?"
                    ],
                    "reply": {
                        "text": [
                            "She's a quiet girl. A little awkward. You wouldn't really think she could be a star, right? But when I saw her in tryouts, no one worked harder than her. She's got what it takes. I saw that when she stepped into the ring the first time. You just gotta make her believe it too."
                        ],
                        "choices": []
                    },
                    "person_name": "Natasha Ali"
                },
                {
                    "text": [
                        "What do you think of Zora?"
                    ],
                    "reply": {
                        "text": [
                            "Zora .. she could've been our star. I thought I had it all figured out with her, but things didn't go as planned. Anyway, she's in your hands now. She has the skills and the charisma; you just need to give her some good booking."
                        ],
                        "choices": []
                    },
                    "person_name": "Zora"
                },
                {
                    "text": [
                        "How do I turn someone into a star?"
                    ],
                    "reply": {
                        "text": [
                            "To become a star for the company, you need a good run that ends in winning the POW Championship, our company's flagship title. If the championship winning match goes well, it should thrust that talent into stardom in the eyes of the fans."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "What if someone else gets over?"
                    ],
                    "reply": {
                        "text": [
                            "They could get over, doesn't mean they're a star. These four have what it takes. They're what I need to get the sponsors on board. So put your focus on them."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Tell me more about this premier event."
                    ],
                    "reply": {
                        "text": [
                            "Okay, picture this. A concert hall, a ring on the stage, fans filled to the balconies. All red decor, spotlights, a dedicated camera crew. And our top stars in a showcase match, which I'm still working on, but a match that's gonna put them over big time with the sponsors."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Okay, see you later."
                    ],
                    "reply": {
                        "text": [
                            "Yeah, see you."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        },
        "natasha_ali_success": {
            "text": [
                "Natasha did it. She took her shot and looked like a total star. Good job building her up. The sponsors are gonna love an underdog."
            ],
            "choices": []
        },
        "natasha_ali_failure": {
            "text": [
                "You thought Natasha was ready to be the champion, not being a main eventer? She had to believe in herself and she didn't believe she could be a star. She went completely blank out there!",
                "We have to figure out what to do with her. We might have to give the championship to someone else because her popularity with the fans has nose-dived."
            ],
            "choices": []
        },
        "lady_julia_success": {
            "text": [
                "Lady Julia finally showed up today. High as a kite. What did you say to her?"
            ],
            "choices": [
                {
                    "text": [
                        "Nothing. She left right after her win."
                    ],
                    "reply": {
                        "text": [
                            "Damn. I thought she could do this. She seemed so confident about being champion. Look, we need to get her sobered up and figure out what to do. Go talk to her. And I don't think it would be the best idea to put her in a match right now."
                        ],
                        "choices": []
                    }
                }
            ]
        },
        "violet_success": {
            "text": [
                "Did you see Violet out there? It looked like a main event out of Big Action Wrestling! We're hitting the big leagues, and we got a star like Violet on our roster! The sponsors are going to love seeing her perform like this."
            ],
            "choices": []
        },
        "violet_failure": {
            "text": [
                "Who the hell okay-ed that top rope spot with Violet? Was that you? She looked like a total star until that happened! She wasn't in the ring conditioning to do a spot like that.",
                "She showed up today, still shaken up. Told me she can't work full-time anymore. That's our champion! Just .. go talk to her, okay?"
            ],
            "choices": []
        },
        "zora_success": {
            "text": [
                "Zora's a star! After I drove her straight into the trash, you managed to turn it around. I gotta admit, you're a much better booker than I was."
            ],
            "choices": []
        },
        "zora_failure": {
            "text": [
                "Zora must be pissed. Did you see how the fans treated her after she won? She had to be over with them to have any chance of becoming a star.",
                "Listen .. don't beat yourself up. I've been there too. Maybe she isn't meant to be our star. Just don't tell her you saw me come in today, okay?"
            ],
            "choices": [
                {
                    "text": [
                        "What do we do with her?"
                    ],
                    "reply": {
                        "text": [
                            "I guess we make the best out of her run as champion and move on."
                        ],
                        "choices": []
                    }
                }
            ]
        },
        "success_goals": {
            "text": [
                "You have a knack for making stars, you know? You've done well with all the women I talked to you about.",
                "I think we're ready for our premier event. I talked to the owners and they want it done at the next monthly event.",
                "I've come up with the perfect match for our stars and all of them have agreed to be in it. It's called Femme Fatale; an epic, story-driven match that's bound to interest the sponsors. I trust your judgement with the rest of the show, so book it as you want."
            ],
            "choices": []
        },
        "failure_goals": {
            "text": [
                "The owners are on my back to put on the premier event. I told them we don't have the star power, but they aren't listening.",
                "I have to hold it at the next monthly event. Sponsors from some big TV networks are going to be there and I have no idea what we're going to put on for them. My showcase match won't work without more stars.",
                "You'll have to put on the best show you can with the talent we have. I can't get humiliated out there."
            ],
            "choices": []
        },
        "success_pre_premier_event": {
            "text": [
                "We're finally here. The Femme Fatale match is going to steal the show! Not that your booking won't be great, it will be, but I've been working on this for weeks.",
                "Did you know that it incorporates some elements from my other TV pilot: Time Mechanics? .. okay, well, put on a good show. I'll see you out there."
            ],
            "choices": []
        },
        "failure_pre_premier_event": {
            "text": [
                "Well, this is it .. yeah, I'm nervous, okay? The sponsors are going to be here and the owners are expecting an excellent show.",
                "We really needed more stars for this. I hope the sponsors see something they like .. our future depends on it."
            ],
            "choices": []
        },
        "success_ending": {
            "text": [
                "The sponsors loved it! We managed to get three, yes, three sponsors to sign with us! POW's star power convinced them to pay big money up front, some of which the owners made available for the company.",
                "I've spoken with the owners, and since my deal with them was to get them some sponsors, well, this it for me. I've got big plans for another project, and I told them you were ready to take over the reins."
            ],
            "choices": [
                {
                    "text": [
                        "You're leaving?"
                    ],
                    "reply": {
                        "text": [
                            "Yeah, that was the deal. Don't worry, you can do this on your own. It's just time for me to move on. Never could stay on one project for long.",
                            "Oh, and a little parting gift for you. One of my great ideas, the Femme Fatale match, is yours to use. I believe in being generous with my creativity. Book it wherever you go, just make sure you give me credit."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "What are you going to do now?"
                                ],
                                "reply": {
                                    "text": [
                                        "Another TV pilot: Monsters on the Moon. It's been in the back of my head for years. I talked to some people who are interested in sponsoring production. If everything goes well, you'll be seeing it on your television next summer! I'm gonna go say goodbye to the women."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "failure_ending": {
            "text": [
                "It didn't work. The sponsors didn't sign. The owners called me in afterwards .. and, well .. that was the last straw for them. They're shutting the production down."
            ],
            "choices": [
                {
                    "text": [
                        "That's it?"
                    ],
                    "reply": {
                        "text": [
                            "Yeah, that's it. I asked them for some more time, but they didn't budge. No sponsors, despite all this effort, means no interest from them to keep this afloat any longer. It's time to move on, for all of us."
                        ],
                        "choices": [
                            {
                                "text": [
                                    "What now?"
                                ],
                                "reply": {
                                    "text": [
                                        "Go home. You don't wanna be the one to tell everyone in the back that they're out of a job. I'll go talk to them."
                                    ],
                                    "choices": []
                                }
                            }
                        ]
                    }
                }
            ]
        },
        "information": {
            "name": "Hank Hughes",
            "producer": true,
            "graphic": {
                "accessory": {
                    "object": 31,
                    "colors": [
                        "0xD09F15"
                    ]
                },
                "accessory2": {
                    "object": -1,
                    "colors": [
                        "0xEFEFEF"
                    ]
                },
                "accessory3": {
                    "object": -1,
                    "colors": null
                },
                "body": {
                    "object": 0,
                    "colors": [
                        "0xFFD9B6"
                    ]
                },
                "bottoms": {
                    "object": 0,
                    "colors": [
                        "0x6a87a4"
                    ]
                },
                "elbow": {
                    "object": -1,
                    "colors": null
                },
                "eyes": {
                    "object": 0,
                    "colors": [
                        "0x000000"
                    ]
                },
                "facepaint": {
                    "object": -1,
                    "colors": null
                },
                "facialHair": {
                    "object": 15,
                    "colors": [
                        "0xcccbcb"
                    ]
                },
                "hair": {
                    "object": 32,
                    "colors": [
                        "0xdbdbdb"
                    ]
                },
                "knee": {
                    "object": -1,
                    "colors": null
                },
                "shoes": {
                    "object": 1,
                    "colors": [
                        "0x242424",
                        "0x242424"
                    ]
                },
                "tattoo": {
                    "object": 2,
                    "colors": [
                        "0x31661A"
                    ]
                },
                "torso": {
                    "object": 48,
                    "colors": [
                        "0xd1d1d1",
                        "0xcecece"
                    ]
                },
                "alternate_attires": []
            }
        }
    },
    "Scarlet": {
        "normal": {
            "text": [
                "What?"
            ],
            "choices": [
                {
                    "text": [
                        "Who do you think could be a star for us?"
                    ],
                    "reply": {
                        "text": [
                            "Well it won't be me. Have you seen this face? I'm not gonna be on the cover of any posters or tapes."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "See you."
                    ],
                    "reply": {
                        "text": [
                            "Yeah."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Joan of Narcs": {
        "normal": {
            "text": [
                "Need something?"
            ],
            "choices": [
                {
                    "text": [
                        "Who do you think could be a star for us?"
                    ],
                    "reply": {
                        "text": [
                            "Anyone but Lady Julia. She walks around here like she's the top star, but there are a lot more deserving ladies here."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Gotta go."
                    ],
                    "reply": {
                        "text": [
                            "Bye."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Fortuna": {
        "normal": {
            "text": [
                "Hey there."
            ],
            "choices": [
                {
                    "text": [
                        "Who do you think could be a star for us?"
                    ],
                    "reply": {
                        "text": [
                            "Violet, definitely. So what if she had a baby? Women can do amazing things after childbirth. She's legit."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Bye for now."
                    ],
                    "reply": {
                        "text": [
                            "See ya."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Lora the Lioness": {
        "normal": {
            "text": [
                "Yo."
            ],
            "choices": [
                {
                    "text": [
                        "Who do you think could be a star for us?"
                    ],
                    "reply": {
                        "text": [
                            "Oh, Natasha. She's my homegirl, we came here together, and I know she has what it takes to be a star."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Later."
                    ],
                    "reply": {
                        "text": [
                            "Bye!"
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    },
    "Merry Martha": {
        "normal": {
            "text": [
                "Hi there."
            ],
            "choices": [
                {
                    "text": [
                        "Who do you think could be a star for us?"
                    ],
                    "reply": {
                        "text": [
                            "Star? We already have a star in me. We packed the farmer's market with my title match! Oh it was such a thrill."
                        ],
                        "choices": []
                    }
                },
                {
                    "text": [
                        "Goodbye."
                    ],
                    "reply": {
                        "text": [
                            "Bye dear."
                        ],
                        "choices": [],
                        "end_conversation": true
                    }
                }
            ]
        }
    }
};

});

parcelRequire.register("7UN4J", function(module, exports) {

$parcel$export(module.exports, "StoryChoice", () => $5c33d4b014059d30$export$4f92b53e327291cf);

var $14eBR = parcelRequire("14eBR");
function $5c33d4b014059d30$export$4f92b53e327291cf() {
    // Integer
    const year = null;
    const monthCount = null;
    // String
    const choice = null;
    const information = null;
    // Foreign keys
    const companyId = null;
    return {
        year: year,
        monthCount: monthCount,
        choice: choice,
        information: information,
        companyId: companyId
    };
}
function $5c33d4b014059d30$export$1b68fbe14c55ac7b(storyChoice) {
    return (0, $14eBR.Companies).find({
        "$loki": storyChoice.companyId
    })[0];
}

});



parcelRequire.register("dGbip", function(module, exports) {

$parcel$export(module.exports, "endEvent", () => $9f57f5c1301b7dbc$export$a0e9a46916fac130);

var $98xmD = parcelRequire("98xmD");

var $iRMwH = parcelRequire("iRMwH");

var $9esFv = parcelRequire("9esFv");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $5ZsVo = parcelRequire("5ZsVo");

var $3E8Nt = parcelRequire("3E8Nt");

var $5kTkA = parcelRequire("5kTkA");

var $i7bmn = parcelRequire("i7bmn");

var $iQtzn = parcelRequire("iQtzn");

var $hekDR = parcelRequire("hekDR");

var $jDtEn = parcelRequire("jDtEn");

var $cXLSF = parcelRequire("cXLSF");

var $1Dp0h = parcelRequire("1Dp0h");

var $6PzHO = parcelRequire("6PzHO");

var $1olyO = parcelRequire("1olyO");

var $ko5kE = parcelRequire("ko5kE");

var $kZwpB = parcelRequire("kZwpB");

var $3SyPM = parcelRequire("3SyPM");

var $kZMqI = parcelRequire("kZMqI");

var $4ptHI = parcelRequire("4ptHI");

var $hBIDz = parcelRequire("hBIDz");

var $1JSre = parcelRequire("1JSre");

var $972Ip = parcelRequire("972Ip");

var $jpMCP = parcelRequire("jpMCP");

var $14eBR = parcelRequire("14eBR");

var $ivuOU = parcelRequire("ivuOU");

var $1AAHK = parcelRequire("1AAHK");

var $im36F = parcelRequire("im36F");

var $csISS = parcelRequire("csISS");

var $dBFC4 = parcelRequire("dBFC4");

var $9MKdC = parcelRequire("9MKdC");

var $3NAMH = parcelRequire("3NAMH");

var $8ugbL = parcelRequire("8ugbL");

var $18vSN = parcelRequire("18vSN");

var $lueZ1 = parcelRequire("lueZ1");

var $8bQDO = parcelRequire("8bQDO");

var $aP7lq = parcelRequire("aP7lq");

var $bZol7 = parcelRequire("bZol7");

var $2A9WA = parcelRequire("2A9WA");

var $jC7EP = parcelRequire("jC7EP");
async function $9f57f5c1301b7dbc$export$a0e9a46916fac130(company, user, simulation = false, rosterSuperstars = null, userSimulatorOption = "manage", eventsToSimulate = null) {
    // Declare variables
    const data = {
        leftCompany: [],
        vacated: [],
        tradeReturns: [],
        notUsedAtEvent: [],
        hotChanges: [],
        staleChanges: [],
        staffSkillIncreases: [],
        rehabbed: [],
        staffActionsCompleted: [],
        unlockedCharacters: [],
        availableSuperstars: [],
        signings: [],
        offersAccepted: [],
        moraleChanges: [],
        notUsedMoraleDecreases: [],
        factionReputationsData: [],
        notUsedPopularityDecreases: [],
        fotcChanges: [],
        matchContractsNotUsed: []
    };
    // Get objects
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(company);
    let staffMembers = await (0, $9esFv.getCompanyStaff)(company);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
    const indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
    const trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "training");
    const trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "trainingAvailable");
    const parentEvent = await (0, $5ZsVo.getParentEventForEvent)(parentEvents, latestEvent);
    const indieSuperstars = await (0, $dl5u4.getRosterSuperstars)(indieRoster);
    const indieAvailableSuperstars = await (0, $dl5u4.getRosterSuperstars)(indieAvailableRoster);
    const allTrainingSuperstars = (await (0, $dl5u4.getRosterSuperstars)(trainingRoster)).concat(await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster));
    const scoutingFacility = (await (0, $9esFv.getCompanyFacilities)(company)).find((facility)=>facility.name === "Scouting");
    const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "talent_manager");
    const weeklyShow = latestEvent.weeklyShow || latestEvent.name === "Weekly Show" || latestEvent.temporaryEvent;
    const companySegmentItems = await (0, $9esFv.getCompanySegmentItems)(company);
    const eventMatchesAndSegments = (await (0, $5ZsVo.getEventMatchesAndSegments)(latestEvent)).reverse();
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const isMainCompany = mainCompany.$loki === company.$loki;
    const month = game.monthCount;
    const year = game.year;
    const companyMonth = (0, $8A6FL.getCompanyMonth)(company, game);
    const companyYear = (0, $8A6FL.getCompanyYear)(company, game);
    const startingFans = company.fans;
    if (!rosterSuperstars) rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const superstarsUsedAtEvent = await (0, $5ZsVo.getSuperstarsUsedAtEvent)(eventMatchesAndSegments, rosterSuperstars);
    // Check for annual tournament todo test and test usages
    const annualTournament = (await (0, $9esFv.getCompanyTournaments)(mainCompany)).find((x)=>x.annualTournament && x.status !== "ended");
    const annualTournamentRunning = annualTournament && annualTournament.status === "running"; // True for night 1 & 2
    // Lower prestige of championships not defended recently
    if ((0, $98xmD.globalUser).paid) {
        if (!weeklyShow) {
            const championshipsNotUsedRecently = [];
            const xpChange = -5;
            const uniqueChampionships = (0, $kZwpB.getUniqueChampionships)(companyChampionships.filter((x)=>!x.championshipContract && !x.matchContract && (0, $5kTkA.checkObjectBrandAvailability)(x, latestEvent.brandName, false, latestEvent.activeEffect)));
            for (const championship of uniqueChampionships){
                // Get months passed since last used
                const monthsPassed = await $9f57f5c1301b7dbc$var$getMonthsPassedSinceChampionshipMatch(championship, companyChampionships, company, month, year, companyMonth, companyYear);
                // Lower xp if more than 6 months passed
                if (monthsPassed > 6) {
                    await (0, $8A6FL.processChampionshipXpChange)(championship, xpChange, companyChampionships);
                    championshipsNotUsedRecently.push(championship);
                }
                // Message if 6 months passed
                if (company.userControlled && monthsPassed === 6) {
                    // Add message
                    const newMessage = await (0, $hekDR.createChampionshipNotUsedPenaltyMessage)(championship, month, year, talentManager);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
            // Add to return data
            if (championshipsNotUsedRecently.length > 0) {
                data["championshipsNotUsedRecently"] = (0, $1JSre.getChampionshipsDisplayName)(championshipsNotUsedRecently);
                data["championshipNotUsedXpChange"] = xpChange;
            }
        }
    }
    // Get rating
    let rating = (0, $5ZsVo.calculateEventRating)(eventMatchesAndSegments);
    // Ensure rating active effects work
    // Add buffer for first year since ratings are lower
    let high, low;
    if (game.year === 0) {
        high = 3.75;
        low = 3.25;
    } else {
        high = 4;
        low = 3.25;
    }
    if (latestEvent.activeEffect === "lower_match_ratings") {
        if (rating >= low) rating = low - 0.25;
    } else if (latestEvent.activeEffect === "raise_match_ratings") {
        if (rating <= high) rating = high + 0.5;
    }
    // Add points
    let pointsToAdd = $9f57f5c1301b7dbc$var$getPointsToAdd(rating, weeklyShow);
    if (annualTournamentRunning) pointsToAdd = 0;
    if (pointsToAdd) company.points += pointsToAdd;
    // Add fans
    let [fansToAdd, hypeMultiplier] = $9f57f5c1301b7dbc$var$getFansToAdd(rating, company.reputation, latestEvent.hype, weeklyShow);
    if (annualTournamentRunning) fansToAdd = 0;
    if (fansToAdd && game.marketSize === null) company.fans += fansToAdd;
    // Add current month
    const eventNames = parentEvents.map((x)=>x.name);
    if (latestEvent.monthlyEventName && eventNames.includes(latestEvent.monthlyEventName)) {
        latestEvent.month = eventNames.indexOf(latestEvent.monthlyEventName);
        if (latestEvent.weekNumber < 0) {
            latestEvent.month -= 1;
            if (latestEvent.month < 0) latestEvent.month = 11;
        }
    } else {
        const companyEvents = await (0, $9esFv.getCompanyEvents)(company);
        const latestMonthlyEvent = (0, $5ZsVo.getLatestMonthlyEvent)(companyEvents);
        if (!eventNames.includes(latestMonthlyEvent.name)) // If event name changed, use parent event name
        latestEvent.month = eventNames.indexOf((await (0, $iQtzn.getParentEvent)(latestMonthlyEvent))?.name);
        else latestEvent.month = eventNames.indexOf(latestMonthlyEvent.name);
    }
    // Add data to event
    latestEvent.rating = rating;
    latestEvent.pointsEarned = pointsToAdd;
    if (latestEvent.year === null) latestEvent.year = company.realYear; // For compatibility with older games
    if (game.marketSize === null) latestEvent.fansGained = fansToAdd;
    // Change company overness
    if (!annualTournamentRunning) {
        const startingOverness = company.overness;
        const overnessChange = $9f57f5c1301b7dbc$var$getCompanyOvernessChange(rating, company);
        (0, $8A6FL.updateObjectOverness)(company, overnessChange);
        (0, $8A6FL.checkObjectHot)(company, overnessChange);
        const staleCheck = (0, $8A6FL.checkObjectStale)(company, overnessChange);
        // Add overness change data
        const startingOvernessText = (0, $3E8Nt.getOvernessText)(startingOverness, false);
        const endingOvernessText = (0, $3E8Nt.getOvernessText)(company.overness, false);
        if (endingOvernessText !== startingOvernessText) data["companyOvernessChange"] = {
            name: company.name,
            previousOverness: startingOvernessText,
            currentOverness: endingOvernessText,
            overness: company.overness,
            increase: company.overness > startingOverness
        };
        // Add news if company got stale
        if (staleCheck === "stale") {
            let newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: game.newsMonth,
                year: game.newsYear,
                newsType: "stale_company"
            });
            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                newsItem
            ]);
        }
        // Change brand overness
        const eventBrand = (0, $1Dp0h.getBrandForEvent)(latestEvent, rosterBrands);
        if (eventBrand) {
            const startingOverness = eventBrand.overness;
            const brandOvernessChange = $9f57f5c1301b7dbc$var$getBrandOvernessChange(rating, eventBrand);
            (0, $8A6FL.updateObjectOverness)(eventBrand, brandOvernessChange);
            (0, $8A6FL.checkObjectHot)(eventBrand, brandOvernessChange);
            (0, $8A6FL.checkObjectStale)(eventBrand, brandOvernessChange);
            // Add overness change data
            const startingOvernessText = (0, $3E8Nt.getOvernessText)(startingOverness, false);
            const endingOvernessText = (0, $3E8Nt.getOvernessText)(eventBrand.overness, false);
            if (endingOvernessText !== startingOvernessText) data["brandOvernessChange"] = {
                name: eventBrand.name,
                color: eventBrand.color,
                previousOverness: startingOvernessText,
                currentOverness: endingOvernessText,
                overness: eventBrand.overness,
                increase: eventBrand.overness > startingOverness
            };
        }
    }
    // Mars story events todo later
    // Check if new year started
    let newYearStarted = false;
    if (!weeklyShow && game.newsMonth + 1 > 11) newYearStarted = true;
    // Update month, year and yearly checks for user company
    if (!weeklyShow) {
        if (company.userControlled) {
            // In multiplayer, increases game's month, resets later in this function. Fixes month and year for messages, random events, etc
            game.monthCount += 1;
            if (game.monthCount > 11) {
                game.monthCount = 0;
                game.year += 1;
                if (!company.newUserCompany) {
                    company.yearlyCheckRun = false;
                    company.yearlyReviewRun = false;
                }
            }
        }
        // New user company's month is separate as it can be out of sync with game, is used for callup etc
        if (company.newUserCompany) {
            company.month += 1;
            if (company.month > 11) {
                company.month = 0;
                company.year += 1;
                company.yearlyCheckRun = false;
                company.yearlyReviewRun = false;
            }
        }
    }
    // Check for reputation increase or decrease
    const fanLevels = [
        0,
        500,
        1100,
        2300,
        5000,
        10500,
        22000,
        47000,
        99000,
        212000,
        451000,
        1000000
    ];
    let fansToNextReputation = fanLevels[company.reputation];
    let fansToPreviousReputation = fanLevels[company.reputation - 1];
    let reputationIncrease = false;
    let reputationDecrease = false;
    if (!annualTournamentRunning) {
        if (game.marketSize === null) {
            // Reputation increase
            if (company.fans >= fansToNextReputation && company.reputation < 10) {
                company.reputation += 1;
                reputationIncrease = true;
                // Reset fan levels
                fansToNextReputation = fanLevels[company.reputation];
                fansToPreviousReputation = fanLevels[company.reputation - 1];
                // Show benefits of reputation increase only once, using highestReputation to check
                if (company.reputation > company.highestReputation) {
                    company.highestReputation = company.reputation;
                    isMainCompany && company.storyName;
                }
                data["rosterSize"] = (0, $8A6FL.getCompanyRosterCapacity)(company, game);
            // Reputation decrease
            } else if (company.fans < fansToPreviousReputation && company.reputation > 1) {
                company.reputation -= 1;
                reputationDecrease = true;
                // Reset fan levels
                fansToNextReputation = fanLevels[company.reputation];
                fansToPreviousReputation = fanLevels[company.reputation - 1];
                data["rosterSize"] = (0, $8A6FL.getCompanyRosterCapacity)(company, game);
            }
        }
    }
    // Get next event if not tournament weekly show
    let nextEvent;
    if (latestEvent.name === "Weekly Show" || latestEvent.temporaryEvent) await (0, $9esFv.removeCompanyEvents)(company, [
        latestEvent
    ]);
    else {
        nextEvent = await (0, $5ZsVo.getNextEvent)(latestEvent, parentEvents, company, game.numberOfWeeklyShows);
        await (0, $9esFv.addCompanyEvents)(company, [
            nextEvent
        ]);
    }
    // Update event prestige if paid version
    let eventPrestigeData = null;
    if (!weeklyShow && (0, $98xmD.globalUser).paid) {
        // Update event's xp
        let xpChange;
        if (latestEvent.rating < 3.5) xpChange = (4 - latestEvent.rating) * -10;
        else if (latestEvent.rating < 5) xpChange = (3 - latestEvent.rating) * -15;
        else xpChange = (2.5 - latestEvent.rating) * -15;
        xpChange = Math.floor(xpChange);
        parentEvent.xp += xpChange;
        // Update event's prestige
        let prestigeIncrease = false;
        let prestigeDecrease = false;
        if (parentEvent.xp >= 110 && parentEvent.prestige !== "A") {
            parentEvent.prestige = "A";
            prestigeIncrease = true;
        } else if (40 <= parentEvent.xp && parentEvent.xp < 110 && parentEvent.prestige !== "B") {
            if (parentEvent.prestige === "A") prestigeDecrease = true;
            else prestigeIncrease = true;
            parentEvent.prestige = "B";
        } else if (parentEvent.xp < 40 && parentEvent.prestige !== "C") {
            parentEvent.prestige = "C";
            prestigeDecrease = true;
        }
        // Add prestige data
        const prestige = parentEvent.prestige;
        const prestigeMaximums = {
            "A": 10,
            "B": 9,
            "C": 8
        };
        eventPrestigeData = {
            name: latestEvent.name,
            prestige: prestige,
            xp: parentEvent.xp,
            xpChange: xpChange,
            baseXp: (0, $3E8Nt.eventPrestigeXps)[prestige],
            xpToNextPrestige: prestige === "C" ? 40 : 110,
            prestigeIncrease: prestigeIncrease,
            prestigeDecrease: prestigeDecrease,
            matchLimit: prestigeMaximums[prestige] || 8
        };
    }
    // Monthly checks
    if (!weeklyShow) {
        // Check for training callup
        if (companyMonth === 11 || companyMonth === 5) {
            company.trainingTransferRun = false;
            company.trainingCallupRun = false;
        }
        if (isMainCompany) {
            // Check for awards
            if (month === 9) game.awardsRun = false;
            // Check for yearly rankings in January
            if (latestEvent.month === 11) game.yearlyAttributesResetRan = false;
        }
    }
    if (isMainCompany) // Reset monthly simulation
    game.monthlySimulationRun = false;
    // Decrease overness and morale for active superstars not used
    if (!weeklyShow) {
        for (const s of rosterSuperstars)if (!(0, $3E8Nt.objectInArray)(s, superstarsUsedAtEvent) && s.injured <= 0 && s.suspensionMonths <= 0 && !s.partTimer && !s.retired && !s.dead && !s.unavailable && !s.fullTimeManager && (0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, s)) {
            const startingOverness = s.overness;
            const overnessDecrease = (0, $3E8Nt.getRandomInt)(0, 1);
            s.overness -= overnessDecrease;
            const overnessChange = s.overness - startingOverness;
            // Make sure overness is percentage between 0 and 100
            s.overness = (0, $3E8Nt.limitValueBetweenRange)(s.overness, 0, 100);
            // Add overness change data
            const startingOvernessText = (0, $3E8Nt.getOvernessText)(startingOverness);
            const endingOvernessText = (0, $3E8Nt.getOvernessText)(s.overness);
            if (endingOvernessText !== startingOvernessText) data["notUsedAtEvent"].push({
                name: s.name,
                previousOverness: startingOvernessText,
                currentOverness: endingOvernessText,
                overness: s.overness,
                increase: s.overness > startingOverness
            });
            // Check hot
            const hotCheck = (0, $8A6FL.checkObjectHot)(s, overnessChange);
            if (hotCheck) {
                data["hotChanges"].push({
                    name: s.name,
                    pronoun: s.possessivePronoun,
                    status: hotCheck
                });
                // Check for character unlock upon hot
                if ((0, $98xmD.globalUser).paid && hotCheck === "hot") {
                    const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(s);
                    if (superstarGimmick) {
                        if (superstarGimmick.character) {
                            const unlockedCharacter = (0, $3SyPM.checkCharacterToUnlock)(superstarGimmick.character);
                            if (unlockedCharacter) data["unlockedCharacters"].push({
                                name: unlockedCharacter,
                                originalCharacter: superstarGimmick.character
                            });
                        }
                    }
                }
                if (hotCheck === "hot") {
                    // Add news
                    let newsItem = await (0, $kZMqI.generateNewsItem)({
                        company: company,
                        month: game.newsMonth,
                        year: game.newsYear,
                        superstar: s,
                        newsType: "over_superstar"
                    });
                    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                        newsItem
                    ]);
                    // Check goal
                    if (company.userControlled) {
                        let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                            name: "get over",
                            change: 1,
                            company: company,
                            superstarName: s.name
                        });
                        if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                    }
                }
            }
            // Check stale
            let staleCheck = (0, $8A6FL.checkObjectStale)(s, overnessChange);
            if (staleCheck) {
                data["staleChanges"].push({
                    name: s.name,
                    pronoun: s.possessivePronoun,
                    status: staleCheck
                });
                if (staleCheck === "stale") {
                    // Add news
                    let newsItem = await (0, $kZMqI.generateNewsItem)({
                        company: company,
                        month: game.newsMonth,
                        year: game.newsYear,
                        superstar: s,
                        newsType: "stale_superstar"
                    });
                    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                        newsItem
                    ]);
                    // Update faction rep (overness change)
                    const superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                        superstar: s,
                        overnessChange: "stale"
                    });
                    data["factionReputationsData"].push(...superstarFactionsData);
                }
            }
            // Decrease morale for main eventers if not high fatigue
            if ((0, $5kTkA.getRankFromPopularity)(s.popularity) === "Main Eventer" && s.fatigue < 50) {
                let moraleDecrease = 2;
                (0, $5kTkA.updateSuperstarMorale)(s, moraleDecrease * -1);
                data["notUsedMoraleDecreases"].push({
                    name: s.name,
                    decrease: moraleDecrease
                });
                let startingMorale = s.morale + moraleDecrease;
                let startingMoraleText = (0, $3E8Nt.getMoraleText)(startingMorale);
                let endingMoraleText = (0, $3E8Nt.getMoraleText)(s.morale);
                if (endingMoraleText !== startingMoraleText) data["moraleChanges"].push({
                    name: s.name,
                    previousMorale: startingMoraleText,
                    currentMorale: endingMoraleText,
                    morale: s.morale
                });
            }
        }
        // Decrease popularity for active main eventers not used at event
        for (const s of rosterSuperstars)if (!(0, $3E8Nt.objectInArray)(s, superstarsUsedAtEvent) && (0, $5kTkA.getRankFromPopularity)(s.popularity) === "Main Eventer" && (0, $5kTkA.checkAvailability)(s, false, false, false) && (0, $5kTkA.checkSuperstarBrandAvailability)(latestEvent, s)) {
            // Get popularity decrease
            let popularityDecrease = $9f57f5c1301b7dbc$var$getNotUsedPopularityDecrease(s);
            s.popularity -= popularityDecrease;
            data["notUsedPopularityDecreases"].push({
                "name": s.name,
                "decrease": popularityDecrease
            });
            // Remove FotC
            if (s.faceOfTheCompany && s.popularity < 1000) {
                s.faceOfTheCompany = false;
                s.faceOfTheCompanyCounter = 0;
                data["fotcChanges"].push({
                    name: s.name,
                    faceOfTheCompany: s.faceOfTheCompany
                });
                // Update faction rep (fotc)
                const superstarFactionsData = await (0, $6PzHO.processFactionXpChangeForSuperstar)({
                    superstar: s,
                    fotcChange: "lostFotc"
                });
                data["factionReputationsData"].push(...superstarFactionsData);
            }
        }
        // Check talent request
        for (const s of superstarsUsedAtEvent)await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "be_on_monthly_event",
            talent: s
        });
    }
    // Manage contracts
    if (!weeklyShow) {
        let leftCompanySuperstars = [];
        for (const superstar of rosterSuperstars)if (superstar.activeEffect !== "traded") {
            const leftCompany = await (0, $5kTkA.processSuperstarContract)(superstar, company, game);
            if (leftCompany) {
                leftCompanySuperstars.push(superstar);
                data["leftCompany"].push(superstar.name);
            }
        }
        // Update rosterSuperstars
        rosterSuperstars = rosterSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, leftCompanySuperstars));
    }
    if (!weeklyShow) {
        let superstarsReturned = [];
        if (!(company.userControlled && game.settings["control_multiple_companies"])) {
            // Move/remove teams if trade ending
            const onTradeSuperstars = rosterSuperstars.filter((x)=>x.activeEffect === "traded");
            for (const superstar of onTradeSuperstars){
                if (superstar.appearances === 1) for (const tagTeam of [
                    ...await (0, $hBIDz.getSuperstarTagTeams)(superstar)
                ]){
                    let ts = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                    // Move team if all members were on trade together
                    if (ts.every((s)=>(0, $3E8Nt.objectInArray)(s, onTradeSuperstars) && s.appearances === 1)) await (0, $dl5u4.addRosterTagTeams)(await (0, $hBIDz.getSuperstarOriginalRoster)(superstar), [
                        tagTeam
                    ]);
                    else await (0, $ko5kE.removeTagTeam)(tagTeam);
                }
            }
            // Process superstars on trade
            for (const superstar of onTradeSuperstars){
                superstar.appearances -= 1;
                if (superstar.appearances <= 0) {
                    const originalRoster = await (0, $hBIDz.getSuperstarOriginalRoster)(superstar);
                    if (originalRoster) {
                        await (0, $dl5u4.addRosterSuperstars)(originalRoster, [
                            superstar
                        ]);
                        superstarsReturned.push(superstar);
                        const vacatedChampionships = await (0, $5kTkA.vacateChampionships)({
                            superstar: superstar,
                            championships: companyChampionships,
                            month: month,
                            year: year
                        });
                        if (vacatedChampionships.length > 0) data["vacated"].push(...vacatedChampionships);
                        // Remove from factions/managers
                        await (0, $5kTkA.removeSuperstarFactionRelationships)(superstar, month, year);
                        await (0, $5kTkA.removeSuperstarManagerRelationships)(superstar);
                        // Reset other attributes
                        superstar.brandName = null;
                        superstar.activeEffect = null;
                        if (!superstar.partTimer) superstar.appearances = null;
                        data["tradeReturns"].push(superstar.name);
                    }
                }
            }
        }
        // Update rosterSuperstars
        rosterSuperstars = rosterSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, superstarsReturned));
        // Add alignment months
        for (const superstar of rosterSuperstars)if (!superstar.retired) superstar.alignmentMonths += 1;
        // Update injured superstars
        let doctors = (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "doctor");
        let injuredData = await $9f57f5c1301b7dbc$var$updateInjured(rosterSuperstars, doctors, company);
        data["staffSkillIncreases"].push(...injuredData["staffSkillIncreases"]);
        data["rehabbed"] = injuredData["rehabbed"];
        for (const availableData of injuredData["available"]){
            let s = availableData["superstar"];
            // Add news if not recovering from superstarBreak random event
            let superstarBreakRandomEvent = (await (0, $hBIDz.getSuperstarRandomEvents)(s)).reverse().find((x)=>x.name === "superstarBreak");
            if (!superstarBreakRandomEvent) {
                let newsType = availableData["workableInjury"] ? "workable_injury_return" : "injury_return";
                let newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: game.newsMonth,
                    year: game.newsYear,
                    superstar: s,
                    newsType: newsType
                });
                await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                    newsItem
                ]);
            } else // Remove superstarBreak random event for future injuries to show
            await (0, $hBIDz.removeSuperstarRandomEvents)(s, [
                superstarBreakRandomEvent
            ]);
            // Increase overness if not superstar break or workable injury
            let overnessIncrease = null;
            if (!superstarBreakRandomEvent && !availableData["workableInjury"]) {
                overnessIncrease = (0, $3E8Nt.getRandomInt)(4, 6);
                s.overness += overnessIncrease;
                const addedNextGimmickBoost = await (0, $5kTkA.addNextGimmickBoost)(s, 50);
                if (addedNextGimmickBoost && company.userControlled) {
                    let newMessage = await (0, $hekDR.createGimmickChangeBoostMessage)(s, "Injury Return", month, year, talentManager);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
            data["availableSuperstars"].push({
                name: s.name
            });
            if (company.userControlled) {
                let doctor = null;
                let assignedDoctor = (0, $8ugbL.getTalentRehabDoctor)(s, doctors);
                if (assignedDoctor) doctor = assignedDoctor;
                else if (doctors.length) doctor = (0, $8A6FL.getRandomStaffMemberByRole)(doctors, "doctor");
                let newMessage;
                if (availableData["workableInjury"]) newMessage = await (0, $hekDR.createWorkableInjuryRecoveryMessage)(s, month, year, doctor);
                else newMessage = await (0, $hekDR.createAvailableSuperstarMessage)(s, overnessIncrease, month, year, doctor);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
                // Add alert
                let alertType = availableData["workableInjury"] ? "workableInjuryRecovered" : "injuryRecovered";
                let newCompanyAlert = await (0, $8A6FL.createCompanyAlert)(alertType, s.name);
                await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                    newCompanyAlert
                ]);
            }
        }
        // Update suspended superstars
        for (const superstar of rosterSuperstars)if (superstar.suspensionMonths > 0) superstar.suspensionMonths -= 1;
    }
    // New competitors check, available for buyout check
    if (isMainCompany) {
        if (company.storyName !== "mars" && !weeklyShow) {
            // Check if any competitors are available for buyout
            await (0, $8A6FL.checkCompetitorsAvailableForBuyout)(company, month, year);
            // Check for new competitors
            if (game.settings["generate_competitors"] !== false) data["newCompetitors"] = await (0, $8A6FL.addNewCompetitorCheck)(company);
        }
    }
    // Update indie and training superstars
    if (!weeklyShow) {
        // Check training future superstars
        let trainingFutureRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "trainingFuture");
        if (trainingFutureRoster) {
            let toAdd = await (0, $5kTkA.getFutureSuperstarsToAdd)(trainingFutureRoster, month, year);
            for (const x of toAdd){
                if (company.userControlled) // Add to training roster for user
                await (0, $5kTkA.addFutureSuperstar)(x, trainingRoster);
                else {
                    // Chance to send to main roster for competitors
                    // They can't choose callups and pick out the best ones
                    let sendToMainRosterChance = 40;
                    if (x.popularity >= 500) sendToMainRosterChance += 20;
                    if (x.popularity >= 800) sendToMainRosterChance += 40;
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= sendToMainRosterChance) await (0, $5kTkA.addFutureSuperstar)(x, mainRoster);
                    else await (0, $5kTkA.addFutureSuperstar)(x, trainingRoster);
                }
                if (company.userControlled) {
                    // Add message
                    let newMessage = await (0, $hekDR.createFutureSuperstarMessage)(x, month, year, staffMembers, company, "Training");
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
        }
        // Update training superstar attributes
        let trainer = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "trainer");
        let trainingFacility = (await (0, $9esFv.getCompanyFacilities)(company)).find((x)=>x.name === "Training");
        let trainingFacilityLevel = trainingFacility ? trainingFacility.level : 1;
        let maxPopDict = {
            1: 800,
            2: 850,
            3: 900
        };
        let maxPop = maxPopDict[trainingFacilityLevel] || 900;
        let maxOvernessDict = {
            1: 80,
            2: 85,
            3: 90
        };
        let maxOverness = maxOvernessDict[trainingFacilityLevel] || 90;
        let changesDict = {
            normal: {
                1: {
                    pop: [
                        -4,
                        8
                    ],
                    xp: [
                        2,
                        4
                    ],
                    overness: [
                        -1,
                        2
                    ]
                },
                2: {
                    pop: [
                        -2,
                        12
                    ],
                    xp: [
                        3,
                        5
                    ],
                    overness: [
                        -1,
                        3
                    ]
                },
                3: {
                    pop: [
                        -1,
                        16
                    ],
                    xp: [
                        4,
                        6
                    ],
                    overness: [
                        -1,
                        4
                    ]
                }
            },
            inTraining: {
                1: {
                    pop: [
                        0,
                        12
                    ],
                    xp: [
                        2,
                        4
                    ],
                    overness: [
                        -1,
                        3
                    ]
                },
                2: {
                    pop: [
                        3,
                        15
                    ],
                    xp: [
                        3,
                        5
                    ],
                    overness: [
                        0,
                        4
                    ]
                },
                3: {
                    pop: [
                        6,
                        18
                    ],
                    xp: [
                        4,
                        6
                    ],
                    overness: [
                        1,
                        5
                    ]
                }
            }
        };
        let maxPopularityGainedSuperstars = [];
        for (const superstar of allTrainingSuperstars){
            // Change popularity/overness/xp for active training superstars
            if ((0, $5kTkA.checkAvailability)(superstar, true)) {
                // Get changes data
                let changesData = superstar.activeEffect === "in_training" ? changesDict["inTraining"][trainingFacilityLevel] : changesDict["normal"][trainingFacilityLevel];
                let popFloor = changesData["pop"][0];
                let popCeiling = changesData["pop"][1];
                let xpFloor = changesData["xp"][0];
                let xpCeiling = changesData["xp"][1];
                let overnessFloor = changesData["overness"][0];
                let overnessCeiling = changesData["overness"][1];
                // Popularity and xp
                let change = (0, $3E8Nt.getRandomInt)(popFloor, popCeiling);
                if (superstar.popularity + change < maxPop) {
                    superstar.popularity += change;
                    if (change === popCeiling) maxPopularityGainedSuperstars.push(superstar.name);
                } else // Change if close to max value
                superstar.popularity += (0, $3E8Nt.getRandomInt)(-5, 0);
                // Check for skill xp multiplier trait
                let traitMultiplier = 1;
                for (const trait of superstar.traits){
                    let traitData = (0, $aP7lq.traitsData)[trait];
                    if (traitData && traitData["skill_xp_multiplier"]) traitMultiplier = traitData["skill_xp_multiplier"];
                }
                // Update xp
                let xpGain = Math.floor((0, $3E8Nt.getRandomInt)(xpFloor, xpCeiling) * traitMultiplier);
                superstar.workrateXp += xpGain;
                await (0, $3SyPM.updateSuperstarWorkrate)(superstar, company, staffMembers, month, year);
                xpGain = Math.floor((0, $3E8Nt.getRandomInt)(xpFloor, xpCeiling) * traitMultiplier);
                superstar.charismaXp += xpGain;
                await (0, $4ptHI.updateSuperstarCharisma)(superstar, company, staffMembers, month, year);
                // Overness
                let overnessChange = (0, $3E8Nt.getRandomInt)(overnessFloor, overnessCeiling);
                // Get trait multiplier for overness change
                for (const trait of superstar.traits){
                    let traitData = (0, $aP7lq.traitsData)[trait];
                    if (traitData && traitData["overness_increase_multiplier"]) {
                        if (overnessChange > 0) overnessChange *= traitData["overness_increase_multiplier"];
                    }
                    if (traitData && traitData["overness_decrease_multiplier"]) {
                        if (overnessChange < 0) overnessChange *= traitData["overness_decrease_multiplier"];
                    }
                }
                // Change overness
                if (superstar.overness + overnessChange < maxOverness) superstar.overness += overnessChange;
                else // Change if close to max value
                superstar.overness += (0, $3E8Nt.getRandomInt)(-2, 0);
                // Make sure overness is a percentage between 0 and 100
                superstar.overness = (0, $3E8Nt.limitValueBetweenRange)(superstar.overness, 0, 100);
                let hotCheck = (0, $8A6FL.checkObjectHot)(superstar, 0);
                let staleCheck = (0, $8A6FL.checkObjectStale)(superstar, 0);
                if (company.userControlled) {
                    if (hotCheck === "hot") {
                        let newMessage = await (0, $hekDR.createTrainingRosterHotMessage)(superstar, month, year, trainer);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                    }
                    if (staleCheck === "stale") {
                        let newMessage = await (0, $hekDR.createTrainingRosterStaleMessage)(superstar, month, year, trainer);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                    }
                }
            }
            // Update morale
            if (superstar.morale > 20 && superstar.morale < 80) (0, $5kTkA.updateSuperstarMorale)(superstar, (0, $3E8Nt.getRandomInt)(-1, 1));
            if (superstar.injured >= 1) {
                superstar.injured -= 1;
                if (superstar.injured === 0) (0, $5kTkA.endSuperstarInjury)(superstar);
            }
            // Update suspended superstars
            if (superstar.suspensionMonths > 0) superstar.suspensionMonths -= 1;
        }
        // Add message of top training superstar popularity changes
        if (company.userControlled && maxPopularityGainedSuperstars.length > 0) {
            let popCeiling = changesDict["normal"][trainingFacilityLevel]["pop"][1];
            let newMessage = await (0, $hekDR.createTrainingRosterPopularityMessage)(maxPopularityGainedSuperstars, popCeiling, month, year, trainer);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        // Update indie superstars
        if (isMainCompany) {
            for (let x of indieAvailableSuperstars)if (x.availableThisMonth) x.availableThisMonth = null;
            // Check indie future superstars
            let indieFutureRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "indieFuture");
            if (indieFutureRoster) {
                let toAdd = await (0, $5kTkA.getFutureSuperstarsToAdd)(indieFutureRoster, month, year);
                for (let x of toAdd){
                    if (game.settings["all_indies_available"]) {
                        await (0, $5kTkA.addFutureSuperstar)(x, indieAvailableRoster);
                        x.availableThisMonth = true;
                    } else await (0, $5kTkA.addFutureSuperstar)(x, indieRoster);
                    // Add message
                    let newMessage = await (0, $hekDR.createFutureSuperstarMessage)(x, month, year, staffMembers, company, "Indie");
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
            // Make indie superstars available/unavailable
            let madeAvailable = [];
            if (indieSuperstars.length > 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= 70) {
                const talentToTransfer = (0, $3E8Nt.getRandomChoice)(indieSuperstars);
                madeAvailable = await (0, $jpMCP.transferTalentToRoster)(talentToTransfer, indieAvailableRoster);
            }
            let madeUnavailable = [];
            if (indieAvailableSuperstars.length > 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= 30) {
                if (!game.settings["all_indies_available"]) {
                    const talentToTransfer = (0, $3E8Nt.getRandomChoice)(indieAvailableSuperstars);
                    madeUnavailable = await (0, $jpMCP.transferTalentToRoster)(talentToTransfer, indieRoster);
                }
            }
            // Update indie superstars
            for (let x of madeAvailable){
                if ((0, $3E8Nt.objectInArray)(x, indieSuperstars)) indieSuperstars.splice(indieSuperstars.indexOf(x), 1);
                if (!(0, $3E8Nt.objectInArray)(x, indieAvailableSuperstars)) indieAvailableSuperstars.push(x);
                x.availableThisMonth = true;
                // Add scout message
                let scout = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "scout");
                if (scout) {
                    let superstarTagTeam = (await (0, $hBIDz.getSuperstarTagTeams)(x)).find((y)=>!y.temporary);
                    let newMessage = await (0, $hekDR.createIndieSuperstarAvailableMessage)(x, superstarTagTeam, month, year, scout);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
            for (let x of madeUnavailable){
                if (!(0, $3E8Nt.objectInArray)(x, indieSuperstars)) indieSuperstars.push(x);
                if ((0, $3E8Nt.objectInArray)(x, indieAvailableSuperstars)) indieAvailableSuperstars.splice(indieAvailableSuperstars.indexOf(x), 1);
            }
            // Remove available indie superstar's interested relationships
            for (let superstar of indieAvailableSuperstars)if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) {
                let interestedRelationship = (await (0, $hBIDz.getSuperstarRelationships)(superstar)).find((x)=>x.interested);
                if (interestedRelationship) await (0, $14eBR.Relationships).remove(interestedRelationship);
            }
            for (let superstar of indieSuperstars.concat(indieAvailableSuperstars)){
                // Change popularity/overness for active indie superstars
                if ((0, $5kTkA.checkAvailability)(superstar, true)) {
                    let change = (0, $3E8Nt.getRandomInt)(-10, 10);
                    superstar.popularity += change;
                    // Get overness change
                    let overnessChange = (0, $3E8Nt.getRandomInt)(-2, 2);
                    // Get trait multiplier for overness change
                    for (let trait of superstar.traits){
                        let traitData = (0, $aP7lq.traitsData)[trait];
                        if (traitData && traitData["overness_increase_multiplier"]) {
                            if (overnessChange > 0) overnessChange *= traitData["overness_increase_multiplier"];
                        }
                        if (traitData && traitData["overness_decrease_multiplier"]) {
                            if (overnessChange < 0) overnessChange *= traitData["overness_decrease_multiplier"];
                        }
                    }
                    // Change overness
                    superstar.overness += overnessChange;
                    superstar.overness = (0, $3E8Nt.limitValueBetweenRange)(superstar.overness, 0, 100);
                    (0, $8A6FL.checkObjectHot)(superstar, 0);
                    (0, $8A6FL.checkObjectStale)(superstar, 0);
                }
                // Update injured
                if (superstar.injured >= 1) {
                    superstar.injured -= 1;
                    if (superstar.injured === 0) (0, $5kTkA.endSuperstarInjury)(superstar);
                }
                // Update suspension months
                if (superstar.suspensionMonths > 0) superstar.suspensionMonths -= 1;
                // Chance to turn superstar
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 1) {
                    let alignmentChoices = [
                        "face",
                        "heel",
                        null
                    ];
                    if (!superstar.alignment) alignmentChoices.splice(alignmentChoices.indexOf(null), 1);
                    else alignmentChoices.splice(alignmentChoices.indexOf(superstar.alignment), 1);
                    await (0, $jpMCP.turnRosterMember)(superstar, (0, $3E8Nt.getRandomChoice)(alignmentChoices), company);
                } else superstar.alignmentMonths += 1;
            }
            // Add new superstar to indie roster
            if (game.settings["generate_indie_superstars"] !== false && (0, $3E8Nt.getRandomInt)(0, 100) < 33) {
                let generatedSuperstar = await (0, $8bQDO.generateSuperstar)({
                    popularity: (0, $3E8Nt.getRandomInt)(550, 750),
                    patreonChance: true
                });
                // Don't add duplicate
                let indieSuperstarsNames = indieSuperstars.concat(indieAvailableSuperstars).map((y)=>y.name);
                if (!indieSuperstarsNames.includes(generatedSuperstar.name)) {
                    let scout = (0, $8A6FL.getRandomStaffMemberByRole)(staffMembers, "scout");
                    let maxScout = (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "scout");
                    // Auto recruit
                    if (maxScout && maxScout.level >= 3 && scoutingFacility && scoutingFacility.level >= 3) {
                        await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, [
                            generatedSuperstar
                        ]);
                        let newMessage = await (0, $hekDR.createNewIndieSuperstarRecruitedMessage)(generatedSuperstar, month, year, maxScout);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                        generatedSuperstar.availableThisMonth = true;
                        // Add xp
                        let xp = 5;
                        let ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(maxScout);
                        xp = Math.round(xp * ageMultiplier);
                        let scoutLevelIncrease = await (0, $8A6FL.updateStaffMemberXp)(maxScout, xp, company, game);
                        if (scoutLevelIncrease) data["staffSkillIncreases"].push({
                            name: maxScout.name,
                            level: maxScout.level,
                            role: maxScout.role
                        });
                        // Add task completed data
                        data["staffActionsCompleted"].push({
                            name: "recruited a new Indie Talent",
                            xpGained: xp,
                            staffMember: maxScout.name,
                            xpAgeMultiplier: ageMultiplier
                        });
                    } else {
                        if (game.settings["all_indies_available"]) {
                            await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, [
                                generatedSuperstar
                            ]);
                            generatedSuperstar.availableThisMonth = true;
                        } else await (0, $dl5u4.addRosterSuperstars)(indieRoster, [
                            generatedSuperstar
                        ]);
                        let newMessage = await (0, $hekDR.createNewIndieSuperstarMessage)(generatedSuperstar, month, year, scout);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                    }
                }
            }
        }
    }
    // Update time-based championships
    data["expiringChampionships"] = [];
    data["expiredChampionships"] = [];
    if (!weeklyShow) {
        for (const championship of companyChampionships)if (championship.championshipContract) {
            championship.monthsToExpire -= 1;
            // Delete championship after 12 months
            if (championship.monthsToExpire < 0) {
                data["expiredChampionships"].push((0, $1JSre.getChampionshipDisplayName)(championship));
                const champion = await (0, $ivuOU.getChampionshipSuperstar)(championship);
                if (champion) await (0, $hBIDz.removeSuperstarChampionships)(champion, [
                    championship
                ]);
                await (0, $9esFv.removeCompanyChampionships)(company, [
                    championship
                ]);
                await (0, $14eBR.Championships).remove(championship);
            } else if (championship.monthsToExpire === 0) data["expiringChampionships"].push((0, $1JSre.getChampionshipDisplayName)(championship));
        }
    }
    // Go through event's match contracts, checking if used
    if (!weeklyShow) {
        for (const matchContract of (await (0, $iQtzn.getEventMatchContracts)(parentEvent)))// Check if awarded and available for use (i.e not awarded at this event)
        if (matchContract.awarded && matchContract.availableForUse) {
            // Check if championship match held
            const matchContractHolder = await (0, $1AAHK.getMatchContractTalent)(matchContract);
            let used = false;
            for (const match of (await (0, $iQtzn.getEventMatches)(latestEvent)))if ((await (0, $i7bmn.getMatchChampionships)(match)).length > 0 && (0, $3E8Nt.objectInArray)(matchContractHolder, await (0, $i7bmn.getMatchParticipants)(match))) used = true;
            if (!used) {
                // Add fans penalty
                const penalty = $9f57f5c1301b7dbc$var$getMatchContractNotHeldPenalty(company.reputation);
                company.fans -= penalty;
                data["matchContractsNotUsed"].push({
                    matchContract: matchContract.name,
                    penalty: penalty
                });
            }
            // Remove match contract championship(s) if found
            const matchContractChampionship = await (0, $1AAHK.getMatchContractChampionship)(matchContract);
            if (matchContractChampionship) {
                const matchContractChampionships = companyChampionships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, matchContractChampionship));
                for (const c of matchContractChampionships){
                    await (0, $9esFv.removeCompanyChampionships)(company, [
                        c
                    ]);
                    await (0, $14eBR.Championships).remove(c);
                }
            }
            // Delete match contract
            await (0, $14eBR.MatchContracts).remove(matchContract);
        }
    }
    // Make all match contracts available for use
    for (const event of parentEvents){
        for (const matchContract of (await (0, $iQtzn.getEventMatchContracts)(event)))if (!matchContract.availableForUse) matchContract.availableForUse = true;
    }
    // Check for event rating goal
    if (company.userControlled && !weeklyShow) {
        let objectiveCompleted = await (0, $8A6FL.changeProperty)({
            name: "events",
            change: 1,
            company: company,
            rating: rating
        });
        if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
    }
    // Add rating news, messages from competitors, random news
    if (!weeklyShow) {
        if (rating >= 4.25) {
            let newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: game.newsMonth,
                year: game.newsYear,
                event: latestEvent,
                newsType: "high_event_rating"
            });
            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                newsItem
            ]);
            if (company.userControlled && game.competitorsPresent && (0, $3E8Nt.getRandomInt)(0, 100) <= 15) {
                const competitors = await (0, $8A6FL.getCpuControlledCompanies)(company, game);
                if (competitors.length) {
                    const competitor = (0, $3E8Nt.getRandomChoice)(competitors);
                    const subject = "Good show";
                    const content = `<p>That was a pretty good show top to bottom. But I think you can do better, maybe you could even come up to our level.</p>`;
                    const messageFrom = competitor.ownerName ? competitor.ownerName : `Owner - ${competitor.name}`;
                    const newMessage = await (0, $hekDR.createMessage)(subject, messageFrom, month, year, content);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
        } else if (rating < 2.5) {
            let newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: game.newsMonth,
                year: game.newsYear,
                event: latestEvent,
                newsType: "low_event_rating"
            });
            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                newsItem
            ]);
            if (company.userControlled && game.competitorsPresent && (0, $3E8Nt.getRandomInt)(0, 100) <= 15) {
                const competitors = await (0, $8A6FL.getCpuControlledCompanies)(company, game);
                if (competitors.length) {
                    const competitor = (0, $3E8Nt.getRandomChoice)(competitors);
                    const subject = "Tough luck";
                    const content = `<p>That wasn't a good show, huh? Bad matches, bad stories. Stuff like that happens. I'm sure you'll do better next time.</p>`;
                    const messageFrom = competitor.ownerName ? competitor.ownerName : `Owner - ${competitor.name}`;
                    const newMessage = await (0, $hekDR.createMessage)(subject, messageFrom, month, year, content);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
        }
        // Generate random news
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 6 && game.competitorsPresent) {
            // Rib
            if ((0, $3E8Nt.getRandomChoice)([
                true,
                false
            ])) {
                let ribVictim = (0, $3E8Nt.getRandomChoice)(rosterSuperstars);
                let ribCulprit = (0, $3E8Nt.getRandomChoice)(rosterSuperstars);
                while(ribCulprit.$loki === ribVictim.$loki)ribCulprit = (0, $3E8Nt.getRandomChoice)(rosterSuperstars);
                let newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: game.newsMonth,
                    year: game.newsYear,
                    newsType: "rib",
                    ribVictim: ribVictim,
                    ribCulprit: ribCulprit
                });
                await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                    newsItem
                ]);
                // Add feud
                const newFeudSuperstars = [
                    ribVictim,
                    ribCulprit
                ];
                const feudItems = (await (0, $9esFv.getCompanyFeudItems)(company)).filter((x)=>x.unlocked && x.requirement === "rib");
                const feudItem = (0, $3E8Nt.getRandomChoice)(feudItems);
                // Check for existing feud
                let existingFeud;
                for (const y of newFeudSuperstars)for (const f of (await (0, $cXLSF.getRosterMemberFeuds)(y))){
                    if (f.started && !f.ended || !f.started && f.directFeudEvent && !f.ended) {
                        if ((await (0, $jDtEn.getFeudParticipants)(f)).every((y)=>(0, $3E8Nt.objectInArray)(y, newFeudSuperstars))) {
                            existingFeud = f;
                            break;
                        }
                    }
                }
                // Add feud or increase hype of existing feud
                if (!existingFeud) {
                    const newFeud = (0, $jDtEn.Feud)();
                    await (0, $14eBR.Feuds).insert(newFeud);
                    newFeud.name = feudItem.name;
                    newFeud.hype = feudItem.baseHype;
                    newFeud.participants = newFeudSuperstars.map((s)=>s.name);
                    newFeud.directFeudEvent = feudItem.requirement;
                    newFeud.startMonth = month;
                    newFeud.startYear = year;
                    data["feudPotential"] = {
                        name: newFeud.name,
                        participants: newFeudSuperstars.map((x)=>x.name)
                    };
                    await (0, $im36F.addFeudItemFeuds)(feudItem, [
                        newFeud
                    ]);
                    await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                        newFeud
                    ]);
                    await (0, $jDtEn.addFeudSuperstars)(newFeud, newFeudSuperstars);
                } else {
                    const hypeIncrease = Math.floor(feudItem.baseHype / 2);
                    existingFeud.hype += hypeIncrease;
                    data["feudHypeIncreased"] = {
                        name: existingFeud.name,
                        participants: newFeudSuperstars.map((x)=>x.name),
                        hypeIncrease: hypeIncrease,
                        newFeud: feudItem.name
                    };
                }
            } else {
                let newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: game.newsMonth,
                    year: game.newsYear,
                    newsType: "superstar_venture",
                    superstar: (0, $3E8Nt.getRandomChoice)(rosterSuperstars)
                });
                await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                    newsItem
                ]);
            }
        }
    }
    // Ensure max/min overness
    for (const superstar of rosterSuperstars)superstar.overness = (0, $3E8Nt.limitValueBetweenRange)(superstar.overness, 0, 100);
    // Get superstars and championships booked at next event if at tournament/cash in weekly show
    const bookedSuperstars = [];
    const bookedChampionships = [];
    let nextEventMatches = [];
    if (latestEvent.name === "Weekly Show") {
        const nextEvent = (await (0, $9esFv.getCompanyEvents)(company)).reverse().find((event)=>event.name !== "Weekly Show" && !event.temporaryEvent);
        if (nextEvent) nextEventMatches = await (0, $iQtzn.getEventMatches)(nextEvent);
    }
    if (nextEventMatches.length) for (const nextEventMatch of nextEventMatches){
        bookedSuperstars.push(...await (0, $i7bmn.getAllSuperstarsForMatch)(nextEventMatch));
        bookedChampionships.push(...await (0, $i7bmn.getMatchChampionships)(nextEventMatch));
    }
    // Remove temporary tag teams if not booked
    let temporaryTagTeams = (await (0, $dl5u4.getRosterTagTeams)(mainRoster)).filter((x)=>x.temporary);
    for (const tagTeam of temporaryTagTeams){
        let ts = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
        if (!ts.every((x)=>(0, $3E8Nt.objectInArray)(x, bookedSuperstars))) await (0, $ko5kE.removeTagTeam)(tagTeam);
    }
    // Set booked to false for championships
    for (const championship of companyChampionships)if (!(0, $3E8Nt.objectInArray)(championship, bookedChampionships)) championship.booked = false;
    // Reset superstars' attires to base attires
    for (const superstar of rosterSuperstars)if (superstar.currentAttire > 0) superstar.currentAttire = 0;
    // End old feuds
    if (!weeklyShow) for (const feud of (await (0, $dl5u4.getRosterFeuds)(mainRoster))){
        if (feud.startMonth !== null && !feud.ended) try {
            const monthsPassed = (0, $3E8Nt.getMonthsDifference)(month, year, feud.startMonth, feud.startYear);
            let maximumMonths = 14;
            if (feud.hot) maximumMonths = 20;
            else if (feud.stale) maximumMonths = 10;
            const feudData = {
                name: feud.name,
                participants: (await (0, $jDtEn.getFeudParticipants)(feud)).map((x)=>x.name)
            };
            // End feud
            if (monthsPassed >= maximumMonths) {
                feud.ended = true;
                // For ending potential feuds
                if (!feud.started) feud.rating = null;
                else feud.rating = await (0, $cXLSF.getFeudRating)(feud);
                feud.endMonth = month;
                feud.endYear = year;
                // Add message from owner about ending feud
                if (company.userControlled) {
                    const newMessage = await (0, $hekDR.createFeudEndedMessage)(feudData, company, month, year);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            } else if (monthsPassed === maximumMonths - 1 && company.userControlled) {
                const newMessage = await (0, $hekDR.createEndFeudReminderMessage)(feudData, company, month, year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
        } catch (error) {
            (0, $3E8Nt.captureError)(error);
        }
    }
    // Add random messages
    if (company.userControlled && !weeklyShow && company.storyName !== "mars") {
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 15 && rosterSuperstars.length) {
            const newMessage = await (0, $hekDR.generateRamblingMessage)(rosterSuperstars, company);
            if (newMessage) await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
    }
    // Run staff tasks
    const staffTasksCompleted = [];
    const availableStaffMembers = (0, $8A6FL.getAvailableStaffMembers)(staffMembers);
    if (!weeklyShow) {
        // Run scout/recruit tasks separately
        const scouts = availableStaffMembers.filter((x)=>x.role === "scout");
        for (const scout of scouts){
            if (scout.currentTask && [
                "Scouting",
                "Recruiting"
            ].includes(scout.currentTask.split(" ")[0])) {
                // Get talent from indie roster
                const talentName = scout.currentTask.split(" ").splice(1).join(" ");
                let talent = indieSuperstars.concat(indieAvailableSuperstars).find((x)=>x.name === talentName);
                if (!talent) talent = (await (0, $dl5u4.getRosterTagTeams)(indieRoster)).concat(await (0, $dl5u4.getRosterTagTeams)(indieAvailableRoster)).find((x)=>x.name === talentName);
                if (talent) {
                    // Run task
                    const task = scout.currentTask.split(" ")[0];
                    let xp = 0;
                    const ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(scout);
                    if (task === "Scouting") {
                        await (0, $8ugbL.scoutTalent)(talent, indieRoster, indieAvailableRoster, scout, company);
                        xp = 7.5;
                    } else if (task === "Recruiting") {
                        await (0, $8ugbL.recruitTalent)(talent, indieRoster, indieAvailableRoster, scout, company);
                        xp = 5;
                    }
                    if (task === "Scouting" || task === "Recruiting") // Add actions completed (Superstars Scouted/Recruited)
                    await (0, $8A6FL.checkFacilityUpgrade)("Scouting", company);
                    // Add xp
                    xp = Math.round(xp * ageMultiplier);
                    const scoutLevelIncrease = await (0, $8A6FL.updateStaffMemberXp)(scout, xp, company, game);
                    if (scoutLevelIncrease) data["staffSkillIncreases"].push({
                        name: scout.name,
                        level: scout.level,
                        role: scout.role
                    });
                    // Add task completed data
                    staffTasksCompleted.push({
                        name: scout.currentTask,
                        xpGained: xp,
                        staffMember: scout.name,
                        xpAgeMultiplier: ageMultiplier
                    });
                }
                scout.currentTask = null;
            } else if (scout.level >= 2 && scoutingFacility && scoutingFacility.level >= 2) {
                const superstarInterested = await (0, $8ugbL.buildInterest)(indieAvailableSuperstars, scout, company);
                if (superstarInterested) {
                    // Add xp
                    let xp = 5;
                    const ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(scout);
                    xp = Math.round(xp * ageMultiplier);
                    const scoutLevelIncrease = await (0, $8A6FL.updateStaffMemberXp)(scout, xp, company, game);
                    if (scoutLevelIncrease) data["staffSkillIncreases"].push({
                        name: scout.name,
                        level: scout.level,
                        role: scout.role
                    });
                    // Add task completed data
                    data["staffActionsCompleted"].push({
                        name: "got an Indie Talent interested",
                        xpGained: xp,
                        staffMember: scout.name,
                        xpAgeMultiplier: ageMultiplier
                    });
                }
            }
        }
        const transitionedStaffMembers = [];
        for (const staffMember of staffMembers){
            // Progress tasks that run with time
            if (staffMember.currentTask && staffMember.monthsLeftForTask && staffMember.unavailableMonths <= 0 && !staffMember.retired) {
                // Check task end
                if (staffMember.monthsLeftForTask <= 1) {
                    let task = staffMember.currentTask.split(" ")[0];
                    if (task === "Training") task = staffMember.currentTask.split(" ").slice(0, 2).join(" "); // Get next word which is skill in brackets
                    let runTaskOn = null;
                    // Get talent name
                    let talentName = staffMember.currentTask.split(task + " ")[1];
                    if (task === "Unlearning") talentName = staffMember.currentTask.split(" For ")[1];
                    if (task === "Transitioning") {
                        if (staffMember.currentTask.split(" ")[1] === "(Staff)") {
                            task = "Transitioning (Staff)";
                            talentName = staffMember.currentTask.split(" (Staff) ")[1];
                        } else if (staffMember.currentTask.split(" ")[1] === "(Talent)") {
                            task = "Transitioning (Talent)";
                            talentName = staffMember.currentTask.split(" (Talent) ")[1];
                        }
                    }
                    // Get talent
                    if ([
                        "Training (Workrate)",
                        "Training (Charisma)",
                        "Reassuring",
                        "Transitioning",
                        "Unlearning",
                        "Transitioning (Staff)"
                    ].includes(task)) runTaskOn = rosterSuperstars.find((x)=>x.name === talentName);
                    else if (task === "Preparing") runTaskOn = allTrainingSuperstars.find((x)=>x.name === talentName);
                    else if (task === "Negotiating") {
                        const competitorName = staffMember.currentTask.split(" ").slice(1, staffMember.currentTask.split(" ").length - 1).join(" ");
                        const allCompetitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game);
                        runTaskOn = allCompetitors.find((x)=>x.name === competitorName);
                    } else if (task === "Transitioning (Talent)") runTaskOn = staffMembers.find((x)=>x.name === talentName);
                    if (runTaskOn) {
                        // Run task
                        let xp = 0;
                        const ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(staffMember);
                        // Training
                        if ([
                            "Training (Workrate)",
                            "Training (Charisma)"
                        ].includes(task)) {
                            let skill = null;
                            if (task === "Training (Workrate)") skill = "workrate";
                            else if (task === "Training (Charisma)") skill = "charisma";
                            await (0, $8ugbL.trainTalent)(runTaskOn, skill, staffMember, company, staffMembers);
                            xp = 22.5;
                            // Add actions completed (Superstars Trained)
                            await (0, $8A6FL.checkFacilityUpgrade)("Training", company);
                        } else if (task === "Preparing") {
                            await (0, $8ugbL.makeTrainingTalentAvailable)(runTaskOn, staffMember, trainingAvailableRoster, company);
                            xp = 15;
                        } else if (task === "Negotiating") {
                            runTaskOn.operatingStatus = `Running Buyout by ${company.name}`;
                            xp = 50;
                        } else if (task === "Reassuring") {
                            await (0, $8ugbL.reassureTalent)(runTaskOn, staffMember, company);
                            xp = 5;
                            // Add actions completed (Superstars Reassured)
                            await (0, $8A6FL.checkFacilityUpgrade)("Talent Management", company);
                        } else if (task === "Transitioning") {
                            await (0, $8ugbL.transitionTalent)(runTaskOn, staffMember, company);
                            xp = 8;
                        } else if (task === "Unlearning") {
                            await (0, $8ugbL.unlearnTalentTrait)(runTaskOn, staffMember, company);
                            xp = 40;
                        } else if (task === "Transitioning (Staff)") {
                            await (0, $8ugbL.transitionSuperstarToStaffMember)(runTaskOn, staffMember, company);
                            xp = 15;
                            // Remove from roster superstars
                            rosterSuperstars = rosterSuperstars.filter((x)=>x.$loki !== runTaskOn.$loki);
                        } else if (task === "Transitioning (Talent)") {
                            await (0, $8ugbL.transitionStaffMemberToSuperstar)(runTaskOn, staffMember, company);
                            xp = 15;
                            transitionedStaffMembers.push(runTaskOn);
                        }
                        // Add xp
                        xp = Math.round(xp * ageMultiplier);
                        const staffMemberLevelIncrease = await (0, $8A6FL.updateStaffMemberXp)(staffMember, xp, company, game);
                        if (staffMemberLevelIncrease) data["staffSkillIncreases"].push({
                            name: staffMember.name,
                            level: staffMember.level,
                            role: staffMember.role
                        });
                        // Add task completed data
                        staffTasksCompleted.push({
                            name: staffMember.currentTask,
                            xpGained: xp,
                            staffMember: staffMember.name,
                            xpAgeMultiplier: ageMultiplier
                        });
                    }
                    (0, $8A6FL.removeStaffTaskData)(staffMember);
                } else {
                    staffMember.monthsLeftForTask -= 1;
                    // Buyout accepted message before task ends
                    const task = staffMember.currentTask.split(" ")[0];
                    if (task === "Negotiating" && staffMember.monthsLeftForTask === 1) {
                        const competitorName = staffMember.currentTask.split(" ").slice(1, staffMember.currentTask.split(" ").length - 1).join(" ");
                        const allCompetitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game);
                        const competitor = allCompetitors.find((x)=>x.name === competitorName);
                        if (competitor) {
                            const competitorMainRoster = await (0, $8A6FL.getCompanyRosterByType)(competitor, "main");
                            const competitorSuperstars = await (0, $dl5u4.getRosterSuperstars)(competitorMainRoster);
                            const [available, notAvailable] = await (0, $8A6FL.getBuyoutSuperstars)(competitor, competitorSuperstars, company);
                            available.sort((a, b)=>b.popularity - a.popularity);
                            notAvailable.sort((a, b)=>b.popularity - a.popularity);
                            // From top not available superstar
                            let newMessage = await (0, $hekDR.createBuyoutNotAvailableSuperstarMessage)((0, $3E8Nt.getRandomChoice)(notAvailable.slice(0, 5)), month, year);
                            await (0, $9esFv.addCompanyMessages)(company, [
                                newMessage
                            ]);
                            // Message from trainer
                            const trainer = (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "trainer");
                            newMessage = await (0, $hekDR.createBuyoutAcceptedTrainerMessage)(competitor, month, year, trainer);
                            await (0, $9esFv.addCompanyMessages)(company, [
                                newMessage
                            ]);
                            // Message from owner
                            newMessage = await (0, $hekDR.createBuyoutSigningsMessage)(competitor, month, year, company.ownerName);
                            await (0, $9esFv.addCompanyMessages)(company, [
                                newMessage
                            ]);
                            // Message from talent manager
                            newMessage = await (0, $hekDR.createBuyoutAcceptedMessage)(competitor, competitorSuperstars, available, notAvailable, month, year, staffMember);
                            await (0, $9esFv.addCompanyMessages)(company, [
                                newMessage
                            ]);
                        }
                    }
                }
            }
            // Progress unavailability
            if (staffMember.unavailableMonths > 0) staffMember.unavailableMonths--;
        }
        // Update staff
        staffMembers = staffMembers.filter((x)=>!(0, $3E8Nt.objectInArray)(x, transitionedStaffMembers));
    }
    // Remove producer segment focus tasks
    const producers = staffMembers.filter((x)=>x.role === "producer");
    for (const producer of producers){
        if (producer.currentTask && producer.taskData && producer.taskData["segment_id"]) (0, $8A6FL.removeStaffTaskData)(producer);
        // Check producer segment unlocks
        (0, $4ptHI.checkProducerSegmentItemsToUnlock)(producer, companySegmentItems);
    }
    // Remove doctor rehab tasks
    const doctors = staffMembers.filter((x)=>x.role === "doctor");
    for (const doctor of doctors)if (doctor.currentTask && doctor.taskData && doctor.taskData["talent_id"]) {
        const doctorTalent = rosterSuperstars.find((y)=>y.$loki === doctor.taskData["talent_id"]);
        if (!doctorTalent || doctorTalent.injured === 0) (0, $8A6FL.removeStaffTaskData)(doctor);
    }
    // Update staff age and check for retirement
    if (newYearStarted) {
        for (const staffMember of staffMembers){
            staffMember.age += 1;
            if (!game.settings["no_retirements"]) {
                // Retirement chance message
                if (staffMember.age === 65) {
                    if (company.userControlled) {
                        const newMessage = await (0, $hekDR.createStaffMemberRetirementChanceMessage)(staffMember, month, year);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                    }
                } else if (staffMember.age > 65 && !staffMember.retired) {
                    const task = staffMember.currentTask ? staffMember.currentTask.split(" ")[0] : null;
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 25 && task !== "Negotiating") {
                        // Retire
                        staffMember.retired = true;
                        (0, $8A6FL.removeStaffTaskData)(staffMember);
                        staffMember.unavailableMonths = 0;
                        if (company.userControlled) {
                            const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("staffMemberRetired", `${staffMember.name} (${(0, $3E8Nt.toTitleCase)(staffMember.role.replace("_", " "))})`);
                            await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                                newCompanyAlert
                            ]);
                            const newMessage = await (0, $hekDR.createStaffMemberRetirementMessage)(staffMember, month, year);
                            await (0, $9esFv.addCompanyMessages)(company, [
                                newMessage
                            ]);
                        }
                    }
                }
            }
        }
        if (isMainCompany) for (const staffMember of (await (0, $dl5u4.getRosterStaff)(indieAvailableRoster))){
            staffMember.age += 1;
            if (!game.settings["no_retirements"]) {
                // Retirement chance
                if (staffMember.age > 65 && !staffMember.retired) {
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 25) {
                        // Retire
                        staffMember.retired = true;
                        (0, $8A6FL.removeStaffTaskData)(staffMember);
                        staffMember.unavailableMonths = 0;
                        // Generate new staff member
                        const newStaffMember = await (0, $8bQDO.generateStaffMember)(staffMember.role, (0, $3E8Nt.getRandomChoice)([
                            1,
                            2,
                            3
                        ]));
                        await (0, $dl5u4.addRosterStaff)(indieAvailableRoster, [
                            newStaffMember
                        ]);
                    }
                }
            }
        }
    }
    // Staff random events
    if (!weeklyShow) {
        if (availableStaffMembers.length) await (0, $2A9WA.checkForStaffRandomEvent)(availableStaffMembers, company);
    }
    // Manage morale
    for (const superstar of rosterSuperstars){
        // Don't process for injured, suspended, retired, no appearances part timers and on trade deal superstars
        if (!(0, $5kTkA.checkAvailability)(superstar, true, false, false) || superstar.activeEffect === "traded" || superstar.name === company.ownerName) continue;
        await (0, $5kTkA.processSuperstarMorale)(superstar, company, game);
    }
    // Make all superstars available
    for (const s of rosterSuperstars)if (s.unavailable) s.unavailable = false;
    // Process temporary graphics
    if (!annualTournamentRunning) for (const s of rosterSuperstars.concat(indieSuperstars, indieAvailableSuperstars, allTrainingSuperstars)){
        (0, $5kTkA.processSuperstarTemporaryInjury)(s, latestEvent);
        if (!weeklyShow) (0, $5kTkA.processSuperstarTemporaryTrophy)(s);
    }
    // Recover fatigue for all superstars
    let superstarsToRecoverFatigue = [
        ...rosterSuperstars
    ];
    if (isMainCompany) superstarsToRecoverFatigue = superstarsToRecoverFatigue.concat(indieSuperstars, indieAvailableSuperstars, allTrainingSuperstars);
    if (annualTournamentRunning) // Recover fatigue for participating superstars only at annual tournament
    superstarsToRecoverFatigue = [
        ...superstarsUsedAtEvent
    ];
    for (const s of superstarsToRecoverFatigue){
        const usedAtEvent = (0, $3E8Nt.objectInArray)(s, superstarsUsedAtEvent);
        (0, $5kTkA.recoverSuperstarFatigue)(s, usedAtEvent, weeklyShow, rosterBrands, game);
        // Limit fatigue to percentage
        s.fatigue = (0, $3E8Nt.limitValueBetweenRange)(s.fatigue, 0, 100);
    }
    // Remove temporary segment items
    const segmentItemsToRemove = companySegmentItems.filter((x)=>x.temporary);
    for (const segmentItem of segmentItemsToRemove)await (0, $9esFv.removeCompanySegmentItems)(company, [
        segmentItem
    ]);
    // Booking effects for competitors
    if (!company.userControlled && !weeklyShow && mainCompany.storyName !== "mars") {
        const bookingEffects = [
            "good_booking",
            "bad_booking"
        ];
        let activeEffect = company.activeEffect;
        // Chance to add booking effect
        if (!activeEffect && (0, $3E8Nt.getRandomInt)(0, 100) <= 10) company.activeEffect = (0, $3E8Nt.weightedChoice)([
            [
                "good_booking",
                50
            ],
            [
                "bad_booking",
                50
            ]
        ]);
        // Chance to remove booking effect
        if (bookingEffects.includes(activeEffect)) {
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) company.activeEffect = null;
            else if (company.activeEffect === "good_booking" && rating < 3.5 && (0, $3E8Nt.getRandomInt)(0, 100) <= 25) company.activeEffect = null;
            else if (company.activeEffect === "bad_booking" && rating > 3.5 && (0, $3E8Nt.getRandomInt)(0, 100) <= 25) company.activeEffect = null;
        }
        // Chance to add good booking effect if available for buyout
        if (company.operatingStatus === "Buyout Available" && (0, $3E8Nt.getRandomInt)(0, 100) <= 60) company.activeEffect = "good_booking";
    }
    // Check if special segment items are available to re-use if not sandbox mode
    if (!weeklyShow) {
        if (!company.userControlled || !game.settings["no_special_items_cooldown"]) {
            for (const x of companySegmentItems)if (x.special && x.unlocked && x.used) {
                x.monthsToReuse -= 1;
                if (x.monthsToReuse <= 0) {
                    x.used = false;
                    x.monthsToReuse = 36;
                    // Add re-use message
                    if (company.userControlled) {
                        const newMessage = await (0, $hekDR.createSpecialSegmentReuseMessage)(x, month, year);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                    }
                }
            }
            // Check if special finishes are available to re-use
            for (const [_, v] of Object.entries(company.specialFinishesData))if (v["months_to_reuse"] > 0) v["months_to_reuse"] -= 1;
        }
    }
    if (!weeklyShow) {
        const sentNegotiations = await (0, $9esFv.getCompanySentNegotiations)(company);
        // Process negotiations started by company and accepted by talent, except those sent to user-controlled company
        if (!(company.userControlled && game.settings["control_multiple_companies"])) {
            const acceptedNegotiations = await (0, $3NAMH.filterOffersSentToCpuCompanies)(sentNegotiations);
            for (const acceptedNegotiation of acceptedNegotiations){
                let processedNegotiation = await (0, $3NAMH.processNegotiation)(acceptedNegotiation);
                if (processedNegotiation && processedNegotiation.status === "accepted_by_company") {
                    const negotiationTalent = await (0, $csISS.getNegotiationTalent)(processedNegotiation);
                    data["signings"].push(negotiationTalent.name);
                }
            }
        }
        // Process negotiations sent to user-controlled company if simulating
        if (simulation && company.userControlled) {
            // Get incoming offers without duplicates for superstars
            const incomingNegotiations = [];
            let incomingNegotiationsTalentNames = [];
            const acceptedNegotiations = (await (0, $9esFv.getCompanyReceivedNegotiations)(company)).filter((y)=>y.status === "accepted_by_talent");
            for (const acceptedNegotiation of acceptedNegotiations){
                const negotiationTalent = await (0, $csISS.getNegotiationTalent)(acceptedNegotiation);
                if (!incomingNegotiationsTalentNames.includes(negotiationTalent.name)) {
                    incomingNegotiations.push(acceptedNegotiation);
                    incomingNegotiationsTalentNames.push(negotiationTalent.name);
                }
            }
            // Reject offers if simulating game using 'Book' option
            const autoRejectOffers = userSimulatorOption === "book";
            for (const negotiation of incomingNegotiations){
                let processedNegotiation = await (0, $3NAMH.processNegotiation)(negotiation, autoRejectOffers);
                if (processedNegotiation.status === "accepted_by_company") {
                    let negotiationTalent = await (0, $csISS.getNegotiationTalent)(processedNegotiation);
                    let negotiationSenderCompany = await (0, $csISS.getNegotiationSenderCompany)(processedNegotiation);
                    data["offersAccepted"].push({
                        name: negotiationTalent.name,
                        company: negotiationSenderCompany.name
                    });
                    if (negotiationTalent.objectName === "superstar" && (0, $3E8Nt.objectInArray)(negotiationTalent, rosterSuperstars)) rosterSuperstars.splice(rosterSuperstars.indexOf(negotiationTalent), 1);
                }
            }
        }
        // Remove old negotiations (rejected, finished)
        for (const sentNegotiation of sentNegotiations)if (sentNegotiation.monthsToRemove !== null) {
            sentNegotiation.monthsToRemove -= 1;
            if (sentNegotiation.monthsToRemove <= 0 && sentNegotiation.$loki) await (0, $14eBR.Negotiations).remove(sentNegotiation);
        }
    }
    // Check if at last user event
    let lastUserEvent = false;
    if (game.settings["control_multiple_companies"]) {
        if (company.userControlled && (await (0, $iRMwH.getUserControlledCompanies)(game)).filter((y)=>y.turnStatus === "playing").length === 1) lastUserEvent = true;
    } else if (isMainCompany) lastUserEvent = true;
    // Process annual tournament
    if (lastUserEvent) try {
        await (0, $18vSN.processAnnualTournament)(game, mainCompany, user, weeklyShow, eventsToSimulate);
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    // True for monthly event before night 1, night 1 itself, but not night 2
    const annualTournamentActive = annualTournament && [
        "selecting",
        "running"
    ].includes(annualTournament.status);
    // Run random events
    if (company.userControlled && !game.settings["no_random_events"] && !annualTournamentActive) // Mark night 2 of TGI as monthly to process random events
    try {
        await (0, $2A9WA.randomEventCheck)(company, weeklyShow && !annualTournamentRunning);
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    // Add and process talent requests for user companies, don't in stories
    if (company.userControlled && !mainCompany.storyName) {
        // Process talent requests
        try {
            await (0, $1olyO.processTalentRequests)(company, weeklyShow);
        } catch (error) {
            (0, $3E8Nt.captureError)(error);
        }
        // Check to add talent requests after monthly events
        try {
            if (!weeklyShow && (0, $98xmD.globalUser).paid && !game.settings["no_talent_requests"] && !annualTournamentActive) await (0, $1olyO.checkTalentRequestCreation)(company, rosterSuperstars, mainRoster, companyChampionships);
        } catch (error) {
            (0, $3E8Nt.captureError)(error);
        }
    }
    // Process months to form for new company
    if (!weeklyShow && isMainCompany && company.newCompanyData?.monthsToForm !== undefined) company.newCompanyData.monthsToForm -= 1;
    // Add 'shown' to company alerts, delete shown alerts
    if (company.userControlled && !annualTournamentActive) {
        for (const companyAlert of (await (0, $9esFv.getCompanyCompanyAlerts)(company)))if (companyAlert.shown) await (0, $14eBR.CompanyAlerts).remove(companyAlert);
        else companyAlert.shown = true;
    }
    // Add datetime game last played
    if (company.userControlled) game.datetimeLastPlayed = Date.now();
    // Return data
    data["points"] = company.points;
    data["pointsToAdd"] = pointsToAdd;
    data["hype"] = latestEvent.hype;
    if (game.marketSize === null) {
        data["fansGained"] = fansToAdd;
        data["hypeMultiplier"] = hypeMultiplier;
        data["nextReputation"] = fansToNextReputation;
        data["previousReputation"] = fansToPreviousReputation;
        data["reputationIncrease"] = reputationIncrease;
        data["reputationDecrease"] = reputationDecrease;
        data["reputation"] = company.reputation;
        const repXpChange = (company.fans - startingFans) / 100;
        data["reputationXpChange"] = Math.abs(repXpChange) > 10 ? Math.floor(repXpChange) : Math.round(repXpChange * 10) / 10;
        data["reputationXp"] = Math.floor(company.fans / 100);
        data["xpToNextReputation"] = Math.floor(fansToNextReputation / 100);
        data["companyName"] = company.name;
    }
    data["eventPrestige"] = eventPrestigeData;
    data["weeklyShow"] = weeklyShow;
    data["fans"] = company.fans;
    data["rating"] = rating;
    data["staffTasksCompleted"] = staffTasksCompleted;
    data["skipSimulateCompetitors"] = latestEvent.name === "Weekly Show" || latestEvent.temporaryEvent;
    // Increase realYear if first monthly event
    if (!(company.userControlled && game.settings["control_multiple_companies"]) && latestEvent.name !== "Weekly Show" && !latestEvent.temporaryEvent) {
        if (!nextEvent.weeklyShow) {
            const nextEventParentEvent = await (0, $5ZsVo.getParentEventForEvent)(parentEvents, nextEvent);
            if (nextEventParentEvent.$loki === parentEvents[0].$loki) company.realYear += 1;
        }
        nextEvent.year = company.realYear;
    }
    // If local multiplayer and not tournament weekly show, end turn, go to next user controlled company
    if (company.userControlled && game.settings["control_multiple_companies"] && latestEvent.name !== "Weekly Show" && !latestEvent.temporaryEvent) {
        company.turnStatus = "ended";
        let userControlledCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
        let userControlledCompaniesPlaying = userControlledCompanies.filter((y)=>y.turnStatus === "playing");
        // If any user is playing
        if (userControlledCompaniesPlaying.length) {
            // Set next company with 'playing' status as current company
            (0, $dBFC4.setGameCurrentCompany)(game, userControlledCompaniesPlaying[0]);
            // Skip simulate competitors
            data["skipSimulateCompetitors"] = true;
            // Reset game month increase
            if (!weeklyShow) {
                game.monthCount -= 1;
                if (game.monthCount < 0) {
                    game.monthCount = 11;
                    game.year -= 1;
                }
            }
        } else {
            // Check if all user companies at monthly event, for realYear increase
            let allAtMonthlyEvent = true;
            for (const y of userControlledCompanies)if ((await (0, $8A6FL.getCompanyLatestEvent)(y))?.weeklyShow) allAtMonthlyEvent = false;
            // Change status of all companies to 'playing', check for end of brand events
            for (let y of userControlledCompanies){
                y.turnStatus = "playing";
                // Increase realYear if first event of company and all user companies at monthly event
                let nextCompanyEvent = (await (0, $14eBR.Events).find({
                    "companyId": y.$loki
                }).reverse()).find((x)=>!x.temporaryEvent);
                if (allAtMonthlyEvent) {
                    let companyParentEvents = await (0, $8A6FL.getCompanyParentEvents)(y);
                    let nextEventParentEvent = await (0, $5ZsVo.getParentEventForEvent)(companyParentEvents, nextCompanyEvent);
                    if (nextEventParentEvent && nextEventParentEvent.$loki === companyParentEvents[0].$loki) y.realYear += 1;
                }
                // If end of brand events or no brand events, end turn
                let companyMainRoster = await (0, $8A6FL.getCompanyRosterByType)(y, "main");
                if (weeklyShow) {
                    let companyRosterBrands = await (0, $dl5u4.getRosterBrands)(companyMainRoster);
                    let companyBrandIndex = (0, $1Dp0h.getBrandIndexForWeeklyShow)(nextCompanyEvent, companyRosterBrands);
                    if (companyBrandIndex < 1) y.turnStatus = "ended";
                }
                // Set year for next event
                nextCompanyEvent.year = y.realYear;
                // Process negotiations
                let acceptedNegotiations = await (0, $3NAMH.filterOffersSentToCpuCompanies)(await (0, $9esFv.getCompanySentNegotiations)(y));
                for (let acceptedNegotiation of acceptedNegotiations)await (0, $3NAMH.processNegotiation)(acceptedNegotiation);
                if (!weeklyShow) {
                    let onTradeSuperstars = (await (0, $dl5u4.getRosterSuperstars)(companyMainRoster)).filter((x)=>x.activeEffect === "traded");
                    // Process superstars on trade
                    for (let superstar of onTradeSuperstars){
                        superstar.appearances -= 1;
                        if (superstar.appearances <= 0) {
                            // Transfer superstar
                            const originalRoster = await (0, $hBIDz.getSuperstarOriginalRoster)(superstar);
                            await (0, $dl5u4.addRosterSuperstars)(originalRoster, [
                                superstar
                            ]);
                            const vacatedChampionships = await (0, $5kTkA.vacateChampionships)({
                                superstar: superstar,
                                championships: await (0, $9esFv.getCompanyChampionships)(y),
                                month: month,
                                year: year
                            });
                            if (vacatedChampionships.length > 0) data["vacated"].push(...vacatedChampionships);
                            // Remove from factions/managers
                            await (0, $5kTkA.removeSuperstarFactionRelationships)(superstar, month, year);
                            await (0, $5kTkA.removeSuperstarManagerRelationships)(superstar);
                            // Reset other attributes
                            superstar.brandName = null;
                            superstar.activeEffect = null;
                            if (!superstar.partTimer) superstar.appearances = null;
                            data["tradeReturns"].push(superstar.name);
                        }
                    }
                    // Move/remove teams if trade ending
                    for (let superstar of onTradeSuperstars){
                        if (!superstar.appearances) for (let tagTeam of [
                            ...await (0, $hBIDz.getSuperstarTagTeams)(superstar)
                        ]){
                            let ts = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                            // Move team if all members were on trade together
                            if (ts.every((s)=>(0, $3E8Nt.objectInArray)(s, onTradeSuperstars) && !s.appearances)) await (0, $dl5u4.addRosterTagTeams)(await (0, $hBIDz.getSuperstarOriginalRoster)(superstar), [
                                tagTeam
                            ]);
                            else await (0, $ko5kE.removeTagTeam)(tagTeam);
                        }
                    }
                }
            }
            // If any user playing (when extra brand events)
            userControlledCompaniesPlaying = userControlledCompanies.filter((y)=>y.turnStatus === "playing");
            if (userControlledCompaniesPlaying.length) // Set next company with 'playing' status as current company
            (0, $dBFC4.setGameCurrentCompany)(game, userControlledCompaniesPlaying[0]);
            else {
                // Set game as current company
                game.currentCompanyId = null;
                // Change status of all companies to 'playing'
                for (let y of userControlledCompanies)y.turnStatus = "playing";
            }
            // Allow simulating competitors
            game.monthlySimulationRun = false;
        }
    }
    // Remove previous draft (e.g yearly draft created while simulating that wasn't run by user) todo test simulating
    let draft = await (0, $9esFv.getCompanyDraft)(company);
    if (draft) draft.ended = true;
    // Process yearly draft
    try {
        // Run after monthly event if weekly shows are present, otherwise run at monthly event
        if (company.settings["yearly_brand_draft_settings"] && Object.keys(company.settings["yearly_brand_draft_settings"]).length !== 0 && !weeklyShow) {
            let currentMonth = await (0, $8A6FL.getCurrentMonth)(company, parentEvents);
            await (0, $lueZ1.checkYearlyDraft)(company, currentMonth);
        }
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    // Process PoW story
    if (company.storyName === "passion") {
        let storyChoices = (await (0, $9esFv.getCompanyStoryChoices)(company)).reverse();
        // Get post event dialog
        data["postEventDialogs"] = (0, $jC7EP.getPowPostEventDialogs)(storyChoices, rosterSuperstars);
        // Process story choices
        await (0, $jC7EP.processPowStoryChoices)(storyChoices, company, latestEvent);
    }
    if (company.storyName === "tutorial") {
        // Force vacate titles if not vacated
        let tutorialState = await (0, $8A6FL.getTutorialStateName)(company);
        if (tutorialState === "end_first_event") {
            let s = rosterSuperstars.find((x)=>x.name === "Chris Gray");
            if (s) await (0, $5kTkA.vacateChampionships)({
                superstar: s,
                championships: companyChampionships,
                month: month,
                year: year
            });
        }
    }
    // Add form new company message
    if (!game.settings["control_multiple_companies"] && company.userControlled && !company.storyName && company.newCompanyData?.monthsToForm === undefined && companyYear === 3 && companyMonth === 0 && (await (0, $iRMwH.getGameActiveCompanies)(game)).length < (0, $3E8Nt.gameLimits).maxCompetitors + 1 && !weeklyShow) {
        let newMessage = await (0, $hekDR.createFormingNewCompanyPotentialMessage)((0, $8A6FL.generateFormNewCompanyOwnerName)(company), game.monthCount, game.year);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    }
    if (company.fans < 0) company.fans = 0;
    if (company.points < 0) company.points = 0;
    // Reset creative points in sandbox mode
    if (company.userControlled && game.settings["unlimited_creative_points"]) company.points = 100000000;
    // Add to user's events played
    user = (0, $bZol7.loadUser)();
    if (isMainCompany && !simulation && user) {
        user.eventsPlayed += 1;
        (0, $bZol7.saveUser)(user);
    }
    return data;
}
function $9f57f5c1301b7dbc$var$getPointsToAdd(rating, weeklyShow = false) {
    let pointsToAdd = 0;
    // Divide rating into 0.25 star divisions
    let divisions = Math.floor(rating / 0.25) + 1;
    // Add points for different rating integer levels
    for(let i = 0; i < divisions; i++){
        if (i <= 3) pointsToAdd += 1.5;
        else if (i <= 11) pointsToAdd += 3;
        else if (i <= 15) pointsToAdd += 10;
        else if (i <= 19) pointsToAdd += 22.5;
        else if (i <= 23) pointsToAdd += 30;
        else pointsToAdd += 30;
    }
    if (weeklyShow) pointsToAdd *= 0.5;
    return Math.floor(pointsToAdd);
}
function $9f57f5c1301b7dbc$var$getFansToAdd(rating, reputation, hype, weeklyShow = false) {
    if (reputation >= 10) reputation = 4;
    // Get fans to add
    let formulaRating = rating;
    let multiplier;
    if (formulaRating <= 3.0) {
        multiplier = -2;
        formulaRating = 4.25 - formulaRating;
    } else if (formulaRating <= 3.5) multiplier = 0.25;
    else if (formulaRating <= 4.5) multiplier = 0.5;
    else if (formulaRating <= 5) multiplier = 1;
    else multiplier = 2;
    let reputationMultiplier = 2 ** (reputation / 2);
    let hypeMultiplier = hype / 40 + 1;
    let fansToAdd = formulaRating ** 2 * multiplier * reputationMultiplier * hypeMultiplier * 20;
    if (weeklyShow) fansToAdd *= 0.3;
    return [
        (0, $3E8Nt.myround)(fansToAdd, 10),
        Math.round(hypeMultiplier * 10) / 10
    ];
}
function $9f57f5c1301b7dbc$var$getCompanyOvernessChange(eventRating, company) {
    const overnessDict = {
        0.0: -20,
        0.25: -20,
        0.50: -19,
        0.75: -18,
        1.0: -17,
        1.25: -16,
        1.50: -15,
        1.75: -13,
        2.0: -11,
        2.25: -10,
        2.50: -9,
        2.75: -8,
        3.0: -6,
        3.25: -4,
        3.50: 1,
        3.75: 2,
        4.0: 4,
        4.25: 6,
        4.50: 8,
        4.75: 10,
        5.0: 11,
        5.25: 12,
        5.50: 14,
        5.75: 15,
        6.0: 16
    };
    let overnessChange = overnessDict[eventRating] || 0;
    // Max overness
    if (eventRating >= 6) overnessChange = Math.max(...Object.values(overnessDict));
    // Reduce overness increase if hot, reduce decrease if stale
    if (company.hot) {
        if (overnessChange > 0) overnessChange /= 5;
        else overnessChange *= 3;
    }
    if (company.stale) {
        if (overnessChange < 0) overnessChange /= 4;
        else overnessChange *= 2;
    }
    return Math.floor(overnessChange);
}
function $9f57f5c1301b7dbc$var$getBrandOvernessChange(eventRating, brand) {
    const overnessDict = {
        0.0: -10,
        0.25: -10,
        0.50: -10,
        0.75: -9,
        1.0: -9,
        1.25: -8,
        1.50: -8,
        1.75: -7,
        2.0: -7,
        2.25: -6,
        2.50: -6,
        2.75: -5,
        3.0: -5,
        3.25: -4,
        3.50: -2,
        3.75: 2,
        4.0: 3,
        4.25: 4,
        4.50: 5,
        4.75: 6,
        5.0: 6,
        5.25: 7,
        5.50: 7,
        5.75: 8,
        6.0: 9
    };
    let overnessChange = overnessDict[eventRating] || 0;
    // Max overness
    if (eventRating >= 6) overnessChange = Math.max(...Object.values(overnessDict));
    // Reduce overness increase if hot, reduce decrease if stale
    if (brand.hot) {
        if (overnessChange > 0) overnessChange /= 3;
        else overnessChange *= 3;
    }
    if (brand.stale) {
        if (overnessChange < 0) overnessChange /= 3;
        else overnessChange *= 3;
    }
    return Math.floor(overnessChange);
}
async function $9f57f5c1301b7dbc$var$getMonthsPassedSinceChampionshipMatch(championship, companyChampionships, company, month, year, companyMonth, companyYear) {
    // Get latest match from current championship reign
    let latestMatch = null;
    let reign = await (0, $ivuOU.getChampionshipCurrentReign)(championship);
    if (reign) {
        let reignMatches = (await (0, $9MKdC.getChampionshipReignMatches)(reign)).reverse();
        if (reignMatches.length > 0) latestMatch = reignMatches[0];
    }
    let monthsPassed;
    if (latestMatch) {
        // Get monthly event of latest match
        let companyMonthlyEvents = (await (0, $9esFv.getCompanyEvents)(company)).filter((x)=>!x.weeklyShow).reverse();
        let matchEvent = await (0, $i7bmn.getMatchEvent)(latestMatch);
        let monthlyEvent = matchEvent.weeklyShow || matchEvent.name === "Weekly Show" ? companyMonthlyEvents.find((x)=>x.name === matchEvent.monthlyEventName) : matchEvent;
        // Get months passed since monthly event
        monthsPassed = companyMonthlyEvents.indexOf(monthlyEvent);
        if (monthsPassed === -1) monthsPassed = 0;
    } else {
        // If new championship, get months passed after championship created
        let championshipLog = (await (0, $9esFv.getCompanyCompanyLogs)(company)).find((x)=>x.type === "new-championship" && x.text === championship.name);
        if (championshipLog) monthsPassed = (0, $3E8Nt.getMonthsDifference)(month, year, championshipLog.month, championshipLog.realYear);
        else monthsPassed = companyMonth + companyYear * 12;
    }
    return monthsPassed;
}
function $9f57f5c1301b7dbc$var$getNotUsedPopularityDecrease(superstar) {
    let popularityDecrease = superstar.popularity * 0.035;
    if (superstar.faceOfTheCompany) popularityDecrease *= 2.5;
    if (superstar.partTimer) popularityDecrease /= 2.5;
    if (superstar.popularity - popularityDecrease < 800) popularityDecrease += 25;
    return (0, $3E8Nt.myround)(popularityDecrease, 5);
}
function $9f57f5c1301b7dbc$var$getMatchContractNotHeldPenalty(reputation) {
    return (0, $3E8Nt.myround)(reputation ** 2 * 25, 10);
}
async function $9f57f5c1301b7dbc$var$updateInjured(superstars, doctors, company) {
    const data = {
        available: [],
        rehabbed: [],
        staffSkillIncreases: []
    };
    const game = await (0, $9esFv.getCompanyGame)(company);
    for (const superstar of superstars)if (superstar.injured >= 1) {
        // Get doctor
        let doctor = null;
        const assignedDoctor = (0, $8ugbL.getTalentRehabDoctor)(superstar, doctors);
        if (assignedDoctor) doctor = assignedDoctor;
        else if (doctors.length > 0) doctor = (0, $8A6FL.getHighestLevelStaffMemberByRole)(doctors, "doctor");
        // Don't update superstar injured at latest show
        if (superstar.injuredAtLatestShow) {
            superstar.injuredAtLatestShow = false;
            continue;
        }
        let monthsRecovered = 1;
        const startingMonths = superstar.injured;
        // Check to add rehab if doctor assigned (don't add for kayfabe injuries)
        let rehabPerformed = false;
        const oldTime = (0, $5kTkA.getInjuryReturnTime)(superstar, doctor);
        if (superstar.injured >= 3 && superstar.injuryName && assignedDoctor) {
            // Check doctor and facility level
            const medicalFacility = (await (0, $9esFv.getCompanyFacilities)(company)).find((x)=>x.name === "Medical");
            if (doctor && doctor.level >= 2 && medicalFacility && medicalFacility.level >= 2) {
                const rehabChance = (0, $8ugbL.getRehabChance)(doctor, medicalFacility);
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= rehabChance) {
                    rehabPerformed = true;
                    monthsRecovered += 1;
                    // Add doctor xp
                    const ageMultiplier = (0, $8A6FL.getStaffAgeMultiplier)(doctor);
                    const doctorXpGained = Math.round(5 * ageMultiplier);
                    const doctorLevelIncrease = await (0, $8A6FL.updateStaffMemberXp)(doctor, doctorXpGained, company, game);
                    if (doctorLevelIncrease) data["staffSkillIncreases"].push({
                        name: doctor.name,
                        level: doctor.level,
                        role: doctor.role
                    });
                    data["rehabbed"].push({
                        name: superstar.name,
                        doctorXpGained: doctorXpGained,
                        doctorName: doctor.name,
                        doctorAgeMultiplier: ageMultiplier
                    });
                }
            }
        }
        // Update injury and return timeline
        superstar.injured -= monthsRecovered;
        if (superstar.injuryReturnMin && superstar.injuryReturnMax) {
            superstar.injuryReturnMin -= monthsRecovered;
            superstar.injuryReturnMax -= monthsRecovered;
        }
        if (superstar.injuryReturnMin <= 0) superstar.injuryReturnMin = 1;
        if (superstar.injuryReturnMax <= 1) superstar.injuryReturnMax = 2;
        const newTime = (0, $5kTkA.getInjuryReturnTime)(superstar, doctor);
        // Re-evaluate injury when passing month 10 and month 6
        if (superstar.injuryName) {
            if ($9f57f5c1301b7dbc$var$checkToReevaluateInjury(startingMonths, superstar.injured, doctor)) {
                const injuryTime = (0, $5kTkA.evaluateInjury)(superstar, doctor);
                const injuryData = {
                    name: superstar.name.trim(),
                    time: injuryTime,
                    injuryName: superstar.injuryName,
                    oldTime: oldTime,
                    rehabPerformed: rehabPerformed
                };
                if (company.userControlled) {
                    const newMessage = await (0, $hekDR.createInjuryReevaluatedMessage)(injuryData, doctor, game.monthCount, game.year);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            } else if (rehabPerformed) {
                const injuryData = {
                    name: superstar.name.trim(),
                    rehabPerformed: rehabPerformed,
                    injuryName: superstar.injuryName,
                    oldTime: oldTime,
                    newTime: newTime
                };
                if (company.userControlled) {
                    const newMessage = await (0, $hekDR.createInjuryRehabMessage)(injuryData, doctor, game.monthCount, game.year);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
        }
        // Decrease popularity if injury (i.e not kayfabe injury)
        if (superstar.injuryName) {
            if (superstar.popularity < 1000) superstar.popularity -= 10;
            else superstar.popularity -= 5;
        }
        if (superstar.injured === 0) {
            // If not kayfabe or workable injury
            if (superstar.injuryName && !superstar.workableInjury) {
                const increase = (0, $3E8Nt.getRandomInt)(25, 50);
                (0, $5kTkA.updateSuperstarPopularity)(superstar, increase);
                // Add actions completed (Injuries Recovered)
                if ((0, $98xmD.globalUser).paid && ![
                    "minor injury",
                    "major injury"
                ].includes(superstar.injuryName)) await (0, $8A6FL.checkFacilityUpgrade)("Medical", company);
            }
            data["available"].push({
                superstar: superstar,
                workableInjury: superstar.workableInjury
            });
            (0, $5kTkA.endSuperstarInjury)(superstar);
        }
    }
    return data;
}
function $9f57f5c1301b7dbc$var$checkToReevaluateInjury(startingMonths, endingMonths, doctor) {
    // Don't reevaluate if doctor level is 3 or higher, as they give accurate months
    if (doctor && doctor.level >= 3) return false;
    else if (endingMonths < 10 && startingMonths >= 10) return true;
    else if (endingMonths < 6 && startingMonths >= 6) return true;
    return false;
}

});
parcelRequire.register("1Dp0h", function(module, exports) {

$parcel$export(module.exports, "getViewBrandsData", () => $130cd41e9fc45958$export$9e870ef9ff569cd4);
$parcel$export(module.exports, "getBrandColorForEvent", () => $130cd41e9fc45958$export$9a87e9043ca89528);
$parcel$export(module.exports, "getBrandForEvent", () => $130cd41e9fc45958$export$3e576c71ccae6726);
$parcel$export(module.exports, "getBrandIndexForWeeklyShow", () => $130cd41e9fc45958$export$950cd7614a647372);
$parcel$export(module.exports, "setObjectBrand", () => $130cd41e9fc45958$export$7df4609343698ac9);
$parcel$export(module.exports, "removeObjectBrand", () => $130cd41e9fc45958$export$8bbe2af4b55705fb);
$parcel$export(module.exports, "getAddBrandSelections", () => $130cd41e9fc45958$export$d57505f12b1f05a5);
$parcel$export(module.exports, "addOrEditBrand", () => $130cd41e9fc45958$export$c04d40997469dcd0);
$parcel$export(module.exports, "removeBrand", () => $130cd41e9fc45958$export$46ffe99e66c6ddb0);
$parcel$export(module.exports, "runBrandDraft", () => $130cd41e9fc45958$export$515077a57872ad70);
$parcel$export(module.exports, "saveYearlyBrandDraftSettings", () => $130cd41e9fc45958$export$a93c09796dd5758a);
$parcel$export(module.exports, "getBrandDraftSelectionsData", () => $130cd41e9fc45958$export$d21257dd806ad506);
$parcel$export(module.exports, "getBrandsDataForSegment", () => $130cd41e9fc45958$export$1d8351515011eb29);
$parcel$export(module.exports, "draftSuperstarToBrand", () => $130cd41e9fc45958$export$98207dd0717937ae);

var $98xmD = parcelRequire("98xmD");

var $3E8Nt = parcelRequire("3E8Nt");

var $14eBR = parcelRequire("14eBR");

var $iRMwH = parcelRequire("iRMwH");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $9esFv = parcelRequire("9esFv");

var $kZwpB = parcelRequire("kZwpB");

var $5kTkA = parcelRequire("5kTkA");

var $4K85d = parcelRequire("4K85d");

var $8LLPX = parcelRequire("8LLPX");

var $1olyO = parcelRequire("1olyO");

var $lueZ1 = parcelRequire("lueZ1");
async function $130cd41e9fc45958$export$9e870ef9ff569cd4(companyUid) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get main roster's superstars, company championships and parent events
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const mainRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(selectedCompany);
    // Get brands data
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    return rosterBrands.map((x)=>$130cd41e9fc45958$var$getBrandData(x, mainRosterSuperstars, parentEvents, companyChampionships));
}
function $130cd41e9fc45958$var$getBrandData(brand, rosterSuperstars, parentEvents, companyChampionships) {
    let data = {};
    // Get attributes
    data["name"] = brand.name;
    data["uid"] = brand.$loki;
    data["weeklyShowName"] = brand.weeklyShowName;
    data["weeklyShowIsExclusive"] = brand.weeklyShowIsExclusive;
    data["color"] = brand.color;
    data["overness"] = brand.overness;
    data["hot"] = brand.hot;
    data["stale"] = brand.stale;
    // Get brand objects
    const brandSuperstars = rosterSuperstars.filter((x)=>x.brandName === brand.name);
    brandSuperstars.sort((a, b)=>b.popularity - a.popularity);
    const brandChampionships = (0, $kZwpB.getUniqueChampionships)(companyChampionships.filter((x)=>x.brandName === brand.name));
    brandChampionships.sort((0, $kZwpB.compareChampionships));
    const brandEvents = parentEvents.filter((x)=>x.brandName === brand.name);
    // Get data for brand objects
    data["superstars"] = brandSuperstars.map((x)=>({
            "name": x.name
        }));
    data["championships"] = brandChampionships.map((x)=>({
            "name": x.name,
            "prestige": x.prestige
        }));
    data["events"] = brandEvents.map((x)=>({
            "name": x.name,
            "prestige": x.prestige
        }));
    return data;
}
function $130cd41e9fc45958$export$9a87e9043ca89528(event, rosterBrands) {
    const brand = $130cd41e9fc45958$export$3e576c71ccae6726(event, rosterBrands);
    if (brand) return brand.color;
    return null;
}
function $130cd41e9fc45958$var$getBrandColorFromBrandName(brandName, rosterBrands) {
    const brand = rosterBrands.find((x)=>x.name === brandName);
    if (brand) return brand.color;
    return null;
}
function $130cd41e9fc45958$export$3e576c71ccae6726(event, rosterBrands) {
    if (event.weeklyShow) return rosterBrands.find((x)=>x.weeklyShowName === event.name);
    else return rosterBrands.find((x)=>x.name === event.brandName);
}
function $130cd41e9fc45958$export$950cd7614a647372(event, rosterBrands) {
    // Get index of current event (weekly show) using weekly show names of roster brands
    const brandIndex = null;
    const brandWeeklyShowNames = rosterBrands.map((x)=>x.weeklyShowName);
    if (brandWeeklyShowNames.indexOf(event.name) >= 0) return brandWeeklyShowNames.indexOf(event.name);
    return brandIndex;
}
function $130cd41e9fc45958$export$7df4609343698ac9(brandObject, brandName) {
    // Set brand name for superstars, championships and events
    if ([
        "superstar",
        "championship",
        "event"
    ].indexOf(brandObject.objectName) >= 0) brandObject.brandName = brandName;
}
function $130cd41e9fc45958$export$8bbe2af4b55705fb(brandObject) {
    // Remove brand name for superstars, championships and events
    if ([
        "superstar",
        "championship",
        "event"
    ].indexOf(brandObject.objectName) >= 0) brandObject.brandName = null;
}
async function $130cd41e9fc45958$export$d57505f12b1f05a5() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(selectedCompany);
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const ranks = {
        "Main Eventer": 4,
        "Upper Midcarder": 3,
        "Lower Midcarder": 2,
        "Jabroni": 1
    };
    // Get superstars
    data["superstars"] = rosterSuperstars.map((x)=>{
        const brandColor = $130cd41e9fc45958$var$getBrandColorFromBrandName(x.brandName, rosterBrands);
        const championships = (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(x, companyChampionships);
        const championshipNames = championships.map((y)=>y.name);
        return {
            "name": x.name,
            "popularity": x.popularity,
            "age": x.age,
            "retired": x.retired,
            "brandName": x.brandName,
            "uid": x.$loki,
            "appearances": x.partTimer ? x.appearances : null,
            "injured": x.injured > 0 ? x.injured : false,
            "fullTimeManager": x.fullTimeManager,
            "championshipNames": championshipNames,
            "brandColor": brandColor
        };
    });
    data["superstars"].sort((a, b)=>b.popularity - a.popularity);
    // Get championships
    const uniqueChampionships = (0, $kZwpB.getUniqueChampionships)(companyChampionships);
    data["championships"] = uniqueChampionships.map((x)=>{
        const brandColor = $130cd41e9fc45958$var$getBrandColorFromBrandName(x.brandName, rosterBrands);
        return {
            "name": x.name,
            "rank": x.rank,
            "prestige": x.prestige,
            "brandName": x.brandName,
            "uid": x.$loki,
            "brandColor": brandColor
        };
    });
    data["championships"].sort((a, b)=>ranks[b.rank] - ranks[a.rank]);
    // Get events
    data["events"] = parentEvents.map((x)=>{
        const brandColor = $130cd41e9fc45958$var$getBrandColorFromBrandName(x.brandName, rosterBrands);
        return {
            "name": x.name,
            "prestige": x.prestige,
            "brandName": x.brandName,
            "uid": x.$loki,
            "brandColor": brandColor
        };
    });
    data["events"].sort((a, b)=>ranks[b.rank] - ranks[a.rank]);
    return data;
}
async function $130cd41e9fc45958$export$c04d40997469dcd0(brandName, weeklyShowName, weeklyShowIsExclusive, brandColor, superstarUids, eventUids, championshipUids, edit, brandUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(selectedCompany);
    const currentEvent = await (0, $8A6FL.getCompanyLatestEvent)(selectedCompany);
    const competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(selectedCompany, currentGame);
    let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const competitorMainRosters = (await Promise.all(competitors.map((x)=>(0, $8A6FL.getCompanyRosterByType)(x, "main")))).flat();
    const competitorBrands = (await Promise.all(competitorMainRosters.map((x)=>(0, $dl5u4.getRosterBrands)(x)))).flat();
    const maxBrands = 3;
    // Get cost
    let cost = 50;
    if (!edit) {
        if (rosterBrands.length > 0) cost = 100;
        else cost = 0;
    }
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "not-paid";
        return data;
    }
    // Check points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Check for story
    if ([
        "mars",
        "passion"
    ].indexOf(selectedCompany.storyName) >= 0) {
        data["error"] = selectedCompany.storyName;
        return data;
    }
    // Check for max brands
    if (!edit && rosterBrands.length + 1 > maxBrands) {
        data["error"] = "max-brands";
        return data;
    }
    // Get brand if editing
    let brand;
    if (edit) {
        brand = await (0, $14eBR.Brands).get(brandUid);
        if (!brand) {
            data["error"] = "brand-not-found";
            return data;
        }
    }
    // Check brand name uniqueness
    let brandNamesToCheck = rosterBrands.concat(competitorBrands).map((x)=>x.name);
    if (edit) brandNamesToCheck = brandNamesToCheck.filter((x)=>x !== brand.name);
    if (brandNamesToCheck.indexOf(brandName) >= 0) {
        data["error"] = "brand-name-exists";
        return data;
    }
    // Check weekly show name uniqueness (against all brands and competitors' weekly shows)
    weeklyShowName = weeklyShowName ? weeklyShowName : brandName;
    let weeklyShowNamesToCheck = rosterBrands.concat(competitorBrands).map((x)=>x.weeklyShowName);
    weeklyShowNamesToCheck.push(...competitors.filter((x)=>x.weeklyShowName).map((x)=>x.weeklyShowName));
    if (edit) weeklyShowNamesToCheck = weeklyShowNamesToCheck.filter((x)=>x !== brand.weeklyShowName);
    if (weeklyShowNamesToCheck.indexOf(weeklyShowName) >= 0) {
        data["error"] = "weekly-show-name-exists";
        return data;
    }
    // Get brand objects
    const brandSuperstars = $130cd41e9fc45958$var$getBrandObjectsFromUids(superstarUids, rosterSuperstars);
    const brandEvents = $130cd41e9fc45958$var$getBrandObjectsFromUids(eventUids, parentEvents);
    let brandChampionships = $130cd41e9fc45958$var$getBrandObjectsFromUids(championshipUids, companyChampionships);
    brandChampionships = companyChampionships.filter((x)=>brandChampionships.some((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, y)));
    brandColor = brandColor ? brandColor : null;
    if (edit) // Edit brand
    brand = await $130cd41e9fc45958$var$editBrand(brand, brandName, weeklyShowName, weeklyShowIsExclusive, brandColor, rosterSuperstars, parentEvents, companyChampionships, brandSuperstars, brandEvents, brandChampionships, currentEvent, selectedCompany, currentGame);
    else {
        // Create brand
        brand = await $130cd41e9fc45958$var$createBrand(brandName, weeklyShowName, weeklyShowIsExclusive, brandColor, brandSuperstars, brandEvents, brandChampionships, currentEvent, mainRoster);
        // Add company log
        const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, selectedCompany.realYear);
        (0, $14eBR.CompanyLogs).insert(newCompanyLog);
        newCompanyLog.text = brand.name;
        newCompanyLog.type = "brand-created";
        newCompanyLog.realYear = currentGame.year;
        await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
            newCompanyLog
        ]);
    }
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["brandName"] = brand.name;
    data["currentEvent"] = {};
    data["currentEvent"]["name"] = currentEvent.name;
    data["currentEvent"]["brandName"] = currentEvent.brandName;
    data["currentEvent"]["weeklyShow"] = currentEvent.weeklyShow;
    rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    data["currentEvent"]["brandColor"] = $130cd41e9fc45958$export$9a87e9043ca89528(currentEvent, rosterBrands);
    return data;
}
function $130cd41e9fc45958$var$getBrandObjectsFromUids(uids, objects) {
    let brandObjects = [];
    for (const uid of uids){
        const brandObject = objects.find((x)=>x.$loki === uid);
        if (brandObject) brandObjects.push(brandObject);
    }
    return brandObjects;
}
async function $130cd41e9fc45958$var$createBrand(name, weeklyShowName, weeklyShowIsExclusive, color, superstars, events, championships, currentEvent, roster) {
    const brand = (0, $8LLPX.Brand)();
    brand.name = name;
    brand.weeklyShowName = weeklyShowName;
    brand.weeklyShowIsExclusive = weeklyShowIsExclusive;
    brand.color = color;
    (0, $14eBR.Brands).insert(brand);
    // Add brand name to objects
    for (const x of [
        ...superstars,
        ...events,
        ...championships
    ])$130cd41e9fc45958$export$7df4609343698ac9(x, name);
    // Add brand name to current monthly event if part of brand events
    if (!currentEvent.weeklyShow) {
        if (events.map((x)=>x.name).indexOf(currentEvent.name) >= 0) $130cd41e9fc45958$export$7df4609343698ac9(currentEvent, name);
    } else if (currentEvent.name === weeklyShowName) {
        currentEvent.name = weeklyShowName;
        if (weeklyShowIsExclusive) $130cd41e9fc45958$export$7df4609343698ac9(currentEvent, name);
    }
    // Add to roster
    await (0, $dl5u4.addRosterBrands)(roster, [
        brand
    ]);
    return brand;
}
async function $130cd41e9fc45958$var$editBrand(brand, name, weeklyShowName, weeklyShowIsExclusive, color, rosterSuperstars, parentEvents, companyChampionships, brandSuperstars, brandEvents, brandChampionships, currentEvent, company, currentGame) {
    // Set/remove brand name from objects
    for (const x of [
        ...rosterSuperstars,
        ...parentEvents,
        ...companyChampionships
    ]){
        if (x.objectName === "superstar" && (0, $3E8Nt.objectInArray)(x, brandSuperstars) || x.objectName === "event" && (0, $3E8Nt.objectInArray)(x, brandEvents) || x.objectName === "championship" && (0, $3E8Nt.objectInArray)(x, brandChampionships)) {
            $130cd41e9fc45958$export$7df4609343698ac9(x, name);
            if ((0, $3E8Nt.objectInArray)(x, brandSuperstars)) {
                // Check talent request
                let requestData = {
                    "brandId": brand.$loki
                };
                await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "change_brand",
                    talent: x,
                    data: requestData
                });
            }
        } else if (x.brandName === brand.name) $130cd41e9fc45958$export$8bbe2af4b55705fb(x);
    }
    // Add brand name to current monthly event if part of brand events
    if (!currentEvent.weeklyShow) {
        if (brandEvents.map((x)=>x.name).indexOf(currentEvent.name) >= 0) $130cd41e9fc45958$export$7df4609343698ac9(currentEvent, name);
        else if (currentEvent.brandName === brand.name) $130cd41e9fc45958$export$8bbe2af4b55705fb(currentEvent);
    } else if (currentEvent.name === brand.weeklyShowName) {
        currentEvent.name = weeklyShowName;
        if (weeklyShowIsExclusive) $130cd41e9fc45958$export$7df4609343698ac9(currentEvent, name);
        else $130cd41e9fc45958$export$8bbe2af4b55705fb(currentEvent);
    }
    // Edit brand attributes
    const previousName = brand.name;
    const previousWeeklyShowName = brand.weeklyShowName;
    brand.name = name;
    brand.weeklyShowName = weeklyShowName;
    brand.weeklyShowIsExclusive = weeklyShowIsExclusive;
    brand.color = color;
    // Lower overness if name or weekly show name changed
    if (name !== previousName || previousWeeklyShowName !== weeklyShowName) (0, $8A6FL.updateObjectOverness)(brand, -10);
    // Save to local storage
    await (0, $iRMwH.saveGameDataToLocalStorage)(currentGame);
    return brand;
}
async function $130cd41e9fc45958$export$46ffe99e66c6ddb0(brandUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(selectedCompany);
    const currentEvent = await (0, $8A6FL.getCompanyLatestEvent)(selectedCompany);
    let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    // Get brand
    let brand = await (0, $14eBR.Brands).get(brandUid);
    if (!brand) {
        data["error"] = "brand-not-found";
        return data;
    }
    // Don't allow if at weekly show (can cause conflicts with brand index)
    if (currentEvent.weeklyShow || currentEvent.name === "Weekly Show") {
        data["error"] = "at-weekly-show";
        return data;
    }
    // Remove brand from roster
    await (0, $dl5u4.removeRosterBrands)(mainRoster, [
        brand
    ]);
    // Remove brand name from brand objects
    for (const x of [
        ...rosterSuperstars,
        ...parentEvents,
        ...companyChampionships
    ])if (x.brandName === brand.name) $130cd41e9fc45958$export$8bbe2af4b55705fb(x);
    // Remove brand name from current event if added
    if (!currentEvent.weeklyShow) {
        if (currentEvent.brandName === brand.name) $130cd41e9fc45958$export$8bbe2af4b55705fb(currentEvent);
    }
    // Delete brand
    const brandName = brand.name;
    (0, $14eBR.Brands).remove(brand);
    // Add company log
    const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, selectedCompany.realYear);
    (0, $14eBR.CompanyLogs).insert(newCompanyLog);
    newCompanyLog.text = brand.name;
    newCompanyLog.type = "brand-removed";
    newCompanyLog.realYear = currentGame.year;
    await (0, $9esFv.addCompanyCompanyLogs)(selectedCompany, [
        newCompanyLog
    ]);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["brandName"] = brandName;
    data["currentEvent"] = {};
    data["currentEvent"]["name"] = currentEvent.name;
    data["currentEvent"]["brandName"] = currentEvent.brandName;
    data["currentEvent"]["weeklyShow"] = currentEvent.weeklyShow;
    data["currentEvent"]["brandColor"] = $130cd41e9fc45958$export$9a87e9043ca89528(currentEvent, rosterBrands);
    return data;
}
async function $130cd41e9fc45958$export$515077a57872ad70(brandDraftSettings) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const cost = brandDraftSettings["type"] === "full" ? 100 : 50;
    // Check if user is paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "not-paid";
        return data;
    }
    // Check points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Get brands
    let brands = [];
    for (let brandUid of brandDraftSettings["brandUids"]){
        let brand = await (0, $14eBR.Brands).get(brandUid);
        if (!brand || !(0, $3E8Nt.objectInArray)(brand, rosterBrands)) {
            data["error"] = "brand-not-found";
            return data;
        }
        brands.push(brand);
    }
    // Check brands are present
    if (!brands.length) {
        data["error"] = "no-brands-present";
        return data;
    }
    // Create draft event
    let draft = await (0, $lueZ1.createBrandDraft)(selectedCompany, brands, brandDraftSettings["type"], await (0, $dl5u4.getRosterSuperstars)(mainRoster));
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["draftData"] = await (0, $lueZ1.getDraftData)(draft, selectedCompany);
    data["points"] = selectedCompany.points;
    return data;
}
async function $130cd41e9fc45958$export$a93c09796dd5758a(yearlyBrandDraftSettings) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Update settings
    if (yearlyBrandDraftSettings["run"]) selectedCompany.settings["yearly_brand_draft_settings"] = yearlyBrandDraftSettings;
    else selectedCompany.settings["yearly_brand_draft_settings"] = {};
    (0, $14eBR.db).saveDatabase();
    return data;
}
async function $130cd41e9fc45958$export$d21257dd806ad506() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    data["brands"] = rosterBrands.map((x)=>{
        return {
            "name": x.name,
            "color": x.color,
            "uid": x.$loki
        };
    });
    data["yearlyBrandDraftSettings"] = selectedCompany.settings["yearly_brand_draft_settings"];
    return data;
}
async function $130cd41e9fc45958$export$1d8351515011eb29() {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
    // Get brands data
    data["brands"] = rosterBrands.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    // Get talent data
    data["talent"] = rosterSuperstars.filter((x)=>!x.fullTimeManager).map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki,
            "type": "superstar"
        };
    });
    data["talent"].push(...rosterTagTeams.filter((x)=>!x.temporary).map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki,
            "type": "team"
        };
    }));
    data["talent"].sort((a, b)=>a.name.localeCompare(b.name));
    return data;
}
function $130cd41e9fc45958$export$98207dd0717937ae(superstar, brand, companyChampionships) {
    // Move superstar to brand
    superstar.brandName = brand;
    // Move superstar's championships to brand
    let superstarChampionships = companyChampionships.filter((x)=>x.superstarId === superstar.$loki);
    superstarChampionships = companyChampionships.filter((x)=>superstarChampionships.some((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, y))); // Get team titles
    for (let championship of superstarChampionships)championship.brandName = brand;
    return superstar.brandName;
}

});
parcelRequire.register("lueZ1", function(module, exports) {

$parcel$export(module.exports, "createDraft", () => $fa4805b13bc43baf$export$3c3214997190395f);
$parcel$export(module.exports, "createCustomCompanyDraft", () => $fa4805b13bc43baf$export$d369814c9a4a298a);
$parcel$export(module.exports, "getDraftData", () => $fa4805b13bc43baf$export$b3b48bb36d0e886f);
$parcel$export(module.exports, "checkYearlyDraft", () => $fa4805b13bc43baf$export$b524b92794d1f0b);
$parcel$export(module.exports, "createBrandDraft", () => $fa4805b13bc43baf$export$e4e4aed659c3c9db);
$parcel$export(module.exports, "getDraftSuperstarInfo", () => $fa4805b13bc43baf$export$3298e1f2da5d9d38);
$parcel$export(module.exports, "addUserDraftPick", () => $fa4805b13bc43baf$export$571175a8786a20e7);
$parcel$export(module.exports, "processDraftPick", () => $fa4805b13bc43baf$export$a6abb59131f55816);
$parcel$export(module.exports, "addBrandDraftPick", () => $fa4805b13bc43baf$export$663cc773a4cae79);
$parcel$export(module.exports, "simulateDraftPicks", () => $fa4805b13bc43baf$export$e4be05925f55df79);
$parcel$export(module.exports, "skipBrandDraftTurn", () => $fa4805b13bc43baf$export$8c0a1b2c634c7f00);
$parcel$export(module.exports, "endBrandDraftTurn", () => $fa4805b13bc43baf$export$ea26ea19139a1a70);
$parcel$export(module.exports, "endDraftTurn", () => $fa4805b13bc43baf$export$f66df47a232745a5);

var $98xmD = parcelRequire("98xmD");

var $8A6FL = parcelRequire("8A6FL");

var $1Dp0h = parcelRequire("1Dp0h");

var $hekDR = parcelRequire("hekDR");

var $9esFv = parcelRequire("9esFv");

var $3ZjYr = parcelRequire("3ZjYr");

var $14eBR = parcelRequire("14eBR");

var $dl5u4 = parcelRequire("dl5u4");

var $5kTkA = parcelRequire("5kTkA");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $hBIDz = parcelRequire("hBIDz");

var $1olyO = parcelRequire("1olyO");

var $5yA6U = parcelRequire("5yA6U");

var $972Ip = parcelRequire("972Ip");

var $jpMCP = parcelRequire("jpMCP");
async function $fa4805b13bc43baf$export$3c3214997190395f(mainUserCompany, companies) {
    // Create draft event, add to company
    let draft = (0, $3ZjYr.Draft)();
    (0, $14eBR.Drafts).insert(draft);
    draft.name = "Roster Draft";
    await (0, $3ZjYr.addDraftCompanies)(draft, [
        mainUserCompany
    ]);
    // Get rosters to add for draft
    let rosters = [];
    for (let company of companies)rosters.push(await (0, $8A6FL.getCompanyRosterByType)(company, "main"));
    // Add rosters to draft
    await (0, $3ZjYr.addDraftRosters)(draft, rosters);
    // Randomize roster order, add to rosters list
    (0, $3E8Nt.shuffle)(rosters);
    draft.rosterPickOrderIds = rosters.map((x)=>x.$loki);
    // Set first pick roster
    (0, $3ZjYr.setDraftCurrentPickRoster)(draft, rosters[0]);
    // Set draft result
    let result = {};
    for (let roster of rosters)result[await $fa4805b13bc43baf$var$getRosterCompanyName(roster)] = [];
    draft.result = result;
    return draft;
}
async function $fa4805b13bc43baf$export$d369814c9a4a298a(mainUserCompany, draftSettings) {
    // Create draft event, add to company
    let draft = (0, $3ZjYr.Draft)();
    await (0, $14eBR.Drafts).insert(draft);
    draft.name = "Custom Company Draft";
    draft.type = "user_only";
    draft.settings = draftSettings;
    await (0, $3ZjYr.addDraftCompanies)(draft, [
        mainUserCompany
    ]);
    // Add main roster to draft
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(mainUserCompany, "main");
    await (0, $3ZjYr.addDraftRosters)(draft, [
        mainRoster
    ]);
    draft.rosterPickOrderIds = [
        mainRoster.$loki
    ];
    (0, $3ZjYr.setDraftCurrentPickRoster)(draft, mainRoster);
    // Set draft result
    let result = {};
    result[mainUserCompany.name] = [];
    draft.result = result;
    return draft;
}
async function $fa4805b13bc43baf$export$b3b48bb36d0e886f(draft, company) {
    let data = {};
    let game = await (0, $9esFv.getCompanyGame)(company);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    let companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    if (draft.type === "user_only") {
        const competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game);
        const competitorChampionships = (await Promise.all(competitors.map((x)=>(0, $9esFv.getCompanyChampionships)(x)))).flat();
        companyChampionships.push(...competitorChampionships);
    }
    data["result"] = JSON.parse(JSON.stringify(draft.result));
    data["ended"] = draft.ended;
    data["name"] = draft.name;
    data["type"] = draft.type;
    data["settings"] = draft.settings;
    data["uid"] = draft.$loki;
    // Get available/unavailable picks
    let { availableSuperstars: availableSuperstars, unavailableSuperstars: unavailableSuperstars } = await $fa4805b13bc43baf$var$getPicksForDraft(draft, game, company, mainCompany);
    let sortedPicks = [
        ...availableSuperstars,
        ...unavailableSuperstars
    ].sort((a, b)=>b.popularity - a.popularity);
    // Get picks data
    data["picksData"] = sortedPicks.map((x)=>{
        return {
            "name": x.name,
            "popularity": x.popularity,
            "age": x.age,
            "uid": x.$loki,
            "partTimer": x.partTimer,
            "retired": x.retired,
            "injured": x.injured > 0,
            "fullTimeManager": x.fullTimeManager,
            "championships": (0, $5kTkA.getSuperstarChampionshipsAll)(x, companyChampionships),
            "unavailable": (0, $3E8Nt.objectInArray)(x, unavailableSuperstars)
        };
    });
    // Get brands/rosters
    if (draft.brands.length || draft.currentPickBrand) {
        data["brands"] = [
            ...draft.brands
        ];
        data["currentPickBrand"] = draft.currentPickBrand;
        data["isBrandDraft"] = true;
        let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
        let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
        data["brandColors"] = {};
        for (let x of rosterBrands)data["brandColors"][x.name] = x.color;
    } else {
        data["rosters"] = [];
        for (let x of draft.rosterPickOrderIds)data["rosters"].push(await $fa4805b13bc43baf$var$getRosterCompanyName(await (0, $14eBR.Rosters).get(x)));
        const currentPickRoster = await (0, $3ZjYr.getDraftCurrentPickRoster)(draft);
        data["currentPickCompany"] = await $fa4805b13bc43baf$var$getRosterCompanyName(currentPickRoster);
        data["playerNames"] = {};
        let userControlledCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
        for (let x of userControlledCompanies)data["playerNames"][x.name] = x.playerName;
        data["isBrandDraft"] = false;
        if (draft.type === "user_only") data["rosterCapacity"] = await (0, $8A6FL.getCompanyRosterCapacity)(company, game);
    }
    return data;
}
async function $fa4805b13bc43baf$var$getRosterCompanyName(roster) {
    const rosterCompany = await (0, $dl5u4.getRosterCompany)(roster);
    return rosterCompany.name;
}
async function $fa4805b13bc43baf$var$getPicksForDraft(draft, game, company, mainCompany) {
    // Return object of {availablePicks, unavailablePicks}
    let availableSuperstars = [];
    let unavailableSuperstars = [];
    if (draft.brands.length) {
        // Get main roster superstars
        let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
        if (draft.type === "shuffle") {
            // If 'shuffle' type draft, don't get superstars from current pick brand
            availableSuperstars = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>x.brandName !== draft.currentPickBrand);
            // Exclude already picked superstars
            let alreadyPickedNames = [
                ...Object.values(draft.result)
            ].flat();
            availableSuperstars = availableSuperstars.filter((x)=>!alreadyPickedNames.includes(x.name));
        } else // If 'full' type draft, get superstars who aren't assigned to a brand
        availableSuperstars = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>!x.brandName);
    } else // For user only draft (custom company), get competitor/indie superstars based on draft settings
    if (draft.type === "user_only") {
        // Get superstars from indie roster
        if (draft.settings["includeIndies"]) {
            let indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
            availableSuperstars.push(...await (0, $dl5u4.getRosterSuperstars)(indieRoster));
        }
        // Get competitor superstars
        if (draft.settings["includeCompanyRosters"]) {
            let competitorsSuperstars = [];
            for (let competitor of (await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game))){
                let rosters = (await (0, $9esFv.getCompanyRosters)(competitor)).filter((x)=>[
                        "main",
                        "training"
                    ].includes(x.type));
                for (let roster of rosters)competitorsSuperstars.push(...await (0, $dl5u4.getRosterSuperstars)(roster));
            }
            // Get protected picks
            if (draft.settings["protectCompanyTalent"]) {
                if (draft.protectedSuperstarsIds.length) unavailableSuperstars = competitorsSuperstars.filter((x)=>draft.protectedSuperstarsIds.includes(x.$loki));
                else {
                    unavailableSuperstars = $fa4805b13bc43baf$var$getProtectedDraftPicks(competitorsSuperstars);
                    draft.protectedSuperstarsIds = unavailableSuperstars.map((x)=>x.$loki);
                    (0, $14eBR.db).saveDatabase();
                }
                competitorsSuperstars = competitorsSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, unavailableSuperstars));
            }
            availableSuperstars.push(...competitorsSuperstars);
        }
    } else {
        // For main rosters draft, get superstars from indie available roster
        let indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
        availableSuperstars = await (0, $dl5u4.getRosterSuperstars)(indieAvailableRoster);
    }
    return {
        availableSuperstars: availableSuperstars,
        unavailableSuperstars: unavailableSuperstars
    };
}
function $fa4805b13bc43baf$var$getProtectedDraftPicks(superstars) {
    let protectedPicks = [];
    // Get superstar weights
    let superstarWeights = [];
    for (let s of superstars){
        let weight = Math.pow(s.popularity / 100, 3);
        if (s.popularity >= 800) weight *= 100;
        else if (s.popularity >= 600) weight *= 30;
        if (s.hot) weight *= 50;
        if (s.traits.includes("Loyal")) weight *= 100;
        if (s.traits.includes("Rebel")) weight *= 0.1;
        if (s.retired) weight *= 0.25;
        superstarWeights.push([
            s,
            Math.floor(weight)
        ]);
    }
    // Get protected picks
    let numberOfPicks = Math.floor(superstars.length * 0.3);
    for(let x = 0; x < numberOfPicks; x++){
        let pick = (0, $3E8Nt.weightedChoice)(superstarWeights);
        protectedPicks.push(pick);
        superstarWeights = superstarWeights.filter((x)=>x[0].$loki !== pick.$loki);
    }
    return protectedPicks;
}
async function $fa4805b13bc43baf$export$b524b92794d1f0b(company, currentMonth) {
    let data = {};
    let draftSettings = company.settings["yearly_brand_draft_settings"];
    // Check if yearly draft enabled, in the right month, existing draft not present
    let draftCheck = false;
    let companyDraft = await (0, $9esFv.getCompanyDraft)(company);
    if ((0, $98xmD.globalUser).paid && draftSettings && draftSettings["run"] && draftSettings["month"] && ![
        "mars",
        "passion"
    ].includes(company.storyName)) {
        let draftMonth = parseInt(draftSettings["month"]);
        if (draftMonth === currentMonth) // Run draft
        {
            if (!companyDraft || companyDraft.ended) draftCheck = true;
        } else if ($fa4805b13bc43baf$var$getMonthsIndexDifference(draftMonth, currentMonth) === 1) {
            // Add message about upcoming yearly draft one month before it happens
            let newMessage = await (0, $hekDR.createUpcomingYearlyDraftMessage)(company);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
    }
    if (draftCheck) {
        // Get brands
        let brands = [];
        for (let brandUid of draftSettings["brandUids"]){
            let brand = await (0, $14eBR.Brands).get(brandUid);
            if (brand) brands.push(brand);
        }
        // Create draft event
        if (brands.length > 0) {
            let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
            await $fa4805b13bc43baf$export$e4e4aed659c3c9db(company, brands, draftSettings["type"], await (0, $dl5u4.getRosterSuperstars)(mainRoster));
        }
    }
    return data;
}
function $fa4805b13bc43baf$var$getMonthsIndexDifference(firstMonth, secondMonth) {
    // Return difference between month indexes (0-11)
    let monthsDifference;
    if (firstMonth < secondMonth) monthsDifference = firstMonth + 12 - secondMonth;
    else monthsDifference = firstMonth - secondMonth;
    return monthsDifference;
}
async function $fa4805b13bc43baf$export$e4e4aed659c3c9db(company, brands, draftType, rosterSuperstars) {
    // Create draft event, add to company
    let draft = (0, $3ZjYr.Draft)();
    await (0, $14eBR.Drafts).insert(draft);
    draft.name = draftType === "full" ? "Brand Draft" : "Brand Shuffle";
    draft.type = draftType; // 'shuffle' or 'full'
    await (0, $3ZjYr.addDraftCompanies)(draft, [
        company
    ]);
    // Add brands
    draft.brands = brands.map((x)=>x.name);
    // Set first pick brand
    draft.currentPickBrand = brands[0].name;
    // If full draft, remove brands from all superstars, reset brand overness
    if (draftType === "full") {
        for (let superstar of rosterSuperstars)(0, $1Dp0h.removeObjectBrand)(superstar);
        for (let brand of brands)brand.overness = 45;
    }
    // Set draft result
    let result = {};
    for (let brand of draft.brands)result[brand] = [];
    draft.result = result;
    return draft;
}
async function $fa4805b13bc43baf$export$3298e1f2da5d9d38({ draftUid: draftUid, superstarUid: superstarUid }) {
    const superstar = await (0, $14eBR.Superstars).get(superstarUid);
    const draft = await (0, $14eBR.Drafts).get(draftUid);
    let data = await (0, $5kTkA.getSuperstarDisplayData)({
        superstar: superstar,
        getTeamsAndFactions: true,
        getTagTeamPartners: true
    });
    // Don't show 'limited appearances' for retired part timers
    if (superstar.partTimer && superstar.retired) data["partTimer"] = false;
    // Get company name
    if (draft && draft["type"] === "user_only") {
        let superstarRoster = await (0, $hBIDz.getSuperstarRoster)(superstar);
        if (superstarRoster) {
            if ([
                "indie",
                "indieAvailable"
            ].includes(superstarRoster.type)) data["companyName"] = "Indies";
            else {
                let company = await (0, $dl5u4.getRosterCompany)(superstarRoster);
                if (company) data["companyName"] = company.name;
            }
        }
    }
    return data;
}
async function $fa4805b13bc43baf$export$571175a8786a20e7({ superstarUid: superstarUid, draftUid: draftUid, random: random } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    let draft = await (0, $14eBR.Drafts).get(draftUid);
    let draftRoster = await (0, $3ZjYr.getDraftCurrentPickRoster)(draft);
    let draftRosterCompany = await (0, $dl5u4.getRosterCompany)(draftRoster);
    let { availableSuperstars: availableSuperstars } = await $fa4805b13bc43baf$var$getPicksForDraft(draft, game, userCompany, mainCompany);
    // Check for roster capacity
    let capacity = (0, $8A6FL.getCompanyRosterCapacity)(draftRosterCompany, game);
    let size = (await (0, $dl5u4.getRosterSuperstars)(draftRoster)).filter((x)=>!x.retired && !x.dead).length;
    if (size >= capacity) {
        data["error"] = "max-capacity";
        data["capacity"] = capacity;
        return data;
    }
    // Check for available superstars
    if (!availableSuperstars.length) {
        data["error"] = "no-superstars-available";
        return data;
    }
    // Find superstar
    let superstar;
    if (superstarUid) {
        superstar = await (0, $14eBR.Superstars).get(superstarUid);
        if (!superstar) {
            data["error"] = "superstar-not-found";
            return data;
        }
        if (!(0, $3E8Nt.objectInArray)(superstar, availableSuperstars)) {
            data["error"] = "superstar-not-available";
            return data;
        }
    } else if (random) superstar = await $fa4805b13bc43baf$var$simulateDraftPick(availableSuperstars);
    // Check if it's user's pick
    if (!draftRosterCompany.userControlled) {
        data = await $fa4805b13bc43baf$export$a6abb59131f55816(draft, availableSuperstars);
        (0, $14eBR.db).saveDatabase();
        data["error"] = "not-user-turn";
        return data;
    }
    // Process draft pick
    await $fa4805b13bc43baf$export$a6abb59131f55816(draft, availableSuperstars, superstar);
    (0, $14eBR.db).saveDatabase();
    // Get draft result
    data["draftData"] = await $fa4805b13bc43baf$export$b3b48bb36d0e886f(draft, userCompany);
    // Get random pick data
    if (random) {
        data["randomPick"] = superstar.name;
        data["picksData"] = availableSuperstars.map((x)=>x.name);
    }
    return data;
}
async function $fa4805b13bc43baf$export$663cc773a4cae79({ superstarUid: superstarUid, draftUid: draftUid, random: random } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    let draft = await (0, $14eBR.Drafts).get(draftUid);
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    let companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    // Check for available superstars
    let { availableSuperstars: availableSuperstars } = await $fa4805b13bc43baf$var$getPicksForDraft(draft, game, userCompany, mainCompany);
    if (!availableSuperstars.length) {
        data["error"] = "no-superstars-available";
        return data;
    }
    // Find superstar
    let superstar;
    if (superstarUid) {
        superstar = await (0, $14eBR.Superstars).get(superstarUid);
        if (!superstar) {
            data["error"] = "superstar-not-found";
            return data;
        }
        if (!(0, $3E8Nt.objectInArray)(superstar, availableSuperstars)) {
            data["error"] = "superstar-not-available";
            return data;
        }
    } else if (random) superstar = await $fa4805b13bc43baf$var$simulateDraftPick(availableSuperstars);
    // Check talent request
    let selectedBrand = rosterBrands.find((y)=>y.name === draft.currentPickBrand);
    if (selectedBrand) {
        let requestData = {
            "brandId": selectedBrand.$loki
        };
        await (0, $1olyO.checkTalentRequestAction)({
            company: userCompany,
            requestType: "change_brand",
            talent: superstar,
            data: requestData
        });
    }
    // Process draft pick
    await $fa4805b13bc43baf$var$processBrandDraftPick(draft, availableSuperstars, superstar, companyChampionships);
    (0, $14eBR.db).saveDatabase();
    // Get draft result
    data["draftData"] = await $fa4805b13bc43baf$export$b3b48bb36d0e886f(draft, userCompany);
    // Get random pick data
    if (random) {
        data["randomPick"] = superstar.name;
        data["picksData"] = availableSuperstars.map((x)=>x.name);
    }
    return data;
}
async function $fa4805b13bc43baf$export$e4be05925f55df79({ draftUid: draftUid } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    let draft = await (0, $14eBR.Drafts).get(draftUid);
    // Simulate rest of draft
    let { availableSuperstars: availableSuperstars } = await $fa4805b13bc43baf$var$getPicksForDraft(draft, game, userCompany, mainCompany);
    await $fa4805b13bc43baf$export$a6abb59131f55816(draft, availableSuperstars, null, true);
    (0, $14eBR.db).saveDatabase();
    data["draftData"] = await $fa4805b13bc43baf$export$b3b48bb36d0e886f(draft, userCompany);
    return data;
}
async function $fa4805b13bc43baf$export$8c0a1b2c634c7f00({ draftUid: draftUid } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let draft = await (0, $14eBR.Drafts).get(draftUid);
    // Get next pick brand
    draft.currentPickBrand = $fa4805b13bc43baf$var$getNextDraftPickBrand(draft);
    (0, $14eBR.db).saveDatabase();
    data["draftData"] = await $fa4805b13bc43baf$export$b3b48bb36d0e886f(draft, userCompany);
    return data;
}
async function $fa4805b13bc43baf$export$ea26ea19139a1a70({ draftUid: draftUid } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let draft = await (0, $14eBR.Drafts).get(draftUid);
    let draftBrand = draft.currentPickBrand;
    // Remove brand from draft if draft has brands
    if (draft.brands.length) {
        draft.currentPickBrand = $fa4805b13bc43baf$var$getNextDraftPickBrand(draft);
        draft.brands = draft.brands.filter((x)=>x !== draftBrand);
    }
    // End draft if no more brands present
    if (!draft.brands.length) {
        draft.ended = true;
        draft.postEndRun = true;
    }
    (0, $14eBR.db).saveDatabase();
    data["draftData"] = await $fa4805b13bc43baf$export$b3b48bb36d0e886f(draft, userCompany);
    return data;
}
async function $fa4805b13bc43baf$export$f66df47a232745a5({ draftUid: draftUid } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    let indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
    let indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
    let draft = await (0, $14eBR.Drafts).get(draftUid);
    let draftRoster = await (0, $3ZjYr.getDraftCurrentPickRoster)(draft);
    let draftRosterCompany = await (0, $dl5u4.getRosterCompany)(draftRoster);
    // Check for minimum picks
    let minimumPicks = 10;
    if (!draft.ended && (await (0, $dl5u4.getRosterSuperstars)(draftRoster)).length < minimumPicks) {
        data["error"] = "minimum-picks";
        data["minimumPicks"] = minimumPicks;
        return data;
    }
    // Remove user roster from draft if draft has rosters
    if (draftRosterCompany.userControlled && draft.rosterPickOrderIds.length) {
        (0, $3ZjYr.setDraftCurrentPickRoster)(draft, await $fa4805b13bc43baf$var$getNextDraftPickRoster(draft));
        draft.rosterPickOrderIds = draft.rosterPickOrderIds.filter((x)=>x !== draftRoster.$loki);
    }
    // Process other picks
    let { availableSuperstars: availableSuperstars } = await $fa4805b13bc43baf$var$getPicksForDraft(draft, game, userCompany, mainCompany);
    await $fa4805b13bc43baf$export$a6abb59131f55816(draft, availableSuperstars);
    if (draft.ended) {
        let mainCompanyObjectivesAdded = (await (0, $9esFv.getCompanyObjectives)(mainCompany)).length;
        let userControlledCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
        for (let company of userControlledCompanies){
            // Get main roster superstars
            let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
            let mainRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
            // Add staff and facilities messages
            await (0, $8A6FL.addNewCompanyStaffAndFacilities)(company, mainRosterSuperstars, indieAvailableRoster, game.settings);
            // Add unlimited artifacts message
            if (game.settings["unlock_all_items"]) {
                let newMessage = await (0, $hekDR.createIntroducePowerupsSandboxModeMessage)(company, game);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            // Add sandbox mode message
            if (game.settings["sandbox_mode_enabled"]) {
                let newMessage = await (0, $hekDR.createIntroduceSandboxModeMessage)(0, 0, company.ownerName, game.settings);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
            }
            // If custom starting company draft, add superstar joined / competitor messages
            if (draft.type === "user_only") {
                let topSuperstars = [
                    ...mainRosterSuperstars
                ].sort((a, b)=>b.popularity - a.popularity).slice(0, 3);
                let newMessage = await (0, $hekDR.createJoinedCompanySuperstarMessage)((0, $3E8Nt.getRandomChoice)(topSuperstars), game.monthCount, game.year);
                await (0, $9esFv.addCompanyMessages)(company, [
                    newMessage
                ]);
                let competitors = await (0, $8A6FL.getCpuControlledCompanies)(company, game);
                if (competitors.length) {
                    let newMessage = await (0, $hekDR.createCustomStartingCompanyCompetitorMessage)((0, $3E8Nt.getRandomChoice)(competitors), game.monthCount, game.year);
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                }
            }
            // Add objectives
            if (![
                "mars",
                "passion"
            ].includes(company.storyName)) {
                let objectives = await (0, $5yA6U.generateCompanyObjectives)(company, game);
                await (0, $9esFv.addCompanyObjectives)(company, objectives);
            }
        }
        if (!mainCompanyObjectivesAdded) {
            // Transfer teams for user only draft
            if (draft.type === "user_only") {
                // Get all draft rosters
                let allDraftRosters = [];
                if (draft.settings["includeIndies"]) allDraftRosters.push(await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie"));
                if (draft.settings["includeCompanyRosters"]) for (let competitor of (await (0, $8A6FL.getActiveCompetitorsForCompany)(userCompany, game))){
                    let competitorRosters = (await (0, $9esFv.getCompanyRosters)(competitor)).filter((x)=>[
                            "main",
                            "training"
                        ].includes(x.type));
                    allDraftRosters.push(...competitorRosters);
                }
                // Go through teams
                for (let roster of allDraftRosters)for (let tagTeam of (await (0, $dl5u4.getRosterTagTeams)(roster))){
                    // If all team superstars moved to another roster, move team
                    let tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                    let firstMemberRoster = await (0, $hBIDz.getSuperstarRoster)(tagTeamSuperstars[0]);
                    let foundInRoster = firstMemberRoster;
                    for (const tagTeamSuperstar of tagTeamSuperstars){
                        let memberRoster = await (0, $hBIDz.getSuperstarRoster)(tagTeamSuperstar);
                        if (!memberRoster || memberRoster.$loki !== firstMemberRoster.$loki) foundInRoster = null;
                    }
                    if (foundInRoster) {
                        if (foundInRoster.$loki !== roster.$loki) await (0, $dl5u4.addRosterTagTeams)(foundInRoster, [
                            tagTeam
                        ]);
                    } else {
                        tagTeam.rosterId = null;
                        await (0, $972Ip.removeTagTeamSuperstars)(tagTeam);
                    }
                }
            } else {
                // Transfer indie teams
                for (let tagTeam of (await (0, $dl5u4.getRosterTagTeams)(indieAvailableRoster))){
                    // If all team superstars moved to another roster, move team
                    let tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                    let firstMemberRoster = await (0, $hBIDz.getSuperstarRoster)(tagTeamSuperstars[0]);
                    let foundInRoster = firstMemberRoster;
                    for (const tagTeamSuperstar of tagTeamSuperstars){
                        let memberRoster = await (0, $hBIDz.getSuperstarRoster)(tagTeamSuperstar);
                        if (!memberRoster || memberRoster.$loki !== firstMemberRoster.$loki) foundInRoster = null;
                    }
                    if (foundInRoster) {
                        if (foundInRoster.$loki !== indieAvailableRoster.$loki) await (0, $dl5u4.addRosterTagTeams)(foundInRoster, [
                            tagTeam
                        ]);
                    } else {
                        tagTeam.rosterId = null;
                        await (0, $972Ip.removeTagTeamSuperstars)(tagTeam);
                    }
                }
                // Move all draft (indie available) superstars/tagteams to indie roster
                for (let s of (await (0, $dl5u4.getRosterSuperstars)(indieAvailableRoster)))await (0, $dl5u4.addRosterSuperstars)(indieRoster, [
                    s
                ]);
                for (let t of (await (0, $dl5u4.getRosterTagTeams)(indieAvailableRoster)))await (0, $dl5u4.addRosterTagTeams)(indieRoster, [
                    t
                ]);
            }
            // Make all indies available if sandbox mode
            if (game.settings["all_indies_available"]) {
                for (let s of (await (0, $dl5u4.getRosterSuperstars)(indieRoster)))await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, [
                    s
                ]);
                for (let t of (await (0, $dl5u4.getRosterTagTeams)(indieRoster)))await (0, $dl5u4.addRosterTagTeams)(indieAvailableRoster, [
                    t
                ]);
            } else {
                let indieSuperstars = await (0, $dl5u4.getRosterSuperstars)(indieRoster);
                for(let i = 0; i < 3; i++)if (indieSuperstars.length) {
                    const talentToTransfer = (0, $3E8Nt.getRandomChoice)(indieSuperstars);
                    let transferredToIndies = await (0, $jpMCP.transferTalentToRoster)(talentToTransfer, indieAvailableRoster);
                    indieSuperstars = indieSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, transferredToIndies));
                }
            }
        }
        draft.postEndRun = true;
    }
    (0, $14eBR.db).saveDatabase();
    data["draftData"] = await $fa4805b13bc43baf$export$b3b48bb36d0e886f(draft, userCompany);
    return data;
}
async function $fa4805b13bc43baf$export$a6abb59131f55816(draft, superstars, pick = null, simulating = false) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let draftRoster = await (0, $3ZjYr.getDraftCurrentPickRoster)(draft);
    let draftRosterCompany = await (0, $dl5u4.getRosterCompany)(draftRoster);
    // If no picks or rosters left, end draft
    if (!superstars.length || !draft.rosterPickOrderIds.length) {
        draft.ended = true;
        return data;
    }
    // Return if user pick and if not simulating
    if (draftRosterCompany.userControlled && !pick && !simulating) return data;
    // Simulate pick for competitor
    if (!draftRosterCompany.userControlled || simulating) {
        pick = await $fa4805b13bc43baf$var$simulateDraftPick(superstars);
        // Remove roster from draft if near capacity, get next pick roster
        let capacity = await (0, $8A6FL.getCompanyRosterCapacity)(draftRosterCompany, game);
        let size = await (0, $dl5u4.getRosterSuperstars)(draftRoster).filter((x)=>!x.retired && !x.dead).length;
        let minimum = Math.floor(capacity * 0.8);
        if (size >= (0, $3E8Nt.getRandomInt)(minimum, capacity)) {
            (0, $3ZjYr.setDraftCurrentPickRoster)(draft, await $fa4805b13bc43baf$var$getNextDraftPickRoster(draft));
            draft.rosterPickOrderIds = draft.rosterPickOrderIds.filter((x)=>x !== draftRoster.$loki);
            return $fa4805b13bc43baf$export$a6abb59131f55816(draft, superstars, null, simulating);
        }
    }
    // Remove championships/managers/factions/brands
    if (draft.type === "user_only") {
        let pickRoster = await (0, $hBIDz.getSuperstarRoster)(pick);
        let pickCompany = await (0, $dl5u4.getRosterCompany)(pickRoster);
        if (pickCompany && pickCompany !== draftRosterCompany) await (0, $5kTkA.vacateChampionships)({
            superstar: pick,
            championships: await (0, $9esFv.getCompanyChampionships)(pickCompany),
            month: 0,
            year: 0
        });
        await (0, $5kTkA.removeSuperstarManagerRelationships)(pick);
        await (0, $5kTkA.removeSuperstarFactionRelationships)(pick, 0, 0);
        pick.brandName = null;
    }
    // Move superstar to draftRoster
    await (0, $dl5u4.addRosterSuperstars)(draftRoster, [
        pick
    ]);
    superstars = superstars.filter((x)=>x.$loki !== pick.$loki);
    // Add pick to draft result
    await $fa4805b13bc43baf$var$updateDraftResult(draft, pick);
    // Get next pick roster
    (0, $3ZjYr.setDraftCurrentPickRoster)(draft, await $fa4805b13bc43baf$var$getNextDraftPickRoster(draft));
    // Run next pick
    return $fa4805b13bc43baf$export$a6abb59131f55816(draft, superstars, null, simulating);
}
async function $fa4805b13bc43baf$var$getNextDraftPickRoster(draft) {
    let order = draft.rosterPickOrderIds;
    // Get next roster id in order
    let rosterIndex = order.indexOf((await (0, $3ZjYr.getDraftCurrentPickRoster)(draft))?.$loki);
    let rosterId;
    if (rosterIndex === order.length - 1) rosterId = order[0];
    else rosterId = order[rosterIndex + 1];
    // Get next roster by id
    return (0, $14eBR.Rosters).get(rosterId);
}
async function $fa4805b13bc43baf$var$processBrandDraftPick(draft, superstars, pick = null, companyChampionships = null) {
    let data = {};
    let draftBrand = draft.currentPickBrand;
    // If no picks left, end draft
    if (!superstars.length) {
        draft.ended = true;
        return data;
    }
    // Draft superstar
    (0, $1Dp0h.draftSuperstarToBrand)(pick, draftBrand, companyChampionships);
    // Add pick to draft result
    await $fa4805b13bc43baf$var$updateDraftResult(draft, pick);
    // Get next pick brand
    draft.currentPickBrand = $fa4805b13bc43baf$var$getNextDraftPickBrand(draft);
    return true;
}
function $fa4805b13bc43baf$var$getNextDraftPickBrand(draft) {
    let draftBrands = draft.brands;
    // Get next brand in order
    let brandIndex = draftBrands.indexOf(draft.currentPickBrand);
    let nextBrand;
    if (brandIndex === draftBrands.length - 1) nextBrand = draftBrands[0];
    else nextBrand = draftBrands[brandIndex + 1];
    return nextBrand;
}
async function $fa4805b13bc43baf$var$updateDraftResult(draft, pick) {
    // Get key
    let key;
    if (draft.brands.length) // Brand name
    key = draft.currentPickBrand;
    else {
        // Current roster's company name
        let currentRoster = await (0, $3ZjYr.getDraftCurrentPickRoster)(draft);
        key = await $fa4805b13bc43baf$var$getRosterCompanyName(currentRoster);
    }
    // Add pick to draft result
    draft.result[key].push(pick.name);
    return draft.result;
}
function $fa4805b13bc43baf$var$simulateDraftPick(superstars) {
    let superstarWeights = $fa4805b13bc43baf$var$getSuperstarWeights(superstars);
    return (0, $3E8Nt.weightedChoice)(superstarWeights);
}
function $fa4805b13bc43baf$var$getSuperstarWeights(superstars) {
    // Get weights for top superstars by popularity, ensuring that active superstars are included
    let superstarWeights = [];
    let numberOfSuperstars = 8;
    let sortedSuperstars = [
        ...superstars
    ].sort((a, b)=>b.popularity - a.popularity);
    let activeSuperstars = sortedSuperstars.filter((x)=>!x.retired);
    // Get index of last active superstar in sorted superstars, use to get top superstars
    let lastActiveSuperstarIndex;
    if (activeSuperstars.length > numberOfSuperstars) lastActiveSuperstarIndex = sortedSuperstars.indexOf(activeSuperstars[numberOfSuperstars]);
    else if (activeSuperstars.length > 0) lastActiveSuperstarIndex = sortedSuperstars.indexOf(activeSuperstars[activeSuperstars.length - 1]);
    else lastActiveSuperstarIndex = numberOfSuperstars;
    let topSuperstars = sortedSuperstars.slice(0, lastActiveSuperstarIndex + 1);
    topSuperstars.forEach((s)=>{
        // Set weight
        let weight = Math.pow(s.popularity / 100, 6) / 10000;
        if (s.workrate >= 3) weight *= 3;
        if (s.charisma >= 3) weight *= 3;
        // Part timers less likely
        if (s.partTimer) weight *= 0.6;
        // Retired less likely
        if (s.retired) weight *= 0.02;
        // Manager less likely
        if (s.fullTimeManager) weight *= 0.2;
        // Hot/stale
        if (!s.retired) {
            if (s.hot) weight *= 10;
            if (s.stale) weight *= 0.1;
        }
        superstarWeights.push([
            s,
            Math.floor(weight)
        ]);
    });
    return superstarWeights;
}

});
parcelRequire.register("3ZjYr", function(module, exports) {

$parcel$export(module.exports, "Draft", () => $2e768ffb55c8adc0$export$cbc94960dbffa143);
$parcel$export(module.exports, "addDraftCompanies", () => $2e768ffb55c8adc0$export$e7696f721b36f00c);
$parcel$export(module.exports, "addDraftRosters", () => $2e768ffb55c8adc0$export$b8b22e6e72fca362);
$parcel$export(module.exports, "getDraftCurrentPickRoster", () => $2e768ffb55c8adc0$export$6f247308d3fb2c11);
$parcel$export(module.exports, "setDraftCurrentPickRoster", () => $2e768ffb55c8adc0$export$80140ff515b9e388);

var $14eBR = parcelRequire("14eBR");
function $2e768ffb55c8adc0$export$cbc94960dbffa143() {
    // Strings
    const name = null;
    const type = null;
    const currentPickBrand = null;
    // Boolean
    const ended = false;
    const postEndRun = false;
    // Arrays
    const brands = [];
    const protectedSuperstarsIds = [];
    const rosterPickOrderIds = [];
    // Objects
    const settings = {};
    const result = {};
    // Foreign keys
    const currentPickRosterId = null;
    return {
        name: name,
        type: type,
        currentPickBrand: currentPickBrand,
        ended: ended,
        postEndRun: postEndRun,
        brands: brands,
        protectedSuperstarsIds: protectedSuperstarsIds,
        rosterPickOrderIds: rosterPickOrderIds,
        settings: settings,
        result: result,
        currentPickRosterId: currentPickRosterId
    };
}
function $2e768ffb55c8adc0$export$e7696f721b36f00c(draft, companies) {
    companies.forEach((c)=>{
        c.draftId = draft.$loki;
    });
}
function $2e768ffb55c8adc0$export$1ab23e2ad5197c3a(draft, companies) {
    companies.forEach((c)=>{
        c.draftId = null;
    });
}
function $2e768ffb55c8adc0$export$3a7b7af65d1d59d4(draft) {
    return (0, $14eBR.Companies).find({
        "draftId": draft.$loki
    });
}
function $2e768ffb55c8adc0$export$b8b22e6e72fca362(draft, rosters) {
    rosters.forEach((c)=>{
        c.draftId = draft.$loki;
    });
}
function $2e768ffb55c8adc0$export$47d52884e3cbb76f(draft, rosters) {
    rosters.forEach((c)=>{
        c.draftId = null;
    });
}
function $2e768ffb55c8adc0$export$2cd5cc6934690f39(draft) {
    return (0, $14eBR.Rosters).find({
        "draftId": draft.$loki
    });
}
function $2e768ffb55c8adc0$export$6f247308d3fb2c11(draft) {
    return (0, $14eBR.Rosters).find({
        "$loki": draft.currentPickRosterId
    })[0];
}
function $2e768ffb55c8adc0$export$80140ff515b9e388(draft, roster) {
    draft.currentPickRosterId = roster.$loki;
}

});



parcelRequire.register("csISS", function(module, exports) {

$parcel$export(module.exports, "Negotiation", () => $912aeaa22b8eccd2$export$abf40db32e7bd948);
$parcel$export(module.exports, "getNegotiationSenderCompany", () => $912aeaa22b8eccd2$export$451d6b44cc36e54f);
$parcel$export(module.exports, "getNegotiationReceiverCompany", () => $912aeaa22b8eccd2$export$b5e71f25b4cf390f);
$parcel$export(module.exports, "getNegotiationTalent", () => $912aeaa22b8eccd2$export$89e541d793eb7eab);

var $14eBR = parcelRequire("14eBR");

var $hBIDz = parcelRequire("hBIDz");

var $972Ip = parcelRequire("972Ip");
function $912aeaa22b8eccd2$export$abf40db32e7bd948(status = "negotiating", attemptsRemaining = 3) {
    // Integer
    const offeredAmount = null;
    const monthsToRemove = null;
    // Boolean
    const sendToMainRoster = false;
    // Foreign keys
    const senderCompanyId = null;
    const receiverCompanyId = null;
    const superstarId = null;
    const tagTeamId = null;
    return {
        offeredAmount: offeredAmount,
        attemptsRemaining: attemptsRemaining,
        monthsToRemove: monthsToRemove,
        status: status,
        sendToMainRoster: sendToMainRoster,
        senderCompanyId: senderCompanyId,
        receiverCompanyId: receiverCompanyId,
        superstarId: superstarId,
        tagTeamId: tagTeamId
    };
}
function $912aeaa22b8eccd2$export$451d6b44cc36e54f(negotiation) {
    return (0, $14eBR.Companies).find({
        "$loki": negotiation.senderCompanyId
    })[0];
}
function $912aeaa22b8eccd2$export$b5e71f25b4cf390f(negotiation) {
    if (!negotiation.receiverCompanyId) return null;
    return (0, $14eBR.Companies).find({
        "$loki": negotiation.receiverCompanyId
    })[0];
}
function $912aeaa22b8eccd2$export$b88b817ef203f728(negotiation) {
    return (0, $14eBR.Superstars).find({
        "$loki": negotiation.superstarId
    })[0];
}
function $912aeaa22b8eccd2$export$c0e6bdcbc236fad4(negotiation) {
    return (0, $14eBR.TagTeams).find({
        "$loki": negotiation.tagTeamId
    })[0];
}
function $912aeaa22b8eccd2$export$89e541d793eb7eab(negotiation) {
    if (negotiation.superstarId) return $912aeaa22b8eccd2$export$b88b817ef203f728(negotiation);
    else return $912aeaa22b8eccd2$export$c0e6bdcbc236fad4(negotiation);
}
function $912aeaa22b8eccd2$export$e5a3d34137971b5b(talent) {
    if (talent.objectName === "superstar") return (0, $hBIDz.getSuperstarNegotiations)(talent);
    else if (talent.objectName === "tagTeam") return (0, $972Ip.getTagTeamNegotiations)(talent);
}

});

parcelRequire.register("3NAMH", function(module, exports) {

$parcel$export(module.exports, "getStartNegotiationData", () => $2c427b5109924a54$export$5c4039dee499904e);
$parcel$export(module.exports, "getTalentValueAmount", () => $2c427b5109924a54$export$4a77ac73b625e9f7);
$parcel$export(module.exports, "makeNegotiationOffer", () => $2c427b5109924a54$export$cd332953d2a62952);
$parcel$export(module.exports, "makeTalentOffer", () => $2c427b5109924a54$export$3a190c789f7fa8b1);
$parcel$export(module.exports, "negotiationSendToMainRoster", () => $2c427b5109924a54$export$d789596dc0d48d97);
$parcel$export(module.exports, "filterOffersSentToCpuCompanies", () => $2c427b5109924a54$export$ba9e6e1d6e16aefa);
$parcel$export(module.exports, "processNegotiation", () => $2c427b5109924a54$export$1ff796413db2b03d);
$parcel$export(module.exports, "getTalentOfferData", () => $2c427b5109924a54$export$79ba20bc94038647);
$parcel$export(module.exports, "acceptOrRejectTalentOfferRequest", () => $2c427b5109924a54$export$e8e3ae0eebbbd185);

var $14eBR = parcelRequire("14eBR");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $8A6FL = parcelRequire("8A6FL");

var $5kTkA = parcelRequire("5kTkA");

var $dl5u4 = parcelRequire("dl5u4");

var $csISS = parcelRequire("csISS");

var $9esFv = parcelRequire("9esFv");

var $hBIDz = parcelRequire("hBIDz");

var $972Ip = parcelRequire("972Ip");

var $eiAJX = parcelRequire("eiAJX");

var $aP7lq = parcelRequire("aP7lq");

var $kZMqI = parcelRequire("kZMqI");

var $ko5kE = parcelRequire("ko5kE");

var $cXLSF = parcelRequire("cXLSF");

var $4K85d = parcelRequire("4K85d");

var $hekDR = parcelRequire("hekDR");

var $jC7EP = parcelRequire("jC7EP");
async function $2c427b5109924a54$export$5c4039dee499904e(uid, selectionType) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    // Get talent
    let talent;
    if ([
        "superstar",
        "training-superstar"
    ].indexOf(selectionType) >= 0) talent = await (0, $14eBR.Superstars).get(uid);
    else talent = await (0, $14eBR.TagTeams).get(uid);
    if (!talent) {
        data["error"] = "not-found";
        return data;
    }
    // Check if talent on trade deal
    const talentSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
    const talentRoster = await (0, $hBIDz.getSuperstarRoster)(talentSuperstars[0]);
    if (talentSuperstars.some((x)=>x.activeEffect === "traded" && (!talentRoster || talentRoster.type !== "indieAvailable"))) {
        data["error"] = "on-trade";
        return data;
    }
    // Check roster capacity
    const rosterCapacity = (0, $8A6FL.getCompanyRosterCapacity)(selectedCompany, currentGame);
    const rosterSize = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).filter((x)=>!x.retired && !x.dead).length;
    if (rosterSize + talentSuperstars.length > rosterCapacity) {
        data["error"] = "capacity";
        return data;
    }
    const negotiation = await $2c427b5109924a54$var$startNegotiation(talent, selectedCompany);
    (0, $14eBR.db).saveDatabase();
    return $2c427b5109924a54$var$getNegotiationData(negotiation);
}
async function $2c427b5109924a54$var$startNegotiation(talent, company) {
    // Get existing negotiation
    let existingNegotiation;
    if (talent.objectName === "superstar") {
        existingNegotiation = (await (0, $9esFv.getCompanySentNegotiations)(company)).find((x)=>x.superstarId === talent.$loki);
        if (!existingNegotiation) {
            const talentTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(talent)).filter((x)=>!x.temporary);
            for (const t of talentTagTeams){
                existingNegotiation = (await (0, $9esFv.getCompanySentNegotiations)(company)).find((x)=>x.tagTeamId === t.$loki);
                if (existingNegotiation) return existingNegotiation;
            }
        }
    } else {
        existingNegotiation = (await (0, $9esFv.getCompanySentNegotiations)(company)).find((x)=>x.tagTeamId === talent.$loki);
        if (!existingNegotiation) for (const s of (await (0, $5kTkA.getRosterMemberSuperstars)(talent))){
            existingNegotiation = (await (0, $9esFv.getCompanySentNegotiations)(company)).find((x)=>x.superstarId === s.$loki);
            if (existingNegotiation) return existingNegotiation;
        }
    }
    if (existingNegotiation) {
        let receiverCompany = await (0, $csISS.getNegotiationReceiverCompany)(existingNegotiation);
        if (!receiverCompany || receiverCompany === await (0, $3E8Nt.getTalentCompany)(talent)) return existingNegotiation;
    }
    // Create new negotiation
    const newNegotiation = (0, $csISS.Negotiation)();
    await (0, $14eBR.Negotiations).insert(newNegotiation);
    await $2c427b5109924a54$var$addTalentNegotiations(talent, [
        newNegotiation
    ]);
    await (0, $9esFv.addCompanySentNegotiations)(company, [
        newNegotiation
    ]);
    // Add receiver company, if present
    const receiverCompany = await (0, $3E8Nt.getTalentCompany)(talent);
    if (receiverCompany) await (0, $9esFv.addCompanyReceivedNegotiations)(receiverCompany, [
        newNegotiation
    ]);
    return newNegotiation;
}
async function $2c427b5109924a54$var$addTalentNegotiations(talent, negotiations) {
    if (talent.objectName === "superstar") return (0, $hBIDz.addSuperstarNegotiations)(talent, negotiations);
    else return (0, $972Ip.addTagTeamNegotiations)(talent, negotiations);
}
async function $2c427b5109924a54$var$getTalentNegotiations(talent) {
    if (talent.objectName === "superstar") return (0, $hBIDz.getSuperstarNegotiations)(talent);
    else return (0, $972Ip.getTagTeamNegotiations)(talent);
}
async function $2c427b5109924a54$var$getNegotiationData(negotiation) {
    let data = {};
    const talent = await (0, $csISS.getNegotiationTalent)(negotiation);
    const company = await (0, $csISS.getNegotiationSenderCompany)(negotiation);
    const companyStaff = await (0, $9esFv.getCompanyStaff)(company);
    const scout = (0, $8A6FL.getHighestLevelStaffMemberByRole)(companyStaff, "scout");
    const talentManager = (0, $8A6FL.getHighestLevelStaffMemberByRole)(companyStaff, "talent_manager");
    const talentSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
    const topSuperstar = (0, $3E8Nt.getArrayMaxByProperty)(talentSuperstars, "popularity");
    const receiverCompany = await (0, $csISS.getNegotiationReceiverCompany)(negotiation);
    // Get data
    data["name"] = talent.name;
    const topSuperstarGraphic = (0, $5kTkA.getGraphicForSuperstar)(topSuperstar);
    data["graphic"] = [
        topSuperstarGraphic
    ];
    data["status"] = negotiation.status;
    data["attemptsRemaining"] = negotiation.attemptsRemaining;
    data["offeredAmount"] = negotiation.offeredAmount;
    data["monthsToRemove"] = negotiation.monthsToRemove;
    data["sendToMainRoster"] = negotiation.sendToMainRoster;
    data["uid"] = negotiation.$loki;
    data["dialog"] = $2c427b5109924a54$var$getNegotiationDialog(negotiation, talent);
    data["scoutName"] = scout ? scout.name : "";
    data["scoutLevel"] = scout ? scout.level : null;
    data["scoutOfferAmountEstimate"] = await $2c427b5109924a54$var$getNegotiationScoutOfferAmountEstimate(negotiation, scout, talent, company, receiverCompany);
    data["talentManagerName"] = talentManager ? talentManager.name : "";
    if (receiverCompany) data["receiverCompanyName"] = receiverCompany.name;
    // Get other offers
    data["otherOffers"] = [];
    const otherOffers = (await $2c427b5109924a54$var$getTalentNegotiations(talent)).filter((x)=>x.status === "accepted_by_talent" && x.$loki !== negotiation.$loki);
    for (const otherOffer of otherOffers){
        const offerCompany = await (0, $csISS.getNegotiationSenderCompany)(otherOffer);
        data["otherOffers"].push(offerCompany.name);
    }
    return data;
}
function $2c427b5109924a54$var$getNegotiationDialog(negotiation, talent) {
    const negotiationRandom = new Math.seedrandom(negotiation.meta.created);
    let dialog = null;
    let dialogs = talent.objectName === "superstar" ? (0, $eiAJX.negotiationSuperstarDialogData) : (0, $eiAJX.negotiationTagDialogData);
    if (negotiation.status === "negotiating") dialogs = dialogs[negotiation.status][negotiation.attemptsRemaining];
    else dialogs = dialogs[negotiation.status];
    if (dialogs) dialog = (0, $3E8Nt.getRandomChoice)(dialogs, negotiationRandom());
    return dialog;
}
async function $2c427b5109924a54$var$getNegotiationScoutOfferAmountEstimate(negotiation, scout, talent, senderCompany, receiverCompany) {
    // Get accept amount
    const negotiationRandom = new Math.seedrandom(negotiation.meta.created);
    let estimate = await $2c427b5109924a54$export$3697c6750c97e7ff(negotiation, talent, senderCompany, receiverCompany);
    // Add scout deviation
    const scoutDeviationData = {
        1: 200,
        2: 100,
        3: 50
    };
    let deviation;
    if (scout) deviation = scoutDeviationData[scout.level];
    else deviation = 250;
    estimate += (0, $3E8Nt.getRandomInt)(-deviation, deviation, negotiationRandom());
    return (0, $3E8Nt.myround)(estimate, 25);
}
async function $2c427b5109924a54$export$3697c6750c97e7ff(negotiation, talent, senderCompany, receiverCompany) {
    let isContracted = !!receiverCompany;
    let talentValue = await $2c427b5109924a54$export$4a77ac73b625e9f7(talent, senderCompany, isContracted);
    return (0, $3E8Nt.myround)(talentValue, 10);
}
async function $2c427b5109924a54$export$4a77ac73b625e9f7(talent, senderCompany, isContracted = false) {
    const maximumSuperstarValue = 400;
    let totalValue = 0;
    for (const superstar of (await (0, $5kTkA.getRosterMemberSuperstars)(talent))){
        // Get weights from popularity and attributes
        let value = superstar.popularity / 10 * 0.7 + (superstar.workrate - 1 + superstar.charisma - 1) / 4 * 30;
        if ((0, $5kTkA.getRankFromPopularity)(superstar.popularity) === "Main Eventer") value += 15;
        if (superstar.faceOfTheCompany) value += 30;
        if (superstar.hot) value += 20;
        if (superstar.stale) value -= 20;
        if (superstar.fullTimeManager) value *= 0.6;
        // Add value for contracted talent
        if (isContracted) {
            value += 50;
            // Add value for loyal, lower for rebel traits
            for (const trait of superstar.traits){
                const traitData = (0, $aP7lq.traitsData)[trait];
                if (traitData && traitData["leaving_chance_multiplier"]) {
                    if (traitData["leaving_chance_multiplier"] < 1) value += 40;
                    else value -= 40;
                }
            }
            // Lower value if leaving
            if (superstar.contractMonthsRemaining !== null) value *= 0.5;
        }
        // Lower value if interested relationship
        let interestedRelationship = (await (0, $hBIDz.getSuperstarRelationships)(superstar)).find((x)=>x.interested && x.companyId === senderCompany.$loki);
        if (interestedRelationship) value *= 0.75;
        totalValue += value * maximumSuperstarValue / 100;
    }
    if (totalValue < 10) totalValue = 10;
    return totalValue;
}
async function $2c427b5109924a54$export$cd332953d2a62952(uid, amount) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get negotiation and talent
    const negotiation = await (0, $14eBR.Negotiations).get(uid);
    if (!negotiation) {
        data["error"] = "not-found";
        return data;
    }
    // Check negotiation status
    if (negotiation.status !== "negotiating") {
        data["error"] = "not-negotiating";
        return data;
    }
    // Check points
    if (amount > selectedCompany.points) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Get accept amount
    const talent = await (0, $csISS.getNegotiationTalent)(negotiation);
    const senderCompany = await (0, $csISS.getNegotiationSenderCompany)(negotiation);
    const receiverCompany = await (0, $csISS.getNegotiationReceiverCompany)(negotiation);
    const negotiationAcceptAmount = await $2c427b5109924a54$export$3697c6750c97e7ff(negotiation, talent, senderCompany, receiverCompany);
    // Chance to bluff and reject acceptable offer
    const bluffChance = negotiation.attemptsRemaining > 1 ? 20 : -1;
    // Reject offer
    if (amount < negotiationAcceptAmount || (0, $3E8Nt.getRandomInt)(0, 100) <= bluffChance) {
        negotiation.attemptsRemaining -= 1;
        data["offerRejected"] = true;
        if (negotiation.attemptsRemaining <= 0) {
            $2c427b5109924a54$var$rejectNegotiation(negotiation);
            data["negotiationRejected"] = true;
            data["name"] = talent.name;
        }
    } else {
        await $2c427b5109924a54$var$acceptNegotiation(negotiation, amount, talent, selectedCompany);
        // Get accept data
        data["offerAccepted"] = true;
        const talentManager = (0, $8A6FL.getHighestLevelStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(selectedCompany), "talent_manager");
        data["talentManagerName"] = talentManager ? talentManager.name : "";
        if (receiverCompany) data["companyName"] = receiverCompany.name;
        // Chance for cpu competitors to make offer to talent too if they can afford it
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 30) {
            const cpuCompetitors = (await (0, $8A6FL.getCpuControlledCompanies)(selectedCompany, currentGame)).filter((x)=>!receiverCompany || x.$loki !== receiverCompany.$loki);
            if (cpuCompetitors.length > 0) {
                // Limit offer companies
                let numberOfOfferCompaniesMax = cpuCompetitors.length > 3 ? 3 : cpuCompetitors.length;
                const offerCompanies = (0, $3E8Nt.getRandomSample)(cpuCompetitors, (0, $3E8Nt.getRandomInt)(1, numberOfOfferCompaniesMax));
                for (const offerCompany of offerCompanies)if (offerCompany.points > negotiation.offeredAmount) await $2c427b5109924a54$export$3a190c789f7fa8b1(talent, offerCompany, receiverCompany);
            }
        }
    }
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["dialog"] = $2c427b5109924a54$var$getNegotiationDialog(negotiation, talent);
    data["points"] = selectedCompany.points;
    return data;
}
function $2c427b5109924a54$var$rejectNegotiation(negotiation) {
    negotiation.status = "rejected_by_talent";
    negotiation.monthsToRemove = (0, $3E8Nt.getRandomInt)(3, 5);
    return true;
}
async function $2c427b5109924a54$var$acceptNegotiation(negotiation, amount, talent, senderCompany) {
    negotiation.status = "accepted_by_talent";
    negotiation.offeredAmount = amount;
    senderCompany.points -= amount;
    return true;
}
async function $2c427b5109924a54$export$3a190c789f7fa8b1(talent, company, receiverCompany) {
    // Creates negotiation, skips minigame, offers around acceptAmount and offer gets accepted
    const newNegotiation = await $2c427b5109924a54$var$startNegotiation(talent, company);
    if (newNegotiation.status !== "negotiating") return newNegotiation //  Skip if previous rejected negotiation
    ;
    let offerAmount = await $2c427b5109924a54$export$3697c6750c97e7ff(newNegotiation, talent, company, receiverCompany);
    offerAmount += (0, $3E8Nt.getRandomInt)(offerAmount * -0.1, offerAmount * 0.2);
    offerAmount = (0, $3E8Nt.myround)(offerAmount, 10);
    await $2c427b5109924a54$var$acceptNegotiation(newNegotiation, offerAmount, talent, company);
    return newNegotiation;
}
async function $2c427b5109924a54$export$d789596dc0d48d97(uid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get negotiation
    const negotiation = await (0, $14eBR.Negotiations).get(uid);
    if (!negotiation) {
        data["error"] = "not-found";
        return data;
    }
    // Get cost
    let cost = 100;
    const trainer = (0, $8A6FL.getHighestLevelStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(selectedCompany), "trainer");
    const trainingFacility = (await (0, $9esFv.getCompanyFacilities)(selectedCompany)).find((x)=>x.name === "Training");
    if (trainingFacility && trainingFacility.level >= 3 && trainer && trainer.level >= 3) {
        cost = 0;
        data["acceleratedTrainingFacility"] = true;
    }
    // Check if already set
    if (negotiation.sendToMainRoster) {
        data["error"] = "already-set";
        return data;
    }
    // Check points
    if (cost > selectedCompany.points) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Remove points
    selectedCompany.points -= cost;
    // Set sendToMainRoster to true
    negotiation.sendToMainRoster = true;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    return data;
}
async function $2c427b5109924a54$export$ba9e6e1d6e16aefa(sentNegotiations) {
    const acceptedNegotiations = [];
    for (const y of sentNegotiations)if (y.status === "accepted_by_talent") {
        const receiverCompany = await (0, $csISS.getNegotiationReceiverCompany)(y);
        if (receiverCompany) {
            if (!receiverCompany.userControlled) acceptedNegotiations.push(y);
        } else acceptedNegotiations.push(y);
    }
    return acceptedNegotiations;
}
async function $2c427b5109924a54$export$1ff796413db2b03d(negotiation, autoRejectOffers = false) {
    let talent = await (0, $csISS.getNegotiationTalent)(negotiation);
    // Get best offer
    let talentAcceptedNegotiations = (await $2c427b5109924a54$var$getTalentNegotiations(talent)).filter((x)=>x.status === "accepted_by_talent");
    let negotiationToAccept;
    if (talentAcceptedNegotiations.length) {
        negotiationToAccept = $2c427b5109924a54$var$getBestNegotiationOffer(talentAcceptedNegotiations);
        // Accept or reject
        let acceptOfferChance = await $2c427b5109924a54$var$getNegotiationAcceptChance(negotiationToAccept);
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= acceptOfferChance && !autoRejectOffers) await $2c427b5109924a54$var$acceptTalentOffer(negotiationToAccept);
        else await $2c427b5109924a54$var$rejectTalentOffer(negotiationToAccept, autoRejectOffers);
    }
    return negotiationToAccept;
}
function $2c427b5109924a54$var$getBestNegotiationOffer(negotiations) {
    return (0, $3E8Nt.getArrayMaxByProperty)(negotiations, "offeredAmount");
}
async function $2c427b5109924a54$var$getNegotiationAcceptChance(negotiation) {
    let talent = await (0, $csISS.getNegotiationTalent)(negotiation);
    // Max chance for indie, lower for competitor's talent
    let chance = 100;
    let receiverCompany = await (0, $csISS.getNegotiationReceiverCompany)(negotiation);
    if (receiverCompany) {
        chance = 75;
        // Lower chance if talent is valuable
        let talentSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
        for (let superstar of talentSuperstars){
            if ((0, $5kTkA.getRankFromPopularity)(superstar.popularity) === "Main Eventer") chance -= 15 / talentSuperstars.length;
            if (superstar.faceOfTheCompany) chance -= 30 / talentSuperstars.length;
            if (superstar.hot) chance -= 20 / talentSuperstars.length;
            if (superstar.contractMonthsRemaining !== null) chance += 30 / talentSuperstars.length;
            if ((await (0, $hBIDz.getSuperstarChampionships)(superstar)).length) chance -= 20;
        }
        // Get offer multiplier
        let value = await $2c427b5109924a54$export$3697c6750c97e7ff(negotiation, talent, await (0, $csISS.getNegotiationSenderCompany)(negotiation), receiverCompany);
        let offer = negotiation.offeredAmount;
        let offerMultiplier = offer / value;
        chance *= offerMultiplier;
    }
    return chance;
}
async function $2c427b5109924a54$var$acceptTalentOffer(negotiation) {
    negotiation.status = "accepted_by_company";
    negotiation.monthsToRemove = 2;
    let talent = await (0, $csISS.getNegotiationTalent)(negotiation);
    let superstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
    let company = await (0, $csISS.getNegotiationSenderCompany)(negotiation);
    let offerReceivingCompany = await (0, $csISS.getNegotiationReceiverCompany)(negotiation);
    let game = await (0, $9esFv.getCompanyGame)(company);
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    let month = game.monthCount;
    let year = game.year;
    // Add points to receiving company
    if (offerReceivingCompany) offerReceivingCompany.points += negotiation.offeredAmount;
    // Get roster to add superstar to
    let rosterToAddTo;
    if (company.userControlled) {
        rosterToAddTo = await (0, $8A6FL.getCompanyRosterByType)(company, "training");
        if (negotiation.sendToMainRoster) rosterToAddTo = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    } else rosterToAddTo = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let vacated = [];
    let disbanded = [];
    for (let s of superstars){
        // Add to company's roster
        await (0, $dl5u4.addRosterSuperstars)(rosterToAddTo, [
            s
        ]);
        // Add overness boost
        let overnessIncrease = (0, $3E8Nt.getRandomInt)(8, 12);
        s.overness += overnessIncrease;
        if (s.overness > 100) s.overness = 100;
        // Remove interested relationship
        for (const relationship of (await (0, $hBIDz.getSuperstarRelationships)(s)).filter((x)=>x.interested))await (0, $14eBR.Relationships).remove(relationship);
        // Add former company relationship
        if (offerReceivingCompany) {
            for (const relationship of (await (0, $hBIDz.getSuperstarRelationships)(s)).filter((x)=>x.type === "former_company"))await (0, $14eBR.Relationships).remove(relationship);
            await (0, $8A6FL.addFormerCompanyRelationship)(s, offerReceivingCompany);
            // Delete talent requests
            for (const talentRequest of (await (0, $hBIDz.getSuperstarTalentRequests)(s)))await (0, $14eBR.TalentRequests).remove(talentRequest);
            // Process POW stars leaving
            if (offerReceivingCompany.storyName === "passion") await (0, $jC7EP.processPowSuperstarLeavesCompany)(s, offerReceivingCompany);
        }
        // Vacate championships, remove teams
        if (offerReceivingCompany) {
            const vacatedChampionships = await (0, $5kTkA.vacateChampionships)({
                superstar: s,
                championships: await (0, $9esFv.getCompanyChampionships)(offerReceivingCompany),
                month: month,
                year: year
            });
            if (vacatedChampionships.length) vacated.push(...vacatedChampionships);
        }
        let superstarTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary && x.$loki !== talent.$loki);
        for (let superstarTagTeam of superstarTagTeams){
            disbanded.push(superstarTagTeam.name);
            await (0, $ko5kE.removeTagTeam)(superstarTagTeam);
        }
        // Remove relationships
        await (0, $5kTkA.removeSuperstarFactionRelationships)(s, month, year);
        await (0, $5kTkA.removeSuperstarManagerRelationships)(s);
        s.brandName = null;
        if (s.activeEffect === "traded") {
            s.activeEffect = null; // fix for trade superstars of folded companies
            if (!s.partTimer) s.appearances = null;
        }
        // Remove feuds
        for (const feud of (await (0, $hBIDz.getSuperstarFeuds)(s)))if (!feud.ended) {
            feud.ended = true;
            feud.endMonth = month;
            feud.endYear = year;
            // For ending potential feuds
            if (!feud.started) feud.rating = null;
            else feud.rating = await (0, $cXLSF.getFeudRating)(feud);
        }
        // Reset morale, fotc, suspension, temporary stats
        (0, $5kTkA.changeSuperstarMoraleToHappy)(s);
        s.faceOfTheCompanyCounter = 0;
        s.suspensionMonths = 0;
        s.winsTemporary = 0;
        s.lossesTemporary = 0;
    }
    // Move team
    if (talent.objectName === "tagTeam") {
        await (0, $dl5u4.addRosterTagTeams)(rosterToAddTo, [
            talent
        ]);
        // Add signing company log for team's superstars
        for (const s of superstars){
            const newLog = (0, $4K85d.CompanyLog)(month, company.realYear);
            (0, $14eBR.CompanyLogs).insert(newLog);
            newLog.text = s.name;
            newLog.value = negotiation.offeredAmount;
            newLog.type = "signing";
            newLog.realYear = year;
            await (0, $9esFv.addCompanyCompanyLogs)(company, [
                newLog
            ]);
        }
    }
    // Add signing company log for talent (superstar or team)
    const newLog = (0, $4K85d.CompanyLog)(month, company.realYear);
    (0, $14eBR.CompanyLogs).insert(newLog);
    newLog.text = talent.name;
    newLog.value = negotiation.offeredAmount;
    newLog.type = "signing";
    newLog.realYear = year;
    await (0, $9esFv.addCompanyCompanyLogs)(company, [
        newLog
    ]);
    // Add news
    let newsItem = await (0, $kZMqI.generateNewsItem)({
        company: company,
        month: game.newsMonth,
        year: game.newsYear,
        superstar: talent,
        newsType: "new_signing"
    });
    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
        newsItem
    ]);
    // If offer sent by user controlled company, add talent joined and offer accepted message and company alert
    if (company.userControlled) {
        for (const s of superstars){
            const newMessage = await (0, $hekDR.createJoinedCompanySuperstarMessage)(s, month, year);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        if (offerReceivingCompany) {
            const newMessage = await (0, $hekDR.createTalentOfferAcceptedMessage)(talent, month, year, offerReceivingCompany);
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("talentOfferAccepted", talent.name);
        await (0, $9esFv.addCompanyCompanyAlerts)(company, [
            newCompanyAlert
        ]);
    }
    // If offer sent to user controlled company, add message about talent released
    if (offerReceivingCompany && offerReceivingCompany.userControlled) {
        const newMessage = await (0, $hekDR.createTalentReleasedMessage)(talent, await (0, $9esFv.getCompanyStaff)(offerReceivingCompany), month, year, vacated, disbanded);
        await (0, $9esFv.addCompanyMessages)(offerReceivingCompany, [
            newMessage
        ]);
    }
    // Change objective properties
    if (company.userControlled) {
        if (superstars.length > 0 && await (0, $3E8Nt.getRosterMemberRank)(talent) === "Main Eventer") {
            let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                name: "main eventers signed",
                change: 1,
                company: company
            });
            if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
        }
    }
    // Remove other offers for talent
    let offers = (await $2c427b5109924a54$var$getTalentNegotiations(talent)).filter((x)=>x.status !== "accepted_by_company");
    for (const offer of offers){
        if (offer.status === "accepted_by_talent") {
            // Return points
            let offerSenderCompany = await (0, $csISS.getNegotiationSenderCompany)(offer);
            offerSenderCompany.points += offer.offeredAmount;
            // If offer sent by user controlled company, add rejected message and company alert
            if (offerSenderCompany.userControlled) {
                const newMessage = await (0, $hekDR.createTalentOfferRejectedByTalentMessage)(talent, month, year, company);
                await (0, $9esFv.addCompanyMessages)(offerSenderCompany, [
                    newMessage
                ]);
                const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("talentOfferRejected", talent.name);
                await (0, $9esFv.addCompanyCompanyAlerts)(offerSenderCompany, [
                    newCompanyAlert
                ]);
            }
        }
        await (0, $14eBR.Negotiations).remove(offer);
    }
    return true;
}
async function $2c427b5109924a54$var$rejectTalentOffer(negotiation, autoRejectOffers = false) {
    negotiation.status = "rejected_by_company";
    negotiation.monthsToRemove = (0, $3E8Nt.getRandomInt)(4, 6);
    let talent = await (0, $csISS.getNegotiationTalent)(negotiation);
    let superstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
    let company = await (0, $csISS.getNegotiationSenderCompany)(negotiation);
    let offerReceivingCompany = await (0, $csISS.getNegotiationReceiverCompany)(negotiation);
    let game = await (0, $9esFv.getCompanyGame)(company);
    // Lower morale if not auto rejected
    if (!autoRejectOffers) for (let s of superstars)await (0, $5kTkA.updateSuperstarMorale)(s, (0, $3E8Nt.getRandomInt)(-30, -25));
    // If offer sent by user controlled company, add rejected message and company alert
    if (company.userControlled) {
        let newMessage = await (0, $hekDR.createTalentOfferRejectedMessage)(talent, game.monthCount, game.year, offerReceivingCompany);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        let newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("talentOfferRejected", talent.name);
        await (0, $9esFv.addCompanyCompanyAlerts)(company, [
            newCompanyAlert
        ]);
    }
    // If offer sent to user controlled company, add message about low morale
    if (offerReceivingCompany && offerReceivingCompany.userControlled && !autoRejectOffers) {
        let newMessage = await (0, $hekDR.createTalentOfferDeclinedMessage)(talent, game.monthCount, game.year, offerReceivingCompany);
        await (0, $9esFv.addCompanyMessages)(offerReceivingCompany, [
            newMessage
        ]);
    }
    // Return points to offer company
    company.points += negotiation.offeredAmount;
    // Remove other offers for talent
    let offers = (await $2c427b5109924a54$var$getTalentNegotiations(talent)).filter((offer)=>offer.status === "accepted_by_talent");
    for (let offer of offers){
        offer.status = "rejected_by_company";
        offer.monthsToRemove = (0, $3E8Nt.getRandomInt)(4, 6);
        // Return points
        let offerSenderCompany = await (0, $csISS.getNegotiationSenderCompany)(offer);
        offerSenderCompany.points += offer.offeredAmount;
        // If offer sent by user controlled company, add rejected message and company alert
        if (offerSenderCompany.userControlled) {
            let newMessage = await (0, $hekDR.createTalentOfferRejectedMessage)(talent, game.monthCount, game.year, offerReceivingCompany);
            await (0, $9esFv.addCompanyMessages)(offerSenderCompany, [
                newMessage
            ]);
            let newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("talentOfferRejected", talent.name);
            await (0, $9esFv.addCompanyCompanyAlerts)(offerSenderCompany, [
                newCompanyAlert
            ]);
        }
    }
    return true;
}
// Talent Offer (incoming negotiation)
async function $2c427b5109924a54$export$79ba20bc94038647(negotiation) {
    const data = {};
    const talent = await (0, $csISS.getNegotiationTalent)(negotiation);
    const topSuperstar = (0, $3E8Nt.getArrayMaxByProperty)(await (0, $5kTkA.getRosterMemberSuperstars)(talent), "popularity");
    data["name"] = talent.name;
    data["uid"] = talent.$loki;
    data["type"] = talent.objectName;
    let topSuperstarGraphic = topSuperstar.graphic;
    if (!topSuperstarGraphic || Object.keys(topSuperstarGraphic).length === 0) topSuperstarGraphic = (0, $5kTkA.getEmptySuperstarGraphic)(topSuperstar);
    data["graphic"] = [
        topSuperstarGraphic
    ];
    data["dialog"] = $2c427b5109924a54$var$getTalentOfferDialog(negotiation, talent);
    // Get offers
    data["offers"] = [];
    const offers = (await $2c427b5109924a54$var$getTalentNegotiations(talent)).filter((x)=>x.status === "accepted_by_talent");
    for (const offer of offers){
        const offerCompany = await (0, $csISS.getNegotiationSenderCompany)(offer);
        data["offers"].push({
            "companyName": offerCompany.name,
            "offeredAmount": offer.offeredAmount,
            "uid": offer.$loki
        });
    }
    data["offers"].sort((a, b)=>b.offeredAmount - a.offeredAmount);
    return data;
}
function $2c427b5109924a54$var$getTalentOfferDialog(negotiation, talent) {
    const negotiationRandom = new Math.seedrandom(negotiation.meta.created);
    let dialogs = talent.objectName === "superstar" ? (0, $eiAJX.negotiationSuperstarDialogData) : (0, $eiAJX.negotiationTagDialogData);
    if (negotiation.status === "accepted_by_talent") dialogs = dialogs["talent_offer"];
    else if (negotiation.status === "accepted_by_company") dialogs = dialogs["talent_offer_accepted"];
    else if (negotiation.status === "rejected_by_company") dialogs = dialogs["talent_offer_rejected"];
    return (0, $3E8Nt.getRandomChoice)(dialogs, negotiationRandom());
}
async function $2c427b5109924a54$export$e8e3ae0eebbbd185({ uid: uid, selectedChoice: selectedChoice } = {}) {
    const data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const negotiation = await (0, $14eBR.Negotiations).get(uid);
    const talent = await (0, $csISS.getNegotiationTalent)(negotiation);
    if (selectedChoice === "accept") await $2c427b5109924a54$var$acceptTalentOffer(negotiation);
    else if (selectedChoice === "reject") await $2c427b5109924a54$var$rejectTalentOffer(negotiation);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["dialog"] = $2c427b5109924a54$var$getTalentOfferDialog(negotiation, talent);
    data["points"] = userCompany.points;
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(userCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}

});
parcelRequire.register("eiAJX", function(module, exports) {

$parcel$export(module.exports, "negotiationSuperstarDialogData", () => $a68f3ef8facbc241$export$bce2243417e538ab);
$parcel$export(module.exports, "negotiationTagDialogData", () => $a68f3ef8facbc241$export$851b646941ef3084);
const $a68f3ef8facbc241$export$bce2243417e538ab = {
    // Outgoing offer
    "negotiating": {
        3: [
            "Give me your best offer.",
            "What number did you have on your mind?",
            "Okay, I'm ready to hear your offer.",
            "Let's make this quick. I got places to be.",
            "Don't you dare lowball me.",
            "Before you start, you do know my actual value, right?",
            "Okay, put your cards on the table.",
            "Let's work towards an offer I like.",
            "I'm ready to hear your offer.",
            "Okay. What's your offer?",
            "Make me an offer I can't refuse.",
            "Let's see if I can work for you."
        ],
        2: [
            "Let's see what else you got.",
            "That's it? I could get better offers from my backyard indie promotion!",
            "Sorry, but I'm looking for a better offer.",
            "I'm not going to come work for you for that offer.",
            "I expected better from you.",
            "I didn't know you were a cheapskate.",
            "Let's try that again, shall we?",
            "Is that all you think I'm worth?",
            "That's too low for me.",
            "You better put some ice cream bars on top of that offer.",
            "I think you could go higher.",
            "Ladies and gentlemen, we found a penny pincher!"
        ],
        1: [
            "Last chance to win me over.",
            "You keep lowballing me and we won't have a deal.",
            "One more bad offer and I'm out.",
            "I'm not going to stick around much longer for this.",
            "Present a better offer or we're done here.",
            "You're not so good at this.",
            "I'll hear one final offer but that's it.",
            "Last attempt to convince me.",
            "Last try. I'm not bluffing.",
            "Don't make another bad offer.",
            "One more low offer and I'm done.",
            "You got one final chance to convince me."
        ]
    },
    "accepted_by_talent": [
        "The deal is done.",
        "I'll pop for that offer.",
        "It's a done deal.",
        "That's what I'm talking about.",
        "I knew you had it in you!",
        "I'll gladly accept that offer.",
        "I can't say no to that.",
        "That works for me.",
        "Now that's an offer I can agree to.",
        "You got it!",
        "Thank you. That's what I was looking for.",
        "I'm glad we came to an understanding.",
        "I'll accept those terms.",
        "That's an offer I must accept.",
        "That's a good offer. I accept.",
        "Glad we could work out a deal."
    ],
    "rejected_by_talent": [
        "I'm not interested in negotiating any further.",
        "No deal.",
        "I won't take any more offers from you.",
        "We're done here.",
        "Sorry, you couldn't convince me.",
        "I won't consider any more offers from you.",
        "It's over. Leave me alone.",
        "You really suck at this, don't you?",
        "No. And don't you go talking to the dirtsheets about this!",
        "Sorry it didn't work out.",
        "No more offers.",
        "I can't negotiate with you anymore."
    ],
    "rejected_by_company": [
        "I'm not allowed to entertain any more offers from you.",
        "My company is stupid. The sooner I leave the better.",
        "I can't negotiate again. Sorry.",
        "I really wanted it to work out, but the people above didn't.",
        "I don't think you should be approaching me anymore.",
        "They really think they can stop me from leaving? Hah!",
        "We can't negotiate again.",
        "We can't do this again right now.",
        "Those idiots above blocked the offer.",
        "We can negotiate as soon as I leave.",
        "They can't hold on to me forever.",
        "I can't believe they wouldn't let me leave."
    ],
    // Incoming offer
    "talent_offer": [
        "I received a good offer to work somewhere else. I'd like you to consider it.",
        "Could you take a look at this offer I received?",
        "I'm looking to take this offer. What do you think?",
        "I got a good offer from somewhere else. Please consider it seriously.",
        "I think it would be best for me to take this offer. Don't you agree?",
        "Look at this offer! You can't pass this up.",
        "Let me take this offer and leave. It's best for both of us.",
        "I could be making so much more money with this offer. You need to accept it.",
        "You better accept this offer, or else!",
        "No way I'm passing up this money. Release me now!",
        "I've made up my mind about leaving. There's no point dragging it any further.",
        "Time for me to go to greener pastures. And by greener I mean lots more money."
    ],
    "talent_offer_accepted": [
        "Thank you very much.",
        "I knew you'd do what's best.",
        "I always knew you were smart.",
        "I hope to work with you again sometime.",
        "I think this is best for everyone right now.",
        "I'm glad you agreed.",
        "Thank you for releasing me.",
        "So, guess this is it?",
        "You get the money and I get to leave. Win win.",
        "I knew you couldn't pass up the money!",
        "I hope to return someday.",
        "Thanks for letting me go where I want."
    ],
    "talent_offer_rejected": [
        "You're going to regret doing that.",
        "You're going to pay for that.",
        "You just pissed me off.",
        "You really know how to take care of your talent, don't you?",
        "I'm not going to stay here much longer.",
        "Why would you do that? You know it's what I wanted.",
        "I really wanted to take that offer.",
        "You suck.",
        "I really thought that was a good deal.",
        "I can't believe you didn't agree to that.",
        "You just gained an enemy.",
        "You're not going to hold on to me for much longer."
    ]
};
const $a68f3ef8facbc241$export$851b646941ef3084 = {
    // Outgoing offer
    "negotiating": {
        3: [
            "Give us your best offer.",
            "What number did you have on your mind?",
            "Okay, we're ready to hear your offer.",
            "Let's make this quick. We got places to be.",
            "Don't you dare lowball us.",
            "Before you start, you do know our actual value, right?",
            "Okay, put your cards on the table.",
            "Let's work towards an offer we like.",
            "We're ready to hear your offer.",
            "Okay. What's your offer?",
            "Make us an offer we can't refuse.",
            "Let's see if we can work for you."
        ],
        2: [
            "Let's see what else you got.",
            "That's it? We could get better offers from my backyard indie promotion!",
            "Sorry, but we're looking for a better offer.",
            "We're not going to come work for you for that offer.",
            "We expected better from you.",
            "We didn't know you were a cheapskate.",
            "Let's try that again, shall we?",
            "Is that all you think we're worth?",
            "That's too low for us.",
            "You better put some ice cream bars on top of that offer.",
            "We think you could go higher.",
            "Ladies and gentlemen, we found a penny pincher!"
        ],
        1: [
            "Last chance to win us over.",
            "You keep lowballing us and we won't have a deal.",
            "One more bad offer and we're out.",
            "We're not going to stick around much longer for this.",
            "Present a better offer or we're done here.",
            "You're not so good at this.",
            "We'll hear one final offer but that's it.",
            "Last attempt to convince us.",
            "Last try. We're not bluffing.",
            "Don't make another bad offer.",
            "One more low offer and we're done.",
            "You got one final chance to convince us."
        ]
    },
    "accepted_by_talent": [
        "The deal is done.",
        "We'll pop for that offer.",
        "It's a done deal.",
        "That's what we're talking about.",
        "We knew you had it in you!",
        "We'll gladly accept that offer.",
        "We can't say no to that.",
        "That works for us.",
        "Now that's an offer we can agree to.",
        "You got it!",
        "Thank you. That's what we were looking for.",
        "We're glad we came to an understanding.",
        "We'll accept those terms.",
        "That's an offer we must accept.",
        "That's a good offer. We accept.",
        "Glad we could work out a deal."
    ],
    "rejected_by_talent": [
        "We're not interested in negotiating any further.",
        "No deal.",
        "We won't take any more offers from you.",
        "We're done here.",
        "Sorry, you couldn't convince us.",
        "We won't consider any more offers from you.",
        "It's over. Leave us alone.",
        "You really suck at this, don't you?",
        "No. And don't you go talking to the dirtsheets about this!",
        "Sorry it didn't work out.",
        "No more offers.",
        "We can't negotiate with you anymore."
    ],
    "rejected_by_company": [
        "We're not allowed to entertain any more offers from you.",
        "Our company is stupid. The sooner we leave the better.",
        "We can't negotiate again. Sorry.",
        "We really wanted it to work out, but the people above didn't.",
        "We don't think you should be approaching us anymore.",
        "They really think they can stop us from leaving? Hah!",
        "We can't negotiate again.",
        "We can't do this again right now.",
        "Those idiots above blocked the offer.",
        "We can negotiate as soon as we leave.",
        "They can't hold on to us forever.",
        "We can't believe they wouldn't let us leave."
    ],
    // Incoming offer
    "talent_offer": [
        "We received a good offer to work somewhere else. We'd like you to consider it.",
        "Could you take a look at this offer we received?",
        "We're looking to take this offer. What do you think?",
        "We got a good offer from somewhere else. Please consider it seriously.",
        "We think it would be best for us to take this offer. Do you agree?",
        "Look at this offer! You can't pass this up.",
        "Let us take this offer and leave. It's best for both of us.",
        "We could be making so much more money with this offer. You need to accept it.",
        "You better accept this offer, or else!",
        "No way we're passing up this money. Release us now!",
        "We've made up our minds about leaving. There's no point dragging it any further.",
        "Time for us to go to greener pastures. And by greener We mean lots more money."
    ],
    "talent_offer_accepted": [
        "Thank you very much.",
        "We knew you'd do what's best.",
        "We always knew you were smart.",
        "We hope to work with you again sometime.",
        "We think this is best for everyone right now.",
        "We're glad you agreed.",
        "Thank you for releasing us.",
        "So, guess this is it?",
        "You get the money and we get to leave. Win win.",
        "We knew you couldn't pass up the money!",
        "We hope to return someday.",
        "Thanks for letting us go where we want."
    ],
    "talent_offer_rejected": [
        "You're going to regret doing that.",
        "You're going to pay for that.",
        "You just pissed us off.",
        "You really know how to take care of your talent, don't you?",
        "We're not going to stay here much longer.",
        "Why would you do that? You know it's what we wanted.",
        "We really wanted to take that offer.",
        "You suck.",
        "We really thought that was a good deal.",
        "We can't believe you didn't agree to that.",
        "You just gained an enemy.",
        "You're not going to hold on to us for much longer."
    ]
};

});


parcelRequire.register("8ugbL", function(module, exports) {

$parcel$export(module.exports, "scoutTalent", () => $62ddaecbdddc992b$export$46d23113bb4ff73c);
$parcel$export(module.exports, "recruitTalent", () => $62ddaecbdddc992b$export$ea10abfe889cf133);
$parcel$export(module.exports, "buildInterest", () => $62ddaecbdddc992b$export$7a645f871be7b09d);
$parcel$export(module.exports, "reassureTalent", () => $62ddaecbdddc992b$export$9e89e0f59c21ecd0);
$parcel$export(module.exports, "transitionTalent", () => $62ddaecbdddc992b$export$39563ee00f41951b);
$parcel$export(module.exports, "unlearnTalentTrait", () => $62ddaecbdddc992b$export$c3fcc591d10a1be7);
$parcel$export(module.exports, "transitionSuperstarToStaffMember", () => $62ddaecbdddc992b$export$2c9d70b6fa0467a6);
$parcel$export(module.exports, "transitionStaffMemberToSuperstar", () => $62ddaecbdddc992b$export$26a09fa76165449b);
$parcel$export(module.exports, "trainTalent", () => $62ddaecbdddc992b$export$5f5d86342cba611e);
$parcel$export(module.exports, "makeTrainingTalentAvailable", () => $62ddaecbdddc992b$export$7f222cb17890ef82);
$parcel$export(module.exports, "getTalentRehabDoctor", () => $62ddaecbdddc992b$export$9810e127b40361fd);
$parcel$export(module.exports, "getRehabChance", () => $62ddaecbdddc992b$export$e94a5398abbc7e7d);

var $9esFv = parcelRequire("9esFv");

var $ko5kE = parcelRequire("ko5kE");

var $5kTkA = parcelRequire("5kTkA");

var $3E8Nt = parcelRequire("3E8Nt");

var $hekDR = parcelRequire("hekDR");

var $jpMCP = parcelRequire("jpMCP");

var $hBIDz = parcelRequire("hBIDz");

var $5JRw3 = parcelRequire("5JRw3");

var $14eBR = parcelRequire("14eBR");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $cXLSF = parcelRequire("cXLSF");

var $3SyPM = parcelRequire("3SyPM");

var $4ptHI = parcelRequire("4ptHI");

var $1olyO = parcelRequire("1olyO");

var $aP7lq = parcelRequire("aP7lq");

var $bZol7 = parcelRequire("bZol7");
async function $62ddaecbdddc992b$export$46d23113bb4ff73c(talent, indieRoster, indieAvailableRoster, scout, company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let talentType = talent.objectName;
    let talentInfo;
    if (talentType === "tagTeam") talentInfo = await (0, $ko5kE.getTagTeamDisplayData)({
        tagTeam: talent
    });
    else talentInfo = await (0, $5kTkA.getSuperstarDisplayData)({
        superstar: talent
    });
    // Recruit talent chance
    let chances = {
        1: 20,
        2: 40,
        3: 60
    };
    let scoutLevel = scout ? scout.level : 1;
    let recruited = false;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= (chances[scoutLevel] || 60)) {
        await $62ddaecbdddc992b$var$makeTalentAvailable(talent, indieAvailableRoster);
        recruited = true;
    }
    let newMessage = await (0, $hekDR.createScoutingReportMessage)(talentInfo, scout, game.monthCount, game.year, recruited);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    return newMessage;
}
async function $62ddaecbdddc992b$export$ea10abfe889cf133(talent, indieRoster, indieAvailableRoster, scout, company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let talentType = talent.objectName;
    let scoutLevel = scout ? scout.level : 1;
    let recruitmentChances = {
        1: 40,
        2: 60,
        3: 80
    };
    let chance = recruitmentChances[scoutLevel] || 80;
    let newMessage;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= chance) {
        // Build interest chance
        let buildInterestChances = {
            2: 10,
            3: 20
        };
        let interested = false;
        let scoutingFacility = (await (0, $9esFv.getCompanyFacilities)(company)).find((x)=>x.name === "Scouting");
        if (scoutLevel >= 2 && talentType === "superstar" && scoutingFacility && scoutingFacility.level >= 2) {
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= (buildInterestChances[scoutLevel] || 20)) {
                await (0, $5kTkA.addInterestedRelationship)(talent, company);
                interested = true;
            }
        }
        await $62ddaecbdddc992b$var$makeTalentAvailable(talent, indieAvailableRoster);
        newMessage = await (0, $hekDR.createRecruitmentSuccessMessage)(talent, game.monthCount, game.year, scout, interested);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    } else {
        newMessage = await (0, $hekDR.createRecruitmentFailMessage)(talent, game.monthCount, game.year, scout);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    }
    return newMessage;
}
async function $62ddaecbdddc992b$var$makeTalentAvailable(talent, indieAvailableRoster) {
    // Move to indie available roster
    let talentSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talent);
    let superstarToTransfer = talentSuperstars[0];
    let transferred = await (0, $jpMCP.transferTalentToRoster)(superstarToTransfer, indieAvailableRoster);
    for (let superstar of talentSuperstars)superstar.availableThisMonth = true;
    return transferred;
}
async function $62ddaecbdddc992b$export$7a645f871be7b09d(indieAvailableSuperstars, scout, company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let chances = {
        2: 10,
        3: 20
    };
    let scoutLevel = scout ? scout.level : 1;
    let superstar = null;
    if (indieAvailableSuperstars.length && (0, $3E8Nt.getRandomInt)(0, 100) <= (chances[scoutLevel] || 20)) {
        superstar = (0, $3E8Nt.getRandomChoice)(indieAvailableSuperstars);
        await (0, $5kTkA.addInterestedRelationship)(superstar, company);
        // Add message from superstar or scout
        let newMessage;
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 50) newMessage = await (0, $hekDR.createSuperstarInterestMessage)(superstar, scout, game.monthCount, game.year);
        else newMessage = await (0, $hekDR.createSuperstarInterestedScoutMessage)(superstar, scout, game.monthCount, game.year);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    }
    return superstar;
}
async function $62ddaecbdddc992b$export$9e89e0f59c21ecd0(talent, talentManager, company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let talentManagerLevel = talentManager ? talentManager.level : 1;
    let moraleChangeDict = {
        1: 8,
        2: 13,
        3: 20
    };
    let reassureChances = {
        1: 50,
        2: 60,
        3: 70
    };
    let chance = reassureChances[talentManagerLevel] || 70;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= chance) {
        let moraleChange = (moraleChangeDict[talentManagerLevel] || 20) + (0, $3E8Nt.getRandomInt)(0, 3);
        (0, $5kTkA.updateSuperstarMorale)(talent, moraleChange);
        let newMessage = await (0, $hekDR.createReassureSuccessMessage)(talent, moraleChange, game.monthCount, game.year, talentManager);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    } else {
        let moraleChange = (0, $3E8Nt.getRandomInt)(-6, -3);
        (0, $5kTkA.updateSuperstarMorale)(talent, moraleChange);
        let newMessage = await (0, $hekDR.createReassureFailureMessage)(talent, moraleChange, game.monthCount, game.year, talentManager);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    }
    return true;
}
async function $62ddaecbdddc992b$export$39563ee00f41951b(talent, trainer, company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let role;
    if (talent.fullTimeManager) {
        talent.fullTimeManager = false;
        role = "superstar";
    } else {
        talent.fullTimeManager = true;
        role = "manager";
        let manager = await (0, $hBIDz.getSuperstarManager)(talent);
        if (manager) await (0, $5kTkA.removeSuperstarsFromManager)(manager, [
            talent
        ]);
    }
    let newMessage = await (0, $hekDR.createTransitionFinishedMessage)(talent, game.monthCount, game.year, trainer, role);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    return true;
}
async function $62ddaecbdddc992b$export$c3fcc591d10a1be7(talent, staffMember, company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let staffMemberLevel = staffMember ? staffMember.level : 1;
    let unlearnChances = {
        1: 60,
        2: 75,
        3: 90
    };
    let chance = unlearnChances[staffMemberLevel] || 90;
    let traitToRemove = staffMember.taskData["trait_name"];
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= chance && traitToRemove) {
        (0, $5kTkA.removeTraitFromSuperstar)(talent, traitToRemove);
        let newMessage = await (0, $hekDR.createUnlearnTraitSuccessMessage)(talent, game.monthCount, game.year, traitToRemove, staffMember);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    } else {
        let newMessage = await (0, $hekDR.createUnlearnTraitFailureMessage)(talent, game.monthCount, game.year, traitToRemove, staffMember);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    }
    return true;
}
async function $62ddaecbdddc992b$export$2c9d70b6fa0467a6(superstar, taskStaffMember, company) {
    let role = taskStaffMember.taskData["role_name"];
    let game = await (0, $9esFv.getCompanyGame)(company);
    let month = game.monthCount;
    let year = game.year;
    let superstarRoster = await (0, $hBIDz.getSuperstarRoster)(superstar);
    // Check for existing staff object, otherwise create new
    let existingStaffObject = await (0, $hBIDz.getSuperstarStaffObject)(superstar);
    let staffObject;
    if (existingStaffObject) staffObject = existingStaffObject;
    else {
        let newStaffObject = (0, $5JRw3.Staff)();
        await (0, $14eBR.StaffMembers).insert(newStaffObject);
        newStaffObject.role = role;
        await (0, $hBIDz.addSuperstarStaffObjects)(superstar, [
            newStaffObject
        ]); // Link staff object to superstar
        staffObject = newStaffObject;
        // Add xp boost
        let roleBoostData = (0, $8A6FL.getTransitionToStaffMemberRoleBoostData)(superstar, role);
        newStaffObject.xp = roleBoostData["xpBoost"];
    }
    // Update shared attributes
    staffObject.name = superstar.name;
    staffObject.gender = superstar.gender;
    staffObject.age = superstar.age;
    staffObject.graphic = superstar.graphic;
    // Add staff member to company
    await (0, $9esFv.addCompanyStaff)(company, [
        staffObject
    ]);
    // Remove superstar from their roster
    if (superstarRoster) await (0, $dl5u4.removeRosterSuperstars)(superstarRoster, [
        superstar
    ]);
    // Remove championships, tag teams, relationships
    await (0, $5kTkA.vacateChampionships)({
        superstar: superstar,
        championships: await (0, $9esFv.getCompanyChampionships)(company),
        month: month,
        year: year
    });
    await (0, $5kTkA.removeSuperstarTagTeams)(superstar);
    await (0, $5kTkA.removeSuperstarFactionRelationships)(superstar, month, year);
    await (0, $5kTkA.removeSuperstarManagerRelationships)(superstar);
    superstar.brandName = null;
    for (const negotiation of (await (0, $hBIDz.getSuperstarNegotiations)(superstar)))await (0, $14eBR.Negotiations).remove(negotiation);
    for (const talentRequest of (await (0, $hBIDz.getSuperstarTalentRequests)(superstar)))await (0, $14eBR.TalentRequests).remove(talentRequest);
    for (const feud of (await (0, $hBIDz.getSuperstarFeuds)(superstar)))if (!feud.ended) {
        feud.ended = true;
        feud.endMonth = month;
        feud.endYear = year;
        if (!feud.started) feud.rating = null;
        else feud.rating = await (0, $cXLSF.getFeudRating)(feud);
    }
    // Reset temporary attributes
    superstar.faceOfTheCompanyCounter = 0;
    superstar.suspensionMonths = 0;
    superstar.kayfabePointsTemporary = 0;
    superstar.winsTemporary = 0;
    superstar.lossesTemporary = 0;
    // Add messages
    let newMessage = await (0, $hekDR.createTransitionToStaffFinishedMessage)(superstar, month, year, taskStaffMember, role);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    let newSuperstarMessage = await (0, $hekDR.createTransitionToStaffFinishedSuperstarMessage)(superstar, month, year, role);
    await (0, $9esFv.addCompanyMessages)(company, [
        newSuperstarMessage
    ]);
    return true;
}
async function $62ddaecbdddc992b$export$26a09fa76165449b(staffMember, taskStaffMember, company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    let month = game.monthCount;
    let year = game.year;
    // Add superstar to company's main roster
    let superstarObject = await (0, $5JRw3.getStaffSuperstarObject)(staffMember);
    let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    await (0, $dl5u4.addRosterSuperstars)(mainRoster, [
        superstarObject
    ]);
    // Remove staff member from their company
    await (0, $9esFv.removeCompanyStaff)(company, [
        staffMember
    ]);
    // Reset temporary attributes
    (0, $8A6FL.removeStaffTaskData)(staffMember);
    staffMember.unavailableMonths = 0;
    // Update shared attributes
    superstarObject.name = staffMember.name;
    superstarObject.gender = staffMember.gender;
    superstarObject.age = staffMember.age;
    superstarObject.graphic = staffMember.graphic;
    // Add message
    let newMessage = await (0, $hekDR.createTransitionToSuperstarFinishedMessage)(staffMember, month, year, taskStaffMember);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    return true;
}
async function $62ddaecbdddc992b$export$5f5d86342cba611e(talent, skill, trainer, company, staffMembers) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const user = (0, $bZol7.loadUser)();
    const xpGainedDict = {
        1: 25,
        2: 35,
        3: 45
    };
    if (!skill) skill = (0, $3E8Nt.getRandomChoice)([
        "workrate",
        "charisma"
    ]);
    let xpGained = xpGainedDict[trainer.level] || 45;
    // Check for training xp multiplier trait
    for (let trait of talent.traits){
        let traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["training_xp_multiplier"]) xpGained *= traitData["training_xp_multiplier"];
    }
    xpGained = Math.round(xpGained);
    // Add xp to skill
    if (skill === "workrate") {
        talent.workrateXp += xpGained;
        let levelIncrease = await (0, $3SyPM.updateSuperstarWorkrate)(talent, company, staffMembers, game.monthCount, game.year);
        // Unlock special segment
        if (levelIncrease && talent.workrate === 3) await (0, $3SyPM.unlockSpecialSegment)(company, "Dummy Wrestling", game.monthCount, game.year);
    } else if (skill === "charisma") {
        talent.charismaXp += xpGained;
        await (0, $4ptHI.updateSuperstarCharisma)(talent, company, staffMembers, game.monthCount, game.year);
    }
    let data = {
        "skill": skill,
        "xpGained": xpGained
    };
    // Add message from trainer
    let newMessage = await (0, $hekDR.createTrainingFinishedMessage)(talent, data, game.monthCount, game.year, trainer);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Check talent request
    let requestData = {
        "skill": skill
    };
    await (0, $1olyO.checkTalentRequestAction)({
        company: company,
        requestType: "train_skill_x",
        talent: talent,
        data: requestData
    });
    return data;
}
async function $62ddaecbdddc992b$export$7f222cb17890ef82(talent, trainer, trainingAvailableRoster, company) {
    let game = await (0, $9esFv.getCompanyGame)(company);
    await (0, $jpMCP.transferTalentToRoster)(talent, trainingAvailableRoster);
    // Add message from trainer
    let newMessage = await (0, $hekDR.createPreparingFinishedMessage)(talent, game.monthCount, game.year, trainer);
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    return true;
}
function $62ddaecbdddc992b$export$9810e127b40361fd(talent, doctors) {
    return doctors.find((x)=>x.taskData && x.taskData["talent_id"] === talent.$loki);
}
function $62ddaecbdddc992b$export$e94a5398abbc7e7d(doctor, medicalFacility) {
    if (doctor.level >= 3 && medicalFacility.level >= 3) return 25;
    else return 15;
}

});

parcelRequire.register("2A9WA", function(module, exports) {

$parcel$export(module.exports, "getRandomEventData", () => $1e16a83827fcd664$export$90272a23354fe2db);
$parcel$export(module.exports, "addRandomEventChoice", () => $1e16a83827fcd664$export$f4d98b80c26ad4e1);
$parcel$export(module.exports, "checkForStaffRandomEvent", () => $1e16a83827fcd664$export$d85c16accf8fae14);
$parcel$export(module.exports, "randomEventCheck", () => $1e16a83827fcd664$export$c902c8f551e3201f);

var $3E8Nt = parcelRequire("3E8Nt");

var $9esFv = parcelRequire("9esFv");

var $8A6FL = parcelRequire("8A6FL");

var $hekDR = parcelRequire("hekDR");

var $khZb1 = parcelRequire("khZb1");

var $98xmD = parcelRequire("98xmD");

var $9tPJr = parcelRequire("9tPJr");

var $5kTkA = parcelRequire("5kTkA");

var $dl5u4 = parcelRequire("dl5u4");

var $3SyPM = parcelRequire("3SyPM");

var $jDtEn = parcelRequire("jDtEn");

var $972Ip = parcelRequire("972Ip");

var $1olyO = parcelRequire("1olyO");

var $14eBR = parcelRequire("14eBR");

var $hBIDz = parcelRequire("hBIDz");

var $cYLJ6 = parcelRequire("cYLJ6");

var $ivuOU = parcelRequire("ivuOU");

var $6PzHO = parcelRequire("6PzHO");

var $2GWzg = parcelRequire("2GWzg");

var $4K85d = parcelRequire("4K85d");

var $aP7lq = parcelRequire("aP7lq");

var $kZwpB = parcelRequire("kZwpB");

var $kZMqI = parcelRequire("kZMqI");

var $im36F = parcelRequire("im36F");

var $iRMwH = parcelRequire("iRMwH");

var $5ZsVo = parcelRequire("5ZsVo");
async function $1e16a83827fcd664$export$90272a23354fe2db(randomEvent) {
    let data = {};
    data["name"] = randomEvent.name;
    data["choices"] = randomEvent.choices;
    data["uid"] = randomEvent.$loki;
    const message = await (0, $9tPJr.getRandomEventMessage)(randomEvent);
    if (message) {
        data["subject"] = message.subject;
        data["content"] = message.content;
        data["fromName"] = message.fromName;
    }
    return data;
}
async function $1e16a83827fcd664$export$f4d98b80c26ad4e1({ uid: uid, choice: choice } = {}) {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    // Get random event
    const randomEvent = (0, $14eBR.RandomEvents).get(uid);
    // Check for errors
    if (!randomEvent) {
        data["error"] = "random-event-not-found";
        return data;
    }
    if (!randomEvent.choices.includes(choice)) {
        data["error"] = "choice-not-found";
        return data;
    }
    if (randomEvent.selectedChoice) {
        data["error"] = "choice-already-added";
        return data;
    }
    // Add choice
    randomEvent.selectedChoice = choice;
    // Process immediate events
    if (randomEvent.name === "drugAbuse" && choice === "Suspend") await $1e16a83827fcd664$var$processDrugAbuseEvent(randomEvent, userCompany);
    if (randomEvent.name === "drugScandal" && choice === "Suspend") await $1e16a83827fcd664$var$processDrugScandalEvent(randomEvent, userCompany);
    if (randomEvent.name === "superstarBreak" && choice === "Decline") await $1e16a83827fcd664$var$processSuperstarBreakEvent(randomEvent, userCompany);
    if (randomEvent.name === "backstageBrawl" && choice === "Suspend") await $1e16a83827fcd664$var$processBackstageBrawlEvent(randomEvent, userCompany);
    if (randomEvent.name === "conservativeGovernmentShow" && choice === "Accept") {
        // Add news
        let newsItem = await (0, $kZMqI.generateNewsItem)({
            company: userCompany,
            month: game.monthCount,
            year: game.year,
            newsType: "conservative_government_show",
            location: randomEvent.location
        });
        await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
            newsItem
        ]);
    }
    (0, $14eBR.db).saveDatabase();
    // Add reply if message from owner or staff
    const randomEventMessage = await (0, $9tPJr.getRandomEventMessage)(randomEvent);
    if ([
        "owner",
        "staff"
    ].includes(randomEventMessage.tag)) {
        const replies = [
            "Got it.",
            "Understood.",
            "All right."
        ];
        data["replyContent"] = (0, $3E8Nt.getRandomChoice)(replies);
    }
    // Get unread messages count
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(userCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $1e16a83827fcd664$export$d85c16accf8fae14(staffMembers, company) {
    let game = await (0, $3E8Nt.getCurrentGame)();
    let pick = (0, $3E8Nt.getRandomInt)(0, 1000);
    let staffMember = (0, $3E8Nt.getRandomChoice)(staffMembers);
    let data = {};
    // Select random event
    if (pick <= 50) {
        let eventTypePick = (0, $3E8Nt.getRandomInt)(0, 100);
        if (eventTypePick <= 10) {
            data["name"] = "court-case";
            staffMember.unavailableMonths = (0, $3E8Nt.getRandomInt)(4, 8);
        } else if (eventTypePick <= 30) {
            data["name"] = "family-issue";
            staffMember.unavailableMonths = 2;
        } else if (eventTypePick <= 60) {
            data["name"] = "illness";
            staffMember.unavailableMonths = 1;
        }
    }
    // Add message and company alert
    if (data["name"]) {
        let newMessage = await (0, $hekDR.createStaffMemberUnavailableMessage)(staffMember, data, game.monthCount, game.year);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        let newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("randomEvent", (0, $3E8Nt.toTitleCase)(data["name"].replace("-", " ")));
        await (0, $9esFv.addCompanyCompanyAlerts)(company, [
            newCompanyAlert
        ]);
    }
    return data;
}
async function $1e16a83827fcd664$export$c902c8f551e3201f(company, weeklyShow) {
    const data = {};
    // Process existing random events
    const companyRandomEvents = (await (0, $9esFv.getCompanyRandomEvents)(company)).filter((x)=>x.monthsRemaining > 0);
    data["processedEvents"] = await $1e16a83827fcd664$var$processRandomEvents(companyRandomEvents, company, weeklyShow);
    // Run new ones if no existing ones present and after monthly event
    if (!companyRandomEvents.length && !weeklyShow) data["ranEvents"] = await $1e16a83827fcd664$var$runRandomEvents(company);
    return data;
}
async function $1e16a83827fcd664$var$runRandomEvents(company) {
    const ranEvents = [];
    // Chance to run a random event
    const randomEventName = await $1e16a83827fcd664$var$selectRandomEventName(company);
    if (randomEventName && !company.storyName) {
        const randomEventRan = await $1e16a83827fcd664$var$runRandomEvent(randomEventName, company);
        if (randomEventRan) {
            ranEvents.push(randomEventName);
            const newCompanyAlert = await (0, $8A6FL.createCompanyAlert)("randomEvent", `${(0, $3E8Nt.toTitleCase)(randomEventName.replace(/([A-Z])/g, " $1"))}`); // camel case to title case
            await (0, $9esFv.addCompanyCompanyAlerts)(company, [
                newCompanyAlert
            ]);
        }
    }
    return ranEvents;
}
async function $1e16a83827fcd664$var$selectRandomEventName(company) {
    // Select category or skip selection
    const pick = (0, $3E8Nt.getRandomInt)(1, 100);
    let filteredRandomEventsData = [];
    if (pick <= 6 && (0, $98xmD.globalUser).paid) // Major
    filteredRandomEventsData = (0, $khZb1.randomEventsData).filter((x)=>x["category"] === "major");
    else if (pick <= 31) // Minor
    filteredRandomEventsData = (0, $khZb1.randomEventsData).filter((x)=>x["category"] === "minor");
    // Select random event
    if (filteredRandomEventsData.length) {
        const companyRandomEvents = (await (0, $9esFv.getCompanyRandomEvents)(company)).reverse();
        filteredRandomEventsData = filteredRandomEventsData.filter((x)=>$1e16a83827fcd664$var$filterRandomEventSelections(x, companyRandomEvents));
        if (filteredRandomEventsData.length) {
            const randomEvent = (0, $3E8Nt.getRandomChoice)(filteredRandomEventsData);
            return randomEvent["name"];
        }
    }
    return false;
}
function $1e16a83827fcd664$var$filterRandomEventSelections(randomEventData, companyRandomEvents) {
    // Don't run if held within last x random events. Higher limit for non-repeatable and major events.
    let limit;
    if (randomEventData["category"] === "minor") {
        limit = 10;
        if (randomEventData["repeatable"]) limit = 4;
    } else {
        limit = 20;
        if (randomEventData["repeatable"]) limit = 8;
    }
    const previousRandomEventNames = companyRandomEvents.slice(0, limit).map((x)=>x.name);
    return !previousRandomEventNames.includes(randomEventData["name"]);
}
async function $1e16a83827fcd664$var$runRandomEvent(randomEventName, company) {
    // Dictionary of functions
    const randomEventFunctions = {
        // Minor
        "superstarNotAvailable": $1e16a83827fcd664$var$superstarNotAvailableEventFunction,
        "mainstreamCoverage": $1e16a83827fcd664$var$mainstreamCoverageEventFunction,
        "ownerControversy": $1e16a83827fcd664$var$ownerControversyEventFunction,
        "negativeSuperstarCoverage": $1e16a83827fcd664$var$negativeSuperstarCoverageEventFunction,
        "moraleBoost": $1e16a83827fcd664$var$moraleBoostEventFunction,
        "gimmickInterview": $1e16a83827fcd664$var$gimmickInterviewEventFunction,
        "goodTrainingSession": $1e16a83827fcd664$var$goodTrainingSessionEventFunction,
        "neglectedTraining": $1e16a83827fcd664$var$neglectedTrainingEventFunction,
        "hairChange": $1e16a83827fcd664$var$hairChangeEventFunction,
        "gimmickMatchBoost": $1e16a83827fcd664$var$gimmickMatchBoostEventFunction,
        "feudIgnored": $1e16a83827fcd664$var$feudIgnoredEventFunction,
        "feudBoosted": $1e16a83827fcd664$var$feudBoostedEventFunction,
        "cultFollowing": $1e16a83827fcd664$var$cultFollowingEventFunction,
        "wrestlerCourt": $1e16a83827fcd664$var$wrestlerCourtEventFunction,
        "factionBoosted": $1e16a83827fcd664$var$factionBoostedEventFunction,
        "factionIgnored": $1e16a83827fcd664$var$factionIgnoredEventFunction,
        // Major
        "fluBug": $1e16a83827fcd664$var$fluBugEventFunction,
        "flightsCancelled": $1e16a83827fcd664$var$flightsCancelledEventFunction,
        "championshipStolen": $1e16a83827fcd664$var$championshipStolenEventFunction,
        "backstageUnrest": $1e16a83827fcd664$var$backstageUnrestEventFunction,
        "conservativeGovernmentShow": $1e16a83827fcd664$var$conservativeGovernmentShowEventFunction,
        "planeRideSuspensions": $1e16a83827fcd664$var$planeRideSuspensionsEventFunction,
        "stormAffectsShow": $1e16a83827fcd664$var$stormAffectsShowEventFunction,
        "showAppearances": $1e16a83827fcd664$var$showAppearancesEventFunction,
        "drugAbuse": $1e16a83827fcd664$var$drugAbuseEventFunction,
        "backstageFight": $1e16a83827fcd664$var$backstageFightEventFunction,
        "superstarBreak": $1e16a83827fcd664$var$superstarBreakEventFunction,
        "drugScandal": $1e16a83827fcd664$var$drugScandalEventFunction,
        "backstageBrawl": $1e16a83827fcd664$var$backstageBrawlEventFunction
    };
    // Get function and run
    const randomEventFunction = randomEventFunctions[randomEventName];
    if (randomEventFunction) return randomEventFunction(company);
    return null;
}
async function $1e16a83827fcd664$var$processRandomEvents(randomEvents, company, weeklyShow) {
    const processedRandomEvents = [];
    for (const randomEvent of randomEvents){
        if (!weeklyShow) randomEvent.monthsRemaining -= 1;
        const randomEventProcessed = await $1e16a83827fcd664$var$processRandomEvent(randomEvent, company, weeklyShow);
        if (randomEventProcessed) processedRandomEvents.push(randomEvent.name);
    }
    return processedRandomEvents;
}
async function $1e16a83827fcd664$var$processRandomEvent(randomEvent, company, weeklyShow) {
    // Dictionary of functions
    const randomEventFunctions = {
        "championshipStolen": $1e16a83827fcd664$var$processChampionshipStolenEvent,
        "gimmickMatchBoost": $1e16a83827fcd664$var$processGimmickMatchBoostEvent,
        "conservativeGovernmentShow": $1e16a83827fcd664$var$processConservativeGovernmentShowEvent,
        "womenOnlyShow": $1e16a83827fcd664$var$processWomenOnlyShowEvent,
        "drugAbuse": $1e16a83827fcd664$var$processDrugAbuseEvent,
        "superstarBreak": $1e16a83827fcd664$var$processSuperstarBreakEvent,
        "cultFollowing": $1e16a83827fcd664$var$processCultFollowingEvent,
        "drugScandal": $1e16a83827fcd664$var$processDrugScandalEvent,
        "backstageBrawl": $1e16a83827fcd664$var$processBackstageBrawlEvent
    };
    // Get function and run
    const randomEventFunction = randomEventFunctions[randomEvent.name];
    if (randomEventFunction) return randomEventFunction(randomEvent, company, weeklyShow);
    return null;
}
async function $1e16a83827fcd664$var$getActiveSuperstars(roster) {
    return (await (0, $dl5u4.getRosterSuperstars)(roster)).filter((x)=>(0, $5kTkA.checkAvailability)(x) && ![
            "retirement_return",
            "traded"
        ].includes(x.activeEffect));
}
async function $1e16a83827fcd664$var$getCompanyTalentManager(company) {
    return (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "talent_manager");
}
function $1e16a83827fcd664$var$setSuperstarSkillLevelForDecrease(s, skill) {
    const xps = {
        3: 300,
        2: 100,
        1: 0
    };
    if (skill === "workrate") {
        if (s.workrateXp < (xps[s.workrate] || 0)) s.workrate -= 1;
        return s.workrate;
    }
    if (skill === "charisma") {
        if (s.charismaXp < (xps[s.charisma] || 0)) s.charisma -= 1;
        return s.charisma;
    }
}
/*
Run random event functions
 */ async function $1e16a83827fcd664$var$superstarNotAvailableEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select active superstar
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const activeSuperstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    const selectedSuperstar = (0, $3E8Nt.getRandomChoice)(activeSuperstars);
    // Make superstar unavailable, select reason
    selectedSuperstar.unavailable = true;
    const reason = (0, $3E8Nt.getRandomChoice)((0, $khZb1.superstarUnavailableReasons));
    // Create message from superstar
    const messageContent = `<p>${reason["content"]}</p>`;
    const newMessage = await (0, $hekDR.createMessage)(reason["name"], selectedSuperstar.name, game.monthCount, game.year, messageContent, "superstar");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "superstarNotAvailable";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$mainstreamCoverageEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mediaNames = [
        "news channel",
        "entertainment show",
        "magazine",
        "tabloid",
        "media network"
    ];
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(roster);
    // Select brand or company
    let objectToBoost;
    let objectName;
    if (rosterBrands.length && (0, $3E8Nt.getRandomInt)(0, 100) <= 50) {
        objectToBoost = (0, $3E8Nt.getRandomChoice)(rosterBrands);
        objectName = objectToBoost.name;
    } else {
        objectToBoost = company;
        objectName = company.name;
    }
    // Add to overness
    const overnessChange = (0, $3E8Nt.getRandomInt)(5, 10);
    (0, $8A6FL.updateObjectOverness)(objectToBoost, overnessChange);
    (0, $8A6FL.checkObjectHot)(objectToBoost, overnessChange);
    (0, $8A6FL.checkObjectStale)(objectToBoost, overnessChange);
    const changeHtml = `<div class="message-info-box grey">` + `<span class="green margin-right-5"><i class="fa fa-angle-double-up"></i> ${overnessChange}%</span>` + `Overness</div>`;
    const subject = "Mainstream Coverage";
    const content = `<p>A popular ${(0, $3E8Nt.getRandomChoice)(mediaNames)} covered ${objectName} recently, resulting in a ` + `slight boost to overness.</p><p>${changeHtml}</p>`;
    // Create message from owner
    const fromName = company.ownerName || "Owner";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "mainstreamCoverage";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$ownerControversyEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Decrease fans
    const decrease = Math.abs(Math.floor(company.fans * 0.05));
    company.fans -= decrease;
    const ownerName = company.ownerName || `the Owner of ${company.name}`;
    const changeHtml = `<div class="message-info-box grey">` + `<span class="red margin-right-5"><i class="fa fa-angle-double-down"></i> ${decrease.toLocaleString("en")}</span>` + `Fans </div>`;
    const subject = "Controversy";
    const content = `<p>In a recent interview, ${ownerName} took a controversial political position, offending many ` + `viewers. As a result, we've noticed a slight decrease in our fanbase.</p><p>${changeHtml}</p>`;
    // Create message
    const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "ownerControversy";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$negativeSuperstarCoverageEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select active superstar
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    const superstar = (0, $3E8Nt.getRandomChoice)(superstars);
    // Decrease pop
    const decrease = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(50, 100), 10);
    superstar.popularity -= decrease;
    if (superstar.popularity < 0) superstar.popularity = 0;
    const changeHtml = `<div class="message-info-box grey">` + `<span class="red margin-right-5"><i class="fa fa-angle-double-down"></i> ${decrease}</span>` + `Popularity</div>`;
    const subject = "Insensitive Comments";
    const content = `<p>${superstar.name} made some insensitive comments in a recent interview, drawing the ire ` + `of many fans. Other media joined in on the story and as a result, ${superstar.name}'s popularity has ` + `suffered.</p><p>${changeHtml}</p>`;
    // Create message
    const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "negativeSuperstarCoverage";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$moraleBoostEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const activities = [
        "drinks",
        "bowling",
        "a walk",
        "a trip to the amusement park",
        "karaoke"
    ];
    // Select unhappy, active superstar
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    const unhappySuperstars = superstars.filter((x)=>x.unhappy);
    if (!unhappySuperstars.length) return null;
    const superstar = (0, $3E8Nt.getRandomChoice)(unhappySuperstars);
    // Select happy, active superstar
    const happySuperstars = superstars.filter((x)=>!x.unhappy);
    if (!happySuperstars.length) return null;
    // Find superstar with leader trait
    let leaderTraitSuperstars = [];
    let moraleBoostHelperChance = 0;
    for (let s of happySuperstars)for (const trait of s.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["morale_boost_helper_chance"]) {
            leaderTraitSuperstars.push(s);
            moraleBoostHelperChance = traitData["morale_boost_helper_chance"];
        }
    }
    let moraleBoosterSuperstar;
    if (leaderTraitSuperstars.length && (0, $3E8Nt.getRandomInt)(0, 100) <= moraleBoostHelperChance) moraleBoosterSuperstar = (0, $3E8Nt.getRandomChoice)(leaderTraitSuperstars);
    else moraleBoosterSuperstar = (0, $3E8Nt.getRandomChoice)(happySuperstars);
    // Change morale
    (0, $5kTkA.changeSuperstarMoraleToHappy)(superstar);
    // Create message
    const subject = "Morale Boost";
    const content = `<p>I hope you don't mind, but I took out ${superstar.name} for ${(0, $3E8Nt.getRandomChoice)(activities)} ` + `last night. ${(0, $3E8Nt.toTitleCase)(superstar.pronoun)} seemed quite upset, so I thought I'd cheer ${superstar.objectivePronoun} up.</p>` + `<p>We ended up having a real good talk, and I don't think ${superstar.pronoun} will give you any problems in ` + `the near future.</p>`;
    const fromName = moraleBoosterSuperstar.name;
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "superstar");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "moraleBoost";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    // Check to acquire trait
    await (0, $5kTkA.checkAcquireTrait)(moraleBoosterSuperstar, "Leader");
    return true;
}
async function $1e16a83827fcd664$var$gimmickInterviewEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select active superstar
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = [];
    for (let x of (await $1e16a83827fcd664$var$getActiveSuperstars(roster)))if ((await (0, $hBIDz.getSuperstarGimmicks)(x)).length && !x.debutNewGimmick) superstars.push(x);
    if (!superstars.length) return null;
    // Find superstar with character worker trait
    let characterWorkerTraitSuperstars = [];
    let gimmickInterviewSuperstarChance = 0;
    for (let s of superstars)for (const trait of s.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["gimmick_interview_superstar_chance"]) {
            characterWorkerTraitSuperstars.push(s);
            gimmickInterviewSuperstarChance = traitData["gimmick_interview_superstar_chance"];
        }
    }
    let superstar;
    if (characterWorkerTraitSuperstars.length && (0, $3E8Nt.getRandomInt)(0, 100) <= gimmickInterviewSuperstarChance) superstar = (0, $3E8Nt.getRandomChoice)(characterWorkerTraitSuperstars);
    else superstar = (0, $3E8Nt.getRandomChoice)(superstars);
    // Increase gimmick effectiveness
    const superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(superstar);
    const increase = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(15, 30), 5);
    superstarGimmick.effectiveness += increase;
    if (superstarGimmick.effectiveness > 100) superstarGimmick.effectiveness = 100;
    // Create message
    const changeHtml = `<div class="message-info-box grey">` + `<span class="green margin-right-5"><i class="fa fa-angle-double-up"></i> ${increase}%</span>` + `Effectiveness</div>`;
    const subject = "Gimmick Boost";
    const content = `<p>${superstar.name} gave a remarkable interview a few days ago, done fully in character. ` + `This gave ${superstar.possessivePronoun} gimmick a good boost in the eyes of the fans.</p>` + `<p>${changeHtml}</p>`;
    const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "gimmickInterview";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$goodTrainingSessionEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select trained superstar
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    const lowWorkrateSuperstars = superstars.filter((x)=>x.workrate < 3);
    if (!lowWorkrateSuperstars.length) return null;
    const superstar = (0, $3E8Nt.getRandomChoice)(lowWorkrateSuperstars);
    // Select training from
    const highWorkrateSuperstars = superstars.filter((x)=>x.workrate >= 3);
    if (!highWorkrateSuperstars.length) return null;
    const trainingFrom = (0, $3E8Nt.getRandomChoice)(highWorkrateSuperstars);
    // Increase workrate xp
    const increase = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(20, 40), 5);
    superstar.workrateXp += increase;
    await (0, $3SyPM.updateSuperstarWorkrate)(superstar, company, await (0, $9esFv.getCompanyStaff)(company), game.monthCount, game.year);
    // Create message
    const changeHtml = `<div class="message-info-box grey">` + `<span class="green margin-right-5"><i class="fa fa-angle-double-up"></i> ${increase}</span>` + `Workrate XP</div>`;
    const subject = "Good Training";
    const content = `<p>I took out ${superstar.name} for training yesterday, and we had a monster of a session. ` + `${(0, $3E8Nt.toTitleCase)(superstar.pronoun)} picked up a lot and worked really hard. I could feel ` + `${superstar.possessivePronoun} workrate improving.</p>` + `<p>${changeHtml}</p>`;
    const fromName = trainingFrom.name;
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "superstar");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "goodTrainingSession";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$neglectedTrainingEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select active superstar
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    // Find superstars with hates training trait
    let hatesTrainingTraitSuperstars = [];
    let neglectedTrainingSuperstarChance = 0;
    for (let s of superstars)for (const trait of s.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["neglected_training_superstar_chance"]) {
            hatesTrainingTraitSuperstars.push(s);
            neglectedTrainingSuperstarChance = traitData["neglected_training_superstar_chance"];
        }
    }
    // Get superstar
    let superstar;
    if (hatesTrainingTraitSuperstars.length && (0, $3E8Nt.getRandomInt)(0, 100) <= neglectedTrainingSuperstarChance) superstar = (0, $3E8Nt.getRandomChoice)(hatesTrainingTraitSuperstars);
    else {
        const weights = superstars.map((x)=>{
            const weight = x.fatigue >= 50 ? Math.pow(x.fatigue / 20, 3) : 0;
            return [
                x,
                weight
            ];
        });
        superstar = (0, $3E8Nt.weightedChoice)(weights);
    }
    // Decrease workrate xp
    const decrease = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(20, 40), 5);
    superstar.workrateXp -= decrease;
    if (superstar.workrateXp < 0) superstar.workrateXp = 0;
    $1e16a83827fcd664$var$setSuperstarSkillLevelForDecrease(superstar, "workrate");
    // Create message
    const changeHtml = `<div class="message-info-box grey">` + `<span class="red margin-right-5"><i class="fa fa-angle-double-down"></i> ${decrease}</span>` + `Workrate XP</div>`;
    const subject = "No Training";
    const content = `<p>I've been noticing that ${superstar.name} hasn't showed up in the gym for a while. ` + `${(0, $3E8Nt.toTitleCase)(superstar.pronoun)} is refusing to train, and I feel like ` + `${superstar.possessivePronoun} workrate is decreasing.</p>` + `<p>${changeHtml}</p>`;
    const trainer = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "trainer");
    const fromName = trainer ? trainer.name : "Staff";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "neglectedTraining";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$hairChangeEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select bald superstar
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    const baldSuperstars = superstars.filter((x)=>{
        const graphic = x.graphic;
        return graphic && Object.keys(graphic).length !== 0 && !graphic["empty_graphic"] && graphic["hair"]["object"] === 0;
    });
    if (!baldSuperstars.length) return null;
    const superstar = (0, $3E8Nt.getRandomChoice)(baldSuperstars);
    const graphic = superstar.graphic;
    // Select hair object to add
    const hairObjects = (0, $2GWzg.graphicsData)["hairs"].filter((x)=>x["category"] === "short");
    const hairObject = (0, $3E8Nt.getRandomChoice)(hairObjects);
    const hairObjectNumber = hairObject["number"];
    // Select hair color
    const regularColors = [
        "0x443526",
        "0x222222"
    ];
    let hairColor = null;
    // Get hair color from beard color if any
    if (graphic["facialHair"]["object"] > 0) hairColor = graphic["facialHair"]["colors"][0];
    // Otherwise get a new hair color
    if (!hairColor) {
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) hairColor = (0, $3E8Nt.getHairColor)();
        else hairColor = (0, $3E8Nt.getRandomChoice)(regularColors);
    }
    // Add hair colors for each design in hair object
    const hairColors = new Array(hairObject["designs"]).fill(hairColor);
    // Add hair
    graphic["hair"]["object"] = hairObjectNumber;
    graphic["hair"]["colors"] = hairColors;
    // Add hair on alternate attires
    const alternateAttires = graphic["alternate_attires"];
    if (alternateAttires) {
        const newAlternateAttires = [];
        for (const alt of alternateAttires){
            let altGraphic = JSON.parse(JSON.stringify(alt));
            altGraphic["hair"]["object"] = hairObjectNumber;
            altGraphic["hair"]["colors"] = hairColors;
            newAlternateAttires.push(altGraphic);
        }
        graphic["alternate_attires"] = newAlternateAttires;
    }
    superstar.graphic = graphic;
    // Create message
    const subject = "Hair Change";
    const content = "<p>I've decided to grow out my hair. It was time for a change. What do you think?</p>";
    const fromName = superstar.name;
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "superstar");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "hairChange";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$gimmickMatchBoostEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select gimmick match
    const gimmickMatches = await (0, $9esFv.getCompanyGimmickMatches)(company);
    if (!gimmickMatches.length) return null;
    const gimmickMatch = (0, $3E8Nt.getRandomChoice)(gimmickMatches);
    // Add boost
    gimmickMatch.ratingBoost += 0.2;
    // Create message
    const subject = "Match Hype";
    const content = `<p>${gimmickMatch.name} Matches are quite hot these days. Fans are giving them a lot of attention ` + `and I think we could get quite a bit of hype if we use them at the next show.</p>`;
    const fromName = company.ownerName || "Owner";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "gimmickMatchBoost";
    newRandomEvent.monthsRemaining = 1;
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    await (0, $cYLJ6.addGimmickMatchRandomEvents)(gimmickMatch, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$feudIgnoredEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const actions = [
        "training at the local gym",
        "drinking at a club",
        "attending a sporting event",
        "sitting at a movie premiere",
        "attending a concert"
    ];
    // Select feud
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const feuds = (await (0, $dl5u4.getRosterFeuds)(roster)).filter((x)=>x.started && !x.ended);
    if (!feuds.length) return null;
    // Find feud with neglects story trait participant superstar
    let neglectsStoryTraitFeuds = [];
    let feudIgnoredFeudChance = 0;
    for (let feud of feuds)for (let participant of (await (0, $jDtEn.getFeudParticipants)(feud))){
        for (let s of (await (0, $5kTkA.getRosterMemberSuperstars)(participant)))for (let trait of s.traits){
            let traitData = (0, $aP7lq.traitsData)[trait];
            if (traitData && traitData["feud_ignored_feud_chance"]) {
                neglectsStoryTraitFeuds.push(feud);
                feudIgnoredFeudChance = traitData["feud_ignored_feud_chance"];
            }
        }
    }
    let feud;
    if (neglectsStoryTraitFeuds.length && (0, $3E8Nt.getRandomInt)(0, 100) <= feudIgnoredFeudChance) feud = (0, $3E8Nt.getRandomChoice)(neglectsStoryTraitFeuds);
    else feud = (0, $3E8Nt.getRandomChoice)(feuds);
    // Select superstars
    const feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
    if (feudParticipants.length < 2) return null;
    let selectedSuperstars;
    if (feudParticipants[0].objectName === "tagTeam") {
        // Get one superstar from each tag team
        let firstFeudParticipantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(feudParticipants[0]);
        let secondFeudParticipantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(feudParticipants[1]);
        if (!firstFeudParticipantSuperstars.length || !secondFeudParticipantSuperstars.length) return null;
        selectedSuperstars = [
            (0, $3E8Nt.getRandomChoice)(firstFeudParticipantSuperstars),
            (0, $3E8Nt.getRandomChoice)(secondFeudParticipantSuperstars)
        ];
    } else selectedSuperstars = (0, $3E8Nt.getRandomSample)(feudParticipants, 2);
    // Decrease feud hype
    const decrease = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(15, 25), 5);
    feud.hype -= decrease;
    if (feud.hype < 0) feud.hype = 0;
    // Create message
    const superstarNames = (0, $3E8Nt.commaSeparate)(selectedSuperstars.map((x)=>x.name));
    const changeHtml = `<div class="message-info-box grey">` + `<span class="red margin-right-5"><i class="fa fa-angle-double-down"></i> ${decrease}</span>` + `Hype` + `</div>`;
    const subject = "Feud Ignored";
    const content = `<p>${superstarNames} were recently spotted by fans ${(0, $3E8Nt.getRandomChoice)(actions)} together.</p>` + `<p>Obviously, this negatively affected their ongoing Feud's Hype. I've talked to both of them and told them ` + `of the consequences of this action.</p>` + `<p>${changeHtml}</p>`;
    const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "feudIgnored";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$feudBoostedEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const actions = [
        "going to blows on a TV show",
        "fighting in front of fans in the parking lot before the show",
        "starting a brawl at a press event",
        "yelling at each other in a charity event",
        "refusing to fly on the same flight"
    ];
    // Select feud
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const feuds = (await (0, $dl5u4.getRosterFeuds)(roster)).filter((x)=>x.started && !x.ended);
    if (!feuds.length) return null;
    // Find feud with storyteller trait participant superstar
    let storytellerTraitFeuds = [];
    let feudBoostedFeudChance = 0;
    for (let feud of feuds)for (let participant of (await (0, $jDtEn.getFeudParticipants)(feud))){
        for (let s of (await (0, $5kTkA.getRosterMemberSuperstars)(participant)))for (let trait of s.traits){
            let traitData = (0, $aP7lq.traitsData)[trait];
            if (traitData && traitData["feud_boosted_feud_chance"]) {
                storytellerTraitFeuds.push(feud);
                feudBoostedFeudChance = traitData["feud_boosted_feud_chance"];
            }
        }
    }
    let feud;
    if (storytellerTraitFeuds.length && (0, $3E8Nt.getRandomInt)(0, 100) <= feudBoostedFeudChance) feud = (0, $3E8Nt.getRandomChoice)(storytellerTraitFeuds);
    else feud = (0, $3E8Nt.getRandomChoice)(feuds);
    // Select superstars
    const feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
    if (feudParticipants.length < 2) return null;
    let selectedSuperstars;
    if (feudParticipants[0].objectName === "tagTeam") {
        // Get one superstar from each tag team
        let firstFeudParticipantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(feudParticipants[0]);
        let secondFeudParticipantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(feudParticipants[1]);
        if (!firstFeudParticipantSuperstars.length || !secondFeudParticipantSuperstars.length) return null;
        selectedSuperstars = [
            (0, $3E8Nt.getRandomChoice)(firstFeudParticipantSuperstars),
            (0, $3E8Nt.getRandomChoice)(secondFeudParticipantSuperstars)
        ];
    } else selectedSuperstars = (0, $3E8Nt.getRandomSample)(feudParticipants, 2);
    // Increase feud hype
    const increase = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(15, 25), 5);
    feud.hype += increase;
    // Create message
    const changeHtml = `<div class="message-info-box grey">` + `<span class="green margin-right-5"><i class="fa fa-angle-double-up"></i> ${increase}</span>` + `Hype` + `</div>`;
    const subject = "Feud Boosted";
    const superstarNames = (0, $3E8Nt.commaSeparate)(selectedSuperstars.map((superstar)=>superstar.name));
    const content = `<p>${superstarNames} recently made a scene by ${(0, $3E8Nt.getRandomChoice)(actions)}.</p>` + `<p>The interaction gave a good boost to their ongoing Feud's Hype in the eyes of the fans.</p>` + `<p>${changeHtml}</p>`;
    const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "feudBoosted";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$cultFollowingEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const attributes = [
        "cool look",
        "witty humor",
        "unique personality",
        "awesome moves",
        "everyman nature",
        "carefree attitude"
    ];
    // Select a superstar from the active roster that is not hot
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = (await $1e16a83827fcd664$var$getActiveSuperstars(roster)).filter((x)=>x.overness <= 60);
    if (!superstars.length) return null;
    const superstar = (0, $3E8Nt.getRandomChoice)(superstars);
    // Add to overness
    const increase = (0, $3E8Nt.getRandomInt)(10, 15);
    superstar.overness += increase;
    if (superstar.overness > 100) superstar.overness = 100;
    // Create message
    const changeHtml = `<div class="message-info-box grey">` + `<span class="green margin-right-5"><i class="fa fa-angle-double-up"></i> ${increase}%</span>` + `Overness</div>`;
    const subject = "Cult Following";
    const content = `<p>For no discernible reason, a cult following has developed around ${superstar.name} due to ` + `${superstar.possessivePronoun} ${(0, $3E8Nt.getRandomChoice)(attributes)}.</p>` + `<p>Whether this grows or fades is yet to be seen, but ${superstar.name} got a slight boost ` + `to ${superstar.possessivePronoun} overness because of it.</p>` + `<p>${changeHtml}</p>`;
    const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "cultFollowing";
    newRandomEvent.monthsRemaining = 2;
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    await (0, $hBIDz.addSuperstarRandomEvents)(superstar, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$wrestlerCourtEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const punishments = [
        "a month-long ban from the locker room",
        "pay the (huge) bar tab",
        "bring video games for everyone",
        "buy everyone food"
    ];
    // Get active superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    if (superstars.length < 5) return null;
    // Find superstars with leader trait
    const leaderTraitSuperstars = [];
    for (let s of superstars)for (const trait of s.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["wrestler_court_judge_chance"]) leaderTraitSuperstars.push(s);
    }
    // Find superstars with troublemaker trait
    const troublemakerTraitSuperstars = [];
    let wrestlerCourtDefendantChance = 0;
    for (let s of superstars)for (const trait of s.traits){
        const traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["wrestler_court_defendant_chance"]) {
            troublemakerTraitSuperstars.push(s);
            wrestlerCourtDefendantChance = traitData["wrestler_court_defendant_chance"];
        }
    }
    // Get defendant and plaintiff
    let defendant;
    if (troublemakerTraitSuperstars.length && (0, $3E8Nt.getRandomInt)(0, 100) <= wrestlerCourtDefendantChance) defendant = (0, $3E8Nt.getRandomChoice)(troublemakerTraitSuperstars);
    else defendant = (0, $3E8Nt.getRandomChoice)(superstars);
    superstars = superstars.filter((x)=>x.$loki !== defendant.$loki);
    const plaintiff = (0, $3E8Nt.getRandomChoice)(superstars);
    superstars = superstars.filter((x)=>x.$loki !== plaintiff.$loki);
    // Select judges
    const sortedSuperstars = [
        ...superstars
    ].sort((a, b)=>{
        return (0, $3E8Nt.objectInArray)(b, leaderTraitSuperstars) - (0, $3E8Nt.objectInArray)(a, leaderTraitSuperstars) || b.age - a.age;
    });
    const veterans = sortedSuperstars.slice(0, 4);
    const judges = (0, $3E8Nt.getRandomSample)(veterans, 3);
    // Make defendant unhappy
    if (!game.settings["no_unhappiness"]) await (0, $5kTkA.changeSuperstarMoraleToUnhappy)(defendant, company);
    // Create message
    const subject = "Wrestlers Court";
    const crimes = [
        `complaining about ${defendant.possessivePronoun} position in the company`,
        "leaving trash in the locker room",
        "no-selling moves in the ring",
        "speaking of the show in a negative light",
        "trying to bribe the management",
        "stealing a wrestling move"
    ];
    const content = `<p>A session of the Wrestlers Court took place recently, with ${plaintiff.name} ` + `accusing ${defendant.name} of ${(0, $3E8Nt.getRandomChoice)(crimes)}.</p>` + `<p>${(0, $3E8Nt.commaSeparate)(judges.map((x)=>x.name))} were the judges, and after a lengthy session of ` + `pleading cases, ${defendant.name} was found guilty and sentenced to ${(0, $3E8Nt.getRandomChoice)(punishments)}.</p>` + `<p>Due to the embarrassment of the whole ordeal, ${defendant.name} isn't too happy.</p>`;
    const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "wrestlerCourt";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    // Check to acquire trait
    for (let judge of judges)await (0, $5kTkA.checkAcquireTrait)(judge, "Leader");
    return true;
}
async function $1e16a83827fcd664$var$drugAbuseEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Get active superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    // Find superstars with drug habit trait
    let drugHabitTraitSuperstars = [];
    let drugAbuseSuperstarChance = 0;
    for (let superstar of superstars)for (let trait of superstar.traits){
        let traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["drug_abuse_superstar_chance"]) {
            drugHabitTraitSuperstars.push(superstar);
            drugAbuseSuperstarChance = traitData["drug_abuse_superstar_chance"];
        }
    }
    let superstar;
    if (drugHabitTraitSuperstars.length && (0, $3E8Nt.getRandomInt)(0, 100) <= drugAbuseSuperstarChance) superstar = (0, $3E8Nt.getRandomChoice)(drugHabitTraitSuperstars);
    else {
        const weights = superstars.map((x)=>{
            const weight = x.fatigue >= 50 ? Math.pow(x.fatigue / 20, 3) : 0;
            return [
                x,
                weight
            ];
        });
        superstar = (0, $3E8Nt.weightedChoice)(weights);
    }
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "drugAbuse";
    newRandomEvent.monthsRemaining = 1;
    newRandomEvent.choices = [
        "Suspend",
        "Ignore"
    ];
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    await (0, $hBIDz.addSuperstarRandomEvents)(superstar, [
        newRandomEvent
    ]);
    // Create message for random event
    const subject = "Drug Abuse";
    const content = `<p>Last night, I caught ${superstar.name} using illicit drugs.</p>` + `<p>You have two options here: you can either suspend ${superstar.objectivePronoun} for a couple months and ` + `put an immediate stop to the drug use or you can ignore the issue.</p>` + `<p>If you don't do anything, the drug use will probably continue and negatively affect ` + `${superstar.possessivePronoun} skills.</p>`;
    const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    newMessage.promptAction = true;
    await (0, $9tPJr.addRandomEventMessages)(newRandomEvent, [
        newMessage
    ]);
    // Check to acquire trait
    await (0, $5kTkA.checkAcquireTrait)(superstar, "Drug Habit");
    return true;
}
async function $1e16a83827fcd664$var$factionBoostedEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    let actions = [
        "meet and greet",
        "press event",
        "training session",
        "charity event",
        "merchandise showcase",
        "photo shoot",
        "commercial shoot"
    ];
    // Select faction
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let factions = await (0, $6PzHO.getRosterActiveFactions)(roster);
    if (!factions.length) return null;
    let faction = (0, $3E8Nt.getRandomChoice)(factions);
    // Increase faction xp
    let increase = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(20, 40), 5);
    (0, $6PzHO.updateFactionXpAndReputation)(faction, increase);
    // Create message
    let changeHtml = `<div class="message-info-box grey">` + `<span class="green margin-right-5"><i class="fa fa-angle-double-up"></i> ${increase}</span>XP` + `</div>`;
    let subject = "Faction Together";
    let content = `<p>${faction.name} were recently seen attending a ${(0, $3E8Nt.getRandomChoice)(actions)} as a group.</p>` + `<p>They arrived together, dressed similarly and acted like a unit. This should give their faction's ` + `reputation a boost.</p>` + `<p>${changeHtml}</p>`;
    let talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "factionBoosted";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$factionIgnoredEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    let actions = [
        "meet and greet",
        "press event",
        "training session",
        "charity event",
        "merchandise showcase",
        "photo shoot",
        "commercial shoot"
    ];
    // Select faction
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let factions = await (0, $6PzHO.getRosterActiveFactions)(roster);
    if (!factions.length) return null;
    let faction = (0, $3E8Nt.getRandomChoice)(factions);
    // Decrease faction
    let decrease = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(-40, -20), 5);
    (0, $6PzHO.updateFactionXpAndReputation)(faction, decrease);
    // Create message
    let changeHtml = `<div class="message-info-box grey">` + `<span class="red margin-right-5"><i class="fa fa-angle-double-down"></i> ${decrease * -1}</span>XP` + `</div>`;
    let subject = "Faction Separated";
    let content = `<p>Fans recently saw ${faction.name} attend a ${(0, $3E8Nt.getRandomChoice)(actions)} separately from each other.</p>` + `<p>They didn't interact with each other at all, which doesn't bode well for their reputation as a unit.</p>` + `<p>${changeHtml}</p>`;
    let talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    const fromName = talentManager ? talentManager.name : "Staff";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "factionIgnored";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$fluBugEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select active superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    if (superstars.length < 6) return null;
    let numberSuperstarsAffected = (0, $3E8Nt.getRandomInt)(4, 7);
    let superstarsAffected = (0, $3E8Nt.getRandomSample)(superstars, numberSuperstarsAffected);
    let superstarNames = (0, $3E8Nt.commaSeparate)(superstarsAffected.map((x)=>x.name));
    // Make superstars unusable
    for (let superstar of superstarsAffected)superstar.unavailable = true;
    // Create message from doctor
    let subject = "Flu Bug";
    let content = `<p>A serious flu bug is going around the locker room. So far, the following Superstars have ` + `been affected: ${superstarNames}.</p>` + `<p>All of them have been sent home and won't be wrestling at the upcoming show. It's a big ` + `setback, but we can't let anyone else catch the illness.</p>`;
    let doctor = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(company), "doctor");
    let fromName = doctor ? doctor.name : "Staff";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "fluBug";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$flightsCancelledEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select about half of active superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    if (superstars.length < 20) return null;
    const halfNumberOfSuperstars = superstars.length / 2;
    const numberOfSuperstarsAffected = (0, $3E8Nt.getRandomInt)(halfNumberOfSuperstars - 5, halfNumberOfSuperstars + 5);
    const superstarsAffected = (0, $3E8Nt.getRandomSample)(superstars, numberOfSuperstarsAffected);
    // Make superstars unusable
    for (let superstar of superstarsAffected)superstar.unavailable = true;
    // Create message from talent manager
    let subject = "Cancelled Flights";
    let content = "<p>We faced some really bad weather coming out of our last show. All flights from the airport were cancelled and the weather still hasn't improved.</p><p>Thankfully, around half the Superstars left before the storm and made it here. The rest are stuck and won't be able to make it in time for our upcoming show.</p><p>We'll have to work with the talent we have. It might not be ideal but it's a chance to get creative.</p>";
    content += "<p>Top names who are unavailable include:</p>";
    const topSuperstarsAffected = [
        ...superstarsAffected
    ].sort((a, b)=>b.popularity - a.popularity).slice(0, 5);
    for (let s of topSuperstarsAffected)content += "<p>- " + s.name + "</p>";
    let talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    let fromName = talentManager ? talentManager.name : "Staff";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "flightsCancelled";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$championshipStolenEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    // Select championship and champion
    let companyChampionships = (0, $kZwpB.getUniqueChampionships)((await (0, $9esFv.getCompanyChampionships)(company)).filter((x)=>!x.championshipContract && !x.matchContract && !x.tagTeam && !x.trio && !x.vacated));
    if (!companyChampionships.length) return null;
    let championship = (0, $3E8Nt.getRandomChoice)(companyChampionships);
    let champion = await (0, $ivuOU.getChampionshipSuperstar)(championship);
    // Create random event
    let newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "championshipStolen";
    newRandomEvent.monthsRemaining = 2;
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    await (0, $ivuOU.addChampionshipRandomEvents)(championship, [
        newRandomEvent
    ]);
    if (champion) await (0, $hBIDz.addSuperstarRandomEvents)(champion, [
        newRandomEvent
    ]);
    // Remove championship relationships
    championship.companyId = null;
    championship.superstarId = null;
    championship.matchId = null;
    championship.tournamentId = null;
    // Create message from owner
    let subject = "Championship Stolen";
    let content = `<p>The ${championship.name} Championship is missing. I don't know how this could happen. The ` + `champion, ${champion.name}, has no idea where it is and thinks that it was stolen during travel.</p>` + `<p>This is an embarrassment! We're going to get the championship back, but for now, you'll have to book ` + `without it.</p>`;
    let fromName = company.ownerName || "Owner";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Add news
    let newsItem = await (0, $kZMqI.generateNewsItem)({
        company: company,
        month: game.monthCount,
        year: game.year,
        newsType: "championship_stolen",
        championship: championship
    });
    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
        newsItem
    ]);
    return true;
}
async function $1e16a83827fcd664$var$backstageUnrestEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Select from active superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    let happySuperstars = superstars.filter((x)=>!x.unhappy);
    let unhappySuperstars = superstars.filter((x)=>x.unhappy);
    if (happySuperstars.length < 6 || unhappySuperstars.length < 1) return null;
    let superstarsAffected = (0, $3E8Nt.getRandomSample)(happySuperstars, (0, $3E8Nt.getRandomInt)(4, 6));
    let instigatorSuperstar = (0, $3E8Nt.getRandomChoice)(unhappySuperstars);
    // Make superstars unhappy
    if (!game.settings["no_unhappiness"]) for (let superstar of superstarsAffected)await (0, $5kTkA.changeSuperstarMoraleToUnhappy)(superstar, company);
    // Create message from talent manager
    let superstarsAffectedNames = (0, $3E8Nt.commaSeparate)(superstarsAffected.map((x)=>x.name));
    let subject = "Backstage Unrest";
    let content = `<p>We are dealing with some serious backstage unrest that seems to be spreading. The following ` + `Superstars have made their unhappiness clear to me: ${superstarsAffectedNames}.</p>` + `<p>I believe all this was started by ${instigatorSuperstar.name} who was unhappy and let everyone know ` + `about it.</p>`;
    let talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
    let fromName = talentManager ? talentManager.name : "Staff";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "backstageUnrest";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$conservativeGovernmentShowEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const locations = [
        "Saudi Arabia",
        "Afghanistan",
        "Yemen"
    ];
    // Check for female superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    const femaleSuperstars = superstars.filter((x)=>x.gender === "female");
    if (femaleSuperstars.length < 7) return null;
    // Get location
    const location = (0, $3E8Nt.getRandomChoice)(locations);
    // Create random event
    let newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "conservativeGovernmentShow";
    newRandomEvent.monthsRemaining = 2;
    newRandomEvent.choices = [
        "Accept",
        "Decline"
    ];
    newRandomEvent.location = location;
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    // Create message for random event
    let subject = `${location}'s Offer`;
    let content = `<p>${location}'s government want us to hold an event in their country to promote their sports ` + `and entertainment options.</p><p>They're willing to offer us substantial compensation for it. ` + `They insisted, however, that women won't be allowed to wrestle, as per their cultural norms.</p>` + `<p>If you are willing to do the show, I'll give you plenty of Creative Points to spend. ` + `But the fans and some of our female roster might not be happy with it.</p>`;
    let fromName = company.ownerName || "Owner";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    newMessage.promptAction = true;
    await (0, $9tPJr.addRandomEventMessages)(newRandomEvent, [
        newMessage
    ]);
    return true;
}
async function $1e16a83827fcd664$var$planeRideSuspensionsEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    let pranks = [
        "razor-shaving prank",
        "scare prank",
        "laxative prank",
        "bathroom prank",
        "scissors prank"
    ];
    let fights = [
        "an amateur wrestling fight",
        "a shoot fight",
        "a big brawl",
        "a boxing contest",
        "an MMA fight"
    ];
    let inappropriateActions = [
        "public nudity",
        "bullying staff members",
        "threatening the travel crew",
        "recreational drug use",
        "harassing other passengers"
    ];
    // Select active superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    if (superstars.length < 7) return null;
    let superstarsSuspended = (0, $3E8Nt.getRandomSample)(superstars, 5);
    superstars = superstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, superstarsSuspended));
    let receivingSuperstar = (0, $3E8Nt.getRandomChoice)(superstars);
    // Suspend superstars
    for (let superstar of superstarsSuspended){
        superstar.suspensionMonths = 1;
        // Add to company logs
        const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
        await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
        newCompanyLog.text = superstar.name;
        newCompanyLog.type = "suspension";
        newCompanyLog.value = superstar.suspensionMonths;
        await (0, $9esFv.addCompanyCompanyLogs)(company, [
            newCompanyLog
        ]);
        // Check talent request
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "write_off",
            talent: superstar
        });
    }
    // Create message from owner
    let subject = "Travel Disaster";
    let content = `<p>On the way back from our last show, we had a number of unfortunate incidents. ` + `There were too many intoxicants available and the long travel didn't help.</p>` + `<p>I won't go into too many details. The following Superstars have been suspended:</p>` + `<p>- ${superstarsSuspended[2].name} and ${superstarsSuspended[3].name}, for starting ${(0, $3E8Nt.getRandomChoice)(fights)}.</p>` + `<p>- ${superstarsSuspended[0].name} and ${superstarsSuspended[1].name}, for almost injuring ` + `${receivingSuperstar.name} in a ${(0, $3E8Nt.getRandomChoice)(pranks)}.</p>` + `<p>- ${superstarsSuspended[4].name}, for ${(0, $3E8Nt.getRandomChoice)(inappropriateActions)}.</p>` + `<p>I'll make sure this never happens again.</p>`;
    let fromName = company.ownerName || "Owner";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    let newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "planeRideSuspensions";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$stormAffectsShowEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Check event and producers
    let nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
    if (!nextEvent.weeklyShow) return null;
    let producers = (0, $8A6FL.getAvailableStaffMembersByRole)(await (0, $9esFv.getCompanyStaff)(company), "producer");
    if (!producers.length) return null;
    // Add active effect to event
    nextEvent.activeEffect = "production_packages_only";
    // Create message from owner
    let subject = `${nextEvent.name} Cancelled`;
    let content = `<p>Due to a huge storm in the area, we can't hold a live event at this week's ${nextEvent.name}.</p>` + `<p>There's a hurricane warning, so there won't be any fans in the arena, and we can't hold any matches. ` + `But we can air production packages.</p>` + `<p>The show must go on. Use this as an opportunity to build up some Superstars and Feuds.</p>`;
    let fromName = company.ownerName || "Owner";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    let newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "stormAffectsShow";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$showAppearancesEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    let shows = [
        "Late Night",
        "Talk",
        "Comedy",
        "Sports",
        "Game"
    ];
    // Check if weekly show
    const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
    if (!nextEvent.weeklyShow) return null;
    // Get active superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    if (superstars.length < 6) return null;
    // Select superstars using weighted choice (auto booker formula)
    let weights = superstars.map((x)=>{
        return [
            x,
            Math.exp(x.popularity / 70) / 100
        ];
    });
    let superstarsSelected = [];
    for (let _ of Array((0, $3E8Nt.getRandomInt)(4, 6)).keys()){
        let selected = (0, $3E8Nt.weightedChoice)(weights);
        weights = weights.filter((x)=>x[0].$loki !== selected.$loki);
        superstarsSelected.push(selected);
    }
    // Get show name
    let showName = (0, $3E8Nt.getRandomChoice)(shows);
    // Make superstars unavailable, add overness
    for (let s of superstarsSelected){
        s.unavailable = true;
        let overnessIncrease = (0, $3E8Nt.getRandomInt)(5, 10);
        (0, $8A6FL.updateObjectOverness)(s, overnessIncrease);
        (0, $8A6FL.checkObjectHot)(s, overnessIncrease);
        (0, $8A6FL.checkObjectStale)(s, overnessIncrease);
    }
    // Create message from owner
    let superstarNames = (0, $3E8Nt.commaSeparate)(superstarsSelected.map((x)=>x.name));
    let subject = `${showName} Show`;
    let content = `<p>We received an offer from a popular ${showName} Show to have some of our Superstars appear on it.</p>` + `<p>I selected ${superstarNames} to go.</p>` + `<p>The ${showName} Show runs live and airs close to ${nextEvent.name} so they won't be ` + `available for our upcoming show, but they should get a nice overness boost.</p>`;
    let fromName = company.ownerName || "Owner";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    let newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "showAppearances";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    return true;
}
async function $1e16a83827fcd664$var$backstageFightEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    let moves = [
        "headlock",
        "stiff punch",
        "chokehold",
        "right hook",
        "takedown"
    ];
    // Check feud item
    let feudItem = (await (0, $9esFv.getCompanyFeudItems)(company)).find((x)=>x.requirement === "backstage-fight");
    if (!feudItem) return null;
    // Get active superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    if (superstars.length < 7) return null;
    // Find superstars with troublemaker trait
    let troublemakerTraitSuperstars = [];
    let backstageFightStarterChance = 0;
    for (let superstar of superstars)for (let trait of superstar.traits){
        let traitData = (0, $aP7lq.traitsData)[trait];
        if (traitData && traitData["backstage_fight_starter_chance"]) {
            troublemakerTraitSuperstars.push(superstar);
            backstageFightStarterChance = traitData["backstage_fight_starter_chance"];
        }
    }
    // Get fight superstars
    let fightStarter;
    if (troublemakerTraitSuperstars.length && (0, $3E8Nt.getRandomInt)(0, 100) <= backstageFightStarterChance) fightStarter = (0, $3E8Nt.getRandomChoice)(troublemakerTraitSuperstars);
    else fightStarter = (0, $3E8Nt.getRandomChoice)(superstars);
    superstars = superstars.filter((x)=>x.$loki !== fightStarter.$loki);
    const fightAgainst = (0, $3E8Nt.getRandomChoice)(superstars);
    superstars = superstars.filter((x)=>x.$loki !== fightAgainst.$loki);
    const fightSuperstars = [
        fightStarter,
        fightAgainst
    ];
    const fightingNames = fightSuperstars.map((x)=>x.name);
    // Get intervening superstars
    let interveningSuperstars = (0, $3E8Nt.getRandomSample)(superstars, (0, $3E8Nt.getRandomInt)(3, 5));
    // Suspend first superstar, make second unhappy
    fightSuperstars[0].suspensionMonths = 1;
    if (!game.settings["no_unhappiness"]) await (0, $5kTkA.changeSuperstarMoraleToUnhappy)(fightSuperstars[1], company);
    // Check talent request
    await (0, $1olyO.checkTalentRequestAction)({
        company: company,
        requestType: "write_off",
        talent: fightSuperstars[0]
    });
    // Create potential feud
    const newFeud = (0, $jDtEn.Feud)();
    await (0, $14eBR.Feuds).insert(newFeud);
    newFeud.name = feudItem.name;
    newFeud.hype = feudItem.baseHype;
    newFeud.participants = fightingNames;
    newFeud.directFeudEvent = "backstage-fight";
    newFeud.startMonth = game.monthCount;
    newFeud.startYear = game.year;
    await (0, $im36F.addFeudItemFeuds)(feudItem, [
        newFeud
    ]);
    await (0, $dl5u4.addRosterFeuds)(roster, [
        newFeud
    ]);
    await (0, $jDtEn.addFeudSuperstars)(newFeud, fightSuperstars);
    // Create message from owner
    let reasons = [
        `${fightingNames[1]} being unsafe and dangerous to work with`,
        "the fallout from an affair",
        `disparaging comments ${fightingNames[1]} made in an interview`,
        `allegations ${fightingNames[1]} made in a book`,
        "an unpaid loan"
    ];
    let subject = "Backstage Fight";
    let content = `<p>We had an unfortunate incident after our last show.</p>` + `<p>${fightingNames[0]} got into a disagreement with ${fightingNames[1]} backstage, reportedly ` + `about ${(0, $3E8Nt.getRandomChoice)(reasons)}.</p>` + `<p>The two started yelling and pushing each other before it came to blows. ${fightingNames[0]}` + ` got the better of ${fightingNames[1]} with a ${(0, $3E8Nt.getRandomChoice)(moves)} before ` + `${(0, $3E8Nt.commaSeparate)(interveningSuperstars.map((x)=>x.name))} broke it up.</p>` + `<p>Needless to say, things are pretty heated between ${fightingNames[1]} and ${fightingNames[0]}. ` + `I have suspended ${fightingNames[0]} for starting the fight while ${fightingNames[1]} is unhappy about ` + `the whole thing.</p>` + `<p>The only positive you can take out of this is that a Feud between the two would be quite hot.</p>`;
    let fromName = company.ownerName || "Owner";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "backstageFight";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    // Check to acquire trait
    await (0, $5kTkA.checkAcquireTrait)(fightStarter, "Troublemaker");
    return true;
}
async function $1e16a83827fcd664$var$superstarBreakEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Filter out part timers and superstars who have workable injury and want to work through it
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = (await $1e16a83827fcd664$var$getActiveSuperstars(roster)).filter((x)=>!x.partTimer && (!x.workableInjury || !(0, $5kTkA.checkSuperstarWorkThroughInjury)(x)));
    if (!superstars.length) return null;
    // Select superstar
    let weights = [];
    for (let x of superstars){
        let weight;
        if (game.settings["enable_fatigue"] !== false && x.fatigue !== null) {
            weight = Math.pow(x.fatigue / 20, 3);
            if (x.fatigue >= 60) weight *= 1000;
            else if (x.fatigue >= 40) weight *= 50;
        } else weight = Math.pow(x.popularity / 250, 4.5);
        weights.push([
            x,
            weight
        ]);
    }
    let superstar = (0, $3E8Nt.weightedChoice)(weights);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "superstarBreak";
    newRandomEvent.monthsRemaining = 1;
    newRandomEvent.choices = [
        "Accept",
        "Decline"
    ];
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    await (0, $hBIDz.addSuperstarRandomEvents)(superstar, [
        newRandomEvent
    ]);
    // Create message for random event
    let subject = "Time Off";
    let content = `<p>The past few months have been quite tough on me, both physically and mentally. The long travel ` + `and the wrestling really adds up.</p>` + `<p>I think I need some time off. Just a few months to recharge and come back fresh. What do you say?</p>` + `<p>If you give me this time off, I'll be here till the upcoming monthly show and I'll be happy to do ` + `anything on it.</p>`;
    let newMessage = await (0, $hekDR.createMessage)(subject, superstar.name, game.monthCount, game.year, content, "superstar");
    newMessage.promptAction = true;
    await (0, $9tPJr.addRandomEventMessages)(newRandomEvent, [
        newMessage
    ]);
    return true;
}
async function $1e16a83827fcd664$var$drugScandalEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Check superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    if (superstars.length < 10) return null;
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "drugScandal";
    newRandomEvent.monthsRemaining = 1;
    newRandomEvent.choices = [
        "Suspend",
        "Ignore"
    ];
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    // Select superstars
    let selectionRandom = new Math.seedrandom(newRandomEvent.meta.created);
    let numberOfSuperstarsAffected = (0, $3E8Nt.getRandomInt)(5, 10, selectionRandom());
    let superstarsAffected = (0, $3E8Nt.getRandomSample)(superstars, numberOfSuperstarsAffected, selectionRandom);
    let superstarsAffectedNames = (0, $3E8Nt.commaSeparate)(superstarsAffected.map((x)=>x.name));
    newRandomEvent.selectionIds = superstarsAffected.map((x)=>x.$loki);
    // Create message from owner
    let subject = "Steroid Scandal";
    let content = `<p>Some of our Superstars are in trouble. Law enforcement agencies identified ` + `${numberOfSuperstarsAffected} of our Superstars as part of a recent steroid scandal: ` + `${superstarsAffectedNames}.</p>` + `<p>The story is growing bigger as we speak. Members of government are looking to investigate the use of ` + `steroids in wrestling and are paying close attention to this case.</p>` + `<p>We have the option to reduce any possible backlash by suspending all Superstars linked with the scandal.</p>` + `<p>We can also choose to ignore it and hope the story dies down. But if it doesn't, the backlash could be huge.</p>`;
    let fromName = company.ownerName || "Owner";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    newMessage.promptAction = true;
    await (0, $9tPJr.addRandomEventMessages)(newRandomEvent, [
        newMessage
    ]);
    return true;
}
/*
Process random event functions
 */ async function $1e16a83827fcd664$var$processGimmickMatchBoostEvent(randomEvent, company, weeklyShow = null) {
    if (randomEvent.monthsRemaining === 0 && !weeklyShow) {
        let gimmickMatch = await (0, $9tPJr.getRandomEventGimmickMatch)(randomEvent);
        // Remove boost
        gimmickMatch.ratingBoost -= 0.2;
        return true;
    }
    return null;
}
async function $1e16a83827fcd664$var$processChampionshipStolenEvent(randomEvent, company, weeklyShow = null) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    if (randomEvent.monthsRemaining === 1 && !weeklyShow) {
        const championship = await (0, $9tPJr.getRandomEventChampionship)(randomEvent);
        const champion = await (0, $9tPJr.getRandomEventSuperstar)(randomEvent);
        const subject = "No Luck";
        const content = `<p>We checked everywhere, from our travel partners to the previous arena, and still there's ` + `no sign of the ${championship.name} Championship.</p>` + `<p>This is getting out of hand. We need to get the police involved. My gut says that ` + `${champion.name} was part of the disappearance.</p>`;
        // Create message from owner
        const fromName = company.ownerName || "Owner";
        const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        return true;
    }
    if (randomEvent.monthsRemaining === 0 && !weeklyShow) {
        const championship = await (0, $9tPJr.getRandomEventChampionship)(randomEvent);
        const champion = await (0, $9tPJr.getRandomEventSuperstar)(randomEvent);
        // Add championship relationships
        await (0, $9esFv.addCompanyChampionships)(company, [
            championship
        ]);
        if (champion) await (0, $hBIDz.addSuperstarChampionships)(champion, [
            championship
        ]);
        const subject = "Championship Found";
        const content = `<p>We finally found the ${championship.name} Championship. It was indeed stolen, and the police ` + `tracked down the thief before they could sell it.</p>` + `<p>What a relief. ${champion.name} had nothing to do with it and promised to take ` + `much better care of it.</p><p>Let's give all our focus to the championship to make up for the ` + `months it wasn't here.</p>`;
        // Create message from owner
        const fromName = company.ownerName || "Owner";
        const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        // Add news
        let newsItem = await (0, $kZMqI.generateNewsItem)({
            company: company,
            month: game.monthCount,
            year: game.year,
            newsType: "championship_found",
            championship: championship
        });
        await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
            newsItem
        ]);
        return true;
    }
    return null;
}
async function $1e16a83827fcd664$var$processDrugAbuseEvent(randomEvent, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const superstar = await (0, $9tPJr.getRandomEventSuperstar)(randomEvent);
    // Chance to lower a skill, otherwise stop drug use
    if (randomEvent.monthsRemaining === 0 && randomEvent.selectedChoice === "Ignore") {
        const pick = (0, $3E8Nt.getRandomInt)(0, 100);
        let subject;
        let content;
        if (pick <= 70) {
            // Lower a skill
            const skillToLower = (0, $3E8Nt.getRandomChoice)([
                "workrate",
                "charisma"
            ]);
            const decrease = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(50, 80), 5);
            if (skillToLower === "workrate") {
                superstar.workrateXp -= decrease;
                if (superstar.workrateXp < 0) superstar.workrateXp = 0;
            } else if (skillToLower === "charisma") {
                superstar.charismaXp -= decrease;
                if (superstar.charismaXp < 0) superstar.charismaXp = 0;
            }
            $1e16a83827fcd664$var$setSuperstarSkillLevelForDecrease(superstar, skillToLower);
            const changeHtml = `<div class="message-info-box grey">` + `<span class="red margin-right-5"><i class="fa fa-angle-double-down"></i> ${decrease}</span>` + `${(0, $3E8Nt.toTitleCase)(skillToLower)} XP` + `</div>`;
            subject = "Skill Affected";
            content = `<p>The drug abuse caught up to ${superstar.name}. The effects were quite bad, so much so that I think ` + `${superstar.possessivePronoun} ${(0, $3E8Nt.toTitleCase)(skillToLower)} skill was affected.</p>` + `<p>${superstar.name} has resolved to not let ${superstar.objectivePronoun}self deteriorate any further. ` + `I don't think ${superstar.pronoun} will be using anymore.</p>` + `<p>${changeHtml}</p>`;
        } else {
            // Drug use stopped
            subject = "Drug Use Ended";
            content = `<p>${superstar.name} hit an all-time low following the drug abuse. There was a lot of shame and guilt, ` + `but with the help of friends and family, ${superstar.pronoun} managed to stop using.</p>` + `<p>I don't think any significant harm came to ${superstar.objectivePronoun}.</p>`;
        }
        // Create message
        const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
        const fromName = talentManager ? talentManager.name : "Staff";
        const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        return true;
    }
    // Suspend superstar for 2 months
    if (randomEvent.selectedChoice === "Suspend" && !randomEvent.eventsRun.includes("0A")) {
        superstar.suspensionMonths = 2;
        // Check talent request
        await (0, $1olyO.checkTalentRequestAction)({
            company: company,
            requestType: "write_off",
            talent: superstar
        });
        // Add to company logs
        const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
        await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
        newCompanyLog.text = superstar.name;
        newCompanyLog.type = "suspension";
        newCompanyLog.value = superstar.suspensionMonths;
        await (0, $9esFv.addCompanyCompanyLogs)(company, [
            newCompanyLog
        ]);
        // Create message
        const subject = "Suspended";
        const content = `<p>${superstar.name} has been suspended for ${superstar.suspensionMonths} months due to drug abuse.</p>` + `<p>${(0, $3E8Nt.toTitleCase)(superstar.pronoun)} isn't doing so well but is getting professional help. ` + `I believe ${superstar.pronoun} should come back clean and ready to wrestle.</p>`;
        const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
        const fromName = talentManager ? talentManager.name : "Staff";
        const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        // Add to events run
        randomEvent.eventsRun.push("0A");
        // Add news
        let newsItem = await (0, $kZMqI.generateNewsItem)({
            company: company,
            month: game.monthCount,
            year: game.year,
            newsType: "drug_use_suspension",
            superstar: superstar
        });
        await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
            newsItem
        ]);
        return true;
    }
    return null;
}
async function $1e16a83827fcd664$var$processDrugScandalEvent(randomEvent, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    if (randomEvent.monthsRemaining === 0 && randomEvent.selectedChoice === "Ignore") {
        const pick = (0, $3E8Nt.getRandomInt)(0, 100);
        // Scandal grows
        if (pick <= 70) {
            // Lower fans
            const decrease = Math.abs(Math.floor(company.fans * 0.2));
            company.fans -= decrease;
            const changeHtml = `<div class="message-info-box grey">` + `<span class="red margin-right-5"><i class="fa fa-angle-double-down"></i> ${decrease.toLocaleString("en")}</span>` + `Fans` + `</div>`;
            const subject = "Scandal Backlash";
            const content = `<p>The steroid scandal has spread to the mainstream audience.</p>` + `<p>Media outlets are attacking us for not punishing the Superstars involved and many fans have started ` + `boycotts of our product.</p>` + `<p>${changeHtml}</p>`;
            // Create message
            const fromName = company.ownerName || "Owner";
            const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        } else {
            const subject = "Scandal Over";
            const content = `<p>The steroid scandal has died down in the media. People have moved on to more important ` + `things.</p>` + `<p>I've given a warning to all the Superstars involved in it. I think that's enough. ` + `Suspending them would have been too much.</p>`;
            // Create message
            const fromName = company.ownerName || "Owner";
            const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
        return true;
    }
    // Suspend superstars
    if (randomEvent.selectedChoice === "Suspend" && !randomEvent.eventsRun.includes("0A")) {
        // Get superstars
        const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
        const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
        // Get previously selected superstars
        let superstarsAffected;
        if (randomEvent.selectionIds.length) superstarsAffected = superstars.filter((x)=>randomEvent.selectionIds.includes(x.$loki));
        else {
            const selectionRandom = new Math.seedrandom(randomEvent.meta.created);
            const numberOfSuperstarsAffected = (0, $3E8Nt.getRandomInt)(5, 10, selectionRandom());
            superstarsAffected = (0, $3E8Nt.getRandomSample)(superstars, numberOfSuperstarsAffected, selectionRandom);
        }
        // Suspend superstars
        for (const superstar of superstarsAffected){
            superstar.suspensionMonths = 1;
            // Check talent request
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "write_off",
                talent: superstar
            });
            // Add to company logs
            const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
            await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
            newCompanyLog.text = superstar.name;
            newCompanyLog.type = "suspension";
            newCompanyLog.value = superstar.suspensionMonths;
            await (0, $9esFv.addCompanyCompanyLogs)(company, [
                newCompanyLog
            ]);
        }
        // Create message
        const superstarsAffectedNames = (0, $3E8Nt.commaSeparate)(superstarsAffected.map((x)=>x.name));
        const subject = "Superstars Suspended";
        const content = `<p>The following Superstars have been suspended for being part of the recent steroid scandal:</p>` + `<p>${superstarsAffectedNames}.</p>` + `<p>This step should protect us from any fan backlash.</p>`;
        const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
        const fromName = talentManager ? talentManager.name : "Staff";
        const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        // Add to events run
        randomEvent.eventsRun.push("0A");
        return true;
    }
    return null;
}
async function $1e16a83827fcd664$var$processSuperstarBreakEvent(randomEvent, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const superstar = await (0, $9tPJr.getRandomEventSuperstar)(randomEvent);
    try {
        if (randomEvent.monthsRemaining === 0 && randomEvent.selectedChoice === "Accept") {
            // Make happy, unavailable
            (0, $5kTkA.changeSuperstarMoraleToHappy)(superstar);
            (0, $5kTkA.addKayfabeInjuryToSuperstar)(superstar, (0, $3E8Nt.getRandomInt)(2, 3));
            // Create message from superstar
            const subject = "Thank you";
            const content = "<p>I really appreciate you giving me time off. I'll be ready to return soon, better than ever.</p>";
            const newMessage = await (0, $hekDR.createMessage)(subject, superstar.name, game.monthCount, game.year, content, "superstar");
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
            // Add news
            let newsItem = await (0, $kZMqI.generateNewsItem)({
                company: company,
                month: game.monthCount,
                year: game.year,
                newsType: "superstar_time_off",
                superstar: superstar
            });
            await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                newsItem
            ]);
            return true;
        }
        if (randomEvent.selectedChoice === "Decline" && !randomEvent.eventsRun.includes("0B")) {
            // Make unhappy
            if (!game.settings["no_unhappiness"]) await (0, $5kTkA.changeSuperstarMoraleToUnhappy)(superstar, company);
            // Create message from superstar
            const subject = "Disappointed";
            const content = "<p>I can't believe you wouldn't give me a few months off, despite everything I do for you!</p><p>This is complete neglect of your Superstars' health.</p>";
            const newMessage = await (0, $hekDR.createMessage)(subject, superstar.name, game.monthCount, game.year, content, "superstar");
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
            // Add to events run
            randomEvent.eventsRun.push("0B");
            return true;
        }
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    return null;
}
async function $1e16a83827fcd664$var$processConservativeGovernmentShowEvent(randomEvent, company, weeklyShow = null) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const eventNames = [
        "Super Showoff",
        "Hurt In The Desert",
        "Crowning Point",
        "Big Progress",
        "Eternal Kingdom"
    ];
    if (randomEvent.selectedChoice === "Accept") {
        const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
        if (randomEvent.monthsRemaining === 1) {
            // Get seeded random event name
            const latestMonthlyEvent = (await (0, $9esFv.getCompanyEvents)(company)).sort((a, b)=>b.$loki - a.$loki).find((x)=>!x.weeklyShow && x.name !== "Weekly Show" && x.$loki !== nextEvent.$loki && !x.temporaryEvent);
            const eventRandom = new Math.seedrandom(latestMonthlyEvent.meta.created);
            const eventName = (0, $3E8Nt.getRandomChoice)(eventNames, eventRandom());
            // Add no women bookable effect to monthly event and rename
            if (!nextEvent.weeklyShow) {
                nextEvent.activeEffect = "no_women_bookable";
                nextEvent.name = eventName;
            } else // Change name of weekly show before event
            if (nextEvent.weekNumber < 0) nextEvent.monthlyEventName = eventName;
            // Run at monthly show or weekly show before monthly show
            if (!nextEvent.weeklyShow || nextEvent.weeklyShow && nextEvent.weekNumber < 0) // Run once
            {
                if (!randomEvent.eventsRun.includes("1A")) {
                    // Add points
                    const increase = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(400, 600), 50);
                    company.points += increase;
                    // Create message from owner
                    const changeHtml = `<div class="message-info-box blue">` + `<span class="margin-right-5 top--2px">` + `<i class="fa fa-angle-double-up"></i> ${increase}` + `</span>` + `<img alt="Points" src="static/cp_icon.png" class="points-image-small margin-left-5 three-px"/>` + `</div>`;
                    const subject = `${randomEvent.location} Show`;
                    const content = `<p>Now that you signed off on the ${randomEvent.location} show, we're going to ` + `run it this month. The event has been named '${eventName}'.</p>` + `<p>I've given you quite a bit of Creative Points. There will be some fan backlash but ` + `you need to focus on putting on a good show for the ${randomEvent.location} government.</p>` + `<p>${changeHtml}</p>`;
                    const fromName = company.ownerName || "Owner";
                    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                    // Add to events run
                    randomEvent.eventsRun.push("1A");
                    return true;
                }
            }
        }
        // Run after monthly show
        if (randomEvent.monthsRemaining === 0 && !weeklyShow) {
            // Reduce fans
            const decrease = Math.abs(Math.floor(company.fans * 0.2));
            company.fans -= decrease;
            // Create womenOnlyShow random event
            const newRandomEvent = (0, $9tPJr.RandomEvent)();
            (0, $14eBR.RandomEvents).insert(newRandomEvent);
            newRandomEvent.name = "womenOnlyShow";
            newRandomEvent.monthsRemaining = 2;
            newRandomEvent.choices = [
                "Accept",
                "Decline"
            ];
            await (0, $9esFv.addCompanyRandomEvents)(company, [
                newRandomEvent
            ]);
            // Create message from owner
            const changeHtml = `<div class="message-info-box grey">` + `<span class="red margin-right-5">` + `<i class="fa fa-angle-double-down"></i> ${decrease.toLocaleString("en")}` + `</span>` + `Fans` + `</div>`;
            const subject = "Backlash Counter";
            const content = `<p>I was expecting some backlash for our ${randomEvent.location} show, but the media and ` + `the fans are going crazy. We need to do something drastic to counter this.</p>` + `<p>I came up with the idea of holding a women-only show. The fans will like it and so will the female roster. ` + `Plus, it'll improve the damage to our image. What do you say?</p>` + `<p>${changeHtml}</p>`;
            const fromName = company.ownerName || "Owner";
            const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
            newMessage.promptAction = true;
            await (0, $9tPJr.addRandomEventMessages)(newRandomEvent, [
                newMessage
            ]);
            return true;
        }
    }
    return null;
}
async function $1e16a83827fcd664$var$processWomenOnlyShowEvent(randomEvent, company, weeklyShow = null) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    if (randomEvent.selectedChoice === "Accept") {
        const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(company);
        if (randomEvent.monthsRemaining === 1) {
            // Add no men bookable effect to monthly event
            if (!nextEvent.weeklyShow) nextEvent.activeEffect = "no_men_bookable";
            // Run at monthly show or weekly show before monthly show
            if (!nextEvent.weeklyShow || nextEvent.weeklyShow && nextEvent.weekNumber < 0) // Run once
            {
                if (!randomEvent.eventsRun.includes("0A")) {
                    // Create message from owner
                    const subject = "Women's Show";
                    const content = "<p>We're ready to run our women-only show this month! The roster is excited. Everyone thinks this was a long time coming.</p><p>Let's give the fans a great event and show them that we support our women.</p>";
                    const fromName = company.ownerName || "Owner";
                    const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
                    await (0, $9esFv.addCompanyMessages)(company, [
                        newMessage
                    ]);
                    // Add to events run
                    randomEvent.eventsRun.push("0A");
                    return true;
                }
            }
        }
        // Run after monthly show
        if (randomEvent.monthsRemaining === 0 && !weeklyShow) {
            // Increase fans
            const increase = Math.abs(Math.floor(company.fans * 0.2));
            company.fans += increase;
            // Create message from owner
            const changeHtml = `<div class="message-info-box grey">` + `<span class="green margin-right-5">` + `<i class="fa fa-angle-double-up"></i> ${increase.toLocaleString("en")}` + `</span>` + `Fans` + `</div>`;
            const subject = "Show Success";
            const content = "<p>Our women-only show was a success! The fans loved seeing the women perform and the media ate it up.</p><p>We took a big step towards improving our image and made our brand stronger.</p>" + `<p>${changeHtml}</p>`;
            const fromName = company.ownerName || "Owner";
            const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
            return true;
        }
    }
    return null;
}
async function $1e16a83827fcd664$var$processCultFollowingEvent(randomEvent, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const superstar = await (0, $9tPJr.getRandomEventSuperstar)(randomEvent);
    if (randomEvent.monthsRemaining === 0) {
        const pick = (0, $3E8Nt.getRandomInt)(0, 100);
        if (pick <= 50) {
            // Increase overness, make hot
            let increase;
            if (superstar.overness >= 80) {
                increase = 10;
                superstar.overness += increase;
                if (superstar.overness > 100) superstar.overness = 100;
            } else {
                increase = 80 - superstar.overness;
                superstar.overness = 80;
                superstar.hot = true;
            }
            // Create message
            const changeHtml = `<div class="message-info-box grey">` + `<span class="green margin-right-5">` + `<i class="fa fa-angle-double-up"></i> ${increase}%` + `</span>` + `Overness` + `</div>`;
            const subject = "Following Grows";
            const content = `<p>The cult following around ${superstar.name} seems to have grown into a full-on fad.</p>` + `<p>${superstar.name} got a big boost to ${superstar.possessivePronoun} overness and is getting quite hot because of this.</p>` + `<p>${changeHtml}</p>`;
            const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
            const fromName = talentManager.name || "Staff";
            const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        } else {
            // Decrease overness, make stale
            let decrease;
            if (superstar.overness < 20) {
                decrease = 10;
                superstar.overness -= decrease;
                if (superstar.overness < 0) superstar.overness = 0;
            } else {
                decrease = superstar.overness - 19;
                superstar.overness = 19;
                superstar.stale = true;
            }
            // Create message
            const changeHtml = `<div class="message-info-box grey">` + `<span class="red margin-right-5">` + `<i class="fa fa-angle-double-down"></i> ${decrease}%` + `</span>` + `Overness` + `</div>`;
            const subject = "Following Over";
            const content = `<p>The cult following around ${superstar.name} has turned into an over-used and boring joke. Needless to say, the original interest has died down.</p>` + `<p>${superstar.name} got a significant hit to ${superstar.possessivePronoun} overness and is getting quite stale because of it.</p>` + `<p>${changeHtml}</p>`;
            const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
            const fromName = talentManager.name || "Staff";
            const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
            await (0, $9esFv.addCompanyMessages)(company, [
                newMessage
            ]);
        }
    }
    return true;
}
async function $1e16a83827fcd664$var$backstageBrawlEventFunction(company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    const lastEvent = await (0, $5ZsVo.getLatestMonthlyEvent)(await (0, $9esFv.getCompanyEvents)(company));
    // Get active superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    let superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    if (superstars.length < 8) return null;
    // Get fight starter weights
    let fightStarterWeights = [];
    for (let x of superstars){
        let weight = 1;
        if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Main Eventer") weight += 20;
        if ([
            "Troublemaker",
            "Rebel",
            "Extreme Emotions"
        ].some((y)=>x.traits.includes(y))) weight += 50;
        fightStarterWeights.push([
            x,
            weight
        ]);
    }
    // Get fight starter
    let fightStarter;
    if (fightStarterWeights.length) {
        fightStarter = (0, $3E8Nt.weightedChoice)(fightStarterWeights);
        fightStarterWeights = fightStarterWeights.filter((x)=>x[0].$loki !== fightStarter.$loki);
    } else fightStarter = (0, $3E8Nt.getRandomChoice)(superstars);
    superstars = superstars.filter((x)=>x.$loki !== fightStarter.$loki);
    // Adjust fight starter weights based on gender
    let newFightStarterWeights = fightStarterWeights.filter((x)=>x[0].gender === fightStarter.gender);
    if (newFightStarterWeights.length) fightStarterWeights = newFightStarterWeights;
    // Get fight starter partners
    let fightStarterPartners = [];
    let fightStarterTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(fightStarter)).filter((x)=>!x.temporary);
    let fightStarterFactions = await (0, $5kTkA.getSuperstarActiveFactions)(fightStarter);
    for (let x of fightStarterTagTeams.concat(fightStarterFactions))fightStarterPartners.push(...(await (0, $5kTkA.getRosterMemberSuperstars)(x)).filter((x)=>x.$loki !== fightStarter.$loki));
    // Get fight starter helpers
    let fightStarterHelpers = [];
    for (let x of Array((0, $3E8Nt.getRandomInt)(2, 3)).keys()){
        let fightStarterHelper;
        if (fightStarterPartners.length && (0, $3E8Nt.getRandomInt)(0, 100) <= 75) {
            fightStarterHelper = (0, $3E8Nt.getRandomChoice)(fightStarterPartners);
            fightStarterPartners = fightStarterPartners.filter((x)=>x.$loki !== fightStarterHelper.$loki);
        } else if (fightStarterWeights.length) {
            fightStarterHelper = (0, $3E8Nt.weightedChoice)(fightStarterWeights);
            fightStarterWeights = fightStarterWeights.filter((y)=>y[0].$loki !== fightStarterHelper.$loki);
        } else fightStarterHelper = (0, $3E8Nt.getRandomChoice)(superstars);
        fightStarterHelpers.push(fightStarterHelper);
        superstars = superstars.filter((x)=>x.$loki !== fightStarterHelper.$loki);
    }
    // Get fight against weights
    let fightAgainstWeights = [];
    for (let x of superstars)if (x.gender === fightStarter.gender) {
        let weight = 1;
        if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Main Eventer") weight += 20;
        if (x.traits.includes("Loyal", "Giving Veteran", "Leader")) weight += 50;
        fightAgainstWeights.push([
            x,
            weight
        ]);
    }
    // Get fight against
    let fightAgainstSuperstar;
    if (fightAgainstWeights.length) {
        fightAgainstSuperstar = (0, $3E8Nt.weightedChoice)(fightAgainstWeights);
        fightAgainstWeights = fightAgainstWeights.filter((x)=>x[0].$loki !== fightAgainstSuperstar.$loki);
    } else fightAgainstSuperstar = (0, $3E8Nt.getRandomChoice)(superstars);
    superstars = superstars.filter((x)=>x.$loki !== fightAgainstSuperstar.$loki);
    // Get fight against partners
    let fightAgainstPartners = [];
    let fightAgainstTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(fightAgainstSuperstar)).filter((x)=>!x.temporary);
    let fightAgainstFactions = await (0, $5kTkA.getSuperstarActiveFactions)(fightAgainstSuperstar);
    for (let x of fightAgainstTagTeams.concat(fightAgainstFactions))fightAgainstPartners.push(...(await (0, $5kTkA.getRosterMemberSuperstars)(x)).filter((x)=>x.$loki !== fightAgainstSuperstar.$loki));
    // Get fight against helpers
    let fightAgainstHelpers = [];
    for (let x of Array((0, $3E8Nt.getRandomInt)(2, 3)).keys()){
        let fightAgainstHelper;
        if (fightAgainstPartners.length && (0, $3E8Nt.getRandomInt)(0, 100) <= 75) {
            fightAgainstHelper = (0, $3E8Nt.getRandomChoice)(fightAgainstPartners);
            fightAgainstPartners = fightAgainstPartners.filter((x)=>x.$loki !== fightAgainstHelper.$loki);
        } else if (fightAgainstWeights.length) {
            fightAgainstHelper = (0, $3E8Nt.weightedChoice)(fightAgainstWeights);
            fightAgainstWeights = fightAgainstWeights.filter((y)=>y[0].$loki !== fightAgainstHelper.$loki);
        } else fightAgainstHelper = (0, $3E8Nt.getRandomChoice)(superstars);
        fightAgainstHelpers.push(fightAgainstHelper);
        superstars = superstars.filter((x)=>x.$loki !== fightAgainstHelper.$loki);
    }
    // Create message from owner
    const fightSuperstars = [
        fightStarter,
        ...fightStarterHelpers,
        fightAgainstSuperstar,
        ...fightAgainstHelpers
    ];
    let reasons = [
        `circulating dirt sheet rumors`,
        `allegations during a post event interview`,
        `refusing to take advice`
    ];
    let severeAction = [
        `${(0, $3E8Nt.getRandomChoice)(fightSuperstars).name} got knocked out`,
        `a table got thrown at ${(0, $3E8Nt.getRandomChoice)(fightSuperstars).name}`,
        `${(0, $3E8Nt.getRandomChoice)(fightSuperstars).name}'s valuables got destroyed`
    ];
    let subject = "Backstage Brawl";
    let content = `<p>After ${lastEvent.name}, ${fightStarter.name} got into a disagreement with ` + `${fightAgainstSuperstar.name} in the locker room, reportedly about ${(0, $3E8Nt.getRandomChoice)(reasons)}.</p>` + `<p>As the argument got heated, ${(0, $3E8Nt.commaSeparate)(fightAgainstHelpers.map((x)=>x.name))} joined ` + `${fightAgainstSuperstar.name}, which only escalated things.</p>` + `<p>${(0, $3E8Nt.commaSeparate)(fightStarterHelpers.map((x)=>x.name))} rushed to defend ${fightStarter.name}, and a brawl ` + `broke out between the two parties in which ${(0, $3E8Nt.getRandomChoice)(severeAction)}.</p>` + `<p>Tensions are high backstage. We don't know who started the fight, so the safe choice would be ` + `to suspend everyone involved in the brawl. We could also ignore it and hope things fix themselves.</p>`;
    let fromName = company.ownerName || "Owner";
    let newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "owner");
    newMessage.promptAction = true;
    await (0, $9esFv.addCompanyMessages)(company, [
        newMessage
    ]);
    // Create random event
    const newRandomEvent = (0, $9tPJr.RandomEvent)();
    (0, $14eBR.RandomEvents).insert(newRandomEvent);
    newRandomEvent.name = "backstageBrawl";
    await (0, $9esFv.addCompanyRandomEvents)(company, [
        newRandomEvent
    ]);
    newRandomEvent.monthsRemaining = 1;
    newRandomEvent.choices = [
        "Suspend",
        "Ignore"
    ];
    newRandomEvent.selectionIds = fightSuperstars.map((x)=>x.$loki);
    await (0, $9tPJr.addRandomEventMessages)(newRandomEvent, [
        newMessage
    ]);
    // Check to acquire trait
    await (0, $5kTkA.checkAcquireTrait)(fightStarter, "Troublemaker");
    return true;
}
async function $1e16a83827fcd664$var$processBackstageBrawlEvent(randomEvent, company) {
    const game = await (0, $9esFv.getCompanyGame)(company);
    // Get superstars
    const roster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
    const superstars = await $1e16a83827fcd664$var$getActiveSuperstars(roster);
    const superstarsAffected = superstars.filter((x)=>randomEvent.selectionIds.includes(x.$loki));
    const superstarsAffectedNames = (0, $3E8Nt.commaSeparate)(superstarsAffected.map((x)=>x.name));
    if (randomEvent.monthsRemaining === 0 && randomEvent.selectedChoice === "Ignore") {
        const pick = (0, $3E8Nt.getRandomInt)(0, 100);
        let subject;
        let content;
        if (pick <= 70) {
            // Make some superstars unhappy
            let superstarsToMakeUnhappy = (0, $3E8Nt.getRandomSample)(superstarsAffected, Math.ceil(superstarsAffected.length / 2));
            for (let x of superstarsToMakeUnhappy)if (!game.settings["no_unhappiness"]) await (0, $5kTkA.changeSuperstarMoraleToUnhappy)(x, company);
            subject = "Unresolved issues";
            content = `<p>The issues resulting from the backstage brawl haven't improved; in fact ` + `${(0, $3E8Nt.commaSeparate)(superstarsToMakeUnhappy.map((x)=>x.name))} are clearly unhappy with the situation ` + `and their morale has dropped.</p>` + `<p>I think our lack of dealing with the issue didn't help.</p>`;
        } else {
            subject = "Issues resolved";
            content = `<p>The issues between ${superstarsAffectedNames} seem to have been resolved.</p>` + `<p>I think the brawl has largely been forgotten and everyone is eager to work together.</p>`;
        }
        // Create message
        const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
        const fromName = talentManager ? talentManager.name : "Staff";
        const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        return true;
    }
    // Suspend superstars
    if (randomEvent.selectedChoice === "Suspend" && !randomEvent.eventsRun.includes("0A")) {
        for (const superstar of superstarsAffected){
            superstar.suspensionMonths = 1;
            // Check talent request
            await (0, $1olyO.checkTalentRequestAction)({
                company: company,
                requestType: "write_off",
                talent: superstar
            });
            // Add to company logs
            const newCompanyLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
            await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
            newCompanyLog.text = superstar.name;
            newCompanyLog.type = "suspension";
            newCompanyLog.value = superstar.suspensionMonths;
            await (0, $9esFv.addCompanyCompanyLogs)(company, [
                newCompanyLog
            ]);
        }
        // Create message
        const subject = "Superstars Suspended";
        const content = `<p>The following superstars involved in the recent backstage brawl have been suspended:</p>` + `<p>${superstarsAffectedNames}.</p>` + `<p>This should help protect the locker room's morale.</p>`;
        const talentManager = await $1e16a83827fcd664$var$getCompanyTalentManager(company);
        const fromName = talentManager ? talentManager.name : "Staff";
        const newMessage = await (0, $hekDR.createMessage)(subject, fromName, game.monthCount, game.year, content, "staff");
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
        // Add to events run
        randomEvent.eventsRun.push("0A");
        return true;
    }
    return null;
}

});
parcelRequire.register("khZb1", function(module, exports) {

$parcel$export(module.exports, "randomEventsData", () => $ec54d999ef7a7c36$export$35a3663e1be77280);
$parcel$export(module.exports, "superstarUnavailableReasons", () => $ec54d999ef7a7c36$export$c27e60175313414d);
let $ec54d999ef7a7c36$export$35a3663e1be77280 = [
    // Minor
    {
        "name": "superstarNotAvailable",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "superstarNotAvailable",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "superstarNotAvailable",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "mainstreamCoverage",
        "category": "minor",
        "repeatable": false
    },
    {
        "name": "ownerControversy",
        "category": "minor",
        "repeatable": false
    },
    {
        "name": "negativeSuperstarCoverage",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "moraleBoost",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "gimmickInterview",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "goodTrainingSession",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "neglectedTraining",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "hairChange",
        "category": "minor",
        "repeatable": false
    },
    {
        "name": "gimmickMatchBoost",
        "category": "minor",
        "repeatable": false
    },
    {
        "name": "feudIgnored",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "feudBoosted",
        "category": "minor",
        "repeatable": true
    },
    {
        "name": "cultFollowing",
        "category": "minor",
        "repeatable": false
    },
    {
        "name": "wrestlerCourt",
        "category": "minor",
        "repeatable": false
    },
    {
        "name": "factionBoosted",
        "category": "minor",
        "repeatable": false
    },
    {
        "name": "factionIgnored",
        "category": "minor",
        "repeatable": false
    },
    // Major
    {
        "name": "fluBug",
        "category": "major",
        "repeatable": false
    },
    {
        "name": "flightsCancelled",
        "category": "major",
        "repeatable": false
    },
    {
        "name": "backstageUnrest",
        "category": "major",
        "repeatable": false
    },
    {
        "name": "planeRideSuspensions",
        "category": "major",
        "repeatable": false
    },
    {
        "name": "stormAffectsShow",
        "category": "major",
        "repeatable": false
    },
    {
        "name": "showAppearances",
        "category": "major",
        "repeatable": false
    },
    {
        "name": "backstageFight",
        "category": "major",
        "repeatable": true
    },
    {
        "name": "drugAbuse",
        "category": "major",
        "repeatable": true
    },
    {
        "name": "superstarBreak",
        "category": "major",
        "repeatable": true
    },
    {
        "name": "championshipStolen",
        "category": "major",
        "repeatable": false
    },
    {
        "name": "conservativeGovernmentShow",
        "category": "major",
        "repeatable": false
    },
    {
        "name": "drugScandal",
        "category": "major",
        "repeatable": false
    },
    {
        "name": "backstageBrawl",
        "category": "major",
        "repeatable": false
    }
];
const $ec54d999ef7a7c36$export$c27e60175313414d = [
    {
        "name": "Missed Flight",
        "content": "I missed my flight! I'll try my best to get another but I don't think I'll be able to make it to the show."
    },
    {
        "name": "Car Accident",
        "content": "I had a small car accident on my way to the show. I'm doing fine but I won't be able to make it to the event."
    },
    {
        "name": "Lost Ticket",
        "content": "I lost my ticket and couldn't get a new one in time, so I can't show up for the upcoming event. Sorry!"
    },
    {
        "name": "Car Breakdown",
        "content": "My car broke down on the way to the arena. Unfortunately, I won't be able to make it."
    },
    {
        "name": "Home Accident",
        "content": "I had a minor accident while driving around on my motorbike. I know, it was quite stupid. I'm doing better but I can't wrestle this show."
    },
    {
        "name": "Illness",
        "content": "I've come down with a bad case of the flu. I don't think I can wrestle right now."
    },
    {
        "name": "Lost Passport",
        "content": "I lost my passport.. can you believe that? Needless to say I can't make it to the show."
    },
    {
        "name": "Family Emergency",
        "content": "A family emergency came up today so I won't be able to come to the next event. I'll see you after."
    },
    {
        "name": "Can't Make It",
        "content": "Due to some personal reasons, I cannot make it to the upcoming event. You'll have to do without me."
    }
];

});

parcelRequire.register("9tPJr", function(module, exports) {

$parcel$export(module.exports, "RandomEvent", () => $6e6ef36150f53742$export$315a662b45778750);
$parcel$export(module.exports, "addRandomEventMessages", () => $6e6ef36150f53742$export$c1f9281c4831fe14);
$parcel$export(module.exports, "getRandomEventMessage", () => $6e6ef36150f53742$export$7ec0f23f50c1d831);
$parcel$export(module.exports, "getRandomEventSuperstar", () => $6e6ef36150f53742$export$5f12a05a03ab1f7d);
$parcel$export(module.exports, "getRandomEventChampionship", () => $6e6ef36150f53742$export$b4022fa94d768685);
$parcel$export(module.exports, "getRandomEventGimmickMatch", () => $6e6ef36150f53742$export$8b4462b42c7fbcd8);

var $14eBR = parcelRequire("14eBR");
function $6e6ef36150f53742$export$315a662b45778750() {
    // Integer
    const monthsRemaining = null;
    // Strings
    const name = null;
    const selectedChoice = null;
    const location = null;
    // Arrays
    const choices = [];
    const eventsRun = [];
    const selectionIds = [];
    // Foreign keys
    const companyId = null;
    const superstarId = null;
    const championshipId = null;
    const gimmickMatchId = null;
    return {
        monthsRemaining: monthsRemaining,
        name: name,
        selectedChoice: selectedChoice,
        location: location,
        choices: choices,
        eventsRun: eventsRun,
        selectionIds: selectionIds,
        companyId: companyId,
        superstarId: superstarId,
        championshipId: championshipId,
        gimmickMatchId: gimmickMatchId
    };
}
function $6e6ef36150f53742$export$c1f9281c4831fe14(randomEvent, messages) {
    messages.forEach((c)=>{
        c.randomEventId = randomEvent.$loki;
    });
}
function $6e6ef36150f53742$export$f0e15614fd849cf5(randomEvent, messages) {
    messages.forEach((c)=>{
        c.randomEventId = null;
    });
}
function $6e6ef36150f53742$export$7ec0f23f50c1d831(randomEvent) {
    return (0, $14eBR.Messages).find({
        "randomEventId": randomEvent.$loki
    })[0];
}
function $6e6ef36150f53742$export$5f12a05a03ab1f7d(randomEvent) {
    return (0, $14eBR.Superstars).find({
        "$loki": randomEvent.superstarId
    })[0];
}
function $6e6ef36150f53742$export$b4022fa94d768685(randomEvent) {
    return (0, $14eBR.Championships).find({
        "$loki": randomEvent.championshipId
    })[0];
}
function $6e6ef36150f53742$export$8b4462b42c7fbcd8(randomEvent) {
    return (0, $14eBR.GimmickMatches).find({
        "$loki": randomEvent.gimmickMatchId
    })[0];
}

});




parcelRequire.register("3MfBd", function(module, exports) {

$parcel$export(module.exports, "checkToGoToNextTutorialState", () => $2c01f47bfbd776fd$export$aa75f19ce2ee2cff);

var $iTOJp = parcelRequire("iTOJp");

var $9esFv = parcelRequire("9esFv");

var $98xmD = parcelRequire("98xmD");

var $14eBR = parcelRequire("14eBR");
/*
Tutorial state uses a single story choice to store data.
State name is stored in the "choice" attribute.
Tutorial state names are stored in a list.
 */ async function $2c01f47bfbd776fd$export$aa75f19ce2ee2cff(company, stateCompletedNames) {
    let currentState = (await (0, $9esFv.getCompanyStoryChoices)(company))[0];
    if (stateCompletedNames.includes(currentState.choice)) {
        let nextState = $2c01f47bfbd776fd$var$goToNextTutorialState(currentState);
        if (nextState === "end_tutorial") {
            company.storyName = null;
            if (!(0, $98xmD.globalUser).paid) await $2c01f47bfbd776fd$var$removeTutorialPaidFeatures(company);
        }
        return nextState;
    }
    return false;
}
function $2c01f47bfbd776fd$var$getNextTutorialStateName(currentState) {
    // Get next tutorial state based on name of current state
    let currentStateIndex = (0, $iTOJp.tutorialStates).indexOf(currentState.choice);
    let nextStateIndex = currentStateIndex + 1;
    if (nextStateIndex < (0, $iTOJp.tutorialStates).length) return (0, $iTOJp.tutorialStates)[nextStateIndex];
    else return null;
}
function $2c01f47bfbd776fd$var$goToNextTutorialState(currentState) {
    // Move tutorial to next state if it is present
    currentState.choice = $2c01f47bfbd776fd$var$getNextTutorialStateName(currentState);
    return currentState.choice;
}
async function $2c01f47bfbd776fd$var$removeTutorialPaidFeatures(company) {
    for (let staffMember of (await (0, $9esFv.getCompanyStaff)(company)))await (0, $14eBR.StaffMembers).remove(staffMember);
}

});
parcelRequire.register("iTOJp", function(module, exports) {

$parcel$export(module.exports, "tutorialSteps", () => $dc24b73c5af961af$export$49aa6a98f5586f5d);
$parcel$export(module.exports, "tutorialStates", () => $dc24b73c5af961af$export$e5d4b0e25437ae78);
const $dc24b73c5af961af$export$49aa6a98f5586f5d = {
    "add_singles_match": [
        {
            "text": 'Welcome to the JoW Tutorial. I am the Mysterious Advisor and I am going to teach you how to run your wrestling company. Click <span class="tutorial-color">Continue</span> or press <span class="tutorial-color">enter</span> to continue.',
            "element": null,
            "action": null
        },
        {
            "text": "You're in charge of Ultimate Action Wrestling, a small but growing company looking to challenge the behemoth, Global Wrestling Federation, in the year 2003.",
            "element": null,
            "action": null
        },
        {
            "text": 'Once you are done with the tutorial, you can keep playing this game with all the normal features. You can also exit the tutorial by clicking <span class="tutorial-color">Menu</span> and come back to it later.',
            "element": "#main-menu-button",
            "action": null
        },
        {
            "text": "Let's start with your dashboard. It contains alerts about your roster, upcoming events and staff tasks.",
            "element": "#dashboard-container",
            "action": null
        },
        {
            "text": "This is the card for your upcoming event. Booked matches and segments will show up here.",
            "element": "#event-card",
            "action": null
        },
        {
            "text": 'Let\'s book a match. Click <span class="tutorial-color">Book</span> to open the booking page.',
            "element": "#book-menu-button",
            "action": "click_book_button"
        },
        {
            "text": "This is the match booking page, containing your singles roster.",
            "element": "#booking-container",
            "action": null
        },
        {
            "text": 'We\'re going to book a match between our two top stars. Click on <span class="tutorial-color">Ghost</span> (you might have to tap twice on mobile) to select him for booking.',
            "element": '.roster-item-member[data-name="Ghost"]',
            "action": "click_superstar_select"
        },
        {
            "text": "Here you can see this superstar's information, such as their popularity, workrate and charisma.",
            "element": ".superstar-information-container",
            "action": null
        },
        {
            "text": "A superstar's popularity determines their rank on your roster. Ghost's popularity is over 800 and he is a Main Eventer.",
            "element": ".superstar-info-popularity",
            "action": null
        },
        {
            "text": "Ghost also has a high workrate, which means he should perform well in a match.",
            "element": ".superstar-info-workrate",
            "action": null
        },
        {
            "text": 'Click on <span class="tutorial-color">Sean Hunt</span> to book these two in a match.',
            "element": '.roster-item-member[data-name="Sean Hunt"]',
            "action": "add_singles_match"
        },
        {
            "text": "Great! This match is now on your event card.",
            "element": "#matches",
            "action": null
        }
    ],
    "add_feud_to_match": [
        {
            "text": 'Let\'s add a feud to this match. A feud is a rivalry or story that the superstars are involved in. Click <span class="tutorial-color">Edit</span> and select <span class="tutorial-color">Add Feud</span>.',
            "element": ".event-card-match-edit-menu .button-dropdown",
            "action": "click_add_feud",
            "subElements": [
                ".event-card-match-add-feud-button"
            ]
        },
        {
            "text": 'Let\'s select the <span class="tutorial-color">Better Wrestler</span> feud.',
            "element": ".feud-item-container",
            "action": "select_feud_item"
        },
        {
            "text": "This feud will now start when this match runs. There are other ways to start feuds that I'll go over later.",
            "element": ".match-feud-name",
            "action": null,
            "position": "bottom"
        }
    ],
    "add_tag_match": [
        {
            "text": 'Click <span class="tutorial-color">Tag Team</span> to open the teams roster.',
            "element": "#book-tag-team-menu-button",
            "action": "click_tag_team_button"
        },
        {
            "text": 'This time, we\'ll book more than 2 participants in the match, so click <span class="tutorial-color">Multi</span> to enable multiple selections.',
            "element": "#multi-match-button",
            "action": "click_multi_button"
        },
        {
            "text": 'Let\'s book a match for the tag titles. Select <span class="tutorial-color">Brothers of Sickness</span>.',
            "element": '.roster-item-member[data-name="Brothers of Sickness"]',
            "action": "click_team_select"
        },
        {
            "text": "The team's information shows the average of its members' stats.",
            "element": ".superstar-information-container",
            "action": null
        },
        {
            "text": 'Select <span class="tutorial-color">The Foundation</span>, who are the champions.',
            "element": '.roster-item-member[data-name="The Foundation"]',
            "action": "click_team_select"
        },
        {
            "text": 'And select <span class="tutorial-color">The Dirty Reeds</span>.',
            "element": '.roster-item-member[data-name="The Dirty Reeds"]',
            "action": "click_team_select"
        },
        {
            "text": 'Now click <span class="tutorial-color">Book</span> to add this match.',
            "element": "#add-match-button",
            "action": "add_tag_team_match",
            "position": "bottom"
        },
        {
            "text": "This three-way match is now booked for the tag titles.",
            "element": "#matches",
            "action": null
        }
    ],
    "play_first_event": [
        {
            "text": 'Okay, it\'s time to run your first event! Click <span class="tutorial-color">Play</span>.',
            "element": "#play-event",
            "action": "click_play_event"
        },
        {
            "text": "This page contains the details of the match and its participants.",
            "element": ".match-container",
            "action": null
        },
        {
            "text": '<span class="tutorial-color">Brothers of Sickness</span> are one of our top teams, so let\'s select them to win the match.',
            "element": '.match-wrestler[data-name="Brothers of Sickness"]',
            "action": "click_match_wrestler"
        },
        {
            "text": "This is the result of the match, which shows attribute changes and the match rating. You can hover over items to see their details.",
            "element": ".match-result",
            "action": null
        },
        {
            "text": "It looks like Chris Gray suffered an injury, right as his team won the titles! Your staff will give you details about the injury after the event.",
            "element": ".updates-container",
            "action": null
        },
        {
            "text": "I don't think Brothers of Sickness can be the champions with one member injured, so let's vacate the titles.",
            "element": ".vacate-superstar-championships-button",
            "action": "click_vacate_superstar_championships_button"
        },
        {
            "text": 'The titles were vacated. Click <span class="tutorial-color">Continue</span> to go to the next match.',
            "element": "#progress-segment-button",
            "action": "click_match_continue"
        }
    ],
    "simulate_match": [
        {
            "text": 'For this match, let\'s simulate the winner. When simulating, the game will choose the winner for you. Click <span class="tutorial-color">Simulate</span>.',
            "element": "#simulate-match",
            "action": "click_simulate_button",
            "position": "bottom",
            "scrollTo": "end"
        },
        {
            "text": 'The Better Wrestler feud was started in this match. You can see the hype for this feud, marked by <i class="fa fa-bolt faded-red-light margin-left-2"></i>. The higher the hype, the more fans it will attract.',
            "element": ".match-result-feuds",
            "action": null
        }
    ],
    "end_first_event": [
        {
            "text": 'Okay, click <span class="tutorial-color">Continue</span> to end the event.',
            "element": "#progress-segment-button",
            "action": "click_event_continue"
        },
        {
            "text": "After an event ends, you'll get some Creative Points based on the event's rating.",
            "element": ".event-results-points-change",
            "action": null
        },
        {
            "text": "Creative Points are used instead of money for most company actions, like signing talent, adding gimmick matches and hiring staff.",
            "element": "#points",
            "action": null
        },
        {
            "text": 'Click <span class="tutorial-color">Continue</span> to go to the next event.',
            "element": "#continue",
            "action": "go_to_game"
        }
    ],
    "view_messages": [
        {
            "text": "Your first event is over, so let's take a look at that injury. Click the messages icon.",
            "element": "#messages",
            "action": "click_messages_button"
        },
        {
            "text": "This is your messages page. Here you'll find updates from your staff, messages from the owner and your superstars. Check it often.",
            "element": "#game-messages",
            "action": null
        },
        {
            "text": "Open up the injury message from your staff.",
            "element": '.message-preview-item:contains("Injury")',
            "action": "click_injury_message"
        },
        {
            "text": "Okay, looks like Chris Gray is out for a while. We'll deal with that soon. You can read other messages if you want here, I'll wait.",
            "element": "#game-messages .message-content-container",
            "action": null
        }
    ],
    "book_feud_segment": [
        {
            "text": "You're on a weekly show now. Let's start by booking a segment. A segment can be a promo or any other thing that is not a match. Click <span class=\"tutorial-color\">Book</span>.",
            "element": "#book-menu-button",
            "action": "click_book_segment_button"
        },
        {
            "text": "This is the segment booking page.",
            "element": "#booking-container",
            "action": null
        },
        {
            "text": "Segment items show up here. These determine what kind of segment it will be.",
            "element": "#segment-items-container",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": "Segment participants show up here. Currently it's showing feuds.",
            "element": ".participants-box-segment-container",
            "action": null
        },
        {
            "text": 'Click on the <span class="tutorial-color">Better Wrestler</span> feud to select its participants for the segment.',
            "element": ".feud-container",
            "action": "click_segment_feud"
        },
        {
            "text": 'We\'ll book these two in a <span class="tutorial-color">Promo Ambush</span> segment.',
            "element": '.segment-item-container[data-name="Promo Ambush"]',
            "action": "click_segment_item"
        },
        {
            "text": 'Now click <span class="tutorial-color">Book</span> to add this segment.',
            "element": "#add-segment",
            "action": "add_segment"
        }
    ],
    "book_singles_segment": [
        {
            "text": 'Let\'s book another segment. Click <span class="tutorial-color">Singles</span> to open the singles roster.',
            "element": '.book-segment-option:contains("Singles")',
            "action": "click_segment_singles_button"
        },
        {
            "text": 'Click on <span class="tutorial-color">The Empress</span> to select her for the segment.',
            "element": '.roster-item-member[data-name="The Empress"]',
            "action": "click_segment_superstar_select"
        },
        {
            "text": "The Empress has high charisma, which means she should perform well in a segment.",
            "element": ".superstar-info-charisma",
            "action": null
        },
        {
            "text": 'Select the <span class="tutorial-color">Backstage Interview</span> segment item.',
            "element": '.segment-item-container[data-name="Backstage Interview"]',
            "action": "click_segment_item"
        },
        {
            "text": 'Now click <span class="tutorial-color">Book</span> to add this segment.',
            "element": "#add-segment",
            "action": "add_segment"
        },
        {
            "text": "Good job! You can add a variety of segments for superstars and teams this way.",
            "element": "#matches",
            "action": null
        }
    ],
    "view_superstar_details": [
        {
            "text": 'Okay, let\'s deal with that injury. Click <span class="tutorial-color">Manage</span>.',
            "element": "#manage",
            "action": "click_manage_button"
        },
        {
            "text": 'Click <span class="tutorial-color">Roster</span> and select <span class="tutorial-color">View</span>.',
            "element": "#manage-roster",
            "action": "click_view_roster",
            "subElements": [
                "#view-roster-menu-button"
            ]
        },
        {
            "text": "This is your roster page containing details of all your superstars.",
            "element": "#roster-container",
            "action": null
        },
        {
            "text": 'Click on <span class="tutorial-color">Chris Gray</span> to open his details.',
            "element": '.roster-member:contains("Chris Gray")',
            "action": "click_roster_superstar"
        },
        {
            "text": "This page contains all of the superstar's details.",
            "element": "#roster-member-details",
            "action": null
        },
        {
            "text": "This is your superstar's alignment, which can be Face, Heel or Neutral. This affects their matches and feuds. Faces generally do well against heels.",
            "element": ".roster-member-alignment",
            "action": null
        },
        {
            "text": "This is their appearances status, which can be full time or part time.",
            "element": ".roster-member-status",
            "action": null
        },
        {
            "text": "This is their overness, which determines how much the fans like them. Superstars can get over or become stale due to their overness.",
            "element": ".roster-member-overness",
            "action": null
        },
        {
            "text": "This is their morale. If this goes too low, they can get unhappy and potentially leave the company.",
            "element": ".roster-member-morale",
            "action": null
        },
        {
            "text": "These are their workrate and charisma stats. Superstars gain XP in their skills by performing and via training.",
            "element": ".roster-member-workrate-and-charisma",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": "This is their gimmick, which can affect their overness.",
            "element": ".roster-member-gimmick-container",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": "Superstars can have traits, each of which has a unique effect that you can see by hovering over it.",
            "element": ".roster-member-traits-container",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": "These are your superstar's stats, from win/loss records to best matches. These are only available in <span class='gold'>JoW Paid</span>.",
            "element": ".roster-member-stats",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": "Here you have actions you can perform on your superstar, from training, changing alignment to adding a gimmick or releasing them.",
            "element": ".roster-member-actions",
            "action": null,
            "scrollTo": "start"
        }
    ],
    "disband_team": [
        {
            "text": 'Okay, let\'s add a new team for Brandon Gray. But first, we need to disband Brothers of Sickness. Click <span class="tutorial-color">Roster</span> and select <span class="tutorial-color">Teams</span>.',
            "element": "#manage-roster",
            "action": "click_view_teams",
            "subElements": [
                "#view-teams-menu-button"
            ]
        },
        {
            "text": "This is your teams page containing details of all your tag teams and trios.",
            "element": "#view-teams-container",
            "action": null
        },
        {
            "text": 'Click <span class="tutorial-color">Brothers of Sickness</span> to open their details.',
            "element": '.view-teams-item:contains("Brothers of Sickness")',
            "action": "click_view_teams_item"
        },
        {
            "text": "Here you can find all of the information for the team.",
            "element": "#roster-member-details",
            "action": null
        },
        {
            "text": 'Click <span class="tutorial-color">Disband</span> to disband this team.',
            "element": ".disband-team-button",
            "action": "disband_team"
        }
    ],
    "add_team": [
        {
            "text": 'Now click <span class="tutorial-color">Add</span> to add a new team.',
            "element": "#add-team-menu-button",
            "action": "click_add_team_menu_button"
        },
        {
            "text": 'Select <span class="tutorial-color">Brandon Gray</span> as the first superstar.',
            "element": ".add-team-first-superstar-select",
            "action": "select_team_first_superstar",
            "position": "bottom"
        },
        {
            "text": 'We\'re going to team him with <span class="tutorial-color">Benjamin Dread</span>, who should be a good match for him.',
            "element": ".add-team-second-superstar-select",
            "action": "select_team_second_superstar"
        },
        {
            "text": "Enter a name for the team.",
            "element": ".add-team-name",
            "action": null
        },
        {
            "text": 'Now click <span class="tutorial-color">Add</span>.',
            "element": "#add-team-button",
            "action": "add_team",
            "position": "bottom",
            "subElements": [
                ".add-team-name"
            ]
        },
        {
            "text": "Great, Brandon Gray is now ready to challenge for those vacated titles.",
            "element": "",
            "action": null
        }
    ],
    "add_vacant_title_match": [
        {
            "text": 'Click <span class="tutorial-color">Book</span>.',
            "element": "#book-menu-button",
            "action": "click_book_segment_button"
        },
        {
            "text": 'Click <span class="tutorial-color">Tag Team</span> to open the teams roster.',
            "element": "#book-tag-team-menu-button",
            "action": "click_tag_team_button"
        },
        {
            "text": "Select the vacant tag titles. This will book them in the match.",
            "element": ".superstar-select.roster-item-championship",
            "action": "click_title_select"
        },
        {
            "text": "Select the newly created team.",
            "element": ".roster-item-member",
            "action": "click_team_select"
        },
        {
            "text": 'And select <span class="tutorial-color">The Foundation</span>, the former champions, to book them in a match.',
            "element": '.roster-item-member[data-name="The Foundation"]',
            "action": "add_tag_team_match"
        },
        {
            "text": "This match is now booked for the vacant tag titles.",
            "element": "#matches",
            "action": null
        }
    ],
    "add_gimmick_to_match": [
        {
            "text": 'I feel like the match needs a gimmick. The titles are vacant. You thinking what I\'m thinking? Click <span class="tutorial-color">Edit</span> and select <span class="tutorial-color">Add Gimmick</span>.',
            "element": ".event-card-match-edit-menu:last .button-dropdown",
            "action": "click_add_gimmick",
            "subElements": [
                ".event-card-match-add-gimmick-button"
            ]
        },
        {
            "text": 'Gimmick matches can boost match ratings but cost some Creative Points. Select <span class="tutorial-color">Ladder</span> to open its details.',
            "element": '.gimmick-match-item[data-name="Ladder"]',
            "action": "click_gimmick_match_item"
        },
        {
            "text": 'Click <span class="tutorial-color">Add Gimmick Match</span> to make this a ladder match.',
            "element": ".confirm-gimmick-match-for-match",
            "action": "add_gimmick_to_match"
        },
        {
            "text": "You can perform a variety of other actions in the Edit menu, like deleting the match/segment, adding or removing a feud, removing a title to make a non-title match or selecting multiple titles.",
            "element": ".event-card-match-edit-menu:last .button-dropdown",
            "action": null
        }
    ],
    "move_to_main_event": [
        {
            "text": "I think the title match should be in the main event, so let's move it up there.",
            "element": "#matches",
            "action": null
        },
        {
            "text": "Click and drag the title match to where the current main event is.",
            "element": ".event-match:last",
            "action": "move_match_to_main_event",
            "position": "bottom"
        },
        {
            "text": "There you go! You can rearrange match order like this.",
            "element": "#matches",
            "action": null
        }
    ],
    "play_second_event": [
        {
            "text": 'Okay, let\'s run this event. Click <span class="tutorial-color">Play</span>.',
            "element": "#play-event",
            "action": "click_play_event"
        },
        {
            "text": "This page contains the segment details. The segment is now running.",
            "element": ".match-container",
            "action": "play_segment"
        },
        {
            "text": "Here you can see the result of the segment.",
            "element": "#event-match-results",
            "action": null
        },
        {
            "text": 'Click <span class="tutorial-color">Continue</span> to go to the next segment.',
            "element": "#progress-segment-button",
            "action": "click_segment_continue"
        }
    ],
    "play_second_event_second_segment": [
        {
            "text": 'For some segments, you can select who performs the action. We\'ll have <span class="tutorial-color">Sean Hunt</span> perform the attack, being the heel.',
            "element": '.match-wrestler:contains("Sean Hunt")',
            "action": "select_segment_winner",
            "scrollTo": "end"
        },
        {
            "text": 'With the segment over, click <span class="tutorial-color">Continue</span> to go to the main event.',
            "element": "#progress-segment-button",
            "action": "click_segment_continue"
        }
    ],
    "play_second_event_main_event": [
        {
            "text": 'The title match is up next. Let\'s add an alternate finish to this match. Click <span class="tutorial-color">Add Finish</span>.',
            "element": ".show-match-finishes-button",
            "action": "click_add_finish_button",
            "position": "bottom",
            "scrollTo": "end"
        },
        {
            "text": 'Select <span class="tutorial-color">Cheating</span> as the finish.',
            "element": '.match-finishes-item-container:contains("Cheating")',
            "action": "click_match_finish_item"
        },
        {
            "text": "Here are the details of this finish, such as whether it affects morale, its effect on rating and on popularity/overness changes.",
            "element": ".match-finishes-item-container.selected",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": "Let's select the heels to win by cheating. Brandon Gray will have a longer road to recapturing the tag titles.",
            "element": '.match-wrestler[data-name="The Foundation"]',
            "action": "click_match_wrestler"
        }
    ],
    "end_second_event": [
        {
            "text": 'Okay, they won by cheating. Click <span class="tutorial-color">Continue</span> to end the event.',
            "element": "#progress-segment-button",
            "action": "click_event_continue",
            "scrollTo": "end"
        },
        {
            "text": "This page shows updates like injuries, morale changes and feuds started/ended.",
            "element": "#event-updates",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": "This page shows your prestige changes. Most items, like segments, events and titles, have prestige that can be raised to provide benefits.",
            "element": "#prestige-results",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": 'Click <span class="tutorial-color">Continue</span> to go to the post event.',
            "element": "#continue",
            "action": "go_to_post_event"
        },
        {
            "text": "This page shows your viewership results. After weekly shows, you'll see how many viewers you and your competitors got, and event buys after monthly events. This feature is only available in <span class='gold'>JoW Paid</span>.",
            "element": ".viewership-results-box",
            "action": null
        },
        {
            "text": 'Your viewership depends on your existing fans and the hype of your event. You can learn more about event hype by clicking <span class="tutorial-color">Help</span> under <span class="tutorial-color">About</span> in the main menu.',
            "element": ".user-company",
            "action": null
        },
        {
            "text": "Your fan change depends on your event's rating relative to your competitors'. ",
            "element": ".user-company .viewership-results-fan-change",
            "action": null
        },
        {
            "text": "Fans determine your company's reputation, which affects things like your roster size and the ability to buyout competitors.",
            "element": "#fans",
            "action": null
        },
        {
            "text": 'Click <span class="tutorial-color">Continue</span> to go to the next event.',
            "element": "#continue-viewership-results-button",
            "action": "go_to_game",
            "scrollTo": "end"
        }
    ],
    "goals": [
        {
            "text": 'Let\'s take a look at the event you just ran. Click <span class="tutorial-color">Manage</span>.',
            "element": "#manage",
            "action": "click_manage_button"
        },
        {
            "text": 'Click <span class="tutorial-color">Company</span> and select <span class="tutorial-color">Events</span>.',
            "element": "#manage-company",
            "action": "click_view_events",
            "subElements": [
                "#view-events-menu-button"
            ]
        },
        {
            "text": "This is the event history page. You can go through all your past events, view your calender and see competitors' events.",
            "element": "#event-history-container",
            "action": null
        },
        {
            "text": 'Now let\'s see how you are doing against your competitors. Click <span class="tutorial-color">Job</span> and select <span class="tutorial-color">Fan History</span>.',
            "element": "#manage-job",
            "action": "click_view_fan_history",
            "subElements": [
                "#view-fan-history-menu-button"
            ]
        },
        {
            "text": "This is the fan history page. You can see graphs of fans, viewers, buys and fan change here as you progress through the game.",
            "element": ".viewership-history-container",
            "action": null
        },
        {
            "text": "Let's take a look at your game's options.",
            "element": "#view-options-menu-button",
            "action": "click_game_options"
        },
        {
            "text": "Here, you can change your game's settings, like the number of weekly shows to run.",
            "element": "#game-options-container",
            "action": null
        },
        {
            "text": 'Each year, your owner will give you goals to complete. Let\'s take a look at them. Click <span class="tutorial-color">Job</span> and select <span class="tutorial-color">Goals</span>.',
            "element": "#manage-job",
            "action": "click_view_objectives",
            "subElements": [
                "#view-objectives-menu-button"
            ]
        },
        {
            "text": "These are your goals for this year. Complete them to be rewarded with Creative Points. You'll also get a message from the owner about your goals.",
            "element": "#objectives-list",
            "action": null
        },
        {
            "text": "Your first goal is to make Johnny Knight a main eventer. You can do that by booking him to win until his popularity goes above 800.",
            "element": '.objective-item-container:contains("Johnny Knight")',
            "action": null
        }
    ],
    "add_feud": [
        {
            "text": 'Let\'s put Johnny Knight into a feud. Click <span class="tutorial-color">Company</span> and select <span class="tutorial-color">Feuds</span>.',
            "element": "#manage-company",
            "action": "click_view_feuds_menu_button",
            "subElements": [
                "#view-feuds-menu-button"
            ]
        },
        {
            "text": "This is your feuds page. It shows your current, potential and past feuds, and allows you to create new feuds.",
            "element": "#feud-history-container",
            "action": null
        },
        {
            "text": 'Click <span class="tutorial-color">Add</span> to add a feud.',
            "element": "#create-feud-menu-button",
            "action": "click_create_feud_menu_button"
        },
        {
            "text": 'Select <span class="tutorial-color">Johnny Knight</span> as the first superstar.',
            "element": ".create-feud-first-participant-select",
            "action": "select_first_feud_superstar"
        },
        {
            "text": 'We\'ve got to put him against a top guy to get him to the main event, so select <span class="tutorial-color">Joe Hammer</span> as the second superstar.',
            "element": ".create-feud-second-participant-select",
            "action": "select_second_feud_superstar"
        },
        {
            "text": "You can enter a custom name for your feud here. Enter anything you want e.g 'Betrayal'.",
            "element": "#create-feud-custom-name",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": "Click on this feud item to select it.",
            "element": ".feud-item-container:eq(1)",
            "action": "select_create_feud_item"
        },
        {
            "text": 'Now click <span class="tutorial-color">Create</span>.',
            "element": "#create-feud-button",
            "action": "create_feud"
        },
        {
            "text": "A potential feud was created that you can start in a match or segment.",
            "element": "",
            "action": null
        },
        {
            "text": "Okay, let's go back.",
            "element": "#back-to-view-feuds-button",
            "action": "click_view_feuds_menu_button"
        },
        {
            "text": "Select this feud to view its details.",
            "element": ".feud-history-item",
            "action": "select_feud_history_item"
        },
        {
            "text": "Here you can view this feud's history, records and staleness. Feuds that go on too long with lose hype.",
            "element": ".feud-history",
            "action": null,
            "scrollTo": "start"
        },
        {
            "text": "Click this feud to deselect it.",
            "element": ".feud-history-item",
            "action": "unselect_feud_history_item"
        }
    ],
    "view_indies": [
        {
            "text": 'If you want to grow your company, you\'ll probably need to sign new talent. Let\'s check out the indies. Click <span class="tutorial-color">Roster</span> and select <span class="tutorial-color">Indies</span>.',
            "element": "#manage-roster",
            "action": "click_view_indies_menu_button",
            "subElements": [
                "#view-indies-menu-button"
            ]
        },
        {
            "text": "This is the indies page. You can view and sign independent talent here.",
            "element": "#indie",
            "action": null
        },
        {
            "text": "These superstars are available to sign. You can recruit unavailable talent or wait for them to become available.",
            "element": ".available-indie",
            "action": null
        },
        {
            "text": "Click on this superstar to open their details.",
            "element": ".available-indie .roster-member",
            "action": "click_indie_roster_member"
        },
        {
            "text": "The level of detail that you can see depends on the level of your scout.",
            "element": "#roster-member-details",
            "action": null
        },
        {
            "text": 'You can click on <span class="tutorial-color">Negotiate</span> to make an offer to this talent. We don\'t really have the money for that right now .. ',
            "element": "#start-negotiation-button",
            "action": null,
            "disallowClick": true,
            "scrollTo": "start"
        },
        {
            "text": 'Anyway, let\'s take a look at how to sign a competitor\'s talent. Click <span class="tutorial-color">Roster</span> and select <span class="tutorial-color">View</span>.',
            "element": "#manage-roster",
            "action": "click_view_roster",
            "subElements": [
                "#view-roster-menu-button"
            ]
        },
        {
            "text": 'Select <span class="tutorial-color">Global Wrestling Enterprise</span>.',
            "element": ".select-company-for-view-roster",
            "action": "select_view_roster_company"
        },
        {
            "text": "Click on this superstar to open up their details.",
            "element": ".roster-member",
            "action": "click_roster_superstar"
        },
        {
            "text": 'You can click <span class="tutorial-color">Negotiate</span> to make an offer, though talent signed to a company are more expensive than independent talent.',
            "element": "#start-negotiation-button",
            "action": null,
            "disallowClick": true,
            "scrollTo": "start"
        }
    ],
    "view_staff_and_facilities": [
        {
            "text": 'Remember I mentioned your scout? They are part of your staff, available in <span class=\'gold\'>JoW Paid</span>. Click <span class="tutorial-color">Staff</span> and select <span class="tutorial-color">View</span>.',
            "element": "#manage-staff",
            "action": "click_view_company_staff_menu_button",
            "subElements": [
                "#view-company-staff-menu-button"
            ]
        },
        {
            "text": "This is the staff page. It shows your hired staff for each role and their skill progress. You can hover over the roles to view more details. You'll also see a briefing from each staff member in your messages.",
            "element": ".company-staff-container",
            "action": null
        },
        {
            "text": "Click on this staff member to view their details.",
            "element": ".company-staff-member",
            "action": "click_staff_member"
        },
        {
            "text": "These are your staff member's details.",
            "element": ".staff-member-details",
            "action": null
        },
        {
            "text": "Okay, let's go back.",
            "element": "#back-to-staff-view-button",
            "action": "click_back_to_staff_view_button"
        },
        {
            "text": 'You can click <span class="tutorial-color">Hire</span> to hire new staff members, though you can only have one staff member per role.',
            "element": '.company-staff-container .button:contains("Hire")',
            "action": null,
            "disallowClick": true
        },
        {
            "text": 'Let\'s take a look at your company\'s facilities. Click <span class="tutorial-color">Staff</span> and select <span class="tutorial-color">Facilities</span>.',
            "element": "#manage-staff",
            "action": "click_view_company_facilities_menu_button",
            "subElements": [
                "#view-company-facilities-menu-button"
            ]
        },
        {
            "text": "This is your company facilities page. It shows the level of your existing facilities and the requirements to upgrade them.",
            "element": ".company-facilities-container",
            "action": null
        }
    ],
    "add_gimmick_match": [
        {
            "text": 'Time to add some customization. Let\'s add a gimmick match. Click <span class="tutorial-color">Company</span> and select <span class="tutorial-color">Gimmick Matches</span>.',
            "element": "#manage-company",
            "action": "click_view_gimmick_matches_menu_button",
            "subElements": [
                "#view-gimmick-matches-menu-button"
            ]
        },
        {
            "text": "This is your gimmick matches page.",
            "element": "#view-gimmick-matches-container",
            "action": null
        },
        {
            "text": 'Click <span class="tutorial-color">Add</span> to add a gimmick match.',
            "element": "#add-gimmick-match-menu-button",
            "action": "click_add_gimmick_match_menu_button"
        },
        {
            "text": "You can customize your gimmick match, editing its name, match type, boost and consequence.",
            "element": "#add-gimmick-match",
            "action": null
        },
        {
            "text": "Enter a name for the gimmick match.",
            "element": ".add-gimmick-match-name",
            "action": null
        },
        {
            "text": 'You can set a consequence for your gimmick match, like the loser becoming unavailable or the winner getting a championship match contract. Select <span class="tutorial-color">Fixed Match Contract</span>.',
            "element": ".add-gimmick-match-consequence",
            "action": "select_gimmick_match_consequence"
        },
        {
            "text": "Fixed match contracts grant a title shot at a fixed event, while championship contracts grant a title shot that can be used anytime and can expire.",
            "element": ".add-gimmick-match-consequence",
            "action": null
        },
        {
            "text": "Add a name for this contract e.g 'Title Shot'.",
            "element": ".add-gimmick-match-match-contract-name",
            "action": null
        },
        {
            "text": 'Now click <span class="tutorial-color">Add</span>.',
            "element": "#add-gimmick-match-button",
            "action": "add_gimmick_match",
            "position": "bottom",
            "subElements": [
                ".add-gimmick-match-name",
                ".add-gimmick-match-match-contract-name"
            ]
        },
        {
            "text": "Good job! Your new gimmick match should be available while booking.",
            "element": null,
            "action": null
        }
    ],
    "other_features": [
        {
            "text": 'Under <span class="tutorial-color">Company</span> you can also write your own segments (<span class="tutorial-color">Segments</span> - <span class=\'gold\'>JoW Paid</span>), edit titles (<span class="tutorial-color">Titles</span>) and view company stats (<span class="tutorial-color">Stats</span>).',
            "element": "#manage-company",
            "action": null
        },
        {
            "text": 'Under <span class="tutorial-color">Roster</span> you also have the option to manage factions (<span class="tutorial-color">Factions</span>) and make trades with your competitors (<span class="tutorial-color">Trades</span>).',
            "element": "#manage-roster",
            "action": null
        },
        {
            "text": 'Under <span class="tutorial-color">Job</span> you can also see how well your competitors are doing (<span class="tutorial-color">Companies</span>) and see your activity as a booker (<span class="tutorial-color">Activity</span>).',
            "element": "#manage-job",
            "action": null
        },
        {
            "text": "There are a variety of other features to explore, like artifacts, which will be introduced after a month of playing. They allow you to perform special actions like bring back retired superstars.",
            "element": "#manage-other",
            "action": null
        },
        {
            "text": "You will also unlock Special Segments (<span class='gold'>JoW Paid</span>), which are unique segments with high bonuses, after four months.",
            "element": "#manage-other",
            "action": null
        },
        {
            "text": "There are many more features in JoW, like Tournaments, Random Events, Gimmicks, the Simulator and Stories. But I think you can discover them on your own.",
            "element": null,
            "action": null
        },
        {
            "text": 'Before I go, let me tell you one way to book an end to a feud. Click <span class="tutorial-color">Book</span>.',
            "element": "#book-menu-button",
            "action": "click_book_segment_button"
        }
    ],
    "book_feud_match": [
        {
            "text": 'Click <span class="tutorial-color">Singles</span>.',
            "element": "#book-singles-menu-button",
            "action": "click_book_singles_feud_button"
        },
        {
            "text": 'We\'re going to book the end to our top feud. Click on the <span class="tutorial-color">Better Wrestler</span> to select its participants for the match.',
            "element": ".feud-container",
            "action": "click_match_feud"
        },
        {
            "text": 'Now click <span class="tutorial-color">Book</span> to add this match.',
            "element": "#add-match-button",
            "action": "add_singles_match",
            "position": "bottom"
        }
    ],
    "add_feud_blowoff": [
        {
            "text": 'Click <span class="tutorial-color">Add Blowoff</span> to end this feud after this match. The winner could move onto bigger things, perhaps challenging the champion, Eddie Dust?',
            "element": ".add-blowoff-to-feud",
            "action": "add_feud_blowoff"
        },
        {
            "text": "You can also blowoff feuds using specific segments, or end them on the feuds page.",
            "element": "#matches",
            "action": null
        },
        {
            "text": "You've learned a lot and are already on your way towards becoming a master booker! If you have any questions, click <span class=\"tutorial-color\">Help</span> under <span class=\"tutorial-color\">About</span> in the main menu or ask on the <a href='https://discord.gg/tjwJb99' target='_blank'>Discord</a>.",
            "element": null,
            "action": null
        },
        {
            "text": "I am also contractually obliged to mention that <a href='/jow-paid-features' target='_blank'>JoW Paid</a> adds a number of cool features like the ratings war, sandbox mode and company staff. You can <a href='/free-trial' target='_blank'>try it</a> for free!",
            "element": null,
            "action": null
        },
        {
            "text": "I'm going to leave you to run the company yourself now. You can continue this game and make your own story for UAW or click <span class=\"tutorial-color\">Menu</span> to go back and choose a new game. I'll see you around.",
            "element": "#main-menu-button",
            "action": null
        }
    ]
};
const $dc24b73c5af961af$export$e5d4b0e25437ae78 = [
    "add_singles_match",
    "add_feud_to_match",
    "add_tag_match",
    "play_first_event",
    "simulate_match",
    "end_first_event",
    "view_messages",
    "book_feud_segment",
    "book_singles_segment",
    "view_superstar_details",
    "disband_team",
    "add_team",
    "add_vacant_title_match",
    "add_gimmick_to_match",
    "move_to_main_event",
    "play_second_event",
    "play_second_event_second_segment",
    "play_second_event_main_event",
    "end_second_event",
    "goals",
    "add_feud",
    "view_indies",
    "view_staff_and_facilities",
    "add_gimmick_match",
    "other_features",
    "book_feud_match",
    "add_feud_blowoff",
    "end_tutorial"
];

});





parcelRequire.register("5IqxM", function(module, exports) {

$parcel$export(module.exports, "gimmickCombinationsData", () => $4295a6dd6eee52e3$export$ab915de8a390a0e);
const $4295a6dd6eee52e3$export$ab915de8a390a0e = {
    "Abstainer": {
        "easy": [
            "Obnoxious",
            "Incorruptible",
            "Stoic",
            "Troublesome",
            "Solitary",
            "Arrogant"
        ],
        "hard": [
            "Weak"
        ]
    },
    "Amateur Wrestler": {
        "easy": [
            "Athletic",
            "Cocky",
            "Hardworking",
            "Intelligent",
            "Impressive"
        ],
        "hard": [
            "Anxious",
            "Distracted",
            "Extreme",
            "Humble",
            "Unstable"
        ]
    },
    "Big Shot": {
        "easy": [
            "Glamorous",
            "Charismatic",
            "Elegant",
            "Power-hungry",
            "Confident",
            "Selfish",
            "Arrogant"
        ],
        "hard": [
            "Ordinary",
            "Solitary",
            "Humble",
            "Naive"
        ]
    },
    "Biker": {
        "easy": [
            "Tough",
            "Badass",
            "Intense",
            "Troublesome",
            "Aggressive"
        ],
        "hard": [
            "Glamorous",
            "Cowardly",
            "Cultured",
            "Elegant"
        ]
    },
    "Body-builder": {
        "easy": [
            "Attractive",
            "Strong",
            "Confident",
            "Perfect",
            "Impressive"
        ],
        "hard": [
            "Miserable",
            "Cowardly",
            "Humble",
            "Weak"
        ]
    },
    "Brute": {
        "easy": [
            "Strong",
            "Tough",
            "Troublesome",
            "Malicious"
        ],
        "hard": [
            "Cultured",
            "Stoic",
            "Cute"
        ]
    },
    "Bully": {
        "easy": [
            "Frightening",
            "Dominating",
            "Troublesome",
            "Aggressive",
            "Cowardly",
            "Miserable",
            "Weak",
            "Selfish"
        ],
        "hard": [
            "Lovable",
            "Heroic",
            "Reserved"
        ]
    },
    "Cheerleader": {
        "easy": [
            "Charismatic",
            "Cute",
            "Attractive",
            "Enthusiastic",
            "Athletic",
            "Naive",
            "Distracted"
        ],
        "hard": [
            "Frightening",
            "Malicious",
            "Humble",
            "Solitary"
        ]
    },
    "Child": {
        "easy": [
            "Cute",
            "Ordinary",
            "Enthusiastic",
            "Lovable",
            "Trusting",
            "Fearless",
            "Naive"
        ],
        "hard": [
            "Attractive",
            "Badass",
            "Malicious",
            "Sleazy",
            "Extreme"
        ]
    },
    "Cowboy": {
        "easy": [
            "Tough",
            "Fun-loving",
            "Troublesome",
            "Familial",
            "Heroic",
            "Cultured",
            "Reserved"
        ],
        "hard": [
            "Glamorous",
            "Anxious",
            "Naive",
            "Trusting",
            "Intense"
        ]
    },
    "Cult Leader": {
        "easy": [
            "Frightening",
            "Bizarre",
            "Unstable",
            "Power-hungry",
            "Charismatic",
            "Extreme",
            "Fearless",
            "Wise"
        ],
        "hard": [
            "Glamorous",
            "Fun-loving",
            "Incorruptible",
            "Elegant",
            "Lovable",
            "Heroic",
            "Authoritarian"
        ]
    },
    "Occultist": {
        "easy": [
            "Bizarre",
            "Passionate",
            "Stoic",
            "Tranquilo",
            "Fearless",
            "Solitary",
            "Reserved"
        ],
        "hard": [
            "Distracted",
            "Glamorous",
            "Ordinary",
            "Fun-loving",
            "Lovable",
            "Elegant",
            "Intense"
        ]
    },
    "Degenerate": {
        "easy": [
            "Badass",
            "Fun-loving",
            "Troublesome",
            "Sleazy",
            "Obnoxious"
        ],
        "hard": [
            "Hardworking",
            "Cultured",
            "Humble",
            "Authoritarian"
        ]
    },
    "Demon": {
        "easy": [
            "Frightening",
            "Bizarre",
            "Fearless",
            "Intense",
            "Malicious",
            "Heroic",
            "Unstable"
        ],
        "hard": [
            "Glamorous",
            "Ordinary",
            "Incorruptible",
            "Fun-loving",
            "Elegant",
            "Cultured"
        ]
    },
    "Drug Lord": {
        "easy": [
            "Tranquilo",
            "Charismatic",
            "Badass",
            "Power-hungry",
            "Deceitful",
            "Familial",
            "Wise"
        ],
        "hard": [
            "Naive",
            "Trusting",
            "Weak",
            "Incorruptible",
            "Authoritarian"
        ]
    },
    "Druggie": {
        "easy": [
            "Fun-loving",
            "Miserable",
            "Anxious",
            "Selfish",
            "Unpredictable",
            "Distracted"
        ],
        "hard": [
            "Calculating",
            "Perfect",
            "Stoic",
            "Hardworking",
            "Elegant"
        ]
    },
    "Enigma": {
        "easy": [
            "Bizarre",
            "Intense",
            "Charismatic",
            "Unpredictable",
            "Solitary",
            "Tranquilo"
        ],
        "hard": [
            "Cultured",
            "Power-hungry",
            "Naive",
            "Elegant"
        ]
    },
    "Executive": {
        "easy": [
            "Power-hungry",
            "Confident",
            "Calculating",
            "Cultured",
            "Authoritarian",
            "Cowardly",
            "Selfish"
        ],
        "hard": [
            "Naive",
            "Distracted",
            "Unpredictable",
            "Heroic",
            "Bizarre"
        ]
    },
    // Empty
    "Fighter": {
        "easy": [],
        "hard": []
    },
    "Foreigner": {
        "easy": [
            "Aggressive",
            "Arrogant",
            "Cultured",
            "Strong",
            "Dominating",
            "Obnoxious"
        ],
        "hard": [
            "Hardworking",
            "Heroic",
            "Humble",
            "Lovable"
        ]
    },
    "Game Dev.": {
        "easy": [
            "Fun-loving",
            "Hardworking",
            "Lovable",
            "Anxious",
            "Passionate"
        ],
        "hard": [
            "Distracted",
            "Unpredictable",
            "Unstable"
        ]
    },
    "Giant": {
        "easy": [
            "Strong",
            "Frightening",
            "Aggressive",
            "Dominating",
            "Lovable"
        ],
        "hard": [
            "Ordinary",
            "Cowardly",
            "Anxious",
            "Weak"
        ]
    },
    "Jock": {
        "easy": [
            "Athletic",
            "Attractive",
            "Dominating",
            "Arrogant",
            "Confident",
            "Cocky",
            "Selfish"
        ],
        "hard": [
            "Wise",
            "Intelligent",
            "Badass",
            "Reserved",
            "Heroic"
        ]
    },
    "Kickboxer": {
        "easy": [
            "Athletic",
            "Tough",
            "Badass",
            "Intense",
            "Calculating"
        ],
        "hard": [
            "Weak",
            "Unstable",
            "Distracted",
            "Cowardly"
        ]
    },
    "Lunatic": {
        "easy": [
            "Unstable",
            "Unpredictable",
            "Aggressive",
            "Extreme",
            "Malicious",
            "Distracted"
        ],
        "hard": [
            "Elegant",
            "Wise",
            "Reserved",
            "Trusting"
        ]
    },
    "Martian": {
        "easy": [
            "Cute",
            "Bizarre",
            "Miserable",
            "Familial",
            "Extreme"
        ],
        "hard": [
            "Perfect",
            "Elegant",
            "Cowardly",
            "Power-hungry",
            "Dominating"
        ]
    },
    "Mobster": {
        "easy": [
            "Sleazy",
            "Tough",
            "Troublesome",
            "Deceitful",
            "Familial"
        ],
        "hard": [
            "Trusting",
            "Incorruptible",
            "Naive",
            "Solitary"
        ]
    },
    "Monster": {
        "easy": [
            "Frightening",
            "Aggressive",
            "Malicious",
            "Fearless",
            "Attractive",
            "Strong"
        ],
        "hard": [
            "Cultured",
            "Elegant",
            "Cowardly",
            "Cute",
            "Reserved"
        ]
    },
    "Movie Star": {
        "easy": [
            "Glamorous",
            "Attractive",
            "Cocky",
            "Obnoxious",
            "Charismatic"
        ],
        "hard": [
            "Extreme",
            "Authoritarian",
            "Reserved",
            "Frightening"
        ]
    },
    "Musician": {
        "easy": [
            "Passionate",
            "Arrogant",
            "Cocky",
            "Bizarre"
        ],
        "hard": [
            "Strong",
            "Reserved",
            "Humble"
        ]
    },
    "Mythical Being": {
        "easy": [
            "Bizarre",
            "Frightening",
            "Malicious",
            "Heroic",
            "Impressive"
        ],
        "hard": [
            "Weak",
            "Cultured",
            "Elegant",
            "Cowardly",
            "Ordinary"
        ]
    },
    "Opportunist": {
        "easy": [
            "Cowardly",
            "Malicious",
            "Sleazy",
            "Calculating",
            "Weak",
            "Selfish"
        ],
        "hard": [
            "Naive",
            "Distracted",
            "Hardworking",
            "Incorruptible",
            "Badass",
            "Dominating"
        ]
    },
    "Patriot": {
        "easy": [
            "Passionate",
            "Hardworking",
            "Incorruptible",
            "Lovable",
            "Heroic",
            "Fearless",
            "Authoritarian"
        ],
        "hard": [
            "Frightening",
            "Troublesome",
            "Cowardly",
            "Selfish",
            "Weak",
            "Obnoxious"
        ]
    },
    "Philosophist": {
        "easy": [
            "Wise",
            "Intelligent",
            "Obnoxious",
            "Cultured",
            "Stoic",
            "Authoritarian",
            "Tranquilo"
        ],
        "hard": [
            "Naive",
            "Sleazy",
            "Fun-loving",
            "Anxious"
        ]
    },
    "Pirate": {
        "easy": [
            "Lovable",
            "Badass",
            "Fun-loving",
            "Troublesome",
            "Deceitful"
        ],
        "hard": [
            "Naive",
            "Trusting",
            "Cultured",
            "Cowardly",
            "Anxious"
        ]
    },
    "Police Officer": {
        "easy": [
            "Tough",
            "Aggressive",
            "Fearless",
            "Incorruptible",
            "Authoritarian"
        ],
        "hard": [
            "Anxious",
            "Cowardly",
            "Naive",
            "Unpredictable",
            "Weak"
        ]
    },
    "Prize Fighter": {
        "easy": [
            "Tough",
            "Malicious",
            "Familial",
            "Calculating",
            "Selfish"
        ],
        "hard": [
            "Distracted",
            "Incorruptible",
            "Cute",
            "Anxious",
            "Cowardly"
        ]
    },
    "Punk": {
        "easy": [
            "Badass",
            "Troublesome",
            "Arrogant",
            "Obnoxious",
            "Selfish"
        ],
        "hard": [
            "Cultured",
            "Stoic",
            "Authoritarian"
        ]
    },
    "Rapper": {
        "easy": [
            "Obnoxious",
            "Flamboyant",
            "Badass",
            "Passionate",
            "Intense"
        ],
        "hard": [
            "Reserved",
            "Solitary"
        ]
    },
    "Rich Person": {
        "easy": [
            "Obnoxious",
            "Flamboyant",
            "Attractive",
            "Power-hungry",
            "Cultured",
            "Impressive",
            "Selfish",
            "Perfect"
        ],
        "hard": [
            "Incorruptible",
            "Extreme",
            "Anxious",
            "Bizarre"
        ]
    },
    "Rising Star": {
        "easy": [
            "Flamboyant",
            "Athletic",
            "Impressive",
            "Confident",
            "Cocky",
            "Hardworking",
            "Perfect"
        ],
        "hard": [
            "Humble",
            "Wise",
            "Ordinary",
            "Cowardly",
            "Fun-loving",
            "Miserable",
            "Reserved"
        ]
    },
    "Rockstar": {
        "easy": [
            "Intense",
            "Obnoxious",
            "Cocky",
            "Flamboyant",
            "Charismatic"
        ],
        "hard": [
            "Reserved",
            "Humble",
            "Ordinary",
            "Cultured"
        ]
    },
    "Royalty": {
        "easy": [
            "Power-hungry",
            "Reserved",
            "Impressive",
            "Elegant",
            "Authoritarian"
        ],
        "hard": [
            "Ordinary",
            "Solitary",
            "Naive",
            "Extreme",
            "Intense"
        ]
    },
    "Shoot Fighter": {
        "easy": [
            "Tough",
            "Strong",
            "Badass",
            "Aggressive",
            "Fearless",
            "Intense"
        ],
        "hard": [
            "Cowardly",
            "Anxious",
            "Reserved",
            "Distracted",
            "Weak"
        ]
    },
    "Sidekick": {
        "easy": [
            "Ordinary",
            "Passionate",
            "Cute",
            "Trusting",
            "Naive",
            "Heroic",
            "Humble",
            "Distracted",
            "Weak"
        ],
        "hard": [
            "Cowardly",
            "Strong",
            "Obnoxious",
            "Cocky",
            "Selfish"
        ]
    },
    "Singer": {
        "easy": [
            "Glamorous",
            "Attractive",
            "Enthusiastic",
            "Charismatic"
        ],
        "hard": [
            "Aggressive",
            "Frightening",
            "Unstable"
        ]
    },
    "Sports Star": {
        "easy": [
            "Athletic",
            "Strong",
            "Cocky",
            "Impressive",
            "Confident"
        ],
        "hard": [
            "Ordinary",
            "Cowardly",
            "Reserved",
            "Authoritarian",
            "Weak",
            "Humble"
        ]
    },
    "Spot Monkey": {
        "easy": [
            "Athletic",
            "Flamboyant",
            "Enthusiastic",
            "Cocky",
            "Fearless",
            "Extreme"
        ],
        "hard": [
            "Anxious",
            "Cowardly",
            "Humble",
            "Weak"
        ]
    },
    "Superhero": {
        "easy": [
            "Strong",
            "Tough",
            "Intelligent",
            "Fearless",
            "Incorruptible",
            "Heroic",
            "Humble",
            "Reserved",
            "Perfect"
        ],
        "hard": [
            "Cowardly",
            "Obnoxious",
            "Cocky",
            "Selfish",
            "Authoritarian",
            "Naive",
            "Weak"
        ]
    },
    // Empty
    "Superstar": {
        "easy": [],
        "hard": []
    },
    "Thug": {
        "easy": [
            "Badass",
            "Troublesome",
            "Aggressive",
            "Malicious",
            "Tough"
        ],
        "hard": [
            "Reserved",
            "Cowardly",
            "Perfect",
            "Fun-loving",
            "Incorruptible"
        ]
    },
    "Undead": {
        "easy": [
            "Frightening",
            "Bizarre",
            "Fearless",
            "Malicious",
            "Intense",
            "Solitary"
        ],
        "hard": [
            "Cute",
            "Glamorous",
            "Attractive",
            "Fun-loving",
            "Cowardly",
            "Weak"
        ]
    },
    "Underdog": {
        "easy": [
            "Fearless",
            "Ordinary",
            "Passionate",
            "Hardworking",
            "Lovable",
            "Humble",
            "Heroic"
        ],
        "hard": [
            "Cowardly",
            "Strong",
            "Obnoxious",
            "Power-hungry",
            "Cocky",
            "Weak",
            "Selfish",
            "Perfect"
        ]
    },
    "Vampire": {
        "easy": [
            "Frightening",
            "Attractive",
            "Intense",
            "Malicious"
        ],
        "hard": [
            "Authoritarian",
            "Ordinary",
            "Fun-loving",
            "Weak",
            "Cowardly"
        ]
    },
    "Veteran": {
        "easy": [
            "Humble",
            "Wise",
            "Badass",
            "Lovable",
            "Miserable",
            "Hardworking"
        ],
        "hard": [
            "Naive",
            "Anxious",
            "Ordinary",
            "Cowardly"
        ]
    },
    "VIP": {
        "easy": [
            "Glamorous",
            "Cocky",
            "Confident",
            "Obnoxious",
            "Sleazy",
            "Selfish"
        ],
        "hard": [
            "Ordinary",
            "Solitary",
            "Humble",
            "Naive",
            "Heroic"
        ]
    },
    "Voodoo": {
        "easy": [
            "Frightening",
            "Intense",
            "Malicious",
            "Bizarre",
            "Unpredictable"
        ],
        "hard": [
            "Elegant",
            "Cute",
            "Ordinary"
        ]
    },
    // Empty
    "Wrestler": {
        "easy": [],
        "hard": []
    }
};

});





parcelRequire.register("iWkAo", function(module, exports) {

$parcel$export(module.exports, "Relationship", () => $dc9d9cb904bac875$export$69a0e7946cf616df);
$parcel$export(module.exports, "getRelationshipCompany", () => $dc9d9cb904bac875$export$67d98d03496f7493);

var $14eBR = parcelRequire("14eBR");
function $dc9d9cb904bac875$export$69a0e7946cf616df() {
    // Boolean
    const interested = null;
    // String
    const type = null;
    // Foreign keys
    const superstarId = null;
    const companyId = null;
    return {
        interested: interested,
        type: type,
        superstarId: superstarId,
        companyId: companyId
    };
}
function $dc9d9cb904bac875$export$67d98d03496f7493(relationship) {
    return (0, $14eBR.Companies).find({
        "$loki": relationship.companyId
    })[0];
}
function $dc9d9cb904bac875$export$517bb014ef028ed6(relationship) {
    return (0, $14eBR.Superstars).find({
        "$loki": relationship.superstarId
    })[0];
}

});

parcelRequire.register("5DBvS", function(module, exports) {

$parcel$export(module.exports, "CompanyAlert", () => $41adb19bd892552f$export$a058b60f15e7a8a7);

var $14eBR = parcelRequire("14eBR");
function $41adb19bd892552f$export$a058b60f15e7a8a7() {
    // Strings
    const name = null;
    const description = null;
    const type = null;
    // Boolean
    const shown = false;
    // Foreign keys
    const companyId = null;
    return {
        name: name,
        description: description,
        type: type,
        shown: shown,
        companyId: companyId
    };
}
function $41adb19bd892552f$export$d6c553056c0b60ef(companyAlert) {
    return (0, $14eBR.Companies).find({
        "$loki": companyAlert.$loki
    })[0];
}

});

parcelRequire.register("cJeaP", function(module, exports) {

$parcel$export(module.exports, "getScenarioCompanyInformation", () => $9444ae96f95d00d2$export$e4ea0dca145e863e);

var $dBFC4 = parcelRequire("dBFC4");

var $9esFv = parcelRequire("9esFv");

var $dl5u4 = parcelRequire("dl5u4");

var $972Ip = parcelRequire("972Ip");

var $eSlDe = parcelRequire("eSlDe");

var $5ZsVo = parcelRequire("5ZsVo");

var $kZwpB = parcelRequire("kZwpB");

var $3E8Nt = parcelRequire("3E8Nt");

var $hBIDz = parcelRequire("hBIDz");
async function $9444ae96f95d00d2$export$35e71caeb05644ae(scenario) {
    // Used to create game from local scenario. Duplicates all objects, removing id keys. todo test might have to delete keys instead of using object destructuring
    let gameData = {
        "companies": []
    };
    const game = await (0, $eSlDe.getScenarioGame)(scenario);
    const { $loki: $loki, scenarioId: scenarioId, ...newGame } = game;
    gameData.gameDetails = newGame;
    const gameCompanies = await (0, $dBFC4.getGameCompanies)(game);
    for (const company of gameCompanies){
        let companyData = {
            "rosters": []
        };
        const { $loki: $loki, ...newCompany } = company;
        companyData.companyDetails = newCompany;
        let companyEvents = await (0, $9esFv.getCompanyEvents)(company);
        companyEvents = companyEvents.map(({ $loki: $loki, ...keepAttrs })=>keepAttrs);
        companyData.events = companyEvents;
        let companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
        // Add superstar uid
        for (const championship of companyChampionships){
            championship.superstarUid = championship.superstarId;
            delete championship.$loki;
        }
        companyData.championships = companyChampionships;
        const companyRosters = await (0, $9esFv.getCompanyRosters)(company);
        for (const roster of companyRosters){
            let rosterData = {};
            let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(roster);
            for (const superstar of rosterSuperstars){
                superstar.uid = superstar.$loki;
                delete superstar.$loki;
            }
            rosterData.superstars = rosterSuperstars;
            let rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(roster);
            // Add superstar uids
            for (const tagTeam of rosterTagTeams){
                const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                tagTeam.superstarUids = tagTeamSuperstars.map((x)=>x.$loki);
                delete tagTeam.$loki;
            }
            rosterData.tagTeams = rosterTagTeams;
            companyData.rosters.push(rosterData);
        }
        gameData.companies.push(companyData);
    }
    return gameData;
}
async function $9444ae96f95d00d2$export$e4ea0dca145e863e(company, competitor = false) {
    const data = {};
    const events = await (0, $9esFv.getCompanyEvents)(company);
    const topEvent = (0, $5ZsVo.getTopEvent)(events);
    data["companyName"] = company.name;
    data["reputation"] = $9444ae96f95d00d2$var$getCompanyReputationFromFans(company.fans);
    data["fans"] = company.fans;
    data["points"] = company.points;
    data["ownerName"] = company.ownerName;
    data["style"] = company.style;
    data["topEvent"] = {
        "name": topEvent.name,
        "prestige": topEvent.prestige
    };
    if (competitor) {
        data["rosters"] = [];
        let companyRosters = await (0, $9esFv.getCompanyRosters)(company);
        // List of rosters: main and training rosters
        const rosters = [
            [
                companyRosters.find((x)=>x.type === "main")
            ],
            companyRosters.filter((x)=>[
                    "training",
                    "trainingAvailable"
                ].includes(x.type))
        ];
        for (const x of rosters){
            const rosterInformation = await $9444ae96f95d00d2$var$getScenarioRosterInformation(x, competitor);
            data["rosters"].push(rosterInformation);
        }
        data["championships"] = await $9444ae96f95d00d2$var$getScenarioChampionshipsInformation(company);
    //data['brands'] = getScenarioBrandsInformation(company); todo
    }
    return data;
}
async function $9444ae96f95d00d2$var$getScenarioRosterInformation(rosters, competitor) {
    // Get number of superstars, tag teams, trios, retired and future superstars, top workers
    const data = {};
    const superstars = (await Promise.all(rosters.map((x)=>(0, $dl5u4.getRosterSuperstars)(x)))).flat();
    const allTagTeams = (await Promise.all(rosters.map((x)=>(0, $dl5u4.getRosterTagTeams)(x)))).flat();
    const tagTeams = allTagTeams.filter((x)=>!x.trio);
    const trios = allTagTeams.filter((x)=>x.trio);
    const factions = (await Promise.all(rosters.map((x)=>(0, $dl5u4.getRosterFactions)(x)))).flat();
    const managerIds = superstars.filter((x)=>x.managerId).map((x)=>x.managerId);
    const managers = superstars.filter((x)=>x.fullTimeManager || managerIds.includes(x.$loki));
    // Superstars
    const activeSuperstars = superstars.filter((x)=>!x.retired && !x.monthToAppearIn && !x.fullTimeManager);
    data["topSuperstars"] = getTopSuperstars(activeSuperstars);
    if (rosters[0].type === "main") {
        const retiredSuperstars = superstars.filter((x)=>x.retired);
        data["retiredSuperstars"] = getTopSuperstars(retiredSuperstars);
    } else {
        const futureSuperstars = superstars.filter((x)=>x.monthToAppearIn);
        data["futureSuperstars"] = getTopSuperstars(futureSuperstars);
    }
    // Stats (gimmicks, graphics, hot/over)
    data["numberOfSuperstars"] = superstars.length;
    data["numberOfSuperstarsWithGraphics"] = superstars.filter((x)=>x.graphic && typeof x.graphic === "object" && Object.keys(x.graphic).length !== 0 && !x.graphic["empty_graphic"]).length;
    data["numberOfSuperstarsWithTraits"] = superstars.filter((x)=>x.traits && x.traits.length).length;
    if (rosters[0].type === "main" && !competitor) {
        const rosterGimmicks = (await Promise.all(rosters.map((x)=>(0, $dl5u4.getRosterGimmicks)(x)))).flat();
        if (rosterGimmicks.length) data["numberOfSuperstarsWithGimmicks"] = superstars.filter((x)=>rosterGimmicks.find((y)=>y.superstarId === x.$loki)).length;
        else data["numberOfSuperstarsWithGimmicks"] = (await Promise.all(superstars.filter((x)=>(0, $hBIDz.getSuperstarCurrentGimmick)(x)))).flat().length;
        data["numberOfFaceSuperstars"] = superstars.filter((x)=>x.alignment === "face").length;
        data["numberOfHeelSuperstars"] = superstars.filter((x)=>x.alignment === "heel").length;
        data["numberOfOverSuperstars"] = superstars.filter((x)=>x.overness >= 80).length;
        data["numberOfStaleSuperstars"] = superstars.filter((x)=>x.overness < 20).length;
    }
    // Teams
    data["topTagTeam"] = await getTopTeams(tagTeams);
    data["topTrio"] = await getTopTeams(trios);
    data["numberOfTagTeams"] = tagTeams.length;
    data["numberOfTrios"] = trios.length;
    data["numberOfFactions"] = factions.length;
    data["numberOfManagers"] = managers.length;
    data["type"] = rosters[0].type;
    function getTopSuperstars(l) {
        const sortedSuperstars = l.sort((a, b)=>b.popularity - a.popularity);
        return sortedSuperstars.slice(0, 3).map((x)=>x.name);
    }
    async function getTopTeams(l) {
        let sortedTeams = [
            ...l
        ];
        for (const x of sortedTeams){
            let s = await (0, $972Ip.getTagTeamSuperstars)(x);
            if (s.length) x.tempPopularity = await (0, $3E8Nt.getRosterMemberPopularity)(x, s);
        }
        sortedTeams = sortedTeams.filter((x)=>x.tempPopularity !== undefined).sort((a, b)=>b.tempPopularity - a.tempPopularity);
        for (const x of sortedTeams)delete x.tempPopularity;
        return sortedTeams.length ? sortedTeams[0].name : null;
    }
    return data;
}
async function $9444ae96f95d00d2$var$getScenarioChampionshipsInformation(company) {
    // Get number of championships, graphics, top 2 championships' names
    const data = {};
    const championships = await (0, $kZwpB.getUniqueChampionships)((await (0, $9esFv.getCompanyChampionships)(company)).filter((x)=>!x.matchContract));
    const sortedChampionships = championships.sort((0, $kZwpB.compareChampionships));
    data["topChampionships"] = [];
    for (const x of sortedChampionships.slice(0, 2)){
        const holder = await (0, $kZwpB.getChampionshipHolder)(x);
        let championName = holder ? holder.name : null;
        data["topChampionships"].push({
            "name": x.name,
            "championName": championName
        });
    }
    data["numberOfChampionships"] = championships.length;
    data["numberOfChampionshipsWithGraphics"] = championships.filter((x)=>x.graphic && typeof x.graphic === "object" && Object.keys(x.graphic).length !== 0).length;
    return data;
}
function $9444ae96f95d00d2$var$getCompanyReputationFromFans(fans) {
    const fansData = [
        0,
        500,
        1100,
        2300,
        5000,
        10500,
        22000,
        47000,
        99000,
        212000,
        451000
    ];
    const reputation = fansData.find((x)=>fans < x) ?? 451000;
    return fansData.indexOf(reputation);
}

});

parcelRequire.register("fQoFZ", function(module, exports) {

$parcel$export(module.exports, "Facility", () => $b88eda8773dcedd4$export$a7fc9678230ff44);

var $14eBR = parcelRequire("14eBR");
function $b88eda8773dcedd4$export$a7fc9678230ff44() {
    // Integer
    const level = 1;
    const actionsCompleted = 0;
    // Strings
    const name = null;
    // Boolean
    const staffNeverHired = true;
    // Foreign keys
    const companyId = null;
    return {
        level: level,
        actionsCompleted: actionsCompleted,
        name: name,
        staffNeverHired: staffNeverHired,
        companyId: companyId
    };
}
function $b88eda8773dcedd4$export$82c96f5559c1e1b8(facility) {
    return (0, $14eBR.Companies).find({
        "$loki": facility.companyId
    })[0];
}

});

parcelRequire.register("66ItE", function(module, exports) {

$parcel$export(module.exports, "getViewRankingsData", () => $4725cddb21c4dc52$export$1754736963c55377);
$parcel$export(module.exports, "processYearlyRanking", () => $4725cddb21c4dc52$export$7c2ab664eda9e15e);
$parcel$export(module.exports, "getYearlyRankingData", () => $4725cddb21c4dc52$export$e7059e8a28533af0);
$parcel$export(module.exports, "getSuperstarRankingHighlight", () => $4725cddb21c4dc52$export$6a6671e2797c04f4);
$parcel$export(module.exports, "setupGetRankingDataForYear", () => $4725cddb21c4dc52$export$d0751016abfd0587);

var $3E8Nt = parcelRequire("3E8Nt");

var $14eBR = parcelRequire("14eBR");

var $iRMwH = parcelRequire("iRMwH");

var $jpMCP = parcelRequire("jpMCP");

var $98xmD = parcelRequire("98xmD");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $9esFv = parcelRequire("9esFv");

var $5kTkA = parcelRequire("5kTkA");

var $1JSre = parcelRequire("1JSre");

var $kZwpB = parcelRequire("kZwpB");

var $hekDR = parcelRequire("hekDR");

var $gImaj = parcelRequire("gImaj");

var $dBFC4 = parcelRequire("dBFC4");
async function $4725cddb21c4dc52$export$1754736963c55377(companyUid, period) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "not-paid";
        return data;
    }
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get talent and championships
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompany, "main");
    const talent = (await (0, $dl5u4.getRosterSuperstars)(mainRoster)).concat(await (0, $jpMCP.getRosterActiveTagTeams)(mainRoster));
    const championships = await (0, $9esFv.getCompanyChampionships)(selectedCompany);
    // Get ranking data
    data["rankingData"] = await $4725cddb21c4dc52$var$getWinLossRankingData(talent, championships, period);
    // Get brand names
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    data["brandNames"] = rosterBrands.map((x)=>x.name);
    return data;
}
async function $4725cddb21c4dc52$var$getWinLossRankingData(talent, championships, period) {
    let rankingData = [];
    // Get data for each talent
    for (const talentMember of talent){
        let d = {};
        let memberSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(talentMember);
        // Get name, pronoun, type
        d["name"] = talentMember.name;
        d["pronoun"] = memberSuperstars.every((x)=>x.pronoun === memberSuperstars[0].pronoun) ? memberSuperstars[0].pronoun : null;
        d["brandName"] = memberSuperstars.every((x)=>x.brandName === memberSuperstars[0].brandName) ? memberSuperstars[0].brandName : null;
        d["type"] = talentMember.objectName;
        // Get wins/losses based on period
        if (period === "current") {
            d["wins"] = talentMember.winsTemporary;
            d["losses"] = talentMember.lossesTemporary;
        } else if (period === "allTime") {
            d["wins"] = talentMember.wins;
            d["losses"] = talentMember.losses;
        }
        // Get championships
        let talentChampionships = [];
        if (talentMember.objectName === "superstar") {
            talentChampionships = championships.filter((x)=>x.superstarId === talentMember.$loki);
            d["championships"] = talentChampionships.map((x)=>(0, $1JSre.getChampionshipDisplayName)(x, true, false, false));
        } else {
            const uniqueTagTitles = (0, $kZwpB.getUniqueChampionships)(championships.filter((x)=>x.tagTeam || x.trio));
            for (const c of uniqueTagTitles){
                // Check if each title of the set is held by this team's members
                let tagChampionshipsSet = championships.filter((y)=>(0, $kZwpB.checkAreChampionshipsEqual)(y, c));
                const memberSuperstarsIds = memberSuperstars.map((x)=>x.$loki);
                if (tagChampionshipsSet.every((x)=>memberSuperstarsIds.indexOf(x.superstarId) >= 0)) talentChampionships.push(c);
            }
            d["championships"] = talentChampionships.map((x)=>(0, $1JSre.getChampionshipDisplayName)(x, true));
        }
        rankingData.push(d);
    }
    rankingData.sort($4725cddb21c4dc52$var$sortWinLossRanking);
    return rankingData;
}
function $4725cddb21c4dc52$var$sortWinLossRanking(a, b) {
    return (b["wins"] + b["losses"] > 0) - (a["wins"] + a["losses"] > 0) || (b["wins"] > 0) - (a["wins"] > 0) || b["wins"] - b["losses"] - (a["wins"] - a["losses"]) || b["wins"] - a["wins"];
}
async function $4725cddb21c4dc52$export$7c2ab664eda9e15e(game, mainCompany) {
    let data = {};
    let { superstars: superstars, championships: championships, tagTeams: tagTeams, indieRosters: indieRosters } = await $4725cddb21c4dc52$var$getRankingObjects(game);
    let updated = false;
    try {
        // Don't get yearly rankings if story or free user
        if (!mainCompany.storyName && (0, $98xmD.globalUser).paid) {
            // Load ranking if present
            let yearlyRanking = await $4725cddb21c4dc52$var$loadYearlyRanking(game, mainCompany.realYear - 1);
            // Get yearly ranking if not present and points added
            let pointsPresent = !superstars.every((x)=>x.kayfabePointsTemporary === 0);
            if (!yearlyRanking && pointsPresent) {
                // Get ranking for current year
                let rankingData = await $4725cddb21c4dc52$var$getRankingDataForYear(superstars, championships, indieRosters);
                // Store ranking
                yearlyRanking = await $4725cddb21c4dc52$var$storeYearlyRanking(rankingData, game, mainCompany);
                // Add boost to top superstar
                let topSuperstar = superstars.find((x)=>x.name === rankingData[0].name);
                if (topSuperstar) {
                    let popularityBoost = $4725cddb21c4dc52$var$addTopSuperstarPopularityBoost(topSuperstar);
                    // Add message if superstar belongs to user's company
                    let company = await (0, $3E8Nt.getTalentCompany)(topSuperstar);
                    if (company && company.userControlled) {
                        let newMessage = await (0, $hekDR.createTopSuperstarPopularityMessage)(topSuperstar, popularityBoost, company, game.monthCount, game.year);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                        // Add creative points boost and message
                        let creativePointsBoost = $4725cddb21c4dc52$var$addTopSuperstarCreativePointsBoost(company);
                        newMessage = await (0, $hekDR.createTopSuperstarPointsMessage)(topSuperstar, creativePointsBoost, company, game.monthCount, game.year);
                        await (0, $9esFv.addCompanyMessages)(company, [
                            newMessage
                        ]);
                    }
                }
                updated = true;
            }
            if (yearlyRanking) data = $4725cddb21c4dc52$export$e7059e8a28533af0(yearlyRanking, game);
        }
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    // Reset temporary attributes
    if (!game.yearlyAttributesResetRan) {
        $4725cddb21c4dc52$var$resetTalentTemporaryAttributes([
            ...superstars,
            ...tagTeams
        ]);
        game.yearlyAttributesResetRan = true;
        updated = true;
    }
    // Update database if changes made
    if (updated) (0, $14eBR.db).saveDatabase();
    return data;
}
function $4725cddb21c4dc52$export$e7059e8a28533af0(yearlyRanking, game) {
    let data = {};
    const gameRandom = new Math.seedrandom(game.meta.created);
    data["rankingData"] = yearlyRanking.data;
    data["year"] = yearlyRanking.year;
    data["editor"] = (0, $3E8Nt.generateName)((0, $3E8Nt.getRandomChoice)([
        "male",
        "female"
    ], gameRandom()), gameRandom());
    return data;
}
function $4725cddb21c4dc52$export$6a6671e2797c04f4(superstar, championships) {
    let highlights = [];
    let superstarChampionships = championships.filter((x)=>x.superstarId === superstar.$loki);
    if (superstarChampionships.length) highlights.push(...superstarChampionships.map((x)=>(0, $1JSre.getChampionshipDisplayName)(x, true, false, false)));
    let totalMatches = superstar.winsTemporary + superstar.lossesTemporary;
    let winPercentage = totalMatches > 0 ? Math.round(superstar.winsTemporary / totalMatches * 100) : null;
    if (winPercentage >= 80) highlights.push(`${winPercentage}% Match Wins`);
    return highlights.length ? highlights[0] : null;
}
async function $4725cddb21c4dc52$var$storeYearlyRanking(rankingData, game, mainCompany) {
    let yearlyRanking = (0, $gImaj.YearlyRanking)();
    (0, $14eBR.YearlyRankings).insert(yearlyRanking);
    yearlyRanking.data = rankingData;
    yearlyRanking.year = mainCompany.realYear - 1;
    await (0, $dBFC4.addGameYearlyRankings)(game, [
        yearlyRanking
    ]);
    return yearlyRanking;
}
async function $4725cddb21c4dc52$var$loadYearlyRanking(game, year) {
    return (await (0, $dBFC4.getGameYearlyRankings)(game)).find((x)=>x.year === year);
}
async function $4725cddb21c4dc52$var$getRankingDataForYear() {
    return;
}
function $4725cddb21c4dc52$export$d0751016abfd0587(newFunction) {
    $4725cddb21c4dc52$var$getRankingDataForYear = newFunction;
}
function $4725cddb21c4dc52$var$resetTalentTemporaryAttributes(talentArray) {
    // Reset temporary wins, losses and kayfabe points
    for (let talent of talentArray){
        if (talent.objectName === "superstar") talent.kayfabePointsTemporary = 0;
        talent.winsTemporary = 0;
        talent.lossesTemporary = 0;
    }
    return true;
}
async function $4725cddb21c4dc52$var$getRankingObjects(game) {
    // Get superstars and championships
    let companies = await (0, $iRMwH.getGameActiveCompanies)(game);
    let superstars = [];
    let championships = [];
    let tagTeams = [];
    let indieRosters = [];
    for (let company of companies){
        championships.push(...await (0, $9esFv.getCompanyChampionships)(company));
        // Get superstars and teams
        let rosters = (await (0, $9esFv.getCompanyRosters)(company)).filter((x)=>[
                "main",
                "training",
                "trainingAvailable",
                "indie",
                "indieAvailable"
            ].includes(x.type));
        for (const roster of rosters){
            superstars.push(...await (0, $dl5u4.getRosterSuperstars)(roster));
            tagTeams.push(...await (0, $dl5u4.getRosterTagTeams)(roster));
            if ([
                "indie",
                "indieAvailable"
            ].includes(roster.type)) indieRosters.push(roster);
        }
    }
    return {
        superstars: superstars,
        championships: championships,
        tagTeams: tagTeams,
        indieRosters: indieRosters
    };
}
function $4725cddb21c4dc52$var$addTopSuperstarPopularityBoost(superstar) {
    let boost = (0, $3E8Nt.getRandomInt)(40, 60);
    boost = (0, $5kTkA.updateSuperstarPopularity)(superstar, boost);
    return boost;
}
function $4725cddb21c4dc52$var$addTopSuperstarCreativePointsBoost(company) {
    let boost = (0, $3E8Nt.myround)((0, $3E8Nt.getRandomInt)(200, 300), 10);
    company.points += boost;
    return boost;
}

});
parcelRequire.register("gImaj", function(module, exports) {

$parcel$export(module.exports, "YearlyRanking", () => $c2b1f300304085a5$export$ae57298b67f35439);

var $14eBR = parcelRequire("14eBR");
function $c2b1f300304085a5$export$ae57298b67f35439() {
    // Integer
    const year = null;
    // Objects
    const data = {};
    // Foreign keys
    const gameId = null;
    return {
        year: year,
        data: data,
        gameId: gameId
    };
}
function $c2b1f300304085a5$export$659d5aae13c75a2(yearlyRanking) {
    return (0, $14eBR.Games).find({
        "$loki": yearlyRanking.gameId
    })[0];
}

});





parcelRequire.register("fPpxU", function(module, exports) {

$parcel$export(module.exports, "getDashboardData", () => $b85f6f5166ac8237$export$80b97040cbf2e3b5);

var $3E8Nt = parcelRequire("3E8Nt");

var $8A6FL = parcelRequire("8A6FL");

var $5kTkA = parcelRequire("5kTkA");

var $98xmD = parcelRequire("98xmD");

var $iRMwH = parcelRequire("iRMwH");

var $9esFv = parcelRequire("9esFv");

var $csISS = parcelRequire("csISS");

var $1olyO = parcelRequire("1olyO");
async function $b85f6f5166ac8237$export$80b97040cbf2e3b5(userCompany = null, game = null) {
    // Get current game and company
    if (!game) game = await (0, $3E8Nt.getCurrentGame)();
    if (!userCompany) userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    // Define data structure
    let data = {
        "alerts": {
            "unhappy": [],
            "notUnhappy": [],
            "leftCompany": [],
            "injured": [],
            "injuryRecovered": [],
            "workableInjuryRecovered": [],
            "superstarRetired": [],
            "staffMemberRetired": [],
            "leavingCompany": [],
            "notLeavingCompany": [],
            "randomEvent": [],
            "facilityUpgradeAvailable": [],
            "buyoutAvailable": [],
            "companyFormed": [],
            "companyFolded": [],
            "talentOfferAccepted": [],
            "talentOfferRejected": [],
            "goalCompleted": [],
            "goalFailed": [],
            "talentRequestCompleted": [],
            "talentRequestFailed": []
        },
        "upcomingMatters": [],
        "unavailable": {
            "kayfabeInjured": [],
            "suspended": [],
            "notAvailableStaff": [],
            "notAvailable": [],
            "noAppearances": []
        },
        "injured": [],
        "tasksProgress": [],
        "talentRequests": []
    };
    const mainRosterSuperstars = await (0, $8A6FL.getCompanyMainRosterSuperstars)(userCompany);
    const nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const companyAlerts = await (0, $9esFv.getCompanyCompanyAlerts)(userCompany);
    const staffMembers = (await (0, $9esFv.getCompanyStaff)(userCompany)).filter((x)=>!x.retired);
    let gameMonth = game.monthCount === 0 ? 12 : game.monthCount;
    let companyMonth = (0, $8A6FL.getCompanyMonth)(userCompany, game) === 0 ? 12 : (0, $8A6FL.getCompanyMonth)(userCompany, game);
    // Get company alerts by type
    for(const alertType in data.alerts)if (data.alerts.hasOwnProperty(alertType)) {
        const companyAlertsOfType = companyAlerts.filter((x)=>x.type === alertType);
        data.alerts[alertType] = companyAlertsOfType.map((x)=>x.name);
    }
    // Check for available callup
    if ([
        0,
        6
    ].includes((0, $8A6FL.getCompanyMonth)(userCompany, game)) && !userCompany.trainingCallupRun) data["alerts"]["availableCallup"] = [
        "Callup"
    ];
    // Get events
    let companyEvents = [
        {
            "name": "Yearly Negotiations",
            "months": [
                12
            ]
        },
        {
            "name": "Available Callup",
            "months": [
                12,
                6
            ]
        }
    ];
    let gameEvents = [];
    if (game.competitorsPresent) gameEvents.push({
        "name": "Year-End Awards",
        "months": [
            10
        ]
    });
    if (![
        "mars",
        "passion"
    ].includes(userCompany.storyName)) {
        companyEvents.push({
            "name": "Goals Review",
            "months": [
                12
            ]
        });
        if ((0, $98xmD.globalUser).paid && game.settings["run_annual_tournament"] !== false) gameEvents.push({
            "name": "The Grand Invitational",
            "months": [
                5
            ]
        });
    }
    // Check if any events are upcoming
    for (const event of gameEvents)for (const month of event["months"]){
        let monthsRemaining = month - gameMonth;
        if (3 > monthsRemaining && monthsRemaining > 0) data["upcomingMatters"].push({
            "event": event["name"],
            "monthsRemaining": monthsRemaining
        });
    }
    for (const event of companyEvents)for (const month of event["months"]){
        let monthsRemaining = month - companyMonth;
        if (3 > monthsRemaining && monthsRemaining > 0) data["upcomingMatters"].push({
            "event": event["name"],
            "monthsRemaining": monthsRemaining
        });
    }
    // Check for yearly rankings and yearly draft
    if ((0, $98xmD.globalUser).paid && ![
        "mars",
        "passion"
    ].includes(userCompany.storyName)) {
        // Yearly rankings
        let currentMonth = await (0, $8A6FL.getCurrentMonth)(userCompany);
        if ([
            10,
            11
        ].includes(currentMonth)) data["upcomingMatters"].push({
            "event": "Top 50 Rankings",
            "monthsRemaining": 12 - currentMonth
        });
        // Yearly draft
        let draftSettings = userCompany.settings["yearly_brand_draft_settings"];
        if (draftSettings && draftSettings.run && draftSettings.month) {
            let draftMonth = Number.parseInt(draftSettings.month);
            let monthsRemaining = (0, $3E8Nt.getMonthsIndexDifference)(draftMonth, currentMonth);
            // Show upcoming draft if at monthly event before draft
            if (3 > monthsRemaining && monthsRemaining > 0 || monthsRemaining === 0 && !nextEvent.weeklyShow) data["upcomingMatters"].push({
                "event": "Yearly Draft",
                "monthsRemaining": monthsRemaining
            });
        }
    }
    // Check for leaving superstars
    for (const s of mainRosterSuperstars)if (s.contractMonthsRemaining !== null && 4 > s.contractMonthsRemaining && s.contractMonthsRemaining > 0) data["upcomingMatters"].push({
        "event": `${s.name} is leaving the company`,
        "monthsRemaining": s.contractMonthsRemaining
    });
    // Staff tasks progress
    for (const staffMember of staffMembers)if (staffMember.currentTask) data["tasksProgress"].push({
        "staffMember": staffMember.name,
        "task": staffMember.currentTask,
        "monthsRemaining": staffMember.monthsLeftForTask
    });
    // Talent Offers sent and accepted (finalizing)
    const acceptedOffers = (await (0, $9esFv.getCompanySentNegotiations)(userCompany)).filter((x)=>x.status === "accepted_by_talent");
    const acceptedOffersTalent = await Promise.all(acceptedOffers.map((x)=>{
        return (0, $csISS.getNegotiationTalent)(x);
    }));
    if (acceptedOffersTalent.length > 0) {
        const talentManager = (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "talent_manager");
        const talentManagerName = talentManager ? talentManager.name : "Staff";
        const offerWord = acceptedOffersTalent.length === 1 ? "deal" : "deals";
        const acceptedOffersTalentNames = (0, $3E8Nt.commaSeparate)(acceptedOffersTalent.map((x)=>x.name));
        data["tasksProgress"].push({
            "staffMember": talentManagerName,
            "task": `Finalizing ${offerWord} for ${acceptedOffersTalentNames}`,
            "monthsRemaining": 1
        });
    }
    // Check roster unavailability and injuries
    const doctor = (0, $8A6FL.getHighestLevelStaffMemberByRole)(staffMembers, "doctor");
    for (const s of mainRosterSuperstars){
        // Injured
        if (s.injured > 0) {
            let returnTime = (0, $5kTkA.getInjuryReturnTime)(s, doctor);
            let monthsWord = returnTime === "1" ? "month" : "months";
            // Add real injuries to 'injured' section
            if (s.injuryName) {
                // Show injury name if present
                let injuryName;
                if (![
                    "minor injury",
                    "major injury"
                ].includes(s.injuryName)) injuryName = (0, $3E8Nt.toTitleCase)(s.injuryName);
                else injuryName = "Injury";
                // Add 'Workable' text for workable injury
                if (s.workableInjury) injuryName = "Workable " + injuryName;
                data["injured"].push({
                    "name": s.name,
                    "months": s.injuryReturnMin,
                    "value": `${injuryName}: ${returnTime} ${monthsWord}`
                });
            } else data["unavailable"]["kayfabeInjured"].push({
                "name": s.name,
                "months": s.injuryReturnMin,
                "value": `Kayfabe: ${returnTime} ${monthsWord}`
            });
        } else if (s.suspensionMonths > 0) {
            let monthsWord = s.suspensionMonths === 1 ? "month" : "months";
            data["unavailable"]["suspended"].push({
                "name": s.name,
                "months": s.suspensionMonths,
                "value": `Suspended: ${s.suspensionMonths} ${monthsWord}`
            });
        } else if (s.unavailable) data["unavailable"]["notAvailable"].push(s.name);
        else if (s.partTimer && s.appearances === 0 && !s.fullTimeManager) data["unavailable"]["noAppearances"].push(s.name);
    }
    // Check staff unavailability
    for (const staffMember of staffMembers)if (staffMember.unavailableMonths > 0) {
        const monthsWord = staffMember.unavailableMonths === 1 ? "month" : "months";
        data["unavailable"]["notAvailableStaff"].push({
            "name": `${staffMember.name} (${(0, $3E8Nt.toTitleCase)(staffMember.role.replace("_", " "))})`,
            "months": staffMember.unavailableMonths,
            "value": `Not Available: ${staffMember.unavailableMonths} ${monthsWord}`
        });
    }
    // Get talent requests
    data["talentRequests"] = await (0, $1olyO.getCompanyTalentRequestsData)(userCompany);
    return data;
}

});

parcelRequire.register("iY7cj", function(module, exports) {

$parcel$export(module.exports, "TradeOffer", () => $dcf369e5f1f912a7$export$fb83a1acff28c4a9);
$parcel$export(module.exports, "getTradeOfferSenderCompany", () => $dcf369e5f1f912a7$export$93aab2454185b101);
$parcel$export(module.exports, "getTradeOfferReceiverCompany", () => $dcf369e5f1f912a7$export$73f8cab540b0ad7c);
$parcel$export(module.exports, "addTradeOfferOfferedSuperstars", () => $dcf369e5f1f912a7$export$50f38dd09a67498b);
$parcel$export(module.exports, "removeTradeOfferOfferedSuperstars", () => $dcf369e5f1f912a7$export$63eaf5086f08301);
$parcel$export(module.exports, "getTradeOfferOfferedSuperstars", () => $dcf369e5f1f912a7$export$104c1cf04780f869);
$parcel$export(module.exports, "addTradeOfferRequestedSuperstars", () => $dcf369e5f1f912a7$export$cb8d9d0b477124);
$parcel$export(module.exports, "removeTradeOfferRequestedSuperstars", () => $dcf369e5f1f912a7$export$9b08574b9df1d16a);
$parcel$export(module.exports, "getTradeOfferRequestedSuperstars", () => $dcf369e5f1f912a7$export$fff549c44996b263);

var $14eBR = parcelRequire("14eBR");
function $dcf369e5f1f912a7$export$fb83a1acff28c4a9() {
    // Integer
    const duration = null;
    // Foreign keys
    const senderCompanyId = null;
    const receiverCompanyId = null;
    return {
        duration: duration,
        senderCompanyId: senderCompanyId,
        receiverCompanyId: receiverCompanyId
    };
}
function $dcf369e5f1f912a7$export$93aab2454185b101(tradeOffer) {
    return (0, $14eBR.Companies).find({
        "$loki": tradeOffer.senderCompanyId
    })[0];
}
function $dcf369e5f1f912a7$export$73f8cab540b0ad7c(tradeOffer) {
    return (0, $14eBR.Companies).find({
        "$loki": tradeOffer.receiverCompanyId
    })[0];
}
function $dcf369e5f1f912a7$export$50f38dd09a67498b(tradeOffer, superstars) {
    superstars.forEach((c)=>{
        c.offeredTradeOfferId = tradeOffer.$loki;
    });
}
function $dcf369e5f1f912a7$export$63eaf5086f08301(tradeOffer, superstars) {
    superstars.forEach((c)=>{
        c.offeredTradeOfferId = null;
    });
}
function $dcf369e5f1f912a7$export$104c1cf04780f869(tradeOffer) {
    return (0, $14eBR.Superstars).find({
        "offeredTradeOfferId": tradeOffer.$loki
    });
}
function $dcf369e5f1f912a7$export$cb8d9d0b477124(tradeOffer, superstars) {
    superstars.forEach((c)=>{
        c.requestedTradeOfferId = tradeOffer.$loki;
    });
}
function $dcf369e5f1f912a7$export$9b08574b9df1d16a(tradeOffer, superstars) {
    superstars.forEach((c)=>{
        c.requestedTradeOfferId = null;
    });
}
function $dcf369e5f1f912a7$export$fff549c44996b263(tradeOffer) {
    return (0, $14eBR.Superstars).find({
        "requestedTradeOfferId": tradeOffer.$loki
    });
}

});

parcelRequire.register("aynj3", function(module, exports) {

$parcel$export(module.exports, "getTradeAvailableSuperstars", () => $7aef2884f3e931f4$export$71de2bae30cc9afb);
$parcel$export(module.exports, "makeTradeOffer", () => $7aef2884f3e931f4$export$fe5c256bb9992964);
$parcel$export(module.exports, "getTradeOfferData", () => $7aef2884f3e931f4$export$77446c22fda417af);
$parcel$export(module.exports, "replyToTradeOfferRequest", () => $7aef2884f3e931f4$export$572d59245a163cfd);

var $3E8Nt = parcelRequire("3E8Nt");

var $14eBR = parcelRequire("14eBR");

var $iRMwH = parcelRequire("iRMwH");

var $8A6FL = parcelRequire("8A6FL");

var $9esFv = parcelRequire("9esFv");

var $iY7cj = parcelRequire("iY7cj");

var $5kTkA = parcelRequire("5kTkA");

var $hekDR = parcelRequire("hekDR");

var $4K85d = parcelRequire("4K85d");

var $dl5u4 = parcelRequire("dl5u4");

var $hBIDz = parcelRequire("hBIDz");

var $cXLSF = parcelRequire("cXLSF");

var $972Ip = parcelRequire("972Ip");

var $ko5kE = parcelRequire("ko5kE");

var $kZMqI = parcelRequire("kZMqI");

var $6RCLU = parcelRequire("6RCLU");

var $jC7EP = parcelRequire("jC7EP");
async function $7aef2884f3e931f4$export$71de2bae30cc9afb(companyUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get selected company
    let selectedCompany;
    if (companyUid) selectedCompany = await (0, $14eBR.Companies).get(companyUid);
    else selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get superstars, sort
    const mainRosterSuperstars = await (0, $8A6FL.getCompanyMainRosterSuperstars)(selectedCompany);
    const sortedSuperstarsByPopularity = [
        ...mainRosterSuperstars
    ].sort((a, b)=>b.popularity - a.popularity);
    // Get championships' superstar ids, including stolen title champions
    let championshipsSuperstarsIds = (await (0, $9esFv.getCompanyChampionships)(selectedCompany)).map((x)=>x.superstarId);
    let championshipStolenSuperstarsIds = (await (0, $9esFv.getCompanyRandomEvents)(selectedCompany)).filter((x)=>x.name === "championshipStolen" && x.monthsRemaining > 0).map((y)=>y.superstarId);
    championshipsSuperstarsIds.push(...championshipStolenSuperstarsIds);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(selectedCompany);
    const bookedSuperstars = await (0, $6RCLU.getSuperstarsBookedAtEventMatches)(latestEvent);
    data["availableSuperstars"] = sortedSuperstarsByPopularity.map((x)=>{
        return {
            "name": x.name,
            "popularity": x.popularity,
            "uid": x.$loki,
            "retired": x.retired,
            "booked": (0, $3E8Nt.objectInArray)(x, bookedSuperstars),
            "contractMonthsRemaining": x.contractMonthsRemaining,
            "fullTimeManager": x.fullTimeManager,
            "appearances": x.partTimer && !x.retired ? x.appearances : null,
            "injured": x.injured > 0 ? x.injured : null,
            "onTradeDeal": x.activeEffect === "traded",
            "isChampion": championshipsSuperstarsIds.indexOf(x.$loki) >= 0,
            "partOfTradeOffer": !!(x.offeredTradeOfferId || x.requestedTradeOfferId),
            "isOwner": x.name === selectedCompany.ownerName,
            "powStar": selectedCompany.storyName === "passion" && [
                "Lady Julia",
                "Violet",
                "Natasha Ali",
                "Zora"
            ].indexOf(x.name) >= 0
        };
    });
    return data;
}
async function $7aef2884f3e931f4$export$fe5c256bb9992964(offeredSuperstarsUids, requestedSuperstarsUids, duration, companyUid) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const cost = 100;
    // Get competitor
    let competitor = await (0, $14eBR.Companies).get(companyUid);
    if (!competitor) {
        data["error"] = "competitor-not-found";
        return data;
    }
    // Check points
    if (selectedCompany.points < cost) {
        data["error"] = "not-enough-points";
        return data;
    }
    // Check mars story
    if (selectedCompany.storyName === "mars") {
        data["error"] = "mars";
        return data;
    }
    // Get superstars, remove empty values
    let offeredSuperstars = await Promise.all(offeredSuperstarsUids.map((x)=>(0, $14eBR.Superstars).get(x)));
    let requestedSuperstars = await Promise.all(requestedSuperstarsUids.map((x)=>(0, $14eBR.Superstars).get(x)));
    offeredSuperstars = offeredSuperstars.filter((x)=>x);
    requestedSuperstars = requestedSuperstars.filter((x)=>x);
    // Check if superstars present
    if (offeredSuperstars.length <= 0 || requestedSuperstars.length <= 0) {
        data["error"] = "superstars-not-found";
        return data;
    }
    // Create trade offer
    const tradeOffer = await $7aef2884f3e931f4$var$createTradeOffer(selectedCompany, competitor, offeredSuperstars, requestedSuperstars, duration);
    // Process trade offer reply if not sent to user controlled company
    if (!competitor.userControlled) await $7aef2884f3e931f4$var$processCpuReplyToTradeOffer(tradeOffer);
    // Remove points
    selectedCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = selectedCompany.points;
    data["competitorName"] = competitor.name;
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(selectedCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}
async function $7aef2884f3e931f4$var$createTradeOffer(senderCompany, receiverCompany, offeredSuperstars, requestedSuperstars, duration = null) {
    const tradeOffer = (0, $iY7cj.TradeOffer)();
    if (duration) tradeOffer.duration = duration;
    await (0, $14eBR.TradeOffers).insert(tradeOffer);
    // Add trade offer superstars and companies
    await (0, $iY7cj.addTradeOfferOfferedSuperstars)(tradeOffer, offeredSuperstars);
    await (0, $iY7cj.addTradeOfferRequestedSuperstars)(tradeOffer, requestedSuperstars);
    await (0, $9esFv.addCompanySentTradeOffers)(senderCompany, [
        tradeOffer
    ]);
    await (0, $9esFv.addCompanyReceivedTradeOffers)(receiverCompany, [
        tradeOffer
    ]);
    return tradeOffer;
}
async function $7aef2884f3e931f4$var$processCpuReplyToTradeOffer(tradeOffer) {
    const acceptChance = await $7aef2884f3e931f4$var$getTradeOfferAcceptChance(tradeOffer);
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= acceptChance) await $7aef2884f3e931f4$var$acceptTradeOffer(tradeOffer);
    else await $7aef2884f3e931f4$var$declineTradeOffer(tradeOffer);
}
async function $7aef2884f3e931f4$var$getTradeOfferAcceptChance(tradeOffer) {
    const offeredSuperstars = await (0, $iY7cj.getTradeOfferOfferedSuperstars)(tradeOffer);
    const requestedSuperstars = await (0, $iY7cj.getTradeOfferRequestedSuperstars)(tradeOffer);
    const offeredSuperstarsPoints = $7aef2884f3e931f4$var$getTradeOfferSuperstarsPoints(offeredSuperstars);
    const requestedSuperstarsPoints = $7aef2884f3e931f4$var$getTradeOfferSuperstarsPoints(requestedSuperstars);
    const pointsDifference = offeredSuperstarsPoints - requestedSuperstarsPoints;
    let acceptChance;
    if (pointsDifference >= 100) acceptChance = 100;
    else if (pointsDifference >= -50) acceptChance = 80;
    else if (pointsDifference >= -100) acceptChance = 40;
    else acceptChance = -1;
    return acceptChance;
}
function $7aef2884f3e931f4$var$getTradeOfferSuperstarsPoints(superstars) {
    let points = 0;
    for (const x of superstars){
        let p = 0;
        p += x.popularity;
        if ((0, $5kTkA.getRankFromPopularity)(x.popularity) === "Main Eventer" || x.faceOfTheCompany || x.hot) p += 200;
        if (x.stale || x.retired || x.partTimer || x.injured > 0 || x.fullTimeManager) p -= 200;
        if (x.partTimer && x.appearances <= 0 || x.retired) p /= 2;
        points += p;
    }
    points /= superstars.length;
    points += points * 0.125 * (superstars.length - 1);
    return points;
}
async function $7aef2884f3e931f4$var$acceptTradeOffer(tradeOffer) {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(currentGame);
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const senderCompany = await (0, $iY7cj.getTradeOfferSenderCompany)(tradeOffer);
    const senderCompanyMainRoster = await (0, $8A6FL.getCompanyRosterByType)(senderCompany, "main");
    const receiverCompany = await (0, $iY7cj.getTradeOfferReceiverCompany)(tradeOffer);
    const receiverCompanyMainRoster = await (0, $8A6FL.getCompanyRosterByType)(receiverCompany, "main");
    const offeredSuperstars = await (0, $iY7cj.getTradeOfferOfferedSuperstars)(tradeOffer);
    const requestedSuperstars = await (0, $iY7cj.getTradeOfferRequestedSuperstars)(tradeOffer);
    const tradeOfferSuperstars = offeredSuperstars.concat(requestedSuperstars);
    const requestedSuperstarsNames = (0, $3E8Nt.commaSeparate)(requestedSuperstars.map((x)=>x.name));
    const offeredSuperstarsNames = (0, $3E8Nt.commaSeparate)(offeredSuperstars.map((x)=>x.name));
    const offeredMovedTeams = [];
    const requestedMovedTeams = [];
    // Transfer superstars
    for (const x of tradeOfferSuperstars){
        // Get roster to transfer to
        let superstarRoster;
        let rosterToSendTo;
        if ((0, $3E8Nt.objectInArray)(x, offeredSuperstars)) {
            superstarRoster = senderCompanyMainRoster;
            rosterToSendTo = receiverCompanyMainRoster;
        } else {
            superstarRoster = receiverCompanyMainRoster;
            rosterToSendTo = senderCompanyMainRoster;
        }
        // Transfer to new roster
        await (0, $dl5u4.addRosterSuperstars)(rosterToSendTo, [
            x
        ]);
        // Move teams if all members present in trade offer
        const superstarTagTeams = (await (0, $hBIDz.getSuperstarTagTeams)(x)).filter((y)=>!y.temporary);
        for (const tagTeam of superstarTagTeams){
            const tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
            if (tagTeamSuperstars.every((y)=>(0, $3E8Nt.objectInArray)(y, tradeOfferSuperstars))) {
                await (0, $dl5u4.addRosterTagTeams)(rosterToSendTo, [
                    tagTeam
                ]);
                if ((0, $3E8Nt.objectInArray)(x, offeredSuperstars) && !(0, $3E8Nt.objectInArray)(tagTeam, offeredMovedTeams)) offeredMovedTeams.push(tagTeam);
                if ((0, $3E8Nt.objectInArray)(x, requestedSuperstars) && !(0, $3E8Nt.objectInArray)(tagTeam, requestedMovedTeams)) requestedMovedTeams.push(tagTeam);
            } else await (0, $ko5kE.removeTagTeam)(tagTeam);
        }
        // Add temp trade attributes
        if (tradeOffer.duration) {
            x.activeEffect = "traded";
            x.appearances = tradeOffer.duration;
            // Add original roster
            await (0, $dl5u4.addRosterOriginalSuperstars)(superstarRoster, [
                x
            ]);
        } else {
            // End feuds
            for (const feud of (await (0, $hBIDz.getSuperstarFeuds)(x)))if (!feud.ended) await (0, $cXLSF.endFeud)(feud, currentGame.monthCount, currentGame.year);
            // Make superstar happy
            (0, $5kTkA.changeSuperstarMoraleToHappy)(x);
            // Delete talent requests
            for (const talentRequest of (await (0, $hBIDz.getSuperstarTalentRequests)(x)))await (0, $14eBR.TalentRequests).remove(talentRequest);
            // Delete all relationships, add former company relationship
            for (const relationship of (await (0, $hBIDz.getSuperstarRelationships)(x)))await (0, $14eBR.Relationships).remove(relationship);
            if ((0, $3E8Nt.objectInArray)(x, offeredSuperstars)) await (0, $8A6FL.addFormerCompanyRelationship)(x, senderCompany);
            else await (0, $8A6FL.addFormerCompanyRelationship)(x, receiverCompany);
            // Process POW stars leaving
            if (userCompany.storyName === "passion") await (0, $jC7EP.processPowSuperstarLeavesCompany)(x, userCompany);
        }
        // Remove superstar from factions and managers
        await (0, $5kTkA.removeSuperstarFactionRelationships)(x, currentGame.monthCount, currentGame.year);
        await (0, $5kTkA.removeSuperstarManagerRelationships)(x);
        // Reset attributes
        x.brandName = null;
        x.faceOfTheCompanyCounter = 0;
        x.suspensionMonths = 0;
    }
    // Add message from receiver company to sender company
    if (senderCompany.userControlled) {
        const subject = "Trade accepted";
        let durationText = "";
        if (tradeOffer.duration) {
            let monthsWord = tradeOffer.duration === 1 ? "month" : "months";
            durationText = ` for the next ${tradeOffer.duration} ${monthsWord}`;
        }
        const content = `<p>We have accepted your offer to trade ${requestedSuperstarsNames}` + ` for ${offeredSuperstarsNames}. We hope you take good care of our ` + `talent${durationText} and we'll do the same with yours.</p>`;
        const messageFrom = (0, $8A6FL.getCompanyOwnerName)(receiverCompany);
        const newMessage = await (0, $hekDR.createMessage)(subject, messageFrom, currentGame.monthCount, currentGame.year, content);
        await (0, $9esFv.addCompanyMessages)(senderCompany, [
            newMessage
        ]);
    }
    // Add message from talent manager of receiver company
    if (receiverCompany.userControlled) {
        const subject = "Trade deal";
        let durationText = "";
        let verb = offeredSuperstars.length === 1 ? "has" : "have";
        if (tradeOffer.duration) {
            let monthsWord = tradeOffer.duration === 1 ? "month" : "months";
            durationText = ` for the next ${tradeOffer.duration} ${monthsWord}`;
        }
        const content = `<p>The deal to trade ${requestedSuperstarsNames} for ${offeredSuperstarsNames}${durationText} ` + `was accepted. ${offeredSuperstarsNames} ${verb} joined our roster.</p>`;
        const talentManager = (0, $8A6FL.getRandomStaffMemberByRole)(await (0, $9esFv.getCompanyStaff)(receiverCompany), "talent_manager");
        const messageFrom = talentManager ? talentManager.name : "Staff";
        const newMessage = await (0, $hekDR.createMessage)(subject, messageFrom, currentGame.monthCount, currentGame.year, content);
        await (0, $9esFv.addCompanyMessages)(receiverCompany, [
            newMessage
        ]);
    }
    // Add company log to both companies
    for (const company of [
        senderCompany,
        receiverCompany
    ]){
        const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, userCompany.realYear);
        await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
        newCompanyLog.text = `${offeredSuperstarsNames} for ${requestedSuperstarsNames}`;
        newCompanyLog.value = tradeOffer.duration;
        newCompanyLog.type = "trade-deal";
        newCompanyLog.realYear = currentGame.year;
        await (0, $9esFv.addCompanyCompanyLogs)(company, [
            newCompanyLog
        ]);
    }
    // Add new trade superstar logs for superstars and teams moved
    for (const x of tradeOfferSuperstars.concat(offeredMovedTeams, requestedMovedTeams)){
        const newCompanyLog = (0, $4K85d.CompanyLog)(currentGame.monthCount, userCompany.realYear);
        await (0, $14eBR.CompanyLogs).insert(newCompanyLog);
        newCompanyLog.text = x.name;
        newCompanyLog.type = "new-trade-superstar";
        newCompanyLog.realYear = currentGame.year;
        if ((0, $3E8Nt.objectInArray)(x, offeredSuperstars) || (0, $3E8Nt.objectInArray)(x, offeredMovedTeams)) await (0, $9esFv.addCompanyCompanyLogs)(receiverCompany, [
            newCompanyLog
        ]);
        if ((0, $3E8Nt.objectInArray)(x, requestedSuperstars) || (0, $3E8Nt.objectInArray)(x, requestedMovedTeams)) await (0, $9esFv.addCompanyCompanyLogs)(senderCompany, [
            newCompanyLog
        ]);
    }
    // Add news
    let newsItem = await (0, $kZMqI.generateNewsItem)({
        company: senderCompany,
        month: currentGame.monthCount,
        year: currentGame.year,
        competitor: receiverCompany,
        newsType: "trade_deal"
    });
    await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
        newsItem
    ]);
    // Delete trade offer
    await (0, $iY7cj.removeTradeOfferRequestedSuperstars)(tradeOffer, requestedSuperstars);
    await (0, $iY7cj.removeTradeOfferOfferedSuperstars)(tradeOffer, offeredSuperstars);
    await (0, $14eBR.TradeOffers).remove(tradeOffer);
}
async function $7aef2884f3e931f4$var$declineTradeOffer(tradeOffer) {
    const senderCompany = await (0, $iY7cj.getTradeOfferSenderCompany)(tradeOffer);
    const offeredSuperstars = await (0, $iY7cj.getTradeOfferOfferedSuperstars)(tradeOffer);
    const requestedSuperstars = await (0, $iY7cj.getTradeOfferRequestedSuperstars)(tradeOffer);
    // Add message from receiver company to sender company
    if (senderCompany.userControlled) {
        const receiverCompany = await (0, $iY7cj.getTradeOfferReceiverCompany)(tradeOffer);
        const currentGame = await (0, $3E8Nt.getCurrentGame)();
        const subject = "Trade declined";
        const content = `<p>We have rejected your offer to trade ${(0, $3E8Nt.commaSeparate)(requestedSuperstars.map((x)=>x.name))}` + ` for ${(0, $3E8Nt.commaSeparate)(offeredSuperstars.map((x)=>x.name))}. We don't think it will benefit us right now.</p>`;
        const messageFrom = (0, $8A6FL.getCompanyOwnerName)(receiverCompany);
        const newMessage = await (0, $hekDR.createMessage)(subject, messageFrom, currentGame.monthCount, currentGame.year, content);
        await (0, $9esFv.addCompanyMessages)(senderCompany, [
            newMessage
        ]);
    }
    // Delete trade offer
    await (0, $iY7cj.removeTradeOfferRequestedSuperstars)(tradeOffer, requestedSuperstars);
    await (0, $iY7cj.removeTradeOfferOfferedSuperstars)(tradeOffer, offeredSuperstars);
    await (0, $14eBR.TradeOffers).remove(tradeOffer);
}
async function $7aef2884f3e931f4$export$77446c22fda417af(tradeOffer) {
    let data = {};
    const senderCompany = await (0, $iY7cj.getTradeOfferSenderCompany)(tradeOffer);
    const receiverCompany = await (0, $iY7cj.getTradeOfferReceiverCompany)(tradeOffer);
    const offeredSuperstars = await (0, $iY7cj.getTradeOfferOfferedSuperstars)(tradeOffer);
    const requestedSuperstars = await (0, $iY7cj.getTradeOfferRequestedSuperstars)(tradeOffer);
    data["offeredSuperstars"] = offeredSuperstars.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    data["requestedSuperstars"] = requestedSuperstars.map((x)=>{
        return {
            "name": x.name,
            "uid": x.$loki
        };
    });
    data["senderCompany"] = senderCompany.name;
    data["receiverCompany"] = receiverCompany.name;
    data["duration"] = tradeOffer.duration;
    data["uid"] = tradeOffer.$loki;
    return data;
}
async function $7aef2884f3e931f4$export$572d59245a163cfd({ tradeOfferUid: tradeOfferUid, selectedChoice: selectedChoice } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const selectedCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    // Get trade offer
    const tradeOffer = (await (0, $9esFv.getCompanyReceivedTradeOffers)(selectedCompany)).find((x)=>x.$loki === tradeOfferUid);
    if (!tradeOffer) {
        data["error"] = "trade-offer-not-found";
        return data;
    }
    if (selectedChoice === "accept") await $7aef2884f3e931f4$var$acceptTradeOffer(tradeOffer);
    else await $7aef2884f3e931f4$var$declineTradeOffer(tradeOffer);
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    const unreadMessages = await (0, $8A6FL.getCompanyUnreadMessages)(selectedCompany);
    data["unreadMessages"] = unreadMessages.length;
    return data;
}

});


parcelRequire.register("1JkT6", function(module, exports) {

$parcel$export(module.exports, "specialSegmentCelebritiesData", () => $142a324ea0eb2145$export$1288e02109d0d9ca);
$parcel$export(module.exports, "segmentsData", () => $142a324ea0eb2145$export$8807716155157f84);
$parcel$export(module.exports, "segmentItemsOrder", () => $142a324ea0eb2145$export$74ce561d86f9af31);
const $142a324ea0eb2145$export$1288e02109d0d9ca = [
    {
        "name": "American Queen",
        "possessivePronoun": "her"
    },
    {
        "name": "Prezz",
        "possessivePronoun": "him"
    },
    {
        "name": "Big T",
        "possessivePronoun": "him"
    }
];
let $142a324ea0eb2145$export$8807716155157f84 = {
    "Feud Package": {
        "start": "A video package airs about the feud between {0} and {4} ...",
        "action": "It focused on {0}",
        "choices": [
            "a training montage of {0} and {4} as they prepare to face each other.",
            "a recalling of the history between {0} and {4}.",
            "a recap of the backstage encounters between {0} and {4}.",
            "in-ring highlights of the previous encounters between {0} and {4}.",
            "highlights of their rivalry with an awesome music track.",
            "interviews by those close to {0} and {4} about their rivalry.",
            "interviews given by {0} and {4} about each other."
        ]
    },
    "Promo Battle": {
        "start": "{0} are in the ring with mics in hand ...",
        "action": "{0}",
        "choices": [
            "The conversation got personal, as they lined insult after insult at each other's families.",
            "They embarrassed each other about their worst in-ring losses.",
            "They sarcastically glorified each other's failures.",
            "They roasted each other's gear and looks.",
            "They took shots at each other's gimmicks.",
            "They slammed each other's lack of charisma.",
            "They guaranteed to expose the worst of each other.",
            "They criticized each other's ability to wrestle.",
            "They exposed each other's weaknesses to the fans.",
            "They belittled each other's accomplishments."
        ]
    },
    "Fight": {
        "start": "A camera crew is live with a fight between {0} ...",
        "action": "They went through an intense brawl {0}",
        "choices": [
            "at a popular local bar.",
            "backstage, fighting each other around the whole locker room.",
            "inside the arena's parking lot.",
            "in the streets outside the arena.",
            "at the nearby dance club.",
            "at the beach.",
            "at the local minigolf.",
            "inside the backstage boiler room.",
            "in the VIP catering section.",
            "outside the arena with a bunch of cheering fans.",
            "inside the owner's office.",
            "at a nearby bed & breakfast.",
            "at the nearby hotel's lobby.",
            "drunk in a dark alley.",
            "by the merch store.",
            "inside a grocery store.",
            "outside the local graveyard."
        ]
    },
    "Heat Promo": {
        "start": "{0} is in the ring for a promo ...",
        "startTag": "{0} are in the ring for a promo ...",
        "action": "{0}",
        "choices": [
            "{0} ran down the local sports team and made fun of their recent loss.",
            "{0} talked about being better than every person in the crowd.",
            "{0} demeaned the city and promised to never return to it.",
            "{0} degraded the people sitting in the crowd.",
            "{0} vented about being ashamed to perform in this city.",
            "{0} talked about how the people in the crowd will never amount to anything.",
            "{0} insulted the people in the crowd and called them losers."
        ]
    },
    "Spirited Promo": {
        "start": "{0} is in the ring for a promo ...",
        "startTag": "{0} are in the ring for a promo ...",
        "action": "{0}",
        "choices": [
            "{0} talked about {2} love for wrestling and promised to keep doing it as long as possible.",
            "{0} thanked the fans for coming out and for their support.",
            "{0} told the fans that they are the reason for {1} wrestling.",
            "{0} promised to go all-out in {2} next match.",
            "{0} spoke about {2} last injury and how the thought of coming out here brought {1} back.",
            "{0} talked about never wanting to do anything but this since childhood.",
            "{0} spoke about being happy to return to this city again."
        ]
    },
    "Midget Impersonation": {
        "start": "",
        "action": "{0} came to the ring and called {4} to come out ... A little person emerged from the back, dressed exactly like {4}. After some cruel jokes, {0} threw the little person out of the ring.",
        "actionTag": "{0} came to the ring and called {4} to come out ... Little people emerged from the back, dressed exactly like {4}. After some cruel jokes, {0} threw the little people out of the ring."
    },
    "Kidnapping": {
        "start": "A scheduled match is on hold because someone's missing ... ",
        "action": "People backstage say they saw some masked people force {4} into a car and abduct {5}! Could it be {0}?"
    },
    "Local Squash": {
        "start": "{0} is in the ring, calling out anyone for a match ...",
        "startTag": "{0} are in the ring, calling out anyone for a match ...",
        "action": "A local superstar, {4}, answered the challenge. {0} made short work of it, squashing the competitor in a quick match!",
        "actionTag": "Some local superstars, {4}, answered the challenge. {0} made short work of it, squashing the competitors in a quick match!"
    },
    "Talk Show": {
        "start": "{0} is in the ring for {2} talk show, inviting {8} and {4} as guests ... ",
        "startTag": "{0} are in the ring for {2} talk show, inviting {8} and {4} as guests ... ",
        "action": "{8} and {4} exchange some words before starting a brawl, with {0} unable to stop them!"
    },
    "Home Invasion": {
        "start": "A live camera crew is stationed outside what appears to be someone's house ... ",
        "action": "That's {4}'s house, and {0} is breaking in! The two end up brawling in front of {6} family!",
        "actionTag": "That's {4}'s house, and {0} are breaking in! The two end up brawling in front of {6} family!"
    },
    "Car Destruction": {
        "start": "The camera crew is in the parking lot ... ",
        "action": "{0} appeared, standing in front of {4}'s car, before destroying it with a baseball bat!"
    },
    "Masked Attacker": {
        "start": "",
        "action": "{4} walked down the ramp for a scheduled match when a masked person attacked {5} from behind! Could it be {0}?",
        "actionTag": "{4} walked down the ramp for a scheduled match when masked people attacked {5} from behind! Could it be {0}?"
    },
    "Promo Ambush": {
        "start": "",
        "action": "{4} started a promo in the ring when {0} appeared from behind to ambush {5}! What a cheap attack."
    },
    "Slander Competitor": {
        "start": "{0} is in the ring with a microphone, talking about a competitor ... ",
        "startTag": "{0} are in the ring with microphones, talking about a competitor ... ",
        "action": "{0}",
        "choices": [
            "{0} trashed their ratings.",
            "{0} told the fans how bad their last event was.",
            "{0} parodied their top wrestlers.",
            "{0} made fun of their booking.",
            "{0} ridiculed their owner's recent decisions.",
            "{0} mocked their in-ring product."
        ]
    },
    "Spooky Trick": {
        "start": "We're getting some flickering lights backstage ... ",
        "action": "A camera showed {4} wandering backstage when the hallway lights went out and a shadow appeared in front of {5}! Turns out it was only {0} with a scary antic."
    },
    "Slime Surprise": {
        "start": "A big veiled box is set up in the ring ... ",
        "action": "{0} invited {4} into the ring, promising a special gift to thank {5}. The box turned out to be empty, and a load of slime poured onto {4}!"
    },
    "Smack Talk": {
        "start": "{0} and {4} are both in the ring to talk ...",
        "action": "They trade insults and verbal blows, with {0} landing some serious digs at {4}."
    },
    "Singing Contest": {
        "start": "We have some musical equipment set up in the ring ...",
        "action": "{0} challenged {4} to a singing contest! They both sang along with the instruments. Seems like the crowd liked {0}'s performance more."
    },
    "Push-up Contest": {
        "start": "{0} and {4} are out here trying to see who is stronger, so they challenge each other to a push-up contest!",
        "action": "After {4} performed dozens of reps easily, {0} refused to participate and instead threw out the exhausted {4}!"
    },
    "Debut": {
        "start": "We're awaiting the debut of a new superstar ...",
        "action": "It's {0}! {0} is here! The fans are on their feet as they cheer {1} on!",
        "startTag": "We're awaiting the debut of a new team ...",
        "actionTag": "It's {0}! {0} are here! The fans are on their feet as they cheer {1} on!"
    },
    "Cash-In Tease": {
        "start": "The champion {4} is heading backstage after a tough match ...",
        "action": "{0}'s music hits! The champion retreats as {0} teases a cash-in, only to promise to do it at another time.",
        "startTag": "The champions {4} are heading backstage after a tough match ...",
        "actionTag": "{0}'s music hits! The champions retreat as {0} tease a cash-in, only to promise to do it another time."
    },
    "Anger Management": {
        "participants": {
            "2": {
                "start": "{0} and {4} are sitting outside a therapist's office ...",
                "action": "The therapist makes them talk it out, and after sharing grievances and anger, they all go for an awkward hug."
            },
            "3": {
                "start": "{0}, {4} and {8} are sitting outside a therapist's office ...",
                "action": "The therapist makes them talk it out, and after sharing grievances and anger, they all go for an awkward hug."
            }
        }
    },
    "Backstage BBQ": {
        "start": "Some smoke is coming out of a room backstage ...",
        "action": "{0} is hosting a backstage barbeque for the locker room! When a staff member cites fire safety and asks {1} to end it, {0} kicks him in the face.",
        "actionTag": "{0} are hosting a backstage barbeque for the locker room! When a staff member cites fire safety and asks {1} to end it, {0} kick him in the face."
    },
    "Contract Signing": {
        "start": "{0} and {4} are sitting across a table in the ring, with a contract between them ...",
        "action": "They both sign the contract and go for a handshake, but {0} strikes {4} before putting {5} through the table!",
        "actionTag": "They both sign the contract and go for a handshake, but {0} strike {4} before putting {5} through the table!"
    },
    "Exposing the Past": {
        "start": "",
        "action": "{0} is in the ring, promising to expose {4}. Footage plays on the titantron showing some vile moments from {4}'s past!"
    },
    "Title Disrespect": {
        "start": "A camera crew is live somewhere outside the arena with {0} ...",
        "action": "{0} has {4}'s title in {2} hands and asks {5} to come get it, but ends up throwing it in a lake behind {1}!",
        "actionTag": "{0} have {4}'s titles in {2} hands and ask {5} to come get it, but end up throwing them in a lake behind {1}!"
    },
    "Demand Title Shot": {
        "start": "{0} is coming out to the ring to talk about who to face next ...",
        "action": "{0} calls out {4} and demands a title match! {4} answers and holds {6} title up.",
        "actionTag": "{0} call out {4} and demand a title match! {4} answer and hold {6} titles up."
    },
    "Champion Coronation": {
        "start": "The ring is decorated for a celebration as {0} is coming out alongside the owner of the company ...",
        "action": "{0} is presented with the title and wears it with pride as the owner applauds {2} title victory!",
        "startTag": "The ring is decorated for a celebration as {0} are coming out alongside the owner of the company ...",
        "actionTag": "{0} are presented with the titles and wear them with pride as the owner applauds {2} title victory!"
    },
    "Epic Brawl": {
        "start": "{0} is calling out {4} to come to the ring and face {1} ...",
        "action": "The two go at each other with full force! The locker room comes out to separate them but they continue to pummel each other!",
        "startTag": "{0} are calling out {4} to come to the ring and face {1} ...",
        "actionTag": "The two go at each other with full force! The locker room comes out to separate them but they continue to pummel each other!"
    },
    "Team Tension": {
        "participants": {
            "2": {
                "start": "{0} and {4} are coming to the ring to discuss their recent string of bad performances ...",
                "action": "Both members end up blaming each other for their losses as tensions rise between them."
            },
            "3": {
                "start": "{0}, {4} and {8} are coming to the ring to discuss their recent string of bad performances ...",
                "action": "All three members end up blaming each other for their losses as tensions rise between them."
            }
        }
    },
    "Unlikely Partners": {
        "start": "{0} and {4} are fighting against each other here as the owner comes out to stop them ...",
        "action": "The owner makes them partners in a tag match! They almost have the match won when {4} turns on {0} and they end up losing the match.",
        "actionTag": "The owner makes them partners in a tag match! They almost have the match won when {4} turn on {0} and they end up losing the match."
    },
    "Legend's Praise": {
        "start": "{0} and {4} are out here in the ring when {8}'s music hits!",
        "action": "{8} shakes everyone's hands, then gives {10} personal opinion that {0} is better than {4} and can't be beaten.",
        "actionTag": "{8} shake everyone's hands, then give {10} personal opinion that {0} are better than {4} and can't be beaten."
    },
    "This Belongs To You": {
        "start": "The owner of the company is here with the title and calls out {0} ...",
        "startTag": "The owner of the company is out with the titles and calls out {0} ...",
        "action": "The owner praises {1} and asserts {2} right to be champion. {0} is awarded the title!",
        "actionTag": "The owner praises {1} and asserts {2} right to be champions. {0} are awarded the titles!"
    },
    "You're Fired": {
        "start": "The owner of the company is out here in a serious mood and calls out {0} ...",
        "action": "The owner tears into {0}, builds it up, then fires {1}! {0} can't believe it."
    },
    "Lost My Smile": {
        "start": "{0} comes to the ring looking dispirited and stands in the middle with downcast eyes ...",
        "action": "{0} states {2} unhappiness with {2} current position in life and doesn't feel like being the champion anymore. {0} vacates {2} title!",
        "actionTag": "{0} state {2} unhappiness with {2} current position in life and don't feel like being the champions anymore. {0} vacate {2} titles!"
    },
    "Title Destruction": {
        "start": "The champion, {0}, is in the ring holding {2} title up high ...",
        "action": "{0} looks deeply at the title before throwing it behind {1} and then beating it to pieces with a steel chair!",
        "startTag": "The champions, {0}, are in the ring holding {2} titles up high ...",
        "actionTag": "{0} look deeply at the titles before throwing them behind {1} and then beating them to pieces with steel chairs!"
    },
    "Mutual Respect": {
        "start": "{0} calls out {4} to address their feud ...",
        "action": "The two of them tease a fight before going for a handshake of respect."
    },
    "Moving On": {
        "start": "",
        "action": "{0} talks about moving on from {2} feud with {4} towards bigger things. What could they be?"
    },
    "Vicious Beatdown": {
        "start": "{0} and {4} are out in the ring for a promo ...",
        "action": "Before {4} can even talk, {0} launches an attack on {5}! {0} mercilessly beats down {4} all around the ring. All people are asking is 'Why?'.",
        "startTag": "{0} and {4} are out in the ring for a promo ...",
        "actionTag": "Before {4} can even talk, {0} launch an attack on {5}! {0} mercilessly beat down {4} all around the ring. All people are asking is 'Why?'."
    },
    "Backstab": {
        "participants": {
            "2": {
                "start": "{0} and {4} are out in the ring, calling out their previous opponent ...",
                "action": "{0} grabs a chair and hits {4} in the back! What is going on?! {0} hits {2} finisher on {4} and then walks out of the ring with a look of disgust on {2} face."
            },
            "3": {
                "start": "{0}, {4} and {8} are out in the ring, calling out their previous opponent ...",
                "action": "{0} grabs a chair and hits {4} in the back! {8} looks on in shock and {0} beats {9} down too! {0} walks out of the ring with a look of disgust on {2} face."
            }
        }
    },
    "Beatdown Save": {
        "start": "{8} is beating down {4} in the ring. This isn't looking good for {4} as {8} continues to thrash {5} ...",
        "action": "It's {0}! {0} comes out to the ring and strikes down {8}, throwing {9} out of the ring! {4} and {0} embrace!",
        "startTag": "{8} are beating down {4} in the ring. This isn't looking good for {4} as {8} continue to thrash {5} ...",
        "actionTag": "It's {0}! {0} come out to the ring and strike down {8}, throwing {9} out of the ring! {4} and {0} embrace!"
    },
    "Forgiveness": {
        "start": "{0} calls out {4} to address their feud ...",
        "startTag": "{0} call out {4} to address their feud ...",
        "action": "{4} is cautious but {0} has had enough and asks for {6} forgiveness. {4} nods and then raises {0}'s hand! The crowd cheers!",
        "actionTag": "{4} are cautious but {0} have had enough and ask for {6} forgiveness. {4} look at each other, nod and then raise {0}'s hands! The crowd cheers!"
    },
    "Defying a Villain": {
        "participants": {
            "2": {
                "start": "{0} and {4} are out in the ring talking about how good they are ...",
                "action": "{0} confronts {4} about all the things they've done and refuses to take any more of {4}. {0} then hits {4} with {2} finisher!"
            },
            "3": {
                "start": "{0}, {4} and {8} are out in the ring talking about how good they are ...",
                "action": "{0} confronts {4} and {8} about all the things they've done and refuses to take any more of them. {0} hits {4} and then {8} with {2} finisher!"
            }
        }
    },
    "Delayed Vengeance": {
        "start": "{0} and {4} are out in the ring, teaming up for a tag match ...",
        "action": "Before their opponents can come out, {0} hits {4} from behind! {0} screams at {4} about never forgetting what {4} did to {1} and continues to beat {5} down!",
        "startTag": "{0} and {4} are out in the ring, teaming up for a match ...",
        "actionTag": "Before their opponents can come out, {0} hit {4} from behind! {0} scream at {4} about never forgetting what {4} did to {1} and continue to beat {5} down!"
    },
    "Joining the Devil": {
        "start": "{4} is laying a beating on {8}. Someone needs to come help {9} ...",
        "action": "{0} comes out to the ring. Finally! Wait, what's this?! {0} joins {4} as the two of them beat {8} helpless and then shake hands!",
        "startTag": "{4} are laying a beating on {8}. Someone needs to come help {9} ...",
        "actionTag": "{0} come out to the ring. Finally! Wait, what's this?! {0} join {4} as both of them beat {8} helpless and then shake hands!"
    },
    "Neutralize": {
        "start": "{0} is out in the ring with a mic in hand ...",
        "action": "{0} says some uncharacteristic things. The fans are unsure whether to cheer or boo {1}.",
        "startTag": "{0} are out in the ring with mics in hand ...",
        "actionTag": "{0} say some uncharacteristic things. The fans are unsure whether to cheer or boo {1}."
    },
    "Villainize": {
        "start": "{0} is out in the ring with a mic in hand ...",
        "action": "{0} berates the crowd and feels the fans owe {1} more respect. The fans start to turn on {1}.",
        "startTag": "{0} are out in the ring with mics in hand ...",
        "actionTag": "{0} berates the crowd and feel the fans owe {1} more respect. The fans start to turn on {1}."
    },
    "Build Honor": {
        "start": "{0} is out in the ring with a mic in hand ...",
        "action": "{0} is insistent on reclaiming lost honor and strives to work hard for it. The fans start to cheer {1}.",
        "startTag": "{0} are out in the ring with mics in hand ...",
        "actionTag": "{0} are insistent on reclaiming lost honor and strive to work hard for it. The fans start to cheer {1}."
    },
    "Video Package": {
        "start": "A video package airs about {0} ...",
        "action": "It focused on {0}",
        "choices": [
            "interviews by people close to {0}.",
            "training highlights of {0} getting ready to wrestle.",
            "a sit-down backstage interview with {0}.",
            "prominent people praising {0}.",
            "the ability of {0} in the ring.",
            "the story of {0} to get here.",
            "in-ring highlights of {0}'s wrestling career.",
            "{0} promoting the company outside the ring.",
            "a backstage monologue by {0} about {2} wrestling ability.",
            "the big wins of {0}'s career."
        ]
    },
    "Event Package": {
        "start": "A video package airs ...",
        "action": "It promoted and built hype for the upcoming monthly event."
    },
    "Debut Package": {
        "start": "A video package airs ...",
        "action": "It contained highlights of a new superstar, {0}."
    },
    "Return Package": {
        "start": "A video package airs ...",
        "action": "It showed {0} getting ready to return to the ring!"
    },
    "Career Package": {
        "start": "A video package airs ...",
        "action": "It showed highlights of the long and storied career of {0}."
    },
    "Day in the Life": {
        "start": "A video package airs ...",
        "action": "It focused on {0}",
        "choices": [
            "{0} going hunting for the day.",
            "{0} spending the whole day perfecting {2} wrestling ability.",
            "{0} spending a day at home with {2} family.",
            "{0} going for a picnic in the park with {2} family.",
            "{0} spending a day sun-bathing at the beach.",
            "{0} spending the day and night camping in the woods.",
            "{0} fishing in {2} boat all day long.",
            "{0} going trekking up the local hills.",
            "{0} dominating a local wrestling meet-up.",
            "{0} playing frisbee in the park with little kids and defeating them.",
            "{0} going swimming in the local lake and napping in the center of it."
        ]
    },
    "Competitor Buyout": {
        "start": "{0} is out in the ring to talk about the fate of {1} ...",
        "action": "{0} announces the purchase of {1}! {0} says the deal will be finalized soon and {1} will be no more. The fans are in awe."
    },
    "Champion Package": {
        "start": "A video package airs ...",
        "action": "It focused on {0}",
        "choices": [
            "the Championship Reign of {0}.",
            "how {0} won {2} Championship.",
            "how {0} surpasses the lineage of the Championship.",
            "the history of {0}'s Championship.",
            "{0} talking about how great {2} reign will be."
        ],
        "choicesTag": [
            "the Championship Reign of {0}.",
            "how {0} won {2} Championships.",
            "the lineage of the Championships and how {0} surpass it.",
            "the history of {0}'s Championships.",
            "{0} talking about how great {2} reign will be."
        ]
    },
    "Option C": {
        "start": "{0} comes out to the ring ...",
        "startTag": "{0} come out to the ring ...",
        "action": "{0} decides to invoke option C, vacating {2} Championship for a world title shot!",
        "actionTag": "{0} decide to invoke option C, vacating {2} Championships for a world title shot!"
    },
    "New Title Reveal": {
        "start": "{0} comes out to the ring ...",
        "startTag": "{0} come out to the ring ...",
        "action": "{0} reveals the new and customized version of {2} Championship!",
        "actionTag": "{0} reveal the new and customized versions of {2} Championships!"
    },
    "Championship Split": {
        "start": "The owner and {0} come out to the ring ...",
        "action": "The owner tells the fans about splitting {0}'s Championship into two and presents the new Championship!",
        "actionTag": "The owner tells the fans about splitting {0}'s Championships into two and presents the new Championships!"
    },
    "Entrance Parody": {
        "start": "",
        "action": "{4}'s music hits as ... Wait, it's actually {0} dressed in {4}'s gear! {0} mocks {6} entrance, doing the whole thing in an over the top way."
    },
    "Backstage Interview": {
        "start": "Our interviewer is backstage with {0} ...",
        "action": "{0}",
        "choices": [
            "{0} makes fun of the interviewer for all sorts of reasons.",
            "{0} talks about being the best performer in the locker room.",
            "{0} talks about being more than ready for {2} next match.",
            "{0} tells the interviewer to get lost and never disturb {1} again.",
            "{0} talks about how no one is above {1}."
        ],
        "choicesTag": [
            "{0} make fun of the interviewer for all sorts of reasons.",
            "{0} talk about being the best performers in the locker room.",
            "{0} talk about being more than ready for {2} next match.",
            "{0} tell the interviewer to get lost and never disturb {1} again.",
            "{0} talk about how no one is above {1}."
        ]
    },
    "Main Event Package": {
        "start": "A video package airs ...",
        "action": "It promoted and built hype for the main event of the show."
    },
    "Recap Package": {
        "start": "A video package airs ...",
        "action": "It went over the best part of the last show."
    },
    "Bodybuilding Contest": {
        "start": "{0} and {4} are in the ring and the lights are turned down ...",
        "action": "They do a variety of poses for the crowd before the contest devolves into a brawl! For what it's worth the crowd seemed to like {0}'s poses more."
    },
    "Spouse Affair": {
        "start": "",
        "action": "{4} is in the ring when {0} appears on the titantron, lying in bed. {4}'s spouse appears and joins {0} in bed! The video cuts away as {4} looks on, shattered.",
        "actionTag": "{4} are in the ring when {0} appear on the titantron, lying in bed. {4}'s spouses appear and join {0} in bed! The video cuts away as {4} look on, shattered."
    },
    "This Is My Life": {
        "start": "The ring is decorated as {0} comes out ...",
        "startTag": "The ring is decorated as {0} come out ...",
        "action": "{0} goes over all {2} accomplishments in life, bringing out past trophies, coaches singing {2} praise and messages of support from influential figures.",
        "actionTag": "{0} go over all {2} accomplishments in life, bringing out past trophies, coaches singing {2} praise and messages of support from influential figures."
    },
    "Siblings Parody": {
        "start": "",
        "action": "{0} brings three people pretending to be {4}'s siblings into the ring. They tell stories about how badly {4} treated them growing up.",
        "actionTag": "{0} bring three people pretending to be {4}'s siblings into the ring. They tell stories about how badly {4} treated them growing up."
    },
    "Backstage Attack": {
        "start": "",
        "action": "{0}",
        "choices": [
            "{4} is walking into the arena when {0} attacks {5} from behind! Superstars scramble backstage to pull {0} away from {4}.",
            "{0} is seen walking into {4}'s locker room. A scuffle is heard as cameras rush in to see {0} beating the hell out of {4}!",
            "{4} is seen coming out of {6} car when {0} ambushes {5}! {0} beats down {4} and throws {5} into the car window!"
        ],
        "choicesTag": [
            "{4} are walking into the arena when {0} attack {5} from behind! Superstars scramble backstage to get {0} away from {4}.",
            "{0} are seen walking into {4}'s locker room. A scuffle is heard as cameras rush in to see {0} beating the hell out of {4}!",
            "{4} are seen coming out of {6} car when {0} ambush {5}! {0} beat down {4} and throw {5} into the car window!"
        ]
    },
    "Retirement Ceremony": {
        "start": "{0} is out in the ring and the fans won't stop chanting {2} name ...",
        "action": "Friends and management come out to honor {1}. {0} wipes {2} cheeks as everyone applauds."
    },
    "Losing Streak Promo": {
        "start": "{0} is out in the ring counting {2} recent losses ...",
        "action": "{0} vows to break the losing streak in {2} next match!"
    },
    "Legendary Endorsement": {
        "start": "{4} is here and is coming down to the ring!",
        "action": "{4} calls out {0}, praises {2} recent work and endorses {1}!"
    },
    "Legendary Beatdown": {
        "start": "{4} is out in the ring thanking the fans for welcoming {5} back ...",
        "action": "{0} comes down to the ring and launches an attack on {4}! {0} viciously beats {4} down as officials try to pull {1} away."
    },
    "I'm The Face": {
        "start": "{0} comes out to the ring and talks about {2} recent achievements ...",
        "startTag": "{0} come out to the ring and talk about {2} recent achievements ...",
        "action": "{0} declares {2} right to be a face of this company!",
        "actionTag": "{0} declare {2} right to be faces of this company!"
    },
    "Best Wrestler Promo": {
        "start": "{0} comes out to the ring with the Wrestler of the Year trophy ...",
        "action": "{0} talks about finally getting recognized for being the best wrestler in the world and lifts the trophy over {2} head!"
    },
    "Trophy Destruction": {
        "start": "{0} comes out to the ring with {2} recently won trophy ...",
        "startTag": "{0} come out to the ring with {2} recently won trophy ...",
        "action": "{0} is talking about {2} award win when {4} shows up and attacks {0}. {4} picks up the trophy, throws it outside the ring and proceeds to smash it to pieces against the floor!",
        "actionTag": "{0} are talking about {2} award win when {4} show up and attack {0}. {4} pick up the trophy, throw it outside the ring and proceed to smash it to pieces against the floor!"
    },
    "Injury Gloat": {
        "start": "{0} comes out to the ring with a mic in {2} hands ...",
        "startTag": "{0} come out to the ring with mics in {2} hands ...",
        "action": "{0} talks about how good it felt to injure and take out {4}.",
        "actionTag": "{0} talk about how good it felt to injure and take out {4}."
    },
    "Retirement Gloat": {
        "start": "{0} comes out to the ring with a mic in {2} hands ...",
        "startTag": "{0} come out to the ring with mics in {2} hands ...",
        "action": "{0} gloats about retiring {4}. The fans boo as {3} tells them they will never see {4} wrestle again.",
        "actionTag": "{0} gloat about retiring {4}. The fans boo as {3} tells them they will never see {4} wrestle again."
    },
    "New Heel Promo": {
        "start": "{0} comes out to the answer the question everyone's been asking: 'Why?' ...",
        "startTag": "{0} come out to the answer the question everyone's been asking: 'Why?' ...",
        "action": "{0} talks about how the fans and {4} let {1} down. {0} says {2} time for needing anyone's support is over.",
        "actionTag": "{0} talk about how the fans and {4} let {1} down. {0} says {2} time for needing anyone's support is over."
    },
    "New Babyface Promo": {
        "start": "{0} comes out to the ovation of the fans ...",
        "startTag": "{0} come out to the ovation of the fans ...",
        "action": "{0} talks about having new priorities and moving on from {2} past. The fans applaud and {0} takes it in.",
        "actionTag": "{0} talk about having new priorities and moving on from {2} past. The fans applaud and {0} take it in."
    },
    "New Gimmick Package": {
        "start": "A video package airs about {0} ...",
        "action": "It introduced a new character for {0}.",
        "actionTag": "It introduced new characters for {0}."
    },
    "I Quit": {
        "start": "{0} comes out to the ring looking frustrated ...",
        "startTag": "{0} come out to the ring looking frustrated ...",
        "action": '{0} divulges {2} frustrations with the company and informs the fans of not wanting to be here anymore. {0} says "I Quit"!',
        "actionTag": '{0} divulge {2} frustrations with the company and inform the fans of not wanting to be here anymore. {0} say "We Quit"!'
    },
    "Better Together": {
        "start": "{0} comes out to the ring and calls out {4} ...",
        "action": "{0} says that despite their differences, they are better together. {4} looks on with mistrust but finally agrees and asks to join forces."
    },
    "Police Arrest": {
        "start": "{0} and {4} are shown brawling violently backstage ...",
        "action": "The owner demands them to stop but they bring their scuffle to the ring! Police are brought in to separate them. They put {0} and {4} in handcuffs as they continue to fight!"
    },
    "Retirement Announcement": {
        "start": "{0} comes out to the ring with a distressed look on {2} face ...",
        "startTag": "{0} come out to the ring with a distressed look on {2} faces ...",
        "action": "{0} announces that due to unforeseen developments, {2} in-ring career is now over. The fans are in in disbelief and despair. The retirement sinks in. Slowly, they start to chant {2} name.",
        "actionTag": "{0} announce that due to unforeseen developments, {2} in-ring careers are now over. The fans are in in disbelief and despair. The retirement sinks in. Slowly, they start to chant {2} name."
    },
    "One Last Run": {
        "start": "{0} comes out to the ring to talk about {2} future ...",
        "startTag": "{0} come out to the ring to talk about {2} future ...",
        "action": "{0} says it's time to retire. The fans chant against it. {0} asks for one final match against a Superstar of {2} choosing: {4}. {4} comes down to the ring, accepts and promises to retire {0}.",
        "actionTag": "{0} say it's time to retire. The fans chant against it. {0} ask for one final match against a Team of {2} choosing: {4}. {4} come down to the ring, accept and promise to retire {0}."
    },
    "New Partner": {
        "start": "{0} comes out to address the injury of {2} tag partner ...",
        "action": "{0} says it's time to move on and introduce {2} new tag team partner. {4}'s music hits! {0} declares they will be better than {2} old team and the two of them embrace."
    },
    "Dangerous Attack": {
        "start": "We're waiting for our next match ...",
        "action": "As {4} comes down to the ring, {0} ambushes {5} from behind. {0} places {4}'s neck between a steel chair and stomps the chair! The fans are concerned as a stretcher comes down for {4}.",
        "actionTag": "As {4} come down to the ring, {0} ambush {5} from behind. {0} place {4}'s necks between steel chairs and stomp the chairs! The fans are concerned as stretchers come down for {4}."
    },
    "Strip Champion": {
        "start": "The owner comes out to address the recent situation regarding the champion, {0} ...",
        "startTag": "The owner comes out to address the recent situation regarding the champions, {0} ...",
        "action": "The owner proclaims the need for immediate action and strips {0} of {2} title!",
        "actionTag": "The owner proclaims the need for immediate action and strips {0} of {2} titles!"
    },
    "Laying Down The Law": {
        "start": "The owner comes out to address the recent actions of {0} ...",
        "action": "The owner talks about how {0} must be punished for {2} actions and proceeds to suspend {1} for a month!"
    },
    "Best Company Brag": {
        "start": "The owner of the company comes out to the ring with the Company of the Year trophy ...",
        "action": "The owner brags about winning the award and puts down the competitors!"
    },
    "Proven Winner": {
        "start": "",
        "action": "{0} comes down to the ring and talks about winning the feud against {4} by proving to be better than {5}.",
        "actionTag": "{0} come down to the ring and talk about winning the feud against {4} by proving to be better than {5}."
    },
    "New Alliance": {
        "start": "{0} is out in the ring fighting with {4} ...",
        "action": "{0} seemed to be getting the better of the exchange when {8} and {12} come down to attack {1}! After beating down {0} mercilessly, {4}, {8} and {12} announce the formation of a new alliance."
    },
    "Cryptic Threat": {
        "start": "{0} is shown in a dark room backstage ...",
        "startTag": "{0} are shown in a dark room backstage ...",
        "action": "{0} sends a warning to someone filled with cryptic hints. Who could it be?",
        "actionTag": "{0} send a warning to someone filled with cryptic hints. Who could it be?"
    },
    "Car Explosion": {
        "start": "{0} is seen getting into {2} car backstage ...",
        "action": "As the car takes off, there's a sudden explosion and the car is engulfed in fire! Crew rush to put it out. Everyone is in shock as to what just happened to {0}."
    },
    "Celebrity Beatdown": {
        "start": "{4} is out in the ring! The fans are excited ...",
        "action": "{0} comes out from behind and attacks {4}! {0} picks {4} up and hits {2} finisher on {5}!"
    },
    "Hosedown": {
        "start": "A bunch of superstars are crowding the ring. {0}'s music hits but wait, is that a truck? ...",
        "action": "{3}'s coming out in a lemonade truck! {0} grabs a hose and starts spraying lemonade on everyone in the ring! All the superstars are slipping and falling around."
    },
    "Helicopter Raid": {
        "start": "A helicopter is hovering in the air. Wait, is that {0} in it?! ...",
        "action": "Yes it is! And {3}'s landing on top of {4}'s building! {0} is launching a raid on {4}!"
    },
    "Ring Invasion": {
        "start": "{0} is standing in the ring and says {3} won't leave until {3} gets what he wants ...",
        "action": "Dozens of people storm the ring! {0} says they are taking over the show as the ring fills up with even more people! Security fails to remove anyone and the establishment has no choice but to meet their demands."
    },
    "Love Making": {
        "start": "There's a bed in the ring as {0} comes out with {2} partner ...",
        "action": "They take each others clothes off, get under the covers, and start making love in front of everyone!"
    },
    "Dummy Wrestling": {
        "start": "{0} is calling out anyone in the back to a match. Wait, is that ...",
        "action": "A wrestling doll comes out and {0} proceeds to wrestle the doll! The two have a fantastic match, with great story, tremendous moves and thrilling near-falls. The crowd is on their feet as {0} hits {2} finisher for the win!"
    },
    "Anti-Company Rant": {
        "start": "{0} comes out to the stage with a mic in {2} hands ...",
        "action": "{0} goes on a rant against the company, saying {3} is the best but the company won't let {1} be the top guy. {3} threatens to leave for a competitor and calls the owner an idiot before {2} mic gets cut off."
    },
    "Stunt Dive": {
        "start": "The roster is fighting on the ramp. {0} climbs the titantron to get away from them. That must be 50 feet or more ...",
        "action": "{0} leaps off the titantron onto everyone below! The crowd goes wild!"
    },
    "Timely Rescue": {
        "start": "{0} is backstage, talking to the camera. A staff member is seen walking behind when, suddenly, they collapse. {0} rushes over and starts performing CPR ...",
        "action": "Everyone in the audience is holding their breath. It's announced that the staff member was {4} and this is not part of the show. {0} keeps performing compressions as paramedics arrive. After thorough medical aid, the doctors say {4} will be alright."
    },
    "Handicap Beatdown": {
        "participants": {
            "3": {
                "start": "{0} is out in the ring for a promo ...",
                "startTag": "{0} are out in the ring for a promo ...",
                "action": "{4} and {8} ambush {1} from behind! They continue to beat down {0} until officials pull them off."
            },
            "4": {
                "start": "{0} is out in the ring for a promo ...",
                "startTag": "{0} are out in the ring for a promo ...",
                "action": "{4}, {8} and {12} ambush {1} from behind! They continue to beat down {0} until officials pull them off."
            },
            "5": {
                "start": "{0} is out in the ring for a promo ...",
                "startTag": "{0} are out in the ring for a promo ...",
                "action": "{4}, {8}, {12} and {16} ambush {1} from behind! They continue to beat down {0} until officials pull them off."
            }
        }
    },
    "Rip Off Mask": {
        "start": "{0} is out in the ring when {4} ambushes {1} from behind!",
        "action": "{4} attacks {0} and proceeds to take {2} mask off! {0} pulls away with {2} face in {2} hands while {4} poses with the mask.",
        "startTag": "{0} are out in the ring when {4} ambush {1} from behind!",
        "actionTag": "{4} attack {0} and proceed to take {2} masks off! {0} pull away with {2} faces in {2} hands while {4} pose with the masks."
    },
    "Kicked Out": {
        "start": "{0} are out in the ring. They say they have to make an important announcement ...",
        "action": "{0} turn and attack {1}, throwing {2} out of the ring! It seems like {0} have kicked {1} out of the faction.",
        "startTag": "{0} are out in the ring. They say they have to make an important announcement ...",
        "actionTag": "{0} turn and attack {1}, throwing {2} out of the ring! It seems like {0} have kicked {1} out of the faction."
    },
    "Time To Leave": {
        "start": "{1} comes out to the ring and calls out the rest of {0} ...",
        "action": "{1} says it's time for {2} to leave {0}. The rest of {0} look on as {1} walks away.",
        "startTag": "{1} come out to the ring and call out the rest of {0} ...",
        "actionTag": "{1} say it's time for {2} to leave {0}. The rest of {0} look on as {1} walk away."
    },
    "New Blood": {
        "start": "{0} are standing in the ring, saying they have an exciting announcement ...",
        "action": "They welcome the newest member of {0}. {1} comes out and embraces everyone! {1} has joined {0}.",
        "startTag": "{0} are standing in the ring, saying they have an exciting announcement ...",
        "actionTag": "They welcome the newest members of {0}. {1} come out and embrace everyone! {1} have joined {0}."
    },
    "Our Leader": {
        "start": "{0} are out in the ring to make an announcement ...",
        "action": "{0} introduce their new leader: {1}! {1} grabs a mic and talks about guiding the faction to the top of the company."
    },
    "New Leadership": {
        "start": "{0} are out in the ring to make an announcement ...",
        "action": "{5} says its time for someone else to lead {0} and announces the new leader: {1}! {1} promises to guide the faction to greater heights."
    },
    "Usurped": {
        "start": "{0} are out in the ring. {1} grabs the mic ...",
        "action": "Before saying a word, {1} attacks {5}! The rest of {0} join the attack, supporting {1}'s control over the faction!"
    },
    "Switching Sides": {
        "start": "{0} are out in the ring when {9} come out ...",
        "startTag": "{0} are out in the ring when {9} come out ...",
        "action": "Before they can enter the ring, {1} attacks the other members of {0} from behind! {9} join {2} as they beat down {0} together. {1} embraces the members of {9}!",
        "actionTag": "Before they can enter the ring, {1} attack the other members of {0} from behind! {9} join {2} as they beat down {0} together. {1} embrace the members of {9}!"
    },
    "Joining Forces": {
        "start": "{0} are out in the ring. They call out {5} ...",
        "action": 'The two factions stand together and announce that they are joining forces to form "{6}"!'
    },
    "Internal Division": {
        "start": "{0} are out in the ring. Looks like they have something on their minds ...",
        "startTag": "{0} are out in the ring. Looks like they have something on their minds ...",
        "action": '{1} blindside the other members of {0}, attacking them from behind! {1} announce that they are splitting from {0} to form "{10}"!',
        "actionTag": '{1} blindside the other members of {0}, attacking them from behind! {1} announce that they are splitting from {0} to form "{10}"!'
    },
    "No Leadership": {
        "start": "{0} are out in the ring to make an announcement ...",
        "action": "They say that, from now on, {0} will operate without any leadership."
    },
    "Our End": {
        "start": "{0} are out in the ring with something on their minds ...",
        "action": "They announce that this is the end of {0}."
    },
    "New Power": {
        "start": "{1} come out to the ring and stand together ...",
        "startTag": "{1} come out to the ring and stand together ...",
        "action": 'They say they have come together to form an alliance. They will be called "{10}"!',
        "actionTag": 'They say they have come together to form an alliance. They will be called "{10}"!'
    },
    "Manager Promo": {
        "start": "{0} is in the ring along with {4} ...",
        "action": "{0}",
        "choices": [
            "{0} praised {4}'s accomplishments.",
            "{0} applauded {4}'s ability and skill.",
            "{0} warned everyone in the back to watch out for {4}.",
            "{0} told the fans that no one can defeat {4}.",
            "{0} talked about {4}'s unmatched talent.",
            "{0} said everyone should watch out for {4}'s next move.",
            "{0} hyped {4}'s unique capabilities.",
            "{4} stood aside as {0} sang {6} praises.",
            "{0} told everyone who is watching that they should be scared of {4}.",
            "{0} spoke about the immense strengths of {4}.",
            "{0} talked about {4}'s greatness and said no one can match {5}.",
            "{0} went on about {4}'s talent and said no one is above {5}.",
            "{0} said no one should think about getting in the way of {4}.",
            "{0} talked about {4} being better than anyone in the locker room.",
            "{4} looked menacing as {0} built {5} up."
        ]
    },
    "Dismiss Manager": {
        "start": "{4} comes out to the ring and calls out {0} ...",
        "action": "{4} says {7} no longer wants {0} as {6} manager and ends their relationship!",
        "startTag": "{4} come out to the ring and call out {0} ...",
        "actionTag": "{4} say {7} no longer want {0} as {6} manager and end their relationship!"
    },
    "Reveal Manager": {
        "start": "{4} is here with an important announcement ...",
        "action": "{0} comes out to stand with {5}, revealing that {3} is the new manager of {4}!",
        "startTag": "{4} are here with an important announcement ...",
        "actionTag": "{0} comes out to stand with {5}, revealing that {3} is the new manager of {4}!"
    },
    "Client Betrayal": {
        "start": "{0} comes into the ring, cheering {4} on ...",
        "action": "As {4} turns around, {0} attacks {5} with a weapon! {4} looks on in shock at {0}.",
        "startTag": "{0} comes into the ring, cheering {4} on ...",
        "actionTag": "As {4} turn around, {0} attacks {5} with a weapon! {4} look on in shock at {0}."
    },
    "Brand Invasion": {
        "start": "There's something going on in the stands ... Wait, that's {0} from {2}!",
        "action": "They storm the ring, fight off incoming {1} superstars and throw them out. The {2} superstars have invaded {1}!"
    },
    "Brand Signing": {
        "start": "{0} is here with some big news ...",
        "action": "{0} says {3} has decided to join {4}! From now on, {0} will be exclusive to the {4} brand.",
        "startTag": "{0} are here with some big news ...",
        "actionTag": "{0} say {3} have decided to join {4}! From now on, {0} will be exclusive to the {4} brand."
    },
    "Backstage Confrontation": {
        "start": "We are backstage for a scheduled interview ...",
        "action": "{4} is talking to the interviewer when {0} interrupts {5}. They get aggressive with each other before officials come in between.",
        "startTag": "We are backstage for a scheduled interview ...",
        "actionTag": "{4} are talking to the interviewer when {0} interrupt {5}. They get aggressive with each other before officials come in between."
    },
    "Off-Camera Assault": {
        "start": "We have a camera backstage with an incident ...",
        "action": "{4} is lying on the floor, battered and bloodied. {0} is seen walking away in the corner of the frame.",
        "startTag": "We have a camera backstage with an incident ...",
        "actionTag": "{4} are lying on the floor, battered and bloodied. {0} are seen walking away in the corner of the frame."
    },
    "Split Interview": {
        "start": "Our interviewer is live with {0} and {4} in separate locations ...",
        "action": "The conversation got heated as they argued and verbally attacked each other.",
        "startTag": "Our interviewer is live with {0} and {4} in separate locations ...",
        "actionTag": "The conversation got heated as they argued and verbally attacked each other."
    },
    "Solo Feud Promo": {
        "start": "{0} is in the ring for a promo ...",
        "startTag": "{0} are in the ring for a promo ...",
        "action": "{0}",
        "choices": [
            "{0} talked about how {3} will embarass {4} soon.",
            "{0} described the many ways in which {3} will enjoy beating up {4}.",
            "{0} listed all the ways that {3} is better than {4}.",
            "{0} insulted {4} and {6} hometown.",
            "{0} explained to the fans how {4} is a disgrace to the wrestling industry.",
            "{0} disclosed {2} unpleasant history with {4} to the fans.",
            "{0} told the fans a story about how {4} is a terrible person.",
            "{0} made things personal with {4} by bringing up {6} family.",
            "{0} called {4} a loser and other things that are too vile to be repeated.",
            "{0} promised the fans that not only will {3} defeat {4}, but {3} will also humiliate {5}.",
            "{0} went off on {4}, berating {5} for everything {7} has done.",
            "{0} talked about being a better wrestler than {4} and promised to prove it."
        ],
        "choicesTag": [
            "{0} talked about how {3} will embarass {4} soon.",
            "{0} described the many ways in which {3} will enjoy beating up {4}.",
            "{0} listed all the ways that {3} are better than {4}.",
            "{0} insulted {4} and {6} hometown.",
            "{0} explained to the fans how {4} are a disgrace to the wrestling industry.",
            "{0} disclosed {2} unpleasant history with {4} to the fans.",
            "{0} told the fans a story about how {4} are terrible people.",
            "{0} made things personal with {4} by bringing up {6} family.",
            "{0} called {4} losers and other things that are too vile to be repeated.",
            "{0} promised the fans that not only will {3} defeat {4}, but {3} will also humiliate {5}.",
            "{0} went off on {4}, berating {5} for everything {7} have done.",
            "{0} talked about being better wrestlers than {4} and promised to prove it."
        ]
    },
    "Staredown": {
        "start": "{4} is in the ring cutting a promo when {0}'s music hits!",
        "action": "{0} comes face to face with {4} and they have an intense staredown.",
        "startTag": "{4} are in the ring cutting a promo when {0}'s music hits!",
        "actionTag": "{0} come face to face with {4} and they have an intense staredown."
    },
    "Fight Tease": {
        "start": "{0} and {4} are talking in the ring. Tensions are getting high ...",
        "action": "{0} teases a fight but backs out of the ring at the last minute.",
        "startTag": "{0} and {4} are talking in the ring. Tensions are getting high ...",
        "actionTag": "{0} tease a fight but back out of the ring at the last minute."
    },
    "Forced To Retreat": {
        "start": "{0} and {4} are in the ring, talking. They say some insulting things to each other ...",
        "action": "A fight breaks out. {0} has {4} ready for {2} finisher but {4} is able to escape from the ring!",
        "startTag": "{0} and {4} are in the ring, talking. They say some insulting things to each other ...",
        "actionTag": "A fight breaks out. {0} have {4} ready for {2} finisher but {4} are able to escape from the ring!"
    },
    "Standing Tall": {
        "start": "{0} and {4} are talking to each other in the ring. It's getting hostile ...",
        "action": "They start brawling! {0} gets the upper hand and hits {2} finisher on {4} to stand tall!",
        "startTag": "{0} and {4} are talking to each other in the ring. It's getting hostile ...",
        "actionTag": "They start brawling! {0} get the upper hand and hit {2} finisher on {4} to stand tall!"
    },
    "Tense Pull-Apart": {
        "start": "{0} and {4} are out talking in the ring. Things are getting intense between them ...",
        "action": "They start fighting! Officials run in to pull them apart but they can barely contain the two!",
        "startTag": "{0} and {4} are out talking in the ring. Things are getting intense between them ...",
        "actionTag": "They start fighting! Officials run in to pull them apart but they can barely contain the teams!"
    },
    "Surprise Attack": {
        "start": "We're in the ring, waiting to hear from a superstar ...",
        "action": "{4} is talking on the mic when {0} sneaks in from behind to attack {5}! {0} beats down {4} and leaves {5} laying in the ring.",
        "startTag": "We're in the ring, waiting to hear from a superstar ...",
        "actionTag": "{4} are talking on the mic when {0} sneak in from behind to attack {5}! {0} beat down {4} and leave {5} laying in the ring."
    },
    "After Match Attack": {
        "start": "We just finished our last match ...",
        "action": "{4} is going to leave after {6} match when {0} attacks {5} from behind! {0} lays {4} out and exits the ring.",
        "startTag": "We just finished our last match ...",
        "actionTag": "{4} are going to leave after {6} match when {0} attack {5} from behind! {0} lay {4} out and exit the ring."
    },
    "After Match Save": {
        "start": "The match is over ...",
        "action": "{4} is attacking {6} opponent when {0}'s music hits! {0} charges down to the ring as {4} retreats.",
        "startTag": "The match is over ...",
        "actionTag": "{4} are attacking {6} opponent when {0}'s music hits! {0} charge down to the ring as {4} retreat."
    },
    "Interview Attack": {
        "start": "We're backstage with an interview ...",
        "action": "{4} is talking when {0} ambushes {5} from behind! {0} continues the attack until officials are able to force {1} away.",
        "startTag": "We're backstage with an interview ...",
        "actionTag": "{4} are talking when {0} ambush {5} from behind! {0} continue the attack until officials are able to force {1} away."
    },
    "Spouse Attack": {
        "start": "",
        "action": "{4} is in the ring with {6} spouse when {0} knocks out {4} from behind and then attacks {6} spouse! {4} crawls to {6} spouse as {0} walks away.",
        "startTag": "",
        "actionTag": "{4} are in the ring with {6} spouse when {0} knock out {4} from behind and then attack {6} spouse! {4} crawl to {6} spouse as {0} walk away."
    },
    "Desecrate Grave": {
        "start": "A camera is outside where it's dark and gloomy. We seem to be in a graveyard ...",
        "action": "{0} is standing next to a grave. The camera pans to the tombstone, revealing it belongs to a family member of {4}. {0} mocks the dead and then vandalizes the grave!",
        "startTag": "A camera is outside where it's dark and gloomy. We seem to be in a graveyard ...",
        "actionTag": "{0} are standing next to a grave. The camera pans to the tombstone, revealing it belongs to a family member of {4}. {0} mock the dead and then vandalize the grave!"
    },
    "Debut Promo": {
        "start": "We're in the ring when the lights go out and someone's music hits ...",
        "startTag": "We're in the ring when the lights go out and someone's music hits ...",
        "action": "{0}",
        "choices": [
            "It's {0}! {0} comes out to the cheering of the fans and says {3} has joined the best wrestling company!",
            "{0} is here! {0} arrives to the ovation of the fans and talks trash about {2} previous employer!",
            "It's {0}! {0} comes down to the applause of the fans and says {3} is going to shake this company up!",
            "{0} is here! {0} comes out to the cheering of the fans and puts everyone on the roster on notice!",
            "It's {0}! {0} arrives to the ovation of the fans and says {3} is the best superstar in this company!"
        ],
        "choicesTag": [
            "It's {0}! {0} come out to the cheering of the fans and say {3} have joined the best wrestling company!",
            "{0} are here! {0} arrive to the ovation of the fans and talk trash about {2} previous employer!",
            "It's {0}! {0} come down to the cheering of the fans and say {3} are going to shake this company up!",
            "{0} are here! {0} come out to the cheering of the fans and put everyone on the roster on notice!",
            "It's {0}! {0} arrive to the ovation of the fans and say {3} are the best team in this company!"
        ]
    },
    "Debut Attack": {
        "start": "{4} is in the ring cutting a promo when the lights go out ...",
        "action": "It's {0}! {0} attacks {4} and takes {5} out! The fans are in shock as {0} walks away.",
        "startTag": "{4} are in the ring cutting a promo when the lights go out ...",
        "actionTag": "It's {0}! {0} attack {4} and take {5} out! The fans are in shock as {0} walk away."
    },
    "Indifferent Promo": {
        "start": "{0} is in the ring for a promo ...",
        "startTag": "{0} are in the ring for a promo ...",
        "action": "{0}",
        "choices": [
            "{0} told the fans {3} doesn't care whether they cheer {1} or boo {1}.",
            "{0} said {3} doesn't know if {3} is a good person or a bad person, but does know that {3} is the best.",
            "{0} talked about doing whatever {3} wants, regardless of what people think.",
            "{0} spoke about being the best performer in the company.",
            "{0} told the fans {3} doesn't care what they think about {1}.",
            "{0} talked about doing things that other people wouldn't have the guts to do.",
            "{0} promised the fans that {3} will never change who {3} is."
        ],
        "choicesTag": [
            "{0} told the fans {3} don't care whether they cheer {1} or boo {1}.",
            "{0} said {3} don't know if {3} are good people or bad people, but do know that {3} are the best.",
            "{0} talked about doing whatever {3} want, regardless of what people think.",
            "{0} spoke about being the best performers in the company.",
            "{0} told the fans {3} don't care what they think about {1}.",
            "{0} talked about doing things that other people wouldn't have the guts to do.",
            "{0} promised the fans that {3} will never change who {3} are."
        ]
    },
    "Catchphrase Showdown": {
        "start": "{0} and {4} are in the ring, mics in hand, ready to go ...",
        "action": "They used their catchphrases against each other and hurled some major insults!"
    },
    "Cutting Ties": {
        "participants": {
            "2": {
                "start": "{0} and {4} are in the ring to discuss their future ...",
                "action": "They announce that they will no longer team together and walk away."
            },
            "3": {
                "start": "{0}, {4} and {8} are in the ring to discuss their future ...",
                "action": "They announce that they will no longer team together and walk away."
            }
        }
    },
    "New Association": {
        "participants": {
            "2": {
                "start": "{0} is in the ring when {4} comes out to join {1} ...",
                "action": "They agree on having a common goal and decide to form a team with each other."
            },
            "3": {
                "start": "{0} is in the ring when {4} and {8} come out to join {1} ...",
                "action": "They agree on having a common goal and decide to form a team with each other."
            }
        }
    },
    "Face Reveal": {
        "start": "{0} is standing in the middle of the ring, looking hesitant ...",
        "action": "{0} takes off {2} mask to reveal {2} face! The crowd looks on in shock.",
        "startTag": "{0} are standing in the middle of the ring, looking hesitant ...",
        "actionTag": "{0} take off {2} mask to reveal {2} faces! The crowd looks on in shock."
    },
    "Righteous Beatdown": {
        "start": "{0} and {4} are out in the ring for a promo ...",
        "action": "After {4} says some nasty things, {0} gets angry and attacks {5}! {0} beats {4} up as the crowd cheers {1} on!",
        "startTag": "{0} and {4} are out in the ring for a promo ...",
        "actionTag": "After {4} say some nasty things, {0} get angry and attack {5}! {0} beat {4} up as the crowd cheers {1} on!"
    },
    "Title Unification": {
        "start": "The owner comes out to the ring with {0} ...",
        "action": "The owner announces that {0}'s Championships will be unified and presents {0} with the single new Championship!",
        "startTag": "The owner comes out to the ring with {0} ...",
        "actionTag": "The owner announces that {0}'s Championships will be unified and presents {0} with the single new Championships!"
    },
    "Surprise Return": {
        "start": "The owner is in the ring to announce someone's return ...",
        "action": "{0}'s music hits and the fans go crazy! They're on their feet as {3} comes down to the ring, soaking it all in.",
        "startTag": "The owner is in the ring to announce someone's return ...",
        "actionTag": "{0}'s music plays! {0} are back! The fans are on their feet as {3} come down to the ring, soaking it all in."
    },
    "Return Attack": {
        "start": "{4} is in the ring when some familiar music plays ...",
        "action": "It's {0}! {0} has returned from injury! The fans are going crazy as {0} comes down to the ring and takes {4} out!",
        "startTag": "{4} are in the ring when some familiar music plays ...",
        "actionTag": "It's {0}! {0} have returned from injury! The fans are going crazy as {0} come down to the ring and take {4} out!"
    },
    "Retirement Fakeout": {
        "start": "{4} is in the ring when {0} comes out with an uneasy look on {2} face ...",
        "action": "{0} gets choked up as {3} talks about {2} career and announces that it's time to retire. Loud chants erupt for {1}. {4} goes to raise {2} hand but {0} attacks {4} and lays {5} out!",
        "startTag": "",
        "actionTag": ""
    },
    "TGI Victory Boast": {
        "start": "{0} comes out to the ring holding the TGI trophy ...",
        "action": "{0} talks about the importance of winning The Grand Invitational for the company and lifts the trophy up high!"
    }
};
let $142a324ea0eb2145$export$74ce561d86f9af31 = [
    // Repeatable
    "Backstage Interview",
    "Fight",
    "Promo Battle",
    "Solo Feud Promo",
    "Spirited Promo",
    "Heat Promo",
    "Indifferent Promo",
    // No requirement/consequence
    "Slander Competitor",
    "Backstage Confrontation",
    "Off-Camera Assault",
    "Split Interview",
    "Staredown",
    "Fight Tease",
    "Forced To Retreat",
    "Standing Tall",
    "Tense Pull-Apart",
    "Surprise Attack",
    "After Match Attack",
    "After Match Save",
    "Interview Attack",
    "Backstage Attack",
    "Promo Ambush",
    "Handicap Beatdown",
    "Contract Signing",
    "Kidnapping",
    "Desecrate Grave",
    "Masked Attacker",
    "Unlikely Partners",
    "Push-up Contest",
    "Home Invasion",
    "Spouse Attack",
    "Car Destruction",
    "Smack Talk",
    "Catchphrase Showdown",
    "Epic Brawl",
    "Local Squash",
    "This Is My Life",
    "Talk Show",
    // Consequence/Requirement
    "Dangerous Attack",
    "Police Arrest",
    "Rip Off Mask",
    "Trophy Destruction",
    "Cryptic Threat",
    "Debut",
    "Debut Promo",
    "Debut Attack",
    "Surprise Return",
    "Return Attack",
    "Proven Winner",
    "Moving On",
    "Mutual Respect",
    "Best Wrestler Promo",
    "Best Company Brag",
    "I'm The Face",
    "Build Honor",
    "Villainize",
    "Neutralize",
    "Injury Gloat",
    "Losing Streak Promo",
    "Demand Title Shot",
    "Title Disrespect",
    "Cash-In Tease",
    "Title Destruction",
    "Champion Coronation",
    "Title Unification",
    "Championship Split",
    "New Title Reveal",
    "Option C",
    "New Association",
    "Cutting Ties",
    "New Alliance",
    "New Partner",
    "Better Together",
    "Team Tension",
    "Vicious Beatdown",
    "Righteous Beatdown",
    "Backstab",
    "Defying a Villain",
    "Beatdown Save",
    "Joining the Devil",
    "Delayed Vengeance",
    "Forgiveness",
    "New Heel Promo",
    "New Babyface Promo",
    "Retirement Ceremony",
    "Retirement Fakeout",
    "One Last Run",
    "Retirement Announcement",
    "Retirement Gloat",
    "Legendary Beatdown",
    "Legendary Endorsement",
    "Legend's Praise",
    "Competitor Buyout",
    "Laying Down The Law",
    "Strip Champion",
    "This Belongs To You",
    "I Quit",
    "Face Reveal",
    "You're Fired",
    "Lost My Smile",
    // Production
    "Video Package",
    "Feud Package",
    "Event Package",
    "Main Event Package",
    "Recap Package",
    "Champion Package",
    "Debut Package",
    "New Gimmick Package",
    "Return Package",
    "Career Package",
    "Day in the Life",
    // Manager/faction/brand
    "Manager Promo",
    "Reveal Manager",
    "Dismiss Manager",
    "Client Betrayal",
    "Kicked Out",
    "Time To Leave",
    "New Blood",
    "Our Leader",
    "Usurped",
    "New Leadership",
    "Switching Sides",
    "Joining Forces",
    "Internal Division",
    "No Leadership",
    "Our End",
    "New Power",
    "Brand Signing",
    "Brand Invasion",
    // Silly
    "Singing Contest",
    "Slime Surprise",
    "Spooky Trick",
    "Backstage BBQ",
    "Midget Impersonation",
    "Anger Management",
    "Entrance Parody",
    "Siblings Parody",
    "Bodybuilding Contest",
    "Spouse Affair",
    "Exposing the Past",
    // Special
    "Car Explosion",
    "Timely Rescue",
    "Stunt Dive",
    "Anti-Company Rant",
    "Dummy Wrestling",
    "Love Making",
    "Ring Invasion",
    "Helicopter Raid",
    "Hosedown",
    "Celebrity Beatdown"
];

});



parcelRequire.register("bmMQt", function(module, exports) {
module.exports = import("./protectedFunctions.bac340c1.js").then(()=>parcelRequire("7XiTw"));

});


var $lCS03 = parcelRequire("lCS03");
$(document).ready(function() {
    const $dropdownMenus = $(".main-menu, #matches, #main-menu-buttons");
    const $html = $("html");
    // Show/hide dropdown menu upon clicking on dropdown button
    $dropdownMenus.on("click", ".button-dropdown", function() {
        if ($(this).hasClass("disabled")) {
            notie.alert({
                type: 4,
                text: "You cannot edit this Match/Segment."
            });
            return false;
        }
        (0, $lCS03.playSoundEffect)("success");
        let t = $(this).children(".dropdown-menu").is(":hidden");
        $(".button-dropdown .dropdown-menu").hide();
        $(".button-dropdown").removeClass("selected");
        if (t) $(this).children(".dropdown-menu").toggle().parents(".button-dropdown").addClass("selected");
    });
    // Hide dropdown menu when clicking anywhere else
    $html.on("click", function(t) {
        let n = $(t.target);
        const $dropdownMenu = $(".button-dropdown .dropdown-menu");
        if (n.closest(".button-dropdown").length <= 0 && $dropdownMenu.is(":visible")) {
            $dropdownMenu.hide();
            $(".button-dropdown").removeClass("selected");
        }
    });
    // Hide dropdown menu upon clicking its item. Keep dropdown button selected.
    $dropdownMenus.on("click", ".dropdown-menu li", function(e) {
        e.preventDefault();
        e.stopPropagation();
        (0, $lCS03.playSoundEffect)("success");
        // Show error if disabled, don't select
        if ($(this).hasClass("disabled")) {
            let errorText = $(this).data("tipText");
            notie.alert({
                type: 3,
                text: errorText,
                stay: true
            });
            return false;
        }
        // Select this item, hide dropdown
        $(".dropdown-menu").children().removeClass("selected");
        $(this).addClass("selected");
        $(this).parent().hide();
        $(this).closest(".button-dropdown").siblings().removeClass("selected");
        // Hide event effects
        $(".event-prestige-effects-container").hide();
        $(".event-prestige-effects-more i").addClass("fa-angle-down").removeClass("fa-angle-up");
    });
    // Show help text
    $(document).on({
        mouseenter: function() {
            let title = $(this).attr("title");
            if (title) {
                $(this).data("tipText", title).removeAttr("title");
                $('<p class="tooltip"></p>').text(title).appendTo("body").fadeIn("fast");
            }
        },
        mouseleave: function() {
            $(this).attr("title", $(this).data("tipText"));
            $(".tooltip").remove();
            // Remove help text for multi match check box upon checking it
            if ($(this).attr("id") === "multi-match-button" && $(this).find(".fa").hasClass("fa-check-circle-o")) $(this).removeClass("help-text").attr("title", "");
        },
        mousedown: function() {
            $(".tooltip").remove();
        },
        mousemove: function(e) {
            let mouseX = e.pageX + 20; //Get X coordinates
            let mouseY = e.pageY + 10; //Get Y coordinates
            $(".tooltip").css({
                top: mouseY,
                left: mouseX
            });
        },
        touchstart: function(e) {
            $(".tooltip").remove();
            let title = $(this).attr("title");
            if (title) {
                $('<p class="tooltip"></p>').text(title).appendTo("body").fadeIn("fast");
                let xPos = e.originalEvent.touches[0].pageX + 40; //Get X coordinates
                let yPos = e.originalEvent.touches[0].pageY - 30; //Get Y coordinates
                $(".tooltip").css({
                    top: yPos,
                    left: xPos
                });
            }
        },
        touchend: function() {
            $(this).attr("title", $(this).data("tipText"));
            $(".tooltip").remove();
        }
    }, ".help-text");
});



var $98xmD = parcelRequire("98xmD");

var $1JSre = parcelRequire("1JSre");

var $iRMwH = parcelRequire("iRMwH");

var $iRMwH = parcelRequire("iRMwH");

var $3E8Nt = parcelRequire("3E8Nt");

var $98xmD = parcelRequire("98xmD");

var $14eBR = parcelRequire("14eBR");

var $98xmD = parcelRequire("98xmD");

var $iRMwH = parcelRequire("iRMwH");

var $98xmD = parcelRequire("98xmD");

var $98xmD = parcelRequire("98xmD");

var $8A6FL = parcelRequire("8A6FL");

var $1JSre = parcelRequire("1JSre");

var $3E8Nt = parcelRequire("3E8Nt");

var $lCS03 = parcelRequire("lCS03");
function $cdadd3e3b416e3dd$export$cd054587bb4ae1d2() {
    // Get textures
    let textures = PIXI.loader.resources["static/www/static/images/sprites/sprites.json"].textures;
    // Load sprites from textures
    let bodyHe = new PIXI.Sprite(textures["body_he.png"]);
    let bodyShe = new PIXI.Sprite(textures["body_she.png"]);
    let bodyHeAbs = new PIXI.Sprite(textures["body_he_abs.png"]);
    let bodySheAbs = new PIXI.Sprite(textures["body_she_abs.png"]);
    let eyesDesign = new PIXI.Sprite(textures["eyes.png"]);
    let trunksBase = new PIXI.Sprite(textures["trunks_base.png"]);
    let trunksDesign1 = new PIXI.Sprite(textures["trunks_1.png"]);
    let trunksDesign2 = new PIXI.Sprite(textures["trunks_2.png"]);
    let trunksDesign3 = new PIXI.Sprite(textures["trunks_3.png"]);
    let trunksDesign4 = new PIXI.Sprite(textures["trunks_4.png"]);
    let trunksDesign5 = new PIXI.Sprite(textures["trunks_5.png"]);
    let trunksDesign6A = new PIXI.Sprite(textures["trunks_6_a.png"]);
    let trunksDesign6B = new PIXI.Sprite(textures["trunks_6_b.png"]);
    let trunksDesign7 = new PIXI.Sprite(textures["trunks_7.png"]);
    let trunksDesign8A = new PIXI.Sprite(textures["trunks_8_a.png"]);
    let trunksDesign8B = new PIXI.Sprite(textures["trunks_8_b.png"]);
    let trunksDesign9 = new PIXI.Sprite(textures["trunks_9.png"]);
    let trunksDesign10A = new PIXI.Sprite(textures["trunks_10_a.png"]);
    let trunksDesign10B = new PIXI.Sprite(textures["trunks_10_b.png"]);
    let trunksDesign11 = new PIXI.Sprite(textures["trunks_11.png"]);
    let trunksDesign12 = new PIXI.Sprite(textures["trunks_12.png"]);
    let trunksDesign13 = new PIXI.Sprite(textures["trunks_13.png"]);
    let trunksDesign14A = new PIXI.Sprite(textures["trunks_14_a.png"]);
    let trunksDesign14B = new PIXI.Sprite(textures["trunks_14_b.png"]);
    let trunksDesign15A = new PIXI.Sprite(textures["trunks_15_a.png"]);
    let trunksDesign15B = new PIXI.Sprite(textures["trunks_15_b.png"]);
    let shortsBase = new PIXI.Sprite(textures["shorts_base.png"]);
    let shortsDesign1A = new PIXI.Sprite(textures["shorts_1_a.png"]);
    let shortsDesign1B = new PIXI.Sprite(textures["shorts_1_b.png"]);
    let shortsDesign1C = new PIXI.Sprite(textures["shorts_1_c.png"]);
    let shortsDesign2A = new PIXI.Sprite(textures["shorts_2_a.png"]);
    let shortsDesign2B = new PIXI.Sprite(textures["shorts_2_b.png"]);
    let shortsDesign3 = new PIXI.Sprite(textures["shorts_3.png"]);
    let shortsDesign4A = new PIXI.Sprite(textures["shorts_4_a.png"]);
    let shortsDesign4B = new PIXI.Sprite(textures["shorts_4_b.png"]);
    let shortsDesign5 = new PIXI.Sprite(textures["shorts_5.png"]);
    let shortsDesign6A = new PIXI.Sprite(textures["shorts_6_a.png"]);
    let shortsDesign6B = new PIXI.Sprite(textures["shorts_6_b.png"]);
    let shortsDesign7A = new PIXI.Sprite(textures["shorts_7_a.png"]);
    let shortsDesign7B = new PIXI.Sprite(textures["shorts_7_b.png"]);
    let shortsDesign8A = new PIXI.Sprite(textures["shorts_8_a.png"]);
    let shortsDesign8B = new PIXI.Sprite(textures["shorts_8_b.png"]);
    let shortsDesign9A = new PIXI.Sprite(textures["shorts_9_a.png"]);
    let shortsDesign9B = new PIXI.Sprite(textures["shorts_9_b.png"]);
    let shortsDesign9C = new PIXI.Sprite(textures["shorts_9_c.png"]);
    let tightsBase = new PIXI.Sprite(textures["tights_base.png"]);
    let tightsDesign1A = new PIXI.Sprite(textures["tights_1_a.png"]);
    let tightsDesign1B = new PIXI.Sprite(textures["tights_1_b.png"]);
    let tightsDesign2 = new PIXI.Sprite(textures["tights_2.png"]);
    let tightsDesign3 = new PIXI.Sprite(textures["tights_3.png"]);
    let tightsDesign4A = new PIXI.Sprite(textures["tights_4_a.png"]);
    let tightsDesign4B = new PIXI.Sprite(textures["tights_4_b.png"]);
    let tightsDesign5A = new PIXI.Sprite(textures["tights_5_a.png"]);
    let tightsDesign5B = new PIXI.Sprite(textures["tights_5_b.png"]);
    let tightsDesign6 = new PIXI.Sprite(textures["tights_6.png"]);
    let tightsDesign7A = new PIXI.Sprite(textures["tights_7_a.png"]);
    let tightsDesign7B = new PIXI.Sprite(textures["tights_7_b.png"]);
    let tightsDesign8 = new PIXI.Sprite(textures["tights_8.png"]);
    let tightsDesign9A = new PIXI.Sprite(textures["tights_9_a.png"]);
    let tightsDesign9B = new PIXI.Sprite(textures["tights_9_b.png"]);
    let tightsDesign10 = new PIXI.Sprite(textures["tights_10.png"]);
    let tightsDesign11A = new PIXI.Sprite(textures["tights_11_a.png"]);
    let tightsDesign11B = new PIXI.Sprite(textures["tights_11_b.png"]);
    let tightsDesign12 = new PIXI.Sprite(textures["tights_12.png"]);
    let tightsDesign13 = new PIXI.Sprite(textures["tights_13.png"]);
    let tightsDesign14 = new PIXI.Sprite(textures["tights_14.png"]);
    let tightsDesign15 = new PIXI.Sprite(textures["tights_15.png"]);
    let tightsDesign16 = new PIXI.Sprite(textures["tights_16.png"]);
    let tightsDesign17A = new PIXI.Sprite(textures["tights_17_a.png"]);
    let tightsDesign17B = new PIXI.Sprite(textures["tights_17_b.png"]);
    let tightsDesign18 = new PIXI.Sprite(textures["tights_18.png"]);
    let tightsDesign19A = new PIXI.Sprite(textures["tights_19_a.png"]);
    let tightsDesign19B = new PIXI.Sprite(textures["tights_19_b.png"]);
    let tightsDesign20A = new PIXI.Sprite(textures["tights_20_a.png"]);
    let tightsDesign20B = new PIXI.Sprite(textures["tights_20_b.png"]);
    let tightsDesign20C = new PIXI.Sprite(textures["tights_20_c.png"]);
    let tightsDesign21A = new PIXI.Sprite(textures["tights_21_a.png"]);
    let tightsDesign21B = new PIXI.Sprite(textures["tights_21_b.png"]);
    let tightsDesign21C = new PIXI.Sprite(textures["tights_21_c.png"]);
    let tightsDesign22 = new PIXI.Sprite(textures["tights_22.png"]);
    let tightsDesign23A = new PIXI.Sprite(textures["tights_23_a.png"]);
    let tightsDesign23B = new PIXI.Sprite(textures["tights_23_b.png"]);
    let tightsDesign24A = new PIXI.Sprite(textures["tights_24_a.png"]);
    let tightsDesign24B = new PIXI.Sprite(textures["tights_24_b.png"]);
    let tightsDesign24C = new PIXI.Sprite(textures["tights_24_c.png"]);
    let tightsDesign25A = new PIXI.Sprite(textures["tights_25_a.png"]);
    let tightsDesign25B = new PIXI.Sprite(textures["tights_25_b.png"]);
    let tightsDesign25C = new PIXI.Sprite(textures["tights_25_c.png"]);
    let hairDesign0 = new PIXI.Sprite(textures["hair_0.png"]);
    let hairDesign1 = new PIXI.Sprite(textures["hair_1.png"]);
    let hairDesign2 = new PIXI.Sprite(textures["hair_2.png"]);
    let hairDesign3 = new PIXI.Sprite(textures["hair_3.png"]);
    let hairDesign4 = new PIXI.Sprite(textures["hair_4.png"]);
    let hairDesign5A = new PIXI.Sprite(textures["hair_5_a.png"]);
    let hairDesign5B = new PIXI.Sprite(textures["hair_5_b.png"]);
    let hairDesign6A = new PIXI.Sprite(textures["hair_6_a.png"]);
    let hairDesign6B = new PIXI.Sprite(textures["hair_6_b.png"]);
    let hairDesign7A = new PIXI.Sprite(textures["hair_7_a.png"]);
    let hairDesign7B = new PIXI.Sprite(textures["hair_7_b.png"]);
    let hairDesign8 = new PIXI.Sprite(textures["hair_8.png"]);
    let hairDesign9 = new PIXI.Sprite(textures["hair_9.png"]);
    let hairDesign10 = new PIXI.Sprite(textures["hair_10.png"]);
    let hairDesign11 = new PIXI.Sprite(textures["hair_11.png"]);
    let hairDesign12 = new PIXI.Sprite(textures["hair_12.png"]);
    let hairDesign13 = new PIXI.Sprite(textures["hair_13.png"]);
    let hairDesign14 = new PIXI.Sprite(textures["hair_14.png"]);
    let hairDesign15 = new PIXI.Sprite(textures["hair_15.png"]);
    let hairDesign16 = new PIXI.Sprite(textures["hair_16.png"]);
    let hairDesign17 = new PIXI.Sprite(textures["hair_17.png"]);
    let hairDesign18 = new PIXI.Sprite(textures["hair_18.png"]);
    let hairDesign19 = new PIXI.Sprite(textures["hair_19.png"]);
    let hairDesign20A = new PIXI.Sprite(textures["hair_20_a.png"]);
    let hairDesign20B = new PIXI.Sprite(textures["hair_20_b.png"]);
    let hairDesign21 = new PIXI.Sprite(textures["hair_21.png"]);
    let hairDesign22 = new PIXI.Sprite(textures["hair_22.png"]);
    let hairDesign23 = new PIXI.Sprite(textures["hair_23.png"]);
    let hairDesign24A = new PIXI.Sprite(textures["hair_24_a.png"]);
    let hairDesign24B = new PIXI.Sprite(textures["hair_24_b.png"]);
    let hairDesign25 = new PIXI.Sprite(textures["hair_25.png"]);
    let hairDesign26 = new PIXI.Sprite(textures["hair_26.png"]);
    let hairDesign27 = new PIXI.Sprite(textures["hair_27.png"]);
    let hairDesign28 = new PIXI.Sprite(textures["hair_28.png"]);
    let hairDesign29 = new PIXI.Sprite(textures["hair_29.png"]);
    let hairDesign30 = new PIXI.Sprite(textures["hair_30.png"]);
    let hairDesign31 = new PIXI.Sprite(textures["hair_31.png"]);
    let hairDesign32 = new PIXI.Sprite(textures["hair_32.png"]);
    let hairDesign33 = new PIXI.Sprite(textures["hair_33.png"]);
    let hairDesign34 = new PIXI.Sprite(textures["hair_34.png"]);
    let hairDesign35 = new PIXI.Sprite(textures["hair_35.png"]);
    let hairDesign36A = new PIXI.Sprite(textures["hair_36_a.png"]);
    let hairDesign36B = new PIXI.Sprite(textures["hair_36_b.png"]);
    // Streaks
    let hairDesign4Streak = new PIXI.Sprite(textures["hair_4_streak.png"]);
    let hairDesign10Streak = new PIXI.Sprite(textures["hair_10_streak.png"]);
    let hairDesign12Streak = new PIXI.Sprite(textures["hair_12_streak.png"]);
    let hairDesign18Streak = new PIXI.Sprite(textures["hair_18_streak.png"]);
    let hairDesign23Streak = new PIXI.Sprite(textures["hair_23_streak.png"]);
    let hairDesign27Streak = new PIXI.Sprite(textures["hair_27_streak.png"]);
    let hairDesign29Streak = new PIXI.Sprite(textures["hair_29_streak.png"]);
    let hairDesign31Streak = new PIXI.Sprite(textures["hair_31_streak.png"]);
    let hairDesign34Streak = new PIXI.Sprite(textures["hair_34_streak.png"]);
    let shoesDesign1 = new PIXI.Sprite(textures["shoes_1.png"]);
    let shoesDesign1A = new PIXI.Sprite(textures["shoes_1_a.png"]);
    let shoesDesign2 = new PIXI.Sprite(textures["shoes_2.png"]);
    let shoesDesign2A = new PIXI.Sprite(textures["shoes_2_a.png"]);
    let shoesDesign2B = new PIXI.Sprite(textures["shoes_2_b.png"]);
    let shoesDesign3 = new PIXI.Sprite(textures["shoes_3.png"]);
    let shoesDesign3A = new PIXI.Sprite(textures["shoes_3_a.png"]);
    let shoesDesign4 = new PIXI.Sprite(textures["shoes_4.png"]);
    let shoesDesign4A = new PIXI.Sprite(textures["shoes_4_a.png"]);
    let shoesDesign5 = new PIXI.Sprite(textures["shoes_5.png"]);
    let shoesDesign5A = new PIXI.Sprite(textures["shoes_5_a.png"]);
    let shoesDesign6 = new PIXI.Sprite(textures["shoes_6.png"]);
    let shoesDesign6A = new PIXI.Sprite(textures["shoes_6_a.png"]);
    let shoesDesign7 = new PIXI.Sprite(textures["shoes_7.png"]);
    let shoesDesign7A = new PIXI.Sprite(textures["shoes_7_a.png"]);
    let shoesDesign8 = new PIXI.Sprite(textures["shoes_8.png"]);
    let shoesDesign8A = new PIXI.Sprite(textures["shoes_8_a.png"]);
    let shoesDesign9 = new PIXI.Sprite(textures["shoes_9.png"]);
    let shoesDesign9A = new PIXI.Sprite(textures["shoes_9_a.png"]);
    let shoesDesign10 = new PIXI.Sprite(textures["shoes_10.png"]);
    let shoesDesign10A = new PIXI.Sprite(textures["shoes_10_a.png"]);
    let shoesDesign11 = new PIXI.Sprite(textures["shoes_11.png"]);
    let shoesDesign11A = new PIXI.Sprite(textures["shoes_11_a.png"]);
    let shoesDesign12 = new PIXI.Sprite(textures["shoes_12.png"]);
    let shoesDesign12A = new PIXI.Sprite(textures["shoes_12_a.png"]);
    let shoesDesign12B = new PIXI.Sprite(textures["shoes_12_b.png"]);
    let shoesDesign13 = new PIXI.Sprite(textures["shoes_13.png"]);
    let shoesDesign13A = new PIXI.Sprite(textures["shoes_13_a.png"]);
    let shoesDesign14A = new PIXI.Sprite(textures["shoes_14_a.png"]);
    let shoesDesign15A = new PIXI.Sprite(textures["shoes_15_a.png"]);
    let shoesDesign16 = new PIXI.Sprite(textures["shoes_16.png"]);
    let shoesDesign16A = new PIXI.Sprite(textures["shoes_16_a.png"]);
    let shoesDesign17 = new PIXI.Sprite(textures["shoes_17.png"]);
    let shoesDesign17A = new PIXI.Sprite(textures["shoes_17_a.png"]);
    let shoesDesign18 = new PIXI.Sprite(textures["shoes_18.png"]);
    let shoesDesign18A = new PIXI.Sprite(textures["shoes_18_a.png"]);
    let shoesDesign19A = new PIXI.Sprite(textures["shoes_19_a.png"]);
    let shoesDesign20A = new PIXI.Sprite(textures["shoes_20_a.png"]);
    let topDesign1 = new PIXI.Sprite(textures["top_1.png"]);
    let topDesign1A = new PIXI.Sprite(textures["top_1_a.png"]);
    let topDesign2 = new PIXI.Sprite(textures["top_2.png"]);
    let topDesign2A = new PIXI.Sprite(textures["top_2_a.png"]);
    let topDesign3 = new PIXI.Sprite(textures["top_3.png"]);
    let topDesign4 = new PIXI.Sprite(textures["top_4.png"]);
    let topDesign4A = new PIXI.Sprite(textures["top_4_a.png"]);
    let topDesign5 = new PIXI.Sprite(textures["top_5.png"]);
    let topDesign5A = new PIXI.Sprite(textures["top_5_a.png"]);
    let topDesign6 = new PIXI.Sprite(textures["top_6.png"]);
    let topDesign6A = new PIXI.Sprite(textures["top_6_a.png"]);
    let topDesign6B = new PIXI.Sprite(textures["top_6_b.png"]);
    let topDesign7 = new PIXI.Sprite(textures["top_7.png"]);
    let topDesign8 = new PIXI.Sprite(textures["top_8.png"]);
    let topDesign9 = new PIXI.Sprite(textures["top_9.png"]);
    let topDesign10 = new PIXI.Sprite(textures["top_10.png"]);
    let topDesign11 = new PIXI.Sprite(textures["top_11.png"]);
    let topDesign12 = new PIXI.Sprite(textures["top_12.png"]);
    let topDesign12A = new PIXI.Sprite(textures["top_12_a.png"]);
    let topDesign13A = new PIXI.Sprite(textures["top_13_a.png"]);
    let topDesign14 = new PIXI.Sprite(textures["top_14.png"]);
    let topDesign15 = new PIXI.Sprite(textures["top_15.png"]);
    let topDesign15A = new PIXI.Sprite(textures["top_15_a.png"]);
    let topDesign16 = new PIXI.Sprite(textures["top_16.png"]);
    let topDesign16A = new PIXI.Sprite(textures["top_16_a.png"]);
    let topDesign16B = new PIXI.Sprite(textures["top_16_b.png"]);
    let topDesign17 = new PIXI.Sprite(textures["top_17.png"]);
    let topDesign18 = new PIXI.Sprite(textures["top_18.png"]);
    let topDesign18A = new PIXI.Sprite(textures["top_18_a.png"]);
    let topDesign19A = new PIXI.Sprite(textures["top_19_a.png"]);
    let topDesign20A = new PIXI.Sprite(textures["top_20_a.png"]);
    let topDesign21 = new PIXI.Sprite(textures["top_21.png"]);
    let topDesign21A = new PIXI.Sprite(textures["top_21_a.png"]);
    let topDesign22A = new PIXI.Sprite(textures["top_22_a.png"]);
    let topDesign23A = new PIXI.Sprite(textures["top_23_a.png"]);
    let topDesign24A = new PIXI.Sprite(textures["top_24_a.png"]);
    let topDesign25A = new PIXI.Sprite(textures["top_25_a.png"]);
    let topDesign26A = new PIXI.Sprite(textures["top_26_a.png"]);
    let topDesign27A = new PIXI.Sprite(textures["top_27_a.png"]);
    let topDesign28A = new PIXI.Sprite(textures["top_28_a.png"]);
    let topDesign29 = new PIXI.Sprite(textures["top_29.png"]);
    let topDesign29A = new PIXI.Sprite(textures["top_29_a.png"]);
    let topDesign30A = new PIXI.Sprite(textures["top_30_a.png"]);
    let topDesign31 = new PIXI.Sprite(textures["top_31.png"]);
    let topDesign31A = new PIXI.Sprite(textures["top_31_a.png"]);
    let topDesign31B = new PIXI.Sprite(textures["top_31_b.png"]);
    let topDesign32A = new PIXI.Sprite(textures["top_32_a.png"]);
    let topDesign33 = new PIXI.Sprite(textures["top_33.png"]);
    let topDesign33A = new PIXI.Sprite(textures["top_33_a.png"]);
    let topDesign34A = new PIXI.Sprite(textures["top_34_a.png"]);
    let topDesign35A = new PIXI.Sprite(textures["top_35_a.png"]);
    let topDesign36 = new PIXI.Sprite(textures["top_36.png"]);
    let topDesign37A = new PIXI.Sprite(textures["top_37_a.png"]);
    let topDesign37B = new PIXI.Sprite(textures["top_37_b.png"]);
    let topDesign37C = new PIXI.Sprite(textures["top_37_c.png"]);
    let topDesign38 = new PIXI.Sprite(textures["top_38.png"]);
    let topDesign39 = new PIXI.Sprite(textures["top_39.png"]);
    let topDesign40A = new PIXI.Sprite(textures["top_40_a.png"]);
    let topDesign40B = new PIXI.Sprite(textures["top_40_b.png"]);
    let topDesign41A = new PIXI.Sprite(textures["top_41_a.png"]);
    let topDesign41B = new PIXI.Sprite(textures["top_41_b.png"]);
    let topDesign42 = new PIXI.Sprite(textures["top_42.png"]);
    let topDesign43 = new PIXI.Sprite(textures["top_43.png"]);
    let topDesign44 = new PIXI.Sprite(textures["top_44.png"]);
    let topDesign45A = new PIXI.Sprite(textures["top_45_a.png"]);
    let topDesign45B = new PIXI.Sprite(textures["top_45_b.png"]);
    let topDesign46 = new PIXI.Sprite(textures["top_46.png"]);
    let topDesign47A = new PIXI.Sprite(textures["top_47_a.png"]);
    let topDesign47B = new PIXI.Sprite(textures["top_47_b.png"]);
    let topDesign48A = new PIXI.Sprite(textures["top_48_a.png"]);
    let topDesign48B = new PIXI.Sprite(textures["top_48_b.png"]);
    let topDesign49A = new PIXI.Sprite(textures["top_49_a.png"]);
    let topDesign49B = new PIXI.Sprite(textures["top_49_b.png"]);
    let topDesign50A = new PIXI.Sprite(textures["top_50_a.png"]);
    let topDesign50B = new PIXI.Sprite(textures["top_50_b.png"]);
    let topDesign50C = new PIXI.Sprite(textures["top_50_c.png"]);
    let topDesign50D = new PIXI.Sprite(textures["top_50_d.png"]);
    let topDesign51 = new PIXI.Sprite(textures["top_51.png"]);
    let topDesign52 = new PIXI.Sprite(textures["top_52.png"]);
    let elbowDesign1 = new PIXI.Sprite(textures["elbow_1.png"]);
    let elbowDesign2 = new PIXI.Sprite(textures["elbow_2.png"]);
    let elbowDesign3 = new PIXI.Sprite(textures["elbow_3.png"]);
    let elbowDesign4 = new PIXI.Sprite(textures["elbow_4.png"]);
    let elbowDesign5 = new PIXI.Sprite(textures["elbow_5.png"]);
    let elbowDesign6 = new PIXI.Sprite(textures["elbow_6.png"]);
    let elbowDesign7 = new PIXI.Sprite(textures["elbow_7.png"]);
    let elbowDesign7A = new PIXI.Sprite(textures["elbow_7_a.png"]);
    let elbowDesign8 = new PIXI.Sprite(textures["elbow_8.png"]);
    let elbowDesign9 = new PIXI.Sprite(textures["elbow_9.png"]);
    let elbowDesign10 = new PIXI.Sprite(textures["elbow_10.png"]);
    let facialHairDesign1 = new PIXI.Sprite(textures["facial_hair_1.png"]);
    let facialHairDesign2 = new PIXI.Sprite(textures["facial_hair_2.png"]);
    let facialHairDesign3 = new PIXI.Sprite(textures["facial_hair_3.png"]);
    let facialHairDesign4 = new PIXI.Sprite(textures["facial_hair_4.png"]);
    let facialHairDesign5 = new PIXI.Sprite(textures["facial_hair_5.png"]);
    let facialHairDesign6 = new PIXI.Sprite(textures["facial_hair_6.png"]);
    let facialHairDesign7 = new PIXI.Sprite(textures["facial_hair_7.png"]);
    let facialHairDesign8 = new PIXI.Sprite(textures["facial_hair_8.png"]);
    let facialHairDesign9 = new PIXI.Sprite(textures["facial_hair_9.png"]);
    let facialHairDesign10 = new PIXI.Sprite(textures["facial_hair_10.png"]);
    let facialHairDesign11 = new PIXI.Sprite(textures["facial_hair_11.png"]);
    let facialHairDesign12 = new PIXI.Sprite(textures["facial_hair_12.png"]);
    let facialHairDesign13 = new PIXI.Sprite(textures["facial_hair_13.png"]);
    let facialHairDesign14 = new PIXI.Sprite(textures["facial_hair_14.png"]);
    let facialHairDesign15 = new PIXI.Sprite(textures["facial_hair_15.png"]);
    let facialHairDesign16 = new PIXI.Sprite(textures["facial_hair_16.png"]);
    let facialHairDesign17 = new PIXI.Sprite(textures["facial_hair_17.png"]);
    let facialHairDesign18 = new PIXI.Sprite(textures["facial_hair_18.png"]);
    let facialHairDesign19 = new PIXI.Sprite(textures["facial_hair_19.png"]);
    let facialHairDesign20 = new PIXI.Sprite(textures["facial_hair_20.png"]);
    let emptySprite = new PIXI.Sprite(textures["empty_sprite.png"]);
    let accessoryDesign1A = new PIXI.Sprite(textures["accessory_1_a.png"]);
    let accessoryDesign1B = new PIXI.Sprite(textures["accessory_1_b.png"]);
    let accessoryDesign1C = new PIXI.Sprite(textures["accessory_1_c.png"]);
    let accessoryDesign2A = new PIXI.Sprite(textures["accessory_2_a.png"]);
    let accessoryDesign2B = new PIXI.Sprite(textures["accessory_2_b.png"]);
    let accessoryDesign3A = new PIXI.Sprite(textures["accessory_3_a.png"]);
    let accessoryDesign3B = new PIXI.Sprite(textures["accessory_3_b.png"]);
    let accessoryDesign3C = new PIXI.Sprite(textures["accessory_3_c.png"]);
    let accessoryDesign3D = new PIXI.Sprite(textures["accessory_3_d.png"]);
    let accessoryDesign4 = new PIXI.Sprite(textures["accessory_4.png"]);
    let accessoryDesign5 = new PIXI.Sprite(textures["accessory_5.png"]);
    let accessoryDesign5A = new PIXI.Sprite(textures["accessory_5_a.png"]);
    let accessoryDesign6 = new PIXI.Sprite(textures["accessory_6.png"]);
    let accessoryDesign7 = new PIXI.Sprite(textures["accessory_7.png"]);
    let accessoryDesign7A = new PIXI.Sprite(textures["accessory_7_a.png"]);
    let accessoryDesign8 = new PIXI.Sprite(textures["accessory_8.png"]);
    let accessoryDesign8A = new PIXI.Sprite(textures["accessory_8_a.png"]);
    let accessoryDesign8B = new PIXI.Sprite(textures["accessory_8_b.png"]);
    let accessoryDesign9 = new PIXI.Sprite(textures["accessory_9.png"]);
    let accessoryDesign10 = new PIXI.Sprite(textures["accessory_10.png"]);
    let accessoryDesign11 = new PIXI.Sprite(textures["accessory_11.png"]);
    let accessoryDesign11A = new PIXI.Sprite(textures["accessory_11_a.png"]);
    let accessoryDesign12A = new PIXI.Sprite(textures["accessory_12_a.png"]);
    let accessoryDesign13 = new PIXI.Sprite(textures["accessory_13.png"]);
    let accessoryDesign14A = new PIXI.Sprite(textures["accessory_14_a.png"]);
    let accessoryDesign14B = new PIXI.Sprite(textures["accessory_14_b.png"]);
    let accessoryDesign15 = new PIXI.Sprite(textures["accessory_15.png"]);
    let accessoryDesign16A = new PIXI.Sprite(textures["accessory_16_a.png"]);
    let accessoryDesign16B = new PIXI.Sprite(textures["accessory_16_b.png"]);
    let accessoryDesign17 = new PIXI.Sprite(textures["accessory_17.png"]);
    let accessoryDesign18 = new PIXI.Sprite(textures["accessory_18.png"]);
    let accessoryDesign19 = new PIXI.Sprite(textures["accessory_19.png"]);
    let accessoryDesign20 = new PIXI.Sprite(textures["accessory_20.png"]);
    let accessoryDesign21A = new PIXI.Sprite(textures["accessory_21_a.png"]);
    let accessoryDesign21B = new PIXI.Sprite(textures["accessory_21_b.png"]);
    let accessoryDesign22A = new PIXI.Sprite(textures["accessory_22_a.png"]);
    let accessoryDesign22B = new PIXI.Sprite(textures["accessory_22_b.png"]);
    let accessoryDesign22C = new PIXI.Sprite(textures["accessory_22_c.png"]);
    let accessoryDesign23A = new PIXI.Sprite(textures["accessory_23_a.png"]);
    let accessoryDesign23B = new PIXI.Sprite(textures["accessory_23_b.png"]);
    let accessoryDesign24A = new PIXI.Sprite(textures["accessory_24_a.png"]);
    let accessoryDesign24B = new PIXI.Sprite(textures["accessory_24_b.png"]);
    let accessoryDesign25A = new PIXI.Sprite(textures["accessory_25_a.png"]);
    let accessoryDesign25B = new PIXI.Sprite(textures["accessory_25_b.png"]);
    let accessoryDesign26A = new PIXI.Sprite(textures["accessory_26_a.png"]);
    let accessoryDesign26B = new PIXI.Sprite(textures["accessory_26_b.png"]);
    let accessoryDesign27A = new PIXI.Sprite(textures["accessory_27_a.png"]);
    let accessoryDesign27B = new PIXI.Sprite(textures["accessory_27_b.png"]);
    let accessoryDesign28A = new PIXI.Sprite(textures["accessory_28_a.png"]);
    let accessoryDesign29A = new PIXI.Sprite(textures["accessory_29_a.png"]);
    let accessoryDesign29B = new PIXI.Sprite(textures["accessory_29_b.png"]);
    let accessoryDesign30A = new PIXI.Sprite(textures["accessory_30_a.png"]);
    let accessoryDesign30B = new PIXI.Sprite(textures["accessory_30_b.png"]);
    let accessoryDesign31A = new PIXI.Sprite(textures["accessory_31_a.png"]);
    let accessoryDesign31B = new PIXI.Sprite(textures["accessory_31_b.png"]);
    let accessoryDesign32Base = new PIXI.Sprite(textures["accessory_32.png"]);
    let accessoryDesign32A = new PIXI.Sprite(textures["accessory_32_a.png"]);
    let accessoryDesign32B = new PIXI.Sprite(textures["accessory_32_b.png"]);
    let accessoryDesign32C = new PIXI.Sprite(textures["accessory_32_c.png"]);
    let accessoryDesign33A = new PIXI.Sprite(textures["accessory_33_a.png"]);
    let accessoryDesign33B = new PIXI.Sprite(textures["accessory_33_b.png"]);
    let accessoryDesign34A = new PIXI.Sprite(textures["accessory_34_a.png"]);
    let accessoryDesign34B = new PIXI.Sprite(textures["accessory_34_b.png"]);
    let accessoryDesign34C = new PIXI.Sprite(textures["accessory_34_c.png"]);
    let accessoryDesign35A = new PIXI.Sprite(textures["accessory_35_a.png"]);
    let accessoryDesign35B = new PIXI.Sprite(textures["accessory_35_b.png"]);
    let accessoryDesign35C = new PIXI.Sprite(textures["accessory_35_c.png"]);
    let accessoryDesign36A = new PIXI.Sprite(textures["accessory_36_a.png"]);
    let accessoryDesign36B = new PIXI.Sprite(textures["accessory_36_b.png"]);
    let accessoryDesign36C = new PIXI.Sprite(textures["accessory_36_c.png"]);
    let accessoryDesign37A = new PIXI.Sprite(textures["accessory_37_a.png"]);
    let accessoryDesign37B = new PIXI.Sprite(textures["accessory_37_b.png"]);
    let accessoryDesign37C = new PIXI.Sprite(textures["accessory_37_c.png"]);
    let accessoryDesign38A = new PIXI.Sprite(textures["accessory_38_a.png"]);
    let accessoryDesign38B = new PIXI.Sprite(textures["accessory_38_b.png"]);
    let accessoryDesign38C = new PIXI.Sprite(textures["accessory_38_c.png"]);
    let accessoryDesign39A = new PIXI.Sprite(textures["accessory_39_a.png"]);
    let accessoryDesign39B = new PIXI.Sprite(textures["accessory_39_b.png"]);
    let accessoryDesign39C = new PIXI.Sprite(textures["accessory_39_c.png"]);
    let accessoryDesign39D = new PIXI.Sprite(textures["accessory_39_d.png"]);
    let accessoryDesign40A = new PIXI.Sprite(textures["accessory_40_a.png"]);
    let accessoryDesign40B = new PIXI.Sprite(textures["accessory_40_b.png"]);
    let accessoryDesign40C = new PIXI.Sprite(textures["accessory_40_c.png"]);
    let accessoryDesign41A = new PIXI.Sprite(textures["accessory_41_a.png"]);
    let accessoryDesign41B = new PIXI.Sprite(textures["accessory_41_b.png"]);
    let accessoryDesign42A = new PIXI.Sprite(textures["accessory_42_a.png"]);
    let accessoryDesign42B = new PIXI.Sprite(textures["accessory_42_b.png"]);
    let accessoryDesign42C = new PIXI.Sprite(textures["accessory_42_c.png"]);
    let accessoryDesign43A = new PIXI.Sprite(textures["accessory_43_a.png"]);
    let accessoryDesign43B = new PIXI.Sprite(textures["accessory_43_b.png"]);
    let accessoryDesign44A = new PIXI.Sprite(textures["accessory_44_a.png"]);
    let accessoryDesign44B = new PIXI.Sprite(textures["accessory_44_b.png"]);
    let accessoryDesign45A = new PIXI.Sprite(textures["accessory_45_a.png"]);
    let accessoryDesign46A = new PIXI.Sprite(textures["accessory_46_a.png"]);
    let accessoryDesign46B = new PIXI.Sprite(textures["accessory_46_b.png"]);
    let accessoryDesign47A = new PIXI.Sprite(textures["accessory_47_a.png"]);
    let accessoryDesign48A = new PIXI.Sprite(textures["accessory_48_a.png"]);
    let accessoryDesign48B = new PIXI.Sprite(textures["accessory_48_b.png"]);
    let accessoryDesign48C = new PIXI.Sprite(textures["accessory_48_c.png"]);
    let accessoryDesign49A = new PIXI.Sprite(textures["accessory_49_a.png"]);
    let accessoryDesign49B = new PIXI.Sprite(textures["accessory_49_b.png"]);
    let accessoryDesign49C = new PIXI.Sprite(textures["accessory_49_c.png"]);
    let accessoryDesign49D = new PIXI.Sprite(textures["accessory_49_d.png"]);
    let accessoryDesign50A = new PIXI.Sprite(textures["accessory_50_a.png"]);
    let accessoryDesign50B = new PIXI.Sprite(textures["accessory_50_b.png"]);
    let accessoryDesign50C = new PIXI.Sprite(textures["accessory_50_c.png"]);
    let accessoryDesign50D = new PIXI.Sprite(textures["accessory_50_d.png"]);
    let accessoryDesign51A = new PIXI.Sprite(textures["accessory_51_a.png"]);
    let accessoryDesign52A = new PIXI.Sprite(textures["accessory_52_a.png"]);
    let accessoryDesign53A = new PIXI.Sprite(textures["accessory_53_a.png"]);
    let accessoryDesign53B = new PIXI.Sprite(textures["accessory_53_b.png"]);
    let accessoryDesign53C = new PIXI.Sprite(textures["accessory_53_c.png"]);
    let accessoryDesign54A = new PIXI.Sprite(textures["accessory_54_a.png"]);
    let accessoryDesign54B = new PIXI.Sprite(textures["accessory_54_b.png"]);
    let accessoryDesign55A = new PIXI.Sprite(textures["accessory_55_a.png"]);
    let accessoryDesign55B = new PIXI.Sprite(textures["accessory_55_b.png"]);
    let accessoryDesign55C = new PIXI.Sprite(textures["accessory_55_c.png"]);
    let accessoryDesign55D = new PIXI.Sprite(textures["accessory_55_d.png"]);
    let accessoryDesign56A = new PIXI.Sprite(textures["accessory_56_a.png"]);
    let accessoryDesign56B = new PIXI.Sprite(textures["accessory_56_b.png"]);
    let accessoryDesign57A = new PIXI.Sprite(textures["accessory_57_a.png"]);
    let accessoryDesign57B = new PIXI.Sprite(textures["accessory_57_b.png"]);
    let accessoryDesign58A = new PIXI.Sprite(textures["accessory_58_a.png"]);
    let accessoryDesign58B = new PIXI.Sprite(textures["accessory_58_b.png"]);
    let accessoryDesign59A = new PIXI.Sprite(textures["accessory_59_a.png"]);
    let accessoryDesign59B = new PIXI.Sprite(textures["accessory_59_b.png"]);
    let accessoryDesign59C = new PIXI.Sprite(textures["accessory_59_c.png"]);
    let accessoryDesign59D = new PIXI.Sprite(textures["accessory_59_d.png"]);
    let accessoryDesign60A = new PIXI.Sprite(textures["accessory_60_a.png"]);
    let accessoryDesign60B = new PIXI.Sprite(textures["accessory_60_b.png"]);
    let accessoryDesign60C = new PIXI.Sprite(textures["accessory_60_c.png"]);
    let accessoryDesign61A = new PIXI.Sprite(textures["accessory_61_a.png"]);
    let accessoryDesign61B = new PIXI.Sprite(textures["accessory_61_b.png"]);
    let accessoryDesign61C = new PIXI.Sprite(textures["accessory_61_c.png"]);
    let accessoryDesign62A = new PIXI.Sprite(textures["accessory_62_a.png"]);
    let accessoryDesign62B = new PIXI.Sprite(textures["accessory_62_b.png"]);
    let accessoryDesign62C = new PIXI.Sprite(textures["accessory_62_c.png"]);
    let accessoryDesign63A = new PIXI.Sprite(textures["accessory_63_a.png"]);
    let accessoryDesign63B = new PIXI.Sprite(textures["accessory_63_b.png"]);
    let accessoryDesign64A = new PIXI.Sprite(textures["accessory_64_a.png"]);
    let accessoryDesign64B = new PIXI.Sprite(textures["accessory_64_b.png"]);
    let accessoryDesign65A = new PIXI.Sprite(textures["accessory_65_a.png"]);
    let accessoryDesign65B = new PIXI.Sprite(textures["accessory_65_b.png"]);
    let accessoryDesign65C = new PIXI.Sprite(textures["accessory_65_c.png"]);
    let accessoryDesign66A = new PIXI.Sprite(textures["accessory_66_a.png"]);
    let accessoryDesign66B = new PIXI.Sprite(textures["accessory_66_b.png"]);
    let accessoryDesign67A = new PIXI.Sprite(textures["accessory_67_a.png"]);
    let accessoryDesign67B = new PIXI.Sprite(textures["accessory_67_b.png"]);
    let accessoryDesign68A = new PIXI.Sprite(textures["accessory_68_a.png"]);
    let accessoryDesign68B = new PIXI.Sprite(textures["accessory_68_b.png"]);
    let accessoryDesign68C = new PIXI.Sprite(textures["accessory_68_c.png"]);
    let accessoryDesign68D = new PIXI.Sprite(textures["accessory_68_d.png"]);
    let accessoryDesign69A = new PIXI.Sprite(textures["accessory_69_a.png"]);
    let accessoryDesign70A = new PIXI.Sprite(textures["accessory_70_a.png"]);
    let accessoryDesign70B = new PIXI.Sprite(textures["accessory_70_b.png"]);
    let accessoryDesign71A = new PIXI.Sprite(textures["accessory_71_a.png"]);
    let accessoryDesign71B = new PIXI.Sprite(textures["accessory_71_b.png"]);
    let accessoryDesign71C = new PIXI.Sprite(textures["accessory_71_c.png"]);
    let accessoryDesign72A = new PIXI.Sprite(textures["accessory_72_a.png"]);
    let accessoryDesign72B = new PIXI.Sprite(textures["accessory_72_b.png"]);
    // Gloves
    let glovesDesign1 = new PIXI.Sprite(textures["gloves_1.png"]);
    let glovesDesign2A = new PIXI.Sprite(textures["gloves_2_a.png"]);
    let glovesDesign2B = new PIXI.Sprite(textures["gloves_2_b.png"]);
    let glovesDesign3A = new PIXI.Sprite(textures["gloves_3_a.png"]);
    let glovesDesign3B = new PIXI.Sprite(textures["gloves_3_b.png"]);
    let glovesDesign4A = new PIXI.Sprite(textures["gloves_4_a.png"]);
    let glovesDesign4B = new PIXI.Sprite(textures["gloves_4_b.png"]);
    let glovesDesign5A = new PIXI.Sprite(textures["gloves_5_a.png"]);
    let glovesDesign5B = new PIXI.Sprite(textures["gloves_5_b.png"]);
    let glovesDesign6A = new PIXI.Sprite(textures["gloves_6_a.png"]);
    let glovesDesign6B = new PIXI.Sprite(textures["gloves_6_b.png"]);
    // Glasses
    let glassesDesign2 = new PIXI.Sprite(textures["glasses_2.png"]);
    let glassesDesign3 = new PIXI.Sprite(textures["glasses_3.png"]);
    let glassesDesign4 = new PIXI.Sprite(textures["glasses_4.png"]);
    let glassesDesign5 = new PIXI.Sprite(textures["glasses_5.png"]);
    let glassesDesign6 = new PIXI.Sprite(textures["glasses_6.png"]);
    let glassesDesign7A = new PIXI.Sprite(textures["glasses_7_a.png"]);
    let glassesDesign7B = new PIXI.Sprite(textures["glasses_7_b.png"]);
    let glassesDesign8A = new PIXI.Sprite(textures["glasses_8_a.png"]);
    let glassesDesign8B = new PIXI.Sprite(textures["glasses_8_b.png"]);
    // Wrist tapes
    let wristTape1 = new PIXI.Sprite(textures["wrist_tape_1.png"]);
    let wristTape2 = new PIXI.Sprite(textures["wrist_tape_2.png"]);
    let wristTape3 = new PIXI.Sprite(textures["wrist_tape_3.png"]);
    // Ties
    let ties1 = new PIXI.Sprite(textures["ties_1.png"]);
    let ties2 = new PIXI.Sprite(textures["ties_2.png"]);
    let ties3 = new PIXI.Sprite(textures["ties_3.png"]);
    let ties4 = new PIXI.Sprite(textures["ties_4.png"]);
    // Suits
    let suits1 = new PIXI.Sprite(textures["suits_1.png"]);
    let suits2 = new PIXI.Sprite(textures["suits_2.png"]);
    let suits3A = new PIXI.Sprite(textures["suits_3_a.png"]);
    let suits3B = new PIXI.Sprite(textures["suits_3_b.png"]);
    // Face paint
    let facepaint1 = new PIXI.Sprite(textures["facepaint_1.png"]);
    let facepaint2 = new PIXI.Sprite(textures["facepaint_2.png"]);
    let facepaint3 = new PIXI.Sprite(textures["facepaint_3.png"]);
    let facepaint4A = new PIXI.Sprite(textures["facepaint_4_a.png"]);
    let facepaint4B = new PIXI.Sprite(textures["facepaint_4_b.png"]);
    let facepaint5A = new PIXI.Sprite(textures["facepaint_5_a.png"]);
    let facepaint5B = new PIXI.Sprite(textures["facepaint_5_b.png"]);
    let facepaint6A = new PIXI.Sprite(textures["facepaint_6_a.png"]);
    let facepaint6B = new PIXI.Sprite(textures["facepaint_6_b.png"]);
    let facepaint7A = new PIXI.Sprite(textures["facepaint_7_a.png"]);
    let facepaint7B = new PIXI.Sprite(textures["facepaint_7_b.png"]);
    let facepaint7C = new PIXI.Sprite(textures["facepaint_7_c.png"]);
    let facepaint8A = new PIXI.Sprite(textures["facepaint_8_a.png"]);
    let facepaint8B = new PIXI.Sprite(textures["facepaint_8_b.png"]);
    let facepaint9A = new PIXI.Sprite(textures["facepaint_9_a.png"]);
    let facepaint9B = new PIXI.Sprite(textures["facepaint_9_b.png"]);
    let facepaint9C = new PIXI.Sprite(textures["facepaint_9_c.png"]);
    let facepaint10A = new PIXI.Sprite(textures["facepaint_10_a.png"]);
    let facepaint10B = new PIXI.Sprite(textures["facepaint_10_b.png"]);
    let facepaint11A = new PIXI.Sprite(textures["facepaint_11_a.png"]);
    let facepaint11B = new PIXI.Sprite(textures["facepaint_11_b.png"]);
    let facepaint12A = new PIXI.Sprite(textures["facepaint_12_a.png"]);
    let facepaint12B = new PIXI.Sprite(textures["facepaint_12_b.png"]);
    let facepaint2Female = new PIXI.Sprite(textures["facepaint_2_female.png"]);
    let facepaint3Female = new PIXI.Sprite(textures["facepaint_3_female.png"]);
    let facepaint4AFemale = new PIXI.Sprite(textures["facepaint_4_a_female.png"]);
    let facepaint4BFemale = new PIXI.Sprite(textures["facepaint_4_b_female.png"]);
    let facepaint5AFemale = new PIXI.Sprite(textures["facepaint_5_a_female.png"]);
    let facepaint5BFemale = new PIXI.Sprite(textures["facepaint_5_b_female.png"]);
    let facepaint6AFemale = new PIXI.Sprite(textures["facepaint_6_a_female.png"]);
    let facepaint6BFemale = new PIXI.Sprite(textures["facepaint_6_b_female.png"]);
    let facepaint7AFemale = new PIXI.Sprite(textures["facepaint_7_a_female.png"]);
    let facepaint8AFemale = new PIXI.Sprite(textures["facepaint_8_a_female.png"]);
    let facepaint8BFemale = new PIXI.Sprite(textures["facepaint_8_b_female.png"]);
    let facepaint9AFemale = new PIXI.Sprite(textures["facepaint_9_a_female.png"]);
    let facepaint9BFemale = new PIXI.Sprite(textures["facepaint_9_b_female.png"]);
    let facepaint9CFemale = new PIXI.Sprite(textures["facepaint_9_c_female.png"]);
    let facepaint10AFemale = new PIXI.Sprite(textures["facepaint_10_a_female.png"]);
    let facepaint10BFemale = new PIXI.Sprite(textures["facepaint_10_b_female.png"]);
    let facepaint11AFemale = new PIXI.Sprite(textures["facepaint_11_a_female.png"]);
    let facepaint11BFemale = new PIXI.Sprite(textures["facepaint_11_b_female.png"]);
    let facepaint12AFemale = new PIXI.Sprite(textures["facepaint_12_a_female.png"]);
    let facepaint12BFemale = new PIXI.Sprite(textures["facepaint_12_b_female.png"]);
    // Sports bras
    let sportsbraBasic = new PIXI.Sprite(textures["sports_bras_basic.png"]);
    let sportsbraLow = new PIXI.Sprite(textures["sports_bras_low.png"]);
    let sportsbraShort = new PIXI.Sprite(textures["sports_bras_short.png"]);
    let sportsbraThinA = new PIXI.Sprite(textures["sports_bras_thin_a.png"]);
    let sportsbraThinB = new PIXI.Sprite(textures["sports_bras_thin_b.png"]);
    let sportsbra1 = new PIXI.Sprite(textures["sports_bras_1.png"]);
    let sportsbra2A = new PIXI.Sprite(textures["sports_bras_2_a.png"]);
    let sportsbra2B = new PIXI.Sprite(textures["sports_bras_2_b.png"]);
    let sportsbra3 = new PIXI.Sprite(textures["sports_bras_3.png"]);
    let sportsbra4 = new PIXI.Sprite(textures["sports_bras_4.png"]);
    let sportsbra5A = new PIXI.Sprite(textures["sports_bras_5_a.png"]);
    let sportsbra5B = new PIXI.Sprite(textures["sports_bras_5_b.png"]);
    let sportsbra6A = new PIXI.Sprite(textures["sports_bras_6_a.png"]);
    let sportsbra6B = new PIXI.Sprite(textures["sports_bras_6_b.png"]);
    let sportsbra6C = new PIXI.Sprite(textures["sports_bras_6_c.png"]);
    let sportsbra7A = new PIXI.Sprite(textures["sports_bras_7_a.png"]);
    let sportsbra7B = new PIXI.Sprite(textures["sports_bras_7_b.png"]);
    let sportsbra8A = new PIXI.Sprite(textures["sports_bras_8_a.png"]);
    let sportsbra8B = new PIXI.Sprite(textures["sports_bras_8_b.png"]);
    let sportsbra8C = new PIXI.Sprite(textures["sports_bras_8_c.png"]);
    let sportsbra9A = new PIXI.Sprite(textures["sports_bras_9_a.png"]);
    let sportsbra9B = new PIXI.Sprite(textures["sports_bras_9_b.png"]);
    let sportsbra9C = new PIXI.Sprite(textures["sports_bras_9_c.png"]);
    let sportsbra10A = new PIXI.Sprite(textures["sports_bras_10_a.png"]);
    let sportsbra10B = new PIXI.Sprite(textures["sports_bras_10_b.png"]);
    let sportsbra10C = new PIXI.Sprite(textures["sports_bras_10_c.png"]);
    let sportsbra11A = new PIXI.Sprite(textures["sports_bras_11_a.png"]);
    let sportsbra11B = new PIXI.Sprite(textures["sports_bras_11_b.png"]);
    let sportsbra12 = new PIXI.Sprite(textures["sports_bras_12.png"]);
    let sportsbra13A = new PIXI.Sprite(textures["sports_bras_13_a.png"]);
    let sportsbra13B = new PIXI.Sprite(textures["sports_bras_13_b.png"]);
    let sportsbra13C = new PIXI.Sprite(textures["sports_bras_13_c.png"]);
    let sportsbra14A = new PIXI.Sprite(textures["sports_bras_14_a.png"]);
    let sportsbra14B = new PIXI.Sprite(textures["sports_bras_14_b.png"]);
    let sportsbra14C = new PIXI.Sprite(textures["sports_bras_14_c.png"]);
    let sportsbra14D = new PIXI.Sprite(textures["sports_bras_14_d.png"]);
    let sportsbra15 = new PIXI.Sprite(textures["sports_bras_15.png"]);
    let sportsbra16A = new PIXI.Sprite(textures["sports_bras_16_a.png"]);
    let sportsbra16B = new PIXI.Sprite(textures["sports_bras_16_b.png"]);
    let sportsbra16C = new PIXI.Sprite(textures["sports_bras_16_c.png"]);
    // Tattoos
    let tattoo1 = new PIXI.Sprite(textures["tattoo_1.png"]);
    let tattoo2 = new PIXI.Sprite(textures["tattoo_2.png"]);
    let tattoo3 = new PIXI.Sprite(textures["tattoo_3.png"]);
    let tattoo4 = new PIXI.Sprite(textures["tattoo_4.png"]);
    let tattoo5 = new PIXI.Sprite(textures["tattoo_5.png"]);
    let tattoo6 = new PIXI.Sprite(textures["tattoo_6.png"]);
    let tattoo7A = new PIXI.Sprite(textures["tattoo_7_a.png"]);
    let tattoo7B = new PIXI.Sprite(textures["tattoo_7_b.png"]);
    let tattoo7C = new PIXI.Sprite(textures["tattoo_7_c.png"]);
    let tattoo8A = new PIXI.Sprite(textures["tattoo_8_a.png"]);
    let tattoo8B = new PIXI.Sprite(textures["tattoo_8_b.png"]);
    let tattoo9 = new PIXI.Sprite(textures["tattoo_9.png"]);
    let tattoo10 = new PIXI.Sprite(textures["tattoo_10.png"]);
    let tattoo11 = new PIXI.Sprite(textures["tattoo_11.png"]);
    let tattoo12 = new PIXI.Sprite(textures["tattoo_12.png"]);
    let tattoo13 = new PIXI.Sprite(textures["tattoo_13.png"]);
    let tattoo14 = new PIXI.Sprite(textures["tattoo_14.png"]);
    let tattoo15 = new PIXI.Sprite(textures["tattoo_15.png"]);
    let tattoo16 = new PIXI.Sprite(textures["tattoo_16.png"]);
    let tattoo17 = new PIXI.Sprite(textures["tattoo_17.png"]);
    let tattoo18 = new PIXI.Sprite(textures["tattoo_18.png"]);
    let tattoo19 = new PIXI.Sprite(textures["tattoo_19.png"]);
    let tattoo20 = new PIXI.Sprite(textures["tattoo_20.png"]);
    let tattoo21 = new PIXI.Sprite(textures["tattoo_21.png"]);
    let tattoo22 = new PIXI.Sprite(textures["tattoo_22.png"]);
    let tattoo23 = new PIXI.Sprite(textures["tattoo_23.png"]);
    let tattoo1Female = new PIXI.Sprite(textures["tattoo_1_female.png"]);
    let tattoo2Female = new PIXI.Sprite(textures["tattoo_2_female.png"]);
    let tattoo3Female = new PIXI.Sprite(textures["tattoo_3_female.png"]);
    let tattoo4Female = new PIXI.Sprite(textures["tattoo_4_female.png"]);
    let tattoo5Female = new PIXI.Sprite(textures["tattoo_5_female.png"]);
    let tattoo10Female = new PIXI.Sprite(textures["tattoo_10_female.png"]);
    let tattoo11Female = new PIXI.Sprite(textures["tattoo_11_female.png"]);
    let tattoo16Female = new PIXI.Sprite(textures["tattoo_16_female.png"]);
    let tattoo17Female = new PIXI.Sprite(textures["tattoo_17_female.png"]);
    let tattoo19Female = new PIXI.Sprite(textures["tattoo_19_female.png"]);
    let tattoo20Female = new PIXI.Sprite(textures["tattoo_20_female.png"]);
    let tattoo21Female = new PIXI.Sprite(textures["tattoo_21_female.png"]);
    let tattoo22Female = new PIXI.Sprite(textures["tattoo_22_female.png"]);
    let tattoo23Female = new PIXI.Sprite(textures["tattoo_23_female.png"]);
    // Knee pads
    let kneepad1 = new PIXI.Sprite(textures["knee_pads_1.png"]);
    let kneepad2 = new PIXI.Sprite(textures["knee_pads_2.png"]);
    let kneepad3 = new PIXI.Sprite(textures["knee_pads_3.png"]);
    let kneepad4 = new PIXI.Sprite(textures["knee_pads_4.png"]);
    let kneepad5 = new PIXI.Sprite(textures["knee_pads_5.png"]);
    let kneepad6 = new PIXI.Sprite(textures["knee_pads_6.png"]);
    let kneepad7 = new PIXI.Sprite(textures["knee_pads_7.png"]);
    let kneepad8 = new PIXI.Sprite(textures["knee_pads_8.png"]);
    let kneepad9 = new PIXI.Sprite(textures["knee_pads_9.png"]);
    let kneepad10 = new PIXI.Sprite(textures["knee_pads_10.png"]);
    // Female tops
    let femaleTop1 = new PIXI.Sprite(textures["female_tops_1.png"]);
    let femaleTop2 = new PIXI.Sprite(textures["female_tops_2.png"]);
    let femaleTop3 = new PIXI.Sprite(textures["female_tops_3.png"]);
    let femaleTop4 = new PIXI.Sprite(textures["female_tops_4.png"]);
    let femaleTop5 = new PIXI.Sprite(textures["female_tops_5.png"]);
    let femaleTop6 = new PIXI.Sprite(textures["female_tops_6.png"]);
    let femaleTop7 = new PIXI.Sprite(textures["female_tops_7.png"]);
    let femaleTop8A = new PIXI.Sprite(textures["female_tops_8_a.png"]);
    let femaleTop8B = new PIXI.Sprite(textures["female_tops_8_b.png"]);
    let femaleTop9A = new PIXI.Sprite(textures["female_tops_9_a.png"]);
    let femaleTop9B = new PIXI.Sprite(textures["female_tops_9_b.png"]);
    let femaleTop10A = new PIXI.Sprite(textures["female_tops_10_a.png"]);
    let femaleTop10B = new PIXI.Sprite(textures["female_tops_10_b.png"]);
    let femaleTop11A = new PIXI.Sprite(textures["female_tops_11_a.png"]);
    let femaleTop11B = new PIXI.Sprite(textures["female_tops_11_b.png"]);
    // Female bottoms
    let femaleBottom1A = new PIXI.Sprite(textures["female_bottoms_1_a.png"]);
    let femaleBottom1B = new PIXI.Sprite(textures["female_bottoms_1_b.png"]);
    let femaleBottom2 = new PIXI.Sprite(textures["female_bottoms_2.png"]);
    let femaleBottom3A = new PIXI.Sprite(textures["female_bottoms_3_a.png"]);
    let femaleBottom3B = new PIXI.Sprite(textures["female_bottoms_3_b.png"]);
    let femaleBottom3C = new PIXI.Sprite(textures["female_bottoms_3_c.png"]);
    let femaleBottom4A = new PIXI.Sprite(textures["female_bottoms_4_a.png"]);
    let femaleBottom4B = new PIXI.Sprite(textures["female_bottoms_4_b.png"]);
    let femaleBottom4C = new PIXI.Sprite(textures["female_bottoms_4_c.png"]);
    let femaleBottom5 = new PIXI.Sprite(textures["female_bottoms_5.png"]);
    let femaleBottom6A = new PIXI.Sprite(textures["female_bottoms_6_a.png"]);
    let femaleBottom6B = new PIXI.Sprite(textures["female_bottoms_6_b.png"]);
    let femaleBottom6C = new PIXI.Sprite(textures["female_bottoms_6_c.png"]);
    let femaleBottom7 = new PIXI.Sprite(textures["female_bottoms_7.png"]);
    let femaleBottom8A = new PIXI.Sprite(textures["female_bottoms_8_a.png"]);
    let femaleBottom8B = new PIXI.Sprite(textures["female_bottoms_8_b.png"]);
    let femaleBottom9A = new PIXI.Sprite(textures["female_bottoms_9_a.png"]);
    let femaleBottom9B = new PIXI.Sprite(textures["female_bottoms_9_b.png"]);
    let femaleBottom10 = new PIXI.Sprite(textures["female_bottoms_10.png"]);
    let femaleBottom11 = new PIXI.Sprite(textures["female_bottoms_11.png"]);
    let femaleBottom12A = new PIXI.Sprite(textures["female_bottoms_12_a.png"]);
    let femaleBottom12B = new PIXI.Sprite(textures["female_bottoms_12_b.png"]);
    let femaleBottom12C = new PIXI.Sprite(textures["female_bottoms_12_c.png"]);
    let femaleBottom13 = new PIXI.Sprite(textures["female_bottoms_13.png"]);
    let femaleBottom14A = new PIXI.Sprite(textures["female_bottoms_14_a.png"]);
    let femaleBottom14B = new PIXI.Sprite(textures["female_bottoms_14_b.png"]);
    let femaleBottom15 = new PIXI.Sprite(textures["female_bottoms_15.png"]);
    let femaleBottom16A = new PIXI.Sprite(textures["female_bottoms_16_a.png"]);
    let femaleBottom16B = new PIXI.Sprite(textures["female_bottoms_16_b.png"]);
    let femaleBottom17 = new PIXI.Sprite(textures["female_bottoms_17.png"]);
    let femaleBottom18 = new PIXI.Sprite(textures["female_bottoms_18.png"]);
    let femaleBottom19 = new PIXI.Sprite(textures["female_bottoms_19.png"]);
    let femaleBottom20 = new PIXI.Sprite(textures["female_bottoms_20.png"]);
    let femaleBottom21A = new PIXI.Sprite(textures["female_bottoms_21_a.png"]);
    let femaleBottom21B = new PIXI.Sprite(textures["female_bottoms_21_b.png"]);
    let femaleBottom21C = new PIXI.Sprite(textures["female_bottoms_21_c.png"]);
    // Female accessories
    let femaleAccessory1 = new PIXI.Sprite(textures["female_accessories_1.png"]);
    let femaleAccessory2 = new PIXI.Sprite(textures["female_accessories_2.png"]);
    let femaleAccessory3 = new PIXI.Sprite(textures["female_accessories_3.png"]);
    let femaleAccessory4A = new PIXI.Sprite(textures["female_accessories_4_a.png"]);
    let femaleAccessory4B = new PIXI.Sprite(textures["female_accessories_4_b.png"]);
    let femaleAccessory5 = new PIXI.Sprite(textures["female_accessories_5.png"]);
    let femaleAccessory6 = new PIXI.Sprite(textures["female_accessories_6.png"]);
    let femaleAccessory7 = new PIXI.Sprite(textures["female_accessories_7.png"]);
    let femaleAccessory8A = new PIXI.Sprite(textures["female_accessories_8_a.png"]);
    let femaleAccessory8B = new PIXI.Sprite(textures["female_accessories_8_b.png"]);
    let femaleAccessory9A = new PIXI.Sprite(textures["female_accessories_9_a.png"]);
    let femaleAccessory9B = new PIXI.Sprite(textures["female_accessories_9_b.png"]);
    let femaleAccessory10 = new PIXI.Sprite(textures["female_accessories_10.png"]);
    let femaleAccessory11 = new PIXI.Sprite(textures["female_accessories_11.png"]);
    let femaleAccessory12 = new PIXI.Sprite(textures["female_accessories_12.png"]);
    // Female hair
    let femaleHair1A = new PIXI.Sprite(textures["hair_female_1_a.png"]);
    let femaleHair1B = new PIXI.Sprite(textures["hair_female_1_b.png"]);
    let femaleHair2A = new PIXI.Sprite(textures["hair_female_2_a.png"]);
    let femaleHair2B = new PIXI.Sprite(textures["hair_female_2_b.png"]);
    let femaleHair3A = new PIXI.Sprite(textures["hair_female_3_a.png"]);
    let femaleHair3B = new PIXI.Sprite(textures["hair_female_3_b.png"]);
    let femaleHair4A = new PIXI.Sprite(textures["hair_female_4_a.png"]);
    let femaleHair5A = new PIXI.Sprite(textures["hair_female_5_a.png"]);
    let femaleHair5B = new PIXI.Sprite(textures["hair_female_5_b.png"]);
    let femaleHair6A = new PIXI.Sprite(textures["hair_female_6_a.png"]);
    let femaleHair6B = new PIXI.Sprite(textures["hair_female_6_b.png"]);
    let femaleHair7A = new PIXI.Sprite(textures["hair_female_7_a.png"]);
    let femaleHair7B = new PIXI.Sprite(textures["hair_female_7_b.png"]);
    let femaleHair8A = new PIXI.Sprite(textures["hair_female_8_a.png"]);
    let femaleHair8B = new PIXI.Sprite(textures["hair_female_8_b.png"]);
    let femaleHair9A = new PIXI.Sprite(textures["hair_female_9_a.png"]);
    let femaleHair9B = new PIXI.Sprite(textures["hair_female_9_b.png"]);
    let femaleHair10A = new PIXI.Sprite(textures["hair_female_10_a.png"]);
    let femaleHair10B = new PIXI.Sprite(textures["hair_female_10_b.png"]);
    let femaleHair11A = new PIXI.Sprite(textures["hair_female_11_a.png"]);
    let femaleHair11B = new PIXI.Sprite(textures["hair_female_11_b.png"]);
    let femaleHair12A = new PIXI.Sprite(textures["hair_female_12_a.png"]);
    let femaleHair12B = new PIXI.Sprite(textures["hair_female_12_b.png"]);
    let femaleHair13A = new PIXI.Sprite(textures["hair_female_13_a.png"]);
    let femaleHair13B = new PIXI.Sprite(textures["hair_female_13_b.png"]);
    let femaleHair14A = new PIXI.Sprite(textures["hair_female_14_a.png"]);
    let femaleHair14B = new PIXI.Sprite(textures["hair_female_14_b.png"]);
    let femaleHair15A = new PIXI.Sprite(textures["hair_female_15_a.png"]);
    let femaleHair15B = new PIXI.Sprite(textures["hair_female_15_b.png"]);
    let femaleHair16A = new PIXI.Sprite(textures["hair_female_16_a.png"]);
    let femaleHair16B = new PIXI.Sprite(textures["hair_female_16_b.png"]);
    let femaleHair17A = new PIXI.Sprite(textures["hair_female_17_a.png"]);
    let femaleHair17B = new PIXI.Sprite(textures["hair_female_17_b.png"]);
    let femaleHair18A = new PIXI.Sprite(textures["hair_female_18_a.png"]);
    let femaleHair18B = new PIXI.Sprite(textures["hair_female_18_b.png"]);
    let femaleHair19A = new PIXI.Sprite(textures["hair_female_19_a.png"]);
    let femaleHair19B = new PIXI.Sprite(textures["hair_female_19_b.png"]);
    let femaleHair20A = new PIXI.Sprite(textures["hair_female_20_a.png"]);
    let femaleHair20B = new PIXI.Sprite(textures["hair_female_20_b.png"]);
    let femaleHair21A = new PIXI.Sprite(textures["hair_female_21_a.png"]);
    let femaleHair21B = new PIXI.Sprite(textures["hair_female_21_b.png"]);
    let femaleHair22A = new PIXI.Sprite(textures["hair_female_22_a.png"]);
    let femaleHair22B = new PIXI.Sprite(textures["hair_female_22_b.png"]);
    let femaleHair23A = new PIXI.Sprite(textures["hair_female_23_a.png"]);
    let femaleHair23B = new PIXI.Sprite(textures["hair_female_23_b.png"]);
    let femaleHair23C = new PIXI.Sprite(textures["hair_female_23_c.png"]);
    let femaleHair24A = new PIXI.Sprite(textures["hair_female_24_a.png"]);
    let femaleHair24B = new PIXI.Sprite(textures["hair_female_24_b.png"]);
    let femaleHair25A = new PIXI.Sprite(textures["hair_female_25_a.png"]);
    let femaleHair25B = new PIXI.Sprite(textures["hair_female_25_b.png"]);
    let femaleHair26A = new PIXI.Sprite(textures["hair_female_26_a.png"]);
    let femaleHair26B = new PIXI.Sprite(textures["hair_female_26_b.png"]);
    let femaleHair27A = new PIXI.Sprite(textures["hair_female_27_a.png"]);
    let femaleHair27B = new PIXI.Sprite(textures["hair_female_27_b.png"]);
    let femaleHair28A = new PIXI.Sprite(textures["hair_female_28_a.png"]);
    let femaleHair28B = new PIXI.Sprite(textures["hair_female_28_b.png"]);
    let femaleHair29A = new PIXI.Sprite(textures["hair_female_29_a.png"]);
    let femaleHair29B = new PIXI.Sprite(textures["hair_female_29_b.png"]);
    let femaleHair30A = new PIXI.Sprite(textures["hair_female_30_a.png"]);
    let femaleHair30B = new PIXI.Sprite(textures["hair_female_30_b.png"]);
    // Title Sprites
    let titleSmallPlate1 = new PIXI.Sprite(textures["title_small_plate_1.png"]);
    let titleSmallPlate2 = new PIXI.Sprite(textures["title_small_plate_2.png"]);
    let titleSmallPlate3 = new PIXI.Sprite(textures["title_small_plate_3.png"]);
    let titleSmallPlate4 = new PIXI.Sprite(textures["title_small_plate_4.png"]);
    let titleSmallPlate5 = new PIXI.Sprite(textures["title_small_plate_5.png"]);
    let titleSmallPlate6 = new PIXI.Sprite(textures["title_small_plate_6.png"]);
    let titleSmallPlate7 = new PIXI.Sprite(textures["title_small_plate_7.png"]);
    let titleSmallPlate8 = new PIXI.Sprite(textures["title_small_plate_8.png"]);
    let titleSmallPlate9 = new PIXI.Sprite(textures["title_small_plate_9.png"]);
    let titleSmallPlate10 = new PIXI.Sprite(textures["title_small_plate_10.png"]);
    let titleSmallGems1 = new PIXI.Sprite(textures["title_small_gems_1.png"]);
    let titleSmallGems2 = new PIXI.Sprite(textures["title_small_gems_2.png"]);
    let titleSmallGems3 = new PIXI.Sprite(textures["title_small_gems_3.png"]);
    let titleSmallGems4 = new PIXI.Sprite(textures["title_small_gems_4.png"]);
    let titleSmallGems5 = new PIXI.Sprite(textures["title_small_gems_5.png"]);
    let titleSmallGems6 = new PIXI.Sprite(textures["title_small_gems_6.png"]);
    let titleSmallGems7 = new PIXI.Sprite(textures["title_small_gems_7.png"]);
    let titleSmallGems8 = new PIXI.Sprite(textures["title_small_gems_8.png"]);
    let titleSmallGems9 = new PIXI.Sprite(textures["title_small_gems_9.png"]);
    let titleSmallGems10 = new PIXI.Sprite(textures["title_small_gems_10.png"]);
    let titleSmallStrap1 = new PIXI.Sprite(textures["title_small_strap_1.png"]);
    let titleSmallStrap2 = new PIXI.Sprite(textures["title_small_strap_2.png"]);
    let titleSmallStrap3 = new PIXI.Sprite(textures["title_small_strap_3.png"]);
    let titleSmallStrap4 = new PIXI.Sprite(textures["title_small_strap_4.png"]);
    let titleSmallStrap5 = new PIXI.Sprite(textures["title_small_strap_5.png"]);
    let titleSmallStrap6 = new PIXI.Sprite(textures["title_small_strap_6.png"]);
    let titleSmallStrap7 = new PIXI.Sprite(textures["title_small_strap_7.png"]);
    let titleSmallStrap8 = new PIXI.Sprite(textures["title_small_strap_8.png"]);
    let titleSmallStrap9 = new PIXI.Sprite(textures["title_small_strap_9.png"]);
    let titleSmallStrap10 = new PIXI.Sprite(textures["title_small_strap_10.png"]);
    // Special segment sprites
    let specialSegmentsCar = new PIXI.Sprite(textures["special_segments_car_black.png"]);
    let specialSegmentsCarFire = new PIXI.Sprite(textures["special_segments_car_fire.png"]);
    let specialSegmentsHelicopter = new PIXI.Sprite(textures["special_segments_helicopter.png"]);
    let specialSegmentsHelicopterBuilding = new PIXI.Sprite(textures["special_segments_helicopter_building.png"]);
    let specialSegmentsHelicopterBuildingLights = new PIXI.Sprite(textures["special_segments_helicopter_building_lights.png"]);
    let specialSegmentsLemonadeTruck = new PIXI.Sprite(textures["special_segments_lemonade_truck.png"]);
    let specialSegmentsLemonadeTruckSpray = new PIXI.Sprite(textures["special_segments_lemonade_truck_spray.png"]);
    let specialSegmentsStage = new PIXI.Sprite(textures["special_segments_stage.png"]);
    let specialSegmentsStageRailing = new PIXI.Sprite(textures["special_segments_stage_railing.png"]);
    let specialSegmentsDummy = new PIXI.Sprite(textures["special_segments_dummy.png"]);
    let specialSegmentsAmbulance = new PIXI.Sprite(textures["special_segments_ambulance.png"]);
    let specialSegmentsCelebrityAmericanQueen = new PIXI.Sprite(textures["special_segments_celebrity_1.png"]);
    let specialSegmentsCelebrityPrezz = new PIXI.Sprite(textures["special_segments_celebrity_2.png"]);
    let specialSegmentsCelebrityBigT = new PIXI.Sprite(textures["special_segments_celebrity_3.png"]);
    let specialSegmentsRantMic = new PIXI.Sprite(textures["special_segments_rant_mic.png"]);
    let specialSegmentsRantSpeech = new PIXI.Sprite(textures["special_segments_rant_speech.png"]);
    let specialSegmentsLoveMakingManClothed = new PIXI.Sprite(textures["special_segments_love_making_man_clothed.png"]);
    let specialSegmentsLoveMakingManNude = new PIXI.Sprite(textures["special_segments_love_making_man_nude.png"]);
    let specialSegmentsLoveMakingWomanClothed = new PIXI.Sprite(textures["special_segments_love_making_woman_clothed.png"]);
    let specialSegmentsLoveMakingWomanNude = new PIXI.Sprite(textures["special_segments_love_making_woman_nude.png"]);
    let specialSegmentsLoveMakingBottomCensor = new PIXI.Sprite(textures["special_segments_love_making_bottom_censor.png"]);
    let specialSegmentsLoveMakingTopCensor = new PIXI.Sprite(textures["special_segments_love_making_top_censor.png"]);
    let specialSegmentsLoveMakingBed = new PIXI.Sprite(textures["special_segments_love_making_bed.png"]);
    let specialSegmentsLoveMakingHeart = new PIXI.Sprite(textures["special_segments_love_making_heart.png"]);
    let specialSegmentsRing = new PIXI.Sprite(textures["special_segments_ring.png"]);
    let specialSegmentsRingRopes = new PIXI.Sprite(textures["special_segments_ring_ropes.png"]);
    let specialSegmentsRingPeopleTop = new PIXI.Sprite(textures["special_segments_ring_people_top.png"]);
    let specialSegmentsRingPeopleBottom = new PIXI.Sprite(textures["special_segments_ring_people_bottom.png"]);
    // Blood sprites
    let bloodDesign1 = new PIXI.Sprite(textures["blood_1.png"]);
    let bloodDesign2 = new PIXI.Sprite(textures["blood_2.png"]);
    let bloodDesign3 = new PIXI.Sprite(textures["blood_3.png"]);
    let bloodDesign4 = new PIXI.Sprite(textures["blood_4.png"]);
    let bloodDesign5 = new PIXI.Sprite(textures["blood_5.png"]);
    let bloodDesign6 = new PIXI.Sprite(textures["blood_6.png"]);
    let bloodDesign7 = new PIXI.Sprite(textures["blood_7.png"]);
    let bloodDesign8 = new PIXI.Sprite(textures["blood_8.png"]);
    let bloodDesign9 = new PIXI.Sprite(textures["blood_9.png"]);
    let bloodDesign10 = new PIXI.Sprite(textures["blood_10.png"]);
    let bloodDesign11 = new PIXI.Sprite(textures["blood_11.png"]);
    let bloodDesign12 = new PIXI.Sprite(textures["blood_12.png"]);
    let bloodDesign13 = new PIXI.Sprite(textures["blood_13.png"]);
    // Backgrounds
    let posterBackground1 = new PIXI.Sprite(textures["poster_background_1.png"]);
    let posterBackground2 = new PIXI.Sprite(textures["poster_background_2.png"]);
    let posterBackground3 = new PIXI.Sprite(textures["poster_background_3.png"]);
    let posterBackground4 = new PIXI.Sprite(textures["poster_background_4.png"]);
    let posterBackground5 = new PIXI.Sprite(textures["poster_background_5.png"]);
    let posterBackground6 = new PIXI.Sprite(textures["poster_background_6.png"]);
    let posterBackground7 = new PIXI.Sprite(textures["poster_background_7.png"]);
    let posterBackground8 = new PIXI.Sprite(textures["poster_background_8.png"]);
    let posterBackground9 = new PIXI.Sprite(textures["poster_background_9.png"]);
    let posterBackground10 = new PIXI.Sprite(textures["poster_background_10.png"]);
    // Gimmick match sprites
    let gimmickMatchLadderBlack = new PIXI.Sprite(textures["gimmick_match_ladder_black.png"]);
    let gimmickMatchLadderGrey = new PIXI.Sprite(textures["gimmick_match_ladder_grey.png"]);
    let gimmickMatchLadderOrange = new PIXI.Sprite(textures["gimmick_match_ladder_red.png"]);
    let gimmickMatchCageGrey = new PIXI.Sprite(textures["gimmick_match_cage_grey.png"]);
    let gimmickMatchCageRed = new PIXI.Sprite(textures["gimmick_match_cage_red.png"]);
    let gimmickMatchCageRetroBlue = new PIXI.Sprite(textures["gimmick_match_cage_retro_blue.png"]);
    let gimmickMatchCageRetroBlack = new PIXI.Sprite(textures["gimmick_match_cage_retro_black.png"]);
    let gimmickMatchTableBrown = new PIXI.Sprite(textures["gimmick_match_table_brown.png"]);
    let gimmickMatchTableBrownStanding = new PIXI.Sprite(textures["gimmick_match_table_brown_standing.png"]);
    let gimmickMatchTableDarkBrown = new PIXI.Sprite(textures["gimmick_match_table_dark_brown.png"]);
    let gimmickMatchTableDarkBrownStanding = new PIXI.Sprite(textures["gimmick_match_table_dark_brown_standing.png"]);
    let gimmickMatchTableLightBrown = new PIXI.Sprite(textures["gimmick_match_table_light_brown.png"]);
    let gimmickMatchTableLightBrownStanding = new PIXI.Sprite(textures["gimmick_match_table_light_brown_standing.png"]);
    let gimmickMatchChairBiege = new PIXI.Sprite(textures["gimmick_match_chair_biege.png"]);
    let gimmickMatchChairBlack = new PIXI.Sprite(textures["gimmick_match_chair_black.png"]);
    let gimmickMatchChairBlue = new PIXI.Sprite(textures["gimmick_match_chair_blue.png"]);
    let gimmickMatchAmbulance = new PIXI.Sprite(textures["gimmick_match_ambulance.png"]);
    let gimmickMatchBarbedWireRopes = new PIXI.Sprite(textures["gimmick_match_barbed_wire_ropes.png"]);
    let gimmickMatchBarbedWireBoard = new PIXI.Sprite(textures["gimmick_match_barbed_wire_board.png"]);
    let gimmickMatchBuriedAlive = new PIXI.Sprite(textures["gimmick_match_buried_alive.png"]);
    let gimmickMatchCasketBrown = new PIXI.Sprite(textures["gimmick_match_casket_brown.png"]);
    let gimmickMatchCasketPurple = new PIXI.Sprite(textures["gimmick_match_casket_purple.png"]);
    let gimmickMatchCasketLightBrown = new PIXI.Sprite(textures["gimmick_match_casket_light_brown.png"]);
    let gimmickMatchParkingLotA = new PIXI.Sprite(textures["gimmick_match_parking_lot_a.png"]);
    let gimmickMatchParkingLotB = new PIXI.Sprite(textures["gimmick_match_parking_lot_b.png"]);
    // Temporary injury sprites
    let bruiseEyeRight = new PIXI.Sprite(textures["bruise_eye_right.png"]);
    let bruiseEyeLeft = new PIXI.Sprite(textures["bruise_eye_left.png"]);
    let bandageArmRight = new PIXI.Sprite(textures["bandage_arm_right.png"]);
    let bandageArmLeft = new PIXI.Sprite(textures["bandage_arm_left.png"]);
    let bandageForeheadLeft = new PIXI.Sprite(textures["bandage_forehead_left.png"]);
    let bandageForeheadRight = new PIXI.Sprite(textures["bandage_forehead_right.png"]);
    let bandageForeheadFull = new PIXI.Sprite(textures["bandage_forehead_full.png"]);
    // TGI sprites
    let TGITrophy = new PIXI.Sprite(textures["tgi_trophy.png"]);
    let TGIFireworks = new PIXI.Sprite(textures["tgi_fireworks.png"]);
    // Set graphic objects
    let bodyObjectHe = {
        designs: [
            {
                sprite: bodyHe,
                zIndex: -1,
                defaultColor: "0xF7D1B9"
            }
        ]
    };
    let bodyObjectHe2 = {
        designs: [
            {
                sprite: bodyHe,
                zIndex: -1,
                defaultColor: "0xB6916E"
            }
        ]
    };
    let bodyObjectHe3 = {
        designs: [
            {
                sprite: bodyHe,
                zIndex: -1,
                defaultColor: "0xEBC6A2"
            }
        ]
    };
    let bodyObjectShe = {
        designs: [
            {
                sprite: bodyShe,
                zIndex: -1,
                defaultColor: "0xF7D1B9"
            }
        ]
    };
    let bodyObjectHeAbs = {
        designs: [
            {
                sprite: bodyHeAbs,
                zIndex: -1,
                defaultColor: "0xF7D1B9"
            }
        ]
    };
    let bodyObjectSheAbs = {
        designs: [
            {
                sprite: bodySheAbs,
                zIndex: -1,
                defaultColor: "0xF7D1B9"
            }
        ]
    };
    let eyesObject = {
        designs: [
            {
                sprite: eyesDesign,
                zIndex: 0,
                defaultColor: "0x000000"
            }
        ]
    };
    let trunkObject1 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x333333"
            }
        ]
    };
    let trunkObject2 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x72A2C7"
            }
        ]
    };
    let trunkObject3 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x5B935F"
            },
            {
                sprite: trunksDesign1,
                zIndex: 2,
                defaultColor: "0xCCCCCC"
            }
        ]
    };
    let trunkObject4 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0xA54848"
            },
            {
                sprite: trunksDesign2,
                zIndex: 2,
                defaultColor: "0x444444"
            }
        ]
    };
    let trunkObject5 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0xE7E7E7"
            },
            {
                sprite: trunksDesign3,
                zIndex: 2,
                defaultColor: "0xE2A54E"
            }
        ]
    };
    let trunkObject6 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x9F557C"
            },
            {
                sprite: trunksDesign4,
                zIndex: 2,
                defaultColor: "0x4C4C4C"
            }
        ]
    };
    let trunkObject7 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x7FB2D2"
            },
            {
                sprite: trunksDesign5,
                zIndex: 2,
                defaultColor: "0xD27F7F"
            }
        ]
    };
    let trunkObject8 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x5BDE37"
            },
            {
                sprite: trunksDesign6A,
                zIndex: 2,
                defaultColor: "0xFFD622"
            },
            {
                sprite: trunksDesign6B,
                zIndex: 3,
                defaultColor: "0xF1FF2E"
            }
        ]
    };
    let trunkObject9 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x505050"
            },
            {
                sprite: trunksDesign7,
                zIndex: 2,
                defaultColor: "0x967892"
            }
        ]
    };
    let trunkObject10 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x313131"
            },
            {
                sprite: trunksDesign8A,
                zIndex: 2,
                defaultColor: "0xB091C1"
            },
            {
                sprite: trunksDesign8B,
                zIndex: 3,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let trunkObject11 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x74D8F6"
            },
            {
                sprite: trunksDesign9,
                zIndex: 2,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let trunkObject12 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x3B3B3B"
            },
            {
                sprite: trunksDesign10A,
                zIndex: 2,
                defaultColor: "0xC9C9C9"
            },
            {
                sprite: trunksDesign10B,
                zIndex: 3,
                defaultColor: "0xDAD235"
            }
        ]
    };
    let trunkObject13 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x62BF6D"
            },
            {
                sprite: trunksDesign11,
                zIndex: 2,
                defaultColor: "0xC3C3C3"
            }
        ]
    };
    let trunkObject14 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0xD2822D"
            },
            {
                sprite: trunksDesign12,
                zIndex: 2,
                defaultColor: "0x474747"
            }
        ]
    };
    let trunkObject15 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0xD2822D"
            },
            {
                sprite: trunksDesign13,
                zIndex: 2,
                defaultColor: "0xDCD43B"
            }
        ]
    };
    let trunkObject16 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0x2E2E2E"
            },
            {
                sprite: trunksDesign14A,
                zIndex: 2,
                defaultColor: "0xCBCBCB"
            },
            {
                sprite: trunksDesign14B,
                zIndex: 3,
                defaultColor: "0x4195B9"
            }
        ]
    };
    let trunkObject17 = {
        designs: [
            {
                sprite: trunksBase,
                zIndex: 1,
                defaultColor: "0xD0D0D0"
            },
            {
                sprite: trunksDesign15A,
                zIndex: 2,
                defaultColor: "0x575757"
            },
            {
                sprite: trunksDesign15B,
                zIndex: 3,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let shortsObjectBasic = {
        designs: [
            {
                sprite: shortsBase,
                zIndex: 13,
                defaultColor: "0x444444"
            }
        ]
    };
    let shortsObject1 = {
        designs: [
            {
                sprite: shortsBase,
                zIndex: 13,
                defaultColor: "0xEEA744"
            },
            {
                sprite: shortsDesign1A,
                zIndex: 14,
                defaultColor: "0x333333"
            },
            {
                sprite: shortsDesign1B,
                zIndex: 15,
                defaultColor: "0xE2E2E2"
            },
            {
                sprite: shortsDesign1C,
                zIndex: 15,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let shortsObject2 = {
        designs: [
            {
                sprite: shortsBase,
                zIndex: 13,
                defaultColor: "0xCA4545"
            },
            {
                sprite: shortsDesign2A,
                zIndex: 14,
                defaultColor: "0x65A1DD"
            },
            {
                sprite: shortsDesign2B,
                zIndex: 15,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let shortsObject3 = {
        designs: [
            {
                sprite: shortsBase,
                zIndex: 13,
                defaultColor: "0x77C1C0"
            },
            {
                sprite: shortsDesign3,
                zIndex: 14,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let shortsObject4 = {
        designs: [
            {
                sprite: shortsBase,
                zIndex: 13,
                defaultColor: "0x4C4C4C"
            },
            {
                sprite: shortsDesign4A,
                zIndex: 14,
                defaultColor: "0x4E9755"
            },
            {
                sprite: shortsDesign4B,
                zIndex: 15,
                defaultColor: "0xC6C6C6"
            }
        ]
    };
    let shortsObject5 = {
        designs: [
            {
                sprite: shortsBase,
                zIndex: 13,
                defaultColor: "0x564695"
            },
            {
                sprite: shortsDesign5,
                zIndex: 14,
                defaultColor: "0x7DC1DA"
            }
        ]
    };
    let shortsObject6 = {
        designs: [
            {
                sprite: shortsBase,
                zIndex: 13,
                defaultColor: "0x3B3B3B"
            },
            {
                sprite: shortsDesign6A,
                zIndex: 14,
                defaultColor: "0xCF3636"
            },
            {
                sprite: shortsDesign6B,
                zIndex: 15,
                defaultColor: "0x3B3B3B"
            }
        ]
    };
    let shortsObject7 = {
        designs: [
            {
                sprite: shortsBase,
                zIndex: 13,
                defaultColor: "0x3B3B3B"
            },
            {
                sprite: shortsDesign7A,
                zIndex: 14,
                defaultColor: "0xD1D1D1"
            },
            {
                sprite: shortsDesign7B,
                zIndex: 15,
                defaultColor: "0x656565"
            }
        ]
    };
    let shortsObject8 = {
        designs: [
            {
                sprite: shortsBase,
                zIndex: 13,
                defaultColor: "0x45565E"
            },
            {
                sprite: shortsDesign8A,
                zIndex: 14,
                defaultColor: "0xCCCCCC"
            },
            {
                sprite: shortsDesign8B,
                zIndex: 15,
                defaultColor: "0x4D6069"
            }
        ]
    };
    let shortsObject9 = {
        designs: [
            {
                sprite: shortsDesign9A,
                zIndex: 13,
                defaultColor: "0x333333"
            },
            {
                sprite: shortsDesign9B,
                zIndex: 14,
                defaultColor: "0xF3C632"
            },
            {
                sprite: shortsDesign9C,
                zIndex: 15,
                defaultColor: "0xF3C632"
            }
        ]
    };
    let tightsObject0 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x333333"
            }
        ]
    };
    let tightsObject1 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x6ACFE7"
            },
            {
                sprite: tightsDesign1A,
                zIndex: 5,
                defaultColor: "0x358B7C"
            },
            {
                sprite: tightsDesign1B,
                zIndex: 5,
                defaultColor: "0x358B7C"
            }
        ]
    };
    let tightsObject2 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x785CAA"
            },
            {
                sprite: tightsDesign2,
                zIndex: 5,
                defaultColor: "0xEBEBEB"
            }
        ]
    };
    let tightsObject3 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x65C474"
            },
            {
                sprite: tightsDesign3,
                zIndex: 5,
                defaultColor: "0xEBDB55"
            }
        ]
    };
    let tightsObject4 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x6FB0E7"
            },
            {
                sprite: tightsDesign4A,
                zIndex: 5,
                defaultColor: "0xE75B5B"
            },
            {
                sprite: tightsDesign4B,
                zIndex: 5,
                defaultColor: "0xE75B5B"
            }
        ]
    };
    let tightsObject5 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x3F3F3F"
            },
            {
                sprite: tightsDesign5A,
                zIndex: 5,
                defaultColor: "0xBA3434"
            },
            {
                sprite: tightsDesign5B,
                zIndex: 5,
                defaultColor: "0xBA3434"
            }
        ]
    };
    let tightsObject6 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x5D5D5D"
            },
            {
                sprite: tightsDesign6,
                zIndex: 5,
                defaultColor: "0xDB8A49"
            }
        ]
    };
    let tightsObject7 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x3B3B3B"
            },
            {
                sprite: tightsDesign7A,
                zIndex: 5,
                defaultColor: "0xFDA9FF"
            },
            {
                sprite: tightsDesign7B,
                zIndex: 5,
                defaultColor: "0xFDA9FF"
            }
        ]
    };
    let tightsObject8 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x7B985D"
            },
            {
                sprite: tightsDesign8,
                zIndex: 5,
                defaultColor: "0xD2FFA3"
            }
        ]
    };
    let tightsObject9 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x363636"
            },
            {
                sprite: tightsDesign9A,
                zIndex: 5,
                defaultColor: "0xDC814A"
            },
            {
                sprite: tightsDesign9B,
                zIndex: 5,
                defaultColor: "0xF4DC38"
            }
        ]
    };
    let tightsObject10 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0xDEFFA0"
            },
            {
                sprite: tightsDesign10,
                zIndex: 5,
                defaultColor: "0x628CE8"
            }
        ]
    };
    let tightsObject11 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x363636"
            },
            {
                sprite: tightsDesign11A,
                zIndex: 5,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: tightsDesign11B,
                zIndex: 5,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let tightsObject12 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0xEBE93D"
            },
            {
                sprite: tightsDesign12,
                zIndex: 5,
                defaultColor: "0x2D2D2D"
            }
        ]
    };
    let tightsObject13 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x363636"
            },
            {
                sprite: tightsDesign13,
                zIndex: 5,
                defaultColor: "0xE1BE1A"
            }
        ]
    };
    let tightsObject14 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x363636"
            },
            {
                sprite: tightsDesign14,
                zIndex: 5,
                defaultColor: "0xD4D4D4"
            }
        ]
    };
    let tightsObject15 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0xB25E4D"
            },
            {
                sprite: tightsDesign15,
                zIndex: 5,
                defaultColor: "0x358B7C"
            }
        ]
    };
    let tightsObject16 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0xF4F4F4"
            },
            {
                sprite: tightsDesign16,
                zIndex: 5,
                defaultColor: "0x4F4F4F"
            }
        ]
    };
    let tightsObject17 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x666666"
            },
            {
                sprite: tightsDesign17A,
                zIndex: 5,
                defaultColor: "0x666666"
            },
            {
                sprite: tightsDesign17B,
                zIndex: 5,
                defaultColor: "0xC8C7C7"
            }
        ]
    };
    let tightsObject18 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0xEFEFEF"
            },
            {
                sprite: tightsDesign18,
                zIndex: 5,
                defaultColor: "0x777777"
            }
        ]
    };
    let tightsObject19 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x333333"
            },
            {
                sprite: tightsDesign19A,
                zIndex: 5,
                defaultColor: "0xD9C431"
            },
            {
                sprite: tightsDesign19B,
                zIndex: 5,
                defaultColor: "0x078DB5"
            }
        ]
    };
    let tightsObject20 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x333333"
            },
            {
                sprite: tightsDesign20A,
                zIndex: 5,
                defaultColor: "0xCECECE"
            },
            {
                sprite: tightsDesign20B,
                zIndex: 5,
                defaultColor: "0x6EA425"
            },
            {
                sprite: tightsDesign20C,
                zIndex: 5,
                defaultColor: "0x666666"
            }
        ]
    };
    let tightsObject21 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0xA53131"
            },
            {
                sprite: tightsDesign21A,
                zIndex: 5,
                defaultColor: "0xE4D5BB"
            },
            {
                sprite: tightsDesign21B,
                zIndex: 5,
                defaultColor: "0xE4D5BB"
            },
            {
                sprite: tightsDesign21C,
                zIndex: 5,
                defaultColor: "0xE4D5BB"
            }
        ]
    };
    let tightsObject22 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x4C64E2"
            },
            {
                sprite: tightsDesign22,
                zIndex: 5,
                defaultColor: "0x212B5D"
            }
        ]
    };
    let tightsObject23 = {
        designs: [
            {
                sprite: tightsBase,
                zIndex: 4,
                defaultColor: "0x920909"
            },
            {
                sprite: tightsDesign23A,
                zIndex: 5,
                defaultColor: "0xE4E4E4"
            },
            {
                sprite: tightsDesign23B,
                zIndex: 5,
                defaultColor: "0xE4E4E4"
            }
        ]
    };
    let tightsObject24 = {
        designs: [
            {
                sprite: tightsDesign24A,
                zIndex: 4,
                defaultColor: "0x515937"
            },
            {
                sprite: tightsDesign24B,
                zIndex: 4,
                defaultColor: "0x94916C"
            },
            {
                sprite: tightsDesign24C,
                zIndex: 4,
                defaultColor: "0x63391E"
            }
        ]
    };
    let tightsObject25 = {
        designs: [
            {
                sprite: tightsDesign25A,
                zIndex: 4,
                defaultColor: "0x7B29D9"
            },
            {
                sprite: tightsDesign25B,
                zIndex: 4,
                defaultColor: "0x438CD9"
            },
            {
                sprite: tightsDesign25C,
                zIndex: 4,
                defaultColor: "0x43C5D9"
            }
        ]
    };
    let hairObject1 = {
        designs: [
            {
                sprite: hairDesign1,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject2 = {
        designs: [
            {
                sprite: hairDesign2,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject3 = {
        designs: [
            {
                sprite: hairDesign3,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject4 = {
        designs: [
            {
                sprite: hairDesign4,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign4Streak,
                zIndex: 25,
                defaultColor: "0xFFF1B8"
            }
        ]
    };
    let hairObject5 = {
        designs: [
            {
                sprite: hairDesign5A,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign5B,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject6 = {
        designs: [
            {
                sprite: hairDesign6A,
                zIndex: 25,
                defaultColor: "0x3C3C3C"
            },
            {
                sprite: hairDesign6B,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject7 = {
        designs: [
            {
                sprite: hairDesign7A,
                zIndex: 25,
                defaultColor: "0x3C3C3C"
            },
            {
                sprite: hairDesign7B,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject8 = {
        designs: [
            {
                sprite: hairDesign8,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject9 = {
        designs: [
            {
                sprite: hairDesign9,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject10 = {
        designs: [
            {
                sprite: hairDesign10,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign10Streak,
                zIndex: 25,
                defaultColor: "0xFFF1B8"
            }
        ]
    };
    let hairObject11 = {
        designs: [
            {
                sprite: hairDesign11,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject12 = {
        designs: [
            {
                sprite: hairDesign12,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign12Streak,
                zIndex: 25,
                defaultColor: "0xFFF1B8"
            }
        ]
    };
    let hairObject13 = {
        designs: [
            {
                sprite: hairDesign13,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject14 = {
        designs: [
            {
                sprite: hairDesign14,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject15 = {
        designs: [
            {
                sprite: hairDesign15,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject16 = {
        designs: [
            {
                sprite: hairDesign16,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject17 = {
        designs: [
            {
                sprite: hairDesign17,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject18 = {
        designs: [
            {
                sprite: hairDesign18,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign18Streak,
                zIndex: 25,
                defaultColor: "0xFFF1B8"
            }
        ]
    };
    let hairObject19 = {
        designs: [
            {
                sprite: hairDesign19,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject20 = {
        designs: [
            {
                sprite: hairDesign20A,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign20B,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject21 = {
        designs: [
            {
                sprite: hairDesign21,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject22 = {
        designs: [
            {
                sprite: hairDesign22,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject23 = {
        designs: [
            {
                sprite: hairDesign23,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign23Streak,
                zIndex: 25,
                defaultColor: "0xFFF1B8"
            }
        ]
    };
    let hairObject24 = {
        designs: [
            {
                sprite: hairDesign24A,
                zIndex: 25,
                defaultColor: "0x3C3C3C"
            },
            {
                sprite: hairDesign24B,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject25 = {
        designs: [
            {
                sprite: hairDesign25,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject26 = {
        designs: [
            {
                sprite: hairDesign26,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject27 = {
        designs: [
            {
                sprite: hairDesign27,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign27Streak,
                zIndex: 25,
                defaultColor: "0xFFF1B8"
            }
        ]
    };
    let hairObject28 = {
        designs: [
            {
                sprite: hairDesign28,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject29 = {
        designs: [
            {
                sprite: hairDesign29,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign29Streak,
                zIndex: 25,
                defaultColor: "0xFFF1B8"
            }
        ]
    };
    let hairObject30 = {
        designs: [
            {
                sprite: hairDesign30,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject31 = {
        designs: [
            {
                sprite: hairDesign31,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign31Streak,
                zIndex: 25,
                defaultColor: "0xFFF1B8"
            }
        ]
    };
    let hairObject32 = {
        designs: [
            {
                sprite: hairDesign32,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject33 = {
        designs: [
            {
                sprite: hairDesign33,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject34 = {
        designs: [
            {
                sprite: hairDesign34,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign34Streak,
                zIndex: 25,
                defaultColor: "0xFFF1B8"
            }
        ]
    };
    let hairObject35 = {
        designs: [
            {
                sprite: hairDesign35,
                zIndex: 25,
                defaultColor: "0x71645F"
            }
        ]
    };
    let hairObject36 = {
        designs: [
            {
                sprite: hairDesign36A,
                zIndex: 25,
                defaultColor: "0x71645F"
            },
            {
                sprite: hairDesign36B,
                zIndex: 25,
                defaultColor: "0x88766E"
            }
        ]
    };
    let shoesObject0 = {
        designs: [
            {
                sprite: shoesDesign2,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let shoesObject1 = {
        designs: [
            {
                sprite: shoesDesign1,
                zIndex: 10,
                defaultColor: "0xeea744"
            },
            {
                sprite: shoesDesign1A,
                zIndex: 11,
                defaultColor: "0x242424"
            }
        ]
    };
    let shoesObject2 = {
        designs: [
            {
                sprite: shoesDesign2,
                zIndex: 10,
                defaultColor: "0x65A1DD"
            },
            {
                sprite: shoesDesign2A,
                zIndex: 11,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: shoesDesign2B,
                zIndex: 12,
                defaultColor: "0xCA4545"
            }
        ]
    };
    let shoesObject3 = {
        designs: [
            {
                sprite: shoesDesign3,
                zIndex: 10,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: shoesDesign3A,
                zIndex: 11,
                defaultColor: "0x77C1C0"
            }
        ]
    };
    let shoesObject4 = {
        designs: [
            {
                sprite: shoesDesign4,
                zIndex: 10,
                defaultColor: "0x4C4C4C"
            },
            {
                sprite: shoesDesign4A,
                zIndex: 11,
                defaultColor: "0x4E9755"
            }
        ]
    };
    let shoesObject5 = {
        designs: [
            {
                sprite: shoesDesign5,
                zIndex: 10,
                defaultColor: "0x7DC1DA"
            },
            {
                sprite: shoesDesign5A,
                zIndex: 11,
                defaultColor: "0x564695"
            }
        ]
    };
    let shoesObject6 = {
        designs: [
            {
                sprite: shoesDesign6,
                zIndex: 10,
                defaultColor: "0x3B3B3B"
            },
            {
                sprite: shoesDesign6A,
                zIndex: 11,
                defaultColor: "0x606060"
            }
        ]
    };
    let shoesObject7 = {
        designs: [
            {
                sprite: shoesDesign7,
                zIndex: 10,
                defaultColor: "0x3B3B3B"
            },
            {
                sprite: shoesDesign7A,
                zIndex: 11,
                defaultColor: "0x525252"
            }
        ]
    };
    let shoesObject8 = {
        designs: [
            {
                sprite: shoesDesign8,
                zIndex: 10,
                defaultColor: "0x313131"
            },
            {
                sprite: shoesDesign8A,
                zIndex: 11,
                defaultColor: "0xADADAD"
            }
        ]
    };
    let shoesObject9 = {
        designs: [
            {
                sprite: shoesDesign9,
                zIndex: 10,
                defaultColor: "0x4B4B4B"
            },
            {
                sprite: shoesDesign9A,
                zIndex: 11,
                defaultColor: "0xD35B5B"
            }
        ]
    };
    let shoesObject10 = {
        designs: [
            {
                sprite: shoesDesign10,
                zIndex: 10,
                defaultColor: "0x5A9DE2"
            },
            {
                sprite: shoesDesign10A,
                zIndex: 11,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let shoesObject11 = {
        designs: [
            {
                sprite: shoesDesign11,
                zIndex: 10,
                defaultColor: "0xF3F3F3"
            },
            {
                sprite: shoesDesign11A,
                zIndex: 11,
                defaultColor: "0x81BE86"
            }
        ]
    };
    let shoesObject12 = {
        designs: [
            {
                sprite: shoesDesign12,
                zIndex: 10,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: shoesDesign12A,
                zIndex: 11,
                defaultColor: "0xDFAC21"
            },
            {
                sprite: shoesDesign12B,
                zIndex: 12,
                defaultColor: "0x3D3D3D"
            }
        ]
    };
    let shoesObject13 = {
        designs: [
            {
                sprite: shoesDesign13,
                zIndex: 10,
                defaultColor: "0x181818"
            },
            {
                sprite: shoesDesign13A,
                zIndex: 11,
                defaultColor: "0x2D862A"
            }
        ]
    };
    let shoesObject14 = {
        designs: [
            {
                sprite: shoesDesign7,
                zIndex: 10,
                defaultColor: "0x323232"
            },
            {
                sprite: shoesDesign14A,
                zIndex: 11,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let shoesObject15 = {
        designs: [
            {
                sprite: shoesDesign7,
                zIndex: 10,
                defaultColor: "0xE6B059"
            },
            {
                sprite: shoesDesign15A,
                zIndex: 11,
                defaultColor: "0x6AABBA"
            }
        ]
    };
    let shoesObject16 = {
        designs: [
            {
                sprite: shoesDesign16,
                zIndex: 10,
                defaultColor: "0xD4A0E9"
            },
            {
                sprite: shoesDesign16A,
                zIndex: 11,
                defaultColor: "0xE8AAE7"
            }
        ]
    };
    let shoesObject17 = {
        designs: [
            {
                sprite: shoesDesign17,
                zIndex: 10,
                defaultColor: "0xF2F2F2"
            },
            {
                sprite: shoesDesign17A,
                zIndex: 11,
                defaultColor: "0x65C8A9"
            }
        ]
    };
    let shoesObject18 = {
        designs: [
            {
                sprite: shoesDesign18,
                zIndex: 10,
                defaultColor: "0x272727"
            },
            {
                sprite: shoesDesign18A,
                zIndex: 11,
                defaultColor: "0x6C94D0"
            }
        ]
    };
    let shoesObject19 = {
        designs: [
            {
                sprite: shoesDesign7,
                zIndex: 10,
                defaultColor: "0xCCCCCC"
            },
            {
                sprite: shoesDesign19A,
                zIndex: 11,
                defaultColor: "0x8B80ED"
            }
        ]
    };
    let shoesObject20 = {
        designs: [
            {
                sprite: shoesDesign7,
                zIndex: 10,
                defaultColor: "0xAF9F8F"
            },
            {
                sprite: shoesDesign20A,
                zIndex: 11,
                defaultColor: "0x63574C"
            }
        ]
    };
    let topObject1 = {
        designs: [
            {
                sprite: topDesign1,
                zIndex: 7,
                defaultColor: "0xB7B7B7"
            },
            {
                sprite: topDesign1A,
                zIndex: 8,
                defaultColor: "0xE3E3E3"
            }
        ]
    };
    let topObject2 = {
        designs: [
            {
                sprite: topDesign2,
                zIndex: 7,
                defaultColor: "0x484848"
            },
            {
                sprite: topDesign2A,
                zIndex: 8,
                defaultColor: "0x232323"
            }
        ]
    };
    let topObject3 = {
        designs: [
            {
                sprite: topDesign3,
                zIndex: 7,
                defaultColor: "0xCD4444"
            }
        ]
    };
    let topObject4 = {
        designs: [
            {
                sprite: topDesign4,
                zIndex: 7,
                defaultColor: "0x2D2D2D"
            },
            {
                sprite: topDesign4A,
                zIndex: 8,
                defaultColor: "0x6EAC6C"
            }
        ]
    };
    let topObject5 = {
        designs: [
            {
                sprite: topDesign5,
                zIndex: 7,
                defaultColor: "0xB85F5F"
            },
            {
                sprite: topDesign5A,
                zIndex: 8,
                defaultColor: "0x515151"
            }
        ]
    };
    let topObject6 = {
        designs: [
            {
                sprite: topDesign6,
                zIndex: 7,
                defaultColor: "0xD3BB6E"
            },
            {
                sprite: topDesign6A,
                zIndex: 8,
                defaultColor: "0xC45265"
            },
            {
                sprite: topDesign6B,
                zIndex: 8,
                defaultColor: "0x526FC4"
            }
        ]
    };
    let topObject7 = {
        designs: [
            {
                sprite: topDesign7,
                zIndex: 7,
                defaultColor: "0xE6D644"
            }
        ]
    };
    let topObject8 = {
        designs: [
            {
                sprite: topDesign8,
                zIndex: 18,
                defaultColor: "0x595E7C"
            }
        ]
    };
    let topObject9 = {
        designs: [
            {
                sprite: topDesign9,
                zIndex: 7,
                defaultColor: "0x857362"
            }
        ]
    };
    let topObject10 = {
        designs: [
            {
                sprite: topDesign10,
                zIndex: 7,
                defaultColor: "0x699B69"
            }
        ]
    };
    let topObject11 = {
        designs: [
            {
                sprite: topDesign11,
                zIndex: 7,
                defaultColor: "0x6198C2"
            }
        ]
    };
    let topObject12 = {
        designs: [
            {
                sprite: topDesign12,
                zIndex: 18,
                defaultColor: "0x5D5D5D"
            },
            {
                sprite: topDesign12A,
                zIndex: 19,
                defaultColor: "0xBDBDBD"
            }
        ]
    };
    let topObject13 = {
        designs: [
            {
                sprite: topDesign11,
                zIndex: 7,
                defaultColor: "0xDBAD58"
            },
            {
                sprite: topDesign13A,
                zIndex: 8,
                defaultColor: "0x6CB4C1"
            }
        ]
    };
    let topObject14 = {
        designs: [
            {
                sprite: topDesign14,
                zIndex: 18,
                defaultColor: "0xDBC952"
            }
        ]
    };
    let topObject15 = {
        designs: [
            {
                sprite: topDesign15,
                zIndex: 7,
                defaultColor: "0x515151"
            },
            {
                sprite: topDesign15A,
                zIndex: 8,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let topObject16 = {
        designs: [
            {
                sprite: topDesign16,
                zIndex: 7,
                defaultColor: "0x7FD1CA"
            },
            {
                sprite: topDesign16A,
                zIndex: 8,
                defaultColor: "0xF8F16F"
            },
            {
                sprite: topDesign16B,
                zIndex: 8,
                defaultColor: "0xDBDBDB"
            }
        ]
    };
    let topObject17 = {
        designs: [
            {
                sprite: topDesign17,
                zIndex: 18,
                defaultColor: "0xF9BFFE"
            }
        ]
    };
    let topObject18 = {
        designs: [
            {
                sprite: topDesign18,
                zIndex: 7,
                defaultColor: "0x7D93F2"
            },
            {
                sprite: topDesign18A,
                zIndex: 8,
                defaultColor: "0x8F70E0"
            }
        ]
    };
    let topObject19 = {
        designs: [
            {
                sprite: topDesign10,
                zIndex: 7,
                defaultColor: "0xD8905C"
            },
            {
                sprite: topDesign19A,
                zIndex: 8,
                defaultColor: "0x958377"
            }
        ]
    };
    let topObject20 = {
        designs: [
            {
                sprite: topDesign7,
                zIndex: 7,
                defaultColor: "0x373737"
            },
            {
                sprite: topDesign20A,
                zIndex: 8,
                defaultColor: "0xBC364C"
            }
        ]
    };
    let topObject21 = {
        designs: [
            {
                sprite: topDesign21,
                zIndex: 18,
                defaultColor: "0xDADADA"
            },
            {
                sprite: topDesign21A,
                zIndex: 19,
                defaultColor: "0x5159AD"
            }
        ]
    };
    let topObject22 = {
        designs: [
            {
                sprite: topDesign10,
                zIndex: 7,
                defaultColor: "0xEBDB55"
            },
            {
                sprite: topDesign22A,
                zIndex: 8,
                defaultColor: "0x65C474"
            }
        ]
    };
    let topObject23 = {
        designs: [
            {
                sprite: topDesign3,
                zIndex: 7,
                defaultColor: "0x9FCEF5"
            },
            {
                sprite: topDesign23A,
                zIndex: 8,
                defaultColor: "0x6899C1"
            }
        ]
    };
    let topObject24 = {
        designs: [
            {
                sprite: topDesign9,
                zIndex: 7,
                defaultColor: "0x363636"
            },
            {
                sprite: topDesign24A,
                zIndex: 8,
                defaultColor: "0xE1BE1A"
            }
        ]
    };
    let topObject25 = {
        designs: [
            {
                sprite: topDesign7,
                zIndex: 7,
                defaultColor: "0x5D5D5D"
            },
            {
                sprite: topDesign25A,
                zIndex: 8,
                defaultColor: "0xDB8A49"
            }
        ]
    };
    let topObject26 = {
        designs: [
            {
                sprite: topDesign9,
                zIndex: 7,
                defaultColor: "0x85755E"
            },
            {
                sprite: topDesign26A,
                zIndex: 8,
                defaultColor: "0x5E5446"
            }
        ]
    };
    let topObject27 = {
        designs: [
            {
                sprite: topDesign11,
                zIndex: 7,
                defaultColor: "0x7B985D"
            },
            {
                sprite: topDesign27A,
                zIndex: 8,
                defaultColor: "0xD2FFA3"
            }
        ]
    };
    let topObject28 = {
        designs: [
            {
                sprite: topDesign3,
                zIndex: 7,
                defaultColor: "0x3B3B3B"
            },
            {
                sprite: topDesign28A,
                zIndex: 8,
                defaultColor: "0xFEC7FF"
            }
        ]
    };
    let topObject29 = {
        designs: [
            {
                sprite: topDesign29,
                zIndex: 7,
                defaultColor: "0x6FB0E7"
            },
            {
                sprite: topDesign29A,
                zIndex: 8,
                defaultColor: "0xE75B5B"
            }
        ]
    };
    let topObject30 = {
        designs: [
            {
                sprite: topDesign7,
                zIndex: 7,
                defaultColor: "0xEBEBEB"
            },
            {
                sprite: topDesign30A,
                zIndex: 8,
                defaultColor: "0x785CAA"
            }
        ]
    };
    let topObject31 = {
        designs: [
            {
                sprite: topDesign31,
                zIndex: 7,
                defaultColor: "0x323232"
            },
            {
                sprite: topDesign31A,
                zIndex: 8,
                defaultColor: "0xDBDBDB"
            },
            {
                sprite: topDesign31B,
                zIndex: 8,
                defaultColor: "0x626262"
            }
        ]
    };
    let topObject32 = {
        designs: [
            {
                sprite: topDesign11,
                zIndex: 7,
                defaultColor: "0x358B7C"
            },
            {
                sprite: topDesign32A,
                zIndex: 8,
                defaultColor: "0x6ACFE7"
            }
        ]
    };
    let topObject33 = {
        designs: [
            {
                sprite: topDesign33,
                zIndex: 7,
                defaultColor: "0xD18E57"
            },
            {
                sprite: topDesign33A,
                zIndex: 8,
                defaultColor: "0xD8D8D8"
            }
        ]
    };
    let topObject34 = {
        designs: [
            {
                sprite: topDesign33,
                zIndex: 7,
                defaultColor: "0x282828"
            },
            {
                sprite: topDesign34A,
                zIndex: 8,
                defaultColor: "0xC54F4F"
            }
        ]
    };
    let topObject35 = {
        designs: [
            {
                sprite: topDesign33,
                zIndex: 7,
                defaultColor: "0x457AA2"
            },
            {
                sprite: topDesign35A,
                zIndex: 8,
                defaultColor: "0x77A3A5"
            }
        ]
    };
    let topObject36 = {
        designs: [
            {
                sprite: topDesign36,
                zIndex: 7,
                defaultColor: "0xFB9A9A"
            }
        ]
    };
    let topObject37 = {
        designs: [
            {
                sprite: topDesign37A,
                zIndex: 7,
                defaultColor: "0x7C7C7C"
            },
            {
                sprite: topDesign37B,
                zIndex: 8,
                defaultColor: "0x3D3E45"
            },
            {
                sprite: topDesign37C,
                zIndex: 9,
                defaultColor: "0xA0A5B7"
            }
        ]
    };
    let topObject38 = {
        designs: [
            {
                sprite: topDesign38,
                zIndex: 7,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let topObject39 = {
        designs: [
            {
                sprite: topDesign39,
                zIndex: 7,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let topObject40 = {
        designs: [
            {
                sprite: topDesign40A,
                zIndex: 7,
                defaultColor: "0x842727"
            },
            {
                sprite: topDesign40B,
                zIndex: 8,
                defaultColor: "0x2D2A2A"
            }
        ]
    };
    let topObject41 = {
        designs: [
            {
                sprite: topDesign1,
                zIndex: 7,
                defaultColor: "0x333333"
            },
            {
                sprite: topDesign41A,
                zIndex: 8,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: topDesign41B,
                zIndex: 8,
                defaultColor: "0xD24143"
            }
        ]
    };
    let topObject42 = {
        designs: [
            {
                sprite: topDesign1,
                zIndex: 7,
                defaultColor: "0x333333"
            },
            {
                sprite: topDesign42,
                zIndex: 8,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let topObject43 = {
        designs: [
            {
                sprite: topDesign1,
                zIndex: 7,
                defaultColor: "0x921B14"
            },
            {
                sprite: topDesign43,
                zIndex: 8,
                defaultColor: "0xBAE37E"
            }
        ]
    };
    let topObject44 = {
        designs: [
            {
                sprite: topDesign1,
                zIndex: 7,
                defaultColor: "0x444444"
            }
        ]
    };
    let topObject45 = {
        designs: [
            {
                sprite: topDesign2,
                zIndex: 7,
                defaultColor: "0xCECECE"
            }
        ]
    };
    let topObject46 = {
        designs: [
            {
                sprite: topDesign44,
                zIndex: 7,
                defaultColor: "0xa36840"
            }
        ]
    };
    let topObject47 = {
        designs: [
            {
                sprite: topDesign45A,
                zIndex: 7,
                defaultColor: "0xA4B9D9"
            },
            {
                sprite: topDesign45B,
                zIndex: 8,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let topObject48 = {
        designs: [
            {
                sprite: topDesign46,
                zIndex: 7,
                defaultColor: "0xF2F2F2"
            }
        ]
    };
    let topObject49 = {
        designs: [
            {
                sprite: topDesign47A,
                zIndex: 7,
                defaultColor: "0x595757"
            },
            {
                sprite: topDesign47B,
                zIndex: 8,
                defaultColor: "0x434343"
            }
        ]
    };
    let topObject50 = {
        designs: [
            {
                sprite: topDesign1,
                zIndex: 7,
                defaultColor: "0x333333"
            },
            {
                sprite: topDesign48A,
                zIndex: 8,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: topDesign48B,
                zIndex: 8,
                defaultColor: "0xFF0100"
            }
        ]
    };
    let topObject51 = {
        designs: [
            {
                sprite: topDesign49A,
                zIndex: 7,
                defaultColor: "0x2D2D2D"
            },
            {
                sprite: topDesign49B,
                zIndex: 8,
                defaultColor: "0xF0F0F0"
            }
        ]
    };
    let topObject52 = {
        designs: [
            {
                sprite: topDesign50A,
                zIndex: 7,
                defaultColor: "0x8CBFDA"
            },
            {
                sprite: topDesign50B,
                zIndex: 8,
                defaultColor: "0xC7565C"
            },
            {
                sprite: topDesign50C,
                zIndex: 8,
                defaultColor: "0x6C8B3F"
            },
            {
                sprite: topDesign50D,
                zIndex: 8,
                defaultColor: "0xD2CE9C"
            }
        ]
    };
    let topObject53 = {
        designs: [
            {
                sprite: topDesign1,
                zIndex: 7,
                defaultColor: "0x333333"
            },
            {
                sprite: topDesign51,
                zIndex: 8,
                defaultColor: "0xD8D8D8"
            }
        ]
    };
    let topObject54 = {
        designs: [
            {
                sprite: topDesign1,
                zIndex: 7,
                defaultColor: "0x333333"
            },
            {
                sprite: topDesign52,
                zIndex: 8,
                defaultColor: "0xD8D8D8"
            }
        ]
    };
    let elbowObject1 = {
        designs: [
            {
                sprite: elbowDesign1,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let elbowObject2 = {
        designs: [
            {
                sprite: elbowDesign2,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let elbowObject3 = {
        designs: [
            {
                sprite: elbowDesign3,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let elbowObject4 = {
        designs: [
            {
                sprite: elbowDesign4,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let elbowObject5 = {
        designs: [
            {
                sprite: elbowDesign5,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let elbowObject6 = {
        designs: [
            {
                sprite: elbowDesign6,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let elbowObject7 = {
        designs: [
            {
                sprite: elbowDesign7,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            },
            {
                sprite: elbowDesign7A,
                zIndex: 10,
                defaultColor: "0x363636"
            }
        ]
    };
    let elbowObject8 = {
        designs: [
            {
                sprite: elbowDesign8,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let elbowObject9 = {
        designs: [
            {
                sprite: elbowDesign9,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let elbowObject10 = {
        designs: [
            {
                sprite: elbowDesign10,
                zIndex: 10,
                defaultColor: "0x1B1B1B"
            }
        ]
    };
    let facialHairObject1 = {
        designs: [
            {
                sprite: facialHairDesign1,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject2 = {
        designs: [
            {
                sprite: facialHairDesign2,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject3 = {
        designs: [
            {
                sprite: facialHairDesign3,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject4 = {
        designs: [
            {
                sprite: facialHairDesign4,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject5 = {
        designs: [
            {
                sprite: facialHairDesign5,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject6 = {
        designs: [
            {
                sprite: facialHairDesign6,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject7 = {
        designs: [
            {
                sprite: facialHairDesign7,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject8 = {
        designs: [
            {
                sprite: facialHairDesign8,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject9 = {
        designs: [
            {
                sprite: facialHairDesign9,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject10 = {
        designs: [
            {
                sprite: facialHairDesign10,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject11 = {
        designs: [
            {
                sprite: facialHairDesign11,
                zIndex: 25,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject12 = {
        designs: [
            {
                sprite: facialHairDesign12,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject13 = {
        designs: [
            {
                sprite: facialHairDesign13,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject14 = {
        designs: [
            {
                sprite: facialHairDesign14,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject15 = {
        designs: [
            {
                sprite: facialHairDesign15,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject16 = {
        designs: [
            {
                sprite: facialHairDesign16,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject17 = {
        designs: [
            {
                sprite: facialHairDesign17,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject18 = {
        designs: [
            {
                sprite: facialHairDesign18,
                zIndex: 24,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject19 = {
        designs: [
            {
                sprite: facialHairDesign19,
                zIndex: 11,
                defaultColor: "0x635955"
            }
        ]
    };
    let facialHairObject20 = {
        designs: [
            {
                sprite: facialHairDesign20,
                zIndex: 11,
                defaultColor: "0x635955"
            }
        ]
    };
    let accessoryObject1 = {
        designs: [
            {
                sprite: accessoryDesign1A,
                zIndex: -2,
                defaultColor: "0x9C2525"
            },
            {
                sprite: accessoryDesign1B,
                zIndex: 20,
                defaultColor: "0x9C2525"
            },
            {
                sprite: accessoryDesign1C,
                zIndex: 21,
                defaultColor: "0x404040"
            }
        ]
    };
    let accessoryObject2 = {
        designs: [
            {
                sprite: accessoryDesign2A,
                zIndex: -2,
                defaultColor: "0x3F6840"
            },
            {
                sprite: accessoryDesign2B,
                zIndex: 20,
                defaultColor: "0x3F6840"
            }
        ]
    };
    let accessoryObject3 = {
        designs: [
            {
                sprite: accessoryDesign3A,
                zIndex: -2,
                defaultColor: "0x947FD3"
            },
            {
                sprite: accessoryDesign3B,
                zIndex: -2,
                defaultColor: "0xE2E2E2"
            },
            {
                sprite: accessoryDesign3C,
                zIndex: 20,
                defaultColor: "0x947FD3"
            },
            {
                sprite: accessoryDesign3D,
                zIndex: 21,
                defaultColor: "0xE2E2E2"
            }
        ]
    };
    let accessoryObject4 = {
        designs: [
            {
                sprite: accessoryDesign4,
                zIndex: 2,
                defaultColor: "0xffff00"
            }
        ]
    };
    let accessoryObject5 = {
        designs: [
            {
                sprite: accessoryDesign5,
                zIndex: 2,
                defaultColor: "0xffff00"
            },
            {
                sprite: accessoryDesign5A,
                zIndex: 3,
                defaultColor: "0x6768CE"
            }
        ]
    };
    let accessoryObject6 = {
        designs: [
            {
                sprite: accessoryDesign6,
                zIndex: 26,
                defaultColor: "0xE4E3B7"
            }
        ]
    };
    let accessoryObject7 = {
        designs: [
            {
                sprite: accessoryDesign7,
                zIndex: 20,
                defaultColor: "0xC6364E"
            },
            {
                sprite: accessoryDesign7A,
                zIndex: 21,
                defaultColor: "0xEFD73C"
            }
        ]
    };
    let accessoryObject8 = {
        designs: [
            {
                sprite: accessoryDesign8,
                zIndex: 20,
                defaultColor: "0x4883C2"
            },
            {
                sprite: accessoryDesign8A,
                zIndex: 21,
                defaultColor: "0xD64E44"
            },
            {
                sprite: accessoryDesign8B,
                zIndex: 21,
                defaultColor: "0x46C44A"
            }
        ]
    };
    let accessoryObject9 = {
        designs: [
            {
                sprite: accessoryDesign9,
                zIndex: 26,
                defaultColor: "0x202020"
            }
        ]
    };
    let accessoryObject10 = {
        designs: [
            {
                sprite: accessoryDesign10,
                zIndex: 20,
                defaultColor: "0x2D2D2D"
            }
        ]
    };
    let accessoryObject11 = {
        designs: [
            {
                sprite: accessoryDesign11,
                zIndex: 2,
                defaultColor: "0xF4F4F4"
            }
        ]
    };
    let accessoryObject12 = {
        designs: [
            {
                sprite: accessoryDesign11,
                zIndex: 2,
                defaultColor: "0x6CA3D9"
            },
            {
                sprite: accessoryDesign11A,
                zIndex: 3,
                defaultColor: "0xCE8A4A"
            }
        ]
    };
    let accessoryObject13 = {
        designs: [
            {
                sprite: accessoryDesign11,
                zIndex: 2,
                defaultColor: "0xEBEBEB"
            },
            {
                sprite: accessoryDesign12A,
                zIndex: 3,
                defaultColor: "0x9C2525"
            }
        ]
    };
    let accessoryObject14 = {
        designs: [
            {
                sprite: accessoryDesign13,
                zIndex: 22,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let accessoryObject15 = {
        designs: [
            {
                sprite: accessoryDesign14A,
                zIndex: 2,
                defaultColor: "0x8C6137"
            },
            {
                sprite: accessoryDesign14B,
                zIndex: 3,
                defaultColor: "0x683605"
            }
        ]
    };
    let accessoryObject16 = {
        designs: [
            {
                sprite: accessoryDesign15,
                zIndex: 2,
                defaultColor: "0x8C8C8C"
            }
        ]
    };
    let accessoryObject17 = {
        designs: [
            {
                sprite: accessoryDesign16A,
                zIndex: 12,
                defaultColor: "0x693420"
            },
            {
                sprite: accessoryDesign16B,
                zIndex: 13,
                defaultColor: "0x59EBE6"
            }
        ]
    };
    let accessoryObject18 = {
        designs: [
            {
                sprite: accessoryDesign17,
                zIndex: 2,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let accessoryObject19 = {
        designs: [
            {
                sprite: accessoryDesign18,
                zIndex: 26,
                defaultColor: "0xCC3636"
            }
        ]
    };
    let accessoryObject20 = {
        designs: [
            {
                sprite: accessoryDesign19,
                zIndex: 20,
                defaultColor: "0x5F5F5F"
            }
        ]
    };
    let accessoryObject21 = {
        designs: [
            {
                sprite: accessoryDesign20,
                zIndex: 20,
                defaultColor: "0xF3F3F3"
            }
        ]
    };
    let accessoryObject22 = {
        designs: [
            {
                sprite: accessoryDesign21A,
                zIndex: 26,
                defaultColor: "0x1F3E7F"
            },
            {
                sprite: accessoryDesign21B,
                zIndex: 26,
                defaultColor: "0xC15E34"
            }
        ]
    };
    let accessoryObject23 = {
        designs: [
            {
                sprite: accessoryDesign22A,
                zIndex: 26,
                defaultColor: "0xF1BF64"
            },
            {
                sprite: accessoryDesign22B,
                zIndex: 26,
                defaultColor: "0x598128"
            },
            {
                sprite: accessoryDesign22C,
                zIndex: 26,
                defaultColor: "0x555555"
            }
        ]
    };
    let accessoryObject24 = {
        designs: [
            {
                sprite: accessoryDesign23A,
                zIndex: 26,
                defaultColor: "0x3A3A3A"
            },
            {
                sprite: accessoryDesign23B,
                zIndex: 26,
                defaultColor: "0x535353"
            }
        ]
    };
    let accessoryObject25 = {
        designs: [
            {
                sprite: accessoryDesign24A,
                zIndex: 30,
                defaultColor: "0xFAEC90"
            },
            {
                sprite: accessoryDesign24B,
                zIndex: 30,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let accessoryObject26 = {
        designs: [
            {
                sprite: accessoryDesign25A,
                zIndex: 26,
                defaultColor: "0x1F1F1F"
            },
            {
                sprite: accessoryDesign25B,
                zIndex: 26,
                defaultColor: "0xF0BC6E"
            }
        ]
    };
    let accessoryObject27 = {
        designs: [
            {
                sprite: accessoryDesign26A,
                zIndex: -2,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: accessoryDesign26B,
                zIndex: -2,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let accessoryObject28 = {
        designs: [
            {
                sprite: accessoryDesign27A,
                zIndex: -2,
                defaultColor: "0xBF58C5"
            },
            {
                sprite: accessoryDesign27B,
                zIndex: -2,
                defaultColor: "0xF29541"
            }
        ]
    };
    let accessoryObject29 = {
        designs: [
            {
                sprite: accessoryDesign28A,
                zIndex: 30,
                defaultColor: "0x383838"
            }
        ]
    };
    let accessoryObject30 = {
        designs: [
            {
                sprite: accessoryDesign29A,
                zIndex: 30,
                defaultColor: "0xCCA670"
            },
            {
                sprite: accessoryDesign29B,
                zIndex: 30,
                defaultColor: "0x4D4D4D"
            }
        ]
    };
    let accessoryObject31 = {
        designs: [
            {
                sprite: accessoryDesign30A,
                zIndex: 30,
                defaultColor: "0xD9BA5B"
            },
            {
                sprite: accessoryDesign30B,
                zIndex: 30,
                defaultColor: "0xD2D2D2"
            }
        ]
    };
    let accessoryObject32 = {
        designs: [
            {
                sprite: accessoryDesign31A,
                zIndex: 30,
                defaultColor: "0xEAC123"
            },
            {
                sprite: accessoryDesign31B,
                zIndex: 30,
                defaultColor: "0xDF3030"
            }
        ]
    };
    // Base face mask
    let accessoryObject33 = {
        designs: [
            {
                sprite: accessoryDesign32Base,
                zIndex: 30,
                defaultColor: "0x333333"
            }
        ]
    };
    // Styled face masks
    let accessoryObject34 = {
        designs: [
            {
                sprite: accessoryDesign32Base,
                zIndex: 30,
                defaultColor: "0x333333"
            },
            {
                sprite: accessoryDesign32A,
                zIndex: 30,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let accessoryObject35 = {
        designs: [
            {
                sprite: accessoryDesign32Base,
                zIndex: 30,
                defaultColor: "0x4E4E4E"
            },
            {
                sprite: accessoryDesign32B,
                zIndex: 31,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let accessoryObject36 = {
        designs: [
            {
                sprite: accessoryDesign32Base,
                zIndex: 30,
                defaultColor: "0x5F5F5F"
            },
            {
                sprite: accessoryDesign32C,
                zIndex: 31,
                defaultColor: "0xC9AF2E"
            }
        ]
    };
    let accessoryObject37 = {
        designs: [
            {
                sprite: accessoryDesign33A,
                zIndex: 30,
                defaultColor: "0xDF0000"
            },
            {
                sprite: accessoryDesign33B,
                zIndex: 31,
                defaultColor: "0xF0F0F0"
            }
        ]
    };
    let accessoryObject38 = {
        designs: [
            {
                sprite: accessoryDesign34A,
                zIndex: 20,
                defaultColor: "0x3A3A3A"
            },
            {
                sprite: accessoryDesign34B,
                zIndex: -2,
                defaultColor: "0x3A3A3A"
            },
            {
                sprite: accessoryDesign34C,
                zIndex: 21,
                defaultColor: "0x949494"
            }
        ]
    };
    let accessoryObject39 = {
        designs: [
            {
                sprite: accessoryDesign35A,
                zIndex: 20,
                defaultColor: "0x434343"
            },
            {
                sprite: accessoryDesign35B,
                zIndex: 20,
                defaultColor: "0xD8D8D8"
            },
            {
                sprite: accessoryDesign35C,
                zIndex: 21,
                defaultColor: "0xF8F8F8"
            }
        ]
    };
    let accessoryObject40 = {
        designs: [
            {
                sprite: accessoryDesign36A,
                zIndex: 26,
                defaultColor: "0xCBD7DA"
            },
            {
                sprite: accessoryDesign36B,
                zIndex: 26,
                defaultColor: "0x9B845D"
            },
            {
                sprite: accessoryDesign36C,
                zIndex: 27,
                defaultColor: "0xE9E2D4"
            }
        ]
    };
    let accessoryObject41 = {
        designs: [
            {
                sprite: accessoryDesign37A,
                zIndex: 30,
                defaultColor: "0xCCCCCC"
            },
            {
                sprite: accessoryDesign37B,
                zIndex: 31,
                defaultColor: "0x969696"
            },
            {
                sprite: accessoryDesign37C,
                zIndex: 31,
                defaultColor: "0xE5564D"
            }
        ]
    };
    let accessoryObject42 = {
        designs: [
            {
                sprite: accessoryDesign38A,
                zIndex: 9,
                defaultColor: "0x616060"
            },
            {
                sprite: accessoryDesign38B,
                zIndex: 10,
                defaultColor: "0x616060"
            },
            {
                sprite: accessoryDesign38C,
                zIndex: 10,
                defaultColor: "0xA1A1A1"
            }
        ]
    };
    let accessoryObject43 = {
        designs: [
            {
                sprite: accessoryDesign39A,
                zIndex: 32,
                defaultColor: "0xD60C08"
            },
            {
                sprite: accessoryDesign39B,
                zIndex: 30,
                defaultColor: "0x262626"
            },
            {
                sprite: accessoryDesign39C,
                zIndex: 31,
                defaultColor: "0xD6E3DF"
            },
            {
                sprite: accessoryDesign39D,
                zIndex: 33,
                defaultColor: "0xFDEF50"
            }
        ]
    };
    let accessoryObject44 = {
        designs: [
            {
                sprite: accessoryDesign40A,
                zIndex: 30,
                defaultColor: "0xEDE4D9"
            },
            {
                sprite: accessoryDesign40B,
                zIndex: 31,
                defaultColor: "0x292929"
            },
            {
                sprite: accessoryDesign40C,
                zIndex: 31,
                defaultColor: "0xB0000F"
            }
        ]
    };
    let accessoryObject45 = {
        designs: [
            {
                sprite: accessoryDesign41A,
                zIndex: 30,
                defaultColor: "0xD1D1D1"
            },
            {
                sprite: accessoryDesign41B,
                zIndex: 31,
                defaultColor: "0xD1B78A"
            }
        ]
    };
    let accessoryObject46 = {
        designs: [
            {
                sprite: accessoryDesign42A,
                zIndex: 26,
                defaultColor: "0xE4E4E4"
            },
            {
                sprite: accessoryDesign42B,
                zIndex: 27,
                defaultColor: "0xEE5F74"
            },
            {
                sprite: accessoryDesign42C,
                zIndex: 28,
                defaultColor: "0xD47281"
            }
        ]
    };
    let accessoryObject47 = {
        designs: [
            {
                sprite: accessoryDesign43A,
                zIndex: 30,
                defaultColor: "0xE0E0E0"
            },
            {
                sprite: accessoryDesign43B,
                zIndex: 31,
                defaultColor: "0x8D8D8D"
            }
        ]
    };
    let accessoryObject48 = {
        designs: [
            {
                sprite: accessoryDesign44A,
                zIndex: 30,
                defaultColor: "0x535353"
            },
            {
                sprite: accessoryDesign44B,
                zIndex: 31,
                defaultColor: "0x535353"
            }
        ]
    };
    let accessoryObject49 = {
        designs: [
            {
                sprite: accessoryDesign45A,
                zIndex: 30,
                defaultColor: "0xC8A979"
            }
        ]
    };
    let accessoryObject50 = {
        designs: [
            {
                sprite: accessoryDesign46A,
                zIndex: 30,
                defaultColor: "0xE8E8E8"
            },
            {
                sprite: accessoryDesign46B,
                zIndex: 30,
                defaultColor: "0xCC3C3C"
            }
        ]
    };
    let accessoryObject51 = {
        designs: [
            {
                sprite: accessoryDesign47A,
                zIndex: 30,
                defaultColor: "0xBF0000"
            }
        ]
    };
    let accessoryObject52 = {
        designs: [
            {
                sprite: accessoryDesign48A,
                zIndex: 31,
                defaultColor: "0x0D0D0D"
            },
            {
                sprite: accessoryDesign48B,
                zIndex: 31,
                defaultColor: "0x0D0D0D"
            },
            {
                sprite: accessoryDesign48C,
                zIndex: 30,
                defaultColor: "0xA6A6A6"
            }
        ]
    };
    let accessoryObject53 = {
        designs: [
            {
                sprite: accessoryDesign49A,
                zIndex: 30,
                defaultColor: "0xFADA9E"
            },
            {
                sprite: accessoryDesign49B,
                zIndex: 30,
                defaultColor: "0x755B3D"
            },
            {
                sprite: accessoryDesign49C,
                zIndex: 30,
                defaultColor: "0x423A30"
            },
            {
                sprite: accessoryDesign49D,
                zIndex: 30,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let accessoryObject54 = {
        designs: [
            {
                sprite: accessoryDesign50A,
                zIndex: 30,
                defaultColor: "0xEEEEEE"
            },
            {
                sprite: accessoryDesign50B,
                zIndex: 31,
                defaultColor: "0xCD2323"
            },
            {
                sprite: accessoryDesign50C,
                zIndex: 31,
                defaultColor: "0xD91414"
            },
            {
                sprite: accessoryDesign50D,
                zIndex: 31,
                defaultColor: "0xCD2323"
            }
        ]
    };
    let accessoryObject55 = {
        designs: [
            {
                sprite: accessoryDesign51A,
                zIndex: 30,
                defaultColor: "0x555555"
            }
        ]
    };
    let accessoryObject56 = {
        designs: [
            {
                sprite: accessoryDesign52A,
                zIndex: 30,
                defaultColor: "0xD0D5D9"
            }
        ]
    };
    let accessoryObject57 = {
        designs: [
            {
                sprite: accessoryDesign53A,
                zIndex: 30,
                defaultColor: "0xAE2D2D"
            },
            {
                sprite: accessoryDesign53B,
                zIndex: 30,
                defaultColor: "0xE8E8E8"
            },
            {
                sprite: accessoryDesign53C,
                zIndex: 30,
                defaultColor: "0xD9D9D9"
            }
        ]
    };
    let accessoryObject58 = {
        designs: [
            {
                sprite: accessoryDesign54A,
                zIndex: 30,
                defaultColor: "0x957F5F"
            },
            {
                sprite: accessoryDesign54B,
                zIndex: 30,
                defaultColor: "0x656565"
            }
        ]
    };
    let accessoryObject59 = {
        designs: [
            {
                sprite: accessoryDesign55A,
                zIndex: 30,
                defaultColor: "0xC2493A"
            },
            {
                sprite: accessoryDesign55B,
                zIndex: 30,
                defaultColor: "0xEBEBEB"
            },
            {
                sprite: accessoryDesign55C,
                zIndex: 30,
                defaultColor: "0x565656"
            },
            {
                sprite: accessoryDesign55D,
                zIndex: 30,
                defaultColor: "0xBEBEBE"
            }
        ]
    };
    let accessoryObject60 = {
        designs: [
            {
                sprite: accessoryDesign56A,
                zIndex: 30,
                defaultColor: "0xE8CD8F"
            },
            {
                sprite: accessoryDesign56B,
                zIndex: 30,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let accessoryObject61 = {
        designs: [
            {
                sprite: accessoryDesign57A,
                zIndex: 2,
                defaultColor: "0xE1E1E1"
            },
            {
                sprite: accessoryDesign57B,
                zIndex: 3,
                defaultColor: "0x4A4A4A"
            }
        ]
    };
    let accessoryObject62 = {
        designs: [
            {
                sprite: accessoryDesign58A,
                zIndex: 2,
                defaultColor: "0xF7EE51"
            },
            {
                sprite: accessoryDesign58B,
                zIndex: 3,
                defaultColor: "0x4A4A4A"
            }
        ]
    };
    let accessoryObject63 = {
        designs: [
            {
                sprite: accessoryDesign59A,
                zIndex: 30,
                defaultColor: "0xEFEFEF"
            },
            {
                sprite: accessoryDesign59B,
                zIndex: 30,
                defaultColor: "0xBB1313"
            },
            {
                sprite: accessoryDesign59C,
                zIndex: 30,
                defaultColor: "0x1E3A74"
            },
            {
                sprite: accessoryDesign59D,
                zIndex: 30,
                defaultColor: "0xCCCCCC"
            }
        ]
    };
    let accessoryObject64 = {
        designs: [
            {
                sprite: accessoryDesign60A,
                zIndex: 30,
                defaultColor: "0xEC1D1E"
            },
            {
                sprite: accessoryDesign60B,
                zIndex: 30,
                defaultColor: "0xEFEFEF"
            },
            {
                sprite: accessoryDesign60C,
                zIndex: 30,
                defaultColor: "0xEC1D1E"
            },
            {
                sprite: accessoryDesign59D,
                zIndex: 30,
                defaultColor: "0xCCCCCC"
            }
        ]
    };
    let accessoryObject65 = {
        designs: [
            {
                sprite: accessoryDesign61A,
                zIndex: 30,
                defaultColor: "0x0032A5"
            },
            {
                sprite: accessoryDesign61B,
                zIndex: 30,
                defaultColor: "0xEFEFEF"
            },
            {
                sprite: accessoryDesign61C,
                zIndex: 30,
                defaultColor: "0xF02832"
            },
            {
                sprite: accessoryDesign59D,
                zIndex: 30,
                defaultColor: "0xCCCCCC"
            }
        ]
    };
    let accessoryObject66 = {
        designs: [
            {
                sprite: accessoryDesign62A,
                zIndex: 30,
                defaultColor: "0x1F1F1F"
            },
            {
                sprite: accessoryDesign62B,
                zIndex: 30,
                defaultColor: "0xD20000"
            },
            {
                sprite: accessoryDesign62C,
                zIndex: 30,
                defaultColor: "0xF2C300"
            },
            {
                sprite: accessoryDesign59D,
                zIndex: 30,
                defaultColor: "0xCCCCCC"
            }
        ]
    };
    let accessoryObject67 = {
        designs: [
            {
                sprite: accessoryDesign63A,
                zIndex: 30,
                defaultColor: "0x005BBC"
            },
            {
                sprite: accessoryDesign63B,
                zIndex: 30,
                defaultColor: "0xF2CA00"
            },
            {
                sprite: accessoryDesign59D,
                zIndex: 30,
                defaultColor: "0xCCCCCC"
            }
        ]
    };
    let accessoryObject68 = {
        designs: [
            {
                sprite: accessoryDesign64A,
                zIndex: 30,
                defaultColor: "0xC21010"
            },
            {
                sprite: accessoryDesign64B,
                zIndex: 30,
                defaultColor: "0xF3F3F3"
            },
            {
                sprite: accessoryDesign59D,
                zIndex: 30,
                defaultColor: "0xCCCCCC"
            }
        ]
    };
    let accessoryObject69 = {
        designs: [
            {
                sprite: accessoryDesign65A,
                zIndex: 30,
                defaultColor: "0xC9082A"
            },
            {
                sprite: accessoryDesign65B,
                zIndex: 30,
                defaultColor: "0xF3F3F3"
            },
            {
                sprite: accessoryDesign65C,
                zIndex: 30,
                defaultColor: "0x0B1F4F"
            },
            {
                sprite: accessoryDesign59D,
                zIndex: 30,
                defaultColor: "0xCCCCCC"
            }
        ]
    };
    let accessoryObject70 = {
        designs: [
            {
                sprite: accessoryDesign66A,
                zIndex: 30,
                defaultColor: "0x505050"
            },
            {
                sprite: accessoryDesign66B,
                zIndex: 30,
                defaultColor: "0x888888"
            }
        ]
    };
    let accessoryObject71 = {
        designs: [
            {
                sprite: accessoryDesign67A,
                zIndex: 30,
                defaultColor: "0xEBC729"
            },
            {
                sprite: accessoryDesign67B,
                zIndex: 30,
                defaultColor: "0x635034"
            }
        ]
    };
    let accessoryObject72 = {
        designs: [
            {
                sprite: accessoryDesign68A,
                zIndex: 30,
                defaultColor: "0xD95C2B"
            },
            {
                sprite: accessoryDesign68B,
                zIndex: 30,
                defaultColor: "0xE3E4E4"
            },
            {
                sprite: accessoryDesign68C,
                zIndex: 30,
                defaultColor: "0xD95C2B"
            },
            {
                sprite: accessoryDesign68D,
                zIndex: 30,
                defaultColor: "0x525252"
            }
        ]
    };
    let accessoryObject73 = {
        designs: [
            {
                sprite: accessoryDesign69A,
                zIndex: 0,
                defaultColor: "0x777777"
            }
        ]
    };
    let accessoryObject74 = {
        designs: [
            {
                sprite: accessoryDesign70A,
                zIndex: 30,
                defaultColor: "0x696969"
            },
            {
                sprite: accessoryDesign70B,
                zIndex: 31,
                defaultColor: "0xE3E3E3"
            }
        ]
    };
    let accessoryObject75 = {
        designs: [
            {
                sprite: accessoryDesign71A,
                zIndex: 30,
                defaultColor: "0x696969"
            },
            {
                sprite: accessoryDesign71B,
                zIndex: 31,
                defaultColor: "0xEEF2F3"
            },
            {
                sprite: accessoryDesign71C,
                zIndex: 31,
                defaultColor: "0xD3BE00"
            }
        ]
    };
    let accessoryObject76 = {
        designs: [
            {
                sprite: accessoryDesign72A,
                zIndex: 30,
                defaultColor: "0x404040"
            },
            {
                sprite: accessoryDesign72B,
                zIndex: 31,
                defaultColor: "0xEEEEEE"
            }
        ]
    };
    // Gloves
    let glovesObject1 = {
        designs: [
            {
                sprite: glovesDesign1,
                zIndex: 2,
                defaultColor: "0x424242"
            }
        ]
    };
    let glovesObject2 = {
        designs: [
            {
                sprite: glovesDesign2A,
                zIndex: 2,
                defaultColor: "0xFF443C"
            },
            {
                sprite: glovesDesign2B,
                zIndex: 2,
                defaultColor: "0x2E3F34"
            }
        ]
    };
    let glovesObject3 = {
        designs: [
            {
                sprite: glovesDesign3A,
                zIndex: 2,
                defaultColor: "0x0D9C9E"
            },
            {
                sprite: glovesDesign3B,
                zIndex: 2,
                defaultColor: "0x424242"
            }
        ]
    };
    let glovesObject4 = {
        designs: [
            {
                sprite: glovesDesign4A,
                zIndex: 2,
                defaultColor: "0xECECEC"
            },
            {
                sprite: glovesDesign4B,
                zIndex: 2,
                defaultColor: "0x333333"
            }
        ]
    };
    let glovesObject5 = {
        designs: [
            {
                sprite: glovesDesign5A,
                zIndex: 2,
                defaultColor: "0x333333"
            },
            {
                sprite: glovesDesign5B,
                zIndex: 2,
                defaultColor: "0xAAAAAA"
            }
        ]
    };
    let glovesObject6 = {
        designs: [
            {
                sprite: glovesDesign6A,
                zIndex: 2,
                defaultColor: "0x333333"
            },
            {
                sprite: glovesDesign6B,
                zIndex: 2,
                defaultColor: "0xe5bd43"
            }
        ]
    };
    // Glasses
    let glassesObject2 = {
        designs: [
            {
                sprite: glassesDesign2,
                zIndex: 20,
                defaultColor: "0x333333"
            }
        ]
    };
    let glassesObject3 = {
        designs: [
            {
                sprite: glassesDesign3,
                zIndex: 20,
                defaultColor: "0x333333"
            }
        ]
    };
    let glassesObject4 = {
        designs: [
            {
                sprite: glassesDesign4,
                zIndex: 20,
                defaultColor: "0x333333"
            }
        ]
    };
    let glassesObject5 = {
        designs: [
            {
                sprite: glassesDesign5,
                zIndex: 20,
                defaultColor: "0x333333"
            }
        ]
    };
    let glassesObject6 = {
        designs: [
            {
                sprite: glassesDesign6,
                zIndex: 20,
                defaultColor: "0x333333"
            }
        ]
    };
    let glassesObject7 = {
        designs: [
            {
                sprite: glassesDesign7A,
                zIndex: 20,
                defaultColor: "0x333333"
            },
            {
                sprite: glassesDesign7B,
                zIndex: 20,
                defaultColor: "0xA9504C"
            }
        ]
    };
    let glassesObject8 = {
        designs: [
            {
                sprite: glassesDesign8A,
                zIndex: 20,
                defaultColor: "0xDEDEDE"
            },
            {
                sprite: glassesDesign8B,
                zIndex: 20,
                defaultColor: "0x333333"
            }
        ]
    };
    // Wrist tapes
    let wristTapeObject1 = {
        designs: [
            {
                sprite: wristTape1,
                zIndex: 2,
                defaultColor: "0xF4F4F4"
            }
        ]
    };
    let wristTapeObject2 = {
        designs: [
            {
                sprite: wristTape2,
                zIndex: 2,
                defaultColor: "0xF4F4F4"
            }
        ]
    };
    let wristTapeObject3 = {
        designs: [
            {
                sprite: wristTape3,
                zIndex: 2,
                defaultColor: "0xf4f4f4"
            }
        ]
    };
    // Ties
    let tiesObject1 = {
        designs: [
            {
                sprite: ties1,
                zIndex: 9,
                defaultColor: "0xE13636"
            }
        ]
    };
    let tiesObject2 = {
        designs: [
            {
                sprite: ties2,
                zIndex: 9,
                defaultColor: "0x4A63CC"
            }
        ]
    };
    let tiesObject3 = {
        designs: [
            {
                sprite: ties3,
                zIndex: 9,
                defaultColor: "0x7D4DD9"
            }
        ]
    };
    let tiesObject4 = {
        designs: [
            {
                sprite: ties4,
                zIndex: 9,
                defaultColor: "0x6E6E6E"
            }
        ]
    };
    // Suits
    let suitsObject1 = {
        designs: [
            {
                sprite: suits1,
                zIndex: 10,
                defaultColor: "0x6E6E6E"
            }
        ]
    };
    let suitsObject2 = {
        designs: [
            {
                sprite: suits2,
                zIndex: 10,
                defaultColor: "0x365994"
            }
        ]
    };
    let suitsObject3 = {
        designs: [
            {
                sprite: suits3A,
                zIndex: 10,
                defaultColor: "0x6E6E6E"
            },
            {
                sprite: suits3B,
                zIndex: 10,
                defaultColor: "0xE4E4E4"
            }
        ]
    };
    // Face paint
    let facepaintObject2Female = {
        designs: [
            {
                sprite: facepaint2Female,
                zIndex: 10,
                defaultColor: "0xDF6565"
            }
        ]
    };
    let facepaintObject3Female = {
        designs: [
            {
                sprite: facepaint3Female,
                zIndex: 10,
                defaultColor: "0x474747"
            }
        ]
    };
    let facepaintObject4Female = {
        designs: [
            {
                sprite: facepaint4AFemale,
                zIndex: 10,
                defaultColor: "0x474747"
            },
            {
                sprite: facepaint4BFemale,
                zIndex: 10,
                defaultColor: "0xECD58B"
            }
        ]
    };
    let facepaintObject5Female = {
        designs: [
            {
                sprite: facepaint5AFemale,
                zIndex: 10,
                defaultColor: "0x474747"
            },
            {
                sprite: facepaint5BFemale,
                zIndex: 10,
                defaultColor: "0xECD58B"
            }
        ]
    };
    let facepaintObject6Female = {
        designs: [
            {
                sprite: facepaint6AFemale,
                zIndex: 10,
                defaultColor: "0xDCDCDC"
            },
            {
                sprite: facepaint6BFemale,
                zIndex: 10,
                defaultColor: "0x484848"
            }
        ]
    };
    let facepaintObject7Female = {
        designs: [
            {
                sprite: facepaint7AFemale,
                zIndex: 10,
                defaultColor: "0xDC7E6F"
            },
            {
                sprite: facepaint7B,
                zIndex: 10,
                defaultColor: "0xC7E278"
            },
            {
                sprite: facepaint7C,
                zIndex: 10,
                defaultColor: "0x303030"
            }
        ]
    };
    let facepaintObject8Female = {
        designs: [
            {
                sprite: facepaint8AFemale,
                zIndex: 10,
                defaultColor: "0x6F6BD4"
            },
            {
                sprite: facepaint8BFemale,
                zIndex: 10,
                defaultColor: "0xE7DE7F"
            }
        ]
    };
    let facepaintObject9Female = {
        designs: [
            {
                sprite: facepaint9AFemale,
                zIndex: 10,
                defaultColor: "0x242424"
            },
            {
                sprite: facepaint9BFemale,
                zIndex: 10,
                defaultColor: "0xD84444"
            },
            {
                sprite: facepaint9CFemale,
                zIndex: 10,
                defaultColor: "0xD5D5D5"
            }
        ]
    };
    let facepaintObject10Female = {
        designs: [
            {
                sprite: facepaint10AFemale,
                zIndex: 10,
                defaultColor: "0xFDCF89"
            },
            {
                sprite: facepaint10BFemale,
                zIndex: 10,
                defaultColor: "0x303030"
            }
        ]
    };
    let facepaintObject11Female = {
        designs: [
            {
                sprite: facepaint11AFemale,
                zIndex: 10,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: facepaint11BFemale,
                zIndex: 10,
                defaultColor: "0x525054"
            }
        ]
    };
    let facepaintObject12Female = {
        designs: [
            {
                sprite: facepaint12AFemale,
                zIndex: 10,
                defaultColor: "0xF35562"
            },
            {
                sprite: facepaint12BFemale,
                zIndex: 10,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let facepaintObject1 = {
        designs: [
            {
                sprite: facepaint1,
                zIndex: 10,
                defaultColor: "0x474747"
            }
        ]
    };
    let facepaintObject2 = {
        designs: [
            {
                sprite: facepaint2,
                zIndex: 10,
                defaultColor: "0xDF6565"
            }
        ],
        femaleObject: facepaintObject2Female
    };
    facepaintObject2Female.maleObject = facepaintObject2;
    let facepaintObject3 = {
        designs: [
            {
                sprite: facepaint3,
                zIndex: 10,
                defaultColor: "0x474747"
            }
        ],
        femaleObject: facepaintObject3Female
    };
    facepaintObject3Female.maleObject = facepaintObject3;
    let facepaintObject4 = {
        designs: [
            {
                sprite: facepaint4A,
                zIndex: 10,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: facepaint4B,
                zIndex: 11,
                defaultColor: "0x191919"
            }
        ],
        femaleObject: facepaintObject4Female
    };
    facepaintObject4Female.maleObject = facepaintObject4;
    let facepaintObject5 = {
        designs: [
            {
                sprite: facepaint5A,
                zIndex: 10,
                defaultColor: "0x474747"
            },
            {
                sprite: facepaint5B,
                zIndex: 11,
                defaultColor: "0xECD58B"
            }
        ],
        femaleObject: facepaintObject5Female
    };
    facepaintObject5Female.maleObject = facepaintObject5;
    let facepaintObject6 = {
        designs: [
            {
                sprite: facepaint6A,
                zIndex: 10,
                defaultColor: "0xDCDCDC"
            },
            {
                sprite: facepaint6B,
                zIndex: 11,
                defaultColor: "0x484848"
            }
        ],
        femaleObject: facepaintObject6Female
    };
    facepaintObject6Female.maleObject = facepaintObject6;
    let facepaintObject7 = {
        designs: [
            {
                sprite: facepaint7A,
                zIndex: 10,
                defaultColor: "0xDC7E6F"
            },
            {
                sprite: facepaint7B,
                zIndex: 11,
                defaultColor: "0xC7E278"
            },
            {
                sprite: facepaint7C,
                zIndex: 12,
                defaultColor: "0x303030"
            }
        ],
        femaleObject: facepaintObject7Female
    };
    facepaintObject7Female.maleObject = facepaintObject7;
    let facepaintObject8 = {
        designs: [
            {
                sprite: facepaint8A,
                zIndex: 10,
                defaultColor: "0x6F6BD4"
            },
            {
                sprite: facepaint8B,
                zIndex: 11,
                defaultColor: "0xE7DE7F"
            }
        ],
        femaleObject: facepaintObject8Female
    };
    facepaintObject8Female.maleObject = facepaintObject8;
    let facepaintObject9 = {
        designs: [
            {
                sprite: facepaint9A,
                zIndex: 10,
                defaultColor: "0x242424"
            },
            {
                sprite: facepaint9B,
                zIndex: 11,
                defaultColor: "0xD84444"
            },
            {
                sprite: facepaint9C,
                zIndex: 12,
                defaultColor: "0xD5D5D5"
            }
        ],
        femaleObject: facepaintObject9Female
    };
    facepaintObject9Female.maleObject = facepaintObject9;
    let facepaintObject10 = {
        designs: [
            {
                sprite: facepaint10A,
                zIndex: 10,
                defaultColor: "0xFDCF89"
            },
            {
                sprite: facepaint10B,
                zIndex: 11,
                defaultColor: "0x303030"
            }
        ],
        femaleObject: facepaintObject10Female
    };
    facepaintObject10Female.maleObject = facepaintObject10;
    let facepaintObject11 = {
        designs: [
            {
                sprite: facepaint11A,
                zIndex: 10,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: facepaint11B,
                zIndex: 11,
                defaultColor: "0x444444"
            }
        ],
        femaleObject: facepaintObject11Female
    };
    facepaintObject11Female.maleObject = facepaintObject11;
    let facepaintObject12 = {
        designs: [
            {
                sprite: facepaint12A,
                zIndex: 10,
                defaultColor: "0xF35562"
            },
            {
                sprite: facepaint12B,
                zIndex: 11,
                defaultColor: "0xFFFFFF"
            }
        ],
        femaleObject: facepaintObject12Female
    };
    facepaintObject12Female.maleObject = facepaintObject12;
    // Sports bras
    let sportsBraObjectBasic = {
        designs: [
            {
                sprite: sportsbraBasic,
                zIndex: 7,
                defaultColor: "0x444444"
            }
        ]
    };
    let sportsBraObjectLow = {
        designs: [
            {
                sprite: sportsbraLow,
                zIndex: 7,
                defaultColor: "0xF6A0BD"
            }
        ]
    };
    let sportsBraObjectShort = {
        designs: [
            {
                sprite: sportsbraShort,
                zIndex: 7,
                defaultColor: "0x136CC0"
            }
        ]
    };
    let sportsBraObjectThin = {
        designs: [
            {
                sprite: sportsbraThinA,
                zIndex: 7,
                defaultColor: "0xDADADA"
            },
            {
                sprite: sportsbraThinB,
                zIndex: 7,
                defaultColor: "0x75AE31"
            }
        ]
    };
    let sportsBraObject1 = {
        designs: [
            {
                sprite: sportsbra1,
                zIndex: 7,
                defaultColor: "0xCA4B4B"
            }
        ]
    };
    let sportsBraObject2 = {
        designs: [
            {
                sprite: sportsbra2A,
                zIndex: 7,
                defaultColor: "0xAB3E3E"
            },
            {
                sprite: sportsbra2B,
                zIndex: 8,
                defaultColor: "0x333333"
            }
        ]
    };
    let sportsBraObject3 = {
        designs: [
            {
                sprite: sportsbra3,
                zIndex: 7,
                defaultColor: "0x4E4E4E"
            }
        ]
    };
    let sportsBraObject4 = {
        designs: [
            {
                sprite: sportsbra4,
                zIndex: 7,
                defaultColor: "0xC12323"
            }
        ]
    };
    let sportsBraObject5 = {
        designs: [
            {
                sprite: sportsbra5A,
                zIndex: 7,
                defaultColor: "0x6043B7"
            },
            {
                sprite: sportsbra5B,
                zIndex: 8,
                defaultColor: "0xBBACE7"
            }
        ]
    };
    let sportsBraObject6 = {
        designs: [
            {
                sprite: sportsbra6A,
                zIndex: 7,
                defaultColor: "0x7C7C7C"
            },
            {
                sprite: sportsbra6B,
                zIndex: 8,
                defaultColor: "0x2E2E2E"
            },
            {
                sprite: sportsbra6C,
                zIndex: 9,
                defaultColor: "0x9E9E9E"
            }
        ]
    };
    let sportsBraObject7 = {
        designs: [
            {
                sprite: sportsbra7A,
                zIndex: 7,
                defaultColor: "0x74B3B6"
            },
            {
                sprite: sportsbra7B,
                zIndex: 8,
                defaultColor: "0xC57BE8"
            }
        ]
    };
    let sportsBraObject8 = {
        designs: [
            {
                sprite: sportsbra8A,
                zIndex: 7,
                defaultColor: "0x74B3B6"
            },
            {
                sprite: sportsbra8B,
                zIndex: 8,
                defaultColor: "0xDE6FB5"
            },
            {
                sprite: sportsbra8C,
                zIndex: 9,
                defaultColor: "0x161616"
            }
        ]
    };
    let sportsBraObject9 = {
        designs: [
            {
                sprite: sportsbra9A,
                zIndex: 7,
                defaultColor: "0x222222"
            },
            {
                sprite: sportsbra9B,
                zIndex: 8,
                defaultColor: "0xC74B4B"
            },
            {
                sprite: sportsbra9C,
                zIndex: 9,
                defaultColor: "0xDAA969"
            }
        ]
    };
    let sportsBraObject10 = {
        designs: [
            {
                sprite: sportsbra10A,
                zIndex: 7,
                defaultColor: "0x393939"
            },
            {
                sprite: sportsbra10B,
                zIndex: 8,
                defaultColor: "0x1F1F1F"
            },
            {
                sprite: sportsbra10C,
                zIndex: 9,
                defaultColor: "0xD53A3A"
            }
        ]
    };
    let sportsBraObject11 = {
        designs: [
            {
                sprite: sportsbra11A,
                zIndex: 7,
                defaultColor: "0x424242"
            },
            {
                sprite: sportsbra11B,
                zIndex: 8,
                defaultColor: "0xBA8A50"
            }
        ]
    };
    let sportsBraObject12 = {
        designs: [
            {
                sprite: sportsbra12,
                zIndex: 7,
                defaultColor: "0x404040"
            }
        ]
    };
    let sportsBraObject13 = {
        designs: [
            {
                sprite: sportsbra13A,
                zIndex: 7,
                defaultColor: "0xC9C9C9"
            },
            {
                sprite: sportsbra13B,
                zIndex: 8,
                defaultColor: "0x101010"
            },
            {
                sprite: sportsbra13C,
                zIndex: 9,
                defaultColor: "0xA43939"
            }
        ]
    };
    let sportsBraObject14 = {
        designs: [
            {
                sprite: sportsbra14A,
                zIndex: 7,
                defaultColor: "0xFFFFFF"
            },
            {
                sprite: sportsbra14B,
                zIndex: 8,
                defaultColor: "0xE2A881"
            },
            {
                sprite: sportsbra14C,
                zIndex: 9,
                defaultColor: "0x589BDD"
            },
            {
                sprite: sportsbra14D,
                zIndex: 10,
                defaultColor: "0x4F4F4F"
            }
        ]
    };
    let sportsBraObject15 = {
        designs: [
            {
                sprite: sportsbra15,
                zIndex: 7,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let sportsBraObject16 = {
        designs: [
            {
                sprite: sportsbra16A,
                zIndex: 7,
                defaultColor: "0xD02D36"
            },
            {
                sprite: sportsbra16B,
                zIndex: 8,
                defaultColor: "0xF4D976"
            },
            {
                sprite: sportsbra16C,
                zIndex: 9,
                defaultColor: "0x524632"
            }
        ]
    };
    // Tattoos
    let tattooObject1Female = {
        designs: [
            {
                sprite: tattoo1Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject2Female = {
        designs: [
            {
                sprite: tattoo2Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject3Female = {
        designs: [
            {
                sprite: tattoo3Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject4Female = {
        designs: [
            {
                sprite: tattoo4Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject5Female = {
        designs: [
            {
                sprite: tattoo5Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject10Female = {
        designs: [
            {
                sprite: tattoo10Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject11Female = {
        designs: [
            {
                sprite: tattoo11Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject16Female = {
        designs: [
            {
                sprite: tattoo16Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject17Female = {
        designs: [
            {
                sprite: tattoo17Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject19Female = {
        designs: [
            {
                sprite: tattoo19Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject20Female = {
        designs: [
            {
                sprite: tattoo20Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject21Female = {
        designs: [
            {
                sprite: tattoo21Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject22Female = {
        designs: [
            {
                sprite: tattoo22Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject23Female = {
        designs: [
            {
                sprite: tattoo23Female,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject1 = {
        designs: [
            {
                sprite: tattoo1,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject1Female
    };
    tattooObject1Female.maleObject = tattooObject1;
    let tattooObject2 = {
        designs: [
            {
                sprite: tattoo2,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject2Female
    };
    tattooObject2Female.maleObject = tattooObject2;
    let tattooObject3 = {
        designs: [
            {
                sprite: tattoo3,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject3Female
    };
    tattooObject3Female.maleObject = tattooObject3;
    let tattooObject4 = {
        designs: [
            {
                sprite: tattoo4,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject4Female
    };
    tattooObject4Female.maleObject = tattooObject4;
    let tattooObject5 = {
        designs: [
            {
                sprite: tattoo5,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject5Female
    };
    tattooObject5Female.maleObject = tattooObject5;
    let tattooObject6 = {
        designs: [
            {
                sprite: tattoo6,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject7 = {
        designs: [
            {
                sprite: tattoo7A,
                zIndex: 1,
                defaultColor: "0x747474"
            },
            {
                sprite: tattoo7B,
                zIndex: 1,
                defaultColor: "0xB26666"
            },
            {
                sprite: tattoo7C,
                zIndex: 1,
                defaultColor: "0x7ED2B6"
            }
        ]
    };
    let tattooObject8 = {
        designs: [
            {
                sprite: tattoo8A,
                zIndex: 1,
                defaultColor: "0x747474"
            },
            {
                sprite: tattoo8B,
                zIndex: 1,
                defaultColor: "0xB26666"
            }
        ]
    };
    let tattooObject9 = {
        designs: [
            {
                sprite: tattoo9,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject10 = {
        designs: [
            {
                sprite: tattoo10,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject10Female
    };
    tattooObject10Female.maleObject = tattooObject10;
    let tattooObject11 = {
        designs: [
            {
                sprite: tattoo11,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject11Female
    };
    tattooObject11Female.maleObject = tattooObject11;
    let tattooObject12 = {
        designs: [
            {
                sprite: tattoo12,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject13 = {
        designs: [
            {
                sprite: tattoo13,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject14 = {
        designs: [
            {
                sprite: tattoo14,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject15 = {
        designs: [
            {
                sprite: tattoo15,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject16 = {
        designs: [
            {
                sprite: tattoo16,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject16Female
    };
    tattooObject16Female.maleObject = tattooObject16;
    let tattooObject17 = {
        designs: [
            {
                sprite: tattoo17,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject17Female
    };
    tattooObject17Female.maleObject = tattooObject17;
    let tattooObject18 = {
        designs: [
            {
                sprite: tattoo18,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ]
    };
    let tattooObject19 = {
        designs: [
            {
                sprite: tattoo19,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject19Female
    };
    tattooObject19Female.maleObject = tattooObject19;
    let tattooObject20 = {
        designs: [
            {
                sprite: tattoo20,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject20Female
    };
    tattooObject20Female.maleObject = tattooObject20;
    let tattooObject21 = {
        designs: [
            {
                sprite: tattoo21,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject21Female
    };
    tattooObject21Female.maleObject = tattooObject21;
    let tattooObject22 = {
        designs: [
            {
                sprite: tattoo22,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject22Female
    };
    tattooObject22Female.maleObject = tattooObject22;
    let tattooObject23 = {
        designs: [
            {
                sprite: tattoo23,
                zIndex: 1,
                defaultColor: "0x747474"
            }
        ],
        femaleObject: tattooObject23Female
    };
    tattooObject23Female.maleObject = tattooObject23;
    // Female tops
    let femaleTopObject1 = {
        designs: [
            {
                sprite: femaleTop1,
                zIndex: 7,
                defaultColor: "0x4E4E4E"
            }
        ]
    };
    let femaleTopObject2 = {
        designs: [
            {
                sprite: femaleTop2,
                zIndex: 7,
                defaultColor: "0xE12B6D"
            }
        ]
    };
    let femaleTopObject3 = {
        designs: [
            {
                sprite: femaleTop3,
                zIndex: 7,
                defaultColor: "0x545454"
            }
        ]
    };
    let femaleTopObject4 = {
        designs: [
            {
                sprite: femaleTop4,
                zIndex: 7,
                defaultColor: "0xE7E7E7"
            }
        ]
    };
    let femaleTopObject5 = {
        designs: [
            {
                sprite: femaleTop5,
                zIndex: 7,
                defaultColor: "0x81B7B7"
            }
        ]
    };
    let femaleTopObject6 = {
        designs: [
            {
                sprite: femaleTop6,
                zIndex: 7,
                defaultColor: "0x545454"
            }
        ]
    };
    let femaleTopObject7 = {
        designs: [
            {
                sprite: femaleTop7,
                zIndex: 7,
                defaultColor: "0x7AB71E"
            }
        ]
    };
    let femaleTopObject8 = {
        designs: [
            {
                sprite: femaleTop8A,
                zIndex: 7,
                defaultColor: "0xE5E5E5"
            },
            {
                sprite: femaleTop8B,
                zIndex: 7,
                defaultColor: "0xA6E3D6"
            }
        ]
    };
    let femaleTopObject9 = {
        designs: [
            {
                sprite: femaleTop9A,
                zIndex: 7,
                defaultColor: "0xA98312"
            },
            {
                sprite: femaleTop9B,
                zIndex: 7,
                defaultColor: "0xFAEABA"
            }
        ]
    };
    let femaleTopObject10 = {
        designs: [
            {
                sprite: femaleTop10A,
                zIndex: 7,
                defaultColor: "0x4FB199"
            },
            {
                sprite: femaleTop10B,
                zIndex: 7,
                defaultColor: "0xD7AD30"
            }
        ]
    };
    let femaleTopObject11 = {
        designs: [
            {
                sprite: femaleTop11A,
                zIndex: 7,
                defaultColor: "0xBCF270"
            },
            {
                sprite: femaleTop11B,
                zIndex: 7,
                defaultColor: "0x252525"
            }
        ]
    };
    // Female bottoms
    let femaleBottomObject1 = {
        designs: [
            {
                sprite: femaleBottom1A,
                zIndex: 3,
                defaultColor: "0x6681AC"
            },
            {
                sprite: femaleBottom1B,
                zIndex: 4,
                defaultColor: "0x3A4A63"
            }
        ]
    };
    let femaleBottomObject2 = {
        designs: [
            {
                sprite: femaleBottom2,
                zIndex: 3,
                defaultColor: "0xCA4B4B"
            }
        ]
    };
    let femaleBottomObject3 = {
        designs: [
            {
                sprite: femaleBottom3A,
                zIndex: 3,
                defaultColor: "0x4E4E4E"
            },
            {
                sprite: femaleBottom3B,
                zIndex: 4,
                defaultColor: "0xB1B1B1"
            },
            {
                sprite: femaleBottom3C,
                zIndex: 5,
                defaultColor: "0x151515"
            }
        ]
    };
    let femaleBottomObject4 = {
        designs: [
            {
                sprite: femaleBottom4A,
                zIndex: 3,
                defaultColor: "0x464646"
            },
            {
                sprite: femaleBottom4B,
                zIndex: 4,
                defaultColor: "0x394390"
            },
            {
                sprite: femaleBottom4C,
                zIndex: 5,
                defaultColor: "0xD8D8D8"
            }
        ]
    };
    let femaleBottomObject5 = {
        designs: [
            {
                sprite: femaleBottom5,
                zIndex: 3,
                defaultColor: "0xE8E8E8"
            }
        ]
    };
    let femaleBottomObject6 = {
        designs: [
            {
                sprite: femaleBottom6A,
                zIndex: 3,
                defaultColor: "0xC12323"
            },
            {
                sprite: femaleBottom6B,
                zIndex: 4,
                defaultColor: "0x181818"
            },
            {
                sprite: femaleBottom6C,
                zIndex: 5,
                defaultColor: "0xB0913B"
            }
        ]
    };
    let femaleBottomObject7 = {
        designs: [
            {
                sprite: femaleBottom7,
                zIndex: 3,
                defaultColor: "0x444444"
            }
        ]
    };
    let femaleBottomObject8 = {
        designs: [
            {
                sprite: femaleBottom8A,
                zIndex: 3,
                defaultColor: "0x1E1E1E"
            },
            {
                sprite: femaleBottom8B,
                zIndex: 4,
                defaultColor: "0xA43535"
            }
        ]
    };
    let femaleBottomObject9 = {
        designs: [
            {
                sprite: femaleBottom9A,
                zIndex: 3,
                defaultColor: "0x292929"
            },
            {
                sprite: femaleBottom9B,
                zIndex: 4,
                defaultColor: "0xD6D6D6"
            }
        ]
    };
    let femaleBottomObject10 = {
        designs: [
            {
                sprite: femaleBottom10,
                zIndex: 3,
                defaultColor: "0xc8c8c8"
            }
        ]
    };
    let femaleBottomObject11 = {
        designs: [
            {
                sprite: femaleBottom11,
                zIndex: 4,
                defaultColor: "0xA41515"
            }
        ]
    };
    let femaleBottomObject12 = {
        designs: [
            {
                sprite: femaleBottom12A,
                zIndex: 3,
                defaultColor: "0x2D2D2D"
            },
            {
                sprite: femaleBottom12B,
                zIndex: 4,
                defaultColor: "0x655346"
            },
            {
                sprite: femaleBottom12C,
                zIndex: 5,
                defaultColor: "0xBCD561"
            }
        ]
    };
    let femaleBottomObject13 = {
        designs: [
            {
                sprite: femaleBottom13,
                zIndex: 3,
                defaultColor: "0x9AB732"
            }
        ]
    };
    let femaleBottomObject14 = {
        designs: [
            {
                sprite: femaleBottom14A,
                zIndex: 13,
                defaultColor: "0xEED8B9"
            },
            {
                sprite: femaleBottom14B,
                zIndex: 14,
                defaultColor: "0xD3C3AC"
            }
        ]
    };
    let femaleBottomObject15 = {
        designs: [
            {
                sprite: femaleBottom15,
                zIndex: 13,
                defaultColor: "0x933838"
            }
        ]
    };
    let femaleBottomObject16 = {
        designs: [
            {
                sprite: femaleBottom16A,
                zIndex: 3,
                defaultColor: "0xE19EFF"
            },
            {
                sprite: femaleBottom16B,
                zIndex: 4,
                defaultColor: "0xA497E6"
            }
        ]
    };
    let femaleBottomObject17 = {
        designs: [
            {
                sprite: femaleBottom17,
                zIndex: 3,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let femaleBottomObject18 = {
        designs: [
            {
                sprite: femaleBottom18,
                zIndex: 3,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let femaleBottomObject19 = {
        designs: [
            {
                sprite: femaleBottom19,
                zIndex: 3,
                defaultColor: "0x794681"
            }
        ]
    };
    let femaleBottomObject20 = {
        designs: [
            {
                sprite: femaleBottom20,
                zIndex: 3,
                defaultColor: "0x333333"
            }
        ]
    };
    let femaleBottomObject21 = {
        designs: [
            {
                sprite: femaleBottom21A,
                zIndex: 3,
                defaultColor: "0xD02D36"
            },
            {
                sprite: femaleBottom21B,
                zIndex: 4,
                defaultColor: "0xF4D976"
            },
            {
                sprite: femaleBottom21C,
                zIndex: 5,
                defaultColor: "0x4D4430"
            }
        ]
    };
    // Female accessories
    let femaleAccessoryObject1 = {
        designs: [
            {
                sprite: femaleAccessory1,
                zIndex: 1,
                defaultColor: "0x272727"
            }
        ]
    };
    let femaleAccessoryObject2 = {
        designs: [
            {
                sprite: femaleAccessory2,
                zIndex: 20,
                defaultColor: "0x313131"
            }
        ]
    };
    let femaleAccessoryObject3 = {
        designs: [
            {
                sprite: femaleAccessory3,
                zIndex: 26,
                defaultColor: "0xCF5252"
            }
        ]
    };
    let femaleAccessoryObject4 = {
        designs: [
            {
                sprite: femaleAccessory4A,
                zIndex: 1,
                defaultColor: "0xA8A8A8"
            },
            {
                sprite: femaleAccessory4B,
                zIndex: 10,
                defaultColor: "0x434343"
            }
        ]
    };
    let femaleAccessoryObject5 = {
        designs: [
            {
                sprite: femaleAccessory5,
                zIndex: 2,
                defaultColor: "0xC5D78A"
            }
        ]
    };
    let femaleAccessoryObject6 = {
        designs: [
            {
                sprite: femaleAccessory6,
                zIndex: 2,
                defaultColor: "0xD4CBE4"
            }
        ]
    };
    let femaleAccessoryObject7 = {
        designs: [
            {
                sprite: femaleAccessory7,
                zIndex: 1,
                defaultColor: "0xCACACA"
            }
        ]
    };
    let femaleAccessoryObject8 = {
        designs: [
            {
                sprite: femaleAccessory8A,
                zIndex: 20,
                defaultColor: "0x5C7CC7"
            },
            {
                sprite: femaleAccessory8B,
                zIndex: 21,
                defaultColor: "0xE0E0E0"
            }
        ]
    };
    let femaleAccessoryObject9 = {
        designs: [
            {
                sprite: femaleAccessory9A,
                zIndex: 1,
                defaultColor: "0xA8A8A8"
            },
            {
                sprite: femaleAccessory9B,
                zIndex: 10,
                defaultColor: "0x404040"
            }
        ]
    };
    let femaleAccessoryObject10 = {
        designs: [
            {
                sprite: femaleAccessory10,
                zIndex: 2,
                defaultColor: "0xF55BE0"
            }
        ]
    };
    let femaleAccessoryObject11 = {
        designs: [
            {
                sprite: femaleAccessory11,
                zIndex: 26,
                defaultColor: "0x4e435d"
            }
        ]
    };
    let femaleAccessoryObject12 = {
        designs: [
            {
                sprite: femaleAccessory12,
                zIndex: 26,
                defaultColor: "0x4386AB"
            }
        ]
    };
    // Female hair
    let femaleHairObject1 = {
        designs: [
            {
                sprite: femaleHair1A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair1B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject2 = {
        designs: [
            {
                sprite: femaleHair2A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair2B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject3 = {
        designs: [
            {
                sprite: femaleHair3A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair3B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject4 = {
        designs: [
            {
                sprite: femaleHair4A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject5 = {
        designs: [
            {
                sprite: femaleHair5A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair5B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject6 = {
        designs: [
            {
                sprite: femaleHair6A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair6B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject7 = {
        designs: [
            {
                sprite: femaleHair7A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair7B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject8 = {
        designs: [
            {
                sprite: femaleHair8A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair8B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject9 = {
        designs: [
            {
                sprite: femaleHair9A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair9B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject10 = {
        designs: [
            {
                sprite: femaleHair10A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair10B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject11 = {
        designs: [
            {
                sprite: femaleHair11A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair11B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject12 = {
        designs: [
            {
                sprite: femaleHair12A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair12B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject13 = {
        designs: [
            {
                sprite: femaleHair13A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair13B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject14 = {
        designs: [
            {
                sprite: femaleHair14A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair14B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject15 = {
        designs: [
            {
                sprite: femaleHair15A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair15B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject16 = {
        designs: [
            {
                sprite: femaleHair16A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair16B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject17 = {
        designs: [
            {
                sprite: femaleHair17A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair17B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject18 = {
        designs: [
            {
                sprite: femaleHair18A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair18B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject19 = {
        designs: [
            {
                sprite: femaleHair19A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair19B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject20 = {
        designs: [
            {
                sprite: femaleHair20A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair20B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject21 = {
        designs: [
            {
                sprite: femaleHair21A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair21B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject22 = {
        designs: [
            {
                sprite: femaleHair22A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair22B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject23 = {
        designs: [
            {
                sprite: femaleHair23A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair23B,
                zIndex: 25,
                defaultColor: "0x83437F"
            },
            {
                sprite: femaleHair23C,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject24 = {
        designs: [
            {
                sprite: femaleHair24A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair24B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject25 = {
        designs: [
            {
                sprite: femaleHair25A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair25B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject26 = {
        designs: [
            {
                sprite: femaleHair26A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair26B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject27 = {
        designs: [
            {
                sprite: femaleHair27A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair27B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject28 = {
        designs: [
            {
                sprite: femaleHair28A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair28B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    let femaleHairObject29 = {
        designs: [
            {
                sprite: femaleHair29A,
                zIndex: 25,
                defaultColor: "0x383838"
            },
            {
                sprite: femaleHair29B,
                zIndex: 25,
                defaultColor: "0x383838"
            }
        ]
    };
    let femaleHairObject30 = {
        designs: [
            {
                sprite: femaleHair30A,
                zIndex: 25,
                defaultColor: "0xB59B82"
            },
            {
                sprite: femaleHair30B,
                zIndex: 25,
                defaultColor: "0xB59B82"
            }
        ]
    };
    // Knee pads
    let kneepadObject1 = {
        designs: [
            {
                sprite: kneepad1,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    let kneepadObject2 = {
        designs: [
            {
                sprite: kneepad2,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    let kneepadObject3 = {
        designs: [
            {
                sprite: kneepad3,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    let kneepadObject4 = {
        designs: [
            {
                sprite: kneepad4,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    let kneepadObject5 = {
        designs: [
            {
                sprite: kneepad5,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    let kneepadObject6 = {
        designs: [
            {
                sprite: kneepad6,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    let kneepadObject7 = {
        designs: [
            {
                sprite: kneepad7,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    let kneepadObject8 = {
        designs: [
            {
                sprite: kneepad8,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    let kneepadObject9 = {
        designs: [
            {
                sprite: kneepad9,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    let kneepadObject10 = {
        designs: [
            {
                sprite: kneepad10,
                zIndex: 10,
                defaultColor: "0x333333"
            }
        ]
    };
    // Empty objects
    let emptyAccessoryObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 20,
                defaultColor: "0xEFEFEF"
            }
        ]
    };
    let emptyHairObject = {
        designs: [
            {
                sprite: hairDesign0,
                zIndex: 20,
                defaultColor: "0xEFEFEF"
            }
        ]
    };
    let emptyFacialHairObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 20,
                defaultColor: "0xEFEFEF"
            }
        ]
    };
    let emptyTopObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 20,
                defaultColor: "0xEFEFEF"
            }
        ]
    };
    let emptyElbowObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 20,
                defaultColor: "0xEFEFEF"
            }
        ]
    };
    let emptyKneepadObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 20,
                defaultColor: "0xEFEFEF"
            }
        ]
    };
    let emptyFacepaintObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 20,
                defaultColor: "0xEFEFEF"
            }
        ]
    };
    let emptyTattooObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 20,
                defaultColor: "0xEFEFEF"
            }
        ]
    };
    let emptyShoesObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 20,
                defaultColor: "0xEFEFEF"
            }
        ]
    };
    // Title objects
    let smallStrapObject1 = {
        designs: [
            {
                sprite: titleSmallStrap1,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallStrapObject2 = {
        designs: [
            {
                sprite: titleSmallStrap2,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallStrapObject3 = {
        designs: [
            {
                sprite: titleSmallStrap3,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallStrapObject4 = {
        designs: [
            {
                sprite: titleSmallStrap4,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallStrapObject5 = {
        designs: [
            {
                sprite: titleSmallStrap5,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallStrapObject6 = {
        designs: [
            {
                sprite: titleSmallStrap6,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallStrapObject7 = {
        designs: [
            {
                sprite: titleSmallStrap7,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallStrapObject8 = {
        designs: [
            {
                sprite: titleSmallStrap8,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallStrapObject9 = {
        designs: [
            {
                sprite: titleSmallStrap9,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallStrapObject10 = {
        designs: [
            {
                sprite: titleSmallStrap10,
                zIndex: 15,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let smallGemsObject1 = {
        designs: [
            {
                sprite: titleSmallGems1,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallGemsObject2 = {
        designs: [
            {
                sprite: titleSmallGems2,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallGemsObject3 = {
        designs: [
            {
                sprite: titleSmallGems3,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallGemsObject4 = {
        designs: [
            {
                sprite: titleSmallGems4,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallGemsObject5 = {
        designs: [
            {
                sprite: titleSmallGems5,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallGemsObject6 = {
        designs: [
            {
                sprite: titleSmallGems6,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallGemsObject7 = {
        designs: [
            {
                sprite: titleSmallGems7,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallGemsObject8 = {
        designs: [
            {
                sprite: titleSmallGems8,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallGemsObject9 = {
        designs: [
            {
                sprite: titleSmallGems9,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallGemsObject10 = {
        designs: [
            {
                sprite: titleSmallGems10,
                zIndex: 17,
                defaultColor: "0xC51616"
            }
        ]
    };
    let smallPlateObject1 = {
        designs: [
            {
                sprite: titleSmallPlate1,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject1,
        smallGemsObject: smallGemsObject1
    };
    let smallPlateObject2 = {
        designs: [
            {
                sprite: titleSmallPlate2,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject2,
        smallGemsObject: smallGemsObject2
    };
    let smallPlateObject3 = {
        designs: [
            {
                sprite: titleSmallPlate3,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject3,
        smallGemsObject: smallGemsObject3
    };
    let smallPlateObject4 = {
        designs: [
            {
                sprite: titleSmallPlate4,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject4,
        smallGemsObject: smallGemsObject4
    };
    let smallPlateObject5 = {
        designs: [
            {
                sprite: titleSmallPlate5,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject5,
        smallGemsObject: smallGemsObject5
    };
    let smallPlateObject6 = {
        designs: [
            {
                sprite: titleSmallPlate6,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject6,
        smallGemsObject: smallGemsObject6
    };
    let smallPlateObject7 = {
        designs: [
            {
                sprite: titleSmallPlate7,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject7,
        smallGemsObject: smallGemsObject7
    };
    let smallPlateObject8 = {
        designs: [
            {
                sprite: titleSmallPlate8,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject8,
        smallGemsObject: smallGemsObject8
    };
    let smallPlateObject9 = {
        designs: [
            {
                sprite: titleSmallPlate9,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject9,
        smallGemsObject: smallGemsObject9
    };
    let smallPlateObject10 = {
        designs: [
            {
                sprite: titleSmallPlate10,
                zIndex: 16,
                defaultColor: "0xC59548"
            }
        ],
        smallStrapObject: smallStrapObject10,
        smallGemsObject: smallGemsObject10
    };
    let centerPlateObject1 = {
        smallPlateObject: smallPlateObject1
    };
    let centerPlateObject2 = {
        smallPlateObject: smallPlateObject2
    };
    let centerPlateObject3 = {
        smallPlateObject: smallPlateObject3
    };
    let centerPlateObject4 = {
        smallPlateObject: smallPlateObject4
    };
    let centerPlateObject5 = {
        smallPlateObject: smallPlateObject5
    };
    let centerPlateObject6 = {
        smallPlateObject: smallPlateObject6
    };
    let centerPlateObject7 = {
        smallPlateObject: smallPlateObject7
    };
    let centerPlateObject8 = {
        smallPlateObject: smallPlateObject8
    };
    let centerPlateObject9 = {
        smallPlateObject: smallPlateObject9
    };
    let centerPlateObject10 = {
        smallPlateObject: smallPlateObject10
    };
    // Blood objects
    let bloodObject1 = {
        designs: [
            {
                sprite: bloodDesign1,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject2 = {
        designs: [
            {
                sprite: bloodDesign2,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject3 = {
        designs: [
            {
                sprite: bloodDesign3,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject4 = {
        designs: [
            {
                sprite: bloodDesign4,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject5 = {
        designs: [
            {
                sprite: bloodDesign5,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject6 = {
        designs: [
            {
                sprite: bloodDesign6,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject7 = {
        designs: [
            {
                sprite: bloodDesign7,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject8 = {
        designs: [
            {
                sprite: bloodDesign8,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject9 = {
        designs: [
            {
                sprite: bloodDesign9,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject10 = {
        designs: [
            {
                sprite: bloodDesign10,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject11 = {
        designs: [
            {
                sprite: bloodDesign11,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject12 = {
        designs: [
            {
                sprite: bloodDesign12,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bloodObject13 = {
        designs: [
            {
                sprite: bloodDesign13,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    // Injury objects
    let bruiseEyeRightObject = {
        designs: [
            {
                sprite: bruiseEyeRight,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bruiseEyeLeftObject = {
        designs: [
            {
                sprite: bruiseEyeLeft,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bandageArmRightObject = {
        designs: [
            {
                sprite: bandageArmRight,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bandageArmLeftObject = {
        designs: [
            {
                sprite: bandageArmLeft,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bandageForeheadLeftObject = {
        designs: [
            {
                sprite: bandageForeheadLeft,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bandageForeheadRightObject = {
        designs: [
            {
                sprite: bandageForeheadRight,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let bandageForeheadFullObject = {
        designs: [
            {
                sprite: bandageForeheadFull,
                zIndex: 1,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    // Trophy objects
    let trophyObject1 = {
        designs: [
            {
                sprite: TGITrophy,
                zIndex: 40,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    // Define sprite arrays
    let bodies = [
        bodyObjectHe,
        bodyObjectHe2,
        bodyObjectHe3,
        bodyObjectShe,
        bodyObjectSheAbs,
        bodyObjectHeAbs
    ];
    let eyes = [
        eyesObject
    ];
    let bottoms = [
        tightsObject0,
        tightsObject1,
        tightsObject2,
        tightsObject3,
        tightsObject4,
        tightsObject5,
        tightsObject6,
        tightsObject7,
        tightsObject8,
        tightsObject9,
        tightsObject10,
        tightsObject11,
        tightsObject12,
        tightsObject13,
        tightsObject14,
        tightsObject15,
        shortsObjectBasic,
        shortsObject1,
        shortsObject2,
        shortsObject3,
        shortsObject4,
        shortsObject5,
        shortsObject6,
        shortsObject7,
        shortsObject8,
        trunkObject1,
        trunkObject2,
        trunkObject3,
        trunkObject4,
        trunkObject5,
        trunkObject6,
        trunkObject7,
        trunkObject8,
        trunkObject9,
        trunkObject10,
        trunkObject11,
        trunkObject12,
        trunkObject13,
        trunkObject14,
        trunkObject15,
        trunkObject16,
        trunkObject17,
        femaleBottomObject1,
        femaleBottomObject18,
        femaleBottomObject2,
        femaleBottomObject3,
        femaleBottomObject4,
        femaleBottomObject5,
        femaleBottomObject6,
        femaleBottomObject7,
        femaleBottomObject8,
        femaleBottomObject9,
        femaleBottomObject19,
        femaleBottomObject10,
        femaleBottomObject11,
        femaleBottomObject12,
        femaleBottomObject13,
        femaleBottomObject14,
        femaleBottomObject15,
        femaleBottomObject16,
        femaleBottomObject17,
        femaleBottomObject20,
        tightsObject16,
        femaleBottomObject21,
        shortsObject9,
        tightsObject17,
        tightsObject18,
        tightsObject19,
        tightsObject20,
        tightsObject21,
        tightsObject22,
        tightsObject23,
        tightsObject24,
        tightsObject25
    ];
    let shorts = [
        shortsObjectBasic,
        shortsObject1,
        shortsObject2,
        shortsObject3,
        shortsObject4,
        shortsObject5,
        shortsObject6,
        shortsObject7,
        shortsObject8,
        shortsObject9
    ];
    let trunks = [
        trunkObject1,
        trunkObject2,
        trunkObject3,
        trunkObject4,
        trunkObject5,
        trunkObject6,
        trunkObject7,
        trunkObject8,
        trunkObject9,
        trunkObject10,
        trunkObject11,
        trunkObject12,
        trunkObject13,
        trunkObject14,
        trunkObject15,
        trunkObject16,
        trunkObject17
    ];
    let tights = [
        tightsObject0,
        tightsObject1,
        tightsObject2,
        tightsObject3,
        tightsObject4,
        tightsObject5,
        tightsObject6,
        tightsObject7,
        tightsObject8,
        tightsObject9,
        tightsObject10,
        tightsObject11,
        tightsObject12,
        tightsObject13,
        tightsObject14,
        tightsObject15,
        tightsObject16,
        tightsObject17,
        tightsObject18,
        tightsObject19,
        tightsObject20,
        tightsObject21,
        tightsObject22,
        tightsObject23,
        tightsObject24,
        tightsObject25
    ];
    let shoes = [
        shoesObject0,
        shoesObject1,
        shoesObject2,
        shoesObject3,
        shoesObject4,
        shoesObject5,
        shoesObject6,
        shoesObject7,
        shoesObject8,
        shoesObject9,
        shoesObject10,
        shoesObject11,
        shoesObject12,
        shoesObject13,
        shoesObject14,
        shoesObject15,
        shoesObject16,
        shoesObject17,
        shoesObject18,
        shoesObject19,
        shoesObject20,
        emptyShoesObject
    ];
    let hairs = [
        emptyHairObject,
        hairObject1,
        hairObject2,
        hairObject3,
        hairObject4,
        hairObject5,
        hairObject6,
        hairObject7,
        hairObject8,
        hairObject9,
        hairObject10,
        hairObject11,
        hairObject12,
        hairObject13,
        hairObject14,
        hairObject15,
        hairObject16,
        hairObject17,
        hairObject18,
        hairObject19,
        hairObject20,
        hairObject21,
        hairObject22,
        hairObject23,
        hairObject24,
        hairObject25,
        hairObject26,
        hairObject27,
        hairObject28,
        hairObject29,
        hairObject30,
        hairObject31,
        hairObject32,
        hairObject33,
        hairObject34,
        hairObject35,
        femaleHairObject1,
        femaleHairObject2,
        femaleHairObject3,
        femaleHairObject4,
        femaleHairObject5,
        femaleHairObject6,
        femaleHairObject7,
        femaleHairObject8,
        femaleHairObject9,
        femaleHairObject10,
        femaleHairObject11,
        femaleHairObject12,
        femaleHairObject13,
        femaleHairObject14,
        femaleHairObject15,
        femaleHairObject16,
        femaleHairObject17,
        femaleHairObject18,
        femaleHairObject19,
        femaleHairObject20,
        femaleHairObject21,
        femaleHairObject22,
        femaleHairObject23,
        femaleHairObject24,
        femaleHairObject25,
        femaleHairObject26,
        femaleHairObject27,
        femaleHairObject28,
        femaleHairObject30,
        femaleHairObject29,
        hairObject36
    ];
    let torsos = [
        topObject1,
        topObject2,
        topObject3,
        topObject4,
        topObject5,
        topObject6,
        topObject7,
        topObject8,
        topObject9,
        topObject10,
        topObject11,
        topObject12,
        topObject13,
        topObject14,
        topObject15,
        topObject16,
        topObject17,
        topObject18,
        topObject19,
        topObject20,
        topObject21,
        topObject22,
        topObject23,
        topObject24,
        topObject25,
        topObject26,
        topObject27,
        topObject28,
        topObject29,
        topObject30,
        topObject31,
        topObject32,
        topObject33,
        topObject34,
        topObject35,
        topObject36,
        topObject37,
        topObject38,
        topObject39,
        topObject40,
        topObject41,
        topObject42,
        topObject43,
        topObject44,
        topObject45,
        topObject46,
        topObject47,
        topObject48,
        topObject49,
        sportsBraObjectBasic,
        sportsBraObjectLow,
        sportsBraObjectShort,
        sportsBraObjectThin,
        sportsBraObject1,
        sportsBraObject2,
        sportsBraObject3,
        sportsBraObject4,
        sportsBraObject5,
        sportsBraObject6,
        sportsBraObject7,
        sportsBraObject8,
        sportsBraObject9,
        sportsBraObject10,
        sportsBraObject11,
        sportsBraObject12,
        sportsBraObject13,
        sportsBraObject14,
        sportsBraObject15,
        femaleTopObject1,
        femaleTopObject2,
        femaleTopObject3,
        femaleTopObject4,
        femaleTopObject5,
        femaleTopObject6,
        femaleTopObject7,
        femaleTopObject8,
        femaleTopObject9,
        femaleTopObject10,
        femaleTopObject11,
        sportsBraObject16,
        topObject50,
        topObject51,
        topObject52,
        topObject53,
        topObject54,
        emptyTopObject
    ];
    let elbows = [
        elbowObject1,
        elbowObject2,
        elbowObject3,
        elbowObject4,
        elbowObject5,
        elbowObject6,
        elbowObject7,
        elbowObject8,
        elbowObject9,
        elbowObject10,
        emptyElbowObject
    ];
    let facialHairs = [
        facialHairObject1,
        facialHairObject2,
        facialHairObject3,
        facialHairObject4,
        facialHairObject5,
        facialHairObject6,
        facialHairObject7,
        facialHairObject8,
        facialHairObject9,
        facialHairObject10,
        facialHairObject11,
        facialHairObject12,
        facialHairObject13,
        facialHairObject14,
        facialHairObject15,
        facialHairObject16,
        facialHairObject17,
        facialHairObject18,
        facialHairObject19,
        facialHairObject20,
        emptyFacialHairObject
    ];
    let accessories = [
        accessoryObject1,
        accessoryObject2,
        accessoryObject3,
        accessoryObject4,
        accessoryObject5,
        accessoryObject6,
        accessoryObject7,
        accessoryObject8,
        accessoryObject9,
        accessoryObject10,
        accessoryObject11,
        accessoryObject12,
        accessoryObject13,
        accessoryObject14,
        accessoryObject15,
        accessoryObject16,
        accessoryObject17,
        accessoryObject18,
        accessoryObject19,
        accessoryObject20,
        glovesObject1,
        glovesObject2,
        glovesObject3,
        glovesObject4,
        glovesObject5,
        glovesObject6,
        wristTapeObject1,
        wristTapeObject2,
        wristTapeObject3,
        glassesObject2,
        glassesObject3,
        glassesObject4,
        glassesObject5,
        glassesObject6,
        glassesObject7,
        glassesObject8,
        suitsObject1,
        suitsObject2,
        suitsObject3,
        tiesObject1,
        tiesObject2,
        tiesObject3,
        tiesObject4,
        femaleAccessoryObject1,
        femaleAccessoryObject2,
        femaleAccessoryObject3,
        femaleAccessoryObject4,
        femaleAccessoryObject5,
        femaleAccessoryObject6,
        femaleAccessoryObject7,
        femaleAccessoryObject8,
        femaleAccessoryObject9,
        femaleAccessoryObject10,
        femaleAccessoryObject11,
        femaleAccessoryObject12,
        accessoryObject21,
        accessoryObject22,
        accessoryObject23,
        accessoryObject24,
        accessoryObject25,
        accessoryObject26,
        accessoryObject27,
        accessoryObject28,
        accessoryObject29,
        accessoryObject30,
        accessoryObject31,
        accessoryObject32,
        accessoryObject33,
        accessoryObject34,
        accessoryObject35,
        accessoryObject36,
        accessoryObject37,
        accessoryObject38,
        accessoryObject39,
        accessoryObject40,
        accessoryObject41,
        accessoryObject42,
        accessoryObject43,
        accessoryObject44,
        accessoryObject45,
        accessoryObject46,
        accessoryObject47,
        accessoryObject48,
        accessoryObject49,
        accessoryObject50,
        accessoryObject51,
        accessoryObject52,
        accessoryObject53,
        accessoryObject54,
        accessoryObject55,
        accessoryObject56,
        accessoryObject57,
        accessoryObject58,
        accessoryObject59,
        accessoryObject60,
        accessoryObject61,
        accessoryObject62,
        accessoryObject63,
        accessoryObject64,
        accessoryObject65,
        accessoryObject66,
        accessoryObject67,
        accessoryObject68,
        accessoryObject69,
        accessoryObject70,
        accessoryObject71,
        accessoryObject72,
        accessoryObject73,
        accessoryObject74,
        accessoryObject75,
        accessoryObject76,
        emptyAccessoryObject
    ];
    let flags = [
        accessoryObject63,
        accessoryObject64,
        accessoryObject65,
        accessoryObject66,
        accessoryObject67,
        accessoryObject68,
        accessoryObject69
    ];
    let facepaints = [
        facepaintObject1,
        facepaintObject2,
        facepaintObject3,
        facepaintObject4,
        facepaintObject5,
        facepaintObject6,
        facepaintObject7,
        facepaintObject8,
        facepaintObject9,
        facepaintObject10,
        facepaintObject11,
        facepaintObject12,
        emptyFacepaintObject
    ];
    let allFacepaints = [
        facepaintObject2Female,
        facepaintObject3Female,
        facepaintObject4Female,
        facepaintObject5Female,
        facepaintObject6Female,
        facepaintObject7Female,
        facepaintObject8Female,
        facepaintObject9Female,
        facepaintObject10Female,
        facepaintObject11Female,
        facepaintObject12Female,
        facepaintObject1,
        facepaintObject2,
        facepaintObject3,
        facepaintObject4,
        facepaintObject5,
        facepaintObject6,
        facepaintObject7,
        facepaintObject8,
        facepaintObject9,
        facepaintObject10,
        facepaintObject11,
        facepaintObject12
    ];
    let masculineFacepaints = [
        facepaintObject1,
        facepaintObject2,
        facepaintObject3,
        facepaintObject4,
        facepaintObject5,
        facepaintObject6,
        facepaintObject7,
        facepaintObject8,
        facepaintObject9,
        facepaintObject10,
        facepaintObject11,
        facepaintObject12,
        emptyFacepaintObject
    ];
    let feminineFacepaints = [
        facepaintObject1,
        facepaintObject2Female,
        facepaintObject3Female,
        facepaintObject4Female,
        facepaintObject5Female,
        facepaintObject6Female,
        facepaintObject7Female,
        facepaintObject8Female,
        facepaintObject9Female,
        facepaintObject10Female,
        facepaintObject11Female,
        facepaintObject12Female,
        emptyFacepaintObject
    ];
    let tattoos = [
        tattooObject1,
        tattooObject2,
        tattooObject3,
        tattooObject4,
        tattooObject5,
        tattooObject6,
        tattooObject7,
        tattooObject8,
        tattooObject9,
        tattooObject10,
        tattooObject11,
        tattooObject12,
        tattooObject13,
        tattooObject14,
        tattooObject15,
        tattooObject16,
        tattooObject17,
        tattooObject18,
        tattooObject19,
        tattooObject20,
        tattooObject21,
        tattooObject22,
        tattooObject23,
        emptyTattooObject
    ];
    let masculineTattoos = [
        tattooObject1,
        tattooObject2,
        tattooObject3,
        tattooObject4,
        tattooObject5,
        tattooObject6,
        tattooObject7,
        tattooObject8,
        tattooObject9,
        tattooObject10,
        tattooObject11,
        tattooObject12,
        tattooObject13,
        tattooObject14,
        tattooObject15,
        tattooObject16,
        tattooObject17,
        tattooObject18,
        tattooObject19,
        tattooObject20,
        tattooObject21,
        tattooObject22,
        tattooObject23,
        emptyTattooObject
    ];
    let feminineTattoos = [
        tattooObject1Female,
        tattooObject2Female,
        tattooObject3Female,
        tattooObject4Female,
        tattooObject5Female,
        tattooObject6,
        tattooObject7,
        tattooObject8,
        tattooObject9,
        tattooObject10Female,
        tattooObject11Female,
        tattooObject12,
        tattooObject13,
        tattooObject14,
        tattooObject15,
        tattooObject16Female,
        tattooObject17Female,
        tattooObject18,
        tattooObject19Female,
        tattooObject20Female,
        tattooObject21Female,
        tattooObject22Female,
        tattooObject23Female,
        emptyTattooObject
    ];
    let allTattoos = [
        tattooObject1Female,
        tattooObject2Female,
        tattooObject3Female,
        tattooObject4Female,
        tattooObject5Female,
        tattooObject10Female,
        tattooObject11Female,
        tattooObject16Female,
        tattooObject17Female,
        tattooObject19Female,
        tattooObject20Female,
        tattooObject21Female,
        tattooObject22Female,
        tattooObject23Female,
        tattooObject1,
        tattooObject2,
        tattooObject3,
        tattooObject4,
        tattooObject5,
        tattooObject6,
        tattooObject7,
        tattooObject8,
        tattooObject9,
        tattooObject10,
        tattooObject11,
        tattooObject12,
        tattooObject13,
        tattooObject14,
        tattooObject15,
        tattooObject16,
        tattooObject17,
        tattooObject18,
        tattooObject19,
        tattooObject20,
        tattooObject21,
        tattooObject22,
        tattooObject23
    ];
    let kneepads = [
        kneepadObject1,
        kneepadObject2,
        kneepadObject3,
        kneepadObject4,
        kneepadObject5,
        kneepadObject6,
        kneepadObject7,
        kneepadObject8,
        kneepadObject9,
        kneepadObject10,
        emptyKneepadObject
    ];
    // Sub categories
    let shortHair = [
        emptyHairObject,
        hairObject1,
        hairObject2,
        hairObject3,
        hairObject5,
        hairObject6,
        hairObject7,
        hairObject9,
        hairObject11,
        hairObject13,
        hairObject14,
        hairObject15,
        hairObject16,
        hairObject17,
        hairObject18,
        hairObject21,
        hairObject22,
        hairObject23,
        hairObject24,
        hairObject25,
        hairObject26,
        hairObject28,
        hairObject33,
        hairObject34
    ];
    let longHair = [
        hairObject4,
        hairObject8,
        hairObject10,
        hairObject12,
        hairObject19,
        hairObject20,
        hairObject27,
        hairObject29,
        hairObject30,
        hairObject31,
        hairObject32,
        hairObject35,
        hairObject36
    ];
    let feminineHair = [
        femaleHairObject1,
        femaleHairObject2,
        femaleHairObject3,
        femaleHairObject4,
        femaleHairObject5,
        femaleHairObject6,
        femaleHairObject7,
        femaleHairObject8,
        femaleHairObject9,
        femaleHairObject10,
        femaleHairObject11,
        femaleHairObject12,
        femaleHairObject13,
        femaleHairObject14,
        femaleHairObject15,
        femaleHairObject16,
        femaleHairObject17,
        femaleHairObject18,
        femaleHairObject19,
        femaleHairObject20,
        femaleHairObject21,
        femaleHairObject22,
        femaleHairObject23,
        femaleHairObject24,
        femaleHairObject25,
        femaleHairObject26,
        femaleHairObject27,
        femaleHairObject28,
        femaleHairObject30,
        femaleHairObject29
    ];
    let shirtTops = [
        topObject44,
        topObject1,
        topObject3,
        topObject46,
        topObject4,
        topObject7,
        topObject15,
        topObject20,
        topObject23,
        topObject25,
        topObject28,
        topObject29,
        topObject30,
        topObject31,
        topObject37,
        topObject41,
        topObject42,
        topObject43,
        topObject47,
        topObject48,
        topObject49,
        topObject50,
        topObject51,
        topObject52,
        topObject53,
        topObject54,
        emptyTopObject
    ];
    let vestTops = [
        topObject45,
        topObject2,
        topObject9,
        topObject10,
        topObject11,
        topObject13,
        topObject14,
        topObject18,
        topObject19,
        topObject22,
        topObject24,
        topObject26,
        topObject27,
        topObject32,
        topObject36,
        topObject38,
        topObject40,
        emptyTopObject
    ];
    let sportsBraTops = [
        sportsBraObjectBasic,
        sportsBraObjectLow,
        sportsBraObjectShort,
        sportsBraObjectThin,
        sportsBraObject1,
        sportsBraObject2,
        sportsBraObject3,
        sportsBraObject4,
        sportsBraObject5,
        sportsBraObject6,
        sportsBraObject7,
        sportsBraObject8,
        sportsBraObject9,
        sportsBraObject10,
        sportsBraObject11,
        sportsBraObject12,
        sportsBraObject13,
        sportsBraObject14,
        sportsBraObject15,
        sportsBraObject16,
        emptyTopObject
    ];
    let feminineTops = [
        femaleTopObject1,
        femaleTopObject2,
        femaleTopObject3,
        femaleTopObject4,
        femaleTopObject5,
        femaleTopObject6,
        femaleTopObject7,
        femaleTopObject8,
        femaleTopObject9,
        femaleTopObject10,
        femaleTopObject11,
        emptyTopObject
    ];
    let otherTops = [
        topObject5,
        topObject6,
        topObject8,
        topObject12,
        topObject16,
        topObject17,
        topObject21,
        topObject33,
        topObject34,
        topObject35,
        topObject39,
        emptyTopObject
    ];
    let feminineBottoms = [
        femaleBottomObject1,
        femaleBottomObject18,
        femaleBottomObject2,
        femaleBottomObject3,
        femaleBottomObject4,
        femaleBottomObject5,
        femaleBottomObject6,
        femaleBottomObject7,
        femaleBottomObject8,
        femaleBottomObject9,
        femaleBottomObject19,
        femaleBottomObject10,
        femaleBottomObject11,
        femaleBottomObject12,
        femaleBottomObject13,
        femaleBottomObject14,
        femaleBottomObject15,
        femaleBottomObject16,
        femaleBottomObject17,
        femaleBottomObject20,
        femaleBottomObject21
    ];
    let shortShoes = [
        shoesObject1,
        shoesObject3,
        shoesObject4,
        shoesObject5,
        shoesObject6,
        shoesObject8,
        shoesObject11,
        shoesObject16,
        shoesObject17,
        shoesObject18,
        emptyShoesObject
    ];
    let longShoes = [
        shoesObject0,
        shoesObject2,
        shoesObject7,
        shoesObject9,
        shoesObject10,
        shoesObject12,
        shoesObject13,
        shoesObject14,
        shoesObject15,
        shoesObject19,
        shoesObject20,
        emptyShoesObject
    ];
    let glovesAccessories = [
        glovesObject1,
        glovesObject2,
        glovesObject3,
        glovesObject4,
        glovesObject5,
        glovesObject6,
        emptyAccessoryObject
    ];
    let wristTapeAccessories = [
        wristTapeObject1,
        wristTapeObject2,
        wristTapeObject3,
        accessoryObject11,
        accessoryObject12,
        accessoryObject13,
        emptyAccessoryObject
    ];
    let suitAndTieAccessories = [
        suitsObject1,
        suitsObject2,
        suitsObject3,
        tiesObject1,
        tiesObject2,
        tiesObject3,
        tiesObject4,
        accessoryObject51,
        emptyAccessoryObject
    ];
    let feminineAccessories = [
        femaleAccessoryObject1,
        femaleAccessoryObject2,
        femaleAccessoryObject3,
        femaleAccessoryObject4,
        femaleAccessoryObject5,
        femaleAccessoryObject6,
        femaleAccessoryObject7,
        femaleAccessoryObject8,
        femaleAccessoryObject9,
        femaleAccessoryObject10,
        femaleAccessoryObject11,
        femaleAccessoryObject12,
        emptyAccessoryObject
    ];
    let neckAccessories = [
        accessoryObject4,
        accessoryObject5,
        accessoryObject15,
        accessoryObject16,
        emptyAccessoryObject
    ];
    let otherAccessories = [
        accessoryObject1,
        accessoryObject2,
        accessoryObject3,
        accessoryObject6,
        accessoryObject9,
        accessoryObject14,
        accessoryObject17,
        accessoryObject18,
        accessoryObject19,
        accessoryObject20,
        accessoryObject21,
        accessoryObject22,
        accessoryObject23,
        accessoryObject24,
        accessoryObject26,
        accessoryObject27,
        accessoryObject28,
        accessoryObject32,
        accessoryObject33,
        accessoryObject34,
        accessoryObject35,
        accessoryObject36,
        accessoryObject37,
        accessoryObject38,
        accessoryObject39,
        accessoryObject40,
        accessoryObject42,
        accessoryObject46,
        accessoryObject48,
        accessoryObject50,
        accessoryObject61,
        accessoryObject62,
        accessoryObject70,
        accessoryObject71,
        accessoryObject73,
        emptyAccessoryObject
    ];
    let glassesAccessories = [
        accessoryObject10,
        glassesObject2,
        glassesObject3,
        glassesObject4,
        glassesObject5,
        glassesObject6,
        glassesObject7,
        glassesObject8,
        emptyAccessoryObject
    ];
    let masksAccessories = [
        accessoryObject7,
        accessoryObject8,
        accessoryObject43,
        accessoryObject44,
        accessoryObject54,
        accessoryObject74,
        accessoryObject75,
        accessoryObject76,
        emptyAccessoryObject
    ];
    let flagsAccessories = [
        accessoryObject63,
        accessoryObject64,
        accessoryObject65,
        accessoryObject66,
        accessoryObject67,
        accessoryObject68,
        accessoryObject69,
        emptyAccessoryObject
    ];
    // Title parts
    let centerPlates = [
        centerPlateObject10,
        centerPlateObject1,
        centerPlateObject2,
        centerPlateObject3,
        centerPlateObject4,
        centerPlateObject5,
        centerPlateObject6,
        centerPlateObject7,
        centerPlateObject8,
        centerPlateObject9
    ];
    let smallCenterPlates = [
        smallPlateObject1,
        smallPlateObject2,
        smallPlateObject3,
        smallPlateObject4,
        smallPlateObject5,
        smallPlateObject6,
        smallPlateObject7,
        smallPlateObject8,
        smallPlateObject9,
        smallPlateObject10
    ];
    let smallStraps = [
        smallStrapObject1,
        smallStrapObject2,
        smallStrapObject3,
        smallStrapObject4,
        smallStrapObject5,
        smallStrapObject6,
        smallStrapObject7,
        smallStrapObject8,
        smallStrapObject9,
        smallStrapObject10
    ];
    let smallGems = [
        smallGemsObject1,
        smallGemsObject2,
        smallGemsObject3,
        smallGemsObject4,
        smallGemsObject5,
        smallGemsObject6,
        smallGemsObject7,
        smallGemsObject8,
        smallGemsObject9,
        smallGemsObject10
    ];
    let bloodObjects = [
        bloodObject1,
        bloodObject2,
        bloodObject3,
        bloodObject4,
        bloodObject5,
        bloodObject6,
        bloodObject7,
        bloodObject8,
        bloodObject9,
        bloodObject10,
        bloodObject11,
        bloodObject12,
        bloodObject13
    ];
    let backgroundObjects = [
        posterBackground1,
        posterBackground2,
        posterBackground3,
        posterBackground4,
        posterBackground5,
        posterBackground6,
        posterBackground7,
        posterBackground8,
        posterBackground9,
        posterBackground10
    ];
    let weaponObjects = [
        accessoryObject25,
        accessoryObject29,
        accessoryObject30,
        accessoryObject31,
        accessoryObject41,
        accessoryObject45,
        accessoryObject47,
        accessoryObject49,
        accessoryObject52,
        accessoryObject53,
        accessoryObject55,
        accessoryObject56,
        accessoryObject57,
        accessoryObject58,
        accessoryObject59,
        accessoryObject60,
        accessoryObject72
    ];
    let temporaryInjuryObjects = [
        bruiseEyeLeftObject,
        bruiseEyeRightObject,
        bandageArmLeftObject,
        bandageArmRightObject,
        bandageForeheadLeftObject,
        bandageForeheadRightObject,
        bandageForeheadFullObject
    ];
    let temporaryTrophyObjects = [
        trophyObject1
    ];
    return {
        accessories: accessories,
        bottoms: bottoms,
        torsos: torsos,
        hairs: hairs,
        shoes: shoes,
        elbows: elbows,
        facialHairs: facialHairs,
        bodies: bodies,
        kneepads: kneepads,
        facepaints: facepaints,
        tattoos: tattoos,
        eyes: eyes,
        bloodObjects: bloodObjects,
        weaponObjects: weaponObjects,
        temporaryInjuryObjects: temporaryInjuryObjects,
        temporaryTrophyObjects: temporaryTrophyObjects,
        shorts: shorts,
        trunks: trunks,
        tights: tights,
        flags: flags,
        allTattoos: allTattoos,
        masculineTattoos: masculineTattoos,
        feminineTattoos: feminineTattoos,
        allFacepaints: allFacepaints,
        masculineFacepaints: masculineFacepaints,
        feminineFacepaints: feminineFacepaints,
        shortHair: shortHair,
        longHair: longHair,
        feminineHair: feminineHair,
        shirtTops: shirtTops,
        vestTops: vestTops,
        sportsBraTops: sportsBraTops,
        feminineTops: feminineTops,
        otherTops: otherTops,
        feminineBottoms: feminineBottoms,
        shortShoes: shortShoes,
        longShoes: longShoes,
        glovesAccessories: glovesAccessories,
        wristTapeAccessories: wristTapeAccessories,
        suitAndTieAccessories: suitAndTieAccessories,
        feminineAccessories: feminineAccessories,
        neckAccessories: neckAccessories,
        otherAccessories: otherAccessories,
        glassesAccessories: glassesAccessories,
        masksAccessories: masksAccessories,
        flagsAccessories: flagsAccessories,
        centerPlates: centerPlates,
        smallCenterPlates: smallCenterPlates,
        smallStraps: smallStraps,
        smallGems: smallGems,
        backgroundObjects: backgroundObjects,
        gimmickMatchLadderBlack: gimmickMatchLadderBlack,
        gimmickMatchLadderGrey: gimmickMatchLadderGrey,
        gimmickMatchLadderOrange: gimmickMatchLadderOrange,
        gimmickMatchCageGrey: gimmickMatchCageGrey,
        gimmickMatchCageRed: gimmickMatchCageRed,
        gimmickMatchCageRetroBlue: gimmickMatchCageRetroBlue,
        gimmickMatchCageRetroBlack: gimmickMatchCageRetroBlack,
        gimmickMatchTableBrown: gimmickMatchTableBrown,
        gimmickMatchTableBrownStanding: gimmickMatchTableBrownStanding,
        gimmickMatchTableDarkBrown: gimmickMatchTableDarkBrown,
        gimmickMatchTableDarkBrownStanding: gimmickMatchTableDarkBrownStanding,
        gimmickMatchTableLightBrown: gimmickMatchTableLightBrown,
        gimmickMatchTableLightBrownStanding: gimmickMatchTableLightBrownStanding,
        gimmickMatchChairBiege: gimmickMatchChairBiege,
        gimmickMatchChairBlack: gimmickMatchChairBlack,
        gimmickMatchChairBlue: gimmickMatchChairBlue,
        gimmickMatchAmbulance: gimmickMatchAmbulance,
        gimmickMatchBarbedWireRopes: gimmickMatchBarbedWireRopes,
        gimmickMatchBarbedWireBoard: gimmickMatchBarbedWireBoard,
        gimmickMatchBuriedAlive: gimmickMatchBuriedAlive,
        gimmickMatchCasketBrown: gimmickMatchCasketBrown,
        gimmickMatchCasketPurple: gimmickMatchCasketPurple,
        gimmickMatchCasketLightBrown: gimmickMatchCasketLightBrown,
        gimmickMatchParkingLotA: gimmickMatchParkingLotA,
        gimmickMatchParkingLotB: gimmickMatchParkingLotB,
        specialSegmentsCar: specialSegmentsCar,
        specialSegmentsCarFire: specialSegmentsCarFire,
        specialSegmentsHelicopter: specialSegmentsHelicopter,
        specialSegmentsHelicopterBuilding: specialSegmentsHelicopterBuilding,
        specialSegmentsHelicopterBuildingLights: specialSegmentsHelicopterBuildingLights,
        specialSegmentsLemonadeTruck: specialSegmentsLemonadeTruck,
        specialSegmentsLemonadeTruckSpray: specialSegmentsLemonadeTruckSpray,
        specialSegmentsStage: specialSegmentsStage,
        specialSegmentsStageRailing: specialSegmentsStageRailing,
        specialSegmentsDummy: specialSegmentsDummy,
        specialSegmentsAmbulance: specialSegmentsAmbulance,
        specialSegmentsCelebrityAmericanQueen: specialSegmentsCelebrityAmericanQueen,
        specialSegmentsCelebrityPrezz: specialSegmentsCelebrityPrezz,
        specialSegmentsCelebrityBigT: specialSegmentsCelebrityBigT,
        specialSegmentsRantMic: specialSegmentsRantMic,
        specialSegmentsRantSpeech: specialSegmentsRantSpeech,
        specialSegmentsLoveMakingManClothed: specialSegmentsLoveMakingManClothed,
        specialSegmentsLoveMakingManNude: specialSegmentsLoveMakingManNude,
        specialSegmentsLoveMakingWomanClothed: specialSegmentsLoveMakingWomanClothed,
        specialSegmentsLoveMakingWomanNude: specialSegmentsLoveMakingWomanNude,
        specialSegmentsLoveMakingBottomCensor: specialSegmentsLoveMakingBottomCensor,
        specialSegmentsLoveMakingTopCensor: specialSegmentsLoveMakingTopCensor,
        specialSegmentsLoveMakingBed: specialSegmentsLoveMakingBed,
        specialSegmentsLoveMakingHeart: specialSegmentsLoveMakingHeart,
        specialSegmentsRing: specialSegmentsRing,
        specialSegmentsRingRopes: specialSegmentsRingRopes,
        specialSegmentsRingPeopleTop: specialSegmentsRingPeopleTop,
        specialSegmentsRingPeopleBottom: specialSegmentsRingPeopleBottom,
        accessoryObject23: accessoryObject23,
        accessoryObject24: accessoryObject24,
        accessoryObject50: accessoryObject50,
        accessoryObject25: accessoryObject25,
        accessoryObject29: accessoryObject29,
        accessoryObject30: accessoryObject30,
        accessoryObject31: accessoryObject31,
        accessoryObject41: accessoryObject41,
        accessoryObject45: accessoryObject45,
        accessoryObject47: accessoryObject47,
        accessoryObject49: accessoryObject49,
        accessoryObject52: accessoryObject52,
        accessoryObject53: accessoryObject53,
        accessoryObject55: accessoryObject55,
        accessoryObject56: accessoryObject56,
        accessoryObject57: accessoryObject57,
        accessoryObject58: accessoryObject58,
        accessoryObject59: accessoryObject59,
        accessoryObject72: accessoryObject72,
        TGIFireworks: TGIFireworks,
        TGITrophy: TGITrophy,
        emptySprite: emptySprite,
        topObject41: topObject41,
        emptyTopObject: emptyTopObject,
        tightsObject0: tightsObject0,
        shoesObject0: shoesObject0,
        hairObject1: hairObject1,
        femaleBottomObject7: femaleBottomObject7,
        sportsBraObjectBasic: sportsBraObjectBasic,
        posterBackground3: posterBackground3,
        bodyObjectShe: bodyObjectShe,
        bodyObjectSheAbs: bodyObjectSheAbs,
        bodyObjectHe: bodyObjectHe
    };
}
function $cdadd3e3b416e3dd$export$3418d293d1536e9() {
    // Get sprites
    let textures = PIXI.loader.resources["static/www/static/images/sprites/sprites.json"].textures;
    let centerPlate1 = new PIXI.Sprite(textures["title_center_1.png"]);
    let centerPlate2 = new PIXI.Sprite(textures["title_center_2.png"]);
    let centerPlate3 = new PIXI.Sprite(textures["title_center_3.png"]);
    let centerPlate4 = new PIXI.Sprite(textures["title_center_4.png"]);
    let centerPlate5 = new PIXI.Sprite(textures["title_center_5.png"]);
    let centerPlate6 = new PIXI.Sprite(textures["title_center_6.png"]);
    let centerPlate7 = new PIXI.Sprite(textures["title_center_7.png"]);
    let centerPlate8 = new PIXI.Sprite(textures["title_center_8.png"]);
    let centerPlate9 = new PIXI.Sprite(textures["title_center_9.png"]);
    let centerPlate10 = new PIXI.Sprite(textures["title_center_10.png"]);
    let centerGems1 = new PIXI.Sprite(textures["title_gems_1.png"]);
    let centerGems2 = new PIXI.Sprite(textures["title_gems_2.png"]);
    let centerGems3 = new PIXI.Sprite(textures["title_gems_3.png"]);
    let centerGems4 = new PIXI.Sprite(textures["title_gems_4.png"]);
    let centerGems5 = new PIXI.Sprite(textures["title_gems_5.png"]);
    let centerGems6 = new PIXI.Sprite(textures["title_gems_6.png"]);
    let centerGems7 = new PIXI.Sprite(textures["title_gems_7.png"]);
    let centerGems8 = new PIXI.Sprite(textures["title_gems_8.png"]);
    let centerGems9 = new PIXI.Sprite(textures["title_gems_9.png"]);
    let centerGems10 = new PIXI.Sprite(textures["title_gems_10.png"]);
    let sideGems1 = new PIXI.Sprite(textures["title_side_gems_1.png"]);
    let sideGems2 = new PIXI.Sprite(textures["title_side_gems_2.png"]);
    let sideGems3 = new PIXI.Sprite(textures["title_side_gems_3.png"]);
    let sideGems4 = new PIXI.Sprite(textures["title_side_gems_4.png"]);
    let sideGems5 = new PIXI.Sprite(textures["title_side_gems_5.png"]);
    let sideGems6 = new PIXI.Sprite(textures["title_side_gems_6.png"]);
    let sideGems7 = new PIXI.Sprite(textures["title_side_gems_7.png"]);
    let sideGems8 = new PIXI.Sprite(textures["title_side_gems_8.png"]);
    let sideGems9 = new PIXI.Sprite(textures["title_side_gems_9.png"]);
    let sideGems10 = new PIXI.Sprite(textures["title_side_gems_10.png"]);
    let strap1 = new PIXI.Sprite(textures["title_strap_1.png"]);
    let strap2 = new PIXI.Sprite(textures["title_strap_2.png"]);
    let strap3 = new PIXI.Sprite(textures["title_strap_3.png"]);
    let strap4 = new PIXI.Sprite(textures["title_strap_4.png"]);
    let strap5 = new PIXI.Sprite(textures["title_strap_5.png"]);
    let strap6 = new PIXI.Sprite(textures["title_strap_6.png"]);
    let strap7 = new PIXI.Sprite(textures["title_strap_7.png"]);
    let strap8 = new PIXI.Sprite(textures["title_strap_8.png"]);
    let strap9 = new PIXI.Sprite(textures["title_strap_9.png"]);
    let strap10 = new PIXI.Sprite(textures["title_strap_10.png"]);
    let sidePlates1 = new PIXI.Sprite(textures["title_side_plates_1.png"]);
    let sidePlates2 = new PIXI.Sprite(textures["title_side_plates_2.png"]);
    let sidePlates3 = new PIXI.Sprite(textures["title_side_plates_3.png"]);
    let sidePlates4 = new PIXI.Sprite(textures["title_side_plates_4.png"]);
    let sidePlates5 = new PIXI.Sprite(textures["title_side_plates_5.png"]);
    let sidePlates6 = new PIXI.Sprite(textures["title_side_plates_6.png"]);
    let sidePlates7 = new PIXI.Sprite(textures["title_side_plates_7.png"]);
    let sidePlates8 = new PIXI.Sprite(textures["title_side_plates_8.png"]);
    let sidePlates9 = new PIXI.Sprite(textures["title_side_plates_9.png"]);
    let sidePlates10 = new PIXI.Sprite(textures["title_side_plates_10.png"]);
    let sidePlatesGeneral1 = new PIXI.Sprite(textures["side_plates_1.png"]);
    let sidePlatesGeneral2 = new PIXI.Sprite(textures["side_plates_2.png"]);
    let sidePlatesGeneral3 = new PIXI.Sprite(textures["side_plates_3.png"]);
    let sidePlatesGeneral4 = new PIXI.Sprite(textures["side_plates_4.png"]);
    let sidePlatesGeneral5 = new PIXI.Sprite(textures["side_plates_5.png"]);
    let sidePlatesGeneral6 = new PIXI.Sprite(textures["side_plates_6.png"]);
    let sidePlatesGeneral7 = new PIXI.Sprite(textures["side_plates_7.png"]);
    let sidePlatesGeneral8 = new PIXI.Sprite(textures["side_plates_8.png"]);
    let sidePlatesGeneral9 = new PIXI.Sprite(textures["side_plates_9.png"]);
    let sidePlatesGeneral10 = new PIXI.Sprite(textures["side_plates_10.png"]);
    let sidePlatesGeneral11 = new PIXI.Sprite(textures["side_plates_11.png"]);
    let sideGemsGeneral1 = new PIXI.Sprite(textures["side_plate_gems_1.png"]);
    let sideGemsGeneral2 = new PIXI.Sprite(textures["side_plate_gems_2.png"]);
    let sideGemsGeneral3 = new PIXI.Sprite(textures["side_plate_gems_3.png"]);
    let sideGemsGeneral4 = new PIXI.Sprite(textures["side_plate_gems_4.png"]);
    let sideGemsGeneral5 = new PIXI.Sprite(textures["side_plate_gems_5.png"]);
    let sideGemsGeneral6 = new PIXI.Sprite(textures["side_plate_gems_6.png"]);
    let sideGemsGeneral7 = new PIXI.Sprite(textures["side_plate_gems_7.png"]);
    let sideGemsGeneral8 = new PIXI.Sprite(textures["side_plate_gems_8.png"]);
    let sideGemsGeneral9 = new PIXI.Sprite(textures["side_plate_gems_9.png"]);
    let sideGemsGeneral10 = new PIXI.Sprite(textures["side_plate_gems_10.png"]);
    let sideGemsGeneral11 = new PIXI.Sprite(textures["side_plate_gems_11.png"]);
    let emptySprite = new PIXI.Sprite(textures["empty_sprite.png"]);
    let centerGemsObject1 = {
        designs: [
            {
                sprite: centerGems1,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let centerGemsObject2 = {
        designs: [
            {
                sprite: centerGems2,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let centerGemsObject3 = {
        designs: [
            {
                sprite: centerGems3,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let centerGemsObject4 = {
        designs: [
            {
                sprite: centerGems4,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let centerGemsObject5 = {
        designs: [
            {
                sprite: centerGems5,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let centerGemsObject6 = {
        designs: [
            {
                sprite: centerGems6,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let centerGemsObject7 = {
        designs: [
            {
                sprite: centerGems7,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let centerGemsObject8 = {
        designs: [
            {
                sprite: centerGems8,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let centerGemsObject9 = {
        designs: [
            {
                sprite: centerGems9,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let centerGemsObject10 = {
        designs: [
            {
                sprite: centerGems10,
                zIndex: 2,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject1 = {
        designs: [
            {
                sprite: sideGems1,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject2 = {
        designs: [
            {
                sprite: sideGems2,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject3 = {
        designs: [
            {
                sprite: sideGems3,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject4 = {
        designs: [
            {
                sprite: sideGems4,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject5 = {
        designs: [
            {
                sprite: sideGems5,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject6 = {
        designs: [
            {
                sprite: sideGems6,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject7 = {
        designs: [
            {
                sprite: sideGems7,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject8 = {
        designs: [
            {
                sprite: sideGems8,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject9 = {
        designs: [
            {
                sprite: sideGems9,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsObject10 = {
        designs: [
            {
                sprite: sideGems10,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject1 = {
        designs: [
            {
                sprite: sideGemsGeneral1,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject2 = {
        designs: [
            {
                sprite: sideGemsGeneral2,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject3 = {
        designs: [
            {
                sprite: sideGemsGeneral3,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject4 = {
        designs: [
            {
                sprite: sideGemsGeneral4,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject5 = {
        designs: [
            {
                sprite: sideGemsGeneral5,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject6 = {
        designs: [
            {
                sprite: sideGemsGeneral6,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject7 = {
        designs: [
            {
                sprite: sideGemsGeneral7,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject8 = {
        designs: [
            {
                sprite: sideGemsGeneral8,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject9 = {
        designs: [
            {
                sprite: sideGemsGeneral9,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject10 = {
        designs: [
            {
                sprite: sideGemsGeneral10,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let sideGemsGeneralObject11 = {
        designs: [
            {
                sprite: sideGemsGeneral11,
                zIndex: 4,
                defaultColor: "0xC51616"
            }
        ]
    };
    let strapObject1 = {
        designs: [
            {
                sprite: strap1,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let strapObject2 = {
        designs: [
            {
                sprite: strap2,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let strapObject3 = {
        designs: [
            {
                sprite: strap3,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let strapObject4 = {
        designs: [
            {
                sprite: strap4,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let strapObject5 = {
        designs: [
            {
                sprite: strap5,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let strapObject6 = {
        designs: [
            {
                sprite: strap6,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let strapObject7 = {
        designs: [
            {
                sprite: strap7,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let strapObject8 = {
        designs: [
            {
                sprite: strap8,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let strapObject9 = {
        designs: [
            {
                sprite: strap9,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let strapObject10 = {
        designs: [
            {
                sprite: strap10,
                zIndex: 0,
                defaultColor: "0x1D1D1D"
            }
        ]
    };
    let sidePlateObject1 = {
        designs: [
            {
                sprite: sidePlates1,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject1
    };
    let sidePlateObject2 = {
        designs: [
            {
                sprite: sidePlates2,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject2
    };
    let sidePlateObject3 = {
        designs: [
            {
                sprite: sidePlates3,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject3
    };
    let sidePlateObject4 = {
        designs: [
            {
                sprite: sidePlates4,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject4
    };
    let sidePlateObject5 = {
        designs: [
            {
                sprite: sidePlates5,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject5
    };
    let sidePlateObject6 = {
        designs: [
            {
                sprite: sidePlates6,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject6
    };
    let sidePlateObject7 = {
        designs: [
            {
                sprite: sidePlates7,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject7
    };
    let sidePlateObject8 = {
        designs: [
            {
                sprite: sidePlates8,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject8
    };
    let sidePlateObject9 = {
        designs: [
            {
                sprite: sidePlates9,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject9
    };
    let sidePlateObject10 = {
        designs: [
            {
                sprite: sidePlates10,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsObject10
    };
    let sidePlatesGeneralObject1 = {
        designs: [
            {
                sprite: sidePlatesGeneral1,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject1
    };
    let sidePlatesGeneralObject2 = {
        designs: [
            {
                sprite: sidePlatesGeneral2,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject2
    };
    let sidePlatesGeneralObject3 = {
        designs: [
            {
                sprite: sidePlatesGeneral3,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject3
    };
    let sidePlatesGeneralObject4 = {
        designs: [
            {
                sprite: sidePlatesGeneral4,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject4
    };
    let sidePlatesGeneralObject5 = {
        designs: [
            {
                sprite: sidePlatesGeneral5,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject6
    };
    let sidePlatesGeneralObject6 = {
        designs: [
            {
                sprite: sidePlatesGeneral6,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject5
    };
    let sidePlatesGeneralObject7 = {
        designs: [
            {
                sprite: sidePlatesGeneral7,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject7
    };
    let sidePlatesGeneralObject8 = {
        designs: [
            {
                sprite: sidePlatesGeneral8,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject8
    };
    let sidePlatesGeneralObject9 = {
        designs: [
            {
                sprite: sidePlatesGeneral9,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject9
    };
    let sidePlatesGeneralObject10 = {
        designs: [
            {
                sprite: sidePlatesGeneral10,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject10
    };
    let sidePlatesGeneralObject11 = {
        designs: [
            {
                sprite: sidePlatesGeneral11,
                zIndex: 3,
                defaultColor: "0xC59548"
            }
        ],
        sideGemsPart: sideGemsGeneralObject11
    };
    let centerPlateObject1 = {
        designs: [
            {
                sprite: centerPlate1,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject1,
        strapPart: strapObject1,
        sidePlatesPart: sidePlateObject1
    };
    let centerPlateObject2 = {
        designs: [
            {
                sprite: centerPlate2,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject2,
        strapPart: strapObject2,
        sidePlatesPart: sidePlateObject2
    };
    let centerPlateObject3 = {
        designs: [
            {
                sprite: centerPlate3,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject3,
        strapPart: strapObject3,
        sidePlatesPart: sidePlateObject3
    };
    let centerPlateObject4 = {
        designs: [
            {
                sprite: centerPlate4,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject4,
        strapPart: strapObject4,
        sidePlatesPart: sidePlateObject4
    };
    let centerPlateObject5 = {
        designs: [
            {
                sprite: centerPlate5,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject5,
        strapPart: strapObject5,
        sidePlatesPart: sidePlateObject5
    };
    let centerPlateObject6 = {
        designs: [
            {
                sprite: centerPlate6,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject6,
        strapPart: strapObject6,
        sidePlatesPart: sidePlateObject6
    };
    let centerPlateObject7 = {
        designs: [
            {
                sprite: centerPlate7,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject7,
        strapPart: strapObject7,
        sidePlatesPart: sidePlateObject7
    };
    let centerPlateObject8 = {
        designs: [
            {
                sprite: centerPlate8,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject8,
        strapPart: strapObject8,
        sidePlatesPart: sidePlateObject8
    };
    let centerPlateObject9 = {
        designs: [
            {
                sprite: centerPlate9,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject9,
        strapPart: strapObject9,
        sidePlatesPart: sidePlateObject9
    };
    let centerPlateObject10 = {
        designs: [
            {
                sprite: centerPlate10,
                zIndex: 1,
                defaultColor: "0xC59548"
            }
        ],
        gemPart: centerGemsObject10,
        strapPart: strapObject10,
        sidePlatesPart: sidePlateObject10
    };
    // Empty objects
    let emptyCenterGemsObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 0,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let emptySideGemsObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 0,
                defaultColor: "0xFFFFFF"
            }
        ]
    };
    let emptySidePlatesObject = {
        designs: [
            {
                sprite: emptySprite,
                zIndex: 0,
                defaultColor: "0xFFFFFF"
            }
        ],
        sideGemsPart: emptySideGemsObject
    };
    // Initialize variables and arrays
    let allCenterPlates = [
        centerPlateObject10,
        centerPlateObject1,
        centerPlateObject2,
        centerPlateObject3,
        centerPlateObject4,
        centerPlateObject5,
        centerPlateObject6,
        centerPlateObject7,
        centerPlateObject8,
        centerPlateObject9
    ];
    let allStraps = [
        strapObject1,
        strapObject2,
        strapObject3,
        strapObject4,
        strapObject5,
        strapObject6,
        strapObject7,
        strapObject8,
        strapObject9,
        strapObject10
    ];
    let allCenterGems = [
        centerGemsObject1,
        centerGemsObject2,
        centerGemsObject3,
        centerGemsObject4,
        centerGemsObject5,
        centerGemsObject6,
        centerGemsObject7,
        centerGemsObject8,
        centerGemsObject9,
        centerGemsObject10,
        emptyCenterGemsObject
    ];
    let allSidePlates = [
        sidePlateObject1,
        sidePlateObject2,
        sidePlateObject3,
        sidePlateObject4,
        sidePlateObject5,
        sidePlateObject6,
        sidePlateObject7,
        sidePlateObject8,
        sidePlateObject9,
        sidePlateObject10,
        sidePlatesGeneralObject1,
        sidePlatesGeneralObject2,
        sidePlatesGeneralObject3,
        sidePlatesGeneralObject4,
        sidePlatesGeneralObject5,
        sidePlatesGeneralObject6,
        sidePlatesGeneralObject7,
        sidePlatesGeneralObject8,
        sidePlatesGeneralObject9,
        sidePlatesGeneralObject10,
        sidePlatesGeneralObject11,
        emptySidePlatesObject
    ];
    let allSideGems = [
        sideGemsObject1,
        sideGemsObject2,
        sideGemsObject3,
        sideGemsObject4,
        sideGemsObject5,
        sideGemsObject6,
        sideGemsObject7,
        sideGemsObject8,
        sideGemsObject9,
        sideGemsObject10,
        sideGemsGeneralObject1,
        sideGemsGeneralObject2,
        sideGemsGeneralObject3,
        sideGemsGeneralObject4,
        sideGemsGeneralObject5,
        sideGemsGeneralObject6,
        sideGemsGeneralObject7,
        sideGemsGeneralObject8,
        sideGemsGeneralObject9,
        sideGemsGeneralObject10,
        sideGemsGeneralObject11,
        emptySideGemsObject
    ];
    let centerPlates = [
        centerPlateObject10,
        centerPlateObject1,
        centerPlateObject2,
        centerPlateObject3,
        centerPlateObject4,
        centerPlateObject5,
        centerPlateObject6,
        centerPlateObject7,
        centerPlateObject8,
        centerPlateObject9
    ];
    let straps = [
        strapObject1
    ];
    let centerGems = [
        centerGemsObject1
    ];
    let sidePlates = [
        sidePlateObject1,
        sidePlateObject2,
        sidePlateObject3,
        sidePlateObject4,
        sidePlateObject5,
        sidePlateObject6,
        sidePlateObject7,
        sidePlateObject8,
        sidePlateObject9,
        sidePlateObject10,
        sidePlatesGeneralObject1,
        sidePlatesGeneralObject2,
        sidePlatesGeneralObject3,
        sidePlatesGeneralObject4,
        sidePlatesGeneralObject5,
        sidePlatesGeneralObject6,
        sidePlatesGeneralObject7,
        sidePlatesGeneralObject8,
        sidePlatesGeneralObject9,
        sidePlatesGeneralObject10,
        sidePlatesGeneralObject11,
        emptySidePlatesObject
    ];
    let sideGems = [
        sideGemsObject1
    ];
    return {
        allCenterPlates: allCenterPlates,
        allStraps: allStraps,
        allCenterGems: allCenterGems,
        allSidePlates: allSidePlates,
        allSideGems: allSideGems,
        centerPlates: centerPlates,
        straps: straps,
        centerGems: centerGems,
        sidePlates: sidePlates,
        sideGems: sideGems,
        emptySprite: emptySprite,
        emptyCenterGemsObject: emptyCenterGemsObject,
        emptySideGemsObject: emptySideGemsObject,
        emptySidePlatesObject: emptySidePlatesObject
    };
}



var $3E8Nt = parcelRequire("3E8Nt");

var $1JSre = parcelRequire("1JSre");

var $98xmD = parcelRequire("98xmD");

var $lCS03 = parcelRequire("lCS03");


var $1JSre = parcelRequire("1JSre");

var $3E8Nt = parcelRequire("3E8Nt");

var $98xmD = parcelRequire("98xmD");

var $lCS03 = parcelRequire("lCS03");

var $8A6FL = parcelRequire("8A6FL");

var $1JSre = parcelRequire("1JSre");

var $3E8Nt = parcelRequire("3E8Nt");

var $4ptHI = parcelRequire("4ptHI");

var $1JkT6 = parcelRequire("1JkT6");


var $1JSre = parcelRequire("1JSre");

var $3E8Nt = parcelRequire("3E8Nt");

var $98xmD = parcelRequire("98xmD");

var $98xmD = parcelRequire("98xmD");

var $3E8Nt = parcelRequire("3E8Nt");

var $1JSre = parcelRequire("1JSre");


var $lCS03 = parcelRequire("lCS03");

var $jpMCP = parcelRequire("jpMCP");


var $3E8Nt = parcelRequire("3E8Nt");

var $1JSre = parcelRequire("1JSre");

var $98xmD = parcelRequire("98xmD");

var $lCS03 = parcelRequire("lCS03");

var $6PzHO = parcelRequire("6PzHO");

var $jpMCP = parcelRequire("jpMCP");

function $9c7fdb096dd8e19a$export$4da77264dc7a7732(faction) {
    // Get disbanded text and class
    let disbandedHtml = "";
    let disbandedClass = "";
    if (faction["disbanded"]) {
        disbandedHtml = '<div class="margin-top-2">Disbanded</div>';
        disbandedClass = " light-opaque";
    }
    // Get superstar names
    let superstarNames = Array.from(faction["superstars"], function(superstar) {
        if (superstar["leader"]) return '<span class="medium-grey">' + superstar["name"] + "</span>";
        else return superstar["name"];
    });
    // Get html
    return '<div class="view-factions-item' + disbandedClass + '" data-uid="' + faction["uid"] + '">' + '<div class="margin-bottom-8">' + "<span>" + faction["name"] + "</span>" + '<span class="float-right light-grey">' + faction["reputationData"]["reputation"] + " REP" + "</span>" + "</div>" + '<div class="light-grey">' + (0, $3E8Nt.commaSeparate)(superstarNames) + disbandedHtml + "</div>" + "</div>";
}
function $9c7fdb096dd8e19a$export$91cd24c87164e19f(data, isCompetitorFaction, element) {
    if (typeof element === "undefined") element = null;
    let parentElement = $(".faction-details-container");
    // Add element to data
    parentElement.data("element", element);
    // Name
    parentElement.find(".faction-details-name").html(data["name"]);
    // Graphic
    $(".faction-details-graphic").html("");
    let el = parentElement.find(".faction-details-graphic");
    let matchData = {
        "type": "singles",
        "larger_tag": data["graphic"].length,
        "faction_graphic": true
    };
    if (data["graphic"].length > 10) matchData = {
        "type": "singles"
    };
    (0, $c82cd471f4baff6b$export$4b9758d42b68e382)(data["graphic"], el, matchData);
    $(".faction-details").data("graphic", data["graphic"]);
    // Leader
    let factionLeader = data["superstars"].filter(function(obj) {
        return obj["leader"] === true;
    })[0];
    let factionLeaderHtml = factionLeader ? $9c7fdb096dd8e19a$export$7bc49520a71c2f4d([
        factionLeader
    ]) : "None";
    parentElement.find(".faction-details-leader").html(factionLeaderHtml);
    // Other superstars
    let otherSuperstars = data["superstars"].filter(function(obj) {
        return obj["leader"] !== true;
    });
    let otherSuperstarsHtml = $9c7fdb096dd8e19a$export$7bc49520a71c2f4d(otherSuperstars, true);
    parentElement.find(".faction-details-superstars").html(otherSuperstarsHtml);
    // Former members if present
    if (data["formerMembers"] && data["formerMembers"].length > 0) {
        let formerMembersHtml = "";
        data["formerMembers"].forEach(function(formerMember) {
            formerMembersHtml += '<div class="margin-bottom-4">' + formerMember + "</div>";
        });
        parentElement.find(".faction-details-former-members").html(formerMembersHtml);
        parentElement.find(".faction-details-former-members").parent().show();
    } else {
        parentElement.find(".faction-details-former-members").html("");
        parentElement.find(".faction-details-former-members").parent().hide();
    }
    // Show all buttons
    parentElement.find(".faction-details-buttons").children().show();
    // Hide 'remove leader' button if no leader
    if (factionLeader) parentElement.find(".remove-faction-leader-button").show();
    else parentElement.find(".remove-faction-leader-button").hide();
    // Show disbanded, hide buttons if disbanded
    if (data["disbanded"]) {
        parentElement.find(".faction-details-disbanded").show();
        parentElement.find(".faction-details-buttons").children(":not(.back-to-view-factions-button)").hide();
    } else {
        parentElement.find(".faction-details-disbanded").hide();
        parentElement.find(".faction-details-buttons").children(":not(.back-to-view-factions-button)").show();
    }
    // Hide all buttons except 'back' if competitor faction
    if (isCompetitorFaction) parentElement.find(".faction-details-buttons").children(":not(.back-to-view-factions-button)").hide();
    // Reputation and progress
    let reputationHtml = "REP {0}".format(data["reputationData"]["reputation"]);
    if (data["reputationData"]["reputation"] >= 10) reputationHtml += '<span class="margin-left-8 red">MAX</span>';
    parentElement.find(".faction-details-reputation").html(reputationHtml);
    let reputationProgressHtml = $9c7fdb096dd8e19a$var$getFactionReputationProgressHtml(data["reputationData"]);
    $(".faction-details-reputation-progress").html(reputationProgressHtml);
    // Add uid to data
    parentElement.data("factionUid", data["uid"]);
    // Show faction details container
    (0, $1JSre.hideContent)($());
    parentElement.fadeIn("slow");
    parentElement[0].scrollIntoView();
}
function $9c7fdb096dd8e19a$export$7bc49520a71c2f4d(superstarsData, addSuperstarMargins, highlightLeader) {
    let factionSuperstarsHtml = "";
    superstarsData.forEach(function(superstarData) {
        // Name
        let superstarHtml;
        if (superstarData["leader"] && highlightLeader) superstarHtml = '<span class="dark-grey">' + superstarData["name"] + "</span>";
        else superstarHtml = superstarData["name"];
        // Championships
        if (superstarData["championshipsNames"]) superstarHtml += '<span class="gold margin-left-8">' + superstarData["championshipsNames"] + "</span>";
        // Manager
        if (superstarData["fullTimeManager"]) superstarHtml += ' <span class="light-grey">(Manager)</span>';
        // Margins
        if (addSuperstarMargins) factionSuperstarsHtml += '<div class="margin-bottom-4">' + superstarHtml + "</div>";
        else factionSuperstarsHtml += "<div>" + superstarHtml + "</div>";
    });
    return factionSuperstarsHtml;
}
function $9c7fdb096dd8e19a$var$getFactionReputationProgressHtml(reputationData) {
    let progressPercentage = reputationData["progressPercentage"];
    if (progressPercentage <= 0) progressPercentage = 1;
    return '<div class="progress-under compact help-text" title="' + reputationData["xp"] + " / " + reputationData["xpToNextReputation"] + ' XP">' + '<div class="progress compact" style="width:' + progressPercentage + '%">' + "</div>" + "</div>";
}
async function $9c7fdb096dd8e19a$export$241c76ae49f3fa40() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.getSuperstarsAvailableForFaction)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $9c7fdb096dd8e19a$var$showAddFactionPageData(data);
}
function $9c7fdb096dd8e19a$var$showAddFactionPageData(data) {
    const $addFactionContainer = $(".add-faction-container");
    // Reset add faction inputs
    $addFactionContainer.find(".select-faction-member").slice(2).parent().remove();
    $(".add-faction-container .add-faction-name").val("");
    // Reset faction member selects
    let selectFactionMemberDiv = $addFactionContainer.find(".select-faction-member");
    selectFactionMemberDiv.html("");
    // Add available superstars to faction member and faction leader selects
    data["availableSuperstars"].forEach(function(factionSuperstar) {
        selectFactionMemberDiv.append($("<option />").val(factionSuperstar["uid"]).text(factionSuperstar["name"]));
    });
    // Select second option for second faction member select
    selectFactionMemberDiv.eq(1).find(":selected").next().prop("selected", true);
    // Update faction leader select
    $9c7fdb096dd8e19a$export$25d3e1524ca4231d($addFactionContainer);
    $addFactionContainer.fadeIn("slow");
}
async function $9c7fdb096dd8e19a$export$5b36f1fda16fa6c1() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    let factionUid = $(".faction-details-container").data("factionUid");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.getSuperstarsAvailableForFaction)({
        factionUid: factionUid
    });
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $9c7fdb096dd8e19a$var$showAddFactionMembersPageData(data);
}
function $9c7fdb096dd8e19a$var$showAddFactionMembersPageData(data) {
    const $addFactionMembersContainer = $(".add-faction-members-container");
    // Reset faction member selects
    $addFactionMembersContainer.find(".select-faction-member").not(":eq(0)").parent().remove();
    let selectFactionMemberDiv = $addFactionMembersContainer.find(".select-faction-member");
    selectFactionMemberDiv.html("");
    data["availableSuperstars"].forEach(function(factionSuperstar) {
        selectFactionMemberDiv.append($("<option />").val(factionSuperstar["uid"]).text(factionSuperstar["name"]));
    });
    $addFactionMembersContainer.fadeIn("slow");
}
async function $9c7fdb096dd8e19a$export$21bf19b4e900627a() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    let factionUid = $(".faction-details-container").data("factionUid");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.getFactionSuperstarsRequest)({
        factionUid: factionUid
    });
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $9c7fdb096dd8e19a$var$showRemoveFactionMembersPageData(data);
}
function $9c7fdb096dd8e19a$var$showRemoveFactionMembersPageData(data) {
    const $removeFactionMembersContainer = $(".remove-faction-members-container");
    // Reset faction member selects
    $removeFactionMembersContainer.find(".select-faction-member").not(":eq(0)").parent().remove();
    let selectFactionMemberDiv = $removeFactionMembersContainer.find(".select-faction-member");
    selectFactionMemberDiv.html("");
    data["factionSuperstars"].forEach(function(factionSuperstar) {
        selectFactionMemberDiv.append($("<option />").val(factionSuperstar["uid"]).text(factionSuperstar["name"]));
    });
    $removeFactionMembersContainer.fadeIn("slow");
}
async function $9c7fdb096dd8e19a$export$412a54151b429031() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    let factionUid = $(".faction-details-container").data("factionUid");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.getFactionSuperstarsRequest)({
        factionUid: factionUid
    });
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $9c7fdb096dd8e19a$var$showSetFactionLeaderPageData(data);
}
function $9c7fdb096dd8e19a$var$showSetFactionLeaderPageData(data) {
    let selectFactionLeaderDiv = $(".set-faction-leader-container .select-faction-leader");
    selectFactionLeaderDiv.html("");
    data["factionSuperstars"].forEach(function(factionSuperstar) {
        selectFactionLeaderDiv.append($("<option />").val(factionSuperstar["uid"]).text(factionSuperstar["name"]));
    });
    $(".set-faction-leader-container").fadeIn("slow");
}
async function $9c7fdb096dd8e19a$export$2c66b191d8ddd09() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    let type = "faction";
    let factionUid = $(".faction-details-container").data("factionUid");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $jpMCP.getRosterMemberNameData)({
        uid: factionUid,
        type: type
    });
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $9c7fdb096dd8e19a$var$showChangeFactionNamePageData(data, factionUid, type);
}
function $9c7fdb096dd8e19a$var$showChangeFactionNamePageData(data, factionUid, type) {
    const $changeNameContainer = $("#change-name-container");
    $(".change-name-member-name").text(data["name"]);
    $("#change-name-container .change-name-input").val(data["name"]);
    $changeNameContainer.data("uid", factionUid);
    $changeNameContainer.data("type", type);
    $changeNameContainer.fadeIn();
}
async function $9c7fdb096dd8e19a$export$2aafbbea3509d6f4() {
    if ((0, $98xmD.globals).requestRunning) return;
    let parent = $(".add-faction-container");
    let factionName = parent.find(".add-faction-name").val();
    let leaderSuperstarUid = parseInt(parent.find(".select-faction-leader").find(":selected").val());
    let superstarUids = Array.from(parent.find(".select-faction-member"), function(x) {
        return parseInt($(x).find(":selected").val());
    });
    // Validate
    if (factionName.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Faction"
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.addFaction)(factionName, superstarUids, leaderSuperstarUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $9c7fdb096dd8e19a$var$showAddFactionData(data);
}
function $9c7fdb096dd8e19a$var$showAddFactionData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block">' + data["factionName"] + " added" + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to view factions
        setTimeout(function() {
            $("#view-factions-menu-button").trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to add a faction."
        });
        if (data["error"] === "already-present") notie.alert({
            type: 3,
            text: "A faction with that name already exists."
        });
        if (data["error"] === "team-already-present") notie.alert({
            type: 3,
            text: "A team with that name already exists."
        });
        if (data["error"] === "superstar-not-found") notie.alert({
            type: 3,
            text: "One of the selected superstars could not be found. Please try again."
        });
        if (data["error"] === "already-in-faction") notie.alert({
            type: 3,
            text: data["errorSuperstarName"] + " is already in another faction."
        });
        if (data["error"] === "leader-superstar-not-present") notie.alert({
            type: 3,
            text: "The leader needs to be a member of the faction."
        });
        if (data["error"] === "maximum-superstars") notie.alert({
            type: 3,
            text: `You cannot have more than ${(0, $3E8Nt.gameLimits).maxFactionSuperstars} members in a faction.`
        });
        if (data["error"] === "minimum-superstars") notie.alert({
            type: 3,
            text: "You cannot have less than 2 members in a faction."
        });
    }
}
async function $9c7fdb096dd8e19a$export$29c5871aa73736ca() {
    if ((0, $98xmD.globals).requestRunning) return;
    let factionUid = $(".faction-details-container").data("factionUid");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.disbandFactionRequest)(factionUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $9c7fdb096dd8e19a$var$showDisbandFactionData(data);
}
function $9c7fdb096dd8e19a$var$showDisbandFactionData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block">' + data["factionName"] + " have disbanded" + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Go back to view factions
        const $viewFactionsMenuButton = $("#view-factions-menu-button");
        setTimeout(function() {
            if ($viewFactionsMenuButton.length <= 0) {
                (0, $212d6f8aa99fe567$export$55237cdd4bf855f5)();
                $("#manage-roster").trigger("click");
            }
            $viewFactionsMenuButton.trigger("click");
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "faction-not-found") notie.alert({
            type: 3,
            text: "That faction could not be found. Please try again."
        });
    }
}
async function $9c7fdb096dd8e19a$export$c65f4d09e390ecce() {
    if ((0, $98xmD.globals).requestRunning) return;
    let factionUid = $(".faction-details-container").data("factionUid");
    let superstarUids = Array.from($(".add-faction-members-container .select-faction-member"), function(x) {
        return parseInt($(x).find(":selected").val());
    });
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.addFactionMembers)(factionUid, superstarUids);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $9c7fdb096dd8e19a$var$showAddFactionMembersData(data);
}
function $9c7fdb096dd8e19a$var$showAddFactionMembersData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let xpChangeHtml = "";
        if (data["xpChange"] < 0) xpChangeHtml = '<span class="red margin-left-5">- ' + data["xpChange"] * -1 + " XP" + "</span>";
        else xpChangeHtml = '<span class="green margin-left-5">+ ' + data["xpChange"] + " XP" + "</span>";
        let addedToFactionVerb = data["addedSuperstarsNames"].length < 2 ? "was" : "were";
        let html = '<span class="display-block">' + (0, $3E8Nt.commaSeparate)(data["addedSuperstarsNames"]) + " " + addedToFactionVerb + " added to the faction" + xpChangeHtml + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to view factions
        const $viewFactionsMenuButton = $("#view-factions-menu-button");
        setTimeout(function() {
            if ($viewFactionsMenuButton.length <= 0) {
                (0, $212d6f8aa99fe567$export$55237cdd4bf855f5)();
                $("#manage-roster").trigger("click");
            }
            $viewFactionsMenuButton.trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "faction-not-found") notie.alert({
            type: 3,
            text: "That faction could not be found. Please try again."
        });
        if (data["error"] === "superstar-not-found") notie.alert({
            type: 3,
            text: "One of the superstars selected could not be found. Please try again."
        });
        if (data["error"] === "already-in-faction") notie.alert({
            type: 3,
            text: data["errorSuperstarName"] + " is already in another faction."
        });
        if (data["error"] === "already-member-of-faction") notie.alert({
            type: 3,
            text: data["errorSuperstarName"] + " is already part of this faction."
        });
        if (data["error"] === "maximum-superstars") notie.alert({
            type: 3,
            text: `You cannot have more than ${(0, $3E8Nt.gameLimits).maxFactionSuperstars} members in a faction.`
        });
    }
}
async function $9c7fdb096dd8e19a$export$1dc83bfa1359e058() {
    if ((0, $98xmD.globals).requestRunning) return;
    let factionUid = $(".faction-details-container").data("factionUid");
    let superstarUids = Array.from($(".remove-faction-members-container .select-faction-member"), function(x) {
        return parseInt($(x).find(":selected").val());
    });
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.removeFactionMembers)(factionUid, superstarUids);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $9c7fdb096dd8e19a$var$showRemoveFactionMembersData(data);
}
function $9c7fdb096dd8e19a$var$showRemoveFactionMembersData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let xpChangeHtml = "";
        if (data["xpChange"] < 0) xpChangeHtml = '<span class="red margin-left-5">- ' + data["xpChange"] * -1 + " XP" + "</span>";
        else xpChangeHtml = '<span class="green margin-left-5">+ ' + data["xpChange"] + " XP" + "</span>";
        let removedFromFactionVerb = data["removedSuperstarsNames"].length < 2 ? "was" : "were";
        let html = '<span class="display-block">' + (0, $3E8Nt.commaSeparate)(data["removedSuperstarsNames"]) + " " + removedFromFactionVerb + " removed from the faction" + xpChangeHtml + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to view factions
        const $viewFactionsMenuButton = $("#view-factions-menu-button");
        setTimeout(function() {
            if ($viewFactionsMenuButton.length <= 0) {
                (0, $212d6f8aa99fe567$export$55237cdd4bf855f5)();
                $("#manage-roster").trigger("click");
            }
            $viewFactionsMenuButton.trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "faction-not-found") notie.alert({
            type: 3,
            text: "That faction could not be found. Please try again."
        });
        if (data["error"] === "superstar-not-found") notie.alert({
            type: 3,
            text: "One of the superstars selected could not be found. Please try again."
        });
        if (data["error"] === "not-member-of-faction") notie.alert({
            type: 3,
            text: data["errorSuperstarName"] + " is not part of this faction."
        });
        if (data["error"] === "minimum-superstars") notie.alert({
            type: 3,
            text: "You cannot have less than 2 members in a faction."
        });
    }
}
async function $9c7fdb096dd8e19a$export$2b4e8c92e9a9222c() {
    if ((0, $98xmD.globals).requestRunning) return;
    let factionUid = $(".faction-details-container").data("factionUid");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.removeFactionLeaderRequest)(factionUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $9c7fdb096dd8e19a$var$showRemoveFactionLeaderData(data);
}
function $9c7fdb096dd8e19a$var$showRemoveFactionLeaderData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let xpChangeHtml = "";
        if (data["xpChange"] < 0) xpChangeHtml = '<span class="red margin-left-5">- ' + data["xpChange"] * -1 + " XP" + "</span>";
        else xpChangeHtml = '<span class="green margin-left-5">+ ' + data["xpChange"] + " XP" + "</span>";
        let html = '<span class="display-block">Leader of ' + data["factionName"] + " was removed" + xpChangeHtml + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Go back to view factions
        const $viewFactionsMenuButton = $("#view-factions-menu-button");
        setTimeout(function() {
            if ($viewFactionsMenuButton.length <= 0) {
                (0, $212d6f8aa99fe567$export$55237cdd4bf855f5)();
                $("#manage-roster").trigger("click");
            }
            $viewFactionsMenuButton.trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "faction-not-found") notie.alert({
            type: 3,
            text: "That faction could not be found. Please try again."
        });
        if (data["error"] === "leader-not-present") notie.alert({
            type: 3,
            text: "That faction does not have a leader."
        });
    }
}
async function $9c7fdb096dd8e19a$export$732fd4d36a9453b0() {
    if ((0, $98xmD.globals).requestRunning) return;
    let factionUid = $(".faction-details-container").data("factionUid");
    let leaderSuperstarUid = parseInt($(".set-faction-leader-container .select-faction-leader").find(":selected").val());
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $6PzHO.setFactionLeader)(factionUid, leaderSuperstarUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $9c7fdb096dd8e19a$var$showSetFactionLeaderData(data);
}
function $9c7fdb096dd8e19a$var$showSetFactionLeaderData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let xpChangeHtml = "";
        if (data["xpChange"] < 0) xpChangeHtml = '<span class="red margin-left-5">- ' + data["xpChange"] * -1 + " XP" + "</span>";
        else xpChangeHtml = '<span class="green margin-left-5">+ ' + data["xpChange"] + " XP" + "</span>";
        let html = '<span class="display-block">' + data["leaderSuperstarName"] + " was set as the leader" + xpChangeHtml + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Go back to view factions
        const $viewFactionsMenuButton = $("#view-factions-menu-button");
        setTimeout(function() {
            if ($viewFactionsMenuButton.length <= 0) {
                (0, $212d6f8aa99fe567$export$55237cdd4bf855f5)();
                $("#manage-roster").trigger("click");
            }
            $viewFactionsMenuButton.trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "faction-not-found") notie.alert({
            type: 3,
            text: "That faction could not be found. Please try again."
        });
        if (data["error"] === "leader-superstar-not-found") notie.alert({
            type: 3,
            text: "That superstar could not be found. Please try again."
        });
        if (data["error"] === "leader-superstar-not-present") notie.alert({
            type: 3,
            text: "The leader needs to be a member of the faction."
        });
    }
}
function $9c7fdb096dd8e19a$export$25d3e1524ca4231d(parent) {
    let selectFactionMemberDivs = parent.find(".select-faction-member");
    let selectFactionLeaderDiv = parent.find(".select-faction-leader");
    let selectedValue = selectFactionLeaderDiv.val();
    // Reset
    selectFactionLeaderDiv.html("");
    selectFactionLeaderDiv.append($("<option selected value>None</option>"));
    // Add faction members selected as options, don't add duplicates
    selectFactionMemberDivs.each(function(i, e) {
        let selectedOption = $(e).find("option:selected");
        if (selectFactionLeaderDiv.find('option[value="' + selectedOption.val() + '"]').length <= 0) selectFactionLeaderDiv.append($("<option />").val(selectedOption.val()).text(selectedOption.text()));
    });
    // If previously selected value found, select it, otherwise select none
    if (selectFactionLeaderDiv.find('option[value="' + selectedValue + '"]').length > 0) selectFactionLeaderDiv.val(selectedValue);
    else selectFactionLeaderDiv.val("");
}



var $cXLSF = parcelRequire("cXLSF");

var $8A6FL = parcelRequire("8A6FL");


var $4ptHI = parcelRequire("4ptHI");


var $6PzHO = parcelRequire("6PzHO");

var $1Dp0h = parcelRequire("1Dp0h");

var $ycsyu = parcelRequire("ycsyu");

var $98xmD = parcelRequire("98xmD");

var $3E8Nt = parcelRequire("3E8Nt");

var $1JSre = parcelRequire("1JSre");
function $1145891c855e0e78$export$18150d6b84dd892a(data) {
    const $eventPrestigeEffects = $(".event-prestige-effects");
    const $eventPrestigeEffectsContainer = $(".event-prestige-effects-container");
    const $eventPrestigeEffectsMoreIcon = $(".event-prestige-effects-more i");
    $(".event-card-weekly-show").hide();
    // Add prestige icon
    let prestigeIcon = $1145891c855e0e78$var$getEventPrestigeIcon(data["prestige"]);
    $("#event-card-name-details").append(prestigeIcon);
    // Add streaks, match effects and match contracts texts
    let eventEffectsContainer = $('<div class="light-container font-bold medium-grey"></div>');
    if (data["streaks"].length > 0) {
        const eventStreaksContainer = $1145891c855e0e78$var$getEventEffectsStreaksHtml(data["streaks"]);
        eventEffectsContainer.append(eventStreaksContainer);
    }
    if (data["matchEffects"].length > 0) {
        const eventMatchEffectsContainer = $1145891c855e0e78$var$getEventEffectsMatchEffectsHtml(data["matchEffects"]);
        eventEffectsContainer.append(eventMatchEffectsContainer);
    }
    if (data["matchContracts"].length > 0) {
        const eventMatchContractsContainer = $1145891c855e0e78$var$getEventEffectsMatchContractsHtml(data["matchContracts"]);
        eventEffectsContainer.append(eventMatchContractsContainer);
    }
    // Add event effects header
    let prestigeEffects = data["streaks"].concat(data["matchEffects"], data["matchContracts"]);
    if (prestigeEffects.length > 0) $(".event-prestige-effects-number").text(prestigeEffects.length);
    else $(".event-prestige-effects-number").text("No");
    if (prestigeEffects.length === 1) $(".event-prestige-effects-text").text("Event Effect");
    else $(".event-prestige-effects-text").text("Event Effects");
    // Show 'expand event effects' icon
    $eventPrestigeEffectsContainer.html("");
    if (prestigeEffects.length < 1) {
        $eventPrestigeEffectsMoreIcon.hide();
        $(".event-prestige-effects-more").removeClass("cursor-pointer");
        $(".event-prestige-effects").addClass("grey").removeClass("medium-dark-grey cursor-pointer");
    } else {
        $eventPrestigeEffectsMoreIcon.removeClass("fa-angle-up").addClass("fa-angle-down");
        $eventPrestigeEffectsMoreIcon.show();
        $(".event-prestige-effects-more").addClass("cursor-pointer");
        $eventPrestigeEffects.addClass("medium-dark-grey cursor-pointer").removeClass("grey");
        $eventPrestigeEffectsContainer.append(eventEffectsContainer);
    }
    $eventPrestigeEffects.show();
    $eventPrestigeEffectsContainer.hide();
    // Show hype help
    $(".event-hype").addClass("help-text").attr("title", "Event Hype affects the viewers/buys for the event.");
    // Show prestige help
    let eventPrestigeHelpText;
    if ((0, $98xmD.globalUser).paid) eventPrestigeHelpText = "Event Prestige affects an event's Hype, its minimum and maximum matches and is linked to Event Effects. Event Prestige changes based on the Event's Rating.";
    else eventPrestigeHelpText = "Event Prestige affects an event's Hype, its minimum and maximum matches and is linked to Event Effects. Event Prestige can only change in JoW Paid.";
    $(".current-event-prestige-icon").addClass("help-text").attr("title", eventPrestigeHelpText);
    // Event effects help
    let eventEffectsHelpText;
    if ((0, $98xmD.globalUser).paid) eventEffectsHelpText = "Event Effects include Streaks, Gimmick Match Effects and Match Contracts. Streaks can only be used on Gold Prestige Events.";
    else eventEffectsHelpText = "Event Effects include Streaks, Gimmick Match Effects and Match Contracts. Streaks and Gimmick Match Effects can only be used in JoW Paid.";
    $eventPrestigeEffects.addClass("help-text").attr("title", eventEffectsHelpText);
    $(".event-match-bonuses").addClass("help-text").attr("title", "Gimmick Match Effects add a bonus or a penalty to Gimmick Matches held at this Event.");
    $(".event-match-contracts").addClass("help-text").attr("title", "Match Contracts add a bonus if the contract holder's is in a Title Match at this Event and fan disappointment if not. The bonus depends on the Prestige of the current Event.");
    $(".event-streaks").addClass("help-text").attr("title", "Streaks add a bonus to the defending Superstar's Match at this Event.");
}
function $1145891c855e0e78$var$getEventPrestigeIcon(prestige) {
    let prestigeIcon;
    switch(prestige){
        case "C":
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-7 font-0p925em current-event-prestige-icon bronze"></i>';
            break;
        case "B":
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-7 font-0p925em current-event-prestige-icon silver"></i>';
            break;
        case "A":
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-7 font-0p925em current-event-prestige-icon gold-light"></i>';
            break;
    }
    return prestigeIcon;
}
function $1145891c855e0e78$var$getEventEffectsStreaksHtml(streaksData) {
    // Create container
    let eventStreaksContainer = $('<div class="bonuses-container"></div>');
    // Add header
    eventStreaksContainer.append('<div class="margin-bottom-2 medium-dark-grey event-streaks">Streaks</div>');
    // Add html for each streak
    streaksData.forEach(function(streakData) {
        if (streakData["length"] >= 2) {
            const streakHtml = $1145891c855e0e78$var$getEventEffectsStreakHtml(streakData);
            eventStreaksContainer.append(streakHtml);
        }
    });
    // Add streak potentials
    const streakPotentials = streaksData.reduce(function(filtered, streak) {
        if (streak["length"] < 2) filtered.push(streak["holder"]);
        return filtered;
    }, []);
    if (streakPotentials.length > 0) {
        const streakText = '<span class="light-grey">Streak Potential: {0}</span>'.format(streakPotentials.join(", "));
        const streakHtml = "<div>" + streakText + "</div>";
        eventStreaksContainer.append(streakHtml);
    }
    return eventStreaksContainer;
}
function $1145891c855e0e78$var$getEventEffectsStreakHtml(streakData) {
    // Get color depending on streak's length
    let streakClass = "bronze";
    if (streakData["length"] < 5) streakClass = "bronze";
    else if (streakData["length"] < 10) streakClass = "gold-light";
    else if (streakData["length"] < 20) streakClass = "faded-red";
    else streakClass = "obsidian";
    // Get streak text
    let streakText;
    if (streakData["length"] >= 10) streakText = '{0} <span class="{1} margin-left-3">{2}-0</span>'.format(streakData["holder"], streakClass, streakData["length"]);
    else {
        const winText = streakData["length"] > 1 ? "Wins" : "Win";
        streakText = '{0} <span class="{1} margin-left-3">{2} {3}</span>'.format(streakData["holder"], streakClass, streakData["length"], winText);
    }
    return "<div>" + streakText + "</div>";
}
function $1145891c855e0e78$var$getEventEffectsMatchEffectsHtml(matchEffectsData) {
    // Create container
    const eventMatchEffectsContainer = $('<div class="bonuses-container"></div>');
    // Add header
    eventMatchEffectsContainer.append('<div class="margin-bottom-2 medium-dark-grey event-match-bonuses">Gimmick Match Effects</div>');
    // Add html for each match effect
    matchEffectsData.forEach(function(matchEffectData) {
        if (matchEffectData["bonus"]) {
            const matchBonusHtml = $1145891c855e0e78$var$getEventEffectsMatchEffectHtml(matchEffectData);
            eventMatchEffectsContainer.append(matchBonusHtml);
        }
    });
    // Add positive match effect potentials
    const positiveMatchEffectPotentials = matchEffectsData.reduce(function(filtered, matchBonus) {
        if (!matchBonus["bonus"] && matchBonus["points"] > 0) filtered.push(matchBonus["gimmickMatch"]);
        return filtered;
    }, []);
    if (positiveMatchEffectPotentials.length > 0) {
        const matchBonusText = '<span class="light-grey">+ Effect Potential: {0}</span>'.format(positiveMatchEffectPotentials.join(", "));
        const matchBonusHtml = "<div>" + matchBonusText + "</div>";
        eventMatchEffectsContainer.append(matchBonusHtml);
    }
    // Add negative match effect potentials
    const negativeMatchEffectPotentials = matchEffectsData.reduce(function(filtered, matchBonus) {
        if (!matchBonus["bonus"] && matchBonus["points"] < 0) filtered.push(matchBonus["gimmickMatch"]);
        return filtered;
    }, []);
    if (negativeMatchEffectPotentials.length > 0) {
        const matchBonusText = '<span class="light-grey">- Effect Potential: {0}</span>'.format(negativeMatchEffectPotentials.join(", "));
        const matchBonusHtml = "<div>" + matchBonusText + "</div>";
        eventMatchEffectsContainer.append(matchBonusHtml);
    }
    return eventMatchEffectsContainer;
}
function $1145891c855e0e78$var$getEventEffectsMatchEffectHtml(matchEffectData) {
    // Get color depending on match effect's bonus
    let matchBonusClass = "bronze";
    if (matchEffectData["bonus"] < 0) matchBonusClass = "puke-green";
    else matchBonusClass = "gold";
    // Format bonus text
    let bonusText;
    if (matchEffectData["bonus"] > 0) bonusText = "+ " + matchEffectData["bonus"];
    else bonusText = "- " + matchEffectData["bonus"] * -1;
    // Get match effect text
    const matchEffectText = '{0} <span class="{1} margin-left-3">{2} HYPE</span>'.format(matchEffectData["gimmickMatch"], matchBonusClass, bonusText);
    return "<div>" + matchEffectText + "</div>";
}
function $1145891c855e0e78$var$getEventEffectsMatchContractsHtml(matchContractsData) {
    // Create container
    const eventMatchContractsContainer = $('<div class="bonuses-container"></div>');
    // Add header
    eventMatchContractsContainer.append('<div class="margin-bottom-2 medium-dark-grey event-match-contracts">Match Contracts</div>');
    // Add html for each match contract
    matchContractsData.forEach(function(matchContractData) {
        const matchContractHtml = $1145891c855e0e78$var$getEventEffectsMatchContractHtml(matchContractData);
        eventMatchContractsContainer.append(matchContractHtml);
    });
    return eventMatchContractsContainer;
}
function $1145891c855e0e78$var$getEventEffectsMatchContractHtml(matchContractData) {
    // Get color depending on match contract's bonus
    let matchContractClass;
    if (matchContractData["bonus"] < 25) matchContractClass = "bronze";
    else if (matchContractData["bonus"] < 50) matchContractClass = "gold-light";
    else if (matchContractData["bonus"] < 70) matchContractClass = "faded-red";
    else matchContractClass = "obsidian";
    // Get match contract text
    const matchContractText = '{0}<span class="margin-left-3 light-grey"> {1}</span><span class="{2} margin-left-3"> + {3} HYPE</span>'.format(matchContractData["holder"], matchContractData["name"], matchContractClass, matchContractData["bonus"]);
    return "<div>" + matchContractText + "</div>";
}
function $1145891c855e0e78$export$a23fd95a66c9ff1d(matchesAndSegments) {
    if (matchesAndSegments.length > 0) {
        $("#matches").html("");
        matchesAndSegments.forEach(function(matchOrSegment, index) {
            // Add segment to card
            let matchOrSegmentHtml;
            if (matchOrSegment["segmentType"] === "segment") matchOrSegmentHtml = $1145891c855e0e78$export$e0309c2afefc2b87(matchOrSegment, index);
            else matchOrSegmentHtml = $1145891c855e0e78$export$1b746ece54537942(matchOrSegment, index);
            $("#matches").append(matchOrSegmentHtml);
        });
    } else $("#matches").html('<span class="font-bold display-block light-grey margin-bottom-10 margin-top-10 event-match-empty">No matches or segments booked</span>');
    // Add match limits
    let matchLimitsHtml = $1145891c855e0e78$export$30265932b480a0df();
    $("#match-limits").html(matchLimitsHtml);
}
function $1145891c855e0e78$export$1b746ece54537942(match, index) {
    const $matches = $("#matches");
    // Show empty element if match is hidden
    if (match["hidden"]) return '<span class="event-match font-bold display-block hidden" tabindex="0"><div class="event-match-column-left">???</div><div class="event-match-column-right"></div><div class="clear"></div></span>';
    // Main event indication
    let mainEventHtml = "";
    if ($matches.text() === "No matches or segments booked" || index === 0) {
        if ($matches.text() === "No matches or segments booked") $matches.text("");
        mainEventHtml = '<span class="main-event-label light-grey margin-bottom-3 display-block">Main Event</span>';
    }
    // Get gimmick info
    const matchGimmickHtml = $1145891c855e0e78$var$getMatchGimmickHtml(match);
    // Get tournament info
    const matchTournamentHtml = $1145891c855e0e78$var$getMatchTournamentHtml(match);
    // Get feud and feud buttons html
    const [feudsHtml, addFeudMenuHtml, removeFeudMenuHtml] = $1145891c855e0e78$var$getMatchFeudsHtml(match);
    // Get participants html, check if managers present
    const [matchParticipantsHtml, managersPresent] = $1145891c855e0e78$var$getMatchParticipantsHtml(match);
    // Get match championships html
    const [championshipHtml, removeChampionshipMenuHtml, selectChampionshipMenuHtml] = $1145891c855e0e78$var$getMatchChampionshipsHtml(match);
    // Get starting html (classes, data attributes etc)
    let played = match["winnerName"] ? " played" : "";
    let tournamentMatch = match["tournamentRound"] ? " tournament-match" : "";
    let matchSpanStartHtml = '<span class="event-match font-bold display-block ' + tournamentMatch + played + '" data-uid="' + match["uid"] + '" data-matchtype="' + match["type"] + '" tabindex=0>';
    // If lots of participants, show help text with list of match's participants
    if (match["participants"].length > 10) {
        let participantNames = Array.from(match["participants"], function(s) {
            return s["name"];
        });
        let titleNames = participantNames.join(", ").replace(/"/g, "&quot;");
        matchSpanStartHtml = '<span class="event-match font-bold display-block help-text ' + tournamentMatch + played + '" ' + 'title="' + titleNames + '" data-uid="' + match["uid"] + '" data-matchtype="' + match["type"] + '" tabindex="0">';
    }
    // Check to disable match buttons
    let disabledClass = "";
    if ((0, $98xmD.globals).game.annualTournamentRunning) disabledClass = " disabled";
    // Get match buttons
    const [deleteMatchMenuHtml, addGimmickMatchMenuHtml, addMatchManagerMenuHtml, removeMatchManagerMenuHtml] = $1145891c855e0e78$var$getMatchButtonsHtml(match, managersPresent);
    // Get remaining html
    return matchSpanStartHtml + '<div class="event-match-column-left">' + mainEventHtml + championshipHtml + matchParticipantsHtml + matchGimmickHtml + matchTournamentHtml + feudsHtml + "</div>" + '<div class="event-match-column-right">' + '<nav class="nav event-card-match-edit-menu">' + "<ul>" + '<li class="button-dropdown' + disabledClass + '">' + '<div class="dropdown-toggle">Edit <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' + '<ul class="dropdown-menu">' + deleteMatchMenuHtml + addFeudMenuHtml + removeFeudMenuHtml + addGimmickMatchMenuHtml + selectChampionshipMenuHtml + removeChampionshipMenuHtml + addMatchManagerMenuHtml + removeMatchManagerMenuHtml + "</ul>" + "</li>" + "</ul>" + "</nav>" + "</div>" + '<div class="clear"></div>' + "</span>";
}
function $1145891c855e0e78$var$getMatchGimmickHtml(match) {
    let matchGimmickHtml = "";
    if (match["gimmick"]) {
        let matchGimmickText = "";
        // Show generated objects
        if (match["generated"]["objectToClaim"] || match["generated"]["location"]) {
            if (match["generated"]["objectToClaim"]) matchGimmickText = match["generated"]["objectToClaim"] + " on a Pole";
            else if (match["generated"]["location"]) matchGimmickText = match["generated"]["location"] + " Brawl";
        } else matchGimmickText = match["gimmick"];
        let refereeText = "";
        if (match["refereeName"]) refereeText = " w/ " + match["refereeName"];
        matchGimmickHtml = '<span class="display-block grey margin-top-2">' + matchGimmickText + " Match" + refereeText + "</span>";
    }
    return matchGimmickHtml;
}
function $1145891c855e0e78$var$getMatchTournamentHtml(match) {
    let matchTournamentHtml = "";
    if (match["tournamentName"]) {
        let group = "";
        if (match["tournamentGroup"]) group = " - Group {0}".format(match["tournamentGroup"]);
        matchTournamentHtml = '<span class="display-block grey margin-top-2">' + match["tournamentName"] + '<span class="light-grey margin-left-5">' + match["tournamentRoundName"] + group + "</span>" + "</span>";
    }
    return matchTournamentHtml;
}
function $1145891c855e0e78$var$getMatchFeudsHtml(match) {
    let matchFeudsHtml = "";
    let addFeudMenuHtml = "";
    let removeFeudMenuHtml = "";
    // Add html for each feud
    if (match["feuds"] && match["feuds"].length > 0) {
        let feudsHtml = "";
        match["feuds"].forEach(function(feudData) {
            const getMatchFeudHtmlData = $1145891c855e0e78$var$getMatchFeudHtml(feudData, match);
            feudsHtml += getMatchFeudHtmlData.feudHtml;
            removeFeudMenuHtml = getMatchFeudHtmlData.removeFeudMenuHtml;
        });
        matchFeudsHtml += '<span class="display-block margin-top-2 line-height-24px">' + feudsHtml + "</span>";
    } else // Add 'add feud' button if no match feuds present
    if (match["participants"].length === 2 && !match["winnerName"]) addFeudMenuHtml = '<li class="event-card-match-add-feud-button"><span>Add Feud</span></li>';
    return [
        matchFeudsHtml,
        addFeudMenuHtml,
        removeFeudMenuHtml
    ];
}
function $1145891c855e0e78$var$getMatchFeudHtml(feudData, match) {
    let removeFeudMenuHtml = "";
    // Add feud name
    let feudName = "";
    if (feudData["participants"]) {
        let feudParticipants = feudData["participants"].join(" vs ").replace(/"/g, "&quot;");
        feudName = '<span class="help-text" title="' + feudParticipants + '">' + feudData["name"] + "</span>";
    } else feudName = "<span>" + feudData["name"] + "</span>";
    let blowoffButton = "";
    let feudHype = "";
    // Add remove feud button if feud not started and 1 feud in match
    if (!feudData["started"] && match["feuds"].length === 1) {
        if (!match["winnerName"]) removeFeudMenuHtml = '<li class="event-card-match-remove-feud-button"><span>Remove Feud</span></li>';
    } else {
        // Add 'add blowoff' button if feud started
        if (!match["winnerName"] && feudData["started"]) blowoffButton = '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 add-blowoff-to-feud" data-uid="' + match["uid"] + '" data-match-type="' + match["type"] + '" ' + 'data-feud-uid="' + feudData["uid"] + '">Add Blowoff</span>';
        // Add 'remove blowoff' button if running blowoff
        if (feudData["runBlowoff"] && !match["winnerName"]) {
            feudName += " <span>Blowoff</span>";
            blowoffButton = '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 remove-blowoff-from-feud" data-uid="' + match["uid"] + '" data-match-type="' + match["type"] + '" ' + 'data-feud-uid="' + feudData["uid"] + '">Remove Blowoff</span>';
        }
        // Add feud hype
        feudHype = '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + Math.round(feudData["hype"]);
    }
    // Get feud html
    const feudHtml = '<span class="faded-red-light match-feud-name display-block">' + feudName + feudHype + blowoffButton + "</span>";
    return {
        feudHtml: feudHtml,
        removeFeudMenuHtml: removeFeudMenuHtml
    };
}
function $1145891c855e0e78$var$getMatchParticipantsHtml(match) {
    let participantsHtml;
    let participantsHtmlsArray = [];
    let managersPresent = false;
    // For empty participants (tournaments/random opponent)
    if (match["participants"].length === 0) match["participants"] = [
        {
            "name": "???"
        },
        {
            "name": "???"
        }
    ];
    if (match["participants"].length === 1) match["participants"].push({
        "name": "???"
    });
    // Get html for each participant
    match["participants"].forEach(function(participant) {
        const getMatchParticipantHtmlData = $1145891c855e0e78$var$getMatchParticipantHtml(participant, match);
        const participantHtml = getMatchParticipantHtmlData.participantHtml;
        if (getMatchParticipantHtmlData.managersPresent) managersPresent = true;
        participantsHtmlsArray.push('<span class="event-card-match-participant">' + participantHtml + "</span>");
    });
    // If lots of participants, condense participants htmls
    if (match["participants"].length > 10) {
        // If match winner, move to start of array
        participantsHtmlsArray.sort(function(x, y) {
            return x.includes(match["winnerName"]) ? -1 : y.includes(match["winnerName"]) ? 1 : 0;
        });
        // Condense participants list to top 10
        let condensedParticipants = participantsHtmlsArray.slice(0, 10);
        let othersText;
        if (match["participants"].length - 10 > 1) othersText = "others";
        else othersText = "other";
        let othersTextHtml = match["participants"].length - 10 + " " + othersText;
        if (match["winnerName"]) othersTextHtml = '<span class="event-card-match-loser">' + othersTextHtml + "</span>";
        condensedParticipants.push(othersTextHtml);
        participantsHtml = condensedParticipants.join('<span class="font-weight-normal"> vs </span>');
    } else participantsHtml = participantsHtmlsArray.join('<span class="font-weight-normal"> vs </span>');
    // Add active effect indication
    let activeEffectHtml = "";
    if (match["activeEffect"]) activeEffectHtml = '<img alt="Artifact" src="static/www/static/powerup_1_icon_small.png" class="artifact-image-small left-0 help-text margin-left-6" title="' + (0, $3E8Nt.toTitleCase)((0, $1JSre.replaceAll)(match["activeEffect"], "_", " ")) + '"/>';
    participantsHtml = '<div class="event-match-participants-container line-height-24px">' + participantsHtml + activeEffectHtml + "</div>";
    return [
        participantsHtml,
        managersPresent
    ];
}
function $1145891c855e0e78$var$getMatchParticipantHtml(participant, match) {
    let managersPresent = false;
    let participantHtml = '<span class="event-card-match-participant-name">' + participant["name"] + "</span>";
    // Add name
    if (match["winnerName"]) {
        if (participant["name"] !== match["winnerName"]) participantHtml = '<span class="event-card-match-loser event-card-match-participant-name">' + participant["name"] + "</span>";
    }
    // Add champion label
    if (participant["champion"]) participantHtml += '<span class="light-grey margin-left-3 font-15px top--1px event-card-champion-label">(c)</span>';
    // Add 'change' button for trio tag team
    if (participant["trioTagTeam"] && !match["winnerName"] && participant["trioMembers"]) {
        let teamMembers = JSON.stringify(participant["trioMembers"]).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        let teamMembersSelected = JSON.stringify(participant["trioMembersSelected"]).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        let teamName = JSON.stringify(participant["name"]).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        participantHtml += '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 margin-right-3 change-trio-tagteam-members" data-trio-members=\'' + teamMembers + "' " + "data-trio-members-selected='" + teamMembersSelected + "' " + 'data-match-uid="' + match["uid"] + "\" data-team-name='" + teamName + "'>Change</span>";
    }
    // Add 'change' button for faction tag team
    if (participant["factionTagTeam"] && !match["winnerName"] && participant["factionMembers"]) {
        let factionMembers = JSON.stringify(participant["factionMembers"]).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        let factionMembersSelected = JSON.stringify(participant["factionMembersSelected"]).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        let teamName = JSON.stringify(participant["name"]).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        participantHtml += '<span class="button retro-button event-card-button grey-button-background display-inline light-grey margin-left-5 margin-right-3 change-faction-tagteam-members" data-faction-members=\'' + factionMembers + "' " + "data-faction-members-selected='" + factionMembersSelected + "' " + 'data-match-uid="' + match["uid"] + "\" data-team-name='" + teamName + "' data-team-size=\"" + participant["factionMembersSelected"].length + '">Change</span>';
    }
    // Show alternate attires button if present
    if (match["type"] !== "tag") {
        if (participant["alternateAttires"] && !match["winnerName"]) {
            let currentAttire = String.fromCharCode(65 + participant["currentAttire"]);
            participantHtml += '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 margin-right-3 change-superstar-attire-button help-text" title="Change attire" data-uid="' + participant["uid"] + '">' + currentAttire + "</span>";
        }
    } else if (participant["members"]) {
        let attiresPresent = participant["members"].some(function(el) {
            return el["alternateAttires"];
        });
        if (attiresPresent) participant["members"].forEach(function(member) {
            let currentAttire = String.fromCharCode(65 + member["currentAttire"]);
            participantHtml += '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 margin-right-3 change-superstar-attire-button help-text" title="Change attire for ' + member["name"] + '" data-uid="' + member["uid"] + '">' + currentAttire + "</span>";
        });
    }
    // Add managers
    let managersHtml = $1145891c855e0e78$export$b9b438f3e67a1018(participant);
    participantHtml += managersHtml;
    if (managersHtml) managersPresent = true;
    return {
        participantHtml: participantHtml,
        managersPresent: managersPresent
    };
}
function $1145891c855e0e78$var$getMatchButtonsHtml(match, managersPresent) {
    // Delete match button
    let deleteMatchMenuHtml = "";
    if (!match["winnerName"]) deleteMatchMenuHtml = '<li class="event-card-match-delete-button"><span>Delete</span></li>';
    // Add gimmick match button
    let addGimmickMatchMenuHtml = "";
    if (!match["gimmick"] && !match["winnerName"]) addGimmickMatchMenuHtml = '<li class="event-card-match-add-gimmick-button"><span>Add Gimmick</span></li>';
    // Add manager button
    let addMatchManagerMenuHtml = "";
    if (!match["winnerName"] && (0, $98xmD.globalUser).paid) addMatchManagerMenuHtml = '<li class="event-card-match-add-manager-button"><span>Add Manager</span></li>';
    // Remove manager button if managers present
    let removeMatchManagerMenuHtml = "";
    if (managersPresent && !match["winnerName"] && (0, $98xmD.globalUser).paid) removeMatchManagerMenuHtml = '<li class="event-card-match-remove-manager-button"><span>Remove Man.</span></li>';
    return [
        deleteMatchMenuHtml,
        addGimmickMatchMenuHtml,
        addMatchManagerMenuHtml,
        removeMatchManagerMenuHtml
    ];
}
function $1145891c855e0e78$var$getMatchChampionshipsHtml(match) {
    let championshipHtml = "";
    let removeChampionshipMenuHtml = "";
    let selectChampionshipMenuHtml = "";
    if (match["championships"].length > 0) {
        // Name
        let championshipText = (0, $1JSre.getChampionshipsDisplayName)(match["championships"], null, true);
        if (!match["winnerName"]) removeChampionshipMenuHtml = '<li class="event-card-match-remove-championship-button"><span>Remove Title</span></li>';
        championshipHtml = '<span class="margin-right-5 display-block margin-bottom-2 gold match-championship-name">' + championshipText + "</span>";
    }
    if (match["championshipsAvailable"] && !match["winnerName"]) selectChampionshipMenuHtml = '<li class="event-card-match-select-championships-button"><span>Select Titles</span></li>';
    return [
        championshipHtml,
        removeChampionshipMenuHtml,
        selectChampionshipMenuHtml
    ];
}
function $1145891c855e0e78$export$b9b438f3e67a1018(participant) {
    let managersHtml = "";
    let managerNames = [];
    if (participant["members"]) // Get manager names from team members
    managerNames = participant["members"].filter(function(member) {
        if (member["managerName"]) return member;
    }).map(function(member) {
        return member["managerName"];
    });
    else // Get manager names from superstar
    if (participant["managerName"]) managerNames.push(participant["managerName"]);
    if (managerNames.length > 0) managersHtml = '<span class="margin-left-5 grey"><span>w/</span> {0}</span>'.format((0, $3E8Nt.commaSeparate)(managerNames, " <span>and</span> "));
    return managersHtml;
}
function $1145891c855e0e78$export$e0309c2afefc2b87(segment, index) {
    if (typeof index === "undefined") index = 1;
    // Show empty element if segment is hidden
    if (segment["hidden"]) return '<span class="event-match font-bold display-block hidden" tabindex="0"><div class="event-match-column-left">???</div><div class="event-match-column-right"></div><div class="clear"></div></span>';
    let mainEventLabel = "";
    if (index === 0) {
        // If first match, reset empty card text, add main event label
        mainEventLabel = '<span class="main-event-label light-grey margin-bottom-3 display-block">Main Event</span>';
        $("#matches").text("");
    }
    let participantsHtml = "";
    if (segment["participants"].length > 0) {
        let participantsHtmls = [];
        segment["participants"].forEach(function(participant) {
            let participantHtml = participant["name"];
            if (segment["participantsType"] !== "tag") // Show alternate attires button if present
            {
                if (participant["alternateAttires"]) {
                    let currentAttire = String.fromCharCode(65 + participant["currentAttire"]);
                    participantHtml += '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 margin-right-3 change-superstar-attire-button help-text" title="Change attire" data-uid="' + participant["uid"] + '">' + currentAttire + "</span>";
                }
            } else if (participant["members"]) {
                // Show alternate attires buttons for each member of team if any of them have alternate attires present
                let attiresPresent = participant["members"].every(function(el) {
                    return el["alternateAttires"];
                });
                if (attiresPresent) participant["members"].forEach(function(member) {
                    let currentAttire = String.fromCharCode(65 + member["currentAttire"]);
                    participantHtml += '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 margin-right-3 change-superstar-attire-button help-text" title="Change attire for ' + member["name"] + '" data-uid="' + member["uid"] + '">' + currentAttire + "</span>";
                });
            }
            // Add managers
            let managersHtml = $1145891c855e0e78$export$b9b438f3e67a1018(participant);
            participantHtml += managersHtml;
            participantsHtmls.push(participantHtml);
        });
        let participantsDetails = (0, $3E8Nt.commaSeparate)(participantsHtmls, '<span class="font-weight-normal">&</span>');
        participantsHtml = '<span class="display-block margin-top-2 line-height-24px">' + participantsDetails + "</span>";
    }
    // Add Feud Item
    let feudsHtml = "";
    let addFeudMenuHtml = "";
    let removeFeudMenuHtml = "";
    if (segment["feuds"].length > 0) {
        // Add all feuds
        let feudHtml = "";
        segment["feuds"].forEach(function(feud) {
            let feudName = "";
            if (feud["participants"]) {
                let feudParticipants = feud["participants"].join(" vs ");
                feudName = '<span class="help-text" title="' + feudParticipants.replace(/"/g, "&quot;") + '">' + feud["name"] + "</span>";
            } else feudName = "<span>" + feud["name"] + "</span>";
            let feudHype = "";
            // Add remove feud button if feud not started and 1 feud in segment
            if (!feud["started"] && segment["feuds"].length === 1) // Add remove feud button if feud not started
            {
                if (!segment["played"]) removeFeudMenuHtml = '<li class="event-card-match-remove-feud-button"><span>Remove Feud</span></li>';
            } else feudHype = '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + Math.round(feud["hype"]);
            feudHtml += '<span class="faded-red-light match-feud-name display-block">' + feudName + feudHype + "</span>";
        });
        feudsHtml += '<span class="display-block margin-top-2 line-height-24px">' + feudHtml + "</span>";
    } else // Add feud button
    if (segment["participants"].length === 2 && !segment["played"]) addFeudMenuHtml = '<li class="event-card-match-add-feud-button"><span>Add Feud</span></li>';
    let segmentText = '<span class="display-block faded-purple">' + segment["name"] + "</span>" + participantsHtml;
    // Producer name
    let producerHtml = "";
    if (segment["producerName"]) producerHtml = '<span class="display-block grey margin-top-2 help-text" title="Producer assigned to this segment.">' + segment["producerName"] + "</span>";
    // Add/remove producer button
    let addSegmentProducerHtml = "";
    let removeSegmentProducerHtml = "";
    if (!segment["played"] && (0, $98xmD.globalUser).paid) {
        if (segment["producerName"]) removeSegmentProducerHtml = '<li class="event-card-segment-remove-producer-button"><span>Remove Producer</span></li>';
        else addSegmentProducerHtml = '<li class="event-card-segment-add-producer-button"><span>Add Producer</span></li>';
    }
    let deleteSegmentMenuHtml = "";
    if (!segment["played"]) deleteSegmentMenuHtml = '<li class="event-card-segment-delete-button"><span>Delete</span></li>';
    let disabledClass = "";
    if ((0, $98xmD.globals).game.annualTournamentRunning) disabledClass = " disabled";
    let played = segment["played"] ? " played" : "";
    return '<span class="event-match segment font-bold display-block' + played + '" data-uid="' + segment["uid"] + '" data-matchtype="' + segment["participantsType"] + '" data-is-segment="true" tabindex="0">' + '<div class="event-match-column-left">' + mainEventLabel + segmentText + feudsHtml + producerHtml + "</div>" + '<div class="event-match-column-right">' + '<nav class="nav event-card-match-edit-menu">' + "<ul>" + '<li class="button-dropdown' + disabledClass + '">' + '<div class="dropdown-toggle">Edit <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' + '<ul class="dropdown-menu">' + deleteSegmentMenuHtml + addFeudMenuHtml + removeFeudMenuHtml + addSegmentProducerHtml + removeSegmentProducerHtml + "</ul>" + "</li>" + "</ul>" + "</nav>" + "</div>" + '<div class="clear"></div>' + "</span>";
}
function $1145891c855e0e78$export$30265932b480a0df() {
    const numberOfMatches = $("#matches").find(".event-match").length;
    const maximumHelpText = "Maximum matches/segments are determined by the Prestige of the upcoming Event and the level of your Production Facility.";
    const minimumHelpText = "Minimum matches/segments are determined by the Prestige of the upcoming Event and the number of available Superstars.";
    const minimumText = "{0}".format((0, $98xmD.globals).game.minimumMatchesAndSegments);
    const minimumHtml = numberOfMatches < (0, $98xmD.globals).game.minimumMatchesAndSegments || numberOfMatches >= (0, $98xmD.globals).game.maximumMatchesAndSegments ? '<span class="help-text" title="{0}">Min {1}</span>'.format(minimumHelpText, minimumText) : '<span class="green help-text" title="{0}">Min</span> {1}</span>'.format(minimumHelpText, minimumText);
    const maximumText = "{0}".format((0, $98xmD.globals).game.maximumMatchesAndSegments);
    const maximumHtml = numberOfMatches < (0, $98xmD.globals).game.maximumMatchesAndSegments ? '<span class="help-text" title="{0}">Max {1}</span>'.format(maximumHelpText, maximumText) : '<span class="red help=text" title="{0}">Max</span> {1}</span>'.format(maximumHelpText, maximumText);
    const slotsLeft = (0, $98xmD.globals).game.maximumMatchesAndSegments - numberOfMatches;
    const slotsLeftHtml = '<span class="margin-left-7 medium-grey "> {0} left</span>'.format(slotsLeft);
    return '<div>{0} <span class="margin-left-7">{1}</span>{2}</div>'.format(minimumHtml, maximumHtml, slotsLeftHtml);
}
function $1145891c855e0e78$export$24e5a79523641dba(data) {
    const $eventCardName = $("#event-card-name");
    const $eventCardBrand = $(".event-card-brand");
    // Add brand name
    $eventCardName.html("<span>" + data["name"] + "</span>");
    $eventCardName.css("color", "");
    $eventCardBrand.hide();
    if (data["brandName"] && !data["weeklyShow"]) {
        // Show brand for monthly event
        if (data["brandColor"] && !(0, $98xmD.globalUser).settings.colorblindMode) $eventCardBrand.css("color", data["brandColor"]);
        else $eventCardBrand.css("color", "");
        $eventCardBrand.text(data["brandName"]).show();
    } else {
        // Color event name for weekly show
        if (data["weeklyShow"]) {
            if (data["brandColor"] && !(0, $98xmD.globalUser).settings.colorblindMode) $eventCardName.css("color", data["brandColor"]);
            else $eventCardName.css("color", "");
        }
        $eventCardBrand.hide();
    }
}




var $6RCLU = parcelRequire("6RCLU");


var $5kTkA = parcelRequire("5kTkA");

var $98xmD = parcelRequire("98xmD");

var $lCS03 = parcelRequire("lCS03");

var $jpMCP = parcelRequire("jpMCP");

var $8A6FL = parcelRequire("8A6FL");

var $1JSre = parcelRequire("1JSre");

var $3E8Nt = parcelRequire("3E8Nt");


var $1JSre = parcelRequire("1JSre");

var $98xmD = parcelRequire("98xmD");

var $lCS03 = parcelRequire("lCS03");


var $14eBR = parcelRequire("14eBR");

var $5kTkA = parcelRequire("5kTkA");

var $aynj3 = parcelRequire("aynj3");
function $af8d9de467381f29$export$2df10f3dcd3975b4(element) {
    let $tradeOfferContainer = $(".trade-offer-container");
    let competitorUid = element.find(":selected").attr("data-uid");
    let competitorName = element.val();
    // Confirm if a trade slot has been selected
    if ($tradeOfferContainer.find(".trade-offer-superstar-item[data-uid]:visible").length > 0) notie.confirm({
        text: "Are you sure? The existing trade will be reset.",
        submitCallback: function() {
            $af8d9de467381f29$export$9c4b3a546a360703($tradeOfferContainer, competitorUid, competitorName);
        }
    });
    else $af8d9de467381f29$export$9c4b3a546a360703($tradeOfferContainer, competitorUid, competitorName);
}
function $af8d9de467381f29$export$9c4b3a546a360703($tradeOfferContainer, competitorUid, competitorName) {
    const $bookingContainer = $("#booking-container");
    // Add competitor name and uid
    $tradeOfferContainer.find(".trade-offer-receiver-company").attr("data-company-uid", competitorUid);
    $tradeOfferContainer.find(".trade-offer-receiver-company-name").text(competitorName);
    // Reset trade offer
    $tradeOfferContainer.find(".trade-offer-company-container").show();
    $tradeOfferContainer.find(".trade-offer-superstar-item").each(function(i, e) {
        $(e).text("Empty");
        $(e).removeAttr("data-uid");
        $(e).addClass("light-grey");
    });
    $tradeOfferContainer.find(".trade-offer-duration-select").val("3");
    $tradeOfferContainer.find(".trade-offer-info-text").text("");
    $tradeOfferContainer.find(".trade-offer-info-container").hide();
    $tradeOfferContainer.find(".trade-offer-available-superstars-container").hide();
    $tradeOfferContainer.find(".trade-offer-search-container").hide();
    $tradeOfferContainer.find(".select-trade-superstar-button").hide();
    $tradeOfferContainer.find(".remove-trade-superstar-button").hide();
    $tradeOfferContainer.find(".trade-offer-back-button").hide();
    $tradeOfferContainer.find(".make-trade-offer-button").show();
    $tradeOfferContainer.find(".trade-offer-duration-container").show();
    $tradeOfferContainer.find(".trade-offer-competitor-select-container").show();
    $tradeOfferContainer.find(".trade-offer-help-container").show();
    $bookingContainer.hide();
    $bookingContainer.find(".participants-box-match-header, .participants-box-segment-header, .participants-box-match-container, .participants-box-callup-header, .participants-box-segment-container, #add-segment, #booking-talent-menu, #championship_info, .participants-box-draft-header, #booking-talent-container").hide();
    $bookingContainer.find(".participants-box-trade-offer-header").show();
    // Show trade offer container
    if ($tradeOfferContainer.is(":visible")) {
        (0, $1JSre.hideContent)($());
        $tradeOfferContainer.show();
    } else {
        (0, $1JSre.hideContent)($());
        $tradeOfferContainer.fadeIn("fast");
    }
}
function $af8d9de467381f29$export$b6c23020a997d324() {
    let parent = $(".trade-offer-container");
    parent.find(".trade-offer-available-superstars-container").fadeOut("fast", function() {
        parent.find(".trade-offer-company-container").fadeIn("fast");
        parent.find(".select-trade-superstar-button").hide();
        parent.find(".remove-trade-superstar-button").hide();
        parent.find(".trade-offer-back-button").hide();
        parent.find(".trade-offer-search-container").hide();
        parent.find(".make-trade-offer-button").show();
        parent.find(".trade-offer-duration-container").show();
        parent.find(".trade-offer-competitor-select-container").show();
        $("#booking-container").hide();
    });
}
function $af8d9de467381f29$export$a91e79c047f9c925() {
    let tradeContainer = $(".trade-offer-container");
    let availableSuperstarsContainer = tradeContainer.find(".trade-offer-available-superstars-container");
    let availableSuperstarsElements = tradeContainer.find(".trade-offer-available-superstar-item:not(.no-trade-search-results)");
    let searchTerm = tradeContainer.find(".trade-offer-search-input").val();
    availableSuperstarsElements.hide();
    // Run search
    if (searchTerm.length > 0) {
        let searchResults = (0, $1JSre.runFuseElementsSearch)(availableSuperstarsElements, searchTerm, [
            "textContent"
        ]);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function(e) {
                $(e).show();
            });
            $(".no-trade-search-results").hide();
        } else {
            const $noSearchResults = $(".no-trade-search-results");
            if ($noSearchResults.length > 0) $noSearchResults.show();
            else availableSuperstarsContainer.append('<div class="no-trade-search-results inner-box-item trade-offer-available-superstar-item disabled light-grey">No Results Found</div>');
        }
    } else {
        availableSuperstarsElements.show();
        $(".no-trade-search-results").hide();
    }
    availableSuperstarsContainer.scrollTop(0);
    availableSuperstarsContainer[0].scrollIntoView();
}
async function $af8d9de467381f29$export$7311d400be939671(companyUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $aynj3.getTradeAvailableSuperstars)(companyUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $af8d9de467381f29$var$showTradeSuperstarsSelectPage(data);
}
function $af8d9de467381f29$var$showTradeSuperstarsSelectPage(data) {
    let html = "";
    data["availableSuperstars"].forEach(function(availableSuperstar) {
        html += $af8d9de467381f29$var$getAvailableTradeSuperstarHtml(availableSuperstar);
    });
    let $tradeOfferContainer = $(".trade-offer-container");
    $tradeOfferContainer.find(".trade-offer-available-superstars-container").html(html);
    $tradeOfferContainer.find(".trade-offer-company-container").fadeOut("fast", function() {
        $tradeOfferContainer.find(".trade-offer-available-superstars-container").fadeIn("fast");
        $tradeOfferContainer.find(".trade-offer-available-superstars-container").scrollTop(0);
        $tradeOfferContainer.find(".trade-offer-duration-container").hide();
        $tradeOfferContainer.find(".trade-offer-competitor-select-container").hide();
        $tradeOfferContainer.find(".make-trade-offer-button").hide();
        $tradeOfferContainer.find(".select-trade-superstar-button").show();
        $tradeOfferContainer.find(".trade-offer-search-container").show();
        $tradeOfferContainer.find(".trade-offer-back-button").show();
        $tradeOfferContainer.find(".trade-offer-search-input").val("");
        // Show remove button if superstar slot has superstar selected
        let superstarsContainer = $tradeOfferContainer.find(".trade-offer-superstars-container.current-selection");
        let selectedSlot = superstarsContainer.find(".trade-offer-superstar-item.current-selection");
        if (selectedSlot.attr("data-uid")) $tradeOfferContainer.find(".remove-trade-superstar-button").show();
        else $tradeOfferContainer.find(".remove-trade-superstar-button").hide();
    });
}
function $af8d9de467381f29$var$getAvailableTradeSuperstarHtml(superstar) {
    let popularity = '<span class="margin-left-15">' + superstar["popularity"] + "</span>";
    let appearances = superstar["appearances"] !== null ? '<span class="medium-light-grey">' + superstar["appearances"] + " apps.</span>" : "";
    // Superstar name, color and help text
    let superstarNameClass = "";
    let superstarHelpTexts = [];
    if (superstar["appearances"] !== null) {
        superstarNameClass = "blue";
        superstarHelpTexts.push("Part-timer");
    }
    if (superstar["injured"]) {
        superstarNameClass = "dark-red";
        superstarHelpTexts.push("Injured");
    }
    if (superstar["retired"]) {
        superstarNameClass = "light-grey";
        superstarHelpTexts.push("Retired");
    }
    if (superstar["fullTimeManager"]) {
        superstarNameClass = "manager-color";
        superstarHelpTexts.push("Full-time Manager");
    }
    let superstarName;
    if (superstarHelpTexts.length > 0) superstarName = '<div class="line-height-1p4 ' + superstarNameClass + ' help-text display-inline-block" title="' + superstarHelpTexts.join(", ") + '">' + superstar["name"] + "</div>";
    else if (superstarNameClass) superstarName = '<div class="line-height-1p4 display-inline-block' + superstarNameClass + '">' + superstar["name"] + "</div>";
    else superstarName = '<div class="line-height-1p4 display-inline-block">' + superstar["name"] + "</div>";
    let unavailableClass = "";
    if (superstar["isChampion"] || superstar["onTradeDeal"] || superstar["booked"] || superstar["contractMonthsRemaining"] || superstar["partOfTradeOffer"] || superstar["isOwner"] || superstar["powStar"]) unavailableClass = " unavailable";
    return '<div class="inner-box-item trade-offer-available-superstar-item' + unavailableClass + '" data-uid="' + superstar["uid"] + '" data-is-champion="' + superstar["isChampion"] + '" data-on-trade-deal="' + superstar["onTradeDeal"] + '" data-booked="' + superstar["booked"] + '" data-contract-months-remaining="' + superstar["contractMonthsRemaining"] + '" data-part-of-trade-offer="' + superstar["partOfTradeOffer"] + '" data-is-owner="' + superstar["isOwner"] + '" data-pow-star="' + superstar["powStar"] + '">' + '<div class="trade-offer-available-superstar-name">' + superstarName + "</div>" + '<div class="trade-offer-available-superstar-details">' + "<span>" + appearances + popularity + "</span>" + "</div>" + '<div class="clear"></div>' + "</div>";
}
async function $af8d9de467381f29$export$4578822934507e29(offeredSuperstarsUids, requestedSuperstarsUids, duration, companyUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    // _make_trade_offer
    let data = await (0, $aynj3.makeTradeOffer)(offeredSuperstarsUids, requestedSuperstarsUids, duration, companyUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $af8d9de467381f29$var$showMakeTradeOfferData(data);
}
function $af8d9de467381f29$var$showMakeTradeOfferData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let $tradeOfferContainer = $(".trade-offer-container");
        $tradeOfferContainer.find(".trade-offer-info-text").text("Your offer was sent to {0}. You should receive a reply in your messages.".format(data["competitorName"]));
        $tradeOfferContainer.find(".trade-offer-info-container").show();
        $tradeOfferContainer.find(".trade-offer-company-container").hide();
        $tradeOfferContainer.find(".trade-offer-duration-container").hide();
        $tradeOfferContainer.find(".trade-offer-competitor-select-container").hide();
        $tradeOfferContainer.find(".trade-offer-help-container").hide();
        $tradeOfferContainer.find(".make-trade-offer-button").hide();
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "competitor-not-found") notie.alert({
            type: 3,
            text: "That Competitor could not be found. Please try again."
        });
        if (data["error"] === "superstars") notie.alert({
            type: 3,
            text: "Those Superstars could not be found. Please try again."
        });
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to make this offer."
        });
        if (data["error"] === "mars") notie.alert({
            type: 3,
            text: "Trades are not available in Wrestling on Mars"
        });
    }
}
async function $af8d9de467381f29$export$2425462df21708bb(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let superstar = (0, $14eBR.Superstars).get(uid);
    let data = await (0, $5kTkA.getSuperstarDisplayData)({
        superstar: superstar,
        getTeamsAndFactions: true
    });
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $f18c00e15af0c7db$export$8d1c45aa228e7350)(data, false, true, false, true);
}



var $66ItE = parcelRequire("66ItE");

var $98xmD = parcelRequire("98xmD");

var $1JSre = parcelRequire("1JSre");

var $lCS03 = parcelRequire("lCS03");

var $1Dp0h = parcelRequire("1Dp0h");

var $8A6FL = parcelRequire("8A6FL");


var $3E8Nt = parcelRequire("3E8Nt");


var $1JSre = parcelRequire("1JSre");


var $lCS03 = parcelRequire("lCS03");

var $98xmD = parcelRequire("98xmD");

var $3E8Nt = parcelRequire("3E8Nt");

var $lueZ1 = parcelRequire("lueZ1");


let $06fab4d9d48fca73$var$showRandomPickAnimation = true;
function $06fab4d9d48fca73$export$a67bece96d5ad74f(draftData) {
    // Show draft info
    let draftInfoContent = $06fab4d9d48fca73$var$getDraftInfoHtml(draftData);
    $(".draft-info-content").html(draftInfoContent);
    $(".draft-name-label").text(draftData["name"]);
    $("#booking-container").find(".participants-box-match-header, .participants-box-segment-header, .participants-box-match-container, .participants-box-callup-header, .participants-box-segment-container, #add-segment, #booking-talent-menu, #booking-championship-info, .participants-box-trade-offer-header, #booking-talent-container").hide();
    $("#booking-container").find(".participants-box-draft-header").show();
    (0, $1JSre.hideContent)($(".draft-info-container"));
    $(".main-menu-container").find("li").removeClass("selected");
    $("#main-menu-right").html("");
    // Disable menu buttons
    (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
    // Show draft results
    $(".continue-to-draft-button").off("click");
    $(".continue-to-draft-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        $06fab4d9d48fca73$var$showDraftResults(draftData);
    });
}
function $06fab4d9d48fca73$var$getDraftInfoHtml(draftData) {
    let infoTextArray;
    if (draftData["isBrandDraft"]) {
        if (draftData["type"] === "full") infoTextArray = [
            "All superstars are removed from their current brands",
            "Draft ends when all brands have ended their turns",
            "Championships will move alongside their champions",
            "Undrafted superstars will become available on all brands",
            "Overness will reset for all brands"
        ];
        else infoTextArray = [
            "Brands can pick from all superstars belonging to other brands or not assigned to a brand",
            "Remaining superstars will stay on their current brands",
            "Championships will move alongside their champions"
        ];
    } else if (draftData["type"] === "user_only") {
        let availableSuperstarsInfo;
        if (draftData["settings"]["includeCompanyRosters"] && draftData["settings"]["includeIndies"]) availableSuperstarsInfo = "Superstars from all Companies and the Indies are eligible";
        else if (draftData["settings"]["includeCompanyRosters"]) availableSuperstarsInfo = "Superstars from all Companies are eligible";
        else if (draftData["settings"]["includeIndies"]) availableSuperstarsInfo = "Superstars from the Indies are eligible";
        infoTextArray = [
            availableSuperstarsInfo,
            "You are required to draft a minimum of 10 Superstars",
            "Draft ends when no more Superstars are available or you click on 'End Draft'",
            "Drafted Superstars are removed from their factions, managers and brands, and their championships are vacated"
        ];
    } else infoTextArray = [
        "Superstars from all main Rosters are eligible",
        "First draft selection is chosen at random",
        "You are required to draft a minimum of 10 Superstars",
        "Draft ends when no more Superstars are available or you click on 'End Draft'",
        "Any Superstars not picked will be sent to the Indies",
        "All Championships will be vacated"
    ];
    let infoContent = "";
    infoTextArray.forEach(function(infoText) {
        infoContent += '<div class="margin-bottom-7">— ' + infoText + "</div>";
    });
    return infoContent;
}
function $06fab4d9d48fca73$var$showDraftResults(draft, fadeIn = true, endDraft = false) {
    let randomPickAnimationRunning = false;
    (0, $1JSre.hideContent)($());
    // Add brand draft info
    $(".draft-result-container").data("is-brand-draft", draft["isBrandDraft"]);
    let isSingleColumn = false;
    if (draft["isBrandDraft"] || draft["type"] === "user_only") {
        $(".draft-result-container").addClass("single-column");
        isSingleColumn = true;
    } else $(".draft-result-container").removeClass("single-column");
    // Draft result
    let draftResultHtml = $06fab4d9d48fca73$var$getDraftResultHtml(draft["result"], draft["playerNames"], draft["brandColors"], isSingleColumn, draft["rosterCapacity"]);
    // Draft header
    let draftHeaderHtml = '<div class="margin-bottom-30 font-mukta-mahee font-1p325em font-bold menu-header-color">' + draft["name"] + "</div>";
    // Draft buttons
    let draftButtonsHtml = "";
    let draftRandomPickAnimationInput = "";
    if (!endDraft) {
        if (!draft["ended"]) {
            let skipPickButtonHtml = "";
            let simulatePicksButtonHtml = "";
            // Skip pick button for brand draft
            if (draft["isBrandDraft"]) skipPickButtonHtml = '<button type="button" class="button retro-button grey-button-background margin-right-5 margin-bottom-5 thin skip-draft-pick-button">Skip Pick</button>';
            else simulatePicksButtonHtml = '<button type="button" class="button retro-button grey-button-background margin-right-5 thin simulate-draft-picks-button">Simulate Picks</button>';
            draftButtonsHtml = '<div><button type="button" class="button retro-button margin-right-5 margin-bottom-5 thin make-next-draft-pick-button">Make Pick</button><button type="button" class="button retro-button orange-button-background margin-right-5 thin randomize-next-draft-pick-button">Random Pick</button>' + simulatePicksButtonHtml + skipPickButtonHtml + '<button type="button" id="end-draft-turn-button" ' + 'class="button retro-button thin red-button-background">End Turn</button>' + "</div>";
        } else {
            draftButtonsHtml = '<button type="button" id="end-draft-turn-button" class="button retro-button thin display-block">End Draft</button></div>';
            notie.alert({
                type: 4,
                text: "All draft selections have been made"
            });
        }
        // Random pick animation checkbox
        let animationChecked = "";
        if ($06fab4d9d48fca73$var$showRandomPickAnimation) animationChecked = ' checked="checked"';
        draftRandomPickAnimationInput = '<label class="control control--checkbox display-block medium-grey margin-bottom-20"><input type="checkbox" value="show_random_pick_animation"' + animationChecked + ' autocomplete="off">Show Random Pick Animation' + '<div class="control__indicator"></div>' + "</label>";
    }
    // Add html, scroll to top of result picks
    let draftResultContainerHtml = draftHeaderHtml + draftResultHtml + draftRandomPickAnimationInput + draftButtonsHtml;
    $(".draft-result-container").html(draftResultContainerHtml);
    if (fadeIn) $(".draft-result-container").fadeIn("fast");
    else $(".draft-result-container").show();
    $06fab4d9d48fca73$var$scrollToLatestPick(draft, endDraft);
    // Make pick button
    $(".draft-result-container").off("click", ".make-next-draft-pick-button, .next-draft-pick");
    $(".draft-result-container").on("click", ".make-next-draft-pick-button, .next-draft-pick", function() {
        if (randomPickAnimationRunning) {
            notie.alert({
                type: 4,
                text: "Please wait for the random pick to finish"
            });
            return false;
        }
        if (draft["picksData"].length <= 0) {
            notie.alert({
                type: 3,
                text: "There are no more Superstars available to be drafted"
            });
            return false;
        }
        let draftAvailablePicksHtml = $06fab4d9d48fca73$var$getDraftAvailablePicksHtml(draft);
        $(".draft-available-picks-container").html(draftAvailablePicksHtml);
        $(".draft-result-container").fadeOut("fast", function() {
            $(".draft-available-picks-container").fadeIn("fast");
            $(".draft-available-picks-box").scrollTop(0);
        });
    });
    // Show superstar info when clicking on draft pick superstar
    $(".draft-available-picks-container").off("click", ".draft-available-pick");
    $(".draft-available-picks-container").on("click", ".draft-available-pick", async function() {
        if ($(this).hasClass("disabled")) return false;
        let superstarUid = $(this).attr("data-uid");
        // Add selected
        $(".draft-available-pick").removeClass("selected");
        $(this).addClass("selected");
        $(".draft-available-pick-name div").removeClass("team-superstar");
        await (0, $1JSre.makeGameRequest)((0, $lueZ1.getDraftSuperstarInfo), {
            superstarUid: superstarUid,
            draftUid: draft["uid"]
        }, $06fab4d9d48fca73$var$showGetDraftSuperstarInfoData, {}, false);
    });
    // Confirm draft pick
    $(".draft-available-picks-container").off("click", "#confirm-draft-pick-button");
    $(".draft-available-picks-container").on("click", "#confirm-draft-pick-button", async function() {
        // Get selected pick
        let selectedPick = $(".draft-available-pick.selected");
        if (selectedPick.length <= 0) {
            notie.alert({
                type: 3,
                text: "Select a Superstar to draft"
            });
            return false;
        }
        // Check if superstar is protected
        if (selectedPick.hasClass("unavailable")) {
            notie.alert({
                type: 3,
                text: "This Talent is protected by their Company and cannot be drafted"
            });
            return false;
        }
        // Get function to call
        let functionToCall;
        if ($(".draft-result-container").data("is-brand-draft")) functionToCall = (0, $lueZ1.addBrandDraftPick);
        else functionToCall = (0, $lueZ1.addUserDraftPick);
        let superstarUid = selectedPick.attr("data-uid");
        await (0, $1JSre.makeGameRequest)(functionToCall, {
            superstarUid: superstarUid,
            draftUid: draft["uid"]
        }, $06fab4d9d48fca73$var$showUserPickData, {}, false);
    });
    // Back to draft result
    $(".draft-available-picks-container").off("click", "#back-to-draft-result-button");
    $(".draft-available-picks-container").on("click", "#back-to-draft-result-button", function() {
        $(".draft-available-picks-container").fadeOut("fast", function() {
            $(".draft-result-container").fadeIn("fast");
            $("#booking-container").hide();
            $06fab4d9d48fca73$var$scrollToLatestPick(draft, endDraft);
        });
    });
    // Draft search
    $(".draft-available-picks-container").off("input", ".draft-available-picks-search-input");
    $(".draft-available-picks-container").on("input", ".draft-available-picks-search-input", function() {
        $06fab4d9d48fca73$var$runDraftSuperstarsSearch();
    });
    // Random pick button
    $(".draft-result-container").off("click", ".randomize-next-draft-pick-button");
    $(".draft-result-container").on("click", ".randomize-next-draft-pick-button", async function() {
        if (randomPickAnimationRunning) {
            notie.alert({
                type: 4,
                text: "Please wait for the random pick to finish"
            });
            return false;
        }
        if (draft["picksData"].length <= 0) {
            notie.alert({
                type: 3,
                text: "There are no more Superstars available to be drafted"
            });
            return false;
        }
        // Get function to call
        let functionToCall;
        if ($(".draft-result-container").data("is-brand-draft")) functionToCall = (0, $lueZ1.addBrandDraftPick);
        else functionToCall = (0, $lueZ1.addUserDraftPick);
        await (0, $1JSre.makeGameRequest)(functionToCall, {
            draftUid: draft["uid"],
            random: true
        }, showRandomPickData, {}, false);
        function showRandomPickData({ data: data } = {}) {
            if ($06fab4d9d48fca73$var$showRandomPickAnimation) {
                randomPickAnimationRunning = true;
                let nextPickElement = $(".draft-result-container .next-draft-pick .draft-result-roster-pick-name");
                let picks = (0, $3E8Nt.shuffle)(data["picksData"]);
                let j = 0;
                let k = 0;
                let showAvailableDraftPicks = setInterval(function() {
                    // Get next draft pick from randomized array
                    nextPickElement.text(picks[j]);
                    j++;
                    if (j >= picks.length) j = 0;
                    k++;
                    if (k >= 26) {
                        nextPickElement.text(data["randomPick"]);
                        clearInterval(showAvailableDraftPicks);
                        setTimeout(function() {
                            $06fab4d9d48fca73$var$showUserPickData({
                                data: data,
                                fadeIn: false
                            });
                            randomPickAnimationRunning = false;
                        }, 450);
                    }
                }, 115, k);
            } else $06fab4d9d48fca73$var$showUserPickData({
                data: data,
                fadeIn: false
            });
        }
    });
    // Simulate picks button
    $(".draft-result-container").off("click", ".simulate-draft-picks-button");
    $(".draft-result-container").on("click", ".simulate-draft-picks-button", function() {
        if (randomPickAnimationRunning) {
            notie.alert({
                type: 4,
                text: "Please wait for the random pick to finish"
            });
            return false;
        }
        notie.confirm({
            text: "Are you sure you want to Simulate Picks for the Draft? All remaining picks will be simulated.",
            submitCallback: async function() {
                await (0, $1JSre.makeGameRequest)((0, $lueZ1.simulateDraftPicks), {
                    draftUid: draft["uid"]
                }, $06fab4d9d48fca73$var$showUserPickData, {
                    fadeIn: false
                }, false);
            }
        });
    });
    // End draft button
    $(".draft-result-container").off("click", "#end-draft-turn-button");
    $(".draft-result-container").on("click", "#end-draft-turn-button", function() {
        if (randomPickAnimationRunning) {
            notie.alert({
                type: 4,
                text: "Please wait for the random pick to finish"
            });
            return false;
        }
        notie.confirm({
            text: "Are you sure you want to end this turn?",
            submitCallback: async function() {
                let functionToCall;
                if ($(".draft-result-container").data("is-brand-draft")) functionToCall = (0, $lueZ1.endBrandDraftTurn);
                else functionToCall = (0, $lueZ1.endDraftTurn);
                await (0, $1JSre.makeGameRequest)(functionToCall, {
                    draftUid: draft["uid"]
                }, $06fab4d9d48fca73$var$showEndDraftData, {}, false);
            }
        });
    });
    // Skip draft pick button
    $(".draft-result-container").off("click", ".skip-draft-pick-button");
    $(".draft-result-container").on("click", ".skip-draft-pick-button", async function() {
        if (randomPickAnimationRunning) {
            notie.alert({
                type: 4,
                text: "Please wait for the random pick to finish"
            });
            return false;
        }
        await (0, $1JSre.makeGameRequest)((0, $lueZ1.skipBrandDraftTurn), {
            draftUid: draft["uid"]
        }, $06fab4d9d48fca73$var$showUserPickData, {
            fadeIn: false
        }, false);
    });
    // Enable/disable random pick animation
    $(".draft-result-container").off("change", 'input[value="show_random_pick_animation"]');
    $(".draft-result-container").on("change", 'input[value="show_random_pick_animation"]', function() {
        $06fab4d9d48fca73$var$showRandomPickAnimation = !!$(this).prop("checked");
    });
    // Scroll roster pick boxes together
    if (!endDraft) {
        let divs = document.getElementsByClassName("draft-result-roster-picks");
        let syncing = new Array(divs.length).fill(false);
        [].forEach.call(divs, function(div, i) {
            div.onscroll = function() {
                let $this = this;
                if (!syncing[i]) // Scroll other elements
                [].forEach.call(divs, function(otherDiv, j) {
                    if ($this !== otherDiv) {
                        syncing[j] = true;
                        otherDiv.scrollTop = $this.scrollTop;
                    }
                });
                // Element synced, don't run scroll function again
                syncing[i] = false;
            };
        });
    }
}
function $06fab4d9d48fca73$var$scrollToLatestPick(draft, endDraft) {
    // Scroll to latest pick
    $(".draft-result-roster-picks").scrollTop(0);
    $(".draft-result-roster-picks").each(function(i, el) {
        // If roster/brand active in draft or ending draft or showing simulation results (no rosters/brands present in draft)
        let keyName = $(el).siblings(".draft-result-roster-name").attr("data-name");
        let draftObjects = draft["isBrandDraft"] ? draft["brands"] : draft["rosters"];
        let draftCurrentPick = draft["currentPickBrand"] ? draft["currentPickBrand"] : draft["currentPickCompany"];
        if (draftObjects.indexOf(keyName) >= 0 || endDraft || draftObjects.length === 0) {
            // Scroll to current pick's next empty pick
            let picksMade = $(el).find('.draft-result-roster-pick:not(:contains("Empty"))').length;
            if ((keyName === draftCurrentPick || draft["ended"]) && picksMade > 4) {
                let scrollToIndex = picksMade - 4;
                if (endDraft) scrollToIndex = -3;
                let latestPickElement = $(el).find('.draft-result-roster-pick:not(:contains("Empty"))').eq(scrollToIndex);
                if (latestPickElement.length > 0) latestPickElement[0].scrollIntoView();
            }
            if (keyName === draftCurrentPick) $(el).parent()[0].scrollIntoView();
            if (!endDraft) {
                // Highlight next pick
                let nextEmptyDiv = $(el).find('.draft-result-roster-pick:contains("Empty"):first');
                nextEmptyDiv.find(".draft-result-roster-pick-name").removeClass("extra-light-grey").addClass("light-grey");
                // Add next pick button to user company's next pick
                if (!draft["ended"]) {
                    if (keyName === draftCurrentPick) nextEmptyDiv.addClass("next-draft-pick background-pulse");
                }
            }
        }
    });
}
function $06fab4d9d48fca73$var$getDraftResultHtml(resultData, playerData, brandColors, isSingleColumn, rosterCapacity) {
    let html = "";
    if (!isSingleColumn) html = '<div class="draft-result-items-container margin-bottom-10">';
    // Draft results
    Object.keys(resultData).forEach(function(name) {
        // Add player name if local multiplayer
        let playerName;
        if ((0, $98xmD.globals).game.controlMultipleCompanies && playerData) playerName = playerData[name] ? playerData[name] : "CPU";
        let brandColor;
        if (brandColors) brandColor = brandColors[name];
        let keyPicks = resultData[name];
        let draftResult = $06fab4d9d48fca73$var$getKeyDraftResult(name, keyPicks, playerName, brandColor, isSingleColumn, rosterCapacity);
        html += draftResult;
    });
    if (!isSingleColumn) html += "</div>";
    return html;
}
function $06fab4d9d48fca73$var$getKeyDraftResult(name, picks, playerName, brandColor, isSingleColumn, rosterCapacity) {
    let picksHtml = $06fab4d9d48fca73$var$getDraftPicksHtml(picks, isSingleColumn);
    // Get player name
    let playerNameHtml = "";
    if (playerName) playerNameHtml = '<div class="draft-result-roster-player-name light-grey margin-top-3 line-height-1p4 text-center"><div>' + playerName + "</div>" + "</div>";
    // Get brand color
    let brandNameStyleHtml = "";
    if (brandColor && !(0, $98xmD.globalUser).settings.colorblindMode) brandNameStyleHtml = ' style="color: ' + brandColor + '"';
    // Show roster capacity
    let rosterCapacityInfo = "";
    if (rosterCapacity) {
        let rosterSizeClass;
        if (picks.length === rosterCapacity) rosterSizeClass = "dark-yellow";
        else rosterSizeClass = "light-green";
        rosterCapacityInfo = '<span class="float-right ' + rosterSizeClass + '">' + picks.length + '<span class="margin-left-2 margin-right-2">/</span>' + rosterCapacity + "</span>";
    }
    return '<div class="draft-result-roster-box"><div class="draft-result-roster-name medium-dark-grey line-height-1p4 text-center" data-name="' + name.replace(/"/g, "&quot;") + '">' + "<div" + brandNameStyleHtml + ">" + name + rosterCapacityInfo + "</div>" + "</div>" + playerNameHtml + '<div class="draft-result-roster-picks margin-top-10">' + "<div>" + picksHtml + "</div>" + "</div>" + "</div>";
}
function $06fab4d9d48fca73$var$getDraftPicksHtml(picks, isSingleColumn) {
    let html = "";
    picks.forEach(function(pick, index) {
        let pickHtml = $06fab4d9d48fca73$var$getDraftPickHtml(pick, index, false, isSingleColumn);
        html += pickHtml;
    });
    // Show empty picks (total picks become rounded to next ten)
    for(let i = picks.length; i < Math.ceil((picks.length + 3) / 10) * 10; i++){
        let pickHtml = $06fab4d9d48fca73$var$getDraftPickHtml("Empty", i, true);
        html += pickHtml;
    }
    return html;
}
function $06fab4d9d48fca73$var$getDraftPickHtml(pick, index, empty, isSingleColumn) {
    let order = index + 1;
    let ordinalIndicator = $06fab4d9d48fca73$var$getOrdinalIndicator(order);
    let pickClass = empty ? " extra-light-grey" : "";
    let nameMaxLimit = isSingleColumn ? 35 : 15;
    let name = (0, $1JSre.getShortenedName)(pick, nameMaxLimit, true);
    let helpClass = "";
    let titleHtml = "";
    if (name !== pick) {
        helpClass = " help-text";
        titleHtml = ' title="' + pick.replace(/"/g, "&quot;") + '"';
    }
    let numberText = order;
    if (order < 100) numberText += ordinalIndicator;
    return '<div class="draft-result-roster-pick"><div class="draft-result-roster-pick-number medium-light-grey margin-right-8">' + numberText + "</div>" + '<div class="draft-result-roster-pick-name' + pickClass + helpClass + '"' + titleHtml + ">" + name.replace(/"/g, "&quot;") + "</div>" + '<div class="clear"></div>' + "</div>";
}
function $06fab4d9d48fca73$var$getOrdinalIndicator(number) {
    let tensRemainder = number % 10, hundredsRemainder = number % 100;
    if (tensRemainder === 1 && hundredsRemainder !== 11) return "st";
    if (tensRemainder === 2 && hundredsRemainder !== 12) return "nd";
    if (tensRemainder === 3 && hundredsRemainder !== 13) return "rd";
    return "th";
}
function $06fab4d9d48fca73$var$getDraftAvailablePicksHtml(draftData) {
    let html = "";
    let draftCurrentPick = draftData["currentPickBrand"] ? draftData["currentPickBrand"] : draftData["currentPickCompany"];
    let draftCurrentPickHtml = '<div class="light-grey margin-top-2 font-arial font-16px">' + draftCurrentPick + "'s Turn</div>";
    // Header
    html += '<div class="margin-bottom-30 font-mukta-mahee font-1p325em font-bold menu-header-color">Available Picks' + draftCurrentPickHtml + "</div>";
    // Search
    html += '<div class="draft-available-picks-search-container margin-bottom-15"><input type="text" name="draft-available-picks-search-input" placeholder="Search" autocomplete="off" class="styled-input draft-available-picks-search-input remove-outline"></div>';
    // Available picks
    let availablePicksListHtml = $06fab4d9d48fca73$var$getAvailablePicksListHtml(draftData["picksData"]);
    html += availablePicksListHtml;
    // Confirm/back buttons
    html += '<div class="margin-top-25"><button type="button" id="confirm-draft-pick-button" class="button retro-button button-background margin-right-8 thin">Confirm</button><button type="button" id="back-to-draft-result-button" class="button retro-button thin grey-button-background">Back</button></div>';
    return html;
}
function $06fab4d9d48fca73$var$getAvailablePicksListHtml(data) {
    let picksHtml = "";
    data.forEach(function(superstar) {
        picksHtml += $06fab4d9d48fca73$var$getAvailablePickHtml(superstar);
    });
    return '<div class="draft-available-picks-box margin-bottom-20">' + picksHtml + "</div>";
}
function $06fab4d9d48fca73$var$getAvailablePickHtml(superstar) {
    let popularity = '<span class="margin-left-15">' + superstar["popularity"] + "</span>";
    let age = '<span class="margin-left-10 medium-light-grey">' + superstar["age"] + " y/o</span>";
    // Superstar name, color and help text
    let superstarNameClass = "";
    let superstarHelpTexts = [];
    let unavailableClass = "";
    if (superstar["unavailable"]) {
        unavailableClass = " unavailable";
        superstarHelpTexts.push("Protected by Company");
    }
    if (superstar["partTimer"]) {
        superstarNameClass = "blue";
        superstarHelpTexts.push("Part-timer");
    }
    if (superstar["injured"]) {
        superstarNameClass = "dark-red";
        superstarHelpTexts.push("Injured");
    }
    if (superstar["retired"]) {
        superstarNameClass = "light-grey";
        superstarHelpTexts.push("Retired");
    }
    if (superstar["fullTimeManager"]) {
        superstarNameClass = "manager-color";
        superstarHelpTexts.push("Full-time Manager");
    }
    if (superstar["championships"].length > 0) {
        superstarNameClass = "gold";
        let championships = Array.from(superstar["championships"], function(championship) {
            return championship + " Champion";
        });
        superstarHelpTexts.push((0, $3E8Nt.commaSeparate)(championships));
    }
    let superstarName;
    if (superstarHelpTexts.length > 0) superstarName = '<div class="line-height-1p4 ' + superstarNameClass + ' help-text display-inline-block" title="' + superstarHelpTexts.join(", ") + '">' + superstar["name"] + "</div>";
    else if (superstarNameClass) superstarName = '<div class="line-height-1p4 display-inline-block' + superstarNameClass + '">' + superstar["name"] + "</div>";
    else superstarName = '<div class="line-height-1p4 display-inline-block">' + superstar["name"] + "</div>";
    return '<div class="inner-box-item draft-available-pick' + unavailableClass + '" data-uid="' + superstar["uid"] + '" data-name="' + superstar["name"].replace(/"/g, "&quot;") + '">' + '<div class="draft-available-pick-name">' + superstarName + "</div>" + '<div class="draft-available-pick-details">' + "<span>" + age + popularity + "</span>" + "</div>" + '<div class="clear"></div>' + "</div>";
}
function $06fab4d9d48fca73$var$runDraftSuperstarsSearch() {
    let availableSuperstarsContainer = $(".draft-available-picks-box");
    let availableSuperstarsElements = $(".draft-available-pick:not(.no-draft-search-results)");
    let searchTerm = $(".draft-available-picks-search-input").val();
    availableSuperstarsElements.hide();
    // Run search
    if (searchTerm.length > 0) {
        let searchResults = (0, $1JSre.runFuseElementsSearch)(availableSuperstarsElements, searchTerm, [
            "textContent"
        ]);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function(e) {
                $(e).show();
            });
            $(".no-draft-search-results").hide();
        } else if ($(".no-draft-search-results").length > 0) $(".no-draft-search-results").show();
        else availableSuperstarsContainer.append('<div class="no-draft-search-results inner-box-item draft-available-pick disabled light-grey">No Results Found</div>');
    } else {
        availableSuperstarsElements.show();
        $(".no-draft-search-results").hide();
    }
    availableSuperstarsContainer.scrollTop(0);
    availableSuperstarsContainer[0].scrollIntoView();
}
function $06fab4d9d48fca73$var$showGetDraftSuperstarInfoData({ data: data } = {}) {
    (0, $f18c00e15af0c7db$export$8d1c45aa228e7350)(data, false, false, true, true);
    data["teamSuperstars"].forEach(function(participant) {
        let elementsFound = $(".draft-available-pick").filter(function() {
            return $(this).data("name") === participant;
        });
        elementsFound.find(".draft-available-pick-name div").addClass("team-superstar");
    });
}
function $06fab4d9d48fca73$var$showUserPickData({ data: data, fadeIn: fadeIn } = {}) {
    if (!data["error"]) // Show draft results
    $(".draft-available-picks-container").fadeOut("fast", function() {
        $06fab4d9d48fca73$var$showDraftResults(data["draftData"], fadeIn);
    });
    else {
        let errorText;
        if (data["error"] === "superstar-not-found") errorText = "That Superstar could not be found. Please try again.";
        else if (data["error"] === "superstar-not-available") errorText = "That Superstar is not available to be drafted.";
        else if (data["error"] === "not-user-turn") errorText = "It wasn't your turn to draft a Superstar.";
        else if (data["error"] === "max-capacity") errorText = "Your Roster Capacity does not allow more than " + data["capacity"] + " active Superstars";
        else if (data["error"] === "no-superstars-available") errorText = "There are no more Superstars available to be drafted";
        notie.alert({
            type: 3,
            text: errorText
        });
    }
}
async function $06fab4d9d48fca73$var$showEndDraftData({ data: data } = {}) {
    if (!data["error"]) {
        // Show draft results
        $06fab4d9d48fca73$var$showDraftResults(data["draftData"], false, data["draftData"]["ended"]);
        if (data["draftData"]["ended"]) {
            // Hide draft container, load home page
            setTimeout(function() {
                $(".draft-result-container").fadeOut("fast", async function() {
                    await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)());
                });
            }, 2500);
            notie.alert({
                type: 4,
                text: data["draftData"]["name"] + " has ended"
            });
            // Enable menu buttons
            (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
        }
    } else if (data["error"] === "minimum-picks") notie.alert({
        type: 3,
        text: "You need to make a minimum of " + data["minimumPicks"] + " picks in the Draft",
        stay: true
    });
}


async function $99c29f4521d84bf4$export$17bf265a32fa820(companyUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view brands data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewBrandsData = await (0, $1Dp0h.getViewBrandsData)(companyUid);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) companySelectData = await (0, $8A6FL.getCompanySelectData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show company select
    if (!companyUid) (0, $d3e44747ec383890$export$4e74726e57dcef35)(companySelectData, $(".view-brands-company-select"));
    // Show view brands data
    (0, $1JSre.hideContent)($());
    $99c29f4521d84bf4$var$showViewBrandsPageData(viewBrandsData);
}
function $99c29f4521d84bf4$var$showViewBrandsPageData(data) {
    const $viewBrandsItemsContainer = $(".view-brands-items-container");
    const $viewBrandsContainer = $("#view-brands-container");
    $viewBrandsItemsContainer.html("");
    // Show brands
    data.forEach(function(brand) {
        let viewBrandHtml = $99c29f4521d84bf4$export$1a23879a51f09770(brand);
        $viewBrandsItemsContainer.append(viewBrandHtml);
    });
    // Show empty text if no brands
    if (data.length === 0) {
        let div = '<div class="view-brands-item disabled"><div><span class="grey">No Brands present</span></div></div>';
        $(".view-brands-items-container").append(div);
    }
    $viewBrandsContainer.fadeIn("slow");
    $viewBrandsItemsContainer.scrollTop(0);
    // Brand click handler
    $viewBrandsContainer.off("click", ".view-brands-item");
    $viewBrandsContainer.on("click", ".view-brands-item", function() {
        if ($(this).hasClass("disabled")) return false;
        let brandUid = parseInt($(this).attr("data-uid"));
        let brandData = data.filter(function(obj) {
            return obj.uid === brandUid;
        })[0];
        let isCompetitorBrand = $(".view-brands-company-select").find(":selected[data-is-competitor]").length > 0;
        $99c29f4521d84bf4$export$9b874a0a69c783bf(brandData, isCompetitorBrand);
    });
    // Edit brand
    const $brandDetailsContainer = $(".brand-details-container");
    $brandDetailsContainer.off("click", ".edit-brand-menu-button");
    $brandDetailsContainer.on("click", ".edit-brand-menu-button", async function() {
        let brandUid = $brandDetailsContainer.data("brandUid");
        let brandData = data.filter(function(obj) {
            return obj.uid === brandUid;
        })[0];
        await $99c29f4521d84bf4$export$3efe03d5175b2d15(brandData);
    });
}
function $99c29f4521d84bf4$export$1a23879a51f09770(brand) {
    // Get number of brand objects
    let brandSuperstarsWord = brand["superstars"].length === 1 ? "Superstar" : "Superstars";
    let brandSuperstarsHtml = "{0} {1}".format(brand["superstars"].length, brandSuperstarsWord);
    let brandChampionshipsWord = brand["championships"].length === 1 ? "Championship" : "Championships";
    let brandChampionshipsHtml = "{0} {1}".format(brand["championships"].length, brandChampionshipsWord);
    let brandEventsWord = brand["events"].length === 1 ? "Event" : "Events";
    let brandEventsHtml = "{0} {1}".format(brand["events"].length, brandEventsWord);
    let brandNumberOfObjects = [
        brandSuperstarsHtml,
        brandChampionshipsHtml,
        brandEventsHtml
    ].join(", ");
    // Get brand color
    let brandNameStyleHtml = "";
    if (brand["color"] && !(0, $98xmD.globalUser).settings.colorblindMode) brandNameStyleHtml = ' style="color: ' + brand["color"] + '"';
    // Get hot or stale
    let brandHotOrStaleHtml = "";
    if (brand["hot"]) brandHotOrStaleHtml = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5"/>';
    else if (brand["stale"]) brandHotOrStaleHtml = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5"/>';
    // Get brand overness
    let brandOvernessHtml = '<span class="margin-right-6 grey help-text" title="Brand Overness affects Event Hype for the brand\'s exclusive events.">Ovr.</span>' + brand["overness"] + "%";
    // Get html
    return '<div class="view-brands-item" data-uid="' + brand["uid"] + '">' + '<div class="margin-bottom-8">' + "<span" + brandNameStyleHtml + ">" + brand["name"] + brandHotOrStaleHtml + "</span>" + '<span class="float-right grey">' + brandOvernessHtml + "</span>" + "</div>" + '<div class="grey">' + brandNumberOfObjects + "</div>" + "</div>";
}
function $99c29f4521d84bf4$export$9b874a0a69c783bf(data, isCompetitorBrand) {
    let $brandDetailsContainer = $(".brand-details-container");
    // Name
    $brandDetailsContainer.find(".brand-details-name").html(data["name"]);
    // Set color if present
    if (data["color"] && !(0, $98xmD.globalUser).settings.colorblindMode) $brandDetailsContainer.find(".brand-details-name").css("color", data["color"]);
    else $brandDetailsContainer.find(".brand-details-name").css("color", "");
    // Weekly show name, exclusive
    $brandDetailsContainer.find(".brand-details-weekly-show-name").html(data["weeklyShowName"]);
    $brandDetailsContainer.find(".brand-details-weekly-show-is-exclusive").html(data["weeklyShowIsExclusive"] ? "Yes" : "No");
    // Overness, hot or stale
    let brandHotOrStaleHtml = "";
    if (data["hot"]) brandHotOrStaleHtml = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5"/>';
    else if (data["stale"]) brandHotOrStaleHtml = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5"/>';
    let brandOvernessHtml = data["overness"] + "%" + brandHotOrStaleHtml;
    $brandDetailsContainer.find(".brand-details-overness").html(brandOvernessHtml);
    // Superstars
    let brandSuperstarsHtml = "";
    data["superstars"].forEach(function(superstar) {
        brandSuperstarsHtml += '<div class="margin-bottom-6">' + superstar["name"] + "</div>";
    });
    if (data["superstars"].length <= 0) brandSuperstarsHtml += '<div class="margin-bottom-6">None</div>';
    $brandDetailsContainer.find(".brand-details-superstars").html(brandSuperstarsHtml);
    // Championships
    let brandChampionshipsHtml = "";
    data["championships"].forEach(function(championship) {
        // Get name and prestige icon
        let championshipPrestigeIcon = '<span class="margin-left-6">' + (0, $1JSre.getChampionshipPrestigeIconHtml)(championship["prestige"]) + "</span>";
        brandChampionshipsHtml += '<div class="margin-bottom-6">' + championship["name"] + championshipPrestigeIcon + "</div>";
    });
    if (data["championships"].length <= 0) brandChampionshipsHtml += '<div class="margin-bottom-6">None</div>';
    $brandDetailsContainer.find(".brand-details-championships").html(brandChampionshipsHtml);
    // Events
    let brandEventsHtml = "";
    data["events"].forEach(function(event) {
        // Get name and prestige icon
        let eventPrestigeIcon = '<span class="margin-left-6">' + (0, $1JSre.getChampionshipPrestigeIconHtml)(event["prestige"]) + "</span>";
        brandEventsHtml += '<div class="margin-bottom-6">' + event["name"] + eventPrestigeIcon + "</div>";
    });
    if (data["events"].length <= 0) brandEventsHtml += '<div class="margin-bottom-6">None</div>';
    $brandDetailsContainer.find(".brand-details-events").html(brandEventsHtml);
    // Show all buttons
    $brandDetailsContainer.find(".brand-details-buttons").children().show();
    // Hide all buttons except 'back' if competitor brand
    if (isCompetitorBrand) $brandDetailsContainer.find(".brand-details-buttons").children(":not(.back-to-view-brands-button)").hide();
    // Add uid to data
    $brandDetailsContainer.data("brandUid", data["uid"]);
    // Show brand details container
    (0, $1JSre.hideContent)($());
    $brandDetailsContainer.fadeIn("slow");
    $brandDetailsContainer[0].scrollIntoView();
    $brandDetailsContainer.find(".brand-details-superstars").scrollTop(0);
    $brandDetailsContainer.find(".brand-details-inside-container").scrollTop(0);
}
function $99c29f4521d84bf4$export$c2bf9abfd974f72b(data) {
    let parent = $(".add-brand-container");
    // Set header
    parent.find(".add-brand-header").text("Edit Brand");
    parent.find(".add-brand-cost").text("50");
    parent.find(".add-brand-help-content").text("Changing your Brand's name or weekly show name will lower its Overness slightly.");
    parent.find(".add-brand-help").show();
    // Set inputs
    parent.find(".add-brand-name").val(data["name"]);
    parent.find(".add-brand-weekly-show-name").val(data["weeklyShowName"]);
    if (data["weeklyShowIsExclusive"]) parent.find('input[value="weekly_show_is_exclusive"]').prop("checked", true);
    else parent.find('input[value="weekly_show_is_exclusive"]').prop("checked", false);
    // Set color, preview
    parent.find(".add-brand-preview").text(data["name"]);
    parent.find(".add-brand-preview").css("color", data["color"]);
    parent.find(".add-brand-color").val(data["color"]);
    parent.find(".add-brand-color").spectrum("set", data["color"]);
    // Select brand objects
    parent.find('.brand-selection-item[data-brand-name="' + data["name"].replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1") + '"]').addClass("selected");
    // Update superstars selected
    let brandSuperstarsSelected = parent.find(".add-brand-selection-superstars .brand-selection-item.selected");
    let selectedNames = Array.from(brandSuperstarsSelected, function(el) {
        return $(el).find(".brand-selection-item-name").text();
    });
    let superstarsSelected = selectedNames.length > 0 ? (0, $3E8Nt.commaSeparate)(selectedNames) : "";
    parent.find(".add-brand-selection-superstars-selected").text(superstarsSelected);
    // Set buttons
    parent.find(".edit-brand-button, .back-to-brand-details-button").show();
    parent.find(".add-brand-button, .back-to-view-brands-button").hide();
}
async function $99c29f4521d84bf4$export$b87445d6d5ea80c7(edit = false) {
    if ((0, $98xmD.globals).requestRunning) return;
    let parent = $(".add-brand-container");
    // Get brand attributes
    let brandName = parent.find(".add-brand-name").val();
    let brandWeeklyShowName = parent.find(".add-brand-weekly-show-name").val();
    let weeklyShowIsExclusive = parent.find('input[value="weekly_show_is_exclusive"]').prop("checked");
    let brandColor = parent.find(".add-brand-color").val();
    let brandUid = $(".brand-details-container").data("brandUid"); // For editing brand
    // Get superstars/events/championships selected
    let superstarUids = Array.from(parent.find(".add-brand-selection-superstars .brand-selection-item.selected"), function(x) {
        return parseInt($(x).attr("data-uid"));
    });
    let eventUids = Array.from(parent.find(".add-brand-selection-events .brand-selection-item.selected"), function(x) {
        return parseInt($(x).attr("data-uid"));
    });
    let championshipUids = Array.from(parent.find(".add-brand-selection-championships .brand-selection-item.selected"), function(x) {
        return parseInt($(x).attr("data-uid"));
    });
    // Validate
    if (brandName.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Brand"
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $1Dp0h.addOrEditBrand)(brandName, brandWeeklyShowName, weeklyShowIsExclusive, brandColor, superstarUids, eventUids, championshipUids, edit, brandUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $99c29f4521d84bf4$var$showAddOrEditBrandData(data, edit);
}
function $99c29f4521d84bf4$var$showAddOrEditBrandData(data, edit) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let brandWord = edit ? "edited" : "added";
        let html = '<span class="display-block">' + data["brandName"] + " Brand " + brandWord + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Show brand name
        (0, $1145891c855e0e78$export$24e5a79523641dba)(data["currentEvent"]);
        // Go back to view brands
        setTimeout(function() {
            $("#view-brands-menu-button").trigger("click");
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-enough-points") {
            let brandWord = edit ? "edit" : "add";
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to " + brandWord + " a brand."
            });
        }
        if (data["error"] === "not-paid") notie.alert({
            type: 3,
            text: "Brands are only available in JoW Paid."
        });
        if (data["error"] === "brand-name-exists") notie.alert({
            type: 3,
            text: "A brand with that name already exists."
        });
        if (data["error"] === "weekly-show-name-exists") notie.alert({
            type: 3,
            text: "A weekly show with that name already exists."
        });
        if (data["error"] === "brand-not-found") notie.alert({
            type: 3,
            text: "The selected brand could not be found. Please try again."
        });
        if (data["error"] === "max-brands") notie.alert({
            type: 3,
            text: "You cannot have more than 3 brands."
        });
        if (data["error"] === "mars") notie.alert({
            type: 3,
            text: "You cannot add Brands in Wrestling on Mars"
        });
        if (data["error"] === "passion") notie.alert({
            type: 3,
            text: "You cannot add Brands in Passion of Wrestling"
        });
    }
}
async function $99c29f4521d84bf4$export$8bb7271bd6c2936(brandUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $1Dp0h.removeBrand)(brandUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $99c29f4521d84bf4$var$showRemoveBrandData(data);
}
function $99c29f4521d84bf4$var$showRemoveBrandData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block">' + data["brandName"] + " Brand removed" + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Show brand name
        (0, $1145891c855e0e78$export$24e5a79523641dba)(data["currentEvent"]);
        // Go back to view brands
        setTimeout(function() {
            $("#view-brands-menu-button").trigger("click");
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "brand-not-found") notie.alert({
            type: 3,
            text: "That brand could not be found. Please try again."
        });
        else if (data["error"] === "at-weekly-show") notie.alert({
            type: 3,
            text: "Brands can only be removed at a monthly event. This is to avoid conflicts with the current weekly show."
        });
    }
}
function $99c29f4521d84bf4$export$ed37bb4ebca58880() {
    let addBrand = $(".add-brand-container");
    let availableSuperstarsContainer = addBrand.find(".add-brand-selection-superstars");
    let availableSuperstarsElements = availableSuperstarsContainer.find(".brand-selection-item");
    let searchTerm = addBrand.find(".add-brand-superstar-search-input").val();
    availableSuperstarsElements.hide();
    // Run search
    if (searchTerm.length > 0) {
        let searchResults = (0, $1JSre.runFuseElementsSearch)(availableSuperstarsElements, searchTerm, [
            "textContent"
        ]);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function(e) {
                $(e).show();
            });
            $(".no-add-brand-superstar-search-results").hide();
        } else {
            const $noSearchResults = $(".no-add-brand-superstar-search-results");
            if ($noSearchResults.length > 0) $noSearchResults.show();
            else availableSuperstarsContainer.append('<div class="no-add-brand-superstar-search-results inner-box-item disabled empty light-grey">No Results Found</div>');
        }
    } else availableSuperstarsElements.show();
    availableSuperstarsContainer.scrollTop(0);
}
async function $99c29f4521d84bf4$export$3efe03d5175b2d15(brandData) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $1Dp0h.getAddBrandSelections)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $99c29f4521d84bf4$var$showAddBrandPageData(data, brandData);
}
function $99c29f4521d84bf4$var$showAddBrandPageData(data, brandData) {
    let parent = $(".add-brand-container");
    let addedBrands = $("#view-brands-container").find(".view-brands-item:not(.disabled)").length;
    const $addBrandSelectionSuperstars = $(".add-brand-selection-superstars");
    const $addBrandSelectionChampionships = $(".add-brand-selection-championships");
    const $addBrandSelectionEvents = $(".add-brand-selection-events");
    // Show no cost for first brand
    let cost = addedBrands > 0 ? "100" : "0";
    // Reset header, inputs, buttons
    parent.find(".add-brand-header").text("Add Brand");
    parent.find(".add-brand-cost").text(cost);
    parent.find(".add-brand-help").hide();
    parent.find(".add-brand-name, .add-brand-weekly-show-name, .add-brand-color").val("");
    parent.find('input[value="weekly_show_is_exclusive"]').prop("checked", true);
    parent.find(".add-brand-preview").text("Preview");
    parent.find(".add-brand-preview").css("color", "");
    parent.find(".edit-brand-button, .back-to-brand-details-button").hide();
    parent.find(".add-brand-button, .back-to-view-brands-button").show();
    // Superstars
    let superstarsHtml = "";
    data["superstars"].forEach(function(superstar) {
        superstarsHtml += $99c29f4521d84bf4$var$getBrandSuperstarsSelectionHtml(superstar);
    });
    $addBrandSelectionSuperstars.html(superstarsHtml);
    // Championships
    let championshipsHtml = "";
    data["championships"].forEach(function(championship) {
        championshipsHtml += $99c29f4521d84bf4$var$getBrandChampionshipsSelectionHtml(championship);
    });
    $addBrandSelectionChampionships.html(championshipsHtml);
    // Events
    let eventsHtml = "";
    data["events"].forEach(function(event, eventIndex) {
        eventsHtml += $99c29f4521d84bf4$var$getBrandEventsSelectionHtml(event, eventIndex);
    });
    $addBrandSelectionEvents.html(eventsHtml);
    // Add color select
    parent.find(".add-brand-color").spectrum({
        preferredFormat: "hex",
        allowEmpty: true,
        showInitial: true,
        showInput: true,
        showButtons: false
    });
    parent.fadeIn("slow").removeClass("display-none");
    // Reset selections scroll, selected text, search
    $addBrandSelectionSuperstars.scrollTop(0);
    $(".add-brand-selection-superstars-selected").text("");
    $addBrandSelectionChampionships.scrollTop(0);
    $addBrandSelectionEvents.scrollTop(0);
    $(".add-brand-superstar-search-input").val("");
    if (brandData) $99c29f4521d84bf4$export$c2bf9abfd974f72b(brandData);
}
function $99c29f4521d84bf4$var$getBrandSuperstarsSelectionHtml(superstar) {
    let popularity = '<span class="margin-left-10"><i class="fa fa-angle-double-up margin-right-5"></i>' + superstar["popularity"] + "</span>";
    let age = '<span class="margin-left-10 light-grey">' + superstar["age"] + " y/o</span>";
    let appearances = superstar["appearances"] != null ? '<span class="light-grey">' + superstar["appearances"] + " apps.</span>" : "";
    // Superstar name, color and help text
    let superstarNameClass = "";
    let superstarHelpTexts = [];
    if (superstar["appearances"] != null) {
        superstarNameClass = "blue";
        superstarHelpTexts.push("Part-timer");
    }
    if (superstar["championshipNames"].length > 0) {
        superstarNameClass = "gold";
        let championships = Array.from(superstar["championshipNames"], function(championship) {
            return championship + " Champion";
        });
        superstarHelpTexts.push((0, $3E8Nt.commaSeparate)(championships));
    }
    if (superstar["injured"]) {
        superstarNameClass = "dark-red";
        superstarHelpTexts.push("Injured for {0} months".format(superstar["injured"]));
    }
    if (superstar["retired"]) {
        superstarNameClass = "medium-light-grey";
        superstarHelpTexts.push("Retired");
    }
    if (superstar["fullTimeManager"]) {
        superstarNameClass = "manager-color";
        superstarHelpTexts.push("Full-time Manager");
    }
    let superstarName;
    if (superstarHelpTexts.length > 0) superstarName = '<div class="line-height-1p4 brand-selection-item-name ' + superstarNameClass + ' help-text display-inline-block margin-right-8" title="' + superstarHelpTexts.join(", ") + '">' + superstar["name"] + "</div>";
    else if (superstarNameClass) superstarName = '<div class="line-height-1p4 brand-selection-item-name display-inline-block margin-right-8' + superstarNameClass + '">' + superstar["name"] + "</div>";
    else superstarName = '<div class="line-height-1p4 brand-selection-item-name display-inline-block margin-right-8">' + superstar["name"] + "</div>";
    let brandNameHtml = "";
    let dataBrandName = "";
    if (superstar["brandName"]) {
        let brandNameStyleHtml = "";
        if (superstar["brandColor"] && !(0, $98xmD.globalUser).settings.colorblindMode) brandNameStyleHtml = ' style="color: ' + superstar["brandColor"] + '"';
        brandNameHtml = '<span class="font-14px light-grey display-inline-block margin-top-2"' + brandNameStyleHtml + ">" + superstar["brandName"] + "</span>";
        // Use data-brand-name to select brand objects while editing
        dataBrandName = '" data-brand-name="' + superstar["brandName"].replace(/"/g, "&quot;");
    }
    return '<div class="inner-box-item brand-selection-item" data-uid="' + superstar["uid"] + dataBrandName + '">' + '<div class="medium-dark-grey">' + '<div class="brand-selection-item-column-left">' + superstarName + brandNameHtml + "</div>" + '<div class="brand-selection-item-column-right">' + "<span>" + appearances + age + popularity + "</span>" + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
}
function $99c29f4521d84bf4$var$getBrandChampionshipsSelectionHtml(championship) {
    let brandNameHtml = "";
    let dataBrandName = "";
    if (championship["brandName"]) {
        let brandNameStyleHtml = "";
        if (championship["brandColor"] && !(0, $98xmD.globalUser).settings.colorblindMode) brandNameStyleHtml = ' style="color: ' + championship["brandColor"] + '"';
        brandNameHtml = '<span class="font-14px light-grey display-inline-block margin-top-2"' + brandNameStyleHtml + ">" + championship["brandName"] + "</span>";
        dataBrandName = '" data-brand-name="' + championship["brandName"].replace(/"/g, "&quot;");
    }
    // Get name and prestige icon
    let championshipPrestigeIcon = '<span class="margin-left-6">' + (0, $1JSre.getChampionshipPrestigeIconHtml)(championship["prestige"]) + "</span>";
    let championshipName = '<div class="brand-selection-item-name line-height-1p4 display-inline-block margin-right-8">' + championship["name"] + championshipPrestigeIcon + "</div>";
    // Get rank
    let rank = '<span class="margin-left-10 light-grey">' + championship["rank"] + "</span>";
    return '<div class="inner-box-item brand-selection-item" data-uid="' + championship["uid"] + dataBrandName + '">' + '<div class="medium-dark-grey">' + '<div class="brand-selection-item-column-left">' + championshipName + brandNameHtml + "</div>" + '<div class="brand-selection-item-column-right">' + rank + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
}
function $99c29f4521d84bf4$var$getBrandEventsSelectionHtml(event, eventIndex) {
    let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    let brandNameHtml = "";
    let dataBrandName = "";
    if (event["brandName"]) {
        let brandNameStyleHtml = "";
        if (event["brandColor"] && !(0, $98xmD.globalUser).settings.colorblindMode) brandNameStyleHtml = ' style="color: ' + event["brandColor"] + '"';
        brandNameHtml = '<span class="font-14px light-grey display-inline-block margin-top-2"' + brandNameStyleHtml + ">" + event["brandName"] + "</span>";
        dataBrandName = '" data-brand-name="' + event["brandName"].replace(/"/g, "&quot;");
    }
    // Get name and prestige icon
    let eventPrestigeIcon = '<span class="margin-left-6">' + (0, $1JSre.getChampionshipPrestigeIconHtml)(event["prestige"]) + "</span>";
    let eventName = '<div class="brand-selection-item-name line-height-1p4 display-inline-block margin-right-8">' + event["name"] + eventPrestigeIcon + "</div>";
    // Get month
    let eventMonth = '<span class="light-grey">' + months[eventIndex] + "</span>";
    return '<div class="inner-box-item brand-selection-item" data-uid="' + event["uid"] + dataBrandName + '">' + '<div class="medium-dark-grey">' + '<div class="brand-selection-item-column-left">' + eventName + brandNameHtml + "</div>" + '<div class="brand-selection-item-column-right">' + eventMonth + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
}
async function $99c29f4521d84bf4$export$52c82543a30b1bd7() {
    if ((0, $98xmD.globals).requestRunning) return;
    let parent = $(".run-brand-draft-container");
    let brandDraftSettings = {};
    brandDraftSettings.type = parent.find('input[type="radio"][name="run-brand-draft-type-option"]:checked').val();
    brandDraftSettings.brandUids = Array.from(parent.find(".run-brand-draft-selection-brands .brand-selection-item.selected"), function(x) {
        return parseInt($(x).attr("data-uid"));
    });
    // Validate brand selections
    if (brandDraftSettings.brandUids.length < 1) {
        notie.alert({
            type: 3,
            text: "You need to select at least one Brand to hold a draft"
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $1Dp0h.runBrandDraft)(brandDraftSettings);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $99c29f4521d84bf4$var$showRunBrandDraftData(data);
}
function $99c29f4521d84bf4$var$showRunBrandDraftData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        (0, $06fab4d9d48fca73$export$a67bece96d5ad74f)(data["draftData"]);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "brand-not-found") notie.alert({
            type: 3,
            text: "One of the selected brands could not be found. Please try again."
        });
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to run a draft."
        });
        if (data["error"] === "no-brands-present") notie.alert({
            type: 3,
            text: "You need to select at least one Brand to hold a draft."
        });
        if (data["error"] === "not-paid") notie.alert({
            type: 3,
            text: "Brands are only available in JoW Paid."
        });
    }
}
async function $99c29f4521d84bf4$export$4d71feeedf5feac7() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    let parent = $(".yearly-brand-draft-container");
    let yearlyBrandDraftSettings = {};
    yearlyBrandDraftSettings.run = parent.find('input[value="run_yearly_draft"]').prop("checked");
    yearlyBrandDraftSettings.type = parent.find('input[type="radio"][name="yearly-brand-draft-type-option"]:checked').val();
    yearlyBrandDraftSettings.month = parent.find('select[name="yearly-brand-draft-month-option"]').val();
    yearlyBrandDraftSettings.brandUids = Array.from(parent.find(".yearly-brand-draft-selection-brands .brand-selection-item.selected"), function(x) {
        return parseInt($(x).attr("data-uid"));
    });
    // Validate brand selections
    if (yearlyBrandDraftSettings.run && yearlyBrandDraftSettings.brandUids.length < 1) {
        notie.alert({
            type: 3,
            text: "You need to select at least one Brand to hold a draft"
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    await (0, $1Dp0h.saveYearlyBrandDraftSettings)(yearlyBrandDraftSettings);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    notie.alert({
        type: 4,
        text: "Yearly Draft settings updated"
    });
    $("#view-brands-container").fadeIn("slow");
}
async function $99c29f4521d84bf4$export$1b6578d49f70d4cf() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $1Dp0h.getBrandDraftSelectionsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $99c29f4521d84bf4$var$showRunBrandDraftPageData(data);
}
function $99c29f4521d84bf4$var$showRunBrandDraftPageData(data) {
    if (data["brands"].length > 0) {
        (0, $lCS03.playSoundEffect)("success");
        let parent = $(".run-brand-draft-container");
        // Reset cost, input
        parent.find(".run-brand-draft-cost").text("100");
        parent.find('input[type="radio"][name="run-brand-draft-type-option"][value="shuffle"]').prop("checked", true).trigger("click");
        // Add brands
        let brandsHtml = "";
        data["brands"].forEach(function(brand) {
            brandsHtml += $99c29f4521d84bf4$var$getBrandDraftBrandsSelection(brand);
        });
        parent.find(".run-brand-draft-selection-brands").html(brandsHtml);
        parent.fadeIn("slow").removeClass("display-none");
    } else {
        (0, $lCS03.playSoundEffect)("error");
        notie.alert({
            type: 3,
            text: "You need to have at least one Brand present to hold a draft."
        });
    }
}
async function $99c29f4521d84bf4$export$83ceeba364ecf5bd() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $1Dp0h.getBrandDraftSelectionsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $99c29f4521d84bf4$var$showYearlyBrandDraftPageData(data);
}
function $99c29f4521d84bf4$var$showYearlyBrandDraftPageData(data) {
    if (data["brands"].length > 0) {
        (0, $lCS03.playSoundEffect)("success");
        let parent = $(".yearly-brand-draft-container");
        // Add brands
        let brandsHtml = "";
        data["brands"].forEach(function(brand) {
            brandsHtml += $99c29f4521d84bf4$var$getBrandDraftBrandsSelection(brand);
        });
        parent.find(".yearly-brand-draft-selection-brands").html(brandsHtml);
        let yearlyDraftSettings = data["yearlyBrandDraftSettings"];
        if (yearlyDraftSettings && yearlyDraftSettings["run"]) {
            // Load yearly brand draft settings if present
            parent.find('input[value="run_yearly_draft"]').prop("checked", true);
            parent.find('input[type="radio"][name="yearly-brand-draft-type-option"][value="' + yearlyDraftSettings["type"] + '"]').prop("checked", true).trigger("click");
            parent.find('select[name="yearly-brand-draft-month-option"]').val(yearlyDraftSettings["month"]);
            parent.find(".yearly-brand-draft-selection-brands .brand-selection-item").each(function(i, e) {
                if (yearlyDraftSettings["brandUids"].indexOf(parseInt($(e).attr("data-uid"))) >= 0) $(e).addClass("selected");
                else $(e).removeClass("selected");
            });
            parent.find(".yearly-brand-draft-options-container").show();
        } else {
            // Otherwise reset inputs
            parent.find('input[type="radio"][name="yearly-brand-draft-type-option"][value="shuffle"]').prop("checked", true).trigger("click");
            parent.find('select[name="yearly-brand-draft-month-option"]').val("0");
            parent.find('input[value="run_yearly_draft"]').prop("checked", false);
            parent.find(".yearly-brand-draft-options-container").hide();
        }
        parent.fadeIn("slow").removeClass("display-none");
    } else {
        (0, $lCS03.playSoundEffect)("error");
        notie.alert({
            type: 3,
            text: "You need to have at least one Brand present to hold a draft."
        });
    }
}
function $99c29f4521d84bf4$var$getBrandDraftBrandsSelection(brand) {
    // Get brand color
    let brandNameStyleHtml = "";
    if (brand["color"] && !(0, $98xmD.globalUser).settings.colorblindMode) brandNameStyleHtml = ' style="color: ' + brand["color"] + '"';
    return '<div class="inner-box-item brand-selection-item selected" data-uid="' + brand["uid"] + '">' + '<div class="medium-dark-grey">' + "<div" + brandNameStyleHtml + ">" + brand["name"] + "</div>" + "</div>" + "</div>";
}



var $6PzHO = parcelRequire("6PzHO");


var $3NAMH = parcelRequire("3NAMH");

var $aP7lq = parcelRequire("aP7lq");
let $76da554e02071cd0$export$8ca504209c139329 = [
    {
        "name": "Weak",
        "tag": "physical"
    },
    {
        "name": "Athletic",
        "tag": "physical"
    },
    {
        "name": "Strong",
        "tag": "physical"
    },
    {
        "name": "Glamorous",
        "tag": "physical"
    },
    {
        "name": "Cute",
        "tag": "physical"
    },
    {
        "name": "Frightening",
        "tag": "physical"
    },
    {
        "name": "Attractive",
        "tag": "physical"
    },
    {
        "name": "Tough",
        "tag": "physical"
    },
    {
        "name": "Dominating",
        "tag": "physical"
    },
    {
        "name": "Badass",
        "tag": "physical"
    },
    {
        "name": "Ordinary",
        "tag": "physical"
    },
    {
        "name": "Bizarre",
        "tag": "physical"
    },
    {
        "name": "Flamboyant",
        "tag": "physical"
    },
    {
        "name": "Enthusiastic",
        "tag": "emotional"
    },
    {
        "name": "Fun-loving",
        "tag": "emotional"
    },
    {
        "name": "Passionate",
        "tag": "emotional"
    },
    {
        "name": "Troublesome",
        "tag": "emotional"
    },
    {
        "name": "Miserable",
        "tag": "emotional"
    },
    {
        "name": "Aggressive",
        "tag": "emotional"
    },
    {
        "name": "Anxious",
        "tag": "emotional"
    },
    {
        "name": "Intense",
        "tag": "emotional"
    },
    {
        "name": "Reserved",
        "tag": "emotional"
    },
    {
        "name": "Cowardly",
        "tag": "negative"
    },
    {
        "name": "Arrogant",
        "tag": "negative"
    },
    {
        "name": "Malicious",
        "tag": "negative"
    },
    {
        "name": "Deceitful",
        "tag": "negative"
    },
    {
        "name": "Obnoxious",
        "tag": "negative"
    },
    {
        "name": "Sleazy",
        "tag": "negative"
    },
    {
        "name": "Selfish",
        "tag": "negative"
    },
    {
        "name": "Power-hungry",
        "tag": "negative"
    },
    {
        "name": "Cocky",
        "tag": "negative"
    },
    {
        "name": "Hardworking",
        "tag": "positive"
    },
    {
        "name": "Incorruptible",
        "tag": "positive"
    },
    {
        "name": "Familial",
        "tag": "positive"
    },
    {
        "name": "Lovable",
        "tag": "positive"
    },
    {
        "name": "Heroic",
        "tag": "positive"
    },
    {
        "name": "Humble",
        "tag": "positive"
    },
    {
        "name": "Perfect",
        "tag": "distinguished"
    },
    {
        "name": "Cultured",
        "tag": "distinguished"
    },
    {
        "name": "Elegant",
        "tag": "distinguished"
    },
    {
        "name": "Stoic",
        "tag": "distinguished"
    },
    {
        "name": "Wise",
        "tag": "distinguished"
    },
    {
        "name": "Authoritarian",
        "tag": "distinguished"
    },
    {
        "name": "Confident",
        "tag": "mental"
    },
    {
        "name": "Distracted",
        "tag": "mental"
    },
    {
        "name": "Calculating",
        "tag": "mental"
    },
    {
        "name": "Unstable",
        "tag": "mental"
    },
    {
        "name": "Tranquilo",
        "tag": "mental"
    },
    {
        "name": "Fearless",
        "tag": "mental"
    },
    {
        "name": "Intelligent",
        "tag": "mental"
    },
    {
        "name": "Unpredictable",
        "tag": "mental"
    },
    {
        "name": "Extreme",
        "tag": "mental"
    },
    {
        "name": "Naive",
        "tag": "social"
    },
    {
        "name": "Solitary",
        "tag": "social"
    },
    {
        "name": "Charismatic",
        "tag": "social"
    },
    {
        "name": "Impressive",
        "tag": "social"
    },
    {
        "name": "Trusting",
        "tag": "social"
    }
];



var $98xmD = parcelRequire("98xmD");

var $iTOJp = parcelRequire("iTOJp");
let $acecca4a272c50a4$var$currentTutorialSteps;
function $acecca4a272c50a4$export$36f96b5f9463ac7a(stateName) {
    if (stateName === "end_tutorial") {
        // If tutorial ended, remove tutorial elements, enable pointer events
        $(".tutorial-element-outline").hide();
        $(".tutorial-info-container").hide();
        (0, $98xmD.globals).currentTutorialStep = null;
        $acecca4a272c50a4$export$8dec9b3b951af069();
        (0, $98xmD.globals).game.story = null;
    } else {
        // Get steps for this tutorial state, run first step
        $acecca4a272c50a4$var$currentTutorialSteps = (0, $iTOJp.tutorialSteps)[stateName];
        // Top menu button steps if not at that position
        if ([
            "simulate_match",
            "end_first_event",
            "play_second_event_second_segment",
            "play_second_event_main_event",
            "end_second_event"
        ].indexOf(stateName) >= 0 && !$("#event-match-results").is(":visible") && $acecca4a272c50a4$var$currentTutorialSteps[0]["action"] !== "click_play_event") $acecca4a272c50a4$var$currentTutorialSteps.unshift({
            "text": 'Click <span class="tutorial-color">Play</span>.',
            "element": "#play-event",
            "action": "click_play_event"
        });
        if ([
            "add_tag_match"
        ].indexOf(stateName) >= 0 && !$("#booking-container").is(":visible") && $acecca4a272c50a4$var$currentTutorialSteps[0]["action"] !== "click_book_button") $acecca4a272c50a4$var$currentTutorialSteps.unshift({
            "text": 'Click <span class="tutorial-color">Book</span>.',
            "element": "#book-menu-button",
            "action": "click_book_button"
        });
        if ([
            "book_singles_segment",
            "book_feud_match"
        ].indexOf(stateName) >= 0 && !$("#booking-container").is(":visible") && $acecca4a272c50a4$var$currentTutorialSteps[0]["action"] !== "click_book_segment_button") $acecca4a272c50a4$var$currentTutorialSteps.unshift({
            "text": 'Click <span class="tutorial-color">Book</span>.',
            "element": "#book-menu-button",
            "action": "click_book_segment_button"
        });
        if ([
            "add_team"
        ].indexOf(stateName) >= 0 && $("#main-menu-right").is(":empty") && $acecca4a272c50a4$var$currentTutorialSteps[0]["action"] !== "click_view_teams") $acecca4a272c50a4$var$currentTutorialSteps.unshift({
            "text": 'Click <span class="tutorial-color">Roster</span> and select <span class="tutorial-color">Teams</span>.',
            "element": "#manage-roster",
            "action": "click_view_teams",
            "subElements": [
                "#view-teams-menu-button"
            ]
        });
        if ([
            "disband_team",
            "add_team",
            "add_feud",
            "view_indies",
            "view_staff_and_facilities",
            "add_gimmick_match",
            "other_features"
        ].indexOf(stateName) >= 0 && $("#main-menu-right").is(":empty") && $acecca4a272c50a4$var$currentTutorialSteps[0]["action"] !== "click_manage_button") $acecca4a272c50a4$var$currentTutorialSteps.unshift({
            "text": 'Click <span class="tutorial-color">Manage</span>.',
            "element": "#manage",
            "action": "click_manage_button"
        });
        // Set multi match button setting
        if (stateName === "add_vacant_title_match" && $("#multi-match-button").hasClass("selected")) $("#multi-match-button").trigger("click");
        if ([
            "add_singles_match",
            "add_tag_match"
        ].indexOf(stateName) >= 0 && $("#multi-match-button").hasClass("selected")) $("#multi-match-button").trigger("click");
        (0, $98xmD.globals).currentTutorialStep = $acecca4a272c50a4$var$currentTutorialSteps[0];
        $acecca4a272c50a4$var$runTutorialStep((0, $98xmD.globals).currentTutorialStep);
    }
}
function $acecca4a272c50a4$var$runTutorialStep(tutorialStep) {
    $acecca4a272c50a4$var$highlightTutorialElement(tutorialStep["element"]);
    $acecca4a272c50a4$var$showTutorialText(tutorialStep["text"], tutorialStep["action"], tutorialStep["element"], tutorialStep["position"]);
    $acecca4a272c50a4$export$a0ca3fbd9bfabbf(tutorialStep);
    $acecca4a272c50a4$var$scrollToTutorialContainer(tutorialStep);
}
function $acecca4a272c50a4$var$highlightTutorialElement(element) {
    let tutorialOutlineContainer = $(".tutorial-element-outline");
    tutorialOutlineContainer.hide();
    if (element) {
        // Scroll parent to element
        if ($(element).parent().is($("#segment-items-container")) || $(element).parent().is($(".message-preview-container"))) {
            let $container = $(element).parent(), $scrollTo = $(element);
            $container.scrollTop($scrollTo.offset().top - $container.offset().top + $container.scrollTop());
        }
        let pos = $(element).eq(0).offset();
        if (pos) {
            tutorialOutlineContainer.show();
            let elementWidth = $(element).innerWidth();
            let elementHeight = $(element).innerHeight();
            // Adjust outline for some smaller elements
            if ($(element).is(".roster-member-alignment, .roster-member-status, .roster-member-overness, .roster-member-morale, .roster-member, .superstar-info-popularity, .superstar-info-workrate, .superstar-info-charisma, .match-feud-name, .match-result-feuds")) elementHeight -= 6;
            tutorialOutlineContainer.css({
                top: pos.top - 8,
                left: pos.left - 8,
                width: elementWidth + 16,
                height: elementHeight + 16
            });
        }
    }
}
function $acecca4a272c50a4$var$showTutorialText(text, action, element, position) {
    let tutorialInfoContainer = $(".tutorial-info-container");
    $(".tutorial-info-text").html(text);
    // Show continue button if no action associated with this step
    if (!action) $(".tutorial-info-continue-button").show();
    else $(".tutorial-info-continue-button").hide();
    // Position tutorial container relative to element if present
    tutorialInfoContainer.show();
    if (element && $(element).length > 0) {
        let pos = $(element).eq(0).offset();
        if (pos) {
            let topPos = pos.top - tutorialInfoContainer.height() - 10;
            if (topPos < 0 || position === "bottom") // If above window, place below element
            topPos = pos.top + $(element).outerHeight() + 10;
            let leftPos = pos.left;
            if (leftPos + tutorialInfoContainer.width() >= $(window).width()) // If overflowing to the right, move to right edge
            leftPos -= leftPos + tutorialInfoContainer.width() - $(window).width() + 10;
            tutorialInfoContainer.css({
                top: topPos,
                left: leftPos
            });
        }
    } else // Default position
    tutorialInfoContainer.css({
        top: "5%",
        left: ($(window).width() - tutorialInfoContainer.outerWidth()) / 2
    });
    // Force DOM refresh
    tutorialInfoContainer.hide().show(0);
    // Go to next step upon pressing continue
    $(".tutorial-info-continue-button").off("click");
    $(".tutorial-info-continue-button").on("click", function() {
        $acecca4a272c50a4$var$goToNextTutorialStep();
    });
}
function $acecca4a272c50a4$var$scrollToTutorialContainer(tutorialStep) {
    let tutorialInfoContainer = $(".tutorial-info-container");
    let tutorialOutlineContainer = $(".tutorial-element-outline");
    // Set where to scroll to (start aligns to top, end aligns to bottom)
    let blockValue;
    if (tutorialStep["scrollTo"]) blockValue = tutorialStep["scrollTo"];
    else blockValue = $(".container").css("width") === "480px" ? "start" : "end";
    setTimeout(function() {
        let containerToScrollTo;
        // On mobile, scroll to outline container if it is visible and higher than info container
        if (blockValue === "start" && tutorialOutlineContainer.is(":visible") && tutorialOutlineContainer.offset().top < tutorialInfoContainer.offset().top) containerToScrollTo = tutorialOutlineContainer;
        else if (tutorialStep["action"] && blockValue === "end" && tutorialOutlineContainer.is(":visible") && tutorialOutlineContainer.offset().top > tutorialInfoContainer.offset().top) containerToScrollTo = tutorialOutlineContainer;
        else containerToScrollTo = tutorialInfoContainer;
        containerToScrollTo[0].scrollIntoView({
            behavior: "smooth",
            block: blockValue
        });
    }, 50);
}
function $acecca4a272c50a4$export$a0ca3fbd9bfabbf(tutorialStep) {
    if (tutorialStep) {
        $(".main-menu li:not(#main-menu-button), #booking-container .button, #booking-talent-menu input, #booking-talent-menu select, #booking-container .roster-item-member, .main-menu .dropdown-menu li, .event-card-match-edit-menu .dropdown-menu li, .tag-match-option, #messages, #match .match-wrestler, #match .button, #event-updates .button, #continue, #game-messages .button, .delete-message, #booking-container .feud-container, #booking-container .segment-item-container,#add-segment-item-menu input, #roster-container .button, #roster-container input, #roster-container select, #roster-container .roster-member, #roster-member-details .button, #view-teams-container .button, #view-teams-container select, #view-teams-container .view-teams-item, #add-team select, #add-team input, #add-team .button, #select-gimmick-match-container .gimmick-match-item, .match-finishes-container .match-finishes-item-container, .viewership-results-box .button, #event-history-container .button, #event-history-container select, #next-event, #last-event, #feud-history-container .button, #feud-history-container select, #feud-history-container .feud-history-item, #feud-history-container input, .feuds-history-sort-order, #create-feud .button, #create-feud input, #create-feud select, #create-feud .feud-item-container, #indie .roster-member, #indie input, .company-staff-container .button, .company-staff-container .company-staff-member, .company-facilities-container .button, .staff-member-details .button, #view-gimmick-matches-container .button, #add-gimmick-match .button, #add-gimmick-match input, #add-gimmick-match select, #matches .button, #matches .event-match, #feud-items-container .feud-item-container").css("pointer-events", "none");
        if (tutorialStep["element"] && !tutorialStep["disallowClick"]) {
            $(tutorialStep["element"]).eq(0).css("pointer-events", "auto");
            if ($(tutorialStep["element"]).eq(0).is("input, select")) $(tutorialStep["element"]).eq(0).focus();
        }
        if (tutorialStep["subElements"]) tutorialStep["subElements"].forEach(function(subElement) {
            $(subElement).eq(0).css("pointer-events", "auto");
        });
    }
}
function $acecca4a272c50a4$export$8dec9b3b951af069() {
    if ($(".main-menu li:not(#main-menu-button)").css("pointer-events") === "none") $(".main-menu li:not(#main-menu-button), #booking-container .button, #booking-talent-menu input, #booking-talent-menu select, #booking-container .roster-item-member, .main-menu .dropdown-menu li, .event-card-match-edit-menu .dropdown-menu li, .tag-match-option, #messages, #match .match-wrestler, #match .button, #event-updates .button, #continue, #game-messages .button, .delete-message, #booking-container .feud-container, #booking-container .segment-item-container,#add-segment-item-menu input, #roster-container .button, #roster-container input, #roster-container select, #roster-container .roster-member, #roster-member-details .button, #view-teams-container .button, #view-teams-container select, #view-teams-container .view-teams-item, #add-team select, #add-team input, #add-team .button, #select-gimmick-match-container .gimmick-match-item, .match-finishes-container .match-finishes-item-container, .viewership-results-box .button, #event-history-container .button, #event-history-container select, #next-event, #last-event, #feud-history-container .button, #feud-history-container select, #feud-history-container .feud-history-item, #feud-history-container input, .feuds-history-sort-order, #create-feud .button, #create-feud input, #create-feud select, #create-feud .feud-item-container, #indie .roster-member, #indie input, .company-staff-container .button, .company-staff-container .company-staff-member, .company-facilities-container .button, .staff-member-details .button, #view-gimmick-matches-container .button, #add-gimmick-match .button, #add-gimmick-match input, #add-gimmick-match select, #matches .button, #matches .event-match, #feud-items-container .feud-item-container").css("pointer-events", "auto");
}
function $acecca4a272c50a4$var$goToNextTutorialStep() {
    // Check if next step exists
    let tutorialStepIndex = $acecca4a272c50a4$var$currentTutorialSteps.indexOf((0, $98xmD.globals).currentTutorialStep);
    if (tutorialStepIndex + 1 < $acecca4a272c50a4$var$currentTutorialSteps.length) {
        // Set next tutorial step and run it
        (0, $98xmD.globals).currentTutorialStep = $acecca4a272c50a4$var$currentTutorialSteps[tutorialStepIndex + 1];
        $acecca4a272c50a4$var$runTutorialStep((0, $98xmD.globals).currentTutorialStep);
    } else // Run next tutorial state
    $acecca4a272c50a4$export$36f96b5f9463ac7a((0, $98xmD.globals).game.tutorialState);
}
function $acecca4a272c50a4$export$a1aafb768cdbcc70(performedAction) {
    // Check if current tutorial step's action matches the performed action
    if ((0, $98xmD.globals).currentTutorialStep && (0, $98xmD.globals).currentTutorialStep["action"] === performedAction) $acecca4a272c50a4$var$goToNextTutorialStep();
}


const $d3e44747ec383890$var$headerClasses = {
    "Champions": "roster-champions",
    "Main Eventers": "roster-main-eventers",
    "Upper Midcarders": "roster-upper-midcarders",
    "Lower Midcarders": "roster-lower-midcarders",
    "Jabronis": "roster-jabronis",
    "Managers": "roster-managers",
    "Tag Teams": "roster-tag-teams",
    "Trios": "roster-trios",
    "Training Roster": "roster-training",
    "Retired": "roster-retired",
    "Dead": "roster-dead"
};
let $d3e44747ec383890$var$allowGenerateGimmick = true;
// Event handlers
$(document).ready(function() {
    const $rosterContainer = $("#roster-container");
    const $game = $("#game");
    // View roster company select handler
    $rosterContainer.on("change", ".select-company-for-view-roster", async function() {
        let companyUid = parseInt($(this).find(":selected").attr("data-uid"));
        await $d3e44747ec383890$export$9595013ad42e288e(companyUid);
    });
    // Roster section select handler
    $rosterContainer.on("change", ".roster-section-select", function() {
        // Reset filter and search
        $(".roster-search-container").hide();
        $(".roster-members-container").show();
        $(".view-roster-filter").removeClass("selected");
        $(".roster-search-input").val("");
        // Scroll to selected section
        const headerClass = $d3e44747ec383890$var$headerClasses[$(this).val()];
        $("." + headerClass)[0].scrollIntoView();
    });
    // Roster filter handler
    $rosterContainer.on("click", ".view-roster-filter", function() {
        let filterName;
        let filterBrandName;
        // Unselect filter
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else {
            $(".view-roster-filter.selected").removeClass("selected");
            $(this).addClass("selected");
            filterName = $(this).attr("data-value");
            filterBrandName = $(this).attr("data-brand-name");
        }
        $d3e44747ec383890$var$applyRosterSearchOrFilter("filter", filterName, filterBrandName);
    });
    // Roster search handler
    $rosterContainer.on("input", ".roster-search-input", function() {
        let searchTerm = $(this).val();
        $d3e44747ec383890$var$applyRosterSearchOrFilter("search", searchTerm);
    });
    // Roster member click handler
    $rosterContainer.on("click", ".roster-member", async function() {
        let memberUid = parseInt($(this).attr("data-uid"));
        let memberType = $(this).attr("data-type");
        let competitorUid = parseInt($(".select-company-for-view-roster").find(":selected[data-is-competitor]").attr("data-uid"));
        await $d3e44747ec383890$export$8777720a6e173e8e(memberUid, memberType, competitorUid, "#roster-container");
    });
    // Back to view roster handler
    const $rosterMemberDetails = $("#roster-member-details");
    $rosterMemberDetails.on("click", ".roster-member-details-back-button", function() {
        let element = $rosterMemberDetails.data("element");
        // Go back to view managers page
        if (element === "#view-managers-container") $(".view-managers-company-select").trigger("change");
        else if (element === "#view-teams-container") $(".view-teams-company-select").trigger("change");
        else {
            (0, $lCS03.playSoundEffect)("success");
            $rosterMemberDetails.hide();
            // Go back to booking page
            if (element === "#booking-container") {
                if ($("#book-tag-team-menu-button").hasClass("selected")) $(".tag-match-options").find(".selected").trigger("click");
                else if ($("#book-segment-menu-button").hasClass("selected") || $("#book-singles-menu-button").hasClass("selected")) $("#booking-menu").find(".selected").trigger("click");
                else $(".view-available-callup-button").trigger("click");
            } else {
                $(element).fadeIn();
                // Reload graphic on previous page
                if ($(element).hasClass("talent-offer-box")) {
                    const $talentOfferBoxGraphic = $(".talent-offer-box-graphic");
                    if ($talentOfferBoxGraphic.data("graphic")) (0, $c82cd471f4baff6b$export$e7557da3ac483fcd)($talentOfferBoxGraphic, $talentOfferBoxGraphic.data("graphic"));
                }
                if ($(element).hasClass("talent-request-box")) {
                    const $talentRequestGraphic = $(".talent-request-graphic");
                    if ($talentRequestGraphic.data("graphic")) (0, $c82cd471f4baff6b$export$e7557da3ac483fcd)($talentRequestGraphic, $talentRequestGraphic.data("graphic"));
                }
                // Find roster member element
                let rosterMemberUid = $rosterMemberDetails.data("uid");
                let rosterMemberElement = $('.roster-member[data-uid="' + rosterMemberUid + '"]')[0];
                // Scroll to roster member
                if (rosterMemberElement) {
                    Element.prototype.documentOffsetTop = function() {
                        return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0);
                    };
                    let top = rosterMemberElement.documentOffsetTop() - window.innerHeight / 2;
                    window.scrollTo(0, top);
                    // Highlight roster member
                    setTimeout(function() {
                        $(rosterMemberElement).addClass("flash-red");
                    }, 0);
                    setTimeout(function() {
                        $(rosterMemberElement).removeClass("flash-red");
                    }, 1500);
                }
            }
        }
    });
    // Load add superstar page
    $("#roster-container, #view-managers-container").on("click", ".add-superstar-menu-button", async function() {
        await $d3e44747ec383890$var$loadAddSuperstarPage($(this));
    });
    // Load release superstar page
    $rosterContainer.on("click", "#release-superstar-menu-button", async function() {
        await $d3e44747ec383890$var$loadReleaseSuperstarPage();
    });
    // Add superstar cost change
    $('#add-superstar select[name="custom-superstar-workrate"], #add-superstar select[name="custom-superstar-charisma"]').on("change", function() {
        $d3e44747ec383890$var$updateCustomSuperstarCost();
    });
    // Show/hide superstar graphic
    $("#add-superstar select[name='superstar-graphic-option']").on("change", function() {
        if ($(this).val() === "0") {
            $("#wrestler-graphic").hide();
            $("#add-superstar").find(".character-creator-controls").hide();
        } else if ($(this).val() === "1") {
            $("#wrestler-graphic").show();
            $("#add-superstar").find(".character-creator-controls").show();
        }
    });
    // Select superstar trait
    const $container = $("#container");
    $container.on("click", ".superstar-trait-item-container", function() {
        let $this = $(this);
        $d3e44747ec383890$export$f81d542126046733($this);
    });
    // Show superstar traits button
    $container.on("click", ".superstar-traits-show-button", function() {
        let $this = $(this);
        if ($this.find("span").text() === "Show Traits") {
            // Hide open containers
            $(".superstar-trait-items-container:visible").each(function(i, e) {
                $(e).hide();
                $(e).siblings(".superstar-traits-selection-container").find(".superstar-traits-show-button span").text("Show Traits");
                $(e).siblings(".superstar-traits-selection-container").find("i").addClass("fa-angle-down").removeClass("fa-angle-up");
                $(e).siblings(".superstar-traits-selection-container").find(".superstar-traits-information").fadeOut("fast");
            });
            // Show this container
            $this.parent().siblings(".superstar-trait-items-container").fadeIn("fast");
            $this.parent().siblings(".superstar-trait-items-container").scrollTop(0);
            $this.find("span").text("Hide Traits");
            $this.find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
            $this.siblings(".superstar-traits-information").fadeIn("fast");
        } else {
            // Hide this container
            $this.parent().siblings(".superstar-trait-items-container").fadeOut("fast");
            $this.find("span").text("Show Traits");
            $this.find("i").addClass("fa-angle-down").removeClass("fa-angle-up");
            $this.siblings(".superstar-traits-information").fadeOut("fast");
        }
    });
    // Add superstar button
    $("#add-superstar #add-superstar-button").on("click", async function() {
        await $d3e44747ec383890$var$getAddSuperstarRequest();
    });
    // Release superstar button
    $("#release-superstar").on("click", "#release-superstar-button", async function() {
        await $d3e44747ec383890$var$getReleaseSuperstarRequest();
    });
    // Go back to view roster
    $game.on("click", ".back-to-view-roster-button", function() {
        let parentContainer = $(this).closest(".box");
        if (parentContainer.data("element") === "view-managers-container") $(".view-managers-company-select").trigger("change");
        else $("#view-roster-menu-button").trigger("click");
    });
    // Load change name page
    $rosterMemberDetails.on("click", "#edit-name-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.getRosterMemberNameData), {
            uid: uid,
            type: type
        }, $d3e44747ec383890$export$69bc1b0077a67580, {
            uid: uid,
            type: type
        });
    });
    // Load change pronoun page
    $rosterMemberDetails.on("click", "#edit-pronoun-button", async function() {
        let uid = $("#roster-member-details").data("uid");
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.getRosterMemberPronounData), {
            uid: uid
        }, $d3e44747ec383890$var$showRosterMemberPronounData, {
            uid: uid
        });
    });
    // Load change appearance page
    $rosterMemberDetails.on("click", "#edit-appearance-button", async function() {
        $rosterMemberDetails.hide();
        let uid = $rosterMemberDetails.data("uid");
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.getRosterMemberGimmickData), {
            uid: uid,
            getCharacters: false
        }, $d3e44747ec383890$var$showRosterMemberAppearanceData, {
            uid: uid
        });
    });
    // Load change alignment page
    $rosterMemberDetails.on("click", "#edit-alignment-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.getRosterMemberAlignmentData), {
            uid: uid,
            type: type
        }, $d3e44747ec383890$var$showRosterMemberAlignmentData, {
            uid: uid,
            type: type
        });
    });
    // Load change brand page
    $rosterMemberDetails.on("click", "#edit-superstar-brand-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.getRosterMemberBrandData), {
            uid: uid,
            type: type
        }, $d3e44747ec383890$var$showRosterMemberBrandData, {
            uid: uid,
            type: type
        });
    });
    // Load change gimmick page
    $rosterMemberDetails.on("click", "#edit-gimmick-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let $el = $(this);
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.getRosterMemberGimmickData), {
            uid: uid
        }, $d3e44747ec383890$var$showRosterMemberGimmickData, {
            uid: uid,
            $el: $el
        });
    });
    // Select gimmick item
    const $createGimmickContainer = $("#create-gimmick-container");
    $createGimmickContainer.on("click", ".gimmick-selection-item", function() {
        (0, $lCS03.playSoundEffect)("success");
        let $this = $(this);
        $d3e44747ec383890$var$allowGenerateGimmick = false;
        if ($this.hasClass("selected")) {
            $this.removeClass("selected");
            if ($this.hasClass("character-item")) {
                $(".character-selected").text("");
                $(".personality-item").each(function(i, e) {
                    $(e).removeClass("green red dark-yellow");
                });
                $(".gimmick-times-used").text("");
                $(".gimmick-penalty").text("");
                $(".personality-easy-combinations-unlocked").text("");
                $(".personality-easy-combinations-total").text("");
                $(".personality-hard-combinations-unlocked").text("");
                $(".personality-hard-combinations-total").text("");
                $(".combinations-count-divider").text("");
            } else if ($this.hasClass("personality-item")) $(".personality-selected").text("");
            // If nothing selected, show default gimmick label
            if (!$(".character-selected").text() && !$(".personality-selected").text()) $(".default-gimmick-label").show();
        } else if (!$(this).hasClass("locked")) {
            $this.addClass("selected");
            // Unselect other options
            if ($this.hasClass("character-item")) {
                // Add selected option to gimmick display
                $(".character-selected").text($this.text());
                $(".character-item").each(function(i, e) {
                    if (!$(e).is($this)) $(e).removeClass("selected");
                });
                // Add highlighting to unlocked combinations
                let goodCombinations = $this.data("good-combinations") || [];
                let badCombinations = $this.data("bad-combinations") || [];
                let okayCombinations = $this.data("okay-combinations") || [];
                $(".personality-item").each(function(i, e) {
                    let personalityName = $(e).text();
                    $(e).removeClass("green red dark-yellow");
                    if (goodCombinations.indexOf(personalityName) >= 0) $(e).addClass("green");
                    else if (badCombinations.indexOf(personalityName) >= 0) $(e).addClass("red");
                    else if (okayCombinations.indexOf(personalityName) >= 0) $(e).addClass("dark-yellow");
                });
                let timesUsed = $this.data("times-used");
                if (timesUsed) {
                    let timesUsedText = "Used {0} {1}".format(timesUsed, (0, $1JSre.getTimesWord)(timesUsed));
                    $(".gimmick-times-used").text(timesUsedText);
                    let penalty = $d3e44747ec383890$var$getTimesUsedPenalty(timesUsed);
                    $(".gimmick-penalty").text(penalty);
                } else {
                    $(".gimmick-times-used").text("");
                    $(".gimmick-penalty").text("");
                }
                // Show unlock counts
                let easyCombinationsTotal = $this.data("easy-combinations-total");
                let easyCombinationsUnlocked = $this.data("easy-combinations-unlocked");
                if (easyCombinationsTotal) {
                    $(".personality-easy-combinations-total").text(easyCombinationsTotal);
                    $(".personality-easy-combinations-unlocked").text(easyCombinationsUnlocked);
                    $(".combinations-count-divider").text("/");
                } else {
                    $(".personality-easy-combinations-total").text("");
                    $(".personality-easy-combinations-unlocked").text("");
                    $(".combinations-count-divider").text("");
                }
                let hardCombinationsTotal = $this.data("hard-combinations-total");
                let hardCombinationsUnlocked = $this.data("hard-combinations-unlocked");
                if (hardCombinationsTotal) {
                    $(".personality-hard-combinations-total").text(hardCombinationsTotal);
                    $(".personality-hard-combinations-unlocked").text(hardCombinationsUnlocked);
                    $(".combinations-count-divider").text("/");
                } else {
                    $(".personality-hard-combinations-total").text("");
                    $(".personality-hard-combinations-unlocked").text("");
                    $(".combinations-count-divider").text("");
                }
            } else if ($this.hasClass("personality-item")) {
                // Add selected option to gimmick display
                $(".personality-selected").text($this.text());
                $(".personality-item").each(function(i, e) {
                    if (!$(e).is($this)) $(e).removeClass("selected");
                });
            }
            // Hide default gimmick label
            $(".default-gimmick-label").hide();
        }
        // Update combination result
        $d3e44747ec383890$var$updateCombinationText();
        // Update gimmick name text
        $d3e44747ec383890$var$updateGimmickNameText();
    });
    // Add custom gimmick name
    $createGimmickContainer.on("input focus", ".gimmick-item-custom-name", function() {
        (0, $lCS03.playSoundEffect)("success");
        let $this = $(this);
        $d3e44747ec383890$var$allowGenerateGimmick = false;
        if ($this.val()) {
            $(".character-selected").hide();
            $(".personality-selected").hide();
            $(".default-gimmick-label").hide();
            $(".custom-gimmick-value").text($this.val());
        } else $d3e44747ec383890$var$updateGimmickNameText();
        // Update combination result
        $d3e44747ec383890$var$updateCombinationText();
    });
    // Gimmick item filter
    $createGimmickContainer.on("click", ".gimmick-item-filter", function() {
        let val = $(this).text().toLowerCase();
        let selected = $(this).hasClass("selected");
        if ($(this).hasClass("character-item-filter")) {
            // Unselect other options and select this one
            $(".character-item-filter").each(function() {
                $(this).removeClass("selected");
            });
            if (selected) // Select 'All'
            $(".character-item").show();
            else {
                // Select this filter
                $(".character-item").each(function(i, e) {
                    if ($(e).attr("data-tag") === val) $(e).show();
                    else $(e).hide();
                });
                $(this).addClass("selected");
            }
        } else if ($(this).hasClass("personality-item-filter")) {
            $(".personality-item-filter").each(function() {
                $(this).removeClass("selected");
            });
            if (selected) // Select 'All'
            $(".personality-item").show();
            else {
                // Select this filter
                $(".personality-item").each(function(i, e) {
                    if ($(e).attr("data-tag") === val) $(e).show();
                    else $(e).hide();
                });
                $(this).addClass("selected");
            }
        }
        $d3e44747ec383890$var$formatGimmickItemsGrid();
    });
    // Generate gimmick
    $createGimmickContainer.on("click", "#generate-gimmick-button", function() {
        if ($d3e44747ec383890$var$allowGenerateGimmick) {
            $d3e44747ec383890$var$generateGimmick();
            $d3e44747ec383890$var$allowGenerateGimmick = true;
        } else notie.confirm({
            text: "Are you sure?",
            submitCallback: function() {
                $d3e44747ec383890$var$generateGimmick();
                $d3e44747ec383890$var$allowGenerateGimmick = true;
            }
        });
    });
    // Back to roster member button
    $("#change-appearance-container, #create-gimmick-container").on("click", "#back-to-roster-member", function() {
        (0, $lCS03.playSoundEffect)("success");
        let graphic = $rosterMemberDetails.data("graphic");
        let match = $rosterMemberDetails.data("match");
        const $el = $(".roster-member-graphic");
        $el.html("");
        (0, $c82cd471f4baff6b$export$ca0cc0827d137f10)(graphic, $el, match);
        (0, $1JSre.hideContent)($());
        $rosterMemberDetails.fadeIn();
    });
    $("#change-alignment-container, #change-pronoun-container, #change-brand-container, #change-name-container").on("click", "#back-to-roster-member", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideContent)($());
        if ($(this).closest("[change-name-container]") && $("#change-name-container").data("type") === "faction") $(".faction-details-container").fadeIn("fast");
        else $rosterMemberDetails.fadeIn("fast");
    });
    // Change appearance option for edit gimmick/appearance
    const $changeAppearanceContainer = $("#change-appearance-container");
    $createGimmickContainer.on("change", 'input[name="radio-gimmick-appearance-option"]', function() {
        let val = $(this).val();
        if (val === "change") (0, $c82cd471f4baff6b$export$fe2486523999867a)($("#gimmick-graphic"));
        else {
            $("#gimmick-graphic").html("");
            $("#gimmick-graphic").next(".character-creator-controls").hide();
        }
    });
    $changeAppearanceContainer.on("change", 'input[name="radio-change-appearance-option"]', function() {
        let val = $(this).val();
        if (val === "change") (0, $c82cd471f4baff6b$export$fe2486523999867a)($("#change-appearance-graphic"));
        else {
            $("#change-appearance-graphic").html("");
            $("#change-appearance-graphic").next(".character-creator-controls").hide();
        }
    });
    // Create gimmick
    $createGimmickContainer.on("click", "#create-gimmick-button", async function() {
        if (!$(".character-selected").text() && !$(".personality-selected").text() && !$(".custom-gimmick-value").text()) {
            notie.alert({
                type: 3,
                text: "Select a Character and/or Personality or enter a Custom Gimmick.",
                stay: true
            });
            return false;
        }
        let character = $(".character-selected").text();
        let personality = $(".personality-selected").text();
        let customGimmickName = $(".custom-gimmick-value").text();
        let appearanceOption = $('input[name="radio-gimmick-appearance-option"]:checked').val();
        let uid = $("#gimmick-graphic").data("uid");
        let superstarName = $("#create-gimmick-container .change-name-input").val();
        let alignment = $("#create-gimmick-container .change-alignment-select").val();
        if (superstarName.length <= 0) {
            notie.alert({
                type: 3,
                text: "Enter a name for the Superstar.",
                stay: true
            });
            return false;
        }
        // Get graphic if 'change' Appearance selected
        let graphicData;
        if (appearanceOption === "change") {
            $("#create-gimmick-graphic-container .share-character").trigger("click").removeClass("selected");
            $("#create-gimmick-graphic-container .share-character-code-container").hide();
            graphicData = $("#create-gimmick-graphic-container .share-character-code-input").val();
        }
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.addSuperstarGimmick), {
            uid: uid,
            character: character,
            personality: personality,
            customGimmickName: customGimmickName,
            appearanceOption: appearanceOption,
            graphicData: graphicData,
            superstarName: superstarName,
            alignment: alignment
        }, $d3e44747ec383890$var$showAddGimmickData, {
            personality: personality,
            character: character
        }, false);
    });
    // Remove gimmick
    $createGimmickContainer.on("click", "#remove-gimmick-button", async function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                let uid = $("#roster-member-details").data("uid");
                await (0, $1JSre.makeGameRequest)((0, $jpMCP.removeSuperstarGimmick), {
                    uid: uid
                }, $d3e44747ec383890$var$showRemoveGimmickData, {}, false);
            }
        });
    });
    // Change name
    $("#change-name-container").on("click", "#change-name-button", async function() {
        const $changeNameContainer = $("#change-name-container");
        let name = $("#change-name-container .change-name-input").val();
        let uid = $changeNameContainer.data("uid");
        let type = $changeNameContainer.data("type");
        let memberName = type === "superstar" ? "Superstar" : "Team/Faction";
        if (name.length <= 0) {
            notie.alert({
                type: 3,
                text: "Enter a name for the {0}.".format(memberName),
                stay: true
            });
            return false;
        }
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.changeRosterMemberName), {
            uid: uid,
            type: type,
            name: name
        }, $d3e44747ec383890$var$showChangeNameData, {
            type: type,
            memberName: memberName
        }, false);
    });
    // Change appearance
    $changeAppearanceContainer.on("click", "#change-appearance-button", async function() {
        let appearanceOption = $('input[name="radio-change-appearance-option"]:checked').val();
        let uid = $("#change-appearance-graphic").data("uid");
        // Get graphic if 'change' Appearance selected
        let graphicData;
        if (appearanceOption === "change") {
            $("#change-appearance-graphic-container .share-character").trigger("click").removeClass("selected");
            $("#change-appearance-graphic-container .share-character-code-container").hide();
            graphicData = $("#change-appearance-graphic-container .share-character-code-input").val();
        }
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.changeSuperstarGraphic), {
            uid: uid,
            appearanceOption: appearanceOption,
            graphicData: graphicData
        }, $d3e44747ec383890$var$showChangeGraphicData, {
            appearanceOption: appearanceOption
        }, false);
    });
    // Change alignment
    $("#change-alignment-container").on("click", "#change-alignment-button", async function() {
        const $changeAlignmentContainer = $("#change-alignment-container");
        let alignment = $("#change-alignment-container .change-alignment-select").val();
        let uid = $changeAlignmentContainer.data("uid");
        let type = $changeAlignmentContainer.data("type");
        let memberName = type === "superstar" ? "Superstar" : "Team";
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.changeRosterMemberAlignment), {
            uid: uid,
            type: type,
            alignment: alignment
        }, $d3e44747ec383890$var$showChangeAlignmentData, {
            type: type,
            memberName: memberName
        }, false);
    });
    // Change pronoun
    $("#change-pronoun-container").on("click", "#change-pronoun-button", async function() {
        let pronoun = $("#change-pronoun-container .change-pronoun-select").val();
        let uid = $("#change-pronoun-container").data("uid");
        if (!pronoun) {
            notie.alert({
                type: 3,
                text: "Select a pronoun.",
                stay: true
            });
            return false;
        }
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.changeRosterMemberPronoun), {
            uid: uid,
            pronoun: pronoun
        }, $d3e44747ec383890$var$showChangePronounData, {}, false);
    });
    // Change brand
    $("#change-brand-container").on("click", "#change-brand-button", async function() {
        const $changeBrandContainer = $("#change-brand-container");
        let brandName = $("#change-brand-container .change-brand-select").val();
        let uid = $changeBrandContainer.data("uid");
        let type = $changeBrandContainer.data("type");
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.changeRosterMemberBrand), {
            uid: uid,
            type: type,
            brandName: brandName
        }, $d3e44747ec383890$var$showChangeBrandData, {}, false);
    });
    // Release talent
    $rosterMemberDetails.on("click", "#release-talent-button", async function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                let uid = $("#roster-member-details").data("uid");
                let type = $("#roster-member-details").data("type");
                let memberVerb = type === "superstar" ? "has" : "have";
                await (0, $1JSre.makeGameRequest)((0, $jpMCP.releaseTalent), {
                    uid: uid,
                    type: type
                }, $d3e44747ec383890$var$showReleaseTalentData, {
                    memberVerb: memberVerb
                }, false);
            }
        });
    });
    // Disband team
    $rosterMemberDetails.on("click", ".disband-team-button", async function(e) {
        let uid = $rosterMemberDetails.data("uid");
        if (!((0, $98xmD.globals).currentTutorialStep && (0, $98xmD.globals).currentTutorialStep["action"] === "disband_team")) notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                await (0, $1JSre.makeGameRequest)((0, $jpMCP.disbandTagTeam), {
                    uid: uid
                }, $d3e44747ec383890$var$showDisbandTagTeamData, {}, false);
            }
        });
        else await (0, $1JSre.makeGameRequest)((0, $jpMCP.disbandTagTeam), {
            uid: uid
        }, $d3e44747ec383890$var$showDisbandTagTeamData, {}, false);
    });
    // Train talent
    $rosterMemberDetails.on("click", "#train-talent-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        let rosterMemberName = $(".roster-member-name").text();
        await $d3e44747ec383890$export$eb0e5b221232766e(uid, type, rosterMemberName, "train");
    });
    // Prepare for callup
    $rosterMemberDetails.on("click", "#prepare-for-callup-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        let rosterMemberName = $(".roster-member-name").text();
        await $d3e44747ec383890$export$eb0e5b221232766e(uid, type, rosterMemberName, "prepare");
    });
    // Reassure talent
    $rosterMemberDetails.on("click", "#reassure-talent-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        let rosterMemberName = $(".roster-member-name").text();
        await $d3e44747ec383890$export$eb0e5b221232766e(uid, type, rosterMemberName, "reassure");
    });
    // Change talent role
    $rosterMemberDetails.on("click", "#transition-talent-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        let rosterMemberName = $(".roster-member-name").text();
        await $d3e44747ec383890$export$eb0e5b221232766e(uid, type, rosterMemberName, "transition");
    });
    // Rehab talent
    $rosterMemberDetails.on("click", "#rehab-talent-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        let rosterMemberName = $(".roster-member-name").text();
        await $d3e44747ec383890$export$eb0e5b221232766e(uid, type, rosterMemberName, "rehab");
    });
    // Unlearn trait
    $rosterMemberDetails.on("click", "#unlearn-talent-trait-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        let rosterMemberName = $(".roster-member-name").text();
        await $d3e44747ec383890$export$eb0e5b221232766e(uid, type, rosterMemberName, "unlearn trait");
    });
    // Transition to staff
    $rosterMemberDetails.on("click", "#transition-talent-to-staff-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        let rosterMemberName = $(".roster-member-name").text();
        await $d3e44747ec383890$export$eb0e5b221232766e(uid, type, rosterMemberName, "transition (staff)");
    });
    // Add manager relationship for talent
    $rosterMemberDetails.on("click", "#add-manager-relationship-for-talent-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        await $d3e44747ec383890$var$loadAddManagerRelationshipPage(uid);
    });
    // Remove manager relationship for talent
    $rosterMemberDetails.on("click", "#remove-manager-relationship-for-talent-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        await $d3e44747ec383890$var$loadRemoveManagerRelationshipPage(uid);
    });
    // Indie search handler
    $("#indie").on("input", ".indie-roster-search-input", function() {
        let searchTerm = $(this).val();
        $d3e44747ec383890$var$runIndieRosterSearch(searchTerm);
    });
    // Start negotiation
    $rosterMemberDetails.on("click", "#start-negotiation-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        await $d3e44747ec383890$var$loadStartNegotiationPage(uid, type);
    });
    // Change offer amount buttons
    let timeout, interval;
    [].forEach.call(document.querySelectorAll(".negotiation-box-offer-plus, .negotiation-box-offer-minus"), function(button) {
        button.addEventListener("mousedown", function() {
            if (button.classList.contains("negotiation-box-offer-plus")) {
                $d3e44747ec383890$var$incrementNegotiationOfferAmount();
                timeout = setTimeout(function() {
                    interval = setInterval(function() {
                        $d3e44747ec383890$var$incrementNegotiationOfferAmount();
                    }, 50);
                }, 300);
            } else {
                $d3e44747ec383890$var$decreaseNegotiationOfferAmount();
                timeout = setTimeout(function() {
                    interval = setInterval(function() {
                        $d3e44747ec383890$var$decreaseNegotiationOfferAmount();
                    }, 50);
                }, 300);
            }
        });
        button.addEventListener("mouseup", clearTimers);
        button.addEventListener("mouseleave", clearTimers);
        function clearTimers() {
            clearTimeout(timeout);
            clearInterval(interval);
        }
    });
    // Make negotiation offer
    const $negotiationBox = $(".negotiation-box");
    $negotiationBox.on("click", "#make-negotiation-offer", async function() {
        let uid = $negotiationBox.data("uid");
        let amount = parseInt($negotiationBox.find(".negotiation-box-offer-input").val());
        if (!amount) {
            notie.alert({
                type: 3,
                text: "Please enter an offer amount"
            });
            return false;
        }
        if (amount < 0) {
            notie.alert({
                type: 3,
                text: "Please enter an offer amount above 0"
            });
            return false;
        }
        if (amount > 3000) {
            notie.alert({
                type: 3,
                text: "Please enter an offer amount below 3000"
            });
            return false;
        }
        await $d3e44747ec383890$var$getMakeNegotiationOfferRequest(uid, amount);
    });
    // Go back to talent from negotiation
    $negotiationBox.on("click", ".negotiation-box-back-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        $negotiationBox.hide();
        $rosterMemberDetails.fadeIn();
        // Reload graphic
        const graphic = $rosterMemberDetails.data("graphic");
        const match = $rosterMemberDetails.data("match");
        const $el = $(".roster-member-graphic");
        $el.html("");
        (0, $c82cd471f4baff6b$export$ca0cc0827d137f10)(graphic, $el, match);
    });
    // Send to main roster button
    $negotiationBox.on("click", "#negotiation-send-to-main-roster-button", async function() {
        let uid = $negotiationBox.data("uid");
        await $d3e44747ec383890$var$getNegotiationSendToMainRosterRequest(uid);
    });
    // Scout talent button
    $rosterMemberDetails.on("click", "#scout-talent-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        let rosterMemberName = $(".roster-member-name").text();
        await $d3e44747ec383890$export$eb0e5b221232766e(uid, type, rosterMemberName, "scout");
    });
    // Recruit talent button
    $rosterMemberDetails.on("click", "#recruit-talent-button", async function() {
        let uid = $rosterMemberDetails.data("uid");
        let type = $rosterMemberDetails.data("type");
        let rosterMemberName = $(".roster-member-name").text();
        await $d3e44747ec383890$export$eb0e5b221232766e(uid, type, rosterMemberName, "recruit");
    });
    // Add staff task button
    const $addStaffTaskContainer = $("#add-staff-task-container");
    $addStaffTaskContainer.on("click", ".add-staff-task-button", async function() {
        let staffUid = parseInt($addStaffTaskContainer.find(".add-staff-task-staff-select").find(":selected").val());
        let talentUid = $addStaffTaskContainer.data("talentUid");
        let talentType = $addStaffTaskContainer.data("talentType");
        let taskName = $addStaffTaskContainer.data("task");
        let skillName = $addStaffTaskContainer.find(".add-staff-task-skill-select").find(":selected").val();
        let traitName = $addStaffTaskContainer.find(".add-staff-task-trait-select").find(":selected").val();
        let roleName = $addStaffTaskContainer.find(".add-staff-task-role-select").find(":selected").val();
        await $d3e44747ec383890$var$getAddStaffTaskRequest(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName);
    });
    // Add staff task back button
    $addStaffTaskContainer.on("click", ".add-staff-task-back-button", function() {
        (0, $1JSre.hideContent)($());
        if ($("#add-staff-task-container").data("talentType") === "staff") $(".staff-member-details").fadeIn("slow");
        else $("#roster-member-details").fadeIn("slow");
    });
    // View teams company select handler
    const $viewTeamsContainer = $("#view-teams-container");
    $viewTeamsContainer.on("change", ".view-teams-company-select", async function() {
        let companyUid = parseInt($(this).find(":selected").attr("data-uid"));
        await $d3e44747ec383890$export$7c983fe739d97452(companyUid);
    });
    // Team click handler
    $viewTeamsContainer.on("click", ".view-teams-item", async function() {
        if ($(this).hasClass("disabled")) return false;
        let memberUid = parseInt($(this).attr("data-uid"));
        let memberType = "tagTeam";
        let competitorUid = parseInt($(".view-teams-company-select").find(":selected[data-is-competitor]").attr("data-uid"));
        await $d3e44747ec383890$export$8777720a6e173e8e(memberUid, memberType, competitorUid, "#view-teams-container");
    });
    // Add team menu button
    $viewTeamsContainer.on("click", "#add-team-menu-button", async function() {
        await $d3e44747ec383890$var$loadAddTeamPage();
    });
    $game.on("change", 'select[name="tag-team-type-option"]', function() {
        let val = $(this).val();
        if (val === "trio") $(this).parent().parent().find(".add-team-third-superstar-select").parent().removeClass("display-none");
        else $(this).parent().parent().find(".add-team-third-superstar-select").parent().addClass("display-none");
    });
    // Add team
    $("#add-team").on("click", "#add-team-button", async function() {
        await $d3e44747ec383890$var$getAddTeamRequest();
    });
    // Add team tutorial step checks
    $(".add-team-first-superstar-select").on("change", function() {
        if ($(this).val() === "Brandon Gray") (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_team_first_superstar");
    });
    $(".add-team-second-superstar-select").on("change", function() {
        if ($(this).val() === "Benjamin Dread") (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_team_second_superstar");
    });
    // Go back to view teams
    $game.on("click", ".back-to-view-teams-button", function() {
        $(".view-teams-company-select").trigger("change");
    });
    // View managers company select handler
    const $viewManagersContainer = $("#view-managers-container");
    $viewManagersContainer.on("change", ".view-managers-company-select", async function() {
        let companyUid = parseInt($(this).find(":selected").attr("data-uid"));
        await $d3e44747ec383890$export$19fc0b31850b3e21(companyUid);
    });
    // Manager click handler
    $viewManagersContainer.on("click", ".view-managers-item", async function() {
        if ($(this).hasClass("disabled")) return false;
        let memberUid = parseInt($(this).attr("data-uid"));
        let memberType = "superstar";
        let competitorUid = parseInt($(".view-managers-company-select").find(":selected[data-is-competitor]").attr("data-uid"));
        await $d3e44747ec383890$export$8777720a6e173e8e(memberUid, memberType, competitorUid, "#view-managers-container");
    });
    // Show 'add manager relationship' page
    $viewManagersContainer.on("click", ".add-manager-relationship-menu-button", async function() {
        await $d3e44747ec383890$var$loadAddManagerRelationshipPage();
    });
    // Show 'remove manager relationship' page
    $viewManagersContainer.on("click", ".remove-manager-relationship-menu-button", async function() {
        await $d3e44747ec383890$var$loadRemoveManagerRelationshipPage();
    });
    // Add talent select for 'add/remove manager relationship' page
    const $addManagerRelationshipAndRemoveManagerRelationship = $("#add-manager-relationship, #remove-manager-relationship");
    $addManagerRelationshipAndRemoveManagerRelationship.on("click", ".manager-relationship-add-talent-select-button", function() {
        // Get existing talent selects
        let parentBox = $(this).closest(".box");
        let talentSelects = parentBox.find('select[name="talent-select"]');
        // Check for maximum talent selects
        if (talentSelects.length >= 15) {
            notie.alert({
                type: 3,
                text: "You cannot select more than 15 talent to manage"
            });
            return false;
        }
        // Clone talent select, add remove button
        let talentSelectHtml = "<div>" + talentSelects.eq(0).clone().prop("outerHTML") + '<button type="button" class="manager-relationship-remove-talent-select-button button retro-button styled-select-button font-bold margin-left-6">' + '<i class="fa fa-minus"></i>' + "</button></div>";
        // Add talent select after last one
        talentSelects.last().parent().after(talentSelectHtml);
    });
    // Remove talent select for 'add manager relationship' page
    $addManagerRelationshipAndRemoveManagerRelationship.on("click", ".manager-relationship-remove-talent-select-button", function() {
        $(this).parent().remove();
    });
    // Add manager relationship
    $("#add-manager-relationship").on("click", "#add-manager-relationship-button", async function() {
        await $d3e44747ec383890$var$getAddManagerRelationshipRequest();
    });
    // Remove manager relationship
    $("#remove-manager-relationship").on("click", "#remove-manager-relationship-button", async function() {
        await $d3e44747ec383890$var$getRemoveManagerRelationshipRequest();
    });
    // Go back to view managers
    $game.on("click", ".back-to-view-managers-button", function() {
        $(".view-managers-company-select").trigger("change");
    });
    // Make trade offer competitor select handler
    const $tradeOfferContainer = $(".trade-offer-container");
    $tradeOfferContainer.on("change", ".trade-offer-competitor-select", function() {
        (0, $af8d9de467381f29$export$2df10f3dcd3975b4)($(this));
    });
    // Get available trade superstars
    $tradeOfferContainer.on("click", ".trade-offer-superstar-item", async function() {
        let parent = $(".trade-offer-container");
        // Select company and superstar slot
        parent.find(".trade-offer-superstar-item").removeClass("current-selection");
        $(this).addClass("current-selection");
        parent.find(".trade-offer-superstars-container").removeClass("current-selection");
        $(this).closest(".trade-offer-superstars-container").addClass("current-selection");
        // Load available superstars
        let companyUid = parseInt($(this).closest(".trade-offer-company-container").attr("data-company-uid"));
        await (0, $af8d9de467381f29$export$7311d400be939671)(companyUid);
    });
    // Show superstar info when clicking on available trade superstar
    $tradeOfferContainer.on("click", ".trade-offer-available-superstar-item", async function() {
        if ($(this).hasClass("disabled")) return false;
        let uid = parseInt($(this).attr("data-uid"));
        $(".trade-offer-container").find(".trade-offer-available-superstar-item").removeClass("selected");
        $(this).addClass("selected");
        await (0, $af8d9de467381f29$export$2425462df21708bb)(uid);
    });
    // Select available trade superstar
    $tradeOfferContainer.on("click", ".select-trade-superstar-button", function() {
        let parent = $(".trade-offer-container");
        // Get selected superstar
        let selectedSuperstar = $(".trade-offer-available-superstar-item.selected");
        if (selectedSuperstar.length <= 0) {
            notie.alert({
                type: 3,
                text: "Please select a superstar"
            });
            return false;
        }
        // Check if superstar already added
        let selectedSuperstarUid = selectedSuperstar.attr("data-uid");
        let superstarsContainer = parent.find(".trade-offer-superstars-container.current-selection");
        let superstarElement = superstarsContainer.find('.trade-offer-superstar-item[data-uid="' + selectedSuperstarUid + '"]');
        if (superstarElement.length > 0) {
            notie.alert({
                type: 3,
                text: "That superstar has already been selected"
            });
            return false;
        }
        // Check if superstar is eligible
        if (selectedSuperstar.attr("data-is-champion") === "true") {
            notie.alert({
                type: 3,
                text: "Champions cannot be traded"
            });
            return false;
        }
        if (selectedSuperstar.attr("data-on-trade-deal") === "true") {
            notie.alert({
                type: 3,
                text: "Superstars already on trade deals cannot be traded"
            });
            return false;
        }
        if (selectedSuperstar.attr("data-contract-months-remaining") !== "null") {
            notie.alert({
                type: 3,
                text: "Superstars leaving the company cannot be traded"
            });
            return false;
        }
        if (selectedSuperstar.attr("data-booked") === "true") {
            notie.alert({
                type: 3,
                text: "Superstars already booked for the next event cannot be traded"
            });
            return false;
        }
        if (selectedSuperstar.attr("data-part-of-trade-offer") === "true") {
            notie.alert({
                type: 3,
                text: "That superstar is already involved in a trade offer"
            });
            return false;
        }
        if (selectedSuperstar.attr("data-is-owner") === "true") {
            notie.alert({
                type: 3,
                text: "Owners cannot be traded"
            });
            return false;
        }
        if (selectedSuperstar.attr("data-pow-star") === "true") {
            notie.alert({
                type: 3,
                text: '"You can\'t trade that talent away!" - Hank Hughes'
            });
            return false;
        }
        // Get slot to add superstar to. Select first empty slot if empty slot clicked.
        let superstarName = selectedSuperstar.find(".trade-offer-available-superstar-name").text();
        let superstarSlot = superstarsContainer.find(".trade-offer-superstar-item.current-selection");
        if (!superstarSlot.attr("data-uid")) superstarSlot = superstarsContainer.find(".trade-offer-superstar-item:not([data-uid])").eq(0);
        // Add superstar to slot
        superstarSlot.text(superstarName);
        superstarSlot.attr("data-uid", selectedSuperstarUid);
        superstarSlot.removeClass("light-grey");
        (0, $af8d9de467381f29$export$b6c23020a997d324)();
    });
    // Remove trade superstar
    $tradeOfferContainer.on("click", ".remove-trade-superstar-button", function() {
        let parent = $(".trade-offer-container");
        // Reset slot
        let superstarsContainer = parent.find(".trade-offer-superstars-container.current-selection");
        let selectedSlot = superstarsContainer.find(".trade-offer-superstar-item.current-selection");
        selectedSlot.text("Empty");
        selectedSlot.removeAttr("data-uid");
        selectedSlot.addClass("light-grey");
        (0, $af8d9de467381f29$export$b6c23020a997d324)();
    });
    // Make trade offer
    $tradeOfferContainer.on("click", ".make-trade-offer-button", async function() {
        let offeredSuperstarsUids = [];
        let requestedSuperstarsUids = [];
        let $tradeOfferContainer = $(".trade-offer-container");
        $tradeOfferContainer.find(".trade-offer-offered-superstar").each(function(i, e) {
            let offeredSuperstarUid = parseInt($(e).attr("data-uid"));
            if (offeredSuperstarUid) offeredSuperstarsUids.push(offeredSuperstarUid);
        });
        $tradeOfferContainer.find(".trade-offer-requested-superstar").each(function(i, e) {
            let requestedSuperstarUid = parseInt($(e).attr("data-uid"));
            if (requestedSuperstarUid) requestedSuperstarsUids.push(requestedSuperstarUid);
        });
        // Validate
        if (offeredSuperstarsUids.length <= 0 || requestedSuperstarsUids.length <= 0) {
            notie.alert({
                type: 3,
                text: "Please select at least 1 superstar to trade from each company"
            });
            return false;
        }
        let duration = parseInt($tradeOfferContainer.find(".trade-offer-duration-select").val());
        let companyUid = parseInt($tradeOfferContainer.find(".trade-offer-receiver-company").attr("data-company-uid"));
        await (0, $af8d9de467381f29$export$4578822934507e29)(offeredSuperstarsUids, requestedSuperstarsUids, duration, companyUid);
    });
    // Back to trade offer
    $tradeOfferContainer.on("click", ".trade-offer-back-button", function() {
        (0, $af8d9de467381f29$export$b6c23020a997d324)();
    });
    // Trade search
    $tradeOfferContainer.on("input", ".trade-offer-search-input", function() {
        (0, $af8d9de467381f29$export$a91e79c047f9c925)();
    });
    // Roster rankings company/period select handler
    const $rosterRankingsContainer = $("#roster-rankings-container");
    $rosterRankingsContainer.off("change", ".select-company-for-roster-rankings, .roster-rankings-period-select");
    $rosterRankingsContainer.on("change", ".select-company-for-roster-rankings, .roster-rankings-period-select", async function() {
        let companyUid = parseInt($(".select-company-for-roster-rankings").find(":selected").attr("data-uid"));
        let period = $(".roster-rankings-period-select").val();
        await $d3e44747ec383890$export$4077c55c538d9414(companyUid, period);
    });
    // Roster rankings filter handler
    $rosterRankingsContainer.on("click", ".roster-rankings-filter", function() {
        let parent = $(this).parent();
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else {
            parent.find(".roster-rankings-filter").removeClass("selected");
            $(this).addClass("selected");
        }
        $d3e44747ec383890$var$applyRosterRankingsFilter();
    });
    // View brands company select handler
    const $viewBrandsContainer = $("#view-brands-container");
    $viewBrandsContainer.on("change", ".view-brands-company-select", async function() {
        let companyUid = parseInt($(this).find(":selected").attr("data-uid"));
        await (0, $99c29f4521d84bf4$export$17bf265a32fa820)(companyUid);
    });
    // Show add brand info container
    $viewBrandsContainer.on("click", ".add-brand-menu-button", function() {
        // Check for story
        if ((0, $98xmD.globals).game.story === "passion" || (0, $98xmD.globals).game.story === "mars") {
            notie.alert({
                type: 3,
                text: "You cannot add Brands in this story"
            });
            return false;
        }
        // Check for max brands
        if ($("#view-brands-container").find(".view-brands-item").length >= 3) {
            notie.alert({
                type: 3,
                text: "You cannot have more than 3 brands."
            });
            return false;
        }
        // Show add brand info
        (0, $1JSre.hideContent)($());
        $(".add-brand-info-container").hide().fadeIn();
    });
    // Show add brand page
    $(".add-brand-info-container").on("click", ".continue-to-add-brand-button", async function() {
        await (0, $99c29f4521d84bf4$export$3efe03d5175b2d15)();
    });
    // Select add brand superstars/championships/events
    const $addBrandContainer = $(".add-brand-container");
    $addBrandContainer.on("click", ".brand-selection-item", function() {
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else $(this).addClass("selected");
        if ($(this).parent().hasClass("add-brand-selection-superstars")) {
            // Update superstars selected
            let brandSuperstarsSelected = $(this).parent().find(".brand-selection-item.selected");
            let selectedNames = Array.from(brandSuperstarsSelected, function(el) {
                return $(el).find(".brand-selection-item-name").text();
            });
            let superstarsSelected = selectedNames.length > 0 ? (0, $3E8Nt.commaSeparate)(selectedNames) : "";
            $(".add-brand-selection-superstars-selected").text(superstarsSelected);
        }
    });
    // Add brand superstar search
    $addBrandContainer.on("input", ".add-brand-superstar-search-input", function() {
        (0, $99c29f4521d84bf4$export$ed37bb4ebca58880)();
    });
    // Show brand name preview
    $(".add-brand-name").on("input", function() {
        $(".add-brand-preview").text($(this).val());
    });
    // Change brand name preview color
    $(".add-brand-color").on("move.spectrum change", function(e, tinycolor) {
        let brandColor = tinycolor ? tinycolor.toHexString() : "";
        $(".add-brand-color").val(brandColor);
        $(".add-brand-preview").css("color", brandColor);
    });
    // Add brand button
    $addBrandContainer.on("click", ".add-brand-button", async function() {
        await (0, $99c29f4521d84bf4$export$b87445d6d5ea80c7)();
    });
    // Edit brand button
    $addBrandContainer.on("click", ".edit-brand-button", async function() {
        await (0, $99c29f4521d84bf4$export$b87445d6d5ea80c7)(true);
    });
    // Show run draft page
    $viewBrandsContainer.on("click", ".run-brand-draft-menu-button", async function() {
        await (0, $99c29f4521d84bf4$export$1b6578d49f70d4cf)();
    });
    // Show yearly draft page
    $viewBrandsContainer.on("click", ".yearly-brand-draft-menu-button", async function() {
        await (0, $99c29f4521d84bf4$export$83ceeba364ecf5bd)();
    });
    // Run brand draft
    const $runBrandDraftContainer = $(".run-brand-draft-container");
    $runBrandDraftContainer.on("click", ".run-brand-draft-button", async function() {
        await (0, $99c29f4521d84bf4$export$52c82543a30b1bd7)();
    });
    // Save yearly brand draft settings
    const $yearlyBrandDraftContainer = $(".yearly-brand-draft-container");
    $yearlyBrandDraftContainer.on("click", ".yearly-brand-draft-save-button", async function() {
        await (0, $99c29f4521d84bf4$export$4d71feeedf5feac7)();
    });
    // Change draft cost based on type
    $runBrandDraftContainer.on("click", 'input[type="radio"][name="run-brand-draft-type-option"]', function() {
        let value = $(this).val();
        let cost;
        if (value === "full") cost = 100;
        else if (value === "shuffle") cost = 50;
        $(".run-brand-draft-cost").text(cost);
    });
    // Change draft info based on draft type
    $(".run-brand-draft-container, .yearly-brand-draft-container").on("click", 'input[type="radio"][name="run-brand-draft-type-option"], input[type="radio"][name="yearly-brand-draft-type-option"]', function() {
        let value = $(this).val();
        if (value === "full") $(this).parent().siblings(".brand-draft-info").find(".brand-draft-info-content").text("A Full Draft removes all superstars from their current brands. It also resets each brand's overness.");
        else if (value === "shuffle") $(this).parent().siblings(".brand-draft-info").find(".brand-draft-info-content").text("A Brand Shuffle lets you move superstars between brands and keeps the remaining superstars on their current brands.");
    });
    // Show/hide yearly draft options
    $yearlyBrandDraftContainer.on("click", 'input[value="run_yearly_draft"]', function() {
        let value = $(this).prop("checked");
        if (value) $(".yearly-brand-draft-options-container").show();
        else $(".yearly-brand-draft-options-container").hide();
    });
    // Select brands for draft
    $(".run-brand-draft-container, .yearly-brand-draft-container").on("click", ".brand-selection-item", function() {
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else $(this).addClass("selected");
    });
    // Remove brand
    $(".brand-details-container").on("click", ".remove-brand-button", async function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                let brandUid = $(".brand-details-container").data("brandUid");
                await (0, $99c29f4521d84bf4$export$8bb7271bd6c2936)(brandUid);
            }
        });
    });
    // Go back to view brands
    $game.on("click", ".back-to-view-brands-button", function() {
        (0, $1JSre.hideContent)($());
        $("#view-brands-container").fadeIn("slow");
    });
    // Go back to brand details
    $game.on("click", ".back-to-brand-details-button", function() {
        (0, $1JSre.hideContent)($());
        $(".brand-details-container").fadeIn("slow");
    });
    const $viewFactionsContainer = $("#view-factions-container");
    const $factionsDetailsContainer = $(".faction-details-container");
    // View factions company select handler
    $viewFactionsContainer.on("change", ".view-factions-company-select", async function() {
        let companyUid = parseInt($(this).find(":selected").attr("data-uid"));
        await $d3e44747ec383890$export$818d6af52bedd640(companyUid);
    });
    // Back to view factions button
    $game.on("click", ".back-to-view-factions-button", function() {
        // Go back to booking page
        if ($factionsDetailsContainer.data("element") === "#booking-container") {
            if ($("#book-tag-team-menu-button").hasClass("selected")) $(".tag-match-options").find(".selected").trigger("click");
            else $("#booking-menu").find(".selected").trigger("click");
        } else $(".view-factions-company-select").trigger("change");
    });
    // Add faction page
    $viewFactionsContainer.on("click", ".add-faction-menu-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$241c76ae49f3fa40)();
    });
    // Update faction leader select
    $(".add-faction-container, #segment-items-container").on("change", ".select-faction-member", function() {
        if ($(this).closest(".add-faction-container").length > 0) (0, $9c7fdb096dd8e19a$export$25d3e1524ca4231d)($(".add-faction-container"));
        if ($(this).closest('.segment-item-container[data-consequence="create-faction"]').length > 0) (0, $9c7fdb096dd8e19a$export$25d3e1524ca4231d)($(this).closest('.segment-item-container[data-consequence="create-faction"]'));
    });
    // Add faction member selects
    const $factionContainers = $(".add-faction-members-container, .remove-faction-members-container, .add-faction-container, #segment-items-container");
    $factionContainers.on("click", ".add-faction-member-select-button", function() {
        // Get existing faction member selects
        let parentBox = $(this).closest(".box, .segment-item-container");
        let factionMemberSelects = parentBox.find(".select-faction-member");
        // Check for maximum faction member selects
        if (factionMemberSelects.length >= (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
            notie.alert({
                type: 3,
                text: `You cannot select more than ${(0, $3E8Nt.gameLimits).maxFactionSuperstars} faction members`
            });
            return false;
        }
        // Clone faction member select, add remove button
        let factionMemberSelectHtml = '<div class="margin-bottom-6">' + factionMemberSelects.eq(0).clone().prop("outerHTML") + '<button type="button" class="remove-faction-member-select-button button retro-button styled-select-button font-bold margin-left-6">' + '<i class="fa fa-minus"></i>' + "</button></div>";
        // Add faction member select after last one
        factionMemberSelects.last().parent().after(factionMemberSelectHtml);
        // Update faction leader select
        if ($(this).closest(".add-faction-container").length > 0) (0, $9c7fdb096dd8e19a$export$25d3e1524ca4231d)($(".add-faction-container"));
        if ($(this).closest('.segment-item-container[data-consequence="create-faction"]').length > 0) (0, $9c7fdb096dd8e19a$export$25d3e1524ca4231d)($(this).closest('.segment-item-container[data-consequence="create-faction"]'));
    });
    // Remove faction member selects
    $factionContainers.on("click", ".remove-faction-member-select-button", function() {
        let addFactionContainerParent = $(this).closest(".add-faction-container");
        let segmentItemContainerParent = $(this).closest('.segment-item-container[data-consequence="create-faction"]');
        $(this).parent().remove();
        // Update faction leader select
        if (addFactionContainerParent.length > 0) (0, $9c7fdb096dd8e19a$export$25d3e1524ca4231d)(addFactionContainerParent);
        if (segmentItemContainerParent.length > 0) (0, $9c7fdb096dd8e19a$export$25d3e1524ca4231d)(segmentItemContainerParent);
    });
    // Add faction
    $(".add-faction-container").on("click", ".add-faction-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$2aafbbea3509d6f4)();
    });
    // Disband faction
    $factionsDetailsContainer.on("click", ".disband-faction-button", async function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                await (0, $9c7fdb096dd8e19a$export$29c5871aa73736ca)();
            }
        });
    });
    // Add faction members page
    $factionsDetailsContainer.on("click", ".add-faction-members-menu-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$5b36f1fda16fa6c1)();
    });
    // Add faction members
    $(".add-faction-members-container").on("click", ".add-faction-members-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$c65f4d09e390ecce)();
    });
    // Remove faction members page
    $factionsDetailsContainer.on("click", ".remove-faction-members-menu-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$21bf19b4e900627a)();
    });
    // Remove faction members
    $(".remove-faction-members-container").on("click", ".remove-faction-members-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$1dc83bfa1359e058)();
    });
    // Remove faction leader
    $factionsDetailsContainer.on("click", ".remove-faction-leader-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$2b4e8c92e9a9222c)();
    });
    // Set faction leader page
    $factionsDetailsContainer.on("click", ".set-faction-leader-menu-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$412a54151b429031)();
    });
    // Set faction leader
    $(".set-faction-leader-container").on("click", ".set-faction-leader-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$732fd4d36a9453b0)();
    });
    // Change faction name page
    $factionsDetailsContainer.on("click", ".change-faction-name-button", async function() {
        await (0, $9c7fdb096dd8e19a$export$2c66b191d8ddd09)();
    });
    // Back to faction details button
    $game.on("click", ".back-to-faction-details-button", function() {
        (0, $1JSre.hideContent)($());
        $(".faction-details-container").fadeIn("fast");
    });
});
async function $d3e44747ec383890$export$9595013ad42e288e(companyUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view roster data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewRosterData = await (0, $jpMCP.getViewRosterData)(companyUid);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) companySelectData = await (0, $8A6FL.getCompanySelectData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show company select
    if (!companyUid) $d3e44747ec383890$export$4e74726e57dcef35(companySelectData, $(".select-company-for-view-roster"));
    // Show view roster data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showViewRosterPageData(viewRosterData, companyUid);
}
function $d3e44747ec383890$var$showViewRosterPageData(data, companyUid) {
    let rosterMembersContainer = $(".roster-members-container");
    let rosterSearchContainer = $(".roster-search-container");
    // Reset ui
    rosterMembersContainer.html("").hide();
    rosterSearchContainer.html("").hide();
    // Add headers
    $d3e44747ec383890$var$addViewRosterPageHeaders($d3e44747ec383890$var$headerClasses, rosterMembersContainer);
    // Add sections
    $d3e44747ec383890$var$addViewRosterPageChampionships(data["championships"], rosterMembersContainer);
    $d3e44747ec383890$var$addViewRosterPageMainRosterSuperstars(data["superstars"], $d3e44747ec383890$var$headerClasses);
    $d3e44747ec383890$var$addViewRosterPageManagers(data["managers"]);
    $d3e44747ec383890$var$addViewRosterPageTagTeams(data["tagTeams"], $d3e44747ec383890$var$headerClasses);
    $d3e44747ec383890$var$addViewRosterPageTrainingSuperstars(data["trainingSuperstars"]);
    $d3e44747ec383890$var$addViewRosterPageRetiredSuperstars(data["retiredSuperstars"]);
    $d3e44747ec383890$var$addViewRosterPageDeadSuperstars(data["deadSuperstars"]);
    // Add default order
    $(".roster-members-container").find(".roster-member, .future-superstar, .superstar-select-champion").each(function(i, e) {
        $(e).attr("data-default-order", i);
    });
    // Show roster size
    let rosterSizeClass = "";
    if (data["rosterSize"] > data["rosterCapacity"]) rosterSizeClass = "light-red";
    else if (data["rosterSize"] === data["rosterCapacity"]) rosterSizeClass = "dark-yellow";
    else rosterSizeClass = "light-green";
    $(".roster-size-container").removeClass("light-red dark-yellow light-green").addClass(rosterSizeClass).html('<span class="roster-size-number">' + data["rosterSize"] + "</span>" + "/" + data["rosterCapacity"]);
    // Add custom brand filters
    $(".view-roster-filter.brand-filter").remove();
    let rosterFilterNoBrand = $('.view-roster-filter[data-value="no-brand"]');
    if (data["brandNames"].length > 0) {
        data["brandNames"].forEach(function(rosterBrandName) {
            let rosterBrandFilterHtml = '<button type="button" class="view-roster-filter brand-filter button retro-button condensed light-button-background" data-value="custom-brand" data-brand-name="' + rosterBrandName.replace(/"/g, "&quot;") + '">' + rosterBrandName + "</button> ";
            rosterFilterNoBrand.before(rosterBrandFilterHtml);
        });
        rosterFilterNoBrand.show();
    } else rosterFilterNoBrand.hide();
    // Reset search, select dropdown, filters
    $(".roster-search-input").val("");
    $(".roster-section-select").val("Champions");
    $(".view-roster-filter").removeClass("selected");
    $('.view-roster-filter:contains("All")').addClass("selected");
    // Show roster container
    rosterMembersContainer.show();
    $("#roster-container").fadeIn("slow").removeClass("display-none");
    rosterMembersContainer.scrollTop(0);
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_roster");
    if (companyUid) setTimeout(function() {
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_view_roster_company");
    }, 100);
}
function $d3e44747ec383890$var$addViewRosterPageHeaders(headerClasses, rosterMembersContainer) {
    for (const [index, header] of Object.keys(headerClasses).entries()){
        let headerClass = headerClasses[header];
        let marginTop = index === 0 ? "" : "margin-top-25 ";
        rosterMembersContainer.append('<div class="margin-bottom-15 font-bold ' + marginTop + headerClass + '">' + '<div class="light-grey margin-bottom-7">' + header + "</div>" + "</div>");
    }
}
function $d3e44747ec383890$var$addViewRosterPageChampionships(championshipsData, rosterMembersContainer) {
    let championshipsSelector = rosterMembersContainer.find(".roster-champions");
    championshipsData.forEach(function(item) {
        let championHtml = $d3e44747ec383890$var$getRosterChampionshipHtml(item);
        championshipsSelector.append(championHtml);
    });
    $d3e44747ec383890$var$checkAndAddRosterSectionNoneText(championshipsData, championshipsSelector);
}
function $d3e44747ec383890$var$addViewRosterPageMainRosterSuperstars(superstarsData, headerClasses) {
    // Add superstars to respective sections
    for (const rank of [
        "Main Eventer",
        "Upper Midcarder",
        "Lower Midcarder",
        "Jabroni"
    ]){
        const rankClass = headerClasses[rank + "s"];
        const rankElement = $("." + rankClass);
        let rankSuperstars = superstarsData.filter((x)=>x.rank === rank);
        let rankHtml = "";
        rankSuperstars.forEach(function(superstar) {
            rankHtml += $d3e44747ec383890$var$getRosterSuperstarHtml(superstar, rankClass);
        });
        rankElement.append(rankHtml);
        $d3e44747ec383890$var$checkAndAddRosterSectionNoneText(rankSuperstars, rankElement);
    }
}
function $d3e44747ec383890$var$addViewRosterPageManagers(managersData) {
    let managersSelector = $(".roster-managers");
    managersData.forEach(function(superstar) {
        let managerHtml = $d3e44747ec383890$var$getRosterSuperstarHtml(superstar, "roster-managers");
        managersSelector.append(managerHtml);
    });
    $d3e44747ec383890$var$checkAndAddRosterSectionNoneText(managersData, managersSelector);
}
function $d3e44747ec383890$var$addViewRosterPageTagTeams(tagTeamsData, headerClasses) {
    // Add tag teams and trios
    for (const section of [
        "Tag Teams",
        "Trios"
    ]){
        const sectionClass = headerClasses[section];
        const sectionElement = $("." + sectionClass);
        let sectionItems = tagTeamsData.filter((x)=>{
            return section === "Tag Teams" ? !x.trio : x.trio;
        });
        sectionItems.forEach(function(sectionItem) {
            sectionElement.append('<div class="margin-bottom-7"><span data-type="tagTeam" data-container="' + sectionClass + '"' + ' data-uid="' + sectionItem["uid"] + '" class="col1 roster-member opacity-hover">' + sectionItem["name"] + "</span>" + '<span class="col2 grey">' + sectionItem["superstars"].join(" - ") + "</span></div>");
        });
        $d3e44747ec383890$var$checkAndAddRosterSectionNoneText(sectionItems, sectionElement);
    }
}
function $d3e44747ec383890$var$addViewRosterPageTrainingSuperstars(trainingSuperstarsData) {
    let trainingSelector = $(".roster-training");
    // Sort by future superstars last
    trainingSuperstarsData.sort((a, b)=>{
        return a.future - b.future || a.yearToAppearIn - b.yearToAppearIn;
    });
    trainingSuperstarsData.forEach(function(superstar) {
        let superstarClass = "";
        let information = "";
        let rosterMemberClass = " roster-member opacity-hover";
        if (superstar["future"]) {
            superstarClass = " grey";
            information = `Future Superstar (Year ${superstar["yearToAppearIn"]})`;
            rosterMemberClass = " future-superstar";
        }
        trainingSelector.append('<div class="margin-bottom-7"><span data-container="roster-training" data-type="training-superstar" data-uid="' + superstar["uid"] + '"' + ' class="col1 ' + rosterMemberClass + superstarClass + '">' + superstar["name"] + "</span>" + '<span class="col2 grey">' + information + "</span>" + "</div>");
    });
    $d3e44747ec383890$var$checkAndAddRosterSectionNoneText(trainingSuperstarsData, trainingSelector);
}
function $d3e44747ec383890$var$addViewRosterPageRetiredSuperstars(retiredSuperstarsData) {
    let retiredSelector = $(".roster-retired");
    retiredSuperstarsData.forEach(function(superstar) {
        let hallOfFamer = "";
        if (superstar["hallOfFamer"]) hallOfFamer = '<span class="gold margin-right-5">Hall of Famer</span>';
        let inTrainingRoster = "";
        if (superstar["inTrainingRoster"]) inTrainingRoster = '<span class="grey">(Training)</span>';
        retiredSelector.append('<div class="margin-bottom-7"><span data-type="superstar" data-container="roster-retired" data-uid="' + superstar["uid"] + '" class="col1 roster-member opacity-hover">' + superstar["name"] + "</span>" + '<span class="col2">' + hallOfFamer + inTrainingRoster + "</span>" + "</div>");
    });
    $d3e44747ec383890$var$checkAndAddRosterSectionNoneText(retiredSuperstarsData, retiredSelector);
}
function $d3e44747ec383890$var$addViewRosterPageDeadSuperstars(deadSuperstarsData) {
    let deadSelector = $(".roster-dead");
    deadSuperstarsData.forEach(function(superstar) {
        deadSelector.append('<div class="margin-bottom-7"><span data-type="superstar" data-container="roster-dead" data-uid="' + superstar["uid"] + '" class="col1 roster-member opacity-hover">' + superstar["name"] + "</span>" + "</div>");
    });
    $d3e44747ec383890$var$checkAndAddRosterSectionNoneText(deadSuperstarsData, deadSelector);
}
function $d3e44747ec383890$var$checkAndAddRosterSectionNoneText(items, element) {
    if (items.length <= 0) element.append('<span class="col1 margin-bottom-5 high-light-grey">None</span>');
}
function $d3e44747ec383890$var$getRosterSuperstarHtml(superstar, dataContainerName) {
    // Define variables
    let injuredText = null;
    let suspendedText = null;
    let appearanceText = null;
    let unhappyText = null;
    let faceOfTheCompanyText = null;
    let name = superstar["name"];
    // Fotc
    if (superstar["faceOfTheCompany"]) name += '<i class="fa fa-star medium-blue margin-left-5 top--1px"></i>';
    else if (superstar["faceOfTheCompanyCounter"] > 0) {
        let monthsLeft = 6 - parseInt(superstar["faceOfTheCompanyCounter"]);
        if (monthsLeft === 1) faceOfTheCompanyText = monthsLeft + " month to becoming a Face of the Company";
        else faceOfTheCompanyText = monthsLeft + " months to becoming a Face of the Company";
    }
    // Appearances
    if (superstar["appearances"] !== undefined) {
        if (superstar["appearances"] === 1) appearanceText = superstar["appearances"] + " appearance left";
        else appearanceText = superstar["appearances"] + " appearances left";
    }
    // Injured
    if (superstar["injured"] !== undefined) injuredText = (0, $1JSre.getSuperstarInjuredText)(superstar);
    // Suspension months
    if (superstar["suspensionMonths"] > 0) {
        if (superstar["suspensionMonths"] !== "1") suspendedText = "Suspended for " + superstar["suspensionMonths"] + " months";
        else suspendedText = "Suspended for " + superstar["suspensionMonths"] + " month";
    }
    // Unhappy
    if (superstar["unhappy"] !== undefined) {
        if (superstar["unhappy"]) unhappyText = "Unhappy";
    }
    // Join info, remove null values
    const infoText = [
        injuredText,
        suspendedText,
        unhappyText,
        appearanceText,
        faceOfTheCompanyText
    ].filter(function(val) {
        return val;
    }).join(", ");
    // Get brand name
    let brandName = superstar["brandName"];
    if (brandName) brandName = brandName.replace(/"/g, "&quot;");
    // Get data attributes
    let dataAlignment = ' data-alignment="' + superstar["alignment"] + '"';
    let dataPronoun = ' data-pronoun="' + superstar["pronoun"] + '"';
    let dataBrandName = ' data-brand-name="' + brandName + '"';
    // Get filter classes
    let filterClasses = "";
    if (appearanceText) filterClasses += "part-timer ";
    if (unhappyText) filterClasses += "unhappy ";
    if (injuredText) filterClasses += "injured ";
    // Get color class
    let colorClass = "";
    if (unhappyText) colorClass = "puke-green ";
    else if (appearanceText) colorClass = "blue ";
    else if (injuredText || suspendedText) colorClass = "dark-red ";
    // Return html
    return '<div class="margin-bottom-7"><span data-type="superstar" data-uid="' + superstar["uid"] + '" data-container="' + dataContainerName + '" ' + 'class="col1 ' + colorClass + filterClasses + 'roster-member opacity-hover"' + dataAlignment + dataPronoun + dataBrandName + ">" + name + "</span>" + '<span class="col2 grey">' + infoText + "</span>" + "</div>";
}
function $d3e44747ec383890$var$getRosterChampionshipHtml(championship) {
    // Get champion name and class
    let championName = championship["championName"];
    let championClass = "roster-member opacity-hover gold";
    if (!championName) {
        championName = "Vacant";
        championClass = "medium-light-grey";
    }
    // Get match contract info
    let event = "";
    if (championship["matchContract"]) event = " (" + championship["event"] + ")";
    // Get brand name
    let brandName = championship["brandName"];
    if (brandName) brandName = brandName.replace(/"/g, "&quot;");
    // Get prestige icon
    let prestigeIcon = (0, $1JSre.getChampionshipPrestigeIconHtml)(championship["prestige"]);
    // Get data attributes
    let dataBrandName = ' data-brand-name="' + brandName + '"';
    let dataType = championship["tagTeam"] || championship["trio"] ? "tagTeam" : "superstar";
    // Return html
    return '<div class="margin-bottom-7"><span data-type="' + dataType + '" data-uid="' + championship["championUid"] + '" data-container="roster-champions" ' + 'class="superstar-select-champion col1 ' + championClass + '"' + dataBrandName + ">" + championName + "</span>" + '<span class="col2">' + championship["name"] + event + " " + prestigeIcon + "</span>" + "</div>";
}
function $d3e44747ec383890$export$4e74726e57dcef35(data, selectElement) {
    // Reset select
    selectElement.find("option").remove().end();
    // Add options
    data.forEach(function(company) {
        let isCompetitorAttribute = company["isCompetitor"] ? ' data-is-competitor="true"' : "";
        selectElement.append('<option data-uid="' + company["uid"] + '"' + isCompetitorAttribute + ">" + company["name"] + "</option>");
    });
}
function $d3e44747ec383890$var$getTalentFilterResults(rosterElement, filterName, filterBrandName) {
    // Filter roster elements by classes / data attributes
    let elements;
    elements = rosterElement.filter(function(e) {
        if ([
            "part-timer",
            "unhappy",
            "injured"
        ].indexOf(filterName) >= 0) return $(e).hasClass(filterName);
        else if ([
            "he",
            "she",
            "they"
        ].indexOf(filterName) >= 0) return $(e).attr("data-pronoun") === filterName;
        else if ([
            "face",
            "heel"
        ].indexOf(filterName) >= 0) return $(e).attr("data-alignment") === filterName;
        else if (filterName === "neutral") return $(e).attr("data-alignment") === "null" || $(e).attr("data-alignment") === "";
        else if (filterName === "no-brand") return $(e).attr("data-brand-name") === "null";
        else if (filterName === "custom-brand") return $(e).attr("data-brand-name") === filterBrandName;
    });
    return elements;
}
function $d3e44747ec383890$var$applyRosterSearchOrFilter(type, term, brandTerm) {
    // Define selectors
    const $resultsContainer = $(".roster-search-container");
    const $rosterContainer = $(".roster-members-container");
    const $allMembersContainer = $resultsContainer.add($rosterContainer);
    const $noRosterResultsElement = $(".no-roster-results");
    // Get all roster elements
    let rosterElements = $allMembersContainer.find(".roster-member, .future-superstar, .superstar-select-champion").toArray();
    // Reset elements to default containers, sorted by default order
    rosterElements.sort(function(a, b) {
        return parseInt($(a).attr("data-default-order")) - parseInt($(b).attr("data-default-order"));
    });
    rosterElements.forEach(function(e) {
        const elementContainerName = $(e).attr("data-container");
        const elementContainer = $("." + elementContainerName);
        elementContainer.append($(e).parent());
    });
    $(".roster-filter-champions").remove();
    // Don't show champions for search
    if (type === "search") rosterElements = $(rosterElements).filter(":not(.superstar-select-champion)").toArray();
    // Run filter/search
    if (term) {
        let results;
        if (type === "search") results = (0, $1JSre.runFuseElementsSearch)(rosterElements, term, [
            "textContent"
        ]);
        else results = $d3e44747ec383890$var$getTalentFilterResults(rosterElements, term, brandTerm);
        // Show results if found
        if (results.length > 0) {
            // Show champions section if champions are present (for brands)
            let championsPresent = results.some(function(e) {
                return $(e).hasClass("superstar-select-champion");
            });
            if (championsPresent) $resultsContainer.append($('<div class="margin-bottom-15 roster-filter-champions"><div class="light-grey margin-bottom-7">Champions</div></div>'));
            // Add results to $resultsContainer
            results.forEach(function(e) {
                if ($(e).hasClass("superstar-select-champion")) $resultsContainer.find(".roster-filter-champions").append($(e).parent());
                else $resultsContainer.append($(e).parent());
            });
            $(".no-roster-search-results").hide();
            $noRosterResultsElement.hide();
        } else if ($noRosterResultsElement.length > 0) $noRosterResultsElement.show();
        else $resultsContainer.append('<div class="no-roster-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
        $resultsContainer.show();
        $rosterContainer.hide();
    } else {
        $resultsContainer.hide();
        $rosterContainer.show();
    }
    if (type === "search") // Reset filters
    $(".view-roster-filter").removeClass("selected");
    else // Reset search
    $(".roster-search-input").val("");
    $rosterContainer.scrollTop(0);
    $rosterContainer[0].scrollIntoView();
}
function $d3e44747ec383890$var$runIndieRosterSearch(term) {
    // Define selectors
    const $availableIndie = $(".available-indie");
    const $unavailableIndie = $(".unavailable-indie");
    const $noAvailableIndieSearchResults = $(".no-available-indie-search-results");
    const $noUnavailableIndieSearchResults = $(".no-unavailable-indie-search-results");
    const $rosterMembersContainer = $(".roster-members-container");
    const $resultsContainer = $(".indie-search-container");
    const $rosterContainers = $(".available-indie, .unavailable-indie");
    const $allMembersContainer = $resultsContainer.add($rosterContainers);
    // Get all roster elements
    let rosterElements = $allMembersContainer.find(".roster-member");
    // Move all members to results container
    rosterElements.toArray().forEach(function(e) {
        $resultsContainer.append(e);
    });
    // Run search
    if (term.length > 0) {
        let searchResults = (0, $1JSre.runFuseElementsSearch)(rosterElements, term, [
            "dataset.name"
        ]);
        // Sort search results by order
        searchResults.sort(function(a, b) {
            return parseFloat($(a).attr("data-order")) - parseFloat($(b).attr("data-order"));
        });
        // Show search results if found
        searchResults.forEach(function(e) {
            const elementContainerName = $(e).attr("data-container");
            const elementContainer = $("." + elementContainerName);
            elementContainer.append(e);
        });
        // Show no results found
        if ($availableIndie.find(".roster-member").length <= 0) {
            if ($noAvailableIndieSearchResults.length > 0) $noAvailableIndieSearchResults.show();
            else $availableIndie.append('<div class="no-available-indie-search-results inner-box-item disabled light-grey ">No Results Found</div>');
        } else $noAvailableIndieSearchResults.hide();
        if ($unavailableIndie.find(".roster-member").length <= 0) {
            if ($noUnavailableIndieSearchResults.length > 0) $noUnavailableIndieSearchResults.show();
            else $unavailableIndie.append('<div class="no-unavailable-indie-search-results inner-box-item disabled light-grey ">No Results Found</div>');
        } else $noUnavailableIndieSearchResults.hide();
        // Hide empty container text
        $(".no-unavailable-indie-talent-present").hide();
        $(".no-available-indie-talent-present").hide();
    } else {
        // Move back to original containers, sorted by order
        rosterElements.sort(function(a, b) {
            return parseFloat($(a).attr("data-order")) - parseFloat($(b).attr("data-order"));
        });
        rosterElements.toArray().forEach(function(e) {
            const elementContainerName = $(e).attr("data-container");
            const elementContainer = $("." + elementContainerName);
            elementContainer.append(e);
        });
        // Hide no results found
        $noAvailableIndieSearchResults.hide();
        $noUnavailableIndieSearchResults.hide();
        // Show empty container text
        $(".no-unavailable-indie-talent-present").show();
        $(".no-available-indie-talent-present").show();
    }
    $rosterMembersContainer.scrollTop(0);
    $rosterMembersContainer[0].scrollIntoView();
}
async function $d3e44747ec383890$export$8777720a6e173e8e(memberUid, memberType, competitorUid, previousElement) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view roster member data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewRosterMemberData = await (0, $jpMCP.getViewRosterMemberData)({
        uid: memberUid,
        type: memberType,
        companyUid: competitorUid
    });
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show view roster member data
    (0, $1JSre.hideContent)($());
    const hideInfo = !!competitorUid;
    $d3e44747ec383890$export$bebb4c117c1f020f(viewRosterMemberData, memberUid, memberType, hideInfo, viewRosterMemberData["scoutLevel"], previousElement);
    // Tutorial action check
    if (viewRosterMemberData["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = viewRosterMemberData["nextTutorialState"];
}
function $d3e44747ec383890$export$bebb4c117c1f020f(data, memberUid, memberType, hideInfo, scoutLevel, previousElement, indieRoster = false, indieUnavailableRoster = false) {
    // Define selectors
    const $rosterMemberDetails = $("#roster-member-details");
    const $rosterMemberStatus = $(".roster-member-status");
    const $rosterMemberAge = $(".roster-member-age");
    const $rosterMemberPronoun = $(".roster-member-pronoun");
    const $rosterMemberCharisma = $(".roster-member-charisma");
    const $rosterMemberWorkrate = $(".roster-member-workrate");
    const $rosterMemberAlignment = $(".roster-member-alignment");
    const $rosterMemberOverness = $(".roster-member-overness");
    const $rosterMemberMorale = $(".roster-member-morale");
    const $rosterMemberFatigue = $(".roster-member-fatigue");
    const $rosterMemberGimmick = $(".roster-member-gimmick");
    const $rosterMemberTraits = $(".roster-member-traits");
    const $rosterMemberInformation = $(".roster-member-information");
    const $rosterMemberBrand = $(".roster-member-brand");
    const $rosterMemberTournamentsWon = $(".roster-member-tournaments-won");
    const $rosterMemberChampionships = $(".roster-member-championships");
    const $rosterMemberStats = $(".roster-member-stats");
    const $rosterMemberAvailable = $(".roster-member-available");
    const $editNameButton = $("#edit-name-button");
    const $editAlignmentButton = $("#edit-alignment-button");
    const $releaseTalentButton = $("#release-talent-button");
    const $disbandTeamButton = $(".disband-team-button");
    const $editSuperstarBrandButton = $("#edit-superstar-brand-button");
    const $transitionTalentButton = $("#transition-talent-button");
    const $unlearnTalentTraitButton = $("#unlearn-talent-trait-button");
    // Set data attributes
    $rosterMemberDetails.data("uid", memberUid);
    $rosterMemberDetails.data("type", memberType);
    $rosterMemberDetails.data("element", previousElement);
    // If competitor or indie talent, show info based on scout level
    const showLevel1Info = !hideInfo || scoutLevel >= 1;
    const showLevel2Info = !hideInfo || scoutLevel >= 2;
    const showLevel3Info = !hideInfo || scoutLevel >= 3;
    const noInfoHtml = '<span class="light-grey">???</span>';
    // Name
    $(".roster-member-name").text(data["name"]);
    // Popularity/rank
    if (showLevel2Info) $(".roster-member-popularity").html(data["popularity"]);
    else if (showLevel1Info) $(".roster-member-popularity").html(data["rank"]);
    else $(".roster-member-popularity").html(noInfoHtml);
    // Age
    if (showLevel1Info) {
        let age = Math.round(data["age"]);
        $rosterMemberAge.text(age);
    } else $rosterMemberAge.html(noInfoHtml);
    // Pronoun
    if (data["pronoun"] !== undefined) {
        if (!data["pronoun"]) // For teams with mixed pronouns
        data["pronoun"] = "they";
        $rosterMemberPronoun.text((0, $3E8Nt.toTitleCase)(data["pronoun"]));
    } else $rosterMemberPronoun.html(noInfoHtml);
    // Alignment
    if (showLevel3Info) {
        let rosterMemberAlignmentHtml = (0, $1JSre.getRosterMemberAlignmentHtml)(data);
        $rosterMemberAlignment.html(rosterMemberAlignmentHtml);
    } else $rosterMemberAlignment.html(noInfoHtml);
    // Overness
    if (showLevel3Info) {
        let overnessText = "";
        let hotStaleText;
        if (data["hot"]) {
            overnessText = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5"/>';
            hotStaleText = "Being Over boosts a Superstar's Attributes (Workrate, Charisma), their Popularity changes, the changes in their Gimmicks effectiveness  and the chance to have Hot Matches, Segments and Feuds.";
        } else if (data["stale"]) {
            overnessText = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5"/>';
            hotStaleText = "Becoming Stale lowers the ratings of a Superstar's Segments,  their Popularity gains and the chance to have Hot Matches, Segments and Feuds.";
        }
        let overness = Math.round(data["overness"]);
        let overnessHtml;
        if (data["hot"] || data["stale"]) overnessHtml = '<span class="help-text" title="' + hotStaleText + '">' + overness + "%" + overnessText + "</span>";
        else overnessHtml = '<span class="help-text" title="' + (0, $1JSre.getOvernessLevelText)(data["overness"]) + '">' + overness + "%" + "</span>";
        $rosterMemberOverness.html(overnessHtml);
    } else $rosterMemberOverness.html(noInfoHtml);
    // Morale
    if (showLevel2Info) {
        let morale = Math.round(data["morale"]);
        let moraleClass = (0, $1JSre.getRosterMemberMoraleClass)(data["morale"]);
        let moraleText = (0, $1JSre.getRosterMemberMoraleText)(data["morale"]);
        let moraleHtml = '<span><span class="margin-right-5"><span class="' + moraleClass + '">' + moraleText + "</span>" + "</span>" + '<span class="light-grey">(' + morale + "%" + ")</span>" + "</span>";
        $rosterMemberMorale.html(moraleHtml);
    } else $rosterMemberMorale.html(noInfoHtml);
    // Fatigue
    if (showLevel2Info) {
        let fatigueHtml = '<span class="' + (0, $1JSre.getRosterMemberFatigueClass)(data["fatigue"]) + ' help-text" ' + 'title="Fatigue affects the chance of getting injured">' + data["fatigue"] + "%" + "</span>";
        $rosterMemberFatigue.html(fatigueHtml);
    } else $rosterMemberFatigue.html(noInfoHtml);
    // Charisma
    if (showLevel2Info) {
        let charismaHtml;
        let originalCharisma;
        if (memberType === "tagTeam") charismaHtml = (0, $1JSre.getStarRatingHtml)(data["charisma"], "charisma-purple", 3);
        else {
            originalCharisma = data["hot"] ? data["charisma"] - 1 : data["charisma"];
            charismaHtml = '<i class="fa fa-star"></i>'.repeat(originalCharisma);
            if (data["hot"]) charismaHtml += '<i class="fa fa-star hot-color"></i>';
            if (data["charisma"] < 3) charismaHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - data["charisma"]);
        }
        charismaHtml = '<span role="text" aria-label="' + data["charisma"] + " star charisma" + '">' + charismaHtml + "</span>";
        $rosterMemberCharisma.html(charismaHtml);
        if (memberType !== "tagTeam") {
            // Progress
            let baseXp;
            let nextXp;
            switch(originalCharisma){
                case 1:
                    baseXp = 0;
                    nextXp = 100;
                    break;
                case 2:
                    baseXp = 100;
                    nextXp = 300;
                    break;
                case 3:
                    nextXp = 300;
                    break;
            }
            let xpToLevel = "";
            let progress = 100;
            if (originalCharisma < 3) {
                progress = (data["charismaXp"] - baseXp) / (nextXp - baseXp) * 100;
                xpToLevel = "{0} XP to Level {1}".format(nextXp - Math.round(data["charismaXp"]), originalCharisma + 1);
            } else xpToLevel = "Max Level";
            if (progress > 100) progress = 100;
            else if (progress <= 0) progress = 1;
            let charismaProgress = '<div class="display-block margin-bottom-3 margin-top-5"><div class="display-inline-block font-0p925em dark-grey">' + xpToLevel + "</div>" + "</div>" + '<div class="progress-under compact help-text" title="' + Math.round(data["charismaXp"]) + " / " + nextXp + ' XP">' + '<div class="progress compact charisma-purple-background" style="width:' + progress + '%">' + "</div>" + "</div>";
            $(".roster-member-charisma-progress").html(charismaProgress);
        } else $(".roster-member-charisma-progress").html("");
    } else {
        $rosterMemberCharisma.html("???");
        $(".roster-member-charisma-progress").html("");
    }
    // Workrate
    if (showLevel2Info) {
        let workrateHtml;
        let originalWorkrate;
        if (memberType === "tagTeam") workrateHtml = (0, $1JSre.getStarRatingHtml)(data["workrate"], "workrate-blue", 3);
        else {
            originalWorkrate = data["hot"] ? data["workrate"] - 1 : data["workrate"];
            workrateHtml = '<i class="fa fa-star"></i>'.repeat(originalWorkrate);
            if (data["hot"]) workrateHtml += '<i class="fa fa-star hot-color"></i>';
            if (data["workrate"] < 3) workrateHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - data["workrate"]);
        }
        workrateHtml = '<span role="text" aria-label="' + data["workrate"] + " star workrate" + '">' + workrateHtml + "</span>";
        $rosterMemberWorkrate.html(workrateHtml);
        if (memberType !== "tagTeam") {
            // Progress
            let baseXp;
            let nextXp;
            switch(originalWorkrate){
                case 1:
                    baseXp = 0;
                    nextXp = 100;
                    break;
                case 2:
                    baseXp = 100;
                    nextXp = 300;
                    break;
                case 3:
                    nextXp = 300;
                    break;
            }
            let xpToLevel = "";
            let progress = 100;
            if (originalWorkrate < 3) {
                progress = (data["workrateXp"] - baseXp) / (nextXp - baseXp) * 100;
                xpToLevel = "{0} XP to Level {1}".format(nextXp - Math.round(data["workrateXp"]), originalWorkrate + 1);
            } else xpToLevel = "Max Level";
            if (progress > 100) progress = 100;
            else if (progress <= 0) progress = 1;
            let workrateProgress = '<div class="display-block margin-bottom-3 margin-top-5"><div class="display-inline-block font-0p925em dark-grey">' + xpToLevel + "</div>" + "</div>" + '<div class="progress-under compact help-text" title="' + Math.round(data["workrateXp"]) + " / " + nextXp + ' XP">' + '<div class="progress compact workrate-blue-background" style="width:' + progress + '%">' + "</div>" + "</div>";
            $(".roster-member-workrate-progress").html(workrateProgress);
        } else $(".roster-member-workrate-progress").html("");
    } else {
        $rosterMemberWorkrate.html("???");
        $(".roster-member-workrate-progress").html("");
    }
    // Face of the Company
    let fotc = "";
    if (showLevel3Info) {
        if (data["faceOfTheCompany"]) fotc = '<span class="light-grey margin-left-5 help-text" title="Face of the Company."><i class="fa fa-star medium-blue"></i></span>';
        else if (data["faceOfTheCompanyCounter"] > 0) fotc = '<span class="light-grey margin-left-5 help-text" title="Face of the Company progress in months"><i class="fa fa-star medium-blue"></i> ' + String(parseInt(data["faceOfTheCompanyCounter"])) + "/6" + "</span>";
        $(".roster-member-popularity").html(data["popularity"] + fotc);
    }
    // Status
    let statusText = "";
    if (data["fullTimeManager"]) statusText = "Manager";
    else {
        if (data["appearances"] !== null && data["appearances"] !== undefined) {
            // Show 'months' instead of 'appearances' if on trade deal
            let appearancesWord;
            if (data["activeEffect"] === "traded") appearancesWord = (0, $3E8Nt.getMonthsWord)(data["appearances"]);
            else appearancesWord = data["appearances"] === 1 ? "app." : "apps.";
            statusText = "{0} {1}".format(data["appearances"], appearancesWord);
            // Add text for active effects
            if (data["activeEffect"] === "traded") statusText += " (Trade Deal)";
            else if (data["activeEffect"] === "retirement_return") statusText += " (Retirement Return)";
            if (data["partTimer"]) statusText = '<span class="help-text" title="Part-timer appearances are used up in Matches but not in Segments">' + statusText + "</span>";
        } else if (data["retired"]) statusText = "Retired";
        else statusText = "Full time";
        if (data["activeEffect"] === "in_training") statusText += " (Training)";
    }
    if (statusText) $rosterMemberStatus.html(statusText);
    else $rosterMemberStatus.html(noInfoHtml);
    // Information
    let info = [];
    if (showLevel3Info && data["cyborg"]) {
        let cyborgHtml = '<span class="grey-blue">Cyborg</span>';
        info.push(cyborgHtml);
    }
    if (data["retired"]) {
        let retiredHtml = ' <span class="help-text" title="Retired Superstars can be booked in Legends, Retired and Manager Segments or as part of a Faction">Retired</span>';
        info.push(retiredHtml);
    }
    if (showLevel2Info && data["hallOfFamer"]) {
        let hofHtml = ' <span class="gold">Hall of Famer</span>';
        info.push(hofHtml);
    }
    if (data["dead"]) {
        let deadHtml = '<span class="dead">Dead</span>';
        info.push(deadHtml);
    }
    // Team/faction members
    if (memberType === "tagTeam") {
        let tagTeamSuperstars = data["superstars"].slice(0, -1).join(", ") + " and " + data["superstars"].slice(-1);
        let tagTeamSuperstarsHtml = '<span class="medium-grey">{0}</span>'.format(tagTeamSuperstars);
        info.push(tagTeamSuperstarsHtml);
    }
    if (data["teams"] && data["teams"].length > 0) {
        let teamWord = data["teams"].length === 1 ? "Team" : "Teams";
        let teamHtml = '<span class="medium-grey">{0}</span> ({1})'.format((0, $3E8Nt.commaSeparate)(data["teams"]), teamWord);
        info.push(teamHtml);
    }
    if (data["factions"] && data["factions"].length > 0) {
        let factionHtml = '<span class="medium-grey">{0}</span> (Faction)'.format((0, $3E8Nt.commaSeparate)(data["factions"]));
        info.push(factionHtml);
    }
    // Manager/managed talent
    if ((0, $98xmD.globalUser).paid) {
        if (data["managedTalentNames"] && data["managedTalentNames"].length > 0) {
            let managerHtml = '<span class="medium-grey">Managing {0}</span>'.format((0, $3E8Nt.commaSeparate)(data["managedTalentNames"]));
            info.push(managerHtml);
        }
        if (data["managerNames"] && data["managerNames"].length > 0) {
            let managerWord = data["managerNames"].length === 1 ? "Manager" : "Managers";
            let managerHtml = '<span class="medium-grey">{0}</span> ({1})'.format((0, $3E8Nt.commaSeparate)(data["managerNames"]), managerWord);
            info.push(managerHtml);
        }
    }
    // One match appearance
    if (data["activeEffect"] === "one_match_appearance") info.push("One Match Appearance");
    // Show injured and suspended if not retired or dead
    if (showLevel2Info && !data["retired"] && !data["dead"]) {
        if (data["injured"] > 0) {
            let injuredText = (0, $1JSre.getSuperstarInjuredText)(data);
            let injuredHtml = '<span class="dark-red line-height-1p4">' + injuredText + "</span>";
            info.push(injuredHtml);
        }
        if (data["suspensionMonths"] > 0) {
            let suspendedText;
            if (data["suspensionMonths"] === "1") suspendedText = "Suspended for " + data["suspensionMonths"] + " month";
            else suspendedText = "Suspended for " + data["suspensionMonths"] + " months";
            let suspendedHtml = '<span class="dark-red">' + suspendedText + "</span>";
            info.push(suspendedHtml);
        }
    }
    // Contract months remaining
    let contractMonthsRemainingHtml = "";
    if (data["contractMonthsRemaining"]) {
        let contractMonthsRemainingWord = (0, $3E8Nt.getMonthsWord)(data["contractMonthsRemaining"]);
        contractMonthsRemainingHtml = '<span class="puke-green">{0} {1} to leave</span>'.format(data["contractMonthsRemaining"], contractMonthsRemainingWord);
        info.push(contractMonthsRemainingHtml);
    }
    // Join info together
    info = $.grep(info, Boolean).join(", ");
    $rosterMemberInformation.html("");
    if (info.length > 0) $rosterMemberInformation.html('<div class="margin-bottom-5">' + info + "</div>");
    // Show/hide attributes
    $rosterMemberAge.parent().show();
    $rosterMemberPronoun.parent().show();
    $rosterMemberStatus.parent().show();
    $rosterMemberCharisma.parent().show();
    $rosterMemberWorkrate.parent().show();
    $rosterMemberAlignment.parent().show();
    $rosterMemberOverness.parent().show();
    $rosterMemberMorale.parent().show();
    $rosterMemberFatigue.parent().show();
    $rosterMemberGimmick.parent().show();
    $rosterMemberTraits.parent().show();
    $rosterMemberInformation.show();
    $rosterMemberBrand.parent().show();
    // Championships
    $rosterMemberChampionships.html("");
    if (data["championships"] && data["championships"].length > 0) {
        let championshipNames = (0, $1JSre.getChampionshipsDisplayName)(data["championships"], true);
        $rosterMemberChampionships.html('<div class="margin-bottom-5">' + championshipNames + "</div>");
    }
    // Stats
    $rosterMemberStats.html("").show();
    if (data["stats"]) {
        const statsHtml = $d3e44747ec383890$var$getViewRosterMemberStatsHtml(data["stats"]);
        $rosterMemberStats.html('<div><div class="display-block dark-grey font-1p125em blue">Talent Stats</div>' + statsHtml + "</div>");
    } else if ((memberType === "superstar" || memberType === "tagTeam") && !indieRoster && !(0, $98xmD.globalUser).paid) {
        // Show JoW Paid text
        let div = "";
        div += '<div class="margin-top-15">';
        div += '<span class="display-block light-grey">Talent Stats are only available in JoW Paid. View stats like Win/Loss Records, Championship Reigns, Average Match Rating and more.</span>';
        $rosterMemberStats.html('<div><div class="display-block dark-grey font-1p125em blue">Talent Stats</div>' + div + "</div>");
        $rosterMemberStats.addClass("disabled");
    } else $rosterMemberStats.hide();
    // Tournaments won
    $rosterMemberTournamentsWon.html("");
    if (data["tournamentsWon"] && data["tournamentsWon"].length > 0) {
        let tournamentsWonText = "";
        if (data["tournamentsWon"].length > 1) tournamentsWonText = '<span class="cyan">' + data["tournamentsWon"].slice(0, -1).join(", ") + "</span>" + " and " + '<span class="cyan">' + data["tournamentsWon"].slice(-1) + "</span>";
        else tournamentsWonText = '<span class="cyan">' + data["tournamentsWon"][0] + "</span>";
        $rosterMemberTournamentsWon.html('<div class="margin-bottom-5">Winner of ' + tournamentsWonText + "</div>");
    }
    // Graphic if present
    let matchData = null;
    let graphicData;
    if (memberType === "tagTeam") {
        // Show team graphics if present
        if (data["graphics"]) matchData = {
            "type": "tag",
            "largerTag": data["graphics"].length
        };
        graphicData = data["graphics"];
    } else graphicData = [
        data["graphic"]
    ];
    $(".roster-member-graphic").html("");
    let el = $rosterMemberDetails.find(".roster-member-graphic");
    (0, $c82cd471f4baff6b$export$ca0cc0827d137f10)(graphicData, el, matchData);
    $rosterMemberDetails.data("graphic", graphicData);
    $rosterMemberDetails.data("match", matchData);
    // Gimmick
    if (showLevel3Info) {
        let gimmickData = '<span class="medium-grey">None</span>';
        if (data["gimmick"]) {
            gimmickData = (0, $1JSre.getGimmickDescription)(data["gimmick"]);
            $("#edit-gimmick-button").text("Change Gimmick");
            $(".create-gimmick-label").text("Change Gimmick");
            $("#create-gimmick-button").text("Change");
        } else {
            $("#edit-gimmick-button").text("Create Gimmick");
            $(".create-gimmick-label").text("Create Gimmick");
            $("#create-gimmick-button").text("Create");
        }
        $rosterMemberGimmick.html(gimmickData);
    } else $rosterMemberGimmick.html(noInfoHtml);
    // Hide gimmick for tagTeam
    if (memberType === "tagTeam") $rosterMemberGimmick.parent().hide();
    // Traits
    if (showLevel3Info) {
        let traitHtml = '<span class="medium-grey">None</span>';
        if (data["traits"].length > 0) {
            traitHtml = "";
            data["traits"].forEach((x)=>{
                traitHtml += $d3e44747ec383890$var$getViewRosterMemberTraitHtml(x);
            });
        }
        $rosterMemberTraits.html(traitHtml);
    } else $rosterMemberTraits.html(noInfoHtml);
    // Brand
    let brandName = '<span class="medium-grey">None</span>';
    if (data["brandName"]) brandName = data["brandName"];
    $rosterMemberBrand.html(brandName);
    // Hide brand for indie talent
    if (indieRoster) $rosterMemberBrand.parent().hide();
    // Show/hide buttons
    $("#train-talent-workrate-button").hide();
    $("#train-talent-charisma-button").hide();
    $editNameButton.show();
    $editAlignmentButton.show();
    $releaseTalentButton.show();
    $disbandTeamButton.hide();
    $editSuperstarBrandButton.show();
    if (memberType === "superstar") {
        $("#edit-gimmick-button").show();
        $("#edit-appearance-button").show();
        $("#train-talent-button").show();
        $("#reassure-talent-button").show();
        $("#edit-pronoun-button").show();
        // Show transition button and proper text
        if ((0, $98xmD.globalUser).paid) {
            $transitionTalentButton.show();
            if (data["fullTimeManager"]) {
                $transitionTalentButton.text("Transition To Superstar");
                $("#add-manager-relationship-for-talent-button").show();
                $("#remove-manager-relationship-for-talent-button").show();
            } else {
                $transitionTalentButton.text("Transition To Manager");
                $("#add-manager-relationship-for-talent-button").hide();
                $("#remove-manager-relationship-for-talent-button").hide();
            }
        } else {
            $transitionTalentButton.hide();
            $("#add-manager-relationship-for-talent-button").hide();
            $("#remove-manager-relationship-for-talent-button").hide();
        }
        // Show rehab button if injured
        if (data["injured"] > 0) $("#rehab-talent-button").show();
        else $("#rehab-talent-button").hide();
        // Show unlearn traits button if any present
        if (data["canUnlearnTraits"] && data["canUnlearnTraits"].length > 0) {
            $unlearnTalentTraitButton.show();
            $unlearnTalentTraitButton.data("canUnlearnTraits", data["canUnlearnTraits"]);
        } else $unlearnTalentTraitButton.hide();
        // Show transition to staff button if retired
        if (data["retired"]) $("#transition-talent-to-staff-button").show();
        else $("#transition-talent-to-staff-button").hide();
    } else {
        $("#edit-gimmick-button").hide();
        $("#edit-appearance-button").hide();
        $("#train-talent-button").hide();
        $("#reassure-talent-button").hide();
        $transitionTalentButton.hide();
        $("#rehab-talent-button").hide();
        $("#transition-talent-to-staff-button").hide();
        $unlearnTalentTraitButton.hide();
        $("#add-manager-relationship-for-talent-button").hide();
        $("#remove-manager-relationship-for-talent-button").hide();
        $("#edit-pronoun-button").hide();
    }
    if (!(0, $98xmD.globalUser).paid) $editSuperstarBrandButton.hide();
    if ((0, $98xmD.globals).game.story === "mars") {
        $editNameButton.hide();
        $("#edit-pronoun-button").hide();
    }
    if ((0, $98xmD.globals).game.story === "mars" || (0, $98xmD.globals).game.story === "passion") $editSuperstarBrandButton.hide();
    if (memberType === "tagTeam") $disbandTeamButton.show();
    // Indie buttons
    if (indieRoster) {
        $("#edit-gimmick-button").hide();
        $("#edit-appearance-button").hide();
        $("#train-talent-button").hide();
        $("#reassure-talent-button").hide();
        $transitionTalentButton.hide();
        $("#rehab-talent-button").hide();
        $("#transition-talent-to-staff-button").hide();
        $unlearnTalentTraitButton.hide();
        $("#add-manager-relationship-for-talent-button").hide();
        $("#remove-manager-relationship-for-talent-button").hide();
        if (indieUnavailableRoster) {
            $("#scout-talent-button").show();
            $("#recruit-talent-button").show();
            $("#start-negotiation-button").hide();
        } else {
            $("#scout-talent-button").hide();
            $("#recruit-talent-button").hide();
            $("#start-negotiation-button").show();
        }
        $editNameButton.hide();
        $editAlignmentButton.hide();
        $("#edit-pronoun-button").hide();
        $editSuperstarBrandButton.hide();
        $releaseTalentButton.hide();
        $disbandTeamButton.hide();
    } else {
        $("#scout-talent-button").hide();
        $("#recruit-talent-button").hide();
        $("#start-negotiation-button").hide();
    }
    // Training superstar buttons and info
    if (memberType === "training-superstar") {
        $("#prepare-for-callup-button").show();
        $rosterMemberAvailable.text(data["available"] ? "Yes" : "No");
        $rosterMemberAvailable.parent().show();
        $editSuperstarBrandButton.hide();
    } else {
        $("#prepare-for-callup-button").hide();
        $rosterMemberAvailable.parent().hide();
    }
    // Hide buttons for competitor talent
    if (data["competitorTalent"]) {
        $("#prepare-for-callup-button").hide();
        $rosterMemberAvailable.parent().hide();
        $("#scout-talent-button").hide();
        $("#recruit-talent-button").hide();
        $("#start-negotiation-button").show();
        $("#edit-gimmick-button").hide();
        $("#edit-appearance-button").hide();
        $("#train-talent-button").hide();
        $("#reassure-talent-button").hide();
        $transitionTalentButton.hide();
        $("#rehab-talent-button").hide();
        $("#transition-talent-to-staff-button").hide();
        $unlearnTalentTraitButton.hide();
        $("#add-manager-relationship-for-talent-button").hide();
        $("#remove-manager-relationship-for-talent-button").hide();
        $editNameButton.hide();
        $editAlignmentButton.hide();
        $("#edit-pronoun-button").hide();
        $editSuperstarBrandButton.hide();
        $releaseTalentButton.hide();
        $disbandTeamButton.hide();
    }
    $rosterMemberDetails.fadeIn();
    $rosterMemberDetails[0].scrollIntoView();
    $rosterMemberStats.scrollTop(0);
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_teams_item");
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_roster_superstar");
}
function $d3e44747ec383890$var$getViewRosterMemberTraitHtml(trait) {
    let html = "";
    // For teams, get trait name with superstar name
    if (typeof trait === "object") html += '<div class="superstar-trait-color">' + (0, $1JSre.getSuperstarTraitHelpHtml)(trait["name"]) + '<span class="margin-left-5 light-grey">(' + trait["superstar"] + ")</span>" + "</div>";
    else html += '<div class="superstar-trait-color">' + (0, $1JSre.getSuperstarTraitHelpHtml)(trait) + "</div>";
    return html;
}
function $d3e44747ec383890$var$getViewRosterMemberStatsHtml(stats) {
    let html = "";
    // Win/loss
    let winningPercentage = "";
    if (stats["winPercentage"] !== null) winningPercentage = "({0}%)".format(stats["winPercentage"]);
    let winLossRecord = '{0}-{1} <span class="margin-left-2 light-grey">{2}</span>'.format(stats["wins"], stats["losses"], winningPercentage);
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Win/Loss Record</span>';
    html += '<span class="display-block dark-grey">' + winLossRecord + "</span>";
    html += "</div>";
    // Winning/losing streak
    let winningLosingStreak = "{0}-{1}".format(stats["winningStreak"], stats["losingStreak"]);
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Winning/Losing Streak</span>';
    html += '<span class="display-block dark-grey">' + winningLosingStreak + "</span>";
    html += "</div>";
    // Current Feuds
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Current Feuds</span>';
    stats["currentFeuds"].forEach(function(feud) {
        let participantNames = (0, $3E8Nt.commaSeparate)(feud["opponents"]);
        let hype = '<span class="faded-red-light"><i class="fa fa-bolt margin-left-8 margin-right-5"></i>' + feud["hype"] + "</span>";
        let text = "vs " + participantNames + '<span class="faded-red-light margin-left-8">' + feud["name"] + "</span>" + hype;
        html += '<span class="display-block dark-grey margin-bottom-8">' + text + "</span>";
    });
    if (stats["currentFeuds"].length < 1) html += '<span class="display-block dark-grey">None</span>';
    html += "</div>";
    // Average match rating
    let averageMatchRating = "None";
    if (stats["averageMatchRating"] !== undefined) averageMatchRating = stats["averageMatchRating"];
    if (stats["averageMatchRating"] !== undefined) {
        html += '<div class="margin-top-15">';
        html += '<span class="display-block blue margin-bottom-2">Average Match Rating</span>';
        html += '<span class="display-block dark-grey">' + averageMatchRating + '<i class="fa fa-star margin-left-3"></i>' + "</span>";
        html += "</div>";
    }
    // Recent Matches
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Recent Matches</span>';
    stats["recentMatches"].forEach(function(match) {
        html += $d3e44747ec383890$var$getTalentStatsMatchHtml(match, true, true);
    });
    if (stats["recentMatches"].length < 1) html += '<span class="display-block dark-grey">None</span>';
    html += "</div>";
    // Greatest Match
    let greatestMatch = "None";
    if (stats["greatestMatch"] !== undefined) greatestMatch = $d3e44747ec383890$var$getTalentStatsMatchHtml(stats["greatestMatch"], true, false);
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Greatest Match</span>';
    html += '<span class="display-block dark-grey">' + greatestMatch + "</span>";
    html += "</div>";
    // Biggest Rival
    let biggestRival = "None";
    if (stats["biggestRival"] !== undefined) biggestRival = stats["biggestRival"];
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Biggest Rival</span>';
    html += '<span class="display-block dark-grey">' + biggestRival + "</span>";
    html += "</div>";
    // Championship reigns
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Championship Reigns</span>';
    stats["championshipReigns"].forEach(function(reign) {
        html += $d3e44747ec383890$var$getTalentStatsChampionshipReignHtml(reign);
    });
    if (stats["championshipReigns"].length < 1) html += '<span class="display-block dark-grey">None</span>';
    html += "</div>";
    // Awards Won
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Awards Won</span>';
    stats["awardsWon"].forEach(function(award) {
        let trophy = "";
        switch(award["award"]){
            case 0:
                trophy = "trophy_icon_trash";
                break;
            case 1:
                trophy = "trophy_icon_bronze";
                break;
            case 2:
                trophy = "trophy_icon_silver";
                break;
            case 3:
                trophy = "trophy_icon_gold";
                break;
        }
        html += '<span class="display-block dark-grey margin-bottom-8 line-height-27px"><img alt="Trophy" src="static/www/static/' + trophy + '.png" class="trophy-image margin-right-8"/>' + award["name"] + "</span>";
    });
    if (stats["awardsWon"].length < 1) html += '<span class="display-block dark-grey">None</span>';
    html += "</div>";
    // Rankings history
    if (stats["yearlyRankingsHistory"].length > 0) {
        html += '<div class="margin-top-15">';
        html += '<span class="display-block blue margin-bottom-3">Top 50 History (Top 10 Only)</span>';
        stats["yearlyRankingsHistory"].forEach(function(rankingHistory) {
            let trophyHtml = rankingHistory["rank"] === 1 ? '<img alt="Trophy" src="static/www/static/trophy_icon_gold.png" class="trophy-image margin-right-8"/>' : "";
            let rankingText = 'No. {0} <span class="grey margin-left-3">{1}</span>'.format(rankingHistory["rank"], rankingHistory["year"]);
            html += '<span class="display-block dark-grey margin-bottom-5">' + trophyHtml + rankingText + "</span>";
        });
        html += "</div>";
    }
    // Event Streaks
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Event Streaks</span>';
    stats["eventStreaks"].forEach(function(streak) {
        let streakClass = "bronze";
        if (streak["length"] < 5) streakClass = "bronze";
        else if (streak["length"] < 10) streakClass = "gold-light";
        else if (streak["length"] < 20) streakClass = "faded-red";
        else streakClass = "obsidian";
        let streakText = '<span class="{0}">{1}-0</span> at {2}'.format(streakClass, streak["length"], streak["event"]);
        html += '<span class="display-block dark-grey margin-bottom-5">' + streakText + "</span>";
    });
    if (stats["eventStreaks"].length < 1) html += '<span class="display-block dark-grey">None</span>';
    html += "</div>";
    return html;
}
function $d3e44747ec383890$var$getTalentStatsMatchHtml(match, showRating, showMatchResult) {
    let rating = (0, $1JSre.setRating)(match["rating"]);
    let condensedSuperstars = match["opponents"].slice(0, 5);
    if (match["opponents"].length > 5) {
        let remainingSuperstars = match["opponents"].length - 5;
        let othersText = remainingSuperstars > 1 ? "others" : "other";
        condensedSuperstars.push("{0} {1}".format(remainingSuperstars, othersText));
    }
    let opponents = (0, $3E8Nt.commaSeparate)(condensedSuperstars);
    let ratingHtml = "";
    if (showRating) ratingHtml = '<span class="display-block margin-top-3 margin-bottom-20">' + rating + "</span>";
    let matchResult = "";
    if (showMatchResult) switch(match["win"]){
        case true:
            matchResult = '<span class="green">W</span> ';
            break;
        case false:
            matchResult = '<span class="red">L</span> ';
            break;
    }
    let text = '{0}vs {1} <span class="light-grey margin-left-2">{2}</span>'.format(matchResult, opponents, match["event"]);
    return '<span class="display-block dark-grey margin-bottom-8">' + text + ratingHtml + "</span>";
}
function $d3e44747ec383890$var$getTalentStatsChampionshipReignHtml(reign) {
    let endDate = reign["endDate"] !== null ? reign["endDate"] : "Present";
    let period = "{0} - {1}".format(reign["startDate"], endDate);
    let defensesWord = reign["defenses"] === 1 ? "Defense" : "Defenses";
    let defenses = "{0} {1}".format(reign["defenses"], defensesWord);
    let lengthWord = reign["length"] === 1 ? "Month" : "Months";
    let length = "{0} {1}".format(reign["length"], lengthWord);
    let name = "{0}".format(reign["name"]);
    let text = '<span class="gold">' + name + "</span>" + '<span class="margin-left-8">' + period + "</span>" + '<span class="light-grey margin-left-8">' + defenses + "</span>";
    return '<span class="display-block dark-grey margin-bottom-12">' + text + "</span>";
}
async function $d3e44747ec383890$export$75d6879fdd072c0a() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view indies data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewIndiesData = await (0, $jpMCP.getViewIndiesData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show view indies data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showViewIndiesPageData(viewIndiesData);
}
function $d3e44747ec383890$var$showViewIndiesPageData(data) {
    // Get data
    let availableRoster = data["available"];
    let unavailableRoster = data["unavailable"];
    let scoutLevel = data["scoutLevel"];
    // Define selectors
    const $indie = $("#indie");
    const $availableIndie = $(".available-indie");
    const $unavailableIndie = $(".unavailable-indie");
    // Show available roster members
    $availableIndie.html("");
    if (availableRoster.length > 0) availableRoster.forEach(function(rosterMember, i) {
        let objClass = $d3e44747ec383890$var$getViewIndiesElementBorderClass(availableRoster, i);
        let name = $d3e44747ec383890$var$getViewIndiesElementFormattedName(rosterMember);
        // Show interested
        let interested = "";
        let titleHtml = "";
        let helpClass = "";
        if (rosterMember["interested"]) {
            interested = " interested";
            titleHtml = ' title="This talent is interested in joining our company, which means they can be signed for a lower cost."';
            helpClass = " help-text";
        }
        let new_div = '<span class="font-bold roster-member inner-box-item compact' + interested + objClass + helpClass + '"' + titleHtml + ' data-name="' + rosterMember["name"].replace(/"/g, "&quot;") + '" data-order="' + i + '" data-container="available-indie" ' + 'data-type="' + rosterMember["type"] + '" data-uid="' + rosterMember["uid"] + '">' + name + "</span>";
        $availableIndie.append(new_div);
    });
    else $availableIndie.append('<span class="light-grey inner-box-item disabled no-available-indie-talent-present">No Talent Present</span>');
    // Show unavailable roster members
    $unavailableIndie.html("");
    if (unavailableRoster.length > 0) unavailableRoster.forEach(function(rosterMember, i) {
        let objClass = $d3e44747ec383890$var$getViewIndiesElementBorderClass(unavailableRoster, i);
        let name = $d3e44747ec383890$var$getViewIndiesElementFormattedName(rosterMember);
        let new_div = '<span class="font-bold roster-member inner-box-item compact ' + objClass + '" data-name="' + rosterMember["name"].replace(/"/g, "&quot;") + '" data-order="' + i + '" data-container="unavailable-indie" ' + 'data-type="' + rosterMember["type"] + '" data-uid="' + rosterMember["uid"] + '">' + name + "</span>";
        $unavailableIndie.append(new_div);
    });
    else $unavailableIndie.append('<span class="light-grey inner-box-item disabled no-unavailable-indie-talent-present">No Talent Present</span>');
    $indie.fadeIn();
    $availableIndie.scrollTop(0);
    $unavailableIndie.scrollTop(0);
    $(".indie-roster-search-input").val("");
    $(".indie-search-container").html("");
    // Roster member click handler
    $indie.off("click", ".roster-member");
    $indie.on("click", ".roster-member", function(event) {
        $d3e44747ec383890$var$showIndieRosterMemberPage($(event.target), availableRoster, unavailableRoster, scoutLevel);
    });
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_indies_menu_button");
}
function $d3e44747ec383890$var$getViewIndiesElementBorderClass(roster, i) {
    let objClass = "";
    if (roster.length % 2 === 0) {
        if (i === roster.length - 1 || i === roster.length - 2) objClass = " border-bottom-0";
    } else if (i === roster.length - 1) objClass = " border-bottom-0";
    return objClass;
}
function $d3e44747ec383890$var$getViewIndiesElementFormattedName(rosterMember) {
    let name = rosterMember["name"];
    if (name.length > 18) {
        name = name.slice(0, 18) + ".";
        // Remove space if just before shortening period
        if (name.substr(-2) === " .") name = name.slice(0, 17) + ".";
    }
    return name;
}
function $d3e44747ec383890$var$showIndieRosterMemberPage($el, availableRoster, unavailableRoster, scoutLevel) {
    // Get roster member data
    let memberUid = parseInt($el.attr("data-uid"));
    let memberType = $el.attr("data-type");
    let rosterMemberData = availableRoster.concat(unavailableRoster).filter(function(s) {
        return s["uid"] === memberUid;
    })[0];
    let presentInUnavailableRoster = unavailableRoster.indexOf(rosterMemberData) >= 0;
    // Lower scout level for unavailable roster member
    if (presentInUnavailableRoster) scoutLevel -= 1;
    // Show roster member data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$export$bebb4c117c1f020f(rosterMemberData, memberUid, memberType, true, scoutLevel, "#indie", true, presentInUnavailableRoster);
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_indie_roster_member");
}
async function $d3e44747ec383890$export$7c983fe739d97452(companyUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view teams data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewTeamsData = await (0, $jpMCP.getViewTeamsData)(companyUid);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) companySelectData = await (0, $8A6FL.getCompanySelectData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show company select
    if (!companyUid) $d3e44747ec383890$export$4e74726e57dcef35(companySelectData, $(".view-teams-company-select"));
    // Show view teams data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showViewTeamsPageData(viewTeamsData);
}
function $d3e44747ec383890$var$showViewTeamsPageData(data) {
    const $viewTeamsItemsContainer = $(".view-teams-items-container");
    $viewTeamsItemsContainer.html("");
    // Show teams
    data.forEach(function(team) {
        let teamType = team["trio"] ? "Trio" : "Tag Team";
        let div = '<div class="view-teams-item" data-name="' + team["name"].replace(/"/g, "&quot;") + '" data-uid="' + team["uid"] + '">' + '<div class="margin-bottom-6">' + "<span>" + team["name"] + "</span>" + '<span class="float-right light-grey">' + teamType + "</span>" + "</div>" + '<div class="medium-light-grey">' + (0, $3E8Nt.commaSeparate)(team["superstars"]) + "</div>" + "</div>";
        $viewTeamsItemsContainer.append(div);
    });
    if (data.length === 0) {
        let div = '<div class="view-teams-item disabled"><div><span class="grey">No Teams present</span></div></div>';
        $viewTeamsItemsContainer.append(div);
    }
    $("#view-teams-container").fadeIn("slow");
    $viewTeamsItemsContainer.scrollTop(0);
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_teams");
}
async function $d3e44747ec383890$export$19fc0b31850b3e21(companyUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view managers data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewManagersData = await (0, $jpMCP.getViewManagersData)(companyUid);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) companySelectData = await (0, $8A6FL.getCompanySelectData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show company select
    if (!companyUid) $d3e44747ec383890$export$4e74726e57dcef35(companySelectData, $(".view-managers-company-select"));
    // Show view managers data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showViewManagersPageData(viewManagersData);
}
function $d3e44747ec383890$var$showViewManagersPageData(data) {
    const $viewManagersItemsContainer = $(".view-managers-items-container");
    $viewManagersItemsContainer.html("");
    // Show managers
    data.forEach(function(manager) {
        // Get charisma
        let originalCharisma = manager["hot"] ? manager["charisma"] - 1 : manager["charisma"];
        let charismaHtml = '<i class="fa fa-star"></i>'.repeat(originalCharisma);
        if (manager["hot"]) charismaHtml += '<i class="fa fa-star hot-color"></i>';
        if (manager["charisma"] < 3) charismaHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - manager["charisma"]);
        // Get managed talent names
        let managedSuperstarsHtml;
        if (manager["managedTalentNames"].length > 0) managedSuperstarsHtml = '<div class="light-grey">Managing {0}</div>'.format((0, $3E8Nt.commaSeparate)(manager["managedTalentNames"]));
        else managedSuperstarsHtml = '<div class="medium-light-grey">No talent assigned</div>';
        // Get full time manager
        let fullTimeManagerHtml = "";
        if (!manager["fullTimeManager"]) fullTimeManagerHtml = '<div class="medium-light-grey margin-top-5">Non full-time manager</div>';
        // Get html
        let html = '<div class="view-managers-item" data-uid="' + manager["uid"] + '">' + '<div class="margin-bottom-6">' + "<span>" + manager["name"] + "</span>" + '<span class="float-right font-16px charisma-purple help-text" title="Manager Charisma">' + charismaHtml + "</span>" + "</div>" + "<div>" + managedSuperstarsHtml + fullTimeManagerHtml + "</div>" + "</div>";
        $viewManagersItemsContainer.append(html);
    });
    if (data.length === 0) {
        let div = '<div class="view-managers-item disabled"><div><span class="grey">No Managers present</span></div></div>';
        $viewManagersItemsContainer.append(div);
    }
    $("#view-managers-container").fadeIn("slow");
    $viewManagersItemsContainer.scrollTop(0);
}
async function $d3e44747ec383890$export$d2be21ddf647bf61() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get make trade offer data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let makeTradeOfferData = await (0, $8A6FL.getMakeTradeOfferData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show make trade offer data
    $d3e44747ec383890$var$showMakeTradeOfferPageData(makeTradeOfferData);
}
function $d3e44747ec383890$var$showMakeTradeOfferPageData(data) {
    if (data["competitors"].length > 0) {
        let $tradeOfferContainer = $(".trade-offer-container");
        // Add competitors select and user company name
        let companySelector = $(".trade-offer-competitor-select");
        $d3e44747ec383890$export$4e74726e57dcef35(data["competitors"], companySelector);
        $tradeOfferContainer.find(".trade-offer-sender-company-name").text(data["userCompanyName"]);
        // Load first competitor
        (0, $af8d9de467381f29$export$9c4b3a546a360703)($tradeOfferContainer, data["competitors"][0]["uid"], data["competitors"][0]["name"]);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        notie.alert({
            type: 3,
            text: "There are no companies available to trade with",
            stay: true
        });
    }
}
async function $d3e44747ec383890$export$4077c55c538d9414(companyUid, period = "current") {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get view roster rankings data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewRosterRankingsData = await (0, $66ItE.getViewRankingsData)(companyUid, period);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) companySelectData = await (0, $8A6FL.getCompanySelectData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show company select
    if (!companyUid) $d3e44747ec383890$export$4e74726e57dcef35(companySelectData, $(".select-company-for-roster-rankings"));
    // Select 'current' period (for first load)
    if (period === "current") $(".roster-rankings-period-select").val("current");
    // Show view roster rankings data
    $d3e44747ec383890$var$showViewRankingsPageData(viewRosterRankingsData);
}
function $d3e44747ec383890$var$showViewRankingsPageData(data) {
    if (!data["error"]) {
        (0, $1JSre.hideContent)($());
        (0, $lCS03.playSoundEffect)("success");
        // Show rankings data
        $d3e44747ec383890$var$displayRosterRankingsData(data["rankingData"]);
        // Add custom brand filters
        $(".roster-rankings-filter.brand-filter").remove();
        if (data["brandNames"].length > 0) data["brandNames"].forEach(function(rosterBrandName) {
            let rosterBrandFilterHtml = '<button type="button" class="roster-rankings-filter brand-filter button retro-button condensed light-button-background" data-value="custom-brand" data-brand-name="' + rosterBrandName.replace(/"/g, "&quot;") + '">' + rosterBrandName + "</button> ";
            $(".roster-rankings-brand-filters").append(rosterBrandFilterHtml);
        });
        // Apply 'singles' and 'he' filters
        $(".roster-rankings-filter").removeClass("selected");
        $('.roster-rankings-filter[data-value="superstar"]').addClass("selected");
        $('.roster-rankings-filter[data-value="he"]').addClass("selected");
        $d3e44747ec383890$var$applyRosterRankingsFilter();
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-paid") notie.alert({
            type: 3,
            text: "Roster Rankings are only available in JoW Paid."
        });
    }
}
function $d3e44747ec383890$var$displayRosterRankingsData(data) {
    let rosterRankingsDataContainer = $(".roster-rankings-data-container");
    rosterRankingsDataContainer.html("");
    // Show ranking items
    let rankingsHtml = "";
    data.forEach(function(ranking, i) {
        let highlightClasses = i + 1 <= 10 ? " menu-header-color font-1p125em" : "";
        let numberHtml = '<span class="display-inline-block roster-rankings-number grey' + highlightClasses + '">' + (i + 1) + "</span>";
        let winLossHtml = '<span class="display-inline-block font-1p125em">{0}<span class="margin-left-2 margin-right-2">-</span>{1}</span>'.format(ranking["wins"], ranking["losses"]);
        let championshipNamesHtml = Array.from(ranking["championships"], function(x) {
            return '<span class="gold">' + x + "</span>";
        });
        let brandName = ranking["brandName"];
        if (brandName) brandName = brandName.replace(/"/g, "&quot;");
        let html = '<div class="roster-rankings-item font-century-gothic" data-pronoun="' + ranking["pronoun"] + '" data-type="' + ranking["type"] + '" data-brand-name="' + brandName + '">' + "<div>" + '<div class="roster-rankings-column-number">' + numberHtml + "</div>" + '<div class="roster-rankings-column-name">' + '<div class="line-height-1p4">' + ranking["name"] + "</div>" + '<div class="line-height-1p4">' + '<div class="margin-top-3 grey">' + (0, $3E8Nt.commaSeparate)(championshipNamesHtml) + "</div>" + "</div>" + "</div>" + '<div class="roster-rankings-column-data">' + winLossHtml + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
        rankingsHtml += html;
    });
    $("#roster-rankings-container").fadeIn("slow");
    rosterRankingsDataContainer.html(rankingsHtml);
    rosterRankingsDataContainer.scrollTop(0);
}
function $d3e44747ec383890$var$applyRosterRankingsFilter() {
    // Define selectors
    const $typeFilter = $(".roster-rankings-type-filters").find(".roster-rankings-filter.selected");
    const $pronounFilter = $(".roster-rankings-pronoun-filters").find(".roster-rankings-filter.selected");
    const $brandFilter = $(".roster-rankings-brand-filters").find(".roster-rankings-filter.selected");
    const $rosterRankingsDataContainer = $(".roster-rankings-data-container");
    // Show items that pass both filters
    $rosterRankingsDataContainer.find(".roster-rankings-item").each(function(i, x) {
        if (($typeFilter.length <= 0 || $(x).attr("data-type") === $typeFilter.attr("data-value")) && ($pronounFilter.length <= 0 || $(x).attr("data-pronoun") === $pronounFilter.attr("data-value")) && ($brandFilter.length <= 0 || $(x).attr("data-brand-name") === $brandFilter.attr("data-brand-name"))) $(x).show();
        else $(x).hide();
    });
    // Show/hide 'no talent found' element
    const visibleElements = $rosterRankingsDataContainer.find(".roster-rankings-item:visible");
    const $noRosterRankingsFilterResults = $(".no-roster-rankings-filter-results");
    if (visibleElements.length <= 0) {
        if ($noRosterRankingsFilterResults.length > 0) $noRosterRankingsFilterResults.show();
        else $rosterRankingsDataContainer.append('<div class="no-roster-rankings-filter-results font-bold margin-left-8 light-grey">No Talent Found</div>');
    } else $noRosterRankingsFilterResults.hide();
    // Show numbers
    visibleElements.each(function(i, e) {
        const $rosterRankingsNumber = $(e).find(".roster-rankings-number");
        $rosterRankingsNumber.text(i + 1);
        if (i + 1 <= 10) $rosterRankingsNumber.addClass("menu-header-color font-1p125em");
        else $rosterRankingsNumber.removeClass("menu-header-color font-1p125em");
    });
    $rosterRankingsDataContainer.scrollTop(0);
}
async function $d3e44747ec383890$export$818d6af52bedd640(companyUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view factions data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewFactionsData = await (0, $6PzHO.getViewFactionsData)(companyUid);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) companySelectData = await (0, $8A6FL.getCompanySelectData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show company select
    if (!companyUid) $d3e44747ec383890$export$4e74726e57dcef35(companySelectData, $(".view-factions-company-select"));
    // Show view factions data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showViewFactionsPageData(viewFactionsData);
}
function $d3e44747ec383890$var$showViewFactionsPageData(data) {
    const $viewFactionsItemsContainer = $(".view-factions-items-container");
    const $viewFactionsContainer = $("#view-factions-container");
    $viewFactionsItemsContainer.html("");
    // Show factions
    data.forEach(function(faction) {
        let viewFactionHtml = (0, $9c7fdb096dd8e19a$export$4da77264dc7a7732)(faction);
        $viewFactionsItemsContainer.append(viewFactionHtml);
    });
    // Show empty text if no factions
    if (data.length === 0) {
        let div = '<div class="view-factions-item disabled"><div><span class="grey">No Factions present</span></div></div>';
        $viewFactionsItemsContainer.append(div);
    }
    $viewFactionsContainer.fadeIn("slow");
    $viewFactionsItemsContainer.scrollTop(0);
    // Faction click handler
    $viewFactionsContainer.off("click", ".view-factions-item");
    $viewFactionsContainer.on("click", ".view-factions-item", function() {
        if ($(this).hasClass("disabled")) return false;
        let factionUid = parseInt($(this).attr("data-uid"));
        let factionData = data.filter(function(obj) {
            return obj.uid === factionUid;
        })[0];
        let isCompetitorFaction = $(".view-factions-company-select").find(":selected[data-is-competitor]").length > 0;
        (0, $9c7fdb096dd8e19a$export$91cd24c87164e19f)(factionData, isCompetitorFaction);
    });
}
async function $d3e44747ec383890$var$loadStartNegotiationPage(uid, type) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $3NAMH.getStartNegotiationData)(uid, type);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $d3e44747ec383890$var$showStartNegotiationPageData(data, type);
}
function $d3e44747ec383890$var$showStartNegotiationPageData(data, type) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideContent)($());
        $d3e44747ec383890$var$displayNegotiation(data);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "This {0} could not be found".format((0, $3E8Nt.toTitleCase)(type))
        });
        else if (data["error"] === "capacity") notie.alert({
            type: 3,
            text: "You do not have enough space in your roster. Release superstars or raise your Company Reputation to increase roster capacity."
        });
        else if (data["error"] === "on-trade") notie.alert({
            type: 3,
            text: "This talent is on trade and cannot be negotiated with right now"
        });
    }
}
function $d3e44747ec383890$var$displayNegotiation(data) {
    let parent = $(".negotiation-box");
    parent.data("uid", data["uid"]);
    // Attempts remaining
    parent.find(".negotiation-box-attempts-remaining i.fa-times").show();
    parent.find(".negotiation-box-attempts-remaining i.fa-check").hide();
    if (data["status"] === "accepted_by_talent") {
        parent.find(".negotiation-box-attempts-remaining i.fa-check").show();
        parent.find(".negotiation-box-attempts-remaining i.fa-times").hide();
    } else {
        let attemptsRemainingIcons = parent.find(".negotiation-box-attempts-remaining i.fa-times");
        attemptsRemainingIcons.addClass("light-grey").removeClass("red");
        attemptsRemainingIcons.slice(0, 3 - data["attemptsRemaining"]).addClass("red").removeClass("light-grey");
    }
    // Name and graphic of talent
    parent.find(".negotiation-box-name").text(data["name"]);
    (0, $c82cd471f4baff6b$export$e7557da3ac483fcd)($(".negotiation-box-graphic"), data["graphic"]);
    parent.find(".negotiation-box-dialog-content").text(data["dialog"]).hide().fadeIn("fast");
    // Add default offer of staff estimate
    parent.find(".negotiation-box-offer-input").val(parseInt(data["scoutOfferAmountEstimate"]));
    // Show offer info
    let infoHtml = "";
    if (data["status"] === "negotiating") {
        let staffHtml = "";
        if (data["scoutName"]) staffHtml = "Your Scout, " + data["scoutName"] + ",";
        else staffHtml = "Your Staff";
        let estimateWord = $d3e44747ec383890$var$getScoutEstimateWord(data["scoutLevel"]);
        infoHtml = staffHtml + " gives a " + estimateWord + " estimate of" + '<span class="blue margin-left-5 margin-right-2">' + ' <img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-2"> ' + data["scoutOfferAmountEstimate"] + "</span>" + " for " + data["name"] + "'s value.</span>";
    } else if (data["status"] === "accepted_by_talent") {
        let staffHtml = "";
        if (data["talentManagerName"]) staffHtml = "Your Talent Manager, " + data["talentManagerName"] + ",";
        else staffHtml = "Your Staff";
        infoHtml = staffHtml + " is finalizing the deal. It should be complete next month.";
    } else if (data["status"] === "rejected_by_talent") {
        let offerMonthsWord = (0, $3E8Nt.getMonthsWord)(data["monthsToRemove"]);
        infoHtml = data["name"] + " will not take any more offers from us for the next {0} {1}.".format(data["monthsToRemove"], offerMonthsWord);
    } else if (data["status"] === "rejected_by_company") {
        let offerMonthsWord = (0, $3E8Nt.getMonthsWord)(data["monthsToRemove"]);
        infoHtml = data["receiverCompanyName"] + " have blocked any further offers to " + data["name"] + " for the next {0} {1}.".format(data["monthsToRemove"], offerMonthsWord);
    }
    const $otherOffers = $(".negotiation-box-other-offers");
    if (data["otherOffers"].length > 0) {
        $otherOffers.html("<div>" + data["name"] + " is also negotiating with " + (0, $3E8Nt.commaSeparate)(data["otherOffers"]) + ".</div>");
        $otherOffers.show();
    } else {
        $otherOffers.html("");
        $otherOffers.hide();
    }
    parent.find(".negotiation-box-info").html(infoHtml);
    // Send to main roster button
    if (data["status"] === "accepted_by_talent" && !data["sendToMainRoster"]) parent.find("#negotiation-send-to-main-roster-button").show();
    else parent.find("#negotiation-send-to-main-roster-button").hide();
    if (data["status"] === "negotiating") {
        parent.find("#make-negotiation-offer").show();
        parent.find(".negotiation-box-offer-container").show();
        parent.find(".negotiation-box-other-offers").show();
    } else {
        parent.find("#make-negotiation-offer").hide();
        parent.find(".negotiation-box-offer-container").hide();
        if (data["status"] === "rejected_by_talent") parent.find(".negotiation-box-other-offers").hide();
    }
    parent.fadeIn("fast");
}
function $d3e44747ec383890$var$getScoutEstimateWord(level) {
    switch(level){
        case null:
            return "crude";
        case 1:
            return "rough";
        case 2:
            return "decent";
        case 3:
            return "good";
    }
}
function $d3e44747ec383890$var$incrementNegotiationOfferAmount() {
    const $negotiationBoxOfferInput = $(".negotiation-box-offer-input");
    let offerInputValue = parseInt($negotiationBoxOfferInput.val());
    if (offerInputValue < 3000) $negotiationBoxOfferInput.val(offerInputValue + 25);
}
function $d3e44747ec383890$var$decreaseNegotiationOfferAmount() {
    const $negotiationBoxOfferInput = $(".negotiation-box-offer-input");
    let offerInputValue = parseInt($negotiationBoxOfferInput.val());
    if (offerInputValue > 0) $negotiationBoxOfferInput.val(offerInputValue - 25);
}
async function $d3e44747ec383890$var$getMakeNegotiationOfferRequest(uid, amount) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $3NAMH.makeNegotiationOffer)(uid, amount);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $d3e44747ec383890$var$showMakeNegotiationOfferData(data);
}
function $d3e44747ec383890$var$showMakeNegotiationOfferData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        $d3e44747ec383890$var$displayNegotiationOfferResult(data);
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to make that offer"
        });
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "This negotiation could not be found. Please try again."
        });
        if (data["error"] === "not-negotiating") notie.alert({
            type: 3,
            text: "You can no longer make offers in this negotiation"
        });
    }
}
async function $d3e44747ec383890$var$getNegotiationSendToMainRosterRequest(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $3NAMH.negotiationSendToMainRoster)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $d3e44747ec383890$var$showNegotiationSendToMainRosterData(data);
}
function $d3e44747ec383890$var$showNegotiationSendToMainRosterData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        $(".negotiation-box").find("#negotiation-send-to-main-roster-button").hide();
        let notieText = "Talent will be sent to the Main Roster";
        if (data["acceleratedTrainingFacility"]) notieText += " for no extra cost due to the Accelerated Training Facility";
        notie.alert({
            type: 4,
            text: notieText
        });
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points."
        });
        if (data["error"] === "already-set") notie.alert({
            type: 3,
            text: "This talent has already been set to be sent to the Main Roster."
        });
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "This negotiation could not be found. Please try again."
        });
    }
}
function $d3e44747ec383890$var$displayNegotiationOfferResult(data) {
    let $negotiationBox = $(".negotiation-box");
    $negotiationBox.find(".negotiation-box-dialog-content").text(data["dialog"]).hide().fadeIn("fast");
    if (data["offerRejected"]) {
        let icon = $negotiationBox.find(".negotiation-box-attempts-remaining i.fa-times.light-grey").first();
        icon.addClass("red").removeClass("light-grey");
        if (data["negotiationRejected"]) {
            let infoHtml = data["name"] + " will not take any more offers from us.";
            $negotiationBox.find(".negotiation-box-info").html(infoHtml);
            $negotiationBox.find("#make-negotiation-offer").hide();
            $negotiationBox.find(".negotiation-box-offer-container").hide();
            $negotiationBox.find(".negotiation-box-other-offers").hide();
        }
    }
    if (data["offerAccepted"]) {
        $negotiationBox.find(".negotiation-box-attempts-remaining i.fa-check").show();
        $negotiationBox.find(".negotiation-box-attempts-remaining i.fa-times").hide();
        let staffHtml = "";
        if (data["talentManagerName"]) staffHtml = "Your Talent Manager, " + data["talentManagerName"] + ",";
        else staffHtml = "Your Staff";
        let infoHtml;
        if (data["companyName"]) infoHtml = staffHtml + " will finalize the deal with " + data["companyName"] + " by next month.";
        else infoHtml = staffHtml + " will finalize the deal by next month.";
        $negotiationBox.find(".negotiation-box-info").html(infoHtml);
        $negotiationBox.find("#make-negotiation-offer").hide();
        $negotiationBox.find("#negotiation-send-to-main-roster-button").show();
        $negotiationBox.find(".negotiation-box-offer-container").hide();
    }
}
async function $d3e44747ec383890$export$eb0e5b221232766e(talentUid, talentType, talentName, task) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getAddStaffTaskData)(talentUid, task);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $d3e44747ec383890$var$showAddStaffTaskPageData(data, talentUid, talentType, talentName, task);
}
function $d3e44747ec383890$var$showAddStaffTaskPageData(data, talentUid, talentType, talentName, task) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideContent)($());
        let $addStaffTaskContainer = $("#add-staff-task-container");
        // Get task name and staff role
        let taskName;
        let staffRole;
        if (task === "unlearn trait" || task === "transition (staff)") staffRole = "Staff";
        else staffRole = (0, $3E8Nt.toTitleCase)(data["role"].replace(/_/g, " "));
        if (task === "unlearn trait") taskName = "Unlearn Trait For {0}".format(talentName);
        else taskName = "{0} {1}".format((0, $3E8Nt.toTitleCase)(task), talentName);
        $addStaffTaskContainer.find(".add-staff-task-name").text(taskName);
        $addStaffTaskContainer.find(".add-staff-task-role").text(staffRole + " To Assign");
        // Add top role info
        if (data["topRolesData"] && data["topRolesData"].length > 0) {
            let rolesData = [];
            data["topRolesData"].forEach(function(roleData) {
                rolesData.push("{0} ({1})".format((0, $3E8Nt.toTitleCase)(roleData["role"].replace(/_/g, " ")), roleData["boostNames"].join(", ")));
            });
            let roleInfoHtml = "Your Staff believes that {0} will be best suited as a {1}.".format(talentName, (0, $3E8Nt.commaSeparate)(rolesData, "or"));
            $(".transition-to-staff-role-info").text(roleInfoHtml).show();
        } else $(".transition-to-staff-role-info").hide();
        // Populate staff select
        let staffMemberSelect = $addStaffTaskContainer.find(".add-staff-task-staff-select");
        let staffOptions = "";
        data["availableStaffMembers"].forEach(function(staff) {
            // Show roles if showing all staff
            let staffOptionRole = "";
            if (task === "unlearn trait" || task === "transition (staff)") staffOptionRole = " " + (0, $3E8Nt.toTitleCase)(staff["role"].replace(/_/g, " "));
            staffOptions += '<option value="' + staff["uid"] + '">' + staff["name"] + " (Lvl " + staff["level"] + staffOptionRole + ")</option>";
        });
        staffMemberSelect.html(staffOptions);
        // Show/hide selects
        $addStaffTaskContainer.find(".add-staff-task-trait-select").parent().hide();
        $addStaffTaskContainer.find(".add-staff-task-skill-select").parent().hide();
        $addStaffTaskContainer.find(".add-staff-task-role-select").parent().hide();
        if (task === "train") {
            $addStaffTaskContainer.find(".add-staff-task-skill-select").parent().show();
            $addStaffTaskContainer.find(".add-staff-task-skill-select").val("workrate");
        } else if (task === "unlearn trait") {
            $addStaffTaskContainer.find(".add-staff-task-trait-select").parent().show();
            // Populate trait select
            let traitOptions = "";
            let superstarTraits = $("#unlearn-talent-trait-button").data("canUnlearnTraits");
            superstarTraits.forEach(function(trait) {
                traitOptions += "<option>" + trait + "</option>";
            });
            $addStaffTaskContainer.find(".add-staff-task-trait-select").html(traitOptions);
        } else if (task === "transition (staff)") {
            $addStaffTaskContainer.find(".add-staff-task-role-select").parent().show();
            $addStaffTaskContainer.find(".add-staff-task-role-select").val("producer");
        }
        // Show/hide info
        let addStaffTaskInfo = $d3e44747ec383890$var$getAddStaffTaskInfo(task);
        if (addStaffTaskInfo) {
            $addStaffTaskContainer.find(".add-staff-task-info-text").html(addStaffTaskInfo);
            $addStaffTaskContainer.find(".add-staff-task-info").show();
        } else $addStaffTaskContainer.find(".add-staff-task-info").hide();
        // Show cost
        let cost = 10;
        if (task === "transition (staff)") cost = 50;
        $addStaffTaskContainer.find(".add-staff-task-cost").text(cost);
        // Set data
        $addStaffTaskContainer.data("talentUid", talentUid);
        $addStaffTaskContainer.data("talentType", talentType);
        $addStaffTaskContainer.data("task", task);
        $addStaffTaskContainer.fadeIn("slow").removeClass("display-none");
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "no-staff-member") {
            let errorText;
            if (task === "unlearn trait") errorText = "You need to have a Staff Member available to unlearn traits for talent";
            else if (task === "transition (staff)") errorText = "You need to have a Staff Member (besides a Doctor) available to transition talent to staff";
            else errorText = "You need to have a {0} available on your staff to {1} talent".format((0, $3E8Nt.toTitleCase)(data["role"].replace(/_/g, " ")), task);
            if (!(0, $98xmD.globals).game["paid"]) errorText += " (JoW Paid)";
            notie.alert({
                type: 3,
                text: errorText
            });
        }
    }
}
async function $d3e44747ec383890$var$getAddStaffTaskRequest(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName, replace) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.addStaffTask)(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName, replace);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    await $d3e44747ec383890$var$showAddStaffTaskData(data, talentUid, talentType, staffUid, taskName, skillName, traitName, roleName);
}
async function $d3e44747ec383890$var$showAddStaffTaskData(data, talentUid, talentType, staffUid, taskName, skillName, traitName, roleName) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let taskNameDisplay = taskName === "unlearn trait" ? "unlearn a trait for " : taskName;
        notie.alert({
            type: 4,
            text: "{0} has been assigned to {1} {2}".format(data["staffMemberName"], taskNameDisplay, data["talentName"]),
            stay: true
        });
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        setTimeout(function() {
            $("#add-staff-task-container").hide();
            if (taskName === "transition (talent)") $("#view-company-staff-menu-button").trigger("click");
            else $(".roster-member-details-back-button").trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-paid") notie.alert({
            type: 3,
            text: "You can only add Staff tasks in JoW Paid."
        });
        if (data["error"] === "talent-not-found") notie.alert({
            type: 3,
            text: "The selected talent could not be found. Please try again."
        });
        if (data["error"] === "staff-not-found") notie.alert({
            type: 3,
            text: "The selected staff could not be found. Please try again."
        });
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to add this task"
        });
        if (data["error"] === "task-present") // Confirm task replacement
        notie.confirm({
            text: "{0} is already working on {1}. Do you want to replace that task with this one?".format(data["staffMemberName"], data["currentTask"]),
            submitCallback: async function() {
                await $d3e44747ec383890$var$getAddStaffTaskRequest(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName, true);
            },
            cancelText: "No"
        });
        if (data["error"] === "negotiating-buyout") notie.alert({
            type: 3,
            text: "{0} is already working on {1}.".format(data["staffMemberName"], data["currentTask"])
        });
        if (data["error"] === "no-task") notie.alert({
            type: 3,
            text: "That task could not be added. Please try again."
        });
        if (data["error"] === "trainer-level-2") notie.alert({
            type: 3,
            text: "This task can only be performed by a Level 2 Trainer or above."
        });
        if (data["error"] === "leaving-talent") notie.alert({
            type: 3,
            text: data["talentName"] + " has decided to leave the company and cannot be worked on."
        });
        if (data["error"] === "high-morale-talent") notie.alert({
            type: 3,
            text: data["talentName"] + "'s morale is already high."
        });
        if (data["error"] === "task-already-present") notie.alert({
            type: 3,
            text: "{0} is already working on {1}. Please cancel that task first.".format(data["otherStaff"], data["otherStaffTask"])
        });
        if (data["error"] === "short-injury") notie.alert({
            type: 3,
            text: data["talentName"] + "'s injury is not severe enough to benefit from rehab."
        });
        if (data["error"] === "non-injury") notie.alert({
            type: 3,
            text: data["talentName"] + "'s injury cannot benefit from rehab (it might be a kayfabe injury or an injury that was set when the game started)"
        });
        if (data["error"] === "doctor-level-2") notie.alert({
            type: 3,
            text: "This task can only be performed by a Level 2 Doctor or above."
        });
        if (data["error"] === "medical-facility-level-2") notie.alert({
            type: 3,
            text: "You need to have a Developed (Level 2) Medical Facility to rehab talent."
        });
        if (data["error"] === "trait-not-found") notie.alert({
            type: 3,
            text: "The selected trait could not be found. Please try again."
        });
        if (data["error"] === "cannot-unlearn-trait") notie.alert({
            type: 3,
            text: "The selected trait cannot be unlearned."
        });
        if (data["error"] === "wrong-staff-role-to-unlearn") notie.alert({
            type: 3,
            text: "The selected trait can only be unlearned by a {0}.".format((0, $3E8Nt.toTitleCase)(data["staffRoleToUnlearn"].replace(/_/g, " ")))
        });
        if (data["error"] === "trade-talent") notie.alert({
            type: 3,
            text: data["talentName"] + " is on trade and cannot be transitioned to staff."
        });
        if (data["error"] === "wrong-staff-role-to-transition") notie.alert({
            type: 3,
            text: "The selected role requires a {0} to work on the transition.".format((0, $3E8Nt.toTitleCase)(roleName.replace(/_/g, " ")))
        });
        if (data["error"] === "different-existing-staff-role") notie.alert({
            type: 3,
            text: "{0} is only interested in transitioning back to a {1}.".format(data["talentName"], (0, $3E8Nt.toTitleCase)(data["existingRole"].replace(/_/g, " ")))
        });
        if (data["error"] === "max-roles") notie.alert({
            type: 3,
            text: "Your {0} Facility only allows a maximum of {1} {2}s (including transitioning superstars).".format(data["facilityName"], data["numberOfRoles"], (0, $3E8Nt.toTitleCase)(roleName.replace(/_/g, " ")))
        });
        if (data["error"] === "task-assigned-to-self") notie.alert({
            type: 3,
            text: "Staff cannot work on themselves. Please select someone else."
        });
        if (data["error"] === "no-superstar-object-present") notie.alert({
            type: 3,
            text: "Only staff who were previously superstars can be transitioned back."
        });
        if (data["error"] === "mars") notie.alert({
            type: 3,
            text: "You cannot transition talent to staff in Wrestling on Mars."
        });
        if (data["error"] === "passion") notie.alert({
            type: 3,
            text: "You cannot transition talent to staff in Passion of Wrestling."
        });
        if (data["error"] === "role-requirement-failed") notie.alert({
            type: 3,
            text: "{0} does not have the necessary skills to become a {1} ({2}).".format(data["talentName"], roleName.replace(/_/g, " "), data["requirementName"])
        });
        if (data["error"] === "transition-declined") notie.alert({
            type: 3,
            text: "{0} is not interested in transitioning to staff at this point ({1}).".format(data["talentName"], data["declinedReason"])
        });
    }
}
function $d3e44747ec383890$var$getAddStaffTaskInfo(task) {
    if (task === "unlearn trait") return "Unlearning a Trait takes 6 months and requires Staff with a specific role related to the Trait. The chance of success depends on the skill of the Staff Member.";
    else if (task === "transition (staff)") return "Transitioning to Staff takes 2 months. Transitioned Superstars cannot be used as Talent unless they are transitioned back.";
    else if (task === "train") return "Training takes 3 months.";
    else if (task === "reassure") return "Reassuring takes 1 month.";
    else if (task === "transition") return "Transitioning takes 1 month.";
    else if (task === "scout") return "Scouting takes 1 month.";
    else if (task === "recruit") return "Recruiting takes 1 month.";
    else if (task === "prepare") return "Preparing for callups takes 1-2 months, depending on the level of the Staff Member.";
    else if (task === "rehab") return "Rehab is assigned for the duration of the injury.";
    else if (task === "transition (talent)") return "Transitioning to Talent takes 2 months.";
    else return "";
}
async function $d3e44747ec383890$var$loadAddManagerRelationshipPage(uid, checkBrandExclusivity) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getAddManagerRelationshipData)(checkBrandExclusivity);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showAddManagerRelationshipPageData(data, uid);
}
function $d3e44747ec383890$var$showAddManagerRelationshipPageData(data, uid) {
    // Populate manager select
    let managerSelect = $("#add-manager-relationship .add-manager-relationship-manager-select");
    let managerOptionsHtml = "";
    managerOptionsHtml += "<option selected disabled value>Select Manager</option>";
    // Put full time managers and superstars into optgroups
    let fullTimeManagersOptions = "";
    let superstarsOptions = "";
    data["managerSelections"].forEach(function(manager) {
        let managerOptionHtml = '<option value="' + manager["uid"] + '">' + manager["name"] + "</option>";
        if (manager["fullTimeManager"]) fullTimeManagersOptions += managerOptionHtml;
        else superstarsOptions += managerOptionHtml;
    });
    managerOptionsHtml += '<optgroup label="Full-time Managers">' + fullTimeManagersOptions + "</optgroup>";
    managerOptionsHtml += '<optgroup label="Superstars">' + superstarsOptions + "</optgroup>";
    managerSelect.html(managerOptionsHtml);
    // Populate talent select
    let talentSelect = $("#add-manager-relationship .add-manager-relationship-talent-select");
    talentSelect.slice(1).parent().remove(); // Remove extra talent selects
    let talentOptions = "";
    talentOptions += "<option selected disabled value>Select Talent</option>";
    data["talentSelections"].forEach(function(talent) {
        talentOptions += '<option value="' + talent["uid"] + '" data-type="' + talent["type"] + '">' + talent["name"] + "</option>";
    });
    talentSelect.html(talentOptions);
    // Select uid if present
    if (uid && managerSelect.find("option[value='" + uid + "']").length > 0) managerSelect.val(uid);
    $("#add-manager-relationship").fadeIn("slow").removeClass("display-none");
}
async function $d3e44747ec383890$var$loadRemoveManagerRelationshipPage(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getRemoveManagerRelationshipData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showRemoveManagerRelationshipPageData(data, uid);
}
function $d3e44747ec383890$var$showRemoveManagerRelationshipPageData(data, uid) {
    // Populate manager select
    let managerSelect = $("#remove-manager-relationship .remove-manager-relationship-manager-select");
    let managerOptionsHtml = "";
    data["managerSelections"].forEach(function(manager) {
        managerOptionsHtml += '<option value="' + manager["uid"] + '">' + manager["name"] + "</option>";
    });
    managerSelect.html(managerOptionsHtml);
    // Remove extra talent selects
    let talentSelect = $("#remove-manager-relationship .remove-manager-relationship-talent-select");
    talentSelect.slice(1).parent().remove();
    // Show manager talent upon remove manager select
    const $removeManagerRelationship = $("#remove-manager-relationship");
    $removeManagerRelationship.off("change", ".remove-manager-relationship-manager-select");
    $removeManagerRelationship.on("change", ".remove-manager-relationship-manager-select", function() {
        // Get selected manager data
        let el = $(this);
        let selectedManagerData = data["managerSelections"].filter(function(managerSelection) {
            return managerSelection["uid"] === parseInt(el.val());
        })[0];
        // Remove extra talent selects
        talentSelect = $("#remove-manager-relationship .remove-manager-relationship-talent-select");
        talentSelect.slice(1).parent().remove();
        // Populate talent select
        let talentOptions = "";
        talentOptions += "<option selected disabled value>Select Talent</option>";
        selectedManagerData["talentData"].forEach(function(talent) {
            talentOptions += '<option value="' + talent["uid"] + '">' + talent["name"] + "</option>";
        });
        talentSelect.html(talentOptions);
    });
    // Select first manager if present
    if (data["managerSelections"].length > 0) managerSelect.val(managerSelect.find("option:first").val()).trigger("change");
    else {
        managerSelect.html("<option selected disabled value>Select Manager</option>");
        talentSelect.html("<option selected disabled value>Select Talent</option>");
    }
    // Select uid if present
    if (uid && managerSelect.find("option[value='" + uid + "']").length > 0) managerSelect.val(uid).trigger("change");
    $("#remove-manager-relationship").fadeIn("slow").removeClass("display-none");
}
async function $d3e44747ec383890$var$getAddManagerRelationshipRequest() {
    if ((0, $98xmD.globals).requestRunning) return;
    let parent = $("#add-manager-relationship");
    // Get uid for manager
    let managerUid = parseInt(parent.find(".add-manager-relationship-manager-select").find(":selected").val());
    // Get talent selects that have a value selected
    let talentSelects = parent.find(".add-manager-relationship-talent-select").filter(function(i, x) {
        return $(x).val();
    });
    // Get uid and type for talent
    let talentData = Array.from(talentSelects, function(el) {
        let elSelectedOption = $(el).find(":selected");
        return {
            "uid": parseInt(elSelectedOption.val()),
            "type": elSelectedOption.attr("data-type")
        };
    });
    // Validate
    if (!managerUid) {
        notie.alert({
            type: 3,
            text: "Select a manager to be assigned to talent"
        });
        return false;
    }
    if (talentData.length <= 0) {
        notie.alert({
            type: 3,
            text: "Select talent to be assigned to the manager"
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.addManagerRelationship)(managerUid, talentData);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $d3e44747ec383890$var$showAddManagerRelationshipData(data);
}
function $d3e44747ec383890$var$showAddManagerRelationshipData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block">Assigned {0} to manage {1}</span>'.format(data["managerName"], (0, $3E8Nt.commaSeparate)(data["managedSuperstarsNames"]));
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to view managers
        setTimeout(function() {
            $("#view-managers-menu-button").trigger("click");
        }, 1000);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to add a manager relationship."
        });
        if (data["error"] === "manager-not-found") notie.alert({
            type: 3,
            text: "The selected manager could not be found. Please try again."
        });
        if (data["error"] === "talent-not-found") notie.alert({
            type: 3,
            text: "One of the selected talent could not be found. Please try again."
        });
        if (data["error"] === "maximum-superstars") notie.alert({
            type: 3,
            text: "A manager cannot manage more than 15 superstars."
        });
        if (data["error"] === "manager-present") notie.alert({
            type: 3,
            text: "{0} already has a manager present.".format(data["superstarName"])
        });
        if (data["error"] === "managing-self") notie.alert({
            type: 3,
            text: "Superstars cannot manage themselves."
        });
        if (data["error"] === "managing-full-time-manager") notie.alert({
            type: 3,
            text: "Full-time managers cannot be managed."
        });
    }
}
async function $d3e44747ec383890$var$getRemoveManagerRelationshipRequest() {
    if ((0, $98xmD.globals).requestRunning) return;
    let parent = $("#remove-manager-relationship");
    // Get uid for manager
    let managerUid = parseInt(parent.find(".remove-manager-relationship-manager-select").find(":selected").val());
    // Get talent selects that have a value selected
    let talentSelects = parent.find(".remove-manager-relationship-talent-select").filter(function(i, x) {
        return $(x).val();
    });
    // Get uid for talent
    let talentData = Array.from(talentSelects, function(el) {
        let elSelectedOption = $(el).find(":selected");
        return {
            "uid": parseInt(elSelectedOption.val())
        };
    });
    // Validate
    if (talentData.length <= 0) {
        notie.alert({
            type: 3,
            text: "Select talent to be removed from the manager"
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.removeManagerRelationship)(managerUid, talentData);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $d3e44747ec383890$var$showRemoveManagerRelationshipData(data);
}
function $d3e44747ec383890$var$showRemoveManagerRelationshipData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block">Removed {0} from {1}</span>'.format((0, $3E8Nt.commaSeparate)(data["removedSuperstarsNames"]), data["managerName"]);
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Go back to view managers
        setTimeout(function() {
            $("#view-managers-menu-button").trigger("click");
        }, 1000);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "manager-not-found") notie.alert({
            type: 3,
            text: "The selected manager could not be found. Please try again."
        });
        if (data["error"] === "talent-not-found") notie.alert({
            type: 3,
            text: "One of the selected talent could not be found. Please try again."
        });
        if (data["error"] === "not-manager") notie.alert({
            type: 3,
            text: "{0} is not managed by this manager.".format(data["superstarName"])
        });
    }
}
async function $d3e44747ec383890$var$loadAddTeamPage() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $jpMCP.getAddTeamData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showAddTeamPageData(data);
}
function $d3e44747ec383890$var$showAddTeamPageData(data) {
    const $addTeam = $("#add-team");
    // Reset inputs
    $addTeam.find('select[name="tag-team-type-option"]').val("tag-team").trigger("change");
    $addTeam.find(".add-team-superstar-select").html("");
    $addTeam.find("input").val("");
    let superstarSelects = $("#add-team .add-team-superstar-select");
    superstarSelects.html("");
    // Populate participant select
    let optionsHtml = "";
    optionsHtml += "<option selected disabled>Select Superstar</option>";
    data.forEach(function(superstar) {
        optionsHtml += '<option value="' + superstar.replace(/"/g, "&quot;") + '">' + superstar + "</option>";
    });
    superstarSelects.html(optionsHtml);
    $addTeam.fadeIn("slow").removeClass("display-none");
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_add_team_menu_button");
}
async function $d3e44747ec383890$var$getAddTeamRequest() {
    if ((0, $98xmD.globals).requestRunning) return;
    let name = $("#add-team input[name=team-name]").val();
    let firstSuperstar = $("#add-team .add-team-first-superstar-select").val();
    let secondSuperstar = $("#add-team .add-team-second-superstar-select").val();
    let thirdSuperstar = $("#add-team .add-team-third-superstar-select").val();
    let teamType = $("#add-team select[name=tag-team-type-option]").val();
    // Validate
    if (name.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Team"
        });
        return false;
    }
    if (!firstSuperstar) {
        notie.alert({
            type: 3,
            text: "Select the first Superstar"
        });
        return false;
    }
    if (!secondSuperstar) {
        notie.alert({
            type: 3,
            text: "Select the second Superstar"
        });
        return false;
    }
    if (teamType === "trio" && !thirdSuperstar) {
        notie.alert({
            type: 3,
            text: "Select the third Superstar"
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $jpMCP.addTeam)(name, firstSuperstar, secondSuperstar, thirdSuperstar, teamType);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $d3e44747ec383890$var$showAddTeamData(data);
}
function $d3e44747ec383890$var$showAddTeamData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block">' + "Added {0} ({1}) to the Roster!".format(data["tagTeamName"], data["tagTeamType"]) + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("add_team");
        // Go back to view teams
        setTimeout(function() {
            $("#view-teams-menu-button").trigger("click");
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "One of the selected Superstars could not be found. Please try again."
        });
        else if (data["error"] === "already-present") notie.alert({
            type: 3,
            text: "A Team with that name already exists"
        });
        else if (data["error"] === "faction-already-present") notie.alert({
            type: 3,
            text: "A Faction with that name already exists"
        });
        else if (data["error"] === "duplicate-superstars") notie.alert({
            type: 3,
            text: "Superstars cannot tag with themselves"
        });
        else if (data["error"] === "already-in-tag-team") notie.alert({
            type: 3,
            text: data["superstarName"] + " is already in a " + data["tagTeamType"]
        });
        else if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to add a Team"
        });
    }
}
async function $d3e44747ec383890$var$loadAddSuperstarPage($el) {
    if ((0, $98xmD.globals).requestRunning) return;
    if ((0, $98xmD.globals).game.story === "passion") {
        notie.alert({
            type: 3,
            text: "You cannot add custom superstars or managers in Passion of Wrestling"
        });
        return false;
    }
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getCompanyBrandNames)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showAddSuperstarPageData(data, $el);
}
function $d3e44747ec383890$var$showAddSuperstarPageData(data, $el) {
    // Add select data
    let brandNameSelect = $('#add-superstar select[name="custom-superstar-brand"]');
    (0, $1JSre.populateBrandNameSelect)(data, brandNameSelect);
    let parentContainer = $el.closest(".box");
    let addSuperstarElement = $("#add-superstar");
    let $graphic = $("#wrestler-graphic");
    $graphic.html("").show();
    (0, $c82cd471f4baff6b$export$f4b4d1e8d535dcff)($graphic);
    addSuperstarElement.fadeIn("slow").removeClass("display-none");
    addSuperstarElement.find(".character-creator-controls").show();
    // Reset inputs
    addSuperstarElement.find("input").val("");
    addSuperstarElement.find('select[name="custom-superstar-pronoun"]').val("he");
    addSuperstarElement.find('select[name="custom-superstar-charisma"], select[name="custom-superstar-workrate"]').val("1");
    addSuperstarElement.find('select[name="custom-superstar-alignment-select"]').val("");
    addSuperstarElement.find('select[name="superstar-graphic-option"]').val("1").trigger("change");
    addSuperstarElement.find('select[name="custom-superstar-part-timer"]').val("0");
    addSuperstarElement.find(".add-superstar-cost").text("100");
    addSuperstarElement.find(".superstar-traits-selection-text").text("None").removeClass("superstar-trait-color");
    addSuperstarElement.find(".superstar-trait-item-container").removeClass("selected");
    addSuperstarElement.find(".superstar-trait-items-container").hide();
    addSuperstarElement.find(".superstar-traits-information").text("Select a trait to display its details here").hide();
    addSuperstarElement.find(".superstar-traits-show-button").find("span").text("Show Traits");
    addSuperstarElement.find(".superstar-traits-show-button").find("i").addClass("fa-angle-down").removeClass("fa-angle-up");
    if (parentContainer[0].id === "view-managers-container") addSuperstarElement.find('select[name="custom-superstar-full-time-manager"]').val("1");
    else addSuperstarElement.find('select[name="custom-superstar-full-time-manager"]').val("0");
    if ((0, $98xmD.globalUser).paid) {
        addSuperstarElement.find('select[name="custom-superstar-full-time-manager"]').parent().show();
        addSuperstarElement.find('select[name="custom-superstar-brand"]').parent().show();
    } else {
        addSuperstarElement.find('select[name="custom-superstar-full-time-manager"]').parent().hide();
        addSuperstarElement.find('select[name="custom-superstar-brand"]').parent().hide();
    }
    addSuperstarElement.data("element", parentContainer[0].id);
}
async function $d3e44747ec383890$var$loadReleaseSuperstarPage() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getCompanySuperstarsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $d3e44747ec383890$var$showReleaseSuperstarPageData(data);
}
function $d3e44747ec383890$var$showReleaseSuperstarPageData(data) {
    let div = $("#release-superstar .select-superstar-all");
    div.html("");
    $.each(data, function() {
        div.append($("<option />").val(this.value).text(this.name).data("uid", this.uid));
    });
    $("#release-superstar").fadeIn("slow").removeClass("display-none");
}
async function $d3e44747ec383890$var$getAddSuperstarRequest() {
    if ((0, $98xmD.globals).requestRunning) return;
    let parent = $("#add-superstar");
    let name = parent.find("input[name='name']").val();
    let age = parseInt(parent.find("input[name='age']").val());
    let pronoun = parent.find("select[name='custom-superstar-pronoun']").val();
    let alignment = parent.find("select[name='custom-superstar-alignment-select']").val();
    let partTimer = parent.find("select[name='custom-superstar-part-timer']").val() === "1";
    let charisma = parseInt(parent.find("select[name='custom-superstar-charisma']").val());
    let workrate = parseInt(parent.find("select[name='custom-superstar-workrate']").val());
    let fullTimeManager = parent.find("select[name='custom-superstar-full-time-manager']").val() === "1";
    let brandName = parent.find("select[name='custom-superstar-brand']").val();
    // Get graphic data
    $("#add-superstar .share-character").trigger("click").removeClass("selected");
    $("#add-superstar .share-character-code-container").hide();
    let graphicData = $("#add-superstar .share-character-code-input").val();
    let addGraphic = parent.find("select[name='superstar-graphic-option']").val() === "1";
    // Get traits
    let selectedTraits = Array.from(parent.find(".superstar-trait-item-container.selected"), function(x) {
        return $(x).text().trim().replace(/\s+/g, " ");
    });
    // Validate
    if (name.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Superstar"
        });
        return false;
    }
    if (age.length <= 0 || !age) {
        notie.alert({
            type: 3,
            text: "Enter a number for the Superstar's Age"
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $jpMCP.addSuperstar)(name, age, pronoun, alignment, partTimer, charisma, workrate, fullTimeManager, brandName, graphicData, addGraphic, selectedTraits);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $d3e44747ec383890$var$showAddSuperstarData(data);
}
function $d3e44747ec383890$var$showAddSuperstarData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block">' + data["superstarName"] + " added to the Main Roster" + "</span>";
        notie.alert({
            type: 4,
            text: html
        });
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Go back to view roster/managers
        setTimeout(function() {
            if ($("#add-superstar").data("element") === "view-managers-container") $("#view-managers-menu-button").trigger("click");
            else $("#view-roster-menu-button").trigger("click");
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to add a Superstar"
        });
        if (data["error"] === "managers-paid") notie.alert({
            type: 3,
            text: "Managers are only available in JoW Paid"
        });
        if (data["error"] === "brands-paid") notie.alert({
            type: 3,
            text: "Brands are only available in JoW Paid"
        });
        if (data["error"] === "brand-not-found") notie.alert({
            type: 3,
            text: "That brand could not be found. Please try again."
        });
        if (data["error"] === "already-exists") notie.alert({
            type: 3,
            text: "A Superstar with that name already exists in your " + data["existsRoster"] + " Roster"
        });
        if (data["error"] === "owner-name") notie.alert({
            type: 3,
            text: "The Superstar's name cannot be the same as the owner's name"
        });
        if (data["error"] === "age") notie.alert({
            type: 3,
            text: "Please enter an age between 10 and 100"
        });
    }
}
async function $d3e44747ec383890$var$getReleaseSuperstarRequest() {
    if ((0, $98xmD.globals).requestRunning) return;
    let uid = $("#release-superstar").find(".select-superstar-all").find(":selected").data("uid");
    let type = "superstar";
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $jpMCP.releaseTalent)({
        uid: uid,
        type: type
    });
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $d3e44747ec383890$var$showReleaseSuperstarData(data);
}
function $d3e44747ec383890$var$showReleaseSuperstarData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let overnessDecrease = '<span class="stale-color">' + data["overnessDecrease"] + '<span class="margin-left-2">%</span></span>';
        let html = '<span class="display-block">' + data["name"] + " has been released, " + "lowering " + data["possessivePronoun"] + " Overness by " + overnessDecrease + "</span>";
        notie.alert({
            type: 4,
            text: html
        });
        // Select next superstar
        let selected = $("#release-superstar").find(".select-superstar-all").find(":selected");
        selected.next().prop("selected", true);
        // Remove released superstar
        selected.remove();
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "Talent not found in your roster"
        });
        else if (data["error"] === "champion") notie.alert({
            type: 3,
            text: "Champions cannot be released"
        });
        else if (data["error"] === "trade-deal") notie.alert({
            type: 3,
            text: "Talent belonging to other Companies cannot be released"
        });
        else if (data["error"] === "martian") notie.alert({
            type: 3,
            text: "Markus won't put through the release of any Martians"
        });
        else if (data["error"] === "pow-person") notie.alert({
            type: 3,
            text: '"What? No, we need that talent!" - Hank Hughes'
        });
        else if (data["error"] === "booked") notie.alert({
            type: 3,
            text: "Talent booked in a match cannot be released"
        });
    }
}
function $d3e44747ec383890$var$updateCustomSuperstarCost() {
    // Update cost with superstar attribute change
    let cost = 100;
    let addSuperstarElement = $("#add-superstar");
    let workrate = addSuperstarElement.find("select[name='custom-superstar-workrate']").val();
    let charisma = addSuperstarElement.find("select[name='custom-superstar-charisma']").val();
    let selectedTraits = addSuperstarElement.find(".superstar-trait-item-container.selected");
    cost += (workrate - 1) * 75;
    cost += (charisma - 1) * 75;
    cost += selectedTraits.length * 50;
    $(".add-superstar-cost").text(cost);
    return cost;
}
function $d3e44747ec383890$export$f81d542126046733(element) {
    let traitName = element.text().trim().replace(/\s+/g, " ");
    let validationFailed = false;
    let parentContainer = element.closest(".superstar-trait-items-container");
    let superstarTraitInformationElement = parentContainer.siblings(".superstar-traits-selection-container").find(".superstar-traits-information");
    let selectedTraitsTextElement = parentContainer.siblings(".superstar-traits-selection-container").find(".superstar-traits-selection-text");
    if (element.hasClass("selected")) {
        // Deselect trait
        element.removeClass("selected");
        superstarTraitInformationElement.text("Select a trait to display its details here");
    } else {
        // Check if less than max traits selected
        let selectedTraits = parentContainer.find(".superstar-trait-item-container.selected");
        if (selectedTraits.length >= (0, $3E8Nt.gameLimits).maxTraits) {
            notie.alert({
                type: 4,
                text: `You cannot select more than ${(0, $3E8Nt.gameLimits).maxTraits} Traits`
            });
            return false;
        }
        // Check for conflicting traits
        selectedTraits.each(function(i, selectedTraitElement) {
            // Convert conflicting traits attribute into list, check if this trait is present in list
            let conflictingTraitsArray = $(selectedTraitElement).attr("data-conflicting-traits").split(",");
            if (conflictingTraitsArray.indexOf(traitName) >= 0) {
                let conflictText = "{0} has a conflict with {1}. Unselect it before selecting this Trait.".format(traitName, $(selectedTraitElement).text());
                superstarTraitInformationElement.html(conflictText);
                validationFailed = true;
            }
        });
        if (validationFailed) return false;
        element.addClass("selected");
        // Show trait information
        let traitInformationText = $d3e44747ec383890$var$getSuperstarTraitHelpText(traitName);
        superstarTraitInformationElement.text(traitName + ": " + traitInformationText);
    }
    let selectedTraitElements = parentContainer.find(".superstar-trait-item-container.selected");
    // Update selected traits text
    let selectedTraitsHtmlArray = Array.from(selectedTraitElements, function(x) {
        let selectedTraitName = $(x).text().trim().replace(/\s+/g, " ");
        return '<span class="help-text" title="' + $d3e44747ec383890$var$getSuperstarTraitHelpText(selectedTraitName) + '">' + selectedTraitName + "</span>";
    });
    let selectedTraitsHtml;
    if (selectedTraitsHtmlArray.length > 0) {
        selectedTraitsHtml = selectedTraitsHtmlArray.join(", ");
        selectedTraitsTextElement.addClass("superstar-trait-color");
    } else {
        selectedTraitsHtml = "None";
        selectedTraitsTextElement.removeClass("superstar-trait-color");
    }
    selectedTraitsTextElement.html(selectedTraitsHtml);
    // Update hidden input with trait names
    let selectedTraitsNamesArray = Array.from(selectedTraitElements, function(x) {
        return $(x).text().trim().replace(/\s+/g, " ");
    });
    let selectedTraitsNames;
    if (selectedTraitsNamesArray.length > 0) selectedTraitsNames = selectedTraitsNamesArray.join(", ");
    else selectedTraitsNames = "";
    let hiddenInput = parentContainer.siblings(".superstar-traits-selection-container").find(".superstar-traits-selection-input");
    if (hiddenInput.length > 0) hiddenInput.val(selectedTraitsNames);
    if (element.closest("#add-superstar").length > 0) $d3e44747ec383890$var$updateCustomSuperstarCost();
}
function $d3e44747ec383890$var$getSuperstarTraitHelpText(trait) {
    function getTraitChangeHtml(change) {
        return change >= 0 ? "+" + change : "-" + change * -1;
    }
    function getTraitChangeWord(change) {
        return change >= 1.0 ? "Multiplies" : "Reduces";
    }
    if (!(0, $aP7lq.traitsData)) return "";
    let helpTexts = [];
    let traitData = (0, $aP7lq.traitsData)[trait];
    if (traitData) {
        if (traitData["gimmick_match_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["gimmick_match_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} gimmick match rating boost {1} {2}x".format(changeWord, changeVerb, traitData["gimmick_match_multiplier"]));
        }
        if (traitData["holy_shit_moment_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["holy_shit_moment_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} holy shit moment chance in gimmick matches {1} {2}x".format(changeWord, changeVerb, traitData["holy_shit_moment_chance_multiplier"]));
        }
        if (traitData["holy_shit_moment_pure_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["holy_shit_moment_pure_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} holy shit moment chance in non-gimmick matches in 'pure' companies {1} {2}x".format(changeWord, changeVerb, traitData["holy_shit_moment_pure_chance_multiplier"]));
        }
        if (traitData["injury_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["injury_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} chance to get injured {1} {2}x".format(changeWord, changeVerb, traitData["injury_chance_multiplier"]));
        }
        if (traitData["cause_injury_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["cause_injury_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} chance to injure an opponent {1} {2}x".format(changeWord, changeVerb, traitData["cause_injury_chance_multiplier"]));
        }
        if (traitData["add_blood_to_opponent_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["add_blood_to_opponent_chance_boost"]);
            helpTexts.push("Changes chance to make opponent bleed by {0}%".format(change));
        }
        if (traitData["positive_match_rating_boost_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["positive_match_rating_boost_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} positive match rating effect chance {1} {2}x".format(changeWord, changeVerb, traitData["positive_match_rating_boost_multiplier"]));
        }
        if (traitData["negative_match_rating_boost_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["negative_match_rating_boost_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} negative match rating effect chance {1} {2}x".format(changeWord, changeVerb, traitData["negative_match_rating_boost_multiplier"]));
        }
        if (traitData["monthly_event_match_rating_boost"]) {
            let change = getTraitChangeHtml(traitData["monthly_event_match_rating_boost"]);
            helpTexts.push("Changes match ratings by {0} on monthly events".format(change));
        }
        if (traitData["weekly_show_match_rating_boost"]) {
            let change = getTraitChangeHtml(traitData["weekly_show_match_rating_boost"]);
            helpTexts.push("Changes match ratings by {0} on weekly shows".format(change));
        }
        if (traitData["hot_match_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["hot_match_chance_boost"]);
            helpTexts.push("Changes hot match chance by {0}%".format(change));
        }
        if (traitData["no_morale_change_except_rank"]) helpTexts.push("Mostly happy to lose to anyone except {0}s".format(traitData["no_morale_change_except_rank"]));
        if (traitData["no_morale_change_rank"]) helpTexts.push("Mostly happy to lose to {0}s".format(traitData["no_morale_change_rank"]));
        if (traitData["loss_affects_morale_chance"]) helpTexts.push("{0}% chance for losses to lower morale".format(traitData["loss_affects_morale_chance"]));
        if (traitData["win_affects_morale_chance"]) helpTexts.push("{0}% chance for wins to raise morale".format(traitData["win_affects_morale_chance"]));
        if (traitData["leaving_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["leaving_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} chance to leave if unhappy {1} {2}x".format(changeWord, changeVerb, traitData["leaving_chance_multiplier"]));
        }
        if (traitData["training_xp_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["training_xp_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} training XP gain {1} {2}x".format(changeWord, changeVerb, traitData["training_xp_multiplier"]));
        }
        if (traitData["skill_xp_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["skill_xp_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} skill XP gain in matches and segments {1} {2}x".format(changeWord, changeVerb, traitData["skill_xp_multiplier"]));
        }
        if (traitData["retirement_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["retirement_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} retirement chance {1} {2}x".format(changeWord, changeVerb, traitData["retirement_chance_multiplier"]));
        }
        if (traitData["retirement_age_change"]) {
            let change = getTraitChangeHtml(traitData["retirement_age_change"]);
            helpTexts.push("Changes retirement age by {0}".format(change));
        }
        if (traitData["turn_part_timer_age_change"]) {
            let change = getTraitChangeHtml(traitData["turn_part_timer_age_change"]);
            helpTexts.push("Changes age of turning part-timer by {0}".format(change));
        }
        if (traitData["overness_increase_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["overness_increase_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} overness increases {1} {2}x".format(changeWord, changeVerb, traitData["overness_increase_multiplier"]));
        }
        if (traitData["overness_decrease_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["overness_decrease_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} overness decreases {1} {2}x".format(changeWord, changeVerb, traitData["overness_decrease_multiplier"]));
        }
        if (traitData["silly_segment_rating_boost"]) {
            let change = getTraitChangeHtml(traitData["silly_segment_rating_boost"]);
            helpTexts.push("Changes silly segment ratings by {0}".format(change));
        }
        if (traitData["hot_segment_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["hot_segment_chance_boost"]);
            helpTexts.push("Changes hot segment chance by {0}%".format(change));
        }
        if (traitData["face_alignment_hype_boost"]) {
            let change = getTraitChangeHtml(traitData["face_alignment_hype_boost"]);
            helpTexts.push("Changes face alignment hype boost for matches and feuds by {0}".format(change));
        }
        if (traitData["heel_alignment_hype_boost"]) {
            let change = getTraitChangeHtml(traitData["heel_alignment_hype_boost"]);
            helpTexts.push("Changes heel alignment hype boost for matches and feuds by {0}".format(change));
        }
        if (traitData["face_alignment_penalty"]) {
            let change = getTraitChangeHtml(traitData["face_alignment_penalty"]);
            helpTexts.push("Adds hype penalty of {0} when aligned as a face".format(change));
        }
        if (traitData["heel_alignment_penalty"]) {
            let change = getTraitChangeHtml(traitData["heel_alignment_penalty"]);
            helpTexts.push("Adds hype penalty of {0} when aligned as a heel".format(change));
        }
        if (traitData["fantasy_gimmick_character_boost"]) {
            let change = getTraitChangeHtml(traitData["fantasy_gimmick_character_boost"]);
            helpTexts.push("Changes gimmick effectiveness for fantasy characters by {0}%".format(change));
        }
        if (traitData["non_fantasy_gimmick_character_boost"]) {
            let change = getTraitChangeHtml(traitData["non_fantasy_gimmick_character_boost"]);
            helpTexts.push("Changes gimmick effectiveness for non-fantasy characters by {0}%".format(change));
        }
        if (traitData["bad_combination_gimmick_boost"]) {
            let change = getTraitChangeHtml(traitData["bad_combination_gimmick_boost"]);
            helpTexts.push("Changes gimmick effectiveness for bad combination gimmicks by {0}%".format(change));
        }
        if (traitData["gimmick_boost"]) {
            let change = getTraitChangeHtml(traitData["gimmick_boost"]);
            helpTexts.push("Changes gimmick effectiveness for all gimmicks by {0}%".format(change));
        }
        if (traitData["gimmick_interview_superstar_chance"]) helpTexts.push("Adds {0}% chance to be in the Gimmick Interview random event".format(traitData["gimmick_interview_superstar_chance"]));
        if (traitData["hot_feud_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["hot_feud_chance_boost"]);
            helpTexts.push("Changes hot feud chance by {0}%".format(change));
        }
        if (traitData["feud_staleness_limit_boost"]) {
            let change = getTraitChangeHtml(traitData["feud_staleness_limit_boost"]);
            helpTexts.push("Changes feud staleness limit by {0}".format(change));
        }
        if (traitData["feud_boosted_feud_chance"]) helpTexts.push("Adds {0}% chance to be in the Feud Boosted random event".format(traitData["feud_boosted_feud_chance"]));
        if (traitData["feud_ignored_feud_chance"]) helpTexts.push("Adds {0}% chance to be in the Feud Ignored random event".format(traitData["feud_ignored_feud_chance"]));
        if (traitData["feud_hype_change_boost"]) {
            let change = getTraitChangeHtml(traitData["feud_hype_change_boost"]);
            helpTexts.push("Adds {0} to feud hype change in matches and segments".format(change));
        }
        if (traitData["gimmick_effectiveness_increase_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["gimmick_effectiveness_increase_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} gimmick effectiveness change {1} {2}x".format(changeWord, changeVerb, traitData["gimmick_effectiveness_increase_multiplier"]));
        }
        if (traitData["morale_boost_helper_chance"]) helpTexts.push("Adds {0}% chance to be in the Morale Boost random event".format(traitData["morale_boost_helper_chance"]));
        if (traitData["wrestler_court_judge_chance"]) helpTexts.push("Adds {0}% chance to be a judge in the Wrestlers Court random event".format(traitData["wrestler_court_judge_chance"]));
        if (traitData["wrestler_court_defendant_chance"]) helpTexts.push("Adds {0}% chance to be a defendant in the Wrestlers Court random event".format(traitData["wrestler_court_defendant_chance"]));
        if (traitData["backstage_fight_starter_chance"]) helpTexts.push("Adds {0}% chance to be in the Backstage Fight random event".format(traitData["backstage_fight_starter_chance"]));
        if (traitData["drug_abuse_superstar_chance"]) helpTexts.push("Adds {0}% chance to be in the Drug Abuse random event".format(traitData["drug_abuse_superstar_chance"]));
        if (traitData["tag_match_workrate_boost"]) {
            let change = getTraitChangeHtml(traitData["tag_match_workrate_boost"]);
            helpTexts.push("Changes workrate by {0} in tag matches".format(change));
        }
        if (traitData["lose_trait_chance_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["lose_trait_chance_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} chance to lose traits with age {1} {2}x".format(changeWord, changeVerb, traitData["lose_trait_chance_multiplier"]));
        }
        if (traitData["add_blood_chance_boost"]) {
            let change = getTraitChangeHtml(traitData["add_blood_chance_boost"]);
            helpTexts.push("Changes chance to bleed by {0}%".format(change));
        }
        if (traitData["months_to_unlearn_traits_boost"]) {
            let change = getTraitChangeHtml(traitData["months_to_unlearn_traits_boost"]);
            helpTexts.push("Changes number of months needed to unlearn traits by {0}".format(change));
        }
        if (traitData["weekly_show_match_fatigue_change"]) {
            let change = getTraitChangeHtml(traitData["weekly_show_match_fatigue_change"]);
            helpTexts.push("Changes match fatigue by {0} on weekly shows".format(change));
        }
        if (traitData["monthly_event_match_fatigue_change"]) {
            let change = getTraitChangeHtml(traitData["monthly_event_match_fatigue_change"]);
            helpTexts.push("Changes match fatigue by {0} on monthly events".format(change));
        }
        if (traitData["gimmick_match_fatigue_multiplier"]) {
            let changeWord = getTraitChangeWord(traitData["gimmick_match_fatigue_multiplier"]);
            let changeVerb = changeWord === "Multiplies" ? "by" : "to";
            helpTexts.push("{0} gimmick match fatigue change {1} {2}x".format(changeWord, changeVerb, traitData["gimmick_match_fatigue_multiplier"]));
        }
        if (traitData["remove_fatigue_age_penalty"]) helpTexts.push("Removes fatigue penalty normally added past the age of 40");
    }
    let helpText = helpTexts.join(". ");
    helpText += ".";
    return helpText;
}
function $d3e44747ec383890$export$69bc1b0077a67580({ data: data, uid: uid, type: type } = {}) {
    const $changeNameContainer = $("#change-name-container");
    $(".change-name-member-name").text(data["name"]);
    $("#change-name-container .change-name-input").val(data["name"]);
    $changeNameContainer.data("uid", uid);
    $changeNameContainer.data("type", type);
    $changeNameContainer.fadeIn();
}
function $d3e44747ec383890$var$showRosterMemberPronounData({ data: data, uid: uid } = {}) {
    const $changePronounContainer = $("#change-pronoun-container");
    $(".change-pronoun-member-name").text(data["name"]);
    $("#change-pronoun-container .change-pronoun-select").val(data["pronoun"]);
    $changePronounContainer.data("uid", uid);
    $changePronounContainer.fadeIn();
}
function $d3e44747ec383890$var$showRosterMemberAppearanceData({ data: data, uid: uid } = {}) {
    const $changeAppearanceGraphic = $("#change-appearance-graphic");
    $(".change-appearance-superstar-name").text(data["name"]);
    $changeAppearanceGraphic.data("key", JSON.stringify(data["graphic"]));
    $changeAppearanceGraphic.data("uid", uid);
    $('input:radio[name="radio-change-appearance-option"][value="change"]').trigger("change").trigger("click");
    $("#change-appearance-container").fadeIn();
    if (data["graphic"]) $(".change-appearance-cost").text("15");
    else $(".change-appearance-cost").text("0");
}
function $d3e44747ec383890$var$showRosterMemberAlignmentData({ data: data, uid: uid, type: type } = {}) {
    if (!data["error"]) {
        const $changeAlignmentContainer = $("#change-alignment-container");
        $(".change-alignment-member-name").text(data["name"]);
        $("#change-alignment-container .change-alignment-select").val(data["alignment"]);
        $changeAlignmentContainer.data("uid", uid);
        $changeAlignmentContainer.data("type", type);
        $changeAlignmentContainer.fadeIn();
    } else if (data["error"] === "different-alignments") notie.alert({
        type: 3,
        text: "To change a Team's Alignment, all Team Members need to have the same Alignment"
    });
}
function $d3e44747ec383890$var$showRosterMemberBrandData({ data: data, uid: uid, type: type } = {}) {
    const $changeBrandContainer = $("#change-brand-container");
    $(".change-brand-member-name").text(data["name"]);
    let brandNamesOptions = '<option value="">None</option>';
    data["brandNames"].forEach(function(brandName) {
        if (brandName === data["brandName"]) brandNamesOptions += '<option selected value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + "</option>";
        else brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + "</option>";
    });
    $("#change-brand-container .change-brand-select").html(brandNamesOptions);
    $changeBrandContainer.data("uid", uid);
    $changeBrandContainer.data("type", type);
    $changeBrandContainer.fadeIn();
}
function $d3e44747ec383890$var$showRosterMemberGimmickData({ data: data, uid: uid, $el: $el } = {}) {
    // Personalities
    let personalitiesHtml = "";
    let personalities = [
        ...(0, $76da554e02071cd0$export$8ca504209c139329)
    ];
    personalities.sort((0, $1JSre.predicateBy)("name"));
    personalities.forEach(function(obj, i) {
        let objClass = "";
        // Remove bottom border for elements in last row
        if (data.length >= 5) {
            // If even items, remove bottom border from last 2 elements
            if (data.length % 2 === 0) {
                if (i === data.length - 1 || i === data.length - 2) objClass += " border-bottom-0";
            } else if (i === data.length - 1) objClass += " border-bottom-0";
        }
        if (i % 2 !== 0) objClass += " border-right-0";
        personalitiesHtml += '<div class="gimmick-selection-item personality-item' + objClass + '" data-tag="' + obj["tag"] + '">' + obj["name"] + "</div>";
    });
    $(".personalities-container").html(personalitiesHtml);
    // Characters
    let charactersHtml = "";
    let lockedText = " (JoW Paid)";
    if ((0, $98xmD.globalUser).paid) lockedText = "";
    data["characters"].sort((0, $1JSre.predicateBy)("name"));
    data["characters"].forEach(function(obj, i) {
        let level = "";
        if (obj["level"] === 2) level = '<i class="fa fa-star silver-light margin-left-5"></i>';
        else if (obj["level"] === 3) level = '<i class="fa fa-star gold-light margin-left-5"></i>';
        let objClass = "";
        if (data.length >= 5) {
            if (data.length % 2 === 0) {
                if (i === data.length - 1 || i === data.length - 2) objClass += " border-bottom-0";
            } else if (i === data.length - 1) objClass += " border-bottom-0";
        }
        if (i % 2 !== 0) objClass += " border-right-0";
        let helpText = "";
        if (obj["locked"]) {
            objClass += " locked help-text";
            let unlockedBy = $d3e44747ec383890$var$getCharacterUnlockedBy(obj["name"]);
            helpText = " title=\" Unlocked by using the '" + unlockedBy + "' Gimmick to get a Superstar Over" + lockedText + '"';
        }
        // Combinations
        let goodCombinationsData = "";
        let badCombinationsData = "";
        let okayCombinationsData = "";
        if (obj["combinations"]) {
            let goodCombinations = obj["combinations"]["easy"];
            let badCombinations = obj["combinations"]["hard"];
            let okayCombinations = obj["combinations"]["okay"];
            if (goodCombinations.length > 0) goodCombinationsData = " data-good-combinations='" + JSON.stringify(goodCombinations) + "'";
            if (badCombinations.length > 0) badCombinationsData = " data-bad-combinations='" + JSON.stringify(badCombinations) + "'";
            if (okayCombinations.length > 0) okayCombinationsData = " data-okay-combinations='" + JSON.stringify(okayCombinations) + "'";
        }
        // Times used
        let timesUsed = obj["timesUsed"];
        let timesUsedData = "";
        if (timesUsed !== undefined && timesUsed > 0) timesUsedData = " data-times-used='" + JSON.stringify(timesUsed) + "'";
        // Easy Combinations
        let easyCombinationsTotal = obj["easyCombinationsTotal"];
        let easyCombinationsTotalData = "";
        if (easyCombinationsTotal !== undefined) easyCombinationsTotalData = " data-easy-combinations-total='" + JSON.stringify(easyCombinationsTotal) + "'";
        // Unlocked
        let easyCombinationsUnlocked = obj["easyCombinationsUnlocked"];
        let easyCombinationsUnlockedData = "";
        if (easyCombinationsUnlocked !== undefined) easyCombinationsUnlockedData = " data-easy-combinations-unlocked='" + JSON.stringify(easyCombinationsUnlocked) + "'";
        // Hard Combinations
        let hardCombinationsTotal = obj["hardCombinationsTotal"];
        let hardCombinationsTotalData = "";
        if (hardCombinationsTotal !== undefined) hardCombinationsTotalData = " data-hard-combinations-total='" + JSON.stringify(hardCombinationsTotal) + "'";
        // Unlocked
        let hardCombinationsUnlocked = obj["hardCombinationsUnlocked"];
        let hardCombinationsUnlockedData = "";
        if (hardCombinationsUnlocked !== undefined) hardCombinationsUnlockedData = " data-hard-combinations-unlocked='" + JSON.stringify(hardCombinationsUnlocked) + "'";
        let objHtml = '<div class="gimmick-selection-item character-item' + objClass + '" data-tag="' + obj["tag"] + '"' + goodCombinationsData + badCombinationsData + okayCombinationsData + timesUsedData + easyCombinationsTotalData + easyCombinationsUnlockedData + hardCombinationsTotalData + hardCombinationsUnlockedData + helpText + ">" + obj["name"] + level + "</div>";
        charactersHtml += objHtml;
    });
    $(".characters-container").html(charactersHtml);
    // Gimmick
    if (data["gimmick"]) $(".create-gimmick-superstar-name").text(data["name"] + " (" + data["gimmick"] + ")");
    else $(".create-gimmick-superstar-name").text(data["name"]);
    $("#gimmick-graphic").data("key", JSON.stringify(data["graphic"]));
    $("#gimmick-graphic").data("uid", uid);
    $("#create-gimmick-container .change-name-input").val(data["name"]);
    $("#create-gimmick-container .change-alignment-select").val(data["alignment"]);
    if ((0, $98xmD.globals).game.story === "mars") $("#create-gimmick-container .change-name-input").parent().parent().hide();
    $("#create-gimmick-container").fadeIn();
    // New gimmick available
    if (data["nextGimmickBoost"]) {
        $(".next-gimmick-boost").html('<span class="help-text green" title="Due to an Important Moment, a Gimmick change is available for free with an Effectiveness Boost.">+ 20% Eff.</span>');
        $(".create-gimmick-cost").text("0");
    } else $(".next-gimmick-boost").text("");
    // Add cost
    if ($el.text() === "Create Gimmick") {
        $(".create-gimmick-cost").text("0");
        $(".create-gimmick-label").text("Create Gimmick");
        $("#remove-gimmick-button").hide();
    } else {
        $(".create-gimmick-cost").text("30");
        $(".create-gimmick-label").text("Change Gimmick");
        $("#remove-gimmick-button").show();
    }
    // Reset
    $(".gimmick-item-custom-name").val("");
    $(".character-selected").text("");
    $(".personality-selected").text("");
    $(".custom-gimmick-value").text("");
    $(".default-gimmick-label").show();
    $(".create-gimmick-combination").html("None");
    $('input:radio[name="radio-gimmick-appearance-option"][value="existing"]').trigger("click");
    $d3e44747ec383890$var$allowGenerateGimmick = true;
    $(".gimmick-times-used").text("");
    $(".gimmick-penalty").text("");
    $(".personality-easy-combinations-unlocked").text("");
    $(".personality-easy-combinations-total").text("");
    $(".personality-hard-combinations-unlocked").text("");
    $(".personality-hard-combinations-total").text("");
    $(".combinations-count-divider").text("");
    $(".gimmick-item-filter").removeClass("selected");
}
function $d3e44747ec383890$var$showChangeNameData({ data: data, type: type, memberName: memberName } = {}) {
    if (!data["error"]) {
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Update faction name
        if (type === "faction") $(".faction-details-name").text(data["name"]);
        else {
            $(".roster-member-name").text(data["name"]);
            // Update name in roster view
            $(".roster-member:contains(" + data["previousName"] + ")").text(data["name"]);
        }
        // Go back to superstar info
        $("#change-name-container").hide();
        if (type === "faction") $(".faction-details-container").fadeIn("fast");
        else $("#roster-member-details").fadeIn("fast");
        notie.alert({
            type: 4,
            text: "Name changed"
        });
    } else {
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to change this {0}'s Name".format(memberName)
        });
        else if (data["error"] === "same-name") notie.alert({
            type: 3,
            text: "Enter a different Name from the {0}'s current Name".format(memberName)
        });
        else if (data["error"] === "mars") notie.alert({
            type: 3,
            text: "You cannot change Talent Names in Wrestling on Mars"
        });
        else if (data["error"] === "pow-person") notie.alert({
            type: 3,
            text: '"Why change their name? That\'s who the fans know them as." - Hank Hughes'
        });
        else if (data["error"] === "owner-name-change") notie.alert({
            type: 3,
            text: "You cannot change the Owner's Name"
        });
        else if (data["error"] === "same-name-as-owner") notie.alert({
            type: 3,
            text: "You cannot change a Talent's Name to the Owner's Name"
        });
        else if (data["error"] === "name-exists") notie.alert({
            type: 3,
            text: "A {0} with that name already exists on your Roster".format(memberName)
        });
    }
}
function $d3e44747ec383890$var$showChangeGraphicData({ data: data, appearanceOption: appearanceOption } = {}) {
    if (!data["error"]) {
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Update roster member graphics data
        $("#roster-member-details").data("graphic", [
            data["graphic"]
        ]);
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to superstar info
        $("#change-appearance-container").find("#back-to-roster-member").trigger("click");
        if (appearanceOption === "change") notie.alert({
            type: 4,
            text: "Appearance changed"
        });
        else notie.alert({
            type: 4,
            text: "Graphic removed"
        });
    } else if (data["error"] === "not-enough-points") notie.alert({
        type: 3,
        text: "You do not have enough Creative Points to change this Superstar's Appearance"
    });
}
function $d3e44747ec383890$var$showChangeAlignmentData({ data: data, memberName: memberName } = {}) {
    if (!data["error"]) {
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Update alignment
        let rosterMemberAlignmentHtml = (0, $1JSre.getRosterMemberAlignmentHtml)(data);
        $(".roster-member-alignment").html(rosterMemberAlignmentHtml);
        // Go back to superstar info
        $("#change-alignment-container").hide();
        $("#roster-member-details").fadeIn();
        if (memberName === "Team") notie.alert({
            type: 4,
            text: "Alignments changed"
        });
        else notie.alert({
            type: 4,
            text: "Alignment changed"
        });
    } else {
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to change this {0}'s Alignment".format(memberName)
        });
        else if (data["error"] === "same-alignment") notie.alert({
            type: 3,
            text: "Select a different Alignment from the {0}'s current Alignment".format(memberName)
        });
    }
}
function $d3e44747ec383890$var$showChangePronounData({ data: data } = {}) {
    if (!data["error"]) {
        $(".roster-member-pronoun").text((0, $3E8Nt.toTitleCase)(data["pronoun"]));
        // Go back to superstar info
        $("#change-pronoun-container").hide();
        $("#roster-member-details").fadeIn("fast");
        notie.alert({
            type: 4,
            text: "Pronoun changed"
        });
    } else {
        if (data["error"] === "mars") notie.alert({
            type: 3,
            text: "You cannot change Talent Pronouns in Wrestling on Mars"
        });
        if (data["error"] === "passion") notie.alert({
            type: 3,
            text: "You cannot change Talent Pronouns in Passion of Wrestling"
        });
    }
}
function $d3e44747ec383890$var$showChangeBrandData({ data: data } = {}) {
    if (!data["error"]) {
        let rosterMemberBrandNameHtml = '<span class="medium-grey">None</span>';
        if (data["brandName"]) rosterMemberBrandNameHtml = data["brandName"];
        $(".roster-member-brand").html(rosterMemberBrandNameHtml);
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to superstar info
        $("#change-brand-container").hide();
        $("#roster-member-details").fadeIn("fast");
        notie.alert({
            type: 4,
            text: "Brand changed"
        });
    } else {
        if (data["error"] === "not-paid") notie.alert({
            type: 3,
            text: "Brands are only available in JoW Paid."
        });
        if (data["error"] === "mars") notie.alert({
            type: 3,
            text: "You cannot change Brands in Wrestling on Mars"
        });
        else if (data["error"] === "passion") notie.alert({
            type: 3,
            text: "You cannot change Brands in Passion of Wrestling"
        });
        else if (data["error"] === "roster-member-not-found") notie.alert({
            type: 3,
            text: "That talent could not be found. Please try again."
        });
        else if (data["error"] === "brand-name-not-found") notie.alert({
            type: 3,
            text: "That brand could not be found. Please try again."
        });
        else if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to change this Superstar's Brand."
        });
    }
}
function $d3e44747ec383890$var$showAddGimmickData({ data: data, personality: personality, character: character } = {}) {
    if (!data["error"]) {
        let html = "";
        let notificationText;
        switch(data["combinationResult"]){
            case "easy":
                html = '<span class="green">Easy</span>';
                notificationText = '{0} is excited to debut {1} new "{2}" Gimmick!';
                break;
            case "hard":
                html = '<span class="red">Hard</span>';
                notificationText = '{0} is uncertain about {1} new "{2}" Gimmick.';
                break;
            case "okay":
                html = '<span class="dark-yellow">Okay</span>';
                break;
            default:
                html = '<span class="dark-grey">None</span>';
                break;
        }
        // Show combination result
        $(".create-gimmick-combination").html(html).hide().fadeIn();
        if (notificationText) {
            let gimmickName = '<span class="character-label">' + personality + " " + character + "</span>";
            let formattedText = notificationText.format(data["superstarName"], data["superstarPossessivePronoun"], gimmickName);
            notie.alert({
                type: 4,
                text: '<span class="display-block">' + formattedText + "</span>",
                stay: true
            });
        } else notie.alert({
            type: 4,
            text: "Gimmick added"
        });
        // Add new gimmick
        let gimmickDescription = (0, $1JSre.getGimmickDescription)(data["gimmick"]);
        $(".roster-member-gimmick").html(gimmickDescription);
        $("#edit-gimmick-button").text("Change Gimmick");
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Update name if changed
        if (data["previousName"]) {
            $(".roster-member-name").text(data["superstarName"]);
            // Update name in roster view
            $(".roster-member:contains(" + data["previousName"] + ")").text(data["superstarName"]);
        }
        // Update alignment if changed
        if (data["alignment"] !== undefined) {
            let rosterMemberAlignmentHtml = (0, $1JSre.getRosterMemberAlignmentHtml)(data);
            $(".roster-member-alignment").html(rosterMemberAlignmentHtml);
        }
        // Update roster member graphics data
        $("#roster-member-details").data("graphic", [
            data["graphic"]
        ]);
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to superstar info
        $("#create-gimmick-container").find("#back-to-roster-member").trigger("click");
    } else {
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to create this Gimmick"
        });
        else if (data["error"] === "same-name") notie.alert({
            type: 3,
            text: "The new Gimmick cannot have the same name as the current Gimmick"
        });
        else if (data["error"] === "pow-person") notie.alert({
            type: 3,
            text: '"Why change their name? That\'s who the fans know them as." - Hank Hughes'
        });
    }
}
function $d3e44747ec383890$var$showRemoveGimmickData({ data: data } = {}) {
    if (!data["error"]) {
        $(".roster-member-gimmick").html('<span class="medium-grey">None</span>');
        $("#edit-gimmick-button").text("Create Gimmick");
        notie.alert({
            type: 4,
            text: "Gimmick removed"
        });
        // Go back to superstar info
        $("#create-gimmick-container").find("#back-to-roster-member").trigger("click");
    } else {
        if (data["error"] === "superstar-not-found") notie.alert({
            type: 3,
            text: "That Superstar could not be found. Please try again."
        });
        else if (data["error"] === "no-gimmick-present") notie.alert({
            type: 3,
            text: "That Superstar does not have a Gimmick assigned."
        });
    }
}
function $d3e44747ec383890$var$generateGimmick() {
    (0, $lCS03.playSoundEffect)("success");
    // Unselect everything
    $(".character-selected").text("");
    $(".personality-selected").text("");
    $(".custom-gimmick-value").text("");
    $(".character-item.selected").removeClass("selected");
    $(".personality-item.selected").removeClass("selected");
    $(".gimmick-times-used").text("");
    $(".gimmick-penalty").text("");
    $(".personality-easy-combinations-unlocked").text("");
    $(".personality-easy-combinations-total").text("");
    $(".personality-hard-combinations-unlocked").text("");
    $(".personality-hard-combinations-total").text("");
    $(".combinations-count-divider").text("");
    let choice = (0, $3E8Nt.getRandomInt)(0, 100);
    if (choice < 60) {
        let selectedCharacter = (0, $3E8Nt.getRandomChoice)($(".character-item:not(.locked)"));
        $(selectedCharacter).trigger("click");
        let selectedPersonality = (0, $3E8Nt.getRandomChoice)($(".personality-item"));
        $(selectedPersonality).trigger("click");
        $(".gimmick-item-custom-name").val("");
    } else {
        let randomGimmicks = [
            "Legend Killer",
            "Grim Reaper",
            "Rock Star",
            "Crime Boss",
            "General Manager",
            "Demon Hunter",
            "Secret Service",
            "Career Killer",
            "Unleashed Animal",
            "Wrestling God",
            "Parole Officer",
            "Crazy Russian",
            "Country Singer",
            "Outdoorsman",
            "Little Dog",
            "Bulldog",
            "Brawler",
            "Romantic",
            "Hugger",
            "Lovesick",
            "Royalty",
            "Comic-book Hero",
            "Comic-book Villain",
            "Supermodel",
            "Hacker",
            "Redneck",
            "Bodyguard",
            "Rebel",
            "Monk",
            "Hypocrite",
            "Hustler",
            "Butcher",
            "Surfer",
            "Skater",
            "Ninja",
            "Iceman",
            "Dancer",
            "Poser",
            "Hoser",
            "Lumberjack"
        ];
        $(".gimmick-item-custom-name").val((0, $3E8Nt.getRandomChoice)(randomGimmicks)).trigger("input");
    }
}
function $d3e44747ec383890$var$formatGimmickItemsGrid() {
    let items = $(".character-item:visible");
    items.each(function(i, e) {
        $d3e44747ec383890$var$formatGridItemBorder(e, i, items);
    });
    items = $(".personality-item:visible");
    items.each(function(i, e) {
        $d3e44747ec383890$var$formatGridItemBorder(e, i, items);
    });
}
function $d3e44747ec383890$var$formatGridItemBorder(item, i, items) {
    $(item).removeClass("border-bottom-0 border-right-0");
    // Remove bottom border for elements in last row
    if (items.length >= 5) {
        if (items.length % 2 === 0) {
            if (i === items.length - 1 || i === items.length - 2) $(item).addClass("border-bottom-0");
        } else if (i === items.length - 1) $(item).addClass("border-bottom-0");
    }
    if (i % 2 !== 0) $(item).addClass("border-right-0");
}
function $d3e44747ec383890$var$updateGimmickNameText() {
    $(".character-selected").show();
    $(".personality-selected").show();
    // If nothing selected, show default gimmick label
    if (!$(".character-selected").text() && !$(".personality-selected").text()) $(".default-gimmick-label").show();
    $(".custom-gimmick-value").text("");
}
function $d3e44747ec383890$var$updateCombinationText() {
    // Custom gimmick
    if ($(".gimmick-item-custom-name").val() && $(".gimmick-item-custom-name").is(":focus")) {
        $(".create-gimmick-combination").html("None");
        return false;
    }
    let el = $(".personality-item.selected");
    if (el.length > 0) {
        if (el.hasClass("green")) $(".create-gimmick-combination").html('<span class="green">Easy</span>');
        else if (el.hasClass("red")) $(".create-gimmick-combination").html('<span class="red">Hard</span>');
        else if (el.hasClass("dark-yellow")) $(".create-gimmick-combination").html('<span class="dark-yellow">Okay</span>');
        else if ($(".character-item.selected").length > 0) $(".create-gimmick-combination").html("???");
        else $(".create-gimmick-combination").html("None");
    } else $(".create-gimmick-combination").html("None");
}
function $d3e44747ec383890$var$getCharacterUnlockedBy(name) {
    let unlockedByName;
    switch(name){
        case "Abstainer":
            unlockedByName = "Punk";
            break;
        case "Degenerate":
            unlockedByName = "Rich Person";
            break;
        case "Enigma":
            unlockedByName = "Spot Monkey";
            break;
        case "Rapper":
            unlockedByName = "Singer";
            break;
        case "Rockstar":
            unlockedByName = "Musician";
            break;
        case "Cult Leader":
            unlockedByName = "Occultist";
            break;
        case "Drug Lord":
            unlockedByName = "Big Shot";
            break;
        case "Royalty":
            unlockedByName = "VIP";
            break;
        case "Undead":
            unlockedByName = "Demon";
            break;
        case "Game Dev.":
            unlockedByName = "Philosophist";
            break;
        case "Martian":
            unlockedByName = "Game Dev.";
            break;
    }
    return unlockedByName;
}
function $d3e44747ec383890$var$showReleaseTalentData({ data: data, memberVerb: memberVerb } = {}) {
    if (!data["error"]) {
        // Go back
        setTimeout(function() {
            let element = $("#roster-member-details").data("element");
            if (element === "#view-managers-container") $(".view-managers-company-select").trigger("change");
            else {
                // Go back to booking
                if (element === "#booking-container") {
                    if ($("#book-tag-team-menu-button").hasClass("selected")) $(".tag-match-options").find(".selected").trigger("click");
                    else $("#booking-menu").find(".selected").trigger("click");
                } else // Go back to view teams
                if ($(element).attr("id") === "view-teams-container") $(".view-teams-company-select").trigger("change");
                else $(".select-company-for-view-roster").trigger("change");
            }
        }, 1300);
        let overnessDecrease = '<span class="stale-color">' + data["overnessDecrease"] + '<span class="margin-left-2">%</span></span>';
        let html = '<span class="display-block">{0} {1} been released, lowering {2} Overness by {3}</span>'.format(data["name"], memberVerb, data["possessivePronoun"], overnessDecrease);
        notie.alert({
            type: 4,
            text: html
        });
    } else {
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "Talent not found in your roster"
        });
        else if (data["error"] === "champion") notie.alert({
            type: 3,
            text: "Champions cannot be released"
        });
        else if (data["error"] === "trade-deal") notie.alert({
            type: 3,
            text: "Talent belonging to other Companies cannot be released"
        });
        else if (data["error"] === "martian") notie.alert({
            type: 3,
            text: "Markus won't put through the release of any Martians"
        });
        else if (data["error"] === "pow-person") notie.alert({
            type: 3,
            text: '"What? No, we need that talent!" - Hank Hughes'
        });
        else if (data["error"] === "booked") notie.alert({
            type: 3,
            text: "Superstars booked in a match cannot be released"
        });
    }
}
function $d3e44747ec383890$var$showDisbandTagTeamData({ data: data } = {}) {
    if (!data["error"]) {
        let html = '<span class="display-block">' + data["name"] + " have disbanded" + "</span>";
        if (data["feudPotential"]) {
            let feudPotentialHtml = (0, $1JSre.getFeudPotentialHtml)(data["feudPotential"]);
            html += '<span class="display-block">' + feudPotentialHtml + "</span>";
        }
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        // Go back to roster view
        setTimeout(function() {
            let element = $("#roster-member-details").data("element");
            // Go back to booking
            if (element === "#booking-container") {
                if ($("#book-tag-team-menu-button").hasClass("selected")) $(".tag-match-options").find(".selected").trigger("click");
                else $("#booking-menu").find(".selected").trigger("click");
            } else // Go back to view teams
            if ($(element).attr("id") === "view-teams-container") $(".view-teams-company-select").trigger("change");
            else $(".select-company-for-view-roster").trigger("change");
            // Tutorial action check
            if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
            // Tutorial action check
            setTimeout(function() {
                (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("disband_team");
            }, 100);
        }, 1300);
    } else {
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "That team could not be found. Please try again."
        });
        else if (data["error"] === "champion") notie.alert({
            type: 3,
            text: "Champions cannot be disbanded."
        });
        else if (data["error"] === "booked") notie.alert({
            type: 3,
            text: "Teams booked at the upcoming event cannot be disbanded."
        });
    }
}
function $d3e44747ec383890$var$getTimesUsedPenalty(timesUsed) {
    if (timesUsed >= 8) return "Large Penalty";
    else if (timesUsed >= 5) return "Medium Penalty";
    else if (timesUsed >= 2) return "Small Penalty";
    else return "";
}



var $14eBR = parcelRequire("14eBR");

var $3E8Nt = parcelRequire("3E8Nt");

var $iRMwH = parcelRequire("iRMwH");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $9esFv = parcelRequire("9esFv");

var $5ZsVo = parcelRequire("5ZsVo");

var $6RCLU = parcelRequire("6RCLU");

var $4ptHI = parcelRequire("4ptHI");

var $5kTkA = parcelRequire("5kTkA");

var $972Ip = parcelRequire("972Ip");

var $iQtzn = parcelRequire("iQtzn");

var $i7bmn = parcelRequire("i7bmn");

var $jDtEn = parcelRequire("jDtEn");

var $hBIDz = parcelRequire("hBIDz");

var $1AAHK = parcelRequire("1AAHK");

var $kZwpB = parcelRequire("kZwpB");

var $cYLJ6 = parcelRequire("cYLJ6");

var $cXLSF = parcelRequire("cXLSF");

var $98xmD = parcelRequire("98xmD");

var $ycsyu = parcelRequire("ycsyu");

var $im36F = parcelRequire("im36F");

var $eg5dz = parcelRequire("eg5dz");

var $cMrnz = parcelRequire("cMrnz");

var $8bQDO = parcelRequire("8bQDO");

var $1Dp0h = parcelRequire("1Dp0h");

var $1JSre = parcelRequire("1JSre");

var $dGbip = parcelRequire("dGbip");

var $3SyPM = parcelRequire("3SyPM");

var $6hwt2 = parcelRequire("6hwt2");

var $kpu3X = parcelRequire("kpu3X");

var $iRMwH = parcelRequire("iRMwH");

var $9esFv = parcelRequire("9esFv");

var $iQtzn = parcelRequire("iQtzn");

var $eg5dz = parcelRequire("eg5dz");

var $8A6FL = parcelRequire("8A6FL");

var $dl5u4 = parcelRequire("dl5u4");

var $3E8Nt = parcelRequire("3E8Nt");

var $6PzHO = parcelRequire("6PzHO");

var $kZwpB = parcelRequire("kZwpB");

var $14eBR = parcelRequire("14eBR");

var $i7bmn = parcelRequire("i7bmn");

var $6RCLU = parcelRequire("6RCLU");

var $4K85d = parcelRequire("4K85d");

var $kpu3X = parcelRequire("kpu3X");

var $hekDR = parcelRequire("hekDR");

var $2JFAd = parcelRequire("2JFAd");

var $ivuOU = parcelRequire("ivuOU");

var $1JSre = parcelRequire("1JSre");

var $jDtEn = parcelRequire("jDtEn");

var $hBIDz = parcelRequire("hBIDz");

var $cXLSF = parcelRequire("cXLSF");
async function $b7dd8c4f6cc3ca70$export$97a1cb8a1145fa57() {
    let data = {};
    try {
        const game = await (0, $3E8Nt.getCurrentGame)();
        const allCompanies = await (0, $iRMwH.getGameActiveCompanies)(game);
        const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
        const realYear = mainCompany.realYear;
        let monthlyEvents = [];
        let matches = [];
        let allFeuds = [];
        let segments = [];
        let weeklyShows = [];
        let championships = [];
        let factions = [];
        // Don't run awards if not right month and if no competitors
        if (game.awardsRun || allCompanies.length === 1 || mainCompany.storyName === "mars") return data;
        // Get all events of last year that have been held (check for rating)
        let companyEvents = {};
        for (const company of allCompanies)companyEvents[company.$loki] = {
            name: company.name,
            events: [],
            company: company
        };
        for (const company of allCompanies){
            for (const event of (await $b7dd8c4f6cc3ca70$var$getCompanyLastYearsEvents(company)))if (event.rating) {
                if (!event.weeklyShow) {
                    monthlyEvents.push(event);
                    companyEvents[company.$loki]["events"].push(event);
                } else weeklyShows.push(event);
            }
            championships.push(...await (0, $9esFv.getCompanyChampionships)(company));
            // Get all feuds started in past year
            const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
            for (const x of (await (0, $dl5u4.getRosterFeuds)(mainRoster)))if (x.started && x.rating !== null) {
                const monthsSinceStarted = (0, $3E8Nt.getMonthsDifference)(game.monthCount, game.year, x.startMonth, x.startYear);
                if (monthsSinceStarted <= 12) allFeuds.push(x);
            }
            factions.push(...await (0, $6PzHO.getRosterActiveFactions)(mainRoster));
        }
        // Get matches and segments of events (exclude production segments)
        for (const event of [
            ...monthlyEvents,
            ...weeklyShows
        ]){
            let eventSegments = await (0, $iQtzn.getEventSegments)(event);
            for (const eventSegment of eventSegments){
                let segmentItem = await (0, $eg5dz.getSegmentSegmentItem)(eventSegment);
                if (segmentItem && !segmentItem.productionSegment) segments.push(eventSegment);
            }
            matches.push(...(await (0, $iQtzn.getEventMatches)(event)).filter((x)=>x.rating !== null));
        }
        // Add awards data in order
        data["awards"] = [];
        data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestGimmickMatch(matches, game, true, realYear));
        data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestGimmickMatch(matches, game, false, realYear));
        if (segments.length > 2) {
            data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestSegment(segments, game, true, realYear));
            data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestSegment(segments, game, false, realYear));
        }
        if (championships.length) {
            let uniqueChampionships = (0, $kZwpB.getUniqueChampionships)(championships);
            // Add awards if prestige is added (JoW Paid)
            if (uniqueChampionships.filter((x)=>x.xpGainedThisYear !== 0).length > 2) data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestChampionship(uniqueChampionships, game, realYear));
        }
        if (factions.filter((x)=>x.xpGainedThisYear !== 0).length > 2) data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestFaction(factions, game, realYear));
        data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestWrestler(matches, game, realYear));
        data["awards"].push(await $b7dd8c4f6cc3ca70$var$getMostHypedEvent(monthlyEvents, game, realYear));
        data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestEvent(monthlyEvents, game, true, realYear));
        data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestEvent(monthlyEvents, game, false, realYear));
        if (allFeuds.length) {
            data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestFeud(allFeuds, game, true, realYear));
            data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestFeud(allFeuds, game, false, realYear));
        }
        let [bestCompanyData, bestCompanyContenders] = await $b7dd8c4f6cc3ca70$var$getBestCompany(companyEvents, game, false, realYear);
        if (bestCompanyContenders.length > 1) data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestCompany(companyEvents, game, true, realYear));
        data["awards"].push(bestCompanyData);
        data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestMatch(matches, game, true, realYear));
        data["awards"].push(await $b7dd8c4f6cc3ca70$var$getBestMatch(matches, game, false, realYear));
        // Check for objectives completed
        let options = {
            "Craziest Match of the Year": "win gmoty",
            "Match of the Year": "win moty",
            "Wrestler of the Year": "win woty",
            "Event of the Year": "win eoty",
            "Championship of the Year": "win toty",
            "Feud of the Year": "win foty",
            "Segment of the Year": "win soty",
            "Company of the Year": "win coty",
            "Most Hyped Event of the Year": "win mheoty",
            "Faction of the Year": "win foty"
        };
        let userControlledCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
        for (let x of data["awards"])if (!(Object.keys(x["reward"]).length === 0)) {
            // Find objective property if award won
            let property = options[x["name"]];
            let company = userControlledCompanies.find((y)=>y.name === x["companyName"]);
            if (property && company) {
                let objectiveCompleted = await (0, $8A6FL.changeProperty)({
                    name: property,
                    change: 1,
                    company: company
                });
                if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                objectiveCompleted = await (0, $8A6FL.changeProperty)({
                    name: "win awards",
                    change: 1,
                    company: company
                });
                if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
            }
        }
        // Add host
        const randomRoster = (0, $3E8Nt.getRandomChoice)(await (0, $9esFv.getCompanyRosters)((0, $3E8Nt.getRandomChoice)(allCompanies)));
        const hostSuperstars = (await (0, $dl5u4.getRosterSuperstars)(randomRoster)).filter((y)=>!y.monthToAppearIn);
        if (hostSuperstars.length) data["host"] = (0, $3E8Nt.getRandomChoice)(hostSuperstars).name;
        else data["host"] = "Al Bananaworth";
        // Reset xpGainedThisYear for all championships and factions
        for (const x of [
            ...championships,
            factions
        ])x.xpGainedThisYear = 0;
        game.awardsRun = true;
        (0, $14eBR.db).saveDatabase();
        data["points"] = mainCompany.points;
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
        data["error"] = true;
        await (0, $14eBR.loadDb)((0, $14eBR.db).filename);
    }
    return data;
}
async function $b7dd8c4f6cc3ca70$var$getCompanyLastYearsEvents(company) {
    let allEvents = await (0, $9esFv.getCompanyEvents)(company);
    const monthlyEvents = allEvents.filter((x)=>!x.weeklyShow);
    const firstEvent = monthlyEvents[monthlyEvents.length - 13];
    const lastEvent = monthlyEvents[monthlyEvents.length - 1];
    return allEvents.filter((x)=>x.$loki >= firstEvent.$loki && x.$loki <= lastEvent.$loki);
}
async function $b7dd8c4f6cc3ca70$var$getBestMatch(matches, game, reverse = false, realYear) {
    let data = {};
    // Get award data
    let maxRating;
    let value;
    if (reverse) {
        maxRating = Math.min(...matches.map((y)=>y.rating));
        data["name"] = "Worst Match of the Year";
        data["trophy"] = "worst";
        value = 0;
    } else {
        maxRating = Math.max(...matches.map((y)=>y.rating));
        data["name"] = "Match of the Year";
        data["trophy"] = "gold";
        value = 3;
    }
    // Get best
    let matchWeights = [];
    for (let m of matches)if (m.rating === maxRating) {
        let weight = await (0, $i7bmn.getMatchGimmickMatch)(m) ? 10 : 100;
        matchWeights.push([
            m,
            weight
        ]);
    }
    let bestMatch = (0, $3E8Nt.weightedChoice)(matchWeights);
    // Get nominees
    let sortedMatches = [
        ...matches
    ].sort((a, b)=>reverse ? a.rating - b.rating : b.rating - a.rating);
    let nominees = sortedMatches.filter((x)=>x !== bestMatch).slice(0, 2);
    nominees.push(bestMatch);
    (0, $3E8Nt.shuffle)(nominees);
    // Get award company
    let bestMatchEvent = await (0, $i7bmn.getMatchEvent)(bestMatch);
    let awardCompany = await (0, $iQtzn.getEventCompany)(bestMatchEvent);
    // Add company log
    const bestMatchEventName = await (0, $6RCLU.getMatchEventTitle)(bestMatch);
    const bestMatchParticipantsNames = (await (0, $i7bmn.getMatchParticipants)(bestMatch)).map((y)=>y.name).join(" vs ");
    const bestMatchText = `${bestMatchParticipantsNames} (${bestMatchEventName})`;
    const companyLogText = `${reverse ? "Worst Match of the Year" : "Match of the Year"}: ${bestMatchText}`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, value, companyLogText, realYear);
    // Add reward
    if (reverse) await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, -50);
    else await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 200, true);
    // Format data
    data["nominees"] = [];
    for (const match of nominees){
        const matchEventName = await (0, $6RCLU.getMatchEventTitle)(match);
        const matchParticipantsNames = (await (0, $i7bmn.getMatchParticipants)(match)).map((y)=>y.name).join(" vs ");
        data["nominees"].push({
            name: `${matchParticipantsNames} (${matchEventName})`,
            rating: match.rating
        });
    }
    data["winner"] = {
        name: bestMatchText,
        rating: bestMatch.rating
    };
    return data;
}
async function $b7dd8c4f6cc3ca70$var$getBestGimmickMatch(matches, game, reverse = false, realYear) {
    let data = {};
    // Get only gimmick matches
    let filteredMatches = [];
    for (const match of matches)if (await (0, $i7bmn.getMatchGimmickMatch)(match)) filteredMatches.push(match);
    // If no gimmick matches
    if (filteredMatches.length < 3) filteredMatches = matches;
    // Get award data
    let maxRating;
    let value;
    if (reverse) {
        maxRating = Math.min(...filteredMatches.map((y)=>y.rating));
        data["name"] = "Stupidest Match of the Year";
        data["trophy"] = "worst";
        value = 0;
    } else {
        maxRating = Math.max(...filteredMatches.map((y)=>y.rating));
        data["name"] = "Craziest Match of the Year";
        data["trophy"] = "bronze";
        value = 1;
    }
    // Get best
    let bestMatches = filteredMatches.filter((x)=>x.rating === maxRating);
    let bestMatch = (0, $3E8Nt.getRandomChoice)(bestMatches);
    // Get nominees
    let sortedMatches = [
        ...filteredMatches
    ].sort((a, b)=>reverse ? a.rating - b.rating : b.rating - a.rating);
    let nominees = sortedMatches.filter((x)=>x !== bestMatch).slice(0, 2);
    nominees.push(bestMatch);
    (0, $3E8Nt.shuffle)(nominees);
    // Get award company
    let bestMatchEvent = await (0, $i7bmn.getMatchEvent)(bestMatch);
    let awardCompany = await (0, $iQtzn.getEventCompany)(bestMatchEvent);
    // Add company log
    const matchEventName = await (0, $6RCLU.getMatchEventTitle)(bestMatch);
    const bestMatchParticipantsNames = (await (0, $i7bmn.getMatchParticipants)(bestMatch)).map((y)=>y.name).join(" vs ");
    const bestMatchGimmickMatch = await (0, $i7bmn.getMatchGimmickMatch)(bestMatch);
    let bestMatchText;
    if (bestMatchGimmickMatch) bestMatchText = `${bestMatchParticipantsNames} - ${bestMatchGimmickMatch.name} Match (${matchEventName})`;
    else bestMatchText = `${bestMatchParticipantsNames} (${matchEventName})`;
    const companyLogText = `${reverse ? "Stupidest Match of the Year" : "Craziest Match of the Year"}: ${bestMatchText}`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, value, companyLogText, realYear);
    // Add reward
    if (reverse) await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, -50);
    else await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 50);
    // Format data
    data["nominees"] = [];
    for (const match of nominees){
        const matchEventName = await (0, $6RCLU.getMatchEventTitle)(match);
        const matchParticipantsNames = (await (0, $i7bmn.getMatchParticipants)(match)).map((y)=>y.name).join(" vs ");
        const matchGimmickMatch = await (0, $i7bmn.getMatchGimmickMatch)(match);
        let name;
        if (matchGimmickMatch) name = `${matchParticipantsNames} - ${matchGimmickMatch.name} Match (${matchEventName})`;
        else name = `${matchParticipantsNames} (${matchEventName})`;
        data["nominees"].push({
            name: name,
            rating: match.rating
        });
    }
    data["winner"] = {
        name: bestMatchText,
        rating: bestMatch.rating
    };
    return data;
}
async function $b7dd8c4f6cc3ca70$var$getBestEvent(events, game, reverse = false, realYear) {
    let data = {};
    // Get award data
    let maxRating;
    let value;
    if (reverse) {
        maxRating = Math.min(...events.map((y)=>y.rating));
        data["name"] = "Worst Event of the Year";
        data["trophy"] = "worst";
        value = 0;
    } else {
        maxRating = Math.max(...events.map((y)=>y.rating));
        data["name"] = "Event of the Year";
        data["trophy"] = "gold";
        value = 3;
    }
    // Get best
    let bestEvents = events.filter((x)=>x.rating === maxRating);
    let bestEvent = (0, $3E8Nt.getRandomChoice)(bestEvents);
    // Get nominees
    let sortedEvents = [
        ...events
    ].sort((a, b)=>reverse ? a.rating - b.rating : b.rating - a.rating);
    let nominees = sortedEvents.filter((x)=>x !== bestEvent).slice(0, 2);
    nominees.push(bestEvent);
    (0, $3E8Nt.shuffle)(nominees);
    // Get award company
    let awardCompany = await (0, $iQtzn.getEventCompany)(bestEvent);
    // Add company log
    const companyLogText = `${reverse ? "Worst Event of the Year" : "Event of the Year"}: ${bestEvent.name} (${bestEvent.year})`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, value, companyLogText, realYear);
    // Add reward
    if (reverse) await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, -50);
    else await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 200, true);
    // Format data
    data["nominees"] = nominees.map((x)=>{
        return {
            name: x.name,
            rating: x.rating
        };
    });
    data["winner"] = {
        name: bestEvent.name,
        rating: bestEvent.rating
    };
    return data;
}
async function $b7dd8c4f6cc3ca70$var$getMostHypedEvent(events, game, realYear) {
    let data = {};
    // Get award data
    data["name"] = "Most Hyped Event of the Year";
    data["trophy"] = "silver";
    let value = 2;
    // Get best
    let sortedEvents = events.sort((a, b)=>b.hype - a.hype);
    let mostHypedEvent = sortedEvents[0];
    // Get nominees
    let nominees = sortedEvents.filter((x)=>x !== mostHypedEvent).slice(0, 2);
    nominees.push(mostHypedEvent);
    (0, $3E8Nt.shuffle)(nominees);
    // Get award company
    let awardCompany = await (0, $iQtzn.getEventCompany)(mostHypedEvent);
    // Add company log
    const companyLogText = `Most Hyped Event of the Year: ${mostHypedEvent.name} (${mostHypedEvent.year})`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, value, companyLogText, realYear);
    // Add reward
    await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 100);
    // Format data
    data["nominees"] = nominees.map((x)=>{
        return {
            name: x.name,
            hype: x.hype
        };
    });
    data["winner"] = {
        name: mostHypedEvent.name,
        hype: mostHypedEvent.hype
    };
    return data;
}
async function $b7dd8c4f6cc3ca70$var$getBestWrestler(matches, game, realYear) {
    let data = {};
    // Get award data
    data["name"] = "Wrestler of the Year";
    data["trophy"] = "silver";
    // Get wrestlers who had more than a few matches
    let superstars = (await Promise.all(matches.map((x)=>(0, $i7bmn.getAllSuperstarsForMatch)(x)))).flat();
    const uniqueSuperstars = (0, $3E8Nt.getUniqueObjects)(superstars);
    let mostMatches = uniqueSuperstars.map((x)=>{
        return {
            "number": superstars.filter((y)=>y.$loki === x.$loki).length,
            "superstar": x
        };
    });
    mostMatches.sort((a, b)=>b.number - a.number); // Get most common objects
    let contenders = [];
    for (let superstarData of mostMatches.slice(0, Math.floor(mostMatches.length / 4))){
        // Get average match rating
        let averageRating = (await (0, $hBIDz.getSuperstarMatches)(superstarData["superstar"])).filter((match)=>match.rating !== null && (0, $3E8Nt.objectInArray)(match, matches)).map((match)=>match.rating).reduce((a, b)=>a + b, 0) / superstarData["number"];
        let contender = {
            "superstar": superstarData["superstar"],
            "averageRating": averageRating
        };
        contenders.push(contender);
    }
    // Get best
    let sortedContenders = [
        ...contenders
    ].sort((a, b)=>b.averageRating - a.averageRating);
    let bestWrestler = sortedContenders[0];
    // Get nominees
    let nominees = [];
    nominees.push(...sortedContenders.slice(0, 3));
    (0, $3E8Nt.shuffle)(nominees);
    // Get award company
    let bestWrestlerRoster = await (0, $hBIDz.getSuperstarRoster)(bestWrestler["superstar"]);
    let awardCompany = await (0, $dl5u4.getRosterCompany)(bestWrestlerRoster);
    // Add company log
    const companyLogText = `Wrestler of the Year: ${bestWrestler["superstar"]["name"]} (${realYear - 1})`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, 2, companyLogText, realYear);
    // Add reward
    await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 100);
    // Format data
    data["nominees"] = nominees.map((superstarData)=>{
        return {
            name: superstarData["superstar"]["name"],
            averageRating: superstarData["averageRating"]
        };
    });
    data["winner"] = {
        name: bestWrestler["superstar"]["name"],
        averageRating: bestWrestler["averageRating"]
    };
    return data;
}
async function $b7dd8c4f6cc3ca70$var$getBestFeud(feuds, game, reverse = false, realYear) {
    let data = {};
    // Get award data
    let maxRating;
    let value;
    if (reverse) {
        maxRating = Math.min(...feuds.map((feud)=>feud.rating));
        data["name"] = "Worst Feud of the Year";
        data["trophy"] = "worst";
        value = 0;
    } else {
        maxRating = Math.max(...feuds.map((feud)=>feud.rating));
        data["name"] = "Feud of the Year";
        data["trophy"] = "gold";
        value = 3;
    }
    // Get best
    let bestFeuds = feuds.filter((feud)=>feud.rating === maxRating);
    let bestFeud = (0, $3E8Nt.getRandomChoice)(bestFeuds);
    // Get nominees
    let sortedFeuds = [
        ...feuds
    ].sort((a, b)=>reverse ? a.rating - b.rating : b.rating - a.rating);
    let nominees = sortedFeuds.filter((x)=>x !== bestFeud).slice(0, 2);
    nominees.push(bestFeud);
    (0, $3E8Nt.shuffle)(nominees);
    // Get award company
    let bestFeudRoster = await (0, $jDtEn.getFeudRoster)(bestFeud);
    let awardCompany = await (0, $dl5u4.getRosterCompany)(bestFeudRoster);
    // Add company log
    const bestFeudParticipantsNames = (await (0, $cXLSF.getFeudParticipantsNames)(bestFeud)).join(" vs ");
    const bestFeudText = `${bestFeudParticipantsNames} (${bestFeud.name})`;
    const companyLogText = `${reverse ? "Worst Feud of the Year" : "Feud of the Year"}: ${bestFeudText} (${realYear - 1})`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, value, companyLogText, realYear);
    // Add reward
    if (reverse) await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, -50);
    else await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 200, true);
    // Format data
    data["nominees"] = [];
    for (const feud of nominees){
        const feudParticipantsNames = (await (0, $cXLSF.getFeudParticipantsNames)(feud)).join(" vs ");
        let name = `${feudParticipantsNames} (${feud.name})`;
        data["nominees"].push({
            name: name,
            rating: feud.rating
        });
    }
    data["winner"] = {
        name: bestFeudText,
        rating: bestFeud.rating
    };
    return data;
}
async function $b7dd8c4f6cc3ca70$var$getBestSegment(segments, game, reverse = false, realYear) {
    let data = {};
    // Get award data
    let maxRating;
    let value;
    if (reverse) {
        maxRating = Math.min(...segments.map((segment)=>segment.rating));
        data["name"] = "Worst Segment of the Year";
        data["trophy"] = "worst";
        value = 0;
    } else {
        maxRating = Math.max(...segments.map((segment)=>segment.rating));
        data["name"] = "Segment of the Year";
        data["trophy"] = "silver";
        value = 3;
    }
    // Get best
    let bestSegments = segments.filter((segment)=>segment.rating === maxRating);
    let bestSegment = (0, $3E8Nt.getRandomChoice)(bestSegments);
    // Get nominees
    let sortedSegments = [
        ...segments
    ].sort((a, b)=>reverse ? a.rating - b.rating : b.rating - a.rating);
    let nominees = sortedSegments.filter((m)=>m !== bestSegment).slice(0, 2);
    nominees.push(bestSegment);
    (0, $3E8Nt.shuffle)(nominees);
    // Get award company
    let bestSegmentEvent = await (0, $eg5dz.getSegmentEvent)(bestSegment);
    let awardCompany = await (0, $iQtzn.getEventCompany)(bestSegmentEvent);
    // Add company log
    const bestSegmentEventName = await (0, $6RCLU.getMatchEventTitle)(bestSegment);
    const bestSegmentParticipantsNames = (await (0, $eg5dz.getSegmentParticipants)(bestSegment)).map((y)=>y.name).join(" and ");
    const bestSegmentText = `${(await (0, $eg5dz.getSegmentSegmentItem)(bestSegment))?.name}: ${bestSegmentParticipantsNames} (${bestSegmentEventName})`;
    const companyLogText = `${reverse ? "Worst Segment of the Year" : "Segment of the Year"}: ${bestSegmentText} (${realYear - 1})`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, value, companyLogText, realYear);
    // Add reward
    if (reverse) await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, -50);
    else await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 200);
    // Format data
    data["nominees"] = [];
    for (const segment of nominees){
        const segmentEventName = await (0, $6RCLU.getMatchEventTitle)(segment);
        const segmentParticipantsNames = (await (0, $eg5dz.getSegmentParticipants)(segment)).map((y)=>y.name).join(" and ");
        data["nominees"].push({
            name: `${(await (0, $eg5dz.getSegmentSegmentItem)(segment))?.name}: ${segmentParticipantsNames} (${segmentEventName})`,
            rating: segment.rating
        });
    }
    data["winner"] = {
        name: bestSegmentText,
        rating: bestSegment.rating
    };
    return data;
}
async function $b7dd8c4f6cc3ca70$var$getBestCompany(companyEvents, game, reverse = false, realYear) {
    let data = {};
    let companiesData = [];
    // Get average rating for each company's shows
    for (let companyData of Object.values(companyEvents)){
        let events = companyData["events"];
        if (events.length >= 4) {
            let rating = events.reduce((a, b)=>a + b.rating, 0) / events.length;
            companiesData.push({
                company: companyData["company"],
                name: companyData["name"],
                rating: rating
            });
        }
    }
    // Get award data
    let awardWinner;
    let value;
    if (reverse) {
        awardWinner = companiesData.reduce((min, p)=>p.rating < min.rating ? p : min, companiesData[0]);
        data["name"] = "Worst Company of the Year";
        data["trophy"] = "worst";
        value = 0;
    } else {
        awardWinner = companiesData.reduce((max, p)=>p.rating > max.rating ? p : max, companiesData[0]);
        data["name"] = "Company of the Year";
        data["trophy"] = "gold";
        value = 3;
    }
    let awardCompany = awardWinner["company"];
    // Get nominees
    let sortedCompanies = [
        ...companiesData
    ].sort((a, b)=>reverse ? a.rating - b.rating : b.rating - a.rating);
    let nominees = sortedCompanies.filter((c)=>c !== awardWinner).slice(0, 2);
    nominees.push(awardWinner);
    (0, $3E8Nt.shuffle)(nominees);
    // Add company log
    const companyLogText = `${reverse ? "Worst Company of the Year" : "Company of the Year"}: ${awardWinner.name} (${realYear - 1})`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, value, companyLogText, realYear);
    // Add reward
    if (reverse) await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, -50);
    else await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 200, true);
    // Format data
    data["nominees"] = nominees.map((x)=>{
        return {
            name: x.name,
            rating: x.rating
        };
    });
    data["winner"] = {
        name: awardWinner["name"],
        rating: awardWinner["rating"]
    };
    if (!reverse) return [
        data,
        companiesData
    ];
    else return data;
}
async function $b7dd8c4f6cc3ca70$var$getBestChampionship(championships, game, realYear) {
    let data = {};
    // Get award data
    data["name"] = "Championship of the Year";
    data["trophy"] = "silver";
    // Get best
    let sortedChampionships = [
        ...championships
    ].sort((a, b)=>b.xpGainedThisYear - a.xpGainedThisYear);
    let bestChampionship = sortedChampionships[0];
    // Add nominees and shuffle
    let nominees = [];
    nominees.push(...sortedChampionships.slice(0, 3));
    (0, $3E8Nt.shuffle)(nominees);
    // Get award company
    let awardCompany = await (0, $ivuOU.getChampionshipCompany)(bestChampionship);
    // Add company log
    const companyLogText = `Championship of the Year: ${(0, $1JSre.getChampionshipDisplayName)(bestChampionship)} (${realYear - 1})`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, 2, companyLogText, realYear);
    // Add reward
    await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 100);
    // Format data
    data["nominees"] = nominees.map((x)=>{
        return {
            name: (0, $1JSre.getChampionshipDisplayName)(x),
            xpGained: x.xpGainedThisYear
        };
    });
    data["winner"] = {
        name: (0, $1JSre.getChampionshipDisplayName)(bestChampionship),
        averageRating: bestChampionship.xpGainedThisYear
    };
    return data;
}
async function $b7dd8c4f6cc3ca70$var$getBestFaction(factions, game, realYear) {
    let data = {};
    // Get award data
    data["name"] = "Faction of the Year";
    data["trophy"] = "bronze";
    // Get best
    let sortedFactions = [
        ...factions
    ].sort((a, b)=>b.xpGainedThisYear - a.xpGainedThisYear);
    let bestFaction = sortedFactions[0];
    // Add nominees and shuffle
    let nominees = [];
    nominees.push(...sortedFactions.slice(0, 3));
    (0, $3E8Nt.shuffle)(nominees);
    // Get award company
    let bestFactionRoster = await (0, $2JFAd.getFactionRoster)(bestFaction);
    let awardCompany = await (0, $dl5u4.getRosterCompany)(bestFactionRoster);
    // Add company log
    const companyLogText = `Faction of the Year: ${bestFaction.name} (${realYear - 1})`;
    await $b7dd8c4f6cc3ca70$var$addCompanyLog(awardCompany, game, 1, companyLogText, realYear);
    // Add reward
    await $b7dd8c4f6cc3ca70$var$addReward(data, awardCompany, game, 50);
    // Format data
    data["nominees"] = nominees.map((x)=>{
        return {
            name: x.name,
            xpGained: x.xpGainedThisYear
        };
    });
    data["winner"] = {
        name: bestFaction.name,
        averageRating: bestFaction.xpGainedThisYear
    };
    return data;
}
async function $b7dd8c4f6cc3ca70$var$checkToAwardOrUnlockPowerups(data, company, game) {
    let powerups = await (0, $9esFv.getCompanyPowerups)(company);
    if (powerups.length) {
        let powerupsToUnlock = (0, $kpu3X.getPowerupsToUnlock)(powerups);
        if (powerupsToUnlock.length > 0) await $b7dd8c4f6cc3ca70$var$awardOrUnlockPowerup(data, company, game, powerupsToUnlock, true);
        else await $b7dd8c4f6cc3ca70$var$awardOrUnlockPowerup(data, company, game, powerups);
    }
}
async function $b7dd8c4f6cc3ca70$var$awardOrUnlockPowerup(data, company, game, allPowerups, unlock = false) {
    let unlockedOrAwardedPowerup;
    if (!unlock) allPowerups = allPowerups.filter((y)=>y.unlocked);
    unlockedOrAwardedPowerup = (0, $kpu3X.awardPowerup)(allPowerups, unlock, true);
    if (company.userControlled) {
        let newMessage = await (0, $hekDR.createPowerupMessage)(unlockedOrAwardedPowerup, game.monthCount, game.year, unlock);
        await (0, $9esFv.addCompanyMessages)(company, [
            newMessage
        ]);
    }
}
async function $b7dd8c4f6cc3ca70$var$addReward(data, company, game, points, checkPowerups = false) {
    data["reward"] = {};
    data["companyName"] = company.name;
    if (company.userControlled) {
        data["reward"]["points"] = points;
        company.points += points;
    }
    if (checkPowerups) await $b7dd8c4f6cc3ca70$var$checkToAwardOrUnlockPowerups(data, company, game);
}
async function $b7dd8c4f6cc3ca70$var$addCompanyLog(company, game, value, text, realYear) {
    const newLog = (0, $4K85d.CompanyLog)(game.monthCount, realYear);
    (0, $14eBR.CompanyLogs).insert(newLog);
    newLog.text = text;
    newLog.type = "award";
    newLog.realYear = game.year;
    newLog.value = value;
    await (0, $9esFv.addCompanyCompanyLogs)(company, [
        newLog
    ]);
}



var $jpMCP = parcelRequire("jpMCP");

var $ko5kE = parcelRequire("ko5kE");

var $1olyO = parcelRequire("1olyO");

var $kZMqI = parcelRequire("kZMqI");

var $3NAMH = parcelRequire("3NAMH");

var $ivuOU = parcelRequire("ivuOU");

var $6PzHO = parcelRequire("6PzHO");

var $2JFAd = parcelRequire("2JFAd");

var $4K85d = parcelRequire("4K85d");

var $fuJHb = parcelRequire("fuJHb");


var $66ItE = parcelRequire("66ItE");

var $bZol7 = parcelRequire("bZol7");

var $hekDR = parcelRequire("hekDR");
async function $f0da149825527215$export$54d5b3aa18b9b8d2({ style: style, numberOption: numberOption, addOption: addOption, hideBooked: hideBooked } = {}) {
    let data = {};
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(currentGame);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const producers = (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
    // Get cost
    const costsData = {
        "standard": 10,
        "long-term": 20,
        "quality": 15,
        "bizarro": 5,
        "terrible": 2
    };
    let cost = costsData[style] || 10;
    if (latestEvent.weeklyShow) cost = Math.floor(cost / 2);
    // Check points
    if (userCompany.points < cost) {
        data["error"] = "points";
        return data;
    }
    // Don't allow at premier event in POW
    if (userCompany.storyName === "passion" && addOption === "replace") {
        const sponsorGoal = (await (0, $9esFv.getCompanyObjectives)(userCompany)).find((x)=>x.name === "Get some Sponsors");
        if (!sponsorGoal.completed && !sponsorGoal.failed) {
            data["error"] = "pow-cannot-replace";
            return data;
        }
    }
    // Auto book event
    await $f0da149825527215$var$autoBookEvent({
        company: userCompany,
        roster: mainRoster,
        rosterSuperstars: rosterSuperstars,
        latestEvent: latestEvent,
        producers: producers,
        game: currentGame,
        style: style,
        numberOption: numberOption,
        addOption: addOption,
        hideBooked: hideBooked
    });
    // Subtract points
    userCompany.points -= cost;
    (0, $14eBR.db).saveDatabase();
    // Get data to return
    data["points"] = userCompany.points;
    const matches = await (0, $5ZsVo.getEventMatchesData)({
        event: latestEvent,
        rosterSuperstars: rosterSuperstars
    });
    const segments = await (0, $5ZsVo.getEventSegmentsData)({
        event: latestEvent,
        rosterSuperstars: rosterSuperstars,
        producers: producers
    });
    data["matchesAndSegments"] = matches.concat(segments);
    data["matchesAndSegments"].sort((a, b)=>a.order - b.order);
    return data;
}
async function $f0da149825527215$var$autoBookEvent({ company: company, roster: roster, rosterSuperstars: rosterSuperstars, latestEvent: latestEvent, producers: producers, game: game, style: style, numberOption: numberOption = "auto", addOption: addOption = "replace", hideBooked: hideBooked = false, championships: championships = null, parentEvents: parentEvents = null, companyEvents: companyEvents = null } = {}) {
    let data = {};
    const eventMatchesAndSegments = await (0, $5ZsVo.getEventMatchesAndSegments)(latestEvent);
    const numberOfMatchesAndSegmentsBooked = eventMatchesAndSegments.length;
    const rosterTeams = await (0, $dl5u4.getRosterTagTeams)(roster);
    const tagTeams = rosterTeams.filter((x)=>!x.trio);
    const trios = rosterTeams.filter((x)=>x.trio);
    const gimmickMatches = await (0, $9esFv.getCompanyGimmickMatches)(company);
    const feudItems = await (0, $9esFv.getCompanyFeudItems)(company);
    const companyLogs = await (0, $9esFv.getCompanyCompanyLogs)(company);
    const productionFacility = (await (0, $9esFv.getCompanyFacilities)(company)).find((x)=>x.name === "Production");
    if (!parentEvents) parentEvents = await (0, $8A6FL.getCompanyParentEvents)(company);
    if (!championships) championships = await (0, $9esFv.getCompanyChampionships)(company);
    if (!companyEvents) companyEvents = (await (0, $9esFv.getCompanyEvents)(company)).reverse();
    // Don't use already booked superstars if add option selected
    let bookedSuperstars = [];
    if (addOption === "add") bookedSuperstars = await (0, $6RCLU.getSuperstarsBookedAtEventMatches)(latestEvent);
    // If 'replace' option selected, delete matches and segments
    if (addOption === "replace") {
        for (const x of eventMatchesAndSegments)if (x.objectName === "segment") await (0, $4ptHI.deleteSegment)(x, producers);
        else await (0, $6RCLU.deleteMatch)(x, company);
        latestEvent.matchesCount = 0;
    }
    // Get available
    let availableSuperstars = [];
    for (const x of rosterSuperstars)if (await $f0da149825527215$var$checkAutoBookParticipantAvailability(x, rosterSuperstars, latestEvent, championships, bookedSuperstars)) availableSuperstars.push(x);
    let availableTagTeams = [];
    for (const x of tagTeams)if (await $f0da149825527215$var$checkAutoBookParticipantAvailability(x, rosterSuperstars, latestEvent, championships, bookedSuperstars)) availableTagTeams.push(x);
    let availableTrios = [];
    for (const x of trios)if (await $f0da149825527215$var$checkAutoBookParticipantAvailability(x, rosterSuperstars, latestEvent, championships, bookedSuperstars)) availableTrios.push(x);
    // Fix low number of available superstars for competitors
    if (!company.userControlled) {
        if (availableSuperstars.length < 7) // Generate superstars
        for (const x of Array(5).keys()){
            let newSuperstar = await (0, $8bQDO.generateSuperstar)({
                notManager: true
            });
            await (0, $dl5u4.addRosterSuperstars)(roster, [
                newSuperstar
            ]);
            rosterSuperstars.push(newSuperstar);
            availableSuperstars.push(newSuperstar);
        }
    }
    // Get past event's matches
    let monthlyEvents = companyEvents.filter((x)=>!x.weeklyShow);
    let pastEventMatches = [];
    for (const m of (await (0, $iQtzn.getEventMatches)(monthlyEvents[1]))){
        let matchParticipants = await (0, $i7bmn.getMatchParticipants)(m);
        let available = true;
        for (const x of matchParticipants)if (!await $f0da149825527215$var$checkAutoBookParticipantAvailability(x, rosterSuperstars, latestEvent, championships, bookedSuperstars)) available = false;
        if (matchParticipants.length > 1 && available) pastEventMatches.push(m);
    }
    // Get number to book
    let numberToBook = $f0da149825527215$var$getEventMatchesAndSegmentsToAutoBook(latestEvent, parentEvents, rosterSuperstars, productionFacility, numberOption, style);
    // If 'add' option selected, subtract added segments
    if (addOption === "add") {
        numberToBook -= numberOfMatchesAndSegmentsBooked;
        if (numberToBook <= 0) {
            data["error"] = "already-booked";
            return data;
        }
    }
    // Get feuds
    let singlesFeuds = [];
    let tagFeuds = [];
    for (const f of (await (0, $dl5u4.getRosterFeuds)(roster)))if (f.startMonth !== null && !f.ended) {
        let feudCheckResult = await $f0da149825527215$var$checkAutoBookFeudAvailability(f, rosterSuperstars, latestEvent, championships, bookedSuperstars);
        if (feudCheckResult[0]) {
            if (feudCheckResult[1] === "superstar") singlesFeuds.push(f);
            else if (feudCheckResult[1] === "tagTeam") tagFeuds.push(f);
        }
    }
    // Auto book event
    if (latestEvent.weeklyShow || latestEvent.name === "Weekly Show") data = await $f0da149825527215$var$autoBookWeeklyEvent(company, roster, availableSuperstars, availableTagTeams, availableTrios, championships, style, gimmickMatches, latestEvent, parentEvents, numberToBook, singlesFeuds, tagFeuds, pastEventMatches, feudItems, companyLogs, rosterSuperstars, game, hideBooked);
    else data = await $f0da149825527215$var$autoBookMonthlyEvent(company, roster, availableSuperstars, availableTagTeams, availableTrios, championships, style, gimmickMatches, latestEvent, parentEvents, numberToBook, singlesFeuds, tagFeuds, pastEventMatches, feudItems, companyLogs, rosterSuperstars, game, hideBooked);
    return data;
}
async function $f0da149825527215$var$autoBookMonthlyEvent(company, roster, availableSuperstars, availableTagTeams, availableTrios, championships, style, gimmickMatches, latestEvent, parentEvents, numberToBook, singlesFeuds, tagFeuds, pastEventMatches, feudItems, companyLogs, rosterSuperstars, game, hideBooked) {
    let data = {};
    // Get roster division and member weights
    let matchDivisionsWeights = await $f0da149825527215$var$getAutoBookerDivisionAndMembersWeights(roster, availableSuperstars, availableTagTeams, availableTrios, championships, style);
    // Get match contracts
    let parentEvent = await (0, $5ZsVo.getParentEventForEvent)(parentEvents, latestEvent);
    let matchContracts = parentEvents.length > 0 ? await (0, $iQtzn.getEventMatchContracts)(parentEvent) : [];
    // Book matches based on numberToBook
    data["bookedMatches"] = [];
    for (const x of Array(numberToBook).keys()){
        // Select a division, select top division in first match (main event)
        let selectedDivision;
        if (x === 0) selectedDivision = [
            ...matchDivisionsWeights
        ].sort((a, b)=>b[1] - a[1])[0][0];
        else selectedDivision = (0, $3E8Nt.weightedChoice)(matchDivisionsWeights);
        // Book match if 2 or more participants are present in division
        if (selectedDivision.length >= 2) {
            let autoBookData = await $f0da149825527215$var$autoBookMatch(selectedDivision, latestEvent, championships, company, gimmickMatches, pastEventMatches, game, singlesFeuds, tagFeuds, [
                ...feudItems
            ], companyLogs, style, rosterSuperstars, hideBooked, matchDivisionsWeights, matchContracts);
            data["bookedMatches"].push(autoBookData["bookedMatch"]);
            // Update variables
            matchDivisionsWeights = autoBookData["divisionsWeights"];
            singlesFeuds = autoBookData["singlesFeuds"];
            tagFeuds = autoBookData["tagFeuds"];
            pastEventMatches = autoBookData["pastEventMatches"];
            matchContracts = autoBookData["matchContracts"];
        }
    }
    return data;
}
async function $f0da149825527215$var$autoBookWeeklyEvent(company, roster, availableSuperstars, availableTagTeams, availableTrios, championships, style, gimmickMatches, latestEvent, parentEvents, numberToBook, singlesFeuds, tagFeuds, pastEventMatches, feudItems, companyLogs, rosterSuperstars, game, hideBooked) {
    let data = {};
    let itemsUsed = [];
    const segmentItems = await (0, $9esFv.getCompanySegmentItems)(company);
    const onlyProductionSegments = latestEvent.activeEffect === "production_packages_only";
    const segmentRate = company.style === "entertainment" ? 50 : 25;
    // Get roster division and member weights
    let matchDivisionsWeights = await $f0da149825527215$var$getAutoBookerDivisionAndMembersWeights(roster, availableSuperstars, availableTagTeams, availableTrios, championships, style);
    let segmentDivisionsWeights = await $f0da149825527215$var$getAutoBookerDivisionAndMembersWeights(roster, availableSuperstars, availableTagTeams, availableTrios, championships, style, true);
    // Book matches/segments based on numberToBook
    data["bookedMatches"] = [];
    data["bookedSegments"] = [];
    for (const x of Array(numberToBook).keys()){
        let bookSegment = (0, $3E8Nt.getRandomInt)(0, 100) <= segmentRate || onlyProductionSegments;
        // Select a division, select top division in main event
        let selectedDivision;
        let selectedDivisionWeights = bookSegment ? segmentDivisionsWeights : matchDivisionsWeights;
        if (x === 0) selectedDivision = [
            ...selectedDivisionWeights
        ].sort((a, b)=>b[1] - a[1])[0][0];
        else selectedDivision = (0, $3E8Nt.weightedChoice)(selectedDivisionWeights);
        // Book if 2 or more participants are present in division
        if (selectedDivision.length >= 2) {
            // Book segment
            if (bookSegment) {
                let autoBookData = await $f0da149825527215$var$autoBookSegment(selectedDivision, latestEvent, championships, company, game, singlesFeuds, tagFeuds, feudItems, segmentItems, itemsUsed, companyLogs, style, rosterSuperstars, hideBooked, segmentDivisionsWeights);
                if (autoBookData) {
                    data["bookedSegments"].push(autoBookData["bookedSegment"]);
                    // Update variables
                    segmentDivisionsWeights = autoBookData["divisionsWeights"];
                    singlesFeuds = autoBookData["singlesFeuds"];
                    tagFeuds = autoBookData["tagFeuds"];
                    itemsUsed = autoBookData["itemsUsed"];
                }
            } else {
                let autoBookData = await $f0da149825527215$var$autoBookMatch(selectedDivision, latestEvent, championships, company, gimmickMatches, pastEventMatches, game, singlesFeuds, tagFeuds, feudItems, companyLogs, style, rosterSuperstars, hideBooked, matchDivisionsWeights);
                data["bookedMatches"].push(autoBookData["bookedMatch"]);
                // Update variables
                matchDivisionsWeights = autoBookData["divisionsWeights"];
                singlesFeuds = autoBookData["singlesFeuds"];
                tagFeuds = autoBookData["tagFeuds"];
                pastEventMatches = autoBookData["pastEventMatches"];
            }
        }
    }
    return data;
}
async function $f0da149825527215$var$getAutoBookerDivisionAndMembersWeights(roster, superstars, tagTeams, trios, championships, style, segment = false) {
    // Returns data in format [ [ [member, memberWeight], [member, memberWeight] ], divisionWeight ]
    let weights = [];
    // Get singles, tag team and trio division members
    let maleSinglesDivisionMembers = superstars.filter((x)=>x.gender === "male" || x.gender === "non-binary");
    let femaleSinglesDivisionMembers = superstars.filter((x)=>x.gender === "female" || x.gender === "non-binary");
    let maleTagTeamDivisionMembers = [];
    let femaleTagTeamDivisionMembers = [];
    for (const x of tagTeams){
        let tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(x);
        if (tagTeamSuperstars.every((x)=>x.gender === "male" || x.gender === "non-binary")) maleTagTeamDivisionMembers.push(x);
        if (tagTeamSuperstars.every((x)=>x.gender === "female" || x.gender === "non-binary")) femaleTagTeamDivisionMembers.push(x);
    }
    let maleTrioDivisionMembers = [];
    let femaleTrioDivisionMembers = [];
    for (const x of trios){
        let trioSuperstars = await (0, $972Ip.getTagTeamSuperstars)(x);
        if (trioSuperstars.every((x)=>x.gender === "male" || x.gender === "non-binary")) maleTrioDivisionMembers.push(x);
        if (trioSuperstars.every((x)=>x.gender === "female" || x.gender === "non-binary")) femaleTrioDivisionMembers.push(x);
    }
    // Get division members' weights, add division weights based on number of division members
    let totalMembers = maleSinglesDivisionMembers.length + femaleSinglesDivisionMembers.length + maleTagTeamDivisionMembers.length + femaleTagTeamDivisionMembers.length + maleTrioDivisionMembers.length + femaleTrioDivisionMembers.length;
    for (const x of [
        maleSinglesDivisionMembers,
        femaleSinglesDivisionMembers,
        maleTagTeamDivisionMembers,
        femaleTagTeamDivisionMembers,
        maleTrioDivisionMembers,
        femaleTrioDivisionMembers
    ]){
        let divisionMembersWeights = await $f0da149825527215$var$getDivisionMembersWeights(x, championships, style, segment);
        let numberOfMembers = divisionMembersWeights.length;
        if ([
            maleTagTeamDivisionMembers,
            femaleTagTeamDivisionMembers
        ].includes(x)) numberOfMembers *= 2;
        else if ([
            maleTrioDivisionMembers,
            femaleTrioDivisionMembers
        ].includes(x)) numberOfMembers *= 3;
        weights.push([
            divisionMembersWeights,
            numberOfMembers / totalMembers
        ]);
    }
    return weights;
}
async function $f0da149825527215$var$getDivisionMembersWeights(divisionMembers, championships, style, segment) {
    let divisionMembersWeights = [];
    if (divisionMembers.length <= 0) return divisionMembersWeights;
    // Filter championships
    if (divisionMembers[0].objectName === "superstar") championships = championships.filter((x)=>!x.tagTeam && !x.trio);
    else if (divisionMembers[0].objectName === "tagTeam") {
        let trio = divisionMembers[0].trio;
        if (trio) championships = championships.filter((x)=>x.trio);
        else championships = championships.filter((x)=>x.tagTeam);
    }
    // Get segment or match weights
    for (const x of divisionMembers){
        // Skip temporary teams
        if (x.objectName === "tagTeam " && x.temporary) continue;
        let weight = await $f0da149825527215$var$getDivisionMemberWeight(x, championships, style, segment);
        divisionMembersWeights.push([
            x,
            weight
        ]);
    }
    return divisionMembersWeights;
}
async function $f0da149825527215$var$getDivisionMemberWeight(x, championships, style, segment) {
    // Get superstars
    let superstars = await (0, $5kTkA.getRosterMemberSuperstars)(x);
    // Set initial weight using popularity
    let weight;
    let popularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
    popularity = (0, $3E8Nt.limitValueBetweenRange)(popularity, 0, 10000);
    if (style === "quality") {
        weight = Math.exp(popularity / 70) / 1000;
        if ((0, $5kTkA.getRankFromPopularity)(popularity) === "Main Eventer") weight *= 5;
    } else if (style === "bizarro") weight = Math.exp(popularity / 250);
    else weight = Math.exp(popularity / 70) / 100;
    // Part timer
    if (superstars.some((y)=>y.partTimer)) {
        let partTimerDivisor = 1.3;
        if (style === "long-term") {
            partTimerDivisor = 2.5;
            let age = Math.round(superstars.reduce((n, { age: age })=>n + age, 0) / superstars.length);
            weight *= $f0da149825527215$var$getAutoBookerAgeMultiplier(age); // Move outside of part timer check
        } else if (style === "bizarro") partTimerDivisor = 0.2;
        weight /= partTimerDivisor;
    }
    // Hot/stale
    if (superstars.some((x)=>x.hot)) {
        if (style === "quality") weight *= 20;
        else if (style === "terrible") weight *= 0.5;
        else weight *= 10;
    }
    if (superstars.some((x)=>x.stale)) {
        if (style === "quality") weight *= 0.05;
        else if (style === "terrible") weight *= 10;
        else weight *= 0.2;
    }
    if (segment) // Charisma
    for (const y of superstars){
        let charismaMultipliers;
        if (style === "quality") charismaMultipliers = {
            1: 0.1,
            2: 0.5,
            3: 30,
            4: 30
        };
        else if (style === "terrible") charismaMultipliers = {
            1: 20,
            2: 1,
            3: 0.1,
            4: 0.1
        };
        else charismaMultipliers = {
            1: 1,
            2: 3,
            3: 5,
            4: 5
        };
        weight *= charismaMultipliers[(0, $5kTkA.getSuperstarCharisma)(y)];
    }
    else {
        // Champion
        let memberChampionships = championships.filter((y)=>y.superstarId === superstars[0].$loki);
        if (memberChampionships.length > 0) {
            if (style === "quality") weight *= 1000;
            else if (style === "terrible") weight *= 0.5;
            else weight *= 5;
        }
        // Unhappy/leaving
        if (superstars.some((x)=>x.unhappy || x.contractMonthsRemaining !== null)) weight *= 500;
        // Workrate
        for (const y of superstars){
            let workrateMultipliers;
            if (style === "quality") workrateMultipliers = {
                1: 0.1,
                2: 0.5,
                3: 30,
                4: 30
            };
            else if (style === "terrible") workrateMultipliers = {
                1: 20,
                2: 1,
                3: 0.1,
                4: 0.1
            };
            else workrateMultipliers = {
                1: 1,
                2: 3,
                3: 5,
                4: 5
            };
            weight *= workrateMultipliers[(0, $5kTkA.getSuperstarWorkrate)(y)];
        }
    }
    return Math.ceil(weight);
}
function $f0da149825527215$var$getAutoBookerAgeMultiplier(age) {
    if (age <= 25) return 3;
    else if (age <= 32) return 2;
    else if (age <= 38) return 1;
    else return 0.5;
}
async function $f0da149825527215$var$checkAutoBookParticipantAvailability(p, rosterSuperstars, event, companyChampionships, bookedSuperstars = []) {
    if (p.objectName === "superstar") {
        if (!(0, $5kTkA.checkAvailability)(p, false) || p.fatigue >= 50 || !(0, $3E8Nt.objectInArray)(p, rosterSuperstars) || (0, $3E8Nt.objectInArray)(p, bookedSuperstars)) return false;
        else if (!(0, $5kTkA.checkSuperstarBrandAvailability)(event, p, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(p, companyChampionships))) return false;
        else if (event.activeEffect === "no_men_bookable" && p.gender === "male" || event.activeEffect === "no_women_bookable" && p.gender === "female") return false;
        return true;
    } else if (p.objectName === "tagTeam") {
        let available = true;
        let superstars = await (0, $972Ip.getTagTeamSuperstars)(p);
        if (superstars.length <= 0) available = false;
        for (const s of superstars){
            if (!(0, $5kTkA.checkAvailability)(s, false) || s.fatigue >= 50 || !(0, $3E8Nt.objectInArray)(s, rosterSuperstars) || (0, $3E8Nt.objectInArray)(s, bookedSuperstars)) available = false;
            else if (!(0, $5kTkA.checkSuperstarBrandAvailability)(event, s, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(s, companyChampionships))) available = false;
            else if (event.activeEffect === "no_men_bookable" && s.gender === "male" || event.activeEffect === "no_women_bookable" && s.gender === "female") available = false;
        }
        return available;
    }
}
async function $f0da149825527215$var$checkAutoBookFeudAvailability(feud, rosterSuperstars, event, companyChampionships, bookedSuperstars) {
    let available = true;
    let participantType;
    // Don't add feuds with less than 2 participants and faction feuds
    let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
    if (feudParticipants.length < 2 || feudParticipants.some((x)=>x.objectName === "faction")) available = false;
    else // Check availability of feud participants
    for (const x of feudParticipants){
        participantType = x.objectName;
        if (!await $f0da149825527215$var$checkAutoBookParticipantAvailability(x, rosterSuperstars, event, companyChampionships, bookedSuperstars)) available = false;
    }
    return [
        available,
        participantType
    ];
}
function $f0da149825527215$var$getEventMatchesAndSegmentsToAutoBook(event, parentEvents, rosterSuperstars, productionFacility, numberOption, style) {
    let minimum = (0, $5ZsVo.getEventMinimumMatchesAndSegments)(event, parentEvents, rosterSuperstars);
    let maximum = (0, $5ZsVo.getEventMaximumMatchesAndSegments)(event, parentEvents, productionFacility);
    if (numberOption === "min") return minimum;
    else if (numberOption === "max") return maximum;
    // Add weights, higher for more segments
    let weights = [];
    if (style === "quality") {
        let i = 1;
        for(let step = maximum; step > minimum - 1; step--){
            weights.push([
                step,
                i
            ]);
            i++;
        }
    } else {
        let i = 1;
        for(let step = minimum; step < maximum + 1; step++){
            weights.push([
                step,
                i
            ]);
            i++;
        }
    }
    return (0, $3E8Nt.weightedChoice)(weights);
}
async function $f0da149825527215$var$autoBookMatch(divisionWeights, event, championships, company, gimmickMatches, pastEventMatches, game, singlesFeuds, tagFeuds, feudItems, companyLogs, style, rosterSuperstars, hideBooked, matchDivisionsWeights, matchContracts = []) {
    let bookedParticipants;
    let bookedPastEventMatch;
    let bookedMatchContract;
    let selectedGimmickMatch;
    let matchChampionship;
    let weeklyShow = event.weeklyShow || event.name === "Weekly Show";
    let femaleNames = [
        "women",
        "woman",
        "diva",
        "female",
        "ladies",
        "knockout"
    ];
    let useFeudChance = [
        "long-term",
        "quality"
    ].includes(style) ? 90 : 70;
    let usePastMatchChance = 20;
    let divisionMember = divisionWeights[0][0];
    let feudsOfType;
    let vacatedChampionships;
    let matchType;
    let matchSuperstars;
    // Get match type specific objects
    if (divisionMember.objectName === "superstar") {
        matchType = "singles";
        feudsOfType = singlesFeuds;
    } else if (divisionMember.objectName === "tagTeam") {
        matchType = "tag";
        feudsOfType = tagFeuds;
    }
    // Get match contract if holder is in this division and available
    let matchContract;
    for (const x of matchContracts){
        let t = await (0, $1AAHK.getMatchContractTalent)(x);
        if (t && (0, $3E8Nt.objectInArray)(t, divisionWeights.map((y)=>y[0])) && (await (0, $5kTkA.getRosterMemberSuperstars)(t)).every((y)=>(0, $5kTkA.checkSuperstarBrandAvailability)(event, y, (0, $5kTkA.getSuperstarChampionshipsFromCompanyChampionships)(y, championships)))) matchContract = x;
    }
    // Select participants
    if (matchContract) {
        // Select match contract holder and champion
        let holder = await (0, $1AAHK.getMatchContractTalent)(matchContract);
        let selectData = await $f0da149825527215$var$selectAutoBookChampion(divisionWeights, championships, holder, matchType);
        bookedParticipants = [
            holder,
            selectData["participant"]
        ];
        matchChampionship = selectData["championship"];
        bookedMatchContract = matchContract;
    } else // Select feud participants
    if (feudsOfType.length > 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= useFeudChance) {
        let selectData = await $f0da149825527215$var$selectAutoBookFeudParticipants(feudsOfType, championships, weeklyShow);
        bookedParticipants = selectData["participants"];
        matchChampionship = selectData["championship"];
    } else {
        // Select past event match
        let pastEventMatchesOfType = pastEventMatches.filter((y)=>y.type === matchType);
        if (style !== "bizarro" && pastEventMatchesOfType.length > 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= usePastMatchChance) {
            let selectData = await $f0da149825527215$var$selectAutoBookMatchParticipants(pastEventMatchesOfType, championships, style, weeklyShow);
            bookedParticipants = selectData["participants"];
            matchChampionship = selectData["championship"];
            bookedPastEventMatch = selectData["match"];
        } else {
            let selectData = await $f0da149825527215$var$selectAutoBookRandomParticipants([
                ...divisionWeights
            ], championships, style, weeklyShow, matchType);
            bookedParticipants = selectData["participants"];
            matchChampionship = selectData["championship"];
        }
    }
    // Get superstars in match
    matchSuperstars = (await Promise.all(bookedParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    // Get vacated championship if matchChampionship not present, based on participants' gender
    if (!matchChampionship) {
        if (divisionMember.objectName === "superstar") vacatedChampionships = championships.filter((x)=>x.vacated && !x.tagTeam && !x.trio && !x.booked);
        else if (divisionMember.objectName === "tagTeam") {
            vacatedChampionships = championships.filter((x)=>x.vacated && !x.booked);
            if (bookedParticipants[0].trio) vacatedChampionships = vacatedChampionships.filter((x)=>x.trio);
            else vacatedChampionships = vacatedChampionships.filter((x)=>x.tagTeam);
        }
        if (!matchSuperstars.some((x)=>x.gender === "male")) vacatedChampionships = vacatedChampionships.filter((x)=>femaleNames.some((y)=>x.name.toLowerCase().includes(y)));
        else if (!matchSuperstars.some((x)=>x.gender === "female")) vacatedChampionships = vacatedChampionships.filter((x)=>!femaleNames.some((y)=>x.name.toLowerCase().includes(y)));
        if (vacatedChampionships.length > 0) matchChampionship = (0, $3E8Nt.getRandomChoice)(vacatedChampionships);
    }
    // Select gimmick match
    if (matchChampionship && matchChampionship.gimmickRestriction && matchChampionship.gimmickRestriction["type"] === "gimmick_match") {
        // Select gimmick match if championship is restricted to gimmick matches
        let availableGimmickMatches = gimmickMatches.filter((x)=>x.available && x.cost <= company.points);
        if (availableGimmickMatches.length > 0) {
            if (matchChampionship.gimmickRestriction["value"]) selectedGimmickMatch = availableGimmickMatches.find((x)=>x.name === matchChampionship.gimmickRestriction["value"]);
            else selectedGimmickMatch = await $f0da149825527215$var$selectAutoBookerGimmickMatch(company, gimmickMatches, matchSuperstars, matchChampionship, matchType);
        }
    } else {
        // Select random gimmick match
        let gimmickMatchChance = $f0da149825527215$var$getAutoBookerGimmickMatchChance(company, style, weeklyShow);
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= gimmickMatchChance) selectedGimmickMatch = await $f0da149825527215$var$selectAutoBookerGimmickMatch(company, gimmickMatches, matchSuperstars, matchChampionship, matchType);
    }
    // Check gimmick restriction for matchChampionship
    if (matchChampionship && !(0, $kZwpB.checkChampionshipGimmickRestriction)(matchChampionship, selectedGimmickMatch, event, bookedParticipants)) matchChampionship = null;
    // Check gender for championship
    if (matchChampionship) {
        if (matchSuperstars.some((x)=>x.gender === "male") && femaleNames.some((y)=>matchChampionship.name.toLowerCase().includes(y))) matchChampionship = null;
    }
    // Remove all except first participant for open challenge
    if (selectedGimmickMatch && selectedGimmickMatch.consequence === "random_opponent") {
        bookedParticipants = [
            bookedParticipants[0]
        ];
        matchSuperstars = await (0, $5kTkA.getRosterMemberSuperstars)(bookedParticipants[0]);
        // Remove matchChampionship if doesn't belong to first participant
        if (matchChampionship && !matchSuperstars.some((x)=>x.$loki === matchChampionship.superstarId)) matchChampionship = null;
    }
    // Create match
    let bookedMatch = (0, $i7bmn.Match)(event.matchesCount, matchType);
    await (0, $14eBR.Matches).insert(bookedMatch);
    await (0, $iQtzn.addEventMatches)(event, [
        bookedMatch
    ]);
    event.matchesCount += 1;
    // Add participants
    await (0, $i7bmn.addMatchParticipants)(bookedMatch, bookedParticipants);
    // Add championship
    if (matchChampionship) {
        await (0, $i7bmn.addMatchChampionships)(bookedMatch, [
            matchChampionship
        ]);
        for (const c of championships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, matchChampionship)))c.booked = true;
    }
    // Add gimmick match and its data
    if (selectedGimmickMatch) {
        await (0, $cYLJ6.addGimmickMatchMatches)(selectedGimmickMatch, [
            bookedMatch
        ]);
        // Add custom object or location
        if (selectedGimmickMatch.generateObject) bookedMatch.objectToClaim = (0, $8A6FL.generateGimmickMatchObjectName)(bookedParticipants.map((x)=>x.name));
        if (selectedGimmickMatch.generateLocation) bookedMatch.location = (0, $8A6FL.generateGimmickMatchLocationName)(bookedParticipants.map((x)=>x.name));
        // Add referee id
        if (selectedGimmickMatch.rules === "special_referee") {
            let refereeWeights = await $f0da149825527215$var$getRefereeWeights(rosterSuperstars, bookedParticipants);
            let refereeSuperstar = (0, $3E8Nt.weightedChoice)(refereeWeights);
            bookedMatch.refereeId = refereeSuperstar.$loki;
        }
    }
    // Get all tag teams present
    let tagTeamsPresent = [];
    for (const s of matchSuperstars)tagTeamsPresent.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
    tagTeamsPresent = (0, $3E8Nt.getUniqueObjects)(tagTeamsPresent);
    // Find existing feuds and add to match
    let bookedFeuds = await (0, $cXLSF.getParticipantFeuds)(matchSuperstars, tagTeamsPresent);
    await (0, $i7bmn.addMatchFeuds)(bookedMatch, bookedFeuds);
    // Start direct feuds
    for (const feud of bookedFeuds)if (!feud.started && feud.directFeudEvent && !feud.ended) {
        feud.startMonth = game.monthCount;
        feud.startYear = game.year;
        feud.runBlowoff = false;
    }
    // Add managers
    if ((0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(bookedMatch, matchSuperstars, rosterSuperstars, event);
    // Set hidden if hideBooked
    if (hideBooked) bookedMatch.hidden = true;
    // Add hype to match
    bookedMatch.hype = await (0, $6RCLU.getHypeForMatch)(bookedParticipants, bookedFeuds, [
        matchChampionship
    ], company.style);
    // Chance to add blowoff to feuds
    for (const feud of bookedFeuds)await $f0da149825527215$var$checkToAddAutoBookFeudBlowoff(feud, bookedParticipants, matchType);
    // Chance to create new feud if match has 2 participants and no feuds
    if (bookedFeuds.length <= 0 && bookedParticipants.length === 2) await $f0da149825527215$var$checkToCreateAutoBookFeud(bookedParticipants, bookedMatch, feudItems, company, style, matchType, companyLogs, game.monthCount, game.year);
    // Process and get data to return
    let data = await $f0da149825527215$var$processAutoBookMatchData(matchSuperstars, tagTeamsPresent, bookedMatch, bookedFeuds, bookedPastEventMatch, bookedMatchContract, singlesFeuds, tagFeuds, pastEventMatches, matchContracts, matchDivisionsWeights);
    data["bookedMatch"] = bookedMatch;
    return data;
}
async function $f0da149825527215$var$selectAutoBookChampion(weights, championships, holder, matchType) {
    let data = {};
    let championship;
    let championsWeights = [];
    let trio = matchType === "tag" ? weights[0][0].trio : false;
    let prestigeWeights = {
        "S": 4,
        "A": 3,
        "B": 2,
        "C": 1
    };
    let participantsChampionshipsData = {};
    // Don't select match contract holder
    let newWeights = weights.filter((x)=>x[0].$loki !== holder.$loki);
    // Add to championsWeights if champion
    for (const x of newWeights){
        let participant = x[0];
        let participantChampionships;
        if (matchType === "singles") participantChampionships = championships.filter((y)=>y.superstarId === participant.$loki && !y.matchContract && !y.tagTeam && !y.trio);
        else if (matchType === "tag") {
            let participantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(participant);
            participantChampionships = championships.filter((y)=>y.superstarId === participantSuperstars[0].$loki && !y.matchContract);
            if (trio) participantChampionships = participantChampionships.filter((y)=>y.trio);
            else participantChampionships = participantChampionships.filter((y)=>y.tagTeam);
        }
        if (participantChampionships.length > 0) {
            let weight = x[1];
            // Increase weight by championship's prestige
            for (const c of participantChampionships)weight *= (prestigeWeights[c.prestige] / 3) ** 2;
            championsWeights.push([
                participant,
                weight
            ]);
            participantsChampionshipsData[participant.$loki] = participantChampionships;
        }
    }
    // Add random participant if no champions found
    if (championsWeights.length <= 0) championsWeights.push([
        (0, $3E8Nt.getRandomChoice)(newWeights)[0],
        1
    ]);
    // Get participant
    let participant = (0, $3E8Nt.weightedChoice)(championsWeights);
    // Get championship
    if (participantsChampionshipsData[participant.$loki]) championship = (0, $3E8Nt.getRandomChoice)(participantsChampionshipsData[participant.$loki]);
    // Get data to return
    data["participant"] = participant;
    data["championship"] = championship;
    return data;
}
async function $f0da149825527215$var$selectAutoBookFeudParticipants(feuds, championships, weeklyShow) {
    let data = {};
    let feudWeights = [];
    // Get feud weights
    for (const feud of feuds){
        let weight = 0;
        if (feud.hype > 0) weight += (feud.hype / 4) ** 2;
        if (feud.hot) weight *= 2;
        feudWeights.push([
            feud,
            weight
        ]);
    }
    // Get feud
    let feud = (0, $3E8Nt.weightedChoice)(feudWeights);
    // Get championship from participants
    let participants = await (0, $jDtEn.getFeudParticipants)(feud);
    if (championships) data["championship"] = await $f0da149825527215$var$getAutoBookerChampionshipFromParticipants(participants, championships, weeklyShow);
    // Get data to return
    data["participants"] = participants;
    return data;
}
async function $f0da149825527215$var$selectAutoBookMatchParticipants(matches, championships, style, weeklyShow) {
    let data = {};
    let matchWeights = [];
    // Get match weights
    for (const match of matches){
        let order = match.order + 1;
        if (order === 0) order = 1;
        let weight = 10 / (order + 1);
        if (style === "quality" && match.rating >= 4) weight += match.rating ** 2;
        matchWeights.push([
            match,
            weight
        ]);
    }
    // Get match
    let match = (0, $3E8Nt.weightedChoice)(matchWeights);
    // Get championship from participants
    let participants = await (0, $i7bmn.getMatchParticipants)(match);
    let championship = await $f0da149825527215$var$getAutoBookerChampionshipFromParticipants(participants, championships, weeklyShow);
    // Get data to return
    data["participants"] = participants;
    data["championship"] = championship;
    data["match"] = match;
    return data;
}
async function $f0da149825527215$var$selectAutoBookRandomParticipants(weights, championships, style, weeklyShow, matchType) {
    let data = {};
    let participants = [];
    // Get number of participants
    let numberOfParticipantsWeights;
    if (matchType === "singles") numberOfParticipantsWeights = [
        [
            2,
            78
        ],
        [
            3,
            7
        ],
        [
            4,
            5
        ],
        [
            5,
            2
        ],
        [
            6,
            3
        ],
        [
            7,
            1
        ],
        [
            8,
            2
        ],
        [
            9,
            1
        ],
        [
            10,
            1
        ]
    ];
    else numberOfParticipantsWeights = [
        [
            2,
            60
        ],
        [
            3,
            13
        ],
        [
            4,
            10
        ],
        [
            5,
            5
        ],
        [
            6,
            5
        ],
        [
            7,
            2
        ],
        [
            8,
            3
        ],
        [
            9,
            1
        ],
        [
            10,
            1
        ]
    ];
    let numberOfParticipants = (0, $3E8Nt.weightedChoice)(numberOfParticipantsWeights);
    if (numberOfParticipants > weights.length) numberOfParticipants = 2;
    // Get participants
    for (const x of Array(numberOfParticipants).keys()){
        let participant = (0, $3E8Nt.weightedChoice)(weights);
        weights = weights.filter((y)=>y[0].$loki !== participant.$loki);
        participants.push(participant);
        // If long term and main eventer selected, increase weight for lower popularity superstars
        let popularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
        if (x === 0 && style === "long-term" && (0, $5kTkA.getRankFromPopularity)(popularity) === "Main Eventer") for (const [index, element] of Object.entries(weights)){
            let newWeight = element[1];
            let p = await (0, $3E8Nt.getRosterMemberPopularity)(element[0]);
            if ((0, $5kTkA.getRankFromPopularity)(p) !== "Main Eventer") newWeight *= 5;
            weights[index][1] = newWeight;
        }
        // Add alignment bias
        if (x === 0 && style !== "bizarro" && numberOfParticipants === 2) {
            let alignmentMultiplier = style === "quality" ? 40 : 10;
            let participantAlignment = await (0, $3E8Nt.getRosterMemberAlignment)(participant);
            if (participantAlignment === "face" || participantAlignment === "heel") for (const [index, element] of Object.entries(weights)){
                let newWeight = element[1];
                let elementAlignment = await (0, $3E8Nt.getRosterMemberAlignment)(element[0]);
                if (participantAlignment === "face") {
                    if (elementAlignment === "heel") newWeight *= alignmentMultiplier;
                    else if (!elementAlignment) newWeight /= 2;
                } else if (participantAlignment === "heel") {
                    if (elementAlignment === "face") newWeight *= alignmentMultiplier;
                    else if (elementAlignment === "heel") newWeight /= 5;
                }
                weights[index][1] = newWeight;
            }
        }
        // Add brand name bias
        let participantBrandName = await (0, $3E8Nt.getRosterMemberBrandName)(participant);
        if (x === 0 && style !== "bizarro" && participantBrandName) for (const [index, element] of Object.entries(weights)){
            let newWeight = element[1];
            let elementBrandName = await (0, $3E8Nt.getRosterMemberBrandName)(element[0]);
            if (elementBrandName === participantBrandName || !elementBrandName) newWeight *= 20;
            weights[index][1] = newWeight;
        }
    }
    // Get championship from participants
    let championship = await $f0da149825527215$var$getAutoBookerChampionshipFromParticipants(participants, championships, weeklyShow);
    // Get data to return
    data["participants"] = participants;
    data["championship"] = championship;
    return data;
}
async function $f0da149825527215$var$getAutoBookerChampionshipFromParticipants(participants, championships, weeklyShow) {
    let championship;
    // Get participants' championships
    let participantsChampionships = [];
    for (const x of participants){
        let participantChampionships = [];
        if (x.objectName === "superstar") participantChampionships = championships.filter((y)=>y.superstarId === x.$loki && !y.tagTeam && !y.trio);
        else if (x.objectName === "tagTeam") {
            let participantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(x);
            participantChampionships = championships.filter((y)=>y.superstarId === participantSuperstars[0].$loki && !y.matchContract);
            if (participants.every((y)=>y.trio)) participantChampionships = participantChampionships.filter((y)=>y.trio);
            else participantChampionships = participantChampionships.filter((y)=>y.tagTeam);
        }
        participantsChampionships.push(...participantChampionships);
    }
    // Chance to select a participant championship
    let addChampionshipChance = weeklyShow ? 20 : 95;
    if (participantsChampionships.length > 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= addChampionshipChance) championship = (0, $3E8Nt.getRandomChoice)(participantsChampionships);
    return championship;
}
function $f0da149825527215$var$getAutoBookerGimmickMatchChance(company, autoBookerStyle, weeklyShow) {
    let percentage;
    if (company.style === "entertainment") percentage = 12;
    else percentage = 2;
    if (autoBookerStyle === "bizarro") percentage *= 3;
    else if (autoBookerStyle === "quality") percentage *= 2;
    else if (autoBookerStyle === "terrible") percentage *= 0.5;
    if (weeklyShow) percentage /= 2;
    return percentage;
}
async function $f0da149825527215$var$selectAutoBookerGimmickMatch(company, gimmickMatches, matchSuperstars, championship, style) {
    // Remove unavailable, not enough points, battle royal and cash in matches
    let filteredGimmickMatches = gimmickMatches.filter((x)=>x.available && x.rules !== "battle_royal" && !x.cashinContractName && x.cost <= company.points);
    // Chance to select match contract matches
    let availableGimmickMatches;
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5 && !championship) availableGimmickMatches = filteredGimmickMatches.filter((x)=>x.matchContractName);
    else availableGimmickMatches = filteredGimmickMatches.filter((x)=>!x.matchContractName);
    // Check/chance to remove femme fatale match
    if (matchSuperstars.some((x)=>x.gender !== "female") || (0, $3E8Nt.getRandomInt)(0, 100) <= 75) availableGimmickMatches = availableGimmickMatches.filter((x)=>!(x.name === "Femme Fatale" && x.special));
    // Chance to remove pole match
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 75) availableGimmickMatches = availableGimmickMatches.filter((x)=>!x.generateObject);
    // Chance to remove some consequence matches
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 90 && style !== "bizarro") availableGimmickMatches = availableGimmickMatches.filter((x)=>![
            "remove_hair",
            "add_hair",
            "remove_mask",
            "remove_mask_or_hair"
        ].includes(x.consequence));
    // Select gimmick match from available
    if (availableGimmickMatches.length > 0) {
        let selectedGimmickMatch = (0, $3E8Nt.getRandomChoice)(availableGimmickMatches);
        company.points -= selectedGimmickMatch.cost;
        return selectedGimmickMatch;
    }
    return null;
}
async function $f0da149825527215$var$checkToAddAutoBookFeudBlowoff(feud, bookedParticipants, matchType) {
    if (feud.stalenessCounter > 0) {
        // Get blowoff chance based on staleness
        let feudParticipants = await (0, $jDtEn.getFeudParticipants)(feud);
        let blowoffChance = await $f0da149825527215$var$getAutoBookFeudBlowoffChance(feud, feudParticipants);
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= blowoffChance) {
            let feudItem = await (0, $jDtEn.getFeudFeudItem)(feud);
            let runBlowoff = true;
            // Only blowoff consequence feud in same match type as participant type
            if (feudItem.consequence) {
                if (feudParticipants[0].objectName === "superstar" && matchType !== "singles") runBlowoff = false;
                else if (feudParticipants[0].objectName === "faction" && matchType !== "tag") runBlowoff = false;
                else if (feudParticipants[0].objectName === "tagTeam") {
                    if (matchType !== "tag") runBlowoff = false;
                    if (feudParticipants.every((x)=>x.trio)) // Allow trios feud blowoff in tag or trios match
                    for (const x of bookedParticipants){
                        let participantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(x);
                        if (![
                            2,
                            3
                        ].includes(participantSuperstars.length)) runBlowoff = false;
                    }
                    else // Allow tag feud blowoff in tag match only
                    for (const x of bookedParticipants){
                        let participantSuperstars = await (0, $972Ip.getTagTeamSuperstars)(x);
                        if (participantSuperstars.length !== 2) runBlowoff = false;
                    }
                }
            }
            if (runBlowoff) feud.runBlowoff = true;
        }
    }
}
async function $f0da149825527215$var$getAutoBookFeudBlowoffChance(feud, feudParticipants) {
    let staleLength = await (0, $cXLSF.getMatchesForStaleFeud)(feud, feudParticipants);
    let blowoffChance = -1;
    if (feud.stalenessCounter >= staleLength) blowoffChance = 90;
    else if (feud.stalenessCounter >= staleLength * 0.75) blowoffChance = 10;
    return blowoffChance;
}
async function $f0da149825527215$var$checkToCreateAutoBookFeud(bookedParticipants, bookedMatchOrSegment, feudItems, company, style, participantType, companyLogs, month, year) {
    // Get create feud chance
    let createFeudChance = 50;
    if (style === "long-term") createFeudChance = 75;
    else if (style === "quality") createFeudChance = 90;
    // Lower chance if any participant has existing feuds
    let participantsFeuds = (await Promise.all(bookedParticipants.map((x)=>(0, $cXLSF.getRosterMemberFeuds)(x)))).flat().filter((x)=>x.started && !x.ended);
    if (participantsFeuds.length > 0) createFeudChance /= 2;
    // Create feud
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= createFeudChance) {
        // Get available feud items
        const feudItemsData = await (0, $cXLSF.getAvailableFeudItems)(feudItems, bookedParticipants, company.storyName, month, year, companyLogs, participantType);
        let availableFeudItems = feudItemsData[0];
        if (availableFeudItems.length > 0) {
            // Check minimum previous feud boost
            let previousFeudBoost = await (0, $cXLSF.getFeudCreationPreviousFeudsBoost)({}, bookedParticipants, month, year);
            let minimumPreviousFeudBoost = $f0da149825527215$var$getAutoBookerMinimumPreviousFeudBoost(style);
            if (previousFeudBoost >= minimumPreviousFeudBoost) {
                // Get feud name
                let feudItem = (0, $3E8Nt.getRandomChoice)(availableFeudItems);
                let feudName = feudItem.name;
                let generateFeudNameChance = style !== "bizarro" ? 30 : 80;
                if (feudItem.name === "Grudge" && (0, $3E8Nt.getRandomInt)(0, 100) <= generateFeudNameChance) feudName = (0, $cXLSF.generateRandomFeudItemName)();
                // Add new feud attributes
                let newFeud = (0, $jDtEn.Feud)();
                newFeud.participants = bookedParticipants.map((x)=>x.name);
                newFeud.name = feudName;
                newFeud.hype = feudItem.baseHype;
                newFeud.startMonth = month;
                newFeud.startYear = year;
                // Get who to apply consequence to
                if (feudItem.oneWayConsequence) newFeud.consequenceAppliedTo = await (0, $cXLSF.getFeudConsequenceAppliedTo)(feudItem, bookedParticipants, participantType);
                // Save feud to db
                await (0, $14eBR.Feuds).insert(newFeud);
                // Add feud to feud item and roster
                await (0, $im36F.addFeudItemFeuds)(feudItem, [
                    newFeud
                ]);
                let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
                await (0, $dl5u4.addRosterFeuds)(mainRoster, [
                    newFeud
                ]);
                // Add feud to match/segment
                if (bookedMatchOrSegment.objectName === "match") await (0, $i7bmn.addMatchFeuds)(bookedMatchOrSegment, [
                    newFeud
                ]);
                else if (bookedMatchOrSegment.objectName === "segment") await (0, $eg5dz.addSegmentFeuds)(bookedMatchOrSegment, [
                    newFeud
                ]);
                // Add feud to participants
                if (participantType === "singles") await (0, $jDtEn.addFeudSuperstars)(newFeud, bookedParticipants);
                else if (participantType === "tag") await (0, $jDtEn.addFeudTagTeams)(newFeud, bookedParticipants);
            }
        }
    }
}
function $f0da149825527215$var$getAutoBookerMinimumPreviousFeudBoost(style) {
    let minimumPreviousFeudBoost = -15;
    if (style === "quality") minimumPreviousFeudBoost = 0;
    else if (style === "terrible") minimumPreviousFeudBoost = -90;
    return minimumPreviousFeudBoost;
}
async function $f0da149825527215$var$selectAutoBookSegmentParticipants(weights, numberOfParticipants, style) {
    let data = {};
    let participants = [];
    // Minimum participants
    if (numberOfParticipants > weights.length) numberOfParticipants = 1;
    // Get participants
    for (const x of Array(numberOfParticipants).keys()){
        let participant = (0, $3E8Nt.weightedChoice)(weights);
        weights = weights.filter((y)=>y[0].$loki !== participant.$loki);
        participants.push(participant);
        // If long term and main eventer selected, increase weight for lower popularity superstars
        let popularity = await (0, $3E8Nt.getRosterMemberPopularity)(x);
        if (x === 0 && style === "long-term" && (0, $5kTkA.getRankFromPopularity)(popularity) === "Main Eventer") for (const [index, element] of Object.entries(weights)){
            let newWeight = element[1];
            let p = await (0, $3E8Nt.getRosterMemberPopularity)(element[0]);
            if ((0, $5kTkA.getRankFromPopularity)(p) !== "Main Eventer") newWeight *= 5;
            weights[index][1] = newWeight;
        }
    }
    // Get data to return
    data["participants"] = participants;
    return data;
}
async function $f0da149825527215$var$autoBookSegment(divisionWeights, event, championships, company, game, singlesFeuds, tagFeuds, feudItems, segmentItems, itemsUsed, companyLogs, style, rosterSuperstars, hideBooked, segmentDivisionsWeights) {
    const staffMembers = await (0, $9esFv.getCompanyStaff)(company);
    const availableStaffMembers = (0, $8A6FL.getAvailableStaffMembers)(staffMembers);
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let useFeudChance = [
        "long-term",
        "quality"
    ].includes(style) ? 80 : 60;
    let divisionMember = divisionWeights[0][0];
    let feudsOfType;
    let participantType;
    let allSuperstars;
    // Filter segment items
    segmentItems = $f0da149825527215$var$filterAutoBookerSegmentItems(segmentItems, company);
    // Get participant type specific objects
    if (divisionMember.objectName === "superstar") {
        participantType = "singles";
        feudsOfType = singlesFeuds;
    } else if (divisionMember.objectName === "tagTeam") {
        participantType = "tag";
        feudsOfType = tagFeuds;
    }
    // Get number of participants depending on minParticipants of segment items
    const items = segmentItems.map((x)=>x["minParticipants"]);
    const numberOfParticipantsWeights = [
        ...new Set(items)
    ].map((x)=>{
        return [
            x,
            items.filter((y)=>y === x).length
        ];
    });
    const numberOfParticipants = (0, $3E8Nt.weightedChoice)(numberOfParticipantsWeights);
    // Select segment participants
    let selectData;
    if (feudsOfType.length > 0 && (0, $3E8Nt.getRandomInt)(0, 100) <= useFeudChance) selectData = await $f0da149825527215$var$selectAutoBookFeudParticipants(feudsOfType);
    else selectData = await $f0da149825527215$var$selectAutoBookSegmentParticipants([
        ...divisionWeights
    ], numberOfParticipants, style);
    let bookedParticipants = selectData["participants"];
    // Create segment, add to event
    let bookedSegment = (0, $eg5dz.Segment)();
    bookedSegment.order = event.matchesCount;
    await (0, $14eBR.Segments).insert(bookedSegment);
    await (0, $iQtzn.addEventSegments)(event, [
        bookedSegment
    ]);
    event.matchesCount += 1;
    // Add participants
    await (0, $eg5dz.addSegmentParticipants)(bookedSegment, bookedParticipants);
    // Get all superstars and tag teams in segment
    allSuperstars = (await Promise.all(bookedParticipants.map((x)=>(0, $5kTkA.getRosterMemberSuperstars)(x)))).flat();
    let tagTeamsPresent = [];
    for (const s of allSuperstars)tagTeamsPresent.push(...(await (0, $hBIDz.getSuperstarTagTeams)(s)).filter((x)=>!x.temporary));
    tagTeamsPresent = (0, $3E8Nt.getUniqueObjects)(tagTeamsPresent);
    // Find existing feuds and add to segment
    let bookedFeuds = await (0, $cXLSF.getParticipantFeuds)(allSuperstars, tagTeamsPresent);
    await (0, $eg5dz.addSegmentFeuds)(bookedSegment, bookedFeuds);
    // Get available segment items
    let availableSegmentItems = await $f0da149825527215$var$getAutoBookAvailableSegmentItems(segmentItems, bookedParticipants, companyLogs, game.monthCount, game.year, championships, availableStaffMembers, event, bookedFeuds, participantType);
    // Get segment item
    let bookedSegmentItem;
    if (availableSegmentItems.length > 0) {
        let availableSegmentItemsWeights = $f0da149825527215$var$getAutoBookAvailableSegmentItemsWeights(availableSegmentItems, style, itemsUsed);
        bookedSegmentItem = (0, $3E8Nt.weightedChoice)(availableSegmentItemsWeights);
    } else // Fallback segment item if none available
    bookedSegmentItem = segmentItems.find((x)=>x.name === "Promo Battle");
    await (0, $cMrnz.addSegmentItemSegments)(bookedSegmentItem, [
        bookedSegment
    ]);
    // Add one way consequence
    if (bookedSegmentItem.oneWayConsequence) bookedSegment.consequenceAppliedTo = await (0, $4ptHI.getSegmentConsequenceAppliedTo)(bookedSegmentItem, bookedParticipants);
    // Set segment item to used
    if (bookedSegmentItem.special && !currentGame.settings["no_special_items_cooldown"]) bookedSegmentItem.used = true;
    // Add managers
    if (!bookedSegmentItem.special && (0, $98xmD.globalUser).paid) (0, $ycsyu.setManagersForMatchOrSegment)(bookedSegment, allSuperstars, rosterSuperstars, event);
    // Set hidden if hideBooked
    if (hideBooked) bookedSegment.hidden = true;
    // Add hype
    bookedSegment.hype = await (0, $4ptHI.getHypeForSegment)(bookedParticipants, bookedFeuds, bookedSegmentItem);
    // Chance to create new feud if segment has 2 participants and no feuds
    if (bookedFeuds.length <= 0 && bookedParticipants.length === 2) await $f0da149825527215$var$checkToCreateAutoBookFeud(bookedParticipants, bookedSegment, feudItems, company, style, participantType, companyLogs, game.monthCount, game.year);
    // Process and get data to return
    let data = $f0da149825527215$var$processAutoBookSegmentData(allSuperstars, tagTeamsPresent, bookedSegment, bookedFeuds, bookedSegmentItem, singlesFeuds, tagFeuds, itemsUsed, segmentDivisionsWeights);
    data["bookedSegment"] = bookedSegment;
    return data;
}
function $f0da149825527215$var$filterAutoBookerSegmentItems(segmentItems, company) {
    // Remove producer/buyout segment items for competitors since they don't have staff
    if (!company.userControlled) segmentItems = segmentItems.filter((x)=>!x.requirement || !x.requirement.includes("producer") && !x.requirement.includes("buyout"));
    // Remove locked and used special segment items
    segmentItems = segmentItems.filter((x)=>x.unlocked && !x.used);
    // Remove faction/manager/brand/some other segment items for now
    return segmentItems.filter((x)=>!x.factionSegment && ![
            "boost-managed-talent",
            "add-manager",
            "remove-manager",
            "remove-managed-talent",
            "draft-talent-to-brand",
            "fire-superstar",
            "retire"
        ].includes(x.consequence) && ![
            "other-brand-talent",
            "feud-present"
        ].includes(x.requirement));
}
async function $f0da149825527215$var$getAutoBookAvailableSegmentItems(segmentItems, bookedParticipants, companyLogs, month, year, championships, availableStaffMembers, event, bookedFeuds, participantType) {
    let availableSegmentItems = [];
    // Check requirements and min/max participants
    for (const x of segmentItems)if (bookedParticipants.length >= x.minParticipants && bookedParticipants.length <= x.maxParticipants && (!x.feudOnly || bookedFeuds.length > 0)) {
        let requirementCheck = await (0, $4ptHI.checkSegmentItemRequirement)(x, bookedParticipants, companyLogs, month, year, championships, availableStaffMembers);
        if (!requirementCheck["error"]) availableSegmentItems.push(x);
    }
    // Check for production packages only, don't book segment if none found
    if (event.activeEffect === "production_packages_only") availableSegmentItems = availableSegmentItems.filter((x)=>x.productionSegment);
    // Don't add special segments for tag teams
    if (participantType !== "singles") availableSegmentItems = availableSegmentItems.filter((x)=>!x.special);
    return availableSegmentItems;
}
function $f0da149825527215$var$getAutoBookAvailableSegmentItemsWeights(availableSegmentItems, style, itemsUsed) {
    // Add weights for items used and silly items
    let availableSegmentItemsWeights;
    if (style === "terrible") availableSegmentItemsWeights = availableSegmentItems.map((x)=>(0, $3E8Nt.objectInArray)(x, itemsUsed) && x.oneAtATime ? [
            x,
            5
        ] : [
            x,
            1
        ]);
    else availableSegmentItemsWeights = availableSegmentItems.map((x)=>(0, $3E8Nt.objectInArray)(x, itemsUsed) && x.oneAtATime ? [
            x,
            1
        ] : [
            x,
            5
        ]);
    if (style === "quality") availableSegmentItemsWeights = availableSegmentItemsWeights.map((x)=>x[0].silly ? [
            x[0],
            x[1] / 10
        ] : [
            x[0],
            x[1]
        ]);
    else if (style === "bizarro") availableSegmentItemsWeights = availableSegmentItemsWeights.map((x)=>x[0].silly ? [
            x[0],
            x[1]
        ] : [
            x[0],
            x[1] / 10
        ]);
    else availableSegmentItemsWeights = availableSegmentItemsWeights.map((x)=>x[0].silly ? [
            x[0],
            x[1] / 2
        ] : [
            x[0],
            x[1]
        ]);
    return availableSegmentItemsWeights;
}
async function $f0da149825527215$var$processAutoBookMatchData(superstarsPresent, tagTeamsPresent, bookedMatch, bookedFeuds, bookedPastEventMatch, bookedMatchContract, singlesFeuds, tagFeuds, pastEventMatches, matchContracts, divisionsWeights) {
    /*
    Removes booked objects from arrays
     */ let data = {};
    let participants = superstarsPresent.concat(tagTeamsPresent);
    // Remove booked participants from each division
    for (const [index, element] of Object.entries(divisionsWeights))divisionsWeights[index][0] = element[0].filter((y)=>!(0, $3E8Nt.objectInArray)(y[0], participants));
    // Remove booked feuds
    for (const y of bookedFeuds){
        singlesFeuds = singlesFeuds.filter((f)=>f.$loki !== y.$loki);
        tagFeuds = tagFeuds.filter((f)=>f.$loki !== y.$loki);
    }
    // Remove booked past event match
    if (bookedPastEventMatch) pastEventMatches = pastEventMatches.filter((y)=>y.$loki !== bookedPastEventMatch.$loki);
    // Remove booked match contract
    if (bookedMatchContract) matchContracts = matchContracts.filter((x)=>x.$loki !== bookedMatchContract.$loki);
    // Remove past event matches if any booked participant is present in them
    let matchesToRemove = [];
    for (const y of pastEventMatches){
        let matchParticipants = await (0, $i7bmn.getMatchParticipants)(y);
        if (participants.some((p)=>(0, $3E8Nt.objectInArray)(p, matchParticipants))) matchesToRemove.push(y);
    }
    pastEventMatches = pastEventMatches.filter((y)=>!(0, $3E8Nt.objectInArray)(y, matchesToRemove));
    // Remove feuds if any booked participant is present in them
    let feudsToRemove = [];
    for (const y of singlesFeuds.concat(tagFeuds)){
        let feudParticipants = await (0, $jDtEn.getFeudParticipants)(y);
        if (feudParticipants[0].objectName === participants[0].objectName && participants.some((p)=>(0, $3E8Nt.objectInArray)(p, feudParticipants))) feudsToRemove.push(y);
    }
    singlesFeuds = singlesFeuds.filter((y)=>!(0, $3E8Nt.objectInArray)(y, feudsToRemove));
    tagFeuds = tagFeuds.filter((y)=>!(0, $3E8Nt.objectInArray)(y, feudsToRemove));
    // Get data to return
    data["divisionsWeights"] = divisionsWeights;
    data["singlesFeuds"] = singlesFeuds;
    data["tagFeuds"] = tagFeuds;
    data["pastEventMatches"] = pastEventMatches;
    data["matchContracts"] = matchContracts;
    return data;
}
function $f0da149825527215$var$processAutoBookSegmentData(superstarsPresent, tagTeamsPresent, bookedSegment, bookedFeuds, bookedSegmentItem, singlesFeuds, tagFeuds, itemsUsed, divisionsWeights) {
    /*
    Removes booked objects from arrays
     */ let data = {};
    let participants = superstarsPresent.concat(tagTeamsPresent);
    // Remove booked participants from each division
    for (const [index, element] of Object.entries(divisionsWeights))divisionsWeights[index][0] = element[0].filter((y)=>!(0, $3E8Nt.objectInArray)(y[0], participants));
    // Remove booked feuds
    for (const y of bookedFeuds){
        singlesFeuds = singlesFeuds.filter((f)=>f.$loki !== y.$loki);
        tagFeuds = tagFeuds.filter((f)=>f.$loki !== y.$loki);
    }
    // Add booked segment item
    if (bookedSegmentItem) itemsUsed.push(bookedSegmentItem);
    // Get data to return
    data["divisionsWeights"] = divisionsWeights;
    data["singlesFeuds"] = singlesFeuds;
    data["tagFeuds"] = tagFeuds;
    data["itemsUsed"] = itemsUsed;
    return data;
}
async function $f0da149825527215$export$bc91b222c7cf4008({ style: style, eventsToSimulate: eventsToSimulate, simulatorOption: simulatorOption } = {}) {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const userCompany = await (0, $iRMwH.getGameCurrentUserCompany)(game);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
    const indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
    const latestEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(userCompany);
    const mainRoster = await (0, $8A6FL.getCompanyRosterByType)(userCompany, "main");
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const staffMembers = await (0, $9esFv.getCompanyStaff)(userCompany);
    const producers = (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(userCompany);
    const user = (0, $bZol7.loadUser)();
    // Check paid
    if (!(0, $98xmD.globalUser).paid) {
        data["error"] = "paid-only";
        return data;
    }
    // Check not local multiplayer
    if (game.settings["control_multiple_companies"]) {
        data["error"] = "local-multiplayer-disabled";
        return data;
    }
    // Check points
    let costData = {
        "standard": 10,
        "long-term": 20,
        "quality": 15,
        "bizarro": 5,
        "terrible": 2
    };
    let cost = costData[style] || 10;
    if (userCompany.points < cost) {
        data["error"] = "points";
        return data;
    }
    try {
        // Auto book event
        await $f0da149825527215$var$autoBookEvent({
            company: userCompany,
            roster: mainRoster,
            rosterSuperstars: rosterSuperstars,
            latestEvent: latestEvent,
            producers: producers,
            game: game,
            style: style,
            championships: companyChampionships,
            parentEvents: parentEvents
        });
        // Simulate event
        data["results"] = await $f0da149825527215$var$simulateUserEvent(userCompany, latestEvent, user, indieRoster, indieAvailableRoster, mainRoster, staffMembers, game, mainCompany, companyChampionships, style, rosterSuperstars, parentEvents, simulatorOption, eventsToSimulate);
        // Simulate competitors
        let simulateCompetitorsData = await $f0da149825527215$export$3afbd25365a8855a({
            simulating: true
        });
        // Simulate post event
        let updates = {};
        if (!latestEvent.weeklyShow) updates = await $f0da149825527215$var$simulatePostEvent(userCompany, user, style, simulatorOption);
        // Process yearly rankings at start of year
        let currentMonth = await (0, $8A6FL.getCurrentMonth)(userCompany, parentEvents);
        let nextEvent = await (0, $8A6FL.getCompanyLatestEvent)(userCompany);
        if (currentMonth === 0 && !nextEvent.weeklyShow) await (0, $66ItE.processYearlyRanking)(game, mainCompany);
        userCompany.points -= cost;
        // Set news month/year
        game.newsMonth = game.monthCount;
        game.newsYear = game.year;
        (0, $14eBR.db).saveDatabase();
        // Save to local storage
        await (0, $iRMwH.saveGameDataToLocalStorage)(game);
        // Get data to return
        if (latestEvent.weeklyShow) {
            let nextMonthlyEvent = await (0, $5ZsVo.getUpcomingMonthlyEventForWeeklyEvent)(latestEvent, parentEvents, userCompany);
            data["weeklyShowName"] = (0, $5ZsVo.getWeeklyEventName)(latestEvent, nextMonthlyEvent, game.numberOfWeeklyShows);
        }
        data["event"] = latestEvent.name;
        data["year"] = userCompany.realYear;
        data["points"] = userCompany.points;
        data["fans"] = userCompany.fans;
        data["updates"] = updates;
        data["updates"]["news"] = simulateCompetitorsData["news"];
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
        data["error"] = "simulator";
    }
    return data;
}
async function $f0da149825527215$var$simulateUserEvent(company, event, user, indieRoster, indieAvailableRoster, mainRoster, staffMembers, game, mainCompany, companyChampionships, style, rosterSuperstars, parentEvents, userSimulatorOption, eventsToSimulate) {
    let data = {};
    let eventMatches = await (0, $iQtzn.getEventMatches)(event);
    let eventSegments = await (0, $iQtzn.getEventSegments)(event);
    // Play event (adds event hype, poster etc)
    await (0, $5ZsVo.playEvent)({
        simulating: true,
        eventMatches: eventMatches,
        eventSegments: eventSegments
    });
    // Play matches and segments
    let matchOrSegmentResults = [];
    let matchesAndSegments = eventMatches.concat(eventSegments);
    matchesAndSegments.sort((a, b)=>a.order - b.order);
    for (let matchOrSegment of matchesAndSegments){
        let matchOrSegmentResult;
        if (matchOrSegment.objectName === "segment") matchOrSegmentResult = await (0, $4ptHI.processPlaySegment)(matchOrSegment, null, eventSegments, event, company, mainCompany, game, mainRoster, indieRoster, indieAvailableRoster, null, rosterSuperstars, companyChampionships, staffMembers, [
            ...matchesAndSegments
        ]);
        else {
            let winner = await (0, $6RCLU.simulateMatchWinner)(matchOrSegment, style);
            let matchFinish = await $f0da149825527215$var$getMatchFinishForSimulatorMatch(matchOrSegment, event, company);
            matchOrSegmentResult = await (0, $3SyPM.processPlayMatch)(matchOrSegment, winner.name, event, company, mainCompany, mainRoster, indieRoster, game, {}, matchFinish, null, rosterSuperstars, parentEvents, companyChampionships, staffMembers, [
                ...matchesAndSegments
            ], null, true);
        }
        matchOrSegmentResults.push(matchOrSegmentResult);
    }
    // End event
    let eventResults = await (0, $dGbip.endEvent)(company, user, true, rosterSuperstars, userSimulatorOption, eventsToSimulate);
    // Get data to return
    data["injuries"] = matchOrSegmentResults.flatMap((matchOrSegment)=>matchOrSegment["unavailable"] || []).filter((unavailable)=>unavailable["type"] === "injury");
    data["availableSuperstars"] = eventResults["availableSuperstars"] || [];
    data["facesOfTheCompanyMade"] = matchOrSegmentResults.flatMap((matchOrSegment)=>matchOrSegment["fotcChanges"] || []).filter((fotc)=>!fotc["faceOfTheCompanyStart"] && fotc["faceOfTheCompany"]).map((fotc)=>fotc["name"]);
    data["facesOfTheCompanyLost"] = matchOrSegmentResults.flatMap((matchOrSegment)=>matchOrSegment["fotcChanges"] || []).filter((fotc)=>!fotc["faceOfTheCompanyStart"] && !fotc["faceOfTheCompany"]).map((fotc)=>fotc["name"]);
    data["streaksEnded"] = matchOrSegmentResults.flatMap((matchOrSegment)=>matchOrSegment["streaks"] || []).filter((streak)=>streak["ended"]);
    data["leftCompany"] = eventResults["leftCompany"] || [];
    data["signings"] = eventResults["signings"] || [];
    data["offersAccepted"] = eventResults["offersAccepted"] || [];
    data["fired"] = matchOrSegmentResults.flatMap((matchOrSegment)=>matchOrSegment["fired"] || []);
    data["feudsEnded"] = matchOrSegmentResults.flatMap((matchOrSegment)=>matchOrSegment["feudsEnded"] || []);
    data["hotChanges"] = matchOrSegmentResults.flatMap((matchOrSegment)=>matchOrSegment["hotChanges"] || []);
    data["staleChanges"] = matchOrSegmentResults.flatMap((matchOrSegment)=>matchOrSegment["staleChanges"] || []);
    data["debutedGimmicks"] = matchOrSegmentResults.flatMap((matchOrSegment)=>matchOrSegment["debutedGimmicks"] || []);
    return data;
}
async function $f0da149825527215$export$3afbd25365a8855a({ simulating: simulating = false } = {}) {
    let data = {};
    let game = await (0, $3E8Nt.getCurrentGame)();
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    let mainCompanyEvents = (await (0, $9esFv.getCompanyEvents)(mainCompany)).reverse().filter((x)=>!x.temporaryEvent);
    let indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
    let indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
    let previousEvent = mainCompanyEvents[1];
    let latestEvent = mainCompanyEvents[0];
    let competitors = await (0, $8A6FL.getCpuControlledCompanies)(mainCompany, game);
    let userCompanies = await (0, $iRMwH.getUserControlledCompanies)(game);
    try {
        // Run simulation at end of month
        if (!game.monthlySimulationRun) {
            // Get maximum brand index of user controlled companies
            let [userBrandIndex, userRosterBrands] = await $f0da149825527215$var$getUserRosterBrandsAndIndex(userCompanies);
            // Go through other companies latest event
            await (0, $3E8Nt.asyncFor)(competitors, async (competitor)=>{
                try {
                    let event = await (0, $8A6FL.getCompanyLatestEvent)(competitor);
                    let competitorMainRoster = await (0, $8A6FL.getCompanyRosterByType)(competitor, "main");
                    let competitorRosterBrands = await (0, $dl5u4.getRosterBrands)(competitorMainRoster);
                    // Skip competitor show if no brand present corresponding to user brand
                    let skipCompetitorCheck = $f0da149825527215$var$checkSkipCompetitorSimulation(userBrandIndex, competitorRosterBrands);
                    if (!skipCompetitorCheck) {
                        // Simulate event if same time as game's event
                        let eventIndex = (await (0, $8A6FL.getCompanyParentEvents)(competitor)).map((x)=>x.name).indexOf((await (0, $iQtzn.getParentEvent)(event))?.name);
                        let previousEventIndex = (await (0, $8A6FL.getCompanyParentEvents)(mainCompany)).map((x)=>x.name).indexOf((await (0, $iQtzn.getParentEvent)(previousEvent))?.name);
                        if (event.weeklyShow === previousEvent.weeklyShow && event.weekNumber === previousEvent.weekNumber && (event.weeklyShow || eventIndex === previousEventIndex)) {
                            let simError = false;
                            try {
                                await $f0da149825527215$var$simulateCompetitorEvent(event, competitorMainRoster, competitor, indieRoster, indieAvailableRoster, game);
                            } catch (error) {
                                (0, $3E8Nt.captureError)(error);
                                simError = true;
                                data["error"] = "simulate-competitor-event";
                            }
                            // If user is on last brand show and competitor has more brand shows, simulate them until end
                            let simulateNextEventCheck = $f0da149825527215$var$checkNextCompetitorEventSimulation(event, userBrandIndex, userRosterBrands, competitorRosterBrands);
                            if (simulateNextEventCheck) {
                                let latestCompetitorEvent = await (0, $8A6FL.getCompanyLatestEvent)(competitor);
                                let competitorBrandIndex = (0, $1Dp0h.getBrandIndexForWeeklyShow)(latestCompetitorEvent, competitorRosterBrands);
                                // Simulate next brand event until monthly event or first brand event
                                while(latestCompetitorEvent.weeklyShow && competitorBrandIndex > 0){
                                    try {
                                        await $f0da149825527215$var$simulateCompetitorEvent(latestCompetitorEvent, competitorMainRoster, competitor, indieRoster, indieAvailableRoster, game);
                                    } catch (error) {
                                        (0, $3E8Nt.captureError)(error);
                                        simError = true;
                                        data["error"] = "simulate-competitor-event";
                                        break;
                                    }
                                    latestCompetitorEvent = await (0, $8A6FL.getCompanyLatestEvent)(competitor);
                                    competitorBrandIndex = (0, $1Dp0h.getBrandIndexForWeeklyShow)(latestCompetitorEvent, competitorRosterBrands);
                                }
                            }
                            if (simError) // Adds next event to competitors
                            await $f0da149825527215$var$fixCompetitorSimError(competitor, latestEvent, mainCompany, competitorRosterBrands);
                        } else await $f0da149825527215$var$fixCompetitorSimError(competitor, latestEvent, mainCompany, competitorRosterBrands);
                    }
                } catch (error) {
                    (0, $3E8Nt.captureError)(error);
                    data["error"] = "simulate-competitor-event";
                }
            });
            // Get news
            let newsItems = [];
            if (!previousEvent.weeklyShow) {
                let allNewsItems = await (0, $9esFv.getCompanyNewsItems)(mainCompany);
                newsItems = allNewsItems.filter((x)=>x.year === game.newsYear && x.monthCount === game.newsMonth);
                // Remove previous news
                try {
                    let currentTotalMonths = game.newsMonth + game.newsYear * 12;
                    for (let x of allNewsItems){
                        let totalMonths = x.monthCount + x.year * 12;
                        if (totalMonths < currentTotalMonths && !(0, $3E8Nt.objectInArray)(x, newsItems)) (0, $14eBR.NewsItems).remove(x);
                    }
                } catch (err) {
                    (0, $3E8Nt.captureError)(err);
                }
            }
            // Get most important news items, sorting by headline and priority
            data["news"] = [];
            newsItems.sort((a, b)=>b.headline - a.headline || b.priority - a.priority);
            for (let x of newsItems.slice(0, 16))data["news"].push($f0da149825527215$var$getNewsData(x));
            game.monthlySimulationRun = true;
            // Get viewership data for all companies
            if (game.marketSize != null) {
                let allCompanies = await (0, $iRMwH.getGameActiveCompanies)(game);
                data["fanChangeData"] = await (0, $8A6FL.getViewershipData)(allCompanies, game, previousEvent);
            }
        }
        if (!simulating) (0, $14eBR.db).saveDatabase();
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
        data["error"] = "simulate-competitors";
    }
    return data;
}
async function $f0da149825527215$var$fixCompetitorSimError(competitor, latestEvent, mainCompany, competitorRosterBrands) {
    let newEvent;
    if (!latestEvent.weeklyShow) {
        let eventNames = (await (0, $9esFv.getCompanyEvents)(mainCompany)).slice(0, 12).map((x)=>x.name);
        let eventIndex = eventNames.indexOf(latestEvent.name);
        let parentEvent = (await (0, $9esFv.getCompanyEvents)(competitor))[eventIndex];
        if (!parentEvent && typeof window.Sentry != "undefined") Sentry.captureMessage("Parent event not found for competitor. eventIndex: " + eventIndex + " competitorEvents: " + (await (0, $9esFv.getCompanyEvents)(competitor)).length);
        newEvent = (0, $iQtzn.Event)(parentEvent.name);
        await (0, $14eBR.Events).insert(newEvent);
        await (0, $iQtzn.addChildEvent)(parentEvent, newEvent);
    } else {
        let eventNames = (await (0, $9esFv.getCompanyEvents)(mainCompany)).slice(0, 12).map((x)=>x.name);
        let eventIndex = eventNames.indexOf(latestEvent.monthlyEventName);
        let monthlyEvent = (await (0, $9esFv.getCompanyEvents)(competitor))[eventIndex];
        // Add weekly show
        let weeklyShowName = competitor.weeklyShowName;
        if (!weeklyShowName) weeklyShowName = `${(0, $1JSre.formatCompanyNameBackend)(competitor.name)} Weekly`;
        let firstBrand = competitorRosterBrands.length > 0 ? competitorRosterBrands[0] : null;
        newEvent = await (0, $5ZsVo.addWeeklyShow)(weeklyShowName, monthlyEvent.name, latestEvent.weekNumber, firstBrand);
    }
    await (0, $9esFv.addCompanyEvents)(competitor, [
        newEvent
    ]);
    competitor.realYear = mainCompany.realYear;
}
function $f0da149825527215$var$checkSkipCompetitorSimulation(gameBrandIndex, competitorRosterBrands) {
    // Check if competitor has fewer brands than user's current brand
    return gameBrandIndex > 0 && competitorRosterBrands.length <= gameBrandIndex;
}
function $f0da149825527215$var$checkNextCompetitorEventSimulation(latestEvent, gameBrandIndex, gameRosterBrands, competitorRosterBrands) {
    // Check if user is on its last brand's weekly show and competitor has more brand shows
    if (latestEvent.weeklyShow && (gameBrandIndex === null || gameBrandIndex + 1 >= gameRosterBrands.length)) {
        if (competitorRosterBrands.length > 1 && (gameBrandIndex === null || competitorRosterBrands.length > gameBrandIndex + 1)) return true;
    }
    return false;
}
async function $f0da149825527215$var$getUserRosterBrandsAndIndex(companies) {
    // Get user company with highest brand index and number of brands
    let data = [];
    for (const company of companies){
        let latestEvent = (await (0, $9esFv.getCompanyEvents)(company)).filter((x)=>x.rating !== null).reverse()[0];
        let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main");
        let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
        let brandIndex = (0, $1Dp0h.getBrandIndexForWeeklyShow)(latestEvent, rosterBrands);
        data.push([
            brandIndex,
            rosterBrands
        ]);
    }
    return data.reduce((max, cur)=>cur[0] > max[0] || cur[0] === max[0] && cur[1].length > max[1].length ? cur : max);
}
function $f0da149825527215$var$getNewsData(news) {
    let data = {};
    data["title"] = news.title;
    data["content"] = news.content;
    data["priority"] = news.priority;
    data["headline"] = news.headline;
    if (news.companyName) data["company"] = news.companyName;
    return data;
}
async function $f0da149825527215$var$simulateCompetitorEvent(event, mainRoster, company, indieRoster, indieAvailableRoster, game) {
    const rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
    const rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
    const companyEvents = (await (0, $9esFv.getCompanyEvents)(company)).reverse();
    const staffMembers = await (0, $9esFv.getCompanyStaff)(company);
    const producers = (0, $8A6FL.getAvailableStaffMembersByRole)(staffMembers, "producer");
    const parentEvents = await (0, $8A6FL.getCompanyParentEvents)(company);
    const parentEvent = await (0, $5ZsVo.getParentEventForEvent)(parentEvents, event);
    const companyChampionships = await (0, $9esFv.getCompanyChampionships)(company);
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const user = (0, $bZol7.loadUser)();
    // Normal difficulty
    let style = (0, $3E8Nt.weightedChoice)([
        [
            "quality",
            50
        ],
        [
            "long-term",
            30
        ],
        [
            "standard",
            20
        ]
    ]);
    let effect = null;
    let eventHypeBoost = 0;
    // Hard difficulty
    if (game.settings["competitor_difficulty"] === "hard") {
        style = (0, $3E8Nt.weightedChoice)([
            [
                "quality",
                90
            ],
            [
                "long-term",
                10
            ]
        ]);
        effect = (0, $3E8Nt.weightedChoice)([
            [
                "positive_boost",
                80
            ],
            [
                null,
                20
            ]
        ]);
        eventHypeBoost = (0, $3E8Nt.weightedChoice)([
            [
                30,
                90
            ],
            [
                0,
                10
            ]
        ]);
    }
    // Add positive/negative effects
    if (company["activeEffect"] === "good_booking") {
        style = "quality";
        effect = "positive_boost";
    } else if (company["activeEffect"] === "bad_booking") {
        style = "terrible";
        effect = "negative_boost";
    }
    // Auto book matches and segments
    let autoBookData = await $f0da149825527215$var$autoBookEvent({
        company: company,
        roster: mainRoster,
        rosterSuperstars: rosterSuperstars,
        latestEvent: event,
        producers: producers,
        game: game,
        style: style,
        championships: companyChampionships,
        parentEvents: parentEvents,
        companyEvents: companyEvents
    });
    let bookedSegments = autoBookData["bookedSegments"];
    let bookedSegmentsAndMatches = autoBookData["bookedMatches"];
    if (bookedSegments) bookedSegmentsAndMatches.push(...bookedSegments);
    bookedSegmentsAndMatches.sort((a, b)=>a.order - b.order);
    // Set event hype
    let topEvent = event.name === (0, $5ZsVo.getTopEvent)(parentEvents).name;
    event.hype = await (0, $5ZsVo.getEventHype)(event, topEvent, bookedSegmentsAndMatches, companyEvents[1], rosterBrands);
    // Add event hype boost
    if (company.activeEffect === "good_booking") eventHypeBoost = 30;
    else if (company.activeEffect === "bad_booking") eventHypeBoost = 0;
    event.hype += eventHypeBoost;
    // Set poster graphic
    if (!event.weeklyShow && (0, $98xmD.globalUser).paid) {
        let posterData = await (0, $5ZsVo.getEventPosterGraphicData)(event, bookedSegmentsAndMatches, companyChampionships, parentEvent);
        if (posterData) event.posterGraphic = posterData["graphics"];
    }
    // Play matches and segments
    for (let matchOrSegment of bookedSegmentsAndMatches)try {
        if (matchOrSegment.objectName === "segment") await (0, $4ptHI.processPlaySegment)(matchOrSegment, null, bookedSegments, event, company, mainCompany, game, mainRoster, indieRoster, indieAvailableRoster, null, rosterSuperstars, companyChampionships, staffMembers, [
            ...bookedSegmentsAndMatches
        ]);
        else {
            let winner = await (0, $6RCLU.simulateMatchWinner)(matchOrSegment, style);
            let matchFinish = await $f0da149825527215$var$getMatchFinishForSimulatorMatch(matchOrSegment, event, company);
            await (0, $3SyPM.processPlayMatch)(matchOrSegment, winner.name, event, company, mainCompany, mainRoster, indieRoster, game, {}, matchFinish, null, rosterSuperstars, parentEvents, companyChampionships, staffMembers, [
                ...bookedSegmentsAndMatches
            ], effect, true);
        }
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    // End event, run post event
    await (0, $dGbip.endEvent)(company, user, true, rosterSuperstars);
    if (!event.weeklyShow) await $f0da149825527215$var$simulatePostEvent(company, user, style, "manage");
    return true;
}
async function $f0da149825527215$var$getMatchFinishForSimulatorMatch(match, event, company) {
    let matchFinish = {};
    let addMatchFinishChance = 5;
    if (event && event.weeklyShow) addMatchFinishChance = 20;
    // Chance to add match finish
    if ((0, $3E8Nt.getRandomInt)(0, 100) <= addMatchFinishChance) {
        // Get non-special finishes that can be used
        let availableMatchFinishes = (0, $6hwt2.matchFinishesData).filter((x)=>x["category"] !== "special" && company.points >= x["cost"]);
        // Remove indecisive finishes if gimmick match
        if (await (0, $i7bmn.getMatchGimmickMatch)(match)) availableMatchFinishes = availableMatchFinishes.filter((x)=>x["changeChampionship"]);
        // Choose random finish
        if (availableMatchFinishes.length > 0) {
            matchFinish = (0, $3E8Nt.getRandomChoice)(availableMatchFinishes);
            // Subtract points
            company.points -= matchFinish["cost"];
        }
    }
    return matchFinish;
}
async function $f0da149825527215$var$simulatePostEvent(company, user, style = "standard", simulatorOption = "manage") {
    let data = {};
    const game = await (0, $3E8Nt.getCurrentGame)();
    const mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    const companyName = company.name;
    const month = game.monthCount;
    const year = game.year;
    const companyMonth = (0, $8A6FL.getCompanyMonth)(company, game);
    const companyYear = (0, $8A6FL.getCompanyYear)(company, game);
    const powerups = await (0, $9esFv.getCompanyPowerups)(company);
    let retired = [];
    let awards = [];
    let reviewData = {};
    // Introduce powerups and special segments
    if (!company.userControlled || !game.settings["unlock_all_items"]) {
        if (month === 1 && year === 0) await (0, $kpu3X.introducePowerups)(company);
        if (month === 4 && year === 0) await (0, $4ptHI.introduceSpecialSegments)(company, game, user);
    }
    // Process user company
    if (company.userControlled) {
        // Yearly updates
        if (companyMonth === 0 && companyYear > 0) {
            const yearlyData = await (0, $8A6FL.processSuperstarsYearlyChanges)(company, true);
            retired = yearlyData["retired"];
        }
        // Objectives review and messages
        reviewData = await (0, $8A6FL.reviewObjectives)(company, game);
        let objectivesMessage = await (0, $hekDR.checkToAddCurrentObjectivesMessage)(company);
        if (objectivesMessage) await (0, $9esFv.addCompanyMessages)(company, [
            objectivesMessage
        ]);
        // Awards
        if (month === 10) {
            const awardsData = await (0, $b7dd8c4f6cc3ca70$export$97a1cb8a1145fa57)();
            if (awardsData["awards"]) awards = awardsData["awards"];
        }
    }
    // Simulate actions
    let createdTagteams = [];
    let createdTrios = [];
    let createdFactions = [];
    let disbandedTagteams = [];
    let createdChampionships = [];
    let callups = [];
    let powerupsUsed = [];
    let releasedSuperstars = [];
    let managersTransitioned = [];
    let managersAdded = [];
    let managersRemoved = [];
    let brandsChanged = [];
    // Manage company
    if (simulatorOption === "manage") {
        let companyRosters = await (0, $9esFv.getCompanyRosters)(company);
        let mainRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "main", companyRosters);
        let trainingRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "training", companyRosters);
        let trainingAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(company, "trainingAvailable", companyRosters);
        let indieRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indie");
        let indieAvailableRoster = await (0, $8A6FL.getCompanyRosterByType)(mainCompany, "indieAvailable");
        let rosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(mainRoster);
        let rosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(mainRoster);
        let rosterTagTeamSuperstars = (await Promise.all(rosterTagTeams.filter((x)=>!x.trio).map((t)=>(0, $972Ip.getTagTeamSuperstars)(t)))).flat();
        let rosterTrioSuperstars = (await Promise.all(rosterTagTeams.filter((x)=>x.trio).map((t)=>(0, $972Ip.getTagTeamSuperstars)(t)))).flat();
        let championships = await (0, $9esFv.getCompanyChampionships)(company);
        let championshipSuperstarIds = championships.map((x)=>x.superstarId);
        let rosterBrands = await (0, $dl5u4.getRosterBrands)(mainRoster);
        // Get chances
        let tagTeamChance = 6;
        if (style === "long-term") tagTeamChance = 3;
        else if (style === "bizarro") tagTeamChance = 15;
        let factionsChance = 20;
        let signingChance = 50;
        let championshipChance = 1;
        if (style === "long-term") championshipChance = 0;
        else if (style === "bizarro") championshipChance = 4;
        let gimmickChance = 20;
        if (style === "long-term") gimmickChance = 10;
        else if (style === "bizarro") gimmickChance = 40;
        let powerupsChance = 80;
        // Callup
        if (trainingRoster && (companyMonth === 1 || companyMonth === 7)) {
            // Add to available training roster
            if (!company.trainingTransferRun) {
                const talentToTransfer = (0, $3E8Nt.getRandomChoice)(await (0, $dl5u4.getRosterSuperstars)(trainingRoster));
                if (talentToTransfer) await (0, $jpMCP.transferTalentToRoster)(talentToTransfer, trainingAvailableRoster);
                company.trainingTransferRun = true;
            }
            // Run callup
            if (!company.trainingCallupRun) {
                let trainingRosterSuperstars = await (0, $dl5u4.getRosterSuperstars)(trainingAvailableRoster);
                if (trainingRosterSuperstars.length) {
                    // Get talent to callup
                    let superstar = (0, $3E8Nt.getRandomChoice)(trainingRosterSuperstars);
                    let superstarTagTeam = (await (0, $hBIDz.getSuperstarTagTeams)(superstar)).find((x)=>x);
                    let talent = superstarTagTeam || superstar;
                    // Callup, mark as done
                    await (0, $jpMCP.callupTalentToMainRoster)(talent, mainRoster, company, game);
                    company.trainingCallupRun = true;
                    callups.push(talent.name);
                    // Increase morale for talent superstars
                    for (const x of (await (0, $5kTkA.getRosterMemberSuperstars)(talent)))(0, $5kTkA.updateSuperstarMorale)(x, (0, $3E8Nt.getRandomInt)(20, 25));
                }
            }
        }
        // Disband tag team
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= tagTeamChance / 1.5) {
            // Get non champions
            let nonChampionTagTeams = [];
            for (const x of rosterTagTeams)if (!(await (0, $972Ip.getTagTeamSuperstars)(x)).some((s)=>championshipSuperstarIds.includes(s.$loki))) nonChampionTagTeams.push(x);
            if (nonChampionTagTeams.length) {
                let tagTeam = (0, $3E8Nt.weightedChoice)(await $f0da149825527215$var$getDisbandTagTeamWeights(nonChampionTagTeams));
                let tagTeamSuperstars = await (0, $972Ip.getTagTeamSuperstars)(tagTeam);
                // Check talent request
                for (let superstar of tagTeamSuperstars){
                    let requestData = {
                        "teamId": tagTeam.$loki
                    };
                    await (0, $1olyO.checkTalentRequestAction)({
                        company: company,
                        requestType: "disband_team",
                        talent: superstar,
                        data: requestData
                    });
                }
                await (0, $ko5kE.removeTagTeam)(tagTeam);
                disbandedTagteams.push(tagTeam.name);
            }
        }
        // Add tag team
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= tagTeamChance) {
            let tagTeamType = (0, $3E8Nt.getRandomInt)(0, 100) <= 65 ? "tagTeam" : "trio";
            if (tagTeamType === "tagTeam") {
                let availableSuperstars = rosterSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, rosterTagTeamSuperstars) && !x.retired && !x.fullTimeManager);
                if (availableSuperstars.length > 1) {
                    let superstarWeights = $f0da149825527215$var$getAddTagTeamWeights(availableSuperstars, style);
                    let firstSuperstar = (0, $3E8Nt.weightedChoice)(superstarWeights);
                    // Update weights for close popularity, gender, firstSuperstar
                    let secondSuperstarWeights = superstarWeights.filter((y)=>y[0].gender === firstSuperstar.gender && y[0] !== firstSuperstar && (!y[0].brandName || y[0].brandName === firstSuperstar.brandName)).map((y)=>$f0da149825527215$var$addTagteamPopularityCheck(y, firstSuperstar, style));
                    if (secondSuperstarWeights.length) {
                        let secondSuperstar = (0, $3E8Nt.weightedChoice)(secondSuperstarWeights);
                        let tagTeamMembers = [
                            firstSuperstar,
                            secondSuperstar
                        ];
                        let newTagTeam = await (0, $8bQDO.generateTagTeam)(tagTeamMembers);
                        await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
                            newTagTeam
                        ]);
                        createdTagteams.push({
                            "name": newTagTeam.name,
                            "superstars": tagTeamMembers.map((x)=>x.name)
                        });
                        // Check talent request
                        for (let participant of tagTeamMembers){
                            let teamMember = tagTeamMembers.find((x)=>x !== participant);
                            if (teamMember) {
                                let requestData = {
                                    "talentId": teamMember.$loki
                                };
                                await (0, $1olyO.checkTalentRequestAction)({
                                    company: company,
                                    requestType: "team_with_x",
                                    talent: participant,
                                    data: requestData
                                });
                            }
                        }
                    }
                }
            } else if (tagTeamType === "trio") {
                let availableSuperstars = rosterSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, rosterTrioSuperstars) && !x.retired && !x.fullTimeManager);
                if (availableSuperstars.length > 2) {
                    let superstarWeights = $f0da149825527215$var$getAddTagTeamWeights(availableSuperstars, style);
                    let firstSuperstar = (0, $3E8Nt.weightedChoice)(superstarWeights);
                    superstarWeights = superstarWeights.filter((y)=>y[0].gender === firstSuperstar.gender && y[0] !== firstSuperstar && (!y[0].brandName || y[0].brandName === firstSuperstar.brandName)).map((y)=>$f0da149825527215$var$addTagteamPopularityCheck(y, firstSuperstar, style));
                    if (superstarWeights.length > 1) {
                        let secondSuperstar = (0, $3E8Nt.weightedChoice)(superstarWeights);
                        superstarWeights = superstarWeights.filter((x)=>x[0] !== secondSuperstar);
                        let thirdSuperstar = (0, $3E8Nt.weightedChoice)(superstarWeights);
                        let trioSuperstars = [
                            firstSuperstar,
                            secondSuperstar,
                            thirdSuperstar
                        ];
                        let newTrio = await (0, $8bQDO.generateTrio)(trioSuperstars);
                        await (0, $dl5u4.addRosterTagTeams)(mainRoster, [
                            newTrio
                        ]);
                        createdTrios.push({
                            "name": newTrio.name,
                            "superstars": trioSuperstars.map((x)=>x.name)
                        });
                        // Check talent request
                        for (let participant of trioSuperstars)for (const teamMember of trioSuperstars.filter((x)=>x !== participant)){
                            let requestData = {
                                "talentId": teamMember.$loki
                            };
                            await (0, $1olyO.checkTalentRequestAction)({
                                company: company,
                                requestType: "team_with_x",
                                talent: participant,
                                data: requestData
                            });
                        }
                    }
                }
            }
        }
        // Release superstars if roster above capacity
        let capacity = (0, $8A6FL.getCompanyRosterCapacity)(company, game);
        let size = rosterSuperstars.filter((x)=>!x.retired && !x.dead).length;
        while(size > capacity && (0, $3E8Nt.getRandomInt)(0, 100) <= 50){
            let availableSuperstars = rosterSuperstars.filter((x)=>!championshipSuperstarIds.includes(x.$loki) && x.activeEffect !== "traded" && !x.retired && x.name !== company.ownerName);
            if (availableSuperstars.length) {
                let superstarToRelease;
                if (style === "bizarro") superstarToRelease = (0, $3E8Nt.getRandomChoice)(availableSuperstars);
                else superstarToRelease = (0, $3E8Nt.getArrayMinByProperty)(availableSuperstars, "popularity");
                // Add to indie roster
                rosterSuperstars = rosterSuperstars.filter((x)=>x !== superstarToRelease);
                if (game.settings["all_indies_available"]) await (0, $dl5u4.addRosterSuperstars)(indieAvailableRoster, [
                    superstarToRelease
                ]);
                else await (0, $dl5u4.addRosterSuperstars)(indieRoster, [
                    superstarToRelease
                ]);
                releasedSuperstars.push(superstarToRelease.name);
                // Remove teams/managers/factions
                await (0, $5kTkA.removeSuperstarTagTeams)(superstarToRelease);
                await (0, $5kTkA.removeSuperstarFactionRelationships)(superstarToRelease, month, year);
                await (0, $5kTkA.removeSuperstarManagerRelationships)(superstarToRelease);
                // Delete all relationships, add former company relationship
                for (const relationship of (await (0, $hBIDz.getSuperstarRelationships)(superstarToRelease)))await (0, $14eBR.Relationships).remove(relationship);
                await (0, $8A6FL.addFormerCompanyRelationship)(superstarToRelease, company);
                // Delete talent requests
                for (const talentRequest of (await (0, $hBIDz.getSuperstarTalentRequests)(superstarToRelease)))await (0, $14eBR.TalentRequests).remove(talentRequest);
                // Make superstar happy
                (0, $5kTkA.changeSuperstarMoraleToHappy)(superstarToRelease);
                // Decrease overness
                superstarToRelease.overness -= (0, $3E8Nt.getRandomInt)(8, 12);
                // Reset attributes
                superstarToRelease.brandName = null;
                superstarToRelease.faceOfTheCompanyCounter = 0;
                superstarToRelease.suspensionMonths = 0;
                // Add news
                let newsItem = await (0, $kZMqI.generateNewsItem)({
                    company: company,
                    month: game.newsMonth,
                    year: game.newsYear,
                    superstar: superstarToRelease,
                    newsType: "superstar_released_by_company"
                });
                await (0, $9esFv.addCompanyNewsItems)(mainCompany, [
                    newsItem
                ]);
                size = rosterSuperstars.filter((x)=>!x.retired && !x.dead).length;
            }
        }
        // Negotiate with talent
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= signingChance) {
            let competitors = await (0, $8A6FL.getActiveCompetitorsForCompany)(company, game);
            // Pick number of offers to make
            let numberOfOffers = (0, $3E8Nt.weightedChoice)([
                [
                    1,
                    80
                ],
                [
                    2,
                    15
                ],
                [
                    3,
                    5
                ]
            ]);
            for(let y = 0; y < numberOfOffers; y++)if (company.points > 100 && size < capacity) {
                // Choose roster
                let selectedCompetitor;
                let offerRoster = null;
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 60 && (await (0, $dl5u4.getRosterSuperstars)(indieAvailableRoster)).length) offerRoster = indieAvailableRoster;
                else if (competitors.length) {
                    // Choose roster from competitors, double chance to choose main company
                    let competitorWeights = competitors.map((y)=>y === mainCompany ? [
                            y,
                            y.reputation * 2
                        ] : [
                            y,
                            y.reputation
                        ]);
                    selectedCompetitor = (0, $3E8Nt.weightedChoice)(competitorWeights);
                    let offerCompanyRosters = await (0, $9esFv.getCompanyRosters)(selectedCompetitor);
                    let offerCompanyMainRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompetitor, "main", offerCompanyRosters);
                    let offerCompanyTrainingRoster = await (0, $8A6FL.getCompanyRosterByType)(selectedCompetitor, "training", offerCompanyRosters);
                    offerRoster = offerCompanyMainRoster;
                    // Small chance to choose training roster
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 20 && offerCompanyTrainingRoster && (await (0, $dl5u4.getRosterSuperstars)(offerCompanyTrainingRoster)).length) offerRoster = offerCompanyTrainingRoster;
                }
                if (offerRoster) {
                    let isContracted = offerRoster !== indieAvailableRoster;
                    let runningNegotiations = await (0, $9esFv.getCompanySentNegotiations)(company);
                    // Choose superstars or teams
                    let runningNegotiationsIds, availableTalent;
                    let offerRosterTagTeams = await (0, $dl5u4.getRosterTagTeams)(offerRoster);
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 20 && offerRosterTagTeams.length) {
                        runningNegotiationsIds = runningNegotiations.map((x)=>x.tagTeamId);
                        availableTalent = offerRosterTagTeams.filter((x)=>!x.temporary);
                    } else {
                        runningNegotiationsIds = runningNegotiations.map((x)=>x.superstarId);
                        let offerRosterTagTeamSuperstars = (await Promise.all(offerRosterTagTeams.map((t)=>(0, $972Ip.getTagTeamSuperstars)(t)))).flat();
                        availableTalent = (await (0, $dl5u4.getRosterSuperstars)(offerRoster)).filter((x)=>!(0, $3E8Nt.objectInArray)(x, offerRosterTagTeamSuperstars));
                    }
                    // Get talent available to send offer to, check for already running negotiations, trade deals etc
                    let availableTalentFiltered = [];
                    for (const x of availableTalent){
                        let s = await (0, $5kTkA.getRosterMemberSuperstars)(x);
                        if (!runningNegotiationsIds.includes(x.$loki) && company.points >= await (0, $3NAMH.getTalentValueAmount)(x, company, isContracted) && !s.some((y)=>y.activeEffect === "traded" || y.availableThisMonth)) availableTalentFiltered.push(x);
                    }
                    if (availableTalentFiltered.length) {
                        // Choose talent, make offer
                        let talentAvailableWeights = await $f0da149825527215$var$getNegotiationWeights(availableTalentFiltered, style);
                        let negotiationTalent = (0, $3E8Nt.weightedChoice)(talentAvailableWeights);
                        let newNegotiation = await (0, $3NAMH.makeTalentOffer)(negotiationTalent, company, selectedCompetitor);
                        // Chance for cpu competitors to make offer to talent too if they can afford it
                        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 30) {
                            let cpuCompetitors = competitors.filter((x)=>!x.userControlled && x !== selectedCompetitor);
                            if (cpuCompetitors.length) {
                                // Limit to 3 offer companies
                                let numberOfOfferCompaniesMax = cpuCompetitors.length > 3 ? 3 : cpuCompetitors.length;
                                let cpuCompetitorsSample = (0, $3E8Nt.getRandomSample)(cpuCompetitors, (0, $3E8Nt.getRandomInt)(1, numberOfOfferCompaniesMax));
                                for (let cpuCompetitor of cpuCompetitorsSample)if (cpuCompetitor.points > newNegotiation.offeredAmount) await (0, $3NAMH.makeTalentOffer)(negotiationTalent, cpuCompetitor, selectedCompetitor);
                            }
                        }
                    }
                }
            }
        }
        // Retire championship
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= championshipChance) // Don't retire if company has 2 or fewer championships
        {
            if ((0, $kZwpB.getUniqueChampionships)(championships).length > 2) {
                let championshipWeights = $f0da149825527215$var$getRetireChampionshipWeights(championships);
                let championship = (0, $3E8Nt.weightedChoice)(championshipWeights);
                // Add points
                let points = (0, $8A6FL.getChampionshipCost)(championship.rank, true, championship.gimmickRestriction);
                // Remove championship(s)
                let championshipsToRetire = championships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship));
                for (const x of championshipsToRetire){
                    championships = championships.filter((c)=>c !== x);
                    const champion = await (0, $ivuOU.getChampionshipSuperstar)(x);
                    if (champion) {
                        await (0, $hBIDz.removeSuperstarChampionships)(champion, [
                            x
                        ]);
                        champion.popularity -= (0, $8A6FL.getChampionshipPopularityDecrease)(x);
                        const oldReign = await (0, $ivuOU.getChampionshipCurrentReign)(x);
                        if (oldReign) {
                            oldReign.endMonth = month;
                            oldReign.endYear = year;
                            oldReign.retired = true;
                        }
                    }
                    if (x.matchContract) {
                        const matchContract = await (0, $ivuOU.getChampionshipMatchContract)(x);
                        if (matchContract) (0, $14eBR.MatchContracts).remove(matchContract);
                    }
                    if (x.matchContract || x.championshipContract) {
                        points = 0;
                        await (0, $9esFv.removeCompanyChampionships)(company, [
                            x
                        ]);
                    }
                    x.retired = true;
                }
                company.points += points;
            }
        }
        // Vacate championships if champion unavailable
        for (const championship of championships){
            let champion = await (0, $ivuOU.getChampionshipSuperstar)(championship);
            let femaleNames = [
                "women",
                "knockout",
                "diva",
                "female",
                "ladies",
                "woman"
            ];
            let wrongPronounChampion = femaleNames.some((n)=>championship.name.toLowerCase().includes(n)) && champion && champion.gender === "male";
            if (champion && !(0, $5kTkA.checkAvailability)(champion, true) || wrongPronounChampion) {
                let allChampionships = championships.filter((x)=>(0, $kZwpB.checkAreChampionshipsEqual)(x, championship));
                for (const c of allChampionships){
                    c.vacated = true;
                    let holder = await (0, $ivuOU.getChampionshipSuperstar)(c);
                    if (holder) await (0, $hBIDz.removeSuperstarChampionships)(holder, [
                        c
                    ]);
                    const oldReign = await (0, $ivuOU.getChampionshipCurrentReign)(c);
                    if (oldReign) {
                        oldReign.endMonth = month;
                        oldReign.endYear = year;
                        oldReign.vacated = true;
                    }
                    // Check talent request
                    if (holder) {
                        let requestData = {
                            "championshipId": c.$loki
                        };
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "vacate_championship",
                            talent: holder,
                            data: requestData
                        });
                    }
                }
            }
        }
        // Faction actions
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= factionsChance && (0, $98xmD.globalUser).paid) {
            let rosterFactions = await (0, $6PzHO.getRosterActiveFactions)(mainRoster);
            let rosterFactionSuperstars = (await Promise.all(rosterFactions.map((x)=>(0, $2JFAd.getFactionSuperstars)(x)))).flat();
            let superstarsAvailableForFactions = rosterSuperstars.filter((x)=>!(0, $3E8Nt.objectInArray)(x, rosterFactionSuperstars));
            // Faction actions if factions present or at limit
            if (rosterFactions.length && ((0, $3E8Nt.getRandomInt)(0, 100) <= 75 || rosterFactions.length >= 8)) {
                let factionActionPick = (0, $3E8Nt.getRandomInt)(0, 100);
                let factionForAction = (0, $3E8Nt.getRandomChoice)(rosterFactions);
                let factionSuperstars = await (0, $2JFAd.getFactionSuperstars)(factionForAction);
                // Chance to remove members
                if (factionActionPick <= 40) {
                    if (factionSuperstars.length > 2) {
                        let memberToRemove = (0, $3E8Nt.getRandomChoice)(factionSuperstars);
                        await (0, $6PzHO.removeSuperstarsFromFaction)(factionForAction, [
                            memberToRemove
                        ]);
                        // Don't add reputation change to give AI a chance at awards
                        // Check leave faction request
                        let requestData = {
                            "factionId": factionForAction.$loki
                        };
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "leave_faction",
                            talent: memberToRemove,
                            data: requestData
                        });
                    }
                } else if (factionActionPick <= 80) {
                    if (factionSuperstars.length < (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
                        let memberToAdd = (0, $3E8Nt.getRandomChoice)(superstarsAvailableForFactions);
                        let membersToAdd = [
                            memberToAdd
                        ];
                        await (0, $6PzHO.processFactionXpChangeForFaction)({
                            faction: factionForAction,
                            addedMembers: membersToAdd
                        });
                        await (0, $2JFAd.addFactionSuperstars)(factionForAction, membersToAdd);
                        // Check join faction request
                        let requestData = {
                            "factionId": factionForAction.$loki
                        };
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "join_faction",
                            talent: memberToAdd,
                            data: requestData
                        });
                    }
                } else if (factionActionPick <= 90) {
                    let newLeader = (0, $3E8Nt.getRandomChoice)(factionSuperstars);
                    await (0, $2JFAd.setFactionLeaderSuperstar)(factionForAction, newLeader);
                } else if (factionActionPick <= 100) await (0, $6PzHO.disbandFaction)(factionForAction, month, year);
            } else if (superstarsAvailableForFactions.length > 8 && rosterFactions.length < 8) {
                // Create faction and add to roster
                let factionSuperstars = (0, $3E8Nt.getRandomSample)(superstarsAvailableForFactions, (0, $3E8Nt.getRandomInt)(2, 8));
                let newFaction = await (0, $8bQDO.generateFaction)(factionSuperstars, rosterFactions, rosterTagTeams);
                await (0, $dl5u4.addRosterFactions)(mainRoster, [
                    newFaction
                ]);
                // Add company log
                const newLog = (0, $4K85d.CompanyLog)(game.monthCount, company.realYear);
                (0, $14eBR.CompanyLogs).insert(newLog);
                newLog.text = `${newFaction.name}`;
                newLog.type = "new-faction";
                newLog.realYear = game.year;
                await (0, $9esFv.addCompanyCompanyLogs)(company, [
                    newLog
                ]);
                createdFactions.push({
                    "name": newFaction.name,
                    "superstars": factionSuperstars.map((x)=>x.name)
                });
                // Check start faction request
                for (let factionSuperstar of factionSuperstars)await (0, $1olyO.checkTalentRequestAction)({
                    company: company,
                    requestType: "start_faction",
                    talent: factionSuperstar
                });
            }
        }
        // Create championship
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= championshipChance) {
            let rankNameWeights = [
                [
                    "Main Eventer",
                    2
                ],
                [
                    "Upper Midcarder",
                    10
                ],
                [
                    "Lower Midcarder",
                    8
                ],
                [
                    "Jabroni",
                    2
                ]
            ];
            let rankName = (0, $3E8Nt.weightedChoice)(rankNameWeights);
            let cost = (0, $8A6FL.getChampionshipCost)(rankName);
            if (company.points > cost) {
                // Chance to add women's championship
                let femaleSuperstar = rosterSuperstars.filter((x)=>x.gender === "female");
                let isWomens = false;
                if (femaleSuperstar.length > 4 && (0, $3E8Nt.getRandomInt)(0, 100) <= 30) isWomens = true;
                // Generate unique name
                let championshipName = (0, $8bQDO.generateChampionshipName)(companyName, rankName, null, isWomens);
                while(championships.some((x)=>x.name === championshipName))championshipName = (0, $8bQDO.generateChampionshipName)(companyName, rankName, null, isWomens);
                // Get number of championships to create
                let division = (0, $3E8Nt.weightedChoice)([
                    [
                        "singles",
                        70
                    ],
                    [
                        "tag-team",
                        20
                    ],
                    [
                        "trio",
                        10
                    ]
                ]);
                let divisionData = {
                    "singles": 1,
                    "tag-team": 2,
                    "trio": 3
                };
                let numberOfChampionships = divisionData[division] || 1;
                // Create championships
                let championshipGraphic = (0, $8bQDO.generateChampionshipGraphic)();
                for (let championship of Array(numberOfChampionships).keys()){
                    const newChampionship = (0, $ivuOU.Championship)(championshipName);
                    newChampionship.rank = rankName;
                    newChampionship.vacated = true;
                    if (division === "tag-team") newChampionship.tagTeam = true;
                    if (division === "trio") newChampionship.trio = true;
                    newChampionship.graphic = championshipGraphic;
                    (0, $14eBR.Championships).insert(newChampionship);
                    await (0, $9esFv.addCompanyChampionships)(company, [
                        newChampionship
                    ]);
                }
                // Change objective property
                if (company.userControlled) {
                    const objectiveCompleted = await (0, $8A6FL.changeProperty)({
                        name: "new championship",
                        change: 1,
                        company: company
                    });
                    if (objectiveCompleted) await (0, $8A6FL.processObjectiveCompleted)(objectiveCompleted, company);
                }
                // Subtract points
                company.points -= cost;
                createdChampionships.push(championshipName);
            }
        }
        // Artifacts
        let unlockedPowerups = powerups.filter((x)=>x.unlocked);
        if (unlockedPowerups.length) {
            // Buy artifact (if low on stock and can afford)
            let availablePowerups = unlockedPowerups.filter((x)=>x.stock > 0);
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= powerupsChance / 5) {
                let powerupsToBuy = unlockedPowerups.filter((x)=>company.points > x.cost && x.stock === 0);
                if (powerupsToBuy.length && availablePowerups.length < 3) {
                    let powerup = (0, $3E8Nt.getRandomChoice)(powerupsToBuy);
                    company.points -= powerup.cost;
                    powerup.stock += 1;
                }
            }
            if (game.settings["generate_indie_superstars"] === false) availablePowerups = availablePowerups.filter((x)=>x.effect !== "recruitment");
            // Use artifact
            if (availablePowerups.length) {
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= powerupsChance) {
                    // Get powerups that have selections available
                    let powerupsAndSelections = await Promise.all(availablePowerups.map(async (x)=>[
                            x,
                            await (0, $kpu3X.getPowerupSelections)(company, x)
                        ]));
                    powerupsAndSelections = powerupsAndSelections.filter((x)=>x[1]["selections"] || !x[0].selection);
                    if (powerupsAndSelections.length) {
                        let powerupAndSelections = (0, $3E8Nt.getRandomChoice)(powerupsAndSelections);
                        let powerup = powerupAndSelections[0];
                        let selections = powerupAndSelections[1]["selections"];
                        if (powerup.selection) {
                            let selection = (0, $3E8Nt.getRandomChoice)(selections);
                            await (0, $kpu3X.applyPowerupToSelection)(company, powerup, selection["uid"]);
                            powerupsUsed.push({
                                "name": powerup.name,
                                "usedOn": selection["name"]
                            });
                        } else {
                            await (0, $kpu3X.applyPowerupToSelection)(company, powerup);
                            powerupsUsed.push({
                                "name": powerup.name
                            });
                        }
                    }
                }
            }
        }
        // Gimmick
        if ((0, $3E8Nt.getRandomInt)(0, 100) <= gimmickChance) {
            // Get superstar and gimmick
            let superstar = (0, $3E8Nt.getRandomChoice)(rosterSuperstars);
            let superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(superstar);
            if (superstarGimmick) {
                // Pick again, bias against superstars with gimmicks
                superstar = (0, $3E8Nt.getRandomChoice)(rosterSuperstars);
                superstarGimmick = await (0, $hBIDz.getSuperstarCurrentGimmick)(superstar);
            }
            // Check for points if changing gimmick
            let gimmickPointsCheck = false;
            if (superstarGimmick && !superstarGimmick.nextGimmickBoost) {
                if (company.points >= 30) gimmickPointsCheck = true;
            } else gimmickPointsCheck = true;
            if (gimmickPointsCheck) {
                let character, personality, customGimmickName = null;
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 20) customGimmickName = (0, $8bQDO.generateGimmickName)();
                else {
                    let characters = (0, $fuJHb.charactersData).filter((x)=>x.standard);
                    if ((0, $98xmD.globalUser).paid) characters.push(...(0, $fuJHb.charactersData).filter((x)=>!x.standard && user.unlockedCharacters.includes(x.name)));
                    character = (0, $3E8Nt.getRandomChoice)(characters)["name"];
                    personality = (0, $3E8Nt.getRandomChoice)((0, $76da554e02071cd0$export$8ca504209c139329))["name"];
                }
                // Set gimmick name
                let gimmickName;
                if (customGimmickName) gimmickName = customGimmickName;
                else gimmickName = `${personality} ${character}`;
                // Check usage of character
                let alreadyUsedPenalty = 0;
                if (character) {
                    const timesUsed = await (0, $jpMCP.checkCharacterUsage)(character, mainRoster, superstar);
                    if (timesUsed > 0) {
                        if (timesUsed >= 8) alreadyUsedPenalty = -40;
                        else if (timesUsed >= 5) alreadyUsedPenalty = -15;
                        else if (timesUsed >= 2) alreadyUsedPenalty = -5;
                    }
                }
                // Next gimmick available bonus
                let nextGimmickBonus = 0;
                if (superstarGimmick && superstarGimmick.nextGimmickBoost) nextGimmickBonus = 20;
                // Create gimmick
                const newGimmick = await (0, $jpMCP.createGimmick)(superstar, gimmickName, character, alreadyUsedPenalty, nextGimmickBonus);
                superstar.debutNewGimmick = true;
                // Get combination bonus
                if (character && personality) newGimmick.combinationBonus = await (0, $jpMCP.getGimmickCreationBonus)(character, personality);
                // Remove points if changing gimmick
                if (superstarGimmick && !superstarGimmick.nextGimmickBoost) company.points -= 30;
            }
        }
        // Manager actions
        let transitionTalentChance = 15;
        let addManagerRelationshipChance = 10;
        let removeManagerRelationshipChance = 5;
        if ((0, $98xmD.globalUser).paid) {
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= removeManagerRelationshipChance) {
                // Get superstar from superstars with managers assigned
                let superstarsWithManagers = rosterSuperstars.filter((x)=>x.managerId);
                if (superstarsWithManagers.length) {
                    let superstarToRemove = (0, $3E8Nt.getRandomChoice)(superstarsWithManagers);
                    let manager = rosterSuperstars.find((x)=>x.$loki === superstarToRemove.managerId);
                    if (manager) {
                        // Remove superstar from manager
                        await (0, $5kTkA.removeSuperstarsFromManager)(manager, [
                            superstarToRemove
                        ]);
                        managersRemoved.push({
                            "managerName": manager.name,
                            "removedSuperstarsNames": [
                                superstarToRemove.name
                            ]
                        });
                    }
                }
            }
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= addManagerRelationshipChance) {
                // Get manager from full-time managers and talent with high charisma who are not managing someone
                let managerIds = [
                    ...new Set(rosterSuperstars.filter((x)=>x.managerId).map((x)=>x.managerId))
                ];
                let managerChoices = rosterSuperstars.filter((x)=>x.fullTimeManager && x.charisma >= 2 && !managerIds.includes(x.$loki));
                if (!managerChoices.length) managerChoices = rosterSuperstars.filter((x)=>x.charisma >= 2 && !managerIds.includes(x.$loki));
                if (managerChoices.length) {
                    let manager = (0, $3E8Nt.getRandomChoice)(managerChoices);
                    // Get superstar from non full-time manager superstars without managers with charisma lower than manager's
                    let superstarToManageChoices = rosterSuperstars.filter((x)=>!x.fullTimeManager && x.$loki !== manager.$loki && x.charisma < manager.charisma && !x.managerId && !x.retired && !x.partTimer && (!x.brandName || x.brandName === manager.brandName));
                    if (superstarToManageChoices.length) {
                        let superstarToManage = (0, $3E8Nt.getRandomChoice)(superstarToManageChoices);
                        // Add superstar to manager
                        await (0, $5kTkA.addSuperstarsToManager)(manager, [
                            superstarToManage
                        ]);
                        managersAdded.push({
                            "managerName": manager.name,
                            "managedSuperstarsNames": [
                                superstarToManage.name
                            ]
                        });
                        // Check manager requests
                        let requestData = {
                            "talentId": superstarToManage.$loki
                        };
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "be_managed",
                            talent: superstarToManage
                        });
                        await (0, $1olyO.checkTalentRequestAction)({
                            company: company,
                            requestType: "manage_x",
                            talent: manager,
                            data: requestData
                        });
                    }
                }
            }
            if ((0, $3E8Nt.getRandomInt)(0, 100) <= transitionTalentChance) {
                // Transition retired talent with high charisma into full-time managers
                let superstarChoices = rosterSuperstars.filter((x)=>!x.fullTimeManager && x.retired && x.charisma >= 3);
                if (superstarChoices.length) {
                    let superstarToTransition = (0, $3E8Nt.getRandomChoice)(superstarChoices);
                    superstarToTransition.fullTimeManager = true;
                    managersTransitioned.push(superstarToTransition.name);
                    let manager = await (0, $hBIDz.getSuperstarManager)(superstarToTransition);
                    if (manager) await (0, $5kTkA.removeSuperstarsFromManager)(manager, [
                        superstarToTransition
                    ]);
                }
            }
        }
        // Brand actions
        if ((0, $98xmD.globalUser).paid) {
            let brandShuffleChance = 8;
            // If more than one exclusive brand, shuffle superstars
            let exclusiveRosterBrands = rosterBrands.filter((x)=>x.weeklyShowIsExclusive);
            if (exclusiveRosterBrands.length > 1 && (0, $3E8Nt.getRandomInt)(0, 100) <= brandShuffleChance) {
                let superstarsMoved = [];
                for (let brand of exclusiveRosterBrands){
                    let availableSuperstars = rosterSuperstars.filter((x)=>x.brandName !== brand.name && !championshipSuperstarIds.includes(x.$loki) && !(0, $3E8Nt.objectInArray)(x, superstarsMoved));
                    if (availableSuperstars.length > 6) {
                        // Move random superstars to this brand
                        let superstarsToMove = (0, $3E8Nt.getRandomSample)(availableSuperstars, (0, $3E8Nt.getRandomInt)(3, 6));
                        for (let superstarToMove of superstarsToMove){
                            (0, $1Dp0h.draftSuperstarToBrand)(superstarToMove, brand.name, championships);
                            // Check talent request
                            let requestData = {
                                "brandId": brand.$loki
                            };
                            await (0, $1olyO.checkTalentRequestAction)({
                                company: company,
                                requestType: "change_brand",
                                talent: superstarToMove,
                                data: requestData
                            });
                        }
                        superstarsMoved.push(...superstarsToMove);
                        brandsChanged.push({
                            "superstars": (0, $3E8Nt.commaSeparate)(superstarsToMove.map((s)=>s.name)),
                            "brand": brand.name
                        });
                    }
                }
            }
        }
        // End feuds with low hype
        if (style === "quality") {
            for (let feud of (await (0, $dl5u4.getRosterFeuds)(mainRoster)))if (feud.hype < 0) {
                feud.ended = true;
                feud.endMonth = month;
                feud.endYear = year;
                // For ending potential feuds
                if (!feud.started) feud.rating = null;
                else feud.rating = await (0, $cXLSF.getFeudRating)(feud);
            }
        }
    }
    if (company.points < 0) company.points = 0;
    // Get data to return
    data["createdTagTeams"] = createdTagteams;
    data["disbandedTagTeams"] = disbandedTagteams;
    data["createdTrios"] = createdTrios;
    data["createdFactions"] = createdFactions;
    data["createdChampionships"] = createdChampionships;
    data["callups"] = callups;
    data["retired"] = retired;
    data["awardsWon"] = awards.filter((award)=>Object.keys(award["reward"]).length !== 0);
    data["powerupsUsed"] = powerupsUsed;
    data["releasedSuperstars"] = releasedSuperstars;
    data["managersTransitioned"] = managersTransitioned;
    data["managersAdded"] = managersAdded;
    data["managersRemoved"] = managersRemoved;
    data["brandsChanged"] = brandsChanged;
    data["reviewData"] = reviewData;
    return data;
}
async function $f0da149825527215$var$getDisbandTagTeamWeights(tagTeams) {
    let weights = [];
    for (let t of tagTeams){
        let weight = Math.pow(1000 / await (0, $ko5kE.getTagTeamPopularity)(t), 3);
        weights.push([
            t,
            Math.floor(weight)
        ]);
    }
    return weights;
}
function $f0da149825527215$var$getAddTagTeamWeights(superstars, style = "standard") {
    let weights = [];
    for (let s of superstars){
        let talentPopularity = (0, $3E8Nt.limitValueBetweenRange)(s.popularity, 1, 10000);
        let weight;
        if (style !== "bizarro") weight = Math.pow(1000 / talentPopularity, 2);
        else weight = Math.exp(talentPopularity / 150);
        weights.push([
            s,
            Math.floor(weight)
        ]);
    }
    return weights;
}
function $f0da149825527215$var$addTagteamPopularityCheck(weights, firstSuperstar, style = "standard") {
    if (style === "standard") return Math.abs(weights[0].popularity - firstSuperstar.popularity) > 50 ? [
        weights[0],
        weights[1]
    ] : [
        weights[0],
        weights[1] * 5
    ];
    else if (style === "long-term") return Math.abs(weights[0].popularity - firstSuperstar.popularity) < 100 ? [
        weights[0],
        weights[1]
    ] : [
        weights[0],
        weights[1] * 5
    ];
    else return [
        weights[0],
        weights[1]
    ];
}
async function $f0da149825527215$var$getNegotiationWeights(talents, style = "standard") {
    let weights = [];
    for (let t of talents){
        let weight = 1;
        for (let s of (await (0, $5kTkA.getRosterMemberSuperstars)(t))){
            weight += (s.workrate - 1 + s.charisma - 1) * 15;
            if (s.hot) weight += 40;
            if (s.contractMonthsRemaining !== null) weight *= 20;
            if (s.fullTimeManager) weight /= 3;
            if (style === "long-term") {
                let ageBiases = new Map([
                    [
                        25,
                        2
                    ],
                    [
                        32,
                        1.5
                    ],
                    [
                        38,
                        0.5
                    ],
                    [
                        45,
                        0.3
                    ]
                ]);
                let ageBias = 0.3;
                for (let [key, value] of ageBiases)if (key > s.age) {
                    ageBias = value;
                    break;
                }
                weight *= ageBias;
                if (s.partTimer) weight /= 3;
            }
        }
        weights.push([
            t,
            Math.round(weight)
        ]);
    }
    return weights;
}
function $f0da149825527215$var$getRetireChampionshipWeights(championships) {
    let weights = [];
    let prestigeWeights = {
        "S": 1,
        "A": 2,
        "B": 3,
        "C": 4
    };
    for (let c of championships){
        let weight = Math.pow(prestigeWeights[c.prestige] || 1, 3);
        weights.push([
            c,
            Math.floor(weight)
        ]);
    }
    return weights;
}
async function $f0da149825527215$var$getRefereeWeights(rosterSuperstars, bookedParticipants) {
    let weights = [];
    for (let x of rosterSuperstars){
        if ((0, $3E8Nt.objectInArray)(x, bookedParticipants)) continue;
        let weight = 1;
        if (x.retired) weight *= 10;
        if (x.gender === (await (0, $5kTkA.getRosterMemberSuperstars)(bookedParticipants[0]))[0].gender) weight *= 20;
        weights.push([
            x,
            Math.floor(weight)
        ]);
    }
    return weights;
}



var $46buw = parcelRequire("46buw");

var $98xmD = parcelRequire("98xmD");





var $1JSre = parcelRequire("1JSre");

var $3E8Nt = parcelRequire("3E8Nt");




var $98xmD = parcelRequire("98xmD");



var $lCS03 = parcelRequire("lCS03");

var $6RCLU = parcelRequire("6RCLU");

var $kZwpB = parcelRequire("kZwpB");


var $iRMwH = parcelRequire("iRMwH");



var $3E8Nt = parcelRequire("3E8Nt");

var $1JSre = parcelRequire("1JSre");


var $98xmD = parcelRequire("98xmD");


var $18vSN = parcelRequire("18vSN");
/* Annual Tournament */ function $e37bb324c1adb297$export$1efa17883ef037ff(dialogData) {
    $("#npc-dialog").fadeIn("slow");
    // Disable menu buttons if not at match
    if (!$("#progress-segment-button").is(":visible")) (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$c2e2884eb1888beb));
    // Show name and information
    let dialogPersonInformation = dialogData["information"];
    $(".npc-dialog-person-name").text(dialogPersonInformation["name"]);
    $(".npc-dialog-person-role").html('<div>President</div><div class="medium-grey">The Grand Invitational</div>').show();
    $(".npc-dialog-person-information").show();
    // Show graphic
    let el = $(".npc-dialog-person-graphic");
    (0, $c82cd471f4baff6b$export$e7557da3ac483fcd)(el, [
        dialogPersonInformation["graphic"]
    ], false, true);
    // Show dialog
    $e37bb324c1adb297$var$goThroughNPCDialog(dialogData["dialogs"], 0);
}
function $e37bb324c1adb297$var$goThroughNPCDialog(dialogs, dialogIndex) {
    let selectedChoice;
    let dialog = dialogs[dialogIndex];
    let currentChoices = dialog["choices"];
    // Show dialog
    let textIndex = 0;
    let currentDialogText = dialog["text"];
    $e37bb324c1adb297$var$showNPCDialogText(currentDialogText[textIndex]);
    // Check to show dialog choices or continue button
    $e37bb324c1adb297$var$processNPCNextDialogText(textIndex, currentDialogText, currentChoices);
    // Show/hide end button
    if (dialog && dialog["action"] === "startEvent") $(".npc-dialog-end-button-container").show();
    else $(".npc-dialog-end-button-container").hide();
    // Choice click
    $(document).off("click", ".npc-dialog-text");
    $(document).on("click", ".npc-dialog-text", async function() {
        // Get selected choice
        let selectedChoiceIndex = $(".npc-dialog-text").index($(this));
        selectedChoice = currentChoices[selectedChoiceIndex];
        // Mark choice as selected
        selectedChoice["selected"] = true;
        // Run choice's action if present
        if (selectedChoice["action"]) {
            let replyText = selectedChoice["reply"] ? selectedChoice["reply"]["text"] : "";
            await performNPCAction(selectedChoice["action"], replyText);
        } else {
            // Get next choices if present
            if (selectedChoice["reply"]["choices"]) currentChoices = selectedChoice["reply"]["choices"];
            else currentChoices = dialog["choices"];
            // Show dialog
            textIndex = 0;
            currentDialogText = selectedChoice["reply"]["text"];
            $e37bb324c1adb297$var$showNPCDialogText(currentDialogText[textIndex]);
            $e37bb324c1adb297$var$processNPCNextDialogText(textIndex, currentDialogText, currentChoices, selectedChoice["reply"]["goToNextDialog"]);
        }
    });
    // Continue dialog click
    $(document).off("click", ".npc-dialog-continue-button");
    $(document).on("click", ".npc-dialog-continue-button", function() {
        let goToNextDialog = selectedChoice && selectedChoice["reply"]["goToNextDialog"];
        // Go to next dialog
        if (goToNextDialog && textIndex >= currentDialogText.length - 1) {
            dialogIndex++;
            $e37bb324c1adb297$var$goThroughNPCDialog(dialogs, dialogIndex);
        } else {
            textIndex++;
            $e37bb324c1adb297$var$showNPCDialogText(currentDialogText[textIndex]);
            $e37bb324c1adb297$var$processNPCNextDialogText(textIndex, currentDialogText, currentChoices, goToNextDialog);
        }
    });
    // End dialog click
    $(document).off("click", ".npc-dialog-end-button");
    $(document).on("click", ".npc-dialog-end-button", async function() {
        let startEvent = dialog && dialog["action"] === "startEvent";
        if (!startEvent) $("#npc-dialog").hide();
        // Enable menu buttons if not at match
        if (!$("#progress-segment-button").is(":visible")) (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
        // Play event if bracket created
        if (startEvent) await (0, $212d6f8aa99fe567$export$f401be2a67e052a3)(false, true);
        else // Enable continue button if at match
        if ($("#progress-segment-button").is(":visible")) $("#progress-segment-button").removeClass("disabled");
        else await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)());
    });
    // Click selection item
    $(document).off("click", ".annual-tournament-selection-item");
    $(document).on("click", ".annual-tournament-selection-item", function() {
        if ($(this).hasClass("unavailable")) return;
        let selectionsAvailable = parseInt($(".annual-tournament-selections-info").data("value"));
        let selectionsSelected = $(".annual-tournament-selection-item.selected");
        // Select
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else {
            if (selectionsSelected.length >= selectionsAvailable) {
                let entriesWord = selectionsAvailable === 1 ? "entry" : "entries";
                notie.alert({
                    type: 4,
                    text: "You can't select more than {0} {1}".format(selectionsAvailable, entriesWord),
                    stay: true
                });
                return;
            }
            $(this).addClass("selected");
        }
        // Update selections available
        selectionsSelected = $(".annual-tournament-selection-item.selected").length;
        $(".annual-tournament-selections-info").html('<span class="annual-tournament-selections-number margin-right-2">' + "{0} / {1}</span> Selected".format(selectionsSelected, selectionsAvailable));
        // Turn green if selections complete
        if (selectionsSelected === selectionsAvailable) $(".annual-tournament-selections-number").addClass("green");
        else $(".annual-tournament-selections-number").removeClass("green");
    });
    // Confirm selections
    $(".annual-tournament-selections-container").off("click", ".annual-tournament-confirm-selections-button");
    $(".annual-tournament-selections-container").on("click", ".annual-tournament-confirm-selections-button", function() {
        // Check if all selections selected
        let selectionsAvailable = parseInt($(".annual-tournament-selections-info").data("value"));
        let selectionsSelected = $(".annual-tournament-selection-item.selected").length;
        let confirmText = "Are you sure?";
        if (selectionsSelected < selectionsAvailable) confirmText = "You haven't selected all the entries available to you. Are you sure you want to continue?";
        notie.confirm({
            text: confirmText,
            submitCallback: async function() {
                let injuryReplacement = $(".annual-tournament-selections-container").data("injuryReplacement");
                if (injuryReplacement) await performNPCAction("confirmReplacement");
                else await performNPCAction("confirmEntries");
            }
        });
    });
    // Back button
    $(".annual-tournament-selections-container").off("click", ".annual-tournament-back-button");
    $(".annual-tournament-selections-container").on("click", ".annual-tournament-back-button", function() {
        $(".annual-tournament-selections-container").fadeOut("fast", function() {
            $("#npc-dialog").fadeIn("fast");
            // Go back to main choices
            $e37bb324c1adb297$var$goThroughNPCDialog(dialogs, dialogIndex);
        });
    });
    // Search selections
    $(".annual-tournament-selections-container").off("input", ".annual-tournament-selections-search-input");
    $(".annual-tournament-selections-container").on("input", ".annual-tournament-selections-search-input", function() {
        (0, $1JSre.runAnnualTournamentSelectionsSearch)();
    });
    async function performNPCAction(action, dialogText) {
        if (action === "acceptInvitation" || action === "declineInvitation") await (0, $1JSre.makeGameRequest)((0, $18vSN.updateAnnualTournamentCompanyStatusView), {
            action: action
        }, showUpdateAnnualTournamentCompanyStatusData, {}, false);
        else if (action === "selectEntries") await (0, $1JSre.makeGameRequest)((0, $18vSN.getAnnualTournamentAvailableSelections), {}, showGetAnnualTournamentAvailableSelectionsData, {}, false);
        else if (action === "bribePresident") await (0, $1JSre.makeGameRequest)((0, $18vSN.addAnnualTournamentCompanyBribeView), {
            action: action
        }, showAddAnnualTournamentCompanyBribeData, {}, false);
        else if (action === "confirmEntries") {
            let participantUids = Array.from($(".annual-tournament-selection-item.selected"), function(el) {
                return parseInt($(el).attr("data-uid"));
            });
            await (0, $1JSre.makeGameRequest)((0, $18vSN.selectAnnualTournamentCompanyParticipants), {
                participantUids: participantUids
            }, showSelectAnnualTournamentCompanyParticipantsData, {}, false);
        } else if (action === "startTournament") await (0, $1JSre.makeGameRequest)((0, $18vSN.startAnnualTournamentView), {}, showStartAnnualTournamentData, {}, false);
        else if (action === "selectReplacement") await (0, $1JSre.makeGameRequest)((0, $18vSN.getAnnualTournamentAvailableSelections), {
            injuryReplacement: true
        }, showGetAnnualTournamentAvailableSelectionsData, {
            injuryReplacement: true
        }, false);
        else if (action === "confirmReplacement") {
            let replacementUid = parseInt($(".annual-tournament-selection-item.selected").attr("data-uid"));
            await (0, $1JSre.makeGameRequest)((0, $18vSN.replaceAnnualTournamentCompanyInjuredParticipant), {
                replacementUid: replacementUid
            }, showReplaceAnnualTournamentCompanyInjuredParticipantData, {}, false);
        }
        function showUpdateAnnualTournamentCompanyStatusData({ data: data } = {}) {
            if (!data["error"]) $e37bb324c1adb297$var$showNPCDialogEnd(dialogText);
            else if (data["error"] === "tournament-not-found") notie.alert({
                type: 3,
                text: "The annual tournament could not be found. Please try again."
            });
        }
        function showGetAnnualTournamentAvailableSelectionsData({ data: data, injuryReplacement: injuryReplacement = false } = {}) {
            // Add selections
            let html = "";
            data["selections"].forEach(function(selection) {
                html += (0, $b947816677aa453b$export$d11fe3a77bf18ed6)(selection);
            });
            if (data["selections"].length <= 0) html += '<div class="no-annual-tournament-selections-search-results inner-box-item annual-tournament-selection-item unavailable light-grey">No Talent Present</div>';
            $(".annual-tournament-selection-items-container").html(html).show().scrollTop(0);
            // Add selections text
            let selectionsAvailable = data["numberOfEntries"];
            $(".annual-tournament-selections-info").data("value", selectionsAvailable);
            $(".annual-tournament-selections-info").html('<span class="annual-tournament-selections-number ' + 'margin-right-2">0 / {0}</span> Selected'.format(selectionsAvailable));
            // Show confirm selections container
            $("#npc-dialog").fadeOut("fast", function() {
                $(".annual-tournament-selections-container").fadeIn("fast");
                $(".annual-tournament-selections-container").data("injuryReplacement", injuryReplacement);
                $(".annual-tournament-selection-items-container").scrollTop(0);
                $(".annual-tournament-selections-search-input").val("");
            });
        }
        function showAddAnnualTournamentCompanyBribeData({ data: data } = {}) {
            if (!data["error"]) {
                // If success, remove bribe choice
                if (data["success"]) {
                    dialog["choices"].pop();
                    // Update points
                    let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
                    $(".points-number").html(pointsHtml);
                }
                // Show bribe dialog reply, go back to main choices
                currentChoices = dialog["choices"];
                textIndex = 0;
                currentDialogText = data["dialog"];
                $e37bb324c1adb297$var$showNPCDialogText(currentDialogText[textIndex]);
                $e37bb324c1adb297$var$processNPCNextDialogText(textIndex, currentDialogText, currentChoices);
            } else if (data["error"] === "tournament-not-found") notie.alert({
                type: 3,
                text: "The annual tournament could not be found. Please try again."
            });
        }
        function showSelectAnnualTournamentCompanyParticipantsData({ data: data } = {}) {
            if (!data["error"]) $(".annual-tournament-selections-container").fadeOut("fast", function() {
                $("#npc-dialog").fadeIn("fast");
                $e37bb324c1adb297$var$showNPCDialogEnd(data["dialog"]);
                // Update points
                let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
                $(".points-number").html(pointsHtml);
            });
            else {
                if (data["error"] === "tournament-not-found") notie.alert({
                    type: 3,
                    text: "The annual tournament could not be found. Please try again."
                });
                else if (data["error"] === "too-many-entries") notie.alert({
                    type: 3,
                    text: "You have selected more entries than are available to you."
                });
            }
        }
        function showStartAnnualTournamentData({ data: data } = {}) {
            if (!data["error"]) {
                // If success, show reply and start event
                if (data["success"]) $e37bb324c1adb297$var$showNPCDialogEnd(data["dialog"]);
                else {
                    currentChoices = dialog["choices"];
                    textIndex = 0;
                    currentDialogText = data["dialog"];
                    $e37bb324c1adb297$var$showNPCDialogText(currentDialogText[textIndex]);
                    $e37bb324c1adb297$var$processNPCNextDialogText(textIndex, currentDialogText, currentChoices);
                }
            } else if (data["error"] === "tournament-not-found") notie.alert({
                type: 3,
                text: "The annual tournament could not be found. Please try again."
            });
        }
        function showReplaceAnnualTournamentCompanyInjuredParticipantData({ data: data } = {}) {
            if (!data["error"]) $(".annual-tournament-selections-container").fadeOut("fast", function() {
                $("#npc-dialog").fadeIn("fast");
                $e37bb324c1adb297$var$showNPCDialogEnd(data["dialog"]);
                // Add injury to event updates if at match
                let eventUpdatesSelector = $(".event-updates-other .updates-container");
                if (eventUpdatesSelector.length > 0) {
                    let tournamentInjuryHtml = (0, $5fab2de231db267f$export$2fe3faa2f51b0444)(data["tournamentInjury"]);
                    eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12">' + tournamentInjuryHtml + "</span>");
                    $(eventUpdatesSelector).parent().fadeIn("slow");
                }
            });
            else {
                if (data["error"] === "tournament-not-found") notie.alert({
                    type: 3,
                    text: "The annual tournament could not be found. Please try again."
                });
                else if (data["error"] === "replacement-not-found") notie.alert({
                    type: 3,
                    text: "The selected replacement could not be found. Please try again."
                });
            }
        }
    }
}
function $e37bb324c1adb297$var$processNPCNextDialogText(textIndex, currentDialogText, currentChoices, goToNextDialog) {
    $(".npc-dialog-continue-button-container").hide();
    // If final text and not end of dialog, show this dialog's choices
    if (textIndex >= currentDialogText.length - 1 && !goToNextDialog) {
        $e37bb324c1adb297$var$showNPCDialogChoices(currentChoices);
        $(".npc-dialog-continue-button-container").hide();
    } else {
        setTimeout(function() {
            $(".npc-dialog-continue-button-container").fadeIn("slow");
        }, 250);
        $(".npc-dialog-choices-container").hide();
    }
}
function $e37bb324c1adb297$var$showNPCDialogText(text) {
    let dialogContentElement = $(".npc-dialog-content");
    // Show text
    dialogContentElement.html(text).hide().fadeIn();
}
function $e37bb324c1adb297$var$showNPCDialogChoices(choices) {
    let dialogChoicesElement = $(".npc-dialog-choices-container");
    // Show choices
    let choicesHtml = "";
    choices.forEach(function(choice) {
        let selectedClass = "";
        if (choice["selected"]) selectedClass = " selected";
        if (choice["highlight"]) selectedClass = " " + choice["highlight"];
        choicesHtml += '<div class="dialog-choice-item npc-dialog-text' + selectedClass + '">' + choice["text"] + "</div>";
    });
    dialogChoicesElement.hide();
    if (choices.length > 0) setTimeout(function() {
        dialogChoicesElement.html(choicesHtml).fadeIn("slow");
    }, 500);
}
function $e37bb324c1adb297$var$showNPCDialogEnd(dialog) {
    // Show dialog, hide responses, show continue button
    $e37bb324c1adb297$var$showNPCDialogText(dialog);
    $(".npc-dialog-choices-container").hide();
    setTimeout(function() {
        $(".npc-dialog-end-button-container").fadeIn("slow");
    }, 500);
}
/* PoW */ let $e37bb324c1adb297$var$dialogData;
function $e37bb324c1adb297$export$92109d096b3683dd({ data: data }) {
    // Load dialog
    $e37bb324c1adb297$var$dialogData = data;
    if ($e37bb324c1adb297$var$dialogData["Hank Hughes"] && $e37bb324c1adb297$var$dialogData["Hank Hughes"]["storyPosition"] === "introduction") // Show introduction dialog
    $e37bb324c1adb297$var$selectDialogPerson([
        $e37bb324c1adb297$var$dialogData["Hank Hughes"]
    ]);
    else // Show person choices once dialog is loaded
    $("#select-dialog-person").trigger("click");
    $(".dialog-header").show();
    $("#pow-dialog").fadeIn("slow");
}
function $e37bb324c1adb297$var$selectDialogPerson(dialogsData, isReactionDialog) {
    let dialog = dialogsData[0];
    // Show name and information
    let dialogPersonInformation = dialog["information"];
    $(".dialog-person-name").text(dialogPersonInformation["name"]);
    if (dialogPersonInformation["producer"]) {
        $(".dialog-person-superstar-information").hide();
        $(".dialog-person-role").html('<div>Boss</div><div class="medium-grey">Producer</div>').show();
    } else {
        $(".dialog-person-popularity").text(dialogPersonInformation["popularity"]);
        $(".dialog-person-overness").text(dialogPersonInformation["overness"] + "%");
        let charisma = dialogPersonInformation["charisma"];
        let originalCharisma = dialogPersonInformation["hot"] ? charisma - 1 : charisma;
        let charismaHtml = '<i class="fa fa-star"></i>'.repeat(originalCharisma);
        if (dialogPersonInformation["hot"]) charismaHtml += '<i class="fa fa-star hot-color"></i>';
        if (charisma < 3) charismaHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - charisma);
        $(".dialog-person-charisma").html(charismaHtml);
        let workrate = dialogPersonInformation["workrate"];
        let originalWorkrate = dialogPersonInformation["hot"] ? workrate - 1 : workrate;
        let workrateHtml = '<i class="fa fa-star"></i>'.repeat(originalWorkrate);
        if (dialogPersonInformation["hot"]) workrateHtml += '<i class="fa fa-star hot-color"></i>';
        if (workrate < 3) workrateHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - workrate);
        $(".dialog-person-workrate").html(workrateHtml);
        if (dialogPersonInformation["hot"]) {
            $(".dialog-person-workrate").addClass("hot-color");
            $(".dialog-person-charisma").addClass("hot-color");
        } else {
            $(".dialog-person-workrate").removeClass("hot-color");
            $(".dialog-person-charisma").removeClass("hot-color");
        }
        $(".dialog-person-superstar-information").show();
        $(".dialog-person-role").hide();
    }
    $(".dialog-person-information").show();
    // Show graphic
    let el = $(".dialog-person-graphic");
    (0, $c82cd471f4baff6b$export$c401870440d21dc6)([
        dialogPersonInformation["graphic"]
    ], el);
    // Show dialog
    $e37bb324c1adb297$var$goThroughChoicesDialog(dialogsData, 0, isReactionDialog);
}
function $e37bb324c1adb297$var$goThroughChoicesDialog(dialogsData, dialogIndex, isReactionDialog) {
    let dialog = dialogsData[dialogIndex];
    // Get main dialog choices
    let currentChoices = dialog["choices"];
    // Show dialog
    let textIndex = 0;
    let currentDialogText = dialog["text"];
    $e37bb324c1adb297$var$showDialogText(currentDialogText[textIndex]);
    // Check to show dialog choices or continue button
    $e37bb324c1adb297$var$processNextDialogText(textIndex, currentDialogText, currentChoices, isReactionDialog);
    // Choice click
    $(document).off("click", ".dialog-text");
    $(document).on("click", ".dialog-text", function() {
        // Get selected choice
        let selectedChoiceIndex = $(".dialog-text").index($(this));
        let selectedChoice = currentChoices[selectedChoiceIndex];
        // Mark choice as selected
        selectedChoice["selected"] = true;
        if (selectedChoice["reply"]["choices"].length > 0 || isReactionDialog || selectedChoice["reply"]["end_conversation"]) // Get next choices if present and direct dialog
        currentChoices = selectedChoice["reply"]["choices"];
        else // Otherwise go back to main choices
        currentChoices = dialog["choices"];
        // Show dialog
        textIndex = 0;
        currentDialogText = selectedChoice["reply"]["text"];
        $e37bb324c1adb297$var$showDialogText(currentDialogText[textIndex]);
        $e37bb324c1adb297$var$processNextDialogText(textIndex, currentDialogText, currentChoices, isReactionDialog);
        if (selectedChoice["reply"]["end_conversation"]) setTimeout(function() {
            $("#select-dialog-person").trigger("click");
        }, 1300);
    });
    // Continue dialog click
    $(document).off("click", ".pow-dialog-continue-button");
    $(document).on("click", ".pow-dialog-continue-button", function() {
        // Show next dialog text
        textIndex++;
        $e37bb324c1adb297$var$showDialogText(currentDialogText[textIndex]);
        $e37bb324c1adb297$var$processNextDialogText(textIndex, currentDialogText, currentChoices, isReactionDialog);
    });
    // Next dialog click
    $(document).off("click", ".pow-dialog-next-button");
    $(document).on("click", ".pow-dialog-next-button", function() {
        dialogIndex++;
        if (dialogsData[dialogIndex]) // Get next dialog
        $e37bb324c1adb297$var$goThroughChoicesDialog(dialogsData, dialogIndex, isReactionDialog);
        else // If no more dialogs, hide dialog box
        $("#pow-dialog").fadeOut(function() {
            // Enable menu buttons if not at end event and not failure ending
            if (!$("#continue-container").is(":visible")) {
                if (!(0, $98xmD.globals).game.powStoryFailureEnding) (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
                $("#dashboard-container").show();
                $("#view-dashboard-menu-button").addClass("selected");
            }
        });
    });
}
function $e37bb324c1adb297$var$showDialogText(text) {
    let dialogContentElement = $(".pow-dialog-content");
    dialogContentElement.html(text).hide().fadeIn();
}
function $e37bb324c1adb297$var$processNextDialogText(textIndex, currentDialogText, currentChoices, isReactionDialog) {
    $(".pow-dialog-continue-button-container").hide();
    $(".pow-dialog-next-button-container").hide();
    // If final text, show dialog choices
    if (textIndex >= currentDialogText.length - 1) {
        $e37bb324c1adb297$var$showDialogChoices(currentChoices);
        $(".pow-dialog-continue-button-container").hide();
        // Check to show next dialog button
        $e37bb324c1adb297$var$checkToShowNextDialogButton(currentChoices, isReactionDialog);
    } else {
        setTimeout(function() {
            $(".pow-dialog-continue-button-container").fadeIn("slow");
        }, 250);
        $(".dialog-choices-container").hide();
    }
}
function $e37bb324c1adb297$var$checkToShowNextDialogButton(choices, isReactionDialog) {
    // Show 'next' button if reaction dialog and no more choices
    if (choices.length <= 0 && isReactionDialog) setTimeout(function() {
        $(".pow-dialog-next-button-container").fadeIn("slow");
    }, 250);
}
function $e37bb324c1adb297$var$showDialogChoices(choices) {
    let dialogChoicesElement = $(".dialog-choices-container");
    // Show choices
    let choicesHtml = "";
    choices.forEach(function(choice) {
        let selectedClass = "";
        if (choice["selected"]) selectedClass = " selected";
        choicesHtml += '<div class="dialog-choice-item dialog-text' + selectedClass + '">' + choice["text"] + "</div>";
    });
    dialogChoicesElement.hide();
    if (choices.length > 0) setTimeout(function() {
        dialogChoicesElement.html(choicesHtml).fadeIn("slow");
    }, 500);
}
function $e37bb324c1adb297$export$22af59cdbd54e1f8(dialogsData) {
    $("#pow-dialog").fadeIn("slow");
    $(".dialog-header").hide();
    // Disable menu buttons if not at end event
    if (!$("#continue-container").is(":visible")) (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
    $e37bb324c1adb297$var$selectDialogPerson(dialogsData, true);
}
function $e37bb324c1adb297$export$468062643968fd83(name) {
    // Get person's data
    let personDialogData = $e37bb324c1adb297$var$dialogData[name];
    if (!personDialogData) {
        notie.alert({
            type: 3,
            text: "{0} is not available to talk to.".format(name)
        });
        return false;
    }
    $e37bb324c1adb297$var$selectDialogPerson([
        personDialogData
    ]);
}
function $e37bb324c1adb297$export$53ca73c04f3e229a() {
    $(".pow-dialog-content").hide();
    $(".dialog-person-information").hide();
    $(".pow-dialog-next-button-container").hide();
    $(".pow-dialog-continue-button-container").hide();
    // Get people choices from dialogData
    let dialogPeopleArray = [
        "Hank Hughes",
        "Lady Julia",
        "Violet",
        "Zora",
        "Natasha Ali"
    ];
    let sidePeopleArray = [];
    // Add side character choices after introduction
    if ($e37bb324c1adb297$var$dialogData["Hank Hughes"] && $e37bb324c1adb297$var$dialogData["Hank Hughes"]["storyPosition"] !== "introduction") sidePeopleArray = [
        "Merry Martha",
        "Lora the Lioness",
        "Fortuna",
        "Scarlet",
        "Joan of Narcs"
    ];
    // Get people choices html
    let personChoicesHtml = "";
    let sidePersonChoicesHtml = "";
    dialogPeopleArray.concat(sidePeopleArray).forEach(function(person) {
        // Show opaque item if not available
        let dialogChoiceClass = !$e37bb324c1adb297$var$dialogData[person] ? " selected" : "";
        let dialogChoiceHtml = '<div class="dialog-person-choice dialog-choice-item' + dialogChoiceClass + '">' + person + "</div>";
        if (dialogPeopleArray.indexOf(person) >= 0) personChoicesHtml += dialogChoiceHtml;
        else sidePersonChoicesHtml += dialogChoiceHtml;
    });
    // Add people choices
    $(".dialog-choices-container").html('<div class="column-left">' + personChoicesHtml + "</div>" + '<div class="column-right">' + sidePersonChoicesHtml + "</div>" + '<div class="clear"></div>').hide().fadeIn();
}



let $5fab2de231db267f$var$playMatchHintShown = false;
$(document).ready(function() {
    // Show championship prestige details
    $("#prestige-results").off("click", ".show-championship-prestige-details");
    $("#prestige-results").on("click", ".show-championship-prestige-details", function() {
        $(this).parent().siblings(".championship-prestige-details").toggleClass("display-none");
    });
    // Show faction reputation details
    $("#prestige-results").off("click", ".show-faction-reputation-details");
    $("#prestige-results").on("click", ".show-faction-reputation-details", function() {
        $(this).parent().siblings(".faction-reputation-details").toggleClass("display-none");
    });
    // Match results options
    $("#game-content").on("click", ".hide-stats", async function() {
        // Select stats to show/hide
        let elements;
        let text = $(this).text();
        switch(text){
            case "Ovr.":
                elements = $(".match-result-overness");
                break;
            case "XP":
                elements = $(".match-result-xp");
                break;
            case "Pop.":
                elements = $(".match-result-popularity");
                break;
            case "Gim.":
                elements = $(".match-result-gimmick-effectiveness");
                break;
            case "Feuds":
                elements = $(".match-result-feuds");
                break;
            case "Mor.":
                elements = $(".match-result-morale");
                break;
            case "Fat.":
                elements = $(".match-result-fatigue");
                break;
        }
        if ($(this).hasClass("medium-grey")) {
            $(this).removeClass("medium-grey").addClass("extra-light-grey");
            elements.hide();
        } else {
            $(this).addClass("medium-grey").removeClass("extra-light-grey");
            elements.show();
        }
        // Save setting
        let setting = {};
        $(".hide-stats").each(function(i, e) {
            switch($(e).text()){
                case "Ovr.":
                    setting.overness = $(e).hasClass("medium-grey");
                    break;
                case "XP":
                    setting.xp = $(e).hasClass("medium-grey");
                    break;
                case "Pop.":
                    setting.popularity = $(e).hasClass("medium-grey");
                    break;
                case "Gim.":
                    setting.gimmickEffectiveness = $(e).hasClass("medium-grey");
                    break;
                case "Feuds":
                    setting.feuds = $(e).hasClass("medium-grey");
                    break;
                case "Mor.":
                    setting.morale = $(e).hasClass("medium-grey");
                    break;
                case "Fat.":
                    setting.fatigue = $(e).hasClass("medium-grey");
                    break;
            }
        });
        (0, $98xmD.globalUser).settings["matchResult"] = setting;
        await (0, $1JSre.makeGameRequest)((0, $iRMwH.changeUserMatchResultSetting), {
            setting: setting
        }, function() {
            notie.alert({
                type: 4,
                text: "Setting updated"
            });
        }, {}, false);
    });
    // Show championship contracts for cash in (during match)
    $("#match").on("click", "#championship-contract-cashin-show", async function() {
        let element = $(this);
        let teamType = $(this).attr("data-team-type");
        await (0, $1JSre.makeGameRequest)((0, $kZwpB.getChampionshipContractHolders), {
            teamType: teamType
        }, $5fab2de231db267f$var$showGetChampionshipContractHoldersData, {
            element: element
        }, false);
    });
    // Show championships for cash in (during booking)
    $("#booking-talent-info").on("click", "#championship-contract-cashin-show", async function() {
        let element = $(this);
        let uid = $(this).attr("data-uid");
        await (0, $1JSre.makeGameRequest)((0, $kZwpB.getChampionshipsForCashin), {
            uid: uid
        }, $5fab2de231db267f$var$showGetChampionshipsForCashinData, {
            element: element
        }, false);
    });
    // Cash in (during booking)
    $("#booking-talent-info").on("click", "#championship-contract-cashin", async function() {
        let championshipContractUid = $(this).attr("data-uid");
        let championshipUid = $(".championship-contract-cashin-box select[name='cashin-championships']").val();
        await (0, $1JSre.makeGameRequest)((0, $kZwpB.addCashinFutureMatch), {
            championshipContractUid: championshipContractUid,
            championshipUid: championshipUid
        }, $5fab2de231db267f$var$showAddCashinFutureMatchData, {}, false);
    });
});
async function $5fab2de231db267f$export$fa6405f9da4f10e6({ matchesAndSegmentsData: matchesAndSegmentsData, index: index = 0, tournamentDisplay: tournamentDisplay, cashinData: cashinData } = {}) {
    const $matchInfoSelector = $("#match-info");
    const $match = $("#match");
    let stageLayers;
    // Get match
    let match = matchesAndSegmentsData[index];
    // Show header
    $(".match-container-header-text").text("Next Match");
    // Reset ui
    $matchInfoSelector.html("").removeClass("visibility-hidden").show();
    $match.data("played", false);
    // Show match info, participants text
    $5fab2de231db267f$var$showMatchInfoText(match, matchesAndSegmentsData, index, cashinData["cashin"], cashinData["challenger"], cashinData["championshipContract"]);
    $matchInfoSelector.fadeIn("slow");
    let largeTag = $5fab2de231db267f$var$showMatchParticipantsText(match);
    $(".match-container").fadeIn("fast");
    // Reset booking talent info
    $("#booking-talent-info").html("");
    $("#booking-talent-info").addClass("match").hide();
    // Show cash in button
    if (match["canCashin"]) {
        if (match["type"] === "singles" && cashinData["cashinSinglesAvailable"] || match["teamType"] === "tag-team" && cashinData["cashinTagAvailable"] || match["teamType"] === "trio" && cashinData["cashinTriosAvailable"]) $match.append('<button type="button" id="championship-contract-cashin-show" data-match-type="' + match["type"] + '" ' + 'data-match-uid="' + match["uid"] + '" ' + 'data-team-type="' + match["teamType"] + '" ' + 'class="button retro-button gold-button-background margin-top-20 margin-bottom-10 help-text margin-sides-auto display-block" ' + 'title="Cash in a contract during or after this match">Cash In</button>');
    }
    // Add show match finishes and simulate buttons
    $(".show-match-finishes-button").remove();
    $("#simulate-match").remove();
    let matchFinishesButton = "";
    if (!(0, $98xmD.globals).game.annualTournamentRunning) // Don't show 'add finish' during annual tournament
    matchFinishesButton = '<div><button type="button" class="display-block show-match-finishes-button button retro-button margin-top-10 display-inline-block">Add Finish</button></div>';
    $match.append('<div class="text-center match-buttons-container"><div><button type="button" class="button retro-button margin-top-15 display-inline-block" id="simulate-match" data-match-uid="' + match["uid"] + '">Simulate</button></div>' + matchFinishesButton + "</div>");
    // Add information box
    $match.append('<div class="match-superstar-information information-box"><div class="superstar-info-match-container">Participant Details<div class="empty-superstar-info light-grey"><div class="vertical-center">Hover over a Participant to display their details here</div></div></div></div>');
    // Show graphics
    if (match["graphics"].length > 0) stageLayers = (0, $c82cd471f4baff6b$export$aebc172523823760)(match);
    // Show open challenge text
    if (match["consequence"] === "random_opponent" && match["participants"].length < 2) {
        let text = " is calling out anyone in the back to a match...";
        if (match["type"] === "tag") text = " are calling out anyone in the back to a match...";
        $matchInfoSelector.append("<span class='font-bold display-block grey margin-top-5'>" + match["participants"][0]["name"] + text + "</span>");
        $matchInfoSelector.append("<span id='random-opponent-name' class='font-bold display-block dark-grey margin-top-5'>Who's it going to be?</span>");
        // Don't allow playing
        $match.data("played", true);
        // Get random opponent
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.getRandomOpponent), {
            uid: match["uid"],
            type: match["type"]
        }, showGetRandomOpponentData, {}, false, true);
        function showGetRandomOpponentData({ data: data } = {}) {
            if (!data["error"]) {
                let randomOpponentDiv = $("#random-opponent-name");
                let available = (0, $3E8Nt.shuffle)(data["available"]);
                let j = 0;
                let k = 0;
                let showAvailableOpponents = setInterval(function() {
                    // Show available opponents
                    randomOpponentDiv.text(available[j]);
                    j++;
                    if (j >= available.length) j = 0;
                    k++;
                    if (k >= 30) {
                        // Show selected opponent
                        randomOpponentDiv.text(data["opponent"]["name"] + " answered the challenge!");
                        clearInterval(showAvailableOpponents);
                        setTimeout(function() {
                            // Add match wrestler element
                            let dataType = "";
                            if (match["type"] === "tag") dataType = "tagTeam";
                            let matchWrestlerElement = '<div class="match-wrestler-container"><button class="match-wrestler match-span" data-type="' + dataType + '"' + ' data-name="' + data["opponent"]["name"].replace(/"/g, "&quot;") + '">' + (0, $67cc16607ee33ebf$export$bc6829a93fbd1f8a)(data["opponent"]) + "</button></div>";
                            $("#match").find(".match-wrestler-container").last().after('<span class="match-span">vs</span>' + matchWrestlerElement);
                            // Update match data
                            match["participants"].push(data["opponent"]);
                            match["graphics"] = data["graphics"];
                            // Update graphics
                            stageLayers = (0, $c82cd471f4baff6b$export$aebc172523823760)(match);
                            $("#match-graphics").hide().fadeIn();
                            // Mark as not played
                            $("#match").data("played", false);
                        }, 500);
                    }
                }, 110, k);
            } else if (data["error"] === "no-opponents-found") notie.alert({
                type: 3,
                text: "No opponents are available for this match. Try going back and deleting this match."
            });
        }
    }
    // Show gimmick match roulette text
    if (match["activeEffect"] === "gimmick_match_roulette") {
        if (!match["gimmick"]) {
            $matchInfoSelector.append("<span id='random-gimmick-match-name' class='font-bold display-block dark-grey'>The Roulette is spun ...</span>");
            $("#match").data("played", true);
            setTimeout(async function() {
                await (0, $1JSre.makeGameRequest)((0, $6RCLU.getRandomGimmickMatch), {
                    uid: match["uid"]
                }, showGetRandomGimmickMatchData, {}, false, true);
                function showGetRandomGimmickMatchData({ data: data } = {}) {
                    let randomGimmickMatchDiv = $("#random-gimmick-match-name");
                    let available = (0, $3E8Nt.shuffle)(data["available"]);
                    let j = 0;
                    let k = 0;
                    let showAvailableGimmickMatches = setInterval(function() {
                        // Get random gimmick match
                        randomGimmickMatchDiv.text(available[j]);
                        j++;
                        if (j >= available.length) j = 0;
                        k++;
                        if (k > 18) {
                            // Clear interval, set roulette to decelerating function
                            clearInterval(showAvailableGimmickMatches);
                            let l = 0;
                            let numberToRun = 6;
                            $5fab2de231db267f$var$setDeceleratingTimeout(function() {
                                randomGimmickMatchDiv.text(available[j]);
                                j++;
                                if (j >= available.length) j = 0;
                                l++;
                                if (l >= numberToRun) {
                                    // Show selected gimmick match
                                    randomGimmickMatchDiv.text(data["gimmickMatch"]["gimmick"]);
                                    setTimeout(function() {
                                        let gimmickMatchName = data["gimmickMatch"]["gimmick"];
                                        randomGimmickMatchDiv.text("The Roulette landed on " + gimmickMatchName + " Match!");
                                        // Show gimmick match name
                                        setTimeout(function() {
                                            let gimmickMatchText = $5fab2de231db267f$var$getMatchGimmickText(data["gimmickMatch"]);
                                            $("#match-info").append("<span class='font-bold display-block margin-bottom-10 grey'>" + gimmickMatchText + " Match</span>");
                                            match["gimmick"] = gimmickMatchName;
                                            match["generated"] = data["gimmickMatch"]["generated"];
                                            randomGimmickMatchDiv.remove();
                                            $("#match").data("played", false);
                                        }, 1200);
                                    }, 1000);
                                }
                            }, 140, numberToRun);
                        }
                    }, 160, k);
                }
            }, 500);
        }
    }
    // Show pick winner notie
    if (!$5fab2de231db267f$var$playMatchHintShown) {
        notie.alert({
            type: 4,
            text: '<span class="display-block">Click on a participant\'s name to pick them as the winner</span>',
            stay: true
        });
        $5fab2de231db267f$var$playMatchHintShown = true;
    }
    // Show tournament display
    if (tournamentDisplay && match["tournamentRound"]) {
        let tournamentMatchDisplay;
        // Add bracket
        let tournamentRound;
        let tournamentRounds;
        if (tournamentDisplay["type"] === "elimination" || tournamentDisplay["stage"] === "elimination") {
            tournamentRound = match["tournamentRound"];
            tournamentRounds = Object.keys(tournamentDisplay["bracket"]).length;
            let bracket = tournamentDisplay["bracket"][tournamentRound];
            let bracketHtml = (0, $70adc4a1fd111893$export$d1c14a92b2f32dc8)(bracket, tournamentRound, tournamentRounds, false, tournamentDisplay["startRound"]);
            tournamentMatchDisplay = '<div class="tournament-bracket-container font-bold text-left">' + bracketHtml + "</div>";
        } else if (tournamentDisplay["type"] === "round-robin") {
            let table = tournamentDisplay["table"];
            let tableHtml = (0, $70adc4a1fd111893$export$b15b76cf4991fb5f)(table, tournamentDisplay["participantsAdvancing"]);
            tournamentMatchDisplay = '<div class="font-bold text-left margin-top-20 margin-bottom-20">' + tableHtml + "</div>";
        }
        $match.append(tournamentMatchDisplay);
        // Navigate bracket rounds
        if (tournamentDisplay["type"] === "elimination") {
            $match.off("click", ".tournament-bracket-next");
            $match.off("click", ".tournament-bracket-prev");
            $match.on("click", ".tournament-bracket-next", function() {
                tournamentRound++;
                let bracket = tournamentDisplay["bracket"][tournamentRound];
                if (!bracket) {
                    tournamentRound--;
                    return false;
                }
                let bracketDiv = (0, $70adc4a1fd111893$export$d1c14a92b2f32dc8)(bracket, tournamentRound, tournamentRounds, false, tournamentDisplay["startRound"]);
                $(".tournament-bracket-container").html(bracketDiv).hide().fadeIn("fast");
            });
            $match.on("click", ".tournament-bracket-prev", function() {
                tournamentRound--;
                let bracket = tournamentDisplay["bracket"][tournamentRound];
                if (!bracket) {
                    tournamentRound++;
                    return false;
                }
                let bracketDiv = (0, $70adc4a1fd111893$export$d1c14a92b2f32dc8)(bracket, tournamentRound, tournamentRounds, false, tournamentDisplay["startRound"]);
                $(".tournament-bracket-container").html(bracketDiv).hide().fadeIn("fast");
            });
        }
    }
    // Cash in (during match)
    $("#match").off("click", "#championship-contract-cashin");
    $("#match").on("click", "#championship-contract-cashin", async function() {
        let matchUid = parseInt($(this).attr("data-match-uid"));
        let cashinTime = $(this).prev().val();
        let challengerUid = $(this).siblings('select[name="cashin-championships"]').val();
        await (0, $1JSre.makeGameRequest)((0, $kZwpB.addCashinToMatch), {
            challengerUid: challengerUid,
            cashinTime: cashinTime,
            matchUid: matchUid
        }, showAddCashinToMatchData, {
            cashinTime: cashinTime,
            challengerUid: challengerUid
        }, false);
    });
    function showAddCashinToMatchData({ data: data, cashinTime: cashinTime } = {}) {
        if (cashinTime === "0") {
            $(".notie-textbox-inner").text("");
            if (data["error"]) {
                if (data["error"] === "no-women-allowed") notie.alert({
                    type: 3,
                    text: "Women are not allowed to be booked at this event"
                });
                if (data["error"] === "no-men-allowed") notie.alert({
                    type: 3,
                    text: "Men are not allowed to be booked at this event"
                });
                if (data["error"] === "challenger-not-found") notie.alert({
                    type: 3,
                    text: "The challenger could not be found"
                });
                if (data["error"] === "challenger-in-match") notie.alert({
                    type: 3,
                    text: "The challenger is already present in the match"
                });
                return false;
            }
            // Add challenger to match participants
            let span = '<div class="match-wrestler-container"><button class="match-wrestler match-span" data-name="' + data["challenger"]["name"].replace(/"/g, "&quot;") + '">' + (0, $67cc16607ee33ebf$export$bc6829a93fbd1f8a)(data["challenger"]) + "</button></div>";
            if ($match.children(".match-wrestler-container").length > 4) $match.find(".match-wrestler-container").last().after(span);
            else $match.find(".match-wrestler-container").last().after('<span class="match-span">vs</span>' + span);
            match["participants"].push(data["challenger"]);
            // Show cash in text
            let cashinText;
            if (data["challenger"]["pronoun"] !== "they") cashinText = "{0} is cashing in {1}!".format(data["challenger"]["name"], data["championshipContract"]);
            else cashinText = "{0} are cashing in {1}!".format(data["challenger"]["name"], data["championshipContract"]);
            $("#match-info").append("<span class='font-bold display-block margin-bottom-5'>" + cashinText + "</span>");
            // Set cash in checks
            cashinData["cashinSinglesAvailable"] = data["cashinSinglesAvailable"];
            cashinData["cashinTagAvailable"] = data["cashinTagAvailable"];
            cashinData["cashinTriosAvailable"] = data["cashinTriosAvailable"];
            // Show holy shit text
            let text = "<span class='display-block'>HOLY SHIT! The fans are going crazy for the cash-in! You've been awarded <span class='blue margin-left-2 margin-right-3'><img alt='Points' src='static/www/static/cp_icon.png' class='points-image-small'/> 30</span></span>";
            notie.alert({
                type: 4,
                text: text,
                stay: true,
                append: true
            });
            // Refresh graphics
            match["graphics"] = data["graphics"];
            stageLayers = (0, $c82cd471f4baff6b$export$aebc172523823760)(match);
            $("#match-graphics").hide().fadeIn();
            if (data["unreadMessages"]) {
                let unreadMessages = data["unreadMessages"].toLocaleString("en");
                $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
                $(".messages-number").text(unreadMessages);
                $("#messages").hide().fadeIn("fast");
            }
            // Update points and fans
            (0, $1JSre.updateGamePointsAndFans)(data["points"], data["fans"]);
            // Remove box
            $(".championship-contract-cashin-box").remove();
        } else if (cashinTime === "1") {
            if (data["error"]) {
                if (data["error"] === "no-women-allowed") notie.alert({
                    type: 3,
                    text: "Women are not allowed to be booked at this event"
                });
                if (data["error"] === "no-men-allowed") notie.alert({
                    type: 3,
                    text: "Men are not allowed to be booked at this event"
                });
                if (data["error"] === "challenger-not-found") notie.alert({
                    type: 3,
                    text: "The challenger could not be found"
                });
                if (data["error"] === "challenger-in-match") notie.alert({
                    type: 3,
                    text: "The challenger is already present in the match"
                });
                return false;
            }
            $("#match-info").attr("data-cashin-challenger", data["challenger"]["name"]);
            $(".championship-contract-cashin-box").html('<span class="font-bold">Cash-in added!</span>');
        }
    }
    // Show information handler
    let timer;
    $match.off("mouseenter", ".match-wrestler");
    $match.on({
        mouseenter: function() {
            let $this = $(this);
            timer = setTimeout(function() {
                let selectedName = $this.attr("data-name");
                let member = match["participants"].filter(function(obj) {
                    return obj.name === selectedName;
                })[0];
                if (member) {
                    if ($this.attr("data-type") === "tagTeam") (0, $f18c00e15af0c7db$export$b73c16b811178760)(member, true);
                    else (0, $f18c00e15af0c7db$export$8d1c45aa228e7350)(member, true);
                }
            }, 70);
        },
        mouseleave: function() {
            clearTimeout(timer);
        }
    }, ".match-wrestler");
    // Get match finishes
    $(document).off("click", ".show-match-finishes-button");
    $(document).on("click", ".show-match-finishes-button", async function() {
        if ($(this).text() === "Add Finish") {
            await $5fab2de231db267f$var$getMatchFinishes(match["uid"]);
            $(this).text("Remove Finish");
        } else {
            $(".match-finishes-container").fadeOut();
            $(this).text("Add Finish");
        }
    });
    // Simulate handler
    $match.off("click", "#simulate-match");
    $match.on("click", "#simulate-match", async function() {
        if ($match.data("played")) return;
        let uid = parseInt($(this).attr("data-match-uid"));
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.simulateMatchWinnerRequest), {
            uid: uid
        }, showSimulateMatchWinnerData, {}, false);
        async function showSimulateMatchWinnerData({ data: data } = {}) {
            if (!data["error"]) {
                let winnerNameFormatted = data["winnerName"].replace(/([ #;&,.+*~':"!^$[\]()=>|\/@])/g, "\\$1");
                let winnerDiv = $('#match .match-wrestler[data-name="' + winnerNameFormatted + '"]');
                if (!winnerDiv.length) {
                    winnerDiv = $((0, $3E8Nt.getRandomChoice)($("#match .match-wrestler")));
                    if (typeof window.Sentry !== "undefined") Sentry.captureMessage("Simulate Match: " + winnerNameFormatted + " not found");
                }
                await matchWinnerClick(winnerDiv, true);
            } else if (data["error"] === "match-not-found") notie.alert({
                type: 3,
                text: "Match not found. Please try again or select a Participant.",
                stay: true
            });
        }
    });
    // Winner click handler
    $(document).off("click", "#match .match-wrestler");
    $(document).on({
        click: async function() {
            await matchWinnerClick($(this));
        }
    }, "#match .match-wrestler");
    async function matchWinnerClick(element, simulate) {
        if (element.hasClass("match-wrestler")) {
            if ($match.data("played")) return;
            if (element.hasClass("disabled") && !simulate) {
                notie.alert({
                    type: 4,
                    text: "You cannot select winners at The Grand Invitational"
                });
                return;
            }
            // Get winner name
            let winnerName = element.attr("data-name");
            // After match cash in check
            cashinData["challengerName"] = "";
            let attrChallenger = $("#match-info").attr("data-cashin-challenger");
            if (typeof attrChallenger !== "undefined" && attrChallenger !== false) {
                cashinData["challengerName"] = attrChallenger;
                $("#match-info").removeAttr("data-cashin-challenger");
            }
            if (match["uid"] === undefined || match["uid"] === null) {
                if (typeof window.Sentry !== "undefined") Sentry.captureMessage(match);
            }
            // Get match finish data
            let matchFinishData = {};
            if ($(".match-finishes-container").is(":visible")) {
                matchFinishData["name"] = $(".match-finishes-item-container.selected").data("name");
                // Get data for interfering roster member
                if ($(".match-finishes-interfering-member-select").is(":visible")) {
                    let matchFinishRosterMemberOption = $(".match-finishes-interfering-member-select select").find(":selected");
                    matchFinishData["interferingMemberUid"] = matchFinishRosterMemberOption.data("uid");
                    matchFinishData["interferingMemberType"] = matchFinishRosterMemberOption.data("type");
                }
            }
            await (0, $1JSre.makeGameRequest)((0, $6RCLU.playMatch), {
                winnerName: winnerName,
                uid: match["uid"],
                type: match["type"],
                cashinData: cashinData,
                matchFinishData: matchFinishData,
                graphics: match["graphics"]
            }, $5fab2de231db267f$var$showPlayMatchData, {
                match: match,
                winnerName: winnerName,
                cashinData: cashinData,
                tournamentDisplay: tournamentDisplay,
                matchesAndSegmentsData: matchesAndSegmentsData,
                index: index,
                stageLayers: stageLayers,
                largeTag: largeTag
            }, false);
        }
    }
}
function $5fab2de231db267f$var$getMatchGimmickText(matchGimmick) {
    // Show generated objects
    if (matchGimmick["generated"]["objectToClaim"] || matchGimmick["generated"]["location"]) {
        if (matchGimmick["generated"]["objectToClaim"]) return "<span>" + matchGimmick["generated"]["objectToClaim"] + " on a Pole" + "</span>";
        else if (matchGimmick["generated"]["location"]) return "<span>" + matchGimmick["generated"]["location"] + " Brawl" + "</span>";
    } else return "<span>" + matchGimmick["gimmick"] + "</span>";
}
async function $5fab2de231db267f$var$getMatchFinishes(uid) {
    // Add match finishes container
    $(".match-finishes-container").remove();
    let matchFinishesContainer = '<div class="match-finishes-container box font-bold margin-sides-auto     margin-top-20 dark-grey text-left display-none">    <div class="margin-bottom-15">       <div class="match-finish-color">Match Finishes</div>    </div>        <div class="match-finishes-items-container"></div></div>';
    $(".match-buttons-container").after(matchFinishesContainer);
    await (0, $1JSre.makeGameRequest)((0, $6RCLU.getAvailableMatchFinishes), {
        uid: uid
    }, $5fab2de231db267f$var$showGetAvailableMatchFinishesData, {
        uid: uid
    }, false);
}
function $5fab2de231db267f$export$2fe3faa2f51b0444(data) {
    let tournamentInjuryHtml = "";
    let tournamentNameText = '<span class="cyan">' + data["tournamentName"] + " Tournament" + "</span>";
    if (data["type"] === "elimination") {
        if (data["replacement"]) tournamentInjuryHtml = "Due to {0}'s injury, {1} was replaced by {2} in the next round of the {3}".format(data["injured"], data["injuredPronoun"], data["participantGoingThrough"], tournamentNameText);
        else tournamentInjuryHtml = "Due to {0}'s injury, {1} progressed to the next round of the {2}".format(data["injured"], data["participantGoingThrough"], tournamentNameText);
    } else if (data["type"] === "round-robin") tournamentInjuryHtml = "{0} decided to fight through the injury and finish the {1}!".format(data["injured"], tournamentNameText);
    return tournamentInjuryHtml;
}
function $5fab2de231db267f$var$getMatchParticipantClasses(superstar) {
    let classes = "";
    if (superstar["champion"] || superstar["championships"].length > 0) classes += "champion ";
    if (superstar["partTimer"]) classes += "part-timer ";
    if (superstar["unhappy"]) classes += "unhappy ";
    if ((0, $98xmD.globals).game.annualTournamentRunning) classes += " disabled";
    return classes;
}
function $5fab2de231db267f$var$showMatchInfoText(match, matchesAndSegmentsData, index, cashin, challenger, championshipContract) {
    const $matchInfoSelector = $("#match-info");
    // Main event indication
    if (index === matchesAndSegmentsData.length - 1) {
        let mainEventHtml = '<span class="light-grey font-0p925em">Main Event</span>';
        $matchInfoSelector.append("<span class='font-bold display-block margin-bottom-2'>" + mainEventHtml + "</span>");
    }
    // Add championship
    if (match["championships"].length > 0) {
        let championshipText = (0, $1JSre.getChampionshipsDisplayName)(match["championships"]);
        $matchInfoSelector.append("<span class='font-bold display-block gold margin-bottom-3'>" + championshipText + "</span>");
    }
    // Show feud names and consequences
    let feudsHtmlArray = [];
    match["feuds"].forEach(function(feud) {
        let feudConsequenceHtml = "";
        if (feud["runBlowoff"] && feud["consequence"]) feudConsequenceHtml = " ({0})".format((0, $3E8Nt.toTitleCase)(feud["consequence"].replace(/-/g, " ")));
        feudsHtmlArray.push("<span class='help-text' title='" + feud["participants"].join(" vs ").replace(/'/g, "&#39;") + "'>" + feud["name"] + feudConsequenceHtml + "</span>");
    });
    if (feudsHtmlArray.length > 0) $matchInfoSelector.append("<span class='font-bold display-block margin-bottom-3 faded-red-light'>" + (0, $3E8Nt.commaSeparate)(feudsHtmlArray, "&") + "</span>");
    // Show hype
    let matchHype = match["hype"];
    if (matchHype < 0) matchHype = "- " + matchHype * -1;
    else matchHype = "+ " + matchHype;
    $matchInfoSelector.append("<span class='font-bold display-block medium-dark-grey margin-bottom-3'>" + matchHype + " HYPE</span>");
    // Show bonuses
    let bonusesDivs = "";
    if (match["streakBonus"]) bonusesDivs += "<span class='font-bold display-block grey'>+ " + match["streakBonus"] + " Streak Bonus</span>";
    if (match["eventBonus"]) {
        let eventBonus = match["eventBonus"];
        if (eventBonus < 0) eventBonus = "- " + eventBonus * -1;
        else eventBonus = "+ " + eventBonus;
        bonusesDivs += "<span class='font-bold display-block grey'>" + eventBonus + " Match Effect Bonus</span>";
    }
    if (match["contractBonus"]) bonusesDivs += "<span class='font-bold display-block grey'>+ " + match["contractBonus"] + " Match Contract Bonus</span>";
    if (match["tournamentFinalBonus"]) bonusesDivs += "<span class='font-bold display-block grey'>+ " + match["tournamentFinalBonus"] + " Tournament Final Bonus</span>";
    if (bonusesDivs) $matchInfoSelector.append('<div class="margin-bottom-2 line-height-1p4">' + bonusesDivs + "</div>");
    // Add tournament information
    if (match["tournamentName"]) $matchInfoSelector.append("<span class='font-bold display-block dark-grey'>" + match["tournamentName"] + " " + match["tournamentRoundName"] + "</span>");
    // Show gimmick text
    $5fab2de231db267f$var$showMatchGimmickText(match);
    // Show cash in text if match is a weekly show cash in
    if (cashin) {
        let cashinText;
        if (match["type"] === "singles") cashinText = "{0} is cashing in {1}!".format(challenger, championshipContract);
        else cashinText = "{0} are cashing in {1}!".format(challenger, championshipContract);
        $matchInfoSelector.append("<span class='font-bold display-block grey'>" + cashinText + "</span>");
        let text = "<span class='display-block'>HOLY SHIT! The fans are going crazy for the cash-in! You've been awarded <span class='blue margin-left-2 margin-right-3'><img alt='Points' src='static/www/static/cp_icon.png' class='points-image-small margin-right-5'/>30</span></span>";
        notie.alert({
            type: 4,
            text: text,
            stay: true,
            prepend: true
        });
    }
}
function $5fab2de231db267f$var$showMatchGimmickText(match) {
    let matchTypeText;
    // Match type
    switch(match["participants"].length){
        case 2:
            matchTypeText = "";
            break;
        case 3:
            matchTypeText = "Triple Threat";
            break;
        case 4:
            matchTypeText = "Fatal 4 Way";
            break;
        case 5:
            matchTypeText = "5 Way";
            break;
        case 6:
            matchTypeText = "6 Way";
            break;
        case 7:
            matchTypeText = "7 Way";
            break;
        case 8:
            matchTypeText = "8 Way";
            break;
        case 9:
            matchTypeText = "9 Way";
            break;
        case 10:
            matchTypeText = "10 Way";
            break;
        default:
            matchTypeText = "";
    }
    // Tag text
    let tagText = "";
    if (match["type"] === "tag") {
        if (match["teamType"] === "trio") tagText = " Trio ";
        else tagText = " Tag ";
    }
    // Singles tag text
    let singlesTagText = "";
    if (match["largerTag"] && match["teamType"] !== "trio") singlesTagText = match["largerTag"] + "v" + match["largerTag"];
    if (match["handicapSize"]) singlesTagText = "{0}v{1} ".format(match["handicapSize"][0], match["handicapSize"][1]);
    // Show gimmick match text
    if (match["gimmick"]) {
        let gimmickMatchText = $5fab2de231db267f$var$getMatchGimmickText(match);
        let refereeText = "";
        if (match["refereeName"]) refereeText = " w/ " + match["refereeName"];
        $("#match-info").append("<span class='font-bold display-block grey match-gimmick-text'>" + matchTypeText + " " + singlesTagText + tagText + gimmickMatchText + " Match" + refereeText + "</span>");
    } else if (match["generated"]["objectToClaim"] || match["generated"]["location"]) $("#match-info").append("<span class='font-bold display-block grey'>" + matchTypeText + " " + singlesTagText + tagText + " Match</span>");
}
function $5fab2de231db267f$var$setDeceleratingTimeout(callback, factor, times) {
    let internalCallback = function(tick, counter) {
        return function() {
            if (--tick >= 0) {
                window.setTimeout(internalCallback, ++counter * factor);
                callback(times);
            }
        };
    }(times, 0);
    window.setTimeout(internalCallback, factor);
}
function $5fab2de231db267f$var$showMatchParticipantsText(match) {
    let largeTag = false;
    // Create x vs x vs x ... elements
    let participantElements = [];
    if (match["participants"].length > 10) {
        $("#match").css("text-align", "left");
        match["participants"].forEach(function(participant) {
            let classes = $5fab2de231db267f$var$getMatchParticipantClasses(participant);
            let dataType = "";
            if (match["type"] === "tag") dataType = "tagTeam";
            participantElements.push('<div class="match-wrestler-container-battle-royal"><div class="match-wrestler match-span-small ' + classes + '" data-type="' + dataType + '"' + ' data-name="' + participant["name"].replace(/"/g, "&quot;") + '" tabindex="0">' + participant["name"] + "</div></div>");
        });
    } else {
        $("#match").css("text-align", "center");
        if (match["largerTag"] && match["teamType"] !== "trio") {
            largeTag = true;
            match["participants"].forEach(function(participant) {
                let classes = $5fab2de231db267f$var$getMatchParticipantClasses(participant);
                let dataType = "";
                if (match["type"] === "tag") dataType = "tagTeam";
                let matchWrestlerText = (0, $67cc16607ee33ebf$export$bc6829a93fbd1f8a)(participant);
                participantElements.push('<div class="match-wrestler-container"><button type="button" class="match-wrestler match-span-large-tag ' + classes + '" data-type="' + dataType + '"' + ' data-name="' + participant["name"].replace(/"/g, "&quot;") + '">' + matchWrestlerText + "</button></div>");
            });
        } else match["participants"].forEach(function(participant) {
            let classes = $5fab2de231db267f$var$getMatchParticipantClasses(participant);
            let dataType = "";
            if (match["type"] === "tag") dataType = "tagTeam";
            let matchWrestlerText = (0, $67cc16607ee33ebf$export$bc6829a93fbd1f8a)(participant);
            participantElements.push('<div class="match-wrestler-container"><button type="button" class="match-wrestler match-span ' + classes + '" data-type="' + dataType + '"' + ' data-name="' + participant["name"].replace(/"/g, "&quot;") + '">' + matchWrestlerText + "</button></div>");
        });
    }
    // Add match text
    let matchText;
    if (match["participants"].length > 4) matchText = participantElements.join("");
    else if (match["largerTag"] && match["teamType"] !== "trio") matchText = participantElements.join('<span class="match-span match-vs-small">vs</span>');
    else matchText = participantElements.join('<span class="match-span dark-grey margin-top-2">vs</span>');
    $("#match").html(matchText).show();
    return largeTag;
}
function $5fab2de231db267f$var$showGetAvailableMatchFinishesData({ data: data, uid: uid } = {}) {
    if (!data["error"]) {
        // Show match finishes container
        $(".match-finishes-container").fadeIn();
        // Add match finish items
        let matchFinishItemsHtml = "";
        let dustyMatchFinishes = "";
        let otherMatchFinishes = "";
        let specialMatchFinishes = "";
        data["matchFinishes"].forEach(function(matchFinish) {
            if (matchFinish["category"] === "dusty") dustyMatchFinishes += $5fab2de231db267f$var$getMatchFinishItemHtml(matchFinish);
            else if (matchFinish["category"] === "other") otherMatchFinishes += $5fab2de231db267f$var$getMatchFinishItemHtml(matchFinish);
            else if (matchFinish["category"] === "special") specialMatchFinishes += $5fab2de231db267f$var$getMatchFinishItemHtml(matchFinish);
        });
        matchFinishItemsHtml += '<div class="match-finishes-category-container"><div class="display-block margin-bottom-5 match-finishes-label">    <span class="light-grey margin-left-2">Dusty</span></div>' + dustyMatchFinishes + "</div>" + '<div class="match-finishes-category-container">' + '<div class="display-block margin-bottom-5 margin-top-10 match-finishes-label">' + '    <span class="light-grey margin-left-2">Other</span>' + "</div>" + otherMatchFinishes + "</div>" + '<div class="match-finishes-category-container">' + '<div class="display-block margin-bottom-5 margin-top-10 match-finishes-label">' + '    <span class="light-grey margin-left-2">Special</span>' + "</div>" + specialMatchFinishes + "</div>";
        // Show match finish items
        $(".match-finishes-items-container").scrollTop(0);
        $(".match-finishes-items-container").html(matchFinishItemsHtml);
        // Select Match Finish
        $(document).off("click", ".match-finishes-item-container");
        $(document).on("click", ".match-finishes-item-container", async function() {
            (0, $lCS03.playSoundEffect)("success");
            // Hide other items and information
            $(".match-finish-item-information").hide();
            $(".match-finishes-item-container").hide();
            $(".match-finishes-interfering-member-select").remove();
            let $this = $(this);
            if ($this.hasClass("selected")) {
                // Deselect this item
                $this.removeClass("selected");
                // Show labels
                $(".match-finishes-label").show();
                // Show other items
                $(".match-finishes-item-container").promise().done(function() {
                    $(".match-finishes-item-container").hide().fadeIn();
                });
            } else {
                // Select this option
                $this.addClass("selected");
                // Hide labels
                $(".match-finishes-label").hide();
                // Show this option
                $this.find(".match-finish-item-information").show();
                $(".match-finishes-item-container").promise().done(async function() {
                    $this.fadeIn("fast");
                    $(".match-finishes-items-container").scrollTop(0);
                    // Show roster member select if applicable
                    if ($this.data("get-roster-members")) await (0, $1JSre.makeGameRequest)((0, $6RCLU.getRosterMembersForInterference), {
                        uid: uid
                    }, $5fab2de231db267f$var$showGetRosterMembersForInterferenceData, {}, false, true);
                });
            }
            // Tutorial action check
            (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_match_finish_item");
        });
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_add_finish_button");
    } else if (data["error"] === "match-not-found") notie.alert({
        type: 3,
        text: "Match not found. Please try again.",
        stay: true
    });
}
function $5fab2de231db267f$var$getMatchFinishPenaltyHelpText(name) {
    switch(name){
        case "Indecisive Blowoff":
            return "Using a finish that is not clean adds a penalty to Feud Blowoffs.";
        case "Problematic Finish":
            return "Using a finish that is not clean adds a penalty to Gimmick Matches.";
        case "Finish Already Held":
            return "Using a finish that is not clean and has already been held at the Event or in the Feud adds a penalty.";
        default:
            return "Alternate Match finishes can add a penalty or boost to the Match's rating.";
    }
}
function $5fab2de231db267f$var$getMatchFinishItemHtml(matchFinishItem) {
    // Get affect record
    let affectRecord;
    if (matchFinishItem["affectRecord"]) affectRecord = "<div>Record Affected</div>";
    else affectRecord = '<div class="light-grey">Record Not Affected</div>';
    // Get affect morale
    let affectMorale;
    if (matchFinishItem["affectMorale"]) affectMorale = "<div>Morale Affected</div>";
    else affectMorale = '<div class="light-grey">Morale Not Affected</div>';
    // Get title change
    let titleChanges;
    if (matchFinishItem["changeChampionship"]) titleChanges = "<div>Title Changes Hands</div>";
    else titleChanges = '<div class="light-grey">No Title Change</div>';
    // Get rating html
    let ratingPenalty;
    let ratingWord;
    let ratingIcon;
    if (matchFinishItem["ratingEffect"] < 0) {
        ratingPenalty = matchFinishItem["ratingEffect"] * -1;
        ratingWord = "Penalty";
        ratingIcon = '<i class="fa fa-angle-double-down margin-right-3 top-1px font-17px"></i>';
    } else {
        ratingPenalty = matchFinishItem["ratingEffect"];
        ratingWord = "Boost";
        ratingIcon = '<i class="fa fa-angle-double-up margin-right-3 top-1px font-17px"></i>';
    }
    let ratingHtml = $5fab2de231db267f$var$getMatchFinishItemRatingHtml(ratingPenalty);
    let ratingPenaltyHtml = "<div>" + ratingIcon + '<span class="margin-right-5 margin-left-3">' + ratingHtml + "</span>" + "Rating " + ratingWord + "</div>";
    // Get staleness effect
    let feudStaleness = '<div class="help-text" title="The amount this finish adds to a Feud\'s staleness. A normal match adds +1."><span class="margin-right-2 font-16px top-1px">+</span>' + matchFinishItem["feudStalenessEffect"] + " Feud Staleness" + "</div>";
    // Get win/loss multipliers
    let lossMultiplier;
    if (matchFinishItem["lossMultiplier"] >= 0) lossMultiplier = '<span class="dark-red margin-left-3">{0}<span class="margin-left-1">%</span> Loss</span>'.format(matchFinishItem["lossMultiplier"] * 100);
    else lossMultiplier = '<span class="green margin-left-3">{0}<span class="margin-left-1">%</span> Loss</span>'.format(matchFinishItem["lossMultiplier"] * -100);
    let winMultiplier = '<span class="green margin-right-3">{0}<span class="margin-left-1">%</span> Win</span>'.format(matchFinishItem["winMultiplier"] * 100);
    let winLossMultiplierHtml = '<div class="help-text" title="The percentage this finish reduces the win/loss Popularity and Overness changes to.">' + winMultiplier + lossMultiplier + "</div>";
    // Get requirements
    let requirementsHtml = "";
    if (matchFinishItem["requirements"]) {
        let formattedRequirements = Array.from(matchFinishItem["requirements"], function(x) {
            return (0, $3E8Nt.toTitleCase)(x.replace(/_/g, " "));
        });
        let requirementsText = formattedRequirements.join(", ");
        requirementsHtml = '<div class="sky-blue width-95 margin-top-10 line-height-1p4"><span>' + requirementsText + "</span>" + "</div>";
    }
    // Get consequences
    let consequencesHtml = "";
    if (matchFinishItem["consequences"]) {
        let formattedRequirements = Array.from(matchFinishItem["consequences"], function(x) {
            return (0, $3E8Nt.toTitleCase)(x.replace(/_/g, " "));
        });
        let consequencesText = formattedRequirements.join(", ");
        consequencesHtml = '<div class="faded-red-light width-95 margin-top-5 line-height-1p4"><span>' + consequencesText + "</span>" + "</div>";
    }
    let monthsToReuseHtml = "";
    if (matchFinishItem["monthsToReuse"]) {
        let monthsWord = (0, $3E8Nt.getMonthsWord)(matchFinishItem["monthsToReuse"]);
        let monthsToReuseText = "{0} {1} to re-use".format(matchFinishItem["monthsToReuse"], monthsWord);
        monthsToReuseHtml = '<div class="width-95 light-grey line-height-1p4 margin-top-5"><span>' + monthsToReuseText + "</span>" + "</div>";
    }
    // Get roster members attribute
    let getRosterMembers = "false";
    if (matchFinishItem["interference"]) getRosterMembers = "true";
    // Get unavailability, add class
    let unavailableClass = "";
    if (matchFinishItem["unavailable"]) unavailableClass = " unavailable";
    return '<div class="match-finishes-item-container' + unavailableClass + '" data-name="' + matchFinishItem["name"] + '" data-get-roster-members="' + getRosterMembers + '">' + matchFinishItem["name"] + '<span class="float-right blue">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/>' + matchFinishItem["cost"] + "</span>" + '<div class="match-finish-item-information display-none margin-top-8 margin-bottom-3 medium-grey">' + '<div class="medium-light-grey line-height-1p4 margin-bottom-10 width-95">' + matchFinishItem["description"] + "</div>" + '<div class="column-left">' + affectRecord + affectMorale + titleChanges + "</div>" + '<div class="column-right">' + ratingPenaltyHtml + feudStaleness + winLossMultiplierHtml + "</div>" + '<div class="clear"></div>' + requirementsHtml + consequencesHtml + monthsToReuseHtml + "</div>" + "</div>";
}
function $5fab2de231db267f$var$getMatchFinishItemRatingHtml(rating) {
    let ratingValue = rating;
    let ratingFloor = Math.floor(ratingValue);
    let decimalRating = ratingValue - ratingFloor;
    let ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
    if (decimalRating) {
        if (decimalRating === 0.75) decimalRating = 0.70;
        else if (decimalRating === 0.25) decimalRating = 0.35;
        ratingText += '<i class="star star-under fa fa-star"><i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' + "</i>";
    }
    return ratingText;
}
function $5fab2de231db267f$var$showGetRosterMembersForInterferenceData({ data: data } = {}) {
    if (!data["error"]) {
        let interferingMemberSelectHtml = "<option disabled selected value>Select Interfering Member</option>";
        // Add match managers if present
        if (data["matchManagers"].length > 0) {
            let matchManagersOptions = "";
            data["matchManagers"].forEach(function(matchManagers) {
                matchManagersOptions += '<option data-uid="' + matchManagers["uid"] + '" data-type="' + matchManagers["type"] + '">' + matchManagers["name"] + "</option>";
            });
            interferingMemberSelectHtml += '<optgroup label="Match Managers">' + matchManagersOptions + "</optgroup>";
        }
        // Add roster members
        let rosterMembersOptions = "";
        data["rosterMembers"].forEach(function(rosterMember) {
            rosterMembersOptions += '<option data-uid="' + rosterMember["uid"] + '" data-type="' + rosterMember["type"] + '">' + rosterMember["name"] + "</option>";
        });
        interferingMemberSelectHtml += '<optgroup label="Talent">' + rosterMembersOptions + "</optgroup>";
        let interferingMemberSelect = '<div class="match-finishes-interfering-member-select margin-top-5">    <select name="name">' + interferingMemberSelectHtml + "</select>" + "</div>";
        $(".match-finishes-container").append(interferingMemberSelect);
    } else if (data["error"] === "match-not-found") notie.alert({
        type: 3,
        text: "Match not found. Please try again.",
        stay: true
    });
}
function $5fab2de231db267f$var$showPlayMatchData({ data: data, match: match, winnerName: winnerName, cashinData: cashinData, tournamentDisplay: tournamentDisplay, matchesAndSegmentsData: matchesAndSegmentsData, index: index, stageLayers: stageLayers, largeTag: largeTag } = {}) {
    if (!data["error"]) {
        const $match = $("#match");
        // Mark match as played
        $match.data("played", true);
        // Update graphics if updated in data
        if (data["graphics"]) {
            match["graphics"] = data["graphics"];
            stageLayers = (0, $c82cd471f4baff6b$export$aebc172523823760)(match);
        }
        // Add losing layer, pop changes
        (0, $c82cd471f4baff6b$export$c085e4755974582e)(match, winnerName, stageLayers);
        $5fab2de231db267f$var$showMatchPopularityChanges(data, match, winnerName, largeTag);
        // Show match result
        $5fab2de231db267f$var$showMatchResult(data, match, cashinData["cashin"], cashinData["championshipContract"]);
        // Show updates
        $5fab2de231db267f$var$showMatchUpdates(data, match);
        (0, $67cc16607ee33ebf$export$45a344294533d7c2)();
        (0, $67cc16607ee33ebf$export$32c25d7dd1621e23)();
        (0, $1JSre.updateGamePointsAndFans)(data["points"], data["fans"]);
        // Reset gimmick match background
        $match.css({
            "background": "none"
        });
        // If after match cash in, add new match to matches array
        if (data["createdMatch"]) matchesAndSegmentsData.splice(index + 1, 0, data["createdMatch"]);
        // Increase index
        index++;
        // If new matches added (for tournament), add to matches variable
        if (data["matches"]) {
            matchesAndSegmentsData = data["matches"];
            index = 0; // Reset match counter, as data contains matches not held
        }
        // Update tournamentDisplay
        if (data["tournamentDisplay"]) tournamentDisplay = data["tournamentDisplay"];
        // Update cashin data
        if (data["challenger"]) {
            cashinData["challenger"] = data["challenger"];
            cashinData["championshipContract"] = data["championshipContract"];
            cashinData["cashin"] = true;
        } else {
            cashinData["challenger"] = "";
            cashinData["championshipContract"] = "";
            cashinData["cashin"] = "";
        }
        // Show 'continue' button, hide simulate and show finishes buttons, cash in box
        $(".match-superstar-information").before('<button type="button" class="button retro-button margin-top-15 margin-sides-auto display-block grey-button-background" id="progress-segment-button">Continue</button>');
        $("#simulate-match").hide();
        $(".show-match-finishes-button").hide();
        $(".match-finishes-container").hide();
        $(".championship-contract-cashin-box").remove();
        $("#championship-contract-cashin-show").remove();
        // Progress match handler
        $match.off("click", "#progress-segment-button");
        $match.on("click", "#progress-segment-button", async function() {
            if ($(this).hasClass("disabled")) {
                notie.alert({
                    type: 4,
                    text: "Please finish the current action before proceeding"
                });
                return false;
            }
            await (0, $e6954d9b34d9dd89$export$6f7d6178afe1e87f)({
                data: {
                    "matchesAndSegmentsData": matchesAndSegmentsData,
                    "cashinData": cashinData,
                    "tournamentDisplay": tournamentDisplay
                },
                index: index
            });
            // Tutorial action check
            (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_match_continue");
        });
        // Show injury replacement dialog for annual tournament
        if (data["annualTournamentDialogData"]) {
            (0, $e37bb324c1adb297$export$1efa17883ef037ff)(data["annualTournamentDialogData"]);
            // Disable continue button
            $("#progress-segment-button").addClass("disabled");
        }
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_match_wrestler");
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_simulate_button");
    } else {
        let errorText;
        if (data["error"] === "team-members-not-found") errorText = "Team members could not be found for {0}. Try removing this Match.".format(data["teamName"]);
        else if (data["error"] === "indecisive-finish-gimmick-match") errorText = "Indecisive Finishes cannot be used in Gimmick Matches";
        else if (data["error"] === "indecisive-finish-tournament-final") errorText = "Indecisive Finishes cannot be used in Tournament Finals";
        else if (data["error"] === "draw-elimination-tournament") errorText = "Match Finishes that result in draws cannot be used in Elimination Tournaments";
        else if (data["error"] === "match-finish-points") errorText = "You do not have enough Creative Points to add this Match Finish";
        else if (data["error"] === "match-finish-reuse-not-available") {
            let monthsWord = (0, $3E8Nt.getMonthsWord)(data["monthsToReuse"]);
            errorText = "Special Finishes can only be used once every 6 months. This Finish can be re-used in {0} {1}.".format(data["monthsToReuse"], monthsWord);
        } else if (data["error"] === "manager-finish-paid") errorText = "Manager Finishes are only available in JoW Paid";
        else if (data["error"] === "requirement-fail") switch(data["requirement"]){
            case "face_vs_heel":
                errorText = "One Participant needs to have 'Face' Alignment and the other needs to have 'Heel' Alignment";
                break;
            case "face_winner":
                errorText = "The participant with 'Face' Alignment needs to win the Match";
                break;
            case "heel_loser":
                errorText = "The participant with 'Heel' Alignment needs to lose the Match";
                break;
            case "hot_feud":
                errorText = "This Match needs to contain a Feud that is 'Hot'";
                break;
            case "title_match":
                errorText = "A Championship needs to be contested in this Match";
                break;
            case "main_event":
                errorText = "This Match needs to be the last Match on the show";
                break;
            case "loser_has_manager":
                errorText = "The loser needs to have a manager assigned to them";
                break;
            case "winner_has_no_manager":
                errorText = "The winner cannot have a Manager assigned or be a Full-time Manager";
                break;
            case "one-on-one-match":
                errorText = "This Match Finish only be used in one on one Matches";
                break;
            case "level_2_producer":
                errorText = "You need to have a Level 2 Producer available on your Staff";
                break;
            case "level_3_producer":
                errorText = "You need to have a Level 3 Producer available on your Staff";
                break;
            default:
                errorText = "This Match doesn't fulfill the requirements for this Match Finish";
        }
        else errorText = "There was an error playing this Match";
        notie.alert({
            type: 3,
            text: errorText
        });
    }
}
function $5fab2de231db267f$var$showMatchResult(data, match, cashin, championshipContract) {
    let eventResultsSelector = $("#event-match-results");
    let matchResultHtml = $5fab2de231db267f$var$getMatchResultHtml(data, cashin, championshipContract, match);
    eventResultsSelector.find(".empty-event-match-results-text").remove();
    eventResultsSelector.find(".event-results-header").after('<div class="margin-bottom-20 match-result" tabindex="0">' + matchResultHtml + "</div>");
}
function $5fab2de231db267f$var$getMatchResultHtml(data, cashin, championshipContract, match) {
    // Load match result settings
    let matchResultSetting = (0, $98xmD.globalUser).settings["matchResult"];
    let XPClass = "match-result-xp";
    let overnessClass = "match-result-overness";
    let popularityClass = "match-result-popularity";
    let feudsClass = "match-result-feuds";
    let gimmickEffectivenessClass = "match-result-gimmick-effectiveness";
    let moraleClass = "match-result-morale";
    let fatigueClass = "match-result-fatigue";
    if (matchResultSetting) {
        if (!matchResultSetting.xp) XPClass += " display-none";
        if (!matchResultSetting.overness) overnessClass += " display-none";
        if (!matchResultSetting.popularity) popularityClass += " display-none";
        if (!matchResultSetting.gimmickEffectiveness) gimmickEffectivenessClass += " display-none";
        if (!matchResultSetting.feuds) feudsClass += " display-none";
        if (matchResultSetting.morale === false) moraleClass += " display-none";
        if (!matchResultSetting.fatigue) fatigueClass += " display-none";
    } else {
        XPClass += " display-none";
        gimmickEffectivenessClass += " display-none";
        fatigueClass += " display-none";
    }
    // Get winner data
    let gimmickEffectivenessChange = "";
    if (data["winner"]["gimmickEffectivenessChange"]) {
        let prefix = "+ ";
        if (data["winner"]["gimmickEffectivenessChange"] < 0) {
            prefix = "- ";
            data["winner"]["gimmickEffectivenessChange"] *= -1;
        }
        gimmickEffectivenessChange = '<span class="character-label margin-left-8 ' + gimmickEffectivenessClass + ' help-text" title="Gimmick Overness Change">' + prefix + data["winner"]["gimmickEffectivenessChange"] + '<span class="margin-left-2">%</span></span>';
    }
    let overnessChange = "";
    let winnerOvernessChange = data["winner"]["overnessChange"];
    if (winnerOvernessChange) {
        let prefix = "+ ";
        if (winnerOvernessChange < 0) {
            prefix = "- ";
            winnerOvernessChange *= -1;
            overnessChange = '<span class="stale-color margin-left-8 ' + overnessClass + ' help-text" title="Overness Change">' + prefix + winnerOvernessChange + '<span class="margin-left-2">%</span></span>';
        } else overnessChange = '<span class="hot-color margin-left-8 ' + overnessClass + ' help-text" title="Overness Change">' + prefix + winnerOvernessChange + '<span class="margin-left-2">%</span></span>';
    }
    let hotOrStaleIcon = "";
    if (data["winner"]["hot"]) hotOrStaleIcon = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass + '" title="Being Over boosts ' + " a Superstar's Workrate, Popularity changes and Gimmick Effectiveness changes in Matches.\">";
    else if (data["winner"]["stale"]) hotOrStaleIcon = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass + '" title="Being Stale' + " lowers the ratings of a Superstar's Segments and their Popularity gains.\">";
    // Morale change
    let moraleChange = "";
    let winnerMoraleChange = data["winner"]["moraleChange"];
    if (winnerMoraleChange) {
        let prefix = "+ ";
        if (winnerMoraleChange < 0) {
            prefix = "- ";
            winnerMoraleChange *= -1;
            moraleChange = '<span class="margin-left-8 morale-dissatisfied-color ' + moraleClass + ' help-text" title="Morale Change">' + prefix + winnerMoraleChange + '<span class="margin-left-2">%</span></span>';
        } else moraleChange = '<span class="margin-left-8 light-green ' + moraleClass + ' help-text" title="Morale Change">' + prefix + winnerMoraleChange + '<span class="margin-left-2">%</span></span>';
    }
    // XP gained
    let xpGained = '<span class="workrate-blue ' + XPClass + ' margin-left-8 help-text" title="XP Change">+ ' + data["winner"]["xpGained"] + " XP</span>";
    // Fatigue change
    let fatigueChange = "";
    if (data["winner"]["fatigueChange"] !== undefined) fatigueChange = '<span class="fatigue-yellow ' + fatigueClass + ' margin-left-8 help-text" title="Fatigue Change">+ ' + data["winner"]["fatigueChange"] + '<span class="margin-left-2">%</span>' + "</span>";
    // Popularity change
    let icon = "fa-angle-double-up";
    if (data["winner"]["popularityChange"] < 0) {
        icon = "fa-angle-double-down";
        data["winner"]["popularityChange"] *= -1;
    }
    let popColor = "medium-dark-grey";
    if (data["hotMatch"]) popColor = "hot-color";
    let popularityChange = '<span class="' + popularityClass + '">' + '<span class="margin-left-8 grey">' + data["winner"]["popularity"] + "</span>" + '<span class="' + popColor + ' margin-right-5 help-text" title="Popularity Change">' + '<i class="fa ' + icon + ' margin-left-8 margin-right-5"></i>' + data["winner"]["popularityChange"] + "</span>" + "</span>";
    // Managers
    let managersHtml = (0, $67cc16607ee33ebf$export$c79dd895db6e3598)(data["winner"]["managersData"], "match");
    let winner = data["winner"]["name"] + hotOrStaleIcon + xpGained + gimmickEffectivenessChange + overnessChange + moraleChange + fatigueChange + popularityChange + managersHtml;
    let winnerChampionshipText = "";
    let retainedChampionshipText = "";
    if (data["winner"]["wonChampionships"].length > 0 && data["winner"]["defendedChampionships"].length > 0) {
        winnerChampionshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold flash-text">' + (0, $1JSre.getChampionshipsDisplayName)(data["winner"]["wonChampionships"]) + "</span></span>";
        winnerChampionshipText += '<span class="margin-left-5">and retain the<span class="margin-left-5 gold">' + (0, $1JSre.getChampionshipsDisplayName)(data["winner"]["defendedChampionships"]) + "</span></span>";
    } else {
        if (data["winner"]["wonChampionships"].length > 0) {
            let championshipText = (0, $1JSre.getChampionshipsDisplayName)(data["winner"]["wonChampionships"]);
            winnerChampionshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold flash-text">' + championshipText + "</span></span>";
        } else if (data["winner"]["defendedChampionships"].length > 0) {
            let championshipText = (0, $1JSre.getChampionshipsDisplayName)(data["winner"]["defendedChampionships"]);
            winnerChampionshipText = '<span class="margin-left-5">to retain the<span class="margin-left-5 gold">' + championshipText + "</span></span>";
        } else if (data["winner"]["retainedChampionships"].length > 0) {
            let championshipText = (0, $1JSre.getChampionshipsDisplayName)(data["winner"]["retainedChampionships"]);
            retainedChampionshipText = '<span class="display-block margin-top-5"><span class="gold">' + championshipText + "</span> did not change hands</span>";
        }
    }
    let losers = [];
    let losersHtml = "";
    data["losers"].forEach(function(loser) {
        let decrease = loser["popularityChange"] * -1;
        let icon = "fa-angle-double-down";
        if (decrease >= 0) {
            icon = "fa-angle-double-up";
            loser["popularityChange"] *= -1;
            if (data["hotMatch"]) icon += " hot-label";
        }
        let gimmickEffectivenessChange = "";
        if (loser["gimmickEffectivenessChange"]) {
            let prefix = "+ ";
            if (loser["gimmickEffectivenessChange"] < 0) {
                prefix = "- ";
                loser["gimmickEffectivenessChange"] *= -1;
            }
            gimmickEffectivenessChange = '<span class="character-label margin-left-8 ' + gimmickEffectivenessClass + ' help-text" title="Gimmick Overness Change">' + prefix + loser["gimmickEffectivenessChange"] + '<span class="margin-left-2">%</span></span>';
        }
        let overnessChange = "";
        let loserOvernessChange = loser["overnessChange"];
        if (loserOvernessChange) {
            let prefix = "+ ";
            if (loserOvernessChange < 0) {
                prefix = "- ";
                loserOvernessChange *= -1;
                overnessChange = '<span class="stale-color ' + overnessClass + ' margin-left-8 help-text" title="Overness Change">' + prefix + loserOvernessChange + '<span class="margin-left-2">%</span></span>';
            } else overnessChange = '<span class="hot-color ' + overnessClass + ' margin-left-8 help-text" title="Overness Change">' + prefix + loserOvernessChange + '<span class="margin-left-2">%</span></span>';
        }
        let hotOrStaleIcon = "";
        if (loser["hot"]) hotOrStaleIcon = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass + '" title="Being Over boosts ' + " a Superstar's Workrate, Popularity changes and Gimmick Effectiveness changes in Matches.\">";
        else if (loser["stale"]) hotOrStaleIcon = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass + '" title="Being Stale' + " lowers the ratings of a Superstar's Segments and their Popularity gains.\">";
        // Morale change
        let moraleChange = "";
        let loserMoraleChange = loser["moraleChange"];
        if (loserMoraleChange) {
            let prefix = "+ ";
            if (loserMoraleChange < 0) {
                prefix = "- ";
                loserMoraleChange *= -1;
                moraleChange = '<span class="margin-left-8 morale-dissatisfied-color ' + moraleClass + ' help-text" title="Morale Change">' + prefix + loserMoraleChange + '<span class="margin-left-2">%</span></span>';
            } else moraleChange = '<span class="margin-left-8 light-green ' + moraleClass + ' help-text" title="Morale Change">' + prefix + loserMoraleChange + '<span class="margin-left-2">%</span></span>';
        }
        // Fatigue change
        let fatigueChange = "";
        if (loser["fatigueChange"] !== undefined) fatigueChange = '<span class="fatigue-yellow ' + fatigueClass + ' margin-left-8 help-text" title="Fatigue Change">+ ' + loser["fatigueChange"] + '<span class="margin-left-2">%</span>' + "</span>";
        // XP gained
        let xpGained = '<span class="workrate-blue ' + XPClass + ' margin-left-8 help-text" title="XP Change">+ ' + loser["xpGained"] + " XP</span>";
        let popularityChange = '<span class="' + popularityClass + '">' + '<span class="margin-left-8 grey">' + loser["popularity"] + "</span>" + '<span class="' + popColor + ' margin-right-5 help-text" title="Popularity Change">' + '<i class="fa ' + icon + ' margin-left-8 margin-right-5"></i>' + loser["popularityChange"] + "</span>" + "</span>";
        // Managers
        let managersHtml = (0, $67cc16607ee33ebf$export$c79dd895db6e3598)(loser["managersData"], "match");
        let loserArray = loser["name"] + hotOrStaleIcon + xpGained + gimmickEffectivenessChange + overnessChange + moraleChange + fatigueChange + popularityChange + managersHtml;
        losers.push(loserArray);
    });
    // Join losers with comma and 'and'
    if (losers.length > 1) losersHtml = losers.slice(0, -1).join(", ") + ' <span class="light-grey">and</span> ' + losers.slice(-1);
    else losersHtml = losers[0];
    // Match finish text
    let finishHtml = "";
    if (data["finishName"]) {
        let finishText = "";
        if (data["finishText"]) {
            finishText = '<span class="margin-left-5">by ' + data["finishText"] + "</span>";
            // Show popularity increase
            if (data["interferencePopularityIncrease"]) finishText += '<span class="help-text match-result-popularity" title="Popularity Change"><i class="fa fa-angle-double-up margin-left-8 margin-right-5"></i>' + data["interferencePopularityIncrease"] + "</span>";
            // Show feud hype increase
            data["interferenceFeuds"].forEach(function(interferenceFeud) {
                finishText += $5fab2de231db267f$var$getFeudHtml(interferenceFeud, "match-result-feuds");
            });
        }
        let noContestText = "";
        if (data["matchFinish"]["draw"]) noContestText = " No Contest ";
        finishHtml = '<span class="margin-left-5 light-grey">' + noContestText + 'via <span class="match-finish-color">' + data["finishName"] + "</span>" + finishText + "</span>";
    }
    let cashinText = "";
    if (cashin) cashinText = " (" + championshipContract + " Cash In) ";
    let generatedText;
    if (data["generatedText"]) generatedText = '<span class="display-block generated-text">' + data["generatedText"] + "</span>";
    // Set rating
    let rating;
    let ratingText;
    if (data["rating"] !== null) {
        let ratingValue = data["rating"];
        let ratingFloor = Math.floor(ratingValue);
        let decimalRating = ratingValue - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) decimalRating = 0.70;
            else if (decimalRating === 0.25) decimalRating = 0.35;
            ratingText += '<i class="star star-under fa fa-star"><i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' + "</i>";
            if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
        } else if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
        // Set rating element
        rating = '<span class="display-block match-star-rating margin-bottom-10"><span class="dark-grey" role="text" aria-label="' + data["rating"] + " stars" + '">' + ratingText + "</span></span>";
    } else {
        ratingText = "No Rating";
        // Set rating element
        rating = '<span class="display-block margin-bottom-12"><span class="grey font-0p925em">' + ratingText + "</span></span>";
    }
    // Set Gimmick match text
    let text;
    let matchGimmick = data["matchGimmick"];
    if (matchGimmick) {
        // Show generated text
        if (data["generatedText"]) {
            if (match["rules"] === "battle_royal") text = "{0}{1} won the {2} match{3}{4}".format(generatedText, winner, matchGimmick, finishHtml, winnerChampionshipText);
            else if (matchGimmick === "Ironman") text = "{0} <span class='light-grey'>def.</span> {1}{2} with a score of {3}{4}".format(winner, losersHtml, finishHtml, data["generatedText"], winnerChampionshipText);
            else // 2/3 falls, elimination
            text = "{0}{1} <span class='light-grey'>def.</span> {2}{3}{4}{5}".format(generatedText, winner, losersHtml, finishHtml, winnerChampionshipText, cashinText);
        } else if (match["refereeName"]) {
            let refereeText = '<span class="medium-grey"> with Special Referee ' + match["refereeName"] + "</span>";
            text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}{4}".format(winner, losersHtml, finishHtml, winnerChampionshipText, refereeText);
        } else if (matchGimmick === "Steel Cage" || matchGimmick === "Graphene Cage") text = "{0} escaped the cage{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        else if (matchGimmick === "I Quit") text = "{0} made {1} say 'I Quit'{2}{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        else if (matchGimmick === "Street Fight") text = "{0} <span class='light-grey'>def.</span> {1}{2} in a violent street fight{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        else if (matchGimmick.includes("Ladder")) text = "{0} climbed the ladder{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        else if (matchGimmick === "Pu Ladder") text = "{0} climbed the plutonium ladder{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        else if (matchGimmick === "Pole") text = "{0} grabbed the {1} off the pole{2}, defeating {3}{4}".format(winner, match["generated"]["objectToClaim"], winnerChampionshipText, losersHtml, finishHtml);
        else if (matchGimmick === "Canyon Fight") text = "{0} <span class='light-grey'>def.</span> {1}{2} in a violent canyon fight{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        else if (matchGimmick === "Glacier Escape") text = "{0} escaped the glacier{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        else text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
    } else if (data["matchFinish"] && data["matchFinish"]["draw"]) text = "{0} <span class='light-grey'>vs</span> {1}{2}{3}{4}".format(winner, losersHtml, finishHtml, winnerChampionshipText, cashinText);
    else text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}{4}".format(winner, losersHtml, finishHtml, winnerChampionshipText, cashinText);
    // Feud Hypes
    let feudsHtml = "";
    data["feuds"].forEach(function(feud) {
        feudsHtml += $5fab2de231db267f$var$getFeudHtml(feud, feudsClass);
    });
    // Penalties/Boosts
    let boostHtml = "";
    if (data["ratingData"]["unhappySuperstarsPenalty"]) {
        let unhappyPenalty = data["ratingData"]["unhappySuperstarsPenalty"];
        let ratingHtml = '<i class="star star-under fa fa-star margin-left-5"><i class="star star-over fa fa-star dark-red" style="width: ' + unhappyPenalty * 100 + '%"></i>' + "</i>";
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Unhappy workers lower Match ratings."><span class="dark-red line-height-1p4"><i class="fa fa-angle-double-down margin-right-5"></i>Unhappy Worker' + ratingHtml + "</span></span>";
    }
    if (data["ratingData"]["workableInjuryPenalty"]) {
        let injuredPenalty = data["ratingData"]["workableInjuryPenalty"];
        let ratingHtml = (0, $1JSre.getStarRatingHtml)(injuredPenalty, "dark-red", injuredPenalty);
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Injured workers lower Match ratings."><span class="dark-red line-height-1p4"><i class="fa fa-angle-double-down margin-right-5"></i><span class="margin-right-5">Injured Worker</span>' + ratingHtml + "</span></span>";
    }
    if (data["ratingData"]["negativeBoostName"]) {
        let negativeBoost = data["ratingData"]["negativeBoostNumber"] * -1;
        let ratingHtml = '<i class="star star-under fa fa-star margin-left-5"><i class="star star-over fa fa-star dark-red" style="width: ' + negativeBoost * 100 + '%"></i>' + "</i>";
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Matches can sometimes get negative effects that lower their ratings."><span class="dark-red line-height-1p4"><i class="fa fa-angle-double-down margin-right-5"></i>' + data["ratingData"]["negativeBoostName"] + ratingHtml + "</span></span>";
    }
    if (data["ratingData"]["positiveBoostName"]) {
        let positiveBoost = data["ratingData"]["positiveBoostNumber"];
        let ratingHtml = '<i class="star star-under fa fa-star margin-left-5"><i class="star star-over fa fa-star green" style="width: ' + positiveBoost * 100 + '%"></i>' + "</i>";
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Matches can sometimes get positive effects that increase their ratings."><span class="green line-height-1p4"><i class="fa fa-angle-double-up margin-right-5"></i>' + data["ratingData"]["positiveBoostName"] + ratingHtml + "</span></span>";
    }
    if (data["ratingData"]["drewBloodBoost"]) {
        let drewBloodBoost = data["ratingData"]["drewBloodBoost"];
        if (drewBloodBoost === 0.75) drewBloodBoost = 0.70;
        else if (drewBloodBoost === 0.25) drewBloodBoost = 0.35;
        let ratingHtml = '<i class="star star-under fa fa-star margin-left-5"><i class="star star-over fa fa-star green" style="width: ' + drewBloodBoost * 100 + '%"></i>' + "</i>";
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Gimmick Matches have a small chance to draw blood, increasing a Match\'s Rating."><span class="green line-height-1p4"><i class="fa fa-angle-double-up margin-right-5"></i>Blood' + ratingHtml + "</span></span>";
    }
    // Match finish effect
    if (data["ratingData"]["matchFinishRatingData"]) data["ratingData"]["matchFinishRatingData"].forEach(function(ratingEffect) {
        let matchFinishRatingEffect;
        let matchFinishRatingClass;
        let matchFinishRatingIcon;
        if (ratingEffect["number"] < 0) {
            matchFinishRatingEffect = ratingEffect["number"] * -1;
            matchFinishRatingClass = "dark-red";
            matchFinishRatingIcon = '<i class="fa fa-angle-double-down margin-right-5"></i>';
        } else {
            matchFinishRatingEffect = ratingEffect["number"];
            matchFinishRatingClass = "green";
            matchFinishRatingIcon = '<i class="fa fa-angle-double-up margin-right-5"></i>';
        }
        if (matchFinishRatingEffect === 0.75) matchFinishRatingEffect = 0.70;
        else if (matchFinishRatingEffect === 0.25) matchFinishRatingEffect = 0.35;
        let finishPenaltyHelpText = $5fab2de231db267f$var$getMatchFinishPenaltyHelpText(ratingEffect["name"]);
        let matchFinishRatingName = '<span class="margin-right-5">' + ratingEffect["name"] + "</span>";
        let ratingHtml = (0, $1JSre.getStarRatingHtml)(matchFinishRatingEffect, matchFinishRatingClass, matchFinishRatingEffect);
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="' + finishPenaltyHelpText + '">' + '<span class="line-height-1p4 ' + matchFinishRatingClass + '">' + matchFinishRatingIcon + matchFinishRatingName + ratingHtml + "</span></span>";
    });
    return "<div class=col1>" + text + feudsHtml + retainedChampionshipText + "</div>" + '<div class="col2 text-right">' + rating + boostHtml + "</div>" + '<div class="clear"></div>';
}
function $5fab2de231db267f$var$getFeudHtml(feud, feudsClass) {
    let hypeChange;
    if (feud["hypeChange"] < 0) {
        feud["hypeChange"] *= -1;
        hypeChange = '<i class="fa fa-angle-double-down margin-left-8 margin-right-8"></i>' + feud["hypeChange"];
    } else hypeChange = '<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i>' + feud["hypeChange"];
    let feudName = feud["name"];
    if (feud["ended"]) feudName += ' <span class="bright-red">Blowoff</span>';
    let feudClass = "faded-red-light";
    if (feud["hot"]) feudClass = "hot-color";
    return '<span class="margin-left-8 ' + feudsClass + '">' + '<span class="faded-red-light">' + feudName + "</span>" + '<span class="' + feudClass + '">' + '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["hype"] + '<span class="faded-red">' + hypeChange + "</span>" + "</span>" + "</span>";
}
function $5fab2de231db267f$var$showMatchPopularityChanges(data, match, winnerName, largeTag) {
    // Show popularity changes next to wrestler's names
    $(".match-wrestler").each(function(index) {
        let wrestlerDiv = $(this);
        let wrestlerName = wrestlerDiv.attr("data-name");
        let singles = data["losers"].length === 1;
        // Losers
        if (!(wrestlerName === winnerName)) {
            $(this).addClass("opaque"); // Darken losers' names
            // Show loser's change if participants are 10 or less
            if (match["participants"].length <= 10) data["losers"].forEach(function(loser) {
                if (wrestlerName === loser["name"]) {
                    let decrease = loser["popularityChange"] * -1;
                    let color = "dark-red";
                    if (decrease >= 0) {
                        color = "green";
                        decrease = "+ " + decrease;
                    } else decrease = "- " + loser["popularityChange"];
                    // Show changes to the right and left if singles match
                    if (singles && !largeTag) {
                        if (index === 1) wrestlerDiv.parent().prepend('<div class="match-stat ' + color + '">  ' + decrease + "</div>");
                        else wrestlerDiv.parent().prepend('<div class="match-stat ' + color + '">  ' + decrease + "</div>");
                    } else if (largeTag) wrestlerDiv.parent().prepend('<div class="match-stat-large-tag ' + color + '">  ' + decrease + "</div>");
                    else wrestlerDiv.parent().prepend('<div class="match-stat ' + color + '">  ' + decrease + "</div>");
                }
            });
        } else // Show winner' changes if participants are 10  or less
        if (match["participants"].length <= 10) {
            let winner = data["winner"];
            let increase = winner["popularityChange"];
            let color = "green";
            if (increase < 0) {
                color = "dark-red";
                increase = "- " + winner["popularityChange"] * -1;
            } else increase = "+ " + increase;
            if (singles && !largeTag) {
                if (index === 1) $(this).parent().prepend('<div class="match-stat ' + color + '">' + increase + "</div>");
                else $(this).parent().prepend('<div class="match-stat ' + color + '">' + increase + "</div>");
            } else if (largeTag) $(this).parent().prepend('<div class="match-stat-large-tag ' + color + '">' + increase + "</div>");
            else $(this).parent().prepend('<div class="match-stat ' + color + '">' + increase + "</div>");
        }
    });
    // Show popularity change
    $("#match").find(".match-stat, .match-stat-large-tag").each(function() {
        $(this).hide().slideDown("slow");
    });
    // Find loser in tournament bracket
    if (match["tournamentRound"] && !match["tournamentGroup"]) // Check if right round selected in tournament bracket
    {
        if (parseInt($(".tournament-round-name").attr("data-round-number")) === match["tournamentRound"]) {
            let loserName;
            $("#match .match-wrestler").each(function(i, e) {
                if ($(e).attr("data-name") !== winnerName) {
                    loserName = $(e).attr("data-name");
                    return false;
                }
            });
            if (loserName) {
                // Add opaque class
                let loserTournamentElement = $('.tournament-participant-name[data-name="' + loserName.replace(/([ #;&,.+*~':"!^$[\]()=>|\/@])/g, "\\$1") + '"]');
                if (loserTournamentElement.length > 0) loserTournamentElement.parent().addClass("opaque");
            }
        }
    }
}
function $5fab2de231db267f$var$showMatchUpdates(data, match) {
    let prestigeResultsSelector = $("#prestige-results");
    let eventUpdatesSelector = $(".event-updates-other .updates-container");
    let eventUpdatesAvailabilitySelector = $(".event-updates-availability .updates-container");
    let eventUpdatesOvernessSelector = $(".event-updates-overness .updates-container");
    let eventUpdatesGimmicksSelector = $(".event-updates-gimmicks .updates-container");
    let eventUpdatesFeudsSelector = $(".event-updates-feuds .updates-container");
    // If holy shit text, show it
    let holyShitText;
    if (data["holyShitData"]) {
        let holyShitData = data["holyShitData"];
        let overnessIncrease = '<span class="hot-color margin-left-2 margin-right-3">' + holyShitData["overnessIncrease"] + '<span class="margin-left-2">%</span></span>';
        let pointsAwardedHtml = "";
        if (holyShitData["pointsGained"]) {
            let pointsGained = '<span class="blue margin-left-2 margin-right-3"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ' + holyShitData["pointsGained"] + "</span>";
            pointsAwardedHtml = "You've been awarded " + pointsGained + " and ";
        }
        holyShitText = '<span class="display-block generated-text"><span class="holy-shit-text">HOLY SHIT! </span>' + holyShitData["text"] + " The fans are going crazy. " + pointsAwardedHtml + holyShitData["superstarName"] + " gained an Overness boost of " + overnessIncrease + ".</span>";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12">' + holyShitText + "</span>");
        setTimeout(function() {
            $(".holy-shit-text").last().addClass("flash-text-grey");
        }, 200);
        setTimeout(function() {
            $(".holy-shit-text").last().removeClass("flash-text-grey");
        }, 2000);
    }
    // Blood
    if (data["bloodySuperstarsData"].length > 0) {
        let bloodySuperstarsNames = Array.from(data["bloodySuperstarsData"], function(s) {
            return s["name"];
        });
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + (0, $3E8Nt.commaSeparate)(bloodySuperstarsNames) + " bled in the match!" + "</span>");
    }
    // Feud blowoff results
    data["feuds"].forEach(function(feud) {
        if (feud["ended"]) {
            let participantNames = feud["participants"].join(" and ");
            let feudName = feud["name"];
            let rating = '<span class="display-inline-block margin-left-8 top--1px">' + (0, $1JSre.getStarRatingHtml)(feud["rating"]) + "</span>";
            let text = '<span class="faded-red-light">' + feudName + "</span>" + " Feud between " + participantNames + " ended after the Blowoff" + rating;
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' + text + "</span>");
        } else if (feud["stale"]) {
            let participantNames = feud["participants"].join(" and ");
            let feudName = feud["name"];
            let overnessChange = '<span class="stale-color">' + feud["overnessDecrease"] + '<span class="margin-left-2">%</span></span>';
            let text = '<span class="faded-red-light">' + feudName + "</span>" + " Feud between " + participantNames + ' became <span class="stale-color">Stale</span>' + " with the Fans, lowering the Overness of its Participants by " + overnessChange + " each and decreasing its Hype.";
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' + text + "</span>");
        } else if (feud["staleWarning"]) {
            let participantNames = feud["participants"].join(" and ");
            let feudName = feud["name"];
            let text = '<span class="faded-red-light">' + feudName + " Feud</span>" + " between " + participantNames + ' is starting to become <span class="stale-color">Stale</span> with the Fans.';
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' + text + "</span>");
        }
    });
    // Segment Prestige
    data["feudItemsLevelData"].forEach(function(levelData) {
        let levelText;
        let progress;
        let levelXp;
        if (levelData["level"] < 3) {
            levelXp = Math.pow(levelData["level"], 2) * 40;
            progress = levelData["xp"] / levelXp * 100;
        } else {
            progress = 100;
            levelXp = Math.pow(2, 2) * 40;
        }
        // Set level
        let level;
        switch(levelData["level"]){
            case 1:
                level = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case 2:
                level = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case 3:
                level = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }
        let xpChangeHtml;
        let xpChange = levelData["xpChange"];
        if (xpChange >= 0) xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + "</span>";
        else if (xpChange < 0) xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' + -1 * xpChange + "</span>";
        levelText = '<div class="display-block margin-bottom-5"><div class="display-inline-block"><span>' + levelData["name"] + "</span>" + level + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey prestige-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text" title="' + levelData["xp"] + " / " + levelXp + ' XP">' + '<div class="progress faded-red-light-background" style="width:' + progress + '%">' + "</div>" + "</div>";
        // Add level increase data
        if (levelData["levelIncrease"]) levelText += '<span class="gold display-block margin-top-12 margin-bottom-2">Level Up!</span><span class="display-block medium-grey">Base Hype<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i><span class="faded-red-light"><i class="fa fa-bolt margin-right-5"></i>' + levelData["hypeIncrease"] + "</span>" + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after('<div class="feud-item-level margin-bottom-25">' + levelText + "</div>");
        // Animate XP and progress
        $(".feud-item-level .prestige-xp-value").last().hide().fadeIn("slow");
        setTimeout(function() {
            $(".feud-item-level .progress").last().addClass("expand-width");
        }, 0);
        setTimeout(function() {
            $(".feud-item-level .progress").last().removeClass("expand-width");
        }, 1800);
    });
    // Workrate Increases
    data["workrateIncreases"].forEach(function(superstar) {
        let text = '{0}\'s <span class="workrate-blue">Workrate</span> increased to <span class="gold">Level {1}</span>'.format(superstar["name"], superstar["level"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Gimmick Effectiveness Level Changes
    data["gimmickEffectivenessLevelChanges"].forEach(function(gimmickLevelChange) {
        let gimmickLevelChangeHtml = (0, $1JSre.getGimmickEffectivenessLevelChangeHtml)(gimmickLevelChange);
        eventUpdatesGimmicksSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + gimmickLevelChangeHtml + "</span>");
    });
    // Staff Skill Increases
    data["staffSkillIncreases"].forEach(function(staffMember) {
        let roleHtml = '<span class="light-grey">(' + (0, $3E8Nt.toTitleCase)(staffMember["role"].replace(/_/g, " ")) + ")</span>";
        let skillLevelHtml = '<span class="staff-color">Skill</span>';
        let text = '{0}\'s {1} {2} increased to <span class="gold">Level {3}</span>'.format(staffMember["name"], roleHtml, skillLevelHtml, staffMember["level"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Show streaks
    data["streaks"].forEach(function(streak) {
        let streakText;
        if (streak["extended"]) {
            let streakHtml = '<span class="obsidian">Winning Streak</span>';
            streakText = "{0}'s {1} at {2} increased to {3}-0".format(streak["holder"], streakHtml, streak["event"], streak["length"]);
        } else if (streak["started"]) {
            let streakHtml = '<span class="obsidian">Winning Streak</span>';
            streakText = "{0} started a {1} at {2}".format(streak["holder"], streakHtml, streak["event"]);
        } else if (streak["ended"]) {
            let streakHtml = '<span class="obsidian">Undefeated Streak</span>';
            streakText = "{0} ended {1}'s {2} match {3} at {4}!".format(streak["winner"], streak["holder"], streak["length"], streakHtml, streak["event"]);
        }
        eventUpdatesSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' + streakText + "</span>");
    });
    // Show gimmick match level data
    let levelText;
    let levelData = data["gimmickMatchLevelData"];
    if (levelData) {
        let progress;
        let levelXp;
        if (levelData["level"] < 3) {
            levelXp = Math.pow(levelData["level"], 2) * 50;
            progress = levelData["xp"] / levelXp * 100;
        } else {
            progress = 100;
            levelXp = Math.pow(2, 2) * 50;
        }
        // Set level
        let level;
        switch(levelData["level"]){
            case 1:
                level = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case 2:
                level = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case 3:
                level = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }
        let xpChangeHtml;
        let xpChange = levelData["xpChange"];
        if (xpChange >= 0) xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + "</span>";
        else if (xpChange < 0) xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' + -1 * xpChange + "</span>";
        levelText = '<div class="display-block margin-bottom-5"><div class="display-inline-block"><span>' + levelData["name"] + " Match" + "</span>" + level + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey prestige-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text" title="' + levelData["xp"] + " / " + levelXp + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>";
        // Add level increase data
        if (levelData["levelIncrease"]) {
            let perk;
            switch(levelData["addedPerk"]){
                case "rating":
                    perk = "Rating boost increased for this Gimmick Match!";
                    break;
                case "injury":
                    perk = "Injury rate decreased for this Gimmick Match!";
                    break;
                case "popularity":
                    perk = "Popularity boost increased for this Gimmick Match!";
                    break;
                case "cost":
                    perk = "Cost decreased for this Gimmick Match!";
                    break;
            }
            levelText += '<span class="gold display-block margin-top-12">Level Up!</span><span class="display-block margin-top-5">' + perk + "</span>";
        }
        prestigeResultsSelector.find(".event-prestige-header").after('<div class="gimmick-match-level margin-bottom-25">' + levelText + "</div>");
        $(".gimmick-match-level .prestige-xp-value").hide().fadeIn("slow");
        setTimeout(function() {
            $(".gimmick-match-level .progress").addClass("expand-width");
        }, 0);
        setTimeout(function() {
            $(".gimmick-match-level .progress").removeClass("expand-width");
        }, 1800);
    }
    // Show tournament prestige
    let tournamentPrestigeHtml;
    let tournamentPrestige = data["tournamentPrestige"];
    if (tournamentPrestige) {
        let progress = 100;
        if (tournamentPrestige["prestige"] !== "A") progress = (tournamentPrestige["xp"] - tournamentPrestige["baseXp"]) / (tournamentPrestige["xpToNextPrestige"] - tournamentPrestige["baseXp"]) * 100;
        if (progress > 100) progress = 100;
        else if (progress < 0) progress = 0;
        let xpChangeHtml;
        let xpChange = tournamentPrestige["xpChange"];
        if (tournamentPrestige["xpChange"] >= 0) xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + "</span>";
        else if (tournamentPrestige["xpChange"] < 0) xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' + -1 * xpChange + "</span>";
        let prestigeIcon;
        switch(tournamentPrestige["prestige"]){
            case "C":
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case "B":
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case "A":
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }
        tournamentPrestigeHtml = '<div class="display-block margin-bottom-5"><div class="display-inline-block"><span>Tourn. Prestige</span>' + prestigeIcon + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey prestige-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text" title="' + tournamentPrestige["xp"] + " / " + tournamentPrestige["xpToNextPrestige"] + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>";
        if (tournamentPrestige["prestigeIncrease"]) {
            tournamentPrestigeHtml += '<span class="gold display-block margin-top-12">Tournament Prestige Increased</span>';
            tournamentPrestigeHtml += '<span class="display-block margin-top-5"><i class="fa fa-angle-double-up margin-right-5"></i>Final Bonus increased to + ' + tournamentPrestige["finalBonus"] + " for this Tournament</span>";
        } else if (tournamentPrestige["prestigeDecrease"]) {
            tournamentPrestigeHtml += '<span class="puke-green display-block margin-top-12">Tournament Prestige Decreased</span>';
            tournamentPrestigeHtml += '<span class="display-block margin-top-5"><i class="fa fa-angle-double-down margin-right-5"></i>Final Bonus decreased to + ' + tournamentPrestige["finalBonus"] + " for this Tournament</span>";
        }
        prestigeResultsSelector.find(".event-prestige-header").after('<div class="tournament-prestige-progress  margin-bottom-25">' + tournamentPrestigeHtml + "</div>");
        $(".tournament-prestige-progress .prestige-xp-value").hide().fadeIn("slow");
        setTimeout(function() {
            $(".tournament-prestige-progress .progress").addClass("expand-width");
        }, 0);
        setTimeout(function() {
            $(".tournament-prestige-progress .progress").removeClass("expand-width");
        }, 1800);
    }
    // Show match effect change
    if (data["matchEffectIncrease"]) eventUpdatesSelector.prepend('<span class="display-block event-match-effect margin-bottom-12"><span class="bronze"><i class="fa fa-angle-double-up margin-right-5 dark-grey"></i>' + data["matchGimmick"] + "</span>" + " Match Effect" + " increased for this Event" + "</span>");
    else if (data["matchEffectDecrease"]) eventUpdatesSelector.prepend('<span class="display-block event-match-effect margin-bottom-12"><span class="bronze"><i class="fa fa-angle-double-down margin-right-5 dark-grey"></i>' + data["matchGimmick"] + "</span>" + " Match Effect" + " decreased for this Event" + "</span>");
    // Tournament advance
    if (data["tournamentAdvance"]) {
        let names = data["tournamentAdvance"]["names"];
        let group = data["tournamentAdvance"]["group"];
        if (names.length > 1) names = names.slice(0, -1).join(", ") + " and " + names.slice(-1);
        let text = '<span class="cyan">knockout stage</span>';
        let tournamentAdvanceText = "{0} advanced from Group {1} to the {2}".format(names, (0, $1JSre.getTournamentGroupName)(group), text);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12">' + tournamentAdvanceText + "</span>");
    }
    // Tournament win
    if (data["tournamentWon"]) {
        let won = data["tournamentWon"]["tournamentName"];
        let text = '<span class="cyan">' + won + "</span>";
        if (data["tournamentWon"]["matchContractName"]) text += ' and the <span class="gold">' + data["tournamentWon"]["matchContractName"] + " Contract" + "</span>";
        let tournamentWinPrefix = "won the";
        // Don't add 'the' if tournament name starts with 'the'
        if (data["tournamentWon"]["tournamentName"].split(" ")[0].toLowerCase() === "the") tournamentWinPrefix = "won";
        let tournamentWinText = "{0} {1} {2}!".format(data["tournamentWon"]["name"], tournamentWinPrefix, text);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12">' + tournamentWinText + "</span>");
    }
    // Feud consequence results
    if (data["feudConsequenceResults"]) {
        let feudResults = data["feudConsequenceResults"];
        feudResults["retirements"].forEach(function(superstar) {
            let text;
            if (superstar["hallOfFame"]) text = superstar["name"] + " has retired and been inducted into the " + '<span class="gold">' + "Hall of Fame" + "</span>";
            else text = superstar["name"] + " has retired from wrestling";
            eventUpdatesAvailabilitySelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        });
        // Career not ended
        if (feudResults["careerNotEnded"]) {
            let text = "{0}'s career is not over yet!".format(feudResults["careerNotEnded"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Main Event Push
        if (feudResults["pushed"]) {
            let text = "{0} gained a Popularity Boost to get into the Main Event!".format(feudResults["pushed"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Unified
        if (feudResults["unifiedChampionships"]) {
            let unifiedData = feudResults["unifiedChampionships"];
            let championshipVerb = unifiedData["multipleChampionships"] ? "have" : "has";
            let unifiedChampionshipsName = '<span class="gold">{0}</span>'.format(unifiedData["unifiedChampionships"]);
            let unifiedChampionshipWithName = '<span class="gold">{0}</span>'.format(unifiedData["unifiedChampionshipWith"]);
            let text = "{0} {1} been unified with the {2}".format(unifiedChampionshipsName, championshipVerb, unifiedChampionshipWithName);
            if (unifiedData["xpChange"]) {
                let xpChange = '<span class="green margin-left-5">+ ' + unifiedData["xpChange"] + " XP</span>";
                text += ", increasing Prestige {0}".format(xpChange);
            }
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Disbanded
        if (feudResults["disbanded"].length > 0) {
            let text = "{0} have disbanded".format((0, $3E8Nt.commaSeparate)(feudResults["disbanded"]));
            eventUpdatesAvailabilitySelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Forced to leave
        if (feudResults["forcedToLeave"]) {
            let verb = feudResults["forcedToLeaveType"] === "superstar" ? "has" : "have";
            let text = "{0} {1} been forced to leave the company for some time!".format(feudResults["forcedToLeave"], verb);
            eventUpdatesAvailabilitySelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Left Company
        feudResults["fired"].forEach(function(superstar) {
            let overnessDecrease = '<span class="stale-color">' + superstar["overnessDecrease"] + '<span class="margin-left-2">%</span></span>';
            let text = superstar["name"] + " was fired from the company, " + "lowering " + superstar["pronoun"] + " Overness by " + overnessDecrease;
            eventUpdatesAvailabilitySelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        });
        // Turn Heel
        if (feudResults["turnedHeel"]) {
            let text = "{0} fell into corruption and turned Heel!".format(feudResults["turnedHeel"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Did not turn Heel
        if (feudResults["didNotTurnHeel"]) {
            let text = "{0} fought the corruption and remained Face!".format(feudResults["didNotTurnHeel"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Turn Face
        if (feudResults["turnedFace"]) {
            let text = "{0} gained redemption and turned Face!".format(feudResults["turnedFace"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Did not turn Face
        if (feudResults["didNotTurnFace"]) {
            let text = "{0} could not find redemption and remained Heel!".format(feudResults["didNotTurnFace"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Unmasked
        feudResults["maskRemoved"].forEach(function() {
            let text = "{0} was forced to unmask!".format(feudResults["maskRemoved"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        });
        // Faction consequences
        feudResults["factionConsequences"].forEach(function(factionConsequence) {
            let text;
            if (factionConsequence["consequence"] === "join_faction") text = factionConsequence["name"] + " was forced to join " + factionConsequence["faction"];
            if (factionConsequence["consequence"] === "leave_faction") text = factionConsequence["name"] + " was forced to leave " + factionConsequence["faction"];
            if (factionConsequence["consequence"] === "become_faction_leader") text = factionConsequence["name"] + " became the leader of " + factionConsequence["faction"];
            if (factionConsequence["consequence"] === "did_not_join_faction") text = "Join Faction did not trigger as " + factionConsequence["faction"] + " already have " + (0, $3E8Nt.gameLimits).maxFactionSuperstars + " members";
            if (text) eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        });
    }
    // Show faction reputation progress
    data["factionReputationsData"].forEach(function(factionReputationData) {
        (0, $1JSre.showFactionReputationData)(factionReputationData);
    });
    data["unavailable"].forEach(function(data) {
        let dataText;
        if (data["type"] === "injury") {
            let doctorHtml = "";
            if (data["doctorName"]) {
                let doctorName = data["doctorName"];
                let doctorAgeMultiplier = data["doctorAgeMultiplier"];
                let doctorXp = '<span class="green margin-left-8">+ ' + data["doctorXpGained"] + " XP</span>";
                if (doctorAgeMultiplier !== 1) doctorXp += '<span class="light-grey margin-left-8 font-0p925em">(' + doctorAgeMultiplier + '<span class="help-text" title="Age affects progression of ' + 'Skill Level. Younger staff members gain XP faster than older ones.">x Age Multiplier</span>' + ")</span>";
                doctorHtml = doctorName + " is working to evaluate it" + doctorXp;
            }
            // Injury chance
            let injuryChanceHtml = "";
            if (data["injuryChance"]) injuryChanceHtml = '<span class="margin-left-5 light-grey font-0p925em">(' + Math.round(data["injuryChance"] * 10) / 10 + '<span class="margin-left-2">%</span> chance) </span>';
            let injuryWords = "an injury";
            if (data["injuryType"] === "major") injuryWords = "a severe injury";
            else if (data["injuryType"] === "workable") injuryWords = "a slight injury";
            dataText = '<span class="display-block margin-bottom-12 dark-grey">' + data["name"] + " " + '<span class="dark-red">' + "suffered " + injuryWords + injuryChanceHtml + "</span>. " + doctorHtml + "</span>";
            // Add vacate championships button
            if (data["championshipsToVacate"].length > 0) {
                let championshipsToVacate = (0, $1JSre.getChampionshipsDisplayName)(data["championshipsToVacate"], true);
                let vacateChampionshipsText = '<span class="gold">' + championshipsToVacate + "</span>" + " suffered an injury " + '<button type="button" data-superstar-uid="' + data["uid"] + '" class="button retro-button ' + 'display-block condensed margin-top-5 blue-button-background vacate-superstar-championships-button">' + "Vacate</button>";
                eventUpdatesAvailabilitySelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + vacateChampionshipsText + "</span>");
            }
            // Show injured border
            let elementsFound = $("#match").find(".match-wrestler").filter(function() {
                return $(this).data("name").indexOf(data["participantName"]) >= 0;
            });
            elementsFound.addClass("injured");
        } else if (data["type"] === "unavailable") {
            if (match["type"] === "singles") dataText = '<span class="display-block margin-bottom-12 dark-grey">' + data["name"] + " has been forced to leave the company for some time</span>";
            else dataText = '<span class="display-block margin-bottom-12 dark-grey">' + data["name"] + " has been forced to leave the company for some time</span>";
        } else if (data["type"] === "death") dataText = '<span class="display-block margin-bottom-12 dark-grey">' + data["name"] + " suffered a life-threatening injury and is in critical condition</span>";
        eventUpdatesAvailabilitySelector.prepend(dataText);
    });
    // Hair loss
    data["hairRemoved"].forEach(function(data) {
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + data["name"] + " got " + data["possessivePronoun"] + " hair forcefully shaved off!" + "</span>");
    });
    // Hair added
    data["hairAdded"].forEach(function(data) {
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + data["name"] + " was forced to grow " + data["possessivePronoun"] + " hair!" + "</span>");
    });
    // Mask removed
    data["maskRemoved"].forEach(function(data) {
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + data["name"] + " was forced to unmask!" + "</span>");
    });
    data["vacated"].forEach(function(vacated) {
        let text;
        let championshipName = (0, $1JSre.getChampionshipDisplayName)(vacated);
        if (!vacated["tagTeam"] && !vacated["trio"]) text = '<span class="gold">' + championshipName + "</span>" + " has been vacated";
        else text = '<span class="gold">' + championshipName + "</span>" + " have been vacated";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Show face of the company notifications
    data["fotcChanges"].forEach(function(data) {
        let faceOfTheCompanyText;
        if (data["faceOfTheCompanyStart"]) faceOfTheCompanyText = data["name"] + " is on the way to becoming a " + '<span class="medium-blue">' + "Face of the Company" + "</span>";
        else if (data["faceOfTheCompany"]) faceOfTheCompanyText = data["name"] + " became a " + '<span class="medium-blue">' + "Face of the Company" + "</span>!";
        else faceOfTheCompanyText = data["name"] + " is no longer a Face of the Company";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + faceOfTheCompanyText + "</span>");
    });
    // Feud Potential
    data["feudPotentials"].forEach(function(feud) {
        let feudPotentialHtml = (0, $1JSre.getFeudPotentialHtml)(feud);
        eventUpdatesFeudsSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + feudPotentialHtml + "</span>");
    });
    // Feud hype increased
    data["feudHypeIncreased"].forEach(function(feud) {
        let feudPotentialHtml = (0, $1JSre.getFeudHypeIncreasedHtml)(feud);
        eventUpdatesFeudsSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + feudPotentialHtml + "</span>");
    });
    // Feuds started
    data["feudsStarted"].forEach(function(feud) {
        let feudStartedHtml = (0, $1JSre.getFeudStartedHtml)(feud);
        eventUpdatesFeudsSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + feudStartedHtml + "</span>");
    });
    // Show championship prestige progress
    data["championshipPrestiges"].forEach(function(prestigeData) {
        let prestigeHtml = (0, $1JSre.getChampionshipPrestigeHtml)(prestigeData);
        prestigeResultsSelector.find(".event-prestige-header").after('<div class="championship-prestige margin-bottom-20">' + prestigeHtml + "</div>");
        $(".championship-prestige .prestige-xp").hide().fadeIn("slow");
        setTimeout(function() {
            $(".championship-prestige .progress").addClass("expand-width");
        }, 0);
        setTimeout(function() {
            $(".championship-prestige .progress").removeClass("expand-width");
        }, 1800);
    });
    // Show unlocked gimmick matches
    if (data["unlockedGimmickMatches"].length > 0) {
        let matchWord = data["unlockedGimmickMatches"].length === 1 ? "Match" : "Matches";
        let unlockText = '<span class="light-blue">' + (0, $3E8Nt.commaSeparate)(data["unlockedGimmickMatches"]) + " " + matchWord + "</span>" + " unlocked!";
        let html = '<span class="display-block margin-bottom-15">' + unlockText + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after(html);
    }
    // Show unlocked feud items
    data["unlockedFeudItems"].forEach(function(feudItem) {
        let unlockText = '<span class="faded-red-light">' + feudItem + "</span>" + " Feud Item unlocked!";
        let html = '<span class="display-block margin-bottom-15">' + unlockText + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after(html);
    });
    // Show unlocked championship segment items
    data["unlockedChampionshipSegmentItems"].forEach(function(segmentItem) {
        let unlockText = '<span class="faded-purple">' + segmentItem + "</span>" + " Championship Segment unlocked!";
        let html = '<span class="display-block margin-bottom-15">' + unlockText + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after(html);
    });
    // Show unlocked gimmick characters
    data["unlockedCharacters"].forEach(function(unlockedCharacter) {
        let unlockText = '<span class="character-label">' + unlockedCharacter["name"] + "</span>" + " Character unlocked due to the " + unlockedCharacter["originalCharacter"] + " Character getting Over!";
        let html = '<span class="display-block margin-bottom-15">' + unlockText + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after(html);
    });
    // Tournament injury
    if (data["tournamentInjury"]) {
        let tournamentInjuryHtml = $5fab2de231db267f$export$2fe3faa2f51b0444(data["tournamentInjury"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12">' + tournamentInjuryHtml + "</span>");
    }
    // Tournament substitution
    if (data["tournamentSubstitution"]) {
        let tournamentNameText = '<span class="cyan">' + data["tournamentSubstitution"]["tournamentName"] + " Tournament" + "</span>";
        let substitutionResult = data["tournamentSubstitution"];
        let tournamentInjuryText = "Due to {0}'s injury, {1} took {2} place in the next round of the {3}".format(substitutionResult["injured"], substitutionResult["newMember"], substitutionResult["possessivePronoun"], tournamentNameText);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12">' + tournamentInjuryText + "</span>");
    }
    data["turnedHeel"].forEach(function(participant) {
        let turnText = participant + ' turned <span class="alignment-heel">Heel</span>!';
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + turnText + "</span>");
    });
    data["turnedFace"].forEach(function(participant) {
        let turnText = participant + ' turned <span class="alignment-face">Face</span>!';
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + turnText + "</span>");
    });
    data["debutedGimmicks"].forEach(function(gimmick) {
        let gimmickDebutHtml = (0, $1JSre.getGimmickDebutHtml)(gimmick);
        eventUpdatesGimmicksSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + gimmickDebutHtml + "</span>");
    });
    // Show overness change
    if (data["hotMatch"]) {
        let overnessChange = '<span class="hot-color">' + data["hotMatchOvernessIncrease"] + '<span class="margin-left-2">%</span></span>';
        // Get participant names
        let participantNames = [
            ...data["losers"],
            data["winner"]
        ].map((x)=>x["name"]);
        let participantsText = participantNames.slice(0, -1).join(", ") + " and " + participantNames.slice(-1);
        let eventHypeBoost = "";
        if (data["eventHypeBoostData"]) {
            if (data["eventHypeBoostData"]["hotMatchBoost"]) eventHypeBoost = ' A lot of viewers tuned in to watch.<span class="medium-dark-grey margin-left-8">+ ' + data["eventHypeBoostData"]["hypeBoost"] + " HYPE</span>";
        }
        let hotMatchText = participantsText + ' put on a <span class="hot-color">Hot</span> Match, ' + "boosting their Overness by " + overnessChange + " each." + eventHypeBoost;
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + hotMatchText + "</span>");
        // Update event hype
        $(".event-hype-text").html((0, $e6954d9b34d9dd89$export$46dc9792936abd2f)(data["eventHype"])).hide().fadeIn("fast");
    }
    // Overness Changes
    data["overnessChanges"].forEach(function(overnessChange) {
        let overnessPercentage = '<span class="light-grey margin-left-5">' + overnessChange["overness"] + '<span class="margin-left-2">%</span></span>';
        let changeWord = overnessChange["increase"] ? "increased" : "decreased";
        let text = "{0}'s Overness{1} ".format(overnessChange["name"], overnessPercentage) + changeWord + ' to <span class="light-grey">' + overnessChange["currentOverness"] + "</span>" + ' from <span class="light-grey">' + overnessChange["previousOverness"] + "</span>";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Hot Changes
    data["hotChanges"].forEach(function(hotChange) {
        let text;
        if (hotChange["status"] === "hotStart") text = hotChange["name"] + ' is starting to get <span class="hot-color">Over</span> with the Fans';
        else if (hotChange["status"] === "hotEnd") text = hotChange["name"] + ' is no longer <span class="hot-color">Over</span> with the Fans. ' + "All boosts have been removed.";
        else if (hotChange["status"] === "hot") text = hotChange["name"] + ' got <span class="hot-color hot-text">Over</span> with the Fans, ' + " boosting " + hotChange["pronoun"] + " Attributes and performance in Matches, Segments and Feuds.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        setTimeout(function() {
            $(".hot-text").addClass("flash-text-orange");
        }, 200);
        setTimeout(function() {
            $(".hot-text").removeClass("flash-text-orange");
        }, 3000);
    });
    // Stale Changes
    data["staleChanges"].forEach(function(staleChange) {
        let text;
        if (staleChange["status"] === "staleStart") text = staleChange["name"] + ' is starting to become <span class="stale-color">Stale</span> with the Fans';
        else if (staleChange["status"] === "staleEnd") text = staleChange["name"] + ' is no longer <span class="stale-color">Stale</span> with the Fans. ' + "All negative effects have been removed.";
        else if (staleChange["status"] === "stale") text = staleChange["name"] + ' became <span class="stale-color stale-text">Stale</span> with the Fans, ' + " lowering " + staleChange["pronoun"] + " performance in Matches, Segments and Feuds.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        setTimeout(function() {
            $(".stale-text").addClass("flash-text-stale");
        }, 200);
        setTimeout(function() {
            $(".stale-text").removeClass("flash-text-stale");
        }, 3000);
    });
    // Show hot feuds
    data["hotFeuds"].forEach(function(feud) {
        let overnessChange = '<span class="hot-color">' + feud["overnessIncrease"] + '<span class="margin-left-2">%</span></span>';
        // Get participant names
        let participantNames = [
            ...feud["participants"]
        ];
        let participantsText = participantNames.slice(0, -1).join(", ") + " and " + participantNames.slice(-1);
        let feudName = feud["name"];
        let hotFeudText = '<span class="faded-red-light">{0}</span> Feud between {1} became <span class="hot-color">Hot</span>,'.format(feudName, participantsText) + " boosting its chance to have Hot Matches and Segments and the Overness of the Participants by " + overnessChange + " each.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + hotFeudText + "</span>");
    });
    // Morale Changes
    data["moraleChanges"].forEach(function(moraleChange) {
        let moralePercentage = '<span class="light-grey margin-left-5">' + moraleChange["morale"] + '<span class="margin-left-2">%</span></span>';
        let text = "{0}'s Morale{1} ".format(moraleChange["name"], moralePercentage) + ' changed to <span class="light-grey">' + moraleChange["currentMorale"] + '</span> from <span class="light-grey">' + moraleChange["previousMorale"] + "</span>";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Managers added/removed
    data["managersAdded"].forEach(function(managerAdded) {
        let text = '<span class="display-block">Assigned {0} to manage {1}</span>'.format(managerAdded["managerName"], (0, $3E8Nt.commaSeparate)(managerAdded["managedSuperstarsNames"]));
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    data["managersRemoved"].forEach(function(managerRemoved) {
        let text = '<span class="display-block">Removed {0} from managing {1}</span>'.format(managerRemoved["managerName"], (0, $3E8Nt.commaSeparate)(managerRemoved["removedSuperstarsNames"]));
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
}
function $5fab2de231db267f$var$showGetChampionshipContractHoldersData({ data: data, element: element } = {}) {
    let options = [];
    data.forEach(function(holder) {
        options.push('<option value="' + holder["uid"] + '">' + holder["name"] + "</option>");
    });
    // Create new div with championship names and time of cashin
    let div = '<div class="championship-contract-cashin-box display-block margin-top-20 text-center"><select name="cashin-championships">' + options + "</select>" + '<select name="cashin-time">' + '<option value="0" selected>Now</option>' + '<option value="1">After Match</option>' + "</select>" + '<button type="button" id="championship-contract-cashin" ' + 'class="button retro-button condensed gold-button-background margin-left-2" data-match-uid="' + element.attr("data-match-uid") + '">' + "Cash In" + "</button>" + "</div>";
    // Add new div and remove previous one
    element.replaceWith(div);
}
function $5fab2de231db267f$var$showGetChampionshipsForCashinData({ data: data, element: element } = {}) {
    // Add championship names
    let options = [];
    data.forEach(function(championship) {
        options.push("<option value='" + championship["uid"] + "'>" + championship["name"] + "</option>");
    });
    // Create new div with championship names and time of cashin
    let div = '<div class="championship-contract-cashin-box display-block"><div class="line-height-1p4 font-0p925em grey-blue-dark margin-top-5"><i class="fa fa-info-circle margin-right-2"></i> Cash in for a championship match at the upcoming event.</div><select name="cashin-championships">' + options + "</select>" + '<button type="button" id="championship-contract-cashin" ' + 'class="button retro-button condensed gold-button-background margin-top-5" data-uid="' + element.attr("data-uid") + '">' + "Cash In" + "</button>" + "</div>";
    // Add new div and remove previous one
    element.parent().after(div);
    element.prev().text(" ");
    element.remove();
}
async function $5fab2de231db267f$var$showAddCashinFutureMatchData({ data: data } = {}) {
    if (data["error"]) {
        if (data["error"] === "no-women-allowed") notie.alert({
            type: 3,
            text: "Women are not allowed to be booked at this event"
        });
        if (data["error"] === "no-men-allowed") notie.alert({
            type: 3,
            text: "Men are not allowed to be booked at this event"
        });
        if (data["error"] === "production-packages-only") notie.alert({
            type: 3,
            text: "You can only book Production Segments at this Event"
        });
        if (data["error"] === "championship-not-found") notie.alert({
            type: 3,
            text: "That championship could not be found"
        });
        if (data["error"] === "challenger-is-champion") notie.alert({
            type: 3,
            text: "Champions can't cash in on themselves!"
        });
        return false;
    }
    await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)());
}



var $1JSre = parcelRequire("1JSre");

var $5ZsVo = parcelRequire("5ZsVo");

var $3E8Nt = parcelRequire("3E8Nt");


var $5kTkA = parcelRequire("5kTkA");




var $bZol7 = parcelRequire("bZol7");
$(document).ready(function() {
    // Continue from end event
    $("#game-content").on("click", "#continue", async function() {
        // Don't continue if PoW dialog showing
        if ($("#pow-dialog").is(":visible")) {
            notie.alert({
                type: 4,
                text: "Please finish the current action before proceeding"
            });
            return false;
        }
        let showNextPage = checkShowNextPage();
        // Don't continue if competitors not simulated
        if (!showNextPage && !$e6954d9b34d9dd89$var$competitorsSimulated && (0, $98xmD.globals).game.competitorsPresent) {
            showCompetitorsNotSimulatedNotification();
            return false;
        }
        $(".match-container").fadeOut("fast");
        // Show news and viewership
        if (showNextPage) {
            checkToShowNewsAndViewershipContainers();
            // Tutorial action check
            (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("go_to_post_event");
        } else await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)());
    });
    // Continue from viewership page
    $("#game-content").on("click", "#continue-viewership-results-button, #continue-news-button", async function() {
        // Don't continue if competitors not simulated
        if (!$e6954d9b34d9dd89$var$competitorsSimulated) {
            showCompetitorsNotSimulatedNotification();
            return false;
        }
        // Go to home page
        await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)());
    });
    // Viewership options
    $("#game-content").on("click", ".viewership-results-box-option", function() {
        $(".viewership-results-box-option").removeClass("medium-grey").addClass("extra-light-grey");
        $(this).addClass("medium-grey").removeClass("extra-light-grey");
        let val = $(this).text();
        if (val === "Number") $(".viewership-results-item-container").each(function(i, e) {
            let viewership = parseInt($(e).attr("data-viewership"));
            let viewershipText = (0, $1JSre.getViewershipText)(viewership);
            $(e).find(".viewership-results-item-number").text(viewershipText);
        });
        else if (val === "Rating") $(".viewership-results-item-container").each(function(i, e) {
            let rating = $(e).attr("data-nielsen-rating");
            $(e).find(".viewership-results-item-number").text(rating);
        });
    });
    $("#event-updates").on("click", ".vacate-superstar-championships-button", async function() {
        let element = $(this);
        let superstarUid = parseInt(element.attr("data-superstar-uid"));
        await (0, $1JSre.makeGameRequest)((0, $5kTkA.vacateSuperstarChampionships), {
            superstarUid: superstarUid
        }, $e6954d9b34d9dd89$var$showVacateSuperstarChampionshipsData, {
            element: element
        }, false);
    });
    function showCompetitorsNotSimulatedNotification() {
        let notieText = "Please wait for competitors to finish simulating";
        notie.alert({
            type: 3,
            text: notieText
        });
    }
    function checkShowNextPage() {
        return (0, $98xmD.globals).game.competitorsPresent && $("#continue").data("skipPostEvent") !== true && ($("#continue").data("showNews") === true || (0, $98xmD.globals).game.marketSize && ((0, $98xmD.globalUser).paid || (0, $98xmD.globals).currentTutorialStep)) && !((0, $98xmD.globals).currentTutorialStep && (0, $98xmD.globals).currentTutorialStep["action"] !== "go_to_post_event");
    }
    function checkToShowNewsAndViewershipContainers() {
        if ($("#continue").data("showNews") === true) {
            $(".news-box").fadeIn();
            $(".news-content").scrollTop(0);
        }
        if ((0, $98xmD.globals).game.marketSize && ((0, $98xmD.globalUser).paid || (0, $98xmD.globals).currentTutorialStep)) {
            $(".viewership-results-box").fadeIn();
            $(".viewership-results-box-container").scrollTop(0);
            $(".news-box-buttons-container").hide();
        } else $(".news-box-buttons-container").show();
    }
});
async function $e6954d9b34d9dd89$export$f3b814448fcb699b({ data: data } = {}) {
    if (!data["error"]) {
        // Select menu button
        $(".main-menu-container").find("li").removeClass("selected");
        $("#play-event").addClass("selected");
        // Disable menu options
        (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
        // Reset ui
        $("#main-menu-right").html("");
        $("#multi-match-info").html("");
        $(".event-hype").html("");
        $(".event-prestige-effects").hide();
        $(".event-prestige-effects-container").hide();
        $("#event-card").hide();
        $("#matches").html("");
        $("#match").html("");
        $("#booking-talent-info").hide();
        $(".tooltip").remove();
        $("#prestige-results").html('<div class="event-prestige-header font-mukta-mahee font-1p325em menu-header-color margin-bottom-20">Prestige</div>').hide();
        $("#continue-container").hide();
        // Check to show event preview or continue to play event
        let showEventPreview = !((0, $98xmD.globalUser).settings["showEventPreview"] === false);
        let clickPlayEventTutorialStep = (0, $98xmD.globals).currentTutorialStep && (0, $98xmD.globals).currentTutorialStep["action"] === "click_play_event";
        if (data["eventPreviewData"] && showEventPreview && !clickPlayEventTutorialStep) {
            $e6954d9b34d9dd89$var$showEventPreviewData(data["eventPreviewData"]);
            $("#event-preview-continue-button").data("continue-to-event", false);
            // Continue button
            $("#event-preview-container").off("click", "#event-preview-continue-button");
            $("#event-preview-container").on("click", "#event-preview-continue-button", async function() {
                if (!$(this).data("continue-to-event")) {
                    $e6954d9b34d9dd89$var$showEventPredictionsData(data["eventPreviewData"]["predictionsData"], data["eventPreviewData"]["activeEffect"]);
                    $(this).data("continue-to-event", true);
                } else {
                    $("#event-preview-container").hide();
                    $("#event-preview-poster-container").hide();
                    await $e6954d9b34d9dd89$var$showPlayEventPageData(data);
                }
            });
        } else await $e6954d9b34d9dd89$var$showPlayEventPageData(data);
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_play_event");
    } else if (data["error"] === "training-callup-available") notie.confirm({
        text: "A Training Roster Callup is available. Are you sure you want to skip it?",
        submitText: "Yes",
        cancelText: "No",
        submitCallback: async function() {
            await (0, $212d6f8aa99fe567$export$f401be2a67e052a3)(true, true);
        },
        cancelCallback: async function() {
            await (0, $b947816677aa453b$export$cc99d6c9d04059f3)();
        }
    });
    else {
        let text;
        if (data["error"] === "team-members-not-found") text = "Team members could not be found for {0}. Try deleting their Match/Segment.".format(data["teamName"]);
        else if (data["error"] === "min-limit") text = "You need to book at least " + data["limit"] + " Matches/Segments for this Event";
        else text = "An error occurred while starting the event";
        notie.alert({
            type: 3,
            text: text
        });
    }
}
async function $e6954d9b34d9dd89$var$showPlayEventPageData(data) {
    let eventHype = $e6954d9b34d9dd89$export$46dc9792936abd2f(data["hype"]);
    // Add empty match results box
    let fatigueHtml = (0, $98xmD.globals).game.settings["enable_fatigue"] !== false ? '<span class="hide-stats extra-light-grey cursor-pointer margin-left-8">Fat.</span>' : "";
    $("#event-match-results").html('<div class="margin-bottom-15 event-results-header"><span class="font-mukta-mahee font-1p325em menu-header-color">Results</span><div class="float-right"><span class="hide-stats extra-light-grey cursor-pointer">XP</span><span class="hide-stats medium-grey cursor-pointer margin-left-8">Ovr.</span><span class="hide-stats medium-grey cursor-pointer margin-left-8">Pop.</span><span class="hide-stats extra-light-grey cursor-pointer margin-left-8">Gim.</span><span class="hide-stats medium-grey cursor-pointer margin-left-8">Feuds</span><span class="hide-stats medium-grey cursor-pointer margin-left-8">Mor.</span>' + fatigueHtml + "</div>" + '<div class="clear"></div>' + '<div class="margin-top-25 margin-bottom-25 line-height-24px">' + '<span class="dark-grey font-mukta-mahee font-1p325em">' + data["eventName"] + "</span>" + '<div class="float-right">' + '<span class="display-block medium-dark-grey font-bold">' + eventHype + " HYPE" + "</span>" + "</div>" + "</div>" + "</div>" + '<div class="margin-bottom-20 light-grey empty-event-match-results-text">No matches or segments played</div>').show();
    // Add update containers for each category of updates
    $("#event-updates").html('<div class="event-updates-header font-mukta-mahee font-1p325em menu-header-color margin-bottom-20">Updates</div><div class="event-updates-availability display-none margin-bottom-15"><div class="light-grey font-0p925em margin-bottom-5">Availability</div><div class="updates-container"></div></div><div class="event-updates-overness display-none margin-bottom-20"><div class="light-grey font-0p925em margin-bottom-5">Overness</div><div class="updates-container"></div></div><div class="event-updates-gimmicks display-none margin-bottom-20"><div class="light-grey font-0p925em margin-bottom-5">Gimmicks</div><div class="updates-container"></div></div></div><div class="event-updates-feuds display-none margin-bottom-20"><div class="light-grey font-0p925em margin-bottom-5">Feuds</div><div class="updates-container"></div></div><div class="event-updates-other display-none"><div class="light-grey font-0p925em margin-bottom-5">Other</div><div class="updates-container"></div></div>').hide();
    // Load match result settings
    let matchResultSetting = (0, $98xmD.globalUser).settings["matchResult"];
    if (matchResultSetting) $(".hide-stats").each(function(i, e) {
        switch($(e).text()){
            case "Ovr.":
                if (!matchResultSetting.overness) $(e).removeClass("medium-grey").addClass("extra-light-grey");
                else $(e).removeClass("extra-light-grey").addClass("medium-grey");
                break;
            case "XP":
                if (!matchResultSetting.xp) $(e).removeClass("medium-grey").addClass("extra-light-grey");
                else $(e).removeClass("extra-light-grey").addClass("medium-grey");
                break;
            case "Pop.":
                if (!matchResultSetting.popularity) $(e).removeClass("medium-grey").addClass("extra-light-grey");
                else $(e).removeClass("extra-light-grey").addClass("medium-grey");
                break;
            case "Gim.":
                if (!matchResultSetting.gimmickEffectiveness) $(e).removeClass("medium-grey").addClass("extra-light-grey");
                else $(e).removeClass("extra-light-grey").addClass("medium-grey");
                break;
            case "Feuds":
                if (!matchResultSetting.feuds) $(e).removeClass("medium-grey").addClass("extra-light-grey");
                else $(e).removeClass("extra-light-grey").addClass("medium-grey");
                break;
            case "Mor.":
                if (matchResultSetting.morale === false) $(e).removeClass("medium-grey").addClass("extra-light-grey");
                else $(e).removeClass("extra-light-grey").addClass("medium-grey");
                break;
            case "Fat.":
                if (!matchResultSetting.fatigue) $(e).removeClass("medium-grey").addClass("extra-light-grey");
                else $(e).removeClass("extra-light-grey").addClass("medium-grey");
                break;
        }
    });
    // Run matches and segments
    return $e6954d9b34d9dd89$export$6f7d6178afe1e87f({
        data: data
    });
}
async function $e6954d9b34d9dd89$export$6f7d6178afe1e87f({ data: data, index: index = 0 } = {}) {
    if (data["matchesAndSegmentsData"].length > 0 && index < data["matchesAndSegmentsData"].length) {
        // Play next match/segment
        if (data["matchesAndSegmentsData"][index]["segmentType"] === "match") await (0, $5fab2de231db267f$export$fa6405f9da4f10e6)({
            matchesAndSegmentsData: data["matchesAndSegmentsData"],
            index: index,
            tournamentDisplay: data["tournamentDisplay"],
            cashinData: data["cashinData"]
        });
        else await (0, $67cc16607ee33ebf$export$71048709d8f0e26a)({
            matchesAndSegmentsData: data["matchesAndSegmentsData"],
            index: index,
            tournamentDisplay: data["tournamentDisplay"],
            cashinData: data["cashinData"]
        });
    } else // End event if end of matches and segments
    await (0, $1JSre.makeGameRequest)((0, $5ZsVo.endEventRequest), {}, $e6954d9b34d9dd89$var$showEndEventRequestData, {}, false);
}
function $e6954d9b34d9dd89$var$showEventPreviewData(data) {
    let parent = $("#event-preview-container");
    parent.find(".event-preview-header").text("{0} {1} Preview".format(data["eventName"], data["eventYear"]));
    parent.find(".event-preview-sub-header").text("by The Wrestling Spectator");
    // Preview text
    let previewHtml = "";
    if (data["previewTexts"]) data["previewTexts"].forEach(function(previewText, i) {
        if (i === 0) previewHtml += "<div>{0}</div>".format(previewText);
        else if (i === data["previewTexts"].length - 1) previewHtml += '<div class="margin-top-15 margin-bottom-10">{0}</div>'.format(previewText);
        else previewHtml += '<div class="margin-top-15">{0}</div>'.format(previewText);
    });
    else {
        previewHtml += "<div>{0}</div>".format(data["introText"]);
        previewHtml += '<div class="margin-top-15">{0}</div>'.format(data["interestText"]);
        if (data["topMatchesText"]) previewHtml += '<div class="margin-top-15">{0}</div>'.format(data["topMatchesText"]);
        if (data["matchContractText"]) previewHtml += '<div class="margin-top-15">{0}</div>'.format(data["matchContractText"]);
        if (data["streakText"]) previewHtml += '<div class="margin-top-15">{0}</div>'.format(data["streakText"]);
        previewHtml += '<div class="margin-top-15 margin-bottom-10">Continue on to see our predictions for the event.</div>';
    }
    parent.find(".event-preview-box").html(previewHtml);
    parent.fadeIn();
    parent.find(".event-preview-box").scrollTop(0);
    // Show poster
    (0, $c82cd471f4baff6b$export$ea8a53556b69e3e0)(data["eventPosterData"], $("#event-preview-poster-container"));
}
function $e6954d9b34d9dd89$var$showEventPredictionsData(data, eventActiveEffect) {
    let parent = $("#event-preview-container");
    let previewHtml = "";
    let POWSponsorsText = "";
    if (eventActiveEffect === "premier_event") POWSponsorsText = ", one of the attending sponsors,";
    previewHtml += '<div class="margin-bottom-15">Here is {0}{1} with {2} predictions for the event:</div>'.format(data["journalistName"], POWSponsorsText, data["journalistPossessivePronoun"]);
    data["predictions"].forEach(function(prediction) {
        previewHtml += '<div class="margin-bottom-15"><div class="margin-bottom-5 font-bold">' + prediction["matchText"] + "</div>" + '<div class="font-style-italic">Prediction: ' + prediction["predictionText"] + "</div>" + "</div>";
    });
    previewHtml += '<div class="margin-top-15 margin-bottom-15">Let\'s see how those predictions hold up at the event.</div>';
    parent.find(".event-preview-box").html(previewHtml);
    parent.find(".event-preview-box").scrollTop(0);
}
function $e6954d9b34d9dd89$export$46dc9792936abd2f(eventHype) {
    if (eventHype < 0) eventHype = "- " + eventHype * -1;
    else eventHype = "+ " + eventHype;
    return '<span class="event-hype-text">' + eventHype + "</span>";
}
async function $e6954d9b34d9dd89$var$showEndEventRequestData({ data: data } = {}) {
    if (!data["error"]) {
        // Show post event dialog for PoW
        if (data["postEventDialogs"] && data["postEventDialogs"].length > 0) (0, $e37bb324c1adb297$export$22af59cdbd54e1f8)(data["postEventDialogs"]);
        // Update ui
        $("#progress-segment-button").remove();
        $(".match-container").show();
        $("#superstar_info").removeClass("match");
        $("#continue-container").show();
        // Reset viewership, load post event
        $e6954d9b34d9dd89$var$resetViewershipContainer(data);
        await $e6954d9b34d9dd89$var$loadPostEventData(data);
        // Show event result
        $e6954d9b34d9dd89$var$showEventResult(data);
        // Show updates
        $e6954d9b34d9dd89$var$showEndEventUpdates(data);
        (0, $67cc16607ee33ebf$export$45a344294533d7c2)();
        (0, $1JSre.updateGamePointsAndFans)(data["points"], data["fans"]);
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_event_continue");
        // Save to cloud
        if (!(0, $98xmD.globalUser).developerMode) {
            await (0, $993642189aedf295$export$d3ab5fe070517e4f)(false);
            await (0, $bZol7.syncUserData)();
        }
    } else {
        let errorText = "There was an error ending the Event.";
        notie.alert({
            type: 3,
            text: errorText
        });
    }
}
function $e6954d9b34d9dd89$var$resetViewershipContainer(data) {
    $(".viewership-results-box-container").html("");
    if (data["weeklyShow"]) {
        $(".viewership-results-box-header").text("Viewers");
        $(".viewership-results-box-options").show();
        $(".viewership-results-box-option").removeClass("medium-grey").addClass("extra-light-grey");
        $(".viewership-results-box-option").eq(0).addClass("medium-grey").removeClass("extra-light-grey");
    } else {
        $(".viewership-results-box-header").text("Buys");
        $(".viewership-results-box-options").hide();
    }
}
let $e6954d9b34d9dd89$var$competitorsSimulated = true;
async function $e6954d9b34d9dd89$var$loadPostEventData(data) {
    // Update whether to skip post event
    if (data["skipSimulateCompetitors"]) $("#continue").data("skipPostEvent", true);
    else $("#continue").data("skipPostEvent", false);
    // Simulate competitors
    if ((0, $98xmD.globals).game.competitorsPresent && !data["skipSimulateCompetitors"]) {
        $e6954d9b34d9dd89$var$competitorsSimulated = false;
        let showNews = !data["weeklyShow"];
        $("#continue").data("showNews", showNews);
        $(".news-content").html("");
        await (0, $1JSre.makeGameRequest)((0, $f0da149825527215$export$3afbd25365a8855a), {}, $e6954d9b34d9dd89$var$showSimulateCompetitorsData, {
            showNews: showNews
        }, false);
    }
}
function $e6954d9b34d9dd89$var$showEventResult(data) {
    let eventResultsSelector = $("#event-match-results");
    // Add rating
    let ratingStarsHtml = (0, $1JSre.getStarRatingHtml)(data["rating"]);
    let ratingHelpText;
    if ((0, $98xmD.globals).game.story === "mars") ratingHelpText = "Average of Solar Wrestling News, EarthSideMatch and CircledSquare";
    else ratingHelpText = "Average of The Wrestling Spectator, RingSideChairs and CircledSquare";
    let ratingHtml = '<span class="match-star-rating help-text" title="' + ratingHelpText + '" role="text" aria-label="Event Rating: ' + data["rating"] + " stars" + '">' + ratingStarsHtml + "</span>";
    // Display points and fans increase
    let pointsHtml;
    if (data["pointsToAdd"] >= 0) pointsHtml = '<span class="event-results-points-change margin-bottom-10 font-1p125em help-text" title="Depends on Event Rating"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small"/><i class="fa fa-angle-double-up margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Increase"></i><span class="dark-grey">' + data["pointsToAdd"] + "</span></span>";
    else pointsHtml = '<span class="event-results-points-change margin-bottom-10 font-1p125em help-text" title="Depends on Event Rating"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small"/><i class="fa fa-angle-double-down margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Decrease"></i><span class="dark-grey">' + data["pointsToAdd"] + "</span></span>";
    let fansHtml = "";
    let hypeMultiplier = "";
    if (data["fansGained"] !== undefined) {
        // Show fans for old system
        let fans = data["fansGained"].toLocaleString();
        if (data["fansGained"] >= 0) fansHtml = '<span class="event-results-fan-change margin-left-15 margin-bottom-10 font-1p125em help-text" title="Fan Change: Depends on Event Rating, Fan Multiplier and Company Reputation"><img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small"/><i class="fa fa-angle-double-up margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Increase"></i><span class="dark-grey">' + fans + "</span></span>";
        else fansHtml = '<span class="event-results-fan-change margin-left-15 margin-bottom-10 font-1p125em help-text" title="Fan Change: Depends on Event Rating, Fan Multiplier and Company Reputation"><img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small"/><i class="fa fa-angle-double-down margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Decrease"></i><span class="dark-grey">' + fans + "</span></span>";
        hypeMultiplier = '<span class="event-results-fan-change margin-left-15 margin-bottom-10 font-1p125em help-text" title="Fan Multiplier: Depends on Event Hype."><span class="faded-red-light">' + data["hypeMultiplier"] + "x</span></span>";
    }
    // Add to event results
    eventResultsSelector.append('<div class="event-results-container" tabindex="0"><div class="col1 font-mukta-mahee font-1p125em">' + pointsHtml + fansHtml + hypeMultiplier + "</div>" + '<div class="col2 text-right">' + ratingHtml + "</div>" + '<div class="clear"></div>' + "</div>");
}
function $e6954d9b34d9dd89$var$showEndEventUpdates(data) {
    let prestigeResultsSelector = $("#prestige-results");
    let eventUpdatesSelector = $(".event-updates-other .updates-container");
    let eventUpdatesAvailabilitySelector = $(".event-updates-availability .updates-container");
    let eventUpdatesOvernessSelector = $(".event-updates-overness .updates-container");
    let eventUpdatesFeudsSelector = $(".event-updates-feuds .updates-container");
    // Match contracts not held
    data["matchContractsNotUsed"].forEach(function(contract) {
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">Due to the <span class="gold">' + contract["matchContract"] + " Contract</span>" + " not being used, " + "fans were disappointed" + '<img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small margin-right-5 margin-left-8"/>' + '<i class="fa fa-angle-double-down margin-right-5 red"></i>' + '<span class="red">' + contract["penalty"].toLocaleString("en") + "</span>" + "<span/>");
    });
    // Trade returns
    if (data["tradeReturns"].length > 0) {
        let text;
        if (data["tradeReturns"].length > 1) text = '<span class="display-block">' + data["tradeReturns"].slice(0, -1).join(", ") + " and " + data["tradeReturns"].slice(-1) + " have left due to the trade deal ending" + "</span>";
        else text = '<span class="display-block">' + data["tradeReturns"][0] + " left due to the trade deal ending" + "</span>";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    }
    // Vacated titles
    data["vacated"].forEach(function(vacated) {
        let text;
        let championshipName = (0, $1JSre.getChampionshipDisplayName)(vacated);
        if (!vacated["tagTeam"] && !vacated["trio"]) text = '<span class="gold">' + championshipName + "</span>" + " has been vacated";
        else text = '<span class="gold">' + championshipName + "</span>" + " have been vacated";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Event prestige
    if (data["eventPrestige"]) {
        let progress = 100;
        if (data["eventPrestige"]["prestige"] !== "A") progress = (data["eventPrestige"]["xp"] - data["eventPrestige"]["baseXp"]) / (data["eventPrestige"]["xpToNextPrestige"] - data["eventPrestige"]["baseXp"]) * 100;
        if (progress > 100) progress = 100;
        else if (progress < 0) progress = 0;
        let xpChangeHtml;
        let xpChange = data["eventPrestige"]["xpChange"];
        if (data["eventPrestige"]["xpChange"] >= 0) xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + "</span>";
        else if (data["eventPrestige"]["xpChange"] < 0) xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' + -1 * xpChange + "</span>";
        let prestigeIcon;
        switch(data["eventPrestige"]["prestige"]){
            case "C":
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case "B":
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case "A":
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }
        let prestigeText = '<div class="display-block margin-bottom-5"><div class="display-inline-block"><span>' + data["eventPrestige"]["name"] + "</span>" + prestigeIcon + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey prestige-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text" title="' + data["eventPrestige"]["xp"] + " / " + data["eventPrestige"]["xpToNextPrestige"] + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>";
        if (data["eventPrestige"]["prestigeIncrease"]) {
            prestigeText += '<span class="gold display-block margin-top-12">Event Prestige Increased</span>';
            prestigeText += '<span class="display-block grey margin-top-5"><i class="fa fa-angle-double-up margin-right-5"></i>Match Limit increased to ' + data["eventPrestige"]["matchLimit"] + " for this Event</span>";
        } else if (data["eventPrestige"]["prestigeDecrease"]) {
            prestigeText += '<span class="puke-green display-block margin-top-12">Event Prestige Decreased</span>';
            prestigeText += '<span class="display-block grey margin-top-5"><i class="fa fa-angle-double-down margin-right-5"></i>Match Limit decreased to ' + data["eventPrestige"]["matchLimit"] + " for this Event</span>";
        }
        prestigeResultsSelector.find(".event-prestige-header").after('<div class="event-prestige-progress margin-bottom-25">' + prestigeText + "</div>");
        $(".event-prestige-progress .prestige-xp-value").hide().fadeIn("slow");
        setTimeout(function() {
            $(".event-prestige-progress .progress").addClass("expand-width");
        }, 0);
        setTimeout(function() {
            $(".event-prestige-progress .progress").removeClass("expand-width");
        }, 1800);
    }
    // Reputation for old system
    if (data["reputation"] !== undefined) {
        // Show reputation level
        let progress;
        let max = "";
        if (data["reputation"] < 10) progress = (data["fans"] - data["previousReputation"]) / (data["nextReputation"] - data["previousReputation"]) * 100;
        else {
            progress = 100;
            max = "MAX";
        }
        if (progress > 100) progress = 100;
        else if (progress < 0) progress = 0;
        let xpChangeHtml;
        let xpChange = data["reputationXpChange"];
        if (xpChange >= 0) xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + "</span>";
        else if (xpChange < 0) xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' + -1 * xpChange + "</span>";
        let levelText = '<div class="display-block margin-bottom-5"><div class="display-inline-block"><span class="margin-right-5">' + data["companyName"] + " REP</span>" + "<span>" + data["reputation"] + "</span>" + '<span class="margin-left-8 red">' + max + "</span>" + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey prestige-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text" title="' + data["reputationXp"].toLocaleString("en") + " / " + data["xpToNextReputation"].toLocaleString("en") + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>";
        if (data["reputationIncrease"]) levelText += '<span class="gold display-block margin-top-12">Reputation Increased</span>';
        else if (data["reputationDecrease"]) levelText += '<span class="puke-green display-block margin-top-12">Reputation Decreased</span>';
        // Show new roster size upon reputation increase
        if (data["rosterSize"] && !(0, $98xmD.globals).game.maximumRosterCapacity) {
            let rosterText;
            if (data["reputationIncrease"]) rosterText = '<span class="display-block grey"><i class="fa fa-angle-double-up margin-right-5"></i>Roster size increased to ' + data["rosterSize"] + "</span>";
            else rosterText = '<span class="display-block grey"><i class="fa fa-angle-double-down margin-right-5"></i>Roster size decreased to ' + data["rosterSize"] + "</span>";
            levelText += '<span class="display-block margin-top-5">' + rosterText + "</span>";
        }
        prestigeResultsSelector.find(".event-prestige-header").after('<div class="company-reputation margin-bottom-25">' + levelText + "</div>");
        $(".company-reputation .prestige-xp-value").hide().fadeIn("slow");
        setTimeout(function() {
            $(".company-reputation .progress").addClass("expand-width");
        }, 0);
        setTimeout(function() {
            $(".company-reputation .progress").removeClass("expand-width");
        }, 1800);
    }
    // Expiring championship contracts
    data["expiringChampionships"].forEach(function(championship) {
        let text = '<span class="display-block"><span class="gold">' + championship + "</span> will expire at the upcoming event" + "</span>";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Expired championship contracts
    data["expiredChampionships"].forEach(function(championship) {
        let text = '<span class="display-block"><span class="gold">' + championship + "</span> has expired" + "</span>";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Feud potential
    if (data["feudPotential"]) {
        let feudPotentialHtml = (0, $1JSre.getFeudPotentialHtml)(data["feudPotential"]);
        eventUpdatesFeudsSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + feudPotentialHtml + "</span>");
    }
    // Feud hype increased
    if (data["feudHypeIncreased"]) {
        let feudHypeIncreased = (0, $1JSre.getFeudHypeIncreasedHtml)(data["feudHypeIncreased"]);
        eventUpdatesFeudsSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + feudHypeIncreased + "</span>");
    }
    // Not used at event
    if (data["notUsedAtEvent"].length > 3) {
        // Show together if more than 4 changes
        let overnessDecreases = Array.from(data["notUsedAtEvent"], function(s) {
            return s["name"];
        });
        if (overnessDecreases.length > 1) overnessDecreases = overnessDecreases.slice(0, -1).join(", ") + " and " + overnessDecreases.slice(-1);
        else overnessDecreases = overnessDecreases.join("");
        let changeWord = data["notUsedAtEvent"][0]["increase"] ? "increased" : "decreased";
        let text = "{0}'s Overness ".format(overnessDecreases) + changeWord + " a Level";
        if (changeWord === "decreased") text += " due to not being used at the Event.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    } else data["notUsedAtEvent"].forEach(function(overnessChange) {
        let overnessPercentage = '<span class="light-grey margin-left-5">' + overnessChange["overness"] + '<span class="margin-left-2">%</span></span>';
        let changeWord = overnessChange["increase"] ? "increased" : "decreased";
        let text = "{0}'s Overness{1} ".format(overnessChange["name"], overnessPercentage) + changeWord + ' from <span class="light-grey">' + overnessChange["previousOverness"] + " to " + overnessChange["currentOverness"] + "</span>";
        if (changeWord === "decreased") text += " due to not being used at the Event.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Hot changes
    data["hotChanges"].forEach(function(hotChange) {
        let text;
        if (hotChange["status"] === "hotStart") text = hotChange["name"] + ' is starting to get <span class="hot-color">Over</span> with the Fans';
        else if (hotChange["status"] === "hotEnd") text = hotChange["name"] + ' is no longer <span class="hot-color">Over</span> with the Fans. ' + "All boosts have been removed.";
        else if (hotChange["status"] === "hot") text = hotChange["name"] + ' got <span class="hot-color hot-text">Over</span> with the Fans, ' + " boosting " + hotChange["pronoun"] + " Attributes and performance in Matches, Segments and Feuds.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        setTimeout(function() {
            $(".hot-text").addClass("flash-text-orange");
        }, 200);
        setTimeout(function() {
            $(".hot-text").removeClass("flash-text-orange");
        }, 3000);
    });
    // Stale changes
    data["staleChanges"].forEach(function(staleChange) {
        let text;
        if (staleChange["status"] === "staleStart") text = staleChange["name"] + ' is starting to become <span class="stale-color">Stale</span> with the Fans';
        else if (staleChange["status"] === "staleEnd") text = staleChange["name"] + ' is no longer <span class="stale-color">Stale</span> with the Fans. ' + "All negative effects have been removed.";
        else if (staleChange["status"] === "stale") text = staleChange["name"] + ' became <span class="stale-color stale-text">Stale</span> with the Fans, ' + " lowering " + staleChange["pronoun"] + " performance in Matches, Segments and Feuds.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        setTimeout(function() {
            $(".stale-text").addClass("flash-text-stale");
        }, 200);
        setTimeout(function() {
            $(".stale-text").removeClass("flash-text-stale");
        }, 3000);
    });
    // Rehabbed
    data["rehabbed"].forEach(function(rehab) {
        let doctorAgeMultiplier = rehab["doctorAgeMultiplier"];
        let doctorXp = '<span class="green margin-left-8">+ ' + rehab["doctorXpGained"] + " XP</span>";
        if (doctorAgeMultiplier !== 1) doctorXp += '<span class="light-grey margin-left-8 font-0p925em">(' + doctorAgeMultiplier + '<span class="help-text" title="Age affects progression of ' + 'Skill Level. Younger staff members gain XP faster than older ones.">x Age Multiplier</span>)' + "</span>";
        let text = '{0}\'s recovery from <span class="dark-red">injury</span> was helped by rehab from {1}{2}'.format(rehab["name"], rehab["doctorName"], doctorXp);
        eventUpdatesAvailabilitySelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Staff skill increases
    data["staffSkillIncreases"].forEach(function(staffMember) {
        let roleHtml = '<span class="light-grey">(' + (0, $3E8Nt.toTitleCase)(staffMember["role"].replace(/_/g, " ")) + ")</span>";
        let skillLevelHtml = '<span class="staff-color">Skill</span>';
        let text = '{0}\'s {1} {2} increased to <span class="gold">Level {3}</span>'.format(staffMember["name"], roleHtml, skillLevelHtml, staffMember["level"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Staff tasks completed
    data["staffTasksCompleted"].forEach(function(task) {
        let taskHtml = '<span class="medium-grey">' + task["name"] + "</span>";
        let xpGained = '<span class="green margin-left-5">+ ' + task["xpGained"] + " XP</span>";
        if (task["xpAgeMultiplier"] !== 1) xpGained += '<span class="light-grey margin-left-8 font-0p925em">(' + task["xpAgeMultiplier"] + '<span class="help-text" title="Age affects progression of ' + 'Skill Level. Younger staff members gain XP faster than older ones.">x Age Multiplier</span>' + ")</span>";
        let text = "{0} completed the {1} task {2}</span>".format(task["staffMember"], taskHtml, xpGained);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Staff actions completed
    data["staffActionsCompleted"].forEach(function(task) {
        let xpGained = '<span class="green margin-left-8">+ ' + task["xpGained"] + " XP</span>";
        if (task["xpAgeMultiplier"] !== 1) xpGained += '<span class="light-grey margin-left-8 font-0p925em">(' + task["xpAgeMultiplier"] + '<span class="help-text" title="Age affects progression of ' + 'Skill Level. Younger staff members gain XP faster than older ones.">x Age Multiplier</span>' + ")</span>";
        let text = "{0} {1} {2}</span>".format(task["staffMember"], task["name"], xpGained);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Championships not used
    if (data["championshipsNotUsedRecently"]) {
        let xpChange = '<span class="red margin-left-3">- ' + data["championshipNotUsedXpChange"] * -1 + " XP</span>";
        let championshipNameHtml = '<span class="gold">' + data["championshipsNotUsedRecently"] + "</span>";
        let text = '<span class="display-block">Prestige of the ' + championshipNameHtml + " decreased due to not being used in over 6 months " + xpChange + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after('<span class="display-block margin-bottom-15 dark-grey">' + text + "</span>");
    }
    // Morale changes
    data["moraleChanges"].forEach(function(moraleChange) {
        let moralePercentage = '<span class="light-grey margin-left-5">' + moraleChange["morale"] + '<span class="margin-left-2">%</span></span>';
        let text = "{0}'s Morale{1} ".format(moraleChange["name"], moralePercentage) + ' changed to <span class="light-grey">' + moraleChange["currentMorale"] + '</span> from <span class="light-grey">' + moraleChange["previousMorale"] + "</span>";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Morale decreases due to not used
    if (data["notUsedMoraleDecreases"].length > 0) {
        let moraleDecreasesNames = Array.from(data["notUsedMoraleDecreases"], function(s) {
            return s["name"];
        });
        let moralePercentage = '<span class="puke-green margin-left-3">' + data["notUsedMoraleDecreases"][0]["decrease"] + '<span class="margin-left-2">%</span></span>';
        let text = "{0}'s Morale ".format((0, $3E8Nt.commaSeparate)(moraleDecreasesNames)) + "decreased by " + moralePercentage;
        text += " due to not being used at the Event.";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    }
    // Popularity decrease due to not used
    if (data["notUsedPopularityDecreases"].length > 0) {
        let popularityDecreasesNames = Array.from(data["notUsedPopularityDecreases"], function(s) {
            return s["name"] + '<span class="margin-left-5 light-grey"><i class="fa fa-angle-double-down margin-right-5"></i>' + s["decrease"] + "</span>";
        });
        let text = "Popularity of {0}".format((0, $3E8Nt.commaSeparate)(popularityDecreasesNames)) + " decreased due to not being used at the Event.";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    }
    // Fotc changes
    data["fotcChanges"].forEach(function(data) {
        let faceOfTheCompanyText;
        if (data["faceOfTheCompany"]) faceOfTheCompanyText = data["name"] + " became a " + '<span class="medium-blue">' + "Face of the Company" + "</span>!";
        else faceOfTheCompanyText = data["name"] + " is no longer a Face of the Company";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + faceOfTheCompanyText + "</span>");
    });
    // Faction reputation progress
    data["factionReputationsData"].forEach(function(factionReputationData) {
        (0, $1JSre.showFactionReputationData)(factionReputationData);
    });
    // Company overness changes
    let companyOvernessChange = data["companyOvernessChange"];
    if (companyOvernessChange !== undefined) {
        let overnessPercentage = '<span class="light-grey margin-left-5">' + companyOvernessChange["overness"] + '<span class="margin-left-2">%</span></span>';
        let changeWord = companyOvernessChange["increase"] ? "increased" : "decreased";
        let text = "{0}'s Overness{1} ".format(companyOvernessChange["name"], overnessPercentage) + changeWord + ' from <span class="light-grey">' + companyOvernessChange["previousOverness"] + " to " + companyOvernessChange["currentOverness"] + "</span>";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    }
    // Brand overness changes
    let brandOvernessChange = data["brandOvernessChange"];
    if (brandOvernessChange !== undefined) {
        // Get brand name and color
        let brandNameStyleHtml = "";
        if (brandOvernessChange["color"] && !(0, $98xmD.globalUser).settings.colorblindMode) brandNameStyleHtml = ' style="color: ' + brandOvernessChange["color"] + '"';
        let brandNameHtml = "<span" + brandNameStyleHtml + ">" + brandOvernessChange["name"] + "</span>";
        let overnessPercentage = '<span class="light-grey margin-left-5">' + brandOvernessChange["overness"] + '<span class="margin-left-2">%</span></span>';
        let changeWord = brandOvernessChange["increase"] ? "increased" : "decreased";
        let text = "{0}'s Overness{1} ".format(brandNameHtml, overnessPercentage) + changeWord + ' from <span class="light-grey">' + brandOvernessChange["previousOverness"] + " to " + brandOvernessChange["currentOverness"] + "</span>";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    }
}
function $e6954d9b34d9dd89$var$showSimulateCompetitorsData({ data: data, showNews: showNews } = {}) {
    if (data["error"]) {
        let text;
        if (data["error"] === "simulate-competitor-event") text = "There was an error simulating some competitors. Please continue to your next event. Competitor simulations might not work for the next event but should work afterwards.";
        else if (data["error"] === "simulate-competitors") text = "There was an error simulating competitors. Please continue to your next event. Competitor simulations might not work for the next event but should work afterwards.";
        notie.alert({
            type: 3,
            text: text,
            stay: true
        });
    }
    $e6954d9b34d9dd89$var$competitorsSimulated = true;
    if (data["news"] && showNews) $e6954d9b34d9dd89$var$displayNews(data["news"]);
    let fanChangeData = data["fanChangeData"];
    if (fanChangeData) {
        if (fanChangeData["viewershipData"]) $e6954d9b34d9dd89$var$displayViewershipData(fanChangeData["viewershipData"]);
        if (fanChangeData["reputationData"].length > 0) $e6954d9b34d9dd89$var$displayReputationData(fanChangeData["reputationData"]);
    }
}
function $e6954d9b34d9dd89$var$displayNews(data) {
    if ((0, $98xmD.globals).game.story === "mars") {
        if (!(0, $98xmD.globals).game.earth) {
            $(".news-heading").text("Martian Wrestling News");
            $(".news-heading").addClass("mars-red");
            $(".news-box").addClass("mars-box");
        } else {
            $(".news-heading").text("Earth Wrestling News");
            $(".news-heading").removeClass("mars-red");
            $(".news-box").removeClass("mars-box");
        }
    } else {
        $(".news-heading").text("The Wrestling Spectator");
        $(".news-heading").removeClass("font-1p125em font-bold mars-red margin-bottom-20");
        $(".news-heading").addClass("font-nanum-gothic margin-bottom-10");
        $(".news-box").removeClass("mars-box");
    }
    $(".news-subheading").hide();
    if (data.length) data.forEach(function(news) {
        let newsHtml = $e6954d9b34d9dd89$export$37886a697c58e9e2(news, true);
        $(".news-content").append(newsHtml);
    });
    else $(".news-content").append('<div class="margin-bottom-15 news-item font-lora">Nothing significant happened this month. Surely things will pick up. It\'s the wrestling business after all.</div>');
    if ((0, $98xmD.globals).game.story === "mars") $(".news-subheading").html((0, $98xmD.globals).game.month + ", Year " + (0, $98xmD.globals).game.year).show();
    else $(".news-subheading").html((0, $98xmD.globals).game.month + " " + (0, $98xmD.globals).game.year).show();
}
function $e6954d9b34d9dd89$export$37886a697c58e9e2(news, showContent = true, simulation = false) {
    let newsHtml;
    let company = "";
    if (news["company"]) company = news["company"];
    let content = "";
    if (showContent) content = '<div class="font-normal margin-top-2">' + news["content"] + "</div>";
    if (news["headline"] && !simulation) newsHtml = '<div class="margin-bottom-25 display-block news-item headline"><div class="news-item-title font-bold margin-bottom-10 text-center font-libre-bakerville">' + news["title"] + "</div>" + '<div class="font-lora">' + content + "</div>" + "</div>";
    else {
        let newsClass = "margin-bottom-20";
        if (simulation) newsClass = "";
        newsHtml = '<div class="' + newsClass + ' news-item">' + '<div class="font-bold font-libre-bakerville font-15px">' + '<span class="company-name grey">' + company + "</span> " + '<span class="news-item-title">' + news["title"] + "</span>" + "</div>" + '<div class="font-lora">' + content + "</div>" + "</div>";
    }
    return newsHtml;
}
function $e6954d9b34d9dd89$var$displayViewershipData(data) {
    let html = "";
    data.forEach(function(viewershipData) {
        let fanChangeHtml = "";
        if (viewershipData["fanChange"] !== undefined) {
            let roundedFanChange = Math.round((viewershipData["fanChange"] / 1000 + Number.EPSILON) * 100) / 100;
            if (roundedFanChange >= 0) {
                let fanChangeText;
                if (roundedFanChange < 1) fanChangeText = "{0} Fans".format((roundedFanChange * 1000).toLocaleString("en"));
                else fanChangeText = "{0}K Fans".format(roundedFanChange.toLocaleString("en"));
                fanChangeHtml = '<span class="margin-left-8 light-grey viewership-results-fan-change"><i class="fa fa-angle-double-up top-1px margin-right-5" role="text" aria-label="Increase"></i>' + fanChangeText + "</span>";
            } else {
                let fanChangeText;
                roundedFanChange *= -1;
                if (roundedFanChange < 1) fanChangeText = "{0} Fans".format((roundedFanChange * 1000).toLocaleString("en"));
                else fanChangeText = "{0}K Fans".format(roundedFanChange.toLocaleString("en"));
                fanChangeHtml = '<span class="margin-left-8 light-grey viewership-results-fan-change"><i class="fa fa-angle-double-down top-1px margin-right-5" role="text" aria-label="Decrease"></i>' + fanChangeText + "</span>";
            }
            // Show total fan change label
            if (viewershipData["multipleCompanyEvents"]) fanChangeHtml += ' <span class="light-grey help-text" title="Total fan change is based on the results of all weekly shows shown for this company.">(Total)</span>';
        }
        let viewershipText = (0, $1JSre.getViewershipText)(viewershipData["viewership"]);
        // Get player name
        let playerNameHtml = "";
        if (viewershipData["playerName"]) playerNameHtml = '<div class="medium-grey">{0}</div>'.format(viewershipData["playerName"]);
        // User controlled class
        let userControlledClass = "";
        if (viewershipData["isUserControlled"]) userControlledClass = " user-company";
        // Last weekly show label
        let lastWeeklyShowLabelHtml = "";
        if (viewershipData["pastEvent"]) lastWeeklyShowLabelHtml = '<div class="light-grey margin-top-2 help-text" title="Fan change is based on this company\'s last weekly show.">Last Weekly Show</div>';
        // Brand
        let brandNameHtml = "";
        let eventStyleHtml = "";
        if (viewershipData["weeklyShow"]) {
            // Add brand color to event name for weekly shows
            if (viewershipData["brandColor"]) {
                if (viewershipData["brandColor"] && !(0, $98xmD.globalUser).settings.colorblindMode) eventStyleHtml = ' style="color: ' + viewershipData["brandColor"] + '"';
            }
        } else // Show brand name with color for monthly events
        if (viewershipData["brandName"]) {
            let brandNameStyleHtml = "";
            if (viewershipData["brandColor"] && !(0, $98xmD.globalUser).settings.colorblindMode) brandNameStyleHtml = ' style="color: ' + viewershipData["brandColor"] + '"';
            brandNameHtml = ' <span class="medium-grey display-inline-block"' + brandNameStyleHtml + ">" + viewershipData["brandName"] + "</span>";
        }
        html += '<div class="viewership-results-item-container' + userControlledClass + '" data-viewership="' + viewershipData["viewership"] + '" ' + 'data-nielsen-rating="' + viewershipData["nielsenRating"] + '">' + '<div class="viewership-results-item-column-left">' + '<div class="margin-bottom-12 font-1p25em darker-grey line-height-24px"' + eventStyleHtml + ">" + viewershipData["event"] + "</div>" + "<div>" + '<span class="medium-grey">' + viewershipData["company"] + "</span>" + brandNameHtml + fanChangeHtml + playerNameHtml + lastWeeklyShowLabelHtml + "</div>" + "</div>" + '<div class="viewership-results-item-column-right text-right">' + '<div class="font-1p4em margin-bottom-15 darker-grey viewership-results-item-number display-inline-block">' + viewershipText + "</div>" + '<div class="font-1p125em" role="text" aria-label="Latest Event Rating: ' + viewershipData["rating"] + " stars" + '">' + (0, $1JSre.getStarRatingHtml)(viewershipData["rating"]) + "</div>" + "</div>" + '<div class="clear"></div>' + "</div>";
    });
    $(".viewership-results-box-container").html(html);
}
function $e6954d9b34d9dd89$var$displayReputationData(data) {
    data.forEach(function(reputationData) {
        // Show reputation level
        let progress;
        let max = "";
        if (reputationData["reputation"] < 10) progress = (reputationData["reputationXp"] - reputationData["xpToPreviousReputation"]) / (reputationData["xpToNextReputation"] - reputationData["xpToPreviousReputation"]) * 100;
        else {
            progress = 100;
            max = "MAX";
        }
        if (progress > 100) progress = 100;
        else if (progress < 0) progress = 0;
        let xpChangeHtml;
        let xpChange = reputationData["reputationXpChange"];
        if (xpChange >= 0) xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + "</span>";
        else if (xpChange < 0) xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' + -1 * xpChange + "</span>";
        let levelText = '<div class="display-block margin-bottom-5"><div class="display-inline-block"><span class="margin-right-5">' + reputationData["companyName"] + " REP</span>" + "<span>" + reputationData["reputation"] + "</span>" + '<span class="margin-left-8 red">' + max + "</span>" + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey prestige-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text" title="' + reputationData["reputationXp"].toLocaleString("en") + " / " + reputationData["xpToNextReputation"].toLocaleString("en") + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>";
        if (reputationData["reputationIncrease"]) levelText += '<span class="gold display-block margin-top-12">Reputation Increased</span>';
        else if (reputationData["reputationDecrease"]) levelText += '<span class="puke-green display-block margin-top-12">Reputation Decreased</span>';
        // Show new roster size upon reputation increase
        if (reputationData["rosterSize"] && !(0, $98xmD.globals).game.maximumRosterCapacity) {
            let rosterText;
            if (reputationData["reputationIncrease"]) rosterText = '<span class="display-block grey"><i class="fa fa-angle-double-up margin-right-5"></i>Roster size increased to ' + reputationData["rosterSize"] + "</span>";
            else rosterText = '<span class="display-block grey"><i class="fa fa-angle-double-down margin-right-5"></i>Roster size decreased to ' + reputationData["rosterSize"] + "</span>";
            levelText += '<span class="display-block margin-top-5">' + rosterText + "</span>";
        }
        $("#prestige-results").find(".event-prestige-header").after('<div class="company-reputation margin-bottom-25">' + levelText + "</div>");
    });
    $(".company-reputation .prestige-xp-value").hide().fadeIn("slow");
    setTimeout(function() {
        $(".company-reputation .progress").addClass("expand-width");
    }, 0);
    setTimeout(function() {
        $(".company-reputation .progress").removeClass("expand-width");
    }, 1800);
    if (!$("#prestige-results").is(":visible")) $("#prestige-results").fadeIn("slow");
}
function $e6954d9b34d9dd89$var$showVacateSuperstarChampionshipsData({ data: data, element: element } = {}) {
    data["vacatedChampionships"].forEach(function(championship) {
        let verb = championship["tagTeam"] || championship["trio"] ? "have" : "has";
        let championshipName = (0, $1JSre.getChampionshipDisplayName)(championship);
        let notieText = '<span class="gold">' + championshipName + "</span> " + verb + " been vacated";
        element.parent().after('<span class="display-block margin-bottom-12 dark-grey">' + notieText + "</span>");
    });
    element.remove();
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_vacate_superstar_championships_button");
}



const $f18c00e15af0c7db$var$emptyTalentInfoHtml = '<div class="superstar-information-container font-bold medium-grey">Participant Details<div class="empty-superstar-info light-grey"><div class="vertical-center">Hover over a Participant to display their details here</div></div></div>';
const $f18c00e15af0c7db$var$tagMatchOptionsHtml = '<div class="tag-match-options margin-top-10"><span class="tag-match-option selected">Tag</span><span class="tag-match-option">Trio</span><span class="tag-match-option">2v2</span><span class="tag-match-option">3v3</span><span class="tag-match-option">4v4</span><span class="tag-match-option">5v5</span><span class="tag-match-option">1v2</span><span class="tag-match-option">1v3</span><span class="tag-match-option">2v3</span><span class="tag-match-option">?v?</span></div>';
const $f18c00e15af0c7db$var$customTeamSizeInput = '<div class="margin-top-10 custom-team-size-inputs"><input type="number" class="custom-team-size-input custom-team-size-a styled-input" name="custom-team-size" value="3" max="10" min="1"><input type="number" class="custom-team-size-input custom-team-size-b styled-input margin-left-5" name="custom-team-size" value="4" max="10" min="1"></div>';
let $f18c00e15af0c7db$var$randomizeFeudHintShown = false;
// Declare variables
let $f18c00e15af0c7db$var$selectedParticipants = [];
let $f18c00e15af0c7db$var$selectedElements = [];
let $f18c00e15af0c7db$var$selectedChampionship;
let $f18c00e15af0c7db$var$selectedGimmickMatch;
let $f18c00e15af0c7db$var$teams = [];
let $f18c00e15af0c7db$var$tagTeamSize = 2;
let $f18c00e15af0c7db$var$tagVal = 2;
let $f18c00e15af0c7db$var$handicapSize;
let $f18c00e15af0c7db$var$segmentParticipants = [];
$(document).ready(function() {
    // Declare selectors
    const $game = $("#game");
    const $mainMenuRight = $("#main-menu-right");
    const $addSegmentItemMenu = $("#add-segment-item-menu");
    const $segmentItemsContainer = $("#segment-items-container");
    const $bookingContainer = $("#booking-container");
    const $selectGimmickMatchContainer = $("#select-gimmick-match-container");
    const $container = $("#container");
    const $matches = $("#matches");
    // ** MATCHES **
    // Book singles menu button
    $mainMenuRight.on("click", "#book-singles-menu-button", async function() {
        // Reset ui
        $("#booking-menu").find("li").removeClass("selected");
        $(this).addClass("selected");
        $("#booking-talent-container").removeClass("compact segments-selection");
        $(".match-participants-container").text("No participants selected");
        $("#multi-match-info").remove();
        $(".tooltip").remove();
        $(".tag-match-options").remove();
        $("#show-gimmick-matches-button").removeClass("selected").find(".fa").removeClass("fa-minus-circle").addClass("fa-plus-circle");
        $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
        $("#show-gimmick-matches-button").show();
        $("#add-tournament-menu-button").show();
        // Reset variables
        $f18c00e15af0c7db$var$selectedChampionship = "";
        $f18c00e15af0c7db$var$selectedParticipants = [];
        $f18c00e15af0c7db$var$selectedElements = [];
        $f18c00e15af0c7db$var$selectedGimmickMatch = "";
        // Show feuds
        let matchType = "singles";
        const $bookMatchFeudsContainer = $(".book-match-feuds-container");
        await (0, $1JSre.makeGameRequest)((0, $cXLSF.getFeudsForBooking), {
            matchType: matchType
        }, $f18c00e15af0c7db$var$showGetFeudsForBookingData, {
            matchType: matchType,
            $el: $bookMatchFeudsContainer
        }, false, true);
        // Show singles booking data
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingData), {
            matchType: matchType
        }, $f18c00e15af0c7db$var$showGetBookingData, {
            matchType: matchType
        });
    });
    // Book tag team menu button
    $mainMenuRight.on("click", "#book-tag-team-menu-button", async function() {
        // Reset ui
        $("#booking-menu").find("li").removeClass("selected");
        $(this).addClass("selected");
        $("#booking-talent-container").removeClass("compact segments-selection");
        $(".match-participants-container").text("No participants selected");
        $("#multi-match-info").remove();
        $(".tooltip").remove();
        $(".tag-match-options").remove();
        $("#show-gimmick-matches-button").removeClass("selected").find(".fa").removeClass("fa-minus-circle").addClass("fa-plus-circle");
        $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
        $("#show-gimmick-matches-button").show();
        $("#add-tournament-menu-button").show();
        // Reset variables
        $f18c00e15af0c7db$var$selectedChampionship = "";
        $f18c00e15af0c7db$var$selectedParticipants = [];
        $f18c00e15af0c7db$var$selectedElements = [];
        $f18c00e15af0c7db$var$selectedGimmickMatch = "";
        $f18c00e15af0c7db$var$teams = [];
        $f18c00e15af0c7db$var$teams[0] = [];
        $f18c00e15af0c7db$var$teams[1] = [];
        $f18c00e15af0c7db$var$tagTeamSize = 2;
        $f18c00e15af0c7db$var$tagVal = 2;
        $f18c00e15af0c7db$var$handicapSize = "";
        // Add tag team match options
        $("#booking-menu").append($f18c00e15af0c7db$var$tagMatchOptionsHtml);
        // Show feuds
        let matchType = "tag";
        const $bookMatchFeudsContainer = $(".book-match-feuds-container");
        await (0, $1JSre.makeGameRequest)((0, $cXLSF.getFeudsForBooking), {
            matchType: matchType
        }, $f18c00e15af0c7db$var$showGetFeudsForBookingData, {
            matchType: matchType,
            $el: $bookMatchFeudsContainer
        }, false, true);
        // Show tag team booking data
        let tagTeamType = "tag-team";
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingData), {
            matchType: matchType,
            tagTeamType: tagTeamType
        }, $f18c00e15af0c7db$var$showGetBookingData, {
            matchType: matchType,
            tagTeamType: tagTeamType
        });
        // Tag match option button
        $("#main-menu-right").off("click", ".tag-match-option");
        $("#main-menu-right").on("click", ".tag-match-option", async function() {
            // Reset ui
            $(".tag-match-option").removeClass("selected");
            $(this).addClass("selected");
            $("#multi-match-info").html("");
            $("#multi-match-info").remove();
            $(".match-participants-container").text("No participants selected");
            $("#show-gimmick-matches-button").removeClass("selected").find(".fa").removeClass("fa-minus-circle").addClass("fa-plus-circle");
            $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
            $(".custom-team-size-inputs").remove();
            $("#show-gimmick-matches-button").show();
            $("#add-tournament-menu-button").removeClass("selected");
            // Reset variables
            $f18c00e15af0c7db$var$selectedParticipants = [];
            $f18c00e15af0c7db$var$selectedElements = [];
            $f18c00e15af0c7db$var$selectedGimmickMatch = "";
            $f18c00e15af0c7db$var$selectedChampionship = "";
            $f18c00e15af0c7db$var$tagVal = $(this).text();
            // Singles
            if ([
                "2v2",
                "3v3",
                "4v4",
                "5v5",
                "1v2",
                "1v3",
                "2v3",
                "?v?"
            ].indexOf($f18c00e15af0c7db$var$tagVal) >= 0) {
                // Show singles booking data
                matchType = "singles";
                let getVacatedChampionships = true;
                if ($f18c00e15af0c7db$var$tagVal === "2v2" || $f18c00e15af0c7db$var$tagVal === "3v3") tagTeamType = $f18c00e15af0c7db$var$tagVal === "2v2" ? "tag-team" : "trio";
                else {
                    tagTeamType = null;
                    // Don't show vacated titles for 4v4 and 5v5 matches
                    getVacatedChampionships = false;
                }
                await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingData), {
                    matchType: matchType,
                    tagTeamType: tagTeamType,
                    getVacatedChampionships: getVacatedChampionships
                }, $f18c00e15af0c7db$var$showGetBookingData, {
                    matchType: matchType
                });
                // Add handicap size
                if ([
                    "1v2",
                    "1v3",
                    "2v3"
                ].indexOf($f18c00e15af0c7db$var$tagVal) >= 0) $f18c00e15af0c7db$var$handicapSize = [
                    parseInt($f18c00e15af0c7db$var$tagVal.charAt(0)),
                    parseInt($f18c00e15af0c7db$var$tagVal.charAt(2))
                ];
                else if ($f18c00e15af0c7db$var$tagVal === "?v?") {
                    // Show custom team size inputs
                    let teamASize = 3;
                    let teamBSize = 4;
                    $f18c00e15af0c7db$var$handicapSize = [
                        teamASize,
                        teamBSize
                    ];
                    $(".tag-match-options").append($f18c00e15af0c7db$var$customTeamSizeInput);
                } else {
                    $f18c00e15af0c7db$var$tagTeamSize = parseInt($f18c00e15af0c7db$var$tagVal.charAt(0));
                    $f18c00e15af0c7db$var$handicapSize = "";
                }
                // Select multi person button
                $("#multi-match-button").addClass("selected");
                $("#multi-match-button").find(".fa").removeClass("fa-circle-o").addClass("fa-check-circle-o");
                // Hide feuds
                $(".book-match-feuds-container").hide();
            } else {
                tagTeamType = $f18c00e15af0c7db$var$tagVal === "Trio" ? "trio" : "tag-team";
                // Show feuds
                let feudMatchType = tagTeamType === "tag-team" ? "tag" : "trio";
                const $bookMatchFeudsContainer = $(".book-match-feuds-container");
                await (0, $1JSre.makeGameRequest)((0, $cXLSF.getFeudsForBooking), {
                    matchType: feudMatchType
                }, $f18c00e15af0c7db$var$showGetFeudsForBookingData, {
                    matchType: feudMatchType,
                    $el: $bookMatchFeudsContainer
                }, false, true);
                // Show tag team booking data
                matchType = "tag";
                await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingData), {
                    matchType: matchType,
                    tagTeamType: tagTeamType
                }, $f18c00e15af0c7db$var$showGetBookingData, {
                    matchType: matchType,
                    tagTeamType: tagTeamType
                });
            }
        });
    });
    // Change custom team size
    $mainMenuRight.on("change", ".custom-team-size-input", function() {
        let customTeamSizeInputA = $(".custom-team-size-a").val();
        let customTeamSizeInputB = $(".custom-team-size-b").val();
        $f18c00e15af0c7db$var$handicapSize = [
            parseInt(customTeamSizeInputA),
            parseInt(customTeamSizeInputB)
        ];
    });
    // Booking talent sort
    $(".superstar-sort").on("change", function() {
        let value = $(this).val();
        let tagMatch = $(".tag-match-option.selected").text() === "Tag" || $(".tag-match-option.selected").text() === "Trio" || $(".book-segment-option.selected").text() === "Tag" || $(".book-segment-option.selected").text() === "Factions";
        if (tagMatch) $f18c00e15af0c7db$var$applyTeamSort(value);
        else $f18c00e15af0c7db$var$applySuperstarSort(value);
    });
    // Booking talent sort order
    $(".superstar-sort-order").on("click", function() {
        let icon = $(this).find("i");
        let tagMatch = $(".tag-match-option.selected").text() === "Tag" || $(".tag-match-option.selected").text() === "Trio" || $(".book-segment-option.selected").text() === "Tag" || $(".book-segment-option.selected").text() === "Factions";
        if (tagMatch) {
            let tagTeamsContainer = $("#tag-teams");
            let triosContainer = $("#trios");
            let factionsContainer = $("#factions");
            // Reverse team elements
            if (icon.hasClass("fa-sort-up")) {
                icon.removeClass("fa-sort-up").addClass("fa-sort-down");
                tagTeamsContainer.append(tagTeamsContainer.find(".superstar-select").get().reverse());
                triosContainer.append(triosContainer.find(".superstar-select").get().reverse());
                factionsContainer.append(factionsContainer.find(".superstar-select").get().reverse());
            } else if (icon.hasClass("fa-sort-down")) {
                icon.removeClass("fa-sort-down").addClass("fa-sort-up");
                tagTeamsContainer.append(tagTeamsContainer.find(".superstar-select").get().reverse());
                triosContainer.append(triosContainer.find(".superstar-select").get().reverse());
                factionsContainer.append(factionsContainer.find(".superstar-select").get().reverse());
            }
        } else {
            let resultsContainer = $("#all-superstars");
            let retiredContainer = $("#retired");
            let notAvailableContainer = $("#not-available");
            let managersContainer = $("#managers");
            // Reverse superstar elements
            if (icon.hasClass("fa-sort-up")) {
                icon.removeClass("fa-sort-up").addClass("fa-sort-down");
                resultsContainer.append(resultsContainer.find(".superstar-select").get().reverse());
                retiredContainer.append(retiredContainer.find(".superstar-select").get().reverse());
                notAvailableContainer.append(notAvailableContainer.find(".superstar-select").get().reverse());
                managersContainer.append(managersContainer.find(".superstar-select").get().reverse());
            } else if (icon.hasClass("fa-sort-down")) {
                icon.removeClass("fa-sort-down").addClass("fa-sort-up");
                resultsContainer.append(resultsContainer.find(".superstar-select").get().reverse());
                retiredContainer.append(retiredContainer.find(".superstar-select").get().reverse());
                notAvailableContainer.append(notAvailableContainer.find(".superstar-select").get().reverse());
                managersContainer.append(managersContainer.find(".superstar-select").get().reverse());
            }
        }
    });
    // Booking talent search
    $(".superstar-search-input").on("input", function() {
        let tagMatch = $(".tag-match-option.selected").text() === "Tag" || $(".tag-match-option.selected").text() === "Trio" || $(".book-segment-option.selected").is(":visible") && ($(".book-segment-option.selected").text() === "Tag" || $(".book-segment-option.selected").text() === "Factions");
        if (tagMatch) $f18c00e15af0c7db$var$runTeamSearch();
        else $f18c00e15af0c7db$var$runSuperstarSearch();
    });
    // Booking talent filter
    $("#booking-talent-menu").on("click", ".superstar-filter", function() {
        let filterName;
        let filterBrandName;
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else {
            $(".superstar-filter").removeClass("selected");
            $(this).addClass("selected");
            filterName = $(this).attr("data-value");
            filterBrandName = $(this).attr("data-brand-name");
        }
        let tagMatch = $(".tag-match-option.selected").text() === "Tag" || $(".tag-match-option.selected").text() === "Trio" || $(".book-segment-option.selected").text() === "Tag" || $(".book-segment-option.selected").text() === "Factions";
        if (tagMatch) $f18c00e15af0c7db$var$applyTeamFilter(filterName, filterBrandName);
        else $f18c00e15af0c7db$var$applySuperstarFilter(filterName, filterBrandName);
    });
    // Booking talent click
    $("#booking-talent-container").on("click", ".superstar-select", async function() {
        let $this = $(this);
        let parentId = $this.parent().closest("div").attr("id");
        // Don't run for training, not available talent and segment booking
        if ($("#booking-talent-container").hasClass("segments-selection")) return;
        if (parentId === "training" || parentId === "not-available") {
            (0, $lCS03.playSoundEffect)("error");
            if (parentId === "not-available") notie.alert({
                type: 3,
                text: "That talent is not available for a match"
            });
            return;
        }
        (0, $lCS03.playSoundEffect)("success");
        // Check for title selection
        if (parentId === "vacated-titles") {
            $this.toggleClass("selected");
            if (!$f18c00e15af0c7db$var$selectedChampionship) $f18c00e15af0c7db$var$selectedChampionship = $this;
            else if ($this.is($f18c00e15af0c7db$var$selectedChampionship)) $f18c00e15af0c7db$var$selectedChampionship = "";
            else {
                $f18c00e15af0c7db$var$selectedChampionship.removeClass("selected");
                $f18c00e15af0c7db$var$selectedChampionship = $this;
            }
            // Add selected title to tournament award options
            if ($("#add-tournament-menu-button").hasClass("selected")) {
                if ($f18c00e15af0c7db$var$selectedChampionship) {
                    let div = '<label class="control control--radio margin-right-10 award-options-championship">' + $f18c00e15af0c7db$var$selectedChampionship.text() + '<input type="radio" name="radio-award-option" value="championship">' + '<div class="control__indicator"></div></label>';
                    if (!$(".award-options-championship").length) $(".award-options").append(div);
                    else $(".award-options-championship").replaceWith(div);
                    $(".award-options-match-contract").hide();
                    $('input[name="radio-award-option"]').val([
                        "championship"
                    ]);
                } else $(".award-options-championship").remove();
            }
            // Tutorial action check
            (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_title_select");
        } else // Check if user is selecting an available talent
        if (parentId !== "not-available" && parentId !== "training") {
            let name = $this.data("name");
            let uid = $this.data("uid");
            let participantType = $this.attr("data-type");
            let tournament = $("#add-tournament-menu-button").hasClass("selected");
            let bookSingles = $("#book-singles-menu-button").hasClass("selected");
            if (bookSingles) await $f18c00e15af0c7db$var$processMatchParticipantSelection(name, $this, participantType, uid, tournament);
            else // Selecting team
            if (parentId === "tag-teams" || parentId === "trios" || parentId === "factions") {
                if (tournament && parentId === "factions") {
                    notie.alert({
                        type: 3,
                        text: "You cannot use factions in tournaments. Create a Tag Team or Trio for them instead."
                    });
                    return false;
                }
                await $f18c00e15af0c7db$var$processMatchParticipantSelection(name, $this, participantType, uid, tournament);
            } else await $f18c00e15af0c7db$var$processSinglesTagMatchParticipantSelection(name, $this, participantType, uid);
            // Reset search, scroll to selected element
            if ($(".superstar-search-input").val()) {
                $(".superstar-search-input").val("").focus().trigger("input");
                let $container = $("#booking-talent-container");
                $container.scrollTop($this.offset().top - $container.offset().top + $container.scrollTop());
            }
            // Tutorial action check
            if (bookSingles) (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_superstar_select");
            else (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_team_select");
        }
    });
    // Booking feud click
    $(".book-match-feuds-container").on("click", ".feud-container", function() {
        let $this = $(this);
        let notAvailable = "";
        // Get participants
        let participants = $this.find(".feud-participants").text().split(" vs ");
        let participantElements = Array.from(participants, function(participant) {
            let el = $("#booking-talent-container .superstar-select").filter(function() {
                return $(this).data("name") === participant;
            });
            if (el.length <= 0) {
                notAvailable = participant;
                return false;
            }
            return el;
        });
        if (notAvailable) {
            notie.alert({
                type: 3,
                text: "{0} is not available to be booked at this Event".format(notAvailable)
            });
            return false;
        }
        // Reset selections
        $f18c00e15af0c7db$var$selectedParticipants = [];
        $f18c00e15af0c7db$var$selectedElements.forEach(function(x) {
            // Unselect superstars not part of feud
            if (participants.indexOf(x.text()) < 0) $(x).removeClass("selected");
        });
        $f18c00e15af0c7db$var$selectedElements = [];
        if ($this.hasClass("selected")) {
            // Deselect this feud
            $this.removeClass("selected");
            $(".feud-container").show();
            $(".match-participants-container").text("No participants selected");
            // If participant element is not selected, select it so 'click' trigger unselects it
            participantElements.forEach(function(element) {
                if (!$(element).hasClass("selected")) $(element).addClass("selected");
            });
            // Scroll to previous position
            $(".book-match-feuds-container").scrollTop($(".book-match-feuds-container").data("scrollTop"));
        } else {
            // Set scroll position
            $(".book-match-feuds-container").data("scrollTop", $(".book-match-feuds-container").scrollTop());
            // Unselect others
            $(".feud-container").removeClass("selected").hide();
            // Select this feud
            $this.addClass("selected");
            $this.show();
            // Select multi match
            if (!$("#multi-match-button").hasClass("selected")) $("#multi-match-button").trigger("click");
            // If participant element is selected, unselect it so 'click' trigger selects it
            participantElements.forEach(function(element) {
                if ($(element).hasClass("selected")) $(element).removeClass("selected");
            });
        }
        // Trigger click on participant elements
        participantElements.forEach(function(element) {
            element.trigger("click");
        });
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_match_feud");
    });
    // Show gimmick matches button
    $bookingContainer.on("click", "#show-gimmick-matches-button", async function() {
        // Reset ui
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
        $("#select-gimmick-match-container").hide();
        $("#gimmick-matches-container").remove();
        if ($("#show-gimmick-matches-button").hasClass("selected")) {
            // Unselect
            $f18c00e15af0c7db$var$selectedGimmickMatch = "";
            $(this).find(".fa").removeClass("fa-minus-circle").addClass("fa-plus-circle");
            // Update match participants text
            $f18c00e15af0c7db$var$updateMatchParticipantsText();
        } else {
            // Select
            $(this).find(".fa").removeClass("fa-plus-circle").addClass("fa-minus-circle");
            // Add new div for gimmick matches
            let newDiv = $('<div id="gimmick-matches-container" class="box"></div>');
            let scrollDiv = $('<div class="gimmick-matches-container-scroll"></div>');
            $(newDiv).append('<div class="margin-bottom-30">   <span class="menu-header-color font-mukta-mahee font-1p325em">Gimmick Match</span></div>');
            let tagMatchOptionSelected = $(".tag-match-options .selected").text();
            // Load gimmick matches
            await (0, $1JSre.makeGameRequest)((0, $8A6FL.getBookingGimmickMatchesData), {
                tagMatchOptionSelected: tagMatchOptionSelected
            }, $f18c00e15af0c7db$var$showGetBookingGimmickMatchesData, {
                scrollDiv: scrollDiv,
                newDiv: newDiv
            }, false);
        }
        $("#show-gimmick-matches-button").toggleClass("selected");
    });
    // Gimmick match click handler
    $selectGimmickMatchContainer.on("click", ".gimmick-match", async function() {
        // Show error if open challenge and more than one participant selected
        if ($(this).attr("data-consequence") === "random-opponent" && $f18c00e15af0c7db$var$selectedParticipants.length > 1) {
            (0, $lCS03.playSoundEffect)("error");
            notie.alert({
                type: 3,
                text: "This gimmick match cannot be booked with more than 1 participant"
            });
            return false;
        }
        (0, $lCS03.playSoundEffect)("success");
        $(".confirm-gimmick-match-for-match").remove();
        $(".tooltip").remove();
        // Select event card gimmick match so it can be deselected
        if ($(".event-card-match-add-gimmick-button.selected").length > 0 && !$f18c00e15af0c7db$var$selectedGimmickMatch) {
            if ($("#gimmick-matches-container .selected").length > 0) $f18c00e15af0c7db$var$selectedGimmickMatch = $("#gimmick-matches-container .selected");
        }
        if (!$f18c00e15af0c7db$var$selectedGimmickMatch) {
            $f18c00e15af0c7db$var$selectedGimmickMatch = $(this);
            $(this).toggleClass("selected");
            if (!$(this).hasClass("selected")) $f18c00e15af0c7db$var$selectedGimmickMatch = "";
            else {
                // Set scroll position
                $(".gimmick-matches-container-scroll").data("scrollTop", $(".gimmick-matches-container-scroll").scrollTop());
                // Hide other gimmick matches
                $(".gimmick-match-item").each(function() {
                    if ($(this)[0] !== $f18c00e15af0c7db$var$selectedGimmickMatch[0]) $(this).hide();
                });
                // Show selected gimmick match
                $(".gimmick-match-item").promise().done(function() {
                    if ($f18c00e15af0c7db$var$selectedGimmickMatch) {
                        $f18c00e15af0c7db$var$selectedGimmickMatch.find(".gimmick-match-details").show();
                        // Show full name
                        $f18c00e15af0c7db$var$selectedGimmickMatch.find(".gimmick-match-item-name").text($f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-name"));
                        if ($(".event-card-match-add-gimmick-button.selected").length > 0) {
                            $f18c00e15af0c7db$var$selectedGimmickMatch.after('<button type="button" class="display-block confirm-gimmick-match-for-match button retro-button condensed blue-button-background margin-top-12 display-block condensed">Add Gimmick Match</button>');
                            // Don't select gimmick match for booking if adding to existing match
                            $f18c00e15af0c7db$var$selectedGimmickMatch = "";
                        }
                    }
                });
                $("#gimmick-matches-container").children("#auto-picker").remove();
                // Show auto picker for battle royal
                if ($(this).attr("data-auto-picker") === "true") {
                    let autoPickerHtml = $f18c00e15af0c7db$var$getAutoPickerHtml();
                    $("#gimmick-matches-container").append(autoPickerHtml);
                }
            }
        } else {
            $f18c00e15af0c7db$var$selectedGimmickMatch.toggleClass("selected"); // Unselect previously selected gimmick match
            $f18c00e15af0c7db$var$selectedGimmickMatch.find(".gimmick-match-details").hide();
            // Hide full name
            if ($f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-name").length > 13) $f18c00e15af0c7db$var$selectedGimmickMatch.find(".gimmick-match-item-name").text($f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-name").slice(0, 13) + ".");
            // Clicking on selected gimmick match unselects it
            if ($f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-name") === $(this).attr("data-name")) {
                // Show other gimmick matches
                $(".gimmick-match-item").each(function() {
                    if ($(this)[0] !== $f18c00e15af0c7db$var$selectedGimmickMatch[0]) $(this).show();
                });
                $("#gimmick-matches-container").children("#auto-picker").remove();
                $f18c00e15af0c7db$var$selectedGimmickMatch = "";
                // Scroll to previous position
                $(".gimmick-matches-container-scroll").scrollTop($(".gimmick-matches-container-scroll").data("scrollTop"));
            } else {
                $(this).toggleClass("selected");
                $f18c00e15af0c7db$var$selectedGimmickMatch = $(this);
            }
        }
        // Add match if open challenge and one participant selected
        if ($f18c00e15af0c7db$var$selectedGimmickMatch && $f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-consequence") === "random-opponent" && $f18c00e15af0c7db$var$selectedParticipants.length === 1) await $f18c00e15af0c7db$var$callAddMatch();
        // Update match participants text
        $f18c00e15af0c7db$var$updateMatchParticipantsText();
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_gimmick_match_item");
    });
    // Auto picker
    $game.on("click", "#auto-pick", function() {
        if ($("#book-singles-menu-button").hasClass("selected")) {
            let numberToPick = parseInt($(this).siblings("#auto-pick-input").val());
            let autoPickerType = $(this).attr("data-type");
            let tournament = autoPickerType === "tournament";
            let resultsContainer = $("#all-superstars");
            let mainContainer = $("#main-eventers, #upper-midcarders, #lower-midcarders, #jabroni");
            let notieText = "";
            // Reset selections
            $f18c00e15af0c7db$var$selectedElements.forEach(function(x) {
                $(x).toggleClass("selected");
            });
            $f18c00e15af0c7db$var$selectedParticipants = [];
            $f18c00e15af0c7db$var$selectedElements = [];
            $(".feud-container").show().removeClass("selected");
            $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
            $(".superstar-select-feud-details").remove();
            // Popularity sort
            let autoSortBy = $(this).siblings("#auto-pick-sort").val();
            // Select results container for filtering, notify of active filter or search
            if (resultsContainer.is(":visible")) {
                mainContainer = resultsContainer;
                if ($(".superstar-filter.selected").length) notieText += `<span class="display-block">"${$(".superstar-filter.selected").text().trim()}" booking filter is active</span>`;
                else if ($(".superstar-search-input").val()) notieText += '<span class="display-block">Search filter is active</span>';
            }
            let superstarsElement = mainContainer.find(".superstar-select");
            // Top
            if ([
                "1",
                "2",
                "3",
                "4"
            ].includes(autoSortBy)) {
                superstarsElement = superstarsElement.filter(function() {
                    let popularity = $(this).attr("data-popularity");
                    if (autoSortBy === "1") return popularity >= 600;
                    else if (autoSortBy === "2") return popularity >= 600 && popularity < 800;
                    else if (autoSortBy === "3") return popularity >= 400 && popularity < 800;
                    else if (autoSortBy === "4") return popularity >= 400 && popularity < 600;
                });
                superstarsElement = $((0, $3E8Nt.shuffle)(superstarsElement));
            } else if (autoSortBy === "5") superstarsElement = $(superstarsElement.get().reverse());
            else if (autoSortBy === "6") superstarsElement = $((0, $3E8Nt.shuffle)(superstarsElement));
            // Pronoun filter
            let autoPickPronounFilter = $(this).siblings("#auto-pick-pronoun-filter").val();
            // He
            if (autoPickPronounFilter === "1") superstarsElement = superstarsElement.filter('[data-pronoun="he"]');
            else if (autoPickPronounFilter === "2") superstarsElement = superstarsElement.filter('[data-pronoun="she"]');
            else if (autoPickPronounFilter === "3") superstarsElement = superstarsElement.filter('[data-pronoun="they"]');
            // Booked filter
            let autoPickBookedFilter = $(this).siblings("#auto-pick-booked-filter").val();
            // Not booked
            if (autoPickBookedFilter === "0") superstarsElement = superstarsElement.filter(":not(.booked)");
            superstarsElement.each(function(index, element) {
                // Select and add superstars
                if ($f18c00e15af0c7db$var$selectedParticipants.length < numberToPick) {
                    if (jQuery.inArray($(element).text(), $f18c00e15af0c7db$var$selectedParticipants) === -1 && $(element).parent().attr("id") !== "not-available" && $(element).parent().attr("id") !== "vacated-titles") {
                        $f18c00e15af0c7db$var$selectedParticipants.push($(element).text());
                        $f18c00e15af0c7db$var$selectedElements.push($(element));
                        $(element).toggleClass("selected");
                    }
                } else return false;
            });
            // Format selection text
            let matchParticipantsText;
            let participantsText;
            if (tournament) participantsText = $f18c00e15af0c7db$var$selectedParticipants.join(", ");
            else participantsText = $f18c00e15af0c7db$var$selectedParticipants.join(" vs ");
            // Show match participants text if more than 1 superstar selected
            if ($f18c00e15af0c7db$var$selectedParticipants.length > 0) {
                let suffix = "Match";
                if (tournament) suffix = "Tournament";
                let selectedGimmickMatchName = $f18c00e15af0c7db$var$selectedGimmickMatch ? $f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-name") : null;
                if (selectedGimmickMatchName) matchParticipantsText = "{0} ({1} Person {2} {3})".format(participantsText, $f18c00e15af0c7db$var$selectedParticipants.length, selectedGimmickMatchName, suffix);
                else matchParticipantsText = "{0} ({1} Person {2})".format(participantsText, $f18c00e15af0c7db$var$selectedParticipants.length, suffix);
                // Show match participants text
                if (matchParticipantsText) {
                    let addButton = "";
                    if (!tournament && $f18c00e15af0c7db$var$selectedParticipants.length > 1) addButton = '<button type="button" id="add-match-button" class="button retro-button blue-button-background condensed display-block margin-top-5">Book</button>';
                    $("#multi-match-info").remove();
                    $(".match-participants-container").html('<div class="font-bold"  id="multi-match-info">' + matchParticipantsText + addButton + "</div>");
                }
            } else {
                notieText += "<span class='display-block'>No superstars found</span>";
                $("#multi-match-info").remove();
            }
            // Show tournament participants
            if (tournament) $(".tournament-participants-selected").text($f18c00e15af0c7db$var$selectedParticipants.length);
            if (notieText) notie.alert({
                type: 4,
                text: notieText
            });
        } else if ($("#book-tag-team-menu-button").hasClass("selected")) {
            let numberToPick = parseInt($(this).siblings("#auto-pick-input").val());
            let autoPickerType = $(this).attr("data-type");
            let tournament = autoPickerType === "tournament";
            let notieText = "";
            // Reset selections
            $f18c00e15af0c7db$var$selectedElements.forEach(function(x) {
                $(x).toggleClass("selected");
            });
            $f18c00e15af0c7db$var$selectedParticipants = [];
            $f18c00e15af0c7db$var$selectedElements = [];
            $(".feud-container").show().removeClass("selected");
            $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
            $(".superstar-select-feud-details").remove();
            // Notify of active filter or search, select results container for filtering
            if ($(".superstar-filter.selected").length && $(".superstar-filter.selected").attr("data-value")) notieText += `<span class="display-block">"${$(".superstar-filter.selected").text().trim()}" booking filter is active</span>`;
            else if ($(".superstar-search-input").val()) notieText += '<span class="display-block">Search filter is active</span>';
            let tagTeamType = $f18c00e15af0c7db$var$tagVal === "Trio" ? "trio" : "tag-team";
            let teamDiv = tagTeamType === "trio" ? $("#trios") : $("#tag-teams");
            let autoSortBy = $(this).siblings("#auto-pick-sort").val();
            let tagTeamsElement;
            if (autoSortBy === "0") tagTeamsElement = teamDiv.find(".superstar-select");
            else if (autoSortBy === "5") tagTeamsElement = $(teamDiv.find(".superstar-select").get().reverse());
            else if (autoSortBy === "6") tagTeamsElement = $((0, $3E8Nt.shuffle)(teamDiv.find(".superstar-select")));
            tagTeamsElement.each(function(index, element) {
                // Select and add superstars
                if ($f18c00e15af0c7db$var$selectedParticipants.length < numberToPick) {
                    if (jQuery.inArray($(element).text(), $f18c00e15af0c7db$var$selectedParticipants) === -1 && $(element).parent().attr("id") !== "not-available" && $(element).parent().attr("id") !== "vacated-titles") {
                        $f18c00e15af0c7db$var$selectedParticipants.push($(element).text());
                        $f18c00e15af0c7db$var$selectedElements.push($(element));
                        $(element).toggleClass("selected");
                    }
                } else return false;
            });
            // Format selection text
            let matchParticipantsText;
            let participantsText;
            if (tournament) participantsText = $f18c00e15af0c7db$var$selectedParticipants.join(", ");
            else participantsText = $f18c00e15af0c7db$var$selectedParticipants.join(" vs ");
            // Show match participants text if more than 1 superstar selected
            if ($f18c00e15af0c7db$var$selectedParticipants.length > 0) {
                let suffix = "Match";
                if (tournament) suffix = "Tournament";
                let selectedGimmickMatchName = $f18c00e15af0c7db$var$selectedGimmickMatch ? $f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-name") : null;
                if (selectedGimmickMatchName) matchParticipantsText = "{0} ({1} Team {2} {3})".format(participantsText, $f18c00e15af0c7db$var$selectedParticipants.length, selectedGimmickMatchName, suffix);
                else matchParticipantsText = "{0} ({1} Team {2})".format(participantsText, $f18c00e15af0c7db$var$selectedParticipants.length, suffix);
                // Add match participants text to screen
                if (matchParticipantsText) {
                    let addButton = "";
                    if (!tournament && $f18c00e15af0c7db$var$selectedParticipants.length > 1) addButton = '<button type="button" id="add-match-button" class="button retro-button blue-button-background condensed display-block margin-top-5">Book</button>';
                    $("#multi-match-info").remove();
                    $(".match-participants-container").html('<div class="font-bold"  id="multi-match-info">' + matchParticipantsText + addButton + "</div>");
                }
            } else {
                notieText += "No teams found";
                $("#multi-match-info").remove();
            }
            // Show tournament participants
            if (tournament) $(".tournament-participants-selected").text($f18c00e15af0c7db$var$selectedParticipants.length);
            if (notieText) notie.alert({
                type: 4,
                text: notieText
            });
        }
        // Select multi match button
        $("#multi-match-button").addClass("selected");
        $("#multi-match-button").find(".fa").removeClass("fa-circle-o").addClass("fa-check-circle-o");
    });
    // Prevent gimmick match click on inputs
    $selectGimmickMatchContainer.on("click", ".match-event-select, .match-fall-select, .match-referee-select, .match-name-input, .gimmick-match-generate-object-button", function(e) {
        e.stopPropagation();
    });
    // Set event of gimmick match element
    $selectGimmickMatchContainer.on("change", ".match-event-select", function() {
        let gimmickDiv = $(this).closest(".gimmick-match");
        gimmickDiv.attr("data-event-uid", $(this).val());
    });
    // Set object of gimmick match element
    $selectGimmickMatchContainer.on("keyup", ".match-name-input", function() {
        let gimmickDiv = $(this).closest(".gimmick-match");
        let object = (0, $3E8Nt.toTitleCase)($(this).val());
        if (gimmickDiv.find(".gimmick-match-generate-object-button").attr("data-generate-object") === "true") object = object + " on a Pole";
        else if (gimmickDiv.find(".gimmick-match-generate-object-button").attr("data-generate-location") === "true") object = object + " Brawl";
        gimmickDiv.attr("data-name", object);
        // Update match participants text
        $f18c00e15af0c7db$var$updateMatchParticipantsText();
    });
    // Generate gimmick match object/location
    $selectGimmickMatchContainer.on("click", ".gimmick-match-generate-object-button", async function() {
        let element = $(this);
        let previousName = $(this).data("previous-name");
        // If adding gimmick match to existing match, select participants from match card
        let participantNames;
        if ($(".confirm-gimmick-match-for-match").is(":visible")) {
            let eventCardMatchElement = $(".event-card-match-add-gimmick-button.selected").closest(".event-match");
            participantNames = Array.from(eventCardMatchElement.find(".event-card-match-participant-name"), function(e) {
                return $(e).text();
            });
        } else participantNames = $f18c00e15af0c7db$var$selectedParticipants;
        if ($(this).attr("data-generate-object") === "true") await (0, $1JSre.makeGameRequest)((0, $8A6FL.generateGimmickMatchObject), {
            participantNames: participantNames,
            previousName: previousName
        }, $f18c00e15af0c7db$var$showGenerateGimmickMatchData, {
            element: element,
            type: "object"
        }, false);
        else if ($(this).attr("data-generate-location") === "true") await (0, $1JSre.makeGameRequest)((0, $8A6FL.generateGimmickMatchLocation), {
            participantNames: participantNames,
            previousName: previousName
        }, $f18c00e15af0c7db$var$showGenerateGimmickMatchData, {
            element: element,
            type: "location"
        }, false);
    });
    // Add match button
    $game.on("click", "#add-match-button", async function() {
        await $f18c00e15af0c7db$var$callAddMatch();
    });
    // Multi person button
    $bookingContainer.on("click", "#multi-match-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        // Select/unselect
        $(this).toggleClass("selected");
        let icon = $(this).find(".fa");
        if (icon.hasClass("fa-circle-o")) icon.removeClass("fa-circle-o").addClass("fa-check-circle-o");
        else if (icon.hasClass("fa-check-circle-o")) icon.removeClass("fa-check-circle-o").addClass("fa-circle-o");
        // Hide tournament container
        $("#add-tournament-container").hide();
        $("#add-tournament-menu-button").removeClass("selected");
        // When unselecting, if more than one participant selected, unselect all
        if (!$(this).hasClass("selected")) {
            if ($f18c00e15af0c7db$var$selectedParticipants.length >= 2) {
                // Reset participants
                $f18c00e15af0c7db$var$selectedElements.forEach(function(x) {
                    $(x).toggleClass("selected");
                });
                $f18c00e15af0c7db$var$selectedParticipants = [];
                $f18c00e15af0c7db$var$selectedElements = [];
                $(".feud-container").show().removeClass("selected");
                $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
                $(".superstar-select-feud-details").remove();
                // Update match participants text
                $f18c00e15af0c7db$var$updateMatchParticipantsText();
            }
        }
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_multi_button");
    });
    // Delete match
    $matches.on("click", ".event-card-match-delete-button", async function() {
        let $matchElement = $(this).closest(".event-match");
        let uid = parseInt($matchElement.attr("data-uid"));
        if ($matchElement.hasClass("tournament-match")) {
            // Add all tournament matches to be deleted
            $matchElement = $(".event-match.tournament-match");
            notie.confirm({
                text: "Deleting this match will delete the whole tournament. Are you sure you want to do that?",
                submitText: "Yes",
                cancelText: "No",
                submitCallback: async function() {
                    await (0, $1JSre.makeGameRequest)((0, $6RCLU.deleteCompanyMatch), {
                        uid: uid
                    }, $f18c00e15af0c7db$var$showDeleteMatchData, {
                        $matchElement: $matchElement
                    }, false);
                }
            });
        } else await (0, $1JSre.makeGameRequest)((0, $6RCLU.deleteCompanyMatch), {
            uid: uid
        }, $f18c00e15af0c7db$var$showDeleteMatchData, {
            $matchElement: $matchElement
        }, false);
    });
    // Add gimmick match event card button
    $matches.on("click", ".event-card-match-add-gimmick-button", async function() {
        // Reset
        $f18c00e15af0c7db$var$selectedGimmickMatch = "";
        $("#show-gimmick-matches-button").find(".fa").addClass("fa-plus-circle").removeClass("fa-minus-circle");
        $("#show-gimmick-matches-button").removeClass("selected");
        $f18c00e15af0c7db$var$updateMatchParticipantsText();
        // Add new div for gimmick matches
        let newDiv = $('<div id="gimmick-matches-container" class="box"></div>');
        let scrollDiv = $('<div class="gimmick-matches-container-scroll"></div>');
        $(newDiv).append('<div class="margin-bottom-30">   <span class="menu-header-color font-mukta-mahee font-1p325em">Add Gimmick Match</span></div>');
        // Load gimmick matches
        let matchElement = $(this).closest(".event-match");
        let matchUid = parseInt(matchElement.attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $8A6FL.getBookingGimmickMatchesData), {
            matchUid: matchUid
        }, $f18c00e15af0c7db$var$showGetBookingGimmickMatchesData, {
            scrollDiv: scrollDiv,
            newDiv: newDiv,
            eventCard: true
        }, false);
    });
    // Confirm gimmick match event card button
    $("#select-gimmick-match-container").on("click", ".confirm-gimmick-match-for-match", async function() {
        let parent = $(".event-card-match-add-gimmick-button.selected").closest(".event-match");
        let matchUid = parseInt(parent.attr("data-uid"));
        let gimmickMatchElement = $(".gimmick-match-item.selected");
        let gimmickMatchUid = parseInt(gimmickMatchElement.attr("data-uid"));
        let gimmickMatchName = gimmickMatchElement.attr("data-name");
        let gimmickMatchObject = gimmickMatchElement.find(".gimmick-match-generate-object-button").length > 0;
        // Validate event selected for gimmick match with match contract
        let matchEventUid = parseInt(gimmickMatchElement.attr("data-event-uid"));
        if (gimmickMatchElement.find("#match_event").length > 0) {
            if (!matchEventUid) {
                notie.alert({
                    type: 3,
                    text: "Select an event for this match contract to be held at"
                });
                gimmickMatchElement[0].scrollIntoView();
                gimmickMatchElement.find("#match_event").addClass("highlight");
                return false;
            }
        }
        // Get fall select values, referee uid
        let fallGimmickNames = Array.from(gimmickMatchElement.find(".match-fall-select"), function(x) {
            return $(x).val();
        });
        let refereeUid = parseInt(gimmickMatchElement.find(".match-referee-select").val());
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.addGimmickMatchToMatch), {
            matchUid: matchUid,
            gimmickMatchUid: gimmickMatchUid,
            gimmickMatchName: gimmickMatchName,
            matchEventUid: matchEventUid,
            gimmickMatchObject: gimmickMatchObject,
            fallGimmickNames: fallGimmickNames,
            refereeUid: refereeUid
        }, $f18c00e15af0c7db$var$showAddGimmickMatchToMatchData, {
            parent: parent
        }, false);
    });
    // Drag to sort matches/segments
    $matches.sortable({
        cancel: ".tournament-match, .played, .hidden, .event-card-match-edit-menu, .event-card-button",
        axis: "y",
        containment: "#matches",
        opacity: 0.8,
        tolerance: "pointer",
        items: ".event-match:not(.played)"
    });
    // Match/segment sort handler
    $matches.on("sortupdate", async function(event, ui) {
        let matchOrSegmentDiv = $(ui.item[0]);
        let matchOrSegmentDivIndex = $(".event-match").index(matchOrSegmentDiv);
        let uid = parseInt(matchOrSegmentDiv.attr("data-uid"));
        let objectName = matchOrSegmentDiv.attr("data-is-segment") === "true" ? "segment" : "match";
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.changeMatchOrSegmentOrder), {
            uid: uid,
            objectName: objectName,
            position: matchOrSegmentDivIndex
        }, $f18c00e15af0c7db$var$showChangeMatchOrSegmentOrderData, {
            matchOrSegmentDivIndex: matchOrSegmentDivIndex
        }, false);
    });
    // Don't allow drag on tournament and played matches
    $matches.on("mousedown", ".event-match.played, .event-match.tournament-match", function(e) {
        let target = $(e.target);
        if (target.closest(".button-dropdown").length <= 0) notie.alert({
            type: 4,
            text: "You cannot change the order of Tournament and Played Matches"
        });
    });
    // Remove match championship
    $matches.on("click", ".event-card-match-remove-championship-button", async function() {
        let parent = $(this).closest(".event-match");
        let matchUid = parseInt(parent.attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.removeChampionshipFromMatch), {
            matchUid: matchUid
        }, $f18c00e15af0c7db$var$showRemoveChampionshipFromMatchData, {
            parent: parent
        }, false);
    });
    // Select match championships
    $matches.on("click", ".event-card-match-select-championships-button", async function() {
        let parent = $(this).closest(".event-match");
        let matchUid = parseInt(parent.attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.getMatchChampionshipsForSelection), {
            matchUid: matchUid
        }, $f18c00e15af0c7db$var$showGetMatchChampionshipsForSelectionData, {
            matchUid: matchUid
        }, false);
    });
    // Confirm match championships
    $container.on("click", "#confirm-match-championships-selection", async function() {
        let matchUid = $("#match-championships-selection-container").data("match-uid");
        let selectedChampionshipDivs = $(this).parent().find(".selected");
        let selectedChampionshipsUids = Array.from(selectedChampionshipDivs, function(memberDiv) {
            return parseInt($(memberDiv).attr("data-uid"));
        });
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.changeMatchChampionships), {
            matchUid: matchUid,
            selectedChampionshipsUids: selectedChampionshipsUids
        }, $f18c00e15af0c7db$var$showChangeMatchChampionshipsData, {
            matchUid: matchUid
        }, false);
    });
    // Match championship item select
    $container.on("click", ".match-championships-item", function() {
        // Select, unselect
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else $(this).addClass("selected");
    });
    // Load available feuds for match
    $matches.on("click", ".event-card-match-add-feud-button", async function() {
        let matchElement = $(this).closest(".event-match");
        let matchUid = parseInt(matchElement.attr("data-uid"));
        let matchType = matchElement.attr("data-matchtype");
        let isSegment = matchElement.attr("data-is-segment") ? matchElement.attr("data-is-segment") : false;
        await (0, $1JSre.makeGameRequest)((0, $cXLSF.getAvailableFeudsForMatch), {
            matchUid: matchUid,
            matchType: matchType,
            isSegment: isSegment
        }, $f18c00e15af0c7db$var$showGetAvailableFeudsForMatchData, {
            matchUid: matchUid,
            matchType: matchType,
            isSegment: isSegment
        }, false);
    });
    // Add feud to match
    $("#feud-items-container").on("click", ".feud-item-container", async function() {
        // Don't run for disabled feud item
        if ($(this).hasClass("disabled")) return false;
        let feudItemUid = parseInt($(this).attr("data-uid"));
        let matchOrSegmentUid = parseInt($("#feud-items-container").attr("data-uid"));
        let matchType = $("#feud-items-container").attr("data-match-type");
        let isSegment = $("#feud-items-container").attr("data-is-segment") === "true";
        let feudName = $(this).find(".feud-item-custom-name").val();
        await (0, $1JSre.makeGameRequest)((0, $cXLSF.addFeudToMatchOrSegment), {
            matchOrSegmentUid: matchOrSegmentUid,
            matchType: matchType,
            isSegment: isSegment,
            feudItemUid: feudItemUid,
            feudName: feudName
        }, $f18c00e15af0c7db$var$showAddFeudToMatchData, {
            matchOrSegmentUid: matchOrSegmentUid
        }, false);
    });
    // Remove feud from match
    $matches.on("click", ".event-card-match-remove-feud-button", async function() {
        let matchElement = $(this).closest(".event-match");
        let matchOrSegmentUid = parseInt(matchElement.attr("data-uid"));
        let isSegment = matchElement.attr("data-is-segment") === "true";
        await (0, $1JSre.makeGameRequest)((0, $cXLSF.removeFeudFromMatchOrSegment), {
            matchOrSegmentUid: matchOrSegmentUid,
            isSegment: isSegment
        }, $f18c00e15af0c7db$var$showRemoveFeudFromMatchOrSegmentData, {
            matchElement: matchElement
        }, false);
    });
    // Add feud blowoff
    $container.on("click", ".add-blowoff-to-feud", async function() {
        let matchUid = parseInt($(this).attr("data-uid"));
        let matchType = $(this).attr("data-match-type");
        let feudUid = parseInt($(this).attr("data-feud-uid"));
        let $el = $(this);
        await (0, $1JSre.makeGameRequest)((0, $cXLSF.changeFeudBlowoff), {
            matchUid: matchUid,
            matchType: matchType,
            feudUid: feudUid,
            add: true
        }, $f18c00e15af0c7db$var$showChangeFeudBlowoffData, {
            $el: $el,
            add: true
        }, false);
    });
    // Remove feud blowoff
    $container.on("click", ".remove-blowoff-from-feud", async function() {
        let matchUid = parseInt($(this).attr("data-uid"));
        let matchType = $(this).attr("data-match-type");
        let feudUid = parseInt($(this).attr("data-feud-uid"));
        let $el = $(this);
        await (0, $1JSre.makeGameRequest)((0, $cXLSF.changeFeudBlowoff), {
            matchUid: matchUid,
            matchType: matchType,
            feudUid: feudUid,
            add: false
        }, $f18c00e15af0c7db$var$showChangeFeudBlowoffData, {
            $el: $el,
            add: false
        }, false);
    });
    // Show 'add match manager' selections
    $matches.on("click", ".event-card-match-add-manager-button", async function() {
        let parent = $(this).closest(".event-match");
        let matchUid = parseInt(parent.attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.getAddMatchManagerSelections), {
            matchUid: matchUid
        }, $f18c00e15af0c7db$var$showGetAddMatchManagerSelectionsData, {
            matchUid: matchUid
        }, false);
    });
    // Add match manager button
    $container.on("click", "#match-add-manager-button", async function() {
        let parent = $("#match-add-manager-container");
        let matchUid = parent.data("match-uid");
        let participantUid = parseInt(parent.find(".match-add-manager-participant-select").val());
        let managerUid = parseInt(parent.find(".match-add-manager-manager-select").val());
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.addManagerToMatch), {
            matchUid: matchUid,
            participantUid: participantUid,
            managerUid: managerUid
        }, $f18c00e15af0c7db$var$showAddManagerToMatchData, {
            matchUid: matchUid
        }, false);
    });
    // Show 'remove match manager' selections
    $matches.on("click", ".event-card-match-remove-manager-button", async function() {
        let parent = $(this).closest(".event-match");
        let matchUid = parseInt(parent.attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.getRemoveMatchManagerSelections), {
            matchUid: matchUid
        }, $f18c00e15af0c7db$var$showGetRemoveMatchManagerSelectionsData, {
            matchUid: matchUid
        }, false);
    });
    // Remove match manager button
    $container.on("click", "#match-remove-manager-button", async function() {
        let parent = $("#match-remove-manager-container");
        let matchUid = parent.data("match-uid");
        let superstarUid = parseInt(parent.find(".match-remove-manager-manager-select").val());
        await (0, $1JSre.makeGameRequest)((0, $6RCLU.removeManagerFromMatch), {
            matchUid: matchUid,
            superstarUid: superstarUid
        }, $f18c00e15af0c7db$var$showRemoveManagerFromMatchData, {
            matchUid: matchUid
        }, false);
    });
    // Load 'change trio team members' page
    $container.on("click", ".change-trio-tagteam-members", async function() {
        let members = $(this).data("trio-members");
        let membersSelected = $(this).data("trio-members-selected");
        let matchUid = $(this).data("match-uid");
        let teamName = $(this).data("team-name");
        $f18c00e15af0c7db$var$showTrioMembersForSelection(members, membersSelected, matchUid, teamName);
    });
    // Change trio team members
    $container.on("click", ".trio-member", async function() {
        let selectedMemberDivs = $(this).parent().find(".selected");
        // Select, unselect
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else if (selectedMemberDivs.length < 2) {
            $(this).addClass("selected");
            // Change members if 2 selected
            selectedMemberDivs = $(this).parent().find(".selected");
            if (selectedMemberDivs.length === 2) {
                let matchUid = $("#trio-members-selection-container").data("match-uid");
                // JSON.parse teamName since it's a single string
                let teamName = JSON.parse($("#trio-members-selection-container").data("team-name"));
                let selectedMembers = Array.from(selectedMemberDivs, function(memberDiv) {
                    return $(memberDiv).text();
                });
                await (0, $1JSre.makeGameRequest)((0, $6RCLU.changeTrioTagTeamMembers), {
                    matchUid: matchUid,
                    teamName: teamName,
                    selectedMembers: selectedMembers
                }, $f18c00e15af0c7db$var$showChangeTrioTagTeamMembersData, {
                    matchUid: matchUid
                }, false);
            }
        } else notie.alert({
            type: 4,
            text: "You can only select 2 members. Deselect a selected member first."
        });
    });
    // Load 'change faction team members page'
    $container.on("click", ".change-faction-tagteam-members", async function() {
        let members = $(this).data("faction-members");
        let membersSelected = $(this).data("faction-members-selected");
        let matchUid = $(this).data("match-uid");
        let teamName = $(this).data("team-name");
        let teamSize = $(this).data("team-size");
        $f18c00e15af0c7db$var$showFactionMembersForSelection(members, membersSelected, matchUid, teamName, teamSize);
    });
    // Change faction team members
    $container.on("click", ".faction-member", async function() {
        let selectedMemberDivs = $(this).parent().find(".selected");
        let matchTeamSize = $("#faction-members-selection-container").data("team-size");
        // Select, unselect
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else if (selectedMemberDivs.length < matchTeamSize) {
            $(this).addClass("selected");
            // Change members if matchTeamSize selected
            selectedMemberDivs = $(this).parent().find(".selected");
            if (selectedMemberDivs.length === matchTeamSize) {
                let matchUid = $("#faction-members-selection-container").data("match-uid");
                // JSON.parse teamName since it's a single string
                let teamName = JSON.parse($("#faction-members-selection-container").data("team-name"));
                let selectedMembers = Array.from(selectedMemberDivs, function(memberDiv) {
                    return $(memberDiv).text();
                });
                await (0, $1JSre.makeGameRequest)((0, $6RCLU.changeFactionTagTeamMembers), {
                    matchUid: matchUid,
                    teamName: teamName,
                    selectedMembers: selectedMembers
                }, $f18c00e15af0c7db$var$showChangeFactionTagTeamMembersData, {
                    matchUid: matchUid
                }, false);
            }
        } else notie.alert({
            type: 4,
            text: "You can only select " + matchTeamSize + " members. Deselect a selected member first."
        });
    });
    // Change superstar attire
    $container.on("click", ".change-superstar-attire-button", async function() {
        let superstarUid = parseInt($(this).attr("data-uid"));
        let $el = $(this);
        await (0, $1JSre.makeGameRequest)((0, $5kTkA.changeSuperstarAttire), {
            superstarUid: superstarUid
        }, $f18c00e15af0c7db$var$showChangeSuperstarAttireData, {
            $el: $el
        }, false);
    });
    // View roster member details while booking
    $("#booking-talent-info").on("click", ".view-roster-member-details-button", async function() {
        let type = $(this).attr("data-type");
        let uid = parseInt($(this).attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $jpMCP.getViewRosterMemberData), {
            uid: uid,
            type: type
        }, $f18c00e15af0c7db$var$showViewRosterMemberDetailsData, {
            uid: uid,
            type: type
        });
    });
    // ** SEGMENTS **
    // Book segment menu button
    $mainMenuRight.on("click", "#book-segment-menu-button", async function() {
        const $bookingContainer = $("#booking-container");
        // Reset ui
        $("#booking-menu").find("li").removeClass("selected");
        $(this).addClass("selected");
        $(".tooltip").remove();
        $(".tag-match-options").remove();
        $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
        $(".segment-participants").removeClass("faded-red-light").text("No participants selected");
        $(".segment-item-selected").removeClass("faded-purple").text("No Segment Item selected");
        $(".segment-item-container.selected").removeClass("selected");
        $(".segment-booking-already-held").remove();
        $(".segment-item-container.already-held").removeClass("already-held");
        $(".segment-booking-unavailable").remove();
        $(".segment-item-container.unavailable").removeClass("unavailable");
        $bookingContainer.find('input[value="add_segment_producer_focus"]').prop("checked", false);
        $bookingContainer.find(".add-segment-producer-select").hide();
        $("#booking-talent-container").find(".superstar-select").removeClass("selected");
        $("#add-tournament-menu-button").hide();
        // Add segment menu
        let segmentBookingMenuHtml = $f18c00e15af0c7db$var$getSegmentBookingMenuHtml();
        $("#add-segment-menu").html(segmentBookingMenuHtml);
        // Add segment item menu
        let segmentItemMenuHtml = $f18c00e15af0c7db$var$getSegmentItemMenuHtml();
        $("#add-segment-item-menu").html(segmentItemMenuHtml);
        // Reset variables
        $f18c00e15af0c7db$var$segmentParticipants = [];
        // Show feuds
        let matchType = "segment";
        const $bookSegmentFeudsContainer = $(".book-segment-feuds-container");
        await (0, $1JSre.makeGameRequest)((0, $cXLSF.getFeudsForBooking), {
            matchType: matchType
        }, $f18c00e15af0c7db$var$showGetFeudsForBookingData, {
            matchType: matchType,
            $el: $bookSegmentFeudsContainer
        }, true);
        // Show booking container
        $bookingContainer.find(".participants-box-callup-header, .participants-box-match-header, .participants-box-draft-header, .participants-box-match-container, .participants-box-trade-offer-header, #booking-talent-info, #booking-talent-menu, #booking-talent-container, #booking-championship-info").hide();
        $bookingContainer.find("#add-segment-item-menu, #segment-items-container, .participants-box-segment-header, .participants-box-segment-container, #add-segment, #add-segment-menu").show();
        $bookingContainer.show();
        $(".book-segment-feuds-container").scrollTop(0);
        $("#segment-items-container").scrollTop(0);
        // Load segment items
        await (0, $1JSre.makeGameRequest)((0, $4ptHI.getAvailableSegmentItems), {}, (0, $67cc16607ee33ebf$export$43c5cdc832e20b0c), {}, false, true);
        // Load producers
        await (0, $1JSre.makeGameRequest)((0, $8A6FL.getCompanyProducers), {}, $f18c00e15af0c7db$var$showGetCompanyProducersData, {}, false, true);
    });
    // Book segment option button (feuds, singles etc)
    $("#add-segment-menu").on("click", ".book-segment-option", async function() {
        // Reset ui
        $(".book-segment-option").removeClass("selected");
        $(this).addClass("selected");
        $("#booking-talent-container").addClass("compact segments-selection");
        $(".segment-participants").removeClass("faded-red-light").text("No participants selected");
        $(".feud-container.selected").trigger("click");
        if ($(".add-custom-segment-segments-menu-button").hasClass("selected")) $(".add-custom-segment-segments-menu-button").trigger("click") // Hide custom segment container
        ;
        // Reset variables
        $f18c00e15af0c7db$var$selectedParticipants = [];
        $f18c00e15af0c7db$var$selectedElements = [];
        $f18c00e15af0c7db$var$segmentParticipants = [];
        let val = $(this).text();
        // Show singles roster
        if (val === "Singles") await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingData), {
            matchType: "singles",
            segment: true,
            getVacatedChampionships: false
        }, $f18c00e15af0c7db$var$showGetBookingData, {
            matchType: "singles",
            segment: true
        });
        else if (val === "Tag") await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingData), {
            matchType: "tag",
            segment: true,
            getVacatedChampionships: false,
            tagTeamType: "tag-team"
        }, $f18c00e15af0c7db$var$showGetBookingData, {
            matchType: "tag",
            segment: true,
            tagTeamType: "tag-team"
        });
        else if (val === "Feuds") {
            $("#booking-talent-info, #booking-talent-container, #booking-talent-menu").hide();
            $("#booking-talent-container").find(".superstar-select").removeClass("selected");
            $(".book-segment-feuds-container").show();
            $(".book-segment-feuds-container").scrollTop(0);
        } else if (val === "Factions") await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingData), {
            matchType: "factions",
            segment: true,
            getVacatedChampionships: false
        }, $f18c00e15af0c7db$var$showGetBookingData, {
            matchType: "factions",
            segment: true
        });
    });
    // Book segment feud click
    $(".book-segment-feuds-container").on("click", ".feud-container", async function() {
        (0, $lCS03.playSoundEffect)("success");
        let $this = $(this);
        // Unselect other options
        $(".feud-container").each(function(i, e) {
            if (!$(e).is($this)) {
                $(e).removeClass("selected");
                $(e).hide();
            }
        });
        // Remove already held indication
        $(".segment-booking-already-held").remove();
        $(".segment-item-container.already-held").removeClass("already-held");
        // Remove unavailable indication
        $(".segment-booking-unavailable").remove();
        $(".segment-item-container.unavailable").removeClass("unavailable");
        if ($this.hasClass("selected")) {
            // Deselect this feud
            $this.removeClass("selected");
            $(".feud-container").show();
            $(".segment-participants").removeClass("faded-red-light").text("No participants selected");
            // If 'available' segment filter selected, get available segments again (as they are changed by feud deselection)
            if ($('.filter-segment-items-option[data-value="available"].selected').length > 0) $f18c00e15af0c7db$var$showAvailableSegmentItems();
        } else {
            // Select this feud
            $this.addClass("selected");
            $this.show();
            // Update segment participants
            let participants = $this.find(".feud-participants").text().split(" vs ");
            let participantNames = participants.slice(0, -1).join(", ") + " and " + participants.slice(-1);
            $(".segment-participants").addClass("faded-red-light").text(participantNames);
            // Show already held segment items, gets unique list of segment item names
            let uid = parseInt($(this).attr("data-uid"));
            await (0, $1JSre.makeGameRequest)((0, $cXLSF.getFeudSegmentsInformation), {
                uid: uid
            }, $f18c00e15af0c7db$var$showGetFeudSegmentsInformationData, {}, false, true);
        }
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_segment_feud");
    });
    // Book segment participant click
    $("#booking-talent-container").on("click", ".superstar-select", async function() {
        // Don't run for training, vacated titles, non-segment booking
        if (!$("#booking-talent-container").hasClass("segments-selection")) return;
        let parentId = $(this).parent().closest("div").attr("id");
        if (parentId === "training" || parentId === "vacated-titles") return;
        (0, $lCS03.playSoundEffect)("success");
        let $this = $(this);
        let name = $this.data("name");
        let uid = $this.data("uid");
        let selectedSegmentItem = $(".segment-item-container.selected");
        if ($this.hasClass("selected")) {
            // Deselect this participant
            $this.removeClass("selected");
            $f18c00e15af0c7db$var$segmentParticipants.splice($f18c00e15af0c7db$var$segmentParticipants.indexOf(name), 1);
            if (selectedSegmentItem.length > 0 && selectedSegmentItem.attr("data-consequence") !== "create-faction") {
                selectedSegmentItem.find(".segment-item-faction-inputs").remove();
                selectedSegmentItem.find(".segment-item-manager-inputs").remove();
                if ([
                    "vacate-title",
                    "award-title"
                ].indexOf(selectedSegmentItem.attr("data-consequence")) >= 0 || selectedSegmentItem.attr("data-requirement") === "feud-present") selectedSegmentItem.find(".segment-item-other-inputs").remove();
            }
        } else {
            // Select this participant
            $f18c00e15af0c7db$var$segmentParticipants.push(name);
            $this.addClass("selected");
        }
        let participantNames = $f18c00e15af0c7db$var$segmentParticipants[0];
        if ($f18c00e15af0c7db$var$segmentParticipants.length > 1) participantNames = $f18c00e15af0c7db$var$segmentParticipants.slice(0, -1).join(", ") + " and " + $f18c00e15af0c7db$var$segmentParticipants.slice(-1);
        else if ($f18c00e15af0c7db$var$segmentParticipants.length < 1) participantNames = "No participants selected";
        $(".segment-participants").removeClass("faded-red-light").text(participantNames);
        // Revert to all superstars, scroll to selected element
        if ($(".superstar-search-input").val()) {
            $(".superstar-search-input").val("").focus().trigger("input");
            let $container = $("#booking-talent-container"), $scrollTo = $(this);
            $container.scrollTop($scrollTo.offset().top - $container.offset().top + $container.scrollTop());
        }
        // Show information for selected superstar (feuds, teams/factions)
        $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
        $(".superstar-select-feud-details").remove();
        if ($f18c00e15af0c7db$var$segmentParticipants.length > 0 && $(this).hasClass("selected")) {
            if (uid) {
                let participantType = $this.attr("data-type");
                await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingSelectionInformation), {
                    uid: uid,
                    participantType: participantType
                }, $f18c00e15af0c7db$var$showGetBookingSelectionInformationData, {}, false, true);
            } else if (typeof window.Sentry !== "undefined") Sentry.captureMessage("(Segment) Name attribute not present for .superstar-select: " + $this.text() + " type: " + $this.data("type") + " name: " + $this.data("name"));
        }
        let selectedParticipant = $("#booking-talent-container .superstar-select.selected").eq(0);
        // Show faction inputs if faction segment and faction roster member selected, and if not create faction segment
        if (selectedParticipant.attr("data-type") === "faction") {
            if (selectedSegmentItem.length > 0 && selectedSegmentItem.data("tags").indexOf("faction") >= 0 && selectedSegmentItem.attr("data-consequence") !== "create-faction") await $f18c00e15af0c7db$var$showFactionSegmentInputs(selectedSegmentItem, selectedParticipant);
        }
        // Show manager inputs if manager segment and superstar selected
        if (selectedParticipant.attr("data-type") === "superstar" || selectedParticipant.attr("data-type") === "tag-team" || selectedParticipant.attr("data-type") === "trio") {
            if (selectedSegmentItem.length > 0 && selectedSegmentItem.attr("data-manager-input")) await $f18c00e15af0c7db$var$showManagerSegmentInputs(selectedSegmentItem, selectedParticipant);
        }
        // Show other inputs (only for title/feud segment)
        if (selectedParticipant.attr("data-type") && ([
            "vacate-title",
            "award-title"
        ].indexOf(selectedSegmentItem.attr("data-consequence")) >= 0 || selectedSegmentItem.attr("data-requirement") === "feud-present")) {
            if (selectedSegmentItem.length > 0 && selectedSegmentItem.attr("data-other-input")) await $f18c00e15af0c7db$var$showOtherSegmentInputs(selectedSegmentItem, selectedParticipant);
        }
        // Tutorial action check
        setTimeout(function() {
            (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_segment_superstar_select");
        }, 50);
    });
    // Book segment item click
    $("#segment-items-container").on("click", ".segment-item-container", async function() {
        (0, $lCS03.playSoundEffect)("success");
        notie.hideAlerts();
        let $this = $(this);
        // Unselect other options
        $("#segment-items-container .item-container").each(function(i, e) {
            if (!$(e).is($this)) {
                $(e).removeClass("selected");
                $(e).find(".segment-item-faction-inputs").remove();
                $(e).find(".segment-item-manager-inputs").remove();
                $(e).find(".segment-item-brand-inputs").remove();
                $(e).find(".segment-item-other-inputs").remove();
            }
        });
        if ($this.hasClass("selected")) {
            // Deselect this segment
            $this.removeClass("selected");
            $(".segment-item-selected").removeClass("faded-purple").text("No Segment Item selected");
            $this.find(".segment-item-faction-inputs").remove();
            $this.find(".segment-item-manager-inputs").remove();
            $this.find(".segment-item-brand-inputs").remove();
            $this.find(".segment-item-other-inputs").remove();
        } else {
            // Select this segment
            $this.addClass("selected");
            let segmentButtonsHtml = '<div><button type="button" class="button retro-button condensed blue-button-background margin-top-5" id="add-segment">Book</button></div>';
            $(".segment-item-selected").addClass("faded-purple").html($this.find(".segment-item-name").text() + segmentButtonsHtml);
            // Show help text
            if ($this.find(".segment-item-name").text() === "Talk Show") notie.alert({
                type: 4,
                text: "The first Participant selected hosts the talk show"
            });
            if ($this.find(".segment-item-name").text() === "Handicap Beatdown") notie.alert({
                type: 4,
                text: "The first Participant selected gets the beatdown"
            });
            if ($this.data("tags").indexOf("choose-winner") >= 0) notie.alert({
                type: 4,
                text: "You can choose who performs/wins this Segment when it runs"
            });
            let selectedParticipant = $("#booking-talent-container .superstar-select.selected").eq(0);
            // Show faction inputs if faction segment and faction roster member selected or create faction segment
            if ($this.data("tags").indexOf("faction") >= 0) {
                if (selectedParticipant.attr("data-type") === "faction" || $this.attr("data-consequence") === "create-faction") await $f18c00e15af0c7db$var$showFactionSegmentInputs($this, selectedParticipant);
            }
            // Show manager inputs if manager segment and superstar selected
            if ($this.attr("data-manager-input")) {
                if (selectedParticipant.attr("data-type") === "superstar" || selectedParticipant.attr("data-type") === "tag-team" || selectedParticipant.attr("data-type") === "trio") await $f18c00e15af0c7db$var$showManagerSegmentInputs($this, selectedParticipant);
            }
            // Show brand inputs if brand segment
            if ($this.attr("data-brand-input")) await $f18c00e15af0c7db$var$showBrandSegmentInputs($this);
            // Show other inputs (only show for title/feud segments if participant selected)
            if ($this.attr("data-other-input")) {
                if (selectedParticipant.attr("data-type") || [
                    "vacate-title",
                    "award-title"
                ].indexOf($this.attr("data-consequence")) < 0 && $this.attr("data-requirement") !== "feud-present") await $f18c00e15af0c7db$var$showOtherSegmentInputs($this, selectedParticipant);
            }
        }
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_segment_item");
    });
    // Add segment button
    $("#booking-container").on("click", "#add-segment", async function() {
        let selectedSegment = $(".segment-item-container.selected");
        let segmentItemUid = parseInt(selectedSegment.attr("data-uid"));
        let noParticipants = selectedSegment.attr("data-no-participants");
        let isFactionSegment = selectedSegment.attr("data-is-faction-segment") === "true";
        let isFactionInputSegment = selectedSegment.attr("data-faction-input");
        let isManagerInputSegment = selectedSegment.attr("data-manager-input");
        let isBrandInputSegment = selectedSegment.attr("data-brand-input");
        let isOtherInputSegment = selectedSegment.attr("data-other-input");
        // Feud/participants
        let feudUid;
        if ($(".feud-container.selected").is(":visible")) feudUid = parseInt($(".feud-container.selected").attr("data-uid"));
        // Validation checks
        if (!segmentItemUid) {
            notie.alert({
                type: 3,
                text: "Select a Segment Item to use"
            });
            return false;
        }
        if (!noParticipants) {
            if (!feudUid && $f18c00e15af0c7db$var$segmentParticipants.length < 1) {
                notie.alert({
                    type: 3,
                    text: "Select participants for this Segment"
                });
                return false;
            }
        }
        // Reset search
        if ($(".superstar-search-input").val()) $(".superstar-search-input").val("").trigger("input");
        // Get selected participants
        let selectedParticipants = [];
        let selectedElements = $("#booking-talent-container.segments-selection .superstar-select.selected");
        selectedElements.each(function(i, selection) {
            selectedParticipants.push({
                "name": $(selection).attr("data-name"),
                "uid": parseInt($(selection).attr("data-uid")),
                "type": $(selection).attr("data-type")
            });
        });
        // Sort in order of selected participants
        if ($f18c00e15af0c7db$var$segmentParticipants.length > 0) selectedParticipants.sort((x, y)=>$f18c00e15af0c7db$var$segmentParticipants.indexOf(x.name) - $f18c00e15af0c7db$var$segmentParticipants.indexOf(y.name));
        // Check if factions selected in faction segment
        if (isFactionSegment) {
            let selectedParticipantsNotFactions = selectedParticipants.filter(function(selectedParticipant) {
                return selectedParticipant["type"] !== "faction";
            });
            if (selectedParticipantsNotFactions.length > 0 && !noParticipants) {
                notie.alert({
                    type: 3,
                    text: "You can only select Factions for this Segment"
                });
                return false;
            }
        }
        // Get consequence data (faction inputs) if faction input segment
        let consequenceData = {};
        if (isFactionInputSegment) {
            // Check for empty first input
            let selectFactionMemberInputs = selectedSegment.find(".select-faction-member");
            if (selectFactionMemberInputs.length > 0 && !selectFactionMemberInputs.eq(0).val()) {
                notie.alert({
                    type: 3,
                    text: "Select members for this segment (under the segment item)"
                });
                selectedSegment[0].scrollIntoView();
                selectFactionMemberInputs.eq(0).addClass("highlight");
                return false;
            }
            // Get faction member inputs that aren't empty
            let superstarUids = [];
            selectFactionMemberInputs.each(function() {
                if ($(this).val()) superstarUids.push(parseInt($(this).val()));
            });
            let factionConsequenceUids = Array.from(selectedSegment.find(".select-faction"), function(x) {
                return parseInt($(x).val());
            });
            let factionUids = Array.from(selectedElements, function(x) {
                return parseInt($(x).attr("data-uid"));
            });
            let createdFactionName = selectedSegment.find(".segment-item-faction-name").val();
            let leaderUid = parseInt(selectedSegment.find(".select-faction-leader").val());
            // Validate
            if (selectedSegment.find(".segment-item-faction-name").length > 0 && createdFactionName.length <= 0) {
                notie.alert({
                    type: 3,
                    text: "Enter a name for the Faction"
                });
                return false;
            }
            consequenceData["superstarUids"] = superstarUids;
            consequenceData["factionUids"] = factionUids;
            consequenceData["factionConsequenceUids"] = factionConsequenceUids;
            consequenceData["createdFactionName"] = createdFactionName;
            consequenceData["leaderUid"] = leaderUid;
        }
        // Check talent input for manager input segment
        let managedTalentUid;
        let managerUid;
        if (isManagerInputSegment) {
            // Check if superstar or team selected
            let selectedParticipantsFactions = selectedParticipants.filter(function(selectedParticipant) {
                return selectedParticipant["type"] === "faction";
            });
            if (selectedParticipantsFactions.length > 0) {
                notie.alert({
                    type: 3,
                    text: "You can only select Superstars and Teams for this Segment"
                });
                return false;
            }
            // Check for empty first input for managed talent select
            let selectManagedTalentInput = selectedSegment.find(".select-managed-talent");
            if (selectManagedTalentInput.length > 0 && !selectManagedTalentInput.eq(0).val()) {
                notie.alert({
                    type: 3,
                    text: "Select managed talent to use for this segment (under the segment item)"
                });
                selectedSegment[0].scrollIntoView();
                selectManagedTalentInput.eq(0).addClass("highlight");
                return false;
            }
            // Check for empty first input for manager select
            let selectManagerInput = selectedSegment.find(".select-manager");
            if (selectManagerInput.length > 0 && !selectManagerInput.eq(0).val()) {
                notie.alert({
                    type: 3,
                    text: "Select a manager to add to this talent (under the segment item)"
                });
                selectedSegment[0].scrollIntoView();
                selectManagerInput.eq(0).addClass("highlight");
                return false;
            }
            // Get uid for talent
            managedTalentUid = parseInt(selectManagedTalentInput.eq(0).val());
            // Get uid for manager
            managerUid = parseInt(selectManagerInput.eq(0).val());
        }
        // Get consequence data if brand input segment
        if (isBrandInputSegment) {
            let selectBrandInput = selectedSegment.find(".select-brand");
            if (selectBrandInput.length > 0 && !selectBrandInput.eq(0).val()) {
                notie.alert({
                    type: 3,
                    text: "Select a brand to draft this talent to (under the segment item)"
                });
                selectedSegment[0].scrollIntoView();
                selectBrandInput.eq(0).addClass("highlight");
                return false;
            }
            // Get uid for brand
            consequenceData["brandUid"] = parseInt(selectBrandInput.eq(0).val());
            let selectBrandTalentInput = selectedSegment.find(".select-brand-talent");
            if (selectBrandTalentInput.length > 0 && !selectBrandTalentInput.eq(0).val()) {
                notie.alert({
                    type: 3,
                    text: "Select a talent to draft (under the segment item)"
                });
                selectedSegment[0].scrollIntoView();
                selectBrandTalentInput.eq(0).addClass("highlight");
                return false;
            }
            // Get uid and type for talent
            consequenceData["talentUid"] = parseInt(selectBrandTalentInput.eq(0).val());
            consequenceData["talentType"] = selectBrandTalentInput.find(":selected").attr("data-type");
        }
        // Get consequence data if other input segment
        if (isOtherInputSegment) {
            let otherInput = selectedSegment.find(".segment-item-input");
            if (otherInput.length > 0) {
                if (otherInput.attr("name") === "segment-item-unavailable-months") consequenceData["monthsUnavailable"] = otherInput.eq(0).val();
                if (otherInput.attr("name") === "segment-item-object-name") consequenceData["objectName"] = otherInput.eq(0).val();
                if (otherInput.attr("name") === "segment-item-competitor") consequenceData["competitorUid"] = parseInt(otherInput.eq(0).val());
                if (otherInput.attr("name") === "segment-item-feud") consequenceData["feudUid"] = parseInt(otherInput.eq(0).val());
                if (otherInput.attr("name") === "segment-item-championship") consequenceData["championshipUid"] = parseInt(otherInput.eq(0).val());
                if (otherInput.attr("name") === "segment-item-match-or-segment") {
                    consequenceData["matchOrSegmentUid"] = parseInt(otherInput.eq(0).val());
                    consequenceData["matchOrSegmentType"] = otherInput.find(":selected").attr("data-type");
                }
            }
        }
        // Get producer uid if selected
        let producerUid;
        if ($("#booking-container").find('input[value="add_segment_producer_focus"]').prop("checked")) producerUid = parseInt($("#booking-container").find(".add-segment-producer-select").val());
        await (0, $1JSre.makeGameRequest)((0, $4ptHI.bookSegment), {
            feudUid: feudUid,
            segmentItemUid: segmentItemUid,
            selectedParticipants: selectedParticipants,
            consequenceData: consequenceData,
            managedTalentUid: managedTalentUid,
            managerUid: managerUid,
            producerUid: producerUid
        }, $f18c00e15af0c7db$var$showBookSegmentData, {}, false);
    });
    // Show/hide segment producer select
    $("#booking-container").on("click", 'input[value="add_segment_producer_focus"]', function() {
        let value = $(this).prop("checked");
        if (value) $("#booking-container").find(".add-segment-producer-select").show();
        else $("#booking-container").find(".add-segment-producer-select").hide();
    });
    // Segment items filter
    $addSegmentItemMenu.on("click", ".filter-segment-items-option", function() {
        (0, $lCS03.playSoundEffect)("success");
        let filterName;
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else {
            $(".filter-segment-items-option").removeClass("selected");
            $(this).addClass("selected");
            filterName = $(this).attr("data-value");
        }
        $("#segment-items-container").show();
        $(".add-custom-segment-container").hide();
        $(".add-custom-segment-segments-menu-button").removeClass("selected");
        $(".no-segment-search-results").hide();
        let segmentItemsContainer = $("#segment-items-container");
        let segmentElements = segmentItemsContainer.find(".item-container");
        if (filterName) {
            if (filterName === "available") // For dynamic filters (like unavailable feud segments), check for class
            segmentElements.each(function(i, e) {
                if ($(e).hasClass("unavailable") || $(e).hasClass("locked")) $(e).hide();
                else $(e).show();
            });
            else // Otherwise, check if filter value present in segment item's tags
            segmentElements.each(function(i, e) {
                let tags = $(e).data("tags");
                if (tags.indexOf(filterName) >= 0) $(e).show();
                else $(e).hide();
            });
            if (segmentElements.is(":visible")) $(".no-segment-search-results").hide();
            else if ($(".no-segment-search-results").length > 0) $(".no-segment-search-results").show();
            else segmentItemsContainer.append('<div class="no-segment-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
        } else segmentElements.show();
        // Reset search
        $(".segment-search-input").val("");
        $("#segment-items-container").scrollTop(0);
    });
    // Segment items search
    $addSegmentItemMenu.on("input", ".segment-search-input", function() {
        $f18c00e15af0c7db$var$runSegmentSearch();
    });
    // Segment items sort
    $addSegmentItemMenu.on("change", ".segment-sort", function() {
        let value = $(this).val();
        $f18c00e15af0c7db$var$applySegmentSort(value);
    });
    // Segment items sort order
    $addSegmentItemMenu.on("click", ".segment-sort-order", function() {
        let icon = $(this).find("i");
        if (icon.hasClass("fa-sort-up") || icon.hasClass("fa-sort-down")) {
            let segmentItemsContainer = $("#segment-items-container");
            let availableSegmentElements = segmentItemsContainer.find(".item-container:not(.locked)");
            let unavailableSegmentElements = segmentItemsContainer.find(".item-container.locked");
            segmentItemsContainer.append(availableSegmentElements.get().reverse());
            segmentItemsContainer.append(unavailableSegmentElements.get().reverse());
            if (icon.hasClass("fa-sort-up")) icon.removeClass("fa-sort-up").addClass("fa-sort-down");
            else if (icon.hasClass("fa-sort-down")) icon.removeClass("fa-sort-down").addClass("fa-sort-up");
        }
    });
    // Add custom segment menu button
    $addSegmentItemMenu.on("click", ".add-custom-segment-segments-menu-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        if ($(this).hasClass("selected")) {
            $(this).removeClass("selected");
            // Show all segment items
            let segmentItemsContainer = $("#segment-items-container");
            let segmentElements = segmentItemsContainer.find(".item-container");
            segmentElements.show();
            segmentItemsContainer.show();
            // Hide custom segment container
            $(".add-custom-segment-container").hide();
            // Scroll to top of segment items container
            segmentItemsContainer.scrollTop(0);
            return false;
        } else {
            $(".filter-segment-items-option").removeClass("selected");
            $(".segment-search-input").val("");
            $(this).addClass("selected");
            $(".add-custom-segment-container").find(".back-to-view-segments-button").hide();
        }
        (0, $9f0f3c0f4508366a$export$4acf80557bedaca3).addCustomSegmentChangesMade = false;
        $(".add-custom-segment-container").addClass("scroll margin-top-20").show();
        $(".add-custom-segment-container").scrollTop(0);
        $("#segment-items-container").hide();
        // Reset
        $(".add-custom-segment-template-button:contains('Basic')").trigger("click");
        $(".add-custom-segment-more-options").hide();
        let customSegmentMoreOptionsButton = $(".add-custom-segment-more-options-button");
        customSegmentMoreOptionsButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        customSegmentMoreOptionsButton.find("span").text("Show Details");
        $(".import-community-segment-input").val("");
        $(".add-custom-segment-community-segments-container").hide();
        let customSegmentCommunitySegmentsButton = $(".add-custom-segment-show-community-segments-button");
        customSegmentCommunitySegmentsButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        customSegmentCommunitySegmentsButton.find("span").text("Show Community Segments");
        // Show save options
        $(".add-custom-segment-save-to-game-container").show();
        $(".add-custom-segment-save-to-community-container").show();
        // Hide edit info
        $(".edit-custom-segment-button").hide();
        $(".back-to-edit-custom-segments-button").hide();
        $(".add-custom-segment-button").show();
        $(".add-custom-segment-label").text("Add Custom Segment");
        $(".add-custom-segment-help-text-container").hide();
        let customSegmentHelpButton = $(".add-custom-segment-help-button");
        customSegmentHelpButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        customSegmentHelpButton.find("span").text("Show How It Works");
        // Disable if free user
        if (!(0, $98xmD.globalUser).paid) {
            $(".add-custom-segment-container").addClass("disabled");
            $(".add-custom-segment-container").find("input, textarea").prop("disabled", true);
            $(".add-custom-segment-container").addClass("help-text");
            $(".add-custom-segment-container").attr("title", "JoW Paid includes Custom Segments");
            $(".add-custom-segment-help-text-container").hide();
            let customSegmentHelpButton = $(".add-custom-segment-help-button");
            customSegmentHelpButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
            customSegmentHelpButton.find("span").text("Show How It Works");
        } else {
            $(".add-custom-segment-container").removeClass("help-text");
            $(".add-custom-segment-container").removeAttr("title");
            $(".add-custom-segment-container").removeClass("disabled");
            $(".add-custom-segment-container").find("input, textarea").prop("disabled", false);
        }
    });
    // Custom Package preview
    let customPackageTimer = null;
    let customPackageInterval = null;
    let customPackageTypingTimer = null;
    $segmentItemsContainer.on("keyup", ".custom-package-start-text, .custom-package-action-text, .custom-package-name", function() {
        let timeoutDelay = 800;
        if (window.mobilecheck()) timeoutDelay = 1400;
        // Reset timers
        clearTimeout(customPackageTimer);
        clearTimeout(customPackageInterval);
        clearTimeout(customPackageTypingTimer);
        let name = $(".custom-package-name").val();
        let startText = $(".custom-package-start-text").val();
        // Wait for user to stop typing
        customPackageTypingTimer = setTimeout(function() {
            (function showPackageAnimation() {
                customPackageTimer = $f18c00e15af0c7db$var$runCustomPackagePreviewAnimation(name, startText, customPackageTimer);
                // Loop package preview
                customPackageInterval = setTimeout(showPackageAnimation, 5400);
            })();
        }, timeoutDelay);
    });
    // Custom package help
    $segmentItemsContainer.on("click", ".custom-package-help-button", function() {
        let container = $(".custom-package-help-container");
        if (container.is(":visible")) {
            container.hide();
            $(this).text("help");
        } else {
            container.show();
            $(this).text("hide help");
        }
    });
    // Add custom package action text inputs
    $segmentItemsContainer.on("click", ".add-custom-package-action-text-button, .remove-custom-package-action-text-button", function() {
        if ($(this).hasClass("add-custom-package-action-text-button")) $(".custom-package-action-text").last().after('<input type="text" placeholder="Action Text" class="styled-input custom-package-action-text margin-top-5" maxlength="250">');
        else $(".custom-package-action-text").last().remove();
        // Add/remove icons
        if ($(".custom-package-action-text").length > 1) $(".remove-custom-package-action-text-button").show();
        else $(".remove-custom-package-action-text-button").hide();
        if ($(".custom-package-action-text").length > 10) $(".add-custom-package-action-text-button").hide();
        else $(".add-custom-package-action-text-button").show();
    });
    // Create custom package
    $("#segment-items-container").on("click", "#create-custom-package-button", async function() {
        // Get values
        let name = $(".custom-package-name").val();
        let startText = $(".custom-package-start-text").val();
        let actionTexts = [];
        let actionTextInputs = $(".custom-package-action-text").filter(function() {
            return !!this.value;
        });
        actionTextInputs.each(function(i, e) {
            actionTexts.push($(e).val());
        });
        await (0, $1JSre.makeGameRequest)((0, $4ptHI.createCustomProductionPackage), {
            name: name,
            startText: startText,
            actionTexts: actionTexts
        }, $f18c00e15af0c7db$var$showCreateCustomProductionPackageData, {}, false);
    });
    $segmentItemsContainer.on("click", ".add-faction-member-select-button, .remove-faction-member-select-button, .select-faction-member, .select-faction, .segment-item-faction-name, .select-faction-leader, .select-managed-talent, .select-manager, .select-brand, .select-brand-talent, .segment-item-input", function(e) {
        e.stopPropagation();
    });
    // Delete segment
    $("#matches").on("click", ".event-card-segment-delete-button", async function() {
        let $segmentElement = $(this).closest(".event-match");
        let uid = parseInt($segmentElement.attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $4ptHI.deleteCompanySegment), {
            uid: uid
        }, $f18c00e15af0c7db$var$showDeleteSegmentData, {
            $segmentElement: $segmentElement
        }, false);
    });
    // Show 'add producer' page for segment
    $("#matches").on("click", ".event-card-segment-add-producer-button", async function() {
        let segmentUid = parseInt($(this).closest(".event-match").attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $8A6FL.getCompanyProducers), {}, $f18c00e15af0c7db$var$showGetAddProducersData, {
            segmentUid: segmentUid
        }, false);
    });
    // Add segment producer button
    $("#container").on("click", "#segment-add-producer-button", async function() {
        let parent = $("#segment-add-producer-container");
        let segmentUid = parent.data("segment-uid");
        let producerUid = parseInt(parent.find(".segment-add-producer-select").val());
        // Validate
        if (!producerUid) {
            notie.alert({
                type: 3,
                text: "Select a Producer to assign to the Segment"
            });
            return false;
        }
        await (0, $1JSre.makeGameRequest)((0, $4ptHI.addProducerToSegment), {
            segmentUid: segmentUid,
            producerUid: producerUid
        }, $f18c00e15af0c7db$var$showAddProducerToSegmentData, {
            segmentUid: segmentUid
        }, false);
    });
    // Remove segment producer button
    $("#matches").on("click", ".event-card-segment-remove-producer-button", async function() {
        let segmentUid = parseInt($(this).closest(".event-match").attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $4ptHI.removeProducerFromSegment), {
            segmentUid: segmentUid
        }, $f18c00e15af0c7db$var$showRemoveProduceFromSegmentData, {
            segmentUid: segmentUid
        }, false);
    });
    // ** AUTO BOOKER / SIMULATOR **
    // Show auto booker
    $("#main-menu-right").on("click", "#auto-book-button", function() {
        (0, $1JSre.hideContent)($("#event-card"));
        // Reset ui
        $(".tag-match-options").remove();
        $("#add-tournament-menu-button").hide();
        // Cost
        let autoBookerCost = "15";
        if ((0, $98xmD.globals).game.weeklyShow) autoBookerCost = "7";
        // Hide booked
        let hideBookedChecked = "";
        let rememberHideBookedChecked = "";
        let hideRememberCheckbox = " display-none";
        if ((0, $98xmD.globals).game.settings["rememberHideBooked"]) {
            hideBookedChecked = ' checked="checked"';
            rememberHideBookedChecked = ' checked="checked"';
            hideRememberCheckbox = "";
        }
        // Add auto booker container
        let autoBookerHtml = '<div class="auto-booker-container font-bold box margin-0-auto"><div class="margin-0-auto auto-booker"><div class="margin-bottom-10"><span class="font-mukta-mahee font-1p325em menu-header-color">Auto Booker</span><span class="blue float-right"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/> <span class="auto-booker-cost">' + autoBookerCost + "</span>" + "</span>" + "</div>" + '<div class="font-0p825em">' + '<div class="margin-bottom-10">' + '<div class="display-block margin-bottom-2">Style</div>' + '<select class="styled-select help-text" id="auto-booker-style" ' + 'title="Select the booking style">' + '<option value="quality" selected>Quality</option>' + '<option value="standard">Standard</option>' + '<option value="long-term">Long-term</option>' + '<option value="bizarro">Bizarro</option>' + '<option value="terrible">Terrible</option>' + "</select>" + "</div>" + '<div class="margin-bottom-15">' + '<div class="display-block margin-bottom-2">Number of Matches/Segments</div>' + '<select class="styled-select help-text" id="auto-booker-matches" ' + 'title="Select the number of Matches/Segments to book">' + '<option value="auto" selected>Auto</option>' + '<option value="max">Maximum</option>' + '<option value="min">Minimum</option>' + "</select>" + "</div>" + '<div class="margin-bottom-10">' + '<label class="control control--radio margin-right-10">' + 'Replace<input type="radio" name="radio-auto-booker-option" value="replace" checked="checked">' + '<div class="control__indicator"></div></label>' + '<label class="control control--radio margin-right-10">' + 'Add <input type="radio" name="radio-auto-booker-option" value="add">' + '<div class="control__indicator"></div></label>' + "</div>" + '<div class="margin-bottom-15">' + '<label class="control control--checkbox">' + "Hide Booked" + '<input type="checkbox" class="auto-booker-hide-booked-checkbox"' + hideBookedChecked + "/>" + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox margin-left-10' + hideRememberCheckbox + '">' + "Remember" + '<input type="checkbox" class="auto-booker-hide-booked-remember-checkbox"' + rememberHideBookedChecked + "/>" + '<div class="control__indicator"></div>' + "</label>" + "</div>" + "<div>" + '<button type="button" ' + 'class="button retro-button blue-button-background" id="auto-book-button">Book</button> ' + "</div>" + "</div>" + "</div>" + "</div>";
        $("#auto-booker-container").html(autoBookerHtml).show();
    });
    // Show remember 'hide booked' checkbox
    $("#auto-booker-container").on("click", ".auto-booker-hide-booked-checkbox", function() {
        if ($(this).prop("checked")) $(".auto-booker-hide-booked-remember-checkbox").parent().removeClass("display-none");
        else $(".auto-booker-hide-booked-remember-checkbox").parent().addClass("display-none");
    });
    // Change auto booker style
    $("#auto-booker-container").on("change", "#auto-booker-style", function() {
        let style = $(this).val();
        let cost = $f18c00e15af0c7db$var$getSimulatorCost(style);
        if ((0, $98xmD.globals).game.weeklyShow) cost = Math.floor(cost / 2);
        $(".auto-booker-cost").text(cost);
    });
    // Change game setting (remember hide booked)
    $("#auto-booker-container").on("click", ".auto-booker-hide-booked-remember-checkbox", async function() {
        let settingName = "rememberHideBooked";
        let value = $(this).prop("checked");
        await (0, $70adc4a1fd111893$export$a8834e9c186723b7)(settingName, value);
    });
    // Auto book button
    $("#auto-booker-container").on("click", "#auto-book-button", async function() {
        let style = $(".auto-booker-container").find("#auto-booker-style").val();
        let numberOption = $(".auto-booker-container").find("#auto-booker-matches").val();
        let addOption = $('input[name="radio-auto-booker-option"]:checked').val();
        // If matches exist, confirm
        if ($("#matches .event-match").length > 0 && addOption === "replace") notie.confirm({
            text: "Auto booking will remove all booked Matches/Segments. Are you sure you want to do that?",
            submitText: "Yes",
            cancelText: "No",
            submitCallback: async function() {
                await $f18c00e15af0c7db$var$autoBookRequest(style, numberOption, addOption);
            },
            cancelCallback: function() {
                return false;
            }
        });
        else await $f18c00e15af0c7db$var$autoBookRequest(style, numberOption, addOption);
    });
    // Show simulator
    $("#main-menu-right").on("click", "#simulator-menu-button", function() {
        (0, $1JSre.hideContent)($("#event-card"));
        // Reset ui
        $(".tag-match-options").remove();
        $("#add-tournament-menu-button").hide();
        let maxEvents = 1000;
        // Add auto booker container
        let div = '<div class="auto-booker-container font-bold box margin-0-auto"><div class="margin-0-auto simulator"><div class="margin-bottom-10"><span class="font-mukta-mahee font-1p325em menu-header-color">Simulator</span><span class="blue float-right"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/> <span class="simulator-cost">15</span></span></div><div class="font-0p825em"><div class="margin-bottom-10"><div class="display-block margin-bottom-2">Booking Style</div><select class="styled-select help-text" id="simulator-booking-style" title="Select the booking style"><option value="quality" selected>Quality</option><option value="standard">Standard</option><option value="long-term">Long-term</option><option value="bizarro">Bizarro</option><option value="terrible">Terrible</option></select></div><div class="margin-bottom-10"><div class="display-block margin-bottom-2">Events</div><input type="number" id="simulator-events" min="1" max="' + maxEvents + '" ' + 'name="simulator-events" class="styled-input help-text" ' + 'value="1" ' + 'title="Select the number of months to simulate">' + "</div>" + '<div class="margin-bottom-20">' + '<div class="display-block margin-bottom-2">Notifications</div>' + '<select class="styled-select" id="simulator-notifications">' + '<option value="brief">Brief</option>' + '<option value="deep" selected>Deep</option>' + "</select>" + "</div>" + '<div class="margin-bottom-15">' + '<label class="control control--radio margin-right-10">' + 'Book Only<input type="radio" name="radio-simulator-option" value="book" checked="checked">' + '<div class="control__indicator"></div></label>' + '<label class="control control--radio margin-right-10 help-text" ' + 'title="While managing the Company, Simulator creates and disbands Teams, signs and ' + 'releases Superstars, creates and retires Titles, uses Artifacts and calls up Superstars.">' + "Book & Manage Company" + '<input type="radio" name="radio-simulator-option" value="manage">' + '<div class="control__indicator"></div></label>' + "</div>" + "<div>" + '<button type="button" ' + 'class="button retro-button blue-button-background" id="simulator-button">Simulate</button> ' + "</div>" + "</div>" + "</div>" + "</div>";
        $("#auto-booker-container").html(div).show();
    });
    // Simulator cost
    $("#auto-booker-container").on("input", "#simulator-events", function() {
        let style = $("#simulator-booking-style").val();
        let cost = $f18c00e15af0c7db$var$getSimulatorCost(style);
        let totalCost = $(this).val() * cost;
        $(".simulator-cost").text(totalCost);
    });
    $("#auto-booker-container").on("change", "#simulator-booking-style", function() {
        let style = $(this).val();
        let cost = $f18c00e15af0c7db$var$getSimulatorCost(style);
        let totalCost = $("#simulator-events").val() * cost;
        $(".simulator-cost").text(totalCost);
    });
    // Simulate button
    $("#auto-booker-container").on("click", "#simulator-button", async function() {
        let style = $(".simulator").find("#simulator-booking-style").val();
        let eventsToSimulate = parseInt($(".simulator").find("#simulator-events").val());
        let notificationsOption = $(".simulator").find("#simulator-notifications").val();
        let simulatorOption = $(".simulator").find('input[name="radio-simulator-option"]:checked').val();
        let maxEvents = 1000;
        if (eventsToSimulate < 1) {
            notie.alert({
                type: 3,
                text: "You can't simulate less than 1 month"
            });
            return false;
        }
        if (eventsToSimulate > maxEvents) {
            notie.alert({
                type: 3,
                text: "You can't simulate more than " + maxEvents + " Events at a time"
            });
            return false;
        }
        // Reset ui
        (0, $1JSre.hideContent)($());
        $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
        $("#simulation-results-container").show();
        $("#simulation-results-container").data("stopSimulation", false);
        $("#stop-simulation-button").parent().show();
        let progressBarHtml = '<div class="progress-under margin-bottom-20"><div class="progress" style="width:0"></div></div>';
        let progressHtml = '<div id="simulation-progress-bar" class="margin-bottom-25">' + progressBarHtml + "</div>";
        $("#simulation-results-container #simulation-progress").html(progressHtml);
        $("#simulation-updates").html("");
        $("#simulation-news").html("");
        notie.setOptions({
            transitionDuration: 0
        });
        notie.alert({
            type: 4,
            text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Simulating...',
            stay: true
        });
        setTimeout(async ()=>{
            notie.setOptions({
                transitionDuration: 0.3
            });
            await (0, $1JSre.makeGameRequest)((0, $f0da149825527215$export$bc91b222c7cf4008), {
                style: style,
                eventsToSimulate: eventsToSimulate,
                simulatorOption: simulatorOption
            }, $f18c00e15af0c7db$var$showRunSimulatorData, {
                style: style,
                eventsToSimulate: eventsToSimulate,
                notificationsOption: notificationsOption,
                simulatorOption: simulatorOption,
                totalEvents: eventsToSimulate
            }, false, true, true, false);
        }, 50);
    });
    // Stop simulation button
    $("#simulation-results-container").on("click", "#stop-simulation-button", function() {
        $("#simulation-results-container").data("stopSimulation", true);
        notie.alert({
            type: 4,
            text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Stopping Simulation',
            stay: true
        });
    });
    // ** TOURNAMENT **
    // Show tournament page
    $("#main-menu-right").on("click", "#add-tournament-menu-button", async function() {
        // If tournament matches exist, don't allow
        if ($("#matches").find(".tournament-match").length > 0) {
            notie.alert({
                type: 3,
                text: "You already have a tournament booked at this event"
            });
            return false;
        }
        // Don't allow singles tag tournament
        if ([
            "2v2",
            "3v3",
            "4v4",
            "5v5",
            "1v2",
            "1v3",
            "2v3",
            "?v?"
        ].indexOf($(".tag-match-option.selected").text()) >= 0) {
            notie.alert({
                type: 3,
                text: "You can only book tag/trio tournaments (not 3v3, 4v4 etc)"
            });
            return false;
        }
        await (0, $1JSre.makeGameRequest)((0, $8A6FL.getCompanyUniqueTournaments), {}, $f18c00e15af0c7db$var$showGetCompanyUniqueTournamentsData, {}, false);
    });
    // Show Round Robin options
    $("#add-tournament-container").on("change", "#tournament-type", function() {
        if (this.value === "round-robin") {
            $(".round-robin-options").show();
            $(this).closest("#add-tournament-container").find("#auto-pick-input").replaceWith('<input type="number" id="auto-pick-input" class="auto-pick-input" name="auto-picker-value" value="12" min="4">');
            $("#create-bracket").text("Create Groups");
            $(".tournament-bracket-container").hide();
        } else {
            $(".round-robin-options").hide();
            $(this).closest("#add-tournament-container").find("#auto-pick-input").replaceWith('<select name="auto-pick-number" id="auto-pick-input" class="styled-select"><option value="4">4</option><option value="8">8</option><option value="16" selected>16</option><option value="32">32</option><option value="64">64</option><option value="128">128</option></select>');
            $("#create-bracket").text("Create Bracket");
            $(".tournament-groups-container").hide();
        }
        $f18c00e15af0c7db$var$setTournamentMatchesAtEvent();
    });
    // Set participant options based on number of groups
    $("#add-tournament-container").on("change", "#number-of-groups", function() {
        if (this.value === "1") {
            $("#participants-advancing").html('<option value="0">0</option><option value="2" selected>2</option>');
            $(".number-of-groups-text").text(" Group");
        } else {
            $("#participants-advancing").html('<option value="1" selected>1</option><option value="2">2</option>');
            $(".number-of-groups-text").text(" Groups");
        }
        $("#participants-advancing").trigger("change");
        $f18c00e15af0c7db$var$setTournamentMatchesAtEvent();
    });
    // Set participants advancing text
    $("#add-tournament-container").on("change", "#participants-advancing", function() {
        if (this.value === "1") $(".participant-advancing-text").text(" Participant advances");
        else if (this.value === "0") $(".participant-advancing-text").text(" Participants advance (No Elimination Round)");
        else $(".participant-advancing-text").text(" Participants advance");
        $f18c00e15af0c7db$var$setTournamentMatchesAtEvent();
    });
    // Show award options
    $("#add-tournament-container").on("change", 'input[name="radio-award-option"]', function() {
        if (this.value === "match-contract") $(".award-options-match-contract").show();
        else $(".award-options-match-contract").hide();
    });
    // Show selected tournament's prestige while adding a tournament
    $("#add-tournament-container").on("change", "#add-tournament-select", function() {
        let selected = $(this).find(":selected");
        if (selected.val()) {
            let prestige = $(selected).attr("data-prestige");
            let prestigeIcon = "";
            switch(prestige){
                case "C":
                    prestigeIcon = '<i class="fa fa-star-o font-bold top-1px margin-left-8 bronze"></i>';
                    break;
                case "B":
                    prestigeIcon = '<i class="fa fa-star-o font-bold top-1px margin-left-8 silver"></i>';
                    break;
                case "A":
                    prestigeIcon = '<i class="fa fa-star-o font-bold top-1px margin-left-8 gold-light"></i>';
                    break;
            }
            $(".add-tournament-select-prestige").html(prestigeIcon);
            let cost = $(selected).attr("data-cost");
            $(".add-tournament-cost").text(cost);
            // Show/hide award options
            let matchContractName = $(selected).attr("data-match-contract-name");
            if (matchContractName) {
                $("#tournament-match-contract-name").val(matchContractName);
                $('input[name="radio-award-option"]').val([
                    "match-contract"
                ]);
                $(".award-options-match-contract").show();
            } else {
                $("#tournament-match-contract-name").val("");
                $('input[name="radio-award-option"]').val([
                    "none"
                ]);
                $(".award-options-match-contract").hide();
            }
            $("#tournament-name").hide();
        } else {
            $(".add-tournament-select-prestige").html("");
            $(".add-tournament-cost").text("150");
            $("#tournament-match-contract-name").val("");
            $('input[name="radio-award-option"]').val([
                "none"
            ]);
            $(".award-options-match-contract").hide();
            $("#tournament-name").show();
        }
    });
    // Get tournament bracket
    $("#add-tournament-container").on("click", "#create-bracket", async function() {
        let tournamentType = $(".add-tournament-container").find("#tournament-type").val();
        let numberOfGroups = parseInt($("#number-of-groups").val());
        let matchType;
        let $el = $(this);
        if ($("#book-singles-menu-button").hasClass("selected")) matchType = "singles";
        else if ($("#book-tag-team-menu-button").hasClass("selected")) matchType = "tag";
        // Validate elimination
        if (tournamentType === "elimination") {
            // Max
            let participantsLimit = 16;
            if ((0, $98xmD.globalUser).paid) participantsLimit = 128;
            // Minimum
            if ($f18c00e15af0c7db$var$selectedParticipants.length < 4) {
                notie.alert({
                    type: 3,
                    text: "You need to select at least 4 participants for a tournament"
                });
                return false;
            } else if ($f18c00e15af0c7db$var$selectedParticipants.length > participantsLimit) {
                let paidText = "";
                if (!(0, $98xmD.globalUser).paid) paidText += ". JoW Paid allows 128 participants.";
                notie.alert({
                    type: 3,
                    text: "You can't select more than " + participantsLimit + " participants for an Elimination Tournament" + paidText
                });
                return false;
            } else if (!(0, $3E8Nt.isPowerOfTwo)($f18c00e15af0c7db$var$selectedParticipants.length)) {
                notie.alert({
                    type: 3,
                    text: "Tournament participants need to be a power of 2 e.g 4/8/16/32 etc"
                });
                return false;
            }
        } else if (tournamentType === "round-robin") {
            // Max
            let participantsLimit = 12;
            if ((0, $98xmD.globalUser).paid) participantsLimit = 24;
            // Check for minimum group participants
            if ($f18c00e15af0c7db$var$selectedParticipants.length < numberOfGroups * 4) {
                notie.alert({
                    type: 3,
                    text: "You need to select at least 4 participants for every group"
                });
                return false;
            }
            // Maximum group participants
            if ($f18c00e15af0c7db$var$selectedParticipants.length > participantsLimit) {
                let paidText = "";
                if (!(0, $98xmD.globalUser).paid) paidText += ". JoW Paid allows 24 participants.";
                notie.alert({
                    type: 3,
                    text: "You can't select more than " + participantsLimit + " participants for a Round Robin Tournament" + paidText
                });
                return false;
            }
            // Participants per group must be even
            if ($f18c00e15af0c7db$var$selectedParticipants.length / numberOfGroups % 2 !== 0) {
                notie.alert({
                    type: 3,
                    text: "The number of participants per group should be an even number"
                });
                return false;
            }
            // Participants multiple of number of groups
            if ($f18c00e15af0c7db$var$selectedParticipants.length % numberOfGroups !== 0) {
                notie.alert({
                    type: 3,
                    text: "The number of participants should be a multiple of the number of groups e.g 8/10/12 etc for 2 groups"
                });
                return false;
            }
            // Multiple of 2
            if ($f18c00e15af0c7db$var$selectedParticipants.length % 2 !== 0) {
                notie.alert({
                    type: 3,
                    text: "Tournament participants need to be a multiple of 2 e.g 8/10/12 etc"
                });
                return false;
            }
        }
        // Get participants data
        let participantsData = [];
        $f18c00e15af0c7db$var$selectedElements.forEach(function(selection) {
            let $selectionElement = $(selection);
            participantsData.push({
                "name": $selectionElement.attr("data-name"),
                "type": $selectionElement.attr("data-type"),
                "uid": parseInt($selectionElement.attr("data-uid"))
            });
        });
        await (0, $1JSre.makeGameRequest)((0, $46buw.getTournamentDisplay), {
            participantsData: participantsData,
            tournamentType: tournamentType,
            matchType: matchType,
            numberOfGroups: numberOfGroups
        }, $f18c00e15af0c7db$var$showGetTournamentDisplayData, {
            participantsData: participantsData,
            tournamentType: tournamentType,
            $el: $el
        }, false);
    });
    // Add tournament
    $("#add-tournament-container").on("click", "#create-tournament", async function() {
        let nameElement = $(".add-tournament-container").find("#tournament-name");
        let name = nameElement.val().trim();
        let tournamentName = $("#add-tournament-select").find(":selected").val();
        let type = $(".add-tournament-container").find("#tournament-type").val();
        let matchesAtEvent = $(".add-tournament-container").find("#tournament-matches-at-event").val();
        let participantsAdvancing = parseInt($("#participants-advancing").val());
        // Get participants
        let participantsData;
        if (type === "elimination") participantsData = Array.from($(".add-tournament-container .tournament-participant-name:visible"), function(x) {
            if ($(x).attr("data-name") !== undefined) return $(x).attr("data-name");
            return $(x).text();
        });
        else if (type === "round-robin") {
            participantsData = [];
            $(".add-tournament-container .tournament-bracket-match").each(function(i, e) {
                let x = [];
                $(e).find(".tournament-participant-name:visible").each(function(j, p) {
                    x.push($(p).text());
                });
                participantsData.push(x);
            });
        }
        let matchType;
        if ($("#book-singles-menu-button").hasClass("selected")) matchType = "singles";
        else if ($("#book-tag-team-menu-button").hasClass("selected")) matchType = "tag";
        let matchContractName = $("#tournament-match-contract-name").val();
        let matchContractEventName = $("#tournament-match-contract-event").val();
        let awardOption = $('input[name="radio-award-option"]:checked').val();
        // Validate
        if (!name && nameElement.is(":visible")) {
            notie.alert({
                type: 3,
                text: "Enter a name for the Tournament"
            });
            return false;
        }
        let triosMatch = $("#tag-teams:visible").length <= 0 && $("#trios:visible").length > 0;
        let selectedChampionshipUid = $f18c00e15af0c7db$var$selectedChampionship ? parseInt($f18c00e15af0c7db$var$selectedChampionship.attr("data-uid")) : null;
        await (0, $1JSre.makeGameRequest)((0, $46buw.createTournament), {
            participantsData: participantsData,
            name: name,
            tournamentName: tournamentName,
            type: type,
            matchesAtEvent: matchesAtEvent,
            matchType: matchType,
            matchContractName: matchContractName,
            matchContractEventName: matchContractEventName,
            awardOption: awardOption,
            participantsAdvancing: participantsAdvancing,
            triosMatch: triosMatch,
            selectedChampionshipUid: selectedChampionshipUid
        }, $f18c00e15af0c7db$var$showCreateTournamentData, {
            matchType: matchType
        }, false);
    });
});
function $f18c00e15af0c7db$var$showGetBookingData({ data: data, matchType: matchType, callbackFunction: callbackFunction, segment: segment, tagTeamType: tagTeamType } = {}) {
    // Define selectors
    let $tagTeamContainer = $("#tag-teams");
    let $trioContainer = $("#trios");
    let $factionContainer = $("#factions");
    let $notAvailableSelector = $("#not-available");
    let $managersSelector = $("#managers");
    let $retiredSelector = $("#retired");
    const $bookingTalentContainer = $("#booking-talent-container");
    const $bookingContainer = $("#booking-container");
    const $bookingTalentInfo = $("#booking-talent-info");
    // Reset ui
    $bookingTalentInfo.html($f18c00e15af0c7db$var$emptyTalentInfoHtml);
    $bookingTalentInfo.removeClass("match");
    $bookingTalentContainer.find(".superstar-select, .none-team-text").remove();
    $bookingTalentContainer.children().hide();
    // Show vacated championships
    data["vacatedChampionships"].forEach(function(championship) {
        let name = (0, $1JSre.getChampionshipDisplayName)(championship);
        $("#vacated-titles").append('<button type="button" class="superstar-select roster-item-championship font-bold" data-uid="' + championship["uid"] + '">' + name + "</button>");
    });
    if (data["vacatedChampionships"].length > 0) $("#vacated-titles").show();
    if (matchType === "singles") {
        function addSuperstarToSelector(superstar, selector) {
            let superstarDiv = $f18c00e15af0c7db$var$getRosterMemberBookingHtml(superstar, "superstar");
            selector.append(superstarDiv);
        }
        let $mainEventersSelector = $("#main-eventers");
        let $upperMidcardersSelector = $("#upper-midcarders");
        let $lowerMidcardersSelector = $("#lower-midcarders");
        let $jabroniSelector = $("#jabroni");
        // Add superstars to respective ranks
        data["available"].forEach(function(superstar) {
            let rankSelector;
            switch(superstar["rank"]){
                case "Main Eventer":
                    rankSelector = $mainEventersSelector;
                    break;
                case "Upper Midcarder":
                    rankSelector = $upperMidcardersSelector;
                    break;
                case "Lower Midcarder":
                    rankSelector = $lowerMidcardersSelector;
                    break;
                case "Jabroni":
                    rankSelector = $jabroniSelector;
                    break;
            }
            addSuperstarToSelector(superstar, rankSelector);
        });
        // Show containers
        $mainEventersSelector.show();
        $upperMidcardersSelector.show();
        $lowerMidcardersSelector.show();
        $jabroniSelector.show();
    } else if (matchType === "tag") {
        // Show tag teams
        let tagTeams = data["teams"].filter(function(obj) {
            return obj["trio"] === false;
        });
        tagTeams.forEach(function(tagTeam) {
            let tagTeamDiv = $f18c00e15af0c7db$var$getRosterMemberBookingHtml(tagTeam, "tag-team");
            $tagTeamContainer.append(tagTeamDiv);
        });
        if (tagTeams.length < 1) $tagTeamContainer.append('<span class="font-bold grey margin-left-5 display-block margin-top-2 none-team-text">None</span>');
        // Show trios
        let trios = data["teams"].filter(function(obj) {
            return obj["trio"] === true;
        });
        trios.forEach(function(tagTeam) {
            let tagTeamDiv = $f18c00e15af0c7db$var$getRosterMemberBookingHtml(tagTeam, "trio");
            $trioContainer.append(tagTeamDiv);
        });
        if (trios.length < 1) $trioContainer.append('<span class="font-bold grey margin-left-5 display-block margin-top-2 none-team-text">None</span>');
        // Show factions if not segment
        if (!segment && (0, $98xmD.globalUser).paid) {
            data["factions"].forEach(function(faction) {
                let factionDiv = $f18c00e15af0c7db$var$getRosterMemberBookingHtml(faction, "faction");
                $factionContainer.append(factionDiv);
            });
            if (data["factions"].length < 1) $factionContainer.append('<span class="font-bold grey margin-left-5 display-block margin-top-2 none-team-text">None</span>');
        }
        // Show/hide containers
        if (matchType === "tag") {
            if (tagTeamType === "trio") $trioContainer.show();
            else {
                $tagTeamContainer.show();
                $trioContainer.show();
            }
            if (!segment) $factionContainer.show();
        }
        if (!(0, $98xmD.globalUser).paid) $factionContainer.hide();
    } else if (matchType === "factions") {
        // Show factions
        data["factions"].forEach(function(faction) {
            let factionDiv = $f18c00e15af0c7db$var$getRosterMemberBookingHtml(faction, "faction");
            $factionContainer.append(factionDiv);
        });
        if (data["factions"].length < 1) $factionContainer.append('<span class="font-bold grey margin-left-7 display-block margin-top-5 none-team-text">None</span>');
        $factionContainer.show();
    }
    // Not available
    if (Array.isArray(data["notAvailable"]) && data["notAvailable"].length > 0) {
        data["notAvailable"].forEach(function(superstar) {
            let rosterMemberType = matchType === "tag" ? "tag-team" : "superstar";
            let superstarDiv = $f18c00e15af0c7db$var$getRosterMemberBookingHtml(superstar, rosterMemberType);
            $notAvailableSelector.append(superstarDiv);
        });
        if (segment) $notAvailableSelector.find(".superstars-header").addClass("medium-grey").removeClass("unavailable-color");
        else $notAvailableSelector.find(".superstars-header").removeClass("medium-grey").addClass("unavailable-color");
        $notAvailableSelector.show();
    }
    // Managers
    if (Array.isArray(data["managers"]) && data["managers"].length > 0 && (0, $98xmD.globalUser).paid) {
        data["managers"].forEach(function(superstar) {
            let superstarDiv = $f18c00e15af0c7db$var$getRosterMemberBookingHtml(superstar, "superstar");
            $managersSelector.append(superstarDiv);
        });
        $managersSelector.show();
    }
    // Retired
    if (Array.isArray(data["retired"]) && data["retired"].length > 0) {
        data["retired"].forEach(function(superstar) {
            let superstarDiv = $f18c00e15af0c7db$var$getRosterMemberBookingHtml(superstar, "superstar");
            $retiredSelector.append(superstarDiv);
        });
        $retiredSelector.show();
    }
    // Run callback function
    if (callbackFunction) callbackFunction();
    // Get all roster members
    let rosterMembers = data["available"].concat(data["notAvailable"], data["factions"], data["managers"], data["retired"], data["teams"]);
    // Show roster member information
    let rosterItemMemberTimer;
    $bookingTalentContainer.off("mouseenter", ".roster-item-member");
    $bookingTalentContainer.on({
        mouseenter: function() {
            let $this = $(this);
            rosterItemMemberTimer = setTimeout(function() {
                let rosterItemMemberUid = parseInt($this.attr("data-uid"));
                let objectName = $this.attr("data-type");
                if (objectName === "tag-team" || objectName === "trio") objectName = "tagTeam";
                if (objectName === "singles") objectName = "superstar";
                let member = rosterMembers.filter(function(obj) {
                    return (obj.objectName === objectName || obj.type === objectName) && obj.uid === rosterItemMemberUid;
                })[0];
                if (member) {
                    if ($this.attr("data-type") === "tag-team" || $this.attr("data-type") === "trio") $f18c00e15af0c7db$export$b73c16b811178760(member);
                    else if ($this.attr("data-type") === "faction") $f18c00e15af0c7db$var$showFactionInformation(member);
                    else $f18c00e15af0c7db$export$8d1c45aa228e7350(member);
                }
            }, 70);
        },
        mouseleave: function() {
            clearTimeout(rosterItemMemberTimer);
        }
    }, ".roster-item-member");
    // Show championship information
    let rosterItemChampionshipTimer;
    $bookingTalentContainer.off("mouseenter", ".roster-item-championship");
    $bookingTalentContainer.on({
        mouseenter: function() {
            let $this = $(this);
            rosterItemChampionshipTimer = setTimeout(function() {
                let itemUid = parseInt($this.attr("data-uid"));
                let championship = data["vacatedChampionships"].filter(function(obj) {
                    return obj.uid === itemUid;
                })[0];
                $f18c00e15af0c7db$var$showChampionshipInformation(championship);
            }, 70);
        },
        mouseleave: function() {
            clearTimeout(rosterItemChampionshipTimer);
        }
    }, ".roster-item-championship");
    // Add custom brand filters
    $(".superstar-filter.brand-filter").remove();
    let superstarFilterNoBrand = $('.superstar-filter[data-value="no-brand"]');
    if (data["brandNames"].length > 0) {
        data["brandNames"].forEach(function(rosterBrandName) {
            let rosterBrandFilterHtml = '<button type="button" class="superstar-filter brand-filter button retro-button condensed light-button-background" data-value="custom-brand" data-brand-name="' + rosterBrandName.replace(/"/g, "&quot;") + '">' + rosterBrandName + "</button> ";
            superstarFilterNoBrand.before(rosterBrandFilterHtml);
        });
        superstarFilterNoBrand.show();
    } else superstarFilterNoBrand.hide();
    // Add default order
    $bookingContainer.find(".roster-item-member").each(function(i, e) {
        $(e).attr("data-default-order", i);
    });
    // Reset search, filters, sort
    $(".superstar-search-input").val("");
    $(".superstar-filter").removeClass("selected");
    $('.superstar-filter:contains("All")').addClass("selected");
    $(".superstar-sort").val("pop");
    $(".superstar-sort-order i").removeClass("fa-sort-up fa-sort-down fa-sort").addClass("fa-sort");
    $(".superstar-sort").find('option[value="fatigue"]').show();
    if ((0, $98xmD.globals).game.settings["enable_fatigue"] === false) $(".superstar-sort").find('option[value="fatigue"]').hide();
    $(".no-tag-team-search-results").hide();
    $(".no-trios-search-results").hide();
    $(".no-factions-search-results").hide();
    // Show booking container and sub containers
    if (segment) {
        $(".book-segment-feuds-container").hide();
        $bookingContainer.find("#booking-talent-info, #booking-talent-container, #booking-talent-menu").show();
    } else {
        $bookingContainer.find(".participants-box-match-header, .participants-box-match-container, #booking-talent-info, #booking-talent-menu, #booking-talent-container").show();
        $bookingContainer.find("#add-segment-item-menu, #segment-items-container, .participants-box-segment-header, .participants-box-segment-container, #add-segment, .participants-box-callup-header, .participants-box-draft-header, .participants-box-trade-offer-header, #booking-championship-info").hide();
    }
    $bookingContainer.show();
    $bookingTalentContainer.hide().fadeIn();
    setTimeout(()=>{
        $bookingTalentContainer.scrollTop(0);
    });
    // Add no margin top to first header
    $bookingTalentContainer.find(".superstars-header").removeClass("no-margin-top");
    $bookingTalentContainer.find(".superstars-header:visible:first").addClass("no-margin-top");
    (0, $acecca4a272c50a4$export$a0ca3fbd9bfabbf)((0, $98xmD.globals).currentTutorialStep);
    // Tutorial action check
    if (matchType === "singles") {
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_book_button");
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_segment_singles_button");
    } else if (matchType === "tag") (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_tag_team_button");
}
function $f18c00e15af0c7db$var$getRosterMemberBookingHtml(rosterMember, memberType) {
    if (rosterMember["type"] === "faction") memberType = "faction";
    let dataAge = "";
    let dataPronoun = "";
    let dataPopularity = ' data-popularity="' + rosterMember["popularity"] + '"';
    let dataAlignment = ' data-alignment="' + rosterMember["alignment"] + '"';
    let dataOverness = ' data-overness="' + rosterMember["overness"] + '"';
    let dataCharisma = ' data-charisma="' + rosterMember["charisma"] + '"';
    let dataWorkrate = ' data-workrate="' + rosterMember["workrate"] + '"';
    let dataMorale = ' data-morale="' + rosterMember["morale"] + '"';
    let dataFatigue = ' data-fatigue="' + rosterMember["fatigue"] + '"';
    let dataType = ' data-type="' + memberType + '"';
    let dataUid = ' data-uid="' + rosterMember["uid"] + '"';
    let dataName = ' data-name="' + rosterMember["name"].replace(/"/g, "&quot;") + '"';
    let brandName = rosterMember["brandName"];
    if (brandName) brandName = brandName.replace(/"/g, "&quot;");
    let dataManagingMultipleTalent = rosterMember["managedTalentNames"] && rosterMember["managedTalentNames"].length > 1 ? ' data-managing-multiple-talent="true"' : "";
    let dataBrandName = ' data-brand-name="' + brandName + '"';
    if (rosterMember["age"]) dataAge = ' data-age="' + rosterMember["age"] + '"';
    if (rosterMember["pronoun"]) dataPronoun = ' data-pronoun="' + rosterMember["pronoun"] + '"';
    let classes = "";
    if (rosterMember["championships"] && rosterMember["championships"].length > 0) classes += "champion ";
    if (rosterMember["partTimer"]) classes += "part-timer ";
    if (rosterMember["unhappy"]) classes += "unhappy ";
    if (rosterMember["workableInjury"]) classes += "dark-red ";
    if (rosterMember["booked"]) classes += "booked ";
    return '<button type="button" class="font-bold superstar-select roster-item-member ' + classes + '"' + dataType + dataUid + dataAge + dataPronoun + dataPopularity + dataAlignment + dataOverness + dataCharisma + dataWorkrate + dataMorale + dataFatigue + dataName + dataManagingMultipleTalent + dataBrandName + ">" + rosterMember["name"] + "</button>";
}
function $f18c00e15af0c7db$export$8d1c45aa228e7350(superstar, inMatch, showNumberOfAppearances, showTeamSuperstars, showViewDetailsButton = false) {
    if (typeof inMatch === "undefined") inMatch = false;
    if (typeof showNumberOfAppearances === "undefined") showNumberOfAppearances = true;
    // Define variables
    let championshipHtml = "";
    let appearancesHtml = "";
    let injuredHtml = "";
    let suspendedHtml = "";
    let unavailableHtml = "";
    let fotcHtml = "";
    let unhappyHtml = "";
    let cyborgHtml = "";
    let retiredHtml = "";
    let hofHtml = "";
    let teamsHtml = "";
    let factionsHtml = "";
    let managerHtml = "";
    let managedTalentHtml = "";
    let fullTimeManagerHtml = "";
    const $bookingTalentInfo = $("#booking-talent-info");
    // Add championships
    if (superstar["championships"]) superstar["championships"].forEach(function(championship, i) {
        championshipHtml += $f18c00e15af0c7db$var$getTalentInformationChampionshipHtml(championship, superstar, i, inMatch);
    });
    // Show appearances left if part timer or traded or returning from retirement
    if (superstar["partTimer"] || superstar["activeEffect"] === "traded" || superstar["activeEffect"] === "retirement_return") {
        if (showNumberOfAppearances) {
            // Show 'months' instead of 'appearances' if on trade deal
            let appearancesWord = superstar["activeEffect"] === "traded" ? "month" : "appearance";
            if (superstar["appearances"] === 1) appearancesHtml = superstar["appearances"] + " " + appearancesWord + " left";
            else appearancesHtml = superstar["appearances"] + " " + appearancesWord + "s left";
            // Add text for active effects
            if (superstar["activeEffect"] === "traded") appearancesHtml += " | Trade Deal";
            else if (superstar["activeEffect"] === "retirement_return") appearancesHtml += " | Retirement Return";
        } else appearancesHtml = "Limited appearances";
        // Add help text for part timers
        if (superstar["partTimer"]) appearancesHtml = '<span class="help-text" title="Part-timer appearances are used up in Matches but not in Segments">' + appearancesHtml + "</span>";
    }
    // Add injury details
    if (superstar["injured"] > 0) injuredHtml = (0, $1JSre.getSuperstarInjuredText)(superstar);
    // Add other status effects
    if (superstar["suspensionMonths"] > 0) {
        if (superstar["suspensionMonths"] === "1") suspendedHtml = "Suspended for " + superstar["suspensionMonths"] + " month";
        else suspendedHtml = "Suspended for " + superstar["suspensionMonths"] + " months";
    }
    if (superstar["unavailable"]) unavailableHtml = "Unavailable";
    if (superstar["unhappy"]) unhappyHtml = '<span class="puke-green">Unhappy</span>';
    if (superstar["cyborg"]) cyborgHtml = '<span class="grey-blue">Cyborg</span>';
    if (superstar["retired"]) retiredHtml = ' <span class="help-text" title="Retired Superstars can be booked in Legends, Retired and Manager Segments or as part of a Faction">Retired</span>';
    if (superstar["hallOfFamer"]) hofHtml = ' <span class="gold">Hall of Famer</span>';
    if (superstar["faceOfTheCompany"]) fotcHtml = '<span class="light-grey margin-left-5 help-text" title="Face of the Company"><i class="fa fa-star medium-blue"></i></span>';
    else if (superstar["faceOfTheCompanyCounter"] > 0) fotcHtml = '<span class="light-grey margin-left-5 help-text" title="Face of the Company progress in months"><i class="fa fa-star medium-blue"></i> ' + String(parseInt(superstar["faceOfTheCompanyCounter"])) + "/6" + "</span>";
    // Add teams and factions
    if (superstar["teams"] && superstar["teams"].length > 0) {
        teamsHtml = Array.from(superstar["teams"], function(team) {
            return team + " (Team)";
        });
        teamsHtml = (0, $3E8Nt.commaSeparate)(teamsHtml, "&");
    }
    if (superstar["factions"] && superstar["factions"].length > 0) {
        factionsHtml = Array.from(superstar["factions"], function(faction) {
            return faction + " (Faction)";
        });
        factionsHtml = (0, $3E8Nt.commaSeparate)(factionsHtml, "&");
    }
    // Add manager details
    if ((0, $98xmD.globalUser).paid) {
        if (superstar["managerNames"] && superstar["managerNames"].length > 0) managerHtml = '{0} <span class="light-grey">(Manager)</span>'.format(superstar["managerNames"]);
        if (superstar["managedTalentNames"] && superstar["managedTalentNames"].length > 0) managedTalentHtml = "Managing {0}".format((0, $3E8Nt.commaSeparate)(superstar["managedTalentNames"]));
        if (!managedTalentHtml && superstar["fullTimeManager"]) fullTimeManagerHtml = "Full-time Manager";
    }
    // Popularity
    let popularityHtml = superstar["popularity"];
    // Change charisma/workrate class if hot
    let charismaClass = "charisma-purple";
    let workrateClass = "workrate-blue";
    if (superstar["hot"]) {
        charismaClass = "hot-color";
        workrateClass = "hot-color";
    }
    // Charisma
    let charismaHtml = $f18c00e15af0c7db$var$getTalentInformationCharismaHtml(superstar, charismaClass);
    // Workrate
    let workrateHtml = $f18c00e15af0c7db$var$getTalentInformationWorkrateHtml(superstar, workrateClass);
    // Winning/Losing Streak
    let winLossHtml = "";
    if (superstar["wins"] !== undefined) winLossHtml = $f18c00e15af0c7db$var$getTalentInformationWinLossHtml(superstar);
    // Traits
    let superstarTraitsHtml = "";
    if (superstar["traits"].length > 0) {
        let superstarTraitsHtmlArray = [];
        // Show traits with help text
        superstar["traits"].forEach(function(superstarTrait) {
            let traitHtml = '<span class="superstar-trait-color">' + (0, $1JSre.getSuperstarTraitHelpHtml)(superstarTrait) + "</span>";
            superstarTraitsHtmlArray.push(traitHtml);
        });
        superstarTraitsHtml = '<span class="light-grey">' + superstarTraitsHtmlArray.join(", ") + "</span>";
    }
    // Contract months remaining
    let contractMonthsRemainingHtml = "";
    if (superstar["contractMonthsRemaining"]) {
        let contractMonthsRemainingWord = (0, $3E8Nt.getMonthsWord)(superstar["contractMonthsRemaining"]);
        contractMonthsRemainingHtml = '<span class="puke-green">{0} {1} to leave</span>'.format(superstar["contractMonthsRemaining"], contractMonthsRemainingWord);
    }
    // One match appearance
    let oneMatchAppearanceHtml = "";
    if (superstar["activeEffect"] === "one_match_appearance") oneMatchAppearanceHtml = "One Match Appearance";
    // Partner superstars
    let partnersHtml = "";
    if (showTeamSuperstars && superstar["teamSuperstars"] && superstar["teamSuperstars"].length > 0) partnersHtml = "Partners: " + (0, $3E8Nt.commaSeparate)(superstar["teamSuperstars"], "&");
    // Brand name
    let brandNameHtml = "";
    if (superstar["brandName"]) brandNameHtml = superstar["brandName"];
    // Company name
    let companyNameHtml = "";
    if (superstar["companyName"]) companyNameHtml = superstar["companyName"];
    // Join info
    let info = [
        companyNameHtml,
        brandNameHtml,
        championshipHtml,
        injuredHtml,
        suspendedHtml,
        unavailableHtml,
        appearancesHtml,
        oneMatchAppearanceHtml,
        unhappyHtml,
        contractMonthsRemainingHtml,
        managerHtml,
        managedTalentHtml,
        fullTimeManagerHtml,
        superstarTraitsHtml,
        cyborgHtml,
        retiredHtml,
        hofHtml,
        teamsHtml,
        factionsHtml,
        partnersHtml
    ];
    info = $.grep(info, Boolean).join(" | ");
    if (info) info = '<div class="font-bold medium-grey display-block margin-top-2 superstar-info-information">' + info + "</div>";
    else info = "";
    // Alignment
    let alignmentHtml = $f18c00e15af0c7db$var$getTalentInformationAlignmentHtml(superstar);
    // Gimmick
    let gimmickHtml = "";
    if (superstar["gimmick"]) {
        let gimmickEffectiveness = "";
        if (superstar["gimmick"]["effectiveness"]) gimmickEffectiveness = '<span class="light-grey margin-left-8">(' + superstar["gimmick"]["effectiveness"] + "%)</span>";
        gimmickHtml = '<span class="character-label margin-left-8">' + superstar["gimmick"]["name"] + gimmickEffectiveness + "</span>";
    }
    // Hot/stale
    let hotOrStaleIcon = "";
    let hotStaleText;
    let overnessClass = "";
    if (superstar["hot"]) {
        overnessClass = "hot-color";
        hotOrStaleIcon = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5">';
        hotStaleText = "Being Over boosts a Superstar's Attributes (Workrate, Charisma), their Popularity changes, the changes in their Gimmick Effectiveness  and the chance to have Hot Matches, Segments and Feuds.";
    } else if (superstar["stale"]) {
        overnessClass = "stale-color";
        hotOrStaleIcon = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5">';
        hotStaleText = "Becoming Stale lowers the ratings of a Superstar's Segments,  their Popularity gains and the chance to have Hot Matches, Segments and Feuds.";
    }
    // Overness
    let overnessHtml;
    if (superstar["hot"] || superstar["stale"]) overnessHtml = '<span class="help-text ' + overnessClass + '" title="' + hotStaleText + '">' + Math.round(superstar["overness"]) + "%" + hotOrStaleIcon + "</span>";
    else overnessHtml = '<span class="help-text" title="' + (0, $1JSre.getOvernessLevelText)(superstar["overness"]) + '">' + Math.round(superstar["overness"]) + "%" + "</span>";
    // Morale
    let moraleHtml = $f18c00e15af0c7db$var$getTalentInformationMoraleHtml(superstar);
    // Fatigue
    let fatigueHtml = $f18c00e15af0c7db$var$getTalentInformationFatigueHtml(superstar);
    // Show graphic
    if (inMatch) {
        const $matchSuperstarInformation = $(".match-superstar-information");
        let infoClass = "superstar-info-match-container";
        // Add match element
        if ($matchSuperstarInformation.length < 1) $(".match-buttons-container").after('<div class="match-superstar-information information-box"></div>');
        // Select match element
        let elementToAddTo = $matchSuperstarInformation;
        $bookingTalentInfo.hide();
        elementToAddTo.html('<div class="' + infoClass + '">' + '<div class="font-bold display-block margin-bottom-5">' + superstar["name"] + gimmickHtml + "</div>" + '<div class="superstar-info-column-left">' + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Pop.</span>' + popularityHtml + fotcHtml + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Age.</span>' + superstar["age"] + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Aln.</span>' + alignmentHtml + "</div>" + winLossHtml + fatigueHtml + "</div>" + '<div class="superstar-info-column-right">' + '<div class="display-block grey font-bold">' + workrateHtml + "</div>" + '<div class="display-block grey font-bold">' + charismaHtml + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5 width-32px display-inline-block">Ovr.</span>' + '<span class="margin-left-4">' + overnessHtml + "</span>" + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5 width-32px display-inline-block">Mor.</span>' + '<span class="margin-left-4">' + moraleHtml + "</span>" + "</div>" + "</div>" + '<div class="clear"></div>' + info + "</div>");
    } else {
        let viewDetailsButton = "";
        if (!showViewDetailsButton) viewDetailsButton = '<button type="button" class="button retro-button grey-button-background condensed remove-outline no-select view-roster-member-details-button margin-top-8" data-type="superstar" data-uid="' + superstar["uid"] + '">View Details</button>';
        const superstarInfoHtml = '<div class="superstar-information-container"><div class="superstar-column-left"><div class="font-bold display-block margin-bottom-5">' + superstar["name"] + gimmickHtml + "</div>" + '<div class="superstar-info-column-left">' + '<div class="display-block medium-grey font-bold superstar-info-popularity">' + '<span class="grey margin-right-5">Pop.</span>' + popularityHtml + fotcHtml + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Age</span>' + '<span class="margin-left-5">' + superstar["age"] + "</span>" + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Aln.</span>' + alignmentHtml + "</div>" + winLossHtml + fatigueHtml + "</div>" + '<div class="superstar-info-column-right">' + '<div class="display-block grey font-bold superstar-info-workrate">' + workrateHtml + "</div>" + '<div class="display-block grey font-bold superstar-info-charisma">' + charismaHtml + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5 width-32px display-inline-block">Ovr.</span>' + '<span class="margin-left-4">' + overnessHtml + "</span>" + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5 width-32px display-inline-block">Mor.</span>' + '<span class="margin-left-4">' + moraleHtml + "</span>" + "</div>" + "</div>" + '<div class="clear"></div>' + info + "</div>" + '<div class="superstar-column-right">' + '<div class="superstar-info-graphic"></div>' + '<div class="margin-top-3 text-center">' + '<button type="button" class="button retro-button grey-button-background ' + 'condensed remove-outline attire-select-button no-select selected">A</button>\n' + '<button type="button" class="button retro-button grey-button-background ' + 'condensed remove-outline attire-select-button no-select">B</button>\n' + '<button type="button" class="button retro-button grey-button-background ' + 'condensed remove-outline attire-select-button no-select">C</button>' + "</div>" + "</div>" + '<div class="clear"></div>' + viewDetailsButton + "</div>";
        $bookingTalentInfo.html(superstarInfoHtml);
        $bookingTalentInfo.show();
        $("#booking-container").show();
        // Show graphic
        let el = $bookingTalentInfo.find(".superstar-info-graphic");
        (0, $c82cd471f4baff6b$export$95c74f71dcb41f44)([
            superstar["graphic"]
        ], el, null);
        $(".superstar-information-container").scrollTop(0);
    }
    $("#booking-championship-info").hide();
}
function $f18c00e15af0c7db$export$b73c16b811178760(tagTeam, inMatch) {
    if (typeof inMatch === "undefined") inMatch = false;
    const $bookingTalentInfo = $("#booking-talent-info");
    // Add championships
    let championshipHtml = "";
    if (tagTeam["championships"]) tagTeam["championships"].forEach(function(championship, i) {
        championshipHtml += $f18c00e15af0c7db$var$getTalentInformationChampionshipHtml(championship, tagTeam, i, inMatch);
    });
    // Popularity
    let popularityHtml = tagTeam["popularity"];
    // Charisma
    let charismaHtml = $f18c00e15af0c7db$var$getTalentInformationCharismaHtml(tagTeam, "charisma-purple");
    // Workrate
    let workrateHtml = $f18c00e15af0c7db$var$getTalentInformationWorkrateHtml(tagTeam, "workrate-blue");
    // Alignment
    let alignmentHtml = $f18c00e15af0c7db$var$getTalentInformationAlignmentHtml(tagTeam);
    // Overness
    let overnessHtml = '<span class="help-text" title="' + (0, $1JSre.getOvernessLevelText)(tagTeam["overness"]) + '">' + Math.round(tagTeam["overness"]) + "%" + "</span>";
    // Show appearances left
    let appearancesHtml = "";
    if (tagTeam["appearances"] !== null && tagTeam["appearances"] !== undefined) {
        let appearancesMonthWord = tagTeam["appearances"] === 1 ? "appearance" : "appearances";
        appearancesHtml = tagTeam["appearances"] + " " + appearancesMonthWord + " left";
    }
    // Unhappy
    let unhappyHtml = "";
    if (tagTeam["unhappy"]) unhappyHtml = '<span class="puke-green">Unhappy</span>';
    // Winning/Losing Streak
    let winLossHtml = "";
    if (tagTeam["wins"] !== undefined) winLossHtml = $f18c00e15af0c7db$var$getTalentInformationWinLossHtml(tagTeam);
    // Superstars
    let tagTeamSuperstars = (0, $3E8Nt.commaSeparate)(tagTeam["superstars"]);
    // Traits
    let traitsHtml = "";
    if (tagTeam["traits"].length > 0) {
        let traitsHtmlArray = [];
        // Show traits with help text
        tagTeam["traits"].forEach(function(traitData) {
            let traitHtml = '<span class="superstar-trait-color">' + (0, $1JSre.getSuperstarTraitHelpHtml)(traitData["name"]) + '<span class="margin-left-5 light-grey">(' + traitData["superstar"] + ")</span>" + "</span>";
            traitsHtmlArray.push(traitHtml);
        });
        traitsHtml = '<span class="light-grey">' + traitsHtmlArray.join(", ") + "</span>";
    }
    // Morale
    let moraleHtml = $f18c00e15af0c7db$var$getTalentInformationMoraleHtml(tagTeam);
    // Fatigue
    let fatigueHtml = $f18c00e15af0c7db$var$getTalentInformationFatigueHtml(tagTeam);
    // Manager details
    let managerHtml = "";
    if ((0, $98xmD.globalUser).paid) {
        if (tagTeam["managerNames"] && tagTeam["managerNames"].length > 0) {
            let managerWord = tagTeam["managerNames"].length === 1 ? "Manager" : "Managers";
            managerHtml = '{0} <span class="light-grey">({1})</span>'.format((0, $3E8Nt.commaSeparate)(tagTeam["managerNames"]), managerWord);
        }
    }
    // Brand name
    let brandNameHtml = "";
    if (tagTeam["brandName"]) brandNameHtml = tagTeam["brandName"];
    // Join second line info together
    let info = [
        brandNameHtml,
        championshipHtml,
        tagTeamSuperstars,
        appearancesHtml,
        unhappyHtml,
        managerHtml,
        traitsHtml
    ];
    info = $.grep(info, Boolean).join(" | ");
    if (inMatch) {
        const $matchSuperstarInformation = $(".match-superstar-information");
        // Add match element
        if ($matchSuperstarInformation.length < 1) $(".match-buttons-container").after('<div class="match-superstar-information information-box"></div>');
        $matchSuperstarInformation.html('<div class="superstar-info-match-container"><div class="font-bold display-block margin-bottom-5">' + tagTeam["name"] + "</div>" + '<div class="superstar-info-column-left">' + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Pop.</span>' + popularityHtml + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Age.</span>' + tagTeam["age"] + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Aln.</span>' + alignmentHtml + "</div>" + winLossHtml + fatigueHtml + "</div>" + '<div class="superstar-info-column-right">' + '<div class="display-block grey font-bold">' + workrateHtml + "</div>" + '<div class="display-block grey font-bold">' + charismaHtml + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5 width-32px display-inline-block">Ovr.</span>' + '<span class="margin-left-4">' + overnessHtml + "</span>" + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5 width-32px display-inline-block">Mor.</span>' + '<span class="margin-left-4">' + moraleHtml + "</span>" + "</div>" + "</div>" + '<div class="clear"></div>' + '<div class="font-bold medium-grey display-block margin-top-2 superstar-info-information">' + info + "</div>" + "</div>");
    } else {
        const tagTeamInfoHtml = '<div class="superstar-information-container"><div class="superstar-column-left"><div class="font-bold display-block margin-bottom-5">' + tagTeam["name"] + "</div>" + '<div class="superstar-info-column-left">' + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Pop.</span>' + popularityHtml + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Age.</span>' + tagTeam["age"] + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5">Aln.</span>' + alignmentHtml + "</div>" + winLossHtml + fatigueHtml + "</div>" + '<div class="superstar-info-column-right">' + '<div class="display-block grey font-bold">' + workrateHtml + "</div>" + '<div class="display-block grey font-bold">' + charismaHtml + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5 width-32px display-inline-block">Ovr.</span>' + '<span class="margin-left-4">' + overnessHtml + "</span>" + "</div>" + '<div class="display-block medium-grey font-bold">' + '<span class="grey margin-right-5 width-32px display-inline-block">Mor.</span>' + '<span class="margin-left-4">' + moraleHtml + "</span>" + "</div>" + "</div>" + '<div class="clear"></div>' + "</div>" + '<div class="superstar-column-right">' + '<div class="superstar-info-graphic"></div>' + "</div>" + '<div class="clear"></div>' + '<div class="font-bold medium-grey display-block margin-top-2 superstar-info-information">' + info + "</div>" + '<button type="button" class="button retro-button grey-button-background condensed remove-outline no-select ' + 'view-roster-member-details-button margin-top-8" data-type="tagTeam" data-uid="' + tagTeam["uid"] + '">View Details</button>' + "</div>";
        $bookingTalentInfo.html(tagTeamInfoHtml);
        $bookingTalentInfo.show();
        $("#booking-container").show();
        // Show graphic
        let el = $bookingTalentInfo.find(".superstar-info-graphic");
        (0, $c82cd471f4baff6b$export$95c74f71dcb41f44)(tagTeam["graphics"], el, {
            "type": "tag",
            "largerTag": tagTeam["graphics"].length
        });
    }
    $("#booking-championship-info").hide();
}
function $f18c00e15af0c7db$var$showFactionInformation(faction) {
    const $bookingTalentInfo = $("#booking-talent-info");
    let factionSuperstarsHtml = (0, $9c7fdb096dd8e19a$export$7bc49520a71c2f4d)(faction["superstars"], false, true);
    let factionHtml = '<div class="superstar-information-container"><div class="font-bold display-block margin-bottom-2">' + faction["name"] + '<span class="float-right light-grey">' + faction["reputationData"]["reputation"] + " REP" + "</span>" + "</div>" + '<div class="faction-info-graphic-container margin-bottom-10"></div>' + '<div class="font-bold medium-grey display-block superstar-info-information">' + factionSuperstarsHtml + "</div>" + '<button type="button" class="button retro-button grey-button-background condensed remove-outline no-select ' + 'view-roster-member-details-button margin-top-8" data-type="faction" data-uid="' + faction["uid"] + '">View Details</button>' + "</div>";
    $bookingTalentInfo.html(factionHtml);
    $bookingTalentInfo.show();
    $("#booking-container").show();
    // Show graphic
    let el = $bookingTalentInfo.find(".faction-info-graphic-container");
    let matchData = {
        "type": "singles",
        "largerTag": faction["graphic"].length,
        "factionGraphic": true
    };
    if (faction["graphic"].length > 10) matchData = {
        "type": "singles"
    };
    (0, $c82cd471f4baff6b$export$7dd6f6d8f75bfc39)(faction["graphic"], el, matchData);
    $("#booking-championship-info").hide();
}
function $f18c00e15af0c7db$var$showChampionshipInformation(championship) {
    // Get full name
    let name = (0, $1JSre.getChampionshipDisplayName)(championship);
    if (championship["event"]) name += " (" + championship["event"] + ")";
    $(".championship-name").text(name);
    // Brand name
    let brandNameHtml = "";
    if (championship["brandName"]) brandNameHtml = championship["brandName"];
    // Gimmick restriction
    let gimmickRestrictionHtml = "";
    if (championship["gimmickRestriction"]) gimmickRestrictionHtml = (0, $1JSre.getChampionshipGimmickRestrictionText)(championship["gimmickRestriction"]);
    // Join info
    let info = [
        brandNameHtml,
        championship["rank"],
        gimmickRestrictionHtml
    ];
    info = $.grep(info, Boolean).join(" | ");
    $(".championship-info").html(info);
    // Show graphic
    if (championship["graphic"]) {
        let el = $("#booking-championship-info-graphic");
        (0, $c82cd471f4baff6b$export$319a5ed9f109ccce)([
            championship["graphic"]
        ], el);
    } else $("#booking-championship-info-graphic").html('<div class="empty-championship-graphic"><div class="text-center vertical-center">No graphic</div></div>');
    $("#booking-talent-info").hide();
    $("#booking-championship-info").show();
}
function $f18c00e15af0c7db$var$getTalentInformationChampionshipHtml(championship, talent, index, inMatch) {
    let championshipHtml = "";
    // Get name
    let name;
    if (talent["championships"].length > 3) name = championship["name"];
    else name = (0, $1JSre.getChampionshipDisplayName)(championship, true);
    // Get prestige
    let prestigeIcon = '<span class="margin-left-5">' + (0, $1JSre.getChampionshipPrestigeIconHtml)(championship["prestige"]) + "</span>";
    // Get reign length
    let reignLength = "";
    if (championship["reignLength"] !== undefined) {
        let monthsWord = championship["reignLength"] === 1 ? "Month" : "Months";
        reignLength = '<span class="light-grey margin-left-5"> {0} {1}</span>'.format(championship["reignLength"], monthsWord);
    }
    // Add separator and margin if more than 1 championship
    let separatorHtml = "";
    let marginClass = "";
    if (index > 0) {
        marginClass = "margin-left-5 ";
        separatorHtml = '<span class="margin-left-5">|</span>';
    }
    // Add html
    championshipHtml += separatorHtml + '<span class="' + marginClass + 'gold">' + name + prestigeIcon + reignLength + "</span>";
    // Add cashin button
    if (championship["championshipContract"] && !inMatch) championshipHtml += '<button type="button" id="championship-contract-cashin-show" class="button retro-button condensed gold-button-background margin-left-5 no-margin-bottom help-text" data-uid="' + championship["championshipUid"] + '" ' + 'title="Cash in this contract for the championship at the upcoming event. You can also cash it ' + 'in during a championship match (a cash in button will appear during championship matches)">' + "Cash In" + "</button>";
    return championshipHtml;
}
function $f18c00e15af0c7db$var$getTalentInformationAlignmentHtml(talent) {
    let alignment = talent["alignment"];
    let alignmentClass;
    switch(talent["alignment"]){
        case "heel":
            alignmentClass = "alignment-heel";
            break;
        case "face":
            alignmentClass = "alignment-face";
            break;
        default:
            alignmentClass = "alignment-neutral";
            alignment = "Neutral";
    }
    return '<span class="margin-left-5 ' + alignmentClass + '">' + (0, $3E8Nt.toTitleCase)(alignment) + "</span>";
}
function $f18c00e15af0c7db$var$getTalentInformationWinLossHtml(talent) {
    let winningLosingStreaksData = ' <span class="help-text" title="Win/Loss Streaks">({0}-{1})</span>'.format(talent["winsCounter"], talent["lossesCounter"]);
    let winningLosingData = "{0}-{1}".format(talent["wins"], talent["losses"]);
    return '<div class="display-block medium-grey font-bold"><span class="grey margin-right-10">W/L</span>' + winningLosingData + winningLosingStreaksData + "</div>";
}
function $f18c00e15af0c7db$var$getTalentInformationMoraleHtml(talent) {
    return '<span class="help-text ' + (0, $1JSre.getRosterMemberMoraleClass)(talent["morale"]) + '" title="' + (0, $1JSre.getRosterMemberMoraleText)(talent["morale"]) + '">' + talent["morale"] + "%" + "</span>";
}
function $f18c00e15af0c7db$var$getTalentInformationWorkrateHtml(talent, workrateClass) {
    let workrateStars = (0, $1JSre.getStarRatingHtml)(talent["workrate"], workrateClass, 3);
    return '<span class="grey">Wor.</span><span class="margin-left-5 font-1p125em ' + workrateClass + '" role="text" aria-label="' + talent["workrate"] + " star workrate" + '">' + workrateStars + "</span>";
}
function $f18c00e15af0c7db$var$getTalentInformationCharismaHtml(talent, charismaClass) {
    let charismaStars = (0, $1JSre.getStarRatingHtml)(talent["charisma"], charismaClass, 3);
    return '<span class="grey">Cha.</span><span class="margin-left-5 font-1p125em ' + charismaClass + '" role="text" aria-label="' + talent["charisma"] + " star charisma" + '">' + charismaStars + "</span>";
}
function $f18c00e15af0c7db$var$getTalentInformationFatigueHtml(talent) {
    return '<div class="display-block medium-grey font-bold"><span class="grey margin-right-5">Fat.</span><span class="margin-left-6 ' + (0, $1JSre.getRosterMemberFatigueClass)(talent["fatigue"]) + ' help-text" ' + 'title="Fatigue affects the chance of getting injured">' + talent["fatigue"] + "%" + "</span>" + "</div>";
}
function $f18c00e15af0c7db$var$showGetFeudsForBookingData({ data: data, matchType: matchType, $el: $el } = {}) {
    let html = "";
    if (data["feuds"].length > 0) {
        let currentFeuds = data["feuds"].filter(function(feud) {
            return feud["started"];
        });
        let potentialFeuds = data["feuds"].filter(function(feud) {
            return !feud["started"];
        });
        // Current feuds
        if (currentFeuds.length > 0) {
            let marginBottomClass = "";
            if (potentialFeuds.length > 0) marginBottomClass = " margin-bottom-10";
            html += '<div class="current-feuds-items' + marginBottomClass + '"><span class="display-block margin-left-2 ' + 'font-bold margin-bottom-2 medium-grey">Current Feuds</span>';
            currentFeuds.forEach(function(feud) {
                html += $f18c00e15af0c7db$var$getFeudBookingHtml(feud);
            });
            if (currentFeuds.length <= 0) html += '<span class="display-block grey font-bold font-0p925em">No Current Feuds</span>';
            html += "</div>";
        }
        // Potential feuds
        if (potentialFeuds.length > 0) {
            html += '<div class="potential-feuds-items"><span class="display-block margin-left-2 font-bold margin-bottom-2 medium-grey">Potential Feuds</span>';
            potentialFeuds.forEach(function(feud) {
                html += $f18c00e15af0c7db$var$getFeudBookingHtml(feud);
            });
            if (potentialFeuds.length <= 0) html += '<span class="display-block grey font-bold font-0p925em">No Potential Feuds</span>';
            html += "</div>";
        }
        $el.html(html).show();
        $el.scrollTop(0);
        (0, $acecca4a272c50a4$export$a0ca3fbd9bfabbf)((0, $98xmD.globals).currentTutorialStep);
        // Tutorial action check
        if (matchType === "singles") setTimeout(function() {
            (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_book_singles_feud_button");
        }, 100);
    } else if (matchType === "segment") {
        html += '<span class="display-block grey font-bold font-0p925em margin-left-2">No Feuds present</span>';
        $el.html(html).show();
    } else $el.html(html).hide();
}
function $f18c00e15af0c7db$var$getFeudBookingHtml(feud) {
    // Get participant names
    let participantNames = feud["participants"].join(" vs ");
    // Get potential display
    let potential = "";
    if (!feud["started"]) potential = '<div class="potential-feud-red">Potential</div>';
    // Get hype class
    let hypeClass = "faded-red-light";
    if (feud["hot"]) hypeClass = "hot-color";
    if (feud["stale"]) hypeClass = "stale-color";
    // Get months passed
    let duration = "";
    if (feud["monthsElapsed"] !== undefined) duration = feud["monthsElapsed"] + " " + (0, $3E8Nt.getMonthsWord)(feud["monthsElapsed"]) + " long";
    // Get staleness data
    let stalenessCheck = "";
    if (feud["staleLength"]) stalenessCheck = '<span class="display-block light-grey help-text" title="Monthly Event Matches add +1, Weekly Show Matches add +0.5 and Segments add +0.25 to the Feud\'s Staleness Check.">' + feud["stalenessCounter"] + " / " + '<span class="stale-color">' + feud["staleLength"] + "</span>" + '<span class="margin-left-5">Staleness</span>' + "</span>";
    return '<div class="feud-container item-container compact font-bold" data-uid="' + feud["uid"] + '" tabindex="0">' + '<div class="margin-bottom-5">' + (0, $1JSre.getShortenedName)(feud["name"], 19) + '<span class="float-right ' + hypeClass + '">' + '<i class="fa fa-bolt margin-right-5"></i>' + Math.round(feud["hype"]) + "</span>" + "</div>" + '<div class="grey feud-participants line-height-1p4">' + participantNames + "</div>" + "<div>" + stalenessCheck + "</div>" + '<div class="light-grey">' + duration + "</div>" + potential + "</div>";
}
function $f18c00e15af0c7db$var$getSegmentBookingMenuHtml() {
    let factionsOptionHtml = "";
    if ((0, $98xmD.globalUser).paid) factionsOptionHtml = '<button type="button" class="book-segment-option button retro-button condensed grey-button-background">Factions</button>';
    return '<div class="book-segment-options"><button type="button" class="book-segment-option button retro-button condensed grey-button-background selected margin-right-5">Feuds</button><button type="button" class="book-segment-option button retro-button condensed grey-button-background margin-right-5">Singles</button><button type="button" class="book-segment-option button retro-button condensed grey-button-background margin-right-5">Tag</button>' + factionsOptionHtml + "</div>";
}
function $f18c00e15af0c7db$var$getSegmentItemMenuHtml() {
    let factionsFilterHtml = "";
    if ((0, $98xmD.globalUser).paid) factionsFilterHtml = '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="faction"> Faction</button> ';
    let managersFilterHtml = "";
    if ((0, $98xmD.globalUser).paid) managersFilterHtml = '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="manager"> Manager</button> ';
    let brandsFilterHtml = "";
    if ((0, $98xmD.globalUser).paid) brandsFilterHtml = '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="brand"> Brand</button> ';
    let customSegmentMenuButton = '<button type="button" class="button retro-button condensed purple-button-background add-custom-segment-segments-menu-button"><i class="fa fa-plus-circle"></i> Custom</button> ';
    let segmentSortHtml = '<select title="Segment sort" name="segment-sort" class="styled-select segment-sort remove-outline"><option value="default-order" selected>Default</option><option value="participants">Part.</option><option value="hype-boost">Hype</option><option value="popularity-boost">Pop.</option><option value="entertainment">Ent.</option><option value="action">Act.</option><option value="difficulty">Diff.</option></select> <div class="font-bold dark-grey margin-left-3 display-inline-block segment-sort-order help-text" title="Reverse sort order"><i class="fa fa-sort"></i></div>';
    return '<div class="display-inline-block"><div><input type="text" name="segment-search" placeholder="Search" autocomplete="off" class="styled-input segment-search-input remove-outline margin-bottom-5"> </div><div>' + segmentSortHtml + "</div>" + "</div>" + '<div class="filter-segment-items-options float-right display-inline-block">' + '<div class="text-right margin-right-7"> ' + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background selected">' + "All" + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="feud">' + "Feud" + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="repeatable"> ' + "Repeatable" + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="production">' + "Production" + "</button> " + customSegmentMenuButton + factionsFilterHtml + managersFilterHtml + '<button type="button"" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="available"> ' + "Available" + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="alignment">' + "Alignment" + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="title"> ' + "Title " + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="special"> ' + "Special" + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="custom"> ' + "Custom" + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="silly"> ' + "Silly " + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="team"> ' + "Team" + "</button> " + brandsFilterHtml + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="retired"> ' + "Retired" + "</button> " + '<button type="button" class="filter-segment-items-option margin-bottom-5 button retro-button condensed light-button-background" data-value="locked"> ' + "Locked " + "</button> " + "</div> " + "</div>" + '<div class="clear"></div>';
}
function $f18c00e15af0c7db$var$showGetCompanyProducersData({ data: data } = {}) {
    let parent = $("#add-segment-producer-container");
    let producerSelect = parent.find(".add-segment-producer-select");
    let producerOptions = "";
    data["producers"].forEach(function(producer) {
        producerOptions += '<option value="' + producer["uid"] + '">' + producer["name"] + " (Lvl " + producer["level"] + ")</option>";
    });
    if (data["producers"].length <= 0) producerOptions += "<option disabled selected value>No Producers Available</option>";
    producerSelect.html(producerOptions);
    parent.show();
}
function $f18c00e15af0c7db$var$runSegmentSearch() {
    let segmentItemsContainer = $("#segment-items-container");
    let segmentElements = segmentItemsContainer.find(".item-container");
    let searchTerm = $(".segment-search-input").val();
    // Deselect add custom segment container
    segmentItemsContainer.show();
    $(".add-custom-segment-container").hide();
    $(".add-custom-segment-segments-menu-button").removeClass("selected");
    // Run search
    if (searchTerm.length > 0) {
        let searchResults = (0, $1JSre.runFuseElementsSearch)(segmentElements, searchTerm, [
            "dataset.name",
            "dataset.requirement",
            "dataset.consequence"
        ]);
        segmentElements.hide();
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function(e) {
                $(e).show();
            });
            $(".no-segment-search-results").hide();
        } else if ($(".no-segment-search-results").length > 0) $(".no-segment-search-results").show();
        else segmentItemsContainer.append('<div class="no-segment-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
    } else segmentElements.show();
    // Reset filters
    $(".filter-segment-items-option").removeClass("selected");
    segmentItemsContainer.scrollTop(0);
}
function $f18c00e15af0c7db$var$applySegmentSort(value) {
    let segmentItemsContainer = $("#segment-items-container");
    let availableSegmentElements = segmentItemsContainer.find(".item-container:not(.locked)");
    let unavailableSegmentElements = segmentItemsContainer.find(".item-container.locked");
    // Get sort function and default sorting
    let sortClass = "";
    let sortFunction;
    if (value) {
        if ([
            "hype-boost",
            "popularity-boost",
            "action",
            "entertainment"
        ].indexOf(value) >= 0) {
            sortFunction = function(a, b) {
                return parseFloat($(b).attr("data-" + value)) - parseFloat($(a).attr("data-" + value)) || $(b).text().localeCompare($(a).text());
            };
            sortClass = "fa-sort-down";
        } else {
            sortFunction = function(a, b) {
                return parseFloat($(a).attr("data-" + value)) - parseFloat($(b).attr("data-" + value)) || $(a).text().localeCompare($(b).text());
            };
            sortClass = "fa-sort-up";
        }
    }
    availableSegmentElements.sort(sortFunction);
    unavailableSegmentElements.sort(sortFunction);
    // Add sorted elements
    availableSegmentElements.toArray().forEach(function(e) {
        segmentItemsContainer.append(e);
    });
    unavailableSegmentElements.toArray().forEach(function(e) {
        segmentItemsContainer.append(e);
    });
    // Select default sort order
    if (sortClass) {
        let sortOrderElement = $(".segment-sort-order");
        let sortOrderIcon = sortOrderElement.find("i");
        sortOrderIcon.removeClass("fa-sort fa-sort-up fa-sort-down").addClass(sortClass);
        sortOrderElement.addClass("cursor-pointer");
    }
    segmentItemsContainer.scrollTop(0);
}
function $f18c00e15af0c7db$var$runCustomPackagePreviewAnimation(name, startText, timer) {
    // Reset
    $(".custom-package-start-text-preview").text("").addClass("medium-dark-grey").removeClass("light-grey");
    $(".custom-package-action-text-preview").text("");
    $(".custom-package-name-preview").text("");
    // Generate text
    let actionTextInputs = $(".custom-package-action-text").filter(function() {
        return !!this.value;
    });
    let actionText = $((0, $3E8Nt.getRandomChoice)(actionTextInputs)).val();
    let dataType = (0, $3E8Nt.getRandomChoice)([
        "he",
        "she",
        "tag"
    ]);
    startText = $f18c00e15af0c7db$var$parseCustomPackageText(startText, dataType);
    actionText = $f18c00e15af0c7db$var$parseCustomPackageText(actionText, dataType);
    $(".custom-package-name-preview").text(name);
    $(".custom-package-start-text-preview").text(startText).hide().fadeIn(500);
    timer = setTimeout(function() {
        $(".custom-package-action-text-preview").text(actionText).hide().fadeIn(500);
        $(".custom-package-start-text-preview").removeClass("medium-dark-grey").addClass("light-grey");
    }, 2200);
    return timer;
}
function $f18c00e15af0c7db$var$parseCustomPackageText(text, dataType) {
    if (typeof dataType === "undefined") dataType = "he";
    if (dataType === "he") {
        text = (0, $1JSre.replaceAll)(text, "{name}", "Jimmy Boblsed");
        text = (0, $1JSre.replaceAll)(text, "{objective}", "him");
        text = (0, $1JSre.replaceAll)(text, "{possessive}", "his");
        text = (0, $1JSre.replaceAll)(text, "{pronoun}", "he");
    } else if (dataType === "she") {
        text = (0, $1JSre.replaceAll)(text, "{name}", "Hoffing Holly");
        text = (0, $1JSre.replaceAll)(text, "{objective}", "her");
        text = (0, $1JSre.replaceAll)(text, "{possessive}", "her");
        text = (0, $1JSre.replaceAll)(text, "{pronoun}", "she");
    } else if (dataType === "tag") {
        text = (0, $1JSre.replaceAll)(text, "{name}", "The Ugly Duo");
        text = (0, $1JSre.replaceAll)(text, "{objective}", "them");
        text = (0, $1JSre.replaceAll)(text, "{possessive}", "their");
        text = (0, $1JSre.replaceAll)(text, "{pronoun}", "they");
    }
    return (0, $1JSre.applySentenceCase)(text);
}
function $f18c00e15af0c7db$var$applySuperstarSort(value) {
    // Get containers
    let resultsContainer = $("#all-superstars");
    let rankContainers = $("#main-eventers, #upper-midcarders, #lower-midcarders, #jabroni");
    let retiredContainer = $("#retired");
    let notAvailableContainer = $("#not-available");
    let managersContainer = $("#managers");
    let allSuperstarsContainer = resultsContainer.add(rankContainers);
    // Sort search/filter results
    let superstarElements = resultsContainer.find(".superstar-select");
    // If viewing all superstars, sort all
    if (rankContainers.is(":visible")) superstarElements = allSuperstarsContainer.find(".superstar-select");
    let retiredElements = retiredContainer.find(".superstar-select");
    let notAvailableElements = notAvailableContainer.find(".superstar-select");
    let managerElements = managersContainer.find(".superstar-select");
    // Get sort function and default sorting
    let sortClass = "";
    let sortFunction;
    if (value === "age") {
        sortFunction = function(a, b) {
            return parseFloat($(a).attr("data-age")) - parseFloat($(b).attr("data-age")) || $(a).text().localeCompare($(b).text());
        };
        sortClass = "fa-sort-down";
    } else if (value === "name") {
        sortFunction = function(a, b) {
            return $(a).text().localeCompare($(b).text());
        };
        sortClass = "fa-sort-down";
    } else if ([
        "workrate",
        "charisma",
        "overness"
    ].indexOf(value) >= 0) {
        let dataName = value;
        sortFunction = function(a, b) {
            return parseFloat($(b).attr("data-" + dataName)) - parseFloat($(a).attr("data-" + dataName)) || $(a).text().localeCompare($(b).text());
        };
        sortClass = "fa-sort-up";
    } else if ([
        "pop",
        "morale"
    ].indexOf(value) >= 0) {
        let dataName = value === "pop" ? "popularity" : value;
        sortFunction = function(a, b) {
            return parseFloat($(b).attr("data-" + dataName)) - parseFloat($(a).attr("data-" + dataName));
        };
        sortClass = "fa-sort-up";
    } else if (value === "fatigue") {
        sortFunction = function(a, b) {
            return parseFloat($(a).attr("data-fatigue")) - parseFloat($(b).attr("data-fatigue"));
        };
        sortClass = "fa-sort-down";
    }
    superstarElements.sort(sortFunction);
    retiredElements.sort(sortFunction);
    notAvailableElements.sort(sortFunction);
    managerElements.sort(sortFunction);
    // Add sorted elements to results, hide ranks
    superstarElements.toArray().forEach(function(e) {
        resultsContainer.append(e);
    });
    retiredElements.toArray().forEach(function(e) {
        retiredContainer.append(e);
    });
    notAvailableElements.toArray().forEach(function(e) {
        notAvailableContainer.append(e);
    });
    managerElements.toArray().forEach(function(e) {
        managersContainer.append(e);
    });
    resultsContainer.show();
    rankContainers.hide();
    // Select default sort order
    if (sortClass) {
        let sortOrderElement = $(".superstar-sort-order");
        let sortOrderIcon = sortOrderElement.find("i");
        sortOrderIcon.removeClass("fa-sort fa-sort-up fa-sort-down").addClass(sortClass);
        sortOrderElement.addClass("cursor-pointer");
    }
    $("#booking-talent-container").scrollTop(0);
}
function $f18c00e15af0c7db$var$applyTeamSort(value) {
    // Get containers
    let teamContainers = $("#tag-teams, #trios, #factions");
    // Sort search/filter results
    let sortedElements = teamContainers.find(".superstar-select");
    let sortClass = "";
    if (value === "age") {
        sortedElements.sort(function(a, b) {
            return parseFloat($(a).attr("data-age")) - parseFloat($(b).attr("data-age")) || $(a).text().localeCompare($(b).text());
        });
        sortClass = "fa-sort-down";
    } else if (value === "name") {
        sortedElements.sort(function(a, b) {
            return $(a).text().localeCompare($(b).text());
        });
        sortClass = "fa-sort-down";
    } else if ([
        "workrate",
        "charisma",
        "overness"
    ].indexOf(value) >= 0) {
        let dataName = value;
        sortedElements.sort(function(a, b) {
            return parseFloat($(b).attr("data-" + dataName)) - parseFloat($(a).attr("data-" + dataName)) || $(a).text().localeCompare($(b).text());
        });
        sortClass = "fa-sort-up";
    } else if ([
        "pop",
        "morale"
    ].indexOf(value) >= 0) {
        let dataName = value === "pop" ? "popularity" : value;
        sortedElements.sort(function(a, b) {
            return parseFloat($(b).attr("data-" + dataName)) - parseFloat($(a).attr("data-" + dataName));
        });
        sortClass = "fa-sort-up";
    } else if (value === "fatigue") {
        sortedElements.sort(function(a, b) {
            return parseFloat($(a).attr("data-fatigue")) - parseFloat($(b).attr("data-fatigue"));
        });
        sortClass = "fa-sort-down";
    }
    // Add teams to containers
    sortedElements.toArray().forEach(function(e) {
        let elementContainer = $f18c00e15af0c7db$var$getRosterElementContainer($(e));
        elementContainer.append(e);
    });
    // Select default sort order
    if (sortClass) {
        let sortOrderElement = $(".superstar-sort-order");
        let sortOrderIcon = sortOrderElement.find("i");
        sortOrderIcon.removeClass("fa-sort fa-sort-up fa-sort-down").addClass(sortClass);
        sortOrderElement.addClass("cursor-pointer");
    }
    $("#booking-talent-container").scrollTop(0);
}
function $f18c00e15af0c7db$var$getRosterElementContainer(element) {
    if (element.attr("data-type") === "tag-team") return $("#tag-teams");
    else if (element.attr("data-type") === "trio") return $("#trios");
    else if (element.attr("data-type") === "faction") return $("#factions");
    else {
        let popularity = element.attr("data-popularity");
        if (popularity >= 800) return $("#main-eventers");
        else if (popularity >= 600) return $("#upper-midcarders");
        else if (popularity >= 400) return $("#lower-midcarders");
        else return $("#jabroni");
    }
}
function $f18c00e15af0c7db$var$runSuperstarSearch() {
    let resultsContainer = $("#all-superstars");
    let rankContainers = $("#main-eventers, #upper-midcarders, #lower-midcarders, #jabroni");
    let allSuperstarsContainer = resultsContainer.add(rankContainers);
    let superstarElements = allSuperstarsContainer.find(".superstar-select");
    let searchTerm = $(".superstar-search-input").val();
    // Reset superstars to ranks, sorted
    superstarElements.sort(function(a, b) {
        return parseFloat($(a).attr("data-default-order")) - parseFloat($(b).attr("data-default-order"));
    });
    superstarElements.toArray().forEach(function(e) {
        let elementContainer = $f18c00e15af0c7db$var$getRosterElementContainer($(e));
        elementContainer.append(e);
    });
    // Show not available, retired, managers
    let notAvailableSelector = $("#not-available");
    let notAvailableElements = notAvailableSelector.find(".superstar-select");
    notAvailableElements.show();
    let retiredSelector = $("#retired");
    let retiredElements = retiredSelector.find(".superstar-select");
    retiredElements.show();
    let managersSelector = $("#managers");
    let managersElements = managersSelector.find(".superstar-select");
    managersElements.show();
    // Show headers if elements present
    if (notAvailableElements.length > 0) notAvailableSelector.show();
    else notAvailableSelector.hide();
    if (retiredElements.length > 0) retiredSelector.show();
    else retiredSelector.hide();
    if (managersElements.length > 0) managersSelector.show();
    else managersSelector.hide();
    // Run search
    if (searchTerm.length > 0) {
        let searchResults = (0, $1JSre.runFuseElementsSearch)(superstarElements, searchTerm, [
            "textContent"
        ]);
        // Show results if found
        if (searchResults.length > 0) {
            // Sort superstars by pop and add superstars to results, hide ranks
            searchResults.sort(function(a, b) {
                return parseFloat($(a).attr("data-default-order")) - parseFloat($(b).attr("data-default-order"));
            });
            searchResults.forEach(function(e) {
                resultsContainer.append(e);
            });
            $(".no-superstar-search-results").hide();
        } else if ($(".no-superstar-search-results").length > 0) $(".no-superstar-search-results").show();
        else resultsContainer.append('<div class="no-superstar-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
        resultsContainer.show();
        rankContainers.hide();
        // Filter results in not available, retired and managers
        let filteredNotAvailable = (0, $1JSre.runFuseElementsSearch)(notAvailableElements.toArray(), searchTerm, [
            "textContent"
        ]);
        let filteredRetired = (0, $1JSre.runFuseElementsSearch)(retiredElements.toArray(), searchTerm, [
            "textContent"
        ]);
        let filteredManagers = (0, $1JSre.runFuseElementsSearch)(managersElements.toArray(), searchTerm, [
            "textContent"
        ]);
        notAvailableElements.hide();
        retiredElements.hide();
        managersElements.hide();
        filteredNotAvailable.concat(filteredManagers, filteredRetired).forEach(function(e) {
            $(e).show();
        });
        // Show headers if any found
        if (filteredNotAvailable.length > 0) notAvailableSelector.show();
        else notAvailableSelector.hide();
        if (filteredRetired.length > 0) retiredSelector.show();
        else retiredSelector.hide();
        if (filteredManagers.length > 0) managersSelector.show();
        else managersSelector.hide();
        $(".superstar-sort-order").addClass("cursor-pointer");
    } else {
        // Show ranks if empty search term
        resultsContainer.hide();
        rankContainers.show();
        $(".superstar-sort-order").removeClass("cursor-pointer");
    }
    // Set sort select to popularity
    $(".superstar-sort").val("pop");
    let sortClass = resultsContainer.is(":visible") ? "fa-sort-up" : "fa-sort";
    $(".superstar-sort-order i").removeClass("fa-sort fa-sort-up fa-sort-down").addClass(sortClass);
    // Reset filters
    $(".superstar-filter").removeClass("selected");
    $("#booking-talent-container").scrollTop(0);
}
function $f18c00e15af0c7db$var$runTeamSearch() {
    let tempContainer = $("#all-teams");
    let teamContainers = $("#tag-teams, #trios, #factions");
    let allTeamsContainer = tempContainer.add(teamContainers);
    let teamElements = allTeamsContainer.find(".superstar-select");
    let searchTerm = $(".superstar-search-input").val();
    // Move all teams to temp container
    teamElements.toArray().forEach(function(e) {
        tempContainer.append(e);
    });
    // Run search
    let sortClass;
    if (searchTerm.length > 0) {
        let searchResults = (0, $1JSre.runFuseElementsSearch)(teamElements, searchTerm, [
            "textContent"
        ]);
        if (searchResults.length > 0) {
            // Add search results to team containers
            searchResults.sort(function(a, b) {
                return parseFloat($(a).attr("data-default-order")) - parseFloat($(b).attr("data-default-order"));
            });
            searchResults.forEach(function(e) {
                let elementContainer = $f18c00e15af0c7db$var$getRosterElementContainer($(e));
                elementContainer.append(e);
            });
        }
        // Show no results found for tag teams, trios and factions
        if ($("#tag-teams").find(".superstar-select").length <= 0) {
            if ($(".no-tag-team-search-results").length > 0) $(".no-tag-team-search-results").show();
            else $("#tag-teams").append('<div class="no-tag-team-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
            $("#tag-teams").find(".none-team-text").hide();
        } else {
            $(".no-tag-team-search-results").hide();
            $("#tag-teams").find(".none-team-text").show();
        }
        if ($("#trios").find(".superstar-select").length <= 0) {
            if ($(".no-trios-search-results").length > 0) $(".no-trios-search-results").show();
            else $("#trios").append('<div class="no-trios-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
            $("#trios").find(".none-team-text").hide();
        } else {
            $(".no-trios-search-results").hide();
            $("#trios").find(".none-team-text").show();
        }
        if ($("#factions").find(".superstar-select").length <= 0) {
            if ($(".no-factions-search-results").length > 0) $(".no-factions-search-results").show();
            else $("#factions").append('<div class="no-factions-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
            $("#factions").find(".none-team-text").hide();
        } else {
            $(".no-factions-search-results").hide();
            $("#factions").find(".none-team-text").show();
        }
        sortClass = "fa-sort-up";
        $(".superstar-sort-order").addClass("cursor-pointer");
    } else {
        // Show all teams
        teamElements.sort(function(a, b) {
            return parseFloat($(a).attr("data-default-order")) - parseFloat($(b).attr("data-default-order"));
        });
        teamElements.toArray().forEach(function(e) {
            let elementContainer = $f18c00e15af0c7db$var$getRosterElementContainer($(e));
            elementContainer.append(e);
        });
        $(".no-tag-team-search-results").hide();
        $(".no-trios-search-results").hide();
        $(".no-factions-search-results").hide();
        $(".none-team-text").show();
        sortClass = "fa-sort";
        $(".superstar-sort-order").removeClass("cursor-pointer");
    }
    // Set sort select to popularity
    $(".superstar-sort").val("pop");
    $(".superstar-sort-order i").removeClass("fa-sort fa-sort-up fa-sort-down").addClass(sortClass);
    // Reset filters
    $(".superstar-filter").removeClass("selected");
    $("#booking-talent-container").scrollTop(0);
}
function $f18c00e15af0c7db$var$applySuperstarFilter(filterName, filterBrandName) {
    let resultsContainer = $("#all-superstars");
    let rankContainers = $("#main-eventers, #upper-midcarders, #lower-midcarders, #jabroni");
    let allSuperstarsContainer = resultsContainer.add(rankContainers);
    let superstarElements = allSuperstarsContainer.find(".superstar-select");
    // Reset superstars to ranks, sorted
    superstarElements.sort(function(a, b) {
        return parseFloat($(a).attr("data-default-order")) - parseFloat($(b).attr("data-default-order"));
    });
    superstarElements.toArray().forEach(function(e) {
        let elementContainer = $f18c00e15af0c7db$var$getRosterElementContainer($(e));
        elementContainer.append(e);
    });
    // Show not available, retired and managers
    let notAvailableSelector = $("#not-available");
    let notAvailableElements = notAvailableSelector.find(".superstar-select");
    notAvailableElements.show();
    let retiredSelector = $("#retired");
    let retiredElements = retiredSelector.find(".superstar-select");
    retiredElements.show();
    let managersSelector = $("#managers");
    let managersElements = managersSelector.find(".superstar-select");
    managersElements.show();
    // Show headers if elements present
    if (notAvailableElements.length > 0) notAvailableSelector.show();
    else notAvailableSelector.hide();
    if (retiredElements.length > 0) retiredSelector.show();
    else retiredSelector.hide();
    if (managersElements.length > 0) managersSelector.show();
    else managersSelector.hide();
    // Apply filter
    if (filterName) {
        let filterResults = $f18c00e15af0c7db$var$getTalentFilterResults(superstarElements.toArray(), filterName, filterBrandName);
        // Show results if found
        if (filterResults.length > 0) {
            // Add superstars to results, hide ranks, sort by pop
            filterResults.sort(function(a, b) {
                return parseFloat($(a).attr("data-default-order")) - parseFloat($(b).attr("data-default-order"));
            });
            filterResults.forEach(function(e) {
                resultsContainer.append(e);
            });
            $(".no-superstar-search-results").hide();
        } else if ($(".no-superstar-search-results").length > 0) $(".no-superstar-search-results").show();
        else resultsContainer.append('<div class="no-superstar-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
        resultsContainer.show();
        rankContainers.hide();
        // Filter results in not available, retired and managers
        let filteredNotAvailable = $f18c00e15af0c7db$var$getTalentFilterResults(notAvailableElements.toArray(), filterName, filterBrandName);
        let filteredRetired = $f18c00e15af0c7db$var$getTalentFilterResults(retiredElements.toArray(), filterName, filterBrandName);
        let filteredManagers = $f18c00e15af0c7db$var$getTalentFilterResults(managersElements.toArray(), filterName, filterBrandName);
        notAvailableElements.hide();
        retiredElements.hide();
        managersElements.hide();
        filteredNotAvailable.concat(filteredManagers, filteredRetired).forEach(function(e) {
            $(e).show();
        });
        // Show headers if any found
        if (filteredNotAvailable.length > 0) notAvailableSelector.show();
        else notAvailableSelector.hide();
        if (filteredRetired.length > 0) retiredSelector.show();
        else retiredSelector.hide();
        if (filteredManagers.length > 0) managersSelector.show();
        else managersSelector.hide();
        $(".superstar-sort-order").addClass("cursor-pointer");
    } else {
        // Show ranks if no filter
        resultsContainer.hide();
        rankContainers.show();
        $(".superstar-sort-order").removeClass("cursor-pointer");
    }
    // Set sort select to popularity
    $(".superstar-sort").val("pop");
    let sortClass = resultsContainer.is(":visible") ? "fa-sort-up" : "fa-sort";
    $(".superstar-sort-order i").removeClass("fa-sort fa-sort-up fa-sort-down").addClass(sortClass);
    // Reset search
    $(".superstar-search-input").val("");
    $("#booking-talent-container").scrollTop(0);
}
function $f18c00e15af0c7db$var$applyTeamFilter(filterName, filterBrandName) {
    let tempContainer = $("#all-teams");
    let teamContainers = $("#tag-teams, #trios, #factions");
    let allTeamsContainer = tempContainer.add(teamContainers);
    let teamElements = allTeamsContainer.find(".superstar-select");
    // Move all teams to temp container
    teamElements.toArray().forEach(function(e) {
        tempContainer.append(e);
    });
    // Show not available
    let notAvailableSelector = $("#not-available");
    let notAvailableElements = notAvailableSelector.find(".superstar-select");
    notAvailableElements.show();
    // Show header if elements present
    if (notAvailableElements.length > 0) notAvailableSelector.show();
    else notAvailableSelector.hide();
    // Apply filter
    let sortClass;
    if (filterName) {
        let filterResults = $f18c00e15af0c7db$var$getTalentFilterResults(teamElements.toArray(), filterName, filterBrandName);
        if (filterResults.length > 0) {
            // Add search results to team containers
            filterResults.sort(function(a, b) {
                return parseFloat($(a).attr("data-default-order")) - parseFloat($(b).attr("data-default-order"));
            });
            filterResults.forEach(function(e) {
                let elementContainer = $f18c00e15af0c7db$var$getRosterElementContainer($(e));
                elementContainer.append(e);
            });
        }
        // Show no results found for tag teams and trios
        if ($("#tag-teams").find(".superstar-select").length <= 0) {
            if ($(".no-tag-team-search-results").length > 0) $(".no-tag-team-search-results").show();
            else $("#tag-teams").append('<div class="no-tag-team-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
            $("#tag-teams").find(".none-team-text").hide();
        } else {
            $(".no-tag-team-search-results").hide();
            $("#tag-teams").find(".none-team-text").show();
        }
        if ($("#trios").find(".superstar-select").length <= 0) {
            if ($(".no-trios-search-results").length > 0) $(".no-trios-search-results").show();
            else $("#trios").append('<div class="no-trios-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
            $("#trios").find(".none-team-text").hide();
        } else {
            $(".no-trios-search-results").hide();
            $("#trios").find(".none-team-text").show();
        }
        if ($("#factions").find(".superstar-select").length <= 0) {
            if ($(".no-factions-search-results").length > 0) $(".no-factions-search-results").show();
            else $("#factions").append('<div class="no-factions-search-results font-bold margin-left-5 light-grey margin-top-2">No Results Found</div>');
            $("#factions").find(".none-team-text").hide();
        } else {
            $(".no-factions-search-results").hide();
            $("#factions").find(".none-team-text").show();
        }
        sortClass = "fa-sort-up";
        // Filter results in not available
        let filteredNotAvailable = $f18c00e15af0c7db$var$getTalentFilterResults(notAvailableElements.toArray(), filterName, filterBrandName);
        notAvailableElements.hide();
        filteredNotAvailable.forEach(function(e) {
            $(e).show();
        });
        // Show headers if any found
        if (filteredNotAvailable.length > 0) notAvailableSelector.show();
        else notAvailableSelector.hide();
        $(".superstar-sort-order").addClass("cursor-pointer");
    } else {
        // Show all teams
        teamElements.sort(function(a, b) {
            return parseFloat($(a).attr("data-default-order")) - parseFloat($(b).attr("data-default-order"));
        });
        teamElements.toArray().forEach(function(e) {
            let elementContainer = $f18c00e15af0c7db$var$getRosterElementContainer($(e));
            elementContainer.append(e);
        });
        $(".no-tag-team-search-results").hide();
        $(".no-trios-search-results").hide();
        $(".no-factions-search-results").hide();
        $(".none-team-text").show();
        sortClass = "fa-sort";
        $(".superstar-sort-order").removeClass("cursor-pointer");
    }
    // Set sort select to popularity
    $(".superstar-sort").val("pop");
    $(".superstar-sort-order i").removeClass("fa-sort fa-sort-up fa-sort-down").addClass(sortClass);
    // Reset search
    $(".superstar-search-input").val("");
    $("#booking-talent-container").scrollTop(0);
}
function $f18c00e15af0c7db$var$getTalentFilterResults(rosterElement, filterName, filterBrandName) {
    let elements;
    if (filterName === "champion") elements = rosterElement.filter(function(e) {
        return $(e).hasClass("champion");
    });
    else if (filterName === "part-time") elements = rosterElement.filter(function(e) {
        return $(e).hasClass("part-timer");
    });
    else if (filterName === "unhappy") elements = rosterElement.filter(function(e) {
        return $(e).hasClass("unhappy");
    });
    else if (filterName === "injured") elements = rosterElement.filter(function(e) {
        return $(e).hasClass("injured");
    });
    else if (filterName === "he") elements = rosterElement.filter(function(e) {
        return $(e).attr("data-pronoun") === "he";
    });
    else if (filterName === "she") elements = rosterElement.filter(function(e) {
        return $(e).attr("data-pronoun") === "she";
    });
    else if (filterName === "they") elements = rosterElement.filter(function(e) {
        return $(e).attr("data-pronoun") === "they";
    });
    else if (filterName === "face") elements = rosterElement.filter(function(e) {
        return $(e).attr("data-alignment") === "face";
    });
    else if (filterName === "heel") elements = rosterElement.filter(function(e) {
        return $(e).attr("data-alignment") === "heel";
    });
    else if (filterName === "neutral") elements = rosterElement.filter(function(e) {
        return $(e).attr("data-alignment") === "null" || $(e).attr("data-alignment") === "";
    });
    else if (filterName === "no-brand") elements = rosterElement.filter(function(e) {
        return $(e).attr("data-brand-name") === "null";
    });
    else if (filterName === "custom-brand") elements = rosterElement.filter(function(e) {
        return $(e).attr("data-brand-name") === filterBrandName;
    });
    else if (filterName === "not-booked") elements = rosterElement.filter(function(e) {
        return !$(e).hasClass("booked");
    });
    return elements;
}
async function $f18c00e15af0c7db$var$showCreateCustomProductionPackageData({ data: data } = {}) {
    if (!data["error"]) {
        notie.alert({
            type: 4,
            text: '<span class="faded-purple">' + data["name"] + "</span> added!",
            stay: true
        });
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        let scrollFunction = function() {
            // Scroll to this segment item
            let $container = $("#segment-items-container"), $scrollTo = $(".segment-item-container").filter(function() {
                return $(this).find(".segment-item-name").text() === data["name"];
            });
            $container.scrollTop($scrollTo.offset().top - $container.offset().top + $container.scrollTop());
            // Highlight segment item
            setTimeout(function() {
                $scrollTo.addClass("flash-border-red");
            }, 0);
            setTimeout(function() {
                $scrollTo.removeClass("flash-border-red");
            }, 1500);
        };
        // Reload segment items, pass scrollFunction as callback
        await (0, $1JSre.makeGameRequest)((0, $4ptHI.getAvailableSegmentItems), {}, (0, $67cc16607ee33ebf$export$43c5cdc832e20b0c), {
            callbackFunction: scrollFunction
        }, false, true);
    } else {
        if (data["error"] === "level") notie.alert({
            type: 3,
            text: "You need to have an Advanced (Level 3) Production Facility and a Level 3 Producer to create a Custom Package."
        });
        else if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to add a Custom Package"
        });
        else if (data["error"] === "name-exists") notie.alert({
            type: 3,
            text: "A Custom Package with that name already exists"
        });
    }
}
async function $f18c00e15af0c7db$var$showManagerSegmentInputs(segmentElement, participantElement) {
    let managerUid = parseInt(participantElement.attr("data-uid"));
    let segmentConsequence = segmentElement.attr("data-consequence");
    let managingMultipleTalent = participantElement.attr("data-managing-multiple-talent");
    // Remove manager input container
    segmentElement.find(".segment-item-manager-inputs").fadeOut("fast").remove();
    // Add manager input container
    segmentElement.append('<div class="segment-item-manager-inputs light-grey margin-top-5"></div>');
    segmentElement.find(".segment-item-manager-inputs").hide();
    // Add managed talent select input if managing multiple talent
    if ([
        "boost-managed-talent",
        "remove-managed-talent"
    ].indexOf(segmentConsequence) >= 0 && managingMultipleTalent) await (0, $1JSre.makeGameRequest)((0, $ycsyu.getManagedTalentForManager), {
        managerUid: managerUid
    }, $f18c00e15af0c7db$var$showGetManagedTalentForManagerData, {
        segmentElement: segmentElement
    }, false, true);
    // Add manager select input
    if ([
        "add-manager"
    ].indexOf(segmentConsequence) >= 0) await (0, $1JSre.makeGameRequest)((0, $8A6FL.getAddManagerRelationshipData), {
        checkBrandExclusivity: true
    }, $f18c00e15af0c7db$var$showGetAddManagerRelationshipsSelectionsData, {
        segmentElement: segmentElement
    }, false, true);
}
function $f18c00e15af0c7db$var$showGetManagedTalentForManagerData({ data: data, segmentElement: segmentElement } = {}) {
    // Add talent select if more than 1 managed talent
    if (data["managedTalent"].length > 1) {
        // Add options
        let optionsHtml = "<option disabled selected value>Select Talent</option>";
        data["managedTalent"].forEach(function(managedTalent) {
            optionsHtml += '<option value="' + managedTalent["uid"] + '">' + managedTalent["name"] + "</option>";
        });
        // Add talent input html to end of segment item
        let talentInputsHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Talent</div><select name="select-managed-talent" class="select-managed-talent styled-select">' + optionsHtml + "</select>" + "</div>";
        segmentElement.find(".segment-item-manager-inputs").append(talentInputsHtml);
        segmentElement.find(".segment-item-manager-inputs").fadeIn("fast");
    }
}
function $f18c00e15af0c7db$var$showGetAddManagerRelationshipsSelectionsData({ data: data, segmentElement: segmentElement } = {}) {
    // Put full time managers and superstars into optgroups
    let optionsHtml = "";
    optionsHtml += "<option selected disabled value>Select Manager</option>";
    let fullTimeManagersOptions = "";
    let superstarsOptions = "";
    data["managerSelections"].forEach(function(manager) {
        let managerOptionHtml = '<option value="' + manager["uid"] + '">' + manager["name"] + "</option>";
        if (manager["fullTimeManager"]) fullTimeManagersOptions += managerOptionHtml;
        else superstarsOptions += managerOptionHtml;
    });
    optionsHtml += '<optgroup label="Full-time Managers">' + fullTimeManagersOptions + "</optgroup>";
    optionsHtml += '<optgroup label="Superstars">' + superstarsOptions + "</optgroup>";
    // Add manager input html to end of segment item
    let managerInputsHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Manager</div><select name="select-manager" class="select-manager styled-select">' + optionsHtml + "</select>" + "</div>";
    segmentElement.find(".segment-item-manager-inputs").append(managerInputsHtml);
    segmentElement.find(".segment-item-manager-inputs").fadeIn("fast");
}
async function $f18c00e15af0c7db$var$showBrandSegmentInputs(segmentElement) {
    let segmentConsequence = segmentElement.attr("data-consequence");
    // Remove brand input container
    segmentElement.find(".segment-item-brand-inputs").fadeOut("fast").remove();
    // Add brand input container
    segmentElement.append('<div class="segment-item-brand-inputs light-grey margin-top-5"></div>');
    segmentElement.find(".segment-item-brand-inputs").hide();
    // Add brand select input
    if ([
        "draft-talent-to-brand"
    ].indexOf(segmentConsequence) >= 0) await (0, $1JSre.makeGameRequest)((0, $1Dp0h.getBrandsDataForSegment), {}, $f18c00e15af0c7db$var$showGetBrandsDataForSegmentData, {
        segmentElement: segmentElement
    }, false, true);
}
function $f18c00e15af0c7db$var$showGetBrandsDataForSegmentData({ data: data, segmentElement: segmentElement } = {}) {
    // Add brand options
    let brandOptionsHtml = "<option selected disabled value>Select Brand</option>";
    data["brands"].forEach(function(brand) {
        brandOptionsHtml += '<option value="' + brand["uid"] + '">' + brand["name"] + "</option>";
    });
    // Add talent options
    let talentOptionsHtml = "<option selected disabled value>Select Talent</option>";
    data["talent"].forEach(function(talent) {
        talentOptionsHtml += '<option value="' + talent["uid"] + '" data-type="' + talent["type"] + '">' + talent["name"] + "</option>";
    });
    // Add brand input html to end of segment item
    let brandInputsHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Brand</div><select name="select-brand" class="select-brand styled-select">' + brandOptionsHtml + "</select>" + "</div>" + '<div class="margin-bottom-6">' + '<div class="display-block margin-bottom-2 font-13px">Talent</div>' + '<select name="select-brand-talent" class="select-brand-talent styled-select">' + talentOptionsHtml + "</select>" + "</div>";
    segmentElement.find(".segment-item-brand-inputs").append(brandInputsHtml);
    segmentElement.find(".segment-item-brand-inputs").fadeIn("fast");
}
async function $f18c00e15af0c7db$var$showOtherSegmentInputs(segmentElement, participantElement) {
    let segmentConsequence = segmentElement.attr("data-consequence");
    let participantUid = parseInt(participantElement.attr("data-uid"));
    let participantType = participantElement.attr("data-type");
    // Reset other inputs container
    segmentElement.find(".segment-item-other-inputs").fadeOut("fast").remove();
    segmentElement.append('<div class="segment-item-other-inputs light-grey margin-top-5"></div>');
    segmentElement.find(".segment-item-other-inputs").hide();
    // Add months select
    if ([
        "loser-unavailable",
        "make-unavailable"
    ].indexOf(segmentConsequence) >= 0) {
        let inputHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Months Unavailable</div><select name="segment-item-unavailable-months" class="segment-item-input styled-select"><option>2</option><option selected>3</option><option>4</option><option>5</option><option>6</option></select></div>';
        segmentElement.find(".segment-item-other-inputs").append(inputHtml);
        segmentElement.find(".segment-item-other-inputs").fadeIn("fast");
    } else if ([
        "create-team",
        "create-trio-of-heels",
        "remove-tag-team-and-create-tag-team",
        "create-tag-team-and-blowoff",
        "unify-titles",
        "split-title"
    ].indexOf(segmentConsequence) >= 0) {
        let nameWord = "Name";
        let helpClass = "";
        let titleAttribute = "";
        if ([
            "create-team",
            "create-trio-of-heels",
            "remove-tag-team-and-create-tag-team",
            "create-tag-team-and-blowoff"
        ].indexOf(segmentConsequence) >= 0) nameWord = "New Team Name";
        if ([
            "unify-titles",
            "split-title"
        ].indexOf(segmentConsequence) >= 0) {
            nameWord = "New Title Name";
            helpClass = " help-text";
            titleAttribute = " title=\"Enter the name of the championship e.g 'World' without the word 'Championship' or 'Title'.\"";
        }
        let inputHtml = '<div class="margin-bottom-8 margin-top-8"><div class="display-block margin-bottom-2 font-13px">' + nameWord + "</div>" + '<input type="text" name="segment-item-object-name" class="segment-item-input styled-input' + helpClass + '"' + titleAttribute + ">" + "</div>";
        segmentElement.find(".segment-item-other-inputs").append(inputHtml);
        segmentElement.find(".segment-item-other-inputs").fadeIn("fast");
    } else if (segmentElement.attr("data-name") === "Slander Competitor") await (0, $1JSre.makeGameRequest)((0, $4ptHI.getSegmentInputsData), {
        inputType: "competitors"
    }, $f18c00e15af0c7db$var$showGetSegmentInputsData, {
        segmentElement: segmentElement
    }, false, true);
    else if (segmentElement.attr("data-requirement") === "feud-present") await (0, $1JSre.makeGameRequest)((0, $4ptHI.getSegmentInputsData), {
        participantUid: participantUid,
        participantType: participantType,
        inputType: "participant-feuds"
    }, $f18c00e15af0c7db$var$showGetSegmentInputsData, {
        segmentElement: segmentElement
    }, false, true);
    else if ([
        "vacate-title",
        "award-title"
    ].indexOf(segmentConsequence) >= 0) {
        let inputType;
        if (segmentConsequence === "award-title") inputType = "vacant-championships";
        else if (segmentConsequence === "vacate-title") inputType = "participant-championships";
        await (0, $1JSre.makeGameRequest)((0, $4ptHI.getSegmentInputsData), {
            participantUid: participantUid,
            participantType: participantType,
            inputType: inputType
        }, $f18c00e15af0c7db$var$showGetSegmentInputsData, {
            segmentElement: segmentElement
        }, false, true);
    } else if (segmentConsequence === "boost-popularity") await (0, $1JSre.makeGameRequest)((0, $4ptHI.getSegmentInputsData), {
        inputType: "segments-and-matches"
    }, $f18c00e15af0c7db$var$showGetSegmentInputsData, {
        segmentElement: segmentElement
    }, false, true);
}
function $f18c00e15af0c7db$var$showGetSegmentInputsData({ data: data, segmentElement: segmentElement } = {}) {
    if (data["competitors"] && data["competitors"].length > 0) {
        // Add options
        let optionsHtml = "";
        data["competitors"].forEach(function(competitor) {
            optionsHtml += '<option value="' + competitor["uid"] + '">' + competitor["name"] + "</option>";
        });
        let inputHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Competitor</div><select name="segment-item-competitor" class="segment-item-input styled-select">' + optionsHtml + "</select>" + "</div>";
        segmentElement.find(".segment-item-other-inputs").append(inputHtml);
        segmentElement.find(".segment-item-other-inputs").fadeIn("fast");
    }
    if (data["feuds"] && data["feuds"].length > 0) {
        let optionsHtml = "";
        data["feuds"].forEach(function(feud) {
            optionsHtml += '<option value="' + feud["uid"] + '">' + feud["opponents"] + " - " + feud["name"] + "</option>";
        });
        let inputHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Feud</div><select name="segment-item-feud" class="segment-item-input styled-select">' + optionsHtml + "</select>" + "</div>";
        segmentElement.find(".segment-item-other-inputs").append(inputHtml);
        segmentElement.find(".segment-item-other-inputs").fadeIn("fast");
    }
    if (data["championships"] && data["championships"].length > 0) {
        let optionsHtml = "";
        data["championships"].forEach(function(championship) {
            optionsHtml += '<option value="' + championship["uid"] + '">' + championship["name"] + "</option>";
        });
        let inputHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Championship</div><select name="segment-item-championship" class="segment-item-input styled-select">' + optionsHtml + "</select>" + "</div>";
        segmentElement.find(".segment-item-other-inputs").append(inputHtml);
        segmentElement.find(".segment-item-other-inputs").fadeIn("fast");
    }
    if (data["segmentsAndMatches"] && data["segmentsAndMatches"].length > 0) {
        let optionsHtml = "";
        data["segmentsAndMatches"].forEach(function(object) {
            optionsHtml += '<option value="' + object["uid"] + '" data-type="' + object["type"] + '">' + object["name"] + "</option>";
        });
        let inputHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Match Or Segment</div><select name="segment-item-match-or-segment" class="segment-item-input styled-select">' + optionsHtml + "</select>" + "</div>";
        segmentElement.find(".segment-item-other-inputs").append(inputHtml);
        segmentElement.find(".segment-item-other-inputs").fadeIn("fast");
    }
}
async function $f18c00e15af0c7db$var$showFactionSegmentInputs(segmentElement, participantElement) {
    let factionUid = parseInt(participantElement.attr("data-uid"));
    let segmentConsequence = segmentElement.attr("data-consequence");
    // Remove faction input
    segmentElement.find(".segment-item-faction-inputs").fadeOut("fast").remove();
    // Add faction input container
    segmentElement.append('<div class="segment-item-faction-inputs light-grey margin-top-5"></div>');
    segmentElement.find(".segment-item-faction-inputs").hide();
    // Add faction superstar select input
    if ([
        "remove-faction-members",
        "add-faction-members",
        "add-faction-leader",
        "change-faction-leader",
        "kick-out-faction-leader-and-change-leader",
        "leave-faction-and-join-other-faction",
        "split-faction"
    ].indexOf(segmentConsequence) >= 0) {
        // Get function and data key
        let getFunction;
        let dataKey;
        let checkBrandExclusivity;
        let excludeFactionSuperstars;
        if ([
            "remove-faction-members",
            "change-faction-leader",
            "kick-out-faction-leader-and-change-leader",
            "leave-faction-and-join-other-faction",
            "split-faction"
        ].indexOf(segmentConsequence) >= 0) {
            getFunction = (0, $6PzHO.getFactionSuperstarsRequest);
            dataKey = "factionSuperstars";
        } else if (segmentConsequence === "add-faction-members") {
            getFunction = (0, $6PzHO.getSuperstarsAvailableForFaction);
            checkBrandExclusivity = true;
            dataKey = "availableSuperstars";
        } else if (segmentConsequence === "add-faction-leader") {
            getFunction = (0, $6PzHO.getSuperstarsAvailableForFaction);
            checkBrandExclusivity = true;
            excludeFactionSuperstars = true;
            dataKey = "availableSuperstars";
        }
        await (0, $1JSre.makeGameRequest)(getFunction, {
            factionUid: factionUid,
            checkBrandExclusivity: checkBrandExclusivity,
            excludeFactionSuperstars: excludeFactionSuperstars
        }, $f18c00e15af0c7db$var$showGetFactionSuperstarsData, {
            segmentElement: segmentElement,
            dataKey: dataKey,
            segmentConsequence: segmentConsequence
        }, false, true);
    }
    // Add faction select input
    if ([
        "leave-faction-and-join-other-faction",
        "merge-factions"
    ].indexOf(segmentConsequence) >= 0) await (0, $1JSre.makeGameRequest)((0, $6PzHO.getCompanyFactionsForSelection), {}, $f18c00e15af0c7db$var$showGetCompanyFactionsForSelectionData, {
        segmentElement: segmentElement
    }, false, true);
    // Add faction name input
    if ([
        "merge-factions",
        "split-faction"
    ].indexOf(segmentConsequence) >= 0) {
        // Add faction input html to end of segment item
        let factionInputsHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Faction Name</div><input type="text" name="segment-item-faction-name" class="segment-item-faction-name styled-input"></div>';
        segmentElement.find(".segment-item-faction-inputs").append(factionInputsHtml);
        segmentElement.find(".segment-item-faction-inputs").fadeIn("fast");
    }
    // Add faction inputs
    if (segmentConsequence === "create-faction") {
        // Add faction name input
        let factionNameInputHtml = '<div class="margin-bottom-8 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Faction Name</div><input type="text" name="segment-item-faction-name" class="segment-item-faction-name styled-input"></div>';
        segmentElement.find(".segment-item-faction-inputs").append(factionNameInputHtml);
        // Add faction member select inputs
        await (0, $1JSre.makeGameRequest)((0, $6PzHO.getSuperstarsAvailableForFaction), {
            checkBrandExclusivity: true
        }, $f18c00e15af0c7db$var$showGetSuperstarsAvailableForFactionData, {
            segmentElement: segmentElement
        }, false, true);
    }
}
function $f18c00e15af0c7db$var$showGetFactionSuperstarsData({ data: data, segmentElement: segmentElement, dataKey: dataKey, segmentConsequence: segmentConsequence } = {}) {
    // Add options
    let optionsHtml = "<option disabled selected value>Select Member</option>";
    data[dataKey].forEach(function(factionSuperstar) {
        optionsHtml += '<option value="' + factionSuperstar["uid"] + '">' + factionSuperstar["name"] + "</option>";
    });
    // Don't show add select button if selecting faction leader
    let addFactionMemberSelectButton = '<button type="button" class="add-faction-member-select-button button retro-button font-bold styled-select-button"><i class="fa fa-plus"></i></button>';
    if ([
        "change-faction-leader",
        "kick-out-faction-leader-and-change-leader",
        "add-faction-leader"
    ].indexOf(segmentConsequence) >= 0) addFactionMemberSelectButton = "";
    // Add faction input html to end of segment item
    let factionInputsHtml = '<div class="margin-bottom-6"><div class="display-block margin-bottom-2 font-13px">Select Member(s) For Consequence</div><select name="select-faction-member" class="select-faction-member styled-select">' + optionsHtml + "</select>" + "</div>" + "<div>" + addFactionMemberSelectButton + "</div>";
    segmentElement.find(".segment-item-faction-inputs").prepend(factionInputsHtml);
    segmentElement.find(".segment-item-faction-inputs").fadeIn("fast");
}
function $f18c00e15af0c7db$var$showGetCompanyFactionsForSelectionData({ data: data, segmentElement: segmentElement } = {}) {
    // Add options
    let optionsHtml = "";
    data["factions"].forEach(function(faction) {
        optionsHtml += '<option value="' + faction["uid"] + '">' + faction["name"] + "</option>";
    });
    // Add faction input html to end of segment item
    let factionInputsHtml = '<div class="margin-bottom-6 margin-top-8"><div class="display-block margin-bottom-2 font-13px">Select Faction For Consequence</div><select name="select-faction" class="select-faction styled-select">' + optionsHtml + "</select>" + "</div>";
    segmentElement.find(".segment-item-faction-inputs").append(factionInputsHtml);
    segmentElement.find(".segment-item-faction-inputs").fadeIn("fast");
}
function $f18c00e15af0c7db$var$showGetSuperstarsAvailableForFactionData({ data: data, segmentElement: segmentElement } = {}) {
    // Add options
    let optionsHtml = "";
    data["availableSuperstars"].forEach(function(factionSuperstar) {
        optionsHtml += '<option value="' + factionSuperstar["uid"] + '">' + factionSuperstar["name"] + "</option>";
    });
    // Add faction member and leader selects
    let factionSelectsHtml = '<div class="margin-bottom-6"><div class="display-block margin-bottom-2 font-13px">Select Faction Members</div><select name="select-faction-member" class="select-faction-member styled-select">' + optionsHtml + "</select>" + "</div>" + '<div class="margin-bottom-6">' + '<select name="select-faction-member" class="select-faction-member styled-select">' + optionsHtml + "</select>" + "</div>" + "<div>" + '<button type="button" class="add-faction-member-select-button button retro-button font-bold styled-select-button">' + '<i class="fa fa-plus"></i>' + "</button>" + "</div>" + '<div class="margin-top-8">' + '<div class="display-block margin-bottom-2 font-13px">Select Faction Leader</div>' + '<select name="select-faction-leader" class="select-faction-leader styled-select"></select>' + "</div>";
    segmentElement.find(".segment-item-faction-inputs").append(factionSelectsHtml);
    segmentElement.find(".segment-item-faction-inputs").fadeIn("fast");
    // Select second option for second faction member select
    segmentElement.find(".select-faction-member").eq(1).find(":selected").next().prop("selected", true);
    (0, $9c7fdb096dd8e19a$export$25d3e1524ca4231d)(segmentElement);
}
function $f18c00e15af0c7db$var$showGetBookingSelectionInformationData({ data: data } = {}) {
    let parent = $("#booking-talent-container");
    if (data["feudsData"]) data["feudsData"].forEach(function(feud) {
        let feudHype;
        let feudBorderClass;
        // Potential feud
        if (!feud["started"] && !feud["ended"]) {
            feudBorderClass = "potential-feud";
            feudHype = '<span class="margin-left-8 potential-feud-red superstar-select-feud-details"><i class="fa fa-bolt margin-right-5"></i>' + Math.round(feud["hype"]) + "</span>";
        } else if (feud["previousFeudBoost"] !== undefined) {
            if (feud["previousFeudBoost"] > 0) {
                feudHype = '<span class="margin-left-8 hot-color superstar-select-feud-details"><i class="fa fa-bolt margin-right-5"></i><i class="fa fa-angle-double-up marign-left-5"></i></span>';
                feudBorderClass = "";
            } else {
                feudHype = '<span class="margin-left-8 stale-color superstar-select-feud-details"><i class="fa fa-bolt margin-right-5"></i><i class="fa fa-angle-double-down marign-left-5"></i></span>';
                feudBorderClass = "";
            }
        } else {
            feudBorderClass = "current-feud";
            feudHype = '<span class="margin-left-8 faded-red-light superstar-select-feud-details"><i class="fa fa-bolt margin-right-5"></i>' + Math.round(feud["hype"]) + "</span>";
        }
        feud["participants"].forEach(function(participant) {
            let elementsFound = parent.find(".superstar-select:not(.selected)").filter(function() {
                return $(this).data("name") === participant;
            });
            elementsFound.addClass(feudBorderClass);
            elementsFound.append(feudHype);
        });
    });
    if (data["partnerSuperstars"]) data["partnerSuperstars"].forEach(function(participant) {
        let elementsFound = parent.find(".superstar-select:not(.selected)").filter(function() {
            return $(this).data("name") === participant;
        });
        elementsFound.addClass("partner-superstar");
    });
}
function $f18c00e15af0c7db$var$showGetFeudSegmentsInformationData({ data: data } = {}) {
    data["feudSegmentNames"].forEach(function(segmentItem) {
        let alreadyHeld = '<div class="dark-grey segment-booking-already-held">Already Held</div>';
        let element = $(".segment-item-name").filter(function() {
            return $(this).text() === segmentItem;
        });
        let segmentItemContainer = element.closest(".segment-item-container");
        segmentItemContainer.find(".column-right.segment-item-information").children("div").append(alreadyHeld);
        segmentItemContainer.addClass("already-held");
    });
    data["unavailableSegments"].forEach(function(segmentItem) {
        let alreadyHeld = '<div class="dark-grey segment-booking-unavailable">Unavailable</div>';
        let element = $(".segment-item-name").filter(function() {
            return $(this).text() === segmentItem;
        });
        let segmentItemContainer = element.closest(".segment-item-container");
        segmentItemContainer.find(".column-right.segment-item-information").children("div").append(alreadyHeld);
        segmentItemContainer.addClass("unavailable");
    });
    // If 'available' segment filter selected, get available segments again (as they are changed by feud selection)
    if ($('.filter-segment-items-option[data-value="available"].selected').length > 0) $f18c00e15af0c7db$var$showAvailableSegmentItems();
}
function $f18c00e15af0c7db$var$showAvailableSegmentItems() {
    let segmentItemsContainer = $("#segment-items-container");
    let segmentElements = segmentItemsContainer.find(".item-container");
    segmentElements.each(function(i, e) {
        if ($(e).hasClass("unavailable") || $(e).hasClass("locked")) $(e).hide();
        else $(e).show();
    });
}
function $f18c00e15af0c7db$var$showBookSegmentData({ data: data } = {}) {
    if (!data["error"]) {
        let notieText = "";
        $f18c00e15af0c7db$var$segmentParticipants = [];
        // Show consequence applied to
        if (data["segment"]["consequenceAppliedTo"] && data["segment"]["participants"].length > 2) {
            let consequenceText = '<span class="display-block"><span class="faded-red-light">' + (0, $3E8Nt.toTitleCase)(data["segment"]["consequence"].replace(/-/g, " ")) + "</span> Consequence applied to " + data["segment"]["consequenceAppliedTo"] + "</span>";
            notieText += '<span class="display-block">Segment Added' + consequenceText + "</span>";
        } else notieText += '<span class="display-block">Segment Added</span>';
        // Reset segment containers
        let selected = $(".segment-item-container.selected");
        $(".segment-participants").text("No participants selected");
        $(".segment-item-selected").text("No Segment Item selected");
        $(".segment-participants").removeClass("faded-red-light");
        $(".segment-item-selected").removeClass("faded-purple");
        selected.removeClass("selected");
        $(".segment-search-input").val("");
        $(".feud-container").show().removeClass("selected");
        // Reset singles/tag
        $("#booking-talent-container.segments-selection .superstar-select.selected").removeClass("selected");
        // Remove already held indication
        $(".segment-booking-already-held").remove();
        $(".segment-item-container.already-held").removeClass("already-held");
        // Remove unavailable indication
        $(".segment-booking-unavailable").remove();
        $(".segment-item-container.unavailable").removeClass("unavailable");
        // Remove faction/manager/brand/other inputs
        selected.find(".segment-item-faction-inputs").remove();
        selected.find(".segment-item-manager-inputs").remove();
        selected.find(".segment-item-brand-inputs").remove();
        selected.find(".segment-item-other-inputs").remove();
        // Uncheck 'Add Producer Focus', hide producer select
        $("#booking-container").find('input[value="add_segment_producer_focus"]').prop("checked", false);
        $("#booking-container").find(".add-segment-producer-select").hide();
        // Add segment to event card
        let index;
        if ($("#matches").text() === "No matches or segments booked") index = 0;
        let segmentHtml = (0, $1145891c855e0e78$export$e0309c2afefc2b87)(data["segment"], index);
        $("#matches").append(segmentHtml);
        // Update match limits
        let matchLimitsHtml = (0, $1145891c855e0e78$export$30265932b480a0df)();
        $("#match-limits").html(matchLimitsHtml);
        // Show notifications
        if (notieText) notie.alert({
            type: 4,
            text: notieText
        });
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("add_segment");
    } else {
        if (data["error"] === "match-and-segment-limit") notie.alert({
            type: 3,
            text: "You can't book more than " + data["limit"] + " Matches/Segments at this Event"
        });
        else if (data["error"] === "monthly-event-segment-limit") notie.alert({
            type: 3,
            text: "You can't book more than " + data["limit"] + " Segments at Monthly Events"
        });
        else if (data["error"] === "max-participants") {
            let participantsText = "Participant";
            if (data["maxParticipants"] !== 1) participantsText = "Participants";
            let errorText = "You can't book more than " + data["maxParticipants"] + " " + participantsText + " in this Segment";
            if (data["maxParticipants"] === 0) errorText += ". Try unselecting Participants in the booking section.";
            notie.alert({
                type: 3,
                text: errorText
            });
        } else if (data["error"] === "min-participants") {
            let participantsText = "Participant";
            if (data["minParticipants"] !== 1) participantsText = "Participants";
            notie.alert({
                type: 3,
                text: "You need at least " + data["minParticipants"] + " " + participantsText + " in this Segment"
            });
        } else if (data["error"] === "max-segments") notie.alert({
            type: 3,
            text: "You can't book a Roster Member in more than 2 Segments at this Event"
        });
        else if (data["error"] === "feud-only") notie.alert({
            type: 3,
            text: "This Segment can only be used with an existing Feud"
        });
        else if (data["error"] === "production-packages-only") notie.alert({
            type: 3,
            text: "You can only book Production Segments at this Event"
        });
        else if (data["error"] === "already-used") {
            let monthsWord = (0, $3E8Nt.getMonthsWord)(data["monthsToReuse"]);
            notie.alert({
                type: 3,
                text: "Special Segments can only be used once every 3 years. This segment can be re-used in {0} {1}.".format(data["monthsToReuse"], monthsWord)
            });
        } else if (data["error"] === "special-segments-not-paid") notie.alert({
            type: 3,
            text: "Special Segments can only be used in JoW Paid"
        });
        else if (data["error"] === "producer-focus-not-paid") notie.alert({
            type: 3,
            text: "Producers can only be assigned to Segments in JoW Paid."
        });
        else if (data["error"] === "locked-segment-item") notie.alert({
            type: 3,
            text: "This Segment is locked"
        });
        else if (data["error"] === "superstars-only") notie.alert({
            type: 3,
            text: "Special Segments can only be used on singles Superstars"
        });
        else if (data["error"] === "retired") notie.alert({
            type: 3,
            text: "Retired Superstars can only be booked in Legends, Retired and Manager Segments or as part of a Faction"
        });
        else if (data["error"] === "manager") notie.alert({
            type: 3,
            text: "Managers cannot be added to Teams"
        });
        else if (data["error"] === "superstar-not-available") notie.alert({
            type: 3,
            text: data["superstarName"] + " is not available to be booked at this Event"
        });
        else if (data["error"] === "requirement-fail") {
            let participantsType = $(".book-segment-option.selected").text();
            let participantName = participantsType !== "Feuds" ? participantsType : "";
            let errorText;
            if (data["alreadyHeld"]) errorText = "This Segment has already been held before";
            else switch(data["requirement"]){
                case "title-feud":
                    errorText = "Participants need to be involved in a Title Feud (New Challenger, Better Champion etc)";
                    break;
                case "team-superstars":
                    errorText = "All Participants need to be Singles Superstars and be in a Team together";
                    break;
                case "champion":
                    if (participantName === "Factions") errorText = "This segment can only be used with Superstars and Teams";
                    else errorText = "Participant needs to be a " + participantName + " champion";
                    break;
                case "new-champion":
                    if (participantName === "Factions") errorText = "This segment can only be used with Superstars and Teams";
                    else errorText = "Participant needs to have won a " + participantName + " championship in the last 2 months";
                    break;
                case "previous-feuds":
                    errorText = "Participants need to be involved in one or more previous Feuds";
                    break;
                case "new-talent":
                    errorText = "A participant who is a recent signing, callup, trade or custom Superstar needs to be present";
                    break;
                case "contract-and-champion":
                    if (participantName === "Factions") errorText = "This segment can only be used with Superstars and Teams";
                    else errorText = "One Participant needs to hold a cash-in contract and another needs to be a " + participantName + " champion";
                    break;
                case "legend":
                    errorText = "One Participant needs to be a retired Hall of Famer";
                    break;
                case "vacant-title":
                    if (participantName === "Factions") errorText = "This segment can only be used with Superstars and Teams";
                    else errorText = "A Vacant " + participantName + " Title needs to be present and not booked in a Match";
                    break;
                case "heel":
                    errorText = "Participant needs to have 'Heel' Alignment";
                    break;
                case "face":
                    errorText = "Participant needs to have 'Face' Alignment";
                    break;
                case "neutral":
                    errorText = "Participant needs to have 'Neutral' Alignment";
                    break;
                case "face-vs-heel":
                    errorText = "One Participant needs to have 'Face' Alignment and the other needs to have 'Heel' Alignment";
                    break;
                case "face-vs-face":
                    errorText = "Both Participants need to have 'Face' Alignment";
                    break;
                case "face-team-superstars":
                    errorText = "All Participants need to have 'Face' Alignment and be in a Team together";
                    break;
                case "heel-team-superstars":
                    errorText = "All Participants need to have 'Heel' Alignment and be in a Team together";
                    break;
                case "face-vs-face-past-feud":
                    errorText = "Both Participants need to have 'Face' Alignment and have been in a past Feud against each other";
                    break;
                case "face-vs-heel-past-feud":
                    errorText = "Participants need to be a 'Heel' and a 'Face' that have been in a past Feud against each other";
                    break;
                case "level-1-producer":
                    errorText = "You need to have a Level 1 Producer available on your Staff";
                    if (!(0, $98xmD.globals).game["paid"]) errorText += " (JoW Paid)";
                    break;
                case "level-2-producer":
                    errorText = "You need to have a Level 2 Producer available on your Staff";
                    break;
                case "level-3-producer":
                    errorText = "You need to have a Level 3 Producer available on your Staff";
                    break;
                case "new-talent-and-level-2-producer":
                    errorText = "Participant needs to be a recent signing, callup, trade or custom Superstar that hasn't had a Debut Segment and you need to have a Level 2 Producer available on your Staff";
                    break;
                case "returning-talent-and-level-2-producer":
                    errorText = "Participant needs to be injured, up to 3 months away from their return and you need to have a Level 2 Producer available on your Staff";
                    break;
                case "retiring-talent-and-level-3-producer":
                    errorText = "Participant needs to be over 45 years old and you need to have a Level 3 Producer available on your Staff";
                    break;
                case "buyout-offer-accepted":
                    errorText = "You need to make an offer to buyout a Competitor and have it accepted";
                    break;
                case "champion-and-level-2-producer":
                    if (participantName === "Factions") errorText = "This segment can only be used with Superstars and Teams";
                    else errorText = "Participant needs to be a " + participantName + " champion and you need to have a Level 2 " + "Producer available on your Staff";
                    break;
                case "silver-champion":
                    if (participantName === "Factions") errorText = "This segment can only be used with Superstars and Teams";
                    else errorText = "Participant needs to hold a " + participantName + " championship with Silver Prestige or higher";
                    break;
                case "gold-champion":
                    if (participantName === "Factions") errorText = "This segment can only be used with Superstars and Teams";
                    else errorText = "Participant needs to hold a " + participantName + " championship with Gold Prestige or higher and a Graphic added";
                    break;
                case "obsidian-champion":
                    if (participantName === "Factions") errorText = "This segment can only be used with Superstars and Teams";
                    else errorText = "Participant needs to hold a " + participantName + " championship with Obsidian Prestige or higher";
                    break;
                case "retirement":
                    errorText = "Participant needs to have retired in the last 2 months";
                    break;
                case "losing-streak":
                    errorText = "Participant needs to have a Losing Streak of 5 Matches or more";
                    break;
                case "legend-and-over-superstar":
                    errorText = "One Participant needs to be a retired Hall of Famer and another needs to be an Over Superstar";
                    break;
                case "legend-and-heel":
                    errorText = "One Participant needs to be a retired Hall of Famer and another needs to have 'Heel' Alignment";
                    break;
                case "face-of-the-company":
                    errorText = "Participant needs to be a Face of the Company";
                    break;
                case "wrestler-of-the-year-award":
                    errorText = "Participant needs to have won a Wrestler of the Year Award in the last 2 months";
                    break;
                case "company-of-the-year-award":
                    errorText = "Your Company needs to have won a Company of the Year Award in the last 2 months";
                    break;
                case "award-winner":
                    errorText = "One Participant needs to have won a Year-End Award (not bad awards) in the last 2 months";
                    break;
                case "inflicted-injury":
                    errorText = "Participant needs to have injured another Superstar in the last 1 month";
                    break;
                case "not-done-yet-potential-feud":
                    errorText = "Participant needs to have retired another Superstar in the last 2 months";
                    break;
                case "shocking-heel-turn":
                    errorText = "Participant needs to have turned Heel in a Shocking Turn (Main Eventer turns against someone in a Segment after a year or more of being Heel or Face) in the last 2 months";
                    break;
                case "shocking-face-turn":
                    errorText = "Participant needs to have turned Face in a Shocking Turn (Main Eventer turns against someone in a Segment after a year or more of being Heel or Face) in the last 2 months";
                    break;
                case "new-gimmick-and-level-1-producer":
                    errorText = "Participant needs to have a new Gimmick and you need to have a Level 1 Producer available on your Staff";
                    break;
                case "singles-superstars":
                    errorText = "Participants need to be singles Superstars not in a Team";
                    break;
                case "retiring":
                    errorText = "A participant over 45 years old needs to be present";
                    break;
                case "injured-partner-and-singles-superstar":
                    errorText = "One participant needs to have an injured tag partner and another needs to be a singles Superstar not in a Team";
                    break;
                case "heels-vs-face-singles":
                    errorText = "One participant needs to be have 'Face' alignment and the others need to have 'Heel' alignment. Participants need to be singles Superstars not in a Team.";
                    break;
                case "masked-talent":
                    errorText = "A participant with a mask needs to be present.";
                    break;
                case "no-faction-leader":
                    errorText = "The faction needs to not have a leader present.";
                    break;
                case "faction-leader-present":
                    errorText = "The faction needs to have a leader present.";
                    break;
                case "other-brand-talent":
                    errorText = "Participants need to belong to another brand. Try using the Interbrand artifact to book other brand talent.";
                    break;
                case "heel-vs-heel":
                    errorText = "Both Participants need to have 'Heel' Alignment";
                    break;
                case "returning-talent":
                    errorText = "A participant who is available to return from injury (and hasn't been used since) needs to be present";
                    break;
                case "double-champion":
                    if (participantName === "Factions") errorText = "This segment can only be used with Superstars and Teams";
                    else errorText = "Participant needs to hold two " + participantName + " championships";
                    break;
                case "over-talent":
                    errorText = "Participants need to be Over (80% Overness or higher)";
                    break;
                case "feud-present":
                    errorText = "Participant needs to be in one or more active Feuds";
                    break;
                case "the-grand-invitational-winner":
                    errorText = "Participant needs to have won The Grand Invitational for the company in the last 2 months";
                    break;
                default:
                    errorText = "The participant(s) do not fulfill the requirements for this Segment";
            }
            notie.alert({
                type: 3,
                text: errorText
            });
        } else if (data["error"] === "minimum-faction-superstars") notie.alert({
            type: 3,
            text: "You cannot have less than 2 members in a faction."
        });
        else if (data["error"] === "maximum-faction-superstars") notie.alert({
            type: 3,
            text: `You cannot have more than ${(0, $3E8Nt.gameLimits).maxFactionSuperstars} members in a faction.`
        });
        else if (data["error"] === "not-member-of-faction") notie.alert({
            type: 3,
            text: data["errorSuperstarName"] + " is not part of this faction."
        });
        else if (data["error"] === "faction-superstar-not-found") notie.alert({
            type: 3,
            text: "One of the faction superstars selected could not be found. Please try again."
        });
        else if (data["error"] === "already-member-of-faction") notie.alert({
            type: 3,
            text: data["errorSuperstarName"] + " is already part of this faction."
        });
        else if (data["error"] === "already-in-faction") notie.alert({
            type: 3,
            text: data["errorSuperstarName"] + " is already in another faction."
        });
        else if (data["error"] === "leader-superstar-not-present") notie.alert({
            type: 3,
            text: "The leader needs to be a member of the faction."
        });
        else if (data["error"] === "select-non-faction-leader") notie.alert({
            type: 3,
            text: "Select a faction member who is not the leader."
        });
        else if (data["error"] === "faction-not-found") notie.alert({
            type: 3,
            text: "That faction could not be found. Please try again."
        });
        else if (data["error"] === "selected-existing-faction") notie.alert({
            type: 3,
            text: "Select a faction different from the selected faction."
        });
        else if (data["error"] === "selected-disbanded-faction") notie.alert({
            type: 3,
            text: "Select a faction that hasn't been disbanded."
        });
        else if (data["error"] === "faction-name-not-entered") notie.alert({
            type: 3,
            text: "Enter a name for the created faction."
        });
        else if (data["error"] === "faction-already-present") notie.alert({
            type: 3,
            text: "A faction with that name already exists."
        });
        else if (data["error"] === "team-already-present") notie.alert({
            type: 3,
            text: "A team with that name already exists."
        });
        else if (data["error"] === "faction-superstar-not-available") notie.alert({
            type: 3,
            text: data["errorSuperstarName"] + " is not available to be booked."
        });
        else if (data["error"] === "not-enough-available-faction-superstars") notie.alert({
            type: 3,
            text: "At least 2 members of a faction need to be available"
        });
        else if (data["error"] === "factions-only") notie.alert({
            type: 3,
            text: "You can only select Factions for this Segment"
        });
        else if (data["error"] === "disbanded-faction") notie.alert({
            type: 3,
            text: "You can only select Factions for this Segment"
        });
        else if (data["error"] === "factions-paid-only") notie.alert({
            type: 3,
            text: "Faction Segments are only available in JoW Paid"
        });
        else if (data["error"] === "managers-paid-only") notie.alert({
            type: 3,
            text: "Manager Segments are only available in JoW Paid"
        });
        else if (data["error"] === "brands-paid-only") notie.alert({
            type: 3,
            text: "Brand Segments are only available in JoW Paid"
        });
        else if (data["error"] === "no-women-allowed") notie.alert({
            type: 3,
            text: "Women are not allowed to be booked at this event"
        });
        else if (data["error"] === "no-men-allowed") notie.alert({
            type: 3,
            text: "Men are not allowed to be booked at this event"
        });
        else if (data["error"] === "no-managed-talent") notie.alert({
            type: 3,
            text: "Participant needs to be managing available talent."
        });
        else if (data["error"] === "manager-not-found") notie.alert({
            type: 3,
            text: "The selected manager could not be found. Please try again."
        });
        else if (data["error"] === "maximum-superstars") notie.alert({
            type: 3,
            text: "A manager cannot manage more than 15 superstars."
        });
        else if (data["error"] === "manager-present") notie.alert({
            type: 3,
            text: "{0} already has a manager present.".format(data["superstarName"])
        });
        else if (data["error"] === "no-manager-present") notie.alert({
            type: 3,
            text: "Participant needs to have a manager present."
        });
        else if (data["error"] === "managing-self") notie.alert({
            type: 3,
            text: "Superstars cannot manage themselves."
        });
        else if (data["error"] === "managing-full-time-manager") notie.alert({
            type: 3,
            text: "Full-time managers cannot be managed."
        });
        else if (data["error"] === "brand-not-found") notie.alert({
            type: 3,
            text: "The selected brand could not be found. Please try again."
        });
        else if (data["error"] === "talent-not-found") notie.alert({
            type: 3,
            text: "The selected talent could not be found. Please try again."
        });
        else if (data["error"] === "already-on-brand") notie.alert({
            type: 3,
            text: "The selected talent is already part of the selected brand."
        });
        else if (data["error"] === "already-on-brand") notie.alert({
            type: 3,
            text: "The selected talent is already part of the selected brand."
        });
        else if (data["error"] === "championship-already-present") notie.alert({
            type: 3,
            text: "A championship with that name already exists. Leave the field blank to keep the current name."
        });
        else if (data["error"] === "producer-task-present") notie.alert({
            type: 3,
            text: "{0} is already working on another task. Please cancel that task or select another Producer.".format(data["producer"])
        });
    }
    // Remove highlighted feuding members
    $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
    $(".superstar-select-feud-details").remove();
}
function $f18c00e15af0c7db$var$showDeleteSegmentData({ data: data, $segmentElement: $segmentElement } = {}) {
    if (!data["error"]) $segmentElement.fadeOut(300).promise().done(function() {
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        // Move main event label
        let mainEventLabel = $segmentElement.find(".main-event-label");
        if (mainEventLabel.length > 0) mainEventLabel.prependTo($segmentElement.last().next().find(".event-match-column-left"));
        $segmentElement.remove();
        // Reset match limits
        if ($("#matches").text() === "") $("#matches").html('<span class="font-bold display-block light-grey margin-bottom-10 margin-top-10 event-match-empty">No matches or segments booked</span>');
        let matchLimitsHtml = (0, $1145891c855e0e78$export$30265932b480a0df)();
        $("#match-limits").html(matchLimitsHtml);
    });
    else if (data["error"] === "pow-cannot-delete") notie.alert({
        type: 3,
        text: '"We need a welcome promo, and who better to deliver it than me?" - Hank Hughes'
    });
}
function $f18c00e15af0c7db$var$showGetAddProducersData({ data: data, segmentUid: segmentUid } = {}) {
    let parent = $("#segment-add-producer-container");
    (0, $1JSre.hideEventCardContent)($("#event-card"));
    parent.data("segment-uid", segmentUid);
    // Populate producer select
    let producerSelect = parent.find(".segment-add-producer-select");
    let producerOptions = "";
    data["producers"].forEach(function(producer) {
        producerOptions += '<option value="' + producer["uid"] + '">' + producer["name"] + " (Lvl " + producer["level"] + ")</option>";
    });
    if (data["producers"].length <= 0) producerOptions += "<option disabled selected value>No Producers Available</option>";
    producerSelect.html(producerOptions);
    parent.hide().fadeIn("fast");
    parent[0].scrollIntoView();
}
function $f18c00e15af0c7db$var$showAddProducerToSegmentData({ data: data, segmentUid: segmentUid } = {}) {
    if (!data["error"]) {
        let segmentHtml = (0, $1145891c855e0e78$export$e0309c2afefc2b87)(data["segment"]);
        let segmentDiv = $('.event-match[data-uid="' + segmentUid + '"]');
        segmentDiv.replaceWith(segmentHtml);
        notie.alert({
            type: 4,
            text: '<div class="display-block">Producer added</div>',
            stay: false
        });
        setTimeout(function() {
            $("#segment-add-producer-container").fadeOut("fast");
        }, 600);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "segment-not-found") notie.alert({
            type: 3,
            text: "The Segment could not found. Please try again."
        });
        if (data["error"] === "producer-not-found") notie.alert({
            type: 3,
            text: "That Producer could not found. Please try again."
        });
        if (data["error"] === "producer-task-present") notie.alert({
            type: 3,
            text: "{0} is already working on another task. Please cancel that task or select another Producer.".format(data["producer"])
        });
        if (data["error"] === "not-paid") notie.alert({
            type: 3,
            text: "Producers can only be assigned to Segments in JoW Paid."
        });
    }
}
function $f18c00e15af0c7db$var$showRemoveProduceFromSegmentData({ data: data, segmentUid: segmentUid } = {}) {
    if (!data["error"]) {
        let segmentHtml = (0, $1145891c855e0e78$export$e0309c2afefc2b87)(data["segment"]);
        let segmentDiv = $('.event-match[data-uid="' + segmentUid + '"]');
        segmentDiv.replaceWith(segmentHtml);
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        notie.alert({
            type: 4,
            text: '<div class="display-block">Producer removed</div>',
            stay: false
        });
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "segment-not-found") notie.alert({
            type: 3,
            text: "The Segment could not found. Please try again.",
            stay: true
        });
        else if (data["error"] === "no-producer-assigned") notie.alert({
            type: 3,
            text: "That Segment does not have a Producer assigned to it.",
            stay: true
        });
    }
}
async function $f18c00e15af0c7db$var$showDeleteMatchData({ data: data, $matchElement: $matchElement } = {}) {
    if (!data["error"]) $matchElement.fadeOut(300).promise().done(async function() {
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        // Move main event label
        let mainEventLabel = $matchElement.find(".main-event-label");
        if (mainEventLabel.length > 0) mainEventLabel.prependTo($matchElement.last().next().find(".event-match-column-left"));
        $matchElement.remove();
        // Remove deleted potential feuds
        $f18c00e15af0c7db$var$removeDeletedPotentialFeuds(data["deletedPotentialFeudUids"]);
        // Remove unbooked superstars
        $f18c00e15af0c7db$var$processUnbookedMatchSuperstars(data["unbookedMatchSuperstarsUids"]);
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Reset match limits
        if ($("#matches").text() === "") $("#matches").html('<span class="font-bold display-block light-grey margin-bottom-10 margin-top-10 event-match-empty">No matches or segments booked</span>');
        let matchLimitsHtml = (0, $1145891c855e0e78$export$30265932b480a0df)();
        $("#match-limits").html(matchLimitsHtml);
        if (data["weeklyShowDeleted"]) await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)());
    });
    else {
        if (data["error"] === "pow-cannot-delete") notie.alert({
            type: 3,
            text: '"That\'s my match! You know how hard I worked on it? No, it stays on the card." - Hank Hughes'
        });
        else if (data["error"] === "match-not-found") notie.alert({
            type: 3,
            text: "Match not found. Please try again."
        });
    }
}
function $f18c00e15af0c7db$var$updateMatchParticipantsText() {
    // If singles tag selected, use its function
    let tagMatchOptionSelected = $(".tag-match-options .selected").text();
    let singlesTag = [
        "2v2",
        "3v3",
        "4v4",
        "5v5",
        "1v2",
        "1v3",
        "2v3",
        "?v?"
    ].indexOf(tagMatchOptionSelected) > -1;
    if (singlesTag) {
        $f18c00e15af0c7db$var$updateSinglesTagMatchParticipantsText();
        return false;
    }
    let tournament = $("#add-tournament-menu-button").hasClass("selected");
    if ($f18c00e15af0c7db$var$selectedParticipants.length > 0) {
        // Get participants names
        let participantsNames;
        if (tournament) participantsNames = $f18c00e15af0c7db$var$selectedParticipants.join(", ");
        else participantsNames = $f18c00e15af0c7db$var$selectedParticipants.join(" vs ");
        // Get match type text
        let matchTypeText;
        let tagMatchOptionSelected = $(".tag-match-options .selected").text();
        let participantName = $("#book-singles-menu-button").hasClass("selected") ? "Person" : "Team";
        switch($f18c00e15af0c7db$var$selectedParticipants.length){
            case 1:
                matchTypeText = "";
                break;
            case 2:
                matchTypeText = tagMatchOptionSelected;
                break;
            case 3:
                matchTypeText = "Triple Threat {0}".format(tagMatchOptionSelected);
                break;
            case 4:
                matchTypeText = "Fatal 4 Way {0}".format(tagMatchOptionSelected);
                break;
            case 5:
                matchTypeText = "5 Way {0}".format(tagMatchOptionSelected);
                break;
            case 6:
                matchTypeText = "6 Way {0}".format(tagMatchOptionSelected);
                break;
            case 7:
                matchTypeText = "7 Way {0}".format(tagMatchOptionSelected);
                break;
            case 8:
                matchTypeText = "8 Way {0}".format(tagMatchOptionSelected);
                break;
            case 9:
                matchTypeText = "9 Way {0}".format(tagMatchOptionSelected);
                break;
            case 10:
                matchTypeText = "10 Way {0}".format(tagMatchOptionSelected);
                break;
            default:
                matchTypeText = $f18c00e15af0c7db$var$selectedParticipants.length + " " + participantName;
        }
        if (tournament) matchTypeText = $f18c00e15af0c7db$var$selectedParticipants.length + " " + participantName;
        // Get match participants text
        let matchParticipantsText;
        let suffix = tournament ? "Tournament" : "Match";
        let selectedGimmickMatchName = $f18c00e15af0c7db$var$selectedGimmickMatch ? $f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-name") : null;
        if (selectedGimmickMatchName) {
            if (matchTypeText) matchParticipantsText = "{0} ({1} {2} {3})".format(participantsNames, matchTypeText, selectedGimmickMatchName, suffix);
            else matchParticipantsText = "{0} ({1} {2})".format(participantsNames, selectedGimmickMatchName, suffix);
        } else if (matchTypeText) matchParticipantsText = "{0} ({1} {2})".format(participantsNames, matchTypeText, suffix);
        else matchParticipantsText = "{0}".format(participantsNames);
        // Get 'add' button (if multi person selected) and tournament size confirm
        let tournamentSizeConfirm = "";
        let addButton = "";
        if ($("#multi-match-button").hasClass("selected")) {
            if ($f18c00e15af0c7db$var$selectedParticipants.length > 1 && !tournament) addButton = '<button type="button" id="add-match-button" class="button retro-button blue-button-background condensed display-block margin-top-5">Book</button>';
            else {
                let tournamentType = $("#tournament-type").val();
                if (tournamentType === "elimination") // Check for full length of tournament participants
                {
                    if ((0, $3E8Nt.isPowerOfTwo)($f18c00e15af0c7db$var$selectedParticipants.length) && $f18c00e15af0c7db$var$selectedParticipants.length > 2) tournamentSizeConfirm = '<span><i class="fa fa-check light-green margin-left-5 font-1p25em top-1px flash-color-green"></i></span>';
                } else if (tournamentType === "round-robin") {
                    // Check for minimum group participants
                    let groups = $("#number-of-groups").val();
                    if ($f18c00e15af0c7db$var$selectedParticipants.length >= groups * 4 && $f18c00e15af0c7db$var$selectedParticipants.length % groups === 0 && $f18c00e15af0c7db$var$selectedParticipants.length % 2 === 0) tournamentSizeConfirm = '<span><i class="fa fa-check light-green margin-left-5 font-1p25em top-1px flash-color-green"></i></span>';
                }
            }
        }
        // Show match participants text
        $("#multi-match-info").remove();
        $(".match-participants-container").html('<div class="font-bold" id="multi-match-info">' + matchParticipantsText + tournamentSizeConfirm + addButton + "</div>");
        // Show tournament participants
        if (tournament) $(".tournament-participants-selected").text($f18c00e15af0c7db$var$selectedParticipants.length);
    } else {
        $("#multi-match-info").remove();
        $(".match-participants-container").text("No participants selected");
    }
}
async function $f18c00e15af0c7db$var$processMatchParticipantSelection(name, $el, participantType, uid, tournament) {
    // Unselect if already selected
    if ($el.hasClass("selected")) {
        let itemIndex = $f18c00e15af0c7db$var$selectedParticipants.indexOf(name);
        $f18c00e15af0c7db$var$selectedParticipants.splice(itemIndex, 1);
        $f18c00e15af0c7db$var$selectedElements.splice(itemIndex, 1);
    }
    // Check for multi person participant limit
    let multiPerson = $("#multi-match-button").hasClass("selected");
    if (multiPerson && $f18c00e15af0c7db$var$selectedParticipants.length >= 10 && $($f18c00e15af0c7db$var$selectedGimmickMatch).attr("data-auto-picker") !== "true" && !tournament) {
        (0, $lCS03.playSoundEffect)("error");
        notie.alert({
            type: 3,
            text: "You can't select more than 10 Participants"
        });
        return false;
    }
    // Select participant
    if (!$el.hasClass("selected")) {
        $f18c00e15af0c7db$var$selectedParticipants.push(name);
        $f18c00e15af0c7db$var$selectedElements.push($el);
    }
    $el.toggleClass("selected");
    // Update participants text
    $f18c00e15af0c7db$var$updateMatchParticipantsText();
    // Check to add match if multi person not selected or open challenge
    let matchParticipantsRequired = 2;
    if ($f18c00e15af0c7db$var$selectedGimmickMatch && $f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-consequence") === "random-opponent") matchParticipantsRequired = 1;
    let addMatchCalled = false; // helps not run booking selection info if add match has error, since $el will still have selected class
    if (!multiPerson || matchParticipantsRequired === 1) {
        if ($f18c00e15af0c7db$var$selectedParticipants.length === matchParticipantsRequired) {
            await $f18c00e15af0c7db$var$callAddMatch();
            addMatchCalled = true;
        }
    }
    // Show information for selected participant (feuds, teams/factions)
    $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
    $(".superstar-select-feud-details").remove();
    if ($f18c00e15af0c7db$var$selectedParticipants.length > 0 && $el.hasClass("selected") && !addMatchCalled) await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingSelectionInformation), {
        uid: uid,
        participantType: participantType
    }, $f18c00e15af0c7db$var$showGetBookingSelectionInformationData, {}, false, true, false);
}
async function $f18c00e15af0c7db$var$processSinglesTagMatchParticipantSelection(name, $el, participantType, uid) {
    // Add and remove superstars
    if (jQuery.inArray(name, $f18c00e15af0c7db$var$selectedParticipants) === -1) {
        // Get maximum superstars
        let maximumSuperstars;
        if ($f18c00e15af0c7db$var$handicapSize) maximumSuperstars = $f18c00e15af0c7db$var$handicapSize.reduce(function(acc, val) {
            return acc + val;
        }, 0);
        else maximumSuperstars = $f18c00e15af0c7db$var$tagTeamSize * 10;
        // Add superstar
        if ($f18c00e15af0c7db$var$selectedParticipants.length < maximumSuperstars) {
            $f18c00e15af0c7db$var$selectedParticipants.push(name);
            $f18c00e15af0c7db$var$selectedElements.push($el);
            $el.toggleClass("selected");
        } else if ($f18c00e15af0c7db$var$handicapSize) notie.alert({
            type: 3,
            text: "You can't select more than " + maximumSuperstars + " Superstars in this Match"
        });
        else notie.alert({
            type: 3,
            text: "You can't select more than 10 Teams"
        });
    } else {
        let itemIndex = $f18c00e15af0c7db$var$selectedParticipants.indexOf(name);
        $f18c00e15af0c7db$var$selectedParticipants.splice(itemIndex, 1);
        $f18c00e15af0c7db$var$selectedElements.splice(itemIndex, 1);
        $el.removeClass("selected");
    }
    // Format teams
    $f18c00e15af0c7db$var$teams = [];
    // If handicap match, get two teams using handicap size
    if ($f18c00e15af0c7db$var$handicapSize) {
        let teamA = $f18c00e15af0c7db$var$selectedParticipants.slice(0, $f18c00e15af0c7db$var$handicapSize[0]);
        let teamB = $f18c00e15af0c7db$var$selectedParticipants.slice($f18c00e15af0c7db$var$handicapSize[0], $f18c00e15af0c7db$var$handicapSize[0] + $f18c00e15af0c7db$var$handicapSize[1]);
        $f18c00e15af0c7db$var$teams.push(teamA);
        if (teamB.length > 0) $f18c00e15af0c7db$var$teams.push(teamB);
    } else {
        let i, j, chunk = $f18c00e15af0c7db$var$tagTeamSize;
        for(i = 0, j = $f18c00e15af0c7db$var$selectedParticipants.length; i < j; i += chunk){
            let team = $f18c00e15af0c7db$var$selectedParticipants.slice(i, i + chunk);
            $f18c00e15af0c7db$var$teams.push(team);
        }
    }
    // Update participants text
    $f18c00e15af0c7db$var$updateSinglesTagMatchParticipantsText();
    // Show information for selected superstar (feuds, teams/factions)
    $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
    $(".superstar-select-feud-details").remove();
    if ($f18c00e15af0c7db$var$selectedParticipants.length > 0 && $el.hasClass("selected")) await (0, $1JSre.makeGameRequest)((0, $jpMCP.getBookingSelectionInformation), {
        uid: uid,
        participantType: participantType
    }, $f18c00e15af0c7db$var$showGetBookingSelectionInformationData, {}, false, true);
}
function $f18c00e15af0c7db$var$updateSinglesTagMatchParticipantsText() {
    // Show if more than 1 participant selected
    if ($f18c00e15af0c7db$var$selectedParticipants.length > 0) {
        // Get participants names
        let participantsNames = [];
        $f18c00e15af0c7db$var$teams.forEach(function(team) {
            participantsNames.push((0, $3E8Nt.commaSeparate)(team));
        });
        participantsNames = participantsNames.join(" vs ");
        // Get match type text
        let matchTypeText;
        if ($f18c00e15af0c7db$var$handicapSize) matchTypeText = "{0}v{1} ".format($f18c00e15af0c7db$var$handicapSize[0], $f18c00e15af0c7db$var$handicapSize[1]);
        else {
            matchTypeText = $f18c00e15af0c7db$var$tagTeamSize * 2 + " Person ";
            if ($f18c00e15af0c7db$var$tagTeamSize === 2) {
                matchTypeText = "";
                // Add normal text for 2v2 tag match
                if ($f18c00e15af0c7db$var$selectedParticipants.length > 4) switch($f18c00e15af0c7db$var$selectedParticipants.length / 2){
                    case 3:
                        matchTypeText = "Triple Threat ";
                        break;
                    case 4:
                        matchTypeText = "Fatal 4 Way ";
                        break;
                    case 5:
                        matchTypeText = "5 Way ";
                        break;
                    case 6:
                        matchTypeText = "6 Way ";
                        break;
                    case 7:
                        matchTypeText = "7 Way ";
                        break;
                    case 8:
                        matchTypeText = "8 Way ";
                        break;
                    case 9:
                        matchTypeText = "9 Way ";
                        break;
                    case 10:
                        matchTypeText = "10 Way ";
                        break;
                }
            }
        }
        // Get match participants text
        let matchParticipantsText;
        let selectedGimmickMatchName = $f18c00e15af0c7db$var$selectedGimmickMatch ? $f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-name") : null;
        if (selectedGimmickMatchName) matchParticipantsText = "{0} ({1}Tag {2} Match)".format(participantsNames, matchTypeText, selectedGimmickMatchName);
        else matchParticipantsText = "{0} ({1}Tag Match)".format(participantsNames, matchTypeText);
        // Check for full length of larger tag
        let tagTeamSizeConfirm = "";
        if ($f18c00e15af0c7db$var$handicapSize) {
            let maximumSuperstars = $f18c00e15af0c7db$var$handicapSize.reduce(function(acc, val) {
                return acc + val;
            }, 0);
            if ($f18c00e15af0c7db$var$selectedParticipants.length === maximumSuperstars) tagTeamSizeConfirm = '<span><i class="fa fa-check light-green margin-left-5 font-1p25em top-1px flash-color-green"></i></span>';
        } else if ($f18c00e15af0c7db$var$selectedParticipants.length % $f18c00e15af0c7db$var$tagTeamSize === 0 && $f18c00e15af0c7db$var$selectedParticipants.length > $f18c00e15af0c7db$var$tagTeamSize) tagTeamSizeConfirm = '<span><i class="fa fa-check light-green margin-left-5 font-1p25em top-1px flash-color-green"></i></span>';
        // Get 'add' button
        let addButton = "";
        if ($f18c00e15af0c7db$var$selectedParticipants.length > 1) addButton = '<button type="button" id="add-match-button" class="button retro-button blue-button-background condensed display-block margin-top-5">Book</button>';
        // Show match participants text
        $("#multi-match-info").remove();
        $(".match-participants-container").html('<div class="font-bold"  id="multi-match-info">' + matchParticipantsText + tagTeamSizeConfirm + addButton + "</div>");
    } else {
        $("#multi-match-info").remove();
        $(".match-participants-container").text("No participants selected");
    }
}
async function $f18c00e15af0c7db$var$callAddMatch() {
    // Get match type
    let matchType = $("#book-singles-menu-button").hasClass("selected") ? "singles" : "tag";
    let tagMatchOptionSelected = $(".tag-match-options .selected").text();
    let singlesTag = [
        "2v2",
        "3v3",
        "4v4",
        "5v5",
        "1v2",
        "1v3",
        "2v3",
        "?v?"
    ].indexOf(tagMatchOptionSelected) > -1;
    // If larger tag / handicap match, check if correct number of superstars selected
    if (singlesTag) {
        if ($f18c00e15af0c7db$var$handicapSize) {
            // Check if correct number of superstars selected for handicap match
            let size = $f18c00e15af0c7db$var$handicapSize.reduce(function(acc, val) {
                return acc + val;
            }, 0);
            if ($f18c00e15af0c7db$var$selectedParticipants.length !== size) {
                notie.alert({
                    type: 3,
                    text: "You need to select " + size + " Superstars for this Match"
                });
                return false;
            }
        } else {
            // Check if superstars are a multiple of and greater than team size
            let size = parseInt($f18c00e15af0c7db$var$tagTeamSize);
            if ($f18c00e15af0c7db$var$selectedParticipants.length % size !== 0 || $f18c00e15af0c7db$var$selectedParticipants.length <= size) {
                notie.alert({
                    type: 3,
                    text: "You need to add " + size + " Superstars for each Team in this Match"
                });
                return false;
            }
        }
    }
    // Validate event selected for gimmick match with match contract
    if ($f18c00e15af0c7db$var$selectedGimmickMatch && $f18c00e15af0c7db$var$selectedGimmickMatch.find("#match_event").length > 0 && !$f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-event-uid")) {
        notie.alert({
            type: 3,
            text: "Select an event for this match contract to be held at"
        });
        $f18c00e15af0c7db$var$selectedGimmickMatch[0].scrollIntoView();
        $f18c00e15af0c7db$var$selectedGimmickMatch.find("#match_event").addClass("highlight");
        return false;
    }
    // Get gimmick match options
    let matchEventUid;
    let gimmickMatchObject = false;
    let fallGimmickNames = [];
    let refereeUid;
    if ($f18c00e15af0c7db$var$selectedGimmickMatch) {
        matchEventUid = parseInt($f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-event-uid"));
        gimmickMatchObject = $f18c00e15af0c7db$var$selectedGimmickMatch.find(".gimmick-match-generate-object-button").length > 0;
        fallGimmickNames = Array.from($f18c00e15af0c7db$var$selectedGimmickMatch.find(".match-fall-select"), function(x) {
            return $(x).val();
        });
        refereeUid = parseInt($f18c00e15af0c7db$var$selectedGimmickMatch.find(".match-referee-select").val());
    }
    // Get participants data
    let participantsData = [];
    $f18c00e15af0c7db$var$selectedElements.forEach(function(selection) {
        let $selectionElement = $(selection);
        participantsData.push({
            "name": $selectionElement.attr("data-name"),
            "type": $selectionElement.attr("data-type"),
            "uid": parseInt($selectionElement.attr("data-uid"))
        });
    });
    // Get selected championship and gimmick match
    let selectedChampionshipUid = $f18c00e15af0c7db$var$selectedChampionship ? parseInt($f18c00e15af0c7db$var$selectedChampionship.attr("data-uid")) : null;
    let selectedGimmickMatchUid = $f18c00e15af0c7db$var$selectedGimmickMatch ? parseInt($f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-uid")) : null;
    let selectedGimmickMatchName = $f18c00e15af0c7db$var$selectedGimmickMatch ? $f18c00e15af0c7db$var$selectedGimmickMatch.attr("data-name") : null;
    // Reset search, scroll to selected element
    if ($(".superstar-search-input").val()) {
        $(".superstar-search-input").val("").trigger("input");
        let $container = $("#booking-talent-container"), $scrollTo = $f18c00e15af0c7db$var$selectedElements[0];
        $container.scrollTop($scrollTo.offset().top - $container.offset().top + $container.scrollTop());
    }
    await (0, $1JSre.makeGameRequest)((0, $6RCLU.addMatch), {
        participantsData: participantsData,
        selectedGimmickMatchUid: selectedGimmickMatchUid,
        selectedGimmickMatchName: selectedGimmickMatchName,
        selectedChampionshipUid: selectedChampionshipUid,
        matchEventUid: matchEventUid,
        gimmickMatchObject: gimmickMatchObject,
        fallGimmickNames: fallGimmickNames,
        refereeUid: refereeUid,
        tagTeamSize: $f18c00e15af0c7db$var$tagTeamSize,
        handicapSize: $f18c00e15af0c7db$var$handicapSize,
        singlesTag: singlesTag,
        matchType: matchType,
        tagMatchOptionSelected: tagMatchOptionSelected
    }, $f18c00e15af0c7db$var$showAddMatchData, {
        matchType: matchType,
        singlesTag: singlesTag
    }, false);
}
function $f18c00e15af0c7db$var$showAddMatchData({ data: data, matchType: matchType, singlesTag: singlesTag } = {}) {
    if (!data["error"]) {
        // Add match to event card
        let matchHtml = (0, $1145891c855e0e78$export$1b746ece54537942)(data["match"]);
        $("#matches").append(matchHtml);
        // Remove selected title
        if ($f18c00e15af0c7db$var$selectedChampionship) $f18c00e15af0c7db$var$selectedChampionship.fadeOut();
        // Lower opacity of selected elements
        if (matchType === "singles" || singlesTag) $f18c00e15af0c7db$var$selectedElements.forEach(function(x) {
            $(x).addClass("booked");
        });
        // Reset event card
        $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Show alignment boost
        let notieText = '<span class="display-block">Match Added </span>';
        if (data["alignmentBoost"]) {
            let alignmentBoost = data["alignmentBoost"];
            if (alignmentBoost < 0) alignmentBoost = '<span class="display-block red">- ' + alignmentBoost * -1 + " Alignment Boost" + "</span>";
            else alignmentBoost = '<span class="display-block green">+ ' + alignmentBoost + " Alignment Boost" + "</span>";
            notieText += alignmentBoost;
        }
        // Show gimmick restriction applied for championships
        if (data["gimmickRestrictedChampionships"]) data["gimmickRestrictedChampionships"].forEach(function(championship) {
            let gimmickRestrictedChampionshipText = (0, $1JSre.getChampionshipGimmickRestrictionInfoHtml)(championship);
            notieText += gimmickRestrictedChampionshipText;
        });
        // Show notifications
        if (notieText) {
            $(".notie-textbox-inner").text("");
            notie.alert({
                type: 4,
                text: notieText,
                stay: false,
                prepend: true
            });
        }
        // Update match limits
        let matchLimitsHtml = (0, $1145891c855e0e78$export$30265932b480a0df)();
        $("#match-limits").html(matchLimitsHtml);
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        if (matchType === "singles") (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("add_singles_match");
        else (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("add_tag_team_match");
    } else {
        if (data["error"] === "same") notie.alert({
            type: 3,
            text: "Participants can't face themselves"
        });
        else if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to add that gimmick match"
        });
        else if (data["error"] === "match-and-segment-limit") notie.alert({
            type: 3,
            text: "You can't book more than " + data["limit"] + " matches/segments at this event"
        });
        else if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "One of the participants selected could not be found. Please try again."
        });
        else if (data["error"] === "championship-not-found") notie.alert({
            type: 3,
            text: "The selected championship could not be found. Please try again."
        });
        else if (data["error"] === "gimmick-match-not-found") notie.alert({
            type: 3,
            text: "The selected gimmick match could not be found. Please try again."
        });
        else if (data["error"] === "match-contract-exists") notie.alert({
            type: 3,
            text: "A match contract with that name already exists. You can book another one after using it."
        });
        else if (data["error"] === "cashin-contract-exists") notie.alert({
            type: 3,
            text: "A cash-in contract with that name already exists. You can book another one after using it."
        });
        else if (data["error"] === "2/3-falls-one-on-one") notie.alert({
            type: 3,
            text: " Falls can only be used in one on one matches"
        });
        else if (data["error"] === "graphics-not-present") notie.alert({
            type: 3,
            text: "This match requires graphics to be present for all participants"
        });
        else if (data["error"] === "hair-not-present") notie.alert({
            type: 3,
            text: "This match requires hair to be present for all participants"
        });
        else if (data["error"] === "hair-present") notie.alert({
            type: 3,
            text: "This match requires hair to not be present for all participants"
        });
        else if (data["error"] === "mask-not-present") notie.alert({
            type: 3,
            text: "This match requires a mask to be present for all participants"
        });
        else if (data["error"] === "mask-and-hair-not-present") notie.alert({
            type: 3,
            text: "This match requires one participant with a mask and one with hair present"
        });
        else if (data["error"] === "no-women-allowed") notie.alert({
            type: 3,
            text: "Women are not allowed to be booked at this event"
        });
        else if (data["error"] === "no-men-allowed") notie.alert({
            type: 3,
            text: "Men are not allowed to be booked at this event"
        });
        else if (data["error"] === "production-packages-only") notie.alert({
            type: 3,
            text: "You can only book Production Segments at this Event"
        });
        else if (data["error"] === "gimmick-restriction") {
            let gimmickRestrictedChampionship = data["gimmickRestrictedChampionship"];
            let notieText = (0, $1JSre.getChampionshipGimmickRestrictionInfoHtml)(gimmickRestrictedChampionship);
            notie.alert({
                type: 3,
                text: notieText
            });
        } else if (data["error"] === "olympus-mons-already-booked") notie.alert({
            type: 3,
            text: "Only one Olympus Mons match can be booked at the event"
        });
        else if (data["error"] === "femme-fatale-men") notie.alert({
            type: 3,
            text: "Only women can be booked in this match"
        });
        else if (data["error"] === "referee-in-match") notie.alert({
            type: 3,
            text: "The referee cannot be part of the match"
        });
        else if (data["error"] === "not-available") notie.alert({
            type: 3,
            text: "Team members are not available"
        });
        else if (data["error"] === "duplicate-superstar") notie.alert({
            type: 3,
            text: data["duplicateSuperstar"] + " was booked more than once in the Match"
        });
        else if (data["error"] === "max-team-size") notie.alert({
            type: 3,
            text: "You can't book a team of more than " + data["maxTeamSize"] + " superstars"
        });
    }
    // Unselect selected elements
    $f18c00e15af0c7db$var$selectedElements.forEach(function(x) {
        $(x).toggleClass("selected");
    });
    // Unselect selected championship
    if ($f18c00e15af0c7db$var$selectedChampionship) $f18c00e15af0c7db$var$selectedChampionship.removeClass("selected");
    // Reset selections
    $f18c00e15af0c7db$var$selectedParticipants = [];
    $f18c00e15af0c7db$var$selectedElements = [];
    $f18c00e15af0c7db$var$selectedGimmickMatch = "";
    $f18c00e15af0c7db$var$selectedChampionship = "";
    // Reset ui
    $(".match-participants-container").text("No participants selected");
    $("#multi-match-info").remove();
    $(".feud-container").show().removeClass("selected");
    $(".book-match-feuds-container").scrollTop($(".book-match-feuds-container").data("scrollTop"));
    $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
    $(".superstar-select-feud-details").remove();
    $("#show-gimmick-matches-button").removeClass("selected").find(".fa").removeClass("fa-minus-circle").addClass("fa-plus-circle");
    $("#select-gimmick-match-container").hide();
}
function $f18c00e15af0c7db$var$getAutoPickerHtml() {
    let autoPickPronounFilter = "";
    let autoPickBookedFilter = "";
    let singlesOptions = "";
    if ($("#book-singles-menu-button").hasClass("selected")) {
        autoPickPronounFilter = '<select name="auto-pick-pronoun-filter" id="auto-pick-pronoun-filter" class="styled-select margin-right-5"><option value="0" selected>All Pronouns</option><option value="1">He</option><option value="2">She</option><option value="3">They</option></select>';
        autoPickBookedFilter = '<select name="auto-pick-booked-filter" id="auto-pick-booked-filter" class="styled-select margin-right-5"><option value="0" selected>Not Booked</option><option value="1">All</option></select>';
        singlesOptions = '<option value="1">M. Event - U. Midcard</option><option value="2">Upper Midcard</option><option value="3">U. Midcard - L. Midcard</option><option value="4">Lower Midcard</option>';
    }
    return '<div id="auto-picker" class="font-bold margin-top-12"><input type="number" id="auto-pick-input" class="auto-pick-input" name="auto-picker-value" value="30" min="8"><select name="auto-pick-from" id="auto-pick-sort" class="margin-left-5 styled-select margin-right-5"><option value="0" selected>Top</option>' + singlesOptions + '<option value="5">Bottom</option>' + '<option value="6">Random</option>' + "</select>" + autoPickPronounFilter + autoPickBookedFilter + '<button type="button" id="auto-pick" class="button retro-button condensed blue-button-background margin-top-7">' + "Auto Pick" + "</button>" + "</div>";
}
function $f18c00e15af0c7db$var$showGetBookingGimmickMatchesData({ data: data, scrollDiv: scrollDiv, newDiv: newDiv, eventCard: eventCard } = {}) {
    data["availableGimmickMatches"].forEach(function(gimmickMatch) {
        let gimmickMatchHtml = $f18c00e15af0c7db$var$getBookingGimmickMatchHtml(gimmickMatch, data);
        $(scrollDiv).append(gimmickMatchHtml);
    });
    // Unavailable gimmick matches
    let lockedText = "Locked: Unlocked with Gimmick Match Prestige";
    data["unavailableGimmickMatches"].forEach(function(gimmickMatch) {
        let gimmickMatchName = gimmickMatch["name"];
        if (gimmickMatchName.length > 13) gimmickMatchName = gimmickMatchName.slice(0, 13) + ".";
        let unlockedBy = (0, $1JSre.getGimmickMatchUnlockedBy)(gimmickMatch["name"]);
        let unlockText = " (by getting Gold Prestige on " + unlockedBy + " Match)";
        if (!unlockedBy) unlockText = "";
        let gimmickDiv = '<div class="gimmick-match-item disabled help-text" title="' + lockedText + unlockText + '">' + "<span>" + gimmickMatchName + '<span class="blue float-right">' + '<img alt="Points"  src="static/www/static/cp_icon.png" class="margin-left-5 points-image-small"/> ' + "???" + "</span>" + "</span>" + "</div>";
        $(scrollDiv).append(gimmickDiv);
    });
    if (data["availableGimmickMatches"].length === 0 && data["unavailableGimmickMatches"].length === 0) {
        let div = '<span class="display-block medium-dark-grey font-bold font-0p925em">No Gimmick Matches Available</span>';
        $(scrollDiv).append(div);
    }
    // Move container to left column
    $("#select-gimmick-match-container").detach().prependTo(".game-content-left-column");
    if (eventCard) {
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        // Move container to right column
        $("#select-gimmick-match-container").detach().appendTo(".game-content-right-column");
    }
    // Show gimmick matches
    $(newDiv).append(scrollDiv);
    $("#select-gimmick-match-container").html(newDiv).fadeIn("fast");
    $(".gimmick-matches-container-scroll").scrollTop(0);
    if (eventCard) {
        $("#select-gimmick-match-container")[0].scrollIntoView();
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_add_gimmick");
    }
}
function $f18c00e15af0c7db$var$getBookingGimmickMatchHtml(gimmickMatch, data) {
    let gimmickDiv;
    // Set level
    let level;
    switch(gimmickMatch["level"]){
        case 1:
            level = '<i class="fa fa-star-o gimmick-match-level-icon bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o gimmick-match-level-icon silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o gimmick-match-level-icon gold-light"></i>';
            break;
    }
    // Set boosts
    let rating, pop, injury;
    rating = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch["ratingBoost"]);
    if (gimmickMatch["ratingBoost"] < 3) rating += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch["ratingBoost"]);
    pop = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch["popularityBoost"]);
    if (gimmickMatch["popularityBoost"] < 3) pop += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch["popularityBoost"]);
    injury = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch["injuryRate"]);
    if (gimmickMatch["injuryRate"] < 3) injury += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch["injuryRate"]);
    let fatigueHtml = "";
    if ((0, $98xmD.globals).game.settings["enable_fatigue"] !== false) {
        let fatigueText = '<span class="gimmick-match-fatigue-value"><span class="margin-right-2">+</span>' + gimmickMatch["fatigueChange"] + '<span class="margin-left-2">%</span></span>';
        fatigueHtml = '<div class="medium-grey"><span class="gimmick-match-label">Fatigue</span> ' + fatigueText + "</div>";
    }
    let specialMatchHtml = "";
    let dataConsequence = "";
    if (gimmickMatch["cashinContractName"]) specialMatchHtml = '<span class="display-block gold margin-top-5">Cash-in Contract</span>';
    else if (gimmickMatch["matchContractName"]) specialMatchHtml = '<span class="display-block gold margin-top-5">Fixed Match Contract</span>';
    else if (gimmickMatch["consequence"] === "loser_unavailable") specialMatchHtml = '<span class="display-block light-grey margin-top-5">Loser Unavailable</span>';
    else if (gimmickMatch["consequence"] === "remove_hair") specialMatchHtml = '<span class="display-block light-grey margin-top-5">Remove Hair</span>';
    else if (gimmickMatch["consequence"] === "add_hair") specialMatchHtml = '<span class="display-block light-grey margin-top-5">Add Hair</span>';
    else if (gimmickMatch["consequence"] === "random_opponent") {
        specialMatchHtml = '<span class="display-block light-grey margin-top-5">Random Opponent</span>';
        dataConsequence = ' data-consequence="random-opponent"';
    } else if (gimmickMatch["consequence"] === "remove_mask") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Remove Mask</span>';
    else if (gimmickMatch["consequence"] === "remove_mask_or_hair") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Remove Mask or Hair</span>';
    else if (gimmickMatch["rules"] === "2/3_falls") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Best of Three Falls</span>';
    else if (gimmickMatch["rules"] === "special_referee") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Guest Referee</span>';
    else if (gimmickMatch["rules"] === "elimination") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Superstar Elimination</span>';
    // Add description if present
    let spanHtml;
    if (gimmickMatch["description"]) spanHtml = '<div class="gimmick-match gimmick-match-item help-text" data-uid="' + gimmickMatch["uid"] + '" data-name="' + gimmickMatch["name"].replace(/"/g, "&quot;") + '" ' + 'title="' + gimmickMatch["description"].replace(/"/g, "&quot;") + '"' + ' data-auto-picker="' + (gimmickMatch["rules"] === "battle_royal") + '"' + dataConsequence + ">";
    else spanHtml = '<div class="gimmick-match gimmick-match-item" data-uid="' + gimmickMatch["uid"] + '" data-name="' + gimmickMatch["name"].replace(/"/g, "&quot;") + '" ' + 'data-auto-picker="' + (gimmickMatch["rules"] === "battle_royal") + '"' + dataConsequence + ">";
    // Get progress to next level
    let progress;
    let levelXp;
    if (gimmickMatch["level"] < 3) {
        levelXp = Math.pow(gimmickMatch["level"], 2) * 50;
        progress = gimmickMatch["xp"] / levelXp * 100;
    } else {
        levelXp = Math.pow(2, 2) * 50;
        progress = 100;
    }
    let progressHtml = '<div class="margin-top-8 margin-bottom-3 item-progress-container display-inline-block"><div class="progress-under help-text" title="' + gimmickMatch["xp"] + " / " + levelXp + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>" + "</div>";
    let gimmickMatchName = gimmickMatch["name"];
    if (gimmickMatchName.length > 13) gimmickMatchName = gimmickMatchName.slice(0, 13) + ".";
    if (gimmickMatch["generateObject"] || gimmickMatch["generateLocation"]) {
        let placeholder;
        if (gimmickMatch["generateObject"]) placeholder = "Enter Object on the Pole";
        else if (gimmickMatch["generateLocation"]) placeholder = "Enter Location of Brawl";
        gimmickDiv = spanHtml + "<span>" + '<span class="gimmick-match-item-name">' + gimmickMatchName + "</span>" + '<span class="blue float-right">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/>' + gimmickMatch["cost"] + "</span>" + "</span>" + '<div class="gimmick-match-details margin-top-7 display-none">' + '<div class="medium-grey">' + '<input type="text" placeholder="' + placeholder + '" id="match_object" ' + 'class="match-name-input" maxlength="25">' + "</div>" + '<div class="medium-grey margin-bottom-8">' + '<button type="button" class="button retro-button condensed blue-button-background ' + 'gimmick-match-generate-object-button" ' + 'data-generate-object="' + gimmickMatch["generateObject"] + '" ' + 'data-generate-location="' + gimmickMatch["generateLocation"] + '">' + "Generate" + "</button>" + "</div>" + '<div class="medium-grey">' + '<span class="gimmick-match-label">Rating</span> ' + rating + "</div>" + progressHtml + level + "</div>" + "</div>";
    } else {
        let specialInput = "";
        if (gimmickMatch["matchContractName"]) {
            // Add select event options
            let selectOptions = "<option disabled selected value>Select Event</option>";
            data["parentEvents"].forEach(function(event) {
                selectOptions += '<option value="' + event.uid + '">' + event.name + "</option>";
            });
            specialInput = '<div class="medium-grey"><select id="match_event" class="match-event-select help-text" title="Select event to hold this match contract at">' + selectOptions + "</select>" + "</div>";
        } else if (gimmickMatch["rules"] === "2/3_falls") {
            // Add select gimmick matches options
            let selectOptions = "";
            data["multipleFallsGimmickMatches"].forEach(function(g) {
                selectOptions += "<option>" + g + "</option>";
            });
            specialInput = '<div><select class="match-fall-select"><option disabled selected value>Select First Fall</option>' + selectOptions + "</select>" + "</div>" + "<div>" + '<select class="match-fall-select"><option disabled selected value>Select Second Fall</option>' + selectOptions + "</select>" + "</div>" + "<div>" + '<select class="match-fall-select"><option disabled selected value>Select Third Fall</option>' + selectOptions + "</select>" + "</div>";
        } else if (gimmickMatch["rules"] === "special_referee") {
            // Add select gimmick matches options
            let selectOptions = "";
            data["specialRefereeSuperstars"].forEach(function(y) {
                selectOptions += '<option value="' + y["uid"] + '">' + y["name"] + "</option>";
            });
            specialInput = '<div><select class="match-referee-select"><option disabled selected value>Select Referee</option>' + selectOptions + "</select>" + "</div>";
        }
        gimmickDiv = spanHtml + "<span>" + '<span class="gimmick-match-item-name">' + gimmickMatchName + "</span>" + '<span class="blue float-right">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/>' + gimmickMatch["cost"] + "</span>" + "</span>" + '<div class="gimmick-match-details margin-top-7 display-none">' + specialInput + '<div class="medium-grey">' + '<span class="gimmick-match-label">Rating</span> ' + rating + "</div>" + '<div class="medium-grey">' + '<span class="gimmick-match-label">Pop.</span> ' + pop + "</div>" + '<div class="medium-grey">' + '<span class="gimmick-match-label">Injury</span> ' + injury + "</div>" + fatigueHtml + specialMatchHtml + progressHtml + level + "</div>" + "</div>";
    }
    return gimmickDiv;
}
function $f18c00e15af0c7db$var$showGenerateGimmickMatchData({ data: data, element: element, type: type } = {}) {
    // Add object name to input
    element.parent().prev().find(".match-name-input").val(data);
    let gimmickDiv = element.closest(".gimmick-match");
    let object;
    if (type === "object") object = data + " on a Pole";
    else if (type === "location") object = data + " Brawl";
    gimmickDiv.attr("data-name", object);
    // Update match participants text
    $f18c00e15af0c7db$var$updateMatchParticipantsText();
    $(".gimmick-match-generate-object-button").data("previous-name", data);
}
function $f18c00e15af0c7db$var$showAddGimmickMatchToMatchData({ data: data, parent: parent } = {}) {
    if (!data["error"]) {
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        // Reset
        $f18c00e15af0c7db$var$selectedGimmickMatch = "";
        // Update match
        let matchIndex = $(".event-match").index(parent);
        let matchHtml = (0, $1145891c855e0e78$export$1b746ece54537942)(data["match"], matchIndex);
        parent.replaceWith(matchHtml);
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        let notieText = "Gimmick Match added";
        notie.alert({
            type: 4,
            text: notieText
        });
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("add_gimmick_to_match");
    } else {
        if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to add that Gimmick Match"
        });
        else if (data["error"] === "match-contract-exists") notie.alert({
            type: 3,
            text: "A Match Contract with that name already exists. You can book another one after using it."
        });
        else if (data["error"] === "cashin-contract-exists") notie.alert({
            type: 3,
            text: "A cash-in contract with that name already exists. You can book another one after using it."
        });
        else if (data["error"] === "2/3-falls-one-on-one") notie.alert({
            type: 3,
            text: " Falls can only be used in one on one matches"
        });
        else if (data["error"] === "graphics-not-present") notie.alert({
            type: 3,
            text: "This match requires graphics to be present for all participants"
        });
        else if (data["error"] === "hair-not-present") notie.alert({
            type: 3,
            text: "This match requires hair to be present for all participants"
        });
        else if (data["error"] === "hair-present") notie.alert({
            type: 3,
            text: "This match requires hair to not be present for all participants"
        });
        else if (data["error"] === "mask-not-present") notie.alert({
            type: 3,
            text: "This match requires a mask to be present for all participants"
        });
        else if (data["error"] === "mask-and-hair-not-present") notie.alert({
            type: 3,
            text: "This match requires one participant with a mask and one with hair present"
        });
        else if (data["error"] === "olympus-mons-already-booked") notie.alert({
            type: 3,
            text: "Only one Olympus Mons match can be booked at the event"
        });
        else if (data["error"] === "femme-fatale-men") notie.alert({
            type: 3,
            text: "Only women can be booked in this match"
        });
        else if (data["error"] === "referee-in-match") notie.alert({
            type: 3,
            text: "The referee cannot be part of the match"
        });
        else if (data["error"] === "no-participants") notie.alert({
            type: 3,
            text: "This match cannot be added without participants"
        });
    }
}
function $f18c00e15af0c7db$var$showChangeMatchOrSegmentOrderData({ data: data, matchOrSegmentDivIndex: matchOrSegmentDivIndex } = {}) {
    // Move main event label
    let mainEventLabel = $("#matches").find(".main-event-label");
    if (mainEventLabel.length > 0) mainEventLabel.prependTo($(".event-match").eq(0).find(".event-match-column-left"));
    // Tutorial action check
    if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
    // Tutorial action check
    if (matchOrSegmentDivIndex === 0) (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("move_match_to_main_event");
}
function $f18c00e15af0c7db$var$showGetMatchChampionshipsForSelectionData({ data: data, matchUid: matchUid } = {}) {
    (0, $1JSre.hideEventCardContent)($("#event-card"));
    $(".match-championships-container").html("");
    $("#match-championships-selection-container").data("match-uid", matchUid);
    data["championships"].forEach(function(championship) {
        let selectedClass = "";
        if (championship["present"]) selectedClass = " selected";
        let div = '<div class="inner-box-item match-championships-item font-bold' + selectedClass + '" data-uid="' + championship["uid"] + '">' + championship["name"] + "</div>";
        $(".match-championships-container").append(div);
    });
    $("#match-championships-selection-container").hide().fadeIn("fast");
    $("#match-championships-selection-container")[0].scrollIntoView();
}
function $f18c00e15af0c7db$var$showChangeMatchChampionshipsData({ data: data, matchUid: matchUid } = {}) {
    if (!data["error"]) {
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        // Get match element, replace
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $(".event-match").index(matchElement);
        let matchHtml = (0, $1145891c855e0e78$export$1b746ece54537942)(data["match"], matchIndex);
        matchElement.replaceWith(matchHtml);
        // Add champion labels
        $f18c00e15af0c7db$var$addMatchChampionshipLabels(data["championships"], matchElement);
        if ($("#book-tag-team-menu-button").hasClass("selected")) setTimeout(function() {
            $(".tag-match-options").find(".selected").trigger("click");
        }, 50);
        else setTimeout(function() {
            $("#booking-menu").find(".selected").trigger("click");
        }, 50);
    } else {
        if (data["error"] === "gimmick-restriction") {
            let gimmickRestrictedChampionship = data["gimmickRestrictedChampionship"];
            let notieText = (0, $1JSre.getChampionshipGimmickRestrictionInfoHtml)(gimmickRestrictedChampionship);
            notie.alert({
                type: 3,
                text: notieText
            });
        } else if (data["error"] === "already-booked") {
            let championshipVerb = data["championshipTag"] ? "are" : "is";
            notie.alert({
                type: 3,
                text: "{0} {1} already booked in another match".format(data["championshipName"], championshipVerb)
            });
        }
    }
}
function $f18c00e15af0c7db$var$showRemoveChampionshipFromMatchData({ parent: parent } = {}) {
    $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
    (0, $1JSre.hideEventCardContent)($("#event-card"));
    // Remove 'remove title' button
    parent.find(".event-card-match-remove-championship-button").remove();
    parent.find(".match-championship-name").remove();
    // Remove champion label
    $f18c00e15af0c7db$var$addMatchChampionshipLabels([], parent);
    if ($("#book-singles-menu-button").hasClass("selected") || $("#book-tag-team-menu-button").hasClass("selected")) {
        if ($("#book-tag-team-menu-button").hasClass("selected")) setTimeout(function() {
            $(".tag-match-options").find(".selected").trigger("click");
        }, 50);
        else setTimeout(function() {
            $("#booking-menu").find(".selected").trigger("click");
        }, 50);
    }
}
function $f18c00e15af0c7db$var$addMatchChampionshipLabels(championships, matchElement) {
    // Add champion label for each championship
    let championNames = Array.from(championships, function(championship) {
        return championship["holder"];
    });
    // Go through each match participant
    matchElement.find(".event-card-match-participant").each(function(i, el) {
        // Check if champion
        let participantDiv = $(el).find(".event-card-match-participant-name");
        let participantChampionLabelDiv = $(el).find(".event-card-champion-label");
        let participantName = participantDiv.text();
        if (championNames.indexOf(participantName) >= 0) // Add champion label if not already added
        {
            if (participantChampionLabelDiv.length <= 0) participantDiv.after('<span class="light-grey margin-left-3 font-15px top--1px event-card-champion-label">(c)</span>');
        } else // If not champion, remove champion label
        participantChampionLabelDiv.remove();
    });
}
function $f18c00e15af0c7db$var$showGetAvailableFeudsForMatchData({ data: data, matchUid: matchUid, matchType: matchType, isSegment: isSegment } = {}) {
    if (!data["error"]) {
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        const $feudItemsContainer = $("#feud-items-container");
        $feudItemsContainer.html("");
        $feudItemsContainer.attr("data-uid", matchUid);
        $feudItemsContainer.attr("data-match-type", matchType);
        $feudItemsContainer.attr("data-is-segment", isSegment);
        // Add header
        $feudItemsContainer.append('<div class="margin-bottom-30">   <span class="menu-header-color font-mukta-mahee font-1p325em">Add Feud</span></div>');
        // Add scrollable container
        $feudItemsContainer.append('<div class="feud-items-container-scroll"></div>');
        // Add available and unavailable feuds
        data["availableFeudItems"].forEach(function(item) {
            let feudItemHtml = (0, $70adc4a1fd111893$export$f5ff3b2dec6c145a)(item, data["randomFeudName"], true);
            $(".feud-items-container-scroll").append(feudItemHtml);
        });
        data["unavailableFeudItems"].forEach(function(item) {
            let feudItemHtml = (0, $70adc4a1fd111893$export$131bc8800ece965d)(item, true);
            $(".feud-items-container-scroll").append(feudItemHtml);
        });
        // Show randomize feud hint
        if (!$f18c00e15af0c7db$var$randomizeFeudHintShown) {
            $f18c00e15af0c7db$var$randomizeFeudHintShown = true;
            notie.alert({
                type: 4,
                text: '<span class="display-block">Click the <i class="fa fa-refresh grey"></i> button to randomize the Feud name or add your own</span>'
            });
        }
        $feudItemsContainer.hide().fadeIn("fast");
        $feudItemsContainer[0].scrollIntoView();
        $(".feud-items-container-scroll").scrollTop(0);
        // Adjust custom feud name input's width
        $("#feud-items-container .feud-item-custom-name").trigger("input");
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_add_feud");
    } else {
        if (data["error"] === "match-not-found") notie.alert({
            type: 3,
            text: "Match not found. Please try again.",
            stay: true
        });
        if (data["error"] === "segment-not-found") notie.alert({
            type: 3,
            text: "Segment not found. Please try again.",
            stay: true
        });
        if (data["error"] === "superstar-and-team") notie.alert({
            type: 3,
            text: "Superstars cannot feud with teams.",
            stay: true
        });
        if (data["error"] === "temporary-team") notie.alert({
            type: 3,
            text: "Feuds cannot be created with temporary Teams.",
            stay: true
        });
        if (data["error"] === "faction-vs-non-faction") notie.alert({
            type: 3,
            text: "Factions can only feud with other factions.",
            stay: true
        });
    }
}
function $f18c00e15af0c7db$var$showAddFeudToMatchData({ data: data, matchOrSegmentUid: matchOrSegmentUid } = {}) {
    if (!data["error"]) {
        $("#feud-items-container").html("").hide();
        $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
        let parent = $('.event-match[data-uid="' + matchOrSegmentUid + '"]');
        // Add remove feud dropdown
        parent.find(".event-card-match-add-feud-button").replaceWith('<li class="event-card-match-remove-feud-button"><span>Remove Feud</span></li>');
        // Add feud name to left column
        let html = '<span class="display-block margin-top-3"><span class="faded-red-light match-feud-name">' + data["feud"]["name"] + "</span>" + "</span>";
        parent.find(".event-match-column-left").append(html);
        let notieTexts = "";
        // Show consequence applied to
        if (data["consequenceAppliedTo"]) {
            let consequenceHtml = '<span class="faded-red-light">{0}</span>'.format((0, $3E8Nt.toTitleCase)(data["feud"]["consequence"].replace(/-/g, " ")));
            notieTexts += '<span class="display-block">{0} Consequence applied to {1}</span>'.format(consequenceHtml, data["consequenceAppliedTo"]);
        }
        // Previous feud hype
        if (data["previousFeudBoost"] > 0) notieTexts += '<span class="display-block">Feud Hype will be boosted due to a previous Feud between the Participants</span>';
        else if (data["previousFeudBoost"] < 0) notieTexts += '<span class="display-block">Feud Hype will be penalized due to a previous Feud between the Participants</span>';
        if (notieTexts) notie.alert({
            type: 4,
            text: notieTexts,
            stay: true
        });
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_feud_item");
    } else {
        if (data["error"] === "match-not-found") notie.alert({
            type: 3,
            text: "Match not found. Please try again.",
            stay: true
        });
        if (data["error"] === "segment-not-found") notie.alert({
            type: 3,
            text: "Segment not found. Please try again.",
            stay: true
        });
        if (data["error"] === "feud-item-not-found") notie.alert({
            type: 3,
            text: "The selected Feud could not be found",
            stay: true
        });
    }
}
function $f18c00e15af0c7db$var$showRemoveFeudFromMatchOrSegmentData({ data: data, matchElement: matchElement } = {}) {
    if (!data["error"]) {
        $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
        (0, $1JSre.hideEventCardContent)($("#event-card"));
        // Add 'add feud' dropdown
        matchElement.find(".event-card-match-remove-feud-button").replaceWith('<li class="event-card-match-add-feud-button"><span>Add Feud</span></li>');
        matchElement.find(".match-feud-name").remove();
        // Remove deleted potential feuds
        $f18c00e15af0c7db$var$removeDeletedPotentialFeuds(data["deletedPotentialFeudUids"]);
    } else {
        if (data["error"] === "match-not-found") notie.alert({
            type: 3,
            text: "Match not found. Please try again.",
            stay: true
        });
        if (data["error"] === "segment-not-found") notie.alert({
            type: 3,
            text: "Segment not found. Please try again.",
            stay: true
        });
    }
}
function $f18c00e15af0c7db$var$showChangeFeudBlowoffData({ data: data, $el: $el, add: add = true } = {}) {
    if (add) {
        if (!data["error"]) {
            $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
            (0, $1JSre.hideEventCardContent)($("#event-card"));
            // Update match
            let matchElement = $el.closest(".event-match");
            let matchIndex = $(".event-match").index(matchElement);
            let matchHtml = (0, $1145891c855e0e78$export$1b746ece54537942)(data["match"], matchIndex);
            matchElement.replaceWith(matchHtml);
            if (data["newMatch"]) {
                let participantNames = data["participants"].join(" and ");
                let html = '<span class="display-block">' + participantNames + " have come up with a new Gimmick Match (" + '<span class="light-blue">' + data["newMatch"] + "</span>" + ") to use in their Feud Blowoff." + "</span>";
                notie.alert({
                    type: 4,
                    text: html,
                    stay: true,
                    prepend: true
                });
            }
            if (data["points"]) {
                let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
                $(".points-number").html(pointsHtml);
            }
            // Show gimmick restriction applied for championships
            let gimmickRestrictedChampionshipText = "";
            data["gimmickRestrictedChampionships"].forEach(function(championship) {
                gimmickRestrictedChampionshipText += (0, $1JSre.getChampionshipGimmickRestrictionInfoHtml)(championship);
            });
            if (gimmickRestrictedChampionshipText) {
                $(".notie-textbox-inner").text("");
                notie.alert({
                    type: 4,
                    text: gimmickRestrictedChampionshipText,
                    stay: false,
                    prepend: true
                });
            }
            // Tutorial action check
            if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
            (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("add_feud_blowoff");
        } else {
            if (data["error"] === "match-not-found") notie.alert({
                type: 3,
                text: "Match not found. Please try again.",
                stay: true
            });
            if (data["error"] === "multi-person-match") notie.alert({
                type: 3,
                text: "This feud can only be blown off in a one on one match.",
                stay: true
            });
            if (data["error"] === "singles-match-blowoff") notie.alert({
                type: 3,
                text: "This feud can only be blown off in a singles match.",
                stay: true
            });
            if (data["error"] === "tag-match-blowoff") notie.alert({
                type: 3,
                text: "This feud can only be blown off in a tag match.",
                stay: true
            });
            if (data["error"] === "trio-match-blowoff") notie.alert({
                type: 3,
                text: "This feud can only be blown off in a trios match.",
                stay: true
            });
            if (data["error"] === "faction-match-blowoff") notie.alert({
                type: 3,
                text: "This feud can only be blown off in a tag match.",
                stay: true
            });
            if (data["error"] === "blowoff-set") notie.alert({
                type: 3,
                text: "A blowoff has already been added to this feud.",
                stay: true
            });
        }
    } else {
        if (!data["error"]) {
            $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
            (0, $1JSre.hideEventCardContent)($("#event-card"));
            // Update match
            let matchElement = $el.closest(".event-match");
            let matchIndex = $(".event-match").index(matchElement);
            let matchHtml = (0, $1145891c855e0e78$export$1b746ece54537942)(data["match"], matchIndex);
            matchElement.replaceWith(matchHtml);
        } else if (data["error"] === "match-not-found") notie.alert({
            type: 3,
            text: "Match not found. Please try again.",
            stay: true
        });
    }
}
function $f18c00e15af0c7db$var$removeDeletedPotentialFeuds(feudUids) {
    for (const uid of feudUids){
        let feudElement = $('.feud-container[data-uid="' + uid + '"]');
        if (feudElement.length) feudElement.remove();
    }
    if ($(".potential-feuds-items").children(".feud-container").length <= 0) $(".potential-feuds-items").remove();
}
function $f18c00e15af0c7db$var$processUnbookedMatchSuperstars(superstarUids) {
    for (const uid of superstarUids){
        let superstarElement = $('.superstar-select[data-type="superstar"][data-uid="' + uid + '"]');
        if (superstarElement.length) superstarElement.removeClass("booked");
    }
}
function $f18c00e15af0c7db$var$processBookedMatchSuperstars(superstarUids) {
    for (const uid of superstarUids){
        let superstarElement = $('.superstar-select[data-type="superstar"][data-uid="' + uid + '"]');
        if (superstarElement.length) superstarElement.addClass("booked");
    }
}
function $f18c00e15af0c7db$var$showGetAddMatchManagerSelectionsData({ data: data, matchUid: matchUid } = {}) {
    (0, $1JSre.hideEventCardContent)($("#event-card"));
    $("#match-add-manager-container").data("match-uid", matchUid);
    // Populate participant select
    let participantSelect = $("#match-add-manager-container .match-add-manager-participant-select");
    let participantOptions = "";
    data["matchParticipants"].forEach(function(participant) {
        participantOptions += '<option value="' + participant["uid"] + '">' + participant["name"] + "</option>";
    });
    participantSelect.html(participantOptions);
    // Populate manager select
    let managerSelect = $("#match-add-manager-container .match-add-manager-manager-select");
    let managerOptionsHtml = "";
    let managerOptions = "";
    let partnerOptions = "";
    data["managerSelections"].forEach(function(manager) {
        let managerOptionHtml = '<option value="' + manager["uid"] + '">' + manager["name"] + "</option>";
        if (manager["partnerSuperstar"]) partnerOptions += managerOptionHtml;
        else managerOptions += managerOptionHtml;
    });
    managerOptionsHtml += '<optgroup label="Partners">' + partnerOptions + "</optgroup>";
    managerOptionsHtml += '<optgroup label="Superstars">' + managerOptions + "</optgroup>";
    managerSelect.html(managerOptionsHtml);
    $("#match-add-manager-container").hide().fadeIn("fast");
    $("#match-add-manager-container")[0].scrollIntoView();
}
function $f18c00e15af0c7db$var$showAddManagerToMatchData({ data: data, matchUid: matchUid } = {}) {
    if (!data["error"]) {
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $(".event-match").index(matchElement);
        let matchHtml = (0, $1145891c855e0e78$export$1b746ece54537942)(data["match"], matchIndex);
        matchElement.replaceWith(matchHtml);
        notie.alert({
            type: 4,
            text: '<div class="display-block">Manager added</div>',
            stay: false
        });
        $("#match-add-manager-container").fadeOut("fast");
    } else {
        if (data["error"] === "match-not-found") notie.alert({
            type: 3,
            text: "The Match could not found. Please try again.",
            stay: true
        });
        if (data["error"] === "participant-not-found") notie.alert({
            type: 3,
            text: "That Participant could not found. Please try again.",
            stay: true
        });
        if (data["error"] === "manager-not-found") notie.alert({
            type: 3,
            text: "That Manager could not found. Please try again.",
            stay: true
        });
        if (data["error"] === "manager-assigned") notie.alert({
            type: 3,
            text: "A Manager is already assigned to {0}. Please remove them before adding another Manager.".format(data["participantName"]),
            stay: true
        });
        if (data["error"] === "manager-in-match") notie.alert({
            type: 3,
            text: "{0} is already part of the match.".format(data["managerName"]),
            stay: true
        });
        if (data["error"] === "manager-not-available") notie.alert({
            type: 3,
            text: "{0} is not available to be booked.".format(data["managerName"]),
            stay: true
        });
    }
}
function $f18c00e15af0c7db$var$showGetRemoveMatchManagerSelectionsData({ data: data, matchUid: matchUid } = {}) {
    (0, $1JSre.hideEventCardContent)($("#event-card"));
    $("#match-remove-manager-container").data("match-uid", matchUid);
    // Populate manager select
    let managerSelect = $("#match-remove-manager-container .match-remove-manager-manager-select");
    let managerOptions = "";
    data["managerSelections"].forEach(function(manager) {
        managerOptions += '<option value="' + manager["superstarUid"] + '">' + manager["name"] + "</option>";
    });
    managerSelect.html(managerOptions);
    $("#match-remove-manager-container").hide().fadeIn("fast");
    $("#match-remove-manager-container")[0].scrollIntoView();
}
function $f18c00e15af0c7db$var$showRemoveManagerFromMatchData({ data: data, matchUid: matchUid } = {}) {
    if (!data["error"]) {
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $(".event-match").index(matchElement);
        let matchHtml = (0, $1145891c855e0e78$export$1b746ece54537942)(data["match"], matchIndex);
        matchElement.replaceWith(matchHtml);
        notie.alert({
            type: 4,
            text: '<div class="display-block">Manager removed</div>',
            stay: false
        });
        $("#match-remove-manager-container").fadeOut("fast");
    } else {
        if (data["error"] === "match-not-found") notie.alert({
            type: 3,
            text: "The Match could not found. Please try again.",
            stay: true
        });
        if (data["error"] === "superstar-not-found") notie.alert({
            type: 3,
            text: "That Manager could not found. Please try again.",
            stay: true
        });
        if (data["error"] === "manager-not-assigned") notie.alert({
            type: 3,
            text: "That Manager is not part of the match.",
            stay: true
        });
    }
}
function $f18c00e15af0c7db$var$showTrioMembersForSelection(members, membersSelected, matchUid, teamName) {
    (0, $1JSre.hideEventCardContent)($("#event-card"));
    $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
    $(".trio-members-container").html("");
    $("#trio-members-selection-container").data("match-uid", matchUid);
    $("#trio-members-selection-container").data("team-name", teamName);
    members.forEach(function(member) {
        let selectedClass = "";
        if (membersSelected.indexOf(member) >= 0) selectedClass = " selected";
        let div = '<div class="inner-box-item trio-member font-bold' + selectedClass + '">' + member + "</div>";
        $(".trio-members-container").append(div);
    });
    $("#trio-members-selection-container").hide().fadeIn("fast");
    $("#trio-members-selection-container")[0].scrollIntoView();
}
function $f18c00e15af0c7db$var$showFactionMembersForSelection(members, membersSelected, matchUid, teamName, teamSize) {
    (0, $1JSre.hideEventCardContent)($("#event-card"));
    $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
    $(".faction-members-container").html("");
    $("#faction-members-selection-container").data("match-uid", matchUid);
    $("#faction-members-selection-container").data("team-name", teamName);
    $("#faction-members-selection-container").data("team-size", teamSize);
    members.forEach(function(member) {
        let selectedClass = "";
        if (membersSelected.indexOf(member) >= 0) selectedClass = " selected";
        let div = '<div class="inner-box-item faction-member font-bold' + selectedClass + '">' + member + "</div>";
        $(".faction-members-container").append(div);
    });
    $("#faction-members-selection-container").hide().fadeIn("fast");
    $("#faction-members-selection-container")[0].scrollIntoView();
}
function $f18c00e15af0c7db$var$showChangeTrioTagTeamMembersData({ data: data, matchUid: matchUid } = {}) {
    if (!data["error"]) {
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $(".event-match").index(matchElement);
        let matchHtml = (0, $1145891c855e0e78$export$1b746ece54537942)(data["match"], matchIndex);
        matchElement.replaceWith(matchHtml);
        // Change unbooked/booked
        $f18c00e15af0c7db$var$processUnbookedMatchSuperstars(data["unbookedMatchSuperstarsUids"]);
        $f18c00e15af0c7db$var$processBookedMatchSuperstars(data["bookedMatchSuperstarsUids"]);
        // Show alignment bonus
        let notieText = '<div class="display-block">Team members changed</div>';
        if (data["alignmentBoost"]) {
            let alignmentBoost = data["alignmentBoost"];
            if (alignmentBoost < 0) alignmentBoost = '<span class="red display-block">- ' + alignmentBoost * -1 + " Alignment Boost" + "</span>";
            else alignmentBoost = '<span class="green display-block">+ ' + alignmentBoost + " Alignment Boost" + "</span>";
            notieText += alignmentBoost;
        }
        notie.alert({
            type: 4,
            text: notieText,
            stay: false
        });
        $("#trio-members-selection-container").fadeOut("fast");
    } else {
        if (data["error"] === "match-not-found") notie.alert({
            type: 3,
            text: "The Match could not be found. Please try again."
        });
        if (data["error"] === "team-not-found") notie.alert({
            type: 3,
            text: "The Team could not be found. Please try again."
        });
        if (data["error"] === "team-members-not-found") notie.alert({
            type: 3,
            text: "The selected Superstars could not be found. Please try again."
        });
        if (data["error"] === "member-not-available") notie.alert({
            type: 3,
            text: "{0} is not available to be booked".format(data["memberName"])
        });
        else if (data["error"] === "no-women-allowed") notie.alert({
            type: 3,
            text: "Women are not allowed to be booked at this event"
        });
        else if (data["error"] === "no-men-allowed") notie.alert({
            type: 3,
            text: "Men are not allowed to be booked at this event"
        });
        else if (data["error"] === "referee-in-match") notie.alert({
            type: 3,
            text: "The referee cannot be part of the match"
        });
    }
}
function $f18c00e15af0c7db$var$showChangeFactionTagTeamMembersData({ data: data, matchUid: matchUid } = {}) {
    if (!data["error"]) {
        let matchElement = $('.event-match[data-uid="' + matchUid + '"]');
        let matchIndex = $(".event-match").index(matchElement);
        let matchHtml = (0, $1145891c855e0e78$export$1b746ece54537942)(data["match"], matchIndex);
        matchElement.replaceWith(matchHtml);
        // Change unbooked/booked
        $f18c00e15af0c7db$var$processUnbookedMatchSuperstars(data["unbookedMatchSuperstarsUids"]);
        $f18c00e15af0c7db$var$processBookedMatchSuperstars(data["bookedMatchSuperstarsUids"]);
        // Show alignment bonus
        let notieText = '<div class="display-block">Team members changed</div>';
        if (data["alignmentBoost"]) {
            let alignmentBoost = data["alignmentBoost"];
            if (alignmentBoost < 0) alignmentBoost = '<span class="red display-block">- ' + alignmentBoost * -1 + " Alignment Boost" + "</span>";
            else alignmentBoost = '<span class="green display-block">+ ' + alignmentBoost + " Alignment Boost" + "</span>";
            notieText += alignmentBoost;
        }
        notie.alert({
            type: 4,
            text: notieText,
            stay: false
        });
        $("#faction-members-selection-container").fadeOut("fast");
    } else {
        if (data["error"] === "match-not-found") notie.alert({
            type: 3,
            text: "The Match could not be found. Please try again."
        });
        if (data["error"] === "team-not-found") notie.alert({
            type: 3,
            text: "The Team could not be found. Please try again."
        });
        if (data["error"] === "team-members-not-found") notie.alert({
            type: 3,
            text: "The selected Superstars could not be found. Please try again."
        });
        if (data["error"] === "member-not-available") notie.alert({
            type: 3,
            text: "{0} is not available to be booked".format(data["memberName"])
        });
        else if (data["error"] === "no-women-allowed") notie.alert({
            type: 3,
            text: "Women are not allowed to be booked at this event"
        });
        else if (data["error"] === "no-men-allowed") notie.alert({
            type: 3,
            text: "Men are not allowed to be booked at this event"
        });
        else if (data["error"] === "referee-in-match") notie.alert({
            type: 3,
            text: "The referee cannot be part of the match"
        });
    }
}
function $f18c00e15af0c7db$var$showChangeSuperstarAttireData({ data: data, $el: $el } = {}) {
    if (!data["error"]) {
        // Update current attire
        let currentAttire = String.fromCharCode(65 + data["currentAttire"]);
        $el.text(currentAttire);
        notie.alert({
            type: 4,
            text: "Attire changed for {0}".format(data["name"])
        });
    } else {
        if (data["error"] === "no-graphic") notie.alert({
            type: 3,
            text: "{0} doesn't have a graphic added".format(data["name"])
        });
        if (data["error"] === "no-alternate-attires") notie.alert({
            type: 3,
            text: "{0} doesn't have any alternate attires added".format(data["name"])
        });
    }
}
function $f18c00e15af0c7db$var$showViewRosterMemberDetailsData({ data: data, uid: uid, type: type } = {}) {
    if (type === "faction") (0, $9c7fdb096dd8e19a$export$91cd24c87164e19f)(data, false, "#booking-container");
    else (0, $d3e44747ec383890$export$bebb4c117c1f020f)(data, uid, type, false, data["scoutLevel"], "#booking-container");
}
function $f18c00e15af0c7db$var$getSimulatorCost(style) {
    let cost;
    switch(style){
        case "standard":
            cost = 10;
            return cost;
        case "long-term":
            cost = 20;
            return cost;
        case "quality":
            cost = 15;
            return cost;
        case "bizarro":
            cost = 5;
            return cost;
        case "terrible":
            cost = 2;
            return cost;
    }
}
async function $f18c00e15af0c7db$var$autoBookRequest(style, numberOption, addOption) {
    (0, $1JSre.hideEventCardContent)($("#event-card"));
    $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
    let hideBooked = $(".auto-booker-hide-booked-checkbox:checked").length > 0;
    await (0, $1JSre.makeGameRequest)((0, $f0da149825527215$export$54d5b3aa18b9b8d2), {
        style: style,
        numberOption: numberOption,
        addOption: addOption,
        hideBooked: hideBooked
    }, $f18c00e15af0c7db$var$showAutoBookEventData, {}, false);
}
function $f18c00e15af0c7db$var$showAutoBookEventData({ data: data } = {}) {
    if (!data["error"]) {
        // Add matches and segments
        if (data["matchesAndSegments"].length > 0) (0, $1145891c855e0e78$export$a23fd95a66c9ff1d)(data["matchesAndSegments"]);
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    } else {
        let error = "";
        if (data["error"] === "points") error = "You do not have enough Creative Points to use the Auto Booker";
        if (data["error"] === "already-booked") error = "Auto Booker didn't find any available space at the Event";
        if (data["error"] === "pow-cannot-replace") error = "You cannot use the Auto Booker with the replace option at this Event";
        notie.alert({
            type: 3,
            text: error
        });
    }
}
async function $f18c00e15af0c7db$var$showRunSimulatorData({ data: data, style: style, eventsToSimulate: eventsToSimulate, notificationsOption: notificationsOption, simulatorOption: simulatorOption, totalEvents: totalEvents } = {}) {
    if (!data["error"]) await $f18c00e15af0c7db$var$showSimulationUpdates(data, style, eventsToSimulate, notificationsOption, simulatorOption, totalEvents);
    else {
        let error = "";
        if (data["error"] === "points") error = "You do not have enough Creative Points to use the Simulator";
        if (data["error"] === "paid-only") error = "The Simulator can only be used with JoW Paid";
        if (data["error"] === "local-multiplayer-disabled") error = "The Simulator cannot be used in Local Multiplayer";
        if (data["error"] === "simulator") error = "There was an error simulating events.";
        // Load home page if error while simulating
        if (eventsToSimulate !== totalEvents || data["error"] === "simulator") {
            await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)(), false);
            $("#stop-simulation-button").parent().hide();
            $(".simulation-progress-loading").hide();
            notie.alert({
                type: 3,
                text: error
            });
        } else {
            $("#simulation-results-container").hide();
            $("#simulator-menu-button").trigger("click");
            notie.alert({
                type: 3,
                text: error
            });
        }
    }
}
async function $f18c00e15af0c7db$var$showSimulationUpdates(data, style, eventsToSimulate, notificationsOption, simulatorOption, totalEvents) {
    let progressDiv = $("#simulation-progress");
    let updatesDiv = $("#simulation-updates");
    let newsDiv = $("#simulation-news");
    // Notifications options
    let newsToShow = 2;
    let updatesToShow = 10;
    let showNewsContent = false;
    // Add updates
    updatesDiv.show();
    let awardsWon = data["updates"]["awardsWon"];
    let retired = data["updates"]["retired"];
    let callups = data["updates"]["callups"];
    let leftCompany = data["results"]["leftCompany"];
    let injuries = data["results"]["injuries"];
    let available = data["results"]["availableSuperstars"];
    let fotcMade = data["results"]["facesOfTheCompanyMade"];
    let fotcLost = data["results"]["facesOfTheCompanyLost"];
    let signings = data["results"]["signings"];
    let offersAccepted = data["results"]["offersAccepted"];
    let fired = data["results"]["fired"];
    let hotChanges = data["results"]["hotChanges"];
    let staleChanges = data["results"]["staleChanges"];
    let debutedGimmicks = data["results"]["debutedGimmicks"];
    if (fired) fired.forEach(function(superstar) {
        let firedDiv = '<div class="simulation-update margin-bottom-8">' + superstar["name"] + '<span class="puke-green">' + " was fired (due to booking consequence) from the company" + "</span>" + "</div>";
        updatesDiv.prepend(firedDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (signings) signings.forEach(function(signing) {
        let signingDiv = '<div class="simulation-update margin-bottom-8"><span class="blue">Signed </span>' + signing + " to the Company" + "</div>";
        updatesDiv.prepend(signingDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (offersAccepted) offersAccepted.forEach(function(offerAccepted) {
        let offerAcceptedDiv = '<div class="simulation-update margin-bottom-8"><span class="blue">Offer </span>for ' + offerAccepted["name"] + " by " + offerAccepted["company"] + " was accepted" + "</div>";
        updatesDiv.prepend(offerAcceptedDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (injuries) injuries.forEach(function(injury) {
        let injuryDiv = '<div class="simulation-update margin-bottom-8">' + injury["name"] + '<span class="dark-red">' + " suffered an injury" + "</span>" + "</div>";
        updatesDiv.prepend(injuryDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (available) available.forEach(function(superstar) {
        let availableDiv = '<div class="simulation-update margin-bottom-8">' + superstar["name"] + " ready to return" + "</div>";
        updatesDiv.prepend(availableDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (awardsWon) awardsWon.forEach(function(award) {
        let trophy = "";
        switch(award["trophy"]){
            case "worst":
                trophy = "trophy_icon_trash";
                break;
            case "bronze":
                trophy = "trophy_icon_bronze";
                break;
            case "silver":
                trophy = "trophy_icon_silver";
                break;
            case "gold":
                trophy = "trophy_icon_gold";
                break;
        }
        trophy = '<img alt="Trophy" src="static/www/static/' + trophy + '.png" class="trophy-image margin-right-8"/>';
        let awardWonDiv = '<div class="simulation-update margin-bottom-8">' + trophy + "Won the " + award["name"] + " Award" + "</div>";
        updatesDiv.prepend(awardWonDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (retired) retired.forEach(function(superstar) {
        let hof = "";
        if (superstar["hallOfFame"]) hof = ' and was inducted into the <span class="gold">Hall of Fame</span>';
        let retiredDiv = '<div class="simulation-update margin-bottom-8">' + superstar["name"] + " retired from wrestling" + hof + "</div>";
        updatesDiv.prepend(retiredDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (callups) callups.forEach(function(superstar) {
        let retiredDiv = '<div class="simulation-update margin-bottom-8"><span class="green">Called up </span>' + superstar + " to the Main Roster" + "</div>";
        updatesDiv.prepend(retiredDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (fotcMade) fotcMade.forEach(function(superstar) {
        let retiredDiv = '<div class="simulation-update margin-bottom-8">' + superstar + " became a " + '<span class="medium-blue">' + "Face of the Company" + "</span>" + "</div>";
        updatesDiv.prepend(retiredDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (fotcLost) fotcLost.forEach(function(superstar) {
        let retiredDiv = '<div class="simulation-update margin-bottom-8">' + superstar + " is no longer a Face of the Company" + "</div>";
        updatesDiv.prepend(retiredDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (leftCompany) leftCompany.forEach(function(superstar) {
        let leftCompanyDiv = '<div class="simulation-update margin-bottom-8">' + superstar + '<span class="puke-green">' + " left the company" + "</span>" + "</div>";
        updatesDiv.prepend(leftCompanyDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    hotChanges.forEach(function(hotChange) {
        let text;
        if (hotChange["status"] === "hotStart") text = hotChange["name"] + ' is starting to get <span class="hot-color">Over</span> with the Fans';
        else if (hotChange["status"] === "hotEnd") text = hotChange["name"] + ' is no longer <span class="hot-color">Over</span> with the Fans';
        else if (hotChange["status"] === "hot") text = hotChange["name"] + ' got <span class="hot-color hot-text">Over</span> with the Fans.';
        let hotChangeDiv = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + "</div>";
        updatesDiv.prepend(hotChangeDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    staleChanges.forEach(function(staleChange) {
        let text;
        if (staleChange["status"] === "staleStart") text = staleChange["name"] + ' is starting to become <span class="stale-color">Stale</span> with the Fans';
        else if (staleChange["status"] === "staleEnd") text = staleChange["name"] + ' is no longer <span class="stale-color">Stale</span> with the Fans';
        else if (staleChange["status"] === "stale") text = staleChange["name"] + ' became <span class="stale-color stale-text">Stale</span> with the Fans';
        let staleChangeDiv = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + "</div>";
        updatesDiv.prepend(staleChangeDiv);
        updatesDiv.children().first().hide().fadeIn();
    });
    if (notificationsOption === "deep") {
        updatesToShow = 16;
        newsToShow = 4;
        showNewsContent = true;
        let reviewData = data["updates"]["reviewData"];
        let createdTagTeams = data["updates"]["createdTagTeams"];
        let disbandedTagTeams = data["updates"]["disbandedTagTeams"];
        let createdTrios = data["updates"]["createdTrios"];
        let createdFactions = data["updates"]["createdFactions"];
        let createdChampionships = data["updates"]["createdChampionships"];
        let powerupsUsed = data["updates"]["powerupsUsed"];
        let releasedSuperstars = data["updates"]["releasedSuperstars"];
        let managersTransitioned = data["updates"]["managersTransitioned"];
        let managersAdded = data["updates"]["managersAdded"];
        let managersRemoved = data["updates"]["managersRemoved"];
        let brandsChanged = data["updates"]["brandsChanged"];
        let streaksEnded = data["results"]["streaksEnded"];
        if (createdTagTeams) createdTagTeams.forEach(function(tagTeam) {
            let teamSuperstars = tagTeam["superstars"].join(" and ");
            let newTagTeamDiv = '<div class="simulation-update margin-bottom-8">Created a Tag Team (' + tagTeam["name"] + ") of " + teamSuperstars + "</div>";
            updatesDiv.prepend(newTagTeamDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (disbandedTagTeams) disbandedTagTeams.forEach(function(tagTeam) {
            let disbandedTagTeamDiv = '<div class="simulation-update margin-bottom-8">Disbanded ' + tagTeam + "</div>";
            updatesDiv.prepend(disbandedTagTeamDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (createdTrios) createdTrios.forEach(function(trio) {
            let teamSuperstars = (0, $3E8Nt.commaSeparate)(trio["superstars"]);
            let newTagTeamDiv = '<div class="simulation-update margin-bottom-8">Created a Trio (' + trio["name"] + ") of " + teamSuperstars + "</div>";
            updatesDiv.prepend(newTagTeamDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (createdFactions) createdFactions.forEach(function(faction) {
            let factionSuperstars = (0, $3E8Nt.commaSeparate)(faction["superstars"]);
            let newTagTeamDiv = '<div class="simulation-update margin-bottom-8">Created a Faction (' + faction["name"] + ") of " + factionSuperstars + "</div>";
            updatesDiv.prepend(newTagTeamDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (createdChampionships) createdChampionships.forEach(function(championship) {
            let newChampionshipDiv = '<div class="simulation-update margin-bottom-8">Created the <span class="gold">' + championship + " Championship" + "</span>" + "</div>";
            updatesDiv.prepend(newChampionshipDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (releasedSuperstars) releasedSuperstars.forEach(function(superstar) {
            let releasedSuperstarDiv = '<div class="simulation-update margin-bottom-8">Released ' + superstar + " from the company" + "</div>";
            updatesDiv.prepend(releasedSuperstarDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (streaksEnded) streaksEnded.forEach(function(streak) {
            let unformattedText = '{0} ended {1}\'s {2} match <span class="obsidian">Undefeated Streak</span> at {3}';
            let streakText = unformattedText.format(streak["winner"], streak["holder"], streak["length"], streak["event"]);
            let streakDiv = '<div class="simulation-update margin-bottom-8">' + streakText + "</div>";
            updatesDiv.prepend(streakDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (powerupsUsed) powerupsUsed.forEach(function(powerup) {
            let usedOn = "";
            if (powerup["usedOn"]) usedOn = " on " + powerup["usedOn"];
            let powerupUsedDiv = '<div class="simulation-update margin-bottom-8">Used the <span class="black">' + powerup["name"] + "</span>" + " Artifact" + usedOn + "</div>";
            updatesDiv.prepend(powerupUsedDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (reviewData && Object.keys(reviewData).length !== 0) {
            let reviewText = "";
            if (reviewData["punishment"]) reviewText = '. Lost <span class="blue"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 margin-right-5"/>' + reviewData["punishment"] + "</span>" + ".";
            else if (reviewData["bonus"]) {
                reviewText = '. Gained <span class="blue"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 margin-right-5"/>' + reviewData["bonus"] + "</span>";
                if (reviewData["newMatch"]) reviewText += ' and the <span class="light-blue">' + reviewData["newMatch"] + "</span>" + " Gimmick Match";
                reviewText += ".";
            }
            let reviewDiv = '<div class="simulation-update margin-bottom-8">Completed ' + reviewData["numberOfCompletedObjectives"] + "/3 Owner Goals" + reviewText + "</div>";
            updatesDiv.prepend(reviewDiv);
            updatesDiv.children().first().hide().fadeIn();
        }
        debutedGimmicks.forEach(function(debutedGimmick) {
            let text = (0, $1JSre.getGimmickDebutHtml)(debutedGimmick, true);
            let debutedGimmickHtml = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + "</div>";
            updatesDiv.prepend(debutedGimmickHtml);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (managersTransitioned) managersTransitioned.forEach(function(superstar) {
            let managerTransitionedDiv = '<div class="simulation-update margin-bottom-8">Transitioned ' + superstar + " to a manager role" + "</div>";
            updatesDiv.prepend(managerTransitionedDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (managersAdded) managersAdded.forEach(function(managerAdded) {
            let text = '<span class="display-block">Assigned {0} to manage {1}</span>'.format(managerAdded["managerName"], (0, $3E8Nt.commaSeparate)(managerAdded["managedSuperstarsNames"]));
            let managerAddedDiv = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + "</div>";
            updatesDiv.prepend(managerAddedDiv);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (managersRemoved) managersRemoved.forEach(function(managerRemoved) {
            let text = '<span class="display-block">Removed {0} from managing {1}</span>'.format(managerRemoved["managerName"], (0, $3E8Nt.commaSeparate)(managerRemoved["removedSuperstarsNames"]));
            let managerRemovedHtml = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + "</div>";
            updatesDiv.prepend(managerRemovedHtml);
            updatesDiv.children().first().hide().fadeIn();
        });
        if (brandsChanged) brandsChanged.forEach(function(brandChanged) {
            let text = '<span class="display-block">Moved {0} to {1}</span>'.format(brandChanged["superstars"], brandChanged["brand"]);
            let brandChangedHtml = '<div class="simulation-update margin-bottom-8 dark-grey">' + text + "</div>";
            updatesDiv.prepend(brandChangedHtml);
            updatesDiv.children().first().hide().fadeIn();
        });
    }
    // Fade and remove old updates
    if (updatesDiv.children().length > updatesToShow) {
        let toRemove = updatesDiv.children().length - updatesToShow;
        updatesDiv.children().slice(-toRemove).remove();
    }
    if (updatesDiv.children().length > updatesToShow / 2) {
        let toFade = updatesDiv.children().length - updatesToShow / 2;
        updatesDiv.children().slice(-toFade).addClass("light-opaque");
    }
    // Add news
    let newsData = data["updates"]["news"];
    if ((0, $98xmD.globals).game.competitorsPresent && newsData) {
        newsDiv.show();
        let newsItems = newsData.slice(0, newsToShow / 2);
        newsItems.reverse();
        newsItems.forEach(function(news) {
            let newsHtml = (0, $e6954d9b34d9dd89$export$37886a697c58e9e2)(news, showNewsContent, true);
            let newsItemDiv = '<div class="simulation-news-item compact">' + newsHtml + "</div>";
            newsDiv.prepend(newsItemDiv);
            newsDiv.children().first().hide().fadeIn();
        });
        // Fade and remove old news
        if (newsDiv.children().length > newsToShow) {
            let toRemove = newsDiv.children().length - newsToShow;
            newsDiv.children().slice(-toRemove).remove();
        }
        if (newsDiv.children().length > newsToShow / 2) newsDiv.children().slice(-(newsToShow / 2)).addClass("light-opaque");
    } else newsDiv.hide();
    eventsToSimulate--;
    // Update progress bar/current event
    let progress;
    let currentMonth = totalEvents - eventsToSimulate;
    if (currentMonth < totalEvents) progress = currentMonth / totalEvents * 100;
    else progress = 100;
    let progressBarHtml = '<div class="progress-under margin-bottom-20"><div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>";
    let info = data["year"];
    if (data["weeklyShowName"]) info = `${data["weeklyShowName"]} ${data["year"]}`;
    let progressHtml = '<div id="simulation-progress-bar" class="margin-bottom-25">' + progressBarHtml + "</div>" + '<div id="simulation-progress-event">' + '<span class="display-block dark-grey">' + data["event"] + "</span>" + '<span class="display-block grey font-bold year">' + info + "</span>" + "</div>";
    progressDiv.html(progressHtml);
    // Update points and fans
    (0, $1JSre.updateGamePointsAndFans)(data["points"], data["fans"]);
    // Continue simulation if there are events left to simulate and 'stop simulation' button not selected
    let stopSimulation = $("#simulation-results-container").data("stopSimulation");
    if (eventsToSimulate >= 1 && !stopSimulation) setTimeout(async ()=>{
        await (0, $1JSre.makeGameRequest)((0, $f0da149825527215$export$bc91b222c7cf4008), {
            style: style,
            eventsToSimulate: eventsToSimulate,
            simulatorOption: simulatorOption
        }, $f18c00e15af0c7db$var$showRunSimulatorData, {
            style: style,
            eventsToSimulate: eventsToSimulate,
            notificationsOption: notificationsOption,
            simulatorOption: simulatorOption,
            totalEvents: totalEvents
        }, false, true, true, false);
    }, 500);
    else {
        // End simulation, load home page if game is loaded
        if ($("#game:visible").length > 0) {
            await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)(), false);
            $("#stop-simulation-button").parent().hide();
            $(".simulation-progress-loading").hide();
            notie.alert({
                type: 4,
                text: "Simulation Complete"
            });
        }
        return true;
    }
}
function $f18c00e15af0c7db$var$showGetCompanyUniqueTournamentsData({ data: data } = {}) {
    // Reset ui
    $f18c00e15af0c7db$var$selectedElements.forEach(function(x) {
        $(x).toggleClass("selected");
    });
    $f18c00e15af0c7db$var$selectedElements = [];
    $f18c00e15af0c7db$var$selectedParticipants = [];
    $f18c00e15af0c7db$var$selectedGimmickMatch = "";
    if ($f18c00e15af0c7db$var$selectedChampionship) $f18c00e15af0c7db$var$selectedChampionship.removeClass("selected");
    $f18c00e15af0c7db$var$selectedChampionship = "";
    $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
    $(".superstar-select-feud-details").remove();
    $("#multi-match-info").remove();
    $(".match-participants-container").text("No participants selected");
    $("#multi-match-button").addClass("selected");
    $("#multi-match-button").find(".fa").removeClass("fa-circle-o").addClass("fa-check-circle-o");
    $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
    $("#select-gimmick-match-container").hide();
    $(".book-match-feuds-container").hide();
    $("#show-gimmick-matches-button").hide();
    $("#add-tournament-menu-button").addClass("selected");
    (0, $1JSre.hideEventCardContent)($("#event-card"));
    // Add tournament booking html
    let tournamentBookingHtml = $f18c00e15af0c7db$var$getTournamentBookingHtml(data);
    $("#add-tournament-container").html(tournamentBookingHtml).show();
}
function $f18c00e15af0c7db$var$getTournamentBookingHtml(data) {
    // Add previous tournament select
    let previousTournamentsDiv = "";
    if (data["tournaments"].length > 0) {
        previousTournamentsDiv = '<p class="margin-bottom-10"><select id="add-tournament-select" class="styled-select help-text" title="Hold a previously held Tournament, affecting its Prestige and Win Bonus">';
        previousTournamentsDiv += '<option selected value="">Select Tournament</option>';
        data["tournaments"].forEach(function(tournament) {
            let matchContractName = "";
            if (tournament["matchContractName"]) matchContractName = tournament["matchContractName"].replace(/"/g, "&quot;");
            previousTournamentsDiv += '<option data-prestige="' + tournament["prestige"] + '" ' + 'data-cost="' + tournament["cost"] + '" data-match-contract-name="' + matchContractName + '">' + tournament["name"] + "</option>";
        });
        previousTournamentsDiv += '</select><span class="display-inline add-tournament-select-prestige"></span></p>';
    }
    // Add round robin inputs
    let numberOfGroups = '<select name="number-of-groups" id="number-of-groups" class="styled-select"><option value="1">1</option><option value="2" selected>2</option><option value="4">4</option></select>';
    let participantsAdvancing = '<select name="participants-advancing" id="participants-advancing" class="styled-select"><option value="1" selected>1</option><option value="2">2</option></select>';
    // Add match contract inputs
    let selectOptions = "";
    data["events"].forEach(function(event) {
        selectOptions += "<option>" + event + "</option>";
    });
    let awardOptions = '<label class="control control--radio margin-right-10">None<input type="radio" name="radio-award-option" value="none" checked="checked"><div class="control__indicator"></div></label><label class="control control--radio margin-right-10">Match Contract<input type="radio" name="radio-award-option" value="match-contract"><div class="control__indicator"></div></label>';
    let matchContractEventSelect = '<select id="tournament-match-contract-event" class="display-block help-text styled-select" title="Select event to hold this match contract at">' + selectOptions + "</select>";
    let matchContractNameInput = '<input type="text" id="tournament-match-contract-name" name="match-contract-name" class="margin-bottom-10 display-block styled-input help-text" placeholder="Match Contract Name" title="Enter the name to give to the created match contract e.g \'Title Match\'">';
    // Add auto picker
    let autoPickPronounFilter = "";
    let autoPickBookedFilter = "";
    let singlesOptions = "";
    if ($("#book-singles-menu-button").hasClass("selected")) {
        autoPickPronounFilter = '<select name="auto-pick-pronoun-filter" id="auto-pick-pronoun-filter" class="styled-select"><option value="0" selected>All Pronouns</option><option value="1">He</option><option value="2">She</option><option value="3">They</option></select>';
        autoPickBookedFilter = '<select name="auto-pick-booked-filter" id="auto-pick-booked-filter" class="styled-select margin-right-5"><option value="0" selected>Not Booked</option><option value="1">All</option></select>';
        singlesOptions = '<option value="1">M. Event - U. Midcard</option><option value="2">Upper Midcard</option><option value="3">U. Midcard - L. Midcard</option><option value="4">Lower Midcard</option>';
    }
    return '<div class="add-tournament-container box margin-0-auto font-bold"><div class="margin-bottom-10"><span class="font-mukta-mahee font-1p325em menu-header-color">Tournament</span><span class="blue float-right"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/> <span class="add-tournament-cost">150</span></span></div><div class="margin-bottom-15 line-height-1p4 font-0p825em grey-blue-dark"><i class="fa fa-info-circle margin-right-2"></i> Tournament will run at this Monthly Event. Any extra preliminary Matches will be held at a newly created Weekly Show before this Event.</div><div>' + previousTournamentsDiv + '<div class="margin-bottom-10">' + '<input type="text" id="tournament-name" placeholder="' + "Tournament Name" + '" ' + 'class="styled-input help-text" title="Create a new Tournament">' + "</div>" + '<div class="margin-bottom-10">' + '<select id="tournament-type" class="styled-select">' + '<option value="elimination">Elimination</option>' + '<option value="round-robin">Round Robin</option>' + "</select>" + "</div>" + '<div class="display-none round-robin-options font-0p825em">' + '<div class="margin-bottom-10">' + numberOfGroups + '<span class="number-of-groups-text"> Groups</span>' + "</div>" + '<div class="margin-bottom-10">' + participantsAdvancing + '<span class="participant-advancing-text"> Participant advances</span>' + "</div>" + "</div>" + '<div class="margin-bottom-20 font-0p825em">' + '<select class="styled-select margin-right-3 help-text" id="tournament-matches-at-event" ' + 'title="The rest of the matches will be held at Weekly Shows before the event">' + '<option value="finals">Final</option>' + '<option selected value="semi-finals">Semi-Finals</option>' + '<option value="quarter-finals">Quarter-Finals</option>' + "</select> at Event" + "</div>" + '<div class="margin-bottom-20 font-0p825em">' + '<div class="display-block margin-bottom-5 font-1p125em help-text" ' + 'title="Add an Award to be given to the Tournament winner. Create a Match Contract below or select ' + 'a Vacant Championship by clicking on it.">Award</div>' + '<div class="margin-bottom-8 award-options">' + awardOptions + "</div>" + '<div class="display-none award-options-match-contract">' + matchContractNameInput + matchContractEventSelect + "</div>" + "</div>" + '<div class="margin-bottom-8 font-0p825em help-text" ' + 'title="Select participants by clicking on them below or using the Auto Picker. You ' + 'can only select powers of 2 e.g 4/8/16/32 etc.">' + '<span class="tournament-participants-selected">' + "0</span>" + " participants selected" + "</div>" + '<div id="auto-picker" class="font-bold margin-bottom-20">' + '<select name="auto-pick-number" id="auto-pick-input" class="styled-select">' + '<option value="4">4</option>' + '<option value="8">8</option>' + '<option value="16" selected>16</option>' + '<option value="32">32</option>' + '<option value="64">64</option>' + '<option value="128">128</option>' + "</select>" + '<select name="auto-pick-from" id="auto-pick-sort" class="margin-left-5 styled-select margin-right-5">' + '<option value="0" selected>Top</option>' + singlesOptions + '<option value="5">Bottom</option>' + '<option value="6">Random</option>' + "</select>" + autoPickPronounFilter + autoPickBookedFilter + '<button type="button" id="auto-pick" data-type="tournament" class="button retro-button condensed blue-button-background margin-top-7">' + "Auto Pick" + "</button>" + "</div>" + '<div">' + '<button type="button" ' + 'class="button retro-button blue-button-background" id="create-bracket">Create Bracket</button> ' + "</div>" + '<div class="tournament-bracket-container font-bold display-none margin-top-10"></div>' + '<div class="tournament-groups-container font-bold display-none margin-bottom-20 margin-top-10"></div>' + "</div>" + "</div>";
}
function $f18c00e15af0c7db$var$setTournamentMatchesAtEvent() {
    let matchesAtEventSelect = $("#tournament-matches-at-event");
    let matchesAtEventHtml;
    if ($("#tournament-type").val() === "elimination") matchesAtEventHtml = '<option value="finals">Final</option><option selected value="semi-finals">Semi-Finals</option><option value="quarter-finals">Quarter-Finals</option>';
    else {
        let groups = $("#number-of-groups").val();
        let participantsAdvancing = $("#participants-advancing").val();
        let totalParticipantsAdvancing = parseInt(groups) * parseInt(participantsAdvancing);
        let options = [
            '<option selected value="finals">Final</option>',
            '<option value="semi-finals">Semi-Finals</option>',
            '<option value="quarter-finals">Quarter-Finals</option>'
        ];
        let optionsIndex = totalParticipantsAdvancing !== 0 ? totalParticipantsAdvancing / 2 : 0;
        if (optionsIndex === 0) matchesAtEventHtml = '<option selected value="0">Final Round</option><option value="2">Last 2 Matches</option><option value="4">Last 4 Matches</option><option value="8">Last 8 Matches</option>';
        else matchesAtEventHtml = options.slice(0, optionsIndex).join("");
    }
    matchesAtEventSelect.html(matchesAtEventHtml);
}
function $f18c00e15af0c7db$var$showGetTournamentDisplayData({ data: data, participantsData: participantsData, tournamentType: tournamentType, $el: $el }) {
    if (!data["error"]) {
        // Change create button text to 'Re-create'
        let buttonText = $el.text();
        buttonText = buttonText.replace("Create", "Re-create");
        $el.text(buttonText);
        if (tournamentType === "elimination") {
            // Add bracket
            let tournamentRound = 1;
            let tournamentRounds = Object.keys(data["bracket"]).length;
            let bracket = data["bracket"][tournamentRound];
            let bracketDiv = (0, $70adc4a1fd111893$export$d1c14a92b2f32dc8)(bracket, tournamentRound, tournamentRounds, true);
            $(".add-tournament-container").find(".tournament-bracket-container").html(bracketDiv);
            $(".tournament-bracket-container").show();
            (0, $1JSre.addTournamentParticipantsEditing)(".tournament-bracket-container");
        } else if (tournamentType === "round-robin") {
            // Add groups
            let groupsDiv = (0, $1JSre.getTournamentGroupsHtml)(data["table"], participantsData.length, true);
            $(".add-tournament-container").find(".tournament-groups-container").html(groupsDiv);
            $(".tournament-groups-container").show();
            (0, $1JSre.addTournamentParticipantsEditing)(".tournament-groups-container");
        }
        // Add create tournament button
        if (!$("#create-tournament").length) {
            let button = '<span class="margin-bottom-20 margin-left-5"><button type="button" class="button retro-button blue-button-background" id="create-tournament">Create Tournament</button> </span>';
            $(".add-tournament-container").find("#create-bracket").after(button);
        }
    } else {
        if (data["error"] === "participant-not-found") notie.alert({
            type: 3,
            text: "One of the participants selected could not be found. Please try again."
        });
        else if (data["error"] === "duplicate-participant") notie.alert({
            type: 3,
            text: "One of the participants was found more than once in the selections. Please try again."
        });
    }
}
async function $f18c00e15af0c7db$var$showCreateTournamentData({ data: data, matchType: matchType }) {
    if (!data["error"]) {
        $("#add-tournament-container").hide();
        $("#add-tournament-menu-button").toggleClass("selected");
        $("#multi-match-button").toggleClass("selected");
        $("#multi-match-button").find(".fa").removeClass("fa-check-circle-o").addClass("fa-circle-o");
        $("#show-gimmick-matches-button").show();
        $(".book-match-feuds-container").show();
        // Lower opacity of selected elements
        if (matchType === "singles") $f18c00e15af0c7db$var$selectedElements.forEach(function(x) {
            $(x).addClass("booked");
        });
        // Unselect selected elements
        $f18c00e15af0c7db$var$selectedElements.forEach(function(x) {
            $(x).toggleClass("selected");
        });
        // Unselect selected championship
        if ($f18c00e15af0c7db$var$selectedChampionship) $f18c00e15af0c7db$var$selectedChampionship.removeClass("selected");
        // Reset selections
        $f18c00e15af0c7db$var$selectedParticipants = [];
        $f18c00e15af0c7db$var$selectedElements = [];
        $f18c00e15af0c7db$var$selectedChampionship = "";
        // Reset ui
        $(".superstar-select").removeClass("current-feud potential-feud partner-superstar");
        $(".superstar-select-feud-details").remove();
        $("#multi-match-info").remove();
        $(".match-participants-container").text("No participants selected");
        $(".feud-container").show().removeClass("selected");
        // Update matches if not going to weekly show
        if (!data["weeklyShowCreated"]) {
            (0, $1145891c855e0e78$export$a23fd95a66c9ff1d)(data["matchesAndSegments"]);
            // Update points
            let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
            $(".points-number").html(pointsHtml);
        }
        // Remove selected title
        if ($f18c00e15af0c7db$var$selectedChampionship) $f18c00e15af0c7db$var$selectedChampionship.fadeOut();
        // Game loop if matches added to weekly show
        if (data["weeklyShowCreated"]) await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)());
        // Update match limits
        let matchLimitsHtml = (0, $1145891c855e0e78$export$30265932b480a0df)();
        $("#match-limits").html(matchLimitsHtml);
    } else {
        let error = "";
        if (data["error"] === "non-unique-name") error = "Enter a unique name for this Tournament";
        else if (data["error"] === "tournament-booked") error = "You already have a tournament booked at this event";
        else if (data["error"] === "match-contract-exists") error = "A Match Contract with that name already exists. You can book another one after using it.";
        else if (data["error"] === "not-found") error = "The selected participants could not be found. Please try again.";
        else if (data["error"] === "duplicate-superstar") error = data["duplicateSuperstar"] + " was booked more than once in the Tournament";
        else if (data["error"] === "no-women-allowed") error = "Women are not allowed to be booked at this event";
        else if (data["error"] === "no-men-allowed") error = "Men are not allowed to be booked at this event";
        else if (data["error"] === "not-enough-points") error = "You do not have enough Creative Points to add a tournament";
        notie.alert({
            type: 3,
            text: error
        });
    }
}



var $4ptHI = parcelRequire("4ptHI");


function $67cc16607ee33ebf$export$272205331e6ebe73(segment) {
    let $matchInfo = $("#match-info");
    const $match = $("#match");
    $matchInfo.html("").removeClass("visibility-hidden").show();
    // Hide header
    $(".match-container-header-text").text("");
    // Show segment name
    $matchInfo.append("<span class='font-bold display-block margin-bottom-2 faded-purple'>" + segment["name"] + "</span>");
    // Add names and pronouns for formatting string
    let segmentTextObjects = segment["pronouns"].map(function(obj) {
        return Object.keys(obj).sort().map(function(key) {
            return obj[key];
        });
    }).flat();
    let segmentTexts = (0, $1JkT6.segmentsData)[segment["name"]];
    let segmentStartText = segmentTexts["start"];
    let segmentStartHtml = '<span class="font-bold display-block margin-bottom-15 medium-dark-grey segment-start-text">' + segmentStartText.formatUnicorn(segmentTextObjects) + "</span>";
    $(segmentStartHtml).hide().appendTo($matchInfo).fadeIn(700);
    $matchInfo.fadeIn("slow");
    // Check for 'Continue' button click for special segment
    $match.off("click", "#progress-segment-button");
    $match.on("click", "#progress-segment-button", function() {
        $67cc16607ee33ebf$var$viewSpecialSegmentAction(segment);
    });
    $match.html("").show();
    $match.append('<div class="match-superstar-information information-box"></div>');
    const $matchSuperstarInformation = $(".match-superstar-information");
    $matchSuperstarInformation.hide();
    $("#continue-container").hide();
    // Add information box
    $(".match-container").fadeIn("slow");
    $("#superstar_info").html("");
    // Show 'continue' button
    $matchSuperstarInformation.before('<div class="margin-sides-auto margin-top-15"><button type="button" class="button retro-button" id="progress-segment-button">Continue</button><button type="button" class="button retro-button grey-button-background margin-left-8" id="back-to-special-segments-button">Back</button></div>');
    // Load graphics
    (0, $c82cd471f4baff6b$export$93eabf8ee4239dc8)(segment, false);
}
function $67cc16607ee33ebf$var$viewSpecialSegmentAction(segment) {
    let $matchInfo = $("#match-info");
    // Add names and pronouns for formatting string
    let segmentTextObjects = segment["pronouns"].map(function(obj) {
        return Object.keys(obj).sort().map(function(key) {
            return obj[key];
        });
    }).flat();
    let segmentTexts = (0, $1JkT6.segmentsData)[segment["name"]];
    let segmentActionText = segmentTexts["action"];
    segmentActionText = segmentActionText.formatUnicorn(segmentTextObjects);
    segmentActionText = (0, $1JSre.applySentenceCase)(segmentActionText);
    let segmentActionHtml = '<span class="font-bold display-block margin-bottom-15 medium-dark-grey segment-action-text">' + segmentActionText + "</span>";
    $(segmentActionHtml).hide().appendTo($matchInfo).fadeIn(700);
    $(".segment-start-text").removeClass("medium-dark-grey").addClass("light-grey");
    // Load graphics
    (0, $c82cd471f4baff6b$export$93eabf8ee4239dc8)(segment, true);
    $("#progress-segment-button").remove();
}
function $67cc16607ee33ebf$export$ac3751cc11b68979(data) {
    const $specialSegmentsInventory = $("#special-segments-inventory");
    $specialSegmentsInventory.html("");
    $("#special-segments-selection").html("");
    if (data["error"] === "wom") {
        notie.alert({
            type: 3,
            text: "Special Segments are not available in Wrestling on Mars"
        });
        return false;
    }
    // Add special segments
    data.forEach(function(specialSegment) {
        let html = $67cc16607ee33ebf$var$getViewSpecialSegmentItemHtml(specialSegment);
        $specialSegmentsInventory.append(html);
    });
    $("#special-segments-box").fadeIn("slow").removeClass("display-none");
    $specialSegmentsInventory.scrollTop(0);
}
function $67cc16607ee33ebf$var$getViewSpecialSegmentItemHtml(specialSegment) {
    let iconName = specialSegment["booked"] ? "special_segments_icon_torn" : "special_segments_icon";
    let iconText = specialSegment["booked"] ? "Used" : "Not Used";
    // Show view button if special segment has been used
    let viewButton = "";
    let monthsToReuse = "";
    if (specialSegment["unlocked"] && specialSegment["booked"]) {
        viewButton = '<button type="button" class="button retro-button condensed margin-top-15 blue-button-background view-special-segment" data-uid="' + specialSegment["uid"] + '">View</button>';
        let monthsWord = (0, $3E8Nt.getMonthsWord)(specialSegment["monthsToReuse"]);
        monthsToReuse = '<div class="font-1p125em margin-bottom-7 medium-light-grey">{0} {1} to re-use</div>'.format(specialSegment["monthsToReuse"], monthsWord);
    }
    let lockedClass = "";
    if (!specialSegment["unlocked"]) lockedClass = " locked";
    let name = specialSegment["name"];
    return '<div class="special-segment-container' + lockedClass + '">' + '<div class="font-1p125em margin-bottom-12 font-bold">' + "<span>" + name + "</span>" + '<span class="float-right"><img alt="' + iconText + '" class="special-segment-container-icon" src="static/www/static/' + iconName + '.png"/></span>' + "</div>" + monthsToReuse + '<div class="font-1p125em margin-bottom-7 light-grey">' + $67cc16607ee33ebf$var$getSpecialSegmentUnlockText(name) + "</div>" + '<div class="font-1p125em consequence-red">' + $67cc16607ee33ebf$var$getSpecialSegmentConsequenceText(name) + "</div>" + "<span>" + viewButton + "</span>" + "</div>";
}
function $67cc16607ee33ebf$var$getSpecialSegmentUnlockText(name) {
    let unlockText;
    switch(name){
        case "Car Explosion":
            unlockText = 'Run a blowoff on a custom feud with the word "Family" in it and get a 4.5<i class="fa fa-star margin-left-3 margin-right-5"></i>rating or above. Click<i class="fa fa-refresh margin-left-5 margin-right-5"></i>when adding a feud to generate custom Feud names.';
            break;
        case "Stunt Dive":
            unlockText = "Discovered in the company library.";
            break;
        case "Dummy Wrestling":
            unlockText = 'Train a superstar to 3<i class="fa fa-star margin-left-3 margin-right-5"></i>workrate using a trainer (not from a match).';
            break;
        case "Timely Rescue":
            unlockText = "Train a staff doctor to Level 3 or hire a Level 3 doctor.";
            break;
        case "Helicopter Raid":
            unlockText = "Complete the buyout of a competitor (Level 3 Talent Management Facility).";
            break;
        case "Ring Invasion":
            unlockText = "Get a hot superstar on a 10 match singles losing streak.";
            break;
        case "Love Making":
            unlockText = 'Add a superstar gimmick with the "Degenerate" character and get it to 100% effectiveness.';
            break;
        case "Celebrity Beatdown":
            unlockText = 'Run a custom production package (Level 3 Production Facility) with the word "Celebrity" in it.';
            break;
        case "Hosedown":
            unlockText = "Run a silly segment that gets hot.";
            break;
        case "Anti-Company Rant":
            unlockText = "Run a hot feud between a superstar and the company's owner.";
            break;
    }
    return unlockText;
}
function $67cc16607ee33ebf$var$getSpecialSegmentConsequenceText(name) {
    let consequenceText;
    switch(name){
        case "Car Explosion":
            consequenceText = "Superstar unavailable";
            break;
        case "Stunt Dive":
            consequenceText = "Superstar unavailable";
            break;
        case "Dummy Wrestling":
            consequenceText = "Unhappy superstars";
            break;
        case "Timely Rescue":
            consequenceText = "Staff Member unavailable";
            break;
        case "Helicopter Raid":
            consequenceText = "Superstar suspended";
            break;
        case "Ring Invasion":
            consequenceText = "Superstar suspended";
            break;
        case "Love Making":
            consequenceText = '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px margin-right-3"/> Penalty';
            break;
        case "Celebrity Beatdown":
            consequenceText = '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px margin-right-3"/> Penalty';
            break;
        case "Hosedown":
            consequenceText = "Unhappy superstars";
            break;
        case "Anti-Company Rant":
            consequenceText = "Superstar suspended";
            break;
    }
    return consequenceText;
}
function $67cc16607ee33ebf$export$43c5cdc832e20b0c({ data: data, callbackFunction: callbackFunction } = {}) {
    // Reset ui
    $("#segment-items-container").html("").show();
    $(".filter-segment-items-options").scrollTop(0);
    $(".filter-segment-items-option").removeClass("selected");
    $('.filter-segment-items-option:contains("All")').addClass("selected");
    // Add segment items
    data["availableSegmentItems"].forEach(function(item, itemIndex) {
        let segmentItemBookingHtml = $67cc16607ee33ebf$var$getSegmentItemBookingHtml(item, itemIndex);
        $("#segment-items-container").append(segmentItemBookingHtml);
    });
    // Add 'Custom Package' segment item
    let customPackageSegmentItemHtml = $67cc16607ee33ebf$var$getCustomPackageSegmentItemHtml(data);
    $("#segment-items-container").append(customPackageSegmentItemHtml);
    $(".custom-package-start-text").trigger("keyup");
    // Add unavailable segment items
    data["unavailableSegmentItems"].forEach(function(item, index) {
        let segmentItemBookingHtml = $67cc16607ee33ebf$var$getLockedSegmentItemBookingHtml(item, index);
        $("#segment-items-container").append(segmentItemBookingHtml);
    });
    // Tutorial action check
    if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_book_segment_button");
    if (typeof callbackFunction === "function") callbackFunction();
}
function $67cc16607ee33ebf$var$getSegmentItemBookingHtml(segmentItem, index) {
    let tags = [];
    let isFactionSegment = segmentItem["factionSegment"];
    let levelHtml = $67cc16607ee33ebf$var$getSegmentItemBookingLevelHtml(segmentItem);
    let consequenceHtml = "";
    if (segmentItem["consequence"]) {
        let consequenceText = (0, $3E8Nt.toTitleCase)(segmentItem["consequence"].replace(/-/g, " "));
        if ((consequenceText.search("Turn") >= 0 || consequenceText.search("Face") >= 0 || consequenceText.search("Heel") >= 0) && consequenceText.search("Company") < 0 && segmentItem["name"] !== "New Alliance") tags.push("alignment");
        if (consequenceText.search("Champion") >= 0 || consequenceText.search("Title") >= 0) tags.push("title");
        if (consequenceText.search("Team") >= 0 || consequenceText.search("Tag") >= 0 || consequenceText.search("Trio") >= 0) tags.push("team");
        if (consequenceText.search("Faction") >= 0) tags.push("faction");
        if (consequenceText.search("Brand") >= 0) tags.push("brand");
        consequenceHtml = '<div class="line-height-1p4 faded-red-light padding-top-3 segment-item-consequence">' + consequenceText + "</div>";
    }
    let requirementHtml = "";
    if (segmentItem["requirement"]) {
        if (segmentItem["productionSegment"]) tags.push("production");
        let requirementText = (0, $3E8Nt.toTitleCase)(segmentItem["requirement"].replace(/-/g, " "));
        if (requirementText.search("Champion") >= 0 || requirementText.search("Title") >= 0) tags.push("title");
        if ((requirementText.search("Turn") >= 0 || requirementText.search("Face") >= 0 || requirementText.search("Heel") >= 0 || requirementText.search("Neutral") >= 0) && requirementText.search("Company") < 0 && segmentItem["name"] !== "New Alliance") tags.push("alignment");
        if (requirementText.search("Team") >= 0 || requirementText.search("Tag") >= 0) tags.push("team");
        if (requirementText.search("Retirement") >= 0 || requirementText.search("Legend") >= 0) tags.push("retired");
        if (requirementText.search("Manager") >= 0 || requirementText.search("Managed") >= 0) tags.push("manager");
        if (requirementText.search("Brand") >= 0) tags.push("brand");
        requirementHtml = '<div class="line-height-1p4 padding-top-1 sky-blue">' + requirementText + "</div>";
    }
    let helpClass = "";
    let titleHtml = "";
    if (segmentItem["description"]) {
        helpClass = " help-text";
        titleHtml = ' title="' + segmentItem["description"] + '"';
    }
    let name = '<span class="segment-item-name">' + segmentItem["name"] + "</span>";
    let silly = "";
    if (segmentItem["silly"]) {
        silly = '<div class="puke-green-dark segment-item-silly">Silly</div>';
        tags.push("silly");
    }
    let oneAtATime = "";
    if (!segmentItem["oneAtATime"]) {
        oneAtATime = '<div class="light-grey help-text" title="A Repeatable Segment can be used multiple times at an Event or in a Feud without a penalty">Repeatable</div>';
        tags.push("repeatable");
    }
    let feudOnly = "";
    if (segmentItem["feudOnly"]) feudOnly = '<div class="light-grey segment-item-feud-only">Feuds Only</div>';
    let maxParticipants = "";
    if (isFactionSegment && segmentItem["maxParticipants"] > 0) maxParticipants = '<div class="light-grey">Select a Faction</div>';
    else if (segmentItem["maxParticipants"] !== undefined) {
        let participantsText = "Participant";
        if (segmentItem["maxParticipants"] !== 1) participantsText = "Participants";
        let numberOfParticipants = segmentItem["maxParticipants"];
        if (segmentItem["minParticipants"] !== segmentItem["maxParticipants"]) numberOfParticipants = "{0}-{1}".format(segmentItem["minParticipants"], numberOfParticipants);
        if (numberOfParticipants === 0) numberOfParticipants = "No";
        maxParticipants = '<div class="light-grey">' + numberOfParticipants + " " + participantsText + "</div>";
    }
    let noParticipants = "";
    if (segmentItem["maxParticipants"] === 0) noParticipants = ' data-no-participants="true"';
    if (segmentItem["chooseWinner"]) tags.push("choose-winner");
    if (segmentItem["custom"]) tags.push("custom");
    if (segmentItem["special"]) tags.push("special");
    if (segmentItem["consequence"] && segmentItem["consequence"].search("blowoff") >= 0 || segmentItem["hypeBoost"] && segmentItem["minParticipants"] > 1 || [
        "Solo Feud Promo",
        "Client Betrayal"
    ].indexOf(segmentItem["name"]) >= 0) tags.push("feud");
    let boosts = '<span class="faded-red help-text" title="Hype Boost for the involved Feuds"><i class="fa fa-bolt margin-right-5"></i>' + segmentItem["hypeBoost"] + "</span>" + '<span class="charisma-purple margin-left-10 help-text" ' + 'title="Popularity Boost for the involved Participant(s)">' + '<i class="fa fa-angle-double-up margin-right-5"></i>' + segmentItem["popularityBoost"] + "</span>";
    if (segmentItem["special"]) {
        if (segmentItem["used"]) boosts = '<img alt="Used Special Segment" src="static/www/static/special_segments_icon_torn.png" class="special-segments-icon"/>';
        else boosts = '<img alt="Special Segment" src="static/www/static/special_segments_icon.png" class="special-segments-icon"/>';
    }
    let itemUsed = "";
    if (segmentItem["used"]) itemUsed = '<div class="dark-red">Used</div>';
    let progressHtml = $67cc16607ee33ebf$var$getSegmentItemBookingProgressHtml(segmentItem);
    let sortAttributesHtml = $67cc16607ee33ebf$var$getSegmentItemBookingSortAttributesHtml(segmentItem, index);
    let stats = '<div><span class="segment-item-label margin-right-5 medium-grey help-text" title="Entertainment: Affects a Segment\'s maximum Rating and XP gain">Ent.</span>' + '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem["entertainment"]) + '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem["entertainment"]) + "</div>" + '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' + 'title="Action: Affects a Segment\'s maximum Rating and XP gain">Act.</span>' + '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem["action"]) + '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem["action"]) + "</div>" + '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' + "title=\"Difficulty: Used alongside the Charisma of the Participants to get the Segment's " + 'Effectiveness and Rating">Diff.</span>' + '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem["difficulty"]) + '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem["difficulty"]) + "</div>";
    let info = "<div>" + maxParticipants + oneAtATime + feudOnly + silly + requirementHtml + consequenceHtml + itemUsed + "</div>";
    // Check for faction input
    let factionInputAttr = "";
    if ([
        "remove-faction-members",
        "add-faction-members",
        "leave-faction-and-join-other-faction",
        "merge-factions",
        "split-faction",
        "add-faction-leader",
        "kick-out-faction-leader-and-change-leader",
        "change-faction-leader",
        "create-faction"
    ].indexOf(segmentItem["consequence"]) >= 0) factionInputAttr = ' data-faction-input="true"';
    // Check for manager input
    let managerInputAttr = "";
    if ([
        "boost-managed-talent",
        "add-manager",
        "remove-manager",
        "remove-managed-talent"
    ].indexOf(segmentItem["consequence"]) >= 0) managerInputAttr = ' data-manager-input="true"';
    // Check for brand input
    let brandInputAttr = "";
    if ([
        "draft-talent-to-brand"
    ].indexOf(segmentItem["consequence"]) >= 0) brandInputAttr = ' data-brand-input="true"';
    // Check for other input
    let otherInputAttr = "";
    if ([
        "loser-unavailable",
        "make-unavailable",
        "create-team",
        "create-trio-of-heels",
        "remove-tag-team-and-create-tag-team",
        "create-tag-team-and-blowoff",
        "unify-titles",
        "split-title",
        "vacate-title",
        "award-title",
        "boost-popularity"
    ].indexOf(segmentItem["consequence"]) >= 0 || segmentItem["requirement"] === "feud-present" || segmentItem["name"] === "Slander Competitor") otherInputAttr = ' data-other-input="true"';
    return '<div class="segment-item-container wide item-container font-bold' + helpClass + '" data-uid="' + segmentItem["uid"] + '"' + noParticipants + titleHtml + ' data-name="' + segmentItem["name"].replace(/"/g, "&quot;") + '" data-requirement="' + segmentItem["requirement"] + '" data-consequence="' + segmentItem["consequence"] + '"' + factionInputAttr + managerInputAttr + brandInputAttr + otherInputAttr + sortAttributesHtml + " data-tags='" + JSON.stringify(tags) + "' data-is-faction-segment=\"" + isFactionSegment + '" ' + 'tabindex="0">' + '<div class="margin-bottom-5">' + '<div class="column-left">' + name + "</div>" + '<div class="column-right segment-right-header-container">' + '<div class="column-left">' + progressHtml + levelHtml + "</div>" + '<div class="column-right text-right ">' + boosts + "</div>" + '<div class="clear"></div>' + "</div>" + '<div class="clear"></div>' + "</div>" + '<div class="column-left">' + stats + "</div>" + '<div class="column-right margin-top-1 segment-item-information">' + info + "</div>" + '<div class="clear"></div>' + "</div>";
}
function $67cc16607ee33ebf$var$getLockedSegmentItemBookingHtml(segmentItem, index) {
    let levelHtml = $67cc16607ee33ebf$var$getSegmentItemBookingLevelHtml(segmentItem);
    // Locked text
    let lockedText;
    if (segmentItem["productionSegment"] || segmentItem["special"]) lockedText = "";
    else if (segmentItem["factionSegment"]) lockedText = "";
    else if ([
        "Option C",
        "New Title Reveal",
        "Championship Split"
    ].indexOf(segmentItem["name"]) >= 0) lockedText = "";
    else if ([
        "boost-managed-talent",
        "add-manager",
        "remove-manager",
        "remove-managed-talent",
        "draft-talent-to-brand"
    ].indexOf(segmentItem["consequence"]) >= 0) lockedText = "";
    else if ([
        "other-brand-talent"
    ].indexOf(segmentItem["requirement"]) >= 0) lockedText = "";
    else {
        lockedText = "Locked: Unlocked with Segment Item Prestige";
        if (!(0, $98xmD.globalUser).paid) lockedText += " (JoW Paid)";
    }
    // Tags
    let tags = [];
    tags.push("locked");
    // Silly
    let silly = "";
    if (segmentItem["silly"]) {
        silly = '<div class="puke-green-dark segment-item-silly">Silly</div>';
        tags.push("silly");
    }
    // Consequence
    let consequenceHtml = "";
    if (segmentItem["consequence"]) {
        let consequenceText = (0, $3E8Nt.toTitleCase)(segmentItem["consequence"].replace(/-/g, " "));
        if ((consequenceText.search("Turn") >= 0 || consequenceText.search("Face") >= 0 || consequenceText.search("Heel") >= 0) && consequenceText.search("Company") < 0 && segmentItem["name"] !== "New Alliance") tags.push("alignment");
        if (consequenceText.search("Champion") >= 0 || consequenceText.search("Title") >= 0) tags.push("title");
        if (consequenceText.search("Team") >= 0 || consequenceText.search("Tag") >= 0 || consequenceText.search("Trio") >= 0) tags.push("team");
        if (consequenceText.search("Faction") >= 0) tags.push("faction");
        if (consequenceText.search("Brand") >= 0) tags.push("brand");
        consequenceHtml = '<div class="line-height-1p4 faded-red-light padding-top-3 segment-item-consequence">' + consequenceText + "</div>";
    }
    // Requirement
    let requirement = "";
    if (segmentItem["requirement"]) {
        if (segmentItem["productionSegment"]) tags.push("production");
        let requirementText = (0, $3E8Nt.toTitleCase)(segmentItem["requirement"].replace(/-/g, " "));
        if (requirementText.search("Champion") >= 0 || requirementText.search("Title") >= 0) tags.push("title");
        if (requirementText.search("Turn") >= 0 || requirementText.search("Face") >= 0 || requirementText.search("Heel") >= 0) tags.push("alignment");
        if (requirementText.search("Team") >= 0 || requirementText.search("Tag") >= 0) tags.push("team");
        if (requirementText.search("Retirement") >= 0 || requirementText.search("Legend") >= 0) tags.push("retired");
        requirement = '<div class="line-height-1p4 padding-top-1 sky-blue">' + requirementText + "</div>";
    }
    // One at a time
    let oneAtATime = "";
    if (!segmentItem["oneAtATime"]) {
        oneAtATime = '<div class="light-grey help-text" title="A Repeatable Segment can be used multiple times at an Event or in a Feud without a penalty">Repeatable</div>';
        tags.push("repeatable");
    }
    // Feud only
    let feudOnly = "";
    if (segmentItem["feudOnly"]) feudOnly = '<div class="light-grey segment-item-feud-only">Feuds Only</div>';
    // Max participants
    let maxParticipants = "";
    if (segmentItem["maxParticipants"] !== undefined) {
        let participantsText = "Participant";
        if (segmentItem["maxParticipants"] !== 1) participantsText = "Participants";
        let numberOfParticipants = segmentItem["maxParticipants"];
        if (segmentItem["minParticipants"] !== segmentItem["maxParticipants"]) numberOfParticipants = "{0}-{1}".format(segmentItem["minParticipants"], numberOfParticipants);
        if (numberOfParticipants === 0) numberOfParticipants = "No";
        maxParticipants = '<div class="light-grey">' + numberOfParticipants + " " + participantsText + "</div>";
    }
    // Custom
    if (segmentItem["custom"]) tags.push("custom");
    // Special
    if (segmentItem["special"]) tags.push("special");
    // Feud tag
    if (segmentItem["consequence"] && segmentItem["consequence"].search("blowoff") >= 0 || segmentItem["hypeBoost"] && segmentItem["minParticipants"] > 1) tags.push("feud");
    // Hidden stats
    let stats = '<div><span class="segment-item-label margin-right-5 medium-grey">Ent.</span>???</div><div><span class="segment-item-label margin-right-5 medium-grey">Act.</span>???</div><div><span class="segment-item-label margin-right-5 medium-grey">Diff.</span>???</div>';
    // Boosts
    let boosts = '<span><i class="fa fa-bolt margin-right-5"></i>??</span><span class="margin-left-8"><i class="fa fa-angle-double-up margin-right-5"></i>??</span>';
    if (segmentItem["special"]) boosts = '<img alt="Special Segment" src="static/www/static/special_segments_icon.png" class="special-segments-icon"/>';
    // Info
    let info = "<div>" + maxParticipants + oneAtATime + feudOnly + silly + requirement + consequenceHtml + "</div>";
    // Unlock text
    let unlockText = "";
    let unlockedBy = $67cc16607ee33ebf$var$getSegmentItemUnlockedBy(segmentItem["name"]);
    if (segmentItem["productionSegment"]) {
        unlockText = " Locked: Unlocked by " + unlockedBy;
        if (!(0, $98xmD.globalUser).paid) unlockText += " (JoW Paid)";
    } else if (segmentItem["factionSegment"]) unlockText = "Available in JoW Paid";
    else if ([
        "Option C",
        "New Title Reveal",
        "Championship Split"
    ].indexOf(segmentItem["name"]) >= 0) {
        unlockText = " Locked: Unlocked by getting a " + unlockedBy;
        if (!(0, $98xmD.globalUser).paid) unlockText += " (JoW Paid)";
    } else if ([
        "boost-managed-talent",
        "add-manager",
        "remove-manager",
        "remove-managed-talent",
        "draft-talent-to-brand"
    ].indexOf(segmentItem["consequence"]) >= 0) unlockText = "Available in JoW Paid";
    else if ([
        "other-brand-talent"
    ].indexOf(segmentItem["requirement"]) >= 0) unlockText = "Available in JoW Paid";
    else if (segmentItem["special"]) unlockText = " Locked: Unlocked by completing a specific action ('Manage' > 'Other' > 'Special')";
    else unlockText = " by getting Gold Prestige on " + unlockedBy;
    let progressHtml = $67cc16607ee33ebf$var$getSegmentItemBookingProgressHtml(segmentItem);
    let sortAttributesHtml = $67cc16607ee33ebf$var$getSegmentItemBookingSortAttributesHtml(segmentItem, index);
    return '<div class="wide item-container font-bold disabled locked help-text" title="' + lockedText + unlockText + '" ' + ' data-name="' + segmentItem["name"].replace(/"/g, "&quot;") + '" data-requirement="' + segmentItem["requirement"] + '" data-consequence="' + segmentItem["consequence"] + '"' + sortAttributesHtml + " data-tags='" + JSON.stringify(tags) + "'>" + '<div class="margin-bottom-5">' + '<div class="column-left">' + segmentItem["name"] + "</div>" + '<div class="column-right segment-right-header-container">' + '<div class="column-left">' + progressHtml + levelHtml + "</div>" + '<div class="column-right text-right ">' + boosts + "</div>" + '<div class="clear"></div>' + "</div>" + '<div class="clear"></div>' + "</div>" + '<div class="column-left">' + stats + "</div>" + '<div class="column-right margin-top-1">' + info + "</div>" + '<div class="clear"></div>' + "</div>";
}
function $67cc16607ee33ebf$var$getSegmentItemBookingLevelHtml(item) {
    let levelHtml = "";
    if (!item["special"]) switch(item["level"]){
        case 1:
            levelHtml = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px bronze"></i>';
            break;
        case 2:
            levelHtml = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px silver"></i>';
            break;
        case 3:
            levelHtml = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px gold-light"></i>';
            break;
    }
    return levelHtml;
}
function $67cc16607ee33ebf$var$getSegmentItemBookingProgressHtml(item) {
    // Get progress to next level
    let progress;
    let levelXp;
    if (item["level"] < 3) {
        levelXp = Math.pow(item["level"], 2) * 75;
        progress = item["xp"] / levelXp * 100;
    } else {
        levelXp = Math.pow(2, 2) * 75;
        progress = 100;
    }
    // Hide progress for special segment items
    let progressClass = item["special"] ? " visibility-hidden" : "";
    return '<div class="segment-item-progress-container display-inline-block' + progressClass + '">' + '<div class="progress-under help-text" title="' + item["xp"] + " / " + levelXp + ' XP">' + '<div class="progress faded-purple-background" style="width:' + progress + '%">' + "</div>" + "</div>" + "</div>";
}
function $67cc16607ee33ebf$var$getSegmentItemBookingSortAttributesHtml(item, index) {
    return ' data-default-order="' + index + '" data-participants="' + item["maxParticipants"] + '" data-hype-boost="' + item["hypeBoost"] + '" data-popularity-boost="' + item["popularityBoost"] + '" data-entertainment="' + item["entertainment"] + '" data-action="' + item["action"] + '" data-difficulty="' + item["difficulty"] + '"';
}
function $67cc16607ee33ebf$var$getCustomPackageSegmentItemHtml(data) {
    let tags = [
        "production"
    ];
    let name = '<span class="segment-item-name">Custom Package</span>';
    let itemRequirement = "Level 1 Producer";
    let packageName = '<input type="text" placeholder="Name" class="styled-input custom-package-name" value="Feature Package">';
    let startText = '<input type="text" placeholder="Start Text" class="styled-input custom-package-start-text" value="A video package airs about {name} ..." maxlength="200">';
    let actionText = '<input type="text" placeholder="Action Text" class="styled-input custom-package-action-text" value="It praises {objective} and showcases {possessive} accomplishments." maxlength="250">';
    let inputsDiv = '<div class="font-0p85em"><div class="margin-bottom-10"><div>Name</div>' + packageName + "</div>" + '<div class="margin-bottom-10">' + "<div>Start Text</div>" + startText + "</div>" + '<div class="margin-bottom-10">' + "<div>Action Text</div>" + actionText + '<div class="add-custom-package-action-text-container cursor-pointer light-grey">' + '<i class="fa fa-minus-circle remove-custom-package-action-text-button display-none margin-right-3"></i>' + '<i class="fa fa-plus-circle add-custom-package-action-text-button"></i>' + "</div>" + "</div>" + "</div>";
    let helpDiv = '<div class="custom-package-help-container display-none margin-top-10 medium-dark-grey"><div class="margin-bottom-5">The following keywords, when entered into the Start and Action Texts, will be replaced by a talent\'s details:</div><div class="margin-bottom-5">{name}</div><div class="margin-bottom-5">{pronoun} <span class="light-grey margin-left-2">he/she/they</span></div><div class="margin-bottom-5">{possessive} <span class="light-grey margin-left-2">his/her/their</span></div><div class="margin-bottom-10">{objective} <span class="light-grey margin-left-2">him/her/them</span></div><div>You can also add multiple Action Texts by clicking on the \'+\' icon. One of them will be chosen when the segment runs.</div></div>';
    let buttons = '<div class="light-grey float-right custom-package-help-button">help</div><button type="button" class="button retro-button blue-button-background margin-top-5 condensed" id="create-custom-package-button">Create</button>';
    let outputDivs = '<div class="margin-top-20 custom-package-preview-container"><div class="margin-bottom-5 faded-purple custom-package-name-preview"></div><div class="margin-bottom-10 medium-dark-grey custom-package-start-text-preview"></div><div class="margin-bottom-10 medium-dark-grey custom-package-action-text-preview"></div></div>';
    let customPackageClass = "";
    let customPackageTitle = "";
    if (!data["customPackage"]) {
        customPackageClass = " locked help-text";
        customPackageTitle = ' title="You need to have an Advanced (Level 3) Production Facility and a Level 3 Producer to create a custom package."';
    }
    return '<div class="item-container wide input font-bold' + customPackageClass + '" ' + customPackageTitle + ' data-name="Custom Package" data-requirement="' + itemRequirement + '" ' + "data-tags='" + JSON.stringify(tags) + "'>" + '<div class="margin-bottom-8">' + name + '<span class="float-right blue">' + ' <img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 margin-right-5"/>30</span>' + "</div>" + '<div class="column-left">' + inputsDiv + buttons + helpDiv + "</div>" + '<div class="column-right text-right">' + outputDivs + "</div>" + '<div class="clear"></div>' + "</div>";
}
function $67cc16607ee33ebf$var$getSegmentItemUnlockedBy(feudItemName) {
    let unlockedByName;
    switch(feudItemName){
        case "Legend's Praise":
            unlockedByName = "Debut";
            break;
        case "Title Destruction":
            unlockedByName = "Title Disrespect";
            break;
        case "Exposing the Past":
            unlockedByName = "Anger Management";
            break;
        case "Lost My Smile":
            unlockedByName = "Demand Title Shot";
            break;
        case "You're Fired":
            unlockedByName = "Talk Show";
            break;
        case "Defying a Villain":
            unlockedByName = "Spirited Promo";
            break;
        case "Backstab":
            unlockedByName = "Heat Promo";
            break;
        case "Delayed Vengeance":
            unlockedByName = "Fight";
            break;
        case "Option C":
            unlockedByName = "Bronze Prestige Championship to Silver Prestige";
            break;
        case "New Title Reveal":
            unlockedByName = "Silver Prestige Championship to Gold Prestige";
            break;
        case "Championship Split":
            unlockedByName = "Gold Prestige Championship to Obsidian Prestige";
            break;
        case "Debut Package":
            unlockedByName = "getting your Producer to Level 2";
            break;
        case "Return Package":
            unlockedByName = "getting your Producer to Level 2";
            break;
        case "Champion Package":
            unlockedByName = "getting your Producer to Level 2";
            break;
        case "Career Package":
            unlockedByName = "getting your Producer to Level 3";
            break;
        case "Day in the Life":
            unlockedByName = "getting your Producer to Level 3";
            break;
        case "Entrance Parody":
            unlockedByName = "Siblings Parody";
            break;
        case "Police Arrest":
            unlockedByName = "Backstage Attack";
            break;
        case "One Last Run":
            unlockedByName = "Legendary Beatdown";
            break;
        case "This Is My Life":
            unlockedByName = "Backstage Interview";
            break;
        case "Spouse Attack":
            unlockedByName = "Home Invasion";
            break;
        case "Face Reveal":
            unlockedByName = "Masked Attacker";
            break;
        case "Catchphrase Showdown":
            unlockedByName = "Promo Battle";
            break;
    }
    return unlockedByName;
}
async function $67cc16607ee33ebf$export$71048709d8f0e26a({ matchesAndSegmentsData: matchesAndSegmentsData, index: index = 0, tournamentDisplay: tournamentDisplay, cashinData: cashinData } = {}) {
    const $match = $("#match");
    const matchInfoSelector = $("#match-info");
    let stageLayers;
    // Get segment
    let segment = matchesAndSegmentsData[index];
    // Show header
    $(".match-container-header-text").text("Next Segment");
    // Run annual tournament segment, display only
    if (segment["annualTournament"]) return $67cc16607ee33ebf$var$viewAnnualTournamentSegmentStart(segment, matchesAndSegmentsData, index, tournamentDisplay);
    // Reset ui
    matchInfoSelector.html("").removeClass("visibility-hidden").show();
    $match.data("played", false);
    // Show segment name
    matchInfoSelector.append("<span class='font-bold display-block margin-bottom-3 faded-purple'>" + segment["name"] + "</span>");
    // Show feud names
    let feudsHtmlArray = [];
    segment["feuds"].forEach(function(feud) {
        feudsHtmlArray.push("<span class='help-text' title='" + feud["participants"].join(" vs ").replace(/'/g, "&#39;") + "'>" + feud["name"] + "</span>");
    });
    if (feudsHtmlArray.length > 0) matchInfoSelector.append("<span class='font-bold display-block margin-bottom-3 faded-red-light'>" + (0, $3E8Nt.commaSeparate)(feudsHtmlArray, "&") + "</span>");
    // Show hype
    let segmentHype = segment["hype"];
    if (segmentHype < 0) segmentHype = "- " + segmentHype * -1;
    else segmentHype = "+ " + segmentHype;
    matchInfoSelector.append("<span class='font-bold display-block medium-dark-grey margin-bottom-3'>" + segmentHype + " HYPE</span>");
    // Show segment start text
    $67cc16607ee33ebf$var$showSegmentStartText(segment);
    matchInfoSelector.fadeIn("slow");
    // Get data type
    let dataType = "";
    if (segment["participantsType"] === "tag") dataType = "tagTeam";
    // Check for 'Continue' button click for special segment
    let participantsDisplay = "";
    if (segment["special"]) {
        $match.off("click", "#progress-segment-button");
        $match.on("click", "#progress-segment-button", async function() {
            await (0, $1JSre.makeGameRequest)((0, $4ptHI.playSegment), {
                winnerName: null,
                uid: segment["uid"],
                graphics: segment["graphics"]
            }, $67cc16607ee33ebf$var$showPlaySegmentData, {
                segment: segment,
                winnerName: null,
                cashinData: cashinData,
                tournamentDisplay: tournamentDisplay,
                matchesAndSegmentsData: matchesAndSegmentsData,
                index: index,
                stageLayers: stageLayers
            }, false);
        });
    } else if (!segment["chooseWinner"]) {
        $("#booking-talent-info").addClass("match").hide();
        setTimeout(async function() {
            await (0, $1JSre.makeGameRequest)((0, $4ptHI.playSegment), {
                winnerName: null,
                uid: segment["uid"],
                graphics: segment["graphics"]
            }, $67cc16607ee33ebf$var$showPlaySegmentData, {
                segment: segment,
                winnerName: null,
                cashinData: cashinData,
                tournamentDisplay: tournamentDisplay,
                matchesAndSegmentsData: matchesAndSegmentsData,
                index: index,
                stageLayers: stageLayers
            }, false);
        }, 2800);
    } else {
        // Create x vs x vs x ...
        let participantsHtml = [];
        if (segment["participants"].length > 10) {
            $match.css("text-align", "left");
            segment["participants"].forEach(function(participant) {
                participantsHtml.push('<div class="match-wrestler-container-battle-royal"><button class="match-wrestler match-span-small" data-type="' + dataType + '" data-name="' + participant["name"].replace(/"/g, "&quot;") + '">' + $67cc16607ee33ebf$export$bc6829a93fbd1f8a(participant) + "</button></div>");
            });
        } else {
            $match.css("text-align", "center");
            segment["participants"].forEach(function(participant) {
                participantsHtml.push('<div class="match-wrestler-container"><button class="match-wrestler match-span" data-type="' + dataType + '" data-name="' + participant["name"].replace(/"/g, "&quot;") + '">' + $67cc16607ee33ebf$export$bc6829a93fbd1f8a(participant) + "</button></div>");
            });
        }
        if (segment["participants"].length > 4) participantsDisplay = participantsHtml.join("");
        else participantsDisplay = participantsHtml.join('<span class="match-span dark-grey"></span>');
        $("#booking-talent-info").addClass("match").hide();
        // Show information handler
        let timer;
        $match.off("mouseenter", ".match-wrestler");
        $match.on({
            mouseenter: function() {
                let $this = $(this);
                timer = setTimeout(function() {
                    let selectedName = $this.text();
                    if ($this.attr("data-name")) selectedName = $this.attr("data-name");
                    let member = segment["participants"].filter(function(obj) {
                        return obj.name === selectedName;
                    })[0];
                    if (member) {
                        if ($this.attr("data-type") === "tagTeam") (0, $f18c00e15af0c7db$export$b73c16b811178760)(member, true);
                        else (0, $f18c00e15af0c7db$export$8d1c45aa228e7350)(member, true);
                    }
                }, 70);
            },
            mouseleave: function() {
                clearTimeout(timer);
            }
        }, ".match-wrestler");
        // Ask to choose winner
        notie.alert({
            type: 4,
            text: "Select who performs the Segment",
            stay: true
        });
    }
    // Show participants
    $match.html(participantsDisplay);
    // Remove simulate button
    $("#simulate-match").remove();
    // Show match elements
    if (segment["chooseWinner"]) {
        $match.append('<button type="button" class="button retro-button margin-top-15 margin-sides-auto display-block" id="simulate-match" data-segment-uid="' + segment["uid"] + '">Simulate</button>');
        // Add information box
        $match.append('<div class="match-superstar-information information-box"><div class="superstar-info-match-container">Participant Details<div class="empty-superstar-info light-grey"><div class="vertical-center">Hover over a Participant to display their details here</div></div></div></div>');
    } else {
        $match.append('<div class="match-superstar-information information-box"></div>');
        $(".match-superstar-information").hide();
    }
    $match.show();
    $("#booking-talent-info").html("");
    $(".match-container").fadeIn("fast");
    // Show 'continue' button if special segment
    if (segment["special"]) $(".match-superstar-information").before('<button type="button" class="button retro-button margin-top-15 margin-sides-auto display-block grey-button-background" id="progress-segment-button">Continue</button>');
    // Show graphics
    if (segment["graphics"].length > 0) stageLayers = (0, $c82cd471f4baff6b$export$4d95ef41d1462076)(segment);
    // Simulate handler
    $match.off("click", "#simulate-match");
    $match.on("click", "#simulate-match", function() {
        if ($match.data("played")) return;
        let winnerDiv = $((0, $3E8Nt.getRandomChoice)($("#match .match-wrestler")));
        winnerDiv.trigger("click");
    });
    // Winner click handler
    $(document).off("click", "#match .match-wrestler");
    $(document).on({
        click: async function(event) {
            if ($(this).hasClass("match-wrestler")) {
                $(this).unbind(event);
                let winnerName = $(this).text();
                if ($(this).attr("data-name")) winnerName = $(this).attr("data-name");
                // Put winner first in pronouns
                segment["pronouns"].sort(function(x, y) {
                    return x["name"] === winnerName ? -1 : y["name"] === winnerName ? 1 : 0;
                });
                await (0, $1JSre.makeGameRequest)((0, $4ptHI.playSegment), {
                    winnerName: winnerName,
                    uid: segment["uid"],
                    graphics: segment["graphics"]
                }, $67cc16607ee33ebf$var$showPlaySegmentData, {
                    segment: segment,
                    winnerName: winnerName,
                    cashinData: cashinData,
                    tournamentDisplay: tournamentDisplay,
                    matchesAndSegmentsData: matchesAndSegmentsData,
                    index: index,
                    stageLayers: stageLayers
                }, false);
            }
        }
    }, "#match .match-wrestler");
}
function $67cc16607ee33ebf$var$showSegmentStartText(segment) {
    let segmentStartText = $67cc16607ee33ebf$var$getSegmentStartText(segment);
    $(segmentStartText).hide().appendTo($("#match-info")).fadeIn(700);
}
function $67cc16607ee33ebf$var$getSegmentStartText(segment) {
    let segmentStartText;
    if (segment["startTexts"] && segment["startTexts"].length) // Custom text
    segmentStartText = $67cc16607ee33ebf$var$formatSegmentText((0, $3E8Nt.getRandomChoice)(segment["startTexts"]));
    else if (segment["text"]) {
        // Custom segment text
        let segmentText = segment["text"];
        // Get singles or tag text
        if (segmentText["startTag"] && segment["participantsType"] === "tag") segmentStartText = $67cc16607ee33ebf$var$formatSegmentText((0, $3E8Nt.getRandomChoice)(segmentText["startTag"]));
        else segmentStartText = $67cc16607ee33ebf$var$formatSegmentText((0, $3E8Nt.getRandomChoice)(segmentText["start"]));
    } else {
        let segmentTexts = (0, $1JkT6.segmentsData)[segment["name"]];
        // Get texts based on number of participants if text has this data
        if (segmentTexts["participants"]) segmentTexts = segmentTexts["participants"][segment["participantsNumber"]];
        // Get faction texts
        if (segment["factionSegment"]) {
            if (segment["factionSuperstarsMultiple"]) segmentStartText = segmentTexts["startTag"];
            else segmentStartText = segmentTexts["start"];
        } else if (segmentTexts["startTag"] && segment["participantsType"] === "tag") segmentStartText = segmentTexts["startTag"];
        else segmentStartText = segmentTexts["start"];
    }
    // Add names and pronouns for formatting string
    let segmentTextObjects = segment["pronouns"].map(function(obj) {
        return Object.keys(obj).sort().map(function(key) {
            return obj[key];
        });
    }).flat();
    return '<span class="font-bold display-block margin-bottom-10 margin-top-10 medium-dark-grey segment-start-text">' + segmentStartText.formatUnicorn(segmentTextObjects) + "</span>";
}
function $67cc16607ee33ebf$var$showPlaySegmentData({ data: data, segment: segment, winnerName: winnerName, cashinData: cashinData, tournamentDisplay: tournamentDisplay, matchesAndSegmentsData: matchesAndSegmentsData, index: index, stageLayers: stageLayers } = {}) {
    if (!data["error"]) try {
        // Mark segment as played
        $("#match").data("played", true);
        // Update graphics if special segment or updated in data
        if (segment["special"]) stageLayers = (0, $c82cd471f4baff6b$export$4d95ef41d1462076)(segment, true);
        if (data["graphics"]) {
            segment["graphics"] = data["graphics"];
            stageLayers = (0, $c82cd471f4baff6b$export$4d95ef41d1462076)(segment);
        }
        // Add losing layer, pop changes
        (0, $c82cd471f4baff6b$export$c085e4755974582e)(segment, winnerName, stageLayers);
        $67cc16607ee33ebf$var$showSegmentPopularityChanges(data, segment, winnerName);
        // Show segment action text, result
        $67cc16607ee33ebf$var$showSegmentActionText(segment);
        $67cc16607ee33ebf$var$showSegmentResult(data, segment, winnerName);
        // Show updates
        $67cc16607ee33ebf$var$showSegmentUpdates(data, segment);
        $67cc16607ee33ebf$export$45a344294533d7c2();
        $67cc16607ee33ebf$export$32c25d7dd1621e23();
        // Update segments if returned
        if (data["mainEventHype"]) {
            matchesAndSegmentsData[matchesAndSegmentsData.length - 1]["hype"] = data["mainEventHype"];
            // Update event hype
            $(".event-hype-text").html((0, $e6954d9b34d9dd89$export$46dc9792936abd2f)(data["eventHype"])).hide().fadeIn("fast");
        }
        // Show 'continue' button, hide simulate button
        $("#progress-segment-button").remove();
        $(".match-superstar-information").before('<button type="button" class="button retro-button margin-top-15 margin-sides-auto display-block grey-button-background" id="progress-segment-button">Continue</button>');
        $("#simulate-match").hide();
        // Increase index
        index++;
        // Progress segment handler
        $("#match").off("click", "#progress-segment-button");
        $("#match").on("click", "#progress-segment-button", async function() {
            await (0, $e6954d9b34d9dd89$export$6f7d6178afe1e87f)({
                data: {
                    "matchesAndSegmentsData": matchesAndSegmentsData,
                    "cashinData": cashinData,
                    "tournamentDisplay": tournamentDisplay
                },
                index: index
            });
            // Tutorial action check
            (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_segment_continue");
        });
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_segment_winner");
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("play_segment");
    } catch (error) {
        (0, $3E8Nt.captureError)(error);
    }
    else {
        let text;
        if (data["error"] === "team-members-not-found") text = "Team members could not be found for {0}. Try removing this Segment.".format(data["teamName"]);
        else if (data["error"] === "championship-not-selected") text = "Please rebook this segment and select a championship to award.";
        else text = "There was an error playing this Segment";
        notie.alert({
            type: 3,
            text: text
        });
    }
}
function $67cc16607ee33ebf$var$showSegmentPopularityChanges(data, segment, winnerName) {
    $(".match-wrestler").each(function(i) {
        let wrestlerDiv = $(this);
        let wrestlerName = wrestlerDiv.text();
        if (wrestlerDiv.attr("data-name")) wrestlerName = wrestlerDiv.attr("data-name");
        let singles = segment["participants"].length === 2;
        // Losers
        if (!(wrestlerName === winnerName)) $(this).addClass("opaque"); // Darken losers' names
        else {
            // Show winner' changes if participants are 10 or less
            if (segment["participants"].length <= 10) {
                if (data["popularityChange"] !== null) {
                    let increase = data["popularityChange"];
                    let color = "green";
                    if (increase < 0) {
                        color = "dark-red";
                        increase = "- " + increase * -1;
                    } else increase = "+ " + increase;
                    if (singles) {
                        if (i === 1) $(this).parent().prepend('<div class="match-stat ' + color + '">' + increase + "</div>");
                        else $(this).parent().prepend('<div class="match-stat ' + color + '">' + increase + "</div>");
                    } else $(this).parent().prepend('<div class="match-stat ' + color + '">' + increase + "</div>");
                }
            }
        }
    });
    // Show popularity change
    $("#match").find(".match-stat, .match-stat-large-tag").each(function() {
        $(this).hide().slideDown("slow");
    });
}
function $67cc16607ee33ebf$var$showSegmentActionText(segment) {
    let segmentActionText = $67cc16607ee33ebf$var$getSegmentActionText(segment);
    $(segmentActionText).hide().appendTo($("#match-info")).fadeIn(700);
    $(".segment-start-text").removeClass("medium-dark-grey").addClass("light-grey");
}
function $67cc16607ee33ebf$var$getSegmentActionText(segment) {
    let segmentActionText;
    if (segment["actionTexts"] && segment["actionTexts"].length) // Custom text
    segmentActionText = $67cc16607ee33ebf$var$formatSegmentText((0, $3E8Nt.getRandomChoice)(segment["actionTexts"]));
    else if (segment["text"]) {
        // Get singles or tag custom text
        let segmentText = segment["text"];
        if (segmentText["actionTag"] && segment["participantsType"] === "tag") segmentActionText = $67cc16607ee33ebf$var$formatSegmentText((0, $3E8Nt.getRandomChoice)(segmentText["actionTag"]));
        else segmentActionText = $67cc16607ee33ebf$var$formatSegmentText((0, $3E8Nt.getRandomChoice)(segmentText["action"]));
    } else {
        let segmentTexts = (0, $1JkT6.segmentsData)[segment["name"]];
        // Get texts based on number of participants if text has this data
        if (segmentTexts["participants"]) segmentTexts = segmentTexts["participants"][segment["participantsNumber"]];
        // Get faction texts
        if (segment["factionSegment"]) {
            if (segment["factionSuperstarsMultiple"]) segmentActionText = segmentTexts["actionTag"];
            else segmentActionText = segmentTexts["action"];
        } else if (segmentTexts["actionTag"] && segment["participantsType"] === "tag") segmentActionText = segmentTexts["actionTag"];
        else segmentActionText = segmentTexts["action"];
        if (segmentTexts["choices"]) {
            let choice;
            if (segment["participantsType"] === "tag" && segmentTexts["choicesTag"]) choice = (0, $3E8Nt.getRandomChoice)(segmentTexts["choicesTag"]);
            else choice = (0, $3E8Nt.getRandomChoice)(segmentTexts["choices"]);
            segmentActionText = segmentActionText.format(choice);
            // Shuffle participants for generated text
            segment["participants"] = (0, $3E8Nt.shuffle)(segment["participants"]);
        }
    }
    // Format segment text objects
    let segmentTextObjects = $67cc16607ee33ebf$var$getSegmentTextObjects(segment);
    segmentActionText = segmentActionText.formatUnicorn(segmentTextObjects);
    // Apply sentence case for special segments
    if (segment["special"]) segmentActionText = (0, $1JSre.applySentenceCase)(segmentActionText);
    return '<span class="font-bold display-block medium-dark-grey segment-action-text">' + segmentActionText + "</span>";
}
function $67cc16607ee33ebf$var$getSegmentTextObjects(segment) {
    // Get names and pronouns
    let segmentTextObjects = segment["pronouns"].map(function(obj) {
        return Object.keys(obj).sort().map(function(key) {
            return obj[key];
        });
    }).flat();
    // Highlight patreon superstar for Local Squash segment
    if (segment["name"] === "Local Squash" && segment["usePatreonSuperstar"]) segmentTextObjects[segmentTextObjects.length - 1] = '<span class="faded-blue help-text" title="A Face of the Company Patreon who somehow ended up backstage">' + segmentTextObjects[segmentTextObjects.length - 1] + "</span>";
    return segmentTextObjects;
}
function $67cc16607ee33ebf$var$showSegmentResult(data, segment, winnerName) {
    // Show result
    let eventResultsSelector = $("#event-match-results");
    let segmentResultHtml = $67cc16607ee33ebf$var$getSegmentResultHtml(data, segment, winnerName);
    eventResultsSelector.find(".empty-event-match-results-text").remove();
    eventResultsSelector.fadeIn("slow");
    eventResultsSelector.find(".event-results-header").after('<div class="margin-bottom-8 match-result" tabindex="0">' + segmentResultHtml + "</div>");
    // Show segment text in results
    let segmentText = $(".segment-start-text").text() + " " + $(".segment-action-text").text();
    eventResultsSelector.find(".match-result").first().after('<span class="display-block margin-bottom-20 dark-grey segment-result-text">' + segmentText + "</span>");
}
function $67cc16607ee33ebf$var$getSegmentResultHtml(data, segment, winnerName) {
    // Load match result settings
    let matchResultSetting = (0, $98xmD.globalUser).settings["matchResult"];
    let XPClass = "match-result-xp";
    let overnessClass = "match-result-overness";
    let popularityClass = "match-result-popularity";
    let feudsClass = "match-result-feuds";
    let gimmickEffectivenessClass = "match-result-gimmick-effectiveness";
    let moraleClass = "match-result-morale";
    let eventUpdatesFeudsSelector = $(".event-updates-feuds .updates-container");
    if (matchResultSetting) {
        if (!matchResultSetting.xp) XPClass += " display-none";
        if (!matchResultSetting.overness) overnessClass += " display-none";
        if (!matchResultSetting.popularity) popularityClass += " display-none";
        if (!matchResultSetting.gimmickEffectiveness) gimmickEffectivenessClass += " display-none";
        if (!matchResultSetting.feuds) feudsClass += " display-none";
        if (matchResultSetting.morale === false) moraleClass += " display-none";
    } else {
        XPClass += " display-none";
        gimmickEffectivenessClass += " display-none";
    }
    // For segments without choosing a winner
    if (!winnerName) winnerName = data["winnerName"];
    // Add participant names, xp and pop change
    let icon = "fa-angle-double-up";
    let popClass = "green";
    if (data["popularityChange"] < 0) {
        data["popularityChange"] *= -1;
        icon = "fa-angle-double-down";
        popClass = "dark-red";
    }
    if (data["hotSegment"]) popClass = "hot-color";
    let participantsData = [];
    data["participantsData"].forEach(function(participant) {
        let html = "";
        let gimmickEffectivenessChange = "";
        if (participant["gimmickEffectivenessChange"]) {
            // Show effectiveness change
            let prefix = "+ ";
            if (participant["gimmickEffectivenessChange"] < 0) {
                prefix = "- ";
                participant["gimmickEffectivenessChange"] *= -1;
            }
            gimmickEffectivenessChange = '<span class="character-label margin-left-8 ' + gimmickEffectivenessClass + ' help-text" title="Gimmick Effectiveness Change">' + prefix + participant["gimmickEffectivenessChange"] + '<span class="margin-left-2">%</span></span>';
        }
        let overnessChange = "";
        let participantOvernessChange = participant["overnessChange"];
        if (participantOvernessChange) {
            let prefix = "+ ";
            if (participantOvernessChange < 0) {
                prefix = "- ";
                participantOvernessChange *= -1;
                overnessChange = '<span class="stale-color ' + overnessClass + ' margin-left-8 help-text" title="Overness Change">' + prefix + participantOvernessChange + '<span class="margin-left-2">%</span></span>';
            } else overnessChange = '<span class="hot-color ' + overnessClass + ' margin-left-8 help-text" title="Overness Change">' + prefix + participantOvernessChange + '<span class="margin-left-2">%</span></span>';
        }
        let hotOrStaleIcon = "";
        if (participant["hot"]) hotOrStaleIcon = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass + '" title="Being Over boosts ' + " a Superstar's Charisma, Popularity changes and Gimmick Effectiveness changes in Segments.\">";
        else if (participant["stale"]) hotOrStaleIcon = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass + '" title="Being Stale' + " lowers the ratings of a Superstar's Segments and their Popularity gains.\">";
        // Morale change
        let moraleChange = "";
        let participantMoraleChange = participant["moraleChange"];
        if (participantMoraleChange) {
            let prefix = "+ ";
            if (participantMoraleChange < 0) {
                prefix = "- ";
                participantMoraleChange *= -1;
                moraleChange = '<span class="margin-left-8 morale-dissatisfied-color ' + moraleClass + ' help-text" title="Morale Change">' + prefix + participantMoraleChange + '<span class="margin-left-2">%</span></span>';
            } else moraleChange = '<span class="margin-left-8 light-green ' + moraleClass + ' help-text" title="Morale Change">' + prefix + participantMoraleChange + '<span class="margin-left-2">%</span></span>';
        }
        html += participant["name"] + hotOrStaleIcon;
        if (!segment["productionSegment"] && participant["xpGained"] !== undefined) html += '<span class="faded-purple margin-left-8 + ' + XPClass + ' help-text" title="XP Change">+ ' + participant["xpGained"] + " XP</span>";
        html += gimmickEffectivenessChange + overnessChange + moraleChange;
        if (data["popularityChange"] !== null) {
            // Show popularity change
            let winnerCheck = participant["name"] === winnerName;
            if (data["hotSegment"] || winnerCheck) html += '<span class="' + popClass + " " + popularityClass + ' help-text" title="Popularity Change">' + '<i class="fa ' + icon + ' margin-left-8 margin-right-5"></i>' + data["popularityChange"] + "</span>";
        }
        // Get managers
        let managersHtml = $67cc16607ee33ebf$export$c79dd895db6e3598(participant["managersData"], "segment");
        html += managersHtml;
        participantsData.push(html);
    });
    // Join participants
    let participantsHtml;
    if (participantsData.length > 1) participantsHtml = participantsData.slice(0, -1).join(", ") + ' <span class="grey">and</span> ' + participantsData.slice(-1);
    else if (participantsData.length > 0) participantsHtml = participantsData[0];
    else {
        if (data["consequenceRunOn"]) {
            // Add consequence run on (production segments)
            participantsHtml = data["consequenceRunOn"];
            // Show hype boost
            if (data["hypeBoostAdded"]) participantsHtml += '<span class="faded-red"><i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i><i class="fa fa-bolt margin-right-5"></i>' + data["hypeBoostAdded"] + "</span>";
            // Show popularity boost
            if (data["popularityBoostAdded"]) participantsHtml += '<span class="medium-grey"><i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i>' + data["popularityBoostAdded"] + "</span>";
        } else if (segment["pronouns"].length > 0) participantsHtml = segment["pronouns"][0]["name"];
    }
    // Add feuds and hype change
    let feudsHtml = "";
    data["feuds"].forEach(function(feud) {
        // Hype change
        let hypeChange;
        if (feud["hypeChange"] < 0) {
            feud["hypeChange"] *= -1;
            hypeChange = '<i class="fa fa-angle-double-down margin-left-8 margin-right-8"></i><i class="fa fa-bolt margin-right-5"></i>' + feud["hypeChange"];
        } else hypeChange = '<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i><i class="fa fa-bolt margin-right-5"></i>' + feud["hypeChange"];
        let feudName = feud["name"];
        if (feud["ended"]) feudName += ' <span class="bright-red">Blowoff</span>';
        else if (feud["stale"]) {
            let participantNames = feud["participants"].join(" and ");
            let feudName = feud["name"];
            let overnessChange = '<span class="stale-color">' + feud["overnessDecrease"] + '<span class="margin-left-2">%</span></span>';
            let text = '<span class="faded-red-light">' + feudName + "</span>" + " Feud between " + participantNames + ' became <span class="stale-color">Stale</span>' + " with the Fans, lowering the Overness of its Participants by " + overnessChange + " each and decreasing its Hype.";
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' + text + "</span>");
        } else if (feud["staleWarning"]) {
            let participantNames = feud["participants"].join(" and ");
            let feudName = feud["name"];
            let text = '<span class="faded-red-light">' + feudName + " Feud</span>" + " between " + participantNames + ' is starting to become <span class="stale-color">Stale</span> with the Fans.';
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' + text + "</span>");
        }
        let feudClass = "faded-red-light";
        if (data["hotSegment"] || feud["hot"]) feudClass = "hot-color";
        feudsHtml += '<span class="margin-left-8 ' + feudsClass + '">' + '<span class="faded-red-light">' + feudName + "</span>" + '<span class="' + feudClass + '">' + '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud["hype"] + '<span class="faded-red">' + hypeChange + "</span>" + "</span>" + "</span>";
    });
    // Set rating
    let rating;
    let ratingText;
    let ratingValue = data["rating"];
    let ratingFloor = Math.floor(ratingValue);
    if (ratingFloor === 0) ratingText = '<i class="fa fa-star star-under"></i>'.repeat(5);
    else {
        let decimalRating = ratingValue - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) decimalRating = 0.70;
            else if (decimalRating === 0.25) decimalRating = 0.35;
            ratingText += '<i class="star star-under fa fa-star"><i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' + "</i>";
            if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
        } else if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
    }
    rating = '<span class="display-block match-star-rating help-text" title="Rating: Determined by a Segment\'s Effectiveness and its Entertainment and Action points"><span class="dark-grey" role="text" aria-label="' + data["rating"] + " stars" + '">' + ratingText + "</span></span>";
    // Show effectiveness
    let effectiveness = '<span class="display-block margin-top-10 help-text" title="Effectiveness: Determined by a Segment\'s Difficulty and the Charisma of the Participants."><span class="grey">' + Math.round(parseFloat(data["effectiveness"]) * 10000) / 100 + "% Eff." + "</span></span>";
    // Show negative multiplier
    let alreadyHeld = "";
    if (data["segmentAlreadyHeld"]) alreadyHeld = '<span class="display-block margin-top-2 help-text" title="Using a Segment already held at the Event or in the Feud reduces its Rating"><span class="grey">Already held</span></span>';
    // Show pure multipliers
    let pureBoost = "";
    if (data["pureNegativeBoost"]) pureBoost = '<span class="display-block margin-top-2 help-text" title="Silly Segments have a chance to decrease Segment ratings in a Pure Company"><span class="grey">Silly Decrease</span></span>';
    else if (data["purePositiveBoost"]) pureBoost = '<span class="display-block margin-top-2 help-text" title="Action focused Segments have a chance to increase Segment ratings in a Pure Company"><span class="grey">Action Boost</span></span>';
    // Show silly result
    let sillyResult = "";
    if (data["sillySuccess"]) sillyResult = '<span class="display-block margin-top-2 help-text" title="Silly Segments with a high Rating can be comedy gold, further boosting the Segment\'s Rating"><span class="gold">Comedy Gold</span></span>';
    else if (data["sillyFailure"]) sillyResult = '<span class="display-block margin-top-2 help-text" title="Silly Segments with a low Rating can be a flop, further lowering the Segment\'s Rating"><span class="puke-green">Flop</span></span>';
    // Producer focus effect
    let producerFocusEffectHtml = "";
    if (data["ratingData"] && data["ratingData"]["producerFocusEffect"]) {
        let producerFocusEffect = data["ratingData"]["producerFocusEffect"];
        let producerFocusEffectClass = "";
        let producerFocusEffectIcon = "";
        if (producerFocusEffect >= 0) {
            producerFocusEffectClass = "green";
            producerFocusEffectIcon = '<i class="fa fa-angle-double-up margin-right-5"></i>';
        } else {
            producerFocusEffectClass = "dark-red";
            producerFocusEffect *= -1;
            producerFocusEffectIcon = '<i class="fa fa-angle-double-down margin-right-5"></i>';
        }
        if (producerFocusEffect === 0.25) producerFocusEffect = 0.35;
        let producerFocusRatingHtml = '<i class="star star-under fa fa-star margin-left-5"><i class="star star-over fa fa-star ' + producerFocusEffectClass + '" style="width: ' + producerFocusEffect * 100 + '%"></i>' + "</i>";
        producerFocusEffectHtml = '<span class="display-block margin-top-2 help-text" title="Producers can focus on a segment to try and increase its rating."><span class="' + producerFocusEffectClass + ' line-height-1p4">' + producerFocusEffectIcon + "Producer Focus" + producerFocusRatingHtml + "</span></span>";
    }
    // Show producer xp change
    let producerXPChangeHtml = "";
    if (data["producerXpGained"]) {
        let producerXPGained = '<span class="green margin-left-8">+ ' + data["producerXpGained"] + " XP</span>";
        producerXPChangeHtml = '<div class="margin-top-5 font-0p925em medium-grey">' + data["producerName"] + producerXPGained + "</div>";
    }
    // Show result
    let text;
    let joinText = "between";
    if (segment["participants"].length === 1 || data["managerSegment"]) joinText = "with";
    if (segment["productionSegment"] || segment["participants"].length <= 0) joinText = "for";
    if (participantsHtml) {
        text = "<span class='faded-purple'>{0}</span> <span class='grey'>" + joinText + "</span> {1}";
        text = text.format(segment["name"], participantsHtml);
    } else {
        text = "<span class='faded-purple'>{0}</span>";
        text = text.format(segment["name"]);
    }
    return "<div class=col1>" + text + feudsHtml + producerXPChangeHtml + "</div>" + '<div class="col2 text-right">' + rating + effectiveness + alreadyHeld + pureBoost + sillyResult + producerFocusEffectHtml + "</div>" + '<div class="clear"></div>';
}
function $67cc16607ee33ebf$export$c79dd895db6e3598(managersData, matchType) {
    let managersHtml = "";
    if (managersData.length > 0) {
        let managerHelpIcon = matchType === "segment" ? '<i class="fa fa-angle-double-up help-text margin-left-5 manager-color font-17px" title="Full-time Managers affect Segment Rating, depending on their Charisma"></i>' : '<i class="fa fa-angle-double-up help-text margin-left-5 manager-color font-17px" title="Full-time Managers have a chance to remove penalties for Dusty Match Finishes"></i>';
        // Get manager data for each manager of participant
        let participantManagerHtmls = [];
        managersData.forEach(function(managerData) {
            let participantManagerHtml;
            if (managerData["fullTimeManager"]) participantManagerHtml = "{0}{1}".format(managerData["name"], managerHelpIcon);
            else participantManagerHtml = "{0}".format(managerData["name"]);
            participantManagerHtmls.push(participantManagerHtml);
        });
        managersHtml = '<span class="margin-left-5 grey"><span>w/</span> {0}</span>'.format((0, $3E8Nt.commaSeparate)(participantManagerHtmls, " <span>and</span> "));
    }
    return managersHtml;
}
function $67cc16607ee33ebf$var$showSegmentUpdates(data, segment) {
    let eventUpdatesSelector = $(".event-updates-other .updates-container");
    let eventUpdatesAvailabilitySelector = $(".event-updates-availability .updates-container");
    let eventUpdatesOvernessSelector = $(".event-updates-overness .updates-container");
    let eventUpdatesGimmicksSelector = $(".event-updates-gimmicks .updates-container");
    let eventUpdatesFeudsSelector = $(".event-updates-feuds .updates-container");
    let prestigeResultsSelector = $("#prestige-results");
    // Show heel turns
    data["turnedHeel"].forEach(function(turn) {
        let turnText = "";
        if (turn["shocking"]) {
            let overnessIncrease = '<span class="hot-color">' + turn["overnessChange"] + '<span class="margin-left-2">%</span></span>';
            turnText = '<span class="holy-shit-text">HOLY SHIT! </span>' + turn["name"] + ' turned <span class="alignment-heel">Heel</span> in a shocking move, ' + "boosting " + turn["pronoun"] + " Overness by " + overnessIncrease + "</span>";
            setTimeout(function() {
                $(".holy-shit-text").addClass("flash-text-grey");
            }, 200);
            setTimeout(function() {
                $(".holy-shit-text").removeClass("flash-text-grey");
            }, 2000);
        } else if (turn["tooSoon"]) {
            let overnessDecrease = '<span class="stale-color">' + turn["overnessChange"] * -1 + '<span class="margin-left-2">%</span></span>';
            turnText = turn["name"] + ' turned <span class="alignment-heel">Heel</span> too soon after a previous turn, ' + "lowering " + turn["pronoun"] + " Overness by " + overnessDecrease + "</span>";
        } else turnText = turn["name"] + ' turned <span class="alignment-heel">Heel</span>!';
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + turnText + "</span>");
    });
    // Show face turns
    data["turnedFace"].forEach(function(turn) {
        let turnText = "";
        if (turn["shocking"]) {
            let overnessIncrease = '<span class="hot-color">' + turn["overnessChange"] + '<span class="margin-left-2">%</span></span>';
            turnText = '<span class="holy-shit-text">HOLY SHIT! </span>' + turn["name"] + ' turned <span class="alignment-face">Face</span> in a shocking move, ' + "boosting " + turn["pronoun"] + " Overness by " + overnessIncrease + "</span>";
            setTimeout(function() {
                $(".holy-shit-text").addClass("flash-text-grey");
            }, 200);
            setTimeout(function() {
                $(".holy-shit-text").removeClass("flash-text-grey");
            }, 2000);
        } else if (turn["tooSoon"]) {
            let overnessDecrease = '<span class="stale-color">' + turn["overnessChange"] * -1 + '<span class="margin-left-2">%</span></span>';
            turnText = turn["name"] + ' turned <span class="alignment-face">Face</span> too soon after a previous turn, ' + "lowering " + turn["pronoun"] + " Overness by " + overnessDecrease + "</span>";
        } else turnText = turn["name"] + ' turned <span class="alignment-face">Face</span>!';
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + turnText + "</span>");
    });
    // Show neutral turns
    data["turnedNeutral"].forEach(function(turn) {
        let turnText = turn["name"] + ' turned <span class="alignment-neutral">Neutral</span>!';
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + turnText + "</span>");
    });
    data["debutedGimmicks"].forEach(function(gimmick) {
        let gimmickDebutHtml = (0, $1JSre.getGimmickDebutHtml)(gimmick);
        eventUpdatesGimmicksSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + gimmickDebutHtml + "</span>");
    });
    // Charisma increases
    data["charismaIncreases"].forEach(function(superstar) {
        let text = '{0}\'s <span class="charisma-purple">Charisma</span> increased to <span class="gold">Level {1}</span>'.format(superstar["name"], superstar["level"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Show vacated titles
    data["vacated"].forEach(function(vacated) {
        let text;
        let championshipName = (0, $1JSre.getChampionshipDisplayName)(vacated);
        if (!vacated["tagTeam"] && !vacated["trio"]) text = '<span class="gold">' + championshipName + "</span>" + " has been vacated";
        else text = '<span class="gold">' + championshipName + "</span>" + " have been vacated";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Show awarded titles
    data["awarded"].forEach(function(awarded) {
        let text;
        let championshipName = (0, $1JSre.getChampionshipDisplayName)(awarded);
        if (!awarded["tagTeam"] && !awarded["trio"]) text = '<span class="gold">' + championshipName + "</span>" + " has been awarded to " + segment["participants"][0]["name"];
        else text = '<span class="gold">' + championshipName + "</span>" + " have been awarded to " + segment["participants"][0]["name"];
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Show created titles
    data["createdChampionships"].forEach(function(created) {
        let text;
        let championshipName = (0, $1JSre.getChampionshipDisplayName)(created);
        if (!created["tagTeam"] && !created["trio"]) text = '<span class="gold">' + championshipName + "</span>" + " has been created";
        else text = '<span class="gold">' + championshipName + "</span>" + " have been created";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Fired
    data["fired"].forEach(function(superstar) {
        let overnessDecrease = '<span class="stale-color">' + superstar["overnessDecrease"] + '<span class="margin-left-2">%</span></span>';
        let text = superstar["name"] + " was fired from the company, " + "lowering " + superstar["pronoun"] + " Overness by " + overnessDecrease;
        eventUpdatesAvailabilitySelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Feuds started
    data["feudsStarted"].forEach(function(feud) {
        let feudStartedHtml = (0, $1JSre.getFeudStartedHtml)(feud);
        eventUpdatesFeudsSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + feudStartedHtml + "</span>");
    });
    // Feud Potentials
    data["feudPotentials"].forEach(function(feud) {
        let feudPotentialHtml = (0, $1JSre.getFeudPotentialHtml)(feud);
        eventUpdatesFeudsSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + feudPotentialHtml + "</span>");
    });
    // Feud Potential
    data["feudHypeIncreased"].forEach(function(feud) {
        let feudHypeIncreased = (0, $1JSre.getFeudHypeIncreasedHtml)(feud);
        eventUpdatesFeudsSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + feudHypeIncreased + "</span>");
    });
    // Feud blowoff results
    data["feudsEnded"].forEach(function(feud) {
        let participantNames = feud["participants"].join(" and ");
        let feudName = feud["name"];
        let rating = '<span class="display-inline-block margin-left-8 top--1px">' + (0, $1JSre.getStarRatingHtml)(feud["rating"]) + "</span>";
        let text = '<span class="faded-red-light">' + feudName + "</span>" + " Feud between " + participantNames + " ended after the Blowoff" + rating;
        eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' + text + "</span>");
    });
    // Feud prestige
    data["feudItemsLevelData"].forEach(function(levelData) {
        let levelText;
        let progress;
        let levelXp;
        if (levelData["level"] < 3) {
            levelXp = Math.pow(levelData["level"], 2) * 40;
            progress = levelData["xp"] / levelXp * 100;
        } else {
            levelXp = Math.pow(2, 2) * 40;
            progress = 100;
        }
        // Set level
        let level;
        switch(levelData["level"]){
            case 1:
                level = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case 2:
                level = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case 3:
                level = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }
        let xpChangeHtml;
        let xpChange = levelData["xpChange"];
        if (xpChange >= 0) xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + "</span>";
        else if (xpChange < 0) xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' + -1 * xpChange + "</span>";
        levelText = '<div class="display-block margin-bottom-5"><div class="display-inline-block"><span>' + levelData["name"] + "</span>" + level + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey prestige-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text" title="' + levelData["xp"] + " / " + levelXp + ' XP">' + '<div class="progress faded-red-light-background" style="width:' + progress + '%">' + "</div>" + "</div>";
        // Add level increase data
        if (levelData["levelIncrease"]) levelText += '<span class="gold display-block margin-top-12 margin-bottom-2">Level Up!</span><span class="display-block medium-grey">Base Hype<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i><span class="faded-red-light"><i class="fa fa-bolt margin-right-5"></i>' + levelData["hypeIncrease"] + "</span>" + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after('<div class="feud-item-level margin-bottom-25">' + levelText + "</div>");
        // Animate XP and progress
        $(".feud-item-level .prestige-xp-value").last().hide().fadeIn("slow");
        setTimeout(function() {
            $(".feud-item-level .progress").last().addClass("expand-width");
        }, 0);
        setTimeout(function() {
            $(".feud-item-level .progress").last().removeClass("expand-width");
        }, 1800);
    });
    // Show segment item prestige change
    let levelData = data["segmentItemLevelData"];
    if (levelData) {
        let levelHtml = $67cc16607ee33ebf$var$getSegmentItemPrestigeChangeHtml(levelData);
        prestigeResultsSelector.find(".event-prestige-header").after('<div class="segment-item-level margin-bottom-25">' + levelHtml + "</div>");
        // Animate XP and progress
        $(".segment-item-level .prestige-xp-value").last().hide().fadeIn("slow");
        setTimeout(function() {
            $(".segment-item-level .progress").last().addClass("expand-width");
        }, 0);
        setTimeout(function() {
            $(".segment-item-level .progress").last().removeClass("expand-width");
        }, 1800);
    }
    // Disbanded tag teams
    if (data["disbanded"].length > 0) {
        let text = "{0} have disbanded".format((0, $3E8Nt.commaSeparate)(data["disbanded"]));
        eventUpdatesAvailabilitySelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    }
    // Show overness change
    if (data["hotSegment"]) {
        let overnessChange = '<span class="hot-color">' + data["hotSegmentOvernessIncrease"] + '<span class="margin-left-2">%</span></span>';
        // Get participant names
        let participantNames = data["participantsData"].map((x)=>x["name"]);
        let pronoun = "their";
        let endText = " each.";
        let participantsText;
        if (participantNames.length > 1) participantsText = participantNames.slice(0, -1).join(", ") + " and " + participantNames.slice(-1);
        else {
            participantsText = participantNames[0];
            pronoun = data["participantsData"][0]["pronoun"];
            endText = ".";
        }
        let segmentTypeText = '<span class="hot-color">Hot</span>';
        if (data["specialSegment"]) segmentTypeText = '<span class="special-segment-color">Special</span>';
        let eventHypeBoost = "";
        if (data["eventHypeBoostData"]) {
            if (data["eventHypeBoostData"]["hotSegmentBoost"]) eventHypeBoost = ' A lot of viewers tuned in to watch.<span class="medium-dark-grey margin-left-8">+ ' + data["eventHypeBoostData"]["hypeBoost"] + " HYPE</span>";
        }
        let hotSegmentText = participantsText + " put on a " + segmentTypeText + " Segment, " + "boosting " + pronoun + " Overness by " + overnessChange + endText + eventHypeBoost;
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + hotSegmentText + "</span>");
    }
    // Show hot feuds
    data["hotFeuds"].forEach(function(feud) {
        let overnessChange = '<span class="hot-color">' + feud["overnessIncrease"] + '<span class="margin-left-2">%</span></span>';
        // Get participant names
        let participantNames = [
            ...feud["participants"]
        ];
        let participantsText = participantNames.slice(0, -1).join(", ") + " and " + participantNames.slice(-1);
        let feudName = feud["name"];
        let hotFeudText = '<span class="faded-red-light">{0}</span> Feud between {1} became <span class="hot-color">Hot</span>,'.format(feudName, participantsText) + " boosting its chance to have Hot Matches and Segments and the Overness of the Participants by " + overnessChange + " each.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + hotFeudText + "</span>");
    });
    // Overness changes
    data["overnessChanges"].forEach(function(overnessChange) {
        let overnessPercentage = '<span class="light-grey margin-left-5">' + overnessChange["overness"] + '<span class="margin-left-2">%</span></span>';
        let changeWord = overnessChange["increase"] ? "increased" : "decreased";
        let text = "{0}'s Overness{1} ".format(overnessChange["name"], overnessPercentage) + changeWord + ' from <span class="light-grey">' + overnessChange["previousOverness"] + " to " + overnessChange["currentOverness"] + "</span>";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Hot changes
    data["hotChanges"].forEach(function(hotChange) {
        let text = "";
        if (hotChange["status"] === "hotStart") text = hotChange["name"] + ' is starting to get <span class="hot-color">Over</span> with the Fans';
        else if (hotChange["status"] === "hotEnd") text = hotChange["name"] + ' is no longer <span class="hot-color">Over</span> with the Fans. ' + "All boosts have been removed.";
        else if (hotChange["status"] === "hot") text = hotChange["name"] + ' got <span class="hot-color hot-text">Over</span> with the Fans, ' + " boosting " + hotChange["pronoun"] + " Workrate, Charisma, Popularity Changes, Gimmick Effectiveness, " + " Feud Hypes and the chance to have Hot Matches and Segments.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        setTimeout(function() {
            $(".hot-text").addClass("flash-text-orange");
        }, 200);
        setTimeout(function() {
            $(".hot-text").removeClass("flash-text-orange");
        }, 3000);
    });
    // Stale changes
    data["staleChanges"].forEach(function(staleChange) {
        let text;
        if (staleChange["status"] === "staleStart") text = staleChange["name"] + ' is starting to become <span class="stale-color">Stale</span> with the Fans';
        else if (staleChange["status"] === "staleEnd") text = staleChange["name"] + ' is no longer <span class="stale-color">Stale</span> with the Fans. ' + "All negative boosts have been removed.";
        else if (staleChange["status"] === "stale") text = staleChange["name"] + ' became <span class="stale-color stale-text">Stale</span> with the Fans, ' + " lowering " + staleChange["pronoun"] + " performance in Matches, Segments and Feuds.";
        eventUpdatesOvernessSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        setTimeout(function() {
            $(".stale-text").addClass("flash-text-stale");
        }, 200);
        setTimeout(function() {
            $(".stale-text").removeClass("flash-text-stale");
        }, 3000);
    });
    // Gimmick effectiveness level changes
    data["gimmickEffectivenessLevelChanges"].forEach(function(gimmickLevelChange) {
        let gimmickLevelChangeHtml = (0, $1JSre.getGimmickEffectivenessLevelChangeHtml)(gimmickLevelChange);
        eventUpdatesGimmicksSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + gimmickLevelChangeHtml + "</span>");
    });
    // Morale changes
    data["moraleChanges"].forEach(function(moraleChange) {
        let moralePercentage = '<span class="light-grey margin-left-5">' + moraleChange["morale"] + '<span class="margin-left-2">%</span></span>';
        let text = "{0}'s Morale{1} ".format(moraleChange["name"], moralePercentage) + ' changed to <span class="light-grey">' + moraleChange["currentMorale"] + '</span> from <span class="light-grey">' + moraleChange["previousMorale"] + "</span>";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Staff skill increases
    data["staffSkillIncreases"].forEach(function(staffMember) {
        let roleHtml = '<span class="light-grey">(' + (0, $3E8Nt.toTitleCase)(staffMember["role"].replace(/_/g, " ")) + ")</span>";
        let skillLevelHtml = '<span class="staff-color">Skill</span>';
        let text = '{0}\'s {1} {2} increased to <span class="gold">Level {3}</span>'.format(staffMember["name"], roleHtml, skillLevelHtml, staffMember["level"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Suspensions
    data["suspended"].forEach(function(superstar) {
        let monthsWord = (0, $3E8Nt.getMonthsWord)(superstar["months"]);
        let text = "{0} has been suspended for {1} {2}".format(superstar["name"], superstar["months"], monthsWord);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Unavailable
    data["unavailable"].forEach(function(superstar) {
        let text = "{0} has left the company for some time".format(superstar["name"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Retirements
    data["retirements"].forEach(function(superstar) {
        let text;
        if (superstar["hallOfFame"]) text = superstar["name"] + " has retired and been inducted into the " + '<span class="gold">' + "Hall of Fame" + "</span>";
        else text = superstar["name"] + " has retired from wrestling";
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Tag Teams created
    data["teamsCreated"].forEach(function(team) {
        let text = "Created a Team of {0} called {1}".format(team["superstars"], team["name"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Special segment consequence
    if (data["specialSegmentConsequence"]) {
        let specialSegmentConsequence = data["specialSegmentConsequence"];
        if (specialSegmentConsequence["unavailableSuperstar"]) {
            let text = "{0} is not available for some time".format(specialSegmentConsequence["unavailableSuperstar"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (specialSegmentConsequence["unavailableStaffMember"]) {
            let text = "{0} is not available for some time".format(specialSegmentConsequence["unavailableStaffMember"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (specialSegmentConsequence["unhappySuperstars"]) {
            let text = "{0} are unhappy with the {1}".format((0, $3E8Nt.commaSeparate)(specialSegmentConsequence["unhappySuperstars"]), specialSegmentConsequence["unhappyReason"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (specialSegmentConsequence["suspendedSuperstar"]) {
            let text = "{0} has been suspended for 1 month".format(specialSegmentConsequence["suspendedSuperstar"]);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (specialSegmentConsequence["creativePointsPenalty"]) {
            let pointsHtml = '<span class="blue margin-right-3">{0}</span>'.format(specialSegmentConsequence["creativePointsPenalty"]);
            let pointsImageHtml = '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-3 margin-right-5"/>{0}'.format(pointsHtml);
            let text = "Due to sponsor backlash, {0} took away {1}".format(data["specialSegmentConsequence"]["ownerName"], pointsImageHtml);
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
    }
    // Faction segment consequence
    if (data["factionSegmentConsequence"]) {
        let factionSegmentConsequence = data["factionSegmentConsequence"];
        if (factionSegmentConsequence["removedFactionMembers"]) {
            // Get popularity change html
            let popularityChangeHtml = "";
            if (factionSegmentConsequence["popularityChange"]) {
                let popularityChangeValueHtml = "";
                if (factionSegmentConsequence["popularityChange"] < 0) popularityChangeValueHtml = '<span class="margin-left-2 red">- ' + factionSegmentConsequence["popularityChange"] * -1 + "</span>";
                else popularityChangeValueHtml = '<span class="margin-left-2 green">+ ' + factionSegmentConsequence["popularityChange"] + "</span>";
                popularityChangeHtml = ", changing Popularity by " + popularityChangeValueHtml + "</span>";
            }
            // Add removed members html
            let factionSegmentConsequenceVerb = factionSegmentConsequence["removedFactionMembers"].length < 2 ? "was" : "were";
            let text = (0, $3E8Nt.commaSeparate)(factionSegmentConsequence["removedFactionMembers"]) + " " + factionSegmentConsequenceVerb + " removed from " + factionSegmentConsequence["faction"] + popularityChangeHtml;
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (factionSegmentConsequence["addedFactionMembers"]) {
            // Get popularity change html
            let popularityChangeHtml = "";
            if (factionSegmentConsequence["popularityChange"]) {
                let popularityChangeValueHtml = "";
                if (factionSegmentConsequence["popularityChange"] < 0) popularityChangeValueHtml = '<span class="margin-left-2 red">- ' + factionSegmentConsequence["popularityChange"] * -1 + "</span>";
                else popularityChangeValueHtml = '<span class="margin-left-2 green">+ ' + factionSegmentConsequence["popularityChange"] + "</span>";
                popularityChangeHtml = ", changing Popularity by " + popularityChangeValueHtml + "</span>";
            }
            // Add added members html
            let factionSegmentConsequenceVerb = factionSegmentConsequence["addedFactionMembers"].length < 2 ? "was" : "were";
            let text = (0, $3E8Nt.commaSeparate)(factionSegmentConsequence["addedFactionMembers"]) + " " + factionSegmentConsequenceVerb + " added to " + factionSegmentConsequence["faction"] + popularityChangeHtml;
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (factionSegmentConsequence["setFactionLeader"]) {
            let text = factionSegmentConsequence["setFactionLeader"] + " was set as the leader of " + factionSegmentConsequence["faction"];
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (factionSegmentConsequence["movedFactionMembers"]) {
            let text = (0, $3E8Nt.commaSeparate)(factionSegmentConsequence["movedFactionMembers"]) + " left " + factionSegmentConsequence["faction"] + " and joined " + factionSegmentConsequence["consequenceFaction"];
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (factionSegmentConsequence["mergedFactions"]) {
            let text = (0, $3E8Nt.commaSeparate)(factionSegmentConsequence["mergedFactions"]) + " merged to form " + factionSegmentConsequence["createdFactionName"];
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (factionSegmentConsequence["newFactionMembers"]) {
            let text = (0, $3E8Nt.commaSeparate)(factionSegmentConsequence["newFactionMembers"]) + " left " + factionSegmentConsequence["faction"] + " to form " + factionSegmentConsequence["createdFactionName"];
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (factionSegmentConsequence["removedFactionLeader"]) {
            let text = factionSegmentConsequence["removedFactionLeader"] + " was removed as the leader of " + factionSegmentConsequence["faction"];
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (factionSegmentConsequence["disbandedFaction"]) {
            let text = factionSegmentConsequence["disbandedFaction"] + " have disbanded";
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        if (factionSegmentConsequence["createdFactionMembers"]) {
            let text = (0, $3E8Nt.commaSeparate)(factionSegmentConsequence["createdFactionMembers"]) + " formed " + factionSegmentConsequence["createdFactionName"];
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
    }
    // Managers added/removed
    data["managersAdded"].forEach(function(managerAdded) {
        let text = '<span class="display-block">Assigned {0} to manage {1}</span>'.format(managerAdded["managerName"], (0, $3E8Nt.commaSeparate)(managerAdded["managedSuperstarsNames"]));
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    data["managersRemoved"].forEach(function(managerRemoved) {
        let text = '<span class="display-block">Removed {0} from managing {1}</span>'.format(managerRemoved["managerName"], (0, $3E8Nt.commaSeparate)(managerRemoved["removedSuperstarsNames"]));
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Show faction reputation progress
    data["factionReputationsData"].forEach(function(factionReputationData) {
        (0, $1JSre.showFactionReputationData)(factionReputationData);
    });
    // Show championship prestige progress
    data["championshipPrestiges"].forEach(function(prestigeData) {
        let prestigeHtml = (0, $1JSre.getChampionshipPrestigeHtml)(prestigeData);
        prestigeResultsSelector.find(".event-prestige-header").after('<div class="championship-prestige margin-bottom-20">' + prestigeHtml + "</div>");
        $(".championship-prestige .prestige-xp").hide().fadeIn("slow");
        setTimeout(function() {
            $(".championship-prestige .progress").addClass("expand-width");
        }, 0);
        setTimeout(function() {
            $(".championship-prestige .progress").removeClass("expand-width");
        }, 1800);
    });
    // Show unlocked segment items
    data["unlockedSegmentItems"].forEach(function(segmentItem) {
        let unlockText = '<span class="faded-purple">' + segmentItem + "</span>" + " Segment Item unlocked!";
        let html = '<span class="display-block margin-bottom-15">' + unlockText + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after(html);
    });
    // Show unlocked championship segment items
    data["unlockedChampionshipSegmentItems"].forEach(function(segmentItem) {
        let unlockText = '<span class="faded-purple">' + segmentItem + "</span>" + " Championship Segment unlocked!";
        let html = '<span class="display-block margin-bottom-15">' + unlockText + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after(html);
    });
    // Show unlocked gimmick characters
    data["unlockedCharacters"].forEach(function(unlockedCharacter) {
        let unlockText = '<span class="character-label">' + unlockedCharacter["name"] + "</span>" + " Character unlocked due to the " + unlockedCharacter["originalCharacter"] + " Character getting Over!";
        let html = '<span class="display-block margin-bottom-15">' + unlockText + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after(html);
    });
    // Show unlocked feud items
    data["unlockedFeudItems"].forEach(function(feudItem) {
        let unlockText = '<span class="faded-red-light">' + feudItem + "</span>" + " Feud Item unlocked!";
        let html = '<span class="display-block margin-bottom-15">' + unlockText + "</span>";
        prestigeResultsSelector.find(".event-prestige-header").after(html);
    });
    // Brand changes
    data["brandChanges"].forEach(function(brandChange) {
        let text = '<span class="display-block">{0} moved to {1}</span>'.format(brandChange["name"], brandChange["brandName"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Mask removed
    data["maskRemoved"].forEach(function(maskRemoved) {
        let text = '<span class="display-block">{0} removed {1} mask!</span>'.format(maskRemoved["name"], maskRemoved["possessivePronoun"]);
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    });
    // Unified
    if (data["unifiedChampionships"]) {
        let unifiedData = data["unifiedChampionships"];
        let championshipVerb = unifiedData["multipleChampionships"] ? "have" : "has";
        let unifiedChampionshipsName = '<span class="gold">{0}</span>'.format(unifiedData["unifiedChampionships"]);
        let unifiedChampionshipWithName = '<span class="gold">{0}</span>'.format(unifiedData["unifiedChampionshipWith"]);
        let text = "{0} {1} been unified with the {2}".format(unifiedChampionshipsName, championshipVerb, unifiedChampionshipWithName);
        // Show new championship name
        if (unifiedData["newChampionshipName"]) text += ', creating the <span class="gold">{0}</span>'.format(unifiedData["newChampionshipName"]);
        // Show prestige xp change
        if (unifiedData["xpChange"]) {
            let xpChange = '<span class="green margin-left-5">+ ' + unifiedData["xpChange"] + " XP</span>";
            text += ", increasing Prestige {0}".format(xpChange);
        }
        eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
    }
    // Show event hype boosts
    let eventHypeBoostData = data["eventHypeBoostData"];
    if (eventHypeBoostData) {
        // Show debut boost
        let debutText;
        if (eventHypeBoostData["debutBoost"]) {
            debutText = "Former " + eventHypeBoostData["formerCompanyName"] + " talent " + data["participantsData"][0]["name"] + " showed up in " + eventHypeBoostData["companyName"] + "!";
            let text = debutText + " A lot of viewers tuned in to watch the debut." + '<span class="medium-dark-grey margin-left-8">+ ' + eventHypeBoostData["hypeBoost"] + " HYPE</span>";
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Show slander boost
        if (eventHypeBoostData["slanderBoost"]) {
            debutText = data["participantsData"][0]["name"] + " slandered " + eventHypeBoostData["competitorName"] + ".";
            let text = debutText + " It seemed to work, as a lot of viewers tuned in to watch the segment." + '<span class="medium-dark-grey margin-left-8">+ ' + eventHypeBoostData["hypeBoost"] + " HYPE</span>";
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Show slander penalty
        if (eventHypeBoostData["slanderPenalty"]) {
            debutText = data["participantsData"][0]["name"] + " slandered " + eventHypeBoostData["competitorName"] + ".";
            let text = debutText + " A lot of viewers found it in bad taste and tuned out." + '<span class="medium-dark-grey margin-left-8">- ' + eventHypeBoostData["hypeBoost"] * -1 + " HYPE</span>";
            eventUpdatesSelector.prepend('<span class="display-block margin-bottom-12 dark-grey">' + text + "</span>");
        }
        // Update event hype
        $(".event-hype-text").html((0, $e6954d9b34d9dd89$export$46dc9792936abd2f)(data["eventHype"])).hide().fadeIn("fast");
    }
}
function $67cc16607ee33ebf$export$32c25d7dd1621e23() {
    $(".gimmick-effectiveness").each(function(i, e) {
        let effectiveness = $(e).data("value");
        let animationStarted = $(e).data("animationStarted");
        if (!animationStarted) {
            let i = 0;
            let overnessChange = $(e).data("overness-change");
            let productionBoost = $(e).data("production-boost");
            $(e).data("animationStarted", true);
            let eff = setInterval(function() {
                $(e).text(i);
                i++;
                if (i === effectiveness + 1 || i > 120) {
                    clearInterval(eff);
                    // Gimmick Overness Effect Change
                    let overnessChangeHtml = "";
                    if (overnessChange !== 0) {
                        if (overnessChange < 0) {
                            overnessChange *= -1;
                            overnessChangeHtml = '<span class="red">- ' + overnessChange + "</span>";
                        } else overnessChangeHtml = '<span class="green">+ ' + overnessChange + "</span>";
                        overnessChangeHtml = '<span class="margin-left-8">changing Overness by ' + overnessChangeHtml + "</span>";
                    }
                    // Production Boost
                    let productionBoostHtml = "";
                    if (productionBoost) productionBoostHtml = '<div class="light-grey font-0p925em">(+ ' + productionBoost + "% Production Boost)</div>";
                    $(e).parent().next(".gimmick-effectiveness-text").html((0, $1JSre.getGimmickEffectivenessHtml)(effectiveness) + overnessChangeHtml + productionBoostHtml);
                }
                if (i > 120) $(e).text(effectiveness);
            }, 45, i);
        }
    });
}
function $67cc16607ee33ebf$var$getSegmentItemPrestigeChangeHtml(data) {
    let progress;
    let levelXp;
    if (data["level"] < 3) {
        levelXp = Math.pow(data["level"], 2) * 75;
        progress = data["xp"] / levelXp * 100;
    } else {
        levelXp = Math.pow(2, 2) * 75;
        progress = 100;
    }
    // Set level
    let level;
    switch(data["level"]){
        case 1:
            level = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
            break;
    }
    let xpChangeHtml;
    let xpChange = data["xpChange"];
    if (xpChange >= 0) xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + "</span>";
    else if (xpChange < 0) xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' + -1 * xpChange + "</span>";
    let prestigeChangeHtml = '<div class="display-block margin-bottom-5"><div class="display-inline-block"><span>' + data["name"] + "</span>" + level + "</div>" + '<div class="display-inline-block float-right">' + '<span class="margin-left-5 dark-grey prestige-xp">XP' + xpChangeHtml + "</span>" + "</div>" + "</div>" + '<div class="progress-under help-text" title="' + data["xp"] + " / " + levelXp + ' XP">' + '<div class="progress faded-purple-background" style="width:' + progress + '%">' + "</div>" + "</div>";
    // Add level increase data
    if (data["levelIncrease"]) {
        let perk;
        switch(data["addedPerk"]){
            case "entertainment":
                perk = "Entertainment increased for this Segment Item!";
                break;
            case "action":
                perk = "Action increased for this Segment Item!";
                break;
            case "difficulty":
                perk = "Difficulty decreased for this Segment Item!";
                break;
            case "hype":
                perk = "Hype Boost increased for this Segment Item!";
                break;
            case "popularity":
                perk = "Popularity Boost increased for this Segment Item!";
                break;
            case "cost":
                perk = "Cost decreased for this Segment Item!";
                break;
        }
        prestigeChangeHtml += '<span class="gold display-block margin-top-12 margin-bottom-2">Level Up!</span><span class="display-block medium-grey">' + perk + "</span>";
    }
    return prestigeChangeHtml;
}
function $67cc16607ee33ebf$export$45a344294533d7c2() {
    $(".updates-container").each(function(i, el) {
        if ($(el).children().length > 0) {
            $(el).parent().fadeIn("slow");
            $("#event-updates").fadeIn("slow");
        }
    });
    if ($("#prestige-results").children().length > 1) $("#prestige-results").fadeIn("slow");
}
function $67cc16607ee33ebf$var$formatSegmentText(text) {
    text = (0, $1JSre.replaceAll)(text, "{name}", "{0}");
    text = (0, $1JSre.replaceAll)(text, "{objective}", "{1}");
    text = (0, $1JSre.replaceAll)(text, "{possessive}", "{2}");
    text = (0, $1JSre.replaceAll)(text, "{pronoun}", "{3}");
    // Parse keywords for participants
    for(let i = 1; i < 9; i++){
        text = (0, $1JSre.replaceAll)(text, "{name{0}}".format(i), "{{0}}".format(4 * i - 4));
        text = (0, $1JSre.replaceAll)(text, "{objective{0}}".format(i), "{{0}}".format(4 * i - 3));
        text = (0, $1JSre.replaceAll)(text, "{possessive{0}}".format(i), "{{0}}".format(4 * i - 2));
        text = (0, $1JSre.replaceAll)(text, "{pronoun{0}}".format(i), "{{0}}".format(4 * i - 1));
    }
    return text;
}
function $67cc16607ee33ebf$export$bc6829a93fbd1f8a(participant) {
    let managerText = participant["managerNames"] && participant["managerNames"].length > 0 ? '<span class="grey display-block cursor-pointer"> w/ {0}</span>'.format((0, $3E8Nt.commaSeparate)(participant["managerNames"])) : "";
    return participant["name"] + managerText;
}
function $67cc16607ee33ebf$var$viewAnnualTournamentSegmentStart(segment, matchesAndSegmentsData, index, tournamentDisplay) {
    let matchInfoSelector = $("#match-info");
    matchInfoSelector.html("").removeClass("visibility-hidden").show();
    // Show segment name
    matchInfoSelector.append("<span class='font-bold display-block margin-bottom-3 faded-purple'>" + segment["name"] + "</span>");
    // Add start text
    let segmentStartText = (0, $3E8Nt.getRandomChoice)(segment["startTexts"]);
    let segmentStartHtml = '<span class="font-bold display-block margin-bottom-10 margin-top-10 medium-dark-grey segment-start-text">' + segmentStartText + "</span>";
    $(segmentStartHtml).hide().appendTo(matchInfoSelector).fadeIn(700);
    matchInfoSelector.fadeIn("slow");
    $("#match").html("").show();
    $("#match").append('<div class="match-superstar-information information-box"></div>');
    $(".match-superstar-information").hide();
    // Add information box
    $(".match-container").fadeIn("slow");
    $("#booking-talent-info").html("");
    // Load graphics
    (0, $c82cd471f4baff6b$export$4d95ef41d1462076)(segment);
    // Go to action text after some time
    setTimeout(function() {
        $67cc16607ee33ebf$var$viewAnnualTournamentSegmentAction(segment, matchesAndSegmentsData, index, tournamentDisplay);
    }, 2800);
}
function $67cc16607ee33ebf$var$viewAnnualTournamentSegmentAction(segment, matchesAndSegmentsData, index, tournamentDisplay) {
    let matchInfoSelector = $("#match-info");
    // Add action text
    let segmentActionText = (0, $3E8Nt.getRandomChoice)(segment["actionTexts"]);
    let segmentActionHtml = '<span class="font-bold display-block medium-dark-grey segment-action-text">' + segmentActionText + "</span>";
    $(segmentActionHtml).hide().appendTo(matchInfoSelector).fadeIn(700);
    $(".segment-start-text").removeClass("medium-dark-grey").addClass("light-grey");
    // Load graphics
    (0, $c82cd471f4baff6b$export$4d95ef41d1462076)(segment, true);
    // Show 'continue' button
    $(".match-superstar-information").before('<div class="margin-sides-auto margin-top-15"><button type="button" class="button retro-button grey-button-background" id="progress-segment-button">Continue</button></div>');
    // Increase index
    index++;
    // Progress segment handler
    $("#match").off("click", "#progress-segment-button");
    $("#match").on("click", "#progress-segment-button", async function() {
        await (0, $e6954d9b34d9dd89$export$6f7d6178afe1e87f)({
            data: {
                "matchesAndSegmentsData": matchesAndSegmentsData,
                "cashinData": {},
                "tournamentDisplay": tournamentDisplay
            },
            index: index
        });
    });
}


let $9f0f3c0f4508366a$export$4acf80557bedaca3 = {
    addCustomSegmentChangesMade: false
};
async function $9f0f3c0f4508366a$export$e5b3071bfae896f2() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getViewSegmentsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $9f0f3c0f4508366a$var$showViewSegmentsPageData(data);
}
function $9f0f3c0f4508366a$var$showViewSegmentsPageData(data) {
    const $viewSegmentsItemsContainer = $(".view-segments-items-container");
    // Reset
    $viewSegmentsItemsContainer.html("");
    // Add segment items
    data["segmentItems"].forEach(function(item) {
        let segmentItemHtml = $9f0f3c0f4508366a$var$getViewSegmentsPageSegmentItemHtml(item);
        $(".view-segments-items-container").append(segmentItemHtml);
    });
    if (data["segmentItems"].length === 0) {
        let div = '<div class="view-segments-item"><div><span class="grey">No Custom Segments present</span></div></div>';
        $(".view-segments-items-container").append(div);
    }
    $("#view-segments-container").fadeIn("slow");
    $(".add-custom-segment-container").find(".back-to-view-segments-button").show();
    $viewSegmentsItemsContainer.scrollTop(0);
}
function $9f0f3c0f4508366a$var$getViewSegmentsPageSegmentItemHtml(segmentItem) {
    // Set level
    let level = "";
    switch(segmentItem["level"]){
        case 1:
            level = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px gold-light"></i>';
            break;
    }
    let name = segmentItem["name"];
    if (name.length > 18) name = name.slice(0, 18) + ".";
    name = "<span>" + name + "</span>";
    let silly = "";
    if (segmentItem["silly"]) silly = '<div class="puke-green-dark">Silly</div>';
    let consequence = "";
    if (segmentItem["consequence"]) {
        let consequenceText = (0, $3E8Nt.toTitleCase)(segmentItem["consequence"].replace(/-/g, " "));
        consequence = '<div class="line-height-1p4 faded-red-light padding-top-3">' + consequenceText + "</div>";
    }
    let requirement = "";
    if (segmentItem["requirement"]) {
        let requirementText = (0, $3E8Nt.toTitleCase)(segmentItem["requirement"].replace(/-/g, " "));
        requirement = '<div class="line-height-1p4 padding-top-1 sky-blue">' + requirementText + "</div>";
    }
    let feudOnly = "";
    if (segmentItem["feudOnly"]) feudOnly = '<div class="light-grey">Feuds Only</div>';
    let maxParticipants = "";
    if (segmentItem["maxParticipants"] !== undefined) {
        let participantsText = "Participant";
        if (segmentItem["maxParticipants"] !== 1) participantsText = "Participants";
        let numberOfParticipants = segmentItem["maxParticipants"];
        if (segmentItem["minParticipants"] !== segmentItem["maxParticipants"]) numberOfParticipants = "{0}-{1}".format(segmentItem["minParticipants"], numberOfParticipants);
        if (numberOfParticipants === 0) numberOfParticipants = "No";
        maxParticipants = '<div class="light-grey">' + numberOfParticipants + " " + participantsText + "</div>";
    }
    let boosts = '<span class="faded-red help-text" title="Hype Boost for the involved Feuds"><i class="fa fa-bolt margin-right-5"></i>' + segmentItem["hypeBoost"] + "</span>" + '<span class="charisma-purple margin-left-10 help-text" ' + 'title="Popularity Boost for the involved Participant(s)">' + '<i class="fa fa-angle-double-up margin-right-5"></i>' + segmentItem["popularityBoost"] + "</span>";
    // Get progress to next level
    let progress;
    let levelXp;
    if (segmentItem["level"] < 3) {
        levelXp = Math.pow(segmentItem["level"], 2) * 75;
        progress = segmentItem["xp"] / levelXp * 100;
    } else {
        levelXp = Math.pow(2, 2) * 75;
        progress = 100;
    }
    let progressHtml = '<div class="segment-item-progress-container display-inline-block"><div class="progress-under help-text" title="' + segmentItem["xp"] + " / " + levelXp + ' XP">' + '<div class="progress faded-purple-background" style="width:' + progress + '%">' + "</div>" + "</div>" + "</div>";
    let stats = '<div><span class="segment-item-label margin-right-5 medium-grey help-text" title="Entertainment: Affects a Segment\'s maximum Rating and XP gain">Ent.</span>' + '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem["entertainment"]) + '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem["entertainment"]) + "</div>" + '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' + 'title="Action: Affects a Segment\'s maximum Rating and XP gain">Act.</span>' + '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem["action"]) + '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem["action"]) + "</div>" + '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' + "title=\"Difficulty: Used alongside the Charisma of the Participants to get the Segment's " + 'Effectiveness and Rating">Diff.</span>' + '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem["difficulty"]) + '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem["difficulty"]) + "</div>";
    let info = "<div>" + maxParticipants + feudOnly + silly + requirement + consequence + "</div>";
    return '<div class="view-segments-item"><div class="margin-bottom-6"><div class="column-left">' + name + "</div>" + '<div class="column-right segment-right-header-container">' + '<div class="column-left">' + progressHtml + level + "</div>" + '<div class="column-right text-right ">' + boosts + "</div>" + '<div class="clear"></div>' + "</div>" + '<div class="clear"></div>' + "</div>" + '<div class="column-left">' + stats + "</div>" + '<div class="column-right margin-top-1">' + info + "</div>" + '<div class="clear"></div>' + "</div>";
}
async function $9f0f3c0f4508366a$export$8df32dfa0ef2b566() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getEditSegmentsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $9f0f3c0f4508366a$var$showEditSegmentsPageData(data);
}
function $9f0f3c0f4508366a$var$showEditSegmentsPageData(data) {
    let $select = $(".edit-custom-segment-container .select-custom-segment");
    $select.html("");
    $.each(data, function() {
        $select.append($("<option />").val(this).text(this));
    });
    $(".edit-custom-segment-container").fadeIn("slow").removeClass("display-none");
}
async function $9f0f3c0f4508366a$export$41cb77bdd57b7c8e(name) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.removeSegmentItem)(name);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $9f0f3c0f4508366a$var$showRemoveSegmentData(data);
}
function $9f0f3c0f4508366a$var$showRemoveSegmentData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="faded-purple">' + data["name"] + "</span> removed";
        notie.alert({
            type: 4,
            text: html
        });
        // Select next custom segment
        let selected = $(".edit-custom-segment-container .select-custom-segment").find(":selected");
        selected.next().prop("selected", true);
        selected.remove();
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "The Segment could not be found. Please try again."
        });
        else if (data["error"] === "not-custom") notie.alert({
            type: 3,
            text: "Only custom Segment Items can be removed."
        });
    }
}
async function $9f0f3c0f4508366a$export$e18684635e7ffd2a(name) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getEditSegmentData)(name);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $9f0f3c0f4508366a$var$showEditSegmentPageData(data);
}
function $9f0f3c0f4508366a$var$showEditSegmentPageData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        const $addCustomSegmentContainer = $(".add-custom-segment-container");
        const $addCustomSegmentStartText = $(".add-custom-segment-start-text");
        const $addCustomSegmentActionText = $(".add-custom-segment-action-text");
        const $addCustomSegmentTagStartText = $(".add-custom-segment-tag-start-text");
        const $addCustomSegmentTagActionText = $(".add-custom-segment-tag-action-text");
        // Show 'add custom segment' container
        (0, $1JSre.hideContent)($());
        $addCustomSegmentContainer.removeClass("scroll margin-top-20").fadeIn("slow");
        $(".add-custom-segment-template-button").removeClass("selected");
        // Reset
        $(".add-custom-segment-more-options").hide();
        let customSegmentMoreOptionsButton = $(".add-custom-segment-more-options-button");
        customSegmentMoreOptionsButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        customSegmentMoreOptionsButton.find("span").text("Show Details");
        $(".import-community-segment-input").val("");
        $(".add-custom-segment-community-segments-container").hide();
        let customSegmentCommunitySegmentsButton = $(".add-custom-segment-show-community-segments-button");
        customSegmentCommunitySegmentsButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        customSegmentCommunitySegmentsButton.find("span").text("Show Community Segments");
        $(".add-custom-segment-help-text-container").hide();
        let customSegmentHelpButton = $(".add-custom-segment-help-button");
        customSegmentHelpButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        customSegmentHelpButton.find("span").text("Show How It Works");
        // Hide save options
        $(".add-custom-segment-save-to-game-container").hide();
        $(".add-custom-segment-save-to-community-container").hide();
        $(".add-custom-segment-cost").text(0);
        // Show edit info
        $(".edit-custom-segment-button").show();
        $(".add-custom-segment-button").hide();
        $(".add-custom-segment-label").text("Edit Custom Segment");
        // Remove extra action text inputs
        $addCustomSegmentActionText.not(":first").remove();
        $addCustomSegmentTagActionText.not(":first").remove();
        // Reset texts
        $addCustomSegmentStartText.val("");
        $addCustomSegmentActionText.val("");
        $addCustomSegmentTagStartText.val("");
        $addCustomSegmentTagActionText.val("");
        // Add segment data
        $addCustomSegmentContainer.data("name", data["name"]);
        $(".add-custom-segment-name-input").val(data["name"]);
        $(".add-custom-segment-participants-input").val(data["participants"]);
        $addCustomSegmentStartText.val(data["startText"]);
        // Add action text
        $addCustomSegmentActionText.val(data["actionText"][0]);
        // Multiple action texts
        let actionTextHtml = '<textarea class="add-custom-segment-action-text styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>';
        data["actionText"].forEach(function(actionText, i) {
            if (i > 0) {
                $(".add-custom-segment-action-text").last().after(actionTextHtml);
                $(".add-custom-segment-action-text").eq(i).val(actionText);
            }
        });
        if (data["startTagText"]) $addCustomSegmentTagStartText.val(data["startTagText"]);
        // Add tag action text
        if (data["actionTagText"]) {
            $addCustomSegmentTagActionText.val(data["actionTagText"][0]);
            // Multiple tag action texts
            let actionTextHtml = '<textarea class="add-custom-segment-tag-action-text styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>';
            data["actionTagText"].forEach(function(actionText, i) {
                if (i > 0) {
                    $(".add-custom-segment-tag-action-text").last().after(actionTextHtml);
                    $(".add-custom-segment-tag-action-text").eq(i).val(actionText);
                }
            });
        }
        let chooseWinnerValue = data["chooseWinner"] ? "yes" : "no";
        $('input[name="add-custom-segment-choose-winner-option"][value="' + chooseWinnerValue + '"]').prop("checked", true);
        let feudOnlyValue = data["feudOnly"] ? "yes" : "no";
        $('input[name="add-custom-segment-feud-only-option"][value="' + feudOnlyValue + '"]').prop("checked", true);
        let sillyValue = data["silly"] ? "yes" : "no";
        $('input[name="add-custom-segment-silly-option"][value="' + sillyValue + '"]').prop("checked", true);
        // Run preview
        $(".add-custom-segment-preview-singles-button").trigger("click");
        // Confirm before changes
        $9f0f3c0f4508366a$export$4acf80557bedaca3.addCustomSegmentChangesMade = true;
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "That Segment could not be found. Please try again."
        });
        if (data["error"] === "production-segment") notie.alert({
            type: 3,
            text: "Production Segments cannot be edited"
        });
    }
}
async function $9f0f3c0f4508366a$export$8c2d543f58db4718() {
    if ((0, $98xmD.globals).requestRunning) return;
    // Disabled if add custom segment disabled
    if ($(".add-custom-segment-container").hasClass("disabled")) return false;
    // Get name, participants
    let name = $(".add-custom-segment-name-input").val();
    let numberOfParticipants = $(".add-custom-segment-participants-input").val();
    // Get start and action texts
    let startText = $(".add-custom-segment-start-text").val();
    let actionTexts = $(".add-custom-segment-action-text").map(function(i, x) {
        if (!!x.value) return x.value;
    }).toArray();
    let tagStartText = $(".add-custom-segment-tag-start-text").val();
    let tagActionTexts = $(".add-custom-segment-tag-action-text").map(function(i, x) {
        if (!!x.value) return x.value;
    }).toArray();
    // Validate inputs
    if (!name) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Segment"
        });
        return false;
    }
    if (!startText) {
        notie.alert({
            type: 3,
            text: "Enter a Start Text for the Segment"
        });
        return false;
    }
    if (actionTexts.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter an Action Text for the Segment"
        });
        return false;
    }
    if (!numberOfParticipants) {
        notie.alert({
            type: 3,
            text: "Enter the number of participants for the Segment"
        });
        return false;
    }
    // Get options
    let saveToGame = $('input[name="add-custom-segment-save-to-game-option"]:checked').val() === "yes";
    let saveToCommunity = $('input[name="add-custom-segment-save-to-community-option"]:checked').val() === "yes";
    let chooseWinner = $('input[name="add-custom-segment-choose-winner-option"]:checked').val() === "yes";
    let feudOnly = $('input[name="add-custom-segment-feud-only-option"]:checked').val() === "yes";
    let silly = $('input[name="add-custom-segment-silly-option"]:checked').val() === "yes";
    numberOfParticipants = parseInt(numberOfParticipants);
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.addCustomSegmentItem)(name, numberOfParticipants, startText, actionTexts, tagStartText, tagActionTexts, saveToGame, saveToCommunity, chooseWinner, feudOnly, silly);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    await $9f0f3c0f4508366a$var$showAddCustomSegmentData(data);
}
async function $9f0f3c0f4508366a$var$showAddCustomSegmentData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        notie.alert({
            type: 4,
            text: '<span class="faded-purple">' + data["name"] + "</span> added!",
            stay: true
        });
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        let bookCustomSegmentButton = $(".add-custom-segment-segments-menu-button:visible");
        if (bookCustomSegmentButton.length > 0) {
            let scrollFunction = function() {
                // Scroll to this segment item
                let $container = $("#segment-items-container"), $scrollTo = $(".segment-item-container").filter(function() {
                    return $(this).find(".segment-item-name").text() === data["name"];
                });
                $container.scrollTop($scrollTo.offset().top - $container.offset().top + $container.scrollTop());
                // Highlight segment item
                setTimeout(function() {
                    $scrollTo.addClass("flash-border-red");
                }, 0);
                setTimeout(function() {
                    $scrollTo.removeClass("flash-border-red");
                }, 1500);
                $(".add-custom-segment-container").hide();
                $(".add-custom-segment-segments-menu-button").removeClass("selected");
            };
            // Reload segment items, pass scrollFunction as callback
            await (0, $1JSre.makeGameRequest)((0, $4ptHI.getAvailableSegmentItems), {}, (0, $67cc16607ee33ebf$export$43c5cdc832e20b0c), {
                callbackFunction: scrollFunction
            }, false, true);
        } else // Go back to view segments
        setTimeout(function() {
            $("#view-segments-menu-button").trigger("click");
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "Custom Segments can only be added in JoW Paid"
        });
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to add a Custom Segment"
        });
        if (data["error"] === "already-exists") notie.alert({
            type: 3,
            text: "A Segment with that name already exists"
        });
    }
}
async function $9f0f3c0f4508366a$export$2302c60aede2b155() {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get name, participants
    let previousName = $(".add-custom-segment-container").data("name");
    let name = $(".add-custom-segment-name-input").val();
    let numberOfParticipants = $(".add-custom-segment-participants-input").val();
    // Get start and action texts
    let startText = $(".add-custom-segment-start-text").val();
    let actionTexts = $(".add-custom-segment-action-text").map(function(i, x) {
        if (!!x.value) return x.value;
    }).toArray();
    let tagStartText = $(".add-custom-segment-tag-start-text").val();
    let tagActionTexts = $(".add-custom-segment-tag-action-text").map(function(i, x) {
        if (!!x.value) return x.value;
    }).toArray();
    // Validate inputs
    if (!name) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Segment"
        });
        return false;
    }
    if (!startText) {
        notie.alert({
            type: 3,
            text: "Enter a Start Text for the Segment"
        });
        return false;
    }
    if (actionTexts.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter an Action Text for the Segment"
        });
        return false;
    }
    if (!numberOfParticipants) {
        notie.alert({
            type: 3,
            text: "Enter the number of participants for the Segment"
        });
        return false;
    }
    // Get options
    let chooseWinner = $('input[name="add-custom-segment-choose-winner-option"]:checked').val() === "yes";
    let feudOnly = $('input[name="add-custom-segment-feud-only-option"]:checked').val() === "yes";
    let silly = $('input[name="add-custom-segment-silly-option"]:checked').val() === "yes";
    numberOfParticipants = parseInt(numberOfParticipants);
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.editCustomSegmentItem)(name, previousName, numberOfParticipants, startText, actionTexts, tagStartText, tagActionTexts, chooseWinner, feudOnly, silly);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $9f0f3c0f4508366a$var$showEditCustomSegmentData(data);
}
function $9f0f3c0f4508366a$var$showEditCustomSegmentData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        notie.alert({
            type: 4,
            text: '<span class="faded-purple">' + data["name"] + "</span> edited",
            stay: true
        });
        // Go back to view segments
        setTimeout(function() {
            $("#view-segments-menu-button").trigger("click");
        }, 600);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "Custom Segments can only be edited in JoW Paid"
        });
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "That Segment could not be found. Please try again."
        });
        if (data["error"] === "already-exists") notie.alert({
            type: 3,
            text: "A Segment with that name already exists"
        });
    }
}
function $9f0f3c0f4508366a$export$fd83d02ab0fd7d2(el) {
    $(".add-custom-segment-template-button").removeClass("selected");
    el.addClass("selected");
    let val = el.text().trim();
    const $addCustomSegmentStartText = $(".add-custom-segment-start-text");
    let $addCustomSegmentActionText = $(".add-custom-segment-action-text");
    const $addCustomSegmentTagStartText = $(".add-custom-segment-tag-start-text");
    const $addCustomSegmentTagActionText = $(".add-custom-segment-tag-action-text");
    // Reset texts
    $addCustomSegmentStartText.val("");
    $addCustomSegmentActionText.val("");
    $addCustomSegmentTagStartText.val("");
    $addCustomSegmentTagActionText.val("");
    // Remove extra action text inputs
    $addCustomSegmentActionText.not(":first").remove();
    $addCustomSegmentTagActionText.not(":first").remove();
    // Set winner and silly to 'no'
    $('input[name="add-custom-segment-choose-winner-option"][value="no"]').prop("checked", true);
    $('input[name="add-custom-segment-silly-option"][value="no"]').prop("checked", true);
    // Deselect community segment result
    $(".community-segments-box").find(".community-segments-search-result-item.selected").removeClass("selected");
    if (val === "Promo") {
        // Name, participants and texts
        $(".add-custom-segment-name-input").val("Promo");
        $(".add-custom-segment-participants-input").val(1);
        $addCustomSegmentStartText.val("{name1} comes out to the ring ...");
        $addCustomSegmentActionText.eq(0).val("{name1} talked about how much better {pronoun1} is than every person sitting the crowd.");
        // Feud and save options
        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop("checked", true).trigger("change");
    } else if (val === "Feud") {
        $(".add-custom-segment-name-input").val("Confrontation");
        $(".add-custom-segment-participants-input").val(2);
        $addCustomSegmentStartText.val("We're going backstage for a confrontation between {name1} and {name2} ...");
        $addCustomSegmentActionText.eq(0).val("{name1} goes over {possessive1} accomplishments and {name2} does the same. They come face to face and stare each other down.");
        $('input[name="add-custom-segment-feud-only-option"][value="yes"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop("checked", true).trigger("change");
    } else if (val === "Basic") {
        $(".add-custom-segment-name-input").val("Opening Segment");
        $(".add-custom-segment-participants-input").val(0);
        $addCustomSegmentStartText.val("The show opens with fireworks ...");
        $addCustomSegmentActionText.eq(0).val("The announcers welcome the fans to the show!");
        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-game-option"][value="no"]').prop("checked", true).trigger("change");
    } else if (val === "Singles & Tag") {
        $(".add-custom-segment-name-input").val("Reclaim Honor");
        $(".add-custom-segment-participants-input").val(1);
        $addCustomSegmentStartText.val("{name1} is out in the ring with a mic in hand ...");
        $addCustomSegmentActionText.eq(0).val("{name1} is insistent on reclaiming lost honor and strives to work hard for it. The fans start to cheer {objective1}.");
        $addCustomSegmentTagStartText.val("{name1} are out in the ring with mics in hand ...");
        $addCustomSegmentTagActionText.eq(0).val("{name1} are insistent on reclaiming lost honor and strive to work hard for it. The fans start to cheer {objective1}.");
        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop("checked", true).trigger("change");
    } else if (val === "Select Winner") {
        $(".add-custom-segment-name-input").val("Windshield Destruction");
        $(".add-custom-segment-participants-input").val(2);
        $addCustomSegmentStartText.val("The camera crew is in the parking lot ... ");
        $addCustomSegmentActionText.eq(0).val("{name1} appeared, standing in front of {name2}'s car, before destroying the windshield with a baseball bat!");
        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop("checked", true).trigger("change");
        $('input[name="add-custom-segment-choose-winner-option"][value="yes"]').prop("checked", true);
    } else if (val === "Action Choices") {
        $(".add-custom-segment-name-input").val("Heel Interview");
        $(".add-custom-segment-participants-input").val(1);
        $addCustomSegmentStartText.val("Our interviewer is backstage with {name1} ...");
        // Add 5 action texts
        let actionTextHtml = '<textarea class="add-custom-segment-action-text styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>';
        $addCustomSegmentActionText.last().after(actionTextHtml + actionTextHtml + actionTextHtml + actionTextHtml);
        // Add values to action texts
        $addCustomSegmentActionText = $(".add-custom-segment-action-text");
        $addCustomSegmentActionText.eq(0).val("{name1} talks about being the best in the business.");
        $addCustomSegmentActionText.eq(1).val("{name1} comes on to the interviewer.");
        $addCustomSegmentActionText.eq(2).val("{name1} makes fun of the crowd for being poor.");
        $addCustomSegmentActionText.eq(3).val("{name1} insults the interviewer's looks.");
        $addCustomSegmentActionText.eq(4).val("{name1} berates the wrestlers in the locker room.");
        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop("checked", true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop("checked", true).trigger("change");
    }
    // Show preview
    if (val === "Singles & Tag") $(".add-custom-segment-preview-tag-button").trigger("click");
    else $(".add-custom-segment-preview-singles-button").trigger("click");
    // Allow changes without confirm
    $9f0f3c0f4508366a$export$4acf80557bedaca3.addCustomSegmentChangesMade = false;
}
function $9f0f3c0f4508366a$export$d4aaf9912fff13e(name, startText, actionText, participants, chooseWinner, nameElement, startTextElement, actionTextElement) {
    // Reset
    startTextElement.text("").addClass("medium-dark-grey").removeClass("light-grey");
    actionTextElement.text("");
    nameElement.text("");
    // Generate text
    startText = $9f0f3c0f4508366a$export$5a6dd4c6a40e1acc(startText, participants);
    // Show action text if not selecting winner or less than 2 participants in segment
    if (!chooseWinner || participants.length < 2) {
        actionText = $9f0f3c0f4508366a$export$5a6dd4c6a40e1acc(actionText, participants);
        actionTextElement.html(actionText).hide().fadeIn(500);
    } else {
        // Show participants
        let participantsDisplay;
        let participantsHtml = [];
        participants.forEach(function(participant) {
            participantsHtml.push('<div class="match-wrestler-container"><button class="match-wrestler match-span">' + participant["name"] + "</button></div>");
        });
        if (participants.length > 4) participantsDisplay = participantsHtml.join("");
        else participantsDisplay = participantsHtml.join('<span class="match-span dark-grey"></span>');
        actionTextElement.html(participantsDisplay).hide().fadeIn(500);
    }
    nameElement.text(name);
    startTextElement.html(startText).hide().fadeIn(500);
    startTextElement.removeClass("medium-dark-grey").addClass("light-grey");
    return true;
}
function $9f0f3c0f4508366a$export$5a6dd4c6a40e1acc(text, participants) {
    function getPronoun(type) {
        if (type === "he") return "he";
        if (type === "she") return "she";
        if (type === "tag") return "they";
    }
    function getObjectivePronoun(type) {
        if (type === "he") return "him";
        if (type === "she") return "her";
        if (type === "tag") return "them";
    }
    function getPossessivePronoun(type) {
        if (type === "he") return "his";
        if (type === "she") return "her";
        if (type === "tag") return "their";
    }
    // Parse keywords for participants
    for(let i = 0; i < participants.length; i++){
        text = (0, $1JSre.replaceAll)(text, "{name{0}}".format(i + 1), '<span class="faded-blue">' + participants[i].name + "</span>");
        text = (0, $1JSre.replaceAll)(text, "{pronoun{0}}".format(i + 1), getPronoun(participants[i].type));
        text = (0, $1JSre.replaceAll)(text, "{objective{0}}".format(i + 1), getObjectivePronoun(participants[i].type));
        text = (0, $1JSre.replaceAll)(text, "{possessive{0}}".format(i + 1), getPossessivePronoun(participants[i].type));
    }
    return (0, $1JSre.applySentenceCase)(text);
}


$(document).ready(function() {
    /*
	COMMUNITY GRAPHICS
	 */ // Community graphics main menu button
    $("#community-graphics").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideMainMenuContent)($());
        notie.hideAlerts();
        $(".community-graphics-search-container").hide();
        $(".community-graphics-search-results-container").hide();
        $(".community-graphics-input-name").val("");
        $(".community-graphics-input-age").val("");
        $(".community-graphics-search-menu-button").trigger("click");
        let el = $("#community-graphics-graphic");
        el.html("").show();
        (0, $c82cd471f4baff6b$export$dc322094595ee8d2)(el);
        $("#community-graphics-container").fadeIn("slow").removeClass("display-none");
        $(".community-graphics-input-name").focus();
    });
    // Community graphics search button
    $(".button-community-graphics-search").on("click", function() {
        let searchTerm = $("#community-graphics-container").find(".community-graphics-input-name").val();
        $c4630e829f7e74ef$var$runTemplateSuperstarsSearch(searchTerm);
    });
    $(".community-graphics-input-name").on("keypress", function(e) {
        // Trigger search on enter key press
        if (e.which === 13 && $(".community-graphics-search-menu-button").hasClass("selected")) $(".button-community-graphics-search").click();
    });
    // Community graphics next/previous page buttons
    $(".community-graphics-next-page-button, .community-graphics-previous-page-button").on("click", function() {
        let page = $(this).data("page");
        let searchTerm = $("#community-graphics-container").find(".community-graphics-input-name").val();
        let sortValue = $(".sort-community-graphics-results-button.selected").text().trim().toLowerCase();
        $c4630e829f7e74ef$var$runTemplateSuperstarsSearch(searchTerm, page, sortValue);
    });
    // Community graphics random button
    $(".button-community-graphics-random").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.makeGetRequest)("/_get_random_template_superstar", {}, (data)=>{
            // Get search results html
            let html = "";
            data.forEach(function(item) {
                html += $c4630e829f7e74ef$var$getTemplateSuperstarHtml(item);
            });
            $(".community-graphics-search-results-number").text("Random result").show();
            $(".community-graphics-search-sort-buttons").show();
            // Select 'best' sort option for results
            $(".sort-community-graphics-results-button").removeClass("selected");
            $('.sort-community-graphics-results-button:contains("New")').addClass("selected");
            // Show results
            $(".community-graphics-search-results-container").html(html);
            $(".community-graphics-search-results-container").fadeIn();
            $(".community-graphics-search-container").show();
            // Put focus back on search field
            $(".community-graphics-input-name").focus();
            // Show graphic for first result
            $(".community-graphics-search-results-container").find(".community-graphics-search-result-item").trigger("click");
        });
    });
    // Community graphics sort results button
    $("#community-graphics-container").on("click", ".sort-community-graphics-results-button", function() {
        if (!$(this).hasClass("selected")) {
            $(".sort-community-graphics-results-button").removeClass("selected");
            $(this).addClass("selected");
        }
        let sortValue = $(this).text().trim().toLowerCase();
        let searchTerm = $("#community-graphics-container").find(".community-graphics-input-name").val();
        $c4630e829f7e74ef$var$runTemplateSuperstarsSearch(searchTerm, null, sortValue);
    });
    // Load graphic upon clicking on search result
    $("#community-graphics-container").on("click", ".community-graphics-search-result-item", function() {
        if ($(this).hasClass("disabled")) return false;
        $(".community-graphics-search-result-item.selected").removeClass("selected");
        $(this).addClass("selected");
        let graphicCode = $(this).attr("data-graphic");
        $(".community-graphics-graphic-container").find(".load-character-code-input").val(graphicCode);
        $(".community-graphics-graphic-container").find(".load-character-code-button").trigger("click");
    });
    // Community graphics create button
    $(".button-community-graphics-create").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        // Get graphic code
        let graphicCode = $c4630e829f7e74ef$var$getCommunityGraphicsCode();
        // Get inputs
        let superstarName = $("#community-graphics-container").find(".community-graphics-input-name").val();
        let superstarAge = $("#community-graphics-container").find(".community-graphics-input-age").val();
        // Validate inputs
        if (superstarName.length <= 0) {
            notie.alert({
                type: 3,
                text: "Enter the Superstar's name"
            });
            return false;
        }
        if (superstarAge.length <= 0 || superstarAge < 10 || superstarAge > 100) {
            notie.alert({
                type: 3,
                text: "Enter the Superstar's age (between 10-100)"
            });
            return false;
        }
        (0, $1JSre.makeGetRequest)("/_add_template_superstar", {
            name: superstarName,
            age: superstarAge,
            graphic: graphicCode
        }, (data)=>{
            if (!data["error"]) {
                (0, $lCS03.playSoundEffect)("success");
                let superstarTemplate = data["new_template_superstar"];
                notie.alert({
                    type: 4,
                    text: "Superstar graphic added for {0} ({1} y/o)".format(superstarTemplate["name"], superstarTemplate["age"])
                });
                $(".community-graphics-input-name").val("");
                $(".community-graphics-input-age").val("");
            } else {
                (0, $lCS03.playSoundEffect)("error");
                let superstarTemplate = data["existing_template_superstar"];
                if (data["error"] === "already-exists") notie.alert({
                    type: 3,
                    text: "That superstar graphic already exists as {0} ({1} y/o)".format(superstarTemplate["name"], superstarTemplate["age"])
                });
            }
        });
    });
    $(".community-graphics-input-age").on("keypress", function(e) {
        // Trigger create on enter key press
        if (e.which === 13) $(".button-community-graphics-create").click();
    });
    // Community graphics menu buttons
    $("#community-graphics-container").on("click", ".community-graphics-create-menu-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        $(".community-graphics-menu-button").removeClass("selected");
        $(this).addClass("selected");
        $("#community-graphics-container").find(".character-creator-controls").removeClass("display-none").addClass("display-inline-block");
        $("#community-graphics-container").find(".button-community-graphics-create").show();
        $("#community-graphics-container").find(".button-community-graphics-search").hide();
        $("#community-graphics-container").find(".button-community-graphics-random").hide();
        $(".community-graphics-search-container").hide();
        $(".community-graphics-search-results-container").hide();
        $(".community-graphics-input-age").show();
        $(".community-graphics-input-name").show();
        $(".community-graphics-best-and-new-container").hide();
        $(".community-graphics-my-graphics-container").hide();
        $(".community-graphics-pagination-buttons").hide();
    });
    $("#community-graphics-container").on("click", ".community-graphics-search-menu-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        $(".community-graphics-menu-button").removeClass("selected");
        $(this).addClass("selected");
        $("#community-graphics-container").find(".character-creator-controls").addClass("display-none").removeClass("display-inline-block");
        $("#community-graphics-container").find(".button-community-graphics-create").hide();
        $("#community-graphics-container").find(".button-community-graphics-search").show();
        $("#community-graphics-container").find(".button-community-graphics-random").show();
        $(".community-graphics-input-age").hide();
        $(".community-graphics-search-container").hide();
        $(".community-graphics-search-results-container").hide();
        // Put focus on name field
        $(".community-graphics-input-name").show();
        $(".community-graphics-input-name").focus();
        $(".community-graphics-best-and-new-container").hide();
        $(".community-graphics-search-results-container").hide();
        $(".community-graphics-my-graphics-container").hide();
        $(".community-graphics-pagination-buttons").hide();
    });
    $("#community-graphics-container").on("click", ".community-graphics-best-new-menu-button", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        // Get new and best graphics
        $(".community-graphics-menu-button").removeClass("selected");
        $(this).addClass("selected");
        $(".community-graphics-pagination-buttons").hide();
        (0, $1JSre.makeGetRequest)("/_get_template_superstars_new_and_best", {}, (data)=>{
            let newHtml = "";
            data["new"].forEach(function(item) {
                newHtml += $c4630e829f7e74ef$var$getTemplateSuperstarHtml(item);
            });
            let bestHtml = "";
            data["best"].forEach(function(item) {
                bestHtml += $c4630e829f7e74ef$var$getTemplateSuperstarHtml(item);
            });
            let recentlyRecommendedHtml = "";
            data["recently_recommended"].forEach(function(item) {
                recentlyRecommendedHtml += $c4630e829f7e74ef$var$getTemplateSuperstarHtml(item);
            });
            $(".community-graphics-new-container").html(newHtml);
            $(".community-graphics-best-container").html(bestHtml);
            $(".community-graphics-recently-recommended-container").html(recentlyRecommendedHtml);
            $(".community-graphics-best-and-new-container").show();
            $(".community-graphics-best-container").scrollTop(0);
            $(".community-graphics-new-container").scrollTop(0);
            $(".community-graphics-recently-recommended-container").scrollTop(0);
            $("#community-graphics-container").find(".character-creator-controls").addClass("display-none").removeClass("display-inline-block");
            $("#community-graphics-container").find(".button-community-graphics-create").hide();
            $("#community-graphics-container").find(".button-community-graphics-search").hide();
            $("#community-graphics-container").find(".button-community-graphics-random").hide();
            $(".community-graphics-input-age").hide();
            $(".community-graphics-input-name").hide();
            $(".community-graphics-search-container").hide();
            $(".community-graphics-search-results-container").hide();
            $(".community-graphics-my-graphics-container").hide();
        });
    });
    $("#community-graphics-container").on("click", ".community-graphics-my-graphics-menu-button", function() {
        $c4630e829f7e74ef$var$getTemplateSuperstarsForUser();
    });
    // Next/previous page of favorites buttons
    $(".my-favorites-next-page-button, .my-favorites-previous-page-button").on("click", function() {
        let page = $(this).data("page");
        $c4630e829f7e74ef$var$getTemplateSuperstarsForUser(page, "ratings");
    });
    $(".my-graphics-next-page-button, .my-graphics-previous-page-button").on("click", function() {
        let page = $(this).data("page");
        $c4630e829f7e74ef$var$getTemplateSuperstarsForUser(page, "graphics");
    });
    // Copy graphic
    $("#community-graphics-container").on("click", ".community-graphics-copy-graphic", function() {
        (0, $lCS03.playSoundEffect)("success");
        let graphicCode = $c4630e829f7e74ef$var$getCommunityGraphicsCode();
        (0, $c82cd471f4baff6b$export$2cdf1b96a9f86d16)(null, graphicCode);
    });
    // Community graphics recommend graphic
    $("#community-graphics-container").on("click", ".recommend-community-graphic-button", function(e) {
        e.stopPropagation();
        let el = $(this);
        let uid = $(this).closest(".community-graphics-search-result-item").attr("data-uid");
        $c4630e829f7e74ef$export$182168cbcc8eeaf5(el, uid);
    });
    // Delete graphic
    $("#community-graphics-container").on("click", ".delete-community-graphic-button", function(e) {
        e.stopPropagation();
        let el = $(this).closest(".community-graphics-search-result-item");
        let uid = el.attr("data-uid");
        notie.confirm({
            text: "Are you sure you want to delete this graphic?",
            submitText: "Yes",
            cancelText: "No",
            submitCallback: function() {
                $c4630e829f7e74ef$var$deleteTemplateSuperstar(uid, el);
            }
        });
    });
    /*
	COMMUNITY SEGMENTS
	 */ // Community segments main menu button
    $("#community-segments").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideMainMenuContent)($());
        notie.hideAlerts();
        $("#community-segments-container").fadeIn("slow");
        $("#community-segments-container").find('.community-segments-menu-button[data-value="browse"]').trigger("click");
    });
    // Community segments sort button
    $(".community-segments-sort-button").on("click", function() {
        let val = $(this).data("value");
        // Select this button
        $(".community-segments-sort-button").removeClass("selected");
        $(this).addClass("selected");
        if (val === "search") {
            let searchTerm = $(this).siblings(".community-segments-search-input").val();
            // Validate
            if (searchTerm.length <= 0) {
                notie.alert({
                    type: 3,
                    text: "Enter a name to search for"
                });
                // Put focus back on search field
                $(this).siblings(".community-segments-search-input").focus();
                return false;
            }
            $c4630e829f7e74ef$var$runTemplateSegmentItemsSearch(searchTerm);
        } else $c4630e829f7e74ef$var$getTemplateSegmentItems(val);
    });
    $(".community-segments-search-input").on("keypress", function(e) {
        // Trigger search on enter key press
        if (e.which === 13) $(e.target).siblings(".community-segments-search-button").trigger("click");
    });
    // Community segments next/previous page buttons
    $(".community-segments-next-page-button, .community-segments-previous-page-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        let page = $(this).data("page");
        let parent = $(this).closest(".community-segments-box");
        let val = parent.find(".community-segments-sort-button.selected").data("value");
        if (val === "search") {
            let searchTerm = parent.find(".community-segments-search-input").val();
            $c4630e829f7e74ef$var$runTemplateSegmentItemsSearch(searchTerm, page);
        } else $c4630e829f7e74ef$var$getTemplateSegmentItems(val, page);
    });
    // Community segments recommend button
    $("#community-segments-container, .add-custom-segment-community-segments-container").on("click", ".recommend-community-segment-button", function(e) {
        e.stopPropagation();
        if ((0, $98xmD.globals).requestRunning) return false;
        let uid = $(this).closest(".community-segments-search-result-item").attr("data-uid");
        let $this = $(this);
        (0, $1JSre.makeGetRequest)("/_rate_template_segment_item", {
            uid: uid
        }, (data)=>{
            if (!data["error"]) {
                (0, $lCS03.playSoundEffect)("success");
                $this.siblings(".community-segments-item-recommendations").text(data["rating"]);
                if (data["rated_positive"]) $this.removeClass("not-rated").addClass("rated");
                else $this.removeClass("rated").addClass("not-rated");
            } else if (data["error"] === "not-signed-in") {
                (0, $lCS03.playSoundEffect)("error");
                notie.alert({
                    type: 4,
                    text: "You need to be logged in to favorite segments",
                    stay: true
                });
            }
        });
    });
    // Community segments delete segment
    $("#community-segments-container").on("click", ".delete-community-segment-button", function(e) {
        e.stopPropagation();
        let el = $(this).closest(".community-segments-search-result-item");
        let uid = el.attr("data-uid");
        notie.confirm({
            text: "Are you sure you want to delete this segment?",
            submitText: "Yes",
            cancelText: "No",
            submitCallback: function() {
                $c4630e829f7e74ef$var$deleteTemplateSegmentItem(uid, el);
            }
        });
    });
    // Community segments menu button
    $("#community-segments-container").on("click", ".community-segments-menu-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        let val = $(this).data("value");
        let parent = $(this).closest(".community-segments-box");
        if (val === "copy") {
            let selected = parent.find(".community-segments-search-result-item.selected");
            if (selected.length > 0) {
                let uid = selected.data("uid");
                (0, $c82cd471f4baff6b$export$2cdf1b96a9f86d16)(null, uid, "Copied to clipboard. Paste into Import Segment when creating a segment in-game (JoW Paid).");
            } else // Don't copy if no segment selected
            notie.alert({
                type: 4,
                text: "No segment selected. Select a segment to copy it."
            });
            return false;
        }
        // Select this button
        $(".community-segments-menu-button").removeClass("selected");
        $(this).addClass("selected");
        if (val === "browse") {
            $(".community-segments-browse").show();
            $(".community-segments-my-segments").hide();
            parent.find('.community-segments-sort-button[data-value="new"]').trigger("click");
        } else if (val === "my-segments") {
            $(".community-segments-browse").hide();
            $(".community-segments-my-segments").show();
            parent.find('.community-segments-sort-button[data-value="user-segments"]').trigger("click");
        }
    });
    // Community segments select segment
    $("#community-segments-container").on("click", ".community-segments-search-result-item", function() {
        let parent = $(this).closest(".community-segments-box");
        if ($(this).hasClass("disabled")) {
            parent.find(".community-segments-preview-name").text("");
            parent.find(".community-segments-preview-start-text").text("No segment selected");
            parent.find(".community-segments-preview-action-text").text("");
            return false;
        }
        // Select this element
        parent.find(".community-segments-search-result-item.selected").removeClass("selected");
        $(this).addClass("selected");
        // Run preview
        parent.find(".community-segments-preview-singles-button").trigger("click");
    });
    // Community segments preview button
    $("#community-segments-container").on("click", ".community-segments-preview-singles-button, .community-segments-preview-tag-button", function() {
        let parent = $(this).closest(".community-segments-box");
        // Select this button
        $(".community-segments-preview-buttons-container .button").removeClass("selected");
        $(this).addClass("selected");
        // Get attributes
        let selected = parent.find(".community-segments-search-result-item.selected");
        if (selected.length <= 0) {
            // Don't run if no segment selected
            notie.alert({
                type: 4,
                text: "No segment selected. Select a segment to preview it."
            });
            return false;
        }
        let text = selected.data("text");
        let name = selected.data("name");
        let startText = (0, $3E8Nt.getRandomChoice)(text["start"]);
        let actionText = (0, $3E8Nt.getRandomChoice)(text["action"]);
        let numberOfParticipants = selected.data("participants");
        let chooseWinner = selected.data("choose-winner");
        // Get participants and type
        let dataType;
        let participants;
        if ($(this).hasClass("community-segments-preview-tag-button")) {
            dataType = "tag";
            participants = (0, $1JSre.previewSegmentTagParticipants);
        } else {
            dataType = "singles";
            participants = (0, $1JSre.previewSegmentSinglesParticipants);
        }
        // Get tag texts if present
        if (dataType === "tag") {
            if (text["start_tag"]) startText = (0, $3E8Nt.getRandomChoice)(text["start_tag"]);
            if (text["action_tag"]) actionText = (0, $3E8Nt.getRandomChoice)(text["action_tag"]);
        }
        name = (0, $1JSre.escapeHTML)(name);
        startText = (0, $1JSre.escapeHTML)(startText);
        actionText = (0, $1JSre.escapeHTML)(actionText);
        // Get random participant objects based on number of participants
        (0, $3E8Nt.shuffle)(participants);
        participants = participants.slice(0, numberOfParticipants);
        let nameElement = parent.find(".community-segments-preview-name");
        let startTextElement = parent.find(".community-segments-preview-start-text");
        let actionTextElement = parent.find(".community-segments-preview-action-text");
        (0, $9f0f3c0f4508366a$export$d4aaf9912fff13e)(name, startText, actionText, participants, chooseWinner, nameElement, startTextElement, actionTextElement);
        // Select winner
        parent.find(".community-segments-preview-container").off("click", ".match-wrestler");
        parent.find(".community-segments-preview-container").on("click", ".match-wrestler", function() {
            let name = $(this).text();
            // Put winner first in participants
            participants.sort(function(x, y) {
                return x.name === name ? -1 : y.name === name ? 1 : 0;
            });
            // Show action text
            actionText = (0, $9f0f3c0f4508366a$export$5a6dd4c6a40e1acc)(actionText, participants);
            actionTextElement.html(actionText).hide().fadeIn(500);
        });
    });
});
/*
Community Graphics
 */ function $c4630e829f7e74ef$var$runTemplateSuperstarsSearch(searchTerm, page, sort) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $lCS03.playSoundEffect)("success");
    (0, $1JSre.makeGetRequest)("/_get_template_superstar", {
        name: searchTerm,
        page: page,
        sort: sort
    }, (data)=>{
        let templateSuperstars = data["template_superstars"];
        // Get search results html
        let html = "";
        templateSuperstars.forEach(function(item) {
            html += $c4630e829f7e74ef$var$getTemplateSuperstarHtml(item);
        });
        // Show empty results if no superstars found
        if (templateSuperstars.length <= 0) html = '<div class="inner-box-item community-graphics-search-result-item disabled medium-dark-grey">No Superstars found</div>';
        // Show next/prev page buttons
        $c4630e829f7e74ef$var$showCommunityGraphicsPagination(data);
        // Show number of results found. Max results is 50.
        let resultsFound = data["total_results"];
        let resultsWord = "results";
        if (templateSuperstars.length === 1) resultsWord = "result";
        $(".community-graphics-search-results-number").text(resultsFound + " " + resultsWord + " found").show();
        $(".community-graphics-search-sort-buttons").show();
        // Select 'best' sort option for results
        $(".sort-community-graphics-results-button").removeClass("selected");
        $('.sort-community-graphics-results-button:contains("' + (0, $3E8Nt.toTitleCase)(data["sort_value"]) + '")').addClass("selected");
        // Show results
        $(".community-graphics-search-results-container").html(html);
        $(".community-graphics-search-results-container").scrollTop(0);
        $(".community-graphics-search-results-container").fadeIn();
        $(".community-graphics-search-container").show();
        // Put focus back on search field
        $(".community-graphics-input-name").focus();
    });
}
function $c4630e829f7e74ef$export$d2345c57f6006d32(parent, searchTerm, page, sort) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $lCS03.playSoundEffect)("success");
    (0, $1JSre.makeGetRequest)("/_get_template_superstar", {
        name: searchTerm,
        page: page,
        sort: sort
    }, (data)=>{
        // Get search results html
        let html = "";
        data["template_superstars"].forEach(function(item) {
            html += $c4630e829f7e74ef$var$getTemplateSuperstarHtml(item, "graphics-search-result-item");
        });
        // Show empty results if no superstars found
        if (data["template_superstars"].length <= 0) html = '<div class="inner-box-item graphics-search-result-item disabled medium-dark-grey">No Superstars found</div>';
        // Show next/prev page buttons
        $c4630e829f7e74ef$var$showGraphicsPagination(data);
        // Show number of results found. Max results is 50.
        let resultsFound = data["total_results"];
        let resultsWord = "results";
        if (data["template_superstars"].length === 1) resultsWord = "result";
        parent.find(".graphics-search-results-number").text(resultsFound + " " + resultsWord + " found").show();
        parent.find(".graphics-search-sort-buttons").show();
        // Select sort option for results
        parent.find(".graphics-search-sort-results-button").removeClass("selected");
        parent.find('.graphics-search-sort-results-button:contains("' + (0, $3E8Nt.toTitleCase)(data["sort_value"]) + '")').addClass("selected");
        // Show results
        let searchResultsContainer = parent.find(".graphics-search-results-container");
        searchResultsContainer.html(html);
        searchResultsContainer.scrollTop(0);
        searchResultsContainer.fadeIn();
        parent.find(".graphics-search-results").show();
        // Put focus back on search field
        parent.find(".graphics-search-input-name").focus();
    });
}
function $c4630e829f7e74ef$var$getTemplateSuperstarHtml(item, itemClass, belongsToUser) {
    if (typeof itemClass === "undefined") itemClass = "community-graphics-search-result-item";
    let graphicJSON = JSON.stringify(item["graphic"]);
    let name = (0, $1JSre.getShortenedName)((0, $1JSre.escapeHTML)(item["name"]), 30);
    let creatorName = item["creator_name"] ? '<span class="high-light-grey margin-left-7">by {0}</span>'.format((0, $1JSre.escapeHTML)(item["creator_name"])) : "";
    let ratedClass = " not-rated";
    if (item["rated_positive"]) ratedClass = " rated";
    let recommendations = '<i class="fa fa-star icon-button recommend-community-graphic-button' + ratedClass + '"></i>' + '<span class="community-graphics-item-recommendations medium-grey">' + item["positive_recommendations"] + "</span>";
    let deleteButton = "";
    if (belongsToUser) deleteButton = '<i class="fa fa-times-circle-o delete-community-graphic-button icon-button light help-text" title="Delete"></i>';
    return '<div class="inner-box-item ' + itemClass + "\" data-graphic='" + graphicJSON + "' " + 'data-uid="' + item["uid"] + '">' + '<div class="medium-dark-grey">' + '<div class="graphics-search-result-item-column-left line-height-1p6">' + name + creatorName + "</div>" + '<div class="graphics-search-result-item-column-right light-grey">' + item["age"] + " y/o" + recommendations + deleteButton + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
}
function $c4630e829f7e74ef$var$showCommunityGraphicsPagination(data) {
    if (data["next_page"]) $(".community-graphics-next-page-button").removeClass("visibility-hidden").data("page", data["next_page"]);
    else $(".community-graphics-next-page-button").addClass("visibility-hidden");
    if (data["previous_page"]) $(".community-graphics-previous-page-button").removeClass("visibility-hidden").data("page", data["previous_page"]);
    else $(".community-graphics-previous-page-button").addClass("visibility-hidden");
    if (data["next_page"] || data["previous_page"]) $(".community-graphics-pagination-buttons").show();
    else $(".community-graphics-pagination-buttons").hide();
}
function $c4630e829f7e74ef$var$showGraphicsPagination(data) {
    if (data["next_page"]) $(".graphics-next-page-button").removeClass("visibility-hidden").data("page", data["next_page"]);
    else $(".graphics-next-page-button").addClass("visibility-hidden");
    if (data["previous_page"]) $(".graphics-previous-page-button").removeClass("visibility-hidden").data("page", data["previous_page"]);
    else $(".graphics-previous-page-button").addClass("visibility-hidden");
    if (data["next_page"] || data["previous_page"]) $(".graphics-pagination-buttons").show();
    else $(".graphics-pagination-buttons").hide();
}
function $c4630e829f7e74ef$var$getCommunityGraphicsCode() {
    // Get graphic code from share character button
    $(".community-graphics-graphic-container").find(".share-character").trigger("click").removeClass("selected");
    $(".community-graphics-graphic-container").find(".share-character-code-container").hide();
    return $(".community-graphics-graphic-container").find(".share-character-code-input").val();
}
function $c4630e829f7e74ef$var$getTemplateSuperstarsForUser(page, selection) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $lCS03.playSoundEffect)("success");
    $(".community-graphics-menu-button").removeClass("selected");
    $(".community-graphics-my-graphics-menu-button").addClass("selected");
    $(".community-graphics-pagination-buttons").hide();
    (0, $1JSre.makeGetRequest)("/_get_template_superstars_for_user", {
        page: page,
        selection: selection
    }, (data)=>{
        // My graphics (don't update if loading ratings page)
        if (selection !== "ratings") {
            let myGraphicsHtml = "";
            data["my_graphics"].forEach(function(item) {
                myGraphicsHtml += $c4630e829f7e74ef$var$getTemplateSuperstarHtml(item, "community-graphics-search-result-item", true);
            });
            if (data["my_graphics"].length <= 0) myGraphicsHtml = '<div class="inner-box-item community-graphics-search-result-item disabled medium-dark-grey">No graphics added</div>';
            $(".community-graphics-my-graphics").html(myGraphicsHtml);
            $(".community-graphics-my-graphics").scrollTop(0);
            $(".community-graphics-my-graphics-container").show();
            if (data["next_graphics_page"]) $(".my-graphics-next-page-button").removeClass("visibility-hidden").data("page", data["next_graphics_page"]);
            else $(".my-graphics-next-page-button").addClass("visibility-hidden");
            if (data["previous_graphics_page"]) $(".my-graphics-previous-page-button").removeClass("visibility-hidden").data("page", data["previous_graphics_page"]);
            else $(".my-graphics-previous-page-button").addClass("visibility-hidden");
        }
        // My favorites (don't update if loading graphics page)
        if (selection !== "graphics") {
            let favoritesHtml = "";
            data["recommended"].forEach(function(item) {
                favoritesHtml += $c4630e829f7e74ef$var$getTemplateSuperstarHtml(item);
            });
            if (data["recommended"].length <= 0) favoritesHtml = '<div class="inner-box-item community-graphics-search-result-item disabled medium-dark-grey">No graphics recommended</div>';
            $(".community-graphics-favorites").html(favoritesHtml);
            $(".community-graphics-favorites").scrollTop(0);
            if (data["next_ratings_page"]) $(".my-favorites-next-page-button").removeClass("visibility-hidden").data("page", data["next_ratings_page"]);
            else $(".my-favorites-next-page-button").addClass("visibility-hidden");
            if (data["previous_ratings_page"]) $(".my-favorites-previous-page-button").removeClass("visibility-hidden").data("page", data["previous_ratings_page"]);
            else $(".my-favorites-previous-page-button").addClass("visibility-hidden");
        }
        $("#community-graphics-container").find(".character-creator-controls").addClass("display-none").removeClass("display-inline-block");
        $("#community-graphics-container").find(".button-community-graphics-create").hide();
        $("#community-graphics-container").find(".button-community-graphics-search").hide();
        $("#community-graphics-container").find(".button-community-graphics-random").hide();
        $(".community-graphics-input-age").hide();
        $(".community-graphics-input-name").hide();
        $(".community-graphics-search-container").hide();
        $(".community-graphics-search-results-container").hide();
        $(".community-graphics-best-and-new-container").hide();
    });
}
function $c4630e829f7e74ef$var$deleteTemplateSuperstar(uid, el) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $1JSre.makeGetRequest)("/_delete_template_superstar", {
        uid: uid
    }, (data)=>{
        if (!data["error"]) {
            (0, $lCS03.playSoundEffect)("success");
            notie.alert({
                type: 4,
                text: "Graphic deleted",
                stay: true
            });
            el.remove();
        } else {
            (0, $lCS03.playSoundEffect)("error");
            if (data["error"] === "not-found") notie.alert({
                type: 3,
                text: "That graphic could not be found. Please try again."
            });
            if (data["error"] === "not-signed-in") notie.alert({
                type: 3,
                text: "You need to be logged in to delete graphics."
            });
            if (data["error"] === "wrong-user") notie.alert({
                type: 3,
                text: "That graphic does not belong to you."
            });
        }
    });
}
/*
Community Segments
 */ function $c4630e829f7e74ef$var$runTemplateSegmentItemsSearch(searchTerm, page) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $lCS03.playSoundEffect)("success");
    (0, $1JSre.makeGetRequest)("/_get_template_segment_items", {
        name: searchTerm,
        sort: "search",
        page: page
    }, (data)=>{
        // Get search results html
        let html = "";
        data["template_segment_items"].forEach(function(item) {
            html += $c4630e829f7e74ef$var$getTemplateSegmentItemHtml(item);
        });
        // Show empty results if no segments found
        if (data["template_segment_items"].length <= 0) html = '<div class="inner-box-item community-segments-search-result-item disabled medium-dark-grey">No segments found</div>';
        // Show next/prev page buttons
        $c4630e829f7e74ef$var$showCommunitySegmentsPagination(data);
        // Show number of segments found (if searching)
        let resultsFound = data["total_results"];
        let resultsWord = "segments";
        if (resultsFound === 1) resultsWord = "segment";
        $(".community-segments-results-number").text(resultsFound + " " + resultsWord + " found").show();
        // Show results
        $(".community-segments-results-container").html(html).show();
        $(".community-segments-results-container").scrollTop(0);
        // Put focus back on search field
        $(".community-segments-search-input").focus();
        // Preview first result
        $(".community-segments-search-result-item").eq(0).trigger("click");
    });
}
function $c4630e829f7e74ef$var$getTemplateSegmentItemHtml(item, belongsToUser) {
    let itemText = item["text"];
    let textJson = JSON.stringify(itemText).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    let name = (0, $1JSre.getShortenedName)((0, $1JSre.escapeHTML)(item["name"]), 30);
    let creatorName = item["creator_name"] ? '<span class="high-light-grey margin-left-7">by {0}</span>'.format((0, $1JSre.escapeHTML)(item["creator_name"])) : "";
    let ratedClass = " not-rated";
    if (item["rated_positive"]) ratedClass = " rated";
    let recommendations = '<i class="fa fa-star icon-button recommend-community-segment-button' + ratedClass + '"></i>' + '<span class="community-segments-item-recommendations medium-grey">' + item["positive_recommendations"] + "</span>";
    let deleteButton = "";
    if (belongsToUser) deleteButton = '<i class="fa fa-times-circle-o delete-community-segment-button icon-button light help-text" title="Delete"></i>';
    return '<div class="inner-box-item community-segments-search-result-item" data-participants="' + item["max_participants"] + '"' + ' data-name="' + item["name"].replace(/"/g, "&quot;").replace(/'/g, "&#39;") + '" ' + ' data-choose-winner="' + item["choose_winner"] + '" ' + 'data-text="' + textJson + '" ' + 'data-uid="' + item["uid"] + '">' + '<div class="medium-dark-grey">' + '<div class="community-segments-search-result-item-column-left line-height-1p6">' + name + creatorName + "</div>" + '<div class="community-segments-search-result-item-column-right light-grey">' + recommendations + deleteButton + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
}
function $c4630e829f7e74ef$var$showCommunitySegmentsPagination(data) {
    if (data["next_page"]) $(".community-segments-next-page-button").removeClass("visibility-hidden").data("page", data["next_page"]);
    else $(".community-segments-next-page-button").addClass("visibility-hidden");
    if (data["previous_page"]) $(".community-segments-previous-page-button").removeClass("visibility-hidden").data("page", data["previous_page"]);
    else $(".community-segments-previous-page-button").addClass("visibility-hidden");
    if (data["next_page"] || data["previous_page"]) $(".community-segments-pagination-buttons").show();
    else $(".community-segments-pagination-buttons").hide();
}
function $c4630e829f7e74ef$var$getTemplateSegmentItems(val, page) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $lCS03.playSoundEffect)("success");
    (0, $1JSre.makeGetRequest)("/_get_template_segment_items", {
        sort: val,
        page: page
    }, (data)=>{
        // Get html
        let html = "";
        let belongsToUser = val === "user-segments";
        data["template_segment_items"].forEach(function(item) {
            html += $c4630e829f7e74ef$var$getTemplateSegmentItemHtml(item, belongsToUser);
        });
        // Show empty results if no segments found
        if (data["template_segment_items"].length <= 0) html += '<div class="inner-box-item community-segments-search-result-item disabled medium-dark-grey">No segments found</div>';
        $(".community-segments-results-container").html(html).show();
        $(".community-segments-results-container").scrollTop(0);
        // Show next/prev page buttons
        $c4630e829f7e74ef$var$showCommunitySegmentsPagination(data);
        // Hide search results number, my segments
        $(".community-segments-results-number").hide();
        $(".community-segments-my-segments-container").hide();
        // Reset search
        $(".community-segments-search-input").val("");
        // Preview first result
        $(".community-segments-search-result-item").eq(0).trigger("click");
    });
}
function $c4630e829f7e74ef$var$deleteTemplateSegmentItem(uid, el) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $1JSre.makeGetRequest)("/_delete_template_segment_item", {
        uid: uid
    }, (data)=>{
        if (!data["error"]) {
            (0, $lCS03.playSoundEffect)("success");
            notie.alert({
                type: 4,
                text: "Segment deleted",
                stay: true
            });
            el.remove();
        } else {
            (0, $lCS03.playSoundEffect)("error");
            if (data["error"] === "not-found") notie.alert({
                type: 3,
                text: "That segment could not be found. Please try again."
            });
            if (data["error"] === "not-signed-in") notie.alert({
                type: 3,
                text: "You need to be logged in to delete segments."
            });
            if (data["error"] === "wrong-user") notie.alert({
                type: 3,
                text: "That segment does not belong to you."
            });
        }
    });
}
function $c4630e829f7e74ef$export$2b6d0d77974d29f2(el, uid) {
    (0, $1JSre.makeGetRequest)("/_get_template_segment_item_from_uid", {
        uid: uid
    }, (data)=>{
        if (!data["error"]) {
            (0, $lCS03.playSoundEffect)("success");
            notie.alert({
                type: 4,
                text: "Segment loaded"
            });
            $(".add-custom-segment-template-button").removeClass("selected");
            // Reset
            (0, $9f0f3c0f4508366a$export$4acf80557bedaca3).addCustomSegmentChangesMade = false;
            // Reset texts
            $(".add-custom-segment-start-text").val("");
            $(".add-custom-segment-action-text").val("");
            $(".add-custom-segment-tag-start-text").val("");
            $(".add-custom-segment-tag-action-text").val("");
            // Add segment data
            $(".add-custom-segment-name-input").val(data["name"]);
            $(".add-custom-segment-participants-input").val(data["max_participants"]);
            // Remove extra action text inputs
            $(".add-custom-segment-action-text").not(":first").remove();
            $(".add-custom-segment-tag-action-text").not(":first").remove();
            let text = data["text"];
            $(".add-custom-segment-start-text").val(text["start"]);
            $(".add-custom-segment-action-text").val(text["action"][0]);
            // Multiple action texts
            let actionTextHtml = '<textarea class="add-custom-segment-action-text styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>';
            text["action"].forEach(function(actionText, i) {
                if (i > 0) {
                    $(".add-custom-segment-action-text").last().after(actionTextHtml);
                    $(".add-custom-segment-action-text").eq(i).val(actionText);
                }
            });
            if (text["start_tag"]) $(".add-custom-segment-tag-start-text").val(text["start_tag"]);
            if (text["action_tag"]) {
                $(".add-custom-segment-tag-action-text").val(text["action_tag"][0]);
                // Multiple action texts
                let actionTextHtml = '<textarea class="add-custom-segment-tag-action-text styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>';
                text["action_tag"].forEach(function(actionText, i) {
                    if (i > 0) {
                        $(".add-custom-segment-tag-action-text").last().after(actionTextHtml);
                        $(".add-custom-segment-tag-action-text").eq(i).val(actionText);
                    }
                });
            }
            let chooseWinnerValue = data["choose_winner"] ? "yes" : "no";
            $('input[name="add-custom-segment-choose-winner-option"][value="' + chooseWinnerValue + '"]').prop("checked", true);
            let feudOnlyValue = data["feud_only"] ? "yes" : "no";
            $('input[name="add-custom-segment-feud-only-option"][value="' + feudOnlyValue + '"]').prop("checked", true);
            let sillyValue = data["silly"] ? "yes" : "no";
            $('input[name="add-custom-segment-silly-option"][value="' + sillyValue + '"]').prop("checked", true);
            // Run preview
            $(".add-custom-segment-preview-singles-button").trigger("click");
        } else {
            (0, $lCS03.playSoundEffect)("error");
            if (data["error"] === "not-found") notie.alert({
                type: 3,
                text: "That Segment could not be found. Please try again."
            });
        }
    });
}
function $c4630e829f7e74ef$export$182168cbcc8eeaf5(el, uid) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $1JSre.makeGetRequest)("/_rate_template_superstar", {
        uid: uid
    }, (data)=>{
        if (!data["error"]) {
            (0, $lCS03.playSoundEffect)("success");
            el.siblings(".community-graphics-item-recommendations").text(data["rating"]);
            if (data["rated_positive"]) el.removeClass("not-rated").addClass("rated");
            else el.removeClass("rated").addClass("not-rated");
        } else if (data["error"] === "not-signed-in") {
            (0, $lCS03.playSoundEffect)("error");
            notie.alert({
                type: 4,
                text: "You need to be logged in to rate graphics",
                stay: true
            });
        }
    });
}


// PIXI settings
let $c82cd471f4baff6b$var$spritesVersion = "1.68";
PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
PIXI.loader.defaultQueryString = "v=" + $c82cd471f4baff6b$var$spritesVersion;
PIXI.loader.add("static/www/static/images/sprites/sprites.json");
PIXI.utils.skipHello();
// Define variables
let $c82cd471f4baff6b$var$resourcesLoaded = false;
let $c82cd471f4baff6b$var$renderer;
let $c82cd471f4baff6b$var$stage;
let $c82cd471f4baff6b$export$7d9b72822fcb9a = "static/www/static/images/dark_background.png";
function $c82cd471f4baff6b$export$15751559525d8097(theme) {
    if (theme === "light") $c82cd471f4baff6b$export$7d9b72822fcb9a = null;
    else $c82cd471f4baff6b$export$7d9b72822fcb9a = "static/www/static/images/dark_background.png";
}
function $c82cd471f4baff6b$export$95c74f71dcb41f44(graphicData, el, matchData) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view);
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xF7F7F7;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    // Render the stage
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 110;
    $c82cd471f4baff6b$var$renderer.view.style.height = 110;
    $c82cd471f4baff6b$var$stage.position.set($c82cd471f4baff6b$var$renderer.width / 2, $c82cd471f4baff6b$var$renderer.height / 2);
    $c82cd471f4baff6b$var$stage.scale.set(1.49, 1.49);
    $c82cd471f4baff6b$var$stage.pivot.set(144, 145);
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, matchData, el, false);
}
function $c82cd471f4baff6b$export$dc322094595ee8d2(el) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view);
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xEFEFEF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    // Render the stage
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 120;
    $c82cd471f4baff6b$var$renderer.view.style.height = 200;
    $c82cd471f4baff6b$var$stage.scale.set(2.5, 1.5);
    $c82cd471f4baff6b$var$stage.pivot.set(83, 45);
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, null, null, el);
}
function $c82cd471f4baff6b$export$7dd6f6d8f75bfc39(graphicData, el, matchData) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view);
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xF7F7F7;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    // Render the stage
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    let height = 145;
    let width = 350;
    $c82cd471f4baff6b$var$renderer.view.style.width = width;
    $c82cd471f4baff6b$var$renderer.view.style.height = height;
    $c82cd471f4baff6b$var$stage.position.set($c82cd471f4baff6b$var$renderer.width / 2, $c82cd471f4baff6b$var$renderer.height / 2);
    let scaleHeight = 1.45;
    let scaleWidth = height / width * scaleHeight;
    $c82cd471f4baff6b$var$stage.scale.set(scaleWidth, scaleHeight);
    $c82cd471f4baff6b$var$stage.pivot.set(250, 145);
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, matchData, el, false);
}
function $c82cd471f4baff6b$export$319a5ed9f109ccce(graphicData, el) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(200, 100);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Remove previous canvas
    el.html("");
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view);
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xF7F7F7;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    // Render the stage
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 200;
    $c82cd471f4baff6b$var$renderer.view.style.height = 100;
    $c82cd471f4baff6b$var$stage.scale.set(0.5, 0.5);
    // Show canvas
    el.show();
    $c82cd471f4baff6b$var$loadTitleGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, el);
}
function $c82cd471f4baff6b$export$ca0cc0827d137f10(graphicData, el, matchData) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view);
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xEFEFEF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 145;
    $c82cd471f4baff6b$var$renderer.view.style.height = 145;
    $c82cd471f4baff6b$var$stage.position.set($c82cd471f4baff6b$var$renderer.width / 2, $c82cd471f4baff6b$var$renderer.height / 2);
    $c82cd471f4baff6b$var$stage.scale.set(1.45, 1.45);
    $c82cd471f4baff6b$var$stage.pivot.set(144, 145);
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, matchData, el, false);
    // Hide attire buttons for tagTeam
    if (matchData && matchData["type"] === "tag") $("#roster-member-details").find(".attire-select-button").hide();
    else $("#roster-member-details").find(".attire-select-button").show();
}
function $c82cd471f4baff6b$export$f4b4d1e8d535dcff(el) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view);
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xEFEFEF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 300;
    $c82cd471f4baff6b$var$renderer.view.style.height = 300;
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, null, null, el);
}
function $c82cd471f4baff6b$export$e7557da3ac483fcd(el, graphic, request = false, annualTournament = false) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) {
        if (annualTournament) {
            if ($c82cd471f4baff6b$var$renderer.secondary) $c82cd471f4baff6b$var$renderer.destroy();
        } else $c82cd471f4baff6b$var$renderer.destroy();
    }
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    if (annualTournament) $c82cd471f4baff6b$var$renderer.secondary = true;
    // Remove previous canvas
    el.html("");
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view);
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xFFFFFF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    if (request || annualTournament) {
        $c82cd471f4baff6b$var$renderer.view.style.width = 90;
        $c82cd471f4baff6b$var$renderer.view.style.height = 100;
    } else {
        $c82cd471f4baff6b$var$renderer.view.style.width = 100;
        $c82cd471f4baff6b$var$renderer.view.style.height = 116;
    }
    $c82cd471f4baff6b$var$stage.scale.set(5, 5);
    let yPivot = 55;
    if (annualTournament) yPivot = 58;
    $c82cd471f4baff6b$var$stage.pivot.set(113, yPivot);
    // Show canvas
    el.show();
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphic, null, el);
}
function $c82cd471f4baff6b$export$c401870440d21dc6(graphicData, el) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer && $c82cd471f4baff6b$var$renderer.secondary) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    $c82cd471f4baff6b$var$renderer.secondary = true;
    // Remove previous canvas
    el.html("");
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view).hide();
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xFFFFFF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 90;
    $c82cd471f4baff6b$var$renderer.view.style.height = 100;
    $c82cd471f4baff6b$var$stage.scale.set(5, 5);
    $c82cd471f4baff6b$var$stage.pivot.set(113, 58);
    // Show canvas
    el.show();
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, null, el);
}
function $c82cd471f4baff6b$export$d11e1d8497502e98(graphicData, el) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view); // .hide()
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xEFEFEF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 300;
    $c82cd471f4baff6b$var$renderer.view.style.height = 300;
    $c82cd471f4baff6b$var$stage.pivot.set(0, 10);
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, null, el);
}
function $c82cd471f4baff6b$export$619533229dc4b088(graphic, el) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view);
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xEFEFEF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 145;
    $c82cd471f4baff6b$var$renderer.view.style.height = 145;
    $c82cd471f4baff6b$var$stage.position.set($c82cd471f4baff6b$var$renderer.width / 2, $c82cd471f4baff6b$var$renderer.height / 2);
    $c82cd471f4baff6b$var$stage.scale.set(1.45, 1.45);
    $c82cd471f4baff6b$var$stage.pivot.set(144, 145);
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, [
        graphic
    ], null, el, false);
}
function $c82cd471f4baff6b$export$fe2486523999867a(el) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Remove previous canvas
    el.html("");
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view).hide();
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xEFEFEF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 300;
    $c82cd471f4baff6b$var$renderer.view.style.height = 300;
    // Show canvas
    el.show();
    let graphic = JSON.parse(el.data("key"));
    let graphicList;
    if (graphic) graphicList = [
        graphic
    ];
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicList, null, el);
    // Show controls
    el.next(".character-creator-controls").show();
    $(".sp-replacer").addClass("grey-background");
}
function $c82cd471f4baff6b$export$4b9758d42b68e382(graphicData, el, matchData) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(430, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view);
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xFFFFFF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x1B1B1B;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, matchData, el, false);
}
function $c82cd471f4baff6b$export$ea5c1fdc48a35ee(el, graphicData) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(400, 200);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Remove previous canvas
    el.html("");
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view).hide();
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xF9F9F9;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 370;
    $c82cd471f4baff6b$var$renderer.view.style.height = 185;
    // Show canvas
    el.show();
    $c82cd471f4baff6b$var$loadTitleGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, [
        graphicData
    ], el);
}
function $c82cd471f4baff6b$export$3b20358be464ca0c(el, graphicData) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(400, 200);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Remove previous canvas
    el.html("");
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view).hide();
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xEFEFEF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 400;
    $c82cd471f4baff6b$var$renderer.view.style.height = 200;
    $c82cd471f4baff6b$var$stage.pivot.set(0, 0);
    // Show canvas
    el.show();
    $c82cd471f4baff6b$var$loadTitleGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, el);
}
function $c82cd471f4baff6b$export$aba7f700818b4b5c(graphicData, el) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 150);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Remove previous canvas
    el.html("");
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view).hide();
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xEFEFEF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 300;
    $c82cd471f4baff6b$var$renderer.view.style.height = 150;
    $c82cd471f4baff6b$var$stage.scale.set(0.75, 0.75);
    $c82cd471f4baff6b$var$loadTitleGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, el);
}
function $c82cd471f4baff6b$export$7ba12038bb800503(el, graphicData) {
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(300, 150);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    // Remove previous canvas
    el.html("");
    // Add the canvas to the HTML document
    el.append($c82cd471f4baff6b$var$renderer.view).hide();
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xEFEFEF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x353535;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    $c82cd471f4baff6b$var$renderer.view.style.width = 300;
    $c82cd471f4baff6b$var$renderer.view.style.height = 150;
    $c82cd471f4baff6b$var$stage.scale.set(0.75, 0.75);
    // Show canvas
    el.show();
    $c82cd471f4baff6b$var$loadTitleGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, graphicData, el);
}
function $c82cd471f4baff6b$var$loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, jsonData, match, el, showPalette, segmentAction, posterData) {
    let graphicsParent = el.parent();
    if (typeof showPalette === "undefined") showPalette = true;
    if (typeof jsonData === "undefined") jsonData = null;
    if (typeof match === "undefined") match = null;
    if (typeof el === "undefined" || el === null) el = $(".select-part");
    else el = el.siblings(".character-creator-controls").find(".select-part");
    if (typeof segmentAction === "undefined") segmentAction = null;
    if (typeof posterData === "undefined") posterData = null;
    // Reset attires
    graphicsParent.find(".attire-select-button").data("graphicJson", null);
    // Select "A" attire
    graphicsParent.find(".attire-select-button.selected").removeClass("selected");
    graphicsParent.find('.attire-select-button:contains("A")').addClass("selected");
    $(".part-button.disabled").removeClass("disabled");
    $(".remove-attire-button").hide();
    // Add alternate attires
    let attireButtons = [
        graphicsParent.find('.attire-select-button:contains("B")'),
        graphicsParent.find('.attire-select-button:contains("C")')
    ];
    if (jsonData) {
        let alternateAttires;
        try {
            alternateAttires = jsonData[0]["alternate_attires"];
        } catch (error) {
            (0, $3E8Nt.captureError)(error);
        }
        if (alternateAttires) alternateAttires.forEach(function(attire, i) {
            attireButtons[i].data("graphicJson", JSON.stringify(attire));
        });
        // Add base attire
        graphicsParent.find('.attire-select-button:contains("A")').data("graphicJson", JSON.stringify(jsonData[0]));
    }
    // Run setup if resources loaded, otherwise wait for load event (first time)
    PIXI.loader.on("complete", function() {
        $c82cd471f4baff6b$var$resourcesLoaded = true;
    });
    if ($c82cd471f4baff6b$var$resourcesLoaded) {
        // Unbind click handlers
        $(".character-creator-controls *").off();
        setup();
    } else PIXI.loader.load(setup);
    function setup() {
        // Initialize spectrum color picker
        if (showPalette) el.next(".part-controls").find(".spectrum").spectrum({
            showPalette: true,
            palette: [
                [
                    "#000",
                    "#444",
                    "#666",
                    "#999",
                    "#ccc",
                    "#eee",
                    "#f3f3f3",
                    "#fff"
                ],
                [
                    "#f00",
                    "#f90",
                    "#ff0",
                    "#0f0",
                    "#0ff",
                    "#00f",
                    "#90f",
                    "#f0f"
                ],
                [
                    "#f4cccc",
                    "#fce5cd",
                    "#fff2cc",
                    "#d9ead3",
                    "#d0e0e3",
                    "#cfe2f3",
                    "#d9d2e9",
                    "#ead1dc"
                ],
                [
                    "#ea9999",
                    "#f9cb9c",
                    "#ffe599",
                    "#b6d7a8",
                    "#a2c4c9",
                    "#9fc5e8",
                    "#b4a7d6",
                    "#d5a6bd"
                ],
                [
                    "#e06666",
                    "#f6b26b",
                    "#ffd966",
                    "#93c47d",
                    "#76a5af",
                    "#6fa8dc",
                    "#8e7cc3",
                    "#c27ba0"
                ],
                [
                    "#c00",
                    "#e69138",
                    "#f1c232",
                    "#6aa84f",
                    "#45818e",
                    "#3d85c6",
                    "#674ea7",
                    "#a64d79"
                ],
                [
                    "#900",
                    "#b45f06",
                    "#bf9000",
                    "#38761d",
                    "#134f5c",
                    "#0b5394",
                    "#351c75",
                    "#741b47"
                ],
                [
                    "#600",
                    "#783f04",
                    "#7f6000",
                    "#274e13",
                    "#0c343d",
                    "#073763",
                    "#20124d",
                    "#4c1130"
                ],
                [
                    "#FFE4CB",
                    "#F4D7BC",
                    "#FFD9B6",
                    "#FFD4AB",
                    "#F2D2A5",
                    "#DFB58D",
                    "#CAA684",
                    "#7A6353"
                ]
            ],
            preferredFormat: "hex",
            color: "#F7D1B9",
            showInitial: true,
            showInput: true,
            showButtons: false
        });
        // Add grey background to gimmick graphic spectrum
        $("#create-gimmick-graphic-container").find(".sp-replacer").addClass("grey-background");
        $("#change-appearance-graphic-container").find(".sp-replacer").addClass("grey-background");
        $("#change-staff-appearance-graphic-container").find(".sp-replacer").addClass("grey-background");
        $("#add-superstar").find(".sp-replacer").addClass("grey-background");
        const sprites = (0, $cdadd3e3b416e3dd$export$cd054587bb4ae1d2)();
        let parts = {
            "accessory": sprites.accessories,
            "bottoms": sprites.bottoms,
            "torso": sprites.torsos,
            "hair": sprites.hairs,
            "shoes": sprites.shoes,
            "elbow": sprites.elbows,
            "facialHair": sprites.facialHairs,
            "body": sprites.bodies,
            "accessory2": sprites.accessories,
            "accessory3": sprites.accessories,
            "knee": sprites.kneepads,
            "facepaint": sprites.facepaints,
            "tattoo": sprites.tattoos,
            "eyes": sprites.eyes,
            "blood": sprites.bloodObjects,
            "weapon": sprites.weaponObjects,
            "temporaryInjury": sprites.temporaryInjuryObjects,
            "temporaryTrophy": sprites.temporaryTrophyObjects
        };
        let selected;
        let selectedPart;
        let selections = sprites.bodies;
        // Set positions
        sprites.bodies.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(103, 68);
            });
        }); // 77 originally
        sprites.bottoms.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(121, 159);
            });
        });
        sprites.trunks.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(121, 159);
            });
        });
        sprites.shorts.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(121, 161);
            });
        });
        sprites.tights.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(121, 160);
            });
        });
        sprites.feminineBottoms.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(121, 158);
            });
        });
        sprites.torsos.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(94, 98);
            });
        });
        sprites.hairs.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(103, 50);
            });
        });
        sprites.shoes.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(118, 197);
            });
        });
        sprites.elbows.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(100, 128);
            });
        });
        sprites.facialHairs.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(121, 68);
            });
        });
        sprites.accessories.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(94, 50);
            });
        });
        sprites.flags.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(94, -9);
            });
        });
        sprites.allFacepaints.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(125, 66);
            });
        });
        sprites.kneepads.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(121, 181);
            });
        });
        sprites.allTattoos.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(103, 68);
            });
        });
        sprites.eyes.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(127, 80);
            });
        });
        sprites.smallCenterPlates.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(118, 140);
            });
        });
        sprites.smallStraps.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(118, 140);
            });
        });
        sprites.smallGems.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(118, 140);
            });
        });
        sprites.bloodObjects.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(94, 50);
            });
        });
        sprites.temporaryInjuryObjects.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(94, 50);
            });
        });
        sprites.temporaryTrophyObjects.map(function(x) {
            x.designs.map(function(y) {
                y.sprite.position.set(94, -10);
            });
        });
        function getObject(object, objects) {
            let objectIndex;
            // Don't add object if empty sprite
            if (object && object.designs[0].sprite === sprites.emptySprite) objectIndex = -1;
            else objectIndex = objects.indexOf(object);
            return {
                object: objectIndex,
                colors: object ? object.designs.map(function(x) {
                    return x.defaultColor;
                }) : null
            };
        }
        function getGraphicJson(getAlternateAttires) {
            if (typeof getAlternateAttires === "undefined") getAlternateAttires = true;
            let data = {
                accessory: getObject(addedAccessory, sprites.accessories),
                accessory2: getObject(addedAccessory2, sprites.accessories),
                accessory3: getObject(addedAccessory3, sprites.accessories),
                body: getObject(addedBody, sprites.bodies),
                bottoms: getObject(addedBottoms, sprites.bottoms),
                elbow: getObject(addedElbow, sprites.elbows),
                eyes: getObject(addedEyes, sprites.eyes),
                facepaint: getObject(addedFacepaint, sprites.facepaints),
                facialHair: getObject(addedFacialHair, sprites.facialHairs),
                hair: getObject(addedHair, sprites.hairs),
                knee: getObject(addedKneepad, sprites.kneepads),
                shoes: getObject(addedShoes, sprites.shoes),
                tattoo: getObject(addedTattoo, sprites.tattoos),
                torso: getObject(addedTorso, sprites.torsos)
            };
            if (addedTemporaryInjury) data.temporaryInjury = getObject(addedTemporaryInjury, sprites.temporaryInjuryObjects);
            if (addedTemporaryTrophy) data.temporaryTrophy = getObject(addedTemporaryTrophy, sprites.temporaryTrophyObjects);
            if (getAlternateAttires) {
                // If "A" attire not selected
                if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                    // Set graphic code to "A" attire
                    let baseAttireCode = graphicsParent.find('.attire-select-button:contains("A")').data("graphicJson");
                    data = JSON.parse(baseAttireCode);
                    // Save graphic data for selected attire
                    let selectedAttire = graphicsParent.find(".attire-select-button.selected");
                    $(selectedAttire).data("graphicJson", getGraphicJson(false));
                }
                // Get alternate attires if present and not same as base attire
                let alternateAttireCodes = [
                    graphicsParent.find('.attire-select-button:contains("B")').data("graphicJson"),
                    graphicsParent.find('.attire-select-button:contains("C")').data("graphicJson")
                ];
                let alternateAttireCodesFiltered = alternateAttireCodes.filter(function(jsonString) {
                    return jsonString && !(0, $1JSre.objectEquals)(JSON.parse(jsonString), data);
                });
                let alternateAttires = Array.from(alternateAttireCodesFiltered, function(jsonString) {
                    return JSON.parse(jsonString);
                });
                // Add alternate attires to graphic data
                data["alternate_attires"] = alternateAttires;
            }
            return JSON.stringify(data);
        }
        // Check for loaded data
        let data = jsonData;
        let addedBottoms;
        let addedBody;
        let addedShoes;
        let addedHair;
        let addedTorso;
        let addedElbow;
        let addedFacialHair;
        let addedAccessory;
        let addedAccessory2;
        let addedAccessory3;
        let addedKneepad;
        let addedFacepaint;
        let addedTattoo;
        let addedEyes;
        let addedTemporaryInjury;
        let addedTemporaryTrophy;
        let selectedAccessory;
        let accessoryNumbers = [
            1,
            2,
            3
        ];
        let addedParts = {
            "body": addedBody,
            "bottoms": addedBottoms,
            "torso": addedTorso,
            "hair": addedHair,
            "shoes": addedShoes,
            "elbow": addedElbow,
            "facialHair": addedFacialHair,
            "weapon": null,
            "accessory": addedAccessory,
            "accessory2": addedAccessory2,
            "accessory3": addedAccessory3,
            "facepaint": addedFacepaint,
            "knee": addedKneepad,
            "tattoo": addedTattoo,
            "eyes": addedEyes,
            "blood": null,
            "temporaryInjury": null,
            "temporaryTrophy": null
        };
        let allowChange;
        if (data || match && match["special"]) {
            // Load character if data present or special segment
            loadCharacter(data);
            // Don't allow randomization after loading character
            allowChange = false;
        } else {
            // Add default character
            addedBottoms = sprites.bottoms[0];
            addedBody = sprites.bodies[0];
            addedShoes = sprites.shoes[0];
            addedHair = sprites.hairs[1];
            addedEyes = sprites.eyes[0];
            addedTorso = null;
            addedElbow = null;
            addedFacialHair = null;
            addedAccessory = null;
            addedAccessory2 = null;
            addedAccessory3 = null;
            addedKneepad = null;
            addedFacepaint = null;
            addedTattoo = null;
            // Add parts to stage, set colors and zIndex
            addedBody.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedBottoms.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedHair.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedShoes.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedEyes.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            // Allow randomization
            allowChange = true;
        }
        let originalGraphicData;
        if (jsonData) originalGraphicData = JSON.stringify(jsonData[0]);
        else originalGraphicData = getGraphicJson(false);
        $c82cd471f4baff6b$var$renderer.render(stage);
        // Change style
        let x = 0;
        let scenarioFormSelector = $("#add-superstar, #create-gimmick-graphic-container, #change-appearance-graphic-container, .community-graphics-graphic-container, .scenario-editor-container, #change-staff-appearance-graphic-container");
        scenarioFormSelector.off().on("click", ".select-next, .select-previous", function() {
            allowChange = false;
            let $this = $(this);
            let accessoriesDuplicates = false;
            let accessoryNumberElement = $this.closest(".character-creator-controls").find(".accessory-number-button.selected");
            // Check for accessory sprite duplicates
            if (sprites.accessories.indexOf(selected) !== -1) switch(accessoryNumberElement.text()){
                case "1":
                    selected = addedAccessory;
                    if (addedAccessory && (addedAccessory === addedAccessory2 || addedAccessory === addedAccessory3)) accessoriesDuplicates = true;
                    break;
                case "2":
                    selected = addedAccessory2;
                    if (addedAccessory2 && (addedAccessory2 === addedAccessory || addedAccessory2 === addedAccessory3)) accessoriesDuplicates = true;
                    break;
                case "3":
                    selected = addedAccessory3;
                    if (addedAccessory3 && (addedAccessory3 === addedAccessory || addedAccessory3 === addedAccessory2)) accessoriesDuplicates = true;
                    break;
                default:
                    selected = addedAccessory;
                    if (addedAccessory && (addedAccessory === addedAccessory2 || addedAccessory === addedAccessory3)) accessoriesDuplicates = true;
                    break;
            }
            // Replace existing part
            if (selections.indexOf(selected) !== -1) // Don't replace if same sprite is in another accessory number
            {
                if (!accessoriesDuplicates) selected.designs.map(function(x) {
                    stageObjects.removeChild(x.sprite);
                });
            }
            // Next and previous selection
            if ($this.hasClass("select-previous")) x--;
            else x++;
            // Stay within selections
            if (x === selections.length) x = 0;
            if (x < 0) x = selections.length - 1;
            // Select and display part (add to layer for z index sorting)
            selected = selections[x];
            if (selections.indexOf(selected) !== -1) selected.designs.map(function(x) {
                stageObjects.addChild(x.sprite);
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
            });
            $c82cd471f4baff6b$var$renderer.render(stage);
            // Store selected part and alter positioning if needed
            if (sprites.hairs.indexOf(selected) !== -1) addedHair = selected;
            else if (sprites.bottoms.indexOf(selected) !== -1) addedBottoms = selected;
            else if (sprites.shoes.indexOf(selected) !== -1) addedShoes = selected;
            else if (sprites.torsos.indexOf(selected) !== -1) addedTorso = selected;
            else if (sprites.elbows.indexOf(selected) !== -1) addedElbow = selected;
            else if (sprites.facialHairs.indexOf(selected) !== -1) addedFacialHair = selected;
            else if (sprites.accessories.indexOf(selected) !== -1) {
                selectedAccessory = selected;
                // Save to accessory number
                switch(accessoryNumberElement.text()){
                    case "1":
                        addedAccessory = selected;
                        break;
                    case "2":
                        addedAccessory2 = selected;
                        break;
                    case "3":
                        addedAccessory3 = selected;
                        break;
                    default:
                        addedAccessory = selected;
                }
            } else if (sprites.tattoos.indexOf(selected) !== -1) addedTattoo = selected;
            else if (sprites.facepaints.indexOf(selected) !== -1) addedFacepaint = selected;
            else if (sprites.kneepads.indexOf(selected) !== -1) addedKneepad = selected;
            else if (sprites.eyes.indexOf(selected) !== -1) addedEyes = selected;
            else if (sprites.bodies.indexOf(selected) !== -1) {
                addedBody = selected;
                addedBody.parentLayer = layer;
                addedBody.zIndex = -1;
                updateBodySprites();
            }
            // Update selection number
            $this.parent().find(".selection-number").text(x + 1);
            // Update positions of parts based on size
            updateDesigns(selected);
            if (selected === sprites.topObject41) {
                if ($(".buy-jow-shirt").length > 0) $(".buy-jow-shirt").show();
                else el.parent().find(".preset-2").after('\n<button type="button" class="button retro-button gold-button-background condensed remove-outline buy-jow-shirt no-select">Buy Shirt</button>');
            } else $(".buy-jow-shirt").hide();
        });
        // Link to shirt
        scenarioFormSelector.on("click", ".buy-jow-shirt", function() {
            window.open("https://teespring.com/new-journey-of-wrestling");
        });
        // Select part to edit
        scenarioFormSelector.on("click", ".part-button", function() {
            if ($(this).hasClass("disabled")) {
                notie.alert({
                    type: 4,
                    text: "You cannot change Body, Eyes, Hair, Facial Hair or Tattoos for Alternate Attires"
                });
                return false;
            }
            // Hide share/import
            $(this).parent().siblings(".load-character-code-container").hide();
            $(this).parent().siblings(".share-character-code-container").hide();
            $(this).parent().siblings(".graphics-search-container").hide();
            $(this).parent().siblings(".character-creator-menu").find(".button").removeClass("selected");
            let $this = $(this);
            $(this).addClass("selected");
            $(this).parent().children().each(function() {
                if (!$(this).is($this)) $(this).removeClass("selected");
            });
            selectedPart = $(this).text().trim().toLowerCase();
            let selectAccessoryElement = $this.siblings(".select-accessory-number");
            let characterCreatorElement = $this.closest(".character-creator-controls");
            let subCategories = [];
            // Reset accessory number selection
            characterCreatorElement.find(".select-accessory-number").html("");
            switch($(this).text().trim()){
                case "Body":
                    selections = sprites.bodies;
                    if (addedBody) {
                        x = selections.indexOf(addedBody);
                        selected = addedBody;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Bottoms":
                    selections = sprites.bottoms;
                    if (addedBottoms) {
                        x = selections.indexOf(addedBottoms);
                        selected = addedBottoms;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    subCategories = [
                        "Tights",
                        "Trunks",
                        "Shorts",
                        "Feminine"
                    ];
                    break;
                case "Torso":
                    selections = sprites.torsos;
                    if (addedTorso) {
                        x = selections.indexOf(addedTorso);
                        selected = addedTorso;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    subCategories = [
                        "Shirt",
                        "Vest",
                        "Sports Bra",
                        "Feminine",
                        "Other"
                    ];
                    break;
                case "Hair":
                    selections = sprites.hairs;
                    if (addedHair) {
                        x = selections.indexOf(addedHair);
                        selected = addedHair;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    subCategories = [
                        "Short",
                        "Long",
                        "Feminine"
                    ];
                    break;
                case "Shoes":
                    selections = sprites.shoes;
                    if (addedShoes) {
                        x = selections.indexOf(addedShoes);
                        selected = addedShoes;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    subCategories = [
                        "Long",
                        "Short"
                    ];
                    break;
                case "Elbow":
                    selections = sprites.elbows;
                    if (addedElbow) {
                        x = selections.indexOf(addedElbow);
                        selected = addedElbow;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Facial Hair":
                    selections = sprites.facialHairs;
                    if (addedFacialHair) {
                        x = selections.indexOf(addedFacialHair);
                        selected = addedFacialHair;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Accessory":
                    selections = sprites.accessories;
                    subCategories = [
                        "Wrist Tape",
                        "Gloves",
                        "Glasses",
                        "Neck",
                        "Suit & Tie",
                        "Feminine",
                        "Weapons",
                        "Masks",
                        "Flags",
                        "Other"
                    ];
                    // Show accessory number selection
                    let html = "";
                    accessoryNumbers.forEach(function(accessoryNumber) {
                        html += '<button type="button" class="button retro-button condensed dark-grey-button-background remove-outline accessory-number-button">' + accessoryNumber + "</button>\n";
                    });
                    selectAccessoryElement.html(html);
                    selectAccessoryElement.find(".accessory-number-button").eq(0).trigger("click");
                    break;
                case "Knee":
                    selections = sprites.kneepads;
                    if (addedKneepad) {
                        x = selections.indexOf(addedKneepad);
                        selected = addedKneepad;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Facepaint":
                    selections = sprites.facepaints;
                    if (addedFacepaint) {
                        x = selections.indexOf(addedFacepaint);
                        selected = addedFacepaint;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Tattoo":
                    selections = sprites.tattoos;
                    if (addedTattoo) {
                        x = selections.indexOf(addedTattoo);
                        selected = addedTattoo;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Eyes":
                    selections = sprites.eyes;
                    if (addedEyes) {
                        x = selections.indexOf(addedEyes);
                        selected = addedEyes;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
            }
            $c82cd471f4baff6b$var$addCharacterCreatorSubCategory(subCategories, characterCreatorElement);
        });
        // Select sub-category
        scenarioFormSelector.on("click", ".sub-category-button", function() {
            // Hide share/import
            $(this).parent().siblings(".load-character-code-container").hide();
            $(this).parent().siblings(".share-character-code-container").hide();
            $(this).parent().siblings(".graphics-search-container").hide();
            $(this).parent().siblings(".character-creator-menu").find(".button").removeClass("selected");
            // Select sub-category button
            let $this = $(this);
            $(this).addClass("selected");
            $(this).parent().children().each(function() {
                if (!$(this).is($this)) $(this).removeClass("selected");
            });
            let accessoryNumber = $this.parent().siblings(".select-accessory-number").find(".accessory-number-button.selected").text();
            // Check for accessory sprite duplicates
            let accessoriesDuplicates = false;
            if (sprites.accessories.indexOf(selected) !== -1) switch(accessoryNumber){
                case "1":
                    if (addedAccessory && (addedAccessory === addedAccessory2 || addedAccessory === addedAccessory3)) accessoriesDuplicates = true;
                    selected = addedAccessory;
                    break;
                case "2":
                    if (addedAccessory2 && (addedAccessory2 === addedAccessory || addedAccessory2 === addedAccessory3)) accessoriesDuplicates = true;
                    selected = addedAccessory2;
                    break;
                case "3":
                    if (addedAccessory3 && (addedAccessory3 === addedAccessory2 || addedAccessory3 === addedAccessory)) accessoriesDuplicates = true;
                    selected = addedAccessory3;
                    break;
                default:
                    if (addedAccessory && (addedAccessory === addedAccessory2 || addedAccessory === addedAccessory3)) accessoriesDuplicates = true;
                    selected = addedAccessory;
                    break;
            }
            // Remove existing part
            if (selections.indexOf(selected) !== -1) {
                if (!accessoriesDuplicates) selected.designs.map(function(x) {
                    stageObjects.removeChild(x.sprite);
                });
            }
            // Category name parsing
            let subCategoryName = $this.text().trim();
            let parentCategoryName = $this.parent().siblings(".selected").text().trim();
            selections = getSubCategorySelections(parentCategoryName, subCategoryName);
            // Select first part of sub-category
            x = 0;
            // Set selected part
            try {
                setSelectedPartForSubCategory(parentCategoryName, selections[x], accessoryNumber);
            } catch (e) {
                (0, $3E8Nt.captureError)(e);
            }
            $(this).closest(".select-part").siblings(".part-controls").find(".selection-number").text(x + 1);
            updateDesigns(selected);
            // Display part
            selected.designs.map(function(x) {
                stageObjects.addChild(x.sprite);
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
            });
            $c82cd471f4baff6b$var$renderer.render(stage);
            allowChange = false;
        });
        // Select accessory number
        scenarioFormSelector.on("click", ".accessory-number-button", function() {
            // Hide share/import
            $(this).parent().siblings(".load-character-code-container").hide();
            $(this).parent().siblings(".share-character-code-container").hide();
            $(this).parent().siblings(".graphics-search-container").hide();
            $(this).parent().siblings(".character-creator-menu").find(".button").removeClass("selected");
            // Select this button
            let $this = $(this);
            $(this).addClass("selected");
            $(this).parent().children().each(function() {
                if (!$(this).is($this)) $(this).removeClass("selected");
            });
            // Reset sub category buttons and selections
            $(this).parent().siblings(".select-sub-category").find(".sub-category-button").removeClass("selected");
            selections = sprites.accessories;
            // Load using accessory number
            let accessoryNumber = $this.text();
            switch(accessoryNumber){
                case "1":
                    selectedAccessory = addedAccessory;
                    break;
                case "2":
                    selectedAccessory = addedAccessory2;
                    break;
                case "3":
                    selectedAccessory = addedAccessory3;
                    break;
                default:
                    selectedAccessory = addedAccessory;
            }
            if (selectedAccessory) {
                x = selections.indexOf(selectedAccessory);
                selected = selectedAccessory;
                $(this).closest(".select-part").siblings(".part-controls").find(".selection-number").text(x + 1);
                updateDesigns(selected);
            } else {
                x = -1;
                $(this).closest(".select-part").siblings(".part-controls").find(".selection-number").text(0);
                $(this).closest(".select-part").siblings(".part-controls").find(".select-design .button").hide();
            }
        });
        // Select design to recolor
        scenarioFormSelector.on("click", ".select-design .button", function() {
            let $this = $(this);
            $(this).addClass("selected");
            $this.parent().children().each(function() {
                if (!$(this).is($this)) $(this).removeClass("selected");
            });
            // Update color selection
            let i = $this.parent().children().index($this);
            if (i >= 0) {
                let color = selected.designs[i].defaultColor.slice(2);
                $this.parent().parent().prev().find(".spectrum").spectrum("set", color);
            }
        });
        // Change color
        scenarioFormSelector.on("move.spectrum change", ".spectrum", function(e, tinycolor) {
            if (selected) {
                allowChange = false;
                let selectDesign = $(this).parent().siblings(".select-design-holder").children(".select-design");
                // Convert color to hexadecimal
                let colorString = tinycolor.toHexString();
                let color = "0x" + colorString.slice(1);
                // Find which design is selected
                let i;
                if (selectDesign.find(".selected:visible").length > 0) i = selectDesign.find("button").index(selectDesign.find(".selected"));
                else i = 0;
                selected.designs[i].sprite.tint = color;
                // Change default color, saving selected color
                selected.designs[i].defaultColor = color;
                $c82cd471f4baff6b$var$renderer.render(stage);
            }
        });
        // Save character
        scenarioFormSelector.on("click", ".share-character", function() {
            jsonData = getGraphicJson();
            // Show code and copy button
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this).parent().siblings(".share-character-code-container").hide();
            } else {
                $(this).siblings().removeClass("selected");
                $(this).addClass("selected");
                $(this).parent().siblings(".share-character-code-container").show();
                $(this).parent().siblings(".share-character-code-container").children(".share-character-code-input").val(jsonData).text(jsonData).focus();
                $(this).parent().siblings(".load-character-code-container").hide();
                $(this).parent().siblings(".randomize-character-container").hide();
                $(this).parent().siblings(".graphics-search-container").hide();
            }
        });
        // Copy character code
        scenarioFormSelector.on("click", ".copy-character-code", function() {
            $(this).parent().siblings(".character-creator-menu").find(".share-character").trigger("click");
            $c82cd471f4baff6b$export$2cdf1b96a9f86d16($(this).siblings(".share-character-code-input"));
        });
        // Import character
        scenarioFormSelector.on("click", ".import-character", function() {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this).parent().siblings(".load-character-code-container").hide();
            } else {
                $(this).siblings().removeClass("selected");
                $(this).addClass("selected");
                // Show input and load button
                $(this).parent().siblings(".load-character-code-container").show();
                $(this).parent().siblings(".load-character-code-container").find(".load-character-code-input").focus();
                $(this).parent().siblings(".share-character-code-container").hide();
                $(this).parent().siblings(".randomize-character-container").hide();
                $(this).parent().siblings(".graphics-search-container").hide();
            }
        });
        // Load character code
        scenarioFormSelector.on("click", ".load-character-code-button", function() {
            let data = $(this).siblings(".load-character-code-input").val();
            if (!data) notie.alert({
                type: 3,
                text: "Invalid character code",
                stay: false
            });
            else {
                let communityGraphics = $(el).closest(".community-graphics-graphic-container").length > 0;
                // If loading community graphic, confirm if changes made
                if (communityGraphics) {
                    if (allowChange) loadCharacterCode(data, $(this), communityGraphics);
                    else notie.confirm({
                        text: "Are you sure?",
                        submitCallback: function() {
                            loadCharacterCode(data, $(this), communityGraphics);
                            allowChange = true;
                        }
                    });
                } else loadCharacterCode(data, $(this), communityGraphics);
            }
        });
        function loadCharacterCode(data, button, communityGraphics) {
            try {
                let loadAlternateAttires = true;
                // Only load clothes for alternate attires, except when loading inside community graphics
                if (!communityGraphics) {
                    if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                        // Replace physical appearance parts
                        let keys = [
                            "body",
                            "eyes",
                            "hair",
                            "facialHair",
                            "tattoo"
                        ];
                        let selectedAttire = graphicsParent.find(".attire-select-button.selected");
                        let baseAttireCode = JSON.parse($(selectedAttire).data("graphicJson"));
                        let currentAttireCode = JSON.parse(data);
                        // Go through each key, replacing with base attire value if this attire's value is same as base attire's value
                        keys.forEach(function(key) {
                            if (currentAttireCode[key] && JSON.stringify(currentAttireCode[key]) !== JSON.stringify(baseAttireCode[key])) currentAttireCode[key] = baseAttireCode[key];
                        });
                        data = JSON.stringify(currentAttireCode);
                        loadAlternateAttires = false;
                    }
                }
                // Delete temporary keys
                jsonData = JSON.parse(data);
                if (jsonData.temporaryInjury) {
                    delete jsonData.temporaryInjury;
                    data = JSON.stringify(jsonData);
                }
                if (jsonData.temporaryTrophy) {
                    delete jsonData.temporaryTrophy;
                    data = JSON.stringify(jsonData);
                }
                loadGraphicCode(data, loadAlternateAttires);
                button.parent().siblings(".character-creator-menu").find(".import-character").removeClass("selected");
                button.parent(".load-character-code-container").hide();
                if (!communityGraphics) notie.alert({
                    type: 4,
                    text: "Character loaded!",
                    stay: false
                });
            } catch (e) {
                (0, $3E8Nt.captureError)(e);
                notie.alert({
                    type: 3,
                    text: "Invalid character code",
                    stay: false
                });
            }
        }
        function loadGraphicCode(data, loadAlternateAttires) {
            if (typeof loadAlternateAttires === "undefined") loadAlternateAttires = false;
            let characterData = JSON.parse(data);
            loadCharacter([
                characterData
            ]);
            updateBodySprites();
            if (loadAlternateAttires) {
                $c82cd471f4baff6b$var$loadBaseAttire();
                // Load alternate attires
                let characterDataAlternateAttires = characterData["alternate_attires"] ? characterData["alternate_attires"] : [];
                characterDataAlternateAttires.forEach(function(attire, i) {
                    attireButtons[i].data("graphicJson", JSON.stringify(attire));
                });
                // Load default attire in unused alternate attire buttons
                delete characterData["alternate_attires"]; // Remove alternate attires key for alternate attires
                let unusedButtons = attireButtons.slice(characterDataAlternateAttires.length);
                unusedButtons.forEach(function(attireButton) {
                    attireButton.data("graphicJson", JSON.stringify(characterData));
                });
            }
        }
        // Randomize character menu
        scenarioFormSelector.on("click", ".randomize-character", function() {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this).parent().siblings(".randomize-character-container").hide();
            } else {
                $(this).siblings().removeClass("selected");
                $(this).addClass("selected");
                // Show input and load button
                $(this).parent().siblings(".randomize-character-container").show();
                $(this).parent().siblings(".share-character-code-container").hide();
                $(this).parent().siblings(".load-character-code-container").hide();
                $(this).parent().siblings(".graphics-search-container").hide();
            }
        });
        // Search community graphics button
        scenarioFormSelector.on("click", ".search-graphics", function() {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this).parent().siblings(".graphics-search-container").hide();
            } else {
                $(this).siblings().removeClass("selected");
                $(this).addClass("selected");
                // Show input and load button
                $(this).parent().siblings(".share-character-code-container").hide();
                $(this).parent().siblings(".load-character-code-container").hide();
                $(this).parent().siblings(".randomize-character-container").hide();
                let graphicsSearchContainer = $(this).parent().siblings(".graphics-search-container");
                graphicsSearchContainer.show();
                graphicsSearchContainer.find(".graphics-search-input-name").val("").focus();
                graphicsSearchContainer.find(".graphics-search-results").hide();
                if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) notie.alert({
                    type: 4,
                    text: 'Only clothes are imported for Alternate Attires. Select Attire "A" to load the full graphic.',
                    stay: false
                });
            }
        });
        // Search graphics
        scenarioFormSelector.on("click", ".graphics-search-button", function() {
            let parent = $(this).closest(".graphics-search-container");
            let searchTerm = parent.find(".graphics-search-input-name").val();
            // Validate
            if (searchTerm.length <= 0) {
                notie.alert({
                    type: 3,
                    text: "Enter a name to search for"
                });
                return false;
            }
            (0, $c4630e829f7e74ef$export$d2345c57f6006d32)(parent, searchTerm);
        });
        scenarioFormSelector.on("keypress", ".graphics-search-input-name", function(e) {
            // Trigger search on enter key press
            if (e.which === 13) {
                $(this).parent().find(".graphics-search-button").click();
                e.preventDefault();
            }
        });
        // Recommend graphic
        scenarioFormSelector.on("click", ".recommend-community-graphic-button", function(e) {
            e.stopPropagation();
            let el = $(this);
            let uid = $(this).closest(".graphics-search-result-item").attr("data-uid");
            (0, $c4630e829f7e74ef$export$182168cbcc8eeaf5)(el, uid);
        });
        // Sort graphic search results
        scenarioFormSelector.on("click", ".graphics-search-sort-results-button", function() {
            if (!$(this).hasClass("selected")) {
                $(this).siblings().removeClass("selected");
                $(this).addClass("selected");
            }
            let sortValue = $(this).text().trim().toLowerCase();
            let parent = $(this).closest(".graphics-search-container");
            let searchTerm = parent.find(".graphics-search-input-name").val();
            (0, $c4630e829f7e74ef$export$d2345c57f6006d32)(parent, searchTerm, null, sortValue);
        });
        // Next/previous page buttons
        scenarioFormSelector.on("click", ".graphics-next-page-button, .graphics-previous-page-button", function() {
            let page = $(this).data("page");
            let parent = $(this).closest(".graphics-search-container");
            let searchTerm = parent.find(".graphics-search-input-name").val();
            let sortValue = parent.find(".graphics-search-sort-results-button.selected").text().trim().toLowerCase();
            (0, $c4630e829f7e74ef$export$d2345c57f6006d32)(parent, searchTerm, page, sortValue);
        });
        // Load graphic upon clicking on search result
        scenarioFormSelector.on("click", ".graphics-search-result-item", function() {
            let parent = $(this).closest(".graphics-search-container");
            $(this).siblings().removeClass("selected");
            $(this).addClass("selected");
            let graphicCode = $(this).attr("data-graphic");
            parent.siblings(".load-character-code-container").find(".load-character-code-input").val(graphicCode);
            parent.siblings(".load-character-code-container").find(".load-character-code-button").trigger("click");
        });
        // Randomize character button
        scenarioFormSelector.on("click", ".randomize-character-button", function() {
            let randomizeOption = $(this).text().trim();
            let onlyClothes = randomizeOption === "Clothes";
            if (!onlyClothes) {
                if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                    notie.alert({
                        type: 3,
                        text: 'You cannot randomize body on Alternate Attires. Select Attire "A" to randomize body.',
                        stay: false
                    });
                    return false;
                }
            }
            function randomizeGraphic() {
                // Reset stage
                while(stageObjects.children[0])stageObjects.removeChild(stageObjects.children[0]);
                while(stageLayers.children[0])stageLayers.removeChild(stageLayers.children[0]);
                let color;
                // Select body type if onlyClothes not selected
                if (!onlyClothes) {
                    if (randomizeOption === "Masculine") {
                        let bodiesWeights = [
                            70,
                            0,
                            0,
                            0,
                            0,
                            30
                        ];
                        addedBody = $c82cd471f4baff6b$var$pickUsingWeights(sprites.bodies, bodiesWeights);
                    } else if (randomizeOption === "Feminine") {
                        let bodiesWeights = [
                            0,
                            0,
                            0,
                            70,
                            30,
                            0
                        ];
                        addedBody = $c82cd471f4baff6b$var$pickUsingWeights(sprites.bodies, bodiesWeights);
                    } else {
                        let bodiesWeights = [
                            40,
                            10,
                            10,
                            20,
                            10,
                            10
                        ];
                        addedBody = $c82cd471f4baff6b$var$pickUsingWeights(sprites.bodies, bodiesWeights);
                    }
                }
                // Get style
                let style = addedBody === sprites.bodyObjectShe || addedBody === sprites.bodyObjectSheAbs ? "feminine" : "masculine";
                // Style neutral parts
                addedEyes = sprites.eyes[0];
                addedShoes = sprites.shoes[(0, $3E8Nt.getRandomInt)(0, sprites.shoes.length - 1)];
                addedElbow = null;
                addedKneepad = null;
                addedFacepaint = null;
                addedTattoo = null;
                // Optional style-neutral parts
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) addedElbow = sprites.elbows[(0, $3E8Nt.getRandomInt)(0, sprites.elbows.length - 1)];
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) addedKneepad = sprites.kneepads[(0, $3E8Nt.getRandomInt)(0, sprites.kneepads.length - 1)];
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 4) addedFacepaint = sprites.facepaints[(0, $3E8Nt.getRandomInt)(0, sprites.facepaints.length - 1)];
                // Don't select new tattoo if onlyClothes selected
                if (!onlyClothes && (0, $3E8Nt.getRandomInt)(0, 100) <= 10) addedTattoo = sprites.tattoos[(0, $3E8Nt.getRandomInt)(0, sprites.tattoos.length - 1)];
                // Style specific parts
                addedTorso = null;
                addedAccessory = null;
                addedAccessory2 = null;
                addedAccessory3 = null;
                if (style === "masculine") {
                    // Larger chance to select from masculine designs
                    let bottomsChoices = (0, $3E8Nt.getRandomInt)(0, 100) <= 99 ? sprites.tights.concat(sprites.trunks, sprites.shorts) : sprites.feminineBottoms;
                    let hairChoices = (0, $3E8Nt.getRandomInt)(0, 100) <= 99 ? sprites.shortHair.concat(sprites.longHair) : sprites.feminineHair;
                    addedBottoms = (0, $3E8Nt.getRandomChoice)(bottomsChoices);
                    // Don't select new hair and facial hair if onlyClothes selected
                    if (!onlyClothes) {
                        addedHair = (0, $3E8Nt.getRandomChoice)(hairChoices);
                        addedFacialHair = null;
                        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 20) addedFacialHair = (0, $3E8Nt.getRandomChoice)(sprites.facialHairs);
                    }
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 25) {
                        let torsoChoices = (0, $3E8Nt.getRandomInt)(0, 100) <= 99 ? sprites.shirtTops.concat(sprites.vestTops, sprites.otherTops) : sprites.sportsBraTops.concat(sprites.feminineTops);
                        addedTorso = (0, $3E8Nt.getRandomChoice)(torsoChoices);
                    }
                    let accessoryChoices = (0, $3E8Nt.getRandomInt)(0, 100) <= 99 ? sprites.glovesAccessories.concat(sprites.wristTapeAccessories, sprites.suitAndTieAccessories, sprites.neckAccessories, sprites.otherAccessories, sprites.glassesAccessories, sprites.masksAccessories) : sprites.feminineAccessories;
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 3) addedAccessory = (0, $3E8Nt.getRandomChoice)(accessoryChoices);
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) addedAccessory2 = (0, $3E8Nt.getRandomChoice)(accessoryChoices);
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) addedAccessory3 = (0, $3E8Nt.getRandomChoice)(accessoryChoices);
                } else if (style === "feminine") {
                    // Larger chance to select from masculine designs
                    let bottomsChoices = (0, $3E8Nt.getRandomInt)(0, 100) <= 5 ? sprites.tights.concat(sprites.trunks, sprites.shorts) : sprites.feminineBottoms;
                    let hairChoices = (0, $3E8Nt.getRandomInt)(0, 100) <= 5 ? sprites.shortHair.concat(sprites.longHair) : sprites.feminineHair;
                    let torsoChoices = (0, $3E8Nt.getRandomInt)(0, 100) <= 5 ? sprites.shirtTops.concat(sprites.vestTops, sprites.otherTops) : sprites.sportsBraTops.concat(sprites.feminineTops);
                    // Remove empty sprite from tops
                    torsoChoices = torsoChoices.filter(function(element) {
                        return element !== sprites.emptyTopObject;
                    });
                    addedBottoms = (0, $3E8Nt.getRandomChoice)(bottomsChoices);
                    addedTorso = (0, $3E8Nt.getRandomChoice)(torsoChoices);
                    // Don't select new hair and facial hair if onlyClothes selected
                    if (!onlyClothes) {
                        addedHair = (0, $3E8Nt.getRandomChoice)(hairChoices);
                        addedFacialHair = null;
                        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 0) addedFacialHair = (0, $3E8Nt.getRandomChoice)(sprites.facialHairs);
                    }
                    let accessoryChoices = (0, $3E8Nt.getRandomInt)(0, 100) <= 80 ? sprites.feminineAccessories : sprites.glovesAccessories.concat(sprites.glassesAccessories, sprites.wristTapeAccessories, sprites.neckAccessories, sprites.suitAndTieAccessories, sprites.otherAccessories, sprites.masksAccessories);
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 3) addedAccessory = (0, $3E8Nt.getRandomChoice)(accessoryChoices);
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) addedAccessory2 = (0, $3E8Nt.getRandomChoice)(accessoryChoices);
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) addedAccessory3 = (0, $3E8Nt.getRandomChoice)(accessoryChoices);
                }
                // Add parts to stage
                // * Appearance parts, don't change color if onlyClothes selected *
                // Body
                addedBody.designs.map(function(x) {
                    if (!onlyClothes) {
                        let colors = [
                            "#FFE4CB",
                            "#F4D7BC",
                            "#FFD9B6",
                            "#FFD4AB",
                            "#F2D2A5",
                            "#DFB58D",
                            "#CAA684",
                            "#7A6353"
                        ];
                        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 99) // Get color from skin tone palette
                        color = "0x" + colors[(0, $3E8Nt.getRandomInt)(0, colors.length - 1)].slice(1);
                        else // Get a random color
                        color = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                        x.defaultColor = color;
                        x.sprite.tint = color;
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    stageObjects.addChild(x.sprite);
                });
                // Hair
                let hairColor;
                addedHair.designs.map(function(x) {
                    if (!onlyClothes) {
                        if (hairColor) // Get a new color, otherwise use existing color
                        {
                            if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) hairColor = (0, $3E8Nt.getHairColor)();
                        } else hairColor = (0, $3E8Nt.getHairColor)();
                        x.defaultColor = hairColor;
                        x.sprite.tint = hairColor;
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    stageObjects.addChild(x.sprite);
                });
                // Facial Hair
                if (addedFacialHair) addedFacialHair.designs.map(function(x) {
                    if (!onlyClothes) {
                        // Same color as hair
                        x.defaultColor = hairColor;
                        x.sprite.tint = hairColor;
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    stageObjects.addChild(x.sprite);
                });
                // Eyes
                addedEyes.designs.map(function(x) {
                    if (!onlyClothes) {
                        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 99) color = "0x000000";
                        else // Get a random color
                        color = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                        x.defaultColor = color;
                        x.sprite.tint = color;
                    } else {
                        x.defaultColor = "0x000000";
                        x.sprite.tint = "0x000000";
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    stageObjects.addChild(x.sprite);
                });
                // * Clothes parts *
                // Bottoms
                let bottomsColor;
                addedBottoms.designs.map(function(x) {
                    if (!bottomsColor) bottomsColor = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                    else if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) bottomsColor = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = bottomsColor;
                    x.sprite.tint = bottomsColor;
                    stageObjects.addChild(x.sprite);
                });
                // Shoes
                let shoeColor;
                addedShoes.designs.map(function(x) {
                    shoeColor = "0x1E1E1E";
                    if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) shoeColor = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = shoeColor;
                    x.sprite.tint = shoeColor;
                    stageObjects.addChild(x.sprite);
                });
                // Torso
                if (addedTorso) {
                    let torsoColor;
                    addedTorso.designs.map(function(x) {
                        if (!torsoColor) torsoColor = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                        else if ((0, $3E8Nt.getRandomInt)(0, 100) <= 10) torsoColor = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        x.defaultColor = torsoColor;
                        x.sprite.tint = torsoColor;
                        stageObjects.addChild(x.sprite);
                    });
                }
                // Elbow pads
                if (addedElbow) addedElbow.designs.map(function(x, i) {
                    // Same color as shoes for first layer
                    if (i > 0) color = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                    else color = shoeColor;
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = color;
                    x.sprite.tint = color;
                    stageObjects.addChild(x.sprite);
                });
                // Accessory
                if (addedAccessory) addedAccessory.designs.map(function(x) {
                    color = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = color;
                    x.sprite.tint = color;
                    stageObjects.addChild(x.sprite);
                });
                if (addedAccessory2) addedAccessory2.designs.map(function(x) {
                    color = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = color;
                    x.sprite.tint = color;
                    stageObjects.addChild(x.sprite);
                });
                if (addedAccessory3) addedAccessory3.designs.map(function(x) {
                    color = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = color;
                    x.sprite.tint = color;
                    stageObjects.addChild(x.sprite);
                });
                // Knee pads
                if (addedKneepad) addedKneepad.designs.map(function(x, i) {
                    // Same color as shoes for first layer
                    if (i > 0) color = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                    else color = shoeColor;
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = color;
                    x.sprite.tint = color;
                    stageObjects.addChild(x.sprite);
                });
                // Facepaint
                if (addedFacepaint) addedFacepaint.designs.map(function(x) {
                    color = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = color;
                    x.sprite.tint = color;
                    stageObjects.addChild(x.sprite);
                });
                // Tattoo
                if (addedTattoo) addedTattoo.designs.map(function(x) {
                    if (!onlyClothes) {
                        color = "0x585858";
                        if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) color = "0x" + $c82cd471f4baff6b$var$getRandomColor().slice(1);
                        x.defaultColor = color;
                        x.sprite.tint = color;
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    stageObjects.addChild(x.sprite);
                });
                updateBodySprites();
                // If body changed, add data to attire buttons
                if (!onlyClothes) attireButtons.forEach(function(attireButton) {
                    attireButton.data("graphicJson", getGraphicJson(false));
                });
                // If base attire selected, load 'Body' part button, otherwise load 'Torso'
                if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) el.find('.part-button:contains("Torso")').trigger("click");
                else el.find('.part-button:contains("Body")').trigger("click");
                $(".randomize-character").addClass("selected");
            }
            // Randomize instantly if no parts changed
            if (allowChange) randomizeGraphic();
            else notie.confirm({
                text: "Are you sure?",
                submitCallback: function() {
                    randomizeGraphic();
                    allowChange = true;
                }
            });
        });
        // Masculine preset
        scenarioFormSelector.on("click", ".preset-1", function() {
            if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                notie.alert({
                    type: 3,
                    text: 'You cannot load presets on Alternate Attires. Select Attire "A" to load presets.',
                    stay: false
                });
                return false;
            }
            function changeGraphic() {
                // Reset stage
                while(stageObjects.children[0])stageObjects.removeChild(stageObjects.children[0]);
                while(stageLayers.children[0])stageLayers.removeChild(stageLayers.children[0]);
                // Select parts
                addedBottoms = sprites.tightsObject0;
                addedBody = sprites.bodyObjectHe;
                addedShoes = sprites.shoesObject0;
                addedHair = sprites.hairObject1;
                addedTorso = null;
                addedElbow = null;
                addedFacialHair = null;
                addedAccessory = null;
                addedAccessory2 = null;
                addedAccessory3 = null;
                addedKneepad = null;
                addedFacepaint = null;
                addedTattoo = null;
                addedEyes = sprites.eyes[0];
                // Add parts to stage
                $c82cd471f4baff6b$var$addSpriteToStage(addedBody, "0xF7D1B9", stageObjects, layer);
                $c82cd471f4baff6b$var$addSpriteToStage(addedBottoms, "0x333333", stageObjects, layer);
                $c82cd471f4baff6b$var$addSpriteToStage(addedHair, "0x71645F", stageObjects, layer);
                $c82cd471f4baff6b$var$addSpriteToStage(addedShoes, "0x1B1B1B", stageObjects, layer);
                $c82cd471f4baff6b$var$addSpriteToStage(addedEyes, "0x000000", stageObjects, layer);
                updateBodySprites();
                el.find('.button:contains("Body")').trigger("click");
                notie.alert({
                    type: 4,
                    text: "Preset loaded",
                    stay: false
                });
                // Add data to attire buttons
                attireButtons.forEach(function(attireButton) {
                    attireButton.data("graphicJson", getGraphicJson(false));
                });
            }
            if (allowChange) changeGraphic();
            else notie.confirm({
                text: "Are you sure?",
                submitCallback: function() {
                    changeGraphic();
                    allowChange = true;
                }
            });
        });
        // Feminine preset
        scenarioFormSelector.on("click", ".preset-2", function() {
            if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                notie.alert({
                    type: 3,
                    text: 'You cannot load presets on Alternate Attires. Select Attire "A" to load presets.',
                    stay: false
                });
                return false;
            }
            function changeGraphic() {
                // Reset stage
                while(stageObjects.children[0])stageObjects.removeChild(stageObjects.children[0]);
                while(stageLayers.children[0])stageLayers.removeChild(stageLayers.children[0]);
                // Select parts
                addedBottoms = sprites.femaleBottomObject7;
                addedBody = sprites.bodyObjectShe;
                addedShoes = sprites.shoesObject0;
                addedHair = sprites.hairs[36];
                addedTorso = sprites.sportsBraObjectBasic;
                addedElbow = null;
                addedFacialHair = null;
                addedAccessory = null;
                addedAccessory2 = null;
                addedAccessory3 = null;
                addedKneepad = null;
                addedFacepaint = null;
                addedTattoo = null;
                addedEyes = sprites.eyes[0];
                // Add parts to stage
                $c82cd471f4baff6b$var$addSpriteToStage(addedBody, "0xF7D1B9", stageObjects, layer);
                $c82cd471f4baff6b$var$addSpriteToStage(addedBottoms, "0x444444", stageObjects, layer);
                $c82cd471f4baff6b$var$addSpriteToStage(addedTorso, "0x444444", stageObjects, layer);
                $c82cd471f4baff6b$var$addSpriteToStage(addedHair, "0xB59B82", stageObjects, layer);
                $c82cd471f4baff6b$var$addSpriteToStage(addedShoes, "0x1B1B1B", stageObjects, layer);
                $c82cd471f4baff6b$var$addSpriteToStage(addedEyes, "0x000000", stageObjects, layer);
                updateBodySprites();
                el.find('.button:contains("Body")').trigger("click");
                notie.alert({
                    type: 4,
                    text: "Preset loaded",
                    stay: false
                });
                // Add data to attire buttons
                attireButtons.forEach(function(attireButton) {
                    attireButton.data("graphicJson", getGraphicJson(false));
                });
            }
            if (allowChange) changeGraphic();
            else notie.confirm({
                text: "Are you sure?",
                submitCallback: function() {
                    changeGraphic();
                    allowChange = true;
                }
            });
        });
        // Attire select
        scenarioFormSelector.on("click", ".attire-select-button", function() {
            // Save selected attire
            let selectedAttire = graphicsParent.find(".attire-select-button.selected");
            $(selectedAttire).data("graphicJson", getGraphicJson(false));
            // If alternate attire selected, check for body/eyes/hair/facial hair/tattoos change
            let $this = $(this);
            if ($this.text().trim() !== "A") {
                let keys = [
                    "body",
                    "eyes",
                    "hair",
                    "facialHair",
                    "tattoo"
                ];
                let baseAttireCode = JSON.parse($(selectedAttire).data("graphicJson"));
                let currentAttireCode = JSON.parse($this.data("graphicJson"));
                if (!currentAttireCode) currentAttireCode = JSON.parse(originalGraphicData);
                // Go through each key, replacing with base attire value if this attire's value is same as base attire's value
                keys.forEach(function(key) {
                    if (currentAttireCode[key] && JSON.stringify(currentAttireCode[key]) !== JSON.stringify(baseAttireCode[key])) {
                        currentAttireCode[key] = baseAttireCode[key];
                        $this.data("graphicJson", JSON.stringify(currentAttireCode));
                    }
                });
            }
            // Select this button
            graphicsParent.find(".attire-select-button").removeClass("selected");
            $(this).addClass("selected");
            // Disable body, eyes, hair and facial hair part buttons, community graphics search, remove attire button
            // if not base (A) attire
            let parent = $(this).closest(".character-creator-controls");
            parent.find(".part-button.disabled").removeClass("disabled");
            $(".remove-attire-button").hide();
            if ($(this).text().trim() !== "A") {
                parent.find('.part-button:contains("Body")').addClass("disabled");
                parent.find('.part-button:contains("Eyes")').addClass("disabled");
                parent.find('.part-button:contains("Hair")').addClass("disabled");
                parent.find('.part-button:contains("Facial Hair")').addClass("disabled");
                parent.find('.part-button:contains("Tattoo")').addClass("disabled");
                // Select Torso button if disabled button selected previously
                if (parent.find(".part-button.selected").hasClass("disabled")) el.find('.part-button:contains("Torso")').trigger("click");
                $(".remove-attire-button").show();
            }
            // Load this attire
            let attireJsonData = $(this).data("graphicJson");
            if (attireJsonData) loadGraphicCode(attireJsonData);
            else // Load default graphic if no attire present
            loadGraphicCode(originalGraphicData);
        });
        // Change attire
        $("#roster-member-details, #superstar_info").off("click", ".attire-select-button");
        $("#roster-member-details, #superstar_info").on("click", ".attire-select-button", function() {
            // Load this attire
            let attireJsonData = $(this).data("graphicJson");
            if (!attireJsonData) {
                notie.alert({
                    type: 3,
                    text: "Attire not present"
                });
                return false;
            }
            loadGraphicCode(attireJsonData);
            // Select this button
            graphicsParent.find(".attire-select-button").removeClass("selected");
            $(this).addClass("selected");
        });
        // Remove attire
        $(scenarioFormSelector).on("click", ".remove-attire-button", function() {
            // Replace data from this attire button with "A" attire
            let baseAttireCode = graphicsParent.find('.attire-select-button:contains("A")').data("graphicJson");
            let attireButton = graphicsParent.find(".attire-select-button.selected");
            attireButton.data("graphicJson", baseAttireCode);
            attireButton.removeClass("selected");
            // Select "A" attire
            graphicsParent.find('.attire-select-button:contains("A")').trigger("click");
            notie.alert({
                type: 4,
                text: "Alternate attire removed",
                stay: false
            });
        });
        // Select body button initially
        el.find('.button:contains("Body")').trigger("click");
        // Update parts positioning
        function updateBodySprites() {
            // Change parts to female
            if (addedBody === sprites.bodyObjectShe || addedBody === sprites.bodyObjectSheAbs) {
                // Replace current part
                if (addedTattoo) // Check if female part available
                {
                    if (addedTattoo.femaleObject) {
                        // Remove male part
                        addedTattoo.designs.map(function(x) {
                            stageObjects.removeChild(x.sprite);
                        });
                        // Add female part
                        addedTattoo = addedTattoo.femaleObject;
                        // Display female part
                        addedTattoo.designs.map(function(x) {
                            stageObjects.addChild(x.sprite);
                            x.sprite.parentLayer = layer;
                            x.sprite.zIndex = x.zIndex;
                            x.sprite.tint = x.defaultColor;
                        });
                        $c82cd471f4baff6b$var$renderer.render(stage);
                    }
                }
                if (addedFacepaint) // Check if female part available
                {
                    if (addedFacepaint.femaleObject) {
                        // Remove male part
                        addedFacepaint.designs.map(function(x) {
                            stageObjects.removeChild(x.sprite);
                        });
                        // Add female part
                        addedFacepaint = addedFacepaint.femaleObject;
                        // Display  female part
                        addedFacepaint.designs.map(function(x) {
                            stageObjects.addChild(x.sprite);
                            x.sprite.parentLayer = layer;
                            x.sprite.zIndex = x.zIndex;
                            x.sprite.tint = x.defaultColor;
                        });
                        $c82cd471f4baff6b$var$renderer.render(stage);
                    }
                }
                // Replace sprite list with female parts
                sprites.tattoos = sprites.feminineTattoos;
                sprites.facepaints = sprites.feminineFacepaints;
            } else {
                // Replace current part
                if (addedTattoo) {
                    if (addedTattoo.maleObject) {
                        // Remove female part
                        addedTattoo.designs.map(function(x) {
                            stageObjects.removeChild(x.sprite);
                        });
                        // Add male part
                        addedTattoo = addedTattoo.maleObject;
                        // Display male part
                        addedTattoo.designs.map(function(x) {
                            stageObjects.addChild(x.sprite);
                            x.sprite.parentLayer = layer;
                            x.sprite.zIndex = x.zIndex;
                            x.sprite.tint = x.defaultColor;
                        });
                        $c82cd471f4baff6b$var$renderer.render(stage);
                    }
                }
                if (addedFacepaint) {
                    if (addedFacepaint.maleObject) {
                        // Remove female part
                        addedFacepaint.designs.map(function(x) {
                            stageObjects.removeChild(x.sprite);
                        });
                        // Add male part
                        addedFacepaint = addedFacepaint.maleObject;
                        // Display male part
                        addedFacepaint.designs.map(function(x) {
                            stageObjects.addChild(x.sprite);
                            x.sprite.parentLayer = layer;
                            x.sprite.zIndex = x.zIndex;
                            x.sprite.tint = x.defaultColor;
                        });
                        $c82cd471f4baff6b$var$renderer.render(stage);
                    }
                }
                // Replace sprite list with male parts
                sprites.tattoos = sprites.masculineTattoos;
                sprites.facepaints = sprites.masculineFacepaints;
            }
            $c82cd471f4baff6b$var$renderer.render(stage);
        }
        // Load character
        function loadCharacter(data) {
            // Reset stage
            while(stageObjects.children[0])stageObjects.removeChild(stageObjects.children[0]);
            while(stageLayers.children[0])stageLayers.removeChild(stageLayers.children[0]);
            // Background
            if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
                let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
                background.zIndex = -100;
                stageBackground.addChild(background);
            }
            // Get tag team size and divide canvas
            let teamLayers;
            let characterContainer;
            if (data) {
                let tagTeamSize;
                // Remove clothes for 'Love Making' segment action
                let removeClothes = match && match["special"] && match["name"] === "Love Making" && segmentAction;
                if (match) {
                    // Get tag team size
                    if (match["type"] === "singles") tagTeamSize = 1;
                    else tagTeamSize = 2;
                    if (match["segmentType"] === "segment") tagTeamSize = 1;
                    if (match["largerTag"]) tagTeamSize = parseInt(match["largerTag"]);
                } else tagTeamSize = 1;
                // Get teams without managers
                let teams;
                let nonManagerData = data.filter(function(obj) {
                    return !obj["isManager"];
                });
                // If handicap match, get two teams using handicap size
                if (match && match["handicapSize"]) {
                    let teamA = nonManagerData.slice(0, match["handicapSize"][0]);
                    let teamB = nonManagerData.slice(match["handicapSize"][0]);
                    teams = [
                        teamA,
                        teamB
                    ];
                } else teams = $c82cd471f4baff6b$var$chunk(nonManagerData, tagTeamSize);
                // Add managers to end of team
                teams.forEach(function(team, teamIndex) {
                    let teamManagers = [];
                    team.forEach(function(teamMember) {
                        let teamMemberManager = data.filter(function(obj) {
                            return obj["superstarUid"] && obj["superstarUid"] === teamMember["uid"];
                        })[0];
                        if (teamMemberManager) teamManagers.push(teamMemberManager);
                    });
                    if (teamIndex === 0 && teams.length > 1) // Add to start of team if first team (so managers appear on the left for them)
                    teamManagers.forEach(function(teamManager) {
                        team.unshift(teamManager);
                    });
                    else teamManagers.forEach(function(teamManager) {
                        team.push(teamManager);
                    });
                });
                // Flatten teams to get graphics data, as order of graphics might have changed
                data = [].concat.apply([], teams);
                // Get rows
                let rows;
                let division;
                if (match) {
                    // Divide canvas for positioning (into rows for large number of superstars)
                    if (data.length > 10 && match["type"] === "singles") {
                        rows = $c82cd471f4baff6b$var$chunk(data, $c82cd471f4baff6b$var$getEqualChunkSize(data.length));
                        division = $c82cd471f4baff6b$var$renderer.width / (rows[0].length + 1);
                    } else if (data.length > 13 && match["type"] === "tag") {
                        rows = $c82cd471f4baff6b$var$chunk(data, $c82cd471f4baff6b$var$getEqualChunkSize(data.length));
                        division = $c82cd471f4baff6b$var$renderer.width / (rows[0].length + 1);
                    } else {
                        division = $c82cd471f4baff6b$var$renderer.width / (data.length + 1);
                        rows = [
                            data
                        ];
                    }
                } else {
                    division = $c82cd471f4baff6b$var$renderer.width / (data.length + 1);
                    rows = [
                        data
                    ];
                }
                division = Math.round(division);
                teamLayers = [];
                teams.forEach(function(team) {
                    let teamLayer = new PIXI.display.Layer();
                    stageLayers.addChild(teamLayer);
                    teamLayer.parentLayer = layer;
                    teamLayers.push(teamLayer);
                    // Sort faction graphics by characterLayer zIndex
                    if (match && match["factionGraphic"]) teamLayer.group.enableSort = true;
                    // Sort managed superstar team by zIndex
                    team.forEach(function(teamMember) {
                        if (teamMember["isManager"]) {
                            teamLayer.group.enableSort = true;
                            return;
                        }
                    });
                });
                rows.forEach(function(data, rowIndex) {
                    // Get division for row if more than 1 row
                    if (rowIndex > 0) division = $c82cd471f4baff6b$var$renderer.width / (rows[rowIndex].length + 1);
                    data.forEach(function(characterData, i) {
                        let teamIndex = null;
                        // Go through teams, if indexOf(characterData) exists, get index of parent team
                        teams.map(function(y) {
                            if (y.indexOf(characterData) > -1) teamIndex = teams.indexOf(y);
                        });
                        characterContainer = new PIXI.Container();
                        let characterIndex = null;
                        // Get index of team member
                        teams.map(function(x) {
                            if (x.indexOf(characterData) > -1) characterIndex = x.indexOf(characterData);
                        });
                        let characterLayer = new PIXI.display.Layer();
                        characterLayer.group.enableSort = true;
                        teamLayers[teamIndex].addChild(characterLayer);
                        if (match && match["factionGraphic"]) {
                            // Set zIndex for characterLayer, zIndex decreases after median
                            let medianIndex = Math.floor((teams[teamIndex].length + 1) / 2) - 1;
                            if (i > medianIndex) characterLayer.zIndex = medianIndex - (i - medianIndex);
                            else characterLayer.zIndex = i;
                        }
                        // Add zIndex for manager, moving behind superstars
                        if (characterData["isManager"]) {
                            if (teamIndex === 0) characterLayer.zIndex = characterIndex - teams[teamIndex].length;
                            else characterLayer.zIndex = -1 * characterIndex;
                        }
                        // Make manager slightly opaque
                        if (characterData["isManager"]) {
                            let filter = new PIXI.filters.AlphaFilter();
                            filter.alpha = 0.7;
                            characterLayer.filters = [
                                filter
                            ];
                        }
                        // Add character parts
                        let body = parts["body"][characterData["body"]["object"]];
                        Object.keys(addedParts).forEach(function(key) {
                            // Remove clothes
                            if (removeClothes) {
                                let bodyParts = [
                                    "body",
                                    "hair",
                                    "facialHair",
                                    "tattoo",
                                    "eyes"
                                ];
                                if (bodyParts.indexOf(key) < 0) return;
                            }
                            // Add referee shirt for referee
                            if (key === "torso" && characterData["isReferee"]) characterData[key] = {
                                "object": 81,
                                "colors": [
                                    "0x2D2D2D",
                                    "0xF0F0F0"
                                ]
                            };
                            // Add weapon
                            if (key === "weapon" && characterData["addWeaponGraphic"]) // Don't add weapons for everyone if high number of superstars
                            {
                                if (data.length <= 6 || (0, $3E8Nt.getRandomInt)(0, 100) <= 50 || i === 1) characterData[key] = selectGimmickMatchWeaponObject(characterData["uid"] + match["uid"]);
                            }
                            // Get object by part key
                            let partData = characterData[key];
                            if (partData && partData["object"] >= 0) {
                                let objectIndex = characterData[key]["object"];
                                let item = parts[key][objectIndex]; // get object
                                let newItem = parts[key][objectIndex]; // duplicate object
                                // Remove held accessory if weapon graphic added
                                let heldAccessories = parts["weapon"].concat([
                                    sprites.accessoryObject23,
                                    sprites.accessoryObject24,
                                    sprites.accessoryObject50
                                ], sprites.flags);
                                if ([
                                    "accessory",
                                    "accessory2",
                                    "accessory3"
                                ].indexOf(key) >= 0 && characterData["weapon"]) {
                                    if (heldAccessories.indexOf(item) >= 0) return;
                                }
                                // Add female object if female body
                                if (body === sprites.bodyObjectShe || body === sprites.bodyObjectSheAbs) {
                                    if (item.femaleObject) {
                                        item = item.femaleObject;
                                        newItem = newItem.femaleObject;
                                    }
                                }
                                item.designs.map(function(x, y) {
                                    // Duplicate sprite
                                    let newSprite = new PIXI.Sprite(x.sprite.texture);
                                    // Add color
                                    let spriteColor = characterData[key]["colors"][y];
                                    if (!spriteColor) // For backwards compatibility with new designs added to part (e.g hair streak)
                                    // Set color to previous design's color if not found
                                    spriteColor = characterData[key]["colors"][y - 1];
                                    x.defaultColor = spriteColor; // change defaultColor
                                    newSprite.tint = x.defaultColor;
                                    // Add empty graphic body/eye color depending on light or dark theme
                                    if (characterData["empty_graphic"]) {
                                        if (key === "body") {
                                            if ($c82cd471f4baff6b$export$7d9b72822fcb9a) newSprite.tint = "0x4D4D4D";
                                            else newSprite.tint = "0xF2F2F2";
                                        } else if (key === "eyes") {
                                            if ($c82cd471f4baff6b$export$7d9b72822fcb9a) newSprite.tint = "0x353535";
                                            else newSprite.tint = "0xC9C9C9";
                                        }
                                    }
                                    // Add parts to stage
                                    if (match) newSprite.parentLayer = characterLayer;
                                    else newSprite.parentLayer = layer;
                                    newSprite.zIndex = x.zIndex;
                                    // Get x position of character
                                    let xPos;
                                    if (match) {
                                        xPos = (i + 1) * division;
                                        let width = x.sprite.width;
                                        // Set width of larger items (flags, TGI trophy) to standard accessory width for proper positioning
                                        if (sprites.flags.indexOf(item) >= 0 || sprites.temporaryTrophyObjects.indexOf(item) >= 0) width = 99;
                                        xPos -= width / 2;
                                        // Position team members next to each other using median
                                        let offset = width / 2;
                                        // Get median using size of team
                                        let median = $c82cd471f4baff6b$var$getMedian(Array.from(Array(teams[teamIndex].length).keys()));
                                        let aboveMedian = false;
                                        let belowMedian = false;
                                        // Arrange graphics around center (median) of team
                                        if (characterIndex < median) belowMedian = true;
                                        else if (characterIndex > median) aboveMedian = true;
                                        // Set team size individually for each team
                                        tagTeamSize = teams[teamIndex].length;
                                        // Offset brings teams closer together. Add if less than 10 teams
                                        if (teams.length < 10) {
                                            offset = 12 + tagTeamSize * 10;
                                            if (teams.length > 4) offset /= teams.length;
                                            else if (tagTeamSize > 2) offset /= tagTeamSize - 1;
                                            let secondaryOffset = Math.abs(median - characterIndex);
                                            // Bring closer to center, going right
                                            if (belowMedian) {
                                                offset *= secondaryOffset;
                                                xPos += offset;
                                            } else if (aboveMedian) {
                                                offset *= secondaryOffset;
                                                xPos -= offset;
                                            }
                                        }
                                    }
                                    // Fix hair positioning bug
                                    if (match && key === "hair") xPos = Math.floor(xPos);
                                    else xPos = Math.round(xPos);
                                    // Set position
                                    if (xPos) newSprite.position.x = xPos;
                                    else newSprite.position.x = x.sprite.position.x;
                                    let yPos = x.sprite.position.y;
                                    newSprite.position.y = yPos;
                                    characterContainer.addChild(newSprite);
                                    if (!match) stageObjects.addChild(newSprite);
                                    // Set new sprite to duplicate object
                                    newItem.designs[y].sprite = newSprite;
                                });
                                addedParts[key] = newItem;
                            } else addedParts[key] = null;
                        });
                        if (match) stageObjects.addChild(characterContainer);
                        // Show title, if present, and not removeClothes
                        if (characterData["title"] && !removeClothes) {
                            let titleData = characterData["title"];
                            let smallTitleData = getSmallTitleData(titleData);
                            // Go through small title parts
                            Object.keys(smallTitleData).forEach(function(key) {
                                let item = smallTitleData[key]["object"];
                                let newItem = smallTitleData[key]["object"];
                                item.designs.map(function(x, y) {
                                    // Duplicate sprite
                                    let newSprite = new PIXI.Sprite(x.sprite.texture);
                                    // Add color
                                    let spriteColor = smallTitleData[key]["colors"][y];
                                    x.defaultColor = spriteColor; // change defaultColor
                                    newSprite.tint = x.defaultColor;
                                    // Add parts to stage
                                    if (match) newSprite.parentLayer = characterLayer;
                                    else newSprite.parentLayer = layer;
                                    newSprite.zIndex = x.zIndex;
                                    // Get x position of character
                                    let xPos;
                                    if (match) {
                                        xPos = (i + 1) * division;
                                        let width = x.sprite.width;
                                        xPos -= width / 2;
                                        // Position team members next to each other using median
                                        let median = $c82cd471f4baff6b$var$getMedian(Array.from(Array(teams[teamIndex].length).keys()));
                                        let aboveMedian = false;
                                        let belowMedian = false;
                                        // Arrange graphics around center (median) of team
                                        if (characterIndex < median) belowMedian = true;
                                        else if (characterIndex > median) aboveMedian = true;
                                        // Set team size individually for each team
                                        tagTeamSize = teams[teamIndex].length;
                                        // Offset brings teams closer together
                                        let offset = 12 + tagTeamSize * 10;
                                        if (teams.length > 4) offset /= teams.length;
                                        else if (tagTeamSize > 2) offset /= tagTeamSize - 1;
                                        let secondaryOffset = Math.abs(median - characterIndex);
                                        // Bring closer to center, going right
                                        if (belowMedian) {
                                            offset *= secondaryOffset;
                                            xPos += offset;
                                        } else if (aboveMedian) {
                                            offset *= secondaryOffset;
                                            xPos -= offset;
                                        }
                                    }
                                    xPos = Math.round(xPos);
                                    // Set position
                                    if (xPos) newSprite.position.x = xPos;
                                    else newSprite.position.x = x.sprite.position.x;
                                    let yPos = x.sprite.position.y;
                                    newSprite.position.y = yPos;
                                    characterContainer.addChild(newSprite);
                                    if (!match) stageObjects.addChild(newSprite);
                                    // Set new sprite to duplicate object
                                    newItem.designs[y].sprite = newSprite;
                                });
                            });
                        }
                        // Move rows above and below each other if more than 1 row
                        if (rows.length > 1) {
                            // If 2 rows, space second row apart more
                            if (rows.length === 2 && rowIndex === 1) characterContainer.y += 50;
                            else if (rows.length === 2 && rowIndex === 0) characterContainer.y -= 35;
                            else if (rows.length === 3 && rowIndex !== 0) // If 3 rows, space second and third rows more
                            characterContainer.y += (rowIndex - 1) * 60;
                            else characterContainer.y += (rowIndex - 1) * 50;
                        }
                        // Move row down for hanging championships
                        if (match && match["hangingChampionships"] && match["hangingChampionships"].length > 0) characterContainer.y += 30;
                    });
                });
                // Set added parts for editing
                addedBody = addedParts["body"];
                addedBottoms = addedParts["bottoms"];
                addedTorso = addedParts["torso"];
                addedHair = addedParts["hair"];
                addedShoes = addedParts["shoes"];
                addedElbow = addedParts["elbow"];
                addedFacialHair = addedParts["facialHair"];
                addedAccessory = addedParts["accessory"];
                addedAccessory2 = addedParts["accessory2"];
                addedAccessory3 = addedParts["accessory3"];
                addedKneepad = addedParts["knee"];
                addedFacepaint = addedParts["facepaint"];
                addedTattoo = addedParts["tattoo"];
                addedEyes = addedParts["eyes"];
                addedTemporaryInjury = addedParts["temporaryInjury"];
                addedTemporaryTrophy = addedParts["temporaryTrophy"];
                // Add control data if editing
                if (!jsonData) {
                    // Update part controls
                    if (!selected) // Select body upon initial load
                    selected = addedBody;
                    else // Add selected part again because it changed
                    selected = addedParts[selectedPart];
                    x = selections.indexOf(selected);
                    $(".selection-number").text(x + 1);
                    if (selected) updateDesigns(selected);
                }
            }
            // Adjust graphic for poster
            if (posterData) {
                let posterStyleData = posterData["styleData"];
                if (posterData["annualTournament"]) {
                    posterData["styleData"]["backgroundColor"] = "7D236F";
                    let textStartingY;
                    try {
                        if (posterData["type"] === 5) {
                            posterStyleData["backgroundObject"] = 2;
                            // Scale up superstars, move
                            stageObjects.children.forEach(function(c, i) {
                                c.scale.set(1.2, 1.2);
                                c.x -= 32;
                                c.y += 230;
                                if (i < 8) c.x -= i * 4;
                                else c.x -= (i - 8) * 4;
                            });
                            // Set z indexes
                            teamLayers.forEach(function(l, i) {
                                if (i < 8) l.zIndex = 30;
                                else l.zIndex = 50;
                            });
                            teamLayers[0].zIndex = 35;
                            teamLayers[2].zIndex = 35;
                            teamLayers[5].zIndex = 35;
                            teamLayers[9].zIndex = 100;
                            teamLayers[12].zIndex = 100;
                            teamLayers[14].zIndex = 100;
                            // Adjust text position
                            textStartingY = 50;
                        } else if (posterData["type"] === 6) {
                            posterStyleData["backgroundObject"] = 2;
                            // Scale up superstars, move
                            stageObjects.children.forEach(function(c) {
                                c.scale.set(1.4, 1.4);
                            });
                            let xOffset = 21;
                            stageObjects.children.slice(0, 4).forEach(function(c, i) {
                                c.x += 22 + i * xOffset;
                                c.y += 140;
                            });
                            stageObjects.children.slice(4, 8).forEach(function(c, i) {
                                c.x += -275 + i * xOffset;
                                c.y += 220;
                            });
                            stageObjects.children.slice(8, 12).forEach(function(c, i) {
                                c.x += 22 + i * xOffset;
                                c.y += 218;
                            });
                            stageObjects.children.slice(12, 16).forEach(function(c, i) {
                                c.x += -275 + i * xOffset;
                                c.y += 306;
                            });
                            // Set z indexes
                            teamLayers.forEach(function(l, i) {
                                if (i < 4) l.zIndex = 30;
                                else if (i < 8) l.zIndex = 40;
                                else if (i < 12) l.zIndex = 50;
                                else l.zIndex = 60;
                            });
                            // Adjust text position
                            textStartingY = 40;
                        } else if (posterData["type"] === 7) {
                            posterStyleData["backgroundObject"] = 1;
                            // Scale up superstars, move
                            stageObjects.children.forEach(function(c) {
                                c.scale.set(1, 1);
                            });
                            stageObjects.children.slice(0, 4).forEach(function(c, i) {
                                c.x = 92 + i * 10;
                                c.y = 367;
                            });
                            stageObjects.children.slice(4, 8).forEach(function(c, i) {
                                c.x = -124 + i * 10;
                                c.y = -27;
                            });
                            stageObjects.children[0].position.y -= 15;
                            stageObjects.children[3].position.y -= 15;
                            stageObjects.children[4].position.y += 15;
                            stageObjects.children[7].position.y += 15;
                            stageObjects.children[8].position.set(32, 307);
                            stageObjects.children[9].position.set(290, 307);
                            stageObjects.children[10].position.set(-100, 217);
                            stageObjects.children[11].position.set(207, 217);
                            stageObjects.children[12].position.set(-202, 122);
                            stageObjects.children[13].position.set(101, 122);
                            stageObjects.children[14].position.set(-285, 32);
                            stageObjects.children[15].position.set(-28, 32);
                            // Set z indexes
                            teamLayers[0].zIndex = 90;
                            teamLayers[1].zIndex = 95;
                            teamLayers[2].zIndex = 96;
                            teamLayers[3].zIndex = 90;
                            teamLayers[8].zIndex = 85;
                            teamLayers[9].zIndex = 85;
                            teamLayers[10].zIndex = 80;
                            teamLayers[11].zIndex = 80;
                            teamLayers[12].zIndex = 75;
                            teamLayers[13].zIndex = 75;
                            teamLayers[14].zIndex = 70;
                            teamLayers[15].zIndex = 70;
                            teamLayers[4].zIndex = 65;
                            teamLayers[5].zIndex = 61;
                            teamLayers[6].zIndex = 60;
                            teamLayers[7].zIndex = 65;
                            // Adjust text position
                            textStartingY = 258;
                        }
                    } catch (error) {
                        (0, $3E8Nt.captureError)(error);
                    }
                    // Add 'The Grand Invitational' text
                    let textGrandStyle = new PIXI.TextStyle({
                        fontFamily: [
                            "Cantarell"
                        ],
                        fontWeight: 700,
                        fontSize: 51,
                        fill: "#F5D230",
                        lineJoin: "round",
                        letterSpacing: 5
                    });
                    let grandText = new PIXI.Text("GRAND", textGrandStyle);
                    grandText.x = $c82cd471f4baff6b$var$renderer.width / 2 - grandText.width / 2;
                    grandText.y = textStartingY + 22;
                    grandText.parentLayer = layer;
                    stageObjects.addChild(grandText);
                    let textInvitationalStyle = new PIXI.TextStyle({
                        fontFamily: [
                            "Cantarell"
                        ],
                        fontWeight: 700,
                        fontSize: 25,
                        fill: "#E8D9E7",
                        letterSpacing: 2,
                        lineJoin: "round"
                    });
                    let invitationalText = new PIXI.Text("INVITATIONAL", textInvitationalStyle);
                    invitationalText.x = $c82cd471f4baff6b$var$renderer.width / 2 - invitationalText.width / 2 + 1;
                    invitationalText.y = textStartingY + 82;
                    invitationalText.parentLayer = layer;
                    stageObjects.addChild(invitationalText);
                    let textTheStyle = new PIXI.TextStyle({
                        fontFamily: [
                            "Cantarell"
                        ],
                        fontWeight: 700,
                        fontSize: 19,
                        fill: "#E8D9E7",
                        lineJoin: "round",
                        letterSpacing: 1
                    });
                    let theText = new PIXI.Text("THE", textTheStyle);
                    theText.x = $c82cd471f4baff6b$var$renderer.width / 2 - theText.width / 2;
                    theText.y = textStartingY;
                    theText.parentLayer = layer;
                    stageObjects.addChild(theText);
                } else {
                    // Get y offset (if text on top)
                    let yOffset = 0;
                    if (posterData["type"] === 1) {
                        // Scale up superstars
                        stageObjects.children.forEach(function(x) {
                            x.scale.set(1.4, 1.4);
                        });
                        if (posterStyleData["textPosition"] === "top") yOffset = 100;
                        // 1st row
                        let firstRowY = 170 + yOffset;
                        stageObjects.children[0].position.set(52, firstRowY);
                        stageObjects.children[1].position.set(222, firstRowY);
                        stageObjects.children[2].position.set(36, firstRowY);
                        teamLayers[0].zIndex = 100;
                        teamLayers[1].zIndex = 101;
                        teamLayers[2].zIndex = 100;
                        // 2nd row
                        let secondRowY = 70 + yOffset;
                        stageObjects.children[3].position.set(-168, secondRowY);
                        stageObjects.children[4].position.set(42, secondRowY);
                        stageObjects.children[5].position.set(-165, secondRowY);
                        teamLayers[3].zIndex = 50;
                        teamLayers[4].zIndex = 51;
                        teamLayers[5].zIndex = 50;
                        // 3rd row
                        let thirdRowY = -6 + yOffset;
                        stageObjects.children[6].position.set(-312, thirdRowY);
                        stageObjects.children[7].position.set(-216, thirdRowY);
                        teamLayers[6].zIndex = 40;
                        teamLayers[7].zIndex = 41;
                        // 4th row
                        let fourthRowY = -44 + yOffset;
                        stageObjects.children[8].position.set(-367, fourthRowY);
                        teamLayers[8].zIndex = 30;
                    } else if (posterData["type"] === 2) {
                        // Scale up superstars
                        stageObjects.children.forEach(function(x, i) {
                            if (i === 0) x.scale.set(1.55, 1.55);
                            else x.scale.set(1.4, 1.4);
                        });
                        if (posterStyleData["textPosition"] === "top") yOffset = 70;
                        // 1st row
                        let firstRowY = 130 + yOffset;
                        stageObjects.children[0].position.set(133, firstRowY);
                        teamLayers[0].zIndex = 100;
                        // 2nd row
                        let secondRowY = 130 + yOffset;
                        stageObjects.children[1].position.set(-62, secondRowY);
                        stageObjects.children[2].position.set(62, secondRowY);
                        teamLayers[1].zIndex = 50;
                        teamLayers[2].zIndex = 51;
                        // 3rd row
                        let thirdRowY = 60 + yOffset;
                        stageObjects.children[3].position.set(-203, thirdRowY);
                        stageObjects.children[4].position.set(-177, thirdRowY);
                        teamLayers[3].zIndex = 40;
                        teamLayers[4].zIndex = 41;
                        // 4th row
                        let fourthRowY = yOffset;
                        stageObjects.children[5].position.set(-332, fourthRowY);
                        teamLayers[5].zIndex = 30;
                    } else if (posterData["type"] === 3) {
                        // Scale up superstars
                        stageObjects.children.forEach(function(x, i) {
                            if (i === 0) x.scale.set(1.95, 1.95);
                            else if (i === 1 || i === 2) x.scale.set(1.7, 1.7);
                            else x.scale.set(1.4, 1.4);
                        });
                        if (posterStyleData["textPosition"] === "top") yOffset = 80;
                        // 1st row
                        let firstRowY = 10 + yOffset;
                        stageObjects.children[0].position.set(84, firstRowY);
                        teamLayers[0].zIndex = 100;
                        // 2nd row
                        let secondRowY = 25 + yOffset;
                        stageObjects.children[1].position.set(-121, secondRowY);
                        stageObjects.children[2].position.set(-74, secondRowY);
                        teamLayers[1].zIndex = 50;
                        teamLayers[2].zIndex = 51;
                        // 3rd row
                        let thirdRowY = 40 + yOffset;
                        stageObjects.children[3].position.set(-370, thirdRowY);
                        stageObjects.children[4].position.set(-149, thirdRowY);
                        teamLayers[3].zIndex = 40;
                        teamLayers[4].zIndex = 41;
                    } else if (posterData["type"] === 4) {
                        // Scale up superstars
                        stageObjects.children.forEach(function(x) {
                            x.scale.set(2, 2);
                        });
                        if (posterStyleData["textPosition"] === "top") yOffset = 60;
                        // 1st row
                        let firstRowY = yOffset;
                        stageObjects.children[0].position.set(-1, firstRowY);
                        teamLayers[0].zIndex = 100;
                        // 2nd row
                        let secondRowY = yOffset;
                        stageObjects.children[1].position.set(-355, secondRowY);
                        stageObjects.children[2].position.set(-361, secondRowY);
                        teamLayers[1].zIndex = 50;
                        teamLayers[2].zIndex = 51;
                    }
                    // Select font
                    let fontChoices = [
                        {
                            fontFamily: '"Oswald"',
                            fontSize: 46
                        },
                        {
                            fontFamily: '"Quantico"',
                            fontSize: 42
                        },
                        {
                            fontFamily: '"Saira Stencil One"',
                            fontSize: 42
                        },
                        {
                            fontFamily: '"Orbitron"',
                            fontSize: 36
                        },
                        {
                            fontFamily: '"Cinzel Decorative"',
                            fontSize: 38
                        },
                        {
                            fontFamily: '"Century Gothic"',
                            fontSize: 42
                        },
                        {
                            fontFamily: '"Mukta Mahee"',
                            fontSize: 44
                        }
                    ];
                    let selectedFont = fontChoices[posterStyleData["fontFamilyObject"]];
                    // Set text style
                    let style = new PIXI.TextStyle({
                        fontFamily: [
                            selectedFont.fontFamily,
                            "Century Gothic"
                        ],
                        fontWeight: 700,
                        fontSize: selectedFont.fontSize,
                        fill: "#" + posterStyleData["fontColor"],
                        wordWrap: true,
                        wordWrapWidth: 400,
                        lineJoin: "round",
                        align: "center"
                    });
                    // Reduce font size if long text
                    if (posterData["eventName"].length >= 30) style.fontSize -= 12;
                    // Add text
                    let richText = new PIXI.Text(posterData["eventName"].toUpperCase(), style);
                    richText.x = $c82cd471f4baff6b$var$renderer.width / 2 - richText.width / 2;
                    if (posterStyleData["textPosition"] === "top") richText.y = 75 - richText.height / 2;
                    else richText.y = $c82cd471f4baff6b$var$renderer.height - richText.height / 2 - 75;
                    richText.parentLayer = layer;
                    stageObjects.addChild(richText);
                }
                // Select background
                let backgroundObject = sprites.backgroundObjects[posterStyleData["backgroundObject"]];
                let backgroundColor = "0x" + posterStyleData["backgroundColor"];
                // Add background
                let backgroundSprite = new PIXI.Sprite(backgroundObject.texture);
                backgroundSprite.tint = backgroundColor;
                backgroundSprite.zIndex = -100;
                if (posterStyleData["textPosition"] === "top" && backgroundObject === sprites.posterBackground3 && !posterData["annualTournament"]) {
                    // Flip background 3 so dark part is on top
                    backgroundSprite.anchor.y = 1;
                    backgroundSprite.scale.y *= -1;
                }
                stageObjects.addChild(backgroundSprite);
            }
            // Add special segment sprites
            if (match && match["special"]) {
                if (match["name"] === "Car Explosion") {
                    // Action text
                    if (segmentAction) {
                        // Remove sprites if present
                        if (data) {
                            characterContainer.children.map(function(x) {
                                x.destroy();
                            });
                            stageObjects.children.map(function(x) {
                                x.destroy();
                            });
                        }
                        // Add car fire sprite
                        sprites.specialSegmentsCarFire.parentLayer = layer;
                        sprites.specialSegmentsCarFire.x = 76;
                        sprites.specialSegmentsCarFire.y = 38;
                        sprites.specialSegmentsCarFire.zIndex = -9;
                        stageObjects.addChild(sprites.specialSegmentsCarFire);
                    } else // Move sprite near car
                    stageObjects.children.map(function(x) {
                        x.x -= 60;
                    });
                    // Add car sprite
                    sprites.specialSegmentsCar.parentLayer = layer;
                    sprites.specialSegmentsCar.x = -2;
                    sprites.specialSegmentsCar.y = 92;
                    sprites.specialSegmentsCar.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsCar);
                } else if (match["name"] === "Helicopter Raid") {
                    // Action text
                    if (segmentAction) {
                        if (data) {
                            characterContainer.scale.set(0.6, 0.6);
                            characterContainer.x = 128;
                            characterContainer.y = 107;
                        }
                        sprites.specialSegmentsHelicopterBuilding.parentLayer = layer;
                        sprites.specialSegmentsHelicopterBuilding.x = 0;
                        sprites.specialSegmentsHelicopterBuilding.y = 255;
                        sprites.specialSegmentsHelicopterBuilding.zIndex = -12;
                        stageObjects.addChild(sprites.specialSegmentsHelicopterBuilding);
                        sprites.specialSegmentsHelicopterBuildingLights.parentLayer = layer;
                        sprites.specialSegmentsHelicopterBuildingLights.x = 0;
                        sprites.specialSegmentsHelicopterBuildingLights.y = 284;
                        sprites.specialSegmentsHelicopterBuildingLights.zIndex = -8;
                        stageObjects.addChild(sprites.specialSegmentsHelicopterBuildingLights);
                        sprites.specialSegmentsHelicopter.y = 91;
                    } else {
                        // Remove sprites if present
                        if (data) {
                            characterContainer.children.map(function(x) {
                                x.destroy();
                            });
                            stageObjects.children.map(function(x) {
                                x.destroy();
                            });
                        }
                        sprites.specialSegmentsHelicopter.y = 50;
                    }
                    sprites.specialSegmentsHelicopter.parentLayer = layer;
                    sprites.specialSegmentsHelicopter.x = 10;
                    sprites.specialSegmentsHelicopter.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsHelicopter);
                } else if (match["name"] === "Hosedown") {
                    // Action text
                    let truckXPos = -220;
                    if (segmentAction) {
                        if (data) {
                            characterContainer.scale.set(0.7, 0.7);
                            characterContainer.x = 169;
                            characterContainer.y = 76;
                        }
                        sprites.specialSegmentsLemonadeTruckSpray.parentLayer = layer;
                        sprites.specialSegmentsLemonadeTruckSpray.x = 266;
                        sprites.specialSegmentsLemonadeTruckSpray.y = 169;
                        sprites.specialSegmentsLemonadeTruckSpray.zIndex = 40;
                        stageObjects.addChild(sprites.specialSegmentsLemonadeTruckSpray);
                        truckXPos = 20;
                    } else // Remove sprites if present
                    if (data) {
                        characterContainer.children.map(function(x) {
                            x.destroy();
                        });
                        stageObjects.children.map(function(x) {
                            x.destroy();
                        });
                    }
                    sprites.specialSegmentsLemonadeTruck.parentLayer = layer;
                    sprites.specialSegmentsLemonadeTruck.x = truckXPos;
                    sprites.specialSegmentsLemonadeTruck.y = 85;
                    sprites.specialSegmentsLemonadeTruck.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsLemonadeTruck);
                } else if (match["name"] === "Stunt Dive") {
                    // Action text
                    if (segmentAction) {
                        if (data) {
                            characterContainer.children.map(function(x) {
                                x.destroy();
                            });
                            stageObjects.children.map(function(x) {
                                x.destroy();
                            });
                        }
                    } else if (data) {
                        characterContainer.scale.set(0.6, 0.6);
                        characterContainer.x = 41;
                        characterContainer.y = 46;
                    }
                    sprites.specialSegmentsStage.parentLayer = layer;
                    sprites.specialSegmentsStage.x = 28;
                    sprites.specialSegmentsStage.y = 182;
                    sprites.specialSegmentsStage.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsStage);
                    sprites.specialSegmentsStageRailing.parentLayer = layer;
                    sprites.specialSegmentsStageRailing.x = -2;
                    sprites.specialSegmentsStageRailing.y = 158;
                    sprites.specialSegmentsStageRailing.zIndex = 40;
                    stageObjects.addChild(sprites.specialSegmentsStageRailing);
                } else if (match["name"] === "Dummy Wrestling") {
                    if (data) characterContainer.x += 10;
                    // Action text
                    if (segmentAction) {
                        if (data) characterContainer.x -= 76;
                        sprites.specialSegmentsDummy.parentLayer = layer;
                        sprites.specialSegmentsDummy.x = 260;
                        sprites.specialSegmentsDummy.y = 71;
                        sprites.specialSegmentsDummy.zIndex = 40;
                        stageObjects.addChild(sprites.specialSegmentsDummy);
                    }
                } else if (match["name"] === "Timely Rescue") {
                    // Action text
                    if (segmentAction) {
                        if (data) {
                            characterContainer.destroy();
                            stageObjects.children[0].x += 90;
                            stageObjects.children[0].y += 30;
                        }
                        sprites.specialSegmentsAmbulance.parentLayer = layer;
                        sprites.specialSegmentsAmbulance.x = 0;
                        sprites.specialSegmentsAmbulance.y = 30;
                        sprites.specialSegmentsAmbulance.zIndex = -10;
                        stageObjects.addChild(sprites.specialSegmentsAmbulance);
                    } else if (data) {
                        stageObjects.children[1].scale.set(0.8, 0.8);
                        stageObjects.children[1].y += 0;
                        stageObjects.children[1].x += 118;
                        stageObjects.children[0].x += 70;
                    }
                } else if (match["name"] === "Celebrity Beatdown") {
                    let celebrityName = match["pronouns"][1]["name"];
                    // Add celebrity sprite
                    let celebritySprite;
                    let celebrityYPos;
                    if (celebrityName === "American Queen" || celebrityName === "Opera Queen") {
                        celebritySprite = sprites.specialSegmentsCelebrityAmericanQueen;
                        celebrityYPos = 56;
                    } else if (celebrityName === "Prezz" || celebrityName === "Mister Prez") {
                        celebritySprite = sprites.specialSegmentsCelebrityPrezz;
                        celebrityYPos = 62;
                    } else if (celebrityName === "Big T" || celebrityName === "Big Schwartz") {
                        celebritySprite = sprites.specialSegmentsCelebrityBigT;
                        celebrityYPos = 56;
                    }
                    celebritySprite.parentLayer = layer;
                    celebritySprite.x = 180;
                    celebritySprite.y = celebrityYPos;
                    celebritySprite.zIndex = 0;
                    // Action Text
                    if (segmentAction) {
                        if (data) characterContainer.x += 75;
                        celebritySprite.x -= 75;
                    } else if (data) {
                        characterContainer.children.map(function(x) {
                            x.destroy();
                        });
                        stageObjects.children.map(function(x) {
                            x.destroy();
                        });
                    }
                    stageObjects.addChild(celebritySprite);
                } else if (match["name"] === "Anti-Company Rant") {
                    // Action text
                    if (segmentAction) {
                        sprites.specialSegmentsRantSpeech.parentLayer = layer;
                        sprites.specialSegmentsRantSpeech.x = 42;
                        sprites.specialSegmentsRantSpeech.y = 19;
                        sprites.specialSegmentsRantSpeech.zIndex = 40;
                        stageObjects.addChild(sprites.specialSegmentsRantSpeech);
                        if (data) {
                            characterContainer.scale.set(2, 2);
                            characterContainer.x -= 216;
                            characterContainer.y -= 0;
                        }
                    } else {
                        sprites.specialSegmentsRantMic.parentLayer = layer;
                        sprites.specialSegmentsRantMic.x = 238;
                        sprites.specialSegmentsRantMic.y = 153;
                        sprites.specialSegmentsRantMic.zIndex = 10;
                        stageObjects.addChild(sprites.specialSegmentsRantMic);
                    }
                } else if (match["name"] === "Love Making") {
                    // Move participant to left
                    if (data) characterContainer.x += 70;
                    // Get partner's pronoun
                    let partnerPronoun = match["pronouns"][match["pronouns"].length - 1]["partnerPronoun"];
                    let partnerSprite;
                    if (segmentAction) {
                        // Get partner's nude sprite
                        if (partnerPronoun === "he") partnerSprite = sprites.specialSegmentsLoveMakingManNude;
                        else partnerSprite = sprites.specialSegmentsLoveMakingWomanNude;
                        // Censor participant
                        if (match["pronouns"][0].pronoun !== "he") {
                            sprites.specialSegmentsLoveMakingTopCensor.parentLayer = layer;
                            sprites.specialSegmentsLoveMakingTopCensor.x = 268;
                            sprites.specialSegmentsLoveMakingTopCensor.y = 124;
                            sprites.specialSegmentsLoveMakingTopCensor.zIndex = 40;
                            stageObjects.addChild(sprites.specialSegmentsLoveMakingTopCensor);
                            let specialSegmentsLoveMakingTopCensorDuplicate = new PIXI.Sprite(sprites.specialSegmentsLoveMakingTopCensor.texture);
                            specialSegmentsLoveMakingTopCensorDuplicate.parentLayer = layer;
                            specialSegmentsLoveMakingTopCensorDuplicate.x = 289;
                            specialSegmentsLoveMakingTopCensorDuplicate.y = 124;
                            specialSegmentsLoveMakingTopCensorDuplicate.zIndex = 40;
                            stageObjects.addChild(specialSegmentsLoveMakingTopCensorDuplicate);
                        }
                        sprites.specialSegmentsLoveMakingBottomCensor.parentLayer = layer;
                        sprites.specialSegmentsLoveMakingBottomCensor.x = 268;
                        sprites.specialSegmentsLoveMakingBottomCensor.y = 149;
                        sprites.specialSegmentsLoveMakingBottomCensor.zIndex = 40;
                        stageObjects.addChild(sprites.specialSegmentsLoveMakingBottomCensor);
                        // Add heart
                        sprites.specialSegmentsLoveMakingHeart.parentLayer = layer;
                        sprites.specialSegmentsLoveMakingHeart.x = 195;
                        sprites.specialSegmentsLoveMakingHeart.y = 60;
                        sprites.specialSegmentsLoveMakingHeart.zIndex = -10;
                        stageObjects.addChild(sprites.specialSegmentsLoveMakingHeart);
                    } else // Get partner's clothed sprite
                    if (partnerPronoun === "he") partnerSprite = sprites.specialSegmentsLoveMakingManClothed;
                    else partnerSprite = sprites.specialSegmentsLoveMakingWomanClothed;
                    // Add partner's sprite
                    partnerSprite.parentLayer = layer;
                    partnerSprite.x = 350;
                    partnerSprite.y = 65;
                    stageObjects.addChild(partnerSprite);
                    // Add bed
                    sprites.specialSegmentsLoveMakingBed.parentLayer = layer;
                    sprites.specialSegmentsLoveMakingBed.x = 18;
                    sprites.specialSegmentsLoveMakingBed.y = 147;
                    sprites.specialSegmentsLoveMakingBed.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsLoveMakingBed);
                } else if (match["name"] === "Ring Invasion") {
                    // Scale down participant, move to center
                    if (data) {
                        characterContainer.scale.set(0.86, 0.86);
                        characterContainer.x += 33;
                        characterContainer.y += 25;
                    }
                    // Add ring and ropes
                    sprites.specialSegmentsRing.parentLayer = layer;
                    sprites.specialSegmentsRing.x = 0;
                    sprites.specialSegmentsRing.y = 228;
                    sprites.specialSegmentsRing.zIndex = 40;
                    stageObjects.addChild(sprites.specialSegmentsRing);
                    sprites.specialSegmentsRingRopes.parentLayer = layer;
                    sprites.specialSegmentsRingRopes.x = 0;
                    sprites.specialSegmentsRingRopes.y = 139;
                    sprites.specialSegmentsRingRopes.zIndex = 40;
                    stageObjects.addChild(sprites.specialSegmentsRingRopes);
                    if (segmentAction) {
                        // Add people
                        sprites.specialSegmentsRingPeopleTop.parentLayer = layer;
                        sprites.specialSegmentsRingPeopleTop.x = -12;
                        sprites.specialSegmentsRingPeopleTop.y = 80;
                        sprites.specialSegmentsRingPeopleTop.zIndex = -10;
                        stageObjects.addChild(sprites.specialSegmentsRingPeopleTop);
                        sprites.specialSegmentsRingPeopleBottom.parentLayer = layer;
                        sprites.specialSegmentsRingPeopleBottom.x = -12;
                        sprites.specialSegmentsRingPeopleBottom.y = 184;
                        sprites.specialSegmentsRingPeopleBottom.zIndex = 41;
                        stageObjects.addChild(sprites.specialSegmentsRingPeopleBottom);
                    }
                }
            }
            // Add gimmick match graphics
            if (match && match["gimmickMatchGraphic"]) {
                let newMathRandom = new Math.seedrandom(match["uid"]);
                let ladderObjects = [
                    sprites.gimmickMatchLadderBlack,
                    sprites.gimmickMatchLadderGrey,
                    sprites.gimmickMatchLadderOrange
                ];
                let tableObjects = [
                    sprites.gimmickMatchTableBrown,
                    sprites.gimmickMatchTableDarkBrown,
                    sprites.gimmickMatchTableLightBrown
                ];
                let chairObjects = [
                    sprites.gimmickMatchChairBiege,
                    sprites.gimmickMatchChairBlack,
                    sprites.gimmickMatchChairBlue
                ];
                let casketObjects = [
                    sprites.gimmickMatchCasketBrown,
                    sprites.gimmickMatchCasketPurple,
                    sprites.gimmickMatchCasketLightBrown
                ];
                let parkingLotObjects = [
                    sprites.gimmickMatchParkingLotA,
                    sprites.gimmickMatchParkingLotB
                ];
                let ladderWeights = [
                    10,
                    4,
                    1
                ];
                let tableWeights = [
                    4,
                    10,
                    2
                ];
                let chairWeights = [
                    8,
                    10,
                    5
                ];
                let casketWeights = [
                    10,
                    10,
                    4
                ];
                let parkingLotWeights = [
                    10,
                    10
                ];
                // Ladder
                if ([
                    "ladder",
                    "ladder_black",
                    "ladder_grey",
                    "ladder_orange"
                ].indexOf(match["gimmickMatchGraphic"]) >= 0) {
                    let gimmickMatchLadderSprite;
                    if (match["gimmickMatchGraphic"] === "ladder") gimmickMatchLadderSprite = $c82cd471f4baff6b$var$pickUsingWeights(ladderObjects, ladderWeights, newMathRandom());
                    else if (match["gimmickMatchGraphic"] === "ladder_black") gimmickMatchLadderSprite = sprites.gimmickMatchLadderBlack;
                    else if (match["gimmickMatchGraphic"] === "ladder_grey") gimmickMatchLadderSprite = sprites.gimmickMatchLadderGrey;
                    else if (match["gimmickMatchGraphic"] === "ladder_orange") gimmickMatchLadderSprite = sprites.gimmickMatchLadderOrange;
                    gimmickMatchLadderSprite.parentLayer = layer;
                    gimmickMatchLadderSprite.x = 159;
                    gimmickMatchLadderSprite.y = 18;
                    gimmickMatchLadderSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchLadderSprite);
                    if (match["hangingChampionships"] && match["hangingChampionships"].length > 0) gimmickMatchLadderSprite.y += 30;
                    // Add large side ladder sprites if not 1 on 1 singles match
                    if (match["participants"].length > 2 || match["type"] === "tag") {
                        let gimmickMatchLadderSpriteLarge = new PIXI.Sprite(gimmickMatchLadderSprite.texture);
                        gimmickMatchLadderSpriteLarge.scale.set(1.05, 1.05);
                        gimmickMatchLadderSpriteLarge.parentLayer = layer;
                        gimmickMatchLadderSpriteLarge.x = 10;
                        gimmickMatchLadderSpriteLarge.y = 7;
                        gimmickMatchLadderSpriteLarge.zIndex = -10;
                        stageObjects.addChild(gimmickMatchLadderSpriteLarge);
                        let gimmickMatchLadderSpriteLarge2 = new PIXI.Sprite(gimmickMatchLadderSprite.texture);
                        gimmickMatchLadderSpriteLarge2.scale.set(1.05, 1.05);
                        gimmickMatchLadderSpriteLarge2.parentLayer = layer;
                        gimmickMatchLadderSpriteLarge2.x = 300;
                        gimmickMatchLadderSpriteLarge2.y = 7;
                        gimmickMatchLadderSpriteLarge2.zIndex = -10;
                        stageObjects.addChild(gimmickMatchLadderSpriteLarge2);
                        if (match["hangingChampionships"] && match["hangingChampionships"].length > 0) {
                            gimmickMatchLadderSpriteLarge.y += 25;
                            gimmickMatchLadderSpriteLarge2.y += 25;
                        }
                    }
                } else if (match["gimmickMatchGraphic"] === "table") {
                    let gimmickMatchTableSprite = $c82cd471f4baff6b$var$pickUsingWeights(tableObjects, tableWeights, newMathRandom());
                    gimmickMatchTableSprite.parentLayer = layer;
                    gimmickMatchTableSprite.x = -135;
                    gimmickMatchTableSprite.y = 163;
                    gimmickMatchTableSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableSprite);
                    let gimmickMatchTableSpriteDuplicate = new PIXI.Sprite(gimmickMatchTableSprite.texture);
                    gimmickMatchTableSpriteDuplicate.parentLayer = layer;
                    gimmickMatchTableSpriteDuplicate.x = 343;
                    gimmickMatchTableSpriteDuplicate.y = 163;
                    gimmickMatchTableSpriteDuplicate.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableSpriteDuplicate);
                    // Add standing table based on selected table sprite
                    let gimmickMatchTableStanding;
                    if (gimmickMatchTableSprite === sprites.gimmickMatchTableBrown) gimmickMatchTableStanding = sprites.gimmickMatchTableBrownStanding;
                    else if (gimmickMatchTableSprite === sprites.gimmickMatchTableDarkBrown) gimmickMatchTableStanding = sprites.gimmickMatchTableDarkBrownStanding;
                    else if (gimmickMatchTableSprite === sprites.gimmickMatchTableLightBrown) gimmickMatchTableStanding = sprites.gimmickMatchTableLightBrownStanding;
                    gimmickMatchTableStanding.parentLayer = layer;
                    gimmickMatchTableStanding.x = 183;
                    gimmickMatchTableStanding.y = 50;
                    gimmickMatchTableStanding.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableStanding);
                } else if (match["gimmickMatchGraphic"] === "chair") {
                    let gimmickMatchChairSprite = $c82cd471f4baff6b$var$pickUsingWeights(chairObjects, chairWeights, newMathRandom());
                    let gimmickMatchChairLeftA = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairLeftA.parentLayer = layer;
                    gimmickMatchChairLeftA.x = 56;
                    gimmickMatchChairLeftA.y = 165;
                    gimmickMatchChairLeftA.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairLeftA);
                    let gimmickMatchChairLeftB = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairLeftB.parentLayer = layer;
                    gimmickMatchChairLeftB.x = 341;
                    gimmickMatchChairLeftB.y = 165;
                    gimmickMatchChairLeftB.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairLeftB);
                    let gimmickMatchChairRightA = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairRightA.parentLayer = layer;
                    gimmickMatchChairRightA.x = 11;
                    gimmickMatchChairRightA.y = 165;
                    gimmickMatchChairRightA.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairRightA);
                    let gimmickMatchChairRightB = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairRightB.parentLayer = layer;
                    gimmickMatchChairRightB.x = 386;
                    gimmickMatchChairRightB.y = 165;
                    gimmickMatchChairRightB.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairRightB);
                    // Pick new center chair sprite
                    gimmickMatchChairSprite = $c82cd471f4baff6b$var$pickUsingWeights(chairObjects, chairWeights, newMathRandom());
                    let gimmickMatchChairCenterA = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairCenterA.parentLayer = layer;
                    gimmickMatchChairCenterA.x = 175;
                    gimmickMatchChairCenterA.y = 163;
                    gimmickMatchChairCenterA.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairCenterA);
                    let gimmickMatchChairCenterB = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairCenterB.parentLayer = layer;
                    gimmickMatchChairCenterB.x = 223;
                    gimmickMatchChairCenterB.y = 163;
                    gimmickMatchChairCenterB.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairCenterB);
                } else if (match["gimmickMatchGraphic"] === "tables_ladders_chairs") {
                    // Two tables
                    let gimmickMatchTableSprite = $c82cd471f4baff6b$var$pickUsingWeights(tableObjects, tableWeights, newMathRandom());
                    gimmickMatchTableSprite.parentLayer = layer;
                    gimmickMatchTableSprite.x = -135;
                    gimmickMatchTableSprite.y = 163;
                    gimmickMatchTableSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableSprite);
                    let gimmickMatchTableSpriteDuplicate = new PIXI.Sprite(gimmickMatchTableSprite.texture);
                    gimmickMatchTableSpriteDuplicate.parentLayer = layer;
                    gimmickMatchTableSpriteDuplicate.x = 343;
                    gimmickMatchTableSpriteDuplicate.y = 163;
                    gimmickMatchTableSpriteDuplicate.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableSpriteDuplicate);
                    // Ladder
                    let gimmickMatchLadderSprite = $c82cd471f4baff6b$var$pickUsingWeights(ladderObjects, ladderWeights, newMathRandom());
                    gimmickMatchLadderSprite.parentLayer = layer;
                    gimmickMatchLadderSprite.x = 159;
                    gimmickMatchLadderSprite.y = 18;
                    gimmickMatchLadderSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchLadderSprite);
                    if (match["hangingChampionships"] && match["hangingChampionships"].length > 0) gimmickMatchLadderSprite.y += 30;
                    // Chairs
                    let gimmickMatchChairSprite = $c82cd471f4baff6b$var$pickUsingWeights(chairObjects, chairWeights, newMathRandom());
                    gimmickMatchChairSprite.parentLayer = layer;
                    gimmickMatchChairSprite.x = 11;
                    gimmickMatchChairSprite.y = 165;
                    gimmickMatchChairSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairSprite);
                    let gimmickMatchChairSpriteDuplicate = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairSpriteDuplicate.parentLayer = layer;
                    gimmickMatchChairSpriteDuplicate.x = 386;
                    gimmickMatchChairSpriteDuplicate.y = 165;
                    gimmickMatchChairSpriteDuplicate.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairSpriteDuplicate);
                } else if ([
                    "cage_grey",
                    "cage_red",
                    "cage_retro_blue",
                    "cage_retro_black"
                ].indexOf(match["gimmickMatchGraphic"]) >= 0) {
                    let gimmickMatchCageSprite;
                    if (match["gimmickMatchGraphic"] === "cage_grey") gimmickMatchCageSprite = sprites.gimmickMatchCageGrey;
                    else if (match["gimmickMatchGraphic"] === "cage_red") gimmickMatchCageSprite = sprites.gimmickMatchCageRed;
                    else if (match["gimmickMatchGraphic"] === "cage_retro_blue") gimmickMatchCageSprite = sprites.gimmickMatchCageRetroBlue;
                    else if (match["gimmickMatchGraphic"] === "cage_retro_black") gimmickMatchCageSprite = sprites.gimmickMatchCageRetroBlack;
                    gimmickMatchCageSprite.parentLayer = layer;
                    gimmickMatchCageSprite.x = 0;
                    gimmickMatchCageSprite.y = 0;
                    gimmickMatchCageSprite.zIndex = 40;
                    stageObjects.addChild(gimmickMatchCageSprite);
                } else if (match["gimmickMatchGraphic"] === "ambulance") {
                    sprites.gimmickMatchAmbulance.parentLayer = layer;
                    sprites.gimmickMatchAmbulance.x = -78;
                    sprites.gimmickMatchAmbulance.y = 30;
                    sprites.gimmickMatchAmbulance.zIndex = -10;
                    stageObjects.addChild(sprites.gimmickMatchAmbulance);
                } else if (match["gimmickMatchGraphic"] === "barbed_wire_ropes") {
                    // Ropes
                    sprites.gimmickMatchBarbedWireRopes.parentLayer = layer;
                    sprites.gimmickMatchBarbedWireRopes.x = 0;
                    sprites.gimmickMatchBarbedWireRopes.y = 122;
                    sprites.gimmickMatchBarbedWireRopes.zIndex = 40;
                    stageObjects.addChild(sprites.gimmickMatchBarbedWireRopes);
                    // Boards
                    sprites.gimmickMatchBarbedWireBoard.parentLayer = layer;
                    sprites.gimmickMatchBarbedWireBoard.x = 12;
                    sprites.gimmickMatchBarbedWireBoard.y = 68;
                    sprites.gimmickMatchBarbedWireBoard.zIndex = -10;
                    stageObjects.addChild(sprites.gimmickMatchBarbedWireBoard);
                    let gimmickMatchBarbedWireBoardSpriteDuplicate = new PIXI.Sprite(sprites.gimmickMatchBarbedWireBoard.texture);
                    gimmickMatchBarbedWireBoardSpriteDuplicate.scale.x *= -1;
                    gimmickMatchBarbedWireBoardSpriteDuplicate.parentLayer = layer;
                    gimmickMatchBarbedWireBoardSpriteDuplicate.x = 424;
                    gimmickMatchBarbedWireBoardSpriteDuplicate.y = 68;
                    gimmickMatchBarbedWireBoardSpriteDuplicate.zIndex = -10;
                    stageObjects.addChild(gimmickMatchBarbedWireBoardSpriteDuplicate);
                } else if (match["gimmickMatchGraphic"] === "grave") {
                    sprites.gimmickMatchBuriedAlive.parentLayer = layer;
                    sprites.gimmickMatchBuriedAlive.x = 142;
                    sprites.gimmickMatchBuriedAlive.y = 77;
                    sprites.gimmickMatchBuriedAlive.zIndex = -10;
                    stageObjects.addChild(sprites.gimmickMatchBuriedAlive);
                } else if (match["gimmickMatchGraphic"] === "casket") {
                    let gimmickMatchCasketSprite = $c82cd471f4baff6b$var$pickUsingWeights(casketObjects, casketWeights, newMathRandom());
                    gimmickMatchCasketSprite.parentLayer = layer;
                    gimmickMatchCasketSprite.x = 115;
                    gimmickMatchCasketSprite.y = 134;
                    gimmickMatchCasketSprite.zIndex = 40;
                    stageObjects.addChild(gimmickMatchCasketSprite);
                } else if (match["gimmickMatchGraphic"] === "parking_lot") {
                    let gimmickMatchParkingLotSprite = $c82cd471f4baff6b$var$pickUsingWeights(parkingLotObjects, parkingLotWeights, newMathRandom());
                    gimmickMatchParkingLotSprite.parentLayer = layer;
                    gimmickMatchParkingLotSprite.x = 0;
                    gimmickMatchParkingLotSprite.y = 81;
                    gimmickMatchParkingLotSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchParkingLotSprite);
                }
                // Add hanging championships graphics
                if (match["hangingChampionships"] && match["hangingChampionships"].length > 0) {
                    let hangingChampionshipsMedian = $c82cd471f4baff6b$var$getMedian(Array.from(Array(match["hangingChampionships"].length).keys()));
                    match["hangingChampionships"].forEach(function(hangingChampionship, hangingChampionshipIndex) {
                        let smallTitleData = getSmallTitleData(hangingChampionship);
                        // Go through small title parts
                        Object.keys(smallTitleData).forEach(function(key) {
                            let item = smallTitleData[key]["object"];
                            let newItem = smallTitleData[key]["object"];
                            item.designs.map(function(x, y) {
                                // Duplicate sprite
                                let newSprite = new PIXI.Sprite(x.sprite.texture);
                                // Add color
                                let spriteColor = smallTitleData[key]["colors"][y];
                                x.defaultColor = spriteColor; // change defaultColor
                                newSprite.tint = x.defaultColor;
                                // Add position
                                newSprite.zIndex = x.zIndex;
                                let xPos = $c82cd471f4baff6b$var$renderer.width / 2 - newSprite.width / 2;
                                if (hangingChampionshipIndex > hangingChampionshipsMedian) xPos += 42 * (hangingChampionshipIndex - hangingChampionshipsMedian);
                                else if (hangingChampionshipIndex < hangingChampionshipsMedian) xPos -= 42 * (hangingChampionshipsMedian - hangingChampionshipIndex);
                                newSprite.position.x = xPos;
                                newSprite.position.y = -23;
                                // Add to stage
                                newSprite.parentLayer = layer;
                                stageObjects.addChild(newSprite);
                                // Set new sprite to duplicate object
                                newItem.designs[y].sprite = newSprite;
                            });
                        });
                    });
                }
            }
            if (match && match["annualTournament"]) {
                if (match["name"] === "Trophy Presentation") {
                    // Add trophy graphic
                    sprites.TGITrophy.parentLayer = layer;
                    sprites.TGITrophy.y = -10;
                    sprites.TGITrophy.zIndex = 40;
                    stageObjects.addChild(sprites.TGITrophy);
                    if (segmentAction) {
                        // Add fireworks graphic
                        sprites.TGIFireworks.parentLayer = layer;
                        sprites.TGIFireworks.x = 0;
                        sprites.TGIFireworks.y = 0;
                        sprites.TGIFireworks.zIndex = 40;
                        stageObjects.addChild(sprites.TGIFireworks);
                        // Position trophy next to winner
                        sprites.TGITrophy.x = 96;
                    } else // Position trophy next to president
                    sprites.TGITrophy.x = 241;
                }
            }
            $c82cd471f4baff6b$var$renderer.render(stage);
        }
        function selectGimmickMatchWeaponObject(seed) {
            // Seed random
            let newMathRandom = new Math.seedrandom(seed);
            // Get object by weights
            let weaponObjectWeights = [
                3,
                5,
                3,
                3,
                3,
                1,
                3,
                3,
                1,
                1,
                3,
                3,
                3,
                3,
                3,
                3,
                1
            ];
            let selectedWeaponObject = $c82cd471f4baff6b$var$pickUsingWeights(sprites.weaponObjects, weaponObjectWeights, newMathRandom());
            // Get object color
            let objectColors;
            // Kendo stick
            if (selectedWeaponObject === sprites.accessoryObject25) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xE8D68A",
                    "0xE8E7E7"
                ],
                [
                    "0xC0A15D",
                    "0xCDCDCD"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject29) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0x4C4C4C"
                ],
                [
                    "0x6A83B0"
                ],
                [
                    "0xA1A1A1"
                ],
                [
                    "0xB7AA86"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject30) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xCCA670",
                    "0x4D4D4D"
                ],
                [
                    "0x957A4C",
                    "0x7F7A73"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject31) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xD9BA5B",
                    "0xD2D2D2"
                ],
                [
                    "0xA48040",
                    "0x4C4C4C"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject41) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xCCCCCC",
                    "0x969696",
                    "0xE5564D"
                ],
                [
                    "0x575757",
                    "0x3B3B3B",
                    "0x575757"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject45) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xD1D1D1",
                    "0xD1B78A"
                ],
                [
                    "0x474747",
                    "0xCF7738"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject47) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xE0E0E0",
                    "0x8D8D8D"
                ],
                [
                    "0xC7DBE8",
                    "0x8D8D8D"
                ],
                [
                    "0xEAE2B2",
                    "0x8D8D8D"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject49) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xC6A26B"
                ],
                [
                    "0x474747"
                ],
                [
                    "0xE8C090"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject52) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0x3E3E3E",
                    "0x9D272B",
                    "0x505050"
                ],
                [
                    "0xE8E4E4",
                    "0xACD128",
                    "0xA2A2A2"
                ],
                [
                    "0xDCDCDC",
                    "0x383838",
                    "0xBBB5B5"
                ],
                [
                    "0x4D94A1",
                    "0xD7D7D7",
                    "0xA1A1A1"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject53) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xFFDA94",
                    "0x755B3D",
                    "0x423A30",
                    "0xFFFFFF"
                ],
                [
                    "0x0D0D0D",
                    "0x0D0D0D",
                    "0x0D0D0D",
                    "0x999999"
                ],
                [
                    "0xDEB546",
                    "0x524221",
                    "0x423A30",
                    "0xFFFFFF"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject55) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0x555555"
                ],
                [
                    "0xD9CDC4"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject56) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xD4D8DB"
                ],
                [
                    "0xB2BBB5"
                ],
                [
                    "0x73787F"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject57) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xAE2D2D",
                    "0xE8E8E8",
                    "0xD9D9D9"
                ],
                [
                    "0xE6D434",
                    "0x333333",
                    "0x333333"
                ],
                [
                    "0x1C4AC0",
                    "0xE8E8E8",
                    "0xD9D9D9"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject58) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0x957F5F",
                    "0x656565"
                ],
                [
                    "0x675F4E",
                    "0xB0B0B0"
                ],
                [
                    "0xC6AB33",
                    "0xE4C643"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject59) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xC2493A",
                    "0xEBEBEB",
                    "0x565656",
                    "0xBEBEBE"
                ],
                [
                    "0xC2493A",
                    "0xEFE425",
                    "0xACACAC",
                    "0xA23D31"
                ]
            ], newMathRandom());
            else if (selectedWeaponObject === sprites.accessoryObject72) objectColors = (0, $3E8Nt.getRandomChoice)([
                [
                    "0xD95C2B",
                    "0xE3E4E4",
                    "0xD95C2B",
                    "0x525252"
                ],
                [
                    "0x6C6C6C",
                    "0xE3E4E4",
                    "0xE8DB33",
                    "0x4A4A4A"
                ],
                [
                    "0xD5532A",
                    "0xDBE0E4",
                    "0xC8C8C8",
                    "0x4A4A4A"
                ]
            ], newMathRandom());
            else objectColors = selectedWeaponObject.designs.map(function(x) {
                return x.defaultColor;
            });
            return {
                object: sprites.weaponObjects.indexOf(selectedWeaponObject),
                colors: objectColors
            };
        }
        function getSmallTitleData(titleData) {
            // Get small objects using center plate
            let centerPlateObject = sprites.centerPlates[titleData["centerPlate"]["object"]];
            let smallPlateObject = centerPlateObject.smallPlateObject;
            let smallStrapObject = smallPlateObject.smallStrapObject;
            let smallGemsObject = smallPlateObject.smallGemsObject;
            // Create small title data
            let smallTitleData = {};
            smallTitleData.smallPlateObject = {
                "object": smallPlateObject,
                "colors": titleData["centerPlate"]["colors"]
            };
            smallTitleData.smallStrapObject = {
                "object": smallStrapObject,
                "colors": titleData["strap"]["colors"]
            };
            smallTitleData.smallGemsObject = {
                "object": smallGemsObject,
                "colors": titleData["centerGems"]["colors"]
            };
            return smallTitleData;
        }
        // Update design selection
        function updateDesigns(object) {
            let element = el.siblings(".part-controls").find(".select-design button");
            if (object.designs.length > 1) element.each(function(index) {
                if (index === 0) $(this).addClass("selected");
                else $(this).removeClass("selected");
                if (index < object.designs.length) $(this).show();
                else $(this).hide();
            });
            else element.hide();
            // Update color selection
            let i = element.index(element.eq(0).parent().find(".selected:visible"));
            let color;
            if (i < 0) i = 0;
            color = selected.designs[i].defaultColor.slice(2);
            el.siblings(".part-controls").find(".spectrum").spectrum("set", color);
        }
        function getSubCategorySelections(parentCategory, subCategory) {
            let selections;
            switch(parentCategory){
                case "Hair":
                    switch(subCategory){
                        case "Short":
                            selections = sprites.shortHair;
                            break;
                        case "Long":
                            selections = sprites.longHair;
                            break;
                        case "Feminine":
                            selections = sprites.feminineHair;
                            break;
                    }
                    break;
                case "Shoes":
                    switch(subCategory){
                        case "Long":
                            selections = sprites.longShoes;
                            break;
                        case "Short":
                            selections = sprites.shortShoes;
                            break;
                    }
                    break;
                case "Torso":
                    switch(subCategory){
                        case "Shirt":
                            selections = sprites.shirtTops;
                            break;
                        case "Vest":
                            selections = sprites.vestTops;
                            break;
                        case "Sports Bra":
                            selections = sprites.sportsBraTops;
                            break;
                        case "Feminine":
                            selections = sprites.feminineTops;
                            break;
                        case "Other":
                            selections = sprites.otherTops;
                            break;
                    }
                    break;
                case "Bottoms":
                    switch(subCategory){
                        case "Tights":
                            selections = sprites.tights;
                            break;
                        case "Trunks":
                            selections = sprites.trunks;
                            break;
                        case "Shorts":
                            selections = sprites.shorts;
                            break;
                        case "Feminine":
                            selections = sprites.feminineBottoms;
                            break;
                    }
                    break;
                case "Accessory":
                    switch(subCategory){
                        case "Gloves":
                            selections = sprites.glovesAccessories;
                            break;
                        case "Wrist Tape":
                            selections = sprites.wristTapeAccessories;
                            break;
                        case "Glasses":
                            selections = sprites.glassesAccessories;
                            break;
                        case "Suit & Tie":
                            selections = sprites.suitAndTieAccessories;
                            break;
                        case "Feminine":
                            selections = sprites.feminineAccessories;
                            break;
                        case "Neck":
                            selections = sprites.neckAccessories;
                            break;
                        case "Weapons":
                            selections = sprites.weaponObjects;
                            break;
                        case "Masks":
                            selections = sprites.masksAccessories;
                            break;
                        case "Flags":
                            selections = sprites.flagsAccessories;
                            break;
                        case "Other":
                            selections = sprites.otherAccessories;
                            break;
                    }
                    break;
            }
            return selections;
        }
        function setSelectedPartForSubCategory(parentCategory, selection, accessoryNumber) {
            switch(parentCategory){
                case "Accessory":
                    selectedAccessory = selection;
                    // Save to accessory number
                    switch(accessoryNumber){
                        case "1":
                            addedAccessory = selection;
                            break;
                        case "2":
                            addedAccessory2 = selection;
                            break;
                        case "3":
                            addedAccessory3 = selection;
                            break;
                        default:
                            addedAccessory = selection;
                    }
                    break;
                case "Hair":
                    addedHair = selection;
                    break;
                case "Bottoms":
                    addedBottoms = selection;
                    break;
                case "Torso":
                    addedTorso = selection;
                    break;
                case "Shoes":
                    addedShoes = selection;
                    break;
            }
            selected = selection;
            return true;
        }
    }
}
function $c82cd471f4baff6b$var$loadBaseAttire() {
    // Select attire "A"
    $(".attire-select-button.selected").removeClass("selected");
    $('.attire-select-button:contains("A")').addClass("selected");
    $(".part-button.disabled").removeClass("disabled");
    $(".remove-attire-button").hide();
}
function $c82cd471f4baff6b$var$loadTitleGraphic(stage, stageObjects, stageLayers, stageBackground, layer, jsonData, el, showPalette) {
    if (typeof showPalette === "undefined") showPalette = true;
    if (typeof jsonData === "undefined") jsonData = null;
    if (typeof el === "undefined" || el === null) el = $(".select-part");
    else el = el.siblings(".character-creator-controls").find(".select-part");
    // Run setup if resources loaded, otherwise wait for load event (first time)
    PIXI.loader.on("complete", function() {
        $c82cd471f4baff6b$var$resourcesLoaded = true;
    });
    if ($c82cd471f4baff6b$var$resourcesLoaded) {
        // Unbind click handlers
        $(".character-creator-controls *").off();
        setup();
    } else PIXI.loader.load(setup);
    function setup() {
        // Initialize spectrum color picker
        if (showPalette) el.next(".part-controls").find(".spectrum").spectrum({
            showPalette: true,
            palette: [
                [
                    "#000",
                    "#444",
                    "#666",
                    "#999",
                    "#ccc",
                    "#eee",
                    "#f3f3f3",
                    "#fff"
                ],
                [
                    "#f00",
                    "#f90",
                    "#ff0",
                    "#0f0",
                    "#0ff",
                    "#00f",
                    "#90f",
                    "#f0f"
                ],
                [
                    "#f4cccc",
                    "#fce5cd",
                    "#fff2cc",
                    "#d9ead3",
                    "#d0e0e3",
                    "#cfe2f3",
                    "#d9d2e9",
                    "#ead1dc"
                ],
                [
                    "#ea9999",
                    "#f9cb9c",
                    "#ffe599",
                    "#b6d7a8",
                    "#a2c4c9",
                    "#9fc5e8",
                    "#b4a7d6",
                    "#d5a6bd"
                ],
                [
                    "#e06666",
                    "#f6b26b",
                    "#ffd966",
                    "#93c47d",
                    "#76a5af",
                    "#6fa8dc",
                    "#8e7cc3",
                    "#c27ba0"
                ],
                [
                    "#c00",
                    "#e69138",
                    "#f1c232",
                    "#6aa84f",
                    "#45818e",
                    "#3d85c6",
                    "#674ea7",
                    "#a64d79"
                ],
                [
                    "#900",
                    "#b45f06",
                    "#bf9000",
                    "#38761d",
                    "#134f5c",
                    "#0b5394",
                    "#351c75",
                    "#741b47"
                ],
                [
                    "#600",
                    "#783f04",
                    "#7f6000",
                    "#274e13",
                    "#0c343d",
                    "#073763",
                    "#20124d",
                    "#4c1130"
                ],
                [
                    "#C59548",
                    "#DDA240",
                    "#D9B04D",
                    "#D7A018",
                    "#EABF3E",
                    "#C69F29",
                    "#C1B76B",
                    "#F6CDCE"
                ],
                [
                    "#D99352",
                    "#B7641C",
                    "#E5E6EA",
                    "#BABABA"
                ]
            ],
            preferredFormat: "hex",
            color: "#C59548",
            showInitial: true,
            showInput: true,
            showButtons: false
        });
        $(".add-championship-container").find(".sp-replacer").addClass("grey-background");
        const sprites = (0, $cdadd3e3b416e3dd$export$3418d293d1536e9)();
        /*
        // GENERATE JSON FOR GENERATING GRAPHICS ON BACK END

        function getDesignsLength(x, i) {
            let y = {};
            y['designs'] = x['designs'].length;

            if (x && x.designs[0].sprite === emptySprite) {
                i = -1
            }
            y['number'] = i;

            if (allCenterPlates.indexOf(x) >= 0) {
                y['gemPart'] = allCenterGems.indexOf(x.gemPart);
                y['strapPart'] = allStraps.indexOf(x.strapPart);
                y['sidePlatesPart'] = allSidePlates.indexOf(x.sidePlatesPart);
            }
            else {
                y['sideGemsPart'] = allSideGems.indexOf(x.sideGemsPart);
            }

            return y;
        }

        let allCenterPlates = Array.from(allCenterPlates, getDesignsLength);
        let allSidePlates = Array.from(allSidePlates, getDesignsLength);
        let allParts = {
            'centerPlate': allCenterPlates,
            'sidePlates': allSidePlates
        };
        console.log(JSON.stringify(allParts));*/ let parts = {
            "centerPlate": sprites.allCenterPlates,
            "strap": sprites.allStraps,
            "sidePlates": sprites.allSidePlates,
            "centerGems": sprites.allCenterGems,
            "sideGems": sprites.allSideGems
        };
        let selected;
        let selectedPart;
        let selections = sprites.centerPlates;
        // Check for loaded data
        let data = jsonData;
        let addedCenterPlate;
        let addedStrap;
        let addedSidePlates;
        let addedCenterGems;
        let addedSideGems;
        let addedParts = {
            "centerPlate": addedCenterPlate,
            "strap": addedStrap,
            "sidePlates": addedSidePlates,
            "centerGems": addedCenterGems,
            "sideGems": addedSideGems
        };
        let allowChange;
        if (!data) {
            // Add default character
            addedCenterPlate = sprites.centerPlates[0];
            addedStrap = sprites.straps[0];
            addedSidePlates = sprites.sidePlates[0];
            addedCenterGems = sprites.centerGems[0];
            addedSideGems = sprites.sideGems[0];
            // Add parts to stage, set colors and zIndex
            addedCenterPlate.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedStrap.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedSidePlates.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedCenterGems.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedSideGems.designs.map(function(x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            updateCenterPlateParts(addedCenterPlate);
            // Allow randomization
            allowChange = true;
        } else {
            // Load graphic
            loadGraphicFromCode(data);
            // Update center plate parts but don't replace
            updateCenterPlateParts(addedCenterPlate, false);
            // Don't allow randomization after loading character
            allowChange = false;
        }
        $c82cd471f4baff6b$var$renderer.render(stage);
        // Change style
        let x = 0;
        let selectedElement = $(".add-championship-container, #change-championship-graphic-container, .custom-starting-company-championships, .scenario-editor-container, .form-new-company-championships");
        selectedElement.off().on("click", ".select-next, .select-previous", function() {
            allowChange = false;
            let $this = $(this);
            // Replace existing part
            if (selections.indexOf(selected) !== -1) selected.designs.map(function(x) {
                stageObjects.removeChild(x.sprite);
            });
            // Next and previous selection
            if ($this.hasClass("select-previous")) x--;
            else x++;
            // Stay within selections
            if (x === selections.length) x = 0;
            if (x < 0) x = selections.length - 1;
            // Select and display part (add to layer for z index sorting)
            selected = selections[x];
            if (selections.indexOf(selected) !== -1) selected.designs.map(function(x) {
                stageObjects.addChild(x.sprite);
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
            });
            $c82cd471f4baff6b$var$renderer.render(stage);
            // Store selected part and alter positioning if needed
            if (sprites.centerPlates.indexOf(selected) !== -1) {
                addedCenterPlate = selected;
                // Update center plate's parts (strap, gems)
                updateCenterPlateParts(addedCenterPlate);
            } else if (sprites.straps.indexOf(selected) !== -1) addedStrap = selected;
            else if (sprites.sidePlates.indexOf(selected) !== -1) {
                addedSidePlates = selected;
                updateSidePlatesParts(addedSidePlates);
            } else if (sprites.centerGems.indexOf(selected) !== -1) addedCenterGems = selected;
            else if (sprites.sideGems.indexOf(selected) !== -1) addedSideGems = selected;
            // Update selection number
            $this.parent().find(".selection-number").text(x + 1);
            // Update positions of parts based on size
            updateDesigns(selected);
        });
        // Select part to edit
        selectedElement.on("click", ".part-button", function() {
            // Hide share/import
            $(this).parent().siblings(".load-character-code-container").hide();
            $(this).parent().siblings(".share-character-code-container").hide();
            $(this).parent().siblings(".character-creator-menu").find(".button").removeClass("selected");
            let $this = $(this);
            $(this).addClass("selected");
            $(this).parent().children().each(function() {
                if (!$(this).is($this)) $(this).removeClass("selected");
            });
            selectedPart = $(this).text().trim().toLowerCase();
            switch($(this).text().trim()){
                case "Center Plate":
                    selections = sprites.centerPlates;
                    if (addedCenterPlate) {
                        x = selections.indexOf(addedCenterPlate);
                        selected = addedCenterPlate;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Strap":
                    selections = sprites.straps;
                    if (addedStrap) {
                        x = selections.indexOf(addedStrap);
                        selected = addedStrap;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Side Plates":
                    selections = sprites.sidePlates;
                    if (addedSidePlates) {
                        x = selections.indexOf(addedSidePlates);
                        selected = addedSidePlates;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Center Gems":
                    selections = sprites.centerGems;
                    if (addedCenterGems) {
                        x = selections.indexOf(addedCenterGems);
                        selected = addedCenterGems;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
                case "Side Gems":
                    selections = sprites.sideGems;
                    if (addedSideGems) {
                        x = selections.indexOf(addedSideGems);
                        selected = addedSideGems;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(x + 1);
                        updateDesigns(selected);
                    } else {
                        x = -1;
                        $(this).parent().siblings(".part-controls").find(".selection-number").text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings(".part-controls").find(".select-design .button").hide();
                    }
                    break;
            }
        });
        // Select design to recolor
        selectedElement.on("click", ".select-design .button", function() {
            let $this = $(this);
            $(this).addClass("selected");
            $this.parent().children().each(function() {
                if (!$(this).is($this)) $(this).removeClass("selected");
            });
            // Update color selection
            let i = $this.parent().children().index($this);
            if (i >= 0) {
                let color = selected.designs[i].defaultColor.slice(2);
                $this.parent().parent().prev().find(".spectrum").spectrum("set", color);
            }
        });
        // Change color
        selectedElement.on("move.spectrum change", ".spectrum", function(e, tinycolor) {
            if (selected) {
                allowChange = false;
                let selectDesign = $(this).parent().siblings(".select-design-holder").children(".select-design");
                // Convert color to hexadecimal
                let colorString = tinycolor.toHexString();
                let color = "0x" + colorString.slice(1);
                // Find which design is selected
                let i;
                if (selectDesign.find(".selected:visible").length > 0) i = selectDesign.find("button").index(selectDesign.find(".selected"));
                else i = 0;
                selected.designs[i].sprite.tint = color;
                // Change default color, saving selected color
                selected.designs[i].defaultColor = color;
                $c82cd471f4baff6b$var$renderer.render(stage);
            }
        });
        // Save graphic
        selectedElement.on("click", ".share-character", function() {
            function getObject(object, objects) {
                let objectIndex;
                // Don't add object if empty sprite
                if (object && object.designs[0].sprite === sprites.emptySprite) objectIndex = -1;
                else objectIndex = objects.indexOf(object);
                return {
                    object: objectIndex,
                    colors: object ? object.designs.map(function(x) {
                        return x.defaultColor;
                    }) : null
                };
            }
            let data = {
                centerPlate: getObject(addedCenterPlate, sprites.allCenterPlates),
                strap: getObject(addedStrap, sprites.allStraps),
                sidePlates: getObject(addedSidePlates, sprites.allSidePlates),
                centerGems: getObject(addedCenterGems, sprites.allCenterGems),
                sideGems: getObject(addedSideGems, sprites.allSideGems)
            };
            jsonData = JSON.stringify(data);
            // Show code and copy button
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this).parent().siblings(".share-character-code-container").hide();
            } else {
                $(this).siblings().removeClass("selected");
                $(this).addClass("selected");
                $(this).parent().siblings(".share-character-code-container").show();
                $(this).parent().siblings(".share-character-code-container").children(".share-character-code-input").val(jsonData).text(jsonData);
                $(this).parent().siblings(".load-character-code-container").hide();
            }
        });
        // Copy graphic code
        selectedElement.on("click", ".copy-character-code", function() {
            $(this).parent().siblings(".character-creator-menu").find(".share-character").trigger("click");
            $c82cd471f4baff6b$export$2cdf1b96a9f86d16($(this).siblings(".share-character-code-input"));
        });
        // Import graphic
        selectedElement.on("click", ".import-character", function() {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this).parent().siblings(".load-character-code-container").hide();
            } else {
                $(this).siblings().removeClass("selected");
                $(this).addClass("selected");
                // Show input and load button
                $(this).parent().siblings(".load-character-code-container").show();
                $(this).parent().siblings(".share-character-code-container").hide();
            }
        });
        // Load graphic code
        selectedElement.on("click", ".load-character-code-button", function() {
            let data = $(this).siblings(".load-character-code-input").val();
            let rebrandChampionship = $(this).closest("#change-championship-graphic-container").length > 0;
            if (!data) notie.alert({
                type: 3,
                text: "Invalid graphic code",
                stay: false
            });
            else try {
                let graphicData = JSON.parse(data);
                loadGraphicFromCode([
                    graphicData
                ]);
                // Update center plate's parts but don't replace
                updateCenterPlateParts(addedCenterPlate, false);
                $(this).parent().siblings(".character-creator-menu").find(".import-character").removeClass("selected");
                $(this).parent(".load-character-code-container").hide();
                if (!rebrandChampionship) notie.alert({
                    type: 4,
                    text: "Graphic loaded!",
                    stay: false
                });
            } catch (e) {
                (0, $3E8Nt.captureError)(e);
                notie.alert({
                    type: 3,
                    text: "Invalid graphic code",
                    stay: false
                });
            }
        });
        // Randomize graphic menu
        selectedElement.on("click", ".randomize-character", function() {
            function randomizeGraphic() {
                // Reset stage
                while(stageObjects.children[0])stageObjects.removeChild(stageObjects.children[0]);
                while(stageLayers.children[0])stageLayers.removeChild(stageLayers.children[0]);
                // Select center plate and its parts
                addedCenterPlate = (0, $3E8Nt.getRandomChoice)(sprites.centerPlates);
                addedStrap = addedCenterPlate.strapPart;
                addedCenterGems = addedCenterPlate.gemPart;
                // Select side plates and its parts
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 70) addedSidePlates = addedCenterPlate.sidePlatesPart;
                else addedSidePlates = (0, $3E8Nt.getRandomChoice)(sprites.sidePlates);
                addedSideGems = addedSidePlates.sideGemsPart;
                // Get part colors
                let centerPlateColor = $c82cd471f4baff6b$var$getPlateColor();
                let sidePlatesColor = centerPlateColor;
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) sidePlatesColor = $c82cd471f4baff6b$var$getPlateColor();
                let strapColor = $c82cd471f4baff6b$var$getStrapColor();
                let centerGemsColor = $c82cd471f4baff6b$var$getGemsColor();
                let sideGemsColor = centerGemsColor;
                if ((0, $3E8Nt.getRandomInt)(0, 100) <= 5) sideGemsColor = $c82cd471f4baff6b$var$getGemsColor();
                // Add parts to stage
                addedCenterPlate.designs.map(function(x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = centerPlateColor;
                    x.sprite.tint = centerPlateColor;
                    stageObjects.addChild(x.sprite);
                });
                addedStrap.designs.map(function(x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = strapColor;
                    x.sprite.tint = strapColor;
                    stageObjects.addChild(x.sprite);
                });
                addedSidePlates.designs.map(function(x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = sidePlatesColor;
                    x.sprite.tint = sidePlatesColor;
                    stageObjects.addChild(x.sprite);
                });
                addedCenterGems.designs.map(function(x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = centerGemsColor;
                    x.sprite.tint = centerGemsColor;
                    stageObjects.addChild(x.sprite);
                });
                addedSideGems.designs.map(function(x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = sideGemsColor;
                    x.sprite.tint = sideGemsColor;
                    stageObjects.addChild(x.sprite);
                });
                // Update parts
                sprites.straps = [
                    addedCenterPlate.strapPart
                ];
                sprites.centerGems = [
                    addedCenterPlate.gemPart,
                    sprites.emptyCenterGemsObject
                ];
                sprites.sideGems = [
                    addedSidePlates.sideGemsPart,
                    sprites.emptySideGemsObject
                ];
                el.find(".button").eq(0).trigger("click");
                $c82cd471f4baff6b$var$renderer.render(stage);
            }
            // Randomize instantly if no parts changed
            if (allowChange) randomizeGraphic();
            else notie.confirm({
                text: "Are you sure?",
                submitCallback: function() {
                    randomizeGraphic();
                    allowChange = true;
                }
            });
        });
        // Select center plate button initially
        el.find(".button").eq(0).trigger("click");
        // Load graphic
        function loadGraphicFromCode(data) {
            // Reset stage
            while(stageObjects.children[0])stageObjects.removeChild(stageObjects.children[0]);
            while(stageLayers.children[0])stageLayers.removeChild(stageLayers.children[0]);
            // Background
            if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
                let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
                background.zIndex = -100;
                stageBackground.addChild(background);
            }
            data.forEach(function(characterData, i) {
                let characterContainer = new PIXI.Container();
                Object.keys(addedParts).forEach(function(key, index) {
                    // Get object by part key
                    let partData = characterData[key];
                    if (partData && partData["object"] >= 0) {
                        let objectIndex = characterData[key]["object"];
                        let item = parts[key][objectIndex]; // get object
                        let newItem = parts[key][objectIndex]; // duplicate object
                        item.designs.map(function(x, y) {
                            // Duplicate sprite
                            let newSprite = new PIXI.Sprite(x.sprite.texture);
                            // Add color
                            let spriteColor = characterData[key]["colors"][y];
                            if (!spriteColor) // For backwards compatibility with new designs added to part (e.g hair streak)
                            // Set color to previous design's color if not found
                            spriteColor = characterData[key]["colors"][y - 1];
                            x.defaultColor = spriteColor; // change defaultColor
                            newSprite.tint = x.defaultColor;
                            // Add parts to stage
                            newSprite.parentLayer = layer;
                            newSprite.zIndex = x.zIndex;
                            // Get x position of character
                            newSprite.position.x = x.sprite.position.x;
                            newSprite.position.y = x.sprite.position.y;
                            characterContainer.addChild(newSprite);
                            stageObjects.addChild(newSprite);
                            // Set new sprite to duplicate object
                            newItem.designs[y].sprite = newSprite;
                        });
                        addedParts[key] = newItem;
                    } else addedParts[key] = null;
                });
            });
            // Set added parts
            addedCenterPlate = addedParts["centerPlate"];
            addedStrap = addedParts["strap"];
            addedSidePlates = addedParts["sidePlates"];
            addedCenterGems = addedParts["centerGems"];
            addedSideGems = addedParts["sideGems"];
            // Add empty objects if null
            if (!addedSidePlates) addedSidePlates = sprites.emptySidePlatesObject;
            if (!addedCenterGems) addedCenterGems = sprites.emptyCenterGemsObject;
            if (!addedSideGems) addedSideGems = sprites.emptySideGemsObject;
            if (!selected) // Select center plate upon initial load
            selected = addedCenterPlate;
            else // Add selected part again because it changed
            selected = addedParts["centerPlate"];
            // Select center plate button
            el.find(".button").eq(0).trigger("click");
            // Update part controls
            let x = selections.indexOf(selected);
            $(".selection-number").text(x + 1);
            updateDesigns(selected);
            $c82cd471f4baff6b$var$renderer.render(stage);
        }
        // Update design selection
        function updateDesigns(object) {
            let element = el.siblings(".part-controls").find(".select-design button");
            if (object.designs.length > 1) element.each(function(index) {
                if (index === 0) $(this).addClass("selected");
                else $(this).removeClass("selected");
                if (index < object.designs.length) $(this).show();
                else $(this).hide();
            });
            else element.hide();
            // Update color selection
            let i = element.index(element.eq(0).parent().find(".selected:visible"));
            let color;
            if (i < 0) i = 0;
            color = selected.designs[i].defaultColor.slice(2);
            el.siblings(".part-controls").find(".spectrum").spectrum("set", color);
        }
        // Update strap and gems for center plate change
        function updateCenterPlateParts(centerPlate, replace) {
            // Set to false for loading graphic, so parts not replaced by defaults
            if (typeof replace === "undefined") replace = true;
            // Update gems and straps to center plate's only
            sprites.straps = [
                centerPlate.strapPart
            ];
            sprites.centerGems = [
                centerPlate.gemPart,
                sprites.emptyCenterGemsObject
            ];
            // Replace side plates if added
            if (replace) {
                addedSidePlates.designs.map(function(x) {
                    stageObjects.removeChild(x.sprite);
                });
                // Keep all side plates, set to center plate's default one
                addedSidePlates = centerPlate.sidePlatesPart;
                addedSidePlates.designs.map(function(x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                });
            }
            // Replace center gems if added
            if (replace) {
                addedCenterGems.designs.map(function(x) {
                    stageObjects.removeChild(x.sprite);
                });
                addedCenterGems = sprites.centerGems[0];
                addedCenterGems.designs.map(function(x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                });
            }
            // Replace strap
            if (replace) {
                addedStrap.designs.map(function(x) {
                    stageObjects.removeChild(x.sprite);
                });
                addedStrap = sprites.straps[0];
                addedStrap.designs.map(function(x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                });
            }
            if (addedSidePlates) updateSidePlatesParts(addedSidePlates, replace);
            $c82cd471f4baff6b$var$renderer.render(stage);
        }
        // Update gems for side plates change
        function updateSidePlatesParts(sidePlates, replace) {
            if (typeof replace === "undefined") replace = true;
            // Update side gems side plate's only
            sprites.sideGems = [
                sidePlates.sideGemsPart,
                sprites.emptySideGemsObject
            ];
            // Remove existing part
            if (replace) {
                addedSideGems.designs.map(function(x) {
                    stageObjects.removeChild(x.sprite);
                });
                addedSideGems = sprites.sideGems[0];
                // Display new parts
                addedSideGems.designs.map(function(x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                });
                $c82cd471f4baff6b$var$renderer.render(stage);
            }
        }
    }
}
function $c82cd471f4baff6b$var$getPlateColor() {
    let colorsA = [
        "#C59548",
        "#DDA240",
        "#D9B04D",
        "#D7A018",
        "#EABF3E",
        "#C69F29",
        "#C1B76B"
    ];
    let colorsB = [
        "#F6CDCE",
        "#D99352",
        "#B7641C",
        "#E5E6EA",
        "#BABABA"
    ];
    let centerPlateColor;
    let pick = (0, $3E8Nt.getRandomInt)(0, 100);
    if (pick <= 70) centerPlateColor = (0, $3E8Nt.getRandomChoice)(colorsA);
    else if (pick <= 95) centerPlateColor = (0, $3E8Nt.getRandomChoice)(colorsB);
    else centerPlateColor = $c82cd471f4baff6b$var$getRandomColor();
    return "0x" + centerPlateColor.slice(1);
}
function $c82cd471f4baff6b$var$getStrapColor() {
    let colorsA = [
        "#1D1D1D"
    ];
    let colorsB = [
        "#981E21",
        "#2F4F7D",
        "#E5E5E5",
        "#2F6232",
        "#83264F",
        "#3B2363"
    ];
    let strapColor;
    let pick = (0, $3E8Nt.getRandomInt)(0, 100);
    if (pick <= 70) strapColor = (0, $3E8Nt.getRandomChoice)(colorsA);
    else if (pick <= 95) strapColor = (0, $3E8Nt.getRandomChoice)(colorsB);
    else strapColor = $c82cd471f4baff6b$var$getRandomColor();
    return "0x" + strapColor.slice(1);
}
function $c82cd471f4baff6b$var$getGemsColor() {
    let colorsA = [
        "#001E97",
        "#148A0D",
        "#C51616",
        "#CA0F68",
        "#F4DE39",
        "#BD1DAC",
        "#EFEFF0"
    ];
    let gemsColor;
    let pick = (0, $3E8Nt.getRandomInt)(0, 100);
    if (pick <= 80) gemsColor = (0, $3E8Nt.getRandomChoice)(colorsA);
    else gemsColor = $c82cd471f4baff6b$var$getRandomColor();
    return "0x" + gemsColor.slice(1);
}
function $c82cd471f4baff6b$var$getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for(let i = 0; i < 6; i++)color += letters[Math.floor(Math.random() * 16)];
    return color;
}
function $c82cd471f4baff6b$export$2cdf1b96a9f86d16(element, value, text) {
    let val = element ? $(element).text() : value;
    let $temp = $("<input>");
    $("body").append($temp);
    $temp.val(val).select();
    document.execCommand("copy");
    $temp.remove();
    let notieText = text ? text : "Copied to clipboard!";
    notie.alert({
        type: 4,
        text: notieText,
        stay: false
    });
}
function $c82cd471f4baff6b$var$chunk(arr, len) {
    let chunks = [], i = 0, n = arr.length;
    while(i < n)chunks.push(arr.slice(i, i += len));
    return chunks;
}
function $c82cd471f4baff6b$var$getMedian(numbers) {
    // median of [3, 5, 4, 4, 1, 1, 2, 3] = 3
    let median = 0, numsLen = numbers.length;
    numbers.sort();
    if (numsLen % 2 === 0 // is even
    ) // average of two middle numbers
    median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
    else // middle number only
    median = numbers[(numsLen - 1) / 2];
    return median;
}
function $c82cd471f4baff6b$var$getEqualChunkSize(length) {
    let rows = Math.ceil(length / 10);
    return Math.ceil(length / rows);
}
function $c82cd471f4baff6b$var$addCharacterCreatorSubCategory(subCategories, characterCreatorElement) {
    let html = "";
    subCategories.forEach(function(subCategory) {
        html += '<button type="button" class="button retro-button condensed grey-button-background remove-outline sub-category-button">' + subCategory + "</button>\n";
    });
    characterCreatorElement.find(".select-sub-category").html(html);
    return html;
}
function $c82cd471f4baff6b$export$ea8a53556b69e3e0(data, parentElement) {
    if (data && data["graphics"].length > 0) {
        // Create the renderer
        if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
        $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(475, 645);
        $c82cd471f4baff6b$var$renderer.autoResize = true;
        // Create stage and add a layer
        $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
        let stageObjects = new PIXI.Container();
        let stageLayers = new PIXI.Container();
        let stageBackground = new PIXI.Container();
        $c82cd471f4baff6b$var$stage.addChild(stageBackground);
        $c82cd471f4baff6b$var$stage.addChild(stageObjects);
        $c82cd471f4baff6b$var$stage.addChild(stageLayers);
        let layer = new PIXI.display.Layer();
        layer.group.enableSort = true;
        $c82cd471f4baff6b$var$stage.addChild(layer);
        // Render the stage
        $c82cd471f4baff6b$var$renderer.backgroundColor = 0x222222;
        $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
        $c82cd471f4baff6b$var$renderer.view.style.display = "block";
        $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
        let el = parentElement.find(".event-poster-graphic");
        el.html("");
        el.append($c82cd471f4baff6b$var$renderer.view);
        $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, data["graphics"], {
            "type": "singles"
        }, el, false, true, data);
        parentElement.fadeIn();
        // Download event poster
        parentElement.off("click", ".event-poster-download-button");
        parentElement.on("click", ".event-poster-download-button", function() {
            $c82cd471f4baff6b$var$stage.removeChild(stageBackground);
            let fileName = "{0} {1} Poster.png".format(data["eventName"], data["eventYear"]);
            // Create texture from renderer's dimensions to crop anything outside it
            let downloadTexture = PIXI.RenderTexture.create($c82cd471f4baff6b$var$renderer.width, $c82cd471f4baff6b$var$renderer.height);
            $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage, downloadTexture);
            $c82cd471f4baff6b$var$downloadSprite($c82cd471f4baff6b$var$renderer, downloadTexture, fileName);
        });
    }
}
function $c82cd471f4baff6b$var$downloadSprite(renderer, sprite, fileName) {
    renderer.extract.canvas(sprite).toBlob(function(b) {
        let a = document.createElement("a");
        document.body.append(a);
        a.download = fileName;
        a.href = URL.createObjectURL(b);
        a.click();
        a.remove();
    }, "image/png");
}
function $c82cd471f4baff6b$var$resetMatchGraphics() {
    const $match = $("#match");
    // Reset renderer
    if ($c82cd471f4baff6b$var$renderer) $c82cd471f4baff6b$var$renderer.destroy();
    $c82cd471f4baff6b$var$renderer = PIXI.autoDetectRenderer(434, 300);
    $c82cd471f4baff6b$var$renderer.autoResize = true;
    $("#match-graphics").remove();
    // Add the canvas to the HTML document
    let el = $('<div id="match-graphics" class="margin-bottom-20"></div>');
    el.append($c82cd471f4baff6b$var$renderer.view);
    $match.prepend(el).hide();
    // Create stage and add a layer
    $c82cd471f4baff6b$var$stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    $c82cd471f4baff6b$var$stage.addChild(stageBackground);
    $c82cd471f4baff6b$var$stage.addChild(stageObjects);
    $c82cd471f4baff6b$var$stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    $c82cd471f4baff6b$var$stage.addChild(layer);
    // Background
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) {
        let background = PIXI.Sprite.fromImage($c82cd471f4baff6b$export$7d9b72822fcb9a);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }
    // Render the stage
    $c82cd471f4baff6b$var$renderer.backgroundColor = 0xFFFFFF;
    if ($c82cd471f4baff6b$export$7d9b72822fcb9a) $c82cd471f4baff6b$var$renderer.backgroundColor = 0x1B1B1B;
    $c82cd471f4baff6b$var$renderer.view.style.position = "relative";
    $c82cd471f4baff6b$var$renderer.view.style.display = "block";
    $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    // Show canvas
    $match.show();
    return [
        stageObjects,
        stageLayers,
        stageBackground,
        layer
    ];
}
function $c82cd471f4baff6b$export$93eabf8ee4239dc8(segment, segmentAction) {
    let rendererData = $c82cd471f4baff6b$var$resetMatchGraphics();
    let stageObjects = rendererData[0];
    let stageLayers = rendererData[1];
    let stageBackground = rendererData[2];
    let layer = rendererData[3];
    let el = $("#match-graphics");
    let segmentGraphics = segment["graphics"];
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, segmentGraphics, segment, el, false, segmentAction);
}
function $c82cd471f4baff6b$export$4d95ef41d1462076(segment, segmentAction = false) {
    let rendererData = $c82cd471f4baff6b$var$resetMatchGraphics();
    let stageObjects = rendererData[0];
    let stageLayers = rendererData[1];
    let stageBackground = rendererData[2];
    let layer = rendererData[3];
    let el = $("#match-graphics");
    let segmentGraphics = segment["graphics"];
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, segmentGraphics, segment, el, false, segmentAction);
    return stageLayers;
}
function $c82cd471f4baff6b$export$aebc172523823760(match) {
    let rendererData = $c82cd471f4baff6b$var$resetMatchGraphics();
    let stageObjects = rendererData[0];
    let stageLayers = rendererData[1];
    let stageBackground = rendererData[2];
    let layer = rendererData[3];
    let el = $("#match-graphics");
    let matchGraphics = match["graphics"];
    $c82cd471f4baff6b$var$loadGraphic($c82cd471f4baff6b$var$stage, stageObjects, stageLayers, stageBackground, layer, matchGraphics, match, el, false);
    return stageLayers;
}
function $c82cd471f4baff6b$export$c085e4755974582e(segment, winnerName, stageLayers) {
    // Create new layer of all losing team layers (for opacity change to be applied uniformly on each sprite)
    if (segment["graphics"].length > 0) {
        let losingLayer = new PIXI.display.Layer();
        $c82cd471f4baff6b$var$stage.addChild(losingLayer);
        // Show popularity changes next to wrestler's names
        $(".match-wrestler").each(function(index) {
            let wrestlerDiv = $(this);
            let wrestlerName = wrestlerDiv.text();
            if (wrestlerDiv.attr("data-name")) wrestlerName = wrestlerDiv.attr("data-name");
            if (!(wrestlerName === winnerName)) // Add losing team layers' children to losingLayer
            {
                if (index < stageLayers.children.length) stageLayers.children[index].children.forEach(function(item) {
                    item._activeChildren.forEach(function(itemSprite) {
                        itemSprite.parentLayer = losingLayer;
                    });
                });
            }
        });
        // Make losingLayer opaque
        let filter = new PIXI.filters.AlphaFilter();
        filter.alpha = 0.35;
        losingLayer.filters = [
            filter
        ];
        losingLayer.group.enableSort = true;
        $c82cd471f4baff6b$var$renderer.render($c82cd471f4baff6b$var$stage);
    }
}
function $c82cd471f4baff6b$var$pickUsingWeights(items, weights, mathRandomResult) {
    let total = 0;
    let ranges = weights.slice(0);
    let i;
    let len;
    for(i = 0, len = weights.length; i < len; i++)ranges[i] = [
        total,
        total += ranges[i]
    ];
    if (!mathRandomResult) mathRandomResult = Math.random();
    let randomNumber = parseInt(mathRandomResult * total);
    for(; randomNumber < ranges[--i][0];);
    return items[i];
}
function $c82cd471f4baff6b$var$addSpriteToStage(sprite, color, stageObjects, layer) {
    sprite.designs.map(function(x) {
        x.sprite.parentLayer = layer;
        x.sprite.zIndex = x.zIndex;
        x.defaultColor = color;
        x.sprite.tint = color;
        stageObjects.addChild(x.sprite);
    });
}



var $5ZsVo = parcelRequire("5ZsVo");

var $4ptHI = parcelRequire("4ptHI");


var $kpu3X = parcelRequire("kpu3X");

var $iRMwH = parcelRequire("iRMwH");



var $cXLSF = parcelRequire("cXLSF");




let $70adc4a1fd111893$var$fanHistoryChart;
let $70adc4a1fd111893$var$randomizeFeudHintShown = false;
$(document).ready(function() {
    const $viewershipHistoryContainer = $(".viewership-history-container");
    const $game = $("#game");
    // Fan history graph type select
    $viewershipHistoryContainer.on("change", ".viewership-history-graph-type-select", async function() {
        let graphValue = $(this).val();
        let graphPeriod = $(".viewership-history-graph-period-select").val();
        // Show 'show brands separately' checkbox for all options except 'fans'
        if (graphValue === "fans") $(".viewership-history-graph-brand-option").parent().parent().hide();
        else $(".viewership-history-graph-brand-option").parent().parent().show();
        await $70adc4a1fd111893$export$4cc8be918a3a7c33(graphValue, graphPeriod);
    });
    // Fan history graph period select
    $viewershipHistoryContainer.on("change", ".viewership-history-graph-period-select", async function() {
        let graphPeriod = $(this).val();
        let graphValue = $(".viewership-history-graph-type-select").val();
        await $70adc4a1fd111893$export$4cc8be918a3a7c33(graphValue, graphPeriod);
    });
    // Fan history show brands separately check
    $viewershipHistoryContainer.on("click", ".viewership-history-graph-brand-option", async function() {
        let graphPeriod = $(".viewership-history-graph-period-select").val();
        let graphValue = $(".viewership-history-graph-type-select").val();
        await $70adc4a1fd111893$export$4cc8be918a3a7c33(graphValue, graphPeriod);
    });
    // Fan history graph visibility buttons
    $viewershipHistoryContainer.on("click", ".viewership-history-show-all-button, .viewership-history-hide-all-button, .viewership-history-show-5-button, .viewership-history-show-users-button", async function() {
        (0, $lCS03.playSoundEffect)("success");
        $70adc4a1fd111893$var$changeFanHistoryVisibility($(this).attr("data-value"));
    });
    // Fan history show labels checkbox
    $viewershipHistoryContainer.on("click", ".viewership-history-graph-labels-option", async function() {
        (0, $lCS03.playSoundEffect)("success");
        let enabled = !!$(this).is(":checked");
        $70adc4a1fd111893$var$fanHistoryChart.updateOptions({
            dataLabels: {
                enabled: enabled
            }
        });
        notie.alert({
            type: 4,
            text: "Graph setting changed"
        });
    });
    // Go back to staff view from staff member details
    const $staffMemberDetails = $(".staff-member-details");
    $staffMemberDetails.on("click", "#back-to-staff-view-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        let element = $staffMemberDetails.data("element");
        $staffMemberDetails.hide();
        $(element).fadeIn();
        let staffMemberName = $(".staff-member-name").text();
        let staffMemberElement = $(".staff-member-container:contains(" + staffMemberName + ")")[0];
        if (staffMemberElement) {
            // Scroll to center
            Element.prototype.documentOffsetTop = function() {
                return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0);
            };
            let top = staffMemberElement.documentOffsetTop() - window.innerHeight / 2;
            window.scrollTo(0, top);
        }
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_back_to_staff_view_button");
    });
    // View indie staff button handler
    $(".company-staff-container").on("click", "#view-indie-staff-menu-button", async function() {
        await $70adc4a1fd111893$var$loadViewIndieStaffPage();
    });
    // Hire staff button handler
    $staffMemberDetails.on("click", "#hire-staff-member-button", async function() {
        let uid = $(".staff-member-details").data("uid");
        await $70adc4a1fd111893$var$getHireStaffMemberRequest(uid);
    });
    // Fire staff button handler
    $staffMemberDetails.on("click", "#fire-staff-member-button", async function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                let uid = $(".staff-member-details").data("uid");
                await $70adc4a1fd111893$var$getFireStaffMemberRequest(uid);
            }
        });
    });
    // Go back to view staff from staff hiring board
    $game.on("click", ".back-to-view-staff-button", async function() {
        await $70adc4a1fd111893$export$aaebf53bd9c27ff8();
    });
    // Open 'change staff name' page
    $staffMemberDetails.on("click", "#change-staff-name-menu-button", async function() {
        let uid = $(".staff-member-details").data("uid");
        await $70adc4a1fd111893$var$loadChangeStaffMemberNamePage(uid);
    });
    // Change staff name handler
    $(".change-staff-name-container").on("click", ".change-staff-name-button", async function() {
        let parent = $(".change-staff-name-container");
        let name = parent.find(".change-staff-name-input").val();
        let uid = parent.data("uid");
        await $70adc4a1fd111893$var$getChangeStaffMemberNameRequest(uid, name);
    });
    // Open 'change staff pronoun' page
    $staffMemberDetails.on("click", "#change-staff-pronoun-menu-button", async function() {
        let uid = $(".staff-member-details").data("uid");
        await $70adc4a1fd111893$var$loadChangeStaffMemberPronounPage(uid);
    });
    // Change staff pronoun handler
    $(".change-staff-pronoun-container").on("click", ".change-staff-pronoun-button", async function() {
        let parent = $(".change-staff-pronoun-container");
        let pronoun = parent.find(".change-staff-pronoun-select").val();
        let uid = parent.data("uid");
        await $70adc4a1fd111893$var$getChangeStaffMemberPronounRequest(uid, pronoun);
    });
    // Open 'change staff appearance' page
    $staffMemberDetails.on("click", "#change-staff-appearance-menu-button", async function() {
        let uid = $(".staff-member-details").data("uid");
        await $70adc4a1fd111893$var$loadChangeStaffMemberAppearancePage(uid);
    });
    // Change staff appearance handler
    $(".change-staff-appearance-container").on("click", ".change-staff-appearance-button", async function() {
        let parent = $(".change-staff-appearance-container");
        let uid = parent.data("uid");
        parent.find("#change-staff-appearance-graphic-container .share-character").trigger("click").removeClass("selected");
        parent.find("#change-staff-appearance-graphic-container .share-character-code-container").hide();
        let graphic = $("#change-staff-appearance-graphic-container .share-character-code-input").val();
        await $70adc4a1fd111893$var$getChangeStaffMemberGraphicRequest(uid, graphic);
    });
    // Transition to superstar handler
    $staffMemberDetails.on("click", "#transition-staff-to-talent-button", async function() {
        let uid = $(".staff-member-details").data("uid");
        let staffMemberName = $(".staff-member-name").text();
        await (0, $d3e44747ec383890$export$eb0e5b221232766e)(uid, "staff", staffMemberName, "transition (talent)");
    });
    // Cancel staff task handler
    $staffMemberDetails.on("click", "#cancel-staff-member-task-button", async function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                let uid = $(".staff-member-details").data("uid");
                await $70adc4a1fd111893$var$getCancelStaffMemberTaskRequest(uid);
            }
        });
    });
    // Back to staff member handler
    $(".change-staff-name-container, .change-staff-pronoun-container, .change-staff-appearance-container").on("click", ".back-to-staff-member-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        // Reload graphic if coming back from 'change appearance' page
        if ($(".change-staff-appearance-container").is(":visible")) {
            let graphic = $(".staff-member-details").data("graphic");
            $(".staff-member-graphic").html("");
            let el = $staffMemberDetails.find(".staff-member-graphic");
            (0, $c82cd471f4baff6b$export$619533229dc4b088)(graphic, el);
        }
        $(".change-staff-name-container, .change-staff-pronoun-container, .change-staff-appearance-container").hide();
        $staffMemberDetails.fadeIn();
    });
    // Upgrade facility handler
    $(".company-facilities-container").on("click", "#upgrade-facility-button", async function() {
        let uid = parseInt($(this).closest(".facility-item").attr("data-uid"));
        let facilityItemElement = $(this).closest(".facility-item");
        await $70adc4a1fd111893$var$getUpgradeCompanyFacilityRequest(uid, facilityItemElement);
    });
    // Select year for yearly rankings history
    $("#yearly-rankings-container").on("change", ".yearly-rankings-year-select", async function() {
        let year = parseInt($(this).val());
        await $70adc4a1fd111893$export$d43b059220da65ff(year);
    });
    // Select iteration for annual tournament history
    const $annualTournamentHistoryContainer = $("#annual-tournament-history-container");
    $annualTournamentHistoryContainer.on("change", ".annual-tournament-iteration-select", async function() {
        let iteration = parseInt($(this).val());
        await $70adc4a1fd111893$export$9b13a1ad71568d7b(iteration);
    });
    // View annual tournament stats
    $annualTournamentHistoryContainer.on("click", ".view-annual-tournament-stats-button", async function() {
        await $70adc4a1fd111893$var$loadViewAnnualTournamentStatsPage();
    });
    // Go back from annual tournament stats
    $("#annual-tournament-stats-container").on("click", ".annual-tournament-stats-back-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideContent)($());
        $("#annual-tournament-history-container").fadeIn("slow");
    });
    // View annual tournament poster
    $annualTournamentHistoryContainer.on("click", ".view-annual-tournament-poster-button", async function() {
        let annualTournamentUid = parseInt($(this).data("uid"));
        await $70adc4a1fd111893$var$loadViewEventPosterPage(null, annualTournamentUid);
    });
    // Go back from viewing poster
    $game.on("click", ".event-poster-back-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        let elementToShow = $("#event-history-poster-container").data("previousElement");
        (0, $1JSre.hideContent)($());
        $(elementToShow).fadeIn("slow");
    });
    // View used special segment
    $("#special-segments-box").on("click", ".view-special-segment", async function() {
        let uid = parseInt($(this).attr("data-uid"));
        await $70adc4a1fd111893$var$loadViewUsedSpecialSegmentPage(uid);
    });
    // Back to special segments page
    $("#match").on("click", "#back-to-special-segments-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideContent)($());
        $("#special-segments-box").fadeIn("slow");
    });
    // Change run weekly shows option
    const $gameOptionsContainer = $("#game-options-container");
    $gameOptionsContainer.on("change", 'select[name="number-of-weekly-shows-option"]', async function() {
        let value = parseInt($(this).val());
        let $el = $(this);
        await $70adc4a1fd111893$var$changeNumberOfWeeklyShowsRequest(value, $el);
    });
    // Change user setting
    $gameOptionsContainer.on("change", 'input[value="show_event_preview"], input[value="load_favorite_community_segments"]', async function() {
        let settingName = $(this).attr("data-name");
        let settingValue = $(this).prop("checked");
        await $70adc4a1fd111893$export$3079987a80f5136b(settingName, settingValue);
    });
    // Change game setting
    $gameOptionsContainer.on("change", 'input[name="competitor-difficulty-option"], .toggleable-game-setting', async function() {
        let settingName;
        let settingValue;
        if ($(this).hasClass("toggleable-game-setting")) {
            settingValue = $(this).prop("checked");
            settingName = $(this).val();
        } else {
            settingValue = $(this).val();
            settingName = "competitor_difficulty";
        }
        await $70adc4a1fd111893$export$a8834e9c186723b7(settingName, settingValue);
    });
    // Save to cloud
    $gameOptionsContainer.on("click", ".save-to-cloud-button", async function() {
        await (0, $993642189aedf295$export$d3ab5fe070517e4f)(true, true);
    });
    // Download save
    $gameOptionsContainer.on("click", ".download-save-button", async function() {
        notie.confirm({
            text: "Downloading your save allows you to back it up locally. However, importing downloaded saves isn't supported yet. Continue?",
            submitCallback: async function() {
                await (0, $993642189aedf295$export$2fadf1979583e1b6)();
            },
            cancelText: "No"
        });
    });
    let $eventHistoryContainer = $("#event-history-container");
    // View event company select
    $eventHistoryContainer.on("change", ".select-company-for-view-events", async function() {
        let companyUid = parseInt($(this).find(":selected").attr("data-uid"));
        await $70adc4a1fd111893$export$11eb91805ca2797e(companyUid);
    });
    // Next event handler
    $eventHistoryContainer.on("click", ".event-history-previous-event-button", async function() {
        let eventUid = $("#event-details").data("previousEventId");
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr("data-uid"));
        await $70adc4a1fd111893$export$11eb91805ca2797e(companyUid, eventUid);
    });
    // Previous event handler
    $eventHistoryContainer.on("click", ".event-history-next-event-button", async function() {
        let eventUid = $("#event-details").data("nextEventId");
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr("data-uid"));
        await $70adc4a1fd111893$export$11eb91805ca2797e(companyUid, eventUid);
    });
    // Year select handler
    $eventHistoryContainer.on("change", ".select-year-for-view-events", async function() {
        let eventUid = parseInt($(this).find(":selected").attr("data-uid"));
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr("data-uid"));
        await $70adc4a1fd111893$export$11eb91805ca2797e(companyUid, eventUid);
    });
    // View event calendar handler
    $eventHistoryContainer.on("click", ".event-history-calendar-button", async function() {
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr("data-uid"));
        await $70adc4a1fd111893$var$loadViewEventCalendarPage(companyUid);
    });
    // View event from calendar
    $(".event-calendar-box").on("click", async function() {
        // Get latest child event
        let eventUid = $(this).find(".event-calendar-name").data("latestChildEventUid");
        // If not held, get parent event
        if (!eventUid) eventUid = $(this).find(".event-calendar-name").data("uid");
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr("data-uid"));
        await $70adc4a1fd111893$export$11eb91805ca2797e(companyUid, eventUid);
    });
    // View event poster
    $eventHistoryContainer.on("click", ".view-event-poster-button", async function() {
        let eventUid = $("#event-details").data("uid");
        await $70adc4a1fd111893$var$loadViewEventPosterPage(eventUid, null);
    });
    // Show rebrand event page
    $eventHistoryContainer.on("click", "#rebrand-event-menu-button", async function() {
        let element = $(".rebrand-event-container");
        let selectedEvent = $("#event-history-container .event-history-name").text();
        await $70adc4a1fd111893$var$loadRebrandEventPage(selectedEvent, element);
    });
    // Set brand dropdown upon changing rebrand event's event select
    $(".rebrand-event-container").on("change", ".rebrand-event-event-select", function() {
        let selected = $(this).find(":selected");
        let parent = $(this).closest(".rebrand-event-container");
        // Select brand
        if ((0, $98xmD.globalUser).paid) {
            if (!selected.data("weekly-show")) {
                let brandName = selected.data("brand-name");
                parent.find(".rebrand-event-brand-select").val(brandName);
                parent.find(".rebrand-event-brand-select").parent().show();
            } else parent.find(".rebrand-event-brand-select").parent().hide();
        } else parent.find(".rebrand-event-brand-select").parent().hide();
    });
    // Rebrand event handler
    $game.on("click", "#rebrand-event-button", async function() {
        const $rebrandEventEventSelect = $(".rebrand-event-container .rebrand-event-event-select");
        let uid = $rebrandEventEventSelect.find(":selected").data("uid");
        let weeklyShow = $rebrandEventEventSelect.find(":selected").data("weekly-show");
        let name = $(".rebrand-event-container .rebrand-event-name-input").val();
        let brandName = $(".rebrand-event-container .rebrand-event-brand-select").val();
        await $70adc4a1fd111893$var$rebrandEventRequest(uid, name, weeklyShow, brandName);
    });
    // Go back to view events
    $game.on("click", ".back-to-view-events-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideContent)($());
        $("#event-history-container").fadeIn("slow");
    });
    // Event prestige effects button handler
    $(".event-prestige-effects-more").on("click", function() {
        if ($(this).find("i").hasClass("fa-angle-down")) {
            $(".event-prestige-effects-container").slideDown();
            $(this).find("i").removeClass("fa-angle-down");
            $(this).find("i").addClass("fa-angle-up");
        } else {
            $(".event-prestige-effects-container").slideUp();
            $(this).find("i").addClass("fa-angle-down");
            $(this).find("i").removeClass("fa-angle-up");
        }
    });
    // Show feud history
    const $feudHistoryContainer = $("#feud-history-container");
    $feudHistoryContainer.on("click", ".feud-history-item", async function() {
        let $el = $(this);
        // Deselect
        if ($el.hasClass("selected")) {
            // Show all feuds
            $(".feud-history").html("").hide();
            $(".current-feuds").children().show();
            $(".potential-feuds").children().show();
            $(".past-feuds").children().show();
            $el.removeClass("selected");
            $(".feuds-history-search-input").val("");
            // Tutorial action check
            (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("unselect_feud_history_item");
        } else {
            let uid = parseInt($el.attr("data-uid"));
            await $70adc4a1fd111893$var$loadViewFeudHistoryPage(uid, $el);
        }
    });
    // End feud
    $feudHistoryContainer.on("click", "#end-feud-button", async function(e) {
        e.stopPropagation();
        let $el = $(this);
        notie.confirm({
            text: "Are you sure you want to end this Feud?",
            submitCallback: async function() {
                let parentElement = $el.closest(".feud-history-item");
                let uid = parseInt(parentElement.attr("data-uid"));
                await $70adc4a1fd111893$var$getEndFeudRequest(uid);
            },
            cancelText: "No"
        });
    });
    // Create feud button handler
    $game.on("click", "#create-feud-menu-button", async function() {
        // Load participants and feud items
        let defaultParticipantValue = "singles";
        $(".create-feud-participant-type-select").val(defaultParticipantValue);
        if (!(0, $98xmD.globalUser).paid) $('.create-feud-participant-type-select option[value="faction"]').remove();
        await $70adc4a1fd111893$var$loadCreateFeudPage(defaultParticipantValue, [], true, true);
    });
    // Get participants for create feud
    const $createFeud = $("#create-feud");
    $createFeud.on("change", ".create-feud-participant-type-select", async function() {
        let participantType = $(this).val();
        await $70adc4a1fd111893$var$loadCreateFeudPage(participantType, [], true);
    });
    // Get feud items for create feud
    $createFeud.on("change", ".create-feud-first-participant-select, .create-feud-second-participant-select", async function() {
        const $firstParticipantSelect = $(".create-feud-first-participant-select");
        const $secondParticipantSelect = $(".create-feud-second-participant-select");
        let firstParticipantUid = parseInt($firstParticipantSelect.find(":selected").attr("data-uid"));
        let secondParticipantUid = parseInt($secondParticipantSelect.find(":selected").attr("data-uid"));
        if (firstParticipantUid && secondParticipantUid) {
            let participantUids = [
                firstParticipantUid,
                secondParticipantUid
            ];
            let participantType = $(".create-feud-participant-type-select").find(":selected").val();
            await $70adc4a1fd111893$var$loadCreateFeudPage(participantType, participantUids, false);
        }
        // Tutorial action check
        if ($firstParticipantSelect.val() === "Johnny Knight") (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_first_feud_superstar");
        if ($secondParticipantSelect.val() === "Joe Hammer") (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_second_feud_superstar");
    });
    // Select feud item for create feud
    $createFeud.on("click", ".feud-item-container", function() {
        // Don't run for disabled feud item
        if ($(this).hasClass("disabled")) return false;
        let $this = $(this);
        if ($this.hasClass("selected")) {
            // Deselect this feud item
            $this.removeClass("selected");
            // Show all feud items
            $("#create-feud .feud-item-container").show();
        } else {
            // Unselect other feud items
            $("#create-feud .feud-item-container.selected").removeClass("selected");
            // Select this feud item
            $this.addClass("selected");
            // Hide all other feud items
            $("#create-feud .feud-item-container:not(.selected)").hide();
        }
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_create_feud_item");
    });
    // Create feud button
    $createFeud.on("click", "#create-feud-button", async function() {
        let firstParticipantUid = parseInt($(".create-feud-first-participant-select").find(":selected").attr("data-uid"));
        let secondParticipantUid = parseInt($(".create-feud-second-participant-select").find(":selected").attr("data-uid"));
        let participantUids = [
            firstParticipantUid,
            secondParticipantUid
        ];
        let participantType = $(".create-feud-participant-type-select").find(":selected").val();
        let feudItemSelected = $("#create-feud .feud-item-container.selected");
        let feudItemUid = parseInt(feudItemSelected.attr("data-uid"));
        let customFeudName = feudItemSelected.find(".feud-item-custom-name").val();
        // Validate
        if (feudItemSelected.length <= 0) {
            notie.alert({
                type: 3,
                text: "Feud Item not selected.",
                stay: true
            });
            return;
        }
        if (!firstParticipantUid || !secondParticipantUid) {
            notie.alert({
                type: 3,
                text: "Participants not selected.",
                stay: true
            });
            return;
        }
        await $70adc4a1fd111893$var$getCreateFeudRequest(feudItemUid, customFeudName, participantUids, participantType);
    });
    // Custom feud name click
    const $feudItemsContainerAndCreateFeud = $("#feud-items-container, #create-feud");
    $feudItemsContainerAndCreateFeud.on("click", ".feud-item-custom-name", function(e) {
        e.stopPropagation();
    });
    $createFeud.on("input", "#create-feud-custom-name", function() {
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("enter_feud_name");
    });
    // Generate feud name hover, remove parent hover
    $feudItemsContainerAndCreateFeud.on("mouseover", ".generate-feud-name-icon", function() {
        $(this).closest(".feud-item-container").addClass("not-hovered");
    }).on("mouseout", ".generate-feud-name-icon", function() {
        $(this).closest(".feud-item-container").removeClass("not-hovered");
    });
    // Generate Feud Name
    $feudItemsContainerAndCreateFeud.on("click", ".generate-feud-name-icon", function(e) {
        e.stopPropagation();
        let $el = $(this);
        let previousName;
        if ($el.closest("#feud-items-container").length > 0) previousName = $("#feud-items-container-custom-name").val();
        if ($el.closest("#create-feud").length > 0) previousName = $("#create-feud-custom-name").val();
        let feudName = (0, $cXLSF.generateRandomFeudItemName)(previousName);
        $el.closest(".feud-item-container").find(".feud-item-custom-name").val(feudName).trigger("input");
    });
    // Custom feud name spacing
    $(function() {
        const $feudItemsContainerCustomNameHide = $("#feud-items-container-custom-name-hide");
        const $feudItemsContainerCustomName = $("#feud-items-container-custom-name");
        $feudItemsContainerCustomNameHide.text($feudItemsContainerCustomName.val());
        $feudItemsContainerCustomName.width($feudItemsContainerCustomNameHide.width());
    }).on("input", function() {
        const $feudItemsContainerCustomNameHide = $("#feud-items-container-custom-name-hide");
        const $feudItemsContainerCustomName = $("#feud-items-container-custom-name");
        $feudItemsContainerCustomNameHide.text($feudItemsContainerCustomName.val());
        $feudItemsContainerCustomName.width($feudItemsContainerCustomNameHide.width() + 12);
    });
    $(function() {
        const $createFeudCustomNameHide = $("#create-feud-custom-name-hide");
        const $createFeudCustomName = $("#create-feud-custom-name");
        $createFeudCustomNameHide.text($createFeudCustomName.val());
        $createFeudCustomName.width($createFeudCustomNameHide.width());
    }).on("input", function() {
        const $createFeudCustomNameHide = $("#create-feud-custom-name-hide");
        const $createFeudCustomName = $("#create-feud-custom-name");
        $createFeudCustomNameHide.text($createFeudCustomName.val());
        $createFeudCustomName.width($createFeudCustomNameHide.width() + 12);
    });
    // Go back to view feuds
    $createFeud.on("click", "#back-to-view-feuds-button", function() {
        $("#view-feuds-menu-button").trigger("click");
    });
    // Sort feuds
    $(".feuds-history-sort").on("change", function() {
        let value = $(this).val();
        $70adc4a1fd111893$var$applyFeudsHistorySort(value);
    });
    // Change feud sort order
    $(".feuds-history-sort-order").on("click", function() {
        let icon = $(this).find("i");
        let sortedElements = $(".feud-history-item").get().reverse();
        // Reverse superstar elements
        if (icon.hasClass("fa-sort-up")) icon.removeClass("fa-sort-up").addClass("fa-sort-down");
        else if (icon.hasClass("fa-sort-down")) icon.removeClass("fa-sort-down").addClass("fa-sort-up");
        sortedElements.forEach(function(e) {
            $(e).parent().append(e);
        });
    });
    // Search feuds
    $(".feuds-history-search-input").on("input", function() {
        $70adc4a1fd111893$var$runFeudHistorySearch();
    });
    // View stats company select
    const $companyStatsContainer = $("#company-stats-container");
    $companyStatsContainer.on("change", ".select-company-for-view-stats", async function() {
        let companyUid = parseInt($(this).find(":selected").attr("data-uid"));
        await $70adc4a1fd111893$export$dc8337a6ea2458f6(companyUid);
    });
    // View stats brand select
    $companyStatsContainer.on("click", ".company-stats-brand-filter", async function(e) {
        let parent = $(this).parent();
        let companyUid = parseInt($(".select-company-for-view-stats").find(":selected").attr("data-uid"));
        if ($(this).hasClass("selected")) {
            $(this).removeClass("selected");
            await $70adc4a1fd111893$export$dc8337a6ea2458f6(companyUid);
        } else {
            parent.find(".company-stats-brand-filter").removeClass("selected");
            $(this).addClass("selected");
            await $70adc4a1fd111893$export$dc8337a6ea2458f6(companyUid, $(this).text());
        }
    });
    // Load add gimmick match page
    const $addGimmickMatch = $("#add-gimmick-match");
    $("#view-gimmick-matches-container").on("click", "#add-gimmick-match-menu-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        // Reset inputs
        $("#add-gimmick-match").find("input").val("");
        $addGimmickMatch.find('select[name="match-rating-boost"], select[name="match-popularity-boost"], select[name="match-injury-rate"]').val("1");
        $addGimmickMatch.find('select[name="match-rules"]').val("");
        $addGimmickMatch.find('select[name="match-consequence"]').val("").trigger("change");
        $addGimmickMatch.find('select[name="match-graphic"]').parent().show();
        $addGimmickMatch.find('select[name="match-add-random-weapons"]').parent().show();
        $addGimmickMatch.find('select[name="match-graphic"]').val("");
        $addGimmickMatch.find('select[name="match-add-random-weapons"]').val("0");
        (0, $1JSre.hideContent)($());
        $addGimmickMatch.fadeIn("slow").removeClass("display-none");
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_add_gimmick_match_menu_button");
    });
    // Load remove gimmick match page
    $game.on("click", "#remove-gimmick-match-menu-button", async function() {
        await $70adc4a1fd111893$var$loadRemoveGimmickMatchesPage();
    });
    // Go back to view gimmick matches
    $game.on("click", ".back-to-view-gimmick-matches-button", function() {
        $("#view-gimmick-matches-menu-button").trigger("click");
    });
    // Add gimmick match
    $("#add-gimmick-match").on("click", "#add-gimmick-match-button", async function() {
        await $70adc4a1fd111893$var$getAddGimmickMatchRequest();
    });
    // Remove gimmick match
    $("#remove-gimmick-match").on("click", "#remove-gimmick-match-button", async function() {
        let name = $("#remove-gimmick-match .select-gimmick-match").val();
        await $70adc4a1fd111893$var$getRemoveGimmickMatchRequest(name);
    });
    // Show gimmick match consequences
    $addGimmickMatch.on("change", "select[name='match-consequence']", function() {
        $(this).parent().siblings(".match-cashin-contract-name-container, .match-contract-name-container").addClass("display-none").removeClass("display-block");
        if ($(this).val() === "cashin_contract") $(this).parent().siblings(".match-cashin-contract-name-container").addClass("display-block").removeClass("display-none");
        else if ($(this).val() === "match_contract") $(this).parent().siblings(".match-contract-name-container").addClass("display-block").removeClass("display-none");
        // Tutorial action check
        if ($(this).val() === "match_contract") (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_gimmick_match_consequence");
    });
    // Add custom segment menu button
    $("#view-segments-container").on("click", "#add-custom-segment-menu-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideContent)($());
        const $addCustomSegmentContainer = $(".add-custom-segment-container");
        const $addCustomSegmentHelpTextContainer = $(".add-custom-segment-help-text-container");
        const $addCustomSegmentHelpButton = $(".add-custom-segment-help-button");
        (0, $9f0f3c0f4508366a$export$4acf80557bedaca3).addCustomSegmentChangesMade = false;
        $addCustomSegmentContainer.removeClass("scroll margin-top-20").fadeIn("slow");
        // Reset
        $(".add-custom-segment-template-button:contains('Basic')").trigger("click");
        $(".add-custom-segment-more-options").hide();
        let customSegmentMoreOptionsButton = $(".add-custom-segment-more-options-button");
        customSegmentMoreOptionsButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        customSegmentMoreOptionsButton.find("span").text("Show Details");
        $(".import-community-segment-input").val("");
        $(".add-custom-segment-community-segments-container").hide();
        let customSegmentCommunitySegmentsButton = $(".add-custom-segment-show-community-segments-button");
        customSegmentCommunitySegmentsButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        customSegmentCommunitySegmentsButton.find("span").text("Show Community Segments");
        // Show save options
        $(".add-custom-segment-save-to-game-container").show();
        $(".add-custom-segment-save-to-community-container").show();
        // Hide edit info
        $(".edit-custom-segment-button").hide();
        $(".add-custom-segment-button").show();
        $(".add-custom-segment-label").text("Add Custom Segment");
        $addCustomSegmentHelpTextContainer.hide();
        let customSegmentHelpButton = $addCustomSegmentHelpButton;
        customSegmentHelpButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        customSegmentHelpButton.find("span").text("Show How It Works");
        // Disable if free user
        if (!(0, $98xmD.globalUser).paid) {
            $addCustomSegmentContainer.addClass("disabled");
            $addCustomSegmentContainer.find("input, textarea").prop("disabled", true);
            $addCustomSegmentContainer.addClass("help-text");
            $addCustomSegmentContainer.attr("title", "JoW Paid includes Custom Segments");
            $addCustomSegmentHelpTextContainer.hide();
            let customSegmentHelpButton = $addCustomSegmentHelpButton;
            customSegmentHelpButton.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
            customSegmentHelpButton.find("span").text("Show How It Works");
        } else {
            $addCustomSegmentContainer.removeClass("help-text");
            $addCustomSegmentContainer.removeAttr("title");
            $addCustomSegmentContainer.removeClass("disabled");
            $addCustomSegmentContainer.find("input, textarea").prop("disabled", false);
        }
    });
    // Edit custom segment menu button
    $game.on("click", "#edit-custom-segment-menu-button", async function() {
        await (0, $9f0f3c0f4508366a$export$8df32dfa0ef2b566)();
    });
    // Load edit custom segment page
    const $editCustomSegmentContainer = $(".edit-custom-segment-container");
    $editCustomSegmentContainer.on("click", "#edit-custom-segment-container-button", async function(e) {
        let name = $(".edit-custom-segment-container .select-custom-segment").val();
        await (0, $9f0f3c0f4508366a$export$e18684635e7ffd2a)(name);
    });
    // Remove custom segment
    $editCustomSegmentContainer.on("click", "#remove-custom-segment-button", async function(e) {
        let name = $(".edit-custom-segment-container .select-custom-segment").val();
        await (0, $9f0f3c0f4508366a$export$41cb77bdd57b7c8e)(name);
    });
    // Add custom segment
    $(".add-custom-segment-button").on("click", async function() {
        await (0, $9f0f3c0f4508366a$export$8c2d543f58db4718)();
    });
    // Edit custom segment
    $(".edit-custom-segment-button").on("click", async function() {
        await (0, $9f0f3c0f4508366a$export$2302c60aede2b155)();
    });
    // Go back to view segments
    $game.on("click", ".back-to-view-segments-button", function() {
        $("#view-segments-menu-button").trigger("click");
    });
    // Custom segment preview
    const $addCustomSegmentContainer = $(".add-custom-segment-container");
    $addCustomSegmentContainer.on("click", ".add-custom-segment-preview-singles-button, .add-custom-segment-preview-tag-button", function() {
        // Disabled if add custom segment disabled
        if ($addCustomSegmentContainer.hasClass("disabled")) return false;
        $(".add-custom-segment-preview-buttons-container .button").removeClass("selected");
        $(this).addClass("selected");
        let name = $(".add-custom-segment-name-input").val();
        let startText = $(".add-custom-segment-start-text").val();
        let actionTextInputs = $(".add-custom-segment-action-text").filter(function() {
            return !!this.value;
        });
        let actionText = $((0, $3E8Nt.getRandomChoice)(actionTextInputs)).val();
        let numberOfParticipants = parseInt($(".add-custom-segment-participants-input").val());
        // Validate
        if (!name) {
            notie.alert({
                type: 3,
                text: "Enter a name for the Segment"
            });
            return false;
        }
        if (!startText) {
            notie.alert({
                type: 3,
                text: "Enter a Start Text for the Segment"
            });
            return false;
        }
        if (!actionText) {
            notie.alert({
                type: 3,
                text: "Enter an Action Text for the Segment"
            });
            return false;
        }
        let dataType;
        let participants;
        if ($(this).hasClass("add-custom-segment-preview-tag-button")) {
            dataType = "tag";
            participants = (0, $1JSre.previewSegmentTagParticipants);
        } else {
            dataType = "singles";
            participants = (0, $1JSre.previewSegmentSinglesParticipants);
        }
        // Get tag inputs if entered
        if (dataType === "tag") {
            let tagStartText = $(".add-custom-segment-tag-start-text").val();
            if (tagStartText) startText = tagStartText;
            let tagActionTextInputs = $(".add-custom-segment-tag-action-text").filter(function() {
                return !!this.value;
            });
            let tagActionText = $((0, $3E8Nt.getRandomChoice)(tagActionTextInputs)).val();
            if (tagActionText) actionText = tagActionText;
        }
        // Get random participant objects based on number of participants
        (0, $3E8Nt.shuffle)(participants);
        participants = participants.slice(0, numberOfParticipants);
        let chooseWinner = $('input[name="add-custom-segment-choose-winner-option"]:checked').val() === "yes";
        let nameElement = $(".add-custom-segment-preview-name");
        let startTextElement = $(".add-custom-segment-preview-start-text");
        let actionTextElement = $(".add-custom-segment-preview-action-text");
        (0, $9f0f3c0f4508366a$export$d4aaf9912fff13e)(name, startText, actionText, participants, chooseWinner, nameElement, startTextElement, actionTextElement);
        // Select winner
        $addCustomSegmentContainer.off("click", ".match-wrestler");
        $addCustomSegmentContainer.on("click", ".match-wrestler", function() {
            let name = $(this).text();
            // Put winner first in participants
            participants.sort(function(x, y) {
                return x.name === name ? -1 : y.name === name ? 1 : 0;
            });
            // Show action text
            actionText = (0, $9f0f3c0f4508366a$export$5a6dd4c6a40e1acc)(actionText, participants);
            $(".add-custom-segment-preview-action-text").html(actionText).hide().fadeIn(500);
        });
    });
    // Show more options
    $(".add-custom-segment-more-options-button").on("click", function() {
        // Disabled if add custom segment disabled
        if ($addCustomSegmentContainer.hasClass("disabled")) return false;
        let el = $(this);
        if (el.find("i").hasClass("fa-angle-down")) $(".add-custom-segment-more-options").slideDown(function() {
            el.find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
            el.find("span").text("Hide Details");
        });
        else $(".add-custom-segment-more-options").slideUp(function() {
            el.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
            el.find("span").text("Show Details");
        });
    });
    // Show help
    $(".add-custom-segment-help-button").on("click", function() {
        // Disabled if add custom segment disabled
        if ($addCustomSegmentContainer.hasClass("disabled")) return false;
        let el = $(this);
        if (el.find("i").hasClass("fa-angle-down")) $(".add-custom-segment-help-text-container").slideDown(function() {
            el.find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
            el.find("span").text("Hide How It Works");
        });
        else $(".add-custom-segment-help-text-container").slideUp(function() {
            el.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
            el.find("span").text("See How It Works");
        });
    });
    // Change cost if changing save to game option
    $("input[name='add-custom-segment-save-to-game-option']").on("change", function() {
        let value = $(this).val();
        if (value === "yes") $(".add-custom-segment-cost").text(30);
        else $(".add-custom-segment-cost").text(0);
    });
    // Add custom segment action text inputs
    $addCustomSegmentContainer.on("click", ".add-custom-segment-add-action-text-button, .add-custom-segment-remove-action-text-button", function() {
        // Disabled if add custom segment disabled
        if ($addCustomSegmentContainer.hasClass("disabled")) return false;
        // Add input
        const $addCustomSegmentActionText = $(".add-custom-segment-action-text");
        if ($(this).hasClass("add-custom-segment-add-action-text-button")) {
            // Don't allow more than 8 inputs
            if ($addCustomSegmentActionText.length > 8) {
                notie.alert({
                    type: 3,
                    text: "You can't have more than 8 action texts"
                });
                return false;
            }
            $addCustomSegmentActionText.last().after('<textarea class="add-custom-segment-action-text styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>');
        } else {
            // Don't allow less than 1 input
            if ($addCustomSegmentActionText.length <= 1) {
                notie.alert({
                    type: 3,
                    text: "You can't have less than 1 action text"
                });
                return false;
            }
            $addCustomSegmentActionText.last().remove();
        }
    });
    // Add custom segment tag action text inputs
    $addCustomSegmentContainer.on("click", ".add-custom-segment-tag-add-action-text-button, .add-custom-segment-tag-remove-action-text-button", function() {
        // Disabled if add custom segment disabled
        if ($(".add-custom-segment-container").hasClass("disabled")) return false;
        // Add input
        const $addCustomSegmentTagActionText = $(".add-custom-segment-tag-action-text");
        if ($(this).hasClass("add-custom-segment-tag-add-action-text-button")) {
            // Don't allow more than 8 inputs
            if ($addCustomSegmentTagActionText.length > 8) {
                notie.alert({
                    type: 3,
                    text: "You can't have more than 8 action texts"
                });
                return false;
            }
            $addCustomSegmentTagActionText.last().after('<textarea class="add-custom-segment-tag-action-text styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>');
        } else {
            // Don't allow less than 1 input
            if ($addCustomSegmentTagActionText.length <= 1) {
                notie.alert({
                    type: 3,
                    text: "You can't have less than 1 action text"
                });
                return false;
            }
            $addCustomSegmentTagActionText.last().remove();
        }
    });
    // Copy start/action texts to tag textareas
    $(".add-custom-segment-copy-start-text-button").on("click", function() {
        // Disabled if add custom segment disabled
        if ($(".add-custom-segment-container").hasClass("disabled")) return false;
        let startText = $(".add-custom-segment-start-text").val();
        $(".add-custom-segment-tag-start-text").val(startText);
    });
    $(".add-custom-segment-copy-action-text-button").on("click", function() {
        // Disabled if add custom segment disabled
        if ($(".add-custom-segment-container").hasClass("disabled")) return false;
        $(".add-custom-segment-tag-action-text").each(function(i, el) {
            let actionText = $(".add-custom-segment-action-text").eq(i).val();
            $(this).val(actionText);
        });
    });
    // Check for changes made
    $(".add-custom-segment-name-input, .add-custom-segment-participants-input, .add-custom-segment-start-text, .add-custom-segment-action-text, .add-custom-segment-tag-start-text, .add-custom-segment-tag-action-text").on("change", function() {
        (0, $9f0f3c0f4508366a$export$4acf80557bedaca3).addCustomSegmentChangesMade = true;
        // Deselect community segment result
        $(".community-segments-box").find(".community-segments-search-result-item.selected").removeClass("selected");
    });
    // Load templates
    $(".add-custom-segment-template-button").on("click", function() {
        // Disabled if add custom segment disabled
        if ($(".add-custom-segment-container").hasClass("disabled")) return false;
        let el = $(this);
        if ((0, $9f0f3c0f4508366a$export$4acf80557bedaca3).addCustomSegmentChangesMade) notie.confirm({
            text: "Are you sure? Any existing data will be overwritten.",
            submitCallback: function() {
                (0, $9f0f3c0f4508366a$export$fd83d02ab0fd7d2)(el);
            }
        });
        else (0, $9f0f3c0f4508366a$export$fd83d02ab0fd7d2)(el);
    });
    // Import segment
    $addCustomSegmentContainer.on("click", ".import-community-segment-button", function() {
        if ((0, $98xmD.globals).requestRunning) return;
        // Disabled if add custom segment disabled
        if ($(".add-custom-segment-container").hasClass("disabled")) return false;
        let el = $(this);
        let uid = el.siblings(".import-community-segment-input").val();
        if (!uid) {
            notie.alert({
                type: 3,
                text: "Enter a code to import"
            });
            return false;
        }
        // Deselect community segment result
        $(".community-segments-box").find(".community-segments-search-result-item.selected").removeClass("selected");
        if ((0, $9f0f3c0f4508366a$export$4acf80557bedaca3).addCustomSegmentChangesMade) notie.confirm({
            text: "Are you sure? Any existing data will be overwritten.",
            submitCallback: function() {
                (0, $c4630e829f7e74ef$export$2b6d0d77974d29f2)(el, uid);
            }
        });
        else (0, $c4630e829f7e74ef$export$2b6d0d77974d29f2)(el, uid);
    });
    // Trigger import on enter key press
    $(".import-community-segment-input").keypress(function(e) {
        if (e.which === 13) $(".import-community-segment-button").trigger("click");
    });
    // Show community segments
    $(".add-custom-segment-show-community-segments-button").on("click", function() {
        // Disabled if add custom segment disabled
        if ($(".add-custom-segment-container").hasClass("disabled")) return false;
        let el = $(this);
        if (el.find("i").hasClass("fa-angle-down")) {
            // Show 'new' segments
            $(".add-custom-segment-community-segments-container").find('.community-segments-sort-button[data-value="new"]').trigger("click");
            $(".add-custom-segment-community-segments-container").slideDown(function() {
                el.find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
                el.find("span").text("Hide Community Segments");
            });
        } else $(".add-custom-segment-community-segments-container").slideUp(function() {
            el.find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
            el.find("span").text("Show Community Segments");
        });
    });
    // Select community segment result
    $addCustomSegmentContainer.on("click", ".community-segments-search-result-item", function() {
        if ((0, $98xmD.globals).requestRunning) return;
        let parent = $(".community-segments-box");
        // Select this element
        parent.find(".community-segments-search-result-item.selected").removeClass("selected");
        $(this).addClass("selected");
        let el = $(this);
        let uid = el.data("uid");
        if ((0, $9f0f3c0f4508366a$export$4acf80557bedaca3).addCustomSegmentChangesMade) notie.confirm({
            text: "Are you sure? Any existing data will be overwritten.",
            submitCallback: function() {
                (0, $c4630e829f7e74ef$export$2b6d0d77974d29f2)(el, uid);
            }
        });
        else (0, $c4630e829f7e74ef$export$2b6d0d77974d29f2)(el, uid);
    });
    // View titles company select
    $("#titles-box").on("change", ".select-company-for-view-titles", async function() {
        let companyUid = parseInt($(this).find(":selected").attr("data-uid"));
        await $70adc4a1fd111893$export$c37f99627b0b98ac(companyUid);
    });
    // Show add championship page
    $game.on("click", "#add-championship-menu-button", async function() {
        await $70adc4a1fd111893$var$loadAddChampionshipPage();
    });
    // Populate talent select for add championship page
    $game.on("change", ".add-championship-division", async function() {
        // Populate champion select
        let value = $(this).val();
        if (value === "tag-team") value = "tag";
        let talentData = await (0, $cXLSF.getAllTalentData)(value);
        let $championshipChampion = $('.add-championship-container select[name="championship-champion"]');
        let championNamesOptions = '<option value="">None</option>';
        talentData.forEach(function(talent) {
            championNamesOptions += '<option value="' + talent["uid"] + '">' + talent["name"] + "</option>";
        });
        $championshipChampion.html(championNamesOptions);
    });
    // Show retire championship page
    $game.on("click", "#retire-championship-menu-button", async function() {
        let $selectElement = $("#retire-championship .select-championship-all");
        let selectedChampionship = $(".company-championship-select").val();
        await $70adc4a1fd111893$var$loadRetireChampionshipPage($selectElement, selectedChampionship);
    });
    // Show vacate championship page
    $game.on("click", "#vacate-championship-menu-button", async function() {
        let $selectElement = $("#vacate-championship .select-championship-all");
        let selectedChampionship = $(".company-championship-select").val();
        await $70adc4a1fd111893$var$loadVacateChampionshipPage($selectElement, selectedChampionship);
    });
    // Show rebrand championship page
    $game.on("click", "#rebrand-championship-menu-button", async function() {
        let $element = $(".rebrand-championship-container");
        let selectedChampionship = $(".company-championship-select").val();
        await $70adc4a1fd111893$var$loadRebrandChampionshipPage($element, selectedChampionship);
    });
    // Show championship points cost
    const $addChampionshipContainer = $(".add-championship-container");
    $addChampionshipContainer.on("change", "select[name=championship-rank]", function() {
        let cost = $70adc4a1fd111893$var$getAddChampionshipCost($(".add-championship-container"));
        $(this).closest(".add-championship-container").find(".add-championship-cost").text(cost);
    });
    // Show/hide championship graphic
    $addChampionshipContainer.on("change", 'select[name="championship-graphic-option"]', function() {
        if ($(this).val() === "0") $(".championship-graphic-container").hide();
        else if ($(this).val() === "1") $(".championship-graphic-container").show();
    });
    // Load title details upon changing title select
    const $rebrandChampionshipContainer = $(".rebrand-championship-container");
    $rebrandChampionshipContainer.on("change", ".rebrand-championship-championship-select", function() {
        let selected = $(this).find(":selected");
        let parent = $(this).closest(".rebrand-championship-container");
        // Get graphic using data attribute
        let graphic = selected.data("graphic");
        if (!graphic) {
            // Default title graphic
            graphic = {
                "centerPlate": {
                    "object": 0,
                    "colors": [
                        "0xC59548"
                    ]
                },
                "strap": {
                    "object": 9,
                    "colors": [
                        "0x1D1D1D"
                    ]
                },
                "sidePlates": {
                    "object": 9,
                    "colors": [
                        "0xC59548"
                    ]
                },
                "centerGems": {
                    "object": 9,
                    "colors": [
                        "0xC51616"
                    ]
                },
                "sideGems": {
                    "object": 9,
                    "colors": [
                        "0xC51616"
                    ]
                }
            };
            parent.find(".rebrand-championship-change-label").text("Add");
        } else parent.find(".rebrand-championship-change-label").text("Change");
        $("#change-championship-graphic").data("key", JSON.stringify(graphic));
        // Load graphic using import code
        parent.find(".load-character-code-input").val(JSON.stringify(graphic));
        parent.find(".load-character-code-button").trigger("click");
        // Get gimmick restriction using data attribute
        let gimmickRestriction = selected.data("gimmickRestriction");
        let gimmickRestrictionType = gimmickRestriction ? gimmickRestriction["type"] : "none";
        // Add gimmick restriction value as default value
        if (gimmickRestrictionType === "gimmick_match") parent.find(".championship-gimmick-match-select").data("default-value", gimmickRestriction["value"]);
        else if (gimmickRestrictionType === "minimum_age") parent.find(".championship-minimum-age-input").data("default-value", gimmickRestriction["value"]);
        else if (gimmickRestrictionType === "maximum_age") parent.find(".championship-maximum-age-input").data("default-value", gimmickRestriction["value"]);
        // Select brand
        if ((0, $98xmD.globalUser).paid) {
            let brandName = selected.data("brandName");
            parent.find(".rebrand-championship-brand-select").val(brandName);
        } else parent.find(".rebrand-championship-brand-select").parent().hide();
        // Trigger change on championship gimmick select
        parent.find(".championship-gimmick-select").val(gimmickRestrictionType).trigger("change");
    });
    // Show/hide championship graphic controls
    $rebrandChampionshipContainer.on("change", 'input[name="radio-change-championship-graphic-option"]', function() {
        let val = $(this).val();
        let parent = $(this).closest(".rebrand-championship-container");
        const $changeChampionshipGraphic = $("#change-championship-graphic");
        if (val === "change") {
            // Load graphic
            let graphic = JSON.parse($changeChampionshipGraphic.data("key"));
            if (!graphic) {
                // Default title graphic
                graphic = {
                    "centerPlate": {
                        "object": 0,
                        "colors": [
                            "0xC59548"
                        ]
                    },
                    "strap": {
                        "object": 9,
                        "colors": [
                            "0x1D1D1D"
                        ]
                    },
                    "sidePlates": {
                        "object": 9,
                        "colors": [
                            "0xC59548"
                        ]
                    },
                    "centerGems": {
                        "object": 9,
                        "colors": [
                            "0xC51616"
                        ]
                    },
                    "sideGems": {
                        "object": 9,
                        "colors": [
                            "0xC51616"
                        ]
                    }
                };
                parent.find(".rebrand-championship-change-label").text("Add");
            }
            (0, $c82cd471f4baff6b$export$3b20358be464ca0c)($changeChampionshipGraphic, [
                graphic
            ]);
            // Show controls
            $changeChampionshipGraphic.next(".character-creator-controls").show();
            $(".sp-replacer").addClass("grey-background");
        } else {
            $changeChampionshipGraphic.html("");
            $changeChampionshipGraphic.next(".character-creator-controls").hide();
        }
    });
    // Go back to view titles
    $game.on("click", ".back-to-view-titles-button", function() {
        $("#view-titles-menu-button").trigger("click");
    });
    // Add championship
    $game.on("click", "#add-championship-button", async function() {
        await $70adc4a1fd111893$var$getAddChampionshipRequest();
    });
    // Retire championship
    $("#retire-championship").on("click", "#retire-championship-button", async function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                let uid = parseInt($("#retire-championship .select-championship-all").find(":selected").data("uid"));
                await $70adc4a1fd111893$var$getRetireChampionshipRequest(uid);
            },
            cancelText: "No"
        });
    });
    // Vacate championship
    $("#vacate-championship").on("click", "#vacate-championship-button", async function() {
        let uid = parseInt($("#vacate-championship .select-championship-all").find(":selected").data("uid"));
        await (0, $1JSre.makeGameRequest)((0, $8A6FL.vacateChampionship), {
            uid: uid
        }, $70adc4a1fd111893$var$showVacateChampionshipData, {}, false);
    });
    // Rebrand championship
    $game.on("click", "#rebrand-championship-button", async function() {
        await $70adc4a1fd111893$var$getRebrandChampionshipRequest();
    });
    // Rebrand company menu button
    $("#view-companies-container").on("click", "#rebrand-company-menu-button", async function() {
        (0, $lCS03.playSoundEffect)("success");
        let element = $(".rebrand-company-container");
        (0, $1JSre.hideContent)($());
        // Reset name input
        element.find(".rebrand-company-name-input").val("");
        element.fadeIn("slow").removeClass("display-none");
    });
    // Rebrand company
    $game.on("click", "#rebrand-company-button", async function() {
        await $70adc4a1fd111893$var$getRebrandCompanyRequest();
    });
    // Go back to view companies
    $game.on("click", ".back-to-view-companies-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideContent)($());
        $("#view-companies-container").fadeIn("slow");
    });
    // Buy powerup
    const $powerupsBox = $("#powerups-box");
    $powerupsBox.on("click", ".buy-powerup", async function() {
        let powerupContainer = $(this).closest(".powerup-container");
        let uid = parseInt(powerupContainer.attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $kpu3X.buyPowerup), {
            uid: uid
        }, $70adc4a1fd111893$var$showBuyPowerupData, {
            powerupContainer: powerupContainer
        }, false);
    });
    // Use powerup
    $powerupsBox.on("click", ".use-powerup", async function() {
        let powerupContainer = $(this).closest(".powerup-container");
        let uid = parseInt(powerupContainer.attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $kpu3X.usePowerup), {
            uid: uid
        }, $70adc4a1fd111893$var$showUsePowerupData, {
            powerupContainer: powerupContainer
        }, false);
    });
    // Cancel powerup
    $powerupsBox.on("click", ".powerup-cancel-button", function() {
        $("#powerups-inventory").children().show();
        let selectedPowerup = $("#powerups-inventory").find(".selected");
        selectedPowerup.removeClass("selected").find(".powerup-bottom").show();
        selectedPowerup.find(".powerup-cancel").hide();
        selectedPowerup.find(".powerup-description").hide();
        selectedPowerup.addClass("help-text");
        $("#powerups-selection").hide();
        $(".powerups-header").show();
    });
    // Apply powerup
    $powerupsBox.on("click", ".powerups-selection-item", async function() {
        let uid = parseInt($(this).closest("#powerups-selection").attr("data-uid"));
        let selectionUid = parseInt($(this).attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $kpu3X.applyPowerup), {
            uid: uid,
            selectionUid: selectionUid
        }, $70adc4a1fd111893$var$showApplyPowerupData, {}, false);
    });
    // Buyout button in view companies
    $("#view-companies-container").on("click", ".buyout-competitor-button", async function() {
        let element = $(".buyout-competitor-box");
        let uid = parseInt($(this).parent().parent().attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $8A6FL.getBuyoutInformation), {
            uid: uid
        }, $70adc4a1fd111893$var$showBuyoutInformationData, {
            element: element,
            uid: uid
        });
    });
    // Make buyout offer button
    $(".buyout-competitor-box").on("click", "#make-buyout-offer", async function() {
        let $parent = $(this).closest(".buyout-competitor-box");
        let uid = $parent.data("uid");
        let talentManagerUid = $parent.find(".buyout-competitor-talent-manager-select").find(":selected").val();
        await (0, $1JSre.makeGameRequest)((0, $8A6FL.makeBuyoutOffer), {
            uid: uid,
            talentManagerUid: talentManagerUid
        }, $70adc4a1fd111893$var$showMakeBuyoutOfferData, {
            uid: uid
        }, false);
    });
    // Form new company menu button
    $("#view-companies-container").on("click", "#form-new-company-menu-button", async function() {
        if (!(0, $98xmD.globalUser).paid) {
            notie.alert({
                type: 3,
                text: "You can only form a new company in JoW Paid."
            });
            return;
        }
        if ((0, $98xmD.globals).game.controlMultipleCompanies) {
            notie.alert({
                type: 3,
                text: "You cannot form new a new comany in Local Multiplayer."
            });
            return;
        }
        if ((0, $98xmD.globals).game.story) {
            notie.alert({
                type: 3,
                text: "You cannot form new a new comany in story modes."
            });
            return;
        }
        await (0, $1JSre.makeGameRequest)((0, $8A6FL.getFormNewCompanyInformation), {}, $70adc4a1fd111893$var$showFormNewCompanyInformationData, {});
    });
    // Form new company button
    $(".form-new-company-box").on("click", "#form-new-company-button", async function() {
        notie.confirm({
            text: 'Are you sure? <span class="red">This decision is irreversible and you will only be able to book your new company.</span>',
            submitCallback: async function() {
                notie.confirm({
                    text: "Are you really sure?",
                    submitCallback: async function() {
                        await (0, $1JSre.makeGameRequest)((0, $8A6FL.startFormingNewCompany), {}, $70adc4a1fd111893$var$showFormNewCompanyData, {});
                    }
                });
            }
        });
    });
});
async function $70adc4a1fd111893$export$80dfbe8f4c2048bd() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view companies data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewCompaniesData = await (0, $8A6FL.getViewCompaniesData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show view companies data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewCompaniesPageData(viewCompaniesData);
}
function $70adc4a1fd111893$var$showViewCompaniesPageData(data) {
    let element = $("#view-companies-container");
    element.html("");
    let formNewCompanyHtml = '<button type="button" id="form-new-company-menu-button" class="button retro-button condensed grey-button-background float-right">Form New Company</button>';
    if (data["formingNewCompany"]) formNewCompanyHtml = '<span class="float-right faded-orange top-1px">Forming new company</span>';
    // Add header
    element.append('<div class="margin-bottom-30"><span class="font-mukta-mahee font-1p325em menu-header-color">Companies</span>' + formNewCompanyHtml + "</div>");
    // Add html for each company
    let companiesHtml = "";
    data["companies"].forEach(function(company) {
        companiesHtml += $70adc4a1fd111893$var$getViewCompaniesPageCompanyHtml(company);
    });
    // Add companies html
    element.append('<div class="view-companies-list-container">' + companiesHtml + "</div>");
    element.fadeIn("slow").removeClass("display-none");
    $(".view-companies-list-container").scrollTop(0);
}
function $70adc4a1fd111893$var$getViewCompaniesPageCompanyHtml(company) {
    // Get overness name class
    let companyOvernessClass = "";
    if (company["hot"]) companyOvernessClass = " hot-color";
    else if (company["stale"]) companyOvernessClass = " stale-color";
    // Get company name
    let companyNameHtml = '<span class="margin-right-8 line-height-24px">' + company["name"] + "</span>";
    // Get owner name
    let ownerHtml = "";
    if (company["ownerName"]) ownerHtml = '<div class="grey margin-top-5 line-height-24px">' + company["ownerName"] + "</div>";
    // Get player name
    let playerNameHtml = "";
    if (company["playerName"]) playerNameHtml = '<div class="grey">{0}</div>'.format(company["playerName"]);
    // Show rebrand button if user company
    let rebrandCompanyButton = "";
    if (company["isUserCompany"]) rebrandCompanyButton = '<button type="button" id="rebrand-company-menu-button" class="button retro-button condensed grey-button-background margin-top-8 display-block">Rebrand</button>';
    // Show buyout button if available
    let buyoutButton = "";
    if (company["availableForBuyout"]) buyoutButton = '<button type="button" class="button retro-button condensed blue-button-background buyout-competitor-button margin-top-8 display-block">Buyout</button>';
    return '<div class="view-companies-list-item dark-grey" data-uid="' + company["uid"] + '">' + '<div class="col1">' + companyNameHtml + ownerHtml + playerNameHtml + buyoutButton + rebrandCompanyButton + "</div>" + '<div class="col2">' + // Fans
    "<div>" + '<img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small margin-right-8"/>' + '<span class="font-mukta-mahee font-1p125em top--1px">' + '<span class="red">' + (0, $1JSre.getFansHtml)(company["fans"]) + "</span>" + "</span>" + "</div>" + // REP
    '<div class="medium-grey margin-top-2 help-text" title="Company Reputation, ranging from 1 to 10, affects Roster size.">' + "<span>REP " + company["reputation"] + "</span>" + '<span class="grey margin-left-8">' + "Highest " + company["highestReputation"] + "</span>" + "</div>" + // Overness
    '<div class="medium-grey help-text" title="Company Overness, ranging from Stale to Hot, affects Event Hype for their shows.">' + '<span class="' + companyOvernessClass + '">' + $70adc4a1fd111893$var$getCompanyOvernessLevelText(company["overness"]) + "</span>" + '<span class="grey margin-left-8">' + company["overness"] + "%</span>" + "</div>" + // Style
    '<div class="medium-grey help-text" title="Company Style can be Entertainment or Pure. Entertainment rewards Gimmicks while ' + 'Pure rewards Match Quality.">' + '<span class="">' + (0, $3E8Nt.toTitleCase)(company["style"]) + "</span>" + "</div>" + "</div>" + '<div class="clear"></div>' + "</div>";
}
function $70adc4a1fd111893$var$getCompanyOvernessLevelText(overness) {
    let text;
    if (overness >= 80) text = "Hot";
    else if (overness >= 60) text = "Popular";
    else if (overness >= 40) text = "Average";
    else if (overness >= 20) text = "Not Popular";
    else if (overness >= 0) text = "Stale";
    return text;
}
async function $70adc4a1fd111893$export$51749dd7bf9a1e9d() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view objectives data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewObjectivesData = await (0, $8A6FL.getViewObjectivesData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show view objectives data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewObjectivesPageData(viewObjectivesData);
}
function $70adc4a1fd111893$var$showViewObjectivesPageData(data) {
    let element = $("#objectives-list");
    element.html("");
    // Add objectives
    element.append('<div class="margin-bottom-30"><span class="font-mukta-mahee font-1p325em menu-header-color">Goals</span></div>');
    let objectivesHtml = "";
    data["objectives"].forEach(function(objective) {
        objectivesHtml += $70adc4a1fd111893$var$getViewObjectivesPageObjectiveHtml(objective);
    });
    element.append('<div class="objectives-container">' + objectivesHtml + "</div>");
    element.fadeIn("slow").removeClass("display-none");
    // Tutorial action check
    if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_objectives");
}
function $70adc4a1fd111893$var$getViewObjectivesPageObjectiveHtml(objective) {
    // Get status
    let statusHtml;
    if (objective["completed"]) statusHtml = '<span class="col2 light-green"><i class="fa fa-check-square-o margin-right-5 font-0p825em"></i>Completed</span>';
    else if (objective["failed"]) statusHtml = '<span class="col2 light-red"><i class="fa fa-cross-square-o margin-right-5 font-0p825em"></i>Failed</span>';
    else {
        let left = "";
        if (objective["activationValue"] > 1) left = " (" + (objective["activationValue"] - objective["value"]) + " left)";
        statusHtml = '<span class="col2 grey"><i class="fa fa-square-o margin-right-5 font-0p825em"></i>Incomplete ' + left + "</span>";
    }
    // Get name
    let name = (0, $1JSre.parseObjectiveName)(objective["name"], "");
    // Get help text
    let helpTextHtml = "";
    if (objective["helpText"]) helpTextHtml = ' help-text" title="' + objective["helpText"];
    return '<div class="margin-bottom-15 objective-item-container"><span class="col1' + helpTextHtml + '">' + name + "</span>" + statusHtml + '<div class="clear"></div>' + "</div>";
}
async function $70adc4a1fd111893$export$4372498b97e9c8ff() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view management activity data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewManagementActivityData = await (0, $8A6FL.getViewManagementActivityData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show view management activity data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewManagementActivityPageData(viewManagementActivityData);
}
function $70adc4a1fd111893$var$showViewManagementActivityPageData(data) {
    let element = $(".management-activity-container");
    element.html("");
    let div = "";
    // Signings
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Signings</span>';
    data["signings"].forEach(function(signing) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + signing["name"] + '<span class="margin-left-8 grey">' + signing["date"] + "</span>" + '<span class="blue">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-10 margin-right-5"/>' + signing["value"] + "</span>";
    });
    if (data["signings"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // Callups
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Callups</span>';
    data["callups"].forEach(function(callup) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + callup["name"] + '<span class="margin-left-8 grey">' + callup["date"] + "</span>" + "</span>";
    });
    if (data["callups"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // Releases
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Releases</span>';
    data["releases"].forEach(function(release) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + release["name"] + '<span class="margin-left-8 grey">' + release["date"] + "</span>" + "</span>";
    });
    if (data["releases"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // Trade Deals
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Trade Deals</span>';
    data["tradeDeals"].forEach(function(tradeDeal) {
        let durationText = tradeDeal["value"];
        if (durationText) durationText = "{0} {1}".format(durationText, (0, $3E8Nt.getMonthsWord)(durationText));
        else durationText = "Permanent";
        div += '<span class="display-block dark-grey margin-bottom-3">' + tradeDeal["name"] + " (" + durationText + ")" + '<span class="margin-left-8 grey">' + tradeDeal["date"] + "</span>" + "</span>";
    });
    if (data["tradeDeals"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // On Trade Talent
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">On Trade</span>';
    data["onTradeTalent"].forEach(function(superstar) {
        let companyName = superstar["company"] ? superstar["company"] : "";
        let appearancesWord = (0, $3E8Nt.getMonthsWord)(superstar["appearances"]);
        div += '<span class="display-block dark-grey margin-bottom-3">' + superstar["name"] + '<span class="margin-left-8 bright-blue">' + companyName + "</span>" + '<span class="margin-left-8 grey">' + superstar["appearances"] + " " + appearancesWord + "</span>" + "</span>";
    });
    if (data["onTradeTalent"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // Events Rebranded
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Events Rebranded</span>';
    data["eventsRebranded"].forEach(function(eventData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + eventData["name"] + '<span class="margin-left-8 grey">' + eventData["date"] + "</span>" + "</span>";
    });
    if (data["eventsRebranded"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // Championships Rebranded
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Championships Rebranded</span>';
    data["championshipsRebranded"].forEach(function(championshipData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + championshipData["name"] + '<span class="margin-left-8 grey">' + championshipData["date"] + "</span>" + "</span>";
    });
    if (data["championshipsRebranded"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // Company Rebranded
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Company Rebranded</span>';
    data["companyRebranded"].forEach(function(companyData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + companyData["name"] + '<span class="margin-left-8 grey">' + companyData["date"] + "</span>" + "</span>";
    });
    if (data["companyRebranded"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // Brands created
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Brands Added</span>';
    data["brandsCreated"].forEach(function(companyData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + companyData["name"] + '<span class="margin-left-8 grey">' + companyData["date"] + "</span>" + "</span>";
    });
    if (data["brandsCreated"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // Brands removed
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Brands Removed</span>';
    data["brandsRemoved"].forEach(function(companyData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + companyData["name"] + '<span class="margin-left-8 grey">' + companyData["date"] + "</span>" + "</span>";
    });
    if (data["brandsRemoved"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    // Superstars Suspended
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Superstars Suspended</span>';
    data["superstarsSuspended"].forEach(function(suspensionData) {
        let monthsWord = (0, $3E8Nt.getMonthsWord)(suspensionData["value"]);
        div += '<span class="display-block dark-grey margin-bottom-3">' + suspensionData["name"] + '<span class="margin-left-8 grey">' + suspensionData["date"] + "</span>" + '<span class="margin-left-8 grey">' + suspensionData["value"] + " " + monthsWord + "</span>" + "</span>";
    });
    if (data["superstarsSuspended"].length < 1) div += '<span class="display-block grey">None</span>';
    div += "</div>";
    element.append('<div class="margin-bottom-30"><span class="font-mukta-mahee font-1p325em menu-header-color">Activity</span></div><div class="management-activity-box">' + div + "</div>");
    element.fadeIn("slow").removeClass("display-none");
    $(".management-activity-box").scrollTop(0);
}
async function $70adc4a1fd111893$export$4cc8be918a3a7c33(graphType, timePeriod) {
    if ((0, $98xmD.globals).requestRunning) return;
    const $viewershipHistoryGraphBrandOption = $(".viewership-history-graph-brand-option");
    // Set values upon first load of fan history
    if (!graphType) {
        // Disable ratings war options if no market size
        let graphTypeSelector = $(".viewership-history-graph-type-select");
        if (!(0, $98xmD.globals).game.marketSize) {
            graphTypeSelector.find('option[value="fans"]').attr("disabled", "disabled");
            graphTypeSelector.find('option[value="viewers"]').attr("disabled", "disabled");
            graphTypeSelector.find('option[value="buys"]').attr("disabled", "disabled");
        } else {
            graphTypeSelector.find('option[value="fans"]').attr("disabled", false);
            graphTypeSelector.find('option[value="viewers"]').attr("disabled", false);
            graphTypeSelector.find('option[value="buys"]').attr("disabled", false);
        }
        graphType = (0, $98xmD.globals).game.marketSize ? "fans" : "fan-change";
        timePeriod = "all";
        $viewershipHistoryGraphBrandOption.parent().parent().hide();
    }
    // Get showBrandsSeparately option if visible
    let showBrandsSeparately;
    if ($viewershipHistoryGraphBrandOption.parent().parent().is(":visible")) showBrandsSeparately = $viewershipHistoryGraphBrandOption.prop("checked");
    // Get fan history data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let fanHistoryData = await (0, $8A6FL.getFanHistoryData)(graphType, timePeriod, showBrandsSeparately);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show fan history data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showFanHistoryPageData(fanHistoryData, graphType, timePeriod);
}
function $70adc4a1fd111893$var$showFanHistoryPageData(data, graphType, timePeriod) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        $70adc4a1fd111893$var$displayFanHistoryGraph(data["fanHistoryData"], graphType);
        $(".viewership-history-graph-type-select").val(graphType);
        $(".viewership-history-graph-period-select").val(timePeriod);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "Fan History is only available in JoW Paid"
        });
    }
}
function $70adc4a1fd111893$var$displayFanHistoryGraph(data, graphType) {
    const $viewershipHistoryContainer = $(".viewership-history-container");
    // Destroy previous chart if found
    if ($70adc4a1fd111893$var$fanHistoryChart) $70adc4a1fd111893$var$fanHistoryChart.destroy();
    // Get series data
    let seriesData = [];
    let colors = [];
    data.forEach(function(d) {
        let obj = {
            name: d["name"],
            data: d["data"],
            companyId: d["companyId"],
            userControlled: d["userControlled"]
        };
        seriesData.push(obj);
        colors.push(d["color"]);
    });
    // Set theme variables
    let foreColor = "#474747";
    let axisBorderColor = "#bfbfbf";
    let gridColor = "#d1d1d1";
    if (0, $c82cd471f4baff6b$export$7d9b72822fcb9a) {
        foreColor = "#9e9e9e";
        axisBorderColor = "#6b6b6b";
        gridColor = "#444444";
    }
    // Set options
    let dataLabelsEnabled = false;
    if ((0, $98xmD.globalUser).settings.colorblindMode) {
        dataLabelsEnabled = true;
        $(".viewership-history-graph-labels-option").parent().parent().show();
        $(".viewership-history-graph-labels-option").prop("checked", true);
    } else {
        $(".viewership-history-graph-labels-option").parent().parent().hide();
        $(".viewership-history-graph-labels-option").prop("checked", false);
    }
    // Show/hide users button
    if (data.filter((x)=>x.userControlled).length > 1) $(".viewership-history-show-users-button").show();
    else $(".viewership-history-show-users-button").hide();
    let options = {
        series: seriesData,
        chart: {
            height: 300,
            type: "line",
            toolbar: {
                show: true,
                tools: {
                    download: false,
                    selection: true,
                    zoom: '<i class="fa fa-search-plus"></i>',
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: '<i class="fa fa-search-minus"></i>',
                    customIcons: []
                },
                autoSelected: "zoom",
                offsetY: 4,
                offsetX: -4
            },
            foreColor: foreColor,
            animations: {
                enabled: true,
                easing: "easeinout",
                speed: 800,
                animateGradually: {
                    enabled: false,
                    delay: 150
                }
            },
            offsetX: -5
        },
        colors: colors,
        noData: {
            text: "No data available",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: -7,
            style: {
                color: undefined,
                fontSize: "14px",
                fontFamily: undefined
            }
        },
        yaxis: {
            labels: {
                formatter: function(value) {
                    return (0, $1JSre.getViewershipText)(value);
                },
                style: {
                    fontWeight: 700,
                    fontSize: "15px"
                },
                offsetX: 7
            },
            showForNullSeries: false
        },
        xaxis: {
            labels: {
                style: {
                    fontWeight: 700
                }
            },
            axisTicks: {
                show: false
            },
            type: "datetime",
            tooltip: {
                style: {
                    fontSize: "12px"
                },
                offsetY: 3
            },
            axisBorder: {
                show: true,
                color: axisBorderColor,
                height: 1
            }
        },
        stroke: {
            width: 2
        },
        legend: {
            position: "bottom",
            fontSize: "15px",
            fontWeight: 700,
            itemMargin: {
                horizontal: 8,
                vertical: 5
            },
            markers: {
                width: 10,
                height: 10,
                strokeWidth: 0,
                strokeColor: "#000000",
                radius: 0,
                offsetX: -3,
                offsetY: 0
            },
            offsetY: 10
        },
        tooltip: {
            style: {
                fontSize: "12px"
            },
            x: {
                show: false
            },
            y: {
                formatter: function(value, opts) {
                    if (value !== undefined) {
                        let yTooltipValue = opts.series[opts.seriesIndex][opts.dataPointIndex];
                        let yToolTipText = (0, $1JSre.getViewershipText)(yTooltipValue);
                        return opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].description + ": " + yToolTipText;
                    }
                },
                title: {
                    formatter: function() {
                        return "";
                    }
                }
            }
        },
        markers: {
            size: 0,
            strokeColors: undefined,
            strokeWidth: 0,
            strokeOpacity: 0,
            strokeDashArray: 0,
            fillOpacity: 0,
            hover: {
                size: undefined,
                sizeOffset: 2
            },
            shape: "square",
            radius: 0
        },
        grid: {
            show: true,
            borderColor: gridColor
        },
        dataLabels: {
            enabled: dataLabelsEnabled,
            textAnchor: "start",
            formatter: function(val, opts) {
                let allSeriesData = opts.w.config.series;
                let name = allSeriesData[opts.seriesIndex].name;
                let otherSeriesData = allSeriesData.filter((x)=>x !== allSeriesData[opts.seriesIndex]);
                let firstLetter = name[0];
                // If first letter exists in other series data, use first 3 letters, unless those 3 letters exist too
                if (otherSeriesData.map((x)=>x.name[0]).filter((x)=>x === firstLetter).length) {
                    if (!otherSeriesData.map((x)=>x.name.slice(0, 3)).filter((x)=>x === name.slice(0, 3)).length) return name.slice(0, 3);
                }
                return firstLetter;
            },
            offsetX: 0,
            style: {
                fontSize: "10px"
            },
            background: {
                enabled: true,
                foreColor: "#fff",
                padding: 2,
                borderRadius: 0,
                borderWidth: 0,
                borderColor: "#fff",
                opacity: 1
            }
        }
    };
    if (graphType === "star-rating") {
        options.yaxis.min = 0;
        options.yaxis.forceNiceScale = true;
    }
    // Render graph
    $70adc4a1fd111893$var$fanHistoryChart = new ApexCharts(document.querySelector(".viewership-history-graph"), options);
    $70adc4a1fd111893$var$fanHistoryChart.render();
    if ($viewershipHistoryContainer.is(":visible")) $viewershipHistoryContainer.show();
    else $viewershipHistoryContainer.fadeIn("slow");
    (0, $1JSre.hideContent)($viewershipHistoryContainer);
    setTimeout(function() {
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_fan_history");
    }, 300);
}
async function $70adc4a1fd111893$export$aaebf53bd9c27ff8() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view company staff data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewCompanyStaffData = await (0, $8A6FL.getViewCompanyStaffData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show view company staff data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewCompanyStaffPageData(viewCompanyStaffData);
}
function $70adc4a1fd111893$var$showViewCompanyStaffPageData(data) {
    const $companyStaffMember = $(".company-staff-member");
    const $companyStaffRoleNumbers = $(".company-staff-role-numbers");
    const $companyStaffContainer = $(".company-staff-container");
    // Add staff members
    $companyStaffMember.html("");
    data["activeStaffMembers"].forEach(function(staffMember) {
        let staffMemberHtml = $70adc4a1fd111893$var$getCompanyStaffMemberHtml(staffMember);
        let elementToAddTo;
        switch(staffMember["role"]){
            case "doctor":
                elementToAddTo = $(".company-staff-doctor .company-staff-member");
                break;
            case "producer":
                elementToAddTo = $(".company-staff-producer .company-staff-member");
                break;
            case "scout":
                elementToAddTo = $(".company-staff-scout .company-staff-member");
                break;
            case "trainer":
                elementToAddTo = $(".company-staff-trainer .company-staff-member");
                break;
            case "talent_manager":
                elementToAddTo = $(".company-staff-talent-manager .company-staff-member");
                break;
            default:
                elementToAddTo = $(".company-staff-other .company-staff-member");
        }
        elementToAddTo.append(staffMemberHtml);
    });
    // Add retired staff members
    $(".company-staff-retired-container").html("");
    data["retiredStaffMembers"].forEach(function(staffMember) {
        let staffMemberHtml = $70adc4a1fd111893$var$getCompanyStaffMemberHtml(staffMember);
        $(".company-staff-retired-container").append(staffMemberHtml);
    });
    if (data["retiredStaffMembers"].length <= 0) $(".company-staff-retired").hide();
    else $(".company-staff-retired").show();
    // Add empty staff role
    $companyStaffMember.each(function(i, e) {
        if ($(this).html() === "") {
            let staffRoleEmptyHtml = $70adc4a1fd111893$var$getStaffRoleEmptyHtml($(e));
            $(e).append(staffRoleEmptyHtml);
            $(e).parent().find(".company-staff-role-name").removeClass("help-text").attr("title", "");
        } else $(e).parent().find(".company-staff-role-name").addClass("help-text").attr("title", $70adc4a1fd111893$var$getStaffMemberDescription($(e).parent().attr("data-role")));
    });
    // Show role numbers
    $companyStaffRoleNumbers.each(function(i, e) {
        let roleName = $(e).attr("data-name");
        let roleNumbers = data["staffRoleNumbers"][roleName];
        let roleNumberHtml = '<span class="company-staff-role-number-hired">{0}</span><span class="margin-left-2">/</span><span class="margin-left-2">{1}</span>'.format(roleNumbers["numberHired"], roleNumbers["numberAvailable"]);
        $(e).html(roleNumberHtml);
    });
    $companyStaffRoleNumbers.show();
    // Show staff list container
    $companyStaffContainer.fadeIn("slow");
    $(".company-staff-list-container").scrollTop(0);
    // Staff member click handler
    $companyStaffContainer.off("click", ".staff-member-container");
    $companyStaffContainer.on("click", ".staff-member-container", function(event) {
        $70adc4a1fd111893$var$showCompanyStaffMemberPage($(event.target), data);
    });
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_company_staff_menu_button");
}
function $70adc4a1fd111893$var$getCompanyStaffMemberHtml(staffMember) {
    let uid = staffMember["uid"];
    // Level progress
    let levelProgressData = $70adc4a1fd111893$var$getStaffMemberLevelProgress(staffMember["level"], Math.round(staffMember["xp"]));
    let levelProgressHtml = '<div class="progress-under help-text" title="' + levelProgressData["xpToLevel"] + '">' + '<div class="progress" style="width:' + levelProgressData["progress"] + '%">' + "</div></div>";
    let staffLevelHtml = '<span class="gold margin-left-5"> Lvl ' + staffMember["level"] + "</span>";
    let unavailable = "";
    if (staffMember["unavailableMonths"]) unavailable = '<div class="dark-red line-height-21px margin-top-2">Unavailable</div>';
    // Get current task
    let currentTaskHtml = "";
    if (staffMember["currentTask"]) currentTaskHtml = '<div class="light-grey line-height-21px margin-top-2">' + staffMember["currentTask"] + "</div>";
    return '<div class="inside-box light-background staff-member-container margin-bottom-10" data-uid="' + uid + '">' + '<div class="medium-dark-grey column-left-70">' + staffMember["name"] + staffLevelHtml + unavailable + currentTaskHtml + "</div>" + '<div class="column-right-30">' + '<div class="staff-member-progress">' + levelProgressHtml + "</div>" + "</div>" + '<div class="clear"></div>' + "</div>";
}
function $70adc4a1fd111893$var$getStaffMemberLevelProgress(level, xp) {
    let baseXp;
    let nextXp;
    switch(level){
        case 1:
            baseXp = 0;
            nextXp = 100;
            break;
        case 2:
            baseXp = 100;
            nextXp = 300;
            break;
    }
    let xpToLevel = "";
    let progress = 100;
    if (level < 3) {
        progress = (xp - baseXp) / (nextXp - baseXp) * 100;
        xpToLevel = "{0} XP to Level {1}".format(nextXp - xp, level + 1);
    } else xpToLevel = "Max Level";
    if (progress > 100) progress = 100;
    else if (progress <= 0) progress = 1;
    return {
        "progress": progress,
        "xpToLevel": xpToLevel
    };
}
function $70adc4a1fd111893$var$getStaffRoleEmptyHtml(element) {
    let staffMemberInfo = $70adc4a1fd111893$var$getStaffMemberDescription(element.parent().attr("data-role"));
    return '<div class="inside-box light-background"><div class="medium-grey margin-bottom-3">Not Hired</div><div class="grey font-0p875em line-height-1p4">' + staffMemberInfo + "</div>" + "</div>";
}
function $70adc4a1fd111893$var$getStaffMemberDescription(role) {
    if (role === "doctor") return "Doctors can provide better injury diagnoses and offer rehab services to bring injured superstars back faster.";
    else if (role === "scout") return "Scouts can produce scouting reports, recruit indie talent to make them available to sign and get them interested in joining your company.";
    else if (role === "producer") return "Producers can create production packages to boost Popularity and Hype, improve segment results by focusing on them and boost new Gimmick debuts.";
    else if (role === "trainer") return "Trainers can train talent to increase their skills, make particular talent available for callups and easily bring new signings to the main roster.";
    else if (role === "talent-manager") return "Talent Managers can try to reassure talent, negotiate appearances with part timers and get talent to join your company in company buyouts.";
}
function $70adc4a1fd111893$var$showCompanyStaffMemberPage($el, staffMembersData) {
    const $staffMemberDetails = $(".staff-member-details");
    const $staffMemberAge = $(".staff-member-age");
    const $staffMemberTask = $(".staff-member-task");
    $(".company-staff-container").hide();
    $staffMemberDetails.hide();
    let uid = parseInt($el.closest(".staff-member-container").attr("data-uid"));
    let staffMember = staffMembersData["activeStaffMembers"].concat(staffMembersData["retiredStaffMembers"]).filter(function(s) {
        return s["uid"] === uid;
    })[0];
    // Staff member details
    $staffMemberDetails.data("uid", staffMember["uid"]);
    $staffMemberDetails.data("element", ".company-staff-container");
    $staffMemberDetails.data("graphic", staffMember["graphic"]);
    $(".staff-member-name").text(staffMember["name"]);
    $(".staff-member-pronoun").text((0, $3E8Nt.toTitleCase)(staffMember["pronoun"]));
    $staffMemberAge.text(staffMember["age"]);
    // Add age multiplier
    let ageBoost = $70adc4a1fd111893$var$getStaffMemberAgeBoost(staffMember["age"]);
    $staffMemberAge.attr("title", ageBoost + "x XP Multiplier. Age affects progression of Skill Level.");
    if (!$staffMemberAge.hasClass("help-text")) $staffMemberAge.addClass("help-text");
    $staffMemberAge.parent().removeClass("help-text").attr("title", null);
    let maxHtml = "";
    if (staffMember["level"] === 3) maxHtml = '<span class="medium-light-grey margin-left-6">Max</span>';
    $(".staff-member-role").html('<span class="grey">' + (0, $3E8Nt.toTitleCase)(staffMember["role"].replace(/_/g, " ")) + "</span>" + '<span class="gold margin-left-8">' + "Level " + staffMember["level"] + maxHtml + "</span>");
    // Hide cost
    $(".staff-member-cost").parent().hide();
    // Show task
    let task = staffMember["currentTask"] || "None";
    if (staffMember["monthsLeftForTask"]) {
        let monthWord = staffMember["monthsLeftForTask"] === 1 ? "month" : "months";
        task += " ({0} {1} left)".format(staffMember["monthsLeftForTask"], monthWord);
    }
    $staffMemberTask.text(task);
    $staffMemberTask.parent().show();
    // Show retired
    if (staffMember["retired"]) $(".staff-member-information").text("Retired").show();
    else $(".staff-member-information").hide();
    $(".staff-member-graphic").html("");
    let el = $staffMemberDetails.find(".staff-member-graphic");
    if (staffMember["graphic"]) (0, $c82cd471f4baff6b$export$619533229dc4b088)(staffMember["graphic"], el);
    $("#fire-staff-member-button").show();
    $("#hire-staff-member-button").hide();
    $("#change-staff-name-menu-button").show();
    $("#change-staff-pronoun-menu-button").show();
    $("#change-staff-appearance-menu-button").show();
    if (staffMember["superstarObjectPresent"]) $("#transition-staff-to-talent-button").show();
    else $("#transition-staff-to-talent-button").hide();
    if (staffMember["currentTask"]) $("#cancel-staff-member-task-button").show();
    else $("#cancel-staff-member-task-button").hide();
    $staffMemberDetails.fadeIn();
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_staff_member");
}
function $70adc4a1fd111893$var$getStaffMemberAgeBoost(age) {
    if (30 > age) return "1.5";
    else if (45 > age) return "1";
    else return "0.75";
}
async function $70adc4a1fd111893$var$loadViewIndieStaffPage() {
    if ((0, $98xmD.globals).requestRunning) return;
    if (!(0, $98xmD.globalUser).paid) {
        notie.alert({
            type: 3,
            text: "You can only hire Staff Members in JoW Paid."
        });
        return;
    }
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getViewIndieStaffData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewIndieStaffPageData(data);
}
function $70adc4a1fd111893$var$showViewIndieStaffPageData(data) {
    const $indieStaffListContainer = $(".indie-staff-list-container");
    const $indieStaffContainer = $(".indie-staff-container");
    // Add staff members
    $indieStaffListContainer.html("");
    data.forEach(function(staffMember) {
        $indieStaffListContainer.append($70adc4a1fd111893$var$getIndieStaffMemberHtml(staffMember));
    });
    $indieStaffContainer.fadeIn("slow");
    $indieStaffListContainer.scrollTop(0);
    // Staff member click handler
    $indieStaffContainer.off("click", ".staff-member-container");
    $indieStaffContainer.on("click", ".staff-member-container", function(event) {
        $70adc4a1fd111893$var$showIndieStaffMemberPage($(event.target), data);
    });
}
function $70adc4a1fd111893$var$getIndieStaffMemberHtml(staffMember) {
    let points = staffMember["cost"].toLocaleString("en");
    let price = '<span class="cursor-pointer">' + points + "</span>";
    let uid = staffMember["uid"];
    let retired = "";
    let retiredClass = "";
    if (staffMember["retired"]) retired = ' <span class="light-grey">(Retired)</span>';
    return '<div class="inner-box-item staff-member-container' + retiredClass + '" data-uid="' + uid + '">' + '<div class="margin-bottom-3 medium-dark-grey">' + staffMember["name"] + retired + '<span class="float-right blue">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-3"/> ' + price + "</span>" + "</div>" + '<div class="light-grey">' + (0, $3E8Nt.toTitleCase)(staffMember["role"].replace(/_/g, " ")) + "</div>" + '<div class="gold">' + "Level " + staffMember["level"] + "</div>" + "</div>";
}
function $70adc4a1fd111893$var$showIndieStaffMemberPage($el, data) {
    const $indieStaffContainer = $(".indie-staff-container");
    const $staffMemberDetails = $(".staff-member-details");
    const $staffMemberAge = $(".staff-member-age");
    const $staffMemberCost = $(".staff-member-cost");
    const $staffMemberInformation = $(".staff-member-information");
    $indieStaffContainer.hide();
    $staffMemberDetails.hide();
    let uid = parseInt($el.closest(".staff-member-container").attr("data-uid"));
    let staffMember = data.filter(function(s) {
        return s["uid"] === uid;
    })[0];
    // Staff member details
    $staffMemberDetails.data("uid", staffMember["uid"]);
    $staffMemberDetails.data("element", ".indie-staff-container");
    $(".staff-member-name").text(staffMember["name"]);
    $(".staff-member-pronoun").text((0, $3E8Nt.toTitleCase)(staffMember["pronoun"]));
    $staffMemberAge.text(staffMember["age"]);
    // Add age help text
    $staffMemberAge.attr("title", null);
    $staffMemberAge.removeClass("help-text");
    if (!$staffMemberAge.parent().hasClass("help-text")) $staffMemberAge.parent().addClass("help-text").attr("title", "Age affects progression of Skill Level. Younger staff members gain XP faster than older ones.");
    $(".staff-member-role").html('<span class="light-grey">' + (0, $3E8Nt.toTitleCase)(staffMember["role"].replace(/_/g, " ")) + "</span>" + '<span class="gold margin-left-8">' + "Level " + staffMember["level"] + "</span>");
    // Show cost
    $staffMemberCost.html('<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small"/> ' + staffMember["cost"].toLocaleString("en"));
    $staffMemberCost.parent().show();
    // Hide task
    $(".staff-member-task").parent().hide();
    // Show retired
    if (staffMember["retired"]) {
        $staffMemberInformation.text("Retired");
        $staffMemberInformation.show();
    } else $staffMemberInformation.hide();
    // Show graphic
    $(".staff-member-graphic").html("");
    let el = $staffMemberDetails.find(".staff-member-graphic");
    if (staffMember["graphic"]) (0, $c82cd471f4baff6b$export$619533229dc4b088)(staffMember["graphic"], el);
    // Show appropriate buttons
    $("#fire-staff-member-button").hide();
    $("#hire-staff-member-button").show();
    $("#change-staff-name-menu-button").hide();
    $("#change-staff-pronoun-menu-button").hide();
    $("#change-staff-appearance-menu-button").hide();
    $("#transition-staff-to-talent-button").hide();
    $("#cancel-staff-member-task-button").hide();
    $staffMemberDetails.fadeIn();
}
async function $70adc4a1fd111893$var$loadChangeStaffMemberNamePage(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getEditStaffMemberData)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showChangeStaffMemberNamePageData(data, uid);
}
function $70adc4a1fd111893$var$showChangeStaffMemberNamePageData(data, uid) {
    let parent = $(".change-staff-name-container");
    parent.find(".change-staff-name-text").text(data["name"]);
    parent.find(".change-staff-name-input").val(data["name"]);
    parent.data("uid", uid);
    parent.fadeIn();
}
async function $70adc4a1fd111893$var$loadChangeStaffMemberPronounPage(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getEditStaffMemberData)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showChangeStaffMemberPronounPageData(data, uid);
}
function $70adc4a1fd111893$var$showChangeStaffMemberPronounPageData(data, uid) {
    let parent = $(".change-staff-pronoun-container");
    parent.find(".change-staff-pronoun-text").text(data["name"]);
    parent.find(".change-staff-pronoun-select").val(data["pronoun"]);
    parent.data("uid", uid);
    parent.fadeIn();
}
async function $70adc4a1fd111893$var$loadChangeStaffMemberAppearancePage(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getEditStaffMemberData)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showChangeStaffMemberAppearancePageData(data, uid);
}
function $70adc4a1fd111893$var$showChangeStaffMemberAppearancePageData(data, uid) {
    let parent = $(".change-staff-appearance-container");
    parent.find(".change-staff-appearance-text").text(data["name"]);
    parent.find("#change-staff-appearance-graphic").data("key", JSON.stringify(data["graphic"]));
    parent.data("uid", uid);
    parent.fadeIn();
    (0, $c82cd471f4baff6b$export$fe2486523999867a)($("#change-staff-appearance-graphic"));
}
async function $70adc4a1fd111893$export$ee44f0dfbe65ffc7() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get view company facilities data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewCompanyFacilitiesData = await (0, $8A6FL.getViewCompanyFacilitiesData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show view company facilities data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewCompanyFacilitiesPageData(viewCompanyFacilitiesData);
}
function $70adc4a1fd111893$var$showViewCompanyFacilitiesPageData(data) {
    // Add Facilities
    $(".company-facilities-list-container").html("");
    data["facilities"].forEach(function(facility) {
        let facilityItemHtml = $70adc4a1fd111893$var$getFacilityItemHtml(facility);
        $(".company-facilities-list-container").append(facilityItemHtml);
    });
    $(".company-facilities-container").hide().fadeIn("slow");
    $(".company-facilities-list-container").scrollTop(0);
    // Tutorial action check
    if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_company_facilities_menu_button");
}
function $70adc4a1fd111893$var$getFacilityItemHtml(facility) {
    let uid = facility["uid"];
    // Level
    let levelHtml = '<i class="fa fa-star gold-bright"></i>'.repeat(facility["level"]);
    if (facility["level"] < 3) levelHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - facility["level"]);
    // Actions for next level
    let actionsToNextLevel = "";
    let actionsClass = "";
    if (facility["actionsToNextLevel"]) {
        actionsClass = "red";
        if (facility["actionsCompleted"] >= facility["actionsToNextLevel"]) actionsClass = "green";
        actionsToNextLevel = "/" + facility["actionsToNextLevel"];
    }
    let actionWord = facility["actionName"];
    // Next level info
    let facilityUpgradeInfo = facility["nextLevelInfo"];
    let nextLevelHtml;
    if (facility["level"] < 3) nextLevelHtml = ' for <span class="gold">Level ' + (facility["level"] + 1) + "</span>";
    else nextLevelHtml = ' <span class="medium-light-grey margin-left-3">Max Level</span>';
    // Cost
    let cost = "";
    if (facility["nextLevelCost"]) cost = '<div class="blue margin-bottom-12"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px margin-right-5"/>' + facility["nextLevelCost"] + "</div>";
    // Upgrade
    let upgradeButton = "";
    if (facility["level"] < 3) upgradeButton = '<div><button type="button" id="upgrade-facility-button" class="button retro-button condensed blue-button-background">Upgrade</button></div>';
    // Last/current level info
    let lastLevelInfo = "";
    if (facility["lastLevelInfo"]) lastLevelInfo = '<div class="margin-top-12 high-light-grey">' + facility["lastLevelInfo"] + "</div>";
    let backgroundClass = "light-background";
    if (!(0, $98xmD.globalUser).paid) backgroundClass = "disabled-background";
    return '<div class="inside-box ' + backgroundClass + ' margin-bottom-25 facility-item" data-uid="' + uid + '">' + '<div class="medium-dark-grey margin-bottom-10 font-1p125em">' + facility["name"] + '<div class="float-right facility-level">' + levelHtml + "</div>" + "</div>" + '<div class="medium-grey margin-bottom-8">' + '<span class="' + actionsClass + '">' + facility["actionsCompleted"] + actionsToNextLevel + "</span> " + actionWord + nextLevelHtml + "</div>" + '<div class="light-grey margin-bottom-8">' + facilityUpgradeInfo + "</div>" + cost + upgradeButton + lastLevelInfo + "</div>";
}
async function $70adc4a1fd111893$var$getHireStaffMemberRequest(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.hireStaffMember)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showHireStaffMemberData(data);
}
function $70adc4a1fd111893$var$showHireStaffMemberData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        notie.alert({
            type: 4,
            text: '<span class="display-block">' + data["name"] + " has been added to your " + '<span class="staff-color">Staff</span></span>',
            stay: true
        });
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to view staff
        setTimeout(function() {
            // Remove staff member from view staff
            let staffMemberElement = $(".staff-member-container:contains(" + data["name"] + ")")[0];
            staffMemberElement.remove();
            $(".staff-member-details").hide();
            $(".indie-staff-container").fadeIn();
        }, 600);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to hire this Staff Member"
        });
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "The Staff Member could not be found. Please try again."
        });
        if (data["error"] === "role-present") notie.alert({
            type: 3,
            text: "You already have a " + (0, $3E8Nt.toTitleCase)(data["role"].replace(/_/g, " ")) + " in your Staff. " + "You need to release them before hiring someone else."
        });
        if (data["error"] === "max-roles") notie.alert({
            type: 3,
            text: "Your {0} Facility only allows a maximum of {1} {2}s (including transitioning superstars).".format(data["facilityName"], data["numberOfRoles"], (0, $3E8Nt.toTitleCase)(data["role"].replace(/_/g, " ")))
        });
        if (data["error"] === "retired") notie.alert({
            type: 3,
            text: "This Staff Member is retired and not looking to be hired."
        });
        if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "You can only hire Staff Members in JoW Paid."
        });
        if (data["error"] === "facility-level") notie.alert({
            type: 3,
            text: "Your {0} Facility only allows Level {1} {2}s to be hired.".format(data["facilityName"], data["facilityLevel"], (0, $3E8Nt.toTitleCase)(data["role"].replace(/_/g, " ")))
        });
    }
}
async function $70adc4a1fd111893$var$getFireStaffMemberRequest(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.fireStaffMember)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showFireStaffMemberData(data);
}
function $70adc4a1fd111893$var$showFireStaffMemberData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        notie.alert({
            type: 4,
            text: '<span class="display-block">' + data["name"] + " has been fired from your " + '<span class="staff-color">Staff</span></span>',
            stay: true
        });
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to view staff
        setTimeout(function() {
            $("#view-company-staff-menu-button").trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "That Staff Member could not be found. Please try again."
        });
    }
}
async function $70adc4a1fd111893$var$getChangeStaffMemberNameRequest(uid, name) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Validate inputs
    if (name.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Staff Member.",
            stay: true
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.changeStaffMemberName)(uid, name);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showChangeStaffMemberNameData(data);
}
function $70adc4a1fd111893$var$showChangeStaffMemberNameData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Go back to company staff
        setTimeout(function() {
            $("#view-company-staff-menu-button").trigger("click");
        }, 800);
        notie.alert({
            type: 4,
            text: "Name changed"
        });
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "staff-not-found") notie.alert({
            type: 3,
            text: "The selected staff could not be found. Please try again."
        });
        else if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to change this Staff Member's Name"
        });
        else if (data["error"] === "same-name") notie.alert({
            type: 3,
            text: "Enter a different Name from the Staff Member's current Name"
        });
        else if (data["error"] === "name-exists") notie.alert({
            type: 3,
            text: "A Staff Member with that name already exists in your Company"
        });
    }
}
async function $70adc4a1fd111893$var$getChangeStaffMemberPronounRequest(uid, pronoun) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Validate inputs
    if (!pronoun) {
        notie.alert({
            type: 3,
            text: "Select a pronoun for the Staff Member.",
            stay: true
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.changeStaffMemberPronoun)(uid, pronoun);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showChangeStaffMemberPronounData(data);
}
function $70adc4a1fd111893$var$showChangeStaffMemberPronounData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        // Go back to company staff
        setTimeout(function() {
            $("#view-company-staff-menu-button").trigger("click");
        }, 800);
        notie.alert({
            type: 4,
            text: "Pronoun changed"
        });
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "staff-not-found") notie.alert({
            type: 3,
            text: "The selected staff could not be found. Please try again."
        });
    }
}
async function $70adc4a1fd111893$var$getChangeStaffMemberGraphicRequest(uid, graphic) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.changeStaffMemberGraphic)(uid, graphic);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showChangeStaffMemberGraphicData(data);
}
function $70adc4a1fd111893$var$showChangeStaffMemberGraphicData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Go back to company staff
        setTimeout(function() {
            $("#view-company-staff-menu-button").trigger("click");
        }, 800);
        notie.alert({
            type: 4,
            text: "Appearance changed"
        });
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "staff-not-found") notie.alert({
            type: 3,
            text: "The selected staff could not be found. Please try again."
        });
        else if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to change this Staff Member's Appearance"
        });
    }
}
async function $70adc4a1fd111893$var$getCancelStaffMemberTaskRequest(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.cancelStaffMemberTask)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showCancelStaffMemberTaskData(data);
}
function $70adc4a1fd111893$var$showCancelStaffMemberTaskData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        notie.alert({
            type: 4,
            text: '<span class="display-block">Task cancelled</span>',
            stay: true
        });
        // Go back to view staff
        setTimeout(function() {
            $("#view-company-staff-menu-button").trigger("click");
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "That Staff Member could not be found. Please try again."
        });
        else if (data["error"] === "negotiating-buyout") notie.alert({
            type: 3,
            text: "This Buyout is already in progress and cannot be cancelled."
        });
    }
}
async function $70adc4a1fd111893$var$getUpgradeCompanyFacilityRequest(uid, facilityItemElement) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.upgradeCompanyFacility)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showUpgradeCompanyFacilityData(data, facilityItemElement);
}
function $70adc4a1fd111893$var$showUpgradeCompanyFacilityData(data, facilityItemElement) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let facility = data["facility"];
        notie.alert({
            type: 4,
            text: '<span class="display-block"><span class="facility-color">' + facility["name"] + " Facility</span>" + " has been upgraded to " + facility["levelPhrase"] + ' <span class="gold">Level ' + facility["level"] + "</span> Facility</span>",
            stay: true
        });
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Update facility item
        let facilityItemHtml = $70adc4a1fd111893$var$getFacilityItemHtml(facility);
        $(facilityItemElement).replaceWith(function() {
            return $(facilityItemHtml).hide().fadeIn("slow");
        });
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to upgrade this Facility"
        });
        else if (data["error"] === "requirements-failed") notie.alert({
            type: 3,
            text: "You have not fulfilled the requirements to upgrade this Facility"
        });
        else if (data["error"] === "max-level") notie.alert({
            type: 3,
            text: "This Facility is already at the maximum Level"
        });
        else if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "You can only upgrade Facilities in JoW Paid."
        });
    }
}
async function $70adc4a1fd111893$export$d43b059220da65ff(year) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let viewCompanyFacilitiesData = await (0, $8A6FL.getYearlyRankingsHistoryData)(year);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showViewYearlyRankingsHistoryPageData(viewCompanyFacilitiesData);
}
function $70adc4a1fd111893$var$showViewYearlyRankingsHistoryPageData(data) {
    if (!data["error"]) {
        (0, $1JSre.hideContent)($());
        (0, $lCS03.playSoundEffect)("success");
        const $yearlyRankingsYearSelect = $(".yearly-rankings-year-select");
        // Add yearly rankings data
        $70adc4a1fd111893$export$8e1132a1a7754c30(data["ranking"], true);
        // Add years options
        let yearsHtml = "";
        data["years"].forEach(function(year) {
            yearsHtml += "<option>" + year + "</option>";
        });
        $yearlyRankingsYearSelect.html(yearsHtml);
        // Select year
        $yearlyRankingsYearSelect.val(data["ranking"]["year"]);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "no-rankings-present") notie.alert({
            type: 3,
            text: "No Top 50 Rankings are currently present. They are published in January of each year."
        });
        else if (data["error"] === "ranking-not-found") notie.alert({
            type: 3,
            text: "The Top 50 Rankings for that year could not be found."
        });
        else if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "Top 50 Rankings are only available in JoW Paid."
        });
    }
}
function $70adc4a1fd111893$export$8e1132a1a7754c30(data, history) {
    let parent = $("#yearly-rankings-container");
    let yearlyRankingsDataElement = $(".yearly-rankings-data-container");
    // Add ranking items
    let rankingsHtml = "";
    data["rankingData"]?.forEach(function(ranking, i) {
        // Add headers
        if (i === 0) rankingsHtml += '<div class="yearly-rankings-list-header font-abril-fatface">Top 10</div>';
        if (i === 10) rankingsHtml += '<div class="yearly-rankings-list-subheader font-abril-fatface">The Rest</div>';
        // Get details
        let numberHtml = '<span class="display-inline-block yearly-rankings-number">' + (i + 1) + ".</span>";
        let pointsHtml = '<span class="display-inline-block">{0} pts</span>'.format(Math.round(ranking["points"]));
        let highlightHtml = "";
        if (ranking["highlight"]) highlightHtml = '<div class="margin-top-3 font-normal dark-grey">' + ranking["highlight"] + "</div>";
        let companyNameHtml = '<span class="medium-dark-grey margin-left-8 font-14px">(' + ranking["company"] + ")</span>";
        // Get classes
        let trophyHtml = "";
        let rankingItemClass = "";
        if (i === 0) {
            trophyHtml = '<img alt="Trophy" src="static/www/static/trophy_icon_gold.png" class="trophy-image margin-right-8"/>';
            rankingItemClass += " first";
        }
        if (i === 9) rankingItemClass += " tenth";
        if (i <= 9) rankingItemClass += " highlighted";
        // Add html
        let div = '<div class="yearly-rankings-item' + rankingItemClass + '">' + "<div>" + '<div class="yearly-rankings-column-number">' + numberHtml + "</div>" + '<div class="yearly-rankings-column-name">' + '<div class="line-height-1p4">' + trophyHtml + ranking["name"] + companyNameHtml + "</div>" + '<div class="line-height-1p4">' + highlightHtml + "</div>" + "</div>" + '<div class="yearly-rankings-column-data">' + pointsHtml + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
        rankingsHtml += div;
    });
    if (!data["rankingData"]) rankingsHtml += "<div>No rankings present for this year.</div>";
    // Add year and editor
    parent.find(".yearly-rankings-subheader").text(data["year"]);
    parent.find(".yearly-rankings-editor").text(data["editor"]);
    // Show/hide year select
    if (history) {
        parent.find(".yearly-rankings-subheader").hide();
        parent.find(".yearly-rankings-year-select").show();
    } else {
        parent.find(".yearly-rankings-subheader").show();
        parent.find(".yearly-rankings-year-select").hide();
    }
    parent.fadeIn("slow");
    yearlyRankingsDataElement.html(rankingsHtml);
    yearlyRankingsDataElement.scrollTop(0);
}
async function $70adc4a1fd111893$export$9b13a1ad71568d7b(iteration) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getAnnualTournamentHistoryData)(iteration);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showViewAnnualTournamentHistoryPageData(data);
}
function $70adc4a1fd111893$var$showViewAnnualTournamentHistoryPageData(data) {
    if (!data["error"]) {
        (0, $1JSre.hideContent)($());
        (0, $lCS03.playSoundEffect)("success");
        const $annualTournamentIterationSelect = $(".annual-tournament-iteration-select");
        // Add annual tournament data
        $70adc4a1fd111893$var$displayAnnualTournamentHistoryData(data["annualTournament"]);
        // Add iterations options
        let iterationsHtml = "";
        data["iterations"].forEach(function(iteration, i) {
            iterationsHtml += '<option value="' + (i + 1) + '">' + iteration + "</option>";
        });
        $annualTournamentIterationSelect.html(iterationsHtml);
        // Select shown iteration
        $annualTournamentIterationSelect.val(data["iteration"]);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "no-annual-tournament-present") notie.alert({
            type: 3,
            text: "The Grand Invitational has not been held yet."
        });
        else if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "The Grand Invitational is only available in JoW Paid."
        });
    }
}
function $70adc4a1fd111893$var$displayAnnualTournamentHistoryData(data) {
    let parent = $("#annual-tournament-history-container");
    const $annualTournamentHistoryDataContainer = $(".annual-tournament-history-data-container");
    let tournamentInfoHtml = "";
    // Add year
    let yearHtml = data["year"] ? data["year"] : "";
    tournamentInfoHtml += '<div class="grey text-center margin-top-8">' + yearHtml + "</div>";
    // Add winner name
    let winnerHtml = "{0} ({1})".format(data["winner"], data["winnerOrganizationName"]);
    tournamentInfoHtml += '<div class="medium-dark-grey text-center margin-top-12">Winner</div><div class="annual-tournament-yellow text-center">' + winnerHtml + "</div>";
    // Add uid to poster button
    $(".view-annual-tournament-poster-button").data("uid", data["uid"]);
    // Add bracket
    let tournamentRound = 1;
    let tournamentRounds = Object.keys(data["bracket"]).length;
    let bracketHtml = $70adc4a1fd111893$export$d1c14a92b2f32dc8(data["bracket"][tournamentRound], tournamentRound, tournamentRounds);
    tournamentInfoHtml += '<div class="annual-tournament-bracket-container history margin-top-20 margin-bottom-15" data-round="' + tournamentRound + '" data-rounds="' + tournamentRounds + '">' + bracketHtml + "</div>";
    $annualTournamentHistoryDataContainer.html(tournamentInfoHtml);
    // Navigate bracket rounds
    parent.off("click", ".tournament-bracket-next, .tournament-bracket-prev");
    parent.on("click", ".tournament-bracket-next, .tournament-bracket-prev", function() {
        let bracketContainer = parent.find(".annual-tournament-bracket-container");
        let round = bracketContainer.attr("data-round");
        let rounds = bracketContainer.attr("data-rounds");
        // Go to next/prev round
        if ($(this).hasClass("tournament-bracket-next")) round++;
        else round--;
        let bracket = data["bracket"][round];
        if (!bracket) return false;
        bracketContainer.attr("data-round", round);
        // Show new bracket
        let bracketHtml = $70adc4a1fd111893$export$d1c14a92b2f32dc8(bracket, round, rounds);
        $(".annual-tournament-bracket-container").html(bracketHtml).hide().fadeIn("fast");
    });
    parent.fadeIn("slow");
    $annualTournamentHistoryDataContainer.scrollTop(0);
}
function $70adc4a1fd111893$export$d1c14a92b2f32dc8(bracket, tournamentRound, tournamentRounds, edit, tournamentStartRound) {
    if (typeof edit === "undefined") edit = false;
    if (typeof tournamentStartRound === "undefined") tournamentStartRound = 0;
    let html = "";
    // Get header text
    let round;
    let participants = bracket.length * 2;
    switch(participants){
        case 2:
            round = "Final";
            break;
        case 4:
            round = "Semi Finals";
            break;
        case 8:
            round = "Quarter Finals";
            break;
        case 16:
            round = "Round of 16";
            break;
        default:
            round = "Round " + tournamentRound;
    }
    let bracketClass = "";
    if (participants >= 32) bracketClass = "mini";
    else if (participants >= 16) bracketClass = "compact";
    let prev = '<i class="fa fa-chevron-left font-0p825em margin-right-10 tournament-bracket-prev cursor-pointer visibility-hidden"></i>';
    let next = '<i class="fa fa-chevron-right font-0p825em margin-left-8 tournament-bracket-next cursor-pointer visibility-hidden"></i>';
    if (!edit) {
        // Check for next and previous rounds
        if (tournamentRound < tournamentRounds) next = '<i class="fa fa-chevron-right font-0p825em margin-left-8 tournament-bracket-next cursor-pointer"></i>';
        if (tournamentRound > tournamentStartRound + 1) prev = '<i class="fa fa-chevron-left font-0p825em margin-right-10 tournament-bracket-prev cursor-pointer"></i>';
    }
    html += '<span class="display-block margin-bottom-15 text-center medium-dark-grey">' + prev + '<span class="tournament-round-name" data-round-number="' + tournamentRound + '">' + round + "</span>" + next + "</span>";
    bracket.forEach(function(match, i) {
        html += '<div class="tournament-bracket-match ' + bracketClass + '">';
        match["participants"].forEach(function(participant, j) {
            let participantSeed = participant[1];
            let participantName = participant[0];
            let participantClass = "";
            if (!participantSeed) participantSeed = " ";
            if (!participantName) {
                participantSeed = "—";
                participantName = "???";
            } else {
                if (match["winner"]) {
                    if (participantName !== match["winner"]) participantClass = "opaque";
                }
            }
            let formattedName = (0, $1JSre.getShortenedName)(participantName, 30);
            let helpClass = "";
            let titleHtml = "";
            if (formattedName !== participantName) {
                helpClass = " help-text";
                titleHtml = ' title="' + participantName.replace(/"/g, "&quot;") + '"';
            }
            let editClass = "";
            if (edit) editClass = "edit";
            // Get organization name
            let organizationName = "";
            if (participant[2]) organizationName = '<span class="grey margin-left-8 font-14px">' + participant[2] + "</span>";
            html += '<div class="tournament-participant ' + editClass + participantClass + '">' + '<span class="tournament-participant-seed margin-right-5 light-grey">' + participantSeed + "</span>" + '<span class="tournament-participant-name' + helpClass + '" data-name="' + participantName.replace(/"/g, "&quot;") + '"' + titleHtml + ">" + formattedName + organizationName + "</span>" + "</div>";
            if (j === 0) html += '<div class="tournament-participant-separator"></div>';
        });
        html += "</div>";
    });
    return html;
}
function $70adc4a1fd111893$export$b15b76cf4991fb5f(groups, advancingPositions, history) {
    // Get maximum win/loss/draw items
    let historyArrays = groups.map(function(group) {
        return group.map(function(x) {
            return x["history"].length;
        });
    });
    let histories = [].concat.apply([], historyArrays);
    let maxHistory = Math.max.apply(null, histories);
    let html = "";
    let tableClass = "";
    let recordClass = "";
    if (history) tableClass = "in-table";
    if (maxHistory >= 7) {
        recordClass = "compact";
        tableClass += " compact-table";
    }
    groups.forEach(function(group, i) {
        html += '<div class="tournament-group-container">';
        // Add group name
        let groupName = "";
        switch(i){
            case 0:
                groupName = "A";
                break;
            case 1:
                groupName = "B";
                break;
            case 2:
                groupName = "C";
                break;
            case 3:
                groupName = "D";
                break;
        }
        html += '<span class="display-block margin-bottom-15 text-center medium-dark-grey"><span class="tournament-group-name">Group ' + groupName + "</span>" + "</span>";
        // Add group participants
        html += '<div class="tournament-bracket-match ' + tableClass + '">';
        group.forEach(function(participant, j, arr) {
            let historyHtml = "";
            participant["history"].forEach(function(record) {
                switch(record){
                    case "W":
                        historyHtml += '<span class="tournament-table-record-item win ' + recordClass + '">W</span>';
                        break;
                    case "L":
                        historyHtml += '<span class="tournament-table-record-item loss ' + recordClass + '">L</span>';
                        break;
                    case "D":
                        historyHtml += '<span class="tournament-table-record-item draw ' + recordClass + '">D</span>';
                        break;
                }
            });
            let maxLength = 14;
            if (history) maxLength = 11;
            let name = participant["name"];
            if (name.length > maxLength) name = name.slice(0, maxLength) + ".";
            // Highlight top position if no knockout round
            if (advancingPositions === 0) advancingPositions = 1;
            let participantClass = "";
            if (j < advancingPositions) participantClass = " highlight";
            html += '<div class="tournament-participant table' + participantClass + '">' + '<span class="tournament-table-rank margin-right-5 light-grey">' + (j + 1) + "</span>" + '<span class="tournament-table-name">' + name + "</span>" + '<span class="tournament-table-record">' + historyHtml + "</span>" + '<span class="tournament-table-points">' + participant["points"] + " pts</span>" + "</div>";
            if (j !== arr.length - 1) html += '<div class="tournament-participant-separator"></div>';
        });
        html += "</div></div>";
    });
    return html;
}
async function $70adc4a1fd111893$var$loadViewAnnualTournamentStatsPage(iteration) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getAnnualTournamentStatsData)(iteration);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showViewAnnualTournamentStatsPageData(data);
}
function $70adc4a1fd111893$var$showViewAnnualTournamentStatsPageData(data) {
    if (!data["error"]) {
        (0, $1JSre.hideContent)($());
        (0, $lCS03.playSoundEffect)("success");
        const $annualTournamentStatsDataContainer = $(".annual-tournament-stats-data-container");
        let annualTournamentStatsHtml = $70adc4a1fd111893$var$getAnnualTournamentStatsHtml(data);
        $annualTournamentStatsDataContainer.html(annualTournamentStatsHtml);
        $("#annual-tournament-stats-container").fadeIn("slow");
        $annualTournamentStatsDataContainer.scrollTop(0);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        notie.alert({
            type: 3,
            text: "There was a problem loading The Grand Invitational stats."
        });
    }
}
function $70adc4a1fd111893$var$getAnnualTournamentStatsHtml(data) {
    let html = "";
    html += '<div class="margin-bottom-20">';
    html += '<span class="display-block blue margin-bottom-2">Most Times Won (Talent)</span>';
    data["mostWins"].forEach(function(statData) {
        html += '<span class="display-block dark-grey">' + statData["name"] + '<span class="margin-left-5 light-grey">' + statData["number"] + "</span>" + "</span>";
    });
    html += "</div>";
    html += '<div class="margin-bottom-20">';
    html += '<span class="display-block blue margin-bottom-2">Most Times Won (Company)</span>';
    data["mostOrganizationWins"].forEach(function(statData) {
        html += '<span class="display-block dark-grey">' + statData["name"] + '<span class="margin-left-5 light-grey">' + statData["number"] + "</span>" + "</span>";
    });
    html += "</div>";
    html += '<div class="margin-bottom-20">';
    html += '<span class="display-block blue margin-bottom-2">Best Matches</span>';
    data["bestMatches"].forEach(function(statData) {
        let rating = (0, $1JSre.setRating)(statData["rating"]);
        let text = '{0} <span class="light-grey">def.</span> {1}<span class="light-grey margin-left-8">{2}</span>'.format(statData["winner"], statData["loser"], statData["tournamentName"]);
        html += '<span class="display-block dark-grey margin-bottom-8">' + text + '<span class="margin-left-10 display-inline-block">' + rating + "</span>" + "</span>";
    });
    html += "</div>";
    html += "<div>";
    html += '<span class="display-block blue margin-bottom-2">Most Entries</span>';
    data["mostEntries"].forEach(function(statData) {
        html += '<span class="display-block dark-grey">' + statData["name"] + '<span class="margin-left-5 light-grey">' + statData["number"] + "</span>" + "</span>";
    });
    html += "</div>";
    return html;
}
async function $70adc4a1fd111893$var$loadViewEventPosterPage(eventUid, annualTournamentUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $5ZsVo.getEventPosterData)(eventUid, annualTournamentUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showViewEventPosterPageData(data, eventUid);
}
function $70adc4a1fd111893$var$showViewEventPosterPageData(data, eventUid) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        const $eventHistoryPosterContainer = $("#event-history-poster-container");
        // Show poster
        (0, $c82cd471f4baff6b$export$ea8a53556b69e3e0)(data["eventPosterGraphicData"], $eventHistoryPosterContainer);
        $("#event-history-container").hide();
        $("#annual-tournament-history-container").hide();
        // Set element to go back to
        if (eventUid) $eventHistoryPosterContainer.data("previousElement", "#event-history-container");
        else $eventHistoryPosterContainer.data("previousElement", "#annual-tournament-history-container");
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "event-not-found") notie.alert({
            type: 3,
            text: "That event could not be found. Please try again."
        });
        if (data["error"] === "poster-not-present") notie.alert({
            type: 3,
            text: "Poster not present for event."
        });
        if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "Past event posters can only be viewed in JoW Paid."
        });
    }
}
async function $70adc4a1fd111893$export$360148ccebf3178a() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $4ptHI.getSpecialSegmentsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    (0, $67cc16607ee33ebf$export$ac3751cc11b68979)(data);
}
async function $70adc4a1fd111893$var$loadViewUsedSpecialSegmentPage(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $4ptHI.getSpecialSegmentHistoryData)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    (0, $67cc16607ee33ebf$export$272205331e6ebe73)(data);
}
async function $70adc4a1fd111893$export$f6c7271bf4f4dc95() {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $kpu3X.getPowerupsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewPowerupsPageData(data);
}
function $70adc4a1fd111893$var$showViewPowerupsPageData(data) {
    const $powerupsInventory = $("#powerups-inventory");
    $powerupsInventory.html("");
    $("#powerups-selection").html("");
    // Add header
    let headerHtml = '<img class="pulse" alt="Artifact" src="static/www/static/' + (0, $98xmD.globals).game.powerupLevel1 + '_large.png"/>' + '<img class="pulse" alt="Artifact" src="static/www/static/' + (0, $98xmD.globals).game.powerupLevel2 + '_large.png"/>' + '<img class="pulse" alt="Artifact" src="static/www/static/' + (0, $98xmD.globals).game.powerupLevel3 + '_large.png"/>';
    if ((0, $98xmD.globals).game.story === "mars") headerHtml = '<img alt="Experiment" src="static/www/static/' + (0, $98xmD.globals).game.powerupLevel1 + '_large.png"/>' + '<img alt="Experiment" src="static/www/static/' + (0, $98xmD.globals).game.powerupLevel2 + '_large.png"/>';
    $(".powerups-header").html(headerHtml).show();
    // Add powerups
    data.forEach(function(powerup) {
        const powerupItemHtml = $70adc4a1fd111893$var$getViewPowerupsItemHtml(powerup);
        $powerupsInventory.append(powerupItemHtml);
    });
    $("#powerups-box").fadeIn("slow").removeClass("display-none");
    $powerupsInventory.scrollTop(0);
}
function $70adc4a1fd111893$var$getViewPowerupsItemHtml(powerup) {
    let div;
    let image = (0, $kpu3X.getPowerupImage)(powerup);
    // Show use button if in stock
    let useButton = "";
    if (powerup["stock"] > 0) useButton = '<button type="button" class="button retro-button condensed margin-left-5 blue-button-background use-powerup">Use</button>';
    // Set name and description
    let name = powerup["name"];
    let description = powerup["description"];
    if (powerup["hidden"]) description = "The effects of this " + (0, $98xmD.globals).game.powerupWord + " are not fully known.";
    if (powerup["unlocked"]) div = '<div class="powerup-container help-text" title="' + description + '" data-uid="' + powerup["uid"] + '">' + '<div class="font-1p125em margin-bottom-10 font-bold">' + '<span class="powerup-name">' + name + "</span>" + '<span class="blue float-right top--4px">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ' + powerup["cost"] + "</span>" + "</div>" + '<div class="font-1p125em margin-bottom-10 powerup-description display-none grey font-bold">' + description + "</div>" + '<span class="font-1p125em margin-bottom-10">' + '<span class="font-bold top-5px powerup-image">' + image + '<span class="powerup-stock-number">' + powerup["stock"] + "</span>" + "</span>" + '<span class="blue float-right powerup-bottom">' + '<button type="button" class="button retro-button condensed dark-grey-button-background buy-powerup">Buy</button>' + useButton + "</span>" + "</span>" + '<span class="powerup-cancel display-none float-right">' + '<button type="button" class="button retro-button condensed dark-grey-button-background powerup-cancel-button">Cancel</button>' + "</span>" + "</div>";
    else {
        let divHtml = '<div class="powerup-container locked help-text" title="' + description + '">';
        // Show unavailable powerups
        if (powerup["storyName"] === "mars" && powerup["unavailable"]) divHtml = '<div class="powerup-container unavailable help-text" title="Available after completing Wrestling on Mars (JoW Paid)">';
        div = divHtml + '<div class="font-1p125em margin-bottom-10 font-bold">' + '<span class="powerup-name">' + name + "</span>" + '<span class="blue float-right top--4px">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ??? ' + "</span>" + "</div>" + '<span class="font-1p125em margin-bottom-10">' + '<span class="font-bold top-5px powerup-image">' + image + '<span class="powerup-stock-number">' + powerup["stock"] + "</span>" + "</span>" + '<span class="font-1p125em margin-bottom-10">' + '<span class="blue float-right powerup-bottom">' + '<button type="button" class="button retro-button condensed dark-grey-button-background disabled">Buy</button>' + "</span>" + "</span>" + '<span class="powerup-cancel display-none float-right">' + '<button type="button" class="button retro-button condensed dark-grey-button-background powerup-cancel-button">Cancel</button>' + "</span>" + "</div>";
    }
    return div;
}
async function $70adc4a1fd111893$export$1123285aefc96438() {
    if ((0, $98xmD.globals).requestRunning) return;
    // Select menu option
    $("#main-menu-right").find("li").removeClass("selected");
    $("#view-options-menu-button").addClass("selected");
    // Hide event effects
    $(".event-prestige-effects-container").hide();
    $(".event-prestige-effects-more i").addClass("fa-angle-down").removeClass("fa-angle-up");
    $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $iRMwH.getOptionsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewOptionsPageData(data);
}
function $70adc4a1fd111893$var$showViewOptionsPageData(data) {
    if (data) {
        (0, $lCS03.playSoundEffect)("success");
        const $numberOfWeeklyShowsOption = $('select[name="number-of-weekly-shows-option"]');
        const $enableFatigueOption = $('.other-options input[value="enable_fatigue"]');
        const $runAnnualTournamentOption = $('.other-options input[value="run_annual_tournament"]');
        const $loadFavoriteCommunitySegmentsOption = $('.other-options input[value="load_favorite_community_segments"]');
        // Run weekly shows
        $numberOfWeeklyShowsOption.val(data["numberOfWeeklyShows"]).hide().show();
        // Disable 'run weekly shows' for WoM
        if ((0, $98xmD.globals).game.story !== "mars") {
            $numberOfWeeklyShowsOption.prop("disabled", false);
            $numberOfWeeklyShowsOption.removeClass("help-text").attr("title", "");
        } else {
            $numberOfWeeklyShowsOption.val("0");
            $numberOfWeeklyShowsOption.prop("disabled", true);
            $numberOfWeeklyShowsOption.addClass("help-text").attr("title", "Weekly Shows are disabled for Wrestling on Mars");
        }
        // Sandbox options
        if (data["gameSettings"]["sandbox_mode_enabled"]) {
            let userSandboxOptionsHtml = "";
            let sandboxSettings = [
                "unlimited_creative_points",
                "maximum_roster_capacity",
                "all_indies_available",
                "unlock_all_items",
                "maximum_staff_and_facilities",
                "no_special_items_cooldown"
            ];
            $.map(data["gameSettings"], function(v, i) {
                if (sandboxSettings.indexOf(i) >= 0 && v) {
                    // Rename maximum roster capacity
                    if (i === "maximum_roster_capacity") i = "highest_roster_capacity";
                    userSandboxOptionsHtml += '<div class="light-grey">' + (0, $3E8Nt.toTitleCase)(i.replace(/_/g, " ")) + "</div>";
                }
            });
            // Show toggleable settings
            let toggleableSandboxSettings = [
                "no_injuries",
                "no_unhappiness",
                "no_talent_requests",
                "no_random_events",
                "no_retirements",
                "no_going_part_time"
            ];
            toggleableSandboxSettings.forEach(function(setting) {
                let settingChecked = data["gameSettings"][setting] ? " checked" : "";
                userSandboxOptionsHtml += '<label class="control control--checkbox display-block light-grey">' + (0, $3E8Nt.toTitleCase)(setting.replace(/_/g, " ")) + '<input type="checkbox" class="toggleable-game-setting" value="' + setting + '"' + settingChecked + ">" + '<div class="control__indicator"></div>' + "</label>";
            });
            $(".user-sandbox-options").html(userSandboxOptionsHtml);
            $(".user-sandbox-options-container").show();
        } else $(".user-sandbox-options-container").hide();
        // Competitor difficulty
        if (data["gameSettings"]["competitor_difficulty"]) $('input[name="competitor-difficulty-option"][value="' + data["gameSettings"]["competitor_difficulty"] + '"]').prop("checked", true);
        else $('input[name="competitor-difficulty-option"][value="normal"]').prop("checked", true);
        // Event preview
        if (data["userSettings"]["showEventPreview"] === undefined || data["userSettings"]["showEventPreview"]) $('.other-options input[value="show_event_preview"]').prop("checked", true);
        else $('.other-options input[value="show_event_preview"]').prop("checked", false);
        // Load favorited community segments
        if ((0, $98xmD.globalUser).paid) {
            if (data["userSettings"]["loadFavoriteCommunitySegments"] === undefined || data["userSettings"]["loadFavoriteCommunitySegments"]) $loadFavoriteCommunitySegmentsOption.prop("checked", true);
            else $loadFavoriteCommunitySegmentsOption.prop("checked", false);
            $loadFavoriteCommunitySegmentsOption.parent().show();
        } else $loadFavoriteCommunitySegmentsOption.parent().hide();
        // Annual tournament
        if ((0, $98xmD.globalUser).paid && !(0, $98xmD.globals).game.story) {
            if (data["gameSettings"]["run_annual_tournament"] === undefined || data["gameSettings"]["run_annual_tournament"]) $runAnnualTournamentOption.prop("checked", true);
            else $runAnnualTournamentOption.prop("checked", false);
            $runAnnualTournamentOption.parent().show();
        } else $runAnnualTournamentOption.parent().hide();
        // Enable fatigue
        if (data["gameSettings"]["enable_fatigue"] === undefined || data["gameSettings"]["enable_fatigue"]) $enableFatigueOption.prop("checked", true);
        else $enableFatigueOption.prop("checked", false);
        $enableFatigueOption.parent().show();
        // Generate settings
        if (data["gameSettings"]["generate_indie_superstars"] === undefined || data["gameSettings"]["generate_indie_superstars"]) $('.other-options input[value="generate_indie_superstars"]').prop("checked", true);
        else $('.other-options input[value="generate_indie_superstars"]').prop("checked", false);
        if (data["gameSettings"]["generate_competitors"] === undefined || data["gameSettings"]["generate_competitors"]) $('.other-options input[value="generate_competitors"]').prop("checked", true);
        else $('.other-options input[value="generate_competitors"]').prop("checked", false);
        // Last cloud save
        $70adc4a1fd111893$export$78fe0af1c9049862(data["dateTimeLastCloudSave"]);
        $("#game-options-container").fadeIn();
        $(".game-options-box").scrollTop(0);
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_game_options");
    } else {
        (0, $lCS03.playSoundEffect)("error");
        notie.alert({
            type: 3,
            text: "An error occurred. Please try again."
        });
    }
}
function $70adc4a1fd111893$export$78fe0af1c9049862(dateTimeLastCloudSave) {
    let lastCloudSaveText;
    if (dateTimeLastCloudSave) lastCloudSaveText = "Last saved " + (0, $3E8Nt.getTimeDiffHuman)(dateTimeLastCloudSave, new Date()) + " ago";
    else lastCloudSaveText = "";
    $(".game-options-last-cloud-save").text(lastCloudSaveText);
}
async function $70adc4a1fd111893$var$changeNumberOfWeeklyShowsRequest(value, $el) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Select menu option
    $("#main-menu-right").find("li").removeClass("selected");
    $("#view-options-menu-button").addClass("selected");
    // Hide event effects
    $(".event-prestige-effects-container").hide();
    $(".event-prestige-effects-more i").addClass("fa-angle-down").removeClass("fa-angle-up");
    $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $iRMwH.changeNumberOfWeeklyShows)(value);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showChangeNumberOfWeeklyShowsData(data, $el);
}
function $70adc4a1fd111893$var$showChangeNumberOfWeeklyShowsData(data, $el) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        notie.alert({
            type: 4,
            text: "Setting updated"
        });
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "weekly-show") {
            notie.alert({
                type: 3,
                text: "The number of weekly shows can only be changed at a monthly event"
            });
            $el.val(data["numberOfWeeklyShows"]).hide().show();
        }
        if (data["error"] === "turn-ended") {
            notie.alert({
                type: 3,
                text: "The number of weekly shows can only be changed when no users have played their current shows"
            });
            $el.val(data["numberOfWeeklyShows"]).hide().show();
        }
    }
}
async function $70adc4a1fd111893$export$3079987a80f5136b(settingName, settingValue) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $iRMwH.changeUserSetting)(settingName, settingValue);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showChangeUserSettingData(data);
}
function $70adc4a1fd111893$var$showChangeUserSettingData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        // Update user settings
        (0, $98xmD.globalUser).settings = data["userSettings"];
    } else if (data["error"] === "not-logged-in") {
        (0, $lCS03.playSoundEffect)("error");
        notie.alert({
            type: 4,
            text: "Please login to save this setting."
        });
    }
}
async function $70adc4a1fd111893$export$a8834e9c186723b7(settingName, settingValue) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $iRMwH.changeGameSetting)(settingName, settingValue);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showChangeGameSettingData(data);
}
function $70adc4a1fd111893$var$showChangeGameSettingData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        notie.alert({
            type: 4,
            text: "Setting updated"
        });
        // Update game settings
        (0, $98xmD.globals).game.settings = data["gameSettings"];
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "game-not-found") notie.alert({
            type: 4,
            text: "Game could not be found. Please try again."
        });
        else if (data["error"] === "change-not-allowed") notie.alert({
            type: 4,
            text: "That setting cannot be changed."
        });
    }
}
async function $70adc4a1fd111893$export$11eb91805ca2797e(companyUid, eventUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $5ZsVo.getViewEventsData)(companyUid, eventUid);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) companySelectData = await (0, $8A6FL.getCompanySelectData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show company select
    if (!companyUid) (0, $d3e44747ec383890$export$4e74726e57dcef35)(companySelectData, $(".select-company-for-view-events"));
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewEventsPageData(data);
}
function $70adc4a1fd111893$var$showViewEventsPageData(data) {
    // Add select data
    $70adc4a1fd111893$var$addViewEventsYearSelectOptions(data["years"]);
    $(".select-year-for-view-events").val(data["event"]["year"]);
    $(".select-company-for-view-events").val(data["event"]["companyName"].trim().replace(/\s+/g, " "));
    // Show event details
    $70adc4a1fd111893$var$displayEvent(data);
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_events");
}
function $70adc4a1fd111893$var$addViewEventsYearSelectOptions(years) {
    const $selectYear = $(".select-year-for-view-events");
    $selectYear.find("option").remove().end();
    years.forEach(function(year) {
        $selectYear.append('<option data-uid="' + year["uid"] + '">' + year["year"] + "</option>");
    });
    if (years.length > 0) $selectYear.prop("disabled", false);
    else $selectYear.prop("disabled", true);
}
function $70adc4a1fd111893$var$displayEvent(data) {
    const event = data["event"];
    // Show containers
    $("#event-calendar").hide();
    $("#event-history-container").fadeIn("slow");
    // Declare jQuery selectors
    let nextEventSelector = $(".event-history-next-event-button");
    let previousEventSelector = $(".event-history-previous-event-button");
    let eventDetails = $("#event-details");
    let eventHistory = $('<div class="margin-top-20"></div>');
    if (!event["year"]) event["year"] = $(".select-year-for-view-events").find(":selected").text();
    // Clear the event box
    eventDetails.text("");
    // Show next/previous event buttons
    if (data["nextEventId"]) {
        nextEventSelector.show();
        eventDetails.data("nextEventId", data["nextEventId"]);
    } else nextEventSelector.hide();
    if (data["previousEventId"]) {
        previousEventSelector.show();
        eventDetails.data("previousEventId", data["previousEventId"]);
    } else previousEventSelector.hide();
    // Display event name, prestige and xp
    let prestigeIcon = "";
    switch(event["prestige"]){
        case "C":
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6 current-event-prestige-icon bronze"></i>';
            break;
        case "B":
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6 current-event-prestige-icon silver"></i>';
            break;
        case "A":
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6 current-event-prestige-icon gold-light"></i>';
            break;
    }
    // Get top event text
    let topEvent = "";
    if (event["topEvent"]) topEvent = '<span class="signature-event-color display-block font-bold margin-bottom-2">Signature Event</span>';
    // Get progress to next level
    let progressHtml = "";
    if (event["prestige"]) {
        let progress;
        let levelXp = event["xpToNextPrestige"];
        if (event["prestige"] !== "A") progress = (event["xp"] - event["baseXp"]) / (levelXp - event["baseXp"]) * 100;
        else progress = 100;
        progressHtml = '<div class="event-prestige-progress history display-inline-block"><div class="progress-under help-text" title="' + event["xp"] + " / " + levelXp + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>" + "</div>";
    }
    // Get weekly show name
    let weeklyShowHtml = "";
    if (event["weeklyShowName"]) weeklyShowHtml = '<span class="display-block line-height-1p25em medium-dark-grey margin-top-10">' + event["weeklyShowName"] + "</span>";
    // Get hype
    let eventHype = event["hype"];
    if (eventHype < 0) eventHype = "- " + eventHype * -1;
    else eventHype = "+ " + eventHype;
    let eventHypeHtml = '<span class="display-block medium-dark-grey font-bold">' + eventHype + " HYPE" + "</span>";
    // Viewership
    let viewershipHtml = "";
    if (event["viewership"] !== null && (0, $98xmD.globalUser).paid) {
        let viewershipText = (0, $1JSre.getViewershipText)(event["viewership"]);
        let viewershipWord = event["weeklyShow"] || event["name"] === "Weekly Show" ? " Viewers" : " Buys";
        let nielsenRatingHtml = event["weeklyShow"] ? '<span class="margin-left-5 light-grey">(' + event["nielsenRating"] + ")</span>" : "";
        viewershipHtml = '<div class="medium-dark-grey">' + viewershipText + viewershipWord + nielsenRatingHtml + "</div>";
    }
    // Brand
    let brandNameHtml = "";
    if (event["brandName"] && !event["weeklyShow"]) brandNameHtml = '<div class="display-block grey">' + event["brandName"] + "</div>";
    eventDetails.append('<span class="display-block font-1p25em event-history-name">' + event["name"] + "</span>" + '<span class="display-block grey margin-top-5">' + event["year"] + "</span>" + brandNameHtml + weeklyShowHtml + '<span class="display-block margin-top-8 margin-bottom-15">' + progressHtml + prestigeIcon + "</span>" + topEvent + eventHypeHtml + viewershipHtml);
    // Create bonuses divs
    let eventBonusesDiv = $('<div class="font-bold grey"></div>');
    let eventBonusesContainer = $('<div class="event-history-effects-container margin-top-8"></div>');
    // Add streaks container
    if (event["xp"]) {
        if (event["streaks"].length > 0) {
            let eventStreaksContainer = $('<div class="bonuses-container"></div>');
            eventStreaksContainer.append('<div class="margin-bottom-2 medium-grey">Streaks</div>');
            let streakPotentials = event["streaks"].reduce(function(filtered, streak) {
                if (streak["length"] < 2) filtered.push(streak["holder"]);
                return filtered;
            }, []);
            event["streaks"].forEach(function(streak) {
                // Potential streaks
                if (streak["length"] >= 2) {
                    let streakText;
                    let streakClass = "bronze";
                    if (streak["length"] < 5) streakClass = "bronze";
                    else if (streak["length"] < 10) streakClass = "gold-light";
                    else if (streak["length"] < 20) streakClass = "faded-red";
                    else streakClass = "obsidian";
                    if (streak["length"] >= 10) streakText = '{0} <span class="{1} margin-left-3">{2}-0</span>'.format(streak["holder"], streakClass, streak["length"]);
                    else {
                        let winText = streak["length"] > 1 ? "Wins" : "Win";
                        streakText = '{0} <span class="{1} margin-left-3">{2} {3}</span>'.format(streak["holder"], streakClass, streak["length"], winText);
                    }
                    let streakHtml = "<div>" + streakText + "</div>";
                    eventStreaksContainer.append(streakHtml);
                }
            });
            if (streakPotentials.length > 0) {
                let streakText = '<span class="light-grey">Streak Potential: {0}</span>'.format(streakPotentials.join(", "));
                let streakHtml = "<div>" + streakText + "</div>";
                eventStreaksContainer.append(streakHtml);
            }
            eventBonusesContainer.append(eventStreaksContainer);
        }
        // Add match bonuses container
        if (event["matchEffects"].length > 0) {
            let eventMatchEffectsContainer = $('<div class="bonuses-container"></div>');
            eventMatchEffectsContainer.append('<div class="margin-bottom-2 medium-grey">Gimmick Match Effects</div>');
            let plusPotentials = event["matchEffects"].reduce(function(filtered, matchBonus) {
                if (!matchBonus["bonus"] && matchBonus["points"] > 0) filtered.push(matchBonus["gimmickMatch"]);
                return filtered;
            }, []);
            let minusPotentials = event["matchEffects"].reduce(function(filtered, matchBonus) {
                if (!matchBonus["bonus"] && matchBonus["points"] < 0) filtered.push(matchBonus["gimmickMatch"]);
                return filtered;
            }, []);
            event["matchEffects"].forEach(function(matchEffect) {
                if (matchEffect["bonus"]) {
                    let matchEffectText;
                    let matchEffectClass = "bronze";
                    if (matchEffect["bonus"] < 0) matchEffectClass = "puke-green";
                    else matchEffectClass = "gold";
                    let bonus;
                    if (matchEffect["bonus"] > 0) bonus = "+ " + matchEffect["bonus"];
                    else bonus = "- " + matchEffect["bonus"] * -1;
                    matchEffectText = '{0} <span class="{1} margin-left-3">{2} HYPE</span>'.format(matchEffect["gimmickMatch"], matchEffectClass, bonus);
                    let matchEffectHtml = "<div>" + matchEffectText + "</div>";
                    eventMatchEffectsContainer.append(matchEffectHtml);
                }
            });
            if (plusPotentials.length > 0) {
                let matchBonusText = '<span class="light-grey">+ Effect Potential: {0}</span>'.format(plusPotentials.join(", "));
                let matchBonusHtml = "<div>" + matchBonusText + "</div>";
                eventMatchEffectsContainer.append(matchBonusHtml);
            }
            if (minusPotentials.length > 0) {
                let matchBonusText = '<span class="light-grey">- Effect Potential: {0}</span>'.format(minusPotentials.join(", "));
                let matchBonusHtml = "<div>" + matchBonusText + "</div>";
                eventMatchEffectsContainer.append(matchBonusHtml);
            }
            eventBonusesContainer.append(eventMatchEffectsContainer);
        }
        // Add match contracts container
        if (event["matchContracts"].length > 0) {
            let eventMatchContractsContainer = $('<div class="bonuses-container"></div>');
            eventMatchContractsContainer.append('<div class="margin-bottom-2 medium-grey">Match Contracts</div>');
            event["matchContracts"].forEach(function(matchContract) {
                let matchContractText;
                let matchContractClass;
                if (matchContract["bonus"] < 25) matchContractClass = "bronze";
                else if (matchContract["bonus"] < 50) matchContractClass = "gold-light";
                else if (matchContract["bonus"] < 70) matchContractClass = "faded-red";
                else matchContractClass = "obsidian";
                matchContractText = '{0}<span class="margin-left-3 light-grey"> {1}</span><span class="{2} margin-left-3"> + {3} HYPE</span>'.format(matchContract["holder"], matchContract["name"], matchContractClass, matchContract["bonus"]);
                let matchContractHtml = "<div>" + matchContractText + "</div>";
                eventMatchContractsContainer.append(matchContractHtml);
            });
            eventBonusesContainer.append(eventMatchContractsContainer);
        }
        // Add bonuses to event details
        if (event["streaks"].concat(event["matchEffects"], event["matchContracts"]).length > 0) {
            eventBonusesDiv.append(eventBonusesContainer);
            eventDetails.append(eventBonusesDiv);
        }
    }
    // Display text if event not held and return function
    if (event["rating"] === null) {
        let emptyText;
        emptyText = "To Be Held";
        eventHistory.append('<span class="font-bold display-block grey">' + emptyText + "</span>");
        // Don't show next/prev buttons if event not held (future event)
        nextEventSelector.hide();
        previousEventSelector.hide();
    } else {
        event["matchesAndSegments"].forEach(function(segment) {
            let segmentResultHtml;
            if (segment["segmentType"] === "segment") segmentResultHtml = $70adc4a1fd111893$var$getSegmentHistoryHtml(segment);
            else segmentResultHtml = $70adc4a1fd111893$var$getMatchHistoryHtml(segment);
            eventHistory.append('<div class="margin-bottom-20 font-bold text-left" tabindex="0">' + segmentResultHtml + "</div>");
        });
        // Calculate rating stars
        let eventRating = event["rating"];
        let eventRatingFloor = Math.floor(eventRating);
        let eventDecimalRating = eventRating - eventRatingFloor;
        let eventRatingText = '<i class="fa fa-star"></i>'.repeat(eventRatingFloor);
        // Fix display of stars on quarter and three-quarter star
        if (eventDecimalRating === 0.75) eventDecimalRating = 0.70;
        else if (eventDecimalRating === 0.25) eventDecimalRating = 0.35;
        // Display rating decimal star
        if (eventDecimalRating > 0) eventRatingText += '<i class="star star-under fa fa-star"><i class="star star-over fa fa-star" style="width: ' + eventDecimalRating * 100 + '%"></i>' + "</i>";
        if (eventRatingFloor < 5) {
            if (eventDecimalRating > 0) eventRatingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - eventRatingFloor - 1);
            else eventRatingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - eventRatingFloor);
        }
        // Add points and fans
        let fansAndPointsText = "";
        let pointsEarned = event["pointsEarned"].toLocaleString();
        fansAndPointsText += '<span class="display-block font-1p125em"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small"/>';
        if (event["pointsEarned"] >= 0) fansAndPointsText += '<i class="fa fa-angle-double-up margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Increase"></i><span>' + pointsEarned + "</span>";
        else fansAndPointsText += '<i class="fa fa-angle-double-down margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Decrease"></i><span>' + pointsEarned + "</span>";
        // Add fans
        if (event["fansGained"] !== null) {
            let fansEarned = event["fansGained"].toLocaleString();
            fansAndPointsText += '<img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small margin-left-20"/>';
            if (event["fansGained"] >= 0) fansAndPointsText += '<i class="fa fa-angle-double-up margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Increase"></i><span>' + fansEarned + "</span></span>";
            else fansAndPointsText += '<i class="fa fa-angle-double-down margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Decrease"></i><span>' + fansEarned + "</span></span>";
        }
        // Add to event results
        eventHistory.append('<div class="event-results-container text-left" tabindex="0"><div class=col1><span class="font-bold font-mukta-mahee font-1p125em">' + fansAndPointsText + "</span>" + "</div>" + '<div class="col2 text-right">' + '<span class="font-bold match-star-rating history" role="text" aria-label="Event Rating: ' + event["rating"] + " stars" + '">' + eventRatingText + "</span>" + "</div>" + '<div class="clear"></div>' + "</div>");
    }
    // Add event history
    eventDetails.append(eventHistory);
    eventDetails.data("uid", event["uid"]);
}
function $70adc4a1fd111893$var$getMatchHistoryHtml(match, blowoff, showFeudBlowoffOnly) {
    if (typeof blowoff === "undefined") blowoff = false;
    if (typeof showFeudBlowoffOnly === "undefined") showFeudBlowoffOnly = false;
    // Get winner text
    let winner = match["winner"]["name"];
    // Get manager text if present
    let winnerParticipant = match["participants"].filter(function(m) {
        return m["name"] === match["winner"]["name"];
    })[0];
    if (winnerParticipant) {
        let managersHtml = (0, $1145891c855e0e78$export$b9b438f3e67a1018)(winnerParticipant);
        winner += managersHtml;
    }
    let winnerChampionshipText = "";
    let retainedChampionshipText = "";
    if (match["winner"]["championshipsWon"] && match["winner"]["championshipsDefended"]) {
        winnerChampionshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold">' + match["winner"]["championshipsWon"] + "</span></span>";
        winnerChampionshipText += '<span class="margin-left-5">and retain the<span class="margin-left-5 gold">' + match["winner"]["championshipsDefended"] + "</span></span>";
    } else {
        if (match["winner"]["championshipsWon"]) winnerChampionshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold">' + match["winner"]["championshipsWon"] + "</span></span>";
        else if (match["winner"]["championshipsDefended"]) winnerChampionshipText = '<span class="margin-left-5">to retain the<span class="margin-left-5 gold">' + match["winner"]["championshipsDefended"] + "</span></span>";
        else if (match["winner"]["championshipsRetained"]) retainedChampionshipText = '<span class="display-block margin-top-5"><span class="gold">' + match["winner"]["championshipsRetained"] + "</span> didn't change hands</span>";
    }
    // Get loser names with managers
    let losers = [];
    match["participants"].forEach(function(matchParticipant) {
        if (matchParticipant !== winnerParticipant) {
            let loserText = matchParticipant["name"];
            let managersHtml = (0, $1145891c855e0e78$export$b9b438f3e67a1018)(matchParticipant);
            loserText += managersHtml;
            losers.push(loserText);
        }
    });
    // Join losers with comma and 'and'
    let losersHtml;
    if (losers.length > 1) losersHtml = losers.slice(0, -1).join(", ") + " and " + losers.slice(-1);
    else losersHtml = losers[0];
    // Match finish text
    let finishHtml = "";
    if (match["finishName"]) {
        let finishText = "";
        if (match["finishText"]) finishText = '<span class="margin-left-5">by ' + match["finishText"] + "</span>";
        let noContestText = "";
        if ([
            "Double Pin",
            "Time-limit Draw",
            "Ring Collapse"
        ].indexOf(match["finishName"]) >= 0) noContestText = " No Contest ";
        finishHtml = '<span class="margin-left-5 light-grey">' + noContestText + 'via <span class="match-finish-color">' + match["finishName"] + "</span>" + finishText + "</span>";
    }
    let generatedText;
    if (match["text"]) generatedText = '<span class="display-block generated-text">' + match["text"] + "</span>";
    // Set rating
    let rating;
    let ratingText;
    if (match["rating"] !== null) {
        let ratingValue = match["rating"];
        let ratingFloor = Math.floor(ratingValue);
        let decimalRating = ratingValue - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) decimalRating = 0.70;
            else if (decimalRating === 0.25) decimalRating = 0.35;
            ratingText += '<i class="star star-under fa fa-star"><i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' + "</i>";
            if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
        } else if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
        // Set rating element
        rating = '<span class="display-block match-star-rating history" role="text" aria-label="' + match["rating"] + " stars" + '">' + ratingText + "</span>";
    } else {
        // Show cash in indicator if rating is null and winner is not null
        let cashinHtml = "";
        if (match["winnerName"] !== null) cashinHtml = " <span>Cash In</span>";
        // Set rating element
        rating = '<span class="display-block"><span class="font-0p925em"><span class="grey">No Rating</span>' + cashinHtml + "</span></span>";
    }
    // Show tournament details
    let tournamentText = "";
    if (match["tournamentName"]) tournamentText = "<span class='font-bold display-block margin-bottom-5 medium-grey'>" + match["tournamentName"] + " " + match["tournamentRoundName"] + "</span>";
    // Set Gimmick match text
    let text;
    let matchGimmick = match["gimmick"];
    if (match["activeEffect"] === "draw") text = "{0} wrestled {1} to a {2} minute Time Limit Draw{3}".format(winner, losersHtml, match["text"], winnerChampionshipText);
    else if (match["activeEffect"] === "squash") text = "{0} squashed {1} in a short match{2}".format(winner, losersHtml, winnerChampionshipText);
    else if (matchGimmick) {
        // Show generated text
        if (match["text"]) {
            if (match["rules"] === "battle_royal") text = "{0}{1} won the {2} match{3}{4}".format(generatedText, winner, matchGimmick, finishHtml, winnerChampionshipText);
            else if (matchGimmick === "Ironman") text = "{0} <span class='light-grey'>def.</span> {1}{2} with a score of {3}{4}".format(winner, losersHtml, finishHtml, match["text"], winnerChampionshipText);
            else // 2/3 falls, elimination
            text = "{0}{1} <span class='light-grey'>def.</span> {2}{3}{4}<span class='grey margin-left-8'>{5} Match</span>".format(generatedText, winner, losersHtml, finishHtml, winnerChampionshipText, matchGimmick);
        } else if (match["refereeName"]) {
            let refereeText = "<span> w/ " + match["refereeName"] + "</span>";
            text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}<span class='grey margin-left-8'>{4} Match{5}</span>".format(winner, losersHtml, finishHtml, winnerChampionshipText, matchGimmick, refereeText);
        } else if (matchGimmick === "Steel Cage" || matchGimmick === "Graphene Cage") text = "{0} escaped the cage{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        else if (matchGimmick === "I Quit") text = "{0} made {1} say 'I Quit'{2}{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        else if (matchGimmick === "Street Fight") text = "{0} <span class='light-grey'>def.</span> {1}{2} in a violent street fight{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        else if (matchGimmick.includes("Ladder")) text = "{0} climbed the ladder{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        else if (matchGimmick === "Pu Ladder") text = "{0} climbed the plutonium ladder{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        else if (matchGimmick === "Pole") text = "{0} grabbed the {1} off the pole{2}, defeating {3}{4}".format(winner, match["generated"]["objectToClaim"], winnerChampionshipText, losersHtml, finishHtml);
        else if (matchGimmick === "Canyon Fight") text = "{0} <span class='light-grey'>def.</span> {1}{2} in a violent canyon fight{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        else if (matchGimmick === "Glacier Escape") text = "{0} escaped the glacier{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        else if (matchGimmick === "Open Challenge") text = "{0} <span class='light-grey'>def.</span> {1}{2} in an Open Challenge{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        else text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}<span class='grey margin-left-8'>{4} Match</span>".format(winner, losersHtml, finishHtml, winnerChampionshipText, matchGimmick);
    } else if ([
        "Double Pin",
        "Time-limit Draw",
        "Ring Collapse"
    ].indexOf(match["finishName"]) >= 0) text = "{0} <span class='light-grey'>vs</span> {1}{2}{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
    else text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
    // Feud Hypes
    let feudsHtml = "";
    if (showFeudBlowoffOnly) match["feuds"].forEach(function(feud) {
        if (blowoff && feud["ended"]) {
            let feudName = '<span class="bright-red">Blowoff</span>';
            feudsHtml += '<span class="margin-left-8"><span class="faded-red-light">' + feudName + "</span>" + "</span>";
        }
    });
    else match["feuds"].forEach(function(feud) {
        let feudName = feud["name"];
        if (blowoff && feud["ended"]) feudName += ' <span class="bright-red">Blowoff</span>';
        feudsHtml += '<span class="margin-left-8"><span class="faded-red-light">' + feudName + "</span>" + "</span>";
    });
    return "<div class=col1>" + tournamentText + text + feudsHtml + retainedChampionshipText + "</div>" + '<div class="col2 text-right">' + rating + "</div>" + '<div class="clear"></div>';
}
function $70adc4a1fd111893$var$getSegmentHistoryHtml(segment, blowoff, showFeudBlowoffOnly) {
    if (typeof blowoff === "undefined") blowoff = false;
    if (typeof showFeudBlowoffOnly === "undefined") showFeudBlowoffOnly = false;
    let feudsHtml = "";
    if (showFeudBlowoffOnly) segment["feuds"].forEach(function(feud) {
        if (blowoff && feud["ended"]) {
            let feudName = '<span class="bright-red">Blowoff</span>';
            feudsHtml += '<span class="margin-left-8"><span class="faded-red-light">' + feudName + "</span>" + "</span>";
        }
    });
    else segment["feuds"].forEach(function(feud) {
        let feudName = feud["name"];
        if (blowoff && feud["ended"]) feudName += ' <span class="bright-red">Blowoff</span>';
        feudsHtml += '<span class="margin-left-8"><span class="faded-red-light">' + feudName + "</span>" + "</span>";
    });
    let rating = $70adc4a1fd111893$var$getSegmentRating(segment);
    let text = $70adc4a1fd111893$var$getSegmentText(segment);
    return "<div class=col1>" + text + feudsHtml + "</div>" + '<div class="col2 text-right">' + rating + "</div>" + '<div class="clear"></div>';
}
function $70adc4a1fd111893$var$getSegmentText(segment, segmentNameClass) {
    // Segment history text
    if (typeof segmentNameClass === "undefined") segmentNameClass = "faded-purple";
    let segmentParticipants = "";
    if (Array.isArray(segment["participants"])) {
        let segmentParticipantsList = [];
        segment["participants"].forEach(function(participantName) {
            let segmentParticipant = participantName;
            // Get manager text if present
            if (segment["participantsDetails"]) {
                let participant = segment["participantsDetails"].filter(function(m) {
                    return m["name"] === participantName;
                })[0];
                if (participant && participant["managerNames"].length > 0) segmentParticipant += '<span class="margin-left-5 grey"><span>w/</span> {0}</span>'.format((0, $3E8Nt.commaSeparate)(participant["managerNames"], " <span>and</span> "));
            }
            segmentParticipantsList.push(segmentParticipant);
        });
        segmentParticipants = (0, $3E8Nt.commaSeparate)(segmentParticipantsList);
    }
    let joinText = "";
    let text;
    if (segment["participants"].length > 0) {
        joinText = "between";
        if (segment["participants"].length === 1 || segment["managerSegment"]) joinText = "with";
        if (segment["productionSegment"]) joinText = "for";
    }
    text = "<span class='" + segmentNameClass + "'>{0}</span> <span class='light-grey'>" + joinText + "</span> {1}";
    text = text.format(segment["name"], segmentParticipants);
    return text;
}
function $70adc4a1fd111893$var$getSegmentRating(segment) {
    // Set rating
    let rating;
    let ratingText;
    let ratingValue = segment["rating"];
    let ratingFloor = Math.floor(ratingValue);
    if (ratingFloor === 0) ratingText = '<i class="fa fa-star star-under"></i>'.repeat(5);
    else {
        let decimalRating = ratingValue - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) decimalRating = 0.70;
            else if (decimalRating === 0.25) decimalRating = 0.35;
            ratingText += '<i class="star star-under fa fa-star"><i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' + "</i>";
            if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
        } else if (ratingFloor < 5) ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
    }
    rating = '<span class="display-block match-star-rating history"><span class="dark-grey" role="text" aria-label="' + ratingValue + " stars" + '">' + ratingText + "</span></span>";
    return rating;
}
async function $70adc4a1fd111893$var$loadViewEventCalendarPage(companyUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $5ZsVo.getCompanyEventsData)(companyUid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewEventCalendarPageData(data);
}
function $70adc4a1fd111893$var$showViewEventCalendarPageData(data) {
    data["events"].forEach(function(event, index) {
        let eventCalendarBox = $(".event-calendar-box").eq(index);
        let eventName = event["name"];
        if (event["brandName"]) eventName += ' <span class="grey display-block margin-top-3">' + event["brandName"] + "</span>";
        eventCalendarBox.find(".event-calendar-name").html(eventName);
        eventCalendarBox.find(".event-calendar-name").data("uid", event["uid"]);
        eventCalendarBox.find(".event-calendar-name").data("latestChildEventUid", event["latestChildEventUid"]);
        eventCalendarBox.removeClass("current");
        if (event["name"] === data["upcomingEventName"]) eventCalendarBox.addClass("current");
    });
    $("#event-calendar").fadeIn();
}
async function $70adc4a1fd111893$var$loadRebrandEventPage(selectedEvent, element) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $5ZsVo.getCompanyEventsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showRebrandEventPageData(data, selectedEvent, element);
}
function $70adc4a1fd111893$var$showRebrandEventPageData(data, selectedEvent, element) {
    let selectOptions = "";
    let selectElement = element.find(".rebrand-event-event-select");
    data["events"].forEach(function(event) {
        let eventBrandName = event["brandName"];
        if (eventBrandName) eventBrandName = event["brandName"].replace(/"/g, "&quot;");
        selectOptions += '<option data-uid="' + event["uid"] + '" data-brand-name="' + eventBrandName + '">' + event["name"] + "</option>";
    });
    if (data["companyWeeklyShowName"]) selectOptions += '<option data-weekly-show="true"">' + data["companyWeeklyShowName"] + "</option>";
    selectElement.html(selectOptions);
    // Select previously selected championship
    selectElement.val(selectedEvent);
    if (selectElement.val() === null) selectElement.prop("selectedIndex", 0);
    // Add brand names
    let brandNamesOptions = '<option value="">None</option>';
    data["brandNames"].forEach(function(brandName) {
        brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + "</option>";
    });
    element.find(".rebrand-event-brand-select").html(brandNamesOptions);
    // Reset name input
    element.find(".rebrand-event-name-input").val("");
    // Load details for selected event
    $(".rebrand-event-event-select").trigger("change");
    element.fadeIn("slow").removeClass("display-none");
}
async function $70adc4a1fd111893$var$rebrandEventRequest(uid, name, weeklyShow, brandName) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Check if name entered
    if (name.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Event",
            stay: true
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $5ZsVo.rebrandEvent)(uid, name, weeklyShow, brandName);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    await $70adc4a1fd111893$var$showRebrandEventData(data);
}
async function $70adc4a1fd111893$var$showRebrandEventData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        notie.alert({
            type: 4,
            text: "{0} has been Rebranded to {1}".format(data["previousName"], data["newName"])
        });
        if (data["updateEvent"]) {
            // Reload event card
            await $70adc4a1fd111893$export$7e05ff2c2988840c();
            // Go back to view events
            setTimeout(function() {
                $("#view-events-menu-button").trigger("click");
            }, 1200);
        } else // Go back to view events
        setTimeout(function() {
            $("#view-events-menu-button").trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to change this Event's Name"
        });
        else if (data["error"] === "mars") notie.alert({
            type: 3,
            text: "You cannot change Event Names in Wrestling on Mars"
        });
        else if (data["error"] === "name-exists") notie.alert({
            type: 3,
            text: "An Event with that name already exists in your Company"
        });
        else if (data["error"] === "same-name") notie.alert({
            type: 3,
            text: "Enter a different Name from the Event's current Name"
        });
    }
}
async function $70adc4a1fd111893$export$7e05ff2c2988840c() {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $5ZsVo.getEventCardData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$export$2ea68f2b252ba05a(data);
}
function $70adc4a1fd111893$export$2ea68f2b252ba05a(data) {
    const $eventCardNameDetails = $("#event-card-name-details");
    const $eventCardWeeklyShow = $(".event-card-weekly-show");
    // Show brand name
    (0, $1145891c855e0e78$export$24e5a79523641dba)(data["eventData"]);
    let baseHype = data["eventData"]["baseHype"];
    if (baseHype < 0) {
        baseHype *= -1;
        baseHype = "- " + baseHype + "</span>";
    } else baseHype = "+ " + baseHype + "</span>";
    $(".event-hype").html(baseHype + " Base HYPE");
    // Show event prestige
    $eventCardNameDetails.html("");
    if (!data["eventData"]["weeklyShow"]) (0, $1145891c855e0e78$export$18150d6b84dd892a)(data["eventData"]);
    else {
        $eventCardWeeklyShow.show();
        if (data["eventData"]["weeklyShowName"]) $eventCardWeeklyShow.text(data["eventData"]["weeklyShowName"]);
        else $eventCardWeeklyShow.text("Weekly Show");
        $(".event-prestige-effects").hide();
    }
    // Show event name and information
    let eventActiveEffect = "";
    if (data["eventData"]["activeEffect"]) {
        if (data["eventData"]["activeEffect"] === "premier_event") eventActiveEffect = '<img alt="Trophy" src="static/www/static/trophy_icon_gold.png" class="trophy-image small help-text margin-left-10" title="' + (0, $3E8Nt.toTitleCase)(data["eventData"]["activeEffect"].replace(/_/g, " ")) + '"/>';
        else eventActiveEffect = '<img alt="Artifact" src="static/www/static/powerup_1_icon_small.png" class="powerup-image-small left-0 help-text margin-left-8" title="' + (0, $3E8Nt.toTitleCase)(data["eventData"]["activeEffect"].replace(/_/g, " ")) + '"/>';
    }
    $eventCardNameDetails.append(eventActiveEffect);
    // Update match limits
    (0, $98xmD.globals).game.maximumMatchesAndSegments = data["maximumMatchesAndSegments"];
    (0, $98xmD.globals).game.minimumMatchesAndSegments = data["minimumMatchesAndSegments"];
    // Add matches and segments
    (0, $1145891c855e0e78$export$a23fd95a66c9ff1d)(data["matchesAndSegments"]);
    $("#event-card").fadeIn();
}
async function $70adc4a1fd111893$export$97b0d6ca1b055888() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $cXLSF.getViewFeudsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewFeudsPageData(data);
}
function $70adc4a1fd111893$var$showViewFeudsPageData(data) {
    const $currentFeuds = $(".current-feuds");
    const $potentialFeuds = $(".potential-feuds");
    const $pastFeuds = $(".past-feuds");
    // Reset ui
    $(".feud-history").html("").hide();
    $(".feud-history-item.selected").removeClass("selected");
    $(".feuds-history-search-input").val("");
    // Show current feuds
    let currentFeudsHtml = '<div class="margin-bottom-5 font-0p925em dark-grey margin-left-2">Current Feuds</div>';
    data["currentFeuds"].forEach(function(feud) {
        currentFeudsHtml += $70adc4a1fd111893$var$getFeudDetailsHtml(feud);
    });
    if (data["currentFeuds"].length < 1) currentFeudsHtml += '<div class="grey margin-left-2">None</div>';
    $currentFeuds.html(currentFeudsHtml);
    // Show potential feuds
    let potentialFeudsHtml = '<div class="margin-bottom-5 font-0p925em dark-grey margin-left-2">Potential Feuds</div>';
    data["potentialFeuds"].forEach(function(feud) {
        potentialFeudsHtml += $70adc4a1fd111893$var$getFeudDetailsHtml(feud);
    });
    if (data["potentialFeuds"].length < 1) potentialFeudsHtml += '<div class="grey margin-left-2">None</div>';
    $potentialFeuds.html(potentialFeudsHtml);
    // Show past feuds
    let pastFeudsHtml = '<div class="margin-bottom-5 font-0p925em dark-grey margin-left-2">Past Feuds</div>';
    data["pastFeuds"].forEach(function(feud) {
        pastFeudsHtml += $70adc4a1fd111893$var$getFeudDetailsHtml(feud);
    });
    if (data["pastFeuds"].length < 1) pastFeudsHtml += '<div class="grey margin-left-2 past-feuds-none-text">None</div>';
    $pastFeuds.html(pastFeudsHtml);
    $currentFeuds.children().show();
    $potentialFeuds.children().show();
    $pastFeuds.children().show();
    $(".feuds-history-sort").val("date").trigger("change");
    $("#feud-history-container").fadeIn("slow").removeClass("display-none");
    $(".current-feuds, .potential-feuds, .past-feuds").scrollTop(0);
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_feuds_menu_button");
}
function $70adc4a1fd111893$var$getFeudDetailsHtml(feud, order) {
    let duration = "";
    let sinceEnded = "";
    let endFeudButton = "";
    if (feud["monthsElapsed"] !== undefined) duration = feud["monthsElapsed"] + " " + (0, $3E8Nt.getMonthsWord)(feud["monthsElapsed"]) + " long";
    if (feud["monthsSinceBlowoff"] !== undefined) sinceEnded = feud["monthsSinceBlowoff"] + " " + (0, $3E8Nt.getMonthsWord)(feud["monthsSinceBlowoff"]) + " since end";
    else endFeudButton = '<button type="button" id="end-feud-button" class="button retro-button condensed grey-button-background margin-bottom-5">End Feud</button>';
    let potential = "";
    if (!feud["started"]) potential = '<div class="potential-feud-red">Potential</div>';
    let feudHot = "";
    if (feud["hot"]) feudHot = '<span class="hot-color margin-left-5">Hot</span>';
    let feudStale = "";
    if (feud["stale"]) feudStale = '<span class="stale-color margin-left-5">Stale</span>';
    let participants = feud["participants"].join(" vs ");
    let feudOrder = order ? order : feud["order"];
    return '<div class="margin-bottom-15 feud-history-item inside-box" data-uid="' + feud["uid"] + '" ' + 'data-hype="' + feud["hype"] + '" data-duration="' + feud["monthsElapsed"] + '" data-order="' + feudOrder + '" ' + 'data-name="' + feud["name"] + '" data-participants="' + feud["participants"].join(",").replace(/"/g, "&quot;") + '" tabindex="0">' + '<div class="margin-bottom-3 faded-red-light">' + feud["name"] + feudHot + feudStale + '<span class="float-right faded-red-light">' + '<i class="fa fa-bolt margin-right-5"></i>' + Math.round(feud["hype"]) + "</span>" + "</div>" + '<div class="grey">' + participants + "</div>" + potential + '<div class="light-grey">' + duration + "</div>" + '<div class="light-grey">' + sinceEnded + "</div>" + '<div class="margin-top-10">' + endFeudButton + "</div>" + "</div>";
}
async function $70adc4a1fd111893$var$loadViewFeudHistoryPage(uid, $el) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $cXLSF.getFeudHistoryData)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showViewFeudHistoryPageData(data, $el);
}
function $70adc4a1fd111893$var$showViewFeudHistoryPageData(data, $el) {
    let feudHistoryHtml = $70adc4a1fd111893$var$getFeudHistoryHtml(data);
    $(".feud-history").html(feudHistoryHtml).show();
    // Hide all labels and feuds
    $(".current-feuds").children().hide();
    $(".potential-feuds").children().hide();
    $(".past-feuds").children().hide();
    $el.addClass("selected").show();
    // Tutorial action check
    if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("select_feud_history_item");
}
function $70adc4a1fd111893$var$getFeudHistoryHtml(feud) {
    let history = "";
    if (feud["events"].length > 0) {
        // Win records
        feud["winRecords"].sort(function(a, b) {
            return b["wins"] - a["wins"];
        });
        let winRecords = Array.from(feud["winRecords"], function(participant) {
            return '{0}<span class="light-grey margin-left-5">{1}</span>'.format(participant["name"], participant["wins"]);
        }).join('<span class="margin-left-8">');
        history += '<div class="margin-top-10">';
        history += '<span class="display-block grey">Win Record</span>';
        history += '<span class="display-block dark-grey">' + winRecords + "</span>";
        history += "</div>";
        // Staleness check
        if (feud["staleLength"]) {
            history += '<div class="margin-top-20">';
            history += '<span class="display-block grey">Staleness Check</span>';
            history += '<span class="display-block dark-grey help-text margin-left-1" title="Monthly Event Matches add +1, Weekly Show Matches add +0.5 and Segments add +0.25 to the Feud\'s Staleness Check.">' + feud["stalenessCounter"] + " / " + '<span class="stale-color">' + feud["staleLength"] + "</span>" + "</span>";
            history += "</div>";
        }
        // Match/segment history
        history += '<div class="display-block grey margin-top-20">History</div>';
        feud["events"].forEach(function(event, i) {
            let blowoff = false;
            let html;
            if (i === 0) blowoff = true;
            if (event["eventType"] === "match") html = $70adc4a1fd111893$var$getMatchHistoryHtml(event, blowoff, true);
            else if (event["eventType"] === "segment") html = $70adc4a1fd111893$var$getSegmentHistoryHtml(event, blowoff, true);
            if (event["eventWeeklyShow"]) history += '<div class="margin-bottom-15 font-bold text-left"><div class="faded-blue">' + event["event"] + "</div>" + html + "</div>";
            else history += '<div class="margin-bottom-15 font-bold text-left"><div class="blue">' + event["event"] + "</div>" + html + "</div>";
        });
        if (feud["rating"]) history += '<div class="event-results-container text-left margin-bottom-5" tabindex="0"><div class=col1><span class="font-bold">Feud Rating</span></div><div class="col2 text-right"><span class="font-bold match-star-rating history text-right" role="text" aria-label="' + feud["rating"] + " stars" + '">' + (0, $1JSre.getStarRatingHtml)(feud["rating"]) + "</span>" + "</div>" + '<div class="clear"></div>' + "</div>";
        if (feud["pastFeuds"].length > 0) {
            // Past feuds
            history += '<div class="display-block grey margin-top-20 margin-bottom-5">Past Feuds</div>';
            feud["pastFeuds"].forEach(function(pastFeud) {
                let sinceEnded = "";
                if (pastFeud["monthsSinceBlowoff"] !== undefined) sinceEnded = pastFeud["monthsSinceBlowoff"] + " " + (0, $3E8Nt.getMonthsWord)(pastFeud["monthsSinceBlowoff"]) + " since end";
                let feudHot = "";
                if (pastFeud["hot"]) feudHot = '<span class="hot-color margin-left-8">Hot</span>';
                let feudStale = "";
                if (pastFeud["stale"]) feudStale = '<span class="stale-color margin-left-8">Stale</span>';
                let html = '<div class="margin-bottom-15"><div class="faded-red-light margin-left-1">' + pastFeud["name"] + feudHot + feudStale + '<span class="float-right faded-red-light">' + '<i class="fa fa-bolt margin-right-5"></i>' + Math.round(pastFeud["hype"]) + "</span>" + "</div>" + '<div class="light-grey">' + sinceEnded + "</div>" + "</div>";
                history += html;
            });
        }
    } else history += '<div class="font-bold text-left">No Matches or Segments held</div>';
    return history;
}
function $70adc4a1fd111893$var$applyFeudsHistorySort(value) {
    let sortedElements = $(".feud-history-item");
    let sortClass = "";
    if (value === "hype") {
        sortedElements.sort(function(a, b) {
            return parseFloat($(b).attr("data-hype")) - parseFloat($(a).attr("data-hype"));
        });
        sortClass = "fa-sort-down";
    } else if (value === "duration") {
        sortedElements.sort(function(a, b) {
            let durationA = $(a).attr("data-duration") !== "undefined" ? parseFloat($(a).attr("data-duration")) : 0;
            let durationB = $(b).attr("data-duration") !== "undefined" ? parseFloat($(b).attr("data-duration")) : 0;
            return durationB - durationA;
        });
        sortClass = "fa-sort-down";
    } else if (value === "date") {
        sortedElements.sort(function(a, b) {
            return parseFloat($(a).attr("data-order")) - parseFloat($(b).attr("data-order"));
        });
        sortClass = "fa-sort-down";
    }
    sortedElements.toArray().forEach(function(e) {
        $(e).parent().append(e);
    });
    // Select default sort order
    if (sortClass) {
        let sortOrderElement = $(".feuds-history-sort-order");
        let sortOrderIcon = sortOrderElement.find("i");
        sortOrderIcon.removeClass("fa-sort fa-sort-up fa-sort-down").addClass(sortClass);
        sortOrderElement.addClass("cursor-pointer");
    }
}
function $70adc4a1fd111893$var$runFeudHistorySearch() {
    let feudElements = $(".feud-history-item");
    let searchTerm = $(".feuds-history-search-input").val();
    // Show all feuds
    feudElements.show();
    // Run search
    if (searchTerm.length > 0) {
        let searchResults = (0, $1JSre.runFuseElementsSearch)(feudElements, searchTerm, [
            "dataset.name",
            "dataset.participants"
        ]);
        feudElements.toArray().forEach(function(e) {
            if (searchResults.indexOf(e) < 0) $(e).hide();
        });
        // Show results if found
        if (searchResults.length > 0) $(".no-feuds-history-search-results").hide();
        else $(".no-feuds-history-search-results").show();
    }
}
async function $70adc4a1fd111893$var$getEndFeudRequest(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $cXLSF.endViewFeudsFeud)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showEndFeudData(data);
}
function $70adc4a1fd111893$var$showEndFeudData(data) {
    // Show feud ended notification
    let rating = '<span class="display-inline-block margin-left-5">' + (0, $1JSre.getStarRatingHtml)(data["rating"]) + "</span>";
    let text = 'Ended the <span class="faded-red-light">' + data["name"] + "</span>" + " Feud between " + (0, $3E8Nt.commaSeparate)(data["participants"]) + " " + rating;
    notie.alert({
        type: 4,
        text: text,
        stay: true
    });
    // Go back to view feuds
    setTimeout(function() {
        $("#view-feuds-menu-button").trigger("click");
    }, 1200);
}
async function $70adc4a1fd111893$var$loadCreateFeudPage(participantType, participantUids, getParticipants, runHideContent) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let talentData;
    if (getParticipants) talentData = await (0, $cXLSF.getAllTalentData)(participantType);
    let itemsData = await (0, $cXLSF.getCreateFeudItemsData)(participantUids, participantType);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    if (runHideContent) (0, $1JSre.hideContent)($());
    if (talentData) $70adc4a1fd111893$var$showCreateFeudParticipantsData(talentData);
    $70adc4a1fd111893$var$showCreateFeudItemsData(itemsData);
}
function $70adc4a1fd111893$var$showCreateFeudParticipantsData(data) {
    (0, $lCS03.playSoundEffect)("success");
    // Populate participant select
    let $firstParticipantSelect = $("#create-feud .create-feud-first-participant-select");
    let $secondParticipantSelect = $("#create-feud .create-feud-second-participant-select");
    $firstParticipantSelect.html("");
    $secondParticipantSelect.html("");
    let optionsHtml = "";
    optionsHtml += "<option selected disabled>Select Participant</option>";
    data.forEach(function(participant) {
        optionsHtml += '<option value="' + participant["name"].replace(/"/g, "&quot;") + '" data-uid="' + participant["uid"] + '">' + participant["name"] + "</option>";
    });
    $firstParticipantSelect.html(optionsHtml);
    $secondParticipantSelect.html(optionsHtml);
    $("#create-feud").fadeIn("slow");
}
function $70adc4a1fd111893$var$showCreateFeudItemsData(data) {
    const $createFeudItemsContainer = $(".create-feud-items-container");
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        $createFeudItemsContainer.html("");
        data["availableFeudItems"].forEach(function(item) {
            let feudItemHtml = $70adc4a1fd111893$export$f5ff3b2dec6c145a(item, data["randomFeudName"]);
            $createFeudItemsContainer.append(feudItemHtml);
        });
        // Adjust custom feud name input's width
        $("#create-feud .feud-item-custom-name").trigger("input");
        // Unavailable feud items
        data["unavailableFeudItems"].forEach(function(item) {
            let feudItemHtml = $70adc4a1fd111893$export$131bc8800ece965d(item);
            $createFeudItemsContainer.append(feudItemHtml);
        });
        // Show randomize feud hint
        if (!$70adc4a1fd111893$var$randomizeFeudHintShown) {
            $70adc4a1fd111893$var$randomizeFeudHintShown = true;
            notie.alert({
                type: 4,
                text: '<span class="display-block">Click the <i class="fa fa-refresh grey"></i> button to randomize the Feud name or add your own</span>'
            });
        }
        $createFeudItemsContainer.scrollTop(0);
        $createFeudItemsContainer.show();
        (0, $acecca4a272c50a4$export$a0ca3fbd9bfabbf)((0, $98xmD.globals).currentTutorialStep);
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_create_feud_menu_button");
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "participant-not-found") notie.alert({
            type: 3,
            text: "The selected participants could not be found",
            stay: true
        });
    }
}
function $70adc4a1fd111893$var$getFeudItemUnlockedBy(feudItemName) {
    let unlockedByName;
    switch(feudItemName){
        case "That's My Title":
            unlockedByName = "New Challenger";
            break;
        case "Innovation":
            unlockedByName = "Who's the Best?";
            break;
        case "It's My Time Now":
            unlockedByName = "Taking My Spot";
            break;
        case "Us vs Them":
            unlockedByName = "This Is Our Home";
            break;
        case "Greatest Wrestler":
            unlockedByName = "Better Wrestler";
            break;
        case "Streak vs Career":
            unlockedByName = "Retire Me";
            break;
        case "Legend Killer":
            unlockedByName = "Stepping Up";
            break;
        case "Redemption":
            unlockedByName = "Friendly Contest";
            break;
        case "Corruption":
            unlockedByName = "Better Villain";
            break;
        case "Best in the World":
            unlockedByName = "Main Event Ready";
            break;
        case "Bitter Rivals":
            unlockedByName = "Rivals";
            break;
    }
    return unlockedByName;
}
async function $70adc4a1fd111893$var$getCreateFeudRequest(feudItemUid, customFeudName, participantUids, participantType) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $cXLSF.createFeud)(feudItemUid, customFeudName, participantUids, participantType);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showCreateFeudData(data);
}
function $70adc4a1fd111893$var$showCreateFeudData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        // Show feud name and participants
        let participants = data["feudParticipantNames"].join(" and ");
        let notieText = '<span class="display-block"><span class="faded-red-light">' + data["feudName"] + ' <span class="potential-feud-red">Potential</span>' + "</span>" + " Feud created between " + participants + "</span>" + "</span>";
        // Show consequence applied to
        if (data["consequenceAppliedTo"]) {
            let consequenceHtml = '<span class="faded-red-light">{0}</span>'.format((0, $3E8Nt.toTitleCase)(data["consequence"].replace(/-/g, " ")));
            notieText += '<span class="display-block">{0} Consequence applied to {1}</span>'.format(consequenceHtml, data["consequenceAppliedTo"]);
        }
        notie.alert({
            type: 4,
            text: notieText,
            stay: true
        });
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Unselect selected feud item
        $("#create-feud .feud-item-container.selected").trigger("click");
        // Reset inputs
        $("#create-feud .create-feud-first-participant-select").prop("selectedIndex", 0);
        $("#create-feud .create-feud-second-participant-select").prop("selectedIndex", 0);
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("create_feud");
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "feud-item-not-found") notie.alert({
            type: 3,
            text: "The selected Feud could not be found",
            stay: true
        });
        else if (data["error"] === "participant-not-found") notie.alert({
            type: 3,
            text: "The selected participants could not be found",
            stay: true
        });
        else if (data["error"] === "duplicate-participants") notie.alert({
            type: 3,
            text: "Participants cannot feud with themselves",
            stay: true
        });
        else if (data["error"] === "existing-feud-present") notie.alert({
            type: 3,
            text: "A Feud is already present between these participants",
            stay: true
        });
        else if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to create a Feud",
            stay: true
        });
    }
}
async function $70adc4a1fd111893$export$dc8337a6ea2458f6(companyUid, brandName) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getViewStatsData)(companyUid, brandName);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) companySelectData = await (0, $8A6FL.getCompanySelectData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show company select
    if (!companyUid) (0, $d3e44747ec383890$export$4e74726e57dcef35)(companySelectData, $(".select-company-for-view-stats"));
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewStatsPageData(data);
}
function $70adc4a1fd111893$var$showViewStatsPageData(data) {
    const $companyStatsDataContainer = $("#company-stats-data-container");
    // Select company
    $(".select-company-for-view-stats").val(data["companyName"].trim().replace(/\s+/g, " "));
    // Add brand filters
    $(".company-stats-brand-filters").html("");
    if (data["brandNames"].length > 0) data["brandNames"].forEach(function(rosterBrandName) {
        let selectedClass = "";
        if (rosterBrandName === data["brandName"]) selectedClass = " selected";
        let rosterBrandFilterHtml = '<button type="button" class="company-stats-brand-filter button retro-button condensed light-button-background' + selectedClass + '">' + rosterBrandName + "</button> ";
        $(".company-stats-brand-filters").append(rosterBrandFilterHtml);
    });
    // Company name
    let div = "";
    let companyName = '<div class="display-block dark-grey font-1p25em">' + data["companyName"] + "</div>";
    let inactive = "";
    if (data["inactive"]) inactive = '<div class="display-block grey margin-top-5">Inactive</div>';
    div += '<div class="display-block margin-bottom-15 margin-top-2">' + companyName + inactive + "</div>";
    // Iconic superstars
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Iconic Wrestlers</span>';
    data["iconicSuperstars"].forEach(function(superstar) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + superstar + "</span>";
    });
    if (data["iconicSuperstars"].length < 1) div += '<span class="display-block dark-grey">None</span>';
    div += "</div>";
    // Most over
    let mostOver = data["mostOverSuperstar"];
    if (!mostOver) mostOver = "None";
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Most Over</span>';
    div += '<span class="display-block dark-grey margin-bottom-2">' + mostOver + "</span>";
    div += "</div>";
    // Top heel/face
    let topHeel = data["topHeelSuperstar"];
    if (!topHeel) topHeel = "None";
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Top Heel</span>';
    div += '<span class="display-block dark-grey margin-bottom-2">' + topHeel + "</span>";
    div += "</div>";
    let topFace = data["topFaceSuperstar"];
    if (!topFace) topFace = "None";
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Top Face</span>';
    div += '<span class="display-block dark-grey margin-bottom-2">' + topFace + "</span>";
    div += "</div>";
    // Iconic teams
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Iconic Teams</span>';
    data["iconicTagTeams"].forEach(function(team) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + team + "</span>";
    });
    if (data["iconicTagTeams"].length < 1) div += '<span class="display-block dark-grey">None</span>';
    div += "</div>";
    // Iconic factions
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Iconic Factions</span>';
    data["iconicFactions"].forEach(function(faction) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + faction + "</span>";
    });
    if (data["iconicFactions"].length < 1) div += '<span class="display-block dark-grey">None</span>';
    div += "</div>";
    // Top championship
    let topChampionshipData = data["topChampionship"];
    let topChampionshipHtml = "None";
    if (topChampionshipData) topChampionshipHtml = topChampionshipData["name"] + ' <span class="display-inline-block font-17px">' + (0, $1JSre.getChampionshipPrestigeIconHtml)(topChampionshipData["prestige"]) + "</span>";
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Top Championship</span>';
    div += '<span class="display-block dark-grey margin-bottom-2">' + topChampionshipHtml + "</span>";
    div += "</div>";
    // Iconic events
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Best Events</span>';
    data["iconicEvents"].forEach(function(event) {
        let rating = (0, $1JSre.setRating)(event["rating"]);
        div += '<span class="display-block dark-grey margin-bottom-2">' + event["name"] + " " + event["year"] + '<span class="margin-left-10 display-inline-block">' + rating + "</span>" + "</span>";
    });
    if (data["iconicEvents"].length < 1) div += '<span class="display-block dark-grey">None</span>';
    div += "</div>";
    // Signature event
    if (data["signatureEvent"]) {
        let prestigeIcon;
        switch(data["signatureEvent"]["prestige"]){
            case "C":
                prestigeIcon = '<i class="fa fa-star-o font-bold bronze"></i>';
                break;
            case "B":
                prestigeIcon = '<i class="fa fa-star-o font-bold silver"></i>';
                break;
            case "A":
                prestigeIcon = '<i class="fa fa-star-o font-bold gold-light"></i>';
                break;
        }
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Signature Event</span>';
        div += '<span class="display-block dark-grey margin-bottom-2">' + data["signatureEvent"]["name"] + ' <span class="display-inline-block font-17px">' + prestigeIcon + "</span>" + "</span>";
        div += "</div>";
    }
    // Most bought event
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Most Buys</span>';
    if (data["mostBoughtEvent"]) div += '<span class="display-block dark-grey margin-bottom-2">' + data["mostBoughtEvent"]["name"] + " " + data["mostBoughtEvent"]["year"] + '<span class="light-grey margin-left-5">' + (0, $1JSre.getViewershipText)(data["mostBoughtEvent"]["buys"]) + "</span>" + "</span>";
    else div += '<span class="display-block dark-grey">None</span>';
    div += "</div>";
    // Highest viewership event
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Highest Viewership</span>';
    if (data["highestViewershipEvent"]) div += '<span class="display-block dark-grey margin-bottom-2">' + data["highestViewershipEvent"]["name"] + '<span class="light-grey margin-left-5">' + (0, $1JSre.getViewershipText)(data["highestViewershipEvent"]["viewership"]) + " (" + data["highestViewershipEvent"]["date"] + ")</span>" + "</span>";
    else div += '<span class="display-block dark-grey">None</span>';
    div += "</div>";
    // Iconic matches
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Best Matches</span>';
    data["iconicMatches"].forEach(function(match) {
        let rating = (0, $1JSre.setRating)(match["rating"]);
        let losers = match["losers"];
        let losersText;
        // Join losers with comma and 'and'
        if (losers.length > 1) losersText = losers.slice(0, -1).join(", ") + " and " + losers.slice(-1);
        else losersText = losers[0];
        let gimmickHtml = "";
        if (match["gimmick"]) gimmickHtml = '<span class="grey margin-left-8">{0} Match</span>'.format(match["gimmick"]);
        let text = '{0} <span class="light-grey">def.</span> {1}{2}<span class="light-grey margin-left-8">{3}</span>'.format(match["winner"]["name"], losersText, gimmickHtml, match["event"]);
        div += '<span class="display-block dark-grey margin-bottom-8">' + text + '<span class="margin-left-10 display-inline-block">' + rating + "</span>" + "</span>";
    });
    if (data["iconicMatches"].length < 1) div += '<span class="display-block dark-grey">None</span>';
    div += "</div>";
    // Iconic segments
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Best Segments</span>';
    data["iconicSegments"].forEach(function(segment) {
        let rating = (0, $1JSre.setRating)(segment["rating"]);
        let text = '{0}<span class="light-grey margin-left-8">{1}</span>'.format($70adc4a1fd111893$var$getSegmentText(segment), segment["event"]);
        div += '<span class="display-block dark-grey margin-bottom-8">' + text + '<span class="margin-left-10 display-inline-block">' + rating + "</span>" + "</span>";
    });
    if (data["iconicSegments"].length < 1) div += '<span class="display-block dark-grey">None</span>';
    div += "</div>";
    // Special segments
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Special Segments</span>';
    data["specialSegments"].forEach(function(segment) {
        let rating = (0, $1JSre.setRating)(segment["rating"]);
        let text = '{0}<span class="light-grey margin-left-8">{1}</span>'.format($70adc4a1fd111893$var$getSegmentText(segment), segment["event"]);
        div += '<span class="display-block dark-grey margin-bottom-8">' + text + '<span class="margin-left-10 display-inline-block">' + rating + "</span>" + "</span>";
    });
    if (data["specialSegments"].length < 1) div += '<span class="display-block dark-grey">None</span>';
    div += "</div>";
    // Iconic feuds
    if (data["iconicFeuds"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Feuds</span>';
        data["iconicFeuds"].forEach(function(feud) {
            let participantNames = feud["participants"].join(" and ");
            let feudName = feud["name"];
            let rating = '<span class="display-inline-block margin-left-8">' + (0, $1JSre.getStarRatingHtml)(feud["rating"]) + "</span>";
            let text = '<span class="faded-red-light">' + feudName + "</span>" + " between " + participantNames + rating;
            div += '<span class="display-block dark-grey margin-bottom-8">' + text + "</span>";
        });
        if (data["iconicFeuds"].length < 1) div += '<span class="display-block dark-grey">None</span>';
        div += "</div>";
    }
    // Top moments
    if (data["topMoments"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Moments</span>';
        data["topMoments"].forEach(function(moment) {
            div += '<span class="display-block dark-grey margin-bottom-8">' + moment["name"] + ' <span class="light-grey">' + moment["event"] + "</span>" + "</span>";
        });
        if (data["topMoments"].length < 1) div += '<span class="display-block dark-grey">None</span>';
        div += "</div>";
    }
    // Shocking turns
    if (data["shockingTurns"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Shocking Turns</span>';
        data["shockingTurns"].forEach(function(turn) {
            div += '<span class="display-block dark-grey margin-bottom-8">' + turn["name"] + ' <span class="light-grey">' + turn["event"] + "</span>" + "</span>";
        });
        if (data["shockingTurns"].length < 1) div += '<span class="display-block dark-grey">None</span>';
        div += "</div>";
    }
    // Awards won
    if (data["awardsWon"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Awards Won</span>';
        data["awardsWon"].forEach(function(award) {
            let trophy = "";
            switch(award["value"]){
                case 0:
                    trophy = "trophy_icon_trash";
                    break;
                case 1:
                    trophy = "trophy_icon_bronze";
                    break;
                case 2:
                    trophy = "trophy_icon_silver";
                    break;
                case 3:
                    trophy = "trophy_icon_gold";
                    break;
            }
            div += '<span class="display-block dark-grey margin-bottom-8"><img alt="Trophy" src="static/www/static/' + trophy + '.png" class="trophy-image margin-right-8"/>' + award["name"] + "</span>";
        });
        if (data["awardsWon"].length < 1) div += '<span class="display-block dark-grey">No Awards Won</span>';
        div += "</div>";
    }
    // Legends
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Legends</span>';
    data["legends"].forEach(function(legend) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + legend + "</span>";
    });
    if (data["legends"].length < 1) div += '<span class="display-block dark-grey">No Legends</span>';
    div += "</div>";
    // FotC losses
    if (data["fotcLosses"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Only Wrestlers to Beat ' + data["fotcLosses"]["name"] + "</span>";
        data["fotcLosses"]["losses"].forEach(function(loss) {
            div += '<span class="display-block dark-grey margin-bottom-2">' + loss + "</span>";
        });
        div += "</div>";
    }
    // Top signings
    if (data["topSignings"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Signings</span>';
        data["topSignings"].forEach(function(signing) {
            div += '<span class="display-block dark-grey margin-bottom-2">' + signing["name"] + '<span class="blue">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-10 margin-right-5"/>' + signing["value"] + "</span>" + "</span>";
        });
        if (data["topSignings"].length < 1) div += '<span class="display-block dark-grey">No Signings</span>';
        div += "</div>";
    }
    // Most world titles held
    if (data["mostWorldChampionshipsHeld"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most World Titles</span>';
        div += '<span class="display-block dark-grey">' + data["mostWorldChampionshipsHeld"]["name"] + '<span class="margin-left-5 light-grey">' + data["mostWorldChampionshipsHeld"]["number"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Most titles held
    if (data["mostChampionshipsHeld"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Titles</span>';
        div += '<span class="display-block dark-grey">' + data["mostChampionshipsHeld"]["name"] + '<span class="margin-left-5 light-grey">' + data["mostChampionshipsHeld"]["number"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Longest title reign
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Longest Title Reign</span>';
    if (data["longestReign"]) {
        let monthsText = "Months";
        if (data["longestReign"]["length"] === 1) monthsText = "Month";
        div += '<span class="display-block dark-grey">' + data["longestReign"]["championName"] + '<span class="margin-left-5 gold">' + data["longestReign"]["championshipName"] + "</span>" + '<span class="margin-left-5 light-grey">' + data["longestReign"]["length"] + " " + monthsText + "</span>" + "</span>";
    } else div += '<div class="display-block dark-grey">N/A</div>';
    div += "</div>";
    // Shortest title reign
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Shortest Title Reign</span>';
    if (data["shortestReign"]) {
        let monthsText = "Months";
        if (data["shortestReign"]["length"] === 1) monthsText = "Month";
        div += '<span class="display-block dark-grey">' + data["shortestReign"]["championName"] + '<span class="margin-left-5 gold">' + data["shortestReign"]["championshipName"] + "</span>" + '<span class="margin-left-5 light-grey">' + data["shortestReign"]["length"] + " " + monthsText + "</span>" + "</span>";
    } else div += '<div class="display-block dark-grey">N/A</div>';
    div += "</div>";
    // Greatest non world champion
    if (data["greatestNonWorldChampion"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Greatest to Not Win the Big One</span>';
        div += '<span class="display-block dark-grey">' + data["greatestNonWorldChampion"]["name"] + "</span>";
        div += "</div>";
    }
    // Most main events
    if (data["mostMainEvents"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Main Events</span>';
        div += '<span class="display-block dark-grey">' + data["mostMainEvents"]["name"] + '<span class="margin-left-5 light-grey">' + data["mostMainEvents"]["number"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Most opening matches
    if (data["mostOpeningMatches"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Opening Matches</span>';
        div += '<span class="display-block dark-grey">' + data["mostOpeningMatches"]["name"] + '<span class="margin-left-5 light-grey">' + data["mostOpeningMatches"]["number"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Top worker
    if (data["topWorker"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Worker</span>';
        div += '<span class="display-block dark-grey">' + data["topWorker"]["name"] + '<span class="margin-left-5 light-grey">Average Rating: ' + data["topWorker"]["rating"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Most 5 star matches
    if (data["mostFiveStarMatches"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Five Star Matches</span>';
        div += '<span class="display-block dark-grey">' + data["mostFiveStarMatches"]["name"] + '<span class="margin-left-5 light-grey">' + data["mostFiveStarMatches"]["number"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Top win percentage
    if (data["topWinPercentage"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Win Percentage</span>';
        div += '<span class="display-block dark-grey">' + data["topWinPercentage"]["name"] + '<span class="margin-left-5 light-grey">' + data["topWinPercentage"]["winPercentage"] + "%</span>" + "</span>";
        div += "</div>";
    }
    // Biggest streak
    if (data["biggestStreak"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Biggest Streak</span>';
        div += '<span class="display-block dark-grey">' + data["biggestStreak"]["holder"] + '<span class="margin-left-5 light-grey margin-right-5">' + data["biggestStreak"]["length"] + "-0</span>at " + "<span>" + data["biggestStreak"]["event"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Longest win streak
    if (data["longestWinningStreak"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Longest Winning Streak</span>';
        div += '<span class="display-block dark-grey">' + data["longestWinningStreak"]["name"] + '<span class="margin-left-5 light-grey">' + data["longestWinningStreak"]["length"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Longest losing streak
    if (data["longestLosingStreak"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Longest Losing Streak</span>';
        div += '<span class="display-block dark-grey">' + data["longestLosingStreak"]["name"] + '<span class="margin-left-5 light-grey">' + data["longestLosingStreak"]["length"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Greatest to not turn
    if (data["greatestToNotTurn"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Greatest to Never Turn</span>';
        div += '<span class="display-block dark-grey">' + data["greatestToNotTurn"]["name"] + "</span>";
        div += "</div>";
    }
    // Most simultaneous feuds
    if (data["mostSimultaneousFeuds"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Feuds at One Time</span>';
        div += '<span class="display-block dark-grey">' + data["mostSimultaneousFeuds"]["name"] + '<span class="margin-left-5 light-grey">' + data["mostSimultaneousFeuds"]["numberOfFeuds"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Best gimmick
    if (data["bestGimmick"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Best Gimmick</span>';
        div += '<span class="display-block dark-grey">' + data["bestGimmick"]["name"] + '<span class="margin-left-5 light-grey">' + data["bestGimmick"]["superstarName"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Worst gimmick
    if (data["worstGimmick"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Worst Gimmick</span>';
        div += '<span class="display-block dark-grey">' + data["worstGimmick"]["name"] + '<span class="margin-left-5 light-grey">' + data["worstGimmick"]["superstarName"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Longest gimmick
    if (data["longestGimmick"]) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Longest Gimmick</span>';
        div += '<span class="display-block dark-grey">' + data["longestGimmick"]["name"] + '<span class="margin-left-5 light-grey">' + data["longestGimmick"]["superstarName"] + "</span>" + "</span>";
        div += "</div>";
    }
    // Add html, show container
    $companyStatsDataContainer.html(div);
    $("#company-stats-container").fadeIn("slow");
    $companyStatsDataContainer.scrollTop(0);
}
async function $70adc4a1fd111893$export$a17c0ce7657de2dd() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getViewTournamentsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewTournamentsPageData(data);
}
function $70adc4a1fd111893$var$showViewTournamentsPageData(data) {
    const $tournamentHistoryContainer = $("#tournament-history-container");
    if (data["tournaments"].length > 0) {
        let tournament = data["tournaments"][0];
        const $selectTournamentForViewTournaments = $(".select-tournament-for-view-tournaments");
        // Add tournament select data
        $selectTournamentForViewTournaments.find("option").remove().end();
        data["tournaments"].forEach(function(tournament) {
            $(".select-tournament-for-view-tournaments").append('<option data-uid="' + tournament["uid"] + '">' + tournament["name"] + "</option>");
        });
        $("#tournament-container .tournament-history").show();
        $selectTournamentForViewTournaments.val(tournament["name"]);
        $70adc4a1fd111893$var$showTournamentData(tournament);
    } else {
        $("#tournament-container .tournament-details").html('<span class="font-bold display-block grey">No Tournaments held yet</span>');
        $("#tournament-container .tournament-history").html("").hide();
        $tournamentHistoryContainer.fadeIn("slow").removeClass("display-none");
        $(".select-tournament-for-view-tournaments").find("option").remove().end();
    }
    // Select tournament
    $tournamentHistoryContainer.off("change", ".select-tournament-for-view-tournaments");
    $tournamentHistoryContainer.on("change", ".select-tournament-for-view-tournaments", function() {
        let uid = parseInt($(this).find(":selected").attr("data-uid"));
        let tournament = data["tournaments"].filter(function(tournament) {
            return tournament["uid"] === uid;
        })[0];
        $70adc4a1fd111893$var$showTournamentData(tournament);
    });
}
function $70adc4a1fd111893$var$showTournamentData(tournament) {
    const $tournamentContainer = $("#tournament-container");
    // Reset
    $tournamentContainer.find(".tournament-history").html("");
    $tournamentContainer.find(".tournament-details").html("");
    // Get prestige
    let prestigeIcon;
    switch(tournament["prestige"]){
        case "C":
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6 bronze"></i>';
            break;
        case "B":
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6 silver"></i>';
            break;
        case "A":
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6 gold-light"></i>';
            break;
    }
    // Get progress to next level
    let progressHtml = "";
    if (tournament["prestige"]) {
        let progress;
        let levelXp = tournament["xpToNextPrestige"];
        if (tournament["prestige"] !== "A") progress = (tournament["xp"] - tournament["baseXp"]) / (levelXp - tournament["baseXp"]) * 100;
        else progress = 100;
        progressHtml = '<div class="event-prestige-progress history display-inline-block"><div class="progress-under help-text" title="' + tournament["xp"] + " / " + levelXp + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>" + "</div>";
    }
    // Show tournament details
    $("#tournament-container .tournament-details").append('<span class="font-bold display-block font-1p25em line-height-1p25em margin-bottom-5">' + tournament["name"] + "</span>" + '<span class="display-block medium-grey font-bold">' + '<span class="display-block margin-top-8 margin-bottom-15">' + progressHtml + prestigeIcon + "</span>" + "</span>");
    // Show tournament history for each time it was held
    tournament["history"].forEach(function(history, i) {
        let tournamentHistoryHtml = $70adc4a1fd111893$var$getTournamentHistoryHtml(history, i);
        $(".tournament-history").append(tournamentHistoryHtml);
    });
    // Navigate bracket rounds
    $tournamentContainer.off("click", ".tournament-bracket-next, .tournament-bracket-prev");
    $tournamentContainer.on("click", ".tournament-bracket-next, .tournament-bracket-prev", function() {
        let bracketContainer = $(this).closest(".tournament-bracket-container");
        let round = bracketContainer.attr("data-round");
        let rounds = bracketContainer.attr("data-rounds");
        let index = bracketContainer.attr("data-index");
        // Go to next/prev round
        if ($(this).hasClass("tournament-bracket-next")) round++;
        else round--;
        let bracket = tournament["history"][index]["bracket"][round];
        if (!bracket) return false;
        bracketContainer.attr("data-round", round);
        // Show new bracket
        let bracketHtml = $70adc4a1fd111893$export$d1c14a92b2f32dc8(bracket, round, rounds);
        $(".tournament-history .tournament-bracket-container").eq(index).html(bracketHtml).hide().fadeIn("fast");
    });
    $tournamentContainer.scrollTop(0);
    $("#tournament-history-container").hide().fadeIn("slow").removeClass("display-none");
}
function $70adc4a1fd111893$var$getTournamentHistoryHtml(data, index) {
    let historyHtml = "";
    // History Container
    historyHtml += '<div class="margin-top-30">';
    // Add event name, year, award
    let awardHtml = "";
    if (data["awardName"]) awardHtml = '<span class="gold display-block text-center">' + data["awardName"] + "</span>";
    historyHtml += '<span class="display-block font-bold year text-center margin-bottom-5">' + data["event"] + " " + data["eventYear"] + awardHtml + "</span>" + '<div class="margin-bottom-10">';
    // Check for winner
    if (data["winnerName"]) historyHtml += '<span class="display-block light-grey text-center font-bold">Winner</span><span class="cyan display-block text-center">' + data["winnerName"] + "</span>";
    historyHtml += "</div>";
    // Add bracket
    if (data["bracket"]) {
        let tournamentRound = data["startRound"] + 1; // Start with knockout round, or 1 by default
        let tournamentRounds = Object.keys(data["bracket"]).length;
        let bracketHtml = $70adc4a1fd111893$export$d1c14a92b2f32dc8(data["bracket"][tournamentRound], tournamentRound, tournamentRounds, false, data["startRound"]);
        historyHtml += '<div class="tournament-bracket-container history font-bold margin-top-10" data-index="' + index + '" data-round="' + tournamentRound + '" data-rounds="' + tournamentRounds + '">' + bracketHtml + "</div>";
    }
    // Add table
    if (data["table"]) {
        let tableHtml = $70adc4a1fd111893$export$b15b76cf4991fb5f(data["table"], data["participantsAdvancing"], true);
        historyHtml += '<div class="font-bold margin-bottom-20 margin-top-20">' + tableHtml + "</div>";
    }
    historyHtml += "</div>";
    return historyHtml;
}
async function $70adc4a1fd111893$export$8881fe1fb1468eac() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getViewGimmickMatchesData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewGimmickMatchesPageData(data);
}
function $70adc4a1fd111893$var$showViewGimmickMatchesPageData(data) {
    const $viewGimmickMatchesItemsContainer = $(".view-gimmick-matches-items-container");
    // Reset
    $viewGimmickMatchesItemsContainer.html("");
    // Add gimmick matches
    data["gimmickMatches"].forEach(function(gimmickMatch) {
        let gimmickMatchHtml = $70adc4a1fd111893$var$getViewGimmickMatchesPageGimmickMatchHtml(gimmickMatch);
        $viewGimmickMatchesItemsContainer.append(gimmickMatchHtml);
    });
    if (data["gimmickMatches"].length === 0) {
        let div = '<div class="view-gimmick-matches-item"><div><span class="grey">No Gimmick Matches present</span></div></div>';
        $(".view-gimmick-matches-items-container").append(div);
    }
    $("#view-gimmick-matches-container").fadeIn("slow");
    $viewGimmickMatchesItemsContainer.scrollTop(0);
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_view_gimmick_matches_menu_button");
}
function $70adc4a1fd111893$var$getViewGimmickMatchesPageGimmickMatchHtml(gimmickMatch) {
    let div;
    // Set level
    let level;
    switch(gimmickMatch["level"]){
        case 1:
            level = '<i class="fa fa-star-o gimmick-match-level-icon bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o gimmick-match-level-icon silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o gimmick-match-level-icon gold-light"></i>';
            break;
    }
    // Set boosts
    let rating, pop, injury;
    rating = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch["ratingBoost"]);
    if (gimmickMatch["ratingBoost"] < 3) rating += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch["ratingBoost"]);
    pop = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch["popularityBoost"]);
    if (gimmickMatch["popularityBoost"] < 3) pop += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch["popularityBoost"]);
    injury = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch["injuryRate"]);
    if (gimmickMatch["injuryRate"] < 3) injury += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch["injuryRate"]);
    let fatigueHtml = "";
    if ((0, $98xmD.globals).game.settings["enable_fatigue"] !== false) {
        let fatigueText = '<span class="gimmick-match-fatigue-value"><span class="margin-right-2">+</span>' + gimmickMatch["fatigueChange"] + '<span class="margin-left-2">%</span></span>';
        fatigueHtml = '<div class="medium-grey"><span class="gimmick-match-label">Fatigue</span> ' + fatigueText + "</div>";
    }
    // Info
    let specialMatchHtml = "";
    if (gimmickMatch["cashinContractName"]) specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 gold">Cash-in Contract</span>';
    else if (gimmickMatch["matchContractName"]) specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 gold">Fixed Match Contract</span>';
    else if (gimmickMatch["consequence"] === "loser_unavailable") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Loser Unavailable</span>';
    else if (gimmickMatch["consequence"] === "remove_hair") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Remove Hair</span>';
    else if (gimmickMatch["consequence"] === "add_hair") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Add Hair</span>';
    else if (gimmickMatch["consequence"] === "random_opponent") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Random Opponent</span>';
    else if (gimmickMatch["consequence"] === "remove_mask") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Remove Mask</span>';
    else if (gimmickMatch["consequence"] === "remove_mask_or_hair") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Remove Mask or Hair</span>';
    else if (gimmickMatch["rules"] === "2/3_falls") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Best of Three Falls</span>';
    else if (gimmickMatch["rules"] === "special_referee") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Guest Referee</span>';
    else if (gimmickMatch["rules"] === "elimination") specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">Superstar Elimination</span>';
    // Add description if present
    let descriptionHtml = "";
    if (gimmickMatch["description"]) descriptionHtml = '<div class="medium-light-grey">' + (0, $1JSre.escapeHTML)(gimmickMatch["description"]) + "</div>";
    // Get progress to next level
    let progress;
    let levelXp;
    if (gimmickMatch["level"] < 3) {
        levelXp = Math.pow(gimmickMatch["level"], 2) * 50;
        progress = gimmickMatch["xp"] / levelXp * 100;
    } else {
        levelXp = Math.pow(2, 2) * 50;
        progress = 100;
    }
    let progressHtml = '<div class="margin-bottom-2 margin-top-12 item-progress-container display-inline-block"><div class="progress-under help-text" title="' + gimmickMatch["xp"] + " / " + levelXp + ' XP">' + '<div class="progress" style="width:' + progress + '%">' + "</div>" + "</div>" + "</div>";
    div = '<div class="view-gimmick-matches-item"><div class="margin-bottom-8"><span class="">' + gimmickMatch["name"] + "</span>" + '<span class="blue float-right top--2px">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-2"/> ' + gimmickMatch["cost"] + "</span>" + "</div>" + descriptionHtml + '<div class="margin-top-7">' + '<div class="medium-grey">' + '<span class="gimmick-match-label">Rating</span> ' + rating + "</div>" + '<div class="medium-grey">' + '<span class="gimmick-match-label">Pop.</span> ' + pop + "</div>" + '<div class="medium-grey">' + '<span class="gimmick-match-label">Injury</span> ' + injury + "</div>" + fatigueHtml + "</div>" + "<div>" + specialMatchHtml + progressHtml + level + "</div>" + "</div>";
    return div;
}
async function $70adc4a1fd111893$var$loadRemoveGimmickMatchesPage() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getRemoveGimmickMatchesData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showRemoveGimmickMatchesPageData(data);
}
function $70adc4a1fd111893$var$showRemoveGimmickMatchesPageData(data) {
    let $select = $("#remove-gimmick-match .select-gimmick-match");
    $select.html("");
    $.each(data, function() {
        $select.append($("<option />").val(this).text(this));
    });
    $("#remove-gimmick-match").fadeIn("slow").removeClass("display-none");
}
async function $70adc4a1fd111893$var$getRemoveGimmickMatchRequest(name) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.removeGimmickMatch)(name);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showRemoveGimmickMatchData(data);
}
function $70adc4a1fd111893$var$showRemoveGimmickMatchData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block">' + data["name"] + " Match removed" + "</span>";
        notie.alert({
            type: 4,
            text: html
        });
        // Select next gimmick match
        let selected = $("#remove-gimmick-match .select-gimmick-match").find(":selected");
        selected.next().prop("selected", true);
        // Remove gimmick match
        selected.remove();
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "The Gimmick Match could not be found. Please try again."
        });
    }
}
async function $70adc4a1fd111893$var$getAddGimmickMatchRequest() {
    if ((0, $98xmD.globals).requestRunning) return;
    // Validate
    let name = $('#add-gimmick-match input[name="match-name"]').val();
    let cashinContractName = $('#add-gimmick-match input[name="cashin-contract-name"]').val();
    let cashinContractExpiry = $('#add-gimmick-match input[name="cashin-contract-expiry"]').val();
    let matchContractName = $('#add-gimmick-match input[name="match-contract-name"]').val();
    let consequence = $('#add-gimmick-match select[name="match-consequence"]').val();
    let rules = $('#add-gimmick-match select[name="match-rules"]').val();
    let ratingBoost = $('#add-gimmick-match select[name="match-rating-boost"]').val();
    let popularityBoost = $('#add-gimmick-match select[name="match-popularity-boost"]').val();
    let injuryRate = $('#add-gimmick-match select[name="match-injury-rate"]').val();
    let graphicType = $('#add-gimmick-match select[name="match-graphic"]').val();
    let addRandomWeapons = $('#add-gimmick-match select[name="match-add-random-weapons"]').val();
    if (name.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Gimmick Match"
        });
        return false;
    }
    if (consequence === "cashin_contract") {
        if (cashinContractName.length <= 0) {
            notie.alert({
                type: 3,
                text: "Enter a name for the Cash-in Contract"
            });
            return false;
        }
        if (cashinContractExpiry.length <= 0 || !parseInt(cashinContractExpiry)) {
            notie.alert({
                type: 3,
                text: "Enter a number greater than 0 for Months to Expire for the Cash-in Contract"
            });
            return false;
        }
    }
    if (consequence === "match_contract") {
        if (matchContractName.length <= 0) {
            notie.alert({
                type: 3,
                text: "Enter a name for the Match Contract"
            });
            return false;
        }
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.addGimmickMatch)(name, rules, ratingBoost, popularityBoost, injuryRate, consequence, cashinContractName, cashinContractExpiry, matchContractName, graphicType, addRandomWeapons);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showAddGimmickMatchData(data);
}
function $70adc4a1fd111893$var$showAddGimmickMatchData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block">' + data["name"] + " Match added!" + "</span>";
        notie.alert({
            type: 4,
            text: html
        });
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Tutorial action check
        if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
        // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("add_gimmick_match");
        // Go back to view gimmick matches
        setTimeout(function() {
            $("#view-gimmick-matches-menu-button").trigger("click");
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        let notieText = "";
        if (data["error"] === "already-exists") notieText = "You already have a Gimmick Match with that name";
        else if (data["error"] === "not-enough-points") notieText = "You do not have enough Creative Points to add a Gimmick Match";
        else if (data["error"] === "match-contract-exists") notieText = "You already have a Match Contract with that name";
        else if (data["error"] === "cashin-contract-exists") notieText = "You already have a Cash-in Contract with that name";
        else if (data["error"] === "pow-femme-fatale") notieText = '"That\'s my idea!" - Hank Hughes';
        else if (data["error"] === "pow-cashin") notieText = "\"I don't want anyone winning the championship like that. You'll have to do it the old fashioned way.\" - Hank Hughes";
        notie.alert({
            type: 3,
            text: notieText
        });
    }
}
async function $70adc4a1fd111893$export$c37f99627b0b98ac(companyUid) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getViewTitlesData)(companyUid);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) companySelectData = await (0, $8A6FL.getCompanySelectData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show company select
    if (!companyUid) (0, $d3e44747ec383890$export$4e74726e57dcef35)(companySelectData, $(".select-company-for-view-titles"));
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showViewTitlesPageData(data);
}
function $70adc4a1fd111893$var$showViewTitlesPageData(data) {
    const $titleStatsContainer = $("#title-stats-container");
    const $titlesBox = $("#titles-box");
    const $companyChampionshipSelect = $(".company-championship-select");
    $titleStatsContainer.html("");
    $(".select-company-for-view-titles").val(data["companyName"].trim().replace(/\s+/g, " "));
    let inactive = data["inactive"];
    let championships = data["championships"];
    // Get championship
    let index = 0;
    let championship = championships[index];
    if (championships.length > 0) {
        // Add select data
        $companyChampionshipSelect.find("option").remove().end();
        championships.forEach(function(championship) {
            let name = championship["name"];
            if (championship.retired) name += " (r)";
            $(".company-championship-select").append("<option>" + name + "</option>");
        });
        // Select first title. Remove double spaces.
        $companyChampionshipSelect.val(championship["name"].trim().replace(/\s+/g, " "));
        // Show stats for first title
        $70adc4a1fd111893$var$showTitleStatsPageData(championship, inactive);
    } else // None text
    $titleStatsContainer.html('<span class="grey">No Titles present</span>');
    $titlesBox.fadeIn("slow");
    $titleStatsContainer.scrollTop(0);
    // Select championship, show stats
    $titlesBox.off("change", ".company-championship-select");
    $titlesBox.on("change", ".company-championship-select", function() {
        index = $companyChampionshipSelect.prop("selectedIndex");
        championship = championships[index];
        $70adc4a1fd111893$var$showTitleStatsPageData(championship, inactive);
        $titleStatsContainer.scrollTop(0);
    });
}
function $70adc4a1fd111893$var$showTitleStatsPageData(data, inactive) {
    const $titleStatsContainer = $("#title-stats-container");
    $titleStatsContainer.html("");
    let div = "";
    div += '<div id="championship-stats-graphic" class="margin-bottom-20"></div>';
    // Name, inactive text
    let championshipName = '<div class="display-block gold font-1p125em">' + data["name"] + "</div>";
    let inactiveHtml = "";
    if (inactive) inactiveHtml = '<div class="display-block grey">Inactive</div>';
    let retiredText = "";
    if (data["retired"]) retiredText = '<div class="display-block">Retired</div>';
    // Brand
    let brandNameHtml = "";
    if (data["brandName"] && !data["retired"]) brandNameHtml = '<div class="display-block grey">Exclusive to ' + data["brandName"] + "</div>";
    // Rank
    let rankHtml = '<div class="display-block grey">' + data["rank"] + "</div>";
    // Gimmick Restriction
    let gimmickRestrictionHtml = "";
    let gimmickRestrictionText = (0, $1JSre.getChampionshipGimmickRestrictionText)(data["gimmickRestriction"]);
    if (gimmickRestrictionText) gimmickRestrictionHtml = '<div class="display-block grey">' + gimmickRestrictionText + "</div>";
    // Prestige progress
    let prestigeHtml = '<div class="margin-top-10">' + (0, $1JSre.getChampionshipPrestigeProgressHtml)(data["prestigeData"]) + "</div>";
    div += '<div class="display-block margin-bottom-20">' + championshipName + retiredText + brandNameHtml + rankHtml + inactiveHtml + gimmickRestrictionHtml + prestigeHtml + "</div>";
    // Add stats if present
    if (data["reignsData"] !== undefined) {
        // Current champion
        if (!data["retired"]) {
            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-2">Current Champion</div>';
            if (data["currentReign"]) {
                let monthsWord = data["currentReign"]["length"] === 1 ? "Month" : "Months";
                let defensesWord = data["currentReign"]["numberOfDefenses"] === 1 ? "Defense" : "Defenses";
                let reignDefenses = "{0} {1}".format(data["currentReign"]["numberOfDefenses"], defensesWord);
                let reignLength = "{0} {1}".format(data["currentReign"]["length"], monthsWord);
                div += '<span class="display-block dark-grey">' + data["currentReign"]["championName"] + '<span class="margin-left-7 light-grey">' + reignLength + "</span>" + '<span class="margin-left-5 medium-light-grey">' + reignDefenses + "</span>" + "</span>";
            } else div += '<div class="display-block light-grey">Vacant</div>';
            div += "</div>";
        }
        // Longest reigns
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Longest Reigns</div>';
        data["longestReigns"].forEach(function(reign) {
            let monthsWord = reign["length"] === 1 ? "Month" : "Months";
            let defensesWord = reign["numberOfDefenses"] === 1 ? "Defense" : "Defenses";
            let reignDefenses = "{0} {1}".format(reign["numberOfDefenses"], defensesWord);
            let reignLength = "{0} {1}".format(reign["length"], monthsWord);
            div += '<span class="display-block dark-grey">' + reign["championName"] + '<span class="margin-left-7 light-grey">' + reignLength + "</span>" + '<span class="margin-left-5 medium-light-grey">' + reignDefenses + "</span>" + "</span>";
        });
        if (data["longestReigns"].length <= 0) div += '<div class="display-block dark-grey">N/A</div>';
        div += "</div>";
        // Shortest reign
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Shortest Reign</div>';
        if (data["shortestReign"]) {
            let monthsText = "Months";
            if (data["shortestReign"]["length"] === 1) monthsText = "Month";
            div += '<div class="display-block dark-grey">' + data["shortestReign"]["championName"] + '<span class="margin-left-5 light-grey">' + data["shortestReign"]["length"] + " " + monthsText + "</span>" + "</div>";
        } else div += '<div class="display-block dark-grey">N/A</div>';
        div += "</div>";
        // Most reigns
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Most Reigns</div>';
        if (data["mostReigns"] !== undefined) {
            let monthsText = "Reigns";
            if (data["mostReigns"]["number"] === 1) monthsText = "Reign";
            div += '<div class="display-block dark-grey">' + data["mostReigns"]["name"] + '<span class="margin-left-5 light-grey">' + data["mostReigns"]["number"] + " " + monthsText + "</span>" + "</div>";
        } else div += '<div class="display-block dark-grey">N/A</div>';
        div += "</div>";
        // Best match
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Best Match</div>';
        let bestMatch = data["bestMatch"];
        if (bestMatch) div += $70adc4a1fd111893$var$getTitleReignMatchHtml(bestMatch, false);
        else div += '<div class="display-block dark-grey">N/A</div>';
        div += "</div>";
        // Worst match
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Worst Match</div>';
        let worstMatch = data["worstMatch"];
        if (worstMatch) div += $70adc4a1fd111893$var$getTitleReignMatchHtml(worstMatch, false);
        else div += '<div class="display-block dark-grey">N/A</div>';
        div += "</div>";
        // Title changes + Months per reign
        let averageReign = "";
        if (data["averageReignLength"]) {
            let averageReignText = "Months per Reign";
            if (data["averageReignLength"] === 1) averageReignText = "Month per Reign";
            averageReign = data["averageReignLength"] + " " + averageReignText;
        }
        let changesText = "Title Changes";
        if (data["changes"] === 1) changesText = "Title Change";
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Title Changes</div>';
        div += '<span class="dark-grey">' + data["changes"] + " " + changesText + "</span>";
        if (averageReign) div += '<span class="margin-left-10 light-grey">' + averageReign + "</span>";
        div += "</div>";
        // Reigns
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block margin-bottom-5 blue">Reign History</div>';
        if (data["reignsData"].length > 0) data["reignsData"].forEach(function(reign) {
            // Reign
            let monthsWord = reign["length"] === 1 ? "Month" : "Months";
            let defensesWord = reign["numberOfDefenses"] === 1 ? "Defense" : "Defenses";
            let reignDefenses = "{0} {1}".format(reign["numberOfDefenses"], defensesWord);
            let reignLength = "{0} {1}".format(reign["length"], monthsWord);
            div += '<div class="margin-bottom-15 display-block">';
            div += '<div class="margin-bottom-5 display-block">';
            div += '<div class="display-block dark-grey">' + reign["championName"] + '<span class="margin-left-7 light-grey">' + reignLength + "</span>" + '<span class="margin-left-5 medium-light-grey">' + reignDefenses + "</span>" + "</div>";
            div += "</div>";
            // Matches
            div += '<div class="title-history-box">';
            // Vacated
            if (reign["vacated"]) div += '<div class="margin-bottom-8 title-history-item"><div class="display-block red">Vacated</div></div>';
            // Retired
            if (reign["retired"]) div += '<div class="margin-bottom-8 title-history-item"><div class="display-block red">Retired</div></div>';
            if (reign["matchesData"].length > 0) reign["matchesData"].forEach(function(match) {
                div += '<div class="margin-bottom-8 title-history-item">';
                div += $70adc4a1fd111893$var$getTitleReignMatchHtml(match, true, false);
                div += "</div>";
            });
            else div += '<div class="margin-bottom-8 title-history-item light-grey">No title matches</div>';
            div += "</div>";
            div += "</div>";
        });
        else div += '<div class="title-history-box">No Reigns</div>';
        div += "</div>";
    } else // Show JoW Paid text
    div += '<div><div class="margin-top-15"><span class="display-block light-grey">Title Stats are only available in JoW Paid. View stats like Reign History, Best Matches, Most Reigns and more.</span></div></div>';
    $titleStatsContainer.append(div);
    // Show graphic
    let el = $("#championship-stats-graphic");
    if (data["graphic"]) (0, $c82cd471f4baff6b$export$ea5c1fdc48a35ee)(el, data["graphic"]);
    else el.hide();
}
function $70adc4a1fd111893$var$getTitleReignMatchHtml(match, addChampionshipChange = true, addRating = true) {
    // Join losers with comma and 'and'
    let losers = match["losers"];
    let losersText;
    if (losers.length > 1) losersText = losers.slice(0, -1).join(", ") + " and " + losers.slice(-1);
    else losersText = losers[0];
    // Championship
    let championshipText = "";
    if (match["winner"]["championshipsWon"] && addChampionshipChange) championshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold">' + match["winner"]["championshipsWon"] + "</span></span>";
    if (match["winner"]["championshipsRetained"] && addChampionshipChange) championshipText = '<span class="margin-left-5">(No Title Change)</span>';
    // Tournament details
    let tournamentText = "";
    if (match["tournamentName"]) tournamentText = " (" + match["tournamentName"] + " " + match["tournamentRoundName"] + ")";
    // Match gimmick
    let gimmickHtml = "";
    if (match["gimmick"]) gimmickHtml = '<span class="grey margin-left-8">{0} Match</span>'.format(match["gimmick"]);
    // Rating
    let ratingHtml = "";
    if (addRating) ratingHtml = '<span class="margin-left-10 display-inline-block">' + (0, $1JSre.setRating)(match["rating"]) + "</span>";
    let text = "";
    if ([
        "Double Pin",
        "Time-limit Draw",
        "Ring Collapse"
    ].indexOf(match["finishName"]) >= 0) text = '{0} <span class="light-grey">vs</span> {1} (No Contest){2}<span class="light-grey margin-left-8">{3}</span>{4}'.format(match["winner"]["name"], losersText, gimmickHtml, match["event"], tournamentText);
    else text = '{0} <span class="light-grey">def.</span> {1}{2}{3}<span class="light-grey margin-left-8">{4}</span>{5}'.format(match["winner"]["name"], losersText, championshipText, gimmickHtml, match["event"], tournamentText);
    return '<div class="display-block dark-grey">' + text + ratingHtml + "</div>";
}
function $70adc4a1fd111893$var$getAddChampionshipCost(parent, addGimmickCost) {
    if (typeof addGimmickCost === "undefined") addGimmickCost = true;
    let rankValue = parent.find("select[name=championship-rank]").val();
    let points = 0;
    switch(rankValue){
        case "Main Eventer":
            points = 250;
            break;
        case "Upper Midcarder":
            points = 150;
            break;
        case "Lower Midcarder":
            points = 100;
            break;
        case "Jabroni":
            points = 50;
            break;
    }
    if (parent.hasClass("rebrand-championship-container")) points += 50;
    if (addGimmickCost) {
        let championshipGimmick = parent.find(".championship-gimmick-select").val();
        if (championshipGimmick && championshipGimmick !== "none") points += 100;
    }
    return points;
}
async function $70adc4a1fd111893$var$loadAddChampionshipPage() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let gimmickMatches = await (0, $8A6FL.getCompanyGimmickMatchesForChampionshipGimmick)();
    let brandNames = await (0, $8A6FL.getCompanyBrandNames)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showAddChampionshipPageData(brandNames, gimmickMatches);
}
function $70adc4a1fd111893$var$showAddChampionshipPageData(brandNames, gimmickMatches) {
    // Add brand names to select
    let brandNameSelect = $('.add-championship-container select[name="championship-brand"]');
    let brandNamesOptions = '<option value="">None</option>';
    brandNames.forEach(function(brandName) {
        brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + "</option>";
    });
    brandNameSelect.html(brandNamesOptions);
    // Load default graphic
    let el = $("#championship-graphic");
    (0, $c82cd471f4baff6b$export$3b20358be464ca0c)(el, null);
    let addChampionshipElement = $(".add-championship-container");
    addChampionshipElement.fadeIn("slow").removeClass("display-none");
    addChampionshipElement.find(".character-creator-controls").show();
    // Reset inputs
    addChampionshipElement.find("input").val("");
    addChampionshipElement.find('select[name="championship-rank"]').val("Upper Midcarder").trigger("change");
    addChampionshipElement.find('select[name="championship-division"]').val("singles").trigger("change");
    addChampionshipElement.find('select[name="championship-graphic-option"]').val("1").trigger("change");
    addChampionshipElement.find('select[name="championship-gimmick-select"]').val("none").trigger("change");
    if ((0, $98xmD.globalUser).paid) addChampionshipElement.find('select[name="championship-brand"]').parent().show();
    else addChampionshipElement.find('select[name="championship-brand"]').parent().hide();
    // Show championship gimmick inputs
    const $gimmickSelect = $(".add-championship-container .championship-gimmick-select");
    $gimmickSelect.off("change");
    $gimmickSelect.on("change", function() {
        let value = $(this).val();
        const $addChampionshipGimmickMatchSelect = $(".add-championship-container .championship-gimmick-match-select");
        const $addChampionshipMaximumAgeInput = $(".add-championship-container .championship-maximum-age-input");
        const $addChampionshipMinimumAgeInput = $(".add-championship-container .championship-minimum-age-input");
        $addChampionshipGimmickMatchSelect.parent().hide();
        $addChampionshipMaximumAgeInput.parent().hide();
        $addChampionshipMinimumAgeInput.parent().hide();
        if (value === "gimmick_match") {
            let gimmickMatchSelectDiv = $addChampionshipGimmickMatchSelect;
            gimmickMatchSelectDiv.parent().show();
            // Populate with gimmick matches
            gimmickMatchSelectDiv.html("");
            gimmickMatchSelectDiv.append($("<option />").val("Any").text("Any"));
            gimmickMatches.forEach(function(gimmickMatch) {
                gimmickMatchSelectDiv.append($("<option />").val(gimmickMatch).text(gimmickMatch));
            });
        } else if (value === "maximum_age") $addChampionshipMaximumAgeInput.parent().show();
        else if (value === "minimum_age") $addChampionshipMinimumAgeInput.parent().show();
        // Update cost
        let cost = $70adc4a1fd111893$var$getAddChampionshipCost($(".add-championship-container"));
        $(this).closest(".add-championship-container").find(".add-championship-cost").text(cost);
    });
}
async function $70adc4a1fd111893$var$loadVacateChampionshipPage($selectElement, selectedChampionship) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getCompanyChampionshipsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showVacateChampionshipPageData(data, $selectElement, selectedChampionship);
}
function $70adc4a1fd111893$var$showVacateChampionshipPageData(data, $selectElement, selectedChampionship) {
    $selectElement.html("");
    data["championships"].forEach(function(championship) {
        let select = $("<option></option>");
        select.text(championship["name"]);
        select.data("uid", championship["uid"]);
        $selectElement.append(select);
    });
    // Select previously selected championship
    $selectElement.val(selectedChampionship);
    if ($selectElement.val() === null) $selectElement.prop("selectedIndex", 0);
    $("#vacate-championship").fadeIn("slow");
}
async function $70adc4a1fd111893$var$loadRetireChampionshipPage($selectElement, selectedChampionship) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.getCompanyChampionshipsData)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showRetireChampionshipPageData(data, $selectElement, selectedChampionship);
}
function $70adc4a1fd111893$var$showRetireChampionshipPageData(data, $selectElement, selectedChampionship) {
    $selectElement.html("");
    data["championships"].forEach(function(championship) {
        let select = $("<option></option>");
        select.text(championship["name"]);
        select.data("uid", championship["uid"]);
        $selectElement.append(select);
    });
    // Select previously selected championship
    $selectElement.val(selectedChampionship);
    if ($selectElement.val() === null) $selectElement.prop("selectedIndex", 0);
    $("#retire-championship").fadeIn("slow");
}
async function $70adc4a1fd111893$var$loadRebrandChampionshipPage($element, selectedChampionship) {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let gimmickMatches = await (0, $8A6FL.getCompanyGimmickMatchesForChampionshipGimmick)();
    let data = await (0, $8A6FL.getCompanyChampionshipsData)(false);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    (0, $1JSre.hideContent)($());
    $70adc4a1fd111893$var$showRebrandChampionshipPageData(data, $element, selectedChampionship, gimmickMatches);
}
function $70adc4a1fd111893$var$showRebrandChampionshipPageData(data, $element, selectedChampionship, gimmickMatches) {
    // Reset name input
    $element.find(".rebrand-championship-name-input").val("");
    // Add championships to select, with uid, graphic and brand as data attributes
    let selectElement = $element.find(".rebrand-championship-championship-select");
    selectElement.html("");
    data["championships"].forEach(function(championship) {
        let select = $("<option></option>");
        select.text(championship["name"]);
        select.data("uid", championship["uid"]);
        select.data("graphic", championship["graphic"]);
        select.data("gimmickRestriction", championship["gimmickRestriction"]);
        select.data("brandName", championship["brandName"]);
        selectElement.append(select);
    });
    // Select previously selected championship
    selectElement.val(selectedChampionship);
    if (selectElement.val() === null) selectElement.prop("selectedIndex", 0);
    if (data["championships"].length > 0) {
        // Load title graphic for selected title
        $("#change-championship-graphic").data("key", JSON.stringify(data["championships"][selectElement.prop("selectedIndex")]["graphic"]));
        $('input:radio[name="radio-change-championship-graphic-option"][value="change"]').trigger("change").trigger("click");
    }
    // Add brand names
    let brandNamesOptions = '<option value="">None</option>';
    data["brandNames"].forEach(function(brandName) {
        brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + "</option>";
    });
    $element.find(".rebrand-championship-brand-select").html(brandNamesOptions);
    // Show championship gimmick inputs
    const $rebrandChampionshipContainer = $(".rebrand-championship-container");
    $rebrandChampionshipContainer.off("change", ".championship-gimmick-select");
    $rebrandChampionshipContainer.on("change", ".championship-gimmick-select", function() {
        let value = $(this).val();
        let addGimmickCost = true;
        const $rebrandChampionshipGimmickMatchSelect = $(".rebrand-championship-container .championship-gimmick-match-select");
        const $rebrandChampionshipMaximumAgeInput = $(".rebrand-championship-container .championship-maximum-age-input");
        const $rebrandChampionshipMinimumAgeInput = $(".rebrand-championship-container .championship-minimum-age-input");
        if (value === "gimmick_match") {
            let gimmickMatchSelectDiv = $rebrandChampionshipGimmickMatchSelect;
            let gimmickMatchSelectDivDefaultValue = gimmickMatchSelectDiv.data("default-value");
            // Don't add championship gimmick cost if already added
            if (gimmickMatchSelectDivDefaultValue) addGimmickCost = false;
            // Populate with gimmick matches
            gimmickMatchSelectDiv.html("");
            gimmickMatchSelectDiv.append($("<option />").val("Any").text("Any"));
            gimmickMatches.forEach(function(gimmickMatch) {
                gimmickMatchSelectDiv.append($("<option />").val(gimmickMatch).text(gimmickMatch));
            });
            // Add default value if present
            if (gimmickMatchSelectDivDefaultValue) {
                gimmickMatchSelectDiv.val(gimmickMatchSelectDivDefaultValue);
                gimmickMatchSelectDiv.data("default-value", null);
            }
            $rebrandChampionshipGimmickMatchSelect.parent().hide();
            $rebrandChampionshipMaximumAgeInput.parent().hide();
            $rebrandChampionshipMinimumAgeInput.parent().hide();
            gimmickMatchSelectDiv.parent().show();
        } else if (value === "maximum_age") {
            // Reset input
            let ageInputDiv = $rebrandChampionshipMaximumAgeInput;
            ageInputDiv.val("");
            // Add default value if present
            let ageInputDivDefaultValue = ageInputDiv.data("default-value");
            if (ageInputDivDefaultValue) {
                ageInputDiv.val(ageInputDivDefaultValue);
                ageInputDiv.data("default-value", null);
                addGimmickCost = false;
            }
            $rebrandChampionshipGimmickMatchSelect.parent().hide();
            $rebrandChampionshipMaximumAgeInput.parent().hide();
            $rebrandChampionshipMinimumAgeInput.parent().hide();
            ageInputDiv.parent().show();
        } else if (value === "minimum_age") {
            let ageInputDiv = $rebrandChampionshipMinimumAgeInput;
            ageInputDiv.val("");
            let ageInputDivDefaultValue = ageInputDiv.data("default-value");
            if (ageInputDivDefaultValue) {
                ageInputDiv.val(ageInputDivDefaultValue);
                ageInputDiv.data("default-value", null);
                addGimmickCost = false;
            }
            $rebrandChampionshipGimmickMatchSelect.parent().hide();
            $rebrandChampionshipMaximumAgeInput.parent().hide();
            $rebrandChampionshipMinimumAgeInput.parent().hide();
            ageInputDiv.parent().show();
        } else {
            $rebrandChampionshipGimmickMatchSelect.parent().hide();
            $rebrandChampionshipMaximumAgeInput.parent().hide();
            $rebrandChampionshipMinimumAgeInput.parent().hide();
        }
        // Update cost
        let cost = $70adc4a1fd111893$var$getAddChampionshipCost($(".rebrand-championship-container"), addGimmickCost);
        $(this).closest(".rebrand-championship-container").find(".rebrand-championship-cost").text(cost);
    });
    // Load gimmick restriction for selected title
    $(".rebrand-championship-championship-select").trigger("change");
    $element.fadeIn("slow").removeClass("display-none");
}
async function $70adc4a1fd111893$var$getAddChampionshipRequest() {
    if ((0, $98xmD.globals).requestRunning) return;
    let name = $(".add-championship-container input[name=championship-name]").val();
    let championUid = parseInt($(".add-championship-container select[name=championship-champion]").val());
    let rank = $(".add-championship-container select[name=championship-rank]").val();
    let championshipDivision = $(".add-championship-container select[name=championship-division]").val();
    let addGraphic = $(".add-championship-container select[name='championship-graphic-option']").val() === "1";
    let brandName = $(".add-championship-container select[name='championship-brand']").val();
    // Get gimmick
    let gimmickMatchName;
    let gimmickRestrictionMaxAge;
    let gimmickRestrictionMinAge;
    let gimmickRestriction = $(".add-championship-container .championship-gimmick-select").val();
    if (gimmickRestriction === "gimmick_match") gimmickMatchName = $(".add-championship-container .championship-gimmick-match-select").val();
    else if (gimmickRestriction === "maximum_age") gimmickRestrictionMaxAge = $(".add-championship-container .championship-maximum-age-input").val();
    else if (gimmickRestriction === "minimum_age") gimmickRestrictionMinAge = $(".add-championship-container .championship-minimum-age-input").val();
    // Get graphic data
    $(".add-championship-container .share-character").trigger("click").removeClass("selected");
    $(".add-championship-container .share-character-code-container").hide();
    let graphicData = $(".add-championship-container .share-character-code-input").val();
    // Validate
    if (name.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter a name for the Championship"
        });
        return false;
    }
    if (gimmickRestriction === "maximum_age") {
        if (gimmickRestrictionMaxAge.length <= 0 || !parseInt(gimmickRestrictionMaxAge)) {
            notie.alert({
                type: 3,
                text: "Enter a number greater than 0 for the Maximum Age"
            });
            return false;
        }
    }
    if (gimmickRestriction === "minimum_age") {
        if (gimmickRestrictionMinAge.length <= 0 || !parseInt(gimmickRestrictionMinAge)) {
            notie.alert({
                type: 3,
                text: "Enter a number greater than 0 for the Minimum Age"
            });
            return false;
        }
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.addChampionship)(name, rank, championUid, championshipDivision, addGraphic, graphicData, gimmickRestriction, gimmickMatchName, gimmickRestrictionMaxAge, gimmickRestrictionMinAge, brandName);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showAddChampionshipData(data);
}
function $70adc4a1fd111893$var$showAddChampionshipData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let html = '<span class="display-block"><span class="gold">' + data["championshipName"] + "</span>" + " added" + "</span>";
        notie.alert({
            type: 4,
            text: html
        });
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to view titles
        setTimeout(function() {
            $("#view-titles-menu-button").trigger("click");
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "level-2-production-facility-required") notie.alert({
            type: 3,
            text: "You need to have the Championship Gimmicks Facility (Level 2 Production) present in order to add Gimmicks to Championships."
        });
        else if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "Brands are only available in JoW Paid"
        });
        else if (data["error"] === "brand-not-found") notie.alert({
            type: 3,
            text: "That brand could not be found. Please try again"
        });
        else if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points"
        });
        else if (data["error"] === "already-exists") notie.alert({
            type: 3,
            text: "A Championship with that name already exists in your Company"
        });
        else if (data["error"] === "champion-not-found") notie.alert({
            type: 3,
            text: "That talent could not be found for the selected division"
        });
    }
}
function $70adc4a1fd111893$var$showVacateChampionshipData({ data: data } = {}) {
    if (!data["error"]) {
        let text;
        if (data["tag"]) text = '<span class="display-block"><span class="gold">' + data["championshipName"] + "</span>" + " have been vacated" + "</span>";
        else text = '<span class="display-block"><span class="gold">' + data["championshipName"] + "</span>" + " has been vacated" + "</span>";
        // Show lowered prestige if vacated too often
        if (data["vacatedTooOftenXpDecrease"]) {
            let xpChange = '<span class="red margin-left-5">- ' + data["vacatedTooOftenXpDecrease"] * -1 + " XP</span>";
            text += '<span class="display-block">Prestige decreased due to being vacated too often ' + xpChange + "</span>";
        }
        notie.alert({
            type: 4,
            text: text,
            stay: true
        });
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    } else {
        if (data["error"] === "not-found") notie.alert({
            type: 3,
            text: "That Championship could not be found"
        });
        else if (data["error"] === "already-vacant") notie.alert({
            type: 3,
            text: "That championship is already vacant"
        });
        else if (data["error"] === "pow-title") notie.alert({
            type: 3,
            text: "\"I can't let you vacate the POW Championship like this. You'll have to find another way to do it.\" - Hank Hughes"
        });
    }
}
async function $70adc4a1fd111893$var$getRetireChampionshipRequest(uid) {
    if ((0, $98xmD.globals).requestRunning) return;
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.retireChampionship)(uid);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showRetireChampionshipData(data);
}
function $70adc4a1fd111893$var$showRetireChampionshipData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let text;
        if (data["tag"]) text = '<span class="gold">' + data["championshipName"] + "</span> have been retired, returning " + '<span class="blue margin-left-3">' + " <img alt='Points' src='static/www/static/cp_icon.png' class='points-image-small'/> " + data["pointsReturned"] + "</span>";
        else text = '<span class="gold">' + data["championshipName"] + "</span> has been retired, returning " + '<span class="blue margin-left-3">' + " <img alt='Points' src='static/www/static/cp_icon.png' class='points-image-small'/> " + data["pointsReturned"] + "</span>";
        let html = '<span class="display-block">' + text + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true
        });
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        // Select next championship
        let selected = $("#retire-championship .select-championship-all").find(":selected");
        selected.next().prop("selected", true);
        // Remove deleted championship
        selected.remove();
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "championship-not-found") notie.alert({
            type: 3,
            text: "That Championship could not be found"
        });
        else if (data["error"] === "pow-title") notie.alert({
            type: 3,
            text: '"No, you can\'t retire the POW Championship." - Hank Hughes'
        });
    }
}
async function $70adc4a1fd111893$var$getRebrandChampionshipRequest() {
    if ((0, $98xmD.globals).requestRunning) return;
    let uid = $(".rebrand-championship-container .rebrand-championship-championship-select").find(":selected").data("uid");
    let name = $(".rebrand-championship-container .rebrand-championship-name-input").val().trim();
    let appearanceOption = $('.rebrand-championship-container input[name="radio-change-championship-graphic-option"]:checked').val();
    let brandName = $(".rebrand-championship-container .rebrand-championship-brand-select").val();
    // Get graphic if 'change' graphic selected
    let graphicData;
    if (appearanceOption === "change") {
        $("#change-championship-graphic-container .share-character").trigger("click").removeClass("selected");
        $("#change-championship-graphic-container .share-character-code-container").hide();
        graphicData = $("#change-championship-graphic-container .share-character-code-input").val();
    }
    // Get gimmick
    let gimmickMatchName;
    let gimmickRestrictionMaxAge;
    let gimmickRestrictionMinAge;
    let gimmickRestriction = $(".rebrand-championship-container .championship-gimmick-select").val();
    if (gimmickRestriction === "gimmick_match") gimmickMatchName = $(".rebrand-championship-container .championship-gimmick-match-select").val();
    else if (gimmickRestriction === "maximum_age") {
        gimmickRestrictionMaxAge = $(".rebrand-championship-container .championship-maximum-age-input").val();
        if (gimmickRestrictionMaxAge === "") {
            notie.alert({
                type: 3,
                text: "Enter the maximum age for this Championship Gimmick"
            });
            return false;
        }
    } else if (gimmickRestriction === "minimum_age") {
        gimmickRestrictionMinAge = $(".rebrand-championship-container .championship-minimum-age-input").val();
        if (gimmickRestrictionMinAge === "") {
            notie.alert({
                type: 3,
                text: "Enter the minimum age for this Championship Gimmick"
            });
            return false;
        }
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.rebrandChampionship)(uid, name, appearanceOption, graphicData, gimmickRestriction, gimmickMatchName, gimmickRestrictionMaxAge, gimmickRestrictionMinAge, brandName);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showRebrandChampionshipData(data);
}
function $70adc4a1fd111893$var$showRebrandChampionshipData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        let notieText = '<span class="display-block">Rebranded {0}</span>'.format(data["previousName"]);
        // Show lowered prestige if vacated too often
        if (data["rebrandXpChange"]) {
            let xpChange = '<span class="red margin-left-5">- ' + data["rebrandXpChange"] * -1 + " XP</span>";
            notieText += '<span class="display-block">Prestige decreased due to rebranding ' + xpChange + "</span>";
        }
        notie.alert({
            type: 4,
            text: notieText
        });
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        // Go back to view titles
        setTimeout(function() {
            $("#view-titles-menu-button").trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to change this Championship's Name"
        });
        else if (data["error"] === "mars") notie.alert({
            type: 3,
            text: "You cannot change Championship Names in Wrestling on Mars"
        });
        else if (data["error"] === "pow-title") notie.alert({
            type: 3,
            text: '"We don\'t need to make any changes to the POW Championship." - Hank Hughes'
        });
        else if (data["error"] === "already-exists") notie.alert({
            type: 3,
            text: "A Championship with that name already exists in your Company"
        });
        else if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "Brands are only available in JoW Paid"
        });
        else if (data["error"] === "brand-not-found") notie.alert({
            type: 3,
            text: "That brand could not be found. Please try again"
        });
        else if (data["error"] === "level-2-production-facility-required") notie.alert({
            type: 3,
            text: "You need to have the Championship Gimmicks Facility (Level 2 Production) present in order to add Gimmicks to Championships."
        });
    }
}
async function $70adc4a1fd111893$var$getRebrandCompanyRequest() {
    if ((0, $98xmD.globals).requestRunning) return;
    let name = $(".rebrand-company-container .rebrand-company-name-input").val().trim();
    // Check if name entered
    if (name.length <= 0) {
        notie.alert({
            type: 3,
            text: "Enter a name for your Company",
            stay: true
        });
        return false;
    }
    // Get data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let data = await (0, $8A6FL.rebrandCompany)(name);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show data
    $70adc4a1fd111893$var$showRebrandCompanyData(data);
}
function $70adc4a1fd111893$var$showRebrandCompanyData(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
        notie.alert({
            type: 4,
            text: "{0} has been Rebranded to {1}".format(data["previousName"], data["newName"])
        });
        // Update company name
        $("#company-name").html((0, $1JSre.getCompanyHeaderHtml)(data["newName"], data["playerName"]));
        // Go back to view companies
        setTimeout(function() {
            $("#view-companies-menu-button").trigger("click");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to rebrand your Company"
        });
        else if (data["error"] === "story") notie.alert({
            type: 3,
            text: "You cannot rebrand your Company in Stories"
        });
        else if (data["error"] === "name-exists") notie.alert({
            type: 3,
            text: "A Company with that name already exists"
        });
    }
}
function $70adc4a1fd111893$var$showBuyPowerupData({ data: data, powerupContainer: powerupContainer } = {}) {
    if (!data["error"]) {
        // Add use button if stock goes from 0 to 1
        if (data["stock"] > 0) {
            if (!powerupContainer.find(".use-powerup").length) {
                let useButton = '<button type="button" class="button retro-button condensed margin-left-5 blue-button-background use-powerup">Use</button>';
                powerupContainer.find(".buy-powerup").after(useButton);
            }
        }
        // Update stock
        powerupContainer.find(".powerup-stock-number").text(data["stock"]).hide().fadeIn();
        // Update points
        let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    } else if (data["error"] === "not-enough-points") notie.alert({
        type: 3,
        text: "You do not have enough Creative Points to buy a use of this " + (0, $98xmD.globals).game.powerupWord
    });
}
function $70adc4a1fd111893$var$showUsePowerupData({ data: data, powerupContainer: powerupContainer } = {}) {
    $("#powerups-selection").html("");
    if (!data["error"]) {
        let div;
        // Show selections
        if (data["selections"].length > 0) {
            let text;
            if (data["help"]) text = data["help"];
            else text = "Activate " + (0, $98xmD.globals).game.powerupWord + " on";
            div = '<span class="powerups-selection-text light-grey display-block font-bold margin-bottom-10 margin-left-5">' + text + "</span>";
            let powerupsHtml = "";
            data["selections"].forEach(function(selection) {
                powerupsHtml += '<div class="powerups-selection-item" data-uid="' + selection["uid"] + '">' + selection["name"] + "</div>";
            });
            div += '<div class="powerups-selection-container">' + powerupsHtml + "</div>";
        } else div = '<div class="powerups-selection-item">Activate</div>';
        $("#powerups-selection").append(div);
        powerupContainer.siblings().hide();
        powerupContainer.addClass("selected");
        powerupContainer.find(".powerup-bottom").hide();
        powerupContainer.find(".powerup-cancel").show();
        powerupContainer.find(".powerup-description").show();
        powerupContainer.removeClass("help-text");
        $("#powerups-selection").fadeIn();
        $(".powerups-header").hide();
        $(".powerups-selection-container").scrollTop(0);
        // Add powerup uid
        $("#powerups-selection").attr("data-uid", data["uid"]);
    } else {
        let text;
        if (data["error"] === "not-available") // Set error text
        switch(data["selectionsType"]){
            case "matches":
                text = "You don't have any matches booked to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            case "non_multi_matches":
                text = "You don't have any non multi-person matches booked to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            case "training_superstars":
                text = "You don't have any training superstars to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            case "part_time_superstars":
                text = "You don't have any part time superstars to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            case "retired_superstars":
                text = "You don't have any eligible retired superstars to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            case "injured_superstars":
                text = "You don't have any injured superstars to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            case "returning_superstars":
                text = "You don't have any superstars returning from injury to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            case "unhappy_superstars":
                text = "You don't have any unhappy superstars to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            case "dead_superstars":
                text = "You don't have any dead superstars to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            case "past_gimmick_superstars":
                text = "You don't have any superstars with past gimmicks to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
                break;
            default:
                text = "You don't have anything available to activate this " + (0, $98xmD.globals).game.powerupWord + " on.";
        }
        else if (data["error"] === "stock-empty") text = "You don't have any available uses of this " + (0, $98xmD.globals).game.powerupWord + ".";
        else if (data["error"] === "trade-deal-active") text = "You're already running a trade deal.";
        else if (data["error"] === "upcoming-show-active") text = "This " + (0, $98xmD.globals).game.powerupWord + " has already been applied to the upcoming event.";
        let div;
        div = '<span class="powerups-selection-text light-grey display-block font-bold margin-bottom-10 margin-left-5">' + text + "</span>";
        $("#powerups-selection").append(div);
        powerupContainer.siblings().hide();
        powerupContainer.addClass("selected");
        powerupContainer.find(".powerup-bottom").hide();
        powerupContainer.find(".powerup-cancel").show();
        powerupContainer.find(".powerup-description").show();
        $("#powerups-selection").fadeIn();
        $(".powerups-header").hide();
        // Add powerup uid
        $("#powerups-selection").attr("data-uid", data["uid"]);
    }
}
async function $70adc4a1fd111893$var$showApplyPowerupData({ data: data } = {}) {
    if (!data["error"]) {
        (0, $98xmD.globals).requestRunning = true;
        notie.alert({
            type: 4,
            text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Running',
            stay: true
        });
        let selectedPowerup = $("#powerups-inventory").find(".selected");
        let image = selectedPowerup.find(".powerup-image").find("img");
        // Hide cancel button
        selectedPowerup.find(".powerup-cancel-button").hide();
        // Animate powerup
        let animation = "dissolve";
        if ((0, $98xmD.globals).game.story === "mars") animation = "use-experiment";
        setTimeout(function() {
            image.removeClass("pulse").addClass(animation);
        }, 0);
        setTimeout(async function() {
            (0, $98xmD.globals).requestRunning = false;
            image.removeClass(animation);
            notie.hideAlerts();
            // Hide stock number for dissolve animation
            if (animation === "dissolve") selectedPowerup.find(".powerup-stock-number").hide();
            if ((0, $98xmD.globals).game.story !== "mars") image.addClass("transparent");
            // Show result and back button
            let text = '<span class="powerups-selection-text medium-grey display-block font-bold margin-bottom-8 margin-left-5 line-height-24px">' + data["result"] + "</span>";
            let backButton = '<button type="button" class="powerups-back-button display-block button retro-button condensed blue-button-background margin-left-5">Back</button>';
            $("#powerups-selection").html(text + backButton).fadeIn();
            // Update event card
            let effects = [
                "increase_matches",
                "virtual",
                "raise_multiplier",
                "gimmick_match_roulette",
                "allow_other_brands",
                "allow_other_brands_extended"
            ];
            if (effects.indexOf(data["effect"]) >= 0) await $70adc4a1fd111893$export$7e05ff2c2988840c();
            // Update game style if changed
            if (data["style"]) (0, $98xmD.globals).game.style = data["style"];
        }, 2100);
        // Back button
        $("#powerups-box").off("click", ".powerups-back-button");
        $("#powerups-box").on("click", ".powerups-back-button", function() {
            image.removeClass("transparent");
            if ((0, $98xmD.globals).game.story !== "mars") image.addClass("pulse");
            // Show powerups
            $("#powerups-inventory").children().show();
            selectedPowerup.removeClass("selected").find(".powerup-bottom").show();
            selectedPowerup.find(".powerup-stock-number").show();
            selectedPowerup.find(".powerup-cancel").hide();
            selectedPowerup.find(".powerup-description").hide();
            selectedPowerup.find(".powerup-cancel-button").show();
            // Update stock
            selectedPowerup.find(".powerup-stock-number").text(data["stock"]).hide().fadeIn();
            // Remove use button if stock is 0
            if (data["stock"] === 0) selectedPowerup.find(".use-powerup").remove();
            $("#powerups-selection").hide();
            $(".powerups-header").show();
            // Update unread messages
            if (data["unreadMessages"]) {
                let unreadMessages = data["unreadMessages"].toLocaleString("en");
                $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
                $(".messages-number").text(unreadMessages);
                $("#messages").hide().fadeIn("fast");
            }
        });
    } else {
        if (data["error"] === "stock-empty") notie.alert({
            type: 3,
            text: "You don't have any available uses of this " + (0, $98xmD.globals).game.powerupWord + "."
        });
        else if (data["error"] === "virtual-exemption") notie.alert({
            type: 3,
            text: "The Virtual Experiment can't be applied to the Olympus Mons Match!"
        });
        else if (data["error"] === "empty-roster") notie.alert({
            type: 3,
            text: "There are no available superstars in that company's roster!"
        });
        else if (data["error"] === "max-roster-capacity") notie.alert({
            type: 3,
            text: "You do not have enough space in your roster. Release superstars or raise your Company Reputation to increase roster capacity."
        });
        else if (data["error"] === "not-enough-competitor-superstars") notie.alert({
            type: 3,
            text: "There are not enough superstars in that company's roster!"
        });
        else if (data["error"] === "no-competitors-present") notie.alert({
            type: 3,
            text: "There are no competitors present"
        });
        else if (data["error"] === "not-enough-superstars") notie.alert({
            type: 3,
            text: "There are not enough superstars in your roster!"
        });
        else if (data["error"] === "champion") notie.alert({
            type: 3,
            text: "This " + (0, $98xmD.globals).game.powerupWord + " cannot be used on a champion"
        });
        else if (data["error"] === "injured") notie.alert({
            type: 3,
            text: "This " + (0, $98xmD.globals).game.powerupWord + " cannot be used on an injured superstar"
        });
        else if (data["error"] === "suspensionMonths") notie.alert({
            type: 3,
            text: "This " + (0, $98xmD.globals).game.powerupWord + " cannot be used on a suspended superstar"
        });
        else if (data["error"] === "no-appearances") notie.alert({
            type: 3,
            text: "This " + (0, $98xmD.globals).game.powerupWord + " cannot be used on a part timer with no appearances left"
        });
        else if (data["error"] === "cannot-use-on-event") notie.alert({
            type: 3,
            text: "An " + (0, $98xmD.globals).game.powerupWord + " has already been used on this Event"
        });
        else if (data["error"] === "no-gimmick-matches-available") notie.alert({
            type: 3,
            text: "There are no basic Gimmick Matches present"
        });
        else if (data["error"] === "gimmick-match-already-present") notie.alert({
            type: 3,
            text: "This Match is already a Gimmick Match"
        });
        else if (data["error"] === "owner-not-found") notie.alert({
            type: 3,
            text: "The owner could not be found in the roster"
        });
        else if (data["error"] === "event-already-non-exclusive") notie.alert({
            type: 3,
            text: "This Event already allows Superstars from all brands to be booked."
        });
    }
}
function $70adc4a1fd111893$export$131bc8800ece965d(item, addToMatch) {
    let lockedText = "Locked: Unlocked with Feud Item Prestige (JoW Paid)";
    if ((0, $98xmD.globalUser).paid) lockedText = "Locked: Unlocked with Feud Item Prestige";
    // Set level
    let level;
    switch(item["level"]){
        case 1:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px gold-light"></i>';
            break;
    }
    let consequence = "No Consq.";
    if (item["consequence"]) {
        let consequenceText = item["consequence"];
        if (consequenceText === "retirement-or-unmasking") consequenceText = "retirement-/-unmasking";
        consequence = '<span class="faded-red-light">' + (0, $3E8Nt.toTitleCase)(consequenceText.replace(/-/g, " ")) + "</span>";
    }
    let requirement = "";
    if (item["requirement"]) requirement = '<div class="sky-blue feud-item-requirement">' + (0, $3E8Nt.toTitleCase)(item["requirement"].replace(/-/g, " ")) + "</div>";
    else requirement = '<div class="feud-item-requirement">No Reqs.</div>';
    // Get progress to next level
    let progress;
    let levelXp;
    if (item["level"] < 3) {
        levelXp = Math.pow(item["level"], 2) * 50;
        progress = item["xp"] / levelXp * 100;
    } else {
        levelXp = Math.pow(2, 2) * 50;
        progress = 100;
    }
    let progressHtml = '<div class="margin-top-8 margin-bottom-3 item-progress-container display-inline-block"><div class="progress-under help-text" title="' + item["xp"] + " / " + levelXp + ' XP">' + '<div class="progress faded-red-light-background" style="width:' + progress + '%">' + "</div>" + "</div>" + "</div>";
    let div;
    if (addToMatch) {
        if (item["unlocked"]) div = '<div class="feud-item-container item-container font-bold disabled"><div class="margin-bottom-5">' + item["name"] + "</div>" + '<div class="grey">' + '<i class="fa fa-bolt margin-right-5"></i>' + "??" + "</div>" + '<div class="grey">' + consequence + "</div>" + '<div class="light-grey">' + requirement + "</div>" + progressHtml + level + "</div>";
        else {
            let unlockedBy = $70adc4a1fd111893$var$getFeudItemUnlockedBy(item["name"]);
            let unlockText = " (by getting Gold Prestige on " + unlockedBy + ")";
            div = '<div class="feud-item-container item-container font-bold disabled locked help-text" title="' + lockedText + unlockText + '">' + '<div class="margin-bottom-5">' + item["name"] + "</div>" + '<div class="grey">' + '<i class="fa fa-bolt margin-right-5"></i>' + "??" + "</div>" + '<div class="grey">' + consequence + "</div>" + '<div class="light-grey">' + requirement + "</div>" + progressHtml + level + "</div>";
        }
    } else if (item["unlocked"]) div = '<div class="feud-item-container item-container font-bold disabled"><div class="margin-bottom-5">' + item["name"] + '<span class="float-right grey">' + '<i class="fa fa-bolt margin-right-5"></i>' + "??" + "</span>" + "</div>" + '<div class="grey">' + consequence + "</div>" + '<div class="light-grey">' + requirement + "</div>" + progressHtml + level + "</div>";
    else {
        let unlockedBy = $70adc4a1fd111893$var$getFeudItemUnlockedBy(item["name"]);
        let unlockText = " (by getting Gold Prestige on " + unlockedBy + ")";
        div = '<div class="feud-item-container item-container font-bold disabled locked help-text" title="' + lockedText + unlockText + '">' + '<div class="margin-bottom-5">' + item["name"] + '<span class="float-right grey">' + '<i class="fa fa-bolt margin-right-5"></i>' + "??" + "</span>" + "</div>" + '<div class="grey">' + consequence + "</div>" + '<div class="light-grey">' + requirement + "</div>" + progressHtml + level + "</div>";
    }
    return div;
}
function $70adc4a1fd111893$export$f5ff3b2dec6c145a(item, randomFeudName, addToMatch) {
    // Set level
    let level;
    switch(item["level"]){
        case 1:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px gold-light"></i>';
            break;
    }
    let consequence = "No Consq.";
    if (item["consequence"]) {
        let consequenceText = item["consequence"];
        if (consequenceText === "retirement-or-unmasking") consequenceText = "retirement-/-unmasking";
        consequence = '<span class="faded-red-light">' + (0, $3E8Nt.toTitleCase)(consequenceText.replace(/-/g, " ")) + "</span>";
    }
    let requirement = "";
    if (item["requirement"]) requirement = '<div class="sky-blue feud-item-requirement">' + (0, $3E8Nt.toTitleCase)(item["requirement"].replace(/-/g, " ")) + "</div>";
    else requirement = '<div class="feud-item-requirement">No Reqs.</div>';
    let helpClass = "";
    let titleHtml = "";
    if (item["description"]) {
        helpClass = " help-text";
        titleHtml = ' title="' + item["description"] + '"';
    }
    let name = item["name"];
    let generate = "";
    if (name === "Grudge") {
        let randomName = (0, $3E8Nt.getRandomChoice)([
            "Grudge",
            randomFeudName
        ]);
        if (addToMatch) {
            name = '<span id="feud-items-container-custom-name-hide"></span><input type="text" id="feud-items-container-custom-name" maxlength="25" value="' + randomName + '" class="feud-item-custom-name help-text compact" title="Enter a custom Feud name">';
            generate = '<i class="fa fa-refresh generate-feud-name-icon help-text" title="Randomize Feud Name"></i>';
        } else {
            name = '<span id="create-feud-custom-name-hide"></span><input type="text" id="create-feud-custom-name" maxlength="25" value="' + randomName + '" class="feud-item-custom-name help-text" title="Enter a custom Feud name">';
            generate = '<i class="fa fa-refresh generate-feud-name-icon help-text" title="Randomize Feud Name"></i>';
        }
    }
    // Get progress to next level
    let progress;
    let levelXp;
    if (item["level"] < 3) {
        levelXp = Math.pow(item["level"], 2) * 50;
        progress = item["xp"] / levelXp * 100;
    } else {
        levelXp = Math.pow(2, 2) * 50;
        progress = 100;
    }
    let progressHtml = '<div class="margin-top-8 margin-bottom-3 item-progress-container display-inline-block"><div class="progress-under help-text" title="' + item["xp"] + " / " + levelXp + ' XP">' + '<div class="progress faded-red-light-background" style="width:' + progress + '%">' + "</div>" + "</div>" + "</div>";
    if (addToMatch) return '<div class="feud-item-container item-container font-bold' + helpClass + '" data-uid="' + item["uid"] + '"' + titleHtml + ">" + '<div class="margin-bottom-5">' + name + '<span class="float-right grey">' + generate + "</span>" + "</div>" + '<div class="grey">' + '<i class="fa fa-bolt margin-right-5"></i>' + item["baseHype"] + "</div>" + '<div class="grey">' + consequence + "</div>" + '<div class="light-grey">' + requirement + "</div>" + progressHtml + level + "</div>";
    else return '<div class="feud-item-container item-container font-bold' + helpClass + '" data-uid="' + item["uid"] + '"' + titleHtml + ">" + '<div class="margin-bottom-5">' + name + '<span class="float-right grey">' + '<i class="fa fa-bolt margin-right-5"></i>' + item["baseHype"] + generate + "</span>" + "</div>" + '<div class="grey">' + consequence + "</div>" + '<div class="light-grey">' + requirement + "</div>" + progressHtml + level + "</div>";
}
function $70adc4a1fd111893$var$showBuyoutInformationData({ data: data, element: element, uid: uid } = {}) {
    if (!data["error"]) {
        element.data("uid", uid);
        element.find(".buyout-competitor-company-name").text(data["name"]);
        element.find(".buyout-competitor-cost").text(data["cost"]);
        element.find(".buyout-competitor-info").text("If you buyout {0}, the Company will dissolve and you can acquire some of their Superstars and Championships.".format(data["name"]));
        if (data["availableForBuyout"]) element.find(".buyout-competitor-available").html('<div class="green">Yes</div>');
        else element.find(".buyout-competitor-available").html('<div class="dark-red">No</div>');
        if (data["acquisitionFacilityPresent"]) element.find(".buyout-competitor-facility").html('<div class="green">Yes</div>');
        else element.find(".buyout-competitor-facility").html('<div class="dark-red">No</div>');
        // Populate talent manager select
        let talentManagerSelect = element.find(".buyout-competitor-talent-manager-select");
        let talentManagerOptions = "";
        data["talentManagers"].forEach(function(talentManager) {
            talentManagerOptions += '<option value="' + talentManager["uid"] + '">' + talentManager["name"] + " (Lvl " + talentManager["level"] + ")</option>";
        });
        talentManagerSelect.html(talentManagerOptions);
        element.fadeIn("slow").removeClass("display-none");
        // Show company info
        let rostersDiv = "";
        data["companyInformation"]["rosters"].forEach(function(roster) {
            let rosterDiv = (0, $1JSre.getRosterInfo)(roster, true, false, false);
            rostersDiv += rosterDiv;
        });
        let owner = data["ownerName"] ? data["ownerName"] : "None";
        let companyInfo = '<div class="margin-bottom-25"><div class="blue margin-bottom-5">Company</div>' + (0, $1JSre.getItemColumnDiv)("Name", data["name"]) + (0, $1JSre.getItemColumnDiv)("REP", data["reputation"]) + (0, $1JSre.getItemColumnDiv)("Owner", owner) + (0, $1JSre.getItemColumnDiv)("Style", (0, $3E8Nt.toTitleCase)(data["style"])) + "</div>";
        let companyInfoHtml = companyInfo + rostersDiv + (0, $1JSre.getChampionshipsInfo)(data["companyInformation"]["championships"], true, false);
        $(".buyout-company-information").html(companyInfoHtml);
        $(".buyout-company-information").scrollTop(0);
    } else {
        if (data["error"] === "competitor-not-found") notie.alert({
            type: 3,
            text: "That Competitor could not be found. Please try again."
        });
        else if (data["error"] === "no-talent-manager-available") {
            let errorText = "You need to have a Talent Manager available on your staff to make a buyout offer.";
            if (!(0, $98xmD.globalUser).paid) errorText += " (JoW Paid)";
            notie.alert({
                type: 3,
                text: errorText
            });
        }
    }
}
function $70adc4a1fd111893$var$showMakeBuyoutOfferData({ data: data, uid: uid } = {}) {
    if (!data["error"]) {
        notie.alert({
            type: 4,
            text: "{0} has been assigned to Negotiate the {1} Buyout".format(data["talentManager"], data["competitorName"]),
            stay: true
        });
        setTimeout(function() {
            $(".buyout-competitor-box").fadeOut("fast", function() {
                $("#view-companies-container").fadeIn();
                $('.view-companies-list-item[data-uid="' + uid + '"]').find(".buyout-competitor-button").hide();
                let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
                $(".points-number").html(pointsHtml);
            });
        }, 800);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "mars") notie.alert({
            type: 3,
            text: "You cannot make Buyout Offers in Wrestling on Mars."
        });
        if (data["error"] === "competitor-not-found") notie.alert({
            type: 3,
            text: "That Competitor could not be found. Please try again."
        });
        else if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to make this buyout offer."
        });
        else if (data["error"] === "talent-manager-not-found") notie.alert({
            type: 3,
            text: "The selected Talent Manager could not be found. Please try again."
        });
        else if (data["error"] === "talent-management-facility-level") notie.alert({
            type: 3,
            text: "You need to have the Company Acquisition Facility (Level 3 Talent Management) present in order to make a buyout offer."
        });
        else if (data["error"] === "not-available-for-buyout") notie.alert({
            type: 3,
            text: "That Competitor is not available for a buyout."
        });
        else if (data["error"] === "negotiating-buyout") notie.alert({
            type: 3,
            text: "{0} is already working on {1}. Another Buyout Offer cannot be made until this one is completed.".format(data["talentManager"], data["currentTask"])
        });
    }
}
function $70adc4a1fd111893$var$changeFanHistoryVisibility(value) {
    // Replace update function with empty one, add later. Optimizes hiding/showing multiple series
    const update = $70adc4a1fd111893$var$fanHistoryChart.update;
    $70adc4a1fd111893$var$fanHistoryChart.update = ()=>{
        return Promise.resolve();
    };
    let seriesData = $70adc4a1fd111893$var$fanHistoryChart.w.config.series;
    if (value === "all") for (const [index, _] of seriesData.entries())$70adc4a1fd111893$var$fanHistoryChart.showSeriesById(index);
    else if (value === "none") for (const [index, _] of seriesData.entries())$70adc4a1fd111893$var$fanHistoryChart.hideSeriesById(index);
    else if (value === "5") {
        let addedCompanyIds = [];
        for (const [index, x] of seriesData.entries())// Show series data for first 5 companies, check by companyId
        if (addedCompanyIds.length < 6 || addedCompanyIds.includes(x.companyId)) {
            $70adc4a1fd111893$var$fanHistoryChart.showSeriesById(index);
            if (!addedCompanyIds.includes(x.companyId)) addedCompanyIds.push(x.companyId);
        } else $70adc4a1fd111893$var$fanHistoryChart.hideSeriesById(index);
    } else if (value === "users") {
        for (const [index, x] of seriesData.entries())// Show series data for user controlled companies
        if (x.userControlled) $70adc4a1fd111893$var$fanHistoryChart.showSeriesById(index);
        else $70adc4a1fd111893$var$fanHistoryChart.hideSeriesById(index);
    }
    $70adc4a1fd111893$var$fanHistoryChart.update = update;
    $70adc4a1fd111893$var$fanHistoryChart.update();
    notie.alert({
        type: 4,
        text: "Graph filter applied"
    });
}
function $70adc4a1fd111893$var$showFormNewCompanyInformationData({ data: data } = {}) {
    let element = $(".form-new-company-box");
    // Show requirements status
    let yearsHtml = `<span class="grey margin-left-8">${data["yearsAtCompany"]} ${(0, $3E8Nt.getYearsWord)(data["yearsAtCompany"])}</span>`;
    if (data["yearsAtCompanyFulfilled"]) element.find(".form-new-company-years-requirement").html('<div><span class="green">Yes</span>' + yearsHtml + "</div>");
    else element.find(".form-new-company-years-requirement").html('<div><span class="dark-red">No</span>' + yearsHtml + "</div>");
    if (data["companySpaceAvailable"]) element.find(".form-new-company-space-requirement").html('<div class="green">Yes</div>');
    else element.find(".form-new-company-space-requirement").html('<div class="dark-red">No</div>');
    element.fadeIn("slow").removeClass("display-none");
    // Show company info
    let points = "10% of remaining points";
    if ((0, $98xmD.globals).game.unlimitedCreativePoints) points = "Max";
    let companyInfo = '<div class="margin-bottom-15">' + (0, $1JSre.getItemColumnDiv)("REP", "5") + (0, $1JSre.getItemColumnDiv)("Roster Capacity", "60") + (0, $1JSre.getItemColumnDiv)("Points", points) + (0, $1JSre.getItemColumnDiv)("Owner", data["ownerName"]) + "</div>";
    $(".form-new-company-information").html(companyInfo);
}
function $70adc4a1fd111893$var$showFormNewCompanyData({ data: data } = {}) {
    if (!data["error"]) {
        notie.alert({
            type: 4,
            text: "New message from " + data["ownerName"] + ".",
            stay: true
        });
        $(".form-new-company-box").fadeOut("fast", async function() {
            $("#view-companies-container").fadeIn();
            let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
            $(".points-number").html(pointsHtml);
            if (data["unreadMessages"]) {
                let unreadMessages = data["unreadMessages"].toLocaleString("en");
                $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
                $(".messages-number").text(unreadMessages);
                $("#messages").hide().fadeIn("fast");
            }
            $("#form-new-company-menu-button").replaceWith('<span class="float-right faded-orange top-1px">Forming new company</span>');
        });
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "not-enough-points") notie.alert({
            type: 3,
            text: "You do not have enough Creative Points to form a new company."
        });
        else if (data["error"] === "story") notie.alert({
            type: 3,
            text: "You cannot form a new company in story modes."
        });
        else if (data["error"] === "local-multiplayer") notie.alert({
            type: 3,
            text: "You cannot form a new company in Local Multiplayer."
        });
        else if (data["error"] === "paid-only") notie.alert({
            type: 3,
            text: "You can only form a new company in JoW Paid."
        });
        else if (data["error"] === "already-forming") notie.alert({
            type: 3,
            text: "You are already in the process of forming a new company."
        });
        else if (data["error"] === "not-enough-years") notie.alert({
            type: 3,
            text: "You need to be managing this company for at least 2 years."
        });
        else if (data["error"] === "not-enough-space") notie.alert({
            type: 3,
            text: "There isn't enough space in the market for a new company."
        });
    }
}




var $3E8Nt = parcelRequire("3E8Nt");

var $fPpxU = parcelRequire("fPpxU");

var $1JSre = parcelRequire("1JSre");

var $98xmD = parcelRequire("98xmD");


var $lCS03 = parcelRequire("lCS03");
async function $cfad1684038efd91$export$584146d5021318b6() {
    if ((0, $98xmD.globals).requestRunning) return;
    (0, $lCS03.playSoundEffect)("success");
    // Unselect menus
    $(".main-menu-container").find("li").removeClass("selected");
    $("#main-menu-right").html("");
    $(this).addClass("selected");
    // Hide event effects
    $(".event-prestige-effects-container").hide();
    $(".event-prestige-effects-more i").addClass("fa-angle-down").removeClass("fa-angle-up");
    $("#matches .event-card-match-edit-menu").find(".selected").removeClass("selected");
    // Load dashboard
    await $cfad1684038efd91$export$3a75641b11dbce93();
}
async function $cfad1684038efd91$export$3a75641b11dbce93() {
    // Get dashboard data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let dashboardData = await (0, $fPpxU.getDashboardData)();
    // Show dashboard data
    (0, $1JSre.hideContent)($());
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    $cfad1684038efd91$export$d263176ddbe21bfc(dashboardData);
}
function $cfad1684038efd91$export$d263176ddbe21bfc(data) {
    const $dashboardBox = $("#dashboard-box");
    const $dashboardContainer = $("#dashboard-container");
    $dashboardBox.html("");
    $dashboardContainer.show();
    $dashboardBox.scrollTop(0);
    let div = "";
    // Alerts
    if (data["alerts"]) {
        div += '<span class="display-block blue">Alerts</span>';
        if (data["alerts"]["buyoutAvailable"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["buyoutAvailable"][0] + " is available for a buyout</span>";
        else if (data["alerts"]["buyoutAvailable"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["buyoutAvailable"]) + " are available for a buyout</span>";
        if (data["alerts"]["companyFormed"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["companyFormed"][0] + " formed</span>";
        else if (data["alerts"]["companyFormed"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["companyFormed"]) + " formed</span>";
        if (data["alerts"]["companyFolded"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["companyFolded"][0] + " folded</span>";
        else if (data["alerts"]["companyFolded"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["companyFolded"]) + " folded</span>";
        if (data["alerts"]["leftCompany"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["leftCompany"][0] + " left the company</span>";
        else if (data["alerts"]["leftCompany"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["leftCompany"]) + " left the company</span>";
        if (data["alerts"]["superstarRetired"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["superstarRetired"][0] + " retired from wrestling</span>";
        else if (data["alerts"]["superstarRetired"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["superstarRetired"]) + " retired from wrestling</span>";
        if (data["alerts"]["staffMemberRetired"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["staffMemberRetired"][0] + " retired from their job</span>";
        else if (data["alerts"]["staffMemberRetired"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["staffMemberRetired"]) + " retired from their jobs</span>";
        if (data["alerts"]["leavingCompany"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["leavingCompany"][0] + " is going to leave the company</span>";
        else if (data["alerts"]["leavingCompany"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["leavingCompany"]) + " are going to leave the company</span>";
        if (data["alerts"]["notLeavingCompany"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["notLeavingCompany"][0] + " decided to stay</span>";
        else if (data["alerts"]["notLeavingCompany"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["notLeavingCompany"]) + " decided to stay</span>";
        if (data["alerts"]["talentOfferAccepted"].length === 1) div += '<span class="display-block dark-grey dashboard-item">Offer for ' + data["alerts"]["talentOfferAccepted"][0] + " was accepted</span>";
        else if (data["alerts"]["talentOfferAccepted"].length > 1) div += '<span class="display-block dark-grey dashboard-item">Offers for ' + (0, $3E8Nt.commaSeparate)(data["alerts"]["talentOfferAccepted"]) + " were accepted</span>";
        if (data["alerts"]["talentOfferRejected"].length === 1) div += '<span class="display-block dark-grey dashboard-item">Offer for ' + data["alerts"]["talentOfferRejected"][0] + " was rejected</span>";
        else if (data["alerts"]["talentOfferRejected"].length > 1) div += '<span class="display-block dark-grey dashboard-item">Offers for ' + (0, $3E8Nt.commaSeparate)(data["alerts"]["talentOfferRejected"]) + " were rejected</span>";
        if (data["alerts"]["injured"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["injured"][0] + " suffered an injury</span>";
        else if (data["alerts"]["injured"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["injured"]) + " suffered injuries</span>";
        if (data["alerts"]["unhappy"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["unhappy"][0] + " is unhappy</span>";
        else if (data["alerts"]["unhappy"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["unhappy"]) + " are unhappy</span>";
        if (data["alerts"]["notUnhappy"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["notUnhappy"][0] + " is no longer unhappy</span>";
        else if (data["alerts"]["notUnhappy"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["notUnhappy"]) + " are no longer unhappy</span>";
        if (data["alerts"]["injuryRecovered"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["injuryRecovered"][0] + " is ready to return</span>";
        else if (data["alerts"]["injuryRecovered"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["injuryRecovered"]) + " are ready to return</span>";
        if (data["alerts"]["workableInjuryRecovered"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["workableInjuryRecovered"][0] + " cleared to wrestle</span>";
        else if (data["alerts"]["workableInjuryRecovered"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["workableInjuryRecovered"]) + " cleared to wrestle</span>";
        if (data["alerts"]["randomEvent"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["randomEvent"][0] + " event occurred</span>";
        else if (data["alerts"]["randomEvent"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["randomEvent"]) + " events occurred</span>";
        if (data["alerts"]["facilityUpgradeAvailable"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["alerts"]["facilityUpgradeAvailable"][0] + " Facility upgrade is available</span>";
        else if (data["alerts"]["facilityUpgradeAvailable"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["alerts"]["facilityUpgradeAvailable"]) + " Facility upgrades are available</span>";
        if (data["alerts"]["goalCompleted"].length === 1) div += '<span class="display-block dark-grey dashboard-item"><span class="goal-color">' + (0, $1JSre.parseObjectiveName)(data["alerts"]["goalCompleted"][0]) + "</span> Goal completed</span>";
        else if (data["alerts"]["goalCompleted"].length > 1) {
            let goalsCompletedText = Array.from(data["alerts"]["goalCompleted"], function(goalCompleted) {
                return '<span class="goal-color">' + (0, $1JSre.parseObjectiveName)(goalCompleted) + "</span>";
            });
            div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(goalsCompletedText) + " Goals completed</span>";
        }
        if (data["alerts"]["goalFailed"].length === 1) div += '<span class="display-block dark-grey dashboard-item"><span class="goal-color">' + (0, $1JSre.parseObjectiveName)(data["alerts"]["goalFailed"][0]) + "</span> Goal failed</span>";
        else if (data["alerts"]["goalFailed"].length > 1) {
            let goalsFailedText = Array.from(data["alerts"]["goalFailed"], function(goalFailed) {
                return '<span class="goal-color">' + (0, $1JSre.parseObjectiveName)(goalFailed) + "</span>";
            });
            div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(goalsFailedText) + " Goals failed</span>";
        }
        if (data["alerts"]["talentRequestCompleted"].length === 1) div += '<span class="display-block dark-grey dashboard-item">Request completed for ' + data["alerts"]["talentRequestCompleted"][0] + "</span>";
        else if (data["alerts"]["talentRequestCompleted"].length > 1) div += '<span class="display-block dark-grey dashboard-item">Requests completed for ' + (0, $3E8Nt.commaSeparate)(data["alerts"]["talentRequestCompleted"]) + "</span>";
        if (data["alerts"]["talentRequestFailed"].length === 1) div += '<span class="display-block dark-grey dashboard-item">Request failed for ' + data["alerts"]["talentRequestFailed"][0] + "</span>";
        else if (data["alerts"]["talentRequestFailed"].length > 1) div += '<span class="display-block dark-grey dashboard-item">Requests failed for ' + (0, $3E8Nt.commaSeparate)(data["alerts"]["talentRequestFailed"]) + "</span>";
        // Show available callup alert with View button
        if (data["alerts"]["availableCallup"]) div += '<span class="display-block dark-grey dashboard-item">A Training Roster Callup is available<button type="button" class="button retro-button margin-left-8 condensed grey-button-background no-margin-bottom view-available-callup-button">View</button></span>';
    }
    // Check for no alerts
    const noAlerts = (0, $3E8Nt.areObjectArraysEmpty)(data["alerts"]);
    if (noAlerts) div += '<span class="display-block light-grey dashboard-item">No alerts need your attention</span>';
    // Talent requests
    if (data["talentRequests"]) {
        div += '<span class="display-block blue margin-top-20">Talent Requests</span>';
        data["talentRequests"].forEach(function(talentRequest) {
            const monthsRemaining = talentRequest["monthsRemaining"];
            let remainingText;
            if (monthsRemaining === 0) remainingText = "(Ends next event)";
            else if (monthsRemaining === 1) remainingText = "(Ends next month)";
            else {
                let monthsWord = (0, $3E8Nt.getMonthsWord)(monthsRemaining);
                remainingText = "(Ends in {0} {1})".format(monthsRemaining, monthsWord);
            }
            let remainingHtml = '<span class="grey">{0}</span>'.format(remainingText);
            let upcomingMatterText = '{0} <span class="margin-left-2 margin-right-2">-</span> {1} {2}'.format(talentRequest["talentName"], talentRequest["name"], remainingHtml);
            div += '<span class="display-block dark-grey dashboard-item">{0}</span>'.format(upcomingMatterText);
        });
        if (data["talentRequests"].length === 0) {
            if (!(0, $98xmD.globalUser).paid) div += '<span class="display-block light-grey dashboard-item help-text" title="JoW Paid includes Talent Requests">No active talent requests</span>';
            else div += '<span class="display-block light-grey dashboard-item">No active talent requests</span>';
        }
    }
    // Upcoming
    div += '<span class="display-block blue margin-top-20">Upcoming</span>';
    // Sort by months remaining
    data["upcomingMatters"].sort(function(a, b) {
        return a["monthsRemaining"] - b["monthsRemaining"];
    });
    data["upcomingMatters"].forEach(function(upcomingMatter) {
        const monthsRemaining = upcomingMatter["monthsRemaining"];
        let remainingText;
        if (monthsRemaining === 1) remainingText = "(Next month)";
        else if (monthsRemaining === 0) remainingText = "(This month)";
        else {
            let monthsWord = (0, $3E8Nt.getMonthsWord)(monthsRemaining);
            remainingText = "({0} {1})".format(monthsRemaining, monthsWord);
        }
        let remainingHtml = '<span class="grey">{0}</span>'.format(remainingText);
        let upcomingMatterText = "{0} {1}".format(upcomingMatter["event"], remainingHtml);
        div += '<span class="display-block dark-grey dashboard-item">{0}</span>'.format(upcomingMatterText);
    });
    if (data["upcomingMatters"].length === 0) div += '<span class="display-block light-grey dashboard-item">No upcoming matters in the near future</span>';
    // Tasks
    div += '<span class="display-block blue margin-top-20">Tasks</span>';
    data["tasksProgress"].forEach(function(taskProgress) {
        const monthsRemaining = taskProgress["monthsRemaining"] ? taskProgress["monthsRemaining"] : 1;
        let monthsWord = (0, $3E8Nt.getMonthsWord)(monthsRemaining);
        let remainingHtml = "({0} {1} left)".format(monthsRemaining, monthsWord);
        if (taskProgress["task"].split(" ")[0] === "Rehabbing") remainingHtml = "(Ongoing)";
        let taskText = '{0} <span class="grey">{1} {2}</span>'.format(taskProgress["task"], taskProgress["staffMember"], remainingHtml);
        div += '<span class="display-block dark-grey dashboard-item">{0}</span>'.format(taskText);
    });
    if (data["tasksProgress"].length === 0) div += '<span class="display-block light-grey dashboard-item">No tasks assigned to staff members</span>';
    // Injured
    div += '<span class="display-block blue margin-top-20">Injured</span>';
    data["injured"].sort(function(a, b) {
        return a["months"] - b["months"] || a["value"] - b["value"];
    });
    data["injured"].forEach(function(injuredItem) {
        div += '<span class="display-block dark-grey dashboard-item">{0} <span class="grey">({1})</span></span>'.format(injuredItem["name"], injuredItem["value"]);
    });
    if (data["injured"].length === 0) div += '<span class="display-block light-grey dashboard-item">No roster members are injured</span>';
    // Unavailable
    if (data["unavailable"]) {
        div += '<span class="display-block blue margin-top-20">Unavailable</span>';
        if (data["unavailable"]["notAvailable"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["unavailable"]["notAvailable"][0] + ' <span class="grey"">(Not available this event)</span></span>';
        else if (data["unavailable"]["notAvailable"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["unavailable"]["notAvailable"]) + ' <span class="grey"">(Not available this event)</span></span>';
        // Get suspended and kayfabe injured superstars and not available staff, sort them by time remaining
        let unavailableArray = data["unavailable"]["suspended"].concat(data["unavailable"]["kayfabeInjured"], data["unavailable"]["notAvailableStaff"]);
        unavailableArray.sort(function(a, b) {
            return a["months"] - b["months"] || a["value"] - b["value"];
        });
        unavailableArray.forEach(function(unavailableItem) {
            div += '<span class="display-block dark-grey dashboard-item">{0} <span class="grey">({1})</span></span>'.format(unavailableItem["name"], unavailableItem["value"]);
        });
        // Get no appearances
        if (data["unavailable"]["noAppearances"].length === 1) div += '<span class="display-block dark-grey dashboard-item">' + data["unavailable"]["noAppearances"][0] + ' <span class="grey"">(No appearances left)</span></span>';
        else if (data["unavailable"]["noAppearances"].length > 1) div += '<span class="display-block dark-grey dashboard-item">' + (0, $3E8Nt.commaSeparate)(data["unavailable"]["noAppearances"]) + ' <span class="grey"">(No appearances left)</span></span>';
        // Check for no unavailable
        const noUnavailable = (0, $3E8Nt.areObjectArraysEmpty)(data["unavailable"]);
        if (noUnavailable) div += '<span class="display-block light-grey dashboard-item">No roster members are unavailable</span>';
    }
    $dashboardBox.html(div);
    // View available callup from dashboard
    $dashboardContainer.off("click", ".view-available-callup-button");
    $dashboardContainer.on("click", ".view-available-callup-button", async function() {
        (0, $lCS03.playSoundEffect)("success");
        await (0, $b947816677aa453b$export$cc99d6c9d04059f3)();
    });
}



var $lCS03 = parcelRequire("lCS03");



var $1JSre = parcelRequire("1JSre");

var $hekDR = parcelRequire("hekDR");


var $98xmD = parcelRequire("98xmD");
async function $dc9a57e44bf0a95c$export$3e0a159a4cb39ac1() {
    $("#main-menu-right").html("");
    $(".main-menu-container").find("li").removeClass("selected");
    await (0, $1JSre.makeGameRequest)((0, $hekDR.getMessages), {}, $dc9a57e44bf0a95c$export$d662a060f8391178, {});
}
$(document).ready(function() {
    // Message filters
    $(".messages-filter-button").on("click", function() {
        // Reset if unselecting
        if ($(this).hasClass("selected")) {
            $(this).removeClass("selected");
            $(".message-preview-item").show();
            $(".no-messages-found").hide();
            $dc9a57e44bf0a95c$var$checkEmptyMessages();
            return false;
        }
        // Select this item
        $(".messages-filter-button.selected").removeClass("selected");
        $(this).addClass("selected");
        let filterName = $(this).attr("data-filter-name");
        if (filterName === "all") $(".message-preview-item").show();
        else if (filterName === "unread") $(".message-preview-item").each(function(i, el) {
            if ($(el).hasClass("unread")) $(el).show();
            else $(el).hide();
        });
        else if (filterName === "owner") $(".message-preview-item").each(function(i, el) {
            if ($(el).find(".owner-tag-icon").length > 0) $(el).show();
            else $(el).hide();
        });
        else if (filterName === "staff") $(".message-preview-item").each(function(i, el) {
            if ($(el).find(".staff-tag-icon").length > 0) $(el).show();
            else $(el).hide();
        });
        else if (filterName === "superstar") $(".message-preview-item").each(function(i, el) {
            if ($(el).find(".superstar-tag-icon").length > 0) $(el).show();
            else $(el).hide();
        });
        $dc9a57e44bf0a95c$var$checkEmptyMessages();
    });
    // Delete message
    $("#game-messages").on("click", ".delete-message", async function() {
        let $el = $(this);
        let uid = parseInt($(this).closest(".message-header").attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $hekDR.deleteMessage), {
            uid: uid
        }, $dc9a57e44bf0a95c$var$showDeleteMessageData, {
            $el: $el,
            uid: uid
        }, false);
    });
    // Delete all messages
    $(".delete-all-messages-button").on("click", function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                await (0, $1JSre.makeGameRequest)((0, $hekDR.deleteAllMessages), {
                    read: false
                }, $dc9a57e44bf0a95c$var$showDeleteAllMessagesData, {
                    read: false
                }, false);
            }
        });
    });
    // Delete read messages
    $(".delete-read-messages-button").on("click", function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                await (0, $1JSre.makeGameRequest)((0, $hekDR.deleteAllMessages), {
                    read: true
                }, $dc9a57e44bf0a95c$var$showDeleteAllMessagesData, {
                    read: true
                }, false);
            }
        });
    });
});
async function $dc9a57e44bf0a95c$export$d662a060f8391178({ data: data } = {}) {
    let parent = $("#game-messages");
    // Reset
    parent.find(".message-preview-container").html("");
    parent.find(".message-content-box").html("").hide();
    parent.find(".messages-filter-button").removeClass("selected");
    parent.find(".messages-filter-button").eq(0).addClass("selected");
    // Get message preview items
    data["messages"].forEach(function(message) {
        let messagePreviewHtml = $dc9a57e44bf0a95c$var$getMessagePreviewHtml(message);
        // Insert message preview item
        parent.find(".message-preview-container").append(messagePreviewHtml);
    });
    if (data["messages"].length > 3) parent.find(".message-preview-item").last().addClass("last-without-border");
    // Empty text
    if (data["messages"].length <= 0) {
        if ($(".no-messages-found").length < 1) parent.find(".message-preview-container").append('<div class="no-messages-found light-grey">No messages present</div>');
        else $(".no-messages-found").show();
    }
    // View message handler
    $("#game-messages").off("click", ".message-preview-item");
    $("#game-messages").on("click", ".message-preview-item", async function() {
        // Select this item
        parent.find(".message-preview-item.selected").removeClass("selected");
        $(this).addClass("selected");
        let uid = parseInt($(this).attr("data-uid"));
        let message = data["messages"].filter(function(message) {
            return message.uid === uid;
        })[0];
        let messageContentHtml = $dc9a57e44bf0a95c$var$getMessageContentHtml(message);
        parent.find(".message-content-box").html(messageContentHtml).hide().fadeIn();
        parent.find(".message-content-container").scrollTop(0);
        // Update message read if not read
        if ($(this).hasClass("unread")) {
            await (0, $1JSre.makeGameRequest)((0, $hekDR.setMessageRead), {
                uid: uid
            }, $dc9a57e44bf0a95c$var$showSetMessageReadData, {}, false);
            $(this).removeClass("unread");
            $(this).find(".unread-image").remove();
        }
        if ($(this).find(".message-preview-subject").text().indexOf("Injury") >= 0) // Tutorial action check
        (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_injury_message");
    });
    $("#game-messages").fadeIn();
    // View first message
    parent.find(".message-preview-item").eq(0).trigger("click");
    parent.find(".message-preview-container").scrollTop(0);
    parent.find(".message-content-container").scrollTop(0);
    // Tutorial action check
    if (data["nextTutorialState"]) (0, $98xmD.globals).game.tutorialState = data["nextTutorialState"];
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_messages_button");
}
function $dc9a57e44bf0a95c$var$showDeleteAllMessagesData({ read: read } = {}) {
    // Remove deleted messages, check empty messages text
    if (read) {
        $(".message-preview-item:not(.unread)").remove();
        notie.alert({
            type: 4,
            text: "Read Messages deleted"
        });
    } else {
        $(".message-preview-item").remove();
        // Remove unread icon, reset unread messages to 0
        $(".messages-number").text("0");
        $(".messages-icon").attr("src", "static/www/static/message_icon.png");
        notie.alert({
            type: 4,
            text: "All Messages deleted"
        });
    }
    $(".message-content-box").html("").hide();
    $dc9a57e44bf0a95c$var$checkEmptyMessages();
    // View first message
    $(".message-preview-item:visible").eq(0).trigger("click");
    $(".message-preview-container").scrollTop(0);
    $(".message-content-container").scrollTop(0);
}
function $dc9a57e44bf0a95c$var$showSetMessageReadData() {
    let messagesNumber = parseInt($(".messages-number").text()) - 1;
    $(".messages-number").text(messagesNumber);
    if (messagesNumber <= 0) $(".messages-icon").attr("src", "static/www/static/message_icon.png");
    return true;
}
function $dc9a57e44bf0a95c$var$showDeleteMessageData({ $el: $el, uid: uid } = {}) {
    // Remove message box
    $el.closest(".message-content-box").html("").hide();
    if ($(".message-content-box:visible").length <= 0) {
        // If no messages remaining in this message conversation, move to next message
        let messagePreviewItem = $('.message-preview-item[data-uid="' + uid + '"]');
        let index = $(".message-preview-item:visible").index(messagePreviewItem);
        messagePreviewItem.remove();
        if (index === $(".message-preview-item:visible").length) index -= 1;
        $(".message-preview-item:visible").eq(index).trigger("click");
    }
    $dc9a57e44bf0a95c$var$checkEmptyMessages();
}
function $dc9a57e44bf0a95c$var$checkEmptyMessages() {
    // Show/hide no messages found text
    if ($(".message-preview-item:visible").length < 1) {
        if ($(".no-messages-found").length < 1) $(".message-preview-container").append('<div class="no-messages-found light-grey">No messages present</div>');
        else $(".no-messages-found").show();
    } else $(".no-messages-found").hide();
    return true;
}
function $dc9a57e44bf0a95c$var$getMessageTagIcon(tag) {
    let tagIcon;
    switch(tag){
        case "owner":
            tagIcon = '<img alt="Owner" src="static/www/static/category_icon_gold.png" class="messages-filter-icon owner-tag-icon"/>';
            break;
        case "staff":
            tagIcon = '<img alt="Staff" src="static/www/static/category_icon_green.png" class="messages-filter-icon staff-tag-icon"/>';
            break;
        case "superstar":
            tagIcon = '<img alt="Superstar" src="static/www/static/category_icon_blue.png" class="messages-filter-icon superstar-tag-icon"/>';
            break;
    }
    return tagIcon;
}
function $dc9a57e44bf0a95c$var$getMessagePreviewHtml(message) {
    let unreadClass = "";
    let unreadIcon = "";
    let tagIcon = "";
    if (!message["read"]) {
        unreadClass = " unread";
        unreadIcon = '<img alt="Unread" src="static/www/static/unread_icon.png" class="unread-image"/>';
    }
    if (message["tag"]) tagIcon = $dc9a57e44bf0a95c$var$getMessageTagIcon(message["tag"]);
    return '<div class="message-preview-item' + unreadClass + '" data-uid="' + message["uid"] + '">' + '<div class="message-preview-subject margin-bottom-5">' + message["subject"] + '<div class="message-preview-icons-container">' + unreadIcon + tagIcon + "</div>" + "</div>" + '<div class="message-preview-from light-grey">' + message["fromName"] + "</div>" + "</div>";
}
function $dc9a57e44bf0a95c$var$getMessageContentHtml(message) {
    let monthsPassed = message["monthsPassed"];
    let monthsPassedText;
    if (monthsPassed === 0) monthsPassedText = "This month";
    else if (monthsPassed === 1) monthsPassedText = message["monthsPassed"] + " month ago";
    else monthsPassedText = message["monthsPassed"] + " months ago";
    return '<div class="message-header light-grey margin-bottom-12" data-uid="' + message["uid"] + '">' + monthsPassedText + '<div class="float-right font-1p25em">' + '<i class="fa fa-trash delete-message cursor-pointer"></i>' + "</div>" + "</div>" + '<div class="message-content">' + message["content"] + "</div>" + '<div class="message-from light-grey">' + message["fromName"] + "</div>";
}



var $1JSre = parcelRequire("1JSre");

var $5ZsVo = parcelRequire("5ZsVo");



var $8A6FL = parcelRequire("8A6FL");

var $3E8Nt = parcelRequire("3E8Nt");

$(document).ready(function() {
    // Sub menu button handlers
    const $mainMenuRight = $("#main-menu-right");
    $mainMenuRight.on("click", "#view-companies-menu-button", ()=>(0, $70adc4a1fd111893$export$80dfbe8f4c2048bd)());
    $mainMenuRight.on("click", "#view-objectives-menu-button", ()=>(0, $70adc4a1fd111893$export$51749dd7bf9a1e9d)());
    $mainMenuRight.on("click", "#view-management-activity-menu-button", ()=>(0, $70adc4a1fd111893$export$4372498b97e9c8ff)());
    $mainMenuRight.on("click", "#view-fan-history-menu-button", ()=>(0, $70adc4a1fd111893$export$4cc8be918a3a7c33)());
    $mainMenuRight.on("click", "#view-roster-menu-button", ()=>(0, $d3e44747ec383890$export$9595013ad42e288e)());
    $mainMenuRight.on("click", "#view-indies-menu-button", ()=>(0, $d3e44747ec383890$export$75d6879fdd072c0a)());
    $mainMenuRight.on("click", "#view-teams-menu-button", ()=>(0, $d3e44747ec383890$export$7c983fe739d97452)());
    $mainMenuRight.on("click", "#view-managers-menu-button", ()=>(0, $d3e44747ec383890$export$19fc0b31850b3e21)());
    $mainMenuRight.on("click", "#make-trade-offer-menu-button", ()=>(0, $d3e44747ec383890$export$d2be21ddf647bf61)());
    $mainMenuRight.on("click", "#view-rankings-menu-button", ()=>(0, $d3e44747ec383890$export$4077c55c538d9414)());
    $mainMenuRight.on("click", "#view-brands-menu-button", ()=>(0, $99c29f4521d84bf4$export$17bf265a32fa820)());
    $mainMenuRight.on("click", "#view-factions-menu-button", ()=>(0, $d3e44747ec383890$export$818d6af52bedd640)());
    $mainMenuRight.on("click", "#view-company-staff-menu-button", ()=>(0, $70adc4a1fd111893$export$aaebf53bd9c27ff8)());
    $mainMenuRight.on("click", "#view-company-facilities-menu-button", ()=>(0, $70adc4a1fd111893$export$ee44f0dfbe65ffc7)());
    $mainMenuRight.on("click", "#view-yearly-rankings-history-menu-button", ()=>(0, $70adc4a1fd111893$export$d43b059220da65ff)());
    $mainMenuRight.on("click", "#view-annual-tournament-history-menu-button", ()=>(0, $70adc4a1fd111893$export$9b13a1ad71568d7b)());
    $mainMenuRight.on("click", "#view-special-segments-menu-button", ()=>(0, $70adc4a1fd111893$export$360148ccebf3178a)());
    $mainMenuRight.on("click", "#view-powerups-menu-button", ()=>(0, $70adc4a1fd111893$export$f6c7271bf4f4dc95)());
    $mainMenuRight.on("click", "#view-options-menu-button", ()=>(0, $70adc4a1fd111893$export$1123285aefc96438)());
    $mainMenuRight.on("click", "#view-events-menu-button", ()=>(0, $70adc4a1fd111893$export$11eb91805ca2797e)());
    $mainMenuRight.on("click", "#view-feuds-menu-button", ()=>(0, $70adc4a1fd111893$export$97b0d6ca1b055888)());
    $mainMenuRight.on("click", "#view-stats-menu-button", ()=>(0, $70adc4a1fd111893$export$dc8337a6ea2458f6)());
    $mainMenuRight.on("click", "#view-tournaments-menu-button", ()=>(0, $70adc4a1fd111893$export$a17c0ce7657de2dd)());
    $mainMenuRight.on("click", "#view-gimmick-matches-menu-button", ()=>(0, $70adc4a1fd111893$export$8881fe1fb1468eac)());
    $mainMenuRight.on("click", "#view-segments-menu-button", ()=>(0, $9f0f3c0f4508366a$export$e5b3071bfae896f2)());
    $mainMenuRight.on("click", "#view-titles-menu-button", ()=>(0, $70adc4a1fd111893$export$c37f99627b0b98ac)());
});
function $212d6f8aa99fe567$export$55237cdd4bf855f5() {
    (0, $lCS03.playSoundEffect)("success");
    $(".main-menu-container").find("li").removeClass("selected");
    $(this).addClass("selected");
    // Hide event effects
    $(".event-prestige-effects-container").hide();
    $(".event-prestige-effects-more i").addClass("fa-angle-down").removeClass("fa-angle-up");
    let segmentsHtml = "";
    if ((0, $98xmD.globalUser).paid) segmentsHtml = '<li id="view-segments-menu-button"><span>Segments</span></li>';
    else segmentsHtml = '<li class="disabled help-text" title="JoW Paid includes Custom Segments."><span>Segments</span></li>';
    let statsHtml;
    if (!(0, $98xmD.globalUser).paid) statsHtml = '<li class="disabled help-text" title="JoW Paid includes Company Stats."><span>Stats</span></li>';
    else statsHtml = '<li id="view-stats-menu-button"><span>Stats</span></li>';
    let powerups = "Artifacts";
    let imgName = "powerup_1_icon_small.png";
    if ((0, $98xmD.globals).game.story === "mars") {
        powerups = "Lab";
        imgName = "experiment_1_icon_small.png";
    }
    let fanHistoryHtml = "";
    if ((0, $98xmD.globalUser).paid || (0, $98xmD.globals).currentTutorialStep) fanHistoryHtml = '<li id="view-fan-history-menu-button"><span>Fan History</span></li>';
    else if (!(0, $98xmD.globalUser).paid) fanHistoryHtml = '<li class="disabled help-text" title="JoW Paid includes Fan History."><span>Fan History</span></li>';
    let viewFactionsHtml = "";
    if ((0, $98xmD.globalUser).paid) viewFactionsHtml = '<li id="view-factions-menu-button"><span>Factions</span></li>';
    else viewFactionsHtml = '<li class="disabled help-text" title="JoW Paid includes Factions."><span>Factions</span></li>';
    let viewManagersHtml = "";
    if ((0, $98xmD.globalUser).paid) viewManagersHtml = '<li id="view-managers-menu-button"><span>Managers</span></li>';
    else viewManagersHtml = '<li class="disabled help-text" title="JoW Paid includes Managers."><span>Managers</span></li>';
    let viewRankingsHtml = "";
    if ((0, $98xmD.globalUser).paid) viewRankingsHtml = '<li id="view-rankings-menu-button"><span>Rankings</span></li>';
    else viewRankingsHtml = '<li class="disabled help-text" title="JoW Paid includes Roster Rankings."><span>Rankings</span></li>';
    let viewBrands = "";
    if ((0, $98xmD.globalUser).paid) viewBrands = '<li id="view-brands-menu-button"><span>Brands</span></li>';
    else viewBrands = '<li class="disabled help-text" title="JoW Paid includes Brands."><span>Brands</span></li>';
    let viewYearlyHistoryHtml = "";
    let viewAnnualTournamentHistoryHtml = "";
    if ((0, $98xmD.globalUser).paid) {
        viewYearlyHistoryHtml = '<li id="view-yearly-rankings-history-menu-button"><span>Top 50</span></li>';
        if (!(0, $98xmD.globals).game.story) viewAnnualTournamentHistoryHtml = '<li id="view-annual-tournament-history-menu-button"><span>TGI</span></li>';
    } else viewYearlyHistoryHtml = '<li class="disabled help-text" title="JoW Paid includes Top 50 Rankings."><span>Top 50</span></li>';
    let manageHistoryHtml = '<li id="manage-history" class="button-dropdown"><div class="dropdown-toggle">History <i class="fa fa-sort-down top--2px margin-left-3"></i></div><ul class="dropdown-menu">' + viewYearlyHistoryHtml + viewAnnualTournamentHistoryHtml + "</ul>" + "</li>";
    const $mainMenuRight = $("#main-menu-right");
    $mainMenuRight.fadeIn("fast");
    $mainMenuRight.html('<nav class="nav margin-top-20"><ul><li id="manage-roster" class="button-dropdown"><div class="dropdown-toggle">Roster <i class="fa fa-sort-down top--2px margin-left-3"></i></div><ul class="dropdown-menu"><li id="view-roster-menu-button"><span>View</span></li><li id="view-teams-menu-button"><span>Teams</span></li>' + viewFactionsHtml + viewManagersHtml + '<li id="view-indies-menu-button">' + "<span>Indies</span>" + "</li>" + '<li id="make-trade-offer-menu-button">' + "<span>Trade</span>" + "</li>" + viewRankingsHtml + viewBrands + "</ul>" + "</li>" + '<li id="manage-company" class="button-dropdown">' + '<div class="dropdown-toggle">Company <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' + '<ul class="dropdown-menu">' + '<li id="view-events-menu-button">' + "<span>Events</span>" + "</li>" + '<li id="view-feuds-menu-button">' + "<span>Feuds</span>" + "</li>" + '<li id="view-titles-menu-button">' + "<span>Titles</span>" + "</li>" + '<li id="view-gimmick-matches-menu-button">' + "<span>Gimmick Matches</span>" + "</li>" + segmentsHtml + statsHtml + '<li id="view-tournaments-menu-button">' + "<span>Tourn.</span>" + "</li>" + "</ul>" + "</li>" + '<li id="manage-job" class="button-dropdown">' + '<div class="dropdown-toggle">Job <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' + '<ul class="dropdown-menu">' + '<li id="view-objectives-menu-button">' + "<span>Goals</span>" + "</li>" + '<li id="view-management-activity-menu-button">' + "<span>Activity</span>" + "</li>" + '<li id="view-companies-menu-button">' + "<span>Companies</span>" + "</li>" + fanHistoryHtml + "</ul>" + "</li>" + '<li id="manage-staff" class="button-dropdown">' + '<div class="dropdown-toggle">Staff <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' + '<ul class="dropdown-menu">' + '<li id="view-company-staff-menu-button">' + "<span>View</span>" + "</li>" + '<li id="view-company-facilities-menu-button">' + "<span>Facilities</span>" + "</li>" + "</ul>" + "</li>" + manageHistoryHtml + '<li id="manage-other" class="button-dropdown">' + '<div class="dropdown-toggle">Other <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' + '<ul class="dropdown-menu">' + '<li id="view-powerups-menu-button">' + '<span><img alt="Artifact" src="static/www/static/' + imgName + '" class="margin-right-6 top-2px"/>' + powerups + "</span>" + "</li>" + '<li id="view-special-segments-menu-button">' + '<span><img alt="Special Segment" src="static/www/static/special_segments_icon_small.png" class="margin-right-6 top-2px"/>Special</span>' + "</li>" + "</ul>" + "</li>" + '<li id="view-options-menu-button">' + "Options" + "</li>" + "</ul>" + "</nav>");
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("click_manage_button");
}
function $212d6f8aa99fe567$var$bookHandler() {
    $(".main-menu-container").find("li").removeClass("selected");
    $(this).addClass("selected");
    // Simulator
    let simulator;
    if (!(0, $98xmD.globalUser).paid) simulator = '<li class="disabled help-text" title="JoW Paid includes the Simulator"><span>Simulator</span></li>';
    else if ((0, $98xmD.globals).game.controlMultipleCompanies) simulator = '<li class="disabled help-text" title="The Simulator is not available in Local Multiplayer"><span>Simulator</span></li>';
    else if ((0, $98xmD.globals).game.story) simulator = '<li class="disabled help-text" title="The Simulator is not available in Stories"><span>Simulator</span></li>';
    else simulator = '<li id="simulator-menu-button"><span>Simulator</span></li>';
    // Auto booker
    let autoBooker = '<li id="auto-book-menu-button" class="button-dropdown"><div class="dropdown-toggle">Auto <i class="fa fa-sort-down top--2px margin-left-3"></i></div><ul class="dropdown-menu"><li id="auto-book-button"><span>Booker</span></li>' + simulator + "</ul>" + "</li>";
    // Tournament
    let tournament = "";
    if (!(0, $98xmD.globals).game.weeklyShow) tournament = '<li id="add-tournament-menu-button">Tournament</li>';
    else tournament = '<li class="disabled help-text" title="Tournaments can only be created at Monthly Events">Tournament</li>';
    // Book segment
    let bookSegment = "";
    if ((0, $98xmD.globals).game.story !== "mars") bookSegment = '<li id="book-segment-menu-button">Segment</li>';
    let bookMatch = '<li id="book-singles-menu-button">Singles</li><li id="book-tag-team-menu-button">Tag Team</li>';
    $("#main-menu-right").fadeIn("slow", function() {
        $("#main-menu-right").html('<div id="booking-menu"><nav class="nav margin-top-20"><ul>' + bookSegment + bookMatch + autoBooker + tournament + "</ul>" + "</nav>" + "</div>");
        // Reset roster div
        if ((0, $98xmD.globals).game.weeklyShow) // Trigger segment button
        $("#book-segment-menu-button").trigger("click");
        else // Trigger singles match button
        $("#book-singles-menu-button").trigger("click");
    });
}
async function $212d6f8aa99fe567$export$f401be2a67e052a3(skipTrainingRosterCallup, skipConfirmStartEvent) {
    if (typeof skipTrainingRosterCallup === "undefined") skipTrainingRosterCallup = (0, $98xmD.globalUser).developerMode;
    if (typeof skipConfirmStartEvent === "undefined") skipConfirmStartEvent = (0, $98xmD.globalUser).developerMode;
    let clickPlayEventTutorialStep = (0, $98xmD.globals).currentTutorialStep && (0, $98xmD.globals).currentTutorialStep["action"] === "click_play_event";
    if (!skipConfirmStartEvent && !clickPlayEventTutorialStep) notie.confirm({
        text: "Are you sure you want to play the Event?",
        submitText: "Yes",
        cancelText: "No",
        submitCallback: async function() {
            await $212d6f8aa99fe567$export$f401be2a67e052a3(false, true);
        }
    });
    else await (0, $1JSre.makeGameRequest)((0, $5ZsVo.playEvent), {
        skipTrainingRosterCallup: skipTrainingRosterCallup
    }, (0, $e6954d9b34d9dd89$export$f3b814448fcb699b), {});
}
async function $212d6f8aa99fe567$var$changeCompanyHandler() {
    $("#main-menu-right").html("");
    $(".main-menu-container").find("li").removeClass("selected");
    if ((0, $98xmD.globals).game.numberOfUserCompanies === 2) await (0, $1JSre.makeGameRequest)((0, $8A6FL.changeCurrentCompany), {}, $212d6f8aa99fe567$export$b4f3d13f5954512d, {});
    else await (0, $1JSre.makeGameRequest)((0, $8A6FL.getUserCompanies), {}, $212d6f8aa99fe567$var$showGetUserCompaniesData, {});
}
function $212d6f8aa99fe567$var$showGetUserCompaniesData({ data: data } = {}) {
    $(".company-selection-companies-container").html("");
    data["companies"].forEach(function(company) {
        let selectedClass = "";
        if (company["name"] === data["currentCompanyName"]) selectedClass = " selected";
        if (company["turnStatus"] === "ended") selectedClass = " disabled";
        let playerNameHtml = "";
        if (company["playerName"]) playerNameHtml = '<span class="light-grey margin-left-8">{0}</span>'.format(company["playerName"]);
        let div = '<div class="inner-box-item company-selection-item font-bold' + selectedClass + '" data-uid="' + company["uid"] + '">' + company["name"] + playerNameHtml + "</div>";
        $(".company-selection-companies-container").append(div);
    });
    $("#company-selection-container").hide().fadeIn("fast");
    $(".company-selection-companies-container").scrollTop(0);
    $("#company-selection-container")[0].scrollIntoView();
}
async function $212d6f8aa99fe567$export$b4f3d13f5954512d({ data: data, $el: $el } = {}) {
    if (!data["error"]) {
        if ($el) {
            // Select, unselect
            $(".company-selection-item").removeClass("selected");
            $el.addClass("selected");
        }
        await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)());
    } else {
        if (data["error"] === "company-not-found") notie.alert({
            type: 3,
            text: "That company could not be found. Please try again."
        });
        if (data["error"] === "turn-ended") notie.alert({
            type: 3,
            text: data["playerName"] + "'s turn has ended. Finish your turn to continue."
        });
    }
}
function $212d6f8aa99fe567$export$a281725797d1ff19(funcToAdd) {
    const $bookMenuButton = $("#book-menu-button");
    const $manage = $("#manage");
    const $playEvent = $("#play-event");
    const $messages = $("#messages");
    const $viewDashboardMenuButton = $("#view-dashboard-menu-button");
    const $changeCompanyButton = $(".change-company-button");
    // Remove click handlers
    $bookMenuButton.off("click");
    $manage.off("click");
    $playEvent.off("click");
    $messages.off("click");
    $viewDashboardMenuButton.off("click");
    $changeCompanyButton.off("click");
    if (funcToAdd) {
        // Add default click handlers
        if (funcToAdd === "default") {
            $bookMenuButton.on("click", "", $212d6f8aa99fe567$var$bookHandler);
            $manage.on("click", "", $212d6f8aa99fe567$export$55237cdd4bf855f5);
            $playEvent.on("click", "", $212d6f8aa99fe567$export$f401be2a67e052a3);
            $messages.on("click", "", (0, $dc9a57e44bf0a95c$export$3e0a159a4cb39ac1));
            $viewDashboardMenuButton.on("click", "", (0, $cfad1684038efd91$export$584146d5021318b6));
            $changeCompanyButton.on("click", "", $212d6f8aa99fe567$var$changeCompanyHandler);
        } else {
            $bookMenuButton.on("click", funcToAdd);
            $manage.on("click", funcToAdd);
            $playEvent.on("click", funcToAdd);
            $messages.on("click", funcToAdd);
            $viewDashboardMenuButton.on("click", funcToAdd);
            $changeCompanyButton.on("click", funcToAdd);
        }
    }
    if (funcToAdd === $212d6f8aa99fe567$export$c2e2884eb1888beb) $changeCompanyButton.on("click", "", $212d6f8aa99fe567$var$changeCompanyHandler);
}
function $212d6f8aa99fe567$export$99f8e639d042c746() {
    notie.alert({
        type: 4,
        text: "Please finish the current action before proceeding"
    });
}
function $212d6f8aa99fe567$export$c2e2884eb1888beb() {
    notie.alert({
        type: 4,
        text: "You cannot perform this action right now"
    });
}
function $212d6f8aa99fe567$export$7a872614bdce3277() {
    notie.alert({
        type: 4,
        text: "This game is over. You can try again by starting a new game."
    });
}



var $1JSre = parcelRequire("1JSre");



var $jpMCP = parcelRequire("jpMCP");

var $lCS03 = parcelRequire("lCS03");


var $kpu3X = parcelRequire("kpu3X");

var $4ptHI = parcelRequire("4ptHI");

var $3E8Nt = parcelRequire("3E8Nt");



var $3NAMH = parcelRequire("3NAMH");

var $8A6FL = parcelRequire("8A6FL");

var $1olyO = parcelRequire("1olyO");




var $2A9WA = parcelRequire("2A9WA");


var $aynj3 = parcelRequire("aynj3");

var $jC7EP = parcelRequire("jC7EP");

let $b947816677aa453b$var$updateAlertShown = false;
const $b947816677aa453b$var$updateVersion = "4.4";
$(document).ready(function() {
    // ** BUYOUTS **
    // Select buyout superstars
    $(".buyout-competitor-selection-superstars").on("click", ".buyout-competitor-selection-item", function() {
        if ($(this).hasClass("disabled")) return;
        let parent = $(this).parent();
        let signingsAvailable = parseInt($(".buyout-competitor-selection-signings-available").data("value"));
        let signingsSelected = parent.find(".buyout-competitor-selection-item.selected");
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else {
            // If at signing limit, don't select
            if (signingsSelected.length >= signingsAvailable) {
                notie.alert({
                    type: 4,
                    text: "You can't select more than {0} Superstars to sign".format(signingsAvailable),
                    stay: true
                });
                return;
            }
            $(this).addClass("selected");
        }
        // Update signings available
        signingsSelected = parent.find(".buyout-competitor-selection-item.selected");
        let signingsRemaining = signingsAvailable - signingsSelected.length;
        $(".buyout-competitor-selection-signings-available").text(signingsRemaining + " Selections Available");
        // Update superstars selected
        let selectedNames = Array.from(signingsSelected, function(el) {
            return $(el).find(".buyout-competitor-selection-item-name").text();
        });
        let superstarsSelected = selectedNames.length > 0 ? (0, $3E8Nt.commaSeparate)(selectedNames) : "None";
        $(".buyout-competitor-selection-superstars-selected").text(superstarsSelected);
    });
    // Select buyout championships
    $(".buyout-competitor-selection-championships").on("click", ".buyout-competitor-selection-item", function() {
        if ($(this).hasClass("disabled")) return;
        let parent = $(this).parent();
        let championshipsAvailable = parseInt($(".buyout-competitor-selection-championships-available").data("value"));
        let championshipsSelected = parent.find(".buyout-competitor-selection-item.selected");
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else {
            // If at championships limit, don't select
            if (championshipsSelected.length >= championshipsAvailable) {
                notie.alert({
                    type: 4,
                    text: "You can't select more than {0} Championships to acquire".format(championshipsAvailable),
                    stay: true
                });
                return;
            }
            $(this).addClass("selected");
        }
        // Update championships available
        championshipsSelected = parent.find(".buyout-competitor-selection-item.selected");
        let championshipsRemaining = championshipsAvailable - championshipsSelected.length;
        $(".buyout-competitor-selection-championships-available").text(championshipsRemaining + " Selections Available");
        // Update championships selected
        let selectedNames = Array.from(championshipsSelected, function(el) {
            return $(el).find(".buyout-competitor-selection-item-name").text();
        });
        championshipsSelected = selectedNames.length > 0 ? (0, $3E8Nt.commaSeparate)(selectedNames) : "None";
        $(".buyout-competitor-selection-championships-selected").text(championshipsSelected);
    });
    // Confirm buyout selections
    $(".buyout-competitor-selection-box").on("click", "#confirm-buyout-selections", async function() {
        let parent = $(".buyout-competitor-selection-box");
        // Get superstars
        let superstarsParent = $(".buyout-competitor-selection-superstars");
        let superstarUids = Array.from(superstarsParent.find(".buyout-competitor-selection-item.selected"), function(el) {
            return $(el).data("uid");
        });
        let sendAllToMainRoster = parent.find('input[value="send_all_to_main_roster"]').prop("checked");
        let signingsAvailable = parseInt($(".buyout-competitor-selection-signings-available").data("value"));
        // Get championships
        let championshipsParent = $(".buyout-competitor-selection-championships");
        let championshipUids = Array.from(championshipsParent.find(".buyout-competitor-selection-item.selected"), function(el) {
            return $(el).data("uid");
        });
        let championshipsAvailable = parseInt($(".buyout-competitor-selection-championships-available").data("value"));
        // Get company uid
        let companyUid = parent.data("uid");
        // Validate superstars and championships, ask for confirmation is not all selected
        let confirmText = "";
        if (superstarUids.length === 0) confirmText = "If you don't select any Superstars, the Owner will select them for you. Are you sure you want to confirm?";
        else if (superstarUids.length < signingsAvailable) confirmText = "You haven't selected all Superstars available to you. Are you sure you want to confirm?";
        else if (championshipUids.length === 0) confirmText = "If you don't select any Championships, the Owner will select them for you. Are you sure you want to confirm?";
        else if (championshipUids.length < championshipsAvailable) confirmText = "You haven't selected all Championships available to you. Are you sure you want to confirm?";
        if (confirmText) notie.confirm({
            text: confirmText,
            submitCallback: async function() {
                await (0, $1JSre.makeGameRequest)((0, $8A6FL.confirmBuyoutSelections), {
                    superstarUids: superstarUids,
                    championshipUids: championshipUids,
                    companyUid: companyUid,
                    sendAllToMainRoster: sendAllToMainRoster
                }, $b947816677aa453b$var$showConfirmBuyoutSelectionsData, {}, false);
            }
        });
        else await (0, $1JSre.makeGameRequest)((0, $8A6FL.confirmBuyoutSelections), {
            superstarUids: superstarUids,
            championshipUids: championshipUids,
            companyUid: companyUid,
            sendAllToMainRoster: sendAllToMainRoster
        }, $b947816677aa453b$var$showConfirmBuyoutSelectionsData, {}, false);
    });
    // ** TALENT OFFERS **
    const $talentOfferBox = $(".talent-offer-box");
    // Show talent details for incoming offer
    $talentOfferBox.on("click", "#view-talent-details", async function() {
        let dataType = $(".talent-offer-box").data("type");
        let uid = $(".talent-offer-box").data("uid");
        await (0, $d3e44747ec383890$export$8777720a6e173e8e)(uid, dataType, null, ".talent-offer-box");
    });
    // Accept talent offer
    $talentOfferBox.on("click", "#accept-talent-offer", async function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                let uid = parseInt($(".talent-offer-box .talent-offer-box-offer-item.selected").attr("data-uid"));
                await (0, $1JSre.makeGameRequest)((0, $3NAMH.acceptOrRejectTalentOfferRequest), {
                    uid: uid,
                    selectedChoice: "accept"
                }, $b947816677aa453b$var$showAcceptOrRejectTalentOfferRequestData, {}, false);
            }
        });
    });
    // Reject talent offer
    $talentOfferBox.on("click", "#reject-talent-offer", async function() {
        let uid = parseInt($(".talent-offer-box .talent-offer-box-offer-item.selected").attr("data-uid"));
        await (0, $1JSre.makeGameRequest)((0, $3NAMH.acceptOrRejectTalentOfferRequest), {
            uid: uid,
            selectedChoice: "reject"
        }, $b947816677aa453b$var$showAcceptOrRejectTalentOfferRequestData, {}, false);
    });
    // Select talent offer
    $talentOfferBox.on("click", ".talent-offer-box-offer-item", function() {
        $(".talent-offer-box-offer-item").find(".fa-check").removeClass("opaque").hide();
        $(".talent-offer-box-offer-item").removeClass("selected");
        $(this).addClass("selected");
        $(this).find(".fa-check").show();
    });
    // Hover over talent offer
    $talentOfferBox.on("mouseover", ".talent-offer-box-offer-item", function() {
        $(".talent-offer-box-offer-item:not(.selected)").find(".fa-check").removeClass("opaque").hide();
        if (!$(this).hasClass("selected")) $(this).find(".fa-check").addClass("opaque").show();
    });
    $talentOfferBox.on("mouseleave", ".talent-offer-box-offer-item", function() {
        $(".talent-offer-box-offer-item:not(.selected)").find(".fa-check").removeClass("opaque").hide();
    });
    // ** TRADE OFFERS **
    // Accept trade offer
    $(".incoming-trade-offer-container").on("click", ".accept-trade-offer-button", async function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                const tradeOfferUid = $(".incoming-trade-offer-container").data("uid");
                const selectedChoice = "accept";
                await (0, $1JSre.makeGameRequest)((0, $aynj3.replyToTradeOfferRequest), {
                    tradeOfferUid: tradeOfferUid,
                    selectedChoice: selectedChoice
                }, $b947816677aa453b$var$showReplyToTradeOfferRequestData, {
                    selectedChoice: selectedChoice
                }, false);
            }
        });
    });
    // Decline trade offer
    $(".incoming-trade-offer-container").on("click", ".decline-trade-offer-button", async function() {
        const tradeOfferUid = $(".incoming-trade-offer-container").data("uid");
        const selectedChoice = "decline";
        await (0, $1JSre.makeGameRequest)((0, $aynj3.replyToTradeOfferRequest), {
            tradeOfferUid: tradeOfferUid,
            selectedChoice: selectedChoice
        }, $b947816677aa453b$var$showReplyToTradeOfferRequestData, {
            selectedChoice: selectedChoice
        }, false);
    });
    // Show superstar info when clicking on trade superstar
    $(".incoming-trade-offer-container").on("click", ".trade-offer-superstar-item", async function() {
        let uid = parseInt($(this).attr("data-uid"));
        await (0, $af8d9de467381f29$export$2425462df21708bb)(uid);
    });
    // ** POW **
    // 'Talk' button
    $("#container").on("click", "#pow-talk-button", async function() {
        // Don't allow if PoW dialog showing
        if ($("#pow-dialog").is(":visible")) {
            notie.alert({
                type: 4,
                text: "Please finish the current action before proceeding"
            });
            return false;
        }
        // Don't show if failure ending
        if ((0, $98xmD.globals).game.powStoryFailureEnding) {
            notie.alert({
                type: 4,
                text: "There is no one available to talk to."
            });
            return false;
        }
        await (0, $1JSre.makeGameRequest)((0, $jC7EP.getPowDialog), {}, (0, $e37bb324c1adb297$export$92109d096b3683dd), {});
    });
    // Show person choices
    $("#container").on("click", "#select-dialog-person", function() {
        (0, $e37bb324c1adb297$export$53ca73c04f3e229a)();
    });
    // Show dialog for selected person
    $("#container").on("click", ".dialog-person-choice", function() {
        let name = $(this).text().trim();
        (0, $e37bb324c1adb297$export$468062643968fd83)(name);
    });
    // Go back to dashboard
    $("#game").on("click", ".back-to-dashboard-button", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideContent)($());
        $("#dashboard-container").fadeIn("slow");
    });
    // ** FORM NEW COMPANY **
    // Add championship input
    const $formNewCompanyDetailsBox = $(".form-new-company-details-box");
    $formNewCompanyDetailsBox.on("click", ".add-form-new-company-championship-input-button", function() {
        // Get existing championships selects
        let parentBox = $(this).closest(".box");
        let championshipInputs = parentBox.find(".form-new-company-championship-name-input");
        // Check for maximum championships selects
        if (championshipInputs.length >= 5) {
            notie.alert({
                type: 3,
                text: "You cannot add more than 5 championships"
            });
            return false;
        }
        // Clone championship input, add remove button
        let championshipInput = '<div class="margin-bottom-8">' + championshipInputs.eq(0).parent().clone().prop("innerHTML") + '<button type="button" class="remove-form-new-company-championship-input-button button retro-button styled-select-button ' + 'font-bold top-1px margin-left-3"><i class="fa fa-minus"></i></button></div>';
        // Add championship input after last one
        championshipInputs.last().parent().after(championshipInput);
        // Reset graphic
        let addedInputParent = parentBox.find(".form-new-company-championship-name-input").last().parent();
        addedInputParent.find(".form-new-company-championship-remove-graphic-button").hide();
        addedInputParent.find(".form-new-company-championship-add-graphic-button").text("Add Graphic").addClass("dark-grey-button-background").removeClass("blue-button-background");
        addedInputParent.data("key", null);
    });
    // Remove championship input
    $formNewCompanyDetailsBox.on("click", ".remove-form-new-company-championship-input-button", function() {
        $(this).parent().remove();
        $b947816677aa453b$var$processFormNewCompanyOpenGraphicCreator();
    });
    // Add/edit championship graphic
    $formNewCompanyDetailsBox.on("click", ".form-new-company-championship-add-graphic-button", function() {
        let parent = $(this).parent();
        $b947816677aa453b$var$processFormNewCompanyOpenGraphicCreator();
        // Select this button
        $(this).text("Edit Graphic").removeClass("dark-grey-button-background").addClass("blue-button-background");
        // Show remove graphic button
        $(this).siblings(".form-new-company-championship-remove-graphic-button").show();
        // Set graphic data
        let jsonData;
        let graphicData;
        if (parent.data("key")) jsonData = JSON.parse(parent.data("key"));
        if (jsonData) graphicData = [
            jsonData
        ];
        // Show graphic
        let graphicContainer = $(this).parent().siblings(".character-creator");
        let el = graphicContainer.find(".superstar-graphic");
        graphicContainer.show();
        (0, $c82cd471f4baff6b$export$7ba12038bb800503)(el, graphicData);
    });
    // Remove championship graphic
    $formNewCompanyDetailsBox.on("click", ".form-new-company-championship-remove-graphic-button", function() {
        let parent = $(this).parent();
        $(this).hide();
        $b947816677aa453b$var$processFormNewCompanyOpenGraphicCreator();
        // Remove graphic data
        parent.data("key", null);
        parent.find(".form-new-company-championship-add-graphic-button").text("Add Graphic").addClass("dark-grey-button-background").removeClass("blue-button-background");
    });
    // Confirm new company details
    $formNewCompanyDetailsBox.on("click", "#form-new-company-confirm-details-button", function() {
        // Get input values
        let parent = $(".form-new-company-details-box");
        let companyName = parent.find(".form-new-company-name-input").val();
        let trainingRosterOption = parent.find(".form-new-company-training-roster-select").val();
        let weeklyShowName = parent.find(".form-new-company-weekly-show-name-input").val();
        let companyStyle = parent.find(".form-new-company-style-select").val();
        // Get event and championship names and prestiges
        let companyMonthlyEventsData = [];
        parent.find(".form-new-company-event-name-input").each(function(i, e) {
            let eventName = $(e).val();
            let eventPrestige = $(e).next(".form-new-company-event-prestige-select").val();
            let companyMonthlyEventData = {
                "name": eventName,
                "prestige": eventPrestige
            };
            companyMonthlyEventsData.push(companyMonthlyEventData);
        });
        $b947816677aa453b$var$processFormNewCompanyOpenGraphicCreator(false);
        let companyChampionshipsData = [];
        parent.find(".form-new-company-championship-name-input").each(function(i, e) {
            let championshipName = $(e).val();
            if (championshipName) {
                let championshipDivision = $(e).siblings(".form-new-company-championship-division-select").val();
                let championshipPrestige = $(e).siblings(".form-new-company-championship-prestige-select").val();
                let championshipGraphicData = $(e).parent().data("key");
                let companyChampionshipData = {
                    "name": championshipName,
                    "division": championshipDivision,
                    "prestige": championshipPrestige,
                    "graphic": championshipGraphicData
                };
                companyChampionshipsData.push(companyChampionshipData);
            }
        });
        // Validate inputs
        if (companyName.length <= 0) {
            notie.alert({
                type: 3,
                text: "Please enter the Company's name"
            });
            return false;
        }
        let emptyMonthlyEventName = false;
        let duplicateMonthlyEventName = false;
        let monthlyEventNames = [];
        companyMonthlyEventsData.forEach(function(monthlyEventData) {
            if (!monthlyEventData["name"]) {
                emptyMonthlyEventName = true;
                return false;
            }
            if (monthlyEventNames.includes(monthlyEventData["name"])) {
                duplicateMonthlyEventName = true;
                return false;
            }
            monthlyEventNames.push(monthlyEventData["name"]);
        });
        if (emptyMonthlyEventName) {
            notie.alert({
                type: 3,
                text: "Please enter all Monthly Event names"
            });
            return false;
        }
        if (duplicateMonthlyEventName) {
            notie.alert({
                type: 3,
                text: "Please enter unique names for all Monthly Events"
            });
            return false;
        }
        // Get details data
        let companyDetails = {
            "companyName": companyName,
            "trainingRosterOption": trainingRosterOption,
            "weeklyShowName": weeklyShowName,
            "companyMonthlyEventsData": companyMonthlyEventsData,
            "companyChampionshipsData": companyChampionshipsData,
            "companyStyle": companyStyle
        };
        notie.confirm({
            text: "Are you sure?",
            submitCallback: async function() {
                await (0, $1JSre.makeGameRequest)((0, $8A6FL.confirmNewCompanyDetails), {
                    companyDetails: companyDetails
                }, $b947816677aa453b$var$showConfirmNewCompanyDetailsData, {}, false);
            }
        });
    });
    // Select new company superstars
    $(".form-new-company-talent-box").on("click", ".form-new-company-selection-item", function() {
        let parent = $(this).parent();
        let selectionsAvailable = parseInt($(".form-new-company-selections-available").data("value"));
        let superstarsSelected = parent.find(".form-new-company-selection-item.selected");
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else {
            // If at signing limit, don't select
            if (superstarsSelected.length >= selectionsAvailable) {
                notie.alert({
                    type: 4,
                    text: "You can't select more than {0} Superstars.".format(selectionsAvailable),
                    stay: true
                });
                return;
            }
            $(this).addClass("selected");
        }
        // Update selections available
        superstarsSelected = parent.find(".form-new-company-selection-item.selected");
        let selectionsRemaining = selectionsAvailable - superstarsSelected.length;
        $(".form-new-company-selections-available").text(selectionsRemaining + " Selections Available");
        // Update superstars selected
        let selectedNames = Array.from(superstarsSelected, function(el) {
            return $(el).find(".form-new-company-selection-item-name").text();
        });
        $(".form-new-company-superstars-selected").text(selectedNames.length > 0 ? (0, $3E8Nt.commaSeparate)(selectedNames) : "None");
    });
    // Confirm new company talent
    $(".form-new-company-talent-box").on("click", "#form-new-company-confirm-talent-button", async function() {
        // Get superstars
        let superstarsParent = $(".form-new-company-superstars");
        let superstarUids = Array.from(superstarsParent.find(".form-new-company-selection-item.selected"), function(el) {
            return $(el).data("uid");
        });
        let selectionsAvailable = parseInt($(".form-new-company-selections-available").data("value"));
        // Validate superstars, ask for confirmation is not all selected
        let confirmText = "";
        if (superstarUids.length < selectionsAvailable) confirmText = "You haven't selected all Superstars available to you. Are you sure you want to confirm?";
        if (confirmText) notie.confirm({
            text: confirmText,
            submitCallback: async function() {
                await (0, $1JSre.makeGameRequest)((0, $8A6FL.confirmNewCompanyTalent), {
                    superstarUids: superstarUids
                }, $b947816677aa453b$var$showConfirmNewCompanyDetailsData, {}, false);
            }
        });
        else await (0, $1JSre.makeGameRequest)((0, $8A6FL.confirmNewCompanyTalent), {
            superstarUids: superstarUids
        }, $b947816677aa453b$var$showConfirmNewCompanyDetailsData, {}, false);
    });
    // ** OTHER **
    // Make random event choice
    $(".random-event-choice-box").on("click", ".random-event-choice-button", async function() {
        let uid = $(this).attr("data-uid");
        let choice = $(this).text();
        await (0, $1JSre.makeGameRequest)((0, $2A9WA.addRandomEventChoice), {
            uid: uid,
            choice: choice
        }, $b947816677aa453b$var$showAddRandomEventChoiceData, {}, false);
    });
    // Change company
    $("#container").on("click", ".company-selection-item", async function() {
        let uid = parseInt($(this).attr("data-uid"));
        let $el = $(this);
        await (0, $1JSre.makeGameRequest)((0, $8A6FL.changeCurrentCompany), {
            uid: uid
        }, (0, $212d6f8aa99fe567$export$b4f3d13f5954512d), {
            $el: $el
        });
    });
    // Press enter to continue tutorial step, prevent scroll
    $(document).keydown(function(event) {
        if ($(".tutorial-info-continue-button").is(":visible") && event.key === "Enter") {
            event.preventDefault();
            $(".tutorial-info-continue-button").trigger("click");
        }
    });
});
async function $b947816677aa453b$export$2b9447da23271d13(game, hide = true) {
    // Reset ui
    (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
    $(".main-menu-container").find("li").removeClass("selected");
    $(".event-prestige-effects-container").hide();
    $(".event-prestige-effects-more i").addClass("fa-angle-down").removeClass("fa-angle-up");
    (0, $98xmD.globals).currentTutorialStep = null;
    // Get home page data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    let homePageData = await (0, $iRMwH.getHomePageData)(game);
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    // Show home page data
    $(".notie-textbox-inner").text("");
    $("#game").fadeIn("slow");
    if (hide) (0, $1JSre.hideContent)($());
    await $b947816677aa453b$var$showHomePageData(homePageData, hide);
}
async function $b947816677aa453b$var$showHomePageData(data, hide) {
    // Define jquery selectors
    const $eventCard = $("#event-card");
    const $eventHype = $(".event-hype");
    const $talentRequestBox = $(".talent-request-box");
    const $messagesNumber = $(".messages-number");
    const $bookingContainer = $("#booking-container");
    const $incomingTradeOfferContainer = $(".incoming-trade-offer-container");
    const $talentOfferBox = $(".talent-offer-box");
    if (data["error"]) {
        let errorText = "There was an error loading the game.";
        errorText += ' Please <a href="https://discord.gg/tjwJb99" target="_blank"> contact on Discord</a> for support.';
        notie.alert({
            type: 3,
            text: errorText
        });
        return false;
    }
    // Show dashboard if no other important section displayed
    let showDashboard = true;
    // Set global game attributes
    (0, $98xmD.globals).game.style = data["style"];
    (0, $98xmD.globals).game.month = (0, $1JSre.monthNames)[data["currentMonth"]];
    (0, $98xmD.globals).game.monthCount = data["monthCount"];
    (0, $98xmD.globals).game.companyMonth = data["companyMonth"];
    (0, $98xmD.globals).game.year = data["realYear"];
    (0, $98xmD.globals).game.competitorsPresent = data["competitorsPresent"];
    (0, $98xmD.globals).game.reputation = data["reputation"];
    (0, $98xmD.globals).game.story = data["story"];
    (0, $98xmD.globals).game.earth = data["earth"];
    (0, $98xmD.globals).game.trainingCallupRun = data["trainingCallupRun"];
    (0, $98xmD.globals).game.marketSize = data["marketSize"];
    (0, $98xmD.globals).game.tutorialState = data["tutorialState"];
    (0, $98xmD.globals).game.annualTournamentRunning = data["annualTournamentData"] ? data["annualTournamentData"]["status"] === "running" : false;
    (0, $98xmD.globals).game.settings = data["gameSettings"];
    (0, $98xmD.globalUser).settings = data["userSettings"];
    (0, $98xmD.globals).game.weeklyShow = data["eventData"]["weeklyShow"];
    (0, $98xmD.globals).game.sandboxModeEnabled = data["gameSettings"]["sandbox_mode_enabled"];
    (0, $98xmD.globals).game.unlimitedCreativePoints = data["gameSettings"]["unlimited_creative_points"];
    (0, $98xmD.globals).game.maximumRosterCapacity = data["gameSettings"]["maximum_roster_capacity"];
    (0, $98xmD.globals).game.controlMultipleCompanies = data["gameSettings"]["control_multiple_companies"];
    (0, $98xmD.globals).game.numberOfUserCompanies = data["gameSettings"]["number_of_user_companies"];
    // Don't play story, sandbox or local multiplayer not paid
    if (!(0, $98xmD.globalUser).paid && (data["story"] && data["story"] !== "tutorial" || data["gameSettings"]["sandbox_mode_enabled"] || data["gameSettings"]["control_multiple_companies"])) {
        let errorText;
        if (data["story"]) errorText = "Stories are only available in JoW Paid. ";
        else if (data["gameSettings"]["sandbox_mode_enabled"]) errorText = "Sandbox Mode is only available in JoW Paid. ";
        else if (data["gameSettings"]["control_multiple_companies"]) errorText = "Local Multiplayer is only available in JoW Paid. ";
        notie.alert({
            type: 4,
            text: errorText,
            stay: true
        });
        $eventCard.hide();
        (0, $212d6f8aa99fe567$export$a281725797d1ff19)();
        return false;
    }
    // Set global game owner name
    (0, $98xmD.globals).game.owner = data["owner"] ? data["owner"] + " (Owner)" : "Owner";
    // Set powerup icons
    if ((0, $98xmD.globals).game.story === "mars") {
        (0, $98xmD.globals).game.powerupLevel1 = "experiment_1_icon";
        (0, $98xmD.globals).game.powerupLevel2 = "experiment_2_icon";
        (0, $98xmD.globals).game.powerupLevel3 = "experiment_3_icon";
        (0, $98xmD.globals).game.powerupWord = "Experiment";
    } else {
        (0, $98xmD.globals).game.powerupLevel1 = "powerup_1_icon";
        (0, $98xmD.globals).game.powerupLevel2 = "powerup_2_icon";
        (0, $98xmD.globals).game.powerupLevel3 = "powerup_3_icon";
        (0, $98xmD.globals).game.powerupWord = "Artifact";
    }
    // Show month and year
    let monthName = (0, $98xmD.globals).game.month.slice(0, 3);
    let year = data["realYear"];
    // Show earth year for mars story
    if (data["earthYear"]) {
        year = "Year {0} (Earth {1})".format(year, data["earthYear"]);
        $(".event-card-month-and-year").text(monthName + ", " + year);
    } else $(".event-card-month-and-year").text(monthName + " " + year);
    // Show event card's data
    (0, $70adc4a1fd111893$export$2ea68f2b252ba05a)(data);
    $("#main-menu-right").html("");
    // Show company name
    $("#company-name").html($b947816677aa453b$var$getCompanyHeaderHtml(data["companyName"], data["playerName"]));
    // Show points
    let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
    $(".points-number").html(pointsHtml);
    $("#points").show();
    // Show fans
    let fans = (0, $1JSre.getFansHtml)(data["fans"]);
    $(".fans-number").html(fans);
    $("#fans").show();
    // Get dialogs and append to array
    let dialogs = [];
    if (data["storyEvents"]) {
        data["storyEvents"].forEach(function(event) {
            // Get dialogs for each story choice or event
            if (storyData[event["name"]]) {
                let storyDialogs = storyData[event["name"]];
                // Add information to dialogs
                storyDialogs.forEach(function(dialog, j) {
                    dialog.texts.forEach(function(text, i) {
                        dialog.texts[i] = text.format(event["information"]);
                    });
                });
                dialogs.push.apply(dialogs, storyDialogs);
            }
        });
        // Get dialogs for each year and month
        if (storyData[data["year"]]) {
            if (storyData[data["year"]][data["monthCount"]]) dialogs.push.apply(dialogs, storyData[data["year"]][data["monthCount"]]);
        }
    }
    // Show training callups if relevant
    if ((data["companyMonth"] === 0 || data["companyMonth"] === 6) && !data["draftData"] && !data["trainingCallupRun"] && !data["buyoutData"] && !data["randomEvents"].length > 0 && !dialogs.length > 0 && !data["talentOffers"].length > 0 && !data["tradeOffers"].length > 0 && !data["showPowIntroduction"] && !(data["powReactionDialogs"] && data["powReactionDialogs"].length > 0) && !(data["tutorialState"] && data["tutorialState"] !== "end_tutorial") && !data["yearlyRankingData"] && !data["talentRequestsData"].length > 0 && !data["annualTournamentData"]) {
        await $b947816677aa453b$export$cc99d6c9d04059f3(hide);
        showDashboard = false;
    }
    // Annual Tournament
    let annualTournamentDialogsShown = false;
    if (data["annualTournamentData"]) {
        // Show dialog
        if (data["annualTournamentData"]["dialogData"]) {
            (0, $e37bb324c1adb297$export$1efa17883ef037ff)(data["annualTournamentData"]["dialogData"]);
            annualTournamentDialogsShown = true;
            showDashboard = false;
        }
        if (data["annualTournamentData"]["status"] === "selecting" || data["annualTournamentData"]["status"] === "running") {
            $(".event-prestige-effects").hide();
            $("#match-limits").html("");
            $eventHype.html("");
            $(".event-card-header-container").hide();
            $(".event-card-annual-tournament-header").show();
            $(".event-card-annual-tournament-header-text").text(data["annualTournamentData"]["name"]);
        } else {
            $(".event-card-header-container").show();
            $(".event-card-annual-tournament-header").hide();
        }
    } else {
        $(".event-card-header-container").show();
        $(".event-card-annual-tournament-header").hide();
    }
    // Process awards if competitors present and not mars story
    let awardsShown = false;
    if (data["monthCount"] === 10 && data["competitorsPresent"] && !data["awardsRun"] && data["story"] !== "mars") {
        awardsShown = true;
        showDashboard = false;
        await (0, $1JSre.makeGameRequest)((0, $b7dd8c4f6cc3ca70$export$97a1cb8a1145fa57), {}, $b947816677aa453b$var$showProcessAwardsData, {});
    }
    // Introduce powerups / special segments
    if (!data["eventData"]["weeklyShow"]) {
        // Show powerups
        if (data["monthCount"] === 1 && data["year"] === 0) await (0, $1JSre.makeGameRequest)((0, $kpu3X.introducePowerupsView), {}, $b947816677aa453b$var$showIntroducePowerupsViewData, {}, false, true);
        // Introduce special segments
        if ((0, $98xmD.globalUser).paid && data["monthCount"] === 4 && data["year"] === 0 && data["story"] !== "mars") await (0, $1JSre.makeGameRequest)((0, $4ptHI.introduceSpecialSegmentsView), {}, $b947816677aa453b$var$showIntroduceSpecialSegmentsViewData, {}, false, true);
    }
    // Go through dialogs
    if (dialogs.length > 0) {
        // Disable menu options
        $eventCard.show();
        (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
        dialogNameSpace.goThroughDialogs(dialogs);
        showDashboard = false;
    }
    // Get random events to show for choice selection
    let randomEventShown = false;
    if (data["randomEvents"].length > 0 && !awardsShown && !annualTournamentDialogsShown) {
        randomEventShown = true;
        $b947816677aa453b$var$showRandomEventSelection(data["randomEvents"]);
        showDashboard = false;
    }
    let notieTexts = "";
    // Anonymous user sign up notification
    if (!(0, $98xmD.globalUser).loggedIn) notieTexts += '<span class="display-block">Anonymous users\' saves are not backed up to the cloud and can be lost. Please sign up to enable cloud saves.</span>';
    if (!(0, $98xmD.globalUser).freeTrialActivatedDatetime && !(0, $98xmD.globalUser).paid && (data["monthCount"] === 0 || data["monthCount"] === 2)) {
        let jowPaidPromoText;
        if (data["monthCount"] === 0) jowPaidPromoText = '<span class="gold">JoW Paid</span> includes the Ratings War, Staff & Facilities, Company/Title/Talent Stats and much more. <a href="/free-trial" target="_blank">Try it</a> for free!';
        else jowPaidPromoText = '<span class="gold">JoW Paid</span> includes unlimited save slots, unique story modes, Sandbox Mode and much more. <a href="/free-trial" target="_blank">Try it</a> for free!';
        notieTexts += '<span class="display-block">' + jowPaidPromoText + "</span>";
    }
    if (notieTexts) notie.alert({
        type: 4,
        text: notieTexts,
        stay: true,
        prepend: true
    });
    // Show unread messages
    let unreadMessages = data["unreadMessages"].toLocaleString("en");
    $messagesNumber.text(unreadMessages);
    if (data["unreadMessages"]) $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
    else $(".messages-icon").attr("src", "static/www/static/message_icon.png");
    $("#messages").show();
    // Buyout page
    let buyoutShown = false;
    if (data["buyoutData"] && !awardsShown && !annualTournamentDialogsShown) {
        $b947816677aa453b$var$showBuyoutPage(data["buyoutData"]);
        buyoutShown = true;
        showDashboard = false;
    }
    // Forming new company page
    let formNewCompanyShown = false;
    if (data["newCompanyData"] && !awardsShown && !annualTournamentDialogsShown && !buyoutShown) {
        // Add company details
        if (data["newCompanyData"]["monthsToForm"] === 2 && !data["newCompanyData"]["companyDetails"]) {
            $b947816677aa453b$var$showFormNewCompanyDetailsPage(data);
            showDashboard = false;
            formNewCompanyShown = true;
        } else if (data["newCompanyData"]["monthsToForm"] === 1 && !data["newCompanyData"]["talentDetails"]) {
            $b947816677aa453b$var$showFormNewCompanyTalentPage(data);
            showDashboard = false;
            formNewCompanyShown = true;
        }
    }
    // Draft page
    let draftShown = false;
    if (data["draftData"]) {
        (0, $06fab4d9d48fca73$export$a67bece96d5ad74f)(data["draftData"]);
        draftShown = true;
        showDashboard = false;
    }
    // Talent offers
    let talentOfferShown = false;
    if (data["talentOffers"].length > 0 && !(data["powReactionDialogs"] && data["powReactionDialogs"].length > 0) && !(data["tutorialState"] && data["tutorialState"] !== "end_tutorial") && !awardsShown && !annualTournamentDialogsShown && !draftShown && !(0, $98xmD.globalUser).developerMode) {
        talentOfferShown = true;
        // Show talent offer
        let talentOfferIndex = 0;
        let talentOffer = data["talentOffers"][talentOfferIndex];
        $b947816677aa453b$var$displayTalentOffer(talentOffer);
        // Disable menu buttons
        (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
        // Continue talent offer
        $talentOfferBox.off("click", "#continue-talent-offer-button");
        $talentOfferBox.on("click", "#continue-talent-offer-button", async function() {
            // Get next talent offer
            talentOfferIndex++;
            talentOffer = data["talentOffers"][talentOfferIndex];
            if (talentOffer) $b947816677aa453b$var$displayTalentOffer(talentOffer);
            else {
                $talentOfferBox.hide();
                // Enable menu buttons
                (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
                // Load home page
                await $b947816677aa453b$export$2b9447da23271d13(await (0, $3E8Nt.getCurrentGame)());
            }
        });
        showDashboard = false;
    }
    // Trade Offers
    let tradeOfferShown = false;
    if (data["tradeOffers"].length > 0 && !(data["powReactionDialogs"] && data["powReactionDialogs"].length > 0) && !(data["tutorialState"] && data["tutorialState"] !== "end_tutorial") && !awardsShown && !annualTournamentDialogsShown) {
        tradeOfferShown = true;
        // Show trade offer
        let tradeOfferIndex = 0;
        let tradeOffer = data["tradeOffers"][tradeOfferIndex];
        $b947816677aa453b$var$displayIncomingTradeOffer(tradeOffer);
        // Disable menu buttons
        (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
        $bookingContainer.find(".participants-box-match-header, .participants-box-segment-header, .participants-box-match-container, .participants-box-callup-header, .participants-box-segment-container, #add-segment, #superstars-menu, #championship_info, .participants-box-draft-header, #booking-talent-container").hide();
        $bookingContainer.find(".participants-box-trade-offer-header").show();
        // Continue trade offer
        $incomingTradeOfferContainer.off("click", ".continue-trade-offer-button");
        $incomingTradeOfferContainer.on("click", ".continue-trade-offer-button", async function() {
            // Get next trade offer
            tradeOfferIndex++;
            tradeOffer = data["tradeOffers"][tradeOfferIndex];
            if (tradeOffer) $b947816677aa453b$var$displayIncomingTradeOffer(tradeOffer);
            else {
                $incomingTradeOfferContainer.hide();
                // Enable menu buttons
                (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
                // Load home page
                await $b947816677aa453b$export$2b9447da23271d13(await (0, $3E8Nt.getCurrentGame)());
            }
        });
        showDashboard = false;
    }
    // New talent requests
    let talentRequestShown = false;
    if (data["talentRequestsData"] && data["talentRequestsData"].length > 0 && !talentOfferShown && !tradeOfferShown && !awardsShown && !buyoutShown && !formNewCompanyShown && !randomEventShown && !annualTournamentDialogsShown && !draftShown && !(0, $98xmD.globalUser).developerMode) {
        talentRequestShown = true;
        let talentRequestChanged = false;
        // Show talent request
        let talentRequestIndex = 0;
        let talentRequest = data["talentRequestsData"][talentRequestIndex];
        $b947816677aa453b$var$displayTalentRequest(talentRequest);
        // Disable menu buttons
        (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
        // Continue talent request
        $talentRequestBox.off("click", ".continue-talent-request-button");
        $talentRequestBox.on("click", ".continue-talent-request-button", async function() {
            // Get next talent request unless repeating
            if (!$(this).data("repeat")) talentRequestIndex++;
            talentRequest = data["talentRequestsData"][talentRequestIndex];
            if (talentRequest) $b947816677aa453b$var$displayTalentRequest(talentRequest);
            else {
                // Revert to dashboard
                $talentRequestBox.hide();
                // Enable menu buttons
                (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
                // Show top 50 rankings if present, otherwise run callup if available, otherwise show dashboard
                if (data["yearlyRankingData"] && !(Object.keys(data["yearlyRankingData"]).length === 0)) (0, $70adc4a1fd111893$export$8e1132a1a7754c30)(data["yearlyRankingData"], false);
                else if (((0, $98xmD.globals).game.companyMonth === 0 || (0, $98xmD.globals).game.companyMonth === 6) && !(0, $98xmD.globals).game.trainingCallupRun) await $b947816677aa453b$export$cc99d6c9d04059f3();
                else {
                    // Get dashboard data if talent request changed, otherwise show dashboard
                    if (talentRequestChanged) await (0, $cfad1684038efd91$export$3a75641b11dbce93)();
                    else $("#dashboard-container").show();
                    $(".main-menu-container").find("li").removeClass("selected");
                    $("#main-menu-right").html("");
                    $("#view-dashboard-menu-button").addClass("selected");
                }
            }
        });
        // Change talent request event handler
        $talentRequestBox.off("click", ".change-talent-request-option");
        $talentRequestBox.on("click", ".change-talent-request-option", async function() {
            // Make change request if allowed
            let talentRequestData = data["talentRequestsData"][talentRequestIndex];
            let talentRequestsData = data["talentRequestsData"];
            if (talentRequestData["changeAllowed"]) {
                let uid = talentRequestData["uid"];
                await (0, $1JSre.makeGameRequest)((0, $1olyO.changeTalentRequestView), {
                    uid: uid
                }, ({ data: data } = {})=>{
                    if (!data["error"]) {
                        // Show change dialog
                        $b947816677aa453b$var$showTalentRequestDialogOnly(talentRequestData["changeDialog"]);
                        // Insert new request after current request
                        talentRequestsData.splice(talentRequestIndex + 1, 0, data["newTalentRequestData"]);
                        talentRequestChanged = true;
                    } else if (data["error"] === "talent-request-not-found") notie.alert({
                        type: 3,
                        text: "The talent request could not be found. Please try again."
                    });
                }, {}, false);
            } else {
                $b947816677aa453b$var$showTalentRequestDialogOnly(talentRequestData["changeDialog"]);
                // Mark continue button to repeat talent request
                $(".continue-talent-request-button").data("repeat", true);
            }
        });
        // Accept talent request event handler
        $talentRequestBox.off("click", ".accept-talent-request-option");
        $talentRequestBox.on("click", ".accept-talent-request-option", async function() {
            let talentRequestData = data["talentRequestsData"][talentRequestIndex];
            let uid = talentRequestData["uid"];
            await (0, $1JSre.makeGameRequest)((0, $1olyO.acceptTalentRequestView), {
                uid: uid
            }, ({ data: data } = {})=>{
                if (!data["error"]) // Show dialog
                $b947816677aa453b$var$showTalentRequestDialogOnly(data["dialog"]);
                else if (data["error"] === "talent-request-not-found") notie.alert({
                    type: 3,
                    text: "The talent request could not be found. Please try again."
                });
            }, {}, false);
        });
        // Decline talent request handler
        $talentRequestBox.off("click", ".decline-talent-request-option");
        $talentRequestBox.on("click", ".decline-talent-request-option", async function() {
            let talentRequestData = data["talentRequestsData"][talentRequestIndex];
            let uid = talentRequestData["uid"];
            await (0, $1JSre.makeGameRequest)((0, $1olyO.declineTalentRequestView), {
                uid: uid
            }, ({ data: data } = {})=>{
                if (!data["error"]) {
                    // Show dialog
                    $b947816677aa453b$var$showTalentRequestDialogOnly(data["dialog"]);
                    // Update unread messages
                    if (data["unreadMessages"] !== parseInt($messagesNumber.text())) {
                        let unreadMessages = data["unreadMessages"].toLocaleString("en");
                        $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
                        $messagesNumber.text(unreadMessages);
                        $("#messages").hide().fadeIn("fast");
                    }
                    talentRequestChanged = true;
                } else if (data["error"] === "talent-request-not-found") notie.alert({
                    type: 3,
                    text: "The talent request could not be found. Please try again."
                });
            }, {}, false);
        });
        // Show talent details
        $talentRequestBox.off("click", ".talent-request-view-talent-details-button");
        $talentRequestBox.on("click", ".talent-request-view-talent-details-button", async function() {
            let talentRequestData = data["talentRequestsData"][talentRequestIndex];
            let dataType = talentRequestData["talentType"];
            let talentUid = talentRequestData["talentUid"];
            await (0, $d3e44747ec383890$export$8777720a6e173e8e)(talentUid, dataType, null, ".talent-request-box");
        });
        showDashboard = false;
    }
    // Yearly rankings
    if (data["yearlyRankingData"] && !(Object.keys(data["yearlyRankingData"]).length === 0) && !talentOfferShown && !tradeOfferShown && !awardsShown && !buyoutShown && !formNewCompanyShown && !randomEventShown && !talentRequestShown && !annualTournamentDialogsShown && !draftShown) {
        (0, $70adc4a1fd111893$export$8e1132a1a7754c30)(data["yearlyRankingData"], false);
        showDashboard = false;
    }
    if (data["powReactionDialogs"] && data["powReactionDialogs"].length > 0) showDashboard = false;
    // Dashboard
    if (data["dashboardData"]) (0, $cfad1684038efd91$export$d263176ddbe21bfc)(data["dashboardData"]);
    if (showDashboard) $("#view-dashboard-menu-button").addClass("selected");
    else $("#dashboard-container").hide();
    // Show hide PoW 'Talk' button
    if (data["story"] === "passion") $("#pow-talk-button").show();
    else $("#pow-talk-button").hide();
    // PoW dialogs
    if (data["story"] === "passion" && !awardsShown) {
        // Show producer introduction dialog
        if (data["showPowIntroduction"]) $("#pow-talk-button").trigger("click");
        // Show producer reaction dialog
        if (data["powReactionDialogs"] && data["powReactionDialogs"].length > 0) (0, $e37bb324c1adb297$export$22af59cdbd54e1f8)(data["powReactionDialogs"]);
        // If game story ended in failure, disable menu buttons
        (0, $98xmD.globals).game.powStoryFailureEnding = data["powStoryFailureEnding"];
        if ((0, $98xmD.globals).game.powStoryFailureEnding) (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$7a872614bdce3277));
    }
    // Run tutorial state if not already running
    if ((0, $98xmD.globals).game.tutorialState && !(0, $98xmD.globals).currentTutorialStep) (0, $acecca4a272c50a4$export$36f96b5f9463ac7a)((0, $98xmD.globals).game.tutorialState);
    // Tutorial action check
    (0, $acecca4a272c50a4$export$a1aafb768cdbcc70)("go_to_game");
    // Show ads
    if (!(0, $98xmD.globalUser).paid && (0, $98xmD.globals).game.story !== "tutorial") {
        $("#ads-container").show();
        $(".ad-container").html('<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js" crossorigin="anonymous"></script>\n        <!-- JoW -->\n        <ins class="adsbygoogle"\n             style="display:block"\n             data-ad-client="ca-pub-6641763625967646"\n             data-ad-slot="9880553786"\n             data-ad-format="auto"\n             data-full-width-responsive="true"></ins>\n        <script>\n            (adsbygoogle = window.adsbygoogle || []).push({});\n        </script>');
        // If are are blocked, show ad support message
        if (window.adsJoW === undefined) {
            if (!notieTexts) notie.alert({
                type: 4,
                text: "The free version of JoW is supported by ad revenue. Please consider disabling your ad-blocker for this site to help out the game. Thank you!",
                stay: true
            });
        }
    } else $("#ads-container").hide();
}
function $b947816677aa453b$var$showBuyoutPage(buyoutData) {
    const $buyoutCompetitorSelectionSigningsAvailable = $(".buyout-competitor-selection-signings-available");
    const $buyoutCompetitorSelectionSuperstars = $(".buyout-competitor-selection-superstars");
    const $buyoutCompetitorSelectionChampionshipsAvailable = $(".buyout-competitor-selection-championships-available");
    const $buyoutCompetitorSelectionChampionships = $(".buyout-competitor-selection-championships");
    const $buyoutBox = $(".buyout-competitor-selection-box");
    // Show buyout box, details
    $buyoutBox.show();
    $buyoutBox.data("uid", buyoutData["companyUid"]);
    $(".buyout-competitor-selection-company-name").text(buyoutData["companyName"]);
    $(".buyout-competitor-selection-info").text(buyoutData["ownerName"] + " has allowed you a limited number of Superstars and Championships " + "from " + buyoutData["companyName"] + ". Select the ones you would like to bring in.");
    // Superstars
    $buyoutCompetitorSelectionSigningsAvailable.text(buyoutData["signingsAvailable"] + " Selections Available");
    $buyoutCompetitorSelectionSigningsAvailable.data("value", buyoutData["signingsAvailable"]);
    let superstarsHtml = "";
    buyoutData["superstars"].forEach(function(superstar) {
        superstarsHtml += $b947816677aa453b$var$getBuyoutSuperstarsSelectionHtml(superstar);
    });
    $buyoutCompetitorSelectionSuperstars.html(superstarsHtml);
    $buyoutBox.find('input[value="send_all_to_main_roster"]').prop("checked", false);
    // Championships
    $buyoutCompetitorSelectionChampionshipsAvailable.text(buyoutData["championshipsAvailable"] + " Selections Available");
    $buyoutCompetitorSelectionChampionshipsAvailable.data("value", buyoutData["championshipsAvailable"]);
    let championshipsHtml = "";
    buyoutData["championships"].forEach(function(championship) {
        championshipsHtml += $b947816677aa453b$var$getBuyoutChampionshipsSelectionHtml(championship);
    });
    $buyoutCompetitorSelectionChampionships.html(championshipsHtml);
    // Reset selections scroll, selected text
    $buyoutCompetitorSelectionSuperstars.scrollTop(0);
    $(".buyout-competitor-selection-superstars-selected").text("None");
    $buyoutCompetitorSelectionChampionships.scrollTop(0);
    $(".buyout-competitor-selection-championships-selected").text("None");
    (0, $1JSre.hideContent)($buyoutBox);
    // Disable menu buttons
    (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
}
function $b947816677aa453b$var$getBuyoutSuperstarsSelectionHtml(superstar) {
    let availableClass = "";
    if (!superstar["available"]) availableClass = " disabled";
    let popularity = '<span class="margin-left-10"><i class="fa fa-angle-double-up margin-right-5"></i>' + superstar["popularity"] + "</span>";
    let age = '<span class="margin-left-10 light-grey">' + superstar["age"] + " y/o</span>";
    let appearances = superstar["appearances"] !== null ? '<span class="light-grey">' + superstar["appearances"] + " apps.</span>" : "";
    // Superstar name, color and help text
    let superstarNameClass = "";
    let superstarHelpTexts = [];
    if (superstar["appearances"] !== null) {
        superstarNameClass = "blue";
        superstarHelpTexts.push("Part-timer");
    }
    if (superstar["championships"].length > 0) {
        superstarNameClass = "gold";
        let championships = Array.from(superstar["championships"], function(championship) {
            return championship + " Champion";
        });
        superstarHelpTexts.push((0, $3E8Nt.commaSeparate)(championships));
    }
    if (!superstar["available"]) superstarHelpTexts.push("Not Available to Sign");
    if (superstar["injured"]) {
        superstarNameClass = "dark-red";
        superstarHelpTexts.push("Injured for {0} months".format(superstar["injured"]));
    }
    if (superstar["retired"]) {
        superstarNameClass = "medium-light-grey";
        superstarHelpTexts.push("Retired");
    }
    if (superstar["fullTimeManager"]) {
        superstarNameClass = "manager-color";
        superstarHelpTexts.push("Full-time Manager");
    }
    let superstarName;
    if (superstarHelpTexts.length > 0) superstarName = '<div class="line-height-1p4 buyout-competitor-selection-item-name ' + superstarNameClass + ' help-text display-inline-block" title="' + superstarHelpTexts.join(", ") + '">' + superstar["name"] + "</div>";
    else if (superstarNameClass) superstarName = '<div class="line-height-1p4 buyout-competitor-selection-item-name display-inline-block' + superstarNameClass + '">' + superstar["name"] + "</div>";
    else superstarName = '<div class="line-height-1p4 buyout-competitor-selection-item-name display-inline-block">' + superstar["name"] + "</div>";
    return '<div class="inner-box-item buyout-competitor-selection-item' + availableClass + '" data-uid="' + superstar["uid"] + '">' + '<div class="medium-dark-grey">' + '<div class="buyout-competitor-selection-item-column-left">' + superstarName + "</div>" + '<div class="buyout-competitor-selection-item-column-right">' + "<span>" + appearances + age + popularity + "</span>" + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
}
function $b947816677aa453b$var$getBuyoutChampionshipsSelectionHtml(championship) {
    // Get name and prestige icon
    let championshipPrestigeIcon = '<span class="margin-left-6">' + (0, $1JSre.getChampionshipPrestigeIconHtml)(championship["prestige"]) + "</span>";
    let championshipName = '<div class="buyout-competitor-selection-item-name line-height-1p4">' + championship["name"] + championshipPrestigeIcon + "</div>";
    // Get rank and division
    let rank = '<span class="margin-left-10 light-grey">' + championship["rank"] + "</span>";
    let division = "";
    if (championship["tag"]) division = '<span class="medium-light-grey">Tag</span>';
    if (championship["trio"]) division = '<span class="medium-light-grey">Trio</span>';
    return '<div class="inner-box-item buyout-competitor-selection-item" data-uid="' + championship["uid"] + '">' + '<div class="medium-dark-grey">' + '<div class="buyout-competitor-selection-item-column-left">' + championshipName + "</div>" + '<div class="buyout-competitor-selection-item-column-right">' + division + rank + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
}
function $b947816677aa453b$var$getCompanyHeaderHtml(companyName, playerName) {
    if (companyName.length > 18) companyName = (0, $1JSre.formatCompanyName)(companyName);
    let html = companyName;
    if ((0, $98xmD.globals).game.sandboxModeEnabled) html = '<span class="sandbox-mode-color help-text" title="Sandbox Mode">' + html + "</span>";
    if ((0, $98xmD.globals).game.story === "passion") html = '<span class="pow-color">' + html + "</span>";
    if ((0, $98xmD.globals).game.controlMultipleCompanies) {
        if (playerName) html += '<span class="light-grey margin-left-8">{0}</span>'.format(playerName);
        $(".change-company-button").show();
    } else $(".change-company-button").hide();
    return html;
}
async function $b947816677aa453b$export$cc99d6c9d04059f3(hide = true) {
    // Get available callups data
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    let availableCallupsData = await (0, $jpMCP.getAvailableCallupsData)();
    notie.hideAlerts();
    // Show available callups data
    if (availableCallupsData) {
        if (hide) (0, $1JSre.hideContent)($());
        $b947816677aa453b$var$showAvailableCallupsPage(availableCallupsData);
    }
    // Callup talent handler
    $(document).off("click", "#booking-talent-container .superstar-select");
    $(document).on("click", "#booking-talent-container .superstar-select", $b947816677aa453b$var$callupAvailableTrainingTalentRequest);
}
function $b947816677aa453b$var$showAvailableCallupsPage(data) {
    // Declare jquery selectors
    const $bookingTalentInfo = $("#booking-talent-info");
    const $superstars = $("#booking-talent-container");
    const $bookingContainer = $("#booking-container");
    const $training = $("#training");
    // Show superstar info
    $bookingTalentInfo.html('<div class="superstar-information-container font-bold medium-grey">Roster Member Details<div class="empty-superstar-info light-grey"><div class="vertical-center">Hover over a Roster Member to display their details here</div></div></div>');
    $bookingTalentInfo.removeClass("match").fadeIn();
    // Reset superstars and booking container
    $superstars.find(".superstar-select, .none-team-text, .none-callups-text").remove();
    $superstars.show();
    $superstars.children().hide();
    $(".participants-box-callup-header").show();
    $bookingContainer.show();
    $bookingContainer.find(".participants-box-match-header, .participants-box-segment-header, .participants-box-match-container, .participants-box-segment-container, #add-segment, #booking-talent-menu, #booking-championship-info, .participants-box-draft-header, .participants-box-trade-offer-header").hide();
    // Show available callups
    data.forEach(function(training) {
        $training.append('<button type="button" class="font-bold superstar-select roster-item-member" data-type="' + training["type"] + '" data-uid="' + training["uid"] + '">' + training["name"] + "</button>");
    });
    if (data.length <= 0) $training.append('<span class="font-bold light-grey margin-left-2 none-callups-text">No Talent available</span>');
    $training.fadeIn();
    $superstars.scrollTop(0);
    // Show talent info handler
    let mouseEnterTimer;
    $training.off("mouseenter mouseleave", ".roster-item-member");
    $training.on({
        mouseenter: function(event) {
            mouseEnterTimer = setTimeout(function() {
                $b947816677aa453b$var$showTrainingTalentInformation($(event.target), data);
            }, 50);
        },
        mouseleave: function() {
            clearTimeout(mouseEnterTimer);
        }
    }, ".roster-item-member");
}
async function $b947816677aa453b$var$callupAvailableTrainingTalentRequest() {
    const $el = $(this);
    if ($el.parent().closest("div").attr("id") === "training") {
        if ((0, $98xmD.globals).requestRunning) return;
        // Get talent uid and type
        let talentUid = $el.attr("data-uid");
        let talentType = $el.attr("data-type");
        // Callup talent
        notie.alert({
            type: 4,
            text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
            stay: true
        });
        (0, $98xmD.globals).requestRunning = true;
        let data = await (0, $jpMCP.callupAvailableTrainingTalent)(talentUid, talentType);
        (0, $98xmD.globals).requestRunning = false;
        notie.hideAlerts();
        $(".notie-textbox-inner").text("");
        // Show callup result
        await $b947816677aa453b$var$showCallupAvailableTrainingTalentRequestResult(data);
    }
}
async function $b947816677aa453b$var$showCallupAvailableTrainingTalentRequestResult(data) {
    if (!data["error"]) {
        (0, $lCS03.playSoundEffect)("success");
        let overnessIncrease = '<span class="hot-color">' + data["overnessIncrease"] + '<span class="margin-left-2">%</span></span>';
        let html = '<span class="display-block"><span class="green">Called up </span>' + data["name"] + " to the Main Roster, " + "boosting " + data["pronoun"] + " Overness by " + overnessIncrease + "</span>";
        notie.alert({
            type: 4,
            text: html,
            stay: true,
            prepend: true
        });
        // Hide buttons
        $("#booking-talent-container .superstar-select").hide();
        // Go to dashboard
        setTimeout(async function() {
            await (0, $cfad1684038efd91$export$3a75641b11dbce93)();
            $(".main-menu-container").find("li").removeClass("selected");
            $("#main-menu-right").html("");
            $("#view-dashboard-menu-button").addClass("selected");
        }, 1200);
    } else {
        (0, $lCS03.playSoundEffect)("error");
        if (data["error"] === "talent-not-found") notie.alert({
            type: 3,
            text: "The selected talent could not be found. Please try again."
        });
        if (data["error"] === "callup-already-run") notie.alert({
            type: 3,
            text: "A callup has already been performed."
        });
    }
}
function $b947816677aa453b$var$showTrainingTalentInformation($el, data) {
    let selectedUid = parseInt($el.attr("data-uid"));
    let member = data.filter(function(obj) {
        return obj.objectName === $el.attr("data-type") && obj.uid === selectedUid;
    })[0];
    if (member) {
        if ($el.attr("data-type") === "tagTeam") (0, $f18c00e15af0c7db$export$b73c16b811178760)(member);
        else (0, $f18c00e15af0c7db$export$8d1c45aa228e7350)(member);
    }
}
function $b947816677aa453b$var$showIntroducePowerupsViewData({ data: data } = {}) {
    if (data["powerupIntroduced"]) {
        // Reset notie transition
        notie.setOptions({
            transitionDuration: 0.3
        });
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
        }
        // Show notification
        notie.alert({
            type: 4,
            text: '<span class="display-block">New message about an <span class="black">' + (0, $98xmD.globals).game.powerupWord + "</span> available</span>",
            stay: true,
            prepend: true
        });
    }
}
function $b947816677aa453b$var$showIntroduceSpecialSegmentsViewData({ data: data } = {}) {
    if (data["specialSegmentIntroduced"]) {
        // Reset notie transition
        notie.setOptions({
            transitionDuration: 0.3
        });
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
        }
        // Show notification
        notie.alert({
            type: 4,
            text: '<span class="display-block">New message about a <span class="special-segment-color">Special</span> Segment available</span>',
            stay: true
        });
    }
}
async function $b947816677aa453b$var$showConfirmBuyoutSelectionsData({ data: data } = {}) {
    if (!data["error"]) {
        // Enable menu buttons
        (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
        // Hide button
        $("#confirm-buyout-selections").hide();
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        notie.alert({
            type: 4,
            text: "Buyout Confirmed",
            stay: true
        });
        // Hide buyout container, load home page
        setTimeout(function() {
            $(".buyout-competitor-selection-box").fadeOut("fast", async function() {
                await $b947816677aa453b$export$2b9447da23271d13(await (0, $3E8Nt.getCurrentGame)());
            });
        }, 1000);
    } else {
        if (data["error"] === "competitor-not-found") notie.alert({
            type: 3,
            text: "The Competitor could not be found. Please try again."
        });
        if (data["error"] === "no-buyout-running") notie.alert({
            type: 3,
            text: "No Buyout is running. Please try again."
        });
    }
}
function $b947816677aa453b$var$displayTalentOffer(data) {
    let parent = $(".talent-offer-box");
    let el = $(".talent-offer-box-graphic");
    let offerFrom = data["offers"].length > 1 ? "Multiple companies" : data["offers"][0]["companyName"];
    let offerWord = data["offers"].length > 1 ? "offers" : "an offer";
    let summaryText = "{0} made {1} for {2}".format(offerFrom, offerWord, data["name"]);
    parent.find(".talent-offer-summary").text(summaryText);
    parent.data("name", data["name"]);
    parent.data("uid", data["uid"]);
    parent.data("type", data["type"]);
    el.data("graphic", data["graphic"]);
    (0, $c82cd471f4baff6b$export$e7557da3ac483fcd)(el, data["graphic"]);
    parent.find(".talent-offer-box-dialog-content").text(data["dialog"]).hide().fadeIn("fast");
    // Show offers
    let offersHtml = "";
    data["offers"].forEach(function(offer, i) {
        let selected = "";
        let selectedIcon = '<i class="fa fa-check light-green margin-left-8 font-1p25em"></i>';
        if (i === 0) {
            selected = " selected";
            selectedIcon = '<i class="fa fa-check light-green margin-left-8 font-1p25em"></i>';
        }
        offersHtml += '<div><div class="talent-offer-box-offer-item display-inline-block margin-bottom-2' + selected + '" data-uid="' + offer["uid"] + '">' + '<span class="blue margin-right-3">' + '<img src="static/www/static/cp_icon.png" alt="Points" class="points-image-small margin-right-2"> ' + offer["offeredAmount"] + "</span>" + " " + offer["companyName"] + selectedIcon + "</div>" + "</div>";
    });
    parent.find(".talent-offer-box-amount").html(offersHtml);
    parent.find(".talent-offer-box-offer-container").show();
    parent.find('.talent-offer-box-offer-item:not(".selected") i').hide();
    // Change offer text
    if (data["offers"].length > 1) parent.find(".talent-offer-box-offer-text").text("Offers");
    else parent.find(".talent-offer-box-offer-text").text("Offer");
    parent.find(".talent-offer-box-buttons-container .button").show();
    parent.find("#continue-talent-offer-button").hide();
    parent.fadeIn("fast");
}
function $b947816677aa453b$var$showAcceptOrRejectTalentOfferRequestData({ data: data } = {}) {
    let parent = $(".talent-offer-box");
    parent.find(".talent-offer-box-dialog-content").text(data["dialog"]).hide().fadeIn("fast");
    parent.find(".talent-offer-box-buttons-container .button").hide();
    parent.find("#continue-talent-offer-button").show();
    parent.find(".talent-offer-box-offer-container").hide();
    // Update points
    let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
    $(".points-number").html(pointsHtml);
    // Update unread messages
    if (data["unreadMessages"] !== parseInt($(".messages-number").text())) {
        let unreadMessages = data["unreadMessages"].toLocaleString("en");
        $(".messages-icon").attr("src", "static/www/static/message_alert_icon.png");
        $(".messages-number").text(unreadMessages);
        $("#messages").hide().fadeIn("fast");
    }
}
function $b947816677aa453b$var$displayTalentRequest(data) {
    let parent = $(".talent-request-box");
    let el = $(".talent-request-graphic");
    // Add data attributes
    parent.data("uid", data["talentUid"]);
    parent.data("type", data["talentType"]);
    parent.data("index", data["talentType"]);
    parent.data("changeAllowed", data["changeAllowed"]);
    if (data["changeAllowed"]) parent.data("changeDialog", data["changeDialog"]);
    // Show graphic
    el.data("graphic", data["graphic"]);
    (0, $c82cd471f4baff6b$export$e7557da3ac483fcd)(el, data["graphic"], true);
    // Show dialog
    parent.find(".talent-request-dialog-content").text(data["dialog"]).hide().fadeIn("fast");
    // Show status text
    let remainingHtml;
    if (data["status"] === "created") {
        // Get months remaining
        let monthsRemaining = data["monthsRemaining"];
        if (monthsRemaining === 0) remainingHtml = "Ends next event";
        else if (monthsRemaining === 1) remainingHtml = "Ends next month";
        else {
            let monthsWord = (0, $3E8Nt.getMonthsWord)(monthsRemaining);
            remainingHtml = "Ends in {0} {1}".format(monthsRemaining, monthsWord);
        }
    } else {
        // Get completed/failed text
        if (data["status"] === "completed") remainingHtml = '<span class="green">Request completed</span>';
        else if (data["status"] === "failed") remainingHtml = '<span class="red">Request failed</span>';
    }
    parent.find(".talent-request-status").html(remainingHtml);
    // Show request and talent name
    parent.find(".talent-request-name").text(data["name"]);
    parent.find(".talent-request-talent-name").text(data["talentName"]);
    // Show responses
    parent.find(".accept-talent-request-option").text(data["responses"]["acceptRequest"]);
    parent.find(".decline-talent-request-option").text(data["responses"]["declineRequest"]);
    parent.find(".change-talent-request-option").text(data["responses"]["changeRequest"]);
    // Hide responses if finished, show continue button
    if (data["status"] === "completed" || data["status"] === "failed") {
        parent.find(".talent-request-response-item").hide();
        parent.find(".continue-talent-request-button").show();
    } else {
        parent.find(".talent-request-response-item").show();
        parent.find(".continue-talent-request-button").hide();
    }
    parent.find(".continue-talent-request-button").data("repeat", false);
    parent.fadeIn("fast");
}
function $b947816677aa453b$var$showTalentRequestDialogOnly(dialog) {
    // Show change dialog, hide responses, show continue button
    $(".talent-request-box").find(".talent-request-dialog-content").text(dialog).hide().fadeIn("fast");
    $(".talent-request-box").find(".talent-request-response-item").hide();
    $(".talent-request-box").find(".continue-talent-request-button").show();
}
function $b947816677aa453b$export$d11fe3a77bf18ed6(superstar) {
    let popularity = '<span class="margin-left-15">' + superstar["popularity"] + "</span>";
    let appearances = superstar["appearances"] !== null ? '<span class="light-grey">' + superstar["appearances"] + " apps.</span>" : "";
    // Superstar name, color and help text
    let superstarNameClass = "";
    let superstarHelpTexts = [];
    if (superstar["appearances"] !== null) {
        superstarNameClass = "blue";
        superstarHelpTexts.push("Part-timer");
    }
    if (superstar["championships"].length > 0) {
        superstarNameClass = "gold";
        let championships = Array.from(superstar["championships"], function(championship) {
            return championship + " Champion";
        });
        superstarHelpTexts.push((0, $3E8Nt.commaSeparate)(championships));
    }
    if (superstar["injured"]) {
        superstarNameClass = "dark-red";
        let monthsWord = (0, $3E8Nt.getMonthsWord)(superstar["injured"]);
        superstarHelpTexts.push("Injured for {0} {1}".format(superstar["injured"], monthsWord));
    }
    if (superstar["retired"]) {
        superstarNameClass = "medium-light-grey";
        superstarHelpTexts.push("Retired");
    }
    if (superstar["fullTimeManager"]) {
        superstarNameClass = "manager-color";
        superstarHelpTexts.push("Full-time Manager");
    }
    let superstarName;
    if (superstarHelpTexts.length > 0) superstarName = '<div class="line-height-1p4 annual-tournament-selection-item-name ' + superstarNameClass + ' help-text display-inline-block margin-right-8" title="' + superstarHelpTexts.join(", ") + '">' + superstar["name"] + "</div>";
    else if (superstarNameClass) superstarName = '<div class="line-height-1p4 annual-tournament-selection-item-name display-inline-block margin-right-8' + superstarNameClass + '">' + superstar["name"] + "</div>";
    else superstarName = '<div class="line-height-1p4 annual-tournament-selection-item-name display-inline-block margin-right-8">' + superstar["name"] + "</div>";
    let unavailableClass = "";
    if (!superstar["available"]) unavailableClass = " unavailable";
    return '<div class="inner-box-item annual-tournament-selection-item' + unavailableClass + '" data-uid="' + superstar["uid"] + '">' + '<div class="medium-dark-grey">' + '<div class="annual-tournament-selection-item-column-left">' + superstarName + "</div>" + '<div class="annual-tournament-selection-item-column-right">' + "<span>" + appearances + popularity + "</span>" + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
}
function $b947816677aa453b$var$showProcessAwardsData({ data: data } = {}) {
    if (!data["error"]) {
        if (!(Object.keys(data).length === 0)) {
            // Disable menu buttons
            (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
            // Texts
            let introTexts = [
                "Welcome to The Wrestling Spectator Awards {0}! It feels great to say that I'm your host, {1}. Let's get started with my favorite award.",
                "Hello and welcome to The Wrestling Spectator Awards {0}! I, {1}, will be your host for the evening. The first award is, uh, an interesting one.",
                "Good evening! It's your host for The Wrestling Spectator Awards {0}, {1}! What an honor it is. Let's get to it. The first award is, uh, a weird one.",
                "It's time for The Wrestling Spectator Awards {0}! I'm your host, {1}, and I'll try to do a better job than every other incapable host over the years. We'll start with the stupidest match award.",
                "It's The Wrestling Spectator Awards {0}! What an honor that they chose me, {1}, as the host for this year. We'll be starting off with the stupidest match award."
            ];
            let nomineeTexts = [
                "And the nominees are",
                "Here are the nominees",
                "The nominees for this award are",
                "Let's look at the nominees",
                "Here are the nominees for this award",
                "A look at the nominees",
                "Nominees, please",
                "Take a look at the nominees",
                "The nominees are",
                "The nominees",
                "Okay, the nominees are"
            ];
            let winnerTexts = [
                "And the winner is...",
                "The winner...",
                "And the winner for this award is...",
                "Drumroll please...",
                "The winner, and NEW award holder...",
                "The winner is...",
                "The winner, in a landslide vote...",
                "The winner, in a close call!",
                "A tough vote, but the winner is clear...",
                "A close one! The winner is...",
                "An easy winner this year!",
                "Finally, the winner...",
                "And the WINNER..."
            ];
            let nextAwardTexts = [
                "Moving on to the next award!",
                "Okay, let's go to the next award",
                "The next award is...",
                "Bored yet? Okay next award",
                "The next award...",
                "Moving on",
                "The next award is",
                "Moving on forward",
                "Tu turu tuu",
                "The next award is...",
                "*whistles awkwardly*",
                "Okay, let's keep moving"
            ];
            let endTexts = [
                "Thanks for coming to the awards! Prizes will be distributed now.",
                "Hope you had a nice night everyone! Vote for me as host for the next awards and don't forget to collect your prizes!",
                "Thanks for attending the awards. Winners can collect their prizes now. Sorry if I was a bad host.",
                "That's it, hope you had a fun evening! We'll be giving the winners their prizes now.",
                "That's it for this years awards! Make sure to come back next year. Prizes will be given out now."
            ];
            let awardComments = {
                "Match of the Year": [
                    "What a great match that was!",
                    "I remember I loved that match",
                    "Deserving as well",
                    "An awesome match for sure",
                    "My favorite match too!"
                ],
                "Worst Match of the Year": [
                    "What a terrible match!",
                    "What a bad match that was",
                    "A stinker, indeed",
                    "Ugh, don't remind me of it!",
                    "The crowd really booed them that night, as they are now. Okay, that's enough."
                ],
                "Craziest Match of the Year": [
                    "What a crazy match!",
                    "What a spotfest!",
                    "I loved that match!",
                    "Holy shit they did some awesome stuff",
                    "They need to do another one!"
                ],
                "Stupidest Match of the Year": [
                    "That was a really stupid match",
                    "Oh god. What happened there?",
                    "That was indeed a terrible match",
                    "Okay, please stop booing.",
                    "Never again please!"
                ],
                "Wrestler of the Year": [
                    "Hear hear!",
                    "What a great year that wrestler had!",
                    "Deservedly so",
                    "That superstar put on some fantastic matches",
                    "Can't wait to see what they do next"
                ],
                "Most Hyped Event of the Year": [
                    "That was a big event!",
                    "What a grand show that was.",
                    "The biggest event of the year!",
                    "An awesome production.",
                    "Man was I excited for that!"
                ],
                "Event of the Year": [
                    "What a great event!",
                    "What a spectacle!",
                    "I loved every minute of it",
                    "An amazing night",
                    "A great performance by everyone there"
                ],
                "Worst Event of the Year": [
                    "A terrible event indeed",
                    "What a bad show they put on",
                    "Okay, you can boo this one",
                    "I agree, didn't enjoy it one bit!",
                    "I don't know what happened, but it shouldn't happen again"
                ],
                "Company of the Year": [
                    "What a great year they had!",
                    "They put on some remarkable shows",
                    "I loved so many things they did",
                    "An amazing run",
                    "Everyone worked really hard there"
                ],
                "Worst Company of the Year": [
                    "They had a terrible year",
                    "What a bad run they went on",
                    "Okay, please stop booing",
                    "Yes, they were pretty bad",
                    "Not a good year for them"
                ],
                "Feud of the Year": [
                    "An awesome feud indeed",
                    "Those two were amazing",
                    "What a great feud!",
                    "Can't wait for them to feud again",
                    "One of the highlights of the year"
                ],
                "Worst Feud of the Year": [
                    "That was a waste",
                    "What a bad feud",
                    "Those two can do a lot better than that",
                    "I can't believe how bad that was",
                    "What a waste that was"
                ],
                "Segment of the Year": [
                    "A memorable segment indeed",
                    "What a great segment that was!",
                    "We need more segments like that",
                    "Damn that was enjoyable!",
                    "That was really fun to watch"
                ],
                "Worst Segment of the Year": [
                    "A terrible segment",
                    "Bad acting, bad writing",
                    "That really shouldn't have happened",
                    "That was just silly",
                    "Why did they do that?"
                ],
                "Championship of the Year": [
                    "A memorable year for the title",
                    "What a great run that title had",
                    "What a great bel— I mean title",
                    "A splendid year for that championship",
                    "We saw some great matches for it"
                ],
                "Faction of the Year": [
                    "A great year for them",
                    "What a run they had this past year",
                    "My favorite faction!",
                    "Can I join you guys?",
                    "They had an incredible run"
                ]
            };
            // Selectors
            let awardNomineeHeader = $(".award-nominee-header");
            let awardName = $(".award-name");
            let awardReward = $(".award-reward");
            let awardNominees = $(".award-nominees");
            awardNomineeHeader.show();
            // Reset
            awardNominees.html("");
            awardNomineeHeader.text("");
            awardName.text("");
            awardReward.text("");
            $(".progress-award-button").remove();
            $(".trophy").html("");
            $(".skip-awards-button").show();
            function displayAward() {
                // Reset
                $(".progress-award-button").remove();
                let award = data["awards"][awardIndex];
                if (awardProgressIndex === 0) {
                    // Show award name and trophy
                    awardNomineeHeader.hide();
                    awardNomineeHeader.text((0, $3E8Nt.shuffle)(nomineeTexts)[0]);
                    awardNomineeHeader.fadeIn("medium");
                    awardName.hide();
                    awardName.text(award["name"]);
                    awardName.fadeIn();
                    // Hide previous nominees and rewards
                    awardReward.hide();
                    awardReward.html("");
                    awardNominees.html("");
                    // Show trophy
                    let trophyHtml = "";
                    switch(award["trophy"]){
                        case "worst":
                            trophyHtml = "trophy_icon_trash";
                            break;
                        case "bronze":
                            trophyHtml = "trophy_icon_bronze";
                            break;
                        case "silver":
                            trophyHtml = "trophy_icon_silver";
                            break;
                        case "gold":
                            trophyHtml = "trophy_icon_gold";
                            break;
                    }
                    trophyHtml = '<img alt="' + trophyHtml + '" src="static/www/static/' + trophyHtml + '.png" class="trophy-image large margin-right-8"/>';
                    $(".trophy").html(trophyHtml);
                } else if (awardProgressIndex === 1) {
                    awardNominees.html("");
                    award["nominees"].forEach(function(nominee) {
                        let div = $('<div class="award-nominee">' + nominee["name"] + "</div>");
                        awardNominees.append(div);
                        div.hide();
                        div.slideDown("slow");
                    });
                } else if (awardProgressIndex === 2) {
                    awardNomineeHeader.hide();
                    awardNomineeHeader.text("");
                    awardNomineeHeader.text((0, $3E8Nt.shuffle)(winnerTexts)[0]);
                    awardNomineeHeader.fadeIn("medium");
                    awardNominees.html("");
                } else if (awardProgressIndex === 3) {
                    let div = $('<div class="award-nominee font-bold">' + award["winner"]["name"] + "</div>");
                    awardNominees.html(div).hide().slideDown();
                    if (award["trophy"] === "worst") div.addClass("flash-text-green puke-green");
                    else div.addClass("flash-text gold-true");
                } else if (awardProgressIndex === 4) {
                    if (award["trophy"] === "worst") awardNomineeHeader.text((0, $3E8Nt.shuffle)(awardComments[award["name"]])[0]);
                    else awardNomineeHeader.text((0, $3E8Nt.shuffle)(awardComments[award["name"]])[0]);
                    awardNomineeHeader.hide().fadeIn("medium");
                    // Show reward
                    if (!(Object.keys(award["reward"]).length === 0 && award["reward"].constructor === Object)) {
                        let reward;
                        if (award["reward"]["points"] > 0) reward = award["companyName"] + ' gained <span class="white font-bold">' + '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 margin-right-5"/>{0}</span>';
                        else {
                            reward = '<span class="white font-bold"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-5 margin-right-5"/>{0}</span> were taken away from ' + award["companyName"] + "</span>";
                            award["reward"]["points"] *= -1;
                        }
                        awardReward.hide();
                        awardReward.html(reward.format(award["reward"]["points"]));
                        awardReward.fadeIn("medium");
                    } else {
                        awardReward.hide();
                        awardReward.html("");
                    }
                } else if (awardProgressIndex === 5) {
                    // Show next award
                    if (awardIndex < data["awards"].length - 1) {
                        awardNomineeHeader.hide();
                        awardNomineeHeader.text((0, $3E8Nt.shuffle)(nextAwardTexts)[0]);
                        awardNomineeHeader.fadeIn("medium");
                    } else endAwards();
                }
                // Add 'continue' awards button if not end of last award
                if (awardIndex < data["awards"].length - 1 || awardProgressIndex !== 5) $(".awards-heading").after('<button type="button" class="button retro-button condensed dark-grey-button-background margin-sides-auto display-block progress-award-button">Continue</button>');
            }
            function endAwards() {
                // End awards
                awardNominees.html("");
                awardNomineeHeader.hide();
                awardNomineeHeader.text((0, $3E8Nt.shuffle)(endTexts)[0]);
                awardNomineeHeader.fadeIn("medium");
                $(".skip-awards-button").hide();
                // Update points
                let pointsHtml = (0, $1JSre.getPointsHtml)(data["points"], (0, $98xmD.globals).game.unlimitedCreativePoints);
                $(".points-number").html(pointsHtml);
                setTimeout(async function() {
                    // Enable menu buttons
                    (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
                    // Load home page
                    await $b947816677aa453b$export$2b9447da23271d13(await (0, $3E8Nt.getCurrentGame)(), false);
                }, 1500);
            }
            // Go through awards
            let awardIndex = 0;
            let awardProgressIndex = 0;
            // Add intro text
            awardNomineeHeader.html('<i class="fa fa-commenting fa-flip-horizontal comment-icon"></i>' + (0, $3E8Nt.shuffle)(introTexts)[0].format((0, $98xmD.globals).game.year, data["host"]));
            // Show continue button
            $(".awards-heading").after('<button type="button" class="button retro-button condensed dark-grey-button-background margin-sides-auto display-block progress-award-button">Continue</button>');
            // Progress awards button
            $(".awards-box").off("click", ".progress-award-button");
            $(".awards-box").on("click", ".progress-award-button", function() {
                if (awardProgressIndex > 5) {
                    awardIndex += 1;
                    awardProgressIndex = 0;
                }
                displayAward();
                awardProgressIndex += 1;
            });
            // Skip awards button
            $(".awards-box").off("click", ".skip-awards-button");
            $(".awards-box").on("click", ".skip-awards-button", function() {
                notie.confirm({
                    text: "This will skip ALL awards. Are you sure?",
                    submitCallback: function() {
                        $(this).hide();
                        awardNominees.html("");
                        awardNomineeHeader.text("");
                        awardName.text("");
                        awardReward.text("");
                        $(".progress-award-button").remove();
                        $(".trophy").html("");
                        endAwards();
                    }
                });
            });
        } else notie.alert({
            type: 4,
            text: "The award shows have already run this year! Come back next year for more entertaining fun and prizes!",
            stay: true
        });
        $(".awards-box").show();
    }
}
function $b947816677aa453b$var$showRandomEventSelection(randomEvents) {
    (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
    (0, $1JSre.hideContent)($(".random-event-choice-box"));
    randomEvents.forEach(function(randomEvent) {
        let buttonsHtml = "";
        randomEvent["choices"].forEach(function(choice) {
            let buttonClass = "";
            if (choice === "Ignore") buttonClass = " grey-button-background";
            if (choice === "Accept") buttonClass = " green-button-background";
            if (choice === "Decline" || choice === "Suspend") buttonClass = " red-button-background";
            let button = '<span class="button retro-button random-event-choice-button margin-right-10' + buttonClass + '" ' + 'data-uid="' + randomEvent["uid"] + '">' + choice + "</span>";
            buttonsHtml += button;
        });
        $(".random-event-choice-buttons").html(buttonsHtml).show();
        $(".random-event-choice-from").html("- " + randomEvent["fromName"]);
        $(".random-event-choice-content").html(randomEvent["content"]);
        $(".random-event-choice-subject").html(randomEvent["subject"]);
    });
}
async function $b947816677aa453b$var$showAddRandomEventChoiceData({ data: data } = {}) {
    if (!data["error"]) {
        // Hide buttons
        $(".random-event-choice-buttons").hide();
        // Add response text
        if (data["replyContent"]) $(".random-event-choice-content").text(data["replyContent"]);
        // Update messages
        if (data["unreadMessages"] !== parseInt($(".messages-number").text())) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
        setTimeout(function() {
            $(".random-event-choice-box").fadeOut("fast", async function() {
                // Enable menu buttons
                (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
                // Load home page
                await $b947816677aa453b$export$2b9447da23271d13(await (0, $3E8Nt.getCurrentGame)());
            });
        }, 1500);
    } else {
        if (data["error"] === "choice-already-added") notie.alert({
            type: 3,
            text: "You have already responded to this message"
        });
        else if (data["error"] === "random-event-not-found") notie.alert({
            type: 3,
            text: "There was a problem finding that message"
        });
        else if (data["error"] === "choice-not-found") notie.alert({
            type: 3,
            text: "There was a problem responding to this message"
        });
    }
}
function $b947816677aa453b$var$displayIncomingTradeOffer(tradeOffer) {
    let parent = $(".incoming-trade-offer-container");
    parent.data("uid", tradeOffer["uid"]);
    parent.find(".trade-offer-offered-superstars").html("");
    tradeOffer["offeredSuperstars"].forEach(function(offeredSuperstar) {
        let html = '<div class="trade-offer-superstar-item trade-offer-offered-superstar" data-uid="' + offeredSuperstar["uid"] + '">' + offeredSuperstar["name"] + "<div>";
        parent.find(".trade-offer-offered-superstars").append(html);
    });
    for(let i = 0; i < 5 - tradeOffer["offeredSuperstars"].length; i++){
        let html = '<div class="trade-offer-superstar-item light-grey disabled">Empty</div>';
        parent.find(".trade-offer-offered-superstars").append(html);
    }
    parent.find(".trade-offer-requested-superstars").html("");
    tradeOffer["requestedSuperstars"].forEach(function(requestedSuperstar) {
        let html = '<div class="trade-offer-superstar-item trade-offer-requested-superstar" data-uid="' + requestedSuperstar["uid"] + '">' + requestedSuperstar["name"] + "<div>";
        parent.find(".trade-offer-requested-superstars").append(html);
    });
    for(let i = 0; i < 5 - tradeOffer["requestedSuperstars"].length; i++){
        let html = '<div class="trade-offer-superstar-item light-grey disabled">Empty</div>';
        parent.find(".trade-offer-requested-superstars").append(html);
    }
    parent.find(".trade-offer-sender-company-name").text(tradeOffer["senderCompany"]);
    parent.find(".trade-offer-receiver-company-name").text(tradeOffer["receiverCompany"]);
    let durationText = tradeOffer["duration"];
    if (durationText) durationText = "{0} {1}".format(durationText, (0, $3E8Nt.getMonthsWord)(durationText));
    else durationText = "Permanent";
    parent.find(".trade-offer-duration-text").text(durationText);
    parent.find(".continue-trade-offer-button").hide();
    parent.find(".accept-trade-offer-button").show();
    parent.find(".decline-trade-offer-button").show();
    parent.fadeIn("fast");
}
function $b947816677aa453b$var$showReplyToTradeOfferRequestData({ data: data, selectedChoice: selectedChoice } = {}) {
    if (!data["error"]) {
        let notieText;
        if (selectedChoice === "accept") notieText = "Trade offer accepted";
        else notieText = "Trade offer declined";
        notie.alert({
            type: 4,
            text: notieText
        });
        let parent = $(".incoming-trade-offer-container");
        parent.find(".continue-trade-offer-button").show();
        parent.find(".accept-trade-offer-button").hide();
        parent.find(".decline-trade-offer-button").hide();
        $("#booking-container").hide();
        // Update unread messages
        if (data["unreadMessages"]) {
            let unreadMessages = data["unreadMessages"].toLocaleString("en");
            $(".messages-icon").attr("src", "static/message_alert_icon.png");
            $(".messages-number").text(unreadMessages);
            $("#messages").hide().fadeIn("fast");
        }
    } else if (data["error"] === "trade-offer-not-found") notie.alert({
        type: 3,
        text: "That Trade Offer could not be found. Please try again."
    });
}
function $b947816677aa453b$var$processFormNewCompanyOpenGraphicCreator(hide) {
    if (typeof hide === "undefined") hide = true;
    let openCharacterCreator = $(".form-new-company-championships .character-creator:visible");
    if (openCharacterCreator.length > 0) {
        if (hide) {
            openCharacterCreator.find(".superstar-graphic").html("");
            openCharacterCreator.hide();
        }
        openCharacterCreator.find(".load-character-code-input").val("");
        // Save championship's graphics
        openCharacterCreator.find(".share-character").trigger("click"); // Trigger share and hide it
        openCharacterCreator.find(".share-character-code-container").hide();
        openCharacterCreator.find(".share-character").removeClass("selected");
        let characterData = openCharacterCreator.find(".share-character-code-input").val();
        if (characterData) {
            let selectedChampionship = $(".form-new-company-championship-add-graphic-button.blue-button-background").parent();
            selectedChampionship.data("key", characterData);
            if (hide) selectedChampionship.find(".form-new-company-championship-add-graphic-button").addClass("dark-grey-button-background").removeClass("blue-button-background");
        }
    }
}
async function $b947816677aa453b$var$showConfirmNewCompanyDetailsData({ data: data } = {}) {
    if (!data["error"]) {
        notie.alert({
            type: 4,
            text: "New message from " + data["ownerName"] + ".",
            stay: true
        });
        setTimeout(function() {
            // Enable menu buttons
            (0, $212d6f8aa99fe567$export$a281725797d1ff19)("default");
            $(".form-new-company-details-box").fadeOut("fast", async function() {
                // Load home page
                await $b947816677aa453b$export$2b9447da23271d13(await (0, $3E8Nt.getCurrentGame)());
            });
        }, 1000);
    } else {
        if (data["error"] === "name-exists") notie.alert({
            type: 3,
            text: "A company with that name already exists. Please choose a different name."
        });
        else if (data["error"] === "already-done") notie.alert({
            type: 3,
            text: "This action has already been completed."
        });
    }
}
function $b947816677aa453b$var$showFormNewCompanyDetailsPage(data) {
    (0, $1JSre.hideContent)($(".form-new-company-details-box"));
    $(".form-new-company-details-info").html(`<i class="fa fa-info-circle margin-right-2"></i> Confirm the details of the new company you are forming with ${data["newCompanyData"]["ownerName"]}.`);
    (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
}
function $b947816677aa453b$var$showFormNewCompanyTalentPage(data) {
    (0, $1JSre.hideContent)($(".form-new-company-talent-box"));
    $(".form-new-company-talent-info").html(`<i class="fa fa-info-circle margin-right-2"></i> Make offers to talent for your new company. 
Highlighted superstars are sure to join you, while others have a chance to join, based on morale and traits.`);
    (0, $212d6f8aa99fe567$export$a281725797d1ff19)((0, $212d6f8aa99fe567$export$99f8e639d042c746));
    // Show superstars
    $(".form-new-company-selections-available").text(data["newCompanyData"]["selectionsData"]["selectionsAvailable"] + " Selections Available");
    $(".form-new-company-selections-available").data("value", data["newCompanyData"]["selectionsData"]["selectionsAvailable"]);
    let superstarsHtml = "";
    data["newCompanyData"]["selectionsData"]["superstars"].forEach(function(superstar) {
        superstarsHtml += $b947816677aa453b$var$getFormNewCompanySelectionHtml(superstar);
    });
    $(".form-new-company-superstars").html(superstarsHtml);
    // Reset selections scroll, selected text
    $(".form-new-company-superstars").scrollTop(0);
    $(".form-new-company-superstars-selected").text("None");
}
function $b947816677aa453b$var$getFormNewCompanySelectionHtml(superstar) {
    let interestedClass = "";
    if (superstar["interested"]) interestedClass = " interested";
    let popularity = '<span class="margin-left-10"><i class="fa fa-angle-double-up margin-right-5"></i>' + superstar["popularity"] + "</span>";
    let age = '<span class="margin-left-10 light-grey">' + superstar["age"] + " y/o</span>";
    let appearances = superstar["appearances"] !== null ? '<span class="light-grey">' + superstar["appearances"] + " apps.</span>" : "";
    // Superstar name, color and help text
    let superstarNameClass = "";
    let superstarHelpTexts = [];
    if (superstar["appearances"] !== null) {
        superstarNameClass = "blue";
        superstarHelpTexts.push("Part-timer");
    }
    if (superstar["championships"].length > 0) {
        superstarNameClass = "gold";
        let championships = Array.from(superstar["championships"], function(championship) {
            return championship + " Champion";
        });
        superstarHelpTexts.push((0, $3E8Nt.commaSeparate)(championships));
    }
    if (superstar["interested"]) superstarHelpTexts.push("Interested In Joining");
    if (superstar["injured"]) {
        superstarNameClass = "dark-red";
        superstarHelpTexts.push("Injured for {0} months".format(superstar["injured"]));
    }
    if (superstar["retired"]) {
        superstarNameClass = "medium-light-grey";
        superstarHelpTexts.push("Retired");
    }
    if (superstar["fullTimeManager"]) {
        superstarNameClass = "manager-color";
        superstarHelpTexts.push("Full-time Manager");
    }
    let superstarName;
    if (superstarHelpTexts.length > 0) superstarName = '<div class="line-height-1p4 form-new-company-selection-item-name ' + superstarNameClass + ' help-text display-inline-block" title="' + superstarHelpTexts.join(", ") + '">' + superstar["name"] + "</div>";
    else if (superstarNameClass) superstarName = '<div class="line-height-1p4 form-new-company-selection-item-name display-inline-block' + superstarNameClass + '">' + superstar["name"] + "</div>";
    else superstarName = '<div class="line-height-1p4 form-new-company-selection-item-name display-inline-block">' + superstar["name"] + "</div>";
    return '<div class="inner-box-item form-new-company-selection-item' + interestedClass + '" data-uid="' + superstar["uid"] + '">' + '<div class="medium-dark-grey">' + '<div class="form-new-company-selection-item-column-left">' + superstarName + "</div>" + '<div class="form-new-company-selection-item-column-right">' + "<span>" + appearances + age + popularity + "</span>" + "</div>" + '<div class="clear"></div>' + "</div>" + "</div>";
}



var $1JSre = parcelRequire("1JSre");

var $lCS03 = parcelRequire("lCS03");



var $bZol7 = parcelRequire("bZol7");
let $993642189aedf295$var$oldSavesNotieShown = false;
async function $993642189aedf295$export$ceac039078e40199() {
    (0, $lCS03.playSoundEffect)("success");
    let $existingGames = $("#existing-games");
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $1JSre.hideMainMenuContent)($());
    // Get games data
    (0, $98xmD.globals).requestRunning = true;
    const gamesData = await (0, $iRMwH.getUserGames)();
    (0, $98xmD.globals).requestRunning = false;
    notie.hideAlerts();
    let importSaveButton = "";
    if ((0, $98xmD.globalUser).developerMode) importSaveButton = '<label for="import-save-input" class="button retro-button condensed dark-grey-button-background float-right margin-left-3 import-save-label">Import</label><input id="import-save-input" type="file" class="display-none"/>';
    // Add header
    $existingGames.html('<div class="font-bold medium-grey margin-left-2 margin-top-15 margin-bottom-15">Local Saves' + importSaveButton + '<button type="button" class="button retro-button condensed dark-grey-button-background import-cloud-saves-button' + ' float-right margin-left-3">Cloud Saves</button>' + '<button type="button" class="button retro-button condensed dark-grey-button-background import-main-game-saves-button' + ' float-right">Previous Saves</button>' + "</div>");
    // Show game box for each game
    let gamesHtml = "";
    gamesData.forEach((gameData)=>{
        let gameBoxHtml = $993642189aedf295$var$getGameBoxHtml(gameData, "select-game");
        gamesHtml += gameBoxHtml;
    });
    // Show empty game box
    let html;
    if (!(0, $98xmD.globalUser).paid) html = '<div class="game-box empty help-text" title="JoW Paid includes unlimited save slots."><span class="display-block grey">Empty Save Slot</span></div>';
    else html = '<div class="game-box empty"><span class="display-block grey">Empty Save Slot</span></div>';
    gamesHtml += html;
    // Add games boxes
    $existingGames.append('<div class="existing-games-container">' + gamesHtml + "</div>");
    $existingGames.fadeIn("slow");
    $(".existing-games-container").scrollTop(0);
    // Add notie of how to import if no local saves
    if (!gamesData.length && (0, $98xmD.globalUser).loggedIn && !$993642189aedf295$var$oldSavesNotieShown) {
        notie.alert({
            type: 4,
            text: 'No saves? You can import your old saves by clicking on "Previous Saves".'
        });
        $993642189aedf295$var$oldSavesNotieShown = true;
    }
    return;
}
function $993642189aedf295$var$getGameBoxHtml(gameData, gameBoxClass) {
    // Get scenario name and edit name
    let scenarioInfo = gameData.name;
    if (gameData.editName) {
        let editInfo = '<span class="light-grey margin-left-5">"{0}" Edit</span>'.format(gameData.editName);
        scenarioInfo += editInfo;
    }
    // Don't show delete button if showing games to replace
    let deleteButton = "";
    if (gameBoxClass !== "replace-game") deleteButton = '<button class="button retro-button condensed padding-7-9 display-inline-block margin-bottom-0 red-button-background delete-game-button">Delete</button>';
    // Get sandbox html
    let sandboxHtml = "";
    if (gameData.settings.sandbox_mode_enabled) sandboxHtml = '<div class="margin-top-5 sandbox-mode-color">Sandbox Mode</div>';
    // Get local multiplayer html
    let localMultiplayerHtml = "";
    if (gameData.settings.control_multiple_companies) {
        let playerNamesHtml = '<span class="light-grey margin-left-8">{0}</span>'.format((0, $3E8Nt.commaSeparate)(gameData.playerNames));
        localMultiplayerHtml = '<div class="margin-top-5 local-multiplayer-mode-color">Local Multiplayer{0}</div>'.format(playerNamesHtml);
    }
    // Get last played html
    let lastPlayed = "";
    if (gameData.lastPlayed) lastPlayed = gameData.lastPlayed;
    return '<div class="game-box ' + gameBoxClass + '" data-dbUid="' + gameData.dbUid + '" data-company-name="' + gameData.companyName.replace(/"/g, "&quot;") + '" data-game-year="' + gameData.year + '">' + // Left column
    '<div class="column-left">' + '<span class="display-block margin-bottom-10 font-1p25em line-height-1p4 font-mukta-mahee faded-blue">' + gameData.companyName + "</span>" + '<span class="medium-dark-grey">' + gameData.nextEventName + " (Year " + gameData.year + ") " + "</span>" + '<span class="display-block grey margin-top-5 line-height-1p4">' + scenarioInfo + "</span>" + sandboxHtml + localMultiplayerHtml + "</div>" + // Right column
    '<div class="column-right text-right">' + '<div class="grey font-0p925em top-3px">' + lastPlayed + "</div>" + deleteButton + "</div>" + '<div class="clear"></div>' + "</div>";
}
async function $993642189aedf295$export$5573b974f162909(el) {
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    // Get database by uid
    const dbUid = el.attr("data-dbUid");
    await (0, $14eBR.loadDb)(dbUid);
    const game = (0, $14eBR.Games).find({})[0];
    if (!game) {
        notie.alert({
            type: 3,
            text: "That game could not be found. Please try to find it under Cloud Saves."
        });
        (0, $98xmD.globals).requestRunning = false;
        (0, $lCS03.playSoundEffect)("error");
        return false;
    }
    let mainCompany = await (0, $iRMwH.getGameMainUserCompany)(game);
    if (!(0, $98xmD.globalUser).paid && (mainCompany.storyName && mainCompany.storyName !== "tutorial" || game.settings["sandbox_mode_enabled"] || game.settings["control_multiple_companies"])) {
        notie.alert({
            type: 3,
            text: "Stories, sandbox mode and local multiplayer are only available in JoW Paid"
        });
        (0, $98xmD.globals).requestRunning = false;
        (0, $lCS03.playSoundEffect)("error");
        return false;
    }
    const user = (0, $bZol7.loadUser)();
    if ((0, $98xmD.globalUser).freeTrialActivated && game.userUid && user.uid !== game.userUid) {
        notie.alert({
            type: 3,
            text: "You cannot play games created on another account on the free trial. Please login to that account to play it."
        });
        (0, $98xmD.globals).requestRunning = false;
        (0, $lCS03.playSoundEffect)("error");
        return false;
    }
    (0, $lCS03.playSoundEffect)("success");
    // Set current game
    await (0, $iRMwH.markGameAsPlaying)(game);
    // Save to local storage
    await (0, $iRMwH.saveGameDataToLocalStorage)(game);
    // Go to game
    await $993642189aedf295$export$2dd56c65048c4a4b(game);
}
async function $993642189aedf295$export$2dd56c65048c4a4b(game, storyName = null) {
    // Hide main menu, load home page for game
    return $("#existing-games, #new-game-menu, #main-menu, .main-header-container, .custom-starting-company-container").fadeOut("fast").promise().done(async function() {
        $(".tutorial-element-outline").hide();
        $(".tutorial-info-container").hide();
        (0, $acecca4a272c50a4$export$8dec9b3b951af069)();
        (0, $98xmD.globals).currentTutorialStep = null;
        $(".main-container").addClass("hide-background");
        $("#continue-game").show();
        notie.hideAlerts();
        (0, $98xmD.globals).requestRunning = false;
        // Load story intro page if new story game
        if (storyName === "passion") {
            // Reset content
            $(".intro-text").hide();
            $(".intro-heading").hide();
            $(".intro-sub-heading").hide();
            $(".intro-continue-button-container").hide();
            // Show heading
            const introHeadingHtml = '<div class="text-center font-1p25em margin-top-40 margin-bottom-2">Florida</div>';
            $(".intro-heading").html(introHeadingHtml).fadeIn("slow");
            $("#intro").fadeIn();
            setTimeout(function() {
                // Show subheading
                const introSubHeading = '<div class="text-center margin-bottom-15">March, 1985</div>';
                $(".intro-sub-heading").hide().html(introSubHeading).fadeIn("slow");
                setTimeout(function() {
                    // Show intro text
                    const powIntroText = "<p>It's the 80s. Wrestling is booming. A new promotion is looking to rise up, using the talent of their women's only cast. And you've just joined as booker.</p><p>But before it can rise, <span class=\"pow-color\">Passion of Wrestling</span> needs sponsors. And Hank Hughes, a former sci-fi producer and the guy managing the project, has a plan.</p><p>With the big guns of wrestling running wild, can a small, women's promotion even be noticed?</p>";
                    $(".intro-text").html(powIntroText).fadeIn("slow");
                    $(".intro-continue-button-container").hide().fadeIn(1000);
                }, 1600);
            }, 1200);
        } else await (0, $b947816677aa453b$export$2b9447da23271d13)(game);
    });
}
async function $993642189aedf295$export$c082e02cf58ee558() {
    (0, $1JSre.makeGetRequest)("/_get_user_games", {}, (data)=>{
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideMainMenuContent)($());
        // Add header
        const $accountGames = $("#account-games");
        $accountGames.html('<div class="font-bold blue margin-left-2 margin-top-15 margin-bottom-15">Previous Saves<button type="button" class="button retro-button condensed dark-grey-button-background back-to-saves-button float-right">Back</button></div>');
        // Add games boxes
        let gamesHtml = "";
        data["games"].forEach((gameData)=>{
            let gameBoxHtml = $993642189aedf295$var$getMainGameSaveHtml(gameData);
            gamesHtml += gameBoxHtml;
        });
        if (!data["games"].length) gamesHtml = '<div class="game-box empty"><span class="display-block grey">Empty Save Slot</span></div>';
        $accountGames.append('<div class="account-games-container">' + gamesHtml + "</div>");
        $accountGames.fadeIn("slow");
        $(".account-games-container").scrollTop(0);
    });
}
function $993642189aedf295$var$getMainGameSaveHtml(game) {
    // Get scenario name and edit name
    let scenarioInfo = game["name"];
    if (game["edit_name"]) {
        let editInfo = '<span class="light-grey margin-left-5">"{0}" Edit</span>'.format(game["edit_name"]);
        scenarioInfo += editInfo;
    }
    // Get sandbox html
    let sandboxHtml = "";
    if (game["settings"]["sandbox_mode_enabled"]) sandboxHtml = '<div class="margin-top-5 sandbox-mode-color">Sandbox Mode</div>';
    // Get local multiplayer html
    let localMultiplayerHtml = "";
    if (game["settings"]["control_multiple_companies"]) {
        let playerNamesHtml = '<span class="light-grey margin-left-8">{0}</span>'.format((0, $3E8Nt.commaSeparate)(game["player_names"]));
        localMultiplayerHtml = '<div class="margin-top-5 local-multiplayer-mode-color">Local Multiplayer{0}</div>'.format(playerNamesHtml);
    }
    // Get last played html
    let lastPlayed = "";
    if (game["last_played"]) lastPlayed = game["last_played"];
    return '<div class="game-box import-main-game-save" data-uid="' + game["uid"] + '">' + // Left column
    '<div class="column-left">' + '<span class="display-block margin-bottom-10 font-1p25em line-height-1p4 font-mukta-mahee faded-blue">' + game["company_name"] + "</span>" + '<span class="medium-dark-grey">' + game["next_event"] + " (Year " + game["year"] + ") " + "</span>" + '<span class="display-block grey margin-top-5 line-height-1p4">' + scenarioInfo + "</span>" + sandboxHtml + localMultiplayerHtml + "</div>" + // Right column
    '<div class="column-right text-right">' + '<div class="grey font-0p925em top-3px">' + lastPlayed + "</div>" + "</div>" + '<div class="clear"></div>' + "</div>";
}
async function $993642189aedf295$export$51c87832a3d15ea2(uid) {
    (0, $lCS03.playSoundEffect)("success");
    (0, $1JSre.makeGetRequest)("/_get_game_export_data", {
        uid: uid
    }, async (data)=>{
        if (!data["error"]) await $993642189aedf295$var$checkGetGameExportDataJob(data["statusUrl"]);
        else {
            notie.hideAlerts();
            (0, $98xmD.globals).requestRunning = false;
            (0, $lCS03.playSoundEffect)("error");
            if (data["error"] === "not-logged-in") notie.alert({
                type: 3,
                text: "You need to be logged in to import your account's save games.",
                stay: true
            });
            else if (data["error"] === "game-not-found") notie.alert({
                type: 3,
                text: "That game could not be found. Please try again.",
                stay: true
            });
            else if (data["error"] === "story") notie.alert({
                type: 3,
                text: "This story is not supported yet.",
                stay: true
            });
            else if (data["error"] === "paid-only") notie.alert({
                type: 3,
                text: "Stories, sandbox mode and local multiplayer are only available in JoW Paid"
            });
        }
    }, true, "Loading save data. This can take some time, depending on the size of the save.");
}
async function $993642189aedf295$var$checkGetGameExportDataJob(statusUrl) {
    (0, $1JSre.makeGetRequest)(statusUrl, {}, async (data)=>{
        switch(data.status){
            case "unknown":
            case "failed":
                notie.hideAlerts();
                (0, $98xmD.globals).requestRunning = false;
                (0, $lCS03.playSoundEffect)("error");
                notie.alert({
                    type: 3,
                    text: "There was an error. Please try again"
                });
                break;
            case "finished":
                // Create game
                notie.alert({
                    type: 4,
                    text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Importing save. This can take some time, depending on the size of the save.',
                    stay: true
                });
                try {
                    await (0, $iRMwH.createGameInDatabase)(data["result"]);
                    (0, $98xmD.globals).requestRunning = false;
                    // Go back to saves
                    await $993642189aedf295$export$ceac039078e40199();
                } catch (error) {
                    (0, $3E8Nt.captureError)(error);
                    (0, $98xmD.globals).requestRunning = false;
                    notie.alert({
                        type: 3,
                        text: "There was an error importing the game."
                    });
                }
                break;
            default:
                setTimeout(async function() {
                    await $993642189aedf295$var$checkGetGameExportDataJob(statusUrl);
                }, 1000);
        }
    }, true, null, false);
}
async function $993642189aedf295$export$3b5ab48a7da0c393() {
    (0, $1JSre.makeGetRequest)("/_get_cloud_saves", {}, (data)=>{
        if (!data["error"]) {
            (0, $lCS03.playSoundEffect)("success");
            (0, $1JSre.hideMainMenuContent)($());
            // Add header
            const $accountGames = $("#account-games");
            $accountGames.html('<div class="font-bold blue margin-left-2 margin-top-15 margin-bottom-15">Cloud Saves<button type="button" class="button retro-button condensed dark-grey-button-background back-to-saves-button float-right">Back</button></div>');
            // Add games html
            let gamesHtml = "";
            data.forEach((gameData)=>{
                let gameBoxHtml = $993642189aedf295$var$getCloudSaveHtml(gameData);
                gamesHtml += gameBoxHtml;
            });
            if (!data.length) gamesHtml = '<div class="game-box empty"><span class="display-block grey">Empty Save Slot</span></div>';
            $accountGames.append('<div class="account-games-container">' + gamesHtml + "</div>");
            $accountGames.fadeIn("slow");
            $(".account-games-container").scrollTop(0);
        } else {
            (0, $lCS03.playSoundEffect)("error");
            if (data["error"] === "not-logged-in") notie.alert({
                type: 3,
                text: "You need to login to view cloud saves."
            });
        }
    });
}
function $993642189aedf295$var$getCloudSaveHtml(game) {
    // Get scenario name and edit name
    let scenarioInfo = game["name"];
    if (game["editName"]) {
        let editInfo = '<span class="light-grey margin-left-5">"{0}" Edit</span>'.format(game["editName"]);
        scenarioInfo += editInfo;
    }
    // Get sandbox html
    let sandboxHtml = "";
    if (game["settings"]["sandbox_mode_enabled"]) sandboxHtml = '<div class="margin-top-5 sandbox-mode-color">Sandbox Mode</div>';
    // Get local multiplayer html
    let localMultiplayerHtml = "";
    if (game["settings"]["control_multiple_companies"]) {
        let playerNamesHtml = '<span class="light-grey margin-left-8">{0}</span>'.format((0, $3E8Nt.commaSeparate)(game["playerNames"]));
        localMultiplayerHtml = '<div class="margin-top-5 local-multiplayer-mode-color">Local Multiplayer{0}</div>'.format(playerNamesHtml);
    }
    // Get last played html
    let lastPlayed = "";
    if (game["datetimeLastPlayed"]) lastPlayed = (0, $3E8Nt.getTimeDiffHuman)(game["datetimeLastPlayed"], new Date()) + " ago";
    let deleteButton = '<button class="button retro-button condensed padding-7-9 display-inline-block margin-bottom-0 blue-button-background delete-cloud-save-button">Delete</button>';
    return '<div class="game-box import-cloud-save" data-filename="' + game["filename"] + '" data-company-name="' + game["companyName"].replace(/"/g, "&quot;") + '" data-game-year="' + game["year"] + '">' + // Left column
    '<div class="column-left">' + '<span class="display-block margin-bottom-10 font-1p25em line-height-1p4 font-mukta-mahee faded-blue">' + game["companyName"] + "</span>" + '<span class="medium-dark-grey">' + game["nextEventName"] + " (Year " + game["year"] + ") " + "</span>" + '<span class="display-block grey margin-top-5 line-height-1p4">' + scenarioInfo + "</span>" + sandboxHtml + localMultiplayerHtml + "</div>" + // Right column
    '<div class="column-right text-right">' + '<div class="grey font-0p925em top-3px">' + lastPlayed + "</div>" + deleteButton + "</div>" + '<div class="clear"></div>' + "</div>";
}
async function $993642189aedf295$export$c1bf68c1c2e5e907(filename) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $lCS03.playSoundEffect)("success");
    (0, $1JSre.makeGetRequest)("/_load_game_data_from_cloud", {
        filename: filename
    }, async (data)=>{
        if (!data["error"]) await $993642189aedf295$var$checkLoadGameDataFromCloudJob(data["statusUrl"]);
        else {
            notie.hideAlerts();
            (0, $98xmD.globals).requestRunning = false;
            (0, $lCS03.playSoundEffect)("error");
            if (data["error"] === "not-logged-in") notie.alert({
                type: 4,
                text: "You need to login to load save data from the cloud."
            });
        }
    }, true);
}
async function $993642189aedf295$var$checkLoadGameDataFromCloudJob(statusUrl) {
    (0, $1JSre.makeGetRequest)(statusUrl, {}, async (data)=>{
        switch(data.status){
            case "unknown":
            case "failed":
                notie.hideAlerts();
                (0, $98xmD.globals).requestRunning = false;
                (0, $lCS03.playSoundEffect)("error");
                notie.alert({
                    type: 3,
                    text: "There was an error. Please try again"
                });
                break;
            case "finished":
                // Convert base64 string to array buffer, decompress
                const arrayBuffer = $993642189aedf295$var$base64ToArrayBuffer(data["result"]);
                await $993642189aedf295$export$7ee9bbf5a8bd776d(arrayBuffer);
                break;
            default:
                setTimeout(async function() {
                    await $993642189aedf295$var$checkLoadGameDataFromCloudJob(statusUrl);
                }, 1000);
        }
    }, true, null, false);
}
async function $993642189aedf295$export$605bcac8e4532628(filename, parent) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $1JSre.makeGetRequest)("/_delete_cloud_save", {
        filename: filename
    }, async (data)=>{
        if (!data["error"]) {
            (0, $lCS03.playSoundEffect)("success");
            notie.alert({
                type: 4,
                text: "Cloud save deleted"
            });
            parent.remove();
            // Add empty text if no cloud saves left
            if (!$(".account-games-container .game-box").length) $(".account-games-container").html('<div class="game-box empty"><span class="display-block grey">Empty Save Slot</span></div>');
        } else {
            (0, $lCS03.playSoundEffect)("error");
            notie.alert({
                type: 3,
                text: "Deleting cloud save failed. Please try again."
            });
            (0, $3E8Nt.captureError)(new Error("error for delete cloud save request: " + data["error"]));
        }
    });
}
async function $993642189aedf295$export$d3ab5fe070517e4f(showLoading = true, setDatetimeLastPlayed = false) {
    if ((0, $98xmD.globals).cloudSaveRequestRunning) {
        if (showLoading) notie.alert({
            type: 4,
            text: "A cloud save is already in progress"
        });
        return false;
    }
    // Don't save if offline
    if (!window.navigator.onLine) {
        if (showLoading) notie.alert({
            type: 3,
            text: "Could not save to the cloud because you're offline.",
            stay: true
        });
        else notie.alert({
            type: 3,
            text: "WARNING! Could not save to the cloud because you're offline. Please save after going online as local save data can be lost.",
            stay: true
        });
        return false;
    }
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    // Get database json string
    let databaseJSON = (0, $14eBR.db).serialize();
    // Set datetimeLastPlayed
    if (setDatetimeLastPlayed) currentGame.datetimeLastPlayed = Date.now();
    // Get game save data
    const gameSaveData = await (0, $iRMwH.getGameSaveData)(currentGame);
    delete gameSaveData["uid"];
    gameSaveData["filename"] = (0, $14eBR.db).filename;
    if (showLoading) notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Saving to cloud. This runs in the background so you can continue playing.',
        stay: true
    });
    // Compress
    const databaseJSONArrayBuffer = fflate.strToU8(databaseJSON);
    fflate.compress(databaseJSONArrayBuffer, (err, compressed)=>{
        if (err) {
            notie.alert({
                type: 3,
                text: "Cloud save compression failed."
            });
            (0, $3E8Nt.captureError)(new Error("error for cloud save compression: " + err));
            return;
        }
        // Send as form data
        let compressedDatabaseJSON = new Blob([
            compressed
        ]);
        let formData = new FormData();
        formData.append("databaseJSON", compressedDatabaseJSON);
        formData.append("gameSaveData", JSON.stringify(gameSaveData));
        (0, $98xmD.globals).cloudSaveRequestRunning = true;
        $.ajax({
            type: "POST",
            contentType: false,
            processData: false,
            url: (0, $98xmD.globals).baseUrl + "/_save_game_data_to_cloud",
            data: formData,
            success: async function(data) {
                if (!data["error"]) await $993642189aedf295$var$checkSaveGameDataToCloudJob(data["statusUrl"], currentGame, showLoading);
                else {
                    (0, $lCS03.playSoundEffect)("error");
                    (0, $98xmD.globals).cloudSaveRequestRunning = false;
                    if (data["error"] === "max-limit") {
                        let notieText = "Maximum cloud saves (" + data["max_cloud_saves"] + ") reached. Please delete an existing " + "cloud save if you want to save this game's data to the cloud.";
                        if (data["max_cloud_saves"] === 1) notieText += " JoW Paid allows 10 cloud saves.";
                        notie.alert({
                            type: 3,
                            text: notieText
                        });
                    } else if (data["error"] === "not-logged-in") notie.alert({
                        type: 4,
                        text: "Please login if you want to save your game's data to the cloud."
                    });
                    else if (data["error"] === "paid-only") notie.alert({
                        type: 3,
                        text: "Stories, sandbox mode and local multiplayer are only available in JoW Paid"
                    });
                    else {
                        if (showLoading) notie.alert({
                            type: 3,
                            text: "Cloud save failed. Please try again.",
                            stay: true
                        });
                        else notie.alert({
                            type: 3,
                            text: "WARNING! Cloud save failed. Please try again as local save data can be lost.",
                            stay: true
                        });
                        (0, $3E8Nt.captureError)(new Error("error for cloud save request: " + data["error"]));
                    }
                }
            },
            dataType: "json",
            timeout: (0, $1JSre.requestTimeout),
            error: function(jqXHR, status, errorThrown) {
                (0, $lCS03.playSoundEffect)("error");
                (0, $98xmD.globals).cloudSaveRequestRunning = false;
                if (status === "timeout") notie.alert({
                    type: 3,
                    text: "The cloud save request timed out. Please try again in a while."
                });
                else notie.alert({
                    type: 3,
                    text: "There was an error with the cloud save request. Please try again in a while."
                });
                (0, $3E8Nt.captureError)(new Error("error for cloud save request: " + errorThrown));
            }
        });
    });
}
async function $993642189aedf295$var$checkSaveGameDataToCloudJob(statusUrl, currentGame, showLoading) {
    $.ajax({
        url: (0, $98xmD.globals).baseUrl + statusUrl,
        dataType: "json",
        success: async (data)=>{
            switch(data.status){
                case "unknown":
                case "failed":
                    (0, $lCS03.playSoundEffect)("error");
                    (0, $98xmD.globals).cloudSaveRequestRunning = false;
                    if (showLoading) notie.alert({
                        type: 3,
                        text: "Cloud save failed. Please try again.",
                        stay: true
                    });
                    else notie.alert({
                        type: 3,
                        text: "WARNING! Cloud save failed. Please try again as local save data can be lost.",
                        stay: true
                    });
                    break;
                case "finished":
                    (0, $98xmD.globals).cloudSaveRequestRunning = false;
                    if (!data["result"]["error"]) {
                        (0, $lCS03.playSoundEffect)("success");
                        notie.alert({
                            type: 1,
                            text: "Game data saved to the cloud"
                        });
                        // Set dateTimeLastCloudSave
                        currentGame.dateTimeLastCloudSave = Date.now();
                        (0, $14eBR.db).saveDatabase();
                        await (0, $iRMwH.saveGameDataToLocalStorage)(currentGame);
                        (0, $70adc4a1fd111893$export$78fe0af1c9049862)(currentGame.dateTimeLastCloudSave);
                    } else {
                        (0, $lCS03.playSoundEffect)("error");
                        if (showLoading) notie.alert({
                            type: 3,
                            text: "Cloud save failed. Please try again.",
                            stay: true
                        });
                        else notie.alert({
                            type: 3,
                            text: "WARNING! Cloud save failed. Please try again as local save data can be lost.",
                            stay: true
                        });
                        (0, $3E8Nt.captureError)(new Error("error for cloud save request job: " + data["result"]["error"]));
                    }
                    break;
                default:
                    setTimeout(async function() {
                        await $993642189aedf295$var$checkSaveGameDataToCloudJob(statusUrl, currentGame);
                    }, 1000);
            }
        },
        timeout: (0, $1JSre.requestTimeout),
        error: function(jqXHR, status, errorThrown) {
            (0, $lCS03.playSoundEffect)("error");
            (0, $98xmD.globals).cloudSaveRequestRunning = false;
            if (showLoading) notie.alert({
                type: 3,
                text: "There was an error with the cloud save request. Please try again.",
                stay: true
            });
            else notie.alert({
                type: 3,
                text: "WARNING! There was an error with the cloud save request. Please try again as local save data can be lost.",
                stay: true
            });
            (0, $3E8Nt.captureError)(new Error("error for cloud save request job: " + errorThrown));
        }
    });
}
function $993642189aedf295$var$base64ToArrayBuffer(base64) {
    let binaryString = atob(base64);
    let bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes;
}
async function $993642189aedf295$export$2fadf1979583e1b6() {
    const currentGame = await (0, $3E8Nt.getCurrentGame)();
    let databaseJSON = (0, $14eBR.db).serialize();
    currentGame.datetimeLastPlayed = Date.now();
    const databaseJSONArrayBuffer = fflate.strToU8(databaseJSON);
    fflate.compress(databaseJSONArrayBuffer, (err, compressed)=>{
        if (err) {
            notie.alert({
                type: 3,
                text: "Save compression failed."
            });
            (0, $3E8Nt.captureError)(new Error("error for save compression: " + err));
            return;
        }
        let blob = new Blob([
            compressed
        ]);
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = (0, $14eBR.db).filename;
        a.click();
        URL.revokeObjectURL(a.url);
    });
}
async function $993642189aedf295$export$7ee9bbf5a8bd776d(arrayBuffer) {
    // Decompress and convert to json string
    fflate.decompress(arrayBuffer, async (err, decompressed)=>{
        if (err) {
            notie.hideAlerts();
            (0, $98xmD.globals).requestRunning = false;
            notie.alert({
                type: 3,
                text: "Cloud save decompression failed."
            });
            (0, $3E8Nt.captureError)(new Error("error for cloud save decompression: " + err));
            return;
        }
        const databaseJSON = fflate.strFromU8(decompressed);
        // Create/load db for game
        const dbData = JSON.parse(databaseJSON);
        const filename = dbData.filename;
        await (0, $14eBR.loadDb)(filename, dbData);
        notie.hideAlerts();
        (0, $98xmD.globals).requestRunning = false;
        // Set datetimeLastPlayed and save
        const game = (0, $14eBR.Games).find({})[0];
        await (0, $iRMwH.markGameAsPlaying)(game);
        // Save to local storage
        await (0, $iRMwH.saveGameDataToLocalStorage)(game, filename);
        // Go back to saves
        await $993642189aedf295$export$ceac039078e40199();
    });
}



var $98xmD = parcelRequire("98xmD");

var $lCS03 = parcelRequire("lCS03");


var $8bQDO = parcelRequire("8bQDO");

var $3E8Nt = parcelRequire("3E8Nt");

var $bZol7 = parcelRequire("bZol7");
$(document).ready(function() {
    // Get random scenario
    $(".scenario-random-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        $(".scenario-menu .button").removeClass("selected");
        $(this).addClass("selected");
        // Reset search and category containers, menu and sort
        $(".scenario-sort").val("rating");
        $(".scenario-categories").hide();
        $(".scenario-categories-button").removeClass("selected");
        $(".scenario-search-container").hide();
        $(".scenario-search-button").removeClass("selected");
        $8de2281fafd7b0c6$var$getScenarios("random");
    });
    // Select scenario filter
    $(".scenario-filter").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        let $this = $(this);
        $(".scenario-menu .button").removeClass("selected");
        // Keep category button selected if clicking on sub category
        if ($this.parent().hasClass("scenario-categories")) $(".scenario-categories-button").addClass("selected");
        else $(".scenario-categories").hide();
        // Remove search
        $(".scenario-search-container").hide();
        // Select default sort
        $(".scenario-sort").val($this.attr("data-default-sort"));
        $(this).addClass("selected");
        // Get filtered scenarios
        $8de2281fafd7b0c6$var$getScenarios($this.attr("data-value"));
    });
    // Show scenario categories
    $(".scenario-categories-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        let $this = $(this);
        if ($this.hasClass("selected")) {
            $this.removeClass("selected");
            $(".scenario-categories").hide();
        } else {
            $(".scenario-menu .button").removeClass("selected");
            $this.addClass("selected");
            $(".scenario-categories").show();
            $(".scenario-search-container").hide();
        }
    });
    // Show scenario search
    $(".scenario-search-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        let $this = $(this);
        if ($this.hasClass("selected")) {
            $this.removeClass("selected");
            $(".scenario-search-container").hide();
        } else {
            // Reset menus, except 'All', as it is used to see if all scenarios loaded or not
            $('.scenario-menu .button:not([data-value="all"])').removeClass("selected");
            $this.addClass("selected");
            $(".scenario-search-container").show();
            $(".scenario-categories").hide();
            $(".scenario-search-input").focus();
        }
    });
    // Select 'any' radio if starting year entered
    $(".search-starting-year").on("input", function() {
        if ($(this).val()) $('input[type="radio"][name="radio-scenario-search-period"]').filter('[value="any"]').prop("checked", true);
    });
    // Show scenario search options
    $(".scenario-search-options-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        if ($(".scenario-search-options").is(":visible")) {
            $(".scenario-search-options").hide();
            $(this).html('<span class="font-0p875em">More options</span> <i class="fa fa-angle-down"></i>');
        } else {
            $(".scenario-search-options").show();
            $(this).html('<span class="font-0p875em">Hide options</span> <i class="fa fa-angle-up"></i>');
        }
    });
    // Sort scenarios
    $(".scenario-sort").on("change", function() {
        (0, $lCS03.playSoundEffect)("success");
        let value = $(this).val();
        let scenariosContainerName = "user-scenarios";
        if ($(".scenario-menu").find(".scenario-search-button").hasClass("selected")) scenariosContainerName = "scenarios-search-results";
        let userScenariosElement = document.getElementById(scenariosContainerName);
        // Sort elements by selected option
        let sortedElements = $(userScenariosElement).find(".scenario");
        if (value === "rating") sortedElements.sort(function(a, b) {
            let ratingA = $(a).attr("data-rating") ? parseFloat($(a).attr("data-rating")) : 0;
            let ratingB = $(b).attr("data-rating") ? parseFloat($(b).attr("data-rating")) : 0;
            return ratingB - ratingA;
        });
        else if (value === "plays") sortedElements.sort(function(a, b) {
            return parseFloat($(b).attr("data-plays")) - parseFloat($(a).attr("data-plays"));
        });
        else if (value === "updated") sortedElements.sort(function(a, b) {
            let dateA = $(a).attr("data-updated") ? new Date($(a).attr("data-updated")) : new Date(0);
            let dateB = $(b).attr("data-updated") ? new Date($(b).attr("data-updated")) : new Date(0);
            return dateB - dateA;
        });
        sortedElements.toArray().forEach(function(e) {
            userScenariosElement.appendChild(e);
        });
    });
    // Search scenarios
    $(".button-scenario-search").on("click", function() {
        $8de2281fafd7b0c6$var$runScenariosSearch();
    });
    $(".scenario-search-input, .search-company-name, .search-starting-year").keypress(function(e) {
        // Trigger search on enter key press
        if (e.which === 13 && $(".scenario-search-button").hasClass("selected")) $(".button-scenario-search").click();
    });
    // Show/hide sandbox mode options
    $("#container").on("change", '.game-mode-option input[type="radio"]', function() {
        if ($(this).val() === "sandbox") $(this).closest(".game-mode-option").find(".sandbox-mode-options").show();
        else $(this).closest(".game-mode-option").find(".sandbox-mode-options").hide();
    });
    $("#container").on("change", '.game-mode-option-new-game-options input[type="radio"]', function() {
        if ($(this).val() === "sandbox") $(this).closest(".game-mode-option-new-game-options").find(".sandbox-mode-options-new-game-options").show();
        else $(this).closest(".game-mode-option-new-game-options").find(".sandbox-mode-options-new-game-options").hide();
    });
    // Change competitors upon starting company change
    $("#new-game-menu").on("change", "#select-starting-company", function() {
        let defaultCompetition = $(this).parent().siblings(".competitors").find("#default-competition");
        let customStartingCompany = $(this).parent().siblings(".custom-starting-company-option").find('input[type="radio"]:checked').val();
        let $this = $(this);
        if (defaultCompetition.length > 0 && customStartingCompany !== "yes") {
            // Update select competitors if present
            let selectCompetitorsDiv = $this.closest(".starting-company").siblings(".select-competitors");
            if (selectCompetitorsDiv.length > 0) {
                // Get all companies except selected starting company
                let allCompetitors = [];
                $this.find("option").each(function(i, option) {
                    if ($(option).prop("selected") === false) allCompetitors.push($(option).text());
                });
                // Add checkboxes for all competitors
                let competitorCheckboxes = "";
                allCompetitors.forEach(function(competitor, i) {
                    let checked = i >= (0, $3E8Nt.gameLimits).maxCompetitors ? "" : ' checked="checked"';
                    competitorCheckboxes += '<label class="control control--checkbox display-block"><span class="select-competitor-name">' + (0, $1JSre.escapeHTML)(competitor) + "</span>" + '<input type="checkbox" class="select-competitor-checkbox" value="' + competitor.replace(/"/g, "&quot;") + '"' + checked + ">" + '    <div class="control__indicator"></div>' + "</label>";
                });
                selectCompetitorsDiv.find(".select-competitors-checkboxes").html(competitorCheckboxes);
            }
        }
    });
    // Show/hide select select competitors checkboxes
    $("#new-game-menu").on("click", ".none-competitors-radio, .generate-competitors-radio", function() {
        let selectCompetitorsDiv = $(this).closest(".competitors").siblings(".select-competitors");
        if (selectCompetitorsDiv.length > 0) selectCompetitorsDiv.hide();
    });
    $("#new-game-menu").on("change", ".standard-competitors-radio", function() {
        let selectCompetitorsDiv = $(this).closest(".competitors").siblings(".select-competitors");
        if (selectCompetitorsDiv.length > 0) selectCompetitorsDiv.show();
    });
    // Limit competitor selections
    $("#new-game-menu").on("click", ".select-competitor-checkbox", function() {
        let selectedCheckboxes = $(this).closest(".select-competitors-checkboxes").find(".select-competitor-checkbox:checked");
        if (selectedCheckboxes.length > (0, $3E8Nt.gameLimits).maxCompetitors) {
            notie.alert({
                type: 4,
                text: `You cannot select more than ${(0, $3E8Nt.gameLimits).maxCompetitors} competitors`,
                stay: true
            });
            $(this).prop("checked", false);
        }
    });
    // Singleplayer / local multiplayer options
    $("#container").on("change", '.player-mode-option input[type="radio"]', function() {
        if ($(this).val() === "singleplayer") {
            $(this).closest(".player-mode-option").siblings(".starting-company, .competitors, .select-competitors, .custom-starting-company-option").show();
            if ([
                "generate",
                "none"
            ].includes($(this).closest(".player-mode-option").siblings(".competitors").find('input[type="radio"]:checked').val())) $(this).closest(".player-mode-option").siblings(".select-competitors").hide();
            $(this).closest(".player-mode-option").siblings(".companies-list").hide();
        } else {
            $(this).closest(".player-mode-option").siblings(".starting-company, .competitors, .select-competitors, .custom-starting-company-option").hide();
            $(this).closest(".player-mode-option").siblings(".companies-list").show();
        }
    });
    // Show player name input if 'user' radio option selected
    $("#container").on("change", '.companies-list input[type="radio"]', function() {
        // Limit companies
        let selectedCompanies = $(this).closest(".companies-list").find('input[type="radio"][value!="none"]:checked');
        if (selectedCompanies.length > (0, $3E8Nt.gameLimits).maxCompetitors + 1) {
            notie.alert({
                type: 4,
                text: `You cannot select more than ${(0, $3E8Nt.gameLimits).maxCompetitors + 1} companies`,
                stay: true
            });
            $(this).parent().parent().find('input[value="none"]').prop("checked", true);
            return false;
        }
        if ($(this).val() === "user") $(this).parent().siblings(".player-name-input").show();
        else $(this).parent().siblings(".player-name-input").hide();
    });
    // Show/hide draft options
    $("#container").on("change", '.main-rosters-option input[type="radio"]', function() {
        if ($(this).val() === "draft") $(this).closest(".main-rosters-option").find(".draft-options").show();
        else $(this).closest(".main-rosters-option").find(".draft-options").hide();
    });
    $("#container").on("change", '.main-rosters-option-new-game-options input[type="radio"]', function() {
        if ($(this).val() === "draft") $(this).closest(".main-rosters-option-new-game-options").find(".draft-options-new-game-options").show();
        else $(this).closest(".main-rosters-option-new-game-options").find(".draft-options-new-game-options").hide();
    });
    // Show scenario information
    $("#container").on("click", ".show-scenario-information", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        let parent = $(this).parent(".scenario");
        // Remove other info divs
        $(".scenario-information-content").hide();
        // Show new div
        if (parent.find(".scenario-information-content").length < 1) parent.append('<div class="scenario-information-content line-height-24px dark-grey"></div>');
        let uid = parent.attr("data-uid");
        let scenarioEdit = parent.find(".scenario-edit.selected");
        if (scenarioEdit.length > 0) uid = scenarioEdit.attr("data-uid");
        let version = parent.find(".versions").find("#select-version").val();
        let el = parent.find(".scenario-information-content");
        $(el).html("").hide();
        (0, $1JSre.makeGetRequest)("/_get_scenario_information", {
            uid: uid,
            version: version
        }, (data)=>$8de2281fafd7b0c6$var$showScenarioInformation((0, $1JSre.toCamel)(data), el) // uses python data format, so convert to camel case
        );
    });
    // Show scenario version info
    $("#new-game-menu").on("change", "#select-version", function() {
        let version = $(this).val();
        let competition = $(this).find("option:selected").attr("data-competition");
        let startingCompany = $(this).find("option:selected").attr("data-company-name");
        let customStartingCompany = $(this).parent().siblings(".custom-starting-company-option").find('input[type="radio"]:checked').val();
        // Show version's comments
        let versionComments = $(this).siblings(".version-comments");
        versionComments.find($('div[data-version="' + version + '"]')).show();
        versionComments.find($('div[data-version!="' + version + '"]')).hide();
        // Show version's competition
        let defaultCompetition = $(this).parent().siblings(".competitors").find("#default-competition");
        let startingCompanyElement = $(this).parent().siblings(".starting-company").find("#select-starting-company");
        if (competition) {
            // Check standard competition
            defaultCompetition.siblings("input").prop("checked", true);
            defaultCompetition.parent().removeClass("display-none");
            // Change starting company options
            let competitors = JSON.parse(competition);
            let options = "";
            options += '<option selected data-default="true" value="">' + (0, $1JSre.escapeHTML)(startingCompany) + "</option>";
            competitors.forEach(function(competitor, i) {
                options += '<option value="' + competitor.replace(/"/g, "&quot;") + '">' + (0, $1JSre.escapeHTML)(competitor) + "</option>";
            });
            startingCompanyElement.html(options);
        } else {
            // Check generate option
            defaultCompetition.parent().next().find("input").prop("checked", true);
            defaultCompetition.parent().addClass("display-none");
            // Change starting company options
            let options = "";
            options += '<option selected data-default="true" value="">' + (0, $1JSre.escapeHTML)(startingCompany) + "</option>";
            startingCompanyElement.html(options);
        }
        // Unselect edits
        $(".scenario-edit.selected").removeClass("selected");
        // Update select competitors if present
        let selectCompetitorsDiv = $(this).parent().siblings(".select-competitors");
        let playerModeOption = $(this).parent().siblings(".player-mode-option").find('input[type="radio"]:checked').val();
        if (selectCompetitorsDiv.length > 0) {
            // Get all companies except selected starting company
            let allCompetitors = [];
            startingCompanyElement.find("option").each(function(i, option) {
                if (customStartingCompany === "yes" || $(option).prop("selected") === false) allCompetitors.push($(option).text());
            });
            // Add checkboxes for all competitors
            let competitorCheckboxes = "";
            allCompetitors.forEach(function(competitor, i) {
                let checked = i >= (0, $3E8Nt.gameLimits).maxCompetitors ? "" : ' checked="checked"';
                competitorCheckboxes += '<label class="control control--checkbox display-block"><span class="select-competitor-name">' + (0, $1JSre.escapeHTML)(competitor) + "</span>" + '<input type="checkbox" class="select-competitor-checkbox" value="' + competitor.replace(/"/g, "&quot;") + '"' + checked + ">" + '    <div class="control__indicator"></div>' + "</label>";
            });
            selectCompetitorsDiv.find(".select-competitors-checkboxes").html(competitorCheckboxes);
            // Show if competitors present in this version and local multiplayer not selected
            if (allCompetitors.length > 0 && playerModeOption !== "local-multiplayer") selectCompetitorsDiv.show();
            else selectCompetitorsDiv.hide();
        }
        // Update select companies if present
        let selectCompaniesDiv = $(this).closest(".scenario").find(".companies-list");
        if (selectCompaniesDiv.length > 0) {
            // Get all companies
            let allCompanies = [];
            startingCompanyElement.find("option").each(function(i, option) {
                allCompanies.push($(option).text());
            });
            // Add radio selects for all competitors
            let companiesListHtml = "";
            let scenarioUid = $(this).closest(".scenario, .scenario-edit").attr("data-uid");
            allCompanies.forEach(function(competitor, i) {
                companiesListHtml += $8de2281fafd7b0c6$var$getCompaniesListItemHtml(competitor, i, scenarioUid);
            });
            selectCompaniesDiv.find(".company-list-item").remove();
            selectCompaniesDiv.append(companiesListHtml);
        }
    });
    // Show/hide scenario edits
    $("#new-game-menu").on("click", ".scenario-edits-show-button", function() {
        let editsContainer = $(this).closest(".scenario").find(".scenario-edits-container");
        if ($(this).text() === "Show Edits") {
            if (editsContainer.is(":empty")) {
                let scenarioUid = $(this).closest(".scenario").attr("data-uid");
                $8de2281fafd7b0c6$var$getScenarioEdits(scenarioUid, editsContainer, "best");
            } else {
                editsContainer.show();
                editsContainer.find(".scroll-container").scrollTop(0);
            }
            $(this).text("Hide Edits");
        } else {
            editsContainer.hide();
            $(this).text("Show Edits");
        }
    });
    // Show scenario edit info
    $("#new-game-menu").on("click", ".show-scenario-edit-info", function(e) {
        e.stopPropagation();
        let infoElement = $(this).siblings(".scenario-edit-info");
        if (infoElement.is(":visible")) infoElement.hide();
        else infoElement.show();
    });
    // Sort scenario edits
    $("#new-game-menu").on("click", ".sort-scenario-edits-button", function(e) {
        let editsContainer = $(this).closest(".scenario").find(".scenario-edits-container");
        if (!$(this).hasClass("selected")) {
            editsContainer.find(".sort-scenario-edits-button").removeClass("selected");
            $(this).addClass("selected");
        }
        let scenarioUid = $(this).closest(".scenario").attr("data-uid");
        $8de2281fafd7b0c6$var$getScenarioEdits(scenarioUid, editsContainer, $(this).attr("data-value"));
    });
    // Scenario edit page buttons
    $("#new-game-menu").on("click", ".scenario-edits-next-page-button, .scenario-edits-previous-page-button", function() {
        let page = $(this).data("page");
        let editsContainer = $(this).closest(".scenario").find(".scenario-edits-container");
        let sort = editsContainer.find(".sort-scenario-edits-button.selected").attr("data-value");
        let scenarioUid = $(this).closest(".scenario").attr("data-uid");
        $8de2281fafd7b0c6$var$getScenarioEdits(scenarioUid, editsContainer, sort, page);
    });
    // Show scenario edit info
    $("#new-game-menu").on("click", ".scenario-edit", function() {
        // Select, unselect
        let competition;
        let startingCompany;
        if ($(this).hasClass("selected")) {
            $(this).removeClass("selected");
            // Revert to competition and starting company of selected version
            competition = $(this).closest(".scenario").find("#select-version").find("option:selected").attr("data-competition");
            startingCompany = $(this).closest(".scenario").find("#select-version").find("option:selected").attr("data-company-name");
        } else {
            $(".scenario-edit").removeClass("selected");
            $(this).addClass("selected");
            competition = $(this).attr("data-competition");
            startingCompany = $(this).attr("data-company-name");
        }
        // Show edit's competition
        let defaultCompetition = $(this).closest(".scenario").find(".competitors").find("#default-competition");
        let startingCompanyElement = $(this).closest(".scenario").find(".starting-company").find("#select-starting-company");
        let customStartingCompany = $(this).closest(".scenario").find(".custom-starting-company-option").find('input[type="radio"]:checked').val();
        if (competition) {
            // Check standard competition
            defaultCompetition.siblings("input").prop("checked", true);
            defaultCompetition.parent().removeClass("display-none");
            // Change starting company options
            let competitors = JSON.parse(competition);
            let options = "";
            options += '<option selected data-default="true" value="">' + (0, $1JSre.escapeHTML)(startingCompany) + "</option>";
            competitors.forEach(function(competitor, i) {
                options += '<option value="' + competitor.replace(/"/g, "&quot;") + '">' + (0, $1JSre.escapeHTML)(competitor) + "</option>";
            });
            startingCompanyElement.html(options);
        } else {
            // Check generate option
            defaultCompetition.parent().next().find("input").prop("checked", true);
            defaultCompetition.parent().addClass("display-none");
            // Change starting company options
            let options = "";
            options += '<option selected data-default="true" value="">' + (0, $1JSre.escapeHTML)(startingCompany) + "</option>";
            startingCompanyElement.html(options);
        }
        // Update select competitors if present
        let selectCompetitorsDiv = $(this).closest(".scenario").find(".select-competitors");
        let playerModeOption = $(this).closest(".scenario").find('.player-mode-option input[type="radio"]:checked').val();
        if (selectCompetitorsDiv.length > 0) {
            // Get all companies except selected starting company
            let allCompetitors = [];
            startingCompanyElement.find("option").each(function(i, option) {
                if (customStartingCompany === "yes" || $(option).prop("selected") === false) allCompetitors.push($(option).text());
            });
            // Add checkboxes for all competitors
            let competitorCheckboxes = "";
            allCompetitors.forEach(function(competitor, i) {
                let checked = i >= (0, $3E8Nt.gameLimits).maxCompetitors ? "" : ' checked="checked"';
                competitorCheckboxes += '<label class="control control--checkbox display-block"><span class="select-competitor-name">' + (0, $1JSre.escapeHTML)(competitor) + "</span>" + '<input type="checkbox" class="select-competitor-checkbox" value="' + competitor.replace(/"/g, "&quot;") + '"' + checked + ">" + '    <div class="control__indicator"></div>' + "</label>";
            });
            selectCompetitorsDiv.find(".select-competitors-checkboxes").html(competitorCheckboxes);
            // Show if competitors present in this edit and local multiplayer not selected
            if (allCompetitors.length > 0 && playerModeOption !== "local-multiplayer") selectCompetitorsDiv.show();
            else selectCompetitorsDiv.hide();
        }
        // Update select companies if present
        let selectCompaniesDiv = $(this).closest(".scenario").find(".companies-list");
        if (selectCompaniesDiv.length > 0) {
            // Get all companies
            let allCompanies = [];
            startingCompanyElement.find("option").each(function(i, option) {
                allCompanies.push($(option).text());
            });
            // Add checkboxes for all competitors
            let companiesListHtml = "";
            let scenarioUid = $(this).closest(".scenario, .scenario-edit").attr("data-uid");
            allCompanies.forEach(function(competitor, i) {
                companiesListHtml += $8de2281fafd7b0c6$var$getCompaniesListItemHtml(competitor, i, scenarioUid);
            });
            selectCompaniesDiv.find(".company-list-item").remove();
            selectCompaniesDiv.append(companiesListHtml);
        }
    });
    // Rate scenario buttons
    $("#new-game-menu").on("click", ".rate-up, .rate-down", function(e) {
        e.stopPropagation();
        if ((0, $98xmD.globals).requestRunning) return false;
        let el = $(this);
        let uid = $(this).closest(".scenario, .scenario-edit").attr("data-uid");
        let rating = $(this).hasClass("rate-up") ? "up" : "down";
        let classToCheck = $(this).hasClass("rate-up") ? "positive" : "negative";
        let classToRemove = classToCheck === "positive" ? "negative" : "positive";
        let elementToRemoveClassFrom = classToCheck === "positive" ? $(el).next() : $(el).prev();
        (0, $1JSre.makeGetRequest)("/_rate_scenario", {
            uid: uid,
            rating: rating
        }, (data)=>{
            if (!data["error"]) {
                (0, $lCS03.playSoundEffect)("success");
                if ($(el).hasClass(classToCheck)) $(el).removeClass(classToCheck);
                else $(el).addClass(classToCheck);
                elementToRemoveClassFrom.removeClass(classToRemove);
            } else if (data["error"] === "not-signed-in") {
                (0, $lCS03.playSoundEffect)("error");
                notie.alert({
                    type: 4,
                    text: "You need to be logged in to rate scenarios",
                    stay: true
                });
            }
        });
    });
    // Delete scenario button
    $("#container").on("click", ".delete-scenario", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        let parent = $(this).parent(".scenario");
        let uid = parent.attr("data-uid");
        notie.confirm({
            text: "Are you sure you want to delete all versions of this scenario?",
            submitText: "Yes",
            cancelText: "No",
            submitCallback: function() {
                if ((0, $98xmD.globals).requestRunning) return false;
                (0, $1JSre.makeGetRequest)("/_delete_scenario", {
                    uid: uid
                }, (data)=>{
                    if (data) {
                        (0, $lCS03.playSoundEffect)("success");
                        notie.alert({
                            type: 4,
                            text: "Scenario deleted",
                            stay: true
                        });
                        parent.hide();
                    }
                });
            }
        });
    });
    // Delete scenario edit button
    $("#new-game-menu").on("click", ".delete-scenario-edit", function(e) {
        e.stopPropagation();
        if ((0, $98xmD.globals).requestRunning) return false;
        let parent = $(this).parent(".scenario-edit");
        let uid = parent.attr("data-uid");
        notie.confirm({
            text: "Are you sure you want to delete this scenario edit?",
            submitText: "Yes",
            cancelText: "No",
            submitCallback: function() {
                if ((0, $98xmD.globals).requestRunning) return false;
                (0, $1JSre.makeGetRequest)("/_delete_scenario_edit", {
                    uid: uid
                }, (data)=>{
                    if (!data["error"]) {
                        (0, $lCS03.playSoundEffect)("success");
                        notie.alert({
                            type: 4,
                            text: "Scenario edit deleted",
                            stay: true
                        });
                        parent.hide();
                    } else {
                        (0, $lCS03.playSoundEffect)("error");
                        if (data["error"] === "incorrect-user") notie.alert({
                            type: 3,
                            text: "You cannot delete this scenario edit because it doesn't belong to you"
                        });
                        else if (data["error"] === "not-logged-in") notie.alert({
                            type: 3,
                            text: "You need to be logged in to delete scenario edits"
                        });
                        else if (data["error"] === "already-deleted") notie.alert({
                            type: 3,
                            text: "This scenario edit has already been deleted"
                        });
                    }
                });
            }
        });
    });
    /*
    CUSTOM STARTING COMPANY
     */ // Add/remove starting company to competitors upon selecting custom starting company
    $("#new-game-menu").on("change", '.custom-starting-company-option input[type="radio"]', function() {
        let value = $(this).val();
        let parent = $(this).closest(".custom-starting-company-option");
        // Add starting company
        if (value === "yes") {
            let startingCompanyValue = parent.siblings(".starting-company").find("#select-starting-company option:selected").text();
            // Update select competitors if present
            let selectCompetitorsDiv = parent.siblings(".select-competitors");
            if (selectCompetitorsDiv.length > 0) {
                let checked = selectCompetitorsDiv.find(".select-competitor-checkbox:checked").length >= (0, $3E8Nt.gameLimits).maxCompetitors ? "" : ' checked="checked"';
                let startingCompanyCheckbox = '<label class="control control--checkbox display-block"><span class="select-competitor-name">' + (0, $1JSre.escapeHTML)(startingCompanyValue) + "</span>" + '<input type="checkbox" class="select-competitor-checkbox" value="' + startingCompanyValue.replace(/"/g, "&quot;") + '"' + checked + '">' + '    <div class="control__indicator"></div>' + "</label>";
                selectCompetitorsDiv.find(".select-competitors-checkboxes").prepend(startingCompanyCheckbox);
            }
        } else {
            let startingCompanyValue = parent.siblings(".starting-company").find("#select-starting-company option:selected").text();
            let startingCompanyOption = parent.siblings(".select-competitors").find(".select-competitors-checkboxes").find('input[value="' + startingCompanyValue.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1") + '"]');
            if (startingCompanyOption.length > 0) startingCompanyOption.parent().remove();
        }
    });
    // Add custom starting company championship input
    $(".custom-starting-company-container").on("click", ".add-custom-starting-company-championship-input-button", function() {
        // Get existing championships selects
        let parentBox = $(this).closest(".box");
        let championshipInputs = parentBox.find(".custom-starting-company-championship-name-input");
        // Check for maximum championships selects
        if (championshipInputs.length >= 10) {
            notie.alert({
                type: 3,
                text: "You cannot add more than 10 championships"
            });
            return false;
        }
        // Clone championship input, add remove button
        let championshipInput = '<div class="margin-bottom-8">' + championshipInputs.eq(0).parent().clone().prop("innerHTML") + '<button type="button" class="remove-custom-starting-company-championship-input-button button retro-button styled-select-button ' + 'font-bold top-1px margin-left-3"><i class="fa fa-minus"></i></button></div>';
        // Add championship input after last one
        championshipInputs.last().parent().after(championshipInput);
        // Reset graphic
        let addedInputParent = parentBox.find(".custom-starting-company-championship-name-input").last().parent();
        addedInputParent.find(".custom-starting-company-championship-remove-graphic-button").hide();
        addedInputParent.find(".custom-starting-company-championship-add-graphic-button").text("Add Graphic").addClass("dark-grey-button-background").removeClass("blue-button-background");
        addedInputParent.data("key", null);
    });
    // Remove custom starting company championship input
    $(".custom-starting-company-container").on("click", ".remove-custom-starting-company-championship-input-button", function() {
        $(this).parent().remove();
        $8de2281fafd7b0c6$var$processCustomCompanyOpenGraphicCreator();
    });
    // Add/edit championship graphic
    $(".custom-starting-company-container").on("click", ".custom-starting-company-championship-add-graphic-button", function() {
        let parent = $(this).parent();
        $8de2281fafd7b0c6$var$processCustomCompanyOpenGraphicCreator();
        // Select this button
        $(this).text("Edit Graphic").removeClass("dark-grey-button-background").addClass("blue-button-background");
        // Show remove graphic button
        $(this).siblings(".custom-starting-company-championship-remove-graphic-button").show();
        // Set graphic data
        let jsonData;
        let graphicData;
        if (parent.data("key")) jsonData = JSON.parse(parent.data("key"));
        if (jsonData) graphicData = [
            jsonData
        ];
        // Show graphic
        let graphicContainer = $(this).parent().siblings(".character-creator");
        let el = graphicContainer.find(".superstar-graphic");
        graphicContainer.show();
        (0, $c82cd471f4baff6b$export$7ba12038bb800503)(el, graphicData);
    });
    // Remove championship graphic
    $(".custom-starting-company-container").on("click", ".custom-starting-company-championship-remove-graphic-button", function() {
        let parent = $(this).parent();
        $(this).hide();
        $8de2281fafd7b0c6$var$processCustomCompanyOpenGraphicCreator();
        // Remove graphic data
        parent.data("key", null);
        parent.find(".custom-starting-company-championship-add-graphic-button").text("Add Graphic").addClass("dark-grey-button-background").removeClass("blue-button-background");
    });
    // Show size select info
    $(".custom-starting-company-container").on("change", ".custom-starting-company-size-select", function() {
        let value = $(this).val();
        let companyReputation;
        let rosterCapacity;
        switch(value){
            case "backyard":
                companyReputation = 1;
                rosterCapacity = 20;
                break;
            case "indie":
                companyReputation = 4;
                rosterCapacity = 45;
                break;
            case "national":
                companyReputation = 7;
                rosterCapacity = 95;
                break;
            case "global":
                companyReputation = 10;
                rosterCapacity = 180;
                break;
        }
        let companyInfoText = '<span class="margin-right-10 ">Company REP: {0}</span> Roster Capacity: {1}'.format(companyReputation, rosterCapacity);
        $(".custom-starting-company-size-info").html(companyInfoText);
    });
    // Show finances select info
    $(".custom-starting-company-container").on("change", ".custom-starting-company-finances-select", function() {
        let value = $(this).val();
        let points;
        switch(value){
            case "weak":
                points = 150;
                break;
            case "average":
                points = 500;
                break;
            case "strong":
                points = 2000;
                break;
            case "loaded":
                points = 10000;
                break;
        }
        let financesInfoText = '<span class="blue"><img alt="Points" src="static/www/static/cp_icon.png" ' + 'class="points-image-small margin-right-5"/>{0}</span>'.format(points.toLocaleString("en"));
        $(".custom-starting-company-finances-info").html(financesInfoText);
    });
    // Generate custom company button
    $(".custom-starting-company-container").on("click", ".custom-starting-company-generate-button", async function() {
        notie.confirm({
            text: "Are you sure you want to generate company data? Any existing data will be overwritten.",
            submitCallback: async function() {
                await (0, $1JSre.makeGameRequest)((0, $8bQDO.generateCustomStartingCompany), {}, $8de2281fafd7b0c6$var$showGenerateCustomStartingCompanyData, {}, false);
            }
        });
    });
    // Custom company back button
    $(".custom-starting-company-container").on("click", ".custom-starting-company-back-button", function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: function() {
                (0, $1JSre.hideMainMenuContent)($());
                $("#new-game-menu").fadeIn("slow");
                $("#scenario-filter-menu").fadeIn("slow");
            }
        });
    });
});
async function $8de2281fafd7b0c6$export$75acba7ae7da841() {
    (0, $1JSre.hideMainMenuContent)($());
    // Get top rated scenarios
    $8de2281fafd7b0c6$var$getScenarios("top_rated");
    // Reset ui
    $("#scenario-filter-menu").fadeIn("slow");
    $("#scenario-filter-menu .scenario-filter").each(function() {
        $(this).removeClass("selected");
        if ($(this).attr("data-value") === "top_rated") $(this).addClass("selected");
        $(".scenario-categories").hide();
        $(".scenario-categories-button").removeClass("selected");
        $(".scenario-search-container").hide();
        $(".scenario-search-button").removeClass("selected");
        $(".scenario-random-button").removeClass("selected");
        if (!(0, $98xmD.globalUser).loggedIn && [
            "my-scenarios",
            "favorite-scenarios"
        ].includes($(this).attr("data-value"))) $(this).hide();
        else $(this).show();
    });
    $(".scenario-search-input").val("");
    $('.scenario-search-options input[name="radio-scenario-search-period"]:checked').val("any");
    $(".search-starting-year").val("");
    $(".search-company-name").val("");
    $("#new-game-menu").fadeIn("slow");
}
function $8de2281fafd7b0c6$var$getScenarios(filterName) {
    (0, $lCS03.playSoundEffect)("success");
    // Reset ui
    $("#our-scenarios").html("");
    $("#scenarios-search-results").html("").hide();
    $("#user-scenarios").html("");
    $("#tutorial-scenario").html("");
    $("#featured-scenario").html("");
    // Get scenarios data
    (0, $1JSre.makeGetRequest)("/_get_scenarios", {
        filter_name: filterName
    }, $8de2281fafd7b0c6$var$showGetScenariosData);
}
function $8de2281fafd7b0c6$var$showGetScenariosData(data) {
    let userScenariosHtml = "";
    let storyScenariosHtml = "";
    let tutorialScenarioHtml = "";
    let featuredScenarioHtml = "";
    // Add html for each scenario
    data["scenarios"].forEach(function(scenario) {
        let scenarioHtml = $8de2281fafd7b0c6$var$getScenarioHtml(scenario);
        if (scenario["story_name"]) {
            if (scenario["story_name"] === "tutorial") tutorialScenarioHtml += scenarioHtml;
            else storyScenariosHtml += scenarioHtml;
        } else if (scenario["category"] === "featured") featuredScenarioHtml += scenarioHtml;
        else userScenariosHtml += scenarioHtml;
    });
    if (!data["scenarios"].length) userScenariosHtml += '<div class="scenario">No scenarios found.</div>';
    $("#our-scenarios").html(storyScenariosHtml).show();
    $("#user-scenarios").html(userScenariosHtml).show();
    $("#tutorial-scenario").html(tutorialScenarioHtml).show();
    $("#featured-scenario").html(featuredScenarioHtml).show();
}
function $8de2281fafd7b0c6$var$getScenarioHtml(scenario) {
    // Add competitors
    let competitors = "";
    let selectCompetitors = "";
    if (!scenario["story_name"]) {
        if (scenario["competitors"].length > 0) {
            let competitorsOptions = "";
            if (!scenario["story_name"]) competitorsOptions = '<label class="control control--radio margin-right-10">Generate<input type="radio" name="radio-' + scenario["uid"] + '" ' + 'value="generate" class="generate-competitors-radio"/><div class="control__indicator"></div></label>' + '<label class="control control--radio help-text" title="Removes news and year-end awards.">' + 'None<input type="radio" name="radio-' + scenario["uid"] + '" ' + 'value="none" class="none-competitors-radio"/><div class="control__indicator"></div></label>';
            competitors = '<div class="margin-bottom-15 competitors"><span class="grey display-block margin-bottom-2">Competitors</span> <label class="control control--radio margin-right-10"><span id="default-competition" data-value="' + scenario["competitors"].join(", ").replace(/"/g, "&quot;") + '">' + "Standard</span>" + '<input type="radio" name="radio-' + scenario["uid"] + '" value="standard" checked="checked" class="standard-competitors-radio"/><div class="control__indicator"></div></label>' + competitorsOptions + "</div>";
        } else competitors = '<div class="margin-bottom-15 competitors"><span class="grey display-block margin-bottom-2">Competitors</span> <label class="control control--radio margin-right-10 display-none"><span id="default-competition"></span><input type="radio" name="radio-' + scenario["uid"] + '" value="standard" checked="checked" class="standard-competitors-radio"/><div class="control__indicator"></div></label>' + '<label class="control control--radio margin-right-10">Generate<input type="radio" name="radio-' + scenario["uid"] + '" ' + 'checked="checked" value="generate" class="generate-competitors-radio"/><div class="control__indicator"></div></label>' + '<label class="control control--radio help-text" title="Removes news and year-end awards">' + 'None<input type="radio" name="radio-' + scenario["uid"] + '" ' + 'value="none" class="none-competitors-radio"/><div class="control__indicator"></div></label>' + "</div>";
    }
    // Select competitors checkboxes
    let competitorCheckboxes = "";
    scenario["competitors"].forEach(function(competitor, i) {
        let checked = i >= (0, $3E8Nt.gameLimits).maxCompetitors ? "" : ' checked="checked"';
        competitorCheckboxes += '<label class="control control--checkbox display-block"><span class="select-competitor-name">' + (0, $1JSre.escapeHTML)(competitor) + "</span>" + '<input type="checkbox" class="select-competitor-checkbox" value="' + competitor.replace(/"/g, "&quot;") + '"' + checked + ">" + '    <div class="control__indicator"></div>' + "</label>";
    });
    let selectCompetitorsClass = scenario["competitors"].length > 0 ? "" : " display-none";
    if (!scenario["story_name"]) {
        let moreCompetitorsInfo = "";
        if (scenario["competitors"].length > 10) moreCompetitorsInfo = '<div class="margin-bottom-5 line-height-1p4 font-0p825em grey-blue-dark"><i class="fa fa-info-circle margin-right-2"></i> Number of competitors will affect game load times.</div>';
        selectCompetitors = '<div class="margin-bottom-15 select-competitors' + selectCompetitorsClass + '">' + '<span class="grey display-block margin-bottom-2">Select Competitors</span> ' + moreCompetitorsInfo + '<div class="select-competitors-checkboxes">' + competitorCheckboxes + "</div>" + "</div>";
    }
    // Add versions
    let versions = "";
    let comments = "";
    if (scenario["versions"].length > 0 && !scenario["story_name"] && scenario["category"] !== "featured") {
        let options = "";
        let commentDivs = "";
        scenario["versions"].forEach(function(version, i) {
            let versionCompanyName = version["company_name"];
            if (versionCompanyName) versionCompanyName = versionCompanyName.replace(/"/g, "&quot;");
            options += '<option value="' + version["version_number"] + "\" data-competition='" + JSON.stringify(version["competition"]).replace(/'/g, "&#39;") + "' data-company-name=\"" + versionCompanyName + '">' + version["version_number"] + "</option>";
            // Hide all comments except those of latest version
            if (i !== 0) {
                if (version["comments"]) commentDivs += '<div data-version="' + version["version_number"] + '" class="display-none">' + (0, $1JSre.escapeHTML)(version["comments"]) + "</div>";
            } else commentDivs += '<div data-version="' + version["version_number"] + '">' + (0, $1JSre.escapeHTML)(version["comments"]) + "</div>";
        });
        comments = '<div class="version-comments medium-grey">' + commentDivs + "</div>";
        versions = '<div class="margin-bottom-15 versions"><span class="grey margin-right-5 display-block margin-bottom-3">Version</span> <select id="select-version" title="Select Version" class="styled-select margin-bottom-15">' + options + "</select>" + comments + "</div>";
    }
    // Create edit
    let createEditButton = "";
    if (!scenario["story_name"]) {
        if (scenario["allow_edits"]) {
            if ((0, $98xmD.globalUser).paid) createEditButton = '<button type="button" class="button retro-button condensed dark-grey-button-background margin-left-5 create-scenario-edit">Create Edit</button>';
            else createEditButton = '<button type="button" class="button retro-button condensed dark-grey-button-background margin-left-5 create-scenario-edit disabled help-text" title="Creating edits is only available in JoW Paid">Create Edit</button>';
        } else createEditButton = '<button type="button" class="button retro-button condensed dark-grey-button-background margin-left-5 create-scenario-edit disabled help-text" title="The creator has disabled creating edits for this scenario">Create Edit</button>';
    }
    // Edits
    let editsHtml = "";
    if (!scenario["story_name"]) editsHtml = '<div class="margin-bottom-15"><div class="margin-bottom-10"><button type="button" class="button retro-button condensed dark-grey-button-background scenario-edits-show-button">Show Edits</button>' + createEditButton + "</div>" + '<div class="scenario-edits-container display-none">' + "</div>" + "</div>";
    // Starting company
    let startingCompany = "";
    if (scenario["competitors"].length > 0 && !scenario["story_name"]) {
        let options = "";
        options += '<option selected data-default="true" value="">' + (0, $1JSre.escapeHTML)(scenario["company_name"]) + "</option>";
        scenario["competitors"].forEach(function(competitor) {
            options += '<option value="' + competitor.replace(/"/g, "&quot;") + '">' + (0, $1JSre.escapeHTML)(competitor) + "</option>";
        });
        startingCompany = '<div class="margin-bottom-15 starting-company"><span class="margin-right-5 display-block margin-bottom-3 grey">Starting Company</span> <select id="select-starting-company" title="Select Starting Company" class="styled-select" data-value="' + scenario["company_name"].replace(/"/g, "&quot;") + '">' + options + "</select>" + "</div>";
    }
    // Player Mode
    let playerMode = "";
    if (scenario["competitors"].length > 0 && !scenario["story_name"]) {
        let playerModeDisabled = "";
        let playerModeHelpText = "Local Multiplayer allows you to book multiple companies in your game.";
        if (!(0, $98xmD.globalUser).paid) {
            playerModeDisabled = " disabled";
            playerModeHelpText += " (JoW Paid)";
        }
        playerMode = '<div class="margin-bottom-15 player-mode-option"><span class="grey display-block margin-bottom-3">Player Mode</span> <label class="control control--radio margin-right-10">Singleplayer<input type="radio" name="radio-player-mode-option-' + scenario["uid"] + '" ' + 'checked="checked" value="singleplayer"/><div class="control__indicator"></div></label>' + '<label class="control control--radio help-text' + playerModeDisabled + '" title="' + playerModeHelpText + '">' + 'Local Multiplayer<input type="radio" name="radio-player-mode-option-' + scenario["uid"] + '" ' + 'value="local-multiplayer"' + playerModeDisabled + '/><div class="control__indicator"></div></label>' + "</div>";
    }
    // Custom starting company
    let customStartingCompany = "";
    if (!scenario["story_name"]) {
        let customStartingCompanyDisabled = "";
        let customStartingCompanyHelpText = "Custom Starting Company allows you to start the game controlling a custom company that you create.";
        if (!(0, $98xmD.globalUser).paid) {
            customStartingCompanyDisabled = " disabled";
            customStartingCompanyHelpText += " (JoW Paid)";
        }
        customStartingCompany = '<div class="margin-bottom-15 custom-starting-company-option"><span class="grey display-block margin-bottom-3">Custom Starting Company</span> <label class="control control--radio margin-right-10 help-text' + customStartingCompanyDisabled + '" title="' + customStartingCompanyHelpText + '">Yes<input type="radio" name="radio-custom-starting-company-option-' + scenario["uid"] + '" ' + 'value="yes"' + customStartingCompanyDisabled + '/><div class="control__indicator"></div></label>' + '<label class="control control--radio">' + 'No<input type="radio" name="radio-custom-starting-company-option-' + scenario["uid"] + '" ' + 'value="no" checked="checked"/><div class="control__indicator"></div></label>' + "</div>";
    }
    // Companies List
    let companiesList = "";
    if ((0, $98xmD.globalUser).paid && scenario["competitors"].length > 0 && !scenario["story_name"]) {
        let companiesListHtml = '<span class="grey display-block margin-bottom-3">Companies</span> <div class="margin-top-8 company-list-item"><span class="medium-dark-grey margin-bottom-2 display-block company-list-item-name">' + (0, $1JSre.escapeHTML)(scenario["company_name"]) + "</span>" + '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' + scenario["uid"] + "-" + scenario["company_name"] + '" ' + 'checked="checked" value="user"/><div class="control__indicator"></div></label>' + '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' + scenario["uid"] + "-" + scenario["company_name"] + '" ' + 'value="CPU"/><div class="control__indicator"></div></label>' + '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' + scenario["uid"] + "-" + scenario["company_name"] + '" ' + 'value="none"/><div class="control__indicator"></div></label>' + '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input">' + "</div>";
        scenario["competitors"].forEach(function(competitor, i) {
            if (i < (0, $3E8Nt.gameLimits).maxCompetitors) companiesListHtml += '<div class="margin-top-8 company-list-item"><span class="medium-dark-grey margin-bottom-2 display-block company-list-item-name">' + (0, $1JSre.escapeHTML)(competitor) + "</span>" + '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' + scenario["uid"] + "-" + (0, $1JSre.escapeHTML)(competitor) + '" ' + 'value="user"/><div class="control__indicator"></div></label>' + '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' + scenario["uid"] + "-" + (0, $1JSre.escapeHTML)(competitor) + '" ' + 'checked="checked" value="CPU"/><div class="control__indicator"></div></label>' + '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' + scenario["uid"] + "-" + (0, $1JSre.escapeHTML)(competitor) + '" ' + 'value="none"/><div class="control__indicator"></div></label>' + '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input display-none">' + "</div>";
            else companiesListHtml += '<div class="margin-top-8 company-list-item"><span class="medium-dark-grey margin-bottom-2 display-block company-list-item-name">' + (0, $1JSre.escapeHTML)(competitor) + "</span>" + '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' + scenario["uid"] + "-" + (0, $1JSre.escapeHTML)(competitor) + '" ' + 'value="user"/><div class="control__indicator"></div></label>' + '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' + scenario["uid"] + "-" + (0, $1JSre.escapeHTML)(competitor) + '" ' + 'value="CPU"/><div class="control__indicator"></div></label>' + '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' + scenario["uid"] + "-" + (0, $1JSre.escapeHTML)(competitor) + '" ' + 'checked="checked" value="none"/><div class="control__indicator"></div></label>' + '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input display-none">' + "</div>";
        });
        companiesList = '<div class="margin-bottom-15 companies-list display-none">' + companiesListHtml + "</div>";
    }
    // Scenario rating
    let ratingSpan = "";
    if (scenario["story_name"] !== "tutorial") {
        if (scenario["rating"] === null) ratingSpan = '<span class="rating no-rating">No ratings yet</span>';
        else if (scenario["rating"] >= 50) ratingSpan = '<span class="rating positive">' + scenario["rating"] + "%</span>";
        else ratingSpan = '<span class="rating negative">' + scenario["rating"] + "%</span>";
    }
    // Weekly shows option
    let weeklyShowsOption = "";
    if (!scenario["story_name"]) weeklyShowsOption = '<div class="margin-bottom-15 run-weekly-shows"><span class="grey display-block margin-bottom-3">Run Weekly Shows</span> <label class="control control--radio margin-right-10">Yes<input type="radio" name="radio-run-weekly-shows' + scenario["uid"] + '" ' + 'checked="checked" value="yes"/><div class="control__indicator"></div></label>' + '<label class="control control--radio">No<input type="radio" name="radio-run-weekly-shows' + scenario["uid"] + '" ' + 'value="no"/><div class="control__indicator"></div></label>' + "</div>";
    // Draft option
    let draftOption = "";
    if (!scenario["story_name"] && scenario["competitors"].length > 0) draftOption = '<div class="margin-bottom-15 main-rosters-option"><span class="grey display-block margin-bottom-3">Main Rosters</span> <label class="control control--radio margin-right-10">Default<input type="radio" name="radio-main-rosters-option' + scenario["uid"] + '" ' + 'checked="checked" value="default"/><div class="control__indicator"></div></label>' + '<label class="control control--radio help-text" ' + 'title="All companies draft new rosters from all Superstars">Draft<input type="radio" name="radio-main-rosters-option' + scenario["uid"] + '" ' + 'value="draft"/><div class="control__indicator"></div></label>' + '<div class="margin-top-15 draft-options display-none">' + '<span class="grey display-block margin-bottom-3">Draft Options</span> ' + '<label class="control control--checkbox display-block">' + '<span class="select-draft-options help-text" title="Also includes talent from unselected competitors">Include Indie Roster</span>' + '<input type="checkbox" class="select-draft-options-checkbox" value="include_indie_roster" checked>' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-draft-options help-text" title="Also includes training talent from unselected competitors">Include Training Rosters</span>' + '<input type="checkbox" class="select-draft-options-checkbox" value="include_training_rosters" checked>' + '<div class="control__indicator"></div>' + "</label>" + "</div>" + "</div>";
    // Game Mode option
    let gameModeOption = "";
    if (!scenario["story_name"]) {
        let sandboxModeDisabled = "";
        let sandboxHelpText = "Sandbox Mode removes most of the game's restrictions, allowing you to book freely.";
        if (!(0, $98xmD.globalUser).paid) {
            sandboxModeDisabled = " disabled";
            sandboxHelpText += " (JoW Paid)";
        }
        gameModeOption = '<div class="margin-bottom-15 game-mode-option"><span class="grey display-block margin-bottom-3">Game Mode</span> <label class="control control--radio margin-right-10">Normal<input type="radio" name="radio-game-mode-option' + scenario["uid"] + '" ' + 'checked="checked" value="normal"/><div class="control__indicator"></div></label>' + '<label class="control control--radio help-text' + sandboxModeDisabled + '" ' + 'title="' + sandboxHelpText + '">Sandbox<input type="radio" name="radio-game-mode-option' + scenario["uid"] + '" ' + 'value="sandbox"' + sandboxModeDisabled + '/><div class="control__indicator"></div></label>' + '<div class="margin-top-15 sandbox-mode-options display-none">' + '<span class="grey display-block margin-bottom-3">Sandbox Options</span> ' + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">Unlimited Creative Points</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="unlimited_creative_points" checked>' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">Highest Roster Capacity</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="maximum_roster_capacity" checked>' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">All Indies Available</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="all_indies_available" checked>' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">Unlock All Items</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="unlock_all_items" checked>' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">Maximum Staff & Facilities</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="maximum_staff_and_facilities" checked>' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">No Special Items Cooldown</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_special_items_cooldown" checked>' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">No Injuries</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_injuries" checked>' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">No Unhappiness</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_unhappiness" checked>' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">No Talent Requests</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_talent_requests">' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">No Random Events</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_random_events">' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">No Retirements</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_retirements">' + '<div class="control__indicator"></div>' + "</label>" + '<label class="control control--checkbox display-block">' + '<span class="select-sandbox-options">No Going Part-Time</span>' + '<input type="checkbox" class="select-sandbox-options-checkbox" value="no_going_part_time">' + '<div class="control__indicator"></div>' + "</label>" + "</div>" + "</div>";
    }
    // Check if user has rated scenario
    let rating = "";
    if (scenario["story_name"] !== "tutorial") {
        if (scenario["rated_up"]) rating = '<i class="fa fa-thumbs-o-up icon-button margin-left-10 rate-up font-bold positive"></i><i class="fa fa-thumbs-o-down icon-button margin-left-8 rate-down"></i>';
        else if (scenario["rated_down"]) rating = '<i class="fa fa-thumbs-o-up icon-button margin-left-10 rate-up"></i><i class="fa fa-thumbs-o-down icon-button margin-left-8 rate-down font-bold negative"></i>';
        else rating = '<i class="fa fa-thumbs-o-up icon-button margin-left-10 rate-up"></i><i class="fa fa-thumbs-o-down icon-button margin-left-8 rate-down"></i>';
    }
    // Scenario plays
    let plays = "";
    if (scenario["story_name"] !== "tutorial") {
        let playsSuffix = " plays";
        if (scenario["count"] === 1) playsSuffix = " play";
        plays = '<span class="margin-left-10 light-grey">' + scenario["count"].toLocaleString("en") + playsSuffix + "</span>";
    }
    // Add update button
    let update = "";
    if (scenario["edit"]) update = '<button type="button" class="button retro-button display-inline-block margin-top-5 margin-right-5 dark-grey-button-background edit-scenario">Update</button>';
    // Add duplicate button
    let duplicateButtonHtml = "";
    if (scenario["edit"]) duplicateButtonHtml = '<button type="button" class="button retro-button display-inline-block margin-top-5 margin-right-5 dark-grey-button-background duplicate-scenario-button">Duplicate</button>';
    // Add show info button
    let showInfoButton = '<button type="button" class="button retro-button display-inline-block show-scenario-information grey-button-background margin-top-7">More Info</button>';
    // Add delete button
    let deleteButton = "";
    if (scenario["delete"]) deleteButton = '<button type="button" class="button retro-button display-inline-block margin-top-5 margin-right-5 red-button-background delete-scenario">Delete</button>';
    // Add play button
    let play = '<button type="button" class="button retro-button display-inline-block play-scenario margin-right-5">Play</button>';
    // Add border for stories
    let scenarioClass = "";
    let scenarioStats = "";
    if (scenario["story_name"] === "mars") scenarioClass = " mars";
    else if (scenario["story_name"] === "passion") scenarioClass = " passion";
    else if (scenario["story_name"] === "tutorial") scenarioClass = " tutorial";
    else if (scenario["category"] === "featured") scenarioClass = " featured";
    if (!scenario["story_name"] && scenario["category"] !== "featured") {
        let scenarioCreator = '<span class="grey">' + (0, $1JSre.escapeHTML)(scenario["creator"]) + "</span>";
        if (!scenarioCreator) scenarioCreator = "unknown";
        scenarioStats = "Created by " + scenarioCreator;
    }
    // Datetime created/last updated
    let lastUpdatedHtml = "";
    let datetimeUpdated = "";
    if (scenario["datetime_updated_string"] && !scenario["story_name"] && scenario["category"] !== "featured") {
        lastUpdatedHtml = '<span class="display-block margin-top-2">Last updated on <span class="grey">' + scenario["datetime_updated_string"] + "</span></span>";
        datetimeUpdated = scenario["datetime_updated_string"];
    }
    if (scenario["datetime_created_string"] && !scenario["story_name"] && scenario["category"] !== "featured") scenarioStats += ' on <span class="grey">' + scenario["datetime_created_string"] + "</span>";
    // Sorting attributes
    let confidence = "";
    if (scenario["confidence"]) confidence = scenario["confidence"];
    // Check if private scenario
    let privateHtml = "";
    if (scenario["private"]) privateHtml = '<div class="brown-red margin-top-2">Private</div>';
    // Add starting event
    let startEventHtml = "";
    let startingMonthName = "";
    if (scenario["starting_month"] !== undefined) startingMonthName = (0, $1JSre.monthNames)[scenario["starting_month"]];
    if (scenario["starting_event"] && !scenario["story_name"]) startEventHtml = '<span class="display-block">Starts at <span class="grey">{0}, {1} {2}</span></span>'.format((0, $1JSre.escapeHTML)(scenario["starting_event"]), startingMonthName, scenario["starting_year"]);
    let html = "";
    // If story and user not paid, don't show play button, add help text
    if (scenario["story_name"] && scenario["story_name"] !== "tutorial" && !(0, $98xmD.globalUser).paid || scenario["story_name"] === "passion" && (0, $98xmD.globalUser).freeTrialActivated) {
        let scenarioHelpText;
        if (scenario["story_name"] === "passion" && (0, $98xmD.globalUser).freeTrialActivated) scenarioHelpText = "This story is not available in the Free Trial.";
        else scenarioHelpText = "This story is only available in JoW Paid.";
        html = '<div class="scenario' + scenarioClass + ' disabled help-text" data-myscenario="' + scenario["my_scenario"] + '" data-uid="' + scenario["uid"] + '" title="' + scenarioHelpText + '">' + '<span class="display-block margin-bottom-6 font-22px font-mukta-mahee line-height-1p4">' + (0, $1JSre.escapeHTML)(scenario["name"]) + "</span>" + '<span class="display-block margin-bottom-15">' + ratingSpan + plays + "</span>" + '<span class="display-block margin-bottom-15 description medium-grey">' + (0, $1JSre.escapeHTML)(scenario["description"]) + "</span>" + "</div>";
    } else {
        let featuredUrl = scenario["category"] === "featured" ? '<span> Share your DPW Forever card to <a href="https://twitter.com/JowMahin/status/1760239605746368606" target="_blank">win</a> a DPW on demand subscription or a JoW t-shirt / JoW Paid!</span>' : "";
        html = '<div class="scenario' + scenarioClass + '" data-myscenario="' + scenario["my_scenario"] + '" data-uid="' + scenario["uid"] + '" data-plays="' + scenario["count"] + '" data-rating="' + confidence + '" data-updated="' + datetimeUpdated + '">' + '<span class="display-block margin-bottom-6 font-22px font-mukta-mahee line-height-1p4">' + (0, $1JSre.escapeHTML)(scenario["name"]) + "</span>" + '<span class="display-block margin-bottom-15">' + ratingSpan + rating + plays + "</span>" + '<span class="display-block margin-bottom-15 description medium-grey">' + (0, $1JSre.escapeHTML)(scenario["description"]) + featuredUrl + '<div class="medium-light-grey font-0p925em line-height-1p4 margin-top-15">' + startEventHtml + '<span class="display-block creator margin-top-2">' + scenarioStats + "</span>" + lastUpdatedHtml + privateHtml + "</div>" + "</span>" + versions + editsHtml + playerMode + companiesList + startingCompany + customStartingCompany + competitors + selectCompetitors + weeklyShowsOption + draftOption + gameModeOption + play + update + duplicateButtonHtml + deleteButton + showInfoButton + "</div>";
    }
    return html;
}
async function $8de2281fafd7b0c6$export$c0eac80bdcb2da7f(el) {
    (0, $lCS03.playSoundEffect)("success");
    // Get uid of scenario or edit, if selected
    let uid = el.parent(".scenario").attr("data-uid");
    let scenarioEdit = el.parent(".scenario").find(".scenario-edit.selected");
    if (scenarioEdit.length > 0) uid = scenarioEdit.attr("data-uid");
    let version = el.siblings(".versions").find("#select-version").val();
    let gameSettings = $8de2281fafd7b0c6$var$getNewGameSettings(el);
    if (!gameSettings) return false;
    if (el.parent().hasClass("mars")) {
        notie.alert({
            type: 3,
            text: "This story is not available yet and will be added soon."
        });
        return false;
    }
    // Load custom starting company page if selected
    if (el.siblings(".custom-starting-company-option").find('input[type="radio"]:checked').val() === "yes") {
        // Reset inputs
        let parent = $(".custom-starting-company-container");
        parent.find('input:not([type="checkbox"])').val("");
        parent.find(".custom-starting-company-size-select").val("indie");
        parent.find(".custom-starting-company-finances-select").val("average");
        parent.find(".custom-starting-company-talent-select").val("generate");
        parent.find(".custom-starting-company-training-roster-select").val("generate");
        parent.find(".custom-starting-company-event-prestige-select").val("C");
        parent.find(".custom-starting-company-championship-division-select").val("singles");
        parent.find(".custom-starting-company-championship-prestige-select").val("C");
        parent.find(".custom-starting-company-style-select").val("entertainment");
        parent.find('input[value="include_company_rosters"]').prop("checked", true);
        parent.find('input[value="include_indie_roster"]').prop("checked", true);
        parent.find('input[value="protect_company_talent"]').prop("checked", false);
        // Trigger inputs/selects
        $(".custom-starting-company-size-select").trigger("change");
        $(".custom-starting-company-finances-select").trigger("change");
        $(".custom-starting-company-talent-select").trigger("change");
        // Remove extra championship inputs, reset first
        let championshipInputs = parent.find(".custom-starting-company-championship-name-input");
        championshipInputs.slice(1).parent().remove();
        parent.find(".custom-starting-company-championship-remove-graphic-button").hide();
        parent.find(".custom-starting-company-championship-add-graphic-button").text("Add Graphic").addClass("dark-grey-button-background").removeClass("blue-button-background");
        parent.find(".custom-starting-company-championship-name-input").parent().data("key", null);
        // Hide graphic creator
        parent.find(".character-creator").hide();
        parent.find(".character-creator").find(".superstar-graphic").html("");
        // Show custom starting company page
        notie.hideAlerts();
        (0, $1JSre.hideMainMenuContent)($());
        $(".custom-starting-company-container").fadeIn("slow");
        // Play custom company button
        $(".custom-starting-company-container").off("click", "#custom-starting-company-play-button");
        $(".custom-starting-company-container").on("click", "#custom-starting-company-play-button", async function() {
            // Get input values
            let parent = $(".custom-starting-company-container");
            let companyName = parent.find(".custom-starting-company-name-input").val();
            let companySize = parent.find(".custom-starting-company-size-select").val();
            let companyFinances = parent.find(".custom-starting-company-finances-select").val();
            let talentOption = parent.find(".custom-starting-company-talent-select").val();
            let trainingRosterOption = parent.find(".custom-starting-company-training-roster-select").val();
            let weeklyShowName = parent.find(".custom-starting-company-weekly-show-name-input").val();
            let ownerName = parent.find(".custom-starting-company-owner-name-input").val();
            let companyStyle = parent.find(".custom-starting-company-style-select").val();
            let draftIncludeCompanyRosters = parent.find(".custom-starting-company-draft-options").find('input[value="include_company_rosters"]').prop("checked");
            let draftIncludeIndies = parent.find(".custom-starting-company-draft-options").find('input[value="include_indie_roster"]').prop("checked");
            let draftProtectCompanyTalent = parent.find(".custom-starting-company-draft-options").find('input[value="protect_company_talent"]').prop("checked");
            // Get event and championship names and prestiges
            let companyMonthlyEventsData = [];
            parent.find(".custom-starting-company-event-name-input").each(function(i, e) {
                let eventName = $(e).val();
                let eventPrestige = $(e).next(".custom-starting-company-event-prestige-select").val();
                let companyMonthlyEventData = {
                    "name": eventName,
                    "prestige": eventPrestige
                };
                companyMonthlyEventsData.push(companyMonthlyEventData);
            });
            $8de2281fafd7b0c6$var$processCustomCompanyOpenGraphicCreator(false);
            let companyChampionshipsData = [];
            parent.find(".custom-starting-company-championship-name-input").each(function(i, e) {
                let championshipName = $(e).val();
                if (championshipName) {
                    let championshipDivision = $(e).siblings(".custom-starting-company-championship-division-select").val();
                    let championshipPrestige = $(e).siblings(".custom-starting-company-championship-prestige-select").val();
                    let championshipGraphicData = $(e).parent().data("key");
                    let companyChampionshipData = {
                        "name": championshipName,
                        "division": championshipDivision,
                        "prestige": championshipPrestige,
                        "graphic": championshipGraphicData
                    };
                    companyChampionshipsData.push(companyChampionshipData);
                }
            });
            // Validate inputs
            if (companyName.length <= 0) {
                notie.alert({
                    type: 3,
                    text: "Please enter the Company's name"
                });
                return false;
            }
            if (talentOption === "draft") {
                if (!draftIncludeCompanyRosters && !draftIncludeIndies) {
                    notie.alert({
                        type: 3,
                        text: "You need to include either company or indie talent in the draft"
                    });
                    return false;
                }
            }
            let emptyMonthlyEventName = false;
            companyMonthlyEventsData.forEach(function(monthlyEventData) {
                if (!monthlyEventData["name"]) emptyMonthlyEventName = true;
            });
            if (emptyMonthlyEventName) {
                notie.alert({
                    type: 3,
                    text: "Please enter all Monthly Event names"
                });
                return false;
            }
            // Get custom starting company data
            let draftSettings = {
                "includeCompanyRosters": draftIncludeCompanyRosters,
                "includeIndies": draftIncludeIndies,
                "protectCompanyTalent": draftProtectCompanyTalent
            };
            gameSettings["customStartingCompanyData"] = {
                "companyName": companyName,
                "companySize": companySize,
                "companyFinances": companyFinances,
                "talentOption": talentOption,
                "trainingRosterOption": trainingRosterOption,
                "weeklyShowName": weeklyShowName,
                "ownerName": ownerName,
                "companyMonthlyEventsData": companyMonthlyEventsData,
                "companyChampionshipsData": companyChampionshipsData,
                "companyStyle": companyStyle,
                "draftSettings": draftSettings
            };
            await $8de2281fafd7b0c6$var$makePlayScenarioRequest(uid, version, gameSettings);
        });
        // Show draft options
        $(".custom-starting-company-container").off("change", ".custom-starting-company-talent-select");
        $(".custom-starting-company-container").on("change", ".custom-starting-company-talent-select", function() {
            let value = $(this).val();
            if (value === "draft") {
                $(".custom-starting-company-draft-options").show();
                if (el.siblings(".main-rosters-option").find('input[type="radio"]:checked').val() === "draft") {
                    $(".custom-starting-company-draft-info-content").text("Talent Draft settings are not used when Main Rosters Draft is also selected. Instead of a single company draft, all companies take part in the draft.");
                    $(".custom-starting-company-draft-options input").attr("disabled", true);
                } else {
                    $(".custom-starting-company-draft-info-content").text("A single company draft will run with the following settings:");
                    $(".custom-starting-company-draft-options input").attr("disabled", false);
                }
            } else $(".custom-starting-company-draft-options").hide();
        });
        return false;
    }
    await $8de2281fafd7b0c6$var$makePlayScenarioRequest(uid, version, gameSettings);
}
async function $8de2281fafd7b0c6$var$makePlayScenarioRequest(uid, version, gameSettings) {
    if ((0, $98xmD.globals).requestRunning) return false;
    let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
    if (!(0, $98xmD.globalUser).paid && userGames.length > 0) {
        notie.alert({
            type: 3,
            text: "Free users are limited to one save. Please delete your current save to create a new one.",
            stay: true
        });
        return false;
    }
    const user = (0, $bZol7.loadUser)();
    const loadFavoriteCommunitySegments = user.settings["loadFavoriteCommunitySegments"];
    (0, $1JSre.makeGetRequest)("/_get_scenario_export_data", {
        uid: uid,
        version: version,
        loadFavoriteCommunitySegments: loadFavoriteCommunitySegments
    }, async (data)=>{
        await $8de2281fafd7b0c6$var$checkGetScenarioExportDataJob(data["statusUrl"], gameSettings, uid);
    }, true);
}
async function $8de2281fafd7b0c6$var$checkGetScenarioExportDataJob(statusUrl, gameSettings, uid) {
    (0, $1JSre.makeGetRequest)(statusUrl, {}, async (data)=>{
        switch(data.status){
            case "unknown":
            case "failed":
                notie.hideAlerts();
                (0, $98xmD.globals).requestRunning = false;
                notie.alert({
                    type: 3,
                    text: "There was an error. Please try again"
                });
                break;
            case "finished":
                notie.hideAlerts();
                (0, $98xmD.globals).requestRunning = false;
                // Don't load if html tags found
                const regex = /(<[^>]*>)|(&lt;)|(\/script)|(src=)|(&#)|(onfocus=)/i;
                const regexResult = JSON.stringify(data["result"]).match(regex);
                if (regexResult) {
                    notie.alert({
                        type: 3,
                        text: "HTML tags were found within the scenario. For security purposes, the scenario wasn't loaded."
                    });
                    return false;
                }
                await (0, $1JSre.makeGameRequest)((0, $iRMwH.createGameFromScenarioData), {
                    scenarioData: data["result"],
                    gameSettings: gameSettings
                }, $8de2281fafd7b0c6$var$showCreateNewGameFromScenarioDataData, {
                    uid: uid
                }, false, true);
                break;
            default:
                setTimeout(async function() {
                    await $8de2281fafd7b0c6$var$checkGetScenarioExportDataJob(statusUrl, gameSettings, uid);
                }, 1000);
        }
    }, true, null, false);
}
function $8de2281fafd7b0c6$var$getNewGameSettings(el) {
    let gameSettings = {};
    gameSettings["competitorsOption"] = el.siblings(".competitors").find('input[type="radio"]:checked').val();
    gameSettings["startingCompanyName"] = el.siblings(".starting-company").find("#select-starting-company").val();
    gameSettings["numberOfWeeklyShows"] = el.siblings(".run-weekly-shows").find('input[type="radio"]:checked').val() === "no" ? 0 : 2;
    gameSettings["mainRostersOption"] = el.siblings(".main-rosters-option").find('input[type="radio"]:checked').val();
    gameSettings["gameModeOption"] = el.siblings(".game-mode-option").find('input[type="radio"]:checked').val();
    gameSettings["draftIncludeIndies"] = el.siblings(".main-rosters-option").find('.draft-options input[value="include_indie_roster"]').prop("checked");
    gameSettings["draftIncludeTraining"] = el.siblings(".main-rosters-option").find('.draft-options input[value="include_training_rosters"]').prop("checked");
    // Get selected competitors
    let selectedCompetitorsDiv = el.siblings(".select-competitors");
    if (selectedCompetitorsDiv.length > 0 && selectedCompetitorsDiv.is(":visible")) {
        let selectedCompetitors = [];
        selectedCompetitorsDiv.find("input").each(function(i, selectedCompetitorInput) {
            if ($(selectedCompetitorInput).is(":checked")) selectedCompetitors.push($(selectedCompetitorInput).val());
        });
        gameSettings["selectedCompetitorsNames"] = selectedCompetitors;
    }
    // Get sandbox mode options
    let sandboxModeOptionsDiv = el.siblings(".game-mode-option").find(".sandbox-mode-options");
    if (sandboxModeOptionsDiv.length > 0 && sandboxModeOptionsDiv.is(":visible")) {
        let sandboxModeOptions = [];
        sandboxModeOptionsDiv.find("input").each(function(i, sandboxModeOptionInput) {
            if ($(sandboxModeOptionInput).is(":checked")) sandboxModeOptions.push($(sandboxModeOptionInput).val());
        });
        if (!sandboxModeOptions.length) {
            notie.alert({
                type: 3,
                text: "You need to select at least 1 of the options for Sandbox Mode"
            });
            return false;
        }
        gameSettings["sandboxModeOptions"] = sandboxModeOptions;
    }
    // Get local multiplayer mode options
    gameSettings["playerModeOption"] = el.siblings(".player-mode-option").find('input[type="radio"]:checked').val();
    if (gameSettings["playerModeOption"] === "local-multiplayer") {
        let companiesListElement = el.siblings(".companies-list");
        let selectedUserCompaniesArray = [];
        let selectedCPUCompaniesArray = [];
        let playerNamesArray = [];
        // Add user and CPU companies
        companiesListElement.find('input[type="radio"]:checked').each(function(i, selectedCompanyInput) {
            let selectedCompanyInputValue = $(selectedCompanyInput).val();
            if (selectedCompanyInputValue === "user") {
                selectedUserCompaniesArray.push($(selectedCompanyInput).closest(".company-list-item").find(".company-list-item-name").text());
                // Add player names for user companies
                let selectedCompanyInputPlayerName = $(selectedCompanyInput).closest(".company-list-item").find(".player-name-input").val();
                playerNamesArray.push(selectedCompanyInputPlayerName);
            } else if (selectedCompanyInputValue === "CPU") selectedCPUCompaniesArray.push($(selectedCompanyInput).closest(".company-list-item").find(".company-list-item-name").text());
        });
        // Check if at least 2 user companies have been selected
        if (selectedUserCompaniesArray.length < 2) {
            notie.alert({
                type: 3,
                text: "You need to select at least 2 user controlled companies for local multiplayer"
            });
            return false;
        }
        gameSettings["selectedUserCompanies"] = selectedUserCompaniesArray;
        gameSettings["selectedCPUCompanies"] = selectedCPUCompaniesArray;
        gameSettings["playerNames"] = playerNamesArray;
        // Set other options
        gameSettings["competitorsOption"] = "standard";
    }
    return gameSettings;
}
async function $8de2281fafd7b0c6$var$showCreateNewGameFromScenarioDataData({ data: data, uid: uid } = {}) {
    if (!data["error"]) {
        // Save times played for scenario if online
        if (window.navigator.onLine) $.ajax({
            url: (0, $98xmD.globals).baseUrl + "/_add_scenario_times_played",
            dataType: "json",
            data: {
                uid: uid
            },
            success: ()=>{}
        });
        // Go to created game
        await (0, $993642189aedf295$export$2dd56c65048c4a4b)(data["createdGame"], data["storyName"]);
    } else {
        if (data["error"] === "story-mode-paid") notie.alert({
            type: 3,
            text: "This story is only available in JoW Paid"
        });
        else if (data["error"] === "pow-free-trial") notie.alert({
            type: 3,
            text: "Passion of Wrestling is not available in the Free Trial"
        });
        else if (data["error"] === "sandbox-mode-paid") notie.alert({
            type: 3,
            text: "Sandbox Mode is only available in JoW Paid"
        });
        else if (data["error"] === "local-multiplayer-mode-paid") notie.alert({
            type: 3,
            text: "Local Multiplayer is only available in JoW Paid"
        });
        else if (data["error"] === "private-scenario") notie.alert({
            type: 3,
            text: "This scenario has been set as private by the creator"
        });
        else if (data["error"] === "custom-starting-company-paid") notie.alert({
            type: 3,
            text: "Custom Starting Company is only available in JoW Paid"
        });
        else notie.alert({
            type: 3,
            text: "There was an error creating the game. Please try again."
        });
    }
}
function $8de2281fafd7b0c6$var$runScenariosSearch() {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $lCS03.playSoundEffect)("success");
    let searchTerm = $(".scenario-search-input").val();
    let filterPeriod = $('.scenario-search-options input[name="radio-scenario-search-period"]:checked').val();
    let filterStartingYear = $(".search-starting-year").val();
    let filterCompanyName = $(".search-company-name").val();
    (0, $1JSre.makeGetRequest)("/_search_scenarios", {
        query: searchTerm,
        companyName: filterCompanyName,
        startingYear: filterStartingYear,
        period: filterPeriod
    }, (data)=>{
        // Show results
        let resultsContainer = $("#scenarios-search-results");
        resultsContainer.html("");
        data["scenarios"].forEach(function(scenario) {
            let scenarioHtml = $8de2281fafd7b0c6$var$getScenarioHtml(scenario);
            resultsContainer.append(scenarioHtml);
        });
        if (!data["scenarios"].length) resultsContainer.append('<div class="scenario">No scenarios found.</div>');
        resultsContainer.show();
        $(".scenario-search-input").focus();
        $("#our-scenarios").hide();
        $("#user-scenarios").hide();
        $("#tutorial-scenario").hide();
        $("#featured-scenario").hide();
        $(".scenario-sort").val("rating");
        $("#new-game-menu-container").scrollTop(0);
    });
}
function $8de2281fafd7b0c6$var$processCustomCompanyOpenGraphicCreator(hide) {
    if (typeof hide === "undefined") hide = true;
    let openCharacterCreator = $(".custom-starting-company-championships .character-creator:visible");
    if (openCharacterCreator.length > 0) {
        if (hide) {
            openCharacterCreator.find(".superstar-graphic").html("");
            openCharacterCreator.hide();
        }
        openCharacterCreator.find(".load-character-code-input").val("");
        // Save championship's graphics
        openCharacterCreator.find(".share-character").trigger("click"); // Trigger share and hide it
        openCharacterCreator.find(".share-character-code-container").hide();
        openCharacterCreator.find(".share-character").removeClass("selected");
        let characterData = openCharacterCreator.find(".share-character-code-input").val();
        if (characterData) {
            let selectedChampionship = $(".custom-starting-company-championship-add-graphic-button.blue-button-background").parent();
            selectedChampionship.data("key", characterData);
            if (hide) selectedChampionship.find(".custom-starting-company-championship-add-graphic-button").addClass("dark-grey-button-background").removeClass("blue-button-background");
        }
    }
}
async function $8de2281fafd7b0c6$var$showGenerateCustomStartingCompanyData({ data: data } = {}) {
    // Add company attributes
    let parent = $(".custom-starting-company-container");
    parent.find(".custom-starting-company-name-input").val(data["companyName"]);
    parent.find(".custom-starting-company-size-select").val(data["companySize"]).trigger("change");
    parent.find(".custom-starting-company-finances-select").val(data["companyFinances"]).trigger("change");
    parent.find(".custom-starting-company-weekly-show-name-input").val(data["weeklyShowName"]);
    parent.find(".custom-starting-company-owner-name-input").val(data["ownerName"]);
    parent.find(".custom-starting-company-style-select").val(data["companyStyle"]);
    // Add events data
    parent.find(".custom-starting-company-event-name-input").each(function(i, e) {
        let eventData = data["companyEventsData"][i];
        $(e).val(eventData["name"]);
        $(e).siblings(".custom-starting-company-event-prestige-select").val(eventData["prestige"]);
    });
    // Remove extra championship inputs
    let championshipInputs = parent.find(".custom-starting-company-championship-name-input");
    championshipInputs.slice(1).parent().remove();
    // Reset graphic
    let championshipInputParent = championshipInputs.eq(0).parent();
    championshipInputParent.find(".custom-starting-company-championship-remove-graphic-button").hide();
    championshipInputParent.find(".custom-starting-company-championship-add-graphic-button").text("Add Graphic").addClass("dark-grey-button-background").removeClass("blue-button-background");
    championshipInputParent.data("key", null);
    // Hide graphic creator
    parent.find(".character-creator").hide();
    parent.find(".character-creator").find(".superstar-graphic").html("");
    // Add championship inputs depending on number of company championships
    if (data["companyChampionshipsData"].length > 1) {
        let numberOfChampionshipInputsToAdd = data["companyChampionshipsData"].length - 1;
        let championshipInput = '<div class="margin-bottom-8">' + championshipInputs.eq(0).parent().clone().prop("innerHTML") + '<button type="button" class="remove-custom-starting-company-championship-input-button button retro-button styled-select-button ' + 'font-bold top-1px margin-left-3"><i class="fa fa-minus"></i></button></div>';
        championshipInputs.eq(0).parent().after(championshipInput.repeat(numberOfChampionshipInputsToAdd));
    }
    // Add championships data
    parent.find(".custom-starting-company-championship-name-input").each(function(i, e) {
        let championshipData = data["companyChampionshipsData"][i];
        $(e).val(championshipData["name"]);
        $(e).siblings(".custom-starting-company-championship-division-select").val(championshipData["division"]);
        $(e).siblings(".custom-starting-company-championship-prestige-select").val(championshipData["prestige"]);
    });
}
function $8de2281fafd7b0c6$var$getCompaniesListItemHtml(company, i, scenarioUid) {
    let html;
    if (i === 0) html = '<div class="margin-top-8 company-list-item"><span class="grey margin-bottom-2 display-block company-list-item-name">' + company + "</span>" + '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' + scenarioUid + "-" + company + '" ' + 'checked="checked" value="user"/><div class="control__indicator"></div></label>' + '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' + scenarioUid + "-" + company + '" ' + 'value="CPU"/><div class="control__indicator"></div></label>' + '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' + scenarioUid + "-" + company + '" ' + 'value="none"/><div class="control__indicator"></div></label>' + '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input">' + "</div>";
    else if (i < (0, $3E8Nt.gameLimits).maxCompetitors) html = '<div class="margin-top-8 company-list-item"><span class="grey margin-bottom-2 display-block company-list-item-name">' + company + "</span>" + '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' + scenarioUid + "-" + company + '" ' + 'value="user"/><div class="control__indicator"></div></label>' + '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' + scenarioUid + "-" + company + '" ' + 'checked="checked" value="CPU"/><div class="control__indicator"></div></label>' + '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' + scenarioUid + "-" + company + '" ' + 'value="none"/><div class="control__indicator"></div></label>' + '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input display-none">' + "</div>";
    else html = '<div class="margin-top-8 company-list-item"><span class="grey margin-bottom-2 display-block company-list-item-name">' + company + "</span>" + '<label class="control control--radio margin-right-10">User<input type="radio" name="radio-company-list-item-' + scenarioUid + "-" + company + '" ' + 'value="user"/><div class="control__indicator"></div></label>' + '<label class="control control--radio margin-right-10">CPU<input type="radio" name="radio-company-list-item-' + scenarioUid + "-" + company + '" ' + 'value="CPU"/><div class="control__indicator"></div></label>' + '<label class="control control--radio">None<input type="radio" name="radio-company-list-item-' + scenarioUid + "-" + company + '" ' + 'checked="checked" value="none"/><div class="control__indicator"></div></label>' + '<input type="text" name="company-list-item-player-name" placeholder="Player Name" maxlength="15" class="styled-select player-name-input display-none">' + "</div>";
    return html;
}
function $8de2281fafd7b0c6$var$getScenarioEdits(uid, editsContainer, sort, page) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $lCS03.playSoundEffect)("success");
    (0, $1JSre.makeGetRequest)("/_get_scenario_edits", {
        uid: uid,
        page: page,
        sort: sort
    }, (data)=>{
        let editsHtml = "";
        if (data["edits"].length > 0) data["edits"].forEach(function(edit, i) {
            let ratingHtmlEdit;
            if (edit["rating"] === null) ratingHtmlEdit = '<span class="rating no-rating">?? %</span>';
            else if (edit["rating"] >= 50) ratingHtmlEdit = '<span class="rating positive">' + edit["rating"] + "%</span>";
            else ratingHtmlEdit = '<span class="rating negative">' + edit["rating"] + "%</span>";
            // Check for existing rating, change rating icon
            let ratingIconsEdit;
            if (edit["rated_up"]) ratingIconsEdit = '<i class="fa fa-thumbs-o-up icon-button margin-left-8 grey rate-up font-bold positive"></i><i class="fa fa-thumbs-o-down icon-button margin-left-8 grey rate-down"></i>';
            else if (edit["rated_down"]) ratingIconsEdit = '<i class="fa fa-thumbs-o-up icon-button margin-left-8 grey rate-up"></i><i class="fa fa-thumbs-o-down icon-button margin-left-8 grey rate-down font-bold negative"></i>';
            else ratingIconsEdit = '<i class="fa fa-thumbs-o-up icon-button margin-left-8 grey rate-up"></i><i class="fa fa-thumbs-o-down icon-button margin-left-8 grey rate-down"></i>';
            // Edit options
            let showInfoIcon = '<i class="fa fa-question margin-left-3 font-1p125em show-scenario-edit-info icon-button light"></i>';
            let deleteIcon = "";
            let editIcon = "";
            if (edit["show_delete"]) {
                deleteIcon = '<i class="fa fa-times-circle-o margin-left-3 font-1p125em delete-scenario-edit icon-button light help-text" title="Delete"></i>';
                editIcon = '<i class="fa fa-pencil-square-o margin-left-2 font-1p125em edit-scenario-edit icon-button grey help-text" title="Edit"></i>';
            }
            let editPrivateHtml = "";
            let editNameClass = "";
            if (edit["private"]) {
                editPrivateHtml = '<span class="margin-left-5 light-grey">Private</span>';
                editNameClass = " brown-red";
            }
            let creatorHtml = '<span class="light-grey margin-right-3">by {0}</span>'.format((0, $1JSre.escapeHTML)(edit["creator"]));
            let datetimeUpdatedHtml = '<span class="high-light-grey margin-right-5 help-text" title="Date created/updated">{0}</span>'.format(edit["datetime_updated_string"]);
            let editNameText = "{0}".format((0, $1JSre.escapeHTML)(edit["comments"]));
            let editNameHtml = '<span class="margin-right-5' + editNameClass + '">' + editNameText + "</span>";
            let scenarioVersion = '<span class="high-light-grey help-text margin-right-3" title="Scenario version that the edit is based on">Scenario v{0}</span>'.format(edit["version"]);
            let editVersion = '<span class="high-light-grey help-text" title="Edit version">Edit v{0}</span>'.format(edit["edit_version"]);
            let editCompanyName = edit["company_name"];
            if (editCompanyName) editCompanyName = editCompanyName.replace(/"/g, "&quot;");
            let confidenceRating = edit["confidence_rating"] !== null ? edit["confidence_rating"] : -1;
            let editText = "{0} {1} {2} {3} {4} {5}".format(editNameHtml, ratingHtmlEdit, ratingIconsEdit, showInfoIcon, editIcon, deleteIcon);
            let editInfo = '<span class="scenario-edit-info display-none margin-left-8">{0} {1} {2} {3} {4}</span>'.format(creatorHtml, datetimeUpdatedHtml, scenarioVersion, editVersion, editPrivateHtml);
            editsHtml += '<div class="margin-bottom-10 scenario-edit" data-competition=\'' + JSON.stringify(edit["competition"]).replace(/'/g, "&#39;") + "' data-uid=\"" + edit["uid"] + '" data-date="' + edit["datetime_updated"] + '" data-confidence-rating="' + confidenceRating + '" data-company-name="' + editCompanyName + '">' + editText + editInfo + "</div>";
        });
        else editsHtml += '<div class="light-grey margin-bottom-10">No edits present</div>';
        let html = '<div class="purple display-inline-block">Edits</div> <div class="float-right top--2px"><button type="button" class="button retro-button condensed light-button-background sort-scenario-edits-button " data-value="best">Best</button> <button type="button" class="button retro-button condensed light-button-background sort-scenario-edits-button" data-value="new">New</button> <button type="button" class="button retro-button condensed light-button-background sort-scenario-edits-button" data-value="my-edits">My Edits</button></div><div class="scroll-container margin-top-12">' + editsHtml + "</div>" + '<div class="column-left">' + '<button type="button" class="button retro-button condensed light-button-background scenario-edits-previous-page-button margin-top-10 no-margin-bottom">' + "Prev" + "</button>" + "</div>" + '<div class="column-right text-right">' + '<button type="button" class="button retro-button condensed light-button-background scenario-edits-next-page-button margin-top-10 no-margin-bottom">' + "Next" + "</button>" + "</div>" + '<div class="clear"></div>';
        editsContainer.html(html);
        editsContainer.show();
        editsContainer.find(".scroll-container").scrollTop(0);
        // Show/hide pagination buttons
        if (data["next_page"]) editsContainer.find(".scenario-edits-next-page-button").removeClass("visibility-hidden").data("page", data["next_page"]);
        else editsContainer.find(".scenario-edits-next-page-button").addClass("visibility-hidden");
        if (data["previous_page"]) editsContainer.find(".scenario-edits-previous-page-button").removeClass("visibility-hidden").data("page", data["previous_page"]);
        else editsContainer.find(".scenario-edits-previous-page-button").addClass("visibility-hidden");
        // Select sort button
        editsContainer.find('.sort-scenario-edits-button[data-value="' + sort + '"]').addClass("selected");
    });
}
function $8de2281fafd7b0c6$var$showScenarioInformation(scenarioData, el) {
    let companyInfo = scenarioData["companyInformation"];
    let championships = scenarioData["championships"];
    let gimmickMatches = scenarioData["gimmickMatches"];
    let rosters = scenarioData["rosters"];
    let brands = scenarioData["brands"];
    let competitors = scenarioData["competitorsData"];
    // Company info
    let companyInfoDiv = (0, $1JSre.getCompanyInfo)(companyInfo);
    // Championships
    let championshipsDiv = (0, $1JSre.getChampionshipsInfo)(championships);
    // Gimmick matches
    let topGimmickMatchesDiv = (0, $1JSre.getItemListDiv)(gimmickMatches["topGimmickMatches"]);
    let gimmickMatchesDiv = '<div class="margin-bottom-25"><div class="blue font-1p25em margin-bottom-12">Gimmick Matches</div>' + (0, $1JSre.getItemColumnDiv)("Top", topGimmickMatchesDiv) + "</div>";
    // Rosters
    let rostersDiv = "";
    rosters.forEach(function(roster, i) {
        let rosterDiv = (0, $1JSre.getRosterInfo)(roster);
        rostersDiv += rosterDiv;
        if (i === 0) // Brands
        rostersDiv += (0, $1JSre.getBrandsInfo)(brands);
    });
    // Competitors
    let competitorsDiv = "";
    competitors.forEach(function(competitor, i) {
        let competitorInfo = (0, $1JSre.getCompanyInfo)(competitor, true);
        let championshipsInfo = (0, $1JSre.getChampionshipsInfo)(competitor["championships"], true);
        // Rosters
        let rostersInfo = "";
        competitor["rosters"].forEach(function(roster, i) {
            let rosterDiv = (0, $1JSre.getRosterInfo)(roster, true);
            rostersInfo += rosterDiv;
            if (i === 0) // Brands
            rostersInfo += (0, $1JSre.getBrandsInfo)(competitor["brands"], true);
        });
        let divClass = "";
        if (i !== 0) divClass = "scenario-information-separator";
        else divClass = "margin-top-25";
        let competitorDiv = '<div class="' + divClass + '">' + competitorInfo + rostersInfo + championshipsInfo + "</div>";
        competitorsDiv += competitorDiv;
    });
    if (competitors.length < 1) competitorsDiv = '<div class="grey">No competitors added</div>';
    competitorsDiv = '<div><div class="blue font-1p25em margin-bottom-12">Competitors</div>' + competitorsDiv + "</div>";
    let scenarioInfoDiv = "<div>" + companyInfoDiv + rostersDiv + championshipsDiv + gimmickMatchesDiv + competitorsDiv + "</div>";
    $(el).append(scenarioInfoDiv).fadeIn();
    $(el).scrollTop(0);
}




var $lCS03 = parcelRequire("lCS03");

var $1JSre = parcelRequire("1JSre");

var $iRMwH = parcelRequire("iRMwH");

var $aP7lq = parcelRequire("aP7lq");

var $knp8C = parcelRequire("knp8C");




var $bZol7 = parcelRequire("bZol7");

var $ycsyu = parcelRequire("ycsyu");

var $6PzHO = parcelRequire("6PzHO");

var $66ItE = parcelRequire("66ItE");

var $1olyO = parcelRequire("1olyO");

var $1JSre = parcelRequire("1JSre");

var $98xmD = parcelRequire("98xmD");

var $3E8Nt = parcelRequire("3E8Nt");

var $lCS03 = parcelRequire("lCS03");



var $8bQDO = parcelRequire("8bQDO");
// Declare editor variables
let $3930923fc77c55ab$var$scenarioData;
let $3930923fc77c55ab$var$originalScenarioData;
let $3930923fc77c55ab$var$newScenarioObjectUid = 1;
let $3930923fc77c55ab$var$scenarioEditorInfoShown = false;
$(document).ready(function() {
    /* Load scenario buttons */ // Edit scenario
    $("#container").on("click", ".edit-scenario", function() {
        let uid = $(this).parent(".scenario").attr("data-uid");
        let version = $(this).prevAll(".versions:first").find("#select-version").val();
        $3930923fc77c55ab$var$loadEditScenarioDataRequest(uid, version, "scenario");
    });
    // Create edit
    $("#container").on("click", ".create-scenario-edit", function() {
        if ($(this).hasClass("disabled")) return;
        let uid = $(this).closest(".scenario").attr("data-uid");
        let version = $(this).closest(".scenario").find(".versions").find("#select-version").val();
        $3930923fc77c55ab$var$loadEditScenarioDataRequest(uid, version, "scenario_edit");
    });
    // Edit scenario edit
    $("#new-game-menu").on("click", ".edit-scenario-edit", function(e) {
        e.stopPropagation();
        let parent = $(this).parent(".scenario-edit");
        let uid = parent.attr("data-uid");
        $3930923fc77c55ab$var$loadEditScenarioDataRequest(uid, null, "scenario_edit");
    });
    // Duplicate scenario
    $("#container").on("click", ".duplicate-scenario-button", function() {
        let $this = $(this);
        notie.confirm({
            text: "Are you sure? This will create a new scenario.",
            submitCallback: function() {
                let uid = $this.parent(".scenario").attr("data-uid");
                let version = $this.prevAll(".versions:first").find("#select-version").val();
                $3930923fc77c55ab$var$loadEditScenarioDataRequest(uid, version, "scenario", true);
            }
        });
    });
    /* Editor UI (left column) */ // Continue to editor from info page
    $(".continue-to-scenario-editor-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideMainMenuContent)($());
        $(".scenario-editor-container").fadeIn("slow");
    });
    // Click main menu button
    $(".scenario-editor-main-menu-container .scenario-editor-menu-button").on("click", function() {
        // Don't run if item validation failed
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        // Select this button
        $(".scenario-editor-menu-button.selected").removeClass("selected");
        $(this).addClass("selected");
        // Load scenario details for editing
        let itemType = $(this).attr("data-value");
        if (itemType === "scenario-details") $3930923fc77c55ab$var$loadScenarioEditorObjectForEditing($3930923fc77c55ab$var$scenarioData["scenario_details"], itemType, $3930923fc77c55ab$var$scenarioData["companies"][0]);
        else if (itemType === "changes-made") $3930923fc77c55ab$var$loadScenarioEditorChangesMadePage($3930923fc77c55ab$var$scenarioData, $3930923fc77c55ab$var$originalScenarioData);
    });
    // Click companies menu button
    $(document).on("click", ".scenario-editor-companies-menu-container .scenario-editor-menu-button", function() {
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        // Set company uid / indies
        let selectedCompanyUid = $(this).attr("data-uid") ? $(this).attr("data-uid") : null;
        let indies = !!$(this).attr("data-indies");
        $(".scenario-editor-container").data("companyUid", selectedCompanyUid);
        $(".scenario-editor-container").data("indies", indies);
        // Load company page
        let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
        $3930923fc77c55ab$var$loadScenarioEditorCompanyPage(companyData);
    });
    // Click company/indies menu button
    $(".scenario-editor-company-menu-container .scenario-editor-menu-button, .scenario-editor-indies-menu-container .scenario-editor-menu-button").on("click", function() {
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        // Select this button
        $(".scenario-editor-menu-button.selected").removeClass("selected");
        $(this).addClass("selected");
        // Load list page for company based on item type
        let itemType = $(this).attr("data-value");
        let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
        if (itemType === "company-details") // Load company details for editing
        $3930923fc77c55ab$var$loadScenarioEditorObjectForEditing(companyData["company_details"], itemType, companyData);
        else $3930923fc77c55ab$var$loadScenarioEditorListPage(companyData, itemType);
    });
    // Click back button
    $(".scenario-editor-back-button").on("click", function() {
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        // Process open graphic
        $3930923fc77c55ab$var$processScenarioEditorItemGraphic();
        // Go back to previous page
        let previousPage = $(".scenario-editor-container").data("previousPage");
        if (previousPage === "mainPage") $3930923fc77c55ab$var$loadScenarioEditorMainPage($3930923fc77c55ab$var$scenarioData);
        else if (previousPage === "companyPage") {
            let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
            $3930923fc77c55ab$var$loadScenarioEditorCompanyPage(companyData);
        }
    });
    // Click back to main menu button
    $(".scenario-editor-main-menu-button").on("click", function() {
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        // Process open graphic
        $3930923fc77c55ab$var$processScenarioEditorItemGraphic();
        $3930923fc77c55ab$var$loadScenarioEditorMainPage($3930923fc77c55ab$var$scenarioData);
    });
    // Click list item
    $(document).on("click", ".scenario-editor-list-item", function() {
        // Don't run if disabled (empty results) or validation failed
        if ($(this).hasClass("disabled")) return false;
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        // Process open graphic
        $3930923fc77c55ab$var$processScenarioEditorItemGraphic();
        // Select this list item
        $(".scenario-editor-list-item.selected").removeClass("selected");
        $(this).addClass("selected");
        // Get item object
        let itemUid = $(this).attr("data-uid");
        let itemType = $(".scenario-editor-menu-button.selected").attr("data-value");
        let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
        let itemObjects = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, itemType);
        let itemObject = $3930923fc77c55ab$var$getScenarioEditorItemObject(itemObjects, itemUid);
        // Load object data into edit details page
        $3930923fc77c55ab$var$loadScenarioEditorObjectForEditing(itemObject, itemType, companyData);
    });
    // Change item input
    $(document).on("change", ".scenario-editor-item-container input, .scenario-editor-item-container select, .scenario-editor-item-container textarea", function() {
        // Get attribute and value
        let itemType = $(".scenario-editor-item-container").data("itemType");
        let attribute = $(this).attr("data-attribute");
        let value = $3930923fc77c55ab$var$getScenarioEditorItemInputValue($(this), attribute, itemType);
        if (attribute) {
            // Validate input
            let validationCheck = $3930923fc77c55ab$var$validateScenarioEditorValue(value, attribute, $(this));
            if (!validationCheck.error) {
                // Remove failed validation
                if (attribute !== "traits") notie.hideAlerts();
                $(this).removeClass("validation-failed highlight");
                $(this).attr("data-validation-message", null);
                // Get item object
                let itemObject;
                // Get company/scenario details directly
                let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
                if (itemType === "company-details") itemObject = companyData["company_details"];
                else if (itemType === "scenario-details") {
                    companyData = $3930923fc77c55ab$var$scenarioData;
                    itemObject = $3930923fc77c55ab$var$scenarioData["scenario_details"];
                } else {
                    let itemUid = $(".scenario-editor-item-container").data("uid");
                    let itemObjects = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, itemType);
                    itemObject = $3930923fc77c55ab$var$getScenarioEditorItemObject(itemObjects, itemUid);
                }
                // Update object links
                if (attribute === "name") $3930923fc77c55ab$var$updateScenarioEditorObjectLinks(itemObject, value, itemType, companyData, $3930923fc77c55ab$var$scenarioData);
                // Update object
                $3930923fc77c55ab$var$updateScenarioEditorObject(itemObject, value, attribute, itemType);
            } else {
                // Show failed validation
                $(this).addClass("validation-failed highlight");
                $(this).attr("data-validation-message", validationCheck.message);
                notie.alert({
                    type: 3,
                    text: validationCheck.message,
                    stay: true
                });
            }
        }
    });
    // Click add item button
    $(document).on("click", ".scenario-editor-add-item-button, .scenario-editor-add-5-items-button", function() {
        let $this = $(this);
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        // Process open graphic
        $3930923fc77c55ab$var$processScenarioEditorItemGraphic();
        // Add company
        if ($(".scenario-editor-main-menu-container").is(":visible")) {
            let itemType = "companies";
            let companyObjects = $3930923fc77c55ab$var$scenarioData.companies;
            if (!$3930923fc77c55ab$var$checkScenarioEditorAddItemLimit(companyObjects.length, itemType)) return false;
            // Create item object
            let newItemObject = $3930923fc77c55ab$var$createScenarioEditorItemObject(itemType, $3930923fc77c55ab$var$newScenarioObjectUid.toString());
            $3930923fc77c55ab$var$newScenarioObjectUid += 1;
            // Add item to companies menu before indies
            let newItemHtml = $3930923fc77c55ab$var$getScenarioEditorCompaniesMenuItemHtml(newItemObject);
            $('.scenario-editor-companies-menu-container .scenario-editor-menu-button[data-indies="true"]').before(newItemHtml);
            // Scroll to new list item
            $(".scenario-editor-companies-menu-container").scrollTop($(".scenario-editor-companies-menu-container")[0].scrollHeight);
            // Add to companyObjects
            companyObjects.push(newItemObject);
            // Reset scenario companies
            $(".scenario-companies-container").hide();
            $(".search-companies-button.selected").removeClass("selected");
        } else {
            let itemType = $(".scenario-editor-menu-button.selected").attr("data-value");
            let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
            let itemObjects = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, itemType);
            // Get number of items to add
            let numberOfItemsToAdd = 1;
            if ($this.hasClass("scenario-editor-add-5-items-button") && itemType === "superstars") numberOfItemsToAdd = 5;
            // Check max items limit
            if (!$3930923fc77c55ab$var$checkScenarioEditorAddItemLimit(itemObjects.length + (numberOfItemsToAdd - 1), itemType)) return false;
            let newItemObject;
            for(let i = 0; i < numberOfItemsToAdd; i++){
                // Create item object
                newItemObject = $3930923fc77c55ab$var$createScenarioEditorItemObject(itemType, $3930923fc77c55ab$var$newScenarioObjectUid.toString());
                $3930923fc77c55ab$var$newScenarioObjectUid += 1;
                // Add item to list
                let newItemHtml = $3930923fc77c55ab$var$getScenarioEditorListItemHtml(newItemObject, itemType);
                $(".scenario-editor-list-container").append(newItemHtml);
                // Add item to itemObjects
                itemObjects.push(newItemObject);
            }
            // Hide 'no items present' item
            $(".scenario-editor-list-item.none-text").remove();
            // Reset search
            $(".scenario-editor-list-search-input").val("");
            $(".scenario-editor-list-filter.selected").removeClass("selected");
            $(".scenario-editor-list-item").show();
            $(".no-scenario-editor-search-results").hide();
            // Select latest list item, scroll to it
            $(".scenario-editor-list-item.selected").removeClass("selected");
            $(".scenario-editor-list-item").last().addClass("selected");
            $(".scenario-editor-list-container").scrollTop($(".scenario-editor-list-container")[0].scrollHeight);
            // Load object data into edit details page
            $3930923fc77c55ab$var$loadScenarioEditorObjectForEditing(newItemObject, itemType, companyData);
        }
        notie.alert({
            type: 4,
            text: "Item added"
        });
    });
    // Click remove item button
    $(document).on("click", ".scenario-editor-remove-item-button", function() {
        notie.confirm({
            text: "Are you sure?",
            submitCallback: function() {
                // Remove company
                if ($(".scenario-editor-company-menu-container").is(":visible")) {
                    let companyObjects = $3930923fc77c55ab$var$scenarioData["companies"];
                    // Get company object
                    let companyObject = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
                    if (companyObject) {
                        let companyIndex = companyObjects.indexOf(companyObject);
                        if (companyIndex > 0) {
                            // Remove from companyObjects
                            companyObjects.splice(companyIndex, 1);
                            notie.alert({
                                type: 4,
                                text: "Item removed"
                            });
                            // Show main menu
                            $3930923fc77c55ab$var$loadScenarioEditorMainPage($3930923fc77c55ab$var$scenarioData);
                        } else notie.alert({
                            type: 3,
                            text: "The primary company in a scenario cannot be removed"
                        });
                    } else notie.alert({
                        type: 3,
                        text: "Item could not be found"
                    });
                } else {
                    // Get item object
                    let itemType = $(".scenario-editor-menu-button.selected").attr("data-value");
                    let itemUid = $(".scenario-editor-item-container").data("uid");
                    let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
                    let itemObjects = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, itemType);
                    let itemObject = $3930923fc77c55ab$var$getScenarioEditorItemObject(itemObjects, itemUid);
                    if (itemObject) {
                        // Remove from itemObjects
                        itemObjects.splice(itemObjects.indexOf(itemObject), 1);
                        // Remove item from list
                        $('.scenario-editor-list-item[data-uid="' + itemUid + '"]').remove();
                        // Reset search
                        $(".scenario-editor-list-search-input").val("");
                        $(".scenario-editor-list-filter.selected").removeClass("selected");
                        $(".scenario-editor-list-item").show();
                        $(".no-scenario-editor-search-results").hide();
                        // Add empty text if no objects left
                        if (itemObjects.length <= 0) $(".scenario-editor-list-container").html('<div class="inner-box-item scenario-editor-list-item disabled light-grey none-text">No ' + itemType.replace(/-/g, " ") + " present</div>");
                        notie.alert({
                            type: 4,
                            text: "Item removed"
                        });
                        // Add empty text to Edit Details page
                        $(".scenario-editor-item-container").html('<div class="font-bold margin-left-5 light-grey margin-top-2">Select an item in the Editor to display its details here</div>');
                        $(".scenario-editor-item-buttons-container").hide();
                    } else notie.alert({
                        type: 3,
                        text: "Item could not be found"
                    });
                }
            }
        });
    });
    // Click move item button
    $(document).on("click", ".scenario-editor-move-item-button", function() {
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        // Get companies, excluding current one
        let selectedCompanyUid = $(".scenario-editor-container").data("companyUid");
        let indies = $(".scenario-editor-container").data("indies");
        let moveOptions = "<option selected>Select Company</option>";
        let itemType = $(".scenario-editor-menu-button.selected").attr("data-value");
        $3930923fc77c55ab$var$scenarioData["companies"].forEach(function(company) {
            if (company["company_details"]["uid"] !== selectedCompanyUid) moveOptions += '<option data-uid="' + company["company_details"]["uid"] + '">' + company["company_details"]["name"] + "</option>";
        });
        // Add indies if company item and not faction/championship
        if (!indies && [
            "factions",
            "championships"
        ].indexOf(itemType) < 0) moveOptions += '<option data-indies="indies">Indies</option>';
        // Add company options, show company select
        $(".scenario-editor-move-item-company-select").html(moveOptions).show();
        // Hide move button
        $(this).hide();
    });
    // Select move company
    $(document).on("change", ".scenario-editor-move-item-company-select", function() {
        // Get company to move to
        let selectedOption = $(this).find(":selected");
        let companyUid = selectedOption.attr("data-uid");
        let indies = !!selectedOption.attr("data-indies");
        let companyToMoveToData = $3930923fc77c55ab$var$getScenarioEditorCompanyData($3930923fc77c55ab$var$scenarioData, companyUid, indies);
        if (companyToMoveToData) {
            // Get item object
            let itemType = $(".scenario-editor-menu-button.selected").attr("data-value");
            let itemUid = $(".scenario-editor-item-container").data("uid");
            let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
            let itemObjects = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, itemType);
            let itemObject = $3930923fc77c55ab$var$getScenarioEditorItemObject(itemObjects, itemUid);
            let itemObjectsToMoveTo = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyToMoveToData, itemType);
            let superstarsToMove;
            // Check item limit
            if (!$3930923fc77c55ab$var$checkScenarioEditorAddItemLimit(itemObjectsToMoveTo.length, itemType)) return false;
            if (itemObject) {
                // Move superstars for teams/factions
                if (itemType === "teams" || itemType === "factions") {
                    let superstarItemObjects = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, "superstars");
                    superstarsToMove = Array.from(itemObject["superstars"], function(x) {
                        return superstarItemObjects.filter(function(obj) {
                            return obj["name"] === x;
                        })[0];
                    });
                    let superstarObjectsToMoveTo = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyToMoveToData, "superstars");
                    // Check item limit
                    if (!$3930923fc77c55ab$var$checkScenarioEditorAddItemLimit(superstarObjectsToMoveTo.length + (superstarsToMove.length - 1), "superstars")) return false;
                    superstarsToMove.forEach(function(superstarToMove) {
                        if (superstarToMove) $3930923fc77c55ab$var$moveScenarioEditorItemObject(superstarToMove, superstarItemObjects, "superstars", superstarObjectsToMoveTo, true);
                    });
                }
                // Move item object
                $3930923fc77c55ab$var$moveScenarioEditorItemObject(itemObject, itemObjects, itemType, itemObjectsToMoveTo);
                if (superstarsToMove) notie.alert({
                    type: 4,
                    text: "Item and its superstars moved"
                });
                else notie.alert({
                    type: 4,
                    text: "Item moved"
                });
            } else notie.alert({
                type: 3,
                text: "Item could not be found"
            });
        } else notie.alert({
            type: 3,
            text: "Company could not be found"
        });
    });
    // Randomize item
    $(document).on("click", ".scenario-editor-randomize-item-button", async function() {
        // Get item object
        let itemType = $(".scenario-editor-menu-button.selected").attr("data-value");
        let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
        let itemUid = $(".scenario-editor-item-container").data("uid");
        let itemObjects = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, itemType);
        let itemObject = $3930923fc77c55ab$var$getScenarioEditorItemObject(itemObjects, itemUid);
        // Generate superstar
        let data = await (0, $8bQDO.generateSuperstar)({
            insert: false,
            addGraphic: false,
            generateGimmick: false
        });
        // Add data to itemObject
        itemObject.pronoun = data.pronoun;
        itemObject.age = data.age;
        itemObject.popularity = data.popularity;
        itemObject.traits = data.traits;
        itemObject.status = "active";
        itemObject.workrate = (0, $3E8Nt.getRandomChoice)($(".scenario-editor-workrate-select option")).value;
        itemObject.charisma = (0, $3E8Nt.getRandomChoice)($(".scenario-editor-charisma-select option")).value;
        itemObject.overness = (0, $3E8Nt.getRandomChoice)($(".scenario-editor-overness-select option")).value;
        itemObject.alignment = (0, $3E8Nt.getRandomChoice)($(".scenario-editor-alignment-select option")).value;
        // Load inputs, change name and trigger input
        $3930923fc77c55ab$var$loadScenarioEditorObjectForEditing(itemObject, itemType, companyData);
        $(".scenario-editor-name-input").val(data.name).trigger("change");
    });
    // Set primary company
    $(document).on("click", ".scenario-editor-set-primary-company-button", function() {
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        notie.confirm({
            text: "Are you sure? This company will be moved to the first company's position.",
            submitCallback: function() {
                // Get current company
                let companyObjects = $3930923fc77c55ab$var$scenarioData["companies"];
                let currentCompany = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
                let originalPrimaryCompany = companyObjects[0];
                // Check if company is already primary company
                if (originalPrimaryCompany === currentCompany) {
                    notie.alert({
                        type: 3,
                        text: "This company is already the primary company"
                    });
                    return false;
                }
                if (currentCompany) {
                    // Move company to first position
                    companyObjects.splice(companyObjects.indexOf(currentCompany), 1);
                    companyObjects.unshift(currentCompany);
                    // Get original starting event and its index
                    let originalStartingEvent = originalPrimaryCompany.events.filter(function(obj) {
                        return obj["name"] === $3930923fc77c55ab$var$scenarioData.scenario_details.starting_event;
                    })[0];
                    let startingEventIndex = originalPrimaryCompany.events.indexOf(originalStartingEvent);
                    // Use index to set new starting event
                    $3930923fc77c55ab$var$scenarioData.scenario_details.starting_event = currentCompany.events[startingEventIndex].name;
                    notie.alert({
                        type: 4,
                        text: "Primary company changed"
                    });
                    // Show main menu
                    $3930923fc77c55ab$var$loadScenarioEditorMainPage($3930923fc77c55ab$var$scenarioData);
                } else notie.alert({
                    type: 3,
                    text: "Item could not be found"
                });
            }
        });
    });
    // List search
    $(document).on("input", ".scenario-editor-list-search-input", function() {
        $3930923fc77c55ab$var$runScenarioEditorListSearch();
    });
    // List filter
    $(document).on("click", ".scenario-editor-list-filter", function() {
        let filterName;
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else {
            $(".scenario-editor-list-filter.selected").removeClass("selected");
            $(this).addClass("selected");
            filterName = $(this).attr("data-value");
        }
        $3930923fc77c55ab$var$applyScenarioEditorListFilter(filterName);
    });
    // Click publish button
    $(".scenario-editor-publish-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        if (!$3930923fc77c55ab$var$checkScenarioValidation($3930923fc77c55ab$var$scenarioData)) return false;
        notie.confirm({
            text: "Are you sure? Please check the 'Changes Made' section to go over your changes.",
            submitCallback: async function() {
                await $3930923fc77c55ab$var$addScenarioDataRequest($3930923fc77c55ab$var$scenarioData);
            }
        });
    });
    /* Scenario Companies */ // Search companies menu button
    $(document).on("click", ".search-companies-button", function() {
        if ($(this).hasClass("selected")) {
            $(this).removeClass("selected");
            $(".scenario-companies-container").hide();
        } else {
            $(this).addClass("selected");
            $(".scenario-companies-container").show();
            $(".scenario-companies-results").hide();
            $(".scenario-companies-search-input").val("").focus();
            if (!(0, $98xmD.globalUser).paid) $(".scenario-companies-container").find(".scenario-companies-info").show();
        }
    });
    // Search scenario companies
    $(document).on("click", ".scenario-companies-search-button", function() {
        let searchTerm = $(this).siblings(".scenario-companies-search-input").val();
        // Validate
        if (searchTerm.length <= 0) {
            notie.alert({
                type: 3,
                text: "Enter a company name to search for"
            });
            // Put focus back on search field
            $(this).siblings(".scenario-companies-search-input").focus();
            return false;
        }
        $3930923fc77c55ab$var$runScenarioCompaniesSearch(searchTerm);
    });
    // 'Enter' keypress to search
    $(document).on("keypress", ".scenario-companies-search-input", function(e) {
        // Trigger search on enter key press
        if (e.which === 13) {
            e.preventDefault();
            $(e.target).siblings(".scenario-companies-search-button").trigger("click");
        }
    });
    // Next/previous page buttons
    $(document).on("click", ".scenario-companies-next-page-button, .scenario-companies-previous-page-button", function() {
        let page = $(this).data("page");
        let parent = $(this).closest(".scenario-companies-container");
        let searchTerm = parent.find(".scenario-companies-search-input").val();
        $3930923fc77c55ab$var$runScenarioCompaniesSearch(searchTerm, page);
    });
    // Load scenario company
    $(document).on("click", ".scenario-editor-container .scenario-companies-search-result-item", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        if ($(this).hasClass("disabled")) return false;
        if (!$3930923fc77c55ab$var$checkScenarioEditorItemValidation()) return false;
        if (!$3930923fc77c55ab$var$checkScenarioEditorAddItemLimit($3930923fc77c55ab$var$scenarioData.companies.length, "companies")) return false;
        let uid = $(this).attr("data-uid");
        (0, $1JSre.makeGetRequest)("/_get_community_company_data", {
            uid: uid
        }, (data)=>{
            if (!data["error"]) {
                let newItemObject = data;
                // Add item to companies menu before indies
                let newItemHtml = $3930923fc77c55ab$var$getScenarioEditorCompaniesMenuItemHtml(newItemObject);
                $('.scenario-editor-companies-menu-container .scenario-editor-menu-button[data-indies="true"]').before(newItemHtml);
                // Scroll to new list item
                $(".scenario-editor-companies-menu-container").scrollTop($(".scenario-editor-companies-menu-container")[0].scrollHeight);
                // Add to companyObjects
                $3930923fc77c55ab$var$scenarioData.companies.push(newItemObject);
                // Reset scenario companies
                $(".scenario-companies-container").hide();
                $(".search-companies-button.selected").removeClass("selected");
                notie.alert({
                    type: 4,
                    text: "Company added"
                });
            } else {
                if (data["error"] === "not-found") notie.alert({
                    type: 3,
                    text: "That company could not be found. Please try again.",
                    stay: true
                });
                if (data["error"] === "not-paid") notie.alert({
                    type: 3,
                    text: "You need to have JoW Paid to add a Community Company to your Scenario.",
                    stay: true
                });
            }
        });
    });
    /* Editor Item UI (right column) */ // Show/hide injured/gimmick/manager/training inputs
    $(document).on("change", ".scenario-editor-injured-input, .scenario-editor-gimmick-input, .scenario-editor-manager-input, .scenario-editor-training-input, .scenario-editor-future-input", function() {
        $3930923fc77c55ab$var$toggleScenarioEditorItemInputsContainer($(this));
        // Focus shown input
        if ($(this).hasClass("scenario-editor-gimmick-input")) $(".scenario-editor-gimmick-name-input").focus();
        if ($(this).hasClass("scenario-editor-injured-input")) $(".scenario-editor-injured-months-input").focus();
        if ($(this).hasClass("scenario-editor-future-input")) $(".scenario-editor-year-input").focus();
    });
    // Show/hide gimmick match consequence inputs
    $(document).on("change", ".scenario-editor-consequence-select", function() {
        $3930923fc77c55ab$var$toggleScenarioEditorConsequenceInput($(this));
        // Focus shown input
        $(".scenario-editor-contract-name-input").focus();
    });
    // Show/hide third superstar for team
    $(document).on("change", ".scenario-editor-team-type-select", function() {
        $3930923fc77c55ab$var$toggleScenarioEditorTeamTypeInput($(this));
        // Trigger change to update members
        $(".scenario-editor-third-superstar-select").trigger("change");
    });
    // Update faction leader select
    $(document).on("change", ".scenario-editor-faction-member-select", function() {
        $3930923fc77c55ab$var$updateScenarioEditorFactionLeaderSelect();
    });
    // Add managed talent select
    $(document).on("click", ".scenario-editor-add-managed-talent-button", function() {
        // Get existing talent inputs
        let parentBox = $(this).closest(".superstar-manager-container");
        let managedTalentInputs = parentBox.find(".scenario-editor-managed-talent-select");
        // Check for maximum talent inputs
        if (managedTalentInputs.length >= 15) {
            notie.alert({
                type: 3,
                text: "You cannot select more than 15 talent to manage"
            });
            return false;
        }
        // Clone talent select, add remove button
        let managedTalentInputHtml = '<div class="margin-bottom-8">' + managedTalentInputs.eq(0).clone().addClass("compact").prop("outerHTML") + '<button type="button" class="scenario-editor-remove-managed-talent-button button retro-button styled-select-button margin-left-6">' + '<i class="fa fa-minus"></i>' + "</button></div>";
        // Add talent select after last one
        managedTalentInputs.last().parent().after(managedTalentInputHtml);
    });
    // Remove managed talent select
    $(document).on("click", ".scenario-editor-remove-managed-talent-button", function() {
        let previousManagedTalentSelect = $(this).parent().prev().find(".scenario-editor-managed-talent-select");
        $(this).parent().remove();
        // Update attribute
        previousManagedTalentSelect.trigger("change");
    });
    // Add faction member select
    $(document).on("click", ".scenario-editor-add-faction-member-button", function() {
        // Get existing faction member selects
        let parentBox = $(this).closest(".scenario-editor-item-container");
        let factionMemberSelects = parentBox.find(".scenario-editor-faction-member-select");
        // Check for maximum faction member selects
        if (factionMemberSelects.length >= (0, $3E8Nt.gameLimits).maxFactionSuperstars) {
            notie.alert({
                type: 3,
                text: "You cannot select more than " + (0, $3E8Nt.gameLimits).maxFactionSuperstars + " faction members"
            });
            return false;
        }
        // Clone faction member select, add remove button
        let factionMemberSelectHtml = '<div class="margin-bottom-8">' + factionMemberSelects.eq(0).clone().addClass("compact").prop("outerHTML") + '<button type="button" class="scenario-editor-remove-faction-member-button button retro-button styled-select-button margin-left-6">' + '<i class="fa fa-minus"></i>' + "</button></div>";
        // Add faction member select after last one
        factionMemberSelects.last().parent().after(factionMemberSelectHtml);
    });
    // Remove faction member select
    $(document).on("click", ".scenario-editor-remove-faction-member-button", function() {
        let previousFactionMemberSelect = $(this).parent().prev().find(".scenario-editor-faction-member-select");
        $(this).parent().remove();
        // Update attribute
        previousFactionMemberSelect.trigger("change");
    });
    // Change championship division
    $(document).on("change", ".scenario-editor-division-select", function() {
        // Get champion options based on championship division
        let championOptions;
        let division = $(this).val();
        let companyData = $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData($3930923fc77c55ab$var$scenarioData);
        if (division === "tag-team") championOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("teams", companyData);
        else if (division === "trio") championOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("trios", companyData);
        else championOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("main-roster-current-superstars", companyData);
        // Add new champion options, trigger change to set champion's value
        $(".scenario-editor-champion-select").html(championOptions).trigger("change");
    });
    // Change color preview upon move
    $(document).on("move.spectrum", ".scenario-editor-color-input", function(e, tinycolor) {
        let brandColor = tinycolor ? tinycolor.toHexString() : "";
        $(this).val(brandColor);
        $(this).parent().parent().find(".scenario-editor-color-preview").css("color", brandColor);
    });
    // Trigger color input change upon dragstop so that attribute updates
    $(document).on("dragstop.spectrum", ".scenario-editor-color-input", function() {
        $(this).trigger("change");
    });
    // Select trait item
    $(document).on("click", ".scenario-editor-item-container .superstar-trait-item-container", function() {
        // Update attribute
        $(this).closest(".scenario-editor-item-container").find(".superstar-traits-selection-input").trigger("change");
    });
    // Add superstar graphic
    $(document).on("click", ".add-scenario-editor-superstar-graphic", function() {
        $(this).hide();
        let parent = $(this).parent();
        // Set character data
        let jsonData = parent.data("graphicCode");
        let characterData;
        if (jsonData) characterData = [
            jsonData
        ];
        // Show remove graphic button
        $(this).siblings(".remove-scenario-editor-graphic-button").show();
        // Show graphic
        let graphicContainer = $(this).siblings(".character-creator");
        let el = graphicContainer.find(".superstar-graphic");
        (0, $c82cd471f4baff6b$export$d11e1d8497502e98)(characterData, el);
        graphicContainer.show();
        $(el).show();
    });
    // Remove superstar graphic
    $(document).on("click", ".remove-scenario-editor-graphic-button", function() {
        $(this).hide();
        let parent = $(this).parent();
        // Remove character data
        parent.data("graphicCode", null);
        // Remove character creator
        let graphicContainer = $(this).siblings(".character-creator");
        graphicContainer.hide();
        graphicContainer.find(".superstar-graphic").html("");
        // Reset add graphic button
        $(this).siblings(".add-graphic-button").text("Add Graphic").show();
        // Set graphic attribute to null
        $(".scenario-editor-graphic-input").val(null).trigger("change");
    });
    // Add championship graphic
    $(document).on("click", ".add-scenario-editor-championship-graphic", function() {
        $(this).hide();
        let parent = $(this).parent();
        // Set character data
        let jsonData = parent.data("graphicCode");
        let graphicData;
        if (jsonData) graphicData = [
            jsonData
        ];
        // Show remove character button
        $(this).siblings(".remove-scenario-editor-graphic-button").show();
        // Show graphic
        let graphicContainer = $(this).siblings(".character-creator");
        let el = graphicContainer.find(".superstar-graphic");
        (0, $c82cd471f4baff6b$export$aba7f700818b4b5c)(graphicData, el);
        graphicContainer.show();
        $(el).show();
    });
});
async function $3930923fc77c55ab$export$909e7241648ee4af() {
    if (!(0, $98xmD.globalUser).loggedIn) {
        (0, $lCS03.playSoundEffect)("error");
        notie.alert({
            type: 4,
            text: "You need to login to create a scenario",
            stay: true
        });
        return false;
    }
    (0, $lCS03.playSoundEffect)("success");
    (0, $1JSre.hideMainMenuContent)($());
    // Create new scenario object and copy original
    $3930923fc77c55ab$var$scenarioData = $3930923fc77c55ab$var$createScenarioEditorItemObject("scenarios", $3930923fc77c55ab$var$newScenarioObjectUid.toString());
    $3930923fc77c55ab$var$newScenarioObjectUid += 1;
    $3930923fc77c55ab$var$originalScenarioData = JSON.parse(JSON.stringify($3930923fc77c55ab$var$scenarioData));
    // Load main page
    $3930923fc77c55ab$var$loadScenarioEditorMainPage($3930923fc77c55ab$var$scenarioData);
    if ($3930923fc77c55ab$var$scenarioEditorInfoShown) $(".scenario-editor-container").fadeIn("slow");
    else {
        $(".scenario-editor-info-container").hide().fadeIn();
        $3930923fc77c55ab$var$scenarioEditorInfoShown = true;
    }
}
function $3930923fc77c55ab$var$createScenarioEditorItemObject(itemType, uid) {
    let newItemObject;
    switch(itemType){
        case "superstars":
            newItemObject = {
                "name": "Superstar",
                "age": 25,
                "popularity": 600,
                "status": "active",
                "hall_of_famer": false,
                "injured": 0,
                "pronoun": "he",
                "alignment": null,
                "workrate": 2,
                "charisma": 2,
                "gimmick": null,
                "full_time_manager": null,
                "brand_name": null,
                "managed_talent_names": [],
                "month_to_appear_in": null,
                "overness": "Average",
                "training": false,
                "traits": [],
                "graphic": null,
                "uid": uid
            };
            break;
        case "teams":
            newItemObject = {
                "name": "Team",
                "superstars": [],
                "team_type": "tag-team",
                "uid": uid
            };
            break;
        case "factions":
            newItemObject = {
                "leader_superstar": null,
                "name": "Faction",
                "reputation": 5,
                "superstars": [],
                "type": "faction",
                "uid": uid
            };
            break;
        case "championships":
            newItemObject = {
                "brand_name": null,
                "champion": null,
                "division": "singles",
                "graphic": null,
                "name": "Championship",
                "prestige": "B",
                "rank": "Upper Midcarder",
                "uid": uid
            };
            break;
        case "gimmick-matches":
            newItemObject = {
                "consequence": null,
                "injury_rate": 1,
                "name": "Gimmick Match",
                "rating_boost": 2,
                "rules": null,
                "description": null,
                "contract_name": null,
                "graphic_type": null,
                "add_random_weapons": false,
                "uid": uid
            };
            break;
        case "brands":
            newItemObject = {
                "color": null,
                "name": "Brand",
                "overness": "Average",
                "uid": uid,
                "weekly_show_is_exclusive": true,
                "weekly_show_name": null
            };
            break;
        case "match-contracts":
            newItemObject = {
                "event": "",
                "name": "Title Match",
                "talent": "",
                "uid": uid
            };
            break;
        case "streaks":
            newItemObject = {
                "event": "",
                "length": 5,
                "name": "Streak",
                "talent": "",
                "uid": uid
            };
            break;
        case "events":
            newItemObject = {
                "brand_name": null,
                "name": "Event",
                "prestige": "B",
                "uid": uid,
                "weekly_show_after_name": null,
                "weekly_show_before_name": null
            };
            break;
        case "companies":
            // Create 12 monthly events for company
            let events = [];
            let eventUid = 1;
            for(let step = 0; step < 12; step++){
                let newEvent = $3930923fc77c55ab$var$createScenarioEditorItemObject("events", eventUid.toString());
                newEvent.name = (0, $1JSre.monthNames)[step];
                events.push(newEvent);
                eventUid++;
            }
            // Create default gimmick matches
            let gimmickMatches = $3930923fc77c55ab$var$getScenarioEditorDefaultGimmickMatches();
            // Create company object
            newItemObject = {
                "brands": [],
                "championships": [],
                "company_details": {
                    "creative_points": 500,
                    "name": "Company",
                    "overness": "Average",
                    "owner_name": null,
                    "reputation": 5,
                    "style": "entertainment",
                    "top_event": events[0].name,
                    "uid": uid,
                    "weekly_show_name": null
                },
                "events": events,
                "factions": [],
                "superstars": [],
                "teams": [],
                "streaks": [],
                "gimmick_matches": gimmickMatches,
                "match_contracts": []
            };
            break;
        case "scenarios":
            let defaultCompany = $3930923fc77c55ab$var$createScenarioEditorItemObject("companies", uid.toString());
            newItemObject = {
                "scenario_details": {
                    "allow_edits": true,
                    "allow_sharing": true,
                    "comments": "",
                    "description": "",
                    "market_size": 4000000,
                    "name": "My Scenario",
                    "private": false,
                    "starting_event": defaultCompany.events[0].name,
                    "starting_year": new Date().getFullYear(),
                    "scenario_type": "scenario"
                },
                "companies": [
                    defaultCompany
                ],
                "indies": {
                    "superstars": [],
                    "teams": [],
                    "brands": []
                }
            };
            break;
    }
    return newItemObject;
}
function $3930923fc77c55ab$var$getScenarioEditorDefaultGimmickMatches() {
    return [
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars battle it out anywhere in the arena using weapons.",
            "injury_rate": 1,
            "name": "Street Fight",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": true,
            "uid": "-1"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to put your opponent through a table.",
            "injury_rate": 2,
            "name": "Tables",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": "table",
            "add_random_weapons": false,
            "uid": "-2"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars brawl it out in a special location.",
            "injury_rate": 2,
            "name": "Brawl",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": true,
            "uid": "-3"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to climb the ladder and grab the prize. This match can only be held for a championship.",
            "injury_rate": 3,
            "name": "Ladder",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": "ladder",
            "add_random_weapons": false,
            "uid": "-4"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Teams battle it out in an elimination tag match, where an entire team must be eliminated for the match to end.",
            "injury_rate": 1,
            "name": "Elimination",
            "rating_boost": 2,
            "rules": "elimination",
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-5"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The first superstar to score a submission and make their opponent tap wins the match.",
            "injury_rate": 1,
            "name": "Submission",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-6"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "A marathon match to see who is the best.",
            "injury_rate": 1,
            "name": "Ironman",
            "rating_boost": 3,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-7"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars are locked inside a steel cage, with only one survivor.",
            "injury_rate": 3,
            "name": "Steel Cage",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": "cage_grey",
            "add_random_weapons": false,
            "uid": "-8"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars are eliminated if thrown over the top rope and both feet touch the floor. Last remaining superstar wins!",
            "injury_rate": 1,
            "name": "Battle Royal",
            "rating_boost": 2,
            "rules": "battle_royal",
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-9"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Tables Ladders and Chairs, oh my! This match can only be held for a championship.",
            "injury_rate": 3,
            "name": "TLC",
            "rating_boost": 3,
            "rules": null,
            "graphic_type": "tables_ladders_chairs",
            "add_random_weapons": false,
            "uid": "-10"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to humiliate your opponent and make them quit.",
            "injury_rate": 2,
            "name": "I Quit",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-11"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "A fight without any rules or consequences where anything goes.",
            "injury_rate": 2,
            "name": "Unsanctioned",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": true,
            "uid": "-12"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to force your opponent into the back of an ambulance.",
            "injury_rate": 2,
            "name": "Ambulance",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": "ambulance",
            "add_random_weapons": false,
            "uid": "-25"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to knock your opponent out for a ten count.",
            "injury_rate": 2,
            "name": "LMS",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": true,
            "uid": "-13"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to put your opponent in a casket and close it!",
            "injury_rate": 1,
            "name": "Casket",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": "casket",
            "add_random_weapons": false,
            "uid": "-14"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars are locked in a large, high steel cell, where they battle to survive.",
            "injury_rate": 3,
            "name": "Steel Cell",
            "rating_boost": 3,
            "rules": null,
            "graphic_type": "cage_grey",
            "add_random_weapons": false,
            "uid": "-15"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The first superstar to score two falls wins.",
            "injury_rate": 3,
            "name": "2/3 Falls",
            "rating_boost": 3,
            "rules": "2/3_falls",
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-16"
        },
        {
            "consequence": "loser_unavailable",
            "contract_name": null,
            "description": "A grudge match in which the loser is forced to take takes a hiatus from the company.",
            "injury_rate": 1,
            "name": "Loser Leaves",
            "rating_boost": 3,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-17"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The first superstar to make their opponent bleed wins the match.",
            "injury_rate": 1,
            "name": "First Blood",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-18"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "A guest referee is selected to enforce the match.",
            "injury_rate": 1,
            "name": "Special Referee",
            "rating_boost": 2,
            "rules": "special_referee",
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-19"
        },
        {
            "consequence": "random_opponent",
            "contract_name": null,
            "description": "A random superstar shows up to answer the open challenge!",
            "injury_rate": 1,
            "name": "Open Challenge",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-20"
        },
        {
            "consequence": "remove_hair",
            "contract_name": null,
            "description": "The losing superstar gets their hair shaved off!",
            "injury_rate": 1,
            "name": "Hair vs Hair",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-21"
        },
        {
            "consequence": "remove_mask",
            "contract_name": null,
            "description": "The losing superstar is forced to unmask!",
            "injury_rate": 1,
            "name": "Mask vs Mask",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-22"
        },
        {
            "consequence": "remove_mask_or_hair",
            "contract_name": null,
            "description": "One superstar will be forced to either remove their mask or shave their hair!",
            "injury_rate": 1,
            "name": "Mask vs Hair",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-23"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "An object hangs off a pole, the goal being to claim it or use it. Can be a hit or a big miss!",
            "injury_rate": 1,
            "name": "Pole",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-24"
        }
    ];
}
function $3930923fc77c55ab$var$loadScenarioEditorMainPage(scenarioData) {
    let parent = $(".scenario-editor-container");
    // Unselect menu buttons
    $(".scenario-editor-menu-button.selected").removeClass("selected");
    // Add headers
    let scenarioNameHtml = $3930923fc77c55ab$var$getScenarioNameHtml(scenarioData);
    if (parent.find(".scenario-editor-first-header").html() !== scenarioNameHtml) parent.find(".scenario-editor-first-header").html(scenarioNameHtml).hide().fadeIn();
    parent.find(".scenario-editor-second-header").text("");
    // Show/hide menu buttons
    parent.find(".scenario-editor-main-menu-container").fadeIn();
    parent.find(".scenario-editor-companies-menu-container").hide();
    parent.find(".scenario-editor-company-menu-container, .scenario-editor-indies-menu-container").hide();
    // Get and show companies menu buttons
    let companiesMenuHtml = $3930923fc77c55ab$var$getScenarioEditorCompaniesMenuHtml(scenarioData);
    parent.find(".scenario-editor-companies-menu-container").html(companiesMenuHtml).fadeIn();
    parent.find(".scenario-editor-companies-menu-container").scrollTop(0);
    parent.find(".scenario-editor-companies-header").fadeIn();
    // Hide list container, show list buttons
    parent.find(".scenario-editor-list-container, .scenario-editor-list-menu-container").hide();
    parent.find(".scenario-editor-add-5-items-button").hide();
    parent.find(".scenario-editor-list-buttons-container").hide().fadeIn();
    parent.find(".search-companies-button").show();
    // Show/hide bottom buttons
    parent.find(".scenario-editor-publish-button").show();
    parent.find(".scenario-editor-back-button, .scenario-editor-main-menu-button").hide();
    // Reset scenario companies
    $(".scenario-companies-container").hide();
    $(".search-companies-button.selected").removeClass("selected");
    // Add empty text to Edit Details page
    parent.find(".scenario-editor-item-container").html('<div class="font-bold margin-left-5 light-grey margin-top-2">Select an item in the Editor to display its details here</div>');
    parent.find(".scenario-editor-item-buttons-container").hide();
    // Select scenario details button
    $('.scenario-editor-menu-button[data-value="scenario-details"]').trigger("click");
}
function $3930923fc77c55ab$var$getScenarioNameHtml(data) {
    if (data["scenario_details"]["scenario_type"] === "scenario") {
        let versionText = data["scenario_details"]["version"] ? "(Version {0})".format(data["scenario_details"]["version"]) : "";
        return '{0} <span class="grey margin-left-2">Scenario {1}</span>'.format((0, $1JSre.escapeHTML)(data["scenario_details"]["name"]), versionText);
    } else if (data["scenario_details"]["scenario_type"] === "scenario_edit") {
        let versionText = data["scenario_details"]["edit_version"] ? "(Version {0})".format(data["scenario_details"]["edit_version"]) : "";
        return '{0} <span class="grey margin-left-2">Scenario Edit {1}</span>'.format((0, $1JSre.escapeHTML)(data["scenario_details"]["name"]), versionText);
    }
}
function $3930923fc77c55ab$var$getScenarioEditorCompaniesMenuHtml(scenarioData) {
    let companiesMenuHtml = "";
    // Add companies
    scenarioData["companies"].forEach(function(companyData) {
        companiesMenuHtml += $3930923fc77c55ab$var$getScenarioEditorCompaniesMenuItemHtml(companyData);
    });
    // Add indies
    companiesMenuHtml += '<div class="scenario-editor-menu-button margin-bottom-2" data-indies="true">Indies</div>';
    return companiesMenuHtml;
}
function $3930923fc77c55ab$var$getScenarioEditorCompaniesMenuItemHtml(companyData) {
    return '<div class="scenario-editor-menu-button margin-bottom-10" data-uid="' + companyData["company_details"]["uid"] + '">' + (0, $1JSre.escapeHTML)(companyData["company_details"]["name"]) + "</div>";
}
function $3930923fc77c55ab$var$checkScenarioEditorItemValidation() {
    let validationFailedInput = $(".scenario-editor-item-container").find(".validation-failed");
    if (validationFailedInput.length > 0) {
        // Show notie if not present
        if ($(".notie-container").length <= 0) {
            let validationFailedMessage = validationFailedInput.attr("data-validation-message");
            notie.alert({
                type: 3,
                text: validationFailedMessage,
                stay: true
            });
        }
        return false;
    }
    return true;
}
function $3930923fc77c55ab$var$loadScenarioEditorObjectForEditing(object, itemType, companyData) {
    let scenarioEditorItemContainer = $(".scenario-editor-item-container");
    // Add data to editor
    scenarioEditorItemContainer.data("uid", object.uid);
    scenarioEditorItemContainer.data("itemType", itemType);
    // Add object inputs
    let scenarioEditorObjectInputsHtml = $3930923fc77c55ab$var$getScenarioEditorObjectInputsHtml(object, itemType, companyData);
    scenarioEditorItemContainer.html(scenarioEditorObjectInputsHtml);
    // Add input values
    $3930923fc77c55ab$var$addScenarioEditorObjectInputValues(object, itemType);
    // Show item buttons except for scenario details and events
    if ([
        "scenario-details",
        "events"
    ].indexOf(itemType) < 0) {
        $(".scenario-editor-item-buttons-container").show();
        $(".scenario-editor-move-item-company-select").hide();
        // Show randomize button
        if (itemType === "superstars") $(".scenario-editor-item-buttons-container").find(".scenario-editor-randomize-item-button").show();
        else $(".scenario-editor-item-buttons-container").find(".scenario-editor-randomize-item-button").hide();
        // Show move button
        if ([
            "superstars",
            "teams",
            "factions",
            "championships"
        ].indexOf(itemType) >= 0) $(".scenario-editor-item-buttons-container").find(".scenario-editor-move-item-button").show();
        else $(".scenario-editor-item-buttons-container").find(".scenario-editor-move-item-button").hide();
        // Show 'set primary' button
        if (itemType === "company-details") $(".scenario-editor-item-buttons-container").find(".scenario-editor-set-primary-company-button").show();
        else $(".scenario-editor-item-buttons-container").find(".scenario-editor-set-primary-company-button").hide();
    } else $(".scenario-editor-item-buttons-container").hide();
}
function $3930923fc77c55ab$var$addScenarioEditorObjectInputValues(object, itemType) {
    let scenarioEditorItemContainer = $(".scenario-editor-item-container");
    // Add input values based on itemType
    $(".scenario-editor-name-input").val(object.name.trim());
    if (itemType === "superstars") {
        $(".scenario-editor-age-input").val(object.age);
        $(".scenario-editor-popularity-input").val(object.popularity);
        $(".scenario-editor-pronoun-select").val(object.pronoun);
        $(".scenario-editor-charisma-select").val(object.charisma);
        $(".scenario-editor-workrate-select").val(object.workrate);
        $(".scenario-editor-alignment-select").val(object.alignment);
        $(".scenario-editor-overness-select").val(object.overness);
        $(".scenario-editor-status-select").val(object.status);
        $(".scenario-editor-full-time-manager-input").prop("checked", object.full_time_manager);
        $(".scenario-editor-hall-of-famer-input").prop("checked", object.hall_of_famer);
        // Add graphic
        let graphicCode = object.graphic;
        scenarioEditorItemContainer.data("graphicCode", graphicCode);
        if (graphicCode) {
            scenarioEditorItemContainer.find(".add-graphic-button").text("Edit Graphic");
            scenarioEditorItemContainer.find(".remove-scenario-editor-graphic-button").show();
        }
        // Add brand
        if (object.brand_name) $(".scenario-editor-brand-select").val(object.brand_name.trim());
        else $(".scenario-editor-brand-select").val("None");
        // Add gimmick
        if (object.gimmick && object.gimmick.name) {
            $(".scenario-editor-gimmick-name-input").val(object.gimmick.name);
            $(".scenario-editor-gimmick-effectiveness-select").val(object.gimmick.effectiveness);
            $(".scenario-editor-gimmick-input").prop("checked", true);
            $3930923fc77c55ab$var$toggleScenarioEditorItemInputsContainer($(".scenario-editor-gimmick-input"));
        }
        // Add injury months
        if (object.injured > 0) {
            $(".scenario-editor-injured-months-input").val(object.injured);
            $(".scenario-editor-injured-input").prop("checked", true);
            $3930923fc77c55ab$var$toggleScenarioEditorItemInputsContainer($(".scenario-editor-injured-input"));
        }
        // Add managed talent names
        if (object.managed_talent_names.length > 0) {
            object.managed_talent_names.forEach(function(objectManagedTalent, i) {
                if (i > 0) scenarioEditorItemContainer.find(".scenario-editor-add-managed-talent-button").trigger("click");
                $(".scenario-editor-managed-talent-select").eq(i).val(objectManagedTalent.trim());
            });
            $(".scenario-editor-manager-input").prop("checked", true);
            $3930923fc77c55ab$var$toggleScenarioEditorItemInputsContainer($(".scenario-editor-manager-input"));
        }
        // Add training and months to appear in
        if (object.training) {
            $(".scenario-editor-training-input").prop("checked", true);
            $3930923fc77c55ab$var$toggleScenarioEditorItemInputsContainer($(".scenario-editor-training-input"));
        }
        if (object.month_to_appear_in) {
            let futureSuperstarYear = Math.floor(object.month_to_appear_in / 12);
            let futureSuperstarMonth = object.month_to_appear_in % 12;
            $(".scenario-editor-year-input").val(futureSuperstarYear);
            $(".scenario-editor-month-input").val(futureSuperstarMonth);
            $(".scenario-editor-future-input").prop("checked", true);
            $3930923fc77c55ab$var$toggleScenarioEditorItemInputsContainer($(".scenario-editor-future-input"));
        }
        // Add traits
        let traitElements = scenarioEditorItemContainer.find(".superstar-trait-item-container").filter(function(i, e) {
            return object.traits.indexOf($(e).text().trim().replace(/\s+/g, " ")) >= 0;
        });
        traitElements.each(function(i, traitElement) {
            (0, $d3e44747ec383890$export$f81d542126046733)($(traitElement));
        });
    } else if (itemType === "teams") {
        $(".scenario-editor-team-type-select").val(object.team_type);
        $3930923fc77c55ab$var$toggleScenarioEditorTeamTypeInput($(".scenario-editor-team-type-select"));
        object.superstars.forEach(function(objectSuperstar, i) {
            if (i === 0) $(".scenario-editor-first-superstar-select").val(objectSuperstar.trim());
            else if (i === 1) $(".scenario-editor-second-superstar-select").val(objectSuperstar.trim());
            else if (i === 2) $(".scenario-editor-third-superstar-select").val(objectSuperstar.trim());
        });
    } else if (itemType === "factions") {
        $(".scenario-editor-reputation-input").val(object.reputation);
        object.superstars.forEach(function(factionMember, i) {
            if (i > 1) scenarioEditorItemContainer.find(".scenario-editor-add-faction-member-button").trigger("click");
            $(".scenario-editor-faction-member-select").eq(i).val(factionMember.trim());
        });
        $3930923fc77c55ab$var$updateScenarioEditorFactionLeaderSelect();
        if (object.leader_superstar) $(".scenario-editor-faction-leader-select").val(object.leader_superstar.trim());
        else $(".scenario-editor-faction-leader-select").val("None");
    } else if (itemType === "championships") {
        if (object.champion) $(".scenario-editor-champion-select").val(object.champion.trim());
        else $(".scenario-editor-champion-select").val("None");
        $(".scenario-editor-division-select").val(object.division);
        $(".scenario-editor-prestige-select").val(object.prestige);
        $(".scenario-editor-rank-select").val(object.rank);
        // Add graphic
        let graphicCode = object.graphic;
        scenarioEditorItemContainer.data("graphicCode", graphicCode);
        if (graphicCode) {
            scenarioEditorItemContainer.find(".add-graphic-button").text("Edit Graphic");
            scenarioEditorItemContainer.find(".remove-scenario-editor-graphic-button").show();
        }
        if (object.brand_name) $(".scenario-editor-brand-select").val(object.brand_name.trim());
        else $(".scenario-editor-brand-select").val("None");
    } else if (itemType === "events") {
        $(".scenario-editor-prestige-select").val(object.prestige);
        $(".scenario-editor-weekly-show-before-event-input").val(object.weekly_show_before_name);
        $(".scenario-editor-weekly-show-after-event-input").val(object.weekly_show_after_name);
        if (object.brand_name) $(".scenario-editor-brand-select").val(object.brand_name.trim());
        else $(".scenario-editor-brand-select").val("None");
    } else if (itemType === "gimmick-matches") {
        $(".scenario-editor-rules-select").val(object.rules);
        $(".scenario-editor-rating-select").val(object.rating_boost);
        $(".scenario-editor-injury-rate-select").val(object.injury_rate);
        $(".scenario-editor-consequence-select").val(object.consequence);
        $3930923fc77c55ab$var$toggleScenarioEditorConsequenceInput($(".scenario-editor-consequence-select"));
        $(".scenario-editor-contract-name-input").val(object.contract_name);
        $(".scenario-editor-description-input").val(object.description);
        $(".scenario-editor-graphic-type-select").val(object.graphic_type);
        $(".scenario-editor-add-random-weapons-input").prop("checked", object.add_random_weapons);
    } else if (itemType === "brands") {
        $(".scenario-editor-weekly-show-name-input").val(object.weekly_show_name);
        $(".scenario-editor-overness-select").val(object.overness);
        $(".scenario-editor-exclusive-weekly-show-input").prop("checked", object.weekly_show_is_exclusive);
        // Set color input
        $(".scenario-editor-color-input").spectrum({
            preferredFormat: "hex",
            allowEmpty: true,
            showInitial: true,
            showInput: true,
            showButtons: false
        });
        // Set color, preview
        if (object.color) {
            $(".scenario-editor-color-preview").css("color", object.color);
            $(".scenario-editor-color-input").val(object.color);
            $(".scenario-editor-color-input").spectrum("set", object.color);
        }
    } else if (itemType === "streaks") {
        $(".scenario-editor-event-select").val(object.event.trim());
        $(".scenario-editor-talent-select").val(object.talent.trim());
        $(".scenario-editor-length-input").val(object.length);
    } else if (itemType === "match-contracts") {
        $(".scenario-editor-event-select").val(object.event.trim());
        $(".scenario-editor-talent-select").val(object.talent.trim());
    } else if (itemType === "company-details") {
        $(".scenario-editor-reputation-input").val(object.reputation);
        $(".scenario-editor-style-select").val(object.style);
        $(".scenario-editor-creative-points-input").val(object.creative_points);
        $(".scenario-editor-owner-name-input").val(object.owner_name);
        $(".scenario-editor-weekly-show-name-input").val(object.weekly_show_name);
        $(".scenario-editor-top-event-select").val(object.top_event.trim());
        $(".scenario-editor-overness-select").val(object.overness);
    } else if (itemType === "scenario-details") {
        $(".scenario-editor-description-input").val(object.description);
        if (object.market_size) $(".scenario-editor-market-size-select").val(object.market_size);
        $(".scenario-editor-comments-input").val(object.comments);
        $(".scenario-editor-starting-year-input").val(object.starting_year);
        $(".scenario-editor-starting-event-select").val(object.starting_event.trim());
        $(".scenario-editor-private-input").prop("checked", object.private);
        $(".scenario-editor-allow-edits-input").prop("checked", object.allow_edits);
        $(".scenario-editor-allow-sharing-input").prop("checked", object.allow_sharing);
    }
}
function $3930923fc77c55ab$var$getScenarioEditorObjectInputsHtml(object, itemType, companyData) {
    let inputsHtml;
    if (itemType === "superstars") {
        // Training checkbox
        let trainingInput = "";
        let trainingContainerClass = " display-none";
        let indies = $(".scenario-editor-container").data("indies");
        if (!indies) trainingInput = '        <label class="control control--checkbox">            Training            <input type="checkbox" class="scenario-editor-training-input" tabindex="15" data-attribute="training"/>            <div class="control__indicator"></div>        </label>';
        else trainingContainerClass = "";
        let brandOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("brands", companyData);
        let talentOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("talent", companyData);
        inputsHtml = '<div class="column-left">    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Age</div>        <input type="number" class="styled-input scenario-editor-age-input"               data-attribute="age" tabindex="3" min="10" max="100">    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Charisma</div>        <select class="styled-select scenario-editor-charisma-select" tabindex="5"                 data-attribute="charisma">            <option value="1" selected>1</option>            <option value="2">2</option>            <option value="3">3</option>        </select>    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Alignment</div>        <select class="styled-select scenario-editor-alignment-select" tabindex="7"                 data-attribute="alignment">            <option value="" selected>Neutral</option>            <option value="face">Face</option>            <option value="heel">Heel</option>        </select>    </div>    <div class="margin-bottom-20">        <div class="display-block margin-bottom-2">Status</div>        <select class="styled-select scenario-editor-status-select" tabindex="9"                 data-attribute="status">            <option value="active">Active</option>            <option value="part-timer">Part-timer</option>            <option value="retired">Retired</option>        </select>    </div>    <div class="margin-bottom-12">        <label class="control control--checkbox">            Gimmick            <input type="checkbox" class="scenario-editor-gimmick-input" tabindex="11" data-attribute="gimmick"/>            <div class="control__indicator"></div>        </label>        <div class="superstar-gimmick-container display-none margin-top-5">            <div class="margin-bottom-8">                <div class="display-block margin-bottom-2">Name</div>                <input type="text" class="styled-input scenario-editor-gimmick-name-input"                         data-attribute="gimmick">            </div>            <div class="margin-bottom-20">                <div class="display-block margin-bottom-2">Effectiveness</div>                <select class="styled-select scenario-editor-gimmick-effectiveness-select"                         data-attribute="gimmick">                    <option>Mark Out!</option>                    <option>Good</option>                    <option selected>Average</option>                    <option>Not Good</option>                    <option>Bad</option>                </select>            </div>        </div>    </div>    <div class="margin-bottom-12">        <label class="control control--checkbox">            Managed Talent            <input type="checkbox" class="scenario-editor-manager-input" tabindex="13" data-attribute="managed_talent_names"/>            <div class="control__indicator"></div>        </label>        <div class="superstar-manager-container display-none margin-top-3">            <div class="margin-bottom-20">                <div class="display-block margin-bottom-2">Talent</div>                <div class="margin-bottom-8">                    <select class="styled-select margin-top-2 scenario-editor-managed-talent-select"                            tabindex="3" data-attribute="managed_talent_names">' + talentOptions + "                    </select>" + "                </div>" + "                <div>" + '                    <button type="button"' + '                            class="scenario-editor-add-managed-talent-button button retro-button styled-select-button">' + '                        <i class="fa fa-plus"></i>' + "                    </button>" + "                </div>" + "            </div>" + "        </div>" + "    </div>" + '    <div class="margin-bottom-12">' + '        <label class="control control--checkbox help-text"' + '               title="Full-time managers are not usable in matches. They provide a boost to talent when appearing alongside them in segments.">' + "            Full-time Manager" + '            <input type="checkbox" class="styled-input scenario-editor-full-time-manager-input" ' + '                   data-attribute="full_time_manager"/>' + '            <div class="control__indicator"></div>' + "        </label>" + "    </div>" + "</div>" + '<div class="column-right">' + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Popularity</div>' + '        <input type="number" class="styled-input scenario-editor-popularity-input help-text"' + '               data-attribute="popularity" tabindex="2" min="0" max="1050" title="Main Eventer: 800+, Upper Midcarder: 600-799, Lower Midcarder: 400-599, Jabroni: 0-399">' + "    </div>" + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Pronoun</div>' + '        <select class="styled-select scenario-editor-pronoun-select margin-top-2" tabindex="4" ' + '                data-attribute="pronoun">' + '            <option value="he" selected>He</option>' + '            <option value="she">She</option>' + '            <option value="they">They</option>' + "        </select>" + "    </div>" + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">' + "            Workrate" + "        </div>" + '        <select class="styled-select scenario-editor-workrate-select" tabindex="6" data-attribute="workrate">' + '            <option value="1" selected>1</option>' + '            <option value="2">2</option>' + '            <option value="3">3</option>' + "        </select>" + "    </div>" + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Overness</div>' + '        <select class="styled-select scenario-editor-overness-select" tabindex="8" data-attribute="overness">' + "            <option>Over</option>" + "            <option>Popular</option>" + "            <option selected>Average</option>" + "            <option>Not Popular</option>" + "            <option>Stale</option>" + "        </select>" + "    </div>" + '    <div class="margin-bottom-20">' + '        <div class="display-block margin-bottom-2">Brand</div>' + '        <select class="styled-select scenario-editor-brand-select" tabindex="10" data-attribute="brand_name">' + brandOptions + "        </select>" + "    </div>" + '    <div class="margin-bottom-12">' + '        <label class="control control--checkbox">' + '            <div class="display-block margin-bottom-2">Injured</div>' + '            <input type="checkbox" class="scenario-editor-injured-input" tabindex="12" data-attribute="injured"/>' + '            <div class="control__indicator"></div>' + "        </label>" + '        <div class="display-block superstar-injured-months-container display-none margin-top-3">' + '            <div class="margin-bottom-20">' + '                <div class="display-block margin-bottom-2">Months</div>' + '                <input type="number" class="styled-input scenario-editor-injured-months-input" min="1" max="120" ' + '                   data-attribute="injured">' + "            </div>" + "        </div>" + "    </div>" + '    <div class="margin-bottom-12">' + trainingInput + '        <div class="superstar-future-container' + trainingContainerClass + '">' + '            <label class="control control--checkbox help-text"' + '                   title="Set this superstar to appear at a specified time after the game starts. They will appear at the age you set for them.">' + "                Future" + '                <input type="checkbox" class="styled-input scenario-editor-future-input" data-attribute="month_to_appear_in"/>' + '                <div class="control__indicator"></div>' + "            </label>" + '            <div class="superstar-future-inputs-container margin-top-6 display-none">' + '               <div class="scenario-editor-year-container">' + '                   <div class="display-block margin-bottom-2">Year</div>' + '                   <input type="number" class="styled-input scenario-editor-year-input" ' + '                          data-attribute="month_to_appear_in" min="0" max="200">' + "               </div>" + '               <div class="scenario-editor-month-container">' + '                   <div class="display-block margin-bottom-2">Month</div>' + '                   <input type="number" class="styled-input scenario-editor-month-input" ' + '                          data-attribute="month_to_appear_in" min="0" max="11">' + "               </div>" + '               <div class="clear"></div>' + "            </div>" + "        </div>" + "    </div>" + "    <div>" + '        <label class="control control--checkbox">' + "            Hall of Famer" + '            <input type="checkbox" class="scenario-editor-hall-of-famer-input" tabindex="14" ' + '                   data-attribute="hall_of_famer"/>' + '            <div class="control__indicator"></div>' + "        </label>" + "    </div>" + "</div>" + '<div class="clear"></div>' + '<div class="superstar-traits-selection-container margin-top-5">' + '    <div class="display-block">' + "        Traits" + "    </div>" + '    <div class="superstar-traits-selection-text font-1p125em line-height-24px light-grey">' + "        None" + "    </div>" + '    <input type="hidden" class="superstar-traits-selection-input" data-attribute="traits"/>' + '    <div class="superstar-traits-show-button margin-top-7">' + "        <span>Show Traits</span>" + '        <i class="fa fa-angle-down margin-left-3 font-14px"></i>' + "    </div>" + '    <div class="superstar-traits-information line-height-1p4 margin-top-3 light-grey display-none font-1p125em">' + "        Select a trait to display its details here" + "    </div>" + "</div>" + '<div class="superstar-trait-items-container margin-top-15 display-none">' + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Matches</span>' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Dull Worker">Ring General' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Ring General">Dull Worker' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">' + "            Workhorse" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Big Stage Wreck">Big Match Specialist' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Big Match Specialist,Weekly Sloth">Big Stage Wreck' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Big Stage Wreck">Weekly Sloth' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Hates Gimmick Matches">Enjoys Gimmick Matches' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Enjoys Gimmick Matches">Hates Gimmick Matches' + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Segments</span>' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">' + "            Entertainer" + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="Humorless">' + "            Comedy Chops" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Comedy Chops">Humorless' + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Feuds</span>' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Neglects Story">Storyteller' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Storyteller">Neglects Story' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="Bad Actor">' + "            Good Actor" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Good Actor">Bad Actor' + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Overness/Alignment</span>' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Naturally Stale">Natural Charisma' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Natural Charisma">Naturally Stale' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Natural Heel">Natural Babyface' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Natural Babyface">Natural Heel' + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Progress</span>' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Slow Learner,Loves Training,Hates Training,Self Learner,Lacks Self Learning">' + "            Quick Learner" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Quick Learner,Loves Training,Hates Training,Self Learner,Lacks Self Learning">' + "            Slow Learner" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Hates Training,Quick Learner,Slow Learner">Loves' + "            Training" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Loves Training,Quick Learner,Slow Learner">Hates' + "            Training" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Lacks Self Learning,Quick Learner,Slow Learner">' + "            Self Learner" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Self Learner,Quick Learner,Slow Learner">Lacks' + "            Self Learning" + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Career</span>' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Lifelong Wrestler,Other Interests">Dedicated' + "            Wrestler" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Dedicated Wrestler,Other Interests">Lifelong' + "            Wrestler" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Dedicated Wrestler,Lifelong Wrestler">Other' + "            Interests" + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Morale</span>' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Hard To Please,Rebel,Loyal,Extreme Emotions">Easy' + "            To Please" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Easy To Please,Rebel,Loyal,Extreme Emotions">Hard' + "            To Please" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Rebel,Easy To Please,Hard To Please,Extreme Emotions">' + "            Loyal" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Loyal,Easy To Please,Hard To Please,Extreme Emotions">' + "            Rebel" + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Easy To Please,Hard To Please,Rebel,Loyal">Extreme' + "            Emotions" + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Giving' + "            Veteran" + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Star' + "            Maker" + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Spotlight' + "            Lover" + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Holy Shit Moments</span>' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Risk Averse">Risk Taker' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Risk Taker,Gifted Acrobat">Risk Averse' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Risk Averse">Gifted Acrobat' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Stiff' + "            Worker" + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Injuries</span>' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Injury Prone">Injury Resilient' + "        </div>" + '        <div class="superstar-trait-item-container"' + '             data-conflicting-traits="Injury Resilient">Injury Prone' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Dangerous' + "            Worker" + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Gimmicks</span>' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Character' + "            Worker" + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Lore' + "            Master" + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Redeems' + "            Bad Gimmicks" + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Backstage</span>' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Leader' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">' + "            Troublemaker" + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Drug' + "            Habit" + "        </div>" + "    </div>" + '    <div class="margin-bottom-5">' + '        <div class="display-block margin-bottom-5 font-1p125em">' + '            <span class="light-grey margin-left-3">Misc</span>' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Bleeder' + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Tag Team' + "            Specialist" + "        </div>" + '        <div class="superstar-trait-item-container" data-conflicting-traits="">Ages' + "            Well" + "        </div>" + "    </div>" + "</div>" + '<button type="button" class="button retro-button grey-button-background condensed remove-outline' + '                                add-scenario-editor-superstar-graphic add-graphic-button margin-top-15 margin-right-5 no-margin-bottom">Add Graphic' + "</button>" + '<button type="button" class="button retro-button grey-button-background condensed remove-outline' + '                                remove-scenario-editor-graphic-button display-none margin-top-15 no-margin-bottom">Remove Graphic' + "</button>" + '<input type="hidden" class="scenario-editor-graphic-input" data-attribute="graphic"/>' + '<div class="character-creator display-none">' + '    <div class="margin-top-10 margin-bottom-15 superstar-graphic"></div>' + '    <div class="character-creator-controls">' + "        <div>" + '            <div class="margin-bottom-10 select-part">' + '                <div class="margin-bottom-8">' + '                    <div class="margin-bottom-2">Attire</div>' + '                    <button type="button" class="button retro-button grey-button-background' + '                                                    condensed remove-outline attire-select-button no-select selected">A' + "                    </button>" + '                    <button type="button" class="button retro-button grey-button-background' + '                                                    condensed remove-outline attire-select-button no-select">B' + "                    </button>" + '                    <button type="button" class="button retro-button grey-button-background' + '                                                    condensed remove-outline attire-select-button no-select">C' + "                    </button>" + "                </div>" + "                <div>" + '                    <button type="button" class="button retro-button red-button-background' + '                                                    condensed remove-outline remove-attire-button no-select">Remove' + "                        Attire" + "                    </button>" + "                </div>" + '                <div class="margin-bottom-5">' + '                    <button type="button" class="button retro-button orange-button-background' + '                                                    condensed remove-outline preset-1 no-select">' + "                        Preset 1" + "                    </button>" + '                    <button type="button" class="button retro-button orange-button-background' + '                                                    condensed remove-outline preset-2 no-select">' + "                        Preset 2" + "                    </button>" + "                </div>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline margin-bottom-1">Body' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Eyes' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Hair' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Facial Hair' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Torso' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline margin-bottom-1">Bottoms' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Shoes' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Elbow' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Knee' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Accessory' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Tattoo' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Facepaint' + "                </button>" + '                <div class="font-bold select-accessory-number margin-top-5">' + "                </div>" + '                <div class="font-bold select-sub-category margin-top-10">' + "                </div>" + "            </div>" + '            <div class="font-bold part-controls margin-bottom-20">' + '                <div class="margin-bottom-5 display-inline-block margin-right-15">' + '                    <span class="margin-right-5 light-grey">Style</span>' + '                    <i class="fa fa-angle-double-left select-previous cursor-pointer"></i>' + '                    <span class="selection-number font-1p125em text-center">1</span>' + '                    <i class="fa fa-angle-double-right select-next cursor-pointer"></i>' + "                </div>" + '                <div class="display-inline-block">' + '                    <span class="margin-right-5 light-grey">Color</span>' + '                    <input type="text" class="spectrum"/>' + "                </div>" + '                <div class="select-design-holder">' + '                    <div class="select-design">' + '                        <button type="button"' + '                                class="button retro-button micro grey-button-background remove-outline display-none">' + "                            1" + "                        </button>" + '                        <button type="button"' + '                                class="button retro-button micro grey-button-background remove-outline display-none">' + "                            2" + "                        </button>" + '                        <button type="button"' + '                                class="button retro-button micro grey-button-background remove-outline display-none">' + "                            3" + "                        </button>" + '                        <button type="button"' + '                                class="button retro-button micro grey-button-background remove-outline display-none">' + "                            4" + "                        </button>" + "                    </div>" + "                </div>" + "            </div>" + '            <div class="character-creator-menu">' + '                <button type="button"' + '                        class="button retro-button condensed grey-button-background remove-outline share-character no-margin-bottom">' + "                    Share" + "                </button>" + '                <button type="button"' + '                        class="button retro-button condensed grey-button-background remove-outline import-character no-margin-bottom">' + "                    Import" + "                </button>" + '                <button type="button"' + '                        class="button retro-button condensed grey-button-background remove-outline randomize-character no-margin-bottom">' + "                    Randomize" + "                </button>" + '                <button type="button"' + '                        class="button retro-button condensed grey-button-background remove-outline search-graphics no-margin-bottom">' + "                    Search" + "                </button>" + "            </div>" + '            <div class="display-none load-character-code-container">' + '                <input type="text"' + '                       class="character-code-input load-character-code-input styled-input"' + '                       placeholder="Add Character Code">' + '                <button type="button" class="button retro-button grey-button-background remove-outline margin-top-10' + '                                                condensed load-character-code-button margin-left-1">Load' + "                </button>" + "            </div>" + '            <div class="display-none share-character-code-container">' + '                <input name="superstar-code" type="text"' + '                       class="character-code-input share-character-code-input styled-input">' + '                <button type="button" class="button retro-button grey-button-background remove-outline margin-top-10' + '                                                condensed copy-character-code margin-left-1">Copy' + "                </button>" + "            </div>" + '            <div class="display-none randomize-character-container">' + '                <button type="button"' + '                        class="button retro-button grey-button-background condensed remove-outline margin-top-10' + '                                            randomize-character-button">Masculine' + "                </button>" + '                <button type="button"' + '                        class="button retro-button grey-button-background condensed remove-outline margin-top-10' + '                                            randomize-character-button">Feminine' + "                </button>" + '                <button type="button"' + '                        class="button retro-button grey-button-background condensed remove-outline margin-top-10' + '                                            randomize-character-button">Any' + "                </button>" + '                <button type="button"' + '                        class="button retro-button grey-button-background condensed remove-outline margin-top-10' + '                                            randomize-character-button">Clothes' + "                </button>" + "            </div>" + '            <div class="graphics-search-container font-bold display-none">' + "                <div>" + '                    <input type="text" name="graphics-search-input-name"' + '                           class="styled-input graphics-search-input-name"' + '                           placeholder="Name"' + '                           autocomplete="off">' + '                    <button type="button" class="button retro-button remove-outline margin-top-10 graphics-search-button' + '                                                    condensed grey-button-background margin-left-1">Search' + "                    </button>" + "                </div>" + '                <div class="graphics-search-results display-none text-left margin-top-10">' + '                    <div class="graphics-search-results-number light-grey margin-left-2' + '                                                    display-inline-block"></div>' + '                    <div class="graphics-search-sort-buttons float-right">' + '                        <button type="button" class="button retro-button condensed light-button-background' + '                                                        graphics-search-sort-results-button selected">Best' + "                        </button>" + '                        <button type="button" class="button retro-button condensed light-button-background' + '                                                        graphics-search-sort-results-button">New' + "                        </button>" + "                    </div>" + '                    <div class="graphics-search-results-container inner-box display-none' + '                                                    margin-top-5 compact"></div>' + '                    <div class="graphics-pagination-buttons margin-top-10 display-none">' + '                        <div class="column-left">' + '                            <button type="button" class="button retro-button condensed light-button-background' + '                                                            graphics-previous-page-button">' + "                                Prev" + "                            </button>" + "                        </div>" + '                        <div class="column-right text-right">' + '                            <button type="button" class="button retro-button condensed light-button-background' + '                                                             graphics-next-page-button">' + "                                Next" + "                            </button>" + "                        </div>" + '                        <div class="clear"></div>' + "                    </div>" + "                </div>" + "            </div>" + "        </div>" + "    </div>" + "</div>";
    } else if (itemType === "teams") {
        let superstarOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("current-superstars", companyData, false);
        inputsHtml = '<div class="column-left">    <div class="margin-bottom-15">        <div class="display-block margin-bottom-2">Team Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>    <div>        <div class="display-block margin-bottom-2">First Superstar</div>        <select class="styled-select margin-top-2 scenario-editor-first-superstar-select" tabindex="3"                 data-attribute="superstars">' + superstarOptions + "        </select>" + "    </div>" + '    <div class="display-none margin-top-15">' + '        <div class="display-block margin-bottom-2">Third Superstar</div>' + '        <select class="styled-select margin-top-2 scenario-editor-third-superstar-select" tabindex="5" ' + '                data-attribute="superstars">' + superstarOptions + "        </select>" + "    </div>" + "</div>" + '<div class="column-right">' + '    <div class="margin-bottom-15">' + '        <div class="display-block margin-bottom-2">Team Type</div>' + '        <select class="styled-select margin-top-2 scenario-editor-team-type-select" tabindex="2" ' + '                data-attribute="team_type">' + '            <option value="tag-team" selected>Tag Team</option>' + '            <option value="trio">Trio</option>' + "        </select>" + "    </div>" + "    <div>" + '        <div class="display-block margin-bottom-2">Second Superstar</div>' + '        <select class="styled-select margin-top-2 scenario-editor-second-superstar-select" tabindex="3" ' + '                data-attribute="superstars">' + superstarOptions + "        </select>" + "    </div>" + "</div>" + '<div class="clear"></div>';
    } else if (itemType === "factions") {
        let memberOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("current-superstars", companyData);
        inputsHtml = '<div class="column-left">    <div class="margin-bottom-15">        <div class="display-block margin-bottom-2">Faction Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>    <div class="margin-bottom-8">        <div class="display-block margin-bottom-2">Members</div>        <select class="styled-select margin-top-2 scenario-editor-faction-member-select"                tabindex="3" data-attribute="superstars">' + memberOptions + "        </select>" + "    </div>" + '    <div class="margin-bottom-8">' + '        <select class="styled-select margin-top-2 scenario-editor-faction-member-select"' + '                tabindex="3" data-attribute="superstars">' + memberOptions + "        </select>" + "    </div>" + "    <div>" + '        <button type="button"' + '                class="scenario-editor-add-faction-member-button button retro-button styled-select-button">' + '            <i class="fa fa-plus"></i>' + "        </button>" + "    </div>" + "</div>" + '<div class="column-right">' + '    <div class="margin-bottom-15">' + '        <div class="display-block margin-bottom-2">Reputation</div>' + '        <input type="number" class="styled-input scenario-editor-reputation-input" tabindex="2" ' + '               data-attribute="reputation" min="1" max="10">' + "    </div>" + "    <div>" + '        <div class="display-block margin-bottom-2">Leader</div>' + '        <select class="styled-select margin-top-2 scenario-editor-faction-leader-select"' + '                tabindex="4" data-attribute="leader_superstar">' + "        </select>" + "    </div>" + "</div>" + '<div class="clear"></div>';
    } else if (itemType === "events") {
        let brandOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("brands", companyData);
        inputsHtml = '<div class="column-left">    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Event Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Weekly Show Before Event</div>        <input type="text" class="styled-input scenario-editor-weekly-show-before-event-input help-text"                title="Optional: Enter a custom name for the weekly show before this event" tabindex="3"                data-attribute="weekly_show_before_name">    </div>    <div>        <div class="display-block margin-bottom-2">Brand</div>        <select class="styled-select margin-top-2 scenario-editor-brand-select" tabindex="5"                 data-attribute="brand_name">' + brandOptions + "        </select>" + "    </div>" + "</div>" + '<div class="column-right">' + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Prestige</div>' + '        <select class="styled-select margin-top-2 scenario-editor-prestige-select" tabindex="2" ' + '                data-attribute="prestige">' + "            <option>A</option>" + "            <option>B</option>" + "            <option selected>C</option>" + "        </select>" + "    </div>" + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Weekly Show After Event</div>' + '        <input type="text" class="styled-input scenario-editor-weekly-show-after-event-input help-text" ' + '               title="Optional: Enter a custom name for the weekly show after this event" tabindex="4" ' + '               data-attribute="weekly_show_after_name">' + "    </div>" + "</div>" + '<div class="clear"></div>';
    } else if (itemType === "championships") {
        // Get champion options based on championship division
        let championOptions;
        if (object.division === "tag-team") championOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("teams", companyData);
        else if (object.division === "trio") championOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("trios", companyData);
        else championOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("main-roster-current-superstars", companyData);
        let brandOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("brands", companyData);
        inputsHtml = '<div class="column-left">    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Championship Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Champion</div>        <select class="styled-select margin-top-2 scenario-editor-champion-select" tabindex="3"                 data-attribute="champion">' + championOptions + "        </select>" + "    </div>" + "    <div>" + '        <div class="display-block margin-bottom-2">Rank</div>' + '        <select class="styled-select margin-top-2 scenario-editor-rank-select" tabindex="5" ' + '                data-attribute="rank">' + '            <option value="Main Eventer" selected>Main Event</option>' + '            <option value="Upper Midcarder">Upper Midcard</option>' + '            <option value="Lower Midcarder">Lower Midcard</option>' + '            <option value="Jabroni">Jabroni</option>' + "        </select>" + "    </div>" + "</div>" + '<div class="column-right">' + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Division</div>' + '        <select class="styled-select margin-top-2 scenario-editor-division-select" tabindex="2" ' + '                data-attribute="division">' + '            <option value="singles" selected>Singles</option>' + '            <option value="tag-team">Tag Team</option>' + '            <option value="trio">Trios</option>' + "        </select>" + "    </div>" + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Prestige</div>' + '        <select class="styled-select margin-top-2 scenario-editor-prestige-select" tabindex="4" ' + '                data-attribute="prestige">' + '            <option value="A">Gold</option>' + '            <option value="B">Silver</option>' + '            <option value="C" selected>Bronze</option>' + "        </select>" + "    </div>" + "    <div>" + '        <div class="display-block margin-bottom-2">Brand</div>' + '        <select class="styled-select margin-top-2 scenario-editor-brand-select" tabindex="6" ' + '                data-attribute="brand_name">' + brandOptions + "        </select>" + "    </div>" + "</div>" + '<div class="clear"></div>' + '<button type="button" class="button retro-button grey-button-background condensed remove-outline' + '                                add-scenario-editor-championship-graphic add-graphic-button margin-top-20 margin-right-5 no-margin-bottom">Add Graphic' + "</button>" + '<button type="button" class="button retro-button grey-button-background condensed remove-outline' + '                                remove-scenario-editor-graphic-button display-none margin-top-20 no-margin-bottom">Remove Graphic' + "</button>" + '<input type="hidden" class="scenario-editor-graphic-input" data-attribute="graphic"/>' + '<div class="character-creator display-none">' + '    <div class="margin-top-10 margin-bottom-15 superstar-graphic"></div>' + '    <div class="character-creator-controls">' + "        <div>" + '            <div class="margin-bottom-10 select-part">' + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Center Plate' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Strap' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Side Plates' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Center Gems' + "                </button>" + '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' + '                                                remove-outline">Side Gems' + "                </button>" + "            </div>" + '            <div class="font-bold part-controls margin-bottom-20">' + '                <div class="margin-bottom-5 display-inline-block margin-right-15">' + '                    <span class="margin-right-5 light-grey">Style</span>' + '                    <i class="fa fa-angle-double-left select-previous cursor-pointer"></i>' + '                    <span class="selection-number font-1p125em text-center">1</span>' + '                    <i class="fa fa-angle-double-right select-next cursor-pointer"></i>' + "                </div>" + '                <div class="display-inline-block">' + '                    <span class="margin-right-5 light-grey">Color</span>' + "                    <input type='text' class=\"spectrum\"/>" + "                </div>" + '                <div class="select-design-holder">' + '                    <div class="select-design">' + '                        <button type="button"' + '                                class="button retro-button micro grey-button-background remove-outline display-none">' + "                            1" + "                        </button>" + '                        <button type="button"' + '                                class="button retro-button micro grey-button-background remove-outline display-none">' + "                            2" + "                        </button>" + '                        <button type="button"' + '                                class="button retro-button micro grey-button-background remove-outline display-none">' + "                            3" + "                        </button>" + '                        <button type="button"' + '                                class="button retro-button micro grey-button-background remove-outline display-none">' + "                            4" + "                        </button>" + "                    </div>" + "                </div>" + "            </div>" + '            <div class="character-creator-menu">' + '                <button type="button"' + '                        class="button retro-button condensed grey-button-background remove-outline share-character no-margin-bottom">' + "                    Share" + "                </button>" + '                <button type="button"' + '                        class="button retro-button condensed grey-button-background remove-outline import-character no-margin-bottom">' + "                    Import" + "                </button>" + '                <button type="button"' + '                        class="button retro-button condensed grey-button-background remove-outline randomize-character no-margin-bottom">' + "                    Randomize" + "                </button>" + "            </div>" + '            <div class="display-none load-character-code-container">' + '                <input type="text"' + '                       class="character-code-input load-character-code-input styled-input"' + '                       placeholder="Add Character Code">' + '                <button type="button" class="button retro-button grey-button-background remove-outline margin-top-10' + '                                                condensed load-character-code-button">Load' + "                </button>" + "            </div>" + '            <div class="display-none share-character-code-container">' + '                <input name="superstar-code" type="text"' + '                       class="character-code-input share-character-code-input styled-input">' + '                <button type="button" class="button retro-button grey-button-background remove-outline margin-top-10' + '                                                condensed copy-character-code">Copy' + "                </button>" + "            </div>" + "        </div>" + "    </div>" + "</div>";
    } else if (itemType === "gimmick-matches") inputsHtml = '<div class="column-left">    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Match Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Rating</div>        <select class="styled-select margin-top-2 scenario-editor-rating-select" tabindex="3"                 data-attribute="rating_boost">            <option value="1">Low</option>            <option value="2" selected>Med</option>            <option value="3">High</option>            <option value="4">Highest</option>        </select>    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Consequence</div>        <select class="styled-select margin-top-2 scenario-editor-consequence-select help-text"                tabindex="5" title="Championship contract: Awards a championship contract to the winner that can be cashed in anytime for a championship match.                                    Match Contract: Awards a contract for a match to the winner that can be used at a fixed event."                 data-attribute="consequence">            <option value="" selected>None</option>            <option value="championship_contract">Championship Contract</option>            <option value="match_contract">Fixed Match Contract</option>            <option value="loser_unavailable">Loser Unavailable</option>            <option value="random_opponent">Random Opponent</option>            <option value="remove_hair">Remove Hair</option>            <option value="remove_mask">Remove Mask</option>            <option value="remove_mask_or_hair">Remove Mask or Hair</option>            <option value="add_hair">Add Hair</option>        </select>    </div>    <div class="margin-top-12 margin-bottom-12 scenario-editor-contract-name-container display-none">        <div class="display-block margin-bottom-2">Contract Name</div>        <input type="text" class="styled-input scenario-editor-contract-name-input" tabindex="6"                 data-attribute="contract_name">    </div>    <div class="margin-bottom-15">        <div class="display-block margin-bottom-2">Graphic Type</div>        <select class="styled-select margin-top-2 scenario-editor-graphic-type-select help-text"                tabindex="7" data-attribute="graphic_type" title="A unique graphic will be displayed for this gimmick match. (Early Access)">            <option value="" selected>None</option>            <option value="ladder">Ladder (Any)</option>            <option value="ladder_black">Ladder (Black)</option>            <option value="ladder_grey">Ladder (Grey)</option>            <option value="ladder_orange">Ladder (Orange)</option>            <option value="cage_grey">Cage (Grey)</option>            <option value="cage_red">Cage (Red)</option>            <option value="cage_retro_blue">Cage (Retro Blue)</option>            <option value="cage_retro_black">Cage (Retro Black)</option>            <option value="table">Tables</option>            <option value="chair">Chairs</option>            <option value="tables_ladders_chairs">Tables Ladders & Chairs</option>            <option value="ambulance">Ambulance</option>            <option value="barbed_wire_ropes">Barbed Wire Ropes</option>            <option value="casket">Casket</option>            <option value="grave">Grave</option>            <option value="parking_lot">Parking Lot</option>        </select>    </div>    <div>        <label class="control control--checkbox help-text" title="Participants will hold random weapons in this gimmick match. (Early Access)">            Add Random Weapons            <input type="checkbox" class="scenario-editor-add-random-weapons-input" tabindex="8"                    data-attribute="add_random_weapons"/>            <div class="control__indicator"></div>        </label>    </div></div><div class="column-right">    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Rules</div>        <select class="styled-select margin-top-2 scenario-editor-rules-select" tabindex="2"                 data-attribute="rules">            <option value="" selected>Normal</option>            <option value="battle_royal">Battle Royal</option>            <option value="elimination">Elimination</option>            <option value="2/3_falls">2/3 Falls</option>            <option value="special_referee">Special Referee</option>        </select>    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Injury Rate</div>        <select class="styled-select margin-top-2 scenario-editor-injury-rate-select" tabindex="4"                 data-attribute="injury_rate">            <option value="1">Low</option>            <option value="2" selected>Med</option>            <option value="3">High</option>            <option value="4">Highest</option>        </select>    </div>    <div>        <div class="display-block margin-bottom-2">Description</div>        <textarea class="styled-input scenario-editor-description-input help-text"                   title="Optional" tabindex="6" data-attribute="description"></textarea>    </div></div><div class="clear"></div>';
    else if (itemType === "brands") inputsHtml = '<div class="column-left">    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Brand Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>    <div class="margin-bottom-18">        <div class="display-block margin-bottom-2">Overness</div>        <select class="styled-select margin-top-2 scenario-editor-overness-select" tabindex="3"                 data-attribute="overness">            <option>Hot</option>            <option selected>Popular</option>            <option>Average</option>            <option>Not Popular</option>            <option>Stale</option>        </select>    </div>    <div>        <label class="control control--checkbox">            Exclusive Weekly Show            <input type="checkbox" class="scenario-editor-exclusive-weekly-show-input" tabindex="5"                    data-attribute="weekly_show_is_exclusive"/>            <div class="control__indicator"></div>        </label>    </div></div><div class="column-right">    <div class="margin-bottom-15">        <div class="display-block margin-bottom-2">Weekly Show Name</div>        <input type="text" class="styled-input scenario-editor-weekly-show-name-input"  tabindex="2"                data-attribute="weekly_show_name">    </div>    <div>        <div class="display-block help-text margin-bottom-2"             title="Adding a brand color will overwrite the default color across light/dark mode.">            Color        </div>        <input type="text" class="scenario-editor-color-input" value="" autocomplete="off" tabindex="4"                data-attribute="color"/>        <span class="scenario-editor-color-preview">Preview</span>    </div></div><div class="clear"></div>';
    else if (itemType === "streaks") {
        let eventOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("events", companyData, false);
        let talentOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("talent", companyData, false);
        inputsHtml = '<div class="column-left">    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Event</div>        <select class="styled-select margin-top-2 scenario-editor-event-select" tabindex="1" data-attribute="event">' + eventOptions + "        </select>" + "    </div>" + "    <div>" + '        <div class="display-block margin-bottom-2">Length (Years)</div>' + '        <input type="number" class="styled-input scenario-editor-length-input" tabindex="3" data-attribute="length" ' + '               min="1" max="100">' + "    </div>" + "</div>" + '<div class="column-right">' + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Talent</div>' + '        <select class="styled-select margin-top-2 scenario-editor-talent-select" tabindex="2" data-attribute="talent">' + talentOptions + "        </select>" + "    </div>" + "</div>" + '<div class="clear"></div>';
    } else if (itemType === "match-contracts") {
        let eventOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("events", companyData, false);
        let talentOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("talent", companyData, false);
        inputsHtml = '<div class="column-left">    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>    <div>        <div class="display-block margin-bottom-2">Talent</div>        <select class="styled-select margin-top-2 scenario-editor-talent-select" tabindex="3" data-attribute="talent">' + talentOptions + "        </select>" + "    </div>" + "</div>" + '<div class="column-right">' + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Event</div>' + '        <select class="styled-select margin-top-2 scenario-editor-event-select" tabindex="2" data-attribute="event">' + eventOptions + "        </select>" + "    </div>" + "</div>" + '<div class="clear"></div>';
    } else if (itemType === "company-details") {
        let eventOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("events", companyData, false);
        inputsHtml = '<div class="column-left">    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Company Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Style</div>        <select class="styled-select margin-top-2 scenario-editor-style-select" tabindex="3"                 data-attribute="style">            <option value="entertainment">Entertainment</option>            <option value="pure">Pure</option>        </select>    </div>    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Owner Name</div>        <input type="text" class="styled-input scenario-editor-owner-name-input" tabindex="5"                data-attribute="owner_name">    </div>    <div>        <div class="display-block margin-bottom-2">Top Event</div>        <select class="styled-select margin-top-2 scenario-editor-top-event-select" tabindex="7"                 data-attribute="top_event">' + eventOptions + "</select>" + "    </div>" + "</div>" + '<div class="column-right">' + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Reputation</div>' + '        <input type="number" class="styled-input scenario-editor-reputation-input" tabindex="2" ' + '               data-attribute="reputation" min="1" max="10">' + "    </div>" + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Creative Points</div>' + '        <input type="number" class="styled-input scenario-editor-creative-points-input" tabindex="4" ' + '               data-attribute="creative_points" min="0" max="5000">' + "    </div>" + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Weekly Show Name</div>' + '        <input type="text" class="styled-input scenario-editor-weekly-show-name-input" tabindex="6" ' + '               data-attribute="weekly_show_name">' + "    </div>" + "    <div>" + '        <div class="display-block margin-bottom-2">Overness</div>' + '        <select class="styled-select margin-top-2 scenario-editor-overness-select"' + '                tabindex="8" data-attribute="overness">' + "            <option>Hot</option>" + "            <option>Popular</option>" + '            <option selected="">Average</option>' + "            <option>Not Popular</option>" + "            <option>Stale</option>" + "        </select>" + "    </div>" + "</div>" + '<div class="clear"></div>';
    } else if (itemType === "scenario-details") {
        let scenarioType = object.scenario_type;
        let scenarioNameHtml = "";
        let scenarioDescriptionHtml = "";
        let scenarioCommentsHtml = "";
        let allowEditsHtml = "";
        let allowSharingHtml = "";
        let privateElementClass = "";
        if (scenarioType === "scenario") {
            scenarioNameHtml = '    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Scenario Name</div>        <input type="text" class="styled-input scenario-editor-name-input"               data-attribute="name" maxlength="50" tabindex="1">    </div>';
            scenarioDescriptionHtml = '    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Description</div>        <textarea class="styled-input scenario-editor-description-input" tabindex="2" data-attribute="description" maxlength="300"></textarea>    </div>';
            scenarioCommentsHtml = '    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Version Comments</div>        <textarea class="styled-input scenario-editor-comments-input" tabindex="3" data-attribute="comments"></textarea>    </div>';
            allowEditsHtml = '    <div class="margin-bottom-10">        <label class="control control--checkbox">            Allow Edits            <input type="checkbox" class="scenario-editor-allow-edits-input" tabindex="8" data-attribute="allow_edits"/>            <div class="control__indicator"></div>        </label>    </div>';
            allowSharingHtml = '    <div>        <label class="control control--checkbox help-text"                title="Shared scenarios will be available for other users to add to their scenarios as competitors">            Allow Sharing            <input type="checkbox" class="scenario-editor-allow-sharing-input" tabindex="9" data-attribute="allow_sharing"/>            <div class="control__indicator"></div>        </label>    </div>';
            privateElementClass = "margin-bottom-10";
        } else if (scenarioType === "scenario_edit") scenarioCommentsHtml = '    <div class="margin-bottom-12">        <div class="display-block margin-bottom-2">Edit Name</div>        <input type="text" class="styled-input scenario-editor-comments-input" tabindex="3" data-attribute="comments" data-edit-name="true">    </div>';
        let eventOptions = $3930923fc77c55ab$var$getScenarioEditorInputOptions("events", companyData, false);
        inputsHtml = '<div class="column-left">' + scenarioNameHtml + scenarioCommentsHtml + '    <div class="margin-bottom-20">' + '        <div class="display-block margin-bottom-2">Starting Year</div>' + '        <input type="number" class="styled-input scenario-editor-starting-year-input" tabindex="5" ' + '               data-attribute="starting_year" min="0" max="1000000">' + "    </div>" + '    <div class="' + privateElementClass + '">' + '        <label class="control control--checkbox">' + "            Private" + '            <input type="checkbox" class="scenario-editor-private-input" tabindex="7" data-attribute="private"/>' + '            <div class="control__indicator"></div>' + "        </label>" + "    </div>" + allowSharingHtml + "</div>" + '<div class="column-right">' + scenarioDescriptionHtml + '    <div class="margin-bottom-12">' + '        <div class="display-block margin-bottom-2">Market Size</div>' + '        <select class="styled-select margin-top-2 scenario-editor-market-size-select"' + '                tabindex="4" data-attribute="market_size">' + '            <option value="1000000">1 million</option>' + '            <option value="2000000">2 million</option>' + '            <option value="3000000">3 million</option>' + '            <option value="4000000" selected>4 million</option>' + '            <option value="5000000">5 million</option>' + '            <option value="8000000">8 million</option>' + '            <option value="10000000">10 million</option>' + '            <option value="12000000">12 million</option>' + '            <option value="15000000">15 million</option>' + "        </select>" + "    </div>" + '    <div class="margin-bottom-20">' + '        <div class="display-block margin-bottom-2">Starting Event</div>' + '        <select class="styled-select margin-top-2 scenario-editor-starting-event-select" tabindex="6" data-attribute="starting_event">' + eventOptions + "        </select>" + "    </div>" + allowEditsHtml + "</div>" + '<div class="clear"></div>';
    } else inputsHtml = '<div class="margin-bottom-12"><div class="display-block margin-bottom-2">Name</div><input type="text" class="styled-input scenario-editor-name-input" data-attribute="name" maxlength="50"></div>';
    return inputsHtml;
}
function $3930923fc77c55ab$var$getScenarioEditorInputOptions(itemType, companyData, addNoneOption) {
    if (typeof addNoneOption === "undefined") addNoneOption = true;
    let optionsHtml = "";
    if (addNoneOption) optionsHtml += "<option selected>None</option>";
    // Get objects for options and sort
    let optionsObjects = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, itemType).slice();
    if (itemType !== "events") optionsObjects.sort($3930923fc77c55ab$var$compareObjectNames);
    // Add options with uid
    optionsObjects.forEach(function(optionObject) {
        optionsHtml += '<option data-uid="' + optionObject["uid"] + '">' + optionObject["name"] + "</option>";
    });
    return optionsHtml;
}
function $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, itemType) {
    let objects;
    switch(itemType){
        case "superstars":
            objects = companyData["superstars"];
            break;
        case "current-superstars":
            objects = companyData["superstars"].filter(function(superstar) {
                return !superstar["month_to_appear_in"];
            });
            break;
        case "main-roster-current-superstars":
            objects = companyData["superstars"].filter(function(superstar) {
                return !superstar["month_to_appear_in"] && !superstar["training"];
            });
            break;
        case "teams":
            objects = companyData["teams"];
            break;
        case "trios":
            objects = companyData["teams"].filter(function(team) {
                return team["team_type"] === "trio";
            });
            break;
        case "talent":
            // Get teams and current superstars
            let currentSuperstars = companyData["superstars"].filter(function(superstar) {
                return !superstar["month_to_appear_in"];
            });
            objects = companyData["teams"].concat(currentSuperstars);
            break;
        case "factions":
            objects = companyData["factions"];
            break;
        case "events":
            objects = companyData["events"];
            break;
        case "championships":
            objects = companyData["championships"];
            break;
        case "gimmick-matches":
            objects = companyData["gimmick_matches"];
            break;
        case "brands":
            objects = companyData["brands"];
            break;
        case "streaks":
            objects = companyData["streaks"];
            break;
        case "match-contracts":
            objects = companyData["match_contracts"];
            break;
    }
    return objects;
}
function $3930923fc77c55ab$var$getScenarioEditorItemObject(itemObjects, itemUid) {
    // Get object by uid
    return itemObjects.filter(function(obj) {
        return obj.uid === itemUid;
    })[0];
}
function $3930923fc77c55ab$var$getScenarioEditorSelectedCompanyData(scenarioData) {
    let scenarioEditorContainer = $(".scenario-editor-container");
    let companyUid = scenarioEditorContainer.data("companyUid");
    let indies = scenarioEditorContainer.data("indies");
    return $3930923fc77c55ab$var$getScenarioEditorCompanyData(scenarioData, companyUid, indies);
}
function $3930923fc77c55ab$var$getScenarioEditorCompanyData(scenarioData, companyUid, indies) {
    let companyData;
    // Get indies
    if (indies) companyData = scenarioData["indies"];
    else companyData = scenarioData["companies"].filter(function(obj) {
        return obj["company_details"]["uid"] === companyUid;
    })[0];
    return companyData;
}
function $3930923fc77c55ab$var$loadScenarioEditorCompanyPage(companyData) {
    let parent = $(".scenario-editor-container");
    let indies = $(".scenario-editor-container").data("indies");
    // Set current page
    parent.data("previousPage", "mainPage");
    // Unselect menu buttons
    $(".scenario-editor-menu-button.selected").removeClass("selected");
    // Add headers
    let companyNameHtml = indies ? "Indies" : '{0} <span class="grey margin-left-2">Company</span>'.format((0, $1JSre.escapeHTML)(companyData["company_details"]["name"]));
    if (parent.find(".scenario-editor-first-header").html() !== companyNameHtml) parent.find(".scenario-editor-first-header").html(companyNameHtml).hide().fadeIn();
    parent.find(".scenario-editor-second-header").text("");
    // Show/hide menu buttons
    parent.find(".scenario-editor-main-menu-container").hide();
    parent.find(".scenario-editor-companies-menu-container, .scenario-editor-companies-header").hide();
    // Show company/indies menu buttons
    if (indies) {
        parent.find(".scenario-editor-company-menu-container").hide();
        parent.find(".scenario-editor-indies-menu-container").fadeIn();
    } else {
        parent.find(".scenario-editor-company-menu-container").fadeIn();
        parent.find(".scenario-editor-indies-menu-container").hide();
    }
    // Hide list container
    parent.find(".scenario-editor-list-container, .scenario-editor-list-buttons-container, .scenario-editor-list-menu-container").hide();
    // Show/hide bottom buttons
    parent.find(".scenario-editor-publish-button").hide();
    parent.find(".scenario-editor-back-button").show();
    parent.find(".scenario-editor-main-menu-button").hide();
    // Reset scenario companies
    $(".scenario-companies-container").hide();
    $(".search-companies-button.selected").removeClass("selected");
    // Add empty text to Edit Details page
    parent.find(".scenario-editor-item-container").html('<div class="font-bold margin-left-5 light-grey margin-top-2">Select an item in the Editor to display its details here</div>');
    parent.find(".scenario-editor-item-buttons-container").hide();
    // Select company details button
    if (!indies) $('.scenario-editor-menu-button[data-value="company-details"]').trigger("click");
}
function $3930923fc77c55ab$var$loadScenarioEditorChangesMadePage(scenarioData, originalScenarioData) {
    let parent = $(".scenario-editor-container");
    // Set current page
    parent.data("previousPage", "mainPage");
    // Unselect menu buttons
    $(".scenario-editor-menu-button.selected").removeClass("selected");
    // Add headers
    let scenarioNameHtml = $3930923fc77c55ab$var$getScenarioNameHtml(scenarioData);
    parent.find(".scenario-editor-first-header").html(scenarioNameHtml);
    parent.find(".scenario-editor-second-header").text("Changes Made").hide().fadeIn();
    // Hide menu buttons
    parent.find(".scenario-editor-main-menu-container").hide();
    parent.find(".scenario-editor-companies-menu-container, .scenario-editor-companies-header").hide();
    parent.find(".scenario-editor-company-menu-container, .scenario-editor-indies-menu-container").hide();
    // Get and show list html
    let listContainerHtml = $3930923fc77c55ab$var$getScenarioEditorChangesMadeHtml(scenarioData, originalScenarioData);
    parent.find(".scenario-editor-list-container").html(listContainerHtml).fadeIn();
    parent.find(".scenario-editor-list-container").scrollTop(0);
    parent.find(".scenario-editor-list-buttons-container, .scenario-editor-list-menu-container").hide();
    // Show/hide bottom buttons
    parent.find(".scenario-editor-publish-button").hide();
    parent.find(".scenario-editor-back-button").show();
    parent.find(".scenario-editor-main-menu-button").hide();
    // Reset scenario companies
    $(".scenario-companies-container").hide();
    $(".search-companies-button.selected").removeClass("selected");
    // Add empty text to Edit Details page
    parent.find(".scenario-editor-item-container").html('<div class="font-bold margin-left-5 light-grey margin-top-2">Select an item in the Editor to display its details here</div>');
    parent.find(".scenario-editor-item-buttons-container").hide();
}
function $3930923fc77c55ab$var$getScenarioEditorChangesMadeHtml(newScenarioData, oldScenarioData) {
    // Get change items
    let changeItems = $3930923fc77c55ab$var$getScenarioEditorChangeItems(newScenarioData, oldScenarioData);
    // Get list items html
    let itemsHtml = "";
    changeItems.forEach(function(item) {
        let itemHtml = $3930923fc77c55ab$var$getScenarioEditorChangeItemHtml(item);
        itemsHtml += itemHtml;
    });
    // Add empty text if no change items found
    if (changeItems.length <= 0) itemsHtml += '<div class="inner-box-item scenario-editor-list-item disabled light-grey">No changes made</div>';
    return itemsHtml;
}
function $3930923fc77c55ab$var$getScenarioEditorChangeItems(newScenarioData, oldScenarioData) {
    let changeItems = [];
    // Get changes between new and old scenario data
    getScenarioEditorChangesForObject(newScenarioData, oldScenarioData);
    function getScenarioEditorChangesForObject(newScenarioObject, oldScenarioObject, companyName) {
        Object.keys(newScenarioObject).forEach(function(objectKey) {
            // Get new objects
            let newObjects = newScenarioObject[objectKey];
            if ([
                "scenario_details",
                "indies",
                "company_details"
            ].indexOf(objectKey) >= 0) {
                // Convert certain objects to array
                newObjects = [
                    newObjects
                ];
                if (objectKey === "indies") companyName = "Indies";
            }
            // Go through new objects
            newObjects.forEach(function(newObject) {
                // Set company name when going through company
                if (objectKey === "companies") companyName = newObject.company_details.name;
                processScenarioEditorNewObject(newObject, oldScenarioObject, objectKey, companyName);
            });
            // Check for removed objects
            processRemovedObjects(newObjects, oldScenarioObject, objectKey, companyName);
        });
    }
    function processScenarioEditorNewObject(newObject, oldScenarioObject, objectKey, companyName) {
        // Get old object
        let oldObject = getScenarioEditorOldObject(newObject, oldScenarioObject, objectKey);
        if (oldObject) {
            // Go through keys for parent object (company, indies)
            if (objectKey === "companies" || objectKey === "indies") getScenarioEditorChangesForObject(newObject, oldObject, companyName);
            else getScenarioEditorItemChanges(newObject, oldObject, objectKey);
        } else {
            // Add 'add' change item
            let objectCompanyName = objectKey !== "companies" ? companyName : ""; // Don't add companyName for companies
            let changeItem = $3930923fc77c55ab$var$createScenarioChangeItem($3930923fc77c55ab$var$getScenarioEditorObjectName(newObject, objectKey), "add", getObjectType(objectKey), objectCompanyName);
            changeItems.push(changeItem);
        }
    }
    function getScenarioEditorOldObject(newObject, oldScenarioObject, objectKey) {
        let oldObject;
        // Get object by key
        if ([
            "scenario_details",
            "indies",
            "company_details"
        ].indexOf(objectKey) >= 0) oldObject = oldScenarioObject[objectKey];
        else {
            let indexArray = Array.from(oldScenarioObject[objectKey], function(x) {
                return $3930923fc77c55ab$var$getScenarioEditorObjectUid(x, objectKey);
            });
            oldObject = oldScenarioObject[objectKey][indexArray.indexOf($3930923fc77c55ab$var$getScenarioEditorObjectUid(newObject, objectKey))];
        }
        return oldObject;
    }
    function getScenarioEditorItemChanges(newObject, oldObject, objectKey) {
        // Go through new object's properties and check for changes
        Object.keys(newObject).forEach(function(attributeKey) {
            // Skip streak name changes
            if (objectKey === "streaks" && attributeKey === "name") return;
            // Check for changes between new value and old value
            let newValue = newObject[attributeKey];
            let oldValue = oldObject[attributeKey];
            let changeCheck = scenarioEditorItemChangeCheck(newValue, oldValue);
            if (changeCheck && attributeKey !== "comments") {
                // Add 'update' change item
                let changeItem = $3930923fc77c55ab$var$createScenarioChangeItem(newObject.name, "update", null, null, attributeKey, newValue, oldValue);
                changeItems.push(changeItem);
            }
        });
    }
    function scenarioEditorItemChangeCheck(newValue, oldValue) {
        // Check for changes in an object's property
        let changeCheck = false;
        if (oldValue !== undefined) {
            // Array or object type
            if (newValue instanceof Array || typeof newValue === "object" && newValue !== null) {
                // Compare graphics using its own function
                if (newValue.hasOwnProperty("body") || newValue.hasOwnProperty("strap")) changeCheck = !checkGraphicsDifference(newValue, oldValue);
                else changeCheck = JSON.stringify(newValue) !== JSON.stringify(oldValue);
            } else changeCheck = newValue !== oldValue;
        }
        return changeCheck;
    }
    function checkGraphicsDifference() {
        let i, l, leftChain, rightChain;
        function compare2Objects(x, y) {
            let p;
            if (y === null && x !== null) return false;
            for(p in x){
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) return false;
                else if (typeof y[p] !== typeof x[p]) return false;
                switch(typeof x[p]){
                    case "object":
                        leftChain.push(x);
                        rightChain.push(y);
                        if (!compare2Objects(x[p], y[p])) return false;
                        leftChain.pop();
                        rightChain.pop();
                        break;
                    default:
                        if (x[p] !== y[p]) return false;
                        break;
                }
            }
            return true;
        }
        for(i = 1, l = arguments.length; i < l; i++){
            leftChain = [];
            rightChain = [];
            if (!compare2Objects(arguments[0], arguments[i])) return false;
        }
        return true;
    }
    function processRemovedObjects(newObjects, oldScenarioObject, objectKey, companyName) {
        let oldObjects = oldScenarioObject[objectKey];
        // Check arrays
        if (oldObjects instanceof Array) {
            let removedObjects = $3930923fc77c55ab$var$getArrayDifference(oldObjects, newObjects, objectKey);
            removedObjects.forEach(function(removedObject) {
                // Add 'remove' change item
                let objectCompanyName = objectKey !== "companies" ? companyName : "";
                let changeItem = $3930923fc77c55ab$var$createScenarioChangeItem($3930923fc77c55ab$var$getScenarioEditorObjectName(removedObject, objectKey), "remove", getObjectType(objectKey), objectCompanyName);
                changeItems.push(changeItem);
            });
        }
    }
    function getObjectType(objectKey) {
        switch(objectKey){
            case "superstars":
                return "Superstar";
            case "teams":
                return "Team";
            case "factions":
                return "Faction";
            case "events":
                return "Event";
            case "championships":
                return "Championships";
            case "gimmick_matches":
                return "Gimmick Match";
            case "brands":
                return "Brand";
            case "match_contracts":
                return "Match Contract";
            case "streaks":
                return "Streak";
            case "companies":
                return "Company";
        }
    }
    // Sort change items by type
    changeItems.sort(function(a, b) {
        return a.type > b.type;
    });
    return changeItems;
}
function $3930923fc77c55ab$var$getScenarioEditorChangeItemHtml(changeItem) {
    let itemHtml = "";
    let itemClasses = "inner-box-item scenario-editor-list-item disabled " + changeItem.type;
    if (changeItem.type === "update") {
        let newValue = $3930923fc77c55ab$var$getScenarioEditorChangeItemNewValueHtml(changeItem);
        let attributeName = $3930923fc77c55ab$var$getScenarioEditorChangeItemAttribute(changeItem.attribute);
        let changeDetailsHtml = '<span class="margin-left-5 grey">{0} {1}</span>'.format(attributeName, newValue);
        itemHtml += '<div class="' + itemClasses + '">{0} {1}</div>'.format((0, $1JSre.escapeHTML)(changeItem.name), changeDetailsHtml);
    } else if (changeItem.type === "add" || changeItem.type === "remove") {
        let objectCompany = changeItem.objectCompany ? "({0})".format((0, $1JSre.escapeHTML)(changeItem.objectCompany)) : "";
        let objectDetails = '<span class="margin-left-5 grey">{0} {1}</span>'.format(changeItem.objectType, objectCompany);
        if (changeItem.type === "add") itemHtml += '<div class="' + itemClasses + '">Added {0} {1}</div>'.format((0, $1JSre.escapeHTML)(changeItem.name), objectDetails);
        else itemHtml += '<div class="' + itemClasses + '">Removed {0} {1}</div>'.format((0, $1JSre.escapeHTML)(changeItem.name), objectDetails);
    }
    return itemHtml;
}
function $3930923fc77c55ab$var$getScenarioEditorChangeItemNewValueHtml(changeItem) {
    let changeHtml = "";
    // Don't show for specific attributes
    if ([
        "graphic",
        "name",
        "description",
        "color"
    ].indexOf(changeItem.attribute) < 0) {
        let newValueHtml = $3930923fc77c55ab$var$getScenarioEditorChangeItemValue(changeItem.newValue, changeItem.attribute);
        changeHtml = "({0})".format(newValueHtml);
    }
    return changeHtml;
}
function $3930923fc77c55ab$var$getScenarioEditorChangeItemValue(value, attribute) {
    // Null value
    if (value === null) return "None";
    else if (attribute === "alignment" && value === "") return "Neutral";
    else if (attribute === "gimmick") return "{0} - {1}".format((0, $1JSre.escapeHTML)(value["name"]), value["effectiveness"]);
    else if ([
        "superstars",
        "managed_talent_names",
        "traits"
    ].indexOf(attribute) >= 0) {
        if (!value.length) return "None";
        return value.join(", ");
    } else if ([
        "weekly_show_before_name",
        "weekly_show_after_name",
        "weekly_show_name",
        "owner_name",
        "contract_name"
    ].indexOf(attribute) >= 0) {
        if (value === "") return "None";
        return value;
    } else {
        if (value === parseInt(value)) return parseInt(value);
        return $3930923fc77c55ab$var$capitalizeFirstLettersOfWords(value.toString().replace(/-/g, " ").replace(/_/g, " "));
    }
}
function $3930923fc77c55ab$var$getScenarioEditorChangeItemAttribute(attribute) {
    // Format attribute name
    let attributeName;
    switch(attribute){
        case "full_time_manager":
            attributeName = "Full-time Manager";
            break;
        case "injured":
            attributeName = "Injured Months";
            break;
        case "managed_talent_names":
            attributeName = "Managed Talent";
            break;
        case "weekly_show_is_exclusive":
            attributeName = "Exclusive Weekly Show";
            break;
        default:
            attributeName = attribute;
    }
    return (0, $3E8Nt.toTitleCase)(attributeName.replace(/_/g, " "));
}
function $3930923fc77c55ab$var$createScenarioChangeItem(name, type, objectType, objectCompany, attribute, newValue, oldValue) {
    let changeItem = {};
    changeItem.name = name;
    changeItem.type = type;
    changeItem.attribute = attribute;
    changeItem.newValue = newValue;
    changeItem.oldValue = oldValue;
    changeItem.objectType = objectType;
    changeItem.objectCompany = objectCompany;
    return changeItem;
}
function $3930923fc77c55ab$var$getArrayDifference(array1, array2, objectKey) {
    return array1.filter(function(x) {
        let id1 = $3930923fc77c55ab$var$getScenarioEditorObjectUid(x, objectKey);
        return !array2.some(function(y) {
            let id2 = $3930923fc77c55ab$var$getScenarioEditorObjectUid(y, objectKey);
            return id2 === id1;
        });
    });
}
function $3930923fc77c55ab$var$compareObjectNames(a, b) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
}
function $3930923fc77c55ab$var$getScenarioEditorObjectUid(object, objectKey) {
    return objectKey === "companies" ? object.company_details.uid : object.uid;
}
function $3930923fc77c55ab$var$getScenarioEditorObjectName(object, objectKey) {
    return objectKey === "companies" ? object.company_details.name : object.name;
}
function $3930923fc77c55ab$var$processScenarioEditorItemGraphic() {
    let scenarioEditorItemContainer = $(".scenario-editor-item-container");
    if (scenarioEditorItemContainer.find(".character-creator:visible").length > 0) {
        // Trigger share to get graphic code
        scenarioEditorItemContainer.find(".share-character").trigger("click");
        let characterData = scenarioEditorItemContainer.find(".share-character-code-input").val();
        if (characterData) // Set graphic input value and trigger to update attribute
        $(".scenario-editor-graphic-input").val(characterData).trigger("change");
    }
}
function $3930923fc77c55ab$var$loadScenarioEditorListPage(companyData, itemType) {
    let parent = $(".scenario-editor-container");
    let indies = $(".scenario-editor-container").data("indies");
    // Set current page
    parent.data("previousPage", "companyPage");
    // Add headers
    let companyName = indies ? "Indies" : '{0} <span class="grey margin-left-2">Company</span>'.format((0, $1JSre.escapeHTML)(companyData["company_details"]["name"]));
    parent.find(".scenario-editor-first-header").html(companyName);
    parent.find(".scenario-editor-second-header").text((0, $3E8Nt.toTitleCase)(itemType.replace(/-/g, " "))).hide().fadeIn();
    // Hide menu buttons
    parent.find(".scenario-editor-main-menu-container").hide();
    parent.find(".scenario-editor-companies-menu-container, .scenario-editor-companies-header").hide();
    parent.find(".scenario-editor-company-menu-container, .scenario-editor-indies-menu-container").hide();
    // Get and show list html
    let listContainerHtml = $3930923fc77c55ab$var$getScenarioEditorListHtml(companyData, itemType, indies);
    parent.find(".scenario-editor-list-container").html(listContainerHtml).fadeIn();
    parent.find(".scenario-editor-list-container").scrollTop(0);
    // Show list menu
    parent.find(".scenario-editor-list-menu-container").fadeIn();
    parent.find(".scenario-editor-list-search-input").val("");
    parent.find(".scenario-editor-add-5-items-button").hide();
    parent.find(".scenario-editor-list-buttons-container, .search-companies-button").hide();
    parent.find(".scenario-editor-list-filters-container").hide();
    if (itemType === "superstars") parent.find(".scenario-editor-add-5-items-button").show();
    if (itemType !== "events") parent.find(".scenario-editor-list-buttons-container").fadeIn();
    // Show hide bottom buttons
    parent.find(".scenario-editor-publish-button").hide();
    parent.find(".scenario-editor-back-button, .scenario-editor-main-menu-button").show();
    // Add empty text to Edit Details page
    parent.find(".scenario-editor-item-container").html('<div class="font-bold margin-left-5 light-grey margin-top-2">Select an item in the Editor to display its details here</div>');
    parent.find(".scenario-editor-item-buttons-container").hide();
}
function $3930923fc77c55ab$var$getScenarioEditorListHtml(companyData, itemType, indies) {
    // Get objects
    let itemObjects = $3930923fc77c55ab$var$getScenarioEditorItemObjects(companyData, itemType);
    // Get list items html
    let itemsHtml = "";
    itemObjects.forEach(function(item) {
        let itemHtml = $3930923fc77c55ab$var$getScenarioEditorListItemHtml(item, itemType, indies);
        itemsHtml += itemHtml;
    });
    // Add empty text if no itemObjects found
    if (itemObjects.length <= 0) itemsHtml += '<div class="inner-box-item scenario-editor-list-item disabled light-grey none-text">No ' + itemType.replace(/-/g, " ") + " present</div>";
    return itemsHtml;
}
function $3930923fc77c55ab$var$getScenarioEditorListItemHtml(item, itemType, indies) {
    // Training/future superstars name highlight
    let trainingClass = "";
    let futureClass = "";
    if (itemType === "superstars" && item.training && !indies) trainingClass = " training";
    if (itemType === "superstars" && item.month_to_appear_in) futureClass = " future";
    // Trio class
    let trioClass = "";
    if (itemType === "teams" && item.team_type === "trio") trioClass = " trio";
    // Name
    let name = '<span class="scenario-editor-list-item-name' + trainingClass + futureClass + '">' + (0, $1JSre.escapeHTML)(item["name"]) + "</span>";
    // Get html
    return '<div class="inner-box-item scenario-editor-list-item' + trainingClass + trioClass + '" data-uid="' + item["uid"] + '">' + "<div>" + name + "</div>" + "</div>";
}
function $3930923fc77c55ab$var$validateScenarioEditorValue(value, attribute, element) {
    let validationCheck = {};
    // Check if 'name' is present
    if (attribute === "name") {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a name for this item";
        }
    }
    // Check if 'comments' is present
    if (attribute === "comments" && element.attr("data-edit-name")) {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a name for this Scenario Edit";
        }
    }
    // Check 'age'
    if (attribute === "age") {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = "Please enter an age for this superstar";
        } else if (value < 10 || value > 100) {
            validationCheck.error = true;
            validationCheck.message = "Please enter an age between 10 and 100";
        }
    }
    // Check 'popularity'
    if (attribute === "popularity") {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a popularity for this superstar";
        } else if (value < 0 || value > 1050) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a popularity 0 and 1050";
        }
    }
    // Check months for 'injury'
    if (attribute === "injured") {
        if (element.hasClass("scenario-editor-injured-months-input")) {
            if (value < 0 || value > 120) {
                validationCheck.error = true;
                validationCheck.message = "Please enter injury months between 0 and 120";
            }
        }
    }
    // Check month and year for 'month_to_appear_in'
    if (attribute === "month_to_appear_in") {
        if (element.hasClass("scenario-editor-month-input")) {
            let months = $(".scenario-editor-month-input").val();
            if (months < 0 || months > 11) {
                validationCheck.error = true;
                validationCheck.message = "Please enter future months between 0 and 11";
            }
        }
        if (element.hasClass("scenario-editor-year-input")) {
            let years = $(".scenario-editor-year-input").val();
            if (years < 0 || years > 200) {
                validationCheck.error = true;
                validationCheck.message = "Please enter future years between 0 and 200";
            }
        }
    }
    // Check 'starting_year'
    if (attribute === "starting_year") {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a starting year";
        } else if (value < 0 || value > 1000000) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a starting year between 0 and 1,000,000";
        }
    }
    // Check 'reputation'
    if (attribute === "reputation") {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a reputation";
        } else if (value < 1 || value > 10) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a reputation between 1 and 10";
        }
    }
    // Check 'creative_points'
    if (attribute === "creative_points") {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = "Please enter creative points";
        } else if (value < 0 || value > 5000) {
            validationCheck.error = true;
            validationCheck.message = "Please enter creative points between 0 and 5000";
        }
    }
    // Check 'length'
    if (attribute === "length") {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a length in years";
        } else if (value < 1 || value > 100) {
            validationCheck.error = true;
            validationCheck.message = "Please enter a length in years between 1 and 100";
        }
    }
    return validationCheck;
}
function $3930923fc77c55ab$var$updateScenarioEditorObject(object, value, attribute, itemType) {
    // Update attribute
    object[attribute] = value;
    // Update displayed name
    if (attribute === "name") $3930923fc77c55ab$var$updateScenarioEditorObjectDisplayedName(object, value, itemType);
    // Update streak's displayed name and object attribute
    if (itemType === "streaks" && (attribute === "event" || attribute === "talent")) {
        let streakTalent = $(".scenario-editor-talent-select").val();
        let streakEvent = $(".scenario-editor-event-select").val();
        let streakName = $3930923fc77c55ab$var$getScenarioEditorStreakName(streakTalent, streakEvent);
        $('.scenario-editor-list-item[data-uid="' + object.uid + '"]').find(".scenario-editor-list-item-name").text(streakName);
        object.name = streakName;
    }
}
function $3930923fc77c55ab$var$updateScenarioEditorObjectDisplayedName(object, value, itemType) {
    // Update scenario/company name in header
    if (itemType === "scenario-details") $(".scenario-editor-first-header").html('{0} <span class="grey margin-left-2">Scenario</span>'.format((0, $1JSre.escapeHTML)(value)));
    else if (itemType === "company-details") $(".scenario-editor-first-header").html('{0} <span class="grey margin-left-2">Company</span>'.format((0, $1JSre.escapeHTML)(value)));
    else $('.scenario-editor-list-item[data-uid="' + object.uid + '"]').find(".scenario-editor-list-item-name").text(value);
}
function $3930923fc77c55ab$var$getScenarioEditorStreakName(streakTalent, streakEvent) {
    let streakName;
    if (streakTalent && streakEvent) streakName = "{0} ({1})".format(streakTalent, streakEvent);
    else streakName = streakTalent || streakEvent;
    return streakName;
}
function $3930923fc77c55ab$var$updateScenarioEditorObjectLinks(object, value, itemType, companyData, scenarioData) {
    // Update object's links if any found with same name
    let numberOfLinksUpdated = 0;
    function updateObjectLink(objectToUpdate, attribute, index) {
        // Update array value
        if (index !== undefined) objectToUpdate[attribute][index] = value;
        else objectToUpdate[attribute] = value;
        numberOfLinksUpdated += 1;
    }
    // Superstars
    if (itemType === "superstars") {
        companyData.superstars.forEach(function(superstar) {
            superstar.managed_talent_names.forEach(function(managedSuperstar, i) {
                if (managedSuperstar === object.name) updateObjectLink(superstar, "managed_talent_names", i);
            });
        });
        companyData.teams.forEach(function(team) {
            team.superstars.forEach(function(teamSuperstar, i) {
                if (teamSuperstar === object.name) updateObjectLink(team, "superstars", i);
            });
        });
        // Don't run for indies
        if (companyData.factions) {
            companyData.factions.forEach(function(faction) {
                faction.superstars.forEach(function(factionSuperstar, i) {
                    if (factionSuperstar === object.name) updateObjectLink(faction, "superstars", i);
                });
                if (faction.leader_superstar === object.name) updateObjectLink(faction, "leader_superstar");
            });
            companyData.championships.forEach(function(championship) {
                if (championship.champion === object.name) updateObjectLink(championship, "champion");
            });
            companyData.streaks.forEach(function(streak) {
                if (streak.talent === object.name) {
                    updateObjectLink(streak, "talent");
                    streak.name = $3930923fc77c55ab$var$getScenarioEditorStreakName(streak.talent, streak.event); // Update streak name
                }
            });
            companyData.match_contracts.forEach(function(matchContract) {
                if (matchContract.talent === object.name) updateObjectLink(matchContract, "talent");
            });
        }
    }
    // Teams
    if (itemType === "teams") {
        companyData.superstars.forEach(function(superstar) {
            superstar.managed_talent_names.forEach(function(managedSuperstar, i) {
                if (managedSuperstar === object.name) updateObjectLink(superstar, "managed_talent_names", i);
            });
        });
        // Don't run for indies
        if (companyData.championships) {
            companyData.championships.forEach(function(championship) {
                if (championship.champion === object.name) updateObjectLink(championship, "champion");
            });
            companyData.streaks.forEach(function(streak) {
                if (streak.talent === object.name) {
                    updateObjectLink(streak, "talent");
                    streak.name = $3930923fc77c55ab$var$getScenarioEditorStreakName(streak.talent, streak.event);
                }
            });
            companyData.match_contracts.forEach(function(matchContract) {
                if (matchContract.talent === object.name) updateObjectLink(matchContract, "talent");
            });
        }
    }
    // Events
    if (itemType === "events") {
        companyData.streaks.forEach(function(streak) {
            if (streak.event === object.name) {
                updateObjectLink(streak, "event");
                streak.name = $3930923fc77c55ab$var$getScenarioEditorStreakName(streak.talent, streak.event);
            }
        });
        companyData.match_contracts.forEach(function(matchContract) {
            if (matchContract.event === object.name) updateObjectLink(matchContract, "event");
        });
        if (companyData.company_details.top_event === object.name) updateObjectLink(companyData.company_details, "top_event");
        if (scenarioData.scenario_details.starting_event === object.name) updateObjectLink(scenarioData.scenario_details, "starting_event");
    }
    // Brands
    if (itemType === "brands") {
        let brandObjects = companyData.superstars.concat(companyData.events, companyData.championships);
        brandObjects.forEach(function(brandObject) {
            if (brandObject.brand_name === object.name) updateObjectLink(brandObject, "brand_name");
        });
    }
    if (numberOfLinksUpdated) notie.alert({
        type: 4,
        text: "Item links updated ({0})".format(numberOfLinksUpdated)
    });
}
function $3930923fc77c55ab$var$checkScenarioEditorAddItemLimit(numberOfItems, itemType) {
    // Get item limit
    let itemLimit;
    let indies = $(".scenario-editor-container").data("indies");
    let suffix = indies ? " to the Indies" : " per company";
    switch(itemType){
        case "superstars":
            itemLimit = indies ? 2000 : 1250;
            break;
        case "teams":
            itemLimit = 200;
            break;
        case "factions":
            itemLimit = 100;
            break;
        case "events":
            itemLimit = 12;
            break;
        case "championships":
            itemLimit = 30;
            break;
        case "gimmick-matches":
            itemLimit = 60;
            break;
        case "brands":
            itemLimit = 3;
            break;
        case "match-contracts":
            itemLimit = 20;
            break;
        case "streaks":
            itemLimit = 100;
            break;
        case "companies":
            itemLimit = (0, $3E8Nt.gameLimits).maxEditorCompetitors + 1;
            suffix = "";
            break;
    }
    if (numberOfItems >= itemLimit) {
        notie.alert({
            type: 3,
            text: "You cannot add more than " + itemLimit + " " + (0, $3E8Nt.toTitleCase)(itemType.replace(/-/g, " ")) + suffix
        });
        return false;
    }
    return true;
}
function $3930923fc77c55ab$var$moveScenarioEditorItemObject(itemObject, itemObjects, itemType, itemObjectsToMoveTo, additionalMove) {
    // Remove from itemObjects
    itemObjects.splice(itemObjects.indexOf(itemObject), 1);
    // Add to item objects to move to
    itemObjectsToMoveTo.push(itemObject);
    // Set future superstar to training (for main roster)
    if (itemObject.month_to_appear_in) itemObject.training = true;
    if (!additionalMove) {
        // Remove item from list
        $('.scenario-editor-list-item[data-uid="' + itemObject.uid + '"]').remove();
        // Reset search/filters
        $(".scenario-editor-list-search-input").val("");
        $(".scenario-editor-list-filter.selected").removeClass("selected");
        $(".scenario-editor-list-item").show();
        $(".no-scenario-editor-search-results").hide();
        // Add empty text if no objects left
        if (itemObjects.length <= 0) $(".scenario-editor-list-container").html('<div class="inner-box-item scenario-editor-list-item disabled light-grey none-text">No ' + itemType.replace(/-/g, " ") + " present</div>");
        // Add empty text to Edit Details page
        $(".scenario-editor-item-container").html('<div class="font-bold margin-left-5 light-grey margin-top-2">Select an item in the Editor to display its details here</div>');
        $(".scenario-editor-item-buttons-container").hide();
    }
}
function $3930923fc77c55ab$var$checkScenarioValidation(scenarioData) {
    let validationCheck = true;
    if (scenarioData.companies.length <= 0) {
        notie.alert({
            type: 3,
            text: "You need to have at least 1 Company present in the Scenario",
            stay: true
        });
        validationCheck = false;
    }
    scenarioData.companies.forEach(function(company) {
        if (company.superstars.length < 2) {
            notie.alert({
                type: 3,
                text: "You need to have at least 2 Superstars present for each Company",
                stay: true
            });
            validationCheck = false;
        }
        // Check for duplicate event names
        let companyEventNames = Array.from(company.events, function(e) {
            return e.name;
        });
        if (new Set(companyEventNames).size !== companyEventNames.length) {
            notie.alert({
                type: 3,
                text: "Please make sure all monthly event names are different from each other",
                stay: true
            });
            validationCheck = false;
        }
    });
    return validationCheck;
}
function $3930923fc77c55ab$var$toggleScenarioEditorItemInputsContainer(element) {
    let inputsContainerSelector;
    let highlightElement = true;
    if (element.hasClass("scenario-editor-injured-input")) inputsContainerSelector = ".superstar-injured-months-container";
    else if (element.hasClass("scenario-editor-gimmick-input")) inputsContainerSelector = ".superstar-gimmick-container";
    else if (element.hasClass("scenario-editor-manager-input")) inputsContainerSelector = ".superstar-manager-container";
    else if (element.hasClass("scenario-editor-training-input")) {
        inputsContainerSelector = ".superstar-future-container";
        // Enable/disable brand select, training name highlight
        if (element.prop("checked") === true) {
            // Disable brand select and set value to None
            $(".scenario-editor-brand-select").val("None").trigger("change").prop("disabled", true).addClass("light-opaque");
            // Show training name highlight
            $(".scenario-editor-list-item.selected .scenario-editor-list-item-name").addClass("training");
            $(".scenario-editor-list-item.selected").addClass("training");
        } else {
            // Enable brand select
            $(".scenario-editor-brand-select").prop("disabled", false).removeClass("light-opaque");
            // Hide training name highlight
            $(".scenario-editor-list-item.selected .scenario-editor-list-item-name").removeClass("training");
            $(".scenario-editor-list-item.selected").removeClass("training");
            // Remove month_to_appear_in
            $(".scenario-editor-month-input").val("");
            $(".scenario-editor-year-input").val("").trigger("change");
        }
    } else if (element.hasClass("scenario-editor-future-input")) {
        inputsContainerSelector = ".superstar-future-inputs-container";
        if (element.closest(".superstar-future-container").siblings("label").length > 0) highlightElement = false;
    }
    if (element.prop("checked") === true) {
        if (highlightElement) element.parent().addClass("faded-blue");
        element.parent().siblings(inputsContainerSelector).removeClass("display-none");
    } else {
        if (highlightElement) element.parent().removeClass("faded-blue");
        element.parent().siblings(inputsContainerSelector).addClass("display-none");
    }
}
function $3930923fc77c55ab$var$toggleScenarioEditorTeamTypeInput(element) {
    let val = element.val();
    if (val === "trio") {
        element.closest(".scenario-editor-item-container").find(".scenario-editor-third-superstar-select").parent().removeClass("display-none");
        $(".scenario-editor-list-item.selected").addClass("trio");
    } else {
        element.closest(".scenario-editor-item-container").find(".scenario-editor-third-superstar-select").parent().addClass("display-none");
        $(".scenario-editor-list-item.selected").removeClass("trio");
    }
}
function $3930923fc77c55ab$var$toggleScenarioEditorConsequenceInput(element) {
    let val = element.val();
    if (val === "championship_contract" || val === "match_contract") element.parent().siblings(".scenario-editor-contract-name-container").removeClass("display-none");
    else {
        element.parent().siblings(".scenario-editor-contract-name-container").addClass("display-none");
        // Remove contract_name
        $(".scenario-editor-contract-name-input").val("").trigger("change");
    }
}
function $3930923fc77c55ab$var$getScenarioEditorItemInputValue(element, attribute, itemType) {
    // Get input/checked value
    let value = element.val().trim();
    if (element.attr("type") === "checkbox") value = element.prop("checked");
    // Get integer value of number input
    if (element.attr("type") === "number" && value || [
        "market_size",
        "charisma",
        "workrate",
        "rating_boost",
        "injury_rate"
    ].indexOf(attribute) >= 0) value = parseInt(value);
    // Get specific value based on attribute
    // Superstars
    if (attribute === "gimmick") {
        if ($(".scenario-editor-gimmick-input").prop("checked")) {
            let gimmickName = $(".scenario-editor-gimmick-name-input").val();
            if (gimmickName) value = {
                "name": gimmickName,
                "effectiveness": $(".scenario-editor-gimmick-effectiveness-select").val()
            };
            else value = null;
        } else value = null;
    }
    if (attribute === "injured") {
        if ($(".scenario-editor-injured-input").prop("checked")) value = $(".scenario-editor-injured-months-input").val() ? parseInt($(".scenario-editor-injured-months-input").val()) : 0;
        else value = 0;
    }
    if (attribute === "managed_talent_names") {
        if ($(".scenario-editor-manager-input").prop("checked")) {
            // Don't get None values
            let talentSelects = $(".scenario-editor-managed-talent-select").filter(function(i, x) {
                return $(x).find(":selected").attr("data-uid");
            });
            value = Array.from(talentSelects, function(el) {
                return $(el).val();
            });
        } else value = [];
    }
    if (attribute === "month_to_appear_in") {
        if ($(".scenario-editor-future-input").prop("checked")) {
            let month = $(".scenario-editor-month-input").val() ? parseInt($(".scenario-editor-month-input").val()) : 0;
            let year = $(".scenario-editor-year-input").val() ? parseInt($(".scenario-editor-year-input").val()) : 0;
            if (month || year) {
                value = year * 12 + month;
                $(".scenario-editor-list-item.selected .scenario-editor-list-item-name").addClass("future");
            } else {
                value = null;
                $(".scenario-editor-list-item.selected .scenario-editor-list-item-name").removeClass("future");
            }
        } else {
            value = null;
            $(".scenario-editor-list-item.selected .scenario-editor-list-item-name").removeClass("future");
        }
    }
    if (attribute === "brand_name") {
        let brandOption = $(".scenario-editor-brand-select").find(":selected");
        if (brandOption.attr("data-uid")) value = brandOption.val();
        else value = null;
    }
    if (attribute === "traits") {
        if (value) value = value.split(", ");
        else value = [];
    }
    if (attribute === "graphic") {
        if (value) value = JSON.parse(value);
        else value = null;
    }
    // Teams
    if (itemType === "teams" && attribute === "superstars") {
        value = [
            $(".scenario-editor-first-superstar-select").val(),
            $(".scenario-editor-second-superstar-select").val()
        ];
        if ($(".scenario-editor-team-type-select").val() === "trio") value.push($(".scenario-editor-third-superstar-select").val());
    }
    // Factions
    if (attribute === "leader_superstar") {
        let factionLeaderOption = $(".scenario-editor-faction-leader-select").find(":selected");
        if (factionLeaderOption.attr("data-uid")) value = factionLeaderOption.val();
        else value = null;
    }
    if (itemType === "factions" && attribute === "superstars") {
        // Don't get None values
        let talentSelects = $(".scenario-editor-faction-member-select").filter(function(i, x) {
            return $(x).find(":selected").attr("data-uid");
        });
        value = Array.from(talentSelects, function(el) {
            return $(el).val();
        });
    }
    // Championships
    if (attribute === "champion") {
        let championOption = $(".scenario-editor-champion-select").find(":selected");
        if (championOption.attr("data-uid")) value = championOption.val();
        else value = null;
    }
    // Gimmick Matches
    if (attribute === "consequence" || attribute === "rules" || attribute === "contract_name" || attribute === "graphic_type") {
        if (!value) value = null;
    }
    return value;
}
function $3930923fc77c55ab$var$capitalizeFirstLettersOfWords(str) {
    return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substring(1);
    });
}
function $3930923fc77c55ab$var$runScenarioEditorListSearch() {
    let listContainer = $(".scenario-editor-list-container");
    let listElements = document.querySelectorAll(".scenario-editor-list-item:not(.no-scenario-editor-search-results)");
    let searchTerm = $(".scenario-editor-list-search-input").val();
    for(let i = 0; i < listElements.length; i++)listElements[i].style.display = "none";
    // Run search
    if (searchTerm.length > 0) {
        let searchResults = (0, $1JSre.runFuseElementsSearch)(listElements, searchTerm, [
            "textContent"
        ]);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function(e) {
                e.style.display = "block";
            });
            $(".no-scenario-editor-search-results").hide();
        } else if ($(".no-scenario-editor-search-results").length > 0) $(".no-scenario-editor-search-results").show();
        else listContainer.append('<div class="no-scenario-editor-search-results inner-box-item scenario-editor-list-item disabled light-grey">No results found</div>');
    } else {
        for(let i = 0; i < listElements.length; i++)listElements[i].style.display = "block";
        $(".no-scenario-editor-search-results").hide();
    }
    // Remove filters
    $(".scenario-editor-list-filter.selected").removeClass("selected");
    listContainer.scrollTop(0);
}
function $3930923fc77c55ab$var$loadEditScenarioDataRequest(uid, version, scenarioType, duplicate) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $1JSre.makeGetRequest)("/_get_edit_scenario_data", {
        uid: uid,
        version: version,
        scenarioType: scenarioType,
        duplicate: duplicate,
        job: true
    }, async (data)=>{
        if (!data["error"]) await $3930923fc77c55ab$var$checkGetEditScenarioDataJob(data["statusUrl"], scenarioType);
        else {
            notie.hideAlerts();
            (0, $98xmD.globals).requestRunning = false;
            (0, $lCS03.playSoundEffect)("error");
            if (data["error"] === "does-not-belong-to-user") notie.alert({
                type: 3,
                text: "This scenario is not available for you to edit."
            });
        }
    }, true, "Please wait, this can take some time, depending on the size of the scenario.");
}
async function $3930923fc77c55ab$var$checkGetEditScenarioDataJob(statusUrl, scenarioType) {
    (0, $1JSre.makeGetRequest)(statusUrl, {}, async (data)=>{
        switch(data.status){
            case "unknown":
            case "failed":
                notie.hideAlerts();
                (0, $98xmD.globals).requestRunning = false;
                notie.alert({
                    type: 3,
                    text: "There was an error. Please try again"
                });
                break;
            case "finished":
                notie.hideAlerts();
                (0, $98xmD.globals).requestRunning = false;
                // Don't load edit if html tags found
                if (scenarioType === "scenario_edit") {
                    const regex = /(<[^>]*>)|(&lt;)|(\/script)|(src=)|(&#)|(onfocus=)/i;
                    const regexResult = JSON.stringify(data["result"]).match(regex);
                    if (regexResult) {
                        notie.alert({
                            type: 3,
                            text: "HTML tags were found within the scenario. For security purposes, the scenario wasn't loaded."
                        });
                        return false;
                    }
                }
                (0, $lCS03.playSoundEffect)("success");
                (0, $1JSre.hideMainMenuContent)($());
                // Load scenarioData
                $3930923fc77c55ab$var$scenarioData = data["result"];
                // Add scenario type
                $3930923fc77c55ab$var$scenarioData.scenario_details.scenario_type = scenarioType;
                // Copy original scenario data
                $3930923fc77c55ab$var$originalScenarioData = JSON.parse(JSON.stringify($3930923fc77c55ab$var$scenarioData));
                // Load main page
                $3930923fc77c55ab$var$loadScenarioEditorMainPage($3930923fc77c55ab$var$scenarioData);
                if ($3930923fc77c55ab$var$scenarioEditorInfoShown) $(".scenario-editor-container").fadeIn("slow");
                else {
                    $(".scenario-editor-info-container").hide().fadeIn();
                    $3930923fc77c55ab$var$scenarioEditorInfoShown = true;
                }
                break;
            default:
                setTimeout(async function() {
                    await $3930923fc77c55ab$var$checkGetEditScenarioDataJob(statusUrl, scenarioType);
                }, 1000);
        }
    }, true, null, false);
}
async function $3930923fc77c55ab$var$addScenarioDataRequest(scenarioData) {
    if ((0, $98xmD.globals).requestRunning) return false;
    notie.alert({
        type: 4,
        text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Please wait, this can take some time, depending on the size of the scenario.',
        stay: true
    });
    (0, $98xmD.globals).requestRunning = true;
    // Compress
    const scenarioDataArrayBuffer = fflate.strToU8(JSON.stringify(scenarioData));
    fflate.zlib(scenarioDataArrayBuffer, (err, compressed)=>{
        if (err) {
            notie.alert({
                type: 3,
                text: "Add scenario compression failed."
            });
            (0, $3E8Nt.captureError)(new Error("error for add scenario compression: " + err));
            return;
        }
        $.ajax({
            type: "POST",
            contentType: "application/octet-stream",
            url: (0, $98xmD.globals).baseUrl + "/_add_scenario_data",
            data: compressed,
            success: async function(data, status, request) {
                if (!data["error"]) {
                    let statusUrl = request.getResponseHeader("Location");
                    await $3930923fc77c55ab$var$checkAddScenarioDataJob(statusUrl, scenarioData);
                } else {
                    (0, $98xmD.globals).requestRunning = false;
                    if (data["error"] === "not-logged-in") notie.alert({
                        type: 3,
                        text: "You need to login to create a Scenario",
                        stay: true
                    });
                    else if (data["error"] === "not-paid") notie.alert({
                        type: 3,
                        text: "You need to have JoW Paid to create edits",
                        stay: true
                    });
                    else if (data["error"] === "edits-not-allowed") notie.alert({
                        type: 3,
                        text: "The scenario creator has disabled Edits for this Scenario",
                        stay: true
                    });
                    else if (data["error"] === "incorrect-user") notie.alert({
                        type: 3,
                        text: "This scenario does not belong to you",
                        stay: true
                    });
                    else if (data["error"] === "html-present") notie.alert({
                        type: 3,
                        text: "HTML tags were found within your scenario. Please remove them and try again.",
                        stay: true
                    });
                    else notie.alert({
                        type: 3,
                        text: "An error occurred while adding the scenario. Please try again.",
                        stay: true
                    });
                }
            },
            processData: false,
            timeout: (0, $1JSre.requestTimeout),
            error: function(jqXHR, status, errorThrown) {
                (0, $98xmD.globals).requestRunning = false;
                if (!window.navigator.onLine) notie.alert({
                    type: 3,
                    text: "It seems like you're offline. Please check your internet connection and try again."
                });
                else {
                    if (status === "timeout") notie.alert({
                        type: 3,
                        text: "The add scenario request timed out. Please try again in a while."
                    });
                    else notie.alert({
                        type: 3,
                        text: "There was an error with the add scenario request. Please try again."
                    });
                    (0, $3E8Nt.captureError)(new Error("error for add scenario request: " + errorThrown));
                }
            }
        });
    });
}
async function $3930923fc77c55ab$var$checkAddScenarioDataJob(statusUrl, scenarioData) {
    (0, $1JSre.makeGetRequest)(statusUrl, {}, async (data)=>{
        switch(data.status){
            case "unknown":
            case "failed":
                (0, $98xmD.globals).requestRunning = false;
                notie.alert({
                    type: 3,
                    text: "There was an error adding the scenario. Please try again."
                });
                break;
            case "finished":
                (0, $98xmD.globals).requestRunning = false;
                if (!data["result"]["error"]) {
                    (0, $lCS03.playSoundEffect)("success");
                    $(".scenario-editor-container").fadeOut("fast", function() {
                        $("#main-menu-buttons").find("li").removeClass("selected");
                        $(".main-container").removeClass("blur");
                        let notieText = "";
                        if (scenarioData.scenario_details.scenario_type === "scenario") {
                            if (scenarioData.scenario_details.version) notieText = "Scenario update added.";
                            else notieText = 'Scenario added. It can be found by clicking "My Scenarios" under "New Game".';
                        } else if (scenarioData.scenario_details.scenario_type === "scenario_edit") {
                            if (scenarioData.scenario_details.edit_version) notieText = "Scenario edit update added.";
                            else notieText = 'Scenario edit added. It can be found by clicking "Show Edits" under the scenario.';
                        }
                        notie.alert({
                            type: 4,
                            text: notieText,
                            stay: true
                        });
                    });
                } else {
                    (0, $lCS03.playSoundEffect)("error");
                    if (data["result"]["error"] === "not-logged-in") notie.alert({
                        type: 3,
                        text: "You need to login to create a Scenario",
                        stay: true
                    });
                    else if (data["result"]["error"] === "not-paid") notie.alert({
                        type: 3,
                        text: "You need to have JoW Paid to create edits",
                        stay: true
                    });
                    else if (data["result"]["error"] === "edits-not-allowed") notie.alert({
                        type: 3,
                        text: "The scenario creator has disabled Edits for this Scenario",
                        stay: true
                    });
                    else if (data["result"]["error"] === "incorrect-user") notie.alert({
                        type: 3,
                        text: "This scenario does not belong to you",
                        stay: true
                    });
                    else if (data["result"]["error"] === "html-present") notie.alert({
                        type: 3,
                        text: "HTML tags were found within your scenario. Please remove them and try again.",
                        stay: true
                    });
                    else notie.alert({
                        type: 3,
                        text: "An error occurred while adding the scenario. Please try again.",
                        stay: true
                    });
                }
                break;
            default:
                setTimeout(async function() {
                    await $3930923fc77c55ab$var$checkAddScenarioDataJob(statusUrl, scenarioData);
                }, 1000);
        }
    }, true, null, false);
}
function $3930923fc77c55ab$var$applyScenarioEditorListFilter(filterName) {
    let listContainer = $(".scenario-editor-list-container");
    let listElements = document.querySelectorAll(".scenario-editor-list-item:not(.no-scenario-editor-search-results)");
    // Run search
    if (filterName) {
        let filterResults = [];
        if (filterName === "main") filterResults = document.querySelectorAll(".scenario-editor-list-item:not(.training):not(.no-scenario-editor-search-results)");
        else if (filterName === "training") filterResults = document.querySelectorAll(".scenario-editor-list-item.training:not(.no-scenario-editor-search-results)");
        for(let i = 0; i < listElements.length; i++)listElements[i].style.display = "none";
        // Show results if found
        if (filterResults.length > 0) {
            filterResults.forEach(function(e) {
                e.style.display = "block";
            });
            $(".no-scenario-editor-search-results").hide();
        } else if ($(".no-scenario-editor-search-results").length > 0) $(".no-scenario-editor-search-results").show();
        else listContainer.append('<div class="no-scenario-editor-search-results inner-box-item scenario-editor-list-item disabled light-grey">No results found</div>');
    } else {
        for(let i = 0; i < listElements.length; i++)listElements[i].style.display = "block";
        $(".no-scenario-editor-search-results").hide();
    }
    // Reset search
    $(".scenario-editor-list-search-input").val("");
    listContainer.scrollTop(0);
}
function $3930923fc77c55ab$var$updateScenarioEditorFactionLeaderSelect() {
    let selectFactionMemberDivs = $(".scenario-editor-faction-member-select");
    let selectFactionLeaderDiv = $(".scenario-editor-faction-leader-select");
    let selectedValue = selectFactionLeaderDiv.val();
    // Reset
    selectFactionLeaderDiv.html("");
    selectFactionLeaderDiv.append($("<option selected>None</option>"));
    // Add faction members selected as options, don't add duplicates
    selectFactionMemberDivs.each(function(i, e) {
        let selectedOption = $(e).find("option:selected");
        if (selectedOption.attr("data-uid") && selectFactionLeaderDiv.find('option[value="' + selectedOption.val().replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1") + '"]').length <= 0) selectFactionLeaderDiv.append($("<option />").val(selectedOption.val()).text(selectedOption.text()).attr("data-uid", selectedOption.attr("data-uid")));
    });
    // If previously selected value found, select it, otherwise select none
    let unencodedSelectedValue = selectedValue ? selectedValue.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1") : selectedValue;
    if (selectFactionLeaderDiv.find('option[value="' + unencodedSelectedValue + '"]').length > 0) selectFactionLeaderDiv.val(selectedValue);
    else selectFactionLeaderDiv.val("None");
}
function $3930923fc77c55ab$var$runScenarioCompaniesSearch(searchTerm, page) {
    if ((0, $98xmD.globals).requestRunning) return false;
    (0, $1JSre.makeGetRequest)("/_search_scenario_companies", {
        name: searchTerm,
        page: page
    }, (data)=>{
        // Get search results html
        let html = "";
        data["companies"].forEach(function(item) {
            html += $3930923fc77c55ab$var$getScenarioCompanyItemHtml(item);
        });
        // Show empty results if no companies found
        if (data["companies"].length <= 0) html = '<div class="inner-box-item scenario-companies-search-result-item disabled light-grey">No Companies found</div>';
        // Show next/prev page buttons
        $3930923fc77c55ab$var$showScenarioCompaniesPagination(data);
        // Show results
        $(".scenario-companies-results").show();
        $(".scenario-companies-results-container").html(html).show();
        $(".scenario-companies-results-container").scrollTop(0);
        // Put focus back on search field
        $(".scenario-companies-search-input").focus();
    });
}
function $3930923fc77c55ab$var$showScenarioCompaniesPagination(data) {
    if (data["next_page"]) $(".scenario-companies-next-page-button").removeClass("visibility-hidden").data("page", data["next_page"]);
    else $(".scenario-companies-next-page-button").addClass("visibility-hidden");
    if (data["previous_page"]) $(".scenario-companies-previous-page-button").removeClass("visibility-hidden").data("page", data["previous_page"]);
    else $(".scenario-companies-previous-page-button").addClass("visibility-hidden");
    if (data["next_page"] || data["previous_page"]) $(".scenario-companies-pagination-buttons").show();
    else $(".scenario-companies-pagination-buttons").hide();
}
function $3930923fc77c55ab$var$getScenarioCompanyItemHtml(item) {
    let creatorHtml = '<span class="high-light-grey margin-left-3">by {0}</span>'.format((0, $1JSre.escapeHTML)(item["creator"]));
    let datetimeUpdatedHtml = "";
    if (item["datetime_updated_string"] !== undefined) datetimeUpdatedHtml = '<span class="high-light-grey margin-left-2">{0}</span>'.format(item["datetime_updated_string"]);
    let ratingHtml;
    if (item["rating"] === null) ratingHtml = '<span class="rating no-rating margin-left-2">?? %</span>';
    else if (item["rating"] >= 50) ratingHtml = '<span class="rating positive margin-left-2">' + item["rating"] + "%</span>";
    else ratingHtml = '<span class="rating negative margin-left-2">' + item["rating"] + "%</span>";
    let scenarioName = '<span class="light-grey margin-left-3">{0}</span>'.format((0, $1JSre.escapeHTML)(item["scenario_name"]));
    let itemInfo = "{0} {1} {2} {3} {4}".format((0, $1JSre.escapeHTML)(item["company_name"]), creatorHtml, scenarioName, ratingHtml, datetimeUpdatedHtml);
    return '<div class="inner-box-item scenario-companies-search-result-item" data-uid="' + item["uid"] + '" data-creator="' + item["creator"].replace(/"/g, "&quot;") + '" data-scenario-name="' + item["scenario_name"].replace(/"/g, "&quot;") + '">' + '<div class="medium-dark-grey">' + itemInfo + "</div>" + "</div>";
}




var $3E8Nt = parcelRequire("3E8Nt");

var $14eBR = parcelRequire("14eBR");
$(document).ready(async function() {
    // Check if browser is not supported
    if (navigator.userAgent.match(/SamsungBrowser/i)) {
        notie.alert({
            type: 3,
            text: "Your browser is not supported. Please try playing on another browser like Chrome.",
            stay: true
        });
        throw new Error("Browser not supported");
    }
    let user = await $69677cd2f9b4883e$var$setupUser();
    // Setup other config
    if (navigator.storage) await navigator.storage.persist();
    $("input").attr("autocomplete", "off");
    notie.setOptions({
        alertTime: 6
    });
    // Setup sentry
    if (typeof window.Sentry !== "undefined") Sentry.init({
        dsn: "https://29edf8d19433a6d905e2f4c44c3b4074@o73522.ingest.sentry.io/158367",
        beforeSend: function(event, hint) {
            // filter out UnhandledRejection errors that have no information
            if (event !== undefined && event.exception !== undefined && event.exception.values !== undefined && event.exception.values.length === 1) {
                let e = event.exception.values[0];
                if (e.type === "UnhandledRejection" && e.value === "Non-Error promise rejection captured with value: ") return null;
            }
        },
        ignoreErrors: [
            "NotSupportedError",
            "AbortError",
            "NotAllowedError",
            "null is not an object (evaluating 'd.frameElement')",
            "Object expected",
            "Cannot read property 'frameElement' of null",
            "TagError",
            "Extension context invalidated",
            "undefined is not an object (evaluating 'c.left')",
            "null is not an object (evaluating 'e.target.parentNode.classList')",
            "Cannot read property 'left' of undefined",
            "JSON syntax error",
            "TypeError: undefined is not an object (evaluating 'window.webkit.messageHandlers.selectedDebugHandler.postMessage')",
            "undefined is not an object (evaluating 'window.webkit.messageHandlers.selectedTextHandler.postMessage')",
            "Non-Error promise rejection captured with keys: message",
            "UnknownError: Cannot inject key into script value",
            "Cannot inject key into script value",
            "t.prototype._onMouseMove(src/accessibility/AccessibilityManager)",
            "t.prototype._onMouseMove(src/accessibility/AccessibilityManager)",
            "Event `ErrorEvent` captured as exception with message `Script error.`"
        ],
        whitelistUrls: [
            "www.journeyofwrestling.com",
            "www.journeyofwrestling.com/static",
            "journeyofwrestling.com",
            "journeyofwrestling.com/static"
        ],
        blacklistUrls: []
    });
    // Load google fonts for pixi
    window.WebFontConfig = {
        custom: {
            families: [
                "Oswald",
                "Quantico",
                "Saira Stencil One",
                "Orbitron",
                "Cinzel Decorative",
                "Cantarell",
                "Mukta Mahee"
            ]
        }
    };
    // Include the web-font loader script
    (function() {
        const wf = document.createElement("script");
        wf.src = `static/www/static/webfont.js`;
        wf.type = "text/javascript";
        wf.async = "true";
        const s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(wf, s);
    })();
    // Confirm exit if scenario editor open
    function areYouSure() {
        if ($(".scenario-editor-container").is(":visible")) return "Are you sure you wish to leave?";
    }
    window.onbeforeunload = areYouSure;
    // Save patreon superstars and supporters to local storage if online
    if (window.navigator.onLine) (0, $1JSre.makeGetRequest)("/_get_offline_data", {}, async (data)=>{
        window.localStorage.setItem("patreonSuperstarsData", JSON.stringify(data["patreon_superstars"]));
        window.localStorage.setItem("supportersData", JSON.stringify(data["supporters"]));
    }, true, null, false);
    // 'Continue' main menu button
    $("#continue-game").on("click", "", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        if ($(".scenario-editor-container").is(":visible")) notie.confirm({
            text: "Are you sure you want to leave the scenario editor?",
            submitCallback: function() {
                return (0, $993642189aedf295$export$ceac039078e40199)();
            },
            cancelCallback: function() {
                $("#main-menu-buttons").find("li").removeClass("selected");
                $(".create-scenario-menu-button").addClass("selected");
            }
        });
        else return (0, $993642189aedf295$export$ceac039078e40199)();
    });
    // 'New Game' main menu button
    $("#new-game").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        if ($(".scenario-editor-container").is(":visible")) notie.confirm({
            text: "Are you sure you want to leave the scenario editor?",
            submitCallback: function() {
                return (0, $8de2281fafd7b0c6$export$75acba7ae7da841)();
            },
            cancelCallback: function() {
                $("#main-menu-buttons").find("li").removeClass("selected");
                $(".create-scenario-menu-button").addClass("selected");
            }
        });
        else return (0, $8de2281fafd7b0c6$export$75acba7ae7da841)();
    });
    // Select main menu button
    $("#main-menu-buttons").on("click", "li:not(.button-dropdown)", function() {
        // Select this button
        $("#main-menu-buttons").find("li").removeClass("selected");
        $(this).addClass("selected");
        // Blur background image
        $(".main-container").addClass("blur");
    });
    // Select game under 'Continue'
    $("#existing-games").on("click", ".select-game", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        return (0, $993642189aedf295$export$5573b974f162909)($(this));
    });
    // Import main game saves menu button
    $("#existing-games").on("click", ".import-main-game-saves-button", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        if (!(0, $98xmD.globalUser).loggedIn) {
            notie.alert({
                type: 4,
                text: "You need to be logged in to import saves.",
                stay: true
            });
            return false;
        }
        return (0, $993642189aedf295$export$c082e02cf58ee558)();
    });
    // Import cloud saves menu button
    $("#existing-games").on("click", ".import-cloud-saves-button", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        if (!(0, $98xmD.globalUser).loggedIn) {
            notie.alert({
                type: 4,
                text: "You need to be logged in to import saves.",
                stay: true
            });
            return false;
        }
        return (0, $993642189aedf295$export$3b5ab48a7da0c393)();
    });
    // Import main game save
    $("#account-games").on("click", ".import-main-game-save", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
        if (!(0, $98xmD.globalUser).paid && userGames.length > 0) {
            notie.alert({
                type: 3,
                text: "Free users are limited to one save. Please delete your current save to create a new one.",
                stay: true
            });
            return false;
        }
        let uid = $(this).closest(".game-box").attr("data-uid");
        return (0, $993642189aedf295$export$51c87832a3d15ea2)(uid);
    });
    // Import cloud save
    $("#account-games").on("click", ".import-cloud-save", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
        const filename = $(this).closest(".game-box").attr("data-filename");
        const gamePresent = userGames.find((x)=>x.dbUid === filename);
        if (!(0, $98xmD.globalUser).paid && userGames.length > 0 && !gamePresent) {
            notie.alert({
                type: 3,
                text: "Free users are limited to one save. Please delete your current save to create a new one.",
                stay: true
            });
            return false;
        }
        // Ask to confirm overwrite if exising save present
        if (gamePresent) notie.confirm({
            text: "This save already exists locally and will be overwritten. Are you sure you want to proceed?",
            submitCallback: async function() {
                return (0, $993642189aedf295$export$c1bf68c1c2e5e907)(filename);
            }
        });
        else return (0, $993642189aedf295$export$c1bf68c1c2e5e907)(filename);
    });
    // Delete cloud save
    $("#account-games").on("click", ".delete-cloud-save-button", function(e) {
        e.stopPropagation();
        if ((0, $98xmD.globals).requestRunning) return false;
        let parent = $(this).closest(".game-box");
        let filename = $(this).closest(".game-box").attr("data-filename");
        let companyName = parent.attr("data-company-name");
        let gameYear = parent.attr("data-game-year");
        let notieText = 'Are you sure you want to delete this <span class="game-name-highlight">{0} (Year {1})</span> cloud save?'.format(companyName, gameYear);
        notie.confirm({
            text: notieText,
            submitCallback: async function() {
                notie.confirm({
                    text: 'Are you really sure? <span class="red">This cloud save will be permanently deleted</span>.',
                    submitText: "Yes",
                    cancelText: "No",
                    submitCallback: async function() {
                        return (0, $993642189aedf295$export$605bcac8e4532628)(filename, parent);
                    }
                });
            }
        });
    });
    // Import save
    $(document).on("change", "#import-save-input", function() {
        let reader = new FileReader();
        reader.onload = function() {
            let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
            if (!(0, $98xmD.globalUser).paid && userGames.length > 0) {
                notie.alert({
                    type: 3,
                    text: "Free users are limited to one save. Please delete your current save to create a new one.",
                    stay: true
                });
                return false;
            }
            return (0, $993642189aedf295$export$7ee9bbf5a8bd776d)(new Uint8Array(reader.result));
        };
        reader.readAsArrayBuffer(this.files[0]);
    });
    // Back to saves
    $("#account-games").on("click", ".back-to-saves-button", function() {
        (0, $993642189aedf295$export$ceac039078e40199)();
    });
    // Delete game under 'Continue'
    $("#existing-games").on("click", ".delete-game-button", function(e) {
        e.stopPropagation();
        if ((0, $98xmD.globals).requestRunning) return false;
        let parent = $(this).closest(".game-box");
        let dbUid = parent.attr("data-dbUid");
        let companyName = parent.attr("data-company-name");
        let gameYear = parent.attr("data-game-year");
        let notieText;
        if (gameYear >= 2) notieText = '<span class="red">WARNING!</span> This is a save of over {0} years. Are you sure you want to delete this <span class="game-name-highlight">{1} (Year {2})</span> game?'.format(gameYear, companyName, gameYear);
        else notieText = 'Are you sure you want to delete this <span class="game-name-highlight">{0} (Year {1})</span> game?'.format(companyName, gameYear);
        notie.confirm({
            text: notieText,
            submitText: "Yes",
            cancelText: "No",
            submitCallback: async function() {
                if (gameYear >= 5) notie.confirm({
                    text: "Are you really sure? This is a long save!",
                    submitText: "Yes",
                    cancelText: "No",
                    submitCallback: async function() {
                        await (0, $1JSre.makeGameRequest)((0, $iRMwH.deleteGameRequest), {
                            dbUid: dbUid
                        }, $69677cd2f9b4883e$var$showDeleteGameRequestData, {
                            parent: parent
                        }, false);
                    }
                });
                else await (0, $1JSre.makeGameRequest)((0, $iRMwH.deleteGameRequest), {
                    dbUid: dbUid
                }, $69677cd2f9b4883e$var$showDeleteGameRequestData, {
                    parent: parent
                }, false);
            }
        });
    });
    // Click 'play' on scenario under 'New Game'
    $("#container").on("click", ".play-scenario", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        return (0, $8de2281fafd7b0c6$export$c0eac80bdcb2da7f)($(this));
    });
    // Story intro continue button
    $("#container").on("click", ".intro-continue-button", async function() {
        $("#intro").hide();
        await (0, $b947816677aa453b$export$2b9447da23271d13)(await (0, $3E8Nt.getCurrentGame)());
    });
    // 'Create' main menu button
    $(".create-scenario-menu-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        if ($(".scenario-editor-container").is(":visible")) notie.confirm({
            text: "Are you sure? The scenario editor will reset.",
            submitCallback: function() {
                (0, $3930923fc77c55ab$export$909e7241648ee4af)();
            }
        });
        else (0, $3930923fc77c55ab$export$909e7241648ee4af)();
    });
    // Back to main menu button
    $("#main-menu-button").click(function() {
        (0, $lCS03.playSoundEffect)("success");
        // Stop running simulation
        $("#simulation-results-container").data("stopSimulation", true);
        notie.hideAlerts();
        $("#game").fadeOut("fast").promise().done(function() {
            // Reset and show main menu
            $("#main-menu, .main-header-container").fadeIn("slow");
            $("#main-menu-buttons").find("li").removeClass("selected");
            $(".main-container").removeClass("hide-background blur");
        });
    });
    // About menu button
    $("#about-menu-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        $(".main-container").fadeOut("fast", function() {
            notie.hideAlerts();
            $(".about-container").fadeIn("fast");
        });
    });
    // About page play button
    $(".about-container-play-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        $(".about-container").fadeOut("fast", function() {
            notie.hideAlerts();
            $(".main-container").fadeIn("fast");
            $(".main-container")[0].scrollIntoView();
            $("#main-menu-buttons").find("li").removeClass("selected");
            $(".main-container").removeClass("blur");
            (0, $1JSre.hideMainMenuContent)($());
            $(this).addClass("selected");
        });
    });
    // JoW Paid menu button
    $("#jow-paid-menu-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        notie.hideAlerts();
        (0, $1JSre.hideMainMenuContent)($());
        $("#paid-features").fadeIn().scrollTop(0);
    });
    // Open humble bundle page
    $(".view-upgrade-button").click(function() {
        (0, $lCS03.playSoundEffect)("success");
        window.open("https://www.humblebundle.com/widget/v2/standalone/jow_widget/sRm2uH4QdH");
    });
    // Redeem key page
    $(".redeem-button").click(function() {
        (0, $lCS03.playSoundEffect)("success");
        window.location.href = (0, $98xmD.globals).baseUrl + "/upgrade";
    });
    // Roadmap button
    $("#roadmap-menu-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideMainMenuContent)($());
        $("#roadmap-container").hide().fadeIn();
        $(".roadmap-container").scrollTop(0);
    });
    // Patreon button
    $(".support-jow-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        notie.hideAlerts();
        window.open("https://www.patreon.com/journeyofwrestling");
    });
    // Discord menu button
    $("#discord-menu-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        notie.hideAlerts();
        window.open("https://discord.gg/tjwJb99");
    });
    // Help menu button
    $("#help-menu-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideMainMenuContent)($());
        $("#help-menu-container").hide().fadeIn();
        $(".help-menu-select").val("Superstar Morale").trigger("change");
    });
    // Help menu select
    $("#help-menu-container").on("change", ".help-menu-select", function() {
        (0, $lCS03.playSoundEffect)("success");
        let value = $(this).val().trim();
        let html = "";
        $(".help-container-section-select").hide();
        if (value === "Superstar Traits") {
            let traitCategories = {
                "Matches": [],
                "Segments": [],
                "Feuds": [],
                "Overness/Alignment": [],
                "Progress": [],
                "Career": [],
                "Morale": [],
                "Holy Shit Moments": [],
                "Injuries": [],
                "Gimmicks": [],
                "Backstage": [],
                "Misc": []
            };
            // Put traits into categories
            Object.keys((0, $aP7lq.traitsData)).forEach(function(key) {
                traitCategories[(0, $aP7lq.traitsData)[key]["category"]].push(key);
            });
            function compareTraitsFunction(a, b) {
                return (0, $aP7lq.traitsData)[a]["order"] - (0, $aP7lq.traitsData)[b]["order"];
            }
            Object.keys(traitCategories).forEach(function(category) {
                let traitsHelpHtml = "";
                // Sort traits by order
                traitCategories[category].sort(compareTraitsFunction).forEach(function(trait) {
                    // Add html for each trait
                    traitsHelpHtml += (0, $1JSre.getTraitHelpHtml)(trait, (0, $aP7lq.traitsData)[trait]);
                });
                // Add to category
                let categoryHtml = '<div class="margin-bottom-25"><div class="display-block margin-bottom-5"><span class="light-grey margin-left-2 help-container-section-name">' + category + "</span>" + "</div>" + traitsHelpHtml + "</div>";
                html += categoryHtml;
            });
            // Add section select
            let helpSectionOptions = Array.from(Object.keys(traitCategories), function(x) {
                return "<option>" + x + "</option>";
            });
            let helpSectionOptionsHtml = helpSectionOptions.join("");
            $(".help-container-section-select").html(helpSectionOptionsHtml).hide().fadeIn();
            $(".help-container-section-select").val("Matches");
        } else if (value === "Superstar Morale") {
            html += '<div class="morale-help-item-container"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Matches</div></div><div class="margin-bottom-7">Winning a match increases morale while losing a match decreases it.</div><div class="medium-dark-grey">Winning against a higher popularity talent leads to a larger increase in morale while losing to a lower popularity talent leads to a larger decrease. The increase/decrease is reduced on a weekly show match or if all talent are Faces of the Company.</div></div>';
            html += '<div class="morale-help-item-container"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Titles</div></div><div class="margin-bottom-7">Winning a title increases morale while losing a title decreases it.</div><div class="medium-dark-grey">The increase/decrease depends on the prestige of the title. Being in a title match also increases morale slightly. </div></div>';
            html += '<div class="morale-help-item-container"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Main Event</div></div><div class="margin-bottom-7">Being in the main event match or segment increases morale.</div><div class="medium-dark-grey">The increase is lower for being in the main event of a weekly show.</div></div>';
            html += '<div class="morale-help-item-container"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Hot Match/Feud/Segment</div></div><div class="margin-bottom-7">Being a part of a hot match, feud or segment increases morale.</div><div class="medium-dark-grey">Being a part of a silly segment that gets the \'Comedy Flop\' rating lowers morale.</div></div>';
            html += '<div class="morale-help-item-container"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Feuds</div></div><div class="margin-bottom-7">Starting a feud with a significant popularity difference increases morale for the lower popularity talent and decreases morale for the higher popularity one.</div><div class="medium-dark-grey">The increase/decrease is reduced if talent are Faces of the Company.</div></div>';
            html += '<div class="morale-help-item-container"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Not Booked</div></div><div class="margin-bottom-7">Not being booked on a monthly show decreases morale for Main Eventers.</div></div>';
            html += '<div class="morale-help-item-container"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Talent Offers</div></div><div class="margin-bottom-7">Rejecting a talent offer decreases morale significantly.</div></div>';
            html += '<div class="morale-help-item-container"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Callups</div></div><div class="margin-bottom-7">Calling up a talent to the main roster increases morale.</div></div>';
        } else if (value === "Event Hype") {
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Event Hype Boosts</div></div><div class="margin-bottom-7">Event Hype is boosted during the event by hot matches, hot segments, debut segments involving a competitor\'s talent and slander segments.</div><div class="medium-dark-grey">Slander segments can backfire, depending on their rating, and can lower event hype. Debuts involving main eventers of a competitor add a higher boost.</div></div>';
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Match Hype</div></div><div class="margin-bottom-7">Match hype is affected by feuds, championships, hot or stale participants, main eventers and the alignment of the participants.</div><div class="medium-dark-grey">Match hype is boosted by streaks, gimmick match effects for the event, match contracts and tournament finals.</div></div>';
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Segment Hype</div></div><div class="margin-bottom-7">Segment hype is affected by feuds, hot or stale participants, main eventers, the action and entertainment points of the segment and whether there are any consequences to it.</div></div>';
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Event Prestige</div></div><div class="margin-bottom-7">The higher the event prestige, the higher the base hype for the event. The top event has the highest base hype, and getting your company hot boosts the base hype for all events.</div></div>';
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Packages</div></div><div class="margin-bottom-7">Running the event package segment can affect event hype and the main event package can affect match hype.</div></div>';
        } else if (value === "Faction REP") {
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Titles</div></div><div class="margin-bottom-7">Faction members winning Titles increases REP while losing Titles decreases it.</div><div class="medium-dark-grey">The change depends on the prestige of the Title.</div></div>';
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Members</div></div><div class="margin-bottom-7">Adding or removing faction members through Segments affects REP based on the popularity of the members and whether they are Hot, Stale or a Face of the Company.</div><div class="medium-dark-grey">The change is higher if the added or removed member is the leader.</div></div>';
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Feuds</div></div><div class="margin-bottom-7">Winning Faction vs Faction Feud blowoffs increases REP while losing them decreases it.</div><div class="medium-dark-grey">The change is based on the feud\'s hype.</div></div>';
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Hot/Stale</div></div><div class="margin-bottom-7">Faction members becoming Hot increases REP while becoming Stale decreases it.</div></div>';
            html += '<div class="morale-help-item-container dark-grey"><div class="margin-bottom-10"><div class="superstar-trait-color font-15px">Face of the Company</div></div><div class="margin-bottom-7">If a faction member becomes a Face of the Company, REP increases. If they lose their Face of the Company status, REP decreases.</div></div>';
        } else if (value === "Talent Requests") {
            let talentRequestsDataFormatted = Object.values((0, $knp8C.talentRequestsData)).map((key)=>{
                return {
                    "name": key["display_name"],
                    "importance": key["importance"],
                    "description": key["description"]
                };
            });
            talentRequestsDataFormatted.sort((a, b)=>a.name.localeCompare(b.name));
            html += (0, $1JSre.getTalentRequestTypesHelpHtml)(talentRequestsDataFormatted);
        }
        $(".help-container-items").html(html).scrollTop(0);
        $(".help-container-name").html(value);
        $(".help-container").hide().fadeIn();
    });
    // Help section select
    $("#help-menu-container").on("change", ".help-container-section-select", function() {
        let value = $(this).val();
        let parent = $(".help-container-items");
        let el = parent.find('.help-container-section-name:contains("' + value + '")');
        if (el) el[0].scrollIntoView();
    });
    // Support JoW menu button
    $("#support-jow-menu-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        notie.hideAlerts();
        (0, $1JSre.hideMainMenuContent)($());
        let supportersData = JSON.parse(localStorage.getItem("supportersData")) || [];
        let supportersHtml = "";
        supportersData.forEach(function(supporter) {
            supportersHtml += "<div>" + supporter + "</div>";
        });
        if (!supportersData.length) supportersHtml += "<div>Supporters data could not be loaded.</div>";
        $(".fotc-supporters").html(supportersHtml).scrollTop(0);
        $("#support-jow").fadeIn().scrollTop(0);
    });
    // Leaderboard
    $("#leaderboard-menu-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $lCS03.playSoundEffect)("success");
        notie.hideAlerts();
        (0, $1JSre.hideMainMenuContent)($());
        (0, $1JSre.makeGetRequest)("/_get_leaderboard_stats", {}, (data)=>{
            let div = "";
            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-3">Scenarios Created</div>';
            if (data["created_scenarios"].length > 0) data["created_scenarios"].forEach(function(createdScenario) {
                div += '<div class="display-block dark-grey">' + (0, $1JSre.escapeHTML)(createdScenario["display_name"]) + '<span class="margin-left-8 light-grey">' + createdScenario["created_scenarios"] + "</span>" + "</div>";
            });
            else div += '<div class="display-block dark-grey">N/A</div>';
            div += "</div>";
            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-3">Edits Created</div>';
            if (data["created_edits"].length > 0) data["created_edits"].forEach(function(createdScenario) {
                div += '<div class="display-block dark-grey">' + (0, $1JSre.escapeHTML)(createdScenario["display_name"]) + '<span class="margin-left-8 light-grey">' + createdScenario["created_edits"] + "</span>" + "</div>";
            });
            else div += '<div class="display-block dark-grey">N/A</div>';
            div += "</div>";
            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-3">Community Graphics Recommendations</div>';
            if (data["template_superstar_recommendations"].length > 0) data["template_superstar_recommendations"].forEach(function(templateSuperstarRecommendation) {
                div += '<div class="display-block dark-grey">' + (0, $1JSre.escapeHTML)(templateSuperstarRecommendation["display_name"]) + '<span class="margin-left-5 light-grey">' + '<i class="fa fa-star icon-button margin-right-5 margin-left-3 community-recommendation-color"></i>' + templateSuperstarRecommendation["recommendations"] + "</span>" + "</div>";
            });
            else div += '<div class="display-block dark-grey">N/A</div>';
            div += "</div>";
            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-3">Community Segments Recommendations</div>';
            if (data["template_segment_recommendations"].length > 0) data["template_segment_recommendations"].forEach(function(templateSegmentRecommendation) {
                div += '<div class="display-block dark-grey">' + (0, $1JSre.escapeHTML)(templateSegmentRecommendation["display_name"]) + '<span class="margin-left-5 light-grey">' + '<i class="fa fa-star icon-button margin-right-5 margin-left-3 community-recommendation-color"></i>' + templateSegmentRecommendation["recommendations"] + "</span>" + "</div>";
            });
            else div += '<div class="display-block dark-grey">N/A</div>';
            div += "</div>";
            $(".leaderboard-box").html(div);
            $("#leaderboard-container").hide().fadeIn();
            $(".leaderboard-box").scrollTop(0);
        });
    });
    // Show user info
    $("#user-info-menu-button, .user-display-name").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        if (!(0, $98xmD.globalUser).loggedIn) {
            (0, $lCS03.playSoundEffect)("error");
            notie.alert({
                type: 4,
                text: "You need to login to view User Info",
                stay: true
            });
            return false;
        }
        (0, $1JSre.hideMainMenuContent)($());
        (0, $1JSre.makeGameRequest)((0, $iRMwH.getUserInfo), {}, $69677cd2f9b4883e$var$showGetUserInfoData, {}, false);
    });
    // User Info
    $("#user-info-container").on("focus", ".user-info-display-name", function() {
        $(".save-user-info-display-name").show();
    });
    // Save user display name
    $("#user-info-container").on("click", ".save-user-info-display-name", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        let name = $(".user-info-display-name").val();
        (0, $1JSre.makeGetRequest)("/_change_display_name", {
            name: name
        }, (data)=>{
            if (!data["error"]) {
                (0, $lCS03.playSoundEffect)("success");
                notie.alert({
                    type: 4,
                    text: "Display Name Saved",
                    stay: true
                });
                const user = (0, $bZol7.loadUser)();
                user.displayName = name;
                (0, $bZol7.saveUser)(user);
                (0, $1JSre.showFormattedDisplayName)(user);
            } else {
                (0, $lCS03.playSoundEffect)("error");
                if (data["error"] === "display-name-already-exists") notie.alert({
                    type: 3,
                    text: "That display name is already in use. Please select a different name."
                });
                if (data["error"] === "same") notie.alert({
                    type: 3,
                    text: "That is already your display name."
                });
            }
        });
    });
    // Show settings
    $("#settings-menu-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.hideMainMenuContent)($());
        $69677cd2f9b4883e$var$showSettingsPage();
    });
    // Apply user theme selection
    if (!user || user && user.settings["theme"] !== "light") {
        $(".theme-settings-button").addClass("selected");
        document.getElementById("dark-theme").disabled = false;
    } else {
        $(".main-container").addClass("light");
        (0, $c82cd471f4baff6b$export$15751559525d8097)("light");
    }
    // Theme input
    $("#settings-container").on("change", 'input[name="settings-theme-option"]', async function() {
        (0, $lCS03.playSoundEffect)("success");
        let theme;
        if ($(this).val() === "light") {
            document.getElementById("dark-theme").disabled = true;
            theme = "light";
            $(".main-container").addClass("light");
        } else {
            document.getElementById("dark-theme").disabled = false;
            theme = "dark";
            $(".main-container").removeClass("light");
        }
        (0, $c82cd471f4baff6b$export$15751559525d8097)(theme);
        await (0, $70adc4a1fd111893$export$3079987a80f5136b)("theme", theme);
    });
    // Apply colorblind selection
    if (user && user.settings["colorblindMode"]) {
        $(".colorblind-settings-button").addClass("selected");
        $("html").addClass("colorblind");
    }
    // Colorblind input
    $("#settings-container").on("change", 'input[name="settings-colorblind-mode-option"]', async function() {
        (0, $lCS03.playSoundEffect)("success");
        let colorblindMode;
        if ($(this).val() === "off") {
            $("html").removeClass("colorblind");
            colorblindMode = false;
        } else {
            $("html").addClass("colorblind");
            colorblindMode = true;
        }
        await (0, $70adc4a1fd111893$export$3079987a80f5136b)("colorblindMode", colorblindMode);
    });
    // Apply mobile view selection
    if (user && user.settings["mobileView"]) {
        $(".display-settings-button").addClass("selected");
        $("html").attr("id", "");
        $('meta[name="viewport"]').prop("content", "width=device-width, initial-scale=0.75");
    }
    // Mobile View input
    $("#settings-container").on("change", 'input[name="settings-display-mode-option"]', async function() {
        (0, $lCS03.playSoundEffect)("success");
        let mobileView;
        if ($(this).val() === "desktop") {
            $("html").attr("id", "widescreen");
            $('meta[name="viewport"]').prop("content", "width=1440");
            mobileView = false;
        } else {
            $("html").attr("id", "");
            $('meta[name="viewport"]').prop("content", "width=device-width, initial-scale=0.75");
            mobileView = true;
        }
        await (0, $70adc4a1fd111893$export$3079987a80f5136b)("mobileView", mobileView);
    });
    // Activate free trial
    $(".activate-free-trial-button").click(function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $1JSre.makeGetRequest)("/_activate_free_trial", {}, async (data)=>{
            if (data["trial_activated"]) {
                (0, $lCS03.playSoundEffect)("success");
                notie.alert({
                    type: 4,
                    text: 'Your <span class="gold">JoW Paid</span> Free Trial has been activated! Have a look at all the <a target="_blank" href="/jow-paid-features">unlocked features</a> and click <a href="/">here</a> to go back to the game.',
                    stay: true
                });
                // Add paid features
                for (let gameData of JSON.parse(window.localStorage.getItem("jowGames")) || [])if (!gameData.scenarioId) {
                    await (0, $14eBR.loadDb)(gameData.dbUid);
                    const game = (0, $14eBR.Games).find({})[0];
                    await (0, $iRMwH.addPaidFeatures)(game);
                }
            } else {
                (0, $lCS03.playSoundEffect)("error");
                if (data["error"] === "not-logged-in") notie.alert({
                    type: 3,
                    text: "You need to be logged in to activate your Free Trial",
                    stay: true
                });
                if (data["error"] === "already-paid") notie.alert({
                    type: 3,
                    text: "You already have JoW Paid! What do you want, JoW Paid+?",
                    stay: true
                });
                if (data["error"] === "already-activated-free-trial") notie.alert({
                    type: 3,
                    text: "You have already activated your JoW Paid Free Trial",
                    stay: true
                });
            }
        });
    });
    // Login
    $(".button-login").click(function(e) {
        e.preventDefault();
        (0, $lCS03.playSoundEffect)("success");
        window.location.href = "/login";
    });
    // Logout
    $(".button-logout").click(function(e) {
        e.preventDefault();
        (0, $lCS03.playSoundEffect)("success");
        notie.confirm({
            text: "Are you sure you want to logout?",
            submitText: "Yes",
            cancelText: "No",
            submitCallback: async function() {
                notie.alert({
                    type: 4,
                    text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading',
                    stay: true
                });
                await (0, $bZol7.syncUserData)();
                firebase.auth().signOut().then(function() {
                    window.location.href = "/logout";
                }, function(error) {
                    console.error("Sign Out Error", error);
                    notie.alert({
                        type: 3,
                        text: "An error occurred. Please try again.",
                        stay: true
                    });
                });
            }
        });
    });
    // Accept terms
    $(".accept-terms-button").on("click", function() {
        (0, $lCS03.playSoundEffect)("success");
        (0, $1JSre.makeGetRequest)("/_accept_terms", {}, (data)=>{
            if (data) $("#terms-container").hide();
        });
    });
    // Upgrade
    $(".upgrade-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        let key = $(".upgrade-key-input").val();
        (0, $1JSre.makeGetRequest)("/_check_key", {
            key: key
        }, (data)=>{
            if (!data["error"]) {
                (0, $lCS03.playSoundEffect)("success");
                notie.alert({
                    type: 4,
                    text: 'Thank you for buying JoW Paid! Your account has been upgraded. Click <a href="/">here</a> to go back to the game.',
                    stay: true
                });
                $(".upgrade-key-input").val("");
            } else {
                (0, $lCS03.playSoundEffect)("error");
                if (data["error"] === "key-not-found") notie.alert({
                    type: 3,
                    text: "That key is not valid. Please make sure you copied the key correctly.",
                    stay: true
                });
                else if (data["error"] === "not-logged-in") notie.alert({
                    type: 3,
                    text: 'Please <a href="/">login</a> to upgrade your account.',
                    stay: true
                });
                else if (data["error"] === "already-paid") notie.alert({
                    type: 3,
                    text: "Your account is already upgraded!",
                    stay: true
                });
            }
        });
    });
    // Close update container
    $(".close-update-container").on("click", function() {
        $("#update-container").hide();
    });
    // Redeem mobile key
    $(".redeem-mobile-button").on("click", function() {
        notie.alert({
            type: 3,
            text: "Mobile keys will be available when the game releases on Mobile.",
            stay: true
        });
    });
    // Redeem steam key
    $(".redeem-steam-button").on("click", function() {
        if ((0, $98xmD.globals).requestRunning) return false;
        (0, $1JSre.makeGetRequest)("/_redeem_steam_key", {}, (data)=>{
            if (!data["error"]) {
                (0, $lCS03.playSoundEffect)("success");
                notie.alert({
                    type: 4,
                    text: "Key redeemed."
                });
                $(".redeem-key-info").show();
                $(".redeemed-key").text(data["key"]).show();
                $(".redeem-key-copy-button").show();
            } else {
                (0, $lCS03.playSoundEffect)("error");
                if (data["error"] === "not-logged-in") notie.alert({
                    type: 3,
                    text: 'Please <a href="/">login</a> to upgrade your account.',
                    stay: true
                });
                else if (data["error"] === "not-paid") notie.alert({
                    type: 3,
                    text: "You have not activated JoW Paid on this account.",
                    stay: true
                });
                else if (data["error"] === "post-steam-release") notie.alert({
                    type: 3,
                    text: "Steam keys are only available for users who bought JoW Paid before the Steam release.",
                    stay: true
                });
                else if (data["error"] === "already-redeemed") {
                    $(".redeem-key-info").show();
                    $(".redeemed-key").text(data["redeemed_key"]).show();
                    $(".redeem-key-copy-button").show();
                } else if (data["error"] === "key-not-found") notie.alert({
                    type: 3,
                    text: "No more keys could be found. Please wait as they are refreshed.",
                    stay: true
                });
            }
        });
    });
    // Copy key
    $(".redeem-key-copy-button").on("click", function() {
        (0, $c82cd471f4baff6b$export$2cdf1b96a9f86d16)($(".redeemed-key"));
    });
});
async function $69677cd2f9b4883e$var$setupUser() {
    // Load user from local storage
    let user = (0, $bZol7.loadUser)();
    // Load user data from jow db
    let jowUserData = $("#user-data").data("user-data");
    let protectedFunctionsError;
    if (jowUserData) {
        (0, $98xmD.globalUser).paid = jowUserData.paid;
        (0, $98xmD.globalUser).tester = jowUserData.tester;
        (0, $98xmD.globalUser).freeTrialActivated = jowUserData.freeTrialActivated;
        (0, $98xmD.globalUser).freeTrialActivatedDatetime = jowUserData.freeTrialActivatedDatetime;
        (0, $98xmD.globalUser).loggedIn = true;
        Object.defineProperty((0, $98xmD.globalUser), "paid", {
            configurable: false,
            writable: false
        });
        Object.defineProperty((0, $98xmD.globalUser), "tester", {
            configurable: false,
            writable: false
        });
        // Setup protected functions for paid users
        if ((0, $98xmD.globalUser).paid) {
            protectedFunctionsError = await $69677cd2f9b4883e$var$setupProtectedFunctions();
            (0, $3E8Nt.gameLimits).maxCompetitors = 19;
        }
        Object.defineProperty((0, $3E8Nt.gameLimits), "maxCompetitors", {
            configurable: false,
            writable: false
        });
        // Sync if same user
        if (user.uid === jowUserData.uid) await (0, $bZol7.syncUserData)();
        else {
            user.eventsPlayed = jowUserData.eventsPlayed;
            user.unlockedSegments = jowUserData.unlockedSegments;
            user.storiesCompleted = jowUserData.storiesCompleted;
            user.talentRequestTypesCompleted = jowUserData.talentRequestTypesCompleted;
            user.unlockedPowerups = jowUserData.unlockedPowerups;
            user.unlockedCharacters = jowUserData.unlockedCharacters;
            user.unlockedCombinations = jowUserData.unlockedCombinations;
            user.uid = jowUserData.uid;
            user.displayName = jowUserData.displayName;
            user.settings = jowUserData.settings;
            user.updateVersionShown = jowUserData.updateVersionShown;
            if (user.settings["theme"] === "light") {
                $(".theme-settings-button").removeClass("selected");
                document.getElementById("dark-theme").disabled = true;
            }
            (0, $bZol7.saveUser)(user);
        }
    } else {
        // Show home page
        $(".main-container").hide();
        $(".about-container").show();
        // Show continue button if no games present
        let userGames = JSON.parse(window.localStorage.getItem("jowGames")) || [];
        if (!userGames.length) $("#continue-game").hide();
        // Reset local user identifying data
        if (user.uid) {
            user.uid = null;
            user.displayName = null;
            (0, $bZol7.saveUser)(user);
        }
    }
    // Update user UI
    if ((0, $98xmD.globalUser).paid) {
        if ((0, $98xmD.globalUser).freeTrialActivated) {
            $(".account-level-text").text("Free Trial");
            $(".account-level-text").addClass("gold");
            $(".view-upgrade-button").show();
        } else {
            $(".account-level-text").text("Paid Version");
            $(".account-level-text").addClass("gold top-5px");
        }
    } else {
        $(".account-level-text").text("Free Version");
        $(".account-level-text").addClass("dark-grey");
        $(".view-upgrade-button").show();
    }
    if ((0, $98xmD.globalUser).loggedIn) {
        (0, $1JSre.showFormattedDisplayName)(user);
        $(".button-logout").show();
    } else $(".button-login").show();
    $(".main-container").removeClass("blur");
    $("#container").removeClass("display-none");
    if (!protectedFunctionsError) $(".notie-textbox").remove();
    let notieTexts = "";
    // Update data
    const updateVersion = "5.3";
    let nonUpdateAlert = "";
    const now = Date.now();
    const saleEndDatetime = new Date("2024-06-12T23:00:00");
    if (now < saleEndDatetime) {
        const saleHoursRemaining = (0, $3E8Nt.getTimeDiffHuman)(saleEndDatetime, now);
        nonUpdateAlert = `JoW is now available on <a href="https://store.steampowered.com/app/2941580/?utm_source=website" target="_blank">Steam</a> with a 15% launch discount! Paid users can get a <a href="/redeem-steam" target="_blank">free key</a>.`;
    } else nonUpdateAlert = ``;
    // Non update alert
    if (nonUpdateAlert) notieTexts += '<span class="display-block">' + nonUpdateAlert + "</span>";
    if (jowUserData) {
        // Check free trial time remaining or end of trial
        if (jowUserData["freeTrialData"]) {
            if (jowUserData["freeTrialData"]["trial_ended"]) {
                let freeTrialText = 'Your <span class="gold">JoW Paid</span> Free Trial has ended and paid features have been removed. If you enjoyed playing it, you can upgrade permanently <a href="https://www.humblebundle.com/widget/v2/product/jow_widget/sRm2uH4QdH?theme=light" target="_blank">here</a>.';
                notieTexts += '<span class="display-block">' + freeTrialText + "</span>";
                // Remove paid features
                for (let gameData of JSON.parse(window.localStorage.getItem("jowGames")) || [])if (!gameData.scenarioId) {
                    await (0, $14eBR.loadDb)(gameData.dbUid);
                    const game = (0, $14eBR.Games).find({})[0];
                    await (0, $iRMwH.removePaidFeatures)(game);
                }
            } else {
                // Show free trial and time remaining
                let hoursRemaining = jowUserData["freeTrialData"]["hours_remaining"];
                let hoursWord = hoursRemaining === 1 ? "hour" : "hours";
                $(".account-level-text").addClass("help-text");
                if (hoursRemaining !== 0) $(".account-level-text").attr("title", "{0} {1} left".format(hoursRemaining, hoursWord));
                else {
                    let minutesRemaining = jowUserData["freeTrialData"]["minutes_remaining"];
                    let minutesWord = minutesRemaining === 1 ? "minute" : "minutes";
                    $(".account-level-text").attr("title", "{0} {1} left".format(minutesRemaining, minutesWord));
                }
            }
        }
        // Show terms and conditions if not accepted
        if (!jowUserData["termsAndConditionsAccepted"]) {
            $("#terms-container").show();
            $(".terms-content").load("terms");
        }
        // Show update container
        if (updateVersion !== user.updateVersionShown) {
            $("#update-container").show();
            user.updateVersionShown = updateVersion;
            (0, $bZol7.saveUser)(user);
        }
    }
    // Notify of other account
    const url = new URL(window.location.href);
    const otherAccountInfo = url.searchParams.get("other_account_info");
    if (otherAccountInfo) {
        let otherLoginName = otherAccountInfo === "google" ? "Google" : "Email/Password";
        let currentLoginName = otherAccountInfo === "google" ? "Email/Password" : "Google";
        notieTexts += "Another account exists with this email. If you don't find your data on this account ({0}), please try logging into the other account ({1}).".format(currentLoginName, otherLoginName);
    }
    if (notieTexts) notie.alert({
        type: 4,
        text: notieTexts,
        stay: true
    });
    return user;
}
function $69677cd2f9b4883e$var$showDeleteGameRequestData({ data: data, parent: parent }) {
    if (!data["error"]) {
        notie.alert({
            type: 4,
            text: "Game deleted"
        });
        parent.remove();
    } else if (data["error"] === "game-not-found") notie.alert({
        type: 3,
        text: "That game could not be found. Please try again."
    });
}
function $69677cd2f9b4883e$var$showGetUserInfoData({ data: data }) {
    let eventsPlayed = data["eventsPlayed"];
    // Add special segments unlocked
    let unlockedSegmentsHtml = "";
    data["unlockedSegments"].forEach(function(unlockedSegment) {
        unlockedSegmentsHtml += "<div>" + unlockedSegment + "</div>";
    });
    if (data["unlockedSegments"].length < 1) unlockedSegmentsHtml = '<div class="light-grey">None</div>';
    let specialSegmentsTotal = 10;
    let specialSegmentsUnlockedNumber = '<span class="margin-left-5 special-segment-color">' + data["unlockedSegments"].length + '<span class="margin-left-2">/</span><span class="margin-left-2">' + specialSegmentsTotal + "</span>" + "</span>";
    // Add talent request types completed
    let talentRequestTypesCompletedHtml = "";
    data["talentRequestTypesCompletedData"].forEach(function(talentRequestCompleted) {
        talentRequestTypesCompletedHtml += "<div>" + talentRequestCompleted + "</div>";
    });
    if (data["talentRequestTypesCompletedData"].length < 1) talentRequestTypesCompletedHtml = '<div class="light-grey">None</div>';
    let talentRequestTypesCompletedNumber = '<span class="margin-left-5 green">' + data["talentRequestTypesCompletedData"].length + '<span class="margin-left-2">/</span><span class="margin-left-2">' + data["talentRequestTypesTotal"] + "</span>" + "</span>";
    if (data["displayName"]) {
        $(".user-info-display-name").val(data["displayName"]);
        $(".user-info-display-name").parent().show();
    } else $(".user-info-display-name").parent().hide();
    $(".user-info-events-played").html(eventsPlayed.toLocaleString("en"));
    $(".user-info-special-segments-unlocked").html(unlockedSegmentsHtml);
    $(".user-info-special-segments-unlocked-number").html(specialSegmentsUnlockedNumber);
    $(".user-info-talent-requests-completed").html(talentRequestTypesCompletedHtml);
    $(".user-info-talent-requests-completed-number").html(talentRequestTypesCompletedNumber);
    $(".save-user-info-display-name").hide();
    $("#user-info-container").hide().fadeIn();
    $(".user-info-box").scrollTop(0);
    $(".user-info-talent-requests-completed").scrollTop(0);
    $(".main-container").addClass("blur");
}

async function $69677cd2f9b4883e$var$setupProtectedFunctions() {
    try {
        let { setManagersForMatchOrSegment: setManagersForMatchOrSegment, getRankingDataForYear: getRankingDataForYear, createFaction: createFaction, createTalentRequest: createTalentRequest } = await (parcelRequire("bmMQt"));
        (0, $ycsyu.setupSetManagersForMatchOrSegment)(setManagersForMatchOrSegment);
        (0, $6PzHO.setupCreateFaction)(createFaction);
        (0, $66ItE.setupGetRankingDataForYear)(getRankingDataForYear);
        (0, $1olyO.setupCreateTalentRequest)(createTalentRequest);
    } catch (error) {
        let notieText = "There was an error loading some files. Please refresh.";
        if (!window.navigator.onLine) notieText = "It seems like you're offline. Please connect to the internet once to load the page.";
        notie.alert({
            type: 3,
            text: notieText,
            stay: true
        });
        throw error;
    }
}
function $69677cd2f9b4883e$var$showSettingsPage() {
    const user = (0, $bZol7.loadUser)();
    const $settingsContainer = $("#settings-container");
    if (!user || user && user.settings["theme"] !== "light") $settingsContainer.find('input[name="settings-theme-option"][value="dark"]').prop("checked", true);
    else $settingsContainer.find('input[name="settings-theme-option"][value="light"]').prop("checked", true);
    if (user && user.settings["mobileView"]) $settingsContainer.find('input[name="settings-display-mode-option"][value="mobile"]').prop("checked", true);
    else $settingsContainer.find('input[name="settings-display-mode-option"][value="desktop"]').prop("checked", true);
    if (user && user.settings["colorblindMode"]) $settingsContainer.find('input[name="settings-colorblind-mode-option"][value="on"]').prop("checked", true);
    else $settingsContainer.find('input[name="settings-colorblind-mode-option"][value="off"]').prop("checked", true);
    $settingsContainer.hide().fadeIn();
    $(".main-container").addClass("blur");
}


window.$ = $;
window.jQuery = jQuery;


//# sourceMappingURL=main.js.map
